'use strict';
import * as $i_$0040eonasdan$002ftempus$002ddominus from "@eonasdan/tempus-dominus";
import * as $i_$0040zxing$002flibrary from "@zxing/library";
import * as $i_bootstrap from "bootstrap";
import * as $i_chart$002ejs$002fauto from "chart.js/auto";
import * as $i_chartjs$002dadapter$002dmoment from "chartjs-adapter-moment";
import * as $i_intro$002ejs from "intro.js";
import * as $i_moment$002dtimezone from "moment-timezone";
import * as $i_signature$005fpad from "signature_pad";
var $p;
var $fileLevelThis = this;
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys;
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)));
  }
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = ({});
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, ({
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      }));
      i = ((i + 1) | 0);
    }
    return descriptors;
  });
})());
function $Char(c) {
  this.c = c;
}
$p = $Char.prototype;
$p.toString = (function() {
  return String.fromCharCode(this.c);
});
function $Long(lo, hi) {
  this.l = lo;
  this.h = hi;
}
$p = $Long.prototype;
$p.toString = (function() {
  return $s_RTLong__toString__I__I__T(this.l, this.h);
});
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object");
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0));
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.Z ? arg0.ar() : $objectClone(arg0));
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.l();
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.l();
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.l();
        } else {
          return $d_jl_Integer.l();
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.l();
      } else {
        return $d_jl_Double.l();
      }
    }
    case "boolean": {
      return $d_jl_Boolean.l();
    }
    case "undefined": {
      return $d_jl_Void.l();
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return $d_jl_Long.l();
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.l();
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.l();
      } else {
        return null;
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String";
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte";
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short";
        } else {
          return "java.lang.Integer";
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float";
      } else {
        return "java.lang.Double";
      }
    }
    case "boolean": {
      return "java.lang.Boolean";
    }
    case "undefined": {
      return "java.lang.Void";
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return "java.lang.Long";
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character";
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.N;
      } else {
        return null.aEz();
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0);
  } else {
    return instance.qD(x0);
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0);
  } else {
    return instance.aEv(x0);
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0);
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0);
    }
    default: {
      if ((instance instanceof $Long)) {
        return $f_jl_Long__compareTo__O__I(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I(instance.c, x0);
      } else {
        return instance.jl(x0);
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0);
  } else {
    return instance.aEw(x0);
  }
}
function $dp_compareToIgnoreCase__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareToIgnoreCase__T__I(instance, x0);
  } else {
    return instance.aEx(x0);
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0);
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0);
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.b(x0);
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__equals__O__Z(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance.c, x0);
      } else {
        return $c_O.prototype.b.call(instance, x0);
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3);
  } else {
    return instance.ahp(x0, x1, x2, x3);
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance);
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance);
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.r();
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__hashCode__I(instance.l, instance.h);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance.c);
      } else {
        return $c_O.prototype.r.call(instance);
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0);
  } else {
    return instance.aEB(x0);
  }
}
function $dp_indexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I__I(instance, x0, x1);
  } else {
    return instance.aEA(x0, x1);
  }
}
function $dp_isBlank__Z(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__isBlank__Z(instance);
  } else {
    return instance.aEC();
  }
}
function $dp_lastIndexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I__I(instance, x0, x1);
  } else {
    return instance.aED(x0, x1);
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance);
  } else {
    return instance.F();
  }
}
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0);
  } else {
    return instance.aEE(x0);
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1);
  } else {
    return instance.aEF(x0, x1);
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1);
  } else {
    return instance.aEG(x0, x1);
  }
}
function $dp_strip__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__strip__T(instance);
  } else {
    return instance.aEH();
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1);
  } else {
    return instance.EC(x0, x1);
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance);
  } else {
    return instance.akb();
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString());
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance);
  } else {
    return instance.aEI();
  }
}
function $checkIntDivisor(arg0) {
  if ((arg0 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return arg0;
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)));
}
function $cToS(arg0) {
  return String.fromCharCode(arg0);
}
var $fpBitsDataView = new DataView(new ArrayBuffer(8));
function $floatToBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setFloat32(0, arg0, true);
  return dataView.getInt32(0, true);
}
function $floatFromBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setInt32(0, arg0, true);
  return dataView.getFloat32(0, true);
}
function $doubleToBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__fromDoubleBits__D__O__J(arg0, dataView);
}
function $doubleFromBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__bitsToDouble__I__I__O__D(arg0.l, arg0.h, dataView);
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc;
    }
    superProto = getPrototypeOf(superProto);
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value);
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0);
    }
  }
  throw new TypeError((("super has no setter '" + arg2) + "'."));
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  if (((arg0 !== arg2) || (((arg3 - arg1) >>> 0) > (arg4 >>> 0)))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj);
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj);
      }
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32));
      }
      return biHash;
    }
    case "boolean": {
      return (obj ? 1231 : 1237);
    }
    case "undefined": {
      return 0;
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description));
    }
    default: {
      if ((obj === null)) {
        return 0;
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash);
        }
        return hash;
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)));
}
function $bC(arg0) {
  return new $Char(arg0);
}
var $bC0 = $bC(0);
function $bL(arg0, arg1) {
  return new $Long(arg0, arg1);
}
var $bL0 = $bL(0, 0);
function $uC(arg0) {
  return ((arg0 === null) ? 0 : arg0.c);
}
function $uJ(arg0) {
  return ((arg0 === null) ? $bL0 : arg0);
}
function $ct_O__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_O() {
}
$p = $c_O.prototype;
$p.constructor = $c_O;
/** @constructor */
function $h_O() {
}
$h_O.prototype = $p;
$p.r = (function() {
  return $systemIdentityHashCode(this);
});
$p.b = (function(that) {
  return (this === that);
});
$p.g = (function() {
  var i = this.r();
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.toString = (function() {
  return this.g();
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.a[i] = null;
    }
  } else {
    this.a = arg;
  }
}
$p = $ac_O.prototype = new $h_O();
$p.constructor = $ac_O;
$p.av = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
});
$p.ar = (function() {
  return new $ac_O(this.a.slice());
});
function $ah_O() {
}
$ah_O.prototype = $p;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.a[i] = false;
    }
  } else {
    this.a = arg;
  }
}
$p = $ac_Z.prototype = new $h_O();
$p.constructor = $ac_Z;
$p.av = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
});
$p.ar = (function() {
  return new $ac_Z(this.a.slice());
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Uint16Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_C.prototype = new $h_O();
$p.constructor = $ac_C;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_C(this.a.slice());
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int8Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_B.prototype = new $h_O();
$p.constructor = $ac_B;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_B(this.a.slice());
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int16Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_S.prototype = new $h_O();
$p.constructor = $ac_S;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_S(this.a.slice());
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Int32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_I.prototype = new $h_O();
$p.constructor = $ac_I;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_I(this.a.slice());
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    arg = (arg << 1);
    this.a = new Int32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_J.prototype = new $h_O();
$p.constructor = $ac_J;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray((srcPos << 1), (((srcPos + length) | 0) << 1)), (destPos << 1));
});
$p.ar = (function() {
  return new $ac_J(this.a.slice());
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Float32Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_F.prototype = new $h_O();
$p.constructor = $ac_F;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_F(this.a.slice());
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.a = new Float64Array(arg);
  } else {
    this.a = arg;
  }
}
$p = $ac_D.prototype = new $h_O();
$p.constructor = $ac_D;
$p.av = (function(srcPos, dest, destPos, length) {
  dest.a.set(this.a.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$p.ar = (function() {
  return new $ac_D(this.a.slice());
});
function $TypeData() {
  this.C = (void 0);
  this.n = null;
  this.O = null;
  this.B = null;
  this.D = 0;
  this.z = null;
  this.E = "";
  this.L = (void 0);
  this.A = (void 0);
  this.F = (void 0);
  this.w = (void 0);
  this.J = false;
  this.N = "";
  this.X = false;
  this.Y = false;
  this.Z = false;
  this.I = (void 0);
}
$p = $TypeData.prototype;
$p.p = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.n = ({});
  this.z = zero;
  this.E = arrayEncodedName;
  var self = this;
  this.F = ((that) => (that === self));
  this.N = displayName;
  this.X = true;
  this.I = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this.A = new $TypeData().y(this, arrayClass, typedArrayClass, (arrayEncodedName === "J"));
  }
  return this;
});
$p.i = (function(kindOrCtor, fullName, ancestors, isInstance) {
  var internalName = Object.getOwnPropertyNames(ancestors)[0];
  this.n = ancestors;
  this.E = (("L" + fullName) + ";");
  this.F = ((that) => (!(!that.n[internalName])));
  this.J = (kindOrCtor === 2);
  this.N = fullName;
  this.Y = (kindOrCtor === 1);
  this.I = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.n[internalName])))));
  if (((typeof kindOrCtor) !== "number")) {
    kindOrCtor.prototype.$classData = this;
  }
  return this;
});
$p.y = (function(componentData, arrayClass, typedArrayClass, isLongArray, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.E);
  this.C = arrayClass;
  this.n = ({
    P: 1,
    a: 1
  });
  this.O = componentData;
  this.B = componentData;
  this.D = 1;
  this.E = name;
  this.N = name;
  this.Z = true;
  var self = this;
  this.F = (isAssignableFromFun || ((that) => (self === that)));
  this.w = (isLongArray ? ((array) => {
    var len = (array.length | 0);
    var result = new arrayClass(len);
    var u = result.a;
    for (var i = 0; (i < len); i = ((i + 1) | 0)) {
      var srcElem = array[i];
      u[(i << 1)] = srcElem.l;
      u[(((i << 1) + 1) | 0)] = srcElem.h;
    }
    return result;
  }) : (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array))));
  this.I = ((obj) => (obj instanceof arrayClass));
  return this;
});
$p.a = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.a = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.a[i] = null;
      }
    } else {
      this.a = arg;
    }
  }
  var $p = ArrayClass.prototype = new $ah_O();
  $p.constructor = ArrayClass;
  $p.av = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.a, srcPos, dest.a, destPos, length);
  });
  $p.ar = (function() {
    return new ArrayClass(this.a.slice());
  });
  $p.$classData = this;
  var arrayBase = (componentData.B || componentData);
  var arrayDepth = (componentData.D + 1);
  var name = ("[" + componentData.E);
  this.C = ArrayClass;
  this.n = ({
    P: 1,
    a: 1
  });
  this.O = componentData;
  this.B = arrayBase;
  this.D = arrayDepth;
  this.E = name;
  this.N = name;
  this.Z = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.D;
    return ((thatDepth === arrayDepth) ? arrayBase.F(that.B) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)));
  });
  this.F = isAssignableFromFun;
  this.w = ((array) => new ArrayClass(array));
  var self = this;
  this.I = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)));
  });
  return this;
});
$p.r = (function() {
  if ((!this.A)) {
    this.A = new $TypeData().a(this);
  }
  return this.A;
});
$p.l = (function() {
  if ((!this.L)) {
    this.L = new $c_jl_Class(this);
  }
  return this.L;
});
$p.R = (function(that) {
  return ((this === that) || this.F(that));
});
$p.S = (function() {
  return (this.P ? this.P.l() : null);
});
$p.Q = (function() {
  return (this.O ? this.O.l() : null);
});
$p.U = (function(length) {
  if ((this === $d_V)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return new (this.r().C)(length);
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false;
  } else {
    var arrayDepth = data.D;
    return ((arrayDepth === depth) ? (!data.B.X) : (arrayDepth > depth));
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_Z))));
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_C))));
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_B))));
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_S))));
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_I))));
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_J))));
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_F))));
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && (obj.$classData.B === $d_D))));
}
var $d_O = new $TypeData();
$d_O.n = ({});
$d_O.E = "Ljava.lang.Object;";
$d_O.F = ((that) => (!that.X));
$d_O.N = "java.lang.Object";
$d_O.I = ((obj) => (obj !== null));
$d_O.A = new $TypeData().y($d_O, $ac_O, (void 0), false, ((that) => {
  var thatDepth = that.D;
  return ((thatDepth === 1) ? (!that.B.X) : (thatDepth > 1));
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().p((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().p(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().p(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().p(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().p(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().p(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().p($bL0, "J", "long", $ac_J, Int32Array);
var $d_F = new $TypeData().p(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().p(0.0, "D", "double", $ac_D, Float64Array);
var $typedArraysAreBigEndian = (new Int8Array(new Int32Array([1]).buffer)[0] === 0);
function $constArrayBuffer_B(len, encoded) {
  var buf = new ArrayBuffer(len);
  var view = new DataView(buf);
  var regularChunksEnd = ((encoded.length - 4) | 0);
  var i = 0;
  var j = 0;
  var chunk = 0;
  while (true) {
    chunk = (((encoded.charCodeAt(i) | (encoded.charCodeAt(((i + 1) | 0)) << 8)) | (encoded.charCodeAt(((i + 2) | 0)) << 16)) | (encoded.charCodeAt(((i + 3) | 0)) << 24));
    chunk = ((((chunk - 808464432) | 0) - ((chunk & 1616928864) >>> 3)) | 0);
    chunk = (((chunk & 1056980736) >>> 2) | (chunk & 4128831));
    chunk = (((chunk & 268369920) >>> 4) | (chunk & 4095));
    if ((i === regularChunksEnd)) {
      break;
    }
    view.setUint32(j, chunk, true);
    i = ((i + 4) | 0);
    j = ((j + 3) | 0);
  }
  var trailing = ((len - j) | 0);
  view.setUint8(j, chunk);
  if ((trailing !== 1)) {
    view.setUint8(((j + 1) | 0), (chunk >>> 8));
    if ((trailing === 3)) {
      view.setUint8(((j + 2) | 0), (chunk >>> 16));
    }
  }
  return buf;
}
function $constArrayBuffer_S(len, encoded) {
  var buf = $constArrayBuffer_B((len << 1), encoded);
  if ($typedArraysAreBigEndian) {
    var view = new DataView(buf);
    var i = 0;
    while ((i !== len)) {
      view.putInt16(i, view.getInt16(i, true), false);
      i = ((i + 2) | 0);
    }
  }
  return buf;
}
function $constArrayBuffer_I(len, encoded) {
  var buf = $constArrayBuffer_B((len << 2), encoded);
  if ($typedArraysAreBigEndian) {
    var view = new DataView(buf);
    var i = 0;
    while ((i !== len)) {
      view.putInt32(i, view.getInt32(i, true), false);
      i = ((i + 4) | 0);
    }
  }
  return buf;
}
function $constArrayBuffer_J(len, encoded) {
  return $constArrayBuffer_I((len << 1), encoded);
}
function $constTypedArrayU_I(len, encoded, prevMask) {
  var buf = new Int32Array(len);
  var inLen = (encoded.length | 0);
  var prev = 0;
  var i = 0;
  var j = 0;
  var v = 0;
  while ((i !== inLen)) {
    var c = encoded.charCodeAt(i);
    if ((c < 80)) {
      v = ((v | (c - 48)) << 5);
    } else {
      v = (v | (c - 93));
      prev = (((prev & prevMask) + v) | 0);
      buf[j] = prev;
      j = ((j + 1) | 0);
      v = 0;
    }
    i = ((i + 1) | 0);
  }
  return buf;
}
function $constTypedArrayS_I(len, encoded, prevMask) {
  var buf = new Int32Array(len);
  var inLen = (encoded.length | 0);
  var prev = 0;
  var i = 0;
  var j = 0;
  var v = 0;
  var first = true;
  while ((i !== inLen)) {
    var c = encoded.charCodeAt(i);
    if ((c < 80)) {
      if (first) {
        v = (((c - 48) << 27) >> 22);
        first = false;
      } else {
        v = ((v | (c - 48)) << 5);
      }
    } else {
      if (first) {
        v = (((c - 93) << 27) >> 27);
      } else {
        v = (v | (c - 93));
        first = true;
      }
      prev = (((prev & prevMask) + v) | 0);
      buf[j] = prev;
      j = ((j + 1) | 0);
    }
    i = ((i + 1) | 0);
  }
  return buf;
}
function $constArrRaw_B(len, encoded) {
  return new $ac_B(new Int8Array($constArrayBuffer_B(len, encoded)));
}
function $constArrRaw_S(len, encoded) {
  return new $ac_S(new Int16Array($constArrayBuffer_S(len, encoded)));
}
function $constArrRaw_C(len, encoded) {
  return new $ac_C(new Uint16Array($constArrayBuffer_S(len, encoded)));
}
function $constArrRaw_I(len, encoded) {
  return new $ac_I(new Int32Array($constArrayBuffer_I(len, encoded)));
}
function $constArrRaw_J(len, encoded) {
  return new $ac_J(new Int32Array($constArrayBuffer_J(len, encoded)));
}
function $constArrUVals_I(len, encoded) {
  return new $ac_I($constTypedArrayU_I(len, encoded, 0));
}
function $constArrUDiffs_I(len, encoded) {
  return new $ac_I($constTypedArrayU_I(len, encoded, (-1)));
}
function $constArrSVals_I(len, encoded) {
  return new $ac_I($constTypedArrayS_I(len, encoded, 0));
}
function $constArrSDiffs_I(len, encoded) {
  return new $ac_I($constTypedArrayS_I(len, encoded, (-1)));
}
function $constArrUVals_J(len, encoded) {
  return new $ac_J($constTypedArrayU_I((len << 1), encoded, 0));
}
function $constArrUDiffs_J(len, encoded) {
  return new $ac_J($constTypedArrayU_I((len << 1), encoded, (-1)));
}
function $constArrSVals_J(len, encoded) {
  return new $ac_J($constTypedArrayS_I((len << 1), encoded, 0));
}
function $constArrSDiffs_J(len, encoded) {
  return new $ac_J($constTypedArrayS_I((len << 1), encoded, (-1)));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeBellNotification__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  $m_Lcom_papasofokli_util_package$().fo("86c4f99e-8d48-4a35-99d5-0aad15fb6c29").each((function() {
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(this.getAttribute("data-action"), "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      this.innerText = text$3;
    })), executionContext))), executionContext);
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__tenSecondsUI__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  $m_Lcom_papasofokli_util_package$().fo("636bd85a-892d-440f-a07e-b907d1a80e05").each((function() {
    var delaySecondsAttribute = this.getAttribute("delay-seconds");
    var this$4 = ($m_sc_StringOps$(), $m_sc_StringParsers$().fs(delaySecondsAttribute));
    var seconds = ((this$4.c() ? 10 : this$4.h()) | 0);
    var spanId = $m_ju_UUID$().aW().g();
    var timeSpan = $m_Lscalatags_JsDom$all$().auC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(spanId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ayy().alI("center", $m_Lscalatags_JsDom$all$().acM)]));
    this.appendChild(timeSpan.aB());
    var spanElement = document.getElementById(spanId);
    var isEmpty = (seconds < 0);
    var scala$collection$immutable$Range$$numRangeElements = ((1 + seconds) | 0);
    $m_sci_List$();
    var this$14 = $m_sci_Nil$();
    if (isEmpty) {
      var $x_1 = 0;
    } else {
      if ((scala$collection$immutable$Range$$numRangeElements <= 0)) {
        $m_sci_Range$().oY(0, seconds, 1, true);
      }
      var $x_1 = scala$collection$immutable$Range$$numRangeElements;
    }
    if (($x_1 === 0)) {
      var this$18 = this$14;
    } else {
      var iter = new $c_sci_RangeIterator(0, 1, seconds, isEmpty);
      if (iter.gu) {
        var result = new $c_sci_$colon$colon(iter.jx(), this$14);
        var curr = result;
        while (iter.gu) {
          var temp = new $c_sci_$colon$colon(iter.jx(), this$14);
          curr.bz = temp;
          curr = temp;
        }
        var this$18 = result;
      } else {
        var this$18 = this$14;
      }
    }
    var f = ((passed$3) => {
      var passed$2 = (passed$3 | 0);
      var $x_2 = $m_Lcom_papasofokli_util_DelayFuture$();
      var hi = (passed$2 >> 31);
      var b0 = (65535 & passed$2);
      var b1 = ((passed$2 >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
      return $x_2.jj(lo, hi$1).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => {
        spanElement.innerText = (((seconds - passed$2) | 0) + " seconds");
        if ((passed$2 === seconds)) {
          var \u03b42$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(this);
          return \u03b42$.fadeOut("slow");
        } else {
          return (void 0);
        }
      })), executionContext);
    });
    if ((this$18 === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var x0$1 = this$18.W();
      var h = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      var t = h;
      var rest = this$18.ak();
      while ((rest !== $m_sci_Nil$())) {
        var x0$2 = rest.W();
        var nx = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
        t.bz = nx;
        t = nx;
        rest = rest.ak();
      }
      var $x_3 = h;
    }
    return $x_3;
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeTables__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-tables").each((function() {
    var id = this.id;
    return $m_Lcom_papasofokli_dataTables_ScalaJsTable$().av8(id, ($m_Lcom_papasofokli_dataTables_ScalaJsTable$(), $m_s_None$()), executionContext);
  })).removeClass("not-initialized-tables");
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeStatusDiv__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-status-component-div").removeClass("not-initialized-status-component-div").each((function() {
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(this.id).g(), "", executionContext);
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__animateRotate__Lcom_papasofokli_jquery_JQuery($thiz) {
  var jq = (0, $m_Lcom_papasofokli_jquery_package$().I)(".animate.animate-rotate").removeClass("animate");
  return jq.parent().click(((event$2) => (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + event$2.delegateTarget.id) + " .animate-rotate")).toggleClass("right-angle")));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeNotificationLink__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialised-notificationLink").removeClass("not-initialised-notificationLink").each((function() {
    var id = this.id;
    var linkJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
    var dataClickFunctionUUID = this.getAttribute("data-selection-click");
    return (($m_sc_StringOps$(), (dataClickFunctionUUID !== "")) ? linkJQ.on("click", ((_$2$2) => $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(dataClickFunctionUUID).g(), "", executionContext))) : (void 0));
  }));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialised-notificationSelectionLink").removeClass("not-initialised-notificationSelectionLink").each((function() {
    var id$2 = this.id;
    var linkJQ$1 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id$2));
    var dataClickFunctionUUID$1 = this.getAttribute("data-selection-click");
    return (($m_sc_StringOps$(), (dataClickFunctionUUID$1 !== "")) ? linkJQ$1.on("click", ((_$3$2) => $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(dataClickFunctionUUID$1).g(), id$2, executionContext))) : (void 0));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeNavBarMinimalizeButton__V($thiz) {
  $m_Lcom_papasofokli_util_package$().fo("not-initialized-navbar-minimalize").each((function() {
    var id = this.id;
    var jq = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
    return jq.click(((event$3) => {
      event$3.preventDefault();
      $m_Lcom_papasofokli_util_package$().UD(false);
    }));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeActivityStream__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".dc0d230d-4051-a668-bb37-0aad15fb6c29").removeClass("dc0d230d-4051-a668-bb37-0aad15fb6c29").each((function() {
    var dataClickFunctionUUID = this.getAttribute("data-selection-click");
    (0, $m_Lcom_papasofokli_jquery_package$().I)(".stream-panel-item").each((function() {
      var id = this.id;
      var linkJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
      return (($m_sc_StringOps$(), (dataClickFunctionUUID !== "")) ? linkJQ.on("click", ((_$4$2) => {
        var selectedId = $p_Lcom_papasofokli_InitializeScalaJS$__getSelectedPanelId__T($thiz);
        (0, $m_Lcom_papasofokli_jquery_package$().I)(".stream-panel").each((function() {
          return (void 0);
        })).removeClass("selected-panel");
        (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + id) + "sp")).addClass("selected-panel");
        var this$19 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
        var id$1 = $m_ju_UUID$().aO(dataClickFunctionUUID);
        var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_agileboard_SelectedIdsRequest(($m_sc_StringOps$(), $m_sc_StringParsers$().Er(selectedId)), ($m_sc_StringOps$(), $m_sc_StringParsers$().Er(id))), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_agileboard_SelectedIdsRequest$().q());
        return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$19, id$1.g(), data, executionContext);
      })) : (void 0));
    }));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__getSelectedPanelId__T($thiz) {
  return $f_T__replaceAll__T__T__T($dp_toString__T((0, $m_Lcom_papasofokli_jquery_package$().I)(".selected-panel").first().attr("id")), "sp", "");
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeOnLoadActionSpan__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-on-load-action-span").removeClass("not-initialized-on-load-action-span").each((function() {
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(this.getAttribute("data-on-load-function")).g(), "", executionContext);
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeRedirectDiv__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  $m_Lcom_papasofokli_util_package$().fo("cb8af791-454e-48cf-8aae-b33b274006e4").each((function() {
    return $m_sjs_js_timers_package$().gb(500.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(this.getAttribute("redirect-function")).g(), "", executionContext);
    })));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeA__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".d247c8b4-0587-44aa-954e-c3ef55e7b462"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    var id = x0.id;
    x0.addEventListener("click", ((executionContext, id) => ((_$6$2) => {
      var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(id).g(), "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), executionContext))), executionContext).hj(new $c_Lcom_papasofokli_InitializeScalaJS$$anon$1(freezePage), executionContext);
    }))(executionContext, id));
    x0.classList.remove("d247c8b4-0587-44aa-954e-c3ef55e7b462");
  }
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeBlockKeyDown__Lcom_papasofokli_jquery_JQuery($thiz) {
  return $m_Lcom_papasofokli_util_package$().fo("ca3b63a2-fb85-41dd-9674-d85554e3f525").each((function() {
    this.addEventListener("keydown", ((event$2) => {
      event$2.preventDefault();
    }));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializeBadge__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return $m_Lcom_papasofokli_util_package$().fo("2db70534-1540-4903-8384-678aff65efd3").each((function() {
    var badge = document.querySelector(("#" + this.id));
    var getTextFunId = badge.getAttribute("data-get-text-function");
    return (($m_sc_StringOps$(), (getTextFunId !== "")) ? $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getTextFunId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      var html = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
      $m_sc_StringOps$();
      var size = $m_jl_Integer$().c7(html, 10, 214748364);
      var content = ((size > 99) ? "99+" : html);
      if ((size === 0)) {
        this.classList.add("invisible");
      } else {
        this.classList.remove("invisible");
        this.textContent = content;
      }
      return resp$2;
    })), executionContext))), executionContext) : (void 0));
  }));
}
function $p_Lcom_papasofokli_InitializeScalaJS$__initializePostReloadDiv__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, executionContext) {
  return $m_Lcom_papasofokli_util_package$().fo("e2232ba8-f12e-4043-b57d-ae8d159fafa2").each((function() {
    var divElement = document.querySelector(("#" + this.id));
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(divElement.getAttribute("data-function-id")).g(), "", executionContext).hj(new $c_Lcom_papasofokli_InitializeScalaJS$$anon$2(), executionContext);
  }));
}
/** @constructor */
function $c_Lcom_papasofokli_InitializeScalaJS$() {
}
$p = $c_Lcom_papasofokli_InitializeScalaJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_InitializeScalaJS$;
/** @constructor */
function $h_Lcom_papasofokli_InitializeScalaJS$() {
}
$h_Lcom_papasofokli_InitializeScalaJS$.prototype = $p;
$p.b7 = (function(executionContext) {
  $m_Lcom_papasofokli_sidebar_LiSideBarJS$().b7(executionContext);
  $m_Lcom_papasofokli_input_InputJs$().av3();
  $m_Lcom_papasofokli_input_DoubleInputJs$().co();
  $m_Lcom_papasofokli_input_LongInputJs$().co();
  $m_Lcom_papasofokli_input_SelectInputJs$().b7(executionContext);
  $m_Lcom_papasofokli_input_CheckboxJs$().b7(executionContext);
  $m_Lcom_papasofokli_input_ColorInputJs$().b7(executionContext);
  $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$().av1();
  $m_Lcom_papasofokli_chartjs_ChartJSInitializer$().av0(executionContext);
  $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().av4(executionContext);
  $m_Lcom_papasofokli_attachments_UploadJs$().b7(executionContext);
  $m_Lcom_papasofokli_dataTables_TableInitialize$().av6(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeTables__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $m_Lcom_papasofokli_buttons_ButtonsInitializer$().auY(executionContext);
  $m_Lcom_papasofokli_buttons_ButtonsInitializer$().av7(executionContext);
  $m_Lcom_papasofokli_input_MoneyInputJs$().co();
  $m_Lcom_papasofokli_components_ModalJS$().b7(executionContext);
  $p_Lcom_papasofokli_attachments_ProfilePictureJS$__initializeDeleteProfilePictureButton__V($m_Lcom_papasofokli_attachments_ProfilePictureJS$());
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeStatusDiv__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__animateRotate__Lcom_papasofokli_jquery_JQuery(this);
  $m_Lcom_papasofokli_attachments_ShowPagesJS$().av5(executionContext);
  $m_Lcom_papasofokli_attachments_ImageViewerJS$().av2(executionContext);
  $m_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$().auX(executionContext);
  $m_Lcom_papasofokli_tour_TourInitializer$().ava(executionContext);
  $m_Lcom_papasofokli_chat_ChatJs$().co();
  $m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$().b7(executionContext);
  $m_Lcom_papasofokli_components_BoxJS$().b7(executionContext);
  $m_Lcom_papasofokli_components_NavTabsJS$().b7(executionContext);
  $m_Lcom_papasofokli_progressbar_ProgressBarInitializer$().auW();
  $m_Lcom_papasofokli_tree_DualListBoxJs$().b7(executionContext);
  $m_Lcom_papasofokli_pagination_PaginationJs$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeNotificationLink__s_concurrent_ExecutionContext__V(this, executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeNavBarMinimalizeButton__V(this);
  $m_Lcom_papasofokli_rating_RatingInitializer$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__tenSecondsUI__s_concurrent_ExecutionContext__V(this, executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeBellNotification__s_concurrent_ExecutionContext__V(this, executionContext);
  $m_Lcom_papasofokli_buttons_CopyButtonInitializer$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeActivityStream__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $m_Lcom_papasofokli_qr_scan_QRScanInitializer$().IM(executionContext);
  $m_Lcom_papasofokli_components_OutlookJS$().b7(executionContext);
  $m_Lcom_papasofokli_agileboard_AgileBoardJs$().b7(executionContext);
  $m_Lcom_papasofokli_tileboard_TileBoardJs$().av9(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeOnLoadActionSpan__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $m_Lcom_papasofokli_components_NonSessionExpiringDivJs$().IM(executionContext);
  $m_Lcom_papasofokli_tree_TreeJs$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeRedirectDiv__s_concurrent_ExecutionContext__V(this, executionContext);
  $m_Lcom_papasofokli_components_PopoverJS$().b7(executionContext);
  $m_Lcom_papasofokli_components_TempusDominusJS$().co();
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeA__s_concurrent_ExecutionContext__V(this, executionContext);
  $m_Lcom_papasofokli_card_CardJs$().IM(executionContext);
  $m_Lcom_papasofokli_components_AccordionContentJS$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeBadge__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $m_Lcom_papasofokli_clock_ClockJs$().b7(executionContext);
  $m_Lcom_papasofokli_components_CalendarJS$().avb(executionContext);
  $m_Lcom_papasofokli_components_CalendarJS$().auZ();
  $m_Lcom_papasofokli_components_ToastJS$().co();
  $m_Lcom_papasofokli_clock_CountdownJs$().co();
  $m_Lcom_papasofokli_input_EnhancedTextInputJs$().co();
  $m_Lcom_papasofokli_zxing_InitializeVideoScanner$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializePostReloadDiv__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this, executionContext);
  $m_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$().b7(executionContext);
  $p_Lcom_papasofokli_InitializeScalaJS$__initializeBlockKeyDown__Lcom_papasofokli_jquery_JQuery(this);
  $m_Lcom_papasofokli_pos_PosBarcodeInputJs$().co();
  $m_Lcom_papasofokli_pos_VibrateInitializerJs$().co();
  $m_Lcom_papasofokli_pos_FloatingActionButtonJs$().co();
  $m_Lcom_papasofokli_pos_FullscreenInitializerJs$().co();
  $m_Lcom_papasofokli_components_StyleJs$().co();
  $m_Lcom_papasofokli_signature_SignaturePadJS$().co();
  $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().co();
  $m_Lcom_papasofokli_components_SwipeableMenuListJS$().co();
  $m_Lcom_papasofokli_bootstrap_ClickStopPropagation$().amJ();
  $m_Lcom_papasofokli_util_SyncScrollJs$().co();
  $m_Lcom_papasofokli_util_TopBottomScrollDivJs$().co();
});
$p.U7 = (function(uuid) {
  var uuid$tailLocal1 = uuid;
  while (true) {
    if ((!$ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\d.*", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])).awe(uuid$tailLocal1.g()))) {
      return uuid$tailLocal1;
    } else {
      uuid$tailLocal1 = $m_ju_UUID$().aW();
    }
  }
});
var $d_Lcom_papasofokli_InitializeScalaJS$ = new $TypeData().i($c_Lcom_papasofokli_InitializeScalaJS$, "com.papasofokli.InitializeScalaJS$", ({
  jl: 1
}));
var $n_Lcom_papasofokli_InitializeScalaJS$;
function $m_Lcom_papasofokli_InitializeScalaJS$() {
  if ((!$n_Lcom_papasofokli_InitializeScalaJS$)) {
    $n_Lcom_papasofokli_InitializeScalaJS$ = new $c_Lcom_papasofokli_InitializeScalaJS$();
  }
  return $n_Lcom_papasofokli_InitializeScalaJS$;
}
function $s_Lcom_papasofokli_TopLevelMethods__main__AT__V(args) {
  $m_Lcom_papasofokli_TopLevelMethods$().agH();
}
function $p_Lcom_papasofokli_TopLevelMethods$__pageStatusFunctions__V($thiz) {
  var pathName = window.location.pathname;
  if ((pathName === "/login")) {
    $p_Lcom_papasofokli_TopLevelMethods$__enterPressLogin__V($thiz);
  } else if (((pathName.indexOf("/forgot") | 0) === (-1))) {
    try {
      $m_Lcom_papasofokli_websocket_WebSocketInitializer$().ahM($m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchResult1: {
        var x2 = $m_s_util_control_NonFatal$().dV(e$2);
        if ((!x2.c())) {
          var x3 = x2.h();
          break matchResult1;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
      }
    }
  }
}
function $p_Lcom_papasofokli_TopLevelMethods$__enterPressLogin__V($thiz) {
  if ((window.location.pathname === "/login")) {
    $m_sjs_js_timers_package$().gb(500.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      (0, $m_Lcom_papasofokli_jquery_package$().I)("input").each((function() {
        return (!(!this.dispatchEvent(new Event("input"))));
      }));
    })));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(document.body).keypress(((event$2) => (((event$2.which | 0) === 13) ? (event$2.preventDefault(), (0, $m_Lcom_papasofokli_jquery_package$().I)(".153d8be1-e834-4d8e-864e-993c420e322d").click()) : (void 0))));
  } else {
    try {
      $m_Lcom_papasofokli_websocket_WebSocketInitializer$().ahM($m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchResult1: {
        var x2 = $m_s_util_control_NonFatal$().dV(e$2);
        if ((!x2.c())) {
          var x3 = x2.h();
          break matchResult1;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
      }
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_TopLevelMethods$() {
}
$p = $c_Lcom_papasofokli_TopLevelMethods$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_TopLevelMethods$;
/** @constructor */
function $h_Lcom_papasofokli_TopLevelMethods$() {
}
$h_Lcom_papasofokli_TopLevelMethods$.prototype = $p;
$p.amg = (function(id, data) {
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(0, 0, $m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
  var this$1 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id$1 = $m_ju_UUID$().aO(id);
  var executionContext = $m_sjs_concurrent_JSExecutionContext$Implicits$().kx;
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, id$1.g(), data, executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => freezePage.ep())), $m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
});
$p.ah7 = (function() {
  var width = (document.documentElement.clientWidth | 0);
  var body = document.querySelector("body");
  var nav = document.querySelector("#sidebar-div");
  var pageWrapper = document.querySelector("#page-wrapper");
  var hasMiniBar = (!(!body.classList.contains("mini-navbar")));
  if ((width < 768)) {
    if ((!(!(!body.classList.contains("body-small"))))) {
      body.classList.add("body-small");
      body.classList.remove("mini-navbar");
    }
  } else if ((nav !== null)) {
    body.classList.remove("body-small");
    nav.classList.remove("navbar-ease-expand");
    pageWrapper.classList.remove("screen-hover");
    (0, $m_Lcom_papasofokli_jquery_package$().I)(pageWrapper).unbind("click");
    if (hasMiniBar) {
      body.classList.remove("mini-navbar");
    }
  }
});
$p.agH = (function() {
  $i_chartjs$002dadapter$002dmoment;
  (0, $m_Lcom_papasofokli_jquery_package$().I)(document).ready($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lcom_papasofokli_InitializeScalaJS$().b7($m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
    $m_Lcom_papasofokli_util_GeometryMethods$().azw($m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
    $p_Lcom_papasofokli_TopLevelMethods$__pageStatusFunctions__V(this);
    $m_Lcom_papasofokli_sidebar_SideBarJS$().akk($m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
    this.ah7();
  }))));
});
var $d_Lcom_papasofokli_TopLevelMethods$ = new $TypeData().i($c_Lcom_papasofokli_TopLevelMethods$, "com.papasofokli.TopLevelMethods$", ({
  jo: 1
}));
var $n_Lcom_papasofokli_TopLevelMethods$;
function $m_Lcom_papasofokli_TopLevelMethods$() {
  if ((!$n_Lcom_papasofokli_TopLevelMethods$)) {
    $n_Lcom_papasofokli_TopLevelMethods$ = new $c_Lcom_papasofokli_TopLevelMethods$();
  }
  return $n_Lcom_papasofokli_TopLevelMethods$;
}
function $f_Lcom_papasofokli_agileboard_AgileBoardT__$init$__V($thiz) {
  $thiz.NL = "not-initialized-agile-board";
  $thiz.NN = "data-setup-function";
  $thiz.NJ = "data-click-function";
  $thiz.NI = "single";
  $thiz.NH = "board-item-style";
  $thiz.NK = "view-details";
  $thiz.NM = "view-resume";
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard2_AgileBoard2Functions$() {
}
$p = $c_Lcom_papasofokli_agileboard2_AgileBoard2Functions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard2_AgileBoard2Functions$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard2_AgileBoard2Functions$() {
}
$h_Lcom_papasofokli_agileboard2_AgileBoard2Functions$.prototype = $p;
$p.ayY = (function(agileBoard2Id, column, columnContent) {
  var agileBoardTable = document.getElementById(agileBoard2Id).getElementsByClassName("agile-board2-table")[0];
  var body = agileBoardTable.tBodies[0];
  columnContent.bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult1: {
      if ((x$1$3 !== null)) {
        var content = x$1$3.P();
        var idx = (x$1$3.V() | 0);
        var row = body.rows[idx];
        var cell = row.cells[column];
        cell.innerHTML = content;
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
});
var $d_Lcom_papasofokli_agileboard2_AgileBoard2Functions$ = new $TypeData().i($c_Lcom_papasofokli_agileboard2_AgileBoard2Functions$, "com.papasofokli.agileboard2.AgileBoard2Functions$", ({
  jQ: 1
}));
var $n_Lcom_papasofokli_agileboard2_AgileBoard2Functions$;
function $m_Lcom_papasofokli_agileboard2_AgileBoard2Functions$() {
  if ((!$n_Lcom_papasofokli_agileboard2_AgileBoard2Functions$)) {
    $n_Lcom_papasofokli_agileboard2_AgileBoard2Functions$ = new $c_Lcom_papasofokli_agileboard2_AgileBoard2Functions$();
  }
  return $n_Lcom_papasofokli_agileboard2_AgileBoard2Functions$;
}
function $p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z($thiz, zoom$1) {
  return (zoom$1.bv > 1.0);
}
function $p_Lcom_papasofokli_attachments_ImageViewerJS$__resetPan$1__sr_DoubleRef__sr_DoubleRef__V($thiz, panX$1, panY$1) {
  panX$1.bv = 0.0;
  panY$1.bv = 0.0;
}
function $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateCursor$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__V($thiz, imageElement$1, zoom$2) {
  imageElement$1.style.cursor = ($p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z($thiz, zoom$2) ? "grab" : "default");
}
function $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V($thiz, imageElement$2, panX$2, panY$2, zoom$3, rotation$1) {
  imageElement$2.style.transform = (((((((("translate(" + panX$2.bv) + "px, ") + panY$2.bv) + "px) scale(") + zoom$3.bv) + ") rotate(") + rotation$1.f4) + "deg)");
  $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateCursor$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__V($thiz, imageElement$2, zoom$3);
}
/** @constructor */
function $c_Lcom_papasofokli_attachments_ImageViewerJS$() {
}
$p = $c_Lcom_papasofokli_attachments_ImageViewerJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_ImageViewerJS$;
/** @constructor */
function $h_Lcom_papasofokli_attachments_ImageViewerJS$() {
}
$h_Lcom_papasofokli_attachments_ImageViewerJS$.prototype = $p;
$p.av2 = (function(executionContext) {
  $m_Lcom_papasofokli_util_package$().Eg("a3c8d9e1-7f2a-4b5c-9d6e-1a8f3b2c4d5e", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element$3) => {
    var clickFunctionId = element$3.getAttribute("data-click");
    var downloadFunctionId = element$3.getAttribute("data-download");
    var imageElement = element$3.querySelector(".viewer-image");
    var zoom = new $c_sr_DoubleRef(1.0);
    var rotation = new $c_sr_IntRef(0);
    var panX = new $c_sr_DoubleRef(0.0);
    var panY = new $c_sr_DoubleRef(0.0);
    var isDragging = new $c_sr_BooleanRef(false);
    var startX = new $c_sr_DoubleRef(0.0);
    var startY = new $c_sr_DoubleRef(0.0);
    var initialPanX = new $c_sr_DoubleRef(0.0);
    var initialPanY = new $c_sr_DoubleRef(0.0);
    var this$12 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".zoom-in-btn"));
    var it = this$12.l();
    while (it.f()) {
      var x0 = it.e();
      x0.addEventListener("click", ((zoom, imageElement, panX, panY, rotation) => ((_$2$2) => {
        var a = (zoom.bv + 0.25);
        zoom.bv = (+Math.min(a, 3.0));
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
      }))(zoom, imageElement, panX, panY, rotation));
    }
    var this$15 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".zoom-out-btn"));
    var it$1 = this$15.l();
    while (it$1.f()) {
      var x0$1 = it$1.e();
      x0$1.addEventListener("click", ((zoom, panX, panY, imageElement, rotation) => ((_$4$2) => {
        var a$1 = (zoom.bv - 0.25);
        zoom.bv = (+Math.max(a$1, 0.25));
        if ((!$p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z(this, zoom))) {
          $p_Lcom_papasofokli_attachments_ImageViewerJS$__resetPan$1__sr_DoubleRef__sr_DoubleRef__V(this, panX, panY);
        }
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
      }))(zoom, panX, panY, imageElement, rotation));
    }
    var this$18 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".reset-btn"));
    var it$2 = this$18.l();
    while (it$2.f()) {
      var x0$2 = it$2.e();
      x0$2.addEventListener("click", ((zoom, rotation, panX, panY, imageElement) => ((_$6$2) => {
        zoom.bv = 1.0;
        rotation.f4 = 0;
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__resetPan$1__sr_DoubleRef__sr_DoubleRef__V(this, panX, panY);
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
      }))(zoom, rotation, panX, panY, imageElement));
    }
    var this$20 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".rotate-left-btn"));
    var it$3 = this$20.l();
    while (it$3.f()) {
      var x0$3 = it$3.e();
      x0$3.addEventListener("click", ((rotation, imageElement, panX, panY, zoom) => ((_$8$2) => {
        rotation.f4 = ((((rotation.f4 - 90) | 0) % 360) | 0);
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
      }))(rotation, imageElement, panX, panY, zoom));
    }
    var this$22 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".rotate-right-btn"));
    var it$4 = this$22.l();
    while (it$4.f()) {
      var x0$4 = it$4.e();
      x0$4.addEventListener("click", ((rotation, imageElement, panX, panY, zoom) => ((_$10$2) => {
        rotation.f4 = ((((90 + rotation.f4) | 0) % 360) | 0);
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
      }))(rotation, imageElement, panX, panY, zoom));
    }
    var this$24 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$3.querySelectorAll(".download-btn"));
    var it$5 = this$24.l();
    while (it$5.f()) {
      var x0$5 = it$5.e();
      x0$5.addEventListener("click", ((downloadFunctionId, executionContext) => ((_$12$2) => {
        var this$28 = new $c_s_Option$WithFilter($m_s_Option$().Z(downloadFunctionId), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13$2) => {
          $m_sc_StringOps$();
          return (_$13$2 !== "");
        })));
        var this$29 = this$28.y6;
        var p$1 = this$28.y7;
        var this$30 = ((this$29.c() || (!(!p$1.p(this$29.h())))) ? this$29 : $m_s_None$());
        if ((!this$30.c())) {
          $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(this$30.h()).g(), "", executionContext);
        }
      }))(downloadFunctionId, executionContext));
    }
    imageElement.addEventListener("mousedown", ((e$2) => {
      if ($p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z(this, zoom)) {
        e$2.preventDefault();
        isDragging.e1 = true;
        startX.bv = (+e$2.clientX);
        startY.bv = (+e$2.clientY);
        initialPanX.bv = panX.bv;
        initialPanY.bv = panY.bv;
        imageElement.style.cursor = "grabbing";
        imageElement.classList.add("dragging");
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    document.addEventListener("mousemove", ((e$2$1) => {
      if ((isDragging.e1 && $p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z(this, zoom))) {
        e$2$1.preventDefault();
        var deltaX = ((+e$2$1.clientX) - startX.bv);
        var deltaY = ((+e$2$1.clientY) - startY.bv);
        panX.bv = (initialPanX.bv + deltaX);
        panY.bv = (initialPanY.bv + deltaY);
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    document.addEventListener("mouseup", ((_$14$2) => {
      if (isDragging.e1) {
        isDragging.e1 = false;
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateCursor$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__V(this, imageElement, zoom);
        imageElement.classList.remove("dragging");
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    imageElement.addEventListener("touchstart", ((e$2$2) => {
      if (($p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z(this, zoom) && ((e$2$2.touches.length | 0) === 1))) {
        e$2$2.preventDefault();
        isDragging.e1 = true;
        startX.bv = (+e$2$2.touches[0].clientX);
        startY.bv = (+e$2$2.touches[0].clientY);
        initialPanX.bv = panX.bv;
        initialPanY.bv = panY.bv;
        imageElement.classList.add("dragging");
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    document.addEventListener("touchmove", ((e$2$3) => {
      if (((isDragging.e1 && $p_Lcom_papasofokli_attachments_ImageViewerJS$__isZoomed$1__sr_DoubleRef__Z(this, zoom)) && ((e$2$3.touches.length | 0) === 1))) {
        e$2$3.preventDefault();
        var deltaX$1 = ((+e$2$3.touches[0].clientX) - startX.bv);
        var deltaY$1 = ((+e$2$3.touches[0].clientY) - startY.bv);
        panX.bv = (initialPanX.bv + deltaX$1);
        panY.bv = (initialPanY.bv + deltaY$1);
        $p_Lcom_papasofokli_attachments_ImageViewerJS$__updateTransform$1__Lorg_scalajs_dom_HTMLImageElement__sr_DoubleRef__sr_DoubleRef__sr_DoubleRef__sr_IntRef__V(this, imageElement, panX, panY, zoom, rotation);
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    document.addEventListener("touchend", ((_$15$2) => {
      if (isDragging.e1) {
        isDragging.e1 = false;
        imageElement.classList.remove("dragging");
        return (void 0);
      } else {
        return (void 0);
      }
    }));
    var this$35 = new $c_s_Option$WithFilter($m_s_Option$().Z(clickFunctionId), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16$2) => {
      $m_sc_StringOps$();
      return (_$16$2 !== "");
    })));
    var this$36 = this$35.y6;
    var p$3 = this$35.y7;
    var this$37 = ((this$36.c() || (!(!p$3.p(this$36.h())))) ? this$36 : $m_s_None$());
    if ((!this$37.c())) {
      var x0$7 = this$37.h();
      imageElement.addEventListener("click", ((funcId$1) => ((e$2$4) => ((!isDragging.e1) ? (e$2$4.preventDefault(), $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(funcId$1).g(), "", executionContext), (void 0)) : (void 0))))(x0$7));
    }
  })));
});
var $d_Lcom_papasofokli_attachments_ImageViewerJS$ = new $TypeData().i($c_Lcom_papasofokli_attachments_ImageViewerJS$, "com.papasofokli.attachments.ImageViewerJS$", ({
  jS: 1
}));
var $n_Lcom_papasofokli_attachments_ImageViewerJS$;
function $m_Lcom_papasofokli_attachments_ImageViewerJS$() {
  if ((!$n_Lcom_papasofokli_attachments_ImageViewerJS$)) {
    $n_Lcom_papasofokli_attachments_ImageViewerJS$ = new $c_Lcom_papasofokli_attachments_ImageViewerJS$();
  }
  return $n_Lcom_papasofokli_attachments_ImageViewerJS$;
}
function $p_Lcom_papasofokli_attachments_ProfilePictureJS$__initializeDeleteProfilePictureButton__V($thiz) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".profile-img-i-container").each((function() {
    var deleteId = this.id;
    if ((deleteId !== (void 0))) {
      $m_sc_StringOps$();
      if ((deleteId === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      $f_T__trim__T(deleteId);
    }
  }));
}
/** @constructor */
function $c_Lcom_papasofokli_attachments_ProfilePictureJS$() {
}
$p = $c_Lcom_papasofokli_attachments_ProfilePictureJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_ProfilePictureJS$;
/** @constructor */
function $h_Lcom_papasofokli_attachments_ProfilePictureJS$() {
}
$h_Lcom_papasofokli_attachments_ProfilePictureJS$.prototype = $p;
var $d_Lcom_papasofokli_attachments_ProfilePictureJS$ = new $TypeData().i($c_Lcom_papasofokli_attachments_ProfilePictureJS$, "com.papasofokli.attachments.ProfilePictureJS$", ({
  jT: 1
}));
var $n_Lcom_papasofokli_attachments_ProfilePictureJS$;
function $m_Lcom_papasofokli_attachments_ProfilePictureJS$() {
  if ((!$n_Lcom_papasofokli_attachments_ProfilePictureJS$)) {
    $n_Lcom_papasofokli_attachments_ProfilePictureJS$ = new $c_Lcom_papasofokli_attachments_ProfilePictureJS$();
  }
  return $n_Lcom_papasofokli_attachments_ProfilePictureJS$;
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__uploadImagesFunction__T__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__s_concurrent_ExecutionContext__V($thiz, uploadId, doneId, element, additionalSupportedTypes, executionContext) {
  var this$2 = $m_sc_StringOps$().Eb(uploadId);
  if ((!this$2.c())) {
    $uC(this$2.h());
    (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + element.id) + " ~ .plus")).click(((_$3$2) => (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + element.id) + " ~ input")).each((function() {
      this.click();
      this.onchange = ((_$4$2) => {
        var $x_3 = $m_Lcom_papasofokli_attachments_UploadJs$();
        var $x_2 = this.files;
        var $x_1 = $m_Lcom_papasofokli_ImageUploadS$();
        return $x_3.Vp(uploadId, "a7079b8a-2206-4980-8643-0b812ca36fbc", doneId, $x_2, additionalSupportedTypes, $x_1.Tm, $x_1.Tn, executionContext);
      });
    }))));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(element).on("drop", ((_$5$2) => {
      $p_Lcom_papasofokli_attachments_ShowPagesJS$__drop__T__T__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__Lcom_papasofokli_jquery_JQueryEventObject__s_concurrent_ExecutionContext__V($thiz, uploadId, doneId, additionalSupportedTypes, _$5$2, executionContext);
    })).on("dragover", ((_$6$2) => {
      $p_Lcom_papasofokli_attachments_ShowPagesJS$__allowDrop__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, element, _$6$2);
    })).on("dragleave", $p_Lcom_papasofokli_attachments_ShowPagesJS$__dragLeave__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery($thiz, element));
  }
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__initializeImageActions__s_concurrent_ExecutionContext__V($thiz, executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".bcbc0a62-662c-455b-8ee2-97bee5339495"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    var functionId = x0.getAttribute("data-click");
    var this$7 = new $c_s_Option$WithFilter($m_s_Option$().Z(functionId), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$2) => {
      $m_sc_StringOps$();
      return (_$7$2 !== "");
    })));
    var this$8 = this$7.y6;
    var p$1 = this$7.y7;
    var this$9 = ((this$8.c() || (!(!p$1.p(this$8.h())))) ? this$8 : $m_s_None$());
    if ((!this$9.c())) {
      $p_Lcom_papasofokli_attachments_ShowPagesJS$__imageClickAction__Lorg_scalajs_dom_Element__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, x0, this$9.h(), executionContext);
    }
    x0.classList.remove("bcbc0a62-662c-455b-8ee2-97bee5339495");
  }
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__imageClickAction__Lorg_scalajs_dom_Element__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, elem, clickFunctionId, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)((((("#" + elem.id) + " , #") + elem.id) + " ~ .show-document")).click(((ev$2) => {
    ev$2.preventDefault();
    (0, $m_Lcom_papasofokli_jquery_package$().I)(".click-div-image").remove();
    (0, $m_Lcom_papasofokli_jquery_package$().I)(elem).parent("li").append($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("click-div-image", $m_Lscalatags_JsDom$all$().s)])).aB());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(clickFunctionId).g(), "", executionContext);
  }));
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__onLoadImagesActions__Lorg_scalajs_dom_Element__T__T__s_Option__s_concurrent_ExecutionContext__V($thiz, element, permId, deleteId, messageId, executionContext) {
  $p_Lcom_papasofokli_attachments_ShowPagesJS$__initializeImageActions__s_concurrent_ExecutionContext__V($thiz, executionContext);
  var elem = document.querySelector((("#" + element.id) + " .document-pages-ul"));
  var uiIdSeq = ((elem !== null) ? new $c_sci_$colon$colon(elem.id, $m_sci_Nil$()) : $m_sci_Nil$());
  var startLinks = uiIdSeq.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((uiId$2) => $p_Lcom_papasofokli_attachments_ShowPagesJS$__imageLinksSorted__T__sci_Seq($thiz, uiId$2))));
  var this$7 = new $c_s_Option$WithFilter($m_s_Option$().Z(permId), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => {
    $m_sc_StringOps$();
    return (_$8$2 !== "");
  })));
  var this$8 = this$7.y6;
  var p$1 = this$7.y7;
  var this$9 = ((this$8.c() || (!(!p$1.p(this$8.h())))) ? this$8 : $m_s_None$());
  if ((!this$9.c())) {
    $p_Lcom_papasofokli_attachments_ShowPagesJS$__imagesPermutationAction__Lorg_scalajs_dom_Element__sci_Seq__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, element, startLinks, this$9.h(), executionContext);
  }
  if (((!messageId.c()) && startLinks.c())) {
    $p_Lcom_papasofokli_attachments_ShowPagesJS$__hideErrorMessage__T__V($thiz, messageId.h());
  }
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__hideErrorMessage__T__V($thiz, messageId) {
  var errorMsgDivElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + messageId));
  errorMsgDivElement.removeClass("hidden");
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__imagesPermutationAction__Lorg_scalajs_dom_Element__sci_Seq__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, element, startLinks, permId, executionContext) {
  var $x_1 = (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + element.id) + " .document-pages-ul"));
  var beforeStop$1 = $p_Lcom_papasofokli_attachments_ShowPagesJS$__beforeStop__T__sci_Seq__s_concurrent_ExecutionContext__sjs_js_ThisFunction2($thiz, permId, startLinks, executionContext);
  return $x_1.sortable(new ($a_Lcom_papasofokli_jquery_SortableSettings())("highlight", beforeStop$1, (void 0), (void 0), (void 0), "x"));
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__getImageObjectLink__Lorg_scalajs_dom_Element__T($thiz, image) {
  return ((!(!(image instanceof HTMLImageElement))) ? image.src : ((!(!(image instanceof HTMLEmbedElement))) ? image.src : ((!(!(image instanceof HTMLObjectElement))) ? image.data : ((!(!(image instanceof HTMLDivElement))) ? image.getAttribute("data-link") : (console.error("Link cannot be found for this image."), "")))));
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__beforeStop__T__sci_Seq__s_concurrent_ExecutionContext__sjs_js_ThisFunction2($thiz, permId, startLinks, executionContext) {
  return (function(_$9$3, sortedElement$3) {
    var beforeRequestLinks = $p_Lcom_papasofokli_attachments_ShowPagesJS$__imageLinksSorted__T__sci_Seq($thiz, this.id);
    if ((!((startLinks === null) ? (beforeRequestLinks === null) : startLinks.b(beforeRequestLinks)))) {
      var scrollValue = (+(0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + this.id)).parent().scrollLeft());
      var $x_2 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var $x_1 = $m_Lupickle_default$();
      $m_Lupickle_default$();
      $m_Lupickle_default$();
      $m_Lupickle_default$();
      var this$5 = $m_Lupickle_default$();
      $x_2.c5(permId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, beforeRequestLinks, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5)), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
        (0, eval)(text$2);
        var newId = $f_T__split__T__I__AT(text$2, "\"", 0).a[1];
        return (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + newId) + " div div")).each((function() {
          console.log(this);
        })).scrollLeft(scrollValue);
      })), executionContext))), executionContext);
    } else {
      (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + $m_sjs_js_ArrayOps$().UC(sortedElement$3.item).id) + "  .show-document")).click();
    }
  });
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__imageLinksSorted__T__sci_Seq($thiz, id) {
  var imageLinks = [];
  (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + id) + " li .document-image")).each((function() {
    var link = $p_Lcom_papasofokli_attachments_ShowPagesJS$__getImageObjectLink__Lorg_scalajs_dom_Element__T($thiz, this);
    imageLinks.push(link);
    return imageLinks;
  }));
  return $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), imageLinks));
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__dragLeave__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery($thiz, element) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(element).removeClass("drag-over");
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__allowDrop__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, element, ev) {
  ev.preventDefault();
  (0, $m_Lcom_papasofokli_jquery_package$().I)(element).addClass("drag-over");
}
function $p_Lcom_papasofokli_attachments_ShowPagesJS$__drop__T__T__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__Lcom_papasofokli_jquery_JQueryEventObject__s_concurrent_ExecutionContext__V($thiz, uploadId, doneId, additionalSupportedTypes, ev, executionContext) {
  ev.preventDefault();
  var $x_3 = $m_Lcom_papasofokli_attachments_UploadJs$();
  var $x_2 = ev.originalEvent.dataTransfer.files;
  var $x_1 = $m_Lcom_papasofokli_ImageUploadS$();
  $x_3.Vp(uploadId, "a7079b8a-2206-4980-8643-0b812ca36fbc", doneId, $x_2, additionalSupportedTypes, $x_1.Tm, $x_1.Tn, executionContext);
}
/** @constructor */
function $c_Lcom_papasofokli_attachments_ShowPagesJS$() {
}
$p = $c_Lcom_papasofokli_attachments_ShowPagesJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_ShowPagesJS$;
/** @constructor */
function $h_Lcom_papasofokli_attachments_ShowPagesJS$() {
}
$h_Lcom_papasofokli_attachments_ShowPagesJS$.prototype = $p;
$p.av5 = (function(executionContext) {
  $m_Lcom_papasofokli_util_package$().Eg("not-initialized-pages-show", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element$3) => {
    var functionId = element$3.getAttribute("data-function");
    var permId = element$3.getAttribute("data-perm");
    var deleteId = element$3.getAttribute("data-del");
    var uploadId = element$3.getAttribute("data-upload");
    var doneId = element$3.getAttribute("data-done");
    var messageId = element$3.getAttribute("data-message-id");
    var additionalTypeUUIDs = $f_T__split__T__I__AT(element$3.getAttribute("data-additional"), " ", 0);
    var additionalSupportedTypes = $m_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$().amI($m_sc_ArrayOps$().NC(additionalTypeUUIDs));
    $m_sc_StringOps$();
    var cond = (messageId !== "");
    var messageIdO = (cond ? new $c_s_Some(messageId) : $m_s_None$());
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(functionId).g(), "", executionContext).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
      $p_Lcom_papasofokli_attachments_ShowPagesJS$__onLoadImagesActions__Lorg_scalajs_dom_Element__T__T__s_Option__s_concurrent_ExecutionContext__V(this, element$3, permId, deleteId, messageIdO, executionContext);
    })), executionContext);
    $p_Lcom_papasofokli_attachments_ShowPagesJS$__uploadImagesFunction__T__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__s_concurrent_ExecutionContext__V(this, uploadId, doneId, element$3, additionalSupportedTypes, executionContext);
  })));
});
var $d_Lcom_papasofokli_attachments_ShowPagesJS$ = new $TypeData().i($c_Lcom_papasofokli_attachments_ShowPagesJS$, "com.papasofokli.attachments.ShowPagesJS$", ({
  jU: 1
}));
var $n_Lcom_papasofokli_attachments_ShowPagesJS$;
function $m_Lcom_papasofokli_attachments_ShowPagesJS$() {
  if ((!$n_Lcom_papasofokli_attachments_ShowPagesJS$)) {
    $n_Lcom_papasofokli_attachments_ShowPagesJS$ = new $c_Lcom_papasofokli_attachments_ShowPagesJS$();
  }
  return $n_Lcom_papasofokli_attachments_ShowPagesJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_attachments_UploadJs$() {
}
$p = $c_Lcom_papasofokli_attachments_UploadJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_UploadJs$;
/** @constructor */
function $h_Lcom_papasofokli_attachments_UploadJs$() {
}
$h_Lcom_papasofokli_attachments_UploadJs$.prototype = $p;
$p.b7 = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".a7079b8a-2206-4980-8643-0b812ca36fbc"));
  var it = this$2.l();
  while (it.f()) {
    this.MV(it.e(), "a7079b8a-2206-4980-8643-0b812ca36fbc", executionContext);
  }
  var this$4 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".e42cba92-5702-4684-bc9c-68d86a29c911"));
  var it$1 = this$4.l();
  while (it$1.f()) {
    this.MV(it$1.e(), "e42cba92-5702-4684-bc9c-68d86a29c911", executionContext);
  }
  var this$6 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".af0cd447-ec41-457c-b2ab-8bfe18d60a90"));
  var it$2 = this$6.l();
  while (it$2.f()) {
    this.MV(it$2.e(), "af0cd447-ec41-457c-b2ab-8bfe18d60a90", executionContext);
  }
  var this$8 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".b3deebff-8ee2-4684-a586-2ae230c5513c"));
  var it$3 = this$8.l();
  while (it$3.f()) {
    this.MV(it$3.e(), "b3deebff-8ee2-4684-a586-2ae230c5513c", executionContext);
  }
});
$p.MV = (function(e, uploadType, executionContext) {
  var doneFunction = e.getAttribute("data-onDone");
  var maxFileSize = e.getAttribute("data-max-file-size");
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + e.id)).change($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var fileList = e.files;
    var $x_3 = e.id;
    var $x_2 = new $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes(false, false, false);
    var this$5 = ($m_sc_StringOps$(), $m_sc_StringParsers$().Er(maxFileSize));
    var $x_1 = $uJ((this$5.c() ? $bL(0, 0) : this$5.h()));
    return this.Vp($x_3, uploadType, doneFunction, fileList, $x_2, $x_1.l, $x_1.h, executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
      e.value = "";
    })), executionContext);
  }))));
  e.classList.remove(uploadType);
});
$p.Vp = (function(uploadId, uploadType, doneId, data, additionalSupportedTypes, maxFileSize_$_lo, maxFileSize_$_hi, executionContext) {
  var end = (data.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((end <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, end, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    b.aD(data[x0]);
  }
  var files = b.aR();
  return $m_s_concurrent_Future$().ajG(files.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => $m_Lcom_papasofokli_util_AjaxCallFunctions$().ami(uploadId, uploadType, _$3$2, maxFileSize_$_lo, maxFileSize_$_hi, additionalSupportedTypes, executionContext)))), ($m_sc_BuildFrom$(), new $c_sc_BuildFromLowPriority2$$anon$11()), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result$2) => {
    var this$8 = result$2.bj();
    var this$10 = (this$8.c() ? $m_s_None$() : new $c_s_Some(this$8.h().V()));
    var message = (this$10.c() ? "" : this$10.h());
    if ((!result$2.g8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => (!(!_$5$2.P()))))))) {
      $m_Lcom_papasofokli_components_ToastJS$().IZ(message, $m_s_Option$().Z($bL(10000, 0)));
    }
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(doneId).g(), message, executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => true)), executionContext);
  })), executionContext);
});
var $d_Lcom_papasofokli_attachments_UploadJs$ = new $TypeData().i($c_Lcom_papasofokli_attachments_UploadJs$, "com.papasofokli.attachments.UploadJs$", ({
  jV: 1
}));
var $n_Lcom_papasofokli_attachments_UploadJs$;
function $m_Lcom_papasofokli_attachments_UploadJs$() {
  if ((!$n_Lcom_papasofokli_attachments_UploadJs$)) {
    $n_Lcom_papasofokli_attachments_UploadJs$ = new $c_Lcom_papasofokli_attachments_UploadJs$();
  }
  return $n_Lcom_papasofokli_attachments_UploadJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_bootstrap_ClickStopPropagation$() {
}
$p = $c_Lcom_papasofokli_bootstrap_ClickStopPropagation$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_bootstrap_ClickStopPropagation$;
/** @constructor */
function $h_Lcom_papasofokli_bootstrap_ClickStopPropagation$() {
}
$h_Lcom_papasofokli_bootstrap_ClickStopPropagation$.prototype = $p;
$p.amJ = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".e9c33fc8-4b96-4e39-ba8c-119a809667f5"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove("e9c33fc8-4b96-4e39-ba8c-119a809667f5");
    x0.addEventListener("click", ((event$2) => {
      event$2.stopPropagation();
    }));
  }
});
var $d_Lcom_papasofokli_bootstrap_ClickStopPropagation$ = new $TypeData().i($c_Lcom_papasofokli_bootstrap_ClickStopPropagation$, "com.papasofokli.bootstrap.ClickStopPropagation$", ({
  jW: 1
}));
var $n_Lcom_papasofokli_bootstrap_ClickStopPropagation$;
function $m_Lcom_papasofokli_bootstrap_ClickStopPropagation$() {
  if ((!$n_Lcom_papasofokli_bootstrap_ClickStopPropagation$)) {
    $n_Lcom_papasofokli_bootstrap_ClickStopPropagation$ = new $c_Lcom_papasofokli_bootstrap_ClickStopPropagation$();
  }
  return $n_Lcom_papasofokli_bootstrap_ClickStopPropagation$;
}
function $p_Lcom_papasofokli_buttons_ButtonsInitializer$__getLongAttribute__Lorg_scalajs_dom_HTMLButtonElement__T__s_Option($thiz, element, attribute) {
  var cond = (!(!element.hasAttribute(attribute)));
  var this$3 = (cond ? new $c_s_Some(element.getAttribute(attribute)) : $m_s_None$());
  if (this$3.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$3.h();
    $m_sc_StringOps$();
    return $m_sc_StringParsers$().Er(x0);
  }
}
function $p_Lcom_papasofokli_buttons_ButtonsInitializer$__onClick__Lorg_scalajs_dom_HTMLButtonElement__Z__s_concurrent_ExecutionContext__V($thiz, element, withContent, executionContext) {
  var this$1 = $p_Lcom_papasofokli_buttons_ButtonsInitializer$__getLongAttribute__Lorg_scalajs_dom_HTMLButtonElement__T__s_Option($thiz, element, "delay-action");
  var $x_1 = $uJ((this$1.c() ? $bL(0, 0) : this$1.h()));
  var delayAction_$_lo = $x_1.l;
  var delayAction_$_hi = $x_1.h;
  var inner = element.innerHTML;
  var loadingHtml = (withContent ? (("" + $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Kz.by + " fa-spin"), $m_Lscalatags_JsDom$all$().s)])).aB().outerHTML) + inner) : $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Kz.by + " fa-spin"), $m_Lscalatags_JsDom$all$().s)])).aB().outerHTML);
  element.innerHTML = loadingHtml;
  element.disabled = true;
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
  $m_sjs_js_timers_package$().gb(((4.294967296E9 * delayAction_$_hi) + (delayAction_$_lo >>> 0.0)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(element.id).g(), "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => $m_Lcom_papasofokli_util_DelayFuture$().jj(300, 0).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      element.innerHTML = inner;
      element.disabled = false;
      return freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), executionContext);
    })), executionContext))), executionContext).hj(new $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1(freezePage, element, inner), executionContext);
  })));
}
function $p_Lcom_papasofokli_buttons_ButtonsInitializer$__enableAfterInit__Lorg_scalajs_dom_HTMLButtonElement__V($thiz, element) {
  var this$1 = $p_Lcom_papasofokli_buttons_ButtonsInitializer$__getLongAttribute__Lorg_scalajs_dom_HTMLButtonElement__T__s_Option($thiz, element, "enable-after");
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var $x_1 = $uJ(x0);
    var enableAfter$2_$_lo = $x_1.l;
    var enableAfter$2_$_hi = $x_1.h;
    element.disabled = true;
    var countdownSpan = element.querySelector("[data-enable-after-countdown]");
    var sign = (enableAfter$2_$_hi >> 31);
    var xlo = (enableAfter$2_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((enableAfter$2_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var quotHi = (((rhi >>> 0) / 1000) | 0);
    var k = ((rhi - Math.imul(1000, quotHi)) | 0);
    var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
    if ((enableAfter$2_$_hi < 0)) {
      var lo = ((-quotLo) | 0);
      var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
      var $x_2_$_lo = lo;
      var $x_2_$_hi = hi;
    } else {
      var $x_2_$_lo = quotLo;
      var $x_2_$_hi = quotHi;
    }
    var remaining = new $c_sr_IntRef($x_2_$_lo);
    countdownSpan.textContent = (remaining.f4 + "s");
    $m_sjs_js_timers_package$().gb(1000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_buttons_ButtonsInitializer$__updateCountdown$1__sr_IntRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLButtonElement__V($thiz, remaining, countdownSpan, element);
    })));
  }
}
function $p_Lcom_papasofokli_buttons_ButtonsInitializer$__updateCountdown$1__sr_IntRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLButtonElement__V($thiz, remaining$1, countdownSpan$1, element$7) {
  remaining$1.f4 = ((remaining$1.f4 - 1) | 0);
  if ((remaining$1.f4 > 0)) {
    countdownSpan$1.textContent = (remaining$1.f4 + "s");
    $m_sjs_js_timers_package$().gb(1000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_buttons_ButtonsInitializer$__updateCountdown$1__sr_IntRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLButtonElement__V($thiz, remaining$1, countdownSpan$1, element$7);
    })));
  } else {
    countdownSpan$1.textContent = "";
    element$7.disabled = false;
  }
}
/** @constructor */
function $c_Lcom_papasofokli_buttons_ButtonsInitializer$() {
}
$p = $c_Lcom_papasofokli_buttons_ButtonsInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_buttons_ButtonsInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_buttons_ButtonsInitializer$() {
}
$h_Lcom_papasofokli_buttons_ButtonsInitializer$.prototype = $p;
$p.auY = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".dc0d230d-4051-4ffa-93cc-2ae230c5568c"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    if ((!(!(x0 instanceof HTMLButtonElement)))) {
      $p_Lcom_papasofokli_buttons_ButtonsInitializer$__enableAfterInit__Lorg_scalajs_dom_HTMLButtonElement__V(this, x0);
      x0.onclick = ((x0, executionContext) => ((_$2$2) => {
        $p_Lcom_papasofokli_buttons_ButtonsInitializer$__onClick__Lorg_scalajs_dom_HTMLButtonElement__Z__s_concurrent_ExecutionContext__V(this, x0, true, executionContext);
      }))(x0, executionContext);
      x0.classList.remove("dc0d230d-4051-4ffa-93cc-2ae230c5568c");
    }
  }
  var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".d1230d-4011-4123a-9134c-2a2f30c55fhc"));
  var it$1 = this$5.l();
  while (it$1.f()) {
    var x0$1 = it$1.e();
    if ((!(!(x0$1 instanceof HTMLButtonElement)))) {
      $p_Lcom_papasofokli_buttons_ButtonsInitializer$__enableAfterInit__Lorg_scalajs_dom_HTMLButtonElement__V(this, x0$1);
      x0$1.onclick = ((x0$1, executionContext) => ((_$3$2) => {
        $p_Lcom_papasofokli_buttons_ButtonsInitializer$__onClick__Lorg_scalajs_dom_HTMLButtonElement__Z__s_concurrent_ExecutionContext__V(this, x0$1, false, executionContext);
      }))(x0$1, executionContext);
      x0$1.classList.remove("d1230d-4011-4123a-9134c-2a2f30c55fhc");
    }
  }
});
$p.av7 = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".a5c75bac-cf20-4cd3-b952-bda7e8af8877"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    if ((!(!(x0 instanceof HTMLElement)))) {
      x0.onclick = ((x0, executionContext) => ((_$4$2) => {
        var id = x0.id;
        var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
        return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(id).g(), "", executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
          freezePage.ep();
          return true;
        })), executionContext).hj(new $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2(freezePage), executionContext);
      }))(x0, executionContext);
      x0.classList.remove("a5c75bac-cf20-4cd3-b952-bda7e8af8877");
    }
  }
});
var $d_Lcom_papasofokli_buttons_ButtonsInitializer$ = new $TypeData().i($c_Lcom_papasofokli_buttons_ButtonsInitializer$, "com.papasofokli.buttons.ButtonsInitializer$", ({
  k0: 1
}));
var $n_Lcom_papasofokli_buttons_ButtonsInitializer$;
function $m_Lcom_papasofokli_buttons_ButtonsInitializer$() {
  if ((!$n_Lcom_papasofokli_buttons_ButtonsInitializer$)) {
    $n_Lcom_papasofokli_buttons_ButtonsInitializer$ = new $c_Lcom_papasofokli_buttons_ButtonsInitializer$();
  }
  return $n_Lcom_papasofokli_buttons_ButtonsInitializer$;
}
/** @constructor */
function $c_Lcom_papasofokli_buttons_CopyButtonInitializer$() {
}
$p = $c_Lcom_papasofokli_buttons_CopyButtonInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_buttons_CopyButtonInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_buttons_CopyButtonInitializer$() {
}
$h_Lcom_papasofokli_buttons_CopyButtonInitializer$.prototype = $p;
$p.b7 = (function(executionContext) {
  $m_Lcom_papasofokli_util_package$().fo("0dfc001a-2221-40d3-9ed8-40f167fb2217").each((function() {
    this.onclick = ((_$1$2) => {
      var target = this.getAttribute("clipboard-input-target");
      var notificationMessage = this.getAttribute("clipboard-notification-message");
      return (0, $m_Lcom_papasofokli_jquery_package$().I)((((target + " input, ") + target) + " textarea")).each((function() {
        console.log(this);
        var isDisabled = (!(!this.hasAttribute("disabled")));
        var isHidden = (!(!this.classList.contains("hidden")));
        if (isDisabled) {
          this.removeAttribute("disabled");
        }
        if (isHidden) {
          this.classList.remove("hidden");
        }
        this.setSelectionRange(0, 9999);
        this.select();
        document.execCommand("copy");
        if (isDisabled) {
          this.setAttribute("disabled", "true");
        }
        if (isHidden) {
          this.classList.add("hidden");
        }
        return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(notificationMessage).g(), "", executionContext);
      }));
    });
  }));
});
var $d_Lcom_papasofokli_buttons_CopyButtonInitializer$ = new $TypeData().i($c_Lcom_papasofokli_buttons_CopyButtonInitializer$, "com.papasofokli.buttons.CopyButtonInitializer$", ({
  k3: 1
}));
var $n_Lcom_papasofokli_buttons_CopyButtonInitializer$;
function $m_Lcom_papasofokli_buttons_CopyButtonInitializer$() {
  if ((!$n_Lcom_papasofokli_buttons_CopyButtonInitializer$)) {
    $n_Lcom_papasofokli_buttons_CopyButtonInitializer$ = new $c_Lcom_papasofokli_buttons_CopyButtonInitializer$();
  }
  return $n_Lcom_papasofokli_buttons_CopyButtonInitializer$;
}
function $p_Lcom_papasofokli_buttons_DropdownButtonJs$__boardItemBtnOnClick__T__J__T__T__s_concurrent_ExecutionContext__F1($thiz, buttonId, itemId_$_lo, itemId_$_hi, clickFunctionId, clickType, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => {
    var jq = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + buttonId));
    jq.attr("disabled", "true");
    return new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((freezePage) => (() => {
      var this$8 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(clickFunctionId);
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_agileboard_ItemClickRequest(itemId_$_lo, itemId_$_hi, clickType), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_agileboard_ItemClickRequest$().q());
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$8, id.g(), data, ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rslt$2) => $m_Lcom_papasofokli_util_DelayFuture$().jj(300, 0).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        jq.attr("disabled", false);
        return freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), ec);
      })), ec))), ec).hj(new $c_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1(freezePage, jq), ec);
    }))(new $c_Lcom_papasofokli_util_FreezePage(500, 0, ec))));
  }));
}
/** @constructor */
function $c_Lcom_papasofokli_buttons_DropdownButtonJs$() {
}
$p = $c_Lcom_papasofokli_buttons_DropdownButtonJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_buttons_DropdownButtonJs$;
/** @constructor */
function $h_Lcom_papasofokli_buttons_DropdownButtonJs$() {
}
$h_Lcom_papasofokli_buttons_DropdownButtonJs$.prototype = $p;
$p.auf = (function(items, ec) {
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("dropdown border-0", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("float-end text-black border-0 bg-transparent no-outline", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("button", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_GlobalAttrs__data__T__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "bs-toggle").n("dropdown", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().amT().atK().n("false", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("\u22ee"))])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("dropdown-menu p-0 m-0", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), items.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var label = x$1$2.CA;
      var buttonId = x$1$2.CB;
      var $x_1 = $uJ(x$1$2.CC);
      var recordId_$_lo = $x_1.l;
      var recordId_$_hi = $x_1.h;
      var clickFunctionId = x$1$2.CD;
      var clickType = x$1$2.CE;
      return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("dropdown-item border-0 padding-5 margin-0", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_buttons_DropdownButtonJs$__boardItemBtnOnClick__T__J__T__T__s_concurrent_ExecutionContext__F1(this, buttonId, recordId_$_lo, recordId_$_hi, clickFunctionId, clickType, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(label))]))]));
    }
    throw new $c_s_MatchError(x$1$2);
  }))), $m_s_$less$colon$less$().b0)]))]));
});
var $d_Lcom_papasofokli_buttons_DropdownButtonJs$ = new $TypeData().i($c_Lcom_papasofokli_buttons_DropdownButtonJs$, "com.papasofokli.buttons.DropdownButtonJs$", ({
  k4: 1
}));
var $n_Lcom_papasofokli_buttons_DropdownButtonJs$;
function $m_Lcom_papasofokli_buttons_DropdownButtonJs$() {
  if ((!$n_Lcom_papasofokli_buttons_DropdownButtonJs$)) {
    $n_Lcom_papasofokli_buttons_DropdownButtonJs$ = new $c_Lcom_papasofokli_buttons_DropdownButtonJs$();
  }
  return $n_Lcom_papasofokli_buttons_DropdownButtonJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_card_CardJs$() {
}
$p = $c_Lcom_papasofokli_card_CardJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_card_CardJs$;
/** @constructor */
function $h_Lcom_papasofokli_card_CardJs$() {
}
$h_Lcom_papasofokli_card_CardJs$.prototype = $p;
$p.axc = (function(content, cardElement) {
  var cardBodyElement = cardElement.querySelector(".card-body");
  var innerDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])).aB();
  innerDiv.innerHTML = content;
  cardBodyElement.replaceChildren(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerDiv).ky);
});
$p.IM = (function(executionContext) {
  return $m_Lcom_papasofokli_util_package$().fo("9a785307-7aa1-4b0d-8fc8-40499efb4d92").each(((this$1) => (function() {
    var getBodyFunId = this.getAttribute("data-get-body-function");
    var getBodyCompleteFunId = this.getAttribute("data-oncomplete-body-function");
    var contextMenuFunctionId = this.getAttribute("data-context-menu");
    var referenceRecordId = this.getAttribute("reference-record-id");
    return ((getBodyFunId !== null) ? $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getBodyFunId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      this$1.axc($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J), this);
      this.addEventListener("contextmenu", $m_sjs_js_Any$().b3($m_Lcom_papasofokli_util_CommonFunctionality$().agf(referenceRecordId, contextMenuFunctionId, executionContext)));
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(getBodyCompleteFunId).g(), "", executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
        $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
      })), executionContext);
    })), executionContext))), executionContext) : (void 0));
  }))(this));
});
var $d_Lcom_papasofokli_card_CardJs$ = new $TypeData().i($c_Lcom_papasofokli_card_CardJs$, "com.papasofokli.card.CardJs$", ({
  k6: 1
}));
var $n_Lcom_papasofokli_card_CardJs$;
function $m_Lcom_papasofokli_card_CardJs$() {
  if ((!$n_Lcom_papasofokli_card_CardJs$)) {
    $n_Lcom_papasofokli_card_CardJs$ = new $c_Lcom_papasofokli_card_CardJs$();
  }
  return $n_Lcom_papasofokli_card_CardJs$;
}
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetS = new $TypeData().i(1, "com.papasofokli.chartJSv2x.ChartDatasetS", ({
  cd: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartjs_Axes$() {
}
$p = $c_Lcom_papasofokli_chartjs_Axes$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_Axes$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_Axes$() {
}
$h_Lcom_papasofokli_chartjs_Axes$.prototype = $p;
$p.alM = (function() {
  return new ($a_Lcom_papasofokli_chartjs_GridLines())(true);
});
var $d_Lcom_papasofokli_chartjs_Axes$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_Axes$, "com.papasofokli.chartjs.Axes$", ({
  kn: 1
}));
var $n_Lcom_papasofokli_chartjs_Axes$;
function $m_Lcom_papasofokli_chartjs_Axes$() {
  if ((!$n_Lcom_papasofokli_chartjs_Axes$)) {
    $n_Lcom_papasofokli_chartjs_Axes$ = new $c_Lcom_papasofokli_chartjs_Axes$();
  }
  return $n_Lcom_papasofokli_chartjs_Axes$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_BarChartOptions$() {
}
$p = $c_Lcom_papasofokli_chartjs_BarChartOptions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_BarChartOptions$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_BarChartOptions$() {
}
$h_Lcom_papasofokli_chartjs_BarChartOptions$.prototype = $p;
$p.I7 = (function() {
  return new ($a_Lcom_papasofokli_chartjs_Animation())();
});
var $d_Lcom_papasofokli_chartjs_BarChartOptions$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_BarChartOptions$, "com.papasofokli.chartjs.BarChartOptions$", ({
  ko: 1
}));
var $n_Lcom_papasofokli_chartjs_BarChartOptions$;
function $m_Lcom_papasofokli_chartjs_BarChartOptions$() {
  if ((!$n_Lcom_papasofokli_chartjs_BarChartOptions$)) {
    $n_Lcom_papasofokli_chartjs_BarChartOptions$ = new $c_Lcom_papasofokli_chartjs_BarChartOptions$();
  }
  return $n_Lcom_papasofokli_chartjs_BarChartOptions$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_ChartJS$() {
}
$p = $c_Lcom_papasofokli_chartjs_ChartJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_ChartJS$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_ChartJS$() {
}
$h_Lcom_papasofokli_chartjs_ChartJS$.prototype = $p;
$p.amF = (function(ctx, chartConfiguration, canvasId) {
  var chartType = chartConfiguration.gi;
  var chartTimePeriod = chartConfiguration.gP;
  var data = chartConfiguration.hm;
  var options;
  switch (chartType) {
    case "doughnut": {
      var options = $m_Lcom_papasofokli_chartjs_DefaultChartOptions$().awU(canvasId, data);
      break;
    }
    case "radar": {
      var options = $m_Lcom_papasofokli_chartjs_DefaultChartOptions$().ax1(((data.ho.length | 0) > 1), canvasId, data);
      break;
    }
    case "bar": {
      var indexAxis = (chartConfiguration.gj ? "y" : "x");
      var options = $m_Lcom_papasofokli_chartjs_DefaultChartOptions$().amW(((data.ho.length | 0) !== 1), canvasId, chartConfiguration.gT, data, indexAxis, ((chartConfiguration.gj && (!chartConfiguration.fT.c())) ? new $c_s_Some((chartConfiguration.fT.h() + "px")) : $m_s_None$()));
      break;
    }
    case "scatter": {
      var options = $m_Lcom_papasofokli_chartjs_DefaultChartOptions$().axK(chartTimePeriod, canvasId, data);
      break;
    }
    default: {
      var options = (void 0);
    }
  }
  var config = new ($a_Lcom_papasofokli_chartjs_ChartConfig())(chartType, data, options);
  return new ($a_Lcom_papasofokli_chartjs_ChartJSZoom())(ctx, config);
});
var $d_Lcom_papasofokli_chartjs_ChartJS$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_ChartJS$, "com.papasofokli.chartjs.ChartJS$", ({
  kp: 1
}));
var $n_Lcom_papasofokli_chartjs_ChartJS$;
function $m_Lcom_papasofokli_chartjs_ChartJS$() {
  if ((!$n_Lcom_papasofokli_chartjs_ChartJS$)) {
    $n_Lcom_papasofokli_chartjs_ChartJS$ = new $c_Lcom_papasofokli_chartjs_ChartJS$();
  }
  return $n_Lcom_papasofokli_chartjs_ChartJS$;
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortDatasetLabels__sci_Seq__sci_Seq($thiz, datasets) {
  return datasets.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d$2) => {
    matchResult2: {
      var $x_1;
      if ((d$2 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS)) {
        var this$2 = $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortLabels__sci_Seq__I__sci_Seq($thiz, new $c_sci_$colon$colon(d$2.Ek(), $m_sci_Nil$()), 20).bj();
        var shortLabel$1 = (this$2.c() ? d$2.Ek() : this$2.h());
        var $x_1 = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS(d$2.l6, shortLabel$1, d$2.mW, d$2.mX, d$2.jL, d$2.iC, d$2.iB, d$2.jK);
        break matchResult2;
      }
      if ((d$2 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS)) {
        var this$3 = $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortLabels__sci_Seq__I__sci_Seq($thiz, new $c_sci_$colon$colon(d$2.Ek(), $m_sci_Nil$()), 20).bj();
        var shortLabel$2 = (this$3.c() ? d$2.Ek() : this$3.h());
        var $x_1 = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS(d$2.jN, shortLabel$2, d$2.l7, d$2.l9, d$2.hX, d$2.hW, d$2.hU, d$2.l8, d$2.hV, d$2.iD, d$2.hT);
        break matchResult2;
      }
      throw new $c_s_MatchError(d$2);
    }
    return $x_1;
  })));
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortLabels__sci_Seq__I__sci_Seq($thiz, labels, lengthSize) {
  return labels.bc().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var l = x$1$2.P();
      (x$1$2.V() | 0);
      return $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__wordToShow$1__I__sci_Seq__T__I__T($thiz, lengthSize, $m_sc_ArrayOps$().NC($f_T__split__T__I__AT(l, " ", 0)), "", 0);
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__fitToContainer__Lorg_scalajs_dom_HTMLCanvasElement__I__s_Option__V($thiz, canvas, maxHeight, customWidth) {
  canvas.style.width = "100%";
  canvas.style.height = "100%";
  canvas.width = ((customWidth.c() ? $doubleToInt((+canvas.offsetWidth)) : customWidth.h()) | 0);
  if ((!customWidth.c())) {
    var $x_1 = maxHeight;
  } else {
    var this$2 = new $c_sci_$colon$colon((canvas.width | 0), new $c_sci_$colon$colon(maxHeight, $m_sci_Nil$()));
    var f = ((_$2$3) => ((_$2$3 | 0) > 0));
    _return: {
      var $x_2;
      var l$tailLocal1 = this$2;
      while (true) {
        if (l$tailLocal1.c()) {
          var $x_2 = $m_sci_Nil$();
          break;
        } else {
          var h = l$tailLocal1.W();
          var t = l$tailLocal1.ak();
          if ((!(!(!f(h))))) {
            l$tailLocal1 = t;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t;
          while (true) {
            if (remaining$tailLocal1.c()) {
              var $x_2 = start;
              break _return;
            } else {
              var x = remaining$tailLocal1.W();
              if ((!(!f(x)))) {
                remaining$tailLocal1 = remaining$tailLocal1.ak();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
              var toProcess = start.ak();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
                currentLast.bz = newElem;
                currentLast = newElem;
                toProcess = toProcess.ak();
              }
              var next = firstMiss.ak();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.W();
                if ((!(!f(head)))) {
                  next = next.ak();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                    currentLast.bz = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.ak();
                  }
                  nextToCopy = next.ak();
                  next = next.ak();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.bz = nextToCopy;
              }
              var $x_2 = newHead;
              break _return;
            }
          }
        }
      }
    }
    var $x_1 = ($f_sc_IterableOnceOps__min__s_math_Ordering__O($x_2, $m_s_math_Ordering$Int$()) | 0);
  }
  canvas.height = $x_1;
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__withJSArray__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartJSv2x_ChartConfigurationS($thiz, chartConfig) {
  var data = chartConfig.hm;
  var array = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(data.ho);
  var len = (array.length | 0);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $x_2 = i;
    var x0 = array[i];
    matchResult4: {
      var $x_1;
      if ((x0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS)) {
        var backgroundColor$3 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.Ml());
        var hoverBackgroundColor$3 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.UE());
        var data$3 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.jL);
        var compactData$3 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.TY());
        var borderColor$3 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.Ml());
        var $x_1 = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS(x0.l6, x0.jM, backgroundColor$3, hoverBackgroundColor$3, data$3, x0.iC, compactData$3, borderColor$3);
        break matchResult4;
      }
      if ((x0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS)) {
        var backgroundColor$4 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.Ml());
        var hoverBackgroundColor$4 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.UE());
        var borderColor$4 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.l8);
        var data$4 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.iD);
        var compactData$4 = $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(x0.TY());
        var $x_1 = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS(x0.jN, x0.iE, backgroundColor$4, hoverBackgroundColor$4, x0.hX, x0.hW, x0.hU, borderColor$4, x0.hV, data$4, compactData$4);
        break matchResult4;
      }
      throw new $c_s_MatchError(x0);
    }
    res[$x_2] = $x_1;
    i = ((1 + i) | 0);
  }
  var data$5 = new $c_Lcom_papasofokli_chartJSv2x_ChartDataS($m_sjs_js_JSConverters$JSRichIterableOnce$().hP(data.l5), res, $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(data.hp), $m_sjs_js_JSConverters$JSRichIterableOnce$().hP(data.jJ));
  return new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS(chartConfig.gi, chartConfig.hn, chartConfig.gR, chartConfig.gP, chartConfig.gQ, data$5, chartConfig.gS, chartConfig.gT, chartConfig.gj, chartConfig.fT);
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__chartClickFunction__T__Lcom_papasofokli_chartjs_ChartJSZoom__T__Z__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, id, chart, chartType, pointAndLegendResponse, executionContext) {
  var queryElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  var clickFunctionId = queryElement.attr("data-onclickid");
  return queryElement.click($m_sjs_js_Any$().b3(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((evt$2) => {
    if ((clickFunctionId !== (void 0))) {
      if ((clickFunctionId === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      var $x_1 = (clickFunctionId !== "");
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var activePoints = chart.getElementsAtEventForMode2(evt$2, "nearest", ({
        "intersect": true
      }), false);
      var firstPoint = activePoints[0];
      if (pointAndLegendResponse) {
        if ((firstPoint === (void 0))) {
          var labelStr = (void 0);
        } else {
          var $x_3 = chart.data.datasets;
          var x = firstPoint.datasetIndex;
          var $x_2 = $x_3[(((x === (void 0)) ? 0 : x) | 0)];
          var x$1 = $x_2.label;
          var labelStr = ((x$1 === (void 0)) ? "No label" : x$1);
        }
        var label = (($dp_toString__T(((firstPoint === (void 0)) ? (void 0) : chart.data.notes[(firstPoint.index | 0)])) + " , ") + $dp_toString__T(labelStr));
      } else if ((chartType === "scatter")) {
        if ((firstPoint === (void 0))) {
          var label = (void 0);
        } else {
          var $x_5 = chart.data.datasets;
          var x$2 = firstPoint.datasetIndex;
          var $x_4 = $x_5[(((x$2 === (void 0)) ? 0 : x$2) | 0)];
          var x$3 = $x_4.label;
          var label = ((x$3 === (void 0)) ? "No label" : x$3);
        }
      } else {
        var label = ((firstPoint === (void 0)) ? (void 0) : chart.data.notes[(firstPoint.index | 0)]);
      }
      if ((!$m_sr_BoxesRunTime$().B(label, "No data in the chart"))) {
        $thiz.TL(clickFunctionId, label, executionContext);
      }
    }
    return true;
  }))));
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__createCustomLegends__T__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartjs_ChartJSZoom__s_concurrent_ExecutionContext__V($thiz, id, configuration, chart, ec) {
  if ((((configuration.gi === "doughnut") || (configuration.gi === "radar")) || (configuration.gi === "scatter"))) {
    var legendDiv = document.getElementById((id + "-legend"));
    var legend = $m_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$().avZ(id, configuration.gi, chart, ec);
    legendDiv.appendChild(legend);
  }
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__fun$1__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element__V($thiz, executionContext$1, element) {
  matchResult1: {
    var canvas;
    if ((!(!(element instanceof HTMLCanvasElement)))) {
      var canvas = element;
      break matchResult1;
    }
    throw new $c_s_MatchError(element);
  }
  var ctx = canvas.getContext("2d");
  var canvasId = canvas.id;
  $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(canvasId, "", executionContext$1).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    var configurationWithSeq = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$().auB());
    $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__fitToContainer__Lorg_scalajs_dom_HTMLCanvasElement__I__s_Option__V($thiz, canvas, configurationWithSeq.gQ, configurationWithSeq.fT);
    var chartType = configurationWithSeq.gi;
    var configuration = (((chartType === "radar") && (configurationWithSeq.hm.l5.F() < 3)) ? $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__withJSArray__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartJSv2x_ChartConfigurationS($m_Lcom_papasofokli_chartjs_ChartJSInitializer$(), new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS("bar", configurationWithSeq.hn, configurationWithSeq.gR, configurationWithSeq.gP, configurationWithSeq.gQ, configurationWithSeq.hm, configurationWithSeq.gS, configurationWithSeq.gT, configurationWithSeq.gj, configurationWithSeq.fT)) : $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__withJSArray__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartJSv2x_ChartConfigurationS($m_Lcom_papasofokli_chartjs_ChartJSInitializer$(), configurationWithSeq));
    var initialLabels = configurationWithSeq.hm.l5;
    var shortLabels = (configurationWithSeq.gS ? $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortLabels__sci_Seq__I__sci_Seq($thiz, initialLabels, 5) : initialLabels);
    var legends = $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortLabels__sci_Seq__I__sci_Seq($thiz, initialLabels, 20);
    var dataSetsWithShortLabels = $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__generateShortDatasetLabels__sci_Seq__sci_Seq($thiz, configurationWithSeq.hm.ho);
    var configurationData = new $c_Lcom_papasofokli_chartJSv2x_ChartDataS(shortLabels, dataSetsWithShortLabels, initialLabels, legends);
    var finalConfiguration = $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__withJSArray__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartJSv2x_ChartConfigurationS($m_Lcom_papasofokli_chartjs_ChartJSInitializer$(), new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS(configuration.gi, configuration.hn, configuration.gR, configuration.gP, configuration.gQ, configurationData, configuration.gS, configuration.gT, configuration.gj, configuration.fT));
    var chart = $m_Lcom_papasofokli_chartjs_ChartJS$().amF(ctx, finalConfiguration, canvasId);
    chart.draw();
    $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__chartClickFunction__T__Lcom_papasofokli_chartjs_ChartJSZoom__T__Z__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($m_Lcom_papasofokli_chartjs_ChartJSInitializer$(), canvasId, chart, chartType, configurationWithSeq.gR, executionContext$1);
    $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__createCustomLegends__T__Lcom_papasofokli_chartJSv2x_ChartConfigurationS__Lcom_papasofokli_chartjs_ChartJSZoom__s_concurrent_ExecutionContext__V($m_Lcom_papasofokli_chartjs_ChartJSInitializer$(), canvasId, finalConfiguration, chart, executionContext$1);
    return chart;
  })), executionContext$1))), executionContext$1);
}
function $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__wordToShow$1__I__sci_Seq__T__I__T($thiz, lengthSize$1, wordSeq, acc, characters) {
  var characters$tailLocal1 = characters;
  var acc$tailLocal1 = acc;
  var wordSeq$tailLocal1 = wordSeq;
  while (true) {
    if (wordSeq$tailLocal1.c()) {
      return ("" + acc$tailLocal1);
    } else if ((characters$tailLocal1 >= lengthSize$1)) {
      return (acc$tailLocal1 + " ...");
    } else {
      var wordSeq$tailLocal1$tmp1 = wordSeq$tailLocal1.bo(1);
      $m_sc_StringOps$();
      var x = acc$tailLocal1;
      var this$2 = wordSeq$tailLocal1.bj();
      var xs = (" " + (this$2.c() ? "" : this$2.h()));
      var acc$tailLocal1$tmp1 = (x + xs);
      var $x_1 = characters$tailLocal1;
      var this$4 = wordSeq$tailLocal1.bj();
      var this$6 = (this$4.c() ? $m_s_None$() : new $c_s_Some(((1 + $f_T__toCharArray__AC(this$4.h()).a.length) | 0)));
      var characters$tailLocal1$tmp1 = (($x_1 + ((this$6.c() ? 0 : this$6.h()) | 0)) | 0);
      wordSeq$tailLocal1 = wordSeq$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      characters$tailLocal1 = characters$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_ChartJSInitializer$() {
  this.akB = null;
  this.akB = "not-initialized-chartJS";
}
$p = $c_Lcom_papasofokli_chartjs_ChartJSInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_ChartJSInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_ChartJSInitializer$() {
}
$h_Lcom_papasofokli_chartjs_ChartJSInitializer$.prototype = $p;
$p.av0 = (function(executionContext) {
  $m_Lcom_papasofokli_util_package$().Eg("not-initialized-chartJS", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element$3) => {
    $p_Lcom_papasofokli_chartjs_ChartJSInitializer$__fun$1__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element__V(this, executionContext, element$3);
  })));
});
$p.TL = (function(functionId, label, executionContext) {
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
  var $x_1 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  if ((functionId === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
  }
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($x_1, $m_ju_UUID$().aO(functionId).g(), label, executionContext).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => freezePage.ep())), executionContext);
});
var $d_Lcom_papasofokli_chartjs_ChartJSInitializer$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_ChartJSInitializer$, "com.papasofokli.chartjs.ChartJSInitializer$", ({
  kq: 1
}));
var $n_Lcom_papasofokli_chartjs_ChartJSInitializer$;
function $m_Lcom_papasofokli_chartjs_ChartJSInitializer$() {
  if ((!$n_Lcom_papasofokli_chartjs_ChartJSInitializer$)) {
    $n_Lcom_papasofokli_chartjs_ChartJSInitializer$ = new $c_Lcom_papasofokli_chartjs_ChartJSInitializer$();
  }
  return $n_Lcom_papasofokli_chartjs_ChartJSInitializer$;
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOver__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, datasetIndex, legendIndex, chart) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    var sector = [chart.getDatasetMeta(datasetIndex).data[legendIndex]];
    chart.updateHoverStyle(sector, null, true);
    chart.tooltip._active = sector;
  }));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOut__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, datasetIndex, legendIndex, chart) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    var sector = [chart.getDatasetMeta(datasetIndex).data[legendIndex]];
    chart.updateHoverStyle(sector, null, false);
    chart.tooltip._active = [];
  }));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendOnClick__I__Lcom_papasofokli_chartjs_ChartJS__T__s_concurrent_ExecutionContext__F1($thiz, legendIndex, chart, canvasId, executionContext) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$3) => {
    var clickFunctionId = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + canvasId)).attr("data-onclickid");
    if ((clickFunctionId !== (void 0))) {
      $m_sc_StringOps$();
      if ((clickFunctionId === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      var $x_1 = (clickFunctionId !== "");
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      if ((event$3.currentTarget.lastElementChild.textContent !== "No data in the chart")) {
        $m_Lcom_papasofokli_chartjs_ChartJSInitializer$().TL(clickFunctionId, chart.data.notes[legendIndex], executionContext);
      }
    }
  }));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__scatterLegendOnClick__I__Lcom_papasofokli_chartjs_ChartJS__T__s_concurrent_ExecutionContext__F1($thiz, legendIndex, chart, canvasId, executionContext) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
    var clickFunctionId = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + canvasId)).attr("data-onclickid");
    if ((clickFunctionId !== (void 0))) {
      $m_sc_StringOps$();
      if ((clickFunctionId === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      var $x_1 = (clickFunctionId !== "");
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $m_Lcom_papasofokli_chartjs_ChartJSInitializer$().TL(clickFunctionId, chart.data.datasets[legendIndex].label, executionContext);
    }
  }));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createLegendData__I__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, datasetIndex, canvasId, chart, executionContext) {
  var tooltip = chart.tooltip;
  tooltip.callbacks = new ($a_Lcom_papasofokli_chartjs_TooltipCallbacks())(((_$4$2, _$5$2) => $m_Lcom_papasofokli_chartjs_Tooltip$().ayF(_$4$2, _$5$2)), ((items$2, data$2) => (((items$2.length | 0) !== 0) ? data$2.hp[(items$2[0].index | 0)] : "")));
  var array = chart.data.datasets[datasetIndex].compactData;
  var showCompactData = ((array.length | 0) !== 0);
  var end = (chart.getDatasetMeta(datasetIndex).data.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((end <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, end, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    var value = (showCompactData ? chart.data.datasets[datasetIndex].compactData[x0] : $dp_toString__T(chart.getDatasetMeta(datasetIndex).controller._data[x0]));
    var color = chart.getDatasetMeta(datasetIndex).data[x0].options.backgroundColor;
    var valueText = (($f_T__trim__T(chart.data.legends[x0]) === "No data in the chart") ? "---" : value);
    var textDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("dynamic-text-color", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(valueText))])).aB();
    var \u03b42$ = textDiv.style;
    \u03b42$.setProperty("--custom-text-color", color);
    b.aD($m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), textDiv)])), $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(chart.data.legends[x0]))])), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendOnClick__I__Lcom_papasofokli_chartjs_ChartJS__T__s_concurrent_ExecutionContext__F1($thiz, x0, chart, canvasId, executionContext), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().aj7().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOver__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, datasetIndex, x0, chart), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1)))))), $m_Lscalatags_JsDom$all$().aj6().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOut__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, datasetIndex, x0, chart), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$2) => $m_sjs_js_Any$().b3(f$2$2))))))])));
  }
  var seqLi = b.aR();
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("chart-legend", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), seqLi, $m_s_$less$colon$less$().b0)]));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createScatterLegendData__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, canvasId, chart, executionContext) {
  var end = (chart.data.datasets.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((end <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, end, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    var color = chart.getDatasetMeta(x0).dataset.options.borderColor;
    var x = chart.data.datasets[x0].shortLabel;
    var datasetLabel = ((x === (void 0)) ? "No label" : x);
    var boxIcon = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().a8L.by + " dynamic-text-color"), $m_Lscalatags_JsDom$all$().s)])).aB();
    var \u03b44$ = boxIcon.style;
    \u03b44$.setProperty("--custom-text-color", color);
    var label = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(datasetLabel))]));
    b.aD($m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), boxIcon), label, $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__scatterLegendOnClick__I__Lcom_papasofokli_chartjs_ChartJS__T__s_concurrent_ExecutionContext__F1($thiz, x0, chart, canvasId, executionContext), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().aj7().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOver__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, x0, x0, chart), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1)))))), $m_Lscalatags_JsDom$all$().aj6().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendMouseOut__I__I__Lcom_papasofokli_chartjs_ChartJS__F1($thiz, x0, x0, chart), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$2) => $m_sjs_js_Any$().b3(f$2$2))))))])));
  }
  var seqLi = b.aR();
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("chart-legend chart-legend-square", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), seqLi, $m_s_$less$colon$less$().b0)]));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendId__T($thiz) {
  if ((!$thiz.WO)) {
    $thiz.WN = $m_ju_UUID$().aW().g();
    $thiz.WO = true;
  }
  return $thiz.WN;
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendDiv__Lscalatags_generic_TypedTag__Lscalatags_JsDom$TypedTag($thiz, tag) {
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-md-12", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendId__T($thiz), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [tag]));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__loadDatasetLegends__I__Lcom_papasofokli_chartjs_ChartJS__T__T__T__s_concurrent_ExecutionContext__F1($thiz, datasetIndex, chart, canvasId, chartTabId, tabId, executionContext) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
    var legendHtml = $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createLegendData__I__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, datasetIndex, canvasId, chart, executionContext).aB();
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendId__T($thiz))).empty();
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendId__T($thiz))).append(legendHtml);
    $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__removeActiveClassFromActiveTab__T__Lcom_papasofokli_jquery_JQuery($thiz, chartTabId);
    return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + tabId)).addClass("chart-tab-active");
  }));
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__removeActiveClassFromActiveTab__T__Lcom_papasofokli_jquery_JQuery($thiz, chartTabId) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + chartTabId) + " >li.chart-tab-active")).removeClass("chart-tab-active");
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createAllDataSetTabs__I__Lcom_papasofokli_chartjs_ChartJS__T__T__s_concurrent_ExecutionContext__sci_IndexedSeq($thiz, datasetSize, chart, chartTabId, canvasId, executionContext) {
  var isEmpty = (datasetSize <= 0);
  var scala$collection$immutable$Range$$lastElement = ((datasetSize - 1) | 0);
  if (((datasetSize <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, datasetSize, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    var datasetMeta = chart.getDatasetMeta(x0);
    var $x_1 = datasetMeta.data[0].options.backgroundColor;
    var x = chart.data.datasets[x0].label;
    b.aD($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__makeTabLiComp__I__Lcom_papasofokli_chartjs_ChartJS__T__T__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLAnchorElement($thiz, x0, chart, $x_1, ((x === (void 0)) ? "No label" : x), canvasId, chartTabId, executionContext));
  }
  return b.aR();
}
function $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__makeTabLiComp__I__Lcom_papasofokli_chartjs_ChartJS__T__T__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLAnchorElement($thiz, index, chart, color, datasetLabel, canvasId, chartTabId, executionContext) {
  var tabId = $m_ju_UUID$().aW().g();
  var initialActiveClass = ((index === 0) ? "chart-tab-active" : "");
  var link = $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__loadDatasetLegends__I__Lcom_papasofokli_chartjs_ChartJS__T__T__T__s_concurrent_ExecutionContext__F1($thiz, index, chart, canvasId, chartTabId, tabId, executionContext), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(datasetLabel))])).aB();
  $m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((initialActiveClass + " fw-bold  dynamic-text-color"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(tabId, $m_Lscalatags_JsDom$all$().s)]));
  var \u03b45$ = link.style;
  \u03b45$.setProperty("--custom-text-color", color);
  return link;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$() {
  this.WN = null;
  this.WO = false;
}
$p = $c_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$() {
}
$h_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$.prototype = $p;
$p.avZ = (function(canvasId, chartType, chart, executionContext) {
  var datasetSize = (chart.data.datasets.length | 0);
  var ulId = $m_ju_UUID$().aW().g();
  if ((chartType === "scatter")) {
    return $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createScatterLegendData__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag(this, canvasId, chart, executionContext).aB();
  } else if ((datasetSize > 1)) {
    var tabsLi = $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createAllDataSetTabs__I__Lcom_papasofokli_chartjs_ChartJS__T__T__s_concurrent_ExecutionContext__sci_IndexedSeq(this, datasetSize, chart, ulId, canvasId, executionContext);
    var tabsUl = $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("nav nav-pills", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(ulId, $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), tabsLi, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))]));
    return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [tabsUl, $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__legendDiv__Lscalatags_generic_TypedTag__Lscalatags_JsDom$TypedTag(this, $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createLegendData__I__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag(this, 0, canvasId, chart, executionContext))])).aB();
  } else {
    return $p_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$__createLegendData__I__T__Lcom_papasofokli_chartjs_ChartJS__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag(this, 0, canvasId, chart, executionContext).aB();
  }
});
var $d_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$, "com.papasofokli.chartjs.ChartJsCustomLegendHelper$", ({
  kr: 1
}));
var $n_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$;
function $m_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$() {
  if ((!$n_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$)) {
    $n_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$ = new $c_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$();
  }
  return $n_Lcom_papasofokli_chartjs_ChartJsCustomLegendHelper$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_ChartOptions$() {
}
$p = $c_Lcom_papasofokli_chartjs_ChartOptions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_ChartOptions$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_ChartOptions$() {
}
$h_Lcom_papasofokli_chartjs_ChartOptions$.prototype = $p;
$p.Ts = (function() {
  return new ($a_Lcom_papasofokli_chartjs_Animation())();
});
var $d_Lcom_papasofokli_chartjs_ChartOptions$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_ChartOptions$, "com.papasofokli.chartjs.ChartOptions$", ({
  ks: 1
}));
var $n_Lcom_papasofokli_chartjs_ChartOptions$;
function $m_Lcom_papasofokli_chartjs_ChartOptions$() {
  if ((!$n_Lcom_papasofokli_chartjs_ChartOptions$)) {
    $n_Lcom_papasofokli_chartjs_ChartOptions$ = new $c_Lcom_papasofokli_chartjs_ChartOptions$();
  }
  return $n_Lcom_papasofokli_chartjs_ChartOptions$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_DefaultChartOptions$() {
}
$p = $c_Lcom_papasofokli_chartjs_DefaultChartOptions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_DefaultChartOptions$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_DefaultChartOptions$() {
}
$h_Lcom_papasofokli_chartjs_DefaultChartOptions$.prototype = $p;
$p.awU = (function(canvasId, data) {
  var plugins = $m_Lcom_papasofokli_chartjs_Plugins$().Mf($m_Lcom_papasofokli_chartjs_Legend$().Mh("right", false), $m_Lcom_papasofokli_chartjs_TooltipObject$().Me(data));
  return new ($a_Lcom_papasofokli_chartjs_PieChartOption())(plugins, (void 0), canvasId);
});
$p.ax1 = (function(showLegend, canvasId, data) {
  var plugins = $m_Lcom_papasofokli_chartjs_Plugins$().Mf($m_Lcom_papasofokli_chartjs_Legend$().Mh("top", showLegend), $m_Lcom_papasofokli_chartjs_TooltipObject$().Me(data));
  var scale$1 = new ($a_Lcom_papasofokli_chartjs_RadarScale())();
  return new ($a_Lcom_papasofokli_chartjs_RadarChartOptions())(plugins, scale$1, (void 0), canvasId);
});
$p.amW = (function(showLegend, canvasId, stacked, data, indexAxis, width) {
  var plugins = $m_Lcom_papasofokli_chartjs_Plugins$().Mf($m_Lcom_papasofokli_chartjs_Legend$().Mh("top", showLegend), $m_Lcom_papasofokli_chartjs_TooltipObject$().Me(data));
  var grid$1 = new ($a_Lcom_papasofokli_chartjs_GridLines())(false);
  var scales = new ($a_Lcom_papasofokli_chartjs_Scales())(new ($a_Lcom_papasofokli_chartjs_Axes())((void 0), stacked, grid$1), new ($a_Lcom_papasofokli_chartjs_Axes())((void 0), stacked));
  return new ($a_Lcom_papasofokli_chartjs_BarChartOptions())(plugins, scales, (void 0), canvasId, indexAxis, width);
});
$p.axK = (function(timeUnit, canvasId, data) {
  var plugins = $m_Lcom_papasofokli_chartjs_Plugins$().Mf($m_Lcom_papasofokli_chartjs_Legend$().Mh("right", false), $m_Lcom_papasofokli_chartjs_TooltipObject$().Me(data));
  var $x_1 = new ($a_Lcom_papasofokli_chartjs_ScatterXAxes())("time", new ($a_Lcom_papasofokli_chartjs_Time())(timeUnit));
  var grid$2 = new ($a_Lcom_papasofokli_chartjs_GridLines())(true);
  var scales$1 = new ($a_Lcom_papasofokli_chartjs_ScatterScale())($x_1, new ($a_Lcom_papasofokli_chartjs_Axes())(0, (void 0), grid$2));
  return new ($a_Lcom_papasofokli_chartjs_ScatterChartOption())(plugins, scales$1, (void 0), canvasId);
});
var $d_Lcom_papasofokli_chartjs_DefaultChartOptions$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_DefaultChartOptions$, "com.papasofokli.chartjs.DefaultChartOptions$", ({
  kt: 1
}));
var $n_Lcom_papasofokli_chartjs_DefaultChartOptions$;
function $m_Lcom_papasofokli_chartjs_DefaultChartOptions$() {
  if ((!$n_Lcom_papasofokli_chartjs_DefaultChartOptions$)) {
    $n_Lcom_papasofokli_chartjs_DefaultChartOptions$ = new $c_Lcom_papasofokli_chartjs_DefaultChartOptions$();
  }
  return $n_Lcom_papasofokli_chartjs_DefaultChartOptions$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_EventDataXY$() {
}
$p = $c_Lcom_papasofokli_chartjs_EventDataXY$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_EventDataXY$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_EventDataXY$() {
}
$h_Lcom_papasofokli_chartjs_EventDataXY$.prototype = $p;
$p.amz = (function(x, y) {
  return ({
    "x": x,
    "y": y
  });
});
var $d_Lcom_papasofokli_chartjs_EventDataXY$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_EventDataXY$, "com.papasofokli.chartjs.EventDataXY$", ({
  ku: 1
}));
var $n_Lcom_papasofokli_chartjs_EventDataXY$;
function $m_Lcom_papasofokli_chartjs_EventDataXY$() {
  if ((!$n_Lcom_papasofokli_chartjs_EventDataXY$)) {
    $n_Lcom_papasofokli_chartjs_EventDataXY$ = new $c_Lcom_papasofokli_chartjs_EventDataXY$();
  }
  return $n_Lcom_papasofokli_chartjs_EventDataXY$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_Legend$() {
}
$p = $c_Lcom_papasofokli_chartjs_Legend$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_Legend$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_Legend$() {
}
$h_Lcom_papasofokli_chartjs_Legend$.prototype = $p;
$p.Mh = (function(position, display) {
  return ({
    "position": position,
    "display": display
  });
});
var $d_Lcom_papasofokli_chartjs_Legend$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_Legend$, "com.papasofokli.chartjs.Legend$", ({
  kv: 1
}));
var $n_Lcom_papasofokli_chartjs_Legend$;
function $m_Lcom_papasofokli_chartjs_Legend$() {
  if ((!$n_Lcom_papasofokli_chartjs_Legend$)) {
    $n_Lcom_papasofokli_chartjs_Legend$ = new $c_Lcom_papasofokli_chartjs_Legend$();
  }
  return $n_Lcom_papasofokli_chartjs_Legend$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_MouseEventData$() {
}
$p = $c_Lcom_papasofokli_chartjs_MouseEventData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_MouseEventData$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_MouseEventData$() {
}
$h_Lcom_papasofokli_chartjs_MouseEventData$.prototype = $p;
$p.amy = (function(x, y, native) {
  return ({
    "x": x,
    "y": y,
    "native": native
  });
});
var $d_Lcom_papasofokli_chartjs_MouseEventData$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_MouseEventData$, "com.papasofokli.chartjs.MouseEventData$", ({
  kw: 1
}));
var $n_Lcom_papasofokli_chartjs_MouseEventData$;
function $m_Lcom_papasofokli_chartjs_MouseEventData$() {
  if ((!$n_Lcom_papasofokli_chartjs_MouseEventData$)) {
    $n_Lcom_papasofokli_chartjs_MouseEventData$ = new $c_Lcom_papasofokli_chartjs_MouseEventData$();
  }
  return $n_Lcom_papasofokli_chartjs_MouseEventData$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_PieChartOption$() {
}
$p = $c_Lcom_papasofokli_chartjs_PieChartOption$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_PieChartOption$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_PieChartOption$() {
}
$h_Lcom_papasofokli_chartjs_PieChartOption$.prototype = $p;
$p.Ts = (function() {
  return new ($a_Lcom_papasofokli_chartjs_Animation())();
});
var $d_Lcom_papasofokli_chartjs_PieChartOption$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_PieChartOption$, "com.papasofokli.chartjs.PieChartOption$", ({
  kx: 1
}));
var $n_Lcom_papasofokli_chartjs_PieChartOption$;
function $m_Lcom_papasofokli_chartjs_PieChartOption$() {
  if ((!$n_Lcom_papasofokli_chartjs_PieChartOption$)) {
    $n_Lcom_papasofokli_chartjs_PieChartOption$ = new $c_Lcom_papasofokli_chartjs_PieChartOption$();
  }
  return $n_Lcom_papasofokli_chartjs_PieChartOption$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_Plugins$() {
}
$p = $c_Lcom_papasofokli_chartjs_Plugins$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_Plugins$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_Plugins$() {
}
$h_Lcom_papasofokli_chartjs_Plugins$.prototype = $p;
$p.Mf = (function(legend, tooltip) {
  return ({
    "legend": legend,
    "tooltip": tooltip
  });
});
var $d_Lcom_papasofokli_chartjs_Plugins$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_Plugins$, "com.papasofokli.chartjs.Plugins$", ({
  ky: 1
}));
var $n_Lcom_papasofokli_chartjs_Plugins$;
function $m_Lcom_papasofokli_chartjs_Plugins$() {
  if ((!$n_Lcom_papasofokli_chartjs_Plugins$)) {
    $n_Lcom_papasofokli_chartjs_Plugins$ = new $c_Lcom_papasofokli_chartjs_Plugins$();
  }
  return $n_Lcom_papasofokli_chartjs_Plugins$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_RadarChartOptions$() {
}
$p = $c_Lcom_papasofokli_chartjs_RadarChartOptions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_RadarChartOptions$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_RadarChartOptions$() {
}
$h_Lcom_papasofokli_chartjs_RadarChartOptions$.prototype = $p;
$p.I7 = (function() {
  return new ($a_Lcom_papasofokli_chartjs_Animation())();
});
var $d_Lcom_papasofokli_chartjs_RadarChartOptions$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_RadarChartOptions$, "com.papasofokli.chartjs.RadarChartOptions$", ({
  kz: 1
}));
var $n_Lcom_papasofokli_chartjs_RadarChartOptions$;
function $m_Lcom_papasofokli_chartjs_RadarChartOptions$() {
  if ((!$n_Lcom_papasofokli_chartjs_RadarChartOptions$)) {
    $n_Lcom_papasofokli_chartjs_RadarChartOptions$ = new $c_Lcom_papasofokli_chartjs_RadarChartOptions$();
  }
  return $n_Lcom_papasofokli_chartjs_RadarChartOptions$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_ScatterChartOption$() {
}
$p = $c_Lcom_papasofokli_chartjs_ScatterChartOption$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_ScatterChartOption$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_ScatterChartOption$() {
}
$h_Lcom_papasofokli_chartjs_ScatterChartOption$.prototype = $p;
$p.I7 = (function() {
  return new ($a_Lcom_papasofokli_chartjs_Animation())();
});
var $d_Lcom_papasofokli_chartjs_ScatterChartOption$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_ScatterChartOption$, "com.papasofokli.chartjs.ScatterChartOption$", ({
  kA: 1
}));
var $n_Lcom_papasofokli_chartjs_ScatterChartOption$;
function $m_Lcom_papasofokli_chartjs_ScatterChartOption$() {
  if ((!$n_Lcom_papasofokli_chartjs_ScatterChartOption$)) {
    $n_Lcom_papasofokli_chartjs_ScatterChartOption$ = new $c_Lcom_papasofokli_chartjs_ScatterChartOption$();
  }
  return $n_Lcom_papasofokli_chartjs_ScatterChartOption$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_Tooltip$() {
}
$p = $c_Lcom_papasofokli_chartjs_Tooltip$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_Tooltip$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_Tooltip$() {
}
$h_Lcom_papasofokli_chartjs_Tooltip$.prototype = $p;
$p.ayF = (function(tooltipItem, data) {
  var dataSet = data.ho[(tooltipItem.datasetIndex | 0)];
  var dataSetLabel = dataSet.Ek();
  var array = data.ho;
  if (((array.length | 0) > 1)) {
    var dataSetLabelToShow = (dataSetLabel + " :");
  } else {
    var dataSetLabelToShow = "";
  }
  if ((dataSet instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS)) {
    var value = $dp_toString__T(dataSet.jL[(tooltipItem.index | 0)]);
    var label = data.hp[(tooltipItem.index | 0)];
    return ((((dataSetLabelToShow + " ") + value) + " ") + label);
  }
  if ((dataSet instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS)) {
    var dataValue = dataSet.iD[(tooltipItem.index | 0)];
    var xValue = $m_Lcom_papasofokli_util_DateUtilsJS$().auv(dataValue.mY);
    var this$3 = dataValue.la;
    var yValue = ("" + this$3);
    var value$2 = ((xValue + "  ") + yValue);
    return ((dataSetLabelToShow + " ") + value$2);
  }
  throw new $c_s_MatchError(dataSet);
});
var $d_Lcom_papasofokli_chartjs_Tooltip$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_Tooltip$, "com.papasofokli.chartjs.Tooltip$", ({
  kB: 1
}));
var $n_Lcom_papasofokli_chartjs_Tooltip$;
function $m_Lcom_papasofokli_chartjs_Tooltip$() {
  if ((!$n_Lcom_papasofokli_chartjs_Tooltip$)) {
    $n_Lcom_papasofokli_chartjs_Tooltip$ = new $c_Lcom_papasofokli_chartjs_Tooltip$();
  }
  return $n_Lcom_papasofokli_chartjs_Tooltip$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartjs_TooltipObject$() {
}
$p = $c_Lcom_papasofokli_chartjs_TooltipObject$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartjs_TooltipObject$;
/** @constructor */
function $h_Lcom_papasofokli_chartjs_TooltipObject$() {
}
$h_Lcom_papasofokli_chartjs_TooltipObject$.prototype = $p;
$p.Me = (function(data) {
  var t = ({});
  var cbs = ({});
  cbs.title = ((items$2) => {
    if (((items$2.length | 0) !== 0)) {
      var idx = (items$2[0].dataIndex | 0);
      return data.hp[idx];
    } else {
      return "";
    }
  });
  cbs.label = ((item$2) => {
    var i = (item$2.dataIndex | 0);
    var ds = (item$2.datasetIndex | 0);
    var x2 = data.ho[ds];
    if ((x2 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS)) {
      return $dp_toString__T(x2.jL[i]);
    }
    if ((x2 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS)) {
      return ("" + x2.iD[i].la);
    }
    throw new $c_s_MatchError(x2);
  });
  t.callbacks = cbs;
  return t;
});
var $d_Lcom_papasofokli_chartjs_TooltipObject$ = new $TypeData().i($c_Lcom_papasofokli_chartjs_TooltipObject$, "com.papasofokli.chartjs.TooltipObject$", ({
  kC: 1
}));
var $n_Lcom_papasofokli_chartjs_TooltipObject$;
function $m_Lcom_papasofokli_chartjs_TooltipObject$() {
  if ((!$n_Lcom_papasofokli_chartjs_TooltipObject$)) {
    $n_Lcom_papasofokli_chartjs_TooltipObject$ = new $c_Lcom_papasofokli_chartjs_TooltipObject$();
  }
  return $n_Lcom_papasofokli_chartjs_TooltipObject$;
}
function $p_Lcom_papasofokli_chat_ChatJs$__initializeChatConversation__V($thiz) {
  var chatConversation = document.querySelector("div.s811c7dc-6ef3-11ed-a1eb-0242ac120002");
  if ((!(!(chatConversation instanceof HTMLDivElement)))) {
    chatConversation.classList.remove("s811c7dc-6ef3-11ed-a1eb-0242ac120002");
    $p_Lcom_papasofokli_chat_ChatJs$__addScrollEvent__Lorg_scalajs_dom_HTMLDivElement__V($thiz, chatConversation);
  }
}
function $p_Lcom_papasofokli_chat_ChatJs$__initializeChatTextInput__V($thiz) {
  var element = document.querySelector(".fb8cb0e4-1ccb-4b1a-bc80-3975ae72c77d");
  if ((!(!(element instanceof HTMLInputElement)))) {
    element.classList.remove("fb8cb0e4-1ccb-4b1a-bc80-3975ae72c77d");
    $p_Lcom_papasofokli_chat_ChatJs$__addEnterKeyEvent__Lorg_scalajs_dom_HTMLInputElement__V($thiz, element);
    element.focus();
  }
}
function $p_Lcom_papasofokli_chat_ChatJs$__addEnterKeyEvent__Lorg_scalajs_dom_HTMLInputElement__V($thiz, input) {
  input.onkeypress = ((c$2) => (((c$2.key === $m_Lcom_papasofokli_input_Key$().JC) && ($m_sc_StringOps$(), ($f_T__strip__T(input.value) !== ""))) ? $m_sjs_js_timers_package$().gb(300.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    document.querySelector(".chat-sent-btn").click();
  }))) : (void 0)));
}
function $p_Lcom_papasofokli_chat_ChatJs$__addScrollEvent__Lorg_scalajs_dom_HTMLDivElement__V($thiz, div) {
  div.onscroll = ((_$1$2) => {
    var a = (+div.scrollTop);
    if ((((+Math.ceil(a)) < (-3.0)) && (!(!(!div.classList.contains("div-scroll-pass")))))) {
      div.classList.add("div-scroll-pass");
      return (void 0);
    } else {
      var a$1 = (+div.scrollTop);
      if (((+Math.ceil(a$1)) >= 0.0)) {
        div.classList.remove("div-scroll-pass");
        return (void 0);
      } else {
        return (void 0);
      }
    }
  });
}
/** @constructor */
function $c_Lcom_papasofokli_chat_ChatJs$() {
}
$p = $c_Lcom_papasofokli_chat_ChatJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chat_ChatJs$;
/** @constructor */
function $h_Lcom_papasofokli_chat_ChatJs$() {
}
$h_Lcom_papasofokli_chat_ChatJs$.prototype = $p;
$p.co = (function() {
  $p_Lcom_papasofokli_chat_ChatJs$__initializeChatTextInput__V(this);
  $p_Lcom_papasofokli_chat_ChatJs$__initializeChatConversation__V(this);
});
var $d_Lcom_papasofokli_chat_ChatJs$ = new $TypeData().i($c_Lcom_papasofokli_chat_ChatJs$, "com.papasofokli.chat.ChatJs$", ({
  kD: 1
}));
var $n_Lcom_papasofokli_chat_ChatJs$;
function $m_Lcom_papasofokli_chat_ChatJs$() {
  if ((!$n_Lcom_papasofokli_chat_ChatJs$)) {
    $n_Lcom_papasofokli_chat_ChatJs$ = new $c_Lcom_papasofokli_chat_ChatJs$();
  }
  return $n_Lcom_papasofokli_chat_ChatJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$() {
  this.WP = null;
  $n_Lcom_papasofokli_classes_custom_DynamicClass$ = this;
  this.WP = $m_sci_Seq$().Mj($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$Left$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$Width$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$Height$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$(), $m_Lcom_papasofokli_classes_custom_DynamicClass$Flex$()]));
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$.prototype = $p;
var $d_Lcom_papasofokli_classes_custom_DynamicClass$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$, "com.papasofokli.classes.custom.DynamicClass$", ({
  kE: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$;
}
function $p_Lcom_papasofokli_clock_ClockJs$__checkTime__D__T($thiz, time) {
  return ((time < 10.0) ? ("0" + $doubleToInt(time)) : ("" + $doubleToInt(time)));
}
function $p_Lcom_papasofokli_clock_ClockJs$__getTimeSpan__T__Lorg_scalajs_dom_Element($thiz, time) {
  var span = document.createElement("span");
  span.textContent = time;
  return span;
}
function $p_Lcom_papasofokli_clock_ClockJs$__initializeInterval__Lorg_scalajs_dom_HTMLSpanElement__sjs_js_Date__V($thiz, span, date) {
  if ($thiz.NP) {
    date.setSeconds(((+date.getSeconds()) + 1.0));
  }
  var this$1 = $doubleToInt((+date.getUTCHours()));
  var h = ("" + this$1);
  var m = $p_Lcom_papasofokli_clock_ClockJs$__checkTime__D__T($thiz, (+date.getUTCMinutes()));
  var s = $p_Lcom_papasofokli_clock_ClockJs$__checkTime__D__T($thiz, (+date.getUTCSeconds()));
  var time = ((((h + ":") + m) + ":") + s);
  var newSpan = $p_Lcom_papasofokli_clock_ClockJs$__getTimeSpan__T__Lorg_scalajs_dom_Element($thiz, time);
  span.replaceChildren(newSpan);
}
/** @constructor */
function $c_Lcom_papasofokli_clock_ClockJs$() {
  this.NP = false;
  this.NP = false;
}
$p = $c_Lcom_papasofokli_clock_ClockJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_clock_ClockJs$;
/** @constructor */
function $h_Lcom_papasofokli_clock_ClockJs$() {
}
$h_Lcom_papasofokli_clock_ClockJs$.prototype = $p;
$p.b7 = (function(ec) {
  var element = document.querySelector(".e91c050c-e97e-11ed-a05b-0242ac120003");
  if ((!(!(element instanceof HTMLSpanElement)))) {
    element.classList.remove("e91c050c-e97e-11ed-a05b-0242ac120003");
    this.NP = true;
    $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(element.getAttribute("data-setup-function"), element.getAttribute("data-setup-reference"), ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      var timestampDouble = (+$f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().op));
      var date = new Date(timestampDouble);
      (window.setInterval((() => {
        $p_Lcom_papasofokli_clock_ClockJs$__initializeInterval__Lorg_scalajs_dom_HTMLSpanElement__sjs_js_Date__V(this, element, date);
      }), 1000.0) | 0);
    })), ec))), ec);
  } else {
    $m_s_concurrent_Future$().aE((void 0));
  }
});
var $d_Lcom_papasofokli_clock_ClockJs$ = new $TypeData().i($c_Lcom_papasofokli_clock_ClockJs$, "com.papasofokli.clock.ClockJs$", ({
  kP: 1
}));
var $n_Lcom_papasofokli_clock_ClockJs$;
function $m_Lcom_papasofokli_clock_ClockJs$() {
  if ((!$n_Lcom_papasofokli_clock_ClockJs$)) {
    $n_Lcom_papasofokli_clock_ClockJs$ = new $c_Lcom_papasofokli_clock_ClockJs$();
  }
  return $n_Lcom_papasofokli_clock_ClockJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_clock_CountDownHelper$() {
  this.al1 = null;
  this.al1 = "setup-minutes";
}
$p = $c_Lcom_papasofokli_clock_CountDownHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_clock_CountDownHelper$;
/** @constructor */
function $h_Lcom_papasofokli_clock_CountDownHelper$() {
}
$h_Lcom_papasofokli_clock_CountDownHelper$.prototype = $p;
$p.an4 = (function(minutes) {
  return ((minutes === 0) ? "Now" : ((minutes < 60) ? (minutes + " min ago") : (((minutes >= 60) && (((minutes / 60) | 0) === 1)) ? "1 hour ago" : (((minutes >= 60) && (((((minutes / 60) | 0) / 24) | 0) < 1)) ? (((minutes / 60) | 0) + " hours ago") : (((minutes >= 60) && (((((minutes / 60) | 0) / 24) | 0) === 1)) ? "1 day ago" : (((((minutes / 60) | 0) / 24) | 0) + " days ago"))))));
});
var $d_Lcom_papasofokli_clock_CountDownHelper$ = new $TypeData().i($c_Lcom_papasofokli_clock_CountDownHelper$, "com.papasofokli.clock.CountDownHelper$", ({
  kQ: 1
}));
var $n_Lcom_papasofokli_clock_CountDownHelper$;
function $m_Lcom_papasofokli_clock_CountDownHelper$() {
  if ((!$n_Lcom_papasofokli_clock_CountDownHelper$)) {
    $n_Lcom_papasofokli_clock_CountDownHelper$ = new $c_Lcom_papasofokli_clock_CountDownHelper$();
  }
  return $n_Lcom_papasofokli_clock_CountDownHelper$;
}
function $p_Lcom_papasofokli_clock_CountdownJs$__initializeInterval__Lorg_scalajs_dom_HTMLSpanElement__I__I($thiz, span, setupMins) {
  var setupMinsVr = new $c_sr_IntRef(setupMins);
  return (window.setInterval((() => {
    $p_Lcom_papasofokli_clock_CountdownJs$__initializeIntervalHelper$1__sr_IntRef__Lorg_scalajs_dom_HTMLSpanElement__V($thiz, setupMinsVr, span);
  }), 60000.0) | 0);
}
function $p_Lcom_papasofokli_clock_CountdownJs$__initializeIntervalHelper$1__sr_IntRef__Lorg_scalajs_dom_HTMLSpanElement__V($thiz, setupMinsVr$1, span$1) {
  var finalText = $m_Lcom_papasofokli_clock_CountDownHelper$().an4(setupMinsVr$1.f4);
  setupMinsVr$1.f4 = ((1 + setupMinsVr$1.f4) | 0);
  span$1.replaceChildren(finalText);
}
/** @constructor */
function $c_Lcom_papasofokli_clock_CountdownJs$() {
}
$p = $c_Lcom_papasofokli_clock_CountdownJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_clock_CountdownJs$;
/** @constructor */
function $h_Lcom_papasofokli_clock_CountdownJs$() {
}
$h_Lcom_papasofokli_clock_CountdownJs$.prototype = $p;
$p.co = (function() {
  $m_Lcom_papasofokli_util_package$().fo("d1b639fa-231c-11ee-be56-0242ac120002").each(((this$1) => (function() {
    return ((!(!(this instanceof HTMLSpanElement))) ? (this.classList.remove("d1b639fa-231c-11ee-be56-0242ac120002"), $p_Lcom_papasofokli_clock_CountdownJs$__initializeInterval__Lorg_scalajs_dom_HTMLSpanElement__I__I(this$1, this, ($m_sc_StringOps$(), $m_jl_Integer$().c7(this.getAttribute("setup-minutes"), 10, 214748364)))) : $m_s_concurrent_Future$().aE((void 0)));
  }))(this));
});
var $d_Lcom_papasofokli_clock_CountdownJs$ = new $TypeData().i($c_Lcom_papasofokli_clock_CountdownJs$, "com.papasofokli.clock.CountdownJs$", ({
  kR: 1
}));
var $n_Lcom_papasofokli_clock_CountdownJs$;
function $m_Lcom_papasofokli_clock_CountdownJs$() {
  if ((!$n_Lcom_papasofokli_clock_CountdownJs$)) {
    $n_Lcom_papasofokli_clock_CountdownJs$ = new $c_Lcom_papasofokli_clock_CountdownJs$();
  }
  return $n_Lcom_papasofokli_clock_CountdownJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_components_AccordionContentJS$() {
}
$p = $c_Lcom_papasofokli_components_AccordionContentJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_AccordionContentJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_AccordionContentJS$() {
}
$h_Lcom_papasofokli_components_AccordionContentJS$.prototype = $p;
$p.ajp = (function(e, executionContext) {
  e.removeEventListener("shown.bs.collapse", ((_$1$2) => this.ajp(e, executionContext)));
  return this.ajf(e, executionContext);
});
$p.ajf = (function(e, executionContext) {
  var getBodyFunId = e.getAttribute("data-get-body-function");
  return ((getBodyFunId !== null) ? $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getBodyFunId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    var html = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
    e.removeAttribute("data-get-body-function");
    var accBodyElement = e.querySelector(".accordion-body");
    var innerDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])).aB();
    innerDiv.innerHTML = html;
    accBodyElement.replaceChildren(innerDiv);
    $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
  })), executionContext))), executionContext) : $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (void 0))), executionContext));
});
$p.b7 = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".c1c6f709-0bef-46f7-ab4b-2a598021f8ef"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    if ((!(!x0.classList.contains("show")))) {
      this.ajf(x0, executionContext);
    } else {
      x0.addEventListener("shown.bs.collapse", ((x0, executionContext) => ((_$2$2) => this.ajp(x0, executionContext)))(x0, executionContext));
    }
    x0.classList.remove("c1c6f709-0bef-46f7-ab4b-2a598021f8ef");
  }
});
var $d_Lcom_papasofokli_components_AccordionContentJS$ = new $TypeData().i($c_Lcom_papasofokli_components_AccordionContentJS$, "com.papasofokli.components.AccordionContentJS$", ({
  kV: 1
}));
var $n_Lcom_papasofokli_components_AccordionContentJS$;
function $m_Lcom_papasofokli_components_AccordionContentJS$() {
  if ((!$n_Lcom_papasofokli_components_AccordionContentJS$)) {
    $n_Lcom_papasofokli_components_AccordionContentJS$ = new $c_Lcom_papasofokli_components_AccordionContentJS$();
  }
  return $n_Lcom_papasofokli_components_AccordionContentJS$;
}
function $p_Lcom_papasofokli_components_BoxJS$__updateContent__Lorg_scalajs_dom_Element__T__V($thiz, contentDiv, html) {
  var rowDiv = contentDiv.firstElementChild;
  if (((rowDiv !== null) && (!(!rowDiv.classList.contains("row"))))) {
    rowDiv.innerHTML = html;
  } else {
    contentDiv.innerHTML = html;
  }
}
function $p_Lcom_papasofokli_components_BoxJS$__collapse__Lcom_papasofokli_box_BoxData__Lorg_scalajs_dom_Element__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element($thiz, boxSetup, contentDiv, ec) {
  var icon = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(boxSetup.mU.by, $m_Lscalatags_JsDom$all$().s)])).aB();
  var link = $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn btn-sm btn-link link-light ms-auto p-1 pe-0 lh-1 lazy-collapse", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), icon)])).aB();
  link.onclick = ((_$1$2) => {
    if ((icon.className === boxSetup.mU.by)) {
      return $p_Lcom_papasofokli_components_BoxJS$__expandLazyBox__Lcom_papasofokli_box_BoxData__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, boxSetup, contentDiv, icon, ec);
    } else {
      $p_Lcom_papasofokli_components_BoxJS$__updateContent__Lorg_scalajs_dom_Element__T__V($thiz, contentDiv, "");
      icon.className = boxSetup.mU.by;
      return (void 0);
    }
  });
  if (boxSetup.l2) {
    $p_Lcom_papasofokli_components_BoxJS$__expandLazyBox__Lcom_papasofokli_box_BoxData__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, boxSetup, contentDiv, icon, ec);
  }
  return link;
}
function $p_Lcom_papasofokli_components_BoxJS$__expandLazyBox__Lcom_papasofokli_box_BoxData__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, boxSetup, contentDiv, icon, ec) {
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(boxSetup.qW.g(), "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    $p_Lcom_papasofokli_components_BoxJS$__updateContent__Lorg_scalajs_dom_Element__T__V($thiz, contentDiv, $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J));
    icon.className = boxSetup.qV.by;
    $m_Lcom_papasofokli_InitializeScalaJS$().b7(ec);
  })), ec))), ec);
}
function $p_Lcom_papasofokli_components_BoxJS$__boxRender__Lcom_papasofokli_box_BoxData__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLDivElement($thiz, boxSetup, ec) {
  var content = $thiz.asM(boxSetup);
  var title = $m_Lscalatags_JsDom$all$().bk().aB();
  title.innerHTML = boxSetup.r1;
  title.classList.add("flex-grow-1");
  var elements = $thiz.auO(boxSetup).aV(title).dt($thiz.an2(boxSetup, content, ec));
  var titleDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((boxSetup.qZ + " card-header text-white d-flex align-items-center gap-2 border-0"), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), elements, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB();
  var boxClass = (("ibox card " + boxSetup.qY) + " p-0 mb-4");
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(boxClass, $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), titleDiv), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), content)])).aB();
}
function $p_Lcom_papasofokli_components_BoxJS$__toggleClass__Lorg_scalajs_dom_Element__T__V($thiz, element, str) {
  if ((!(!element.classList.contains(str)))) {
    element.classList.remove(str);
  } else {
    element.classList.add(str);
  }
}
function $p_Lcom_papasofokli_components_BoxJS$__initializeBoxButtons__V($thiz) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".collapse-link"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("click", ((x0) => ((_$2$2) => {
      var box = x0.closest("div.ibox");
      var button = x0.querySelector("i");
      var content = box.querySelector(".ibox-content");
      var \u03b41$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + content.id));
      \u03b41$.slideToggle(200);
      return ((button !== null) ? ($p_Lcom_papasofokli_components_BoxJS$__toggleClass__Lorg_scalajs_dom_Element__T__V($thiz, button, "fa-chevron-up"), $p_Lcom_papasofokli_components_BoxJS$__toggleClass__Lorg_scalajs_dom_Element__T__V($thiz, button, "fa-chevron-down"), (void 0)) : (void 0));
    }))(x0));
    x0.classList.remove("collapse-link");
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_BoxJS$() {
}
$p = $c_Lcom_papasofokli_components_BoxJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_BoxJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_BoxJS$() {
}
$h_Lcom_papasofokli_components_BoxJS$.prototype = $p;
$p.auO = (function(boxSetup) {
  var $x_2 = $m_s_Option$();
  var this$1 = boxSetup.r0;
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.h();
    var $x_1 = new $c_s_Some($m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((x0.by + " fs-6"), $m_Lscalatags_JsDom$all$().s)])).aB());
  }
  return $x_2.hi($x_1).cf();
});
$p.an2 = (function(boxSetup, contentDiv, ec) {
  return (boxSetup.l3 ? new $c_s_Some(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_components_BoxJS$__collapse__Lcom_papasofokli_box_BoxData__Lorg_scalajs_dom_Element__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element(this, boxSetup, contentDiv, ec)).ky) : $m_s_None$());
});
$p.asM = (function(boxSetup) {
  var rowDivO = (boxSetup.l4 ? new $c_s_Some($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row", $m_Lscalatags_JsDom$all$().s)]))) : $m_s_None$());
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("ibox-content " + boxSetup.qX) + " card-body rounded"), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $m_s_Option$().hi(rowDivO).cf(), $m_s_$less$colon$less$().b0)])).aB();
});
$p.b7 = (function(ec) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".mybox-init").each(((this$1) => (function() {
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(this.getAttribute("my-box-setup"), "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      var boxSetup = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_box_BoxData$().q());
      var newContent = $p_Lcom_papasofokli_components_BoxJS$__boxRender__Lcom_papasofokli_box_BoxData__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLDivElement(this$1, boxSetup, ec);
      this.innerHTML = "";
      this.appendChild(newContent);
      this.classList.remove("mybox-init");
    })), ec))), ec);
  }))(this));
  $p_Lcom_papasofokli_components_BoxJS$__initializeBoxButtons__V(this);
});
var $d_Lcom_papasofokli_components_BoxJS$ = new $TypeData().i($c_Lcom_papasofokli_components_BoxJS$, "com.papasofokli.components.BoxJS$", ({
  kW: 1
}));
var $n_Lcom_papasofokli_components_BoxJS$;
function $m_Lcom_papasofokli_components_BoxJS$() {
  if ((!$n_Lcom_papasofokli_components_BoxJS$)) {
    $n_Lcom_papasofokli_components_BoxJS$ = new $c_Lcom_papasofokli_components_BoxJS$();
  }
  return $n_Lcom_papasofokli_components_BoxJS$;
}
function $p_Lcom_papasofokli_components_CalendarJS$__resizeHeaders__T__sc_Seq($thiz, tableId) {
  var tableElement = document.querySelector(("#" + tableId));
  var filters = tableElement.querySelectorAll(".cal-th");
  var widths = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(filters), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    var width = (e$2.clientWidth | 0);
    $p_Lcom_papasofokli_components_CalendarJS$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, (width + "px"), e$2, $m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$());
    return width;
  })));
  widths.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((width$3) => {
    var width$2 = (width$3 | 0);
    return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(".cal-time-slot")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => {
      $p_Lcom_papasofokli_components_CalendarJS$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, (width$2 + "px"), e$3, $m_Lcom_papasofokli_classes_custom_DynamicClass$Width$());
    })));
  })));
  return widths;
}
function $p_Lcom_papasofokli_components_CalendarJS$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, attribute, e, dynamicClass) {
  e.classList.add(dynamicClass.gH());
  var \u03b41$ = e.style;
  \u03b41$.setProperty(dynamicClass.kG(), attribute);
}
/** @constructor */
function $c_Lcom_papasofokli_components_CalendarJS$() {
}
$p = $c_Lcom_papasofokli_components_CalendarJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_CalendarJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_CalendarJS$() {
}
$h_Lcom_papasofokli_components_CalendarJS$.prototype = $p;
$p.avb = (function(ec) {
  $m_Lcom_papasofokli_util_package$().fo("f603df61-1540-4903-8384-0242ac120002").each(((this$1) => (function() {
    var tableElement = this.querySelector("table");
    var size = $p_Lcom_papasofokli_components_CalendarJS$__resizeHeaders__T__sc_Seq(this$1, tableElement.id);
    var loadDataFunctionId = this.getAttribute("data-post-action");
    var this$2 = size.bj();
    var this$5 = (this$2.c() ? $m_s_None$() : new $c_s_Some(("" + (this$2.h() | 0))));
    var response = (this$5.c() ? "" : this$5.h());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(loadDataFunctionId).g(), response, ec);
  }))(this));
});
$p.auZ = (function() {
  $m_Lcom_papasofokli_util_package$().fo("c1fa8822-e961-4c7a-a10a-9d8942312f0a").each(((this$1) => (function() {
    return $p_Lcom_papasofokli_components_CalendarJS$__resizeHeaders__T__sc_Seq(this$1, this.getAttribute("data-container-id"));
  }))(this));
});
$p.axa = (function(elementId) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelector(("#" + elementId)).children);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.remove();
  }
});
var $d_Lcom_papasofokli_components_CalendarJS$ = new $TypeData().i($c_Lcom_papasofokli_components_CalendarJS$, "com.papasofokli.components.CalendarJS$", ({
  kX: 1
}));
var $n_Lcom_papasofokli_components_CalendarJS$;
function $m_Lcom_papasofokli_components_CalendarJS$() {
  if ((!$n_Lcom_papasofokli_components_CalendarJS$)) {
    $n_Lcom_papasofokli_components_CalendarJS$ = new $c_Lcom_papasofokli_components_CalendarJS$();
  }
  return $n_Lcom_papasofokli_components_CalendarJS$;
}
function $p_Lcom_papasofokli_components_ModalJS$__onLoadFun__Lorg_scalajs_dom_Event__s_concurrent_ExecutionContext__O($thiz, e, executionContext) {
  var x3 = e.target;
  if ((!(!(x3 instanceof HTMLElement)))) {
    var modalId = x3.id;
    var modal = document.querySelector(("#" + modalId));
    if ((!(!(modal instanceof HTMLElement)))) {
      if ((!(!modal.classList.contains("b97d1b28-e35e-4c14-a586-fa3ff008aac9")))) {
        modal.classList.remove("b97d1b28-e35e-4c14-a586-fa3ff008aac9");
        return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(modalId).g(), "", executionContext);
      }
    }
    return (void 0);
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_ModalJS$() {
}
$p = $c_Lcom_papasofokli_components_ModalJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_ModalJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_ModalJS$() {
}
$h_Lcom_papasofokli_components_ModalJS$.prototype = $p;
$p.b7 = (function(executionContext) {
  var modal = document.querySelectorAll(".modal");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(modal);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("shown.bs.modal", ((executionContext) => ((e$2) => $p_Lcom_papasofokli_components_ModalJS$__onLoadFun__Lorg_scalajs_dom_Event__s_concurrent_ExecutionContext__O(this, e$2, executionContext)))(executionContext));
  }
});
var $d_Lcom_papasofokli_components_ModalJS$ = new $TypeData().i($c_Lcom_papasofokli_components_ModalJS$, "com.papasofokli.components.ModalJS$", ({
  kY: 1
}));
var $n_Lcom_papasofokli_components_ModalJS$;
function $m_Lcom_papasofokli_components_ModalJS$() {
  if ((!$n_Lcom_papasofokli_components_ModalJS$)) {
    $n_Lcom_papasofokli_components_ModalJS$ = new $c_Lcom_papasofokli_components_ModalJS$();
  }
  return $n_Lcom_papasofokli_components_ModalJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_components_NonSessionExpiringDiv(executionContext) {
  $m_sjs_js_timers_package$().Vq(1200000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    window.location.reload();
  })));
}
$p = $c_Lcom_papasofokli_components_NonSessionExpiringDiv.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_NonSessionExpiringDiv;
/** @constructor */
function $h_Lcom_papasofokli_components_NonSessionExpiringDiv() {
}
$h_Lcom_papasofokli_components_NonSessionExpiringDiv.prototype = $p;
var $d_Lcom_papasofokli_components_NonSessionExpiringDiv = new $TypeData().i($c_Lcom_papasofokli_components_NonSessionExpiringDiv, "com.papasofokli.components.NonSessionExpiringDiv", ({
  l0: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_components_NonSessionExpiringDivJs$() {
}
$p = $c_Lcom_papasofokli_components_NonSessionExpiringDivJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_NonSessionExpiringDivJs$;
/** @constructor */
function $h_Lcom_papasofokli_components_NonSessionExpiringDivJs$() {
}
$h_Lcom_papasofokli_components_NonSessionExpiringDivJs$.prototype = $p;
$p.IM = (function(executionContext) {
  return $m_Lcom_papasofokli_util_package$().Eg("1d6c103e-a9d6-411c-9cb1-c9a2ba8d64c7", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    new $c_Lcom_papasofokli_components_NonSessionExpiringDiv(executionContext);
  })));
});
var $d_Lcom_papasofokli_components_NonSessionExpiringDivJs$ = new $TypeData().i($c_Lcom_papasofokli_components_NonSessionExpiringDivJs$, "com.papasofokli.components.NonSessionExpiringDivJs$", ({
  l1: 1
}));
var $n_Lcom_papasofokli_components_NonSessionExpiringDivJs$;
function $m_Lcom_papasofokli_components_NonSessionExpiringDivJs$() {
  if ((!$n_Lcom_papasofokli_components_NonSessionExpiringDivJs$)) {
    $n_Lcom_papasofokli_components_NonSessionExpiringDivJs$ = new $c_Lcom_papasofokli_components_NonSessionExpiringDivJs$();
  }
  return $n_Lcom_papasofokli_components_NonSessionExpiringDivJs$;
}
function $p_Lcom_papasofokli_components_OutlookJS$__initializeSearch__T__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, searchContentFunctionId, setupFunctionId, executionContext) {
  var searchBtn = (0, $m_Lcom_papasofokli_jquery_package$().I)(".outlook-search-btn");
  var searchInput = (0, $m_Lcom_papasofokli_jquery_package$().I)(".outlook-search");
  searchInput.keypress(((event$2) => (((event$2.which | 0) === 13) ? $p_Lcom_papasofokli_components_OutlookJS$__doSearch__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, searchContentFunctionId, setupFunctionId, executionContext) : (void 0))));
  return searchBtn.click(((_$1$2) => $p_Lcom_papasofokli_components_OutlookJS$__doSearch__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, searchContentFunctionId, setupFunctionId, executionContext)));
}
function $p_Lcom_papasofokli_components_OutlookJS$__doSearch__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, searchContentFunctionId, setupFunctionId, executionContext) {
  var searchInput = (0, $m_Lcom_papasofokli_jquery_package$().I)(".outlook-search");
  var searchValue = searchInput.val();
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(searchContentFunctionId, $dp_toString__T(searchValue), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    var contentsSeq = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_communication_OutlookData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
    var innerHtml = $p_Lcom_papasofokli_components_OutlookJS$__createItemRows__sci_Seq__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement($thiz, contentsSeq, setupFunctionId, executionContext);
    var newTableDiv = (0, $m_Lcom_papasofokli_jquery_package$().I)(".news-table");
    newTableDiv.children().remove().end().append(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerHtml).ky);
    var pageJq = (0, $m_Lcom_papasofokli_jquery_package$().I)(".outlook-pagination");
    return (($dp_toString__T(searchValue) === "") ? pageJq.removeAttr("hidden") : pageJq.attr("hidden", true));
  })), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_components_OutlookJS$__resetPreviouslySelectedItem__Lcom_papasofokli_jquery_JQuery($thiz) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".selected-list-group-item").each((function() {
    var id = this.id;
    var liJs = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
    return liJs.removeClass("selected-list-group-item");
  }));
}
function $p_Lcom_papasofokli_components_OutlookJS$__createItemRows__sci_Seq__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement($thiz, data, setupFunctionId, executionContext) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(400, 0, executionContext);
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("list-group elements-list", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_components_OutlookJS$__process$1__Lcom_papasofokli_util_MultipleEventHandler__T__s_concurrent_ExecutionContext__sci_Seq__sci_Seq__sci_Seq($thiz, multipleEventHandler, setupFunctionId, executionContext, data, $m_sci_Nil$()), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB();
}
function $p_Lcom_papasofokli_components_OutlookJS$__paginationPageClickedF__I__T__T__s_concurrent_ExecutionContext__V($thiz, num, getContentFunctionId, setupFunctionId, executionContext) {
  $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getContentFunctionId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), num, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().ao), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    var contentsSeq = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_communication_OutlookData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
    var innerHtml = $p_Lcom_papasofokli_components_OutlookJS$__createItemRows__sci_Seq__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement($thiz, contentsSeq, setupFunctionId, executionContext);
    var newTableDiv = (0, $m_Lcom_papasofokli_jquery_package$().I)(".news-table");
    return newTableDiv.children().remove().end().append(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerHtml).ky);
  })), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_components_OutlookJS$__initializePagination__T__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, getContentFunctionId, setupFunctionId, executionContext) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-outlook-pagination").removeClass("not-initialized-outlook-pagination").each((function() {
    var id = this.id;
    var totalItems = this.getAttribute("data-total-items");
    var rowsPerPage = this.getAttribute("data-rows-page");
    var pageJq = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
    if ((($m_sc_StringOps$(), $m_jl_Integer$().c7(totalItems, 10, 214748364)) > ($m_sc_StringOps$(), $m_jl_Integer$().c7(rowsPerPage, 10, 214748364)))) {
      pageJq.removeAttr("hidden");
    }
    $m_Lcom_papasofokli_pagination_PaginationJs$().MY(id, ($m_sc_StringOps$(), $m_jl_Double$().fS(totalItems)), ($m_sc_StringOps$(), $m_jl_Double$().fS(rowsPerPage)), 1, $m_Lcom_papasofokli_pagination_PaginationHelper$().OJ, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
      $p_Lcom_papasofokli_components_OutlookJS$__paginationPageClickedF__I__T__T__s_concurrent_ExecutionContext__V($thiz, (v2$2 | 0), getContentFunctionId, setupFunctionId, executionContext);
    })), "");
  }));
}
function $p_Lcom_papasofokli_components_OutlookJS$__process$1__Lcom_papasofokli_util_MultipleEventHandler__T__s_concurrent_ExecutionContext__sci_Seq__sci_Seq__sci_Seq($thiz, multipleEventHandler$1, setupFunctionId$7, executionContext$10, data, acc) {
  var acc$tailLocal1 = acc;
  var data$tailLocal1 = data;
  while (true) {
    if (data$tailLocal1.bj().c()) {
      return acc$tailLocal1;
    } else {
      var item = data$tailLocal1.W();
      var $x_13 = $m_Lscalatags_JsDom$all$().he();
      var $x_12 = $m_Lscalatags_JsDom$all$().D().n(("list-group-item border border-2 " + item.aus()), $m_Lscalatags_JsDom$all$().s);
      var $x_11 = $m_Lscalatags_JsDom$all$().bE().n($bL(item.mw, item.mx), $m_Lscalatags_JsDom$all$().Sy);
      var $x_10 = $m_Lscalatags_JsDom$all$().ij();
      var $x_9 = $m_Lscalatags_JsDom$all$().D().n("unstyle", $m_Lscalatags_JsDom$all$().s);
      var $x_8 = $m_Lscalatags_JsDom$all$().IL().n("#", $m_Lscalatags_JsDom$all$().s);
      var $x_7 = $m_Lscalatags_JsDom$all$().ajN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("float-end text-muted", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item.r2))]));
      var $x_6 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("outlook-title", $m_Lscalatags_JsDom$all$().s), (item.lc ? $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8M.by, $m_Lscalatags_JsDom$all$().s)])) : ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(""))), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag((" " + item.r3)))]));
      var $x_5 = $m_Lscalatags_JsDom$all$().as();
      var $x_4 = $m_Lscalatags_JsDom$all$().D().n("small m-t-xs", $m_Lscalatags_JsDom$all$().s);
      if ((!item.jO.c())) {
        var $x_3 = $m_Lscalatags_JsDom$all$().bk();
        var $x_2 = $m_Lscalatags_JsDom$all$().D();
        var this$17 = item.ld;
        var $x_1 = $x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_2.n(("label " + (this$17.c() ? "label-primary" : this$17.h())), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item.jO.h()))]));
      } else {
        var $x_1 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("m-b-none", $m_Lscalatags_JsDom$all$().s)]));
      }
      var liHtml = $x_13.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_12, $x_11, $x_10.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_9, $x_8, $x_7, $x_6, $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4, $x_1]))])), $m_Lscalatags_JsDom$all$().fc().n(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((multipleEventHandler$1, item, setupFunctionId$7, executionContext$10) => ((_$2$2) => multipleEventHandler$1.atF(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        var id_$_lo = item.mw;
        var id_$_hi = item.mx;
        var liJs = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $s_RTLong__toString__I__I__T(id_$_lo, id_$_hi)));
        $p_Lcom_papasofokli_components_OutlookJS$__resetPreviouslySelectedItem__Lcom_papasofokli_jquery_JQuery($thiz);
        liJs.removeClass("fw-bold");
        liJs.addClass("selected-list-group-item fw-normal");
        $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(setupFunctionId$7, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), $bL(item.mw, item.mx), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().ay), executionContext$10).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
          var contentHtml = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
          var innerContentDiv = (0, $m_Lcom_papasofokli_jquery_package$().I)(".content-inner");
          innerContentDiv.html(contentHtml);
          $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext$10);
        })), executionContext$10))), executionContext$10);
      })))))(multipleEventHandler$1, item, setupFunctionId$7, executionContext$10)), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))])).aB();
      var data$tailLocal1$tmp1 = data$tailLocal1.ak();
      var acc$tailLocal1$tmp1 = acc$tailLocal1.aV(liHtml);
      data$tailLocal1 = data$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_OutlookJS$() {
}
$p = $c_Lcom_papasofokli_components_OutlookJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_OutlookJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_OutlookJS$() {
}
$h_Lcom_papasofokli_components_OutlookJS$.prototype = $p;
$p.b7 = (function(executionContext) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".d8bb5782-9c27-11ea-bb37-0242ac130002").removeClass("d8bb5782-9c27-11ea-bb37-0242ac130002").each(((this$2) => (function() {
    var setupFunctionId = this.getAttribute("data-selection-changed");
    var getContentFunctionId = this.getAttribute("data-content-fun");
    var searchContentFunctionId = this.getAttribute("data-content-search");
    $p_Lcom_papasofokli_components_OutlookJS$__initializePagination__T__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$2, getContentFunctionId, setupFunctionId, executionContext);
    $p_Lcom_papasofokli_components_OutlookJS$__initializeSearch__T__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$2, searchContentFunctionId, setupFunctionId, executionContext);
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getContentFunctionId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), 1, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().ao), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      var contentsSeq = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_communication_OutlookData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
      var innerHtml = $p_Lcom_papasofokli_components_OutlookJS$__createItemRows__sci_Seq__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement(this$2, contentsSeq, setupFunctionId, executionContext);
      var newTableDiv = (0, $m_Lcom_papasofokli_jquery_package$().I)(".news-table");
      newTableDiv.children().remove().end().append(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerHtml).ky);
      if ((!contentsSeq.c())) {
        var $x_3 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
        var $x_2 = $m_Lupickle_default$();
        var $x_1 = contentsSeq.W();
        return $x_3.c5(setupFunctionId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_2, $bL($x_1.mw, $x_1.mx), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().ay), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2$1) => $m_sjs_js_Thenable$Implicits$().bH(resp$2$1.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
          var contentHtml = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
          var innerContentDiv = (0, $m_Lcom_papasofokli_jquery_package$().I)(".content-inner ");
          innerContentDiv.html(contentHtml);
          $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
        })), executionContext))), executionContext);
      } else {
        return (void 0);
      }
    })), executionContext))), executionContext);
  }))(this));
});
var $d_Lcom_papasofokli_components_OutlookJS$ = new $TypeData().i($c_Lcom_papasofokli_components_OutlookJS$, "com.papasofokli.components.OutlookJS$", ({
  l2: 1
}));
var $n_Lcom_papasofokli_components_OutlookJS$;
function $m_Lcom_papasofokli_components_OutlookJS$() {
  if ((!$n_Lcom_papasofokli_components_OutlookJS$)) {
    $n_Lcom_papasofokli_components_OutlookJS$ = new $c_Lcom_papasofokli_components_OutlookJS$();
  }
  return $n_Lcom_papasofokli_components_OutlookJS$;
}
function $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__initializeScrollableNumberInput__Lorg_scalajs_dom_Element__V($thiz, element) {
  element.classList.remove("cc1bd2db-adda-41fc-90ef-7f8366df9380");
  $m_sc_StringOps$();
  var value = $m_jl_Integer$().c7(element.getAttribute("data-value"), 10, 214748364);
  $m_sc_StringOps$();
  var min = $m_jl_Integer$().c7(element.getAttribute("data-min"), 10, 214748364);
  $m_sc_StringOps$();
  var max = $m_jl_Integer$().c7(element.getAttribute("data-max"), 10, 214748364);
  $m_sc_StringOps$();
  var verticalIncrement = $m_jl_Integer$().c7(element.getAttribute("data-vertical-increment"), 10, 214748364);
  $m_sc_StringOps$();
  var horizontalIncrement = $m_jl_Integer$().c7(element.getAttribute("data-horizontal-increment"), 10, 214748364);
  $m_sc_StringOps$();
  var verticalSpeed = $m_jl_Double$().fS(element.getAttribute("data-vertical-speed"));
  $m_sc_StringOps$();
  var horizontalSpeed = $m_jl_Double$().fS(element.getAttribute("data-horizontal-speed"));
  var componentId = element.getAttribute("data-component-id");
  var hiddenInput = document.getElementById(componentId);
  var onChangeIdO = $m_s_Option$().Z(element.getAttribute("data-on-change-id"));
  var this$21 = $m_sc_StringOps$();
  var x$7 = element.getAttribute("data-update-only-on-drag-end");
  var updateOnlyOnDragEnd = this$21.zW(x$7, x$7);
  var this$23 = $m_sc_StringOps$();
  var x$8 = element.getAttribute("data-show-adjacent-numbers");
  var showAdjacentNumbers = this$23.zW(x$8, x$8);
  var display = $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createElement__T__T__s_Option__Lorg_scalajs_dom_HTMLElement($thiz, "div", "number-display", $m_s_None$());
  var currentValue = $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createElement__T__T__s_Option__Lorg_scalajs_dom_HTMLElement($thiz, "span", "", new $c_s_Some(("" + value)));
  display.appendChild(currentValue);
  if (showAdjacentNumbers) {
    var \u03b41$___1 = $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createAdjacentNumber__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement($thiz, element);
    var \u03b41$___2 = $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createAdjacentNumber__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement($thiz, element);
  } else {
    var \u03b41$___1 = null;
    var \u03b41$___2 = null;
  }
  var adjacentLeft = \u03b41$___1;
  var adjacentRight = \u03b41$___2;
  element.appendChild(display);
  var state = new $c_Lcom_papasofokli_components_ScrollableNumberInputState(element, display, currentValue, adjacentLeft, adjacentRight, value, min, max, verticalIncrement, horizontalIncrement, verticalSpeed, horizontalSpeed, hiddenInput, onChangeIdO, updateOnlyOnDragEnd, false, 0.0, 0.0, 0.0, 0.0, $m_s_None$(), 5);
  $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__updateAdjacentNumbers__Lcom_papasofokli_components_ScrollableNumberInputState__V($thiz, state);
  var handler = new $c_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler(state);
  element.addEventListener("pointerdown", handler.WW, false);
}
function $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createElement__T__T__s_Option__Lorg_scalajs_dom_HTMLElement($thiz, tag, className, text) {
  var el = document.createElement(tag);
  if (($m_sc_StringOps$(), (className !== ""))) {
    el.classList.add(className);
  }
  if ((!text.c())) {
    var x0 = text.h();
    el.textContent = x0;
  }
  return el;
}
function $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createAdjacentNumber__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement($thiz, element) {
  var adjacent = $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__createElement__T__T__s_Option__Lorg_scalajs_dom_HTMLElement($thiz, "div", "adjacent-number", $m_s_None$());
  adjacent.style.opacity = "0.5";
  element.appendChild(adjacent);
  return adjacent;
}
function $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__updateAdjacentNumbers__Lcom_papasofokli_components_ScrollableNumberInputState__V($thiz, state) {
  if (((state.le !== null) && (state.lf !== null))) {
    var value = state.jP;
    var min = state.uW;
    var max = state.uV;
    var horizontalIncrement = state.uU;
    var $x_1 = state.le;
    var a = ((value - horizontalIncrement) | 0);
    $x_1.textContent = ("" + ((a > min) ? a : min));
    var $x_2 = state.lf;
    var a$1 = ((value + horizontalIncrement) | 0);
    $x_2.textContent = ("" + ((a$1 < max) ? a$1 : max));
    var elementHtml = state.Aj;
    var currentValueHtml = state.uR;
    var leftEl = state.le;
    var rightEl = state.lf;
    var containerW = (+elementHtml.offsetWidth);
    var centralW = (+currentValueHtml.offsetWidth);
    var centerX = (0.5 * containerW);
    var centralLeft = (centerX - (0.5 * centralW));
    var centralRight = (centerX + (0.5 * centralW));
    var leftAdjacentRightPosition = (centralLeft - 5.0);
    leftEl.style.right = ((containerW - leftAdjacentRightPosition) + "px");
    leftEl.style.removeProperty("left");
    rightEl.style.left = ((centralRight + 5.0) + "px");
    rightEl.style.removeProperty("right");
  }
}
function $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__setOpacity__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__V($thiz, negative, positive, delta) {
  if (((negative !== null) && (positive !== null))) {
    if ((delta > 0.0)) {
      var \u03b42$___1 = "0.2";
      var \u03b42$___2 = "0.8";
    } else {
      var \u03b42$___1 = "0.8";
      var \u03b42$___2 = "0.2";
    }
    var neg = \u03b42$___1;
    var pos = \u03b42$___2;
    negative.style.opacity = neg;
    positive.style.opacity = pos;
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_ScrollableNumberInputJS$() {
}
$p = $c_Lcom_papasofokli_components_ScrollableNumberInputJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_ScrollableNumberInputJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_ScrollableNumberInputJS$() {
}
$h_Lcom_papasofokli_components_ScrollableNumberInputJS$.prototype = $p;
$p.co = (function() {
  var elements = document.querySelectorAll(".cc1bd2db-adda-41fc-90ef-7f8366df9380");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    matchResult1: {
      if ((x0 !== null)) {
        $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__initializeScrollableNumberInput__Lorg_scalajs_dom_Element__V(this, x0);
        break matchResult1;
      }
      if ((x0 === null)) {
        break matchResult1;
      }
      throw new $c_s_MatchError(x0);
    }
  }
});
$p.afW = (function(id, value) {
  var this$2 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id$1 = $m_ju_UUID$().aO(id);
  var executionContext = $m_s_concurrent_ExecutionContext$().ahB();
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$2, id$1.g(), value, executionContext);
});
$p.anM = (function(state, x, y, mode) {
  var display = state.uS;
  if ((mode === "horizontal")) {
    var diff = (x - state.p3);
    var a = (0.5 * diff);
    var a$1 = (+Math.max(a, (-20.0)));
    var tx = (+Math.min(a$1, 20.0));
    display.style.transform = (("translateX(" + tx) + "px)");
    $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__setOpacity__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__D__V(this, state.le, state.lf, diff);
  } else if ((mode === "vertical")) {
    var diff$2 = (y - state.p4);
    var a$2 = (0.5 * diff$2);
    var a$3 = (+Math.max(a$2, (-20.0)));
    var ty = (+Math.min(a$3, 20.0));
    display.style.transform = (("translateY(" + ty) + "px)");
  }
});
$p.afX = (function(state, newValue) {
  var b = state.uW;
  var a = ((newValue > b) ? newValue : b);
  var b$1 = state.uV;
  var bounded = ((a < b$1) ? a : b$1);
  if ((bounded !== state.jP)) {
    state.jP = bounded;
    state.uR.textContent = ("" + bounded);
    state.uT.value = ("" + bounded);
    $p_Lcom_papasofokli_components_ScrollableNumberInputJS$__updateAdjacentNumbers__Lcom_papasofokli_components_ScrollableNumberInputState__V(this, state);
    if ((!state.v0)) {
      var this$5 = state.uX;
      if ((!this$5.c())) {
        this.afW(this$5.h(), ("" + bounded));
      }
    }
  }
});
$p.anL = (function(state) {
  state.uS.style.transform = "translate(0, 0)";
  if (((state.le !== null) && (state.lf !== null))) {
    var this$1 = new $c_sci_$colon$colon(state.le, new $c_sci_$colon$colon(state.lf, $m_sci_Nil$()));
    var these = this$1;
    while ((!these.c())) {
      var x0 = these.W();
      x0.style.opacity = "0.5";
      these = these.ak();
    }
  }
});
var $d_Lcom_papasofokli_components_ScrollableNumberInputJS$ = new $TypeData().i($c_Lcom_papasofokli_components_ScrollableNumberInputJS$, "com.papasofokli.components.ScrollableNumberInputJS$", ({
  l4: 1
}));
var $n_Lcom_papasofokli_components_ScrollableNumberInputJS$;
function $m_Lcom_papasofokli_components_ScrollableNumberInputJS$() {
  if ((!$n_Lcom_papasofokli_components_ScrollableNumberInputJS$)) {
    $n_Lcom_papasofokli_components_ScrollableNumberInputJS$ = new $c_Lcom_papasofokli_components_ScrollableNumberInputJS$();
  }
  return $n_Lcom_papasofokli_components_ScrollableNumberInputJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler(state) {
  this.WW = null;
  this.NR = null;
  this.EM = null;
  this.WW = ((event$3) => {
    state.r4 = true;
    state.uY = (+event$3.clientX);
    state.uZ = (+event$3.clientY);
    state.p3 = (+event$3.clientX);
    state.p4 = (+event$3.clientY);
    state.n0 = $m_s_None$();
    document.addEventListener("pointermove", this.NR, false);
    document.addEventListener("pointerup", this.EM, false);
    document.addEventListener("pointercancel", this.EM, false);
    event$3.preventDefault();
  });
  this.NR = ((event$3$1) => {
    if (state.r4) {
      var clientX = (+event$3$1.clientX);
      var clientY = (+event$3$1.clientY);
      if (state.n0.c()) {
        var a = (clientX - state.uY);
        var deltaX = (+Math.abs(a));
        var a$1 = (clientY - state.uZ);
        var deltaY = (+Math.abs(a$1));
        if (((+Math.max(deltaX, deltaY)) > state.Ai)) {
          state.n0 = new $c_s_Some(((deltaX > deltaY) ? "horizontal" : "vertical"));
        }
      }
      var this$7 = state.n0;
      if ((!this$7.c())) {
        var x0 = this$7.h();
        $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().anM(state, clientX, clientY, x0);
        if ((x0 === "horizontal")) {
          var deltaX$1 = (clientX - state.p3);
          var a$2 = (10.0 / state.Ak);
          var $x_1 = $m_RTLong$().jq((+Math.round(a$2)));
          var x_$_lo = $x_1.l;
          var x_$_hi = $x_1.h;
          var movementThreshold = ((x_$_lo < 1) ? 1 : x_$_lo);
          if (((+Math.abs(deltaX$1)) > movementThreshold)) {
            var change = Math.imul($doubleToInt(((deltaX$1 > 0.0) ? 1.0 : ((deltaX$1 < 0.0) ? (-1.0) : deltaX$1))), state.uU);
            $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().afX(state, ((state.jP + change) | 0));
            state.p3 = clientX;
          }
        } else if ((x0 === "vertical")) {
          var deltaY$1 = (clientY - state.p4);
          var a$3 = (10.0 / state.Am);
          var $x_2 = $m_RTLong$().jq((+Math.round(a$3)));
          var x$1_$_lo = $x_2.l;
          var x$1_$_hi = $x_2.h;
          var movementThreshold$2 = ((x$1_$_lo < 1) ? 1 : x$1_$_lo);
          if (((+Math.abs(deltaY$1)) > movementThreshold$2)) {
            var change$2 = ((-Math.imul($doubleToInt(((deltaY$1 > 0.0) ? 1.0 : ((deltaY$1 < 0.0) ? (-1.0) : deltaY$1))), state.Al)) | 0);
            $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().afX(state, ((state.jP + change$2) | 0));
            state.p4 = clientY;
          }
        }
      }
      event$3$1.preventDefault();
    }
  });
  this.EM = ((event$3$2) => {
    state.r4 = false;
    state.n0 = $m_s_None$();
    $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().anL(state);
    if ((state.v0 || (state.jP !== ($m_sc_StringOps$(), $m_jl_Integer$().c7(state.uT.value, 10, 214748364))))) {
      var this$22 = state.uX;
      if ((!this$22.c())) {
        $m_Lcom_papasofokli_components_ScrollableNumberInputJS$().afW(this$22.h(), ("" + state.jP));
      }
    }
    document.removeEventListener("pointermove", this.NR);
    document.removeEventListener("pointerup", this.EM);
    document.removeEventListener("pointercancel", this.EM);
    event$3$2.preventDefault();
  });
}
$p = $c_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler;
/** @constructor */
function $h_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler() {
}
$h_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler.prototype = $p;
var $d_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler = new $TypeData().i($c_Lcom_papasofokli_components_ScrollableNumberInputJS$InputHandler, "com.papasofokli.components.ScrollableNumberInputJS$InputHandler", ({
  l5: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_components_StyleJs$() {
}
$p = $c_Lcom_papasofokli_components_StyleJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_StyleJs$;
/** @constructor */
function $h_Lcom_papasofokli_components_StyleJs$() {
}
$h_Lcom_papasofokli_components_StyleJs$.prototype = $p;
$p.co = (function() {
  var element = document.querySelectorAll(".bd64d876-67d0-41ef-a138-095c216abd6c");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    $m_Lcom_papasofokli_classes_custom_DynamicClass$().WP.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0) => ((dc$3) => {
      this.an6(x0, dc$3);
    }))(x0)));
    x0.classList.remove("bd64d876-67d0-41ef-a138-095c216abd6c");
  }
});
$p.an6 = (function(element, dynamic) {
  var att = dynamic.oI();
  if ((($m_sc_StringOps$(), (att !== "")) && (!(!element.hasAttribute(att))))) {
    var value = element.getAttribute(att);
    element.classList.add(dynamic.gH());
    var \u03b41$ = element.style;
    \u03b41$.setProperty(dynamic.kG(), value);
  }
});
var $d_Lcom_papasofokli_components_StyleJs$ = new $TypeData().i($c_Lcom_papasofokli_components_StyleJs$, "com.papasofokli.components.StyleJs$", ({
  l6: 1
}));
var $n_Lcom_papasofokli_components_StyleJs$;
function $m_Lcom_papasofokli_components_StyleJs$() {
  if ((!$n_Lcom_papasofokli_components_StyleJs$)) {
    $n_Lcom_papasofokli_components_StyleJs$ = new $c_Lcom_papasofokli_components_StyleJs$();
  }
  return $n_Lcom_papasofokli_components_StyleJs$;
}
function $p_Lcom_papasofokli_components_SwipeableMenuListJS$__initializeSwipeableMenuList__Lorg_scalajs_dom_Element__V($thiz, element) {
  element.classList.remove("f8e2b4d3-9c1a-4f7e-b5d6-7a3c8e9f0d2b");
  $m_sc_StringOps$();
  var threshold = $m_jl_Integer$().c7(element.getAttribute("data-threshold"), 10, 214748364);
  $m_sc_StringOps$();
  var maxSwipeRatio = $m_jl_Double$().fS(element.getAttribute("data-max-swipe-ratio"));
  $m_sc_StringOps$();
  var iconFadeFactor = $m_jl_Integer$().c7(element.getAttribute("data-icon-fade-factor"), 10, 214748364);
  $m_sc_StringOps$();
  var bgFadeFactor = $m_jl_Integer$().c7(element.getAttribute("data-bg-fade-factor"), 10, 214748364);
  var this$13 = $m_sc_StringOps$();
  var x$4 = element.getAttribute("data-remove-on-action");
  var removeOnAction = this$13.zW(x$4, x$4);
  var menuItems = element.querySelectorAll(".swipeable-menu-item");
  var handler = new $c_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler(threshold, maxSwipeRatio, iconFadeFactor, bgFadeFactor, removeOnAction);
  var this$15 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(menuItems);
  var it = this$15.l();
  while (it.f()) {
    var x0 = it.e();
    matchResult2: {
      if ((x0 !== null)) {
        handler.auV(x0);
        break matchResult2;
      }
      if ((x0 === null)) {
        break matchResult2;
      }
      throw new $c_s_MatchError(x0);
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_SwipeableMenuListJS$() {
}
$p = $c_Lcom_papasofokli_components_SwipeableMenuListJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_SwipeableMenuListJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_SwipeableMenuListJS$() {
}
$h_Lcom_papasofokli_components_SwipeableMenuListJS$.prototype = $p;
$p.co = (function() {
  var elements = document.querySelectorAll(".f8e2b4d3-9c1a-4f7e-b5d6-7a3c8e9f0d2b");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    matchResult1: {
      if ((x0 !== null)) {
        $p_Lcom_papasofokli_components_SwipeableMenuListJS$__initializeSwipeableMenuList__Lorg_scalajs_dom_Element__V(this, x0);
        break matchResult1;
      }
      if ((x0 === null)) {
        break matchResult1;
      }
      throw new $c_s_MatchError(x0);
    }
  }
});
$p.anN = (function(id) {
  var this$2 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id$1 = $m_ju_UUID$().aO(id);
  var executionContext = $m_s_concurrent_ExecutionContext$().ahB();
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$2, id$1.g(), "", executionContext);
});
var $d_Lcom_papasofokli_components_SwipeableMenuListJS$ = new $TypeData().i($c_Lcom_papasofokli_components_SwipeableMenuListJS$, "com.papasofokli.components.SwipeableMenuListJS$", ({
  l7: 1
}));
var $n_Lcom_papasofokli_components_SwipeableMenuListJS$;
function $m_Lcom_papasofokli_components_SwipeableMenuListJS$() {
  if ((!$n_Lcom_papasofokli_components_SwipeableMenuListJS$)) {
    $n_Lcom_papasofokli_components_SwipeableMenuListJS$ = new $c_Lcom_papasofokli_components_SwipeableMenuListJS$();
  }
  return $n_Lcom_papasofokli_components_SwipeableMenuListJS$;
}
function $p_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler__performAction__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__T__T__V($thiz, item, content, direction, actionId) {
  var width = (+content.offsetWidth);
  content.style.transform = (("translateX(" + ((direction === "right") ? width : (-width))) + "px)");
  $m_Lcom_papasofokli_components_SwipeableMenuListJS$().anN(actionId);
  if ($thiz.X0) {
    $m_sjs_js_timers_package$().gb(220.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      item.style.height = ((+item.offsetHeight) + "px");
      item.style.overflow = "hidden";
      item.style.transition = "height 0.28s ease, opacity 0.28s ease";
      window.requestAnimationFrame(((_$9$3) => (window.requestAnimationFrame(((_$10$3) => {
        item.style.height = "0";
        item.style.opacity = "0";
        item.style.marginBottom = "0";
      })) | 0)));
      $m_sjs_js_timers_package$().gb(320.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        item.remove();
      })));
    })));
  } else {
    $m_sjs_js_timers_package$().gb(300.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      content.style.transform = "translateX(0)";
      content.style.transition = "transform 0.25s ease";
    })));
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler(threshold, maxSwipeRatio, iconFadeFactor, bgFadeFactor, removeOnAction) {
  this.NS = 0;
  this.WZ = 0.0;
  this.WY = 0;
  this.WX = 0;
  this.X0 = false;
  this.NS = threshold;
  this.WZ = maxSwipeRatio;
  this.WY = iconFadeFactor;
  this.WX = bgFadeFactor;
  this.X0 = removeOnAction;
}
$p = $c_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler;
/** @constructor */
function $h_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler() {
}
$h_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler.prototype = $p;
$p.auV = (function(item) {
  var content = item.querySelector(".swipeable-content");
  var leftOverlay = item.querySelector(".swipe-gradient.left");
  var rightOverlay = item.querySelector(".swipe-gradient.right");
  var this$1 = $m_s_Option$().Z(leftOverlay);
  if (this$1.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.h();
    var $x_1 = $m_s_Option$().Z(x0.querySelector("i"));
  }
  var this$2 = $x_1;
  var leftIcon = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.h()));
  var this$4 = $m_s_Option$().Z(rightOverlay);
  if (this$4.c()) {
    var $x_2 = $m_s_None$();
  } else {
    var x0$2 = this$4.h();
    var $x_2 = $m_s_Option$().Z(x0$2.querySelector("i"));
  }
  var this$5 = $x_2;
  var rightIcon = (this$5.c() ? $m_s_None$() : new $c_s_Some(this$5.h()));
  var leftActionId = $m_s_Option$().Z(item.getAttribute("data-left-action-id"));
  var rightActionId = $m_s_Option$().Z(item.getAttribute("data-right-action-id"));
  var startX = new $c_sr_DoubleRef(0.0);
  var startY = new $c_sr_DoubleRef(0.0);
  var isDragging = new $c_sr_BooleanRef(false);
  var isHorizontalSwipe = new $c_sr_BooleanRef(false);
  var currentDeltaX = new $c_sr_DoubleRef(0.0);
  var b = ((+content.offsetWidth) * this.WZ);
  var maxSwipe = (+Math.max(120.0, b));
  var getX = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    if ((!(!(e$2 instanceof TouchEvent)))) {
      if (((e$2.touches.length | 0) > 0)) {
        return (+e$2.touches[0].clientX);
      }
    }
    if ((!(!(e$2 instanceof MouseEvent)))) {
      return (+e$2.clientX);
    }
    return 0.0;
  }));
  var getY = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2$1) => {
    if ((!(!(e$2$1 instanceof TouchEvent)))) {
      if (((e$2$1.touches.length | 0) > 0)) {
        return (+e$2$1.touches[0].clientY);
      }
    }
    if ((!(!(e$2$1 instanceof MouseEvent)))) {
      return (+e$2$1.clientY);
    }
    return 0.0;
  }));
  var updateOverlay = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var deltaX = (+v1$2);
    var abs = (+Math.abs(deltaX));
    var b$1 = (abs / this.WY);
    var iconOpacity = (+Math.min(1.0, b$1));
    var b$2 = (abs / this.WX);
    var bgOpacity = (+Math.min(1.0, b$2));
    if ((deltaX > 0.0)) {
      if ((leftOverlay !== null)) {
        leftOverlay.style.opacity = ("" + bgOpacity);
      }
      if ((!leftIcon.c())) {
        var x0$4 = leftIcon.h();
        x0$4.style.opacity = ("" + iconOpacity);
      }
      if ((rightOverlay !== null)) {
        rightOverlay.style.opacity = "0";
      }
      if ((!rightIcon.c())) {
        var x0$5 = rightIcon.h();
        x0$5.style.opacity = "0";
      }
    } else if ((deltaX < 0.0)) {
      if ((rightOverlay !== null)) {
        rightOverlay.style.opacity = ("" + bgOpacity);
      }
      if ((!rightIcon.c())) {
        var x0$6 = rightIcon.h();
        x0$6.style.opacity = ("" + iconOpacity);
      }
      if ((leftOverlay !== null)) {
        leftOverlay.style.opacity = "0";
      }
      if ((!leftIcon.c())) {
        var x0$7 = leftIcon.h();
        x0$7.style.opacity = "0";
      }
    } else {
      if ((leftOverlay !== null)) {
        leftOverlay.style.opacity = "0";
      }
      if ((!leftIcon.c())) {
        var x0$8 = leftIcon.h();
        x0$8.style.opacity = "0";
      }
      if ((rightOverlay !== null)) {
        rightOverlay.style.opacity = "0";
      }
      if ((!rightIcon.c())) {
        var x0$9 = rightIcon.h();
        x0$9.style.opacity = "0";
      }
    }
  }));
  var handleStart = ((event$3) => {
    startX.bv = (+getX.p(event$3));
    startY.bv = (+getY.p(event$3));
    isDragging.e1 = true;
    isHorizontalSwipe.e1 = false;
    content.style.transition = "none";
  });
  var handleMove = ((event$3$1) => {
    if (isDragging.e1) {
      var deltaX$1 = ((+getX.p(event$3$1)) - startX.bv);
      var deltaY = ((+getY.p(event$3$1)) - startY.bv);
      if (((!isHorizontalSwipe.e1) && (((+Math.abs(deltaX$1)) > 10.0) || ((+Math.abs(deltaY)) > 10.0)))) {
        isHorizontalSwipe.e1 = ((+Math.abs(deltaX$1)) > (+Math.abs(deltaY)));
      }
      if (isHorizontalSwipe.e1) {
        var a = (-maxSwipe);
        var b$3 = (+Math.min(maxSwipe, deltaX$1));
        currentDeltaX.bv = (+Math.max(a, b$3));
        content.style.transform = (("translateX(" + currentDeltaX.bv) + "px)");
        updateOverlay.p(currentDeltaX.bv);
        event$3$1.preventDefault();
      }
    }
  });
  var handleEnd = ((event$3$2) => {
    if (isDragging.e1) {
      isDragging.e1 = false;
      content.style.transition = "transform 0.25s ease";
      if (isHorizontalSwipe.e1) {
        if (((currentDeltaX.bv > this.NS) && (!leftActionId.c()))) {
          $p_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler__performAction__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__T__T__V(this, item, content, "right", leftActionId.h());
        } else if (((currentDeltaX.bv < ((-this.NS) | 0)) && (!rightActionId.c()))) {
          $p_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler__performAction__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLElement__T__T__V(this, item, content, "left", rightActionId.h());
        } else {
          content.style.transform = "translateX(0)";
          updateOverlay.p(0.0);
        }
        event$3$2.preventDefault();
      } else {
        content.style.transform = "translateX(0)";
        updateOverlay.p(0.0);
      }
    }
  });
  content.addEventListener("mousedown", handleStart, false);
  document.addEventListener("mousemove", handleMove, false);
  document.addEventListener("mouseup", handleEnd, false);
  content.addEventListener("touchstart", handleStart, false);
  content.addEventListener("touchmove", handleMove, false);
  content.addEventListener("touchend", handleEnd, false);
});
var $d_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler = new $TypeData().i($c_Lcom_papasofokli_components_SwipeableMenuListJS$SwipeableMenuHandler, "com.papasofokli.components.SwipeableMenuListJS$SwipeableMenuHandler", ({
  l8: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_components_ToastJS$() {
}
$p = $c_Lcom_papasofokli_components_ToastJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_ToastJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_ToastJS$() {
}
$h_Lcom_papasofokli_components_ToastJS$.prototype = $p;
$p.IZ = (function(text, duration) {
  var element = document.querySelector(".d0d98a57-eafd-4f46-97d9-e05b4a3187a1");
  if ((!(!(element instanceof HTMLDivElement)))) {
    matchResult1: {
      var delay;
      if ((duration instanceof $c_s_Some)) {
        var $x_1 = $uJ(duration.bg);
        var ms_$_lo = $x_1.l;
        var ms_$_hi = $x_1.h;
        var delay = $m_RTLong$().gc(ms_$_lo, ms_$_hi);
        break matchResult1;
      }
      if (($m_s_None$() === duration)) {
        var delay = "0";
        break matchResult1;
      }
      throw new $c_s_MatchError(duration);
    }
    var autoHideStr = ("" + (!duration.c()));
    var closeBtn = $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn-close mb-1 text-white", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "type", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n("button", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "data-bs-dismiss", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n("toast", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "aria-label", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n("close", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8E.by, $m_Lscalatags_JsDom$all$().s)])), $m_sci_Nil$()), $m_s_$less$colon$less$().b0)]));
    var icon = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().a8Q.by + " fa-xl me-2"), $m_Lscalatags_JsDom$all$().s)]));
    var title = $m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("me-auto", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("Warning"))]));
    var header = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(((($m_Lcom_papasofokli_toast_ToastHelper$().a85 + " ") + $m_Lcom_papasofokli_toast_ToastHelper$().a86) + " text-white"), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), new $c_sci_$colon$colon(icon, new $c_sci_$colon$colon(title, new $c_sci_$colon$colon(closeBtn, $m_sci_Nil$()))), $m_s_$less$colon$less$().b0)]));
    var body = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_toast_ToastHelper$().a84, $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text))])), $m_sci_Nil$()), $m_s_$less$colon$less$().b0)]));
    var toastElement = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_toast_ToastHelper$().a83 + " bg-body show b3deebff-1d11-4ffd-8149-8a9881a563f3"), $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_toast_ToastHelper$().Qn, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(delay, $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_toast_ToastHelper$().Qm, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(autoHideStr, $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), new $c_sci_$colon$colon(header, new $c_sci_$colon$colon(body, $m_sci_Nil$())), $m_s_$less$colon$less$().b0)]));
    element.prepend(toastElement.aB());
    this.co();
  }
});
$p.co = (function() {
  var element = document.querySelector(".b3deebff-1d11-4ffd-8149-8a9881a563f3");
  if ((!(!(element instanceof HTMLDivElement)))) {
    element.classList.remove("b3deebff-1d11-4ffd-8149-8a9881a563f3");
    var delayMillisecondsStr = element.getAttribute($m_Lcom_papasofokli_toast_ToastHelper$().Qn);
    var autoHideStr = element.getAttribute($m_Lcom_papasofokli_toast_ToastHelper$().Qm);
    if ($m_sc_StringOps$().zW(autoHideStr, autoHideStr)) {
      (window.setTimeout((() => {
        element.remove();
      }), ($m_sc_StringOps$(), $m_jl_Double$().fS(delayMillisecondsStr))) | 0);
    }
  }
});
var $d_Lcom_papasofokli_components_ToastJS$ = new $TypeData().i($c_Lcom_papasofokli_components_ToastJS$, "com.papasofokli.components.ToastJS$", ({
  la: 1
}));
var $n_Lcom_papasofokli_components_ToastJS$;
function $m_Lcom_papasofokli_components_ToastJS$() {
  if ((!$n_Lcom_papasofokli_components_ToastJS$)) {
    $n_Lcom_papasofokli_components_ToastJS$ = new $c_Lcom_papasofokli_components_ToastJS$();
  }
  return $n_Lcom_papasofokli_components_ToastJS$;
}
function $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__hideContextMenu__Lcom_papasofokli_jquery_JQuery($thiz) {
  $thiz.Ey((-1000), 0);
  return (0, $m_Lcom_papasofokli_jquery_package$().I)($thiz.Jm).html("");
}
function $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__mutatorObserverCallback__sjs_js_Function2($thiz) {
  return ((_$2$3, _$3$3) => {
    if ((($p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).children().length | 0) > 0)) {
      var scroll = Math.fround((0, $m_Lcom_papasofokli_jquery_package$().I)(document).scrollTop());
      var maxLeft = ((+window.innerWidth) - (+$p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).children().innerWidth()));
      var contextMenuHeight = (+$p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).children().innerHeight());
      var maxTop = (((scroll + (+window.innerHeight)) - contextMenuHeight) - 15.0);
      var x = $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).attr("data-page-x");
      var x$1 = ((x === (void 0)) ? (void 0) : ($m_sc_StringOps$(), $m_jl_Float$().gL(x)));
      var leftU = ((x$1 === (void 0)) ? 0.0 : x$1);
      var x$2 = $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).attr("data-page-y");
      var x$3 = ((x$2 === (void 0)) ? (void 0) : ($m_sc_StringOps$(), $m_jl_Float$().gL(x$2)));
      var topU = ((x$3 === (void 0)) ? 0.0 : x$3);
      var a$2 = Math.fround(maxLeft);
      var left = Math.fround((+Math.min(a$2, leftU)));
      var a$3 = Math.fround(maxTop);
      var top = Math.fround((+Math.min(a$3, topU)));
      $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz).each((function() {
        var this$36 = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_StyleValue("top", (Math.fround((top - 10.0)) + "px")), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_StyleValue("left", (Math.fround((left - 10.0)) + "px")), $m_sci_Nil$()));
        var these = this$36;
        while ((!these.c())) {
          these.W().ds(this);
          these = these.ak();
        }
      }));
    }
  });
}
function $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__contextMenuContainer$1__Lcom_papasofokli_jquery_JQuery($thiz) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)($thiz.Jm);
}
/** @constructor */
function $c_Lcom_papasofokli_contextmenu_ContextMenuInitializer$() {
  this.Jm = null;
  this.X3 = null;
  $n_Lcom_papasofokli_contextmenu_ContextMenuInitializer$ = this;
  this.Jm = ".context-menu-container";
  this.X3 = (() => {
    var this$2 = ({});
    this$2.attributes = false;
    this$2.childList = true;
    this$2.subtree = false;
    return this$2;
  })();
}
$p = $c_Lcom_papasofokli_contextmenu_ContextMenuInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_contextmenu_ContextMenuInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_contextmenu_ContextMenuInitializer$() {
}
$h_Lcom_papasofokli_contextmenu_ContextMenuInitializer$.prototype = $p;
$p.av1 = (function() {
  var contextMenu = $m_Lcom_papasofokli_util_package$().fo("29bba887-803c-4226-8b9d-79221fd3fd30");
  return contextMenu.each(((this$1) => (function() {
    var mutatorObserver = new MutationObserver($p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__mutatorObserverCallback__sjs_js_Function2(this$1));
    mutatorObserver.observe(this, this$1.X3);
    contextMenu.on("mouseleave click", $m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__hideContextMenu__Lcom_papasofokli_jquery_JQuery(this$1)))));
    document.body.onclick = ((_$1$2) => $p_Lcom_papasofokli_contextmenu_ContextMenuInitializer$__hideContextMenu__Lcom_papasofokli_jquery_JQuery(this$1));
  }))(this));
});
$p.Ey = (function(pageX, pageY) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(this.Jm).attr("data-page-x", pageX).attr("data-page-y", pageY);
});
var $d_Lcom_papasofokli_contextmenu_ContextMenuInitializer$ = new $TypeData().i($c_Lcom_papasofokli_contextmenu_ContextMenuInitializer$, "com.papasofokli.contextmenu.ContextMenuInitializer$", ({
  lb: 1
}));
var $n_Lcom_papasofokli_contextmenu_ContextMenuInitializer$;
function $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$() {
  if ((!$n_Lcom_papasofokli_contextmenu_ContextMenuInitializer$)) {
    $n_Lcom_papasofokli_contextmenu_ContextMenuInitializer$ = new $c_Lcom_papasofokli_contextmenu_ContextMenuInitializer$();
  }
  return $n_Lcom_papasofokli_contextmenu_ContextMenuInitializer$;
}
function $f_Lcom_papasofokli_dataTables_ScalaJsTableT__$init$__V($thiz) {
  $thiz.XE = "non-freezing-on-loading";
  $thiz.NZ = "data-double-click";
  $thiz.XA = "data-group-expand";
  $thiz.O8 = "data-click";
  $thiz.NW = "data-context-menu";
  $thiz.Xt = "data-help";
  $thiz.Xx = "data-post-reload";
  $thiz.Xw = "data-post-actions";
  $thiz.Xu = "data-init-setup";
  $thiz.EP = "data-top-row-id";
  $thiz.XF = "data-page-id";
  $thiz.O7 = "data-show-id";
  $thiz.XD = "data-lazy-load";
  $thiz.Ju = "data-sticky-cols";
  $thiz.NX = "data-table-id";
  $thiz.Xv = "data-lp";
  $thiz.r8 = "data-sort-index";
  $thiz.p8 = "data-sort-direction";
  $thiz.O1 = "data-icon-sort-index";
  $thiz.XC = "data-icon-group-index";
  $thiz.r7 = "data-search-index";
  $thiz.v9 = "data-group-calculation";
  $thiz.r9 = "date-group-type";
  $thiz.Jw = "tabindex";
  $thiz.Ob = "data-table-grouped";
  $thiz.EN = "data-group-level";
  $thiz.Xr = "data-chart-request";
  $thiz.O0 = "data-export-request";
  $thiz.Jv = "sub-group-row";
  $thiz.O9 = "sub-table-row";
  $thiz.v8 = "group-by";
  $thiz.Ap = "data-group-order";
  $thiz.Aq = "expanded";
  $thiz.NY = "dateGroupTypes";
  $thiz.Jq = "data-row-level";
  $thiz.Js = "fa-arrow-up-arrow-down";
  $thiz.Jr = "fa-arrow-up-short-wide";
  $thiz.Jt = "fa-arrow-down-short-wide";
  $thiz.Jp = "group-option-btn";
  $thiz.Xz = "export-option-btn";
  $thiz.Xn = "aggregation-option-check";
  $thiz.Jn = "aggregation-option-block";
  $thiz.XH = "btn-switch";
  $thiz.Jx = "table-panel";
  $thiz.Oc = "main";
  $thiz.XI = "side";
  $thiz.EO = "collapsed";
  $thiz.Ar = "expanded";
  $thiz.Xy = "export-group-detail-rows";
  $thiz.O3 = "not-init-sorting";
  $thiz.O2 = "not-init-grouping";
  $thiz.Xp = "cell-highlight-transition";
  $thiz.Xo = "cell-additional-transition";
  $thiz.As = "table-reload-transition";
  $thiz.O6 = "search-input";
  $thiz.Xq = "cell-initial-width";
  $thiz.Oa = "table-cell-size";
  $thiz.Xm = "li.active";
  $thiz.v7 = 10;
  $thiz.Jo = 120;
  $thiz.XB = "Icon code";
  $thiz.XG = 0;
  $thiz.O5 = 1;
  $thiz.O4 = 2;
  $thiz.NU = "...";
}
var $d_Lcom_papasofokli_dataTables_TableCellData = new $TypeData().i(1, "com.papasofokli.dataTables.TableCellData", ({
  b9: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableFunctions$() {
}
$p = $c_Lcom_papasofokli_dataTables_TableFunctions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableFunctions$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableFunctions$() {
}
$h_Lcom_papasofokli_dataTables_TableFunctions$.prototype = $p;
$p.ave = (function(tableId, position, noOfColumns, rowContent, collapseExpandedRows) {
  if (collapseExpandedRows) {
    this.afV(tableId, "expanded-row");
  }
  var table = document.getElementById(tableId);
  var newRow = table.insertRow(((1 + position) | 0));
  newRow.classList.add("expanded-row");
  var cell = newRow.insertCell(0);
  cell.setAttribute("colspan", ("" + noOfColumns));
  cell.innerHTML = rowContent;
});
$p.afV = (function(tableId, cssClass) {
  var table = document.getElementById(tableId);
  $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(table.querySelectorAll(("." + cssClass))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$3) => {
    table.deleteRow((r$3.rowIndex | 0));
  })));
});
var $d_Lcom_papasofokli_dataTables_TableFunctions$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableFunctions$, "com.papasofokli.dataTables.TableFunctions$", ({
  m7: 1
}));
var $n_Lcom_papasofokli_dataTables_TableFunctions$;
function $m_Lcom_papasofokli_dataTables_TableFunctions$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableFunctions$)) {
    $n_Lcom_papasofokli_dataTables_TableFunctions$ = new $c_Lcom_papasofokli_dataTables_TableFunctions$();
  }
  return $n_Lcom_papasofokli_dataTables_TableFunctions$;
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__applyCellStyleF__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, cellStyleApplyFunction, executionContext) {
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(cellStyleApplyFunction, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    var data = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_List$())));
    var f = ((_$2$2) => (!_$2$2.n8.c()));
    _return: {
      var result;
      var l$tailLocal1 = data;
      while (true) {
        if (l$tailLocal1.c()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h = l$tailLocal1.W();
          var t = l$tailLocal1.ak();
          if ((!(!(!f(h))))) {
            l$tailLocal1 = t;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t;
          while (true) {
            if (remaining$tailLocal1.c()) {
              var result = start;
              break _return;
            } else {
              var x = remaining$tailLocal1.W();
              if ((!(!f(x)))) {
                remaining$tailLocal1 = remaining$tailLocal1.ak();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
              var toProcess = start.ak();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
                currentLast.bz = newElem;
                currentLast = newElem;
                toProcess = toProcess.ak();
              }
              var next = firstMiss.ak();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.W();
                if ((!(!f(head)))) {
                  next = next.ak();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                    currentLast.bz = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.ak();
                  }
                  nextToCopy = next.ak();
                  next = next.ak();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.bz = nextToCopy;
              }
              var result = newHead;
              break _return;
            }
          }
        }
      }
    }
    var these = result;
    while ((!these.c())) {
      var x0 = these.W();
      var $x_1 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x0.XM));
      var this$9 = x0.n8;
      $x_1.html((this$9.c() ? "" : this$9.h()));
      these = these.ak();
    }
  })), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__tableCellRequest__T__Lorg_scalajs_dom_HTMLTableCellElement__T__Z__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, tableCell, functionId, isSimpleTable, executionContext) {
  var column = (tableCell.cellIndex | 0);
  if ((!isSimpleTable)) {
    var table = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + tableId)).DataTable();
    var row = table.row(tableCell);
    var rowData = row.data();
    if ((rowData !== (void 0))) {
      if ((rowData === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      return $p_Lcom_papasofokli_dataTables_TableInitialize$__dataTableAjaxRequest__T__I__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, functionId, column, $m_sjs_js_ArrayOps$().UC(rowData), executionContext);
    } else {
      $m_s_Console$().J1().zO("row data not retrieved from event target\n");
      return $m_s_concurrent_Future$().aE((void 0));
    }
  } else {
    return $p_Lcom_papasofokli_dataTables_TableInitialize$__simpleTableAjaxRequest__O__I__O__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, functionId, column, tableCell.parentElement.id, executionContext);
  }
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__dataTableAjaxRequest__T__I__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, functionId, column, firstColumnTextContent, executionContext) {
  try {
    var $x_1 = new $c_s_util_Success(firstColumnTextContent);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  return $x_1.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => {
    var pickle = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_dataTables_TableCellS($m_ju_UUID$().aO(firstColumnTextContent), column, $m_s_None$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableCellS$().q());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(functionId).g(), pickle, executionContext);
  }))).Uu(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_s_concurrent_Future$().aE((void 0)))));
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__simpleTableAjaxRequest__O__I__O__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, functionId, column, rowUUID, executionContext) {
  if (((rowUUID !== (void 0)) && (functionId !== (void 0)))) {
    var $x_1 = $m_Lupickle_default$();
    if ((rowUUID === (void 0))) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    }
    var pickle = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, new $c_Lcom_papasofokli_dataTables_SimpleTableCellS($m_ju_UUID$().aO(rowUUID), column, $m_s_None$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_SimpleTableCellS$().q());
    var $x_2 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    if ((functionId === (void 0))) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    }
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($x_2, $m_ju_UUID$().aO(functionId).g(), pickle, executionContext);
  } else {
    return $m_s_concurrent_Future$().aE((void 0));
  }
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__inBufferTime__Z($thiz) {
  var $x_1 = $ct_ju_Date__(new $c_ju_Date());
  var after_$_lo = $x_1.hG;
  var after_$_hi = $x_1.hH;
  var x_$_lo = $thiz.To;
  var x_$_hi = $thiz.Tp;
  var lo = ((after_$_lo - x_$_lo) | 0);
  var hi = ((((after_$_hi - x_$_hi) | 0) - (((lo >>> 0) > (after_$_lo >>> 0)) | 0)) | 0);
  if (((hi === 0) ? ((lo >>> 0) < 300) : (hi < 0))) {
    return true;
  } else {
    $thiz.To = after_$_lo;
    $thiz.Tp = after_$_hi;
    return false;
  }
}
function $p_Lcom_papasofokli_dataTables_TableInitialize$__mouseEventFun__T__O__O__O__Z__Lcom_papasofokli_jquery_JQueryEventObject__s_concurrent_ExecutionContext__V($thiz, tableId, clickFunction, doubleClickFunction, contextMenuFunction, isSimpleTable, event, executionContext) {
  var target = event.target;
  try {
    var $x_1 = new $c_s_util_Success(((target.tagName === "TD") ? target : $m_sjs_js_ArrayOps$().UC((0, $m_Lcom_papasofokli_jquery_package$().I)(target).parent("td").toArray())));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  $x_1.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cell$2) => {
    var x3$1 = event.type;
    if ((x3$1 === "dblclick")) {
      if ((doubleClickFunction !== (void 0))) {
        $m_sc_StringOps$();
        if ((doubleClickFunction === (void 0))) {
          throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
        }
        var $x_3 = (doubleClickFunction !== "");
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var $x_2 = (!$p_Lcom_papasofokli_dataTables_TableInitialize$__inBufferTime__Z($thiz));
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var freezePage = new $c_Lcom_papasofokli_util_FreezePage(300, 0, executionContext);
      event.preventDefault();
      if ((doubleClickFunction === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      $p_Lcom_papasofokli_dataTables_TableInitialize$__tableCellRequest__T__Lorg_scalajs_dom_HTMLTableCellElement__T__Z__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, cell$2, doubleClickFunction, isSimpleTable, executionContext).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
        freezePage.ep().zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => (void 0))), executionContext);
      })), executionContext);
      return (void 0);
    }
    if ((x3$1 === "contextmenu")) {
      if ((contextMenuFunction !== (void 0))) {
        $m_sc_StringOps$();
        if ((contextMenuFunction === (void 0))) {
          throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
        }
        var $x_5 = (contextMenuFunction !== "");
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        var $x_4 = (!$p_Lcom_papasofokli_dataTables_TableInitialize$__inBufferTime__Z($thiz));
      } else {
        var $x_4 = false;
      }
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      event.preventDefault();
      var this$30 = $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$();
      var f = (() => event);
      this$30.Ey((f().pageX | 0), (f().pageY | 0));
      if ((contextMenuFunction === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      return $p_Lcom_papasofokli_dataTables_TableInitialize$__tableCellRequest__T__Lorg_scalajs_dom_HTMLTableCellElement__T__Z__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, cell$2, contextMenuFunction, isSimpleTable, executionContext);
    }
    if ((x3$1 === "click")) {
      if ((clickFunction !== (void 0))) {
        $m_sc_StringOps$();
        if ((clickFunction === (void 0))) {
          throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
        }
        var $x_7 = (clickFunction !== "");
      } else {
        var $x_7 = false;
      }
      if ($x_7) {
        var $x_6 = (!$p_Lcom_papasofokli_dataTables_TableInitialize$__inBufferTime__Z($thiz));
      } else {
        var $x_6 = false;
      }
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      event.preventDefault();
      if ((clickFunction === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
      }
      return $p_Lcom_papasofokli_dataTables_TableInitialize$__tableCellRequest__T__Lorg_scalajs_dom_HTMLTableCellElement__T__Z__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, cell$2, clickFunction, isSimpleTable, executionContext);
    }
  })));
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableInitialize$() {
  this.To = 0;
  this.Tp = 0;
  $n_Lcom_papasofokli_dataTables_TableInitialize$ = this;
  var $x_1 = $ct_ju_Date__(new $c_ju_Date());
  this.To = $x_1.hG;
  this.Tp = $x_1.hH;
}
$p = $c_Lcom_papasofokli_dataTables_TableInitialize$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableInitialize$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableInitialize$() {
}
$h_Lcom_papasofokli_dataTables_TableInitialize$.prototype = $p;
$p.av6 = (function(executionContext) {
  return $m_Lcom_papasofokli_util_package$().Eg("not-initialized-simple-table", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => {
    var clickFunction = e$3.getAttribute("data-click");
    var doubleClickFunction = e$3.getAttribute("data-double-click");
    var contextMenuFunction = e$3.getAttribute("data-context-menu");
    var cellStyleApplyFunction = e$3.getAttribute("data-post-actions");
    var mouseEventFun = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
      var tableId$1 = e$3.id;
      $p_Lcom_papasofokli_dataTables_TableInitialize$__mouseEventFun__T__O__O__O__Z__Lcom_papasofokli_jquery_JQueryEventObject__s_concurrent_ExecutionContext__V($m_Lcom_papasofokli_dataTables_TableInitialize$(), tableId$1, clickFunction, doubleClickFunction, contextMenuFunction, true, _$1$3, executionContext);
    }));
    (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + e$3.id) + " td")).on("contextmenu dblclick click", $m_sjs_js_Any$().b3(mouseEventFun));
    if (($m_sc_StringOps$(), ($f_T__trim__T(cellStyleApplyFunction) !== ""))) {
      $p_Lcom_papasofokli_dataTables_TableInitialize$__applyCellStyleF__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, cellStyleApplyFunction, executionContext);
    } else {
      $m_s_concurrent_Future$().aE((void 0));
    }
  })));
});
var $d_Lcom_papasofokli_dataTables_TableInitialize$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableInitialize$, "com.papasofokli.dataTables.TableInitialize$", ({
  me: 1
}));
var $n_Lcom_papasofokli_dataTables_TableInitialize$;
function $m_Lcom_papasofokli_dataTables_TableInitialize$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableInitialize$)) {
    $n_Lcom_papasofokli_dataTables_TableInitialize$ = new $c_Lcom_papasofokli_dataTables_TableInitialize$();
  }
  return $n_Lcom_papasofokli_dataTables_TableInitialize$;
}
function $f_Lcom_papasofokli_datetimePicker_TempusDominusT__$init$__V($thiz) {
  $thiz.NT = "not-initialized-datetime";
  $thiz.X2 = $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2("data-td-target-input", "nearest"), new $c_T2("data-td-target-toggle", "nearest")]));
  new $c_sci_$colon$colon("data-td-toggle=datetimepicker", $m_sci_Nil$());
}
function $p_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$__dbFieldMatcher__T__F1($thiz, fieldText) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((fieldR) => ((dbField$2) => {
    var x1 = fieldR.atW(dbField$2.toLowerCase());
    if (($m_s_None$() === x1)) {
      return false;
    }
    if ((x1 instanceof $c_s_Some)) {
      return true;
    }
    throw new $c_s_MatchError(x1);
  }))($m_sc_StringOps$().Va(("^" + fieldText.toLowerCase()))));
}
/** @constructor */
function $c_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$() {
}
$p = $c_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$;
/** @constructor */
function $h_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$() {
}
$h_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$.prototype = $p;
$p.ayi = (function(options, autocomplete, response) {
  var fieldText = $dp_toString__T((0, $m_Lcom_papasofokli_jquery_package$().I)(autocomplete.element).data("fieldText"));
  var matcher = $p_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$__dbFieldMatcher__T__F1(this, fieldText);
  var matchingDbFields = options.bB(matcher);
  response($m_sjs_js_JSConverters$JSRichIterableOnce$().hP(matchingDbFields));
});
$p.axL = (function(element, event) {
  var caretAt = (element.selectionStart | 0);
  var this$1 = element.value;
  var searchableText = this$1.substring(0, caretAt);
  var lastOpenAngle = (searchableText.lastIndexOf("{") | 0);
  if ((!((lastOpenAngle >= 0) && ((searchableText.indexOf("}", lastOpenAngle) | 0) < 0)))) {
    event.preventDefault();
    event.stopPropagation();
  } else {
    var $x_1 = (0, $m_Lcom_papasofokli_jquery_package$().I)(element);
    var beginIndex = ((1 + lastOpenAngle) | 0);
    $x_1.data("fieldText", searchableText.substring(beginIndex));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(element).data("caretAt", caretAt);
    (0, $m_Lcom_papasofokli_jquery_package$().I)(element).data("lastOpenAngle", lastOpenAngle);
  }
});
$p.au1 = (function(element, event) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(element);
  event.preventDefault();
});
$p.axN = (function(element, event, ui) {
  $m_sc_StringOps$();
  var caretAt = $m_jl_Integer$().c7($dp_toString__T((0, $m_Lcom_papasofokli_jquery_package$().I)(element).data("caretAt")), 10, 214748364);
  $m_sc_StringOps$();
  var lastOpenAngle = $m_jl_Integer$().c7($dp_toString__T((0, $m_Lcom_papasofokli_jquery_package$().I)(element).data("lastOpenAngle")), 10, 214748364);
  var this$7 = element.value;
  var textAfter = this$7.substring(caretAt);
  var this$10 = element.value;
  var textBefore = this$10.substring(0, lastOpenAngle);
  event.preventDefault();
  element.value = ((((textBefore + "{") + ui.item.value) + "}") + textAfter);
});
$p.auX = (function(ec) {
  var autocompleteInputs = (0, $m_Lcom_papasofokli_jquery_package$().I)(".radiant-autocomplete");
  if (((autocompleteInputs.length | 0) > 0)) {
    var parent = autocompleteInputs.parent(".form-group");
    var firstInput = autocompleteInputs.get(0);
    var optionsFunctionId = firstInput.getAttribute("data-autocomplete");
    parent.addClass("ui-front");
    $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(optionsFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      var options = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
      var autocompleteSettings = new ($a_Lcom_papasofokli_jquery_AutocompleteSettings())(((this$2) => (function(_$1$3, res$3) {
        this$2.ayi(options, this, res$3);
      }))(this), ((this$2) => (function(event$3, _$2$3) {
        this$2.axL(this, event$3);
      }))(this), ((this$2) => (function(event$3$1, _$3$3) {
        this$2.au1(this, event$3$1);
      }))(this), ((this$2) => (function(event$3$2, ui$3) {
        this$2.axN(this, event$3$2, ui$3);
      }))(this), true);
      autocompleteInputs.autocomplete(autocompleteSettings);
      autocompleteInputs.removeClass("radiant-autocomplete");
    })), ec))), ec);
  }
});
var $d_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$ = new $TypeData().i($c_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$, "com.papasofokli.docgenerator.DataBaseFieldsAutoCompleteJS$", ({
  mn: 1
}));
var $n_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$;
function $m_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$() {
  if ((!$n_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$)) {
    $n_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$ = new $c_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$();
  }
  return $n_Lcom_papasofokli_docgenerator_DataBaseFieldsAutoCompleteJS$;
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__updateIconNotification__I__ju_UUID__V($thiz, number, id) {
  var bell = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id)).parent().children(0);
  var numberSpan = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  if (((numberSpan.text() === "") || (($m_sc_StringOps$(), $m_jl_Integer$().c7(numberSpan.text(), 10, 214748364)) !== number))) {
    bell.get(0).classList.remove("notification-icon-ring");
    if ((number > 0)) {
      bell.get(0).classList.add("notification-icon-ring");
      bell.get(0).outerHTML = bell.get(0).outerHTML;
      numberSpan.fadeOut("fast");
      numberSpan.fadeIn("medium");
      numberSpan.text(("" + number));
      numberSpan.show();
    } else {
      numberSpan.text("0");
      var \u03b42$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
      \u03b42$.hide();
    }
  }
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__toggleNotificationDropdown__ju_UUID__V($thiz, id) {
  var element = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  if ((!(!element.hasClass("open")))) {
    element.removeClass("open");
  } else {
    element.addClass("open");
  }
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceElementsWithIdSmoothly__ju_UUID__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, id, html, executionContext) {
  var jquery = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  var scalaPromise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var \u03b45$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id)).fadeOut("fast", $m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__callback$1__Lcom_papasofokli_jquery_JQuery__T__s_concurrent_ExecutionContext__V($thiz, jquery, html, executionContext);
  }))));
  \u03b45$.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise, (void 0))))));
  return scalaPromise;
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceElementContentsById__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, id, html, executionContext) {
  return $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceContentsBySelector__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, html, ("#" + id), executionContext);
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceContentsBySelector__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, html, selector, executionContext) {
  var jquery = (0, $m_Lcom_papasofokli_jquery_package$().I)(selector);
  var scalaPromise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var \u03b44$ = jquery.fadeOut("fast", $m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__callback$2__Lcom_papasofokli_jquery_JQuery__T__s_concurrent_ExecutionContext__V($thiz, jquery, html, executionContext);
  }))));
  var \u03b45$ = \u03b44$.fadeIn("fast");
  \u03b45$.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise, (void 0))))));
  return scalaPromise;
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__download__T__T__Lorg_scalajs_dom_Node($thiz, filename, url) {
  var element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  return document.body.removeChild(element);
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__calculateDropdownPosition__T__s_concurrent_Future($thiz, id) {
  var dropdownMenu = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  dropdownMenu.each((function() {
    return $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdownMenu__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, dropdownMenu);
  }));
  return $m_s_concurrent_Future$().aE((void 0));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdownMenu__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, dropdownMenu) {
  var dropdownContainer = dropdownMenu.parent();
  return dropdownContainer.each((function() {
    return $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdown__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, this, dropdownMenu);
  }));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdown__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, containerElement, dropdownMenu) {
  var selectizeDropdown = dropdownMenu.find(".select-dropdown");
  if (((selectizeDropdown.length | 0) > 0)) {
    return $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdownForSelectize__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, dropdownMenu, selectizeDropdown);
  } else if (($m_sc_StringOps$(), (containerElement.id !== ""))) {
    var dropdownContainerJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + containerElement.id));
    var btnJQ = dropdownContainerJQ.find(".dropdown-toggle");
    return btnJQ.each((function() {
      $p_Lcom_papasofokli_execution_ExecuteImpl$__changeDropdownDirection__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery__V($thiz, containerElement, dropdownMenu, dropdownContainerJQ);
    }));
  } else {
    return dropdownMenu;
  }
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__findDropdownForSelectize__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, dropdownMenu, selectizeDropdown) {
  var dm = dropdownMenu.find(".has-options");
  window.onscroll = ((_$9$2) => {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__changeDirectionForSelectize__Lcom_papasofokli_jquery_JQuery__D__Lcom_papasofokli_jquery_TopLeftDef__V($thiz, selectizeDropdown, (+dm.height()), dm.offset());
  });
  return dropdownMenu.on("click keyup change", ((_$10$3) => {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__changeDirectionForSelectize__Lcom_papasofokli_jquery_JQuery__D__Lcom_papasofokli_jquery_TopLeftDef__V($thiz, selectizeDropdown, (+dm.height()), dm.offset());
  }));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__changeDropdownDirection__Lorg_scalajs_dom_Element__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery__V($thiz, containerElement, dropdownMenu, dropdownContainerJQ) {
  $m_sjs_js_timers_package$().gb(0.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var menuTotalHeight = ((+containerElement.getBoundingClientRect().height) + (+dropdownMenu.outerHeight()));
    $p_Lcom_papasofokli_execution_ExecuteImpl$__removeClassesFromElement__Lcom_papasofokli_jquery_JQuery__sci_Seq__sci_Seq($thiz, dropdownMenu, new $c_sci_$colon$colon("dropdown", new $c_sci_$colon$colon("dropup", $m_sci_Nil$())));
    var offset = dropdownContainerJQ.offset();
    if ((((document.documentElement.scrollHeight | 0) - (Math.fround(offset.top) + menuTotalHeight)) < 40.0)) {
      dropdownContainerJQ.addClass("dropup");
    } else {
      dropdownContainerJQ.addClass("dropdown");
    }
  })));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__changeDirectionForSelectize__Lcom_papasofokli_jquery_JQuery__D__Lcom_papasofokli_jquery_TopLeftDef__V($thiz, dropdownMenu, containerHeight, containerOffset) {
  $m_sjs_js_timers_package$().gb(0.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((alreadyCalculated) => (() => {
    var menuTotalHeight = (containerHeight + (+dropdownMenu.outerHeight()));
    var space = ((document.documentElement.scrollHeight | 0) - (Math.fround(containerOffset.top) + menuTotalHeight));
    var isDropup = (space < 40.0);
    if (alreadyCalculated) {
      dropdownMenu.css("top", "");
    } else if ((isDropup && (!alreadyCalculated))) {
      dropdownMenu.addClass("select-dropup");
      dropdownMenu.css("top", "");
    } else if ((!isDropup)) {
      $p_Lcom_papasofokli_execution_ExecuteImpl$__removeClassesFromElement__Lcom_papasofokli_jquery_JQuery__sci_Seq__sci_Seq($thiz, dropdownMenu, new $c_sci_$colon$colon("select-dropup", $m_sci_Nil$()));
    }
  }))((!(!dropdownMenu.hasClass("select-dropup"))))));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__removeClassesFromElement__Lcom_papasofokli_jquery_JQuery__sci_Seq__sci_Seq($thiz, element, classNamesSeq) {
  return classNamesSeq.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((className$3) => {
    if ((!(!element.hasClass(className$3)))) {
      element.removeClass(className$3);
    }
  })));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__setRightDivSize__ju_UUID__ju_UUID__I__T__Lcom_papasofokli_jquery_JQuery($thiz, rightId, leftId, rightSize, rightCss) {
  var leftDivSize = ((12 - rightSize) | 0);
  var rightBarSizeClass = ((("col-sm-" + rightSize) + " ") + rightCss);
  var leftBarSizeClass = ("col-sm-" + leftDivSize);
  var rightBar = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + rightId));
  var leftBar = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + leftId));
  rightBar.attr("class", rightBarSizeClass);
  return leftBar.attr("class", leftBarSizeClass);
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__blocked$lzyINIT1$1__sr_LazyBoolean__Lorg_scalajs_dom_Window__Z($thiz, blocked$lzy1$1, popup$1) {
  return (blocked$lzy1$1.D8 ? blocked$lzy1$1.D9 : blocked$lzy1$1.ahK((((popup$1 === null) || (!(!popup$1.closed))) || ((!(!popup$1.closed)) === (void 0)))));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__blocked$1__sr_LazyBoolean__Lorg_scalajs_dom_Window__Z($thiz, blocked$lzy1$2, popup$2) {
  return (blocked$lzy1$2.D8 ? blocked$lzy1$2.D9 : $p_Lcom_papasofokli_execution_ExecuteImpl$__blocked$lzyINIT1$1__sr_LazyBoolean__Lorg_scalajs_dom_Window__Z($thiz, blocked$lzy1$2, popup$2));
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__callback$1__Lcom_papasofokli_jquery_JQuery__T__s_concurrent_ExecutionContext__V($thiz, jquery$1, html$5, executionContext$4) {
  var \u03b43$ = jquery$1.replaceWith(html$5);
  \u03b43$.fadeIn("fast");
  $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext$4);
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
}
function $p_Lcom_papasofokli_execution_ExecuteImpl$__callback$2__Lcom_papasofokli_jquery_JQuery__T__s_concurrent_ExecutionContext__V($thiz, jquery$3, html$7, executionContext$6) {
  jquery$3.html(html$7);
  $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext$6);
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
}
/** @constructor */
function $c_Lcom_papasofokli_execution_ExecuteImpl$() {
}
$p = $c_Lcom_papasofokli_execution_ExecuteImpl$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ExecuteImpl$;
/** @constructor */
function $h_Lcom_papasofokli_execution_ExecuteImpl$() {
}
$h_Lcom_papasofokli_execution_ExecuteImpl$.prototype = $p;
$p.atE = (function(e, executionContext) {
  if ((e instanceof $c_Lcom_papasofokli_execution_UpdateValidation)) {
    var x370 = e.wz;
    var x371 = e.wA;
    var x372 = e.wC;
    var x373 = e.wB;
    if ((x370 !== null)) {
      if ((x371 !== null)) {
        if ((x372 !== null)) {
          if ((x373 !== null)) {
            $m_Lcom_papasofokli_util_formgroup_InputValidation$().az0(x370, x371, x372, x373);
            return $m_s_concurrent_Future$().aE((void 0));
          }
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReloadTable)) {
    var x367 = e.w8;
    $m_Lcom_papasofokli_dataTables_TableInitialize$();
    $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ajk(x367, executionContext);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddTableRow)) {
    $m_Lcom_papasofokli_dataTables_TableFunctions$().ave(e.ro, e.rm, e.rl, e.rn, e.lr);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_CollapseTableRow)) {
    $m_Lcom_papasofokli_dataTables_TableFunctions$().afV(e.vI, e.vH);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReplaceElementContents)) {
    var x350 = e.rN;
    var x351 = e.rM;
    var x352 = e.rO;
    if ((x350 !== null)) {
      if ((!x352)) {
        var scalaPromise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
        var \u03b45$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x350)).html(x351);
        \u03b45$.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise, (void 0))))));
        return scalaPromise;
      }
      if (x352) {
        return $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceElementContentsById__T__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, x350.g(), x351, executionContext);
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReplaceElementWithId)) {
    var x339 = e.rQ;
    var x340 = e.rP;
    var x341 = e.rR;
    if (x341) {
      return $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceElementsWithIdSmoothly__ju_UUID__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, x339, x340, executionContext);
    }
    if ((!x341)) {
      var scalaPromise$1 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      var \u03b45$$1 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x339)).replaceWith(x340);
      \u03b45$$1.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$1, (void 0))))));
      return scalaPromise$1;
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv)) {
    var x331 = e.w7;
    return $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().Ex(x331.g(), executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => (void 0))), executionContext);
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight)) {
    var x327 = e.rq;
    var x328 = e.rp;
    return $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().amf(x327.g(), x328, executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => (void 0))), executionContext);
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ModifyPeriods)) {
    var x323 = e.vT;
    var x324 = e.vS;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().awh(x323.g(), x324);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges)) {
    var x319 = e.wr;
    var x320 = e.wq;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().ay2(x319.g(), x320);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges)) {
    var x316 = e.vP;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().auM(x316.g());
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_PrependElementWithId)) {
    var x311 = e.w1;
    var x312 = e.w0;
    if ((x311 !== null)) {
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x311)).prepend(x312);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AppendElementWithId)) {
    var x306 = e.vA;
    var x307 = e.vz;
    if ((x306 !== null)) {
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x306)).append(x307);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if (($m_Lcom_papasofokli_execution_HideModal$() === e)) {
    var element = document.querySelector(".modal");
    if ((element !== null)) {
      var modal = $i_bootstrap.Modal.getOrCreateInstance(element);
      modal.hide();
      var this$25 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".modal-backdrop"));
      var it = this$25.l();
      while (it.f()) {
        var x0 = it.e();
        x0.remove();
      }
    }
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if (($m_Lcom_papasofokli_execution_ShowModal$() === e)) {
    var element$2 = document.querySelector(".modal");
    var modal$2 = $i_bootstrap.Modal.getOrCreateInstance(element$2);
    modal$2.show();
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_OnCloseModal)) {
    var x302 = e.vV;
    if ((x302 !== null)) {
      var element$3 = document.querySelector(".modal");
      element$3.addEventListener("hidden.bs.modal", ((_$4$2) => $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), x302.g(), "", executionContext)));
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_OnShownModal)) {
    var x298 = e.vW;
    if ((x298 !== null)) {
      var element$4 = document.querySelector(".modal");
      element$4.addEventListener("shown.bs.modal", ((_$5$2) => $m_Lcom_papasofokli_util_DelayFuture$().jj(300, 0).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), x298.g(), "", executionContext))), executionContext)));
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_CleanPlannerRow)) {
    var x294 = e.vE;
    var x295 = e.vF;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().anc(x294.g(), x295.g());
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_CleanDetailPlannerRow)) {
    var x289 = e.rz;
    var x290 = e.rA;
    var x291 = e.ry;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().anb(x289.g(), x290.g(), x291);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_RedirectPageToHref)) {
    var x286 = e.w5;
    var $x_1 = $m_s_concurrent_Future$();
    window.location.href = x286;
    return $x_1.aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow)) {
    var x281 = e.vx;
    var x282 = e.vy;
    var x283 = e.vw;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().amc(x281, x282, x283);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddPeriodsToSubject)) {
    var x276 = e.rk;
    var $x_2 = e;
    var x277_$_lo = $x_2.tV;
    var x277_$_hi = $x_2.tW;
    var x278 = e.rj;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().amd(x276.g(), x277_$_lo, x277_$_hi, x278);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_HighlightTimePeriod)) {
    var x268 = e.rF;
    var $x_3 = e;
    var x269_$_lo = $x_3.tX;
    var x269_$_hi = $x_3.tY;
    var $x_4 = e;
    var x270_$_lo = $x_4.tZ;
    var x270_$_hi = $x_4.u0;
    if ((x268 !== null)) {
      $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().auN(x268, x269_$_lo, x269_$_hi, x270_$_lo, x270_$_hi);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod)) {
    var x264 = e.wy;
    if ((x264 !== null)) {
      $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().ayN(x264);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects)) {
    var x260 = e.wo;
    var x261 = e.wp;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().ay1(x260.g(), x261);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_FocusPlanningPeriods)) {
    var x256 = e.vM;
    var x257 = e.vN;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().au2(x256.g(), x257);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect)) {
    var x253 = e.vO;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().auL(x253.g());
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow)) {
    var x247 = e.rh;
    var x248 = e.ri;
    var x249 = e.rf;
    var x250 = e.rg;
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().am0(x247, x248, x249, x250);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ClickOnId)) {
    var x244 = e.vG;
    var scalaPromise$2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var \u03b45$$2 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x244)).click();
    \u03b45$$2.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$2, (void 0))))));
    return scalaPromise$2;
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ShowSidebarForPlanner)) {
    var x240 = e.ws;
    if ((x240 !== null)) {
      $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().ay3(x240.g());
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner)) {
    var x234 = e.rS;
    var x235 = e.rT;
    if ((x234 !== null)) {
      $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().axn(x234.g(), x235);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SetProgress)) {
    $m_Lcom_papasofokli_progressbar_ProgressBarInitializer$().axS(e);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ExpandModal)) {
    var x223 = e.rD;
    var x224 = e.rE;
    var x225 = e.rB;
    var x226 = e.rC;
    if ((x223 !== null)) {
      if ((x224 !== null)) {
        if ((x226 !== null)) {
          $m_Lcom_papasofokli_expandablemodal_Resizeable$().atI(x223.g(), x226.jW, x224.g(), x226.jX, x225);
          return $m_s_concurrent_Future$().aE((void 0));
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ShrinkModal)) {
    var x213 = e.s6;
    var x214 = e.s7;
    var x215 = e.s4;
    var x216 = e.s5;
    if ((x213 !== null)) {
      if ((x214 !== null)) {
        if ((x216 !== null)) {
          $m_Lcom_papasofokli_expandablemodal_Resizeable$().ay4(x213.g(), x216.jW, x214.g(), x216.jX, x215);
          return $m_s_concurrent_Future$().aE((void 0));
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_DownloadFile)) {
    var x209 = e.vK;
    if ((x209 !== null)) {
      $p_Lcom_papasofokli_execution_ExecuteImpl$__download__T__T__Lorg_scalajs_dom_Node(this, "File download", x209);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_PrintReceiptBytes)) {
    var x195 = e.rK;
    var x198 = e.rL;
    var x199 = e.rJ;
    if ((x195 !== null)) {
      if ((x198 !== null)) {
        if ((x199 !== null)) {
          var uint8Array = new Uint8Array(x195.a.length);
          var this$53 = $m_sc_ArrayOps$().auS(x195);
          if ((!this$53.dN)) {
            var i = this$53.cF;
            while (true) {
              var x0$1 = i;
              uint8Array[x0$1] = ((x195.a[x0$1] << 16) >> 16);
              if ((i === this$53.j7)) {
                break;
              }
              i = ((i + this$53.bA) | 0);
            }
          }
          var blob = new Blob([uint8Array.buffer], (() => {
            var this$55 = ({});
            this$55.type = "application/pdf";
            return this$55;
          })());
          var url$2 = URL.createObjectURL(blob);
          $p_Lcom_papasofokli_execution_ExecuteImpl$__download__T__T__Lorg_scalajs_dom_Node(this, (x199 + ".pdf"), url$2);
          return $m_s_concurrent_Future$().aE((void 0));
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_OpenPrinterCashbox)) {
    if ((e.vX !== null)) {
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ShowHideNavSidebar)) {
    $m_Lcom_papasofokli_util_package$().UD(e.s3);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddClassToElement)) {
    var x181 = e.vv;
    var x182 = e.vu;
    if ((x181 !== null)) {
      if ((x182 !== null)) {
        var scalaPromise$3 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
        var \u03b45$$3 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x181)).addClass(x182);
        \u03b45$$3.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$3, (void 0))))));
        return scalaPromise$3;
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_RemoveClassFromElement)) {
    var x175 = e.wc;
    var x176 = e.wb;
    if ((x175 !== null)) {
      if ((x176 !== null)) {
        var scalaPromise$4 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
        var \u03b45$$4 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x175)).removeClass(x176);
        \u03b45$$4.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$4, (void 0))))));
        return scalaPromise$4;
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ToggleClassFromElement)) {
    var x169 = e.ww;
    var x170 = e.wv;
    if ((x169 !== null)) {
      if ((x170 !== null)) {
        var scalaPromise$5 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
        var \u03b45$$5 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x169)).toggleClass(x170);
        \u03b45$$5.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$5, (void 0))))));
        return scalaPromise$5;
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_InitializeTab)) {
    var x166 = e.vR;
    $m_Lcom_papasofokli_components_NavTabsJS$().UI(x166, executionContext);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_UpdateIconNotification)) {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__updateIconNotification__I__ju_UUID__V(this, e.sh, e.sg);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ToggleNotificationDropdown)) {
    $p_Lcom_papasofokli_execution_ExecuteImpl$__toggleNotificationDropdown__ju_UUID__V(this, e.wx);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_OpenUrl)) {
    var x151 = e.rH;
    var x152 = e.rG;
    var x153 = e.ls;
    if ((x151 !== null)) {
      if ((x152 !== null)) {
        var blocked$lzy1 = new $c_sr_LazyBoolean();
        var popup = window.open(x151, x152);
        if ((x153 && $p_Lcom_papasofokli_execution_ExecuteImpl$__blocked$1__sr_LazyBoolean__Lorg_scalajs_dom_Window__Z(this, blocked$lzy1, popup))) {
          $m_Lcom_papasofokli_components_ToastJS$().IZ("Popup blocked, check browser settings.", $m_s_Option$().Z($bL(4500, 0)));
        }
        return $m_s_concurrent_Future$().aE((void 0));
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ChangeUrlTo)) {
    var x147 = e.vD;
    if ((x147 !== null)) {
      var \u03b41$ = window.history;
      \u03b41$.pushState("", "", x147);
      window.dispatchEvent(new Event("popstate"));
      $m_Lcom_papasofokli_sidebar_SideBarJS$().akk(executionContext);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ChangeTitleTo)) {
    var x143 = e.vC;
    if ((x143 !== null)) {
      (0, $m_Lcom_papasofokli_jquery_package$().I)(".title-css").text(x143);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_NavigateTo)) {
    var x139 = e.vU;
    if ((x139 !== null)) {
      window.location.href = "#";
      window.location.href = ("#" + x139);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SetRightDivSize)) {
    var x129 = e.s1;
    var x130 = e.rZ;
    var x131 = e.s2;
    var x132 = e.s0;
    if ((x129 !== null)) {
      if ((x130 !== null)) {
        if ((x132 !== null)) {
          $p_Lcom_papasofokli_execution_ExecuteImpl$__setRightDivSize__ju_UUID__ju_UUID__I__T__Lcom_papasofokli_jquery_JQuery(this, x129, x130, x131, x132);
          return $m_s_concurrent_Future$().aE((void 0));
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_HttpRedirect)) {
    var x125 = e.vQ;
    if ((x125 !== null)) {
      window.location.href = x125;
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReplaceAnchorWithId)) {
    var x121 = e.wg;
    var x122 = e.wh;
    var scalaPromise$6 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var \u03b45$$6 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x121)).replaceWith(x122);
    \u03b45$$6.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$6, (void 0))))));
    return scalaPromise$6;
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReplaceAnchorContents)) {
    return $p_Lcom_papasofokli_execution_ExecuteImpl$__replaceElementContentsById__T__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, e.we, e.wf, executionContext);
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith)) {
    var x113 = e.wi;
    var x114 = e.wj;
    var scalaPromise$7 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var \u03b45$$7 = (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + x113)).html(x114);
    \u03b45$$7.promise().done($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(scalaPromise$7, (void 0))))));
    return scalaPromise$7;
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ResetPayrollTree)) {
    var x110 = e.wk;
    resetPayrollTree(JSON.parse(x110));
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_PayrollTreeLoadData)) {
    var x106 = e.vY;
    if ((x106 !== null)) {
      loadData(JSON.parse(x106));
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_CalculateDropdownPosition)) {
    var x102 = e.vB;
    if ((x102 !== null)) {
      return $p_Lcom_papasofokli_execution_ExecuteImpl$__calculateDropdownPosition__T__s_concurrent_Future(this, x102);
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AppendChildrenToParentTree)) {
    var x86 = e.rw;
    var x87 = e.rx;
    var x88 = e.rr;
    var x89 = e.rv;
    var x90 = e.rs;
    var x91 = e.ru;
    var x92 = e.rt;
    if ((x86 !== null)) {
      if ((x88 !== null)) {
        if ((x89 !== null)) {
          if ((x90 !== null)) {
            if ((x92 !== null)) {
              return $m_s_concurrent_Future$().aE(($m_Lcom_papasofokli_tree_TreeJs$().amo(x86, x87, x88, x89, x90, x91, x92, executionContext), (void 0)));
            }
          }
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv)) {
    var x82 = e.w6;
    if ((x82 !== null)) {
      return $m_Lcom_papasofokli_agileboard_AgileBoardJs$().ax4(x82.g(), executionContext);
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ScrollToAnchorId)) {
    var x76 = e.rU;
    var x77 = e.rV;
    if ((x76 !== null)) {
      var offset = Math.fround((0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + x76)).offset().top);
      if (x77) {
        (0, $m_Lcom_papasofokli_jquery_package$().I)(".modal-body").scrollTop(offset);
      } else {
        (0, $m_Lcom_papasofokli_jquery_package$().I)("html, body").scrollTop(offset);
      }
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_PopoverHide)) {
    var x72 = e.vZ;
    if ((x72 !== null)) {
      $m_Lcom_papasofokli_components_PopoverJS$().auK(x72.g());
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_AddAttributeToElement)) {
    var x62 = e.vt;
    var x63 = e.vr;
    var x64 = e.vs;
    var x65 = e.nm;
    if ((x62 !== null)) {
      if ((x63 !== null)) {
        if ((x64 !== null)) {
          if ((x65 !== null)) {
            var $x_5 = $m_s_concurrent_Future$();
            var element$5 = document.getElementById((("" + x62) + x65));
            element$5.setAttribute(x63, x64);
            return $x_5.aE((void 0));
          }
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_RemoveAttributeFromElement)) {
    var x54 = e.wa;
    var x55 = e.w9;
    var x56 = e.nn;
    if ((x54 !== null)) {
      if ((x55 !== null)) {
        if ((x56 !== null)) {
          var $x_6 = $m_s_concurrent_Future$();
          var element$6 = document.getElementById((("" + x54) + x56));
          element$6.removeAttribute(x55);
          return $x_6.aE((void 0));
        }
      }
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_RemoveElementChildren)) {
    var x50 = e.wd;
    if ((x50 !== null)) {
      return $m_s_concurrent_Future$().aE(($m_Lcom_papasofokli_components_CalendarJS$().axa(x50), (void 0)));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SelectInputEnable)) {
    var x46 = e.wn;
    if ((x46 !== null)) {
      var $x_7 = $m_s_concurrent_Future$();
      var controlDiv = document.getElementById(("" + x46));
      controlDiv.classList.remove("disabled");
      var controlInput = document.getElementById((x46 + "_input"));
      controlInput.removeAttribute("disabled");
      return $x_7.aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SelectInputDisable)) {
    var x42 = e.wm;
    if ((x42 !== null)) {
      var $x_8 = $m_s_concurrent_Future$();
      var controlDiv$2 = document.getElementById(("" + x42));
      controlDiv$2.classList.add("disabled");
      var controlInput$2 = document.getElementById((x42 + "_input"));
      controlInput$2.setAttribute("disabled", "disabled");
      return $x_8.aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_FocusInput)) {
    var x38 = e.vL;
    if ((x38 !== null)) {
      var $x_9 = $m_s_concurrent_Future$();
      var element$7 = document.getElementById(("" + x38));
      if ((!(!(element$7 instanceof HTMLInputElement)))) {
        element$7.focus();
      }
      return $x_9.aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SignaturePadToDataURL)) {
    var x35 = e.wu;
    var elementIdString = x35.g();
    if ((!$m_Lcom_papasofokli_signature_SignaturePadJS$().avr(elementIdString))) {
      var this$102 = $m_Lcom_papasofokli_signature_SignaturePadJS$().ayD(elementIdString);
      var dataUrl = (this$102.c() ? "" : this$102.h());
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), x35.g(), dataUrl, executionContext);
    } else {
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), x35.g(), (void 0), executionContext);
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_SignaturePadClear)) {
    $m_Lcom_papasofokli_signature_SignaturePadJS$().and(e.wt.g());
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_CopyTextToClipboard)) {
    var x29 = e.vJ;
    window.navigator.clipboard.writeText(x29);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if (($m_Lcom_papasofokli_execution_InvalidPrintServerUUID$() === e)) {
    console.warn("Received InvalidPrintServerUUID message in browser context (ignored)");
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column)) {
    $m_Lcom_papasofokli_agileboard2_AgileBoard2Functions$().ayY(e.sd, e.se, e.sf);
    return $m_s_concurrent_Future$().aE((void 0));
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_ResetScanner)) {
    var x20 = e.wl;
    if ((x20 !== null)) {
      $m_Lcom_papasofokli_zxing_ScannerState$().axf(x20);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_TableGroupColumn)) {
    var x14 = e.s9;
    var x15 = e.s8;
    if ((x14 !== null)) {
      var element$8 = document.querySelector(("#" + x14)).querySelector((("[data-icon-group-index='" + x15) + "']"));
      $m_Lcom_papasofokli_dataTables_ScalaJsTable$().IJ(x14, element$8, ($m_Lcom_papasofokli_dataTables_ScalaJsTable$(), true), executionContext);
      return $m_s_concurrent_Future$().aE((void 0));
    }
  }
  if ((e instanceof $c_Lcom_papasofokli_execution_TableSortColumn)) {
    var x6 = e.sc;
    var x7 = e.sa;
    var x8 = e.sb;
    if ((x6 !== null)) {
      if ((x8 !== null)) {
        var element$9 = document.querySelector(("#" + x6)).querySelector((("[data-icon-sort-index='" + x7) + "']"));
        $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ajT(x6, element$9, new $c_s_Some(x8), executionContext);
        return $m_s_concurrent_Future$().aE((void 0));
      }
    }
  }
  throw new $c_s_MatchError(e);
});
var $d_Lcom_papasofokli_execution_ExecuteImpl$ = new $TypeData().i($c_Lcom_papasofokli_execution_ExecuteImpl$, "com.papasofokli.execution.ExecuteImpl$", ({
  mp: 1
}));
var $n_Lcom_papasofokli_execution_ExecuteImpl$;
function $m_Lcom_papasofokli_execution_ExecuteImpl$() {
  if ((!$n_Lcom_papasofokli_execution_ExecuteImpl$)) {
    $n_Lcom_papasofokli_execution_ExecuteImpl$ = new $c_Lcom_papasofokli_execution_ExecuteImpl$();
  }
  return $n_Lcom_papasofokli_execution_ExecuteImpl$;
}
var $d_Lcom_papasofokli_execution_JsStatement = new $TypeData().i(1, "com.papasofokli.execution.JsStatement", ({
  x: 1
}));
function $p_Lcom_papasofokli_expandablemodal_Resizeable$__resizeDivWithSelector__T__s_Option__Lcom_papasofokli_jquery_JQuery($thiz, selector, percentage) {
  var query = (0, $m_Lcom_papasofokli_jquery_package$().I)(selector);
  if ((!percentage.c())) {
    Math.fround(percentage.h());
    if (($dp_toString__T(query.data("max-width")) === "undefined")) {
      var divSize = (+query.outerWidth());
      var parentDivSize = (+query.parent().width());
      var widthRatio = (divSize / parentDivSize);
      var widthRatioPer = (100.0 * widthRatio);
      var width = (widthRatioPer + "%");
      query.data("max-width", width);
    }
  }
  return query.animate(new ($a_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth())(percentage, query), 200);
}
/** @constructor */
function $c_Lcom_papasofokli_expandablemodal_Resizeable$() {
  this.al2 = null;
  this.al2 = ".modal-dialog";
}
$p = $c_Lcom_papasofokli_expandablemodal_Resizeable$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_expandablemodal_Resizeable$;
/** @constructor */
function $h_Lcom_papasofokli_expandablemodal_Resizeable$() {
}
$h_Lcom_papasofokli_expandablemodal_Resizeable$.prototype = $p;
$p.atI = (function(side1Id, div1, side2Id, div2, percentage) {
  $p_Lcom_papasofokli_expandablemodal_Resizeable$__resizeDivWithSelector__T__s_Option__Lcom_papasofokli_jquery_JQuery(this, ".modal-dialog", new $c_s_Some(percentage));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + side1Id)).addClass(("col-md-" + div1));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + side2Id)).addClass(("col-md-" + div2));
});
$p.ay4 = (function(side1Id, div1, side2Id, div2, percentage) {
  $p_Lcom_papasofokli_expandablemodal_Resizeable$__resizeDivWithSelector__T__s_Option__Lcom_papasofokli_jquery_JQuery(this, ".modal-dialog", new $c_s_Some(percentage));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + side1Id)).removeClass(("col-md-" + div1));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + side2Id)).removeClass(("col-md-" + div2));
});
$p.atJ = (function(mainDivSelector, sideDivSelector, percentage, executionContext) {
  $p_Lcom_papasofokli_expandablemodal_Resizeable$__resizeDivWithSelector__T__s_Option__Lcom_papasofokli_jquery_JQuery(this, mainDivSelector, (percentage.c() ? $m_s_None$() : new $c_s_Some(Math.fround((100.0 - Math.fround(percentage.h()))))));
  if (percentage.az(0.0)) {
    var \u03b41$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(sideDivSelector);
    \u03b41$.hide();
  } else {
    $m_Lcom_papasofokli_util_DelayFuture$().jj(400, 0).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => {
      var \u03b42$ = (0, $m_Lcom_papasofokli_jquery_package$().I)(sideDivSelector);
      return \u03b42$.show();
    })), executionContext);
  }
});
var $d_Lcom_papasofokli_expandablemodal_Resizeable$ = new $TypeData().i($c_Lcom_papasofokli_expandablemodal_Resizeable$, "com.papasofokli.expandablemodal.Resizeable$", ({
  oV: 1
}));
var $n_Lcom_papasofokli_expandablemodal_Resizeable$;
function $m_Lcom_papasofokli_expandablemodal_Resizeable$() {
  if ((!$n_Lcom_papasofokli_expandablemodal_Resizeable$)) {
    $n_Lcom_papasofokli_expandablemodal_Resizeable$ = new $c_Lcom_papasofokli_expandablemodal_Resizeable$();
  }
  return $n_Lcom_papasofokli_expandablemodal_Resizeable$;
}
function $p_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$__pasteClickAction__Lorg_scalajs_dom_Element__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, element, ec) {
  return new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((headerName, functionId) => (() => $m_sjs_js_Thenable$ThenableOps$().uE(navigator.clipboard.readText()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((clip$2) => {
    var xs = $f_T__split__T__I__AT($f_T__replaceAll__T__T__T($f_T__replaceAll__T__T__T(clip$2, "\"", ""), "'", ""), "\\n", 0);
    var f = ((value$2) => $p_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$__sanitizeText__T__T($thiz, value$2));
    var ct__runtimeClass;
    var ct__runtimeClass = $d_T.l();
    var len = xs.a.length;
    var componentType = ct__runtimeClass;
    var ys = componentType.ax.U(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = $m_sr_ScalaRunTime$();
          var $x_1 = i;
          var x0 = xs.a[i];
          $x_2.bQ(ys, $x_1, f(x0));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_4 = $m_sr_ScalaRunTime$();
          var $x_3 = i;
          var x0$1 = xs.a[i];
          $x_4.bQ(ys, $x_3, f(x0$1));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_6 = $m_sr_ScalaRunTime$();
          var $x_5 = i;
          var x0$2 = xs.a[i];
          $x_6.bQ(ys, $x_5, f(x0$2));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_10 = $m_sr_ScalaRunTime$();
          var $x_9 = i;
          var $x_7 = xs.a;
          var $x_8 = (i << 1);
          var x0$3_$_lo = $x_7[$x_8];
          var x0$3_$_hi = $x_7[(($x_8 + 1) | 0)];
          $x_10.bQ(ys, $x_9, f($bL(x0$3_$_lo, x0$3_$_hi)));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_12 = $m_sr_ScalaRunTime$();
          var $x_11 = i;
          var x0$4 = xs.a[i];
          $x_12.bQ(ys, $x_11, f(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_14 = $m_sr_ScalaRunTime$();
          var $x_13 = i;
          var x0$5 = xs.a[i];
          $x_14.bQ(ys, $x_13, f($bC(x0$5)));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_16 = $m_sr_ScalaRunTime$();
          var $x_15 = i;
          var x0$6 = xs.a[i];
          $x_16.bQ(ys, $x_15, f(x0$6));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_18 = $m_sr_ScalaRunTime$();
          var $x_17 = i;
          var x0$7 = xs.a[i];
          $x_18.bQ(ys, $x_17, f(x0$7));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_20 = $m_sr_ScalaRunTime$();
          var $x_19 = i;
          var x0$8 = xs.a[i];
          $x_20.bQ(ys, $x_19, f(x0$8));
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var dataO = ((ys.a.length !== 0) ? $m_s_Option$().Z(new $c_Lcom_papasofokli_dataTables_CsvPasteHeader(headerName, $m_sc_ArrayOps$().NC(ys))) : (console.error("Pasted input not valid!"), $m_s_None$()));
    if (dataO.c()) {
      var this$19 = $m_s_None$();
    } else {
      var x0$9 = dataO.h();
      var this$17 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(functionId);
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), x0$9, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_CsvPasteHeader$().q());
      var this$19 = new $c_s_Some($p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$17, id.g(), data, ec));
    }
    return (this$19.c() ? $m_s_concurrent_Future$().aE((void 0)) : this$19.h());
  })), ec)))(element.getAttribute("data-header-name"), element.getAttribute("data-function-id"))));
}
function $p_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$__sanitizeText__T__T($thiz, value) {
  var this$2 = $f_T__strip__T($m_sc_StringOps$().ayk(value));
  return this$2.split("/\\r?\\n|\\r/g").join("");
}
/** @constructor */
function $c_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$() {
}
$p = $c_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$;
/** @constructor */
function $h_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$() {
}
$h_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$.prototype = $p;
$p.b7 = (function(ec) {
  $m_Lcom_papasofokli_util_package$().fo("dc0d130d-4051-4ffa-1313-2ae230c5513c").each(((this$1) => (function() {
    this.addEventListener("click", ((_$1$2) => $p_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$__pasteClickAction__Lorg_scalajs_dom_Element__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, this, ec)));
  }))(this));
});
var $d_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$ = new $TypeData().i($c_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$, "com.papasofokli.headerCsvPaste.HeaderCsvPasteJs$", ({
  oW: 1
}));
var $n_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$;
function $m_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$() {
  if ((!$n_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$)) {
    $n_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$ = new $c_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$();
  }
  return $n_Lcom_papasofokli_headerCsvPaste_HeaderCsvPasteJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_CheckboxJs$() {
}
$p = $c_Lcom_papasofokli_input_CheckboxJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_CheckboxJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_CheckboxJs$() {
}
$h_Lcom_papasofokli_input_CheckboxJs$.prototype = $p;
$p.axU = (function(checkBox, executionContext) {
  checkBox.onchange = ((_$1$2) => {
    var checked = JSON.stringify((!(!checkBox.checked)));
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(checkBox.id).g(), checked, executionContext);
  });
  if ((!(!(!checkBox.disabled)))) {
    var checked$1 = JSON.stringify((!(!checkBox.checked)));
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(checkBox.id).g(), checked$1, executionContext);
  }
});
$p.b7 = (function(executionContext) {
  $m_Lcom_papasofokli_util_package$().fo("not-initialized-checkbox").each(((this$1) => (function() {
    if ((!(!(this instanceof HTMLInputElement)))) {
      this$1.axU(this, executionContext);
    }
  }))(this));
});
var $d_Lcom_papasofokli_input_CheckboxJs$ = new $TypeData().i($c_Lcom_papasofokli_input_CheckboxJs$, "com.papasofokli.input.CheckboxJs$", ({
  oX: 1
}));
var $n_Lcom_papasofokli_input_CheckboxJs$;
function $m_Lcom_papasofokli_input_CheckboxJs$() {
  if ((!$n_Lcom_papasofokli_input_CheckboxJs$)) {
    $n_Lcom_papasofokli_input_CheckboxJs$ = new $c_Lcom_papasofokli_input_CheckboxJs$();
  }
  return $n_Lcom_papasofokli_input_CheckboxJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_ColorInputHelper$() {
}
$p = $c_Lcom_papasofokli_input_ColorInputHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_ColorInputHelper$;
/** @constructor */
function $h_Lcom_papasofokli_input_ColorInputHelper$() {
}
$h_Lcom_papasofokli_input_ColorInputHelper$.prototype = $p;
$p.auJ = (function(hex) {
  if ((!$m_ju_regex_Pattern$().ahZ("^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$", hex))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Invalid hex color code");
  }
  var cleanHex = ((!(!hex.startsWith("#"))) ? hex.substring(1) : hex);
  return new $c_T3($m_jl_Integer$().c7(cleanHex.substring(0, 2), 16, 134217728), $m_jl_Integer$().c7(cleanHex.substring(2, 4), 16, 134217728), $m_jl_Integer$().c7(cleanHex.substring(4, 6), 16, 134217728));
});
var $d_Lcom_papasofokli_input_ColorInputHelper$ = new $TypeData().i($c_Lcom_papasofokli_input_ColorInputHelper$, "com.papasofokli.input.ColorInputHelper$", ({
  oY: 1
}));
var $n_Lcom_papasofokli_input_ColorInputHelper$;
function $m_Lcom_papasofokli_input_ColorInputHelper$() {
  if ((!$n_Lcom_papasofokli_input_ColorInputHelper$)) {
    $n_Lcom_papasofokli_input_ColorInputHelper$ = new $c_Lcom_papasofokli_input_ColorInputHelper$();
  }
  return $n_Lcom_papasofokli_input_ColorInputHelper$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_ColorInputJs$() {
}
$p = $c_Lcom_papasofokli_input_ColorInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_ColorInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_ColorInputJs$() {
}
$h_Lcom_papasofokli_input_ColorInputJs$.prototype = $p;
$p.auo = (function(input) {
  var hex = input.value;
  matchResult1: {
    var \u03b42$;
    var x1 = $m_Lcom_papasofokli_input_ColorInputHelper$().auJ(hex);
    if ((x1 !== null)) {
      var \u03b42$ = x1;
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var r$2 = (\u03b42$.gZ | 0);
  var g$2 = (\u03b42$.fY | 0);
  var b$2 = (\u03b42$.gr | 0);
  return (((((("rgb(" + r$2) + ",") + g$2) + ",") + b$2) + ")");
});
$p.akl = (function(input, rgb, init) {
  var \u03b43$ = input.style;
  \u03b43$.setProperty("--custom-gradient-rgb", rgb);
  if ((!init)) {
    input.value = rgb;
  }
});
$p.awA = (function(e, input, ec) {
  var rgb = this.auo(e.target);
  this.akl(input, rgb, false);
  return new $c_Lcom_papasofokli_util_MultipleEventHandler(100, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(input.id).g(), rgb, ec);
  })));
});
$p.b7 = (function(ec) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".f76e4623-1560-4505-87c1-34c0155f6c0f"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    var inputId = $m_sc_ArrayOps$().auG($f_T__split__T__I__AT(x0.id, "_", 0));
    var input = document.getElementById(inputId);
    var colorInput = document.getElementById((inputId + "_child"));
    this.akl(input, colorInput.value, true);
    colorInput.addEventListener("input", ((input, ec) => ((e$2) => this.awA(e$2, input, ec)))(input, ec));
    x0.classList.remove("f76e4623-1560-4505-87c1-34c0155f6c0f");
  }
});
var $d_Lcom_papasofokli_input_ColorInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_ColorInputJs$, "com.papasofokli.input.ColorInputJs$", ({
  oZ: 1
}));
var $n_Lcom_papasofokli_input_ColorInputJs$;
function $m_Lcom_papasofokli_input_ColorInputJs$() {
  if ((!$n_Lcom_papasofokli_input_ColorInputJs$)) {
    $n_Lcom_papasofokli_input_ColorInputJs$ = new $c_Lcom_papasofokli_input_ColorInputJs$();
  }
  return $n_Lcom_papasofokli_input_ColorInputJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_DoubleInputJs$() {
  this.ZI = null;
  $n_Lcom_papasofokli_input_DoubleInputJs$ = this;
  this.ZI = $m_Lcom_papasofokli_input_Key$().ES.cH(new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().ER, new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().JB, $m_sci_Nil$())));
}
$p = $c_Lcom_papasofokli_input_DoubleInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_DoubleInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_DoubleInputJs$() {
}
$h_Lcom_papasofokli_input_DoubleInputJs$.prototype = $p;
$p.UU = (function(c) {
  var element = c.currentTarget;
  var value = element.valueOf().value;
  if (((((!this.ZI.az(c.key)) && (!$m_Lcom_papasofokli_input_InputHelperJs$().afD(c))) || $m_Lcom_papasofokli_input_InputHelperJs$().ati(c, value)) || $m_Lcom_papasofokli_input_InputHelperJs$().agz(c, value))) {
    c.preventDefault();
  }
});
$p.co = (function() {
  $m_Lcom_papasofokli_util_package$().fo("double-input").each(((this$1) => (function() {
    if ((!(!(this instanceof HTMLInputElement)))) {
      this.onkeypress = ((_$1$2) => {
        this$1.UU(_$1$2);
      });
    }
  }))(this));
});
var $d_Lcom_papasofokli_input_DoubleInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_DoubleInputJs$, "com.papasofokli.input.DoubleInputJs$", ({
  p0: 1
}));
var $n_Lcom_papasofokli_input_DoubleInputJs$;
function $m_Lcom_papasofokli_input_DoubleInputJs$() {
  if ((!$n_Lcom_papasofokli_input_DoubleInputJs$)) {
    $n_Lcom_papasofokli_input_DoubleInputJs$ = new $c_Lcom_papasofokli_input_DoubleInputJs$();
  }
  return $n_Lcom_papasofokli_input_DoubleInputJs$;
}
function $f_Lcom_papasofokli_input_EnhancedTextInputT__$init$__V($thiz) {
  $thiz.Ou = "not-initialized-enhanced-text-input";
  $thiz.ZJ = "rf-eti-backdrop";
  $thiz.ZL = "rf-eti-highlights";
}
function $p_Lcom_papasofokli_input_InputHelperJs$__isControlOrCMD__Lorg_scalajs_dom_KeyboardEvent__Z($thiz, e) {
  return ((!(!e.ctrlKey)) || (!(!e.metaKey)));
}
/** @constructor */
function $c_Lcom_papasofokli_input_InputHelperJs$() {
  this.al3 = null;
  this.al3 = "RF";
}
$p = $c_Lcom_papasofokli_input_InputHelperJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_InputHelperJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_InputHelperJs$() {
}
$h_Lcom_papasofokli_input_InputHelperJs$.prototype = $p;
$p.afD = (function(e) {
  var isControlOrCmd = $p_Lcom_papasofokli_input_InputHelperJs$__isControlOrCMD__Lorg_scalajs_dom_KeyboardEvent__Z(this, e);
  return (((((new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().EQ, new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().ZX, new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().Ow, new $c_sci_$colon$colon($m_Lcom_papasofokli_input_Key$().ZV, $m_sci_Nil$())))).az(e.key) || ((e.key === $m_Lcom_papasofokli_input_Key$().ZO) && isControlOrCmd)) || ((e.key === $m_Lcom_papasofokli_input_Key$().Ov) && isControlOrCmd)) || ((e.key === $m_Lcom_papasofokli_input_Key$().ZQ) && isControlOrCmd)) || ((e.key === $m_Lcom_papasofokli_input_Key$().ZP) && isControlOrCmd)) || $m_Lcom_papasofokli_input_Key$().ZT.az(e.key));
});
$p.avh = (function(e) {
  if ($p_Lcom_papasofokli_input_InputHelperJs$__isControlOrCMD__Lorg_scalajs_dom_KeyboardEvent__Z(this, e)) {
    var this$1 = e.key;
    return (this$1.toUpperCase() === $m_Lcom_papasofokli_input_Key$().Ov);
  } else {
    return false;
  }
});
$p.ati = (function(c, value) {
  if ((c.key === $m_Lcom_papasofokli_input_Key$().ER)) {
    if ((value === "")) {
      var $x_1 = true;
    } else {
      var str = $m_Lcom_papasofokli_input_Key$().ER;
      var $x_1 = ((value.indexOf(str) | 0) === 0);
    }
    if ($x_1) {
      return true;
    } else {
      var s = $m_Lcom_papasofokli_input_Key$().ER;
      return ((value.indexOf(s) | 0) !== (-1));
    }
  } else {
    return false;
  }
});
$p.agz = (function(c, value) {
  return ((c.key === $m_Lcom_papasofokli_input_Key$().JB) && ($m_sc_StringOps$(), (value !== "")));
});
var $d_Lcom_papasofokli_input_InputHelperJs$ = new $TypeData().i($c_Lcom_papasofokli_input_InputHelperJs$, "com.papasofokli.input.InputHelperJs$", ({
  p3: 1
}));
var $n_Lcom_papasofokli_input_InputHelperJs$;
function $m_Lcom_papasofokli_input_InputHelperJs$() {
  if ((!$n_Lcom_papasofokli_input_InputHelperJs$)) {
    $n_Lcom_papasofokli_input_InputHelperJs$ = new $c_Lcom_papasofokli_input_InputHelperJs$();
  }
  return $n_Lcom_papasofokli_input_InputHelperJs$;
}
function $p_Lcom_papasofokli_input_InputJs$__timeoutEvent__Lorg_scalajs_dom_Event__sjs_js_Any($thiz, event) {
  var elementId = event.target.id;
  var this$1 = $thiz.Jy.b9(elementId);
  if ((!this$1.c())) {
    $m_sjs_js_timers_package$().afT(this$1.h());
  }
  $thiz.Jy.Vc(elementId);
  var timerHandle = $m_sjs_js_timers_package$().gb($thiz.ZN, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_input_InputJs$__inputChange__Lorg_scalajs_dom_Event__s_concurrent_Future($thiz, event);
  })));
  $thiz.Jy.aD(new $c_T2(elementId, timerHandle));
}
function $p_Lcom_papasofokli_input_InputJs$__inputChange__Lorg_scalajs_dom_Event__s_concurrent_Future($thiz, event) {
  var element = event.target;
  var id = element.id;
  var value = element.value;
  var this$1 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id$1 = $m_ju_UUID$().aO(id);
  var executionContext = $m_sjs_concurrent_JSExecutionContext$Implicits$().kx;
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, id$1.g(), value, executionContext);
}
function $p_Lcom_papasofokli_input_InputJs$__fun$1__sjs_js_Function1__Lorg_scalajs_dom_Element__V($thiz, ic$1, e) {
  e.onkeydown = ic$1;
  e.onchange = ic$1;
  e.onfocusout = ic$1;
  e.onblur = ic$1;
  e.oninput = ic$1;
  e.classList.remove("not-initialized-input");
}
/** @constructor */
function $c_Lcom_papasofokli_input_InputJs$() {
  this.ZN = 0.0;
  this.Jy = null;
  $n_Lcom_papasofokli_input_InputJs$ = this;
  this.ZN = 200.0;
  this.Jy = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
}
$p = $c_Lcom_papasofokli_input_InputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_InputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_InputJs$() {
}
$h_Lcom_papasofokli_input_InputJs$.prototype = $p;
$p.av3 = (function() {
  var ic = ((_$1$2) => $p_Lcom_papasofokli_input_InputJs$__timeoutEvent__Lorg_scalajs_dom_Event__sjs_js_Any(this, _$1$2));
  var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".not-initialized-input"));
  var it = this$3.l();
  while (it.f()) {
    $p_Lcom_papasofokli_input_InputJs$__fun$1__sjs_js_Function1__Lorg_scalajs_dom_Element__V(this, ic, it.e());
  }
});
var $d_Lcom_papasofokli_input_InputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_InputJs$, "com.papasofokli.input.InputJs$", ({
  p4: 1
}));
var $n_Lcom_papasofokli_input_InputJs$;
function $m_Lcom_papasofokli_input_InputJs$() {
  if ((!$n_Lcom_papasofokli_input_InputJs$)) {
    $n_Lcom_papasofokli_input_InputJs$ = new $c_Lcom_papasofokli_input_InputJs$();
  }
  return $n_Lcom_papasofokli_input_InputJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_Key$() {
  this.ES = null;
  this.ER = null;
  this.JB = null;
  this.EQ = null;
  this.ZV = null;
  this.ZX = null;
  this.Ow = null;
  this.JC = null;
  this.ZO = null;
  this.Ov = null;
  this.ZQ = null;
  this.ZP = null;
  this.ZS = null;
  this.ZR = null;
  this.Jz = null;
  this.JA = null;
  this.ZU = null;
  this.ZT = null;
  this.ZW = null;
  $n_Lcom_papasofokli_input_Key$ = this;
  this.ES = $m_sci_Seq$().Mj($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]));
  this.ER = ".";
  this.JB = "-";
  this.EQ = "Backspace";
  this.ZV = "Delete";
  this.ZX = "Tab";
  this.Ow = "Escape";
  this.JC = "Enter";
  this.ZO = "A";
  this.Ov = "C";
  this.ZQ = "X";
  this.ZP = "V";
  this.ZS = "ArrowRight";
  this.ZR = "ArrowLeft";
  this.Jz = "ArrowDown";
  this.JA = "ArrowUp";
  this.ZU = new $c_sci_$colon$colon(this.Jz, new $c_sci_$colon$colon(this.JA, $m_sci_Nil$()));
  this.ZT = new $c_sci_$colon$colon(this.ZS, new $c_sci_$colon$colon(this.ZR, new $c_sci_$colon$colon(this.Jz, new $c_sci_$colon$colon(this.JA, $m_sci_Nil$()))));
  this.ZW = new $c_sci_$colon$colon(0, new $c_sci_$colon$colon(1, $m_sci_Nil$()));
}
$p = $c_Lcom_papasofokli_input_Key$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_Key$;
/** @constructor */
function $h_Lcom_papasofokli_input_Key$() {
}
$h_Lcom_papasofokli_input_Key$.prototype = $p;
var $d_Lcom_papasofokli_input_Key$ = new $TypeData().i($c_Lcom_papasofokli_input_Key$, "com.papasofokli.input.Key$", ({
  p5: 1
}));
var $n_Lcom_papasofokli_input_Key$;
function $m_Lcom_papasofokli_input_Key$() {
  if ((!$n_Lcom_papasofokli_input_Key$)) {
    $n_Lcom_papasofokli_input_Key$ = new $c_Lcom_papasofokli_input_Key$();
  }
  return $n_Lcom_papasofokli_input_Key$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_LongInputJs$() {
  this.ZY = null;
  $n_Lcom_papasofokli_input_LongInputJs$ = this;
  this.ZY = $m_Lcom_papasofokli_input_Key$().ES.aV($m_Lcom_papasofokli_input_Key$().JB);
}
$p = $c_Lcom_papasofokli_input_LongInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_LongInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_LongInputJs$() {
}
$h_Lcom_papasofokli_input_LongInputJs$.prototype = $p;
$p.UU = (function(c) {
  var element = c.currentTarget;
  var value = element.valueOf().value;
  if ((((!this.ZY.az(c.key)) && (!$m_Lcom_papasofokli_input_InputHelperJs$().afD(c))) || $m_Lcom_papasofokli_input_InputHelperJs$().agz(c, value))) {
    c.preventDefault();
  }
});
$p.co = (function() {
  $m_Lcom_papasofokli_util_package$().fo("long-input").each(((this$1) => (function() {
    if ((!(!(this instanceof HTMLInputElement)))) {
      this.onkeypress = ((_$1$2) => {
        this$1.UU(_$1$2);
      });
    }
  }))(this));
});
var $d_Lcom_papasofokli_input_LongInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_LongInputJs$, "com.papasofokli.input.LongInputJs$", ({
  p6: 1
}));
var $n_Lcom_papasofokli_input_LongInputJs$;
function $m_Lcom_papasofokli_input_LongInputJs$() {
  if ((!$n_Lcom_papasofokli_input_LongInputJs$)) {
    $n_Lcom_papasofokli_input_LongInputJs$ = new $c_Lcom_papasofokli_input_LongInputJs$();
  }
  return $n_Lcom_papasofokli_input_LongInputJs$;
}
function $p_Lcom_papasofokli_input_MoneyInputJs$__handleKeyPress$2__s_Option__sjs_js_Function1__Lorg_scalajs_dom_HTMLInputElement__T__Lorg_scalajs_dom_KeyboardEvent__V($thiz, maxLimitO$2, existingOnKeyDown$2, input, rawValue, e) {
  if ($m_Lcom_papasofokli_input_Key$().ES.az(e.key)) {
    var newRawValue = (("" + rawValue) + e.key);
    var this$3 = ($m_sc_StringOps$(), $m_sc_StringParsers$().Er(newRawValue));
    var $x_1 = $uJ((this$3.c() ? $bL(0, 0) : this$3.h()));
    var newValue_$_lo = $x_1.l;
    var newValue_$_hi = $x_1.h;
    matchResult2: {
      if ((maxLimitO$2 instanceof $c_s_Some)) {
        var $x_2 = $uJ(maxLimitO$2.bg);
        var maxLimit_$_lo = $x_2.l;
        var maxLimit_$_hi = $x_2.h;
        if (((newValue_$_hi === maxLimit_$_hi) ? ((newValue_$_lo >>> 0) > (maxLimit_$_lo >>> 0)) : (newValue_$_hi > maxLimit_$_hi))) {
          e.preventDefault();
          break matchResult2;
        }
      }
      input.value = $thiz.Um(newRawValue);
      $thiz.aje(existingOnKeyDown$2, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((input$2, rawValue$2) => new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rawValue$3) => ((e$3) => {
        $p_Lcom_papasofokli_input_MoneyInputJs$__handleKeyPress$2__s_Option__sjs_js_Function1__Lorg_scalajs_dom_HTMLInputElement__T__Lorg_scalajs_dom_KeyboardEvent__V($thiz, maxLimitO$2, existingOnKeyDown$2, input$2, rawValue$3, e$3);
      }))(rawValue$2)))), input, e, newRawValue);
    }
  } else if ((e.key === $m_Lcom_papasofokli_input_Key$().EQ)) {
    var newRawValue$2 = (($m_sc_StringOps$(), (rawValue !== "")) ? $m_sc_StringOps$().agI(rawValue, 1) : "");
    input.value = ((newRawValue$2 === "") ? "0.00" : $thiz.Um(newRawValue$2));
    $thiz.aje(existingOnKeyDown$2, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((input$2$1, rawValue$2$1) => new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rawValue$4) => ((e$3$1) => {
      $p_Lcom_papasofokli_input_MoneyInputJs$__handleKeyPress$2__s_Option__sjs_js_Function1__Lorg_scalajs_dom_HTMLInputElement__T__Lorg_scalajs_dom_KeyboardEvent__V($thiz, maxLimitO$2, existingOnKeyDown$2, input$2$1, rawValue$4, e$3$1);
    }))(rawValue$2$1)))), input, e, newRawValue$2);
  }
}
/** @constructor */
function $c_Lcom_papasofokli_input_MoneyInputJs$() {
}
$p = $c_Lcom_papasofokli_input_MoneyInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_MoneyInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_MoneyInputJs$() {
}
$h_Lcom_papasofokli_input_MoneyInputJs$.prototype = $p;
$p.ax0 = (function(input, key) {
  var init = ({
    "key": key,
    "bubbles": true,
    "cancelable": true
  });
  var event = new KeyboardEvent("keydown", init);
  input.dispatchEvent(event);
});
$p.an1 = (function(e) {
  e.onclick = ((_$1$2) => {
    this.auD(e);
  });
  e.classList.remove("d3e90d8e-44f0-4846-9e04-053479f052be");
});
$p.auD = (function(button) {
  var value = button.value;
  var inputIdO = ((!(!button.hasAttribute("data-input-id"))) ? $m_s_Option$().Z(button.getAttribute("data-input-id")) : $m_s_None$());
  matchResult1: {
    if ((inputIdO instanceof $c_s_Some)) {
      var inputId = inputIdO.bg;
      this.ax0(document.getElementById(inputId), value);
      break matchResult1;
    }
    if (($m_s_None$() === inputIdO)) {
      break matchResult1;
    }
    throw new $c_s_MatchError(inputIdO);
  }
});
$p.Um = (function(value) {
  return $m_sc_StringOps$().Ul("%.2f", $m_sr_ScalaRunTime$().IE(new $ac_O([(($m_sc_StringOps$(), $m_jl_Double$().fS(value)) / 100.0)])));
});
$p.aje = (function(existingOnKeyDown, handleKeyPress, input, event, newRawValue) {
  event.preventDefault();
  input.onkeydown = ((_$2$2) => handleKeyPress.cm(input, newRawValue).p(_$2$2));
  existingOnKeyDown(event);
});
$p.avd = (function(e) {
  if ((!(!e.hasAttribute("data-max-cents")))) {
    $m_sc_StringOps$();
    var x = e.getAttribute("data-max-cents");
    var maxLimitO = $m_sc_StringParsers$().Er(x);
  } else {
    var maxLimitO = $m_s_None$();
  }
  var formattedValue = e.value;
  var initialRawValue = formattedValue.split(".").join("");
  var existingOnKeyDown = e.onkeydown;
  e.value = ((initialRawValue === "") ? "0.00" : this.Um(initialRawValue));
  e.onkeydown = ((_$3$2) => {
    $p_Lcom_papasofokli_input_MoneyInputJs$__handleKeyPress$2__s_Option__sjs_js_Function1__Lorg_scalajs_dom_HTMLInputElement__T__Lorg_scalajs_dom_KeyboardEvent__V(this, maxLimitO, existingOnKeyDown, e, initialRawValue, _$3$2);
  });
  e.classList.remove("ddb8d638-11ca-45a5-886a-bdccdf925782");
});
$p.co = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".ddb8d638-11ca-45a5-886a-bdccdf925782"));
  var it = this$2.l();
  while (it.f()) {
    this.avd(it.e());
  }
  var this$4 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".d3e90d8e-44f0-4846-9e04-053479f052be"));
  var it$1 = this$4.l();
  while (it$1.f()) {
    this.an1(it$1.e());
  }
});
var $d_Lcom_papasofokli_input_MoneyInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_MoneyInputJs$, "com.papasofokli.input.MoneyInputJs$", ({
  p7: 1
}));
var $n_Lcom_papasofokli_input_MoneyInputJs$;
function $m_Lcom_papasofokli_input_MoneyInputJs$() {
  if ((!$n_Lcom_papasofokli_input_MoneyInputJs$)) {
    $n_Lcom_papasofokli_input_MoneyInputJs$ = new $c_Lcom_papasofokli_input_MoneyInputJs$();
  }
  return $n_Lcom_papasofokli_input_MoneyInputJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_input_SelectInputHelper$() {
  this.OA = null;
  this.a07 = null;
  this.a00 = null;
  this.a01 = null;
  this.a06 = null;
  this.ZZ = null;
  this.a04 = null;
  this.a05 = null;
  this.a02 = null;
  this.JE = null;
  this.i0 = null;
  this.a03 = null;
  this.ET = null;
  this.Ox = null;
  this.JF = null;
  this.OC = null;
  this.a09 = null;
  this.Oz = null;
  this.OB = null;
  this.JD = null;
  this.gl = null;
  this.a08 = null;
  this.a0a = null;
  this.Oy = null;
  this.a0b = null;
  this.wD = null;
  this.a0c = null;
  this.OA = "d3ac5426-9354-11ee-b9d1-0242ac120002";
  this.a07 = "data-options-function-id";
  this.a00 = "data-create-function-id";
  this.a01 = "data-disabled";
  this.a06 = "data-options-div-id";
  this.ZZ = "data-control-div-id";
  this.a04 = "data-max-items";
  this.a05 = "data-max-options";
  this.a02 = "data-force-server-side";
  this.JE = "data-value";
  this.i0 = "data-selectable";
  this.a03 = "data-link";
  this.ET = "data-selected";
  this.Ox = "data-order";
  this.JF = "placeholder";
  this.OC = "title";
  this.a09 = "multiple";
  this.Oz = "item";
  this.OB = "option";
  this.JD = "create";
  this.gl = "hidden";
  this.a08 = "Click to exclude";
  this.a0a = "Click to open";
  this.Oy = "disabled";
  this.a0b = "option-highlight";
  this.wD = "item-highlight";
  this.a0c = "label-option";
}
$p = $c_Lcom_papasofokli_input_SelectInputHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_SelectInputHelper$;
/** @constructor */
function $h_Lcom_papasofokli_input_SelectInputHelper$() {
}
$h_Lcom_papasofokli_input_SelectInputHelper$.prototype = $p;
var $d_Lcom_papasofokli_input_SelectInputHelper$ = new $TypeData().i($c_Lcom_papasofokli_input_SelectInputHelper$, "com.papasofokli.input.SelectInputHelper$", ({
  p8: 1
}));
var $n_Lcom_papasofokli_input_SelectInputHelper$;
function $m_Lcom_papasofokli_input_SelectInputHelper$() {
  if ((!$n_Lcom_papasofokli_input_SelectInputHelper$)) {
    $n_Lcom_papasofokli_input_SelectInputHelper$ = new $c_Lcom_papasofokli_input_SelectInputHelper$();
  }
  return $n_Lcom_papasofokli_input_SelectInputHelper$;
}
function $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$lzyINIT1$1__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$1, disabled$1) {
  return (isDisabled$lzy1$1.D8 ? isDisabled$lzy1$1.D9 : isDisabled$lzy1$1.ahK($m_sc_StringOps$().zW(disabled$1, disabled$1)));
}
function $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$18__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$2, disabled$2) {
  return (isDisabled$lzy1$2.D8 ? isDisabled$lzy1$2.D9 : $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$lzyINIT1$1__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$2, disabled$2));
}
function $p_Lcom_papasofokli_input_SelectInputJs$__fun$1__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element__V($thiz, executionContext$15, e) {
  var isDisabled$lzy1 = new $c_sr_LazyBoolean();
  var optionsFunctionId = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a07);
  var createFunctionId = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a00);
  var disabled = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a01);
  var this$2 = $m_sc_StringOps$();
  var x = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a02);
  var forceServerSide = this$2.zW(x, x);
  var optionsDivId = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a06);
  var controlDivId = e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().ZZ);
  $m_sc_StringOps$();
  var maxItems = $m_jl_Integer$().c7(e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a04), 10, 214748364);
  $m_sc_StringOps$();
  var maxOptions = $m_jl_Integer$().c7(e.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().a05), 10, 214748364);
  var optionsDiv = document.getElementById(optionsDivId);
  var optionsContainerDiv = document.getElementById((optionsDivId + "_container"));
  var controlDiv = document.getElementById(controlDivId);
  var controlInput = document.getElementById((controlDivId + "_input"));
  var parentDiv = controlDiv.parentElement;
  var addOptionHtml = optionsContainerDiv.innerHTML;
  var isMulti = (!(!parentDiv.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().a09)));
  $thiz.i1.aD(new $c_T2(e.id, $m_sci_Nil$()));
  $thiz.AB.aD(new $c_T2(e.id, false));
  $thiz.JG.aD(new $c_T2(e.id, ""));
  $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(optionsFunctionId, "", executionContext$15).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((isDisabled$lzy1$3) => ((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    $thiz.aiM($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J), optionsContainerDiv, addOptionHtml);
    var totalOptions = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children).F();
    var serverSide = ((totalOptions >= maxOptions) || forceServerSide);
    $thiz.axV(parentDiv, optionsDiv, controlInput, controlDiv, e, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, serverSide, executionContext$15, $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$18__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$3, disabled));
    $thiz.atf(e, controlDiv, $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$18__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$3, disabled));
    $thiz.J7(controlInput, e, controlDiv, 20, 5);
    $thiz.axT(parentDiv, controlDiv, optionsDiv, controlInput, e, optionsContainerDiv, maxItems, isMulti, totalOptions, addOptionHtml, createFunctionId, optionsFunctionId, serverSide, executionContext$15, $p_Lcom_papasofokli_input_SelectInputJs$__isDisabled$18__sr_LazyBoolean__T__Z($thiz, isDisabled$lzy1$3, disabled));
    return $thiz.UG(e, executionContext$15).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$1) => ((x$1$2) => text$1))(text$2)), executionContext$15);
  })), executionContext$15)))(isDisabled$lzy1)), executionContext$15);
  e.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().OA);
}
/** @constructor */
function $c_Lcom_papasofokli_input_SelectInputJs$() {
  this.a0d = 0.0;
  this.i1 = null;
  this.AB = null;
  this.JG = null;
  this.OD = null;
  $n_Lcom_papasofokli_input_SelectInputJs$ = this;
  this.a0d = 300.0;
  this.i1 = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
  this.AB = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
  this.JG = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
  this.OD = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
}
$p = $c_Lcom_papasofokli_input_SelectInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_SelectInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_SelectInputJs$() {
}
$h_Lcom_papasofokli_input_SelectInputJs$.prototype = $p;
$p.atf = (function(input, controlDiv, isDisabled) {
  if (isDisabled) {
    input.disabled = true;
    controlDiv.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().Oy);
  }
});
$p.Vu = (function(element, hide) {
  if (hide) {
    element.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().gl);
  } else {
    element.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().gl);
  }
});
$p.aiM = (function(content, optionsContainerDiv, addOptionHtml) {
  optionsContainerDiv.innerHTML = ($m_sc_StringOps$(), (("" + content) + addOptionHtml));
  this.ay5(optionsContainerDiv);
});
$p.ay5 = (function(optionsContainerDiv) {
  var options = optionsContainerDiv.children;
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(options);
  $m_sci_Seq$().fM(this$2).bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult1: {
      if ((x$1$3 !== null)) {
        var elem = x$1$3.P();
        var index = (x$1$3.V() | 0);
        elem.setAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().Ox, ("" + index));
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
});
$p.J7 = (function(controlInput, originalInput, controlDiv, spacing, minRemaining) {
  var items = this.i1.p(originalInput.id);
  var containerRect = controlDiv.getBoundingClientRect();
  if (((((+containerRect.right) - (+containerRect.left)) <= 0.0) && (!items.c()))) {
    if ((!(!(!controlInput.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().gl))))) {
      controlInput.style.width = "0px";
    }
  } else {
    if ((!items.c())) {
      var itemRects = items.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.getBoundingClientRect())));
      var m = $m_scm_Map$().ce();
      var it = itemRects.l();
      while (it.f()) {
        var elem = it.e();
        var a = (+elem.top);
        var $x_1 = $m_RTLong$().jq((+Math.round(a)));
        var key_$_lo = $x_1.l;
        var key_$_hi = $x_1.h;
        m.oM($bL(key_$_lo, key_$_hi), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$3) => (() => this$3.dw()))(itemRects))).aD(elem);
      }
      var result = $m_sci_HashMap$().kr;
      var mapIt = m.l();
      while (mapIt.f()) {
        var x1 = mapIt.e();
        x1.P();
        x1.V();
        var \u03b42$ = x1;
        var k$2 = \u03b42$.P();
        var v$2 = \u03b42$.V();
        result = result.jC(k$2, v$2.aR());
      }
      var lineGroups = result;
      var this$5 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(lineGroups.zQ(), $m_s_math_Ordering$Long$());
      var this$7 = (this$5.c() ? $m_s_None$() : new $c_s_Some(lineGroups.p(this$5.h())));
      var lastLine = (this$7.c() ? $m_sci_Nil$() : this$7.h());
      var this$9 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(lastLine.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => (+_$2$2.right)))), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
      var lastLineRight = (+(this$9.c() ? (+containerRect.left) : this$9.h()));
    } else {
      var lastLineRight = (+containerRect.left);
    }
    var b = (((+containerRect.right) - lastLineRight) - spacing);
    var remainingWidth = (+Math.max(0.0, b));
    var remaining = ((remainingWidth < minRemaining) ? "100%" : ((+Math.floor(remainingWidth)) + "px"));
    controlInput.style.width = remaining;
  }
});
$p.ahP = (function(maxItems, originalInput, totalOptions, isServerSide) {
  var selected = this.i1.p(originalInput.id).F();
  return (((maxItems <= selected) && (maxItems !== 0)) || ((selected === totalOptions) && (!isServerSide)));
});
$p.anf = (function(optionsDiv, controlInput, originalInput, optionsContainerDiv, createFunctionId, isMulti) {
  optionsContainerDiv.scrollTop = 0.0;
  if (((!isMulti) && (!this.i1.p(originalInput.id).c()))) {
    this.Vu(controlInput, true);
  }
  this.AB.aD(new $c_T2(originalInput.id, false));
  this.Vu(optionsDiv, true);
  controlInput.value = "";
  this.Vo(controlInput, optionsContainerDiv, createFunctionId);
  this.Mm(optionsContainerDiv);
});
$p.awF = (function(controlInput, optionsDiv, originalInput, maxItems, isMulti, totalOptions, isServerSide) {
  if (((!(!this.AB.p(originalInput.id))) || (isMulti && this.ahP(maxItems, originalInput, totalOptions, isServerSide)))) {
    controlInput.blur();
  } else {
    controlInput.focus();
    this.AB.aD(new $c_T2(originalInput.id, true));
    this.Vu(optionsDiv, false);
  }
});
$p.VM = (function(controlInput, originalInput) {
  if (((!this.i1.p(originalInput.id).c()) || ($m_sc_StringOps$(), (controlInput.value !== "")))) {
    controlInput.removeAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().JF);
  } else {
    controlInput.setAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().JF, originalInput.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().JF));
  }
});
$p.asN = (function(item, parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, createFunctionId, serverSide, executionContext, isDisabled) {
  var tooltip = (isMulti ? $m_Lcom_papasofokli_input_SelectInputHelper$().a08 : $m_Lcom_papasofokli_input_SelectInputHelper$().a0a);
  item.removeAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().i0);
  item.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().OB);
  item.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().Oz);
  item.setAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().OC, tooltip);
  item.onmousedown = ((e$2) => ((!(controlInput.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().Oy) !== null)) ? (e$2.preventDefault(), e$2.stopPropagation(), (isMulti ? (this.agB(parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, $m_s_Option$().Z(item), createFunctionId, serverSide, executionContext, isDisabled), (void 0)) : (controlInput.focus(), (void 0)))) : (void 0)));
});
$p.agg = (function(item, parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  item.setAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().i0, "");
  item.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().OB);
  item.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().Oz);
  item.removeAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().OC);
  item.onmousedown = ((m$2) => {
    this.V4(parentDiv, m$2, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
  });
  return item;
});
$p.M7 = (function(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, item, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, init, executionContext, isDisabled) {
  if ((item.querySelector("mark") !== null)) {
    item.innerHTML = item.textContent;
  }
  var items = this.i1.p(originalInput.id);
  if (isMulti) {
    this.i1.aD(new $c_T2(originalInput.id, items.aV(item)));
  } else {
    if ((!items.c())) {
      var option = items.bj();
      matchResult2: {
        if ((option instanceof $c_s_Some)) {
          var itm = option.bg;
          try {
            controlDiv.removeChild(itm);
          } catch (e) {
            controlDiv.replaceChildren();
          }
          var option$2 = this.agg(itm, parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
          optionsContainerDiv.append(option$2);
          break matchResult2;
        }
        if (($m_s_None$() === option)) {
          break matchResult2;
        }
        throw new $c_s_MatchError(option);
      }
    }
    this.i1.aD(new $c_T2(originalInput.id, new $c_sci_$colon$colon(item, $m_sci_Nil$())));
  }
  this.asN(item, parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
  item.remove();
  this.akm(originalInput);
  controlDiv.prepend(item);
  if (this.ahP(maxItems, originalInput, totalOptions, isServerSide)) {
    controlInput.blur();
  }
  if ((!init)) {
    this.ayz(originalInput, executionContext);
  }
  controlInput.value = "";
  this.Vo(controlInput, optionsContainerDiv, createFunctionId);
  this.VM(controlInput, originalInput);
  this.J7(controlInput, originalInput, controlDiv, 20, 5);
  this.Mm(optionsContainerDiv);
  if ((!isMulti)) {
    this.ajU(optionsContainerDiv);
  }
});
$p.akm = (function(originalInput) {
  originalInput.setAttribute("value", $f_sc_IterableOnceOps__mkString__T__T__T__T(this.i1.p(originalInput.id).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => _$3$2.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().JE)))), "", ",", ""));
});
$p.V4 = (function(parentDiv, m, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  var target = m.currentTarget;
  matchResult3: {
    if ((!(!(target instanceof HTMLElement)))) {
      if ($f_sc_MapOps__contains__O__Z(new $c_Lorg_scalajs_dom_NamedNodeMapMap(target.attributes), $m_Lcom_papasofokli_input_SelectInputHelper$().i0)) {
        m.preventDefault();
        m.stopPropagation();
        this.M7(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, target, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, false, executionContext, isDisabled);
        break matchResult3;
      }
      if ($f_sc_MapOps__contains__O__Z(new $c_Lorg_scalajs_dom_NamedNodeMapMap(target.attributes), $m_Lcom_papasofokli_input_SelectInputHelper$().a03)) {
        target.querySelector("a").click();
        controlInput.focus();
        break matchResult3;
      }
      if ((!(!target.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().JD)))) {
        this.ata(controlInput.value, createFunctionId, executionContext);
        break matchResult3;
      }
      if ((!(!target.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().a0c)))) {
        m.preventDefault();
        m.stopPropagation();
        controlInput.focus();
        break matchResult3;
      }
    }
  }
});
$p.ajU = (function(optionsContainerDiv) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children);
  var options = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fM(this$2), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    $m_sc_StringOps$();
    var x = _$4$2.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().Ox);
    var this$6 = $m_sc_StringParsers$().fs(x);
    return ((this$6.c() ? 0 : this$6.h()) | 0);
  })), $m_s_math_Ordering$Int$());
  optionsContainerDiv.innerHTML = "";
  options.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => optionsContainerDiv.appendChild(_$5$2))));
});
$p.agB = (function(parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, itemToDelete, createFunctionId, isServerSide, executionContext, isDisabled) {
  var allSeq = this.i1.p(originalInput.id);
  var itemToDeleteO = (itemToDelete.c() ? allSeq.bj() : itemToDelete);
  matchResult4: {
    if ((itemToDeleteO instanceof $c_s_Some)) {
      var item = itemToDeleteO.bg;
      var newAllSeq = allSeq.bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => (_$6$2.id === item.id))));
      controlDiv.removeChild(item);
      optionsContainerDiv.append(this.agg(item, parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled));
      this.i1.aD(new $c_T2(originalInput.id, newAllSeq));
      this.akm(originalInput);
      this.UG(originalInput, executionContext);
      this.J7(controlInput, originalInput, controlDiv, 20, 5);
      this.VM(controlInput, originalInput);
      controlInput.focus();
      this.Mm(optionsContainerDiv);
      this.ajU(optionsContainerDiv);
      break matchResult4;
    }
    if (($m_s_None$() === itemToDeleteO)) {
      break matchResult4;
    }
    throw new $c_s_MatchError(itemToDeleteO);
  }
});
$p.Vo = (function(controlInput, optionsContainerDiv, createFunctionId) {
  var this$1 = controlInput.value;
  var text = this$1.toLowerCase();
  var options = optionsContainerDiv.querySelectorAll((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]"));
  var textTokens = $m_sc_ArrayOps$().NC($f_T__split__T__I__AT(text.toLowerCase(), " ", 0));
  this.ajL(((!textTokens.c()) ? $f_sc_IterableOps__flatMap__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(options), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => ((!(!(!textTokens.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((token$2) => {
    var this$7 = t$2.textContent;
    var this$8 = this$7.toLowerCase();
    return ((this$8.indexOf(token$2) | 0) !== (-1));
  }))).gM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$7$3, _$8$3) => {
    var _$7$2 = (!(!_$7$3));
    var _$8$2 = (!(!_$8$3));
    return (_$7$2 && _$8$2);
  })))))) ? (t$2.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().gl), $m_s_None$()) : (t$2.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().gl), $m_s_Option$().Z(t$2)))))).cf() : $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(options), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$1) => {
    t$2$1.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().gl);
    return t$2$1;
  }))).cf()), optionsContainerDiv, createFunctionId, text);
  this.aiP(optionsContainerDiv, text);
});
$p.ajL = (function(availableOptions, optionsContainerDiv, createFunctionId, text) {
  if (((((createFunctionId !== null) && ($m_sc_StringOps$(), (createFunctionId !== ""))) && availableOptions.c()) && ($m_sc_StringOps$(), (text !== "")))) {
    optionsContainerDiv.querySelector(("." + $m_Lcom_papasofokli_input_SelectInputHelper$().JD)).classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().gl);
  } else if (((createFunctionId !== null) && ($m_sc_StringOps$(), (createFunctionId !== "")))) {
    optionsContainerDiv.querySelector(("." + $m_Lcom_papasofokli_input_SelectInputHelper$().JD)).classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().gl);
  }
});
$p.axM = (function(controlInput, optionsContainerDiv, addOptionHtml, createFunctionId, optionsFunctionId, parentDiv, optionsDiv, controlDiv, originalInput, isMulti, maxItems, totalOptions, isServerSide, executionContext, isDisabled) {
  var this$1 = controlInput.value;
  var newText = $f_T__strip__T(this$1.toLowerCase());
  return ((newText !== this.JG.p(originalInput.id)) ? (this.JG.aD(new $c_T2(originalInput.id, newText)), $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(optionsFunctionId, newText, executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    this.aiM($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J), optionsContainerDiv, addOptionHtml);
    var this$8 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.querySelectorAll((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().ET) + "=true]")));
    var it = this$8.l();
    while (it.f()) {
      var x0 = it.e();
      x0.remove();
    }
    this.ajL($f_sc_IterableOps__init__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children)).cf(), optionsContainerDiv, createFunctionId, text$3);
    var this$12 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children);
    var it$1 = this$12.l();
    while (it$1.f()) {
      var x0$1 = it$1.e();
      if ((!(!(x0$1 instanceof HTMLDivElement)))) {
        x0$1.removeAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().ET);
        x0$1.onmousedown = ((parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) => ((m$2) => {
          this.V4(parentDiv, m$2, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
        }))(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
      }
    }
    this.aiP(optionsContainerDiv, newText);
  })), executionContext))), executionContext)) : (void 0));
});
$p.awB = (function(parentDiv, originalInput, optionsContainerDiv, event, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  var isOpen = (!(!this.AB.p(originalInput.id)));
  matchResult11: {
    var x22 = event.key;
    if (($m_Lcom_papasofokli_input_Key$().Ow === x22)) {
      if (isOpen) {
        event.preventDefault();
        event.stopPropagation();
        controlInput.blur();
        break matchResult11;
      } else {
        break matchResult11;
      }
    }
    if (($m_Lcom_papasofokli_input_Key$().JC === x22)) {
      this.atv(parentDiv, originalInput, optionsContainerDiv, isOpen, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled);
      break matchResult11;
    }
    if (($m_Lcom_papasofokli_input_Key$().EQ === x22)) {
      if (((!this.i1.p(originalInput.id).c()) && (controlInput.value === ""))) {
        event.preventDefault();
        event.stopPropagation();
        this.agB(parentDiv, controlDiv, optionsDiv, optionsContainerDiv, originalInput, controlInput, maxItems, isMulti, totalOptions, $m_s_None$(), createFunctionId, isServerSide, executionContext, isDisabled);
        this.VM(controlInput, originalInput);
        break matchResult11;
      } else {
        break matchResult11;
      }
    }
    if (($m_Lcom_papasofokli_input_Key$().ZU.az(x22) && isOpen)) {
      event.preventDefault();
      this.amU(x22, optionsContainerDiv);
      break matchResult11;
    }
    if ($m_Lcom_papasofokli_input_InputHelperJs$().avh(event)) {
      this.at7(event, originalInput);
      break matchResult11;
    }
  }
});
$p.awT = (function(event, parentDiv, originalInput, optionsContainerDiv, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  var pastedText = event.clipboardData.getData("text");
  if ((!(!pastedText.startsWith("RF[")))) {
    event.preventDefault();
    var idSeq = $f_T__split__T__I__AT($m_sc_StringOps$().ak1($m_sc_StringOps$().aym(pastedText, "RF["), "]"), ",", 0);
    var idSize = idSeq.a.length;
    var xs = $m_sc_ArrayOps$().aEu(idSeq);
    var f = ((x$1$3) => {
      var id = x$1$3.P();
      var idx = (x$1$3.V() | 0);
      var isLast = (idx === ((idSize - 1) | 0));
      var element = optionsContainerDiv.querySelector((((((((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "][") + $m_Lcom_papasofokli_input_SelectInputHelper$().JE) + "=\"") + id) + "\"]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")"));
      if ((element !== null)) {
        this.M7(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, element, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, (!isLast), executionContext, isDisabled);
      }
    });
    var len = xs.a.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var x0 = xs.a[i];
        f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var x0$1 = xs.a[i];
        f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var x0$2 = xs.a[i];
        f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var $x_1 = xs.a;
        var $x_2 = (i << 1);
        var x0$3_$_lo = $x_1[$x_2];
        var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
        f($bL(x0$3_$_lo, x0$3_$_hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var x0$4 = xs.a[i];
        f(x0$4);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var x0$5 = xs.a[i];
        f($bC(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var x0$6 = xs.a[i];
        f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var x0$7 = xs.a[i];
        f(x0$7);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var x0$8 = xs.a[i];
        f(x0$8);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
});
$p.at7 = (function(event, originalInput) {
  var items = this.i1.f6(originalInput.id, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())));
  if ((!items.c())) {
    event.preventDefault();
    var ids = $f_sc_IterableOnceOps__mkString__T__T__T__T(items.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10$2) => _$10$2.getAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().JE)))), "", ",", "");
    var text = (("RF[" + ids) + "]");
    var textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
});
$p.atv = (function(parentDiv, originalInput, optionsContainerDiv, isOpen, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  var firstHighlighted = optionsContainerDiv.querySelector((((((("." + $m_Lcom_papasofokli_input_SelectInputHelper$().wD) + "[") + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")"));
  var firstNotHiddenChild = ((firstHighlighted !== null) ? firstHighlighted : optionsContainerDiv.querySelector((((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")")));
  if ((isOpen && (firstNotHiddenChild !== null))) {
    this.M7(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, firstNotHiddenChild, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, false, executionContext, isDisabled);
    optionsContainerDiv.scrollTop = 0.0;
  }
});
$p.amU = (function(key, optionsContainerDiv) {
  if (($m_Lcom_papasofokli_input_Key$().JA === key)) {
    this.ahG(optionsContainerDiv, false);
  } else if (($m_Lcom_papasofokli_input_Key$().Jz === key)) {
    this.ahG(optionsContainerDiv, true);
  }
});
$p.ahG = (function(optionsContainerDiv, next) {
  var highlightedItem = optionsContainerDiv.querySelector((((((("." + $m_Lcom_papasofokli_input_SelectInputHelper$().wD) + "[") + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")"));
  if ((highlightedItem !== null)) {
    var elem = this.aup(highlightedItem, true, next);
    if ((((elem !== null) && (!(!(!elem.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().gl))))) && (!(!elem.hasAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().i0))))) {
      this.Mm(optionsContainerDiv);
      elem.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().wD);
      var topPos = (next ? (highlightedItem.clientHeight | 0) : ((-(elem.clientHeight | 0)) | 0));
      optionsContainerDiv.scrollTop = ((+optionsContainerDiv.scrollTop) + topPos);
    }
  } else {
    var firstNotHiddenChild = optionsContainerDiv.querySelector((((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")"));
    if ((firstNotHiddenChild !== null)) {
      firstNotHiddenChild.classList.add($m_Lcom_papasofokli_input_SelectInputHelper$().wD);
    }
  }
});
$p.aup = (function(elem, firstTime, next) {
  var firstTime$tailLocal1 = firstTime;
  var elem$tailLocal1 = elem;
  while (true) {
    if (((((elem$tailLocal1 === null) || (!(!(!elem$tailLocal1.classList.contains($m_Lcom_papasofokli_input_SelectInputHelper$().gl))))) || (!(!elem$tailLocal1.hasAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().i0)))) && (!firstTime$tailLocal1))) {
      return elem$tailLocal1;
    } else if (next) {
      var elem$tailLocal1$tmp1 = elem$tailLocal1.nextElementSibling;
      elem$tailLocal1 = elem$tailLocal1$tmp1;
      firstTime$tailLocal1 = false;
    } else {
      var elem$tailLocal1$tmp2 = elem$tailLocal1.previousElementSibling;
      elem$tailLocal1 = elem$tailLocal1$tmp2;
      firstTime$tailLocal1 = false;
    }
  }
});
$p.Mm = (function(optionsContainerDiv) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.querySelectorAll((((((("." + $m_Lcom_papasofokli_input_SelectInputHelper$().wD) + "[") + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]:not(.") + $m_Lcom_papasofokli_input_SelectInputHelper$().gl) + ")")));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove($m_Lcom_papasofokli_input_SelectInputHelper$().wD);
  }
});
$p.axT = (function(parentDiv, controlDiv, optionsDiv, controlInput, originalInput, optionsContainerDiv, maxItems, isMulti, totalOptions, addOptionHtml, createFunctionId, optionsFunctionId, serverSide, executionContext, isDisabled) {
  controlInput.addEventListener("focus", ((_$12$2) => {
    this.awF(controlInput, optionsDiv, originalInput, maxItems, isMulti, totalOptions, serverSide);
  }));
  controlInput.addEventListener("blur", ((_$13$2) => {
    this.anf(optionsDiv, controlInput, originalInput, optionsContainerDiv, createFunctionId, isMulti);
  }));
  controlDiv.addEventListener("click", ((_$14$2) => {
    controlInput.focus();
  }));
  document.addEventListener("resize", ((_$15$2) => {
    this.J7(controlInput, originalInput, controlDiv, 20, 5);
  }));
  document.addEventListener("shown.bs.collapse", ((event$2) => {
    matchResult13: {
      var x24 = event$2.target;
      if ((!(!(x24 instanceof Element)))) {
        if ((!(!x24.contains(controlDiv)))) {
          this.J7(controlInput, originalInput, controlDiv, 20, 5);
          break matchResult13;
        }
      }
    }
  }));
  var this$7 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children);
  var it = this$7.l();
  while (it.f()) {
    var x0 = it.e();
    if ((!(!(x0 instanceof HTMLDivElement)))) {
      x0.onmousedown = ((parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, serverSide, executionContext, isDisabled) => ((m$2) => ($m_Lcom_papasofokli_input_Key$().ZW.az((m$2.button | 0)) ? (this.V4(parentDiv, m$2, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, serverSide, executionContext, isDisabled), (void 0)) : (m$2.preventDefault(), (void 0)))))(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, serverSide, executionContext, isDisabled);
    }
  }
  controlInput.onkeydown = ((k$2) => {
    this.awB(parentDiv, originalInput, optionsContainerDiv, k$2, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, serverSide, executionContext, isDisabled);
  });
  controlInput.onkeyup = ((_$16$2) => (serverSide ? this.axM(controlInput, optionsContainerDiv, addOptionHtml, createFunctionId, optionsFunctionId, parentDiv, optionsDiv, controlDiv, originalInput, isMulti, maxItems, totalOptions, serverSide, executionContext, isDisabled) : (this.Vo(controlInput, optionsContainerDiv, createFunctionId), (void 0))));
  controlInput.addEventListener("paste", ((e$2) => {
    this.awT(e$2, parentDiv, originalInput, optionsContainerDiv, optionsDiv, controlDiv, controlInput, maxItems, isMulti, totalOptions, createFunctionId, serverSide, executionContext, isDisabled);
  }));
});
$p.aiP = (function(optionsContainerDiv, markedText) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.querySelectorAll((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().i0) + "]")));
  var it = this$2.l();
  while (it.f()) {
    this.awd(it.e(), markedText);
  }
});
$p.awd = (function(e, markedText) {
  var text = $f_T__strip__T(e.textContent);
  var position = $f_sc_SeqOps__indexOfSlice__sc_Seq__I__I($m_s_Predef$().akz(text.toLowerCase()), $m_s_Predef$().akz(markedText.toLowerCase()), 0);
  var cutPoint = ((position + markedText.length) | 0);
  if ((position >= 0)) {
    var textSlice = $m_sc_StringOps$().EB(text, 0, position);
    var markElem = $m_Lscalatags_JsDom$tags2$().awc().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag($m_sc_StringOps$().EB(text, position, cutPoint))), $m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_input_SelectInputHelper$().a0b, $m_Lscalatags_JsDom$all$().s)])).aB().outerHTML;
    var textSliceEnd = $m_sc_StringOps$().EB(text, cutPoint, text.length);
    var finalHtml = ((("" + textSlice) + markElem) + textSliceEnd);
  } else {
    var finalHtml = text;
  }
  e.innerHTML = finalHtml;
});
$p.ata = (function(value, createFunctionId, executionContext) {
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(createFunctionId).g(), value, executionContext);
});
$p.UG = (function(originalInput, executionContext) {
  var this$1 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id = $m_ju_UUID$().aO(originalInput.id);
  var data = originalInput.value;
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, id.g(), data, executionContext);
});
$p.axV = (function(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, executionContext, isDisabled) {
  var options = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.querySelectorAll((("[" + $m_Lcom_papasofokli_input_SelectInputHelper$().ET) + "=true]"))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((option$2) => {
    this.M7(parentDiv, optionsDiv, controlInput, controlDiv, originalInput, optionsContainerDiv, option$2, isMulti, maxItems, totalOptions, createFunctionId, isServerSide, true, executionContext, isDisabled);
    return option$2;
  })));
  $f_sc_IterableOps__concat__sc_IterableOnce__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(optionsContainerDiv.children), options).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18$3) => {
    _$18$3.removeAttribute($m_Lcom_papasofokli_input_SelectInputHelper$().ET);
  })));
});
$p.ayz = (function(originalInput, executionContext) {
  var elementId = originalInput.id;
  var this$1 = this.OD.b9(elementId);
  if ((!this$1.c())) {
    $m_sjs_js_timers_package$().afT(this$1.h());
  }
  var timerHandle = $m_sjs_js_timers_package$().gb(this.a0d, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    this.UG(originalInput, executionContext);
  })));
  this.OD.aD(new $c_T2(elementId, timerHandle));
});
$p.b7 = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(("." + $m_Lcom_papasofokli_input_SelectInputHelper$().OA)));
  var it = this$2.l();
  while (it.f()) {
    $p_Lcom_papasofokli_input_SelectInputJs$__fun$1__s_concurrent_ExecutionContext__Lorg_scalajs_dom_Element__V(this, executionContext, it.e());
  }
});
var $d_Lcom_papasofokli_input_SelectInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_SelectInputJs$, "com.papasofokli.input.SelectInputJs$", ({
  p9: 1
}));
var $n_Lcom_papasofokli_input_SelectInputJs$;
function $m_Lcom_papasofokli_input_SelectInputJs$() {
  if ((!$n_Lcom_papasofokli_input_SelectInputJs$)) {
    $n_Lcom_papasofokli_input_SelectInputJs$ = new $c_Lcom_papasofokli_input_SelectInputJs$();
  }
  return $n_Lcom_papasofokli_input_SelectInputJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_jquery_DraggableSettings$() {
}
$p = $c_Lcom_papasofokli_jquery_DraggableSettings$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jquery_DraggableSettings$;
/** @constructor */
function $h_Lcom_papasofokli_jquery_DraggableSettings$() {
}
$h_Lcom_papasofokli_jquery_DraggableSettings$.prototype = $p;
$p.alK = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
$p.Tt = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
$p.Tu = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
var $d_Lcom_papasofokli_jquery_DraggableSettings$ = new $TypeData().i($c_Lcom_papasofokli_jquery_DraggableSettings$, "com.papasofokli.jquery.DraggableSettings$", ({
  pa: 1
}));
var $n_Lcom_papasofokli_jquery_DraggableSettings$;
function $m_Lcom_papasofokli_jquery_DraggableSettings$() {
  if ((!$n_Lcom_papasofokli_jquery_DraggableSettings$)) {
    $n_Lcom_papasofokli_jquery_DraggableSettings$ = new $c_Lcom_papasofokli_jquery_DraggableSettings$();
  }
  return $n_Lcom_papasofokli_jquery_DraggableSettings$;
}
/** @constructor */
function $c_Lcom_papasofokli_jquery_SortableSettings$() {
}
$p = $c_Lcom_papasofokli_jquery_SortableSettings$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jquery_SortableSettings$;
/** @constructor */
function $h_Lcom_papasofokli_jquery_SortableSettings$() {
}
$h_Lcom_papasofokli_jquery_SortableSettings$.prototype = $p;
$p.Tt = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
$p.Tu = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
$p.alN = (function() {
  return (function(event$3, ui$3) {
    return (void 0);
  });
});
var $d_Lcom_papasofokli_jquery_SortableSettings$ = new $TypeData().i($c_Lcom_papasofokli_jquery_SortableSettings$, "com.papasofokli.jquery.SortableSettings$", ({
  pb: 1
}));
var $n_Lcom_papasofokli_jquery_SortableSettings$;
function $m_Lcom_papasofokli_jquery_SortableSettings$() {
  if ((!$n_Lcom_papasofokli_jquery_SortableSettings$)) {
    $n_Lcom_papasofokli_jquery_SortableSettings$ = new $c_Lcom_papasofokli_jquery_SortableSettings$();
  }
  return $n_Lcom_papasofokli_jquery_SortableSettings$;
}
/** @constructor */
function $c_Lcom_papasofokli_jquery_package$() {
  this.I = null;
  $n_Lcom_papasofokli_jquery_package$ = this;
  this.I = $;
}
$p = $c_Lcom_papasofokli_jquery_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jquery_package$;
/** @constructor */
function $h_Lcom_papasofokli_jquery_package$() {
}
$h_Lcom_papasofokli_jquery_package$.prototype = $p;
var $d_Lcom_papasofokli_jquery_package$ = new $TypeData().i($c_Lcom_papasofokli_jquery_package$, "com.papasofokli.jquery.package$", ({
  pc: 1
}));
var $n_Lcom_papasofokli_jquery_package$;
function $m_Lcom_papasofokli_jquery_package$() {
  if ((!$n_Lcom_papasofokli_jquery_package$)) {
    $n_Lcom_papasofokli_jquery_package$ = new $c_Lcom_papasofokli_jquery_package$();
  }
  return $n_Lcom_papasofokli_jquery_package$;
}
var $d_Lcom_papasofokli_jstree_TreeItemData = new $TypeData().i(1, "com.papasofokli.jstree.TreeItemData", ({
  ce: 1
}));
function $f_Lcom_papasofokli_jstree_TreeT__$init$__V($thiz) {
  $thiz.Kx = "not-initialized-tree";
  $thiz.a8d = "node-setup-function";
  $thiz.a8c = "node-click-function";
  $thiz.a8a = "leaf-click-function";
  $thiz.a89 = "data-context-menu";
  $thiz.a8b = "li-class-name";
  $thiz.xO = "node-single-click";
  $thiz.Qr = "node-double-click";
  $thiz.Qp = "leaf-single-click";
  $thiz.Ch = "scala-tree-node-expanded";
  $thiz.Ci = "scala-tree-item-selected";
  $thiz.Kw = "scala-tree-toggle-icon fas fa-angle-right";
  $thiz.Qo = "scala-tree-toggle-icon-expanded fas fa-angle-down";
}
function $f_Lcom_papasofokli_navTabs_NavTabsT__$init$__V($thiz) {
  $thiz.uQ = "not-initialized-tab";
  $thiz.WT = "active";
}
/** @constructor */
function $c_Lcom_papasofokli_pagination_PaginationHelper$() {
  this.OM = null;
  this.a0H = null;
  this.a0F = null;
  this.a0B = null;
  this.a0D = null;
  this.a0G = null;
  this.lD = 0;
  this.OO = null;
  this.ON = null;
  this.a0E = null;
  this.a0C = null;
  this.OP = null;
  this.OL = null;
  this.a0z = null;
  this.OJ = null;
  this.OK = null;
  this.OH = null;
  this.JH = null;
  this.sj = null;
  this.a0y = null;
  this.a0A = null;
  this.EW = null;
  this.wE = null;
  this.OI = null;
  this.OM = "not-initialized-pagination";
  this.a0H = "data-total-items";
  this.a0F = "data-rows-page";
  this.a0B = "data-initial-page";
  this.a0D = "data-page-click";
  this.a0G = "data-table-id";
  this.lD = 5;
  this.OO = "page-link";
  this.ON = "page-item";
  this.a0E = "\u00ab";
  this.a0C = "\u00bb";
  this.OP = "prev";
  this.OL = "next";
  this.a0z = "First";
  this.OJ = "Last";
  this.OK = "last";
  this.OH = "first";
  this.JH = "macro";
  this.sj = "data-lp";
  this.a0y = "aria-hidden";
  this.a0A = "href";
  this.EW = "active";
  this.wE = "disabled";
  this.OI = "hidden";
}
$p = $c_Lcom_papasofokli_pagination_PaginationHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pagination_PaginationHelper$;
/** @constructor */
function $h_Lcom_papasofokli_pagination_PaginationHelper$() {
}
$h_Lcom_papasofokli_pagination_PaginationHelper$.prototype = $p;
var $d_Lcom_papasofokli_pagination_PaginationHelper$ = new $TypeData().i($c_Lcom_papasofokli_pagination_PaginationHelper$, "com.papasofokli.pagination.PaginationHelper$", ({
  pz: 1
}));
var $n_Lcom_papasofokli_pagination_PaginationHelper$;
function $m_Lcom_papasofokli_pagination_PaginationHelper$() {
  if ((!$n_Lcom_papasofokli_pagination_PaginationHelper$)) {
    $n_Lcom_papasofokli_pagination_PaginationHelper$ = new $c_Lcom_papasofokli_pagination_PaginationHelper$();
  }
  return $n_Lcom_papasofokli_pagination_PaginationHelper$;
}
/** @constructor */
function $c_Lcom_papasofokli_pagination_PaginationJs$() {
}
$p = $c_Lcom_papasofokli_pagination_PaginationJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pagination_PaginationJs$;
/** @constructor */
function $h_Lcom_papasofokli_pagination_PaginationJs$() {
}
$h_Lcom_papasofokli_pagination_PaginationJs$.prototype = $p;
$p.b7 = (function(executionContext) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().OM)));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().OM);
    var id = x0.id;
    $m_sc_StringOps$();
    var totalItems = $m_jl_Double$().fS(x0.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().a0H));
    $m_sc_StringOps$();
    var rowsPerPage = $m_jl_Double$().fS(x0.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().a0F));
    $m_sc_StringOps$();
    var initialPage = $m_jl_Integer$().c7(x0.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().a0B), 10, 214748364);
    var paginationClickFunctionUUID = x0.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().a0D);
    var parentTableId = x0.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().a0G);
    this.MY(id, totalItems, rowsPerPage, initialPage, $m_Lcom_papasofokli_pagination_PaginationHelper$().OJ, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((paginationClickFunctionUUID, executionContext) => ((v1$2, v2$2) => {
      this.awH(v1$2, (v2$2 | 0), paginationClickFunctionUUID, executionContext);
    }))(paginationClickFunctionUUID, executionContext)), parentTableId);
  }
});
$p.MY = (function(paginationId, totalRecords, rowsPerPage, initialPage, lastButtonString, paginationPageClickedFun, hrefId) {
  var a = (totalRecords / rowsPerPage);
  var total = $doubleToInt((+Math.ceil(a)));
  var hrefAtt = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_pagination_PaginationHelper$().a0A, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(("#" + hrefId), $m_Lscalatags_JsDom$all$().s);
  var e = document.querySelector(("#" + paginationId));
  var firstA = this.U3($m_Lcom_papasofokli_pagination_PaginationHelper$().a0z, hrefAtt);
  var firstLi = this.Iw($m_Lcom_papasofokli_pagination_PaginationHelper$().OH, firstA, 1, true).aB();
  var lastA = this.U3(lastButtonString, hrefAtt);
  var lastLi = this.Iw($m_Lcom_papasofokli_pagination_PaginationHelper$().OK, lastA, total, true).aB();
  var previousSpan = this.agu($m_Lcom_papasofokli_pagination_PaginationHelper$().a0E);
  var previousA = this.agp(previousSpan, hrefAtt);
  var previousLi = this.Iw($m_Lcom_papasofokli_pagination_PaginationHelper$().OP, previousA, 1, true).aB();
  if ((total > $m_Lcom_papasofokli_pagination_PaginationHelper$().lD)) {
    var a$1 = ((1 + $m_Lcom_papasofokli_pagination_PaginationHelper$().lD) | 0);
    var nextLp = ((a$1 < total) ? a$1 : total);
  } else {
    var nextLp = 2;
  }
  var nextSpan = this.agu($m_Lcom_papasofokli_pagination_PaginationHelper$().a0C);
  var nextA = this.agp(nextSpan, hrefAtt);
  var nextLi = this.Iw($m_Lcom_papasofokli_pagination_PaginationHelper$().OL, nextA, nextLp, true).aB();
  var b = $m_Lcom_papasofokli_pagination_PaginationHelper$().lD;
  var end = ((1 + ((total < b) ? total : b)) | 0);
  var isEmpty = (end <= 1);
  var gap = ((end - 1) | 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((gap <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(1, end, 1, false);
  }
  var b$1 = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(1, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    b$1.aD(this.Iw("", this.U3(("" + x0), hrefAtt), x0, false).aB());
  }
  var numbers = b$1.aR();
  if ((numbers.F() > 1)) {
    var elements = new $c_sci_$colon$colon(firstLi, new $c_sci_$colon$colon(previousLi, $m_sci_Nil$())).cY(numbers).cY(new $c_sci_$colon$colon(nextLi, new $c_sci_$colon$colon(lastLi, $m_sci_Nil$())));
    var these = elements;
    while ((!these.c())) {
      var x0$1 = these.W();
      x0$1.onclick = $m_sjs_js_Any$().b3(this.aw0(e, x0$1, paginationPageClickedFun, total));
      e.appendChild(x0$1);
      these = these.ak();
    }
    this.ahL(e, initialPage, total);
  }
});
$p.U3 = (function(text, hrefAtt) {
  return $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_pagination_PaginationHelper$().OO, $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text)), hrefAtt]));
});
$p.agp = (function(span, hrefAtt) {
  return $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_pagination_PaginationHelper$().OO, $m_Lscalatags_JsDom$all$().s), span, hrefAtt]));
});
$p.agu = (function(arrow) {
  return $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_pagination_PaginationHelper$().a0y, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(true, $m_Lscalatags_JsDom$all$().Sx), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(arrow))]));
});
$p.Iw = (function(css, content, dataLp, includeMacro) {
  return (includeMacro ? $m_Lscalatags_JsDom$tags$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((($m_Lcom_papasofokli_pagination_PaginationHelper$().ON + " ") + css), $m_Lscalatags_JsDom$all$().s), content, $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_pagination_PaginationHelper$().JH, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(true, $m_Lscalatags_JsDom$all$().Sx), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_pagination_PaginationHelper$().sj, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(dataLp, $m_Lscalatags_JsDom$all$().qq)])) : $m_Lscalatags_JsDom$tags$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((($m_Lcom_papasofokli_pagination_PaginationHelper$().ON + " ") + css), $m_Lscalatags_JsDom$all$().s), content, $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $m_Lcom_papasofokli_pagination_PaginationHelper$().sj, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(dataLp, $m_Lscalatags_JsDom$all$().qq)])));
});
$p.awH = (function(element, num, paginationClickFunctionUUID, executionContext) {
  element.setAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().wE, "true");
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
  var this$5 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id = $m_ju_UUID$().aO(paginationClickFunctionUUID);
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), num, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().ao);
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$5, id.g(), data, executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => $m_Lcom_papasofokli_util_DelayFuture$().jj(300, 0).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    element.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().wE);
    return freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), executionContext);
  })), executionContext))), executionContext).hj(new $c_Lcom_papasofokli_pagination_PaginationJs$$anon$1(element, freezePage), executionContext);
});
$p.ahL = (function(pagination, page, total) {
  var init = pagination.querySelector(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().EW));
  if ((init !== null)) {
    init.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().EW);
  }
  var a = ((((page - 1) | 0) / $checkIntDivisor($m_Lcom_papasofokli_pagination_PaginationHelper$().lD)) | 0);
  var maxFloor = (+Math.floor(a));
  var vis = (maxFloor * $m_Lcom_papasofokli_pagination_PaginationHelper$().lD);
  var d = ((page <= vis) ? ((-$m_Lcom_papasofokli_pagination_PaginationHelper$().lD) | 0) : 0);
  var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(pagination.querySelectorAll((("li:not([" + $m_Lcom_papasofokli_pagination_PaginationHelper$().JH) + "])")));
  var lis = $m_sci_Seq$().fM(this$3);
  this.Mx(pagination.querySelector(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().OH)), (page !== 1));
  this.Mx(pagination.querySelector(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().OK)), (page !== total));
  var prevLp = ((((page - 1) | 0) < 1) ? 1.0 : ((((page - 1) | 0) >= $m_Lcom_papasofokli_pagination_PaginationHelper$().lD) ? (maxFloor * $m_Lcom_papasofokli_pagination_PaginationHelper$().lD) : ((page - 1) | 0)));
  var prevLi = pagination.querySelector(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().OP));
  prevLi.setAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().sj, ("" + prevLp));
  this.Mx(prevLi, (page !== 1));
  var nextLp = ((((1 + page) | 0) > total) ? total : ((((1 + page) | 0) < ((total - $m_Lcom_papasofokli_pagination_PaginationHelper$().lD) | 0)) ? ((vis + $m_Lcom_papasofokli_pagination_PaginationHelper$().lD) + 1.0) : ((1 + page) | 0)));
  var nextLi = pagination.querySelector(("." + $m_Lcom_papasofokli_pagination_PaginationHelper$().OL));
  nextLi.setAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().sj, ("" + nextLp));
  this.Mx(nextLi, (page !== total));
  lis.bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult6: {
      if ((x$1$3 !== null)) {
        var li = x$1$3.P();
        var index = (x$1$3.V() | 0);
        var lp = ((((1 + index) | 0) + vis) + d);
        var show = (lp <= total);
        li.setAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().sj, ("" + lp));
        this.axZ(li, show);
        li.firstChild.textContent = ("" + lp);
        break matchResult6;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  var currentLi = pagination.querySelector((((((("[" + $m_Lcom_papasofokli_pagination_PaginationHelper$().sj) + "='") + page) + "']:not([") + $m_Lcom_papasofokli_pagination_PaginationHelper$().JH) + "])"));
  currentLi.classList.add($m_Lcom_papasofokli_pagination_PaginationHelper$().EW);
});
$p.axZ = (function(li, show) {
  if (show) {
    li.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().OI);
  } else {
    li.classList.add($m_Lcom_papasofokli_pagination_PaginationHelper$().OI);
  }
});
$p.Mx = (function(li, show) {
  if (show) {
    li.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().wE);
  } else {
    li.classList.add($m_Lcom_papasofokli_pagination_PaginationHelper$().wE);
  }
});
$p.aw0 = (function(pagination, li, paginationPageClickedFun, total) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
    if (((!(!(!li.classList.contains($m_Lcom_papasofokli_pagination_PaginationHelper$().wE)))) && (!(!(!li.classList.contains($m_Lcom_papasofokli_pagination_PaginationHelper$().EW)))))) {
      $m_sc_StringOps$();
      var page = $m_jl_Integer$().c7(li.getAttribute($m_Lcom_papasofokli_pagination_PaginationHelper$().sj), 10, 214748364);
      paginationPageClickedFun.cm(pagination, page);
      this.ahL(pagination, page, total);
    }
  }));
});
var $d_Lcom_papasofokli_pagination_PaginationJs$ = new $TypeData().i($c_Lcom_papasofokli_pagination_PaginationJs$, "com.papasofokli.pagination.PaginationJs$", ({
  pA: 1
}));
var $n_Lcom_papasofokli_pagination_PaginationJs$;
function $m_Lcom_papasofokli_pagination_PaginationJs$() {
  if ((!$n_Lcom_papasofokli_pagination_PaginationJs$)) {
    $n_Lcom_papasofokli_pagination_PaginationJs$ = new $c_Lcom_papasofokli_pagination_PaginationJs$();
  }
  return $n_Lcom_papasofokli_pagination_PaginationJs$;
}
var $d_Lcom_papasofokli_planning_DivisionData = new $TypeData().i(1, "com.papasofokli.planning.DivisionData", ({
  cf: 1
}));
var $d_Lcom_papasofokli_planning_DivisionsDataJSI = new $TypeData().i(1, "com.papasofokli.planning.DivisionsDataJSI", ({
  cg: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$() {
  this.a18 = null;
  this.a19 = null;
  this.OU = null;
  this.a17 = null;
  $n_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$ = this;
  this.a18 = new $c_Lcom_papasofokli_planning_AppliedToC("Left");
  this.a19 = new $c_Lcom_papasofokli_planning_AppliedToC("Right");
  this.OU = new $c_Lcom_papasofokli_planning_AppliedToC("LeftRight");
  this.a17 = new $c_Lcom_papasofokli_planning_AppliedToC("Center");
}
$p = $c_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$;
/** @constructor */
function $h_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$() {
}
$h_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$.prototype = $p;
var $d_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$ = new $TypeData().i($c_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$, "com.papasofokli.planning.IndicationsDictionaryAppliedTo$", ({
  pW: 1
}));
var $n_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$;
function $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$() {
  if ((!$n_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$)) {
    $n_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$ = new $c_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$();
  }
  return $n_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodStyleE$() {
  this.EX = null;
  this.OW = null;
  this.a1k = null;
  this.OV = null;
  $n_Lcom_papasofokli_planning_PeriodStyleE$ = this;
  $m_Lcom_papasofokli_planning_package$();
  this.EX = new $c_Lcom_papasofokli_planning_PeriodStyle("bar warning dimmed");
  this.OW = new $c_Lcom_papasofokli_planning_PeriodStyle("bar ghost-period");
  this.a1k = new $c_Lcom_papasofokli_planning_PeriodStyle("bar planning-note");
  this.OV = new $c_Lcom_papasofokli_planning_PeriodStyle("bar suggested-period-adjustment");
}
$p = $c_Lcom_papasofokli_planning_PeriodStyleE$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodStyleE$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodStyleE$() {
}
$h_Lcom_papasofokli_planning_PeriodStyleE$.prototype = $p;
var $d_Lcom_papasofokli_planning_PeriodStyleE$ = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodStyleE$, "com.papasofokli.planning.PeriodStyleE$", ({
  q3: 1
}));
var $n_Lcom_papasofokli_planning_PeriodStyleE$;
function $m_Lcom_papasofokli_planning_PeriodStyleE$() {
  if ((!$n_Lcom_papasofokli_planning_PeriodStyleE$)) {
    $n_Lcom_papasofokli_planning_PeriodStyleE$ = new $c_Lcom_papasofokli_planning_PeriodStyleE$();
  }
  return $n_Lcom_papasofokli_planning_PeriodStyleE$;
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__makeDepartment__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__F0__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, departmentDataJSI, layer, initialY, getBelowDepartment, parentDepartment, departmentCreatorFixedData, executionContext) {
  matchResult1: {
    var $x_1;
    if ((departmentDataJSI instanceof $c_Lcom_papasofokli_planning_LeafDivisionJS)) {
      var $x_1 = new $c_Lcom_papasofokli_planning_api_LeafDivisionSVG(departmentDataJSI, layer, initialY, parentDepartment, getBelowDepartment, departmentCreatorFixedData, executionContext);
      break matchResult1;
    }
    if ((departmentDataJSI instanceof $c_Lcom_papasofokli_planning_NodeDivisionJS)) {
      var $x_1 = new $c_Lcom_papasofokli_planning_api_NodeDivisionSVG(departmentDataJSI, layer, initialY, parentDepartment, getBelowDepartment, departmentCreatorFixedData, executionContext);
      break matchResult1;
    }
    throw new $c_s_MatchError(departmentDataJSI);
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__depSvg$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__sci_List__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, depSvg$lzy1$1, s$1, layer$1, initialY$2, parentDepartment$1, departmentCreatorFixedData$1, executionContext$1, seamanDivisionsSVGs$lzy1$1, xs$1) {
  return (depSvg$lzy1$1.i ? depSvg$lzy1$1.j : depSvg$lzy1$1.E($p_Lcom_papasofokli_planning_api_DepartmentCreator$__makeDepartment__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__F0__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, s$1, layer$1, initialY$2, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_planning_api_DepartmentCreator$__getBelowDepartment$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__s_Option($thiz, seamanDivisionsSVGs$lzy1$1, initialY$2, xs$1, layer$1, parentDepartment$1, departmentCreatorFixedData$1, executionContext$1, depSvg$lzy1$1, s$1))), parentDepartment$1, departmentCreatorFixedData$1, executionContext$1)));
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__depSvg$1__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__sci_List__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, depSvg$lzy1$2, s$2, layer$2, initialY$3, parentDepartment$2, departmentCreatorFixedData$2, executionContext$2, seamanDivisionsSVGs$lzy1$2, xs$2) {
  return (depSvg$lzy1$2.i ? depSvg$lzy1$2.j : $p_Lcom_papasofokli_planning_api_DepartmentCreator$__depSvg$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__sci_List__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, depSvg$lzy1$2, s$2, layer$2, initialY$3, parentDepartment$2, departmentCreatorFixedData$2, executionContext$2, seamanDivisionsSVGs$lzy1$2, xs$2));
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__seamanDivisionsSVGs$lzyINIT1$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__sci_List($thiz, seamanDivisionsSVGs$lzy1$3, initialY$4, xs$3, layer$3, parentDepartment$3, departmentCreatorFixedData$3, executionContext$3, depSvg$lzy1$3, s$3) {
  return (seamanDivisionsSVGs$lzy1$3.i ? seamanDivisionsSVGs$lzy1$3.j : seamanDivisionsSVGs$lzy1$3.E($thiz.UY(xs$3, layer$3, Math.fround((initialY$4 + $p_Lcom_papasofokli_planning_api_DepartmentCreator$__depSvg$1__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__sci_List__Lcom_papasofokli_planning_api_DivisionsSVG($thiz, depSvg$lzy1$3, s$3, layer$3, initialY$4, parentDepartment$3, departmentCreatorFixedData$3, executionContext$3, seamanDivisionsSVGs$lzy1$3, xs$3).N7())), parentDepartment$3, departmentCreatorFixedData$3, executionContext$3)));
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__seamanDivisionsSVGs$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__sci_List($thiz, seamanDivisionsSVGs$lzy1$4, initialY$5, xs$4, layer$4, parentDepartment$4, departmentCreatorFixedData$4, executionContext$4, depSvg$lzy1$4, s$4) {
  return (seamanDivisionsSVGs$lzy1$4.i ? seamanDivisionsSVGs$lzy1$4.j : $p_Lcom_papasofokli_planning_api_DepartmentCreator$__seamanDivisionsSVGs$lzyINIT1$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__sci_List($thiz, seamanDivisionsSVGs$lzy1$4, initialY$5, xs$4, layer$4, parentDepartment$4, departmentCreatorFixedData$4, executionContext$4, depSvg$lzy1$4, s$4));
}
function $p_Lcom_papasofokli_planning_api_DepartmentCreator$__getBelowDepartment$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__s_Option($thiz, seamanDivisionsSVGs$lzy1$5, initialY$6, xs$5, layer$5, parentDepartment$5, departmentCreatorFixedData$5, executionContext$5, depSvg$lzy1$5, s$5) {
  return $p_Lcom_papasofokli_planning_api_DepartmentCreator$__seamanDivisionsSVGs$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__sci_List($thiz, seamanDivisionsSVGs$lzy1$5, initialY$6, xs$5, layer$5, parentDepartment$5, departmentCreatorFixedData$5, executionContext$5, depSvg$lzy1$5, s$5).bj();
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_DepartmentCreator$() {
}
$p = $c_Lcom_papasofokli_planning_api_DepartmentCreator$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_DepartmentCreator$;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_DepartmentCreator$() {
}
$h_Lcom_papasofokli_planning_api_DepartmentCreator$.prototype = $p;
$p.UY = (function(departmentDataJSI, layer, initialY, parentDepartment, departmentCreatorFixedData, executionContext) {
  if ((departmentDataJSI instanceof $c_sci_$colon$colon)) {
    var x7 = departmentDataJSI.bz;
    var s = departmentDataJSI.q9;
    var depSvg$lzy1 = new $c_sr_LazyRef();
    var seamanDivisionsSVGs$lzy1 = new $c_sr_LazyRef();
    return new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_DepartmentCreator$__depSvg$1__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__I__F__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__sci_List__Lcom_papasofokli_planning_api_DivisionsSVG(this, depSvg$lzy1, s, layer, initialY, parentDepartment, departmentCreatorFixedData, executionContext, seamanDivisionsSVGs$lzy1, x7), $p_Lcom_papasofokli_planning_api_DepartmentCreator$__seamanDivisionsSVGs$1__sr_LazyRef__F__sci_List__I__s_Option__Lcom_papasofokli_planning_api_DepartmentCreatorFixedData__s_concurrent_ExecutionContext__sr_LazyRef__Lcom_papasofokli_planning_DivisionsDataJSI__sci_List(this, seamanDivisionsSVGs$lzy1, initialY, x7, layer, parentDepartment, departmentCreatorFixedData, executionContext, depSvg$lzy1, s));
  }
  if ($m_sci_Nil$().b(departmentDataJSI)) {
    return $m_sci_Nil$();
  }
  throw new $c_s_MatchError(departmentDataJSI);
});
var $d_Lcom_papasofokli_planning_api_DepartmentCreator$ = new $TypeData().i($c_Lcom_papasofokli_planning_api_DepartmentCreator$, "com.papasofokli.planning.api.DepartmentCreator$", ({
  qH: 1
}));
var $n_Lcom_papasofokli_planning_api_DepartmentCreator$;
function $m_Lcom_papasofokli_planning_api_DepartmentCreator$() {
  if ((!$n_Lcom_papasofokli_planning_api_DepartmentCreator$)) {
    $n_Lcom_papasofokli_planning_api_DepartmentCreator$ = new $c_Lcom_papasofokli_planning_api_DepartmentCreator$();
  }
  return $n_Lcom_papasofokli_planning_api_DepartmentCreator$;
}
function $p_Lcom_papasofokli_planning_api_PeriodIndications__numberOfAllIndications__I($thiz) {
  if ((!$thiz.a3s)) {
    $thiz.a3r = (((($thiz.pv.gU.F() + $thiz.pv.gV.F()) | 0) + $thiz.pv.gW.F()) | 0);
    $thiz.a3s = true;
  }
  return $thiz.a3r;
}
function $p_Lcom_papasofokli_planning_api_PeriodIndications__infoNotificationCenter__s_Option($thiz) {
  if ((!$thiz.a3n)) {
    if (($p_Lcom_papasofokli_planning_api_PeriodIndications__numberOfAllIndications__I($thiz) > 1)) {
      var infoHoverText = $thiz.pv.gV.aL($thiz.wZ.Pr).dt($thiz.pv.gU.aL($thiz.wZ.Pq)).dt($thiz.pv.gW.aL($thiz.wZ.Ps));
      var faIcon$1 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().t6, $m_sci_Nil$());
      var initialY$4 = Math.fround(($thiz.a3q + $thiz.pu));
      var extraCssClass$4 = $m_s_Option$().Z("activeText not-selectable");
      var generalTextHoverHtmlMap$1 = $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2($m_Lcom_papasofokli_util_IconUI$().t6, infoHoverText)]));
      var dragFunction$4 = $m_s_None$();
      var draggingFunction$4 = $m_s_None$();
      var getGroupedDraggedShapes$4 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
      var onHover$4 = $m_s_None$();
      var onMouseOut$4 = $m_s_None$();
      var href$4 = $m_s_None$();
      var $x_1 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon$1, $thiz.Pk, initialY$4, extraCssClass$4, generalTextHoverHtmlMap$1, dragFunction$4, $thiz.a3k, draggingFunction$4, $thiz.a3l, getGroupedDraggedShapes$4, onHover$4, onMouseOut$4, true, href$4, $thiz.pv.fv, $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor()));
    } else {
      var $x_1 = $m_s_None$();
    }
    $thiz.a3m = $x_1;
    $thiz.a3n = true;
  }
  return $thiz.a3m;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PeriodIndications(period, initialX, initialEndX, initialYWithLevel, periodHeight, clickFunction, contextMenuFunction, periodSvgIndicationsSetup) {
  this.pv = null;
  this.a3p = 0.0;
  this.a3o = 0.0;
  this.a3q = 0.0;
  this.a3t = 0.0;
  this.a3k = null;
  this.a3l = null;
  this.wZ = null;
  this.pu = 0.0;
  this.JV = null;
  this.JW = null;
  this.Pm = 0.0;
  this.Pn = 0.0;
  this.Pj = 0.0;
  this.F6 = null;
  this.a3r = 0;
  this.a3s = false;
  this.Pk = 0.0;
  this.a3m = null;
  this.a3n = false;
  this.Pl = false;
  this.a3j = null;
  this.pv = period;
  this.a3p = initialX;
  this.a3o = initialEndX;
  this.a3q = initialYWithLevel;
  this.a3t = periodHeight;
  this.a3k = clickFunction;
  this.a3l = contextMenuFunction;
  this.wZ = ((!period.i3.c()) ? new $c_Lcom_papasofokli_planning_api_PeriodSvgSetup(periodSvgIndicationsSetup.B7.Mq(period.i3.h()), periodSvgIndicationsSetup.x2, periodSvgIndicationsSetup.x3, periodSvgIndicationsSetup.x4) : periodSvgIndicationsSetup);
  var totalWidth = Math.fround((initialEndX - initialX));
  this.pu = Math.fround((Math.fround((0.5 * periodHeight)) - 11.0));
  if ((!period.gV.c())) {
    var initialX$1 = Math.fround((initialX + 5.0));
    var initialY$1 = Math.fround((initialYWithLevel + this.pu));
    var extraCssClass$1 = $m_s_Option$().Z("activeText not-selectable");
    var dragFunction$1 = $m_s_None$();
    var draggingFunction$1 = $m_s_None$();
    var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
    var onHover$1 = $m_s_None$();
    var onMouseOut$1 = $m_s_None$();
    var href$1 = $m_s_None$();
    var horizontalAnchor$1 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
    var $x_1 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_IconTextComponent(period.gV, initialX$1, initialY$1, extraCssClass$1, this.wZ.Pr, dragFunction$1, clickFunction, draggingFunction$1, contextMenuFunction, getGroupedDraggedShapes$1, onHover$1, onMouseOut$1, true, href$1, period.fv, horizontalAnchor$1));
  } else {
    var $x_1 = $m_s_None$();
  }
  this.JV = $x_1;
  if ((!period.gW.c())) {
    var initialX$2 = Math.fround((initialEndX - 5.0));
    var initialY$2 = Math.fround((initialYWithLevel + this.pu));
    var extraCssClass$2 = $m_s_Option$().Z("activeText not-selectable");
    var dragFunction$2 = $m_s_None$();
    var draggingFunction$2 = $m_s_None$();
    var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
    var onHover$2 = $m_s_None$();
    var onMouseOut$2 = $m_s_None$();
    var href$2 = $m_s_None$();
    var appendWithAnimationTime$1 = new $c_s_Some(0.5);
    var $x_2 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_IconTextComponent(period.gW, initialX$2, initialY$2, extraCssClass$2, this.wZ.Ps, dragFunction$2, clickFunction, draggingFunction$2, contextMenuFunction, getGroupedDraggedShapes$2, onHover$2, onMouseOut$2, true, href$2, appendWithAnimationTime$1, $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor()));
  } else {
    var $x_2 = $m_s_None$();
  }
  this.JW = $x_2;
  var this$29 = this.JV;
  var this$31 = (this$29.c() ? $m_s_None$() : new $c_s_Some(this$29.h().uv()));
  this.Pm = Math.fround((this$31.c() ? 0.0 : this$31.h()));
  var this$32 = this.JW;
  var this$34 = (this$32.c() ? $m_s_None$() : new $c_s_Some(this$32.h().uv()));
  this.Pn = Math.fround((this$34.c() ? 0.0 : this$34.h()));
  this.Pj = Math.fround((0.5 * Math.fround((Math.fround((Math.fround((initialX + initialEndX)) + this.Pm)) - this.Pn))));
  if ((!period.gU.c())) {
    var initialY$3 = Math.fround((initialYWithLevel + this.pu));
    var extraCssClass$3 = $m_s_Option$().Z("activeText not-selectable");
    var dragFunction$3 = $m_s_None$();
    var draggingFunction$3 = $m_s_None$();
    var getGroupedDraggedShapes$3 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
    var onHover$3 = $m_s_None$();
    var onMouseOut$3 = $m_s_None$();
    var href$3 = $m_s_None$();
    var $x_3 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_IconTextComponent(period.gU, this.Pj, initialY$3, extraCssClass$3, this.wZ.Pq, dragFunction$3, clickFunction, draggingFunction$3, contextMenuFunction, getGroupedDraggedShapes$3, onHover$3, onMouseOut$3, true, href$3, period.fv, $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor()));
  } else {
    var $x_3 = $m_s_None$();
  }
  this.F6 = $x_3;
  var this$46 = this.F6;
  var this$48 = (this$46.c() ? $m_s_None$() : new $c_s_Some(this$46.h().uv()));
  var centerIndicationsWidth = Math.fround((this$48.c() ? 0.0 : this$48.h()));
  var totalIndicationsWidth = Math.fround((Math.fround((this.Pm + this.Pn)) + centerIndicationsWidth));
  this.Pk = Math.fround((0.5 * Math.fround((initialX + initialEndX))));
  this.Pl = (totalIndicationsWidth < totalWidth);
  this.a3j = (this.Pl ? $m_s_Option$().hi(this.JW).cf().cH(this.JV).dt(this.F6) : $m_s_Option$().hi($p_Lcom_papasofokli_planning_api_PeriodIndications__infoNotificationCenter__s_Option(this)).cf());
}
$p = $c_Lcom_papasofokli_planning_api_PeriodIndications.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_PeriodIndications;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PeriodIndications() {
}
$h_Lcom_papasofokli_planning_api_PeriodIndications.prototype = $p;
$p.gd = (function(nextY) {
  var newYWithLevel = Math.fround((nextY + Math.fround((this.a3t * Math.fround(this.pv.hr)))));
  if (this.Pl) {
    var this$1 = this.JV;
    if ((!this$1.c())) {
      this$1.h().cT(Math.fround((this.a3p + 5.0)), Math.fround((newYWithLevel + this.pu)));
    }
    var this$2 = this.JW;
    if ((!this$2.c())) {
      this$2.h().cT(Math.fround((this.a3o - 5.0)), Math.fround((newYWithLevel + this.pu)));
    }
    var this$3 = this.F6;
    if ((!this$3.c())) {
      this$3.h().cT(this.Pj, Math.fround((newYWithLevel + this.pu)));
    }
  } else {
    var this$4 = this.F6;
    if ((!this$4.c())) {
      this$4.h().cT(this.Pk, Math.fround((newYWithLevel + this.pu)));
    }
  }
});
var $d_Lcom_papasofokli_planning_api_PeriodIndications = new $TypeData().i($c_Lcom_papasofokli_planning_api_PeriodIndications, "com.papasofokli.planning.api.PeriodIndications", ({
  qM: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PeriodSvg$() {
}
$p = $c_Lcom_papasofokli_planning_api_PeriodSvg$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_PeriodSvg$;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PeriodSvg$() {
}
$h_Lcom_papasofokli_planning_api_PeriodSvg$.prototype = $p;
$p.Ux = (function(period, timeLine) {
  var $x_1 = Date;
  var x_$_lo = period.qw;
  var x_$_hi = period.qx;
  var startDate = new $x_1(((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)));
  var $x_2 = Date;
  var x$1_$_lo = period.ot;
  var x$1_$_hi = period.ou;
  var endDate = new $x_2(((4.294967296E9 * x$1_$_hi) + (x$1_$_lo >>> 0.0)));
  var normalPeriodStartX = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(timeLine, startDate);
  var normalPeriodEndX = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(timeLine, endDate);
  return new $c_T2(Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(normalPeriodStartX, new $c_sci_$colon$colon(Math.fround(timeLine.pX.aA()), $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$())), Math.fround($f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon(normalPeriodEndX, new $c_sci_$colon$colon(Math.fround(timeLine.m7.aA()), $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$())));
});
var $d_Lcom_papasofokli_planning_api_PeriodSvg$ = new $TypeData().i($c_Lcom_papasofokli_planning_api_PeriodSvg$, "com.papasofokli.planning.api.PeriodSvg$", ({
  qN: 1
}));
var $n_Lcom_papasofokli_planning_api_PeriodSvg$;
function $m_Lcom_papasofokli_planning_api_PeriodSvg$() {
  if ((!$n_Lcom_papasofokli_planning_api_PeriodSvg$)) {
    $n_Lcom_papasofokli_planning_api_PeriodSvg$ = new $c_Lcom_papasofokli_planning_api_PeriodSvg$();
  }
  return $n_Lcom_papasofokli_planning_api_PeriodSvg$;
}
function $p_Lcom_papasofokli_planning_api_PositionPlanningSVG__makeEffectRectSeq__sci_Seq__T__sci_Seq($thiz, rangeSeq, cssClass) {
  return rangeSeq.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var rowSeq = x$1$2.gZ;
      var dateFrom = x$1$2.fY;
      var dateTo = x$1$2.gr;
      var x = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz.x5, dateFrom);
      var width = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(Math.fround(($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz.x5, dateTo) - x)), new $c_sci_$colon$colon(1.0, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
      return rowSeq.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row$2) => {
        var initialY$1 = row$2.zJ();
        return new $c_Lcom_papasofokli_svg_components_RectComponent(new $c_s_Some(cssClass), row$2.E6(), width, x, initialY$1, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), false, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
      })));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
function $p_Lcom_papasofokli_planning_api_PositionPlanningSVG__focusViewport__sci_Seq__V($thiz, rangeSeq) {
  var rowSeq = rangeSeq.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      return x$1$2.gZ;
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  var this$2 = $m_s_Option$().Z(document.getElementById($thiz.JX));
  var pf = new $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2();
  var positionDivO = ((!this$2.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$2.h()) : $m_s_None$());
  matchResult5: {
    if ((positionDivO instanceof $c_s_Some)) {
      var positionDiv = positionDivO.bg;
      if (((!rangeSeq.c()) && (!rowSeq.c()))) {
        var fromDate = $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(rangeSeq, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => (+_$6$2.fY.getTime()))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()).fY;
        var toDate = $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(rangeSeq, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$2) => (+_$7$2.gr.getTime()))), $m_s_math_Ordering$DeprecatedDoubleOrdering$()).gr;
        var centerX = Math.fround((0.5 * Math.fround(($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz.x5, fromDate) + $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz.x5, toDate)))));
        var topY = Math.fround(rowSeq.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => _$8$2.zJ()))).gJ($m_s_math_Ordering$Float$TotalOrdering$()));
        var bottomY = Math.fround(rowSeq.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row$2) => Math.fround((row$2.zJ() + row$2.E6()))))).fq($m_s_math_Ordering$Float$TotalOrdering$()));
        var centerY = Math.fround((0.5 * Math.fround((topY + bottomY))));
        var $x_1 = positionDiv.offsetLeft;
        var num = ($thiz.sH.clientWidth | 0);
        var a = (((+$x_1) + centerX) - (((num + ((num >>> 31) | 0)) | 0) >> 1));
        var scrollLeft = (+Math.max(a, 0.0));
        var $x_2 = positionDiv.offsetTop;
        var num$1 = ($thiz.sH.clientHeight | 0);
        var a$1 = (((+$x_2) + centerY) - (((num$1 + ((num$1 >>> 31) | 0)) | 0) >> 1));
        var scrollTop = (+Math.max(a$1, 0.0));
        var options = ({
          "left": scrollLeft,
          "top": scrollTop,
          "behavior": "smooth"
        });
        $thiz.sH.scrollTo(options);
        break matchResult5;
      }
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PositionPlanningSVG(persons, timeLine, parentDiv, totalHeight, executionContext) {
  this.x5 = null;
  this.sH = null;
  this.a44 = 0;
  this.sG = null;
  this.Pt = null;
  this.JX = null;
  this.a45 = null;
  this.B8 = null;
  this.x5 = timeLine;
  this.sH = parentDiv;
  this.a44 = 2200;
  var initialHeight$1 = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(totalHeight, new $c_sci_$colon$colon(1.0, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  this.sG = new $c_Lcom_papasofokli_svg_components_RectComponent($m_s_Option$().Z(("period-highlight " + $m_Lcom_papasofokli_planning_package$().nM)), initialHeight$1, 1.0, (-100.0), (-5.0), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var this$20 = $m_sjs_js_ArrayOps$().zK((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + parentDiv.id) + " .all-positions-div")).toArray());
  var pf = new $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1();
  this.Pt = ((!this$20.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$20.h()) : $m_s_None$());
  var this$22 = this.Pt;
  this.JX = (this$22.c() ? $m_ju_UUID$().aW().g() : this$22.h());
  this.a45 = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", this.JX), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "positions-div all-positions-div bg-body"), $m_sci_Nil$()));
  this.B8 = new $c_Lcom_papasofokli_svg_SVGController(this.JX, persons.aV(this.sG), totalHeight, $m_s_Option$().Z(Math.fround(timeLine.m7.aA())), executionContext);
}
$p = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PositionPlanningSVG() {
}
$h_Lcom_papasofokli_planning_api_PositionPlanningSVG.prototype = $p;
$p.gN = (function(h) {
  this.B8.gN(h);
});
$p.UF = (function() {
  this.sG.Em();
});
$p.awj = (function(dateS, dateE) {
  var xCompS = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(this.x5, dateS);
  var xCompE = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(this.x5, dateE);
  this.sG.gN(this.B8.E6());
  this.sG.zS(new $c_s_Some(xCompS), new $c_s_Some(0.0));
  this.sG.Ez(Math.fround((xCompE - xCompS)));
});
$p.atg = (function() {
  this.sG.gN(1.0);
  this.sG.zS($m_s_None$(), new $c_s_Some((-5.0)));
});
$p.Vt = (function(rangeSeq) {
  this.MT();
  var generationShimmerRectSeq = $p_Lcom_papasofokli_planning_api_PositionPlanningSVG__makeEffectRectSeq__sci_Seq__T__sci_Seq(this, rangeSeq, "generation-shimmer");
  this.TE(generationShimmerRectSeq);
  generationShimmerRectSeq.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    _$1$3.Em();
  })));
});
$p.MT = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(this.sH.querySelectorAll(".generation-shimmer"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.remove();
  }
});
$p.Ui = (function(rangeSeq) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(this.sH.querySelectorAll(".period-focus"));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.remove();
  }
  var focusRectSeq = $p_Lcom_papasofokli_planning_api_PositionPlanningSVG__makeEffectRectSeq__sci_Seq__T__sci_Seq(this, rangeSeq, "period-focus");
  var focusElementSeq = this.TE(focusRectSeq);
  focusRectSeq.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
    _$4$3.Em();
  })));
  $p_Lcom_papasofokli_planning_api_PositionPlanningSVG__focusViewport__sci_Seq__V(this, rangeSeq);
  $m_sjs_js_timers_package$().gb(this.a44, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    focusElementSeq.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => {
      _$5$3.remove();
    })));
  })));
});
$p.TE = (function(components) {
  return components.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((component$2) => this.B8.M5(component$2))));
});
$p.amb = (function(c) {
  return this.B8.M5(c);
});
$p.ux = (function(executionContext) {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + this.sH.id) + " .all-positions-div svg")).remove();
    var x20 = this.Pt;
    if ((x20 instanceof $c_s_Some)) {
      var id = x20.bg;
      return document.getElementById(id);
    }
    if (($m_s_None$() === x20)) {
      var positionDiv = document.createElement("div");
      this.a45.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$3) => {
        _$9$3.ds(positionDiv);
      })));
      this.sH.appendChild(positionDiv);
      return positionDiv;
    }
    throw new $c_s_MatchError(x20);
  })), executionContext);
});
$p.ga = (function() {
  return this.B8.ga();
});
var $d_Lcom_papasofokli_planning_api_PositionPlanningSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_PositionPlanningSVG, "com.papasofokli.planning.api.PositionPlanningSVG", ({
  qO: 1
}));
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRowsForSubjectId__J__sci_Seq($thiz, subjectId_$_lo, subjectId_$_hi) {
  return $thiz.iU.ahu(subjectId_$_lo, subjectId_$_hi);
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__gerRowSubjectIdIdByPosition__F__s_Option($thiz, y) {
  return $thiz.iU.Ur(y);
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__setSvgPositionsHeight__F__V($thiz, h) {
  $thiz.gX.gN(h);
  $thiz.JY.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    _$2$3.aiU($m_s_None$(), $m_s_None$(), $m_s_None$(), new $c_s_Some(h));
  })));
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRowSeamanPeriod__ju_UUID__sci_Seq($thiz, rowUUID) {
  return $thiz.iU.MK(rowUUID);
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRelevantPeriods__J__sci_Seq($thiz, periodId_$_lo, periodId_$_hi) {
  return $thiz.iU.aum(periodId_$_lo, periodId_$_hi);
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getVerticalDateLinesToDateLines__sci_Seq__sci_Seq($thiz, dateLines) {
  return dateLines.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((vdl$2) => {
    var $x_4 = $thiz.i6.nK;
    var $x_3 = Date;
    var $x_2 = vdl$2;
    var x_$_lo = $x_2.ud;
    var x_$_hi = $x_2.ue;
    var $x_1 = new $x_3(((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)));
    var coords = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($x_4, $x_1);
    var initialClassName$1 = $m_s_Option$().Z(vdl$2.sq);
    var initialY2$1 = $thiz.gn.eI();
    var onHover$1 = $m_s_Option$().Z($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(vdl$2.sr, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), $m_s_None$())));
    var onMouseOut$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
    })));
    return new $c_Lcom_papasofokli_svg_components_LineComponent(initialClassName$1, coords, 0.0, coords, initialY2$1, $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_LineComponent$().DK(), true, onHover$1, onMouseOut$1, $m_s_Option$().Z(0.5), $m_s_None$(), vdl$2.lY);
  })));
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__calculateMaxItems__F($thiz) {
  var this$3 = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.getElementsByTagName("html")));
  if (this$3.c()) {
    var visibleHeight = $m_s_None$();
  } else {
    var x0 = this$3.h();
    var visibleHeight = new $c_s_Some((x0.clientHeight | 0));
  }
  var prdHeight = $thiz.gn.B9.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => _$4$2.x8))).bj();
  return (((!prdHeight.c()) && (Math.fround(prdHeight.h()) > 0.0)) ? Math.fround((Math.fround(((visibleHeight.c() ? 0 : visibleHeight.h()) | 0)) / Math.fround(prdHeight.h()))) : 100.0);
}
function $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__planningRangeSeq__sci_Seq__sci_Seq($thiz, rangeSeq) {
  return rangeSeq.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((range$2) => {
    var subjectIdSet = $m_sci_Set$().jp(range$2.rI);
    var $x_7 = $thiz.gn.B9.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
      var this$3 = _$6$2.sK;
      if ((!this$3.c())) {
        var x0 = this$3.h();
        var $x_8 = $uJ(x0);
        var elem$2_$_lo = $x_8.l;
        var elem$2_$_hi = $x_8.h;
        return subjectIdSet.az($bL(elem$2_$_lo, elem$2_$_hi));
      } else {
        return false;
      }
    })));
    var $x_6 = Date;
    var $x_5 = range$2;
    var x_$_lo = $x_5.u1;
    var x_$_hi = $x_5.u2;
    var $x_4 = new $x_6(((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)));
    var $x_3 = Date;
    var $x_2 = range$2;
    var x$1_$_lo = $x_2.u3;
    var x$1_$_hi = $x_2.u4;
    var $x_1 = new $x_3(((4.294967296E9 * x$1_$_hi) + (x$1_$_lo >>> 0.0)));
    return new $c_T3($x_7, $x_4, $x_1);
  })));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_ShowPlanningSVGJS(planningData, plannerId, executionContext) {
  this.sJ = null;
  this.eL = null;
  this.sI = null;
  this.K0 = 0.0;
  this.Pu = 0.0;
  this.i6 = null;
  this.gn = null;
  this.JY = null;
  this.JZ = null;
  this.gX = null;
  this.iU = null;
  this.sJ = planningData;
  this.eL = executionContext;
  matchResult1: {
    var $x_1;
    var x1 = document.getElementById(plannerId);
    if ((!(!(x1 instanceof HTMLDivElement)))) {
      var $x_1 = x1;
      break matchResult1;
    }
    throw new $c_s_MatchError("Element not a div as expected");
  }
  this.sI = $x_1;
  var this$1 = planningData.lO;
  this.K0 = Math.fround((this$1.c() ? 35.0 : this$1.h()));
  var this$3 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(planningData.lR.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.N9()))), $m_s_math_Ordering$Int$());
  var maxLayer = ((this$3.c() ? 0 : this$3.h()) | 0);
  this.Pu = Math.fround((Math.fround((planningData.iR + planningData.iS)) + Math.fround((30.0 * Math.fround(maxLayer)))));
  this.i6 = new $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG(planningData, this.sI, this.Pu, $m_s_Option$().Z(this.aiV()), $m_s_Option$().Z(this.agC()), executionContext);
  this.gn = new $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG(planningData, this.sI, this.K0, this.i6.nK, 30.0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((periodId$3) => {
    var $x_2 = $uJ(periodId$3);
    return $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRelevantPeriods__J__sci_Seq(this, $x_2.l, $x_2.h);
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__setSvgPositionsHeight__F__V(this, Math.fround(v1$2));
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((key$3) => {
    this.afB(key$3);
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rowUUID$3) => {
    this.afS(rowUUID$3);
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rowUUID$2) => $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRowSeamanPeriod__ju_UUID__sci_Seq(this, rowUUID$2))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((subjectId$3) => {
    var $x_3 = $uJ(subjectId$3);
    return $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getRowsForSubjectId__J__sci_Seq(this, $x_3.l, $x_3.h);
  })), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y$3) => $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__gerRowSubjectIdIdByPosition__F__s_Option(this, Math.fround(y$3)))), executionContext);
  this.JY = $p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__getVerticalDateLinesToDateLines__sci_Seq__sci_Seq(this, planningData.lS);
  var rowsIndex = (($doubleToInt($p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__calculateMaxItems__F(this)) + $doubleToInt(this.i6.nK.Qg)) | 0);
  var rowsToRender = this.gn.B9.qO(rowsIndex);
  this.JZ = this.gn.B9.bo(rowsIndex);
  this.gX = new $c_Lcom_papasofokli_planning_api_PositionPlanningSVG(rowsToRender.cH(this.gn.a4a).dt(this.JY).aV(this.gn.nI), this.i6.nK, this.sI, this.gn.eI(), executionContext);
  this.iU = new $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$2) => this.gX.amb(c$2))), this.gn.B9, this.K0, this.i6.nK, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.JY)), plannerId, executionContext);
}
$p = $c_Lcom_papasofokli_planning_api_ShowPlanningSVGJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_ShowPlanningSVGJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_ShowPlanningSVGJS() {
}
$h_Lcom_papasofokli_planning_api_ShowPlanningSVGJS.prototype = $p;
$p.afB = (function(key) {
  key.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((k$3) => {
    this.iU.afA(k$3.EZ, k$3.EY);
  })));
  this.gX.UF();
  this.gn.nI.Em();
});
$p.Ma = (function(subjectId_$_lo, subjectId_$_hi, periodSeq) {
  this.iU.Ma(subjectId_$_lo, subjectId_$_hi, periodSeq);
  this.gX.UF();
  this.gn.nI.Em();
});
$p.alZ = (function(rowUUID, rowIndex, periods) {
  this.iU.alR(rowUUID, rowIndex, periods);
  this.gX.UF();
  this.gn.nI.Em();
});
$p.afS = (function(rowUUID) {
  this.iU.ax9(rowUUID);
});
$p.ana = (function(rowUUID, rowIndex) {
  this.iU.ax8(rowUUID, rowIndex);
});
$p.awi = (function(periodChanges) {
  this.iU.ayZ(periodChanges);
});
$p.Vv = (function(changeSeq) {
  this.iU.Vv(changeSeq);
});
$p.MU = (function() {
  this.iU.MU();
});
$p.Vw = (function() {
  this.i6.Vw();
});
$p.Vf = (function(sidebarSize) {
  this.i6.Vf(sidebarSize);
});
$p.awD = (function(currentTopY, currentBottomY) {
  var notRenderedSeq = this.JZ.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => ((x$2.nJ >= currentTopY) && (x$2.nJ <= currentBottomY)))));
  this.JZ = this.JZ.bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$1) => ((x$2$1.nJ >= currentTopY) && (x$2$1.nJ <= currentBottomY)))));
  this.gX.TE(notRenderedSeq);
});
$p.aiV = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((dateS$3, dateE$3) => {
    this.gX.awj(dateS$3, dateE$3);
  }));
});
$p.agC = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    this.gX.atg();
  }));
});
$p.Vt = (function(rangeSeq) {
  this.gX.Vt($p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__planningRangeSeq__sci_Seq__sci_Seq(this, rangeSeq));
});
$p.Ui = (function(rangeSeq) {
  this.gX.Ui($p_Lcom_papasofokli_planning_api_ShowPlanningSVGJS__planningRangeSeq__sci_Seq__sci_Seq(this, rangeSeq));
});
$p.MT = (function() {
  this.gX.MT();
});
$p.ga = (function() {
  var clientHeight = $m_Lcom_papasofokli_util_GeometryMethods$().afU();
  var footerHeightVH = (100.0 * ($m_Lcom_papasofokli_util_GeometryMethods$().auk() / clientHeight));
  var scrollBarWidthVH = (100.0 * ($m_Lcom_papasofokli_util_GeometryMethods$().ahv() / clientHeight));
  var sevenPXHV = (100.0 * (7.0 / clientHeight));
  var maxAvailableHeightVH = (((100.0 - footerHeightVH) - scrollBarWidthVH) - sevenPXHV);
  var maxAvailableHeightVHStr = ((maxAvailableHeightVH - 1.0) + "vh");
  new $c_Lcom_papasofokli_util_StyleValue("max-height", maxAvailableHeightVHStr).ds(this.sI);
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".planner-filters").css("height", maxAvailableHeightVHStr).css("overflow-y", "auto");
  if (this.sJ.lQ) {
    var $x_9 = this.sI;
    var $x_8 = this.i6.nK.m7.aA();
    var $x_7 = this.Pu;
    var $x_6 = this.K0;
    var $x_5 = this.sJ;
    var $x_4_$_lo = $x_5.kC;
    var $x_4_$_hi = $x_5.kD;
    var this$5 = this.sJ.nx;
    if (this$5.c()) {
      var $x_3 = this.sJ;
      var $x_2 = $bL($x_3.kC, $x_3.kD);
    } else {
      var $x_2 = this$5.h();
    }
    var $x_1 = $uJ($x_2);
    var vesselSchedule = new $c_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG($x_9, Math.fround($x_8), $x_7, $x_6, $x_4_$_lo, $x_4_$_hi, $x_1.l, $x_1.h, this.sJ.lT, this.i6.nK, this.sJ.k9, this.sJ.ny, this.eL);
    return vesselSchedule.aw3().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => this.i6.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => this.gn.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => this.gX.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$3) => vesselSchedule.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => this.i6.aiL(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => this.gn.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$2) => this.gX.ga())), this.eL))), this.eL))), this.eL))), this.eL))), this.eL))), this.eL))), this.eL);
  } else {
    var this$7 = $m_s_Option$().Z(document.querySelector((("#" + this.sI.id) + " .voyage-header-div")));
    if ((!this$7.c())) {
      var x0 = this$7.h();
      x0.parentNode.removeChild(x0);
    }
    var this$8 = $m_s_Option$().Z(document.querySelector((("#" + this.sI.id) + " .vessel-schedule-div")));
    if ((!this$8.c())) {
      var x0$1 = this$8.h();
      x0$1.parentNode.removeChild(x0$1);
    }
    return this.i6.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$7) => this.gn.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$8) => this.gX.ux(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$9) => this.i6.aiL(this.eL).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$3) => this.gn.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$4) => this.gX.ga())), this.eL))), this.eL))), this.eL))), this.eL))), this.eL);
  }
});
var $d_Lcom_papasofokli_planning_api_ShowPlanningSVGJS = new $TypeData().i($c_Lcom_papasofokli_planning_api_ShowPlanningSVGJS, "com.papasofokli.planning.api.ShowPlanningSVGJS", ({
  qR: 1
}));
function $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__hoverRectAppear__F__F__V($thiz, height, startY) {
  $thiz.nI.Ez($thiz.a49.uv());
  $thiz.nI.gN(height);
  $thiz.nI.zS(new $c_s_Some(0.0), new $c_s_Some(startY));
}
function $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__hoverRectHide__V($thiz) {
  $thiz.nI.Ez(1.0);
  $thiz.nI.zS(new $c_s_Some((-100.0)), $m_s_None$());
}
function $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__fixSvgHeight__V($thiz) {
  $thiz.Pw.gN($thiz.eI());
  $thiz.Px.gN($thiz.eI());
  $thiz.a48.hK($thiz.eI());
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG(planningData, parentDiv, periodsHeight, timeline, departmentWidth, getAllRelevantPeriods, positionsSvgSetHeight, addPeriodsToRow, cleanRow, getRowSeamanPeriods, getRowsForSubjectId, getSubjectIdByPosition, executionContext) {
  this.a47 = null;
  this.a49 = null;
  this.a48 = null;
  this.nI = null;
  this.F7 = null;
  this.B9 = null;
  this.a4a = null;
  this.Pv = null;
  this.a46 = null;
  this.Px = null;
  this.Pw = null;
  this.a47 = parentDiv;
  this.a49 = timeline;
  this.a48 = positionsSvgSetHeight;
  var this$2 = $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(planningData.lR.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.N9()))), $m_s_math_Ordering$Int$());
  var maxLayer = ((this$2.c() ? 0 : this$2.h()) | 0);
  var totalDepartmentWidth = Math.fround((departmentWidth * Math.fround(maxLayer)));
  this.nI = new $c_Lcom_papasofokli_svg_components_RectComponent($m_s_Option$().Z(("period-highlight " + $m_Lcom_papasofokli_planning_package$().nM)), periodsHeight, 1.0, (-100.0), 0.0, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var showHoursMinutes$1 = planningData.ay0();
  var periodSvgSetup = new $c_Lcom_papasofokli_planning_api_PeriodSvgSetup(planningData.lN, planningData.lK, planningData.lI, showHoursMinutes$1);
  var fixSvgHeight$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__fixSvgHeight__V(this);
  }));
  var hoverRectAppear$1 = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__hoverRectAppear__F__F__V(this, Math.fround(v1$2), Math.fround(v2$2));
  }));
  var hoverRectHide$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG__hoverRectHide__V(this);
  }));
  var this$24 = planningData.nx;
  var $x_1 = $uJ((this$24.c() ? $bL(planningData.kC, planningData.kD) : this$24.h()));
  var windowEndMs$1_$_lo = $x_1.l;
  var windowEndMs$1_$_hi = $x_1.h;
  var departmentCreatorFixedData = new $c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData(planningData.iR, planningData.iS, periodsHeight, departmentWidth, totalDepartmentWidth, timeline, periodSvgSetup, planningData.lJ, getAllRelevantPeriods, planningData.lL, fixSvgHeight$1, addPeriodsToRow, cleanRow, getRowSeamanPeriods, hoverRectAppear$1, hoverRectHide$1, getRowsForSubjectId, planningData.lP, getSubjectIdByPosition, planningData.lM, planningData.k9, planningData.kC, planningData.kD, windowEndMs$1_$_lo, windowEndMs$1_$_hi);
  this.F7 = $m_Lcom_papasofokli_planning_api_DepartmentCreator$().UY(planningData.lR.uF(), 0, 0.0, $m_s_None$(), departmentCreatorFixedData, executionContext);
  this.B9 = this.F7.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.Uw())));
  this.a4a = this.F7.bD(new $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1()).bU($m_s_$less$colon$less$().b0);
  var this$29 = $m_sjs_js_ArrayOps$().zK((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + parentDiv.id) + " .department-structure-div")).toArray());
  var pf = new $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2();
  this.Pv = ((!this$29.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$29.h()) : $m_s_None$());
  var this$31 = this.Pv;
  var nameRankId = (this$31.c() ? $m_ju_UUID$().aW().g() : this$31.h());
  this.a46 = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", nameRankId), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "name-rank-div department-structure-div"), $m_sci_Nil$()));
  var initialTotalHeight = this.eI();
  var nameLength = Math.fround((planningData.iS + planningData.iR));
  var totalSidebarWidth = Math.fround((nameLength + totalDepartmentWidth));
  this.Px = new $c_Lcom_papasofokli_svg_components_RectComponent(new $c_s_Some("white-fill"), initialTotalHeight, totalSidebarWidth, 0.0, 0.0, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
  this.Pw = new $c_Lcom_papasofokli_svg_SVGController(nameRankId, this.F7.ba(this.Px), initialTotalHeight, $m_s_Option$().Z(totalSidebarWidth), executionContext);
}
$p = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG() {
}
$h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG.prototype = $p;
$p.eI = (function() {
  return Math.fround(this.F7.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => _$3$2.N7()))).gO($m_s_math_Numeric$FloatIsFractional$()));
});
$p.ux = (function(executionContext) {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var x9 = this.Pv;
    if ((x9 instanceof $c_s_Some)) {
      var id = x9.bg;
      return document.getElementById(id);
    }
    if (($m_s_None$() === x9)) {
      var nameRankDiv = document.createElement("div");
      this.a46.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
        _$4$3.ds(nameRankDiv);
      })));
      this.a47.appendChild(nameRankDiv);
      return nameRankDiv;
    }
    throw new $c_s_MatchError(x9);
  })), executionContext);
});
$p.ga = (function() {
  return this.Pw.ga();
});
var $d_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG, "com.papasofokli.planning.api.SubjectNameLeafPlanningSVG", ({
  qS: 1
}));
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz) {
  return document.getElementById($thiz.PF);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz) {
  return $p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz).parentElement.parentElement;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__div2El__s_Option($thiz) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq($p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).parentElement.querySelectorAll(("." + $m_Lcom_papasofokli_planning_package$().a4Y))), new $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2());
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__sideFilerDiv__s_Option($thiz) {
  if ((!$thiz.a4y)) {
    var this$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__div2El__s_Option($thiz);
    var pf = new $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3();
    $thiz.a4x = ((!this$1.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$1.h()) : $m_s_None$());
    $thiz.a4y = true;
  }
  return $thiz.a4x;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__mainDivSelector__T($thiz) {
  return ("#" + $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).id);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__sidebarHidden__Z($thiz) {
  var this$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__div2El__s_Option($thiz);
  if (this$1.c()) {
    return true;
  } else {
    var x0 = this$1.h();
    return (window.getComputedStyle(x0).display === "none");
  }
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__tooltipOnHover__T__s_Option__F2($thiz, text, mayBeFun) {
  var tag = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().DR(), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text))]))]))]));
  var html$1 = tag.aB().outerHTML;
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$();
  var concatMode$1 = false;
  return $m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(html$1, concatMode$1, mayBeFun);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton__F__sci_Seq__T__s_Option__F0__s_Option__s_Option__Lcom_papasofokli_svg_components_IconTextComponent($thiz, x, faIcon, tooltipText, onHoverExtra, onMouseOut, clickFn, href) {
  var extraCssClass$1 = $m_s_Option$().Z($thiz.a4c);
  var onHover$4 = $m_s_Option$().Z($p_Lcom_papasofokli_planning_api_TimeLineButtons__tooltipOnHover__T__s_Option__F2($thiz, tooltipText, onHoverExtra));
  var onMouseOut$4 = $m_s_Option$().Z(onMouseOut);
  var generalTextHoverHtmlMap$1 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().afn();
  var dragFunction$4 = $m_s_None$();
  var draggingFunction$1 = $m_s_None$();
  var contextMenuFunction$2 = $m_s_None$();
  var getGroupedDraggedShapes$4 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
  var horizontalAnchor$1 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
  return new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon, x, $thiz.a4b, extraCssClass$1, generalTextHoverHtmlMap$1, dragFunction$4, clickFn, draggingFunction$1, contextMenuFunction$2, getGroupedDraggedShapes$4, onHover$4, onMouseOut$4, true, href, $thiz.Fc, horizontalAnchor$1);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton$default$5__F0($thiz) {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  }));
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__fullPageClickFun__F1($thiz) {
  if ((!$thiz.a4i)) {
    $thiz.a4h = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
      $m_Lcom_papasofokli_util_package$().VH($m_s_None$(), $thiz.K4);
    }));
    $thiz.a4i = true;
  }
  return $thiz.a4h;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__refreshButton__Lcom_papasofokli_svg_components_IconTextComponent($thiz) {
  if ((!$thiz.a4t)) {
    var x$2 = Math.fround(($thiz.Fd + $thiz.K2));
    var faIcon$3 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().QA, $m_sci_Nil$());
    var clickFn$3 = $m_s_Option$().Z($p_Lcom_papasofokli_planning_api_TimeLineButtons__refreshFunctionForPlannerId__T__F1($thiz, $thiz.PF));
    $thiz.a4s = $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton__F__sci_Seq__T__s_Option__F0__s_Option__s_Option__Lcom_papasofokli_svg_components_IconTextComponent($thiz, x$2, faIcon$3, "Refresh", $m_s_None$(), $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton$default$5__F0($thiz), clickFn$3, $m_s_None$());
    $thiz.a4t = true;
  }
  return $thiz.a4s;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__refreshFunctionForPlannerId__T__F1($thiz, id) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__refreshButton__Lcom_papasofokli_svg_components_IconTextComponent($thiz).VA();
    $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().Ex(id, $thiz.K4);
  }));
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__initialShowHideX__F($thiz) {
  if ((!$thiz.a4o)) {
    $thiz.a4n = Math.fround(($thiz.Fd + Math.fround((3.0 * $thiz.K2))));
    $thiz.a4o = true;
  }
  return $thiz.a4n;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__maxShowHideWidth__F($thiz) {
  if ((!$thiz.a4q)) {
    $thiz.a4p = Math.fround(($thiz.a4u - $p_Lcom_papasofokli_planning_api_TimeLineButtons__initialShowHideX__F($thiz)));
    $thiz.a4q = true;
  }
  return $thiz.a4p;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__mouseOutHideSidebar__V($thiz) {
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).ajl($m_Lcom_papasofokli_planning_package$().Fi);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__mouseOutShowSidebar__V($thiz) {
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__showSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).ajl($m_Lcom_papasofokli_planning_package$().Fi);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__fitToWidth__Lcom_papasofokli_svg_components_IconTextComponent__sci_Seq__Lcom_papasofokli_svg_components_IconTextComponent($thiz, btn, fallbackIcon) {
  var this$1 = btn.A7($p_Lcom_papasofokli_planning_api_TimeLineButtons__maxShowHideWidth__F($thiz));
  var this$2 = (this$1.c() ? new $c_Lcom_papasofokli_svg_components_IconTextComponent(fallbackIcon, btn.pI, btn.pJ, btn.sW, btn.sX, btn.pF, btn.pE, btn.pG, btn.sV, btn.pH, btn.xK, btn.xL, btn.pK, btn.sZ, btn.pD, btn.sY).A7($p_Lcom_papasofokli_planning_api_TimeLineButtons__maxShowHideWidth__F($thiz)) : this$1);
  return (this$2.c() ? new $c_Lcom_papasofokli_svg_components_IconTextComponent(new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().Ck, $m_sci_Nil$()), btn.pI, btn.pJ, btn.sW, btn.sX, btn.pF, btn.pE, btn.pG, btn.sV, btn.pH, btn.xK, btn.xL, btn.pK, btn.sZ, btn.pD, btn.sY) : this$2.h());
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__fullHideSideBar__Lcom_papasofokli_svg_components_IconTextComponent($thiz) {
  if ((!$thiz.a4g)) {
    $thiz.a4f = $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton__F__sci_Seq__T__s_Option__F0__s_Option__s_Option__Lcom_papasofokli_svg_components_IconTextComponent($thiz, $p_Lcom_papasofokli_planning_api_TimeLineButtons__initialShowHideX__F($thiz), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().Ck, new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_SpanTextContainer("Hide sidebar"), $m_sci_Nil$())), "Hide sidebar", new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).afv($m_Lcom_papasofokli_planning_package$().Fi);
    }))), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__mouseOutHideSidebar__V($thiz);
    })), new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__showHideSidebarMultipleEventsFiltered__s_concurrent_Future($thiz);
    }))), $m_s_None$());
    $thiz.a4g = true;
  }
  return $thiz.a4f;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz) {
  if ((!$thiz.a4m)) {
    $thiz.a4l = $p_Lcom_papasofokli_planning_api_TimeLineButtons__fitToWidth__Lcom_papasofokli_svg_components_IconTextComponent__sci_Seq__Lcom_papasofokli_svg_components_IconTextComponent($thiz, $p_Lcom_papasofokli_planning_api_TimeLineButtons__fullHideSideBar__Lcom_papasofokli_svg_components_IconTextComponent($thiz), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().Ck, new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_SpanTextContainer("Hide"), $m_sci_Nil$())));
    $thiz.a4m = true;
  }
  return $thiz.a4l;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__fullShowSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz) {
  if ((!$thiz.a4k)) {
    var faIcon$4 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().Ck, new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_SpanTextContainer("Show sidebar"), $m_sci_Nil$()));
    var onHover$5 = $m_s_Option$().Z($p_Lcom_papasofokli_planning_api_TimeLineButtons__tooltipOnHover__T__s_Option__F2($thiz, "Show sidebar", new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__showSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).afv($m_Lcom_papasofokli_planning_package$().Fi);
    })))));
    var onMouseOut$8 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__mouseOutShowSidebar__V($thiz);
    })));
    var initialX$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pI;
    var initialY$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pJ;
    var extraCssClass$2 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).sW;
    var generalTextHoverHtmlMap$2 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).sX;
    var dragFunction$5 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pF;
    var clickFunction$4 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pE;
    var draggingFunction$2 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pG;
    var contextMenuFunction$3 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).sV;
    var getGroupedDraggedShapes$5 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pH;
    var isMovableOnDrag$5 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pK;
    var href$5 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).sZ;
    var appendWithAnimationTime$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).pD;
    var horizontalAnchor$2 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).sY;
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz);
    $thiz.a4j = new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon$4, initialX$1, initialY$1, extraCssClass$2, generalTextHoverHtmlMap$2, dragFunction$5, clickFunction$4, draggingFunction$2, contextMenuFunction$3, getGroupedDraggedShapes$5, onHover$5, onMouseOut$8, isMovableOnDrag$5, href$5, appendWithAnimationTime$1, horizontalAnchor$2);
    $thiz.a4k = true;
  }
  return $thiz.a4j;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__showSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz) {
  if ((!$thiz.a4w)) {
    $thiz.a4v = $p_Lcom_papasofokli_planning_api_TimeLineButtons__fitToWidth__Lcom_papasofokli_svg_components_IconTextComponent__sci_Seq__Lcom_papasofokli_svg_components_IconTextComponent($thiz, $p_Lcom_papasofokli_planning_api_TimeLineButtons__fullShowSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().Ck, new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_SpanTextContainer("Show"), $m_sci_Nil$())));
    $thiz.a4w = true;
  }
  return $thiz.a4v;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__getCurrentPlannerColClass__T($thiz) {
  var xs = $f_T__split__T__I__AT($p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).className, " ", 0);
  _return: {
    var i = 0;
    while ((i < xs.a.length)) {
      var x1 = i;
      var x0 = xs.a[x1];
      if ($m_ju_regex_Pattern$().ahZ($thiz.a4d, x0)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  var this$6 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(xs.a[idx]));
  return (this$6.c() ? $thiz.a4e : this$6.h());
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__removeAllColClasses__V($thiz) {
  var xs = $f_T__split__T__I__AT($p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).className, " ", 0);
  var evidence$1 = $m_s_reflect_ClassTag$().um($objectGetClass(xs).ax.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.dK();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    if ($thiz.PB.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x) => ((x$0$2) => (!(!x.startsWith(x$0$2)))))(x)))) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? $m_scm_ArrayBuilder$().u(elementClass) : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var xs$1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  var f = ((cls$3) => {
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).classList.remove(cls$3);
  });
  var len = xs$1.a.length;
  var i$1 = 0;
  if ((xs$1 !== null)) {
    while ((i$1 < len)) {
      var x0 = xs$1.a[i$1];
      f(x0);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_I)) {
    while ((i$1 < len)) {
      var x0$1 = xs$1.a[i$1];
      f(x0$1);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_D)) {
    while ((i$1 < len)) {
      var x0$2 = xs$1.a[i$1];
      f(x0$2);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_J)) {
    while ((i$1 < len)) {
      var $x_1 = xs$1.a;
      var $x_2 = (i$1 << 1);
      var x0$3_$_lo = $x_1[$x_2];
      var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
      f($bL(x0$3_$_lo, x0$3_$_hi));
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_F)) {
    while ((i$1 < len)) {
      var x0$4 = xs$1.a[i$1];
      f(x0$4);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_C)) {
    while ((i$1 < len)) {
      var x0$5 = xs$1.a[i$1];
      f($bC(x0$5));
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_B)) {
    while ((i$1 < len)) {
      var x0$6 = xs$1.a[i$1];
      f(x0$6);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_S)) {
    while ((i$1 < len)) {
      var x0$7 = xs$1.a[i$1];
      f(x0$7);
      i$1 = ((1 + i$1) | 0);
    }
  } else if ((xs$1 instanceof $ac_Z)) {
    while ((i$1 < len)) {
      var x0$8 = xs$1.a[i$1];
      f(x0$8);
      i$1 = ((1 + i$1) | 0);
    }
  } else {
    throw new $c_s_MatchError(xs$1);
  }
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__expandSidebar__Lorg_scalajs_dom_HTMLDivElement__s_Option__V($thiz, sideBarElement, percentage) {
  $m_Lcom_papasofokli_expandablemodal_Resizeable$().atJ($p_Lcom_papasofokli_planning_api_TimeLineButtons__mainDivSelector__T($thiz), ("#" + sideBarElement.id), percentage, $thiz.K4);
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__showHideSidebarMultipleEventsFiltered__s_concurrent_Future($thiz) {
  return $thiz.a4r.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__showHideSidebarForPlannerId__Z__V($thiz, false);
  })));
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__showHideSidebarForPlannerId__Z__V($thiz, onlyShow) {
  var scrollLeft = (+$p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz).scrollLeft);
  var this$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__sideFilerDiv__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    if ((onlyShow || $p_Lcom_papasofokli_planning_api_TimeLineButtons__sidebarHidden__Z($thiz))) {
      if ($p_Lcom_papasofokli_planning_api_TimeLineButtons__sidebarHidden__Z($thiz)) {
        $p_Lcom_papasofokli_planning_api_TimeLineButtons__showSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => {
          $f_Lcom_papasofokli_svg_api_GeneralShape__remove__V(_$5$3);
        })));
        $thiz.K3.M5($p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz));
        $p_Lcom_papasofokli_planning_api_TimeLineButtons__removeAllColClasses__V($thiz);
        $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).classList.remove($thiz.PC);
        $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).classList.add($thiz.PE);
      }
      x0.scrollWidth;
      var percentage = $m_s_None$();
    } else {
      $thiz.PE = $p_Lcom_papasofokli_planning_api_TimeLineButtons__getCurrentPlannerColClass__T($thiz);
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz).di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$3) => {
        $f_Lcom_papasofokli_svg_api_GeneralShape__remove__V(_$6$3);
      })));
      $thiz.K3.M5($p_Lcom_papasofokli_planning_api_TimeLineButtons__showSidebar__Lcom_papasofokli_svg_components_IconTextComponent($thiz));
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__removeAllColClasses__V($thiz);
      $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).classList.add($thiz.PC);
      var percentage = new $c_s_Some(0.0);
    }
    $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__expandSidebar__Lorg_scalajs_dom_HTMLDivElement__s_Option__V($thiz, x0, percentage);
  }
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz).scrollLeft = scrollLeft;
}
function $p_Lcom_papasofokli_planning_api_TimeLineButtons__resizeSidebarForPlannerId__I__V($thiz, sidebarSize) {
  var scrollLeft = (+$p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz).scrollLeft);
  var this$1 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__sideFilerDiv__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var percentage = new $c_s_Some(Math.fround((100.0 - Math.fround((100.0 * Math.fround((Math.fround((($thiz.K5 - sidebarSize) | 0)) / Math.fround($thiz.K5))))))));
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__removeAllColClasses__V($thiz);
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__div10El__Lorg_scalajs_dom_HTMLElement($thiz).classList.add(("col-md-" + (($thiz.K5 - sidebarSize) | 0)));
    $thiz.PB.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((prefix$2) => {
      var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x0.classList);
      $m_sci_List$();
      var this$7 = $m_sci_Nil$().aY(this$5);
      var f = ((prefix$1) => ((_$7$2) => (!(!_$7$2.startsWith(prefix$1)))))(prefix$2);
      var l$tailLocal1 = this$7;
      while (true) {
        if (l$tailLocal1.c()) {
          return $m_sci_Nil$();
        } else {
          var h = l$tailLocal1.W();
          var t = l$tailLocal1.ak();
          if ((!(!(!f(h))))) {
            l$tailLocal1 = t;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t;
          while (true) {
            if (remaining$tailLocal1.c()) {
              return start;
            } else {
              var x = remaining$tailLocal1.W();
              if ((!(!f(x)))) {
                remaining$tailLocal1 = remaining$tailLocal1.ak();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
              var toProcess = start.ak();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
                currentLast.bz = newElem;
                currentLast = newElem;
                toProcess = toProcess.ak();
              }
              var next = firstMiss.ak();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.W();
                if ((!(!f(head)))) {
                  next = next.ak();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                    currentLast.bz = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.ak();
                  }
                  nextToCopy = next.ak();
                  next = next.ak();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.bz = nextToCopy;
              }
              return newHead;
            }
          }
        }
      }
    }))).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cls$3) => {
      x0.classList.remove(cls$3);
    })));
    x0.classList.add(("col-md-" + sidebarSize));
    $p_Lcom_papasofokli_planning_api_TimeLineButtons__expandSidebar__Lorg_scalajs_dom_HTMLDivElement__s_Option__V($thiz, x0, percentage);
  }
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__plannerEl__Lorg_scalajs_dom_HTMLElement($thiz).scrollLeft = scrollLeft;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLineButtons(timeLineHeight, rightSideWidth, showButtons, plannerId, executionContext) {
  this.a4u = 0.0;
  this.PF = null;
  this.K4 = null;
  this.PB = null;
  this.a4d = null;
  this.a4e = null;
  this.PC = null;
  this.K5 = 0;
  this.K2 = 0.0;
  this.Fd = 0.0;
  this.a4b = 0.0;
  this.a4c = null;
  this.Fc = null;
  this.a4x = null;
  this.a4y = false;
  this.PD = null;
  this.a4z = null;
  this.a4h = null;
  this.a4i = false;
  this.a4s = null;
  this.a4t = false;
  this.a4n = 0.0;
  this.a4o = false;
  this.a4p = 0.0;
  this.a4q = false;
  this.a4f = null;
  this.a4g = false;
  this.a4l = null;
  this.a4m = false;
  this.a4j = null;
  this.a4k = false;
  this.a4v = null;
  this.a4w = false;
  this.a4r = null;
  this.PE = null;
  this.K3 = null;
  this.a4u = rightSideWidth;
  this.PF = plannerId;
  this.K4 = executionContext;
  this.PB = new $c_sci_$colon$colon("col-xs-", new $c_sci_$colon$colon("col-sm-", new $c_sci_$colon$colon("col-md-", new $c_sci_$colon$colon("col-lg-", new $c_sci_$colon$colon("col-xl-", $m_sci_Nil$())))));
  this.a4d = "col-(xs|sm|md|lg|xl)-\\d+";
  this.a4e = "col-md-9";
  this.PC = "col";
  this.K5 = 12;
  this.K2 = 50.0;
  this.Fd = 10.0;
  this.a4b = Math.fround((Math.fround((timeLineHeight / Math.fround($m_Lcom_papasofokli_util_misc_package$().a8Z))) - 25.0));
  this.a4c = "activeText-big activeText not-selectable";
  this.Fc = $m_s_None$();
  var this$5 = $m_s_Option$().Z(document.querySelector((("#" + plannerId) + " .timeline-svg-main .name-rank-div")));
  var pf = new $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1();
  this.PD = ((!this$5.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$5.h()) : $m_s_None$());
  var this$7 = this.PD;
  var timeLineButtonsDivId = (this$7.c() ? $m_ju_UUID$().aW().g() : this$7.h());
  this.a4z = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", timeLineButtonsDivId), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "name-rank-div"), $m_sci_Nil$()));
  var initialClassName$1 = $m_s_Option$().Z($m_Lcom_papasofokli_planning_package$().Bn);
  var resizeUpFunction$1 = $m_s_None$();
  var resizeDownFunction$1 = $m_s_None$();
  var resizeLeftFunction$1 = $m_s_None$();
  var resizeRightFunction$1 = $m_s_None$();
  var dragFunction$1 = $m_s_None$();
  var clickFunction$1 = $m_s_None$();
  var contextMenuFunction$1 = $m_s_None$();
  var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var onHover$1 = $m_s_None$();
  var onMouseOut$1 = $m_s_None$();
  var href$1 = $m_s_None$();
  var color$1 = $m_s_None$();
  var stroke$1 = $m_s_None$();
  var onBoundHover$1 = $m_s_None$();
  var rect = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$1, timeLineHeight, rightSideWidth, 0.0, 0.0, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$1, clickFunction$1, contextMenuFunction$1, getGroupedDraggedShapes$1, onHover$1, onMouseOut$1, true, href$1, this.Fc, color$1, stroke$1, onBoundHover$1);
  var initialClassName$2 = $m_s_Option$().Z("axisline");
  var dragFunction$2 = $m_s_None$();
  var clickFunction$2 = $m_s_None$();
  var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_LineComponent$().DK();
  var onHover$2 = $m_s_None$();
  var onMouseOut$2 = $m_s_None$();
  var stroke$2 = $m_s_None$();
  var lineId$1 = $m_ju_UUID$().aW();
  var horizontalBorder = new $c_Lcom_papasofokli_svg_components_LineComponent(initialClassName$2, 0.0, timeLineHeight, rightSideWidth, timeLineHeight, dragFunction$2, clickFunction$2, getGroupedDraggedShapes$2, true, onHover$2, onMouseOut$2, this.Fc, stroke$2, lineId$1);
  var initialClassName$3 = $m_s_Option$().Z("axisline");
  var dragFunction$3 = $m_s_None$();
  var clickFunction$3 = $m_s_None$();
  var getGroupedDraggedShapes$3 = $m_Lcom_papasofokli_svg_components_LineComponent$().DK();
  var onHover$3 = $m_s_None$();
  var onMouseOut$3 = $m_s_None$();
  var stroke$3 = $m_s_None$();
  var lineId$2 = $m_ju_UUID$().aW();
  var verticalBorder = new $c_Lcom_papasofokli_svg_components_LineComponent(initialClassName$3, rightSideWidth, 0.0, rightSideWidth, timeLineHeight, dragFunction$3, clickFunction$3, getGroupedDraggedShapes$3, true, onHover$3, onMouseOut$3, this.Fc, stroke$3, lineId$2);
  if (showButtons) {
    var faIcon$1 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().a8J, $m_sci_Nil$());
    var href$2 = new $c_s_Some("/");
    var onHoverExtra$1 = $m_s_None$();
    var onMouseOut$5 = $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton$default$5__F0(this);
    var clickFn$1 = $m_s_None$();
    var homePageLink = new $c_s_Some($p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton__F__sci_Seq__T__s_Option__F0__s_Option__s_Option__Lcom_papasofokli_svg_components_IconTextComponent(this, this.Fd, faIcon$1, "Go to home page", onHoverExtra$1, onMouseOut$5, clickFn$1, href$2));
  } else {
    var homePageLink = $m_s_None$();
  }
  if (showButtons) {
    var x$1 = Math.fround((this.Fd + Math.fround((2.0 * this.K2))));
    var faIcon$2 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_IconUI$().a8I, $m_sci_Nil$());
    var clickFn$2 = $m_s_Option$().Z($p_Lcom_papasofokli_planning_api_TimeLineButtons__fullPageClickFun__F1(this));
    var fullPageButton = new $c_s_Some($p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton__F__sci_Seq__T__s_Option__F0__s_Option__s_Option__Lcom_papasofokli_svg_components_IconTextComponent(this, x$1, faIcon$2, "Full screen", $m_s_None$(), $p_Lcom_papasofokli_planning_api_TimeLineButtons__iconButton$default$5__F0(this), clickFn$2, $m_s_None$()));
  } else {
    var fullPageButton = $m_s_None$();
  }
  var refreshButtonO = (showButtons ? new $c_s_Some($p_Lcom_papasofokli_planning_api_TimeLineButtons__refreshButton__Lcom_papasofokli_svg_components_IconTextComponent(this)) : $m_s_None$());
  var cond = (showButtons && (!$p_Lcom_papasofokli_planning_api_TimeLineButtons__sideFilerDiv__s_Option(this).c()));
  var showHideFilterBar = (cond ? new $c_s_Some($p_Lcom_papasofokli_planning_api_TimeLineButtons__hideSidebar__Lcom_papasofokli_svg_components_IconTextComponent(this)) : $m_s_None$());
  this.a4r = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, executionContext);
  this.PE = "";
  this.K3 = new $c_Lcom_papasofokli_svg_SVGController(timeLineButtonsDivId, new $c_sci_$colon$colon(rect, new $c_sci_$colon$colon(horizontalBorder, new $c_sci_$colon$colon(verticalBorder, $m_sci_Nil$()))).cY(fullPageButton).cY(refreshButtonO).cY(homePageLink).cY(showHideFilterBar), timeLineHeight, new $c_s_Some(rightSideWidth), executionContext);
}
$p = $c_Lcom_papasofokli_planning_api_TimeLineButtons.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLineButtons;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLineButtons() {
}
$h_Lcom_papasofokli_planning_api_TimeLineButtons.prototype = $p;
$p.ga = (function() {
  return this.K3.ga();
});
$p.aw5 = (function(timelineDiv) {
  var x13 = this.PD;
  if ((x13 instanceof $c_s_Some)) {
    return timelineDiv;
  }
  if (($m_s_None$() === x13)) {
    var timeLineButtonsDiv = document.createElement("div");
    this.a4z.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$3) => {
      _$8$3.ds(timeLineButtonsDiv);
    })));
    return timelineDiv.appendChild(timeLineButtonsDiv);
  }
  throw new $c_s_MatchError(x13);
});
var $d_Lcom_papasofokli_planning_api_TimeLineButtons = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLineButtons, "com.papasofokli.planning.api.TimeLineButtons", ({
  qV: 1
}));
function $p_Lcom_papasofokli_planning_api_TimeLinePlanningSVG__getEndPoint__F($thiz) {
  var this$1 = $m_s_Option$().Z($thiz.PG);
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.h().ahw());
  return Math.fround((this$2.c() ? $thiz.K8 : this$2.h()));
}
function $p_Lcom_papasofokli_planning_api_TimeLinePlanningSVG__loadTimeTopDiv__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Node($thiz, timelineDiv) {
  var x9 = $thiz.K7;
  if ((x9 instanceof $c_s_Some)) {
    var id = x9.bg;
    var div = document.getElementById(id);
    div.innerHTML = "";
    return div;
  }
  if (($m_s_None$() === x9)) {
    var timeLineTopDiv = document.createElement("div");
    $thiz.a4D.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
      _$4$3.ds(timeLineTopDiv);
    })));
    return timelineDiv.appendChild(timeLineTopDiv);
  }
  throw new $c_s_MatchError(x9);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG(planningData, parentDiv, rightSideWidth, onHover, mouseOut, executionContext) {
  this.a4A = null;
  this.K6 = null;
  this.a4C = null;
  this.K8 = 0.0;
  this.nK = null;
  this.PG = null;
  this.K7 = null;
  this.a4D = null;
  this.a4B = null;
  this.Fe = null;
  this.a4A = parentDiv;
  var scrollBarWidth = Math.fround($m_Lcom_papasofokli_util_GeometryMethods$().ahv());
  var totalWidth = (planningData.k8 ? Math.fround((Math.fround((Math.fround((Math.fround((+parentDiv.parentElement.parentElement.parentElement.getBoundingClientRect().width)) - rightSideWidth)) - scrollBarWidth)) - 20.0)) : Math.fround((Math.fround((Math.fround((+parentDiv.getBoundingClientRect().width)) - rightSideWidth)) - scrollBarWidth)));
  var this$2 = $m_sjs_js_ArrayOps$().zK((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + parentDiv.id) + " .timeline-svg-main")).toArray());
  var pf = new $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1();
  this.K6 = ((!this$2.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$2.h()) : $m_s_None$());
  var this$4 = this.K6;
  var timeLineDivId = (this$4.c() ? $m_ju_UUID$().aW().g() : this$4.h());
  this.a4C = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", timeLineDivId), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "timeline-div  timeline-svg-main"), $m_sci_Nil$()));
  var highlightFromDate_$_lo = planningData.kC;
  var highlightFromDate_$_hi = planningData.kD;
  var this$8 = planningData.nx;
  if (this$8.c()) {
    var $x_2 = $uJ(planningData.lR.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.V8().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => {
      var $x_3 = _$2$2;
      return $bL($x_3.ot, $x_3.ou);
    })))))).fq($m_s_math_Ordering$Long$()));
  } else {
    var $x_2 = this$8.h();
  }
  var $x_1 = $uJ($x_2);
  var toDateLong_$_lo = $x_1.l;
  var toDateLong_$_hi = $x_1.h;
  var $x_4 = $m_Lcom_papasofokli_planning_package$().auj(planningData.ny);
  var divSizeMills_$_lo = $x_4.l;
  var divSizeMills_$_hi = $x_4.h;
  var compressedLo = (((((-2097152) & (toDateLong_$_hi ^ (toDateLong_$_hi >> 10))) === 0) || ((65535 & toDateLong_$_lo) === 0)) ? toDateLong_$_lo : (32768 | ((-32768) & toDateLong_$_lo)));
  var compressedLo$1 = (((((-2097152) & (highlightFromDate_$_hi ^ (highlightFromDate_$_hi >> 10))) === 0) || ((65535 & highlightFromDate_$_lo) === 0)) ? highlightFromDate_$_lo : (32768 | ((-32768) & highlightFromDate_$_lo)));
  var compressedLo$2 = (((((-2097152) & (divSizeMills_$_hi ^ (divSizeMills_$_hi >> 10))) === 0) || ((65535 & divSizeMills_$_lo) === 0)) ? divSizeMills_$_lo : (32768 | ((-32768) & divSizeMills_$_lo)));
  var relativeWidth = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(Math.fround((Math.fround((Math.fround(((4.294967296E9 * toDateLong_$_hi) + (compressedLo >>> 0.0))) - Math.fround(((4.294967296E9 * highlightFromDate_$_hi) + (compressedLo$1 >>> 0.0))))) / Math.fround(((4.294967296E9 * divSizeMills_$_hi) + (compressedLo$2 >>> 0.0))))), new $c_sci_$colon$colon(1.0, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  var timeDomainStart = new Date(((4.294967296E9 * highlightFromDate_$_hi) + (highlightFromDate_$_lo >>> 0.0)));
  var timeDomainEnd = new Date(((4.294967296E9 * toDateLong_$_hi) + (toDateLong_$_lo >>> 0.0)));
  this.K8 = (planningData.lU ? Math.fround((1.7 * Math.fround((totalWidth * relativeWidth)))) : Math.fround((totalWidth * relativeWidth)));
  var appendWithAnimationTime = ((!this.K6.c()) ? $m_s_None$() : new $c_s_Some(0.20000000298023224));
  this.nK = new $c_Lcom_papasofokli_svg_timeline_TimeLineSVG(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_planning_api_TimeLinePlanningSVG__getEndPoint__F(this))), timeDomainStart, timeDomainEnd, 30.0, onHover, mouseOut, appendWithAnimationTime);
  var timeLineHeight = this.nK.Qg;
  var initialClassName$1 = $m_s_Option$().Z("axisline");
  var dragFunction$1 = $m_s_None$();
  var clickFunction$1 = $m_s_None$();
  var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_LineComponent$().DK();
  var onHover$1 = $m_s_None$();
  var onMouseOut$1 = $m_s_None$();
  var appendWithAnimationTime$1 = $m_s_Option$().Z(0.5);
  var stroke$1 = $m_s_None$();
  var lineId$1 = $m_ju_UUID$().aW();
  this.PG = new $c_Lcom_papasofokli_svg_components_LineComponent(initialClassName$1, 0.0, timeLineHeight, this.K8, timeLineHeight, dragFunction$1, clickFunction$1, getGroupedDraggedShapes$1, true, onHover$1, onMouseOut$1, appendWithAnimationTime$1, stroke$1, lineId$1);
  var this$30 = $m_sjs_js_ArrayOps$().zK((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + timeLineDivId) + " .timeline-over-positions-div")).toArray());
  var pf$1 = new $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2();
  this.K7 = ((!this$30.c()) ? new $c_s_PartialFunction$Lifted(pf$1).Z(this$30.h()) : $m_s_None$());
  var this$32 = this.K7;
  var timeLineTopDivId = (this$32.c() ? $m_ju_UUID$().aW().g() : this$32.h());
  this.a4D = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", timeLineTopDivId), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "positions-div timeline-over-positions-div"), $m_sci_Nil$()));
  this.a4B = new $c_Lcom_papasofokli_svg_SVGController(timeLineTopDivId, new $c_sci_$colon$colon(this.PG, new $c_sci_$colon$colon(this.nK, $m_sci_Nil$())), timeLineHeight, $m_s_Option$().Z(this.K8), executionContext);
  this.Fe = new $c_Lcom_papasofokli_planning_api_TimeLineButtons(timeLineHeight, rightSideWidth, planningData.k8, parentDiv.id, executionContext);
}
$p = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG() {
}
$h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG.prototype = $p;
$p.Vw = (function() {
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__showHideSidebarForPlannerId__Z__V(this.Fe, true);
});
$p.Vf = (function(sidebarSize) {
  $p_Lcom_papasofokli_planning_api_TimeLineButtons__resizeSidebarForPlannerId__I__V(this.Fe, sidebarSize);
});
$p.ux = (function(executionContext) {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    matchResult6: {
      var timelineDiv;
      var x12 = this.K6;
      if ((x12 instanceof $c_s_Some)) {
        var id = x12.bg;
        var timelineDiv = document.getElementById(id);
        break matchResult6;
      }
      if (($m_s_None$() === x12)) {
        var div = document.createElement("div");
        this.a4C.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => {
          _$5$3.ds(div);
        })));
        this.a4A.appendChild(div);
        var timelineDiv = div;
        break matchResult6;
      }
      throw new $c_s_MatchError(x12);
    }
    this.Fe.aw5(timelineDiv);
    $p_Lcom_papasofokli_planning_api_TimeLinePlanningSVG__loadTimeTopDiv__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Node(this, timelineDiv);
    return timelineDiv;
  })), executionContext);
});
$p.aiL = (function(executionContext) {
  return this.Fe.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    var this$2 = this.K7;
    var this$4 = (this$2.c() ? $m_s_None$() : new $c_s_Some((this$2.h(), $m_s_concurrent_Future$().aE($m_s_None$()))));
    return (this$4.c() ? $m_Lcom_papasofokli_util_DelayFuture$().jj(100, 0) : this$4.h()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => this.a4B.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$3) => {
      var t$2 = (+t$3);
      return $m_Lcom_papasofokli_util_DelayFuture$().jj(200, 0).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => t$2)), executionContext);
    })), executionContext))), executionContext);
  })), executionContext);
});
var $d_Lcom_papasofokli_planning_api_TimeLinePlanningSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG, "com.papasofokli.planning.api.TimeLinePlanningSVG", ({
  qZ: 1
}));
function $p_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG__createVoyageClickFunction__T__s_Option($thiz, voyageNumber) {
  var this$1 = $thiz.a4I;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((uuid$2) => ((_$1$3) => {
    var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), voyageNumber, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().m);
    var executionContext = $thiz.K9;
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, uuid$2.g(), data, executionContext);
  }))(this$1.h()))));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG(parentDiv, totalWidth, leftWidth, rowHeight, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi, vesselSchedules, timeLineSVG, voyageClickCallback, zoomLevel, ec) {
  this.a4G = null;
  this.a4I = null;
  this.K9 = null;
  this.Bg = null;
  this.PI = false;
  this.Ka = 0.0;
  this.PH = null;
  this.PJ = null;
  this.PK = null;
  this.a4F = null;
  this.a4E = null;
  this.a4H = null;
  this.a4G = parentDiv;
  this.a4I = voyageClickCallback;
  this.K9 = ec;
  this.Bg = new $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig(rowHeight, 5.0, 60.0, 0.0, 8.0, 30.0, 8.0, 5.0, 10.0, 10, 2);
  if ((!zoomLevel.c())) {
    var x0 = zoomLevel.h();
    var $x_2 = $uJ(x0);
    var z$2_$_lo = $x_2.l;
    var z$2_$_hi = $x_2.h;
    var $x_1 = (((z$2_$_lo | z$2_$_hi) === 0) || (((1 ^ z$2_$_lo) | z$2_$_hi) === 0));
  } else {
    var $x_1 = false;
  }
  this.PI = $x_1;
  var vesselInfoPairs = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agw(vesselSchedules, this.PI, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi);
  this.Ka = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().an5(vesselInfoPairs.F(), this.Bg);
  this.PH = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().atV(parentDiv.id, "vessel-schedule-div");
  matchResult2: {
    var \u03b42$;
    var x2 = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().aue(this.PH);
    if ((x2 !== null)) {
      var \u03b42$ = x2;
      break matchResult2;
    }
    throw new $c_s_MatchError(x2);
  }
  var mainDivId$2 = \u03b42$.gZ;
  this.PJ = \u03b42$.fY;
  this.PK = \u03b42$.gr;
  this.a4F = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", mainDivId$2), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "vessel-schedule-div"), $m_sci_Nil$()));
  var leftRectangles = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agr(vesselInfoPairs, this.Bg, leftWidth, 0.0);
  var leftTextComponents = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().ags(vesselInfoPairs, this.Bg, 0.0);
  this.a4E = new $c_Lcom_papasofokli_svg_SVGController(this.PJ, leftRectangles.cH(leftTextComponents), this.Ka, new $c_s_Some(leftWidth), ec);
  var rightBaseRect = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().at8("white-fill", this.Ka, totalWidth);
  var scheduleBlocks = vesselInfoPairs.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var pair = x$1$2.P();
      var vesselIdx = (x$1$2.V() | 0);
      return pair.Bf.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((voyage$2) => $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agx(voyage$2, vesselIdx, timeLineSVG, totalWidth, this.Bg, $p_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG__createVoyageClickFunction__T__s_Option(this, voyage$2.nL), this.PI, 0.0)))).dt(pair.Bd.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((port$2) => $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agt(port$2, vesselIdx, timeLineSVG, totalWidth, this.Bg, 0.0)))));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  this.a4H = new $c_Lcom_papasofokli_svg_SVGController(this.PK, scheduleBlocks.ba(rightBaseRect), this.Ka, new $c_s_Some(totalWidth), ec);
}
$p = $c_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG() {
}
$h_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG.prototype = $p;
$p.aw3 = (function() {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().aw4(this.a4G, this.PH, "vessel-schedule-div", this.a4F, this.PJ, this.PK))), this.K9);
});
$p.ga = (function() {
  return this.a4E.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => this.a4H.ga())), this.K9);
});
var $d_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_VesselInfoPairComponentSVG, "com.papasofokli.planning.api.VesselInfoPairComponentSVG", ({
  r2: 1
}));
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageBlocks__T__sci_Seq__sci_Seq($thiz, vesselName, schedules) {
  var m = $m_scm_Map$().ce();
  var it = schedules.l();
  while (it.f()) {
    var elem = it.e();
    var key = elem.su;
    m.oM(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.dw()))(schedules))).aD(elem);
  }
  var result = $m_sci_HashMap$().kr;
  var mapIt = m.l();
  while (mapIt.f()) {
    var x1 = mapIt.e();
    x1.P();
    x1.V();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.P();
    var v$2 = \u03b42$.V();
    result = result.jC(k$2, v$2.aR());
  }
  var this$2 = result;
  var b = $m_sci_Iterable$().aP();
  var it$1 = this$2.l();
  while (it$1.f()) {
    var x0 = it$1.e();
    matchResult5: {
      var $x_1;
      if ((x0 !== null)) {
        var voyageNumber = x0.P();
        var scheds = x0.V();
        var $x_6 = scheds.W().st;
        var $x_4 = $uJ(scheds.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
          var $x_5 = _$4$2;
          return $bL($x_5.kE, $x_5.kF);
        }))).gJ($m_s_math_Ordering$Long$()));
        var $x_2 = $uJ(scheds.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => {
          var $x_3 = _$5$2;
          return $bL($x_3.ox, $x_3.oy);
        }))).fq($m_s_math_Ordering$Long$()));
        var $x_1 = new $c_Lcom_papasofokli_planning_api_VoyageBlock(voyageNumber, vesselName, $x_6, $x_4.l, $x_4.h, $x_2.l, $x_2.h);
        break matchResult5;
      }
      throw new $c_s_MatchError(x0);
    }
    b.aD($x_1);
  }
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(b.aR().cf(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
    var $x_7 = _$6$2;
    return $bL($x_7.uf, $x_7.ug);
  })), $m_s_math_Ordering$Long$());
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getCalendarDay__J__J($thiz, ms_$_lo, ms_$_hi) {
  var date = new Date(((4.294967296E9 * ms_$_hi) + (ms_$_lo >>> 0.0)));
  var year = $doubleToInt((+date.getUTCFullYear()));
  var month = $doubleToInt((+date.getUTCMonth()));
  var day = $doubleToInt((+date.getUTCDate()));
  var dayStart = new Date((((((year + "-") + ((1 + month) | 0)) + "-") + day) + " UTC"));
  return $m_RTLong$().jq((+dayStart.getTime()));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftRect__I__I__T__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__F__Lcom_papasofokli_svg_components_RectComponent($thiz, vesselIdx, rowWithinVessel, className, config, leftWidth, baseY) {
  var initialClassName$1 = new $c_s_Some(className);
  var initialY$1 = $thiz.E9(vesselIdx, rowWithinVessel, config, baseY);
  var resizeUpFunction$1 = $m_s_None$();
  var resizeDownFunction$1 = $m_s_None$();
  var resizeLeftFunction$1 = $m_s_None$();
  var resizeRightFunction$1 = $m_s_None$();
  var dragFunction$1 = $m_s_None$();
  var clickFunction$1 = $m_s_None$();
  var contextMenuFunction$1 = $m_s_None$();
  var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var onHover$1 = $m_s_None$();
  var onMouseOut$1 = $m_s_None$();
  var href$1 = $m_s_None$();
  var appendWithAnimationTime$1 = new $c_s_Some(0.5);
  var color$1 = $m_s_None$();
  var stroke$1 = $m_s_None$();
  var onBoundHover$1 = $m_s_None$();
  return new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$1, config.i7, leftWidth, 0.0, initialY$1, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$1, clickFunction$1, contextMenuFunction$1, getGroupedDraggedShapes$1, onHover$1, onMouseOut$1, true, href$1, appendWithAnimationTime$1, color$1, stroke$1, onBoundHover$1);
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftText__T__T__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__Lcom_papasofokli_svg_components_TextComponent($thiz, vesselName, infoType, vesselIdx, rowWithinVessel, config, baseY) {
  return $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createSimpleTextComponent__T__T__F__F__Lcom_papasofokli_svg_components_TextComponent($thiz, ((vesselName + " - ") + infoType), "planning-left-side-text-small not-selectable", config.xa, Math.fround((Math.fround(($thiz.E9(vesselIdx, rowWithinVessel, config, baseY) + Math.fround((0.5 * config.i7)))) + config.px)));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageRect__Lcom_papasofokli_planning_api_VoyageBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__s_Option__F__Lcom_papasofokli_svg_components_RectComponent($thiz, voyage, startX, blockWidth, vesselIdx, rowWithinVessel, config, clickFunction, baseY) {
  var yOffset = $thiz.E9(vesselIdx, rowWithinVessel, config, baseY);
  var tooltipHtml = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageTooltipHtml__T__T__T__T__T__T($thiz, voyage.Bl, voyage.nL, voyage.Bk, $m_Lcom_papasofokli_util_DateUtilsJS$().MF(voyage.uf, voyage.ug), $m_Lcom_papasofokli_util_DateUtilsJS$().MF(voyage.zm, voyage.zn));
  matchResult10: {
    var \u03b42$;
    var x25 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createTooltip__T__T2($thiz, tooltipHtml);
    if ((x25 !== null)) {
      x25.P();
      x25.V();
      var \u03b42$ = x25;
      break matchResult10;
    }
    throw new $c_s_MatchError(x25);
  }
  var tooltipAction$2 = \u03b42$.P();
  var mouseOutAction$2 = \u03b42$.V();
  var initialClassName$2 = new $c_s_Some("bar");
  var initialY$2 = Math.fround((yOffset + config.xb));
  var resizeUpFunction$2 = $m_s_None$();
  var resizeDownFunction$2 = $m_s_None$();
  var resizeLeftFunction$2 = $m_s_None$();
  var resizeRightFunction$2 = $m_s_None$();
  var dragFunction$2 = $m_s_None$();
  var contextMenuFunction$2 = $m_s_None$();
  var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var href$2 = $m_s_None$();
  var color$2 = $m_s_None$();
  var stroke$2 = $m_s_None$();
  var onBoundHover$2 = $m_s_None$();
  return new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$2, config.i7, blockWidth, startX, initialY$2, resizeUpFunction$2, resizeDownFunction$2, resizeLeftFunction$2, resizeRightFunction$2, dragFunction$2, clickFunction, contextMenuFunction$2, getGroupedDraggedShapes$2, tooltipAction$2, mouseOutAction$2, true, href$2, $m_s_None$(), color$2, stroke$2, onBoundHover$2);
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageText__Lcom_papasofokli_planning_api_VoyageBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__Z__F__s_Option($thiz, voyage, startX, blockWidth, vesselIdx, rowWithinVessel, config, isMonthZoom, baseY) {
  if ((blockWidth <= config.Bj)) {
    return $m_s_None$();
  }
  var yOffset = $thiz.E9(vesselIdx, rowWithinVessel, config, baseY);
  if (isMonthZoom) {
    var this$2 = $m_sc_StringOps$().Eb($f_T__trim__T(voyage.nL));
    if (this$2.c()) {
      var this$6 = $m_s_None$();
    } else {
      var x0 = this$2.h();
      var _$14$2 = $uC(x0);
      var this$4 = ("" + $cToS(_$14$2));
      var this$6 = new $c_s_Some(this$4.toUpperCase());
    }
    var displayText = (this$6.c() ? "" : this$6.h());
  } else {
    var displayText = voyage.nL;
  }
  if ((displayText === "")) {
    return $m_s_None$();
  }
  var estimatedTextWidth = Math.fround((Math.fround(displayText.length) * config.pw));
  var availableWidth = Math.fround((blockWidth - config.xd));
  if ((estimatedTextWidth > availableWidth)) {
    var \u03b43$___1 = new $c_s_Some(availableWidth);
    var \u03b43$___2 = new $c_s_Some($m_Lcom_papasofokli_svg_api_TextAdjustStrategy$().a6Q);
  } else {
    var \u03b43$___1 = $m_s_None$();
    var \u03b43$___2 = $m_s_None$();
  }
  var textLengthValue = \u03b43$___1;
  var lengthAdjustValue = \u03b43$___2;
  return new $c_s_Some(new $c_Lcom_papasofokli_svg_components_TextComponent(new $c_s_Some("planning-left-side-text-small"), displayText, Math.fround((startX + Math.fround((0.5 * blockWidth)))), Math.fround((Math.fround((yOffset + Math.fround((0.5 * config.i7)))) + config.px)), textLengthValue, lengthAdjustValue, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_TextComponent$().hb(), false, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createPortCell__Lcom_papasofokli_planning_api_MergedPortBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__sci_Seq($thiz, block, startX, blockWidth, vesselIdx, rowWithinVessel, config, baseY) {
  var yOffset = $thiz.E9(vesselIdx, rowWithinVessel, config, baseY);
  var tooltipHtml = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createMultiPortTooltipHtml__sci_Seq__T($thiz, block.ps);
  matchResult12: {
    var \u03b45$;
    var x33 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createTooltip__T__T2($thiz, tooltipHtml);
    if ((x33 !== null)) {
      x33.P();
      x33.V();
      var \u03b45$ = x33;
      break matchResult12;
    }
    throw new $c_s_MatchError(x33);
  }
  var tooltipAction$2 = \u03b45$.P();
  var mouseOutAction$2 = \u03b45$.V();
  var this$2 = block.B2;
  var initialClassName$4 = new $c_s_Some(("bar " + (this$2.c() ? "" : this$2.h())));
  var initialY$4 = Math.fround((yOffset + config.xb));
  var resizeUpFunction$3 = $m_s_None$();
  var resizeDownFunction$3 = $m_s_None$();
  var resizeLeftFunction$3 = $m_s_None$();
  var resizeRightFunction$3 = $m_s_None$();
  var dragFunction$4 = $m_s_None$();
  var clickFunction$3 = $m_s_None$();
  var contextMenuFunction$4 = $m_s_None$();
  var getGroupedDraggedShapes$4 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var href$4 = $m_s_None$();
  var appendWithAnimationTime$2 = new $c_s_Some(0.5);
  var color$4 = $m_s_None$();
  var stroke$4 = $m_s_None$();
  var onBoundHover$3 = $m_s_None$();
  var rect = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$4, config.i7, blockWidth, startX, initialY$4, resizeUpFunction$3, resizeDownFunction$3, resizeLeftFunction$3, resizeRightFunction$3, dragFunction$4, clickFunction$3, contextMenuFunction$4, getGroupedDraggedShapes$4, tooltipAction$2, mouseOutAction$2, true, href$4, appendWithAnimationTime$2, color$4, stroke$4, onBoundHover$3);
  if ((block.ps.F() > 1)) {
    var label = ("" + block.ps.F());
  } else {
    var x_$_lo = block.DB;
    var x_$_hi = block.DC;
    var x$1_$_lo = block.zk;
    var x$1_$_hi = block.zl;
    var lo = ((x_$_lo - x$1_$_lo) | 0);
    var hi = ((((x_$_hi - x$1_$_hi) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
    var label = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getPortLabelForWidth__T__F__J__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__T($thiz, block.ps.W().pp, blockWidth, lo, hi, config);
  }
  $m_sc_StringOps$();
  return $m_s_Option$().hi(((label !== "") ? new $c_s_Some($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createSimpleTextComponent__T__T__F__F__Lcom_papasofokli_svg_components_TextComponent($thiz, label, "planning-left-side-text-small", Math.fround((startX + Math.fround((0.5 * blockWidth)))), Math.fround((Math.fround((yOffset + Math.fround((0.5 * config.i7)))) + config.px)))) : $m_s_None$())).cf().ba(rect);
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getPortLabelForWidth__T__F__J__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__T($thiz, portName, blockWidth, durationMs_$_lo, durationMs_$_hi, config) {
  var sign = (durationMs_$_hi >> 31);
  var xlo = (durationMs_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((durationMs_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074087E-8 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(86400000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((durationMs_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var durationDays_$_lo = lo$2;
    var durationDays_$_hi = hi$2;
  } else {
    var durationDays_$_lo = absR_$_lo;
    var durationDays_$_hi = absR_$_hi;
  }
  if (((durationDays_$_hi === 0) ? ((durationDays_$_lo >>> 0) <= 1) : (durationDays_$_hi < 0))) {
    var this$15 = $m_sc_StringOps$().Eb($f_T__trim__T(portName));
    if (this$15.c()) {
      var this$19 = $m_s_None$();
    } else {
      var x0 = this$15.h();
      var _$15$2 = $uC(x0);
      var this$17 = ("" + $cToS(_$15$2));
      var this$19 = new $c_s_Some(this$17.toUpperCase());
    }
    return (this$19.c() ? "" : this$19.h());
  } else {
    var estimatedTextWidth = Math.fround((Math.fround(portName.length) * config.pw));
    var availableWidth = Math.fround((blockWidth - config.xd));
    if ((availableWidth < Math.fround((2.0 * config.pw)))) {
      return "";
    } else if ((availableWidth < Math.fround((4.0 * config.pw)))) {
      var this$21 = $m_sc_StringOps$().Eb($f_T__trim__T(portName));
      if (this$21.c()) {
        var this$25 = $m_s_None$();
      } else {
        var x0$1 = this$21.h();
        var _$16$2 = $uC(x0$1);
        var this$23 = ("" + $cToS(_$16$2));
        var this$25 = new $c_s_Some(this$23.toUpperCase());
      }
      return (this$25.c() ? "" : this$25.h());
    } else if ((estimatedTextWidth > availableWidth)) {
      if ((portName.length <= config.Bh)) {
        return portName;
      } else {
        var this$27 = $m_sc_StringOps$().Eb($f_T__trim__T(portName));
        if (this$27.c()) {
          var this$31 = $m_s_None$();
        } else {
          var x0$2 = this$27.h();
          var _$17$2 = $uC(x0$2);
          var this$29 = ("" + $cToS(_$17$2));
          var this$31 = new $c_s_Some(this$29.toUpperCase());
        }
        return (this$31.c() ? "" : this$31.h());
      }
    } else {
      return portName;
    }
  }
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__calculateBlockBounds__J__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__Z__s_Option($thiz, startMs_$_lo, startMs_$_hi, endMs_$_lo, endMs_$_hi, timeLineSVG, totalWidth, config, useStandardDayWidth) {
  var startX = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__clampF__F__F__F__F($thiz, $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__xOf__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F($thiz, startMs_$_lo, startMs_$_hi, timeLineSVG), 0.0, totalWidth);
  if (useStandardDayWidth) {
    var $x_1 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getCalendarDay__J__J($thiz, startMs_$_lo, startMs_$_hi);
    var dayStart_$_lo = $x_1.l;
    var dayStart_$_hi = $x_1.h;
    var lo = ((86400000 + dayStart_$_lo) | 0);
    var hi = ((dayStart_$_hi + (((lo >>> 0) < 86400000) | 0)) | 0);
    var endX = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__clampF__F__F__F__F($thiz, $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__xOf__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F($thiz, lo, hi, timeLineSVG), 0.0, totalWidth);
  } else {
    var lo$1 = ((86400000 + endMs_$_lo) | 0);
    var hi$1 = ((endMs_$_hi + (((lo$1 >>> 0) < 86400000) | 0)) | 0);
    var endX = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__clampF__F__F__F__F($thiz, $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__xOf__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F($thiz, lo$1, hi$1, timeLineSVG), 0.0, totalWidth);
  }
  var x = Math.fround((endX - startX));
  var y = config.Bi;
  var blockWidth = Math.fround((+Math.max(x, y)));
  return ((((blockWidth > 0.0) && (startX < totalWidth)) && (endX > 0.0)) ? new $c_s_Some(new $c_T2(startX, blockWidth)) : $m_s_None$());
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__xOf__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F($thiz, ms_$_lo, ms_$_hi, timeLineSVG) {
  return $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(timeLineSVG, new Date(((4.294967296E9 * ms_$_hi) + (ms_$_lo >>> 0.0))));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__clampF__F__F__F__F($thiz, v, lo, hi) {
  var y = Math.fround((+Math.min(hi, v)));
  return Math.fround((+Math.max(lo, y)));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__divCreate__Lorg_scalajs_dom_Element($thiz) {
  return document.createElement("div");
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createSimpleTextComponent__T__T__F__F__Lcom_papasofokli_svg_components_TextComponent($thiz, text, className, x, y) {
  return new $c_Lcom_papasofokli_svg_components_TextComponent(new $c_s_Some(className), text, x, y, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())), false, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createTooltip__T__T2($thiz, htmlContent) {
  return new $c_T2($m_s_Option$().Z($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(htmlContent, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), $m_s_None$())), $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  }))));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageTooltipHtml__T__T__T__T__T__T($thiz, vesselName, voyageNumber, sailingType, fromDate, toDate) {
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().DR(), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("Vessel: " + vesselName)))])), $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("Voyage: " + voyageNumber)))])), $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("Sailing type: " + sailingType)))])), $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("From: " + fromDate)))])), $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("To: " + toDate)))]))]))])).aB().outerHTML;
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createMultiPortTooltipHtml__sci_Seq__T($thiz, ports) {
  var portEntries = $f_sc_IterableOnceOps__mkString__T__T__T__T(ports.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((port$2) => {
    var $x_11 = $m_Lscalatags_JsDom$all$().as();
    var $x_10 = $m_Lscalatags_JsDom$all$().ak3().n("margin-bottom: 10px;", $m_Lscalatags_JsDom$all$().s);
    var $x_9 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(port$2.pp))]))]));
    var $x_8 = $m_Lscalatags_JsDom$all$().ez();
    $m_Lscalatags_JsDom$all$();
    var $x_7 = $m_Lcom_papasofokli_util_DateUtilsJS$();
    var $x_6 = port$2;
    var $x_5 = $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$StringFrag(("ETA: " + $x_7.MF($x_6.kE, $x_6.kF)))]));
    var $x_4 = $m_Lscalatags_JsDom$all$().ez();
    $m_Lscalatags_JsDom$all$();
    var $x_3 = $m_Lcom_papasofokli_util_DateUtilsJS$();
    var $x_2 = port$2;
    var $x_1 = $x_11.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_10, $x_9, $x_5, $x_4.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$StringFrag(("ETD: " + $x_3.MF($x_2.ox, $x_2.oy)))]))])).aB().outerHTML;
    return $x_1;
  }))), "", "<hr style='margin: 5px 0;'/>", "");
  var $x_15 = $m_Lscalatags_JsDom$all$().as();
  var $x_14 = $m_Lscalatags_JsDom$all$().DR();
  var $x_13 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)]));
  var this$24 = $m_Lscalatags_JsDom$all$();
  var $x_12 = $x_15.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_14, $x_13.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$RawFrag(portEntries)]))])).aB().outerHTML;
  return $x_12;
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__makeChildDiv__Lorg_scalajs_dom_Element__T__T__V($thiz, parent, divId, className) {
  var x37 = $m_s_Option$().Z(document.getElementById(divId));
  if ((x37 instanceof $c_s_Some)) {
    var div = x37.bg;
    div.innerHTML = "";
    return (void 0);
  }
  if (($m_s_None$() === x37)) {
    var div$2 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__divCreate__Lorg_scalajs_dom_Element($thiz);
    div$2.setAttribute("id", divId);
    div$2.setAttribute("class", className);
    parent.appendChild(div$2);
    return (void 0);
  }
  throw new $c_s_MatchError(x37);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$() {
  this.alF = 0;
  this.alG = 0;
  this.alF = 86400000;
  this.alG = 0;
}
$p = $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VesselScheduleHelpers$() {
}
$h_Lcom_papasofokli_planning_api_VesselScheduleHelpers$.prototype = $p;
$p.E9 = (function(vesselIdx, rowWithinVessel, config, baseY) {
  return Math.fround((Math.fround((baseY + Math.fround((Math.fround(((Math.imul(vesselIdx, config.xc) + rowWithinVessel) | 0)) * config.i7)))) + Math.fround((Math.fround(vesselIdx) * config.xe))));
});
$p.agw = (function(vesselSchedules, isMonthZoom, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi) {
  var m = $m_scm_Map$().ce();
  var it = vesselSchedules.l();
  while (it.f()) {
    var elem = it.e();
    var key = elem.pq;
    m.oM(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.dw()))(vesselSchedules))).aD(elem);
  }
  var result = $m_sci_HashMap$().kr;
  var mapIt = m.l();
  while (mapIt.f()) {
    var x1 = mapIt.e();
    x1.P();
    x1.V();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.P();
    var v$2 = \u03b42$.V();
    result = result.jC(k$2, v$2.aR());
  }
  var this$2 = result;
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fM(this$2), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.P())), $m_s_math_Ordering$String$()).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var vesselName = x$1$2.P();
      var schedules = x$1$2.V();
      return new $c_Lcom_papasofokli_planning_api_VesselInfoPair(vesselName, $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageBlocks__T__sci_Seq__sci_Seq(this, vesselName, schedules), (isMonthZoom ? $m_sci_Seq$().dj() : this.at9(schedules, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi)));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
});
$p.at9 = (function(schedules, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi) {
  if (schedules.c()) {
    return $m_sci_Seq$().dj();
  }
  var this$12 = schedules.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((sch$2) => {
    var $x_1 = sch$2;
    var x_$_lo = $x_1.kE;
    var x_$_hi = $x_1.kF;
    if (((x_$_hi === windowStartMs_$_hi) ? ((x_$_lo >>> 0) > (windowStartMs_$_lo >>> 0)) : (x_$_hi > windowStartMs_$_hi))) {
      var startClamped_$_lo = x_$_lo;
      var startClamped_$_hi = x_$_hi;
    } else {
      var startClamped_$_lo = windowStartMs_$_lo;
      var startClamped_$_hi = windowStartMs_$_hi;
    }
    var $x_2 = sch$2;
    var x$1_$_lo = $x_2.ox;
    var x$1_$_hi = $x_2.oy;
    var $x_3 = sch$2;
    var y_$_lo = $x_3.kE;
    var y_$_hi = $x_3.kF;
    if (((x$1_$_hi === y_$_hi) ? ((x$1_$_lo >>> 0) > (y_$_lo >>> 0)) : (x$1_$_hi > y_$_hi))) {
      var x$2_$_lo = x$1_$_lo;
      var x$2_$_hi = x$1_$_hi;
    } else {
      var x$2_$_lo = y_$_lo;
      var x$2_$_hi = y_$_hi;
    }
    if (((x$2_$_hi === windowEndMs_$_hi) ? ((x$2_$_lo >>> 0) < (windowEndMs_$_lo >>> 0)) : (x$2_$_hi < windowEndMs_$_hi))) {
      var endClamped_$_lo = x$2_$_lo;
      var endClamped_$_hi = x$2_$_hi;
    } else {
      var endClamped_$_lo = windowEndMs_$_lo;
      var endClamped_$_hi = windowEndMs_$_hi;
    }
    var $x_4 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getCalendarDay__J__J(this, startClamped_$_lo, startClamped_$_hi);
    return new $c_T4($x_4, $bL(startClamped_$_lo, startClamped_$_hi), $bL(endClamped_$_lo, endClamped_$_hi), sch$2);
  })));
  var m = $m_scm_Map$().ce();
  var it = this$12.l();
  while (it.f()) {
    var elem = it.e();
    var $x_5 = $uJ(elem.y8);
    var key_$_lo = $x_5.l;
    var key_$_hi = $x_5.h;
    m.oM($bL(key_$_lo, key_$_hi), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$12) => (() => this$12.dw()))(this$12))).aD(elem);
  }
  var result = $m_sci_HashMap$().kr;
  var mapIt = m.l();
  while (mapIt.f()) {
    var x1 = mapIt.e();
    x1.P();
    x1.V();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.P();
    var v$2 = \u03b42$.V();
    result = result.jC(k$2, v$2.aR());
  }
  var this$13 = result;
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fM(this$13), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => $uJ(_$8$2.P()))), $m_s_math_Ordering$Long$()).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      $uJ(x$1$2.P());
      var portsInDay = x$1$2.V();
      var allPorts = portsInDay.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => _$9$2.tp)));
      var $x_6 = $uJ(portsInDay.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10$2) => $uJ(_$10$2.y9)))).gJ($m_s_math_Ordering$Long$()));
      var minStart_$_lo = $x_6.l;
      var minStart_$_hi = $x_6.h;
      var $x_7 = $uJ(portsInDay.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11$2) => $uJ(_$11$2.ya)))).fq($m_s_math_Ordering$Long$()));
      var maxEnd_$_lo = $x_7.l;
      var maxEnd_$_hi = $x_7.h;
      var customCssO = portsInDay.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12$2) => _$12$2.tp.ss))).bj();
      return new $c_Lcom_papasofokli_planning_api_MergedPortBlock(minStart_$_lo, minStart_$_hi, maxEnd_$_lo, maxEnd_$_hi, $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(allPorts, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13$2) => {
        var $x_8 = _$13$2;
        return $bL($x_8.kE, $x_8.kF);
      })), $m_s_math_Ordering$Long$()), customCssO);
    }
    throw new $c_s_MatchError(x$1$2);
  })));
});
$p.agr = (function(vesselInfoPairs, config, leftWidth, baseY) {
  return vesselInfoPairs.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      x$1$2.P();
      var vesselIdx = (x$1$2.V() | 0);
      return new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftRect__I__I__T__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__F__Lcom_papasofokli_svg_components_RectComponent(this, vesselIdx, 0, "success", config, leftWidth, baseY), new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftRect__I__I__T__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__F__Lcom_papasofokli_svg_components_RectComponent(this, vesselIdx, 1, "topBackgroundError", config, leftWidth, baseY), $m_sci_Nil$()));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
});
$p.ags = (function(vesselInfoPairs, config, baseY) {
  return vesselInfoPairs.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var pair = x$1$2.P();
      var vesselIdx = (x$1$2.V() | 0);
      return new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftText__T__T__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__Lcom_papasofokli_svg_components_TextComponent(this, pair.Be, "VOYAGE INFORMATION", vesselIdx, 0, config, baseY), new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createLeftText__T__T__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__Lcom_papasofokli_svg_components_TextComponent(this, pair.Be, "PORT INFORMATION", vesselIdx, 1, config, baseY), $m_sci_Nil$()));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
});
$p.agx = (function(voyage, vesselIdx, timeLineSVG, totalWidth, config, clickFunction, isMonthZoom, baseY) {
  var x20 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__calculateBlockBounds__J__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__Z__s_Option(this, voyage.uf, voyage.ug, voyage.zm, voyage.zn, timeLineSVG, totalWidth, config, false);
  if ((x20 instanceof $c_s_Some)) {
    var x22 = x20.bg;
    if ((x22 !== null)) {
      var startX = Math.fround(x22.P());
      var blockWidth = Math.fround(x22.V());
      var rect = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageRect__Lcom_papasofokli_planning_api_VoyageBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__s_Option__F__Lcom_papasofokli_svg_components_RectComponent(this, voyage, startX, blockWidth, vesselIdx, 0, config, clickFunction, baseY);
      return $m_s_Option$().hi($p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createVoyageText__Lcom_papasofokli_planning_api_VoyageBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__Z__F__s_Option(this, voyage, startX, blockWidth, vesselIdx, 0, config, isMonthZoom, baseY)).cf().ba(rect);
    }
  }
  if (($m_s_None$() === x20)) {
    return $m_sci_Seq$().dj();
  }
  throw new $c_s_MatchError(x20);
});
$p.agt = (function(block, vesselIdx, timeLineSVG, totalWidth, config, baseY) {
  var $x_1 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__getCalendarDay__J__J(this, block.zk, block.zl);
  var dayStart_$_lo = $x_1.l;
  var dayStart_$_hi = $x_1.h;
  var x28 = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__calculateBlockBounds__J__J__Lcom_papasofokli_svg_timeline_TimeLineSVG__F__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__Z__s_Option(this, dayStart_$_lo, dayStart_$_hi, dayStart_$_lo, dayStart_$_hi, timeLineSVG, totalWidth, config, true);
  if ((x28 instanceof $c_s_Some)) {
    var x30 = x28.bg;
    if ((x30 !== null)) {
      return $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__createPortCell__Lcom_papasofokli_planning_api_MergedPortBlock__F__F__I__I__Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig__F__sci_Seq(this, block, Math.fround(x30.P()), Math.fround(x30.V()), vesselIdx, 1, config, baseY);
    }
  }
  if (($m_s_None$() === x28)) {
    return $m_sci_Seq$().dj();
  }
  throw new $c_s_MatchError(x28);
});
$p.an5 = (function(vesselCount, config) {
  return Math.fround((Math.fround((Math.fround(Math.imul(vesselCount, config.xc)) * config.i7)) + Math.fround((Math.fround(vesselCount) * config.xe))));
});
$p.at8 = (function(className, height, width) {
  return new $c_Lcom_papasofokli_svg_components_RectComponent(new $c_s_Some(className), height, width, 0.0, 0.0, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$p.aw4 = (function(parentDiv, existingMainDivId, cssClass, mainDivProps, leftDivId, rightDivId) {
  matchResult17: {
    var main;
    if ((existingMainDivId instanceof $c_s_Some)) {
      var id = existingMainDivId.bg;
      var main = document.getElementById(id);
      break matchResult17;
    }
    if (($m_s_None$() === existingMainDivId)) {
      var d = $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__divCreate__Lorg_scalajs_dom_Element(this);
      mainDivProps.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18$3) => {
        _$18$3.ds(d);
      })));
      if (((cssClass === "vessel-schedule-div") || (cssClass === "voyage-header-div"))) {
        var timelineDiv = $m_s_Option$().Z(parentDiv.querySelector(".timeline-div"));
        matchResult16: {
          if ((timelineDiv instanceof $c_s_Some)) {
            var timeline = timelineDiv.bg;
            var x40 = $m_s_Option$().Z(timeline.nextSibling);
            if ((x40 instanceof $c_s_Some)) {
              var nextSibling = x40.bg;
              parentDiv.insertBefore(d, nextSibling);
              break matchResult16;
            }
            if (($m_s_None$() === x40)) {
              parentDiv.appendChild(d);
              break matchResult16;
            }
            throw new $c_s_MatchError(x40);
          }
          if (($m_s_None$() === timelineDiv)) {
            parentDiv.appendChild(d);
            break matchResult16;
          }
          throw new $c_s_MatchError(timelineDiv);
        }
      } else {
        parentDiv.appendChild(d);
      }
      var main = d;
      break matchResult17;
    }
    throw new $c_s_MatchError(existingMainDivId);
  }
  $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__makeChildDiv__Lorg_scalajs_dom_Element__T__T__V(this, main, leftDivId, "name-rank-div");
  $p_Lcom_papasofokli_planning_api_VesselScheduleHelpers$__makeChildDiv__Lorg_scalajs_dom_Element__T__T__V(this, main, rightDivId, "positions-div");
  return main;
});
$p.atV = (function(parentDivId, cssClass) {
  var element = $m_s_Option$().Z(document.querySelector(((("#" + parentDivId) + " .") + cssClass)));
  if (element.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = element.h();
    var this$2 = new $c_s_Some(x0.id);
  }
  if (this$2.c()) {
    var $x_1 = true;
  } else {
    var x0$1 = this$2.h();
    $m_sc_StringOps$();
    var $x_1 = (x0$1 !== "");
  }
  if ($x_1) {
    return this$2;
  } else {
    return $m_s_None$();
  }
});
$p.aue = (function(existingMainDivId) {
  var mainDivId = (existingMainDivId.c() ? $m_ju_UUID$().aW().g() : existingMainDivId.h());
  return new $c_T3(mainDivId, (mainDivId + "-left"), (mainDivId + "-right"));
});
var $d_Lcom_papasofokli_planning_api_VesselScheduleHelpers$ = new $TypeData().i($c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$, "com.papasofokli.planning.api.VesselScheduleHelpers$", ({
  r3: 1
}));
var $n_Lcom_papasofokli_planning_api_VesselScheduleHelpers$;
function $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$() {
  if ((!$n_Lcom_papasofokli_planning_api_VesselScheduleHelpers$)) {
    $n_Lcom_papasofokli_planning_api_VesselScheduleHelpers$ = new $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$();
  }
  return $n_Lcom_papasofokli_planning_api_VesselScheduleHelpers$;
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__groupedBySubjectPlanningRows__sci_Map($thiz) {
  if ((!$thiz.a4S)) {
    var this$1 = $thiz.a4V;
    var m = $m_scm_Map$().ce();
    var it = this$1.l();
    while (it.f()) {
      var elem = it.e();
      var key = elem.sK;
      m.oM(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.dw()))(this$1))).aD(elem);
    }
    var result = $m_sci_HashMap$().kr;
    var mapIt = m.l();
    while (mapIt.f()) {
      var x1 = mapIt.e();
      x1.P();
      x1.V();
      var \u03b42$ = x1;
      var k$2 = \u03b42$.P();
      var v$2 = \u03b42$.V();
      result = result.jC(k$2, v$2.aR());
    }
    $thiz.a4R = $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(result, new $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1());
    $thiz.a4S = true;
  }
  return $thiz.a4R;
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addPeriodToRow__ju_UUID__Lcom_papasofokli_planning_PeriodJS__V($thiz, rowUUID, periodToAdd) {
  var seamanPlanningRowSVG = $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__getSeamanPlanningRowSVG__ju_UUID__s_Option($thiz, rowUUID);
  matchResult4: {
    if ((seamanPlanningRowSVG instanceof $c_s_Some)) {
      var planningRow = seamanPlanningRowSVG.bg;
      var initialY$1 = planningRow.zJ();
      var getSubjectIdByPosition$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y$3) => $thiz.Ur(Math.fround(y$3))));
      var detailRowIndexO$1 = $m_s_None$();
      var seamanPeriodSvg = new $c_Lcom_papasofokli_planning_api_PeriodSvg(periodToAdd, initialY$1, $thiz.Kd, $thiz.Fh, planningRow.m0, detailRowIndexO$1, planningRow.x6, planningRow.x9, getSubjectIdByPosition$1, $thiz.Bm);
      if (seamanPeriodSvg.N0()) {
        $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addSeamanPeriodSvg__Lcom_papasofokli_planning_api_PeriodSvg__Z__V($thiz, seamanPeriodSvg, false);
        break matchResult4;
      } else {
        break matchResult4;
      }
    }
    if (($m_s_None$() === seamanPlanningRowSVG)) {
      matchResult3: {
        var \u03b42$;
        var x11 = $m_Lcom_papasofokli_planning_api_PeriodSvg$().Ux(periodToAdd, $thiz.Fh);
        if ((x11 !== null)) {
          Math.fround(x11.P());
          Math.fround(x11.V());
          var \u03b42$ = x11;
          break matchResult3;
        }
        throw new $c_s_MatchError(x11);
      }
      if ((Math.fround(\u03b42$.P()) < Math.fround(\u03b42$.V()))) {
        $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().Ex($thiz.PQ, $thiz.Bm);
      } else {
        $m_s_concurrent_Future$().aE($m_s_None$());
      }
      break matchResult4;
    }
    throw new $c_s_MatchError(seamanPlanningRowSVG);
  }
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__showPeriodChange__Lcom_papasofokli_planning_PlanningPeriodChange__V($thiz, change) {
  var originalPeriodSeq = $thiz.sL.f6(new $c_s_Some($bL(change.ov, change.ow)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().dj()))).eQ(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => _$8$2.po)));
  var this$4 = originalPeriodSeq.bj();
  if (this$4.c()) {
    var changedPeriodO = $m_s_None$();
  } else {
    var x0 = this$4.h();
    var tooltipInformation$1 = $m_s_Option$().hi(x0.dX.nv.bj()).cf().aV("Suggested assignment change");
    var periodStyle$1 = $m_Lcom_papasofokli_planning_PeriodStyleE$().OV;
    var rowInformation$1 = $m_s_Option$().hi(x0.dX.k5.bj()).cf().aV($bL(change.qy, change.qz));
    var periodId$1 = x0.dX.fU;
    var totalHours$1 = x0.dX.iQ;
    var periodType$1 = x0.dX.nu;
    var vesselId$1 = x0.dX.k7;
    var toAppearInRow$1 = x0.dX.hr;
    var leftIndications$1 = x0.dX.gV;
    var text$1 = x0.dX.iP;
    var textLine2$1 = x0.dX.i4;
    var rightIndications$1 = x0.dX.gW;
    var centerIndications$1 = x0.dX.gU;
    var uniqueUUID$1 = x0.dX.fw;
    var color$1 = x0.dX.iM;
    var stroke$1 = x0.dX.iO;
    var customIndicationsDictionary$1 = x0.dX.i3;
    var animationTime$1 = x0.dX.fv;
    var showDatesOnTooltip$1 = x0.dX.iN;
    var changedPeriodO = new $c_s_Some(new $c_Lcom_papasofokli_planning_PeriodJS(periodId$1, change.u9, change.ua, change.ub, change.uc, totalHours$1, change.sl, periodType$1, vesselId$1, tooltipInformation$1, true, true, periodStyle$1, toAppearInRow$1, leftIndications$1, text$1, textLine2$1, rightIndications$1, centerIndications$1, rowInformation$1, uniqueUUID$1, color$1, stroke$1, customIndicationsDictionary$1, $m_s_None$(), $m_s_None$(), $m_s_None$(), animationTime$1, showDatesOnTooltip$1));
  }
  $thiz.Kc.aD(new $c_T2($bL(change.ov, change.ow), originalPeriodSeq));
  $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriodsById__J__V($thiz, change.ov, change.ow);
  if ((!change.sm)) {
    if ((!changedPeriodO.c())) {
      var x0$1 = changedPeriodO.h();
      $thiz.Ma(change.qy, change.qz, new $c_sci_$colon$colon(x0$1, $m_sci_Nil$()));
    }
  }
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriodsById__J__V($thiz, periodId_$_lo, periodId_$_hi) {
  $thiz.sL.f6(new $c_s_Some($bL(periodId_$_lo, periodId_$_hi)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Seq$().dj()))).aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((period$2) => $thiz.MK(period$2.po)))).bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => _$9$2.aI.fU.az($bL(periodId_$_lo, periodId_$_hi))))).jn().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriod__Lcom_papasofokli_planning_api_PeriodSvg__Z__V($thiz, _$10$3, false);
  })));
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__getSeamanPlanningRowSVG__ju_UUID__s_Option($thiz, rowUUID) {
  return $thiz.PP.b9(rowUUID);
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addAdditionalPeriodToRow__ju_UUID__I__Lcom_papasofokli_planning_PeriodJS__V($thiz, rowUUID, index, periodToAdd) {
  var seamanPlanningRowSVG = $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__getSeamanPlanningRowSVG__ju_UUID__s_Option($thiz, rowUUID);
  matchResult9: {
    if ((seamanPlanningRowSVG instanceof $c_s_Some)) {
      var planningRow = seamanPlanningRowSVG.bg;
      var initialY$2 = Math.fround((planningRow.zJ() + Math.fround((Math.fround(((1 + index) | 0)) * $thiz.Kd))));
      var detailRowIndexO$2 = new $c_s_Some(index);
      var getSubjectIdByPosition$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((y$3) => $thiz.Ur(Math.fround(y$3))));
      var seamanPeriodSvg = new $c_Lcom_papasofokli_planning_api_PeriodSvg(periodToAdd, initialY$2, $thiz.Kd, $thiz.Fh, planningRow.m0, detailRowIndexO$2, planningRow.x6, planningRow.x9, getSubjectIdByPosition$2, $thiz.Bm);
      if (seamanPeriodSvg.N0()) {
        $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addSeamanPeriodSvg__Lcom_papasofokli_planning_api_PeriodSvg__Z__V($thiz, seamanPeriodSvg, true);
        break matchResult9;
      } else {
        break matchResult9;
      }
    }
    if (($m_s_None$() === seamanPlanningRowSVG)) {
      matchResult8: {
        var \u03b44$;
        var x22 = $m_Lcom_papasofokli_planning_api_PeriodSvg$().Ux(periodToAdd, $thiz.Fh);
        if ((x22 !== null)) {
          Math.fround(x22.P());
          Math.fround(x22.V());
          var \u03b44$ = x22;
          break matchResult8;
        }
        throw new $c_s_MatchError(x22);
      }
      if ((Math.fround(\u03b44$.P()) < Math.fround(\u03b44$.V()))) {
        $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$().Ex($thiz.PQ, $thiz.Bm);
      } else {
        $m_s_concurrent_Future$().aE($m_s_None$());
      }
      break matchResult9;
    }
    throw new $c_s_MatchError(seamanPlanningRowSVG);
  }
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriod__Lcom_papasofokli_planning_api_PeriodSvg__Z__V($thiz, oldPeriod, isDetailedPeriod) {
  $f_Lcom_papasofokli_svg_components_SvgComponent__removeComponent__V(oldPeriod);
  if (isDetailedPeriod) {
    $thiz.Ke.ED(oldPeriod.aI.fw);
  } else {
    $thiz.Ff.ED(oldPeriod.aI.fw);
    $thiz.Kb.aD(new $c_T2(oldPeriod.eK, $thiz.MK(oldPeriod.eK).bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18$2) => ((_$18$2 === null) ? (oldPeriod === null) : _$18$2.b(oldPeriod)))))));
    var oldPeriodsJS = oldPeriod.aI;
    var updatedSeq = $thiz.sL.p(oldPeriodsJS.fU).bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19$2) => {
      var x = _$19$2.dX;
      return ((x === null) ? (oldPeriodsJS === null) : x.b(oldPeriodsJS));
    })));
    $thiz.sL.aD(new $c_T2(oldPeriodsJS.fU, updatedSeq));
  }
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__refreshTodayLine__V($thiz) {
  $thiz.a4U.aA().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((line$3) => {
    $f_Lcom_papasofokli_svg_components_SvgComponent__appendOnTop__V(line$3);
  })));
}
function $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addSeamanPeriodSvg__Lcom_papasofokli_planning_api_PeriodSvg__Z__V($thiz, seamanPeriodSvg, isDetailedPeriod) {
  $thiz.a4Q.p(seamanPeriodSvg);
  $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__refreshTodayLine__V($thiz);
  var period = seamanPeriodSvg.aI;
  if (isDetailedPeriod) {
    $thiz.Ke.aD(new $c_T2(period.fw, seamanPeriodSvg));
  } else {
    $thiz.Ff.aD(new $c_T2(period.fw, seamanPeriodSvg));
  }
  $thiz.Kb.aD(new $c_T2(seamanPeriodSvg.eK, $thiz.MK(seamanPeriodSvg.eK).aV(seamanPeriodSvg)));
  var newPeriodSeq = $thiz.sL.f6(period.fU, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))).aV(new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod(seamanPeriodSvg.eK, period));
  $thiz.sL.aD(new $c_T2(period.fU, newPeriodSeq));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager(addComponent, seamanPlanningRowSVG, periodHeight, timeLineSVG, importantDateLines, plannerId, executionContext) {
  this.a4Q = null;
  this.a4V = null;
  this.Kd = 0.0;
  this.Fh = null;
  this.a4U = null;
  this.PQ = null;
  this.Bm = null;
  this.Kc = null;
  this.a4R = null;
  this.a4S = false;
  this.Fg = null;
  this.Ff = null;
  this.Ke = null;
  this.Kb = null;
  this.sL = null;
  this.a4T = null;
  this.PP = null;
  this.a4Q = addComponent;
  this.a4V = seamanPlanningRowSVG;
  this.Kd = periodHeight;
  this.Fh = timeLineSVG;
  this.a4U = importantDateLines;
  this.PQ = plannerId;
  this.Bm = executionContext;
  this.Kc = $m_scm_Map$().ce();
  this.Fg = seamanPlanningRowSVG.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11$2) => _$11$2.Pz)));
  this.Ff = $m_scm_Map$().e4(this.Fg.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2) => new $c_T2(p$2.aI.fw, p$2)))));
  var rowAdditionalPeriodSvgs = seamanPlanningRowSVG.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12$2) => _$12$2.Py)));
  this.Ke = $m_scm_Map$().e4(rowAdditionalPeriodSvgs.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$1) => new $c_T2(p$2$1.aI.fw, p$2$1)))));
  var $x_1 = $m_scm_Map$();
  var this$11 = this.Fg;
  var m = $m_scm_Map$().ce();
  var it = this$11.l();
  while (it.f()) {
    var elem = it.e();
    var key = elem.eK;
    m.oM(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$11) => (() => this$11.dw()))(this$11))).aD(elem);
  }
  var result = $m_sci_HashMap$().kr;
  var mapIt = m.l();
  while (mapIt.f()) {
    var x1 = mapIt.e();
    x1.P();
    x1.V();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.P();
    var v$2 = \u03b42$.V();
    result = result.jC(k$2, v$2.aR());
  }
  var this$12 = result;
  this.Kb = $x_1.e4($m_sci_Seq$().fM(this$12));
  this.sL = new $c_sc_MapFactory$ToFactory($m_scm_Map$()).de($f_sc_IterableOps__groupMap__F1__F1__sci_Map(this.Fg, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$16$2) => _$16$2.aI.fU)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$2) => new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod(p$2$2.eK, p$2$2.aI)))));
  this.a4T = new $c_sc_MapFactory$ToFactory($m_scm_Map$()).de($f_sc_IterableOps__groupMap__F1__F1__sci_Map(rowAdditionalPeriodSvgs, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$17$2) => _$17$2.aI.fU)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$3) => new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod(p$2$3.eK, p$2$3.aI)))));
  this.PP = seamanPlanningRowSVG.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2) => new $c_T2(s$2.m0, s$2)))).fd($m_s_$less$colon$less$().b0);
}
$p = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_mutations_ModificationsManager() {
}
$h_Lcom_papasofokli_planning_api_mutations_ModificationsManager.prototype = $p;
$p.Ur = (function(y) {
  var validRows = this.PP.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => ((x$2.V().zJ() <= y) && (!x$2.V().x7))))).cf();
  var rowO = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(validRows, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.V().zJ())), $m_s_math_Ordering$DeprecatedFloatOrdering$()).oS();
  var rowId = (rowO.c() ? $m_s_None$() : new $c_s_Some(rowO.h().P()));
  var this$4 = (rowO.c() ? $m_s_None$() : rowO.h().V().sK);
  if (this$4.c()) {
    return $m_s_None$();
  } else {
    var $x_1 = $uJ(this$4.h());
    return new $c_s_Some(new $c_T2($x_1, rowId.h()));
  }
});
$p.ahu = (function(subjectId_$_lo, subjectId_$_hi) {
  return $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__groupedBySubjectPlanningRows__sci_Map(this).f6($bL(subjectId_$_lo, subjectId_$_hi), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())));
});
$p.aum = (function(periodId_$_lo, periodId_$_hi) {
  var periodO = this.sL.b9(new $c_s_Some($bL(periodId_$_lo, periodId_$_hi)));
  var cond = (!periodO.c());
  var this$4 = (cond ? new $c_s_Some(periodO.h()) : $m_s_None$());
  return (this$4.c() ? this.a4T.f6(new $c_s_Some($bL(periodId_$_lo, periodId_$_hi)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()))) : this$4.h());
});
$p.Ma = (function(subjectId_$_lo, subjectId_$_hi, periodSeq) {
  this.ahu(subjectId_$_lo, subjectId_$_hi).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row$3) => {
    this.afA(row$3.sn, periodSeq);
  })));
});
$p.afA = (function(rowUUID, periods) {
  periods.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addPeriodToRow__ju_UUID__Lcom_papasofokli_planning_PeriodJS__V(this, rowUUID, _$6$3);
  })));
});
$p.ax9 = (function(rowUUID) {
  var filteredPeriodSeq = $f_sc_IterableOps__filter__F1__O(new $c_sc_MapOps$$anon$1(this.Ff), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2) => rowUUID.az(v$2.eK))));
  (filteredPeriodSeq.c() ? this.Fg.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$1) => rowUUID.az(v$2$1.eK)))) : filteredPeriodSeq).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriod__Lcom_papasofokli_planning_api_PeriodSvg__Z__V(this, _$7$3, false);
  })));
});
$p.ayZ = (function(periodChanges) {
  periodChanges.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$3) => {
    var oldSvgPeriod = this.Ff.b9(p$3.wK.fw);
    if ((!oldSvgPeriod.c())) {
      var x0 = oldSvgPeriod.h();
      $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriod__Lcom_papasofokli_planning_api_PeriodSvg__Z__V(this, x0, false);
      var this$2 = p$3.wJ;
      if ((!this$2.c())) {
        $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addSeamanPeriodSvg__Lcom_papasofokli_planning_api_PeriodSvg__Z__V(this, new $c_Lcom_papasofokli_planning_api_PeriodSvg(this$2.h(), x0.x1, x0.iT, x0.sF, x0.eK, x0.sC, x0.sD, x0.nH, x0.x0, this.Bm), false);
      }
    }
  })));
});
$p.Vv = (function(changeSeq) {
  this.MU();
  changeSeq.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((change$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__showPeriodChange__Lcom_papasofokli_planning_PlanningPeriodChange__V(this, change$3);
  })));
});
$p.MU = (function() {
  var originalPeriodSeqById = $m_sci_Map$().dH(this.Kc);
  this.Kc.Iq();
  originalPeriodSeqById.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult5: {
      if ((x$1$3 !== null)) {
        var $x_1 = $uJ(x$1$3.P());
        var periodId_$_lo = $x_1.l;
        var periodId_$_hi = $x_1.h;
        var originalPeriodSeq = x$1$3.V();
        $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriodsById__J__V(this, periodId_$_lo, periodId_$_hi);
        originalPeriodSeq.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((period$3) => {
          $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addPeriodToRow__ju_UUID__Lcom_papasofokli_planning_PeriodJS__V(this, period$3.po, period$3.dX);
        })));
        break matchResult5;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
});
$p.MK = (function(rowUUID) {
  return this.Kb.f6(rowUUID, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())));
});
$p.ax8 = (function(rowUUID, index) {
  $f_sc_IterableOps__collect__s_PartialFunction__O(new $c_sc_MapOps$$anon$1(this.Ke), new $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2(rowUUID, index)).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$13$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__removePeriod__Lcom_papasofokli_planning_api_PeriodSvg__Z__V(this, _$13$3, true);
  })));
});
$p.alR = (function(rowUUID, index, periods) {
  periods.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14$3) => {
    $p_Lcom_papasofokli_planning_api_mutations_ModificationsManager__addAdditionalPeriodToRow__ju_UUID__I__Lcom_papasofokli_planning_PeriodJS__V(this, rowUUID, index, _$14$3);
  })));
});
var $d_Lcom_papasofokli_planning_api_mutations_ModificationsManager = new $TypeData().i($c_Lcom_papasofokli_planning_api_mutations_ModificationsManager, "com.papasofokli.planning.api.mutations.ModificationsManager", ({
  r4: 1
}));
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__addPeriodsToRow__s_Option__ju_UUID__sci_Seq__V($thiz, plannerO, rowUUID, periods) {
  if ((!plannerO.c())) {
    plannerO.h().afB(new $c_sci_$colon$colon(new $c_Lcom_papasofokli_planning_RowPeriodKey(rowUUID, periods), $m_sci_Nil$()));
  }
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__showSidebarForPlanner__s_Option__V($thiz, plannerO) {
  try {
    if ((!plannerO.c())) {
      plannerO.h().Vw();
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var x3 = x2.h();
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__resizePlannerSidebar__s_Option__I__V($thiz, plannerO, sidebarSize) {
  try {
    if ((!plannerO.c())) {
      plannerO.h().Vf(sidebarSize);
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var x3 = x2.h();
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__scrollFunction__T__s_Option($thiz, plannerId) {
  var plannerO = $thiz.fe.b9(plannerId);
  var element = document.getElementById(plannerId);
  var currentTopY = Math.fround((+element.scrollTop));
  var currentBottomY = Math.fround((currentTopY + Math.fround((+element.getBoundingClientRect().bottom))));
  return (plannerO.c() ? $m_s_None$() : new $c_s_Some((plannerO.h().awD(currentTopY, currentBottomY), (void 0))));
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__resizeWindowAction__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, divId, executionContext) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(500, 0, executionContext);
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(window).on("resize", ((_$8$2) => multipleEventHandler.Ue(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.Ex(divId, executionContext))))));
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__loadPlannerComponentWithId__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, divId, executionContext) {
  var divSelector = ("#" + divId);
  var divJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(divSelector);
  var functionId = divJQ.attr($m_Lcom_papasofokli_planning_package$().a4W);
  var freezePage = ((!(!divJQ.hasClass($m_Lcom_papasofokli_planning_package$().a4X))) ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_FreezePage(100, 0, executionContext)));
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(functionId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => $m_sjs_js_Thenable$Implicits$().bH(r$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    var allPlanningData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_planning_PlanningData$().q());
    var showPlanningSVGJS = new $c_Lcom_papasofokli_planning_api_ShowPlanningSVGJS(allPlanningData, divId, executionContext);
    $thiz.fe = $thiz.fe.hk(divId, showPlanningSVGJS);
    return showPlanningSVGJS.ga().aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$3) => {
      var t$2 = (+t$3);
      var this$7 = (freezePage.c() ? $m_s_None$() : new $c_s_Some(freezePage.h().ep()));
      return (this$7.c() ? $m_s_concurrent_Future$().aE($m_s_None$()) : this$7.h()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => t$2)), executionContext);
    })), executionContext);
  })), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__modifyPeriods__s_Option__sci_Seq__V($thiz, plannerO, periodChanges) {
  if ((!plannerO.c())) {
    plannerO.h().awi(periodChanges);
  }
}
/** @constructor */
function $c_Lcom_papasofokli_planning_initializer_PlannerInitializer$() {
  this.fe = null;
  this.pz = null;
  $n_Lcom_papasofokli_planning_initializer_PlannerInitializer$ = this;
  var $x_1;
  var $x_1 = $m_sci_Map$EmptyMap$();
  this.fe = $x_1;
  var $x_2;
  var $x_2 = $m_sci_Map$EmptyMap$();
  this.pz = $x_2;
}
$p = $c_Lcom_papasofokli_planning_initializer_PlannerInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_initializer_PlannerInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_planning_initializer_PlannerInitializer$() {
}
$h_Lcom_papasofokli_planning_initializer_PlannerInitializer$.prototype = $p;
$p.amc = (function(plannerId, rowUUID, periods) {
  $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__addPeriodsToRow__s_Option__ju_UUID__sci_Seq__V(this, this.fe.b9(plannerId.g()), rowUUID, periods);
});
$p.amd = (function(plannerId, subjectId_$_lo, subjectId_$_hi, periodSeq) {
  var plannerO = this.fe.b9(plannerId);
  if ((!plannerO.c())) {
    plannerO.h().Ma(subjectId_$_lo, subjectId_$_hi, periodSeq);
  }
});
$p.am0 = (function(plannerId, rowUUID, rowIndex, periods) {
  var plannerO = this.fe.b9(plannerId.g());
  if ((!plannerO.c())) {
    plannerO.h().alZ(rowUUID, rowIndex, periods);
  }
});
$p.ay3 = (function(plannerId) {
  $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__showSidebarForPlanner__s_Option__V(this, this.fe.b9(plannerId));
});
$p.axn = (function(plannerId, sidebarSize) {
  $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__resizePlannerSidebar__s_Option__I__V(this, this.fe.b9(plannerId), sidebarSize);
});
$p.av4 = (function(executionContext) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(300, 0, executionContext);
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + $m_Lcom_papasofokli_planning_package$().PT)).removeClass($m_Lcom_papasofokli_planning_package$().PT).each(((this$2) => (function() {
    $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__resizeWindowAction__T__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$2, this.id, executionContext);
    this$2.Ex(this.id, executionContext);
    this.addEventListener("scroll", ((_$6$2) => multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__scrollFunction__T__s_Option(this$2, this.id))))));
  }))(this));
});
$p.anc = (function(plannerId, rowUUID) {
  var plannerO = this.fe.b9(plannerId);
  if ((!plannerO.c())) {
    plannerO.h().afS(new $c_sci_$colon$colon($m_ju_UUID$().aO(rowUUID), $m_sci_Nil$()));
  }
});
$p.anb = (function(plannerId, rowUUID, rowIndex) {
  var plannerO = this.fe.b9(plannerId);
  if ((!plannerO.c())) {
    plannerO.h().ana($m_ju_UUID$().aO(rowUUID), rowIndex);
  }
});
$p.Ex = (function(divId, executionContext) {
  if ((!$m_sci_Set$().jp(this.pz.N6()).az(divId))) {
    var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(300, 0, executionContext);
    this.pz = this.pz.hk(divId, multipleEventHandler);
  }
  return this.pz.p(divId).Ue(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    document.getElementById(divId).scrollTop = 0.0;
    return $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__loadPlannerComponentWithId__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, divId, executionContext);
  })));
});
$p.amf = (function(divId, split, executionContext) {
  if ((!$m_sci_Set$().jp(this.pz.N6()).az(divId))) {
    var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(300, 0, executionContext);
    this.pz = this.pz.hk(divId, multipleEventHandler);
  } else {
    $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__showSidebarForPlanner__s_Option__V(this, this.fe.b9(divId));
  }
  return this.pz.p(divId).Ue(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var divSelector = ("#" + divId);
    var divJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(divSelector);
    if (split) {
      divJQ.addClass($m_Lcom_papasofokli_planning_package$().PU);
    } else {
      divJQ.removeClass($m_Lcom_papasofokli_planning_package$().PU);
    }
    return $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__loadPlannerComponentWithId__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, divId, executionContext);
  })));
});
$p.awh = (function(plannerId, periodChanges) {
  $p_Lcom_papasofokli_planning_initializer_PlannerInitializer$__modifyPeriods__s_Option__sci_Seq__V(this, this.fe.b9(plannerId), periodChanges);
});
$p.ay2 = (function(plannerId, changeSeq) {
  var this$1 = this.fe.b9(plannerId);
  if ((!this$1.c())) {
    this$1.h().Vv(changeSeq);
  }
});
$p.auM = (function(plannerId) {
  var this$1 = this.fe.b9(plannerId);
  if ((!this$1.c())) {
    this$1.h().MU();
  }
});
$p.auN = (function(plannerId, fromTime_$_lo, fromTime_$_hi, toTime_$_lo, toTime_$_hi) {
  var plannerO = this.fe.b9(plannerId);
  if ((!plannerO.c())) {
    plannerO.h().aiV().cm(new Date(((4.294967296E9 * fromTime_$_hi) + (fromTime_$_lo >>> 0.0))), new Date(((4.294967296E9 * toTime_$_hi) + (toTime_$_lo >>> 0.0))));
  }
});
$p.ayN = (function(plannerId) {
  var plannerO = this.fe.b9(plannerId);
  if ((!plannerO.c())) {
    plannerO.h().agC().aA();
  }
});
$p.ay1 = (function(plannerId, rangeSeq) {
  var this$1 = this.fe.b9(plannerId);
  if ((!this$1.c())) {
    this$1.h().Vt(rangeSeq);
  }
});
$p.au2 = (function(plannerId, rangeSeq) {
  var this$1 = this.fe.b9(plannerId);
  if ((!this$1.c())) {
    this$1.h().Ui(rangeSeq);
  }
});
$p.auL = (function(plannerId) {
  var this$1 = this.fe.b9(plannerId);
  if ((!this$1.c())) {
    this$1.h().MT();
  }
});
var $d_Lcom_papasofokli_planning_initializer_PlannerInitializer$ = new $TypeData().i($c_Lcom_papasofokli_planning_initializer_PlannerInitializer$, "com.papasofokli.planning.initializer.PlannerInitializer$", ({
  r7: 1
}));
var $n_Lcom_papasofokli_planning_initializer_PlannerInitializer$;
function $m_Lcom_papasofokli_planning_initializer_PlannerInitializer$() {
  if ((!$n_Lcom_papasofokli_planning_initializer_PlannerInitializer$)) {
    $n_Lcom_papasofokli_planning_initializer_PlannerInitializer$ = new $c_Lcom_papasofokli_planning_initializer_PlannerInitializer$();
  }
  return $n_Lcom_papasofokli_planning_initializer_PlannerInitializer$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_package$() {
  this.afg = 0;
  this.afh = 0;
  this.Tq = 0;
  this.Tr = 0;
  this.LY = 0;
  this.LZ = 0;
  this.DD = 0;
  this.DE = 0;
  this.afi = 0;
  this.afj = 0;
  this.M0 = 0;
  this.M1 = 0;
  this.PT = null;
  this.a4W = null;
  this.a4Y = null;
  this.Fi = null;
  this.Bn = null;
  this.nM = null;
  this.PU = null;
  this.a4X = null;
  $n_Lcom_papasofokli_planning_package$ = this;
  this.afg = 1000;
  this.afh = 0;
  var $x_1 = $m_Lcom_papasofokli_planning_package$();
  var x_$_lo = $x_1.afg;
  var x_$_hi = $x_1.afh;
  var b0 = (65535 & x_$_lo);
  var b1 = ((x_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(60, b0);
  var a0b1 = Math.imul(60, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((Math.imul(60, x_$_hi) + ((c1part >>> 16) | 0)) | 0);
  this.Tq = lo;
  this.Tr = hi;
  var $x_2 = $m_Lcom_papasofokli_planning_package$();
  var x$1_$_lo = $x_2.Tq;
  var x$1_$_hi = $x_2.Tr;
  var b0$1 = (65535 & x$1_$_lo);
  var b1$1 = ((x$1_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(60, b0$1);
  var a0b1$1 = Math.imul(60, b1$1);
  var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$1 = ((Math.imul(60, x$1_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
  this.LY = lo$1;
  this.LZ = hi$1;
  var $x_3 = $m_Lcom_papasofokli_planning_package$();
  var x$2_$_lo = $x_3.LY;
  var x$2_$_hi = $x_3.LZ;
  var b0$2 = (65535 & x$2_$_lo);
  var b1$2 = ((x$2_$_lo >>> 16) | 0);
  var a0b0$2 = Math.imul(24, b0$2);
  var a0b1$2 = Math.imul(24, b1$2);
  var lo$2 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$2 = ((Math.imul(24, x$2_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
  this.DD = lo$2;
  this.DE = hi$2;
  var $x_4 = $m_Lcom_papasofokli_planning_package$();
  var x$3_$_lo = $x_4.DD;
  var x$3_$_hi = $x_4.DE;
  var b0$3 = (65535 & x$3_$_lo);
  var b1$3 = ((x$3_$_lo >>> 16) | 0);
  var a0b0$3 = Math.imul(7, b0$3);
  var a0b1$3 = Math.imul(7, b1$3);
  var lo$3 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$3 = ((Math.imul(7, x$3_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
  this.afi = lo$3;
  this.afj = hi$3;
  var $x_5 = $m_Lcom_papasofokli_planning_package$();
  var x$4_$_lo = $x_5.DD;
  var x$4_$_hi = $x_5.DE;
  var b0$4 = (65535 & x$4_$_lo);
  var b1$4 = ((x$4_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(30, b0$4);
  var a0b1$4 = Math.imul(30, b1$4);
  var lo$4 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$4 = ((Math.imul(30, x$4_$_hi) + ((c1part$4 >>> 16) | 0)) | 0);
  this.M0 = lo$4;
  this.M1 = hi$4;
  $m_Lcom_papasofokli_planning_package$();
  this.PT = "not-initialized-planning-component";
  this.a4W = "load-planning-data";
  this.a4Y = "planner-filters";
  this.Fi = "text-highlight";
  this.Bn = "topBackground";
  this.nM = "animate-transition";
  this.PU = "compact-height";
  this.a4X = "non-freezing-on-loading";
}
$p = $c_Lcom_papasofokli_planning_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_package$;
/** @constructor */
function $h_Lcom_papasofokli_planning_package$() {
}
$h_Lcom_papasofokli_planning_package$.prototype = $p;
$p.auj = (function(zoomLevel) {
  if ((zoomLevel instanceof $c_s_Some)) {
    var $x_1 = $uJ(zoomLevel.bg);
    var x17_$_lo = $x_1.l;
    var x17_$_hi = $x_1.h;
    if (((x17_$_lo | x17_$_hi) === 0)) {
      var $x_2 = $m_Lcom_papasofokli_planning_package$();
      var x_$_lo = $x_2.M0;
      var x_$_hi = $x_2.M1;
      var b0 = (65535 & x_$_lo);
      var b1 = ((x_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(18, b0);
      var a0b1 = Math.imul(18, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(18, x_$_hi) + ((c1part >>> 16) | 0)) | 0);
      return $bL(lo, hi);
    }
    if ((((1 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_3 = $m_Lcom_papasofokli_planning_package$();
      var x$1_$_lo = $x_3.M0;
      var x$1_$_hi = $x_3.M1;
      var b0$1 = (65535 & x$1_$_lo);
      var b1$1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(6, b0$1);
      var a0b1$1 = Math.imul(6, b1$1);
      var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$1 = ((Math.imul(6, x$1_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      return $bL(lo$1, hi$1);
    }
    if ((((2 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_4 = $m_Lcom_papasofokli_planning_package$();
      var x$2_$_lo = $x_4.afi;
      var x$2_$_hi = $x_4.afj;
      var b0$2 = (65535 & x$2_$_lo);
      var b1$2 = ((x$2_$_lo >>> 16) | 0);
      var a0b0$2 = Math.imul(9, b0$2);
      var a0b1$2 = Math.imul(9, b1$2);
      var lo$2 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$2 = ((Math.imul(9, x$2_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
      return $bL(lo$2, hi$2);
    }
    if ((((3 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_5 = $m_Lcom_papasofokli_planning_package$();
      var x$3_$_lo = $x_5.DD;
      var x$3_$_hi = $x_5.DE;
      var b0$3 = (65535 & x$3_$_lo);
      var b1$3 = ((x$3_$_lo >>> 16) | 0);
      var a0b0$3 = Math.imul(35, b0$3);
      var a0b1$3 = Math.imul(35, b1$3);
      var lo$3 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$3 = ((Math.imul(35, x$3_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
      return $bL(lo$3, hi$3);
    }
    if ((((4 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_6 = $m_Lcom_papasofokli_planning_package$();
      return $bL($x_6.DD, $x_6.DE);
    }
    if ((((5 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_7 = $m_Lcom_papasofokli_planning_package$();
      var x$4_$_lo = $x_7.LY;
      var x$4_$_hi = $x_7.LZ;
      var b0$4 = (65535 & x$4_$_lo);
      var b1$4 = ((x$4_$_lo >>> 16) | 0);
      var a0b0$4 = Math.imul(12, b0$4);
      var a0b1$4 = Math.imul(12, b1$4);
      var lo$4 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$4 = ((Math.imul(12, x$4_$_hi) + ((c1part$4 >>> 16) | 0)) | 0);
      return $bL(lo$4, hi$4);
    }
    if ((((6 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_8 = $m_Lcom_papasofokli_planning_package$();
      var x$5_$_lo = $x_8.LY;
      var x$5_$_hi = $x_8.LZ;
      var lo$5 = (x$5_$_lo << 1);
      var hi$5 = (((x$5_$_lo >>> 31) | 0) | (x$5_$_hi << 1));
      return $bL(lo$5, hi$5);
    }
    if ((((7 ^ x17_$_lo) | x17_$_hi) === 0)) {
      var $x_9 = $m_Lcom_papasofokli_planning_package$();
      var x$6_$_lo = $x_9.Tq;
      var x$6_$_hi = $x_9.Tr;
      var b0$5 = (65535 & x$6_$_lo);
      var b1$5 = ((x$6_$_lo >>> 16) | 0);
      var a0b0$5 = Math.imul(5, b0$5);
      var a0b1$5 = Math.imul(5, b1$5);
      var lo$6 = ((a0b0$5 + (a0b1$5 << 16)) | 0);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$6 = ((Math.imul(5, x$6_$_hi) + ((c1part$5 >>> 16) | 0)) | 0);
      return $bL(lo$6, hi$6);
    }
  }
  var $x_10 = $m_Lcom_papasofokli_planning_package$();
  var x$7_$_lo = $x_10.M0;
  var x$7_$_hi = $x_10.M1;
  var b0$6 = (65535 & x$7_$_lo);
  var b1$6 = ((x$7_$_lo >>> 16) | 0);
  var a0b0$6 = Math.imul(18, b0$6);
  var a0b1$6 = Math.imul(18, b1$6);
  var lo$7 = ((a0b0$6 + (a0b1$6 << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$7 = ((Math.imul(18, x$7_$_hi) + ((c1part$6 >>> 16) | 0)) | 0);
  return $bL(lo$7, hi$7);
});
var $d_Lcom_papasofokli_planning_package$ = new $TypeData().i($c_Lcom_papasofokli_planning_package$, "com.papasofokli.planning.package$", ({
  r8: 1
}));
var $n_Lcom_papasofokli_planning_package$;
function $m_Lcom_papasofokli_planning_package$() {
  if ((!$n_Lcom_papasofokli_planning_package$)) {
    $n_Lcom_papasofokli_planning_package$ = new $c_Lcom_papasofokli_planning_package$();
  }
  return $n_Lcom_papasofokli_planning_package$;
}
function $p_Lcom_papasofokli_planning_tooltip_Tooltip$__getTooltipElement__Lorg_scalajs_dom_Element($thiz) {
  var oldTooltips = document.getElementsByClassName("tooltip-container");
  var end = (oldTooltips.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((end <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, end, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    var oldElement = oldTooltips[x0];
    $thiz.Kf.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((oldElement) => ((_$1$3) => {
      _$1$3.ds(oldElement);
    }))(oldElement)));
    b.aD(oldElement);
  }
  var toolTips = b.aR();
  var this$7 = $f_sc_IndexedSeqOps__headOption__s_Option(toolTips);
  if (this$7.c()) {
    var element = document.createElement("div");
    document.body.appendChild(element);
    $thiz.Kf.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
      _$2$3.ds(element);
    })));
    return element;
  } else {
    return this$7.h();
  }
}
function $p_Lcom_papasofokli_planning_tooltip_Tooltip$__setCoordinates__F__F__T__Z__V($thiz, pageX, pageY, html, concatMode) {
  if (concatMode) {
    $thiz.sM.innerHTML = (("" + $thiz.sM.innerHTML) + html);
  } else {
    $thiz.sM.innerHTML = html;
  }
  var tooltipJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)($thiz.sM);
  var maxTop = ($m_Lcom_papasofokli_util_GeometryMethods$().afU() - (+tooltipJQ.innerHeight()));
  var scroll = Math.fround((0, $m_Lcom_papasofokli_jquery_package$().I)(window).scrollTop());
  var top = (+$f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon((maxTop + scroll), new $c_sci_$colon$colon(pageY, $m_sci_Nil$())), $m_s_math_Ordering$Double$TotalOrdering$()));
  var tooltipWidth = (+tooltipJQ.width());
  var maxLeft = ($m_Lcom_papasofokli_util_GeometryMethods$().MP() - (0.5 * tooltipWidth));
  var a = Math.fround(maxLeft);
  var a$1 = Math.fround((+Math.min(a, pageX)));
  var b = Math.fround((0.5 * Math.fround(tooltipWidth)));
  var left = Math.fround((+Math.max(a$1, b)));
  var seq = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_StyleValue("left", (left + "px")), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_StyleValue("top", (top + "px")), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", (("tooltip-container " + $m_Lcom_papasofokli_planning_package$().nM) + " visible")), $m_sci_Nil$())));
  var these = seq;
  while ((!these.c())) {
    these.W().ds($thiz.sM);
    these = these.ak();
  }
}
/** @constructor */
function $c_Lcom_papasofokli_planning_tooltip_Tooltip$() {
  this.Kf = null;
  this.sM = null;
  $n_Lcom_papasofokli_planning_tooltip_Tooltip$ = this;
  this.Kf = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", ("tooltip-container " + $m_Lcom_papasofokli_planning_package$().nM)), $m_sci_Nil$());
  this.sM = $p_Lcom_papasofokli_planning_tooltip_Tooltip$__getTooltipElement__Lorg_scalajs_dom_Element(this);
}
$p = $c_Lcom_papasofokli_planning_tooltip_Tooltip$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_tooltip_Tooltip$;
/** @constructor */
function $h_Lcom_papasofokli_planning_tooltip_Tooltip$() {
}
$h_Lcom_papasofokli_planning_tooltip_Tooltip$.prototype = $p;
$p.oU = (function(html, concatMode, furtherAction) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $p_Lcom_papasofokli_planning_tooltip_Tooltip$__setCoordinates__F__F__T__Z__V(this, Math.fround(v1$2), Math.fround((Math.fround(v2$2) + 10.0)), html, concatMode);
    if ((!furtherAction.c())) {
      furtherAction.h().aA();
    }
  }));
});
$p.hO = (function() {
  this.sM.innerHTML = "";
  this.Kf.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
    _$4$3.ds(this.sM);
  })));
});
var $d_Lcom_papasofokli_planning_tooltip_Tooltip$ = new $TypeData().i($c_Lcom_papasofokli_planning_tooltip_Tooltip$, "com.papasofokli.planning.tooltip.Tooltip$", ({
  r9: 1
}));
var $n_Lcom_papasofokli_planning_tooltip_Tooltip$;
function $m_Lcom_papasofokli_planning_tooltip_Tooltip$() {
  if ((!$n_Lcom_papasofokli_planning_tooltip_Tooltip$)) {
    $n_Lcom_papasofokli_planning_tooltip_Tooltip$ = new $c_Lcom_papasofokli_planning_tooltip_Tooltip$();
  }
  return $n_Lcom_papasofokli_planning_tooltip_Tooltip$;
}
function $f_Lcom_papasofokli_popover_PopoverT__$init$__V($thiz) {
  $thiz.WV = "data-setup-function-id";
  $thiz.WU = "data-reload-function-id";
  $thiz.NQ = "not-initialized-popover";
}
function $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__setupScrollListener__Lorg_scalajs_dom_HTMLElement__D__V($thiz, fab, percentage) {
  window.addEventListener("scroll", ((_$1$2) => {
    $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__toggleVisibilityBasedOnScroll$1__D__Lorg_scalajs_dom_HTMLElement__V($thiz, percentage, fab);
  }));
}
function $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__updateVisibility__Lorg_scalajs_dom_HTMLElement__Z__V($thiz, fab, hide) {
  if (hide) {
    fab.classList.add("hidden");
  } else {
    fab.classList.remove("hidden");
  }
}
function $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__toggleVisibilityBasedOnScroll$1__D__Lorg_scalajs_dom_HTMLElement__V($thiz, percentage$1, fab$1) {
  if (((100.0 * ((+window.pageYOffset) / (+window.innerHeight))) > percentage$1)) {
    $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__updateVisibility__Lorg_scalajs_dom_HTMLElement__Z__V($thiz, fab$1, false);
  } else {
    $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__updateVisibility__Lorg_scalajs_dom_HTMLElement__Z__V($thiz, fab$1, true);
  }
}
/** @constructor */
function $c_Lcom_papasofokli_pos_FloatingActionButtonJs$() {
}
$p = $c_Lcom_papasofokli_pos_FloatingActionButtonJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pos_FloatingActionButtonJs$;
/** @constructor */
function $h_Lcom_papasofokli_pos_FloatingActionButtonJs$() {
}
$h_Lcom_papasofokli_pos_FloatingActionButtonJs$.prototype = $p;
$p.co = (function() {
  var fab = document.querySelector(".fab-scroll-trigger");
  if ((!(!(fab instanceof HTMLElement)))) {
    $p_Lcom_papasofokli_pos_FloatingActionButtonJs$__setupScrollListener__Lorg_scalajs_dom_HTMLElement__D__V(this, fab, ($m_sc_StringOps$(), $m_jl_Double$().fS(fab.getAttribute("data-scroll-percentage"))));
  }
});
var $d_Lcom_papasofokli_pos_FloatingActionButtonJs$ = new $TypeData().i($c_Lcom_papasofokli_pos_FloatingActionButtonJs$, "com.papasofokli.pos.FloatingActionButtonJs$", ({
  re: 1
}));
var $n_Lcom_papasofokli_pos_FloatingActionButtonJs$;
function $m_Lcom_papasofokli_pos_FloatingActionButtonJs$() {
  if ((!$n_Lcom_papasofokli_pos_FloatingActionButtonJs$)) {
    $n_Lcom_papasofokli_pos_FloatingActionButtonJs$ = new $c_Lcom_papasofokli_pos_FloatingActionButtonJs$();
  }
  return $n_Lcom_papasofokli_pos_FloatingActionButtonJs$;
}
function $p_Lcom_papasofokli_pos_FullscreenInitializerJs$__toggleFullscreen__sjs_js_Promise($thiz) {
  if ((document.fullscreenElement === null)) {
    var \u03b41$ = document.documentElement;
    return \u03b41$.requestFullscreen();
  } else {
    return document.exitFullscreen();
  }
}
/** @constructor */
function $c_Lcom_papasofokli_pos_FullscreenInitializerJs$() {
}
$p = $c_Lcom_papasofokli_pos_FullscreenInitializerJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pos_FullscreenInitializerJs$;
/** @constructor */
function $h_Lcom_papasofokli_pos_FullscreenInitializerJs$() {
}
$h_Lcom_papasofokli_pos_FullscreenInitializerJs$.prototype = $p;
$p.co = (function() {
  var x1 = document.querySelector(".fullscreen");
  if ((!(!(x1 instanceof HTMLElement)))) {
    x1.addEventListener("click", ((_$1$2) => $p_Lcom_papasofokli_pos_FullscreenInitializerJs$__toggleFullscreen__sjs_js_Promise(this)));
    return (void 0);
  }
});
var $d_Lcom_papasofokli_pos_FullscreenInitializerJs$ = new $TypeData().i($c_Lcom_papasofokli_pos_FullscreenInitializerJs$, "com.papasofokli.pos.FullscreenInitializerJs$", ({
  rf: 1
}));
var $n_Lcom_papasofokli_pos_FullscreenInitializerJs$;
function $m_Lcom_papasofokli_pos_FullscreenInitializerJs$() {
  if ((!$n_Lcom_papasofokli_pos_FullscreenInitializerJs$)) {
    $n_Lcom_papasofokli_pos_FullscreenInitializerJs$ = new $c_Lcom_papasofokli_pos_FullscreenInitializerJs$();
  }
  return $n_Lcom_papasofokli_pos_FullscreenInitializerJs$;
}
function $p_Lcom_papasofokli_pos_PosBarcodeInputJs$__initializeBarcodeInput__Lorg_scalajs_dom_HTMLInputElement__V($thiz, inputElement) {
  inputElement.classList.remove($thiz.PV);
  document.addEventListener("keydown", ((event$2) => (((inputElement !== null) && (!$p_Lcom_papasofokli_pos_PosBarcodeInputJs$__isBootstrapModalOpen__Z($thiz))) ? ($p_Lcom_papasofokli_pos_PosBarcodeInputJs$__handleKeyEvent__Lorg_scalajs_dom_KeyboardEvent__Lorg_scalajs_dom_HTMLInputElement__V($thiz, event$2, inputElement), (void 0)) : (void 0))));
  inputElement.addEventListener("submit-barcode", ((_$1$2) => {
    var functionId = inputElement.getAttribute("data-barcode-submit-id");
    var value = inputElement.value;
    if ((((functionId !== null) && ($m_sc_StringOps$(), (functionId !== ""))) && ($m_sc_StringOps$(), (value !== "")))) {
      var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(functionId);
      var executionContext = $m_sjs_concurrent_JSExecutionContext$Implicits$().kx;
      $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, id.g(), value, executionContext);
      return (void 0);
    } else {
      return (void 0);
    }
  }));
}
function $p_Lcom_papasofokli_pos_PosBarcodeInputJs$__handleKeyEvent__Lorg_scalajs_dom_KeyboardEvent__Lorg_scalajs_dom_HTMLInputElement__V($thiz, event, inputElement) {
  var x3 = event.key;
  if ($m_Lcom_papasofokli_input_Key$().ES.az(x3)) {
    var current = inputElement.value;
    inputElement.value = (("" + current) + x3);
    inputElement.dispatchEvent(new Event("input"));
    event.preventDefault();
    return (void 0);
  }
  if (($m_Lcom_papasofokli_input_Key$().EQ === x3)) {
    var current$2 = inputElement.value;
    if (($m_sc_StringOps$(), (current$2 !== ""))) {
      var endIndex = ((current$2.length - 1) | 0);
      inputElement.value = current$2.substring(0, endIndex);
      (!(!inputElement.dispatchEvent(new Event("input"))));
    }
    event.preventDefault();
    return (void 0);
  }
  if (($m_Lcom_papasofokli_input_Key$().JC === x3)) {
    var value = inputElement.value;
    if (($m_sc_StringOps$(), (value !== ""))) {
      inputElement.dispatchEvent(new Event("submit-barcode"));
      inputElement.value = "";
    }
    event.preventDefault();
    return (void 0);
  }
}
function $p_Lcom_papasofokli_pos_PosBarcodeInputJs$__isBootstrapModalOpen__Z($thiz) {
  return (!$f_sc_SeqOps__isEmpty__Z(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".modal.show"))));
}
/** @constructor */
function $c_Lcom_papasofokli_pos_PosBarcodeInputJs$() {
  this.PW = null;
  this.PV = null;
  $n_Lcom_papasofokli_pos_PosBarcodeInputJs$ = this;
  this.PW = $m_scm_Set$().ce();
  this.PV = "d3ac5426-9354-11ee-b9d1-0242ac120001";
}
$p = $c_Lcom_papasofokli_pos_PosBarcodeInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pos_PosBarcodeInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_pos_PosBarcodeInputJs$() {
}
$h_Lcom_papasofokli_pos_PosBarcodeInputJs$.prototype = $p;
$p.co = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(("." + this.PV)));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    if ((!(!(x0 instanceof HTMLInputElement)))) {
      var inputId = x0.id;
      if ((!this.PW.az(inputId))) {
        $p_Lcom_papasofokli_pos_PosBarcodeInputJs$__initializeBarcodeInput__Lorg_scalajs_dom_HTMLInputElement__V(this, x0);
        this.PW.qA(inputId);
      }
    }
  }
});
var $d_Lcom_papasofokli_pos_PosBarcodeInputJs$ = new $TypeData().i($c_Lcom_papasofokli_pos_PosBarcodeInputJs$, "com.papasofokli.pos.PosBarcodeInputJs$", ({
  rg: 1
}));
var $n_Lcom_papasofokli_pos_PosBarcodeInputJs$;
function $m_Lcom_papasofokli_pos_PosBarcodeInputJs$() {
  if ((!$n_Lcom_papasofokli_pos_PosBarcodeInputJs$)) {
    $n_Lcom_papasofokli_pos_PosBarcodeInputJs$ = new $c_Lcom_papasofokli_pos_PosBarcodeInputJs$();
  }
  return $n_Lcom_papasofokli_pos_PosBarcodeInputJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_pos_VibrateInitializerJs$() {
}
$p = $c_Lcom_papasofokli_pos_VibrateInitializerJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_pos_VibrateInitializerJs$;
/** @constructor */
function $h_Lcom_papasofokli_pos_VibrateInitializerJs$() {
}
$h_Lcom_papasofokli_pos_VibrateInitializerJs$.prototype = $p;
$p.co = (function() {
  var page = document.querySelector(".dc12340d-4051-454p-93cc-298df0c5568c");
  if ((!(!(page instanceof HTMLDivElement)))) {
    page.classList.remove("dc12340d-4051-454p-93cc-298df0c5568c");
    page.addEventListener("click", ((event$2) => {
      var x1 = event$2.target;
      if ((!(!(x1 instanceof HTMLButtonElement)))) {
        return (!(!window.navigator.vibrate(100.0)));
      }
      if ((!(!(x1 instanceof HTMLAnchorElement)))) {
        return (!(!window.navigator.vibrate(100.0)));
      }
      if ((!(!(x1 instanceof HTMLDivElement)))) {
        if ((!(!x1.classList.contains("card-body")))) {
          return (!(!window.navigator.vibrate(100.0)));
        }
      }
    }));
  }
});
var $d_Lcom_papasofokli_pos_VibrateInitializerJs$ = new $TypeData().i($c_Lcom_papasofokli_pos_VibrateInitializerJs$, "com.papasofokli.pos.VibrateInitializerJs$", ({
  rh: 1
}));
var $n_Lcom_papasofokli_pos_VibrateInitializerJs$;
function $m_Lcom_papasofokli_pos_VibrateInitializerJs$() {
  if ((!$n_Lcom_papasofokli_pos_VibrateInitializerJs$)) {
    $n_Lcom_papasofokli_pos_VibrateInitializerJs$ = new $c_Lcom_papasofokli_pos_VibrateInitializerJs$();
  }
  return $n_Lcom_papasofokli_pos_VibrateInitializerJs$;
}
function $p_Lcom_papasofokli_progressbar_ProgressBar__idUU__T($thiz) {
  if ((!$thiz.a54)) {
    $thiz.a53 = $m_ju_UUID$().aW().g();
    $thiz.a54 = true;
  }
  return $thiz.a53;
}
function $p_Lcom_papasofokli_progressbar_ProgressBar__progressBar__Lorg_scalajs_dom_HTMLDivElement($thiz) {
  if ((!$thiz.a57)) {
    $thiz.a55 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($p_Lcom_papasofokli_progressbar_ProgressBar__idUU__T($thiz), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("progress", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("progress-bar progress-bar-striped progress-bar-animated progress-bar-primary w-0", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().axw().n("progressbar", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$thiz.PX]))])).aB();
    $thiz.a57 = true;
    $thiz.PX = null;
  }
  return $thiz.a55;
}
/** @constructor */
function $c_Lcom_papasofokli_progressbar_ProgressBar(containerId) {
  this.a53 = null;
  this.a54 = false;
  this.PX = null;
  this.a55 = null;
  this.a57 = false;
  this.a52 = null;
  this.a56 = null;
  this.PX = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("0%"))]));
  this.a52 = document.getElementById(containerId);
  var this$5 = $m_s_Option$().Z(document.getElementById($p_Lcom_papasofokli_progressbar_ProgressBar__idUU__T(this)));
  this.a56 = (this$5.c() ? this.a52.appendChild($p_Lcom_papasofokli_progressbar_ProgressBar__progressBar__Lorg_scalajs_dom_HTMLDivElement(this)) : this$5.h());
}
$p = $c_Lcom_papasofokli_progressbar_ProgressBar.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_progressbar_ProgressBar;
/** @constructor */
function $h_Lcom_papasofokli_progressbar_ProgressBar() {
}
$h_Lcom_papasofokli_progressbar_ProgressBar.prototype = $p;
$p.axQ = (function(progress, style) {
  var inner = this.a56.firstChild;
  var innerJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(inner);
  if ((!style.c())) {
    var x0 = style.h();
    var removeClasses = $f_sc_IterableOnceOps__mkString__T__T__T__T($m_Lcom_papasofokli_util_ProgressBarStyle$().a8T.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((style$1) => ((_$1$2) => (!((_$1$2 === null) ? (style$1 === null) : (_$1$2 === style$1)))))(x0))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.xS))), "", " ", "");
    innerJQ.removeClass(removeClasses).addClass(x0.xS);
  }
  var value = (progress + "%");
  innerJQ.css("width", value);
  (0, $m_Lcom_papasofokli_jquery_package$().I)(inner.firstChild).text(value);
});
var $d_Lcom_papasofokli_progressbar_ProgressBar = new $TypeData().i($c_Lcom_papasofokli_progressbar_ProgressBar, "com.papasofokli.progressbar.ProgressBar", ({
  ri: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_progressbar_ProgressBarInitializer$() {
  this.PY = null;
  $n_Lcom_papasofokli_progressbar_ProgressBarInitializer$ = this;
  this.PY = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
}
$p = $c_Lcom_papasofokli_progressbar_ProgressBarInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_progressbar_ProgressBarInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_progressbar_ProgressBarInitializer$() {
}
$h_Lcom_papasofokli_progressbar_ProgressBarInitializer$.prototype = $p;
$p.auW = (function() {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(".4065b37f-5942-465d-9fed-c02df4a5d4eb").each(((this$1) => (function() {
    var progressBar = new $c_Lcom_papasofokli_progressbar_ProgressBar(this.id);
    this$1.PY.Jf(this.id, progressBar);
  }))(this)).removeClass("4065b37f-5942-465d-9fed-c02df4a5d4eb");
});
$p.axS = (function(p) {
  var this$1 = this.PY.b9(p.rW.g());
  if ((!this$1.c())) {
    this$1.h().axQ(p.rY, p.rX);
  }
});
var $d_Lcom_papasofokli_progressbar_ProgressBarInitializer$ = new $TypeData().i($c_Lcom_papasofokli_progressbar_ProgressBarInitializer$, "com.papasofokli.progressbar.ProgressBarInitializer$", ({
  rj: 1
}));
var $n_Lcom_papasofokli_progressbar_ProgressBarInitializer$;
function $m_Lcom_papasofokli_progressbar_ProgressBarInitializer$() {
  if ((!$n_Lcom_papasofokli_progressbar_ProgressBarInitializer$)) {
    $n_Lcom_papasofokli_progressbar_ProgressBarInitializer$ = new $c_Lcom_papasofokli_progressbar_ProgressBarInitializer$();
  }
  return $n_Lcom_papasofokli_progressbar_ProgressBarInitializer$;
}
function $p_Lcom_papasofokli_qr_scan_QRScanForDiv__action__Lorg_scalajs_dom_KeyboardEvent__V($thiz, e) {
  if ((!$m_Lcom_papasofokli_util_package$().ahQ())) {
    $m_Lcom_papasofokli_util_package$().VH(new $c_s_Some($thiz.PZ), $thiz.Q0);
  }
  if ((e.key === "Enter")) {
    try {
      var uuid = new $c_s_util_Success($m_ju_UUID$().aO($thiz.Bo));
    } catch (e$1) {
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      matchResult1: {
        var uuid;
        var x2 = $m_s_util_control_NonFatal$().dV(e$2);
        if ((!x2.c())) {
          var uuid = new $c_s_util_Failure(x2.h());
          break matchResult1;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
      }
    }
    matchResult1$1: {
      if ((uuid instanceof $c_s_util_Success)) {
        var str = uuid.hC;
        console.log(("QR code validate : " + str));
        var this$5 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
        var id = $thiz.PZ;
        var data = str.g();
        var executionContext = $thiz.Q0;
        $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$5, id.g(), data, executionContext);
        break matchResult1$1;
      }
      if ((uuid instanceof $c_s_util_Failure)) {
        console.log(("Not recognised QR : " + $thiz.Bo));
        $m_Lcom_papasofokli_components_ToastJS$().IZ("Not recognised QR.", $m_s_Option$().Z($bL(3000, 0)));
        break matchResult1$1;
      }
      throw new $c_s_MatchError(uuid);
    }
    $thiz.Bo = "";
  } else {
    $thiz.Bo = (("" + $thiz.Bo) + e.key);
  }
}
/** @constructor */
function $c_Lcom_papasofokli_qr_scan_QRScanForDiv(divId, executionContext) {
  this.PZ = null;
  this.Q0 = null;
  this.Bo = null;
  this.PZ = divId;
  this.Q0 = executionContext;
  $m_sjs_js_timers_package$().Vq(1200000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    window.location.reload();
  })));
  this.Bo = "";
  var divElement = document.getElementById(divId.g());
  var buttonExpand = $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn btn-primary expand-button-station-scan d-none d-lg-block", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8H.TA("fa-2x", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())).by, $m_Lscalatags_JsDom$all$().s)]))])).aB();
  divElement.appendChild(buttonExpand);
  buttonExpand.onclick = ((_$1$2) => {
    $m_Lcom_papasofokli_util_package$().VH(new $c_s_Some(divId), executionContext);
  });
  buttonExpand.onkeypress = ((_$2$2) => {
    _$2$2.preventDefault();
  });
  document.onkeypress = ((_$3$2) => {
    $p_Lcom_papasofokli_qr_scan_QRScanForDiv__action__Lorg_scalajs_dom_KeyboardEvent__V(this, _$3$2);
  });
}
$p = $c_Lcom_papasofokli_qr_scan_QRScanForDiv.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_qr_scan_QRScanForDiv;
/** @constructor */
function $h_Lcom_papasofokli_qr_scan_QRScanForDiv() {
}
$h_Lcom_papasofokli_qr_scan_QRScanForDiv.prototype = $p;
var $d_Lcom_papasofokli_qr_scan_QRScanForDiv = new $TypeData().i($c_Lcom_papasofokli_qr_scan_QRScanForDiv, "com.papasofokli.qr.scan.QRScanForDiv", ({
  rk: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_qr_scan_QRScanInitializer$() {
}
$p = $c_Lcom_papasofokli_qr_scan_QRScanInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_qr_scan_QRScanInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_qr_scan_QRScanInitializer$() {
}
$h_Lcom_papasofokli_qr_scan_QRScanInitializer$.prototype = $p;
$p.IM = (function(executionContext) {
  return $m_Lcom_papasofokli_util_package$().Eg("b2fff340-0076-4e83-a668-34534ea56fab", new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element$3) => {
    new $c_Lcom_papasofokli_qr_scan_QRScanForDiv($m_ju_UUID$().aO(element$3.id), executionContext);
  })));
});
var $d_Lcom_papasofokli_qr_scan_QRScanInitializer$ = new $TypeData().i($c_Lcom_papasofokli_qr_scan_QRScanInitializer$, "com.papasofokli.qr.scan.QRScanInitializer$", ({
  rl: 1
}));
var $n_Lcom_papasofokli_qr_scan_QRScanInitializer$;
function $m_Lcom_papasofokli_qr_scan_QRScanInitializer$() {
  if ((!$n_Lcom_papasofokli_qr_scan_QRScanInitializer$)) {
    $n_Lcom_papasofokli_qr_scan_QRScanInitializer$ = new $c_Lcom_papasofokli_qr_scan_QRScanInitializer$();
  }
  return $n_Lcom_papasofokli_qr_scan_QRScanInitializer$;
}
function $p_Lcom_papasofokli_rating_IconRating__getSelectedNameText__s_Option__Lscalatags_JsDom$TypedTag($thiz, indexO) {
  var this$2 = (indexO.c() ? $m_s_None$() : new $c_s_Some(indexO.h().c4.g()));
  var indexText = (this$2.c() ? "" : this$2.h());
  if (indexO.c()) {
    var this$4 = $m_s_None$();
  } else {
    var x0$1 = indexO.h();
    var this$4 = new $c_s_Some($thiz.a59.pA.p(x0$1));
  }
  var text = (this$4.c() ? "" : this$4.h());
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-text-div", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-value", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + indexText)))])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-value-text", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("  " + text)))]))]));
}
function $p_Lcom_papasofokli_rating_IconRating__sendToServerSelection__s_Option__s_concurrent_Future($thiz, index) {
  var this$9 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id = $m_ju_UUID$().aO($thiz.Q1.id);
  var $x_2 = $m_Lupickle_default$();
  var $x_1 = new $c_Lcom_papasofokli_rating_OptionChangedRating(index);
  $m_Lupickle_default$();
  $m_Lupickle_default$();
  $m_Lupickle_default$();
  $m_Lupickle_default$();
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_2, $x_1, (-1), false, false, $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_rating_RatingClientMessages$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))));
  var executionContext = $thiz.Q2;
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$9, id.g(), data, executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    $p_Lcom_papasofokli_rating_IconRating__colorIconsUpTo__s_Option__V($thiz, index);
  })), $thiz.Q2);
}
function $p_Lcom_papasofokli_rating_IconRating__colorIconsUpTo__s_Option__V($thiz, index) {
  $thiz.xi.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var iconIndex = x$1$2.P();
      var icon = x$1$2.V();
      return (((!index.c()) && $f_s_math_Ordered__$less$eq__O__Z(iconIndex, index.h())) ? (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + icon.aB().id)).addClass("icon-rating-selected") : (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + icon.aB().id)).removeClass("icon-rating-selected"));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
function $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, text) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.Kh.aB().id)).empty();
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.Kh.aB().id)).append(text);
}
function $p_Lcom_papasofokli_rating_IconRating__initializeClickFunctions__V($thiz) {
  $thiz.xi.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult4: {
      if ((x$1$3 !== null)) {
        var index = x$1$3.P();
        var icon = x$1$3.V();
        var currentSpan = document.getElementById(icon.aB().id);
        currentSpan.onclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__ratingIconOnClick__s_math_BigDecimal__F1($thiz, index));
        currentSpan.onmouseover = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__ratingIconOnMouseOver__s_math_BigDecimal__F1($thiz, index));
        currentSpan.onmouseleave = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__ratingIconOnMouseLeave__s_math_BigDecimal__F1($thiz, index));
        break matchResult4;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  var clear = document.getElementById($thiz.xh.aB().id);
  clear.onclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__clearFunction__F1($thiz));
  clear.onmouseover = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__ratingClearIconOnMouseOver__F1($thiz));
  clear.onmouseleave = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_rating_IconRating__ratingClearIconOnMouseLeave__F1($thiz));
}
function $p_Lcom_papasofokli_rating_IconRating__clearFunction__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    $p_Lcom_papasofokli_rating_IconRating__sendToServerSelection__s_Option__s_concurrent_Future($thiz, $m_s_None$());
    $thiz.sP = $p_Lcom_papasofokli_rating_IconRating__getSelectedNameText__s_Option__Lscalatags_JsDom$TypedTag($thiz, $m_s_None$());
    $thiz.xi.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var prevIcon = x$1$2.V();
        return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + prevIcon.aB().id)).removeClass("icon-rating-previews");
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $thiz.sP.g());
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.xh.aB().id)).removeClass("rating-clear-icon-enabled");
    return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.xh.aB().id)).addClass($thiz.Kg);
  }));
}
function $p_Lcom_papasofokli_rating_IconRating__ratingIconOnClick__s_math_BigDecimal__F1($thiz, index) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => {
    $p_Lcom_papasofokli_rating_IconRating__sendToServerSelection__s_Option__s_concurrent_Future($thiz, new $c_s_Some(index));
    $thiz.sP = $p_Lcom_papasofokli_rating_IconRating__getSelectedNameText__s_Option__Lscalatags_JsDom$TypedTag($thiz, new $c_s_Some(index));
    $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $thiz.sP.g());
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.xh.aB().id)).addClass("rating-clear-icon-enabled");
    return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.xh.aB().id)).removeClass($thiz.Kg);
  }));
}
function $p_Lcom_papasofokli_rating_IconRating__ratingIconOnMouseOver__s_math_BigDecimal__F1($thiz, index) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
    $thiz.xi.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$2) => $f_s_math_Ordered__$less__O__Z(_$7$2.P(), index)))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var prevIcon = x$1$2.V();
        return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + prevIcon.aB().id)).addClass("icon-rating-previews");
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    return $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $p_Lcom_papasofokli_rating_IconRating__getSelectedNameText__s_Option__Lscalatags_JsDom$TypedTag($thiz, new $c_s_Some(index)).g());
  }));
}
function $p_Lcom_papasofokli_rating_IconRating__ratingIconOnMouseLeave__s_math_BigDecimal__F1($thiz, index) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => {
    $thiz.xi.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => $f_s_math_Ordered__$less__O__Z(_$9$2.P(), index)))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var prevIcon = x$1$2.V();
        return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + prevIcon.aB().id)).removeClass("icon-rating-previews");
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    return $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $thiz.sP.g());
  }));
}
function $p_Lcom_papasofokli_rating_IconRating__ratingClearIconOnMouseOver__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10$2) => $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-text-div", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-value-text", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("Clear selections"))]))])).g())));
}
function $p_Lcom_papasofokli_rating_IconRating__ratingClearIconOnMouseLeave__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11$2) => $p_Lcom_papasofokli_rating_IconRating__replaceTextDivContent__T__Lcom_papasofokli_jquery_JQuery($thiz, $thiz.sP.g())));
}
/** @constructor */
function $c_Lcom_papasofokli_rating_IconRating(divElement, initialData, executionContext) {
  this.Q1 = null;
  this.a59 = null;
  this.Q2 = null;
  this.Kg = null;
  this.a58 = null;
  this.sP = null;
  this.xi = null;
  this.xh = null;
  this.Kh = null;
  this.a5a = null;
  this.Q1 = divElement;
  this.a59 = initialData;
  this.Q2 = executionContext;
  this.Kg = "icon-rating-disabled rating-clear-icon-disabled";
  this.a58 = (initialData.kd ? "icon-rating-disabled" : "");
  var clearInitialClass = (initialData.nN.c() ? this.Kg : "rating-clear-icon-enabled");
  var this$5 = initialData.nN;
  var this$8 = (this$5.c() ? $m_s_None$() : new $c_s_Some($p_Lcom_papasofokli_rating_IconRating__getSelectedNameText__s_Option__Lscalatags_JsDom$TypedTag(this, new $c_s_Some(this$5.h()))));
  this.sP = (this$8.c() ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("rating-text-div", $m_Lscalatags_JsDom$all$().s)])) : this$8.h());
  var this$13 = initialData.pA;
  this.xi = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($m_sci_Seq$().fM(this$13), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.P())), $m_s_math_Ordering$BigDecimal$()).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var index = x$1$2.P();
      var this$16 = initialData.nN;
      if (((!this$16.c()) && $f_s_math_Ordered__$greater$eq__O__Z(this$16.h(), index))) {
        var additionalClass = "icon-rating-selected";
      } else {
        var additionalClass = "";
      }
      return new $c_T2(index, $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(initialData.sQ.TA(((("icon-rating " + additionalClass) + " ") + this.a58), $m_s_None$()).by, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s)])));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  this.xh = (initialData.kd ? $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])) : $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(((("rating-value-text " + clearInitialClass) + " ") + $m_Lcom_papasofokli_util_IconUI$().a8N.by), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s)])));
  this.Kh = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-md-12", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [this.sP]));
  var innerDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-md-12 icon-inner-rating-div", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), this.xi.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => _$3$2.V()))).aV(this.xh), $m_s_$less$colon$less$().b0)]));
  this.a5a = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row rating-outer-div", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [innerDiv, this.Kh])).aB();
}
$p = $c_Lcom_papasofokli_rating_IconRating.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_IconRating;
/** @constructor */
function $h_Lcom_papasofokli_rating_IconRating() {
}
$h_Lcom_papasofokli_rating_IconRating.prototype = $p;
$p.axb = (function() {
  this.Q1.appendChild(this.a5a);
  $p_Lcom_papasofokli_rating_IconRating__initializeClickFunctions__V(this);
});
var $d_Lcom_papasofokli_rating_IconRating = new $TypeData().i($c_Lcom_papasofokli_rating_IconRating, "com.papasofokli.rating.IconRating", ({
  rm: 1
}));
var $d_Lcom_papasofokli_rating_RatingClientMessages = new $TypeData().i(1, "com.papasofokli.rating.RatingClientMessages", ({
  ch: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingInitializer$() {
}
$p = $c_Lcom_papasofokli_rating_RatingInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingInitializer$() {
}
$h_Lcom_papasofokli_rating_RatingInitializer$.prototype = $p;
$p.b7 = (function(executionContext) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-rating").removeClass("not-initialized-rating").each((function() {
    var $x_4 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var $x_3 = this.id;
    var $x_2 = $m_Lupickle_default$();
    var $x_1 = new $c_Lcom_papasofokli_rating_InitializeRating();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    return $x_4.c5($x_3, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_2, $x_1, (-1), false, false, $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_rating_RatingClientMessages$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2)))), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      new $c_Lcom_papasofokli_rating_IconRating(this, $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_rating_RatingInitialData$().q()), executionContext).axb();
    })), executionContext))), executionContext);
  }));
});
var $d_Lcom_papasofokli_rating_RatingInitializer$ = new $TypeData().i($c_Lcom_papasofokli_rating_RatingInitializer$, "com.papasofokli.rating.RatingInitializer$", ({
  rv: 1
}));
var $n_Lcom_papasofokli_rating_RatingInitializer$;
function $m_Lcom_papasofokli_rating_RatingInitializer$() {
  if ((!$n_Lcom_papasofokli_rating_RatingInitializer$)) {
    $n_Lcom_papasofokli_rating_RatingInitializer$ = new $c_Lcom_papasofokli_rating_RatingInitializer$();
  }
  return $n_Lcom_papasofokli_rating_RatingInitializer$;
}
/** @constructor */
function $c_Lcom_papasofokli_sidebar_LiSideBarJS$() {
}
$p = $c_Lcom_papasofokli_sidebar_LiSideBarJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sidebar_LiSideBarJS$;
/** @constructor */
function $h_Lcom_papasofokli_sidebar_LiSideBarJS$() {
}
$h_Lcom_papasofokli_sidebar_LiSideBarJS$.prototype = $p;
$p.b7 = (function(executionContext) {
  var elementSeq = document.querySelectorAll(".f3f72fa9-9dfd-4f7e-9ec5-e348b1a59d3b");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elementSeq);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove("f3f72fa9-9dfd-4f7e-9ec5-e348b1a59d3b");
    var getTextFunId = x0.getAttribute("data-get-text-function");
    if (($m_sc_StringOps$(), (getTextFunId !== ""))) {
      $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(getTextFunId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0, executionContext) => ((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
        var content = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
        x0.textContent = (" " + content);
        return resp$2;
      })), executionContext)))(x0, executionContext)), executionContext);
    }
  }
});
var $d_Lcom_papasofokli_sidebar_LiSideBarJS$ = new $TypeData().i($c_Lcom_papasofokli_sidebar_LiSideBarJS$, "com.papasofokli.sidebar.LiSideBarJS$", ({
  rw: 1
}));
var $n_Lcom_papasofokli_sidebar_LiSideBarJS$;
function $m_Lcom_papasofokli_sidebar_LiSideBarJS$() {
  if ((!$n_Lcom_papasofokli_sidebar_LiSideBarJS$)) {
    $n_Lcom_papasofokli_sidebar_LiSideBarJS$ = new $c_Lcom_papasofokli_sidebar_LiSideBarJS$();
  }
  return $n_Lcom_papasofokli_sidebar_LiSideBarJS$;
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__initializeSearchBar__V($thiz) {
  var searchBar = document.querySelector(".d30f883b-2036-4ee3-b243-0d423ab8b016");
  if ((searchBar !== null)) {
    searchBar.classList.remove("d30f883b-2036-4ee3-b243-0d423ab8b016");
    $p_Lcom_papasofokli_sidebar_SideBarJS__setSearchBarEventListener__Lorg_scalajs_dom_HTMLInputElement__V($thiz, searchBar);
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__setSearchBarEventListener__Lorg_scalajs_dom_HTMLInputElement__V($thiz, searchBar) {
  searchBar.oninput = ((_$1$2) => {
    var this$2 = $f_T__trim__T(searchBar.value);
    var query = this$2.toLowerCase();
    var lis = document.querySelectorAll(($thiz.sR + " li"));
    if ((query === "")) {
      $p_Lcom_papasofokli_sidebar_SideBarJS__unhideElements__V($thiz);
      $p_Lcom_papasofokli_sidebar_SideBarJS__collapseElements__V($thiz);
      return (void 0);
    } else {
      $p_Lcom_papasofokli_sidebar_SideBarJS__hideElements__V($thiz);
      var this$4 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(lis);
      var it = this$4.l();
      while (it.f()) {
        var x0 = it.e();
        if ($p_Lcom_papasofokli_sidebar_SideBarJS__isLeaf__Lorg_scalajs_dom_Element__Z($thiz, x0)) {
          var this$5 = $f_T__trim__T(x0.textContent);
          var text = this$5.toLowerCase();
          if (((text.indexOf(query) | 0) !== (-1))) {
            $p_Lcom_papasofokli_sidebar_SideBarJS__unhideToRoot__Lorg_scalajs_dom_Node__V($thiz, x0);
          }
        }
      }
      return (void 0);
    }
  });
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__unhideToRoot__Lorg_scalajs_dom_Node__V($thiz, node) {
  var node$tailLocal1 = node;
  while (true) {
    var x5 = node$tailLocal1;
    if ((x5 === null)) {
      return (void 0);
    }
    if ((!(!(x5 instanceof Element)))) {
      x5.classList.remove($thiz.Kl);
      var this$1 = x5.tagName;
      if ((this$1.toLowerCase() === "ul")) {
        $p_Lcom_papasofokli_sidebar_SideBarJS__expandAria__Lorg_scalajs_dom_Element__V($thiz, x5);
      }
      node$tailLocal1 = x5.parentNode;
      continue;
    }
    node$tailLocal1 = x5.parentNode;
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__isLeaf__Lorg_scalajs_dom_Element__Z($thiz, li) {
  return (li.querySelector("ul") === null);
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__hideElements__V($thiz) {
  var all = document.querySelectorAll(((($thiz.sR + " li, ") + $thiz.sR) + " ul"));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(all);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.add($thiz.Kl);
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__unhideElements__V($thiz) {
  var all = document.querySelectorAll(((($thiz.sR + " li, ") + $thiz.sR) + " ul"));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(all);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove($thiz.Kl);
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__collapseElements__V($thiz) {
  var all = document.querySelectorAll(($thiz.sR + " ul"));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(all);
  var it = this$2.l();
  while (it.f()) {
    $p_Lcom_papasofokli_sidebar_SideBarJS__collapseAria__Lorg_scalajs_dom_Element__V($thiz, it.e());
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__getUrlLink__Lorg_scalajs_dom_Element__T__Lorg_scalajs_dom_Element($thiz, linkWithoutParams, linkWithParams) {
  return ((linkWithoutParams !== null) ? linkWithoutParams : document.querySelector((("a[href='" + linkWithParams) + "']")));
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__expandAria__Lorg_scalajs_dom_Element__V($thiz, target) {
  target.classList.add($thiz.Q6);
  var aResult = document.querySelector((((("[" + $thiz.Kj) + "='#") + target.id) + "']"));
  if ((aResult !== null)) {
    aResult.setAttribute($thiz.Ki, "true");
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__collapseAria__Lorg_scalajs_dom_Element__V($thiz, target) {
  target.classList.remove($thiz.Q6);
  var aResult = document.querySelector((((("[" + $thiz.Kj) + "='#") + target.id) + "']"));
  if ((aResult !== null)) {
    aResult.setAttribute($thiz.Ki, "false");
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__createAutoCloseFeature__V($thiz) {
  var ulsSecondLevel = document.querySelectorAll(("ul." + $thiz.Q5));
  var ulsThirdLevel = document.querySelectorAll(("ul." + $thiz.Kn));
  var ulsFourthLevel = document.querySelectorAll(("ul." + $thiz.Kk));
  $f_sc_IterableOps__concat__sc_IterableOnce__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(ulsSecondLevel), new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(ulsThirdLevel)).cH(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(ulsFourthLevel)).bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2 === null)))).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => {
    e$3.setAttribute($thiz.a5j, ("#" + $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsUl__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLUListElement($thiz, $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsLi__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLLIElement($thiz, e$3)).id));
  })));
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__removeElement__Lorg_scalajs_dom_Element__V($thiz, element) {
  if ((element !== null)) {
    element.remove();
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsUl__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLUListElement($thiz, element) {
  return element.parentNode;
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsLi__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLLIElement($thiz, element) {
  return element.parentNode;
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__scrollFunction__ALorg_scalajs_dom_Element__F1($thiz, newAnchorDivs) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
    $p_Lcom_papasofokli_sidebar_SideBarJS__highlightAction__ALorg_scalajs_dom_Element__V($thiz, newAnchorDivs);
  }));
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__highlightAction__ALorg_scalajs_dom_Element__V($thiz, newAnchorDivs) {
  new $c_Lcom_papasofokli_util_MultipleEventHandler(60, 0, $thiz.Q4).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((newAnchorDivs.a.length !== 0)) {
      var closestElement = $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O($m_s_Predef$().Jl(newAnchorDivs), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
        var a = (+e$2.getBoundingClientRect().top);
        return (+Math.abs(a));
      })), $m_s_math_Ordering$Double$TotalOrdering$());
      $p_Lcom_papasofokli_sidebar_SideBarJS__elementToHighlight__T__V($thiz, closestElement.id);
    }
  })));
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__eventListerOptions__Lorg_scalajs_dom_EventListenerOptions($thiz) {
  return (() => {
    var this$1 = ({});
    this$1.passive = true;
    return this$1;
  })();
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__elementToHighlight__T__V($thiz, elementToHighlightId) {
  var highlightSelector = ("li." + elementToHighlightId);
  var highlightSelectorQS = document.querySelector((highlightSelector + " > a"));
  var fwBold = document.querySelector(("ul > li > a." + $thiz.Fj));
  if ((fwBold !== null)) {
    fwBold.classList.remove($thiz.Fj);
  }
  if (((highlightSelectorQS !== null) && (!(!(!highlightSelectorQS.classList.contains("active")))))) {
    highlightSelectorQS.classList.add($thiz.Fj);
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__appendNavLi__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_Element__V($thiz, list, element) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(600, 0, $thiz.Q4);
  var anchor = ("#" + element.id);
  var text = element.getAttribute("data-side-name");
  var textO = $m_sc_StringOps$().Eb(text);
  if ((!textO.c())) {
    $uC(textO.h());
    var alink = $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().IL().n(anchor, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("text-decoration-none link-light", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text))])).aB();
    alink.onclick = ((_$6$2) => {
      var element$1 = document.querySelector((anchor + " .lazy-collapse"));
      return (((element$1 !== null) && ($f_sc_IterableOnceOps__mkString__T__T__T__T(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element$1.firstElementChild.classList), "", " ", "") !== $m_Lcom_papasofokli_util_IconUI$().a8O.by)) ? multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        element$1.click();
      }))) : (void 0));
    });
    var link = $m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_sc_StringOps$().ak8(anchor), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), alink)])).aB();
    list.append(link);
  }
}
function $p_Lcom_papasofokli_sidebar_SideBarJS__continue$1__Lorg_scalajs_dom_HTMLUListElement__I__V($thiz, ul, acc) {
  var acc$tailLocal1 = acc;
  var ul$tailLocal1 = ul;
  while (true) {
    if ((acc$tailLocal1 > 0)) {
      $p_Lcom_papasofokli_sidebar_SideBarJS__expandAria__Lorg_scalajs_dom_Element__V($thiz, ul$tailLocal1);
      var liParent = $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsLi__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLLIElement($thiz, ul$tailLocal1);
      var ulParent = $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsUl__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLUListElement($thiz, liParent);
      var acc$tailLocal1$tmp1 = ((acc$tailLocal1 - 1) | 0);
      ul$tailLocal1 = ulParent;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    } else {
      return (void 0);
    }
  }
}
/** @constructor */
function $c_Lcom_papasofokli_sidebar_SideBarJS(executionContext) {
  this.Q4 = null;
  this.sR = null;
  this.Fj = null;
  this.Ki = null;
  this.a5j = null;
  this.Kj = null;
  this.Q6 = null;
  this.Kk = null;
  this.Kn = null;
  this.Q5 = null;
  this.Q3 = null;
  this.a5i = null;
  this.Kl = null;
  this.a5m = null;
  this.Km = null;
  this.a5k = null;
  this.a5l = false;
  this.Q4 = executionContext;
  this.sR = "#side-menu";
  this.Fj = "fw-bold";
  this.Ki = "aria-expanded";
  this.a5j = "data-bs-parent";
  this.Kj = "data-bs-target";
  this.Q6 = "show";
  this.Kk = "ul-fourth-level";
  this.Kn = "ul-third-level";
  this.Q5 = "ul-second-level";
  this.Q3 = "component-for-update";
  this.a5i = "current-link";
  this.Kl = "hidden";
  this.a5m = document.querySelector(this.sR);
  this.Km = new ($d_Lorg_scalajs_dom_Element.r().C)([]);
  if ((this.a5m !== null)) {
    $p_Lcom_papasofokli_sidebar_SideBarJS__initializeSearchBar__V(this);
    var anchorDivs = document.querySelectorAll("div.anchor-div-sidebar-link");
    var urlPath = window.location.pathname;
    var urlParams = window.location.search;
    var hash = window.location.hash;
    var linkWithoutParams = document.querySelector((("a[href='" + urlPath) + "']"));
    var urlWithParams = (("" + urlPath) + urlParams);
    var urlLink = $p_Lcom_papasofokli_sidebar_SideBarJS__getUrlLink__Lorg_scalajs_dom_Element__T__Lorg_scalajs_dom_Element(this, linkWithoutParams, urlWithParams);
    if ((urlLink !== null)) {
      var urlLi = $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsLi__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLLIElement(this, urlLink);
      var urlUl = $p_Lcom_papasofokli_sidebar_SideBarJS__getParentAsUl__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLUListElement(this, urlLi);
      var urlLiClass = urlLi.classList;
      var urlUlClass = urlUl.classList;
      if ((!(!urlUlClass.contains(this.Q5)))) {
        var x2___1 = (this.Kn + " border-success");
        var x2___2 = 1;
      } else if ((!(!urlUlClass.contains(this.Kn)))) {
        var x2___1 = (this.Kk + " border-warning");
        var x2___2 = 2;
      } else if ((!(!urlUlClass.contains(this.Kk)))) {
        var x2___1 = "border-light";
        var x2___2 = 3;
      } else {
        var x2___1 = "border-primary";
        var x2___2 = 0;
      }
      var \u03b42$___1 = x2___1;
      var \u03b42$___2 = x2___2;
      var nextCssLevel$2 = \u03b42$___1;
      var positionInt$2 = (\u03b42$___2 | 0);
      var levelCss = (("btn-toggle-nav list-unstyled fw-normal ps-0 bg-dark bg-opacity-25 collapse show border-start border-3 " + nextCssLevel$2) + " ");
      $p_Lcom_papasofokli_sidebar_SideBarJS__removeElement__Lorg_scalajs_dom_Element__V(this, document.querySelector(("." + this.Q3)));
      var newUlId = $m_Lcom_papasofokli_InitializeScalaJS$().U7($m_ju_UUID$().aW());
      var newUList = $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((levelCss + this.Q3), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(("" + newUlId), $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("sidebar", $m_Lscalatags_JsDom$all$().s)]))])).aB();
      var newUlLis = newUList.children;
      var $x_2 = $f_sc_IterableOps__tapEach__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(anchorDivs), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => {
        $p_Lcom_papasofokli_sidebar_SideBarJS__appendNavLi__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_Element__V(this, newUList, x$3);
      })));
      var $x_1;
      var $x_1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_Element.l());
      this.Km = $x_2.jz($x_1);
      $f_sc_IterableOps__tapEach__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(newUlLis), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$1) => {
        if ((!(!x$3$1.classList.contains("sidebar")))) {
          x$3$1.remove();
        }
      })));
      if ((!$f_sc_SeqOps__isEmpty__Z(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(anchorDivs)))) {
        urlLiClass.remove("sidebar");
        urlLiClass.add(this.a5i);
        urlLink.removeAttribute("class");
        urlLink.setAttribute("data-bs-toggle", "collapse");
        urlLink.setAttribute("role", "button");
        urlLink.setAttribute("class", "btn btn-toggle text-start rounded-0 link-light");
        urlLink.setAttribute(this.Kj, ("#" + newUlId));
        urlLink.setAttribute(this.Ki, "true");
        urlLi.append(newUList);
        if (($m_sc_StringOps$(), (hash !== ""))) {
          $p_Lcom_papasofokli_sidebar_SideBarJS__elementToHighlight__T__V(this, $m_sc_StringOps$().ak8(hash));
        }
      }
      $p_Lcom_papasofokli_sidebar_SideBarJS__continue$1__Lorg_scalajs_dom_HTMLUListElement__I__V(this, urlUl, positionInt$2);
      urlLink.classList.add(this.Fj);
      $p_Lcom_papasofokli_sidebar_SideBarJS__createAutoCloseFeature__V(this);
      window.addEventListener("scroll", this.ajD(), $p_Lcom_papasofokli_sidebar_SideBarJS__eventListerOptions__Lorg_scalajs_dom_EventListenerOptions(this));
    }
  }
}
$p = $c_Lcom_papasofokli_sidebar_SideBarJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sidebar_SideBarJS;
/** @constructor */
function $h_Lcom_papasofokli_sidebar_SideBarJS() {
}
$h_Lcom_papasofokli_sidebar_SideBarJS.prototype = $p;
$p.ajD = (function() {
  if ((!this.a5l)) {
    this.a5k = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_sidebar_SideBarJS__scrollFunction__ALorg_scalajs_dom_Element__F1(this, this.Km));
    this.a5l = true;
  }
  return this.a5k;
});
$p.arZ = (function() {
  if ((this.Km.a.length > 0)) {
    window.removeEventListener("scroll", this.ajD(), $p_Lcom_papasofokli_sidebar_SideBarJS__eventListerOptions__Lorg_scalajs_dom_EventListenerOptions(this));
  }
});
var $d_Lcom_papasofokli_sidebar_SideBarJS = new $TypeData().i($c_Lcom_papasofokli_sidebar_SideBarJS, "com.papasofokli.sidebar.SideBarJS", ({
  rx: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sidebar_SideBarJS$() {
  this.Q7 = null;
  $n_Lcom_papasofokli_sidebar_SideBarJS$ = this;
  this.Q7 = $m_s_None$();
}
$p = $c_Lcom_papasofokli_sidebar_SideBarJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sidebar_SideBarJS$;
/** @constructor */
function $h_Lcom_papasofokli_sidebar_SideBarJS$() {
}
$h_Lcom_papasofokli_sidebar_SideBarJS$.prototype = $p;
$p.akk = (function(executionContext) {
  var this$1 = this.Q7;
  if ((!this$1.c())) {
    this$1.h().arZ();
  }
  this.Q7 = $m_s_Option$().Z(new $c_Lcom_papasofokli_sidebar_SideBarJS(executionContext));
});
var $d_Lcom_papasofokli_sidebar_SideBarJS$ = new $TypeData().i($c_Lcom_papasofokli_sidebar_SideBarJS$, "com.papasofokli.sidebar.SideBarJS$", ({
  ry: 1
}));
var $n_Lcom_papasofokli_sidebar_SideBarJS$;
function $m_Lcom_papasofokli_sidebar_SideBarJS$() {
  if ((!$n_Lcom_papasofokli_sidebar_SideBarJS$)) {
    $n_Lcom_papasofokli_sidebar_SideBarJS$ = new $c_Lcom_papasofokli_sidebar_SideBarJS$();
  }
  return $n_Lcom_papasofokli_sidebar_SideBarJS$;
}
function $p_Lcom_papasofokli_signature_SignaturePadJS$__setupSignaturePad__Lorg_scalajs_dom_Element__V($thiz, el) {
  var canvas = el.querySelector(".signature-canvas");
  $m_sc_StringOps$();
  var x = el.getAttribute("data-min-width");
  var this$3 = $m_sc_StringParsers$();
  var this$5 = (this$3.afR(x) ? new $c_s_Some($m_jl_Double$().fS(x)) : $m_s_None$());
  var minWidth = (+(this$5.c() ? 1.0 : this$5.h()));
  $m_sc_StringOps$();
  var x$1 = el.getAttribute("data-max-width");
  var this$8 = $m_sc_StringParsers$();
  var this$10 = (this$8.afR(x$1) ? new $c_s_Some($m_jl_Double$().fS(x$1)) : $m_s_None$());
  var maxWidth = (+(this$10.c() ? 3.0 : this$10.h()));
  var penColor = el.getAttribute("data-pen-color");
  $m_sc_StringOps$();
  var x$2 = el.getAttribute("data-width");
  var this$13 = $m_sc_StringParsers$().fs(x$2);
  var cssWidth = ((this$13.c() ? 300 : this$13.h()) | 0);
  $m_sc_StringOps$();
  var x$3 = el.getAttribute("data-height");
  var this$16 = $m_sc_StringParsers$().fs(x$3);
  var cssHeight = ((this$16.c() ? 150 : this$16.h()) | 0);
  canvas.style.width = (cssWidth + "px");
  canvas.style.height = (cssHeight + "px");
  $p_Lcom_papasofokli_signature_SignaturePadJS$__waitForLayoutAndInit$1__Lorg_scalajs_dom_HTMLCanvasElement__D__D__T__Lorg_scalajs_dom_Element__V($thiz, canvas, minWidth, maxWidth, penColor, el);
}
function $p_Lcom_papasofokli_signature_SignaturePadJS$__resizeCanvas__Lorg_scalajs_dom_HTMLCanvasElement__V($thiz, canvas) {
  var a = (+window.devicePixelRatio);
  var ratio = (+Math.max(a, 1.0));
  var rect = canvas.getBoundingClientRect();
  canvas.width = $doubleToInt(((+rect.width) * ratio));
  canvas.height = $doubleToInt(((+rect.height) * ratio));
  var ctx = canvas.getContext("2d");
  ctx.scale(ratio, ratio);
}
function $p_Lcom_papasofokli_signature_SignaturePadJS$__getPad__T__s_Option($thiz, id) {
  var el = document.getElementById(id);
  if ((el !== null)) {
    var pad = el.signaturePadInstance;
    return (((pad !== (void 0)) && (pad !== null)) ? new $c_s_Some(pad) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
}
function $p_Lcom_papasofokli_signature_SignaturePadJS$__waitForLayoutAndInit$1__Lorg_scalajs_dom_HTMLCanvasElement__D__D__T__Lorg_scalajs_dom_Element__V($thiz, canvas$1, minWidth$1, maxWidth$1, penColor$1, el$1) {
  var rect = canvas$1.getBoundingClientRect();
  if ((((+rect.width) === 0.0) || ((+rect.height) === 0.0))) {
    window.requestAnimationFrame(((_$1$3) => {
      $p_Lcom_papasofokli_signature_SignaturePadJS$__waitForLayoutAndInit$1__Lorg_scalajs_dom_HTMLCanvasElement__D__D__T__Lorg_scalajs_dom_Element__V($thiz, canvas$1, minWidth$1, maxWidth$1, penColor$1, el$1);
    }));
  } else {
    $p_Lcom_papasofokli_signature_SignaturePadJS$__resizeCanvas__Lorg_scalajs_dom_HTMLCanvasElement__V($thiz, canvas$1);
    var options = ({
      "minWidth": minWidth$1,
      "maxWidth": maxWidth$1,
      "penColor": penColor$1,
      "velocityFilterWeight": 0.7
    });
    var pad = new $i_signature$005fpad.default(canvas$1, options);
    el$1.signaturePadInstance = pad;
    window.addEventListener("resize", ((_$2$2) => {
      if ((!(!(!pad.isEmpty())))) {
        pad.clear();
      }
      $p_Lcom_papasofokli_signature_SignaturePadJS$__resizeCanvas__Lorg_scalajs_dom_HTMLCanvasElement__V($thiz, canvas$1);
    }));
  }
}
/** @constructor */
function $c_Lcom_papasofokli_signature_SignaturePadJS$() {
}
$p = $c_Lcom_papasofokli_signature_SignaturePadJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_signature_SignaturePadJS$;
/** @constructor */
function $h_Lcom_papasofokli_signature_SignaturePadJS$() {
}
$h_Lcom_papasofokli_signature_SignaturePadJS$.prototype = $p;
$p.co = (function() {
  var canvases = document.querySelectorAll(".a9387cc6-d2a7-42c8-89a5-1ab6e5bd174d");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(canvases);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    matchResult1: {
      if ((x0 !== null)) {
        x0.classList.remove("a9387cc6-d2a7-42c8-89a5-1ab6e5bd174d");
        $p_Lcom_papasofokli_signature_SignaturePadJS$__setupSignaturePad__Lorg_scalajs_dom_Element__V(this, x0);
        break matchResult1;
      }
      if ((x0 === null)) {
        break matchResult1;
      }
      throw new $c_s_MatchError(x0);
    }
  }
});
$p.avr = (function(id) {
  var this$1 = $p_Lcom_papasofokli_signature_SignaturePadJS$__getPad__T__s_Option(this, id);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    return (!(!x0.isEmpty()));
  } else {
    return false;
  }
});
$p.ayD = (function(id) {
  var this$1 = $p_Lcom_papasofokli_signature_SignaturePadJS$__getPad__T__s_Option(this, id);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some(x0.toDataURL("image/png"));
  }
});
$p.and = (function(id) {
  var this$1 = $p_Lcom_papasofokli_signature_SignaturePadJS$__getPad__T__s_Option(this, id);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    x0.clear();
  }
});
var $d_Lcom_papasofokli_signature_SignaturePadJS$ = new $TypeData().i($c_Lcom_papasofokli_signature_SignaturePadJS$, "com.papasofokli.signature.SignaturePadJS$", ({
  rz: 1
}));
var $n_Lcom_papasofokli_signature_SignaturePadJS$;
function $m_Lcom_papasofokli_signature_SignaturePadJS$() {
  if ((!$n_Lcom_papasofokli_signature_SignaturePadJS$)) {
    $n_Lcom_papasofokli_signature_SignaturePadJS$ = new $c_Lcom_papasofokli_signature_SignaturePadJS$();
  }
  return $n_Lcom_papasofokli_signature_SignaturePadJS$;
}
function $f_Lcom_papasofokli_sortable_SortableConnectedListsT__$init$__V($thiz) {
  $thiz.Ot = "not-initialized-sortable-connected-lists";
  $thiz.Yk = "data-left-list-items-function-id";
  $thiz.Yn = "data-right-list-items-function-id";
  $thiz.Ym = "data-left-list-update-function-id";
  $thiz.Yp = "data-right-list-update-function-id";
  $thiz.Yl = "radiant-sortable-left-";
  $thiz.Yo = "radiant-sortable-right-";
  $thiz.Yq = "data-setup-function-id";
}
function $p_Lcom_papasofokli_svg_SVGController__timeDifferenceInSec__D($thiz) {
  return (((+Date.now()) - $p_Lcom_papasofokli_svg_SVGController__loadedIn__D($thiz)) / 1000.0);
}
function $p_Lcom_papasofokli_svg_SVGController__loadedIn__D($thiz) {
  if ((!$thiz.a5v)) {
    $thiz.a5u = $thiz.Fm.aw2();
    $thiz.a5v = true;
  }
  return $thiz.a5u;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_SVGController(divId, interiorComponents, height, widthO, executionContext) {
  this.a5t = null;
  this.Fm = null;
  this.a5u = 0.0;
  this.a5v = false;
  this.a5t = executionContext;
  this.Fm = new $c_Lcom_papasofokli_svg_api_Svg(divId, interiorComponents.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.di()))), height, widthO);
}
$p = $c_Lcom_papasofokli_svg_SVGController.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_SVGController;
/** @constructor */
function $h_Lcom_papasofokli_svg_SVGController() {
}
$h_Lcom_papasofokli_svg_SVGController.prototype = $p;
$p.E6 = (function() {
  return this.Fm.E6();
});
$p.gN = (function(h) {
  this.Fm.gN(h);
});
$p.M5 = (function(component) {
  return component.di().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((shape$2) => {
    var this$2 = this.Fm;
    var timeSec = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_svg_SVGController__timeDifferenceInSec__D(this)));
    return $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(shape$2, $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this$2), timeSec);
  })));
});
$p.ga = (function() {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_svg_SVGController__loadedIn__D(this))), this.a5t);
});
var $d_Lcom_papasofokli_svg_SVGController = new $TypeData().i($c_Lcom_papasofokli_svg_SVGController, "com.papasofokli.svg.SVGController", ({
  rH: 1
}));
function $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option($thiz) {
  return new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_papasofokli_svg_actions_ActionsShape__makeFunctions__V($thiz);
  })));
}
function $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element($thiz) {
  return document.getElementById($thiz.g9().g());
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__dragIfMovable__F__F__V($thiz, dx, dy) {
  if ($thiz.Eh()) {
    $thiz.E0($thiz.DV(), dx, dy);
  }
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__makeContextMenuFunction__V($thiz) {
  var this$1 = $thiz.DW();
  if ((!this$1.c())) {
    var x0 = this$1.h();
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.g9())).on("contextmenu", ((contextMenuFun$2) => ((_$1$2) => {
      $p_Lcom_papasofokli_svg_actions_ActionsShape__funContextMenuJQ$1__F0__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, contextMenuFun$2, _$1$2);
    }))(x0));
  }
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__makeHoverFun__V($thiz) {
  var this$1 = $thiz.Ep();
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var this$2 = $thiz.Eq();
    if ((!this$2.c())) {
      var x0$1 = this$2.h();
      var shapeJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.g9()));
      var funOverJQ = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((funOver$3) => ((event$3) => {
        funOver$3.cm(Math.fround((event$3.pageX | 0)), Math.fround((event$3.pageY | 0)));
      }))(x0));
      var funOutJQ = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((funOut$2) => ((_$2$3) => {
        funOut$2.aA();
      }))(x0$1));
      shapeJQ.hover($m_sjs_js_Any$().b3(funOverJQ), $m_sjs_js_Any$().b3(funOutJQ));
    }
  }
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__makeClickFun__V($thiz) {
  var this$1 = $thiz.DU();
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var shapeJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.g9()));
    shapeJQ.click(((fun$2) => ((_$3$3) => {
      $thiz.zU();
      fun$2.aA();
    }))(x0));
  }
}
function $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V($thiz) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + $thiz.g9()) + " animateTransform")).remove();
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__drag__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, event) {
  matchResult1: {
    var \u03b42$;
    var x1 = $m_Lcom_papasofokli_svg_actions_MousePositionParameters$().aut(Math.fround((event.pageX | 0)), Math.fround((event.pageY | 0)));
    if ((x1 !== null)) {
      Math.fround(x1.P());
      Math.fround(x1.V());
      var \u03b42$ = x1;
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var dx$2 = Math.fround(\u03b42$.P());
  var dy$2 = Math.fround(\u03b42$.V());
  if ((!$thiz.oN().c())) {
    $thiz.oN().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
      $p_Lcom_papasofokli_svg_actions_ActionsShape__dragIfMovable__F__F__V(_$4$3, dx$2, dy$2);
    })));
  } else {
    $p_Lcom_papasofokli_svg_actions_ActionsShape__dragIfMovable__F__F__V($thiz, dx$2, dy$2);
  }
  var this$3 = $thiz.zD();
  if ((!this$3.c())) {
    this$3.h().cm(dx$2, dy$2);
  }
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__start__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, event) {
  $m_Lcom_papasofokli_svg_actions_MousePositionParameters$().axe(Math.fround((event.pageX | 0)), Math.fround((event.pageY | 0)));
  if ((!$thiz.oN().c())) {
    $thiz.oN().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$3) => {
      $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V(_$6$3);
    })));
  } else {
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V($thiz);
  }
  var this$3 = $thiz.zB();
  if ((!this$3.c())) {
    this$3.h().aA();
  }
  $thiz.zU();
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__stop__V($thiz) {
  var this$1 = $thiz.zC();
  if ((!this$1.c())) {
    this$1.h().aA();
  }
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__dragSettings__Lcom_papasofokli_jquery_DraggableSettings($thiz) {
  return new ($a_Lcom_papasofokli_jquery_DraggableSettings())((function(ev$3, _$15$3) {
    $p_Lcom_papasofokli_svg_actions_ActionsShape__drag__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, ev$3);
  }), (function(ev$3$1, _$10$3) {
    $p_Lcom_papasofokli_svg_actions_ActionsShape__start__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, ev$3$1);
  }), (function(_$12$3, _$13$3) {
    $p_Lcom_papasofokli_svg_actions_ActionsShape__stop__V($thiz);
  }));
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__makeDragFunction__V($thiz) {
  var this$1 = $thiz.zB();
  var this$2 = (this$1.c() ? $thiz.zC() : this$1);
  var any = (this$2.c() ? $thiz.zD() : this$2);
  if ((!any.c())) {
    any.h();
    var shapeJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.g9()));
    shapeJQ.draggable($p_Lcom_papasofokli_svg_actions_ActionsShape__dragSettings__Lcom_papasofokli_jquery_DraggableSettings($thiz));
  }
}
function $f_Lcom_papasofokli_svg_actions_ActionsShape__makeFunctions__V($thiz) {
  $p_Lcom_papasofokli_svg_actions_ActionsShape__makeDragFunction__V($thiz);
  $p_Lcom_papasofokli_svg_actions_ActionsShape__makeClickFun__V($thiz);
  $p_Lcom_papasofokli_svg_actions_ActionsShape__makeHoverFun__V($thiz);
  $p_Lcom_papasofokli_svg_actions_ActionsShape__makeContextMenuFunction__V($thiz);
}
function $p_Lcom_papasofokli_svg_actions_ActionsShape__funContextMenuJQ$1__F0__Lcom_papasofokli_jquery_JQueryEventObject__V($thiz, contextMenuFun$1, event) {
  event.preventDefault();
  var this$2 = $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$();
  var f = (() => event);
  this$2.Ey((f().pageX | 0), (f().pageY | 0));
  contextMenuFun$1.aA();
}
function $is_Lcom_papasofokli_svg_actions_ActionsShape(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aT)));
}
function $isArrayOf_Lcom_papasofokli_svg_actions_ActionsShape(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aT)));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_actions_MousePositionParameters$() {
  this.Ko = 0.0;
  this.Kp = 0.0;
  this.Kq = 0.0;
  this.Kr = 0.0;
  this.Ko = 0.0;
  this.Kp = 0.0;
  this.Kq = 0.0;
  this.Kr = 0.0;
}
$p = $c_Lcom_papasofokli_svg_actions_MousePositionParameters$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_actions_MousePositionParameters$;
/** @constructor */
function $h_Lcom_papasofokli_svg_actions_MousePositionParameters$() {
}
$h_Lcom_papasofokli_svg_actions_MousePositionParameters$.prototype = $p;
$p.axe = (function(newPageX, newPageY) {
  this.Kq = newPageX;
  this.Kr = newPageY;
  this.Ko = 0.0;
  this.Kp = 0.0;
});
$p.aut = (function(newPageX, newPageY) {
  this.Ko = Math.fround((newPageX - this.Kq));
  this.Kp = Math.fround((newPageY - this.Kr));
  this.Kq = newPageX;
  this.Kr = newPageY;
  return new $c_T2(this.Ko, this.Kp);
});
var $d_Lcom_papasofokli_svg_actions_MousePositionParameters$ = new $TypeData().i($c_Lcom_papasofokli_svg_actions_MousePositionParameters$, "com.papasofokli.svg.actions.MousePositionParameters$", ({
  rI: 1
}));
var $n_Lcom_papasofokli_svg_actions_MousePositionParameters$;
function $m_Lcom_papasofokli_svg_actions_MousePositionParameters$() {
  if ((!$n_Lcom_papasofokli_svg_actions_MousePositionParameters$)) {
    $n_Lcom_papasofokli_svg_actions_MousePositionParameters$ = new $c_Lcom_papasofokli_svg_actions_MousePositionParameters$();
  }
  return $n_Lcom_papasofokli_svg_actions_MousePositionParameters$;
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__remove__V($thiz) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    x0.parentNode.removeChild(x0);
  }
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__isMouseOver__Z($thiz) {
  return (!(!(0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $thiz.g9())).is(":hover")));
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__makeFunctions__V($thiz) {
  var this$1 = $thiz.oT();
  if ((!this$1.c())) {
    this$1.h().aA();
  }
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__getAttribute__T__s_Option($thiz, attributeName) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    var attr = x0.getAttribute(attributeName);
    var this$2 = $m_s_Option$().Z(attr);
    if (this$2.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0$1 = this$2.h();
      var $x_1 = new $c_s_Some(new $c_T2(x0$1, $f_T__trim__T(x0$1)));
    }
    var this$9 = new $c_s_Option$WithFilter($x_1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        x$1$2.P();
        var trim$1 = x$1$2.V();
        $m_sc_StringOps$();
        return (trim$1 !== "");
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    var this$10 = this$9.y6;
    var p$1 = this$9.y7;
    var this$11 = ((this$10.c() || (!(!p$1.p(this$10.h())))) ? this$10 : $m_s_None$());
    if (this$11.c()) {
      return $m_s_None$();
    } else {
      var x0$2 = this$11.h();
      matchResult2: {
        var $x_2;
        if ((x0$2 !== null)) {
          x0$2.P();
          var $x_2 = x0$2.V();
          break matchResult2;
        }
        throw new $c_s_MatchError(x0$2);
      }
      return new $c_s_Some($x_2);
    }
  }
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__colorStyle__s_Option($thiz) {
  var this$1 = $thiz.oF();
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some(new $c_Lcom_papasofokli_util_StyleValue("fill", (((((((("rgb(" + x0.nE) + ", ") + x0.nD) + ", ") + x0.nC) + ", ") + x0.pn) + ")")));
  }
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__strokeStyle__s_Option($thiz) {
  var this$1 = $thiz.p0();
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some(new $c_Lcom_papasofokli_util_StyleValue("stroke", (((((((("rgb(" + x0.nE) + ", ") + x0.nD) + ", ") + x0.nC) + ", ") + x0.pn) + ")")));
  }
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option($thiz) {
  var this$1 = $thiz.oP();
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_AttributeValue("class", this$1.h())));
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__attributeValuesClassId__sci_Seq($thiz) {
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("id", $thiz.g9().g()), $m_sci_Nil$()).cY($thiz.oJ()).cY($thiz.oE()).cY($thiz.oG()).cY($p_Lcom_papasofokli_svg_api_GeneralShape__colorStyle__s_Option($thiz)).cY($p_Lcom_papasofokli_svg_api_GeneralShape__strokeStyle__s_Option($thiz));
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option($thiz, attributeName) {
  var this$1 = $p_Lcom_papasofokli_svg_api_GeneralShape__getAttribute__T__s_Option($thiz, attributeName);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    try {
      var $x_1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(x0)));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchResult1: {
        var $x_1;
        var x2 = $m_s_util_control_NonFatal$().dV(e$2);
        if ((!x2.c())) {
          var $x_1 = new $c_s_util_Failure(x2.h());
          break matchResult1;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
      }
    }
    return $x_1.mN();
  }
}
function $p_Lcom_papasofokli_svg_api_GeneralShape__allInteriorElements__F0__sci_Seq($thiz, animateAfterLoadInSec) {
  return $m_s_Option$().hi($thiz.p1()).cf().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$3) => {
    var p$2 = Math.fround(p$3);
    var this$2 = $thiz.oC();
    return (this$2.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight(p$2, Math.fround(this$2.h()), (+animateAfterLoadInSec.aA()))));
  }))).dt($thiz.oQ());
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element($thiz, parentSVGElement, animateAfterLoadInSec) {
  var elementToBeAdded = $m_Lcom_papasofokli_svg_api_GeneralShape$().agv($thiz.oZ(), $thiz.oV());
  if ((!parentSVGElement.c())) {
    var x0 = parentSVGElement.h();
    x0.appendChild(elementToBeAdded);
  }
  $p_Lcom_papasofokli_svg_api_GeneralShape__allInteriorElements__F0__sci_Seq($thiz, animateAfterLoadInSec).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(_$2$2, new $c_s_Some(elementToBeAdded), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0))))));
  $p_Lcom_papasofokli_svg_api_GeneralShape__attributeValuesClassId__sci_Seq($thiz).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
    _$3$3.ds(elementToBeAdded);
  })));
  $p_Lcom_papasofokli_svg_api_GeneralShape__makeFunctions__V($thiz);
  return elementToBeAdded;
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__addClass__T__V($thiz, className) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    x0.classList.add(className);
  }
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__removeClass__T__V($thiz, className) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    x0.classList.remove(className);
  }
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V($thiz) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    x0.parentNode.appendChild(x0);
  }
}
function $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option($thiz) {
  return $m_s_Option$().Z(document.getElementById($thiz.g9().g()));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_GeneralShape$() {
}
$p = $c_Lcom_papasofokli_svg_api_GeneralShape$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_GeneralShape$;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_GeneralShape$() {
}
$h_Lcom_papasofokli_svg_api_GeneralShape$.prototype = $p;
$p.agv = (function(shapeHtml, namespaceURI) {
  if (namespaceURI.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = namespaceURI.h();
    var this$2 = new $c_s_Some(document.createElementNS(x0, shapeHtml));
  }
  return (this$2.c() ? document.createElement(shapeHtml) : this$2.h());
});
var $d_Lcom_papasofokli_svg_api_GeneralShape$ = new $TypeData().i($c_Lcom_papasofokli_svg_api_GeneralShape$, "com.papasofokli.svg.api.GeneralShape$", ({
  rK: 1
}));
var $n_Lcom_papasofokli_svg_api_GeneralShape$;
function $m_Lcom_papasofokli_svg_api_GeneralShape$() {
  if ((!$n_Lcom_papasofokli_svg_api_GeneralShape$)) {
    $n_Lcom_papasofokli_svg_api_GeneralShape$ = new $c_Lcom_papasofokli_svg_api_GeneralShape$();
  }
  return $n_Lcom_papasofokli_svg_api_GeneralShape$;
}
function $f_Lcom_papasofokli_svg_api_HyperLink__attributeValues__sci_Seq($thiz) {
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("href", $thiz.ahH()), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("class", "text-decoration-none"), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("target", "_blank"), $m_sci_Nil$())));
}
function $p_Lcom_papasofokli_svg_api_TextSizeMeasure$__stripInteriorElementsFromProperties__sci_Seq__sci_Seq($thiz, interiorElements) {
  return interiorElements.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 instanceof $c_Lcom_papasofokli_svg_api_ForeignHyperLink)) {
      var x25 = x$1$2.Bq;
      var x26 = x$1$2.Br;
      if (((x25 !== null) && (x26 !== null))) {
        return $p_Lcom_papasofokli_svg_api_TextSizeMeasure$__stripInteriorElementsFromProperties__sci_Seq__sci_Seq($thiz, x26);
      }
    }
    if ((x$1$2 instanceof $c_Lcom_papasofokli_svg_api_ForeignSpan)) {
      matchResult6: {
        var $x_1;
        var x11 = x$1$2.Fw;
        if ((x11 instanceof $c_Lcom_papasofokli_util_CountryFlagIcon)) {
          var $x_1 = new $c_Lcom_papasofokli_util_CountryFlagIcon("cy", "");
          break matchResult6;
        }
        if ((x11 instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon)) {
          var $x_1 = new $c_Lcom_papasofokli_util_GenderSymbolIcon("fas fa-mars", new $c_s_Some(new $c_Lcom_papasofokli_planning_SvgColor(51, 152, 219, 1.0)), "");
          break matchResult6;
        }
        if ((x11 instanceof $c_Lcom_papasofokli_util_IconUI)) {
          var $x_1 = $m_Lcom_papasofokli_util_IconUI$().t6;
          break matchResult6;
        }
        if ((x11 instanceof $c_Lcom_papasofokli_util_AttachmentBoxIcon)) {
          var $x_1 = $m_Lcom_papasofokli_util_IconUI$().t6;
          break matchResult6;
        }
        if ((x11 instanceof $c_Lcom_papasofokli_util_SpanTextContainer)) {
          var $x_1 = x11;
          break matchResult6;
        }
        throw new $c_s_MatchError(x11);
      }
      return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_svg_api_ForeignSpan($x_1, x$1$2.Fu, x$1$2.Fv, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), x$1$2.Bt), $m_sci_Nil$());
    }
    if ((x$1$2 !== null)) {
      return new $c_sci_$colon$colon(x$1$2, $m_sci_Nil$());
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
function $p_Lcom_papasofokli_svg_api_TextSizeMeasure$__stripForeignObjectFromProperties__Lcom_papasofokli_svg_api_ForeignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer($thiz, foreignObjectContainer) {
  return new $c_Lcom_papasofokli_svg_api_ForeignObjectContainer(0.0, 0.0, $p_Lcom_papasofokli_svg_api_TextSizeMeasure$__stripInteriorElementsFromProperties__sci_Seq__sci_Seq($thiz, foreignObjectContainer.nP), foreignObjectContainer.sU, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $thiz.Qa, $m_s_None$(), $m_s_None$(), $m_s_None$(), false);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_TextSizeMeasure$() {
  this.xI = null;
  this.FB = null;
  this.Qa = null;
  $n_Lcom_papasofokli_svg_api_TextSizeMeasure$ = this;
  this.xI = $m_s_Option$().Z($m_Lcom_papasofokli_svg_api_GeneralShape$().agv("svg", new $c_s_Some("http://www.w3.org/2000/svg")));
  var this$3 = this.xI;
  if ((!this$3.c())) {
    var x0 = this$3.h();
    new $c_Lcom_papasofokli_util_AttributeValue("class", "secret-element").ds(x0);
    document.body.appendChild(x0);
  }
  this.FB = $m_scm_Map$().e4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
  this.Qa = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
}
$p = $c_Lcom_papasofokli_svg_api_TextSizeMeasure$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_TextSizeMeasure$;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_TextSizeMeasure$() {
}
$h_Lcom_papasofokli_svg_api_TextSizeMeasure$.prototype = $p;
$p.aur = (function(textSVG) {
  var clonned = new $c_Lcom_papasofokli_svg_api_TextSVG(textSVG.xD, textSVG.xG, 0.0, 0.0, textSVG.xH, textSVG.xE, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), this.Qa, $m_s_None$(), $m_s_None$(), $m_s_None$(), false, textSVG.xC, textSVG.xF);
  var lengthO = this.FB.b9(clonned);
  if ((lengthO instanceof $c_s_Some)) {
    return Math.fround(lengthO.bg);
  }
  if (($m_s_None$() === lengthO)) {
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(clonned, this.xI, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)));
    var element = $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(clonned, this.xI, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)));
    var length$2 = Math.fround(element.getComputedTextLength());
    var this$3 = this.xI;
    if ((!this$3.c())) {
      var x0 = this$3.h();
      x0.innerHTML = "";
    }
    this.FB.aD(new $c_T2(clonned, length$2));
    return length$2;
  }
  throw new $c_s_MatchError(lengthO);
});
$p.ahr = (function(foreignObjectContainer) {
  var clonned = $p_Lcom_papasofokli_svg_api_TextSizeMeasure$__stripForeignObjectFromProperties__Lcom_papasofokli_svg_api_ForeignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this, foreignObjectContainer);
  var lengthO = this.FB.b9(clonned);
  if ((lengthO instanceof $c_s_Some)) {
    return Math.fround(lengthO.bg);
  }
  if (($m_s_None$() === lengthO)) {
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(clonned, this.xI, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)));
    var length$2 = clonned.ake();
    var this$2 = this.xI;
    if ((!this$2.c())) {
      var x0 = this$2.h();
      x0.innerHTML = "";
    }
    this.FB.aD(new $c_T2(clonned, length$2));
    return length$2;
  }
  throw new $c_s_MatchError(lengthO);
});
var $d_Lcom_papasofokli_svg_api_TextSizeMeasure$ = new $TypeData().i($c_Lcom_papasofokli_svg_api_TextSizeMeasure$, "com.papasofokli.svg.api.TextSizeMeasure$", ({
  rN: 1
}));
var $n_Lcom_papasofokli_svg_api_TextSizeMeasure$;
function $m_Lcom_papasofokli_svg_api_TextSizeMeasure$() {
  if ((!$n_Lcom_papasofokli_svg_api_TextSizeMeasure$)) {
    $n_Lcom_papasofokli_svg_api_TextSizeMeasure$ = new $c_Lcom_papasofokli_svg_api_TextSizeMeasure$();
  }
  return $n_Lcom_papasofokli_svg_api_TextSizeMeasure$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_LineComponent$() {
}
$p = $c_Lcom_papasofokli_svg_components_LineComponent$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_LineComponent$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_LineComponent$() {
}
$h_Lcom_papasofokli_svg_components_LineComponent$.prototype = $p;
$p.DK = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_components_LineComponent$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_LineComponent$, "com.papasofokli.svg.components.LineComponent$", ({
  rV: 1
}));
var $n_Lcom_papasofokli_svg_components_LineComponent$;
function $m_Lcom_papasofokli_svg_components_LineComponent$() {
  if ((!$n_Lcom_papasofokli_svg_components_LineComponent$)) {
    $n_Lcom_papasofokli_svg_components_LineComponent$ = new $c_Lcom_papasofokli_svg_components_LineComponent$();
  }
  return $n_Lcom_papasofokli_svg_components_LineComponent$;
}
function $f_Lcom_papasofokli_svg_components_RectangleBounds__refreshBound__V($thiz) {
  var newX1$1 = $thiz.E7();
  var newX2$1 = $thiz.MN();
  var newY1$1 = $thiz.E8();
  var newY2$1 = $thiz.MO();
  $thiz.zR().aiT(newX1$1, newY1$1, newX2$1, newY2$1);
  $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V($thiz.zR());
}
function $f_Lcom_papasofokli_svg_components_RectangleBounds__com$papasofokli$svg$components$RectangleBounds$$dragStartFunction__s_Option($thiz) {
  return $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V($thiz.Ew());
    $thiz.Ew().oN().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
      $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V(_$1$3);
    })));
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V($thiz.zR());
  })));
}
function $f_Lcom_papasofokli_svg_components_RectangleBounds__lineSVG__Lcom_papasofokli_svg_api_LineSVG($thiz) {
  var initialClassName$1 = new $c_s_Some($thiz.gH());
  var initialX1$1 = $thiz.MW();
  var initialX2$1 = $thiz.zL();
  var initialY1$1 = $thiz.Ef();
  var initialY2$1 = $thiz.MX();
  var dragStartFun$1 = $thiz.Mo();
  var draggingFun$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $thiz.Na(Math.fround(v1$2), Math.fround(v2$2));
  })));
  var dragStopFun$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $thiz.Mw().p($thiz.Ew());
  })));
  var onHover$1 = $thiz.Nc();
  return new $c_Lcom_papasofokli_svg_api_LineSVG(initialX1$1, initialY1$1, initialX2$1, initialY2$1, initialClassName$1, $m_s_Option$().Z(0.5), dragStartFun$1, dragStopFun$1, draggingFun$1, $m_s_None$(), $m_Lcom_papasofokli_svg_api_LineSVG$().alL(), onHover$1, $m_s_None$(), $m_s_None$(), true, $m_s_None$(), $m_ju_UUID$().aW());
}
function $f_Lcom_papasofokli_svg_components_SvgComponent__appendOnTop__V($thiz) {
  $thiz.di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V(_$1$3);
  })));
}
function $f_Lcom_papasofokli_svg_components_SvgComponent__removeComponent__V($thiz) {
  $thiz.di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__remove__V(_$2$3);
  })));
}
function $f_Lcom_papasofokli_svg_components_SvgComponent__isMouseOver__Z($thiz) {
  return $thiz.di().fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => $f_Lcom_papasofokli_svg_api_GeneralShape__isMouseOver__Z(_$3$2))));
}
function $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V($thiz, cl) {
  $thiz.di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__addClass__T__V(_$4$3, cl);
  })));
}
function $f_Lcom_papasofokli_svg_components_SvgComponent__removeClass__T__V($thiz, cl) {
  $thiz.di().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__removeClass__T__V(_$5$3, cl);
  })));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_package$() {
}
$p = $c_Lcom_papasofokli_svg_components_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_package$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_package$() {
}
$h_Lcom_papasofokli_svg_components_package$.prototype = $p;
$p.asH = (function(hoverFunction1, hoverFunction2) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    var x = Math.fround(v1$2);
    var y = Math.fround(v2$2);
    hoverFunction1.cm(x, y);
    hoverFunction2.cm(x, y);
  }));
});
$p.asI = (function(mouseOutFunction1, mouseOutFunction2) {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    mouseOutFunction1.aA();
    mouseOutFunction2.aA();
  }));
});
var $d_Lcom_papasofokli_svg_components_package$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_package$, "com.papasofokli.svg.components.package$", ({
  rZ: 1
}));
var $n_Lcom_papasofokli_svg_components_package$;
function $m_Lcom_papasofokli_svg_components_package$() {
  if ((!$n_Lcom_papasofokli_svg_components_package$)) {
    $n_Lcom_papasofokli_svg_components_package$ = new $c_Lcom_papasofokli_svg_components_package$();
  }
  return $n_Lcom_papasofokli_svg_components_package$;
}
function $f_Lcom_papasofokli_svg_timeline_TickInterval__apply__sjs_js_Date__sjs_js_Date__sci_Seq($thiz, startDate, endDate) {
  return $p_Lcom_papasofokli_svg_timeline_TickInterval__makeDatesArray__sjs_js_Date__sjs_js_Date__sci_LazyList($thiz, $thiz.oL(startDate), endDate);
}
function $f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z($thiz, startDate, endDate, getPosition) {
  return (!$m_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$().aj3($f_Lcom_papasofokli_svg_timeline_TickInterval__apply__sjs_js_Date__sjs_js_Date__sci_Seq($thiz, startDate, endDate)).fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var sDate = x$1$2.P();
      var eDate = x$1$2.V();
      var xComp = Math.fround(getPosition.p(sDate));
      var width = Math.fround((Math.fround(getPosition.p(eDate)) - xComp));
      var textToBeShown = $thiz.kJ(sDate);
      return (!new $c_Lcom_papasofokli_svg_components_TextComponent($thiz.mB(), textToBeShown, 0.0, 0.0, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), new $c_s_Some(0.5), $m_Lcom_papasofokli_svg_components_TextComponent$().hb(), true, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()).ahN(width));
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
}
function $p_Lcom_papasofokli_svg_timeline_TickInterval__makeDatesArray__sjs_js_Date__sjs_js_Date__sci_LazyList($thiz, date, endDate) {
  var nextDate = $thiz.oW(date);
  return (((+nextDate.getTime()) > (+endDate.getTime())) ? $m_sci_LazyList$().E4($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [date, nextDate])) : ($m_sci_LazyList$(), $m_sci_LazyList$Deferrer$().alJ(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_svg_timeline_TickInterval__makeDatesArray__sjs_js_Date__sjs_js_Date__sci_LazyList($thiz, nextDate, endDate))), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => date)))));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$() {
}
$h_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$.prototype = $p;
$p.aj3 = (function(seq) {
  try {
    var $x_1 = new $c_s_util_Success(seq.zX(new $c_T2(seq.W(), seq.at(1)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$2, x$2$2) => {
      var x21 = new $c_T2(x$1$2, x$2$2);
      var x22 = x21.L3;
      if ((x22 !== null)) {
        return new $c_T2(x22.V(), x21.L4);
      }
      throw new $c_s_MatchError(x21);
    }))).bo(2));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  return $x_1.Uu(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$())));
});
var $d_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$, "com.papasofokli.svg.timeline.TimeLineSVGHelper$", ({
  s9: 1
}));
var $n_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$;
function $m_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$)) {
    $n_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$ = new $c_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$();
  }
  return $n_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$;
}
function $f_Lcom_papasofokli_tiles_TilesBoardT__$init$__V($thiz) {
  $thiz.Qi = "not-initialized-tiles-board";
  $thiz.Ql = "tile-boxes-items";
  $thiz.G7 = "tile-boxes-outer";
  $thiz.Qh = "tile-boxes-outer-not-initialized";
  $thiz.a7Z = "container-fluid";
  $thiz.a80 = "tile-boxes";
  $thiz.a82 = "tile-id";
  $thiz.a81 = "tile-column";
  $thiz.Qk = "split-tile-row";
  $thiz.G9 = "section-div";
  $thiz.Qj = "row-div";
  $thiz.G8 = "row";
}
/** @constructor */
function $c_Lcom_papasofokli_toast_ToastHelper$() {
  this.a83 = null;
  this.a85 = null;
  this.a84 = null;
  this.a86 = null;
  this.Qn = null;
  this.Qm = null;
  this.a83 = "toast";
  this.a85 = "toast-header";
  this.a84 = "toast-body";
  this.a86 = "bg-warning";
  this.Qn = "data-bs-delay";
  this.Qm = "data-bs-autohide";
}
$p = $c_Lcom_papasofokli_toast_ToastHelper$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_toast_ToastHelper$;
/** @constructor */
function $h_Lcom_papasofokli_toast_ToastHelper$() {
}
$h_Lcom_papasofokli_toast_ToastHelper$.prototype = $p;
var $d_Lcom_papasofokli_toast_ToastHelper$ = new $TypeData().i($c_Lcom_papasofokli_toast_ToastHelper$, "com.papasofokli.toast.ToastHelper$", ({
  sd: 1
}));
var $n_Lcom_papasofokli_toast_ToastHelper$;
function $m_Lcom_papasofokli_toast_ToastHelper$() {
  if ((!$n_Lcom_papasofokli_toast_ToastHelper$)) {
    $n_Lcom_papasofokli_toast_ToastHelper$ = new $c_Lcom_papasofokli_toast_ToastHelper$();
  }
  return $n_Lcom_papasofokli_toast_ToastHelper$;
}
function $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour($thiz) {
  if ((!$thiz.a88)) {
    $thiz.a87 = $i_intro$002ejs.default.tour();
    $thiz.a88 = true;
  }
  return $thiz.a87;
}
function $p_Lcom_papasofokli_tour_TourInitializer$__beforeChange__Lorg_scalajs_dom_Element__V($thiz, element) {
  if ((!(!element.classList.contains("dropdown")))) {
    var a = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element.getElementsByTagName("a")));
    var ul = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(element.getElementsByTagName("ul")));
    if ((!a.c())) {
      var x0 = a.h();
      x0.setAttribute("aria-expanded", "true");
    }
    if ((!ul.c())) {
      var x0$1 = ul.h();
      x0$1.classList.add("show");
    }
  }
}
function $p_Lcom_papasofokli_tour_TourInitializer$__afterChange__Lorg_scalajs_dom_Element__V($thiz, element) {
  if (((!$thiz.Kv) && $f_T__isBlank__Z(element.id))) {
    $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour($thiz).nextStep();
  }
  $thiz.Kv = false;
  window.setTimeout((() => {
    $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour($thiz).refresh();
  }), 50.0);
}
function $p_Lcom_papasofokli_tour_TourInitializer$__onStart__V($thiz) {
  $thiz.Kv = true;
}
/** @constructor */
function $c_Lcom_papasofokli_tour_TourInitializer$() {
  this.a87 = null;
  this.a88 = false;
  this.Kv = false;
  this.Kv = true;
}
$p = $c_Lcom_papasofokli_tour_TourInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_tour_TourInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_tour_TourInitializer$() {
}
$h_Lcom_papasofokli_tour_TourInitializer$.prototype = $p;
$p.ava = (function(x$1) {
  var tour = (0, $m_Lcom_papasofokli_jquery_package$().I)(".not-initialized-tour");
  tour.removeClass("not-initialized-tour").each(((this$2) => (function() {
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(this.id, "", x$1).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((response$2) => $m_sjs_js_Thenable$Implicits$().bH(response$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      var options = JSON.parse(text$2);
      $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour(this$2).onbeforechange(((_$3$2) => {
        $p_Lcom_papasofokli_tour_TourInitializer$__beforeChange__Lorg_scalajs_dom_Element__V(this$2, _$3$2);
      }));
      $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour(this$2).onafterchange(((_$4$2) => {
        $p_Lcom_papasofokli_tour_TourInitializer$__afterChange__Lorg_scalajs_dom_Element__V(this$2, _$4$2);
      }));
      $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour(this$2).onstart(((_$5$2) => {
        $p_Lcom_papasofokli_tour_TourInitializer$__onStart__V(this$2);
      }));
      $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour(this$2).setOptions(options);
      return (0, $m_Lcom_papasofokli_jquery_package$().I)(this).on("click touchstart", $m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $p_Lcom_papasofokli_tour_TourInitializer$__intro__Lcom_papasofokli_tour_IntroJsTour(this$2).start();
      }))));
    })), x$1))), x$1);
  }))(this));
});
var $d_Lcom_papasofokli_tour_TourInitializer$ = new $TypeData().i($c_Lcom_papasofokli_tour_TourInitializer$, "com.papasofokli.tour.TourInitializer$", ({
  se: 1
}));
var $n_Lcom_papasofokli_tour_TourInitializer$;
function $m_Lcom_papasofokli_tour_TourInitializer$() {
  if ((!$n_Lcom_papasofokli_tour_TourInitializer$)) {
    $n_Lcom_papasofokli_tour_TourInitializer$ = new $c_Lcom_papasofokli_tour_TourInitializer$();
  }
  return $n_Lcom_papasofokli_tour_TourInitializer$;
}
function $p_Lcom_papasofokli_tree_DualListBoxJs$__connectedLists__Lcom_papasofokli_sortable_SortableConnectedListsData__Lorg_scalajs_dom_HTMLSelectElement($thiz, data) {
  return $m_Lscalatags_JsDom$all$().ajE().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("form-control dual_select d-none min-height-500", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n("selectList", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().awl(), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), data.Fk.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((datum$2) => {
    var $x_4 = $m_Lscalatags_JsDom$all$().Ne();
    var $x_3 = $m_Lscalatags_JsDom$all$().NG().n(("" + datum$2.iV), $m_Lscalatags_JsDom$all$().s);
    var $x_2 = $m_Lscalatags_JsDom$all$().bE();
    var $x_1 = datum$2;
    return $x_4.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_3, $x_2.n(("" + $s_RTLong__toString__I__I__T($x_1.h9, $x_1.ha)), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + datum$2.iV)))]));
  }))), $m_s_$less$colon$less$().b0), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), data.Fl.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((datum$2$1) => {
    var $x_9 = $m_Lscalatags_JsDom$all$().Ne();
    var $x_8 = $m_Lscalatags_JsDom$all$().ajF();
    var $x_7 = $m_Lscalatags_JsDom$all$().NG().n(("" + datum$2$1.iV), $m_Lscalatags_JsDom$all$().s);
    var $x_6 = $m_Lscalatags_JsDom$all$().bE();
    var $x_5 = datum$2$1;
    return $x_9.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_8, $x_7, $x_6.n(("" + $s_RTLong__toString__I__I__T($x_5.h9, $x_5.ha)), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + datum$2$1.iV)))]));
  }))), $m_s_$less$colon$less$().b0)])).aB();
}
/** @constructor */
function $c_Lcom_papasofokli_tree_DualListBoxJs$() {
}
$p = $c_Lcom_papasofokli_tree_DualListBoxJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_tree_DualListBoxJs$;
/** @constructor */
function $h_Lcom_papasofokli_tree_DualListBoxJs$() {
}
$h_Lcom_papasofokli_tree_DualListBoxJs$.prototype = $p;
$p.b7 = (function(ec) {
  $m_Lcom_papasofokli_util_package$().fo("7c61e596-bdfa-4dd2-be69-65f839a494e2").each(((this$1) => (function() {
    var leftListItemsFunctionId = this.getAttribute($m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$().Yk);
    var rightListItemsFunctionId = this.getAttribute($m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$().Yn);
    var leftListUpdateFunctionId = this.getAttribute($m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$().Ym);
    var rightListUpdateFunctionId = this.getAttribute($m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$().Yp);
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(leftListItemsFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp1$2) => $m_sjs_js_Thenable$Implicits$().bH(resp1$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text1$2) => {
      var leftListItems = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text1$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_sortable_SortableElement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
      return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(rightListItemsFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp2$2) => $m_sjs_js_Thenable$Implicits$().bH(resp2$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text2$2) => {
        var rightListItems = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text2$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_sortable_SortableElement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())));
        var data = new $c_Lcom_papasofokli_sortable_SortableConnectedListsData(leftListItems, rightListItems);
        (0, $m_Lcom_papasofokli_jquery_package$().I)(this).children().remove().end().append($p_Lcom_papasofokli_tree_DualListBoxJs$__connectedLists__Lcom_papasofokli_sortable_SortableConnectedListsData__Lorg_scalajs_dom_HTMLSelectElement(this$1, data));
        (0, $m_Lcom_papasofokli_jquery_package$().I)(this).children().first().bootstrapDualListbox();
        if (($m_sc_StringOps$(), (leftListUpdateFunctionId !== ""))) {
          var box1Jq = (0, $m_Lcom_papasofokli_jquery_package$().I)("#bootstrap-duallistbox-nonselected-list_ ");
          box1Jq.on("change", ((_$1$2) => {
            var childrenJq = (0, $m_Lcom_papasofokli_jquery_package$().I)("#selectList option:selected").map((function() {
              return this.getAttribute("id");
            }));
            var array = childrenJq.toArray();
            var ids = $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array)).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => $dp_toString__T(x$2))));
            var this$26 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
            var id = $m_ju_UUID$().aO(rightListUpdateFunctionId);
            var $x_1 = $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            var this$24 = $m_Lupickle_default$();
            var data$1 = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, ids, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$24));
            return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$26, id.g(), data$1, ec);
          }));
          box1Jq.addClass("inherit-font-size");
          var box1Btn = (0, $m_Lcom_papasofokli_jquery_package$().I)(".moveall");
          box1Btn.attr("class", "btn moveall btn-primary fas fa-arrow-right");
          box1Btn.on("click", ((_$2$2) => {
            var childrenJq$1 = (0, $m_Lcom_papasofokli_jquery_package$().I)("#selectList option:selected").map((function() {
              return this.getAttribute("id");
            }));
            var array$1 = childrenJq$1.toArray();
            var ids$1 = $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$1)).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$1) => $dp_toString__T(x$2$1))));
            var this$38 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
            var id$1 = $m_ju_UUID$().aO(rightListUpdateFunctionId);
            var $x_2 = $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            var this$36 = $m_Lupickle_default$();
            var data$2 = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_2, ids$1, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$36));
            return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$38, id$1.g(), data$2, ec);
          }));
        }
        if (($m_sc_StringOps$(), (rightListUpdateFunctionId !== ""))) {
          var box2Jq = (0, $m_Lcom_papasofokli_jquery_package$().I)("#bootstrap-duallistbox-selected-list_ ");
          box2Jq.on("change", ((_$3$2) => {
            var childrenJq$2 = (0, $m_Lcom_papasofokli_jquery_package$().I)("#selectList option:selected").map((function() {
              return this.getAttribute("id");
            }));
            var array$2 = childrenJq$2.toArray();
            var ids$2 = $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$2)).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $dp_toString__T(x$2$2))));
            var this$50 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
            var id$2 = $m_ju_UUID$().aO(rightListUpdateFunctionId);
            var $x_3 = $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            var this$48 = $m_Lupickle_default$();
            var data$3 = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_3, ids$2, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$48));
            return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$50, id$2.g(), data$3, ec);
          }));
          box2Jq.addClass("inherit-font-size");
          var box2Btn = (0, $m_Lcom_papasofokli_jquery_package$().I)(".removeall");
          box2Btn.attr("class", "btn removeall btn-primary fas fa-arrow-left");
          return box2Btn.on("click", ((_$4$2) => {
            var childrenJq$3 = (0, $m_Lcom_papasofokli_jquery_package$().I)("#selectList option:selected").map((function() {
              return this.getAttribute("id");
            }));
            var array$3 = childrenJq$3.toArray();
            var ids$3 = $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$3)).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$3) => $dp_toString__T(x$2$3))));
            var this$62 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
            var id$3 = $m_ju_UUID$().aO(rightListUpdateFunctionId);
            var $x_4 = $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            $m_Lupickle_default$();
            var this$60 = $m_Lupickle_default$();
            var data$4 = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_4, ids$3, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$60));
            return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$62, id$3.g(), data$4, ec);
          }));
        } else {
          return (void 0);
        }
      })), ec))), ec);
    })), ec))), ec);
  }))(this));
});
var $d_Lcom_papasofokli_tree_DualListBoxJs$ = new $TypeData().i($c_Lcom_papasofokli_tree_DualListBoxJs$, "com.papasofokli.tree.DualListBoxJs$", ({
  sf: 1
}));
var $n_Lcom_papasofokli_tree_DualListBoxJs$;
function $m_Lcom_papasofokli_tree_DualListBoxJs$() {
  if ((!$n_Lcom_papasofokli_tree_DualListBoxJs$)) {
    $n_Lcom_papasofokli_tree_DualListBoxJs$ = new $c_Lcom_papasofokli_tree_DualListBoxJs$();
  }
  return $n_Lcom_papasofokli_tree_DualListBoxJs$;
}
function $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, id, data, executionContext) {
  return $thiz.c5(id, data, executionContext).agV(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((response$2) => (!(!response$2.ok)))), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((response$2$1) => $m_sjs_js_Thenable$Implicits$().bH(response$2$1.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    $m_Lcom_papasofokli_util_package$().Ud(text$3, executionContext);
  })), executionContext))), executionContext).hj(new $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2(), executionContext);
}
function $p_Lcom_papasofokli_util_AjaxCallFunctions$__fetchResponse__O__T__Lorg_scalajs_dom_File__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, id, uploadType, data, additionalSupportedTypes, executionContext) {
  var formData = new FormData();
  formData.append("file", data, data.name);
  additionalSupportedTypes.auq().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((typeStr$3) => {
    formData.append("types", ("" + typeStr$3));
  })));
  return $m_sjs_js_Thenable$Implicits$().bH(fetch(((("/upload/" + id) + "/") + uploadType), (() => {
    var formData$2 = null;
    formData$2 = formData;
    var this$2 = ({});
    this$2.method = "POST";
    this$2.body = formData$2;
    return this$2;
  })())).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
    var status = (!(!resp$2.ok));
    return new $c_T2(status, (status ? "" : ((data.name + " cannot be uploaded. ") + text$2)));
  })), executionContext))), executionContext);
}
/** @constructor */
function $c_Lcom_papasofokli_util_AjaxCallFunctions$() {
}
$p = $c_Lcom_papasofokli_util_AjaxCallFunctions$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_AjaxCallFunctions$;
/** @constructor */
function $h_Lcom_papasofokli_util_AjaxCallFunctions$() {
}
$h_Lcom_papasofokli_util_AjaxCallFunctions$.prototype = $p;
$p.c5 = (function(id, data, executionContext) {
  return $m_sjs_js_Thenable$Implicits$().bH(fetch(("/function/" + id), (() => {
    var data$1 = null;
    data$1 = data;
    var this$1 = ({});
    this$1.method = "POST";
    var x = data$1;
    this$1.body = ((x === (void 0)) ? "" : x);
    return this$1;
  })())).agV(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => (!(!resp$2.ok)))), executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2$1) => resp$2$1)), executionContext);
});
$p.ami = (function(id, uploadType, data, maxFileRequestAllow_$_lo, maxFileRequestAllow_$_hi, additionalSupportedTypes, executionContext) {
  var hi = (maxFileRequestAllow_$_hi >> 9);
  var lo$1 = ((hi >>> 22) | 0);
  var lo$2 = ((maxFileRequestAllow_$_lo + lo$1) | 0);
  var hi$1 = ((maxFileRequestAllow_$_hi + (((lo$2 >>> 0) < (maxFileRequestAllow_$_lo >>> 0)) | 0)) | 0);
  var lo$3 = (((lo$2 >>> 10) | 0) | (hi$1 << 22));
  var hi$2 = (hi$1 >> 10);
  var hi$3 = (hi$2 >> 9);
  var lo$5 = ((hi$3 >>> 22) | 0);
  var lo$6 = ((lo$3 + lo$5) | 0);
  var hi$4 = ((hi$2 + (((lo$6 >>> 0) < (lo$3 >>> 0)) | 0)) | 0);
  var lo$7 = (((lo$6 >>> 10) | 0) | (hi$4 << 22));
  var hi$5 = (hi$4 >> 10);
  var sizeMb = ($s_RTLong__toString__I__I__T(lo$7, hi$5) + "Mb");
  return $m_sjs_js_Thenable$Implicits$().bH(data.arrayBuffer()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arrayBuffer$2) => {
    var length = (arrayBuffer$2.byteLength | 0);
    var hi$6 = (length >> 31);
    if (((maxFileRequestAllow_$_hi === hi$6) ? ((maxFileRequestAllow_$_lo >>> 0) >= (length >>> 0)) : (maxFileRequestAllow_$_hi > hi$6))) {
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__fetchResponse__O__T__Lorg_scalajs_dom_File__Lcom_papasofokli_attachments_AdditionalSupportedFileTypes__s_concurrent_ExecutionContext__s_concurrent_Future(this, id, uploadType, data, additionalSupportedTypes, executionContext);
    } else {
      return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_T2(false, (((data.name + " cannot be uploaded. File size exceeded, must be smaller than ") + sizeMb) + ".")))), executionContext);
    }
  })), executionContext).hj(new $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4(data), executionContext);
});
$p.amh = (function(tableId, data, executionContext) {
  return $m_sjs_js_Thenable$Implicits$().bH(fetch((("/table/" + tableId) + "/rows"), (() => {
    var data$7 = null;
    data$7 = data;
    var this$1 = ({});
    this$1.method = "POST";
    this$1.body = data$7;
    return this$1;
  })())).hj(new $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6(), executionContext);
});
var $d_Lcom_papasofokli_util_AjaxCallFunctions$ = new $TypeData().i($c_Lcom_papasofokli_util_AjaxCallFunctions$, "com.papasofokli.util.AjaxCallFunctions$", ({
  sh: 1
}));
var $n_Lcom_papasofokli_util_AjaxCallFunctions$;
function $m_Lcom_papasofokli_util_AjaxCallFunctions$() {
  if ((!$n_Lcom_papasofokli_util_AjaxCallFunctions$)) {
    $n_Lcom_papasofokli_util_AjaxCallFunctions$ = new $c_Lcom_papasofokli_util_AjaxCallFunctions$();
  }
  return $n_Lcom_papasofokli_util_AjaxCallFunctions$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_CommonFunctionality$() {
}
$p = $c_Lcom_papasofokli_util_CommonFunctionality$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_CommonFunctionality$;
/** @constructor */
function $h_Lcom_papasofokli_util_CommonFunctionality$() {
}
$h_Lcom_papasofokli_util_CommonFunctionality$.prototype = $p;
$p.agf = (function(data, contextMenuFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$2) => {
    if (((data !== null) && (contextMenuFunctionId !== null))) {
      event$2.preventDefault();
      var this$2 = $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$();
      var f = (() => event$2);
      this$2.Ey((f().pageX | 0), (f().pageY | 0));
      return new $c_Lcom_papasofokli_util_MultipleEventHandler(100, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(contextMenuFunctionId).g(), data, ec);
      })));
    } else {
      return (void 0);
    }
  }));
});
var $d_Lcom_papasofokli_util_CommonFunctionality$ = new $TypeData().i($c_Lcom_papasofokli_util_CommonFunctionality$, "com.papasofokli.util.CommonFunctionality$", ({
  sm: 1
}));
var $n_Lcom_papasofokli_util_CommonFunctionality$;
function $m_Lcom_papasofokli_util_CommonFunctionality$() {
  if ((!$n_Lcom_papasofokli_util_CommonFunctionality$)) {
    $n_Lcom_papasofokli_util_CommonFunctionality$ = new $c_Lcom_papasofokli_util_CommonFunctionality$();
  }
  return $n_Lcom_papasofokli_util_CommonFunctionality$;
}
function $p_Lcom_papasofokli_util_DateUtilsJS$__pad$1__I__T($thiz, n) {
  return ((n < 10) ? ("0" + n) : ("" + n));
}
/** @constructor */
function $c_Lcom_papasofokli_util_DateUtilsJS$() {
}
$p = $c_Lcom_papasofokli_util_DateUtilsJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_DateUtilsJS$;
/** @constructor */
function $h_Lcom_papasofokli_util_DateUtilsJS$() {
}
$h_Lcom_papasofokli_util_DateUtilsJS$.prototype = $p;
$p.auw = (function(date) {
  var hours = (+date.getUTCHours());
  var minutes = (+date.getUTCMinutes());
  var hoursStr = ((hours < 10.0) ? ("0" + hours) : ("" + hours));
  var minutesStr = ((minutes < 10.0) ? ("0" + minutes) : ("" + minutes));
  return ((hoursStr + ":") + minutesStr);
});
$p.Mn = (function(date) {
  return new Date((+date.getTime()));
});
$p.aui = (function(date) {
  var beginOfMonth = this.ML(date);
  beginOfMonth.setMonth(0.0);
  return beginOfMonth;
});
$p.IF = (function(date) {
  var cloned = this.Mn(date);
  cloned.setUTCHours(0.0, 0.0, 0.0, 0.0);
  return cloned;
});
$p.ML = (function(date) {
  var beginOfDay = this.IF(date);
  beginOfDay.setUTCDate(1.0);
  return beginOfDay;
});
$p.M6 = (function(date, daysToAdd) {
  var mills = (+date.getTime());
  var hi = (daysToAdd >> 31);
  var b0 = (65535 & daysToAdd);
  var b1 = ((daysToAdd >>> 16) | 0);
  var a0b0 = Math.imul(24, b0);
  var a0b1 = Math.imul(24, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(24, hi) + ((c1part >>> 16) | 0)) | 0);
  var b0$1 = (65535 & lo);
  var b1$1 = ((lo >>> 16) | 0);
  var a0b0$1 = Math.imul(60, b0$1);
  var a0b1$1 = Math.imul(60, b1$1);
  var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((Math.imul(60, hi$1) + ((c1part$1 >>> 16) | 0)) | 0);
  var b0$2 = (65535 & lo$1);
  var b1$2 = ((lo$1 >>> 16) | 0);
  var a0b0$2 = Math.imul(60, b0$2);
  var a0b1$2 = Math.imul(60, b1$2);
  var lo$2 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$3 = ((Math.imul(60, hi$2) + ((c1part$2 >>> 16) | 0)) | 0);
  var b0$3 = (65535 & lo$2);
  var b1$3 = ((lo$2 >>> 16) | 0);
  var a0b0$3 = Math.imul(1000, b0$3);
  var a0b1$3 = Math.imul(1000, b1$3);
  var lo$3 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$4 = ((Math.imul(1000, hi$3) + ((c1part$3 >>> 16) | 0)) | 0);
  return new Date((((4.294967296E9 * hi$4) + (lo$3 >>> 0.0)) + mills));
});
$p.M8 = (function(date, monthsToAdd) {
  var clonned = this.Mn(date);
  var newMonth = ((+clonned.getUTCMonth()) + monthsToAdd);
  clonned.setUTCDate(1.0);
  clonned.setUTCMonth(newMonth);
  var monthNumber = (+clonned.getUTCMonth());
  clonned.setUTCDate((+date.getUTCDate()));
  if (((+clonned.getUTCMonth()) !== monthNumber)) {
    clonned.setUTCDate(0.0);
  }
  return clonned;
});
$p.ame = (function(date, yearsToAdd) {
  return this.M8(date, Math.imul(12, yearsToAdd));
});
$p.MQ = (function(date) {
  return $m_sc_StringOps$().VF(date.toUTCString(), 3);
});
$p.Uz = (function(date) {
  var sp = $f_T__split__T__I__AT(date.toUTCString(), " ", 0);
  return ((sp.a[2] + " ") + sp.a[3]);
});
$p.auu = (function(date) {
  return $f_T__split__T__I__AT(date.toUTCString(), " ", 0).a[2];
});
$p.aux = (function(date) {
  return ("" + (+date.getUTCFullYear()));
});
$p.aug = (function(date) {
  var cloned = this.Mn(date);
  cloned.setMinutes(0.0, 0.0, 0.0);
  return cloned;
});
$p.auh = (function(date, minutesSeparation) {
  var cloned = this.Mn(date);
  var minutes = (+cloned.getUTCMinutes());
  var newMinutes = ((minutes / minutesSeparation) * minutesSeparation);
  cloned.setMinutes(newMinutes, 0.0, 0.0);
  return cloned;
});
$p.afw = (function(date, minutesToAdd) {
  var hoursMills = Math.imul(1000, Math.imul(60, minutesToAdd));
  return new Date(((+date.getTime()) + hoursMills));
});
$p.auv = (function(time) {
  return this.Uz(new Date(time));
});
$p.MF = (function(ms_$_lo, ms_$_hi) {
  var date = new Date(((4.294967296E9 * ms_$_hi) + (ms_$_lo >>> 0.0)));
  var year = $doubleToInt((+date.getUTCFullYear()));
  var month = $doubleToInt(((+date.getUTCMonth()) + 1.0));
  var day = $doubleToInt((+date.getUTCDate()));
  var hours = $doubleToInt((+date.getUTCHours()));
  var minutes = $doubleToInt((+date.getUTCMinutes()));
  return (((((((($p_Lcom_papasofokli_util_DateUtilsJS$__pad$1__I__T(this, day) + "/") + $p_Lcom_papasofokli_util_DateUtilsJS$__pad$1__I__T(this, month)) + "/") + year) + " ") + $p_Lcom_papasofokli_util_DateUtilsJS$__pad$1__I__T(this, hours)) + ":") + $p_Lcom_papasofokli_util_DateUtilsJS$__pad$1__I__T(this, minutes));
});
var $d_Lcom_papasofokli_util_DateUtilsJS$ = new $TypeData().i($c_Lcom_papasofokli_util_DateUtilsJS$, "com.papasofokli.util.DateUtilsJS$", ({
  so: 1
}));
var $n_Lcom_papasofokli_util_DateUtilsJS$;
function $m_Lcom_papasofokli_util_DateUtilsJS$() {
  if ((!$n_Lcom_papasofokli_util_DateUtilsJS$)) {
    $n_Lcom_papasofokli_util_DateUtilsJS$ = new $c_Lcom_papasofokli_util_DateUtilsJS$();
  }
  return $n_Lcom_papasofokli_util_DateUtilsJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_DelayFuture$() {
}
$p = $c_Lcom_papasofokli_util_DelayFuture$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_DelayFuture$;
/** @constructor */
function $h_Lcom_papasofokli_util_DelayFuture$() {
}
$h_Lcom_papasofokli_util_DelayFuture$.prototype = $p;
$p.jj = (function(milliseconds_$_lo, milliseconds_$_hi) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  $m_sjs_js_timers_package$().gb(((4.294967296E9 * milliseconds_$_hi) + (milliseconds_$_lo >>> 0.0)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p, (void 0));
  })));
  return p;
});
var $d_Lcom_papasofokli_util_DelayFuture$ = new $TypeData().i($c_Lcom_papasofokli_util_DelayFuture$, "com.papasofokli.util.DelayFuture$", ({
  sp: 1
}));
var $n_Lcom_papasofokli_util_DelayFuture$;
function $m_Lcom_papasofokli_util_DelayFuture$() {
  if ((!$n_Lcom_papasofokli_util_DelayFuture$)) {
    $n_Lcom_papasofokli_util_DelayFuture$ = new $c_Lcom_papasofokli_util_DelayFuture$();
  }
  return $n_Lcom_papasofokli_util_DelayFuture$;
}
function $p_Lcom_papasofokli_util_FreezePage__spinner__Lscalatags_JsDom$TypedTag($thiz) {
  if ((!$thiz.a8h)) {
    $thiz.a8g = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Kz + " fa-spin freeze-spinner"), $m_Lscalatags_JsDom$all$().s)]));
    $thiz.a8h = true;
  }
  return $thiz.a8g;
}
function $p_Lcom_papasofokli_util_FreezePage__freezeElement__s_Option($thiz) {
  var elementO = $m_s_Option$().Z(document.querySelector(("." + $thiz.Qu)));
  return (elementO.c() ? ((!$thiz.Qt) ? new $c_s_Some($thiz.Ge.appendChild($thiz.Qv)) : $m_s_None$()) : elementO);
}
/** @constructor */
function $c_Lcom_papasofokli_util_FreezePage(mills_$_lo, mills_$_hi, executionContext) {
  this.Qs = null;
  this.Qt = false;
  this.Qu = null;
  this.a8g = null;
  this.a8h = false;
  this.Qv = null;
  this.Ge = null;
  this.a8f = null;
  this.Qs = executionContext;
  this.Qt = false;
  this.Qu = "freeze-div";
  this.Qv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(this.Qu, $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$p_Lcom_papasofokli_util_FreezePage__spinner__Lscalatags_JsDom$TypedTag(this)])).aB();
  this.Qv.onclick = ((event$2) => {
    event$2.preventDefault();
  });
  this.Ge = document.body;
  this.a8f = (((mills_$_hi === 0) ? (mills_$_lo !== 0) : (mills_$_hi > 0)) ? $m_Lcom_papasofokli_util_DelayFuture$().jj(mills_$_lo, mills_$_hi).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => $p_Lcom_papasofokli_util_FreezePage__freezeElement__s_Option(this))), executionContext) : $m_s_concurrent_Future$().aE($p_Lcom_papasofokli_util_FreezePage__freezeElement__s_Option(this)));
}
$p = $c_Lcom_papasofokli_util_FreezePage.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_FreezePage;
/** @constructor */
function $h_Lcom_papasofokli_util_FreezePage() {
}
$h_Lcom_papasofokli_util_FreezePage.prototype = $p;
$p.ep = (function() {
  var fut = this.a8f.aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => {
    if (_$2$2.c()) {
      return $m_s_None$();
    } else {
      var x0 = _$2$2.h();
      return new $c_s_Some(($f_sc_SeqOps__contains__O__Z(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(this.Ge.children), x0) ? this.Ge.removeChild(x0) : this.Ge));
    }
  })), this.Qs);
  this.Qt = true;
  return fut.hj(new $c_Lcom_papasofokli_util_FreezePage$$anon$1(), this.Qs);
});
var $d_Lcom_papasofokli_util_FreezePage = new $TypeData().i($c_Lcom_papasofokli_util_FreezePage, "com.papasofokli.util.FreezePage", ({
  sq: 1
}));
var $d_Lcom_papasofokli_util_GeneralText = new $TypeData().i(1, "com.papasofokli.util.GeneralText", ({
  ba: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeometryMethods$() {
}
$p = $c_Lcom_papasofokli_util_GeometryMethods$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeometryMethods$;
/** @constructor */
function $h_Lcom_papasofokli_util_GeometryMethods$() {
}
$h_Lcom_papasofokli_util_GeometryMethods$.prototype = $p;
$p.ahv = (function() {
  var outer = $m_Lcom_papasofokli_util_package$().agq();
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.position = "fixed";
  document.body.appendChild(outer);
  var widthNoScroll = (+outer.offsetWidth);
  outer.style.overflow = "scroll";
  var inner = $m_Lcom_papasofokli_util_package$().agq();
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = (+inner.offsetWidth);
  outer.parentNode.removeChild(outer);
  return (widthNoScroll - widthWithScroll);
});
$p.afU = (function() {
  return (+(0, $m_Lcom_papasofokli_jquery_package$().I)(window).height());
});
$p.auk = (function() {
  return (+(0, $m_Lcom_papasofokli_jquery_package$().I)(".footer").height());
});
$p.MP = (function() {
  return (+window.innerWidth);
});
$p.azw = (function(executionContext) {
  var windowWidth = new $c_sr_DoubleRef(this.MP());
  var eventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(300, 0, executionContext);
  window.onresize = ((_$1$2) => eventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((windowWidth.bv !== this.MP())) {
      windowWidth.bv = this.MP();
      (0, $m_Lcom_papasofokli_jquery_package$().I)(".initialized-tables").each((function() {
        $m_Lcom_papasofokli_dataTables_TableInitialize$();
        var uuid = $m_ju_UUID$().aO(this.id);
        return $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ajk(uuid, executionContext);
      }));
    }
    $m_Lcom_papasofokli_TopLevelMethods$().ah7();
  }))));
});
var $d_Lcom_papasofokli_util_GeometryMethods$ = new $TypeData().i($c_Lcom_papasofokli_util_GeometryMethods$, "com.papasofokli.util.GeometryMethods$", ({
  sD: 1
}));
var $n_Lcom_papasofokli_util_GeometryMethods$;
function $m_Lcom_papasofokli_util_GeometryMethods$() {
  if ((!$n_Lcom_papasofokli_util_GeometryMethods$)) {
    $n_Lcom_papasofokli_util_GeometryMethods$ = new $c_Lcom_papasofokli_util_GeometryMethods$();
  }
  return $n_Lcom_papasofokli_util_GeometryMethods$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_MultipleEventHandler(timeMills_$_lo, timeMills_$_hi, executionContext) {
  this.M2 = 0;
  this.M3 = 0;
  this.Gk = null;
  this.jg = 0;
  this.jh = 0;
  this.M2 = timeMills_$_lo;
  this.M3 = timeMills_$_hi;
  this.Gk = executionContext;
  this.jg = 0;
  this.jh = 0;
}
$p = $c_Lcom_papasofokli_util_MultipleEventHandler.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_MultipleEventHandler;
/** @constructor */
function $h_Lcom_papasofokli_util_MultipleEventHandler() {
}
$h_Lcom_papasofokli_util_MultipleEventHandler.prototype = $p;
$p.dS = (function(fun) {
  var x_$_lo = this.jg;
  var x_$_hi = this.jh;
  var lo = ((1 + x_$_lo) | 0);
  var hi = ((x_$_hi + ((lo === 0) | 0)) | 0);
  this.jg = lo;
  this.jh = hi;
  var executionId_$_lo = this.jg;
  var executionId_$_hi = this.jh;
  return $m_Lcom_papasofokli_util_DelayFuture$().jj(this.M2, this.M3).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => {
    var x$1_$_lo = this.jg;
    var x$1_$_hi = this.jh;
    if ((((executionId_$_lo ^ x$1_$_lo) | (executionId_$_hi ^ x$1_$_hi)) === 0)) {
      return $m_s_Option$().Z(fun.aA());
    } else {
      return $m_s_None$();
    }
  })), this.Gk);
});
$p.Ue = (function(fun) {
  var x_$_lo = this.jg;
  var x_$_hi = this.jh;
  var lo = ((1 + x_$_lo) | 0);
  var hi = ((x_$_hi + ((lo === 0) | 0)) | 0);
  this.jg = lo;
  this.jh = hi;
  var executionId_$_lo = this.jg;
  var executionId_$_hi = this.jh;
  return $m_Lcom_papasofokli_util_DelayFuture$().jj(this.M2, this.M3).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => {
    var x$1_$_lo = this.jg;
    var x$1_$_hi = this.jh;
    if ((((executionId_$_lo ^ x$1_$_lo) | (executionId_$_hi ^ x$1_$_hi)) === 0)) {
      return fun.aA().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => $m_s_Option$().Z(_$3$2))), this.Gk);
    } else {
      return $m_s_concurrent_Future$().aE($m_s_None$());
    }
  })), this.Gk);
});
$p.atF = (function(fun) {
  var executionId_$_lo = this.jg;
  var executionId_$_hi = this.jh;
  return $m_Lcom_papasofokli_util_DelayFuture$().jj(this.M2, this.M3).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    var x_$_lo = this.jg;
    var x_$_hi = this.jh;
    if ((((executionId_$_lo ^ x_$_lo) | (executionId_$_hi ^ x_$_hi)) === 0)) {
      var x$1_$_lo = this.jg;
      var x$1_$_hi = this.jh;
      var lo = ((1 + x$1_$_lo) | 0);
      var hi = ((x$1_$_hi + ((lo === 0) | 0)) | 0);
      this.jg = lo;
      this.jh = hi;
      return $m_s_Option$().Z(fun.aA());
    } else {
      return $m_s_None$();
    }
  })), this.Gk);
});
var $d_Lcom_papasofokli_util_MultipleEventHandler = new $TypeData().i($c_Lcom_papasofokli_util_MultipleEventHandler, "com.papasofokli.util.MultipleEventHandler", ({
  sI: 1
}));
function $ct_Lcom_papasofokli_util_ProgressBarStyle__T__($thiz, style) {
  $thiz.xS = style;
  return $thiz;
}
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle() {
  this.xS = null;
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle.prototype = $p;
var $d_Lcom_papasofokli_util_ProgressBarStyle = new $TypeData().i(0, "com.papasofokli.util.ProgressBarStyle", ({
  bi: 1
}));
function $p_Lcom_papasofokli_util_SyncScrollJs$__syncScroll__Lorg_scalajs_dom_HTMLDivElement__sci_Seq__V($thiz, source, targets) {
  if ($thiz.KB) {
    return (void 0);
  }
  $thiz.KB = true;
  targets.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    _$1$3.scrollLeft = (+source.scrollLeft);
  })));
  $thiz.KB = false;
}
/** @constructor */
function $c_Lcom_papasofokli_util_SyncScrollJs$() {
  this.KB = false;
  this.KB = false;
}
$p = $c_Lcom_papasofokli_util_SyncScrollJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_SyncScrollJs$;
/** @constructor */
function $h_Lcom_papasofokli_util_SyncScrollJs$() {
}
$h_Lcom_papasofokli_util_SyncScrollJs$.prototype = $p;
$p.co = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".e66365c7-9a28-44a0-8fd8-b95328c1afdd"));
  $m_sci_List$();
  var this$5 = $m_sci_Nil$().aY(this$2);
  var f = ((_$2$2) => _$2$2);
  if ((this$5 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$5.W();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$5.ak();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.W();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.bz = nx;
      t = nx;
      rest = rest.ak();
    }
    var $x_1 = h;
  }
  var divs = $x_1;
  if ((divs.F() < 2)) {
    return (void 0);
  }
  var these = divs;
  while ((!these.c())) {
    var x0$2 = these.W();
    var f$1 = ((x0$2) => ((_$3$2) => Object.is(_$3$2, x0$2)))(x0$2);
    _return$1: {
      var result;
      var l$tailLocal1 = divs;
      while (true) {
        if (l$tailLocal1.c()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h$1 = l$tailLocal1.W();
          var t$1 = l$tailLocal1.ak();
          if ((!(!f$1(h$1)))) {
            l$tailLocal1 = t$1;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t$1;
          while (true) {
            if (remaining$tailLocal1.c()) {
              var result = start;
              break _return$1;
            } else {
              var x = remaining$tailLocal1.W();
              if ((!(!(!f$1(x))))) {
                remaining$tailLocal1 = remaining$tailLocal1.ak();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
              var toProcess = start.ak();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
                currentLast.bz = newElem;
                currentLast = newElem;
                toProcess = toProcess.ak();
              }
              var next = firstMiss.ak();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.W();
                if ((!(!(!f$1(head))))) {
                  next = next.ak();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                    currentLast.bz = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.ak();
                  }
                  nextToCopy = next.ak();
                  next = next.ak();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.bz = nextToCopy;
              }
              var result = newHead;
              break _return$1;
            }
          }
        }
      }
    }
    x0$2.onscroll = ((x0$2, result) => ((_$4$2) => {
      $p_Lcom_papasofokli_util_SyncScrollJs$__syncScroll__Lorg_scalajs_dom_HTMLDivElement__sci_Seq__V(this, x0$2, result);
    }))(x0$2, result);
    these = these.ak();
  }
});
var $d_Lcom_papasofokli_util_SyncScrollJs$ = new $TypeData().i($c_Lcom_papasofokli_util_SyncScrollJs$, "com.papasofokli.util.SyncScrollJs$", ({
  sQ: 1
}));
var $n_Lcom_papasofokli_util_SyncScrollJs$;
function $m_Lcom_papasofokli_util_SyncScrollJs$() {
  if ((!$n_Lcom_papasofokli_util_SyncScrollJs$)) {
    $n_Lcom_papasofokli_util_SyncScrollJs$ = new $c_Lcom_papasofokli_util_SyncScrollJs$();
  }
  return $n_Lcom_papasofokli_util_SyncScrollJs$;
}
function $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__wire__Lorg_scalajs_dom_Element__V($thiz, container) {
  container.classList.remove("b89884c6-8310-42d9-96df-2745081bda63");
  var this$2 = $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__find__Lorg_scalajs_dom_Element__T__s_Option($thiz, container, ".hscroll-top");
  if (this$2.c()) {
    var parts = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var this$4 = $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__find__Lorg_scalajs_dom_Element__T__s_Option($thiz, container, ".hscroll-spacer");
    if (this$4.c()) {
      var parts = $m_s_None$();
    } else {
      var x0$1 = this$4.h();
      var this$6 = $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__find__Lorg_scalajs_dom_Element__T__s_Option($thiz, container, ".hscroll-body");
      if (this$6.c()) {
        var parts = $m_s_None$();
      } else {
        var x0$2 = this$6.h();
        var this$7 = $m_s_Option$().Z(x0$2.firstElementChild);
        var pf = new $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1();
        var this$9 = ((!this$7.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$7.h()) : $m_s_None$());
        var parts = (this$9.c() ? $m_s_None$() : new $c_s_Some(new $c_T4(x0, x0$1, x0$2, this$9.h())));
      }
    }
  }
  if ((!parts.c())) {
    var x0$4 = parts.h();
    matchResult3: {
      if ((x0$4 !== null)) {
        var top = x0$4.y8;
        var spacer = x0$4.y9;
        var body = x0$4.ya;
        var content = x0$4.tp;
        var resize = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          spacer.style.width = ((body.scrollWidth | 0) + "px");
        }));
        resize.aA();
        new ResizeObserver(((_$1$2, _$2$2) => {
          resize.aA();
        })).observe(content);
        var lock = new $c_sr_BooleanRef(false);
        $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__mirror$1__sr_BooleanRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLElement__V($thiz, lock, top, body);
        $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__mirror$1__sr_BooleanRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLElement__V($thiz, lock, body, top);
        break matchResult3;
      }
      throw new $c_s_MatchError(x0$4);
    }
  }
}
function $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__find__Lorg_scalajs_dom_Element__T__s_Option($thiz, root, sel) {
  var this$1 = $m_s_Option$().Z(root.querySelector(sel));
  var pf = new $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2();
  return ((!this$1.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(this$1.h()) : $m_s_None$());
}
function $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__mirror$1__sr_BooleanRef__Lorg_scalajs_dom_HTMLElement__Lorg_scalajs_dom_HTMLElement__V($thiz, lock$1, from, to) {
  from.onscroll = ((_$3$2) => {
    if ((!lock$1.e1)) {
      lock$1.e1 = true;
    }
    to.scrollLeft = (+from.scrollLeft);
    window.requestAnimationFrame(((_$4$3) => {
      lock$1.e1 = false;
    }));
  });
}
/** @constructor */
function $c_Lcom_papasofokli_util_TopBottomScrollDivJs$() {
}
$p = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$;
/** @constructor */
function $h_Lcom_papasofokli_util_TopBottomScrollDivJs$() {
}
$h_Lcom_papasofokli_util_TopBottomScrollDivJs$.prototype = $p;
$p.co = (function() {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".b89884c6-8310-42d9-96df-2745081bda63"));
  var it = this$2.l();
  while (it.f()) {
    $p_Lcom_papasofokli_util_TopBottomScrollDivJs$__wire__Lorg_scalajs_dom_Element__V(this, it.e());
  }
});
var $d_Lcom_papasofokli_util_TopBottomScrollDivJs$ = new $TypeData().i($c_Lcom_papasofokli_util_TopBottomScrollDivJs$, "com.papasofokli.util.TopBottomScrollDivJs$", ({
  sR: 1
}));
var $n_Lcom_papasofokli_util_TopBottomScrollDivJs$;
function $m_Lcom_papasofokli_util_TopBottomScrollDivJs$() {
  if ((!$n_Lcom_papasofokli_util_TopBottomScrollDivJs$)) {
    $n_Lcom_papasofokli_util_TopBottomScrollDivJs$ = new $c_Lcom_papasofokli_util_TopBottomScrollDivJs$();
  }
  return $n_Lcom_papasofokli_util_TopBottomScrollDivJs$;
}
function $p_Lcom_papasofokli_util_WakeLockHandler__requestWakeLock$1__sr_ObjectRef__s_concurrent_Future($thiz, wakeLock$1) {
  return $m_sjs_js_Thenable$ThenableOps$().uE(navigator.wakeLock.request("screen")).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((lock$3) => {
    wakeLock$1.bL = $m_s_Option$().Z(lock$3);
    console.log("Screen Wake Lock activated");
  })), $thiz.QC);
}
function $p_Lcom_papasofokli_util_WakeLockHandler__requestReleaseLockO$1__sr_ObjectRef__s_Option($thiz, wakeLock$3) {
  var this$1 = wakeLock$3.bL;
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some($m_sjs_js_Thenable$ThenableOps$().uE(x0.release()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
      var $x_1 = console;
      var this$4 = wakeLock$3.bL;
      if (this$4.c()) {
        var this$6 = $m_s_None$();
      } else {
        var x0$1 = this$4.h();
        var this$6 = new $c_s_Some(x0$1.released);
      }
      $x_1.log(("Screen Wake Lock released : " + (this$6.c() ? "-" : this$6.h())));
    })), $thiz.QC));
  }
}
/** @constructor */
function $c_Lcom_papasofokli_util_WakeLockHandler(executionContext) {
  this.QC = null;
  this.QC = executionContext;
}
$p = $c_Lcom_papasofokli_util_WakeLockHandler.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_WakeLockHandler;
/** @constructor */
function $h_Lcom_papasofokli_util_WakeLockHandler() {
}
$h_Lcom_papasofokli_util_WakeLockHandler.prototype = $p;
$p.an7 = (function() {
  var wakeLock = new $c_sr_ObjectRef($m_s_None$());
  var handleVisibilityChange = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    console.log(("Window visibilityState : " + document.visibilityState));
    return ((document.visibilityState === "visible") ? $p_Lcom_papasofokli_util_WakeLockHandler__requestWakeLock$1__sr_ObjectRef__s_concurrent_Future(this, wakeLock) : ((!$p_Lcom_papasofokli_util_WakeLockHandler__requestReleaseLockO$1__sr_ObjectRef__s_Option(this, wakeLock).c()) ? $p_Lcom_papasofokli_util_WakeLockHandler__requestReleaseLockO$1__sr_ObjectRef__s_Option(this, wakeLock).h() : $m_s_concurrent_Future$().aE((void 0))));
  }));
  document.addEventListener("visibilitychange", $m_sjs_js_Any$().b3(handleVisibilityChange));
  return $p_Lcom_papasofokli_util_WakeLockHandler__requestWakeLock$1__sr_ObjectRef__s_concurrent_Future(this, wakeLock);
});
var $d_Lcom_papasofokli_util_WakeLockHandler = new $TypeData().i($c_Lcom_papasofokli_util_WakeLockHandler, "com.papasofokli.util.WakeLockHandler", ({
  sU: 1
}));
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus = new $TypeData().i(1, "com.papasofokli.util.formgroup.FormGroupValidationStatus", ({
  bj: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_InputValidation$() {
}
$p = $c_Lcom_papasofokli_util_formgroup_InputValidation$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_InputValidation$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_InputValidation$() {
}
$h_Lcom_papasofokli_util_formgroup_InputValidation$.prototype = $p;
$p.az0 = (function(formGroupId, helpId, status, helpText) {
  var groupId = ("#" + formGroupId);
  var queryInputGroup = (0, $m_Lcom_papasofokli_jquery_package$().I)(groupId);
  $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().a8W.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((validationStatus$2) => ((!((status === null) ? (validationStatus$2 === null) : (status === validationStatus$2))) ? queryInputGroup.removeClass(validationStatus$2.g()) : queryInputGroup.addClass(validationStatus$2.g())))));
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + helpId)).html(helpText);
});
var $d_Lcom_papasofokli_util_formgroup_InputValidation$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_InputValidation$, "com.papasofokli.util.formgroup.InputValidation$", ({
  t3: 1
}));
var $n_Lcom_papasofokli_util_formgroup_InputValidation$;
function $m_Lcom_papasofokli_util_formgroup_InputValidation$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_InputValidation$)) {
    $n_Lcom_papasofokli_util_formgroup_InputValidation$ = new $c_Lcom_papasofokli_util_formgroup_InputValidation$();
  }
  return $n_Lcom_papasofokli_util_formgroup_InputValidation$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_misc_package$() {
  this.a8Z = 0.0;
  $n_Lcom_papasofokli_util_misc_package$ = this;
  this.a8Z = (0.5 * (1.0 + (+Math.sqrt(5.0))));
}
$p = $c_Lcom_papasofokli_util_misc_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_misc_package$;
/** @constructor */
function $h_Lcom_papasofokli_util_misc_package$() {
}
$h_Lcom_papasofokli_util_misc_package$.prototype = $p;
$p.V3 = (function(n) {
  return ((n < 0.0) ? 0.0 : n);
});
var $d_Lcom_papasofokli_util_misc_package$ = new $TypeData().i($c_Lcom_papasofokli_util_misc_package$, "com.papasofokli.util.misc.package$", ({
  t6: 1
}));
var $n_Lcom_papasofokli_util_misc_package$;
function $m_Lcom_papasofokli_util_misc_package$() {
  if ((!$n_Lcom_papasofokli_util_misc_package$)) {
    $n_Lcom_papasofokli_util_misc_package$ = new $c_Lcom_papasofokli_util_misc_package$();
  }
  return $n_Lcom_papasofokli_util_misc_package$;
}
function $p_Lcom_papasofokli_util_package$__collapseNavbar$1__T__T__V($thiz, navbarExpanderCssClass$1, pageWrapperId$1) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(navbarExpanderCssClass$1).removeClass("navbar-ease-expand");
  (0, $m_Lcom_papasofokli_jquery_package$().I)(pageWrapperId$1).removeClass("screen-hover");
  (0, $m_Lcom_papasofokli_jquery_package$().I)(pageWrapperId$1).unbind("click");
  $m_sjs_js_timers_package$().gb(350.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    (0, $m_Lcom_papasofokli_jquery_package$().I)("body").toggleClass("mini-navbar");
  })));
}
function $p_Lcom_papasofokli_util_package$__expandNavbar$1__T__T__V($thiz, pageWrapperId$2, navbarExpanderCssClass$2) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)("body").toggleClass("mini-navbar");
  $m_sjs_js_timers_package$().gb(50.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    (0, $m_Lcom_papasofokli_jquery_package$().I)(pageWrapperId$2).click(((event$3) => {
      event$3.preventDefault();
      $m_Lcom_papasofokli_util_package$().UD(false);
    }));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(navbarExpanderCssClass$2).removeClass("navbar-ease-collapse");
    (0, $m_Lcom_papasofokli_jquery_package$().I)(navbarExpanderCssClass$2).addClass("navbar-ease-expand");
    (0, $m_Lcom_papasofokli_jquery_package$().I)(pageWrapperId$2).addClass("screen-hover");
  })));
}
function $p_Lcom_papasofokli_util_package$__navbarForMobile$1__T__Z__T__V($thiz, navbarExpanderCssClass$4, navbarExpanded$1, pageWrapperId$4) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(navbarExpanderCssClass$4).addClass("navbar-ease-collapse");
  if (navbarExpanded$1) {
    $p_Lcom_papasofokli_util_package$__collapseNavbar$1__T__T__V($thiz, navbarExpanderCssClass$4, pageWrapperId$4);
  } else {
    $p_Lcom_papasofokli_util_package$__expandNavbar$1__T__T__V($thiz, pageWrapperId$4, navbarExpanderCssClass$4);
  }
}
function $p_Lcom_papasofokli_util_package$__toggleNavBar$1__V($thiz) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)("body").toggleClass("mini-navbar");
}
/** @constructor */
function $c_Lcom_papasofokli_util_package$() {
}
$p = $c_Lcom_papasofokli_util_package$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_package$;
/** @constructor */
function $h_Lcom_papasofokli_util_package$() {
}
$h_Lcom_papasofokli_util_package$.prototype = $p;
$p.agq = (function() {
  var x1 = document.createElement("div");
  if ((!(!(x1 instanceof HTMLDivElement)))) {
    return x1;
  }
  throw new $c_s_MatchError("Element not a div as expected");
});
$p.VH = (function(divId, executionContext) {
  if ($m_Lcom_papasofokli_util_package$().ahQ()) {
    return $m_sjs_js_Thenable$ThenableOps$().uE(document.exitFullscreen()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => false)), executionContext);
  } else {
    if (divId.c()) {
      var this$4 = $m_s_None$();
    } else {
      var x0 = divId.h();
      var this$4 = new $c_s_Some(document.getElementById(x0.g()));
    }
    var element = (this$4.c() ? document.body : this$4.h());
    return $m_sjs_js_Thenable$ThenableOps$().uE(element.requestFullscreen()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => true)), executionContext);
  }
});
$p.ahQ = (function() {
  return (!$m_s_Option$().Z(document.fullscreenElement).c());
});
$p.Eg = (function(notInitializedClass, initializeFun) {
  return $m_Lcom_papasofokli_util_package$().fo(notInitializedClass).each($m_sjs_js_ThisFunction$().aud(initializeFun));
});
$p.fo = (function(notInitializedClass) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + notInitializedClass)).removeClass(notInitializedClass);
});
$p.atH = (function(data, executionContext) {
  $m_Lcom_papasofokli_util_package$().Ud(((data === (void 0)) ? (void 0) : JSON.stringify(data)), executionContext);
});
$p.Ud = (function(data, executionContext) {
  var x = (((data === (void 0)) || ($m_sc_StringOps$(), (data !== ""))) ? data : (void 0));
  if ((x !== (void 0))) {
    $m_Lcom_papasofokli_util_package$().atG($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(x, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_execution_JsStatement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))), executionContext);
  }
});
$p.atG = (function(commands, executionContext) {
  commands.fL($m_s_concurrent_Future$().aE((void 0)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((acc$2, eF$2) => acc$2.aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((eF$1) => ((x$1$2) => $m_Lcom_papasofokli_execution_ExecuteImpl$().atE(eF$1, executionContext)))(eF$2)), executionContext)))).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => {
    $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
  })), executionContext);
});
$p.UD = (function(alwaysHidden) {
  var mobileResolution = (!(!(0, $m_Lcom_papasofokli_jquery_package$().I)("body").hasClass("body-small")));
  var navbarExpanded = (!(!(0, $m_Lcom_papasofokli_jquery_package$().I)("body").hasClass("mini-navbar")));
  if (mobileResolution) {
    $p_Lcom_papasofokli_util_package$__navbarForMobile$1__T__Z__T__V(this, ".nav-div", navbarExpanded, "#page-wrapper");
  } else if (alwaysHidden) {
    if ((!navbarExpanded)) {
      $p_Lcom_papasofokli_util_package$__toggleNavBar$1__V(this);
    }
  } else {
    $p_Lcom_papasofokli_util_package$__toggleNavBar$1__V(this);
  }
});
var $d_Lcom_papasofokli_util_package$ = new $TypeData().i($c_Lcom_papasofokli_util_package$, "com.papasofokli.util.package$", ({
  t7: 1
}));
var $n_Lcom_papasofokli_util_package$;
function $m_Lcom_papasofokli_util_package$() {
  if ((!$n_Lcom_papasofokli_util_package$)) {
    $n_Lcom_papasofokli_util_package$ = new $c_Lcom_papasofokli_util_package$();
  }
  return $n_Lcom_papasofokli_util_package$;
}
var $d_Lcom_papasofokli_websocket_ClientMessages = new $TypeData().i(1, "com.papasofokli.websocket.ClientMessages", ({
  b1: 1
}));
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__makeWebsocketUrl__T__T__T($thiz, id, originUrl) {
  return ((("ws" + $m_sc_StringOps$().ato(originUrl, 4)) + "/websocket/") + id);
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getWebPageStatus__Lcom_papasofokli_websocket_WebPageStatus($thiz) {
  return new $c_Lcom_papasofokli_websocket_WebPageStatus(window.location.href, $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getVisibilityInfo__Lcom_papasofokli_websocket_VisibilityInfo($thiz));
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getVisibilityInfo__Lcom_papasofokli_websocket_VisibilityInfo($thiz) {
  return ((!(!document.hidden)) ? $m_Lcom_papasofokli_websocket_IsNotVisibleMessage$() : $m_Lcom_papasofokli_websocket_IsVisibleMessage$());
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__messageEventFunction__Lorg_scalajs_dom_MessageEvent__s_concurrent_ExecutionContext__V($thiz, event, executionContext) {
  $m_Lcom_papasofokli_util_package$().Ud($dp_toString__T(event.data), executionContext);
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V($thiz, source$1, message) {
  var pickled = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), message, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_websocket_ClientMessages$().q());
  source$1.send(pickled);
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__pong$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_WebSocket__sjs_js_timers_SetIntervalHandle($thiz, pong$lzy1$1, source$2) {
  return (pong$lzy1$1.i ? pong$lzy1$1.j : pong$lzy1$1.E($m_sjs_js_timers_package$().Vq(30000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V($thiz, source$2, $m_Lcom_papasofokli_websocket_GreetingMessage$());
  })))));
}
function $p_Lcom_papasofokli_websocket_WebSocketInitializer$__pong$1__sr_LazyRef__Lorg_scalajs_dom_WebSocket__sjs_js_timers_SetIntervalHandle($thiz, pong$lzy1$2, source$3) {
  return (pong$lzy1$2.i ? pong$lzy1$2.j : $p_Lcom_papasofokli_websocket_WebSocketInitializer$__pong$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_WebSocket__sjs_js_timers_SetIntervalHandle($thiz, pong$lzy1$2, source$3));
}
/** @constructor */
function $c_Lcom_papasofokli_websocket_WebSocketInitializer$() {
}
$p = $c_Lcom_papasofokli_websocket_WebSocketInitializer$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_WebSocketInitializer$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_WebSocketInitializer$() {
}
$h_Lcom_papasofokli_websocket_WebSocketInitializer$.prototype = $p;
$p.ahM = (function(executionContext) {
  var id = document.body.id;
  var urlUO = window.location.origin;
  var url = ((urlUO === (void 0)) ? (void 0) : $p_Lcom_papasofokli_websocket_WebSocketInitializer$__makeWebsocketUrl__T__T__T(this, id, urlUO));
  if ((($m_sc_StringOps$(), (id !== "")) && (url !== (void 0)))) {
    var pong$lzy1 = new $c_sr_LazyRef();
    var $x_1 = WebSocket;
    if ((url === (void 0))) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    }
    var source = new $x_1(url);
    source.onmessage = ((event$2) => {
      $p_Lcom_papasofokli_websocket_WebSocketInitializer$__messageEventFunction__Lorg_scalajs_dom_MessageEvent__s_concurrent_ExecutionContext__V(this, event$2, executionContext);
    });
    source.onclose = ((pong$lzy1$3) => ((_$2$2) => {
      $m_sjs_js_timers_package$().ane($p_Lcom_papasofokli_websocket_WebSocketInitializer$__pong$1__sr_LazyRef__Lorg_scalajs_dom_WebSocket__sjs_js_timers_SetIntervalHandle(this, pong$lzy1$3, source));
    }))(pong$lzy1);
    source.onerror = ((event$2$1) => {
      console.error(event$2$1);
    });
    document.addEventListener("visibilitychange", ((_$3$2) => {
      $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V(this, source, $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getVisibilityInfo__Lcom_papasofokli_websocket_VisibilityInfo(this));
    }));
    window.onpopstate = ((_$4$2) => {
      $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V(this, source, $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getWebPageStatus__Lcom_papasofokli_websocket_WebPageStatus(this));
    });
    window.onbeforeunload = ((_$5$2) => {
      $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V(this, source, new $c_Lcom_papasofokli_websocket_ClosePageMessage(false));
    });
    source.onopen = ((pong$lzy1$4) => ((_$6$2) => {
      $p_Lcom_papasofokli_websocket_WebSocketInitializer$__sendClientMessages$1__Lorg_scalajs_dom_WebSocket__Lcom_papasofokli_websocket_ClientMessages__V(this, source, $p_Lcom_papasofokli_websocket_WebSocketInitializer$__getWebPageStatus__Lcom_papasofokli_websocket_WebPageStatus(this));
      return $p_Lcom_papasofokli_websocket_WebSocketInitializer$__pong$1__sr_LazyRef__Lorg_scalajs_dom_WebSocket__sjs_js_timers_SetIntervalHandle(this, pong$lzy1$4, source);
    }))(pong$lzy1);
  }
});
var $d_Lcom_papasofokli_websocket_WebSocketInitializer$ = new $TypeData().i($c_Lcom_papasofokli_websocket_WebSocketInitializer$, "com.papasofokli.websocket.WebSocketInitializer$", ({
  tk: 1
}));
var $n_Lcom_papasofokli_websocket_WebSocketInitializer$;
function $m_Lcom_papasofokli_websocket_WebSocketInitializer$() {
  if ((!$n_Lcom_papasofokli_websocket_WebSocketInitializer$)) {
    $n_Lcom_papasofokli_websocket_WebSocketInitializer$ = new $c_Lcom_papasofokli_websocket_WebSocketInitializer$();
  }
  return $n_Lcom_papasofokli_websocket_WebSocketInitializer$;
}
/** @constructor */
function $c_Lcom_papasofokli_zxing_CameraPermission$() {
}
$p = $c_Lcom_papasofokli_zxing_CameraPermission$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_zxing_CameraPermission$;
/** @constructor */
function $h_Lcom_papasofokli_zxing_CameraPermission$() {
}
$h_Lcom_papasofokli_zxing_CameraPermission$.prototype = $p;
$p.axd = (function() {
  var mediaDevices = window.navigator.mediaDevices;
  var constraints = ({
    "video": true,
    "audio": false
  });
  mediaDevices.getUserMedia(constraints).toFuture;
});
var $d_Lcom_papasofokli_zxing_CameraPermission$ = new $TypeData().i($c_Lcom_papasofokli_zxing_CameraPermission$, "com.papasofokli.zxing.CameraPermission$", ({
  tl: 1
}));
var $n_Lcom_papasofokli_zxing_CameraPermission$;
function $m_Lcom_papasofokli_zxing_CameraPermission$() {
  if ((!$n_Lcom_papasofokli_zxing_CameraPermission$)) {
    $n_Lcom_papasofokli_zxing_CameraPermission$ = new $c_Lcom_papasofokli_zxing_CameraPermission$();
  }
  return $n_Lcom_papasofokli_zxing_CameraPermission$;
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__initialiseVideoScannerSelection__sjs_js_Array__Lorg_scalajs_dom_Element__Z__V($thiz, videoInputDevices, sourceSelect, preferBackCameraIndicator) {
  var sortedDevices = (preferBackCameraIndicator ? $m_sjs_js_ArrayOps$().axv($m_sjs_js_ArrayOps$().Nt(videoInputDevices, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$2) => $dp_toString__T(_$7$2.deviceId))), $m_s_math_Ordering$String$())) : $m_sjs_js_ArrayOps$().Nt(videoInputDevices, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => $dp_toString__T(_$8$2.deviceId))), $m_s_math_Ordering$String$()));
  var len = (sortedDevices.length | 0);
  var i = 0;
  while ((i < len)) {
    var x0 = sortedDevices[i];
    var sourceOption = document.createElement("option");
    var t = document.createTextNode($dp_toString__T(x0.label));
    sourceOption.appendChild(t);
    sourceOption.setAttribute("value", $dp_toString__T(x0.deviceId));
    sourceSelect.appendChild(sourceOption);
    i = ((1 + i) | 0);
  }
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__initializeOtherComponents__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__V($thiz, codeReader, deviceId, videoId, inputsMap, inputsMapFun, scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, setVideoTimeOut, videoTimeOut, timeOutMinutes, validateInputIndicator, scanDelayMillSecs, executionContext) {
  var startButtonElement = document.getElementById("startButton");
  startButtonElement.addEventListener("click", ((_$9$2) => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__startVideoDevice__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, codeReader, deviceId, videoId, inputsMap, inputsMapFun, scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, setVideoTimeOut, videoTimeOut, timeOutMinutes, validateInputIndicator, scanDelayMillSecs, executionContext)));
  var resetButton = document.getElementById("resetButton");
  resetButton.addEventListener("click", ((_$10$2) => {
    $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__videoActions__Z__V($thiz, false);
    codeReader.reset();
    return inputsMapFun.cm($m_s_None$(), 0.0);
  }));
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__startVideoDevice__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, codeReader, deviceId, videoId, inputsMap, inputsMapFun, scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, setVideoTimeOut, videoTimeOut, timeOutMinutes, validateInputIndicator, scanDelayMillSecs, executionContext) {
  var callBack = ((result$3, _$11$3) => {
    $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__decodeFromVideoCallbackFun__Lcom_papasofokli_zxing_Result__Lcom_papasofokli_zxing_BrowserMultiFormatReader__T__T__T__T__F1__s_Option__F0__F2__s_Option__I__s_concurrent_ExecutionContext__V($thiz, result$3, codeReader, timeOutMinutes, checkSessionFunUUID, scanInputFunUUID, errorInputFunUUID, setVideoTimeOut, videoTimeOut, inputsMap, inputsMapFun, validateInputIndicator, scanDelayMillSecs, executionContext);
  });
  return deviceId.aA().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((device$3) => {
    if ((device$3 !== "undefined")) {
      $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__videoActions__Z__V($thiz, true);
      codeReader.decodeFromVideoDevice(device$3, videoId, callBack);
    } else {
      console.error("Camera device not found.");
      (void 0);
    }
  })), executionContext);
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__decodeFromVideoCallbackFun__Lcom_papasofokli_zxing_Result__Lcom_papasofokli_zxing_BrowserMultiFormatReader__T__T__T__T__F1__s_Option__F0__F2__s_Option__I__s_concurrent_ExecutionContext__V($thiz, result, codeReader, timeOutMinutes, checkSessionFunUUID, scanInputFunUUID, errorInputFunUUID, setVideoTimeOut, videoTimeOut, getInputsMap, inputsMapFun, validateInputIndicator, scanDelayMillSecs, executionContext) {
  $m_sc_StringOps$();
  var timeOutInt = $m_sc_StringParsers$().fs(timeOutMinutes);
  if (((result !== null) && (result.text !== (void 0)))) {
    var resultText = result.text;
    var nowMSecs = (+Date.now());
    var currentEntryTime = getInputsMap.aA().b9($dp_toString__T(resultText));
    if ((((!currentEntryTime.c()) && (((+currentEntryTime.h()) + scanDelayMillSecs) <= nowMSecs)) || currentEntryTime.c())) {
      if (((validateInputIndicator.az(false) && (resultText !== (void 0))) || $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__checkIfValidUUID__T__Z($thiz, $dp_toString__T(resultText)))) {
        $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__animateScanner__I($thiz);
        $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__checkServerStateAndReload__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, checkSessionFunUUID, executionContext);
        var this$13 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
        var id = $m_ju_UUID$().aO(scanInputFunUUID);
        var data = $dp_toString__T(resultText);
        $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$13, id.g(), data, executionContext);
        if (((!timeOutInt.c()) && ((timeOutInt.h() | 0) > 0))) {
          window.clearTimeout(((videoTimeOut.c() ? 0 : videoTimeOut.h()) | 0));
          var timeoutD = Math.imul(60000, ((timeOutInt.c() ? 1 : timeOutInt.h()) | 0));
          var timeOut = (window.setTimeout((() => {
            codeReader.reset();
            $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__videoActions__Z__V($thiz, false);
          }), timeoutD) | 0);
          setVideoTimeOut.p($m_s_Option$().Z(timeOut));
        }
      } else {
        $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__animateScannerError__V($thiz);
        $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(errorInputFunUUID).g(), "Invalid code format.", executionContext);
        console.error(($dp_toString__T(resultText) + " is not a valid UUID."));
      }
      inputsMapFun.cm($m_s_Option$().Z($dp_toString__T(resultText)), nowMSecs);
    }
  }
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__checkIfValidUUID__T__Z($thiz, str) {
  try {
    var $x_1 = new $c_s_util_Success($m_ju_UUID$().aO(str));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  return (!$x_1.mN().c());
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__animateScanner__I($thiz) {
  document.getElementById("video-overlay").classList.add("border-flash");
  return (window.setTimeout((() => {
    document.getElementById("video-overlay").classList.remove("border-flash");
  }), 3000.0) | 0);
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__videoActions__Z__V($thiz, enable) {
  if (enable) {
    document.getElementById("startButton").classList.remove("display-inline-block");
    document.getElementById("startButton").classList.add("display-none");
    document.getElementById("sourceSelectPanel").classList.add("display-none");
    document.getElementById("resetButton").classList.remove("display-none");
    document.getElementById("resetButton").classList.add("display-inline-block");
    document.getElementById("video-overlay").classList.remove("video-overlay-backgroundColor-3");
    document.getElementById("video-overlay").classList.add("video-overlay-backgroundColor-1");
  } else {
    document.getElementById("startButton").classList.remove("display-none");
    document.getElementById("startButton").classList.add("display-inline-block");
    document.getElementById("resetButton").classList.remove("display-inline-block");
    document.getElementById("resetButton").classList.add("display-none");
    document.getElementById("video-overlay").classList.remove("video-overlay-backgroundColor-1");
    document.getElementById("video-overlay").classList.add("video-overlay-backgroundColor-3");
  }
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__checkServerStateAndReload__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, functionId, executionContext) {
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(functionId, "", executionContext).hj(new $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2(), executionContext);
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__animateScannerError__V($thiz) {
  document.getElementById("video-overlay").classList.add("border-flash-error");
  window.setTimeout((() => {
    document.getElementById("video-overlay").classList.remove("border-flash-error");
  }), 3000.0);
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__inputDevices$1__Lcom_papasofokli_zxing_BrowserMultiFormatReader__sjs_js_Promise($thiz, codeReader$1) {
  return codeReader$1.listVideoInputDevices();
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__updateInputsMap$1__sr_ObjectRef__s_Option__D__sci_Map($thiz, inputsMap$1, keyO, value) {
  if ((keyO instanceof $c_s_Some)) {
    var key = keyO.bg;
    var $x_1 = inputsMap$1.bL.hk(key, value);
  } else {
    var $x_1;
    var $x_1 = $m_sci_Map$EmptyMap$();
  }
  inputsMap$1.bL = $x_1;
  return inputsMap$1.bL;
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__setVideoTimeOut$4__sr_ObjectRef__s_Option__V($thiz, videoTimeOut$1, value) {
  videoTimeOut$1.bL = value;
}
function $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__getSelectedDeviceId$1__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_zxing_BrowserMultiFormatReader__s_concurrent_Future($thiz, preferBackCameraIndicator$1, ec$2, codeReader$2) {
  return $m_sjs_js_Thenable$ThenableOps$().uE($p_Lcom_papasofokli_zxing_InitializeVideoScanner$__inputDevices$1__Lcom_papasofokli_zxing_BrowserMultiFormatReader__sjs_js_Promise($thiz, codeReader$2)).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((videoInputDevices$2) => {
    if (((videoInputDevices$2.length | 0) > 1)) {
      if (((preferBackCameraIndicator$1 instanceof $c_s_Some) && (!(!preferBackCameraIndicator$1.bg)))) {
        _return: {
          var len = (videoInputDevices$2.length | 0);
          var i = 0;
          while ((i < len)) {
            var x0 = videoInputDevices$2[i];
            var this$8 = $dp_toString__T(x0.label);
            var this$9 = this$8.toLowerCase();
            if (((this$9.indexOf("back") | 0) !== (-1))) {
              var idx = i;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var idx = (-1);
        }
        var this$10 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(videoInputDevices$2[idx]));
        var preselectedCameraO = (this$10.c() ? $m_sjs_js_ArrayOps$().zK($m_sjs_js_ArrayOps$().Nt(videoInputDevices$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => $dp_toString__T(_$2$2.deviceId))), $m_s_math_Ordering$String$())) : this$10);
      } else {
        _return$1: {
          var len$1 = (videoInputDevices$2.length | 0);
          var i$1 = 0;
          while ((i$1 < len$1)) {
            var x0$1 = videoInputDevices$2[i$1];
            var this$16 = $dp_toString__T(x0$1.label);
            var this$17 = this$16.toLowerCase();
            if (((this$17.indexOf("front") | 0) !== (-1))) {
              var idx$1 = i$1;
              break _return$1;
            }
            i$1 = ((1 + i$1) | 0);
          }
          var idx$1 = (-1);
        }
        var this$18 = ((idx$1 === (-1)) ? $m_s_None$() : new $c_s_Some(videoInputDevices$2[idx$1]));
        var preselectedCameraO = (this$18.c() ? $m_sjs_js_ArrayOps$().avY($m_sjs_js_ArrayOps$().Nt(videoInputDevices$2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => $dp_toString__T(_$4$2.deviceId))), $m_s_math_Ordering$String$())) : this$18);
      }
    } else {
      var preselectedCameraO = $m_sjs_js_ArrayOps$().zK(videoInputDevices$2);
    }
    if (preselectedCameraO.c()) {
      var this$23 = $m_s_None$();
    } else {
      var x0$2 = preselectedCameraO.h();
      var this$23 = new $c_s_Some($dp_toString__T(x0$2.deviceId));
    }
    return (this$23.c() ? "undefined" : this$23.h());
  })), ec$2);
}
/** @constructor */
function $c_Lcom_papasofokli_zxing_InitializeVideoScanner$() {
  this.al4 = null;
  this.al4 = "undefined";
}
$p = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$;
/** @constructor */
function $h_Lcom_papasofokli_zxing_InitializeVideoScanner$() {
}
$h_Lcom_papasofokli_zxing_InitializeVideoScanner$.prototype = $p;
$p.b7 = (function(ec) {
  $m_Lcom_papasofokli_util_package$().fo("212a24cd-9b41-4e0c-ba82-fa486016525c").each(((this$1) => (function() {
    var scanInputFunUUID = this.getAttribute("data-scan-input");
    var checkSessionFunUUID = this.getAttribute("data-check");
    var videoOnFlag = this.getAttribute("data-recording-flag");
    var videoId = this.getAttribute("data-video-id");
    var timeOutMinutes = this.getAttribute("data-timeout-minutes");
    var errorInputFunUUID = this.getAttribute("data-error");
    $m_sc_StringOps$();
    var x = this.getAttribute("data-scan-delay");
    var this$4 = $m_sc_StringParsers$().fs(x);
    var default$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 10000));
    var scanDelayMillSecs = ((this$4.c() ? default$1.aA() : this$4.h()) | 0);
    $m_sc_StringOps$();
    var x$1 = this.getAttribute("data-camera-back");
    $m_sc_StringParsers$();
    _return$1: {
      var len = x$1.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(x$1, i);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
            var $x_1 = false;
            break _return$1;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      var preferBackCameraIndicator = new $c_s_Some(true);
    } else {
      _return$3: {
        var len$1 = x$1.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(x$1, i$1);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_2 = false;
              break _return$3;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_2 = true;
        } else {
          var $x_2 = false;
        }
      }
      if ($x_2) {
        var preferBackCameraIndicator = new $c_s_Some(false);
      } else {
        var preferBackCameraIndicator = $m_s_None$();
      }
    }
    $m_sc_StringOps$();
    var x$2 = this.getAttribute("data-input-validation");
    $m_sc_StringParsers$();
    _return$5: {
      var len$2 = x$2.length;
      if ((len$2 === 4)) {
        var i$2 = 0;
        while ((i$2 !== len$2)) {
          var thisCP$2 = $f_T__codePointAt__I__I(x$2, i$2);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$2)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i$2))))) {
            var $x_3 = false;
            break _return$5;
          }
          i$2 = ((i$2 + ((thisCP$2 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_3 = true;
      } else {
        var $x_3 = false;
      }
    }
    if ($x_3) {
      var validateInputIndicatorO = new $c_s_Some(true);
    } else {
      _return$7: {
        var len$3 = x$2.length;
        if ((len$3 === 5)) {
          var i$3 = 0;
          while ((i$3 !== len$3)) {
            var thisCP$3 = $f_T__codePointAt__I__I(x$2, i$3);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$3)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$3))))) {
              var $x_4 = false;
              break _return$7;
            }
            i$3 = ((i$3 + ((thisCP$3 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_4 = true;
        } else {
          var $x_4 = false;
        }
      }
      if ($x_4) {
        var validateInputIndicatorO = new $c_s_Some(false);
      } else {
        var validateInputIndicatorO = $m_s_None$();
      }
    }
    var videoTimeOut = new $c_sr_ObjectRef($m_s_None$());
    var codeReader = $m_Lcom_papasofokli_zxing_ScannerState$().aul(videoId);
    var inputsMap = new $c_sr_ObjectRef($m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $m_sjsr_package$().Vb(new ($d_T2.r().C)([])))));
    var wakeLock = new $c_Lcom_papasofokli_util_WakeLockHandler(ec);
    return $m_sjs_js_Thenable$ThenableOps$().uE($p_Lcom_papasofokli_zxing_InitializeVideoScanner$__inputDevices$1__Lcom_papasofokli_zxing_BrowserMultiFormatReader__sjs_js_Promise(this$1, codeReader)).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((videoInputDevices$2) => {
      var sourceSelect = document.getElementById("sourceSelect");
      if (((videoInputDevices$2.length | 0) > 1)) {
        var default$2 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => false));
        $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__initialiseVideoScannerSelection__sjs_js_Array__Lorg_scalajs_dom_Element__Z__V(this$1, videoInputDevices$2, sourceSelect, (!(!(preferBackCameraIndicator.c() ? default$2.aA() : preferBackCameraIndicator.h()))));
        sourceSelect.addEventListener("change", ((e$2) => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__startVideoDevice__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, codeReader, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((selectElement) => (() => $m_s_concurrent_Future$().aE(selectElement.value)))(e$2.currentTarget)), videoId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => inputsMap.bL)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((keyO$3, value$3) => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__updateInputsMap$1__sr_ObjectRef__s_Option__D__sci_Map(this$1, inputsMap, keyO$3, (+value$3)))), scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$3$1) => {
          $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__setVideoTimeOut$4__sr_ObjectRef__s_Option__V(this$1, videoTimeOut, value$3$1);
        })), videoTimeOut.bL, timeOutMinutes, validateInputIndicatorO, scanDelayMillSecs, ec)));
        var sourceSelectPanel = document.getElementById("sourceSelectPanel");
        sourceSelectPanel.classList.add("display-inline-block");
      } else {
        if (((videoInputDevices$2.length | 0) === 0)) {
          var $x_5 = true;
        } else {
          var this$31 = $m_sjs_js_ArrayOps$().zK(videoInputDevices$2);
          var p$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => {
            var this$30 = $dp_toString__T(_$6$2.deviceId);
            return ((this$30.indexOf("undefined") | 0) !== (-1));
          }));
          var $x_5 = ((!this$31.c()) && (!(!p$1.p(this$31.h()))));
        }
        if ($x_5) {
          $m_Lcom_papasofokli_zxing_CameraPermission$().axd();
        }
      }
      $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__initializeOtherComponents__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__V(this$1, codeReader, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__getSelectedDeviceId$1__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_zxing_BrowserMultiFormatReader__s_concurrent_Future(this$1, preferBackCameraIndicator, ec, codeReader))), videoId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => inputsMap.bL)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((keyO$3$1, value$3$2) => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__updateInputsMap$1__sr_ObjectRef__s_Option__D__sci_Map(this$1, inputsMap, keyO$3$1, (+value$3$2)))), scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$3$3) => {
        $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__setVideoTimeOut$4__sr_ObjectRef__s_Option__V(this$1, videoTimeOut, value$3$3);
      })), videoTimeOut.bL, timeOutMinutes, validateInputIndicatorO, scanDelayMillSecs, ec);
      $m_sc_StringOps$();
      $m_sc_StringParsers$();
      _return$9: {
        var len$4 = videoOnFlag.length;
        if ((len$4 === 4)) {
          var i$4 = 0;
          while ((i$4 !== len$4)) {
            var thisCP$4 = $f_T__codePointAt__I__I(videoOnFlag, i$4);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$4)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i$4))))) {
              var $x_6 = false;
              break _return$9;
            }
            i$4 = ((i$4 + ((thisCP$4 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_6 = true;
        } else {
          var $x_6 = false;
        }
      }
      if ($x_6) {
        var this$39 = new $c_s_Some(true);
      } else {
        _return$11: {
          var len$5 = videoOnFlag.length;
          if ((len$5 === 5)) {
            var i$5 = 0;
            while ((i$5 !== len$5)) {
              var thisCP$5 = $f_T__codePointAt__I__I(videoOnFlag, i$5);
              if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$5)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$5))))) {
                var $x_7 = false;
                break _return$11;
              }
              i$5 = ((i$5 + ((thisCP$5 >= 65536) ? 2 : 1)) | 0);
            }
            var $x_7 = true;
          } else {
            var $x_7 = false;
          }
        }
        if ($x_7) {
          var this$39 = new $c_s_Some(false);
        } else {
          var this$39 = $m_s_None$();
        }
      }
      var default$3 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => false));
      if ((!(!(this$39.c() ? default$3.aA() : this$39.h())))) {
        (window.setTimeout((() => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__startVideoDevice__Lcom_papasofokli_zxing_BrowserMultiFormatReader__F0__T__F0__F2__T__T__T__F1__s_Option__T__s_Option__I__s_concurrent_ExecutionContext__s_concurrent_Future(this$1, codeReader, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__getSelectedDeviceId$1__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_zxing_BrowserMultiFormatReader__s_concurrent_Future(this$1, preferBackCameraIndicator, ec, codeReader))), videoId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => inputsMap.bL)), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((keyO$3$2, value$3$4) => $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__updateInputsMap$1__sr_ObjectRef__s_Option__D__sci_Map(this$1, inputsMap, keyO$3$2, (+value$3$4)))), scanInputFunUUID, errorInputFunUUID, checkSessionFunUUID, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$3$5) => {
          $p_Lcom_papasofokli_zxing_InitializeVideoScanner$__setVideoTimeOut$4__sr_ObjectRef__s_Option__V(this$1, videoTimeOut, value$3$5);
        })), videoTimeOut.bL, timeOutMinutes, validateInputIndicatorO, scanDelayMillSecs, ec)), 1000.0) | 0);
      }
      return wakeLock.an7().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => videoInputDevices$2)), ec);
    })), ec).hj(new $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1(), ec);
  }))(this));
});
var $d_Lcom_papasofokli_zxing_InitializeVideoScanner$ = new $TypeData().i($c_Lcom_papasofokli_zxing_InitializeVideoScanner$, "com.papasofokli.zxing.InitializeVideoScanner$", ({
  tm: 1
}));
var $n_Lcom_papasofokli_zxing_InitializeVideoScanner$;
function $m_Lcom_papasofokli_zxing_InitializeVideoScanner$() {
  if ((!$n_Lcom_papasofokli_zxing_InitializeVideoScanner$)) {
    $n_Lcom_papasofokli_zxing_InitializeVideoScanner$ = new $c_Lcom_papasofokli_zxing_InitializeVideoScanner$();
  }
  return $n_Lcom_papasofokli_zxing_InitializeVideoScanner$;
}
/** @constructor */
function $c_Lcom_papasofokli_zxing_ScannerState$() {
  this.xV = null;
  $n_Lcom_papasofokli_zxing_ScannerState$ = this;
  var $x_1;
  var $x_1 = $m_sci_Map$EmptyMap$();
  this.xV = $x_1;
}
$p = $c_Lcom_papasofokli_zxing_ScannerState$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_zxing_ScannerState$;
/** @constructor */
function $h_Lcom_papasofokli_zxing_ScannerState$() {
}
$h_Lcom_papasofokli_zxing_ScannerState$.prototype = $p;
$p.aul = (function(videoId) {
  return this.xV.f6(videoId, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    console.log("Creating new BrowserMultiFormatReader instance");
    var reader = new $i_$0040zxing$002flibrary.BrowserMultiFormatReader();
    this.xV = this.xV.hk(videoId, reader);
    return reader;
  })));
});
$p.axf = (function(videoId) {
  var this$1 = this.xV.b9(videoId);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    console.log("Resetting scanner...");
    x0.reset();
    this.xV = this.xV.bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$14$2) => {
      var x = _$14$2.P();
      return ((x === null) ? (videoId === null) : $dp_equals__O__Z(x, videoId));
    })));
  }
});
var $d_Lcom_papasofokli_zxing_ScannerState$ = new $TypeData().i($c_Lcom_papasofokli_zxing_ScannerState$, "com.papasofokli.zxing.ScannerState$", ({
  tp: 1
}));
var $n_Lcom_papasofokli_zxing_ScannerState$;
function $m_Lcom_papasofokli_zxing_ScannerState$() {
  if ((!$n_Lcom_papasofokli_zxing_ScannerState$)) {
    $n_Lcom_papasofokli_zxing_ScannerState$ = new $c_Lcom_papasofokli_zxing_ScannerState$();
  }
  return $n_Lcom_papasofokli_zxing_ScannerState$;
}
/** @constructor */
function $c_jl_BoundsChecks$() {
}
$p = $c_jl_BoundsChecks$.prototype = new $h_O();
$p.constructor = $c_jl_BoundsChecks$;
/** @constructor */
function $h_jl_BoundsChecks$() {
}
$h_jl_BoundsChecks$.prototype = $p;
$p.ahU = (function(capacity) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Illegal capacity: " + capacity));
});
$p.ahT = (function(index, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((("Index " + index) + " out of bounds [0, ") + length) + ")"));
});
$p.avA = (function(index, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((("Index " + index) + " out of bounds [0, ") + length) + "]"));
});
$p.ahV = (function(start, end, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((((("Range [" + start) + ", ") + end) + ") out of bounds [0, ") + length) + ")"));
});
$p.mH = (function(offset, count, length) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((((((("Range [" + offset) + ", ") + offset) + " + ") + count) + ") out of bounds [0, ") + length) + ")"));
});
var $d_jl_BoundsChecks$ = new $TypeData().i($c_jl_BoundsChecks$, "java.lang.BoundsChecks$", ({
  tw: 1
}));
var $n_jl_BoundsChecks$;
function $m_jl_BoundsChecks$() {
  if ((!$n_jl_BoundsChecks$)) {
    $n_jl_BoundsChecks$ = new $c_jl_BoundsChecks$();
  }
  return $n_jl_BoundsChecks$;
}
function $is_jl_CharSequence(obj) {
  return ((!(!((obj && obj.$classData) && obj.$classData.n.aO))) || ((typeof obj) === "string"));
}
function $isArrayOf_jl_CharSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aO)));
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, mHat, paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi) {
  this.a97 = 0;
  this.KE = 0;
  this.QJ = 0.0;
  this.QK = null;
  this.afk = 0;
  this.afl = 0;
  this.a97 = chunkLength;
  this.KE = radixPowLength;
  this.QJ = mHat;
  this.QK = paddingZeros;
  this.afk = overflowBarrier_$_lo;
  this.afl = overflowBarrier_$_hi;
}
$p = $c_jl_Long$StringRadixInfo.prototype = new $h_O();
$p.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
}
$h_jl_Long$StringRadixInfo.prototype = $p;
var $d_jl_Long$StringRadixInfo = new $TypeData().i($c_jl_Long$StringRadixInfo, "java.lang.Long$StringRadixInfo", ({
  tJ: 1
}));
/** @constructor */
function $c_jl_Math$() {
}
$p = $c_jl_Math$.prototype = new $h_O();
$p.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
}
$h_jl_Math$.prototype = $p;
$p.aww = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits + y) | 0);
  return (((2139095040 & (newBits | ((bits ^ newBits) >> 8))) !== 2139095040) ? $floatFromBits(newBits) : Math.fround((Math.fround((a + a)) + 1.401298464324817E-45)));
});
$p.awv = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits - y) | 0);
  return (((2139095040 & (newBits | ((bits ^ newBits) >> 8))) !== 2139095040) ? $floatFromBits(newBits) : Math.fround((Math.fround((a + a)) - 1.401298464324817E-45)));
});
$p.axH = (function(d, scaleFactor) {
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, d, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var e = (2047 & ((hi >>> 20) | 0));
  var newE = ((e + scaleFactor) | 0);
  var hi$1 = ((-2146435073) & hi);
  var java$lang$IntFloatBits$Int64Box$$value_$_lo = 0;
  var java$lang$IntFloatBits$Int64Box$$value_$_hi = 0;
  java$lang$IntFloatBits$Int64Box$$value_$_lo = lo;
  java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$1;
  if ((!((((e - 1) | 0) >>> 0) <= 2045))) {
    var hi$2 = (2147483647 & hi);
    if ((((lo | hi$2) === 0) || (hi$2 >= 2146435072))) {
      return d;
    }
    var hi$3 = (1048575 & hi);
    var clz = ((hi$3 !== 0) ? Math.clz32(hi$3) : ((32 + Math.clz32(lo)) | 0));
    newE = ((newE - ((clz - 12) | 0)) | 0);
    var hi$4 = ((-2147483648) & hi);
    var y = ((clz - 11) | 0);
    var lo$2 = (((32 & y) === 0) ? (lo << y) : 0);
    var hi$5 = (((32 & y) === 0) ? (((((lo >>> 1) | 0) >>> (~y)) | 0) | (hi << y)) : (lo << y));
    var hi$6 = (1048575 & hi$5);
    var hi$7 = (hi$4 | hi$6);
    java$lang$IntFloatBits$Int64Box$$value_$_lo = lo$2;
    java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$7;
  }
  if (((((newE - 1) | 0) >>> 0) <= 2045)) {
    var finalNewE = newE;
    var finalSignAndMantissa_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
    var finalSignAndMantissa_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
    var hi$8 = (finalNewE << 20);
    var hi$9 = (hi$8 | finalSignAndMantissa_$_hi);
    var fpBitsDataView$1 = $fpBitsDataView;
    fpBitsDataView$1.setInt32(0, finalSignAndMantissa_$_lo, true);
    fpBitsDataView$1.setInt32(4, hi$9, true);
    return (+fpBitsDataView$1.getFloat64(0, true));
  } else if (((((53 + newE) | 0) >>> 0) <= 53)) {
    var finalNewE$1 = ((54 + newE) | 0);
    var finalSignAndMantissa$1_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
    var finalSignAndMantissa$1_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
    var hi$10 = (finalNewE$1 << 20);
    var hi$11 = (hi$10 | finalSignAndMantissa$1_$_hi);
    var fpBitsDataView$2 = $fpBitsDataView;
    fpBitsDataView$2.setInt32(0, finalSignAndMantissa$1_$_lo, true);
    fpBitsDataView$2.setInt32(4, hi$11, true);
    return (5.551115123125783E-17 * (+fpBitsDataView$2.getFloat64(0, true)));
  } else {
    var finalNewE$2 = (2047 & (~(scaleFactor >> 31)));
    var hi$12 = ((-2147483648) & hi);
    var hi$13 = (finalNewE$2 << 20);
    var hi$14 = (hi$13 | hi$12);
    var fpBitsDataView$3 = $fpBitsDataView;
    fpBitsDataView$3.setInt32(0, 0, true);
    fpBitsDataView$3.setInt32(4, hi$14, true);
    return (+fpBitsDataView$3.getFloat64(0, true));
  }
});
var $d_jl_Math$ = new $TypeData().i($c_jl_Math$, "java.lang.Math$", ({
  tK: 1
}));
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$();
  }
  return $n_jl_Math$;
}
var $d_jl_Runnable = new $TypeData().i(1, "java.lang.Runnable", ({
  co: 1
}));
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().mJ("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < (lines.length | 0))) {
    var line = lines[i];
    if ((line !== "")) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, mtch[1]);
        var $x_5 = classAndMethodName[0];
        var $x_4 = classAndMethodName[1];
        var $x_3 = mtch[2];
        var x$2 = mtch[3];
        var $x_2 = parseInt(x$2);
        var x$3 = mtch[4];
        var $x_1 = trace.push(new $c_jl_StackTraceElement($x_5, $x_4, $x_3, ($x_2 | 0), ((x$3 !== (void 0)) ? (parseInt(x$3) | 0) : (-1))));
      } else {
        (trace.push(new $c_jl_StackTraceElement("<jscode>", line, null, (-1), (-1))) | 0);
      }
    }
    i = ((1 + i) | 0);
  }
  var len = (trace.length | 0);
  var result = new ($d_jl_StackTraceElement.r().C)(len);
  i = 0;
  while ((i < len)) {
    result.a[i] = trace[i];
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().mJ("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().mJ("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().mJ("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().mJ("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().mJ("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchBCOrS[1]), $p_jl_StackTrace$__decodeMethodName__T__T($thiz, matchBCOrS[2])];
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchCTOrN[1]), "<init>"];
    } else {
      var matchM = PatM.exec(functionName);
      return ((matchM !== null) ? [$p_jl_StackTrace$__decodeClassName__T__T($thiz, matchM[1]), "<clinit>"] : ["<jscode>", functionName]);
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ((!(!$m_jl_Utils$Cache$().Cr.call(dict, encodedName)))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = dict$1[encodedName];
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName);
  }
  var this$3 = base.split("_").join(".");
  return this$3.split("\uff3f").join("_");
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.kf) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value;
      }
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0);
    }
    $thiz.QM = dict;
    $thiz.kf = (((1 | $thiz.kf) << 24) >> 24);
  }
  return $thiz.QM;
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.kf) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.QM);
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.kf) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.QN = dict;
    $thiz.kf = (((2 | $thiz.kf) << 24) >> 24);
  }
  return $thiz.QN;
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.kf) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.QN);
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.kf) << 24) >> 24) === 0)) {
    $thiz.QL = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.kf = (((4 | $thiz.kf) << 24) >> 24);
  }
  return $thiz.QL;
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.kf) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.QL);
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  if ((!(!encodedName.startsWith("init___")))) {
    return "<init>";
  } else {
    var methodNameLen = (encodedName.indexOf("__") | 0);
    return ((methodNameLen < 0) ? encodedName : encodedName.substring(0, methodNameLen));
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ((!(!(!(!(!e))))) ? [] : ((!(!(!(!(e.arguments && e.stack))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ((!(!(!(!(e.stack && e.sourceURL))))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ((!(!(!(!(e.stack && e.number))))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ((!(!(!(!(e.stack && e.fileName))))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ((!(!(!(!(e.message && e["opera#sourceloc"]))))) ? ((!(!(!(!(!e.stacktrace))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ((!(!(!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length)))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ((!(!(!(!((e.message && e.stack) && e.stacktrace))))) ? ((!(!(!(!(e.stacktrace.indexOf("called from line") < 0.0))))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ((!(!(!(!(e.stack && (!e.fileName)))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))));
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return (e.stack + "\n").replace($m_jl_StackTrace$StringRE$().mJ("^[\\s\\S]+?\\s+at\\s+"), " at ").replace($m_jl_StackTrace$StringRE$().iw("^\\s+(at eval )?at\\s+", "gm"), "").replace($m_jl_StackTrace$StringRE$().iw("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2").replace($m_jl_StackTrace$StringRE$().iw("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)").replace($m_jl_StackTrace$StringRE$().iw("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2").split("\n").slice(0, (-1));
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().iw("(?:\\n@:0)?\\s+$", "m"), "").replace($m_jl_StackTrace$StringRE$().iw("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@").split("\n");
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = e.stack.replace($m_jl_StackTrace$StringRE$().iw("^\\s*at\\s+(.*)$", "gm"), "$1").replace($m_jl_StackTrace$StringRE$().iw("^Anonymous function\\s+", "gm"), "{anonymous}() ").replace($m_jl_StackTrace$StringRE$().iw("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2").split("\n");
  return qual$1.slice(1);
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().iw("\\[native code\\]\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().iw("^(?=\\w+Error\\:).*$\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().iw("^@", "gm"), "{anonymous}()@").split("\n");
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().iw("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = e.message.split("\n");
  var result = [];
  var i = 2;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      (result.push(((("{anonymous}()@" + mtch[2]) + ":") + mtch[1])) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().iw("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = ((x !== (void 0)) ? x : "{anonymous}");
      (result.push(((((fnName + "()@") + mtch[2]) + ":") + mtch[1])) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().mJ("^(.*)@(.+):(\\d+)$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[1];
      var fnName = ((x !== (void 0)) ? (x + "()") : "global code");
      (result.push(((((fnName + "@") + mtch[2]) + ":") + mtch[3])) | 0);
    }
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().mJ("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var location = ((((mtch[4] + ":") + mtch[1]) + ":") + mtch[2]);
      var x$3 = mtch[2];
      var fnName0 = ((x$3 !== (void 0)) ? x$3 : "global code");
      var fnName = fnName0.replace($m_jl_StackTrace$StringRE$().mJ("<anonymous function: (\\S+)>"), "$1").replace($m_jl_StackTrace$StringRE$().mJ("<anonymous function>"), "{anonymous}");
      (result.push(((fnName + "@") + location)) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return [];
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < ($p_jl_StackTrace$__compressedPrefixes__O($thiz).length | 0))) {
      var prefix = $p_jl_StackTrace$__compressedPrefixes__O($thiz)[i];
      if ((!(!encodedName$1.startsWith(prefix)))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        return (("" + dict[prefix]) + encodedName$1.substring(prefix.length));
      } else {
        i = ((1 + i) | 0);
      }
    } else {
      return ((!(!encodedName$1.startsWith("L"))) ? encodedName$1.substring(1) : encodedName$1);
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.QM = null;
  this.QN = null;
  this.QL = null;
  this.kf = 0;
}
$p = $c_jl_StackTrace$.prototype = new $h_O();
$p.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
}
$h_jl_StackTrace$.prototype = $p;
$p.atL = (function(jsError) {
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError));
});
var $d_jl_StackTrace$ = new $TypeData().i($c_jl_StackTrace$, "java.lang.StackTrace$", ({
  tO: 1
}));
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$();
  }
  return $n_jl_StackTrace$;
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
}
$p = $c_jl_StackTrace$StringRE$.prototype = new $h_O();
$p.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
}
$h_jl_StackTrace$StringRE$.prototype = $p;
$p.mJ = (function(this$) {
  return new RegExp(this$);
});
$p.iw = (function(this$, mods) {
  return new RegExp(this$, mods);
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().i($c_jl_StackTrace$StringRE$, "java.lang.StackTrace$StringRE$", ({
  tP: 1
}));
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$();
  }
  return $n_jl_StackTrace$StringRE$;
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.a98 = null;
  this.xX = null;
  $n_jl_System$Streams$ = this;
  this.a98 = new $c_jl_JSConsoleBasedPrintStream(false);
  this.xX = new $c_jl_JSConsoleBasedPrintStream(true);
}
$p = $c_jl_System$Streams$.prototype = new $h_O();
$p.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
$h_jl_System$Streams$.prototype = $p;
var $d_jl_System$Streams$ = new $TypeData().i($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  tU: 1
}));
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = ({});
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  result["java.vm.version"] = "1.22.0";
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result;
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.QO = null;
  this.a99 = null;
  $n_jl_System$SystemProperties$ = this;
  this.QO = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.a99 = null;
}
$p = $c_jl_System$SystemProperties$.prototype = new $h_O();
$p.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
}
$h_jl_System$SystemProperties$.prototype = $p;
$p.Uv = (function(key, default$1) {
  if ((this.QO !== null)) {
    var dict = this.QO;
    return ((!(!$m_jl_Utils$Cache$().Cr.call(dict, key))) ? dict[key] : default$1);
  } else {
    return this.a99.Uv(key, default$1);
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().i($c_jl_System$SystemProperties$, "java.lang.System$SystemProperties$", ({
  tV: 1
}));
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$();
  }
  return $n_jl_System$SystemProperties$;
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.QP = false;
  this.a9a = null;
  this.QP = false;
}
$p = $c_jl_ThreadLocal.prototype = new $h_O();
$p.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
}
$h_jl_ThreadLocal.prototype = $p;
$p.h = (function() {
  if ((!this.QP)) {
    this.Jb(null);
  }
  return this.a9a;
});
$p.Jb = (function(o) {
  this.a9a = o;
  this.QP = true;
});
var $d_jl_ThreadLocal = new $TypeData().i($c_jl_ThreadLocal, "java.lang.ThreadLocal", ({
  tX: 1
}));
/** @constructor */
function $c_jl_UnicodeData$() {
  this.a9f = null;
  this.a9e = null;
  $n_jl_UnicodeData$ = this;
  this.a9f = $constArrSDiffs_I(161, "8l]]]]]]]]L]]]]]4]]]]]]]]]]]]]]L]]]]zLi]]_{]]z^_^|ya]n]]]]]]]]]l]^]]|]Of]]]]]]]]]]]]]]]]]]]]]]]]]0q`{byaOd]]]]]]]]]]]]]]]]]]]]]]]]]0paz`7s]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]Gz");
  this.a9e = $constArrUDiffs_I(2891, "D4u4_@_4|7^80003f3H0004u3y3t4i3|4^3z3o8m3d4s100004]300004`3m80003w3H0004v3j<j3f2Lu3eL^30t3f10|70^23|60^G]7|9]@^:|8^7|A^7|;]8^;|9^7|L^?|@^:|9^?|7^4`4y7^8`?y4_4|7^4{7_4|23|2<^7^4{?]9]7;^G|9^7|8^>|=]13^8@`3z8003<_3H0014]8000L]3H0008t?f1@t8001Gf3H000DtKf4t3f4t23h8008D]3H0004]58x?`4t4c6|80008a3H0003{<s3f3|@x7c100004t300003f;|4^3|4^9^6|1O|4^14^4=]7|7]8^<|2O^@|7u4f;|8^6|68^60|47x3gD^8w6L^1G|<2|4^4G|8a4qGg54s3y3i8y7{3c4c3N]1Fk5o2o5k6o5k6o5k1w10b3;x@b@p7e1<mHf;|8_3{8a9g1:o3u4e;j3O|4^1:^1B]6]J`18l?j:^1|<<p3j6^Jg4i3g:]={:_6s3g>]1|8a17y<t7f4p1Ge4m3r6^1|3J^1N]1;w8b;6^19|3x1Hf17y44^13{8u3y;i3y8c4q7h2J^6]7{6_11{6_9{6_>]3w8u1Ke4b34^;w8u3e4b1;xDb30s3gGx4m7mHcO|53|4_1:]1>]8g5sJ]J]2<_1z6J^4_2{9_;{10_={6_6z7^>]9|1:^6o7n18l3i4^1N^4_5u4bOx8b7x8b2Gx4bKx4b3x<b?x9c9_;{=w:e5u:e6z6x12e1u@b7x4b>^5w8f17y8r7nHn3{3h4p3k3w:c8_1u4bGx@b7x8b2Gx4bKx4b7x4b7x4b7x8c3w6e;{5wBc5w:c6]3w>c1wLb?x4b3xLf19z5|>^2o3e1:c8_1u4b13x4b;x4b2Gx4bKx4b7x4bCx9c9_;{Aw6c8_1u6e5{3w8b3x1Lb:^5w8f18l4_3cLb6^:];w6c4_5u4bOx8b7x8b2Gx4bKx4b7x4bCx9c9_3{4_3{=w:e5u:e5{3wLc6]4_1u@b7x4b>^5w8f18p3f4cGr1:c1|3x4bGx<b;x4b?x<b7x4b3x4b7x<b7x<b;x<b1?xBe7{4_5u>e9u6e9{3w8b3xJe1u1Hf18_<nG{4_3aFc4_;{1|Ox4b;x4b2Kx4b1Ox9c9]<_=u6c9w6c:]3wNc5w4b;x8b3x8b:^5w8f17tLu3pLn3f6^4_6m3jOx4b;x4b2Kx4b17x4bCx9c9_3{4_Au6c4_5u6e7{2]3wNe5uHb7x4b:^5w8f17t4b:`1u1Bc8_5z13x4b;x4b54^7|6`;{=w6e9u6e:z7t3a@b>`2`Kw>^5w8f18_14n3fGx6c4_5u4b27x<b2Ox4b13x4b3x8bKx<c3wBe;{9w6c1w6eMuHf17t:e6m3e1@b62^1|:^Iw@w3hG|4_J]2]4o3n18l7e4Db7x4b3x4bCx4b2Ox4b3x4b1:^1|:^F]6]5|3x8bCx4a3y4cF]2]3w4f17t8b?x40b4t;y1La3y4a;g8sGj18_18n3g4s3g4s3g5l>p7zOx4b4?xBc1H_3{>]4o3k7|F^19w6c4=w4yOg4sGa4y7yDa?y7e4Db5>`7{@_3{B]6_1{:_7{5|4a18lGjJ`7{5|B^9|6`9z:`Iz>^=|1F^4_7{8_G{1|6`2^19|;{2s7b4G|4^3|D^3|8_5<s80003i3H0003{<`193x4b?x8bKx4b3x4b?x8b53x4b?x8b43x4b?x8bKx4b3x4b?x8b1Kx4b73x4b?x8b8;x8c<o100013p300014]1;r<b20t17aH^:G|8_G{8q3n2=@t3y3j24d3v39n6g<b9<p;o;xOxLb2:^6]4_3u14b2>^6_4m7e14b2:^5w1@b1Cx4b;x6c5w1@b6@^:_3{L_O{4_5{1<o;i4q<_4h6x8f17tHh17rHuGy4a?k<g3s4`17tHb4;|4^6CxLb20000F^200005|4:^1|3xDb8Gx18b3Kx6c<_?{8_9uBe7{4_E{;w@y3a<u7n17y3Gx8bCx1<b5?x@b37xHf100018_300003r<y47f2N^8_7{1w8u7j6F`3{4_3{Iw4c6_3{4_7{10_G{6]Ow8c4`17tHf17tHuKi4qGe8c1H^5|6]1>]9w66c@_1z5L^6_3{D_3{4_C{4_2]3zOx<f18lLa17g14s13y7e6c8_1z3J`3{@_7{6_3{6]5|8a17y5@^6_3{8_;{4_3{:_7u10u?j4B`O{10_7{2]3w<uCn17t<b<a17y3G|Hq7g13{L^5;|8^<tOe10c<o3k1D_3{K|A]7]E^6|4`3{7|3xD_8005@_3H007K{8001D_3H0003{80048_3H004D_4N]1F]1<xBG^10|<7^O|10^G{8^G|8_O|10^O|10^G{8^G|8_O{4^3|4^3|4^3|5_7]K|10^1G{8_10^O|10^O|10^O|C{4_7|@_4u3d4v;d;{4_7|@_4u;d?{8_7|?|4x;dO|Dw;b8_;{4_7|@_4u7b4i1<aDaHa9b6u4e8^3t4e3x10r7`Cy4i15c6w?|8^<^4z7_1<^3|3|4^17q4aCm4m17x80003v3H0003y8hHk<z80006k3H0004d18k<z6g80004a3H001Cy<w43c1Lc1D^?|4^;|1?w1Ly7b4x?b4x8c6|8^7|<^4w3b4x200007z200003eDxGb4x3b4x3b4x3b20000@x200004b7]<^4`?z4w7c7|8uDf7]<w3z4`7c4w3l@001O|3H0020]3H0020]<u7e@^4n7a@vD`Cz8`?z4`7z4`7z4`Kz4`3Kz8`7z4`3z4`3Kz11@`10v?d2?z8`Lw7c:3z4`3Gz34`4OzH`8Ca34y1;a2Dh7@n@0038]3H0038]3H0037l2HnFKz4`13z4`6Gz10`=Kz4`O0v1Fs3Hn5?zDz7`3Ly17a20`OOz@<z2G`7Ly?a40y7a108`5Oz2D`7zH`4Ka8y3Oa4y=3b60^60|;]8^9]J|=]<^;]8000D_3H0007z=]<;^4wHc?a<x6|Du?p4j7g4G{4_3{D_3{8b6OxLa4q3e1Ib7]2Gx14bKx4bKx4bKx4bKx4bKx4bKx4bKx4bKx6c3No9b>x=c6w5b6x13y4a7y4a5b6x9b7uO`Ci4q17y8a?y4a3z4`1Da7y<{N{3i48y37a4y;3a1@yJGa38y1?a@i4i<a3e4^4b5h17d8vN|5_7]4c3k13y@_8i3mDu7k;w4^4p4a7a4b:Gx8c200008r200007f8^4l3n;8p3i<^3xDb5;x4b;Gx4y7l@n17f40t4?a1@b20t3Ka4h18n3Gl10n3l1Ln3Ol18n4Kl1Ln17OfIH0t7Of2B2C|4^4>Kx<y6Ka14b4O|Hq7j11?|4q;j20a17y7x2A^5Ha7_<n5kN]8o3i4z8003?`3H000:_5|8Hb17y8oGe10x2Kf14t8c1G^8|8007G`3H0003{11]C|17`4t8d?`4y?^8|2C]A]7]A]1O]=^:{E^6|4_3{5^B|80030a3H000<{7`80003|3H0007{4`N^1|=^6|>^1|2N`7{8_2q?g3w<hHn7{4_3aHb6@p?e12e5z6:`1M{6]1w10u7n17tHc27|Hp;j4p3j:^2`17y3B^B]<o7j2N^1<_2]3u1<u3j3Cx>c<_1z5L^6_7{@_7{8_6]4m1Ce4a4b17t@u7jF^1{4^14a17yCx4b56^H_7{8_7{5w14b>^1|12^4_1u8f17t8u?j1O|4^Ht;f6`3{4_1z6:^1|6^9|:^5|F^2|>x30b7|4q7j1>`3{8_6m7j3|:a1{3w18bGx8bGx8bGx14bKx4bKx4_5<v80003f3H000?{80014_3H0004t7b@_:0`4>`7{4_7{4_6m3m3{3w8f17tHb1;D?x1@b2Kx@b63x@p7OO|HOOp1=Gx8b=7x4H_K{1@_C{Db6^1|18q3i1Cx4bCx4b3x4b7x4b7x4b=@s23b20b1==n7c1Of7Ox8b6GxLy3a40b1@r4_;g20oL{7_3eHc20o3y8`8|1O_8{7_?|<^;e4u?y5_G_<^3x4b;d4u4_3{7e@bCx4b@Kx8m3m4u<_3{<z7`4^3|3y4a7n18l8^;|7f38q4`3{4b3y4a3d38p4a3z4`4z7_4z7`7j17|4^5C|8^3Kx<bGx8bGx8bGx8b;x<w7|4_4^3{7c4y3z@`7a18m<i7a8b1?x4b37x4b2;x4b7x4b1Kx8b1Gx48b?;xDu;e@h5Cr<y13k6D^@n23l8n;a4y1Ca<y3a5Ly5Cg3w@8b3Cx<b63x1Lc4b3;r@b40c?r14b2@b3x10b3sDb4J^AwDb3Gx4u3j4?x@b10p3oCs58^50^50`9Gx8f17tH^4?|@_4?{@b4Ox10b6?x1<u3f1;|4^1K|4^K|4^7|4_1;{4_1K{4_K{4_7{8<b16Kx14b2Gx18bOx80030a3H0004]80008]3H000;y80004a3H0057y80004a3H0013y8DbGx8b3x4b5?x4b7x<b3x8b2Kx4u3pOw2Lt7lKw3Kx10h13r60b2;x4b7xDhCw2HcGr<u3j37xDu3e80b6Ox@h7w8c1Or8h5Gw6^9w6c5wFc=|?x4b;x4b3Cx8c;w@c4b13rLu13eLb3Dc8j3j3Dc;r40b10t3f3@^7w@hDjKe14b6Gx<uKj2Gx8hOw2;xDhOw27xLu?e1@hKr:0b93x6L^6;|1D_6;{LhGw4B^=w10f17t14Hh3Kr4b57x6c6k3i8b7x9<c;|3Dc17w3x10b2H^1<b@jCe2Hb28^@o?e4Hb2DcKr2@b2Kx16e3{4_1z6F^1F]4oKe@h2?{18z6|6^5|3x14c6]8_1z5F`;{@_5{8o7u4eAk1w18m3m8b33xLf17tJc9|4B^D_3{F]7w4f18l?j6`5z3x10b4<^4o7j3x16c8_1z62`;{14_2]3z@p?k@o5m3{2`17y4p3j4p;e4h2?r1<b27x4b36`;{<_7{2_3{6]2oIk1|:^1w7HbKx4b3x4b?x4b1Kx4b18p3eHb5N^4_;{F]7wDf17tJc8_5u4bOx8b7x8b2Gx4bKx4b7x4bCx4c7|6`7{4_=u:e5u:e6]3u8b3xJe1uDbF`5u8cKw<cCwA<b6F`;{10_5{6]8_2{6|<pCn18l7e4u4k6|7x3Hb62`;{H_3{4_?{8_1{7|8p3j3x10f17tDHb5N`;{=w:e?{8_1{8o2KjB^5w48b62`;{10_7{4_1{6]2o;j3x1<f17tHu1Ce2<b5>^4_3{4_7{F_4z7p3eHf17t6Hb3;x:c<_7{@_3{>]3w@f18_8j<a3fKxG4b5B`;{14_1{8o3e<@^40^40d18_13r1@bOx8b3x8bOx4b7x4b32`Eu6e5u:c6_4{9_1z6`1{4o;e14f17t8HbOx8b4N`;{=w:c8_>{7o3j6`1u3<b6^15|50^:]@_1z6^>oOk3w10b6^H_7{9|5J^1D_1{8o;j4pCe1Db93xLu17eNHb13x4b4F`3{Iw6cH_2z7pCe18f18_2;r<u7j3Gx:c2Ew6e3{L_3{8_3{5w94bKx4b7x4b4J^Ew>c1w6c5w6c:]6]2]7|6^1w10f17tHbGx4b7x4b42`Au6c5w6e7{4_2z6xLf17t16Hb2>^8_6m7eNc5|6`1z1Cx4b4:`7{Aw>e7{2_3{4o1Cn17t:Hb3x1Lh2DnO{@_23a1Du3j3C7x<Hg=Ks4uCe1<bH?x:9@b<4p7e1Db460h20s6|D^1Kw?E8b28Kx11G4b273xLb3Kx4f17t@u7j9Kx4f17tHb3Gx8cDo3e18b60^LoDa?e@q4a3a18f17t4hKr4b2CxDb2;x2F0^40^40f2Lj?e<Db9;xBc1|6`6IuNc={1Cy80a8q3i4_3w1>e5u1HbGNOx10b4JGx58b13x12LLa?y4aKy4a7y4b14;x1Lb3x3Db;x8b3x1Hb?x10b1A?x90@b=;xDb1Cx<b13xLb17x8y3g6]2o3u?mB;@c5Gw8c2Kw14y>?a7@yNGa18y4Ka8y7?i7{<s;iHeOs10s7gLs3Gg@s7Ca2Dy87g<s3a?8h2?r1@h2?r1@y:Ka14h33r@L^38^37|38^K{4_27|38^37|3|4^7|8^3|8^7|8^?|4^10^?{4_3{4_K{4_1;|38^37|7|4^?|8^O|4^K|4_37|7|4^?|4^C|4^3|<^K|4_37|38^37|38^37|38^37|38^37|38^37|38^3?{8^34u3f34t3fG|34u3f34t3fG|34u3f34t3fG|34u3f34t3fG|34u3f34t3fH|6|8f68p1OOg6Ls?g68sOg4s1Gg4s7yCe1LcCw4c1Kw4:0_18`3z2?{H_G{JFcIw6c21w:cIw6c5w6cAw8000Da3H007Gy46c1w>0b5Cx<cK{Ky8f17t@b4t3a180b3H^3w24b5@^@`17tDw3c1J0b3;|4_@`17t2LHbKx4b?x4b7x4b1Kx4bHCx8h13xKw54^48^48a>]2];{3y@f17t@u7e324h7<n3l<l3n?r9@h5Dn3l1KrH8b?x4b3;x4b7x4b3x8b3x4b17x4b?x4b3x4b3xHb3x@b3x4b3x4b3x4b;x4b7x4b3x8b3x4b3x4b3x4b3x4b3x4b7x4b3x8b?x4bKx4b?x4b?x4b3x4b17x4b23xDb;x4bCx4b23x6@v7d11Hy5?a@y<?a1@y1Ka8y1Ka4y1Ka4y4Ca18h1Dn@004<]3@0038]@000H]3@0038]@000H]3@0038]4?a70y3Ca1Dy5?a@y13aLy7a1HyGaC8yO;|D^2JOa@y23a<y1Ca<y>Ka@y;KaHy1?a@y3a1Ly1?a@y6Oa10y17aHy4Oa10y3Ga8y7a9Hy1:?a1@y1Ga8y1Ca<y13aLy5Ga4yKa10y1Ga@y13aLy13aLyB;a4y6Ka4Df17t40Hb56KOx40b@77xHbKGx8bF@7x1HbM63x<3Lb23Gx5L8bC9;xDb@;Ox2FL:4m3m3Hm;Om@0cMOw7N20o7OOGk8o7OOGk");
}
$p = $c_jl_UnicodeData$.prototype = new $h_O();
$p.constructor = $c_jl_UnicodeData$;
/** @constructor */
function $h_jl_UnicodeData$() {
}
$h_jl_UnicodeData$.prototype = $p;
$p.avE = (function(cp) {
  if (((cp >>> 0) > 1114111)) {
    return 0;
  } else {
    var shiftedCP = (cp << 7);
    var dataRanges = this.a9e;
    var low = 0;
    var high = 2891;
    while ((((1 + low) | 0) !== high)) {
      var mid = ((((low + high) | 0) >>> 1) | 0);
      if (((shiftedCP >>> 0) < ((268435328 & dataRanges.a[mid]) >>> 0))) {
        high = mid;
      } else {
        low = mid;
      }
    }
    var data = dataRanges.a[low];
    var parityBit = ((1 & cp) & ((data >>> 5) | 0));
    return ((((-268435329) & data) ^ parityBit) ^ (parityBit << 1));
  }
});
$p.UO = (function(cp) {
  return (((cp >>> 0) < 161) ? ((128 & this.a9f.a[cp]) !== 0) : ((((28672 & (1 << this.avE(cp))) !== 0) && (cp !== 8199)) && (cp !== 8239)));
});
var $d_jl_UnicodeData$ = new $TypeData().i($c_jl_UnicodeData$, "java.lang.UnicodeData$", ({
  tY: 1
}));
var $n_jl_UnicodeData$;
function $m_jl_UnicodeData$() {
  if ((!$n_jl_UnicodeData$)) {
    $n_jl_UnicodeData$ = new $c_jl_UnicodeData$();
  }
  return $n_jl_UnicodeData$;
}
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.Cr = null;
  $n_jl_Utils$Cache$ = this;
  this.Cr = Object.prototype.hasOwnProperty;
}
$p = $c_jl_Utils$Cache$.prototype = new $h_O();
$p.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
}
$h_jl_Utils$Cache$.prototype = $p;
var $d_jl_Utils$Cache$ = new $TypeData().i($c_jl_Utils$Cache$, "java.lang.Utils$Cache$", ({
  tZ: 1
}));
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$();
  }
  return $n_jl_Utils$Cache$;
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0;
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined";
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gv)));
}
var $d_jl_Void = new $TypeData().i(0, "java.lang.Void", ({
  gv: 1
}), ((x) => (x === (void 0))));
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch");
}
function $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, componentType, offset, dimensions$1) {
  var length = dimensions$1.a[offset];
  var result = componentType.ax.U(length);
  var innerOffset = ((1 + offset) | 0);
  if ((innerOffset < dimensions$1.a.length)) {
    var innerComponentType = componentType.ax.Q();
    var i = 0;
    while ((i !== length)) {
      result.a[i] = $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, innerComponentType, innerOffset, dimensions$1);
      i = ((1 + i) | 0);
    }
  }
  return result;
}
/** @constructor */
function $c_jl_reflect_Array$() {
}
$p = $c_jl_reflect_Array$.prototype = new $h_O();
$p.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
}
$h_jl_reflect_Array$.prototype = $p;
$p.awq = (function(componentType, dimensions) {
  var len = dimensions.a.length;
  if ((len === 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var outermostComponentType = componentType;
  var i = 1;
  while ((i !== len)) {
    outermostComponentType = $objectGetClass(outermostComponentType.ax.U(0));
    i = ((1 + i) | 0);
  }
  return $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O(this, outermostComponentType, 0, dimensions);
});
$p.b1 = (function(array) {
  if ((array instanceof $ac_O)) {
    return array.a.length;
  } else if ((array instanceof $ac_Z)) {
    return array.a.length;
  } else if ((array instanceof $ac_C)) {
    return array.a.length;
  } else if ((array instanceof $ac_B)) {
    return array.a.length;
  } else if ((array instanceof $ac_S)) {
    return array.a.length;
  } else if ((array instanceof $ac_I)) {
    return array.a.length;
  } else if ((array instanceof $ac_J)) {
    return ((array.a.length >>> 1) | 0);
  } else if ((array instanceof $ac_F)) {
    return array.a.length;
  } else {
    if ((!(array instanceof $ac_D))) {
      $p_jl_reflect_Array$__mismatch__O__E(this, array);
    }
    return array.a.length;
  }
});
var $d_jl_reflect_Array$ = new $TypeData().i($c_jl_reflect_Array$, "java.lang.reflect.Array$", ({
  u0: 1
}));
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$();
  }
  return $n_jl_reflect_Array$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.QT = null;
  this.QU = null;
  this.QT = quot;
  this.QU = rem;
}
$p = $c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $p;
$p.ayA = (function() {
  return new ($d_Ljava_math_BigInteger.r().C)([this.QT, this.QU]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().i($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  u3: 1
}));
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
$p = $c_Ljava_math_BitLevel$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
$h_Ljava_math_BitLevel$.prototype = $p;
$p.DQ = (function(bi) {
  if ((bi.aX === 0)) {
    return 0;
  } else {
    var bLength = (bi.bb << 5);
    var highDigit = bi.aN.a[((bi.bb - 1) | 0)];
    if ((bi.aX < 0)) {
      if ((bi.MM() === ((bi.bb - 1) | 0))) {
        highDigit = ((highDigit - 1) | 0);
      }
    }
    bLength = ((bLength - Math.clz32(highDigit)) | 0);
    return bLength;
  }
});
$p.ajH = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount !== 0) | 0);
  var resLength = ((((source.bb + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().an8(resLength);
  var resDigits = new $ac_I(resLength);
  this.Vr(resDigits, source.aN, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.aX, resLength, resDigits);
  result.jm();
  return result;
});
$p.Vr = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = ((result.a.length - intCount) | 0);
    source.av(0, result, intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.a[((result.a.length - 1) | 0)] = 0;
    var i = ((result.a.length - 1) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.a[ev$1] = (result.a[ev$1] | ((source.a[((((i - intCount) | 0) - 1) | 0)] >>> rightShiftCount) | 0));
      result.a[((i - 1) | 0)] = (source.a[((((i - intCount) | 0) - 1) | 0)] << count);
      i = ((i - 1) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var value = i$1;
    result.a[value] = 0;
    i$1 = ((1 + i$1) | 0);
  }
});
$p.axW = (function(source) {
  var srcLen = source.bb;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.ajI(resDigits, source.aN, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.aX, resLen, resDigits);
  result.jm();
  return result;
});
$p.ajI = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var value = i;
    var iVal = source.a[value];
    result.a[value] = ((iVal << 1) | elem);
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    result.a[srcLen] = elem;
  }
});
$p.ajJ = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= source.bb)) {
    return ((source.aX < 0) ? $m_Ljava_math_BigInteger$().KH : $m_Ljava_math_BigInteger$().pZ);
  } else {
    var resLength = ((source.bb - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.ajK(resDigits, resLength, source.aN, intCount, andCount);
    if ((source.aX < 0)) {
      var i = 0;
      while (((i < intCount) && (source.aN.a[i] === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = ((source.aN.a[i] << ((-andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.a[i] === (-1)))) {
          resDigits.a[i] = 0;
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        resDigits.a[ev$1] = ((1 + resDigits.a[ev$1]) | 0);
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.aX, resLength, resDigits);
    result.jm();
    return result;
  }
});
$p.ajK = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.a[i] === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    source.av(intCount, result, 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.a[i] << leftShiftCount) === 0))));
    i = 0;
    while ((i < ((resultLen - 1) | 0))) {
      result.a[i] = (((source.a[((i + intCount) | 0)] >>> count) | 0) | (source.a[((1 + ((i + intCount) | 0)) | 0)] << leftShiftCount));
      i = ((1 + i) | 0);
    }
    result.a[i] = ((source.a[((i + intCount) | 0)] >>> count) | 0);
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $TypeData().i($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  u4: 1
}));
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = s.length;
  while (((zeroPrefixLength < len) && (s.charCodeAt(zeroPrefixLength) === 48))) {
    zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
  }
  var beginIndex = zeroPrefixLength;
  return s.substring(beginIndex);
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.QW = null;
  this.QV = null;
  $n_Ljava_math_Conversion$ = this;
  this.QW = $constArrSDiffs_I(37, "|]1]qy{{]||]|]]]|]]]]]]|]]]]]]]]]]]]]|");
  this.QV = $constArrRaw_I(35, "44444jyh:M84444HMFcl@54rWNmaTjUU44444aL`OT54BguFYiimD444YbI@HxAD48hyOyr:kd444448mMLUP4@kyInVbULE44pJDqYSRi:HB@h5m`ip@444`iHLBqd74uRRJ`L`OT54H`C;QZ8U[48foiJHwPFE444449DGvo8HPG5OQLS`i54eRF44");
}
$p = $c_Ljava_math_Conversion$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
$h_Ljava_math_Conversion$.prototype = $p;
$p.amX = (function(bi, radix) {
  var sign = bi.aX;
  var numberLength = bi.bb;
  var digits = bi.aN;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var highDigit = digits.a[((numberLength - 1) | 0)];
    var v_$_lo = highDigit;
    var v_$_hi = 0;
    if ((sign < 0)) {
      var x_$_lo = v_$_lo;
      var x_$_hi = v_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$1 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      v_$_lo = lo;
      v_$_hi = hi$1;
    }
    var this$4 = $m_jl_Long$();
    var i_$_lo = v_$_lo;
    var i_$_hi = v_$_hi;
    return (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34)) ? $m_RTLong$().gc(i_$_lo, i_$_hi) : this$4.avC(i_$_lo, i_$_hi, radix));
  } else if (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34))) {
    return $m_Ljava_math_Conversion$().qP(bi);
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ((+Math.log(a)) / (+Math.log(2.0)));
    var addForSign = ((sign < 0) | 0);
    var biAbsLen = $m_Ljava_math_BitLevel$().DQ(bi.afp());
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      digits.av(0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = this.QW.a[radix];
      var bigRadix = this.QV.a[((radix - 2) | 0)];
      while (true) {
        elem$2 = $m_Ljava_math_Division$().U6(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          elem = (("" + $cToS($m_jl_Character$().au3(((elem$2 % $checkIntDivisor(radix)) | 0), radix))) + elem);
          elem$2 = ((elem$2 / $checkIntDivisor(radix)) | 0);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue;
          }
          break;
        }
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = ((elem$1 - 1) | 0);
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        i$1 = ((elem$3 - 1) | 0);
        while (((i$1 > 0) && (temp.a[i$1] === 0))) {
          i$1 = ((i$1 - 1) | 0);
        }
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.a[0] === 0)))) {
          continue;
        }
        break;
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var value = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & (digits.a[value] >> (j << 2)));
          elem$1 = ((elem$1 - 1) | 0);
          var i$3 = elem$2;
          elem = (("" + (i$3 >>> 0.0).toString(16)) + elem);
          j = ((1 + j) | 0);
        }
        i$2 = ((1 + i$2) | 0);
      }
    }
    var dropLen = 0;
    while ((elem.charCodeAt(dropLen) === 48)) {
      dropLen = ((1 + dropLen) | 0);
    }
    if ((dropLen !== 0)) {
      var this$22 = elem;
      var beginIndex = dropLen;
      elem = this$22.substring(beginIndex);
    }
    return ((sign === (-1)) ? ("-" + elem) : elem);
  }
});
$p.qP = (function(bi) {
  var sign = bi.aX;
  var numberLength = bi.bb;
  var digits = bi.aN;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = digits.a[0];
    var absStr = (i >>> 0.0).toString(10);
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    digits.av(0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = ((tempLen - 1) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.a[i$1];
        var aHat = ((4.294967296E9 * (value >>> 0.0)) + (value$1 >>> 0.0));
        var x = (1.0000000000000017E-9 * aHat);
        var lo = (x | 0.0);
        var hi$2 = ((2.3283064365386963E-10 * x) | 0.0);
        var rHat = ((value$1 - Math.imul(1000000000, lo)) | 0);
        if ((rHat < 0)) {
          var lo$1 = ((lo - 1) | 0);
          var hi$3 = ((((hi$2 - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
          var x$2_$_lo = lo$1;
          var x$2_$_hi = hi$3;
        } else {
          var x$2_$_lo = lo;
          var x$2_$_hi = hi$2;
        }
        temp.a[i$1] = x$2_$_lo;
        var b0 = (65535 & x$2_$_lo);
        rem = ((value$1 - ((Math.imul(51712, b0) + (((Math.imul(15258, b0) + Math.imul(51712, ((x$2_$_lo >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
        i$1 = ((i$1 - 1) | 0);
      }
      var this$22 = rem;
      var remStr = ("" + this$22);
      var beginIndex = remStr.length;
      var padding = "000000000".substring(beginIndex);
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.a[((tempLen - 1) | 0)] === 0))) {
        tempLen = ((tempLen - 1) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$p.ayE = (function(value_$_lo, value_$_hi, scale) {
  if (((value_$_lo | value_$_hi) === 0)) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        var scaleVal = ((scale === (-2147483648)) ? "2147483648" : ("" + ((-scale) | 0)));
        return (((scale < 0) ? "0E+" : "0E") + scaleVal);
      }
    }
  } else {
    var negNumber = (value_$_hi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = ((-value_$_lo) | 0);
      var hi = ((((-value_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      var v_$_lo = lo;
      var v_$_hi = hi;
    } else {
      var v_$_lo = value_$_lo;
      var v_$_hi = value_$_hi;
    }
    while (true) {
      var prev_$_lo = v_$_lo;
      var prev_$_hi = v_$_hi;
      var num_$_lo = v_$_lo;
      var num_$_hi = v_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 10) | 0);
      var k = ((rhi - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$1 = ((-quotLo) | 0);
        var hi$1 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        v_$_lo = lo$1;
        v_$_hi = hi$1;
      } else {
        v_$_lo = quotLo;
        v_$_hi = quotHi;
      }
      currentChar = ((currentChar - 1) | 0);
      var x$1_$_lo = v_$_lo;
      var x$1_$_hi = v_$_hi;
      elem = (("" + ((prev_$_lo - ((Math.imul(10, (65535 & x$1_$_lo)) + (Math.imul(10, ((x$1_$_lo >>> 16) | 0)) << 16)) | 0)) | 0)) + elem);
      var x$2_$_lo = v_$_lo;
      var x$2_$_hi = v_$_hi;
      if (((x$2_$_lo | x$2_$_hi) !== 0)) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$4 = (value$1 >> 31);
    var hi$5 = (scale >> 31);
    var lo$4 = ((value$1 - scale) | 0);
    var hi$6 = ((((hi$4 - hi$5) | 0) - (((lo$4 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 - 1) | 0);
    var hi$7 = ((((hi$6 - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
    if (((scale > 0) && ((hi$7 === (-1)) ? ((lo$5 >>> 0) >= 4294967290) : (hi$7 > (-1))))) {
      var index = ((1 + lo$5) | 0);
      if ((index > 0)) {
        var this$27 = elem;
        var $x_1 = this$27.substring(0, index);
        var this$29 = elem;
        elem = (($x_1 + ".") + this$29.substring(index));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + elem);
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$7 === 0) ? (lo$5 !== 0) : (hi$7 > 0)) ? ("E+" + $s_RTLong__toString__I__I__T(lo$5, hi$7)) : ("E" + $s_RTLong__toString__I__I__T(lo$5, hi$7)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$35 = elem;
        var $x_2 = this$35.substring(0, 1);
        var this$37 = elem;
        elem = ((($x_2 + ".") + this$37.substring(1)) + exponentStr);
      } else {
        elem = (elem + exponentStr);
      }
    }
    return (negNumber ? ("-" + elem) : elem);
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().i($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  u5: 1
}));
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
/** @constructor */
function $c_Ljava_math_Division$() {
}
$p = $c_Ljava_math_Division$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
$h_Ljava_math_Division$.prototype = $p;
$p.agE = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.a[((bLength - 1) | 0)];
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().Vr(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().Vr(normA, a, 0, divisorShift);
  } else {
    a.av(0, normA, 0, aLength);
    b.av(0, normB, 0, bLength);
  }
  var firstDivisorDigit = normB.a[((bLength - 1) | 0)];
  var i$1 = ((quotLength - 1) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.a[elem] === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = normA.a[elem];
      var value$1 = normA.a[((elem - 1) | 0)];
      var $x_1 = $m_RTLong$().Mu(value$1, value, firstDivisorDigit, 0);
      var quotient_$_lo = $x_1.l;
      var quotient_$_hi = $x_1.h;
      elem$1 = quotient_$_lo;
      var a0 = (65535 & quotient_$_lo);
      var a1 = ((quotient_$_lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var lo$1 = ((value$1 - lo) | 0);
      var elem$2 = 0;
      elem$2 = lo$1;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.a[((bLength - 2) | 0)];
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$7 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.a[((elem - 2) | 0)];
          var value$6 = elem$2;
          var lo$3 = ((value$6 + firstDivisorDigit) | 0);
          if (((((lo$3 >>> 0) < (value$6 >>> 0)) | 0) === 0)) {
            elem$2 = lo$3;
            if (((hi$7 === value$4) ? ((lo$2 >>> 0) > (value$5 >>> 0)) : ((hi$7 >>> 0) > (value$4 >>> 0)))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      if (($m_Ljava_math_Division$().awm(normA, ((elem - bLength) | 0), normB, bLength, elem$1) !== 0)) {
        elem$1 = ((elem$1 - 1) | 0);
        var elem$3_$_lo = 0;
        var elem$3_$_hi = 0;
        elem$3_$_lo = 0;
        elem$3_$_hi = 0;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var value$7 = i$2;
          var x_$_lo = elem$3_$_lo;
          var x_$_hi = elem$3_$_hi;
          var value$8 = normA.a[((((elem - bLength) | 0) + value$7) | 0)];
          var value$9 = normB.a[value$7];
          var lo$4 = ((value$8 + value$9) | 0);
          var hi$15 = (((lo$4 >>> 0) < (value$8 >>> 0)) | 0);
          var lo$5 = ((x_$_lo + lo$4) | 0);
          var hi$16 = ((((x_$_hi + hi$15) | 0) + (((lo$5 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem$3_$_lo = lo$5;
          elem$3_$_hi = hi$16;
          normA.a[((((elem - bLength) | 0) + value$7) | 0)] = elem$3_$_lo;
          var x$2_$_lo = elem$3_$_lo;
          var x$2_$_hi = elem$3_$_hi;
          elem$3_$_lo = x$2_$_hi;
          elem$3_$_hi = 0;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      quot.a[i$1] = elem$1;
    }
    elem = ((elem - 1) | 0);
    i$1 = ((i$1 - 1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().ajK(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    normA.av(0, normB, 0, bLength);
    return normA;
  }
});
$p.ath = (function(bi, divisor, divisorSign) {
  var valDigits = bi.aN;
  var valLen = bi.bb;
  var valSign = bi.aX;
  if ((valLen === 1)) {
    var valDigit = valDigits.a[0];
    var value = (((valDigit >>> 0) / ($checkIntDivisor(divisor) >>> 0)) | 0);
    var quo_$_lo = value;
    var quo_$_hi = 0;
    var value$1 = (((valDigit >>> 0) % ($checkIntDivisor(divisor) >>> 0)) | 0);
    var rem_$_lo = value$1;
    var rem_$_hi = 0;
    if ((valSign !== divisorSign)) {
      var x_$_lo = quo_$_lo;
      var x_$_hi = quo_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      quo_$_lo = lo;
      quo_$_hi = hi$2;
    }
    if ((valSign < 0)) {
      var x$1_$_lo = rem_$_lo;
      var x$1_$_hi = rem_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      rem_$_lo = lo$1;
      rem_$_hi = hi$3;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().iy(quo_$_lo, quo_$_hi), $m_Ljava_math_BigInteger$().iy(rem_$_lo, rem_$_hi));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.U6(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.jm();
    result1.jm();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$p.U6 = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = ((srcLength - 1) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.a[i];
    var $x_1 = $m_RTLong$().Mu(value$1, value, divisor, 0);
    var quot_$_lo = $x_1.l;
    var quot_$_hi = $x_1.h;
    var a0 = (65535 & quot_$_lo);
    var a1 = ((quot_$_lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    rem = ((value$1 - ((Math.imul(a0, b0) + (((Math.imul(a1, b0) + Math.imul(a0, ((divisor >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
    dest.a[i] = quot_$_lo;
    i = ((i - 1) | 0);
  }
  return rem;
});
$p.awm = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.a[value];
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    var value$1 = a.a[((start + value) | 0)];
    var lo$2 = ((value$1 - lo$1) | 0);
    var hi$6 = ((-(((lo$2 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var value$2 = elem$1;
    var hi$7 = (value$2 >> 31);
    var lo$3 = ((lo$2 + value$2) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
    a.a[((start + value) | 0)] = lo$3;
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$3 = a.a[((start + bLen) | 0)];
  var value$4 = elem;
  var lo$4 = ((value$3 - value$4) | 0);
  var hi$13 = ((-(((lo$4 >>> 0) > (value$3 >>> 0)) | 0)) | 0);
  var value$5 = elem$1;
  var hi$14 = (value$5 >> 31);
  var lo$5 = ((lo$4 + value$5) | 0);
  var hi$15 = ((((hi$13 + hi$14) | 0) + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
  a.a[((start + bLen) | 0)] = lo$5;
  return hi$15;
});
var $d_Ljava_math_Division$ = new $TypeData().i($c_Ljava_math_Division$, "java.math.Division$", ({
  u6: 1
}));
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.a[0];
  var value$1 = b.a[0];
  var lo = ((value + value$1) | 0);
  var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
  res.a[0] = lo;
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.a[i];
      var value$3 = b.a[i];
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = (((lo$1 >>> 0) < (value$2 >>> 0)) | 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((hi$6 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[i] = lo$2;
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = a.a[i];
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = (((lo$3 >>> 0) < (value$5 >>> 0)) | 0);
      res.a[i] = lo$3;
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.a[i];
      var value$8 = b.a[i];
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = (((lo$4 >>> 0) < (value$7 >>> 0)) | 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((hi$16 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
      res.a[i] = lo$5;
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = b.a[i];
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = (((lo$6 >>> 0) < (value$10 >>> 0)) | 0);
      res.a[i] = lo$6;
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    res.a[i] = carry;
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.a[i];
    var value$1 = b.a[i];
    var lo = ((value - value$1) | 0);
    var hi$2 = ((-(((lo >>> 0) > (value >>> 0)) | 0)) | 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((hi$2 + hi$3) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[i] = lo$1;
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = a.a[i];
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((hi$7 + (((lo$2 >>> 0) < (value$3 >>> 0)) | 0)) | 0);
    res.a[i] = lo$2;
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
$p = $c_Ljava_math_Elementary$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
$h_Ljava_math_Elementary$.prototype = $p;
$p.I8 = (function(op1, op2) {
  var op1Sign = op1.aX;
  var op2Sign = op2.aX;
  var op1Len = op1.bb;
  var op2Len = op2.bb;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.aN.a[0];
    var value$1 = op2.aN.a[0];
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_2 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((-(((lo$1 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$1;
        var $x_1_$_hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((-(((lo$2 >>> 0) > (value >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$2;
        var $x_1_$_hi = hi$4;
      }
      return $x_2.iy($x_1_$_lo, $x_1_$_hi);
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.aN, op1Len, op2.aN, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.aN, op2Len, op1.aN, op1Len));
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.Is(op1.aN, op2.aN, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().pZ;
      }
      if ((cmp === 1)) {
        var x1___1 = op1Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.aN, op1Len, op2.aN, op2Len);
      } else {
        var x1___1 = op2Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.aN, op2Len, op1.aN, op1Len);
      }
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$3.jm();
    return res$3;
  }
});
$p.Is = (function(a, b, size) {
  var i = ((size - 1) | 0);
  while (((i >= 0) && (a.a[i] === b.a[i]))) {
    i = ((i - 1) | 0);
  }
  return ((i < 0) ? 0 : (((a.a[i] >>> 0) < (b.a[i] >>> 0)) ? (-1) : 1));
});
$p.avc = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.a[i];
    var lo = ((value + value$1) | 0);
    var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
    a.a[i] = lo;
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$p.Ny = (function(op1, op2) {
  var op1Sign = op1.aX;
  var op2Sign = op2.aX;
  var op1Len = op1.bb;
  var op2Len = op2.bb;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return op2.aiX();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.aN.a[0];
    var a_$_lo = value;
    var a_$_hi = 0;
    var value$1 = op2.aN.a[0];
    var b_$_lo = value$1;
    var b_$_hi = 0;
    if ((op1Sign < 0)) {
      var x_$_lo = a_$_lo;
      var x_$_hi = a_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      a_$_lo = lo;
      a_$_hi = hi$2;
    }
    if ((op2Sign < 0)) {
      var x$1_$_lo = b_$_lo;
      var x$1_$_hi = b_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      b_$_lo = lo$1;
      b_$_hi = hi$3;
    }
    var $x_1 = $m_Ljava_math_BigInteger$();
    var x$2_$_lo = a_$_lo;
    var x$2_$_hi = a_$_hi;
    var x$3_$_lo = b_$_lo;
    var x$3_$_hi = b_$_hi;
    var lo$2 = ((x$2_$_lo - x$3_$_lo) | 0);
    var hi$4 = ((((x$2_$_hi - x$3_$_hi) | 0) - (((lo$2 >>> 0) > (x$2_$_lo >>> 0)) | 0)) | 0);
    return $x_1.iy(lo$2, hi$4);
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Is(op1.aN, op2.aN, op1Len));
    if ((((op1Sign ^ op2Sign) | cmp) === 0)) {
      return $m_Ljava_math_BigInteger$().pZ;
    }
    if ((cmp === (-1))) {
      var x1___1 = ((-op2Sign) | 0);
      var x1___2 = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.aN, op2Len, op1.aN, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.aN, op2Len, op1.aN, op1Len));
    } else if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.aN, op1Len, op2.aN, op2Len);
    } else {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.aN, op1Len, op2.aN, op2Len);
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$2.jm();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().i($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  u7: 1
}));
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.q0 = 0;
  this.y0 = null;
  if ((setPrecision < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Negative precision: " + setPrecision));
  }
  this.q0 = setPrecision;
  this.y0 = setRoundingMode;
}
$p = $c_Ljava_math_MathContext.prototype = new $h_O();
$p.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
}
$h_Ljava_math_MathContext.prototype = $p;
$p.b = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    if ((this.q0 === x.q0)) {
      var x$2 = this.y0;
      var x$3 = x.y0;
      return ((x$2 === null) ? (x$3 === null) : (x$2 === x$3));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return ((this.q0 << 3) | this.y0.iW);
});
$p.g = (function() {
  return ((("precision=" + this.q0) + " roundingMode=") + this.y0);
});
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gy)));
}
var $d_Ljava_math_MathContext = new $TypeData().i($c_Ljava_math_MathContext, "java.math.MathContext", ({
  gy: 1
}));
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.a9k = null;
  $n_Ljava_math_MathContext$ = this;
  this.a9k = new $c_Ljava_math_MathContext(34, $m_Ljava_math_RoundingMode$().Ct);
  new $c_Ljava_math_MathContext(7, $m_Ljava_math_RoundingMode$().Ct);
  new $c_Ljava_math_MathContext(16, $m_Ljava_math_RoundingMode$().Ct);
  new $c_Ljava_math_MathContext(0, $m_Ljava_math_RoundingMode$().QX);
}
$p = $c_Ljava_math_MathContext$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
}
$h_Ljava_math_MathContext$.prototype = $p;
var $d_Ljava_math_MathContext$ = new $TypeData().i($c_Ljava_math_MathContext$, "java.math.MathContext$", ({
  u8: 1
}));
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$();
  }
  return $n_Ljava_math_MathContext$;
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 1;
  elem_$_hi = 0;
  var i = 0;
  while ((i < 32)) {
    var value = i;
    if ((value <= 18)) {
      $m_Ljava_math_Multiplication$().tb.a[value] = $m_Ljava_math_BigInteger$().iy(elem_$_lo, elem_$_hi);
      var $x_2 = $m_Ljava_math_Multiplication$().tc;
      var $x_1 = $m_Ljava_math_BigInteger$();
      var x_$_lo = elem_$_lo;
      var x_$_hi = elem_$_hi;
      var lo = (((32 & value) === 0) ? (x_$_lo << value) : 0);
      var hi = (((32 & value) === 0) ? (((((x_$_lo >>> 1) | 0) >>> (~value)) | 0) | (x_$_hi << value)) : (x_$_lo << value));
      $x_2.a[value] = $x_1.iy(lo, hi);
      var x$1_$_lo = elem_$_lo;
      var x$1_$_hi = elem_$_hi;
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, x$1_$_hi) + ((c1part >>> 16) | 0)) | 0);
      elem_$_lo = lo$1;
      elem_$_hi = hi$1;
    } else {
      $m_Ljava_math_Multiplication$().tb.a[value] = $m_Ljava_math_Multiplication$().tb.a[((value - 1) | 0)].hf($m_Ljava_math_Multiplication$().tb.a[1]);
      $m_Ljava_math_Multiplication$().tc.a[value] = $m_Ljava_math_Multiplication$().tc.a[((value - 1) | 0)].hf($m_Ljava_math_BigInteger$().pY);
    }
    i = ((1 + i) | 0);
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.a[value];
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[value] = lo$1;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.ajX(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var value = i;
      var elem = 0;
      elem = 0;
      var aI = a.a[value];
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var value$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.a[value$1];
        var c = t.a[((value + value$1) | 0)];
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
        t.a[((value + value$1) | 0)] = lo$2;
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      t.a[((value + bLen) | 0)] = elem;
      i = ((1 + i) | 0);
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  result.a[0] = 1;
  var i = 1;
  while ((i < len)) {
    var value = i;
    result.a[value] = Math.imul(result.a[((value - 1) | 0)], pow);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.tc = null;
  this.tb = null;
  $n_Ljava_math_Multiplication$ = this;
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.tc = new ($d_Ljava_math_BigInteger.r().C)(32);
  this.tb = new ($d_Ljava_math_BigInteger.r().C)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
$p = $c_Ljava_math_Multiplication$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
$h_Ljava_math_Multiplication$.prototype = $p;
$p.ajX = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var value = i;
    elem = 0;
    var _\uff3fself = ((1 + value) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var value$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.a[value];
      var b = a.a[value$1];
      var c = res.a[((value + value$1) | 0)];
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[((value + value$1) | 0)] = lo$2;
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    res.a[((value + aLen) | 0)] = elem;
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().ajI(res, res, (aLen << 1));
  elem = 0;
  var i$2 = 0;
  var index = 0;
  while ((i$2 < aLen)) {
    var a$2 = a.a[i$2];
    var b$1 = a.a[i$2];
    var c$1 = res.a[index];
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((hi$9 + (((lo$4 >>> 0) < (lo$3 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((hi$11 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
    res.a[index] = lo$5;
    index = ((1 + index) | 0);
    var value$2 = res.a[index];
    var lo$6 = ((hi$13 + value$2) | 0);
    var hi$15 = (((lo$6 >>> 0) < (hi$13 >>> 0)) | 0);
    res.a[index] = lo$6;
    elem = hi$15;
    i$2 = ((1 + i$2) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$p.N5 = (function(val1, val2) {
  if ((val2.bb > val1.bb)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = x1___1;
  var op2 = x1___2;
  if ((op2.bb < 63)) {
    return this.awn(op1, op2);
  } else {
    var ndiv2 = (((-2) & op1.bb) << 4);
    var upperOp1 = op1.Nr(ndiv2);
    var upperOp2 = op2.Nr(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().Ny(op1, upperOp1.kT(ndiv2));
    var lowerOp2 = $m_Ljava_math_Elementary$().Ny(op2, upperOp2.kT(ndiv2));
    var upper = this.N5(upperOp1, upperOp2);
    var lower = this.N5(lowerOp1, lowerOp2);
    var middle = this.N5($m_Ljava_math_Elementary$().Ny(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().Ny(lowerOp2, upperOp2));
    middle = $m_Ljava_math_Elementary$().I8($m_Ljava_math_Elementary$().I8(middle, upper), lower);
    middle = middle.kT(ndiv2);
    upper = upper.kT((ndiv2 << 1));
    return $m_Ljava_math_Elementary$().I8($m_Ljava_math_Elementary$().I8(upper, middle), lower);
  }
});
$p.awk = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.a[bLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.a[0]);
    } else if ((bLen === 1)) {
      resDigits.a[aLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.a[0]);
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$p.awn = (function(a, b) {
  var aLen = a.bb;
  var bLen = b.bb;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.aX !== b.aX) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.aN.a[0];
    var b$1 = b.aN.a[0];
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = a.aN;
    var bDigits = b.aN;
    var resDigits = new $ac_I(resLength);
    this.awk(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.jm();
    return result;
  }
});
$p.awV = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Cs;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.hf(acc) : res);
    if ((acc.bb === 1)) {
      var acc2 = acc.hf(acc);
    } else {
      var a = new $ac_I((acc.bb << 1));
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.ajX(acc.aN, acc.bb, a));
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return res.hf(acc);
});
$p.uA = (function(exp_$_lo, exp_$_hi) {
  var value = this.tc.a.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.tc.a[exp_$_lo];
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 50) : (exp_$_hi < 0))) {
    return $m_Ljava_math_BigInteger$().pY.qL(exp_$_lo);
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 2147483647) : (exp_$_hi < 0))) {
    return this.tb.a[1].qL(exp_$_lo).kT(exp_$_lo);
  } else {
    var powerOfFive = this.tb.a[1].qL(2147483647);
    var res = powerOfFive;
    var lo = ((exp_$_lo - 2147483647) | 0);
    var hi$1 = ((((exp_$_hi - 1) | 0) + (((lo >>> 0) < 2147483649) | 0)) | 0);
    var longExp_$_lo = lo;
    var longExp_$_hi = hi$1;
    var sign = (exp_$_hi >> 31);
    var xlo = (exp_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((exp_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var x = (4.656612875245805E-10 * aHat);
    var lo$1 = (x | 0.0);
    ((2.3283064365386963E-10 * x) | 0.0);
    var rHat = ((rlo - Math.imul(2147483647, lo$1)) | 0);
    if ((rHat < 0)) {
      var lo$2 = ((2147483647 + rHat) | 0);
      var absR_$_lo = lo$2;
      var absR_$_hi = 0;
    } else {
      var absR_$_lo = rHat;
      var absR_$_hi = 0;
    }
    if ((exp_$_hi < 0)) {
      var lo$3 = ((-absR_$_lo) | 0);
      var hi$3 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var x$2_$_lo = lo$3;
      var x$2_$_hi = hi$3;
    } else {
      var x$2_$_lo = absR_$_lo;
      var x$2_$_hi = absR_$_hi;
    }
    while (true) {
      var x$3_$_lo = longExp_$_lo;
      var x$3_$_hi = longExp_$_hi;
      if (((x$3_$_hi === 0) ? ((x$3_$_lo >>> 0) > 2147483647) : (x$3_$_hi > 0))) {
        res = res.hf(powerOfFive);
        var x$4_$_lo = longExp_$_lo;
        var x$4_$_hi = longExp_$_hi;
        var lo$4 = ((x$4_$_lo - 2147483647) | 0);
        var hi$4 = ((((x$4_$_hi - 1) | 0) + (((lo$4 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$4;
        longExp_$_hi = hi$4;
      } else {
        break;
      }
    }
    res = res.hf(this.tb.a[1].qL(x$2_$_lo));
    res = res.kT(2147483647);
    var lo$5 = ((exp_$_lo - 2147483647) | 0);
    var hi$5 = ((((exp_$_hi - 1) | 0) + (((lo$5 >>> 0) < 2147483649) | 0)) | 0);
    longExp_$_lo = lo$5;
    longExp_$_hi = hi$5;
    while (true) {
      var x$5_$_lo = longExp_$_lo;
      var x$5_$_hi = longExp_$_hi;
      if (((x$5_$_hi === 0) ? ((x$5_$_lo >>> 0) > 2147483647) : (x$5_$_hi > 0))) {
        res = res.kT(2147483647);
        var x$6_$_lo = longExp_$_lo;
        var x$6_$_hi = longExp_$_hi;
        var lo$6 = ((x$6_$_lo - 2147483647) | 0);
        var hi$6 = ((((x$6_$_hi - 1) | 0) + (((lo$6 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$6;
        longExp_$_hi = hi$6;
      } else {
        break;
      }
    }
    return res.kT(x$2_$_lo);
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().i($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  u9: 1
}));
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.iX = _capacity;
  $thiz.bF = $thiz.iX;
  $thiz.b5 = 0;
  $thiz.mb = (-1);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
}
$p = $c_Ljava_nio_Buffer.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
}
$h_Ljava_nio_Buffer.prototype = $p;
$p.eA = (function(newPosition) {
  if (((newPosition >>> 0) > (this.bF >>> 0))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.b5 = newPosition;
  if ((this.mb > newPosition)) {
    this.mb = (-1);
  }
  return this;
});
$p.UW = (function(newLimit) {
  if (((newLimit >>> 0) > (this.iX >>> 0))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.bF = newLimit;
  if ((this.b5 > newLimit)) {
    this.b5 = newLimit;
    if ((this.mb > newLimit)) {
      this.mb = (-1);
    }
  }
  return this;
});
$p.ah6 = (function() {
  this.mb = (-1);
  this.bF = this.b5;
  this.b5 = 0;
  return this;
});
$p.g = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.b5) + " lim=") + this.bF) + " cap=") + this.iX) + "]");
});
/** @constructor */
function $c_Ljava_nio_CharBuffer$() {
}
$p = $c_Ljava_nio_CharBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_CharBuffer$;
/** @constructor */
function $h_Ljava_nio_CharBuffer$() {
}
$h_Ljava_nio_CharBuffer$.prototype = $p;
$p.TD = (function(capacity) {
  if ((capacity < 0)) {
    $m_jl_BoundsChecks$().ahU(capacity);
  }
  var array = new $ac_C(capacity);
  var length = array.a.length;
  var capacity$1 = array.a.length;
  var length$1 = array.a.length;
  if ((((capacity$1 | capacity$1) | ((length$1 - capacity$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(0, capacity$1, length$1);
  }
  if ((((length | length) | ((capacity$1 - length) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(0, length, capacity$1);
  }
  return new $c_Ljava_nio_HeapCharBuffer(capacity$1, array, 0, 0, length, false);
});
$p.azz = (function(csq, start, end) {
  return $m_Ljava_nio_StringCharBuffer$().azy(csq, 0, $dp_length__I(csq), start, ((end - start) | 0));
});
var $d_Ljava_nio_CharBuffer$ = new $TypeData().i($c_Ljava_nio_CharBuffer$, "java.nio.CharBuffer$", ({
  uc: 1
}));
var $n_Ljava_nio_CharBuffer$;
function $m_Ljava_nio_CharBuffer$() {
  if ((!$n_Ljava_nio_CharBuffer$)) {
    $n_Ljava_nio_CharBuffer$ = new $c_Ljava_nio_CharBuffer$();
  }
  return $n_Ljava_nio_CharBuffer$;
}
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
}
$p = $c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
}
$h_Ljava_nio_HeapByteBuffer$.prototype = $p;
$p.azA = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  var length = array.a.length;
  var endOffset = ((arrayOffset + capacity) | 0);
  if (((((arrayOffset | capacity) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(arrayOffset, capacity, length);
  }
  var endOffset$1 = ((initialPosition + initialLength) | 0);
  if (((((initialPosition | initialLength) | endOffset$1) | ((capacity - endOffset$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(initialPosition, initialLength, capacity);
  }
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, endOffset$1, isReadOnly, false);
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().i($c_Ljava_nio_HeapByteBuffer$, "java.nio.HeapByteBuffer$", ({
  ue: 1
}));
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$();
  }
  return $n_Ljava_nio_HeapByteBuffer$;
}
/** @constructor */
function $c_Ljava_nio_StringCharBuffer$() {
}
$p = $c_Ljava_nio_StringCharBuffer$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_StringCharBuffer$;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer$() {
}
$h_Ljava_nio_StringCharBuffer$.prototype = $p;
$p.azy = (function(csq, csqOffset, capacity, initialPosition, initialLength) {
  var length = $dp_length__I(csq);
  var endOffset = ((csqOffset + capacity) | 0);
  if (((((csqOffset | capacity) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(csqOffset, capacity, length);
  }
  var endOffset$1 = ((initialPosition + initialLength) | 0);
  if (((((initialPosition | initialLength) | endOffset$1) | ((capacity - endOffset$1) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(initialPosition, initialLength, capacity);
  }
  return new $c_Ljava_nio_StringCharBuffer(capacity, csq, csqOffset, initialPosition, endOffset$1);
});
var $d_Ljava_nio_StringCharBuffer$ = new $TypeData().i($c_Ljava_nio_StringCharBuffer$, "java.nio.StringCharBuffer$", ({
  ui: 1
}));
var $n_Ljava_nio_StringCharBuffer$;
function $m_Ljava_nio_StringCharBuffer$() {
  if ((!$n_Ljava_nio_StringCharBuffer$)) {
    $n_Ljava_nio_StringCharBuffer$ = new $c_Ljava_nio_StringCharBuffer$();
  }
  return $n_Ljava_nio_StringCharBuffer$;
}
function $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out) {
  if ((out.iX === 0)) {
    return $m_Ljava_nio_CharBuffer$().TD(1);
  } else {
    var result = $m_Ljava_nio_CharBuffer$().TD((out.iX << 1));
    $c_Ljava_nio_Buffer.prototype.ah6.call(out);
    result.ajh(out);
    return result;
  }
}
function $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageCharsPerByte, _maxCharsPerByte) {
  $thiz.QY = _averageCharsPerByte;
  $thiz.KM = "\ufffd";
  $thiz.KL = $m_Ljava_nio_charset_CodingErrorAction$().KQ;
  $thiz.KN = $m_Ljava_nio_charset_CodingErrorAction$().KQ;
  $thiz.tf = 1;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetDecoder() {
  this.QY = 0.0;
  this.KM = null;
  this.KL = null;
  this.KN = null;
  this.tf = 0;
}
$p = $c_Ljava_nio_charset_CharsetDecoder.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CharsetDecoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetDecoder() {
}
$h_Ljava_nio_charset_CharsetDecoder.prototype = $p;
$p.awC = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.KL = newAction;
  return this;
});
$p.awE = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.KN = newAction;
  return this;
});
$p.atb = (function(in$1, out, endOfInput) {
  if (((this.tf === 4) || ((!endOfInput) && (this.tf === 3)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.tf = (endOfInput ? 3 : 2);
  while (true) {
    try {
      var result1 = this.atd(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(e);
      } else {
        throw e;
      }
    }
    if ((result1.mc === 0)) {
      var remaining = ((in$1.bF - in$1.b5) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.kg;
            break;
          }
          case 2: {
            var result2 = this$1.KO;
            break;
          }
          case 3: {
            var result2 = this$1.Cw;
            break;
          }
          case 4: {
            var result2 = this$1.a9r;
            break;
          }
          default: {
            var result2 = this$1.avI(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    if (((result2.mc === 0) || (result2.mc === 1))) {
      return result2;
    } else {
      var action = ((result2.mc === 3) ? this.KN : this.KL);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().KP;
      if (((x === null) ? (action === null) : (x === action))) {
        if ((((out.bF - out.b5) | 0) < this.KM.length)) {
          return $m_Ljava_nio_charset_CoderResult$().tg;
        } else {
          var src = this.KM;
          out.ajg(src, 0, src.length);
          var $x_1 = in$1.b5;
          var l = result2.Gs;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          $c_Ljava_nio_Buffer.prototype.eA.call(in$1, (($x_1 + l) | 0));
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().KQ;
        if (((x$3 === null) ? (action === null) : (x$3 === action))) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().a9t;
          if (((x$5 === null) ? (action === null) : (x$5 === action))) {
            var $x_2 = in$1.b5;
            var l$1 = result2.Gs;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            $c_Ljava_nio_Buffer.prototype.eA.call(in$1, (($x_2 + l$1) | 0));
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$p.au0 = (function(out) {
  switch (this.tf) {
    case 3: {
      var result = $m_Ljava_nio_charset_CoderResult$().md;
      if ((result.mc === 0)) {
        this.tf = 4;
      }
      return result;
      break;
    }
    case 4: {
      return $m_Ljava_nio_charset_CoderResult$().md;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$p.axg = (function() {
  this.tf = 1;
  return this;
});
$p.atc = (function(in$1) {
  this.axg();
  var initLength = $doubleToInt((((in$1.bF - in$1.b5) | 0) * this.QY));
  var out = $m_Ljava_nio_CharBuffer$().TD(initLength);
  var out$1;
  while (true) {
    var result = this.atb(in$1, out, true);
    if ((result.mc !== 0)) {
      if ((result.mc === 1)) {
        out = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out);
        continue;
      }
      result.ak9();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    if ((in$1.b5 !== in$1.bF)) {
      throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
    }
    var out$1 = out;
    break;
  }
  var out$2;
  while (true) {
    var result$1 = this.au0(out$1);
    if ((result$1.mc !== 0)) {
      if ((result$1.mc === 1)) {
        out$1 = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out$1);
        continue;
      }
      result$1.ak9();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    var out$2 = out$1;
    break;
  }
  $c_Ljava_nio_Buffer.prototype.ah6.call(out$2);
  return out$2;
});
/** @constructor */
function $c_Ljava_nio_charset_CoderResult(kind, _length) {
  this.mc = 0;
  this.Gs = 0;
  this.mc = kind;
  this.Gs = _length;
}
$p = $c_Ljava_nio_charset_CoderResult.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CoderResult;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult() {
}
$h_Ljava_nio_charset_CoderResult.prototype = $p;
$p.ak9 = (function() {
  var x1 = this.mc;
  switch (x1) {
    case 1: {
      throw new $c_Ljava_nio_BufferOverflowException();
      break;
    }
    case 0: {
      throw new $c_Ljava_nio_BufferUnderflowException();
      break;
    }
    case 2: {
      throw new $c_Ljava_nio_charset_MalformedInputException(this.Gs);
      break;
    }
    case 3: {
      throw new $c_Ljava_nio_charset_UnmappableCharacterException(this.Gs);
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
var $d_Ljava_nio_charset_CoderResult = new $TypeData().i($c_Ljava_nio_charset_CoderResult, "java.nio.charset.CoderResult", ({
  ul: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CoderResult$() {
  this.tg = null;
  this.md = null;
  this.kg = null;
  this.KO = null;
  this.Cw = null;
  this.a9r = null;
  this.QZ = null;
  $n_Ljava_nio_charset_CoderResult$ = this;
  this.tg = new $c_Ljava_nio_charset_CoderResult(1, (-1));
  this.md = new $c_Ljava_nio_charset_CoderResult(0, (-1));
  this.kg = new $c_Ljava_nio_charset_CoderResult(2, 1);
  this.KO = new $c_Ljava_nio_charset_CoderResult(2, 2);
  this.Cw = new $c_Ljava_nio_charset_CoderResult(2, 3);
  this.a9r = new $c_Ljava_nio_charset_CoderResult(2, 4);
  this.QZ = [];
}
$p = $c_Ljava_nio_charset_CoderResult$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CoderResult$;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult$() {
}
$h_Ljava_nio_charset_CoderResult$.prototype = $p;
$p.avI = (function(length) {
  var x = this.QZ[length];
  if ((x !== (void 0))) {
    return x;
  } else {
    var result = new $c_Ljava_nio_charset_CoderResult(2, length);
    $m_Ljava_nio_charset_CoderResult$().QZ[length] = result;
    return result;
  }
});
var $d_Ljava_nio_charset_CoderResult$ = new $TypeData().i($c_Ljava_nio_charset_CoderResult$, "java.nio.charset.CoderResult$", ({
  um: 1
}));
var $n_Ljava_nio_charset_CoderResult$;
function $m_Ljava_nio_charset_CoderResult$() {
  if ((!$n_Ljava_nio_charset_CoderResult$)) {
    $n_Ljava_nio_charset_CoderResult$ = new $c_Ljava_nio_charset_CoderResult$();
  }
  return $n_Ljava_nio_charset_CoderResult$;
}
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction(name) {
  this.a9s = null;
  this.a9s = name;
}
$p = $c_Ljava_nio_charset_CodingErrorAction.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction() {
}
$h_Ljava_nio_charset_CodingErrorAction.prototype = $p;
$p.g = (function() {
  return this.a9s;
});
var $d_Ljava_nio_charset_CodingErrorAction = new $TypeData().i($c_Ljava_nio_charset_CodingErrorAction, "java.nio.charset.CodingErrorAction", ({
  un: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction$() {
  this.a9t = null;
  this.KP = null;
  this.KQ = null;
  $n_Ljava_nio_charset_CodingErrorAction$ = this;
  this.a9t = new $c_Ljava_nio_charset_CodingErrorAction("IGNORE");
  this.KP = new $c_Ljava_nio_charset_CodingErrorAction("REPLACE");
  this.KQ = new $c_Ljava_nio_charset_CodingErrorAction("REPORT");
}
$p = $c_Ljava_nio_charset_CodingErrorAction$.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_CodingErrorAction$;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction$() {
}
$h_Ljava_nio_charset_CodingErrorAction$.prototype = $p;
var $d_Ljava_nio_charset_CodingErrorAction$ = new $TypeData().i($c_Ljava_nio_charset_CodingErrorAction$, "java.nio.charset.CodingErrorAction$", ({
  uo: 1
}));
var $n_Ljava_nio_charset_CodingErrorAction$;
function $m_Ljava_nio_charset_CodingErrorAction$() {
  if ((!$n_Ljava_nio_charset_CodingErrorAction$)) {
    $n_Ljava_nio_charset_CodingErrorAction$ = new $c_Ljava_nio_charset_CodingErrorAction$();
  }
  return $n_Ljava_nio_charset_CodingErrorAction$;
}
/** @constructor */
function $c_ju_Arrays$() {
}
$p = $c_ju_Arrays$.prototype = new $h_O();
$p.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
}
$h_ju_Arrays$.prototype = $p;
$p.ajQ = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.ir(a, new $ac_I(a.a.length), 0, end, comparator, ops);
  } else {
    this.ju(a, 0, end, comparator, ops);
  }
});
$p.ay8 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(a, new $ac_I(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.ju(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.ajR = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = ((a.a.length >>> 1) | 0);
  if ((end > 16)) {
    this.ir(a, new $ac_J(((a.a.length >>> 1) | 0)), 0, end, comparator, ops);
  } else {
    this.ju(a, 0, end, comparator, ops);
  }
});
$p.ay9 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(a, new $ac_J(((a.a.length >>> 1) | 0)), fromIndex, toIndex, comparator, ops);
  } else {
    this.ju(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.ajS = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.ir(a, new $ac_S(a.a.length), 0, end, comparator, ops);
  } else {
    this.ju(a, 0, end, comparator, ops);
  }
});
$p.aya = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(a, new $ac_S(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.ju(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.ajP = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.ir(a, new $ac_C(a.a.length), 0, end, comparator, ops);
  } else {
    this.ju(a, 0, end, comparator, ops);
  }
});
$p.ay7 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(a, new $ac_C(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.ju(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.ajO = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = a.a.length;
  if ((end > 16)) {
    this.ir(a, new $ac_B(a.a.length), 0, end, comparator, ops);
  } else {
    this.ju(a, 0, end, comparator, ops);
  }
});
$p.ay6 = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(a, new $ac_B(a.a.length), fromIndex, toIndex, comparator, ops);
  } else {
    this.ju(a, fromIndex, toIndex, comparator, ops);
  }
});
$p.zY = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = array.a.length;
  if ((end > 16)) {
    this.ir(array, $objectGetClass(array).ax.Q().ax.U(array.a.length), 0, end, comparator$1, ops);
  } else {
    this.ju(array, 0, end, comparator$1, ops);
  }
});
$p.ayb = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.ir(array, $objectGetClass(array).ax.Q().ax.U(array.a.length), fromIndex, toIndex, comparator$1, ops);
  } else {
    this.ju(array, fromIndex, toIndex, comparator$1, ops);
  }
});
$p.ir = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + (((length + ((length >>> 31) | 0)) | 0) >> 1)) | 0);
    this.ir(a, temp, start, middle, comparator, ops);
    this.ir(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || (comparator.bM(ops.hd(a, leftInIndex), ops.hd(a, rightInIndex)) <= 0)))) {
        ops.mK(temp, outIndex, ops.hd(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0);
      } else {
        ops.mK(temp, outIndex, ops.hd(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0);
      }
      outIndex = ((1 + outIndex) | 0);
    }
    temp.av(start, a, start, length);
  } else {
    this.ju(a, start, end, comparator, ops);
  }
});
$p.ju = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = ops.hd(a, start);
    var aStartPlusOne = ops.hd(a, ((1 + start) | 0));
    if ((comparator.bM(aStart, aStartPlusOne) > 0)) {
      ops.mK(a, start, aStartPlusOne);
      ops.mK(a, ((1 + start) | 0), aStart);
    }
    var m = 2;
    while ((m < n)) {
      var next = ops.hd(a, ((start + m) | 0));
      if ((comparator.bM(next, ops.hd(a, ((((start + m) | 0) - 1) | 0))) < 0)) {
        var iA = start;
        var iB = ((((start + m) | 0) - 1) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((comparator.bM(next, ops.hd(a, ix)) < 0)) {
            iB = ix;
          } else {
            iA = ix;
          }
        }
        var ix$2 = ((iA + ((comparator.bM(next, ops.hd(a, iA)) >= 0) | 0)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          ops.mK(a, i, ops.hd(a, ((i - 1) | 0)));
          i = ((i - 1) | 0);
        }
        ops.mK(a, ix$2, next);
      }
      m = ((1 + m) | 0);
    }
  }
});
$p.amY = (function(a, key_$_lo, key_$_hi) {
  var startIndex = 0;
  var endIndex = ((a.a.length >>> 1) | 0);
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var $x_1 = a.a;
      var $x_2 = (mid << 1);
      var elem_$_lo = $x_1[$x_2];
      var elem_$_hi = $x_1[(($x_2 + 1) | 0)];
      var cmp = ((key_$_hi === elem_$_hi) ? ((key_$_lo === elem_$_lo) ? 0 : (((key_$_lo >>> 0) < (elem_$_lo >>> 0)) ? (-1) : 1)) : ((key_$_hi < elem_$_hi) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
        continue;
      }
      if ((cmp !== 0)) {
        startIndex = ((1 + mid) | 0);
        continue;
      }
      return mid;
    }
  }
});
$p.afP = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.a.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.a[mid];
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
        continue;
      }
      if ((cmp !== 0)) {
        startIndex = ((1 + mid) | 0);
        continue;
      }
      return mid;
    }
  }
});
$p.agN = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = ((a.a.length >>> 1) | 0);
  if ((((b.a.length >>> 1) | 0) !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a;
    var $x_2 = (i$1 << 1);
    var a$1_$_lo = $x_1[$x_2];
    var a$1_$_hi = $x_1[(($x_2 + 1) | 0)];
    var i$2 = i;
    var $x_3 = b.a;
    var $x_4 = (i$2 << 1);
    var b$1_$_lo = $x_3[$x_4];
    var b$1_$_hi = $x_3[(($x_4 + 1) | 0)];
    if ((!(((a$1_$_lo ^ b$1_$_lo) | (a$1_$_hi ^ b$1_$_hi)) === 0))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.Mz = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.agO = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.agM = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.agL = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.agP = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.a.length;
  if ((b.a.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = a.a[i$1];
    var i$2 = i;
    if ((!($x_1 === b.a[i$2]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.atO = (function(a, fromIndex, toIndex, value_$_lo, value_$_hi) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    var $x_1 = a.a;
    var $x_2 = (i$2 << 1);
    $x_1[$x_2] = value_$_lo;
    $x_1[(($x_2 + 1) | 0)] = value_$_hi;
    i$1 = ((1 + i$1) | 0);
  }
});
$p.agU = (function(a, value) {
  var toIndex = a.a.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    a.a[i$1] = value;
    i = ((1 + i) | 0);
  }
});
$p.cn = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = $objectGetClass(original).ax.Q().ax.U(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.Iv = (function(original, newLength, newType) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = newType.ax.Q().ax.U(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.agl = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.agn = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.agm = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.U2 = (function(original, newLength) {
  var b = ((original.a.length >>> 1) | 0);
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.Mr = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.asY = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.asX = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.ago = (function(original, newLength) {
  var b = original.a.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  original.av(0, ret, 0, copyLength);
  return ret;
});
$p.bO = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to));
  }
  var len = original.a.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = $objectGetClass(original).ax.Q().ax.U(retLength);
  original.av(from, ret, 0, copyLength);
  return ret;
});
$p.asZ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at5 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at3 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at4 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = ((original.a.length >>> 1) | 0);
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at0 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at2 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at1 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
$p.at6 = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.a.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  original.av(start, ret, 0, copyLength);
  return ret;
});
var $d_ju_Arrays$ = new $TypeData().i($c_ju_Arrays$, "java.util.Arrays$", ({
  uy: 1
}));
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$();
  }
  return $n_ju_Arrays$;
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.gF)));
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gF)));
}
/** @constructor */
function $c_ju_Formatter$() {
  this.a9E = null;
  this.a9D = null;
  $n_ju_Formatter$ = this;
  this.a9E = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.a9D = $constArrSVals_I(26, "3]3{0C{0H_1]8]_3{||||||0I]|||3y||||0A]||");
}
$p = $c_ju_Formatter$.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
}
$h_ju_Formatter$.prototype = $p;
$p.UQ = (function(count) {
  if ((count <= 20)) {
    return "00000000000000000000".substring(0, count);
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = ((remaining - 20) | 0);
    }
    var $x_1 = result;
    var endIndex = remaining;
    return (("" + $x_1) + "00000000000000000000".substring(0, endIndex));
  }
});
$p.avO = (function(x) {
  if ((x === 0.0)) {
    return new $c_ju_Formatter$Decimal(((1.0 / x) < 0.0), "0", 0);
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0;
    } else {
      var $x_2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      var $x_1 = $x_2(s.substring(beginIndex));
      var e = ($x_1 | 0);
    }
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      return new $c_ju_Formatter$Decimal(negative$2, s.substring(0, significandEnd), ((-e) | 0));
    } else {
      var $x_3 = s.substring(0, dotPos);
      var beginIndex$1 = ((1 + dotPos) | 0);
      var digits = (("" + $x_3) + s.substring(beginIndex$1, significandEnd));
      var digitsLen = digits.length;
      var i = 0;
      while (((i < digitsLen) && (digits.charCodeAt(i) === 48))) {
        i = ((1 + i) | 0);
      }
      var beginIndex$2 = i;
      return new $c_ju_Formatter$Decimal(negative$2, digits.substring(beginIndex$2), ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0));
    }
  }
});
$p.avN = (function(x) {
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().qP(x.fP());
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0);
  } else {
    var negative = (unscaledValueWithSign.charCodeAt(0) === 45);
    return new $c_ju_Formatter$Decimal(negative, (negative ? unscaledValueWithSign.substring(1) : unscaledValueWithSign), x.bd);
  }
});
var $d_ju_Formatter$ = new $TypeData().i($c_ju_Formatter$, "java.util.Formatter$", ({
  uF: 1
}));
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$();
  }
  return $n_ju_Formatter$;
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.q2;
  var digitsLen = digits.length;
  if ((roundingPos < 0)) {
    return new $c_ju_Formatter$Decimal($thiz.q1, "0", 0);
  } else if ((roundingPos >= digitsLen)) {
    return $thiz;
  } else if ((digits.charCodeAt(roundingPos) < 53)) {
    return ((roundingPos === 0) ? new $c_ju_Formatter$Decimal($thiz.q1, "0", 0) : new $c_ju_Formatter$Decimal($thiz.q1, digits.substring(0, roundingPos), (($thiz.nW - ((digitsLen - roundingPos) | 0)) | 0)));
  } else {
    var lastNonNinePos = ((roundingPos - 1) | 0);
    while (((lastNonNinePos >= 0) && (digits.charCodeAt(lastNonNinePos) === 57))) {
      lastNonNinePos = ((lastNonNinePos - 1) | 0);
    }
    if ((lastNonNinePos < 0)) {
      var newUnscaledValue = "1";
    } else {
      var endIndex = lastNonNinePos;
      var newUnscaledValue = (digits.substring(0, endIndex) + $cToS((65535 & ((1 + digits.charCodeAt(lastNonNinePos)) | 0))));
    }
    var pos = ((1 + lastNonNinePos) | 0);
    var newScale = (($thiz.nW - ((digitsLen - pos) | 0)) | 0);
    return new $c_ju_Formatter$Decimal($thiz.q1, newUnscaledValue, newScale);
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.q1 = false;
  this.q2 = null;
  this.nW = 0;
  this.q1 = negative;
  this.q2 = unscaledValue;
  this.nW = scale;
}
$p = $c_ju_Formatter$Decimal.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
}
$h_ju_Formatter$Decimal.prototype = $p;
$p.ahS = (function() {
  return (this.q2 === "0");
});
$p.ajt = (function(precision) {
  $m_ju_Formatter$();
  if ((!(precision > 0))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Decimal.round() called with non-positive precision");
  }
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision);
});
$p.axR = (function(newScale) {
  var roundingPos = ((((this.q2.length + newScale) | 0) - this.nW) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  if ((!(rounded.ahS() || (rounded.nW <= newScale)))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "roundAtPos returned a non-zero value with a scale too large");
  }
  return ((rounded.ahS() || (rounded.nW === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.q1, (("" + rounded.q2) + $m_ju_Formatter$().UQ(((newScale - rounded.nW) | 0))), newScale));
});
$p.g = (function() {
  return (((((("Decimal(" + this.q1) + ", ") + this.q2) + ", ") + this.nW) + ")");
});
var $d_ju_Formatter$Decimal = new $TypeData().i($c_ju_Formatter$Decimal, "java.util.Formatter$Decimal", ({
  uG: 1
}));
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
}
$p = $c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$p.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
}
$h_ju_Formatter$LocaleInfo.prototype = $p;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cs)));
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cs)));
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bR)));
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bR)));
}
/** @constructor */
function $c_ju_internal_MurmurHash3$() {
}
$p = $c_ju_internal_MurmurHash3$.prototype = new $h_O();
$p.constructor = $c_ju_internal_MurmurHash3$;
/** @constructor */
function $h_ju_internal_MurmurHash3$() {
}
$h_ju_internal_MurmurHash3$.prototype = $p;
$p.d = (function(hash, data) {
  var h = this.kR(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.kR = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.an = (function(hash, length) {
  var hash$1 = (hash ^ length);
  var h = hash$1;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
var $d_ju_internal_MurmurHash3$ = new $TypeData().i($c_ju_internal_MurmurHash3$, "java.util.internal.MurmurHash3$", ({
  vj: 1
}));
var $n_ju_internal_MurmurHash3$;
function $m_ju_internal_MurmurHash3$() {
  if ((!$n_ju_internal_MurmurHash3$)) {
    $n_ju_internal_MurmurHash3$ = new $c_ju_internal_MurmurHash3$();
  }
  return $n_ju_internal_MurmurHash3$;
}
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.eX, $thiz.N);
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().aa5.exec($thiz.eX);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var end = x.length;
      var i = 0;
      while ((i < end)) {
        var value = i;
        $thiz.d4 = ($thiz.d4 | $m_ju_regex_PatternCompiler$().ai0(x.charCodeAt(value)));
        i = ((1 + i) | 0);
      }
    }
    if (((256 & $thiz.d4) !== 0)) {
      $thiz.d4 = (64 | $thiz.d4);
    }
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var end$1 = x$1.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var value$1 = i$1;
        $thiz.d4 = ($thiz.d4 & (~$m_ju_regex_PatternCompiler$().ai0(x$1.charCodeAt(value$1))));
        i$1 = ((1 + i$1) | 0);
      }
    }
    $thiz.N = (($thiz.N + m[0].length) | 0);
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var len = s.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I(s, i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return result;
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().zP(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break;
      }
      default: {
        return (((66 & $thiz.d4) !== 2) ? s : (((((cp - 65) | 0) >>> 0) <= 25) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().zP(((32 + cp) | 0))) + "]") : (((((cp - 97) | 0) >>> 0) <= 25) ? ((("[" + $m_ju_regex_PatternCompiler$().zP(((cp - 32) | 0))) + s) + "]") : s)));
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s);
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  while (true) {
    if (($thiz.N !== len)) {
      switch (pattern.charCodeAt($thiz.N)) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.N = ((1 + $thiz.N) | 0);
          continue;
          break;
        }
        case 35: {
          $thiz.UT();
          continue;
          break;
        }
      }
    }
    break;
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var startOfRepeater = $thiz.N;
  var repeaterDispatchChar = ((startOfRepeater === len) ? 46 : pattern.charCodeAt(startOfRepeater));
  if (((((repeaterDispatchChar === 42) || (repeaterDispatchChar === 63)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    switch (compiledToken.charCodeAt(0)) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break;
      }
      case 40: {
        var isTokenAnAssertion = ((compiledToken.charCodeAt(1) === 63) && (compiledToken.charCodeAt(2) !== 58));
        break;
      }
      case 92: {
        var c = compiledToken.charCodeAt(1);
        var isTokenAnAssertion = ((c === 66) || (c === 98));
        break;
      }
      default: {
        var isTokenAnAssertion = false;
      }
    }
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.N !== len)) {
      switch (pattern.charCodeAt($thiz.N)) {
        case 43: {
          $thiz.N = ((1 + $thiz.N) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break;
        }
        case 63: {
          $thiz.N = ((1 + $thiz.N) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break;
        }
        default: {
          return (("" + wrappedToken) + baseRepeater);
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater);
    }
  } else {
    return compiledToken;
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.eX;
  var startOfRepeater = $thiz.N;
  $thiz.N = ((1 + $thiz.N) | 0);
  if ((repeaterDispatchChar === 123)) {
    var len = pattern.length;
    if ((($thiz.N === len) || (!((((pattern.charCodeAt($thiz.N) - 48) | 0) >>> 0) <= 9)))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    while ((($thiz.N !== len) && ((((pattern.charCodeAt($thiz.N) - 48) | 0) >>> 0) <= 9))) {
      $thiz.N = ((1 + $thiz.N) | 0);
    }
    if (($thiz.N === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    if ((pattern.charCodeAt($thiz.N) === 44)) {
      $thiz.N = ((1 + $thiz.N) | 0);
      while ((($thiz.N !== len) && ((((pattern.charCodeAt($thiz.N) - 48) | 0) >>> 0) <= 9))) {
        $thiz.N = ((1 + $thiz.N) | 0);
      }
    }
    if ((($thiz.N === len) || (pattern.charCodeAt($thiz.N) !== 125))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    $thiz.N = ((1 + $thiz.N) | 0);
  }
  return pattern.substring(startOfRepeater, $thiz.N);
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = ($thiz.j0.length | 0);
  var i = 0;
  while ((i < end)) {
    var value = i;
    var mapped = ($thiz.j0[value] | 0);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.j0[value] = ((1 + mapped) | 0);
    }
    i = ((1 + i) | 0);
  }
  var amendedToken = compiledToken.replace($m_ju_regex_PatternCompiler$().aa6, ((arg1$2, arg2$2, arg3$2) => {
    var num = arg2$2.length;
    var t = ((num >>> 31) | 0);
    if (((((1 & ((num + t) | 0)) - t) | 0) === 0)) {
      return arg1$2;
    } else {
      var groupNumber = (parseInt(arg3$2, 10) | 0);
      return ((groupNumber > compiledGroupCountBeforeThisToken) ? (("" + arg2$2) + ((1 + groupNumber) | 0)) : arg1$2);
    }
  }));
  $thiz.iZ = ((1 + $thiz.iZ) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")");
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  if ((((1 + $thiz.N) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern");
  }
  $thiz.N = ((1 + $thiz.N) | 0);
  var index = $thiz.N;
  var dispatchChar = pattern.charCodeAt(index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = cls.KX;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + cls.nY) + "}");
          break;
        }
        case 1: {
          return (("\\P{" + cls.nY) + "}");
          break;
        }
        case 2: {
          return (("[" + cls.nY) + "]");
          break;
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().N4(cls.nY);
          break;
        }
        default: {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1$2);
        }
      }
      break;
    }
    case 98: {
      if ((pattern.substring($thiz.N, ((4 + $thiz.N) | 0)) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported");
      } else if (((320 & $thiz.d4) !== 0)) {
        $thiz.Ej("\\b with UNICODE_CASE", "2018");
      } else {
        $thiz.N = ((1 + $thiz.N) | 0);
        return "\\b";
      }
      break;
    }
    case 66: {
      if (((320 & $thiz.d4) !== 0)) {
        $thiz.Ej("\\B with UNICODE_CASE", "2018");
      } else {
        $thiz.N = ((1 + $thiz.N) | 0);
        return "\\B";
      }
      break;
    }
    case 65: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return "^";
      break;
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break;
    }
    case 90: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return (("(?=" + (((1 & $thiz.d4) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])")) + "?$)");
      break;
    }
    case 122: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return "$";
      break;
    }
    case 82: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break;
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break;
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.N;
      var end = ((1 + start) | 0);
      while (true) {
        if (((end !== len) && ((((pattern.charCodeAt(end) - 48) | 0) >>> 0) <= 9))) {
          var s = pattern.substring(start, ((1 + end) | 0));
          var $x_1 = ((parseInt(s, 10) | 0) <= ((($thiz.j0.length | 0) - 1) | 0));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          end = ((1 + end) | 0);
        } else {
          break;
        }
      }
      var groupString = pattern.substring(start, end);
      var groupNumber = (parseInt(groupString, 10) | 0);
      if ((groupNumber > ((($thiz.j0.length | 0) - 1) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"));
      }
      var compiledGroupNumber = ($thiz.j0[groupNumber] | 0);
      $thiz.N = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break;
    }
    case 107: {
      $thiz.N = ((1 + $thiz.N) | 0);
      if ((($thiz.N === len) || (pattern.charCodeAt($thiz.N) !== 60))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group");
      }
      $thiz.N = ((1 + $thiz.N) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.Gv;
      if ((!(!(!$m_jl_Utils$Cache$().Cr.call(dict, groupName))))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"));
      }
      var groupNumber$2 = (dict[groupName] | 0);
      var compiledGroupNumber$2 = ($thiz.j0[groupNumber$2] | 0);
      $thiz.N = ((1 + $thiz.N) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break;
    }
    case 81: {
      var start$2 = ((1 + $thiz.N) | 0);
      var end$2 = (pattern.indexOf("\\E", start$2) | 0);
      if ((end$2 < 0)) {
        $thiz.N = pattern.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2));
      } else {
        $thiz.N = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2, end$2));
      }
      break;
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz));
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.eX;
  var x1 = $f_T__codePointAt__I__I(pattern, $thiz.N);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break;
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break;
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break;
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break;
    }
    case 97: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 7;
      break;
    }
    case 116: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 9;
      break;
    }
    case 110: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 10;
      break;
    }
    case 102: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 12;
      break;
    }
    case 114: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 13;
      break;
    }
    case 101: {
      $thiz.N = ((1 + $thiz.N) | 0);
      return 27;
      break;
    }
    case 99: {
      $thiz.N = ((1 + $thiz.N) | 0);
      if (($thiz.N === pattern.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence");
      }
      var cp = $f_T__codePointAt__I__I(pattern, $thiz.N);
      $thiz.N = (($thiz.N + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break;
    }
    default: {
      if ((((((x1 - 65) | 0) >>> 0) <= 25) || ((((x1 - 97) | 0) >>> 0) <= 25))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence");
      }
      $thiz.N = (($thiz.N + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1;
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var start = $thiz.N;
  var d1 = ((((1 + start) | 0) < len) ? ((pattern.charCodeAt(((1 + start) | 0)) - 48) | 0) : (-1));
  if (((d1 >>> 0) > 7)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence");
  }
  var d2 = ((((2 + start) | 0) < len) ? ((pattern.charCodeAt(((2 + start) | 0)) - 48) | 0) : (-1));
  if (((d2 >>> 0) > 7)) {
    $thiz.N = ((2 + $thiz.N) | 0);
    return d1;
  } else if ((d1 > 3)) {
    $thiz.N = ((3 + $thiz.N) | 0);
    return (((d1 << 3) + d2) | 0);
  } else {
    var d3 = ((((3 + start) | 0) < len) ? ((pattern.charCodeAt(((3 + start) | 0)) - 48) | 0) : (-1));
    if (((d3 >>> 0) > 7)) {
      $thiz.N = ((3 + $thiz.N) | 0);
      return (((d1 << 3) + d2) | 0);
    } else {
      $thiz.N = ((4 + $thiz.N) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0);
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var start = ((1 + $thiz.N) | 0);
  if (((start !== len) && (pattern.charCodeAt(start) === 123))) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence");
    }
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.N = ((1 + innerEnd) | 0);
    return cp;
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.N = ((2 + start) | 0);
    return cp$2;
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.eX;
  var start = ((1 + $thiz.N) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.N = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && (pattern.substring(end, lowStart) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.N = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low));
    } else {
      return codeUnit;
    }
  } else {
    return codeUnit;
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  if (((end === start) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
  }
  var i = start;
  while ((i < end)) {
    var value = i;
    var c = pattern.charCodeAt(value);
    if ((!((((((c - 48) | 0) >>> 0) <= 9) || ((((c - 65) | 0) >>> 0) <= 5)) || ((((c - 97) | 0) >>> 0) <= 5)))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
    }
    i = ((1 + i) | 0);
  }
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112;
  } else {
    var s = pattern.substring(start, end);
    var cp = (parseInt(s, 16) | 0);
  }
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big");
  }
  return cp;
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.N = ((1 + $thiz.N) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().aa0;
      break;
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().aa3;
      break;
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().aa1;
      break;
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().aa4;
      break;
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().aa2;
      break;
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break;
    }
    default: {
      var positive;
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(dispatchChar));
    }
  }
  return ((dispatchChar >= 97) ? positive : positive.awo());
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var start = $thiz.N;
  if ((start === len)) {
    var property = "?";
  } else if ((pattern.charCodeAt(start) === 123)) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family");
    }
    $thiz.N = innerEnd;
    var property = pattern.substring(innerStart, innerEnd);
  } else {
    var property = pattern.substring(start, ((1 + start) | 0));
  }
  var dict = $m_ju_regex_PatternCompiler$().Rf;
  if ((!(!(!$m_jl_Utils$Cache$().Cr.call(dict, property))))) {
    $thiz.Ej("Unicode character family", "2018");
  }
  var property2 = ((((66 & $thiz.d4) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().Rf;
  var result = dict$1[property2];
  $thiz.N = ((1 + $thiz.N) | 0);
  return result;
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  $thiz.N = ((1 + $thiz.N) | 0);
  var isNegated = (($thiz.N !== len) && (pattern.charCodeAt($thiz.N) === 94));
  if (isNegated) {
    $thiz.N = ((1 + $thiz.N) | 0);
  }
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.d4) === 2), isNegated);
  while (($thiz.N !== len)) {
    var x1 = $f_T__codePointAt__I__I(pattern, $thiz.N);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.N = ((1 + $thiz.N) | 0);
          return builder.atY();
          break;
        }
        case 38: {
          $thiz.N = ((1 + $thiz.N) | 0);
          if ((($thiz.N !== len) && (pattern.charCodeAt($thiz.N) === 38))) {
            $thiz.N = ((1 + $thiz.N) | 0);
            builder.ayj();
            break matchResult;
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder);
            break matchResult;
          }
          break;
        }
        case 91: {
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz));
          break matchResult;
          break;
        }
        case 92: {
          $thiz.N = ((1 + $thiz.N) | 0);
          if (($thiz.N === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence");
          }
          var index$2 = $thiz.N;
          var c2 = pattern.charCodeAt(index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.alW($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break matchResult;
              break;
            }
            case 81: {
              $thiz.N = ((1 + $thiz.N) | 0);
              var fromIndex = $thiz.N;
              var end = (pattern.indexOf("\\E", fromIndex) | 0);
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
              }
              builder.alY(pattern, $thiz.N, end);
              $thiz.N = ((2 + end) | 0);
              break matchResult;
              break;
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder);
              break matchResult;
            }
          }
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.d4) !== 0)) {
            $thiz.N = ((1 + $thiz.N) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & $thiz.d4) !== 0)) {
            $thiz.UT();
            break matchResult;
          }
          break;
        }
      }
      $thiz.N = (($thiz.N + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder);
    }
  }
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var start = $thiz.N;
  if (((((1 + start) | 0) === len) || (pattern.charCodeAt(((1 + start) | 0)) !== 63))) {
    $thiz.N = ((1 + start) | 0);
    $thiz.iZ = ((1 + $thiz.iZ) | 0);
    $thiz.j0.push($thiz.iZ);
    return (("(" + $thiz.IU(true)) + ")");
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
    }
    var index$1 = ((2 + start) | 0);
    var c1 = pattern.charCodeAt(index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.N = ((3 + start) | 0);
      return ((("" + pattern.substring(start, ((3 + start) | 0))) + $thiz.IU(true)) + ")");
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
      }
      var index$2 = ((3 + start) | 0);
      var c2 = pattern.charCodeAt(index$2);
      if ((((((c2 - 65) | 0) >>> 0) <= 25) || ((((c2 - 97) | 0) >>> 0) <= 25))) {
        $thiz.N = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.Gv;
        if ((!(!$m_jl_Utils$Cache$().Cr.call(dict, name)))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"));
        }
        $thiz.iZ = ((1 + $thiz.iZ) | 0);
        $thiz.j0.push($thiz.iZ);
        var dict$1 = $thiz.Gv;
        var value = ((($thiz.j0.length | 0) - 1) | 0);
        dict$1[name] = value;
        $thiz.N = ((1 + $thiz.N) | 0);
        return (("(" + $thiz.IU(true)) + ")");
      } else {
        if (((c2 !== 33) && (c2 !== 61))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group");
        }
        $thiz.Ej("Look-behind group", "2018");
      }
    } else if ((c1 === 62)) {
      $thiz.N = ((3 + start) | 0);
      $thiz.iZ = ((1 + $thiz.iZ) | 0);
      var groupNumber = $thiz.iZ;
      return (((("(?:(?=(" + $thiz.IU(true)) + "))\\") + groupNumber) + ")");
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported");
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.eX;
  var len = pattern.length;
  var start = $thiz.N;
  while (true) {
    if (($thiz.N !== len)) {
      var index = $thiz.N;
      var c = pattern.charCodeAt(index);
      var $x_1 = ((((((c - 65) | 0) >>> 0) <= 25) || ((((c - 97) | 0) >>> 0) <= 25)) || ((((c - 48) | 0) >>> 0) <= 9));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.N = ((1 + $thiz.N) | 0);
    } else {
      break;
    }
  }
  if ((($thiz.N === len) || (pattern.charCodeAt($thiz.N) !== 62))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'");
  }
  return pattern.substring(start, $thiz.N);
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.d4) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz);
  }
  if ((($thiz.N !== len$2) && (pattern$3.charCodeAt($thiz.N) === 45))) {
    $thiz.N = ((1 + $thiz.N) | 0);
    if (((4 & $thiz.d4) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz);
    }
    if (($thiz.N === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
    }
    var cpEnd = $f_T__codePointAt__I__I(pattern$3, $thiz.N);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      builder$1.Mb(startCodePoint);
      builder$1.Mb(45);
    } else {
      $thiz.N = (($thiz.N + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range");
      }
      builder$1.alX(startCodePoint, endCodePoint);
    }
  } else {
    builder$1.Mb(startCodePoint);
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.eX = null;
  this.d4 = 0;
  this.KW = false;
  this.N = 0;
  this.iZ = 0;
  this.j0 = null;
  this.Gv = null;
  this.eX = pattern;
  this.d4 = flags;
  this.KW = false;
  this.N = 0;
  this.iZ = 0;
  this.j0 = [0];
  this.Gv = ({});
}
$p = $c_ju_regex_PatternCompiler.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
}
$h_ju_regex_PatternCompiler.prototype = $p;
$p.asG = (function() {
  if (((256 & this.d4) !== 0)) {
    this.d4 = (64 | this.d4);
  }
  var isLiteral = ((16 & this.d4) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this);
  }
  if (((128 & this.d4) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported");
  }
  if (((8 & this.d4) !== 0)) {
    this.Ej("MULTILINE", "2018");
  }
  if (((256 & this.d4) !== 0)) {
    this.Ej("UNICODE_CHARACTER_CLASS", "2018");
  }
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.eX);
  } else {
    if ((this.eX.substring(this.N, ((2 + this.N) | 0)) === "\\G")) {
      this.KW = true;
      this.N = ((2 + this.N) | 0);
    }
    var jsPattern = this.IU(false);
  }
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().Re ? "us" : "u");
  var jsFlags = (((66 & this.d4) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.eX, this.d4, jsPattern, jsFlags, this.KW, (((this.j0.length | 0) - 1) | 0), this.j0, this.Gv);
});
$p.Ej = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."));
});
$p.IU = (function(insideGroup) {
  var pattern = this.eX;
  var len = pattern.length;
  var result = "";
  while ((this.N !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I(pattern, this.N);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'");
          }
          this.N = ((1 + this.N) | 0);
          return result;
          break;
        }
        case 124: {
          if ((this.KW && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level");
          }
          this.N = ((1 + this.N) | 0);
          result = (result + "|");
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.d4) !== 0)) {
            this.N = ((1 + this.N) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & this.d4) !== 0)) {
            this.UT();
            break matchResult;
          }
          break;
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().zP(dispatchCP)) + "'"));
          break;
        }
      }
      var compiledGroupCountBeforeThisToken = this.iZ;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break;
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break;
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break;
        }
        case 94: {
          this.N = ((1 + this.N) | 0);
          var compiledToken = "^";
          break;
        }
        case 36: {
          this.N = ((1 + this.N) | 0);
          var compiledToken = "$";
          break;
        }
        case 46: {
          this.N = ((1 + this.N) | 0);
          var rejected = (((32 & this.d4) !== 0) ? "" : (((1 & this.d4) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().N4(rejected);
          break;
        }
        default: {
          this.N = ((this.N + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP);
        }
      }
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken));
    }
  }
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group");
  }
  return result;
});
$p.UT = (function() {
  var pattern = this.eX;
  var len = pattern.length;
  while (true) {
    if ((this.N !== len)) {
      var index = this.N;
      var c = pattern.charCodeAt(index);
      var $x_1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.N = ((1 + this.N) | 0);
    } else {
      break;
    }
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().i($c_ju_regex_PatternCompiler, "java.util.regex.PatternCompiler", ({
  vp: 1
}));
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true;
  } catch (e) {
    return false;
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.aa5 = null;
  this.aa6 = null;
  this.al9 = false;
  this.al8 = false;
  this.Re = false;
  this.aa0 = null;
  this.al5 = null;
  this.aa3 = null;
  this.aa1 = null;
  this.al6 = null;
  this.aa4 = null;
  this.aa2 = null;
  this.al7 = null;
  this.Rf = null;
  this.ala = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.aa5 = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.aa6 = new RegExp("(\\\\+)(\\d+)", "g");
  this.al9 = true;
  this.al8 = true;
  this.Re = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.aa0 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.al5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.aa3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.aa1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.al6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.aa4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.aa2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.al7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = ({});
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.Rf = r;
  this.ala = new RegExp("(?:^|_)[a-z]", "g");
}
$p = $c_ju_regex_PatternCompiler$.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
}
$h_ju_regex_PatternCompiler$.prototype = $p;
$p.Mp = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).asG();
});
$p.ai0 = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break;
    }
    case 100: {
      return 1;
      break;
    }
    case 109: {
      return 8;
      break;
    }
    case 115: {
      return 32;
      break;
    }
    case 117: {
      return 64;
      break;
    }
    case 120: {
      return 4;
      break;
    }
    case 85: {
      return 256;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag");
    }
  }
});
$p.N4 = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().Re ? "." : "[\\d\\D]"));
});
$p.zP = (function(codePoint) {
  return String.fromCodePoint(codePoint);
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().i($c_ju_regex_PatternCompiler$, "java.util.regex.PatternCompiler$", ({
  vq: 1
}));
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$();
  }
  return $n_ju_regex_PatternCompiler$;
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ki === "")) {
    $thiz.ki = alt;
  } else {
    $thiz.ki = (($thiz.ki + "|") + alt);
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.Rh) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().N4($thiz.dx);
    return (($thiz.ki === "") ? negThisSegment : (((("(?:(?!" + $thiz.ki) + ")") + negThisSegment) + ")"));
  } else {
    return (($thiz.dx === "") ? (($thiz.ki === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ki) + ")")) : (($thiz.ki === "") ? (("[" + $thiz.dx) + "]") : (((("(?:" + $thiz.ki) + "|[") + $thiz.dx) + "])")));
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().zP(codePoint);
  return (((((((codePoint - 92) | 0) >>> 0) <= 1) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s);
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.Rg = false;
  this.Rh = false;
  this.Gw = null;
  this.ki = null;
  this.dx = null;
  this.Rg = asciiCaseInsensitive;
  this.Rh = isNegated;
  this.Gw = "";
  this.ki = "";
  this.dx = "";
}
$p = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $p;
$p.atY = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.Gw === "") ? conjunct : ((("(?:" + this.Gw) + conjunct) + ")"));
});
$p.ayj = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.Gw = (this.Gw + (this.Rh ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ki = "";
  this.dx = "";
});
$p.alW = (function(cls) {
  var x1 = cls.KX;
  switch (x1) {
    case 0: {
      this.dx = ((this.dx + ("\\p{" + cls.nY)) + "}");
      break;
    }
    case 1: {
      this.dx = ((this.dx + ("\\P{" + cls.nY)) + "}");
      break;
    }
    case 2: {
      this.dx = (("" + this.dx) + cls.nY);
      break;
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().N4(cls.nY));
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
$p.alY = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I(str, i);
    this.Mb(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0);
  }
});
$p.Mb = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.dx = (("" + s) + this.dx);
  } else {
    this.dx = (("" + this.dx) + s);
  }
  if (this.Rg) {
    if (((((codePoint - 65) | 0) >>> 0) <= 25)) {
      this.dx = (("" + this.dx) + $m_ju_regex_PatternCompiler$().zP(((32 + codePoint) | 0)));
    } else if (((((codePoint - 97) | 0) >>> 0) <= 25)) {
      this.dx = (("" + this.dx) + $m_ju_regex_PatternCompiler$().zP(((codePoint - 32) | 0)));
    }
  }
});
$p.alX = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.dx = (s + this.dx);
  } else {
    this.dx = (this.dx + s);
  }
  if (this.Rg) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $x_1 = this.dx;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.dx = ($x_1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)));
    }
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $x_2 = this.dx;
      var start$3 = ((start$2 - 32) | 0);
      var end$3 = ((end$2 - 32) | 0);
      this.dx = ($x_2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)));
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().i($c_ju_regex_PatternCompiler$CharacterClassBuilder, "java.util.regex.PatternCompiler$CharacterClassBuilder", ({
  vr: 1
}));
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.Ri)) {
    $thiz.Rj = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.KX), $thiz.nY);
    $thiz.Ri = true;
  }
  return $thiz.Rj;
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.Rj = null;
  this.KX = 0;
  this.nY = null;
  this.Ri = false;
  this.KX = kind;
  this.nY = data;
}
$p = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$p.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $p;
$p.awo = (function() {
  return ((!this.Ri) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.Rj);
});
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().i($c_ju_regex_PatternCompiler$CompiledCharClass, "java.util.regex.PatternCompiler$CompiledCharClass", ({
  vs: 1
}));
function $s_RTLong__remainderUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().ax6(alo, ahi, blo, bhi);
}
function $s_RTLong__remainder__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().ax5(alo, ahi, blo, bhi);
}
function $s_RTLong__divideUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().Mu(alo, ahi, blo, bhi);
}
function $s_RTLong__divide__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().agD(alo, ahi, blo, bhi);
}
function $s_RTLong__fromDoubleBits__D__O__J(value, fpBitsDataView) {
  fpBitsDataView.setFloat64(0, value, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__fromDouble__D__J(value) {
  return $m_RTLong$().jq(value);
}
function $s_RTLong__fromUnsignedInt__I__J(value) {
  return $bL(value, 0);
}
function $s_RTLong__fromInt__I__J(value) {
  var hi = (value >> 31);
  return $bL(value, hi);
}
function $s_RTLong__clz__I__I__I(lo, hi) {
  return ((hi !== 0) ? Math.clz32(hi) : ((32 + Math.clz32(lo)) | 0));
}
function $s_RTLong__toFloat__I__I__F(lo, hi) {
  return Math.fround(((4.294967296E9 * hi) + ((((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo))) >>> 0.0)));
}
function $s_RTLong__toDouble__I__I__D(lo, hi) {
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
}
function $s_RTLong__toInt__I__I__I(lo, hi) {
  return lo;
}
function $s_RTLong__toString__I__I__T(lo, hi) {
  return $m_RTLong$().gc(lo, hi);
}
function $s_RTLong__bitsToDouble__I__I__O__D(lo, hi, fpBitsDataView) {
  fpBitsDataView.setInt32(0, lo, true);
  fpBitsDataView.setInt32(4, hi, true);
  return (+fpBitsDataView.getFloat64(0, true));
}
function $s_RTLong__mul__I__I__I__I__J(alo, ahi, blo, bhi) {
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, bhi) + Math.imul(ahi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sub__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo - blo) | 0);
  var hi = ((((ahi - bhi) | 0) - (((lo >>> 0) > (alo >>> 0)) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__add__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo + blo) | 0);
  var hi = ((((ahi + bhi) | 0) + (((lo >>> 0) < (alo >>> 0)) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sar__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : (hi >> n));
  var hi$1 = (((32 & n) === 0) ? (hi >> n) : (hi >> 31));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shr__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : ((hi >>> n) | 0));
  var hi$1 = (((32 & n) === 0) ? ((hi >>> n) | 0) : 0);
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shl__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> (~n)) | 0) | (hi << n)) : (lo << n));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__xor__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo ^ blo);
  var hi = (ahi ^ bhi);
  return $bL(lo, hi);
}
function $s_RTLong__and__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo & blo);
  var hi = (ahi & bhi);
  return $bL(lo, hi);
}
function $s_RTLong__or__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo | blo);
  var hi = (ahi | bhi);
  return $bL(lo, hi);
}
function $s_RTLong__geu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__gtu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__leu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ltu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ge__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__gt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__le__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__lt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__notEquals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) !== 0);
}
function $s_RTLong__equals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) === 0);
}
/** @constructor */
function $c_RTLong$() {
}
$p = $c_RTLong$.prototype = new $h_O();
$p.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
}
$h_RTLong$.prototype = $p;
$p.gc = (function(lo, hi) {
  if ((hi === (lo >> 31))) {
    return ("" + lo);
  } else if ((((-2097152) & (hi ^ (hi >> 10))) === 0)) {
    return ("" + ((4.294967296E9 * hi) + (lo >>> 0.0)));
  } else {
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var qHat = (+Math.floor((1.0000000000000265E-9 * aHat)));
    var rHat = ((rlo - Math.imul(1000000000, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((1000000000 + rHat) | 0);
    }
    var this$7 = rHat;
    var remStr = ("" + this$7);
    var $x_1 = qHat;
    var start = remStr.length;
    var s = ((("" + $x_1) + "000000000".substring(start)) + remStr);
    return ((hi < 0) ? ("-" + s) : s);
  }
});
$p.jq = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    return $bL(0, (-2147483648));
  } else if ((value >= 9.223372036854776E18)) {
    return $bL((-1), 2147483647);
  } else {
    var rawLo = (value | 0.0);
    var rawHi = ((2.3283064365386963E-10 * value) | 0.0);
    var hi = (((value < 0.0) && (rawLo !== 0)) ? ((rawHi - 1) | 0) : rawHi);
    return $bL(rawLo, hi);
  }
});
$p.agD = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  if (((rhi$1 | ((-2097152) & rlo$1)) === 0)) {
    var quotHi = (((rhi >>> 0) / ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var k = ((rhi - Math.imul(rlo$1, quotHi)) | 0);
    var quotLo = ((((4.294967296E9 * k) + (rlo >>> 0.0)) / rlo$1) | 0.0);
    var absR_$_lo = quotLo;
    var absR_$_hi = quotHi;
  } else {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    if ((((((rhi - ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0)) | 0) - (((((rlo - lo$1) | 0) >>> 0) > (rlo >>> 0)) | 0)) | 0) < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else {
      var absR_$_lo = lo;
      var absR_$_hi = hi;
    }
  }
  if (((ahi ^ bhi) >= 0)) {
    return $bL(absR_$_lo, absR_$_hi);
  } else {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  }
});
$p.Mu = (function(alo, ahi, blo, bhi) {
  if (((bhi | ((-2097152) & blo)) === 0)) {
    var quotHi = (((ahi >>> 0) / ($checkIntDivisor(blo) >>> 0)) | 0);
    var k = ((ahi - Math.imul(blo, quotHi)) | 0);
    var quotLo = ((((4.294967296E9 * k) + (alo >>> 0.0)) / blo) | 0.0);
    return $bL(quotLo, quotHi);
  } else if ((bhi >= 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    if ((((((ahi - ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0)) | 0) - (((((alo - lo$1) | 0) >>> 0) > (alo >>> 0)) | 0)) | 0) < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else {
      return $bL(lo, hi);
    }
  } else if (((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)))) {
    return $bL(0, 0);
  } else {
    return $bL(1, 0);
  }
});
$p.ax5 = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  if (((rhi$1 | ((-2097152) & rlo$1)) === 0)) {
    var k$2 = (((rhi >>> 0) % ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var quotLo$2 = ((((4.294967296E9 * k$2) + (rlo >>> 0.0)) / rlo$1) | 0.0);
    var remLo = ((rlo - Math.imul(rlo$1, quotLo$2)) | 0);
    var absR_$_lo = remLo;
    var absR_$_hi = 0;
  } else {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((rlo - lo$1) | 0);
    var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + rlo$1) | 0);
      var hi$3 = ((((hi$2 + rhi$1) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else {
      var absR_$_lo = lo$2;
      var absR_$_hi = hi$2;
    }
  }
  if ((ahi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.ax6 = (function(alo, ahi, blo, bhi) {
  if (((bhi | ((-2097152) & blo)) === 0)) {
    var k$2 = (((ahi >>> 0) % ($checkIntDivisor(blo) >>> 0)) | 0);
    var quotLo$2 = ((((4.294967296E9 * k$2) + (alo >>> 0.0)) / blo) | 0.0);
    var remLo = ((alo - Math.imul(blo, quotLo$2)) | 0);
    return $bL(remLo, 0);
  } else if ((bhi >= 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = ((aHat / bHat) + 0.00390625);
    var lo = (x$1 | 0.0);
    var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((alo - lo$1) | 0);
    var hi$2 = ((((ahi - hi$1) | 0) - (((lo$2 >>> 0) > (alo >>> 0)) | 0)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + blo) | 0);
      var hi$3 = ((((hi$2 + bhi) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else {
      return $bL(lo$2, hi$2);
    }
  } else if (((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)))) {
    return $bL(alo, ahi);
  } else {
    var lo$4 = ((alo - blo) | 0);
    var hi$4 = ((((ahi - bhi) | 0) - (((lo$4 >>> 0) > (alo >>> 0)) | 0)) | 0);
    return $bL(lo$4, hi$4);
  }
});
var $d_RTLong$ = new $TypeData().i($c_RTLong$, "org.scalajs.linker.runtime.RuntimeLong$", ({
  vE: 1
}));
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$();
  }
  return $n_RTLong$;
}
/** @constructor */
function $c_s_$less$colon$less$() {
  this.b0 = null;
  $n_s_$less$colon$less$ = this;
  this.b0 = new $c_s_$less$colon$less$$anon$1();
}
$p = $c_s_$less$colon$less$.prototype = new $h_O();
$p.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
$h_s_$less$colon$less$.prototype = $p;
var $d_s_$less$colon$less$ = new $TypeData().i($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  vH: 1
}));
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().bQ(dest, j, $m_sr_ScalaRunTime$().cZ(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.r().C)(len);
  $m_ju_Arrays$().agU(result, (void 0));
  return result;
}
/** @constructor */
function $c_s_Array$() {
}
$p = $c_s_Array$.prototype = new $h_O();
$p.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
}
$h_s_Array$.prototype = $p;
$p.aha = (function(it, evidence$1) {
  var n = it.G();
  if ((n > (-1))) {
    var elements = evidence$1.fb(n);
    var iterator = it.l();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().bQ(elements, i, iterator.e());
      i = ((1 + i) | 0);
    }
    return elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1.dK();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var iterator$2 = it.l();
    while (iterator$2.f()) {
      var elem = iterator$2.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
});
$p.dd = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if ((srcClass.ax.Z && $objectGetClass(dest).ax.R(srcClass.ax))) {
    src.av(srcPos, dest, destPos, length);
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length);
  }
});
$p.mA = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  }
  if ((original instanceof $ac_O)) {
    return $m_ju_Arrays$().cn(original, newLength);
  }
  if ((original instanceof $ac_I)) {
    return $m_ju_Arrays$().agm(original, newLength);
  }
  if ((original instanceof $ac_D)) {
    return $m_ju_Arrays$().asX(original, newLength);
  }
  if ((original instanceof $ac_J)) {
    return $m_ju_Arrays$().U2(original, newLength);
  }
  if ((original instanceof $ac_F)) {
    return $m_ju_Arrays$().asY(original, newLength);
  }
  if ((original instanceof $ac_C)) {
    return $m_ju_Arrays$().Mr(original, newLength);
  }
  if ((original instanceof $ac_B)) {
    return $m_ju_Arrays$().agl(original, newLength);
  }
  if ((original instanceof $ac_S)) {
    return $m_ju_Arrays$().agn(original, newLength);
  }
  if ((original instanceof $ac_Z)) {
    return $m_ju_Arrays$().ago(original, newLength);
  }
  throw new $c_s_MatchError(original);
});
$p.asW = (function(original, newLength, ct) {
  var runtimeClass = ct.dK();
  if (((runtimeClass !== null) && (runtimeClass === $d_V.l()))) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if (runtimeClass.ax.R($objectGetClass(original).ax.Q().ax)) {
    return (runtimeClass.ax.X ? this.mA(original, newLength) : $m_ju_Arrays$().Iv(original, newLength, $objectGetClass(runtimeClass.ax.U(0))));
  } else {
    var dest = ct.fb(newLength);
    $m_s_Array$().dd(original, 0, dest, 0, $m_jl_reflect_Array$().b1(original));
    return dest;
  }
});
$p.agQ = (function(xs, ys) {
  if ((xs === ys)) {
    return true;
  }
  if ((xs.a.length !== ys.a.length)) {
    return false;
  }
  var len = xs.a.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().B(xs.a[i], ys.a[i]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_s_Array$ = new $TypeData().i($c_s_Array$, "scala.Array$", ({
  vJ: 1
}));
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$();
  }
  return $n_s_Array$;
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.Gz = null;
  this.Rm = null;
  $n_s_Array$EmptyArrays$ = this;
  this.Gz = new $ac_I(0);
  this.Rm = new $ac_O(0);
}
$p = $c_s_Array$EmptyArrays$.prototype = new $h_O();
$p.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
}
$h_s_Array$EmptyArrays$.prototype = $p;
var $d_s_Array$EmptyArrays$ = new $TypeData().i($c_s_Array$EmptyArrays$, "scala.Array$EmptyArrays$", ({
  vK: 1
}));
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$();
  }
  return $n_s_Array$EmptyArrays$;
}
/** @constructor */
function $c_s_LowPriorityImplicits2() {
}
$p = $c_s_LowPriorityImplicits2.prototype = new $h_O();
$p.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
}
$h_s_LowPriorityImplicits2.prototype = $p;
/** @constructor */
function $c_s_Option$() {
}
$p = $c_s_Option$.prototype = new $h_O();
$p.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
$h_s_Option$.prototype = $p;
$p.hi = (function(xo) {
  return (xo.c() ? $m_sc_Iterable$().ce() : ($m_sc_Iterable$(), new $c_sc_Iterable$$anon$1(xo.h())));
});
$p.Z = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x));
});
var $d_s_Option$ = new $TypeData().i($c_s_Option$, "scala.Option$", ({
  vX: 1
}));
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
/** @constructor */
function $c_s_Option$WithFilter(outer, p) {
  this.y7 = null;
  this.y6 = null;
  this.y7 = p;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.y6 = outer;
}
$p = $c_s_Option$WithFilter.prototype = new $h_O();
$p.constructor = $c_s_Option$WithFilter;
/** @constructor */
function $h_s_Option$WithFilter() {
}
$h_s_Option$WithFilter.prototype = $p;
var $d_s_Option$WithFilter = new $TypeData().i($c_s_Option$WithFilter, "scala.Option$WithFilter", ({
  vY: 1
}));
/** @constructor */
function $c_s_PartialFunction$() {
  this.L1 = null;
  this.alb = null;
  this.fX = null;
  $n_s_PartialFunction$ = this;
  this.L1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => this.L1));
  this.alb = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => false));
  this.fX = new $c_s_PartialFunction$$anon$1();
}
$p = $c_s_PartialFunction$.prototype = new $h_O();
$p.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
$h_s_PartialFunction$.prototype = $p;
$p.axy = (function(x) {
  return (this.L1 === x);
});
var $d_s_PartialFunction$ = new $TypeData().i($c_s_PartialFunction$, "scala.PartialFunction$", ({
  vZ: 1
}));
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
function $f_s_Proxy__toString__T($thiz) {
  var $x_1 = $thiz;
  return ("" + $s_RTLong__toString__I__I__T($x_1.g6, $x_1.g7));
}
function $ct_s_UniquenessCache__($thiz) {
  $thiz.Rr = ({});
  return $thiz;
}
/** @constructor */
function $c_s_UniquenessCache() {
  this.Rr = null;
}
$p = $c_s_UniquenessCache.prototype = new $h_O();
$p.constructor = $c_s_UniquenessCache;
/** @constructor */
function $h_s_UniquenessCache() {
}
$h_s_UniquenessCache.prototype = $p;
$p.amC = (function(name) {
  var dict = this.Rr;
  if ((!(!$m_sjs_js_WrappedDictionary$Cache$().abI.call(dict, name)))) {
    return dict[name];
  } else {
    var v = new $c_s_Symbol(name);
    dict[name] = v;
    return v;
  }
});
function $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().afN(\u03b4this$2);
    $m_s_util_Sorting$().Jd(a, 0, $m_jl_reflect_Array$().b1(a), ord$1);
    return a;
  } else {
    if ($d_O.R($objectGetClass(\u03b4this$2).ax.Q().ax)) {
      var a$2 = $m_ju_Arrays$().Iv(\u03b4this$2, len$1, $d_O.r().l());
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().dd(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().b1(\u03b4this$2));
      var a$2 = dest;
    }
    $m_ju_Arrays$().zY(a$2, ord$1);
    return $m_s_Array$().asW(a$2, len$1, $m_s_reflect_ClassTag$().um($objectGetClass(\u03b4this$2).ax.Q()));
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  this.aag = null;
  $n_sc_ArrayOps$ = this;
  this.aag = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sc_ArrayOps$().aag));
}
$p = $c_sc_ArrayOps$.prototype = new $h_O();
$p.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
}
$h_sc_ArrayOps$.prototype = $p;
$p.auG = (function(this$) {
  if (($m_jl_reflect_Array$().b1(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().cZ(this$, 0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array");
  }
});
$p.ai1 = (function(this$) {
  if (($m_jl_reflect_Array$().b1(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().cZ(this$, (($m_jl_reflect_Array$().b1(this$) - 1) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array");
  }
});
$p.uD = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().b1(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      return $m_ju_Arrays$().bO(this$, lo, hi);
    } else if ((this$ instanceof $ac_I)) {
      return $m_ju_Arrays$().at3(this$, lo, hi);
    } else if ((this$ instanceof $ac_D)) {
      return $m_ju_Arrays$().at1(this$, lo, hi);
    } else if ((this$ instanceof $ac_J)) {
      return $m_ju_Arrays$().at4(this$, lo, hi);
    } else if ((this$ instanceof $ac_F)) {
      return $m_ju_Arrays$().at2(this$, lo, hi);
    } else if ((this$ instanceof $ac_C)) {
      return $m_ju_Arrays$().at0(this$, lo, hi);
    } else if ((this$ instanceof $ac_B)) {
      return $m_ju_Arrays$().asZ(this$, lo, hi);
    } else if ((this$ instanceof $ac_S)) {
      return $m_ju_Arrays$().at5(this$, lo, hi);
    } else if ((this$ instanceof $ac_Z)) {
      return $m_ju_Arrays$().at6(this$, lo, hi);
    } else {
      throw new $c_s_MatchError(this$);
    }
  } else {
    return $m_s_reflect_ClassTag$().um($objectGetClass(this$).ax.Q()).fb(0);
  }
});
$p.ayt = (function(this$) {
  if (($m_jl_reflect_Array$().b1(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array");
  } else {
    return $m_sc_ArrayOps$().uD(this$, 1, $m_jl_reflect_Array$().b1(this$));
  }
});
$p.atn = (function(this$, n) {
  return $m_sc_ArrayOps$().uD(this$, n, $m_jl_reflect_Array$().b1(this$));
});
$p.att = (function(this$, n) {
  return $m_sc_ArrayOps$().uD(this$, 0, (($m_jl_reflect_Array$().b1(this$) - ((n > 0) ? n : 0)) | 0));
});
$p.ayg = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().b1(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().afN(this$);
  } else if ((this$ instanceof $ac_O)) {
    var a = $m_ju_Arrays$().cn(this$, len);
    $m_ju_Arrays$().zY(a, ord);
    return a;
  } else if ((this$ instanceof $ac_I)) {
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().agm(this$, len);
      $m_ju_Arrays$().ajQ(a$2);
      return a$2;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_J)) {
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().U2(this$, len);
      $m_ju_Arrays$().ajR(a$3);
      return a$3;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_C)) {
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().Mr(this$, len);
      $m_ju_Arrays$().ajP(a$4);
      return a$4;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_B)) {
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().agl(this$, len);
      $m_ju_Arrays$().ajO(a$5);
      return a$5;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_S)) {
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().agn(this$, len);
      $m_ju_Arrays$().ajS(a$6);
      return a$6;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_Z)) {
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().ago(this$, len);
      $m_s_util_Sorting$().Jd(a$7, 0, a$7.a.length, $m_s_math_Ordering$Boolean$());
      return a$7;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else {
    return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
  }
});
$p.aEu = (function(this$) {
  var b = new ($d_T2.r().C)($m_jl_reflect_Array$().b1(this$));
  var i = 0;
  while ((i < $m_jl_reflect_Array$().b1(this$))) {
    b.a[i] = new $c_T2($m_sr_ScalaRunTime$().cZ(this$, i), i);
    i = ((1 + i) | 0);
  }
  return b;
});
$p.auS = (function(this$) {
  return new $c_sci_Range$Exclusive(0, $m_jl_reflect_Array$().b1(this$), 1);
});
$p.NC = (function(this$) {
  return $m_sci_ArraySeq$().ge($m_s_Array$().mA(this$, $m_jl_reflect_Array$().b1(this$)));
});
var $d_sc_ArrayOps$ = new $TypeData().i($c_sc_ArrayOps$, "scala.collection.ArrayOps$", ({
  wd: 1
}));
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$();
  }
  return $n_sc_ArrayOps$;
}
/** @constructor */
function $c_sc_BitSetOps$() {
}
$p = $c_sc_BitSetOps$.prototype = new $h_O();
$p.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
}
$h_sc_BitSetOps$.prototype = $p;
$p.VL = (function(elems, idx, w_$_lo, w_$_hi) {
  var len = ((elems.a.length >>> 1) | 0);
  while (true) {
    if ((len > 0)) {
      var $x_2 = elems.a;
      var $x_3 = (((len - 1) | 0) << 1);
      var x_$_lo = $x_2[$x_3];
      var x_$_hi = $x_2[(($x_3 + 1) | 0)];
      if (((x_$_lo | x_$_hi) === 0)) {
        var $x_1 = true;
      } else {
        var $x_1 = (((w_$_lo | w_$_hi) === 0) && (idx === ((len - 1) | 0)));
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      len = ((len - 1) | 0);
    } else {
      break;
    }
  }
  var newlen = len;
  if (((idx >= newlen) && ((w_$_lo | w_$_hi) !== 0))) {
    newlen = ((1 + idx) | 0);
  }
  var newelems = new $ac_J(newlen);
  $m_s_Array$().dd(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    var $x_4 = newelems.a;
    var $x_5 = (idx << 1);
    $x_4[$x_5] = w_$_lo;
    $x_4[(($x_5 + 1) | 0)] = w_$_hi;
  } else if (((w_$_lo | w_$_hi) !== 0)) {
    $m_sr_Scala3RunTime$().afO();
  }
  return newelems;
});
$p.us = (function(pred, isFlipped, oldWord_$_lo, oldWord_$_hi, wordIndex) {
  if (((oldWord_$_lo | oldWord_$_hi) === 0)) {
    return $bL(0, 0);
  } else {
    var w_$_lo = oldWord_$_lo;
    var w_$_hi = oldWord_$_hi;
    var l_$_lo = w_$_lo;
    var l_$_hi = w_$_hi;
    var trailingZeroes = ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0));
    var lo = (((32 & trailingZeroes) === 0) ? (1 << trailingZeroes) : 0);
    var hi = (((32 & trailingZeroes) === 0) ? 0 : (1 << trailingZeroes));
    var jmask_$_lo = lo;
    var jmask_$_hi = hi;
    var j = (((wordIndex << 6) + trailingZeroes) | 0);
    var l$1_$_lo = w_$_lo;
    var l$1_$_hi = w_$_hi;
    var maxJ = (((((1 + wordIndex) | 0) << 6) - ((l$1_$_hi !== 0) ? Math.clz32(l$1_$_hi) : ((32 + Math.clz32(l$1_$_lo)) | 0))) | 0);
    while ((j !== maxJ)) {
      var x_$_lo = w_$_lo;
      var x_$_hi = w_$_hi;
      var x$1_$_lo = jmask_$_lo;
      var x$1_$_hi = jmask_$_hi;
      if ((((x_$_lo & x$1_$_lo) | (x_$_hi & x$1_$_hi)) !== 0)) {
        if (((!(!pred.p(j))) === isFlipped)) {
          var x$3_$_lo = w_$_lo;
          var x$3_$_hi = w_$_hi;
          var x$2_$_lo = jmask_$_lo;
          var x$2_$_hi = jmask_$_hi;
          var lo$2 = (~x$2_$_lo);
          var hi$2 = (~x$2_$_hi);
          var lo$3 = (x$3_$_lo & lo$2);
          var hi$3 = (x$3_$_hi & hi$2);
          w_$_lo = lo$3;
          w_$_hi = hi$3;
        }
      }
      var x$4_$_lo = jmask_$_lo;
      var x$4_$_hi = jmask_$_hi;
      var lo$4 = (x$4_$_lo << 1);
      var hi$4 = (((x$4_$_lo >>> 31) | 0) | (x$4_$_hi << 1));
      jmask_$_lo = lo$4;
      jmask_$_hi = hi$4;
      j = ((1 + j) | 0);
    }
    return $bL(w_$_lo, w_$_hi);
  }
});
var $d_sc_BitSetOps$ = new $TypeData().i($c_sc_BitSetOps$, "scala.collection.BitSetOps$", ({
  wf: 1
}));
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$();
  }
  return $n_sc_BitSetOps$;
}
/** @constructor */
function $c_sc_Hashing$() {
}
$p = $c_sc_Hashing$.prototype = new $h_O();
$p.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
}
$h_sc_Hashing$.prototype = $p;
$p.bV = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0));
});
var $d_sc_Hashing$ = new $TypeData().i($c_sc_Hashing$, "scala.collection.Hashing$", ({
  wp: 1
}));
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$();
  }
  return $n_sc_Hashing$;
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $thiz.l();
  while (it.f()) {
    f.p(it.e());
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $thiz.l();
  while ((res && it.f())) {
    res = (!(!p.p(it.e())));
  }
  return res;
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $thiz.l();
  while (((!res) && it.f())) {
    res = (!(!p.p(it.e())));
  }
  return res;
}
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $thiz.l();
  while (it.f()) {
    var a = it.e();
    if ((!(!p.p(a)))) {
      return new $c_s_Some(a);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    return $p_sc_IterableOnceOps__loop$1__F2__sc_IndexedSeq__I__I__O__O($thiz, op, $thiz, 0, $thiz.F(), z);
  } else {
    var result = z;
    var it = $thiz.l();
    while (it.f()) {
      result = op.cm(result, it.e());
    }
    return result;
  }
}
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    if (($thiz.F() > 0)) {
      var z = $thiz.at(0);
      return $p_sc_IterableOnceOps__loop$1__F2__sc_IndexedSeq__I__I__O__O($thiz, op, $thiz, 1, $thiz.F(), z);
    }
  }
  if (($thiz.G() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
  var it = $thiz.l();
  if (it.f()) {
    var acc = it.e();
    while (it.f()) {
      acc = op.cm(acc, it.e());
    }
    return acc;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  var x30 = $thiz.G();
  if ((x30 === (-1))) {
    return (!$thiz.l().f());
  }
  if ((x30 === 0)) {
    return true;
  }
  return false;
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($thiz.G() >= 0)) {
    return $thiz.G();
  } else {
    var it = $thiz.l();
    var len = 0;
    while (it.f()) {
      len = ((1 + len) | 0);
      it.e();
    }
    return len;
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, dest, start, n) {
  var it = $thiz.l();
  var i = start;
  matchResult18: {
    var srclen;
    var x31 = $thiz.G();
    if ((x31 === (-1))) {
      var srclen = $m_jl_reflect_Array$().b1(dest);
      break matchResult18;
    }
    var srclen = x31;
  }
  var destLen = $m_jl_reflect_Array$().b1(dest);
  var limit = ((n < srclen) ? n : srclen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var end = ((start + ((total < 0) ? 0 : total)) | 0);
  while (((i < end) && it.f())) {
    $m_sr_ScalaRunTime$().bQ(dest, i, it.e());
    i = ((1 + i) | 0);
  }
  return ((i - start) | 0);
}
function $f_sc_IterableOnceOps__sum__s_math_Numeric__O($thiz, num) {
  var x32 = $thiz.G();
  if ((x32 === (-1))) {
    return $thiz.fL(num.ID(0), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => num.Ni(x$2, y$2))));
  }
  if ((x32 === 0)) {
    return num.ID(0);
  }
  return $thiz.gM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2$1, y$2$1) => num.Ni(x$2$1, y$2$1))));
}
function $f_sc_IterableOnceOps__min__s_math_Ordering__O($thiz, ord) {
  var x34 = $thiz.G();
  if ((x34 === (-1))) {
    var it = $thiz.l();
    if (it.f()) {
      var acc = it.e();
      while (it.f()) {
        var x0 = acc;
        var x1 = it.e();
        acc = ord.fr(x0, x1);
      }
      return acc;
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
    }
  }
  if ((x34 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
  }
  return $thiz.gM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.fr(x$2, y$2))));
}
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  var x36 = $thiz.G();
  if ((x36 === (-1))) {
    var it = $thiz.l();
    if (it.f()) {
      var acc = it.e();
      while (it.f()) {
        var x0 = acc;
        var x1 = it.e();
        acc = ord.eR(x0, x1);
      }
      return acc;
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
    }
  }
  if ((x36 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
  }
  return $thiz.gM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.eR(x$2, y$2))));
}
function $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($thiz, ord) {
  var x37 = $thiz.G();
  if ((x37 === (-1))) {
    var it = $thiz.l();
    if (it.f()) {
      var acc = it.e();
      while (it.f()) {
        var x0 = acc;
        var x1 = it.e();
        acc = ord.eR(x0, x1);
      }
      return new $c_s_Some(acc);
    } else {
      return $m_s_None$();
    }
  }
  if ((x37 === 0)) {
    return $m_s_None$();
  }
  return new $c_s_Some($thiz.gM(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.eR(x$2, y$2)))));
}
function $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O($thiz, f, ord) {
  if (($thiz.G() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.maxBy");
  }
  return $thiz.fL(new $c_sc_IterableOnceOps$Maximized("maxBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.fm(x$2, y$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2, a$2) => m$2.Mi(m$2, a$2)))).aR();
}
function $f_sc_IterableOnceOps__maxByOption__F1__s_math_Ordering__s_Option($thiz, f, ord) {
  return (($thiz.G() === 0) ? $m_s_None$() : $thiz.fL(new $c_sc_IterableOnceOps$Maximized("maxBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.fm(x$2, y$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2, a$2) => m$2.Mi(m$2, a$2)))).mN());
}
function $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O($thiz, f, ord) {
  if (($thiz.G() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.minBy");
  }
  return $thiz.fL(new $c_sc_IterableOnceOps$Maximized("minBy", f, new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$2, y$2) => ord.fQ(x$2, y$2)))), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((m$2, a$2) => m$2.Mi(m$2, a$2)))).aR();
}
function $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($thiz, pf) {
  var sentinel = new $c_sc_IterableOnceOps$$anon$1();
  var it = $thiz.l();
  while (it.f()) {
    var x = pf.aJ(it.e(), sentinel);
    if ((x !== sentinel)) {
      return new $c_s_Some(x);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  return (($thiz.G() === 0) ? (("" + start) + end) : $thiz.gG($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end).et.aC);
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.et;
  if ((start.length !== 0)) {
    jsb.aC = (("" + jsb.aC) + start);
  }
  var it = $thiz.l();
  if (it.f()) {
    var obj = it.e();
    jsb.aC = (("" + jsb.aC) + obj);
    while (it.f()) {
      if ((sep.length !== 0)) {
        jsb.aC = (("" + jsb.aC) + sep);
      }
      var obj$1 = it.e();
      jsb.aC = (("" + jsb.aC) + obj$1);
    }
  }
  if ((end.length !== 0)) {
    jsb.aC = (("" + jsb.aC) + end);
  }
  return b;
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$1) {
  if (($thiz.G() >= 0)) {
    var length = $thiz.G();
    var destination = evidence$1.fb(length);
    $thiz.d0(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1.dK();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = $thiz.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $thiz.l();
  while (it.f()) {
    xs = new $c_sci_$colon$colon(it.e(), xs);
  }
  return xs;
}
function $p_sc_IterableOnceOps__loop$1__F2__sc_IndexedSeq__I__I__O__O($thiz, op$1, seq$1, at, end, acc) {
  var acc$tailLocal1 = acc;
  var at$tailLocal1 = at;
  while (true) {
    if ((at$tailLocal1 === end)) {
      return acc$tailLocal1;
    } else {
      var at$tailLocal1$tmp1 = ((1 + at$tailLocal1) | 0);
      var acc$tailLocal1$tmp1 = op$1.cm(acc$tailLocal1, seq$1.at(at$tailLocal1));
      at$tailLocal1 = at$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.aav = null;
  this.GL = null;
  this.aav = head;
  this.GL = tail;
}
$p = $c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$p.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $p;
$p.auH = (function() {
  return this.aav.aA().l();
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().i($c_sc_Iterator$ConcatIteratorCell, "scala.collection.Iterator$ConcatIteratorCell", ({
  wN: 1
}));
function $p_sc_SeqOps$__kmpOptimizeWord__sc_Seq__I__I__Z__sc_IndexedSeqView($thiz, W, n0, n1, forward) {
  return ($is_sc_IndexedSeq(W) ? (((forward && (n0 === 0)) && (n1 === W.F())) ? W.mR() : (forward ? new $c_sc_SeqOps$$anon$1(n1, n0, W) : new $c_sc_SeqOps$$anon$2(n1, n0, W))) : new $c_sc_SeqOps$$anon$3(n1, n0, forward, W));
}
function $p_sc_SeqOps$__kmpJumpTable__sc_IndexedSeqView__I__AI($thiz, Wopt, wlen) {
  var arr = new $ac_I(wlen);
  var pos = 2;
  var cnd = 0;
  arr.a[0] = (-1);
  arr.a[1] = 0;
  while ((pos < wlen)) {
    if ($m_sr_BoxesRunTime$().B(Wopt.at(((pos - 1) | 0)), Wopt.at(cnd))) {
      arr.a[pos] = ((1 + cnd) | 0);
      pos = ((1 + pos) | 0);
      cnd = ((1 + cnd) | 0);
    } else if ((cnd > 0)) {
      cnd = arr.a[cnd];
    } else {
      arr.a[pos] = 0;
      pos = ((1 + pos) | 0);
    }
  }
  return arr;
}
function $p_sc_SeqOps$__clipR$1__I__I__I($thiz, x, y) {
  return ((x < y) ? x : (-1));
}
function $p_sc_SeqOps$__clipL$1__I__I__I($thiz, x, y) {
  return ((x > y) ? x : (-1));
}
/** @constructor */
function $c_sc_SeqOps$() {
}
$p = $c_sc_SeqOps$.prototype = new $h_O();
$p.constructor = $c_sc_SeqOps$;
/** @constructor */
function $h_sc_SeqOps$() {
}
$h_sc_SeqOps$.prototype = $p;
$p.axz = (function(S, m0, m1, W, n0, n1, forward) {
  if ((n1 === ((1 + n0) | 0))) {
    return (forward ? $p_sc_SeqOps$__clipR$1__I__I__I(this, S.Ed(W.at(n0), m0), m1) : $p_sc_SeqOps$__clipL$1__I__I__I(this, S.IV(W.at(n0), ((m1 - 1) | 0)), ((m0 - 1) | 0)));
  } else if ((((m1 - m0) | 0) === ((n1 - n0) | 0))) {
    return ($f_sc_Iterator__sameElements__sc_IterableOnce__Z(S.l().EA(m0, m1), W.l().EA(n0, n1)) ? m0 : (-1));
  } else if ($is_sc_IndexedSeq(S)) {
    var Wopt = $p_sc_SeqOps$__kmpOptimizeWord__sc_Seq__I__I__Z__sc_IndexedSeqView(this, W, n0, n1, forward);
    var T = $p_sc_SeqOps$__kmpJumpTable__sc_IndexedSeqView__I__AI(this, Wopt, ((n1 - n0) | 0));
    var i = 0;
    var m = 0;
    var zero = (forward ? m0 : ((m1 - 1) | 0));
    var delta = (forward ? 1 : (-1));
    while ((((i + m) | 0) < ((m1 - m0) | 0))) {
      if ($m_sr_BoxesRunTime$().B(Wopt.at(i), S.at(((zero + Math.imul(delta, ((i + m) | 0))) | 0)))) {
        i = ((1 + i) | 0);
        if ((i === ((n1 - n0) | 0))) {
          return (forward ? ((m + m0) | 0) : ((((m1 - m) | 0) - i) | 0));
        }
      } else {
        var ti = T.a[i];
        m = ((m + ((i - ti) | 0)) | 0);
        if ((i > 0)) {
          i = ti;
        }
      }
    }
    return (-1);
  } else {
    var iter = S.l().ex(m0);
    var Wopt$2 = $p_sc_SeqOps$__kmpOptimizeWord__sc_Seq__I__I__Z__sc_IndexedSeqView(this, W, n0, n1, true);
    var T$2 = $p_sc_SeqOps$__kmpJumpTable__sc_IndexedSeqView__I__AI(this, Wopt$2, ((n1 - n0) | 0));
    var cache = new $ac_O(((n1 - n0) | 0));
    var largest = 0;
    var i$2 = 0;
    var m$2 = 0;
    var answer = (-1);
    while ((((((((m$2 + m0) | 0) + n1) | 0) - n0) | 0) <= m1)) {
      while ((((i$2 + m$2) | 0) >= largest)) {
        cache.a[((largest % $checkIntDivisor(((n1 - n0) | 0))) | 0)] = iter.e();
        largest = ((1 + largest) | 0);
      }
      if ($m_sr_BoxesRunTime$().B(Wopt$2.at(i$2), cache.a[((((i$2 + m$2) | 0) % $checkIntDivisor(((n1 - n0) | 0))) | 0)])) {
        i$2 = ((1 + i$2) | 0);
        if ((i$2 === ((n1 - n0) | 0))) {
          if (forward) {
            return ((m$2 + m0) | 0);
          } else {
            i$2 = ((i$2 - 1) | 0);
            answer = ((m$2 + m0) | 0);
            var ti$2 = T$2.a[i$2];
            m$2 = ((m$2 + ((i$2 - ti$2) | 0)) | 0);
            if ((i$2 > 0)) {
              i$2 = ti$2;
            }
          }
        }
      } else {
        var ti$3 = T$2.a[i$2];
        m$2 = ((m$2 + ((i$2 - ti$3) | 0)) | 0);
        if ((i$2 > 0)) {
          i$2 = ti$3;
        }
      }
    }
    return answer;
  }
});
var $d_sc_SeqOps$ = new $TypeData().i($c_sc_SeqOps$, "scala.collection.SeqOps$", ({
  x0: 1
}));
var $n_sc_SeqOps$;
function $m_sc_SeqOps$() {
  if ((!$n_sc_SeqOps$)) {
    $n_sc_SeqOps$ = new $c_sc_SeqOps$();
  }
  return $n_sc_SeqOps$;
}
/** @constructor */
function $c_sc_StringOps$() {
  this.aaJ = null;
  $n_sc_StringOps$ = this;
  this.aaJ = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => this.aaJ));
}
$p = $c_sc_StringOps$.prototype = new $h_O();
$p.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
}
$h_sc_StringOps$.prototype = $p;
$p.EB = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var that = this$.length;
  var end = ((until < that) ? until : that);
  return ((start >= end) ? "" : this$.substring(start, end));
});
$p.ayk = (function(this$) {
  if ((this$ === "")) {
    return this$;
  } else {
    var i = ((this$.length - 1) | 0);
    var i$1 = i;
    var last = this$.charCodeAt(i$1);
    if ((!((last === 10) || (last === 13)))) {
      return this$;
    } else {
      if (((i > 0) && (((13 ^ this$.charCodeAt(((i - 1) | 0))) | (10 ^ last)) === 0))) {
        i = ((i - 1) | 0);
      }
      var endIndex = i;
      return this$.substring(0, endIndex);
    }
  }
});
$p.aym = (function(this$, prefix) {
  if ((!(!this$.startsWith(prefix)))) {
    var beginIndex = prefix.length;
    return this$.substring(beginIndex);
  } else {
    return this$;
  }
});
$p.ak1 = (function(this$, suffix) {
  if ((!(!this$.endsWith(suffix)))) {
    var endIndex = ((this$.length - suffix.length) | 0);
    return this$.substring(0, endIndex);
  } else {
    return this$;
  }
});
$p.ayl = (function(this$, marginChar) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$.length);
  var this$1 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$1.fy < this$1.yi)) {
    var x0 = this$1.aj0();
    var len = x0.length;
    var index = 0;
    while (((index < len) && (x0.charCodeAt(index) <= 32))) {
      index = ((1 + index) | 0);
    }
    if (((index < len) && (x0.charCodeAt(index) === marginChar))) {
      var beginIndex = ((1 + index) | 0);
      var stripped = x0.substring(beginIndex);
    } else {
      var stripped = x0;
    }
    sb.aC = (("" + sb.aC) + stripped);
  }
  return sb.aC;
});
$p.axA = (function(this$, ch) {
  return (((((((ch - 97) | 0) >>> 0) <= 25) || ((((ch - 65) | 0) >>> 0) <= 25)) || ((((ch - 48) | 0) >>> 0) <= 9)) ? ("" + $cToS(ch)) : ("\\" + $cToS(ch)));
});
$p.ajW = (function(this$, separator) {
  return $f_T__split__T__I__AT(this$, this.axA(this$, separator), 0);
});
$p.Va = (function(this$) {
  return $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), this$, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
});
$p.zW = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"");
  } else {
    _return: {
      var len = s.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(s, i);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
            var $x_1 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    } else {
      _return$1: {
        var len$1 = s.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(s, i$1);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_2 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_2 = true;
        } else {
          var $x_2 = false;
        }
      }
      if ((!$x_2)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""));
      }
      return false;
    }
  }
});
$p.axB = (function(this$, arg) {
  return ((arg instanceof $c_s_math_ScalaNumber) ? arg.akj() : arg);
});
$p.Ul = (function(this$, args) {
  return $m_jl_String$().au5(this$, $m_sr_Arrays$().axO(args.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arg$2) => this.axB(this$, arg$2)))), $d_O.l()));
});
$p.ahF = (function(this$) {
  if ((this$ === "")) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty String");
  } else {
    return this$.charCodeAt(0);
  }
});
$p.Eb = (function(this$) {
  return ((this$ === "") ? $m_s_None$() : new $c_s_Some($bC(this$.charCodeAt(0))));
});
$p.ak8 = (function(this$) {
  if ((this$ === "")) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty String");
  } else {
    return this.EB(this$, 1, this$.length);
  }
});
$p.VF = (function(this$, n) {
  var y = this$.length;
  return this.EB(this$, 0, ((n < y) ? n : y));
});
$p.ato = (function(this$, n) {
  var y = this$.length;
  return this.EB(this$, ((n < y) ? n : y), this$.length);
});
$p.agI = (function(this$, n) {
  return this.VF(this$, ((this$.length - ((n > 0) ? n : 0)) | 0));
});
var $d_sc_StringOps$ = new $TypeData().i($c_sc_StringOps$, "scala.collection.StringOps$", ({
  xa: 1
}));
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$();
  }
  return $n_sc_StringOps$;
}
function $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option($thiz, len$2, from$2, i, agg, isPositive) {
  var agg$tailLocal2 = agg;
  var i$tailLocal2 = i;
  while (true) {
    if ((i$tailLocal2 === len$2)) {
      return ((!isPositive) ? new $c_s_Some(agg$tailLocal2) : ((agg$tailLocal2 === (-2147483648)) ? $m_s_None$() : new $c_s_Some(((-agg$tailLocal2) | 0))));
    } else if ((agg$tailLocal2 < (-214748364))) {
      return $m_s_None$();
    } else {
      var digit = $m_jl_Character$().DZ(from$2.charCodeAt(i$tailLocal2), 10);
      if (((digit === (-1)) || ((((-214748364) ^ agg$tailLocal2) | (9 ^ digit)) === 0))) {
        return $m_s_None$();
      } else {
        var i$tailLocal2$tmp1 = ((1 + i$tailLocal2) | 0);
        var agg$tailLocal2$tmp1 = ((Math.imul(10, agg$tailLocal2) - digit) | 0);
        i$tailLocal2 = i$tailLocal2$tmp1;
        agg$tailLocal2 = agg$tailLocal2$tmp1;
      }
    }
  }
}
function $p_sc_StringParsers$__step$2__I__T__I__J__Z__s_Option($thiz, len$3, from$3, i, agg_$_lo, agg_$_hi, isPositive) {
  var agg$tailLocal3_$_lo = agg_$_lo;
  var agg$tailLocal3_$_hi = agg_$_hi;
  var i$tailLocal3 = i;
  while (true) {
    if ((i$tailLocal3 === len$3)) {
      if (isPositive) {
        var x_$_lo = agg$tailLocal3_$_lo;
        var x_$_hi = agg$tailLocal3_$_hi;
        var $x_1 = ((x_$_lo | ((-2147483648) ^ x_$_hi)) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $m_s_None$();
      } else if (isPositive) {
        var x$1_$_lo = agg$tailLocal3_$_lo;
        var x$1_$_hi = agg$tailLocal3_$_hi;
        var lo = ((-x$1_$_lo) | 0);
        var hi = ((((-x$1_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
        return new $c_s_Some($bL(lo, hi));
      } else {
        return new $c_s_Some($bL(agg$tailLocal3_$_lo, agg$tailLocal3_$_hi));
      }
    } else {
      var x$2_$_lo = agg$tailLocal3_$_lo;
      var x$2_$_hi = agg$tailLocal3_$_hi;
      if (((x$2_$_hi === (-214748365)) ? ((x$2_$_lo >>> 0) < 858993460) : (x$2_$_hi < (-214748365)))) {
        return $m_s_None$();
      } else {
        var digit = $m_jl_Character$().DZ(from$3.charCodeAt(i$tailLocal3), 10);
        if ((digit === (-1))) {
          var $x_2 = true;
        } else {
          var x$3_$_lo = agg$tailLocal3_$_lo;
          var x$3_$_hi = agg$tailLocal3_$_hi;
          if ((((858993460 ^ x$3_$_lo) | ((-214748365) ^ x$3_$_hi)) === 0)) {
            var $x_2 = (digit === 9);
          } else {
            var $x_2 = false;
          }
        }
        if ($x_2) {
          return $m_s_None$();
        } else {
          var i$tailLocal3$tmp1 = ((1 + i$tailLocal3) | 0);
          var x$4_$_lo = agg$tailLocal3_$_lo;
          var x$4_$_hi = agg$tailLocal3_$_hi;
          var b0 = (65535 & x$4_$_lo);
          var b1 = ((x$4_$_lo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$1 = ((Math.imul(10, x$4_$_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$2 = (digit >> 31);
          var lo$2 = ((lo$1 - digit) | 0);
          var hi$3 = ((((hi$1 - hi$2) | 0) - (((lo$2 >>> 0) > (lo$1 >>> 0)) | 0)) | 0);
          i$tailLocal3 = i$tailLocal3$tmp1;
          agg$tailLocal3_$_lo = lo$2;
          agg$tailLocal3_$_hi = hi$3;
        }
      }
    }
  }
}
function $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, ch) {
  return ((((((ch - 48) | 0) >>> 0) <= 9) || ((((ch - 97) | 0) >>> 0) <= 5)) || ((((ch - 65) | 0) >>> 0) <= 5));
}
function $p_sc_StringParsers$__prefixOK$1__T__I__I__Z($thiz, format$6, startIndex, endIndex) {
  var len = ((endIndex - startIndex) | 0);
  if ((len > 0)) {
    if ((format$6.charCodeAt(startIndex) === 46)) {
      if ((len > 1)) {
        var start = ((1 + startIndex) | 0);
        var i$tailLocal4 = start;
        while (true) {
          if ((i$tailLocal4 >= endIndex)) {
            return true;
          } else {
            if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal4))) {
              i$tailLocal4 = ((1 + i$tailLocal4) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      var noLeading;
      var i$tailLocal5 = startIndex;
      while (true) {
        if (((i$tailLocal5 < endIndex) && $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal5)))) {
          i$tailLocal5 = ((1 + i$tailLocal5) | 0);
          continue;
        }
        var noLeading = i$tailLocal5;
        break;
      }
      if ((noLeading >= endIndex)) {
        return true;
      } else if ((format$6.charCodeAt(noLeading) === 46)) {
        var start$1 = ((1 + noLeading) | 0);
        var i$tailLocal4$1 = start$1;
        while (true) {
          if ((i$tailLocal4$1 >= endIndex)) {
            return true;
          } else {
            if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, format$6.charCodeAt(i$tailLocal4$1))) {
              i$tailLocal4$1 = ((1 + i$tailLocal4$1) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__postfixOK$1__T__I__I__Z($thiz, format$7, startIndex, endIndex) {
  if ((startIndex < endIndex)) {
    var $x_1;
    var i$tailLocal4 = startIndex;
    while (true) {
      if ((i$tailLocal4 >= endIndex)) {
        var $x_1 = true;
        break;
      } else {
        if (((((format$7.charCodeAt(i$tailLocal4) - 48) | 0) >>> 0) <= 9)) {
          i$tailLocal4 = ((1 + i$tailLocal4) | 0);
          continue;
        }
        var $x_1 = false;
        break;
      }
    }
    if ($x_1) {
      return true;
    } else {
      var startchar = format$7.charCodeAt(startIndex);
      if ((((startchar === 43) || (startchar === 45)) && (((endIndex - startIndex) | 0) > 1))) {
        var start = ((1 + startIndex) | 0);
        var i$tailLocal4$1 = start;
        while (true) {
          if ((i$tailLocal4$1 >= endIndex)) {
            return true;
          } else {
            if (((((format$7.charCodeAt(i$tailLocal4$1) - 48) | 0) >>> 0) <= 9)) {
              i$tailLocal4$1 = ((1 + i$tailLocal4$1) | 0);
              continue;
            }
            return false;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z($thiz, format$5, startIndex, endIndex) {
  $m_sc_StringOps$();
  _return: {
    var len = format$5.length;
    var i = startIndex;
    while ((i < len)) {
      var index = i;
      var x0 = format$5.charCodeAt(index);
      if (((x0 === 80) || (x0 === 112))) {
        var pIndex = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var pIndex = (-1);
  }
  return (((pIndex <= endIndex) && $p_sc_StringParsers$__prefixOK$1__T__I__I__Z($thiz, format$5, startIndex, pIndex)) && $p_sc_StringParsers$__postfixOK$1__T__I__I__Z($thiz, format$5, ((1 + pIndex) | 0), endIndex));
}
function $p_sc_StringParsers$__isExp$1__C__Z($thiz, c) {
  return ((c === 69) || (c === 101));
}
function $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$9, startIndex, endIndex) {
  if ((startIndex < endIndex)) {
    var startChar = format$9.charCodeAt(startIndex);
    if (((startChar === 43) || (startChar === 45))) {
      if ((endIndex > ((1 + startIndex) | 0))) {
        var from = ((1 + startIndex) | 0);
        var $x_1;
        var i$tailLocal5 = from;
        while (true) {
          if (((i$tailLocal5 < endIndex) && ((((format$9.charCodeAt(i$tailLocal5) - 48) | 0) >>> 0) <= 9))) {
            i$tailLocal5 = ((1 + i$tailLocal5) | 0);
            continue;
          }
          var $x_1 = i$tailLocal5;
          break;
        }
        return ($x_1 === endIndex);
      } else {
        return false;
      }
    } else {
      var $x_2;
      var i$tailLocal5$1 = startIndex;
      while (true) {
        if (((i$tailLocal5$1 < endIndex) && ((((format$9.charCodeAt(i$tailLocal5$1) - 48) | 0) >>> 0) <= 9))) {
          i$tailLocal5$1 = ((1 + i$tailLocal5$1) | 0);
          continue;
        }
        var $x_2 = i$tailLocal5$1;
        break;
      }
      return ($x_2 === endIndex);
    }
  } else {
    return false;
  }
}
function $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z($thiz, format$8, startIndex, endIndex) {
  var startChar = format$8.charCodeAt(startIndex);
  if ((startChar === 46)) {
    var from = ((1 + startIndex) | 0);
    var noSignificant;
    var i$tailLocal5 = from;
    while (true) {
      if (((i$tailLocal5 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5) - 48) | 0) >>> 0) <= 9))) {
        i$tailLocal5 = ((1 + i$tailLocal5) | 0);
        continue;
      }
      var noSignificant = i$tailLocal5;
      break;
    }
    return ((noSignificant > ((1 + startIndex) | 0)) && ((noSignificant >= endIndex) || ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noSignificant)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noSignificant) | 0), endIndex))));
  } else if (((((startChar - 48) | 0) >>> 0) <= 9)) {
    var noInt;
    var i$tailLocal5$1 = startIndex;
    while (true) {
      if (((i$tailLocal5$1 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5$1) - 48) | 0) >>> 0) <= 9))) {
        i$tailLocal5$1 = ((1 + i$tailLocal5$1) | 0);
        continue;
      }
      var noInt = i$tailLocal5$1;
      break;
    }
    if ((noInt === endIndex)) {
      return true;
    } else if ((format$8.charCodeAt(noInt) === 46)) {
      var from$1 = ((1 + noInt) | 0);
      var noSignificant$2;
      var i$tailLocal5$2 = from$1;
      while (true) {
        if (((i$tailLocal5$2 < endIndex) && ((((format$8.charCodeAt(i$tailLocal5$2) - 48) | 0) >>> 0) <= 9))) {
          i$tailLocal5$2 = ((1 + i$tailLocal5$2) | 0);
          continue;
        }
        var noSignificant$2 = i$tailLocal5$2;
        break;
      }
      return ((noSignificant$2 >= endIndex) || ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noSignificant$2)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noSignificant$2) | 0), endIndex)));
    } else {
      return ($p_sc_StringParsers$__isExp$1__C__Z($thiz, format$8.charCodeAt(noInt)) && $p_sc_StringParsers$__expOK$1__T__I__I__Z($thiz, format$8, ((1 + noInt) | 0), endIndex));
    }
  } else {
    return false;
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
}
$p = $c_sc_StringParsers$.prototype = new $h_O();
$p.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
$h_sc_StringParsers$.prototype = $p;
$p.fs = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var v = $m_jl_Character$().DZ(first, 10);
    return ((len === 1) ? ((v > (-1)) ? new $c_s_Some(v) : $m_s_None$()) : ((v > (-1)) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, ((-v) | 0), true) : ((first === 43) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, 0, true) : ((first === 45) ? $p_sc_StringParsers$__step$1__I__T__I__I__Z__s_Option(this, len, from, 1, 0, false) : $m_s_None$()))));
  }
});
$p.Er = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var value = $m_jl_Character$().DZ(first, 10);
    var hi = (value >> 31);
    if ((len === 1)) {
      return ((hi > (-1)) ? new $c_s_Some($bL(value, hi)) : $m_s_None$());
    } else if ((hi > (-1))) {
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
      return $p_sc_StringParsers$__step$2__I__T__I__J__Z__s_Option(this, len, from, 1, lo, hi$1, true);
    } else {
      return ((first === 43) ? $p_sc_StringParsers$__step$2__I__T__I__J__Z__s_Option(this, len, from, 1, 0, 0, true) : ((first === 45) ? $p_sc_StringParsers$__step$2__I__T__I__J__Z__s_Option(this, len, from, 1, 0, 0, false) : $m_s_None$()));
    }
  }
});
$p.afR = (function(format) {
  $m_sc_StringOps$();
  $m_sc_StringOps$();
  var from = 0;
  _return: {
    var len = format.length;
    var i = from;
    while ((i < len)) {
      if ((format.charCodeAt(i) > 32)) {
        var unspacedStart = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var unspacedStart = (-1);
  }
  $m_sc_StringOps$();
  $m_sc_StringOps$();
  var end = 2147483647;
  _return$1: {
    var len$1 = format.length;
    var y = ((len$1 - 1) | 0);
    var i$1 = ((end < y) ? end : y);
    while ((i$1 >= 0)) {
      if ((format.charCodeAt(i$1) > 32)) {
        var $x_1 = i$1;
        break _return$1;
      }
      i$1 = ((i$1 - 1) | 0);
    }
    var $x_1 = (-1);
  }
  var unspacedEnd = ((1 + $x_1) | 0);
  if ((!(((unspacedStart === (-1)) || (unspacedStart >= unspacedEnd)) || (unspacedEnd <= 0)))) {
    var startchar = format.charCodeAt(unspacedStart);
    var unsigned = (((startchar === 43) || (startchar === 45)) ? ((1 + unspacedStart) | 0) : unspacedStart);
    if ((unsigned < unspacedEnd)) {
      if ((format.charCodeAt(unsigned) === 78)) {
        return (format.substring(unsigned, unspacedEnd) === "NaN");
      } else if ((format.charCodeAt(unsigned) === 73)) {
        return (format.substring(unsigned, unspacedEnd) === "Infinity");
      } else {
        var index$2 = ((unspacedEnd - 1) | 0);
        var endchar = format.charCodeAt(index$2);
        var desuffixed = (((((endchar === 70) || (endchar === 102)) || (endchar === 100)) || (endchar === 68)) ? ((unspacedEnd - 1) | 0) : unspacedEnd);
        var len$2 = ((desuffixed - unsigned) | 0);
        return ((len$2 > 0) && (((len$2 >= 2) && ((format.charCodeAt(((1 + unsigned) | 0)) === 120) || (format.charCodeAt(((1 + unsigned) | 0)) === 88))) ? ((format.charCodeAt(unsigned) === 48) && $p_sc_StringParsers$__isHexFloatLiteral$1__T__I__I__Z(this, format, ((2 + unsigned) | 0), desuffixed)) : $p_sc_StringParsers$__isDecFloatLiteral$1__T__I__I__Z(this, format, unsigned, desuffixed)));
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_sc_StringParsers$ = new $TypeData().i($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  xc: 1
}));
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
/** @constructor */
function $c_scg_CommonErrors$() {
}
$p = $c_scg_CommonErrors$.prototype = new $h_O();
$p.constructor = $c_scg_CommonErrors$;
/** @constructor */
function $h_scg_CommonErrors$() {
}
$h_scg_CommonErrors$.prototype = $p;
$p.kM = (function(index, max) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + max) + ")"));
});
$p.auQ = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (min 0, max unknown)"));
});
var $d_scg_CommonErrors$ = new $TypeData().i($c_scg_CommonErrors$, "scala.collection.generic.CommonErrors$", ({
  xr: 1
}));
var $n_scg_CommonErrors$;
function $m_scg_CommonErrors$() {
  if ((!$n_scg_CommonErrors$)) {
    $n_scg_CommonErrors$ = new $c_scg_CommonErrors$();
  }
  return $n_scg_CommonErrors$;
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.aaX = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  try {
    $m_sc_StringOps$();
    var $x_1 = $m_jl_Integer$().c7($m_jl_System$SystemProperties$().Uv("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64"), 10, 214748364);
  } catch (e) {
    if (false) {
      var $x_1 = 64;
    } else {
      var $x_1;
      throw e;
    }
  }
  this.aaX = $x_1;
}
$p = $c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$p.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
}
$h_sci_IndexedSeqDefaults$.prototype = $p;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().i($c_sci_IndexedSeqDefaults$, "scala.collection.immutable.IndexedSeqDefaults$", ({
  xE: 1
}));
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$();
  }
  return $n_sci_IndexedSeqDefaults$;
}
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
}
$p = $c_sci_LazyList$Deferrer$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
}
$h_sci_LazyList$Deferrer$.prototype = $p;
$p.alJ = (function(this$, elem) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem.aA(), ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), this$)));
  })));
});
var $d_sci_LazyList$Deferrer$ = new $TypeData().i($c_sci_LazyList$Deferrer$, "scala.collection.immutable.LazyList$Deferrer$", ({
  xH: 1
}));
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$();
  }
  return $n_sci_LazyList$Deferrer$;
}
/** @constructor */
function $c_sci_LazyList$EmptyMarker$() {
}
$p = $c_sci_LazyList$EmptyMarker$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$EmptyMarker$;
/** @constructor */
function $h_sci_LazyList$EmptyMarker$() {
}
$h_sci_LazyList$EmptyMarker$.prototype = $p;
var $d_sci_LazyList$EmptyMarker$ = new $TypeData().i($c_sci_LazyList$EmptyMarker$, "scala.collection.immutable.LazyList$EmptyMarker$", ({
  xI: 1
}));
var $n_sci_LazyList$EmptyMarker$;
function $m_sci_LazyList$EmptyMarker$() {
  if ((!$n_sci_LazyList$EmptyMarker$)) {
    $n_sci_LazyList$EmptyMarker$ = new $c_sci_LazyList$EmptyMarker$();
  }
  return $n_sci_LazyList$EmptyMarker$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.RQ = null;
}
$p = $c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $p;
$p.Ub = (function() {
  var state = this.RQ;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized");
  }
  return state.aA();
});
$p.UH = (function(state) {
  if ((this.RQ !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized");
  }
  this.RQ = state;
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().i($c_sci_LazyList$LazyBuilder$DeferredState, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", ({
  xK: 1
}));
/** @constructor */
function $c_sci_LazyList$MidEvaluation$() {
}
$p = $c_sci_LazyList$MidEvaluation$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$MidEvaluation$;
/** @constructor */
function $h_sci_LazyList$MidEvaluation$() {
}
$h_sci_LazyList$MidEvaluation$.prototype = $p;
var $d_sci_LazyList$MidEvaluation$ = new $TypeData().i($c_sci_LazyList$MidEvaluation$, "scala.collection.immutable.LazyList$MidEvaluation$", ({
  xM: 1
}));
var $n_sci_LazyList$MidEvaluation$;
function $m_sci_LazyList$MidEvaluation$() {
  if ((!$n_sci_LazyList$MidEvaluation$)) {
    $n_sci_LazyList$MidEvaluation$ = new $c_sci_LazyList$MidEvaluation$();
  }
  return $n_sci_LazyList$MidEvaluation$;
}
/** @constructor */
function $c_sci_MapNode$() {
  this.CY = null;
  $n_sci_MapNode$ = this;
  $m_s_reflect_ManifestFactory$IntManifest$();
  this.CY = new $c_sci_BitmapIndexedMapNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$p = $c_sci_MapNode$.prototype = new $h_O();
$p.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
}
$h_sci_MapNode$.prototype = $p;
var $d_sci_MapNode$ = new $TypeData().i($c_sci_MapNode$, "scala.collection.immutable.MapNode$", ({
  ya: 1
}));
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$();
  }
  return $n_sci_MapNode$;
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (($m_jl_reflect_Array$().b1(as) - 1) | 0)));
}
/** @constructor */
function $c_sci_Node() {
}
$p = $c_sci_Node.prototype = new $h_O();
$p.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
}
$h_sci_Node.prototype = $p;
$p.Nj = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > ((as.a.length - 1) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I(((as.a.length - 1) | 0));
  as.av(0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = ((((as.a.length - ix) | 0) - 1) | 0);
  as.av(srcPos, result, ix, length);
  return result;
});
$p.UJ = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > as.a.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
});
var $d_sci_Node = new $TypeData().i(0, "scala.collection.immutable.Node", ({
  bv: 1
}));
/** @constructor */
function $c_sci_Node$() {
  this.H6 = 0;
  $n_sci_Node$ = this;
  this.H6 = $doubleToInt((+Math.ceil(6.4)));
}
$p = $c_sci_Node$.prototype = new $h_O();
$p.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
}
$h_sci_Node$.prototype = $p;
$p.fp = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0));
});
$p.cS = (function(mask) {
  return (1 << mask);
});
$p.qI = (function(bitmap, bitpos) {
  return $m_jl_Integer$().cI((bitmap & ((bitpos - 1) | 0)));
});
$p.fn = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.qI(bitmap, bitpos));
});
var $d_sci_Node$ = new $TypeData().i($c_sci_Node$, "scala.collection.immutable.Node$", ({
  ye: 1
}));
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$();
  }
  return $n_sci_Node$;
}
/** @constructor */
function $c_sci_SetNode$() {
  this.D1 = null;
  $n_sci_SetNode$ = this;
  $m_s_reflect_ManifestFactory$IntManifest$();
  this.D1 = new $c_sci_BitmapIndexedSetNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$p = $c_sci_SetNode$.prototype = new $h_O();
$p.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
}
$h_sci_SetNode$.prototype = $p;
var $d_sci_SetNode$ = new $TypeData().i($c_sci_SetNode$, "scala.collection.immutable.SetNode$", ({
  yw: 1
}));
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$();
  }
  return $n_sci_SetNode$;
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  var hi$tailLocal1 = hi;
  var lo$tailLocal1 = lo;
  var a$tailLocal1 = a;
  var n$tailLocal1 = n;
  while (true) {
    if ((n$tailLocal1 === 1)) {
      var a$1 = a$tailLocal1;
      var start = lo$tailLocal1;
      var end = hi$tailLocal1;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start | (end ^ a$1.a.length)) === 0) ? a$1 : $m_ju_Arrays$().bO(a$1, start, end)));
      return (void 0);
    } else {
      var bitsN = Math.imul(5, ((n$tailLocal1 - 1) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo$tailLocal1 >>> bitsN) | 0);
      var hiN = ((hi$tailLocal1 >>> bitsN) | 0);
      var loRest = (lo$tailLocal1 & ((widthN - 1) | 0));
      var hiRest = (hi$tailLocal1 & ((widthN - 1) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $x_1 = n$tailLocal1;
          var a$2 = a$tailLocal1;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_1, (((loN | (hiN ^ a$2.a.length)) === 0) ? a$2 : $m_ju_Arrays$().bO(a$2, loN, hiN)));
          return (void 0);
        } else {
          if ((hiN > loN)) {
            var $x_2 = n$tailLocal1;
            var a$3 = a$tailLocal1;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_2, (((loN | (hiN ^ a$3.a.length)) === 0) ? a$3 : $m_ju_Arrays$().bO(a$3, loN, hiN)));
          }
          var n$tailLocal1$tmp1 = ((n$tailLocal1 - 1) | 0);
          var a$tailLocal1$tmp1 = a$tailLocal1.a[hiN];
          n$tailLocal1 = n$tailLocal1$tmp1;
          a$tailLocal1 = a$tailLocal1$tmp1;
          lo$tailLocal1 = 0;
          hi$tailLocal1 = hiRest;
        }
      } else if ((hiN === loN)) {
        var n$tailLocal1$tmp2 = ((n$tailLocal1 - 1) | 0);
        var a$tailLocal1$tmp2 = a$tailLocal1.a[loN];
        n$tailLocal1 = n$tailLocal1$tmp2;
        a$tailLocal1 = a$tailLocal1$tmp2;
        lo$tailLocal1 = loRest;
        hi$tailLocal1 = hiRest;
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, ((n$tailLocal1 - 1) | 0), a$tailLocal1.a[loN], loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_3 = n$tailLocal1;
            var a$4 = a$tailLocal1;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_3, (((start$1 | (hiN ^ a$4.a.length)) === 0) ? a$4 : $m_ju_Arrays$().bO(a$4, start$1, hiN)));
            return (void 0);
          } else {
            return (void 0);
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_4 = n$tailLocal1;
            var a$5 = a$tailLocal1;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_4, (((start$2 | (hiN ^ a$5.a.length)) === 0) ? a$5 : $m_ju_Arrays$().bO(a$5, start$2, hiN)));
          }
          var n$tailLocal1$tmp3 = ((n$tailLocal1 - 1) | 0);
          var a$tailLocal1$tmp3 = a$tailLocal1.a[hiN];
          n$tailLocal1 = n$tailLocal1$tmp3;
          a$tailLocal1 = a$tailLocal1$tmp3;
          lo$tailLocal1 = 0;
          hi$tailLocal1 = hiRest;
        }
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.hB)) {
    var idx = ((11 - n) | 0);
  } else {
    $thiz.hB = n;
    var idx = ((n - 1) | 0);
  }
  $thiz.b2.a[idx] = a;
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.b2.a[((n - 1) | 0)] === null)) {
    if ((n === $thiz.hB)) {
      $thiz.b2.a[((n - 1) | 0)] = $thiz.b2.a[((11 - n) | 0)];
      $thiz.b2.a[((11 - n) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var preN1 = $thiz.b2.a[((((1 + n) | 0) - 1) | 0)];
      $thiz.b2.a[((n - 1) | 0)] = preN1.a[0];
      if ((preN1.a.length === 1)) {
        $thiz.b2.a[((((1 + n) | 0) - 1) | 0)] = null;
        if ((($thiz.hB === ((1 + n) | 0)) && ($thiz.b2.a[((11 - ((1 + n) | 0)) | 0)] === null))) {
          $thiz.hB = n;
        }
      } else {
        $thiz.b2.a[((((1 + n) | 0) - 1) | 0)] = $m_ju_Arrays$().bO(preN1, 1, preN1.a.length);
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.b2.a[((11 - n) | 0)] === null)) {
    if ((n === $thiz.hB)) {
      $thiz.b2.a[((11 - n) | 0)] = $thiz.b2.a[((n - 1) | 0)];
      $thiz.b2.a[((n - 1) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var sufN1 = $thiz.b2.a[((11 - ((1 + n) | 0)) | 0)];
      $thiz.b2.a[((11 - n) | 0)] = sufN1.a[((sufN1.a.length - 1) | 0)];
      if ((sufN1.a.length === 1)) {
        $thiz.b2.a[((11 - ((1 + n) | 0)) | 0)] = null;
        if ((($thiz.hB === ((1 + n) | 0)) && ($thiz.b2.a[((((1 + n) | 0) - 1) | 0)] === null))) {
          $thiz.hB = n;
        }
      } else {
        $thiz.b2.a[((11 - ((1 + n) | 0)) | 0)] = $m_ju_Arrays$().bO(sufN1, 0, ((sufN1.a.length - 1) | 0));
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.RX = 0;
  this.RW = 0;
  this.b2 = null;
  this.mo = 0;
  this.D2 = 0;
  this.hB = 0;
  this.RX = lo;
  this.RW = hi;
  this.b2 = new ($d_O.r().r().C)(11);
  this.mo = 0;
  this.D2 = 0;
  this.hB = 0;
}
$p = $c_sci_VectorSliceBuilder.prototype = new $h_O();
$p.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
}
$h_sci_VectorSliceBuilder.prototype = $p;
$p.cA = (function(n, a) {
  var count = Math.imul(a.a.length, (1 << Math.imul(5, ((n - 1) | 0))));
  var a$1 = ((this.RX - this.D2) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.RW - this.D2) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.mo = ((this.mo + ((hi0 - lo0) | 0)) | 0);
  }
  this.D2 = ((this.D2 + count) | 0);
});
$p.ix = (function() {
  if ((this.mo <= 32)) {
    if ((this.mo === 0)) {
      return $m_sci_Vector0$();
    } else {
      var prefix1 = this.b2.a[0];
      var suffix1 = this.b2.a[10];
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var dest = $m_ju_Arrays$().cn(prefix1, ((prefix1.a.length + suffix1.a.length) | 0));
          var destPos = prefix1.a.length;
          var length = suffix1.a.length;
          suffix1.av(0, dest, destPos, length);
          var $x_1 = dest;
        } else {
          var $x_1 = prefix1;
        }
      } else if ((suffix1 !== null)) {
        var $x_1 = suffix1;
      } else {
        var prefix2 = this.b2.a[1];
        var $x_1 = ((prefix2 !== null) ? prefix2.a[0] : this.b2.a[9].a[0]);
      }
      return new $c_sci_Vector1($x_1);
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.hB;
    if ((resultDim < 6)) {
      var pre = this.b2.a[((this.hB - 1) | 0)];
      var suf = this.b2.a[((11 - this.hB) | 0)];
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.a.length + suf.a.length) | 0) <= 30)) {
          var $x_3 = this.b2;
          var $x_2 = this.hB;
          var dest$1 = $m_ju_Arrays$().cn(pre, ((pre.a.length + suf.a.length) | 0));
          var destPos$1 = pre.a.length;
          var length$1 = suf.a.length;
          suf.av(0, dest$1, destPos$1, length$1);
          $x_3.a[(($x_2 - 1) | 0)] = dest$1;
          this.b2.a[((11 - this.hB) | 0)] = null;
        } else {
          resultDim = ((1 + resultDim) | 0);
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if ((one === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        if ((one.a.length > 30)) {
          resultDim = ((1 + resultDim) | 0);
        }
      }
    }
    var x$proxy1 = this.b2.a[0];
    if ((x$proxy1 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var x$proxy2 = this.b2.a[10];
    if ((x$proxy2 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var len1 = x$proxy1.a.length;
    var x27 = resultDim;
    switch (x27) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().c3;
        var p = this.b2.a[1];
        if ((p !== null)) {
          var $x_4 = p;
        } else {
          var s = this.b2.a[9];
          var $x_4 = ((s !== null) ? s : a$1);
        }
        return new $c_sci_Vector2(x$proxy1, len1, $x_4, x$proxy2, this.mo);
        break;
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().c3;
        var p$1 = this.b2.a[1];
        var prefix2$2 = ((p$1 !== null) ? p$1 : a$2);
        var a$3 = $m_sci_VectorStatics$().e0;
        var p$2 = this.b2.a[2];
        if ((p$2 !== null)) {
          var $x_5 = p$2;
        } else {
          var s$1 = this.b2.a[8];
          var $x_5 = ((s$1 !== null) ? s$1 : a$3);
        }
        var a$4 = $m_sci_VectorStatics$().c3;
        var s$2 = this.b2.a[9];
        return new $c_sci_Vector3(x$proxy1, len1, prefix2$2, ((len1 + (prefix2$2.a.length << 5)) | 0), $x_5, ((s$2 !== null) ? s$2 : a$4), x$proxy2, this.mo);
        break;
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().c3;
        var p$3 = this.b2.a[1];
        var prefix2$3 = ((p$3 !== null) ? p$3 : a$5);
        var a$6 = $m_sci_VectorStatics$().e0;
        var p$4 = this.b2.a[2];
        var prefix3 = ((p$4 !== null) ? p$4 : a$6);
        var a$7 = $m_sci_VectorStatics$().h4;
        var p$5 = this.b2.a[3];
        if ((p$5 !== null)) {
          var $x_6 = p$5;
        } else {
          var s$3 = this.b2.a[7];
          var $x_6 = ((s$3 !== null) ? s$3 : a$7);
        }
        var data4 = $x_6;
        var a$8 = $m_sci_VectorStatics$().e0;
        var s$4 = this.b2.a[8];
        var suffix3 = ((s$4 !== null) ? s$4 : a$8);
        var a$9 = $m_sci_VectorStatics$().c3;
        var s$5 = this.b2.a[9];
        var suffix2$3 = ((s$5 !== null) ? s$5 : a$9);
        var len12$2 = ((len1 + (prefix2$3.a.length << 5)) | 0);
        return new $c_sci_Vector4(x$proxy1, len1, prefix2$3, len12$2, prefix3, ((len12$2 + (prefix3.a.length << 10)) | 0), data4, suffix3, suffix2$3, x$proxy2, this.mo);
        break;
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().c3;
        var p$6 = this.b2.a[1];
        var prefix2$4 = ((p$6 !== null) ? p$6 : a$10);
        var a$11 = $m_sci_VectorStatics$().e0;
        var p$7 = this.b2.a[2];
        var prefix3$2 = ((p$7 !== null) ? p$7 : a$11);
        var a$12 = $m_sci_VectorStatics$().h4;
        var p$8 = this.b2.a[3];
        var prefix4 = ((p$8 !== null) ? p$8 : a$12);
        var a$13 = $m_sci_VectorStatics$().tB;
        var p$9 = this.b2.a[4];
        if ((p$9 !== null)) {
          var $x_7 = p$9;
        } else {
          var s$6 = this.b2.a[6];
          var $x_7 = ((s$6 !== null) ? s$6 : a$13);
        }
        var data5 = $x_7;
        var a$14 = $m_sci_VectorStatics$().h4;
        var s$7 = this.b2.a[7];
        var suffix4 = ((s$7 !== null) ? s$7 : a$14);
        var a$15 = $m_sci_VectorStatics$().e0;
        var s$8 = this.b2.a[8];
        var suffix3$2 = ((s$8 !== null) ? s$8 : a$15);
        var a$16 = $m_sci_VectorStatics$().c3;
        var s$9 = this.b2.a[9];
        var suffix2$4 = ((s$9 !== null) ? s$9 : a$16);
        var len12$3 = ((len1 + (prefix2$4.a.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.a.length << 10)) | 0);
        return new $c_sci_Vector5(x$proxy1, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, ((len123$2 + (prefix4.a.length << 15)) | 0), data5, suffix4, suffix3$2, suffix2$4, x$proxy2, this.mo);
        break;
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().c3;
        var p$10 = this.b2.a[1];
        var prefix2$5 = ((p$10 !== null) ? p$10 : a$17);
        var a$18 = $m_sci_VectorStatics$().e0;
        var p$11 = this.b2.a[2];
        var prefix3$3 = ((p$11 !== null) ? p$11 : a$18);
        var a$19 = $m_sci_VectorStatics$().h4;
        var p$12 = this.b2.a[3];
        var prefix4$2 = ((p$12 !== null) ? p$12 : a$19);
        var a$20 = $m_sci_VectorStatics$().tB;
        var p$13 = this.b2.a[4];
        var prefix5 = ((p$13 !== null) ? p$13 : a$20);
        var a$21 = $m_sci_VectorStatics$().Lx;
        var p$14 = this.b2.a[5];
        if ((p$14 !== null)) {
          var $x_8 = p$14;
        } else {
          var s$10 = this.b2.a[5];
          var $x_8 = ((s$10 !== null) ? s$10 : a$21);
        }
        var data6 = $x_8;
        var a$22 = $m_sci_VectorStatics$().tB;
        var s$11 = this.b2.a[6];
        var suffix5 = ((s$11 !== null) ? s$11 : a$22);
        var a$23 = $m_sci_VectorStatics$().h4;
        var s$12 = this.b2.a[7];
        var suffix4$2 = ((s$12 !== null) ? s$12 : a$23);
        var a$24 = $m_sci_VectorStatics$().e0;
        var s$13 = this.b2.a[8];
        var suffix3$3 = ((s$13 !== null) ? s$13 : a$24);
        var a$25 = $m_sci_VectorStatics$().c3;
        var s$14 = this.b2.a[9];
        var suffix2$5 = ((s$14 !== null) ? s$14 : a$25);
        var len12$4 = ((len1 + (prefix2$5.a.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.a.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.a.length << 15)) | 0);
        return new $c_sci_Vector6(x$proxy1, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, ((len1234$2 + (prefix5.a.length << 20)) | 0), data6, suffix5, suffix4$2, suffix3$3, suffix2$5, x$proxy2, this.mo);
        break;
      }
      default: {
        throw new $c_s_MatchError(x27);
      }
    }
  }
});
$p.g = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.RX) + ", hi=") + this.RW) + ", len=") + this.mo) + ", pos=") + this.D2) + ", maxDim=") + this.hB) + ")");
});
var $d_sci_VectorSliceBuilder = new $TypeData().i($c_sci_VectorSliceBuilder, "scala.collection.immutable.VectorSliceBuilder", ({
  yE: 1
}));
/** @constructor */
function $c_sci_VectorStatics$() {
  this.RY = null;
  this.c3 = null;
  this.e0 = null;
  this.h4 = null;
  this.tB = null;
  this.Lx = null;
  $n_sci_VectorStatics$ = this;
  this.RY = new $ac_O(0);
  this.c3 = new ($d_O.r().r().C)(0);
  this.e0 = new ($d_O.r().r().r().C)(0);
  this.h4 = new ($d_O.r().r().r().r().C)(0);
  this.tB = new ($d_O.r().r().r().r().r().C)(0);
  this.Lx = new ($d_O.r().r().r().r().r().r().C)(0);
}
$p = $c_sci_VectorStatics$.prototype = new $h_O();
$p.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
}
$h_sci_VectorStatics$.prototype = $p;
$p.DX = (function(a, elem) {
  var alen = a.a.length;
  var ac = new $ac_O(((1 + alen) | 0));
  a.av(0, ac, 0, alen);
  ac.a[alen] = elem;
  return ac;
});
$p.bN = (function(a, elem) {
  var ac = $m_ju_Arrays$().cn(a, ((1 + a.a.length) | 0));
  ac.a[((ac.a.length - 1) | 0)] = elem;
  return ac;
});
$p.DY = (function(elem, a) {
  var ac = new $ac_O(((1 + a.a.length) | 0));
  var length = a.a.length;
  a.av(0, ac, 1, length);
  ac.a[0] = elem;
  return ac;
});
$p.bi = (function(elem, a) {
  var ac = $objectGetClass(a).ax.Q().ax.U(((1 + a.a.length) | 0));
  var length$1 = a.a.length;
  a.av(0, ac, 1, length$1);
  ac.a[0] = elem;
  return ac;
});
$p.ME = (function(level, a, f) {
  var i = 0;
  var len = a.a.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.p(a.a[i]);
      i = ((1 + i) | 0);
    }
  } else {
    var l = ((level - 1) | 0);
    while ((i < len)) {
      this.ME(l, a.a[i], f);
      i = ((1 + i) | 0);
    }
  }
});
$p.kO = (function(a, f) {
  var i = 0;
  while ((i < a.a.length)) {
    var v1 = a.a[i];
    var v2 = f.p(v1);
    if ((!Object.is(v1, v2))) {
      return this.awa(a, f, i, v2);
    }
    i = ((1 + i) | 0);
  }
  return a;
});
$p.awa = (function(a, f, at, v2) {
  var ac = new $ac_O(a.a.length);
  if ((at > 0)) {
    a.av(0, ac, 0, at);
  }
  ac.a[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.a.length)) {
    ac.a[i] = f.p(a.a[i]);
    i = ((1 + i) | 0);
  }
  return ac;
});
$p.dU = (function(n, a, f) {
  if ((n === 1)) {
    return this.kO(a, f);
  } else {
    var i = 0;
    while ((i < a.a.length)) {
      var v1 = a.a[i];
      var v2 = this.dU(((n - 1) | 0), v1, f);
      if ((v1 !== v2)) {
        return this.awb(n, a, f, i, v2);
      }
      i = ((1 + i) | 0);
    }
    return a;
  }
});
$p.awb = (function(n, a, f, at, v2) {
  var ac = $objectGetClass(a).ax.Q().ax.U(a.a.length);
  if ((at > 0)) {
    a.av(0, ac, 0, at);
  }
  ac.a[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.a.length)) {
    ac.a[i] = this.dU(((n - 1) | 0), a.a[i], f);
    i = ((1 + i) | 0);
  }
  return ac;
});
$p.Et = (function(prefix1, xs) {
  if ($is_sci_Iterable(xs)) {
    if ((xs.Ns(((32 - prefix1.a.length) | 0)) <= 0)) {
      var x40 = xs.aH();
      if ((x40 === 0)) {
        return null;
      }
      if ((x40 === 1)) {
        return this.bi(xs.W(), prefix1);
      }
      var prefix1b = new $ac_O(((prefix1.a.length + x40) | 0));
      var length = prefix1.a.length;
      prefix1.av(0, prefix1b, x40, length);
      xs.d0(prefix1b, 0, 2147483647);
      return prefix1b;
    } else {
      return null;
    }
  } else {
    var s$2 = xs.G();
    if (((s$2 > 0) && (s$2 <= ((32 - prefix1.a.length) | 0)))) {
      var prefix1b$2 = new $ac_O(((prefix1.a.length + s$2) | 0));
      var length$1 = prefix1.a.length;
      prefix1.av(0, prefix1b$2, s$2, length$1);
      xs.l().d0(prefix1b$2, 0, 2147483647);
      return prefix1b$2;
    } else {
      return null;
    }
  }
});
$p.DN = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    if ((xs.Ns(((32 - suffix1.a.length) | 0)) <= 0)) {
      var x43 = xs.aH();
      if ((x43 === 0)) {
        return null;
      }
      if ((x43 === 1)) {
        return this.bN(suffix1, xs.W());
      }
      var suffix1b = $m_ju_Arrays$().cn(suffix1, ((suffix1.a.length + x43) | 0));
      xs.d0(suffix1b, suffix1.a.length, 2147483647);
      return suffix1b;
    } else {
      return null;
    }
  } else {
    var s$2 = xs.G();
    if (((s$2 > 0) && (s$2 <= ((32 - suffix1.a.length) | 0)))) {
      var suffix1b$2 = $m_ju_Arrays$().cn(suffix1, ((suffix1.a.length + s$2) | 0));
      xs.l().d0(suffix1b$2, suffix1.a.length, 2147483647);
      return suffix1b$2;
    } else {
      return null;
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().i($c_sci_VectorStatics$, "scala.collection.immutable.VectorStatics$", ({
  yF: 1
}));
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$();
  }
  return $n_sci_VectorStatics$;
}
/** @constructor */
function $c_scm_ArrayBuilder$() {
}
$p = $c_scm_ArrayBuilder$.prototype = new $h_O();
$p.constructor = $c_scm_ArrayBuilder$;
/** @constructor */
function $h_scm_ArrayBuilder$() {
}
$h_scm_ArrayBuilder$.prototype = $p;
$p.u = (function(runtimeClass) {
  return ((runtimeClass === $d_B.l()) ? 0 : ((runtimeClass === $d_S.l()) ? 0 : ((runtimeClass === $d_C.l()) ? 0 : ((runtimeClass === $d_I.l()) ? 0 : ((runtimeClass === $d_J.l()) ? $bL(0, 0) : ((runtimeClass === $d_F.l()) ? 0.0 : ((runtimeClass === $d_D.l()) ? 0.0 : ((runtimeClass === $d_Z.l()) ? false : ((runtimeClass === $d_V.l()) ? (void 0) : null)))))))));
});
$p.v = (function(runtimeClass, a) {
  var len = (a.length | 0);
  if ((runtimeClass === $d_C.l())) {
    var result = new $ac_C(len);
    var i = 0;
    while ((i !== len)) {
      result.a[i] = (65535 & (a[i] | 0));
      i = ((1 + i) | 0);
    }
    return result;
  } else {
    var result$2 = runtimeClass.ax.U(len);
    var i$2 = 0;
    while ((i$2 !== len)) {
      $m_sr_ScalaRunTime$().bQ(result$2, i$2, a[i$2]);
      i$2 = ((1 + i$2) | 0);
    }
    return result$2;
  }
});
var $d_scm_ArrayBuilder$ = new $TypeData().i($c_scm_ArrayBuilder$, "scala.collection.mutable.ArrayBuilder$", ({
  yM: 1
}));
var $n_scm_ArrayBuilder$;
function $m_scm_ArrayBuilder$() {
  if ((!$n_scm_ArrayBuilder$)) {
    $n_scm_ArrayBuilder$ = new $c_scm_ArrayBuilder$();
  }
  return $n_scm_ArrayBuilder$;
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.ku = null;
  this.jb = 0;
  this.h6 = null;
  this.dE = null;
  this.ku = _key;
  this.jb = _hash;
  this.h6 = _value;
  this.dE = _next;
}
$p = $c_scm_HashMap$Node.prototype = new $h_O();
$p.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
}
$h_scm_HashMap$Node.prototype = $p;
$p.IA = (function(k, h) {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    if (((h === \u03b4this$tailLocal1.jb) && $m_sr_BoxesRunTime$().B(k, \u03b4this$tailLocal1.ku))) {
      return \u03b4this$tailLocal1;
    } else if (((\u03b4this$tailLocal1.dE === null) || (\u03b4this$tailLocal1.jb > h))) {
      return null;
    } else {
      \u03b4this$tailLocal1 = \u03b4this$tailLocal1.dE;
    }
  }
});
$p.al = (function(f) {
  var \u03b4this$tailLocal2 = this;
  while (true) {
    f.p(new $c_T2(\u03b4this$tailLocal2.ku, \u03b4this$tailLocal2.h6));
    if ((\u03b4this$tailLocal2.dE !== null)) {
      \u03b4this$tailLocal2 = \u03b4this$tailLocal2.dE;
    } else {
      return (void 0);
    }
  }
});
$p.jo = (function(f) {
  var \u03b4this$tailLocal3 = this;
  while (true) {
    f.cm(\u03b4this$tailLocal3.ku, \u03b4this$tailLocal3.h6);
    if ((\u03b4this$tailLocal3.dE !== null)) {
      \u03b4this$tailLocal3 = \u03b4this$tailLocal3.dE;
    } else {
      return (void 0);
    }
  }
});
$p.g = (function() {
  return ((((((("Node(" + this.ku) + ", ") + this.h6) + ", ") + this.jb) + ") -> ") + this.dE);
});
var $d_scm_HashMap$Node = new $TypeData().i($c_scm_HashMap$Node, "scala.collection.mutable.HashMap$Node", ({
  z8: 1
}));
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.qn = null;
  this.mq = 0;
  this.f3 = null;
  this.qn = _key;
  this.mq = _hash;
  this.f3 = _next;
}
$p = $c_scm_HashSet$Node.prototype = new $h_O();
$p.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
}
$h_scm_HashSet$Node.prototype = $p;
$p.atX = (function(k, h) {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    if (((h === \u03b4this$tailLocal1.mq) && $m_sr_BoxesRunTime$().B(k, \u03b4this$tailLocal1.qn))) {
      return \u03b4this$tailLocal1;
    } else if (((\u03b4this$tailLocal1.f3 === null) || (\u03b4this$tailLocal1.mq > h))) {
      return null;
    } else {
      \u03b4this$tailLocal1 = \u03b4this$tailLocal1.f3;
    }
  }
});
$p.al = (function(f) {
  var \u03b4this$tailLocal2 = this;
  while (true) {
    f.p(\u03b4this$tailLocal2.qn);
    if ((\u03b4this$tailLocal2.f3 !== null)) {
      \u03b4this$tailLocal2 = \u03b4this$tailLocal2.f3;
    } else {
      return (void 0);
    }
  }
});
$p.g = (function() {
  return ((((("Node(" + this.qn) + ", ") + this.mq) + ") -> ") + this.f3);
});
var $d_scm_HashSet$Node = new $TypeData().i($c_scm_HashSet$Node, "scala.collection.mutable.HashSet$Node", ({
  ze: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$Entry(key, hash) {
  this.mr = null;
  this.oj = 0;
  this.abh = null;
  this.Ly = null;
  this.fF = null;
  this.mr = key;
  this.oj = hash;
  this.abh = null;
  this.Ly = null;
  this.fF = null;
}
$p = $c_scm_LinkedHashSet$Entry.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashSet$Entry;
/** @constructor */
function $h_scm_LinkedHashSet$Entry() {
}
$h_scm_LinkedHashSet$Entry.prototype = $p;
$p.atU = (function(k, h) {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    if (((h === \u03b4this$tailLocal1.oj) && $m_sr_BoxesRunTime$().B(k, \u03b4this$tailLocal1.mr))) {
      return \u03b4this$tailLocal1;
    } else if (((\u03b4this$tailLocal1.fF === null) || (\u03b4this$tailLocal1.oj > h))) {
      return null;
    } else {
      \u03b4this$tailLocal1 = \u03b4this$tailLocal1.fF;
    }
  }
});
var $d_scm_LinkedHashSet$Entry = new $TypeData().i($c_scm_LinkedHashSet$Entry, "scala.collection.mutable.LinkedHashSet$Entry", ({
  zn: 1
}));
/** @constructor */
function $c_scm_MutationTracker$() {
}
$p = $c_scm_MutationTracker$.prototype = new $h_O();
$p.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
}
$h_scm_MutationTracker$.prototype = $p;
$p.TK = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message);
  }
});
var $d_scm_MutationTracker$ = new $TypeData().i($c_scm_MutationTracker$, "scala.collection.mutable.MutationTracker$", ({
  zq: 1
}));
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$();
  }
  return $n_scm_MutationTracker$;
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__jl_Runnable__Ajl_Runnable__I__($thiz, first, other, size) {
  $thiz.He = first;
  $thiz.Hf = other;
  $thiz.tH = size;
  return $thiz;
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.Hf;
  var curLen = curOther.a.length;
  if ((curSize <= curLen)) {
    return curOther;
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen));
    }
    var newOther = new ($d_jl_Runnable.r().C)(newLen);
    curOther.av(0, newOther, 0, curLen);
    $thiz.Hf = newOther;
    return newOther;
  }
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.He = null;
  this.Hf = null;
  this.tH = 0;
}
$p = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$p.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $p;
$p.awZ = (function(r) {
  var sz = this.tH;
  if ((sz === 0)) {
    this.He = r;
  } else {
    $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz).a[((sz - 1) | 0)] = r;
  }
  this.tH = ((1 + sz) | 0);
});
$p.axx = (function(n) {
  var n$tailLocal1 = n;
  while (true) {
    if ((n$tailLocal1 > 0)) {
      var x1 = this.tH;
      if ((x1 === 0)) {
        return (void 0);
      }
      if ((x1 === 1)) {
        var x$proxy1 = this.He;
        if ((x$proxy1 === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        this.He = null;
        this.tH = 0;
        x$proxy1.zV();
        n$tailLocal1 = ((n$tailLocal1 - 1) | 0);
        continue;
      }
      var o = this.Hf;
      var x$proxy2 = o.a[((x1 - 2) | 0)];
      if ((x$proxy2 === null)) {
        $m_sr_Scala3RunTime$().bW();
      }
      o.a[((x1 - 2) | 0)] = null;
      this.tH = ((x1 - 1) | 0);
      x$proxy2.zV();
      n$tailLocal1 = ((n$tailLocal1 - 1) | 0);
    } else {
      return (void 0);
    }
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.abk = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.abk = new ($d_jl_Runnable.r().C)(0);
}
$p = $c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $p;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().i($c_s_concurrent_BatchingExecutorStatics$, "scala.concurrent.BatchingExecutorStatics$", ({
  zz: 1
}));
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$();
  }
  return $n_s_concurrent_BatchingExecutorStatics$;
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.abl = null;
  this.abm = false;
  this.D6 = null;
  $n_s_concurrent_ExecutionContext$ = this;
  this.D6 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    _$1$3.Eu($m_jl_System$Streams$().xX);
  }));
}
$p = $c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
}
$h_s_concurrent_ExecutionContext$.prototype = $p;
$p.ahB = (function() {
  if ((!this.abm)) {
    this.abl = $m_sjs_concurrent_JSExecutionContext$().Ss;
    this.abm = true;
  }
  return this.abl;
});
var $d_s_concurrent_ExecutionContext$ = new $TypeData().i($c_s_concurrent_ExecutionContext$, "scala.concurrent.ExecutionContext$", ({
  zA: 1
}));
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$();
  }
  return $n_s_concurrent_ExecutionContext$;
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.abp = null;
  this.abr = null;
  this.abq = null;
  this.Sc = null;
  this.abs = null;
  this.abo = null;
  this.abt = null;
  $n_s_concurrent_Future$ = this;
  $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2($d_Z.l(), $d_jl_Boolean.l()), new $c_T2($d_B.l(), $d_jl_Byte.l()), new $c_T2($d_C.l(), $d_jl_Character.l()), new $c_T2($d_S.l(), $d_jl_Short.l()), new $c_T2($d_I.l(), $d_jl_Integer.l()), new $c_T2($d_J.l(), $d_jl_Long.l()), new $c_T2($d_F.l(), $d_jl_Float.l()), new $c_T2($d_D.l(), $d_jl_Double.l()), new $c_T2($d_V.l(), $d_jl_Void.l())]));
  this.abp = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2);
  }));
  this.abr = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.abq = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  $m_s_concurrent_Future$().ahl(this.abq);
  this.Sc = $m_s_concurrent_Future$().atM(new $c_s_concurrent_Future$$anon$4());
  this.abs = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$1) => this.Sc));
  this.abo = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((b$2, e$2) => b$2.aD(e$2)));
  this.abt = this.ahl(new $c_s_util_Success((void 0)));
}
$p = $c_s_concurrent_Future$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
}
$h_s_concurrent_Future$.prototype = $p;
$p.atM = (function(exception) {
  return $m_s_concurrent_Promise$().atN(exception);
});
$p.aE = (function(result) {
  return $m_s_concurrent_Promise$().ayp(result);
});
$p.ahl = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$p.un = (function(body, executor) {
  return this.abt.aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => body.aA())), executor);
});
$p.ajG = (function(in$1, bf, executor) {
  var this$2 = in$1.l();
  var z = this.aE(bf.awp(in$1));
  var f = ((fr$2, fa$2) => fr$2.aEs(fa$2, $m_s_concurrent_Future$().abo, executor));
  if ($is_sc_IndexedSeq(this$2)) {
    var end = this$2.F();
    var $x_1;
    var acc$tailLocal1 = z;
    var at$tailLocal1 = 0;
    while (true) {
      if ((at$tailLocal1 !== end)) {
        var at$tailLocal1$tmp1 = ((1 + at$tailLocal1) | 0);
        var x0 = acc$tailLocal1;
        var x1 = this$2.at(at$tailLocal1);
        var acc$tailLocal1$tmp1 = f(x0, x1);
        at$tailLocal1 = at$tailLocal1$tmp1;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue;
      }
      var $x_1 = acc$tailLocal1;
      break;
    }
  } else {
    var result = z;
    while (this$2.f()) {
      var x0$1 = result;
      var x1$1 = this$2.e();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1.aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => _$6$2.aR())), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()));
});
var $d_s_concurrent_Future$ = new $TypeData().i($c_s_concurrent_Future$, "scala.concurrent.Future$", ({
  zC: 1
}));
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$();
  }
  return $n_s_concurrent_Future$;
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.Je(result)) {
    return $thiz;
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.");
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, new $c_s_util_Success(value));
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, new $c_s_util_Failure(cause));
}
/** @constructor */
function $c_s_concurrent_Promise$() {
}
$p = $c_s_concurrent_Promise$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
}
$h_s_concurrent_Promise$.prototype = $p;
$p.atN = (function(exception) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), new $c_s_util_Failure(exception));
});
$p.ayp = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), new $c_s_util_Success(result));
});
var $d_s_concurrent_Promise$ = new $TypeData().i($c_s_concurrent_Promise$, "scala.concurrent.Promise$", ({
  zH: 1
}));
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$();
  }
  return $n_s_concurrent_Promise$;
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var this$2 = $m_s_Predef$().Jl($f_T__split__T__I__AT($f_T__trim__T(s), "\\s+", 0));
  $m_sci_List$();
  return $m_sci_Nil$().aY(this$2);
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x5 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
    if ((x5 instanceof $c_sci_$colon$colon)) {
      var x8 = x5.bz;
      var \u03b41$___1 = x5.q9;
      var \u03b41$___2 = x8;
      break matchResult3;
    }
    throw new $c_s_MatchError(x5);
  }
  var hd$2 = \u03b41$___1;
  var rest$2 = \u03b41$___2;
  var rest = rest$2;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.W();
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(new $c_sci_$colon$colon(x0, new $c_sci_$colon$colon((x0 + "s"), $m_sci_Nil$())));
    while (it.f()) {
      var nx = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.bz = nx;
      }
      t = nx;
    }
    rest = rest.ak();
  }
  return new $c_sci_$colon$colon(hd$2, ((h === null) ? $m_sci_Nil$() : h));
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.abu = null;
  this.LB = null;
  this.Sd = null;
  this.Se = null;
  $n_s_concurrent_duration_Duration$ = this;
  var timeUnitLabels = new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Hg, "d day"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Sf, "h hr hour"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Si, "m min minute"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Sk, "s sec second"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Sh, "ms milli millisecond"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Sg, "\u00b5s micro microsecond"), new $c_sci_$colon$colon(new $c_T2($m_s_concurrent_duration_package$().Sj, "ns nano nanosecond"), $m_sci_Nil$())))))));
  this.abu = $m_sci_Map$().dH(new $c_sc_MapView$MapValues(new $c_sc_MapView$Id($m_sci_Map$().dH(timeUnitLabels)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2) => $p_s_concurrent_duration_Duration$__words__T__sci_List(this, s$2).cJ()))));
  var $x_2 = $m_sci_Map$();
  var rest = timeUnitLabels;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.W();
    var unit = x0.P();
    var names = x0.V();
    var this$30 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List(this, names);
    var f$1 = ((unit) => ((_$4$2) => new $c_T2(_$4$2, unit)))(unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$1 = this$30.W();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$30.ak();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$2 = rest$1.W();
        var nx = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
        t$1.bz = nx;
        t$1 = nx;
        rest$1 = rest$1.ak();
      }
      var $x_1 = h$1;
    }
    var it = $x_1.l();
    while (it.f()) {
      var nx$1 = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        t.bz = nx$1;
      }
      t = nx$1;
    }
    rest = rest.ak();
  }
  $x_2.dH(((h === null) ? $m_sci_Nil$() : h));
  new $c_s_concurrent_duration_FiniteDuration(0, 0, $m_s_concurrent_duration_package$().Hg);
  this.LB = new $c_s_concurrent_duration_Duration$$anon$1();
  this.Sd = new $c_s_concurrent_duration_Duration$$anon$2();
  this.Se = new $c_s_concurrent_duration_Duration$$anon$3();
}
$p = $c_s_concurrent_duration_Duration$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
}
$h_s_concurrent_duration_Duration$.prototype = $p;
var $d_s_concurrent_duration_Duration$ = new $TypeData().i($c_s_concurrent_duration_Duration$, "scala.concurrent.duration.Duration$", ({
  zI: 1
}));
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$();
  }
  return $n_s_concurrent_duration_Duration$;
}
/** @constructor */
function $c_s_concurrent_duration_package$() {
  this.Hg = null;
  this.Sf = null;
  this.Sg = null;
  this.Sh = null;
  this.Si = null;
  this.Sj = null;
  this.Sk = null;
  $n_s_concurrent_duration_package$ = this;
  this.Hg = $m_ju_concurrent_TimeUnit$().a9Q;
  this.Sf = $m_ju_concurrent_TimeUnit$().a9R;
  this.Sg = $m_ju_concurrent_TimeUnit$().a9S;
  this.Sh = $m_ju_concurrent_TimeUnit$().a9T;
  this.Si = $m_ju_concurrent_TimeUnit$().a9U;
  this.Sj = $m_ju_concurrent_TimeUnit$().R8;
  this.Sk = $m_ju_concurrent_TimeUnit$().a9V;
}
$p = $c_s_concurrent_duration_package$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_duration_package$;
/** @constructor */
function $h_s_concurrent_duration_package$() {
}
$h_s_concurrent_duration_package$.prototype = $p;
var $d_s_concurrent_duration_package$ = new $TypeData().i($c_s_concurrent_duration_package$, "scala.concurrent.duration.package$", ({
  zM: 1
}));
var $n_s_concurrent_duration_package$;
function $m_s_concurrent_duration_package$() {
  if ((!$n_s_concurrent_duration_package$)) {
    $n_s_concurrent_duration_package$ = new $c_s_concurrent_duration_package$();
  }
  return $n_s_concurrent_duration_package$;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.Hh = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.Hh = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$());
}
$p = $c_s_concurrent_impl_Promise$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
}
$h_s_concurrent_impl_Promise$.prototype = $p;
$p.J9 = (function(value) {
  if ((value instanceof $c_s_util_Success)) {
    return value;
  } else {
    var t = value.tJ;
    return (((false || false) || (t instanceof $c_jl_Error)) ? (false ? new $c_s_util_Success(t.akt()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value);
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().i($c_s_concurrent_impl_Promise$, "scala.concurrent.impl.Promise$", ({
  zN: 1
}));
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$();
  }
  return $n_s_concurrent_impl_Promise$;
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.c8)));
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.c8)));
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.D7 = null;
  $n_s_math_BigDecimal$ = this;
  this.D7 = $m_Ljava_math_MathContext$().a9k;
}
$p = $c_s_math_BigDecimal$.prototype = new $h_O();
$p.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
}
$h_s_math_BigDecimal$.prototype = $p;
$p.U4 = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc);
});
$p.atC = (function(repr) {
  return new $c_s_math_BigDecimal(repr, ((repr.Es() <= this.D7.q0) ? this.D7 : new $c_Ljava_math_MathContext(repr.Es(), $m_Ljava_math_RoundingMode$().Ct)));
});
$p.atB = (function(s) {
  return this.atC($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s));
});
var $d_s_math_BigDecimal$ = new $TypeData().i($c_s_math_BigDecimal$, "scala.math.BigDecimal$", ({
  zP: 1
}));
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$();
  }
  return $n_s_math_BigDecimal$;
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.LE) | 0);
  var n = $thiz.Sn.a[offset];
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, i, hi);
    $thiz.Sn.a[offset] = n;
  }
  return n;
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.Sp = null;
  this.LE = 0;
  this.So = 0;
  this.Sn = null;
  this.abv = null;
  $n_s_math_BigInt$ = this;
  this.Sp = $m_Ljava_math_BigInteger$().iy(0, (-2147483648));
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.Sp, 0, (-2147483648));
  this.LE = (-1024);
  this.So = 1024;
  this.Sn = new ($d_s_math_BigInt.r().C)(((1 + ((this.So - this.LE) | 0)) | 0));
  this.abv = $m_Ljava_math_BigInteger$().iy((-1), (-1));
}
$p = $c_s_math_BigInt$.prototype = new $h_O();
$p.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
$h_s_math_BigInt$.prototype = $p;
$p.amD = (function(x) {
  return this.amE($ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), x));
});
$p.amE = (function(x) {
  if (($m_Ljava_math_BitLevel$().DQ(x) <= 63)) {
    var $x_1 = x.jw();
    var l_$_lo = $x_1.l;
    var l_$_hi = $x_1.h;
    var value = this.LE;
    var hi = (value >> 31);
    if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
      var value$1 = this.So;
      var hi$1 = (value$1 >> 31);
      var $x_2 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, l_$_lo, l_$_hi);
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, 0, (-2147483648));
  }
});
var $d_s_math_BigInt$ = new $TypeData().i($c_s_math_BigInt$, "scala.math.BigInt$", ({
  zQ: 1
}));
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var $x_1 = $thiz.jw();
  var lv_$_lo = $x_1.l;
  var lv_$_hi = $x_1.h;
  return ((((lv_$_hi === (-1)) ? ((lv_$_lo >>> 0) >= 2147483648) : (lv_$_hi > (-1))) && ((lv_$_hi === 0) ? ((lv_$_lo >>> 0) <= 2147483647) : (lv_$_hi < 0))) ? lv_$_lo : $m_sr_Statics$().bG(lv_$_lo, lv_$_hi));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x$2 = $uC(x);
    return ($thiz.UM() && ($thiz.js() === x$2));
  } else if ($isByte(x)) {
    var x$3 = (x | 0);
    return ($thiz.UL() && ($thiz.TJ() === x$3));
  } else if ($isShort(x)) {
    var x$4 = (x | 0);
    return ($thiz.UN() && ($thiz.Vs() === x$4));
  } else if ($isInt(x)) {
    var x$5 = (x | 0);
    return ($thiz.N1() && ($thiz.js() === x$5));
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    var x$6_$_lo = $x_1.l;
    var x$6_$_hi = $x_1.h;
    var $x_2 = $thiz.jw();
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x$1_$_lo ^ x$6_$_lo) | (x$1_$_hi ^ x$6_$_hi)) === 0);
  } else if ($isFloat(x)) {
    var x$7 = Math.fround(x);
    return ($thiz.E3() === x$7);
  } else if (((typeof x) === "number")) {
    var x$8 = (+x);
    return ($thiz.qG() === x$8);
  } else {
    return false;
  }
}
/** @constructor */
function $c_s_package$() {
  this.ali = null;
  this.aln = null;
  this.alk = null;
  this.all = null;
  this.alj = null;
  this.abx = null;
  this.aby = false;
  this.abz = null;
  this.abA = false;
  this.alm = null;
  $n_s_package$ = this;
  $m_sc_Iterable$();
  this.ali = $m_sc_Iterable$();
  this.aln = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.alk = $m_sci_List$();
  this.all = $m_sci_Nil$();
  this.alj = $m_sci_LazyList$();
  $m_sci_Vector$();
  $m_s_math_Equiv$();
  this.alm = $m_s_math_Ordering$();
}
$p = $c_s_package$.prototype = new $h_O();
$p.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
$h_s_package$.prototype = $p;
$p.alO = (function() {
  if ((!this.aby)) {
    this.abx = $m_s_math_BigDecimal$();
    this.aby = true;
  }
  return this.abx;
});
$p.alP = (function() {
  if ((!this.abA)) {
    this.abz = $m_s_math_BigInt$();
    this.abA = true;
  }
  return this.abz;
});
var $d_s_package$ = new $TypeData().i($c_s_package$, "scala.package$", ({
  Ao: 1
}));
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
/** @constructor */
function $c_s_reflect_ClassTag$() {
  this.alr = null;
  this.alA = null;
  this.als = null;
  this.alv = null;
  this.alw = null;
  this.alu = null;
  this.alt = null;
  this.alq = null;
  this.alB = null;
  this.alo = null;
  this.alz = null;
  this.alp = null;
  this.alx = null;
  this.aly = null;
  $n_s_reflect_ClassTag$ = this;
  this.alr = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.alA = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.als = $m_s_reflect_ManifestFactory$CharManifest$();
  this.alv = $m_s_reflect_ManifestFactory$IntManifest$();
  this.alw = $m_s_reflect_ManifestFactory$LongManifest$();
  this.alu = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.alt = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.alq = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.alB = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.alo = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.alz = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.alp = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.alx = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.aly = $m_s_reflect_ManifestFactory$NullManifest$();
}
$p = $c_s_reflect_ClassTag$.prototype = new $h_O();
$p.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
}
$h_s_reflect_ClassTag$.prototype = $p;
$p.um = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.l()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.l()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.l()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.l()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.l()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.l()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.l()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.l()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.l()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.l()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.l()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.l()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))));
});
var $d_s_reflect_ClassTag$ = new $TypeData().i($c_s_reflect_ClassTag$, "scala.reflect.ClassTag$", ({
  Ap: 1
}));
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$();
  }
  return $n_s_reflect_ClassTag$;
}
/** @constructor */
function $c_sr_Arrays$() {
}
$p = $c_sr_Arrays$.prototype = new $h_O();
$p.constructor = $c_sr_Arrays$;
/** @constructor */
function $h_sr_Arrays$() {
}
$h_sr_Arrays$.prototype = $p;
$p.axO = (function(xs, clazz) {
  var length = xs.F();
  var arr = clazz.ax.U(length);
  xs.d0(arr, 0, 2147483647);
  return arr;
});
var $d_sr_Arrays$ = new $TypeData().i($c_sr_Arrays$, "scala.runtime.Arrays$", ({
  AU: 1
}));
var $n_sr_Arrays$;
function $m_sr_Arrays$() {
  if ((!$n_sr_Arrays$)) {
    $n_sr_Arrays$ = new $c_sr_Arrays$();
  }
  return $n_sr_Arrays$;
}
/** @constructor */
function $c_sr_BoxesRunTime$() {
}
$p = $c_sr_BoxesRunTime$.prototype = new $h_O();
$p.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
}
$h_sr_BoxesRunTime$.prototype = $p;
$p.B = (function(x, y) {
  return ((x === y) || ($is_jl_Number(x) ? this.dG(x, y) : ((x instanceof $Char) ? this.atz(x, y) : ((x === null) ? (y === null) : $dp_equals__O__Z(x, y)))));
});
$p.dG = (function(xn, y) {
  if ($is_jl_Number(y)) {
    return this.Ua(xn, y);
  } else if ((y instanceof $Char)) {
    if (((typeof xn) === "number")) {
      return ((+xn) === y.c);
    } else if ((xn instanceof $Long)) {
      var $x_1 = $uJ(xn);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      var value = y.c;
      var hi = (value >> 31);
      return (((x3_$_lo ^ value) | (x3_$_hi ^ hi)) === 0);
    } else {
      return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
  }
});
$p.Ua = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = (+xn);
    if (((typeof yn) === "number")) {
      return (x2 === (+yn));
    } else if ((yn instanceof $Long)) {
      var $x_1 = $uJ(yn);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      return (x2 === ((4.294967296E9 * x3_$_hi) + (x3_$_lo >>> 0.0)));
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.b(x2));
    }
  } else if ((xn instanceof $Long)) {
    var $x_2 = $uJ(xn);
    var x3$2_$_lo = $x_2.l;
    var x3$2_$_hi = $x_2.h;
    if ((yn instanceof $Long)) {
      var $x_3 = $uJ(yn);
      var x2$3_$_lo = $x_3.l;
      var x2$3_$_hi = $x_3.h;
      return (((x3$2_$_lo ^ x2$3_$_lo) | (x3$2_$_hi ^ x2$3_$_hi)) === 0);
    } else if (((typeof yn) === "number")) {
      var x3$3 = (+yn);
      return (((4.294967296E9 * x3$2_$_hi) + (x3$2_$_lo >>> 0.0)) === x3$3);
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.b($bL(x3$2_$_lo, x3$2_$_hi)));
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn));
  }
});
$p.atz = (function(xc, y) {
  if ((y instanceof $Char)) {
    return (xc.c === y.c);
  } else if ($is_jl_Number(y)) {
    if (((typeof y) === "number")) {
      return ((+y) === xc.c);
    } else if ((y instanceof $Long)) {
      var $x_1 = $uJ(y);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      var value = xc.c;
      var hi = (value >> 31);
      return (((x3_$_lo ^ value) | (x3_$_hi ^ hi)) === 0);
    } else {
      return ((y === null) ? (xc === null) : $dp_equals__O__Z(y, xc));
    }
  } else {
    return ((xc === null) && (y === null));
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().i($c_sr_BoxesRunTime$, "scala.runtime.BoxesRunTime$", ({
  AW: 1
}));
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$();
  }
  return $n_sr_BoxesRunTime$;
}
var $d_sr_Null$ = new $TypeData().i(0, "scala.runtime.Null$", ({
  B5: 1
}));
/** @constructor */
function $c_sr_RichLong$() {
}
$p = $c_sr_RichLong$.prototype = new $h_O();
$p.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
}
$h_sr_RichLong$.prototype = $p;
$p.atx = (function(this$_$_lo, this$_$_hi, x$0) {
  if ((x$0 instanceof $c_sr_RichLong)) {
    if ((x$0 === null)) {
      var $x_1 = $uJ(null);
      var x$0$2_$_lo = $x_1.l;
      var x$0$2_$_hi = $x_1.h;
    } else {
      var $x_2 = x$0;
      var x$0$2_$_lo = $x_2.g6;
      var x$0$2_$_hi = $x_2.g7;
    }
    return (((this$_$_lo ^ x$0$2_$_lo) | (this$_$_hi ^ x$0$2_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.avt = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 24) >> 24);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.avy = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 16) >> 16);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.avu = (function(this$_$_lo, this$_$_hi) {
  var value = (65535 & this$_$_lo);
  return (((value ^ this$_$_lo) | ((value >> 31) ^ this$_$_hi)) === 0);
});
$p.avx = (function(this$_$_lo, this$_$_hi) {
  return (((this$_$_lo ^ this$_$_lo) | ((this$_$_lo >> 31) ^ this$_$_hi)) === 0);
});
var $d_sr_RichLong$ = new $TypeData().i($c_sr_RichLong$, "scala.runtime.RichLong$", ({
  B9: 1
}));
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$();
  }
  return $n_sr_RichLong$;
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
}
$p = $c_sr_Scala3RunTime$.prototype = new $h_O();
$p.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
}
$h_sr_Scala3RunTime$.prototype = $p;
$p.Mk = (function(message) {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("assertion failed: " + message));
});
$p.afO = (function() {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
});
$p.bW = (function() {
  throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "tried to cast away nullability, but value is null");
});
var $d_sr_Scala3RunTime$ = new $TypeData().i($c_sr_Scala3RunTime$, "scala.runtime.Scala3RunTime$", ({
  Ba: 1
}));
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$();
  }
  return $n_sr_Scala3RunTime$;
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
}
$p = $c_sr_ScalaRunTime$.prototype = new $h_O();
$p.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
}
$h_sr_ScalaRunTime$.prototype = $p;
$p.cZ = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_I)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_D)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_J)) {
    var $x_1 = xs.a;
    var $x_2 = (idx << 1);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  }
  if ((xs instanceof $ac_F)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_C)) {
    return $bC(xs.a[idx]);
  }
  if ((xs instanceof $ac_B)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_S)) {
    return xs.a[idx];
  }
  if ((xs instanceof $ac_Z)) {
    return xs.a[idx];
  }
  if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  throw new $c_s_MatchError(xs);
});
$p.bQ = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    xs.a[idx] = value;
    return (void 0);
  }
  if ((xs instanceof $ac_I)) {
    xs.a[idx] = (value | 0);
    return (void 0);
  }
  if ((xs instanceof $ac_D)) {
    xs.a[idx] = (+value);
    return (void 0);
  }
  if ((xs instanceof $ac_J)) {
    var $x_1 = $uJ(value);
    var $x_2 = xs.a;
    var $x_3 = (idx << 1);
    $x_2[$x_3] = $x_1.l;
    $x_2[(($x_3 + 1) | 0)] = $x_1.h;
    return (void 0);
  }
  if ((xs instanceof $ac_F)) {
    xs.a[idx] = Math.fround(value);
    return (void 0);
  }
  if ((xs instanceof $ac_C)) {
    xs.a[idx] = $uC(value);
    return (void 0);
  }
  if ((xs instanceof $ac_B)) {
    xs.a[idx] = (value | 0);
    return (void 0);
  }
  if ((xs instanceof $ac_S)) {
    xs.a[idx] = (value | 0);
    return (void 0);
  }
  if ((xs instanceof $ac_Z)) {
    xs.a[idx] = (!(!value));
    return (void 0);
  }
  if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  throw new $c_s_MatchError(xs);
});
$p.afN = (function(xs) {
  if ((xs instanceof $ac_O)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_I)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_D)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_J)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_F)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_C)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_B)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_S)) {
    return xs.ar();
  }
  if ((xs instanceof $ac_Z)) {
    return xs.ar();
  }
  if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  throw new $c_s_MatchError(xs);
});
$p.H = (function(x) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(x.C(), (x.A() + "("), ",", ")");
});
$p.IE = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().ge(xs));
});
$p.azB = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if ((xs.a.length === 0)) {
    var this$2 = $m_sci_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$2);
  } else {
    return new $c_sci_ArraySeq$ofRef(xs);
  }
});
var $d_sr_ScalaRunTime$ = new $TypeData().i($c_sr_ScalaRunTime$, "scala.runtime.ScalaRunTime$", ({
  Bc: 1
}));
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$();
  }
  return $n_sr_ScalaRunTime$;
}
/** @constructor */
function $c_sr_Statics$() {
}
$p = $c_sr_Statics$.prototype = new $h_O();
$p.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
}
$h_sr_Statics$.prototype = $p;
$p.d = (function(hash, data) {
  var h = this.kR(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.kR = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.an = (function(hash, length) {
  return this.amV((hash ^ length));
});
$p.amV = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$p.bG = (function(lv_$_lo, lv_$_hi) {
  return ((lv_$_hi === (lv_$_lo >> 31)) ? lv_$_lo : (lv_$_lo ^ lv_$_hi));
});
$p.aS = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv;
  } else {
    var $x_1 = $m_RTLong$().jq(dv);
    var lv_$_lo = $x_1.l;
    var lv_$_hi = $x_1.h;
    if ((((4.294967296E9 * lv_$_hi) + (lv_$_lo >>> 0.0)) === dv)) {
      return (lv_$_lo ^ lv_$_hi);
    } else {
      var valueInt = (dv | 0);
      if (((valueInt === dv) && ((1.0 / dv) !== (-Infinity)))) {
        return valueInt;
      } else if ((dv !== dv)) {
        return 2146959360;
      } else {
        var fpBitsDataView = $fpBitsDataView;
        fpBitsDataView.setFloat64(0, dv, true);
        return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
      }
    }
  }
});
$p.k = (function(x) {
  if ((x === null)) {
    return 0;
  } else if (((typeof x) === "number")) {
    return this.aS((+x));
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    return this.bG($x_1.l, $x_1.h);
  } else {
    return $dp_hashCode__I(x);
  }
});
$p.avg = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_sr_Statics$ = new $TypeData().i($c_sr_Statics$, "scala.runtime.Statics$", ({
  Bf: 1
}));
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$();
  }
  return $n_sr_Statics$;
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
}
$p = $c_sr_Statics$PFMarker$.prototype = new $h_O();
$p.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
}
$h_sr_Statics$PFMarker$.prototype = $p;
var $d_sr_Statics$PFMarker$ = new $TypeData().i($c_sr_Statics$PFMarker$, "scala.runtime.Statics$PFMarker$", ({
  Bg: 1
}));
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$();
  }
  return $n_sr_Statics$PFMarker$;
}
/** @constructor */
function $c_sr_TupleXXL$() {
}
$p = $c_sr_TupleXXL$.prototype = new $h_O();
$p.constructor = $c_sr_TupleXXL$;
/** @constructor */
function $h_sr_TupleXXL$() {
}
$h_sr_TupleXXL$.prototype = $p;
$p.afL = (function(elems) {
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var array = new $ac_O(elems.F());
  var iterator = elems.l();
  var i = 0;
  while (iterator.f()) {
    array.a[i] = iterator.e();
    i = ((1 + i) | 0);
  }
  return new $c_sr_TupleXXL(array);
});
var $d_sr_TupleXXL$ = new $TypeData().i($c_sr_TupleXXL$, "scala.runtime.TupleXXL$", ({
  Bh: 1
}));
var $n_sr_TupleXXL$;
function $m_sr_TupleXXL$() {
  if ((!$n_sr_TupleXXL$)) {
    $n_sr_TupleXXL$ = new $c_sr_TupleXXL$();
  }
  return $n_sr_TupleXXL$;
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$() {
  this.Ss = null;
  $n_sjs_concurrent_JSExecutionContext$ = this;
  this.Ss = $m_sjs_concurrent_QueueExecutionContext$().amK();
}
$p = $c_sjs_concurrent_JSExecutionContext$.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_JSExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$() {
}
$h_sjs_concurrent_JSExecutionContext$.prototype = $p;
var $d_sjs_concurrent_JSExecutionContext$ = new $TypeData().i($c_sjs_concurrent_JSExecutionContext$, "scala.scalajs.concurrent.JSExecutionContext$", ({
  Bi: 1
}));
var $n_sjs_concurrent_JSExecutionContext$;
function $m_sjs_concurrent_JSExecutionContext$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$)) {
    $n_sjs_concurrent_JSExecutionContext$ = new $c_sjs_concurrent_JSExecutionContext$();
  }
  return $n_sjs_concurrent_JSExecutionContext$;
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$Implicits$() {
  this.kx = null;
  $n_sjs_concurrent_JSExecutionContext$Implicits$ = this;
  this.kx = $m_sjs_concurrent_JSExecutionContext$().Ss;
}
$p = $c_sjs_concurrent_JSExecutionContext$Implicits$.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_JSExecutionContext$Implicits$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$Implicits$() {
}
$h_sjs_concurrent_JSExecutionContext$Implicits$.prototype = $p;
var $d_sjs_concurrent_JSExecutionContext$Implicits$ = new $TypeData().i($c_sjs_concurrent_JSExecutionContext$Implicits$, "scala.scalajs.concurrent.JSExecutionContext$Implicits$", ({
  Bj: 1
}));
var $n_sjs_concurrent_JSExecutionContext$Implicits$;
function $m_sjs_concurrent_JSExecutionContext$Implicits$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$Implicits$)) {
    $n_sjs_concurrent_JSExecutionContext$Implicits$ = new $c_sjs_concurrent_JSExecutionContext$Implicits$();
  }
  return $n_sjs_concurrent_JSExecutionContext$Implicits$;
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$() {
}
$p = $c_sjs_concurrent_QueueExecutionContext$.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$() {
}
$h_sjs_concurrent_QueueExecutionContext$.prototype = $p;
$p.amK = (function() {
  return (((typeof Promise) === "undefined") ? new $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() : new $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext());
});
var $d_sjs_concurrent_QueueExecutionContext$ = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$, "scala.scalajs.concurrent.QueueExecutionContext$", ({
  Bk: 1
}));
var $n_sjs_concurrent_QueueExecutionContext$;
function $m_sjs_concurrent_QueueExecutionContext$() {
  if ((!$n_sjs_concurrent_QueueExecutionContext$)) {
    $n_sjs_concurrent_QueueExecutionContext$ = new $c_sjs_concurrent_QueueExecutionContext$();
  }
  return $n_sjs_concurrent_QueueExecutionContext$;
}
function $ps_sjs_js_ArrayOps$__d$1__O__sr_BooleanRef__O(x, matched$1) {
  matched$1.e1 = false;
  return null;
}
/** @constructor */
function $c_sjs_js_ArrayOps$() {
}
$p = $c_sjs_js_ArrayOps$.prototype = new $h_O();
$p.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
}
$h_sjs_js_ArrayOps$.prototype = $p;
$p.UC = (function(this$) {
  if (((this$.length | 0) === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array");
  }
  return this$[0];
});
$p.zK = (function(this$) {
  return (((this$.length | 0) === 0) ? $m_s_None$() : new $c_s_Some(this$[0]));
});
$p.avY = (function(this$) {
  return (((this$.length | 0) === 0) ? $m_s_None$() : new $c_s_Some(this$[(((this$.length | 0) - 1) | 0)]));
});
$p.axv = (function(this$) {
  var len = (this$.length | 0);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    res[((((len - i) | 0) - 1) | 0)] = this$[i];
    i = ((1 + i) | 0);
  }
  return res;
});
$p.ayh = (function(this$, ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$), ord).mt;
});
$p.Nt = (function(this$, f, ord) {
  return $m_sjs_js_ArrayOps$().ayh(this$, new $c_s_math_Ordering$$anon$1(f, ord));
});
$p.ani = (function(this$, pf) {
  var matched = new $c_sr_BooleanRef(true);
  var b = [];
  var len = (this$.length | 0);
  var i = 0;
  while ((i < len)) {
    var x0 = this$[i];
    matched.e1 = true;
    var v = pf.aJ(x0, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((matched) => ((x$2$2) => $ps_sjs_js_ArrayOps$__d$1__O__sr_BooleanRef__O(x$2$2, matched)))(matched)));
    if (matched.e1) {
      (b.push(v) | 0);
    }
    i = ((1 + i) | 0);
  }
  return b;
});
var $d_sjs_js_ArrayOps$ = new $TypeData().i($c_sjs_js_ArrayOps$, "scala.scalajs.js.ArrayOps$", ({
  Bp: 1
}));
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$();
  }
  return $n_sjs_js_ArrayOps$;
}
/** @constructor */
function $c_sjs_js_JSConverters$JSRichIterableOnce$() {
}
$p = $c_sjs_js_JSConverters$JSRichIterableOnce$.prototype = new $h_O();
$p.constructor = $c_sjs_js_JSConverters$JSRichIterableOnce$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichIterableOnce$() {
}
$h_sjs_js_JSConverters$JSRichIterableOnce$.prototype = $p;
$p.hP = (function(this$) {
  if ((this$ instanceof $c_sjs_js_WrappedArray)) {
    return this$.mt;
  } else {
    var result = [];
    var this$2 = this$.l();
    while (this$2.f()) {
      var x0 = this$2.e();
      (result.push(x0) | 0);
    }
    return result;
  }
});
var $d_sjs_js_JSConverters$JSRichIterableOnce$ = new $TypeData().i($c_sjs_js_JSConverters$JSRichIterableOnce$, "scala.scalajs.js.JSConverters$JSRichIterableOnce$", ({
  Bq: 1
}));
var $n_sjs_js_JSConverters$JSRichIterableOnce$;
function $m_sjs_js_JSConverters$JSRichIterableOnce$() {
  if ((!$n_sjs_js_JSConverters$JSRichIterableOnce$)) {
    $n_sjs_js_JSConverters$JSRichIterableOnce$ = new $c_sjs_js_JSConverters$JSRichIterableOnce$();
  }
  return $n_sjs_js_JSConverters$JSRichIterableOnce$;
}
/** @constructor */
function $c_sjs_js_Thenable$Implicits$() {
}
$p = $c_sjs_js_Thenable$Implicits$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Thenable$Implicits$;
/** @constructor */
function $h_sjs_js_Thenable$Implicits$() {
}
$h_sjs_js_Thenable$Implicits$.prototype = $p;
$p.bH = (function(p) {
  return $m_sjs_js_Thenable$ThenableOps$().uE(p);
});
var $d_sjs_js_Thenable$Implicits$ = new $TypeData().i($c_sjs_js_Thenable$Implicits$, "scala.scalajs.js.Thenable$Implicits$", ({
  Bu: 1
}));
var $n_sjs_js_Thenable$Implicits$;
function $m_sjs_js_Thenable$Implicits$() {
  if ((!$n_sjs_js_Thenable$Implicits$)) {
    $n_sjs_js_Thenable$Implicits$ = new $c_sjs_js_Thenable$Implicits$();
  }
  return $n_sjs_js_Thenable$Implicits$;
}
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
}
$p = $c_sjs_js_Thenable$ThenableOps$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
}
$h_sjs_js_Thenable$ThenableOps$.prototype = $p;
$p.uE = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then(((arg1$2) => {
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p2, arg1$2);
  }), $m_sjs_js_defined$().amB(((arg1$2$1) => {
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p2, ((arg1$2$1 instanceof $c_jl_Throwable) ? arg1$2$1 : new $c_sjs_js_JavaScriptException(arg1$2$1)));
  })));
  return p2;
});
var $d_sjs_js_Thenable$ThenableOps$ = new $TypeData().i($c_sjs_js_Thenable$ThenableOps$, "scala.scalajs.js.Thenable$ThenableOps$", ({
  Bv: 1
}));
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$();
  }
  return $n_sjs_js_Thenable$ThenableOps$;
}
/** @constructor */
function $c_sjs_js_ThisFunction$() {
}
$p = $c_sjs_js_ThisFunction$.prototype = new $h_O();
$p.constructor = $c_sjs_js_ThisFunction$;
/** @constructor */
function $h_sjs_js_ThisFunction$() {
}
$h_sjs_js_ThisFunction$.prototype = $p;
$p.aud = (function(f) {
  return (function() {
    return f.p(this);
  });
});
var $d_sjs_js_ThisFunction$ = new $TypeData().i($c_sjs_js_ThisFunction$, "scala.scalajs.js.ThisFunction$", ({
  Bw: 1
}));
var $n_sjs_js_ThisFunction$;
function $m_sjs_js_ThisFunction$() {
  if ((!$n_sjs_js_ThisFunction$)) {
    $n_sjs_js_ThisFunction$ = new $c_sjs_js_ThisFunction$();
  }
  return $n_sjs_js_ThisFunction$;
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.abI = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.abI = Object.prototype.hasOwnProperty;
}
$p = $c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $p;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().i($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  By: 1
}));
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
/** @constructor */
function $c_sjs_js_defined$() {
}
$p = $c_sjs_js_defined$.prototype = new $h_O();
$p.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
$h_sjs_js_defined$.prototype = $p;
$p.amB = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $TypeData().i($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  Bz: 1
}));
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
/** @constructor */
function $c_sjs_js_timers_package$() {
}
$p = $c_sjs_js_timers_package$.prototype = new $h_O();
$p.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
$h_sjs_js_timers_package$.prototype = $p;
$p.gb = (function(interval, body) {
  return setTimeout((() => {
    body.aA();
  }), interval);
});
$p.afT = (function(handle) {
  clearTimeout(handle);
});
$p.Vq = (function(interval, body) {
  return setInterval((() => {
    body.aA();
  }), interval);
});
$p.ane = (function(handle) {
  clearInterval(handle);
});
var $d_sjs_js_timers_package$ = new $TypeData().i($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  BA: 1
}));
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
/** @constructor */
function $c_sjsr_package$() {
}
$p = $c_sjsr_package$.prototype = new $h_O();
$p.constructor = $c_sjsr_package$;
/** @constructor */
function $h_sjsr_package$() {
}
$h_sjsr_package$.prototype = $p;
$p.Vb = (function(array) {
  var len = array.a.length;
  var result = [];
  var i = 0;
  while ((i !== len)) {
    var x1 = i;
    result.push(array.a[x1]);
    i = ((1 + i) | 0);
  }
  return result;
});
var $d_sjsr_package$ = new $TypeData().i($c_sjsr_package$, "scala.scalajs.runtime.package$", ({
  BF: 1
}));
var $n_sjsr_package$;
function $m_sjsr_package$() {
  if ((!$n_sjsr_package$)) {
    $n_sjsr_package$ = new $c_sjsr_package$();
  }
  return $n_sjsr_package$;
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.Su = null;
  this.Su = init;
}
$p = $c_s_util_DynamicVariable.prototype = new $h_O();
$p.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
}
$h_s_util_DynamicVariable.prototype = $p;
$p.g = (function() {
  return (("DynamicVariable(" + this.Su) + ")");
});
var $d_s_util_DynamicVariable = new $TypeData().i($c_s_util_DynamicVariable, "scala.util.DynamicVariable", ({
  BG: 1
}));
/** @constructor */
function $c_s_util_Sorting$() {
}
$p = $c_s_util_Sorting$.prototype = new $h_O();
$p.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
}
$h_s_util_Sorting$.prototype = $p;
$p.en = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0);
  }
  if ((ord.bM($m_sr_ScalaRunTime$().cZ(a, i0), $m_sr_ScalaRunTime$().cZ(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().cZ(a, i0);
    $m_sr_ScalaRunTime$().bQ(a, i0, $m_sr_ScalaRunTime$().cZ(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().bQ(a, ((1 + i0) | 0), temp);
  }
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().cZ(a, ((i0 + m) | 0));
    if ((ord.bM(next, $m_sr_ScalaRunTime$().cZ(a, ((((i0 + m) | 0) - 1) | 0))) < 0)) {
      var iA = i0;
      var iB = ((((i0 + m) | 0) - 1) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if ((ord.bM(next, $m_sr_ScalaRunTime$().cZ(a, ix)) < 0)) {
          iB = ix;
        } else {
          iA = ix;
        }
      }
      var ix$2 = ((iA + ((ord.bM(next, $m_sr_ScalaRunTime$().cZ(a, iA)) >= 0) | 0)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().bQ(a, i, $m_sr_ScalaRunTime$().cZ(a, ((i - 1) | 0)));
        i = ((i - 1) | 0);
      }
      $m_sr_ScalaRunTime$().bQ(a, ix$2, next);
    }
    m = ((1 + m) | 0);
  }
});
$p.cK = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.en(a, i0, iN, ord);
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? evidence$2.fb(((iK - i0) | 0)) : scratch);
    this.cK(a, i0, iK, ord, sc, evidence$2);
    this.cK(a, iK, iN, ord, sc, evidence$2);
    this.eo(a, i0, iK, iN, ord, sc);
  }
});
$p.eo = (function(a, i0, iK, iN, ord, scratch) {
  if ((ord.bM($m_sr_ScalaRunTime$().cZ(a, ((iK - 1) | 0)), $m_sr_ScalaRunTime$().cZ(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().bQ(scratch, j, $m_sr_ScalaRunTime$().cZ(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0);
    }
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if ((ord.bM($m_sr_ScalaRunTime$().cZ(a, i), $m_sr_ScalaRunTime$().cZ(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().bQ(a, k, $m_sr_ScalaRunTime$().cZ(a, i));
        i = ((1 + i) | 0);
      } else {
        $m_sr_ScalaRunTime$().bQ(a, k, $m_sr_ScalaRunTime$().cZ(scratch, j));
        j = ((1 + j) | 0);
      }
      k = ((1 + k) | 0);
    }
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().bQ(a, k, $m_sr_ScalaRunTime$().cZ(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0);
    }
  }
});
$p.axG = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!a.a[i])) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < n)) {
    a.a[((from + i) | 0)] = false;
    i = ((1 + i) | 0);
  }
  while ((((from + i) | 0) < until)) {
    a.a[((from + i) | 0)] = true;
    i = ((1 + i) | 0);
  }
});
$p.Jd = (function(a, from, until, evidence$4) {
  $m_s_math_Ordering$();
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().b1(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering");
    }
    $m_ju_Arrays$().ayb(a, from, until, evidence$4);
  } else if ((a instanceof $ac_I)) {
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().ay8(a, from, until);
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var sc = new $ac_I(((iK - from) | 0));
        if ((((iK - from) | 0) < 32)) {
          this.en(a, from, iK, evidence$4);
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.cK(a, from, iK$1, evidence$4, sc, evidence$2);
          this.cK(a, iK$1, iK, evidence$4, sc, evidence$2);
          this.eo(a, from, iK$1, iK, evidence$4, sc);
        }
        if ((((until - iK) | 0) < 32)) {
          this.en(a, iK, until, evidence$4);
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.cK(a, iK, iK$2, evidence$4, sc, evidence$2);
          this.cK(a, iK$2, until, evidence$4, sc, evidence$2);
          this.eo(a, iK, iK$2, until, evidence$4, sc);
        }
        this.eo(a, from, iK, until, evidence$4, sc);
      }
    }
  } else if ((a instanceof $ac_D)) {
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.en(a, from, until, evidence$4);
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var sc$1 = new $ac_D(((iK$3 - from) | 0));
      if ((((iK$3 - from) | 0) < 32)) {
        this.en(a, from, iK$3, evidence$4);
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.cK(a, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.cK(a, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.eo(a, from, iK$4, iK$3, evidence$4, sc$1);
      }
      if ((((until - iK$3) | 0) < 32)) {
        this.en(a, iK$3, until, evidence$4);
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.cK(a, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.cK(a, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.eo(a, iK$3, iK$5, until, evidence$4, sc$1);
      }
      this.eo(a, from, iK$3, until, evidence$4, sc$1);
    }
  } else if ((a instanceof $ac_J)) {
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().ay9(a, from, until);
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var sc$2 = new $ac_J(((iK$6 - from) | 0));
        if ((((iK$6 - from) | 0) < 32)) {
          this.en(a, from, iK$6, evidence$4);
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.cK(a, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.cK(a, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.eo(a, from, iK$7, iK$6, evidence$4, sc$2);
        }
        if ((((until - iK$6) | 0) < 32)) {
          this.en(a, iK$6, until, evidence$4);
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.cK(a, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.cK(a, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.eo(a, iK$6, iK$8, until, evidence$4, sc$2);
        }
        this.eo(a, from, iK$6, until, evidence$4, sc$2);
      }
    }
  } else if ((a instanceof $ac_F)) {
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.en(a, from, until, evidence$4);
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var sc$3 = new $ac_F(((iK$9 - from) | 0));
      if ((((iK$9 - from) | 0) < 32)) {
        this.en(a, from, iK$9, evidence$4);
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.cK(a, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.cK(a, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.eo(a, from, iK$10, iK$9, evidence$4, sc$3);
      }
      if ((((until - iK$9) | 0) < 32)) {
        this.en(a, iK$9, until, evidence$4);
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.cK(a, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.cK(a, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.eo(a, iK$9, iK$11, until, evidence$4, sc$3);
      }
      this.eo(a, from, iK$9, until, evidence$4, sc$3);
    }
  } else if ((a instanceof $ac_C)) {
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().ay7(a, from, until);
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var sc$4 = new $ac_C(((iK$12 - from) | 0));
        if ((((iK$12 - from) | 0) < 32)) {
          this.en(a, from, iK$12, evidence$4);
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.cK(a, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.cK(a, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.eo(a, from, iK$13, iK$12, evidence$4, sc$4);
        }
        if ((((until - iK$12) | 0) < 32)) {
          this.en(a, iK$12, until, evidence$4);
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.cK(a, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.cK(a, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.eo(a, iK$12, iK$14, until, evidence$4, sc$4);
        }
        this.eo(a, from, iK$12, until, evidence$4, sc$4);
      }
    }
  } else if ((a instanceof $ac_B)) {
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().ay6(a, from, until);
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var sc$5 = new $ac_B(((iK$15 - from) | 0));
        if ((((iK$15 - from) | 0) < 32)) {
          this.en(a, from, iK$15, evidence$4);
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.cK(a, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.cK(a, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.eo(a, from, iK$16, iK$15, evidence$4, sc$5);
        }
        if ((((until - iK$15) | 0) < 32)) {
          this.en(a, iK$15, until, evidence$4);
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.cK(a, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.cK(a, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.eo(a, iK$15, iK$17, until, evidence$4, sc$5);
        }
        this.eo(a, from, iK$15, until, evidence$4, sc$5);
      }
    }
  } else if ((a instanceof $ac_S)) {
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().aya(a, from, until);
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var sc$6 = new $ac_S(((iK$18 - from) | 0));
        if ((((iK$18 - from) | 0) < 32)) {
          this.en(a, from, iK$18, evidence$4);
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.cK(a, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.cK(a, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.eo(a, from, iK$19, iK$18, evidence$4, sc$6);
        }
        if ((((until - iK$18) | 0) < 32)) {
          this.en(a, iK$18, until, evidence$4);
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.cK(a, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.cK(a, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.eo(a, iK$18, iK$20, until, evidence$4, sc$6);
        }
        this.eo(a, from, iK$18, until, evidence$4, sc$6);
      }
    }
  } else if ((a instanceof $ac_Z)) {
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.axG(a, from, until);
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.en(a, from, until, evidence$4);
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var sc$7 = new $ac_Z(((iK$21 - from) | 0));
        if ((((iK$21 - from) | 0) < 32)) {
          this.en(a, from, iK$21, evidence$4);
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.cK(a, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.cK(a, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.eo(a, from, iK$22, iK$21, evidence$4, sc$7);
        }
        if ((((until - iK$21) | 0) < 32)) {
          this.en(a, iK$21, until, evidence$4);
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.cK(a, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.cK(a, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.eo(a, iK$21, iK$23, until, evidence$4, sc$7);
        }
        this.eo(a, from, iK$21, until, evidence$4, sc$7);
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(a);
  }
});
var $d_s_util_Sorting$ = new $TypeData().i($c_s_util_Sorting$, "scala.util.Sorting$", ({
  BH: 1
}));
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$();
  }
  return $n_s_util_Sorting$;
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  return ($m_s_util_control_NoStackTrace$().abK ? $c_jl_Throwable.prototype.zF.call($thiz) : $thiz);
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.abK = false;
  this.abK = false;
}
$p = $c_s_util_control_NoStackTrace$.prototype = new $h_O();
$p.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
}
$h_s_util_control_NoStackTrace$.prototype = $p;
var $d_s_util_control_NoStackTrace$ = new $TypeData().i($c_s_util_control_NoStackTrace$, "scala.util.control.NoStackTrace$", ({
  BJ: 1
}));
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$();
  }
  return $n_s_util_control_NoStackTrace$;
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
$p = $c_s_util_control_NonFatal$.prototype = new $h_O();
$p.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
$h_s_util_control_NonFatal$.prototype = $p;
$p.DO = (function(t) {
  matchAlts1: {
    matchAlts2: {
      if ((t instanceof $c_jl_VirtualMachineError)) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  return true;
});
$p.dV = (function(t) {
  return (this.DO(t) ? new $c_s_Some(t) : $m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $TypeData().i($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  BK: 1
}));
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
}
$p = $c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$p.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
}
$h_s_util_hashing_MurmurHash3.prototype = $p;
$p.d = (function(hash, data) {
  var h = this.kR(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$p.kR = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$p.an = (function(hash, length) {
  return this.Ja((hash ^ length));
});
$p.Ja = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$p.akh = (function(x, y, seed) {
  var h = seed;
  h = this.d(h, $f_T__hashCode__I("Tuple2"));
  h = this.d(h, x);
  h = this.d(h, y);
  return this.an(h, 2);
});
$p.au = (function(x, seed, ignorePrefix) {
  var arr = x.w();
  if ((arr === 0)) {
    return ((!ignorePrefix) ? $f_T__hashCode__I(x.A()) : seed);
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.d(h, $f_T__hashCode__I(x.A()));
    }
    var i = 0;
    while ((i < arr)) {
      h = this.d(h, $m_sr_Statics$().k(x.z(i)));
      i = ((1 + i) | 0);
    }
    return this.an(h, arr);
  }
});
$p.DS = (function(x, seed, caseClassName) {
  var arr = x.w();
  var aye = $f_T__hashCode__I(((caseClassName !== null) ? caseClassName : x.A()));
  if ((arr === 0)) {
    return aye;
  } else {
    var h = seed;
    h = this.d(h, aye);
    var i = 0;
    while ((i < arr)) {
      h = this.d(h, $m_sr_Statics$().k(x.z(i)));
      i = ((1 + i) | 0);
    }
    return this.an(h, arr);
  }
});
$p.Aa = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.l();
  while (iterator.f()) {
    var x = iterator.e();
    var h = $m_sr_Statics$().k(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0);
  }
  var h$2 = seed;
  h$2 = this.d(h$2, a);
  h$2 = this.d(h$2, b);
  h$2 = this.kR(h$2, c);
  return this.an(h$2, n);
});
$p.awG = (function(xs, seed) {
  var it = xs.l();
  var h = seed;
  if ((!it.f())) {
    return this.an(h, 0);
  }
  var x0 = it.e();
  if ((!it.f())) {
    return this.an(this.d(h, $m_sr_Statics$().k(x0)), 1);
  }
  var x1 = it.e();
  var initial = $m_sr_Statics$().k(x0);
  h = this.d(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().k(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.f()) {
    h = this.d(h, prev);
    var hash = $m_sr_Statics$().k(it.e());
    if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
      h = this.d(h, hash);
      i = ((1 + i) | 0);
      while (it.f()) {
        h = this.d(h, $m_sr_Statics$().k(it.e()));
        i = ((1 + i) | 0);
      }
      return this.an(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.Ja(this.d(this.d(h0, rangeDiff), prev));
});
$p.fk = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().b1(a);
  switch (l) {
    case 0: {
      return this.an(h, 0);
      break;
    }
    case 1: {
      return this.an(this.d(h, $m_sr_Statics$().k($m_sr_ScalaRunTime$().cZ(a, 0))), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().k($m_sr_ScalaRunTime$().cZ(a, 0));
      h = this.d(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().k($m_sr_ScalaRunTime$().cZ(a, 1));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.d(h, prev);
        var hash = $m_sr_Statics$().k($m_sr_ScalaRunTime$().cZ(a, i));
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.d(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.d(h, $m_sr_Statics$().k($m_sr_ScalaRunTime$().cZ(a, i)));
            i = ((1 + i) | 0);
          }
          return this.an(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.Ja(this.d(this.d(h0, rangeDiff), prev));
    }
  }
});
$p.aji = (function(start, step, last, seed) {
  return this.Ja(this.d(this.d(this.d(seed, start), step), last));
});
$p.auR = (function(a, seed) {
  var h = seed;
  var l = a.F();
  switch (l) {
    case 0: {
      return this.an(h, 0);
      break;
    }
    case 1: {
      return this.an(this.d(h, $m_sr_Statics$().k(a.at(0))), 1);
      break;
    }
    default: {
      var initial = $m_sr_Statics$().k(a.at(0));
      h = this.d(h, initial);
      var h0 = h;
      var prev = $m_sr_Statics$().k(a.at(1));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.d(h, prev);
        var hash = $m_sr_Statics$().k(a.at(i));
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.d(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.d(h, $m_sr_Statics$().k(a.at(i)));
            i = ((1 + i) | 0);
          }
          return this.an(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.Ja(this.d(this.d(h0, rangeDiff), prev));
    }
  }
});
$p.aw1 = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.c())) {
    var head = elems.W();
    var tail = elems.ak();
    var hash = $m_sr_Statics$().k(head);
    h = this.d(h, hash);
    switch (rangeState) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break;
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break;
      }
      case 2: {
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          rangeState = 3;
        }
        break;
      }
    }
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail;
  }
  return ((rangeState === 2) ? this.aji(initial, rangeDiff, prev, seed) : this.an(h, n));
});
/** @constructor */
function $c_Lscalatags_Escaping$() {
  this.abL = null;
  $n_Lscalatags_Escaping$ = this;
  this.abL = $m_sc_StringOps$().Va("^[a-z][:\\w0-9-]*$");
}
$p = $c_Lscalatags_Escaping$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_Escaping$;
/** @constructor */
function $h_Lscalatags_Escaping$() {
}
$h_Lscalatags_Escaping$.prototype = $p;
$p.az5 = (function(s) {
  return (!this.abL.ayM(s).c());
});
$p.az4 = (function(s) {
  var len = s.length;
  if ((len === 0)) {
    return false;
  }
  var sc = s.charCodeAt(0);
  if ((!((((((sc - 97) | 0) >>> 0) <= 25) || ((((sc - 65) | 0) >>> 0) <= 25)) || (sc === 58)))) {
    return false;
  }
  var pos = 1;
  while ((pos < len)) {
    var index = pos;
    var c = s.charCodeAt(index);
    if ((!((((((((((c - 97) | 0) >>> 0) <= 25) || ((((c - 65) | 0) >>> 0) <= 25)) || ((((c - 48) | 0) >>> 0) <= 9)) || (c === 45)) || (c === 58)) || (c === 46)) || (c === 95)))) {
      return false;
    }
    pos = ((1 + pos) | 0);
  }
  return true;
});
var $d_Lscalatags_Escaping$ = new $TypeData().i($c_Lscalatags_Escaping$, "scalatags.Escaping$", ({
  BQ: 1
}));
var $n_Lscalatags_Escaping$;
function $m_Lscalatags_Escaping$() {
  if ((!$n_Lscalatags_Escaping$)) {
    $n_Lscalatags_Escaping$ = new $c_Lscalatags_Escaping$();
  }
  return $n_Lscalatags_Escaping$;
}
/** @constructor */
function $c_Lscalatags_generic_Attrs$aria$(outer) {
  this.adf = null;
  this.adg = false;
  this.ade = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ade = outer;
}
$p = $c_Lscalatags_generic_Attrs$aria$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Attrs$aria$;
/** @constructor */
function $h_Lscalatags_generic_Attrs$aria$() {
}
$h_Lscalatags_generic_Attrs$aria$.prototype = $p;
$p.atK = (function() {
  if ((!this.adg)) {
    this.adf = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this.ade, "aria-expanded", null, false);
    this.adg = true;
  }
  return this.adf;
});
var $d_Lscalatags_generic_Attrs$aria$ = new $TypeData().i($c_Lscalatags_generic_Attrs$aria$, "scalatags.generic.Attrs$aria$", ({
  C6: 1
}));
/** @constructor */
function $c_Lscalatags_generic_Namespace$() {
  this.eG = null;
  $n_Lscalatags_generic_Namespace$ = this;
  this.eG = new $c_Lscalatags_generic_Namespace$$anon$1();
}
$p = $c_Lscalatags_generic_Namespace$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Namespace$;
/** @constructor */
function $h_Lscalatags_generic_Namespace$() {
}
$h_Lscalatags_generic_Namespace$.prototype = $p;
var $d_Lscalatags_generic_Namespace$ = new $TypeData().i($c_Lscalatags_generic_Namespace$, "scalatags.generic.Namespace$", ({
  Cg: 1
}));
var $n_Lscalatags_generic_Namespace$;
function $m_Lscalatags_generic_Namespace$() {
  if ((!$n_Lscalatags_generic_Namespace$)) {
    $n_Lscalatags_generic_Namespace$ = new $c_Lscalatags_generic_Namespace$();
  }
  return $n_Lscalatags_generic_Namespace$;
}
function $p_Lujson_BaseCharRenderer$__appendIntString0__I__I__AC__I($thiz, i0, index, arr) {
  var i = i0;
  var q = 0;
  var r = 0;
  var charPos = index;
  var negative = (i < 0);
  if ((!negative)) {
    i = ((-i) | 0);
  }
  while ((i <= (-100))) {
    q = ((i / 100) | 0);
    r = ((Math.imul(100, q) - i) | 0);
    i = q;
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = $thiz.LK.a[r];
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = $thiz.LL.a[r];
  }
  q = ((i / 10) | 0);
  r = ((Math.imul(10, q) - i) | 0);
  charPos = ((charPos - 1) | 0);
  arr.a[charPos] = (65535 & ((48 + r) | 0));
  if ((q < 0)) {
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = (65535 & ((48 - q) | 0));
  }
  if (negative) {
    charPos = ((charPos - 1) | 0);
    arr.a[charPos] = 45;
  }
  return charPos;
}
function $p_Lujson_BaseCharRenderer$__appendLongString0__J__I__AC__I($thiz, i0_$_lo, i0_$_hi, index, buf) {
  var i_$_lo = i0_$_lo;
  var i_$_hi = i0_$_hi;
  var q_$_lo = 0;
  var q_$_hi = 0;
  var r = 0;
  var charPos = index;
  var x_$_lo = i_$_lo;
  var x_$_hi = i_$_hi;
  var negative = (x_$_hi < 0);
  if ((!negative)) {
    var x$1_$_lo = i_$_lo;
    var x$1_$_hi = i_$_hi;
    var lo = ((-x$1_$_lo) | 0);
    var hi = ((((-x$1_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    i_$_lo = lo;
    i_$_hi = hi;
  }
  while (true) {
    var x$2_$_lo = i_$_lo;
    var x$2_$_hi = i_$_hi;
    if (((x$2_$_hi === (-1)) ? ((x$2_$_lo >>> 0) <= 2147483648) : (x$2_$_hi < (-1)))) {
      var num_$_lo = i_$_lo;
      var num_$_hi = i_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 100) | 0);
      var k = ((rhi - Math.imul(100, quotHi)) | 0);
      var quotLo = ((0.010000000000000004 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$1 = ((-quotLo) | 0);
        var hi$1 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        q_$_lo = lo$1;
        q_$_hi = hi$1;
      } else {
        q_$_lo = quotLo;
        q_$_hi = quotHi;
      }
      var x$4_$_lo = q_$_lo;
      var x$4_$_hi = q_$_hi;
      r = ((((Math.imul(100, (65535 & x$4_$_lo)) + (Math.imul(100, ((x$4_$_lo >>> 16) | 0)) << 16)) | 0) - i_$_lo) | 0);
      i_$_lo = q_$_lo;
      i_$_hi = q_$_hi;
      charPos = ((charPos - 1) | 0);
      buf.a[charPos] = $thiz.LK.a[r];
      charPos = ((charPos - 1) | 0);
      buf.a[charPos] = $thiz.LL.a[r];
    } else {
      break;
    }
  }
  var q2 = 0;
  var i2 = i_$_lo;
  while ((i2 <= (-100))) {
    q2 = ((i2 / 100) | 0);
    r = ((Math.imul(100, q2) - i2) | 0);
    i2 = q2;
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = $thiz.LK.a[r];
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = $thiz.LL.a[r];
  }
  q2 = ((i2 / 10) | 0);
  r = ((Math.imul(10, q2) - i2) | 0);
  charPos = ((charPos - 1) | 0);
  buf.a[charPos] = (65535 & ((48 + r) | 0));
  if ((q2 < 0)) {
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = (65535 & ((48 - q2) | 0));
  }
  if (negative) {
    charPos = ((charPos - 1) | 0);
    buf.a[charPos] = 45;
  }
  return charPos;
}
function $p_Lujson_BaseCharRenderer$__appendNull0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 110;
  arr.a[((1 + arrOffset) | 0)] = 117;
  arr.a[((2 + arrOffset) | 0)] = 108;
  arr.a[((3 + arrOffset) | 0)] = 108;
}
function $p_Lujson_BaseCharRenderer$__appendTrue0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 116;
  arr.a[((1 + arrOffset) | 0)] = 114;
  arr.a[((2 + arrOffset) | 0)] = 117;
  arr.a[((3 + arrOffset) | 0)] = 101;
}
function $p_Lujson_BaseCharRenderer$__appendFalse0__AC__I__V($thiz, arr, arrOffset) {
  arr.a[arrOffset] = 102;
  arr.a[((1 + arrOffset) | 0)] = 97;
  arr.a[((2 + arrOffset) | 0)] = 108;
  arr.a[((3 + arrOffset) | 0)] = 115;
  arr.a[((4 + arrOffset) | 0)] = 101;
}
function $p_Lujson_BaseCharRenderer$__appendKnownAsciiString0__AC__I__jl_CharSequence__I__V($thiz, arr, arrOffset, s, sLength) {
  var i = 0;
  while ((i < sLength)) {
    arr.a[((arrOffset + i) | 0)] = $dp_charAt__I__C(s, i);
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Lujson_BaseCharRenderer$() {
  this.LL = null;
  this.LK = null;
  $n_Lujson_BaseCharRenderer$ = this;
  this.LL = $constArrRaw_C(100, "l44D4474l44D4474l44D4474l4HD4874m4HD4874m4HD4874m4HD4@74n4XD4@74n4XD4@74n4XD4@74o4lD4D74o4lD4D74o4lD4D74o44E4H74p44E4H74p44E4H74p44E4L74q4HE4L74q4HE4L74q4HE4L74r4XE4P74r4XE4P74r4XE4P74r4lE4T74s4lE4T74s4lE4T74s4lE4X74t44F4X74t44F4X74t44F4X74u4HF4`74u4HF4`74u4HF4`74u444");
  this.LK = $constArrRaw_C(100, "l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u44D4874n4lD4H74q4XE4T74t4HF4474m4XD4D74p4HE4P74s44F4`74l4HD4@74o44E4L74r4lE4X74u444");
}
$p = $c_Lujson_BaseCharRenderer$.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$;
/** @constructor */
function $h_Lujson_BaseCharRenderer$() {
}
$h_Lujson_BaseCharRenderer$.prototype = $p;
$p.ayL = (function(arr, length, i0) {
  var i = i0;
  arr.a[length] = 10;
  while ((i > 0)) {
    arr.a[((length + i) | 0)] = 32;
    i = ((i - 1) | 0);
  }
});
$p.ayI = (function(eb, i0) {
  var size = $m_Lupickle_core_RenderUtils$().avf(i0);
  var newLength = ((eb.be + size) | 0);
  eb.im(size);
  $p_Lujson_BaseCharRenderer$__appendIntString0__I__I__AC__I(this, i0, newLength, eb.dr);
  eb.be = newLength;
});
$p.aki = (function(eb, i0_$_lo, i0_$_hi) {
  var size = $m_Lupickle_core_RenderUtils$().aw6(i0_$_lo, i0_$_hi);
  var newLength = ((eb.be + size) | 0);
  eb.im(size);
  $p_Lujson_BaseCharRenderer$__appendLongString0__J__I__AC__I(this, i0_$_lo, i0_$_hi, newLength, eb.dr);
  eb.be = newLength;
});
$p.ayJ = (function(eb) {
  eb.im(4);
  $p_Lujson_BaseCharRenderer$__appendNull0__AC__I__V(this, eb.dr, eb.be);
  eb.be = ((4 + eb.be) | 0);
});
$p.ayK = (function(eb) {
  eb.im(4);
  $p_Lujson_BaseCharRenderer$__appendTrue0__AC__I__V(this, eb.dr, eb.be);
  eb.be = ((4 + eb.be) | 0);
});
$p.ayH = (function(eb) {
  eb.im(5);
  $p_Lujson_BaseCharRenderer$__appendFalse0__AC__I__V(this, eb.dr, eb.be);
  eb.be = ((5 + eb.be) | 0);
});
$p.VJ = (function(eb, s) {
  var sLength = $dp_length__I(s);
  eb.im(sLength);
  $p_Lujson_BaseCharRenderer$__appendKnownAsciiString0__AC__I__jl_CharSequence__I__V(this, eb.dr, eb.be, s, sLength);
  eb.be = ((eb.be + sLength) | 0);
});
var $d_Lujson_BaseCharRenderer$ = new $TypeData().i($c_Lujson_BaseCharRenderer$, "ujson.BaseCharRenderer$", ({
  Cu: 1
}));
var $n_Lujson_BaseCharRenderer$;
function $m_Lujson_BaseCharRenderer$() {
  if ((!$n_Lujson_BaseCharRenderer$)) {
    $n_Lujson_BaseCharRenderer$ = new $c_Lujson_BaseCharRenderer$();
  }
  return $n_Lujson_BaseCharRenderer$;
}
/** @constructor */
function $c_Lujson_MathUtilsChar$() {
}
$p = $c_Lujson_MathUtilsChar$.prototype = new $h_O();
$p.constructor = $c_Lujson_MathUtilsChar$;
/** @constructor */
function $h_Lujson_MathUtilsChar$() {
}
$h_Lujson_MathUtilsChar$.prototype = $p;
$p.akd = (function(bytes, index, s) {
  var len = s.length;
  var i = 0;
  while ((i < len)) {
    bytes.a[((index + i) | 0)] = s.charCodeAt(i);
    i = ((1 + i) | 0);
  }
  return len;
});
var $d_Lujson_MathUtilsChar$ = new $TypeData().i($c_Lujson_MathUtilsChar$, "ujson.MathUtilsChar$", ({
  CB: 1
}));
var $n_Lujson_MathUtilsChar$;
function $m_Lujson_MathUtilsChar$() {
  if ((!$n_Lujson_MathUtilsChar$)) {
    $n_Lujson_MathUtilsChar$ = new $c_Lujson_MathUtilsChar$();
  }
  return $n_Lujson_MathUtilsChar$;
}
function $f_Lupickle_core_BufferingCharParser__$init$__V($thiz) {
  $thiz.tM = null;
  var $x_1 = $thiz;
  $x_1.I4 = 0;
  $x_1.I5 = 0;
  $thiz.ol = 0;
  $thiz.kB = 0;
  $thiz.HA = 0;
  $thiz.om = 2147483647;
}
function $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C($thiz, i) {
  return $thiz.tM.a[((i - $thiz.ol) | 0)];
}
function $f_Lupickle_core_BufferingCharParser__requestUntil__I__Z($thiz, until) {
  return ((until >= $thiz.kB) && ((until >= $thiz.om) || $p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until)));
}
function $f_Lupickle_core_BufferingCharParser__requestUntilGetSafeIndex__I__I($thiz, until) {
  return ((until < $thiz.kB) ? $thiz.kB : ((until >= $thiz.om) ? $thiz.om : ($p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until) ? $thiz.om : $thiz.kB)));
}
function $p_Lupickle_core_BufferingCharParser__requestUntil0__I__Z($thiz, until) {
  var bufferOffset = (($thiz.kB - $thiz.ol) | 0);
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var x1 = $thiz.ax2($thiz.tM, bufferOffset);
    if ((x1 !== null)) {
      var \u03b41$___1 = x1.gZ;
      var \u03b41$___2 = (!(!x1.fY));
      var \u03b41$___3 = (x1.gr | 0);
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var newBuffer$2 = \u03b41$___1;
  var newDone$2 = (!(!\u03b41$___2));
  var n$2 = (\u03b41$___3 | 0);
  $thiz.tM = newBuffer$2;
  if ((n$2 !== (-1))) {
    $thiz.kB = (($thiz.kB + n$2) | 0);
  }
  if (newDone$2) {
    $thiz.om = $thiz.kB;
  }
  return newDone$2;
}
function $f_Lupickle_core_BufferingCharParser__normalizeIndex__I__I($thiz, i) {
  if (($thiz.ol > 1073741824)) {
    var shift = $thiz.ol;
    var $x_1 = $thiz;
    var x_$_lo = $x_1.I4;
    var x_$_hi = $x_1.I5;
    var hi = (shift >> 31);
    var lo = ((x_$_lo + shift) | 0);
    var hi$1 = ((((x_$_hi + hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
    var $x_2 = $thiz;
    $x_2.I4 = lo;
    $x_2.I5 = hi$1;
    $thiz.kB = (($thiz.kB - shift) | 0);
    $thiz.HA = (($thiz.HA - shift) | 0);
    if (($thiz.om !== 2147483647)) {
      $thiz.om = (($thiz.om - shift) | 0);
    }
    $thiz.ol = 0;
    return ((i - shift) | 0);
  } else {
    return i;
  }
}
function $f_Lupickle_core_BufferingCharParser__absolutePosition__I__J($thiz, i) {
  var $x_1 = $thiz;
  var x_$_lo = $x_1.I4;
  var x_$_hi = $x_1.I5;
  var hi = (i >> 31);
  var lo = ((x_$_lo + i) | 0);
  var hi$1 = ((((x_$_hi + hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
  return $bL(lo, hi$1);
}
function $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I($thiz, i) {
  var $x_1 = $f_Lupickle_core_BufferingCharParser__absolutePosition__I__J($thiz, i);
  var absPos_$_lo = $x_1.l;
  var absPos_$_hi = $x_1.h;
  return (((absPos_$_hi === 0) ? ((absPos_$_lo >>> 0) > 2147483647) : (absPos_$_hi > 0)) ? (-1) : absPos_$_lo);
}
function $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq($thiz, start, length) {
  return new $c_Lupickle_core_WrapCharArrayCharSeq($thiz.tM, ((start - $thiz.ol) | 0), length);
}
function $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V($thiz, chars, charsStart, charsLength) {
  chars.amn($thiz.tM, ((charsStart - $thiz.ol) | 0), charsLength);
}
/** @constructor */
function $c_Lupickle_core_CharAppendC() {
}
$p = $c_Lupickle_core_CharAppendC.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharAppendC;
/** @constructor */
function $h_Lupickle_core_CharAppendC() {
}
$h_Lupickle_core_CharAppendC.prototype = $p;
/** @constructor */
function $c_Lupickle_core_CharOps$() {
}
$p = $c_Lupickle_core_CharOps$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharOps$;
/** @constructor */
function $h_Lupickle_core_CharOps$() {
}
$h_Lupickle_core_CharOps$.prototype = $p;
$p.EK = (function(c1, c2, c3) {
  return ((c2 >= c1) && (c2 <= c3));
});
var $d_Lupickle_core_CharOps$ = new $TypeData().i($c_Lupickle_core_CharOps$, "upickle.core.CharOps$", ({
  Db: 1
}));
var $n_Lupickle_core_CharOps$;
function $m_Lupickle_core_CharOps$() {
  if ((!$n_Lupickle_core_CharOps$)) {
    $n_Lupickle_core_CharOps$ = new $c_Lupickle_core_CharOps$();
  }
  return $n_Lupickle_core_CharOps$;
}
function $p_Lupickle_core_CharUtils$__appendSimpleStringSection0__AC__I__I__I__jl_CharSequence__I($thiz, arr, arrOffset, i0, len, s) {
  var i = i0;
  while (true) {
    if ((i < len)) {
      var c2 = $dp_charAt__I__C(s, i);
      if ((!(((c2 < 32) || (c2 === 34)) || (c2 === 92)))) {
        arr.a[((((arrOffset + i) | 0) - i0) | 0)] = c2;
        i = ((1 + i) | 0);
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
    } else {
      break;
    }
  }
  return ((i - 1) | 0);
}
function $p_Lupickle_core_CharUtils$__appendSimpleStringSectionNoUnicode0__AC__I__I__I__jl_CharSequence__I($thiz, arr, arrOffset, i0, len, s) {
  var i = i0;
  while (true) {
    if ((i < len)) {
      var c2 = $dp_charAt__I__C(s, i);
      if ((!((((((c2 - 32) | 0) >>> 0) > 95) || (c2 === 34)) || (c2 === 92)))) {
        arr.a[((((arrOffset + i) | 0) - i0) | 0)] = c2;
        i = ((1 + i) | 0);
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
    } else {
      break;
    }
  }
  return ((i - 1) | 0);
}
/** @constructor */
function $c_Lupickle_core_CharUtils$() {
}
$p = $c_Lupickle_core_CharUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_CharUtils$;
/** @constructor */
function $h_Lupickle_core_CharUtils$() {
}
$h_Lupickle_core_CharUtils$.prototype = $p;
$p.afH = (function(charBuilder, c, i) {
  switch (c) {
    case 34: {
      this.zE(charBuilder, i, 34);
      return true;
      break;
    }
    case 92: {
      this.zE(charBuilder, i, 92);
      return true;
      break;
    }
    case 8: {
      this.zE(charBuilder, i, 98);
      return true;
      break;
    }
    case 12: {
      this.zE(charBuilder, i, 102);
      return true;
      break;
    }
    case 10: {
      this.zE(charBuilder, i, 110);
      return true;
      break;
    }
    case 13: {
      this.zE(charBuilder, i, 114);
      return true;
      break;
    }
    case 9: {
      this.zE(charBuilder, i, 116);
      return true;
      break;
    }
    default: {
      return false;
    }
  }
});
$p.zE = (function(charBuilder, i, c) {
  charBuilder.im(2);
  var length = charBuilder.be;
  var arr = charBuilder.dr;
  arr.a[length] = 92;
  arr.a[((1 + length) | 0)] = c;
  charBuilder.be = ((2 + charBuilder.be) | 0);
});
$p.agT = (function(charBuilder, i, c) {
  charBuilder.im(6);
  var arr = charBuilder.dr;
  var length = charBuilder.be;
  arr.a[length] = 92;
  arr.a[((1 + length) | 0)] = 117;
  arr.a[((2 + length) | 0)] = $m_Lupickle_core_RenderUtils$().NB((15 & (c >> 12)));
  arr.a[((3 + length) | 0)] = $m_Lupickle_core_RenderUtils$().NB((15 & (c >> 8)));
  arr.a[((4 + length) | 0)] = $m_Lupickle_core_RenderUtils$().NB((15 & (c >> 4)));
  arr.a[((5 + length) | 0)] = $m_Lupickle_core_RenderUtils$().NB((15 & c));
  charBuilder.be = ((6 + charBuilder.be) | 0);
});
$p.amq = (function(charBuilder, i0, len, s) {
  charBuilder.im(((len - i0) | 0));
  var i = $p_Lupickle_core_CharUtils$__appendSimpleStringSection0__AC__I__I__I__jl_CharSequence__I(this, charBuilder.dr, charBuilder.be, i0, len, s);
  charBuilder.be = ((1 + ((charBuilder.be + ((i - i0) | 0)) | 0)) | 0);
  return i;
});
$p.amr = (function(charBuilder, i0, len, s) {
  charBuilder.im(((len - i0) | 0));
  var i = $p_Lupickle_core_CharUtils$__appendSimpleStringSectionNoUnicode0__AC__I__I__I__jl_CharSequence__I(this, charBuilder.dr, charBuilder.be, i0, len, s);
  charBuilder.be = ((1 + ((charBuilder.be + ((i - i0) | 0)) | 0)) | 0);
  return i;
});
$p.J3 = (function(arr, arrOffset, arrLength, decIndex, expIndex) {
  if ((expIndex === (-1))) {
    var expMul = 1;
  } else {
    var mult = 1;
    var $x_1 = this.Ng(arr, ((1 + ((arrOffset + expIndex) | 0)) | 0), ((arrOffset + arrLength) | 0));
    var e_$_lo = $x_1.l;
    var e_$_hi = $x_1.h;
    var i = 0;
    while (true) {
      var value = i;
      var hi = (value >> 31);
      if (((hi === e_$_hi) ? ((value >>> 0) < (e_$_lo >>> 0)) : (hi < e_$_hi))) {
        var value$1 = mult;
        var hi$1 = (value$1 >> 31);
        if (((hi$1 === 214748364) ? ((value$1 >>> 0) >= 3435973836) : (hi$1 > 214748364))) {
          throw new $c_Lupickle_core_Abort("expected integer");
        }
        mult = Math.imul(10, mult);
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    var expMul = mult;
  }
  var end = ((decIndex !== (-1)) ? decIndex : ((expIndex !== (-1)) ? expIndex : arrLength));
  var $x_2 = this.Ng(arr, arrOffset, ((arrOffset + end) | 0));
  var x_$_lo = $x_2.l;
  var x_$_hi = $x_2.h;
  var hi$2 = (expMul >> 31);
  var a0 = (65535 & x_$_lo);
  var a1 = ((x_$_lo >>> 16) | 0);
  var b0 = (65535 & expMul);
  var b1 = ((expMul >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(x_$_lo, hi$2) + Math.imul(x_$_hi, expMul)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if ((decIndex === (-1))) {
    var decPortion_$_lo = 0;
    var decPortion_$_hi = 0;
  } else {
    var end$2 = ((expIndex !== (-1)) ? expIndex : arrLength);
    var $x_3 = this.Ng(arr, ((1 + ((arrOffset + decIndex) | 0)) | 0), ((arrOffset + end$2) | 0));
    var x$1_$_lo = $x_3.l;
    var x$1_$_hi = $x_3.h;
    var hi$4 = (expMul >> 31);
    var a0$1 = (65535 & x$1_$_lo);
    var a1$1 = ((x$1_$_lo >>> 16) | 0);
    var b0$1 = (65535 & expMul);
    var b1$1 = ((expMul >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$5 = ((((((((Math.imul(x$1_$_lo, hi$4) + Math.imul(x$1_$_hi, expMul)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var value$2_$_lo = lo$1;
    var value$2_$_hi = hi$5;
    var i$2 = ((end$2 - ((1 + decIndex) | 0)) | 0);
    while ((i$2 > 0)) {
      var num_$_lo = value$2_$_lo;
      var num_$_hi = value$2_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 10) | 0);
      var k = ((rhi - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$2 = ((-quotLo) | 0);
        var hi$6 = ((((-quotHi) | 0) - ((lo$2 !== 0) | 0)) | 0);
        value$2_$_lo = lo$2;
        value$2_$_hi = hi$6;
      } else {
        value$2_$_lo = quotLo;
        value$2_$_hi = quotHi;
      }
      i$2 = ((i$2 - 1) | 0);
    }
    if ((arr.a[arrOffset] === 45)) {
      var x$3_$_lo = value$2_$_lo;
      var x$3_$_hi = value$2_$_hi;
      var lo$3 = ((-x$3_$_lo) | 0);
      var hi$7 = ((((-x$3_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var decPortion_$_lo = lo$3;
      var decPortion_$_hi = hi$7;
    } else {
      var decPortion_$_lo = value$2_$_lo;
      var decPortion_$_hi = value$2_$_hi;
    }
  }
  var lo$4 = ((lo + decPortion_$_lo) | 0);
  var hi$8 = ((((hi$3 + decPortion_$_hi) | 0) + (((lo$4 >>> 0) < (lo >>> 0)) | 0)) | 0);
  return $bL(lo$4, hi$8);
});
$p.Ng = (function(cs0, start0, end0) {
  if (((((start0 | end0) | ((end0 - start0) | 0)) | ((cs0.a.length - end0) | 0)) < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var cs = new $ac_C(((end0 - start0) | 0));
  var length = ((end0 - start0) | 0);
  cs0.av(start0, cs, 0, length);
  var inverseSum_$_lo = 0;
  var inverseSum_$_hi = 0;
  var inverseSign_$_lo = (-1);
  var inverseSign_$_hi = (-1);
  var i = 0;
  var end = ((end0 - start0) | 0);
  if ((cs.a[0] === 45)) {
    inverseSign_$_lo = 1;
    inverseSign_$_hi = 0;
    i = ((1 + i) | 0);
  }
  var size = ((end - i) | 0);
  if (((((size - 1) | 0) >>> 0) > 18)) {
    throw new $c_jl_NumberFormatException($m_jl_String$().hg(cs, 0, cs.a.length));
  }
  while ((i < end)) {
    var digit = ((cs.a[i] - 48) | 0);
    if (((digit >>> 0) > 9)) {
      throw new $c_jl_NumberFormatException($m_jl_String$().hg(cs, 0, cs.a.length));
    }
    var x_$_lo = inverseSum_$_lo;
    var x_$_hi = inverseSum_$_hi;
    var b0 = (65535 & x_$_lo);
    var b1 = ((x_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(10, b0);
    var a0b1 = Math.imul(10, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((Math.imul(10, x_$_hi) + ((c1part >>> 16) | 0)) | 0);
    var hi$1 = (digit >> 31);
    var lo$1 = ((lo - digit) | 0);
    var hi$2 = ((((hi - hi$1) | 0) - (((lo$1 >>> 0) > (lo >>> 0)) | 0)) | 0);
    inverseSum_$_lo = lo$1;
    inverseSum_$_hi = hi$2;
    i = ((1 + i) | 0);
  }
  if ((size === 19)) {
    var x$1_$_lo = inverseSum_$_lo;
    var x$1_$_hi = inverseSum_$_hi;
    if ((x$1_$_hi >= 0)) {
      var $x_1 = true;
    } else {
      var x$2_$_lo = inverseSum_$_lo;
      var x$2_$_hi = inverseSum_$_hi;
      if (((x$2_$_lo | ((-2147483648) ^ x$2_$_hi)) === 0)) {
        var x$3_$_lo = inverseSign_$_lo;
        var x$3_$_hi = inverseSign_$_hi;
        var $x_1 = (x$3_$_hi < 0);
      } else {
        var $x_1 = false;
      }
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw new $c_jl_NumberFormatException($m_jl_String$().hg(cs, 0, cs.a.length));
  }
  var x$4_$_lo = inverseSum_$_lo;
  var x$4_$_hi = inverseSum_$_hi;
  var x$5_$_lo = inverseSign_$_lo;
  var x$5_$_hi = inverseSign_$_hi;
  var a0 = (65535 & x$4_$_lo);
  var a1 = ((x$4_$_lo >>> 16) | 0);
  var b0$1 = (65535 & x$5_$_lo);
  var b1$1 = ((x$5_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(a0, b0$1);
  var a1b0 = Math.imul(a1, b0$1);
  var a0b1$1 = Math.imul(a0, b1$1);
  var lo$2 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul(x$4_$_lo, x$5_$_hi) + Math.imul(x$4_$_hi, x$5_$_lo)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo$2, hi$3);
});
var $d_Lupickle_core_CharUtils$ = new $TypeData().i($c_Lupickle_core_CharUtils$, "upickle.core.CharUtils$", ({
  Dc: 1
}));
var $n_Lupickle_core_CharUtils$;
function $m_Lupickle_core_CharUtils$() {
  if ((!$n_Lupickle_core_CharUtils$)) {
    $n_Lupickle_core_CharUtils$ = new $c_Lupickle_core_CharUtils$();
  }
  return $n_Lupickle_core_CharUtils$;
}
/** @constructor */
function $c_Lupickle_core_ParseUtils$() {
}
$p = $c_Lupickle_core_ParseUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_ParseUtils$;
/** @constructor */
function $h_Lupickle_core_ParseUtils$() {
}
$h_Lupickle_core_ParseUtils$.prototype = $p;
$p.J2 = (function(s, decIndex, expIndex, index) {
  var arr = $f_T__toCharArray__AC($dp_toString__T(s));
  return $m_Lupickle_core_CharUtils$().J3(arr, 0, arr.a.length, decIndex, expIndex);
});
$p.awJ = (function(cs, start, end) {
  return $m_Lupickle_core_CharUtils$().Ng($f_T__toCharArray__AC($dp_toString__T(cs)), start, end);
});
var $d_Lupickle_core_ParseUtils$ = new $TypeData().i($c_Lupickle_core_ParseUtils$, "upickle.core.ParseUtils$", ({
  Dj: 1
}));
var $n_Lupickle_core_ParseUtils$;
function $m_Lupickle_core_ParseUtils$() {
  if ((!$n_Lupickle_core_ParseUtils$)) {
    $n_Lupickle_core_ParseUtils$ = new $c_Lupickle_core_ParseUtils$();
  }
  return $n_Lupickle_core_ParseUtils$;
}
/** @constructor */
function $c_Lupickle_core_RenderUtils$() {
  this.adq = null;
  $n_Lupickle_core_RenderUtils$ = this;
  var arr = new $ac_I(128);
  var i = 0;
  while ((i < 10)) {
    arr.a[((48 + i) | 0)] = i;
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < 16)) {
    arr.a[((97 + i) | 0)] = ((10 + i) | 0);
    arr.a[((65 + i) | 0)] = ((10 + i) | 0);
    i = ((1 + i) | 0);
  }
  this.adq = arr;
}
$p = $c_Lupickle_core_RenderUtils$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_RenderUtils$;
/** @constructor */
function $h_Lupickle_core_RenderUtils$() {
}
$h_Lupickle_core_RenderUtils$.prototype = $p;
$p.MS = (function(i) {
  return this.adq.a[i];
});
$p.NB = (function(nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0));
});
$p.agS = (function(unicodeCharBuilder, sb, s, escapeUnicode, wrapQuotes) {
  var len = $dp_length__I(s);
  if (wrapQuotes) {
    sb.eP(34);
  }
  return this.atA(0, len, sb, s, escapeUnicode, wrapQuotes);
});
$p.atA = (function(i0, len, sb, s, escapeUnicode, wrapQuotes) {
  var i = i0;
  if (escapeUnicode) {
    while ((i < len)) {
      var c = $dp_charAt__I__C(s, i);
      if ((!$m_Lupickle_core_CharUtils$().afH(sb, c, i))) {
        if (((((c - 32) | 0) >>> 0) > 95)) {
          $m_Lupickle_core_CharUtils$().agT(sb, i, c);
        } else {
          i = $m_Lupickle_core_CharUtils$().amr(sb, i, len, s);
        }
      }
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < len)) {
      var c$2 = $dp_charAt__I__C(s, i);
      if ((!$m_Lupickle_core_CharUtils$().afH(sb, c$2, i))) {
        if ((c$2 < 32)) {
          $m_Lupickle_core_CharUtils$().agT(sb, i, c$2);
        } else {
          i = $m_Lupickle_core_CharUtils$().amq(sb, i, len, s);
        }
      }
      i = ((1 + i) | 0);
    }
  }
  if (wrapQuotes) {
    sb.eP(34);
  }
  return sb;
});
$p.avf = (function(x0) {
  var x = x0;
  var d = 1;
  if ((x >= 0)) {
    d = 0;
    x = ((-x) | 0);
  }
  var p = (-10);
  var i = 1;
  while ((i <= 10)) {
    if ((x > p)) {
      return ((i + d) | 0);
    }
    p = Math.imul(10, p);
    i = ((1 + i) | 0);
  }
  return ((10 + d) | 0);
});
$p.aw6 = (function(x0_$_lo, x0_$_hi) {
  var x_$_lo = x0_$_lo;
  var x_$_hi = x0_$_hi;
  var d = 1;
  var x$1_$_lo = x_$_lo;
  var x$1_$_hi = x_$_hi;
  if ((x$1_$_hi >= 0)) {
    d = 0;
    var x$2_$_lo = x_$_lo;
    var x$2_$_hi = x_$_hi;
    var lo = ((-x$2_$_lo) | 0);
    var hi = ((((-x$2_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    x_$_lo = lo;
    x_$_hi = hi;
  }
  var p_$_lo = (-10);
  var p_$_hi = (-1);
  var i = 1;
  while ((i <= 18)) {
    var x$3_$_lo = x_$_lo;
    var x$3_$_hi = x_$_hi;
    var x$4_$_lo = p_$_lo;
    var x$4_$_hi = p_$_hi;
    if (((x$3_$_hi === x$4_$_hi) ? ((x$3_$_lo >>> 0) > (x$4_$_lo >>> 0)) : (x$3_$_hi > x$4_$_hi))) {
      return ((i + d) | 0);
    }
    var x$5_$_lo = p_$_lo;
    var x$5_$_hi = p_$_hi;
    var b0 = (65535 & x$5_$_lo);
    var b1 = ((x$5_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(10, b0);
    var a0b1 = Math.imul(10, b1);
    var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(10, x$5_$_hi) + ((c1part >>> 16) | 0)) | 0);
    p_$_lo = lo$1;
    p_$_hi = hi$1;
    i = ((1 + i) | 0);
  }
  return ((19 + d) | 0);
});
var $d_Lupickle_core_RenderUtils$ = new $TypeData().i($c_Lupickle_core_RenderUtils$, "upickle.core.RenderUtils$", ({
  Dl: 1
}));
var $n_Lupickle_core_RenderUtils$;
function $m_Lupickle_core_RenderUtils$() {
  if ((!$n_Lupickle_core_RenderUtils$)) {
    $n_Lupickle_core_RenderUtils$ = new $c_Lupickle_core_RenderUtils$();
  }
  return $n_Lupickle_core_RenderUtils$;
}
function $p_Lupickle_core_TraceVisitor$HasPath__components__sci_List($thiz) {
  return $p_Lupickle_core_TraceVisitor$HasPath__listPath$1__s_Option__sci_List__sci_List($thiz, $thiz.Nf(), new $c_sci_$colon$colon($thiz, $m_sci_Nil$()));
}
function $f_Lupickle_core_TraceVisitor$HasPath__path__T($thiz) {
  return ("$" + $f_sc_IterableOnceOps__mkString__T__T__T__T(new $c_sc_Iterator$$anon$9(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => (("[" + _$2) + "]"))), new $c_sc_Iterator$$anon$10(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => _$1.V7())), $p_Lupickle_core_TraceVisitor$HasPath__components__sci_List($thiz).l())), "", "", ""));
}
function $p_Lupickle_core_TraceVisitor$HasPath__listPath$1__s_Option__sci_List__sci_List($thiz, o, list) {
  var list$tailLocal1 = list;
  var o$tailLocal1 = o;
  while (true) {
    var x5 = o$tailLocal1;
    if ((x5 instanceof $c_s_Some)) {
      var p = x5.bg;
      var o$tailLocal1$tmp1 = p.Nf();
      var list$tailLocal1$tmp1 = new $c_sci_$colon$colon(p, list$tailLocal1);
      o$tailLocal1 = o$tailLocal1$tmp1;
      list$tailLocal1 = list$tailLocal1$tmp1;
      continue;
    }
    if (($m_s_None$() === x5)) {
      return list$tailLocal1;
    }
    throw new $c_s_MatchError(x5);
  }
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor$Wrapper() {
  this.Dt = null;
  this.Dt = $m_Lupickle_core_TraceVisitor$RootHasPath$();
}
$p = $c_Lupickle_core_TraceVisitor$Wrapper.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$Wrapper;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$Wrapper() {
}
$h_Lupickle_core_TraceVisitor$Wrapper.prototype = $p;
var $d_Lupickle_core_TraceVisitor$Wrapper = new $TypeData().i($c_Lupickle_core_TraceVisitor$Wrapper, "upickle.core.TraceVisitor$Wrapper", ({
  Ds: 1
}));
function $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor($thiz, taggedReader, index) {
  throw new $c_Lupickle_core_Abort("expected dictionary");
}
/** @constructor */
function $c_Lupickle_core_Types$ReadWriter$(outer) {
  this.oo = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.oo = outer;
}
$p = $c_Lupickle_core_Types$ReadWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$ReadWriter$;
/** @constructor */
function $h_Lupickle_core_Types$ReadWriter$() {
}
$h_Lupickle_core_Types$ReadWriter$.prototype = $p;
$p.aQ = (function(r0, w0) {
  matchResult1: {
    var $x_1;
    if (($is_Lupickle_core_Types$TaggedReader(r0) && (r0.VP() === this.oo))) {
      if (($is_Lupickle_core_Types$TaggedWriter(w0) && (w0.NF() === this.oo))) {
        var $x_1 = new $c_Lupickle_core_Types$$anon$2(r0, w0, w0, this);
        break matchResult1;
      }
    }
    var $x_1 = new $c_Lupickle_core_Types$$anon$3(r0, w0, this);
  }
  return $x_1;
});
var $d_Lupickle_core_Types$ReadWriter$ = new $TypeData().i($c_Lupickle_core_Types$ReadWriter$, "upickle.core.Types$ReadWriter$", ({
  Dx: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$Reader$(outer) {
  this.LR = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.LR = outer;
}
$p = $c_Lupickle_core_Types$Reader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$Reader$;
/** @constructor */
function $h_Lupickle_core_Types$Reader$() {
}
$h_Lupickle_core_Types$Reader$.prototype = $p;
$p.kP = (function(tagKey, readers0) {
  if ((!readers0.g8(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => $is_Lupickle_core_Types$TaggedReader(_$3)))))) {
    $m_sr_Scala3RunTime$().Mk(("Can only merge Readers of case classes, not " + readers0.bC(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => $is_Lupickle_core_Types$TaggedReader(_$4))))));
  }
  return new $c_Lupickle_core_Types$TaggedReader$Node(this.LR.aq(), tagKey, readers0);
});
var $d_Lupickle_core_Types$Reader$ = new $TypeData().i($c_Lupickle_core_Types$Reader$, "upickle.core.Types$Reader$", ({
  Dy: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$(outer) {
  this.HV = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.HV = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$() {
}
$h_Lupickle_core_Types$TaggedReader$.prototype = $p;
var $d_Lupickle_core_Types$TaggedReader$ = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$, "upickle.core.Types$TaggedReader$", ({
  DB: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$(outer) {
  this.HW = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.HW = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$() {
}
$h_Lupickle_core_Types$TaggedWriter$.prototype = $p;
var $d_Lupickle_core_Types$TaggedWriter$ = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$, "upickle.core.Types$TaggedWriter$", ({
  DE: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$Writer$(outer) {
  this.T0 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.T0 = outer;
}
$p = $c_Lupickle_core_Types$Writer$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$Writer$;
/** @constructor */
function $h_Lupickle_core_Types$Writer$() {
}
$h_Lupickle_core_Types$Writer$.prototype = $p;
$p.kQ = (function(writers) {
  if ((!writers.g8(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => $is_Lupickle_core_Types$TaggedWriter(_$5)))))) {
    $m_sr_Scala3RunTime$().Mk(("Can only merge Writers of case classes, not " + writers.bC(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => $is_Lupickle_core_Types$TaggedWriter(_$6))))));
  }
  return new $c_Lupickle_core_Types$TaggedWriter$Node(this.T0.afo(), writers);
});
var $d_Lupickle_core_Types$Writer$ = new $TypeData().i($c_Lupickle_core_Types$Writer$, "upickle.core.Types$Writer$", ({
  DH: 1
}));
function $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O($thiz, s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $thiz.cu($m_jl_String$().hg(s, arrOffset, arrLength), decIndex, expIndex, index);
}
/** @constructor */
function $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension(outer, r) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension;
/** @constructor */
function $h_Lupickle_implicits_MacroImplicits$ReadWriterExtension() {
}
$h_Lupickle_implicits_MacroImplicits$ReadWriterExtension.prototype = $p;
var $d_Lupickle_implicits_MacroImplicits$ReadWriterExtension = new $TypeData().i($c_Lupickle_implicits_MacroImplicits$ReadWriterExtension, "upickle.implicits.MacroImplicits$ReadWriterExtension", ({
  E0: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$JavaReader$(outer) {
  this.aew = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aew = outer;
}
$p = $c_Lupickle_implicits_Readers$JavaReader$.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$JavaReader$;
/** @constructor */
function $h_Lupickle_implicits_Readers$JavaReader$() {
}
$h_Lupickle_implicits_Readers$JavaReader$.prototype = $p;
$p.uo = (function(evidence$1) {
  return new $c_Lupickle_implicits_Readers$JavaReader(this.aew, evidence$1);
});
$p.g = (function() {
  return "JavaReader";
});
var $d_Lupickle_implicits_Readers$JavaReader$ = new $TypeData().i($c_Lupickle_implicits_Readers$JavaReader$, "upickle.implicits.Readers$JavaReader$", ({
  Et: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$JavaWriter$(outer) {
  this.afb = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.afb = outer;
}
$p = $c_Lupickle_implicits_Writers$JavaWriter$.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$JavaWriter$;
/** @constructor */
function $h_Lupickle_implicits_Writers$JavaWriter$() {
}
$h_Lupickle_implicits_Writers$JavaWriter$.prototype = $p;
$p.up = (function(evidence$1) {
  return new $c_Lupickle_implicits_Writers$JavaWriter(this.afb, evidence$1);
});
$p.g = (function() {
  return "JavaWriter";
});
var $d_Lupickle_implicits_Writers$JavaWriter$ = new $TypeData().i($c_Lupickle_implicits_Writers$JavaWriter$, "upickle.implicits.Writers$JavaWriter$", ({
  EX: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_ImageUploadS$() {
  this.Tm = 0;
  this.Tn = 0;
  $n_Lcom_papasofokli_ImageUploadS$ = this;
  this.Tm = 10485760;
  this.Tn = 0;
  new $c_sci_$colon$colon("image/png", new $c_sci_$colon$colon("image/jpg", new $c_sci_$colon$colon("image/jpeg", new $c_sci_$colon$colon("application/pdf", new $c_sci_$colon$colon("message/rfc822", $m_sci_Nil$())))));
}
$p = $c_Lcom_papasofokli_ImageUploadS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_ImageUploadS$;
/** @constructor */
function $h_Lcom_papasofokli_ImageUploadS$() {
}
$h_Lcom_papasofokli_ImageUploadS$.prototype = $p;
var $d_Lcom_papasofokli_ImageUploadS$ = new $TypeData().i($c_Lcom_papasofokli_ImageUploadS$, "com.papasofokli.ImageUploadS$", ({
  jk: 1,
  jp: 1
}));
var $n_Lcom_papasofokli_ImageUploadS$;
function $m_Lcom_papasofokli_ImageUploadS$() {
  if ((!$n_Lcom_papasofokli_ImageUploadS$)) {
    $n_Lcom_papasofokli_ImageUploadS$ = new $c_Lcom_papasofokli_ImageUploadS$();
  }
  return $n_Lcom_papasofokli_ImageUploadS$;
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__assignSortableSettings__Lcom_papasofokli_agileboard_AgileBoardListSetupData__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, setupData, ec) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec);
  var allULists = $f_sc_IterableOnceOps__mkString__T__T__T__T(setupData.hl.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2) => {
    if (b$2.gg) {
      var $x_1 = b$2;
      return ("#" + $s_RTLong__toString__I__I__T($x_1.gC, $x_1.gD));
    } else {
      return "";
    }
  }))), "", ",", "");
  var $x_10 = (0, $m_Lcom_papasofokli_jquery_package$().I)(allULists);
  var update$1 = (function(_$2$3, _$3$3) {
    multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var liSeq = setupData.hl.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2$1) => {
        var $x_5 = $m_Lcom_papasofokli_jquery_package$().I;
        var $x_4 = b$2$1;
        var $x_3 = $x_5((("#" + $s_RTLong__toString__I__I__T($x_4.gC, $x_4.gD)) + " > li"));
        var array = $x_3.toArray();
        var len = (array.length | 0);
        var res = new Array(len);
        var i = 0;
        while ((i < len)) {
          var $x_7 = i;
          var x0 = array[i];
          $m_sc_StringOps$();
          var $x_6 = $m_jl_Long$().V5(x0.id, 10);
          res[$x_7] = $x_6;
          i = ((1 + i) | 0);
        }
        var $x_8 = b$2$1;
        return new $c_Lcom_papasofokli_agileboard_RequestBoardData($x_8.gC, $x_8.gD, $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res)));
      })));
      var this$21 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(setupData.uL.g());
      var $x_9 = $m_Lupickle_default$();
      $m_Lupickle_default$();
      $m_Lupickle_default$();
      $m_Lupickle_default$();
      var this$19 = $m_Lupickle_default$();
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_9, liSeq, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_RequestBoardData$().q(), this$19));
      $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$21, id.g(), data, ec);
      $p_Lcom_papasofokli_agileboard_AgileBoardJs$__updateCounts$1__Lcom_papasofokli_agileboard_AgileBoardListSetupData__V($thiz, setupData);
    })));
  });
  var $x_2 = $x_10.sortable(new ($a_Lcom_papasofokli_jquery_SortableSettings())((void 0), (void 0), (void 0), update$1, ".connectList", (void 0), ".sortable-blocked-item", ".sorting-initialize"));
  return $x_2.disableSelection();
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__reloadBoardData__T__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, setupFunctionId, clickFunctionId, boardItemStyle, ec) {
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, ec);
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(setupFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => ((x$1$3) => {
    var reloadData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_agileboard_AgileBoardListSetupData$().q());
    reloadData.hl.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((brd$2) => {
      var uList = ((boardItemStyle === $thiz.NI) ? $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createSingleBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, brd$2, clickFunctionId, ec) : (brd$2.iz ? $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createTaskManagerBoardItems__Lcom_papasofokli_agileboard_BoardData__T__sci_Seq__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, brd$2, clickFunctionId, reloadData.qS, ec) : $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, brd$2, clickFunctionId, ec)));
      var $x_6 = $m_Lcom_papasofokli_jquery_package$().I;
      var $x_5 = brd$2;
      var $x_4 = $x_6((("#" + $s_RTLong__toString__I__I__T($x_5.gC, $x_5.gD)) + "UlDiv"));
      var $x_3 = $x_4.children();
      var $x_2 = $x_3.remove();
      var $x_1 = $x_2.end();
      return $x_1.append(uList.aB());
    })));
    $p_Lcom_papasofokli_agileboard_AgileBoardJs$__assignSortableSettings__Lcom_papasofokli_agileboard_AgileBoardListSetupData__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, reloadData, ec);
  }))(text$2)), ec))), ec))), ec).hj(new $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2(freezePage), ec);
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createBoard__Lcom_papasofokli_agileboard_BoardData__T__T__T__sci_Seq__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLDivElement($thiz, data, columnSizeStyle, clickFunctionId, boardItemStyle, dropdownData, ec) {
  var uList = ((boardItemStyle === $thiz.NI) ? $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createSingleBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, data, clickFunctionId, ec).aB() : (data.iz ? $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createTaskManagerBoardItems__Lcom_papasofokli_agileboard_BoardData__T__sci_Seq__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, data, clickFunctionId, dropdownData, ec).aB() : $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, data, clickFunctionId, ec).aB()));
  var bgBodyColor = (data.iz ? "bg-body-tertiary rounded" : "bg-body");
  var $x_11 = $m_Lscalatags_JsDom$all$().as();
  var $x_10 = $m_Lscalatags_JsDom$all$().D().n(("" + columnSizeStyle), $m_Lscalatags_JsDom$all$().s);
  var $x_9 = $m_Lscalatags_JsDom$all$().as();
  var $x_8 = $m_Lscalatags_JsDom$all$().D();
  var this$6 = data.kX;
  var $x_7 = $x_8.n(((("ibox-content agile-item-sm agile-item-md agile-item-lg agile-item-xl agile-item-xxl " + bgBodyColor) + " ") + (this$6.c() ? "" : this$6.h())), $m_Lscalatags_JsDom$all$().s);
  var $x_6 = $m_Lscalatags_JsDom$all$().ahE();
  var $x_5 = $m_Lscalatags_JsDom$all$().D().n("text-start padding-left-10px", $m_Lscalatags_JsDom$all$().s);
  $m_Lscalatags_JsDom$all$();
  var $x_4 = new $c_Lscalatags_JsDom$StringFrag((data.qT + " "));
  if ((!data.jE.c())) {
    var $x_3 = $m_Lscalatags_JsDom$all$().bk();
    var $x_2 = $m_Lscalatags_JsDom$all$().D().n("count-box", $m_Lscalatags_JsDom$all$().s);
    $m_Lscalatags_JsDom$all$();
    var this$11 = data.jE;
    var $x_1 = $x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_2, new $c_Lscalatags_JsDom$StringFrag((this$11.c() ? "" : this$11.h()))]));
  } else {
    $m_Lscalatags_JsDom$all$();
    var $x_1 = new $c_Lscalatags_JsDom$StringFrag("");
  }
  return $x_11.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_10, $x_9.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $x_6.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_5, $x_4, $x_1])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(($s_RTLong__toString__I__I__T(data.gC, data.gD) + "UlDiv"), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), uList)]))]))])).aB();
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, board, clickFunctionId, ec) {
  var cond = board.gg;
  var connectedListClass = (cond ? new $c_s_Some("connectList") : $m_s_None$());
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("sortable-list  " + (connectedListClass.c() ? "" : connectedListClass.h())) + " agile-list ui-sortable agile-board-table"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(("" + $s_RTLong__toString__I__I__T(board.gC, board.gD)), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), board.kY.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((item$2) => {
    var this$6 = item$2.gh;
    if (this$6.c()) {
      var statusElement = $m_s_None$();
    } else {
      var x0 = this$6.h();
      var statusElement = new $c_s_Some($m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((x0.V() + " float-end"), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x0.P()))])));
    }
    var this$12 = item$2.jG;
    if (this$12.c()) {
      var assigneeElement = $m_s_None$();
    } else {
      var x0$2 = this$12.h();
      var assigneeElement = new $c_s_Some($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("float-end", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((" " + $m_Lcom_papasofokli_util_IconUI$().QB.by), $m_Lscalatags_JsDom$all$().s)])), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag((" " + x0$2)))])));
    }
    if ((item$2.hR || (!board.gg))) {
      var $x_1 = true;
    } else {
      var this$21 = item$2.gh;
      if ((!this$21.c())) {
        var x0$5 = this$21.h();
        var x = x0$5.P();
        var $x_1 = ((x !== null) && $dp_equals__O__Z(x, "Not Arrived"));
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      var movable = "";
    } else {
      var movable = "sorting-initialize";
    }
    var blockedIcon = ((item$2.hR || (!board.gg)) ? $m_Lcom_papasofokli_util_IconUI$().Qz.by : "");
    var buttonId = $m_ju_UUID$().aW().g();
    var $x_33 = $m_Lscalatags_JsDom$all$().he();
    var $x_32 = $m_Lscalatags_JsDom$all$().D().n((((item$2.p2 + " ") + movable) + " ui-sortable-handle agile-board-item"), $m_Lscalatags_JsDom$all$().s);
    var $x_31 = $m_Lscalatags_JsDom$all$().bE();
    var $x_30 = item$2;
    var $x_29 = $x_31.n(("" + $s_RTLong__toString__I__I__T($x_30.hE, $x_30.hF)), $m_Lscalatags_JsDom$all$().s);
    var $x_28 = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(blockedIcon, $m_Lscalatags_JsDom$all$().s)]));
    var $x_27 = (statusElement.c() ? ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")) : statusElement.h());
    var $x_26 = $m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("agile-board-type", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.mT))]));
    var $x_25 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [(assigneeElement.c() ? ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")) : assigneeElement.h())]));
    var $x_24 = $m_Lscalatags_JsDom$all$().ez();
    var $x_23 = $m_Lscalatags_JsDom$all$().as();
    var $x_22 = $m_Lscalatags_JsDom$all$().D().n("agile-board-detail", $m_Lscalatags_JsDom$all$().s);
    var $x_21 = $m_Lscalatags_JsDom$all$().ij();
    var $x_20 = $m_Lscalatags_JsDom$all$().IL().n("#", $m_Lscalatags_JsDom$all$().s);
    var $x_19 = $m_Lscalatags_JsDom$all$().D().n("text-decoration-none", $m_Lscalatags_JsDom$all$().s);
    var $x_18 = new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), item$2.iA.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name$2) => $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(name$2, $m_Lscalatags_JsDom$all$().s)]))))), $m_s_$less$colon$less$().b0);
    $m_Lscalatags_JsDom$all$();
    var $x_17 = new $c_Lscalatags_JsDom$StringFrag((" " + item$2.l1));
    var $x_16 = $m_Lscalatags_JsDom$all$().fc();
    var $x_15 = item$2;
    var $x_14 = $x_24.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_23.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_22, $x_21.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_20, $x_19, $x_18, $x_17, $x_16.n($p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemOnClick__J__T__T__s_concurrent_ExecutionContext__F1($thiz, $x_15.hE, $x_15.hF, clickFunctionId, $thiz.NK, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))]))]))]));
    var $x_13 = ((!item$2.eJ.c()) ? $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$p_Lcom_papasofokli_agileboard_AgileBoardJs$__handleAdditionalDataDiv__Lcom_papasofokli_agileboard_BoardElement__Lscalatags_JsDom$TypedTag($thiz, item$2)])) : ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")));
    var $x_12 = $m_Lscalatags_JsDom$all$().ez();
    var $x_11 = $m_Lscalatags_JsDom$all$().D().n("d-flex align-items-center", $m_Lscalatags_JsDom$all$().s);
    var $x_10 = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("me-2 " + (($m_sc_StringOps$(), (item$2.jH !== "")) ? $m_Lcom_papasofokli_util_IconUI$().KA.by : "")) + " d-flex justify-content-center align-items-center"), $m_Lscalatags_JsDom$all$().s)]));
    var $x_9 = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("flex-fill", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.jH))]));
    matchResult7: {
      var $x_2;
      var x7 = item$2.jF;
      if ((x7 instanceof $c_s_Some)) {
        var label = x7.bg;
        var $x_8 = $m_Lscalatags_JsDom$all$().qC();
        var $x_7 = $m_Lscalatags_JsDom$all$().bE().n(buttonId, $m_Lscalatags_JsDom$all$().s);
        var $x_6 = $m_Lscalatags_JsDom$all$().D().n("float-end btn btn-sm btn-primary text-white", $m_Lscalatags_JsDom$all$().s);
        $m_Lscalatags_JsDom$all$();
        var $x_5 = new $c_Lscalatags_JsDom$StringFrag(label);
        var $x_4 = $m_Lscalatags_JsDom$all$().fc();
        var $x_3 = item$2;
        var $x_2 = $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $x_6, $x_5, $x_4.n($p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemBtnOnClick__T__J__T__T__s_concurrent_ExecutionContext__F1($thiz, buttonId, $x_3.hE, $x_3.hF, clickFunctionId, $thiz.NM, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]));
        break matchResult7;
      }
      if (($m_s_None$() === x7)) {
        $m_Lscalatags_JsDom$all$();
        var $x_2 = new $c_Lscalatags_JsDom$StringFrag("");
        break matchResult7;
      }
      throw new $c_s_MatchError(x7);
    }
    return $x_33.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_32, $x_29, $x_28, $x_27, $x_26, $x_25, $x_14, $x_13, $x_12.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_11, $x_10, $x_9, $x_2]))]));
  }))), $m_s_$less$colon$less$().b0)]));
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createTaskManagerBoardItems__Lcom_papasofokli_agileboard_BoardData__T__sci_Seq__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, board, clickFunctionId, dropdownOptions, ec) {
  var cond = board.gg;
  var connectedListClass = (cond ? new $c_s_Some("connectList") : $m_s_None$());
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("sortable-list  " + (connectedListClass.c() ? "" : connectedListClass.h())) + " agile-list agile-list-task ui-sortable agile-board-table"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(("" + $s_RTLong__toString__I__I__T(board.gC, board.gD)), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), board.kY.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((item$2) => {
    var this$7 = item$2.gh;
    if (this$7.c()) {
      var statusElement = $m_s_None$();
    } else {
      var x0 = this$7.h();
      var statusElement = new $c_s_Some($m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((x0.V() + " float-end"), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x0.P()))])));
    }
    var this$13 = item$2.jG;
    if (this$13.c()) {
      var assigneeElement = $m_s_None$();
    } else {
      var x0$2 = this$13.h();
      var assigneeElement = new $c_s_Some($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("float-end", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((" " + $m_Lcom_papasofokli_util_IconUI$().QB.by), $m_Lscalatags_JsDom$all$().s)])), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag((" " + x0$2)))])));
    }
    var movable = ((item$2.hR || (!board.gg)) ? "" : "sorting-initialize");
    var blockedIcon = ((item$2.hR || (!board.gg)) ? $m_Lcom_papasofokli_util_IconUI$().Qz.by : "");
    var buttonId = $m_ju_UUID$().aW().g();
    var ddOptions = dropdownOptions.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((item$1) => ((dd$2) => new $c_T5(dd$2.uN, buttonId, $bL(item$1.hE, item$1.hF), clickFunctionId, dd$2.uM.g())))(item$2)));
    var $x_22 = $m_Lscalatags_JsDom$all$().he();
    var $x_21 = $m_Lscalatags_JsDom$all$().D().n((movable + " ui-sortable-handle agile-board-item bg-body"), $m_Lscalatags_JsDom$all$().s);
    var $x_20 = $m_Lscalatags_JsDom$all$().bE();
    var $x_19 = item$2;
    var $x_18 = $x_20.n(("" + $s_RTLong__toString__I__I__T($x_19.hE, $x_19.hF)), $m_Lscalatags_JsDom$all$().s);
    var $x_17 = $m_Lcom_papasofokli_buttons_DropdownButtonJs$().auf(ddOptions, ec);
    var $x_16 = $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(blockedIcon, $m_Lscalatags_JsDom$all$().s)]));
    var $x_15 = (statusElement.c() ? ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")) : statusElement.h());
    var $x_14 = $m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("agile-board-type", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), item$2.iA.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name$2) => $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(name$2, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().A1().n("test", $m_Lscalatags_JsDom$all$().s)]))))), $m_s_$less$colon$less$().b0), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("  ")), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.mT))]));
    var $x_13 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [(assigneeElement.c() ? ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")) : assigneeElement.h())]));
    var $x_12 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex align-items-center", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("me-2 " + (($m_sc_StringOps$(), (item$2.l1 !== "")) ? $m_Lcom_papasofokli_util_IconUI$().a8D.by : "")) + " d-flex justify-content-center align-items-center"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("flex-fill", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.l1))]))]));
    var $x_11 = $m_Lscalatags_JsDom$all$().ez();
    var $x_10 = $m_Lscalatags_JsDom$all$().D().n("d-flex align-items-center", $m_Lscalatags_JsDom$all$().s);
    var $x_9 = $m_Lscalatags_JsDom$all$().bk();
    var $x_8 = $m_Lscalatags_JsDom$all$().D();
    var this$55 = item$2.hS;
    var this$57 = (this$55.c() ? $m_s_None$() : new $c_s_Some(this$55.h().gZ));
    var $x_7 = $x_8.n(("badge rounded-pill " + (this$57.c() ? "" : this$57.h())), $m_Lscalatags_JsDom$all$().s);
    var this$61 = $m_Lscalatags_JsDom$all$();
    var this$58 = item$2.hS;
    var $x_6 = $x_11.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_10, $x_9.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode(this$61, (this$58.c() ? $m_s_None$() : new $c_s_Some(this$58.h().fY)), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$1) => {
      $m_Lscalatags_JsDom$all$();
      return new $c_Lscalatags_JsDom$StringFrag(v$2$1);
    })))]))]));
    var $x_5 = $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex align-items-center", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("me-2 " + (($m_sc_StringOps$(), (item$2.jH !== "")) ? $m_Lcom_papasofokli_util_IconUI$().KA.by : "")) + " d-flex justify-content-center align-items-center"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("flex-fill", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.jH))]))]));
    var $x_4 = ((!item$2.eJ.c()) ? $m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$p_Lcom_papasofokli_agileboard_AgileBoardJs$__handleAdditionalDataDiv__Lcom_papasofokli_agileboard_BoardElement__Lscalatags_JsDom$TypedTag($thiz, item$2)])) : ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("")));
    var this$85 = item$2.hS;
    if ((!(this$85.c() ? $m_s_None$() : this$85.h().gr).c())) {
      var $x_3 = $m_Lscalatags_JsDom$all$().bk();
      var $x_2 = $m_Lscalatags_JsDom$all$().D().n("task-type-and-cancel-comment", $m_Lscalatags_JsDom$all$().s);
      $m_Lscalatags_JsDom$all$();
      var this$88 = item$2.hS;
      var $x_1 = $x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_2, new $c_Lscalatags_JsDom$StringFrag(("CANCELLED: " + (this$88.c() ? $m_s_None$() : this$88.h().gr).h()))]));
    } else {
      $m_Lscalatags_JsDom$all$();
      var $x_1 = new $c_Lscalatags_JsDom$StringFrag("");
    }
    return $x_22.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_21, $x_18, $x_17, $x_16, $x_15, $x_14, $x_13, $x_12, $x_6, $x_5, $x_4, $x_1, $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("flex-fill", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("Created on " + item$2.kZ.h())))]))]));
  }))), $m_s_$less$colon$less$().b0)]));
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__handleAdditionalDataDiv__Lcom_papasofokli_agileboard_BoardElement__Lscalatags_JsDom$TypedTag($thiz, element) {
  if ((element.eJ.F() > 1)) {
    return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), element.eJ.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var iconName = x$1$2.P();
        var info = x$1$2.V();
        return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(iconName, $m_Lscalatags_JsDom$all$().s)])), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("  " + info)))]));
      }
      throw new $c_s_MatchError(x$1$2);
    }))), $m_s_$less$colon$less$().b0)]));
  } else {
    var $x_4 = $m_Lscalatags_JsDom$all$().as();
    var $x_3 = $m_Lscalatags_JsDom$all$().c6();
    var $x_2 = $m_Lscalatags_JsDom$all$().D();
    var this$15 = element.eJ.bj();
    var this$17 = (this$15.c() ? $m_s_None$() : new $c_s_Some(this$15.h().P()));
    var $x_1 = $x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_2.n((this$17.c() ? $m_Lcom_papasofokli_util_IconUI$().t6.by : this$17.h()), $m_Lscalatags_JsDom$all$().s)]));
    $m_Lscalatags_JsDom$all$();
    var this$21 = element.eJ.bj();
    var this$23 = (this$21.c() ? $m_s_None$() : new $c_s_Some(this$21.h().V()));
    return $x_4.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_1, new $c_Lscalatags_JsDom$StringFrag(("  " + (this$23.c() ? "N/A" : this$23.h())))]));
  }
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createSingleBoardItems__Lcom_papasofokli_agileboard_BoardData__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, board, clickFunctionId, ec) {
  var cond = board.gg;
  var dragDropClasses = (cond ? new $c_s_Some("sortable-list connectList ui-sortable") : $m_s_None$());
  var cond$1 = board.gg;
  var dragDropInnerClass = (cond$1 ? new $c_s_Some("ui-sortable-handle") : $m_s_None$());
  var hasInstructions = board.kY.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$11$2) => (!_$11$2.jI.c()))));
  var orderTypeColumnStyle = (hasInstructions ? "col-md-2 col-sm-2 agile-item-col" : "col-md-4 col-sm-4 agile-item-col");
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(((dragDropClasses.c() ? "" : dragDropClasses.h()) + " agile-list padding-right-5px"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bE().n(("" + $s_RTLong__toString__I__I__T(board.gC, board.gD)), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(board.kY, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$12$2) => _$12$2.qU)), $m_s_math_Ordering$BigDecimal$()).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((item$2) => {
    if ((item$2.hR || (!board.gg))) {
      var $x_1 = true;
    } else {
      var this$13 = item$2.gh;
      if ((!this$13.c())) {
        var x0 = this$13.h();
        var x = x0.P();
        var $x_1 = ((x !== null) && $dp_equals__O__Z(x, "Not Arrived"));
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      var movable = "";
    } else {
      var movable = "sorting-initialize";
    }
    var this$14 = item$2.gh;
    if (this$14.c()) {
      var statusElement = $m_s_None$();
    } else {
      var x0$1 = this$14.h();
      var statusElement = new $c_s_Some($m_Lscalatags_JsDom$all$().zZ().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((x0$1.V() + " float-left"), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x0$1.P()))])));
    }
    var cond$2 = item$2.hR;
    var informationColorCss = (cond$2 ? new $c_s_Some("bg-danger") : $m_s_None$());
    var this$22 = item$2.gh;
    if ((!this$22.c())) {
      var x0$3 = this$22.h();
      $m_sc_StringOps$();
      var statusDefined = (x0$3.P() !== "");
    } else {
      var statusDefined = false;
    }
    var rowTopMargin = ((item$2.eJ.F() > 2) ? "margin-top-20px" : "margin-top-15px");
    var buttonId = $m_ju_UUID$().aW().g();
    var $x_36 = $m_Lscalatags_JsDom$all$().he();
    var $x_35 = $m_Lscalatags_JsDom$all$().D().n((((((item$2.p2 + " ") + movable) + " ") + (dragDropInnerClass.c() ? "" : dragDropInnerClass.h())) + " agile-board-item single-agile-board-item agile-item-sm agile-item-md agile-item-lg agile-item-xl agile-item-xxl"), $m_Lscalatags_JsDom$all$().s);
    var $x_34 = $m_Lscalatags_JsDom$all$().bE();
    var $x_33 = item$2;
    var $x_32 = $x_34.n(("" + $s_RTLong__toString__I__I__T($x_33.hE, $x_33.hF)), $m_Lscalatags_JsDom$all$().s);
    var $x_31 = $m_Lscalatags_JsDom$all$().as();
    var $x_30 = $m_Lscalatags_JsDom$all$().D().n("row agile-item-col", $m_Lscalatags_JsDom$all$().s);
    var $x_29 = $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), (statusDefined ? new $c_s_Some($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-md-1 col-sm-1 agile-board-status ", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), statusElement, $m_s_$less$colon$less$().b0)]))) : $m_s_None$()), $m_s_$less$colon$less$().b0);
    var $x_28 = $m_Lscalatags_JsDom$all$().as();
    var $x_27 = $m_Lscalatags_JsDom$all$().D();
    var this$46 = item$2.l0;
    var $x_26 = $x_28.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_27.n(((("col-md-2 col-sm-2 agile-item-col " + (this$46.c() ? "" : this$46.h())) + " ") + rowTopMargin), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(item$2.mT))]));
    var $x_25 = $m_Lscalatags_JsDom$all$().as();
    var $x_24 = $m_Lscalatags_JsDom$all$().D().n(((orderTypeColumnStyle + " ") + rowTopMargin), $m_Lscalatags_JsDom$all$().s);
    var $x_23 = $m_Lscalatags_JsDom$all$().ij();
    var $x_22 = $m_Lscalatags_JsDom$all$().IL().n("#", $m_Lscalatags_JsDom$all$().s);
    var $x_21 = $m_Lscalatags_JsDom$all$().D().n(("text-decoration-none " + (informationColorCss.c() ? "" : informationColorCss.h())), $m_Lscalatags_JsDom$all$().s);
    var $x_20 = new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), item$2.iA.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((name$2) => $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(name$2, $m_Lscalatags_JsDom$all$().s)]))))), $m_s_$less$colon$less$().b0);
    $m_Lscalatags_JsDom$all$();
    var $x_19 = new $c_Lscalatags_JsDom$StringFrag((" " + item$2.l1));
    var $x_18 = $m_Lscalatags_JsDom$all$().fc();
    var $x_17 = item$2;
    var $x_16 = $x_25.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_24, $x_23.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_22, $x_21, $x_20, $x_19, $x_18.n($p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemOnClick__J__T__T__s_concurrent_ExecutionContext__F1($thiz, $x_17.hE, $x_17.hF, clickFunctionId, $thiz.NK, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))]))]));
    var $x_15 = $p_Lcom_papasofokli_agileboard_AgileBoardJs$__handleSingleRowAdditionalDataDiv__Lcom_papasofokli_agileboard_BoardElement__Lscalatags_JsDom$TypedTag($thiz, item$2);
    var $x_14 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("col-md-1 col-sm-1 agile-item-col " + rowTopMargin), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().KA.by, $m_Lscalatags_JsDom$all$().s)])), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag((" " + item$2.jH)))]));
    var $x_13 = $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), (hasInstructions ? new $c_s_Some($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("col-md-2 col-sm-2 agile-item-col " + rowTopMargin), $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), item$2.jI, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$1) => {
      $m_Lscalatags_JsDom$all$();
      return new $c_Lscalatags_JsDom$StringFrag(v$2$1);
    })))]))) : $m_s_None$()), $m_s_$less$colon$less$().b0);
    var $x_12 = $m_Lscalatags_JsDom$all$().as();
    var $x_11 = $m_Lscalatags_JsDom$all$().D().n("col-md-2 col-sm-2 agile-item-col", $m_Lscalatags_JsDom$all$().s);
    var $x_10 = $m_Lscalatags_JsDom$all$().as();
    var $x_9 = $m_Lscalatags_JsDom$all$().D().n("d-grid", $m_Lscalatags_JsDom$all$().s);
    matchResult9: {
      var $x_2;
      var self = item$2.jF;
      var y = item$2.hR;
      if ((self instanceof $c_s_Some)) {
        var x21 = self.bg;
        if ((!y)) {
          var $x_8 = $m_Lscalatags_JsDom$all$().qC();
          var $x_7 = $m_Lscalatags_JsDom$all$().bE().n(buttonId, $m_Lscalatags_JsDom$all$().s);
          var $x_6 = $m_Lscalatags_JsDom$all$().D().n("float-end agile-item btn btn-primary text-white", $m_Lscalatags_JsDom$all$().s);
          var $x_5 = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x21)), $m_Lscalatags_JsDom$all$().D().n("text-center align-items-center", $m_Lscalatags_JsDom$all$().s)]));
          var $x_4 = $m_Lscalatags_JsDom$all$().fc();
          var $x_3 = item$2;
          var $x_2 = $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $x_6, $x_5, $x_4.n($p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemBtnOnClick__T__J__T__T__s_concurrent_ExecutionContext__F1($thiz, buttonId, $x_3.hE, $x_3.hF, clickFunctionId, $thiz.NM, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]));
          break matchResult9;
        }
        if (y) {
          var $x_2 = $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().IL().n("#", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("float-end agile-item btn text-decoration-none text-white bg-body-secondary", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x21)), $m_Lscalatags_JsDom$all$().D().n("d-flex justify-content-center align-items-center text-center", $m_Lscalatags_JsDom$all$().s)]))]));
          break matchResult9;
        }
      }
      $m_Lscalatags_JsDom$all$();
      var $x_2 = new $c_Lscalatags_JsDom$StringFrag("");
    }
    return $x_36.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_35, $x_32, $x_31.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_30, $x_29, $x_26, $x_16, $x_15, $x_14, $x_13, $x_12.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_11, $x_10.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_9, $x_2]))]))]))]));
  }))), $m_s_$less$colon$less$().b0)]));
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__handleSingleRowAdditionalDataDiv__Lcom_papasofokli_agileboard_BoardElement__Lscalatags_JsDom$TypedTag($thiz, element) {
  var this$1 = element.gh;
  if ((!this$1.c())) {
    var x0 = this$1.h();
    $m_sc_StringOps$();
    var statusDefined = (x0.P() !== "");
  } else {
    var statusDefined = false;
  }
  if ((element.eJ.F() > 1)) {
    var rowTopMargin = ((element.eJ.F() > 2) ? "mt-0" : "margin-top-8px");
    return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((((statusDefined ? "col-md-2 col-sm-2" : "col-md-3 col-sm-3") + " agile-item-col ") + rowTopMargin), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), element.eJ.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var iconName = x$1$2.P();
        var info = x$1$2.V();
        return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(iconName, $m_Lscalatags_JsDom$all$().s)])), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("  " + info)))]));
      }
      throw new $c_s_MatchError(x$1$2);
    }))), $m_s_$less$colon$less$().b0)]));
  } else {
    var $x_5 = $m_Lscalatags_JsDom$all$().as();
    var $x_4 = $m_Lscalatags_JsDom$all$().D().n(((statusDefined ? "col-md-2 col-sm-2" : "col-md-3 col-sm-3") + " agile-item-col margin-top-15px"), $m_Lscalatags_JsDom$all$().s);
    var $x_3 = $m_Lscalatags_JsDom$all$().c6();
    var $x_2 = $m_Lscalatags_JsDom$all$().D();
    var this$23 = element.eJ.bj();
    var this$25 = (this$23.c() ? $m_s_None$() : new $c_s_Some(this$23.h().P()));
    var $x_1 = $x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_2.n((this$25.c() ? $m_Lcom_papasofokli_util_IconUI$().t6.by : this$25.h()), $m_Lscalatags_JsDom$all$().s)]));
    $m_Lscalatags_JsDom$all$();
    var this$29 = element.eJ.bj();
    var this$31 = (this$29.c() ? $m_s_None$() : new $c_s_Some(this$29.h().V()));
    return $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4, $x_1, new $c_Lscalatags_JsDom$StringFrag(("  " + (this$31.c() ? "N/A" : this$31.h())))]));
  }
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemOnClick__J__T__T__s_concurrent_ExecutionContext__F1($thiz, itemId_$_lo, itemId_$_hi, clickFunctionId, clickType, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$18$2) => new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var id = $m_ju_UUID$().aO(clickFunctionId);
    var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_agileboard_ItemClickRequest(itemId_$_lo, itemId_$_hi, clickType), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_agileboard_ItemClickRequest$().q());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, id.g(), data, ec);
  })))));
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__boardItemBtnOnClick__T__J__T__T__s_concurrent_ExecutionContext__F1($thiz, buttonId, itemId_$_lo, itemId_$_hi, clickFunctionId, clickType, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$19$2) => {
    var jq = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + buttonId));
    jq.attr("disabled", "true");
    return new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((freezePage) => (() => {
      var this$8 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(clickFunctionId);
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_agileboard_ItemClickRequest(itemId_$_lo, itemId_$_hi, clickType), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_agileboard_ItemClickRequest$().q());
      return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$8, id.g(), data, ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rslt$2) => $m_Lcom_papasofokli_util_DelayFuture$().jj(300, 0).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        jq.attr("disabled", false);
        return freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), ec);
      })), ec))), ec).hj(new $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3(freezePage, jq), ec);
    }))(new $c_Lcom_papasofokli_util_FreezePage(500, 0, ec))));
  }));
}
function $p_Lcom_papasofokli_agileboard_AgileBoardJs$__updateCounts$1__Lcom_papasofokli_agileboard_AgileBoardListSetupData__V($thiz, setupData$2) {
  setupData$2.hl.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((board$2) => {
    var $x_4 = $m_Lcom_papasofokli_jquery_package$().I;
    var $x_3 = board$2;
    var $x_2 = $x_4((("#" + $s_RTLong__toString__I__I__T($x_3.gC, $x_3.gD)) + "UlDiv"));
    var $x_1 = $x_2.closest(".ibox-content");
    var countBox = $x_1.find(".count-box");
    var $x_8 = $m_Lcom_papasofokli_jquery_package$().I;
    var $x_7 = board$2;
    var $x_6 = $x_8((("#" + $s_RTLong__toString__I__I__T($x_7.gC, $x_7.gD)) + "UlDiv > ul > li"));
    var $x_5 = $x_6.length;
    var itemCount = ($x_5 | 0);
    return countBox.text(("" + itemCount));
  })));
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardJs$() {
  this.NL = null;
  this.NN = null;
  this.NJ = null;
  this.NI = null;
  this.NH = null;
  this.NK = null;
  this.NM = null;
  $n_Lcom_papasofokli_agileboard_AgileBoardJs$ = this;
  $f_Lcom_papasofokli_agileboard_AgileBoardT__$init$__V(this);
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardJs$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardJs$() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardJs$.prototype = $p;
$p.b7 = (function(ec) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + this.NL)).removeClass(this.NL).each(((this$2) => (function() {
    var setupFunctionId = this.getAttribute(this$2.NN);
    var clickFunctionId = this.getAttribute(this$2.NJ);
    var boardItemStyleSingleBoard = this.getAttribute(this$2.NH);
    var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, ec);
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(setupFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$1) => ((x$1$2) => {
      var setupData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$1, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_agileboard_AgileBoardListSetupData$().q());
      var columnSize = ((12 / $checkIntDivisor(setupData.hl.F())) | 0);
      var dropdownData = setupData.qS;
      var boardDivs = setupData.hl.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((brd$2) => $p_Lcom_papasofokli_agileboard_AgileBoardJs$__createBoard__Lcom_papasofokli_agileboard_BoardData__T__T__T__sci_Seq__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLDivElement(this$2, brd$2, ((Math.imul(columnSize, setupData.hl.F()) !== 12) ? "col-xs-equal" : ((setupData.hl.F() === 3) ? "col-xs-33" : ((setupData.hl.F() === 4) ? "col-xs-25" : ("col-lg-" + columnSize)))), clickFunctionId, boardItemStyleSingleBoard, dropdownData, ec))));
      (0, $m_Lcom_papasofokli_jquery_package$().I)(this).children().remove().end().append($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), boardDivs, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB());
      return $p_Lcom_papasofokli_agileboard_AgileBoardJs$__assignSortableSettings__Lcom_papasofokli_agileboard_AgileBoardListSetupData__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$2, setupData, ec);
    }))(text$2)), ec))), ec))), ec).hj(new $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1(freezePage), ec);
  }))(this));
});
$p.ax4 = (function(id, ec) {
  var divJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
  if (((divJQ.length | 0) > 0)) {
    var setupFunctionId = divJQ.attr(this.NN);
    var clickFunctionId = divJQ.attr(this.NJ);
    var boardItemStyleSingleBoard = divJQ.attr(this.NH);
    return $p_Lcom_papasofokli_agileboard_AgileBoardJs$__reloadBoardData__T__T__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, $dp_toString__T(setupFunctionId), $dp_toString__T(clickFunctionId), $dp_toString__T(boardItemStyleSingleBoard), ec);
  } else {
    return $m_s_concurrent_Future$().aE((void 0));
  }
});
var $d_Lcom_papasofokli_agileboard_AgileBoardJs$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardJs$, "com.papasofokli.agileboard.AgileBoardJs$", ({
  jq: 1,
  jx: 1
}));
var $n_Lcom_papasofokli_agileboard_AgileBoardJs$;
function $m_Lcom_papasofokli_agileboard_AgileBoardJs$() {
  if ((!$n_Lcom_papasofokli_agileboard_AgileBoardJs$)) {
    $n_Lcom_papasofokli_agileboard_AgileBoardJs$ = new $c_Lcom_papasofokli_agileboard_AgileBoardJs$();
  }
  return $n_Lcom_papasofokli_agileboard_AgileBoardJs$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$Flex$() {
  this.akD = null;
  this.akC = null;
  this.akD = "dynamic-flex";
  this.akC = "--custom-flex";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$Flex$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$Flex$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$Flex$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$Flex$.prototype = $p;
$p.oI = (function() {
  return "";
});
$p.gH = (function() {
  return "dynamic-flex";
});
$p.kG = (function() {
  return "--custom-flex";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$Flex$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$Flex$, "com.papasofokli.classes.custom.DynamicClass$Flex$", ({
  kF: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$Flex$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$Flex$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$Flex$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$Flex$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$Flex$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$Flex$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$() {
  this.akF = null;
  this.akE = null;
  this.akF = "dynamic-gradient-background";
  this.akE = "--custom-gradient-rgb";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$.prototype = $p;
$p.oI = (function() {
  return "";
});
$p.gH = (function() {
  return "dynamic-gradient-background";
});
$p.kG = (function() {
  return "--custom-gradient-rgb";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$, "com.papasofokli.classes.custom.DynamicClass$GradientBackground$", ({
  kG: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$GradientBackground$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$Height$() {
  this.akH = null;
  this.akG = null;
  this.akI = null;
  this.akH = "dynamic-height";
  this.akG = "--custom-height";
  this.akI = "data-height";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$Height$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$Height$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$Height$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$Height$.prototype = $p;
$p.gH = (function() {
  return "dynamic-height";
});
$p.kG = (function() {
  return "--custom-height";
});
$p.oI = (function() {
  return "data-height";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$Height$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$Height$, "com.papasofokli.classes.custom.DynamicClass$Height$", ({
  kH: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$Height$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$Height$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$Height$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$Height$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$Height$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$Height$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$Left$() {
  this.akK = null;
  this.akJ = null;
  this.akK = "dynamic-left";
  this.akJ = "--custom-left";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$Left$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$Left$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$Left$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$Left$.prototype = $p;
$p.oI = (function() {
  return "";
});
$p.gH = (function() {
  return "dynamic-left";
});
$p.kG = (function() {
  return "--custom-left";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$Left$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$Left$, "com.papasofokli.classes.custom.DynamicClass$Left$", ({
  kI: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$Left$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$Left$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$Left$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$Left$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$Left$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$Left$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$() {
  this.akM = null;
  this.akL = null;
  this.akN = null;
  this.akM = "dynamic-margin-left";
  this.akL = "--custom-margin-left";
  this.akN = "data-margin-left";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$.prototype = $p;
$p.gH = (function() {
  return "dynamic-margin-left";
});
$p.kG = (function() {
  return "--custom-margin-left";
});
$p.oI = (function() {
  return "data-margin-left";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$, "com.papasofokli.classes.custom.DynamicClass$MarginLeft$", ({
  kJ: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$MarginLeft$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$() {
  this.akP = null;
  this.akO = null;
  this.akQ = null;
  this.akP = "dynamic-max-width";
  this.akO = "--custom-max-width";
  this.akQ = "data-max-width";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$.prototype = $p;
$p.gH = (function() {
  return "dynamic-max-width";
});
$p.kG = (function() {
  return "--custom-max-width";
});
$p.oI = (function() {
  return "data-max-width";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$, "com.papasofokli.classes.custom.DynamicClass$MaxWidth$", ({
  kK: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$() {
  this.akS = null;
  this.akR = null;
  this.akS = "dynamic-min-width";
  this.akR = "--custom-min-width";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$.prototype = $p;
$p.oI = (function() {
  return "";
});
$p.gH = (function() {
  return "dynamic-min-width";
});
$p.kG = (function() {
  return "--custom-min-width";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$, "com.papasofokli.classes.custom.DynamicClass$MinWidth$", ({
  kL: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$() {
  this.akU = null;
  this.akT = null;
  this.akV = null;
  this.akU = "dynamic-rgb-background";
  this.akT = "--custom-rgb";
  this.akV = "data-custom-rgb";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$.prototype = $p;
$p.gH = (function() {
  return "dynamic-rgb-background";
});
$p.kG = (function() {
  return "--custom-rgb";
});
$p.oI = (function() {
  return "data-custom-rgb";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$, "com.papasofokli.classes.custom.DynamicClass$RgbBackground$", ({
  kM: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$RgbBackground$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$() {
  this.akX = null;
  this.akW = null;
  this.akY = null;
  this.akX = "dynamic-text-color";
  this.akW = "--custom-text-color";
  this.akY = "data-text-color";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$.prototype = $p;
$p.gH = (function() {
  return "dynamic-text-color";
});
$p.kG = (function() {
  return "--custom-text-color";
});
$p.oI = (function() {
  return "data-text-color";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$, "com.papasofokli.classes.custom.DynamicClass$TextColor$", ({
  kN: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$TextColor$;
}
/** @constructor */
function $c_Lcom_papasofokli_classes_custom_DynamicClass$Width$() {
  this.al0 = null;
  this.akZ = null;
  this.al0 = "dynamic-width";
  this.akZ = "--custom-width";
}
$p = $c_Lcom_papasofokli_classes_custom_DynamicClass$Width$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_classes_custom_DynamicClass$Width$;
/** @constructor */
function $h_Lcom_papasofokli_classes_custom_DynamicClass$Width$() {
}
$h_Lcom_papasofokli_classes_custom_DynamicClass$Width$.prototype = $p;
$p.oI = (function() {
  return "";
});
$p.gH = (function() {
  return "dynamic-width";
});
$p.kG = (function() {
  return "--custom-width";
});
var $d_Lcom_papasofokli_classes_custom_DynamicClass$Width$ = new $TypeData().i($c_Lcom_papasofokli_classes_custom_DynamicClass$Width$, "com.papasofokli.classes.custom.DynamicClass$Width$", ({
  kO: 1,
  aG: 1
}));
var $n_Lcom_papasofokli_classes_custom_DynamicClass$Width$;
function $m_Lcom_papasofokli_classes_custom_DynamicClass$Width$() {
  if ((!$n_Lcom_papasofokli_classes_custom_DynamicClass$Width$)) {
    $n_Lcom_papasofokli_classes_custom_DynamicClass$Width$ = new $c_Lcom_papasofokli_classes_custom_DynamicClass$Width$();
  }
  return $n_Lcom_papasofokli_classes_custom_DynamicClass$Width$;
}
function $p_Lcom_papasofokli_components_NavTabsJS$__tabShownHandler__Lorg_scalajs_dom_Event__s_concurrent_ExecutionContext__V($thiz, e, ec) {
  var contentDivId = e.target.getAttribute("data-bs-target");
  var contentDiv = document.querySelector(contentDivId);
  var toggleId = contentDiv.getAttribute("data-bs-toggle");
  if ((!(!contentDiv.classList.contains($thiz.uQ)))) {
    $thiz.UI($m_ju_UUID$().aO(contentDiv.id), ec);
  }
  if ((toggleId !== "")) {
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(toggleId).g(), "", ec);
  } else {
    $m_s_concurrent_Future$().aE((void 0));
  }
}
/** @constructor */
function $c_Lcom_papasofokli_components_NavTabsJS$() {
  this.uQ = null;
  this.WT = null;
  $n_Lcom_papasofokli_components_NavTabsJS$ = this;
  $f_Lcom_papasofokli_navTabs_NavTabsT__$init$__V(this);
}
$p = $c_Lcom_papasofokli_components_NavTabsJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_NavTabsJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_NavTabsJS$() {
}
$h_Lcom_papasofokli_components_NavTabsJS$.prototype = $p;
$p.b7 = (function(ec) {
  var tabs = document.querySelectorAll(("button." + this.uQ));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tabs);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("shown.bs.tab", ((ec) => ((e$2) => {
      $p_Lcom_papasofokli_components_NavTabsJS$__tabShownHandler__Lorg_scalajs_dom_Event__s_concurrent_ExecutionContext__V(this, e$2, ec);
    }))(ec));
    x0.classList.remove(this.uQ);
  }
  var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll((((".tab-pane." + this.WT) + ".") + this.uQ)));
  var it$1 = this$5.l();
  while (it$1.f()) {
    var x0$1 = it$1.e();
    this.UI($m_ju_UUID$().aO(x0$1.id), ec);
  }
});
$p.UI = (function(tabId, ec) {
  var contentDiv = document.getElementById(tabId.g());
  if ((!(!contentDiv.classList.contains(this.uQ)))) {
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), tabId.g(), "", ec);
    contentDiv.classList.remove(this.uQ);
  }
});
var $d_Lcom_papasofokli_components_NavTabsJS$ = new $TypeData().i($c_Lcom_papasofokli_components_NavTabsJS$, "com.papasofokli.components.NavTabsJS$", ({
  kZ: 1,
  py: 1
}));
var $n_Lcom_papasofokli_components_NavTabsJS$;
function $m_Lcom_papasofokli_components_NavTabsJS$() {
  if ((!$n_Lcom_papasofokli_components_NavTabsJS$)) {
    $n_Lcom_papasofokli_components_NavTabsJS$ = new $c_Lcom_papasofokli_components_NavTabsJS$();
  }
  return $n_Lcom_papasofokli_components_NavTabsJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_components_PopoverJS$() {
  this.WV = null;
  this.WU = null;
  this.NQ = null;
  $n_Lcom_papasofokli_components_PopoverJS$ = this;
  $f_Lcom_papasofokli_popover_PopoverT__$init$__V(this);
}
$p = $c_Lcom_papasofokli_components_PopoverJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_PopoverJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_PopoverJS$() {
}
$h_Lcom_papasofokli_components_PopoverJS$.prototype = $p;
$p.b7 = (function(executionContext) {
  var popoverTriggers = document.querySelectorAll(("." + this.NQ));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(popoverTriggers);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove(this.NQ);
    var modal = document.querySelector(".modal-container.modal");
    var container = (((modal !== null) && (!(!modal.classList.contains("in")))) ? ".modal-dialog" : "body");
    var setupFunctionId = x0.getAttribute(this.WV);
    var reloadFunctionId = x0.getAttribute(this.WU);
    x0.addEventListener("shown.bs.popover", ((reloadFunctionId, executionContext, x0) => ((_$1$2) => {
      if (($m_sc_StringOps$(), (reloadFunctionId !== ""))) {
        $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(reloadFunctionId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
          var html = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lupickle_default$().J);
          var popOverId = x0.getAttribute("aria-describedby");
          var popOverBody = document.querySelector(("#" + popOverId)).querySelector(".popover-body");
          var innerDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])).aB();
          innerDiv.innerHTML = html;
          popOverBody.replaceChildren(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerDiv).ky);
          $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
        })), executionContext))), executionContext);
      }
      $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
    }))(reloadFunctionId, executionContext, x0));
    $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(setupFunctionId, "", executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((container, x0, executionContext) => ((resp$2$1) => $m_sjs_js_Thenable$Implicits$().bH(resp$2$1.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3$1) => {
      var setupData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3$1, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_popover_PopoverSetupData$().q());
      var options = new ($a_Lcom_papasofokli_bootstrap_PopoverOptions())(setupData.sO, setupData.sN, setupData.m2, setupData.m4, container, setupData.m1, setupData.m3);
      new $i_bootstrap.Popover(x0, options);
    })), executionContext)))(container, x0, executionContext)), executionContext);
  }
});
$p.auK = (function(id) {
  var popoverTrigger = document.getElementById(id);
  if ((popoverTrigger !== null)) {
    var popover = $i_bootstrap.Popover.getOrCreateInstance(popoverTrigger);
    popover.hide();
  }
});
var $d_Lcom_papasofokli_components_PopoverJS$ = new $TypeData().i($c_Lcom_papasofokli_components_PopoverJS$, "com.papasofokli.components.PopoverJS$", ({
  l3: 1,
  rd: 1
}));
var $n_Lcom_papasofokli_components_PopoverJS$;
function $m_Lcom_papasofokli_components_PopoverJS$() {
  if ((!$n_Lcom_papasofokli_components_PopoverJS$)) {
    $n_Lcom_papasofokli_components_PopoverJS$ = new $c_Lcom_papasofokli_components_PopoverJS$();
  }
  return $n_Lcom_papasofokli_components_PopoverJS$;
}
function $p_Lcom_papasofokli_components_TempusDominusJS$__restrict__Lcom_papasofokli_momentfacade_Date__Lcom_papasofokli_datetimePicker_RestrictionsOptions($thiz, date) {
  var max = date.toDate();
  max.setHours(23.0);
  max.setMinutes(59.0);
  var min = date.toDate();
  min.setHours(0.0);
  min.setMinutes(0.0);
  return (() => {
    var max$1 = null;
    var min$1 = null;
    max$1 = max;
    min$1 = min;
    var this$1 = ({});
    this$1.maxDate = null;
    this$1.minDate = null;
    this$1.maxDate = max$1;
    this$1.minDate = min$1;
    return this$1;
  })();
}
/** @constructor */
function $c_Lcom_papasofokli_components_TempusDominusJS$() {
  this.NT = null;
  this.X2 = null;
  this.X1 = null;
  $n_Lcom_papasofokli_components_TempusDominusJS$ = this;
  $f_Lcom_papasofokli_datetimePicker_TempusDominusT__$init$__V(this);
  var dateTimeOptions = (() => {
    var this$1 = ({});
    this$1.components = null;
    this$1.components = (() => (({})))();
    return this$1;
  })();
  var dateOnlyOptions = (() => {
    var this$2$1 = ({});
    this$2$1.components = null;
    this$2$1.components = (() => {
      var this$3 = ({});
      this$3.clock = null;
      this$3.clock = false;
      return this$3;
    })();
    return this$2$1;
  })();
  var timeOnlyOptions = (() => {
    var this$3$1 = ({});
    this$3$1.viewMode = null;
    this$3$1.components = null;
    this$3$1.viewMode = "clock";
    this$3$1.components = (() => {
      var this$4 = ({});
      this$4.decades = null;
      this$4.year = null;
      this$4.month = null;
      this$4.date = null;
      this$4.decades = false;
      this$4.year = false;
      this$4.month = false;
      this$4.date = false;
      return this$4;
    })();
    return this$3$1;
  })();
  this.X1 = $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2($m_Lcom_papasofokli_datetimePicker_DatetimePickerType$().Yj, dateTimeOptions), new $c_T2($m_Lcom_papasofokli_datetimePicker_DatetimePickerType$().Yi, dateOnlyOptions), new $c_T2($m_Lcom_papasofokli_datetimePicker_DatetimePickerType$().Os, timeOnlyOptions)]));
}
$p = $c_Lcom_papasofokli_components_TempusDominusJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_TempusDominusJS$;
/** @constructor */
function $h_Lcom_papasofokli_components_TempusDominusJS$() {
}
$h_Lcom_papasofokli_components_TempusDominusJS$.prototype = $p;
$p.co = (function() {
  var datetimeComponents = document.querySelectorAll(("." + this.NT));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(datetimeComponents);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove(this.NT);
    this.X2.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0) => ((x$1$3) => {
      matchResult1: {
        if ((x$1$3 !== null)) {
          var attr = x$1$3.P();
          var value = x$1$3.V();
          x0.setAttribute(attr, value);
          break matchResult1;
        }
        throw new $c_s_MatchError(x$1$3);
      }
    }))(x0)));
    var input = x0.querySelector("input");
    var format = input.getAttribute("data-format");
    var inputType = $m_Lcom_papasofokli_datetimePicker_DatetimePickerType$().azx(input.getAttribute("data-type"));
    var initialValue = (0, $i_moment$002dtimezone.default)(input.value, format);
    input.value = "";
    var $x_1 = $m_s_Option$();
    var x$2 = $m_Lcom_papasofokli_datetimePicker_DatetimePickerType$().Os;
    var timeRestrictions = $x_1.Z((((inputType === null) ? (x$2 === null) : inputType.b(x$2)) ? $p_Lcom_papasofokli_components_TempusDominusJS$__restrict__Lcom_papasofokli_momentfacade_Date__Lcom_papasofokli_datetimePicker_RestrictionsOptions(this, initialValue) : (() => (({})))()));
    var localizationOptions = (() => {
      var this$3$1 = ({});
      this$3$1.hourCycle = null;
      this$3$1.hourCycle = "h24";
      return this$3$1;
    })();
    var modalContent = x0.closest(".modal-content");
    var options = ((inputType, timeRestrictions, localizationOptions) => (() => {
      var inputType$1 = null;
      var timeRestrictions$1 = null;
      var localizationOptions$1 = null;
      inputType$1 = inputType;
      timeRestrictions$1 = timeRestrictions;
      localizationOptions$1 = localizationOptions;
      var this$4 = ({});
      this$4.display = null;
      this$4.allowInputToggle = null;
      this$4.useCurrent = null;
      this$4.restrictions = null;
      this$4.localization = null;
      var opt = $m_Lcom_papasofokli_components_TempusDominusJS$().X1.b9(inputType$1);
      this$4.display = (opt.c() ? (void 0) : opt.h());
      this$4.allowInputToggle = false;
      this$4.useCurrent = false;
      var opt$1 = timeRestrictions$1;
      this$4.restrictions = (opt$1.c() ? (void 0) : opt$1.h());
      this$4.localization = localizationOptions$1;
      return this$4;
    }))(inputType, timeRestrictions, localizationOptions)();
    if ((modalContent !== null)) {
      options.container = modalContent;
    }
    var picker = new $i_$0040eonasdan$002ftempus$002ddominus.TempusDominus(x0, options);
    picker.dates.formatInput = $m_sjs_js_Any$().b3(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((format) => ((d$2) => (0, $i_moment$002dtimezone.default)(d$2).format(format)))(format)));
    picker.dates.setFromInput = $m_sjs_js_Any$().b3(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((format, picker) => ((value$2) => {
      var formatted = (0, $i_moment$002dtimezone.default)(value$2, format);
      return ((!(!formatted.isValid())) ? picker.dates.setValue($i_$0040eonasdan$002ftempus$002ddominus.DateTime.convert(formatted.toDate())) : (void 0));
    }))(format, picker)));
    if ((!(!initialValue.isValid()))) {
      picker.dates.setValue($i_$0040eonasdan$002ftempus$002ddominus.DateTime.convert(initialValue.toDate()));
    } else {
      input.value = "";
    }
  }
});
var $d_Lcom_papasofokli_components_TempusDominusJS$ = new $TypeData().i($c_Lcom_papasofokli_components_TempusDominusJS$, "com.papasofokli.components.TempusDominusJS$", ({
  l9: 1,
  mm: 1
}));
var $n_Lcom_papasofokli_components_TempusDominusJS$;
function $m_Lcom_papasofokli_components_TempusDominusJS$() {
  if ((!$n_Lcom_papasofokli_components_TempusDominusJS$)) {
    $n_Lcom_papasofokli_components_TempusDominusJS$ = new $c_Lcom_papasofokli_components_TempusDominusJS$();
  }
  return $n_Lcom_papasofokli_components_TempusDominusJS$;
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeGroupingOptionLinks__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, ec) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(300, 0, ec);
  var containerElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "-container"));
  var dateColumnGroupOption = containerElement.querySelector(("." + $thiz.NY));
  var inputDateColumn = dateColumnGroupOption.querySelectorAll("input");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(inputDateColumn);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("blur", ((multipleEventHandler, tableId, ec) => ((_$3$2) => multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setDateColumnGroupType__T__T($thiz, tableId);
      return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz), ec);
    })))))(multipleEventHandler, tableId, ec));
  }
  var aggregateOptionElements = containerElement.querySelectorAll(("." + $thiz.Xn));
  var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(aggregateOptionElements);
  var it$1 = this$5.l();
  while (it$1.f()) {
    var x0$1 = it$1.e();
    x0$1.addEventListener("change", ((x0$1, tableId) => ((_$4$2) => {
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__aggregateOptionChecked__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_Element__T__V($thiz, _$4$2, x0$1, tableId);
    }))(x0$1, tableId));
  }
  return multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var linkElements = containerElement.querySelectorAll(".group-option");
    var this$9 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(linkElements);
    var it$2 = this$9.l();
    while (it$2.f()) {
      var x0$2 = it$2.e();
      var token = ((!(!x0$2.classList.contains("max"))) ? "max" : ((!(!x0$2.classList.contains("average"))) ? "average" : ((!(!x0$2.classList.contains("min"))) ? "min" : "total")));
      x0$2.addEventListener("click", ((token, tableId, ec) => ((_$5$2) => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__groupOptionButtonClick__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, token, tableId, ec)))(token, tableId, ec));
    }
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__aggregateOptionChecked__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_Element__T__V($thiz, event, element, tableId) {
  var target = event.target;
  var index = element.getAttribute("value");
  var isChecked = (!(!target.checked));
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var sortElmn = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(((((".sorting[" + $thiz.r8) + "='") + index) + "']"))));
  if ((!sortElmn.c())) {
    if (isChecked) {
      sortElmn.h().classList.remove($thiz.Jn);
    } else {
      sortElmn.h().classList.add($thiz.Jn);
    }
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__groupOptionButtonClick__T__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, token, tableId, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  tableElement.removeAttribute($thiz.v9);
  tableElement.setAttribute($thiz.v9, token);
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setDateColumnGroupType__T__T($thiz, tableId);
  return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz), ec);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setDateColumnGroupType__T__T($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var containerElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "-container"));
  var dateColumnGroupOption = containerElement.querySelector(("." + $thiz.NY));
  var dateGroupType = dateColumnGroupOption.querySelector("[data-value]").getAttribute("data-value");
  tableElement.removeAttribute($thiz.r9);
  tableElement.setAttribute($thiz.r9, dateGroupType);
  return dateGroupType;
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postReloadFunction__T__sci_Seq__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, columns, columnGroupBy, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var postReloadFunId = tableElement.getAttribute($thiz.Xx);
  if (($m_sc_StringOps$(), (postReloadFunId !== ""))) {
    var columnsSearch = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__readFilters__T__sci_IndexedSeq($thiz, tableId);
    var $x_3 = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec);
    var $x_2 = $m_Lupickle_default$();
    var $x_1 = columnsSearch.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => (_$6$2.c() ? "" : _$6$2.h()))));
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    var this$7 = $m_Lupickle_default$();
    $x_3.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((pickleToSend) => (() => $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(postReloadFunId).g(), pickleToSend, ec)))($f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_2, $x_1, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7))))).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$3) => (void 0))), ec);
  } else {
    $m_s_concurrent_Future$().aE((void 0));
  }
  return (columnGroupBy.c() ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postActionsFunction__Lorg_scalajs_dom_Element__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableElement, columns, ec) : $m_s_concurrent_Future$().aE((void 0)));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postActionsFunction__Lorg_scalajs_dom_Element__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableElement, columns, ec) {
  var postReloadFunId = tableElement.getAttribute($thiz.Xw);
  var tableRows = tableElement.querySelectorAll("tbody tr");
  var tableRowsIds = $f_sc_IterableOps__collect__s_PartialFunction__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableRows), new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1());
  if (($m_sc_StringOps$(), (postReloadFunId !== ""))) {
    var $x_2 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var $x_1 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    var this$8 = $m_Lupickle_default$();
    return $x_2.c5(postReloadFunId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, tableRowsIds, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8)), ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      var data = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_List$())));
      var result = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__applyStyle__sci_Seq__Lorg_scalajs_dom_Element__sci_Seq__sci_Seq($thiz, data, tableElement, columns);
      $m_Lcom_papasofokli_InitializeScalaJS$().b7(ec);
      return result;
    })), ec))), ec);
  } else {
    return $m_s_concurrent_Future$().aE($m_sci_Nil$());
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__applyStyle__sci_Seq__Lorg_scalajs_dom_Element__sci_Seq__sci_Seq($thiz, data, tableElement, columns) {
  return data.bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2(columns, tableElement));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getHelpButton__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement($thiz, tableId, ec) {
  var spanHelp = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().t6.by, $m_Lscalatags_JsDom$all$().s)]));
  var helpButton = $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn btn-info btn-sm  text-white help-button", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("button", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [spanHelp])).aB();
  helpButton.addEventListener("click", ((_$21$2) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__serverFunctionS__T__T__s_concurrent_ExecutionContext__V($thiz, $thiz.Xt, tableId, ec);
  }));
  return helpButton;
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getResetGroupingButton__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement($thiz, tableId, ec) {
  var spanHelp = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8K.by, $m_Lscalatags_JsDom$all$().s)]));
  var clearButton = $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn btn-primary btn-sm clear-button text-white  me-1 hidden", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("button", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().A1().n("Clear grouping", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [spanHelp])).aB();
  clearButton.addEventListener("click", ((_$22$2) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__clearFunctionS__T__s_concurrent_ExecutionContext__V($thiz, tableId, ec);
  }));
  return clearButton;
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getChartButton__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement($thiz, tableId, topRowId, ec) {
  var spanHelp = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8B.by, $m_Lscalatags_JsDom$all$().s)]));
  var clearButton = $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("btn btn-primary btn-sm chart-button text-white me-1 hidden", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("button", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().A1().n("View chart", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [spanHelp])).aB();
  clearButton.addEventListener("click", ((_$23$2) => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__showChartFunctionS__T__T__s_concurrent_ExecutionContext__O($thiz, tableId, topRowId, ec)));
  return clearButton;
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSearchInput__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, tableId, ec) {
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex ms-1", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().IN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n(("form-control input-sm " + $thiz.O6), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("search", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().aj5().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableEvent__T__s_concurrent_ExecutionContext__F1($thiz, tableId, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().V9().n("Search...", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(""))]))]));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getRefreshButton__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement($thiz, tableId, topRowId, ec) {
  var spanRefresh = $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("" + $m_Lcom_papasofokli_util_IconUI$().QA.by), $m_Lscalatags_JsDom$all$().s)]));
  return $m_Lscalatags_JsDom$all$().qC().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("btn btn-secondary btn-sm text-white", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("button", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__refreshButtonEvent__T__T__s_concurrent_ExecutionContext__F1($thiz, tableId, topRowId, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [spanRefresh])).aB();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, pageNum, forceReload, tableSetupDataO, parentColumnsSearch, headersWidth, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var singleClickFunId = tableElement.getAttribute($thiz.O8);
  var contextClickFunId = tableElement.getAttribute($thiz.NW);
  var doubleClickFunId = tableElement.getAttribute($thiz.NZ);
  var groupExpandFunId = tableElement.getAttribute($thiz.XA);
  var paginationId = tableElement.getAttribute($thiz.XF);
  var topRowDivId = tableElement.getAttribute($thiz.EP);
  var groupingCalculationType = tableElement.getAttribute($thiz.v9);
  var dateColumnGroupType = tableElement.getAttribute($thiz.r9);
  $m_sc_StringOps$();
  var x = tableElement.getAttribute($thiz.O7);
  $m_sc_StringParsers$();
  _return: {
    var len = x.length;
    if ((len === 4)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(x, i);
        if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
          var $x_1 = false;
          break _return;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_1 = true;
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$8 = new $c_s_Some(true);
  } else {
    _return$1: {
      var len$1 = x.length;
      if ((len$1 === 5)) {
        var i$1 = 0;
        while ((i$1 !== len$1)) {
          var thisCP$1 = $f_T__codePointAt__I__I(x, i$1);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
            var $x_2 = false;
            break _return$1;
          }
          i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var this$8 = new $c_s_Some(false);
    } else {
      var this$8 = $m_s_None$();
    }
  }
  var showIdInd = (!(!(this$8.c() ? false : this$8.h())));
  $m_sc_StringOps$();
  var x$1 = tableElement.getAttribute($thiz.XD);
  $m_sc_StringParsers$();
  _return$2: {
    var len$2 = x$1.length;
    if ((len$2 === 4)) {
      var i$2 = 0;
      while ((i$2 !== len$2)) {
        var thisCP$2 = $f_T__codePointAt__I__I(x$1, i$2);
        if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$2)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i$2))))) {
          var $x_3 = false;
          break _return$2;
        }
        i$2 = ((i$2 + ((thisCP$2 >= 65536) ? 2 : 1)) | 0);
      }
      var $x_3 = true;
    } else {
      var $x_3 = false;
    }
  }
  if ($x_3) {
    var this$16 = new $c_s_Some(true);
  } else {
    _return$3: {
      var len$3 = x$1.length;
      if ((len$3 === 5)) {
        var i$3 = 0;
        while ((i$3 !== len$3)) {
          var thisCP$3 = $f_T__codePointAt__I__I(x$1, i$3);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$3)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$3))))) {
            var $x_4 = false;
            break _return$3;
          }
          i$3 = ((i$3 + ((thisCP$3 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_4 = true;
      } else {
        var $x_4 = false;
      }
    }
    if ($x_4) {
      var this$16 = new $c_s_Some(false);
    } else {
      var this$16 = $m_s_None$();
    }
  }
  var lazyLoad = (!(!(this$16.c() ? false : this$16.h())));
  $m_sc_StringOps$();
  var x$2 = tableElement.getAttribute($thiz.Ju);
  var this$19 = $m_sc_StringParsers$().fs(x$2);
  var stickyColNo = ((this$19.c() ? 0 : this$19.h()) | 0);
  $m_sc_StringOps$();
  var x$3 = tableElement.getAttribute($thiz.Ob);
  $m_sc_StringParsers$();
  _return$4: {
    var len$4 = x$3.length;
    if ((len$4 === 4)) {
      var i$4 = 0;
      while ((i$4 !== len$4)) {
        var thisCP$4 = $f_T__codePointAt__I__I(x$3, i$4);
        if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$4)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i$4))))) {
          var $x_5 = false;
          break _return$4;
        }
        i$4 = ((i$4 + ((thisCP$4 >= 65536) ? 2 : 1)) | 0);
      }
      var $x_5 = true;
    } else {
      var $x_5 = false;
    }
  }
  if ($x_5) {
    var this$27 = new $c_s_Some(true);
  } else {
    _return$5: {
      var len$5 = x$3.length;
      if ((len$5 === 5)) {
        var i$5 = 0;
        while ((i$5 !== len$5)) {
          var thisCP$5 = $f_T__codePointAt__I__I(x$3, i$5);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$5)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$5))))) {
            var $x_6 = false;
            break _return$5;
          }
          i$5 = ((i$5 + ((thisCP$5 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_6 = true;
      } else {
        var $x_6 = false;
      }
    }
    if ($x_6) {
      var this$27 = new $c_s_Some(false);
    } else {
      var this$27 = $m_s_None$();
    }
  }
  var inGroupModeInd = (!(!(this$27.c() ? false : this$27.h())));
  $m_sc_StringOps$();
  var cond = (singleClickFunId !== "");
  var singleClickFunIdO = (cond ? new $c_s_Some(singleClickFunId) : $m_s_None$());
  $m_sc_StringOps$();
  var cond$1 = (doubleClickFunId !== "");
  var doubleClickFunIdO = (cond$1 ? new $c_s_Some(doubleClickFunId) : $m_s_None$());
  $m_sc_StringOps$();
  var cond$2 = (contextClickFunId !== "");
  var contextClickFunIdO = (cond$2 ? new $c_s_Some(contextClickFunId) : $m_s_None$());
  var freezePage = ((!(!tableElement.classList.contains($thiz.XE))) ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_FreezePage(100, 0, ec)));
  var blockAggregationIndexes = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getBlockAggregationIndexes__Lorg_scalajs_dom_Element__sc_Seq($thiz, tableElement);
  matchResult15: {
    var \u03b49$;
    var x23 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId);
    if ((x23 !== null)) {
      x23.P();
      x23.V();
      var \u03b49$ = x23;
      break matchResult15;
    }
    throw new $c_s_MatchError(x23);
  }
  var sortColumn$2 = \u03b49$.P();
  var sortDirection$2 = \u03b49$.V();
  var groupColumnIndexes = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingInformation__T__sci_Seq($thiz, tableId).bU($m_s_$less$colon$less$().b0);
  var columnsSearch = (parentColumnsSearch.c() ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__readFilters__T__sci_IndexedSeq($thiz, tableId) : parentColumnsSearch);
  var topRowElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowDivId);
  if ((!inGroupModeInd)) {
    var searchElement = topRowElement.querySelector(("." + $thiz.O6));
    var searchString = searchElement.value;
  } else {
    var searchString = "";
  }
  var pageNo = ((pageNum.c() ? 1 : pageNum.h()) | 0);
  var columnGroupBy = ((!inGroupModeInd) ? groupColumnIndexes : $m_sci_Nil$());
  var groupLevel = (((!inGroupModeInd) && (!groupColumnIndexes.c())) ? $m_s_Option$().Z(0) : $m_s_None$());
  return (tableSetupDataO.c() ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableSetupDataF__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, ec) : $m_s_concurrent_Future$().aE(tableSetupDataO.h())).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((setupData$2) => {
    var columnTypeMap = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnTypeMap__Lcom_papasofokli_dataTables_TableSetupData__sci_Map($thiz, setupData$2);
    var groupByCols = columnGroupBy.bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6(columnTypeMap)).bU($m_s_$less$colon$less$().b0);
    var length = ((!inGroupModeInd) ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLength__T__I__I($thiz, tableId, setupData$2.lp) : $thiz.v7);
    var search = (($m_sc_StringOps$(), (searchString !== "")) ? searchString : "");
    var blockAggregationIndexes$1 = $m_sci_Set$().jp(blockAggregationIndexes);
    var maxClientWidth = (tableSetupDataO.c() ? $m_s_None$() : tableSetupDataO.h().lq);
    $m_sc_StringOps$();
    var cond$3 = (groupingCalculationType !== "");
    var groupCalculationType = (cond$3 ? new $c_s_Some(groupingCalculationType) : $m_s_None$());
    $m_sc_StringOps$();
    var params = new $c_Lcom_papasofokli_dataTables_TableParameters(1, pageNo, length, search, sortColumn$2, sortDirection$2, columnsSearch, lazyLoad, groupByCols, blockAggregationIndexes$1, groupLevel, headersWidth, maxClientWidth, groupCalculationType, ((dateColumnGroupType !== "") ? new $c_s_Some(dateColumnGroupType) : $m_s_None$()), false, $m_s_None$());
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().amh(tableId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), params, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableParameters$().q()), ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((setupData$2$1) => ((rowResult$2) => $m_sjs_js_Thenable$Implicits$().bH(rowResult$2.text()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rowResultJson$2) => {
      var allData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(rowResultJson$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_dataTables_GetRowsResult$().q());
      var reloadPagination = ((pageNum.c() || (pageNo === 2)) || forceReload);
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createTable__Lcom_papasofokli_dataTables_GetRowsResult__T__sci_Seq__Z__s_Option__s_Option__s_Option__O__T__Z__I__s_Option__Z__sci_Seq__s_Option__Z__sci_Set__s_Option__sci_Seq__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__V($thiz, allData, tableId, setupData$2$1.hZ, reloadPagination, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, groupExpandFunId, paginationId, showIdInd, pageNo, ((stickyColNo > 0) ? new $c_s_Some(stickyColNo) : $m_s_None$()), (lazyLoad && (pageNo === 1)), groupByCols, groupLevel, inGroupModeInd, headersWidth, $m_s_None$(), allData.n6.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$25$2) => _$25$2.v6))), setupData$2$1, ec);
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeFilters__T__sci_Seq__sci_Set__sc_Seq($thiz, tableId, setupData$2$1.hZ, headersWidth);
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeHeaders__T__sci_Set__sc_Seq($thiz, tableId, headersWidth);
      if ((stickyColNo > 0)) {
        $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeStickyColum__T__I__V($thiz, tableId, stickyColNo);
      }
      return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postReloadFunction__T__sci_Seq__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, setupData$2$1.hZ, columnGroupBy, ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        var this$66 = (freezePage.c() ? $m_s_None$() : new $c_s_Some(freezePage.h().ep()));
        return (this$66.c() ? $m_s_concurrent_Future$().aE($m_s_None$()) : this$66.h()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
          $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V($thiz, tableId, true);
          return $m_s_Option$().Z(allData);
        })), ec);
      })), ec);
    })), ec)))(setupData$2)), ec);
  })), ec).hj(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7(), ec);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz) {
  return $m_sci_Set$EmptySet$();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnTypeMap__Lcom_papasofokli_dataTables_TableSetupData__sci_Map($thiz, setupData) {
  return setupData.hZ.bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8()).fd($m_s_$less$colon$less$().b0);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableSetupDataF__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(tableElement.getAttribute($thiz.Xu), "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((colProps$2) => $m_sjs_js_Thenable$Implicits$().bH(colProps$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((setupDataJson$2) => $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(setupDataJson$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_dataTables_TableSetupData$().q()))), ec))), ec);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createTable__Lcom_papasofokli_dataTables_GetRowsResult__T__sci_Seq__Z__s_Option__s_Option__s_Option__O__T__Z__I__s_Option__Z__sci_Seq__s_Option__Z__sci_Set__s_Option__sci_Seq__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__V($thiz, data, tableId, columns, reloadPagination, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, groupExpandFunIdO, paginationId, showIdInd, initialPage, stickyColNo, isLazyLoad, columnGroupBy, groupLevel, inGroupModeInd, headersWidth, maxWidth, expandCellValues, tableSetupData, ec) {
  var tableObject = (data.n6.c() ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createFlatTableRows__sci_Seq__sci_Seq__s_Option__s_Option__s_Option__Z__s_Option__s_concurrent_ExecutionContext__sci_Seq($thiz, data.n4, columns, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, showIdInd, stickyColNo, ec) : $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createGroupedTableRows__T__Lcom_papasofokli_dataTables_GetRowsResult__sci_Seq__sci_Seq__s_Option__O__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__sci_Seq($thiz, tableId, data, columns, columnGroupBy, groupLevel, groupExpandFunIdO, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec));
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var element = tableElement.querySelector(".table-body");
  element.replaceChildren(new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), tableObject, $m_s_$less$colon$less$().b0).uB());
  if (reloadPagination) {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createTablePagination__Lcom_papasofokli_dataTables_GetRowsResult__I__T__T__I__Z__Z__s_Option__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__V($thiz, data, (inGroupModeInd ? $thiz.v7 : $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLength__T__I__I($thiz, tableId, tableSetupData.lp)), paginationId, tableId, initialPage, isLazyLoad, inGroupModeInd, maxWidth, tableSetupData, ec);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createFlatTableRows__sci_Seq__sci_Seq__s_Option__s_Option__s_Option__Z__s_Option__s_concurrent_ExecutionContext__sci_Seq($thiz, data, columns, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, showIdInd, stickyColNo, ec) {
  var hiddenIndex = columns.bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9());
  var columnNames = columns.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((c$2) => new $c_T2(c$2.eV, c$2.jT)))).fd($m_s_$less$colon$less$().b0);
  var idColumnIndex = columns.TM(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10());
  var colNumO = ((!showIdInd) ? (stickyColNo.c() ? $m_s_None$() : new $c_s_Some(((1 + (stickyColNo.h() | 0)) | 0))) : stickyColNo);
  var additionalColumns = columns.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$28$2) => _$28$2.lk)));
  return data.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((cells$2) => {
    var prefix$1 = cells$2.bc().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
      if ((x$1$2 !== null)) {
        var cell = x$1$2.P();
        var index = (x$1$2.V() | 0);
        return new $c_T3(cell, index, index);
      }
      throw new $c_s_MatchError(x$1$2);
    })));
    var allCells = additionalColumns.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => new $c_T3(" ", ((1 + a$2.eV) | 0), a$2.rd)))).eS(prefix$1);
    return $m_Lscalatags_JsDom$all$().VI().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($thiz.As, $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(allCells, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
      if ((x$1$2$1 !== null)) {
        return (+x$1$2$1.gr);
      }
      throw new $c_s_MatchError(x$1$2$1);
    })), $m_s_math_Ordering$DeprecatedDoubleOrdering$()).bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11(hiddenIndex, showIdInd, idColumnIndex, columnNames, cells$2, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, stickyColNo, colNumO, ec, columns)), $m_s_$less$colon$less$().b0)]));
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createGroupedTableRows__T__Lcom_papasofokli_dataTables_GetRowsResult__sci_Seq__sci_Seq__s_Option__O__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__sci_Seq($thiz, tableId, data, columns, columnGroupBy, groupLevel, groupExpandFunIdO, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec) {
  return data.n6.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d$2) => {
    var iconId = $m_ju_UUID$().aW().g();
    var tdId = $m_ju_UUID$().aW().g();
    var keyValues = new $c_sci_$colon$colon(d$2.r5, $m_sci_Nil$());
    var $x_11 = $m_Lscalatags_JsDom$all$().as();
    var $x_10 = $m_Lscalatags_JsDom$all$().D().n("d-flex", $m_Lscalatags_JsDom$all$().s);
    var $x_9 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(iconId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Ky.by + " pointer"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, iconId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))]))]));
    var $x_8 = $m_Lscalatags_JsDom$all$().as();
    var $x_7 = $m_Lscalatags_JsDom$all$().D().n("d-flex table-cell-size ms-2", $m_Lscalatags_JsDom$all$().s);
    var $x_6 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "tabindex", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(1, $m_Lscalatags_JsDom$all$().qq);
    var $x_5 = $m_Lscalatags_JsDom$all$().bk();
    var $x_4 = $m_Lscalatags_JsDom$all$().D().n(" cell-highlight-transition", $m_Lscalatags_JsDom$all$().s);
    $m_Lscalatags_JsDom$all$();
    var this$15 = d$2.r5;
    var $x_3 = $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4, new $c_Lscalatags_JsDom$StringFrag(("" + (this$15.c() ? "Empty" : this$15.h())))]));
    var $x_2 = $m_Lscalatags_JsDom$all$().bk();
    var $x_1 = $m_Lscalatags_JsDom$all$().D().n("ms-2 badge float-end cell-badge  bg-primary text-white cell-highlight-transition", $m_Lscalatags_JsDom$all$().s);
    $m_Lscalatags_JsDom$all$();
    var this$23 = d$2.r6.bj();
    var this$25 = (this$23.c() ? $m_s_None$() : new $c_s_Some(this$23.h().V()));
    var content = $x_11.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_10, $x_9, $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $x_6, $x_3, $x_2.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_1, new $c_Lscalatags_JsDom$StringFrag(("" + (this$25.c() ? 0 : this$25.h())))]))]))]));
    var mainTdCell = $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(tdId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("sticky-col", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().TN().n(2, $m_Lscalatags_JsDom$all$().qq), content, $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $thiz.EN, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n($dp_toString__T((groupLevel.c() ? 0 : groupLevel.h())), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().J0().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, iconId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]));
    var indexCellValMap = d$2.r6.ak().fd($m_s_$less$colon$less$().b0);
    var visibleColumns = columns.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$2) => ((!f$2$2.gk) && (((!showIdInd) && (f$2$2.jT !== "Id")) || showIdInd)))));
    if ((visibleColumns.F() > 2)) {
      var tdCells = visibleColumns.bo(2).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
        var this$44 = data.jQ;
        if ((!this$44.c())) {
          var x0$8 = this$44.h();
          $m_sc_StringOps$();
          var $x_12 = (x0$8 !== "");
        } else {
          var $x_12 = false;
        }
        if (($x_12 && indexCellValMap.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((columnProp$1) => ((e$2) => ((e$2.P() | 0) === columnProp$1.eV)))(x$1$2))))) {
          var cell = ((($m_sc_StringOps$(), (indexCellValMap.p(x$1$2.eV) !== "")) && (!x$1$2.pc)) ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex table-cell-size justify-end", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingResultIcon__s_Option__T($thiz, data.jQ) + "m-1"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + indexCellValMap.p(x$1$2.eV))))]))])) : $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table-cell-size", $m_Lscalatags_JsDom$all$().s)])));
          return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [cell, $m_Lscalatags_JsDom$all$().J0().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, iconId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$3) => $m_sjs_js_Any$().b3(f$2$3))))))]));
        } else {
          return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []))]));
        }
      }))).ba(mainTdCell);
    } else {
      var $x_15 = $m_Lscalatags_JsDom$all$().mM();
      var $x_14 = $m_Lscalatags_JsDom$all$().bE().n(tdId, $m_Lscalatags_JsDom$all$().s);
      var $x_13 = $m_Lscalatags_JsDom$all$().TN();
      var res = 0;
      var it = columns.l();
      while (it.f()) {
        if ((!it.e().gk)) {
          res = ((1 + res) | 0);
        }
      }
      var tdCells = new $c_sci_$colon$colon($x_15.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_14, $x_13.n(res, $m_Lscalatags_JsDom$all$().qq), content])), $m_sci_Nil$());
    }
    return $m_Lscalatags_JsDom$all$().VI().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n((tdId + "R"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n($thiz.As, $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), tdCells, $m_s_$less$colon$less$().b0)]));
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$36$3) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClick__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__V($thiz, tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec);
  }));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getStartPadding__s_Option__T($thiz, groupLevel) {
  return ("ms-" + ((1 + ((groupLevel.c() ? 1 : groupLevel.h()) | 0)) | 0));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClick__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__V($thiz, tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec) {
  var element = document.getElementById(elementId);
  var tdElement = document.getElementById(tdId);
  var tbl = document.getElementById(tableId);
  var isExpanded = (!(!tdElement.classList.contains($thiz.Aq)));
  var cond = $f_sc_MapOps__contains__O__Z(new $c_Lorg_scalajs_dom_NamedNodeMapMap(tdElement.attributes), $thiz.EN);
  var groupLevelO = (cond ? new $c_s_Some(tdElement.getAttribute($thiz.EN)) : $m_s_None$());
  var expand = (!isExpanded);
  if (groupLevelO.c()) {
    var groupLevel = $m_s_None$();
  } else {
    var x0 = groupLevelO.h();
    $m_sc_StringOps$();
    var groupLevel = $m_sc_StringParsers$().fs(x0);
  }
  var newElement = (expand ? (tdElement.classList.add($thiz.Aq), element.classList.add($thiz.Aq), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().a8y.by + "  pointer"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, element.id, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2))))))]))) : (tdElement.classList.remove($thiz.Aq), element.classList.remove($thiz.Aq), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Ky.by + " pointer"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClickFun__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__F1($thiz, tableId, element.id, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, expandCellValues, contextClickFunIdO, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]))));
  element.replaceChildren(newElement.aB());
  var groupingCalculationType = tbl.getAttribute($thiz.v9);
  var dateColumnGroupType = tbl.getAttribute($thiz.r9);
  matchResult38: {
    var \u03b416$;
    var x71 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId);
    if ((x71 !== null)) {
      x71.P();
      x71.V();
      var \u03b416$ = x71;
      break matchResult38;
    }
    throw new $c_s_MatchError(x71);
  }
  var sortColumn$2 = \u03b416$.P();
  var sortDirection$2 = \u03b416$.V();
  var expandCellValueMap = expandCellValues.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => new $c_T2(x$2.p5, x$2)))).fd($m_s_$less$colon$less$().b0);
  var keyValueSeq = columnGroupBy.bY(keyValues).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var col = x$1$2.P();
      var value$1 = x$1$2.V();
      var expandCellO = expandCellValueMap.b9(value$1);
      return new $c_T3(col.p6, new $c_Lcom_papasofokli_dataTables_ColumnGroup(value$1, (expandCellO.c() ? $m_s_None$() : expandCellO.h().n3), (expandCellO.c() ? $m_s_None$() : expandCellO.h().n2), (expandCellO.c() ? $m_s_None$() : expandCellO.h().n1)), col.iF);
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  var groupLevel$1 = ((groupLevel.c() ? 1 : groupLevel.h()) | 0);
  var maxClientWidth = $m_s_Option$().Z((tbl.parentElement.clientWidth | 0));
  $m_sc_StringOps$();
  var cond$1 = (groupingCalculationType !== "");
  var groupCalculationType = (cond$1 ? new $c_s_Some(groupingCalculationType) : $m_s_None$());
  $m_sc_StringOps$();
  var tableGroupRequest = new $c_Lcom_papasofokli_dataTables_TableGroupRequest(keyValueSeq, groupLevel$1, columnGroupBy, headersWidth, maxClientWidth, groupCalculationType, ((dateColumnGroupType !== "") ? new $c_s_Some(dateColumnGroupType) : $m_s_None$()), sortColumn$2, sortDirection$2, $p_Lcom_papasofokli_dataTables_ScalaJsTable$__readFilters__T__sci_IndexedSeq($thiz, tableId), $m_sci_Set$().jp($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getBlockAggregationIndexes__Lorg_scalajs_dom_Element__sc_Seq($thiz, $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId))), $m_s_None$());
  if (expand) {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__expandFunction__T__Lorg_scalajs_dom_HTMLTableElement__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__Lcom_papasofokli_dataTables_TableGroupRequest__s_Option__s_Option__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, tbl, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, tableGroupRequest, groupLevel, contextClickFunIdO, ec);
  } else {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__collapseFunction__Lorg_scalajs_dom_HTMLTableElement__s_Option__T__sci_Seq__sci_Seq__V($thiz, tbl, groupLevel, tdId, columnGroupBy, keyValues);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__collapseFunction__Lorg_scalajs_dom_HTMLTableElement__s_Option__T__sci_Seq__sci_Seq__V($thiz, tbl, groupLevel, tdId, columnGroupBy, keyValues) {
  if (groupLevel.c()) {
    var forceDeleteSubTable = $m_s_None$();
  } else {
    var x0 = groupLevel.h();
    var l$2 = (x0 | 0);
    if ((columnGroupBy.at(l$2).iF > $thiz.XG)) {
      if (keyValues.at(l$2).c()) {
        var $x_1 = true;
      } else {
        var this$1 = keyValues.at(l$2);
        var $x_1 = ((!this$1.c()) && (this$1.h() === ""));
      }
    } else {
      var $x_1 = false;
    }
    var forceDeleteSubTable = new $c_s_Some($x_1);
  }
  if (((groupLevel.c() ? $m_s_None$() : new $c_s_Some(((1 + (groupLevel.h() | 0)) | 0))).az(columnGroupBy.F()) || forceDeleteSubTable.az(true))) {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__deleteSubTableRows__Lorg_scalajs_dom_HTMLTableElement__T__Z__V($thiz, tbl, (tdId + "R"), false);
  } else {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__collapseRow__Lorg_scalajs_dom_HTMLTableElement__T__V($thiz, tbl, tdId);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__collapseRow__Lorg_scalajs_dom_HTMLTableElement__T__V($thiz, tbl, tdId) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
  var this$3 = this$2.l();
  _return: {
    var i = 0;
    var dropped = this$3.ex(0);
    while (dropped.f()) {
      var x0 = dropped.e();
      if ((x0.id === (tdId + "R"))) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  var curRow = ((1 + $x_1) | 0);
  $f_sc_IterableOps__filter__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => {
    if ((!(!r$2.classList.contains($thiz.Jv)))) {
      var this$10 = new $c_Lorg_scalajs_dom_NamedNodeMapMap(r$2.attributes).Us($thiz.Jq);
      if ((!this$10.c())) {
        var x0$1 = this$10.h();
        return (x0$1.value === tdId);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }))).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((subRow$3) => {
    var this$13 = subRow$3.id;
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__collapseRow__Lorg_scalajs_dom_HTMLTableElement__T__V($thiz, tbl, this$13.split("R").join(""));
  })));
  var this$15 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
  var res = 0;
  var it = this$15.l();
  while (it.f()) {
    var x0$2 = it.e();
    if ((!(!x0$2.classList.contains($thiz.Jv)))) {
      var this$18 = new $c_Lorg_scalajs_dom_NamedNodeMapMap(x0$2.attributes).Us($thiz.Jq);
      if ((!this$18.c())) {
        var x0$3 = this$18.h();
        var $x_2 = (x0$3.value === tdId);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      res = ((1 + res) | 0);
    }
  }
  var rowPosition = res;
  var end = ((curRow + rowPosition) | 0);
  var isEmpty = (curRow >= end);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if ((!isEmpty)) {
    var i$1 = curRow;
    while (true) {
      try {
        var $x_3 = new $c_s_util_Success(tbl.rows[curRow].id);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var $x_3;
          var x2 = $m_s_util_control_NonFatal$().dV(e$2);
          if ((!x2.c())) {
            var $x_3 = new $c_s_util_Failure(x2.h());
            break matchResult1;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
        }
      }
      var rowIdO = $x_3.mN();
      if ((!rowIdO.c())) {
        $p_Lcom_papasofokli_dataTables_ScalaJsTable$__deleteSubTableRows__Lorg_scalajs_dom_HTMLTableElement__T__Z__V($thiz, tbl, rowIdO.h(), false);
      }
      tbl.deleteRow(curRow);
      if ((i$1 === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i$1 = ((1 + i$1) | 0);
    }
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__expandFunction__T__Lorg_scalajs_dom_HTMLTableElement__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__Lcom_papasofokli_dataTables_TableGroupRequest__s_Option__s_Option__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, tbl, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, tableGroupRequest, groupLevel, contextClickFunIdO, ec) {
  var sentData = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), tableGroupRequest, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableGroupRequest$().q());
  var x = ((groupExpandFunIdO === (void 0)) ? (void 0) : $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(groupExpandFunIdO, sentData, ec));
  if ((x === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
  }
  return x.aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result$2) => $m_sjs_js_Thenable$Implicits$().bH(result$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    var tableGroupedResult = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_dataTables_TableGroupedResult$().q());
    if ((!tableGroupedResult.iG.c())) {
      $m_sc_StringOps$();
      var x$1 = tbl.getAttribute($thiz.Ju);
      var this$24 = $m_sc_StringParsers$().fs(x$1);
      var stickyColNo$1 = ((this$24.c() ? 0 : this$24.h()) | 0);
      var createPageFunO = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__drawInnerTable__T__T__Lorg_scalajs_dom_HTMLTableElement__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__s_Option__s_concurrent_ExecutionContext__s_Option($thiz, tableId, tdId, tbl, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, $m_s_None$(), ec);
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCellsLeftStyleProperty__Lorg_scalajs_dom_Element__sci_Seq__I__V($thiz, tbl, $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnActualWidths__T__sci_Seq($thiz, tableId), stickyColNo$1);
      var this$26 = (createPageFunO.c() ? $m_s_None$() : new $c_s_Some((createPageFunO.h().aA(), (void 0))));
      if ((!this$26.c())) {
        this$26.h();
      }
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postReloadFunction__T__sci_Seq__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, columns, $m_sci_Nil$(), ec);
      new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_Lcom_papasofokli_InitializeScalaJS$().b7(ec);
      })));
    } else {
      var this$27 = tableGroupedResult.ll;
      var allRows = (this$27.c() ? $m_sci_Nil$() : this$27.h());
      var this$29 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
      var this$30 = this$29.l();
      _return: {
        var i = 0;
        var dropped = this$30.ex(0);
        while (dropped.f()) {
          var x0$1 = dropped.e();
          if ((x0$1.id === (tdId + "R"))) {
            var rowPosition = i;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var rowPosition = (-1);
      }
      if ((allRows.F() > 50)) {
        tbl.parentElement.classList.add("div-scrollbar-high");
      }
      var visibleColumns = columns.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => ((!f$2.gk) && (((!showIdInd) && (f$2.jT !== "Id")) || showIdInd)))));
      allRows.bc().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
        matchResult42: {
          if ((x$1$3 !== null)) {
            var x82 = x$1$3.P();
            if ((x82 !== null)) {
              var cellValue = x82.P();
              var cellTotal = x82.V();
              var index = (x$1$3.V() | 0);
              var newRow = tbl.insertRow(((1 + ((rowPosition + index) | 0)) | 0));
              newRow.classList.add($thiz.As);
              newRow.classList.add($thiz.Jv);
              var iconId = $m_ju_UUID$().aW().g();
              newRow.setAttribute($thiz.Jq, tdId);
              var $x_8 = $m_Lscalatags_JsDom$all$().as();
              var $x_7 = $m_Lscalatags_JsDom$all$().D().n("d-flex ms-3", $m_Lscalatags_JsDom$all$().s);
              var $x_6 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(iconId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getStartPadding__s_Option__T($thiz, groupLevel), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().Ky.by + "  pointer additional"), $m_Lscalatags_JsDom$all$().s)]))]));
              var $x_5 = $m_Lscalatags_JsDom$all$().as();
              var $x_4 = $m_Lscalatags_JsDom$all$().D().n("d-flex table-cell-size ms-1", $m_Lscalatags_JsDom$all$().s);
              var $x_3 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "tabindex", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(1, $m_Lscalatags_JsDom$all$().qq);
              var $x_2 = $m_Lscalatags_JsDom$all$().bk();
              var $x_1 = $m_Lscalatags_JsDom$all$().D().n("cell-highlight-transition", $m_Lscalatags_JsDom$all$().s);
              $m_Lscalatags_JsDom$all$();
              var this$46 = cellValue.p5;
              var content = $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7, $x_6, $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4, $x_3, $x_2.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_1, new $c_Lscalatags_JsDom$StringFrag(("" + (this$46.c() ? "Empty" : this$46.h())))])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("ms-2 float-end badge cell-badge  bg-primary text-white cell-highlight-transition", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + cellTotal.W().V())))]))]))]));
              var indexCellValMap = cellTotal.ak().fd($m_s_$less$colon$less$().b0);
              var otherCells = ((visibleColumns.F() > 2) ? visibleColumns.bo(2).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
                var this$64 = tableGroupRequest.jU;
                if ((!this$64.c())) {
                  var x0$8 = this$64.h();
                  $m_sc_StringOps$();
                  var $x_9 = (x0$8 !== "");
                } else {
                  var $x_9 = false;
                }
                if (($x_9 && indexCellValMap.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$1) => ((e$2) => ((e$2.P() | 0) === x$1$1.eV)))(x$1$2))))) {
                  var cell = ((($m_sc_StringOps$(), (indexCellValMap.p(x$1$2.eV) !== "")) && (!x$1$2.pc)) ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex table-cell-size  justify-end", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingResultIcon__s_Option__T($thiz, tableGroupRequest.jU) + "m-1"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + indexCellValMap.p(x$1$2.eV))))]))])) : $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table-cell-size", $m_Lscalatags_JsDom$all$().s)])));
                  return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [cell]));
                } else {
                  return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []))]));
                }
              }))) : $m_sci_Nil$());
              var subId = $m_ju_UUID$().aW().g();
              var tdCell = $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [content]));
              if ((visibleColumns.F() > 2)) {
                var colspan = 2;
              } else {
                var res = 0;
                var it = columns.l();
                while (it.f()) {
                  if ((!it.e().gk)) {
                    res = ((1 + res) | 0);
                  }
                }
                var colspan = res;
              }
              var newTableCell = newRow.insertCell(0);
              newTableCell.innerHTML = tdCell.g();
              newTableCell.classList.add("sticky-col");
              new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(newRow.cells).l().e().setAttribute("colspan", ("" + colspan));
              new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(newRow.cells).l().e().setAttribute("id", subId);
              var $x_11 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(newRow.cells).l().e();
              var $x_10 = $thiz.EN;
              var this$106 = (groupLevel.c() ? $m_s_None$() : new $c_s_Some(((1 + (groupLevel.h() | 0)) | 0)));
              $x_11.setAttribute($x_10, $dp_toString__T((this$106.c() ? 1 : this$106.h())));
              newRow.setAttribute("id", (subId + "R"));
              otherCells.bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
                matchResult41: {
                  if ((x$1$3$1 !== null)) {
                    var c = x$1$3$1.P();
                    var indx = (x$1$3$1.V() | 0);
                    var newTableCell$1 = newRow.insertCell(((1 + indx) | 0));
                    newTableCell$1.innerHTML = c.g();
                    break matchResult41;
                  }
                  throw new $c_s_MatchError(x$1$3$1);
                }
              })));
              $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeAdditionalGroupCells__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__V($thiz, tableId, iconId, subId, columnGroupBy, groupExpandFunIdO, keyValues.aV(cellValue.p5), columns, headersWidth, showIdInd, stickyColNo, allRows.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$50$2) => _$50$2.P()))), contextClickFunIdO, ec);
              break matchResult42;
            }
          }
          throw new $c_s_MatchError(x$1$3);
        }
      })));
    }
    $m_Lcom_papasofokli_InitializeScalaJS$().b7(ec);
  })), ec))), ec);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__deleteSubTableRows__Lorg_scalajs_dom_HTMLTableElement__T__Z__V($thiz, tbl, tdId, excludeLast) {
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
  var this$3 = this$2.l();
  _return: {
    var i = 0;
    var dropped = this$3.ex(0);
    while (dropped.f()) {
      var x0 = dropped.e();
      if ((x0.id === ("" + tdId))) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  var curRow = ((1 + $x_1) | 0);
  var this$7 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
  var res = 0;
  var it = this$7.l();
  while (it.f()) {
    var x0$1 = it.e();
    if ((!(!x0$1.classList.contains((($thiz.O9 + "_") + tdId))))) {
      res = ((1 + res) | 0);
    }
  }
  var rowPosition = res;
  var untilPosition = (excludeLast ? ((((curRow + rowPosition) | 0) - 1) | 0) : ((curRow + rowPosition) | 0));
  var isEmpty = (curRow >= untilPosition);
  var scala$collection$immutable$Range$$lastElement = ((untilPosition - 1) | 0);
  if ((!isEmpty)) {
    var i$1 = curRow;
    while (true) {
      tbl.deleteRow(curRow);
      if ((i$1 === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i$1 = ((1 + i$1) | 0);
    }
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__drawInnerTable__T__T__Lorg_scalajs_dom_HTMLTableElement__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__s_Option__s_concurrent_ExecutionContext__s_Option($thiz, tableId, tdId, tbl, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, pageNo, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var singleClickFunId = tableElement.getAttribute($thiz.O8);
  var contextClickFunId = tableElement.getAttribute($thiz.NW);
  var doubleClickFunId = tableElement.getAttribute($thiz.NZ);
  $m_sc_StringOps$();
  var cond = (singleClickFunId !== "");
  var singleClickFunIdO = (cond ? new $c_s_Some(singleClickFunId) : $m_s_None$());
  $m_sc_StringOps$();
  var cond$1 = (doubleClickFunId !== "");
  var doubleClickFunIdO = (cond$1 ? new $c_s_Some(doubleClickFunId) : $m_s_None$());
  $m_sc_StringOps$();
  var cond$2 = (contextClickFunId !== "");
  var contextClickFunIdO = (cond$2 ? new $c_s_Some(contextClickFunId) : $m_s_None$());
  $m_sc_StringOps$();
  var x = tableElement.getAttribute($thiz.Ju);
  var this$15 = $m_sc_StringParsers$().fs(x);
  var stickyColNo = ((this$15.c() ? 0 : this$15.h()) | 0);
  $m_sc_StringOps$();
  var x$1 = tableElement.getAttribute($thiz.O7);
  $m_sc_StringParsers$();
  _return: {
    var len = x$1.length;
    if ((len === 4)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(x$1, i);
        if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
          var $x_1 = false;
          break _return;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_1 = true;
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$23 = new $c_s_Some(true);
  } else {
    _return$1: {
      var len$1 = x$1.length;
      if ((len$1 === 5)) {
        var i$1 = 0;
        while ((i$1 !== len$1)) {
          var thisCP$1 = $f_T__codePointAt__I__I(x$1, i$1);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
            var $x_2 = false;
            break _return$1;
          }
          i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var this$23 = new $c_s_Some(false);
    } else {
      var this$23 = $m_s_None$();
    }
  }
  var showIdInd = (!(!(this$23.c() ? false : this$23.h())));
  var $x_3 = tableGroupedResult.iG;
  var this$24 = tableGroupedResult.iH;
  var this$26 = (this$24.c() ? $m_s_None$() : new $c_s_Some(this$24.h().hZ));
  var tableRows = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createFlatTableRows__sci_Seq__sci_Seq__s_Option__s_Option__s_Option__Z__s_Option__s_concurrent_ExecutionContext__sci_Seq($thiz, $x_3, (this$26.c() ? $m_sci_Nil$() : this$26.h()), singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, showIdInd, ((stickyColNo > 0) ? new $c_s_Some(stickyColNo) : $m_s_None$()), ec);
  var this$30 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tbl.rows);
  var this$31 = this$30.l();
  _return$2: {
    var i$2 = 0;
    var dropped = this$31.ex(0);
    while (dropped.f()) {
      var x0$1 = dropped.e();
      if ((x0$1.id === (tdId + "R"))) {
        var rowPosition = i$2;
        break _return$2;
      }
      i$2 = ((1 + i$2) | 0);
    }
    var rowPosition = (-1);
  }
  var paginationId = $m_Lcom_papasofokli_InitializeScalaJS$().U7($m_ju_UUID$().aW()).g();
  var cond$4 = ((tableRows.F() >= 50) && pageNo.c());
  if (cond$4) {
    var paginationDiv = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createInnerTablePagination__T__Lscalatags_JsDom$TypedTag($thiz, paginationId);
    var this$35 = tableGroupedResult.iH;
    if (this$35.c()) {
      var this$38 = $m_s_None$();
    } else {
      var x0$2 = this$35.h();
      var this$36 = x0$2.hZ;
      var res = 0;
      var it = this$36.l();
      while (it.f()) {
        if ((!it.e().gk)) {
          res = ((1 + res) | 0);
        }
      }
      var this$38 = new $c_s_Some(res);
    }
    var colSpan = ((this$38.c() ? 1 : this$38.h()) | 0);
    var cell = $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().TN().n(("" + colSpan), $m_Lscalatags_JsDom$all$().s), paginationDiv]));
    var opt = new $c_s_Some($m_Lscalatags_JsDom$all$().VI().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($thiz.As, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table_column_hidden", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(paginationId))])), cell, $m_Lscalatags_JsDom$all$().fc().n((void 0), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$2) => value$2)))))])));
  } else {
    var opt = $m_s_None$();
  }
  tableRows.cH(opt).bY(tableGroupedResult.iG.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$58$2) => _$58$2.W()))).dt((opt.c() ? $m_s_None$() : new $c_s_Some((opt.h(), ""))))).bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult44: {
      if ((x$1$3 !== null)) {
        var x88 = x$1$3.P();
        if ((x88 !== null)) {
          var row = x88.P();
          var rowId = x88.V();
          var index = (x$1$3.V() | 0);
          var subId = $m_ju_UUID$().aW().g();
          var newRow = tbl.insertRow(((1 + ((rowPosition + index) | 0)) | 0));
          newRow.classList.add($thiz.As);
          newRow.classList.add(((($thiz.O9 + "_") + tdId) + "R"));
          newRow.innerHTML = row.g();
          if ((!singleClickFunIdO.c())) {
            newRow.onclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_dataTables_ScalaJsTable$__clickFunction__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, index, singleClickFunIdO.h(), ec));
          }
          if ((!doubleClickFunIdO.c())) {
            newRow.ondblclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_dataTables_ScalaJsTable$__clickFunction__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, index, doubleClickFunIdO.h(), ec));
          }
          if ((!contextClickFunIdO.c())) {
            newRow.oncontextmenu = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuClickFunction__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, index, contextClickFunIdO.h(), ec));
          }
          new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(newRow.cells).l().e().setAttribute("id", subId);
          newRow.setAttribute("id", (subId + "R"));
          newRow.onclick = ((_$60$2) => $m_s_concurrent_Future$().aE((void 0)));
          break matchResult44;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  return ((tableRows.F() >= 50) ? new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createInnerTablePagination__T__T__T__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__I__s_concurrent_ExecutionContext__V($thiz, paginationId, tableId, tdId, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, stickyColNo, ec);
  }))) : $m_s_None$());
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createInnerTablePagination__T__T__T__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__I__s_concurrent_ExecutionContext__V($thiz, paginationId, tableId, tdId, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, stickyColNo, ec) {
  $m_Lcom_papasofokli_pagination_PaginationJs$().MY(paginationId, tableGroupedResult.ln, 50.0, 1, "Last", $p_Lcom_papasofokli_dataTables_ScalaJsTable$__innerPaginationFunction__T__T__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__sci_Seq__I__s_concurrent_ExecutionContext__F2($thiz, tableId, tdId, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnActualWidths__T__sci_Seq($thiz, tableId), stickyColNo, ec), (tdId + "R"));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnActualWidths__T__sci_Seq($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll("th.search-th.sticky-col")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2.clientWidth | 0)))).cf();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__innerPaginationFunction__T__T__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__sci_Seq__I__s_concurrent_ExecutionContext__F2($thiz, tableId, tdId, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, columnActualWidths, stickyColNo, ec) {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    var this$2 = tableGroupedResult.iH;
    var this$4 = (this$2.c() ? $m_s_None$() : new $c_s_Some(this$2.h().hZ));
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadInnerTableRows__T__I__T__sci_Seq__sci_Seq__O__sci_Seq__sci_Seq__I__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tdId, (((v2$2 | 0) - 1) | 0), tableId, columnGroupBy, keyValues, groupExpandFunIdO, (this$4.c() ? $m_sci_Nil$() : this$4.h()), columnActualWidths, stickyColNo, ec);
  }));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingResultIcon__s_Option__T($thiz, typeName) {
  if ((typeName instanceof $c_s_Some)) {
    var x100 = typeName.bg;
    switch (x100) {
      case "total": {
        return new $c_Lcom_papasofokli_util_IconWithStyle($m_Lcom_papasofokli_util_IconUI$().Qy, $m_Lcom_papasofokli_util_IconSizes$().xR, $m_Lcom_papasofokli_util_IconTypes$().Qx, $m_Lcom_papasofokli_util_IconRotations$().Cj, "").g();
        break;
      }
      case "average": {
        return new $c_Lcom_papasofokli_util_IconWithStyle($m_Lcom_papasofokli_util_IconUI$().a8G, $m_Lcom_papasofokli_util_IconSizes$().xR, $m_Lcom_papasofokli_util_IconTypes$().a8w, $m_Lcom_papasofokli_util_IconRotations$().Cj, "").g();
        break;
      }
      case "min": {
        return new $c_Lcom_papasofokli_util_IconWithStyle($m_Lcom_papasofokli_util_IconUI$().a8z, $m_Lcom_papasofokli_util_IconSizes$().xR, $m_Lcom_papasofokli_util_IconTypes$().a8v, $m_Lcom_papasofokli_util_IconRotations$().Cj, "").g();
        break;
      }
      default: {
        if ((x100 === "max")) {
          return new $c_Lcom_papasofokli_util_IconWithStyle($m_Lcom_papasofokli_util_IconUI$().a8A, $m_Lcom_papasofokli_util_IconSizes$().xR, $m_Lcom_papasofokli_util_IconTypes$().a8x, $m_Lcom_papasofokli_util_IconRotations$().Cj, "").g();
        }
      }
    }
  }
  return new $c_Lcom_papasofokli_util_IconWithStyle($m_Lcom_papasofokli_util_IconUI$().Qy, $m_Lcom_papasofokli_util_IconSizes$().xR, $m_Lcom_papasofokli_util_IconTypes$().Qx, $m_Lcom_papasofokli_util_IconRotations$().Cj, "").g();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeAdditionalGroupCells__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__V($thiz, tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, cellValues, contextClickFunIdO, ec) {
  var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll(".pointer.additional"));
  var it = this$3.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("click", ((tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, cellValues, contextClickFunIdO, ec) => ((_$63$2) => {
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onRowExpandClick__T__T__T__sci_Seq__O__sci_Seq__sci_Seq__sci_Set__Z__s_Option__sci_Seq__s_Option__s_concurrent_ExecutionContext__V($thiz, tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, cellValues, contextClickFunIdO, ec);
    }))(tableId, elementId, tdId, columnGroupBy, groupExpandFunIdO, keyValues, columns, headersWidth, showIdInd, stickyColNo, cellValues, contextClickFunIdO, ec));
    x0.classList.remove("additional");
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createTablePagination__Lcom_papasofokli_dataTables_GetRowsResult__I__T__T__I__Z__Z__s_Option__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__V($thiz, data, rowsPerPage, paginationRowId, tableId, initialPage, isLazyLoad, inGroupModeInd, maxWidth, tableSetupData, ec) {
  var paginationId = $m_Lcom_papasofokli_InitializeScalaJS$().U7($m_ju_UUID$().aW()).g();
  var pagination = $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(paginationId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("pagination pagination-sm justify-content-end", $m_Lscalatags_JsDom$all$().s)]));
  var navTag = $m_Lscalatags_JsDom$tags2$().aiW().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "aria-label", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n("Pagination", $m_Lscalatags_JsDom$all$().s), pagination]));
  var tableRowsLengthInput = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__dataTablesLengthOption__T__I__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, tableId, $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLength__T__I__I($thiz, tableId, tableSetupData.lp), ec);
  var rowsPerPageDiv = ((inGroupModeInd && (!maxWidth.c())) ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("text-muted", $m_Lscalatags_JsDom$all$().s)])) : $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(" text-muted", $m_Lscalatags_JsDom$all$().s), tableRowsLengthInput])));
  var messageDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("text-muted table-messages mt-1", $m_Lscalatags_JsDom$all$().s), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableRecordsMessage__T__Lcom_papasofokli_dataTables_GetRowsResult__Z__I__Lscalatags_JsDom$TypedTag($thiz, tableId, data, inGroupModeInd, tableSetupData.lp)]));
  var paginationDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), $thiz.NX, ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(tableId, $m_Lscalatags_JsDom$all$().s), navTag]));
  var footerDiv = ((inGroupModeInd && (!maxWidth.c())) ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex justify-content-between dynamic-max-width", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ak3().n((("--custom-max-width:" + maxWidth.h()) + "px"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [])), messageDiv, paginationDiv])) : $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex justify-content-between", $m_Lscalatags_JsDom$all$().s), rowsPerPageDiv, messageDiv, paginationDiv])));
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__replaceElementContents__T__s_Option__Lscalatags_JsDom$TypedTag__V($thiz, ("" + paginationRowId), $m_s_None$(), footerDiv);
  $m_Lcom_papasofokli_pagination_PaginationJs$().MY(paginationId, ((data.jS > 0) ? data.jS : data.hq), rowsPerPage, initialPage, (isLazyLoad ? "Load all" : "Last"), new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__paginationPageClickedF__Lorg_scalajs_dom_Element__I__T__T__Z__s_concurrent_ExecutionContext__V($thiz, v1$2, (v2$2 | 0), tableId, paginationRowId, inGroupModeInd, ec);
  })), tableId);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createInnerTablePagination__T__Lscalatags_JsDom$TypedTag($thiz, paginationId) {
  var pagination = $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(paginationId, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("pagination pagination-sm justify-content-end", $m_Lscalatags_JsDom$all$().s)]));
  var navTag = $m_Lscalatags_JsDom$tags2$().aiW().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "aria-label", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n("Pagination", $m_Lscalatags_JsDom$all$().s), pagination]));
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("float-end", $m_Lscalatags_JsDom$all$().s), navTag]));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableRecordsMessage__T__Lcom_papasofokli_dataTables_GetRowsResult__Z__I__Lscalatags_JsDom$TypedTag($thiz, tableId, data, inGroupModeInd, defaultRowsPerPage) {
  var rowsPerPage = (inGroupModeInd ? defaultRowsPerPage : $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLength__T__I__I($thiz, tableId, defaultRowsPerPage));
  var showingFrom = ((1 + Math.imul(data.p7, rowsPerPage)) | 0);
  var showingTo = Math.imul(rowsPerPage, ((1 + data.p7) | 0));
  var filteredInd = (data.jS !== data.hq);
  matchResult46: {
    var showingToTotal;
    if ((data.n4.F() < rowsPerPage)) {
      if (filteredInd) {
        var showingToTotal = data.jS;
        break matchResult46;
      }
      if ((!filteredInd)) {
        var showingToTotal = data.hq;
        break matchResult46;
      }
    }
    var showingToTotal = showingTo;
  }
  var cond = (filteredInd && (!data.jR));
  var filteredMsgO = (cond ? new $c_s_Some((("(filtered from " + data.hq) + " entries)")) : $m_s_None$());
  matchResult47: {
    var totalRecordsStr;
    var _1$mcZ$sp = data.jR;
    if (_1$mcZ$sp) {
      if ((data.hq > data.n4.F())) {
        var totalRecordsStr = (data.hq + "+");
        break matchResult47;
      }
      var totalRecordsStr = ("" + data.hq);
      break matchResult47;
    }
    if (((!_1$mcZ$sp) && filteredInd)) {
      var totalRecordsStr = ("" + data.jS);
      break matchResult47;
    }
    var totalRecordsStr = ("" + data.hq);
  }
  return $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(((((((("Showing " + showingFrom) + " to ") + showingToTotal) + " of ") + totalRecordsStr) + " entries ") + (filteredMsgO.c() ? "" : filteredMsgO.h()))))]));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__refreshRecordsMessage__Lcom_papasofokli_dataTables_GetRowsResult__T__T__Z__V($thiz, data, paginationRowId, tableId, inGroupModeInd) {
  var textSpan = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableRecordsMessage__T__Lcom_papasofokli_dataTables_GetRowsResult__Z__I__Lscalatags_JsDom$TypedTag($thiz, tableId, data, inGroupModeInd, $thiz.v7);
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__replaceElementContents__T__s_Option__Lscalatags_JsDom$TypedTag__V($thiz, ("" + paginationRowId), $m_s_Option$().Z(".table-messages"), textSpan);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__paginationPageClickedF__Lorg_scalajs_dom_Element__I__T__T__Z__s_concurrent_ExecutionContext__V($thiz, pagination, num, tableId, paginationRowId, inGroupModeInd, executionContext) {
  pagination.setAttribute("disabled", "true");
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, $m_s_Option$().Z(num), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz), executionContext).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((dataO$3) => {
    if ((!dataO$3.c())) {
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__refreshRecordsMessage__Lcom_papasofokli_dataTables_GetRowsResult__T__T__Z__V($thiz, dataO$3.h(), paginationRowId, tableId, inGroupModeInd);
    }
  })), executionContext);
  pagination.setAttribute("disabled", "false");
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadInnerTableRows__T__I__T__sci_Seq__sci_Seq__O__sci_Seq__sci_Seq__I__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, parentTdId, pageNo, tableId, columnGroupBy, keyValues, groupExpandFunIdO, columns, columnActualWidths, stickyColNo, executionContext) {
  var tbl = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var dateColumnGroupType = tbl.getAttribute($thiz.r9);
  matchResult48: {
    var \u03b419$;
    var x113 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId);
    if ((x113 !== null)) {
      x113.P();
      x113.V();
      var \u03b419$ = x113;
      break matchResult48;
    }
    throw new $c_s_MatchError(x113);
  }
  var sortColumn$2 = \u03b419$.P();
  var sortDirection$2 = \u03b419$.V();
  var keyValues$1 = columnGroupBy.bY(keyValues).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var col = x$1$2.P();
      var value = x$1$2.V();
      return new $c_T3(col.p6, new $c_Lcom_papasofokli_dataTables_ColumnGroup(value, $m_s_None$(), $m_s_None$(), $m_s_None$()), col.iF);
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  var groupLevel$2 = ((keyValues.F() - 1) | 0);
  var columnsSearch$2 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__readFilters__T__sci_IndexedSeq($thiz, tableId);
  var innerTablePageNo$1 = $m_s_Option$().Z(pageNo);
  var headersWidth$2;
  var headersWidth$2 = $m_sci_Set$EmptySet$();
  $m_sc_StringOps$();
  var tableGroupRequest = new $c_Lcom_papasofokli_dataTables_TableGroupRequest(keyValues$1, groupLevel$2, columnGroupBy, headersWidth$2, $m_s_None$(), $m_s_None$(), ((dateColumnGroupType !== "") ? new $c_s_Some(dateColumnGroupType) : $m_s_None$()), sortColumn$2, sortDirection$2, columnsSearch$2, $m_Lcom_papasofokli_dataTables_TableGroupRequest$().I6(), innerTablePageNo$1);
  var sentData = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), tableGroupRequest, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableGroupRequest$().q());
  var x = ((groupExpandFunIdO === (void 0)) ? (void 0) : $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(groupExpandFunIdO, sentData, executionContext));
  if ((x === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
  }
  return x.aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result$2) => $m_sjs_js_Thenable$Implicits$().bH(result$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
    var tableGroupedResult = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_dataTables_TableGroupedResult$().q());
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__deleteSubTableRows__Lorg_scalajs_dom_HTMLTableElement__T__Z__V($thiz, tbl, (parentTdId + "R"), true);
    var createPageFunO = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__drawInnerTable__T__T__Lorg_scalajs_dom_HTMLTableElement__Lcom_papasofokli_dataTables_TableGroupedResult__sci_Seq__sci_Seq__O__s_Option__s_concurrent_ExecutionContext__s_Option($thiz, tableId, parentTdId, tbl, tableGroupedResult, columnGroupBy, keyValues, groupExpandFunIdO, $m_s_Option$().Z(pageNo), executionContext);
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCellsLeftStyleProperty__Lorg_scalajs_dom_Element__sci_Seq__I__V($thiz, tbl, columnActualWidths, stickyColNo);
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__postReloadFunction__T__sci_Seq__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, columns, $m_sci_Nil$(), executionContext);
    var this$39 = (createPageFunO.c() ? $m_s_None$() : new $c_s_Some((createPageFunO.h().aA(), (void 0))));
    if ((!this$39.c())) {
      this$39.h();
    }
    $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
  })), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTopRow__T__T__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, tableId, topRowId, helpButton, clearButton, chartButton, groupOptionsButton, exportButtonUI, switchButtonUI, tableSetupData, ec) {
  groupOptionsButton.addEventListener("click", ((_$67$2) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeGroupingOptionLinks__T__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, ec);
    return new $c_Lcom_papasofokli_util_MultipleEventHandler(50, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var containerElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "-container"));
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V($thiz, tableId, (!(!$f_sc_SeqOps__isEmpty__Z(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(containerElement.querySelectorAll(((((("." + $thiz.Jx) + ".") + $thiz.Oc) + ".") + $thiz.Ar)))))));
    })));
  }));
  if ((!(!exportButtonUI.classList.contains("btn")))) {
    exportButtonUI.addEventListener("click", ((_$68$2) => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__exportDataFunction__T__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, tableSetupData, ec)));
  }
  switchButtonUI.addEventListener("click", ((_$69$2) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__switchViewFunction__T__V($thiz, tableId);
  }));
  var this$6 = tableSetupData.lo;
  if (this$6.c()) {
    var additionalButtonsO = $m_s_None$();
  } else {
    var x0 = this$6.h();
    var addlBtnDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("ms-1", $m_Lscalatags_JsDom$all$().s)])).aB();
    addlBtnDiv.innerHTML = x0;
    var additionalButtonsO = new $c_s_Some(addlBtnDiv);
  }
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex justify-content-between  flex-wrap mb-2", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getRefreshButton__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement($thiz, tableId, topRowId, ec))])), ((!tableSetupData.jV.c()) ? new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createNewButton$1__Lcom_papasofokli_dataTables_TableSetupData__Lorg_scalajs_dom_HTMLDivElement($thiz, tableSetupData)) : ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(""))), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), additionalButtonsO, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex justify-content-end", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().A1().n("Switch view", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), switchButtonUI)])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().A1().n("Export data", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), exportButtonUI)])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().A1().n("Aggregation options", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), groupOptionsButton)])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), chartButton)])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), clearButton)])), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), helpButton)])), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSearchInput__T__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, tableId, ec)]))]));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__dataTablesLengthOption__T__I__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag($thiz, tableId, defaultRowsPerPage, ec) {
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("dataTables_length", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().avV().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag("Rows per page  ")), $m_Lscalatags_JsDom$all$().ajE().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n((tableId + "000"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("form-control input-sm table-length table-row-per-page-input", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().aj5().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableEvent__T__s_concurrent_ExecutionContext__F1($thiz, tableId, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLengthSelectInput__I__I__Lscalatags_JsDom$TypedTag($thiz, 10, defaultRowsPerPage), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLengthSelectInput__I__I__Lscalatags_JsDom$TypedTag($thiz, 25, defaultRowsPerPage), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLengthSelectInput__I__I__Lscalatags_JsDom$TypedTag($thiz, 50, defaultRowsPerPage), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLengthSelectInput__I__I__Lscalatags_JsDom$TypedTag($thiz, 100, defaultRowsPerPage)]))]))]));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLengthSelectInput__I__I__Lscalatags_JsDom$TypedTag($thiz, rowPerPageValue, defaultRowsPerPage) {
  return ((rowPerPageValue === defaultRowsPerPage) ? $m_Lscalatags_JsDom$all$().Ne().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().NG().n(("" + rowPerPageValue), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ajF().n("selected", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + rowPerPageValue)))])) : $m_Lscalatags_JsDom$all$().Ne().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().NG().n(("" + rowPerPageValue), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("" + rowPerPageValue)))])));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableEvent__T__s_concurrent_ExecutionContext__F1($thiz, tableId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$70$2) => new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz), ec))))));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__refreshButtonEvent__T__T__s_concurrent_ExecutionContext__F1($thiz, tableId, topRowId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$71$2) => {
    var topRowElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowId);
    var buttonJs = topRowElement.querySelector(".fa-sync");
    buttonJs.classList.add("fa-spin");
    return new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set($thiz), ec).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$72$3) => {
      buttonJs.classList.remove("fa-spin");
    })), ec))));
  }));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__clearFunctionS__T__s_concurrent_ExecutionContext__V($thiz, tableId, executionContext) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var chartDiv = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "chart"));
  var elements = tableElement.querySelectorAll(("." + $thiz.v8));
  chartDiv.innerHTML = "";
  tableElement.classList.remove("hidden");
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V($thiz, tableId, true);
  if ((new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements).F() === 1)) {
    $thiz.IJ(tableId, new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements).l().e(), true, executionContext);
  } else {
    $f_sc_IterableOps__tail__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements)).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elm$2) => $thiz.IJ(tableId, elm$2, false, executionContext))));
    $thiz.IJ(tableId, new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements).l().e(), true, executionContext);
  }
  var topRowId = tableElement.getAttribute($thiz.EP);
  var btn = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowId).querySelector(".chart-button");
  if ((!(!btn.classList.contains("btn-danger")))) {
    btn.classList.remove("btn-danger");
    btn.classList.add("btn-primary");
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__switchViewFunction__T__V($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  if ((!(!tableElement.classList.contains("no-card")))) {
    tableElement.classList.remove("no-card");
  } else {
    tableElement.classList.add("no-card");
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__exportDataFunction__T__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, tableId, tableSetupData, executionContext) {
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(500, 0, executionContext);
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var columnGroupBy = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingInformation__T__sci_Seq($thiz, tableId).bU($m_s_$less$colon$less$().b0);
  var groupingCalculationType = tableElement.getAttribute($thiz.v9);
  var dateColumnGroupType = tableElement.getAttribute($thiz.r9);
  var exportRequestFunIdAttributeId = tableElement.getAttribute($thiz.O0);
  var containerElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "-container"));
  var exportDetailsOptionCheckO = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(containerElement.querySelectorAll(("input." + $thiz.Xy))));
  var exportDetailsIndO = (exportDetailsOptionCheckO.c() ? $m_s_None$() : new $c_s_Some(exportDetailsOptionCheckO.h()));
  var columnTypeMap = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getColumnTypeMap__Lcom_papasofokli_dataTables_TableSetupData__sci_Map($thiz, tableSetupData);
  matchResult54: {
    var \u03b425$;
    var x123 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId);
    if ((x123 !== null)) {
      x123.P();
      x123.V();
      var \u03b425$ = x123;
      break matchResult54;
    }
    throw new $c_s_MatchError(x123);
  }
  var sortColumn$2 = \u03b425$.P();
  var sortDirection$2 = \u03b425$.V();
  var groupByCols = columnGroupBy.bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12(columnTypeMap)).bU($m_s_$less$colon$less$().b0);
  var groupLevel$3 = $m_s_Option$().Z(0);
  var groupCalculationType$3 = (($m_sc_StringOps$(), (groupingCalculationType !== "")) ? new $c_s_Some(groupingCalculationType) : new $c_s_Some("total"));
  $m_sc_StringOps$();
  var cond = (dateColumnGroupType !== "");
  var dateColumnGroupType$3 = (cond ? new $c_s_Some(dateColumnGroupType) : $m_s_None$());
  var columnsSearch$3 = $m_sci_Nil$();
  var blockAggregationIndexes$3 = $m_sci_Set$().jp($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getBlockAggregationIndexes__Lorg_scalajs_dom_Element__sc_Seq($thiz, tableElement));
  if (exportDetailsIndO.c()) {
    var exportDetailsIndicator$2 = $m_s_None$();
  } else {
    var x0$1 = exportDetailsIndO.h();
    var exportDetailsIndicator$2 = new $c_s_Some((!(!x0$1.checked)));
  }
  var headersWidth$3 = $m_Lcom_papasofokli_dataTables_TableParameters$().DJ();
  var maxClientWidth$3 = $m_s_None$();
  var params = new $c_Lcom_papasofokli_dataTables_TableParameters(1, 1, $thiz.v7, "", sortColumn$2, sortDirection$2, columnsSearch$3, false, groupByCols, blockAggregationIndexes$3, groupLevel$3, headersWidth$3, maxClientWidth$3, groupCalculationType$3, dateColumnGroupType$3, true, exportDetailsIndicator$2);
  var json = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), params, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableParameters$().q());
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(exportRequestFunIdAttributeId).g(), json, executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result$2) => freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), executionContext))), executionContext);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__showChartFunctionS__T__T__s_concurrent_ExecutionContext__O($thiz, tableId, topRowId, executionContext) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var chartRequestFunId = tableElement.getAttribute($thiz.Xr);
  var columnGroupBy = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingInformation__T__sci_Seq($thiz, tableId).bU($m_s_$less$colon$less$().b0);
  var chartDiv = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "chart"));
  var groupingCalculationType = tableElement.getAttribute($thiz.v9);
  var dateColumnGroupType = tableElement.getAttribute($thiz.r9);
  matchResult58: {
    var \u03b42$;
    var x129 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId);
    if ((x129 !== null)) {
      x129.P();
      x129.V();
      var \u03b42$ = x129;
      break matchResult58;
    }
    throw new $c_s_MatchError(x129);
  }
  var sortColumn$2 = \u03b42$.P();
  var sortDirection$2 = \u03b42$.V();
  var groupOptionElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowId).querySelector(("." + $thiz.Jp));
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V($thiz, tableId, true);
  if ((!(!tableElement.classList.contains("hidden")))) {
    chartDiv.innerHTML = "";
    tableElement.classList.remove("hidden");
    var btn = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowId).querySelector(".chart-button");
    btn.classList.remove("btn-danger");
    btn.classList.add("btn-primary");
    groupOptionElement.classList.remove("hidden");
    return (void 0);
  } else {
    var btn$2 = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, topRowId).querySelector(".chart-button");
    btn$2.classList.remove("btn-primary");
    btn$2.classList.add("btn-danger");
    groupOptionElement.classList.add("hidden");
    var columnGroupBy$1 = columnGroupBy.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => new $c_Lcom_papasofokli_dataTables_ColumnGroupOption((x$3 | 0), 0))));
    var groupLevel$1 = $m_s_Option$().Z(0);
    $m_sc_StringOps$();
    var cond = (groupingCalculationType !== "");
    var groupCalculationType$1 = (cond ? new $c_s_Some(groupingCalculationType) : $m_s_None$());
    $m_sc_StringOps$();
    var cond$1 = (dateColumnGroupType !== "");
    var dateColumnGroupType$1 = (cond$1 ? new $c_s_Some(dateColumnGroupType) : $m_s_None$());
    var columnsSearch$1 = $m_sci_Nil$();
    var blockAggregationIndexes$1 = $m_Lcom_papasofokli_dataTables_TableParameters$().oB();
    var headersWidth$1 = $m_Lcom_papasofokli_dataTables_TableParameters$().DJ();
    var maxClientWidth$1 = $m_s_None$();
    var exportDetailsIndicator$1 = $m_s_None$();
    var params = new $c_Lcom_papasofokli_dataTables_TableParameters(1, 1, $thiz.v7, "", sortColumn$2, sortDirection$2, columnsSearch$1, false, columnGroupBy$1, blockAggregationIndexes$1, groupLevel$1, headersWidth$1, maxClientWidth$1, groupCalculationType$1, dateColumnGroupType$1, true, exportDetailsIndicator$1);
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(chartRequestFunId, $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), params, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableParameters$().q()), executionContext).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((result$2) => $m_sjs_js_Thenable$Implicits$().bH(result$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      var tableGroupedResult = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_dataTables_TableGroupedResult$().q());
      var this$23 = tableGroupedResult.lm;
      var chartComponent = (this$23.c() ? "" : this$23.h());
      tableElement.classList.add("hidden");
      chartDiv.innerHTML = chartComponent;
      $m_Lcom_papasofokli_InitializeScalaJS$().b7(executionContext);
    })), executionContext))), executionContext);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V($thiz, tableId, hide) {
  var containerElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, (tableId + "-container"));
  var mainDiv = containerElement.querySelector(((("." + $thiz.Jx) + ".") + $thiz.Oc));
  var sideDiv = containerElement.querySelector(((("." + $thiz.Jx) + ".") + $thiz.XI));
  if (hide) {
    mainDiv.classList.remove($thiz.EO);
    mainDiv.classList.add($thiz.Ar);
    sideDiv.classList.remove($thiz.Ar);
    sideDiv.classList.add($thiz.EO);
  } else {
    mainDiv.classList.remove($thiz.Ar);
    mainDiv.classList.add($thiz.EO);
    sideDiv.classList.remove($thiz.EO);
    sideDiv.classList.add($thiz.Ar);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__serverFunctionS__T__T__s_concurrent_ExecutionContext__V($thiz, attr, tableId, executionContext) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var postReloadFunctionId = tableElement.getAttribute(attr);
  if (($m_sc_StringOps$(), (postReloadFunctionId !== ""))) {
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future($m_Lcom_papasofokli_util_AjaxCallFunctions$(), $m_ju_UUID$().aO(postReloadFunctionId).g(), "", executionContext);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableLength__T__I__I($thiz, tableId, rowsPerPage) {
  var containerDivElement = document.querySelector((("#" + tableId) + "-container.table-panel-container"));
  var lengthInputElement = containerDivElement.querySelector(".table-length");
  if ((lengthInputElement !== null)) {
    var length = lengthInputElement.value;
    var this$3 = ($m_sc_StringOps$(), $m_sc_StringParsers$().fs(length));
    return ((this$3.c() ? $thiz.v7 : this$3.h()) | 0);
  } else {
    return rowsPerPage;
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__replaceElementContents__T__s_Option__Lscalatags_JsDom$TypedTag__V($thiz, tableId, selector, replaceDivElement) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var element = ((!selector.c()) ? tableElement.querySelector(selector.h()) : tableElement);
  element.replaceChildren(replaceDivElement.aB());
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onClickCheckBox__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$2) => {
    event$2.preventDefault();
    return false;
  }));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__clickFunction__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, column, clickFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$2) => new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((freezePage) => (() => {
    event$2.preventDefault();
    var this$8 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var id = $m_ju_UUID$().aO(clickFunctionId);
    var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_dataTables_TableCellS($m_ju_UUID$().aO(rowId), column, $m_s_None$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableCellS$().q());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$8, id.g(), data, ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => freezePage.ep().aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => (void 0))), ec))), ec);
  }))(new $c_Lcom_papasofokli_util_FreezePage(300, 0, ec))))));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuClickFunction__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, column, clickFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$2) => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuEvent__T__I__T__Lorg_scalajs_dom_MouseEvent__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, rowId, column, clickFunctionId, event$2, ec)));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuEvent__T__I__T__Lorg_scalajs_dom_MouseEvent__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, rowId, column, clickFunctionId, event, ec) {
  event.preventDefault();
  $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$().Ey($doubleToInt((+event.pageX)), $doubleToInt((+event.pageY)));
  var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id = $m_ju_UUID$().aO(clickFunctionId);
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_dataTables_TableCellS($m_ju_UUID$().aO(rowId), column, $m_s_None$()), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_dataTables_TableCellS$().q());
  return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, id.g(), data, ec);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__onActionButtonClick__T__I__T__s_concurrent_ExecutionContext__F1($thiz, rowId, column, clickFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((multipleEventHandler) => ((event$2) => multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuEvent__T__I__T__Lorg_scalajs_dom_MouseEvent__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, rowId, column, clickFunctionId, event$2, ec))))))(new $c_Lcom_papasofokli_util_MultipleEventHandler(10, 0, ec)));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeActions__T__s_concurrent_ExecutionContext__V($thiz, tableId, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var tableSortIcons = tableElement.querySelectorAll(("." + $thiz.O3));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableSortIcons);
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.addEventListener("click", ((tableId, x0, ec) => ((_$75$2) => $thiz.ajT(tableId, x0, $m_s_None$(), ec)))(tableId, x0, ec));
    x0.classList.remove($thiz.O3);
  }
  var tableGroupIcons = tableElement.querySelectorAll(("." + $thiz.O2));
  var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableGroupIcons);
  var it$1 = this$5.l();
  while (it$1.f()) {
    var x0$1 = it$1.e();
    x0$1.addEventListener("click", ((tableId, x0$1, ec) => ((_$76$2) => $thiz.IJ(tableId, x0$1, true, ec)))(tableId, x0$1, ec));
    x0$1.classList.remove($thiz.O2);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__nodeToElement__Lorg_scalajs_dom_Node__s_Option($thiz, node) {
  return ((!(!(node instanceof Element))) ? new $c_s_Some(node) : $m_s_None$());
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__changeSortIcon__T__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__V($thiz, sortDirection, e, iconElement) {
  iconElement.classList.remove($thiz.Js);
  e.removeAttribute($thiz.p8);
  if ((sortDirection === "asc")) {
    e.setAttribute($thiz.p8, "desc");
    iconElement.classList.add($thiz.Jt);
  } else {
    e.setAttribute($thiz.p8, "asc");
    iconElement.classList.add($thiz.Jr);
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__defaultSortHeadersProperties__T__sc_Seq($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  tableElement.removeAttribute($thiz.r8);
  tableElement.removeAttribute($thiz.p8);
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(("." + $thiz.Jt)));
  var it = this$2.l();
  while (it.f()) {
    var x0 = it.e();
    x0.classList.remove($thiz.Jt);
    x0.classList.add($thiz.Js);
  }
  var this$4 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(("." + $thiz.Jr)));
  var it$1 = this$4.l();
  while (it$1.f()) {
    var x0$1 = it$1.e();
    x0$1.classList.remove($thiz.Jr);
    x0$1.classList.add($thiz.Js);
  }
  return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(".sorting")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => {
    e$3.removeAttribute($thiz.p8);
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSortInformation__T__T2($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var tableHeaders = tableElement.querySelectorAll((("[" + $thiz.p8) + "]"));
  if (((tableHeaders.length | 0) > 0)) {
    $m_sc_StringOps$();
    var x = tableHeaders[0].getAttribute($thiz.r8);
    return new $c_T2($m_sc_StringParsers$().fs(x), tableHeaders[0].getAttribute($thiz.p8));
  } else {
    return new $c_T2($m_s_None$(), "");
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getGroupingInformation__T__sci_Seq($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var tableGroupColumns = tableElement.querySelectorAll(("." + $thiz.v8));
  var groupIndexes = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableGroupColumns), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elm$2) => {
    $m_sc_StringOps$();
    var x = elm$2.getAttribute(("" + $thiz.XC));
    var $x_1 = $m_sc_StringParsers$().fs(x);
    $m_sc_StringOps$();
    var x$1 = elm$2.getAttribute(("" + $thiz.Ap));
    return new $c_T2($x_1, $m_sc_StringParsers$().fs(x$1));
  })));
  if (groupIndexes.c()) {
    tableElement.classList.remove("noHover");
  } else {
    tableElement.classList.add("noHover");
  }
  return $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(groupIndexes, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      return x$1$2.V();
    }
    throw new $c_s_MatchError(x$1$2);
  })), ($m_s_math_Ordering$(), new $c_s_math_Ordering$O$1($m_s_math_Ordering$Int$()))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
    if ((x$1$2$1 !== null)) {
      return x$1$2$1.P();
    }
    throw new $c_s_MatchError(x$1$2$1);
  }))).cf();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeFilters__T__sci_Seq__sci_Set__sc_Seq($thiz, tableId, columns, headersWidth) {
  var res = 0;
  var it = columns.l();
  while (it.f()) {
    if ((!it.e().gk)) {
      res = ((1 + res) | 0);
    }
  }
  var noColumns = res;
  var overSize = (noColumns > 10);
  var minWidthO = (overSize ? new $c_s_Some(new $c_T2($m_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$(), ($thiz.Jo + "px"))) : $m_s_None$());
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(".search-th")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((headersWidthMap) => ((e$3) => {
    var isActionColumn = (!(!e$3.classList.contains("col-actions")));
    var child = e$3.querySelector((("[" + $thiz.r7) + "]"));
    var index = child.getAttribute($thiz.r7);
    var this$11 = ($m_sc_StringOps$(), $m_sc_StringParsers$().fs(index));
    if (this$11.c()) {
      var overwriteO = $m_s_None$();
    } else {
      var x0$1 = this$11.h();
      var key$2 = (x0$1 | 0);
      var overwriteO = headersWidthMap.b9(key$2);
    }
    var width = ((overSize && ((e$3.clientWidth | 0) < $thiz.Jo)) ? $thiz.Jo : (e$3.clientWidth | 0));
    if (isActionColumn) {
      var attribute = new $c_T2($m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$(), "40px");
    } else {
      var this$20 = (overwriteO.c() ? $m_s_None$() : new $c_s_Some(new $c_T2($m_Lcom_papasofokli_classes_custom_DynamicClass$MinWidth$(), ("" + (overwriteO.h() | 0)))));
      var this$21 = (this$20.c() ? minWidthO : this$20);
      var attribute = (this$21.c() ? new $c_T2($m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$(), (width + "px")) : this$21.h());
    }
    var this$27 = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(e$3.children));
    if (this$27.c()) {
      var this$32 = $m_s_None$();
    } else {
      var x0$3 = this$27.h();
      var this$30 = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x0$3.children));
      if (this$30.c()) {
        var this$32 = $m_s_None$();
      } else {
        var x0$4 = this$30.h();
        $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, attribute.V(), x0$4, attribute.P());
        var this$32 = new $c_s_Some((void 0));
      }
    }
    if ((!this$32.c())) {
      this$32.h();
    }
    var this$35 = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(e$3.children));
    if (this$35.c()) {
      var this$40 = $m_s_None$();
    } else {
      var x0$5 = this$35.h();
      var this$38 = $f_sc_IterableOps__headOption__s_Option(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x0$5.children));
      if (this$38.c()) {
        var this$40 = $m_s_None$();
      } else {
        var x0$6 = this$38.h();
        x0$6.classList.remove(("" + $thiz.Xq));
        var this$40 = new $c_s_Some((void 0));
      }
    }
    if ((!this$40.c())) {
      this$40.h();
    }
  }))($m_sci_Map$().dH(headersWidth))));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, attribute, e, dynamicClass) {
  e.classList.add(dynamicClass.gH());
  var \u03b426$ = e.style;
  \u03b426$.setProperty(dynamicClass.kG(), attribute);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeHeaders__T__sci_Set__sc_Seq($thiz, tableId, headersWidth) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var headersWidthMap = $m_sci_Map$().dH(headersWidth);
  return $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(".sort-th")), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$3) => {
    var isActionColumn = (!(!e$3.classList.contains("col-extra-small")));
    var child = e$3.querySelector(".sorting");
    var index = ((child !== null) ? child.getAttribute($thiz.O1) : "");
    var this$6 = ($m_sc_StringOps$(), $m_sc_StringParsers$().fs(index));
    if (this$6.c()) {
      var overwriteO = $m_s_None$();
    } else {
      var x0 = this$6.h();
      var key$2 = (x0 | 0);
      var overwriteO = headersWidthMap.b9(key$2);
    }
    if (isActionColumn) {
      var attribute___1 = $m_Lcom_papasofokli_classes_custom_DynamicClass$Width$();
      var attribute___2 = "30px";
    } else if ((!overwriteO.c())) {
      var attribute___1 = $m_Lcom_papasofokli_classes_custom_DynamicClass$Width$();
      var attribute___2 = (overwriteO.h() + "px");
    } else {
      var attribute___1 = $m_Lcom_papasofokli_classes_custom_DynamicClass$MaxWidth$();
      var attribute___2 = ((((e$3.clientWidth | 0) - 40) | 0) + "px");
    }
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, attribute___2, e$3.querySelector(".table-header-text"), attribute___1);
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__resizeStickyColum__T__I__V($thiz, tableId, stickyColNo) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var searchHeaders = tableElement.querySelectorAll("th.search-th.sticky-col");
  var sortHeaders = tableElement.querySelectorAll("th.sort-th.sticky-col");
  var columnActualWidths = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(searchHeaders), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => (e$2.clientWidth | 0)))).cf();
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setLeftStyleProperty__Lorg_scalajs_dom_NodeList__sci_Seq__V($thiz, searchHeaders, columnActualWidths);
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setLeftStyleProperty__Lorg_scalajs_dom_NodeList__sci_Seq__V($thiz, sortHeaders, columnActualWidths);
  $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCellsLeftStyleProperty__Lorg_scalajs_dom_Element__sci_Seq__I__V($thiz, tableElement, columnActualWidths, stickyColNo);
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setLeftStyleProperty__Lorg_scalajs_dom_NodeList__sci_Seq__V($thiz, elements, columnActualWidths) {
  $f_sc_IterableOps__zipWithIndex__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elements)).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult68: {
      if ((x$1$3 !== null)) {
        var e = x$1$3.P();
        var indx = (x$1$3.V() | 0);
        if ((indx > 0)) {
          $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, ((columnActualWidths.qO(indx).gO($m_s_math_Numeric$IntIsIntegral$()) | 0) + "px"), e, $m_Lcom_papasofokli_classes_custom_DynamicClass$Left$());
          break matchResult68;
        } else {
          break matchResult68;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCellsLeftStyleProperty__Lorg_scalajs_dom_Element__sci_Seq__I__V($thiz, tableElement, columnActualWidths, stickyColNo) {
  if ((!(stickyColNo < 0))) {
    var i = 0;
    while (true) {
      var x0 = i;
      if ((x0 > 0)) {
        var leftWidth = (columnActualWidths.qO(x0).gO($m_s_math_Numeric$IntIsIntegral$()) | 0);
        var cells = tableElement.querySelectorAll((("td.cell-index-" + x0) + ".sticky-col"));
        var this$7 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(cells);
        var it = this$7.l();
        while (it.f()) {
          var x0$1 = it.e();
          $p_Lcom_papasofokli_dataTables_ScalaJsTable$__setCustomAttribute__T__Lorg_scalajs_dom_Element__Lcom_papasofokli_classes_custom_DynamicClass__V($thiz, (leftWidth + "px"), x0$1, $m_Lcom_papasofokli_classes_custom_DynamicClass$Left$());
        }
      }
      if ((i === stickyColNo)) {
        return (void 0);
      }
      i = ((1 + i) | 0);
    }
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__readFilters__T__sci_IndexedSeq($thiz, tableId) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, tableId);
  var searchInputs = tableElement.querySelectorAll((("[" + $thiz.r7) + "]"));
  var end = (searchInputs.length | 0);
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  if (((end <= 0) && (!isEmpty))) {
    $m_sci_Range$().oY(0, end, 1, false);
  }
  var b = $m_sci_IndexedSeq$().aP();
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while (it.gu) {
    var x0 = it.jx();
    var element = searchInputs[x0];
    if ((!(!element.hasAttribute($thiz.r7)))) {
      var content = element.value;
      var index = element.getAttribute($thiz.r7);
      $m_sc_StringOps$();
      var $x_1 = ((content !== "") ? new $c_s_Some((((("[" + index) + "]:[") + content) + "]")) : $m_s_None$());
    } else {
      var $x_1 = $m_s_None$();
    }
    b.aD($x_1);
  }
  return b.aR();
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element($thiz, elementId) {
  return document.querySelector(("#" + elementId));
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSelectedPageNumber__ju_UUID__s_Option($thiz, tableUuid) {
  var tablePaginationElement = document.querySelector((((("[" + $thiz.NX) + "='") + tableUuid) + "']"));
  if ((tablePaginationElement !== null)) {
    var activePageElement = tablePaginationElement.querySelector($thiz.Xm);
    var pageAttribute = activePageElement.getAttribute($thiz.Xv);
    $m_sc_StringOps$();
    return $m_sc_StringParsers$().fs(pageAttribute);
  } else {
    return $m_s_None$();
  }
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getBlockAggregationIndexes__Lorg_scalajs_dom_Element__sc_Seq($thiz, tableElement) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(("." + $thiz.Jn))), new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14());
}
function $p_Lcom_papasofokli_dataTables_ScalaJsTable$__createNewButton$1__Lcom_papasofokli_dataTables_TableSetupData__Lorg_scalajs_dom_HTMLDivElement($thiz, tableSetupData$1) {
  var addButton = tableSetupData$1.jV;
  var addlBtnDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("ms-1", $m_Lscalatags_JsDom$all$().s)])).aB();
  addlBtnDiv.innerHTML = addButton.h();
  return addlBtnDiv;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$() {
  this.XE = null;
  this.NZ = null;
  this.XA = null;
  this.O8 = null;
  this.NW = null;
  this.Xt = null;
  this.Xx = null;
  this.Xw = null;
  this.Xu = null;
  this.EP = null;
  this.XF = null;
  this.O7 = null;
  this.XD = null;
  this.Ju = null;
  this.NX = null;
  this.Xv = null;
  this.r8 = null;
  this.p8 = null;
  this.O1 = null;
  this.XC = null;
  this.r7 = null;
  this.v9 = null;
  this.r9 = null;
  this.Jw = null;
  this.Ob = null;
  this.EN = null;
  this.Xr = null;
  this.O0 = null;
  this.Jv = null;
  this.O9 = null;
  this.v8 = null;
  this.Ap = null;
  this.Aq = null;
  this.NY = null;
  this.Jq = null;
  this.Js = null;
  this.Jr = null;
  this.Jt = null;
  this.Jp = null;
  this.Xz = null;
  this.Xn = null;
  this.Jn = null;
  this.XH = null;
  this.Jx = null;
  this.Oc = null;
  this.XI = null;
  this.EO = null;
  this.Ar = null;
  this.Xy = null;
  this.O3 = null;
  this.O2 = null;
  this.Xp = null;
  this.Xo = null;
  this.As = null;
  this.O6 = null;
  this.Xq = null;
  this.Oa = null;
  this.Xm = null;
  this.v7 = 0;
  this.Jo = 0;
  this.XB = null;
  this.XG = 0;
  this.O5 = 0;
  this.O4 = 0;
  this.NU = null;
  this.NV = null;
  this.Xs = null;
  $n_Lcom_papasofokli_dataTables_ScalaJsTable$ = this;
  $f_Lcom_papasofokli_dataTables_ScalaJsTableT__$init$__V(this);
  this.NV = $m_sci_Set$().jp($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [3, 5]));
  this.Xs = $m_sci_Set$().jp($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [2]));
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$.prototype = $p;
$p.av8 = (function(tableId, pageNum, ec) {
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, tableId);
  var topRowId = tableElement.getAttribute(this.EP);
  $m_sc_StringOps$();
  var x = tableElement.getAttribute(this.Ob);
  $m_sc_StringParsers$();
  _return: {
    var len = x.length;
    if ((len === 4)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(x, i);
        if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
          var $x_1 = false;
          break _return;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_1 = true;
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$8 = new $c_s_Some(true);
  } else {
    _return$1: {
      var len$1 = x.length;
      if ((len$1 === 5)) {
        var i$1 = 0;
        while ((i$1 !== len$1)) {
          var thisCP$1 = $f_T__codePointAt__I__I(x, i$1);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
            var $x_2 = false;
            break _return$1;
          }
          i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var this$8 = new $c_s_Some(false);
    } else {
      var this$8 = $m_s_None$();
    }
  }
  var inGroupModeInd = (!(!(this$8.c() ? false : this$8.h())));
  var helpButton = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getHelpButton__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement(this, tableId, ec);
  var clearButton = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getResetGroupingButton__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement(this, tableId, ec);
  var chartButton = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getChartButton__T__T__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLButtonElement(this, tableId, topRowId, ec);
  var exportRequestFunIdAttributeId = tableElement.getAttribute(this.O0);
  return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTableSetupDataF__T__s_concurrent_ExecutionContext__s_concurrent_Future(this, tableId, ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((setupData$2) => {
    var topRowElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, topRowId);
    var groupOptions = topRowElement.querySelector(("." + this.Jp));
    var exportButtonUI = topRowElement.querySelector(("." + this.Xz));
    var switchButtonUI = topRowElement.querySelector(("." + this.XH));
    if ((exportRequestFunIdAttributeId === "")) {
      exportButtonUI.classList.add("hidden");
    }
    var topRow = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getTopRow__T__T__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_HTMLButtonElement__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__Lcom_papasofokli_dataTables_TableSetupData__s_concurrent_ExecutionContext__Lscalatags_JsDom$TypedTag(this, tableId, topRowId, helpButton, clearButton, chartButton, groupOptions, exportButtonUI, switchButtonUI, setupData$2, ec);
    if ((!inGroupModeInd)) {
      topRowElement.replaceChildren(topRow.aB());
    }
    return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future(this, tableId, pageNum, false, $m_s_Option$().Z(setupData$2), $m_sci_Nil$(), setupData$2.re, ec).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((setupData$1) => ((x$1$2) => setupData$1))(setupData$2)), ec);
  })), ec).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__initializeActions__T__s_concurrent_ExecutionContext__V(this, tableId, ec);
  })), ec);
});
$p.ao1 = (function(tableCellData) {
  var pf = new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3();
  var this$2 = ((!tableCellData.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(tableCellData.h()) : $m_s_None$());
  return (this$2.c() ? $m_s_None$() : this$2.h().lh);
});
$p.ao2 = (function(tableCellData) {
  var pf = new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4();
  var this$2 = ((!tableCellData.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(tableCellData.h()) : $m_s_None$());
  return (this$2.c() ? $m_s_None$() : this$2.h().IG());
});
$p.ao0 = (function(tableCellData) {
  var pf = new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5();
  var this$2 = ((!tableCellData.c()) ? new $c_s_PartialFunction$Lifted(pf).Z(tableCellData.h()) : $m_s_None$());
  return (this$2.c() ? $m_s_None$() : this$2.h().Or);
});
$p.afZ = (function(cssClass) {
  var xs = $f_T__split__T__I__AT(cssClass, " ", 0);
  var evidence$1 = $m_s_reflect_ClassTag$().um($objectGetClass(xs).ax.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.dK();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    if (($m_sc_StringOps$(), (x !== ""))) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? $m_scm_ArrayBuilder$().u(elementClass) : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var xs$1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  var x$1 = this.Xp;
  var evidence$11__runtimeClass;
  var evidence$11__runtimeClass = $d_T.l();
  var this$13 = $m_s_Array$();
  var newLength = ((1 + xs$1.a.length) | 0);
  var runtimeClass = evidence$11__runtimeClass;
  if (((runtimeClass !== null) && (runtimeClass === $d_V.l()))) {
    var dest$1 = $p_s_Array$__newUnitArray__I__Ajl_Void(this$13, newLength);
  } else if (runtimeClass.ax.R($objectGetClass(xs$1).ax.Q().ax)) {
    var dest$1 = (runtimeClass.ax.X ? this$13.mA(xs$1, newLength) : $m_ju_Arrays$().Iv(xs$1, newLength, $objectGetClass(runtimeClass.ax.U(0))));
  } else {
    var componentType = evidence$11__runtimeClass;
    var dest = componentType.ax.U(newLength);
    $m_s_Array$().dd(xs$1, 0, dest, 0, xs$1.a.length);
    var dest$1 = dest;
  }
  $m_sr_ScalaRunTime$().bQ(dest$1, xs$1.a.length, x$1);
  return dest$1;
});
$p.afY = (function(cell, index, columnNames, rowId, singleClickFunIdO, doubleClickFunIdO, contextClickFunIdO, isBoolean, isSticky, isNumeric, ec) {
  var this$1 = columnNames.b9(index);
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var prefix = this.XB;
    var isIcon = (!(!x0.startsWith(prefix)));
  } else {
    var isIcon = false;
  }
  if (isBoolean) {
    $m_sc_StringOps$();
    $m_sc_StringParsers$();
    _return: {
      var len = cell.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(cell, i);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
            var $x_1 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      var this$9 = new $c_s_Some(true);
    } else {
      _return$1: {
        var len$1 = cell.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(cell, i$1);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_2 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_2 = true;
        } else {
          var $x_2 = false;
        }
      }
      if ($x_2) {
        var this$9 = new $c_s_Some(false);
      } else {
        var this$9 = $m_s_None$();
      }
    }
    if ((!(!(this$9.c() ? false : this$9.h())))) {
      var content = $m_Lscalatags_JsDom$all$().IN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("custom-checkbox", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("checkbox", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onClickCheckBox__F1(this), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().an9()]));
    } else {
      var content = $m_Lscalatags_JsDom$all$().IN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().uH().n("checkbox", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onClickCheckBox__F1(this), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]));
    }
  } else {
    var content = (isNumeric ? $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table-cell-size text-end", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "tabindex", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(index, $m_Lscalatags_JsDom$all$().qq), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(cell))])) : (isIcon ? $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("text-center", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().A1().n(cell, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("" + cell), $m_Lscalatags_JsDom$all$().s)]))])) : ((columnNames.b9(index).az(this.NU) && (!contextClickFunIdO.c())) ? $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(($m_Lcom_papasofokli_util_IconUI$().a8P.by + "  pointer  fa-sm text-body"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__onActionButtonClick__T__I__T__s_concurrent_ExecutionContext__F1(this, rowId, index, $dp_toString__T(contextClickFunIdO.h()), ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$2) => $m_sjs_js_Any$().b3(f$2$2))))))])) : $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table-cell-size", $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "tabindex", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(index, $m_Lscalatags_JsDom$all$().qq), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(cell))])))));
  }
  var tdCss = ((isBoolean || columnNames.b9(index).az(this.NU)) ? "cell-centered" : "");
  var stickyCssO = (isSticky ? new $c_s_Some((("cell-index-" + index) + " sticky-col")) : $m_s_None$());
  return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(((tdCss + " ") + (stickyCssO.c() ? "" : stickyCssO.h())), $m_Lscalatags_JsDom$all$().s), $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($m_Lscalatags_JsDom$all$(), "data-content", ($m_Lscalatags_JsDom$all$(), null), ($m_Lscalatags_JsDom$all$(), false)).n(("" + columnNames.f6(index, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => "")))), $m_Lscalatags_JsDom$all$().s), content, ((!singleClickFunIdO.c()) ? $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__clickFunction__T__I__T__s_concurrent_ExecutionContext__F1(this, rowId, index, $dp_toString__T(singleClickFunIdO.h()), ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$3) => $m_sjs_js_Any$().b3(f$2$3)))))) : $m_Lscalatags_JsDom$all$().fc().n((void 0), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$2) => value$2)))))), ((!doubleClickFunIdO.c()) ? $m_Lscalatags_JsDom$all$().J0().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__clickFunction__T__I__T__s_concurrent_ExecutionContext__F1(this, rowId, index, $dp_toString__T(doubleClickFunIdO.h()), ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$4) => $m_sjs_js_Any$().b3(f$2$4)))))) : $m_Lscalatags_JsDom$all$().J0().n((void 0), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$2$1) => value$2$1)))))), ((!contextClickFunIdO.c()) ? $m_Lscalatags_JsDom$all$().Nd().n($p_Lcom_papasofokli_dataTables_ScalaJsTable$__contextMenuClickFunction__T__I__T__s_concurrent_ExecutionContext__F1(this, rowId, index, $dp_toString__T(contextClickFunIdO.h()), ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$5) => $m_sjs_js_Any$().b3(f$2$5)))))) : $m_Lscalatags_JsDom$all$().Nd().n((void 0), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((value$2$2) => value$2$2))))))]));
});
$p.ajT = (function(tableId, element, sortDirectionO, ec) {
  var sortDirection = element.getAttribute(this.p8);
  var $x_1 = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec);
  $m_sc_StringOps$();
  var x = element.getAttribute(this.r8);
  var this$3 = $m_sc_StringParsers$().fs(x);
  return $x_1.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((sortIndex) => (() => {
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__defaultSortHeadersProperties__T__sc_Seq(this, tableId);
    var iconElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, tableId).querySelector((((("[" + this.O1) + "='") + sortIndex) + "']"));
    $p_Lcom_papasofokli_dataTables_ScalaJsTable$__changeSortIcon__T__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__V(this, (sortDirectionO.c() ? sortDirection : sortDirectionO.h()), element, iconElement);
    return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future(this, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set(this), ec);
  }))(((this$3.c() ? 1 : this$3.h()) | 0))));
});
$p.IJ = (function(tableId, element, reloadTable, ec) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec);
  var tableElement = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, tableId);
  var groupOrderAttributes = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll((("[" + this.Ap) + "]"))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$77$2) => _$77$2.getAttribute(this.Ap))));
  var maxGroupOrder = $f_sc_IterableOnceOps__maxByOption__F1__s_math_Ordering__s_Option(groupOrderAttributes.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$78$2) => {
    $m_sc_StringOps$();
    return $m_sc_StringParsers$().fs(_$78$2);
  }))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => x$2)), ($m_s_math_Ordering$(), new $c_s_math_Ordering$O$1($m_s_math_Ordering$Int$()))).ah5($m_s_$less$colon$less$().b0);
  return multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((parentThO) => (() => {
    if ((!(!element.classList.contains(this.v8)))) {
      element.classList.remove(this.v8);
      element.classList.remove("fa-regular");
      element.classList.remove("text-primary");
      element.classList.add("fa-thin");
      element.removeAttribute(this.Ap);
      if (parentThO.c()) {
        var this$11 = $m_s_None$();
      } else {
        var x0 = parentThO.h();
        x0.classList.remove("header-grouped-highlight");
        var this$11 = new $c_s_Some((void 0));
      }
      if ((!this$11.c())) {
        this$11.h();
      }
    } else {
      element.classList.add(this.v8);
      element.classList.remove("fa-thin");
      element.classList.add("fa-regular");
      element.classList.add("text-primary");
      element.setAttribute(this.Ap, ("" + ((1 + ((maxGroupOrder.c() ? 1 : maxGroupOrder.h()) | 0)) | 0)));
      if (parentThO.c()) {
        var this$15 = $m_s_None$();
      } else {
        var x0$1 = parentThO.h();
        x0$1.classList.add("header-grouped-highlight");
        var this$15 = new $c_s_Some((void 0));
      }
      if ((!this$15.c())) {
        this$15.h();
      }
    }
    var groupSelections = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll(("." + this.v8))).F();
    var topRowId = tableElement.getAttribute(this.EP);
    var groupOptions = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, topRowId).querySelector(("." + this.Jp));
    var clearBtnOptions = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, topRowId).querySelector(".clear-button");
    var chartBtnOptions = $p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSingleElement__T__Lorg_scalajs_dom_Element(this, topRowId).querySelector(".chart-button");
    if ((groupSelections === 0)) {
      groupOptions.classList.add("hidden");
      clearBtnOptions.classList.add("hidden");
      chartBtnOptions.classList.add("hidden");
      $p_Lcom_papasofokli_dataTables_ScalaJsTable$__handleOptionsSideBar__T__Z__V(this, tableId, true);
    } else {
      groupOptions.classList.remove("hidden");
      clearBtnOptions.classList.remove("hidden");
      chartBtnOptions.classList.remove("hidden");
    }
    if ((groupSelections > 0)) {
      var headerWidths = $m_sci_Set$().jp($f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(tableElement.querySelectorAll((("[" + this.r7) + "]"))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elm$2) => {
        var index = elm$2.getAttribute(this.r7);
        return new $c_T2(($m_sc_StringOps$(), $m_sc_StringParsers$().fs(index)), (((elm$2.clientWidth | 0) - 37) | 0));
      }))).bD(new $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13()));
    } else {
      var headerWidths;
      var headerWidths = $m_sci_Set$EmptySet$();
    }
    return (reloadTable ? $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future(this, tableId, $m_s_None$(), false, $m_s_None$(), $m_sci_Nil$(), headerWidths, ec) : $m_s_concurrent_Future$().aE($m_s_None$()));
  }))($p_Lcom_papasofokli_dataTables_ScalaJsTable$__nodeToElement__Lorg_scalajs_dom_Node__s_Option(this, element.parentNode.parentNode.parentNode))));
});
$p.ajk = (function(uuid, executionContext) {
  try {
    var $x_1 = new $c_s_util_Success($p_Lcom_papasofokli_dataTables_ScalaJsTable$__getSelectedPageNumber__ju_UUID__s_Option(this, uuid));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  var selectedPageNoO = $x_1.mN();
  return $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF__T__s_Option__Z__s_Option__sci_Seq__sci_Set__s_concurrent_ExecutionContext__s_concurrent_Future(this, uuid.g(), selectedPageNoO.ah5($m_s_$less$colon$less$().b0), true, $m_s_None$(), $m_sci_Nil$(), $p_Lcom_papasofokli_dataTables_ScalaJsTable$__reloadTableF$default$6__sci_Set(this), executionContext);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$, "com.papasofokli.dataTables.ScalaJsTable$", ({
  lu: 1,
  lJ: 1
}));
var $n_Lcom_papasofokli_dataTables_ScalaJsTable$;
function $m_Lcom_papasofokli_dataTables_ScalaJsTable$() {
  if ((!$n_Lcom_papasofokli_dataTables_ScalaJsTable$)) {
    $n_Lcom_papasofokli_dataTables_ScalaJsTable$ = new $c_Lcom_papasofokli_dataTables_ScalaJsTable$();
  }
  return $n_Lcom_papasofokli_dataTables_ScalaJsTable$;
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__addToSortableHandler__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, itemList) {
  return itemList.find(".list-group-item").one("mouseenter", $m_sjs_js_Any$().b3(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    var eLI = e$2.target;
    eLI.classList.add("sorting-initialize");
    return itemList.sortable("refresh");
  }))));
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__renderList__sci_Seq__sci_Set__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__sci_Seq($thiz, data, filtered, blockedList, contextMenuFunctionId, x$5) {
  return data.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((datum$2) => {
    var $x_1 = datum$2;
    if (filtered.az($bL($x_1.h9, $x_1.ha))) {
      var visibility = "show";
    } else {
      var visibility = "hidden";
    }
    var $x_2 = datum$2;
    if (blockedList.az($bL($x_2.h9, $x_2.ha))) {
      var blocked = "sortable-blocked-item";
    } else {
      var blocked = "";
    }
    var this$3 = datum$2.m5;
    if (this$3.c()) {
      var description = $m_s_None$();
    } else {
      var x0 = this$3.h();
      var description = new $c_s_Some($m_Lscalatags_JsDom$all$().ajN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("text-muted d-block pe-none", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x0))])));
    }
    var $x_5 = $m_Lscalatags_JsDom$all$().he();
    var $x_4 = $m_Lscalatags_JsDom$all$().bE();
    var $x_3 = datum$2;
    var liElement = $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4.n($bL($x_3.h9, $x_3.ha), $m_Lscalatags_JsDom$all$().Sy), $m_Lscalatags_JsDom$all$().D().n(((("list-group-item  " + visibility) + " ") + blocked), $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(datum$2.iV)), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), description, $m_s_$less$colon$less$().b0)])).aB();
    var $x_8 = $m_sjs_js_Any$();
    var $x_7 = $m_Lcom_papasofokli_util_CommonFunctionality$();
    var $x_6 = datum$2;
    var this$15_$_lo = $x_6.h9;
    var this$15_$_hi = $x_6.ha;
    liElement.addEventListener("contextmenu", $x_8.b3($x_7.agf($m_RTLong$().gc(this$15_$_lo, this$15_$_hi), contextMenuFunctionId.g(), x$5)));
    return new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), liElement).ky;
  })));
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__applyFilter__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__sci_Seq__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, filter, itemList, allData, blockedList, contextMenuFunctionId, x$6) {
  var this$1 = filter.value;
  var lowerFilter = this$1.toLowerCase();
  var currentListIds = $m_sci_Set$().jp($f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll((("#" + itemList.id) + " > li"))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => {
    $m_sc_StringOps$();
    return $m_jl_Long$().V5(_$3$2.id, 10);
  }))));
  var currentListData = allData.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((d$2) => {
    var $x_1 = d$2;
    return currentListIds.az($bL($x_1.h9, $x_1.ha));
  })));
  var filtered = $m_sci_Set$().jp(currentListData.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    var this$11 = _$4$2.iV;
    var this$12 = this$11.toLowerCase();
    return ((this$12.indexOf(lowerFilter) | 0) !== (-1));
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => {
    var $x_2 = _$5$2;
    return $bL($x_2.h9, $x_2.ha);
  }))));
  itemList.innerHTML = "";
  itemList.appendChild(new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__renderList__sci_Seq__sci_Set__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__sci_Seq($thiz, currentListData, filtered, blockedList, contextMenuFunctionId, x$6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2)))).uB());
  return $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__addToSortableHandler__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, (0, $m_Lcom_papasofokli_jquery_package$().I)(itemList));
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__clickHandler__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__sci_Seq__sci_Seq__T__ju_UUID__s_concurrent_ExecutionContext__F1($thiz, sourceList, sourceFilter, targetList, targetFilter, allData, blockedList, blockedMessage, contextMenuFunctionId, x$9) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => {
    var eLI = e$2.target;
    if ((!blockedList.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$3) => {
      var $x_1 = $uJ(_$6$3);
      var _$6$2_$_lo = $x_1.l;
      var _$6$2_$_hi = $x_1.h;
      return $m_RTLong$().gc(_$6$2_$_lo, _$6$2_$_hi);
    }))).az(eLI.id))) {
      var clikedItem = new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), eLI).ky;
      sourceList.removeChild(clikedItem);
      targetList.appendChild(clikedItem);
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + sourceList.id)).sortable("refresh");
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + targetList.id)).sortable("refresh");
      $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__applyFilter__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__sci_Seq__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, sourceFilter, sourceList, allData, blockedList, contextMenuFunctionId, x$9);
      $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__applyFilter__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__sci_Seq__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, targetFilter, targetList, allData, blockedList, contextMenuFunctionId, x$9);
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + sourceList.id)).triggerHandler("sortupdate");
      return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + targetList.id)).triggerHandler("sortupdate");
    } else {
      return (($m_sc_StringOps$(), (blockedMessage !== "")) ? ($m_Lcom_papasofokli_components_ToastJS$().IZ(blockedMessage, $m_s_Option$().Z($bL(1000, 0))), (void 0)) : (void 0));
    }
  }));
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__updateHandler__Lorg_scalajs_dom_HTMLUListElement__T__s_concurrent_ExecutionContext__F1($thiz, itemList, updateFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$3) => {
    var data = $f_sc_IterableOps__map__F1__O(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(document.querySelectorAll((("#" + itemList.id) + " > li"))), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => _$8$2.id))).cf();
    var this$9 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var id = $m_ju_UUID$().aO(updateFunctionId);
    var $x_1 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lupickle_default$();
    var this$7 = $m_Lupickle_default$();
    var data$1 = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_1, data, (-1), false, false, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7));
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$9, id.g(), data$1, ec);
  }));
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__createList__sci_Seq__T__ju_UUID__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement($thiz, data, idString, connectionClass, blockedList, contextMenuFunctionId, x$6) {
  return $m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(idString, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n((("list-group " + connectionClass) + " min-height-12"), $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__renderList__sci_Seq__sci_Set__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__sci_Seq($thiz, data, $m_sci_Set$().jp(data.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => {
    var $x_1 = _$9$2;
    return $bL($x_1.h9, $x_1.ha);
  })))), blockedList, contextMenuFunctionId, x$6), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB();
}
function $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__list__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__T__T__Lorg_scalajs_dom_HTMLDivElement($thiz, items, filter, title, cssClass) {
  var filterDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("form-group", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), filter)])).aB();
  return $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-md-6", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), filterDiv), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("panel panel-" + cssClass), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("panel-heading", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ahE().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("panel-title", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(title))]))])), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), items)]))])).aB();
}
/** @constructor */
function $c_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$() {
  this.Ot = null;
  this.Yk = null;
  this.Yn = null;
  this.Ym = null;
  this.Yp = null;
  this.Yl = null;
  this.Yo = null;
  this.Yq = null;
  $n_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$ = this;
  $f_Lcom_papasofokli_sortable_SortableConnectedListsT__$init$__V(this);
}
$p = $c_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$;
/** @constructor */
function $h_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$() {
}
$h_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$.prototype = $p;
$p.b7 = (function(ec) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + this.Ot)).each(((this$1) => (function() {
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(this.getAttribute(this$1.Yq), "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => {
      var setupData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$().q());
      var connectionClass = $m_ju_UUID$().aW();
      var blockedListIds = setupData.xj;
      var this$5 = setupData.nO;
      var blockedItemsMessage = (this$5.c() ? "" : this$5.h());
      var leftList = $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__createList__sci_Seq__T__ju_UUID__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement(this$1, setupData.sS, (("" + this$1.Yl) + this.id), connectionClass, blockedListIds, setupData.ke, ec);
      var rightList = $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__createList__sci_Seq__T__ju_UUID__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLUListElement(this$1, setupData.sT, (("" + this$1.Yo) + this.id), connectionClass, blockedListIds, setupData.ke, ec);
      var leftFilter = $m_Lscalatags_JsDom$all$().IN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("form-control form-control-sm mb-2", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().V9().n("Filter", $m_Lscalatags_JsDom$all$().s)])).aB();
      var rightFilter = $m_Lscalatags_JsDom$all$().IN().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n($m_ju_UUID$().aW().g(), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n("form-control form-control-sm mb-2", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().V9().n("Filter", $m_Lscalatags_JsDom$all$().s)])).aB();
      var leftSide = $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__list__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__T__T__Lorg_scalajs_dom_HTMLDivElement(this$1, leftList, leftFilter, setupData.xl, "primary");
      var rightSide = $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__list__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__T__T__Lorg_scalajs_dom_HTMLDivElement(this$1, rightList, rightFilter, setupData.xn, "success");
      var allItems = setupData.sS.cH(setupData.sT);
      leftFilter.onkeyup = ((_$1$2) => $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__applyFilter__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__sci_Seq__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$1, leftFilter, leftList, allItems, blockedListIds, setupData.ke, ec));
      rightFilter.onkeyup = ((_$2$2) => $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__applyFilter__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__sci_Seq__sci_Seq__ju_UUID__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$1, rightFilter, rightList, allItems, blockedListIds, setupData.ke, ec));
      leftList.onclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__clickHandler__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__sci_Seq__sci_Seq__T__ju_UUID__s_concurrent_ExecutionContext__F1(this$1, leftList, leftFilter, rightList, rightFilter, allItems, $m_sci_Nil$(), "", setupData.ke, ec));
      rightList.onclick = $m_sjs_js_Any$().b3($p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__clickHandler__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLUListElement__Lorg_scalajs_dom_HTMLInputElement__sci_Seq__sci_Seq__T__ju_UUID__s_concurrent_ExecutionContext__F1(this$1, rightList, rightFilter, leftList, leftFilter, allItems, blockedListIds, blockedItemsMessage, setupData.ke, ec));
      (0, $m_Lcom_papasofokli_jquery_package$().I)(this).children().remove().end().append($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), leftSide), new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), rightSide)])).aB()).removeClass(this$1.Ot);
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + leftList.id)).on("sortupdate", $m_sjs_js_Any$().b3($p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__updateHandler__Lorg_scalajs_dom_HTMLUListElement__T__s_concurrent_ExecutionContext__F1(this$1, leftList, setupData.xk.g(), ec)));
      (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + rightList.id)).on("sortupdate", $m_sjs_js_Any$().b3($p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__updateHandler__Lorg_scalajs_dom_HTMLUListElement__T__s_concurrent_ExecutionContext__F1(this$1, rightList, setupData.xm.g(), ec)));
      var $x_1 = (0, $m_Lcom_papasofokli_jquery_package$().I)(((("#" + leftList.id) + ", #") + rightList.id));
      var connectWith$1 = ("." + connectionClass);
      var allSortable = $x_1.sortable(new ($a_Lcom_papasofokli_jquery_SortableSettings())((void 0), (void 0), (void 0), (void 0), connectWith$1, (void 0), "", ".sorting-initialize"));
      allSortable.disableSelection();
      return $p_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$__addToSortableHandler__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery(this$1, allSortable);
    })), ec))), ec);
  }))(this));
});
var $d_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$ = new $TypeData().i($c_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$, "com.papasofokli.docgenerator.SortableConnectedListsJS$", ({
  mo: 1,
  rD: 1
}));
var $n_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$;
function $m_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$() {
  if ((!$n_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$)) {
    $n_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$ = new $c_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$();
  }
  return $n_Lcom_papasofokli_docgenerator_SortableConnectedListsJS$;
}
function $p_Lcom_papasofokli_input_EnhancedTextInputJs$__handleInput__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLDivElement__F1($thiz, textArea, highlighter) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    var text = textArea.value;
    var highlightedText = $p_Lcom_papasofokli_input_EnhancedTextInputJs$__applyHighlights__T__T($thiz, text);
    highlighter.innerHTML = highlightedText;
  }));
}
function $p_Lcom_papasofokli_input_EnhancedTextInputJs$__applyHighlights__T__T($thiz, text) {
  return $thiz.ZM.ajo($thiz.ZK.ajo(text, "\n\n"), "<mark>$0</mark>");
}
function $p_Lcom_papasofokli_input_EnhancedTextInputJs$__handleScroll__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__F1($thiz, textarea, backdrop) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    var scrollPos = (+textarea.scrollTop);
    backdrop.scrollTop = scrollPos;
    var scrollLeft = (+textarea.scrollLeft);
    backdrop.scrollLeft = scrollLeft;
  }));
}
function $p_Lcom_papasofokli_input_EnhancedTextInputJs$__fun$1__Lorg_scalajs_dom_Element__V($thiz, element) {
  element.classList.remove($thiz.Ou);
  var textArea = element.querySelector("textarea");
  var highlighter = element.querySelector(("." + $thiz.ZL));
  var backdrop = element.querySelector(("." + $thiz.ZJ));
  textArea.addEventListener("input", $m_sjs_js_Any$().b3($p_Lcom_papasofokli_input_EnhancedTextInputJs$__handleInput__Lorg_scalajs_dom_HTMLInputElement__Lorg_scalajs_dom_HTMLDivElement__F1($thiz, textArea, highlighter)));
  textArea.addEventListener("scroll", $m_sjs_js_Any$().b3($p_Lcom_papasofokli_input_EnhancedTextInputJs$__handleScroll__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_Element__F1($thiz, textArea, backdrop)));
}
/** @constructor */
function $c_Lcom_papasofokli_input_EnhancedTextInputJs$() {
  this.Ou = null;
  this.ZJ = null;
  this.ZL = null;
  this.ZM = null;
  this.ZK = null;
  $n_Lcom_papasofokli_input_EnhancedTextInputJs$ = this;
  $f_Lcom_papasofokli_input_EnhancedTextInputT__$init$__V(this);
  this.ZM = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "\\{(\\w+?)\\}", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []));
  this.ZK = $m_sc_StringOps$().Va("\\n$");
}
$p = $c_Lcom_papasofokli_input_EnhancedTextInputJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_input_EnhancedTextInputJs$;
/** @constructor */
function $h_Lcom_papasofokli_input_EnhancedTextInputJs$() {
}
$h_Lcom_papasofokli_input_EnhancedTextInputJs$.prototype = $p;
$p.co = (function() {
  var enhancedTextInputComponents = document.querySelectorAll(("." + this.Ou));
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(enhancedTextInputComponents);
  var it = this$2.l();
  while (it.f()) {
    $p_Lcom_papasofokli_input_EnhancedTextInputJs$__fun$1__Lorg_scalajs_dom_Element__V(this, it.e());
  }
});
var $d_Lcom_papasofokli_input_EnhancedTextInputJs$ = new $TypeData().i($c_Lcom_papasofokli_input_EnhancedTextInputJs$, "com.papasofokli.input.EnhancedTextInputJs$", ({
  p1: 1,
  p2: 1
}));
var $n_Lcom_papasofokli_input_EnhancedTextInputJs$;
function $m_Lcom_papasofokli_input_EnhancedTextInputJs$() {
  if ((!$n_Lcom_papasofokli_input_EnhancedTextInputJs$)) {
    $n_Lcom_papasofokli_input_EnhancedTextInputJs$ = new $c_Lcom_papasofokli_input_EnhancedTextInputJs$();
  }
  return $n_Lcom_papasofokli_input_EnhancedTextInputJs$;
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V($thiz) {
  $thiz.ew().wR.cm($thiz.eI(), $thiz.qN());
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__existSubDepartment__Z($thiz) {
  var this$1 = $thiz.Mt();
  var these = this$1;
  while ((!these.c())) {
    if (((these.W() instanceof $c_Lcom_papasofokli_planning_api_NodeDivisionSVG) || false)) {
      return true;
    }
    these = these.ak();
  }
  return false;
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__addDivisionRow__ju_UUID__Lcom_papasofokli_planning_DivisionData__s_concurrent_Future($thiz, uuid, divisionData) {
  return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(uuid.g(), $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), divisionData, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_planning_DivisionData$().q()), $thiz.hL()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((periodsResponse$2) => $m_sjs_js_Thenable$Implicits$().bH(periodsResponse$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$2) => new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((keys) => (() => {
    $thiz.ew().AQ.p(keys);
  }))($f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$2, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))).bY($thiz.qH()).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var periods$1 = x$1$2.P();
      return new $c_Lcom_papasofokli_planning_RowPeriodKey(x$1$2.V().m0, periods$1);
    }
    throw new $c_s_MatchError(x$1$2);
  }))))))), $thiz.hL()))), $thiz.hL());
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__removeSummaryRow__s_concurrent_Future($thiz) {
  return $m_s_concurrent_Future$().un(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $thiz.ew().AR.p($thiz.qH().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.m0))));
  })))), $thiz.hL());
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__loadDepartmentSummaryRow__ju_UUID__Lcom_papasofokli_planning_DivisionData__s_concurrent_Future($thiz, uuid, divisionData) {
  return ($thiz.MZ() ? $p_Lcom_papasofokli_planning_api_DivisionsSVG__removeSummaryRow__s_concurrent_Future($thiz) : $p_Lcom_papasofokli_planning_api_DivisionsSVG__addDivisionRow__ju_UUID__Lcom_papasofokli_planning_DivisionData__s_concurrent_Future($thiz, uuid, divisionData));
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__departmentCompress__V($thiz) {
  $thiz.J8(Math.fround((Math.fround((-$thiz.ew().eW)) * Math.fround($thiz.qH().F()))));
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__departmentExtend__V($thiz) {
  $thiz.J8(Math.fround(($thiz.ew().eW * Math.fround($thiz.qH().F()))));
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__departmentResized__Lcom_papasofokli_planning_api_DivisionsSVG($thiz) {
  if ($thiz.MZ()) {
    $p_Lcom_papasofokli_planning_api_DivisionsSVG__departmentCompress__V($thiz);
  } else {
    $p_Lcom_papasofokli_planning_api_DivisionsSVG__departmentExtend__V($thiz);
  }
  return $thiz;
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summarySubjectId__J($thiz) {
  var x6 = $thiz.Mv();
  if ((x6 instanceof $c_Lcom_papasofokli_planning_NodeData)) {
    var $x_1 = x6;
    var x13_$_lo = $x_1.qu;
    var x13_$_hi = $x_1.qv;
    var x14 = x6.pk;
    return $uJ((x14.c() ? $bL(x13_$_lo, x13_$_hi) : x14.h()));
  }
  if ((x6 instanceof $c_Lcom_papasofokli_planning_LeafData)) {
    var $x_2 = x6;
    return $bL($x_2.u7, $x_2.u8);
  }
  throw new $c_s_MatchError(x6);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summaryLeafData__Lcom_papasofokli_planning_LeafData($thiz) {
  var x15 = $thiz.Mv();
  if ((x15 instanceof $c_Lcom_papasofokli_planning_NodeData)) {
    var $x_1 = x15;
    var x19_$_lo = $x_1.qu;
    var x19_$_hi = $x_1.qv;
    var x20 = x15.pk;
    var $x_2 = $uJ((x20.c() ? $bL(x19_$_lo, x19_$_hi) : x20.h()));
    return new $c_Lcom_papasofokli_planning_LeafData(x19_$_lo, x19_$_hi, $x_2.l, $x_2.h);
  }
  if ((x15 instanceof $c_Lcom_papasofokli_planning_LeafData)) {
    return x15;
  }
  throw new $c_s_MatchError(x15);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionManning__Z($thiz) {
  return $thiz.ew().wP.az($m_Lcom_papasofokli_planning_DivisionEnum$().a0V.i9);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionDaysOff__Z($thiz) {
  return $thiz.ew().wP.az($m_Lcom_papasofokli_planning_DivisionEnum$().a0U.i9);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG($thiz) {
  var $x_2 = $m_s_Option$();
  var $x_1 = $thiz.TU();
  var subjectId$1 = $x_2.Z($x_1);
  var subjectPeriods$1 = $m_sci_Nil$();
  var divisionData$1 = $thiz.TT();
  var timeLine$1 = $thiz.ew().nG;
  var periodHeight$1 = $thiz.ew().eW;
  var initialY$1 = Math.fround(($thiz.qN() + $thiz.eI()));
  var getAllRelevantPeriods$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    $uJ(_$2$3);
    return $m_sci_Nil$();
  }));
  var getRowSeamanPeriods$1 = $thiz.ew().sv;
  var periodSvgIndicationsSetup$1 = $thiz.ew().sx;
  var getSubjectIdByPosition$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => $m_s_None$()));
  return new $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(subjectId$1, divisionData$1, subjectPeriods$1, $m_sci_Nil$(), timeLine$1, initialY$1, periodHeight$1, periodSvgIndicationsSetup$1, getAllRelevantPeriods$1, true, getRowSeamanPeriods$1, getSubjectIdByPosition$1, $thiz.hL());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG($thiz) {
  var $x_2 = $m_s_Option$();
  var $x_1 = $thiz.TU();
  var subjectId$2 = $x_2.Z($x_1);
  var subjectPeriods$2 = $m_sci_Nil$();
  var divisionData$2 = $thiz.TT();
  var timeLine$2 = $thiz.ew().nG;
  var periodHeight$2 = $thiz.ew().eW;
  var initialY$2 = Math.fround(($thiz.qN() + $thiz.eI()));
  var getAllRelevantPeriods$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
    $uJ(_$4$3);
    return $m_sci_Nil$();
  }));
  var getRowSeamanPeriods$2 = $thiz.ew().sv;
  var periodSvgIndicationsSetup$2 = $thiz.ew().sx;
  var getSubjectIdByPosition$2 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => $m_s_None$()));
  return new $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(subjectId$2, divisionData$2, subjectPeriods$2, $m_sci_Nil$(), timeLine$2, initialY$2, periodHeight$2, periodSvgIndicationsSetup$2, getAllRelevantPeriods$2, true, getRowSeamanPeriods$2, getSubjectIdByPosition$2, $thiz.hL());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRowO__s_Option($thiz) {
  return ($thiz.TS() ? new $c_s_Some($thiz.ag6()) : $m_s_None$());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRowO__s_Option($thiz) {
  return ($thiz.TR() ? new $c_s_Some($thiz.ag4()) : $m_s_None$());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraRowSeq__sci_Seq($thiz) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($thiz.ag7(), new $c_sci_$colon$colon($thiz.ag5(), $m_sci_Nil$())), $m_s_$less$colon$less$().b0);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$manningLabelO__s_Option($thiz) {
  return ($thiz.TS() ? new $c_s_Some($thiz.aiO()) : $m_s_None$());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$daysOffLabelO__s_Option($thiz) {
  return ($thiz.TR() ? new $c_s_Some($thiz.agA()) : $m_s_None$());
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraLabelSeq__sci_Seq($thiz) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon($thiz.ag8(), new $c_sci_$colon$colon($thiz.ag3(), $m_sci_Nil$())), $m_s_$less$colon$less$().b0);
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionResize__F__V($thiz, newHeight) {
  $thiz.qH().bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult5: {
      if ((x$1$3 !== null)) {
        var row = x$1$3.P();
        var ind = (x$1$3.V() | 0);
        var extraHeight = Math.fround((Math.fround(((1 + ind) | 0)) * $thiz.ew().eW));
        row.gd(Math.fround((Math.fround(($thiz.qN() + newHeight)) - extraHeight)));
        break matchResult5;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  $thiz.E1().uC().bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
    matchResult6: {
      if ((x$1$3$1 !== null)) {
        var row$1 = x$1$3$1.P();
        var ind$1 = (x$1$3$1.V() | 0);
        row$1.axk(Math.fround((newHeight - Math.fround(($thiz.ew().eW * Math.fround((($thiz.E1().F() - 1) | 0)))))), Math.fround(($thiz.qN() + Math.fround(($thiz.ew().eW * Math.fround(ind$1))))));
        break matchResult6;
      }
      throw new $c_s_MatchError(x$1$3$1);
    }
  })));
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionTranslate__F__F__V($thiz, bottomBoundaries, newStartY) {
  $thiz.qH().bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult7: {
      if ((x$1$3 !== null)) {
        var row = x$1$3.P();
        var ind = (x$1$3.V() | 0);
        var extraHeight = Math.fround((Math.fround(((1 + ind) | 0)) * $thiz.ew().eW));
        row.gd(Math.fround((bottomBoundaries - extraHeight)));
        break matchResult7;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  $thiz.E1().uC().bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
    matchResult8: {
      if ((x$1$3$1 !== null)) {
        var row$1 = x$1$3$1.P();
        var ind$1 = (x$1$3$1.V() | 0);
        var extraHeight$1 = Math.fround((Math.fround(ind$1) * $thiz.ew().eW));
        row$1.akf(Math.fround((newStartY + extraHeight$1)));
        break matchResult8;
      }
      throw new $c_s_MatchError(x$1$3$1);
    }
  })));
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__performSummaryAction__s_Option($thiz) {
  var this$1 = $p_Lcom_papasofokli_planning_api_DivisionsSVG__actionData__s_Option($thiz);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    matchResult9: {
      var $x_1;
      if ((x0 !== null)) {
        var $x_1 = $p_Lcom_papasofokli_planning_api_DivisionsSVG__loadDepartmentSummaryRow__ju_UUID__Lcom_papasofokli_planning_DivisionData__s_concurrent_Future($thiz, x0.P(), x0.V());
        break matchResult9;
      }
      throw new $c_s_MatchError(x0);
    }
    return new $c_s_Some($x_1);
  }
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__actionData__s_Option($thiz) {
  var this$1 = $thiz.ew().AS;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_T2(this$1.h(), $thiz.Mv())));
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__clickFunction__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$3) => {
    ($p_Lcom_papasofokli_planning_api_DivisionsSVG__existSubDepartment__Z($thiz) ? $p_Lcom_papasofokli_planning_api_DivisionsSVG__totalDivisionSummaryAction__s_concurrent_Future($thiz).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => $p_Lcom_papasofokli_planning_api_DivisionsSVG__interiorDivisionsSummaryAction__s_concurrent_Future($thiz).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => true)), $thiz.hL()))), $thiz.hL()) : $p_Lcom_papasofokli_planning_api_DivisionsSVG__totalDivisionSummaryAction__s_concurrent_Future($thiz)).zG(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$3) => {
      if ($f_Lcom_papasofokli_svg_components_SvgComponent__isMouseOver__Z($thiz)) {
        $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V($thiz);
      }
    })), $thiz.hL());
  }));
}
function $f_Lcom_papasofokli_planning_api_DivisionsSVG__clickOnDivisionO__s_Option($thiz) {
  var this$1 = $p_Lcom_papasofokli_planning_api_DivisionsSVG__actionData__s_Option($thiz);
  return (this$1.c() ? $m_s_None$() : new $c_s_Some((this$1.h(), $p_Lcom_papasofokli_planning_api_DivisionsSVG__clickFunction__F1($thiz))));
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__totalDivisionSummaryAction__s_concurrent_Future($thiz) {
  var x41 = $p_Lcom_papasofokli_planning_api_DivisionsSVG__performSummaryAction__s_Option($thiz);
  if ((x41 instanceof $c_s_Some)) {
    var addRowActionF = x41.bg;
    var freezePage = new $c_Lcom_papasofokli_util_FreezePage(0, 0, $thiz.hL());
    return addRowActionF.aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((addRowAction$2) => {
      $f_Lcom_papasofokli_planning_api_DivisionsSVG__departmentResized__Lcom_papasofokli_planning_api_DivisionsSVG($thiz);
      addRowAction$2.aA();
      $thiz.ew().wQ.aA();
      return freezePage.ep();
    })), $thiz.hL());
  }
  if (($m_s_None$() === x41)) {
    return $m_s_concurrent_Future$().aE($m_s_None$());
  }
  throw new $c_s_MatchError(x41);
}
function $p_Lcom_papasofokli_planning_api_DivisionsSVG__interiorDivisionsSummaryAction__s_concurrent_Future($thiz) {
  var freezePage = new $c_Lcom_papasofokli_util_FreezePage(0, 0, $thiz.hL());
  var this$2 = $thiz.Mt();
  var f = ((_$9$2) => _$9$2.MZ());
  _return: {
    var result;
    var l$tailLocal1 = this$2;
    while (true) {
      if (l$tailLocal1.c()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l$tailLocal1.W();
        var t = l$tailLocal1.ak();
        if ((!(!f(h)))) {
          l$tailLocal1 = t;
          continue;
        }
        var start = l$tailLocal1;
        var remaining$tailLocal1 = t;
        while (true) {
          if (remaining$tailLocal1.c()) {
            var result = start;
            break _return;
          } else {
            var x = remaining$tailLocal1.W();
            if ((!(!(!f(x))))) {
              remaining$tailLocal1 = remaining$tailLocal1.ak();
              continue;
            }
            var firstMiss = remaining$tailLocal1;
            var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
            var toProcess = start.ak();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
              currentLast.bz = newElem;
              currentLast = newElem;
              toProcess = toProcess.ak();
            }
            var next = firstMiss.ak();
            var nextToCopy = next;
            while ((!next.c())) {
              var head = next.W();
              if ((!(!(!f(head))))) {
                next = next.ak();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                  currentLast.bz = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.ak();
                }
                nextToCopy = next.ak();
                next = next.ak();
              }
            }
            if ((!nextToCopy.c())) {
              currentLast.bz = nextToCopy;
            }
            var result = newHead;
            break _return;
          }
        }
      }
    }
  }
  var departmentsForAction = ((!result.c()) ? result : $thiz.Mt());
  var $x_1 = $m_s_concurrent_Future$();
  var rest = departmentsForAction;
  var h$1 = null;
  var t$1 = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $p_Lcom_papasofokli_planning_api_DivisionsSVG__performSummaryAction__s_Option(rest.W()).l();
    while (it.f()) {
      var nx = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      if ((t$1 === null)) {
        h$1 = nx;
      } else {
        t$1.bz = nx;
      }
      t$1 = nx;
    }
    rest = rest.ak();
  }
  return $x_1.ajG(((h$1 === null) ? $m_sci_Nil$() : h$1), ($m_sc_BuildFrom$(), new $c_sc_BuildFromLowPriority2$$anon$11()), $thiz.hL()).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((addRowActionSeq$2) => {
    var f$1 = ((_$11$2) => $f_Lcom_papasofokli_planning_api_DivisionsSVG__departmentResized__Lcom_papasofokli_planning_api_DivisionsSVG(_$11$2));
    if ((departmentsForAction === $m_sci_Nil$())) {
      $m_sci_Nil$();
    } else {
      var x0$1 = departmentsForAction.W();
      var h$2 = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$1 = departmentsForAction.ak();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$2 = rest$1.W();
        var nx$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
        t$2.bz = nx$1;
        t$2 = nx$1;
        rest$1 = rest$1.ak();
      }
    }
    addRowActionSeq$2.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((fun$3) => {
      fun$3.aA();
    })));
    $thiz.ew().wQ.aA();
    return freezePage.ep();
  })), $thiz.hL());
}
function $p_Lcom_papasofokli_planning_api_NameSVG__highlightRow__V($thiz) {
  $thiz.a2D.cm($thiz.a2G, Math.fround($thiz.a2H.aA()));
}
function $p_Lcom_papasofokli_planning_api_NameSVG__onNameMouseOut__V($thiz) {
  $thiz.a2E.aA();
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
}
function $p_Lcom_papasofokli_planning_api_NameSVG__makeTooltipElement__T__sci_Seq($thiz, tooltipText) {
  return new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row planner-tooltip", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-10", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(tooltipText))]))])), $m_sci_Nil$());
}
function $p_Lcom_papasofokli_planning_api_NameSVG__checkForFitting__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, textComp) {
  var textComp$tailLocal1 = textComp;
  while (true) {
    if ($p_Lcom_papasofokli_planning_api_NameSVG__textFittingComparison__F__Z($thiz, textComp$tailLocal1.Uy())) {
      return textComp$tailLocal1;
    } else {
      var newText = $m_sc_StringOps$().agI(textComp$tailLocal1.t0, 2);
      var text$1 = (newText + ".");
      textComp$tailLocal1 = new $c_Lcom_papasofokli_svg_components_TextComponent(textComp$tailLocal1.xM, text$1, textComp$tailLocal1.m6, textComp$tailLocal1.nT, textComp$tailLocal1.pW, textComp$tailLocal1.pS, textComp$tailLocal1.nS, textComp$tailLocal1.nR, textComp$tailLocal1.pM, textComp$tailLocal1.pP, textComp$tailLocal1.pR, textComp$tailLocal1.pT, textComp$tailLocal1.pU, textComp$tailLocal1.pO, textComp$tailLocal1.pQ, textComp$tailLocal1.pN, textComp$tailLocal1.pV);
    }
  }
}
function $p_Lcom_papasofokli_planning_api_NameSVG__fullNameOrShortNameDecision__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, textComp) {
  return ($p_Lcom_papasofokli_planning_api_NameSVG__textFittingComparison__F__Z($thiz, textComp.Uy()) ? textComp : new $c_Lcom_papasofokli_svg_components_TextComponent(textComp.xM, $thiz.JT.sp, textComp.m6, textComp.nT, textComp.pW, textComp.pS, textComp.nS, textComp.nR, textComp.pM, textComp.pP, textComp.pR, textComp.pT, textComp.pU, textComp.pO, textComp.pQ, textComp.pN, textComp.pV));
}
function $p_Lcom_papasofokli_planning_api_NameSVG__textFittingComparison__F__Z($thiz, text) {
  return (Math.fround((text + $thiz.a2I)) < Math.fround(($thiz.P9 - $thiz.JS)));
}
function $p_Lcom_papasofokli_planning_api_NameSVG__allGroupedComponents__sci_Seq($thiz) {
  return new $c_sci_$colon$colon($thiz.JP, new $c_sci_$colon$colon($thiz.Pb, $m_sci_Nil$())).cY($thiz.P5).cY($thiz.JQ);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_NameSVG(subject, nameLength, initialX, startY, periodHeight, hoverRectAppear, hoverRectHide, clickSubjectButtonParams, getRowsForSubjectId, divisionData, rowUUID, showSubjectId, initialClassStyle, executionContext) {
  this.JT = null;
  this.P9 = 0.0;
  this.F5 = 0.0;
  this.a2H = null;
  this.a2G = 0.0;
  this.a2D = null;
  this.a2E = null;
  this.P7 = 0.0;
  this.P6 = 0.0;
  this.a2I = 0.0;
  this.JR = 0.0;
  this.a2F = 0.0;
  this.Pa = 0.0;
  this.JP = null;
  this.Pd = 0.0;
  this.P8 = 0.0;
  this.Pc = null;
  this.JQ = null;
  this.JS = 0.0;
  this.Pb = null;
  this.P5 = null;
  this.JT = subject;
  this.P9 = nameLength;
  this.F5 = initialX;
  this.a2H = startY;
  this.a2G = periodHeight;
  this.a2D = hoverRectAppear;
  this.a2E = hoverRectHide;
  this.P7 = 18.0;
  this.P6 = 22.0;
  this.a2I = 22.0;
  this.JR = 10.0;
  this.a2F = 2.0;
  this.Pa = Math.fround((initialX + nameLength));
  var initialClassName$1 = $m_s_Option$().Z(initialClassStyle);
  var initialHeight$1 = Math.fround((periodHeight - 2.0));
  var initialY$1 = Math.fround(startY.aA());
  var onMouseOut$1 = $m_s_Option$().Z(hoverRectHide);
  var onHover$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $p_Lcom_papasofokli_planning_api_NameSVG__highlightRow__V(this);
  })));
  this.JP = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$1, initialHeight$1, nameLength, initialX, initialY$1, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), onHover$1, onMouseOut$1, true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
  this.Pd = Math.fround((Math.fround((0.5 * periodHeight)) + 5.0));
  var textYPosition = Math.fround((Math.fround(startY.aA()) + this.Pd));
  this.P8 = Math.fround((Math.fround((Math.fround(startY.aA()) + Math.fround((0.5 * periodHeight)))) - this.JR));
  if (showSubjectId) {
    var this$16 = subject.nA;
    var firstLineParts = $f_T__trim__T((((this$16.c() ? "" : this$16.h()) + " ") + subject.nz));
  } else {
    var firstLineParts = subject.nz;
  }
  var basicInfo = new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(firstLineParts))])), $m_sci_Nil$());
  var this$21 = subject.lV;
  var xs = $f_T__split__T__I__AT((this$21.c() ? "" : this$21.h()), "\\s+", 0);
  var evidence$1 = $m_s_reflect_ClassTag$().um($objectGetClass(xs).ax.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.dK();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.a.length)) {
    var x1 = i;
    var x = xs.a[x1];
    if (($m_sc_StringOps$(), (x !== ""))) {
      var unboxedElem = (isCharArrayBuilder ? $uC(x) : ((x === null) ? $m_scm_ArrayBuilder$().u(elementClass) : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var extraWords = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  var f = ((word$2) => $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(word$2))]))])));
  var ct__runtimeClass;
  var ct__runtimeClass = $d_Lscalatags_JsDom$TypedTag.l();
  var len = extraWords.a.length;
  var componentType = ct__runtimeClass;
  var ys = componentType.ax.U(len);
  if ((len > 0)) {
    var i$1 = 0;
    if ((extraWords !== null)) {
      while ((i$1 < len)) {
        var $x_2 = $m_sr_ScalaRunTime$();
        var $x_1 = i$1;
        var x0$3 = extraWords.a[i$1];
        $x_2.bQ(ys, $x_1, f(x0$3));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_I)) {
      while ((i$1 < len)) {
        var $x_4 = $m_sr_ScalaRunTime$();
        var $x_3 = i$1;
        var x0$4 = extraWords.a[i$1];
        $x_4.bQ(ys, $x_3, f(x0$4));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_D)) {
      while ((i$1 < len)) {
        var $x_6 = $m_sr_ScalaRunTime$();
        var $x_5 = i$1;
        var x0$5 = extraWords.a[i$1];
        $x_6.bQ(ys, $x_5, f(x0$5));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_J)) {
      while ((i$1 < len)) {
        var $x_10 = $m_sr_ScalaRunTime$();
        var $x_9 = i$1;
        var $x_7 = extraWords.a;
        var $x_8 = (i$1 << 1);
        var x0$6_$_lo = $x_7[$x_8];
        var x0$6_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.bQ(ys, $x_9, f($bL(x0$6_$_lo, x0$6_$_hi)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_F)) {
      while ((i$1 < len)) {
        var $x_12 = $m_sr_ScalaRunTime$();
        var $x_11 = i$1;
        var x0$7 = extraWords.a[i$1];
        $x_12.bQ(ys, $x_11, f(x0$7));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_C)) {
      while ((i$1 < len)) {
        var $x_14 = $m_sr_ScalaRunTime$();
        var $x_13 = i$1;
        var x0$8 = extraWords.a[i$1];
        $x_14.bQ(ys, $x_13, f($bC(x0$8)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_B)) {
      while ((i$1 < len)) {
        var $x_16 = $m_sr_ScalaRunTime$();
        var $x_15 = i$1;
        var x0$9 = extraWords.a[i$1];
        $x_16.bQ(ys, $x_15, f(x0$9));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_S)) {
      while ((i$1 < len)) {
        var $x_18 = $m_sr_ScalaRunTime$();
        var $x_17 = i$1;
        var x0$10 = extraWords.a[i$1];
        $x_18.bQ(ys, $x_17, f(x0$10));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((extraWords instanceof $ac_Z)) {
      while ((i$1 < len)) {
        var $x_20 = $m_sr_ScalaRunTime$();
        var $x_19 = i$1;
        var x0$11 = extraWords.a[i$1];
        $x_20.bQ(ys, $x_19, f(x0$11));
        i$1 = ((1 + i$1) | 0);
      }
    } else {
      throw new $c_s_MatchError(extraWords);
    }
  }
  var seq = basicInfo.cY($m_s_Predef$().Jl(ys));
  var onHoverName = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), seq, $m_s_$less$colon$less$().b0)]));
  var textHtmlInToolTip = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [onHoverName]))]))])).aB().outerHTML;
  this.Pc = $m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(textHtmlInToolTip, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_NameSVG__highlightRow__V(this);
  }))));
  this.JQ = subject.i5.bc().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var generalText = x$1$2.P();
      var index = (x$1$2.V() | 0);
      var xOffset = ((generalText instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon) ? Math.fround((Math.fround((initialX + nameLength)) - this.P6)) : Math.fround((initialX + Math.fround((Math.fround(index) * this.P7)))));
      matchResult2: {
        var generalTextHoverHtmlMap;
        if ((generalText instanceof $c_Lcom_papasofokli_util_IconUI)) {
          $m_Lcom_papasofokli_util_IconUI$();
          var x7 = generalText.m8;
          if ((x7 instanceof $c_s_Some)) {
            var generalTextHoverHtmlMap = $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2(generalText, $p_Lcom_papasofokli_planning_api_NameSVG__makeTooltipElement__T__sci_Seq(this, x7.bg))]));
            break matchResult2;
          }
        }
        var generalTextHoverHtmlMap = $m_sci_Map$EmptyMap$();
      }
      var faIcon$1 = new $c_sci_$colon$colon(generalText, $m_sci_Nil$());
      var extraCssClass$1 = new $c_s_Some("activeText not-selectable");
      var onHover$2 = new $c_s_Some(this.Pc);
      var onMouseOut$2 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $p_Lcom_papasofokli_planning_api_NameSVG__onNameMouseOut__V(this);
      })));
      var dragFunction$2 = $m_s_None$();
      var clickFunction$2 = $m_s_None$();
      var draggingFunction$1 = $m_s_None$();
      var contextMenuFunction$2 = $m_s_None$();
      var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
      var appendWithAnimationTime$2 = new $c_s_Some(0.5);
      var horizontalAnchor$1 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
      return new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon$1, xOffset, this.P8, extraCssClass$1, generalTextHoverHtmlMap, dragFunction$2, clickFunction$2, draggingFunction$1, contextMenuFunction$2, getGroupedDraggedShapes$2, onHover$2, onMouseOut$2, true, subject.ka, appendWithAnimationTime$2, horizontalAnchor$1);
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  this.JS = Math.fround(this.JQ.bY(subject.i5).bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
    if ((x$1$2$1 !== null)) {
      return (x$1$2$1.V() instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon);
    }
    throw new $c_s_MatchError(x$1$2$1);
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    if ((x$1$2$2 !== null)) {
      return Math.fround((x$1$2$2.P().uv() + this.a2F));
    }
    throw new $c_s_MatchError(x$1$2$2);
  }))).gO($m_s_math_Numeric$FloatIsFractional$()));
  var initialClassName$2 = $m_s_Option$().Z("planning-left-side-text");
  var initialX$1 = Math.fround((this.JS + initialX));
  var onHover$3 = new $c_s_Some(this.Pc);
  var onMouseOut$3 = new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_NameSVG__onNameMouseOut__V(this);
  })));
  var textLength$1 = $m_s_None$();
  var lengthAdjust$1 = $m_s_None$();
  var dragFunction$3 = $m_s_None$();
  var clickFunction$3 = $m_s_None$();
  var appendWithAnimationTime$3 = new $c_s_Some(0.5);
  var getGroupedDraggedShapes$3 = $m_Lcom_papasofokli_svg_components_TextComponent$().hb();
  var contextMenuFunction$3 = $m_s_None$();
  var color$2 = $m_s_None$();
  var stroke$2 = $m_s_None$();
  this.Pb = $p_Lcom_papasofokli_planning_api_NameSVG__checkForFitting__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent(this, $p_Lcom_papasofokli_planning_api_NameSVG__fullNameOrShortNameDecision__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent(this, new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$2, subject.nz, initialX$1, textYPosition, textLength$1, lengthAdjust$1, dragFunction$3, clickFunction$3, appendWithAnimationTime$3, getGroupedDraggedShapes$3, true, onHover$3, onMouseOut$3, contextMenuFunction$3, subject.ka, color$2, stroke$2)));
  var this$106 = new $c_s_Option$WithFilter(clickSubjectButtonParams, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => subject.lW)));
  var this$107 = this$106.y6;
  var p$1 = this$106.y7;
  var this$108 = ((this$107.c() || (!(!p$1.p(this$107.h())))) ? this$107 : $m_s_None$());
  if (this$108.c()) {
    var $x_21 = $m_s_None$();
  } else {
    var x0$17 = this$108.h();
    var extraCssClass$2 = new $c_s_Some("activeText not-selectable");
    var $x_21 = new $c_s_Some(new $c_Lcom_papasofokli_planning_api_ClickSubjectRowButton(this.Pa, this.P8, extraCssClass$2, x0$17, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var this$113 = subject.nA;
      var this$115 = (this$113.c() ? $m_s_None$() : new $c_s_Some(getRowsForSubjectId.p(this$113.h())));
      return (this$115.c() ? $m_sci_Nil$() : this$115.h());
    })), divisionData, rowUUID, executionContext));
  }
  this.P5 = $x_21;
}
$p = $c_Lcom_papasofokli_planning_api_NameSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_NameSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_NameSVG() {
}
$h_Lcom_papasofokli_planning_api_NameSVG.prototype = $p;
$p.gd = (function(newStartY) {
  $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this.JP, $m_Lcom_papasofokli_planning_package$().nM);
  this.JP.cT(this.F5, newStartY);
  var this$2 = this.P5;
  if ((!this$2.c())) {
    this$2.h().cT(this.Pa, Math.fround((newStartY + this.JR)));
  }
  this.Pb.cT(Math.fround((this.JS + this.F5)), Math.fround((newStartY + this.Pd)));
  this.JQ.bY(this.JT.i5).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult7: {
      if ((x$1$3 !== null)) {
        var icon = x$1$3.P();
        var generalText = x$1$3.V();
        if ((generalText instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon)) {
          var xOffset = Math.fround((Math.fround((this.F5 + this.P9)) - this.P6));
        } else {
          var flags = this.JT.i5.bC(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => (_$6$2 instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon))));
          var flagIndex = flags.Ed(generalText, 0);
          var xOffset = Math.fround((this.F5 + Math.fround((Math.fround(flagIndex) * this.P7))));
        }
        icon.cT(xOffset, Math.fround((newStartY + this.JR)));
        break matchResult7;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
});
$p.di = (function() {
  return new $c_Lcom_papasofokli_svg_components_FlattenSVG($p_Lcom_papasofokli_planning_api_NameSVG__allGroupedComponents__sci_Seq(this)).xJ;
});
var $d_Lcom_papasofokli_planning_api_NameSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_NameSVG, "com.papasofokli.planning.api.NameSVG", ({
  qK: 1,
  aj: 1
}));
function $p_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG__createVoyageClickFunction__T__s_Option($thiz, voyageNumber) {
  var this$1 = $thiz.a4P;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((uuid$2) => ((_$1$3) => {
    var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), voyageNumber, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lupickle_default$().m);
    var executionContext = $thiz.a4J;
    $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, uuid$2.g(), data, executionContext);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG__getYPositionWithNewStart$1__F__I__I__F($thiz, newStartY$1, vesselIdx, rowWithinVessel) {
  return $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().E9(vesselIdx, rowWithinVessel, $thiz.py, newStartY$1);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG(vesselSchedules, startY, leftWidth, timeLineSVG, periodHeight, totalWidth, voyageClickCallback, zoomLevel, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi, ec) {
  this.a4O = 0.0;
  this.a4P = null;
  this.a4J = null;
  this.py = null;
  this.PL = false;
  this.PM = null;
  this.PN = null;
  this.a4K = null;
  this.a4L = false;
  this.PO = null;
  this.a4M = null;
  this.a4N = false;
  this.a4O = startY;
  this.a4P = voyageClickCallback;
  this.a4J = ec;
  this.py = new $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig(periodHeight, 5.0, 60.0, 0.0, 8.0, 30.0, 8.0, 5.0, 10.0, 10, 2);
  if ((!zoomLevel.c())) {
    var x0 = zoomLevel.h();
    var $x_2 = $uJ(x0);
    var z$2_$_lo = $x_2.l;
    var z$2_$_hi = $x_2.h;
    var $x_1 = (((z$2_$_lo | z$2_$_hi) === 0) || (((1 ^ z$2_$_lo) | z$2_$_hi) === 0));
  } else {
    var $x_1 = false;
  }
  this.PL = $x_1;
  var vesselInfoPairs = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agw(vesselSchedules, this.PL, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi);
  this.PM = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agr(vesselInfoPairs, this.py, leftWidth, startY);
  this.PN = $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().ags(vesselInfoPairs, this.py, startY);
  this.PO = vesselInfoPairs.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var pair = x$1$2.P();
      var vesselIdx = (x$1$2.V() | 0);
      return pair.Bf.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((voyage$2) => $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agx(voyage$2, vesselIdx, timeLineSVG, totalWidth, this.py, $p_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG__createVoyageClickFunction__T__s_Option(this, voyage$2.nL), this.PL, startY)))).dt(pair.Bd.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((port$2) => $m_Lcom_papasofokli_planning_api_VesselScheduleHelpers$().agt(port$2, vesselIdx, timeLineSVG, totalWidth, this.py, startY)))));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
}
$p = $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG() {
}
$h_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG.prototype = $p;
$p.ai2 = (function() {
  if ((!this.a4L)) {
    this.a4K = this.PM.cH(this.PN);
    this.a4L = true;
  }
  return this.a4K;
});
$p.ajs = (function() {
  if ((!this.a4N)) {
    this.a4M = this.PO;
    this.a4N = true;
  }
  return this.a4M;
});
$p.di = (function() {
  return this.ai2().cH(this.ajs()).aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.di())));
});
$p.gd = (function(newStartY) {
  this.PM.bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult3: {
      if ((x$1$3 !== null)) {
        var rect = x$1$3.P();
        var idx = (x$1$3.V() | 0);
        var vesselIdx = (((idx + ((idx >>> 31) | 0)) | 0) >> 1);
        var t = ((idx >>> 31) | 0);
        var rowWithinVessel = (((1 & ((idx + t) | 0)) - t) | 0);
        rect.cT(0.0, $p_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG__getYPositionWithNewStart$1__F__I__I__F(this, newStartY, vesselIdx, rowWithinVessel));
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
  this.PN.bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
    matchResult4: {
      if ((x$1$3$1 !== null)) {
        var text = x$1$3$1.P();
        var idx$1 = (x$1$3$1.V() | 0);
        var vesselIdx$1 = (((idx$1 + ((idx$1 >>> 31) | 0)) | 0) >> 1);
        var t$1 = ((idx$1 >>> 31) | 0);
        var rowWithinVessel$1 = (((1 & ((idx$1 + t$1) | 0)) - t$1) | 0);
        text.cT(this.py.xa, Math.fround((Math.fround(($p_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG__getYPositionWithNewStart$1__F__I__I__F(this, newStartY, vesselIdx$1, rowWithinVessel$1) + Math.fround((0.5 * this.py.i7)))) + this.py.px)));
        break matchResult4;
      }
      throw new $c_s_MatchError(x$1$3$1);
    }
  })));
  var yOffset = Math.fround((newStartY - this.a4O));
  this.PO.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$2) => {
    if ((x$1$3$2 instanceof $c_Lcom_papasofokli_svg_components_RectComponent)) {
      x$1$3$2.cT(x$1$3$2.Cf, Math.fround((x$1$3$2.Cg + yOffset)));
    } else if ((x$1$3$2 instanceof $c_Lcom_papasofokli_svg_components_TextComponent)) {
      x$1$3$2.cT(x$1$3$2.m6, Math.fround((x$1$3$2.nT + yOffset)));
    }
  })));
});
function $isArrayOf_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fB)));
}
var $d_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG, "com.papasofokli.planning.api.VesselScheduleInlineSVG", ({
  fB: 1,
  aj: 1
}));
function $f_Lcom_papasofokli_svg_api_ForeignShape__$init$__V($thiz) {
  $thiz.TX($m_s_None$());
  $thiz.TW(new $c_s_Some("http://www.w3.org/1999/xhtml"));
  $thiz.TV(new $c_Lcom_papasofokli_util_AttributeValue("xmlns", "http://www.w3.org/1999/xhtml"));
}
function $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V($thiz) {
  $thiz.zx($m_s_Option$().Z("http://www.w3.org/2000/svg"));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_FlattenSVG(components) {
  this.xJ = null;
  this.xJ = components.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.di())));
}
$p = $c_Lcom_papasofokli_svg_components_FlattenSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_FlattenSVG;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_FlattenSVG() {
}
$h_Lcom_papasofokli_svg_components_FlattenSVG.prototype = $p;
$p.di = (function() {
  return this.xJ;
});
var $d_Lcom_papasofokli_svg_components_FlattenSVG = new $TypeData().i($c_Lcom_papasofokli_svg_components_FlattenSVG, "com.papasofokli.svg.components.FlattenSVG", ({
  rP: 1,
  aj: 1
}));
function $p_Lcom_papasofokli_svg_components_LineComponent__dragLine__s_Option($thiz) {
  var this$1 = $thiz.a7l;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$3) => (() => {
    fun$3.p($thiz.pL);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_LineComponent__clickLine__s_Option($thiz) {
  var this$1 = $thiz.a7k;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$4) => (() => {
    fun$4.p($thiz.pL);
  }))(this$1.h()))));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_LineComponent(initialClassName, initialX1, initialY1, initialX2, initialY2, dragFunction, clickFunction, getGroupedDraggedShapes, isMovableOnDrag, onHover, onMouseOut, appendWithAnimationTime, stroke, lineId) {
  this.a7m = 0.0;
  this.a7o = 0.0;
  this.a7n = 0.0;
  this.a7p = 0.0;
  this.a7l = null;
  this.a7k = null;
  this.pL = null;
  this.a7m = initialX1;
  this.a7o = initialY1;
  this.a7n = initialX2;
  this.a7p = initialY2;
  this.a7l = dragFunction;
  this.a7k = clickFunction;
  this.pL = new $c_Lcom_papasofokli_svg_api_LineSVG(initialX1, initialY1, initialX2, initialY2, initialClassName, appendWithAnimationTime, $m_s_None$(), $p_Lcom_papasofokli_svg_components_LineComponent__dragLine__s_Option(this), $m_s_None$(), $p_Lcom_papasofokli_svg_components_LineComponent__clickLine__s_Option(this), getGroupedDraggedShapes, onHover, onMouseOut, $m_s_None$(), isMovableOnDrag, stroke, lineId);
}
$p = $c_Lcom_papasofokli_svg_components_LineComponent.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_LineComponent;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_LineComponent() {
}
$h_Lcom_papasofokli_svg_components_LineComponent.prototype = $p;
$p.ahy = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.pL, "y1");
});
$p.auA = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.pL, "y2");
});
$p.auz = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.pL, "x1");
});
$p.ahw = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.pL, "x2");
});
$p.aiU = (function(newX1, newY1, newX2, newY2) {
  var $x_4 = this.pL;
  var this$1 = (newX1.c() ? this.auz() : newX1);
  var $x_3 = (this$1.c() ? this.a7m : this$1.h());
  var this$2 = (newY1.c() ? this.ahy() : newY1);
  var $x_2 = (this$2.c() ? this.a7o : this$2.h());
  var this$3 = (newX2.c() ? this.ahw() : newX2);
  var $x_1 = (this$3.c() ? this.a7n : this$3.h());
  var this$4 = (newY2.c() ? this.auA() : newY2);
  $x_4.aiT(Math.fround($x_3), Math.fround($x_2), Math.fround($x_1), Math.fround((this$4.c() ? this.a7p : this$4.h())));
});
$p.di = (function() {
  return new $c_sci_$colon$colon(this.pL, $m_sci_Nil$());
});
var $d_Lcom_papasofokli_svg_components_LineComponent = new $TypeData().i($c_Lcom_papasofokli_svg_components_LineComponent, "com.papasofokli.svg.components.LineComponent", ({
  rU: 1,
  aj: 1
}));
function $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allShapes__sci_Seq($thiz) {
  return $thiz.Mc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => _$6$2.di())));
}
function $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allActionShapes__F0($thiz) {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.di().bD(new $c_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1())));
}
function $f_Lcom_papasofokli_svg_timeline_DayTickInterval__highlightDate__sjs_js_Date__Z($thiz, date) {
  return (("" + $cToS($m_sc_StringOps$().ahF($m_Lcom_papasofokli_util_DateUtilsJS$().MQ(date)))) === "S");
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_HourTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_HourTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_HourTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_HourTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_HourTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.kJ = (function(date) {
  return ("" + (+date.getUTCHours()));
});
$p.oO = (function(date) {
  return false;
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().afw(date, 60);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().aug(startDate);
});
var $d_Lcom_papasofokli_svg_timeline_HourTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_HourTickInterval$, "com.papasofokli.svg.timeline.HourTickInterval$", ({
  s4: 1,
  aI: 1
}));
var $n_Lcom_papasofokli_svg_timeline_HourTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_HourTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_HourTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_HourTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_HourTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_HourTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_YearTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_YearTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_YearTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_YearTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_YearTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.kJ = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().aux(date);
});
$p.oO = (function(date) {
  return false;
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().ame(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().aui(startDate);
});
var $d_Lcom_papasofokli_svg_timeline_YearTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_YearTickInterval$, "com.papasofokli.svg.timeline.YearTickInterval$", ({
  sa: 1,
  aI: 1
}));
var $n_Lcom_papasofokli_svg_timeline_YearTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_YearTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_YearTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_YearTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_YearTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_YearTickInterval$;
}
function $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelected__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, outerJQ) {
  var mainJQ = outerJQ.children(("." + $thiz.a80)).children(("." + $thiz.a7Z));
  $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectSectionTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ);
  $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectStorageTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ);
  return $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectSplitStorageTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ);
}
function $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectSectionTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ) {
  return $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelectedTile__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ.children(("." + $thiz.G8)).children(("." + $thiz.G9)).children(("." + $thiz.G7)));
}
function $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectStorageTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ) {
  return $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelectedTile__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ.children(("." + $thiz.Qj)).children(("." + $thiz.G8)).children(("." + $thiz.G9)).children(("." + $thiz.G7)));
}
function $p_Lcom_papasofokli_tileboard_TileBoardJs$__deSelectSplitStorageTiles__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ) {
  $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelectedTile__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ.children(("." + $thiz.Qj)).children(("." + $thiz.G8)).children(("." + $thiz.G9)).children(("." + $thiz.G7)).children(("." + $thiz.Qk)));
  return $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelectedTile__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, mainJQ.children(("." + $thiz.G8)).children(("." + $thiz.G9)).children(("." + $thiz.G7)).children(("." + $thiz.Qk)));
}
function $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelectedTile__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery($thiz, selectedJQ) {
  return selectedJQ.each((function() {
    return (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + this.id)).children(("." + $thiz.Ql)).removeClass("selected");
  }));
}
/** @constructor */
function $c_Lcom_papasofokli_tileboard_TileBoardJs$() {
  this.Qi = null;
  this.Ql = null;
  this.G7 = null;
  this.Qh = null;
  this.a7Z = null;
  this.a80 = null;
  this.a82 = null;
  this.a81 = null;
  this.Qk = null;
  this.G9 = null;
  this.Qj = null;
  this.G8 = null;
  $n_Lcom_papasofokli_tileboard_TileBoardJs$ = this;
  $f_Lcom_papasofokli_tiles_TilesBoardT__$init$__V(this);
}
$p = $c_Lcom_papasofokli_tileboard_TileBoardJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_tileboard_TileBoardJs$;
/** @constructor */
function $h_Lcom_papasofokli_tileboard_TileBoardJs$() {
}
$h_Lcom_papasofokli_tileboard_TileBoardJs$.prototype = $p;
$p.av9 = (function(executionContext) {
  var multipleEventHandler = new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, executionContext);
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + this.Qi)).removeClass(this.Qi).each(((this$2) => (function() {
    var dataClickFunctionUUID = this.getAttribute("data-click");
    var outerId = this.id;
    var outerJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + outerId));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + this$2.Qh)).each((function() {
      var id = this.id;
      var tileJQ = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + id));
      var tileId = tileJQ.attr(this$2.a82);
      var tileColumn = tileJQ.attr(this$2.a81);
      tileJQ.removeClass(this$2.Qh);
      return (($m_sc_StringOps$(), (dataClickFunctionUUID !== "")) ? tileJQ.on("click", ((_$1$2) => {
        if ((tileId !== (void 0))) {
          $p_Lcom_papasofokli_tileboard_TileBoardJs$__removeSelected__Lcom_papasofokli_jquery_JQuery__Lcom_papasofokli_jquery_JQuery(this$2, outerJQ);
          tileJQ.children(("." + this$2.Ql)).addClass("selected");
        }
        return multipleEventHandler.dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
          var this$20 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
          var id$1 = $m_ju_UUID$().aO(dataClickFunctionUUID);
          var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_T2($dp_toString__T(tileId), $dp_toString__T(tileColumn)), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m));
          return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$20, id$1.g(), data, executionContext);
        })));
      })) : (void 0));
    }));
  }))(this));
});
var $d_Lcom_papasofokli_tileboard_TileBoardJs$ = new $TypeData().i($c_Lcom_papasofokli_tileboard_TileBoardJs$, "com.papasofokli.tileboard.TileBoardJs$", ({
  sb: 1,
  sc: 1
}));
var $n_Lcom_papasofokli_tileboard_TileBoardJs$;
function $m_Lcom_papasofokli_tileboard_TileBoardJs$() {
  if ((!$n_Lcom_papasofokli_tileboard_TileBoardJs$)) {
    $n_Lcom_papasofokli_tileboard_TileBoardJs$ = new $c_Lcom_papasofokli_tileboard_TileBoardJs$();
  }
  return $n_Lcom_papasofokli_tileboard_TileBoardJs$;
}
function $p_Lcom_papasofokli_tree_TreeJs$__triggerInitialSelectionRecursive__sci_Seq__T__s_concurrent_ExecutionContext__V($thiz, nodes, nodeClickFunctionId, ec) {
  nodes.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node$3) => {
    if (node$3.k1) {
      $p_Lcom_papasofokli_tree_TreeJs$__postClickActions__Lcom_papasofokli_jstree_TreeNodeData__T__T__s_concurrent_ExecutionContext__V($thiz, node$3, nodeClickFunctionId, $thiz.xO, ec);
    }
    $p_Lcom_papasofokli_tree_TreeJs$__triggerInitialSelectionRecursive__sci_Seq__T__s_concurrent_ExecutionContext__V($thiz, node$3.k0, nodeClickFunctionId, ec);
  })));
}
function $p_Lcom_papasofokli_tree_TreeJs$__createAndAppendNodeElementsToParent__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Lorg_scalajs_dom_Element__Z__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, node, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, element, expandOnDoubleClick, cssClass, ec) {
  return $p_Lcom_papasofokli_tree_TreeJs$__appendChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery($thiz, element, node.k0.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node$2) => $p_Lcom_papasofokli_tree_TreeJs$__createNodeElement__Lorg_scalajs_dom_Element__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Z__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement($thiz, element, node$2, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, expandOnDoubleClick, cssClass, ec)))).cH(node.lx.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((leaf$2) => $p_Lcom_papasofokli_tree_TreeJs$__createLeafElement__Lcom_papasofokli_jstree_TreeLeafData__T__T__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement($thiz, leaf$2, leafClickFunctionId, contextMenuFunctionId, cssClass, ec))))));
}
function $p_Lcom_papasofokli_tree_TreeJs$__appendChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery($thiz, element, nodeLis) {
  var jqElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(element);
  return jqElement.addClass($thiz.Ch).children().end().append($m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-children", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), nodeLis, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB()).removeClass($thiz.Kx);
}
function $p_Lcom_papasofokli_tree_TreeJs$__removeChildrenFromElement__Lorg_scalajs_dom_Element__V($thiz, element) {
  var jqElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(element);
  if ((!(!(!jqElement.children().last().hasClass("scala-tree-row"))))) {
    jqElement.removeClass($thiz.Ch);
    jqElement.children().last().remove().end();
  }
}
function $p_Lcom_papasofokli_tree_TreeJs$__removeAndAddChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery($thiz, element, nodeLis) {
  return (0, $m_Lcom_papasofokli_jquery_package$().I)(element).addClass($thiz.Ch).children().remove().end().append($m_Lscalatags_JsDom$all$().jB().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-children", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), nodeLis, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB()).removeClass($thiz.Kx);
}
function $p_Lcom_papasofokli_tree_TreeJs$__createNodeElement__Lorg_scalajs_dom_Element__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Z__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement($thiz, element, data, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, expandOnDoubleClick, cssClass, ec) {
  var itemDivs = $p_Lcom_papasofokli_tree_TreeJs$__createColumnsFromInfoItems__sci_Seq__sci_Seq__sci_Seq($thiz, data.nq, data.lC);
  var collapseIconContainerWidth = ((data.nq.F() === data.lC.F()) ? ((100 - (data.lC.gO($m_s_math_Numeric$IntIsIntegral$()) | 0)) | 0) : ((100 - $thiz.Qq) | 0));
  var nodeClasses = $f_sc_IterableOnceOps__mkString__T__T__T__T($f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon(new $c_s_Some("scala-tree-node"), new $c_sci_$colon$colon((data.k1 ? new $c_s_Some($thiz.Ci) : $m_s_None$()), $m_sci_Nil$())), $m_s_$less$colon$less$().b0), "", " ", "");
  var liElement = $m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(("" + $s_RTLong__toString__I__I__T(data.gE, data.gF)), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n(nodeClasses, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("scala-tree-row " + (cssClass.c() ? "" : cssClass.h())), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-anchor jstree-anchor", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ak6().n("-1", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex me-1 me-lg-0", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("d-inline-block w-" + collapseIconContainerWidth), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(($s_RTLong__toString__I__I__T(data.gE, data.gF) + "-toggle"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n(("" + $thiz.Kw), $m_Lscalatags_JsDom$all$().s)]))]))])), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), itemDivs, $m_s_$less$colon$less$().b0), $m_Lscalatags_JsDom$all$().Nd().n($p_Lcom_papasofokli_tree_TreeJs$__contextMenu__Lcom_papasofokli_jstree_TreeItemData__T__s_concurrent_ExecutionContext__F1($thiz, data, contextMenuFunctionId, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_tree_TreeJs$__treeNodeItemOnClick__Lcom_papasofokli_jstree_TreeNodeData__T__T__Z__s_concurrent_ExecutionContext__F1($thiz, data, nodeClickFunctionId, $thiz.xO, expandOnDoubleClick, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1)))))), $m_Lscalatags_JsDom$all$().J0().n($p_Lcom_papasofokli_tree_TreeJs$__treeNodeItemOnClick__Lcom_papasofokli_jstree_TreeNodeData__T__T__Z__s_concurrent_ExecutionContext__F1($thiz, data, nodeClickFunctionId, $thiz.Qr, expandOnDoubleClick, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$2) => $m_sjs_js_Any$().b3(f$2$2))))))]))]))]))])).aB();
  if (((!data.k0.c()) || (!data.lx.c()))) {
    $p_Lcom_papasofokli_tree_TreeJs$__appendChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery($thiz, element, new $c_sci_$colon$colon(liElement, $m_sci_Nil$()));
    (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $s_RTLong__toString__I__I__T(data.gE, data.gF))).each((function() {
      $p_Lcom_papasofokli_tree_TreeJs$__toggleExpand__J__Z($thiz, data.gE, data.gF);
      return $p_Lcom_papasofokli_tree_TreeJs$__createAndAppendNodeElementsToParent__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Lorg_scalajs_dom_Element__Z__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery($thiz, data, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, this, expandOnDoubleClick, cssClass, ec);
    }));
  }
  return liElement;
}
function $p_Lcom_papasofokli_tree_TreeJs$__createLeafElement__Lcom_papasofokli_jstree_TreeLeafData__T__T__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement($thiz, data, clickFunctionId, contextMenuFunctionId, cssClass, ec) {
  var itemDivs = $p_Lcom_papasofokli_tree_TreeJs$__createColumnsFromInfoItems__sci_Seq__sci_Seq__sci_Seq($thiz, data.no, data.np);
  var leafClasses = $f_sc_IterableOnceOps__mkString__T__T__T__T($f_sc_StrictOptimizedIterableOps__flatten__F1__O(new $c_sci_$colon$colon(new $c_s_Some("scala-tree-leaf"), new $c_sci_$colon$colon((data.jZ ? new $c_s_Some($thiz.Ci) : $m_s_None$()), $m_sci_Nil$())), $m_s_$less$colon$less$().b0), "", " ", "");
  return $m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bE().n(("" + data.i2), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().D().n(leafClasses, $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(("scala-tree-row " + (cssClass.c() ? "" : cssClass.h())), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("jstree-icon jstree-ocl", $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().ij().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-anchor jstree-anchor", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().ak6().n("-1", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), itemDivs, $m_s_$less$colon$less$().b0), $m_Lscalatags_JsDom$all$().Nd().n($p_Lcom_papasofokli_tree_TreeJs$__contextMenu__Lcom_papasofokli_jstree_TreeItemData__T__s_concurrent_ExecutionContext__F1($thiz, data, contextMenuFunctionId, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => $m_sjs_js_Any$().b3(f$2)))))), $m_Lscalatags_JsDom$all$().fc().n($p_Lcom_papasofokli_tree_TreeJs$__treeLeafItemOnClick__Lcom_papasofokli_jstree_TreeLeafData__T__T__s_concurrent_ExecutionContext__F1($thiz, data, clickFunctionId, $thiz.Qp, ec), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_LowPriorityImplicits$$anon$2(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2$1) => $m_sjs_js_Any$().b3(f$2$1))))))]))]))])).aB();
}
function $p_Lcom_papasofokli_tree_TreeJs$__createColumnsFromInfoItems__sci_Seq__sci_Seq__sci_Seq($thiz, data, widths) {
  var nodeRatio = (($thiz.Qq / $checkIntDivisor(data.F())) | 0);
  var withWidths = ((data.F() === widths.F()) ? data.bY(widths) : data.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => new $c_T2(_$2$2, nodeRatio)))));
  var itemWidth = withWidths.bj();
  var firstItem = (itemWidth.c() ? $m_s_None$() : new $c_s_Some(itemWidth.h().P()));
  var this$4 = (firstItem.c() ? $m_s_None$() : firstItem.h().lv);
  var firstItemStyle = (this$4.c() ? "" : this$4.h());
  var firstItemIcons = $m_s_Option$().hi((firstItem.c() ? $m_s_None$() : new $c_s_Some(firstItem.h().lu))).cf().bU($m_s_$less$colon$less$().b0);
  var this$7 = (firstItem.c() ? $m_s_None$() : firstItem.h().lw);
  var text = (this$7.c() ? "" : this$7.h());
  var this$8 = (firstItem.c() ? $m_s_None$() : firstItem.h().lt);
  var iconCss = (this$8.c() ? "" : this$8.h());
  var this$10 = (itemWidth.c() ? $m_s_None$() : new $c_s_Some((itemWidth.h().V() | 0)));
  var widthOfFirstItem = ((this$10.c() ? 5 : this$10.h()) | 0);
  var firstDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((("tree-row-align-top " + firstItemStyle) + " ms-4 ms-lg-2 flex-grow-0 flex-shrink-0 dynamic-flex"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), firstItemIcons.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ic$2) => $m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(((ic$2.by + " ") + iconCss), $m_Lscalatags_JsDom$all$().s)]))))), $m_s_$less$colon$less$().b0)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("pre-wrap", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text))]))])).aB();
  var \u03b41$ = firstDiv.style;
  \u03b41$.setProperty("--custom-flex", (widthOfFirstItem + "%"));
  var tailOfItems = withWidths.ak();
  var tailDivs = tailOfItems.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var item = x$1$2.P();
      var width = (x$1$2.V() | 0);
      var this$29 = item.lw;
      var text$1 = (this$29.c() ? "" : this$29.h());
      var $x_2 = $m_Lscalatags_JsDom$all$().as();
      var $x_1 = $m_Lscalatags_JsDom$all$().D();
      var this$31 = item.lv;
      var rowDiv = $x_2.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_1.n((("tree-row-align-top " + (this$31.c() ? "" : this$31.h())) + " dynamic-flex"), $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), item.lu.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ic$2$1) => {
        var $x_5 = $m_Lscalatags_JsDom$all$().c6();
        var $x_4 = $m_Lscalatags_JsDom$all$().D();
        var $x_3 = ic$2$1.by;
        var this$32 = item.lt;
        return $x_5.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_4.n((($x_3 + " ") + (this$32.c() ? "" : this$32.h())), $m_Lscalatags_JsDom$all$().s)]));
      }))), $m_s_$less$colon$less$().b0)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("pre-wrap", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(text$1))]))])).aB();
      var \u03b42$ = rowDiv.style;
      \u03b42$.setProperty("--custom-flex", (width + "%"));
      return rowDiv;
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  var tailDivWrapper = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex flex-column flex-xl-row ms-1 ms-lg-0 flex-max-content", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), tailDivs, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2))))])).aB();
  var allInnerDivsOfTree = new $c_sci_$colon$colon(firstDiv, new $c_sci_$colon$colon(tailDivWrapper, $m_sci_Nil$()));
  return new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("d-flex ms-1 flex-max-content", $m_Lscalatags_JsDom$all$().s), new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), allInnerDivsOfTree, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2$1) => new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), e$2$1))))])), $m_sci_Nil$());
}
function $p_Lcom_papasofokli_tree_TreeJs$__createEmptyElement__Lorg_scalajs_dom_HTMLLIElement($thiz) {
  return $m_Lscalatags_JsDom$all$().he().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-leaf", $m_Lscalatags_JsDom$all$().s), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("scala-tree-row", $m_Lscalatags_JsDom$all$().s)]))])).aB();
}
function $p_Lcom_papasofokli_tree_TreeJs$__treeNodeItemOnClick__Lcom_papasofokli_jstree_TreeNodeData__T__T__Z__s_concurrent_ExecutionContext__F1($thiz, item, clickFunctionId, clickType, expandOnDoubleClick, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => {
    if ((clickType === $thiz.xO)) {
      var $x_1_$_lo = 400;
      var $x_1_$_hi = 0;
    } else {
      var $x_1_$_lo = 50;
      var $x_1_$_hi = 0;
    }
    return new $c_Lcom_papasofokli_util_MultipleEventHandler($x_1_$_lo, $x_1_$_hi, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var this$2_$_lo = item.gE;
      var this$2_$_hi = item.gF;
      $p_Lcom_papasofokli_tree_TreeJs$__selectElement__T__Lcom_papasofokli_jquery_JQuery($thiz, $m_RTLong$().gc(this$2_$_lo, this$2_$_hi));
      var x = ((clickType + " ") + $thiz.Ga);
      $m_s_Console$().J1().zO((x + "\n"));
      matchResult3: {
        var _3 = $thiz.Ga;
        if (expandOnDoubleClick) {
          if ((clickType === $thiz.Qr)) {
            $p_Lcom_papasofokli_tree_TreeJs$__toggleExpand__J__Z($thiz, item.gE, item.gF);
            $thiz.Ga = true;
            $p_Lcom_papasofokli_tree_TreeJs$__postClickActions__Lcom_papasofokli_jstree_TreeNodeData__T__T__s_concurrent_ExecutionContext__V($thiz, item, clickFunctionId, clickType, ec);
            break matchResult3;
          }
          if ((_3 && (clickType === $thiz.xO))) {
            $thiz.Gb = ((1 + $thiz.Gb) | 0);
            if (($thiz.Gb === 2)) {
              $thiz.Gb = 0;
              $thiz.Ga = false;
              break matchResult3;
            } else {
              break matchResult3;
            }
          }
          if (((!_3) && (clickType === $thiz.xO))) {
            $p_Lcom_papasofokli_tree_TreeJs$__postClickActions__Lcom_papasofokli_jstree_TreeNodeData__T__T__s_concurrent_ExecutionContext__V($thiz, item, clickFunctionId, clickType, ec);
            break matchResult3;
          }
        }
        if ((!expandOnDoubleClick)) {
          if ((clickType === $thiz.xO)) {
            $p_Lcom_papasofokli_tree_TreeJs$__toggleExpand__J__Z($thiz, item.gE, item.gF);
            $p_Lcom_papasofokli_tree_TreeJs$__postClickActions__Lcom_papasofokli_jstree_TreeNodeData__T__T__s_concurrent_ExecutionContext__V($thiz, item, clickFunctionId, clickType, ec);
            break matchResult3;
          }
        }
      }
    })));
  }));
}
function $p_Lcom_papasofokli_tree_TreeJs$__postClickActions__Lcom_papasofokli_jstree_TreeNodeData__T__T__s_concurrent_ExecutionContext__V($thiz, item, clickFunctionId, clickType, ec) {
  var isExpanded = (!(!(0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $s_RTLong__toString__I__I__T(item.gE, item.gF))).hasClass($thiz.Ch)));
  var this$6 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id$1 = $m_ju_UUID$().aO(clickFunctionId);
  var $x_4 = $m_Lupickle_default$();
  var $x_3 = item;
  var $x_2_$_lo = $x_3.u5;
  var $x_2_$_hi = $x_3.u6;
  var $x_1 = item;
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_4, new $c_Lcom_papasofokli_jstree_NodeClickRequest(new $c_Lcom_papasofokli_jstree_TreeNodeData($x_2_$_lo, $x_2_$_hi, $x_1.gE, $x_1.gF, item.k0, item.lx, isExpanded, true, item.nq, item.lC, item.lB, item.lz, item.lA), clickType), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_jstree_NodeClickRequest$().q());
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$6, id$1.g(), data, ec);
}
function $p_Lcom_papasofokli_tree_TreeJs$__treeLeafItemOnClick__Lcom_papasofokli_jstree_TreeLeafData__T__T__s_concurrent_ExecutionContext__F1($thiz, item, clickFunctionId, clickType, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$10$2) => new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_tree_TreeJs$__selectElement__T__Lcom_papasofokli_jquery_JQuery($thiz, item.i2.g());
    $p_Lcom_papasofokli_tree_TreeJs$__toggleExpand__J__Z($thiz, item.or, item.os);
    var this$7 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
    var id$1 = $m_ju_UUID$().aO(clickFunctionId);
    var $x_3 = $m_Lupickle_default$();
    var $x_2 = item.pe;
    var $x_1 = item;
    var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_3, new $c_Lcom_papasofokli_jstree_LeafClickRequest(new $c_Lcom_papasofokli_jstree_TreeLeafData($x_2, $x_1.or, $x_1.os, true, item.no, item.np, item.jY, item.i2), clickType), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_jstree_LeafClickRequest$().q());
    return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, id$1.g(), data, ec);
  })))));
}
function $p_Lcom_papasofokli_tree_TreeJs$__contextMenu__Lcom_papasofokli_jstree_TreeItemData__T__s_concurrent_ExecutionContext__F1($thiz, item, contextMenuFunctionId, ec) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((event$2) => {
    event$2.preventDefault();
    var this$2 = $m_Lcom_papasofokli_contextmenu_ContextMenuInitializer$();
    var f = (() => event$2);
    this$2.Ey((f().pageX | 0), (f().pageY | 0));
    return new $c_Lcom_papasofokli_util_MultipleEventHandler(200, 0, ec).dS(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var this$8 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var id = $m_ju_UUID$().aO(contextMenuFunctionId);
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_jstree_ContextMenuRequest(item), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_jstree_ContextMenuRequest$().q());
      $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$8, id.g(), data, ec);
    })));
  }));
}
function $p_Lcom_papasofokli_tree_TreeJs$__selectElement__T__Lcom_papasofokli_jquery_JQuery($thiz, recordId) {
  var jqElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + recordId));
  var allSelected = (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + $thiz.Ci));
  allSelected.removeClass($thiz.Ci);
  return jqElement.addClass($thiz.Ci);
}
function $p_Lcom_papasofokli_tree_TreeJs$__toggleExpand__J__Z($thiz, recordId_$_lo, recordId_$_hi) {
  var jqElement = (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $s_RTLong__toString__I__I__T(recordId_$_lo, recordId_$_hi)));
  return ((!(!jqElement.hasClass($thiz.Ch))) ? ((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + $s_RTLong__toString__I__I__T(recordId_$_lo, recordId_$_hi)) + "-toggle")).removeClass($thiz.Qo).addClass($thiz.Kw), true) : ((0, $m_Lcom_papasofokli_jquery_package$().I)((("#" + $s_RTLong__toString__I__I__T(recordId_$_lo, recordId_$_hi)) + "-toggle")).removeClass($thiz.Kw).addClass($thiz.Qo), false));
}
/** @constructor */
function $c_Lcom_papasofokli_tree_TreeJs$() {
  this.Kx = null;
  this.a8d = null;
  this.a8c = null;
  this.a8a = null;
  this.a89 = null;
  this.a8b = null;
  this.xO = null;
  this.Qr = null;
  this.Qp = null;
  this.Ch = null;
  this.Ci = null;
  this.Kw = null;
  this.Qo = null;
  this.Qq = 0;
  this.Ga = false;
  this.Gb = 0;
  $n_Lcom_papasofokli_tree_TreeJs$ = this;
  $f_Lcom_papasofokli_jstree_TreeT__$init$__V(this);
  this.Qq = 90;
  this.Ga = false;
  this.Gb = 0;
}
$p = $c_Lcom_papasofokli_tree_TreeJs$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_tree_TreeJs$;
/** @constructor */
function $h_Lcom_papasofokli_tree_TreeJs$() {
}
$h_Lcom_papasofokli_tree_TreeJs$.prototype = $p;
$p.b7 = (function(ec) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("." + this.Kx)).each(((this$1) => (function() {
    var setupFunctionId = this.getAttribute(this$1.a8d);
    var nodeClickFunctionId = this.getAttribute(this$1.a8c);
    var leafClickFunctionId = this.getAttribute(this$1.a8a);
    var contextMenuFunctionId = this.getAttribute(this$1.a89);
    var liClassCss = this.getAttribute(this$1.a8b);
    return $m_Lcom_papasofokli_util_AjaxCallFunctions$().c5(setupFunctionId, "", ec).aF(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((resp$2) => $m_sjs_js_Thenable$Implicits$().bH(resp$2.text()).aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((text$3) => {
      var setupData = $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($m_Lupickle_default$(), new $c_Lujson_Readable$fromTransformer(text$3, $m_Lujson_StringParser$()), ($m_Lupickle_default$(), true), $m_Lcom_papasofokli_jstree_TreeNodeListSetupData$().q());
      $p_Lcom_papasofokli_tree_TreeJs$__removeAndAddChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery(this$1, this, setupData.pg.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node$2) => $p_Lcom_papasofokli_tree_TreeJs$__createNodeElement__Lorg_scalajs_dom_Element__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Z__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement(this$1, this, node$2, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, setupData.si, ($m_sc_StringOps$(), ((liClassCss !== "") ? new $c_s_Some(liClassCss) : $m_s_None$())), ec)))).cH(setupData.pf.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((node$2$1) => $p_Lcom_papasofokli_tree_TreeJs$__createLeafElement__Lcom_papasofokli_jstree_TreeLeafData__T__T__s_Option__s_concurrent_ExecutionContext__Lorg_scalajs_dom_HTMLLIElement(this$1, node$2$1, leafClickFunctionId, contextMenuFunctionId, ($m_sc_StringOps$(), ((liClassCss !== "") ? new $c_s_Some(liClassCss) : $m_s_None$())), ec))))));
      setupData.pf.bB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.jZ))).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((leaf$2) => {
        var this$18 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
        var id$1 = $m_ju_UUID$().aO(leafClickFunctionId);
        var $x_3 = $m_Lupickle_default$();
        var $x_2 = leaf$2.pe;
        var $x_1 = leaf$2;
        var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($x_3, new $c_Lcom_papasofokli_jstree_LeafClickRequest(new $c_Lcom_papasofokli_jstree_TreeLeafData($x_2, $x_1.or, $x_1.os, true, leaf$2.no, leaf$2.np, leaf$2.jY, leaf$2.i2), this$1.Qp), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_jstree_LeafClickRequest$().q());
        return $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$18, id$1.g(), data, ec);
      })));
      $p_Lcom_papasofokli_tree_TreeJs$__triggerInitialSelectionRecursive__sci_Seq__T__s_concurrent_ExecutionContext__V(this$1, setupData.pg, nodeClickFunctionId, ec);
    })), ec))), ec);
  }))(this));
});
$p.amo = (function(node, withRefresh, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, expandOnDoubleClick, cssClass, ec) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(("#" + $s_RTLong__toString__I__I__T(node.gE, node.gF))).each(((this$1) => (function() {
    var alreadyExpanded = node.ly;
    var emptyElement = (node.k0.c() && node.lx.c());
    if (alreadyExpanded) {
      return ((!withRefresh) ? ($p_Lcom_papasofokli_tree_TreeJs$__removeChildrenFromElement__Lorg_scalajs_dom_Element__V(this$1, this), (void 0)) : (void 0));
    } else if (((!alreadyExpanded) && (!emptyElement))) {
      if (withRefresh) {
        $p_Lcom_papasofokli_tree_TreeJs$__removeChildrenFromElement__Lorg_scalajs_dom_Element__V(this$1, this);
      }
      return $p_Lcom_papasofokli_tree_TreeJs$__createAndAppendNodeElementsToParent__Lcom_papasofokli_jstree_TreeNodeData__T__T__T__Lorg_scalajs_dom_Element__Z__s_Option__s_concurrent_ExecutionContext__Lcom_papasofokli_jquery_JQuery(this$1, node, nodeClickFunctionId, leafClickFunctionId, contextMenuFunctionId, this, expandOnDoubleClick, cssClass, ec);
    } else if (((!alreadyExpanded) && emptyElement)) {
      if (withRefresh) {
        $p_Lcom_papasofokli_tree_TreeJs$__removeChildrenFromElement__Lorg_scalajs_dom_Element__V(this$1, this);
      }
      return $p_Lcom_papasofokli_tree_TreeJs$__appendChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery(this$1, this, new $c_sci_$colon$colon($p_Lcom_papasofokli_tree_TreeJs$__createEmptyElement__Lorg_scalajs_dom_HTMLLIElement(this$1), $m_sci_Nil$()));
    } else {
      return $p_Lcom_papasofokli_tree_TreeJs$__appendChildrenToElement__Lorg_scalajs_dom_Element__sci_Seq__Lcom_papasofokli_jquery_JQuery(this$1, this, new $c_sci_$colon$colon($p_Lcom_papasofokli_tree_TreeJs$__createEmptyElement__Lorg_scalajs_dom_HTMLLIElement(this$1), $m_sci_Nil$()));
    }
  }))(this));
});
var $d_Lcom_papasofokli_tree_TreeJs$ = new $TypeData().i($c_Lcom_papasofokli_tree_TreeJs$, "com.papasofokli.tree.TreeJs$", ({
  sg: 1,
  px: 1
}));
var $n_Lcom_papasofokli_tree_TreeJs$;
function $m_Lcom_papasofokli_tree_TreeJs$() {
  if ((!$n_Lcom_papasofokli_tree_TreeJs$)) {
    $n_Lcom_papasofokli_tree_TreeJs$ = new $c_Lcom_papasofokli_tree_TreeJs$();
  }
  return $n_Lcom_papasofokli_tree_TreeJs$;
}
var $d_Lcom_papasofokli_websocket_VisibilityInfo = new $TypeData().i(1, "com.papasofokli.websocket.VisibilityInfo", ({
  cm: 1,
  b1: 1
}));
/** @constructor */
function $c_jl_Character$() {
  this.KD = null;
  $n_jl_Character$ = this;
  this.KD = $constArrUDiffs_I(67, "1C]4m6m=c4]4]4]4]4]4]4]4]4]3g4]2m9]2m1Jm1m9s4g5mm6]3]4mm12>mEm1m6m1]3]=]DI]1<m24mIs4g2c4w9];]4]<]3m3m=m3mH]8]2m=mBHm3]4mK3{gggg2:g=m@]13]4E]");
}
$p = $c_jl_Character$.prototype = new $h_O();
$p.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
}
$h_jl_Character$.prototype = $p;
$p.EF = (function(codePoint) {
  if (((codePoint >>> 0) > 1114111)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return String.fromCodePoint(codePoint);
});
$p.DZ = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((((codePoint - 48) | 0) >>> 0) <= 9) ? ((codePoint - 48) | 0) : (((((codePoint - 65) | 0) >>> 0) <= 25) ? ((codePoint - 55) | 0) : (((((codePoint - 97) | 0) >>> 0) <= 25) ? ((codePoint - 87) | 0) : (-1))));
  } else if (((((codePoint - 65313) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65303) | 0);
  } else if (((((codePoint - 65345) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65335) | 0);
  } else {
    var p = $m_ju_Arrays$().afP(this.KD, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1);
    } else {
      var v = ((codePoint - this.KD.a[zeroCodePointIndex]) | 0);
      var value = ((v > 9) ? (-1) : v);
    }
  }
  return ((value < radix) ? value : (-1));
});
$p.avz = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().afP(this.KD, ch) >= 0));
});
$p.au3 = (function(digit, radix) {
  if ((((((radix - 2) | 0) >>> 0) > 34) || ((digit >>> 0) >= (radix >>> 0)))) {
    return 0;
  } else {
    var overBaseTen = ((digit - 10) | 0);
    return (65535 & ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0)));
  }
});
$p.bs = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break;
    }
    default: {
      if (((((codePoint - 8064) | 0) >>> 0) <= 47)) {
        return (8 | codePoint);
      } else {
        var this$1 = this.EF(codePoint);
        var upperChars = this$1.toUpperCase();
        switch (upperChars.length) {
          case 1: {
            return upperChars.charCodeAt(0);
            break;
          }
          case 2: {
            var high = upperChars.charCodeAt(0);
            var low = upperChars.charCodeAt(1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break;
          }
          default: {
            return codePoint;
          }
        }
      }
    }
  }
});
$p.br = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105;
  } else {
    var this$1 = this.EF(codePoint);
    var lowerChars = this$1.toLowerCase();
    switch (lowerChars.length) {
      case 1: {
        return lowerChars.charCodeAt(0);
        break;
      }
      case 2: {
        var high = lowerChars.charCodeAt(0);
        var low = lowerChars.charCodeAt(1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break;
      }
      default: {
        return codePoint;
      }
    }
  }
});
var $d_jl_Character$ = new $TypeData().i($c_jl_Character$, "java.lang.Character$", ({
  tx: 1,
  a: 1
}));
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$();
  }
  return $n_jl_Character$;
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.t7) << 24) >> 24) === 0)) {
    $thiz.QE = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.t7 = (((1 | $thiz.t7) << 24) >> 24);
  }
  return $thiz.QE;
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.t7) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.QE);
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.t7) << 24) >> 24) === 0)) {
    $thiz.QD = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.t7 = (((2 | $thiz.t7) << 24) >> 24);
  }
  return $thiz.QD;
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.t7) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.QD);
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var x = groups[1];
  var x$1 = groups[2];
  var x$2 = groups[3];
  var x$3 = groups[4];
  if (((x$1 === "") && (x$2 === ""))) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var absResult = $thiz.aj9(x$1, x$2, x$3, 15);
  return ((x === "-") ? (-absResult) : absResult);
}
function $ps_jl_Double$__fail$1__T__E(s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
/** @constructor */
function $c_jl_Double$() {
  this.QE = null;
  this.QD = null;
  this.t7 = 0;
}
$p = $c_jl_Double$.prototype = new $h_O();
$p.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
}
$h_jl_Double$.prototype = $p;
$p.fS = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  return ((groups !== null) ? (+parseFloat(groups[1])) : $p_jl_Double$__parseDoubleSlowPath__T__D(this, s));
});
$p.aj9 = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-(fractionalPartStr.length << 2)) | 0);
  var limit = ((mantissaStr0.length - 1) | 0);
  var i = 0;
  while (((i !== limit) && (mantissaStr0.charCodeAt(i) === 48))) {
    i = ((1 + i) | 0);
  }
  var beginIndex = i;
  var mantissaStr = mantissaStr0.substring(beginIndex);
  var mantissaStrLen = mantissaStr.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      if ((mantissaStr.charCodeAt(j) !== 48)) {
        hasNonZeroChar = true;
      }
      j = ((1 + j) | 0);
    }
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = (mantissaStr.substring(0, maxPrecisionChars) + compressedTail);
  } else {
    var truncatedMantissaStr = mantissaStr;
  }
  var correction2 = (needsCorrection2 ? (((mantissaStr.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  return $m_jl_Math$().axH((+parseInt(truncatedMantissaStr, 16)), (($doubleToInt((+parseInt(binaryExpStr, 10))) + fullCorrection) | 0));
});
$p.zy = (function(a, b) {
  if ((a !== a)) {
    return ((b === b) | 0);
  } else if ((b !== b)) {
    return (-1);
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1));
    } else {
      return 0;
    }
  } else {
    return ((a < b) ? (-1) : 1);
  }
});
var $d_jl_Double$ = new $TypeData().i($c_jl_Double$, "java.lang.Double$", ({
  tA: 1,
  a: 1
}));
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$();
  }
  return $n_jl_Double$;
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.QF)) {
    $thiz.QG = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.QF = true;
  }
  return $thiz.QG;
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.QF) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.QG);
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = (+parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().aww(z);
    var mid$2 = (0.5 * (zDouble + zUp));
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $m_jl_Math$().awv(z);
    var mid$3 = (0.5 * (zDouble + zDown));
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var e = (($m_jl_Integer$().c7(exponentStr, 10, 214748364) - fractionalPartStr.length) | 0);
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, mid, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().iy(lo, hi$3);
  var k = ((lo$1 - 1075) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.hf($m_Ljava_math_BigInteger$().pY.qL(e));
      var y = m.kT(k);
      var cmp = x.ur(y);
    } else {
      var v = f.hf($m_Ljava_math_BigInteger$().pY.qL(e));
      var e$1 = ((-k) | 0);
      var cmp = v.kT(e$1).ur(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var cmp = f.ur(m.hf($m_Ljava_math_BigInteger$().pY.qL(e$2)).kT(k));
  } else {
    var x$2 = f.kT(((-k) | 0));
    var e$4 = ((-e) | 0);
    var y$2 = m.hf($m_Ljava_math_BigInteger$().pY.qL(e$4));
    var cmp = x$2.ur(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $floatToBits(zDown)) === 0) ? zDown : zUp)));
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  return Math.fround($m_jl_Double$().aj9(integralPartStr, fractionalPartStr, binaryExpStr, 7));
}
/** @constructor */
function $c_jl_Float$() {
  this.QG = null;
  this.QF = false;
}
$p = $c_jl_Float$.prototype = new $h_O();
$p.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
$h_jl_Float$.prototype = $p;
$p.gL = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  if ((groups[2] !== (void 0))) {
    var absResult = (NaN);
  } else if ((groups[3] !== (void 0))) {
    var absResult = Infinity;
  } else if ((groups[4] !== (void 0))) {
    var $x_1 = groups[4];
    var x$4 = groups[5];
    var x$5 = groups[6];
    var x$6 = groups[7];
    var x$7 = groups[8];
    var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, $x_1, ((x$4 !== (void 0)) ? x$4 : ""), (("" + ((x$5 !== (void 0)) ? x$5 : "")) + ((x$6 !== (void 0)) ? x$6 : "")), ((x$7 !== (void 0)) ? x$7 : "0"));
  } else {
    var x$8 = groups[10];
    var x$9 = groups[11];
    var x$10 = groups[12];
    var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, ((x$8 !== (void 0)) ? x$8 : ""), (("" + ((x$9 !== (void 0)) ? x$9 : "")) + ((x$10 !== (void 0)) ? x$10 : "")), groups[13]);
  }
  return ((groups[1] === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $TypeData().i($c_jl_Float$, "java.lang.Float$", ({
  tB: 1,
  a: 1
}));
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
/** @constructor */
function $c_jl_Integer$() {
}
$p = $c_jl_Integer$.prototype = new $h_O();
$p.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
}
$h_jl_Integer$.prototype = $p;
$p.iu = (function(s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
});
$p.c7 = (function(s, radix, overflowBarrier) {
  if ((s === null)) {
    $m_jl_Integer$().iu(s);
  }
  var len = s.length;
  if ((len === 0)) {
    $m_jl_Integer$().iu(s);
  }
  var character = $m_jl_Character$();
  var firstChar = s.charCodeAt(0);
  var negative = (firstChar === 45);
  var sign = (negative ? (-1) : 0);
  var i = ((negative || (firstChar === 43)) | 0);
  if ((i >= len)) {
    $m_jl_Integer$().iu(s);
  }
  var java$lang$IntFloatBits$Int32Box$$value = 0;
  java$lang$IntFloatBits$Int32Box$$value = 0;
  while ((i !== len)) {
    var x = character.DZ(s.charCodeAt(i), radix);
    if (((x < 0) || ((java$lang$IntFloatBits$Int32Box$$value >>> 0) > (overflowBarrier >>> 0)))) {
      $m_jl_Integer$().iu(s);
    }
    var x$2 = java$lang$IntFloatBits$Int32Box$$value;
    var x$3 = Math.imul(x$2, radix);
    var v = ((x$3 + x) | 0);
    java$lang$IntFloatBits$Int32Box$$value = v;
    i = ((1 + i) | 0);
  }
  if (((java$lang$IntFloatBits$Int32Box$$value >>> 0) > (((2147483647 - sign) | 0) >>> 0))) {
    $m_jl_Integer$().iu(s);
  }
  return (((java$lang$IntFloatBits$Int32Box$$value ^ sign) - sign) | 0);
});
$p.cI = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24);
});
var $d_jl_Integer$ = new $TypeData().i($c_jl_Integer$, "java.lang.Integer$", ({
  tC: 1,
  a: 1
}));
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$();
  }
  return $n_jl_Integer$;
}
function $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.QH)) {
    var r = [];
    var i = 0;
    while ((i < 2)) {
      r.push(null);
      i = ((1 + i) | 0);
    }
    var i$1 = 2;
    while ((i$1 <= 36)) {
      var value$1 = i$1;
      var barrier = ((1073741824 / ($checkIntDivisor(value$1) >>> 0)) | 0);
      var radixPowLength = value$1;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, value$1);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0");
      }
      var mHat = ((1.0 / radixPowLength) + 2.6469779601696886E-23);
      var $x_1 = $m_RTLong$().Mu((-1), (-1), radixPowLength, 0);
      var overflowBarrier_$_lo = $x_1.l;
      var overflowBarrier_$_hi = $x_1.h;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, mHat, paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi));
      i$1 = ((1 + i$1) | 0);
    }
    $thiz.QI = r;
    $thiz.QH = true;
  }
  return $thiz.QI;
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var digit = $m_jl_Character$().DZ(s$1.charCodeAt(i), radix$1);
    if ((digit === (-1))) {
      $m_jl_Integer$().iu(s$1);
    }
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_jl_Long$() {
  this.QI = null;
  this.QH = false;
}
$p = $c_jl_Long$.prototype = new $h_O();
$p.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
}
$h_jl_Long$.prototype = $p;
$p.UP = (function() {
  return ((!this.QH) ? $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O(this) : this.QI);
});
$p.avC = (function(i_$_lo, i_$_hi, radix) {
  if (((i_$_lo >> 31) === i_$_hi)) {
    return i_$_lo.toString(radix);
  } else if ((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0)) {
    return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)).toString(radix);
  } else {
    var sign = (i_$_hi >> 31);
    var xlo = (i_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((i_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var radixInfo = this.UP()[radix];
    var d = radixInfo.KE;
    var mHat = radixInfo.QJ;
    var paddingZeros = radixInfo.QK;
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var a = (aHat * mHat);
    var qHat = (+Math.floor(a));
    var rHat = ((rlo - Math.imul(d, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((rHat + d) | 0);
    }
    var remStr = rHat.toString(radix);
    var s = ((("" + qHat.toString(radix)) + paddingZeros.substring(remStr.length)) + remStr);
    return ((i_$_hi < 0) ? ("-" + s) : s);
  }
});
$p.avD = (function(i_$_lo, i_$_hi, radix) {
  if ((i_$_hi === 0)) {
    return (i_$_lo >>> 0.0).toString(radix);
  } else if ((((-2097152) & i_$_hi) === 0)) {
    return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)).toString(radix);
  } else {
    var radixInfo = this.UP()[radix];
    var d = radixInfo.KE;
    var mHat = radixInfo.QJ;
    var paddingZeros = radixInfo.QK;
    var aHat = ((4.294967296E9 * (i_$_hi >>> 0.0)) + (i_$_lo >>> 0.0));
    var a = (aHat * mHat);
    var qHat = (+Math.floor(a));
    var rHat = ((i_$_lo - Math.imul(d, (qHat | 0.0))) | 0);
    if ((rHat < 0)) {
      qHat = (qHat - 1.0);
      rHat = ((rHat + d) | 0);
    }
    var remStr = rHat.toString(radix);
    return ((("" + qHat.toString(radix)) + paddingZeros.substring(remStr.length)) + remStr);
  }
});
$p.V5 = (function(s, radix) {
  if ((s === "")) {
    $m_jl_Integer$().iu(s);
  }
  var start = 0;
  var neg = false;
  switch (s.charCodeAt(0)) {
    case 43: {
      start = 1;
      break;
    }
    case 45: {
      start = 1;
      neg = true;
      break;
    }
  }
  var $x_1 = this.awS(s, radix, start);
  var unsignedResult_$_lo = $x_1.l;
  var unsignedResult_$_hi = $x_1.h;
  if (neg) {
    var lo = ((-unsignedResult_$_lo) | 0);
    var hi = ((((-unsignedResult_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    if (((hi === 0) ? (lo !== 0) : (hi > 0))) {
      $m_jl_Integer$().iu(s);
    }
    return $bL(lo, hi);
  } else {
    if ((unsignedResult_$_hi < 0)) {
      $m_jl_Integer$().iu(s);
    }
    return $bL(unsignedResult_$_lo, unsignedResult_$_hi);
  }
});
$p.awS = (function(s, radix, start) {
  var length = s.length;
  if ((start >= length)) {
    $m_jl_Integer$().iu(s);
  } else {
    var radixInfo = this.UP()[radix];
    var chunkLen = radixInfo.a97;
    var firstChunkStart = start;
    while (((firstChunkStart < length) && $m_jl_Character$().avz(s.charCodeAt(firstChunkStart)))) {
      firstChunkStart = ((1 + firstChunkStart) | 0);
    }
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $m_jl_Integer$().iu(s);
    }
    var firstChunkLength = ((1 + ((((((length - firstChunkStart) | 0) - 1) | 0) % $checkIntDivisor(chunkLen)) | 0)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return $bL(x, 0);
    } else {
      var x$1 = radixInfo.KE;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & x$1);
      var b1 = ((x$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$1 = ((lo + x$2) | 0);
      var hi$1 = ((hi + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      if ((secondChunkEnd === length)) {
        return $bL(lo$1, hi$1);
      } else {
        var overflowBarrier_$_lo = radixInfo.afk;
        var overflowBarrier_$_hi = radixInfo.afl;
        var x$3 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$1 === overflowBarrier_$_hi) ? ((lo$1 >>> 0) > (overflowBarrier_$_lo >>> 0)) : (hi$1 > overflowBarrier_$_hi))) {
          $m_jl_Integer$().iu(s);
        }
        var a0$1 = (65535 & lo$1);
        var a1$1 = ((lo$1 >>> 16) | 0);
        var b0$1 = (65535 & x$1);
        var b1$1 = ((x$1 >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$2 = ((((((Math.imul(hi$1, x$1) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$3 = ((lo$2 + x$3) | 0);
        var hi$3 = ((hi$2 + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
        if (((hi$3 === 0) && ((lo$3 >>> 0) < (x$3 >>> 0)))) {
          $m_jl_Integer$().iu(s);
        }
        return $bL(lo$3, hi$3);
      }
    }
  }
});
$p.ahW = (function(lo, hi) {
  if ((hi !== 0)) {
    var $x_1 = (hi >>> 0.0).toString(16);
    var s = (lo >>> 0.0).toString(16);
    var beginIndex = s.length;
    return ($x_1 + (("" + "00000000".substring(beginIndex)) + s));
  } else {
    return (lo >>> 0.0).toString(16);
  }
});
$p.avB = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $x_2 = (hp >>> 0.0).toString(8);
    var s = (mp >>> 0.0).toString(8);
    var beginIndex = s.length;
    var $x_1 = "0000000000".substring(beginIndex);
    var s$1 = (lp >>> 0.0).toString(8);
    var beginIndex$1 = s$1.length;
    return (($x_2 + (("" + $x_1) + s)) + (("" + "0000000000".substring(beginIndex$1)) + s$1));
  } else if ((mp !== 0)) {
    var $x_3 = (mp >>> 0.0).toString(8);
    var s$2 = (lp >>> 0.0).toString(8);
    var beginIndex$2 = s$2.length;
    return ($x_3 + (("" + "0000000000".substring(beginIndex$2)) + s$2));
  } else {
    return (lp >>> 0.0).toString(8);
  }
});
var $d_jl_Long$ = new $TypeData().i($c_jl_Long$, "java.lang.Long$", ({
  tI: 1,
  a: 1
}));
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$();
  }
  return $n_jl_Long$;
}
/** @constructor */
function $c_jl_Number() {
}
$p = $c_jl_Number.prototype = new $h_O();
$p.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
}
$h_jl_Number.prototype = $p;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $Long));
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aA)));
}
/** @constructor */
function $c_jl_StackTraceElement(declaringClass, methodName, fileName, lineNumber, columnNumber) {
  this.Co = null;
  this.Gp = null;
  this.Cp = null;
  this.Cq = 0;
  this.Cn = 0;
  this.Co = declaringClass;
  this.Gp = methodName;
  this.Cp = fileName;
  this.Cq = lineNumber;
  this.Cn = columnNumber;
}
$p = $c_jl_StackTraceElement.prototype = new $h_O();
$p.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
}
$h_jl_StackTraceElement.prototype = $p;
$p.b = (function(that) {
  return ((that instanceof $c_jl_StackTraceElement) && (((((this.Cp === that.Cp) && (this.Cq === that.Cq)) && (this.Cn === that.Cn)) && (this.Co === that.Co)) && (this.Gp === that.Gp)));
});
$p.g = (function() {
  var result = "";
  if ((this.Co !== "<jscode>")) {
    result = ((("" + result) + this.Co) + ".");
  }
  result = (("" + result) + this.Gp);
  if ((this.Cp === null)) {
    result = (result + "(Unknown Source)");
  } else {
    result = ((result + "(") + this.Cp);
    if ((this.Cq >= 0)) {
      result = ((result + ":") + this.Cq);
      if ((this.Cn >= 0)) {
        result = ((result + ":") + this.Cn);
      }
    }
    result = (result + ")");
  }
  return result;
});
$p.r = (function() {
  return (((($f_T__hashCode__I(this.Co) ^ $f_T__hashCode__I(this.Gp)) ^ $f_T__hashCode__I(this.Cp)) ^ this.Cq) ^ this.Cn);
});
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gs)));
}
var $d_jl_StackTraceElement = new $TypeData().i($c_jl_StackTraceElement, "java.lang.StackTraceElement", ({
  gs: 1,
  a: 1
}));
/** @constructor */
function $c_jl_String$() {
}
$p = $c_jl_String$.prototype = new $h_O();
$p.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
}
$h_jl_String$.prototype = $p;
$p.hg = (function(value, offset, count) {
  var endOffset = ((offset + count) | 0);
  var result = "";
  var i = offset;
  while ((i !== endOffset)) {
    result = (result + ("" + $cToS(value.a[i])));
    i = ((1 + i) | 0);
  }
  return result;
});
$p.aiY = (function(bytes, offset, length, charset) {
  var bb = $m_Ljava_nio_HeapByteBuffer$().azA(bytes, 0, bytes.a.length, offset, length, false);
  return $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(charset).atc(bb).g();
});
$p.au5 = (function(format, args) {
  return $ct_ju_Formatter__(new $c_ju_Formatter()).au6(format, args).g();
});
var $d_jl_String$ = new $TypeData().i($c_jl_String$, "java.lang.String$", ({
  tR: 1,
  a: 1
}));
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$();
  }
  return $n_jl_String$;
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.a9c = s;
  $thiz.KF = e;
  $thiz.a9d = writableStackTrace;
  if (writableStackTrace) {
    $thiz.zF();
  }
  return $thiz;
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.a9c = null;
    this.KF = null;
    this.a9d = false;
    this.a9b = null;
    this.xY = null;
  }
  dI() {
    return this.a9c;
  }
  zF() {
    var reference = ((this instanceof $c_sjs_js_JavaScriptException) ? this.b6 : this);
    this.a9b = ((Object.prototype.toString.call(reference) === "[object Error]") ? reference : (((Error.captureStackTrace === (void 0)) || (!(!Object.isSealed(this)))) ? new Error() : (Error.captureStackTrace(this), this)));
    return this;
  }
  II() {
    if ((this.xY === null)) {
      if (this.a9d) {
        this.xY = $m_jl_StackTrace$().atL(this.a9b);
      } else {
        this.xY = new ($d_jl_StackTraceElement.r().C)(0);
      }
    }
    return this.xY;
  }
  Eu(s) {
    this.II();
    var t = this.g();
    s.zT(t);
    if ((this.xY.a.length !== 0)) {
      var i = 0;
      while ((i < this.xY.a.length)) {
        var t$1 = ("  at " + this.xY.a[i]);
        s.zT(t$1);
        i = ((1 + i) | 0);
      }
    } else {
      s.zT("  <no stack trace available>");
    }
    var wCause = this;
    while (((wCause !== wCause.KF) && (wCause.KF !== null))) {
      var parentTrace = wCause.II();
      wCause = wCause.KF;
      var thisTrace = wCause.II();
      var thisLength = thisTrace.a.length;
      var parentLength = parentTrace.a.length;
      var t$2 = ("Caused by: " + wCause);
      s.zT(t$2);
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = thisTrace.a[((((thisLength - sameFrameCount) | 0) - 1) | 0)];
            var x$2 = parentTrace.a[((((parentLength - sameFrameCount) | 0) - 1) | 0)];
            var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            sameFrameCount = ((1 + sameFrameCount) | 0);
          } else {
            break;
          }
        }
        if ((sameFrameCount > 0)) {
          sameFrameCount = ((sameFrameCount - 1) | 0);
        }
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          var t$3 = ("  at " + thisTrace.a[i$2]);
          s.zT(t$3);
          i$2 = ((1 + i$2) | 0);
        }
        if ((sameFrameCount > 0)) {
          var t$4 = (("  ... " + sameFrameCount) + " more");
          s.zT(t$4);
        }
      } else {
        s.zT("  <no stack trace available>");
      }
    }
  }
  g() {
    var className = $objectClassName(this);
    var message = this.dI();
    return ((message === null) ? className : ((className + ": ") + message));
  }
  r() {
    return $c_O.prototype.r.call(this);
  }
  b(that) {
    return $c_O.prototype.b.call(this, that);
  }
  get "message"() {
    var m = this.dI();
    return ((m === null) ? "" : m);
  }
  get "name"() {
    return $objectClassName(this);
  }
  "toString"() {
    return this.g();
  }
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.F)));
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.a9h = null;
  this.QR = null;
  this.Gq = null;
  this.a9g = null;
  this.QQ = null;
  this.a9i = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.a9h = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.QR = this.aiZ(28, 5);
  var len = ((this.QR.a.length >>> 1) | 0);
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var value = i;
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var $x_2 = $m_Ljava_math_BigDecimal$().QR.a;
    var $x_3 = (value << 1);
    var $x_1_$_lo = $x_2[$x_3];
    var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
    result.a[value] = $x_4.Ip($x_1_$_lo, $x_1_$_hi);
    i = ((1 + i) | 0);
  }
  this.Gq = this.aiZ(19, 10);
  var len$2 = ((this.Gq.a.length >>> 1) | 0);
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var value$1 = i$1;
    var $x_8 = $m_Ljava_math_BigDecimal$();
    var $x_6 = $m_Ljava_math_BigDecimal$().Gq.a;
    var $x_7 = (value$1 << 1);
    var $x_5_$_lo = $x_6[$x_7];
    var $x_5_$_hi = $x_6[(($x_7 + 1) | 0)];
    result$2.a[value$1] = $x_8.Ip($x_5_$_lo, $x_5_$_hi);
    i$1 = ((1 + i$1) | 0);
  }
  var result$3 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var value$2 = i$2;
    result$3.a[value$2] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), value$2, 0);
    i$2 = ((1 + i$2) | 0);
  }
  this.a9g = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.r().C)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var value$3 = i$3;
    result$4.a[value$3] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, value$3);
    i$3 = ((1 + i$3) | 0);
  }
  this.QQ = result$4;
  this.a9i = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
$p = $c_Ljava_math_BigDecimal$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
$h_Ljava_math_BigDecimal$.prototype = $p;
$p.aku = (function(unscaledVal_$_lo, unscaledVal_$_hi, scale) {
  return ((scale === 0) ? this.az6(unscaledVal_$_lo, unscaledVal_$_hi) : (((((unscaledVal_$_lo | unscaledVal_$_hi) === 0) && (scale >= 0)) && (scale < this.QQ.a.length)) ? this.QQ.a[scale] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, scale)));
});
$p.az6 = (function(unscaledVal_$_lo, unscaledVal_$_hi) {
  return (((unscaledVal_$_hi >= 0) && ((unscaledVal_$_hi === 0) ? ((unscaledVal_$_lo >>> 0) < 11) : (unscaledVal_$_hi < 0))) ? this.a9g.a[unscaledVal_$_lo] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, 0));
});
$p.avG = (function(value1_$_lo, value1_$_hi, value2_$_lo, value2_$_hi) {
  return (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) > (value2_$_lo >>> 0)) : (value1_$_hi > value2_$_hi)) ? 1 : (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) < (value2_$_lo >>> 0)) : (value1_$_hi < value2_$_hi)) ? (-1) : 0));
});
$p.aiZ = (function(len, pow) {
  var result = new $ac_J(len);
  var $x_1 = result.a;
  $x_1[0] = 1;
  $x_1[1] = 0;
  var i = 1;
  while ((i < len)) {
    var value = i;
    var $x_2 = result.a;
    var $x_3 = (((value - 1) | 0) << 1);
    var x_$_lo = $x_2[$x_3];
    var x_$_hi = $x_2[(($x_3 + 1) | 0)];
    var hi = (pow >> 31);
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(x_$_lo, hi) + Math.imul(x_$_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $x_4 = result.a;
    var $x_5 = (value << 1);
    $x_4[$x_5] = lo;
    $x_4[(($x_5 + 1) | 0)] = hi$1;
    i = ((1 + i) | 0);
  }
  return result;
});
$p.ahY = (function(parityBit, fraction, roundingMode) {
  var sign = (fraction >> 31);
  var absFraction = (((fraction ^ sign) - sign) | 0);
  var sigFraction = ((fraction >> 31) | ((((-fraction) | 0) >>> 31) | 0));
  var x = $m_Ljava_math_RoundingMode$().a9q;
  if (((x === null) ? (roundingMode === null) : (x === roundingMode))) {
    return sigFraction;
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().a9m;
    if (((x$3 === null) ? (roundingMode === null) : (x$3 === roundingMode))) {
      return 0;
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().a9l;
      if (((x$5 === null) ? (roundingMode === null) : (x$5 === roundingMode))) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().a9n;
        if (((x$7 === null) ? (roundingMode === null) : (x$7 === roundingMode))) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().QX;
          if (((x$9 === null) ? (roundingMode === null) : (x$9 === roundingMode))) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().a9o;
            if (((x$11 === null) ? (roundingMode === null) : (x$11 === roundingMode))) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ct;
              if (((x$13 === null) ? (roundingMode === null) : (x$13 === roundingMode))) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().a9p;
                if ((!((x$15 === null) ? (roundingMode === null) : (x$15 === roundingMode)))) {
                  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), roundingMode);
                }
                if ((fraction !== 0)) {
                  throw new $c_jl_ArithmeticException("Rounding necessary");
                }
                return 0;
              }
            }
          }
        }
      }
    }
  }
});
$p.IS = (function(longValue_$_lo, longValue_$_hi) {
  if ((((longValue_$_hi === (-1)) ? ((longValue_$_lo >>> 0) < 2147483648) : (longValue_$_hi < (-1))) || ((longValue_$_hi === 0) ? ((longValue_$_lo >>> 0) > 2147483647) : (longValue_$_hi > 0)))) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + $s_RTLong__toString__I__I__T(longValue_$_lo, longValue_$_hi)));
  }
  return longValue_$_lo;
});
$p.avH = (function(longScale_$_lo, longScale_$_hi) {
  var hi = (longScale_$_lo >> 31);
  if ((((longScale_$_lo ^ longScale_$_lo) | (longScale_$_hi ^ hi)) === 0)) {
    return this.aku(0, 0, longScale_$_lo);
  } else {
    return ((longScale_$_hi >= 0) ? $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647) : $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648)));
  }
});
$p.Ip = (function(sValue_$_lo, sValue_$_hi) {
  if ((sValue_$_hi < 0)) {
    var lo = (~sValue_$_lo);
    var hi = (~sValue_$_hi);
    var smallValue_$_lo = lo;
    var smallValue_$_hi = hi;
  } else {
    var smallValue_$_lo = sValue_$_lo;
    var smallValue_$_hi = sValue_$_hi;
  }
  return ((64 - ((smallValue_$_hi !== 0) ? Math.clz32(smallValue_$_hi) : ((32 + Math.clz32(smallValue_$_lo)) | 0))) | 0);
});
$p.avF = (function(sValue) {
  return ((32 - Math.clz32(((sValue < 0) ? (~sValue) : sValue))) | 0);
});
$p.ahX = (function(c, cs) {
  return (!this.N2(c, cs));
});
$p.N2 = (function(c, cs) {
  var len = cs.a.length;
  var i = 0;
  while ((i !== len)) {
    if ((cs.a[i] === c)) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().i($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  u1: 1,
  a: 1
}));
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Cs = null;
  this.pY = null;
  this.pZ = null;
  this.KH = null;
  this.a9j = null;
  this.QS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Cs = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.pY = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.pZ = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.KH = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.a9j = new ($d_Ljava_math_BigInteger.r().C)([this.pZ, this.Cs, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.pY]);
  var result = new ($d_Ljava_math_BigInteger.r().C)(32);
  var i = 0;
  while ((i < 32)) {
    var value = i;
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & value) === 0) ? (1 << value) : 0);
    var hi = (((32 & value) === 0) ? 0 : (1 << value));
    result.a[value] = $x_1.iy(lo, hi);
    i = ((1 + i) | 0);
  }
  this.QS = result;
}
$p = $c_Ljava_math_BigInteger$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
$h_Ljava_math_BigInteger$.prototype = $p;
$p.iy = (function(lVal_$_lo, lVal_$_hi) {
  if ((lVal_$_hi < 0)) {
    if ((((~lVal_$_lo) | (~lVal_$_hi)) !== 0)) {
      var lo = ((-lVal_$_lo) | 0);
      var hi = ((((-lVal_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), lo, hi);
    } else {
      return this.KH;
    }
  } else {
    return (((lVal_$_hi === 0) ? ((lVal_$_lo >>> 0) <= 10) : (lVal_$_hi < 0)) ? this.a9j.a[lVal_$_lo] : $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal_$_lo, lVal_$_hi));
  }
});
$p.aun = (function(exp) {
  if ((exp < this.QS.a.length)) {
    return this.QS.a[exp];
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.a[intCount] = (1 << bitN);
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$p.an8 = (function(byteLength) {
  if (((byteLength >>> 0) > 67108863)) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().i($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  u2: 1,
  a: 1
}));
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.a9q = null;
  this.a9m = null;
  this.a9l = null;
  this.a9n = null;
  this.QX = null;
  this.a9o = null;
  this.Ct = null;
  this.a9p = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.a9q = new $c_Ljava_math_RoundingMode("UP", 0);
  this.a9m = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.a9l = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.a9n = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.QX = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.a9o = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ct = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.a9p = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
$p = $c_Ljava_math_RoundingMode$.prototype = new $h_O();
$p.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
$h_Ljava_math_RoundingMode$.prototype = $p;
var $d_Ljava_math_RoundingMode$ = new $TypeData().i($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  ub: 1,
  a: 1
}));
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) {
  if (((((2 & $thiz.Gr) << 24) >> 24) === 0)) {
    $thiz.KK = new $c_Ljava_nio_charset_UTF\uff3f8$Decoder().awC($m_Ljava_nio_charset_CodingErrorAction$().KP).awE($m_Ljava_nio_charset_CodingErrorAction$().KP);
    $thiz.Gr = (((2 | $thiz.Gr) << 24) >> 24);
  }
  return $thiz.KK;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder($thiz) {
  return (((((2 & $thiz.Gr) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) : $thiz.KK);
}
function $ct_Ljava_nio_charset_Charset__T__AT__($thiz, canonicalName, _aliases) {
  $thiz.te = canonicalName;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_Charset() {
  this.KK = null;
  this.te = null;
  this.Gr = 0;
}
$p = $c_Ljava_nio_charset_Charset.prototype = new $h_O();
$p.constructor = $c_Ljava_nio_charset_Charset;
/** @constructor */
function $h_Ljava_nio_charset_Charset() {
}
$h_Ljava_nio_charset_Charset.prototype = $p;
$p.b = (function(that) {
  return ((that instanceof $c_Ljava_nio_charset_Charset) && (this.te === that.te));
});
$p.g = (function() {
  return this.te;
});
$p.r = (function() {
  return $f_T__hashCode__I(this.te);
});
$p.jl = (function(o) {
  return $f_T__compareToIgnoreCase__T__I(this.te, o.te);
});
function $isArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gD)));
}
function $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.td;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.KI) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o = in$1.y1;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.KI) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var inStart = ((in$1.b5 + o) | 0);
  var inEnd = ((in$1.bF + o) | 0);
  var a$1 = out.hs;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.IQ()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o$1 = out.iY;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.IQ()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var outStart = ((out.b5 + o$1) | 0);
  var outEnd = ((out.bF + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().md;
      var inPos$1 = inPos;
      var outPos$1 = outPos;
      $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1 - o) | 0));
      $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1 - o$1) | 0));
      return result;
    } else {
      var leading = a.a[inPos];
      if ((leading >= 0)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().tg;
          var inPos$1$1 = inPos;
          var outPos$1$1 = outPos;
          $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1$1 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1$1 - o$1) | 0));
          return result$1;
        } else {
          a$1.a[outPos] = (65535 & leading);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else {
        var length = $m_Ljava_nio_charset_UTF\uff3f8$().R0.a[(127 & leading)];
        if ((length === (-1))) {
          var result$2 = $m_Ljava_nio_charset_CoderResult$().kg;
          var inPos$1$2 = inPos;
          var outPos$1$2 = outPos;
          $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1$2 - o) | 0));
          $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1$2 - o$1) | 0));
          return result$2;
        } else {
          if ((((1 + inPos) | 0) >= inEnd)) {
            var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
            var decoded__high = 0;
            var decoded__low = 0;
          } else {
            var b2 = a.a[((1 + inPos) | 0)];
            if (((192 & b2) !== 128)) {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
              var decoded__high = 0;
              var decoded__low = 0;
            } else if ((length === 2)) {
              var b2$1 = b2;
              var codePoint = (((31 & leading) << 6) | (63 & b2$1));
              if ((codePoint < 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var decoded__failure = null;
                var decoded__high = (65535 & codePoint);
                var decoded__low = 0;
              }
            } else if ((((2 + inPos) | 0) >= inEnd)) {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
              var decoded__high = 0;
              var decoded__low = 0;
            } else {
              var b3 = a.a[((2 + inPos) | 0)];
              if (((192 & b3) !== 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().KO;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 3)) {
                var b2$2 = b2;
                var b3$1 = b3;
                var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                if ((codePoint$1 < 2048)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if (((((codePoint$1 - 55296) | 0) >>> 0) <= 2047)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().Cw;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var decoded__failure = null;
                  var decoded__high = (65535 & codePoint$1);
                  var decoded__low = 0;
                }
              } else if ((((3 + inPos) | 0) >= inEnd)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var b4 = a.a[((3 + inPos) | 0)];
                if (((192 & b4) !== 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().Cw;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var b2$3 = b2;
                  var b3$2 = b3;
                  var b4$1 = b4;
                  var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                  if (((((codePoint$2 - 65536) | 0) >>> 0) > 1048575)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var offsetCodePoint = ((codePoint$2 - 65536) | 0);
                    var decoded__failure = null;
                    var decoded__high = (65535 & (55296 | (offsetCodePoint >> 10)));
                    var decoded__low = (65535 & (56320 | (1023 & offsetCodePoint)));
                  }
                }
              }
            }
          }
          if ((decoded__failure !== null)) {
            var result$3 = decoded__failure;
            var inPos$1$3 = inPos;
            var outPos$1$3 = outPos;
            $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1$3 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1$3 - o$1) | 0));
            return result$3;
          } else if ((decoded__low === 0)) {
            if ((outPos === outEnd)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().tg;
              var inPos$1$4 = inPos;
              var outPos$1$4 = outPos;
              $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1$4 - o) | 0));
              $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1$4 - o$1) | 0));
              return result$4;
            } else {
              a$1.a[outPos] = decoded__high;
              var temp$inPos$2 = ((inPos + length) | 0);
              var temp$outPos$2 = ((1 + outPos) | 0);
              inPos = temp$inPos$2;
              outPos = temp$outPos$2;
            }
          } else if ((((2 + outPos) | 0) > outEnd)) {
            var result$5 = $m_Ljava_nio_charset_CoderResult$().tg;
            var inPos$1$5 = inPos;
            var outPos$1$5 = outPos;
            $c_Ljava_nio_Buffer.prototype.eA.call(in$1, ((inPos$1$5 - o) | 0));
            $c_Ljava_nio_Buffer.prototype.eA.call(out, ((outPos$1$5 - o$1) | 0));
            return result$5;
          } else {
            a$1.a[outPos] = decoded__high;
            a$1.a[((1 + outPos) | 0)] = decoded__low;
            var temp$inPos$3 = ((inPos + length) | 0);
            var temp$outPos$3 = ((2 + outPos) | 0);
            inPos = temp$inPos$3;
            outPos = temp$outPos$3;
          }
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Decoder() {
  this.QY = 0.0;
  this.KM = null;
  this.KL = null;
  this.KN = null;
  this.tf = 0;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.0, 1.0);
}
$p = $c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$p.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Decoder() {
}
$h_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = $p;
$p.atd = (function(in$1, out) {
  if ((((in$1.td !== null) && (!in$1.KI)) && ((out.hs !== null) && (!out.IQ())))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      var startPosition = in$1.b5;
      if ((in$1.b5 === in$1.bF)) {
        return $m_Ljava_nio_charset_CoderResult$().md;
      } else {
        var leading = in$1.MJ();
        if ((leading >= 0)) {
          if ((out.b5 === out.bF)) {
            var result = $m_Ljava_nio_charset_CoderResult$().tg;
            $c_Ljava_nio_Buffer.prototype.eA.call(in$1, startPosition);
            return result;
          } else {
            out.J5((65535 & leading));
          }
        } else {
          var length = $m_Ljava_nio_charset_UTF\uff3f8$().R0.a[(127 & leading)];
          if ((length === (-1))) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().kg;
            $c_Ljava_nio_Buffer.prototype.eA.call(in$1, startPosition);
            return result$1;
          } else {
            if ((in$1.b5 !== in$1.bF)) {
              var b2 = in$1.MJ();
              if (((192 & b2) !== 128)) {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 2)) {
                var b2$1 = b2;
                var codePoint = (((31 & leading) << 6) | (63 & b2$1));
                if ((codePoint < 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var decoded__failure = null;
                  var decoded__high = (65535 & codePoint);
                  var decoded__low = 0;
                }
              } else if ((in$1.b5 !== in$1.bF)) {
                var b3 = in$1.MJ();
                if (((192 & b3) !== 128)) {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().KO;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if ((length === 3)) {
                  var b2$2 = b2;
                  var b3$1 = b3;
                  var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                  if ((codePoint$1 < 2048)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else if (((((codePoint$1 - 55296) | 0) >>> 0) <= 2047)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().Cw;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var decoded__failure = null;
                    var decoded__high = (65535 & codePoint$1);
                    var decoded__low = 0;
                  }
                } else if ((in$1.b5 !== in$1.bF)) {
                  var b4 = in$1.MJ();
                  if (((192 & b4) !== 128)) {
                    var decoded__failure = $m_Ljava_nio_charset_CoderResult$().Cw;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var b2$3 = b2;
                    var b3$2 = b3;
                    var b4$1 = b4;
                    var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                    if (((((codePoint$2 - 65536) | 0) >>> 0) > 1048575)) {
                      var decoded__failure = $m_Ljava_nio_charset_CoderResult$().kg;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    } else {
                      var offsetCodePoint = ((codePoint$2 - 65536) | 0);
                      var decoded__failure = null;
                      var decoded__high = (65535 & (55296 | (offsetCodePoint >> 10)));
                      var decoded__low = (65535 & (56320 | (1023 & offsetCodePoint)));
                    }
                  }
                } else {
                  var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
                  var decoded__high = 0;
                  var decoded__low = 0;
                }
              } else {
                var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
                var decoded__high = 0;
                var decoded__low = 0;
              }
            } else {
              var decoded__failure = $m_Ljava_nio_charset_CoderResult$().md;
              var decoded__high = 0;
              var decoded__low = 0;
            }
            if ((decoded__failure !== null)) {
              var result$2 = decoded__failure;
              $c_Ljava_nio_Buffer.prototype.eA.call(in$1, startPosition);
              return result$2;
            } else if ((decoded__low === 0)) {
              if ((out.b5 === out.bF)) {
                var result$3 = $m_Ljava_nio_charset_CoderResult$().tg;
                $c_Ljava_nio_Buffer.prototype.eA.call(in$1, startPosition);
                return result$3;
              } else {
                out.J5(decoded__high);
              }
            } else if ((((out.bF - out.b5) | 0) < 2)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().tg;
              $c_Ljava_nio_Buffer.prototype.eA.call(in$1, startPosition);
              return result$4;
            } else {
              out.J5(decoded__high);
              out.J5(decoded__low);
            }
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Decoder = new $TypeData().i($c_Ljava_nio_charset_UTF\uff3f8$Decoder, "java.nio.charset.UTF_8$Decoder", ({
  ur: 1,
  uj: 1
}));
function $p_Ljava_security_SecureRandom$__getRandomValuesFun$lzycompute__sjs_js_Function1($thiz) {
  if ((!$thiz.R1)) {
    if ((((typeof crypto) !== "undefined") && ((typeof crypto.getRandomValues) === "function"))) {
      var $x_1 = ((arg1$2) => {
        $m_Ljava_security_SecureRandom$().avJ(arg1$2);
      });
    } else {
      if (((typeof require) !== "function")) {
        $p_Ljava_security_SecureRandom$__notSupported__E($thiz);
      }
      var $x_1 = $p_Ljava_security_SecureRandom$__liftedTree1$1__sjs_js_Function1($thiz);
    }
    $thiz.R2 = $x_1;
    $thiz.R1 = true;
  }
  return $thiz.R2;
}
function $p_Ljava_security_SecureRandom$__notSupported__E($thiz) {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "java.security.SecureRandom is not supported on this platform because it provides neither `crypto.getRandomValues` nor Node.js' \"crypto\" module.");
}
function $p_Ljava_security_SecureRandom$__liftedTree1$1__sjs_js_Function1($thiz) {
  try {
    var crypto = require("crypto");
    return (((typeof crypto.randomFillSync) === "function") ? ((arg1$2) => {
      $m_Ljava_security_SecureRandom$().avK(arg1$2, crypto);
    }) : $p_Ljava_security_SecureRandom$__notSupported__E($thiz));
  } catch (e) {
    $p_Ljava_security_SecureRandom$__notSupported__E($thiz);
  }
}
/** @constructor */
function $c_Ljava_security_SecureRandom$() {
  this.R2 = null;
  this.R1 = false;
}
$p = $c_Ljava_security_SecureRandom$.prototype = new $h_O();
$p.constructor = $c_Ljava_security_SecureRandom$;
/** @constructor */
function $h_Ljava_security_SecureRandom$() {
}
$h_Ljava_security_SecureRandom$.prototype = $p;
$p.avL = (function() {
  return ((!this.R1) ? $p_Ljava_security_SecureRandom$__getRandomValuesFun$lzycompute__sjs_js_Function1(this) : this.R2);
});
$p.avJ = (function(buffer) {
  crypto.getRandomValues(buffer);
});
$p.avK = (function(buffer, crypto$1) {
  crypto$1.randomFillSync(buffer);
});
var $d_Ljava_security_SecureRandom$ = new $TypeData().i($c_Ljava_security_SecureRandom$, "java.security.SecureRandom$", ({
  uu: 1,
  a: 1
}));
var $n_Ljava_security_SecureRandom$;
function $m_Ljava_security_SecureRandom$() {
  if ((!$n_Ljava_security_SecureRandom$)) {
    $n_Ljava_security_SecureRandom$ = new $c_Ljava_security_SecureRandom$();
  }
  return $n_Ljava_security_SecureRandom$;
}
/** @constructor */
function $c_ju_AbstractMap() {
}
$p = $c_ju_AbstractMap.prototype = new $h_O();
$p.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
$h_ju_AbstractMap.prototype = $p;
$p.b = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_Map(o)) {
    if ((this.nX === o.nX)) {
      var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
      var _\uff3fself$1 = _\uff3fself.zN();
      _return: {
        while (_\uff3fself$1.f()) {
          var t = _\uff3fself$1.e();
          var a = $p_ju_HashMap__getOrDefaultImpl__O__O__O(o, t.me, null);
          var b = t.ht;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
  var _\uff3fself$1 = _\uff3fself.zN();
  var result = 0;
  while (_\uff3fself$1.f()) {
    var t = result;
    var u = _\uff3fself$1.e();
    var t$1 = (t | 0);
    result = ((u.r() + t$1) | 0);
  }
  return (result | 0);
});
$p.g = (function() {
  var result = "{";
  var first = true;
  var iter = new $c_ju_HashMap$EntrySet(this).zN();
  while (iter.f()) {
    var entry = iter.e();
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (((("" + result) + entry.me) + "=") + entry.ht);
  }
  return (result + "}");
});
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
}
$p = $c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$p.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
}
$h_ju_Arrays$NaturalComparator$.prototype = $p;
$p.bM = (function(o1, o2) {
  return $dp_compareTo__O__I(o1, o2);
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().i($c_ju_Arrays$NaturalComparator$, "java.util.Arrays$NaturalComparator$", ({
  uz: 1,
  W: 1
}));
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$();
  }
  return $n_ju_Arrays$NaturalComparator$;
}
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cr)));
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cr)));
}
/** @constructor */
function $c_ju_Date$() {
  this.a9x = null;
  this.a9y = null;
  $n_ju_Date$ = this;
  this.a9x = new ($d_T.r().C)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
  this.a9y = new ($d_T.r().C)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]);
}
$p = $c_ju_Date$.prototype = new $h_O();
$p.constructor = $c_ju_Date$;
/** @constructor */
function $h_ju_Date$() {
}
$h_ju_Date$.prototype = $p;
$p.Ei = (function(i) {
  var str = ("" + i);
  return ((str.length < 2) ? ("0" + str) : str);
});
var $d_ju_Date$ = new $TypeData().i($c_ju_Date$, "java.util.Date$", ({
  uB: 1,
  a: 1
}));
var $n_ju_Date$;
function $m_ju_Date$() {
  if ((!$n_ju_Date$)) {
    $n_ju_Date$ = new $c_ju_Date$();
  }
  return $n_ju_Date$;
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
}
$p = $c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$p.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $p;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().i($c_ju_Formatter$RootLocaleInfo$, "java.util.Formatter$RootLocaleInfo$", ({
  uI: 1,
  uH: 1
}));
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$();
  }
  return $n_ju_Formatter$RootLocaleInfo$;
}
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.me = key;
  $thiz.ti = hash;
  $thiz.ht = value;
  $thiz.y3 = previous;
  $thiz.kh = next;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.me = null;
  this.ti = 0;
  this.ht = null;
  this.y3 = null;
  this.kh = null;
}
$p = $c_ju_HashMap$Node.prototype = new $h_O();
$p.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
$h_ju_HashMap$Node.prototype = $p;
$p.b = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var a = this.me;
    var b = that.me;
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.ht;
      var b$1 = that.ht;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  var improvedHash = this.ti;
  var o = this.ht;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)));
});
$p.g = (function() {
  return ((this.me + "=") + this.ht);
});
var $d_ju_HashMap$Node = new $TypeData().i(0, "java.util.HashMap$Node", ({
  gG: 1,
  bR: 1
}));
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  $thiz.Gt = outer.R4;
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.Gt = null;
}
$p = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$p.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $p;
$p.f = (function() {
  return (this.Gt !== null);
});
$p.e = (function() {
  if ((!this.f())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.Gt;
  this.Gt = node.y4;
  return node;
});
function $p_ju_UUID$__csprng$lzycompute__ju_Random($thiz) {
  if (((((1 & $thiz.tj) << 24) >> 24) === 0)) {
    $thiz.R6 = new $c_Ljava_security_SecureRandom();
    $thiz.tj = (((1 | $thiz.tj) << 24) >> 24);
  }
  return $thiz.R6;
}
function $p_ju_UUID$__csprng__ju_Random($thiz) {
  return (((((1 & $thiz.tj) << 24) >> 24) === 0) ? $p_ju_UUID$__csprng$lzycompute__ju_Random($thiz) : $thiz.R6);
}
function $p_ju_UUID$__randomUUIDBuffer$lzycompute__AB($thiz) {
  if (((((2 & $thiz.tj) << 24) >> 24) === 0)) {
    $thiz.R7 = new $ac_B(16);
    $thiz.tj = (((2 | $thiz.tj) << 24) >> 24);
  }
  return $thiz.R7;
}
function $p_ju_UUID$__randomUUIDBuffer__AB($thiz) {
  return (((((2 & $thiz.tj) << 24) >> 24) === 0) ? $p_ju_UUID$__randomUUIDBuffer$lzycompute__AB($thiz) : $thiz.R7);
}
function $ps_ju_UUID$__fail$1__T__E(name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1));
}
/** @constructor */
function $c_ju_UUID$() {
  this.R6 = null;
  this.R7 = null;
  this.tj = 0;
}
$p = $c_ju_UUID$.prototype = new $h_O();
$p.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
}
$h_ju_UUID$.prototype = $p;
$p.aW = (function() {
  var buffer = $p_ju_UUID$__randomUUIDBuffer__AB(this);
  $p_ju_UUID$__csprng__ju_Random(this).awt($p_ju_UUID$__randomUUIDBuffer__AB(this));
  var value = buffer.a[0];
  var lo = (255 & value);
  var value$1 = buffer.a[1];
  var lo$1 = (255 & value$1);
  var lo$2 = (lo$1 << 8);
  var hi$2 = ((lo$1 >>> 24) | 0);
  var lo$3 = (lo | lo$2);
  var value$2 = buffer.a[2];
  var lo$4 = (255 & value$2);
  var lo$5 = (lo$4 << 16);
  var hi$4 = ((lo$4 >>> 16) | 0);
  var lo$6 = (lo$3 | lo$5);
  var hi$5 = (hi$2 | hi$4);
  var value$3 = buffer.a[3];
  var lo$7 = (255 & value$3);
  var lo$8 = (lo$7 << 24);
  var hi$7 = ((lo$7 >>> 8) | 0);
  var lo$9 = (lo$6 | lo$8);
  var hi$8 = (hi$5 | hi$7);
  var value$4 = buffer.a[4];
  var lo$10 = (255 & value$4);
  var hi$10 = (hi$8 | lo$10);
  var value$5 = buffer.a[5];
  var lo$11 = (255 & value$5);
  var hi$12 = (lo$11 << 8);
  var hi$13 = (hi$10 | hi$12);
  var value$6 = buffer.a[6];
  var lo$12 = (255 & value$6);
  var hi$15 = (lo$12 << 16);
  var hi$16 = (hi$13 | hi$15);
  var value$7 = buffer.a[7];
  var lo$13 = (255 & value$7);
  var hi$18 = (lo$13 << 24);
  var hi$19 = (hi$16 | hi$18);
  var lo$14 = ((-61441) & lo$9);
  var lo$15 = (16384 | lo$14);
  var value$8 = buffer.a[8];
  var lo$16 = (255 & value$8);
  var value$9 = buffer.a[9];
  var lo$17 = (255 & value$9);
  var lo$18 = (lo$17 << 8);
  var hi$22 = ((lo$17 >>> 24) | 0);
  var lo$19 = (lo$16 | lo$18);
  var value$10 = buffer.a[10];
  var lo$20 = (255 & value$10);
  var lo$21 = (lo$20 << 16);
  var hi$24 = ((lo$20 >>> 16) | 0);
  var lo$22 = (lo$19 | lo$21);
  var hi$25 = (hi$22 | hi$24);
  var value$11 = buffer.a[11];
  var lo$23 = (255 & value$11);
  var lo$24 = (lo$23 << 24);
  var hi$27 = ((lo$23 >>> 8) | 0);
  var lo$25 = (lo$22 | lo$24);
  var hi$28 = (hi$25 | hi$27);
  var value$12 = buffer.a[12];
  var lo$26 = (255 & value$12);
  var hi$30 = (hi$28 | lo$26);
  var value$13 = buffer.a[13];
  var lo$27 = (255 & value$13);
  var hi$32 = (lo$27 << 8);
  var hi$33 = (hi$30 | hi$32);
  var value$14 = buffer.a[14];
  var lo$28 = (255 & value$14);
  var hi$35 = (lo$28 << 16);
  var hi$36 = (hi$33 | hi$35);
  var value$15 = buffer.a[15];
  var lo$29 = (255 & value$15);
  var hi$38 = (lo$29 << 24);
  var hi$39 = (hi$36 | hi$38);
  var hi$40 = (1073741823 & hi$39);
  var hi$41 = ((-2147483648) | hi$40);
  return new $c_ju_UUID(lo$15, hi$19, lo$25, hi$41);
});
$p.aO = (function(name) {
  if ((((((name.length !== 36) || (name.charCodeAt(8) !== 45)) || (name.charCodeAt(13) !== 45)) || (name.charCodeAt(18) !== 45)) || (name.charCodeAt(23) !== 45))) {
    $ps_ju_UUID$__fail$1__T__E(name);
  }
  try {
    var his = name.substring(0, 4);
    var los = name.substring(4, 8);
    var i1 = (($m_jl_Integer$().c7(his, 16, 134217728) << 16) | $m_jl_Integer$().c7(los, 16, 134217728));
    var his$1 = name.substring(9, 13);
    var los$1 = name.substring(14, 18);
    var i2 = (($m_jl_Integer$().c7(his$1, 16, 134217728) << 16) | $m_jl_Integer$().c7(los$1, 16, 134217728));
    var his$2 = name.substring(19, 23);
    var los$2 = name.substring(24, 28);
    var i3 = (($m_jl_Integer$().c7(his$2, 16, 134217728) << 16) | $m_jl_Integer$().c7(los$2, 16, 134217728));
    var his$3 = name.substring(28, 32);
    var los$3 = name.substring(32, 36);
    var i4 = (($m_jl_Integer$().c7(his$3, 16, 134217728) << 16) | $m_jl_Integer$().c7(los$3, 16, 134217728));
    return new $c_ju_UUID(i2, i1, i4, i3);
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $ps_ju_UUID$__fail$1__T__E(name);
    } else {
      throw e;
    }
  }
});
var $d_ju_UUID$ = new $TypeData().i($c_ju_UUID$, "java.util.UUID$", ({
  v2: 1,
  a: 1
}));
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$();
  }
  return $n_ju_UUID$;
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.R8 = null;
  this.a9S = null;
  this.a9T = null;
  this.a9V = null;
  this.a9U = null;
  this.a9R = null;
  this.a9Q = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.R8 = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.a9S = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.a9T = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.a9V = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.a9U = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.a9R = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.a9Q = new $c_ju_concurrent_TimeUnit$$anon$7();
}
$p = $c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$p.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
}
$h_ju_concurrent_TimeUnit$.prototype = $p;
$p.fa = (function(a_$_lo, a_$_hi, b_$_lo, b_$_hi, max_$_lo, max_$_hi) {
  if (((a_$_hi === max_$_hi) ? ((a_$_lo >>> 0) > (max_$_lo >>> 0)) : (a_$_hi > max_$_hi))) {
    return $bL((-1), 2147483647);
  } else {
    var lo = ((-max_$_lo) | 0);
    var hi = ((((-max_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    if (((a_$_hi === hi) ? ((a_$_lo >>> 0) < (lo >>> 0)) : (a_$_hi < hi))) {
      return $bL(1, (-2147483648));
    } else {
      var a0 = (65535 & a_$_lo);
      var a1 = ((a_$_lo >>> 16) | 0);
      var b0 = (65535 & b_$_lo);
      var b1 = ((b_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(a_$_lo, b_$_hi) + Math.imul(a_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $bL(lo$1, hi$1);
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().i($c_ju_concurrent_TimeUnit$, "java.util.concurrent.TimeUnit$", ({
  v5: 1,
  a: 1
}));
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$();
  }
  return $n_ju_concurrent_TimeUnit$;
}
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ci = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ci = null;
}
$p = $c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$p.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $p;
$p.Ir = (function(expect, update) {
  if (Object.is(expect, this.ci)) {
    this.ci = update;
    return true;
  } else {
    return false;
  }
});
$p.aho = (function(newValue) {
  var old = this.ci;
  this.ci = newValue;
  return old;
});
$p.g = (function() {
  return ("" + this.ci);
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().i($c_ju_concurrent_atomic_AtomicReference, "java.util.concurrent.atomic.AtomicReference", ({
  bT: 1,
  a: 1
}));
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $p;
$p.mK = (function(a, i, v) {
  a.a[i] = v;
});
$p.hd = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", ({
  vh: 1,
  bc: 1
}));
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
}
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.KV = 0;
  $thiz.y5 = null;
  $thiz.Cx = 0;
  return $thiz;
}
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.y5 === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available");
  }
  return $thiz.y5;
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.Gu = null;
  this.R9 = null;
  this.Ra = 0;
  this.tk = null;
  this.KV = 0;
  this.y5 = null;
  this.Cx = 0;
  this.Gu = pattern0;
  this.R9 = input0;
  this.Ra = 0;
  this.tk = this.R9;
  this.KV = 0;
  this.y5 = null;
  this.Cx = 0;
}
$p = $c_ju_regex_Matcher.prototype = new $h_O();
$p.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
}
$h_ju_regex_Matcher.prototype = $p;
$p.V1 = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.y5 = this.Gu.atD(this.tk);
  return (this.y5 !== null);
});
$p.Uh = (function() {
  var this$1 = this.Gu;
  var input = this.tk;
  var start = this.KV;
  var mtch = this$1.avS(input, start);
  var end = (this$1.Rd.lastIndex | 0);
  this.KV = ((mtch !== null) ? ((end === (mtch.index | 0)) ? ((1 + end) | 0) : end) : ((1 + this.tk.length) | 0));
  this.y5 = mtch;
  return (mtch !== null);
});
$p.amp = (function(sb, replacement) {
  var this$1 = this.tk;
  var beginIndex = this.Cx;
  var endIndex = this.Vz();
  var csq = this$1.substring(beginIndex, endIndex);
  sb.aC = (("" + sb.aC) + csq);
  var len = replacement.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x1 = replacement.charCodeAt(index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (((i < len) && ((((replacement.charCodeAt(i) - 48) | 0) >>> 0) <= 9))) {
          i = ((1 + i) | 0);
        }
        var $x_1 = $m_jl_Integer$();
        var endIndex$1 = i;
        var group = $x_1.c7(replacement.substring(j, endIndex$1), 10, 214748364);
        var replaced = this.ahC(group);
        if ((replaced !== null)) {
          sb.aC = (("" + sb.aC) + replaced);
        }
        break;
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var index$2 = i;
          var c$1 = replacement.charCodeAt(index$2);
          var str = ("" + $cToS(c$1));
          sb.aC = (sb.aC + str);
        }
        i = ((1 + i) | 0);
        break;
      }
      default: {
        var str$1 = ("" + $cToS(x1));
        sb.aC = (sb.aC + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  this.Cx = this.U8();
  return this;
});
$p.ams = (function(sb) {
  var this$1 = this.tk;
  var beginIndex = this.Cx;
  var str = this$1.substring(beginIndex);
  sb.aC = (("" + sb.aC) + str);
  this.Cx = this.tk.length;
  return sb;
});
$p.ajn = (function(replacement) {
  this.axh();
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  while (this.Uh()) {
    this.amp(sb, replacement);
  }
  this.ams(sb);
  return sb.aC;
});
$p.axh = (function() {
  this.Ra = 0;
  this.tk = this.R9;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
$p.Vz = (function() {
  return ((($p_ju_regex_Matcher__ensureLastMatch__O(this).index | 0) + this.Ra) | 0);
});
$p.U8 = (function() {
  return ((this.Vz() + this.ahD().length) | 0);
});
$p.ahD = (function() {
  return $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
});
$p.ahC = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[this.Gu.awz(group)];
  return ((x !== (void 0)) ? x : null);
});
var $d_ju_regex_Matcher = new $TypeData().i($c_ju_regex_Matcher, "java.util.regex.Matcher", ({
  vm: 1,
  vl: 1
}));
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.Rb = null;
  this.a9X = null;
  this.a9Y = false;
  this.Rc = 0;
  this.a9W = null;
  this.Rd = null;
  this.a9Z = null;
  this.Rb = _pattern;
  this.a9X = jsFlags;
  this.a9Y = sticky;
  this.Rc = groupCount;
  this.a9W = groupNumberMap;
  this.Rd = new RegExp(jsPattern, (this.a9X + (this.a9Y ? "gy" : "g")));
  this.a9Z = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags);
}
$p = $c_ju_regex_Pattern.prototype = new $h_O();
$p.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
}
$h_ju_regex_Pattern.prototype = $p;
$p.atD = (function(input) {
  return this.a9Z.exec(input);
});
$p.avS = (function(input, start) {
  var regexp = this.Rd;
  regexp.lastIndex = start;
  return regexp.exec(input);
});
$p.awz = (function(group) {
  var length = this.Rc;
  if (((group >>> 0) > (length >>> 0))) {
    $m_jl_BoundsChecks$().avA(group, length);
  }
  return (this.a9W[group] | 0);
});
$p.g = (function() {
  return this.Rb;
});
$p.avT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.r().C)([""]);
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr);
    var result = [];
    var prevEnd = 0;
    while ((((result.length | 0) < ((lim - 1) | 0)) && matcher.Uh())) {
      if ((matcher.U8() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.Vz();
        var $x_1 = result.push(inputStr.substring(beginIndex, endIndex));
      }
      prevEnd = matcher.U8();
    }
    var beginIndex$1 = prevEnd;
    result.push(inputStr.substring(beginIndex$1));
    var actualLength = (result.length | 0);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[((actualLength - 1) | 0)];
          var $x_2 = ((x !== null) && $dp_equals__O__Z(x, ""));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          actualLength = ((actualLength - 1) | 0);
        } else {
          break;
        }
      }
    }
    var r = new ($d_T.r().C)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      r.a[value] = result[value];
      i = ((1 + i) | 0);
    }
    return r;
  }
});
var $d_ju_regex_Pattern = new $TypeData().i($c_ju_regex_Pattern, "java.util.regex.Pattern", ({
  vn: 1,
  a: 1
}));
/** @constructor */
function $c_ju_regex_Pattern$() {
}
$p = $c_ju_regex_Pattern$.prototype = new $h_O();
$p.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
}
$h_ju_regex_Pattern$.prototype = $p;
$p.ahZ = (function(regex, input) {
  return new $c_ju_regex_Matcher($m_ju_regex_PatternCompiler$().Mp(regex, 0), input).V1();
});
var $d_ju_regex_Pattern$ = new $TypeData().i($c_ju_regex_Pattern$, "java.util.regex.Pattern$", ({
  vo: 1,
  a: 1
}));
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$();
  }
  return $n_ju_regex_Pattern$;
}
/** @constructor */
function $c_s_Console$() {
  this.aaa = null;
  $n_s_Console$ = this;
  this.aaa = new $c_s_util_DynamicVariable($m_jl_System$Streams$().a98);
}
$p = $c_s_Console$.prototype = new $h_O();
$p.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
}
$h_s_Console$.prototype = $p;
$p.J1 = (function() {
  return this.aaa.Su;
});
var $d_s_Console$ = new $TypeData().i($c_s_Console$, "scala.Console$", ({
  vL: 1,
  zO: 1
}));
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$();
  }
  return $n_s_Console$;
}
function $ct_s_Enumeration__I__($thiz, initial) {
  $thiz.mf = $ct_scm_HashMap__(new $c_scm_HashMap());
  $thiz.q4 = null;
  $thiz.nZ = false;
  $ct_scm_HashMap__(new $c_scm_HashMap());
  $thiz.bI = initial;
  $thiz.q3 = initial;
  $thiz.j1 = ((initial < 0) ? initial : 0);
  return $thiz;
}
/** @constructor */
function $c_s_Enumeration() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
}
$p = $c_s_Enumeration.prototype = new $h_O();
$p.constructor = $c_s_Enumeration;
/** @constructor */
function $h_s_Enumeration() {
}
$h_s_Enumeration.prototype = $p;
$p.g = (function() {
  return $m_sc_ArrayOps$().ai1($m_sc_StringOps$().ajW($m_sc_ArrayOps$().ai1($m_sc_StringOps$().ajW($m_sc_StringOps$().ak1($objectClassName(this), "$"), 46)), 36));
});
$p.az7 = (function() {
  if ((!this.nZ)) {
    this.q4 = $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(new $c_s_Enumeration$ValueSet$$anon$1(this.Tv()), new $c_sc_MapOps$$anon$1(this.mf)).aR();
    this.nZ = true;
  }
  var x$proxy1 = this.q4;
  if ((x$proxy1 === null)) {
    $m_sr_Scala3RunTime$().bW();
  }
  return x$proxy1;
});
$p.azx = (function(s) {
  var this$1 = this.az7();
  var l = this$1.dw();
  var r = this$1.dw();
  var this$2 = this$1.l();
  while (this$2.f()) {
    var x0 = this$2.e();
    var this$3 = x0.g();
    ((!(!this$3.startsWith("<Unknown name for enum field "))) ? l : r).aD(x0);
  }
  var \u03b42$___1 = l.aR();
  var \u03b42$___2 = r.aR();
  var unnamed$2 = \u03b42$___1;
  var named$2 = \u03b42$___2;
  _return: {
    var it = named$2.l();
    while (it.f()) {
      var a = it.e();
      if ((a.g() === s)) {
        var x4 = new $c_s_Some(a);
        break _return;
      }
    }
    var x4 = $m_s_None$();
  }
  if ((x4 instanceof $c_s_Some)) {
    return x4.bg;
  }
  if ((($m_s_None$() === x4) && (!unnamed$2.c()))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), $m_sc_StringOps$().ayl(((("Couldn't find enum field with name " + s) + ".\n             |However, there were the following unnamed fields:\n             |") + $f_sc_IterableOnceOps__mkString__T__T__T__T(unnamed$2, "  ", "\n  ", "")), 124));
  }
  $m_s_None$().aa();
});
$p.alQ = (function() {
  if ((!this.tm)) {
    this.tl = new $c_s_Enumeration$ValueOrdering$();
    this.tm = true;
  }
  return this.tl;
});
$p.Tv = (function() {
  if ((!this.to)) {
    this.tn = new $c_s_Enumeration$ValueSet$(this);
    this.to = true;
  }
  return this.tn;
});
/** @constructor */
function $c_s_LowPriorityImplicits() {
}
$p = $c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$p.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
}
$h_s_LowPriorityImplicits.prototype = $p;
$p.Jl = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if ((xs.a.length === 0)) {
    var this$2 = $m_scm_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return this$2.S2;
  } else {
    return new $c_scm_ArraySeq$ofRef(xs);
  }
});
$p.akz = (function(s) {
  return ((s === null) ? null : new $c_sci_WrappedString(s));
});
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.aU(x) ? $thiz.p(x) : default$1.p(x));
}
/** @constructor */
function $c_s_Symbol(name) {
  this.L2 = null;
  this.L2 = name;
}
$p = $c_s_Symbol.prototype = new $h_O();
$p.constructor = $c_s_Symbol;
/** @constructor */
function $h_s_Symbol() {
}
$h_s_Symbol.prototype = $p;
$p.g = (function() {
  return (("Symbol(" + this.L2) + ")");
});
$p.r = (function() {
  return $f_T__hashCode__I(this.L2);
});
$p.b = (function(other) {
  return (this === other);
});
var $d_s_Symbol = new $TypeData().i($c_s_Symbol, "scala.Symbol", ({
  wa: 1,
  a: 1
}));
/** @constructor */
function $c_s_Symbol$() {
  this.Rr = null;
  $ct_s_UniquenessCache__(this);
}
$p = $c_s_Symbol$.prototype = new $h_s_UniquenessCache();
$p.constructor = $c_s_Symbol$;
/** @constructor */
function $h_s_Symbol$() {
}
$h_s_Symbol$.prototype = $p;
var $d_s_Symbol$ = new $TypeData().i($c_s_Symbol$, "scala.Symbol$", ({
  wb: 1,
  wc: 1
}));
var $n_s_Symbol$;
function $m_s_Symbol$() {
  if ((!$n_s_Symbol$)) {
    $n_s_Symbol$ = new $c_s_Symbol$();
  }
  return $n_s_Symbol$;
}
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11() {
}
$p = $c_sc_BuildFromLowPriority2$$anon$11.prototype = new $h_O();
$p.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
}
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $p;
$p.awp = (function(from) {
  return from.b4().aP();
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $TypeData().i($c_sc_BuildFromLowPriority2$$anon$11, "scala.collection.BuildFromLowPriority2$$anon$11", ({
  wl: 1,
  wh: 1
}));
/** @constructor */
function $c_sc_WithFilter() {
}
$p = $c_sc_WithFilter.prototype = new $h_O();
$p.constructor = $c_sc_WithFilter;
/** @constructor */
function $h_sc_WithFilter() {
}
$h_sc_WithFilter.prototype = $p;
/** @constructor */
function $c_sci_LazyList$Uninitialized$() {
}
$p = $c_sci_LazyList$Uninitialized$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$Uninitialized$;
/** @constructor */
function $h_sci_LazyList$Uninitialized$() {
}
$h_sci_LazyList$Uninitialized$.prototype = $p;
var $d_sci_LazyList$Uninitialized$ = new $TypeData().i($c_sci_LazyList$Uninitialized$, "scala.collection.immutable.LazyList$Uninitialized$", ({
  xN: 1,
  a: 1
}));
var $n_sci_LazyList$Uninitialized$;
function $m_sci_LazyList$Uninitialized$() {
  if ((!$n_sci_LazyList$Uninitialized$)) {
    $n_sci_LazyList$Uninitialized$ = new $c_sci_LazyList$Uninitialized$();
  }
  return $n_sci_LazyList$Uninitialized$;
}
/** @constructor */
function $c_sci_List$$anon$1() {
}
$p = $c_sci_List$$anon$1.prototype = new $h_O();
$p.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
}
$h_sci_List$$anon$1.prototype = $p;
$p.g = (function() {
  return "<function1>";
});
$p.hK = (function(x$0) {
});
$p.p = (function(x) {
  return this;
});
var $d_sci_List$$anon$1 = new $TypeData().i($c_sci_List$$anon$1, "scala.collection.immutable.List$$anon$1", ({
  xQ: 1,
  p: 1
}));
/** @constructor */
function $c_sci_MapNode() {
}
$p = $c_sci_MapNode.prototype = new $h_sci_Node();
$p.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
}
$h_sci_MapNode.prototype = $p;
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step);
}
/** @constructor */
function $c_sci_Range$() {
}
$p = $c_sci_Range$.prototype = new $h_O();
$p.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
}
$h_sci_Range$.prototype = $p;
$p.oY = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."));
});
$p.Vn = (function(what) {
  return $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), (what + " on empty Range"));
});
var $d_sci_Range$ = new $TypeData().i($c_sci_Range$, "scala.collection.immutable.Range$", ({
  yf: 1,
  a: 1
}));
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$();
  }
  return $n_sci_Range$;
}
/** @constructor */
function $c_sci_SetNode() {
}
$p = $c_sci_SetNode.prototype = new $h_sci_Node();
$p.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
}
$h_sci_SetNode.prototype = $p;
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, elems) {
  if ((elems === $thiz)) {
    $thiz.cz($m_scm_Buffer$().zH(elems));
  } else {
    var it = elems.l();
    while (it.f()) {
      $thiz.aD(it.e());
    }
  }
  return $thiz;
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  var tl = $thiz.abn;
  var b = tl.h();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    b.awZ(runnable);
  } else {
    var i = ((b !== null) ? b : 0);
    if ((i < 16)) {
      tl.Jb(((1 + i) | 0));
      try {
        runnable.zV();
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if (false) {
          $m_s_concurrent_ExecutionContext$().D6.p(e$2);
        } else {
          matchResult3: {
            if ($m_s_util_control_NonFatal$().DO(e$2)) {
              $m_s_concurrent_ExecutionContext$().D6.p(e$2);
              break matchResult3;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
          }
        }
      } finally {
        tl.Jb(b);
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      tl.Jb(batch);
      batch.zV();
      tl.Jb(b);
    }
  }
}
function $is_s_concurrent_BatchingExecutor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cW)));
}
function $isArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cW)));
}
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.Sl = null;
  this.Sm = null;
  this.Sl = first;
  this.Sm = rest;
}
$p = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$p.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $p;
$p.g = (function() {
  return "ManyCallbacks";
});
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i7)));
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().i($c_s_concurrent_impl_Promise$ManyCallbacks, "scala.concurrent.impl.Promise$ManyCallbacks", ({
  i7: 1,
  c8: 1
}));
/** @constructor */
function $c_s_math_Equiv$() {
}
$p = $c_s_math_Equiv$.prototype = new $h_O();
$p.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
}
$h_s_math_Equiv$.prototype = $p;
var $d_s_math_Equiv$ = new $TypeData().i($c_s_math_Equiv$, "scala.math.Equiv$", ({
  zR: 1,
  zU: 1
}));
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$();
  }
  return $n_s_math_Equiv$;
}
function $f_s_math_Ordered__$less__O__Z($thiz, that) {
  return ($thiz.oH(that) < 0);
}
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.oH(that) <= 0);
}
function $f_s_math_Ordered__$greater$eq__O__Z($thiz, that) {
  return ($thiz.oH(that) >= 0);
}
/** @constructor */
function $c_s_math_Ordering$() {
}
$p = $c_s_math_Ordering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
}
$h_s_math_Ordering$.prototype = $p;
var $d_s_math_Ordering$ = new $TypeData().i($c_s_math_Ordering$, "scala.math.Ordering$", ({
  A0: 1,
  zV: 1
}));
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$();
  }
  return $n_s_math_Ordering$;
}
/** @constructor */
function $c_sr_AbstractFunction0() {
}
$p = $c_sr_AbstractFunction0.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
}
$h_sr_AbstractFunction0.prototype = $p;
$p.g = (function() {
  return "<function0>";
});
/** @constructor */
function $c_sr_AbstractFunction1() {
}
$p = $c_sr_AbstractFunction1.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
}
$h_sr_AbstractFunction1.prototype = $p;
$p.hK = (function(v1) {
  this.p(v1);
});
$p.g = (function() {
  return "<function1>";
});
/** @constructor */
function $c_sr_AbstractFunction2() {
}
$p = $c_sr_AbstractFunction2.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
}
$h_sr_AbstractFunction2.prototype = $p;
$p.g = (function() {
  return "<function2>";
});
/** @constructor */
function $c_sr_AbstractFunction3() {
}
$p = $c_sr_AbstractFunction3.prototype = new $h_O();
$p.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
}
$h_sr_AbstractFunction3.prototype = $p;
$p.g = (function() {
  return "<function3>";
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.e1 = false;
  this.e1 = elem;
}
$p = $c_sr_BooleanRef.prototype = new $h_O();
$p.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
$h_sr_BooleanRef.prototype = $p;
$p.g = (function() {
  return ("" + this.e1);
});
var $d_sr_BooleanRef = new $TypeData().i($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  AV: 1,
  a: 1
}));
/** @constructor */
function $c_sr_DoubleRef(elem) {
  this.bv = 0.0;
  this.bv = elem;
}
$p = $c_sr_DoubleRef.prototype = new $h_O();
$p.constructor = $c_sr_DoubleRef;
/** @constructor */
function $h_sr_DoubleRef() {
}
$h_sr_DoubleRef.prototype = $p;
$p.g = (function() {
  return ("" + this.bv);
});
var $d_sr_DoubleRef = new $TypeData().i($c_sr_DoubleRef, "scala.runtime.DoubleRef", ({
  AX: 1,
  a: 1
}));
/** @constructor */
function $c_sr_IntRef(elem) {
  this.f4 = 0;
  this.f4 = elem;
}
$p = $c_sr_IntRef.prototype = new $h_O();
$p.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
}
$h_sr_IntRef.prototype = $p;
$p.g = (function() {
  return ("" + this.f4);
});
var $d_sr_IntRef = new $TypeData().i($c_sr_IntRef, "scala.runtime.IntRef", ({
  AZ: 1,
  a: 1
}));
/** @constructor */
function $c_sr_LazyBoolean() {
  this.D8 = false;
  this.D9 = false;
}
$p = $c_sr_LazyBoolean.prototype = new $h_O();
$p.constructor = $c_sr_LazyBoolean;
/** @constructor */
function $h_sr_LazyBoolean() {
}
$h_sr_LazyBoolean.prototype = $p;
$p.ahK = (function(value) {
  this.D9 = value;
  this.D8 = true;
  return value;
});
$p.g = (function() {
  return ("LazyBoolean " + (this.D8 ? ("of: " + this.D9) : "thunk"));
});
var $d_sr_LazyBoolean = new $TypeData().i($c_sr_LazyBoolean, "scala.runtime.LazyBoolean", ({
  B1: 1,
  a: 1
}));
/** @constructor */
function $c_sr_LazyRef() {
  this.i = false;
  this.j = null;
}
$p = $c_sr_LazyRef.prototype = new $h_O();
$p.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
$h_sr_LazyRef.prototype = $p;
$p.E = (function(value) {
  this.j = value;
  this.i = true;
  return value;
});
$p.g = (function() {
  return ("LazyRef " + (this.i ? ("of: " + this.j) : "thunk"));
});
var $d_sr_LazyRef = new $TypeData().i($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  B2: 1,
  a: 1
}));
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.bL = null;
  this.bL = elem;
}
$p = $c_sr_ObjectRef.prototype = new $h_O();
$p.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
}
$h_sr_ObjectRef.prototype = $p;
$p.g = (function() {
  return ("" + this.bL);
});
var $d_sr_ObjectRef = new $TypeData().i($c_sr_ObjectRef, "scala.runtime.ObjectRef", ({
  B6: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.ea = 0;
  this.qp = 0;
  this.Ho = 0;
  this.LF = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.ea = $f_T__hashCode__I("Seq");
  this.qp = $f_T__hashCode__I("Map");
  this.Ho = $f_T__hashCode__I("Set");
  this.LF = this.Aa($m_sci_Nil$(), this.qp);
}
$p = $c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$p.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
}
$h_s_util_hashing_MurmurHash3$.prototype = $p;
$p.kV = (function(x, y) {
  return this.akh($m_sr_Statics$().k(x), $m_sr_Statics$().k(y), (-889275714));
});
$p.Nq = (function(xs) {
  return ($is_sc_IndexedSeq(xs) ? this.auR(xs, this.ea) : ((xs instanceof $c_sci_List) ? this.aw1(xs, this.ea) : this.awG(xs, this.ea)));
});
$p.UZ = (function(xs) {
  if (xs.c()) {
    return this.LF;
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.qp;
    xs.jo(accum);
    h = this.d(h, accum.LG);
    h = this.d(h, accum.LH);
    h = this.kR(h, accum.LI);
    return this.an(h, accum.LJ);
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().i($c_s_util_hashing_MurmurHash3$, "scala.util.hashing.MurmurHash3$", ({
  BM: 1,
  BL: 1
}));
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$();
  }
  return $n_s_util_hashing_MurmurHash3$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.LG = 0;
  this.LH = 0;
  this.LJ = 0;
  this.LI = 0;
  this.LG = 0;
  this.LH = 0;
  this.LJ = 0;
  this.LI = 1;
}
$p = $c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$p.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $p;
$p.g = (function() {
  return "<function2>";
});
$p.amA = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().kV(k, v);
  this.LG = ((this.LG + h) | 0);
  this.LH = (this.LH ^ h);
  this.LI = Math.imul(this.LI, (1 | h));
  this.LJ = ((1 + this.LJ) | 0);
});
$p.cm = (function(v1, v2) {
  this.amA(v1, v2);
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().i($c_s_util_hashing_MurmurHash3$accum$1, "scala.util.hashing.MurmurHash3$accum$1", ({
  BN: 1,
  cu: 1
}));
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.Da = pattern;
  return $thiz;
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().Mp(regex, 0), groupNames);
  return $thiz;
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.Da = null;
}
$p = $c_s_util_matching_Regex.prototype = new $h_O();
$p.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
}
$h_s_util_matching_Regex.prototype = $p;
$p.ayM = (function(s) {
  var m = new $c_ju_regex_Matcher(this.Da, $dp_toString__T(s));
  if (m.V1()) {
    $m_sci_List$();
    var n = m.Gu.Rc;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      b.TC(m.ahC(((1 + i) | 0)));
      i = ((1 + i) | 0);
    }
    return new $c_s_Some(b.uF());
  } else {
    return $m_s_None$();
  }
});
$p.atW = (function(source) {
  var m = new $c_ju_regex_Matcher(this.Da, $dp_toString__T(source));
  return (m.Uh() ? new $c_s_Some(m.ahD()) : $m_s_None$());
});
$p.awe = (function(source) {
  return new $c_ju_regex_Matcher(this.Da, $dp_toString__T(source)).V1();
});
$p.ajo = (function(target, replacement) {
  return new $c_ju_regex_Matcher(this.Da, $dp_toString__T(target)).ajn(replacement);
});
$p.g = (function() {
  return this.Da.Rb;
});
var $d_s_util_matching_Regex = new $TypeData().i($c_s_util_matching_Regex, "scala.util.matching.Regex", ({
  BO: 1,
  a: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$GenericAttr() {
}
$p = $c_Lscalatags_JsDom$GenericAttr.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$GenericAttr;
/** @constructor */
function $h_Lscalatags_JsDom$GenericAttr() {
}
$h_Lscalatags_JsDom$GenericAttr.prototype = $p;
$p.afK = (function(t, a, v) {
  var x13 = a.Dc;
  if (($m_s_None$() === x13)) {
    if ((!a.Dd)) {
      if ((a.jf === "class")) {
        var xs = $f_T__split__T__I__AT($dp_toString__T(v), " ", 0);
        var f = ((cls) => {
          if (($m_sc_StringOps$(), ($f_T__trim__T(cls) !== ""))) {
            t.classList.add($f_T__trim__T(cls));
          }
        });
        var len = xs.a.length;
        var i = 0;
        if ((xs !== null)) {
          while ((i < len)) {
            var x0 = xs.a[i];
            f(x0);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_I)) {
          while ((i < len)) {
            var x0$1 = xs.a[i];
            f(x0$1);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_D)) {
          while ((i < len)) {
            var x0$2 = xs.a[i];
            f(x0$2);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_J)) {
          while ((i < len)) {
            var $x_1 = xs.a;
            var $x_2 = (i << 1);
            var x0$3_$_lo = $x_1[$x_2];
            var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
            f($bL(x0$3_$_lo, x0$3_$_hi));
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_F)) {
          while ((i < len)) {
            var x0$4 = xs.a[i];
            f(x0$4);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_C)) {
          while ((i < len)) {
            var x0$5 = xs.a[i];
            f($bC(x0$5));
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_B)) {
          while ((i < len)) {
            var x0$6 = xs.a[i];
            f(x0$6);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_S)) {
          while ((i < len)) {
            var x0$7 = xs.a[i];
            f(x0$7);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else if ((xs instanceof $ac_Z)) {
          while ((i < len)) {
            var x0$8 = xs.a[i];
            f(x0$8);
            i = ((1 + i) | 0);
          }
          return (void 0);
        } else {
          throw new $c_s_MatchError(xs);
        }
      } else {
        t.setAttribute(a.jf, $dp_toString__T(v));
        return (void 0);
      }
    } else {
      var tmpElm = document.createElement("p");
      tmpElm.innerHTML = (((("<p " + a.jf) + "=\"") + $dp_toString__T(v)) + "\"><p>");
      var newAttr = tmpElm.children[0].attributes[0].cloneNode(true);
      t.setAttributeNode(newAttr);
      return (void 0);
    }
  }
  if ((x13 instanceof $c_s_Some)) {
    var namespace = x13.bg;
    t.setAttributeNS(namespace.aks(), a.jf, $dp_toString__T(v));
    return (void 0);
  }
  throw new $c_s_MatchError(x13);
});
var $d_Lscalatags_JsDom$GenericAttr = new $TypeData().i($c_Lscalatags_JsDom$GenericAttr, "scalatags.JsDom$GenericAttr", ({
  BT: 1,
  iv: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$GenericStyle() {
}
$p = $c_Lscalatags_JsDom$GenericStyle.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$GenericStyle;
/** @constructor */
function $h_Lscalatags_JsDom$GenericStyle() {
}
$h_Lscalatags_JsDom$GenericStyle.prototype = $p;
$p.amG = (function(t, s, v) {
  var \u03b42$ = t.style;
  \u03b42$.setProperty(s.Df, $dp_toString__T(v));
});
var $d_Lscalatags_JsDom$GenericStyle = new $TypeData().i($c_Lscalatags_JsDom$GenericStyle, "scalatags.JsDom$GenericStyle", ({
  BU: 1,
  Ck: 1
}));
/** @constructor */
function $c_Lscalatags_LowPriorityImplicits$$anon$2(ev$3) {
  this.add = null;
  this.add = ev$3;
}
$p = $c_Lscalatags_LowPriorityImplicits$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lscalatags_LowPriorityImplicits$$anon$2;
/** @constructor */
function $h_Lscalatags_LowPriorityImplicits$$anon$2() {
}
$h_Lscalatags_LowPriorityImplicits$$anon$2.prototype = $p;
$p.afK = (function(t, a, v) {
  t[a.jf] = this.add.p(v);
});
var $d_Lscalatags_LowPriorityImplicits$$anon$2 = new $TypeData().i($c_Lscalatags_LowPriorityImplicits$$anon$2, "scalatags.LowPriorityImplicits$$anon$2", ({
  C0: 1,
  iv: 1
}));
function $f_Lscalatags_generic_Aggregate__$init$__V($thiz) {
  $thiz.s = new $c_Lscalatags_JsDom$GenericAttr();
  $thiz.Sx = new $c_Lscalatags_JsDom$GenericAttr();
  $thiz.qq = new $c_Lscalatags_JsDom$GenericAttr();
  $thiz.Sy = new $c_Lscalatags_JsDom$GenericAttr();
  $thiz.acM = new $c_Lscalatags_JsDom$GenericStyle();
  $thiz.alD = new $c_Lscalatags_JsDom$GenericStyle();
}
/** @constructor */
function $c_Lscalatags_generic_Namespace$$anon$1() {
}
$p = $c_Lscalatags_generic_Namespace$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Namespace$$anon$1;
/** @constructor */
function $h_Lscalatags_generic_Namespace$$anon$1() {
}
$h_Lscalatags_generic_Namespace$$anon$1.prototype = $p;
$p.aks = (function() {
  return "http://www.w3.org/1999/xhtml";
});
var $d_Lscalatags_generic_Namespace$$anon$1 = new $TypeData().i($c_Lscalatags_generic_Namespace$$anon$1, "scalatags.generic.Namespace$$anon$1", ({
  Ch: 1,
  Cf: 1
}));
function $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, s, ns, raw) {
  return new $c_Lscalatags_generic_Attr(s, $m_s_Option$().Z(ns), raw);
}
function $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($thiz, xs, ev) {
  return new $c_Lscalatags_generic_Util$SeqNode($thiz, $m_s_Option$().hi(xs).cf(), ev);
}
/** @constructor */
function $c_Lscalatags_generic_Util$SeqNode(outer, xs, ev) {
  this.adi = null;
  this.adh = null;
  this.adi = xs;
  this.adh = ev;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lscalatags_generic_Util$SeqNode.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Util$SeqNode;
/** @constructor */
function $h_Lscalatags_generic_Util$SeqNode() {
}
$h_Lscalatags_generic_Util$SeqNode.prototype = $p;
$p.oD = (function(t) {
  this.adi.al(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((elem) => {
    this.adh.p(elem).oD(t);
  })));
});
var $d_Lscalatags_generic_Util$SeqNode = new $TypeData().i($c_Lscalatags_generic_Util$SeqNode, "scalatags.generic.Util$SeqNode", ({
  Cq: 1,
  aZ: 1
}));
function $ct_Lujson_CharParser__($thiz) {
  $f_Lupickle_core_BufferingCharParser__$init$__V($thiz);
  $thiz.tL = $m_Lupickle_core_CharOps$();
  $thiz.gB = new $c_Lupickle_core_CharBuilder(32);
  return $thiz;
}
/** @constructor */
function $c_Lujson_CharParser() {
  this.tM = null;
  this.I4 = 0;
  this.I5 = 0;
  this.ol = 0;
  this.kB = 0;
  this.HA = 0;
  this.om = 0;
  this.tL = null;
  this.gB = null;
}
$p = $c_Lujson_CharParser.prototype = new $h_O();
$p.constructor = $c_Lujson_CharParser;
/** @constructor */
function $h_Lujson_CharParser() {
}
$h_Lujson_CharParser.prototype = $p;
$p.DT = (function(j) {
  var newSafeIndex = $f_Lupickle_core_BufferingCharParser__requestUntilGetSafeIndex__I__I(this, j);
  if ((newSafeIndex === j)) {
    throw new $c_Lujson_IncompleteParseException("exhausted input");
  }
  return newSafeIndex;
});
$p.dT = (function(i) {
  this.DT(i);
  return $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, i);
});
$p.awI = (function(facade) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = this.awQ(0, facade);
    if ((x1 !== null)) {
      var \u03b41$___1 = x1.P();
      var \u03b41$___2 = (x1.V() | 0);
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var value$2 = \u03b41$___1;
  var i$2 = (\u03b41$___2 | 0);
  var j = i$2;
  while ((!$f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j))) {
    switch (this.dT(j)) {
      case 10:
      case 32:
      case 9:
      case 13: {
        j = ((1 + j) | 0);
        break;
      }
      default: {
        this.hc(j, "expected whitespace or eof");
      }
    }
  }
  if ((!$f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j))) {
    this.hc(j, "expected eof");
  }
  return value$2;
});
$p.hc = (function(i, msg) {
  var out = new $c_Lupickle_core_CharBuilder(32);
  var $x_2 = $m_Lupickle_core_RenderUtils$();
  var $x_1 = new $c_Lupickle_core_CharBuilder(32);
  var array = new $ac_C(new Uint16Array([(65535 & this.dT(i))]));
  var length = array.a.length;
  var capacity = array.a.length;
  var length$1 = array.a.length;
  if ((((capacity | capacity) | ((length$1 - capacity) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(0, capacity, length$1);
  }
  if ((((length | length) | ((capacity - length) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(0, length, capacity);
  }
  $x_2.agS($x_1, out, new $c_Ljava_nio_HeapCharBuffer(capacity, array, 0, 0, length, false), false, true);
  throw new $c_Lujson_ParseException($m_sc_StringOps$().Ul("%s got %s", $m_sr_ScalaRunTime$().IE(new $ac_O([msg, $m_jl_String$().hg(out.dr, 0, out.be)]))), i);
});
$p.awK = (function(i, ctxt, facade) {
  var j = i;
  var c = this.dT(j);
  var decIndex = (-1);
  var expIndex = (-1);
  if ((c === 45)) {
    j = ((1 + j) | 0);
    c = this.dT(j);
  }
  if ((c === 48)) {
    j = ((1 + j) | 0);
    c = this.dT(j);
  } else {
    var j0 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.dT(j);
    }
    if ((j === j0)) {
      this.hc(i, "expected digit");
    }
  }
  if ((c === 46)) {
    decIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.dT(j);
    var j0$2 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.dT(j);
    }
    if ((j0$2 === j)) {
      this.hc(i, "expected digit");
    }
  }
  if (((c === 69) || (c === 101))) {
    expIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.dT(j);
    if (((c === 43) || (c === 45))) {
      j = ((1 + j) | 0);
      c = this.dT(j);
    }
    var j0$3 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      c = this.dT(j);
    }
    if ((j0$3 === j)) {
      this.hc(i, "expected digit");
    }
  }
  ctxt.bu(this.EI(facade, decIndex, expIndex, i, j), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i));
  return j;
});
$p.EI = (function(facade, decIndex, expIndex, i, j) {
  return facade.d3(this.tM, ((i - this.ol) | 0), ((j - i) | 0), decIndex, expIndex, $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i));
});
$p.awL = (function(i, facade) {
  var j = i;
  var c = this.dT(j);
  var decIndex = (-1);
  var expIndex = (-1);
  if ((c === 45)) {
    j = ((1 + j) | 0);
    c = this.dT(j);
  }
  if ((c === 48)) {
    j = ((1 + j) | 0);
    if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
      return new $c_T2(this.EI(facade, decIndex, expIndex, i, j), j);
    }
    c = this.dT(j);
  } else {
    var j0 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.EI(facade, decIndex, expIndex, i, j), j);
      }
      c = this.dT(j);
    }
    if ((j0 === j)) {
      this.hc(i, "expected digit");
    }
  }
  if ((c === 46)) {
    decIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.dT(j);
    var j0$2 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.EI(facade, decIndex, expIndex, i, j), j);
      }
      c = this.dT(j);
    }
    if ((j0$2 === j)) {
      this.hc(i, "expected digit");
    }
  }
  if (((c === 69) || (c === 101))) {
    expIndex = ((j - i) | 0);
    j = ((1 + j) | 0);
    c = this.dT(j);
    if (((c === 43) || (c === 45))) {
      j = ((1 + j) | 0);
      c = this.dT(j);
    }
    var j0$3 = j;
    while (this.tL.EK(48, c, 57)) {
      j = ((1 + j) | 0);
      if ($f_Lupickle_core_BufferingCharParser__requestUntil__I__Z(this, j)) {
        return new $c_T2(this.EI(facade, decIndex, expIndex, i, j), j);
      }
      c = this.dT(j);
    }
    if ((j0$3 === j)) {
      this.hc(i, "expected digit");
    }
  }
  return new $c_T2(this.EI(facade, decIndex, expIndex, i, j), j);
});
$p.ate = (function(i) {
  var x = 0;
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().MS(this.dT(((2 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().MS(this.dT(((3 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().MS(this.dT(((4 + i) | 0))));
  x = ((x << 4) | $m_Lupickle_core_RenderUtils$().MS(this.dT(((5 + i) | 0))));
  return (65535 & x);
});
$p.ajc = (function(i, facade) {
  this.DT(((3 + i) | 0));
  return (((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 114) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 117)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 101)) ? facade.ch($f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i)) : this.hc(i, "expected true"));
});
$p.aj8 = (function(i, facade) {
  this.DT(((4 + i) | 0));
  return ((((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 97) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 108)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 115)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((4 + i) | 0)) === 101)) ? facade.cg($f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i)) : this.hc(i, "expected false"));
});
$p.ajb = (function(i, facade) {
  this.DT(((3 + i) | 0));
  return (((($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0)) === 117) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((2 + i) | 0)) === 108)) && ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((3 + i) | 0)) === 108)) ? facade.M($f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i)) : this.hc(i, "expected null"));
});
$p.awQ = (function(i, facade) {
  try {
    return this.awR(i, facade);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var \u03b42$ = new $c_Lujson_CharParser$$anon$1(i);
    if (\u03b42$.bq(e$2)) {
      return \u03b42$.bn(e$2, $m_s_PartialFunction$().fX);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
});
$p.awR = (function(i, facade) {
  var i$tailLocal1 = i;
  while (true) {
    switch (this.dT(i$tailLocal1)) {
      case 32:
      case 9:
      case 13: {
        i$tailLocal1 = ((1 + i$tailLocal1) | 0);
        break;
      }
      case 10: {
        i$tailLocal1 = ((1 + i$tailLocal1) | 0);
        break;
      }
      case 91: {
        return this.aja(6, ((1 + i$tailLocal1) | 0), facade.bt((-1), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal1)), $m_sci_Nil$());
        break;
      }
      case 123: {
        return this.aja(7, ((1 + i$tailLocal1) | 0), facade.K((-1), true, $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal1)), $m_sci_Nil$());
        break;
      }
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57: {
        return this.awL(i$tailLocal1, facade);
        break;
      }
      case 34: {
        return this.awO(i$tailLocal1, facade);
        break;
      }
      case 116: {
        return new $c_T2(this.ajc(i$tailLocal1, facade), ((4 + i$tailLocal1) | 0));
        break;
      }
      case 102: {
        return new $c_T2(this.aj8(i$tailLocal1, facade), ((5 + i$tailLocal1) | 0));
        break;
      }
      case 110: {
        return new $c_T2(this.ajb(i$tailLocal1, facade), ((4 + i$tailLocal1) | 0));
        break;
      }
      default: {
        this.hc(i$tailLocal1, "expected json value");
      }
    }
  }
});
$p.aja = (function(state, i, stackHead, stackTail) {
  var stackTail$tailLocal1 = stackTail;
  var stackHead$tailLocal1 = stackHead;
  var state$tailLocal1 = state;
  var i$tailLocal2 = i;
  while (true) {
    switch (this.dT(i$tailLocal2)) {
      case 32:
      case 9:
      case 13:
      case 10: {
        i$tailLocal2 = ((1 + i$tailLocal2) | 0);
        break;
      }
      case 34: {
        switch (state$tailLocal1) {
          case 2:
          case 7: {
            try {
              var nextJ = this.awN(i$tailLocal2, stackHead$tailLocal1);
            } catch (e) {
              var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
              var \u03b43$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
              if (\u03b43$.bq(e$2)) {
                var nextJ = (\u03b43$.bn(e$2, $m_s_PartialFunction$().fX) | 0);
              } else {
                var nextJ;
                throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
              }
            }
            state$tailLocal1 = 3;
            i$tailLocal2 = nextJ;
            break;
          }
          case 1:
          case 6: {
            try {
              var nextJ$2 = this.awP(i$tailLocal2, stackHead$tailLocal1);
            } catch (e$3) {
              var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
              var \u03b44$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
              if (\u03b44$.bq(e$4)) {
                var nextJ$2 = (\u03b44$.bn(e$4, $m_s_PartialFunction$().fX) | 0);
              } else {
                var nextJ$2;
                throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.b6 : e$4);
              }
            }
            var state$tailLocal1$tmp2 = this.zw(stackHead$tailLocal1);
            state$tailLocal1 = state$tailLocal1$tmp2;
            i$tailLocal2 = nextJ$2;
            break;
          }
          default: {
            this.zA(i$tailLocal2, state$tailLocal1);
          }
        }
        break;
      }
      case 58: {
        if ((state$tailLocal1 === 3)) {
          var i$tailLocal2$tmp3 = ((1 + i$tailLocal2) | 0);
          state$tailLocal1 = 1;
          i$tailLocal2 = i$tailLocal2$tmp3;
          break;
        }
        this.zA(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 91: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          var ctx = stackHead$tailLocal1.bw().bt((-1), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal2));
        } catch (e$5) {
          var e$6 = ((e$5 instanceof $c_jl_Throwable) ? e$5 : new $c_sjs_js_JavaScriptException(e$5));
          var \u03b45$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b45$.bq(e$6)) {
            var ctx = \u03b45$.bn(e$6, $m_s_PartialFunction$().fX);
          } else {
            var ctx;
            throw ((e$6 instanceof $c_sjs_js_JavaScriptException) ? e$6.b6 : e$6);
          }
        }
        var i$tailLocal2$tmp4 = ((1 + i$tailLocal2) | 0);
        var stackTail$tailLocal1$tmp1 = new $c_sci_$colon$colon(stackHead$tailLocal1, stackTail$tailLocal1);
        state$tailLocal1 = 6;
        i$tailLocal2 = i$tailLocal2$tmp4;
        stackHead$tailLocal1 = ctx;
        stackTail$tailLocal1 = stackTail$tailLocal1$tmp1;
        break;
      }
      case 123: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          var ctx$2 = stackHead$tailLocal1.bw().K((-1), true, $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal2));
        } catch (e$7) {
          var e$8 = ((e$7 instanceof $c_jl_Throwable) ? e$7 : new $c_sjs_js_JavaScriptException(e$7));
          var \u03b46$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b46$.bq(e$8)) {
            var ctx$2 = \u03b46$.bn(e$8, $m_s_PartialFunction$().fX);
          } else {
            var ctx$2;
            throw ((e$8 instanceof $c_sjs_js_JavaScriptException) ? e$8.b6 : e$8);
          }
        }
        var i$tailLocal2$tmp5 = ((1 + i$tailLocal2) | 0);
        var stackTail$tailLocal1$tmp2 = new $c_sci_$colon$colon(stackHead$tailLocal1, stackTail$tailLocal1);
        state$tailLocal1 = 7;
        i$tailLocal2 = i$tailLocal2$tmp5;
        stackHead$tailLocal1 = ctx$2;
        stackTail$tailLocal1 = stackTail$tailLocal1$tmp2;
        break;
      }
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          var ctx$3 = this.awK(i$tailLocal2, stackHead$tailLocal1.du(), stackHead$tailLocal1.bw());
        } catch (e$9) {
          var e$10 = ((e$9 instanceof $c_jl_Throwable) ? e$9 : new $c_sjs_js_JavaScriptException(e$9));
          var \u03b47$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b47$.bq(e$10)) {
            var ctx$3 = (\u03b47$.bn(e$10, $m_s_PartialFunction$().fX) | 0);
          } else {
            var ctx$3;
            throw ((e$10 instanceof $c_sjs_js_JavaScriptException) ? e$10.b6 : e$10);
          }
        }
        var state$tailLocal1$tmp6 = this.zw(stackHead$tailLocal1);
        state$tailLocal1 = state$tailLocal1$tmp6;
        i$tailLocal2 = ctx$3;
        break;
      }
      case 116: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.du().bu(this.ajc(i$tailLocal2, stackHead$tailLocal1.bw()), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal2));
        } catch (e$11) {
          var e$12 = ((e$11 instanceof $c_jl_Throwable) ? e$11 : new $c_sjs_js_JavaScriptException(e$11));
          var \u03b48$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b48$.bq(e$12)) {
            \u03b48$.bn(e$12, $m_s_PartialFunction$().fX);
          } else {
            throw ((e$12 instanceof $c_sjs_js_JavaScriptException) ? e$12.b6 : e$12);
          }
        }
        var state$tailLocal1$tmp7 = this.zw(stackHead$tailLocal1);
        var i$tailLocal2$tmp7 = ((4 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp7;
        i$tailLocal2 = i$tailLocal2$tmp7;
        break;
      }
      case 102: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.du().bu(this.aj8(i$tailLocal2, stackHead$tailLocal1.bw()), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal2));
        } catch (e$13) {
          var e$14 = ((e$13 instanceof $c_jl_Throwable) ? e$13 : new $c_sjs_js_JavaScriptException(e$13));
          var \u03b49$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b49$.bq(e$14)) {
            \u03b49$.bn(e$14, $m_s_PartialFunction$().fX);
          } else {
            throw ((e$14 instanceof $c_sjs_js_JavaScriptException) ? e$14.b6 : e$14);
          }
        }
        var state$tailLocal1$tmp8 = this.zw(stackHead$tailLocal1);
        var i$tailLocal2$tmp8 = ((5 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp8;
        i$tailLocal2 = i$tailLocal2$tmp8;
        break;
      }
      case 110: {
        this.E2(state$tailLocal1, i$tailLocal2);
        try {
          stackHead$tailLocal1.du().bu(this.ajb(i$tailLocal2, stackHead$tailLocal1.bw()), $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i$tailLocal2));
        } catch (e$15) {
          var e$16 = ((e$15 instanceof $c_jl_Throwable) ? e$15 : new $c_sjs_js_JavaScriptException(e$15));
          var \u03b410$ = new $c_Lujson_CharParser$$anon$1(i$tailLocal2);
          if (\u03b410$.bq(e$16)) {
            \u03b410$.bn(e$16, $m_s_PartialFunction$().fX);
          } else {
            throw ((e$16 instanceof $c_sjs_js_JavaScriptException) ? e$16.b6 : e$16);
          }
        }
        var state$tailLocal1$tmp9 = this.zw(stackHead$tailLocal1);
        var i$tailLocal2$tmp9 = ((4 + i$tailLocal2) | 0);
        state$tailLocal1 = state$tailLocal1$tmp9;
        i$tailLocal2 = i$tailLocal2$tmp9;
        break;
      }
      case 44: {
        var i$6 = i$tailLocal2;
        this.HA = i$6;
        var nextI = $f_Lupickle_core_BufferingCharParser__normalizeIndex__I__I(this, ((1 + i$tailLocal2) | 0));
        var x12 = state$tailLocal1;
        if ((x12 === 4)) {
          state$tailLocal1 = 1;
          i$tailLocal2 = nextI;
          break;
        }
        if ((x12 === 5)) {
          state$tailLocal1 = 2;
          i$tailLocal2 = nextI;
          break;
        }
        this.zA(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 93: {
        var x16 = state$tailLocal1;
        matchAlts11: {
          matchAlts12: {
            if ((x16 === 4)) {
              break matchAlts12;
            }
            if ((x16 === 6)) {
              break matchAlts12;
            }
            break matchAlts11;
          }
          var x13 = this.akg(stackHead$tailLocal1, stackTail$tailLocal1, i$tailLocal2);
          if ((x13 instanceof $c_s_Some)) {
            return x13.bg;
          }
          if (($m_s_None$() === x13)) {
            var stackTailHead = stackTail$tailLocal1.W();
            var state$tailLocal1$tmp12 = this.zw(stackTailHead);
            var i$tailLocal2$tmp12 = ((1 + i$tailLocal2) | 0);
            var stackTail$tailLocal1$tmp3 = stackTail$tailLocal1.ak();
            state$tailLocal1 = state$tailLocal1$tmp12;
            i$tailLocal2 = i$tailLocal2$tmp12;
            stackHead$tailLocal1 = stackTailHead;
            stackTail$tailLocal1 = stackTail$tailLocal1$tmp3;
            break;
          }
          throw new $c_s_MatchError(x13);
        }
        this.zA(i$tailLocal2, state$tailLocal1);
        break;
      }
      case 125: {
        var x20 = state$tailLocal1;
        matchAlts13: {
          matchAlts14: {
            if ((x20 === 5)) {
              break matchAlts14;
            }
            if ((x20 === 7)) {
              break matchAlts14;
            }
            break matchAlts13;
          }
          var x17 = this.akg(stackHead$tailLocal1, stackTail$tailLocal1, i$tailLocal2);
          if ((x17 instanceof $c_s_Some)) {
            return x17.bg;
          }
          if (($m_s_None$() === x17)) {
            var stackTailHead$2 = stackTail$tailLocal1.W();
            var state$tailLocal1$tmp13 = this.zw(stackTailHead$2);
            var i$tailLocal2$tmp13 = ((1 + i$tailLocal2) | 0);
            var stackTail$tailLocal1$tmp4 = stackTail$tailLocal1.ak();
            state$tailLocal1 = state$tailLocal1$tmp13;
            i$tailLocal2 = i$tailLocal2$tmp13;
            stackHead$tailLocal1 = stackTailHead$2;
            stackTail$tailLocal1 = stackTail$tailLocal1$tmp4;
            break;
          }
          throw new $c_s_MatchError(x17);
        }
        this.zA(i$tailLocal2, state$tailLocal1);
        break;
      }
      default: {
        this.zA(i$tailLocal2, state$tailLocal1);
      }
    }
  }
});
$p.zA = (function(i, state) {
  var $x_1;
  switch (state) {
    case 6: {
      var $x_1 = "json value or ]";
      break;
    }
    case 7: {
      var $x_1 = "json value or }";
      break;
    }
    case 1: {
      var $x_1 = "json value";
      break;
    }
    case 2: {
      var $x_1 = "json string key";
      break;
    }
    case 3: {
      var $x_1 = ":";
      break;
    }
    case 4: {
      var $x_1 = ", or ]";
      break;
    }
    case 5: {
      var $x_1 = ", or }";
      break;
    }
    default: {
      throw new $c_s_MatchError(state);
    }
  }
  this.hc(i, ("expected " + $x_1));
});
$p.E2 = (function(state, i) {
  matchAlts19: {
    matchAlts20: {
      if ((state === 1)) {
        break matchAlts20;
      }
      if ((state === 6)) {
        break matchAlts20;
      }
      break matchAlts19;
    }
    return (void 0);
  }
  this.zA(i, state);
});
$p.akg = (function(stackHead, stackTail, i) {
  var safeIdx = $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i);
  if (stackTail.c()) {
    try {
      var $x_1 = stackHead.L(safeIdx);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var \u03b411$ = new $c_Lujson_CharParser$$anon$1(i);
      if (\u03b411$.bq(e$2)) {
        var $x_1 = \u03b411$.bn(e$2, $m_s_PartialFunction$().fX);
      } else {
        var $x_1;
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
      }
    }
    return new $c_s_Some(new $c_T2($x_1, ((1 + i) | 0)));
  } else {
    var ctxt2 = stackTail.W().du();
    try {
      ctxt2.bu(stackHead.L(safeIdx), safeIdx);
    } catch (e$3) {
      var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
      var \u03b412$ = new $c_Lujson_CharParser$$anon$1(i);
      if (\u03b412$.bq(e$4)) {
        \u03b412$.bn(e$4, $m_s_PartialFunction$().fX);
      } else {
        throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.b6 : e$4);
      }
    }
    return $m_s_None$();
  }
});
$p.zw = (function(stackHead) {
  return (stackHead.ey() ? 5 : 4);
});
$p.Nh = (function(i, safeIndex0) {
  var j = i;
  var safeIndex = safeIndex0;
  while (true) {
    if ((j >= safeIndex)) {
      safeIndex = this.DT(j);
    }
    var c = $f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, j);
    switch (c) {
      case 34: {
        return ((1 + j) | 0);
        break;
      }
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 23:
      case 24:
      case 25:
      case 26:
      case 27:
      case 28:
      case 29:
      case 30:
      case 31: {
        this.hc(j, (("control char (" + c) + ") in string"));
        break;
      }
      case 92: {
        return (~j);
        break;
      }
      default: {
        j = ((1 + j) | 0);
      }
    }
  }
});
$p.awM = (function(i0, safeIndex0) {
  var i = i0;
  var safeIndex = safeIndex0;
  while (true) {
    var c = this.dT(i);
    var c$1 = c;
    if ((c$1 === 34)) {
      return ((1 + i) | 0);
    } else if ((c$1 < 32)) {
      this.hc(i, (("control char (" + c$1) + ") in string"));
    } else if ((c$1 === 92)) {
      if ((((1 + i) | 0) >= safeIndex)) {
        safeIndex = this.DT(((1 + i) | 0));
      }
      switch ($f_Lupickle_core_BufferingCharParser__getCharUnsafe__I__C(this, ((1 + i) | 0))) {
        case 98: {
          this.gB.eP(8);
          i = ((2 + i) | 0);
          break;
        }
        case 102: {
          this.gB.eP(12);
          i = ((2 + i) | 0);
          break;
        }
        case 110: {
          this.gB.eP(10);
          i = ((2 + i) | 0);
          break;
        }
        case 114: {
          this.gB.eP(13);
          i = ((2 + i) | 0);
          break;
        }
        case 116: {
          this.gB.eP(9);
          i = ((2 + i) | 0);
          break;
        }
        case 34: {
          this.gB.eP(34);
          i = ((2 + i) | 0);
          break;
        }
        case 47: {
          this.gB.eP(47);
          i = ((2 + i) | 0);
          break;
        }
        case 92: {
          this.gB.eP(92);
          i = ((2 + i) | 0);
          break;
        }
        case 117: {
          this.gB.eP(this.ate(i));
          i = ((6 + i) | 0);
          break;
        }
        default: {
          this.hc(((1 + i) | 0), "illegal escape sequence after \\");
        }
      }
    } else {
      var k = this.Nh(i, safeIndex);
      var normalizedK = ((k >= 0) ? k : ((-k) | 0));
      $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V(this, this.gB, i, ((((normalizedK - i) | 0) - 1) | 0));
      i = ((normalizedK - 1) | 0);
    }
  }
});
$p.awP = (function(i, stackHead) {
  var k = this.Nh(((1 + i) | 0), 0);
  if ((k >= 0)) {
    this.akx(i, $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), stackHead);
    return k;
  } else {
    var k2 = this.V6(i, k);
    var this$1 = this.gB;
    this.akx(i, $m_jl_String$().hg(this$1.dr, 0, this$1.be), stackHead);
    return k2;
  }
});
$p.awN = (function(i, stackHead) {
  var k = this.Nh(((1 + i) | 0), 0);
  if ((k >= 0)) {
    this.aky(i, $f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), stackHead);
    return k;
  } else {
    var k2 = this.V6(i, k);
    var this$1 = this.gB;
    this.aky(i, $m_jl_String$().hg(this$1.dr, 0, this$1.be), stackHead);
    return k2;
  }
});
$p.V6 = (function(i, k) {
  var this$1 = this.gB;
  this$1.be = 0;
  $f_Lupickle_core_BufferingCharParser__appendCharsToBuilder__Lupickle_core_CharBuilder__I__I__V(this, this.gB, ((1 + i) | 0), (((((-2) - k) | 0) - i) | 0));
  return this.awM((~k), 0);
});
$p.akx = (function(i, s, stackHead) {
  var safeIdx = $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i);
  var v = stackHead.bw().bx(s, safeIdx);
  stackHead.du().bu(v, safeIdx);
});
$p.aky = (function(i, s, stackHead) {
  var safeIdx = $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i);
  var keyVisitor = stackHead.eT(safeIdx);
  stackHead.eU(keyVisitor.bx(s, safeIdx));
});
$p.awO = (function(i, facade) {
  var safeIdx = $f_Lupickle_core_BufferingCharParser__safeVisitorIndex__I__I(this, i);
  var k = this.Nh(((1 + i) | 0), 0);
  if ((k >= 0)) {
    return new $c_T2(facade.bx($f_Lupickle_core_BufferingCharParser__unsafeCharSeqForRange__I__I__Lupickle_core_WrapCharArrayCharSeq(this, ((1 + i) | 0), ((((k - i) | 0) - 2) | 0)), safeIdx), k);
  } else {
    var k2 = this.V6(i, k);
    var this$2 = this.gB;
    return new $c_T2(facade.bx($m_jl_String$().hg(this$2.dr, 0, this$2.be), safeIdx), k2);
  }
});
function $f_Lujson_JsVisitor__visitUInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  return ((((i_$_hi === 2097152) ? (i_$_lo !== 0) : (i_$_hi > 2097152)) || (i_$_hi < 0)) ? $thiz.VU($m_jl_Long$().avD(i_$_lo, i_$_hi, 10), index) : $thiz.VT(((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)), index));
}
function $f_Lujson_JsVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  var $x_2 = $f_T__indexOf__I__I(s, 46);
  matchResult1: {
    var $x_1;
    var x1 = $f_T__indexOf__I__I(s, 69);
    if ((x1 === (-1))) {
      var $x_1 = $f_T__indexOf__I__I(s, 101);
      break matchResult1;
    }
    var $x_1 = x1;
  }
  return $thiz.akv(s, $x_2, $x_1, (-1));
}
function $f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index) {
  var arr = new $c_Lujson_BaseCharRenderer$$anon$1($thiz);
  var i = 0;
  while ((i < len)) {
    arr.EJ(arr.h7.Jk(bytes.a[((offset + i) | 0)], index), index);
    i = ((1 + i) | 0);
  }
  return arr.Jj(index);
}
function $f_Lujson_JsVisitor__visitExt__B__AB__I__I__I__O($thiz, tag, bytes, offset, len, index) {
  var arr = new $c_Lujson_BaseCharRenderer$$anon$1($thiz);
  arr.EJ($thiz.VT(tag, index), (-1));
  arr.EJ($f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index), (-1));
  return arr.Jj((-1));
}
function $f_Lujson_JsVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor($thiz, length, jsonableKeys, index) {
  return (jsonableKeys ? new $c_Lujson_BaseCharRenderer$$anon$2($thiz) : new $c_Lujson_JsVisitor$$anon$1(length, index, $thiz));
}
function $f_Lupack_MsgVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  return new $c_Lupack_Float64(($m_sc_StringOps$(), $m_jl_Double$().fS(s)));
}
function $f_Lupack_MsgVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O($thiz, s, decIndex, expIndex, index) {
  return new $c_Lupack_Float64(($m_sc_StringOps$(), $m_jl_Double$().fS($dp_toString__T(s))));
}
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$() {
}
$p = $c_Lupickle_core_BufferedValue$Builder$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$() {
}
$h_Lupickle_core_BufferedValue$Builder$.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.bt = (function(length, i) {
  return new $c_Lupickle_core_BufferedValue$Builder$$anon$9(i);
});
$p.K = (function(length, jsonableKeys, i) {
  return new $c_Lupickle_core_BufferedValue$Builder$$anon$10(jsonableKeys, i);
});
$p.M = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Null(index);
});
$p.cg = (function(index) {
  return new $c_Lupickle_core_BufferedValue$False(index);
});
$p.ch = (function(index) {
  return new $c_Lupickle_core_BufferedValue$True(index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return new $c_Lupickle_core_BufferedValue$Num(s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return new $c_Lupickle_core_BufferedValue$NumRaw(d, index);
});
$p.bx = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Str(s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return new $c_Lupickle_core_BufferedValue$Binary(bytes, offset, len, index);
});
$p.cB = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Char(s, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return new $c_Lupickle_core_BufferedValue$Ext(tag, bytes, offset, len, index);
});
$p.cs = (function(d, index) {
  return new $c_Lupickle_core_BufferedValue$Float32(d, index);
});
$p.cL = (function(s, index) {
  return new $c_Lupickle_core_BufferedValue$Float64String(s, index);
});
$p.c9 = (function(i, index) {
  return new $c_Lupickle_core_BufferedValue$Int32(i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupickle_core_BufferedValue$Int64(i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupickle_core_BufferedValue$UInt64(i_$_lo, i_$_hi, index);
});
var $d_Lupickle_core_BufferedValue$Builder$ = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$, "upickle.core.BufferedValue$Builder$", ({
  D5: 1,
  d: 1
}));
var $n_Lupickle_core_BufferedValue$Builder$;
function $m_Lupickle_core_BufferedValue$Builder$() {
  if ((!$n_Lupickle_core_BufferedValue$Builder$)) {
    $n_Lupickle_core_BufferedValue$Builder$ = new $c_Lupickle_core_BufferedValue$Builder$();
  }
  return $n_Lupickle_core_BufferedValue$Builder$;
}
/** @constructor */
function $c_Lupickle_core_CharBuilder(startSize) {
  this.dr = null;
  this.be = 0;
  this.dr = new $ac_C(startSize);
  this.be = 0;
}
$p = $c_Lupickle_core_CharBuilder.prototype = new $h_Lupickle_core_CharAppendC();
$p.constructor = $c_Lupickle_core_CharBuilder;
/** @constructor */
function $h_Lupickle_core_CharBuilder() {
}
$h_Lupickle_core_CharBuilder.prototype = $p;
$p.im = (function(increment) {
  var multiple = this.dr.a.length;
  var targetLength = ((this.be + increment) | 0);
  while ((multiple < targetLength)) {
    multiple = (multiple << 1);
  }
  if ((multiple !== this.dr.a.length)) {
    this.dr = $m_ju_Arrays$().Mr(this.dr, multiple);
  }
});
$p.eP = (function(x) {
  if ((this.be === this.dr.a.length)) {
    this.dr = $m_ju_Arrays$().Mr(this.dr, (this.dr.a.length << 1));
  }
  this.dr.a[this.be] = x;
  this.be = ((1 + this.be) | 0);
});
$p.amn = (function(chars, charsStart, charsLength) {
  this.im(charsLength);
  var dest = this.dr;
  var destPos = this.be;
  chars.av(charsStart, dest, destPos, charsLength);
  this.be = ((this.be + charsLength) | 0);
});
$p.aC4 = (function(writer, threshold) {
  if ((this.be > threshold)) {
    writer.azC(this.dr, 0, this.be);
    this.be = 0;
  }
});
var $d_Lupickle_core_CharBuilder = new $TypeData().i($c_Lupickle_core_CharBuilder, "upickle.core.CharBuilder", ({
  Da: 1,
  D9: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$() {
}
$p = $c_Lupickle_core_NoOpVisitor$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$() {
}
$h_Lupickle_core_NoOpVisitor$.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_core_NoOpVisitor$$anon$1();
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_NoOpVisitor$$anon$2();
});
$p.M = (function(index) {
  return (void 0);
});
$p.cg = (function(index) {
  return (void 0);
});
$p.ch = (function(index) {
  return (void 0);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return (void 0);
});
$p.bx = (function(s, index) {
  return (void 0);
});
$p.ct = (function(d, index) {
  return (void 0);
});
$p.cs = (function(d, index) {
  return (void 0);
});
$p.c9 = (function(i, index) {
  return (void 0);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return (void 0);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return (void 0);
});
$p.cL = (function(s, index) {
  return (void 0);
});
$p.cr = (function(bytes, offset, len, index) {
  return (void 0);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return (void 0);
});
$p.cB = (function(s, index) {
  return (void 0);
});
var $d_Lupickle_core_NoOpVisitor$ = new $TypeData().i($c_Lupickle_core_NoOpVisitor$, "upickle.core.NoOpVisitor$", ({
  Dg: 1,
  d: 1
}));
var $n_Lupickle_core_NoOpVisitor$;
function $m_Lupickle_core_NoOpVisitor$() {
  if ((!$n_Lupickle_core_NoOpVisitor$)) {
    $n_Lupickle_core_NoOpVisitor$ = new $c_Lupickle_core_NoOpVisitor$();
  }
  return $n_Lupickle_core_NoOpVisitor$;
}
function $f_Lupickle_core_SimpleVisitor__visitTrue__I__O($thiz, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got boolean"));
}
function $f_Lupickle_core_SimpleVisitor__visitFalse__I__O($thiz, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got boolean"));
}
function $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got string"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O($thiz, s, decIndex, expIndex, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got number"));
}
function $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor($thiz, length, jsonableKeys, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got dictionary"));
}
function $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor($thiz, length, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got sequence"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O($thiz, d, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got float64"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O($thiz, d, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got float32"));
}
function $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O($thiz, i, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got int32"));
}
function $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got int64"));
}
function $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O($thiz, i_$_lo, i_$_hi, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got uint64"));
}
function $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got float64 string"));
}
function $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O($thiz, s, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got char"));
}
function $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O($thiz, bytes, offset, len, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got binary"));
}
function $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O($thiz, tag, bytes, offset, len, index) {
  throw new $c_Lupickle_core_Abort(($thiz.bR() + " got ext"));
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor$RootHasPath$() {
}
$p = $c_Lupickle_core_TraceVisitor$RootHasPath$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$RootHasPath$;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$RootHasPath$() {
}
$h_Lupickle_core_TraceVisitor$RootHasPath$.prototype = $p;
$p.g = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.V7 = (function() {
  return $m_s_None$();
});
$p.Nf = (function() {
  return $m_s_None$();
});
var $d_Lupickle_core_TraceVisitor$RootHasPath$ = new $TypeData().i($c_Lupickle_core_TraceVisitor$RootHasPath$, "upickle.core.TraceVisitor$RootHasPath$", ({
  Dq: 1,
  da: 1
}));
var $n_Lupickle_core_TraceVisitor$RootHasPath$;
function $m_Lupickle_core_TraceVisitor$RootHasPath$() {
  if ((!$n_Lupickle_core_TraceVisitor$RootHasPath$)) {
    $n_Lupickle_core_TraceVisitor$RootHasPath$ = new $c_Lupickle_core_TraceVisitor$RootHasPath$();
  }
  return $n_Lupickle_core_TraceVisitor$RootHasPath$;
}
var $d_Lupickle_core_Types$Reader = new $TypeData().i(1, "upickle.core.Types$Reader", ({
  e: 1,
  d: 1
}));
function $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O($thiz, out, v) {
  return ((v === null) ? out.M((-1)) : $thiz.U(out, v));
}
function $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($thiz, f) {
  return new $c_Lupickle_core_Types$Writer$MapWriter($thiz.T().ji(), $thiz, f);
}
var $d_Lupickle_core_Types$Writer = new $TypeData().i(1, "upickle.core.Types$Writer", ({
  k: 1,
  j: 1
}));
function $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegatedReader) {
  $thiz.eO = delegatedReader;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Visitor$Delegate() {
  this.eO = null;
}
$p = $c_Lupickle_core_Visitor$Delegate.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$Delegate;
/** @constructor */
function $h_Lupickle_core_Visitor$Delegate() {
}
$h_Lupickle_core_Visitor$Delegate.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.M = (function(index) {
  return this.eO.M(index);
});
$p.ch = (function(index) {
  return this.eO.ch(index);
});
$p.cg = (function(index) {
  return this.eO.cg(index);
});
$p.bx = (function(s, index) {
  return this.eO.bx(s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.eO.cu(s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return this.eO.ct(d, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return this.eO.K(length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return this.eO.bt(length, index);
});
$p.cs = (function(d, index) {
  return this.eO.cs(d, index);
});
$p.c9 = (function(i, index) {
  return this.eO.c9(i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return this.eO.cv(i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return this.eO.cD(i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return this.eO.cL(s, index);
});
$p.cB = (function(s, index) {
  return this.eO.cB(s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return this.eO.cr(bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return this.eO.cC(tag, bytes, offset, len, index);
});
function $ct_Lupickle_core_Visitor$MapReader__Lupickle_core_Visitor__($thiz, delegatedReader) {
  $thiz.fG = delegatedReader;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Visitor$MapReader() {
  this.fG = null;
}
$p = $c_Lupickle_core_Visitor$MapReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapReader;
/** @constructor */
function $h_Lupickle_core_Visitor$MapReader() {
}
$h_Lupickle_core_Visitor$MapReader.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.it = (function(v) {
  return ((v === null) ? null : this.V0(v));
});
$p.cg = (function(index) {
  return this.it(this.fG.cg(index));
});
$p.M = (function(index) {
  return this.it(this.fG.M(index));
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.it(this.fG.cu(s, decIndex, expIndex, index));
});
$p.ct = (function(d, index) {
  return this.it(this.fG.ct(d, index));
});
$p.bx = (function(s, index) {
  return this.it(this.fG.bx(s, index));
});
$p.ch = (function(index) {
  return this.it(this.fG.ch(index));
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_Visitor$MapObjContext(this.fG.K(length, jsonableKeys, index), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => this.V0(t))));
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_core_Visitor$MapArrContext(this.fG.bt(length, index), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => this.V0(t))));
});
$p.cs = (function(d, index) {
  return this.it(this.fG.cs(d, index));
});
$p.c9 = (function(i, index) {
  return this.it(this.fG.c9(i, index));
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return this.it(this.fG.cv(i_$_lo, i_$_hi, index));
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return this.it(this.fG.cD(i_$_lo, i_$_hi, index));
});
$p.cL = (function(s, index) {
  return this.it(this.fG.cL(s, index));
});
$p.cB = (function(s, index) {
  return this.it(this.fG.cB(s, index));
});
$p.cr = (function(bytes, offset, len, index) {
  return this.it(this.fG.cr(bytes, offset, len, index));
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return this.it(this.fG.cC(tag, bytes, offset, len, index));
});
/** @constructor */
function $c_Lupickle_core_WrapCharArrayCharSeq(arr, start, length0) {
  this.T1 = null;
  this.T2 = 0;
  this.adH = 0;
  this.LT = null;
  this.T1 = arr;
  this.T2 = start;
  this.adH = length0;
  this.LT = null;
}
$p = $c_Lupickle_core_WrapCharArrayCharSeq.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_WrapCharArrayCharSeq;
/** @constructor */
function $h_Lupickle_core_WrapCharArrayCharSeq() {
}
$h_Lupickle_core_WrapCharArrayCharSeq.prototype = $p;
$p.F = (function() {
  return this.g().length;
});
$p.qD = (function(index) {
  return this.g().charCodeAt(index);
});
$p.EC = (function(newStart, newEnd) {
  return new $c_Lupickle_core_WrapCharArrayCharSeq(this.T1, ((this.T2 + newStart) | 0), ((newEnd - newStart) | 0));
});
$p.g = (function() {
  if ((this.LT !== null)) {
    return this.LT;
  } else {
    var res = $m_jl_String$().hg(this.T1, this.T2, this.adH);
    this.LT = res;
    return res;
  }
});
var $d_Lupickle_core_WrapCharArrayCharSeq = new $TypeData().i($c_Lupickle_core_WrapCharArrayCharSeq, "upickle.core.WrapCharArrayCharSeq", ({
  DM: 1,
  aO: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$() {
  this.W3 = null;
  this.W4 = false;
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$.prototype = $p;
$p.g = (function() {
  return "AgileBoardListSetupData";
});
$p.q = (function() {
  if ((!this.W4)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.W3 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2(MacroImplicits_this, this));
    this.W4 = true;
  }
  return this.W3;
});
$p.anj = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ank = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_agileboard_AgileBoardListSetupData$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$, "com.papasofokli.agileboard.AgileBoardListSetupData$", ({
  ju: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_AgileBoardListSetupData$;
function $m_Lcom_papasofokli_agileboard_AgileBoardListSetupData$() {
  if ((!$n_Lcom_papasofokli_agileboard_AgileBoardListSetupData$)) {
    $n_Lcom_papasofokli_agileboard_AgileBoardListSetupData$ = new $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$();
  }
  return $n_Lcom_papasofokli_agileboard_AgileBoardListSetupData$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardData$() {
  this.W6 = null;
  this.W7 = false;
}
$p = $c_Lcom_papasofokli_agileboard_BoardData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardData$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardData$() {
}
$h_Lcom_papasofokli_agileboard_BoardData$.prototype = $p;
$p.g = (function() {
  return "BoardData";
});
$p.q = (function() {
  if ((!this.W7)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.W6 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_BoardData$$anon$9(MacroImplicits_this, 7, this), new $c_Lcom_papasofokli_agileboard_BoardData$$anon$10(MacroImplicits_this, this));
    this.W7 = true;
  }
  return this.W6;
});
$p.anm = (function(ReadersVersionSpecific_this$14) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anl = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_agileboard_BoardData($x_1.l, $x_1.h, params$2.a[1], params$2.a[2], (!(!params$2.a[3])), params$2.a[4], (!(!params$2.a[5])), params$2.a[6]);
  }));
});
var $d_Lcom_papasofokli_agileboard_BoardData$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardData$, "com.papasofokli.agileboard.BoardData$", ({
  jy: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_BoardData$;
function $m_Lcom_papasofokli_agileboard_BoardData$() {
  if ((!$n_Lcom_papasofokli_agileboard_BoardData$)) {
    $n_Lcom_papasofokli_agileboard_BoardData$ = new $c_Lcom_papasofokli_agileboard_BoardData$();
  }
  return $n_Lcom_papasofokli_agileboard_BoardData$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardElement$() {
  this.W9 = null;
  this.Wa = false;
}
$p = $c_Lcom_papasofokli_agileboard_BoardElement$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardElement$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardElement$() {
}
$h_Lcom_papasofokli_agileboard_BoardElement$.prototype = $p;
$p.g = (function() {
  return "BoardElement";
});
$p.q = (function() {
  if ((!this.Wa)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.W9 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_BoardElement$$anon$11(MacroImplicits_this, 16, this), new $c_Lcom_papasofokli_agileboard_BoardElement$$anon$12(MacroImplicits_this, this));
    this.Wa = true;
  }
  return this.W9;
});
$p.ann = (function(ReadersVersionSpecific_this$17) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ano = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_agileboard_BoardElement($x_1.l, $x_1.h, params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], (!(!params$2.a[7])), params$2.a[8], params$2.a[9], params$2.a[10], params$2.a[11], params$2.a[12], params$2.a[13], params$2.a[14], params$2.a[15]);
  }));
});
var $d_Lcom_papasofokli_agileboard_BoardElement$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardElement$, "com.papasofokli.agileboard.BoardElement$", ({
  jB: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_BoardElement$;
function $m_Lcom_papasofokli_agileboard_BoardElement$() {
  if ((!$n_Lcom_papasofokli_agileboard_BoardElement$)) {
    $n_Lcom_papasofokli_agileboard_BoardElement$ = new $c_Lcom_papasofokli_agileboard_BoardElement$();
  }
  return $n_Lcom_papasofokli_agileboard_BoardElement$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_DropdownData$() {
  this.Wc = null;
  this.Wd = false;
}
$p = $c_Lcom_papasofokli_agileboard_DropdownData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_DropdownData$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_DropdownData$() {
}
$h_Lcom_papasofokli_agileboard_DropdownData$.prototype = $p;
$p.g = (function() {
  return "DropdownData";
});
$p.q = (function() {
  if ((!this.Wd)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Wc = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_DropdownData$$anon$13(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_agileboard_DropdownData$$anon$14(MacroImplicits_this, this));
    this.Wd = true;
  }
  return this.Wc;
});
$p.anp = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anq = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_agileboard_DropdownData(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_agileboard_DropdownData$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_DropdownData$, "com.papasofokli.agileboard.DropdownData$", ({
  jE: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_DropdownData$;
function $m_Lcom_papasofokli_agileboard_DropdownData$() {
  if ((!$n_Lcom_papasofokli_agileboard_DropdownData$)) {
    $n_Lcom_papasofokli_agileboard_DropdownData$ = new $c_Lcom_papasofokli_agileboard_DropdownData$();
  }
  return $n_Lcom_papasofokli_agileboard_DropdownData$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_ItemClickRequest$() {
  this.Wf = null;
  this.Wg = false;
}
$p = $c_Lcom_papasofokli_agileboard_ItemClickRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_ItemClickRequest$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_ItemClickRequest$() {
}
$h_Lcom_papasofokli_agileboard_ItemClickRequest$.prototype = $p;
$p.g = (function() {
  return "ItemClickRequest";
});
$p.q = (function() {
  if ((!this.Wg)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Wf = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6(MacroImplicits_this, this));
    this.Wg = true;
  }
  return this.Wf;
});
$p.anr = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ans = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_agileboard_ItemClickRequest($x_1.l, $x_1.h, params$2.a[1]);
  }));
});
var $d_Lcom_papasofokli_agileboard_ItemClickRequest$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_ItemClickRequest$, "com.papasofokli.agileboard.ItemClickRequest$", ({
  jH: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_ItemClickRequest$;
function $m_Lcom_papasofokli_agileboard_ItemClickRequest$() {
  if ((!$n_Lcom_papasofokli_agileboard_ItemClickRequest$)) {
    $n_Lcom_papasofokli_agileboard_ItemClickRequest$ = new $c_Lcom_papasofokli_agileboard_ItemClickRequest$();
  }
  return $n_Lcom_papasofokli_agileboard_ItemClickRequest$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_RequestBoardData$() {
  this.Wi = null;
  this.Wj = false;
}
$p = $c_Lcom_papasofokli_agileboard_RequestBoardData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_RequestBoardData$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_RequestBoardData$() {
}
$h_Lcom_papasofokli_agileboard_RequestBoardData$.prototype = $p;
$p.g = (function() {
  return "RequestBoardData";
});
$p.q = (function() {
  if ((!this.Wj)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Wi = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4(MacroImplicits_this, this));
    this.Wj = true;
  }
  return this.Wi;
});
$p.ant = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anu = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_agileboard_RequestBoardData($x_1.l, $x_1.h, params$2.a[1]);
  }));
});
var $d_Lcom_papasofokli_agileboard_RequestBoardData$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_RequestBoardData$, "com.papasofokli.agileboard.RequestBoardData$", ({
  jK: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_RequestBoardData$;
function $m_Lcom_papasofokli_agileboard_RequestBoardData$() {
  if ((!$n_Lcom_papasofokli_agileboard_RequestBoardData$)) {
    $n_Lcom_papasofokli_agileboard_RequestBoardData$ = new $c_Lcom_papasofokli_agileboard_RequestBoardData$();
  }
  return $n_Lcom_papasofokli_agileboard_RequestBoardData$;
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$() {
  this.Wl = null;
  this.Wm = false;
}
$p = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_SelectedIdsRequest$() {
}
$h_Lcom_papasofokli_agileboard_SelectedIdsRequest$.prototype = $p;
$p.g = (function() {
  return "SelectedIdsRequest";
});
$p.q = (function() {
  if ((!this.Wm)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Wl = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8(MacroImplicits_this, this));
    this.Wm = true;
  }
  return this.Wl;
});
$p.anv = (function(ReadersVersionSpecific_this$11) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anw = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_agileboard_SelectedIdsRequest(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_agileboard_SelectedIdsRequest$ = new $TypeData().i($c_Lcom_papasofokli_agileboard_SelectedIdsRequest$, "com.papasofokli.agileboard.SelectedIdsRequest$", ({
  jN: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_agileboard_SelectedIdsRequest$;
function $m_Lcom_papasofokli_agileboard_SelectedIdsRequest$() {
  if ((!$n_Lcom_papasofokli_agileboard_SelectedIdsRequest$)) {
    $n_Lcom_papasofokli_agileboard_SelectedIdsRequest$ = new $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$();
  }
  return $n_Lcom_papasofokli_agileboard_SelectedIdsRequest$;
}
/** @constructor */
function $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$() {
}
$p = $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$;
/** @constructor */
function $h_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$() {
}
$h_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$.prototype = $p;
$p.amI = (function(additionalTypeUUIDs) {
  return new $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes(additionalTypeUUIDs.az("21530e57-cbd4-4dc9-a7e4-4ea3ef60f2be"), additionalTypeUUIDs.az("1ece4c34-fa6e-4606-9dfe-c9193f2554c4"), additionalTypeUUIDs.az("2b80f4f5-115e-46cf-9baf-13bff19e790b"));
});
var $d_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$ = new $TypeData().i($c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$, "com.papasofokli.attachments.AdditionalSupportedFileTypes$", ({
  jR: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$;
function $m_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$() {
  if ((!$n_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$)) {
    $n_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$ = new $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$();
  }
  return $n_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes$;
}
var $b_Lcom_papasofokli_bootstrap_PopoverOptions;
function $a_Lcom_papasofokli_bootstrap_PopoverOptions() {
  if ((!$b_Lcom_papasofokli_bootstrap_PopoverOptions)) {
    $b_Lcom_papasofokli_bootstrap_PopoverOptions = class $b_Lcom_papasofokli_bootstrap_PopoverOptions extends Object {
      constructor(arg, arg$2, ...rest) {
        var title = null;
        var content = null;
        var html = false;
        var sanitize = false;
        var container = null;
        var customClass = null;
        var placement = null;
        title = arg;
        content = arg$2;
        html = ((rest[0] !== (void 0)) && (!(!rest[0])));
        sanitize = ((rest[1] === (void 0)) || (!(!rest[1])));
        container = ((rest[2] === (void 0)) ? "body" : rest[2]);
        customClass = ((rest[3] === (void 0)) ? "" : rest[3]);
        placement = ((rest[4] === (void 0)) ? "auto" : rest[4]);
        super();
        Object.defineProperty(this, "title", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "content", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "html", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "sanitize", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "container", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "customClass", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "placement", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.title = title;
        this.content = content;
        this.html = html;
        this.sanitize = sanitize;
        this.container = container;
        this.customClass = customClass;
        this.placement = placement;
      }
    };
  }
  return $b_Lcom_papasofokli_bootstrap_PopoverOptions;
}
/** @constructor */
function $c_Lcom_papasofokli_box_BoxData$() {
  this.Wo = null;
  this.Wp = false;
}
$p = $c_Lcom_papasofokli_box_BoxData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_box_BoxData$;
/** @constructor */
function $h_Lcom_papasofokli_box_BoxData$() {
}
$h_Lcom_papasofokli_box_BoxData$.prototype = $p;
$p.g = (function() {
  return "BoxData";
});
$p.q = (function() {
  if ((!this.Wp)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Wo = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_box_BoxData$$anon$1(MacroImplicits_this, 12, this), new $c_Lcom_papasofokli_box_BoxData$$anon$2(MacroImplicits_this, this));
    this.Wp = true;
  }
  return this.Wo;
});
$p.anx = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.any = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_box_BoxData(params$2.a[0], params$2.a[1], params$2.a[2], (!(!params$2.a[3])), (!(!params$2.a[4])), params$2.a[5], params$2.a[6], params$2.a[7], params$2.a[8], params$2.a[9], params$2.a[10], (!(!params$2.a[11])))));
});
var $d_Lcom_papasofokli_box_BoxData$ = new $TypeData().i($c_Lcom_papasofokli_box_BoxData$, "com.papasofokli.box.BoxData$", ({
  jX: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_box_BoxData$;
function $m_Lcom_papasofokli_box_BoxData$() {
  if ((!$n_Lcom_papasofokli_box_BoxData$)) {
    $n_Lcom_papasofokli_box_BoxData$ = new $c_Lcom_papasofokli_box_BoxData$();
  }
  return $n_Lcom_papasofokli_box_BoxData$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$() {
  this.Ww = null;
  this.Wx = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$.prototype = $p;
$p.auB = (function() {
  if ((!this.Wx)) {
    var MacroImplicits_this = $m_Lupickle_default$();
    var evidence$1$proxy1__runtimeClass;
    var evidence$1$proxy1__runtimeClass = $d_Lcom_papasofokli_chartJSv2x_ChartConfigurationS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3(MacroImplicits_this, 10, this);
    this.Ww = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.chartJSv2x.ChartConfigurationS", "ChartConfigurationS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4(MacroImplicits_this, this), "$type", "com.papasofokli.chartJSv2x.ChartConfigurationS", "ChartConfigurationS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy1__runtimeClass)));
    this.Wx = true;
  }
  return this.Ww;
});
$p.anz = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anA = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS(params$2.a[0], (!(!params$2.a[1])), (!(!params$2.a[2])), params$2.a[3], (params$2.a[4] | 0), params$2.a[5], (!(!params$2.a[6])), (!(!params$2.a[7])), (!(!params$2.a[8])), params$2.a[9])));
});
var $d_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$, "com.papasofokli.chartJSv2x.ChartConfigurationS$", ({
  k7: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$;
function $m_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$)) {
    $n_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$ = new $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDataS$() {
  this.Wz = null;
  this.WA = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDataS$() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDataS$.prototype = $p;
$p.UA = (function() {
  if ((!this.WA)) {
    var MacroImplicits_this = $m_Lupickle_default$();
    var evidence$1$proxy2__runtimeClass;
    var evidence$1$proxy2__runtimeClass = $d_Lcom_papasofokli_chartJSv2x_ChartDataS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5(MacroImplicits_this, 4, this);
    this.Wz = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.chartJSv2x.ChartDataS", "ChartDataS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6(MacroImplicits_this, this), "$type", "com.papasofokli.chartJSv2x.ChartDataS", "ChartDataS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy2__runtimeClass)));
    this.WA = true;
  }
  return this.Wz;
});
$p.anB = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anC = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_chartJSv2x_ChartDataS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDataS$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDataS$, "com.papasofokli.chartJSv2x.ChartDataS$", ({
  ka: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_ChartDataS$;
function $m_Lcom_papasofokli_chartJSv2x_ChartDataS$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_ChartDataS$)) {
    $n_Lcom_papasofokli_chartJSv2x_ChartDataS$ = new $c_Lcom_papasofokli_chartJSv2x_ChartDataS$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_ChartDataS$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$() {
  this.WC = null;
  this.WD = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$.prototype = $p;
$p.ahz = (function() {
  if ((!this.WD)) {
    var MacroImplicits_this = $m_Lupickle_default$();
    var evidence$1$proxy4__runtimeClass;
    var evidence$1$proxy4__runtimeClass = $d_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7(MacroImplicits_this, 8, this);
    this.WC = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.chartJSv2x.ChartDatasetDoubleS", "ChartDatasetDoubleS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8(MacroImplicits_this, this), "$type", "com.papasofokli.chartJSv2x.ChartDatasetDoubleS", "ChartDatasetDoubleS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy4__runtimeClass)));
    this.WD = true;
  }
  return this.WC;
});
$p.anD = (function(ReadersVersionSpecific_this$11) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anE = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], params$2.a[7])));
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$, "com.papasofokli.chartJSv2x.ChartDatasetDoubleS$", ({
  kd: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$;
function $m_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$)) {
    $n_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$ = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetS$() {
  this.WF = null;
  this.WG = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetS$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetS$() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetS$.prototype = $p;
$p.UB = (function() {
  if ((!this.WG)) {
    var MacroImplicits_this = $m_Lupickle_default$();
    var $x_2 = MacroImplicits_this.ap();
    var Tuple_this = new $c_T2($m_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$().ahz(), $m_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$().ahA());
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$4);
    var $x_1 = MacroImplicits_this.hJ().kP("$type", readers);
    var Tuple_this$2 = new $c_T2($m_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$().ahz(), $m_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$().ahA());
    var this$9 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this$2);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$9);
    this.WF = $x_2.aQ($x_1, MacroImplicits_this.ji().kQ(writers));
    this.WG = true;
  }
  return this.WF;
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetS$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetS$, "com.papasofokli.chartJSv2x.ChartDatasetS$", ({
  kg: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_ChartDatasetS$;
function $m_Lcom_papasofokli_chartJSv2x_ChartDatasetS$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_ChartDatasetS$)) {
    $n_Lcom_papasofokli_chartJSv2x_ChartDatasetS$ = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetS$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_ChartDatasetS$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$() {
  this.WH = null;
  this.WI = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$.prototype = $p;
$p.ahA = (function() {
  if ((!this.WI)) {
    var MacroImplicits_this = $m_Lupickle_default$();
    var evidence$1$proxy5__runtimeClass;
    var evidence$1$proxy5__runtimeClass = $d_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9(MacroImplicits_this, 11, this);
    this.WH = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.chartJSv2x.ChartDatasetXYS", "ChartDatasetXYS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10(MacroImplicits_this, this), "$type", "com.papasofokli.chartJSv2x.ChartDatasetXYS", "ChartDatasetXYS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy5__runtimeClass)));
    this.WI = true;
  }
  return this.WH;
});
$p.anG = (function(ReadersVersionSpecific_this$14) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anF = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], (!(!params$2.a[5])), (!(!params$2.a[6])), params$2.a[7], (params$2.a[8] | 0), params$2.a[9], params$2.a[10])));
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$, "com.papasofokli.chartJSv2x.ChartDatasetXYS$", ({
  kh: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$;
function $m_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$)) {
    $n_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$ = new $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$;
}
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_XY$() {
  this.WK = null;
  this.WL = false;
}
$p = $c_Lcom_papasofokli_chartJSv2x_XY$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_XY$;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_XY$() {
}
$h_Lcom_papasofokli_chartJSv2x_XY$.prototype = $p;
$p.g = (function() {
  return "XY";
});
$p.q = (function() {
  if ((!this.WL)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    var x$2$proxy1__runtimeClass;
    var x$2$proxy1__runtimeClass = $d_Lcom_papasofokli_chartJSv2x_XY.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_chartJSv2x_XY$$anon$1(MacroImplicits_this, 2, this);
    this.WK = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.chartJSv2x.XY", "XY", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_chartJSv2x_XY$$anon$2(MacroImplicits_this, this), "$type", "com.papasofokli.chartJSv2x.XY", "XY", new $c_Lupickle_core_Annotator$Checker$Cls(x$2$proxy1__runtimeClass)));
    this.WL = true;
  }
  return this.WK;
});
$p.anH = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anI = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_chartJSv2x_XY((+params$2.a[0]), (+params$2.a[1]))));
});
var $d_Lcom_papasofokli_chartJSv2x_XY$ = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_XY$, "com.papasofokli.chartJSv2x.XY$", ({
  kk: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_chartJSv2x_XY$;
function $m_Lcom_papasofokli_chartJSv2x_XY$() {
  if ((!$n_Lcom_papasofokli_chartJSv2x_XY$)) {
    $n_Lcom_papasofokli_chartJSv2x_XY$ = new $c_Lcom_papasofokli_chartJSv2x_XY$();
  }
  return $n_Lcom_papasofokli_chartJSv2x_XY$;
}
var $b_Lcom_papasofokli_chartjs_Animation;
function $a_Lcom_papasofokli_chartjs_Animation() {
  if ((!$b_Lcom_papasofokli_chartjs_Animation)) {
    $b_Lcom_papasofokli_chartjs_Animation = class $b_Lcom_papasofokli_chartjs_Animation extends Object {
      constructor(...rest) {
        var animateScale = false;
        var numSteps = 0;
        var duration = 0;
        animateScale = ((rest[0] !== (void 0)) && (!(!rest[0])));
        numSteps = ((rest[1] === (void 0)) ? 4 : (rest[1] | 0));
        duration = ((rest[2] === (void 0)) ? 100 : (rest[2] | 0));
        super();
        Object.defineProperty(this, "animateScale", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "numSteps", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": 0
        }));
        Object.defineProperty(this, "duration", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": 0
        }));
        this.animateScale = animateScale;
        this.numSteps = numSteps;
        this.duration = duration;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_Animation;
}
var $b_Lcom_papasofokli_chartjs_Axes;
function $a_Lcom_papasofokli_chartjs_Axes() {
  if ((!$b_Lcom_papasofokli_chartjs_Axes)) {
    $b_Lcom_papasofokli_chartjs_Axes = class $b_Lcom_papasofokli_chartjs_Axes extends Object {
      constructor(...rest) {
        var min = 0;
        var stacked = false;
        var grid = null;
        min = ((rest[0] === (void 0)) ? 0 : (rest[0] | 0));
        stacked = ((rest[1] !== (void 0)) && (!(!rest[1])));
        grid = ((rest[2] === (void 0)) ? $m_Lcom_papasofokli_chartjs_Axes$().alM() : rest[2]);
        super();
        Object.defineProperty(this, "min", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": 0
        }));
        Object.defineProperty(this, "stacked", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "grid", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.min = min;
        this.stacked = stacked;
        this.grid = grid;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_Axes;
}
var $b_Lcom_papasofokli_chartjs_ChartConfig;
function $a_Lcom_papasofokli_chartjs_ChartConfig() {
  if ((!$b_Lcom_papasofokli_chartjs_ChartConfig)) {
    $b_Lcom_papasofokli_chartjs_ChartConfig = class $b_Lcom_papasofokli_chartjs_ChartConfig extends Object {
      constructor(arg, arg$2, ...rest) {
        var chartType = null;
        var data = null;
        var options = null;
        chartType = arg;
        data = arg$2;
        options = ((rest[0] === (void 0)) ? (void 0) : rest[0]);
        super();
        Object.defineProperty(this, "type", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "data", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "options", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.type = chartType;
        this.data = data;
        this.options = options;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ChartConfig;
}
var $r_Lcom_papasofokli_chartjs_ChartOptions__canvas = Symbol();
var $b_Lcom_papasofokli_chartjs_ChartOptions;
function $a_Lcom_papasofokli_chartjs_ChartOptions() {
  if ((!$b_Lcom_papasofokli_chartjs_ChartOptions)) {
    $b_Lcom_papasofokli_chartjs_ChartOptions = class $b_Lcom_papasofokli_chartjs_ChartOptions extends Object {
      constructor(arg, ...rest) {
        var plugins = null;
        var animation = null;
        var isScatter = false;
        var indexAxis = null;
        var width = null;
        var cutout = null;
        var canvasId = null;
        plugins = arg;
        animation = ((rest[0] === (void 0)) ? $m_Lcom_papasofokli_chartjs_ChartOptions$().Ts() : rest[0]);
        isScatter = ((rest[1] !== (void 0)) && (!(!rest[1])));
        indexAxis = ((rest[2] === (void 0)) ? "x" : rest[2]);
        width = ((rest[3] === (void 0)) ? $m_s_None$() : rest[3]);
        cutout = ((rest[4] === (void 0)) ? "75%" : rest[4]);
        canvasId = rest[5];
        super();
        Object.defineProperty(this, "plugins", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "animation", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "isScatter", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "indexAxis", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "width", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "cutout", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "canvasId", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this[$r_Lcom_papasofokli_chartjs_ChartOptions__canvas] = null;
        this.plugins = plugins;
        this.animation = animation;
        this.isScatter = isScatter;
        this.indexAxis = indexAxis;
        this.width = width;
        this.cutout = cutout;
        this.canvasId = canvasId;
        this[$r_Lcom_papasofokli_chartjs_ChartOptions__canvas] = document.getElementById(this.canvasId);
        var this$2 = this.width;
        if ((!this$2.c())) {
          var x0 = this$2.h();
          this[$r_Lcom_papasofokli_chartjs_ChartOptions__canvas].style.width = x0;
          this[$r_Lcom_papasofokli_chartjs_ChartOptions__canvas].parentElement.style.width = x0;
        }
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ChartOptions;
}
var $b_Lcom_papasofokli_chartjs_GridLines;
function $a_Lcom_papasofokli_chartjs_GridLines() {
  if ((!$b_Lcom_papasofokli_chartjs_GridLines)) {
    $b_Lcom_papasofokli_chartjs_GridLines = class $b_Lcom_papasofokli_chartjs_GridLines extends Object {
      constructor(arg) {
        var display = false;
        display = (!(!arg));
        super();
        Object.defineProperty(this, "display", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        this.display = display;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_GridLines;
}
var $b_Lcom_papasofokli_chartjs_RadarScale;
function $a_Lcom_papasofokli_chartjs_RadarScale() {
  if ((!$b_Lcom_papasofokli_chartjs_RadarScale)) {
    $b_Lcom_papasofokli_chartjs_RadarScale = class $b_Lcom_papasofokli_chartjs_RadarScale extends Object {
      constructor(...rest) {
        var display = false;
        var min = 0;
        display = ((rest[0] === (void 0)) || (!(!rest[0])));
        min = ((rest[1] === (void 0)) ? 0 : (rest[1] | 0));
        super();
        Object.defineProperty(this, "display", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        Object.defineProperty(this, "min", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": 0
        }));
        this.display = display;
        this.min = min;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_RadarScale;
}
var $b_Lcom_papasofokli_chartjs_Scales;
function $a_Lcom_papasofokli_chartjs_Scales() {
  if ((!$b_Lcom_papasofokli_chartjs_Scales)) {
    $b_Lcom_papasofokli_chartjs_Scales = class $b_Lcom_papasofokli_chartjs_Scales extends Object {
      constructor(arg, arg$2) {
        var x = null;
        var y = null;
        x = arg;
        y = arg$2;
        super();
        Object.defineProperty(this, "x", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "y", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.x = x;
        this.y = y;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_Scales;
}
var $b_Lcom_papasofokli_chartjs_ScatterScale;
function $a_Lcom_papasofokli_chartjs_ScatterScale() {
  if ((!$b_Lcom_papasofokli_chartjs_ScatterScale)) {
    $b_Lcom_papasofokli_chartjs_ScatterScale = class $b_Lcom_papasofokli_chartjs_ScatterScale extends Object {
      constructor(arg, arg$2) {
        var x = null;
        var y = null;
        x = arg;
        y = arg$2;
        super();
        Object.defineProperty(this, "x", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "y", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.x = x;
        this.y = y;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ScatterScale;
}
var $b_Lcom_papasofokli_chartjs_ScatterXAxes;
function $a_Lcom_papasofokli_chartjs_ScatterXAxes() {
  if ((!$b_Lcom_papasofokli_chartjs_ScatterXAxes)) {
    $b_Lcom_papasofokli_chartjs_ScatterXAxes = class $b_Lcom_papasofokli_chartjs_ScatterXAxes extends Object {
      constructor(arg, arg$2) {
        var scatterXAxesType = null;
        var time = null;
        scatterXAxesType = arg;
        time = arg$2;
        super();
        Object.defineProperty(this, "type", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "time", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.type = scatterXAxesType;
        this.time = time;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ScatterXAxes;
}
var $b_Lcom_papasofokli_chartjs_Time;
function $a_Lcom_papasofokli_chartjs_Time() {
  if ((!$b_Lcom_papasofokli_chartjs_Time)) {
    $b_Lcom_papasofokli_chartjs_Time = class $b_Lcom_papasofokli_chartjs_Time extends Object {
      constructor(arg) {
        var unit = null;
        unit = arg;
        super();
        Object.defineProperty(this, "unit", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.unit = unit;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_Time;
}
var $b_Lcom_papasofokli_chartjs_TooltipCallbacks;
function $a_Lcom_papasofokli_chartjs_TooltipCallbacks() {
  if ((!$b_Lcom_papasofokli_chartjs_TooltipCallbacks)) {
    $b_Lcom_papasofokli_chartjs_TooltipCallbacks = class $b_Lcom_papasofokli_chartjs_TooltipCallbacks extends Object {
      constructor(arg, arg$2) {
        var label = null;
        var footer = null;
        label = arg;
        footer = arg$2;
        super();
        Object.defineProperty(this, "label", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "footer", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.label = label;
        this.footer = footer;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_TooltipCallbacks;
}
/** @constructor */
function $c_Lcom_papasofokli_communication_OutlookData$() {
  this.WQ = null;
  this.WR = false;
}
$p = $c_Lcom_papasofokli_communication_OutlookData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_communication_OutlookData$;
/** @constructor */
function $h_Lcom_papasofokli_communication_OutlookData$() {
}
$h_Lcom_papasofokli_communication_OutlookData$.prototype = $p;
$p.g = (function() {
  return "OutlookData";
});
$p.q = (function() {
  if ((!this.WR)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.WQ = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_communication_OutlookData$$anon$1(MacroImplicits_this, 8, this), new $c_Lcom_papasofokli_communication_OutlookData$$anon$2(MacroImplicits_this, this));
    this.WR = true;
  }
  return this.WQ;
});
$p.anJ = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anK = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_communication_OutlookData($x_1.l, $x_1.h, params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], (!(!params$2.a[6])), (!(!params$2.a[7])));
  }));
});
var $d_Lcom_papasofokli_communication_OutlookData$ = new $TypeData().i($c_Lcom_papasofokli_communication_OutlookData$, "com.papasofokli.communication.OutlookData$", ({
  kS: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_communication_OutlookData$;
function $m_Lcom_papasofokli_communication_OutlookData$() {
  if ((!$n_Lcom_papasofokli_communication_OutlookData$)) {
    $n_Lcom_papasofokli_communication_OutlookData$ = new $c_Lcom_papasofokli_communication_OutlookData$();
  }
  return $n_Lcom_papasofokli_communication_OutlookData$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroup$() {
  this.X4 = null;
  this.X5 = false;
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroup$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroup$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroup$() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroup$.prototype = $p;
$p.g = (function() {
  return "ColumnGroup";
});
$p.q = (function() {
  if ((!this.X5)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.X4 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19(MacroImplicits_this, 4, this), new $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20(MacroImplicits_this, this));
    this.X5 = true;
  }
  return this.X4;
});
$p.anO = (function(ReadersVersionSpecific_this$29) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anP = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_ColumnGroup(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
var $d_Lcom_papasofokli_dataTables_ColumnGroup$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroup$, "com.papasofokli.dataTables.ColumnGroup$", ({
  lc: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_ColumnGroup$;
function $m_Lcom_papasofokli_dataTables_ColumnGroup$() {
  if ((!$n_Lcom_papasofokli_dataTables_ColumnGroup$)) {
    $n_Lcom_papasofokli_dataTables_ColumnGroup$ = new $c_Lcom_papasofokli_dataTables_ColumnGroup$();
  }
  return $n_Lcom_papasofokli_dataTables_ColumnGroup$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroupOption$() {
  this.X7 = null;
  this.X8 = false;
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroupOption$() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroupOption$.prototype = $p;
$p.g = (function() {
  return "ColumnGroupOption";
});
$p.q = (function() {
  if ((!this.X8)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.X7 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18(MacroImplicits_this, this));
    this.X8 = true;
  }
  return this.X7;
});
$p.anQ = (function(ReadersVersionSpecific_this$26) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anR = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_ColumnGroupOption((params$2.a[0] | 0), (params$2.a[1] | 0))));
});
var $d_Lcom_papasofokli_dataTables_ColumnGroupOption$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroupOption$, "com.papasofokli.dataTables.ColumnGroupOption$", ({
  lf: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_ColumnGroupOption$;
function $m_Lcom_papasofokli_dataTables_ColumnGroupOption$() {
  if ((!$n_Lcom_papasofokli_dataTables_ColumnGroupOption$)) {
    $n_Lcom_papasofokli_dataTables_ColumnGroupOption$ = new $c_Lcom_papasofokli_dataTables_ColumnGroupOption$();
  }
  return $n_Lcom_papasofokli_dataTables_ColumnGroupOption$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_CsvPasteHeader$() {
  this.Xa = null;
  this.Xb = false;
}
$p = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_CsvPasteHeader$() {
}
$h_Lcom_papasofokli_dataTables_CsvPasteHeader$.prototype = $p;
$p.g = (function() {
  return "CsvPasteHeader";
});
$p.q = (function() {
  if ((!this.Xb)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Xa = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2(MacroImplicits_this, this));
    this.Xb = true;
  }
  return this.Xa;
});
$p.anS = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anT = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_CsvPasteHeader(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_dataTables_CsvPasteHeader$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_CsvPasteHeader$, "com.papasofokli.dataTables.CsvPasteHeader$", ({
  li: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_CsvPasteHeader$;
function $m_Lcom_papasofokli_dataTables_CsvPasteHeader$() {
  if ((!$n_Lcom_papasofokli_dataTables_CsvPasteHeader$)) {
    $n_Lcom_papasofokli_dataTables_CsvPasteHeader$ = new $c_Lcom_papasofokli_dataTables_CsvPasteHeader$();
  }
  return $n_Lcom_papasofokli_dataTables_CsvPasteHeader$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GetRowsResult$() {
  this.Xd = null;
  this.Xe = false;
}
$p = $c_Lcom_papasofokli_dataTables_GetRowsResult$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GetRowsResult$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GetRowsResult$() {
}
$h_Lcom_papasofokli_dataTables_GetRowsResult$.prototype = $p;
$p.g = (function() {
  return "GetRowsResult";
});
$p.oB = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.q = (function() {
  if ((!this.Xe)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Xd = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1(MacroImplicits_this, 11, this), new $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2(MacroImplicits_this, this));
    this.Xe = true;
  }
  return this.Xd;
});
$p.anU = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anV = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_GetRowsResult((params$2.a[0] | 0), (params$2.a[1] | 0), (params$2.a[2] | 0), params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], params$2.a[7], (!(!params$2.a[8])), params$2.a[9], params$2.a[10])));
});
var $d_Lcom_papasofokli_dataTables_GetRowsResult$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_GetRowsResult$, "com.papasofokli.dataTables.GetRowsResult$", ({
  ll: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_GetRowsResult$;
function $m_Lcom_papasofokli_dataTables_GetRowsResult$() {
  if ((!$n_Lcom_papasofokli_dataTables_GetRowsResult$)) {
    $n_Lcom_papasofokli_dataTables_GetRowsResult$ = new $c_Lcom_papasofokli_dataTables_GetRowsResult$();
  }
  return $n_Lcom_papasofokli_dataTables_GetRowsResult$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowChartData$() {
  this.Xg = null;
  this.Xh = false;
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowChartData$() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowChartData$.prototype = $p;
$p.g = (function() {
  return "GroupedRowChartData";
});
$p.q = (function() {
  if ((!this.Xh)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Xg = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16(MacroImplicits_this, this));
    this.Xh = true;
  }
  return this.Xg;
});
$p.anW = (function(ReadersVersionSpecific_this$23) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anX = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_GroupedRowChartData(params$2.a[0], (params$2.a[1] | 0), params$2.a[2])));
});
var $d_Lcom_papasofokli_dataTables_GroupedRowChartData$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowChartData$, "com.papasofokli.dataTables.GroupedRowChartData$", ({
  lo: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_GroupedRowChartData$;
function $m_Lcom_papasofokli_dataTables_GroupedRowChartData$() {
  if ((!$n_Lcom_papasofokli_dataTables_GroupedRowChartData$)) {
    $n_Lcom_papasofokli_dataTables_GroupedRowChartData$ = new $c_Lcom_papasofokli_dataTables_GroupedRowChartData$();
  }
  return $n_Lcom_papasofokli_dataTables_GroupedRowChartData$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$() {
  this.Xj = null;
  this.Xk = false;
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$.prototype = $p;
$p.g = (function() {
  return "GroupedRowSummaryData";
});
$p.q = (function() {
  if ((!this.Xk)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Xj = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14(MacroImplicits_this, this));
    this.Xk = true;
  }
  return this.Xj;
});
$p.anY = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.anZ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_dataTables_GroupedRowSummaryData$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$, "com.papasofokli.dataTables.GroupedRowSummaryData$", ({
  lr: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_GroupedRowSummaryData$;
function $m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$() {
  if ((!$n_Lcom_papasofokli_dataTables_GroupedRowSummaryData$)) {
    $n_Lcom_papasofokli_dataTables_GroupedRowSummaryData$ = new $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$();
  }
  return $n_Lcom_papasofokli_dataTables_GroupedRowSummaryData$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$() {
  this.XN = null;
  this.XO = false;
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$.prototype = $p;
$p.g = (function() {
  return "SimpleTableCellContentCssData";
});
$p.q = (function() {
  if ((!this.XO)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    var x$2$proxy8__runtimeClass;
    var x$2$proxy8__runtimeClass = $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23(MacroImplicits_this, 2, this);
    this.XN = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.dataTables.SimpleTableCellContentCssData", "SimpleTableCellContentCssData", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24(MacroImplicits_this, this), "$type", "com.papasofokli.dataTables.SimpleTableCellContentCssData", "SimpleTableCellContentCssData", new $c_Lupickle_core_Annotator$Checker$Cls(x$2$proxy8__runtimeClass)));
    this.XO = true;
  }
  return this.XN;
});
$p.ao3 = (function(ReadersVersionSpecific_this$47) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ao4 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$, "com.papasofokli.dataTables.SimpleTableCellContentCssData$", ({
  lK: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$;
function $m_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$() {
  if ((!$n_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$)) {
    $n_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$ = new $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$();
  }
  return $n_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellS$() {
  this.XQ = null;
  this.XR = false;
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellS$() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellS$.prototype = $p;
$p.g = (function() {
  return "SimpleTableCellS";
});
$p.q = (function() {
  if ((!this.XR)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    var x$2$proxy2__runtimeClass;
    var x$2$proxy2__runtimeClass = $d_Lcom_papasofokli_dataTables_SimpleTableCellS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3(MacroImplicits_this, 3, this);
    this.XQ = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.dataTables.SimpleTableCellS", "SimpleTableCellS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4(MacroImplicits_this, this), "$type", "com.papasofokli.dataTables.SimpleTableCellS", "SimpleTableCellS", new $c_Lupickle_core_Annotator$Checker$Cls(x$2$proxy2__runtimeClass)));
    this.XR = true;
  }
  return this.XQ;
});
$p.ao5 = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ao6 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_SimpleTableCellS(params$2.a[0], (params$2.a[1] | 0), params$2.a[2])));
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellS$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellS$, "com.papasofokli.dataTables.SimpleTableCellS$", ({
  lN: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_SimpleTableCellS$;
function $m_Lcom_papasofokli_dataTables_SimpleTableCellS$() {
  if ((!$n_Lcom_papasofokli_dataTables_SimpleTableCellS$)) {
    $n_Lcom_papasofokli_dataTables_SimpleTableCellS$ = new $c_Lcom_papasofokli_dataTables_SimpleTableCellS$();
  }
  return $n_Lcom_papasofokli_dataTables_SimpleTableCellS$;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$1, ReadersVersionSpecific_this$7, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1, x3$lzy1$1, x4$lzy1$1) {
  if (x5$lzy1$1.i) {
    var $x_1 = x5$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T5($p_Lcom_papasofokli_dataTables_TableCellData$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$7), $p_Lcom_papasofokli_dataTables_TableCellData$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$7), $p_Lcom_papasofokli_dataTables_TableCellData$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$7), $p_Lcom_papasofokli_dataTables_TableCellData$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$7), $p_Lcom_papasofokli_dataTables_TableCellData$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$1, ReadersVersionSpecific_this$7));
    var this$2 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$2);
    var $x_1 = x5$lzy1$1.E(ReadersVersionSpecific_this$7.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x5$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$2, ReadersVersionSpecific_this$8, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2) {
  return (x5$lzy1$2.i ? x5$lzy1$2.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$2, ReadersVersionSpecific_this$8, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$3, ReadersVersionSpecific_this$9) {
  if (x4$lzy1$3.i) {
    var $x_1 = x4$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$5(ReadersVersionSpecific_this$9, 2, $thiz);
    var $x_1 = x4$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$9.aq(), "$type", "com.papasofokli.dataTables.SimpleTableCellContentCssData", "SimpleTableCellContentCssData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$13) {
  return (x4$lzy1$4.i ? x4$lzy1$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$13));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$3, ReadersVersionSpecific_this$14) {
  if (x3$lzy1$3.i) {
    var $x_1 = x3$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$6(ReadersVersionSpecific_this$14, 3, $thiz);
    var $x_1 = x3$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$14.aq(), "$type", "com.papasofokli.dataTables.TableCellContentCssData", "TableCellContentCssData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$18) {
  return (x3$lzy1$4.i ? x3$lzy1$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$18));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$19) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$7(ReadersVersionSpecific_this$19, 3, $thiz);
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$19.aq(), "$type", "com.papasofokli.dataTables.TableCellStatusData", "TableCellStatusData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$23) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$23));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$24) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$8(ReadersVersionSpecific_this$24, 4, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$24.aq(), "$type", "com.papasofokli.dataTables.TableCellContentData", "TableCellContentData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$28) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$28));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$29) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$9(ReadersVersionSpecific_this$29, 3, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$29.aq(), "$type", "com.papasofokli.dataTables.TableCellHighlightData", "TableCellHighlightData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$33) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$33));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$1, WritersVersionSpecific_this$5, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1, x3$lzy2$1, x4$lzy2$1) {
  if (x5$lzy2$1.i) {
    var $x_1 = x5$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T5($p_Lcom_papasofokli_dataTables_TableCellData$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$5), $p_Lcom_papasofokli_dataTables_TableCellData$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$5), $p_Lcom_papasofokli_dataTables_TableCellData$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$5), $p_Lcom_papasofokli_dataTables_TableCellData$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$5), $p_Lcom_papasofokli_dataTables_TableCellData$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$1, WritersVersionSpecific_this$5));
    var this$3 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x5$lzy2$1.E(WritersVersionSpecific_this$5.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x5$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$2, WritersVersionSpecific_this$6, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2) {
  return (x5$lzy2$2.i ? x5$lzy2$2.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$2, WritersVersionSpecific_this$6, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$3, WritersVersionSpecific_this$7) {
  if (x4$lzy2$3.i) {
    var $x_1 = x4$lzy2$3.j;
  } else {
    var evidence$1$proxy2__runtimeClass;
    var evidence$1$proxy2__runtimeClass = $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData.l();
    var $x_1 = x4$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$10(WritersVersionSpecific_this$7, $thiz), "$type", "com.papasofokli.dataTables.SimpleTableCellContentCssData", "SimpleTableCellContentCssData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy2__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$10) {
  return (x4$lzy2$4.i ? x4$lzy2$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$3, WritersVersionSpecific_this$11) {
  if (x3$lzy2$3.i) {
    var $x_1 = x3$lzy2$3.j;
  } else {
    var evidence$1$proxy3__runtimeClass;
    var evidence$1$proxy3__runtimeClass = $d_Lcom_papasofokli_dataTables_TableCellContentCssData.l();
    var $x_1 = x3$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$11(WritersVersionSpecific_this$11, $thiz), "$type", "com.papasofokli.dataTables.TableCellContentCssData", "TableCellContentCssData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy3__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$14) {
  return (x3$lzy2$4.i ? x3$lzy2$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$14));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$15) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var evidence$1$proxy4__runtimeClass;
    var evidence$1$proxy4__runtimeClass = $d_Lcom_papasofokli_dataTables_TableCellStatusData.l();
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$15, new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$12(WritersVersionSpecific_this$15, $thiz), "$type", "com.papasofokli.dataTables.TableCellStatusData", "TableCellStatusData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy4__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$18) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$18));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$19) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy5__runtimeClass;
    var evidence$1$proxy5__runtimeClass = $d_Lcom_papasofokli_dataTables_TableCellContentData.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$19, new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$13(WritersVersionSpecific_this$19, $thiz), "$type", "com.papasofokli.dataTables.TableCellContentData", "TableCellContentData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy5__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$22) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$23) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy6__runtimeClass;
    var evidence$1$proxy6__runtimeClass = $d_Lcom_papasofokli_dataTables_TableCellHighlightData.l();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$23, new $c_Lcom_papasofokli_dataTables_TableCellData$$anon$14(WritersVersionSpecific_this$23, $thiz), "$type", "com.papasofokli.dataTables.TableCellHighlightData", "TableCellHighlightData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy6__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_dataTables_TableCellData$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$26) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_dataTables_TableCellData$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$26));
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$() {
  this.XT = null;
  this.XU = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$.prototype = $p;
$p.q = (function() {
  if ((!this.XU)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.XT = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_dataTables_TableCellData$__x5$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_dataTables_TableCellData$__x5$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.XU = true;
  }
  return this.XT;
});
$p.aoc = (function(ReadersVersionSpecific_this$11) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aod = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData(params$2.a[0], params$2.a[1])));
});
$p.aoe = (function(ReadersVersionSpecific_this$16) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aof = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableCellContentCssData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
$p.aog = (function(ReadersVersionSpecific_this$21) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ao7 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableCellStatusData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
$p.ao8 = (function(ReadersVersionSpecific_this$26) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ao9 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableCellContentData(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
$p.aoa = (function(ReadersVersionSpecific_this$31) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aob = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableCellHighlightData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_dataTables_TableCellData$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$, "com.papasofokli.dataTables.TableCellData$", ({
  lQ: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_dataTables_TableCellData$;
function $m_Lcom_papasofokli_dataTables_TableCellData$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableCellData$)) {
    $n_Lcom_papasofokli_dataTables_TableCellData$ = new $c_Lcom_papasofokli_dataTables_TableCellData$();
  }
  return $n_Lcom_papasofokli_dataTables_TableCellData$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellS$() {
  this.Y0 = null;
  this.Y1 = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellS$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellS$() {
}
$h_Lcom_papasofokli_dataTables_TableCellS$.prototype = $p;
$p.g = (function() {
  return "TableCellS";
});
$p.q = (function() {
  if ((!this.Y1)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    var x$2$proxy1__runtimeClass;
    var x$2$proxy1__runtimeClass = $d_Lcom_papasofokli_dataTables_TableCellS.l();
    var $x_1 = MacroImplicits_this.ap();
    var reader = new $c_Lcom_papasofokli_dataTables_TableCellS$$anon$1(MacroImplicits_this, 3, this);
    this.Y0 = $x_1.aQ(new $c_Lupickle_core_Types$TaggedReader$Leaf(MacroImplicits_this.aq(), "$type", "com.papasofokli.dataTables.TableCellS", "TableCellS", reader), $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(MacroImplicits_this, new $c_Lcom_papasofokli_dataTables_TableCellS$$anon$2(MacroImplicits_this, this), "$type", "com.papasofokli.dataTables.TableCellS", "TableCellS", new $c_Lupickle_core_Annotator$Checker$Cls(x$2$proxy1__runtimeClass)));
    this.Y1 = true;
  }
  return this.Y0;
});
$p.aoh = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoi = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableCellS(params$2.a[0], (params$2.a[1] | 0), params$2.a[2])));
});
var $d_Lcom_papasofokli_dataTables_TableCellS$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellS$, "com.papasofokli.dataTables.TableCellS$", ({
  m1: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableCellS$;
function $m_Lcom_papasofokli_dataTables_TableCellS$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableCellS$)) {
    $n_Lcom_papasofokli_dataTables_TableCellS$ = new $c_Lcom_papasofokli_dataTables_TableCellS$();
  }
  return $n_Lcom_papasofokli_dataTables_TableCellS$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableColumnProperties$() {
  this.Y3 = null;
  this.Y4 = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableColumnProperties$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableColumnProperties$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableColumnProperties$() {
}
$h_Lcom_papasofokli_dataTables_TableColumnProperties$.prototype = $p;
$p.g = (function() {
  return "TableColumnProperties";
});
$p.q = (function() {
  if ((!this.Y4)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Y3 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5(MacroImplicits_this, 7, this), new $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6(MacroImplicits_this, this));
    this.Y4 = true;
  }
  return this.Y3;
});
$p.aoj = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aok = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableColumnProperties(params$2.a[0], (params$2.a[1] | 0), (!(!params$2.a[2])), (!(!params$2.a[3])), (+params$2.a[4]), params$2.a[5], (!(!params$2.a[6])))));
});
var $d_Lcom_papasofokli_dataTables_TableColumnProperties$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableColumnProperties$, "com.papasofokli.dataTables.TableColumnProperties$", ({
  m4: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableColumnProperties$;
function $m_Lcom_papasofokli_dataTables_TableColumnProperties$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableColumnProperties$)) {
    $n_Lcom_papasofokli_dataTables_TableColumnProperties$ = new $c_Lcom_papasofokli_dataTables_TableColumnProperties$();
  }
  return $n_Lcom_papasofokli_dataTables_TableColumnProperties$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupRequest$() {
  this.Y6 = null;
  this.Y7 = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupRequest$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupRequest$() {
}
$h_Lcom_papasofokli_dataTables_TableGroupRequest$.prototype = $p;
$p.g = (function() {
  return "TableGroupRequest";
});
$p.I6 = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.q = (function() {
  if ((!this.Y7)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Y6 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11(MacroImplicits_this, 12, this), new $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12(MacroImplicits_this, this));
    this.Y7 = true;
  }
  return this.Y6;
});
$p.aol = (function(ReadersVersionSpecific_this$17) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aom = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableGroupRequest(params$2.a[0], (params$2.a[1] | 0), params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], params$2.a[7], params$2.a[8], params$2.a[9], params$2.a[10], params$2.a[11])));
});
var $d_Lcom_papasofokli_dataTables_TableGroupRequest$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupRequest$, "com.papasofokli.dataTables.TableGroupRequest$", ({
  m8: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableGroupRequest$;
function $m_Lcom_papasofokli_dataTables_TableGroupRequest$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableGroupRequest$)) {
    $n_Lcom_papasofokli_dataTables_TableGroupRequest$ = new $c_Lcom_papasofokli_dataTables_TableGroupRequest$();
  }
  return $n_Lcom_papasofokli_dataTables_TableGroupRequest$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupedResult$() {
  this.Y9 = null;
  this.Ya = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupedResult$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupedResult$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupedResult$() {
}
$h_Lcom_papasofokli_dataTables_TableGroupedResult$.prototype = $p;
$p.g = (function() {
  return "TableGroupedResult";
});
$p.q = (function() {
  if ((!this.Ya)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Y9 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9(MacroImplicits_this, 5, this), new $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10(MacroImplicits_this, this));
    this.Ya = true;
  }
  return this.Y9;
});
$p.aoo = (function(ReadersVersionSpecific_this$14) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aon = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableGroupedResult(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], (params$2.a[4] | 0))));
});
var $d_Lcom_papasofokli_dataTables_TableGroupedResult$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupedResult$, "com.papasofokli.dataTables.TableGroupedResult$", ({
  mb: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableGroupedResult$;
function $m_Lcom_papasofokli_dataTables_TableGroupedResult$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableGroupedResult$)) {
    $n_Lcom_papasofokli_dataTables_TableGroupedResult$ = new $c_Lcom_papasofokli_dataTables_TableGroupedResult$();
  }
  return $n_Lcom_papasofokli_dataTables_TableGroupedResult$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableParameters$() {
  this.Yc = null;
  this.Yd = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableParameters$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableParameters$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableParameters$() {
}
$h_Lcom_papasofokli_dataTables_TableParameters$.prototype = $p;
$p.g = (function() {
  return "TableParameters";
});
$p.oB = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.DJ = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.q = (function() {
  if ((!this.Yd)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Yc = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_TableParameters$$anon$7(MacroImplicits_this, 17, this), new $c_Lcom_papasofokli_dataTables_TableParameters$$anon$8(MacroImplicits_this, this));
    this.Yd = true;
  }
  return this.Yc;
});
$p.aop = (function(ReadersVersionSpecific_this$11) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoq = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableParameters((params$2.a[0] | 0), (params$2.a[1] | 0), (params$2.a[2] | 0), params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], (!(!params$2.a[7])), params$2.a[8], params$2.a[9], params$2.a[10], params$2.a[11], params$2.a[12], params$2.a[13], params$2.a[14], (!(!params$2.a[15])), params$2.a[16])));
});
var $d_Lcom_papasofokli_dataTables_TableParameters$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableParameters$, "com.papasofokli.dataTables.TableParameters$", ({
  mf: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableParameters$;
function $m_Lcom_papasofokli_dataTables_TableParameters$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableParameters$)) {
    $n_Lcom_papasofokli_dataTables_TableParameters$ = new $c_Lcom_papasofokli_dataTables_TableParameters$();
  }
  return $n_Lcom_papasofokli_dataTables_TableParameters$;
}
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableSetupData$() {
  this.Yf = null;
  this.Yg = false;
}
$p = $c_Lcom_papasofokli_dataTables_TableSetupData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableSetupData$;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableSetupData$() {
}
$h_Lcom_papasofokli_dataTables_TableSetupData$.prototype = $p;
$p.g = (function() {
  return "TableSetupData";
});
$p.q = (function() {
  if ((!this.Yg)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Yf = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$3(MacroImplicits_this, 6, this), new $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$4(MacroImplicits_this, this));
    this.Yg = true;
  }
  return this.Yf;
});
$p.aor = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aos = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_dataTables_TableSetupData(params$2.a[0], params$2.a[1], params$2.a[2], (params$2.a[3] | 0), params$2.a[4], params$2.a[5])));
});
var $d_Lcom_papasofokli_dataTables_TableSetupData$ = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableSetupData$, "com.papasofokli.dataTables.TableSetupData$", ({
  mi: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_dataTables_TableSetupData$;
function $m_Lcom_papasofokli_dataTables_TableSetupData$() {
  if ((!$n_Lcom_papasofokli_dataTables_TableSetupData$)) {
    $n_Lcom_papasofokli_dataTables_TableSetupData$ = new $c_Lcom_papasofokli_dataTables_TableSetupData$();
  }
  return $n_Lcom_papasofokli_dataTables_TableSetupData$;
}
/** @constructor */
function $c_Lcom_papasofokli_datetimePicker_DatetimePickerType$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.Yj = null;
  this.Yi = null;
  this.Os = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_datetimePicker_DatetimePickerType$ = this;
  this.Yj = new $c_s_Enumeration$Val(this, this.bI, "datetime");
  this.Yi = new $c_s_Enumeration$Val(this, this.bI, "date");
  this.Os = new $c_s_Enumeration$Val(this, this.bI, "time");
}
$p = $c_Lcom_papasofokli_datetimePicker_DatetimePickerType$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_datetimePicker_DatetimePickerType$;
/** @constructor */
function $h_Lcom_papasofokli_datetimePicker_DatetimePickerType$() {
}
$h_Lcom_papasofokli_datetimePicker_DatetimePickerType$.prototype = $p;
var $d_Lcom_papasofokli_datetimePicker_DatetimePickerType$ = new $TypeData().i($c_Lcom_papasofokli_datetimePicker_DatetimePickerType$, "com.papasofokli.datetimePicker.DatetimePickerType$", ({
  ml: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_datetimePicker_DatetimePickerType$;
function $m_Lcom_papasofokli_datetimePicker_DatetimePickerType$() {
  if ((!$n_Lcom_papasofokli_datetimePicker_DatetimePickerType$)) {
    $n_Lcom_papasofokli_datetimePicker_DatetimePickerType$ = new $c_Lcom_papasofokli_datetimePicker_DatetimePickerType$();
  }
  return $n_Lcom_papasofokli_datetimePicker_DatetimePickerType$;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x74$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x74$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1, x3$lzy1$1, x4$lzy1$1, x5$lzy1$1, x6$lzy1$1, x7$lzy1$1, x8$lzy1$1, x9$lzy1$1, x10$lzy1$1, x11$lzy1$1, x12$lzy1$1, x13$lzy1$1, x14$lzy1$1, x15$lzy1$1, x16$lzy1$1, x17$lzy1$1, x18$lzy1$1, x19$lzy1$1, x20$lzy1$1, x21$lzy1$1, x22$lzy1$1, x23$lzy1$1, x24$lzy1$1, x25$lzy1$1, x26$lzy1$1, x27$lzy1$1, x28$lzy1$1, x29$lzy1$1, x30$lzy1$1, x31$lzy1$1, x32$lzy1$1, x33$lzy1$1, x34$lzy1$1, x35$lzy1$1, x36$lzy1$1, x37$lzy1$1, x38$lzy1$1, x39$lzy1$1, x40$lzy1$1, x41$lzy1$1, x42$lzy1$1, x43$lzy1$1, x44$lzy1$1, x45$lzy1$1, x46$lzy1$1, x47$lzy1$1, x48$lzy1$1, x49$lzy1$1, x50$lzy1$1, x51$lzy1$1, x52$lzy1$1, x53$lzy1$1, x54$lzy1$1, x55$lzy1$1, x56$lzy1$1, x57$lzy1$1, x58$lzy1$1, x59$lzy1$1, x60$lzy1$1, x61$lzy1$1, x62$lzy1$1, x63$lzy1$1, x64$lzy1$1, x65$lzy1$1, x66$lzy1$1, x67$lzy1$1, x68$lzy1$1, x69$lzy1$1, x70$lzy1$1, x71$lzy1$1, x72$lzy1$1, x73$lzy1$1) {
  if (x74$lzy1$1.i) {
    var $x_1 = x74$lzy1$1.j;
  } else {
    var Tuple_this = $m_sr_TupleXXL$().afL($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $m_sjsr_package$().Vb(new $ac_O([$p_Lcom_papasofokli_execution_JsStatement$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x5$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x5$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x6$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x6$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x7$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x7$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x8$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x8$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x9$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x9$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x10$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x10$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x11$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x11$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x12$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x12$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x13$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x13$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x14$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x14$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x15$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x15$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x16$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x16$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x17$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x17$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x18$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x18$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x19$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x19$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x20$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x20$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x21$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x21$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x22$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x22$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x23$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x23$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x24$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x24$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x25$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x25$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x26$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x26$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x27$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x27$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x28$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x28$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x29$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x29$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x30$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x30$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x31$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x31$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x32$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x32$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x33$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x33$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x34$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x34$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x35$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x35$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x36$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x36$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x37$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x37$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x38$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x38$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x39$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x39$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x40$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x40$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x41$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x41$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x42$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x42$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x43$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x43$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x44$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x44$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x45$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x45$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x46$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x46$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x47$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x47$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x48$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x48$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x49$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x49$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x50$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x50$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x51$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x51$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x52$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x52$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x53$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x53$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x54$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x54$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x55$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x55$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x56$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x56$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x57$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x57$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x58$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x58$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x59$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x59$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x60$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x60$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x61$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x61$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x62$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x62$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x63$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x63$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x64$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x64$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x65$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x65$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x66$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x66$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x67$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x67$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x68$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x68$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x69$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x69$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x70$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x70$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x71$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x71$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x72$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x72$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x73$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x73$lzy1$1, ReadersVersionSpecific_this$1)]))));
    var this$4 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x74$lzy1$1.E(ReadersVersionSpecific_this$1.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x74$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x74$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2, x5$lzy1$2, x6$lzy1$2, x7$lzy1$2, x8$lzy1$2, x9$lzy1$2, x10$lzy1$2, x11$lzy1$2, x12$lzy1$2, x13$lzy1$2, x14$lzy1$2, x15$lzy1$2, x16$lzy1$2, x17$lzy1$2, x18$lzy1$2, x19$lzy1$2, x20$lzy1$2, x21$lzy1$2, x22$lzy1$2, x23$lzy1$2, x24$lzy1$2, x25$lzy1$2, x26$lzy1$2, x27$lzy1$2, x28$lzy1$2, x29$lzy1$2, x30$lzy1$2, x31$lzy1$2, x32$lzy1$2, x33$lzy1$2, x34$lzy1$2, x35$lzy1$2, x36$lzy1$2, x37$lzy1$2, x38$lzy1$2, x39$lzy1$2, x40$lzy1$2, x41$lzy1$2, x42$lzy1$2, x43$lzy1$2, x44$lzy1$2, x45$lzy1$2, x46$lzy1$2, x47$lzy1$2, x48$lzy1$2, x49$lzy1$2, x50$lzy1$2, x51$lzy1$2, x52$lzy1$2, x53$lzy1$2, x54$lzy1$2, x55$lzy1$2, x56$lzy1$2, x57$lzy1$2, x58$lzy1$2, x59$lzy1$2, x60$lzy1$2, x61$lzy1$2, x62$lzy1$2, x63$lzy1$2, x64$lzy1$2, x65$lzy1$2, x66$lzy1$2, x67$lzy1$2, x68$lzy1$2, x69$lzy1$2, x70$lzy1$2, x71$lzy1$2, x72$lzy1$2, x73$lzy1$2) {
  return (x74$lzy1$2.i ? x74$lzy1$2.j : $p_Lcom_papasofokli_execution_JsStatement$__x74$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x74$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2, x5$lzy1$2, x6$lzy1$2, x7$lzy1$2, x8$lzy1$2, x9$lzy1$2, x10$lzy1$2, x11$lzy1$2, x12$lzy1$2, x13$lzy1$2, x14$lzy1$2, x15$lzy1$2, x16$lzy1$2, x17$lzy1$2, x18$lzy1$2, x19$lzy1$2, x20$lzy1$2, x21$lzy1$2, x22$lzy1$2, x23$lzy1$2, x24$lzy1$2, x25$lzy1$2, x26$lzy1$2, x27$lzy1$2, x28$lzy1$2, x29$lzy1$2, x30$lzy1$2, x31$lzy1$2, x32$lzy1$2, x33$lzy1$2, x34$lzy1$2, x35$lzy1$2, x36$lzy1$2, x37$lzy1$2, x38$lzy1$2, x39$lzy1$2, x40$lzy1$2, x41$lzy1$2, x42$lzy1$2, x43$lzy1$2, x44$lzy1$2, x45$lzy1$2, x46$lzy1$2, x47$lzy1$2, x48$lzy1$2, x49$lzy1$2, x50$lzy1$2, x51$lzy1$2, x52$lzy1$2, x53$lzy1$2, x54$lzy1$2, x55$lzy1$2, x56$lzy1$2, x57$lzy1$2, x58$lzy1$2, x59$lzy1$2, x60$lzy1$2, x61$lzy1$2, x62$lzy1$2, x63$lzy1$2, x64$lzy1$2, x65$lzy1$2, x66$lzy1$2, x67$lzy1$2, x68$lzy1$2, x69$lzy1$2, x70$lzy1$2, x71$lzy1$2, x72$lzy1$2, x73$lzy1$2));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x73$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x73$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x73$lzy1$3.i) {
    var $x_1 = x73$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$1(ReadersVersionSpecific_this$3, 3, $thiz);
    var $x_1 = x73$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.execution.TableSortColumn", "TableSortColumn", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x73$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x73$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x73$lzy1$4.i ? x73$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x73$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x73$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x72$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x72$lzy1$3, ReadersVersionSpecific_this$8) {
  if (x72$lzy1$3.i) {
    var $x_1 = x72$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$2(ReadersVersionSpecific_this$8, 2, $thiz);
    var $x_1 = x72$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$8.aq(), "$type", "com.papasofokli.execution.TableGroupColumn", "TableGroupColumn", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x72$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x72$lzy1$4, ReadersVersionSpecific_this$12) {
  return (x72$lzy1$4.i ? x72$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x72$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x72$lzy1$4, ReadersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x71$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x71$lzy1$3, ReadersVersionSpecific_this$13) {
  if (x71$lzy1$3.i) {
    var $x_1 = x71$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$3(ReadersVersionSpecific_this$13, 1, $thiz);
    var $x_1 = x71$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$13.aq(), "$type", "com.papasofokli.execution.ResetScanner", "ResetScanner", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x71$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x71$lzy1$4, ReadersVersionSpecific_this$17) {
  return (x71$lzy1$4.i ? x71$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x71$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x71$lzy1$4, ReadersVersionSpecific_this$17));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x70$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x70$lzy1$3, ReadersVersionSpecific_this$18) {
  if (x70$lzy1$3.i) {
    var $x_1 = x70$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$4(ReadersVersionSpecific_this$18, 3, $thiz);
    var $x_1 = x70$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$18.aq(), "$type", "com.papasofokli.execution.UpdateAgileBoard2Column", "UpdateAgileBoard2Column", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x70$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x70$lzy1$4, ReadersVersionSpecific_this$22) {
  return (x70$lzy1$4.i ? x70$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x70$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x70$lzy1$4, ReadersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x69$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x69$lzy1$3, ReadersVersionSpecific_this$23) {
  if (x69$lzy1$3.i) {
    var $x_1 = x69$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_execution_JsStatement$$anon$5(ReadersVersionSpecific_this$23, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$23, $m_Lcom_papasofokli_execution_InvalidPrintServerUUID$());
    var $x_1 = x69$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$23.aq(), "$type", "com.papasofokli.execution.InvalidPrintServerUUID", "InvalidPrintServerUUID", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x69$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x69$lzy1$4, ReadersVersionSpecific_this$27) {
  return (x69$lzy1$4.i ? x69$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x69$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x69$lzy1$4, ReadersVersionSpecific_this$27));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x68$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x68$lzy1$3, ReadersVersionSpecific_this$28) {
  if (x68$lzy1$3.i) {
    var $x_1 = x68$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$6(ReadersVersionSpecific_this$28, 2, $thiz);
    var $x_1 = x68$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$28.aq(), "$type", "com.papasofokli.execution.CollapseTableRow", "CollapseTableRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x68$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x68$lzy1$4, ReadersVersionSpecific_this$32) {
  return (x68$lzy1$4.i ? x68$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x68$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x68$lzy1$4, ReadersVersionSpecific_this$32));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x67$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x67$lzy1$3, ReadersVersionSpecific_this$33) {
  if (x67$lzy1$3.i) {
    var $x_1 = x67$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$7(ReadersVersionSpecific_this$33, 5, $thiz);
    var $x_1 = x67$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$33.aq(), "$type", "com.papasofokli.execution.AddTableRow", "AddTableRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x67$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x67$lzy1$4, ReadersVersionSpecific_this$37) {
  return (x67$lzy1$4.i ? x67$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x67$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x67$lzy1$4, ReadersVersionSpecific_this$37));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x66$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x66$lzy1$3, ReadersVersionSpecific_this$38) {
  if (x66$lzy1$3.i) {
    var $x_1 = x66$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$8(ReadersVersionSpecific_this$38, 1, $thiz);
    var $x_1 = x66$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$38.aq(), "$type", "com.papasofokli.execution.CopyTextToClipboard", "CopyTextToClipboard", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x66$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x66$lzy1$4, ReadersVersionSpecific_this$42) {
  return (x66$lzy1$4.i ? x66$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x66$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x66$lzy1$4, ReadersVersionSpecific_this$42));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x65$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x65$lzy1$3, ReadersVersionSpecific_this$43) {
  if (x65$lzy1$3.i) {
    var $x_1 = x65$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$9(ReadersVersionSpecific_this$43, 1, $thiz);
    var $x_1 = x65$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$43.aq(), "$type", "com.papasofokli.execution.SignaturePadClear", "SignaturePadClear", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x65$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x65$lzy1$4, ReadersVersionSpecific_this$47) {
  return (x65$lzy1$4.i ? x65$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x65$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x65$lzy1$4, ReadersVersionSpecific_this$47));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x64$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x64$lzy1$3, ReadersVersionSpecific_this$48) {
  if (x64$lzy1$3.i) {
    var $x_1 = x64$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$10(ReadersVersionSpecific_this$48, 1, $thiz);
    var $x_1 = x64$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$48.aq(), "$type", "com.papasofokli.execution.SignaturePadToDataURL", "SignaturePadToDataURL", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x64$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x64$lzy1$4, ReadersVersionSpecific_this$52) {
  return (x64$lzy1$4.i ? x64$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x64$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x64$lzy1$4, ReadersVersionSpecific_this$52));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x63$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x63$lzy1$3, ReadersVersionSpecific_this$53) {
  if (x63$lzy1$3.i) {
    var $x_1 = x63$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$11(ReadersVersionSpecific_this$53, 1, $thiz);
    var $x_1 = x63$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$53.aq(), "$type", "com.papasofokli.execution.FocusInput", "FocusInput", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x63$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x63$lzy1$4, ReadersVersionSpecific_this$57) {
  return (x63$lzy1$4.i ? x63$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x63$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x63$lzy1$4, ReadersVersionSpecific_this$57));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x62$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x62$lzy1$3, ReadersVersionSpecific_this$58) {
  if (x62$lzy1$3.i) {
    var $x_1 = x62$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$12(ReadersVersionSpecific_this$58, 1, $thiz);
    var $x_1 = x62$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$58.aq(), "$type", "com.papasofokli.execution.SelectInputDisable", "SelectInputDisable", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x62$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x62$lzy1$4, ReadersVersionSpecific_this$62) {
  return (x62$lzy1$4.i ? x62$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x62$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x62$lzy1$4, ReadersVersionSpecific_this$62));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x61$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x61$lzy1$3, ReadersVersionSpecific_this$63) {
  if (x61$lzy1$3.i) {
    var $x_1 = x61$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$13(ReadersVersionSpecific_this$63, 1, $thiz);
    var $x_1 = x61$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$63.aq(), "$type", "com.papasofokli.execution.SelectInputEnable", "SelectInputEnable", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x61$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x61$lzy1$4, ReadersVersionSpecific_this$67) {
  return (x61$lzy1$4.i ? x61$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x61$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x61$lzy1$4, ReadersVersionSpecific_this$67));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x60$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x60$lzy1$3, ReadersVersionSpecific_this$68) {
  if (x60$lzy1$3.i) {
    var $x_1 = x60$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$14(ReadersVersionSpecific_this$68, 1, $thiz);
    var $x_1 = x60$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$68.aq(), "$type", "com.papasofokli.execution.RemoveElementChildren", "RemoveElementChildren", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x60$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x60$lzy1$4, ReadersVersionSpecific_this$72) {
  return (x60$lzy1$4.i ? x60$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x60$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x60$lzy1$4, ReadersVersionSpecific_this$72));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x59$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x59$lzy1$3, ReadersVersionSpecific_this$73) {
  if (x59$lzy1$3.i) {
    var $x_1 = x59$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$15(ReadersVersionSpecific_this$73, 3, $thiz);
    var $x_1 = x59$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$73.aq(), "$type", "com.papasofokli.execution.RemoveAttributeFromElement", "RemoveAttributeFromElement", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x59$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x59$lzy1$4, ReadersVersionSpecific_this$77) {
  return (x59$lzy1$4.i ? x59$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x59$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x59$lzy1$4, ReadersVersionSpecific_this$77));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x58$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x58$lzy1$3, ReadersVersionSpecific_this$78) {
  if (x58$lzy1$3.i) {
    var $x_1 = x58$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$16(ReadersVersionSpecific_this$78, 4, $thiz);
    var $x_1 = x58$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$78.aq(), "$type", "com.papasofokli.execution.AddAttributeToElement", "AddAttributeToElement", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x58$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x58$lzy1$4, ReadersVersionSpecific_this$82) {
  return (x58$lzy1$4.i ? x58$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x58$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x58$lzy1$4, ReadersVersionSpecific_this$82));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x57$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x57$lzy1$3, ReadersVersionSpecific_this$83) {
  if (x57$lzy1$3.i) {
    var $x_1 = x57$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$17(ReadersVersionSpecific_this$83, 1, $thiz);
    var $x_1 = x57$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$83.aq(), "$type", "com.papasofokli.execution.PopoverHide", "PopoverHide", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x57$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x57$lzy1$4, ReadersVersionSpecific_this$87) {
  return (x57$lzy1$4.i ? x57$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x57$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x57$lzy1$4, ReadersVersionSpecific_this$87));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x56$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x56$lzy1$3, ReadersVersionSpecific_this$88) {
  if (x56$lzy1$3.i) {
    var $x_1 = x56$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$18(ReadersVersionSpecific_this$88, 2, $thiz);
    var $x_1 = x56$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$88.aq(), "$type", "com.papasofokli.execution.ScrollToAnchorId", "ScrollToAnchorId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x56$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x56$lzy1$4, ReadersVersionSpecific_this$92) {
  return (x56$lzy1$4.i ? x56$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x56$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x56$lzy1$4, ReadersVersionSpecific_this$92));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x55$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x55$lzy1$3, ReadersVersionSpecific_this$93) {
  if (x55$lzy1$3.i) {
    var $x_1 = x55$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$19(ReadersVersionSpecific_this$93, 1, $thiz);
    var $x_1 = x55$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$93.aq(), "$type", "com.papasofokli.execution.ReloadAgileBoardInDiv", "ReloadAgileBoardInDiv", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x55$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x55$lzy1$4, ReadersVersionSpecific_this$97) {
  return (x55$lzy1$4.i ? x55$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x55$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x55$lzy1$4, ReadersVersionSpecific_this$97));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x54$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x54$lzy1$3, ReadersVersionSpecific_this$98) {
  if (x54$lzy1$3.i) {
    var $x_1 = x54$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$20(ReadersVersionSpecific_this$98, 7, $thiz);
    var $x_1 = x54$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$98.aq(), "$type", "com.papasofokli.execution.AppendChildrenToParentTree", "AppendChildrenToParentTree", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x54$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x54$lzy1$4, ReadersVersionSpecific_this$102) {
  return (x54$lzy1$4.i ? x54$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x54$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x54$lzy1$4, ReadersVersionSpecific_this$102));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x53$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x53$lzy1$3, ReadersVersionSpecific_this$103) {
  if (x53$lzy1$3.i) {
    var $x_1 = x53$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$21(ReadersVersionSpecific_this$103, 1, $thiz);
    var $x_1 = x53$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$103.aq(), "$type", "com.papasofokli.execution.CalculateDropdownPosition", "CalculateDropdownPosition", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x53$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x53$lzy1$4, ReadersVersionSpecific_this$107) {
  return (x53$lzy1$4.i ? x53$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x53$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x53$lzy1$4, ReadersVersionSpecific_this$107));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x52$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x52$lzy1$3, ReadersVersionSpecific_this$108) {
  if (x52$lzy1$3.i) {
    var $x_1 = x52$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_execution_JsStatement$$anon$22(ReadersVersionSpecific_this$108, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$108, $m_Lcom_papasofokli_execution_ShowModal$());
    var $x_1 = x52$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$108.aq(), "$type", "com.papasofokli.execution.ShowModal", "ShowModal", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x52$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x52$lzy1$4, ReadersVersionSpecific_this$112) {
  return (x52$lzy1$4.i ? x52$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x52$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x52$lzy1$4, ReadersVersionSpecific_this$112));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x51$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x51$lzy1$3, ReadersVersionSpecific_this$113) {
  if (x51$lzy1$3.i) {
    var $x_1 = x51$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_execution_JsStatement$$anon$23(ReadersVersionSpecific_this$113, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$113, $m_Lcom_papasofokli_execution_HideModal$());
    var $x_1 = x51$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$113.aq(), "$type", "com.papasofokli.execution.HideModal", "HideModal", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x51$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x51$lzy1$4, ReadersVersionSpecific_this$117) {
  return (x51$lzy1$4.i ? x51$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x51$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x51$lzy1$4, ReadersVersionSpecific_this$117));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x50$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x50$lzy1$3, ReadersVersionSpecific_this$118) {
  if (x50$lzy1$3.i) {
    var $x_1 = x50$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$24(ReadersVersionSpecific_this$118, 3, $thiz);
    var $x_1 = x50$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$118.aq(), "$type", "com.papasofokli.execution.SetProgress", "SetProgress", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x50$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x50$lzy1$4, ReadersVersionSpecific_this$122) {
  return (x50$lzy1$4.i ? x50$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x50$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x50$lzy1$4, ReadersVersionSpecific_this$122));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x49$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x49$lzy1$3, ReadersVersionSpecific_this$123) {
  if (x49$lzy1$3.i) {
    var $x_1 = x49$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$25(ReadersVersionSpecific_this$123, 4, $thiz);
    var $x_1 = x49$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$123.aq(), "$type", "com.papasofokli.execution.AddDetailPeriodsToPlannerRow", "AddDetailPeriodsToPlannerRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x49$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x49$lzy1$4, ReadersVersionSpecific_this$127) {
  return (x49$lzy1$4.i ? x49$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x49$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x49$lzy1$4, ReadersVersionSpecific_this$127));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x48$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x48$lzy1$3, ReadersVersionSpecific_this$128) {
  if (x48$lzy1$3.i) {
    var $x_1 = x48$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$26(ReadersVersionSpecific_this$128, 1, $thiz);
    var $x_1 = x48$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$128.aq(), "$type", "com.papasofokli.execution.HidePlanningGenerationEffect", "HidePlanningGenerationEffect", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x48$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x48$lzy1$4, ReadersVersionSpecific_this$132) {
  return (x48$lzy1$4.i ? x48$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x48$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x48$lzy1$4, ReadersVersionSpecific_this$132));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x47$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x47$lzy1$3, ReadersVersionSpecific_this$133) {
  if (x47$lzy1$3.i) {
    var $x_1 = x47$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$27(ReadersVersionSpecific_this$133, 2, $thiz);
    var $x_1 = x47$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$133.aq(), "$type", "com.papasofokli.execution.ShowPlanningGenerationEffects", "ShowPlanningGenerationEffects", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x47$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x47$lzy1$4, ReadersVersionSpecific_this$137) {
  return (x47$lzy1$4.i ? x47$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x47$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x47$lzy1$4, ReadersVersionSpecific_this$137));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x46$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x46$lzy1$3, ReadersVersionSpecific_this$138) {
  if (x46$lzy1$3.i) {
    var $x_1 = x46$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$28(ReadersVersionSpecific_this$138, 2, $thiz);
    var $x_1 = x46$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$138.aq(), "$type", "com.papasofokli.execution.FocusPlanningPeriods", "FocusPlanningPeriods", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x46$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x46$lzy1$4, ReadersVersionSpecific_this$142) {
  return (x46$lzy1$4.i ? x46$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x46$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x46$lzy1$4, ReadersVersionSpecific_this$142));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x45$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x45$lzy1$3, ReadersVersionSpecific_this$143) {
  if (x45$lzy1$3.i) {
    var $x_1 = x45$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$29(ReadersVersionSpecific_this$143, 1, $thiz);
    var $x_1 = x45$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$143.aq(), "$type", "com.papasofokli.execution.UndoHighlightTimePeriod", "UndoHighlightTimePeriod", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x45$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x45$lzy1$4, ReadersVersionSpecific_this$147) {
  return (x45$lzy1$4.i ? x45$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x45$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x45$lzy1$4, ReadersVersionSpecific_this$147));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x44$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x44$lzy1$3, ReadersVersionSpecific_this$148) {
  if (x44$lzy1$3.i) {
    var $x_1 = x44$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$30(ReadersVersionSpecific_this$148, 3, $thiz);
    var $x_1 = x44$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$148.aq(), "$type", "com.papasofokli.execution.HighlightTimePeriod", "HighlightTimePeriod", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x44$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x44$lzy1$4, ReadersVersionSpecific_this$152) {
  return (x44$lzy1$4.i ? x44$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x44$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x44$lzy1$4, ReadersVersionSpecific_this$152));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x43$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x43$lzy1$3, ReadersVersionSpecific_this$153) {
  if (x43$lzy1$3.i) {
    var $x_1 = x43$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$31(ReadersVersionSpecific_this$153, 3, $thiz);
    var $x_1 = x43$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$153.aq(), "$type", "com.papasofokli.execution.AddPeriodsToSubject", "AddPeriodsToSubject", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x43$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x43$lzy1$4, ReadersVersionSpecific_this$157) {
  return (x43$lzy1$4.i ? x43$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x43$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x43$lzy1$4, ReadersVersionSpecific_this$157));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x42$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x42$lzy1$3, ReadersVersionSpecific_this$158) {
  if (x42$lzy1$3.i) {
    var $x_1 = x42$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$32(ReadersVersionSpecific_this$158, 3, $thiz);
    var $x_1 = x42$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$158.aq(), "$type", "com.papasofokli.execution.AddPeriodsToPlannerRow", "AddPeriodsToPlannerRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x42$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x42$lzy1$4, ReadersVersionSpecific_this$162) {
  return (x42$lzy1$4.i ? x42$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x42$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x42$lzy1$4, ReadersVersionSpecific_this$162));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x41$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x41$lzy1$3, ReadersVersionSpecific_this$163) {
  if (x41$lzy1$3.i) {
    var $x_1 = x41$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$33(ReadersVersionSpecific_this$163, 3, $thiz);
    var $x_1 = x41$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$163.aq(), "$type", "com.papasofokli.execution.CleanDetailPlannerRow", "CleanDetailPlannerRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x41$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x41$lzy1$4, ReadersVersionSpecific_this$167) {
  return (x41$lzy1$4.i ? x41$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x41$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x41$lzy1$4, ReadersVersionSpecific_this$167));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x40$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x40$lzy1$3, ReadersVersionSpecific_this$168) {
  if (x40$lzy1$3.i) {
    var $x_1 = x40$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$34(ReadersVersionSpecific_this$168, 2, $thiz);
    var $x_1 = x40$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$168.aq(), "$type", "com.papasofokli.execution.CleanPlannerRow", "CleanPlannerRow", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x40$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x40$lzy1$4, ReadersVersionSpecific_this$172) {
  return (x40$lzy1$4.i ? x40$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x40$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x40$lzy1$4, ReadersVersionSpecific_this$172));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x39$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x39$lzy1$3, ReadersVersionSpecific_this$173) {
  if (x39$lzy1$3.i) {
    var $x_1 = x39$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$35(ReadersVersionSpecific_this$173, 2, $thiz);
    var $x_1 = x39$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$173.aq(), "$type", "com.papasofokli.execution.ResizeSidebarForPlanner", "ResizeSidebarForPlanner", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x39$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x39$lzy1$4, ReadersVersionSpecific_this$177) {
  return (x39$lzy1$4.i ? x39$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x39$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x39$lzy1$4, ReadersVersionSpecific_this$177));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x38$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x38$lzy1$3, ReadersVersionSpecific_this$178) {
  if (x38$lzy1$3.i) {
    var $x_1 = x38$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$36(ReadersVersionSpecific_this$178, 1, $thiz);
    var $x_1 = x38$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$178.aq(), "$type", "com.papasofokli.execution.ShowSidebarForPlanner", "ShowSidebarForPlanner", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x38$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x38$lzy1$4, ReadersVersionSpecific_this$182) {
  return (x38$lzy1$4.i ? x38$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x38$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x38$lzy1$4, ReadersVersionSpecific_this$182));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x37$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x37$lzy1$3, ReadersVersionSpecific_this$183) {
  if (x37$lzy1$3.i) {
    var $x_1 = x37$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$37(ReadersVersionSpecific_this$183, 1, $thiz);
    var $x_1 = x37$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$183.aq(), "$type", "com.papasofokli.execution.ClickOnId", "ClickOnId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x37$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x37$lzy1$4, ReadersVersionSpecific_this$187) {
  return (x37$lzy1$4.i ? x37$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x37$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x37$lzy1$4, ReadersVersionSpecific_this$187));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x36$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x36$lzy1$3, ReadersVersionSpecific_this$188) {
  if (x36$lzy1$3.i) {
    var $x_1 = x36$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$38(ReadersVersionSpecific_this$188, 4, $thiz);
    var $x_1 = x36$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$188.aq(), "$type", "com.papasofokli.execution.ShrinkModal", "ShrinkModal", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x36$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x36$lzy1$4, ReadersVersionSpecific_this$192) {
  return (x36$lzy1$4.i ? x36$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x36$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x36$lzy1$4, ReadersVersionSpecific_this$192));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x35$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x35$lzy1$3, ReadersVersionSpecific_this$193) {
  if (x35$lzy1$3.i) {
    var $x_1 = x35$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$39(ReadersVersionSpecific_this$193, 4, $thiz);
    var $x_1 = x35$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$193.aq(), "$type", "com.papasofokli.execution.ExpandModal", "ExpandModal", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x35$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x35$lzy1$4, ReadersVersionSpecific_this$197) {
  return (x35$lzy1$4.i ? x35$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x35$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x35$lzy1$4, ReadersVersionSpecific_this$197));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x34$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x34$lzy1$3, ReadersVersionSpecific_this$198) {
  if (x34$lzy1$3.i) {
    var $x_1 = x34$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$40(ReadersVersionSpecific_this$198, 1, $thiz);
    var $x_1 = x34$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$198.aq(), "$type", "com.papasofokli.execution.OnShownModal", "OnShownModal", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x34$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x34$lzy1$4, ReadersVersionSpecific_this$202) {
  return (x34$lzy1$4.i ? x34$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x34$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x34$lzy1$4, ReadersVersionSpecific_this$202));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x33$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x33$lzy1$3, ReadersVersionSpecific_this$203) {
  if (x33$lzy1$3.i) {
    var $x_1 = x33$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$41(ReadersVersionSpecific_this$203, 1, $thiz);
    var $x_1 = x33$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$203.aq(), "$type", "com.papasofokli.execution.OnCloseModal", "OnCloseModal", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x33$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x33$lzy1$4, ReadersVersionSpecific_this$207) {
  return (x33$lzy1$4.i ? x33$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x33$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x33$lzy1$4, ReadersVersionSpecific_this$207));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x32$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x32$lzy1$3, ReadersVersionSpecific_this$208) {
  if (x32$lzy1$3.i) {
    var $x_1 = x32$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$42(ReadersVersionSpecific_this$208, 3, $thiz);
    var $x_1 = x32$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$208.aq(), "$type", "com.papasofokli.execution.ReplaceElementWithId", "ReplaceElementWithId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x32$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x32$lzy1$4, ReadersVersionSpecific_this$212) {
  return (x32$lzy1$4.i ? x32$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x32$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x32$lzy1$4, ReadersVersionSpecific_this$212));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x31$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x31$lzy1$3, ReadersVersionSpecific_this$213) {
  if (x31$lzy1$3.i) {
    var $x_1 = x31$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$43(ReadersVersionSpecific_this$213, 2, $thiz);
    var $x_1 = x31$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$213.aq(), "$type", "com.papasofokli.execution.AppendElementWithId", "AppendElementWithId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x31$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x31$lzy1$4, ReadersVersionSpecific_this$217) {
  return (x31$lzy1$4.i ? x31$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x31$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x31$lzy1$4, ReadersVersionSpecific_this$217));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x30$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x30$lzy1$3, ReadersVersionSpecific_this$218) {
  if (x30$lzy1$3.i) {
    var $x_1 = x30$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$44(ReadersVersionSpecific_this$218, 2, $thiz);
    var $x_1 = x30$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$218.aq(), "$type", "com.papasofokli.execution.PrependElementWithId", "PrependElementWithId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x30$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x30$lzy1$4, ReadersVersionSpecific_this$222) {
  return (x30$lzy1$4.i ? x30$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x30$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x30$lzy1$4, ReadersVersionSpecific_this$222));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x29$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x29$lzy1$3, ReadersVersionSpecific_this$223) {
  if (x29$lzy1$3.i) {
    var $x_1 = x29$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$45(ReadersVersionSpecific_this$223, 3, $thiz);
    var $x_1 = x29$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$223.aq(), "$type", "com.papasofokli.execution.ReplaceElementContents", "ReplaceElementContents", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x29$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x29$lzy1$4, ReadersVersionSpecific_this$227) {
  return (x29$lzy1$4.i ? x29$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x29$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x29$lzy1$4, ReadersVersionSpecific_this$227));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x28$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x28$lzy1$3, ReadersVersionSpecific_this$228) {
  if (x28$lzy1$3.i) {
    var $x_1 = x28$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$46(ReadersVersionSpecific_this$228, 2, $thiz);
    var $x_1 = x28$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$228.aq(), "$type", "com.papasofokli.execution.AdjustPlannerComponentHeight", "AdjustPlannerComponentHeight", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x28$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x28$lzy1$4, ReadersVersionSpecific_this$232) {
  return (x28$lzy1$4.i ? x28$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x28$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x28$lzy1$4, ReadersVersionSpecific_this$232));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x27$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x27$lzy1$3, ReadersVersionSpecific_this$233) {
  if (x27$lzy1$3.i) {
    var $x_1 = x27$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$47(ReadersVersionSpecific_this$233, 1, $thiz);
    var $x_1 = x27$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$233.aq(), "$type", "com.papasofokli.execution.ReloadPlannerComponentInDiv", "ReloadPlannerComponentInDiv", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x27$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x27$lzy1$4, ReadersVersionSpecific_this$237) {
  return (x27$lzy1$4.i ? x27$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x27$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x27$lzy1$4, ReadersVersionSpecific_this$237));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x26$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x26$lzy1$3, ReadersVersionSpecific_this$238) {
  if (x26$lzy1$3.i) {
    var $x_1 = x26$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$48(ReadersVersionSpecific_this$238, 1, $thiz);
    var $x_1 = x26$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$238.aq(), "$type", "com.papasofokli.execution.RedirectPageToHref", "RedirectPageToHref", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x26$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x26$lzy1$4, ReadersVersionSpecific_this$242) {
  return (x26$lzy1$4.i ? x26$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x26$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x26$lzy1$4, ReadersVersionSpecific_this$242));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x25$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x25$lzy1$3, ReadersVersionSpecific_this$243) {
  if (x25$lzy1$3.i) {
    var $x_1 = x25$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$49(ReadersVersionSpecific_this$243, 1, $thiz);
    var $x_1 = x25$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$243.aq(), "$type", "com.papasofokli.execution.OpenPrinterCashbox", "OpenPrinterCashbox", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x25$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x25$lzy1$4, ReadersVersionSpecific_this$247) {
  return (x25$lzy1$4.i ? x25$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x25$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x25$lzy1$4, ReadersVersionSpecific_this$247));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x24$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x24$lzy1$3, ReadersVersionSpecific_this$248) {
  if (x24$lzy1$3.i) {
    var $x_1 = x24$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$50(ReadersVersionSpecific_this$248, 6, $thiz);
    var $x_1 = x24$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$248.aq(), "$type", "com.papasofokli.execution.PrintReceiptBytes", "PrintReceiptBytes", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x24$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x24$lzy1$4, ReadersVersionSpecific_this$252) {
  return (x24$lzy1$4.i ? x24$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x24$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x24$lzy1$4, ReadersVersionSpecific_this$252));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x23$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x23$lzy1$3, ReadersVersionSpecific_this$253) {
  if (x23$lzy1$3.i) {
    var $x_1 = x23$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$51(ReadersVersionSpecific_this$253, 1, $thiz);
    var $x_1 = x23$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$253.aq(), "$type", "com.papasofokli.execution.DownloadFile", "DownloadFile", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x23$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x23$lzy1$4, ReadersVersionSpecific_this$257) {
  return (x23$lzy1$4.i ? x23$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x23$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x23$lzy1$4, ReadersVersionSpecific_this$257));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x22$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x22$lzy1$3, ReadersVersionSpecific_this$258) {
  if (x22$lzy1$3.i) {
    var $x_1 = x22$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$52(ReadersVersionSpecific_this$258, 1, $thiz);
    var $x_1 = x22$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$258.aq(), "$type", "com.papasofokli.execution.ToggleNotificationDropdown", "ToggleNotificationDropdown", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x22$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x22$lzy1$4, ReadersVersionSpecific_this$262) {
  return (x22$lzy1$4.i ? x22$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x22$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x22$lzy1$4, ReadersVersionSpecific_this$262));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x21$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x21$lzy1$3, ReadersVersionSpecific_this$263) {
  if (x21$lzy1$3.i) {
    var $x_1 = x21$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$53(ReadersVersionSpecific_this$263, 2, $thiz);
    var $x_1 = x21$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$263.aq(), "$type", "com.papasofokli.execution.UpdateIconNotification", "UpdateIconNotification", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x21$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x21$lzy1$4, ReadersVersionSpecific_this$267) {
  return (x21$lzy1$4.i ? x21$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x21$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x21$lzy1$4, ReadersVersionSpecific_this$267));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x20$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x20$lzy1$3, ReadersVersionSpecific_this$268) {
  if (x20$lzy1$3.i) {
    var $x_1 = x20$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$54(ReadersVersionSpecific_this$268, 1, $thiz);
    var $x_1 = x20$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$268.aq(), "$type", "com.papasofokli.execution.ShowHideNavSidebar", "ShowHideNavSidebar", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x20$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x20$lzy1$4, ReadersVersionSpecific_this$272) {
  return (x20$lzy1$4.i ? x20$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x20$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x20$lzy1$4, ReadersVersionSpecific_this$272));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x19$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x19$lzy1$3, ReadersVersionSpecific_this$273) {
  if (x19$lzy1$3.i) {
    var $x_1 = x19$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$55(ReadersVersionSpecific_this$273, 1, $thiz);
    var $x_1 = x19$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$273.aq(), "$type", "com.papasofokli.execution.HttpRedirect", "HttpRedirect", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x19$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x19$lzy1$4, ReadersVersionSpecific_this$277) {
  return (x19$lzy1$4.i ? x19$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x19$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x19$lzy1$4, ReadersVersionSpecific_this$277));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x18$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x18$lzy1$3, ReadersVersionSpecific_this$278) {
  if (x18$lzy1$3.i) {
    var $x_1 = x18$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$56(ReadersVersionSpecific_this$278, 1, $thiz);
    var $x_1 = x18$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$278.aq(), "$type", "com.papasofokli.execution.NavigateTo", "NavigateTo", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x18$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x18$lzy1$4, ReadersVersionSpecific_this$282) {
  return (x18$lzy1$4.i ? x18$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x18$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x18$lzy1$4, ReadersVersionSpecific_this$282));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x17$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x17$lzy1$3, ReadersVersionSpecific_this$283) {
  if (x17$lzy1$3.i) {
    var $x_1 = x17$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$57(ReadersVersionSpecific_this$283, 1, $thiz);
    var $x_1 = x17$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$283.aq(), "$type", "com.papasofokli.execution.ChangeTitleTo", "ChangeTitleTo", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x17$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x17$lzy1$4, ReadersVersionSpecific_this$287) {
  return (x17$lzy1$4.i ? x17$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x17$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x17$lzy1$4, ReadersVersionSpecific_this$287));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x16$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x16$lzy1$3, ReadersVersionSpecific_this$288) {
  if (x16$lzy1$3.i) {
    var $x_1 = x16$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$58(ReadersVersionSpecific_this$288, 1, $thiz);
    var $x_1 = x16$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$288.aq(), "$type", "com.papasofokli.execution.ChangeUrlTo", "ChangeUrlTo", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x16$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x16$lzy1$4, ReadersVersionSpecific_this$292) {
  return (x16$lzy1$4.i ? x16$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x16$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x16$lzy1$4, ReadersVersionSpecific_this$292));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x15$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x15$lzy1$3, ReadersVersionSpecific_this$293) {
  if (x15$lzy1$3.i) {
    var $x_1 = x15$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$59(ReadersVersionSpecific_this$293, 3, $thiz);
    var $x_1 = x15$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$293.aq(), "$type", "com.papasofokli.execution.OpenUrl", "OpenUrl", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x15$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x15$lzy1$4, ReadersVersionSpecific_this$297) {
  return (x15$lzy1$4.i ? x15$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x15$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x15$lzy1$4, ReadersVersionSpecific_this$297));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x14$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x14$lzy1$3, ReadersVersionSpecific_this$298) {
  if (x14$lzy1$3.i) {
    var $x_1 = x14$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$60(ReadersVersionSpecific_this$298, 2, $thiz);
    var $x_1 = x14$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$298.aq(), "$type", "com.papasofokli.execution.ReplaceContentsByClassWith", "ReplaceContentsByClassWith", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x14$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x14$lzy1$4, ReadersVersionSpecific_this$302) {
  return (x14$lzy1$4.i ? x14$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x14$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x14$lzy1$4, ReadersVersionSpecific_this$302));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x13$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x13$lzy1$3, ReadersVersionSpecific_this$303) {
  if (x13$lzy1$3.i) {
    var $x_1 = x13$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$61(ReadersVersionSpecific_this$303, 2, $thiz);
    var $x_1 = x13$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$303.aq(), "$type", "com.papasofokli.execution.ReplaceAnchorContents", "ReplaceAnchorContents", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x13$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x13$lzy1$4, ReadersVersionSpecific_this$307) {
  return (x13$lzy1$4.i ? x13$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x13$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x13$lzy1$4, ReadersVersionSpecific_this$307));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x12$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x12$lzy1$3, ReadersVersionSpecific_this$308) {
  if (x12$lzy1$3.i) {
    var $x_1 = x12$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$62(ReadersVersionSpecific_this$308, 2, $thiz);
    var $x_1 = x12$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$308.aq(), "$type", "com.papasofokli.execution.ReplaceAnchorWithId", "ReplaceAnchorWithId", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x12$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x12$lzy1$4, ReadersVersionSpecific_this$312) {
  return (x12$lzy1$4.i ? x12$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x12$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x12$lzy1$4, ReadersVersionSpecific_this$312));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x11$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x11$lzy1$3, ReadersVersionSpecific_this$313) {
  if (x11$lzy1$3.i) {
    var $x_1 = x11$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$63(ReadersVersionSpecific_this$313, 1, $thiz);
    var $x_1 = x11$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$313.aq(), "$type", "com.papasofokli.execution.ReloadTable", "ReloadTable", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x11$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x11$lzy1$4, ReadersVersionSpecific_this$317) {
  return (x11$lzy1$4.i ? x11$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x11$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x11$lzy1$4, ReadersVersionSpecific_this$317));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x10$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x10$lzy1$3, ReadersVersionSpecific_this$318) {
  if (x10$lzy1$3.i) {
    var $x_1 = x10$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$64(ReadersVersionSpecific_this$318, 4, $thiz);
    var $x_1 = x10$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$318.aq(), "$type", "com.papasofokli.execution.UpdateValidation", "UpdateValidation", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x10$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x10$lzy1$4, ReadersVersionSpecific_this$322) {
  return (x10$lzy1$4.i ? x10$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x10$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x10$lzy1$4, ReadersVersionSpecific_this$322));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x9$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x9$lzy1$3, ReadersVersionSpecific_this$323) {
  if (x9$lzy1$3.i) {
    var $x_1 = x9$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$65(ReadersVersionSpecific_this$323, 1, $thiz);
    var $x_1 = x9$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$323.aq(), "$type", "com.papasofokli.execution.ResetPayrollTree", "ResetPayrollTree", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x9$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x9$lzy1$4, ReadersVersionSpecific_this$327) {
  return (x9$lzy1$4.i ? x9$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x9$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x9$lzy1$4, ReadersVersionSpecific_this$327));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x8$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x8$lzy1$3, ReadersVersionSpecific_this$328) {
  if (x8$lzy1$3.i) {
    var $x_1 = x8$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$66(ReadersVersionSpecific_this$328, 1, $thiz);
    var $x_1 = x8$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$328.aq(), "$type", "com.papasofokli.execution.PayrollTreeLoadData", "PayrollTreeLoadData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x8$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x8$lzy1$4, ReadersVersionSpecific_this$332) {
  return (x8$lzy1$4.i ? x8$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x8$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x8$lzy1$4, ReadersVersionSpecific_this$332));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x7$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x7$lzy1$3, ReadersVersionSpecific_this$333) {
  if (x7$lzy1$3.i) {
    var $x_1 = x7$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$67(ReadersVersionSpecific_this$333, 1, $thiz);
    var $x_1 = x7$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$333.aq(), "$type", "com.papasofokli.execution.HidePlanningPeriodChanges", "HidePlanningPeriodChanges", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x7$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x7$lzy1$4, ReadersVersionSpecific_this$337) {
  return (x7$lzy1$4.i ? x7$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x7$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x7$lzy1$4, ReadersVersionSpecific_this$337));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x6$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x6$lzy1$3, ReadersVersionSpecific_this$338) {
  if (x6$lzy1$3.i) {
    var $x_1 = x6$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$68(ReadersVersionSpecific_this$338, 2, $thiz);
    var $x_1 = x6$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$338.aq(), "$type", "com.papasofokli.execution.ShowPlanningPeriodChanges", "ShowPlanningPeriodChanges", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x6$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x6$lzy1$4, ReadersVersionSpecific_this$342) {
  return (x6$lzy1$4.i ? x6$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x6$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x6$lzy1$4, ReadersVersionSpecific_this$342));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x5$lzy1$3, ReadersVersionSpecific_this$343) {
  if (x5$lzy1$3.i) {
    var $x_1 = x5$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$69(ReadersVersionSpecific_this$343, 2, $thiz);
    var $x_1 = x5$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$343.aq(), "$type", "com.papasofokli.execution.ModifyPeriods", "ModifyPeriods", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x5$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x5$lzy1$4, ReadersVersionSpecific_this$347) {
  return (x5$lzy1$4.i ? x5$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x5$lzy1$4, ReadersVersionSpecific_this$347));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$3, ReadersVersionSpecific_this$348) {
  if (x4$lzy1$3.i) {
    var $x_1 = x4$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$70(ReadersVersionSpecific_this$348, 4, $thiz);
    var $x_1 = x4$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$348.aq(), "$type", "com.papasofokli.execution.SetRightDivSize", "SetRightDivSize", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$352) {
  return (x4$lzy1$4.i ? x4$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$352));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$3, ReadersVersionSpecific_this$353) {
  if (x3$lzy1$3.i) {
    var $x_1 = x3$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$71(ReadersVersionSpecific_this$353, 2, $thiz);
    var $x_1 = x3$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$353.aq(), "$type", "com.papasofokli.execution.ToggleClassFromElement", "ToggleClassFromElement", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$357) {
  return (x3$lzy1$4.i ? x3$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$357));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$358) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$72(ReadersVersionSpecific_this$358, 2, $thiz);
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$358.aq(), "$type", "com.papasofokli.execution.RemoveClassFromElement", "RemoveClassFromElement", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$362) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$362));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$363) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$73(ReadersVersionSpecific_this$363, 2, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$363.aq(), "$type", "com.papasofokli.execution.AddClassToElement", "AddClassToElement", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$367) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$367));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$368) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_execution_JsStatement$$anon$74(ReadersVersionSpecific_this$368, 1, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$368.aq(), "$type", "com.papasofokli.execution.InitializeTab", "InitializeTab", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$372) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$372));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x74$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x74$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1, x3$lzy2$1, x4$lzy2$1, x5$lzy2$1, x6$lzy2$1, x7$lzy2$1, x8$lzy2$1, x9$lzy2$1, x10$lzy2$1, x11$lzy2$1, x12$lzy2$1, x13$lzy2$1, x14$lzy2$1, x15$lzy2$1, x16$lzy2$1, x17$lzy2$1, x18$lzy2$1, x19$lzy2$1, x20$lzy2$1, x21$lzy2$1, x22$lzy2$1, x23$lzy2$1, x24$lzy2$1, x25$lzy2$1, x26$lzy2$1, x27$lzy2$1, x28$lzy2$1, x29$lzy2$1, x30$lzy2$1, x31$lzy2$1, x32$lzy2$1, x33$lzy2$1, x34$lzy2$1, x35$lzy2$1, x36$lzy2$1, x37$lzy2$1, x38$lzy2$1, x39$lzy2$1, x40$lzy2$1, x41$lzy2$1, x42$lzy2$1, x43$lzy2$1, x44$lzy2$1, x45$lzy2$1, x46$lzy2$1, x47$lzy2$1, x48$lzy2$1, x49$lzy2$1, x50$lzy2$1, x51$lzy2$1, x52$lzy2$1, x53$lzy2$1, x54$lzy2$1, x55$lzy2$1, x56$lzy2$1, x57$lzy2$1, x58$lzy2$1, x59$lzy2$1, x60$lzy2$1, x61$lzy2$1, x62$lzy2$1, x63$lzy2$1, x64$lzy2$1, x65$lzy2$1, x66$lzy2$1, x67$lzy2$1, x68$lzy2$1, x69$lzy2$1, x70$lzy2$1, x71$lzy2$1, x72$lzy2$1, x73$lzy2$1) {
  if (x74$lzy2$1.i) {
    var $x_1 = x74$lzy2$1.j;
  } else {
    var Tuple_this = $m_sr_TupleXXL$().afL($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $m_sjsr_package$().Vb(new $ac_O([$p_Lcom_papasofokli_execution_JsStatement$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x5$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x5$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x6$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x6$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x7$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x7$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x8$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x8$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x9$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x9$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x10$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x10$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x11$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x11$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x12$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x12$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x13$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x13$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x14$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x14$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x15$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x15$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x16$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x16$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x17$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x17$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x18$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x18$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x19$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x19$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x20$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x20$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x21$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x21$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x22$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x22$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x23$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x23$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x24$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x24$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x25$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x25$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x26$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x26$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x27$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x27$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x28$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x28$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x29$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x29$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x30$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x30$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x31$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x31$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x32$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x32$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x33$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x33$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x34$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x34$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x35$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x35$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x36$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x36$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x37$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x37$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x38$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x38$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x39$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x39$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x40$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x40$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x41$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x41$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x42$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x42$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x43$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x43$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x44$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x44$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x45$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x45$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x46$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x46$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x47$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x47$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x48$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x48$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x49$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x49$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x50$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x50$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x51$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x51$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x52$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x52$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x53$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x53$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x54$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x54$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x55$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x55$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x56$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x56$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x57$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x57$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x58$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x58$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x59$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x59$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x60$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x60$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x61$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x61$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x62$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x62$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x63$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x63$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x64$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x64$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x65$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x65$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x66$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x66$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x67$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x67$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x68$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x68$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x69$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x69$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x70$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x70$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x71$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x71$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x72$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x72$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_execution_JsStatement$__x73$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x73$lzy2$1, WritersVersionSpecific_this$1)]))));
    var this$5 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$5);
    var $x_1 = x74$lzy2$1.E(WritersVersionSpecific_this$1.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x74$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x74$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2, x5$lzy2$2, x6$lzy2$2, x7$lzy2$2, x8$lzy2$2, x9$lzy2$2, x10$lzy2$2, x11$lzy2$2, x12$lzy2$2, x13$lzy2$2, x14$lzy2$2, x15$lzy2$2, x16$lzy2$2, x17$lzy2$2, x18$lzy2$2, x19$lzy2$2, x20$lzy2$2, x21$lzy2$2, x22$lzy2$2, x23$lzy2$2, x24$lzy2$2, x25$lzy2$2, x26$lzy2$2, x27$lzy2$2, x28$lzy2$2, x29$lzy2$2, x30$lzy2$2, x31$lzy2$2, x32$lzy2$2, x33$lzy2$2, x34$lzy2$2, x35$lzy2$2, x36$lzy2$2, x37$lzy2$2, x38$lzy2$2, x39$lzy2$2, x40$lzy2$2, x41$lzy2$2, x42$lzy2$2, x43$lzy2$2, x44$lzy2$2, x45$lzy2$2, x46$lzy2$2, x47$lzy2$2, x48$lzy2$2, x49$lzy2$2, x50$lzy2$2, x51$lzy2$2, x52$lzy2$2, x53$lzy2$2, x54$lzy2$2, x55$lzy2$2, x56$lzy2$2, x57$lzy2$2, x58$lzy2$2, x59$lzy2$2, x60$lzy2$2, x61$lzy2$2, x62$lzy2$2, x63$lzy2$2, x64$lzy2$2, x65$lzy2$2, x66$lzy2$2, x67$lzy2$2, x68$lzy2$2, x69$lzy2$2, x70$lzy2$2, x71$lzy2$2, x72$lzy2$2, x73$lzy2$2) {
  return (x74$lzy2$2.i ? x74$lzy2$2.j : $p_Lcom_papasofokli_execution_JsStatement$__x74$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x74$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2, x5$lzy2$2, x6$lzy2$2, x7$lzy2$2, x8$lzy2$2, x9$lzy2$2, x10$lzy2$2, x11$lzy2$2, x12$lzy2$2, x13$lzy2$2, x14$lzy2$2, x15$lzy2$2, x16$lzy2$2, x17$lzy2$2, x18$lzy2$2, x19$lzy2$2, x20$lzy2$2, x21$lzy2$2, x22$lzy2$2, x23$lzy2$2, x24$lzy2$2, x25$lzy2$2, x26$lzy2$2, x27$lzy2$2, x28$lzy2$2, x29$lzy2$2, x30$lzy2$2, x31$lzy2$2, x32$lzy2$2, x33$lzy2$2, x34$lzy2$2, x35$lzy2$2, x36$lzy2$2, x37$lzy2$2, x38$lzy2$2, x39$lzy2$2, x40$lzy2$2, x41$lzy2$2, x42$lzy2$2, x43$lzy2$2, x44$lzy2$2, x45$lzy2$2, x46$lzy2$2, x47$lzy2$2, x48$lzy2$2, x49$lzy2$2, x50$lzy2$2, x51$lzy2$2, x52$lzy2$2, x53$lzy2$2, x54$lzy2$2, x55$lzy2$2, x56$lzy2$2, x57$lzy2$2, x58$lzy2$2, x59$lzy2$2, x60$lzy2$2, x61$lzy2$2, x62$lzy2$2, x63$lzy2$2, x64$lzy2$2, x65$lzy2$2, x66$lzy2$2, x67$lzy2$2, x68$lzy2$2, x69$lzy2$2, x70$lzy2$2, x71$lzy2$2, x72$lzy2$2, x73$lzy2$2));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x73$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x73$lzy2$3, WritersVersionSpecific_this$3) {
  if (x73$lzy2$3.i) {
    var $x_1 = x73$lzy2$3.j;
  } else {
    var evidence$1$proxy3__runtimeClass;
    var evidence$1$proxy3__runtimeClass = $d_Lcom_papasofokli_execution_TableSortColumn.l();
    var $x_1 = x73$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lcom_papasofokli_execution_JsStatement$$anon$75(WritersVersionSpecific_this$3, $thiz), "$type", "com.papasofokli.execution.TableSortColumn", "TableSortColumn", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy3__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x73$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x73$lzy2$4, WritersVersionSpecific_this$6) {
  return (x73$lzy2$4.i ? x73$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x73$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x73$lzy2$4, WritersVersionSpecific_this$6));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x72$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x72$lzy2$3, WritersVersionSpecific_this$7) {
  if (x72$lzy2$3.i) {
    var $x_1 = x72$lzy2$3.j;
  } else {
    var evidence$1$proxy4__runtimeClass;
    var evidence$1$proxy4__runtimeClass = $d_Lcom_papasofokli_execution_TableGroupColumn.l();
    var $x_1 = x72$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lcom_papasofokli_execution_JsStatement$$anon$76(WritersVersionSpecific_this$7, $thiz), "$type", "com.papasofokli.execution.TableGroupColumn", "TableGroupColumn", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy4__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x72$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x72$lzy2$4, WritersVersionSpecific_this$10) {
  return (x72$lzy2$4.i ? x72$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x72$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x72$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x71$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x71$lzy2$3, WritersVersionSpecific_this$11) {
  if (x71$lzy2$3.i) {
    var $x_1 = x71$lzy2$3.j;
  } else {
    var evidence$1$proxy5__runtimeClass;
    var evidence$1$proxy5__runtimeClass = $d_Lcom_papasofokli_execution_ResetScanner.l();
    var $x_1 = x71$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lcom_papasofokli_execution_JsStatement$$anon$77(WritersVersionSpecific_this$11, $thiz), "$type", "com.papasofokli.execution.ResetScanner", "ResetScanner", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy5__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x71$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x71$lzy2$4, WritersVersionSpecific_this$14) {
  return (x71$lzy2$4.i ? x71$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x71$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x71$lzy2$4, WritersVersionSpecific_this$14));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x70$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x70$lzy2$3, WritersVersionSpecific_this$15) {
  if (x70$lzy2$3.i) {
    var $x_1 = x70$lzy2$3.j;
  } else {
    var evidence$1$proxy6__runtimeClass;
    var evidence$1$proxy6__runtimeClass = $d_Lcom_papasofokli_execution_UpdateAgileBoard2Column.l();
    var $x_1 = x70$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$15, new $c_Lcom_papasofokli_execution_JsStatement$$anon$78(WritersVersionSpecific_this$15, $thiz), "$type", "com.papasofokli.execution.UpdateAgileBoard2Column", "UpdateAgileBoard2Column", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy6__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x70$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x70$lzy2$4, WritersVersionSpecific_this$18) {
  return (x70$lzy2$4.i ? x70$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x70$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x70$lzy2$4, WritersVersionSpecific_this$18));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x69$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x69$lzy2$3, WritersVersionSpecific_this$19) {
  if (x69$lzy2$3.i) {
    var $x_1 = x69$lzy2$3.j;
  } else {
    var $x_1 = x69$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$19, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$19, null), "$type", "com.papasofokli.execution.InvalidPrintServerUUID", "InvalidPrintServerUUID", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_execution_InvalidPrintServerUUID$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x69$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x69$lzy2$4, WritersVersionSpecific_this$22) {
  return (x69$lzy2$4.i ? x69$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x69$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x69$lzy2$4, WritersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x68$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x68$lzy2$3, WritersVersionSpecific_this$23) {
  if (x68$lzy2$3.i) {
    var $x_1 = x68$lzy2$3.j;
  } else {
    var evidence$1$proxy8__runtimeClass;
    var evidence$1$proxy8__runtimeClass = $d_Lcom_papasofokli_execution_CollapseTableRow.l();
    var $x_1 = x68$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$23, new $c_Lcom_papasofokli_execution_JsStatement$$anon$80(WritersVersionSpecific_this$23, $thiz), "$type", "com.papasofokli.execution.CollapseTableRow", "CollapseTableRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy8__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x68$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x68$lzy2$4, WritersVersionSpecific_this$26) {
  return (x68$lzy2$4.i ? x68$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x68$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x68$lzy2$4, WritersVersionSpecific_this$26));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x67$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x67$lzy2$3, WritersVersionSpecific_this$27) {
  if (x67$lzy2$3.i) {
    var $x_1 = x67$lzy2$3.j;
  } else {
    var evidence$1$proxy9__runtimeClass;
    var evidence$1$proxy9__runtimeClass = $d_Lcom_papasofokli_execution_AddTableRow.l();
    var $x_1 = x67$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$27, new $c_Lcom_papasofokli_execution_JsStatement$$anon$81(WritersVersionSpecific_this$27, $thiz), "$type", "com.papasofokli.execution.AddTableRow", "AddTableRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy9__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x67$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x67$lzy2$4, WritersVersionSpecific_this$30) {
  return (x67$lzy2$4.i ? x67$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x67$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x67$lzy2$4, WritersVersionSpecific_this$30));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x66$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x66$lzy2$3, WritersVersionSpecific_this$31) {
  if (x66$lzy2$3.i) {
    var $x_1 = x66$lzy2$3.j;
  } else {
    var evidence$1$proxy10__runtimeClass;
    var evidence$1$proxy10__runtimeClass = $d_Lcom_papasofokli_execution_CopyTextToClipboard.l();
    var $x_1 = x66$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$31, new $c_Lcom_papasofokli_execution_JsStatement$$anon$82(WritersVersionSpecific_this$31, $thiz), "$type", "com.papasofokli.execution.CopyTextToClipboard", "CopyTextToClipboard", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy10__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x66$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x66$lzy2$4, WritersVersionSpecific_this$34) {
  return (x66$lzy2$4.i ? x66$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x66$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x66$lzy2$4, WritersVersionSpecific_this$34));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x65$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x65$lzy2$3, WritersVersionSpecific_this$35) {
  if (x65$lzy2$3.i) {
    var $x_1 = x65$lzy2$3.j;
  } else {
    var evidence$1$proxy11__runtimeClass;
    var evidence$1$proxy11__runtimeClass = $d_Lcom_papasofokli_execution_SignaturePadClear.l();
    var $x_1 = x65$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$35, new $c_Lcom_papasofokli_execution_JsStatement$$anon$83(WritersVersionSpecific_this$35, $thiz), "$type", "com.papasofokli.execution.SignaturePadClear", "SignaturePadClear", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy11__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x65$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x65$lzy2$4, WritersVersionSpecific_this$38) {
  return (x65$lzy2$4.i ? x65$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x65$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x65$lzy2$4, WritersVersionSpecific_this$38));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x64$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x64$lzy2$3, WritersVersionSpecific_this$39) {
  if (x64$lzy2$3.i) {
    var $x_1 = x64$lzy2$3.j;
  } else {
    var evidence$1$proxy12__runtimeClass;
    var evidence$1$proxy12__runtimeClass = $d_Lcom_papasofokli_execution_SignaturePadToDataURL.l();
    var $x_1 = x64$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$39, new $c_Lcom_papasofokli_execution_JsStatement$$anon$84(WritersVersionSpecific_this$39, $thiz), "$type", "com.papasofokli.execution.SignaturePadToDataURL", "SignaturePadToDataURL", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy12__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x64$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x64$lzy2$4, WritersVersionSpecific_this$42) {
  return (x64$lzy2$4.i ? x64$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x64$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x64$lzy2$4, WritersVersionSpecific_this$42));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x63$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x63$lzy2$3, WritersVersionSpecific_this$43) {
  if (x63$lzy2$3.i) {
    var $x_1 = x63$lzy2$3.j;
  } else {
    var evidence$1$proxy13__runtimeClass;
    var evidence$1$proxy13__runtimeClass = $d_Lcom_papasofokli_execution_FocusInput.l();
    var $x_1 = x63$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$43, new $c_Lcom_papasofokli_execution_JsStatement$$anon$85(WritersVersionSpecific_this$43, $thiz), "$type", "com.papasofokli.execution.FocusInput", "FocusInput", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy13__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x63$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x63$lzy2$4, WritersVersionSpecific_this$46) {
  return (x63$lzy2$4.i ? x63$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x63$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x63$lzy2$4, WritersVersionSpecific_this$46));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x62$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x62$lzy2$3, WritersVersionSpecific_this$47) {
  if (x62$lzy2$3.i) {
    var $x_1 = x62$lzy2$3.j;
  } else {
    var evidence$1$proxy14__runtimeClass;
    var evidence$1$proxy14__runtimeClass = $d_Lcom_papasofokli_execution_SelectInputDisable.l();
    var $x_1 = x62$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$47, new $c_Lcom_papasofokli_execution_JsStatement$$anon$86(WritersVersionSpecific_this$47, $thiz), "$type", "com.papasofokli.execution.SelectInputDisable", "SelectInputDisable", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy14__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x62$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x62$lzy2$4, WritersVersionSpecific_this$50) {
  return (x62$lzy2$4.i ? x62$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x62$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x62$lzy2$4, WritersVersionSpecific_this$50));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x61$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x61$lzy2$3, WritersVersionSpecific_this$51) {
  if (x61$lzy2$3.i) {
    var $x_1 = x61$lzy2$3.j;
  } else {
    var evidence$1$proxy15__runtimeClass;
    var evidence$1$proxy15__runtimeClass = $d_Lcom_papasofokli_execution_SelectInputEnable.l();
    var $x_1 = x61$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$51, new $c_Lcom_papasofokli_execution_JsStatement$$anon$87(WritersVersionSpecific_this$51, $thiz), "$type", "com.papasofokli.execution.SelectInputEnable", "SelectInputEnable", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy15__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x61$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x61$lzy2$4, WritersVersionSpecific_this$54) {
  return (x61$lzy2$4.i ? x61$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x61$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x61$lzy2$4, WritersVersionSpecific_this$54));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x60$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x60$lzy2$3, WritersVersionSpecific_this$55) {
  if (x60$lzy2$3.i) {
    var $x_1 = x60$lzy2$3.j;
  } else {
    var evidence$1$proxy16__runtimeClass;
    var evidence$1$proxy16__runtimeClass = $d_Lcom_papasofokli_execution_RemoveElementChildren.l();
    var $x_1 = x60$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$55, new $c_Lcom_papasofokli_execution_JsStatement$$anon$88(WritersVersionSpecific_this$55, $thiz), "$type", "com.papasofokli.execution.RemoveElementChildren", "RemoveElementChildren", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy16__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x60$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x60$lzy2$4, WritersVersionSpecific_this$58) {
  return (x60$lzy2$4.i ? x60$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x60$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x60$lzy2$4, WritersVersionSpecific_this$58));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x59$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x59$lzy2$3, WritersVersionSpecific_this$59) {
  if (x59$lzy2$3.i) {
    var $x_1 = x59$lzy2$3.j;
  } else {
    var evidence$1$proxy17__runtimeClass;
    var evidence$1$proxy17__runtimeClass = $d_Lcom_papasofokli_execution_RemoveAttributeFromElement.l();
    var $x_1 = x59$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$59, new $c_Lcom_papasofokli_execution_JsStatement$$anon$89(WritersVersionSpecific_this$59, $thiz), "$type", "com.papasofokli.execution.RemoveAttributeFromElement", "RemoveAttributeFromElement", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy17__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x59$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x59$lzy2$4, WritersVersionSpecific_this$62) {
  return (x59$lzy2$4.i ? x59$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x59$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x59$lzy2$4, WritersVersionSpecific_this$62));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x58$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x58$lzy2$3, WritersVersionSpecific_this$63) {
  if (x58$lzy2$3.i) {
    var $x_1 = x58$lzy2$3.j;
  } else {
    var evidence$1$proxy18__runtimeClass;
    var evidence$1$proxy18__runtimeClass = $d_Lcom_papasofokli_execution_AddAttributeToElement.l();
    var $x_1 = x58$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$63, new $c_Lcom_papasofokli_execution_JsStatement$$anon$90(WritersVersionSpecific_this$63, $thiz), "$type", "com.papasofokli.execution.AddAttributeToElement", "AddAttributeToElement", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy18__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x58$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x58$lzy2$4, WritersVersionSpecific_this$66) {
  return (x58$lzy2$4.i ? x58$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x58$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x58$lzy2$4, WritersVersionSpecific_this$66));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x57$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x57$lzy2$3, WritersVersionSpecific_this$67) {
  if (x57$lzy2$3.i) {
    var $x_1 = x57$lzy2$3.j;
  } else {
    var evidence$1$proxy19__runtimeClass;
    var evidence$1$proxy19__runtimeClass = $d_Lcom_papasofokli_execution_PopoverHide.l();
    var $x_1 = x57$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$67, new $c_Lcom_papasofokli_execution_JsStatement$$anon$91(WritersVersionSpecific_this$67, $thiz), "$type", "com.papasofokli.execution.PopoverHide", "PopoverHide", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy19__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x57$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x57$lzy2$4, WritersVersionSpecific_this$70) {
  return (x57$lzy2$4.i ? x57$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x57$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x57$lzy2$4, WritersVersionSpecific_this$70));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x56$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x56$lzy2$3, WritersVersionSpecific_this$71) {
  if (x56$lzy2$3.i) {
    var $x_1 = x56$lzy2$3.j;
  } else {
    var evidence$1$proxy20__runtimeClass;
    var evidence$1$proxy20__runtimeClass = $d_Lcom_papasofokli_execution_ScrollToAnchorId.l();
    var $x_1 = x56$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$71, new $c_Lcom_papasofokli_execution_JsStatement$$anon$92(WritersVersionSpecific_this$71, $thiz), "$type", "com.papasofokli.execution.ScrollToAnchorId", "ScrollToAnchorId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy20__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x56$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x56$lzy2$4, WritersVersionSpecific_this$74) {
  return (x56$lzy2$4.i ? x56$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x56$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x56$lzy2$4, WritersVersionSpecific_this$74));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x55$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x55$lzy2$3, WritersVersionSpecific_this$75) {
  if (x55$lzy2$3.i) {
    var $x_1 = x55$lzy2$3.j;
  } else {
    var evidence$1$proxy21__runtimeClass;
    var evidence$1$proxy21__runtimeClass = $d_Lcom_papasofokli_execution_ReloadAgileBoardInDiv.l();
    var $x_1 = x55$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$75, new $c_Lcom_papasofokli_execution_JsStatement$$anon$93(WritersVersionSpecific_this$75, $thiz), "$type", "com.papasofokli.execution.ReloadAgileBoardInDiv", "ReloadAgileBoardInDiv", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy21__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x55$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x55$lzy2$4, WritersVersionSpecific_this$78) {
  return (x55$lzy2$4.i ? x55$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x55$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x55$lzy2$4, WritersVersionSpecific_this$78));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x54$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x54$lzy2$3, WritersVersionSpecific_this$79) {
  if (x54$lzy2$3.i) {
    var $x_1 = x54$lzy2$3.j;
  } else {
    var evidence$1$proxy22__runtimeClass;
    var evidence$1$proxy22__runtimeClass = $d_Lcom_papasofokli_execution_AppendChildrenToParentTree.l();
    var $x_1 = x54$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$79, new $c_Lcom_papasofokli_execution_JsStatement$$anon$94(WritersVersionSpecific_this$79, $thiz), "$type", "com.papasofokli.execution.AppendChildrenToParentTree", "AppendChildrenToParentTree", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy22__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x54$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x54$lzy2$4, WritersVersionSpecific_this$82) {
  return (x54$lzy2$4.i ? x54$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x54$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x54$lzy2$4, WritersVersionSpecific_this$82));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x53$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x53$lzy2$3, WritersVersionSpecific_this$83) {
  if (x53$lzy2$3.i) {
    var $x_1 = x53$lzy2$3.j;
  } else {
    var evidence$1$proxy25__runtimeClass;
    var evidence$1$proxy25__runtimeClass = $d_Lcom_papasofokli_execution_CalculateDropdownPosition.l();
    var $x_1 = x53$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$83, new $c_Lcom_papasofokli_execution_JsStatement$$anon$95(WritersVersionSpecific_this$83, $thiz), "$type", "com.papasofokli.execution.CalculateDropdownPosition", "CalculateDropdownPosition", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy25__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x53$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x53$lzy2$4, WritersVersionSpecific_this$86) {
  return (x53$lzy2$4.i ? x53$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x53$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x53$lzy2$4, WritersVersionSpecific_this$86));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x52$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x52$lzy2$3, WritersVersionSpecific_this$87) {
  if (x52$lzy2$3.i) {
    var $x_1 = x52$lzy2$3.j;
  } else {
    var $x_1 = x52$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$87, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$87, null), "$type", "com.papasofokli.execution.ShowModal", "ShowModal", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_execution_ShowModal$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x52$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x52$lzy2$4, WritersVersionSpecific_this$90) {
  return (x52$lzy2$4.i ? x52$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x52$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x52$lzy2$4, WritersVersionSpecific_this$90));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x51$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x51$lzy2$3, WritersVersionSpecific_this$91) {
  if (x51$lzy2$3.i) {
    var $x_1 = x51$lzy2$3.j;
  } else {
    var $x_1 = x51$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$91, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$91, null), "$type", "com.papasofokli.execution.HideModal", "HideModal", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_execution_HideModal$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x51$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x51$lzy2$4, WritersVersionSpecific_this$94) {
  return (x51$lzy2$4.i ? x51$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x51$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x51$lzy2$4, WritersVersionSpecific_this$94));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x50$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x50$lzy2$3, WritersVersionSpecific_this$95) {
  if (x50$lzy2$3.i) {
    var $x_1 = x50$lzy2$3.j;
  } else {
    var evidence$1$proxy28__runtimeClass;
    var evidence$1$proxy28__runtimeClass = $d_Lcom_papasofokli_execution_SetProgress.l();
    var $x_1 = x50$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$95, new $c_Lcom_papasofokli_execution_JsStatement$$anon$98(WritersVersionSpecific_this$95, $thiz), "$type", "com.papasofokli.execution.SetProgress", "SetProgress", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy28__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x50$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x50$lzy2$4, WritersVersionSpecific_this$98) {
  return (x50$lzy2$4.i ? x50$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x50$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x50$lzy2$4, WritersVersionSpecific_this$98));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x49$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x49$lzy2$3, WritersVersionSpecific_this$99) {
  if (x49$lzy2$3.i) {
    var $x_1 = x49$lzy2$3.j;
  } else {
    var evidence$1$proxy29__runtimeClass;
    var evidence$1$proxy29__runtimeClass = $d_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow.l();
    var $x_1 = x49$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$99, new $c_Lcom_papasofokli_execution_JsStatement$$anon$99(WritersVersionSpecific_this$99, $thiz), "$type", "com.papasofokli.execution.AddDetailPeriodsToPlannerRow", "AddDetailPeriodsToPlannerRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy29__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x49$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x49$lzy2$4, WritersVersionSpecific_this$102) {
  return (x49$lzy2$4.i ? x49$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x49$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x49$lzy2$4, WritersVersionSpecific_this$102));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x48$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x48$lzy2$3, WritersVersionSpecific_this$103) {
  if (x48$lzy2$3.i) {
    var $x_1 = x48$lzy2$3.j;
  } else {
    var evidence$1$proxy30__runtimeClass;
    var evidence$1$proxy30__runtimeClass = $d_Lcom_papasofokli_execution_HidePlanningGenerationEffect.l();
    var $x_1 = x48$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$103, new $c_Lcom_papasofokli_execution_JsStatement$$anon$100(WritersVersionSpecific_this$103, $thiz), "$type", "com.papasofokli.execution.HidePlanningGenerationEffect", "HidePlanningGenerationEffect", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy30__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x48$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x48$lzy2$4, WritersVersionSpecific_this$106) {
  return (x48$lzy2$4.i ? x48$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x48$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x48$lzy2$4, WritersVersionSpecific_this$106));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x47$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x47$lzy2$3, WritersVersionSpecific_this$107) {
  if (x47$lzy2$3.i) {
    var $x_1 = x47$lzy2$3.j;
  } else {
    var evidence$1$proxy31__runtimeClass;
    var evidence$1$proxy31__runtimeClass = $d_Lcom_papasofokli_execution_ShowPlanningGenerationEffects.l();
    var $x_1 = x47$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$107, new $c_Lcom_papasofokli_execution_JsStatement$$anon$101(WritersVersionSpecific_this$107, $thiz), "$type", "com.papasofokli.execution.ShowPlanningGenerationEffects", "ShowPlanningGenerationEffects", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy31__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x47$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x47$lzy2$4, WritersVersionSpecific_this$110) {
  return (x47$lzy2$4.i ? x47$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x47$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x47$lzy2$4, WritersVersionSpecific_this$110));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x46$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x46$lzy2$3, WritersVersionSpecific_this$111) {
  if (x46$lzy2$3.i) {
    var $x_1 = x46$lzy2$3.j;
  } else {
    var evidence$1$proxy32__runtimeClass;
    var evidence$1$proxy32__runtimeClass = $d_Lcom_papasofokli_execution_FocusPlanningPeriods.l();
    var $x_1 = x46$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$111, new $c_Lcom_papasofokli_execution_JsStatement$$anon$102(WritersVersionSpecific_this$111, $thiz), "$type", "com.papasofokli.execution.FocusPlanningPeriods", "FocusPlanningPeriods", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy32__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x46$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x46$lzy2$4, WritersVersionSpecific_this$114) {
  return (x46$lzy2$4.i ? x46$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x46$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x46$lzy2$4, WritersVersionSpecific_this$114));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x45$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x45$lzy2$3, WritersVersionSpecific_this$115) {
  if (x45$lzy2$3.i) {
    var $x_1 = x45$lzy2$3.j;
  } else {
    var evidence$1$proxy33__runtimeClass;
    var evidence$1$proxy33__runtimeClass = $d_Lcom_papasofokli_execution_UndoHighlightTimePeriod.l();
    var $x_1 = x45$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$115, new $c_Lcom_papasofokli_execution_JsStatement$$anon$103(WritersVersionSpecific_this$115, $thiz), "$type", "com.papasofokli.execution.UndoHighlightTimePeriod", "UndoHighlightTimePeriod", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy33__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x45$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x45$lzy2$4, WritersVersionSpecific_this$118) {
  return (x45$lzy2$4.i ? x45$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x45$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x45$lzy2$4, WritersVersionSpecific_this$118));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x44$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x44$lzy2$3, WritersVersionSpecific_this$119) {
  if (x44$lzy2$3.i) {
    var $x_1 = x44$lzy2$3.j;
  } else {
    var evidence$1$proxy34__runtimeClass;
    var evidence$1$proxy34__runtimeClass = $d_Lcom_papasofokli_execution_HighlightTimePeriod.l();
    var $x_1 = x44$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$119, new $c_Lcom_papasofokli_execution_JsStatement$$anon$104(WritersVersionSpecific_this$119, $thiz), "$type", "com.papasofokli.execution.HighlightTimePeriod", "HighlightTimePeriod", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy34__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x44$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x44$lzy2$4, WritersVersionSpecific_this$122) {
  return (x44$lzy2$4.i ? x44$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x44$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x44$lzy2$4, WritersVersionSpecific_this$122));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x43$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x43$lzy2$3, WritersVersionSpecific_this$123) {
  if (x43$lzy2$3.i) {
    var $x_1 = x43$lzy2$3.j;
  } else {
    var evidence$1$proxy35__runtimeClass;
    var evidence$1$proxy35__runtimeClass = $d_Lcom_papasofokli_execution_AddPeriodsToSubject.l();
    var $x_1 = x43$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$123, new $c_Lcom_papasofokli_execution_JsStatement$$anon$105(WritersVersionSpecific_this$123, $thiz), "$type", "com.papasofokli.execution.AddPeriodsToSubject", "AddPeriodsToSubject", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy35__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x43$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x43$lzy2$4, WritersVersionSpecific_this$126) {
  return (x43$lzy2$4.i ? x43$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x43$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x43$lzy2$4, WritersVersionSpecific_this$126));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x42$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x42$lzy2$3, WritersVersionSpecific_this$127) {
  if (x42$lzy2$3.i) {
    var $x_1 = x42$lzy2$3.j;
  } else {
    var evidence$1$proxy36__runtimeClass;
    var evidence$1$proxy36__runtimeClass = $d_Lcom_papasofokli_execution_AddPeriodsToPlannerRow.l();
    var $x_1 = x42$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$127, new $c_Lcom_papasofokli_execution_JsStatement$$anon$106(WritersVersionSpecific_this$127, $thiz), "$type", "com.papasofokli.execution.AddPeriodsToPlannerRow", "AddPeriodsToPlannerRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy36__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x42$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x42$lzy2$4, WritersVersionSpecific_this$130) {
  return (x42$lzy2$4.i ? x42$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x42$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x42$lzy2$4, WritersVersionSpecific_this$130));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x41$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x41$lzy2$3, WritersVersionSpecific_this$131) {
  if (x41$lzy2$3.i) {
    var $x_1 = x41$lzy2$3.j;
  } else {
    var evidence$1$proxy37__runtimeClass;
    var evidence$1$proxy37__runtimeClass = $d_Lcom_papasofokli_execution_CleanDetailPlannerRow.l();
    var $x_1 = x41$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$131, new $c_Lcom_papasofokli_execution_JsStatement$$anon$107(WritersVersionSpecific_this$131, $thiz), "$type", "com.papasofokli.execution.CleanDetailPlannerRow", "CleanDetailPlannerRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy37__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x41$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x41$lzy2$4, WritersVersionSpecific_this$134) {
  return (x41$lzy2$4.i ? x41$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x41$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x41$lzy2$4, WritersVersionSpecific_this$134));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x40$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x40$lzy2$3, WritersVersionSpecific_this$135) {
  if (x40$lzy2$3.i) {
    var $x_1 = x40$lzy2$3.j;
  } else {
    var evidence$1$proxy38__runtimeClass;
    var evidence$1$proxy38__runtimeClass = $d_Lcom_papasofokli_execution_CleanPlannerRow.l();
    var $x_1 = x40$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$135, new $c_Lcom_papasofokli_execution_JsStatement$$anon$108(WritersVersionSpecific_this$135, $thiz), "$type", "com.papasofokli.execution.CleanPlannerRow", "CleanPlannerRow", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy38__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x40$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x40$lzy2$4, WritersVersionSpecific_this$138) {
  return (x40$lzy2$4.i ? x40$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x40$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x40$lzy2$4, WritersVersionSpecific_this$138));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x39$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x39$lzy2$3, WritersVersionSpecific_this$139) {
  if (x39$lzy2$3.i) {
    var $x_1 = x39$lzy2$3.j;
  } else {
    var evidence$1$proxy39__runtimeClass;
    var evidence$1$proxy39__runtimeClass = $d_Lcom_papasofokli_execution_ResizeSidebarForPlanner.l();
    var $x_1 = x39$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$139, new $c_Lcom_papasofokli_execution_JsStatement$$anon$109(WritersVersionSpecific_this$139, $thiz), "$type", "com.papasofokli.execution.ResizeSidebarForPlanner", "ResizeSidebarForPlanner", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy39__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x39$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x39$lzy2$4, WritersVersionSpecific_this$142) {
  return (x39$lzy2$4.i ? x39$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x39$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x39$lzy2$4, WritersVersionSpecific_this$142));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x38$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x38$lzy2$3, WritersVersionSpecific_this$143) {
  if (x38$lzy2$3.i) {
    var $x_1 = x38$lzy2$3.j;
  } else {
    var evidence$1$proxy40__runtimeClass;
    var evidence$1$proxy40__runtimeClass = $d_Lcom_papasofokli_execution_ShowSidebarForPlanner.l();
    var $x_1 = x38$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$143, new $c_Lcom_papasofokli_execution_JsStatement$$anon$110(WritersVersionSpecific_this$143, $thiz), "$type", "com.papasofokli.execution.ShowSidebarForPlanner", "ShowSidebarForPlanner", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy40__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x38$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x38$lzy2$4, WritersVersionSpecific_this$146) {
  return (x38$lzy2$4.i ? x38$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x38$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x38$lzy2$4, WritersVersionSpecific_this$146));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x37$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x37$lzy2$3, WritersVersionSpecific_this$147) {
  if (x37$lzy2$3.i) {
    var $x_1 = x37$lzy2$3.j;
  } else {
    var evidence$1$proxy41__runtimeClass;
    var evidence$1$proxy41__runtimeClass = $d_Lcom_papasofokli_execution_ClickOnId.l();
    var $x_1 = x37$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$147, new $c_Lcom_papasofokli_execution_JsStatement$$anon$111(WritersVersionSpecific_this$147, $thiz), "$type", "com.papasofokli.execution.ClickOnId", "ClickOnId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy41__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x37$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x37$lzy2$4, WritersVersionSpecific_this$150) {
  return (x37$lzy2$4.i ? x37$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x37$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x37$lzy2$4, WritersVersionSpecific_this$150));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x36$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x36$lzy2$3, WritersVersionSpecific_this$151) {
  if (x36$lzy2$3.i) {
    var $x_1 = x36$lzy2$3.j;
  } else {
    var evidence$1$proxy42__runtimeClass;
    var evidence$1$proxy42__runtimeClass = $d_Lcom_papasofokli_execution_ShrinkModal.l();
    var $x_1 = x36$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$151, new $c_Lcom_papasofokli_execution_JsStatement$$anon$112(WritersVersionSpecific_this$151, $thiz), "$type", "com.papasofokli.execution.ShrinkModal", "ShrinkModal", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy42__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x36$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x36$lzy2$4, WritersVersionSpecific_this$154) {
  return (x36$lzy2$4.i ? x36$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x36$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x36$lzy2$4, WritersVersionSpecific_this$154));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x35$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x35$lzy2$3, WritersVersionSpecific_this$155) {
  if (x35$lzy2$3.i) {
    var $x_1 = x35$lzy2$3.j;
  } else {
    var evidence$1$proxy43__runtimeClass;
    var evidence$1$proxy43__runtimeClass = $d_Lcom_papasofokli_execution_ExpandModal.l();
    var $x_1 = x35$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$155, new $c_Lcom_papasofokli_execution_JsStatement$$anon$113(WritersVersionSpecific_this$155, $thiz), "$type", "com.papasofokli.execution.ExpandModal", "ExpandModal", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy43__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x35$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x35$lzy2$4, WritersVersionSpecific_this$158) {
  return (x35$lzy2$4.i ? x35$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x35$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x35$lzy2$4, WritersVersionSpecific_this$158));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x34$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x34$lzy2$3, WritersVersionSpecific_this$159) {
  if (x34$lzy2$3.i) {
    var $x_1 = x34$lzy2$3.j;
  } else {
    var evidence$1$proxy44__runtimeClass;
    var evidence$1$proxy44__runtimeClass = $d_Lcom_papasofokli_execution_OnShownModal.l();
    var $x_1 = x34$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$159, new $c_Lcom_papasofokli_execution_JsStatement$$anon$114(WritersVersionSpecific_this$159, $thiz), "$type", "com.papasofokli.execution.OnShownModal", "OnShownModal", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy44__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x34$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x34$lzy2$4, WritersVersionSpecific_this$162) {
  return (x34$lzy2$4.i ? x34$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x34$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x34$lzy2$4, WritersVersionSpecific_this$162));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x33$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x33$lzy2$3, WritersVersionSpecific_this$163) {
  if (x33$lzy2$3.i) {
    var $x_1 = x33$lzy2$3.j;
  } else {
    var evidence$1$proxy45__runtimeClass;
    var evidence$1$proxy45__runtimeClass = $d_Lcom_papasofokli_execution_OnCloseModal.l();
    var $x_1 = x33$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$163, new $c_Lcom_papasofokli_execution_JsStatement$$anon$115(WritersVersionSpecific_this$163, $thiz), "$type", "com.papasofokli.execution.OnCloseModal", "OnCloseModal", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy45__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x33$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x33$lzy2$4, WritersVersionSpecific_this$166) {
  return (x33$lzy2$4.i ? x33$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x33$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x33$lzy2$4, WritersVersionSpecific_this$166));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x32$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x32$lzy2$3, WritersVersionSpecific_this$167) {
  if (x32$lzy2$3.i) {
    var $x_1 = x32$lzy2$3.j;
  } else {
    var evidence$1$proxy46__runtimeClass;
    var evidence$1$proxy46__runtimeClass = $d_Lcom_papasofokli_execution_ReplaceElementWithId.l();
    var $x_1 = x32$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$167, new $c_Lcom_papasofokli_execution_JsStatement$$anon$116(WritersVersionSpecific_this$167, $thiz), "$type", "com.papasofokli.execution.ReplaceElementWithId", "ReplaceElementWithId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy46__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x32$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x32$lzy2$4, WritersVersionSpecific_this$170) {
  return (x32$lzy2$4.i ? x32$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x32$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x32$lzy2$4, WritersVersionSpecific_this$170));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x31$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x31$lzy2$3, WritersVersionSpecific_this$171) {
  if (x31$lzy2$3.i) {
    var $x_1 = x31$lzy2$3.j;
  } else {
    var evidence$1$proxy47__runtimeClass;
    var evidence$1$proxy47__runtimeClass = $d_Lcom_papasofokli_execution_AppendElementWithId.l();
    var $x_1 = x31$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$171, new $c_Lcom_papasofokli_execution_JsStatement$$anon$117(WritersVersionSpecific_this$171, $thiz), "$type", "com.papasofokli.execution.AppendElementWithId", "AppendElementWithId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy47__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x31$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x31$lzy2$4, WritersVersionSpecific_this$174) {
  return (x31$lzy2$4.i ? x31$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x31$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x31$lzy2$4, WritersVersionSpecific_this$174));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x30$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x30$lzy2$3, WritersVersionSpecific_this$175) {
  if (x30$lzy2$3.i) {
    var $x_1 = x30$lzy2$3.j;
  } else {
    var evidence$1$proxy48__runtimeClass;
    var evidence$1$proxy48__runtimeClass = $d_Lcom_papasofokli_execution_PrependElementWithId.l();
    var $x_1 = x30$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$175, new $c_Lcom_papasofokli_execution_JsStatement$$anon$118(WritersVersionSpecific_this$175, $thiz), "$type", "com.papasofokli.execution.PrependElementWithId", "PrependElementWithId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy48__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x30$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x30$lzy2$4, WritersVersionSpecific_this$178) {
  return (x30$lzy2$4.i ? x30$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x30$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x30$lzy2$4, WritersVersionSpecific_this$178));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x29$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x29$lzy2$3, WritersVersionSpecific_this$179) {
  if (x29$lzy2$3.i) {
    var $x_1 = x29$lzy2$3.j;
  } else {
    var evidence$1$proxy49__runtimeClass;
    var evidence$1$proxy49__runtimeClass = $d_Lcom_papasofokli_execution_ReplaceElementContents.l();
    var $x_1 = x29$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$179, new $c_Lcom_papasofokli_execution_JsStatement$$anon$119(WritersVersionSpecific_this$179, $thiz), "$type", "com.papasofokli.execution.ReplaceElementContents", "ReplaceElementContents", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy49__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x29$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x29$lzy2$4, WritersVersionSpecific_this$182) {
  return (x29$lzy2$4.i ? x29$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x29$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x29$lzy2$4, WritersVersionSpecific_this$182));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x28$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x28$lzy2$3, WritersVersionSpecific_this$183) {
  if (x28$lzy2$3.i) {
    var $x_1 = x28$lzy2$3.j;
  } else {
    var evidence$1$proxy50__runtimeClass;
    var evidence$1$proxy50__runtimeClass = $d_Lcom_papasofokli_execution_AdjustPlannerComponentHeight.l();
    var $x_1 = x28$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$183, new $c_Lcom_papasofokli_execution_JsStatement$$anon$120(WritersVersionSpecific_this$183, $thiz), "$type", "com.papasofokli.execution.AdjustPlannerComponentHeight", "AdjustPlannerComponentHeight", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy50__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x28$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x28$lzy2$4, WritersVersionSpecific_this$186) {
  return (x28$lzy2$4.i ? x28$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x28$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x28$lzy2$4, WritersVersionSpecific_this$186));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x27$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x27$lzy2$3, WritersVersionSpecific_this$187) {
  if (x27$lzy2$3.i) {
    var $x_1 = x27$lzy2$3.j;
  } else {
    var evidence$1$proxy51__runtimeClass;
    var evidence$1$proxy51__runtimeClass = $d_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv.l();
    var $x_1 = x27$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$187, new $c_Lcom_papasofokli_execution_JsStatement$$anon$121(WritersVersionSpecific_this$187, $thiz), "$type", "com.papasofokli.execution.ReloadPlannerComponentInDiv", "ReloadPlannerComponentInDiv", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy51__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x27$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x27$lzy2$4, WritersVersionSpecific_this$190) {
  return (x27$lzy2$4.i ? x27$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x27$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x27$lzy2$4, WritersVersionSpecific_this$190));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x26$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x26$lzy2$3, WritersVersionSpecific_this$191) {
  if (x26$lzy2$3.i) {
    var $x_1 = x26$lzy2$3.j;
  } else {
    var evidence$1$proxy52__runtimeClass;
    var evidence$1$proxy52__runtimeClass = $d_Lcom_papasofokli_execution_RedirectPageToHref.l();
    var $x_1 = x26$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$191, new $c_Lcom_papasofokli_execution_JsStatement$$anon$122(WritersVersionSpecific_this$191, $thiz), "$type", "com.papasofokli.execution.RedirectPageToHref", "RedirectPageToHref", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy52__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x26$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x26$lzy2$4, WritersVersionSpecific_this$194) {
  return (x26$lzy2$4.i ? x26$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x26$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x26$lzy2$4, WritersVersionSpecific_this$194));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x25$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x25$lzy2$3, WritersVersionSpecific_this$195) {
  if (x25$lzy2$3.i) {
    var $x_1 = x25$lzy2$3.j;
  } else {
    var evidence$1$proxy53__runtimeClass;
    var evidence$1$proxy53__runtimeClass = $d_Lcom_papasofokli_execution_OpenPrinterCashbox.l();
    var $x_1 = x25$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$195, new $c_Lcom_papasofokli_execution_JsStatement$$anon$123(WritersVersionSpecific_this$195, $thiz), "$type", "com.papasofokli.execution.OpenPrinterCashbox", "OpenPrinterCashbox", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy53__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x25$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x25$lzy2$4, WritersVersionSpecific_this$198) {
  return (x25$lzy2$4.i ? x25$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x25$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x25$lzy2$4, WritersVersionSpecific_this$198));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x24$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x24$lzy2$3, WritersVersionSpecific_this$199) {
  if (x24$lzy2$3.i) {
    var $x_1 = x24$lzy2$3.j;
  } else {
    var evidence$1$proxy54__runtimeClass;
    var evidence$1$proxy54__runtimeClass = $d_Lcom_papasofokli_execution_PrintReceiptBytes.l();
    var $x_1 = x24$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$199, new $c_Lcom_papasofokli_execution_JsStatement$$anon$124(WritersVersionSpecific_this$199, $thiz), "$type", "com.papasofokli.execution.PrintReceiptBytes", "PrintReceiptBytes", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy54__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x24$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x24$lzy2$4, WritersVersionSpecific_this$202) {
  return (x24$lzy2$4.i ? x24$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x24$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x24$lzy2$4, WritersVersionSpecific_this$202));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x23$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x23$lzy2$3, WritersVersionSpecific_this$203) {
  if (x23$lzy2$3.i) {
    var $x_1 = x23$lzy2$3.j;
  } else {
    var evidence$1$proxy55__runtimeClass;
    var evidence$1$proxy55__runtimeClass = $d_Lcom_papasofokli_execution_DownloadFile.l();
    var $x_1 = x23$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$203, new $c_Lcom_papasofokli_execution_JsStatement$$anon$125(WritersVersionSpecific_this$203, $thiz), "$type", "com.papasofokli.execution.DownloadFile", "DownloadFile", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy55__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x23$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x23$lzy2$4, WritersVersionSpecific_this$206) {
  return (x23$lzy2$4.i ? x23$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x23$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x23$lzy2$4, WritersVersionSpecific_this$206));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x22$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x22$lzy2$3, WritersVersionSpecific_this$207) {
  if (x22$lzy2$3.i) {
    var $x_1 = x22$lzy2$3.j;
  } else {
    var evidence$1$proxy56__runtimeClass;
    var evidence$1$proxy56__runtimeClass = $d_Lcom_papasofokli_execution_ToggleNotificationDropdown.l();
    var $x_1 = x22$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$207, new $c_Lcom_papasofokli_execution_JsStatement$$anon$126(WritersVersionSpecific_this$207, $thiz), "$type", "com.papasofokli.execution.ToggleNotificationDropdown", "ToggleNotificationDropdown", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy56__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x22$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x22$lzy2$4, WritersVersionSpecific_this$210) {
  return (x22$lzy2$4.i ? x22$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x22$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x22$lzy2$4, WritersVersionSpecific_this$210));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x21$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x21$lzy2$3, WritersVersionSpecific_this$211) {
  if (x21$lzy2$3.i) {
    var $x_1 = x21$lzy2$3.j;
  } else {
    var evidence$1$proxy57__runtimeClass;
    var evidence$1$proxy57__runtimeClass = $d_Lcom_papasofokli_execution_UpdateIconNotification.l();
    var $x_1 = x21$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$211, new $c_Lcom_papasofokli_execution_JsStatement$$anon$127(WritersVersionSpecific_this$211, $thiz), "$type", "com.papasofokli.execution.UpdateIconNotification", "UpdateIconNotification", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy57__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x21$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x21$lzy2$4, WritersVersionSpecific_this$214) {
  return (x21$lzy2$4.i ? x21$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x21$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x21$lzy2$4, WritersVersionSpecific_this$214));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x20$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x20$lzy2$3, WritersVersionSpecific_this$215) {
  if (x20$lzy2$3.i) {
    var $x_1 = x20$lzy2$3.j;
  } else {
    var evidence$1$proxy58__runtimeClass;
    var evidence$1$proxy58__runtimeClass = $d_Lcom_papasofokli_execution_ShowHideNavSidebar.l();
    var $x_1 = x20$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$215, new $c_Lcom_papasofokli_execution_JsStatement$$anon$128(WritersVersionSpecific_this$215, $thiz), "$type", "com.papasofokli.execution.ShowHideNavSidebar", "ShowHideNavSidebar", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy58__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x20$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x20$lzy2$4, WritersVersionSpecific_this$218) {
  return (x20$lzy2$4.i ? x20$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x20$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x20$lzy2$4, WritersVersionSpecific_this$218));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x19$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x19$lzy2$3, WritersVersionSpecific_this$219) {
  if (x19$lzy2$3.i) {
    var $x_1 = x19$lzy2$3.j;
  } else {
    var evidence$1$proxy59__runtimeClass;
    var evidence$1$proxy59__runtimeClass = $d_Lcom_papasofokli_execution_HttpRedirect.l();
    var $x_1 = x19$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$219, new $c_Lcom_papasofokli_execution_JsStatement$$anon$129(WritersVersionSpecific_this$219, $thiz), "$type", "com.papasofokli.execution.HttpRedirect", "HttpRedirect", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy59__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x19$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x19$lzy2$4, WritersVersionSpecific_this$222) {
  return (x19$lzy2$4.i ? x19$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x19$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x19$lzy2$4, WritersVersionSpecific_this$222));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x18$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x18$lzy2$3, WritersVersionSpecific_this$223) {
  if (x18$lzy2$3.i) {
    var $x_1 = x18$lzy2$3.j;
  } else {
    var evidence$1$proxy60__runtimeClass;
    var evidence$1$proxy60__runtimeClass = $d_Lcom_papasofokli_execution_NavigateTo.l();
    var $x_1 = x18$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$223, new $c_Lcom_papasofokli_execution_JsStatement$$anon$130(WritersVersionSpecific_this$223, $thiz), "$type", "com.papasofokli.execution.NavigateTo", "NavigateTo", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy60__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x18$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x18$lzy2$4, WritersVersionSpecific_this$226) {
  return (x18$lzy2$4.i ? x18$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x18$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x18$lzy2$4, WritersVersionSpecific_this$226));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x17$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x17$lzy2$3, WritersVersionSpecific_this$227) {
  if (x17$lzy2$3.i) {
    var $x_1 = x17$lzy2$3.j;
  } else {
    var evidence$1$proxy61__runtimeClass;
    var evidence$1$proxy61__runtimeClass = $d_Lcom_papasofokli_execution_ChangeTitleTo.l();
    var $x_1 = x17$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$227, new $c_Lcom_papasofokli_execution_JsStatement$$anon$131(WritersVersionSpecific_this$227, $thiz), "$type", "com.papasofokli.execution.ChangeTitleTo", "ChangeTitleTo", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy61__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x17$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x17$lzy2$4, WritersVersionSpecific_this$230) {
  return (x17$lzy2$4.i ? x17$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x17$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x17$lzy2$4, WritersVersionSpecific_this$230));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x16$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x16$lzy2$3, WritersVersionSpecific_this$231) {
  if (x16$lzy2$3.i) {
    var $x_1 = x16$lzy2$3.j;
  } else {
    var evidence$1$proxy62__runtimeClass;
    var evidence$1$proxy62__runtimeClass = $d_Lcom_papasofokli_execution_ChangeUrlTo.l();
    var $x_1 = x16$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$231, new $c_Lcom_papasofokli_execution_JsStatement$$anon$132(WritersVersionSpecific_this$231, $thiz), "$type", "com.papasofokli.execution.ChangeUrlTo", "ChangeUrlTo", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy62__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x16$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x16$lzy2$4, WritersVersionSpecific_this$234) {
  return (x16$lzy2$4.i ? x16$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x16$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x16$lzy2$4, WritersVersionSpecific_this$234));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x15$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x15$lzy2$3, WritersVersionSpecific_this$235) {
  if (x15$lzy2$3.i) {
    var $x_1 = x15$lzy2$3.j;
  } else {
    var evidence$1$proxy63__runtimeClass;
    var evidence$1$proxy63__runtimeClass = $d_Lcom_papasofokli_execution_OpenUrl.l();
    var $x_1 = x15$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$235, new $c_Lcom_papasofokli_execution_JsStatement$$anon$133(WritersVersionSpecific_this$235, $thiz), "$type", "com.papasofokli.execution.OpenUrl", "OpenUrl", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy63__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x15$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x15$lzy2$4, WritersVersionSpecific_this$238) {
  return (x15$lzy2$4.i ? x15$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x15$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x15$lzy2$4, WritersVersionSpecific_this$238));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x14$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x14$lzy2$3, WritersVersionSpecific_this$239) {
  if (x14$lzy2$3.i) {
    var $x_1 = x14$lzy2$3.j;
  } else {
    var evidence$1$proxy64__runtimeClass;
    var evidence$1$proxy64__runtimeClass = $d_Lcom_papasofokli_execution_ReplaceContentsByClassWith.l();
    var $x_1 = x14$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$239, new $c_Lcom_papasofokli_execution_JsStatement$$anon$134(WritersVersionSpecific_this$239, $thiz), "$type", "com.papasofokli.execution.ReplaceContentsByClassWith", "ReplaceContentsByClassWith", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy64__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x14$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x14$lzy2$4, WritersVersionSpecific_this$242) {
  return (x14$lzy2$4.i ? x14$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x14$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x14$lzy2$4, WritersVersionSpecific_this$242));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x13$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x13$lzy2$3, WritersVersionSpecific_this$243) {
  if (x13$lzy2$3.i) {
    var $x_1 = x13$lzy2$3.j;
  } else {
    var evidence$1$proxy65__runtimeClass;
    var evidence$1$proxy65__runtimeClass = $d_Lcom_papasofokli_execution_ReplaceAnchorContents.l();
    var $x_1 = x13$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$243, new $c_Lcom_papasofokli_execution_JsStatement$$anon$135(WritersVersionSpecific_this$243, $thiz), "$type", "com.papasofokli.execution.ReplaceAnchorContents", "ReplaceAnchorContents", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy65__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x13$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x13$lzy2$4, WritersVersionSpecific_this$246) {
  return (x13$lzy2$4.i ? x13$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x13$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x13$lzy2$4, WritersVersionSpecific_this$246));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x12$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x12$lzy2$3, WritersVersionSpecific_this$247) {
  if (x12$lzy2$3.i) {
    var $x_1 = x12$lzy2$3.j;
  } else {
    var evidence$1$proxy66__runtimeClass;
    var evidence$1$proxy66__runtimeClass = $d_Lcom_papasofokli_execution_ReplaceAnchorWithId.l();
    var $x_1 = x12$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$247, new $c_Lcom_papasofokli_execution_JsStatement$$anon$136(WritersVersionSpecific_this$247, $thiz), "$type", "com.papasofokli.execution.ReplaceAnchorWithId", "ReplaceAnchorWithId", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy66__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x12$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x12$lzy2$4, WritersVersionSpecific_this$250) {
  return (x12$lzy2$4.i ? x12$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x12$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x12$lzy2$4, WritersVersionSpecific_this$250));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x11$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x11$lzy2$3, WritersVersionSpecific_this$251) {
  if (x11$lzy2$3.i) {
    var $x_1 = x11$lzy2$3.j;
  } else {
    var evidence$1$proxy67__runtimeClass;
    var evidence$1$proxy67__runtimeClass = $d_Lcom_papasofokli_execution_ReloadTable.l();
    var $x_1 = x11$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$251, new $c_Lcom_papasofokli_execution_JsStatement$$anon$137(WritersVersionSpecific_this$251, $thiz), "$type", "com.papasofokli.execution.ReloadTable", "ReloadTable", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy67__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x11$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x11$lzy2$4, WritersVersionSpecific_this$254) {
  return (x11$lzy2$4.i ? x11$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x11$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x11$lzy2$4, WritersVersionSpecific_this$254));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x10$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x10$lzy2$3, WritersVersionSpecific_this$255) {
  if (x10$lzy2$3.i) {
    var $x_1 = x10$lzy2$3.j;
  } else {
    var evidence$1$proxy68__runtimeClass;
    var evidence$1$proxy68__runtimeClass = $d_Lcom_papasofokli_execution_UpdateValidation.l();
    var $x_1 = x10$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$255, new $c_Lcom_papasofokli_execution_JsStatement$$anon$138(WritersVersionSpecific_this$255, $thiz), "$type", "com.papasofokli.execution.UpdateValidation", "UpdateValidation", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy68__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x10$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x10$lzy2$4, WritersVersionSpecific_this$258) {
  return (x10$lzy2$4.i ? x10$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x10$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x10$lzy2$4, WritersVersionSpecific_this$258));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x9$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x9$lzy2$3, WritersVersionSpecific_this$259) {
  if (x9$lzy2$3.i) {
    var $x_1 = x9$lzy2$3.j;
  } else {
    var evidence$1$proxy69__runtimeClass;
    var evidence$1$proxy69__runtimeClass = $d_Lcom_papasofokli_execution_ResetPayrollTree.l();
    var $x_1 = x9$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$259, new $c_Lcom_papasofokli_execution_JsStatement$$anon$139(WritersVersionSpecific_this$259, $thiz), "$type", "com.papasofokli.execution.ResetPayrollTree", "ResetPayrollTree", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy69__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x9$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x9$lzy2$4, WritersVersionSpecific_this$262) {
  return (x9$lzy2$4.i ? x9$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x9$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x9$lzy2$4, WritersVersionSpecific_this$262));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x8$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x8$lzy2$3, WritersVersionSpecific_this$263) {
  if (x8$lzy2$3.i) {
    var $x_1 = x8$lzy2$3.j;
  } else {
    var evidence$1$proxy70__runtimeClass;
    var evidence$1$proxy70__runtimeClass = $d_Lcom_papasofokli_execution_PayrollTreeLoadData.l();
    var $x_1 = x8$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$263, new $c_Lcom_papasofokli_execution_JsStatement$$anon$140(WritersVersionSpecific_this$263, $thiz), "$type", "com.papasofokli.execution.PayrollTreeLoadData", "PayrollTreeLoadData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy70__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x8$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x8$lzy2$4, WritersVersionSpecific_this$266) {
  return (x8$lzy2$4.i ? x8$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x8$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x8$lzy2$4, WritersVersionSpecific_this$266));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x7$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x7$lzy2$3, WritersVersionSpecific_this$267) {
  if (x7$lzy2$3.i) {
    var $x_1 = x7$lzy2$3.j;
  } else {
    var evidence$1$proxy71__runtimeClass;
    var evidence$1$proxy71__runtimeClass = $d_Lcom_papasofokli_execution_HidePlanningPeriodChanges.l();
    var $x_1 = x7$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$267, new $c_Lcom_papasofokli_execution_JsStatement$$anon$141(WritersVersionSpecific_this$267, $thiz), "$type", "com.papasofokli.execution.HidePlanningPeriodChanges", "HidePlanningPeriodChanges", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy71__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x7$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x7$lzy2$4, WritersVersionSpecific_this$270) {
  return (x7$lzy2$4.i ? x7$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x7$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x7$lzy2$4, WritersVersionSpecific_this$270));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x6$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x6$lzy2$3, WritersVersionSpecific_this$271) {
  if (x6$lzy2$3.i) {
    var $x_1 = x6$lzy2$3.j;
  } else {
    var evidence$1$proxy72__runtimeClass;
    var evidence$1$proxy72__runtimeClass = $d_Lcom_papasofokli_execution_ShowPlanningPeriodChanges.l();
    var $x_1 = x6$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$271, new $c_Lcom_papasofokli_execution_JsStatement$$anon$142(WritersVersionSpecific_this$271, $thiz), "$type", "com.papasofokli.execution.ShowPlanningPeriodChanges", "ShowPlanningPeriodChanges", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy72__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x6$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x6$lzy2$4, WritersVersionSpecific_this$274) {
  return (x6$lzy2$4.i ? x6$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x6$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x6$lzy2$4, WritersVersionSpecific_this$274));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x5$lzy2$3, WritersVersionSpecific_this$275) {
  if (x5$lzy2$3.i) {
    var $x_1 = x5$lzy2$3.j;
  } else {
    var evidence$1$proxy73__runtimeClass;
    var evidence$1$proxy73__runtimeClass = $d_Lcom_papasofokli_execution_ModifyPeriods.l();
    var $x_1 = x5$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$275, new $c_Lcom_papasofokli_execution_JsStatement$$anon$143(WritersVersionSpecific_this$275, $thiz), "$type", "com.papasofokli.execution.ModifyPeriods", "ModifyPeriods", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy73__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x5$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x5$lzy2$4, WritersVersionSpecific_this$278) {
  return (x5$lzy2$4.i ? x5$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x5$lzy2$4, WritersVersionSpecific_this$278));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$3, WritersVersionSpecific_this$279) {
  if (x4$lzy2$3.i) {
    var $x_1 = x4$lzy2$3.j;
  } else {
    var evidence$1$proxy74__runtimeClass;
    var evidence$1$proxy74__runtimeClass = $d_Lcom_papasofokli_execution_SetRightDivSize.l();
    var $x_1 = x4$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$279, new $c_Lcom_papasofokli_execution_JsStatement$$anon$144(WritersVersionSpecific_this$279, $thiz), "$type", "com.papasofokli.execution.SetRightDivSize", "SetRightDivSize", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy74__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$282) {
  return (x4$lzy2$4.i ? x4$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$282));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$3, WritersVersionSpecific_this$283) {
  if (x3$lzy2$3.i) {
    var $x_1 = x3$lzy2$3.j;
  } else {
    var evidence$1$proxy75__runtimeClass;
    var evidence$1$proxy75__runtimeClass = $d_Lcom_papasofokli_execution_ToggleClassFromElement.l();
    var $x_1 = x3$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$283, new $c_Lcom_papasofokli_execution_JsStatement$$anon$145(WritersVersionSpecific_this$283, $thiz), "$type", "com.papasofokli.execution.ToggleClassFromElement", "ToggleClassFromElement", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy75__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$286) {
  return (x3$lzy2$4.i ? x3$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$286));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$287) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var evidence$1$proxy76__runtimeClass;
    var evidence$1$proxy76__runtimeClass = $d_Lcom_papasofokli_execution_RemoveClassFromElement.l();
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$287, new $c_Lcom_papasofokli_execution_JsStatement$$anon$146(WritersVersionSpecific_this$287, $thiz), "$type", "com.papasofokli.execution.RemoveClassFromElement", "RemoveClassFromElement", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy76__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$290) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$290));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$291) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy77__runtimeClass;
    var evidence$1$proxy77__runtimeClass = $d_Lcom_papasofokli_execution_AddClassToElement.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$291, new $c_Lcom_papasofokli_execution_JsStatement$$anon$147(WritersVersionSpecific_this$291, $thiz), "$type", "com.papasofokli.execution.AddClassToElement", "AddClassToElement", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy77__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$294) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$294));
}
function $p_Lcom_papasofokli_execution_JsStatement$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$295) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy78__runtimeClass;
    var evidence$1$proxy78__runtimeClass = $d_Lcom_papasofokli_execution_InitializeTab.l();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$295, new $c_Lcom_papasofokli_execution_JsStatement$$anon$148(WritersVersionSpecific_this$295, $thiz), "$type", "com.papasofokli.execution.InitializeTab", "InitializeTab", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy78__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_execution_JsStatement$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$298) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_execution_JsStatement$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$298));
}
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$() {
  this.Yr = null;
  this.Ys = false;
}
$p = $c_Lcom_papasofokli_execution_JsStatement$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$() {
}
$h_Lcom_papasofokli_execution_JsStatement$.prototype = $p;
$p.q = (function() {
  if ((!this.Ys)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.Yr = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_execution_JsStatement$__x74$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_execution_JsStatement$__x74$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.Ys = true;
  }
  return this.Yr;
});
$p.aot = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apr = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_TableSortColumn(params$2.a[0], (params$2.a[1] | 0), params$2.a[2])));
});
$p.apC = (function(ReadersVersionSpecific_this$10) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apN = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_TableGroupColumn(params$2.a[0], (params$2.a[1] | 0))));
});
$p.apY = (function(ReadersVersionSpecific_this$15) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aq9 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ResetScanner(params$2.a[0])));
});
$p.aqk = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqv = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column(params$2.a[0], (params$2.a[1] | 0), params$2.a[2])));
});
$p.aqG = (function(ReadersVersionSpecific_this$25) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aou = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_execution_InvalidPrintServerUUID$()));
});
$p.aoF = (function(ReadersVersionSpecific_this$30) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoQ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_CollapseTableRow(params$2.a[0], params$2.a[1])));
});
$p.ap1 = (function(ReadersVersionSpecific_this$35) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apc = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AddTableRow(params$2.a[0], (params$2.a[1] | 0), (params$2.a[2] | 0), params$2.a[3], (!(!params$2.a[4])))));
});
$p.apm = (function(ReadersVersionSpecific_this$40) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apn = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_CopyTextToClipboard(params$2.a[0])));
});
$p.apo = (function(ReadersVersionSpecific_this$45) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.app = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SignaturePadClear(params$2.a[0])));
});
$p.apq = (function(ReadersVersionSpecific_this$50) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aps = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SignaturePadToDataURL(params$2.a[0])));
});
$p.apt = (function(ReadersVersionSpecific_this$55) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apu = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_FocusInput(params$2.a[0])));
});
$p.apv = (function(ReadersVersionSpecific_this$60) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apw = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SelectInputDisable(params$2.a[0])));
});
$p.apx = (function(ReadersVersionSpecific_this$65) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apy = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SelectInputEnable(params$2.a[0])));
});
$p.apz = (function(ReadersVersionSpecific_this$70) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apA = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_RemoveElementChildren(params$2.a[0])));
});
$p.apB = (function(ReadersVersionSpecific_this$75) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apD = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_RemoveAttributeFromElement(params$2.a[0], params$2.a[1], params$2.a[2])));
});
$p.apE = (function(ReadersVersionSpecific_this$80) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apF = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AddAttributeToElement(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
$p.apG = (function(ReadersVersionSpecific_this$85) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apH = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_PopoverHide(params$2.a[0])));
});
$p.apI = (function(ReadersVersionSpecific_this$90) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apJ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ScrollToAnchorId(params$2.a[0], (!(!params$2.a[1])))));
});
$p.apK = (function(ReadersVersionSpecific_this$95) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apL = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv(params$2.a[0])));
});
$p.apM = (function(ReadersVersionSpecific_this$100) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apO = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AppendChildrenToParentTree(params$2.a[0], (!(!params$2.a[1])), params$2.a[2], params$2.a[3], params$2.a[4], (!(!params$2.a[5])), params$2.a[6])));
});
$p.apP = (function(ReadersVersionSpecific_this$105) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apQ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_CalculateDropdownPosition(params$2.a[0])));
});
$p.apR = (function(ReadersVersionSpecific_this$110) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apS = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_execution_ShowModal$()));
});
$p.apT = (function(ReadersVersionSpecific_this$115) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apU = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_execution_HideModal$()));
});
$p.apV = (function(ReadersVersionSpecific_this$120) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apW = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SetProgress(params$2.a[0], (+params$2.a[1]), params$2.a[2])));
});
$p.apX = (function(ReadersVersionSpecific_this$125) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apZ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow(params$2.a[0], params$2.a[1], (params$2.a[2] | 0), params$2.a[3])));
});
$p.aq0 = (function(ReadersVersionSpecific_this$130) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aq1 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect(params$2.a[0])));
});
$p.aq2 = (function(ReadersVersionSpecific_this$135) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aq3 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects(params$2.a[0], params$2.a[1])));
});
$p.aq4 = (function(ReadersVersionSpecific_this$140) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aq5 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_FocusPlanningPeriods(params$2.a[0], params$2.a[1])));
});
$p.aq6 = (function(ReadersVersionSpecific_this$145) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aq7 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod(params$2.a[0])));
});
$p.aq8 = (function(ReadersVersionSpecific_this$150) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqa = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_3 = params$2.a[0];
    var $x_2 = $uJ(params$2.a[1]);
    var $x_1 = $uJ(params$2.a[2]);
    return new $c_Lcom_papasofokli_execution_HighlightTimePeriod($x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h);
  }));
});
$p.aqb = (function(ReadersVersionSpecific_this$155) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqc = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = params$2.a[0];
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_execution_AddPeriodsToSubject($x_2, $x_1.l, $x_1.h, params$2.a[2]);
  }));
});
$p.aqd = (function(ReadersVersionSpecific_this$160) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqe = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow(params$2.a[0], params$2.a[1], params$2.a[2])));
});
$p.aqf = (function(ReadersVersionSpecific_this$165) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqg = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_CleanDetailPlannerRow(params$2.a[0], params$2.a[1], (params$2.a[2] | 0))));
});
$p.aqh = (function(ReadersVersionSpecific_this$170) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqi = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_CleanPlannerRow(params$2.a[0], params$2.a[1])));
});
$p.aqj = (function(ReadersVersionSpecific_this$175) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aql = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner(params$2.a[0], (params$2.a[1] | 0))));
});
$p.aqm = (function(ReadersVersionSpecific_this$180) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqn = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ShowSidebarForPlanner(params$2.a[0])));
});
$p.aqo = (function(ReadersVersionSpecific_this$185) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqp = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ClickOnId(params$2.a[0])));
});
$p.aqq = (function(ReadersVersionSpecific_this$190) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqr = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ShrinkModal(params$2.a[0], params$2.a[1], Math.fround(params$2.a[2]), params$2.a[3])));
});
$p.aqs = (function(ReadersVersionSpecific_this$195) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqt = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ExpandModal(params$2.a[0], params$2.a[1], Math.fround(params$2.a[2]), params$2.a[3])));
});
$p.aqu = (function(ReadersVersionSpecific_this$200) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqw = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_OnShownModal(params$2.a[0])));
});
$p.aqx = (function(ReadersVersionSpecific_this$205) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqy = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_OnCloseModal(params$2.a[0])));
});
$p.aqz = (function(ReadersVersionSpecific_this$210) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqA = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReplaceElementWithId(params$2.a[0], params$2.a[1], (!(!params$2.a[2])))));
});
$p.aqB = (function(ReadersVersionSpecific_this$215) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqC = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AppendElementWithId(params$2.a[0], params$2.a[1])));
});
$p.aqD = (function(ReadersVersionSpecific_this$220) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqE = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_PrependElementWithId(params$2.a[0], params$2.a[1])));
});
$p.aqF = (function(ReadersVersionSpecific_this$225) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqH = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReplaceElementContents(params$2.a[0], params$2.a[1], (!(!params$2.a[2])))));
});
$p.aqI = (function(ReadersVersionSpecific_this$230) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqJ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight(params$2.a[0], (!(!params$2.a[1])))));
});
$p.aqK = (function(ReadersVersionSpecific_this$235) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqL = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv(params$2.a[0])));
});
$p.aqM = (function(ReadersVersionSpecific_this$240) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqN = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_RedirectPageToHref(params$2.a[0])));
});
$p.aqO = (function(ReadersVersionSpecific_this$245) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqP = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_OpenPrinterCashbox(params$2.a[0])));
});
$p.aqQ = (function(ReadersVersionSpecific_this$250) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aov = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_PrintReceiptBytes(params$2.a[0], Math.fround(params$2.a[1]), Math.fround(params$2.a[2]), params$2.a[3], params$2.a[4], (!(!params$2.a[5])))));
});
$p.aow = (function(ReadersVersionSpecific_this$255) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aox = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_DownloadFile(params$2.a[0])));
});
$p.aoy = (function(ReadersVersionSpecific_this$260) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoz = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ToggleNotificationDropdown(params$2.a[0])));
});
$p.aoA = (function(ReadersVersionSpecific_this$265) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoB = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_UpdateIconNotification((params$2.a[0] | 0), params$2.a[1])));
});
$p.aoC = (function(ReadersVersionSpecific_this$270) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoD = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ShowHideNavSidebar((!(!params$2.a[0])))));
});
$p.aoE = (function(ReadersVersionSpecific_this$275) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoG = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_HttpRedirect(params$2.a[0])));
});
$p.aoH = (function(ReadersVersionSpecific_this$280) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoI = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_NavigateTo(params$2.a[0])));
});
$p.aoJ = (function(ReadersVersionSpecific_this$285) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoK = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ChangeTitleTo(params$2.a[0])));
});
$p.aoL = (function(ReadersVersionSpecific_this$290) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoM = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ChangeUrlTo(params$2.a[0])));
});
$p.aoN = (function(ReadersVersionSpecific_this$295) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoO = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_OpenUrl(params$2.a[0], params$2.a[1], (!(!params$2.a[2])))));
});
$p.aoP = (function(ReadersVersionSpecific_this$300) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoR = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith(params$2.a[0], params$2.a[1])));
});
$p.aoS = (function(ReadersVersionSpecific_this$305) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoT = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReplaceAnchorContents(params$2.a[0], params$2.a[1])));
});
$p.aoU = (function(ReadersVersionSpecific_this$310) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoV = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReplaceAnchorWithId(params$2.a[0], params$2.a[1])));
});
$p.aoW = (function(ReadersVersionSpecific_this$315) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoX = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ReloadTable(params$2.a[0])));
});
$p.aoY = (function(ReadersVersionSpecific_this$320) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aoZ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_UpdateValidation(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
$p.ap0 = (function(ReadersVersionSpecific_this$325) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ap2 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ResetPayrollTree(params$2.a[0])));
});
$p.ap3 = (function(ReadersVersionSpecific_this$330) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ap4 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_PayrollTreeLoadData(params$2.a[0])));
});
$p.ap5 = (function(ReadersVersionSpecific_this$335) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ap6 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges(params$2.a[0])));
});
$p.ap7 = (function(ReadersVersionSpecific_this$340) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ap8 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges(params$2.a[0], params$2.a[1])));
});
$p.ap9 = (function(ReadersVersionSpecific_this$345) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apa = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ModifyPeriods(params$2.a[0], params$2.a[1])));
});
$p.apb = (function(ReadersVersionSpecific_this$350) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apd = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_SetRightDivSize(params$2.a[0], params$2.a[1], (params$2.a[2] | 0), params$2.a[3])));
});
$p.ape = (function(ReadersVersionSpecific_this$355) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apf = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ToggleClassFromElement(params$2.a[0], params$2.a[1])));
});
$p.apg = (function(ReadersVersionSpecific_this$360) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aph = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_RemoveClassFromElement(params$2.a[0], params$2.a[1])));
});
$p.api = (function(ReadersVersionSpecific_this$365) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apj = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_AddClassToElement(params$2.a[0], params$2.a[1])));
});
$p.apk = (function(ReadersVersionSpecific_this$370) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.apl = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_InitializeTab(params$2.a[0])));
});
var $d_Lcom_papasofokli_execution_JsStatement$ = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$, "com.papasofokli.execution.JsStatement$", ({
  ms: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_execution_JsStatement$;
function $m_Lcom_papasofokli_execution_JsStatement$() {
  if ((!$n_Lcom_papasofokli_execution_JsStatement$)) {
    $n_Lcom_papasofokli_execution_JsStatement$ = new $c_Lcom_papasofokli_execution_JsStatement$();
  }
  return $n_Lcom_papasofokli_execution_JsStatement$;
}
/** @constructor */
function $c_Lcom_papasofokli_execution_ModalRatio$() {
  this.ZC = null;
  this.ZD = false;
}
$p = $c_Lcom_papasofokli_execution_ModalRatio$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ModalRatio$;
/** @constructor */
function $h_Lcom_papasofokli_execution_ModalRatio$() {
}
$h_Lcom_papasofokli_execution_ModalRatio$.prototype = $p;
$p.g = (function() {
  return "ModalRatio";
});
$p.q = (function() {
  if ((!this.ZD)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.ZC = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_execution_ModalRatio$$anon$1(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_execution_ModalRatio$$anon$2(MacroImplicits_this, this));
    this.ZD = true;
  }
  return this.ZC;
});
$p.aqR = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqS = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_execution_ModalRatio((params$2.a[0] | 0), (params$2.a[1] | 0))));
});
var $d_Lcom_papasofokli_execution_ModalRatio$ = new $TypeData().i($c_Lcom_papasofokli_execution_ModalRatio$, "com.papasofokli.execution.ModalRatio$", ({
  oO: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_execution_ModalRatio$;
function $m_Lcom_papasofokli_execution_ModalRatio$() {
  if ((!$n_Lcom_papasofokli_execution_ModalRatio$)) {
    $n_Lcom_papasofokli_execution_ModalRatio$ = new $c_Lcom_papasofokli_execution_ModalRatio$();
  }
  return $n_Lcom_papasofokli_execution_ModalRatio$;
}
/** @constructor */
function $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$() {
  this.ZF = null;
  this.ZG = false;
}
$p = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$;
/** @constructor */
function $h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$() {
}
$h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$.prototype = $p;
$p.g = (function() {
  return "PlanningGenerationEffectRange";
});
$p.q = (function() {
  if ((!this.ZG)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.ZF = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150(MacroImplicits_this, this));
    this.ZG = true;
  }
  return this.ZF;
});
$p.aqT = (function(ReadersVersionSpecific_this$374) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqU = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_3 = params$2.a[0];
    var $x_2 = $uJ(params$2.a[1]);
    var $x_1 = $uJ(params$2.a[2]);
    return new $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange($x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h);
  }));
});
var $d_Lcom_papasofokli_execution_PlanningGenerationEffectRange$ = new $TypeData().i($c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$, "com.papasofokli.execution.PlanningGenerationEffectRange$", ({
  oR: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_execution_PlanningGenerationEffectRange$;
function $m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$() {
  if ((!$n_Lcom_papasofokli_execution_PlanningGenerationEffectRange$)) {
    $n_Lcom_papasofokli_execution_PlanningGenerationEffectRange$ = new $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$();
  }
  return $n_Lcom_papasofokli_execution_PlanningGenerationEffectRange$;
}
var $b_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth;
function $a_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth() {
  if ((!$b_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth)) {
    $b_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth = class $b_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth extends Object {
      constructor(arg, arg$2) {
        var percentage = null;
        var query = null;
        percentage = arg;
        query = arg$2;
        super();
        Object.defineProperty(this, "max-width", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        var this$1 = percentage;
        var this$3 = (this$1.c() ? $m_s_None$() : new $c_s_Some((Math.fround(this$1.h()) + "%")));
        var query$1 = query;
        this["max-width"] = (this$3.c() ? query$1.data("max-width") : this$3.h());
      }
    };
  }
  return $b_Lcom_papasofokli_expandablemodal_Resizeable$MaxWidth;
}
var $b_Lcom_papasofokli_jquery_AutocompleteSettings;
function $a_Lcom_papasofokli_jquery_AutocompleteSettings() {
  if ((!$b_Lcom_papasofokli_jquery_AutocompleteSettings)) {
    $b_Lcom_papasofokli_jquery_AutocompleteSettings = class $b_Lcom_papasofokli_jquery_AutocompleteSettings extends Object {
      constructor(arg, arg$2, arg$3, arg$4, ...rest) {
        var source = null;
        var search = null;
        var focus = null;
        var select = null;
        var autoFocus = false;
        source = arg;
        search = arg$2;
        focus = arg$3;
        select = arg$4;
        autoFocus = ((rest[0] !== (void 0)) && (!(!rest[0])));
        super();
        Object.defineProperty(this, "source", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "search", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "focus", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "select", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "autoFocus", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": false
        }));
        this.source = source;
        this.search = search;
        this.focus = focus;
        this.select = select;
        this.autoFocus = autoFocus;
      }
    };
  }
  return $b_Lcom_papasofokli_jquery_AutocompleteSettings;
}
var $b_Lcom_papasofokli_jquery_DraggableSettings;
function $a_Lcom_papasofokli_jquery_DraggableSettings() {
  if ((!$b_Lcom_papasofokli_jquery_DraggableSettings)) {
    $b_Lcom_papasofokli_jquery_DraggableSettings = class $b_Lcom_papasofokli_jquery_DraggableSettings extends Object {
      constructor(...rest) {
        var drag = null;
        var start = null;
        var stop = null;
        drag = ((rest[0] === (void 0)) ? $m_Lcom_papasofokli_jquery_DraggableSettings$().alK() : rest[0]);
        start = ((rest[1] === (void 0)) ? $m_Lcom_papasofokli_jquery_DraggableSettings$().Tt() : rest[1]);
        stop = ((rest[2] === (void 0)) ? $m_Lcom_papasofokli_jquery_DraggableSettings$().Tu() : rest[2]);
        super();
        Object.defineProperty(this, "drag", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "start", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "stop", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.drag = drag;
        this.start = start;
        this.stop = stop;
      }
    };
  }
  return $b_Lcom_papasofokli_jquery_DraggableSettings;
}
var $b_Lcom_papasofokli_jquery_SortableSettings;
function $a_Lcom_papasofokli_jquery_SortableSettings() {
  if ((!$b_Lcom_papasofokli_jquery_SortableSettings)) {
    $b_Lcom_papasofokli_jquery_SortableSettings = class $b_Lcom_papasofokli_jquery_SortableSettings extends Object {
      constructor(...rest) {
        var placeholder = null;
        var beforeStop = null;
        var start = null;
        var update = null;
        var connectWith = null;
        var axis = null;
        var cancel = null;
        var items = null;
        placeholder = ((rest[0] === (void 0)) ? "" : rest[0]);
        beforeStop = ((rest[1] === (void 0)) ? $m_Lcom_papasofokli_jquery_SortableSettings$().Tt() : rest[1]);
        start = ((rest[2] === (void 0)) ? $m_Lcom_papasofokli_jquery_SortableSettings$().Tu() : rest[2]);
        update = ((rest[3] === (void 0)) ? $m_Lcom_papasofokli_jquery_SortableSettings$().alN() : rest[3]);
        connectWith = ((rest[4] === (void 0)) ? "" : rest[4]);
        axis = ((rest[5] === (void 0)) ? "" : rest[5]);
        cancel = ((rest[6] === (void 0)) ? "" : rest[6]);
        items = ((rest[7] === (void 0)) ? "" : rest[7]);
        super();
        Object.defineProperty(this, "placeholder", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "beforeStop", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "start", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "update", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "connectWith", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "axis", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "cancel", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        Object.defineProperty(this, "items", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.placeholder = placeholder;
        this.beforeStop = beforeStop;
        this.start = start;
        this.update = update;
        this.connectWith = connectWith;
        this.axis = axis;
        this.cancel = cancel;
        this.items = items;
      }
    };
  }
  return $b_Lcom_papasofokli_jquery_SortableSettings;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_ContextMenuRequest$() {
  this.a0e = null;
  this.a0f = false;
}
$p = $c_Lcom_papasofokli_jstree_ContextMenuRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_ContextMenuRequest$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_ContextMenuRequest$() {
}
$h_Lcom_papasofokli_jstree_ContextMenuRequest$.prototype = $p;
$p.g = (function() {
  return "ContextMenuRequest";
});
$p.q = (function() {
  if ((!this.a0f)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0e = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7(MacroImplicits_this, 1, this), new $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8(MacroImplicits_this, this));
    this.a0f = true;
  }
  return this.a0e;
});
$p.aqV = (function(ReadersVersionSpecific_this$11) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqW = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_jstree_ContextMenuRequest(params$2.a[0])));
});
var $d_Lcom_papasofokli_jstree_ContextMenuRequest$ = new $TypeData().i($c_Lcom_papasofokli_jstree_ContextMenuRequest$, "com.papasofokli.jstree.ContextMenuRequest$", ({
  pd: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_jstree_ContextMenuRequest$;
function $m_Lcom_papasofokli_jstree_ContextMenuRequest$() {
  if ((!$n_Lcom_papasofokli_jstree_ContextMenuRequest$)) {
    $n_Lcom_papasofokli_jstree_ContextMenuRequest$ = new $c_Lcom_papasofokli_jstree_ContextMenuRequest$();
  }
  return $n_Lcom_papasofokli_jstree_ContextMenuRequest$;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_InfoItem$() {
  this.a0h = null;
  this.a0i = false;
}
$p = $c_Lcom_papasofokli_jstree_InfoItem$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_InfoItem$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_InfoItem$() {
}
$h_Lcom_papasofokli_jstree_InfoItem$.prototype = $p;
$p.g = (function() {
  return "InfoItem";
});
$p.q = (function() {
  if ((!this.a0i)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0h = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_jstree_InfoItem$$anon$9(MacroImplicits_this, 5, this), new $c_Lcom_papasofokli_jstree_InfoItem$$anon$10(MacroImplicits_this, this));
    this.a0i = true;
  }
  return this.a0h;
});
$p.aqY = (function(ReadersVersionSpecific_this$14) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aqX = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_jstree_InfoItem(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4])));
});
var $d_Lcom_papasofokli_jstree_InfoItem$ = new $TypeData().i($c_Lcom_papasofokli_jstree_InfoItem$, "com.papasofokli.jstree.InfoItem$", ({
  pg: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_jstree_InfoItem$;
function $m_Lcom_papasofokli_jstree_InfoItem$() {
  if ((!$n_Lcom_papasofokli_jstree_InfoItem$)) {
    $n_Lcom_papasofokli_jstree_InfoItem$ = new $c_Lcom_papasofokli_jstree_InfoItem$();
  }
  return $n_Lcom_papasofokli_jstree_InfoItem$;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_LeafClickRequest$() {
  this.a0k = null;
  this.a0l = false;
}
$p = $c_Lcom_papasofokli_jstree_LeafClickRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_LeafClickRequest$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_LeafClickRequest$() {
}
$h_Lcom_papasofokli_jstree_LeafClickRequest$.prototype = $p;
$p.g = (function() {
  return "LeafClickRequest";
});
$p.q = (function() {
  if ((!this.a0l)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0k = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6(MacroImplicits_this, this));
    this.a0l = true;
  }
  return this.a0k;
});
$p.aqZ = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ar0 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_jstree_LeafClickRequest(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_jstree_LeafClickRequest$ = new $TypeData().i($c_Lcom_papasofokli_jstree_LeafClickRequest$, "com.papasofokli.jstree.LeafClickRequest$", ({
  pj: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_jstree_LeafClickRequest$;
function $m_Lcom_papasofokli_jstree_LeafClickRequest$() {
  if ((!$n_Lcom_papasofokli_jstree_LeafClickRequest$)) {
    $n_Lcom_papasofokli_jstree_LeafClickRequest$ = new $c_Lcom_papasofokli_jstree_LeafClickRequest$();
  }
  return $n_Lcom_papasofokli_jstree_LeafClickRequest$;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_NodeClickRequest$() {
  this.a0n = null;
  this.a0o = false;
}
$p = $c_Lcom_papasofokli_jstree_NodeClickRequest$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_NodeClickRequest$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_NodeClickRequest$() {
}
$h_Lcom_papasofokli_jstree_NodeClickRequest$.prototype = $p;
$p.g = (function() {
  return "NodeClickRequest";
});
$p.q = (function() {
  if ((!this.a0o)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0n = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4(MacroImplicits_this, this));
    this.a0o = true;
  }
  return this.a0n;
});
$p.ar1 = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ar2 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_jstree_NodeClickRequest(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_jstree_NodeClickRequest$ = new $TypeData().i($c_Lcom_papasofokli_jstree_NodeClickRequest$, "com.papasofokli.jstree.NodeClickRequest$", ({
  pm: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_jstree_NodeClickRequest$;
function $m_Lcom_papasofokli_jstree_NodeClickRequest$() {
  if ((!$n_Lcom_papasofokli_jstree_NodeClickRequest$)) {
    $n_Lcom_papasofokli_jstree_NodeClickRequest$ = new $c_Lcom_papasofokli_jstree_NodeClickRequest$();
  }
  return $n_Lcom_papasofokli_jstree_NodeClickRequest$;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$16, x0$lzy1$1, x1$lzy1$1) {
  if (x2$lzy1$1.i) {
    var $x_1 = x2$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T2($thiz.ag0(x0$lzy1$1, ReadersVersionSpecific_this$16, x1$lzy1$1), $thiz.ag1(x1$lzy1$1, ReadersVersionSpecific_this$16));
    var this$3 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x2$lzy1$1.E(ReadersVersionSpecific_this$16.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$17, x0$lzy1$2, x1$lzy1$2) {
  return (x2$lzy1$2.i ? x2$lzy1$2.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$17, x0$lzy1$2, x1$lzy1$2));
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$18) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_jstree_TreeItemData$$anon$11(ReadersVersionSpecific_this$18, 7, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$18.aq(), "$type", "com.papasofokli.jstree.TreeLeafData", "TreeLeafData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$23, x1$lzy1$5) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_jstree_TreeItemData$$anon$12(ReadersVersionSpecific_this$23, 11, x0$lzy1$3, x1$lzy1$5, ReadersVersionSpecific_this$23, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$23.aq(), "$type", "com.papasofokli.jstree.TreeNodeData", "TreeNodeData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$11, x0$lzy2$1, x1$lzy2$1) {
  if (x2$lzy2$1.i) {
    var $x_1 = x2$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T2($thiz.TO(x0$lzy2$1, WritersVersionSpecific_this$11, x1$lzy2$1), $thiz.TP(x1$lzy2$1, WritersVersionSpecific_this$11));
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x2$lzy2$1.E(WritersVersionSpecific_this$11.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$12, x0$lzy2$2, x1$lzy2$2) {
  return (x2$lzy2$2.i ? x2$lzy2$2.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$12, x0$lzy2$2, x1$lzy2$2));
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$13) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy17__runtimeClass;
    var evidence$1$proxy17__runtimeClass = $d_Lcom_papasofokli_jstree_TreeLeafData.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$13, new $c_Lcom_papasofokli_jstree_TreeItemData$$anon$13(WritersVersionSpecific_this$13, $thiz), "$type", "com.papasofokli.jstree.TreeLeafData", "TreeLeafData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy17__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_jstree_TreeItemData$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$17, x1$lzy2$5) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy18__runtimeClass;
    var evidence$1$proxy18__runtimeClass = $d_Lcom_papasofokli_jstree_TreeNodeData.l();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$17, new $c_Lcom_papasofokli_jstree_TreeItemData$$anon$14(WritersVersionSpecific_this$17, x0$lzy2$3, x1$lzy2$5, WritersVersionSpecific_this$17, $thiz), "$type", "com.papasofokli.jstree.TreeNodeData", "TreeNodeData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy18__runtimeClass)));
  }
  return $x_1;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeItemData$() {
  this.a0q = null;
  this.a0r = false;
}
$p = $c_Lcom_papasofokli_jstree_TreeItemData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeItemData$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeItemData$() {
}
$h_Lcom_papasofokli_jstree_TreeItemData$.prototype = $p;
$p.q = (function() {
  if ((!this.a0r)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0q = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_jstree_TreeItemData$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_jstree_TreeItemData$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a0r = true;
  }
  return this.a0q;
});
$p.ar3 = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ar4 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = params$2.a[0];
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_jstree_TreeLeafData($x_2, $x_1.l, $x_1.h, (!(!params$2.a[2])), params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6]);
  }));
});
$p.ag1 = (function(x1$lzy1$4, ReadersVersionSpecific_this$22) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader(this, x1$lzy1$4, ReadersVersionSpecific_this$22));
});
$p.ar5 = (function(ReadersVersionSpecific_this$26) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ar6 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = $uJ(params$2.a[0]);
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_jstree_TreeNodeData($x_2.l, $x_2.h, $x_1.l, $x_1.h, params$2.a[2], params$2.a[3], (!(!params$2.a[4])), (!(!params$2.a[5])), params$2.a[6], params$2.a[7], params$2.a[8], params$2.a[9], params$2.a[10]);
  }));
});
$p.ag0 = (function(x0$lzy1$5, ReadersVersionSpecific_this$28, x1$lzy1$7) {
  return (x0$lzy1$5.i ? x0$lzy1$5.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Reader(this, x0$lzy1$5, ReadersVersionSpecific_this$28, x1$lzy1$7));
});
$p.TP = (function(x1$lzy2$4, WritersVersionSpecific_this$16) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer(this, x1$lzy2$4, WritersVersionSpecific_this$16));
});
$p.TO = (function(x0$lzy2$6, WritersVersionSpecific_this$22, x1$lzy2$8) {
  return (x0$lzy2$6.i ? x0$lzy2$6.j : $p_Lcom_papasofokli_jstree_TreeItemData$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__Lupickle_core_Types$Writer(this, x0$lzy2$6, WritersVersionSpecific_this$22, x1$lzy2$8));
});
var $d_Lcom_papasofokli_jstree_TreeItemData$ = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeItemData$, "com.papasofokli.jstree.TreeItemData$", ({
  pp: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_jstree_TreeItemData$;
function $m_Lcom_papasofokli_jstree_TreeItemData$() {
  if ((!$n_Lcom_papasofokli_jstree_TreeItemData$)) {
    $n_Lcom_papasofokli_jstree_TreeItemData$ = new $c_Lcom_papasofokli_jstree_TreeItemData$();
  }
  return $n_Lcom_papasofokli_jstree_TreeItemData$;
}
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$() {
  this.a0v = null;
  this.a0w = false;
}
$p = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeNodeListSetupData$() {
}
$h_Lcom_papasofokli_jstree_TreeNodeListSetupData$.prototype = $p;
$p.g = (function() {
  return "TreeNodeListSetupData";
});
$p.q = (function() {
  if ((!this.a0w)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0v = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2(MacroImplicits_this, this));
    this.a0w = true;
  }
  return this.a0v;
});
$p.ar7 = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ar8 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_jstree_TreeNodeListSetupData(params$2.a[0], params$2.a[1], (!(!params$2.a[2])))));
});
var $d_Lcom_papasofokli_jstree_TreeNodeListSetupData$ = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeNodeListSetupData$, "com.papasofokli.jstree.TreeNodeListSetupData$", ({
  pu: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_jstree_TreeNodeListSetupData$;
function $m_Lcom_papasofokli_jstree_TreeNodeListSetupData$() {
  if ((!$n_Lcom_papasofokli_jstree_TreeNodeListSetupData$)) {
    $n_Lcom_papasofokli_jstree_TreeNodeListSetupData$ = new $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$();
  }
  return $n_Lcom_papasofokli_jstree_TreeNodeListSetupData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_AppliedToC$() {
  this.a0K = null;
  this.a0L = false;
}
$p = $c_Lcom_papasofokli_planning_AppliedToC$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_AppliedToC$;
/** @constructor */
function $h_Lcom_papasofokli_planning_AppliedToC$() {
}
$h_Lcom_papasofokli_planning_AppliedToC$.prototype = $p;
$p.g = (function() {
  return "AppliedToC";
});
$p.q = (function() {
  if ((!this.a0L)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0K = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_AppliedToC$$anon$41(MacroImplicits_this, 1, this), new $c_Lcom_papasofokli_planning_AppliedToC$$anon$42(MacroImplicits_this, this));
    this.a0L = true;
  }
  return this.a0K;
});
$p.ar9 = (function(ReadersVersionSpecific_this$75) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ara = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_AppliedToC(params$2.a[0])));
});
var $d_Lcom_papasofokli_planning_AppliedToC$ = new $TypeData().i($c_Lcom_papasofokli_planning_AppliedToC$, "com.papasofokli.planning.AppliedToC$", ({
  pC: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_AppliedToC$;
function $m_Lcom_papasofokli_planning_AppliedToC$() {
  if ((!$n_Lcom_papasofokli_planning_AppliedToC$)) {
    $n_Lcom_papasofokli_planning_AppliedToC$ = new $c_Lcom_papasofokli_planning_AppliedToC$();
  }
  return $n_Lcom_papasofokli_planning_AppliedToC$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_DetailedPlanningRow$() {
  this.a0N = null;
  this.a0O = false;
}
$p = $c_Lcom_papasofokli_planning_DetailedPlanningRow$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DetailedPlanningRow$;
/** @constructor */
function $h_Lcom_papasofokli_planning_DetailedPlanningRow$() {
}
$h_Lcom_papasofokli_planning_DetailedPlanningRow$.prototype = $p;
$p.g = (function() {
  return "DetailedPlanningRow";
});
$p.q = (function() {
  if ((!this.a0O)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0N = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14(MacroImplicits_this, this));
    this.a0O = true;
  }
  return this.a0N;
});
$p.arb = (function(ReadersVersionSpecific_this$27) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arc = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_DetailedPlanningRow(params$2.a[0], (!(!params$2.a[1])))));
});
var $d_Lcom_papasofokli_planning_DetailedPlanningRow$ = new $TypeData().i($c_Lcom_papasofokli_planning_DetailedPlanningRow$, "com.papasofokli.planning.DetailedPlanningRow$", ({
  pF: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_DetailedPlanningRow$;
function $m_Lcom_papasofokli_planning_DetailedPlanningRow$() {
  if ((!$n_Lcom_papasofokli_planning_DetailedPlanningRow$)) {
    $n_Lcom_papasofokli_planning_DetailedPlanningRow$ = new $c_Lcom_papasofokli_planning_DetailedPlanningRow$();
  }
  return $n_Lcom_papasofokli_planning_DetailedPlanningRow$;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x2$lzyINIT3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$1, ReadersVersionSpecific_this$44, x0$lzy3$1, x1$lzy3$1) {
  if (x2$lzy3$1.i) {
    var $x_1 = x2$lzy3$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_planning_DivisionData$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$1, ReadersVersionSpecific_this$44), $p_Lcom_papasofokli_planning_DivisionData$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$1, ReadersVersionSpecific_this$44));
    var this$3 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x2$lzy3$1.E(ReadersVersionSpecific_this$44.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x2$3__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$2, ReadersVersionSpecific_this$45, x0$lzy3$2, x1$lzy3$2) {
  return (x2$lzy3$2.i ? x2$lzy3$2.j : $p_Lcom_papasofokli_planning_DivisionData$__x2$lzyINIT3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$2, ReadersVersionSpecific_this$45, x0$lzy3$2, x1$lzy3$2));
}
function $p_Lcom_papasofokli_planning_DivisionData$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$3, ReadersVersionSpecific_this$46) {
  if (x1$lzy3$3.i) {
    var $x_1 = x1$lzy3$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_planning_DivisionData$$anon$25(ReadersVersionSpecific_this$46, 2, $thiz);
    var $x_1 = x1$lzy3$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$46.aq(), "$type", "com.papasofokli.planning.LeafData", "LeafData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$50) {
  return (x1$lzy3$4.i ? x1$lzy3$4.j : $p_Lcom_papasofokli_planning_DivisionData$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$50));
}
function $p_Lcom_papasofokli_planning_DivisionData$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$3, ReadersVersionSpecific_this$51) {
  if (x0$lzy3$3.i) {
    var $x_1 = x0$lzy3$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_planning_DivisionData$$anon$26(ReadersVersionSpecific_this$51, 2, $thiz);
    var $x_1 = x0$lzy3$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$51.aq(), "$type", "com.papasofokli.planning.NodeData", "NodeData", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$55) {
  return (x0$lzy3$4.i ? x0$lzy3$4.j : $p_Lcom_papasofokli_planning_DivisionData$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$55));
}
function $p_Lcom_papasofokli_planning_DivisionData$__x2$lzyINIT4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$1, WritersVersionSpecific_this$33, x0$lzy4$1, x1$lzy4$1) {
  if (x2$lzy4$1.i) {
    var $x_1 = x2$lzy4$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_planning_DivisionData$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$1, WritersVersionSpecific_this$33), $p_Lcom_papasofokli_planning_DivisionData$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$1, WritersVersionSpecific_this$33));
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x2$lzy4$1.E(WritersVersionSpecific_this$33.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x2$4__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$2, WritersVersionSpecific_this$34, x0$lzy4$2, x1$lzy4$2) {
  return (x2$lzy4$2.i ? x2$lzy4$2.j : $p_Lcom_papasofokli_planning_DivisionData$__x2$lzyINIT4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$2, WritersVersionSpecific_this$34, x0$lzy4$2, x1$lzy4$2));
}
function $p_Lcom_papasofokli_planning_DivisionData$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$3, WritersVersionSpecific_this$35) {
  if (x1$lzy4$3.i) {
    var $x_1 = x1$lzy4$3.j;
  } else {
    var evidence$1$proxy14__runtimeClass;
    var evidence$1$proxy14__runtimeClass = $d_Lcom_papasofokli_planning_LeafData.l();
    var $x_1 = x1$lzy4$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$35, new $c_Lcom_papasofokli_planning_DivisionData$$anon$27(WritersVersionSpecific_this$35, $thiz), "$type", "com.papasofokli.planning.LeafData", "LeafData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy14__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$38) {
  return (x1$lzy4$4.i ? x1$lzy4$4.j : $p_Lcom_papasofokli_planning_DivisionData$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$38));
}
function $p_Lcom_papasofokli_planning_DivisionData$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$3, WritersVersionSpecific_this$39) {
  if (x0$lzy4$3.i) {
    var $x_1 = x0$lzy4$3.j;
  } else {
    var evidence$1$proxy15__runtimeClass;
    var evidence$1$proxy15__runtimeClass = $d_Lcom_papasofokli_planning_NodeData.l();
    var $x_1 = x0$lzy4$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$39, new $c_Lcom_papasofokli_planning_DivisionData$$anon$28(WritersVersionSpecific_this$39, $thiz), "$type", "com.papasofokli.planning.NodeData", "NodeData", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy15__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionData$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$42) {
  return (x0$lzy4$4.i ? x0$lzy4$4.j : $p_Lcom_papasofokli_planning_DivisionData$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$42));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionData$() {
  this.a0Q = null;
  this.a0R = false;
}
$p = $c_Lcom_papasofokli_planning_DivisionData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionData$() {
}
$h_Lcom_papasofokli_planning_DivisionData$.prototype = $p;
$p.q = (function() {
  if ((!this.a0R)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0Q = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_planning_DivisionData$__x2$3__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_planning_DivisionData$__x2$4__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a0R = true;
  }
  return this.a0Q;
});
$p.ard = (function(ReadersVersionSpecific_this$48) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.are = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = $uJ(params$2.a[0]);
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_planning_LeafData($x_2.l, $x_2.h, $x_1.l, $x_1.h);
  }));
});
$p.arf = (function(ReadersVersionSpecific_this$53) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arg = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_planning_NodeData($x_1.l, $x_1.h, params$2.a[1]);
  }));
});
var $d_Lcom_papasofokli_planning_DivisionData$ = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionData$, "com.papasofokli.planning.DivisionData$", ({
  pI: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_planning_DivisionData$;
function $m_Lcom_papasofokli_planning_DivisionData$() {
  if ((!$n_Lcom_papasofokli_planning_DivisionData$)) {
    $n_Lcom_papasofokli_planning_DivisionData$ = new $c_Lcom_papasofokli_planning_DivisionData$();
  }
  return $n_Lcom_papasofokli_planning_DivisionData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionEnum$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.a0V = null;
  this.a0U = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_planning_DivisionEnum$ = this;
  this.a0V = new $c_s_Enumeration$Val(this, this.bI, "1");
  this.a0U = new $c_s_Enumeration$Val(this, this.bI, "2");
}
$p = $c_Lcom_papasofokli_planning_DivisionEnum$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionEnum$;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionEnum$() {
}
$h_Lcom_papasofokli_planning_DivisionEnum$.prototype = $p;
var $d_Lcom_papasofokli_planning_DivisionEnum$ = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionEnum$, "com.papasofokli.planning.DivisionEnum$", ({
  pN: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_planning_DivisionEnum$;
function $m_Lcom_papasofokli_planning_DivisionEnum$() {
  if ((!$n_Lcom_papasofokli_planning_DivisionEnum$)) {
    $n_Lcom_papasofokli_planning_DivisionEnum$ = new $c_Lcom_papasofokli_planning_DivisionEnum$();
  }
  return $n_Lcom_papasofokli_planning_DivisionEnum$;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$10, x0$lzy1$1, x1$lzy1$1) {
  if (x2$lzy1$1.i) {
    var $x_1 = x2$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$10, x2$lzy1$1, x1$lzy1$1), $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$10));
    var this$3 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x2$lzy1$1.E(ReadersVersionSpecific_this$10.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$12) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7(ReadersVersionSpecific_this$12, 6, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$12.aq(), "$type", "com.papasofokli.planning.LeafDivisionJS", "LeafDivisionJS", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$16) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$16));
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$17, x2$lzy1$3, x1$lzy1$5) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8(ReadersVersionSpecific_this$17, 4, x2$lzy1$3, ReadersVersionSpecific_this$17, x0$lzy1$3, x1$lzy1$5, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$17.aq(), "$type", "com.papasofokli.planning.NodeDivisionJS", "NodeDivisionJS", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x0$lzy1$5, ReadersVersionSpecific_this$22, x2$lzy1$5, x1$lzy1$7) {
  return (x0$lzy1$5.i ? x0$lzy1$5.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x0$lzy1$5, ReadersVersionSpecific_this$22, x2$lzy1$5, x1$lzy1$7));
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$7, x0$lzy2$1, x1$lzy2$1) {
  if (x2$lzy2$1.i) {
    var $x_1 = x2$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$7, x2$lzy2$1, x1$lzy2$1), $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$7));
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x2$lzy2$1.E(WritersVersionSpecific_this$7.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$9) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy7__runtimeClass;
    var evidence$1$proxy7__runtimeClass = $d_Lcom_papasofokli_planning_LeafDivisionJS.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$9, new $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9(WritersVersionSpecific_this$9, $thiz), "$type", "com.papasofokli.planning.LeafDivisionJS", "LeafDivisionJS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy7__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$12) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$13, x2$lzy2$3, x1$lzy2$5) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy10__runtimeClass;
    var evidence$1$proxy10__runtimeClass = $d_Lcom_papasofokli_planning_NodeDivisionJS.l();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$13, new $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10(WritersVersionSpecific_this$13, x2$lzy2$3, WritersVersionSpecific_this$13, x0$lzy2$3, x1$lzy2$5, $thiz), "$type", "com.papasofokli.planning.NodeDivisionJS", "NodeDivisionJS", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy10__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x0$lzy2$6, WritersVersionSpecific_this$18, x2$lzy2$6, x1$lzy2$8) {
  return (x0$lzy2$6.i ? x0$lzy2$6.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x0$lzy2$6, WritersVersionSpecific_this$18, x2$lzy2$6, x1$lzy2$8));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionsDataJSI$() {
  this.a0W = null;
  this.a0X = false;
}
$p = $c_Lcom_papasofokli_planning_DivisionsDataJSI$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionsDataJSI$;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionsDataJSI$() {
}
$h_Lcom_papasofokli_planning_DivisionsDataJSI$.prototype = $p;
$p.q = (function() {
  if ((!this.a0X)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a0W = MacroImplicits_this.ap().aQ(this.ag2(new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), this.TQ(new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a0X = true;
  }
  return this.a0W;
});
$p.ag2 = (function(x2$lzy1$2, ReadersVersionSpecific_this$11, x0$lzy1$2, x1$lzy1$2) {
  return (x2$lzy1$2.i ? x2$lzy1$2.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, x2$lzy1$2, ReadersVersionSpecific_this$11, x0$lzy1$2, x1$lzy1$2));
});
$p.ari = (function(ReadersVersionSpecific_this$14) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arj = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_LeafDivisionJS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5])));
});
$p.ark = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arh = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_NodeDivisionJS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3])));
});
$p.TQ = (function(x2$lzy2$2, WritersVersionSpecific_this$8, x0$lzy2$2, x1$lzy2$2) {
  return (x2$lzy2$2.i ? x2$lzy2$2.j : $p_Lcom_papasofokli_planning_DivisionsDataJSI$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, x2$lzy2$2, WritersVersionSpecific_this$8, x0$lzy2$2, x1$lzy2$2));
});
var $d_Lcom_papasofokli_planning_DivisionsDataJSI$ = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionsDataJSI$, "com.papasofokli.planning.DivisionsDataJSI$", ({
  pO: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_planning_DivisionsDataJSI$;
function $m_Lcom_papasofokli_planning_DivisionsDataJSI$() {
  if ((!$n_Lcom_papasofokli_planning_DivisionsDataJSI$)) {
    $n_Lcom_papasofokli_planning_DivisionsDataJSI$ = new $c_Lcom_papasofokli_planning_DivisionsDataJSI$();
  }
  return $n_Lcom_papasofokli_planning_DivisionsDataJSI$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_IndicationsDictionary$() {
  this.a14 = null;
  this.a15 = false;
}
$p = $c_Lcom_papasofokli_planning_IndicationsDictionary$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_IndicationsDictionary$;
/** @constructor */
function $h_Lcom_papasofokli_planning_IndicationsDictionary$() {
}
$h_Lcom_papasofokli_planning_IndicationsDictionary$.prototype = $p;
$p.g = (function() {
  return "IndicationsDictionary";
});
$p.q = (function() {
  if ((!this.a15)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a14 = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44(MacroImplicits_this, this));
    this.a15 = true;
  }
  return this.a14;
});
$p.arl = (function(ReadersVersionSpecific_this$78) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arm = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_IndicationsDictionary(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_planning_IndicationsDictionary$ = new $TypeData().i($c_Lcom_papasofokli_planning_IndicationsDictionary$, "com.papasofokli.planning.IndicationsDictionary$", ({
  pT: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_IndicationsDictionary$;
function $m_Lcom_papasofokli_planning_IndicationsDictionary$() {
  if ((!$n_Lcom_papasofokli_planning_IndicationsDictionary$)) {
    $n_Lcom_papasofokli_planning_IndicationsDictionary$ = new $c_Lcom_papasofokli_planning_IndicationsDictionary$();
  }
  return $n_Lcom_papasofokli_planning_IndicationsDictionary$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodJS$() {
  this.a1e = null;
  this.a1f = false;
}
$p = $c_Lcom_papasofokli_planning_PeriodJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodJS$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodJS$() {
}
$h_Lcom_papasofokli_planning_PeriodJS$.prototype = $p;
$p.g = (function() {
  return "PeriodJS";
});
$p.q = (function() {
  if ((!this.a1f)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1e = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PeriodJS$$anon$17(MacroImplicits_this, 27, this), new $c_Lcom_papasofokli_planning_PeriodJS$$anon$18(MacroImplicits_this, this));
    this.a1f = true;
  }
  return this.a1e;
});
$p.arn = (function(ReadersVersionSpecific_this$33) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aro = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_3 = params$2.a[0];
    var $x_2 = $uJ(params$2.a[1]);
    var $x_1 = $uJ(params$2.a[2]);
    return new $c_Lcom_papasofokli_planning_PeriodJS($x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h, params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], params$2.a[7], (!(!params$2.a[8])), (!(!params$2.a[9])), params$2.a[10], (params$2.a[11] | 0), params$2.a[12], params$2.a[13], params$2.a[14], params$2.a[15], params$2.a[16], params$2.a[17], params$2.a[18], params$2.a[19], params$2.a[20], params$2.a[21], params$2.a[22], params$2.a[23], params$2.a[24], params$2.a[25], (!(!params$2.a[26])));
  }));
});
var $d_Lcom_papasofokli_planning_PeriodJS$ = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodJS$, "com.papasofokli.planning.PeriodJS$", ({
  pX: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PeriodJS$;
function $m_Lcom_papasofokli_planning_PeriodJS$() {
  if ((!$n_Lcom_papasofokli_planning_PeriodJS$)) {
    $n_Lcom_papasofokli_planning_PeriodJS$ = new $c_Lcom_papasofokli_planning_PeriodJS$();
  }
  return $n_Lcom_papasofokli_planning_PeriodJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodStyle$() {
  this.a1h = null;
  this.a1i = false;
}
$p = $c_Lcom_papasofokli_planning_PeriodStyle$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodStyle$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodStyle$() {
}
$h_Lcom_papasofokli_planning_PeriodStyle$.prototype = $p;
$p.g = (function() {
  return "PeriodStyle";
});
$p.q = (function() {
  if ((!this.a1i)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1h = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PeriodStyle$$anon$39(MacroImplicits_this, 1, this), new $c_Lcom_papasofokli_planning_PeriodStyle$$anon$40(MacroImplicits_this, this));
    this.a1i = true;
  }
  return this.a1h;
});
$p.arp = (function(ReadersVersionSpecific_this$72) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arq = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_PeriodStyle(params$2.a[0])));
});
var $d_Lcom_papasofokli_planning_PeriodStyle$ = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodStyle$, "com.papasofokli.planning.PeriodStyle$", ({
  q0: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PeriodStyle$;
function $m_Lcom_papasofokli_planning_PeriodStyle$() {
  if ((!$n_Lcom_papasofokli_planning_PeriodStyle$)) {
    $n_Lcom_papasofokli_planning_PeriodStyle$ = new $c_Lcom_papasofokli_planning_PeriodStyle$();
  }
  return $n_Lcom_papasofokli_planning_PeriodStyle$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodTransformation$() {
  this.a1l = null;
  this.a1m = false;
}
$p = $c_Lcom_papasofokli_planning_PeriodTransformation$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodTransformation$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodTransformation$() {
}
$h_Lcom_papasofokli_planning_PeriodTransformation$.prototype = $p;
$p.g = (function() {
  return "PeriodTransformation";
});
$p.q = (function() {
  if ((!this.a1m)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1l = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$33(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$34(MacroImplicits_this, this));
    this.a1m = true;
  }
  return this.a1l;
});
$p.arr = (function(ReadersVersionSpecific_this$63) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ars = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_PeriodTransformation(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_planning_PeriodTransformation$ = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodTransformation$, "com.papasofokli.planning.PeriodTransformation$", ({
  q4: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PeriodTransformation$;
function $m_Lcom_papasofokli_planning_PeriodTransformation$() {
  if ((!$n_Lcom_papasofokli_planning_PeriodTransformation$)) {
    $n_Lcom_papasofokli_planning_PeriodTransformation$ = new $c_Lcom_papasofokli_planning_PeriodTransformation$();
  }
  return $n_Lcom_papasofokli_planning_PeriodTransformation$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PlannerPeriodsData$() {
  this.a1o = null;
  this.a1p = false;
}
$p = $c_Lcom_papasofokli_planning_PlannerPeriodsData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlannerPeriodsData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlannerPeriodsData$() {
}
$h_Lcom_papasofokli_planning_PlannerPeriodsData$.prototype = $p;
$p.g = (function() {
  return "PlannerPeriodsData";
});
$p.q = (function() {
  if ((!this.a1p)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1o = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22(MacroImplicits_this, this));
    this.a1p = true;
  }
  return this.a1o;
});
$p.art = (function(ReadersVersionSpecific_this$39) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.aru = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_PlannerPeriodsData(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_planning_PlannerPeriodsData$ = new $TypeData().i($c_Lcom_papasofokli_planning_PlannerPeriodsData$, "com.papasofokli.planning.PlannerPeriodsData$", ({
  q7: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PlannerPeriodsData$;
function $m_Lcom_papasofokli_planning_PlannerPeriodsData$() {
  if ((!$n_Lcom_papasofokli_planning_PlannerPeriodsData$)) {
    $n_Lcom_papasofokli_planning_PlannerPeriodsData$ = new $c_Lcom_papasofokli_planning_PlannerPeriodsData$();
  }
  return $n_Lcom_papasofokli_planning_PlannerPeriodsData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningData$() {
  this.a1t = null;
  this.a1u = false;
}
$p = $c_Lcom_papasofokli_planning_PlanningData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningData$() {
}
$h_Lcom_papasofokli_planning_PlanningData$.prototype = $p;
$p.g = (function() {
  return "PlanningData";
});
$p.M4 = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.q = (function() {
  if ((!this.a1u)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1t = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PlanningData$$anon$1(MacroImplicits_this, 21, this), new $c_Lcom_papasofokli_planning_PlanningData$$anon$2(MacroImplicits_this, this));
    this.a1u = true;
  }
  return this.a1t;
});
$p.arv = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arw = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = params$2.a[0];
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_planning_PlanningData($x_2, $x_1.l, $x_1.h, params$2.a[2], params$2.a[3], params$2.a[4], (!(!params$2.a[5])), params$2.a[6], params$2.a[7], params$2.a[8], params$2.a[9], params$2.a[10], Math.fround(params$2.a[11]), Math.fround(params$2.a[12]), params$2.a[13], (!(!params$2.a[14])), params$2.a[15], (!(!params$2.a[16])), params$2.a[17], params$2.a[18], (!(!params$2.a[19])), params$2.a[20]);
  }));
});
var $d_Lcom_papasofokli_planning_PlanningData$ = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningData$, "com.papasofokli.planning.PlanningData$", ({
  qa: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PlanningData$;
function $m_Lcom_papasofokli_planning_PlanningData$() {
  if ((!$n_Lcom_papasofokli_planning_PlanningData$)) {
    $n_Lcom_papasofokli_planning_PlanningData$ = new $c_Lcom_papasofokli_planning_PlanningData$();
  }
  return $n_Lcom_papasofokli_planning_PlanningData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningPeriodChange$() {
  this.a1w = null;
  this.a1x = false;
}
$p = $c_Lcom_papasofokli_planning_PlanningPeriodChange$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningPeriodChange$;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningPeriodChange$() {
}
$h_Lcom_papasofokli_planning_PlanningPeriodChange$.prototype = $p;
$p.g = (function() {
  return "PlanningPeriodChange";
});
$p.q = (function() {
  if ((!this.a1x)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1w = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35(MacroImplicits_this, 6, this), new $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36(MacroImplicits_this, this));
    this.a1x = true;
  }
  return this.a1w;
});
$p.arx = (function(ReadersVersionSpecific_this$66) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ary = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_4 = $uJ(params$2.a[0]);
    var $x_3 = $uJ(params$2.a[1]);
    var $x_2 = $uJ(params$2.a[2]);
    var $x_1 = $uJ(params$2.a[3]);
    return new $c_Lcom_papasofokli_planning_PlanningPeriodChange($x_4.l, $x_4.h, $x_3.l, $x_3.h, $x_2.l, $x_2.h, $x_1.l, $x_1.h, params$2.a[4], (!(!params$2.a[5])));
  }));
});
var $d_Lcom_papasofokli_planning_PlanningPeriodChange$ = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningPeriodChange$, "com.papasofokli.planning.PlanningPeriodChange$", ({
  qd: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_PlanningPeriodChange$;
function $m_Lcom_papasofokli_planning_PlanningPeriodChange$() {
  if ((!$n_Lcom_papasofokli_planning_PlanningPeriodChange$)) {
    $n_Lcom_papasofokli_planning_PlanningPeriodChange$ = new $c_Lcom_papasofokli_planning_PlanningPeriodChange$();
  }
  return $n_Lcom_papasofokli_planning_PlanningPeriodChange$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_RowClickData$() {
  this.a1z = null;
  this.a1A = false;
}
$p = $c_Lcom_papasofokli_planning_RowClickData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowClickData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowClickData$() {
}
$h_Lcom_papasofokli_planning_RowClickData$.prototype = $p;
$p.g = (function() {
  return "RowClickData";
});
$p.q = (function() {
  if ((!this.a1A)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1z = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_RowClickData$$anon$31(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_planning_RowClickData$$anon$32(MacroImplicits_this, this));
    this.a1A = true;
  }
  return this.a1z;
});
$p.arz = (function(ReadersVersionSpecific_this$60) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arA = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_RowClickData(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_planning_RowClickData$ = new $TypeData().i($c_Lcom_papasofokli_planning_RowClickData$, "com.papasofokli.planning.RowClickData$", ({
  qg: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_RowClickData$;
function $m_Lcom_papasofokli_planning_RowClickData$() {
  if ((!$n_Lcom_papasofokli_planning_RowClickData$)) {
    $n_Lcom_papasofokli_planning_RowClickData$ = new $c_Lcom_papasofokli_planning_RowClickData$();
  }
  return $n_Lcom_papasofokli_planning_RowClickData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_RowData$() {
  this.a1C = null;
  this.a1D = false;
}
$p = $c_Lcom_papasofokli_planning_RowData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowData$() {
}
$h_Lcom_papasofokli_planning_RowData$.prototype = $p;
$p.g = (function() {
  return "RowData";
});
$p.q = (function() {
  if ((!this.a1D)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1C = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_RowData$$anon$29(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_planning_RowData$$anon$30(MacroImplicits_this, this));
    this.a1D = true;
  }
  return this.a1C;
});
$p.arB = (function(ReadersVersionSpecific_this$57) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arC = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_2 = params$2.a[0];
    var $x_1 = $uJ(params$2.a[1]);
    return new $c_Lcom_papasofokli_planning_RowData($x_2, $x_1.l, $x_1.h, params$2.a[2]);
  }));
});
var $d_Lcom_papasofokli_planning_RowData$ = new $TypeData().i($c_Lcom_papasofokli_planning_RowData$, "com.papasofokli.planning.RowData$", ({
  qj: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_RowData$;
function $m_Lcom_papasofokli_planning_RowData$() {
  if ((!$n_Lcom_papasofokli_planning_RowData$)) {
    $n_Lcom_papasofokli_planning_RowData$ = new $c_Lcom_papasofokli_planning_RowData$();
  }
  return $n_Lcom_papasofokli_planning_RowData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectButtonParameters$() {
  this.a1F = null;
  this.a1G = false;
}
$p = $c_Lcom_papasofokli_planning_SubjectButtonParameters$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectButtonParameters$;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectButtonParameters$() {
}
$h_Lcom_papasofokli_planning_SubjectButtonParameters$.prototype = $p;
$p.g = (function() {
  return "SubjectButtonParameters";
});
$p.q = (function() {
  if ((!this.a1G)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1F = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4(MacroImplicits_this, this));
    this.a1G = true;
  }
  return this.a1F;
});
$p.arD = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arE = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_SubjectButtonParameters(params$2.a[0], params$2.a[1], params$2.a[2])));
});
var $d_Lcom_papasofokli_planning_SubjectButtonParameters$ = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectButtonParameters$, "com.papasofokli.planning.SubjectButtonParameters$", ({
  qm: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_SubjectButtonParameters$;
function $m_Lcom_papasofokli_planning_SubjectButtonParameters$() {
  if ((!$n_Lcom_papasofokli_planning_SubjectButtonParameters$)) {
    $n_Lcom_papasofokli_planning_SubjectButtonParameters$ = new $c_Lcom_papasofokli_planning_SubjectButtonParameters$();
  }
  return $n_Lcom_papasofokli_planning_SubjectButtonParameters$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectJS$() {
  this.a1I = null;
  this.a1J = false;
}
$p = $c_Lcom_papasofokli_planning_SubjectJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectJS$;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectJS$() {
}
$h_Lcom_papasofokli_planning_SubjectJS$.prototype = $p;
$p.g = (function() {
  return "SubjectJS";
});
$p.q = (function() {
  if ((!this.a1J)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1I = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_SubjectJS$$anon$15(MacroImplicits_this, 7, this), new $c_Lcom_papasofokli_planning_SubjectJS$$anon$16(MacroImplicits_this, this));
    this.a1J = true;
  }
  return this.a1I;
});
$p.arF = (function(ReadersVersionSpecific_this$30) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arG = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_SubjectJS(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], (!(!params$2.a[6])))));
});
var $d_Lcom_papasofokli_planning_SubjectJS$ = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectJS$, "com.papasofokli.planning.SubjectJS$", ({
  qp: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_SubjectJS$;
function $m_Lcom_papasofokli_planning_SubjectJS$() {
  if ((!$n_Lcom_papasofokli_planning_SubjectJS$)) {
    $n_Lcom_papasofokli_planning_SubjectJS$ = new $c_Lcom_papasofokli_planning_SubjectJS$();
  }
  return $n_Lcom_papasofokli_planning_SubjectJS$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectPlanningData$() {
  this.a1L = null;
  this.a1M = false;
}
$p = $c_Lcom_papasofokli_planning_SubjectPlanningData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectPlanningData$;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectPlanningData$() {
}
$h_Lcom_papasofokli_planning_SubjectPlanningData$.prototype = $p;
$p.g = (function() {
  return "SubjectPlanningData";
});
$p.q = (function() {
  if ((!this.a1M)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1L = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11(MacroImplicits_this, 5, this), new $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12(MacroImplicits_this, this));
    this.a1M = true;
  }
  return this.a1L;
});
$p.arH = (function(ReadersVersionSpecific_this$24) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arI = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_SubjectPlanningData(params$2.a[0], params$2.a[1], params$2.a[2], (!(!params$2.a[3])), params$2.a[4])));
});
var $d_Lcom_papasofokli_planning_SubjectPlanningData$ = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectPlanningData$, "com.papasofokli.planning.SubjectPlanningData$", ({
  qs: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_SubjectPlanningData$;
function $m_Lcom_papasofokli_planning_SubjectPlanningData$() {
  if ((!$n_Lcom_papasofokli_planning_SubjectPlanningData$)) {
    $n_Lcom_papasofokli_planning_SubjectPlanningData$ = new $c_Lcom_papasofokli_planning_SubjectPlanningData$();
  }
  return $n_Lcom_papasofokli_planning_SubjectPlanningData$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_SvgColor$() {
  this.a1O = null;
  this.a1P = false;
}
$p = $c_Lcom_papasofokli_planning_SvgColor$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SvgColor$;
/** @constructor */
function $h_Lcom_papasofokli_planning_SvgColor$() {
}
$h_Lcom_papasofokli_planning_SvgColor$.prototype = $p;
$p.g = (function() {
  return "SvgColor";
});
$p.q = (function() {
  if ((!this.a1P)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1O = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_SvgColor$$anon$23(MacroImplicits_this, 4, this), new $c_Lcom_papasofokli_planning_SvgColor$$anon$24(MacroImplicits_this, this));
    this.a1P = true;
  }
  return this.a1O;
});
$p.arJ = (function(ReadersVersionSpecific_this$42) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arK = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_SvgColor((params$2.a[0] | 0), (params$2.a[1] | 0), (params$2.a[2] | 0), (+params$2.a[3]))));
});
var $d_Lcom_papasofokli_planning_SvgColor$ = new $TypeData().i($c_Lcom_papasofokli_planning_SvgColor$, "com.papasofokli.planning.SvgColor$", ({
  qv: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_SvgColor$;
function $m_Lcom_papasofokli_planning_SvgColor$() {
  if ((!$n_Lcom_papasofokli_planning_SvgColor$)) {
    $n_Lcom_papasofokli_planning_SvgColor$ = new $c_Lcom_papasofokli_planning_SvgColor$();
  }
  return $n_Lcom_papasofokli_planning_SvgColor$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$() {
  this.a1R = null;
  this.a1S = false;
}
$p = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$;
/** @constructor */
function $h_Lcom_papasofokli_planning_UUIDRowWithPeriod$() {
}
$h_Lcom_papasofokli_planning_UUIDRowWithPeriod$.prototype = $p;
$p.g = (function() {
  return "UUIDRowWithPeriod";
});
$p.q = (function() {
  if ((!this.a1S)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1R = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19(MacroImplicits_this, 2, this), new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20(MacroImplicits_this, this));
    this.a1S = true;
  }
  return this.a1R;
});
$p.arL = (function(ReadersVersionSpecific_this$36) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arM = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod(params$2.a[0], params$2.a[1])));
});
var $d_Lcom_papasofokli_planning_UUIDRowWithPeriod$ = new $TypeData().i($c_Lcom_papasofokli_planning_UUIDRowWithPeriod$, "com.papasofokli.planning.UUIDRowWithPeriod$", ({
  qy: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_UUIDRowWithPeriod$;
function $m_Lcom_papasofokli_planning_UUIDRowWithPeriod$() {
  if ((!$n_Lcom_papasofokli_planning_UUIDRowWithPeriod$)) {
    $n_Lcom_papasofokli_planning_UUIDRowWithPeriod$ = new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$();
  }
  return $n_Lcom_papasofokli_planning_UUIDRowWithPeriod$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_VerticalDateLine$() {
  this.a1U = null;
  this.a1V = false;
}
$p = $c_Lcom_papasofokli_planning_VerticalDateLine$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VerticalDateLine$;
/** @constructor */
function $h_Lcom_papasofokli_planning_VerticalDateLine$() {
}
$h_Lcom_papasofokli_planning_VerticalDateLine$.prototype = $p;
$p.g = (function() {
  return "VerticalDateLine";
});
$p.q = (function() {
  if ((!this.a1V)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1U = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$5(MacroImplicits_this, 4, this), new $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$6(MacroImplicits_this, this));
    this.a1V = true;
  }
  return this.a1U;
});
$p.arN = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arO = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_planning_VerticalDateLine($x_1.l, $x_1.h, params$2.a[1], params$2.a[2], params$2.a[3]);
  }));
});
var $d_Lcom_papasofokli_planning_VerticalDateLine$ = new $TypeData().i($c_Lcom_papasofokli_planning_VerticalDateLine$, "com.papasofokli.planning.VerticalDateLine$", ({
  qB: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_VerticalDateLine$;
function $m_Lcom_papasofokli_planning_VerticalDateLine$() {
  if ((!$n_Lcom_papasofokli_planning_VerticalDateLine$)) {
    $n_Lcom_papasofokli_planning_VerticalDateLine$ = new $c_Lcom_papasofokli_planning_VerticalDateLine$();
  }
  return $n_Lcom_papasofokli_planning_VerticalDateLine$;
}
/** @constructor */
function $c_Lcom_papasofokli_planning_VesselScheduleJS$() {
  this.a1X = null;
  this.a1Y = false;
}
$p = $c_Lcom_papasofokli_planning_VesselScheduleJS$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VesselScheduleJS$;
/** @constructor */
function $h_Lcom_papasofokli_planning_VesselScheduleJS$() {
}
$h_Lcom_papasofokli_planning_VesselScheduleJS$.prototype = $p;
$p.g = (function() {
  return "VesselScheduleJS";
});
$p.q = (function() {
  if ((!this.a1Y)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a1X = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37(MacroImplicits_this, 11, this), new $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38(MacroImplicits_this, this));
    this.a1Y = true;
  }
  return this.a1X;
});
$p.arP = (function(ReadersVersionSpecific_this$69) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arQ = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_9 = $uJ(params$2.a[0]);
    var $x_8 = $uJ(params$2.a[1]);
    var $x_7 = $uJ(params$2.a[2]);
    var $x_6 = params$2.a[3];
    var $x_5 = params$2.a[4];
    var $x_4 = params$2.a[5];
    var $x_3 = params$2.a[6];
    var $x_2 = $uJ(params$2.a[7]);
    var $x_1 = $uJ(params$2.a[8]);
    return new $c_Lcom_papasofokli_planning_VesselScheduleJS($x_9.l, $x_9.h, $x_8.l, $x_8.h, $x_7.l, $x_7.h, $x_6, $x_5, $x_4, $x_3, $x_2.l, $x_2.h, $x_1.l, $x_1.h, params$2.a[9], params$2.a[10]);
  }));
});
var $d_Lcom_papasofokli_planning_VesselScheduleJS$ = new $TypeData().i($c_Lcom_papasofokli_planning_VesselScheduleJS$, "com.papasofokli.planning.VesselScheduleJS$", ({
  qE: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_planning_VesselScheduleJS$;
function $m_Lcom_papasofokli_planning_VesselScheduleJS$() {
  if ((!$n_Lcom_papasofokli_planning_VesselScheduleJS$)) {
    $n_Lcom_papasofokli_planning_VesselScheduleJS$ = new $c_Lcom_papasofokli_planning_VesselScheduleJS$();
  }
  return $n_Lcom_papasofokli_planning_VesselScheduleJS$;
}
function $p_Lcom_papasofokli_planning_api_DivisionLabel__hiddenShowClass__F__T($thiz, height) {
  return ((height === 0.0) ? "hidden" : "");
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_DivisionLabel(labelName, labelClass, initialStartY, bottomRectPadding, totalLabelWidth, leftXComponent, departmentWidth, nonExtendedHeight, totalHeight, clickDivision) {
  this.a21 = null;
  this.a22 = false;
  this.a23 = 0.0;
  this.JK = null;
  this.JJ = 0.0;
  this.AZ = null;
  this.JI = null;
  this.a23 = bottomRectPadding;
  this.JK = nonExtendedHeight;
  this.JJ = Math.fround((leftXComponent + departmentWidth));
  var relativeY = Math.fround(nonExtendedHeight.aA());
  var height = $m_Lcom_papasofokli_util_misc_package$().V3(Math.fround((Math.fround((Math.fround(totalHeight.aA()) - relativeY)) - bottomRectPadding)));
  this.AZ = new $c_Lcom_papasofokli_svg_components_TextComponent($m_s_Option$().Z(("planning-right-side-text-large not-selectable " + $p_Lcom_papasofokli_planning_api_DivisionLabel__hiddenShowClass__F__T(this, height))), labelName, Math.fround((Math.fround((this.JJ + totalLabelWidth)) - 20.0)), Math.fround((Math.fround((initialStartY + relativeY)) + 20.0)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), new $c_s_Some(0.5), $m_Lcom_papasofokli_svg_components_TextComponent$().hb(), true, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  this.JI = new $c_Lcom_papasofokli_svg_components_RectComponent($m_s_Option$().Z(labelClass), height, totalLabelWidth, Math.fround((this.JJ + 10.0)), Math.fround((initialStartY + relativeY)), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), clickDivision, $m_s_None$(), $m_Lcom_papasofokli_svg_components_RectComponent$().hI(), $m_s_None$(), $m_s_None$(), true, $m_s_None$(), new $c_s_Some(0.5), $m_s_None$(), $m_s_None$(), $m_s_None$());
}
$p = $c_Lcom_papasofokli_planning_api_DivisionLabel.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_DivisionLabel;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_DivisionLabel() {
}
$h_Lcom_papasofokli_planning_api_DivisionLabel.prototype = $p;
$p.di = (function() {
  if ((!this.a22)) {
    this.a21 = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allShapes__sci_Seq(this);
    this.a22 = true;
  }
  return this.a21;
});
$p.akf = (function(newStartY) {
  this.JI.cT(this.JJ, Math.fround((newStartY + Math.fround(this.JK.aA()))));
  this.AZ.cT(this.AZ.m6, Math.fround((Math.fround((newStartY + Math.fround(this.JK.aA()))) + 20.0)));
});
$p.axk = (function(nextTotalHeight, lastStartY) {
  var relativeYLabel = Math.fround(this.JK.aA());
  var heightLabel = $m_Lcom_papasofokli_util_misc_package$().V3(Math.fround((Math.fround((nextTotalHeight - relativeYLabel)) - this.a23)));
  if ((heightLabel === 0.0)) {
    $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this.AZ, "hidden");
  } else {
    $f_Lcom_papasofokli_svg_components_SvgComponent__removeClass__T__V(this.AZ, "hidden");
  }
  this.JI.gN(heightLabel);
  this.akf(lastStartY);
});
$p.Mc = (function() {
  return new $c_sci_$colon$colon(this.JI, new $c_sci_$colon$colon(this.AZ, $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_planning_api_DivisionLabel = new $TypeData().i($c_Lcom_papasofokli_planning_api_DivisionLabel, "com.papasofokli.planning.api.DivisionLabel", ({
  qI: 1,
  aj: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_popover_PopoverSetupData$() {
  this.a4Z = null;
  this.a50 = false;
}
$p = $c_Lcom_papasofokli_popover_PopoverSetupData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_popover_PopoverSetupData$;
/** @constructor */
function $h_Lcom_papasofokli_popover_PopoverSetupData$() {
}
$h_Lcom_papasofokli_popover_PopoverSetupData$.prototype = $p;
$p.g = (function() {
  return "PopoverSetupData";
});
$p.q = (function() {
  if ((!this.a50)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a4Z = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$1(MacroImplicits_this, 8, this), new $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$2(MacroImplicits_this, this));
    this.a50 = true;
  }
  return this.a4Z;
});
$p.arR = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arS = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_popover_PopoverSetupData(params$2.a[0], params$2.a[1], (!(!params$2.a[2])), (!(!params$2.a[3])), params$2.a[4], params$2.a[5], (!(!params$2.a[6])), (params$2.a[7] | 0))));
});
var $d_Lcom_papasofokli_popover_PopoverSetupData$ = new $TypeData().i($c_Lcom_papasofokli_popover_PopoverSetupData$, "com.papasofokli.popover.PopoverSetupData$", ({
  ra: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_popover_PopoverSetupData$;
function $m_Lcom_papasofokli_popover_PopoverSetupData$() {
  if ((!$n_Lcom_papasofokli_popover_PopoverSetupData$)) {
    $n_Lcom_papasofokli_popover_PopoverSetupData$ = new $c_Lcom_papasofokli_popover_PopoverSetupData$();
  }
  return $n_Lcom_papasofokli_popover_PopoverSetupData$;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$4, x0$lzy1$1, x1$lzy1$1) {
  if (x2$lzy1$1.i) {
    var $x_1 = x2$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_rating_RatingClientMessages$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$4), $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$4));
    var this$3 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x2$lzy1$1.E(ReadersVersionSpecific_this$4.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$5, x0$lzy1$2, x1$lzy1$2) {
  return (x2$lzy1$2.i ? x2$lzy1$2.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy1$2, ReadersVersionSpecific_this$5, x0$lzy1$2, x1$lzy1$2));
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$6) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$3(ReadersVersionSpecific_this$6, 1, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$6.aq(), "$type", "com.papasofokli.rating.OptionChangedRating", "OptionChangedRating", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$10) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$11) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$4(ReadersVersionSpecific_this$11, 0, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$11.aq(), "$type", "com.papasofokli.rating.InitializeRating", "InitializeRating", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$15) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$15));
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$3, x0$lzy2$1, x1$lzy2$1) {
  if (x2$lzy2$1.i) {
    var $x_1 = x2$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_rating_RatingClientMessages$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$3), $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$3));
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x2$lzy2$1.E(WritersVersionSpecific_this$3.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$4, x0$lzy2$2, x1$lzy2$2) {
  return (x2$lzy2$2.i ? x2$lzy2$2.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy2$2, WritersVersionSpecific_this$4, x0$lzy2$2, x1$lzy2$2));
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$5) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy5__runtimeClass;
    var evidence$1$proxy5__runtimeClass = $d_Lcom_papasofokli_rating_OptionChangedRating.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$5, new $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$5(WritersVersionSpecific_this$5, $thiz), "$type", "com.papasofokli.rating.OptionChangedRating", "OptionChangedRating", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy5__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$8) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$8));
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$9) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy6__runtimeClass;
    var evidence$1$proxy6__runtimeClass = $d_Lcom_papasofokli_rating_InitializeRating.l();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$9, new $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$6(WritersVersionSpecific_this$9, $thiz), "$type", "com.papasofokli.rating.InitializeRating", "InitializeRating", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy6__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$12) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_rating_RatingClientMessages$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$12));
}
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingClientMessages$() {
  this.a5b = null;
  this.a5c = false;
}
$p = $c_Lcom_papasofokli_rating_RatingClientMessages$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingClientMessages$;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingClientMessages$() {
}
$h_Lcom_papasofokli_rating_RatingClientMessages$.prototype = $p;
$p.q = (function() {
  if ((!this.a5c)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a5b = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_rating_RatingClientMessages$__x2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_rating_RatingClientMessages$__x2$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a5c = true;
  }
  return this.a5b;
});
$p.arT = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arU = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_rating_OptionChangedRating(params$2.a[0])));
});
$p.arV = (function(ReadersVersionSpecific_this$13) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arW = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_rating_InitializeRating()));
});
var $d_Lcom_papasofokli_rating_RatingClientMessages$ = new $TypeData().i($c_Lcom_papasofokli_rating_RatingClientMessages$, "com.papasofokli.rating.RatingClientMessages$", ({
  rn: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_rating_RatingClientMessages$;
function $m_Lcom_papasofokli_rating_RatingClientMessages$() {
  if ((!$n_Lcom_papasofokli_rating_RatingClientMessages$)) {
    $n_Lcom_papasofokli_rating_RatingClientMessages$ = new $c_Lcom_papasofokli_rating_RatingClientMessages$();
  }
  return $n_Lcom_papasofokli_rating_RatingClientMessages$;
}
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingInitialData$() {
  this.a5f = null;
  this.a5g = false;
}
$p = $c_Lcom_papasofokli_rating_RatingInitialData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingInitialData$;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingInitialData$() {
}
$h_Lcom_papasofokli_rating_RatingInitialData$.prototype = $p;
$p.g = (function() {
  return "RatingInitialData";
});
$p.q = (function() {
  if ((!this.a5g)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a5f = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_rating_RatingInitialData$$anon$1(MacroImplicits_this, 4, this), new $c_Lcom_papasofokli_rating_RatingInitialData$$anon$2(MacroImplicits_this, this));
    this.a5g = true;
  }
  return this.a5f;
});
$p.arX = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.arY = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_rating_RatingInitialData(params$2.a[0], params$2.a[1], (!(!params$2.a[2])), params$2.a[3])));
});
var $d_Lcom_papasofokli_rating_RatingInitialData$ = new $TypeData().i($c_Lcom_papasofokli_rating_RatingInitialData$, "com.papasofokli.rating.RatingInitialData$", ({
  rs: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_rating_RatingInitialData$;
function $m_Lcom_papasofokli_rating_RatingInitialData$() {
  if ((!$n_Lcom_papasofokli_rating_RatingInitialData$)) {
    $n_Lcom_papasofokli_rating_RatingInitialData$ = new $c_Lcom_papasofokli_rating_RatingInitialData$();
  }
  return $n_Lcom_papasofokli_rating_RatingInitialData$;
}
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$() {
  this.a5n = null;
  this.a5o = false;
}
$p = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$() {
}
$h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$.prototype = $p;
$p.g = (function() {
  return "SortableConnectedListsSetupData";
});
$p.q = (function() {
  if ((!this.a5o)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a5n = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1(MacroImplicits_this, 9, this), new $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2(MacroImplicits_this, this));
    this.a5o = true;
  }
  return this.a5n;
});
$p.as0 = (function(ReadersVersionSpecific_this$2) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.as1 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData(params$2.a[0], params$2.a[1], params$2.a[2], params$2.a[3], params$2.a[4], params$2.a[5], params$2.a[6], params$2.a[7], params$2.a[8])));
});
var $d_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$ = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$, "com.papasofokli.sortable.SortableConnectedListsSetupData$", ({
  rA: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$;
function $m_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$() {
  if ((!$n_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$)) {
    $n_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$ = new $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$();
  }
  return $n_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$;
}
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableElement$() {
  this.a5q = null;
  this.a5r = false;
}
$p = $c_Lcom_papasofokli_sortable_SortableElement$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableElement$;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableElement$() {
}
$h_Lcom_papasofokli_sortable_SortableElement$.prototype = $p;
$p.g = (function() {
  return "SortableElement";
});
$p.q = (function() {
  if ((!this.a5r)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a5q = MacroImplicits_this.ap().aQ(new $c_Lcom_papasofokli_sortable_SortableElement$$anon$5(MacroImplicits_this, 3, this), new $c_Lcom_papasofokli_sortable_SortableElement$$anon$6(MacroImplicits_this, this));
    this.a5r = true;
  }
  return this.a5q;
});
$p.as2 = (function(ReadersVersionSpecific_this$8) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.as3 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    var $x_1 = $uJ(params$2.a[0]);
    return new $c_Lcom_papasofokli_sortable_SortableElement($x_1.l, $x_1.h, params$2.a[1], params$2.a[2]);
  }));
});
var $d_Lcom_papasofokli_sortable_SortableElement$ = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableElement$, "com.papasofokli.sortable.SortableElement$", ({
  rE: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_sortable_SortableElement$;
function $m_Lcom_papasofokli_sortable_SortableElement$() {
  if ((!$n_Lcom_papasofokli_sortable_SortableElement$)) {
    $n_Lcom_papasofokli_sortable_SortableElement$ = new $c_Lcom_papasofokli_sortable_SortableElement$();
  }
  return $n_Lcom_papasofokli_sortable_SortableElement$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_LineSVG$() {
}
$p = $c_Lcom_papasofokli_svg_api_LineSVG$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_LineSVG$;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_LineSVG$() {
}
$h_Lcom_papasofokli_svg_api_LineSVG$.prototype = $p;
$p.g = (function() {
  return "LineSVG";
});
$p.alL = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_api_LineSVG$ = new $TypeData().i($c_Lcom_papasofokli_svg_api_LineSVG$, "com.papasofokli.svg.api.LineSVG$", ({
  rL: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_svg_api_LineSVG$;
function $m_Lcom_papasofokli_svg_api_LineSVG$() {
  if ((!$n_Lcom_papasofokli_svg_api_LineSVG$)) {
    $n_Lcom_papasofokli_svg_api_LineSVG$ = new $c_Lcom_papasofokli_svg_api_LineSVG$();
  }
  return $n_Lcom_papasofokli_svg_api_LineSVG$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_TextAdjustStrategy$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.a6Q = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_svg_api_TextAdjustStrategy$ = this;
  this.a6Q = new $c_s_Enumeration$Val(this, this.bI, "spacingAndGlyphs");
  new $c_s_Enumeration$Val(this, this.bI, "spacing");
}
$p = $c_Lcom_papasofokli_svg_api_TextAdjustStrategy$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_svg_api_TextAdjustStrategy$;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_TextAdjustStrategy$() {
}
$h_Lcom_papasofokli_svg_api_TextAdjustStrategy$.prototype = $p;
var $d_Lcom_papasofokli_svg_api_TextAdjustStrategy$ = new $TypeData().i($c_Lcom_papasofokli_svg_api_TextAdjustStrategy$, "com.papasofokli.svg.api.TextAdjustStrategy$", ({
  rM: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_svg_api_TextAdjustStrategy$;
function $m_Lcom_papasofokli_svg_api_TextAdjustStrategy$() {
  if ((!$n_Lcom_papasofokli_svg_api_TextAdjustStrategy$)) {
    $n_Lcom_papasofokli_svg_api_TextAdjustStrategy$ = new $c_Lcom_papasofokli_svg_api_TextAdjustStrategy$();
  }
  return $n_Lcom_papasofokli_svg_api_TextAdjustStrategy$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight(finalX, durationInSeconds, beginAfterLoadInSec) {
  this.a76 = null;
  this.a77 = false;
  this.a72 = null;
  this.a73 = false;
  this.a79 = null;
  this.a75 = 0.0;
  this.a74 = 0.0;
  this.a71 = 0.0;
  this.a70 = null;
  this.a7b = null;
  this.a78 = null;
  this.a7a = null;
  this.a75 = finalX;
  this.a74 = durationInSeconds;
  this.a71 = beginAfterLoadInSec;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a70 = $m_s_None$();
  this.a7b = $m_s_None$();
  this.a78 = $m_s_None$();
  this.a7a = "animateTransform";
}
$p = $c_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight() {
}
$h_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight.prototype = $p;
$p.g9 = (function() {
  if ((!this.a77)) {
    this.a76 = $m_ju_UUID$().aW();
    this.a77 = true;
  }
  return this.a76;
});
$p.oG = (function() {
  if ((!this.a73)) {
    this.a72 = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a73 = true;
  }
  return this.a72;
});
$p.oT = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a79;
});
$p.zx = (function(x$0) {
  this.a79 = x$0;
});
$p.oC = (function() {
  return this.a70;
});
$p.p1 = (function() {
  return this.a7b;
});
$p.oP = (function() {
  return this.a78;
});
$p.oE = (function() {
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("repeatCount", "1"), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("begin", (this.a71 + "s")), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("attributeName", "transform"), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("type", "translate"), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("dur", (("" + this.a74) + "s")), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("values", (("-" + this.a75) + " 0; 0 0;")), $m_sci_Nil$()))))));
});
$p.oZ = (function() {
  return this.a7a;
});
$p.oQ = (function() {
  return $m_sci_Nil$();
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.p0 = (function() {
  return $m_s_None$();
});
var $d_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight = new $TypeData().i($c_Lcom_papasofokli_svg_api_animations_AnimateTransformLeftToRight, "com.papasofokli.svg.api.animations.AnimateTransformLeftToRight", ({
  rO: 1,
  aH: 1,
  b0: 1
}));
function $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor() {
  $m_Lcom_papasofokli_svg_components_HorizontalAnchor$();
  return $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor;
}
function $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor() {
  $m_Lcom_papasofokli_svg_components_HorizontalAnchor$();
  return $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor;
}
function $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor() {
  $m_Lcom_papasofokli_svg_components_HorizontalAnchor$();
  return $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_HorizontalAnchor$() {
  $n_Lcom_papasofokli_svg_components_HorizontalAnchor$ = this;
  $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor = new $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1("LeftAnchor", 0);
  $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor = new $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1("CenterAnchor", 1);
  $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor = new $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1("RightAnchor", 2);
  $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
  $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
  $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
}
$p = $c_Lcom_papasofokli_svg_components_HorizontalAnchor$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_HorizontalAnchor$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_HorizontalAnchor$() {
}
$h_Lcom_papasofokli_svg_components_HorizontalAnchor$.prototype = $p;
var $d_Lcom_papasofokli_svg_components_HorizontalAnchor$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_HorizontalAnchor$, "com.papasofokli.svg.components.HorizontalAnchor$", ({
  rR: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_svg_components_HorizontalAnchor$;
function $m_Lcom_papasofokli_svg_components_HorizontalAnchor$() {
  if ((!$n_Lcom_papasofokli_svg_components_HorizontalAnchor$)) {
    $n_Lcom_papasofokli_svg_components_HorizontalAnchor$ = new $c_Lcom_papasofokli_svg_components_HorizontalAnchor$();
  }
  return $n_Lcom_papasofokli_svg_components_HorizontalAnchor$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_IconTextComponent$() {
}
$p = $c_Lcom_papasofokli_svg_components_IconTextComponent$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_IconTextComponent$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_IconTextComponent$() {
}
$h_Lcom_papasofokli_svg_components_IconTextComponent$.prototype = $p;
$p.g = (function() {
  return "IconTextComponent";
});
$p.afn = (function() {
  return $m_sci_Map$EmptyMap$();
});
$p.hb = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_components_IconTextComponent$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_IconTextComponent$, "com.papasofokli.svg.components.IconTextComponent$", ({
  rT: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_svg_components_IconTextComponent$;
function $m_Lcom_papasofokli_svg_components_IconTextComponent$() {
  if ((!$n_Lcom_papasofokli_svg_components_IconTextComponent$)) {
    $n_Lcom_papasofokli_svg_components_IconTextComponent$ = new $c_Lcom_papasofokli_svg_components_IconTextComponent$();
  }
  return $n_Lcom_papasofokli_svg_components_IconTextComponent$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_RectComponent$() {
}
$p = $c_Lcom_papasofokli_svg_components_RectComponent$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_RectComponent$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_RectComponent$() {
}
$h_Lcom_papasofokli_svg_components_RectComponent$.prototype = $p;
$p.g = (function() {
  return "RectComponent";
});
$p.hI = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_components_RectComponent$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_RectComponent$, "com.papasofokli.svg.components.RectComponent$", ({
  rW: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_svg_components_RectComponent$;
function $m_Lcom_papasofokli_svg_components_RectComponent$() {
  if ((!$n_Lcom_papasofokli_svg_components_RectComponent$)) {
    $n_Lcom_papasofokli_svg_components_RectComponent$ = new $c_Lcom_papasofokli_svg_components_RectComponent$();
  }
  return $n_Lcom_papasofokli_svg_components_RectComponent$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_TextComponent$() {
}
$p = $c_Lcom_papasofokli_svg_components_TextComponent$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_TextComponent$;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_TextComponent$() {
}
$h_Lcom_papasofokli_svg_components_TextComponent$.prototype = $p;
$p.g = (function() {
  return "TextComponent";
});
$p.hb = (function() {
  return new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_components_TextComponent$ = new $TypeData().i($c_Lcom_papasofokli_svg_components_TextComponent$, "com.papasofokli.svg.components.TextComponent$", ({
  rY: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_svg_components_TextComponent$;
function $m_Lcom_papasofokli_svg_components_TextComponent$() {
  if ((!$n_Lcom_papasofokli_svg_components_TextComponent$)) {
    $n_Lcom_papasofokli_svg_components_TextComponent$ = new $c_Lcom_papasofokli_svg_components_TextComponent$();
  }
  return $n_Lcom_papasofokli_svg_components_TextComponent$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_DayFullTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_DayFullTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_DayFullTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_DayFullTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_DayFullTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M6(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().IF(startDate);
});
$p.oO = (function(date) {
  return $f_Lcom_papasofokli_svg_timeline_DayTickInterval__highlightDate__sjs_js_Date__Z(this, date);
});
$p.kJ = (function(date) {
  return (((($m_Lcom_papasofokli_util_DateUtilsJS$().MQ(date) + " ") + $m_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$().kJ(date)) + " ") + $m_Lcom_papasofokli_util_DateUtilsJS$().Uz(date));
});
var $d_Lcom_papasofokli_svg_timeline_DayFullTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_DayFullTickInterval$, "com.papasofokli.svg.timeline.DayFullTickInterval$", ({
  s0: 1,
  aI: 1,
  bM: 1
}));
var $n_Lcom_papasofokli_svg_timeline_DayFullTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_DayFullTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_DayFullTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_DayFullTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_DayFullTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_DayFullTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M6(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().IF(startDate);
});
$p.oO = (function(date) {
  return $f_Lcom_papasofokli_svg_timeline_DayTickInterval__highlightDate__sjs_js_Date__Z(this, date);
});
$p.kJ = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().MQ(date);
});
var $d_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$, "com.papasofokli.svg.timeline.DayLongWeekTickInterval$", ({
  s1: 1,
  aI: 1,
  bM: 1
}));
var $n_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M6(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().IF(startDate);
});
$p.oO = (function(date) {
  return $f_Lcom_papasofokli_svg_timeline_DayTickInterval__highlightDate__sjs_js_Date__Z(this, date);
});
$p.kJ = (function(date) {
  return ("" + (+date.getUTCDate()));
});
var $d_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$, "com.papasofokli.svg.timeline.DayMonthTickInterval$", ({
  s2: 1,
  aI: 1,
  bM: 1
}));
var $n_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M6(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().IF(startDate);
});
$p.oO = (function(date) {
  return $f_Lcom_papasofokli_svg_timeline_DayTickInterval__highlightDate__sjs_js_Date__Z(this, date);
});
$p.kJ = (function(date) {
  return ("" + $cToS($m_sc_StringOps$().ahF($m_Lcom_papasofokli_util_DateUtilsJS$().MQ(date))));
});
var $d_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$, "com.papasofokli.svg.timeline.DayShortWeekTickInterval$", ({
  s3: 1,
  aI: 1,
  bM: 1
}));
var $n_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M8(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().ML(startDate);
});
$p.oO = (function(date) {
  return false;
});
$p.kJ = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().Uz(date);
});
var $d_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$, "com.papasofokli.svg.timeline.MonthLongTickInterval$", ({
  s5: 1,
  aI: 1,
  ck: 1
}));
var $n_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M8(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().ML(startDate);
});
$p.oO = (function(date) {
  return false;
});
$p.kJ = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().auu(date);
});
var $d_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$, "com.papasofokli.svg.timeline.MonthShortTickInterval$", ({
  s6: 1,
  aI: 1,
  ck: 1
}));
var $n_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$() {
}
$p = $c_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$() {
}
$h_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$.prototype = $p;
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext");
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().M8(date, 1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().ML(startDate);
});
$p.oO = (function(date) {
  return false;
});
$p.kJ = (function(date) {
  return ("" + ((+date.getUTCMonth()) + 1.0));
});
var $d_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$ = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$, "com.papasofokli.svg.timeline.MonthShorterTickInterval$", ({
  s7: 1,
  aI: 1,
  ck: 1
}));
var $n_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$;
function $m_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$() {
  if ((!$n_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$)) {
    $n_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$ = new $c_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$();
  }
  return $n_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$;
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineCell__hoverFun__F2__V($thiz, fun) {
  fun.cm($thiz.a7J, $thiz.a7G);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_TimeLineCell(start, end, sDate, eDate, tickInterval, yComp, getPosition, rowThickness, onHover, mouseOut, appendWithAnimationTime) {
  this.a7E = null;
  this.a7F = false;
  this.a7J = null;
  this.a7G = null;
  this.Qe = 0.0;
  this.a7K = null;
  this.a7H = null;
  this.a7I = null;
  this.a7J = sDate;
  this.a7G = eDate;
  var xCompStart = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(Math.fround(getPosition.p(sDate)), new $c_sci_$colon$colon(start, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  var xCompEnd = Math.fround($f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon(Math.fround(getPosition.p(eDate)), new $c_sci_$colon$colon(end, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  this.Qe = Math.fround((xCompEnd - xCompStart));
  var hoverFunction = (onHover.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((fun$2) => ((v1$2, v2$2) => {
    $p_Lcom_papasofokli_svg_timeline_TimeLineCell__hoverFun__F2__V(this, fun$2);
  }))(onHover.h()))));
  var initialClassName$1 = tickInterval.mB();
  var initialX$1 = Math.fround((0.5 * Math.fround((xCompStart + xCompEnd))));
  var initialY$1 = Math.fround((Math.fround((yComp + 5.0)) + Math.fround((0.5 * rowThickness))));
  this.a7K = new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$1, tickInterval.kJ(sDate), initialX$1, initialY$1, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), appendWithAnimationTime, $m_Lcom_papasofokli_svg_components_TextComponent$().hb(), false, hoverFunction, mouseOut, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  this.a7H = new $c_Lcom_papasofokli_svg_components_LineComponent($m_s_Option$().Z("axisline"), xCompStart, yComp, xCompStart, Math.fround((yComp + rowThickness)), $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_LineComponent$().DK(), false, hoverFunction, mouseOut, appendWithAnimationTime, $m_s_None$(), $m_ju_UUID$().aW());
  var backGround = (tickInterval.oO(sDate) ? "weekend" : $m_Lcom_papasofokli_planning_package$().Bn);
  var initialClassName$3 = $m_s_Option$().Z(backGround);
  var initialHeight$1 = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(rowThickness, new $c_sci_$colon$colon(0.0, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  var resizeUpFunction$1 = $m_s_None$();
  var resizeDownFunction$1 = $m_s_None$();
  var resizeLeftFunction$1 = $m_s_None$();
  var resizeRightFunction$1 = $m_s_None$();
  var dragFunction$3 = $m_s_None$();
  var clickFunction$3 = $m_s_None$();
  var contextMenuFunction$2 = $m_s_None$();
  var getGroupedDraggedShapes$3 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var href$2 = $m_s_None$();
  var color$2 = $m_s_None$();
  var stroke$3 = $m_s_None$();
  var onBoundHover$1 = $m_s_None$();
  this.a7I = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$3, initialHeight$1, this.Qe, xCompStart, yComp, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$3, clickFunction$3, contextMenuFunction$2, getGroupedDraggedShapes$3, hoverFunction, mouseOut, false, href$2, appendWithAnimationTime, color$2, stroke$3, onBoundHover$1);
}
$p = $c_Lcom_papasofokli_svg_timeline_TimeLineCell.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_TimeLineCell;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_TimeLineCell() {
}
$h_Lcom_papasofokli_svg_timeline_TimeLineCell.prototype = $p;
$p.di = (function() {
  if ((!this.a7F)) {
    this.a7E = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allShapes__sci_Seq(this);
    this.a7F = true;
  }
  return this.a7E;
});
$p.Mc = (function() {
  return new $c_sci_$colon$colon(this.a7I, $m_sci_Nil$()).cY(this.a7K.A7(this.Qe)).cY(new $c_sci_$colon$colon(this.a7H, $m_sci_Nil$()));
});
var $d_Lcom_papasofokli_svg_timeline_TimeLineCell = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_TimeLineCell, "com.papasofokli.svg.timeline.TimeLineCell", ({
  s8: 1,
  aj: 1,
  bL: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AttachmentBoxIcon$() {
  $n_Lcom_papasofokli_util_AttachmentBoxIcon$ = this;
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
  $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
}
$p = $c_Lcom_papasofokli_util_AttachmentBoxIcon$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_AttachmentBoxIcon$;
/** @constructor */
function $h_Lcom_papasofokli_util_AttachmentBoxIcon$() {
}
$h_Lcom_papasofokli_util_AttachmentBoxIcon$.prototype = $p;
var $d_Lcom_papasofokli_util_AttachmentBoxIcon$ = new $TypeData().i($c_Lcom_papasofokli_util_AttachmentBoxIcon$, "com.papasofokli.util.AttachmentBoxIcon$", ({
  sl: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_util_AttachmentBoxIcon$;
function $m_Lcom_papasofokli_util_AttachmentBoxIcon$() {
  if ((!$n_Lcom_papasofokli_util_AttachmentBoxIcon$)) {
    $n_Lcom_papasofokli_util_AttachmentBoxIcon$ = new $c_Lcom_papasofokli_util_AttachmentBoxIcon$();
  }
  return $n_Lcom_papasofokli_util_AttachmentBoxIcon$;
}
function $p_Lcom_papasofokli_util_GeneralText$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1, x3$lzy1$1, x4$lzy1$1) {
  if (x5$lzy1$1.i) {
    var $x_1 = x5$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T5($p_Lcom_papasofokli_util_GeneralText$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$1, ReadersVersionSpecific_this$1));
    var this$2 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$2);
    var $x_1 = x5$lzy1$1.E(ReadersVersionSpecific_this$1.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x5$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2) {
  return (x5$lzy1$2.i ? x5$lzy1$2.j : $p_Lcom_papasofokli_util_GeneralText$__x5$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x5$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2, x4$lzy1$2));
}
function $p_Lcom_papasofokli_util_GeneralText$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x4$lzy1$3.i) {
    var $x_1 = x4$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_util_GeneralText$$anon$1(ReadersVersionSpecific_this$3, 1, $thiz);
    var $x_1 = x4$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.util.SpanTextContainer", "SpanTextContainer", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x4$lzy1$4.i ? x4$lzy1$4.j : $p_Lcom_papasofokli_util_GeneralText$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x4$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lcom_papasofokli_util_GeneralText$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$3, ReadersVersionSpecific_this$8) {
  if (x3$lzy1$3.i) {
    var $x_1 = x3$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_util_GeneralText$$anon$2(ReadersVersionSpecific_this$8, 3, $thiz);
    var $x_1 = x3$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$8.aq(), "$type", "com.papasofokli.util.GenderSymbolIcon", "GenderSymbolIcon", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$12) {
  return (x3$lzy1$4.i ? x3$lzy1$4.j : $p_Lcom_papasofokli_util_GeneralText$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_util_GeneralText$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$13) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_util_GeneralText$$anon$3(ReadersVersionSpecific_this$13, 2, $thiz);
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$13.aq(), "$type", "com.papasofokli.util.CountryFlagIcon", "CountryFlagIcon", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$17) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_util_GeneralText$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$17));
}
function $p_Lcom_papasofokli_util_GeneralText$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$18) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
    var reader = new $c_Lcom_papasofokli_util_GeneralText$$anon$4(ReadersVersionSpecific_this$18, 1, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$18.aq(), "$type", "com.papasofokli.util.AttachmentBoxIcon", "AttachmentBoxIcon", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$22) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_util_GeneralText$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_util_GeneralText$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$23) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    $m_Lcom_papasofokli_util_IconUI$();
    var reader = new $c_Lcom_papasofokli_util_GeneralText$$anon$5(ReadersVersionSpecific_this$23, 2, $thiz);
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$23.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$27) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_util_GeneralText$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$27));
}
function $p_Lcom_papasofokli_util_GeneralText$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1, x3$lzy2$1, x4$lzy2$1) {
  if (x5$lzy2$1.i) {
    var $x_1 = x5$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T5($p_Lcom_papasofokli_util_GeneralText$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_GeneralText$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$1, WritersVersionSpecific_this$1));
    var this$3 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x5$lzy2$1.E(WritersVersionSpecific_this$1.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x5$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2) {
  return (x5$lzy2$2.i ? x5$lzy2$2.j : $p_Lcom_papasofokli_util_GeneralText$__x5$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x5$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2, x4$lzy2$2));
}
function $p_Lcom_papasofokli_util_GeneralText$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$3, WritersVersionSpecific_this$3) {
  if (x4$lzy2$3.i) {
    var $x_1 = x4$lzy2$3.j;
  } else {
    var evidence$1$proxy2__runtimeClass;
    var evidence$1$proxy2__runtimeClass = $d_Lcom_papasofokli_util_SpanTextContainer.l();
    var $x_1 = x4$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lcom_papasofokli_util_GeneralText$$anon$6(WritersVersionSpecific_this$3, $thiz), "$type", "com.papasofokli.util.SpanTextContainer", "SpanTextContainer", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy2__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x4$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$6) {
  return (x4$lzy2$4.i ? x4$lzy2$4.j : $p_Lcom_papasofokli_util_GeneralText$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x4$lzy2$4, WritersVersionSpecific_this$6));
}
function $p_Lcom_papasofokli_util_GeneralText$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$3, WritersVersionSpecific_this$7) {
  if (x3$lzy2$3.i) {
    var $x_1 = x3$lzy2$3.j;
  } else {
    var evidence$1$proxy3__runtimeClass;
    var evidence$1$proxy3__runtimeClass = $d_Lcom_papasofokli_util_GenderSymbolIcon.l();
    var $x_1 = x3$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lcom_papasofokli_util_GeneralText$$anon$7(WritersVersionSpecific_this$7, $thiz), "$type", "com.papasofokli.util.GenderSymbolIcon", "GenderSymbolIcon", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy3__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$10) {
  return (x3$lzy2$4.i ? x3$lzy2$4.j : $p_Lcom_papasofokli_util_GeneralText$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_util_GeneralText$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$11) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var evidence$1$proxy4__runtimeClass;
    var evidence$1$proxy4__runtimeClass = $d_Lcom_papasofokli_util_CountryFlagIcon.l();
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lcom_papasofokli_util_GeneralText$$anon$8(WritersVersionSpecific_this$11, $thiz), "$type", "com.papasofokli.util.CountryFlagIcon", "CountryFlagIcon", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy4__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$14) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_util_GeneralText$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$14));
}
function $p_Lcom_papasofokli_util_GeneralText$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$15) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy5__runtimeClass;
    var evidence$1$proxy5__runtimeClass = $d_Lcom_papasofokli_util_AttachmentBoxIcon.l();
    $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$15, new $c_Lcom_papasofokli_util_GeneralText$$anon$9(WritersVersionSpecific_this$15, $thiz), "$type", "com.papasofokli.util.AttachmentBoxIcon", "AttachmentBoxIcon", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy5__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$18) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_util_GeneralText$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$18));
}
function $p_Lcom_papasofokli_util_GeneralText$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$19) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var evidence$1$proxy6__runtimeClass;
    var evidence$1$proxy6__runtimeClass = $d_Lcom_papasofokli_util_IconUI.l();
    $m_Lcom_papasofokli_util_IconUI$();
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$19, new $c_Lcom_papasofokli_util_GeneralText$$anon$10(WritersVersionSpecific_this$19, $thiz), "$type", "com.papasofokli.util.IconUI", "IconUI", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy6__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_GeneralText$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$22) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_util_GeneralText$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$22));
}
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$() {
  this.a8i = null;
  this.a8j = false;
}
$p = $c_Lcom_papasofokli_util_GeneralText$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$() {
}
$h_Lcom_papasofokli_util_GeneralText$.prototype = $p;
$p.q = (function() {
  if ((!this.a8j)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a8i = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_util_GeneralText$__x5$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_util_GeneralText$__x5$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a8j = true;
  }
  return this.a8i;
});
$p.as4 = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.as6 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_util_SpanTextContainer(params$2.a[0])));
});
$p.as7 = (function(ReadersVersionSpecific_this$10) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.as8 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_util_GenderSymbolIcon(params$2.a[0], params$2.a[1], params$2.a[2])));
});
$p.as9 = (function(ReadersVersionSpecific_this$15) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asa = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_util_CountryFlagIcon(params$2.a[0], params$2.a[1])));
});
$p.asb = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asc = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    $m_Lcom_papasofokli_util_AttachmentBoxIcon$();
    return new $c_Lcom_papasofokli_util_AttachmentBoxIcon(params$2.a[0]);
  }));
});
$p.asd = (function(ReadersVersionSpecific_this$25) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.as5 = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => {
    $m_Lcom_papasofokli_util_IconUI$();
    return new $c_Lcom_papasofokli_util_IconUI(params$2.a[0], params$2.a[1]);
  }));
});
var $d_Lcom_papasofokli_util_GeneralText$ = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$, "com.papasofokli.util.GeneralText$", ({
  ss: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_util_GeneralText$;
function $m_Lcom_papasofokli_util_GeneralText$() {
  if ((!$n_Lcom_papasofokli_util_GeneralText$)) {
    $n_Lcom_papasofokli_util_GeneralText$ = new $c_Lcom_papasofokli_util_GeneralText$();
  }
  return $n_Lcom_papasofokli_util_GeneralText$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_IconRotations$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.Cj = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_util_IconRotations$ = this;
  this.Cj = new $c_s_Enumeration$Val(this, this.bI, "");
  new $c_s_Enumeration$Val(this, this.bI, "fa-rotate-90");
  new $c_s_Enumeration$Val(this, this.bI, "fa-rotate-180");
  new $c_s_Enumeration$Val(this, this.bI, "fa-rotate-270");
  new $c_s_Enumeration$Val(this, this.bI, "fa-flip-horizontal");
  new $c_s_Enumeration$Val(this, this.bI, "fa-flip-vertical");
  new $c_s_Enumeration$Val(this, this.bI, "fa-spin");
  new $c_s_Enumeration$Val(this, this.bI, "fa-spin-pulse");
  new $c_s_Enumeration$Val(this, this.bI, "fa-bounce");
}
$p = $c_Lcom_papasofokli_util_IconRotations$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_util_IconRotations$;
/** @constructor */
function $h_Lcom_papasofokli_util_IconRotations$() {
}
$h_Lcom_papasofokli_util_IconRotations$.prototype = $p;
var $d_Lcom_papasofokli_util_IconRotations$ = new $TypeData().i($c_Lcom_papasofokli_util_IconRotations$, "com.papasofokli.util.IconRotations$", ({
  sE: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_util_IconRotations$;
function $m_Lcom_papasofokli_util_IconRotations$() {
  if ((!$n_Lcom_papasofokli_util_IconRotations$)) {
    $n_Lcom_papasofokli_util_IconRotations$ = new $c_Lcom_papasofokli_util_IconRotations$();
  }
  return $n_Lcom_papasofokli_util_IconRotations$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_IconSizes$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.Qw = null;
  this.a8r = null;
  this.a8q = null;
  this.a8s = null;
  this.a8p = null;
  this.a8u = null;
  this.xR = null;
  this.a8t = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_util_IconSizes$ = this;
  this.Qw = new $c_s_Enumeration$Val(this, this.bI, "");
  this.a8r = new $c_s_Enumeration$Val(this, this.bI, "fa-3x");
  this.a8q = new $c_s_Enumeration$Val(this, this.bI, "fa-2x");
  this.a8s = new $c_s_Enumeration$Val(this, this.bI, "fa-8x");
  this.a8p = new $c_s_Enumeration$Val(this, this.bI, "fa-lg");
  this.a8u = new $c_s_Enumeration$Val(this, this.bI, "fa-xl");
  this.xR = new $c_s_Enumeration$Val(this, this.bI, "fa-md");
  this.a8t = new $c_s_Enumeration$Val(this, this.bI, "fa-sm");
  $f_sci_Map__withDefaultValue__O__sci_Map($m_sci_Seq$().Mj($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [this.Qw, this.a8r, this.a8q, this.a8s, this.a8p, this.a8u, this.xR, this.a8t])).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => new $c_T2(t$2.g(), t$2)))).fd($m_s_$less$colon$less$().b0), this.Qw);
}
$p = $c_Lcom_papasofokli_util_IconSizes$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_util_IconSizes$;
/** @constructor */
function $h_Lcom_papasofokli_util_IconSizes$() {
}
$h_Lcom_papasofokli_util_IconSizes$.prototype = $p;
var $d_Lcom_papasofokli_util_IconSizes$ = new $TypeData().i($c_Lcom_papasofokli_util_IconSizes$, "com.papasofokli.util.IconSizes$", ({
  sF: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_util_IconSizes$;
function $m_Lcom_papasofokli_util_IconSizes$() {
  if ((!$n_Lcom_papasofokli_util_IconSizes$)) {
    $n_Lcom_papasofokli_util_IconSizes$ = new $c_Lcom_papasofokli_util_IconSizes$();
  }
  return $n_Lcom_papasofokli_util_IconSizes$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_IconTypes$() {
  this.mf = null;
  this.q4 = null;
  this.nZ = false;
  this.bI = 0;
  this.q3 = 0;
  this.j1 = 0;
  this.tl = null;
  this.tm = false;
  this.tn = null;
  this.to = false;
  this.Qx = null;
  this.a8w = null;
  this.a8x = null;
  this.a8v = null;
  $ct_s_Enumeration__I__(this, 0);
  $n_Lcom_papasofokli_util_IconTypes$ = this;
  new $c_s_Enumeration$Val(this, this.bI, "");
  this.Qx = new $c_s_Enumeration$Val(this, this.bI, "text-primary");
  this.a8w = new $c_s_Enumeration$Val(this, this.bI, "text-success");
  new $c_s_Enumeration$Val(this, this.bI, "text-info");
  this.a8x = new $c_s_Enumeration$Val(this, this.bI, "text-warning");
  this.a8v = new $c_s_Enumeration$Val(this, this.bI, "text-danger");
  new $c_s_Enumeration$Val(this, this.bI, "text-white");
  new $c_s_Enumeration$Val(this, this.bI, "text-body");
}
$p = $c_Lcom_papasofokli_util_IconTypes$.prototype = new $h_s_Enumeration();
$p.constructor = $c_Lcom_papasofokli_util_IconTypes$;
/** @constructor */
function $h_Lcom_papasofokli_util_IconTypes$() {
}
$h_Lcom_papasofokli_util_IconTypes$.prototype = $p;
var $d_Lcom_papasofokli_util_IconTypes$ = new $TypeData().i($c_Lcom_papasofokli_util_IconTypes$, "com.papasofokli.util.IconTypes$", ({
  sG: 1,
  bd: 1,
  a: 1
}));
var $n_Lcom_papasofokli_util_IconTypes$;
function $m_Lcom_papasofokli_util_IconTypes$() {
  if ((!$n_Lcom_papasofokli_util_IconTypes$)) {
    $n_Lcom_papasofokli_util_IconTypes$ = new $c_Lcom_papasofokli_util_IconTypes$();
  }
  return $n_Lcom_papasofokli_util_IconTypes$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_IconUI$() {
  this.a8D = null;
  this.a8H = null;
  this.a8I = null;
  this.QB = null;
  this.a8E = null;
  this.Ck = null;
  this.QA = null;
  this.t6 = null;
  this.a8B = null;
  this.a8Q = null;
  this.KA = null;
  this.a8C = null;
  this.a8J = null;
  this.a8N = null;
  this.a8O = null;
  this.a8F = null;
  this.Kz = null;
  this.a8L = null;
  this.a8A = null;
  this.a8z = null;
  this.Qz = null;
  this.a8M = null;
  this.a8K = null;
  this.Ky = null;
  this.a8y = null;
  this.Qy = null;
  this.a8G = null;
  this.a8P = null;
  $n_Lcom_papasofokli_util_IconUI$ = this;
  $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2("SGD", "USD")]));
  this.a8D = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-clipboard", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8H = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-expand-arrows-alt", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.a8I = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("far fa-expand-arrows", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.QB = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-user", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8E = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-times", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.Ck = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-bars", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.QA = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-sync", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.t6 = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-info-circle", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8B = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-bar-chart", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8Q = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-warning", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.KA = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("far fa-clock", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8C = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-check", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8J = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-home", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8N = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("far fa-trash-alt", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8O = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-chevron-up", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8F = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-cog", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8F.TA("fa-spin", $m_s_None$());
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.Kz = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-circle-notch", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8L = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-square", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8A = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-arrow-up", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.a8z = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-arrow-down", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.Qz = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-lock", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8M = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fas fa-thumbtack", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8K = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-regular fa-object-ungroup", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.Ky = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-regular fa-angle-right", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.a8y = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-regular fa-angle-down", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.Qy = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-solid fa-equals", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  this.a8G = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-solid fa-empty-set", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  this.a8P = ($m_Lcom_papasofokli_util_IconUI$(), new $c_Lcom_papasofokli_util_IconUI("fa-solid fa-ellipsis-vertical", ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$())));
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
  $m_Lcom_papasofokli_util_IconUI$();
}
$p = $c_Lcom_papasofokli_util_IconUI$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_IconUI$;
/** @constructor */
function $h_Lcom_papasofokli_util_IconUI$() {
}
$h_Lcom_papasofokli_util_IconUI$.prototype = $p;
var $d_Lcom_papasofokli_util_IconUI$ = new $TypeData().i($c_Lcom_papasofokli_util_IconUI$, "com.papasofokli.util.IconUI$", ({
  sH: 1,
  v: 1,
  w: 1
}));
var $n_Lcom_papasofokli_util_IconUI$;
function $m_Lcom_papasofokli_util_IconUI$() {
  if ((!$n_Lcom_papasofokli_util_IconUI$)) {
    $n_Lcom_papasofokli_util_IconUI$ = new $c_Lcom_papasofokli_util_IconUI$();
  }
  return $n_Lcom_papasofokli_util_IconUI$;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1, x3$lzy1$1) {
  if (x4$lzy1$1.i) {
    var $x_1 = x4$lzy1$1.j;
  } else {
    $m_Lcom_papasofokli_util_ProgressBarStyle$();
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_util_ProgressBarStyle$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$1));
    var this$2 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$2);
    var $x_1 = x4$lzy1$1.E(ReadersVersionSpecific_this$1.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2) {
  return (x4$lzy1$2.i ? x4$lzy1$2.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x3$lzy1$3.i) {
    var $x_1 = x3$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$1(ReadersVersionSpecific_this$3, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$3, $m_Lcom_papasofokli_util_DangerProgressBar$());
    var $x_1 = x3$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.util.DangerProgressBar", "DangerProgressBar", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x3$lzy1$4.i ? x3$lzy1$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$8) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$2(ReadersVersionSpecific_this$8, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$8, $m_Lcom_papasofokli_util_WarningProgressBar$());
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$8.aq(), "$type", "com.papasofokli.util.WarningProgressBar", "WarningProgressBar", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$12) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$13) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$3(ReadersVersionSpecific_this$13, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$13, $m_Lcom_papasofokli_util_SuccessProgressBar$());
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$13.aq(), "$type", "com.papasofokli.util.SuccessProgressBar", "SuccessProgressBar", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$17) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$17));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$18) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$4(ReadersVersionSpecific_this$18, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$18, $m_Lcom_papasofokli_util_PrimaryProgressBar$());
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$18.aq(), "$type", "com.papasofokli.util.PrimaryProgressBar", "PrimaryProgressBar", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$22) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1, x3$lzy2$1) {
  if (x4$lzy2$1.i) {
    var $x_1 = x4$lzy2$1.j;
  } else {
    $m_Lcom_papasofokli_util_ProgressBarStyle$();
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_util_ProgressBarStyle$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$1));
    var this$3 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x4$lzy2$1.E(WritersVersionSpecific_this$1.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2) {
  return (x4$lzy2$2.i ? x4$lzy2$2.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$3, WritersVersionSpecific_this$3) {
  if (x3$lzy2$3.i) {
    var $x_1 = x3$lzy2$3.j;
  } else {
    var $x_1 = x3$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$3, null), "$type", "com.papasofokli.util.DangerProgressBar", "DangerProgressBar", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_DangerProgressBar$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$6) {
  return (x3$lzy2$4.i ? x3$lzy2$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$6));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$7) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$7, null), "$type", "com.papasofokli.util.WarningProgressBar", "WarningProgressBar", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_WarningProgressBar$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$10) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$11) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$11, null), "$type", "com.papasofokli.util.SuccessProgressBar", "SuccessProgressBar", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_SuccessProgressBar$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$14) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$14));
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$15) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$15, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$15, null), "$type", "com.papasofokli.util.PrimaryProgressBar", "PrimaryProgressBar", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_PrimaryProgressBar$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$18) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_util_ProgressBarStyle$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$18));
}
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle$() {
  this.a8T = null;
  this.a8U = null;
  this.a8V = false;
  $n_Lcom_papasofokli_util_ProgressBarStyle$ = this;
  this.a8T = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_PrimaryProgressBar$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_SuccessProgressBar$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_WarningProgressBar$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_DangerProgressBar$(), $m_sci_Nil$()))));
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle$;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle$() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle$.prototype = $p;
$p.q = (function() {
  if ((!this.a8V)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_ProgressBarStyle$();
    this.a8U = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_util_ProgressBarStyle$__x4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_util_ProgressBarStyle$__x4$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a8V = true;
  }
  return this.a8U;
});
$p.ase = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asf = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_DangerProgressBar$()));
});
$p.asg = (function(ReadersVersionSpecific_this$10) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ash = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_WarningProgressBar$()));
});
$p.asi = (function(ReadersVersionSpecific_this$15) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asj = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_SuccessProgressBar$()));
});
$p.ask = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asl = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_PrimaryProgressBar$()));
});
var $d_Lcom_papasofokli_util_ProgressBarStyle$ = new $TypeData().i($c_Lcom_papasofokli_util_ProgressBarStyle$, "com.papasofokli.util.ProgressBarStyle$", ({
  sK: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_util_ProgressBarStyle$;
function $m_Lcom_papasofokli_util_ProgressBarStyle$() {
  if ((!$n_Lcom_papasofokli_util_ProgressBarStyle$)) {
    $n_Lcom_papasofokli_util_ProgressBarStyle$ = new $c_Lcom_papasofokli_util_ProgressBarStyle$();
  }
  return $n_Lcom_papasofokli_util_ProgressBarStyle$;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1, x3$lzy1$1) {
  if (x4$lzy1$1.i) {
    var $x_1 = x4$lzy1$1.j;
  } else {
    $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$();
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$1));
    var this$2 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$2);
    var $x_1 = x4$lzy1$1.E(ReadersVersionSpecific_this$1.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2) {
  return (x4$lzy1$2.i ? x4$lzy1$2.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x4$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2, x3$lzy1$2));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x3$lzy1$3.i) {
    var $x_1 = x3$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1(ReadersVersionSpecific_this$3, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$3, $m_Lcom_papasofokli_util_formgroup_Error$());
    var $x_1 = x3$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.util.formgroup.Error", "Error", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x3$lzy1$4.i ? x3$lzy1$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x3$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$8) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2(ReadersVersionSpecific_this$8, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$8, $m_Lcom_papasofokli_util_formgroup_Warning$());
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$8.aq(), "$type", "com.papasofokli.util.formgroup.Warning", "Warning", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$12) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$13) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3(ReadersVersionSpecific_this$13, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$13, $m_Lcom_papasofokli_util_formgroup_Success$());
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$13.aq(), "$type", "com.papasofokli.util.formgroup.Success", "Success", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$17) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$17));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$18) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4(ReadersVersionSpecific_this$18, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$18, $m_Lcom_papasofokli_util_formgroup_Default$());
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$18.aq(), "$type", "com.papasofokli.util.formgroup.Default", "Default", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$22) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$22));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1, x3$lzy2$1) {
  if (x4$lzy2$1.i) {
    var $x_1 = x4$lzy2$1.j;
  } else {
    $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$();
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$1));
    var this$3 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x4$lzy2$1.E(WritersVersionSpecific_this$1.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2) {
  return (x4$lzy2$2.i ? x4$lzy2$2.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x4$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2, x3$lzy2$2));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$3, WritersVersionSpecific_this$3) {
  if (x3$lzy2$3.i) {
    var $x_1 = x3$lzy2$3.j;
  } else {
    var $x_1 = x3$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$3, null), "$type", "com.papasofokli.util.formgroup.Error", "Error", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_formgroup_Error$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$6) {
  return (x3$lzy2$4.i ? x3$lzy2$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x3$lzy2$4, WritersVersionSpecific_this$6));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$7) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$7, null), "$type", "com.papasofokli.util.formgroup.Warning", "Warning", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_formgroup_Warning$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$10) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$11) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$11, null), "$type", "com.papasofokli.util.formgroup.Success", "Success", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_formgroup_Success$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$14) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$14));
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$15) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$15, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$15, null), "$type", "com.papasofokli.util.formgroup.Default", "Default", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_util_formgroup_Default$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$18) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$18));
}
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$() {
  this.a8W = null;
  this.a8X = null;
  this.a8Y = false;
  $n_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$ = this;
  this.a8W = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_formgroup_Success$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_formgroup_Warning$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_util_formgroup_Error$(), $m_sci_Nil$())));
}
$p = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$() {
}
$h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$.prototype = $p;
$p.q = (function() {
  if ((!this.a8Y)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$();
    this.a8X = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$__x4$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a8Y = true;
  }
  return this.a8X;
});
$p.asm = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asn = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_formgroup_Error$()));
});
$p.aso = (function(ReadersVersionSpecific_this$10) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asp = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_formgroup_Warning$()));
});
$p.asq = (function(ReadersVersionSpecific_this$15) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asr = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_formgroup_Success$()));
});
$p.ass = (function(ReadersVersionSpecific_this$20) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.ast = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_util_formgroup_Default$()));
});
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$, "com.papasofokli.util.formgroup.FormGroupValidationStatus$", ({
  sY: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$;
function $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$)) {
    $n_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$ = new $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$();
  }
  return $n_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x3$lzy1$1, ReadersVersionSpecific_this$1, x0$lzy1$1, x1$lzy1$1, x2$lzy1$1) {
  if (x3$lzy1$1.i) {
    var $x_1 = x3$lzy1$1.j;
  } else {
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_websocket_ClientMessages$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$1, ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_websocket_VisibilityInfo$().q(), $p_Lcom_papasofokli_websocket_ClientMessages$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$1, ReadersVersionSpecific_this$1), $p_Lcom_papasofokli_websocket_ClientMessages$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$1, ReadersVersionSpecific_this$1));
    var this$2 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$2);
    var $x_1 = x3$lzy1$1.E(ReadersVersionSpecific_this$1.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x3$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2) {
  return (x3$lzy1$2.i ? x3$lzy1$2.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x3$lzyINIT1$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x3$lzy1$2, ReadersVersionSpecific_this$2, x0$lzy1$2, x1$lzy1$2, x2$lzy1$2));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$3, ReadersVersionSpecific_this$3) {
  if (x2$lzy1$3.i) {
    var $x_1 = x2$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_websocket_ClientMessages$$anon$1(ReadersVersionSpecific_this$3, 1, $thiz);
    var $x_1 = x2$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.websocket.ClosePageMessage", "ClosePageMessage", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$7) {
  return (x2$lzy1$4.i ? x2$lzy1$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x2$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x2$lzy1$4, ReadersVersionSpecific_this$7));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$3, ReadersVersionSpecific_this$8) {
  if (x1$lzy1$3.i) {
    var $x_1 = x1$lzy1$3.j;
  } else {
    var reader = new $c_Lcom_papasofokli_websocket_ClientMessages$$anon$2(ReadersVersionSpecific_this$8, 2, $thiz);
    var $x_1 = x1$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$8.aq(), "$type", "com.papasofokli.websocket.WebPageStatus", "WebPageStatus", reader));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$12) {
  return (x1$lzy1$4.i ? x1$lzy1$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x1$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy1$4, ReadersVersionSpecific_this$12));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$3, ReadersVersionSpecific_this$13) {
  if (x0$lzy1$3.i) {
    var $x_1 = x0$lzy1$3.j;
  } else {
    new $c_Lcom_papasofokli_websocket_ClientMessages$$anon$3(ReadersVersionSpecific_this$13, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$13, $m_Lcom_papasofokli_websocket_GreetingMessage$());
    var $x_1 = x0$lzy1$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$13.aq(), "$type", "com.papasofokli.websocket.GreetingMessage", "GreetingMessage", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x0$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$17) {
  return (x0$lzy1$4.i ? x0$lzy1$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x0$lzyINIT1$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy1$4, ReadersVersionSpecific_this$17));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x3$lzy2$1, WritersVersionSpecific_this$1, x0$lzy2$1, x1$lzy2$1, x2$lzy2$1) {
  if (x3$lzy2$1.i) {
    var $x_1 = x3$lzy2$1.j;
  } else {
    var Tuple_this = new $c_T4($p_Lcom_papasofokli_websocket_ClientMessages$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$1, WritersVersionSpecific_this$1), $m_Lcom_papasofokli_websocket_VisibilityInfo$().q(), $p_Lcom_papasofokli_websocket_ClientMessages$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$1, WritersVersionSpecific_this$1), $p_Lcom_papasofokli_websocket_ClientMessages$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$1, WritersVersionSpecific_this$1));
    var this$3 = new $c_s_Product$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x3$lzy2$1.E(WritersVersionSpecific_this$1.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x3$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x3$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2) {
  return (x3$lzy2$2.i ? x3$lzy2$2.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x3$lzyINIT2$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x3$lzy2$2, WritersVersionSpecific_this$2, x0$lzy2$2, x1$lzy2$2, x2$lzy2$2));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$3, WritersVersionSpecific_this$3) {
  if (x2$lzy2$3.i) {
    var $x_1 = x2$lzy2$3.j;
  } else {
    var evidence$1$proxy2__runtimeClass;
    var evidence$1$proxy2__runtimeClass = $d_Lcom_papasofokli_websocket_ClosePageMessage.l();
    var $x_1 = x2$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$3, new $c_Lcom_papasofokli_websocket_ClientMessages$$anon$4(WritersVersionSpecific_this$3, $thiz), "$type", "com.papasofokli.websocket.ClosePageMessage", "ClosePageMessage", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy2__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x2$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$6) {
  return (x2$lzy2$4.i ? x2$lzy2$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x2$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x2$lzy2$4, WritersVersionSpecific_this$6));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$3, WritersVersionSpecific_this$7) {
  if (x1$lzy2$3.i) {
    var $x_1 = x1$lzy2$3.j;
  } else {
    var evidence$1$proxy3__runtimeClass;
    var evidence$1$proxy3__runtimeClass = $d_Lcom_papasofokli_websocket_WebPageStatus.l();
    var $x_1 = x1$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$7, new $c_Lcom_papasofokli_websocket_ClientMessages$$anon$5(WritersVersionSpecific_this$7, $thiz), "$type", "com.papasofokli.websocket.WebPageStatus", "WebPageStatus", new $c_Lupickle_core_Annotator$Checker$Cls(evidence$1$proxy3__runtimeClass)));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x1$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$10) {
  return (x1$lzy2$4.i ? x1$lzy2$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x1$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy2$4, WritersVersionSpecific_this$10));
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$3, WritersVersionSpecific_this$11) {
  if (x0$lzy2$3.i) {
    var $x_1 = x0$lzy2$3.j;
  } else {
    var $x_1 = x0$lzy2$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$11, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$11, null), "$type", "com.papasofokli.websocket.GreetingMessage", "GreetingMessage", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_websocket_GreetingMessage$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_ClientMessages$__x0$2__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$14) {
  return (x0$lzy2$4.i ? x0$lzy2$4.j : $p_Lcom_papasofokli_websocket_ClientMessages$__x0$lzyINIT2$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy2$4, WritersVersionSpecific_this$14));
}
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$() {
  this.a90 = null;
  this.a91 = false;
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$.prototype = $p;
$p.q = (function() {
  if ((!this.a91)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a90 = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_websocket_ClientMessages$__x3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_websocket_ClientMessages$__x3$2__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a91 = true;
  }
  return this.a90;
});
$p.asu = (function(ReadersVersionSpecific_this$5) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asv = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_websocket_ClosePageMessage((!(!params$2.a[0])))));
});
$p.asw = (function(ReadersVersionSpecific_this$10) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asx = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => new $c_Lcom_papasofokli_websocket_WebPageStatus(params$2.a[0], params$2.a[1])));
});
$p.asy = (function(ReadersVersionSpecific_this$15) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asz = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_websocket_GreetingMessage$()));
});
var $d_Lcom_papasofokli_websocket_ClientMessages$ = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$, "com.papasofokli.websocket.ClientMessages$", ({
  t8: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_websocket_ClientMessages$;
function $m_Lcom_papasofokli_websocket_ClientMessages$() {
  if ((!$n_Lcom_papasofokli_websocket_ClientMessages$)) {
    $n_Lcom_papasofokli_websocket_ClientMessages$ = new $c_Lcom_papasofokli_websocket_ClientMessages$();
  }
  return $n_Lcom_papasofokli_websocket_ClientMessages$;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$lzyINIT3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$1, ReadersVersionSpecific_this$18, x0$lzy3$1, x1$lzy3$1) {
  if (x2$lzy3$1.i) {
    var $x_1 = x2$lzy3$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$1, ReadersVersionSpecific_this$18), $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$1, ReadersVersionSpecific_this$18));
    var this$3 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var readers = $m_sci_Nil$().aY(this$3);
    var $x_1 = x2$lzy3$1.E(ReadersVersionSpecific_this$18.hJ().kP("$type", readers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$3__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$2, ReadersVersionSpecific_this$19, x0$lzy3$2, x1$lzy3$2) {
  return (x2$lzy3$2.i ? x2$lzy3$2.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$lzyINIT3$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader($thiz, x2$lzy3$2, ReadersVersionSpecific_this$19, x0$lzy3$2, x1$lzy3$2));
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$3, ReadersVersionSpecific_this$20) {
  if (x1$lzy3$3.i) {
    var $x_1 = x1$lzy3$3.j;
  } else {
    new $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7(ReadersVersionSpecific_this$20, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$20, $m_Lcom_papasofokli_websocket_IsNotVisibleMessage$());
    var $x_1 = x1$lzy3$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$20.aq(), "$type", "com.papasofokli.websocket.IsNotVisibleMessage", "IsNotVisibleMessage", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$24) {
  return (x1$lzy3$4.i ? x1$lzy3$4.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x1$lzy3$4, ReadersVersionSpecific_this$24));
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$3, ReadersVersionSpecific_this$25) {
  if (x0$lzy3$3.i) {
    var $x_1 = x0$lzy3$3.j;
  } else {
    new $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8(ReadersVersionSpecific_this$25, 0, $thiz);
    var rw = new $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(ReadersVersionSpecific_this$25, $m_Lcom_papasofokli_websocket_IsVisibleMessage$());
    var $x_1 = x0$lzy3$3.E(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$25.aq(), "$type", "com.papasofokli.websocket.IsVisibleMessage", "IsVisibleMessage", rw));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$3__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$29) {
  return (x0$lzy3$4.i ? x0$lzy3$4.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$lzyINIT3$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Reader($thiz, x0$lzy3$4, ReadersVersionSpecific_this$29));
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$lzyINIT4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$1, WritersVersionSpecific_this$15, x0$lzy4$1, x1$lzy4$1) {
  if (x2$lzy4$1.i) {
    var $x_1 = x2$lzy4$1.j;
  } else {
    var Tuple_this = new $c_T2($p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$1, WritersVersionSpecific_this$15), $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$1, WritersVersionSpecific_this$15));
    var this$4 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    $m_sci_List$();
    var writers = $m_sci_Nil$().aY(this$4);
    var $x_1 = x2$lzy4$1.E(WritersVersionSpecific_this$15.ji().kQ(writers));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$4__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$2, WritersVersionSpecific_this$16, x0$lzy4$2, x1$lzy4$2) {
  return (x2$lzy4$2.i ? x2$lzy4$2.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$lzyINIT4$1__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer($thiz, x2$lzy4$2, WritersVersionSpecific_this$16, x0$lzy4$2, x1$lzy4$2));
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$3, WritersVersionSpecific_this$17) {
  if (x1$lzy4$3.i) {
    var $x_1 = x1$lzy4$3.j;
  } else {
    var $x_1 = x1$lzy4$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$17, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$17, null), "$type", "com.papasofokli.websocket.IsNotVisibleMessage", "IsNotVisibleMessage", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_websocket_IsNotVisibleMessage$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$20) {
  return (x1$lzy4$4.i ? x1$lzy4$4.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x1$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x1$lzy4$4, WritersVersionSpecific_this$20));
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$3, WritersVersionSpecific_this$21) {
  if (x0$lzy4$3.i) {
    var $x_1 = x0$lzy4$3.j;
  } else {
    var $x_1 = x0$lzy4$3.E($f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter(WritersVersionSpecific_this$21, new $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(WritersVersionSpecific_this$21, null), "$type", "com.papasofokli.websocket.IsVisibleMessage", "IsVisibleMessage", new $c_Lupickle_core_Annotator$Checker$Val($m_Lcom_papasofokli_websocket_IsVisibleMessage$())));
  }
  return $x_1;
}
function $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$4__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$24) {
  return (x0$lzy4$4.i ? x0$lzy4$4.j : $p_Lcom_papasofokli_websocket_VisibilityInfo$__x0$lzyINIT4$1__sr_LazyRef__Lupickle_default$__Lupickle_core_Types$Writer($thiz, x0$lzy4$4, WritersVersionSpecific_this$24));
}
/** @constructor */
function $c_Lcom_papasofokli_websocket_VisibilityInfo$() {
  this.a94 = null;
  this.a95 = false;
}
$p = $c_Lcom_papasofokli_websocket_VisibilityInfo$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_VisibilityInfo$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_VisibilityInfo$() {
}
$h_Lcom_papasofokli_websocket_VisibilityInfo$.prototype = $p;
$p.q = (function() {
  if ((!this.a95)) {
    new $c_Lupickle_implicits_MacroImplicits$ReadWriterExtension($m_Lupickle_default$(), $m_Lupickle_default$().ap());
    var MacroImplicits_this = $m_Lupickle_default$();
    this.a94 = MacroImplicits_this.ap().aQ($p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$3__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Reader(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()), $p_Lcom_papasofokli_websocket_VisibilityInfo$__x2$4__sr_LazyRef__Lupickle_default$__sr_LazyRef__sr_LazyRef__Lupickle_core_Types$Writer(this, new $c_sr_LazyRef(), MacroImplicits_this, new $c_sr_LazyRef(), new $c_sr_LazyRef()));
    this.a95 = true;
  }
  return this.a94;
});
$p.asB = (function(ReadersVersionSpecific_this$22) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asC = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_websocket_IsNotVisibleMessage$()));
});
$p.asD = (function(ReadersVersionSpecific_this$27) {
  $m_sci_Nil$();
  var this$2 = $m_s_None$();
  if ((!this$2.c())) {
    this$2.aa();
  }
  return true;
});
$p.asA = (function() {
  return new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((params$2, collection$2) => $m_Lcom_papasofokli_websocket_IsVisibleMessage$()));
});
var $d_Lcom_papasofokli_websocket_VisibilityInfo$ = new $TypeData().i($c_Lcom_papasofokli_websocket_VisibilityInfo$, "com.papasofokli.websocket.VisibilityInfo$", ({
  th: 1,
  v: 1,
  an: 1
}));
var $n_Lcom_papasofokli_websocket_VisibilityInfo$;
function $m_Lcom_papasofokli_websocket_VisibilityInfo$() {
  if ((!$n_Lcom_papasofokli_websocket_VisibilityInfo$)) {
    $n_Lcom_papasofokli_websocket_VisibilityInfo$ = new $c_Lcom_papasofokli_websocket_VisibilityInfo$();
  }
  return $n_Lcom_papasofokli_websocket_VisibilityInfo$;
}
/** @constructor */
function $c_jl_Class($data) {
  this.ax = $data;
}
$p = $c_jl_Class.prototype = new $h_O();
$p.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
}
$h_jl_Class.prototype = $p;
$p.g = (function() {
  return ((this.ax.Y ? "interface " : (this.ax.X ? "" : "class ")) + this.ax.N);
});
var $d_jl_Class = new $TypeData().i($c_jl_Class, "java.lang.Class", ({
  ty: 1,
  a: 1,
  aJ: 1
}));
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.m9 = _name;
  $thiz.iW = _ordinal;
  return $thiz;
}
/** @constructor */
function $c_jl_Enum() {
  this.m9 = null;
  this.iW = 0;
}
$p = $c_jl_Enum.prototype = new $h_O();
$p.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
$h_jl_Enum.prototype = $p;
$p.g = (function() {
  return this.m9;
});
$p.b = (function(that) {
  return (this === that);
});
$p.r = (function() {
  return $systemIdentityHashCode(this);
});
$p.asE = (function(o) {
  var x = this.iW;
  var y = o.iW;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.jl = (function(o) {
  return this.asE(o);
});
function $ct_jl_Error__jl_Throwable__($thiz, e) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, ((e === null) ? null : e.g()), e, true, true);
  return $thiz;
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bQ)));
}
class $c_jl_Exception extends $c_jl_Throwable {
}
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.td = _array;
  $thiz.y1 = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
  this.td = null;
  this.y1 = 0;
}
$p = $c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$p.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
}
$h_Ljava_nio_ByteBuffer.prototype = $p;
$p.r = (function() {
  var start = this.b5;
  var end = this.bF;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var index = i;
    var a = this.td;
    var i$1 = ((this.y1 + index) | 0);
    h = $x_2.d($x_1, a.a[i$1]);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().an(h, ((end - start) | 0));
});
$p.b = (function(that) {
  return ((that instanceof $c_Ljava_nio_ByteBuffer) && (this.aga(that) === 0));
});
$p.aga = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.b5;
    var thisRemaining = ((this.bF - thisStart) | 0);
    var thatStart = that.b5;
    var thatRemaining = ((that.bF - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var a = this.td;
      var i$1 = ((this.y1 + index) | 0);
      var t = a.a[i$1];
      var index$1 = ((thatStart + i) | 0);
      var a$1 = that.td;
      var i$2 = ((that.y1 + index$1) | 0);
      var u = a$1.a[i$2];
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$p.jl = (function(o) {
  return this.aga(o);
});
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gB)));
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$() {
  this.KK = null;
  this.te = null;
  this.Gr = 0;
  this.R0 = null;
  $ct_Ljava_nio_charset_Charset__T__AT__(this, "UTF-8", new ($d_T.r().C)(["UTF8", "unicode-1-1-utf-8"]));
  $n_Ljava_nio_charset_UTF\uff3f8$ = this;
  this.R0 = $constArrSVals_I(128, "||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||________________________________````````````````aaaaaaaa||||||||");
}
$p = $c_Ljava_nio_charset_UTF\uff3f8$.prototype = new $h_Ljava_nio_charset_Charset();
$p.constructor = $c_Ljava_nio_charset_UTF\uff3f8$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$() {
}
$h_Ljava_nio_charset_UTF\uff3f8$.prototype = $p;
var $d_Ljava_nio_charset_UTF\uff3f8$ = new $TypeData().i($c_Ljava_nio_charset_UTF\uff3f8$, "java.nio.charset.UTF_8$", ({
  uq: 1,
  gD: 1,
  N: 1
}));
var $n_Ljava_nio_charset_UTF\uff3f8$;
function $m_Ljava_nio_charset_UTF\uff3f8$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f8$)) {
    $n_Ljava_nio_charset_UTF\uff3f8$ = new $c_Ljava_nio_charset_UTF\uff3f8$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f8$;
}
/** @constructor */
function $c_ju_AbstractCollection() {
}
$p = $c_ju_AbstractCollection.prototype = new $h_O();
$p.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
$h_ju_AbstractCollection.prototype = $p;
$p.asL = (function(c) {
  var _\uff3fself = c.zN();
  _return: {
    while (_\uff3fself.f()) {
      if ((!this.az(_\uff3fself.e()))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$p.g = (function() {
  var _\uff3fself = this.zN();
  var result = "[";
  var first = true;
  while (_\uff3fself.f()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + _\uff3fself.e());
  }
  return (result + "]");
});
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.me = null;
  this.ti = 0;
  this.ht = null;
  this.y3 = null;
  this.kh = null;
  this.KU = null;
  this.y4 = null;
  this.KU = older;
  this.y4 = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
$p = $c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$p.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
}
$h_ju_LinkedHashMap$Node.prototype = $p;
var $d_ju_LinkedHashMap$Node = new $TypeData().i($c_ju_LinkedHashMap$Node, "java.util.LinkedHashMap$Node", ({
  uV: 1,
  gG: 1,
  bR: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.Gt = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
$p = $c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$p.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $p;
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().i($c_ju_LinkedHashMap$NodeIterator, "java.util.LinkedHashMap$NodeIterator", ({
  uW: 1,
  uU: 1,
  uS: 1
}));
function $ct_ju_Random__J__($thiz, seed_in_$_lo, seed_in_$_hi) {
  return $thiz;
}
/** @constructor */
function $c_ju_Random() {
}
$p = $c_ju_Random.prototype = new $h_O();
$p.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
}
$h_ju_Random.prototype = $p;
/** @constructor */
function $c_ju_UUID(mostSigBits_$_lo, mostSigBits_$_hi, leastSigBits_$_lo, leastSigBits_$_hi) {
  this.zq = 0;
  this.zr = 0;
  this.zo = 0;
  this.zp = 0;
  this.zq = mostSigBits_$_lo;
  this.zr = mostSigBits_$_hi;
  this.zo = leastSigBits_$_lo;
  this.zp = leastSigBits_$_hi;
}
$p = $c_ju_UUID.prototype = new $h_O();
$p.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
}
$h_ju_UUID.prototype = $p;
$p.g = (function() {
  var mostSigBits_$_lo = this.zq;
  var mostSigBits_$_hi = this.zr;
  var leastSigBits_$_lo = this.zo;
  var leastSigBits_$_hi = this.zp;
  var s = (mostSigBits_$_hi >>> 0.0).toString(16);
  var beginIndex = s.length;
  var $x_5 = "00000000".substring(beginIndex);
  var i = (65535 & (((mostSigBits_$_lo >>> 16) | 0) | (mostSigBits_$_hi << 16)));
  var s$1 = (i >>> 0.0).toString(16);
  var beginIndex$1 = s$1.length;
  var $x_4 = "0000".substring(beginIndex$1);
  var i$1 = (65535 & mostSigBits_$_lo);
  var s$2 = (i$1 >>> 0.0).toString(16);
  var beginIndex$2 = s$2.length;
  var $x_3 = "0000".substring(beginIndex$2);
  var i$2 = (65535 & ((leastSigBits_$_hi >>> 16) | 0));
  var s$3 = (i$2 >>> 0.0).toString(16);
  var beginIndex$3 = s$3.length;
  var $x_2 = "0000".substring(beginIndex$3);
  var i$3 = (65535 & leastSigBits_$_hi);
  var s$4 = (i$3 >>> 0.0).toString(16);
  var beginIndex$4 = s$4.length;
  var $x_1 = "0000".substring(beginIndex$4);
  var s$5 = (leastSigBits_$_lo >>> 0.0).toString(16);
  var beginIndex$5 = s$5.length;
  return ((((((((((("" + $x_5) + s) + "-") + (("" + $x_4) + s$1)) + "-") + (("" + $x_3) + s$2)) + "-") + (("" + $x_2) + s$3)) + "-") + (("" + $x_1) + s$4)) + (("" + "00000000".substring(beginIndex$5)) + s$5));
});
$p.r = (function() {
  var value_$_lo = this.zq;
  var value_$_hi = this.zr;
  var value$1_$_lo = this.zo;
  var value$1_$_hi = this.zp;
  return ((value_$_lo ^ value_$_hi) ^ (value$1_$_lo ^ value$1_$_hi));
});
$p.b = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x_$_lo = this.zq;
    var x_$_hi = this.zr;
    var $x_1 = that;
    var x$1_$_lo = $x_1.zq;
    var x$1_$_hi = $x_1.zr;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.zo;
      var x$2_$_hi = this.zp;
      var $x_2 = that;
      var x$3_$_lo = $x_2.zo;
      var x$3_$_hi = $x_2.zp;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.asF = (function(that) {
  var thisHi_$_lo = this.zq;
  var thisHi_$_hi = this.zr;
  var $x_1 = that;
  var thatHi_$_lo = $x_1.zq;
  var thatHi_$_hi = $x_1.zr;
  if ((((thisHi_$_lo ^ thatHi_$_lo) | (thisHi_$_hi ^ thatHi_$_hi)) !== 0)) {
    return (((thisHi_$_hi === thatHi_$_hi) ? ((thisHi_$_lo >>> 0) < (thatHi_$_lo >>> 0)) : (thisHi_$_hi < thatHi_$_hi)) ? (-1) : 1);
  } else {
    var thisLo_$_lo = this.zo;
    var thisLo_$_hi = this.zp;
    var $x_2 = that;
    var thatLo_$_lo = $x_2.zo;
    var thatLo_$_hi = $x_2.zp;
    return ((((thisLo_$_lo ^ thatLo_$_lo) | (thisLo_$_hi ^ thatLo_$_hi)) !== 0) ? (((thisLo_$_hi === thatLo_$_hi) ? ((thisLo_$_lo >>> 0) < (thatLo_$_lo >>> 0)) : (thisLo_$_hi < thatLo_$_hi)) ? (-1) : 1) : 0);
  }
});
$p.jl = (function(o) {
  return this.asF(o);
});
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gH)));
}
var $d_ju_UUID = new $TypeData().i($c_ju_UUID, "java.util.UUID", ({
  gH: 1,
  a: 1,
  N: 1
}));
/** @constructor */
function $c_s_$less$colon$less() {
}
$p = $c_s_$less$colon$less.prototype = new $h_O();
$p.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
$h_s_$less$colon$less.prototype = $p;
$p.hK = (function(x$0) {
});
/** @constructor */
function $c_s_Enumeration$ValueSet$(outer) {
  this.Ro = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ro = outer;
  new $c_s_Enumeration$ValueSet(outer, $m_sci_BitSet$().yn);
}
$p = $c_s_Enumeration$ValueSet$.prototype = new $h_O();
$p.constructor = $c_s_Enumeration$ValueSet$;
/** @constructor */
function $h_s_Enumeration$ValueSet$() {
}
$h_s_Enumeration$ValueSet$.prototype = $p;
$p.aP = (function() {
  return new $c_s_Enumeration$ValueSet$$anon$1(this);
});
$p.MH = (function(it) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(new $c_s_Enumeration$ValueSet$$anon$1(this), it).aR();
});
var $d_s_Enumeration$ValueSet$ = new $TypeData().i($c_s_Enumeration$ValueSet$, "scala.Enumeration$ValueSet$", ({
  vP: 1,
  bf: 1,
  cF: 1
}));
/** @constructor */
function $c_s_Predef$() {
  this.ald = null;
  this.ale = null;
  $n_s_Predef$ = this;
  $m_sci_List$();
  this.ald = $m_sci_Map$();
  this.ale = $m_sci_Set$();
}
$p = $c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$p.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
}
$h_s_Predef$.prototype = $p;
$p.Nl = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed");
  }
});
var $d_s_Predef$ = new $TypeData().i($c_s_Predef$, "scala.Predef$", ({
  w2: 1,
  vT: 1,
  vU: 1
}));
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$();
  }
  return $n_s_Predef$;
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.P();
      break;
    }
    case 1: {
      return $thiz.V();
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.gZ;
      break;
    }
    case 1: {
      return $thiz.fY;
      break;
    }
    case 2: {
      return $thiz.gr;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.y8;
      break;
    }
    case 1: {
      return $thiz.y9;
      break;
    }
    case 2: {
      return $thiz.ya;
      break;
    }
    case 3: {
      return $thiz.tp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
    }
  }
}
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.CA;
      break;
    }
    case 1: {
      return $thiz.CB;
      break;
    }
    case 2: {
      return $thiz.CC;
      break;
    }
    case 3: {
      return $thiz.CD;
      break;
    }
    case 4: {
      return $thiz.CE;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"));
    }
  }
}
/** @constructor */
function $c_sc_BuildFrom$() {
}
$p = $c_sc_BuildFrom$.prototype = new $h_O();
$p.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
}
$h_sc_BuildFrom$.prototype = $p;
var $d_sc_BuildFrom$ = new $TypeData().i($c_sc_BuildFrom$, "scala.collection.BuildFrom$", ({
  wi: 1,
  wk: 1,
  wj: 1
}));
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$();
  }
  return $n_sc_BuildFrom$;
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.CF = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.CF = null;
}
$p = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$p.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $p;
$p.ce = (function() {
  return this.CF.agJ($m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.bp = (function(it) {
  return this.CF.Un(it, $m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.aP = (function() {
  return this.CF.Nb($m_s_reflect_ManifestFactory$AnyManifest$());
});
$p.e4 = (function(elems) {
  return this.CF.Un(elems, $m_s_reflect_ManifestFactory$AnyManifest$());
});
/** @constructor */
function $c_sc_Factory$ArrayFactory(evidence$1) {
  this.aah = null;
  this.aah = evidence$1;
}
$p = $c_sc_Factory$ArrayFactory.prototype = new $h_O();
$p.constructor = $c_sc_Factory$ArrayFactory;
/** @constructor */
function $h_sc_Factory$ArrayFactory() {
}
$h_sc_Factory$ArrayFactory.prototype = $p;
$p.aP = (function() {
  return new $c_scm_ArrayBuilder$generic(this.aah.dK());
});
var $d_sc_Factory$ArrayFactory = new $TypeData().i($c_sc_Factory$ArrayFactory, "scala.collection.Factory$ArrayFactory", ({
  wo: 1,
  bf: 1,
  a: 1
}));
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.q7 = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.q7 = null;
}
$p = $c_sc_IterableFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
}
$h_sc_IterableFactory$Delegate.prototype = $p;
$p.ce = (function() {
  return this.q7.ce();
});
$p.bp = (function(it) {
  return this.q7.bp(it);
});
$p.aP = (function() {
  return this.q7.aP();
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.Rv = null;
  this.Rv = factory;
}
$p = $c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$p.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
}
$h_sc_IterableFactory$ToFactory.prototype = $p;
$p.de = (function(it) {
  return this.Rv.bp(it);
});
$p.aP = (function() {
  return this.Rv.aP();
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().i($c_sc_IterableFactory$ToFactory, "scala.collection.IterableFactory$ToFactory", ({
  wv: 1,
  bf: 1,
  a: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$$anon$1() {
}
$p = $c_sc_IterableOnceOps$$anon$1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $h_sc_IterableOnceOps$$anon$1() {
}
$h_sc_IterableOnceOps$$anon$1.prototype = $p;
$p.p = (function(v1) {
  return this;
});
var $d_sc_IterableOnceOps$$anon$1 = new $TypeData().i($c_sc_IterableOnceOps$$anon$1, "scala.collection.IterableOnceOps$$anon$1", ({
  ww: 1,
  bD: 1,
  p: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$Maximized(descriptor, f, cmp) {
  this.aaj = null;
  this.Rw = null;
  this.aai = null;
  this.GD = null;
  this.L6 = null;
  this.GE = false;
  this.aaj = descriptor;
  this.Rw = f;
  this.aai = cmp;
  this.GD = null;
  this.L6 = null;
  this.GE = false;
}
$p = $c_sc_IterableOnceOps$Maximized.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sc_IterableOnceOps$Maximized;
/** @constructor */
function $h_sc_IterableOnceOps$Maximized() {
}
$h_sc_IterableOnceOps$Maximized.prototype = $p;
$p.mN = (function() {
  return (this.GE ? new $c_s_Some(this.GD) : $m_s_None$());
});
$p.aR = (function() {
  if (this.GE) {
    return this.GD;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), ("empty." + this.aaj));
  }
});
$p.Mi = (function(m, a) {
  if (m.GE) {
    var fa = this.Rw.p(a);
    if ((!(!this.aai.cm(fa, this.L6)))) {
      this.L6 = fa;
      this.GD = a;
    }
    return m;
  } else {
    m.GE = true;
    m.GD = a;
    m.L6 = this.Rw.p(a);
    return m;
  }
});
$p.cm = (function(v1, v2) {
  return this.Mi(v1, v2);
});
var $d_sc_IterableOnceOps$Maximized = new $TypeData().i($c_sc_IterableOnceOps$Maximized, "scala.collection.IterableOnceOps$Maximized", ({
  wx: 1,
  ii: 1,
  cu: 1
}));
function $f_sc_IterableOps__headOption__s_Option($thiz) {
  var it = $thiz.l();
  return (it.f() ? new $c_s_Some(it.e()) : $m_s_None$());
}
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.l();
  var lst = it.e();
  while (it.f()) {
    lst = it.e();
  }
  return lst;
}
function $f_sc_IterableOps__lastOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.cJ()));
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1;
  } else {
    var known = $thiz.G();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1));
    } else {
      var i = 0;
      var it = $thiz.l();
      while (it.f()) {
        if ((i === otherSize)) {
          return 1;
        }
        it.e();
        i = ((1 + i) | 0);
      }
      return ((i - otherSize) | 0);
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.de(new $c_sc_View$Filter($thiz, pred, false));
}
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.de(new $c_sc_View$Filter($thiz, pred, true));
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.de($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n));
}
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.de($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n));
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.bo(1);
}
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.b8(1);
}
function $f_sc_IterableOps__groupMap__F1__F1__sci_Map($thiz, key, f) {
  var m = $m_scm_Map$().ce();
  $thiz.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2) => {
    var k = key.p(elem$2);
    return m.oM(k, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.b4().aP()))).aD(f.p(elem$2));
  })));
  var result = new $c_sc_IterableOps$Result$1();
  m.al(result);
  return result.L7;
}
function $f_sc_IterableOps__scanLeft__O__F2__O($thiz, z, op) {
  return $thiz.b4().bp(new $c_sc_View$ScanLeft($thiz, z, op));
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $thiz.b4().bp($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $thiz.b4().bp(new $c_sc_View$FlatMap($thiz, f));
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $thiz.b4().bp(new $c_sc_View$Collect($thiz, pf));
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  return $thiz.b4().bp(($is_sc_Iterable(suffix) ? new $c_sc_View$Concat($thiz, suffix) : $thiz.l().kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix.l())))));
}
function $f_sc_IterableOps__zip__sc_IterableOnce__O($thiz, that) {
  return $thiz.b4().bp(($is_sc_Iterable(that) ? new $c_sc_View$Zip($thiz, that) : new $c_sc_Iterator$$anon$14(that, $thiz.l())));
}
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $thiz.b4().bp(new $c_sc_View$ZipWithIndex($thiz));
}
function $f_sc_IterableOps__unzip__F1__T2($thiz, asPair) {
  var first = $ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => asPair.p(_$3$2).P())));
  var second = $ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => asPair.p(_$4$2).V())));
  return new $c_T2($thiz.b4().bp(first), $thiz.b4().bp(second));
}
function $f_sc_IterableOps__tapEach__F1__O($thiz, f) {
  return $thiz.de($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
    f.p(a$2);
    return a$2;
  }))));
}
/** @constructor */
function $c_sc_IterableOps$Result$1() {
  this.L7 = null;
  this.L7 = $m_sci_Map$EmptyMap$();
}
$p = $c_sc_IterableOps$Result$1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sc_IterableOps$Result$1;
/** @constructor */
function $h_sc_IterableOps$Result$1() {
}
$h_sc_IterableOps$Result$1.prototype = $p;
$p.amH = (function(kv) {
  this.L7 = this.L7.hk(kv.P(), kv.V().aR());
});
$p.p = (function(v1) {
  this.amH(v1);
});
var $d_sc_IterableOps$Result$1 = new $TypeData().i($c_sc_IterableOps$Result$1, "scala.collection.IterableOps$Result$1", ({
  wy: 1,
  bD: 1,
  p: 1
}));
function $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__($thiz, self, p) {
  $thiz.GF = self;
  $thiz.L8 = p;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableOps$WithFilter() {
  this.GF = null;
  this.L8 = null;
}
$p = $c_sc_IterableOps$WithFilter.prototype = new $h_sc_WithFilter();
$p.constructor = $c_sc_IterableOps$WithFilter;
/** @constructor */
function $h_sc_IterableOps$WithFilter() {
}
$h_sc_IterableOps$WithFilter.prototype = $p;
$p.ah3 = (function() {
  return new $c_sc_View$Filter(this.GF, this.L8, false);
});
$p.X = (function(f) {
  return this.GF.b4().bp($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), this.ah3(), f));
});
var $d_sc_IterableOps$WithFilter = new $TypeData().i($c_sc_IterableOps$WithFilter, "scala.collection.IterableOps$WithFilter", ({
  cw: 1,
  c1: 1,
  a: 1
}));
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.ex(from);
  while (dropped.f()) {
    if ((!(!p.p(dropped.e())))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).kH(xs);
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.mL(0, ((n > 0) ? n : 0));
}
function $f_sc_Iterator__slice__I__I__sc_Iterator($thiz, from, until) {
  return $thiz.mL(from, ((until > 0) ? until : 0));
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().aZ : new $c_sc_Iterator$SliceIterator($thiz, lo, rest));
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.l();
  while ($thiz.f()) {
    if ((!those.f())) {
      return false;
    }
    if ((!$m_sr_BoxesRunTime$().B($thiz.e(), those.e()))) {
      return false;
    }
  }
  return (!those.f());
}
/** @constructor */
function $c_sc_Iterator$() {
  this.aZ = null;
  $n_sc_Iterator$ = this;
  this.aZ = new $c_sc_Iterator$$anon$19();
}
$p = $c_sc_Iterator$.prototype = new $h_O();
$p.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
}
$h_sc_Iterator$.prototype = $p;
$p.aP = (function() {
  return new $c_sc_Iterator$$anon$21();
});
$p.bp = (function(source) {
  return source.l();
});
$p.ce = (function() {
  return this.aZ;
});
var $d_sc_Iterator$ = new $TypeData().i($c_sc_Iterator$, "scala.collection.Iterator$", ({
  wz: 1,
  a: 1,
  U: 1
}));
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$();
  }
  return $n_sc_Iterator$;
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.ye = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.ye = null;
}
$p = $c_sc_MapFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
}
$h_sc_MapFactory$Delegate.prototype = $p;
$p.e4 = (function(elems) {
  return this.ye.e4(elems);
});
$p.bp = (function(it) {
  return this.ye.bp(it);
});
$p.ce = (function() {
  return this.ye.ce();
});
$p.aP = (function() {
  return this.ye.aP();
});
/** @constructor */
function $c_sc_MapFactory$ToFactory(factory) {
  this.RB = null;
  this.RB = factory;
}
$p = $c_sc_MapFactory$ToFactory.prototype = new $h_O();
$p.constructor = $c_sc_MapFactory$ToFactory;
/** @constructor */
function $h_sc_MapFactory$ToFactory() {
}
$h_sc_MapFactory$ToFactory.prototype = $p;
$p.de = (function(it) {
  return this.RB.bp(it);
});
$p.aP = (function() {
  return this.RB.aP();
});
var $d_sc_MapFactory$ToFactory = new $TypeData().i($c_sc_MapFactory$ToFactory, "scala.collection.MapFactory$ToFactory", ({
  wQ: 1,
  bf: 1,
  a: 1
}));
/** @constructor */
function $c_sc_View$() {
}
$p = $c_sc_View$.prototype = new $h_O();
$p.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
}
$h_sc_View$.prototype = $p;
$p.MG = (function(it) {
  return ($is_sc_View(it) ? it : ($is_sc_Iterable(it) ? new $c_sc_View$$anon$1(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((it$2) => (() => it$2.l()))(it))) : $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), $m_sci_LazyList$().E4(it))));
});
$p.aP = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((it$2) => this.MG(it$2))), ($m_scm_ArrayBuffer$(), new $c_scm_ArrayBuffer$$anon$1()));
});
$p.atu = (function(it, n) {
  if ((n <= 0)) {
    return it;
  } else {
    var k = it.G();
    return ((k >= 0) ? it.EE(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n));
  }
});
$p.bp = (function(source) {
  return this.MG(source);
});
$p.ce = (function() {
  return $m_sc_View$Empty$();
});
var $d_sc_View$ = new $TypeData().i($c_sc_View$, "scala.collection.View$", ({
  xd: 1,
  a: 1,
  U: 1
}));
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$();
  }
  return $n_sc_View$;
}
/** @constructor */
function $c_sci_BitSet$() {
  this.yn = null;
  $n_sci_BitSet$ = this;
  this.yn = new $c_sci_BitSet$BitSet1(0, 0);
}
$p = $c_sci_BitSet$.prototype = new $h_O();
$p.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
}
$h_sci_BitSet$.prototype = $p;
$p.ahh = (function(it) {
  return ((it instanceof $c_sci_BitSet) ? it : this.aP().cz(it).aR());
});
$p.aP = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((bs$2) => this.IC(bs$2.fj))), $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet())));
});
$p.Nn = (function(a_$_lo, a_$_hi, b_$_lo, b_$_hi) {
  return (((b_$_lo | b_$_hi) === 0) ? new $c_sci_BitSet$BitSet1(a_$_lo, a_$_hi) : new $c_sci_BitSet$BitSet2(a_$_lo, a_$_hi, b_$_lo, b_$_hi));
});
$p.auc = (function(elems) {
  var len = ((elems.a.length >>> 1) | 0);
  if ((len === 0)) {
    return this.yn;
  } else if ((len === 1)) {
    var $x_2 = elems.a;
    var $x_1_$_lo = $x_2[0];
    var $x_1_$_hi = $x_2[1];
    return new $c_sci_BitSet$BitSet1($x_1_$_lo, $x_1_$_hi);
  } else if ((len === 2)) {
    var $x_6 = elems.a;
    var $x_5_$_lo = $x_6[0];
    var $x_5_$_hi = $x_6[1];
    var $x_4 = elems.a;
    var $x_3_$_lo = $x_4[2];
    var $x_3_$_hi = $x_4[3];
    return this.Nn($x_5_$_lo, $x_5_$_hi, $x_3_$_lo, $x_3_$_hi);
  } else {
    return new $c_sci_BitSet$BitSetN($m_ju_Arrays$().U2(elems, len));
  }
});
$p.IC = (function(elems) {
  var len = ((elems.a.length >>> 1) | 0);
  if ((len === 0)) {
    return this.yn;
  } else if ((len === 1)) {
    var $x_2 = elems.a;
    var $x_1_$_lo = $x_2[0];
    var $x_1_$_hi = $x_2[1];
    return new $c_sci_BitSet$BitSet1($x_1_$_lo, $x_1_$_hi);
  } else if ((len === 2)) {
    var $x_6 = elems.a;
    var $x_5_$_lo = $x_6[0];
    var $x_5_$_hi = $x_6[1];
    var $x_4 = elems.a;
    var $x_3_$_lo = $x_4[2];
    var $x_3_$_hi = $x_4[3];
    return this.Nn($x_5_$_lo, $x_5_$_hi, $x_3_$_lo, $x_3_$_hi);
  } else {
    return new $c_sci_BitSet$BitSetN(elems);
  }
});
var $d_sci_BitSet$ = new $TypeData().i($c_sci_BitSet$, "scala.collection.immutable.BitSet$", ({
  xt: 1,
  bf: 1,
  cF: 1
}));
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$();
  }
  return $n_sci_BitSet$;
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.bZ = 0;
  this.cU = 0;
  this.e6 = null;
  this.hv = null;
  this.e7 = 0;
  this.hu = 0;
  this.bZ = dataMap;
  this.cU = nodeMap;
  this.e6 = content;
  this.hv = originalHashes;
  this.e7 = size;
  this.hu = cachedJavaKeySetHashCode;
}
$p = $c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$p.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
}
$h_sci_BitmapIndexedMapNode.prototype = $p;
$p.aH = (function() {
  return this.e7;
});
$p.dR = (function() {
  return this.hu;
});
$p.jr = (function(index) {
  return this.e6.a[(index << 1)];
});
$p.ip = (function(index) {
  return this.e6.a[((1 + (index << 1)) | 0)];
});
$p.zI = (function(index) {
  return new $c_T2(this.e6.a[(index << 1)], this.e6.a[((1 + (index << 1)) | 0)]);
});
$p.d1 = (function(index) {
  return this.hv.a[index];
});
$p.io = (function(index) {
  return this.e6.a[((((this.e6.a.length - 1) | 0) - index) | 0)];
});
$p.TF = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fp(keyHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bZ & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bZ, mask, bitpos);
    if ($m_sr_BoxesRunTime$().B(key, this.jr(index))) {
      return this.ip(index);
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
    }
  } else if (((this.cU & bitpos) !== 0)) {
    return this.io($m_sci_Node$().fn(this.cU, mask, bitpos)).TF(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.MI = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fp(keyHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bZ & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bZ, mask, bitpos);
    return ($m_sr_BoxesRunTime$().B(key, this.jr(index)) ? new $c_s_Some(this.ip(index)) : $m_s_None$());
  } else {
    return (((this.cU & bitpos) !== 0) ? this.io($m_sci_Node$().fn(this.cU, mask, bitpos)).MI(key, originalHash, keyHash, ((5 + shift) | 0)) : $m_s_None$());
  }
});
$p.Ut = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().fp(keyHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bZ & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bZ, mask, bitpos);
    return ($m_sr_BoxesRunTime$().B(key, this.jr(index)) ? this.ip(index) : f.aA());
  } else {
    return (((this.cU & bitpos) !== 0) ? this.io($m_sci_Node$().fn(this.cU, mask, bitpos)).Ut(key, originalHash, keyHash, ((5 + shift) | 0), f) : f.aA());
  }
});
$p.U1 = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().fp(keyHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bZ & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bZ, mask, bitpos);
    return ((this.hv.a[index] === originalHash) && $m_sr_BoxesRunTime$().B(key, this.jr(index)));
  } else {
    return (((this.cU & bitpos) !== 0) && this.io($m_sci_Node$().fn(this.cU, mask, bitpos)).U1(key, originalHash, keyHash, ((5 + shift) | 0)));
  }
});
$p.VO = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().fp(keyHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bZ & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bZ, mask, bitpos);
    var key0 = this.jr(index);
    var key0UnimprovedHash = this.d1(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().B(key0, key))) {
      if (replaceValue) {
        var value0 = this.ip(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.asV(bitpos, key, value));
      } else {
        return this;
      }
    } else {
      var value0$2 = this.ip(index);
      var key0Hash = $m_sc_Hashing$().bV(key0UnimprovedHash);
      return this.asR(bitpos, key0Hash, this.V2(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0)));
    }
  } else if (((this.cU & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().fn(this.cU, mask, bitpos);
    var subNode = this.io(index$2);
    var subNodeNew$2 = subNode.akn(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.asT(bitpos, subNode, subNodeNew$2));
  } else {
    return this.asP(bitpos, key, originalHash, keyHash, value);
  }
});
$p.V2 = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, $m_sci_Vector$().E5($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2(key0, value0), new $c_T2(key1, value1)])));
  } else {
    var mask0 = $m_sci_Node$().fp(keyHash0, shift);
    var mask1 = $m_sci_Node$().fp(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().cS(mask0) | $m_sci_Node$().cS(mask1));
      if ((mask0 < mask1)) {
        var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key0, value0, key1, value1]);
        var array$2 = new $ac_O(xs.F());
        var iterator = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs));
        var i = 0;
        while ((iterator.eY > 0)) {
          array$2.a[i] = iterator.e();
          i = ((1 + i) | 0);
        }
        return new $c_sci_BitmapIndexedMapNode(dataMap, 0, array$2, new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash);
      } else {
        var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key1, value1, key0, value0]);
        var array$4 = new $ac_O(xs$1.F());
        var iterator$1 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs$1));
        var i$1 = 0;
        while ((iterator$1.eY > 0)) {
          array$4.a[i$1] = iterator$1.e();
          i$1 = ((1 + i$1) | 0);
        }
        return new $c_sci_BitmapIndexedMapNode(dataMap, 0, array$4, new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash);
      }
    } else {
      var nodeMap = $m_sci_Node$().cS(mask0);
      var node = this.V2(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      var xs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [node]);
      var array$6 = new $ac_O(xs$2.F());
      var iterator$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs$2));
      var i$2 = 0;
      while ((iterator$2.eY > 0)) {
        array$6.a[i$2] = iterator$2.e();
        i$2 = ((1 + i$2) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, array$6, $m_s_Array$EmptyArrays$().Gz, node.aH(), node.dR());
    }
  }
});
$p.IK = (function() {
  return (this.cU !== 0);
});
$p.IY = (function() {
  return $m_jl_Integer$().cI(this.cU);
});
$p.Ea = (function() {
  return (this.bZ !== 0);
});
$p.J4 = (function() {
  return $m_jl_Integer$().cI(this.bZ);
});
$p.kI = (function(bitpos) {
  return $m_jl_Integer$().cI((this.bZ & ((bitpos - 1) | 0)));
});
$p.uz = (function(bitpos) {
  return $m_jl_Integer$().cI((this.cU & ((bitpos - 1) | 0)));
});
$p.asV = (function(bitpos, newKey, newValue) {
  var dataIx = this.kI(bitpos);
  var idx = (dataIx << 1);
  var src = this.e6;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[((1 + idx) | 0)] = newValue;
  return new $c_sci_BitmapIndexedMapNode(this.bZ, this.cU, dst, this.hv, this.e7, this.hu);
});
$p.asT = (function(bitpos, oldNode, newNode) {
  var idx = ((((this.e6.a.length - 1) | 0) - this.uz(bitpos)) | 0);
  var src = this.e6;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[idx] = newNode;
  return new $c_sci_BitmapIndexedMapNode(this.bZ, this.cU, dst, this.hv, ((((this.e7 - oldNode.aH()) | 0) + newNode.aH()) | 0), ((((this.hu - oldNode.dR()) | 0) + newNode.dR()) | 0));
});
$p.asP = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.kI(bitpos);
  var idx = (dataIx << 1);
  var src = this.e6;
  var dst = new $ac_O(((2 + src.a.length) | 0));
  src.av(0, dst, 0, idx);
  dst.a[idx] = key;
  dst.a[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.a.length - idx) | 0);
  src.av(idx, dst, destPos, length);
  var dstHashes = this.UJ(this.hv, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.bZ | bitpos), this.cU, dst, dstHashes, ((1 + this.e7) | 0), ((this.hu + keyHash) | 0));
});
$p.awg = (function(bitpos, keyHash, node) {
  var dataIx = this.kI(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = ((((this.e6.a.length - 2) | 0) - this.uz(bitpos)) | 0);
  var src = this.e6;
  var dst = new $ac_O(((src.a.length - 1) | 0));
  src.av(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.av(srcPos, dst, idxOld, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 2) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Nj(this.hv, dataIx);
  this.bZ = (this.bZ ^ bitpos);
  this.cU = (this.cU | bitpos);
  this.e6 = dst;
  this.hv = dstHashes;
  this.e7 = ((((this.e7 - 1) | 0) + node.aH()) | 0);
  this.hu = ((((this.hu - keyHash) | 0) + node.dR()) | 0);
  return this;
});
$p.asR = (function(bitpos, keyHash, node) {
  var dataIx = this.kI(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = ((((this.e6.a.length - 2) | 0) - this.uz(bitpos)) | 0);
  var src = this.e6;
  var dst = new $ac_O(((src.a.length - 1) | 0));
  src.av(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.av(srcPos, dst, idxOld, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 2) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Nj(this.hv, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.bZ ^ bitpos), (this.cU | bitpos), dst, dstHashes, ((((this.e7 - 1) | 0) + node.aH()) | 0), ((((this.hu - keyHash) | 0) + node.dR()) | 0));
});
$p.al = (function(f) {
  var iN = $m_jl_Integer$().cI(this.bZ);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.p(this.zI(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().cI(this.cU);
  var j = 0;
  while ((j < jN)) {
    this.io(j).al(f);
    j = ((1 + j) | 0);
  }
});
$p.jo = (function(f) {
  var iN = $m_jl_Integer$().cI(this.bZ);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.cm(this.jr(i$1), this.ip(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().cI(this.cU);
  var j = 0;
  while ((j < jN)) {
    this.io(j).jo(f);
    j = ((1 + j) | 0);
  }
});
$p.Uk = (function(f) {
  var i = 0;
  var iN = $m_jl_Integer$().cI(this.bZ);
  while ((i < iN)) {
    f.afJ(this.jr(i), this.ip(i), this.d1(i));
    i = ((1 + i) | 0);
  }
  var jN = $m_jl_Integer$().cI(this.cU);
  var j = 0;
  while ((j < jN)) {
    this.io(j).Uk(f);
    j = ((1 + j) | 0);
  }
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    if ((this === that)) {
      return true;
    } else if ((((((this.hu === that.hu) && (this.cU === that.cU)) && (this.bZ === that.bZ)) && (this.e7 === that.e7)) && $m_ju_Arrays$().Mz(this.hv, that.hv))) {
      var a1 = this.e6;
      var a2 = that.e6;
      var length = this.e6.a.length;
      if ((a1 === a2)) {
        return true;
      } else {
        var isEqual = true;
        var i = 0;
        while ((isEqual && (i < length))) {
          isEqual = $m_sr_BoxesRunTime$().B(a1.a[i], a2.a[i]);
          i = ((1 + i) | 0);
        }
        return isEqual;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.g = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.agh = (function() {
  var this$1 = this.e6;
  var contentClone = this$1.ar();
  var contentLength = contentClone.a.length;
  var i$1 = ($m_jl_Integer$().cI(this.bZ) << 1);
  while ((i$1 < contentLength)) {
    contentClone.a[i$1] = contentClone.a[i$1].agj();
    i$1 = ((1 + i$1) | 0);
  }
  return new $c_sci_BitmapIndexedMapNode(this.bZ, this.cU, contentClone, this.hv.ar(), this.e7, this.hu);
});
$p.agX = (function(pred, flipped) {
  if ((this.e7 === 0)) {
    return this;
  } else if ((this.e7 === 1)) {
    return (((!(!pred.p(this.zI(0)))) !== flipped) ? this : $m_sci_MapNode$().CY);
  } else if ((this.cU === 0)) {
    var i = this.bZ;
    var minimumIndex = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
    var maximumIndex = ((32 - Math.clz32(this.bZ)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().cS(i$3);
      if (((bitpos & this.bZ) !== 0)) {
        var payload = this.zI(dataIndex);
        if (((!(!pred.p(payload))) !== flipped)) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bV(this.d1(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      return $m_sci_MapNode$().CY;
    } else if ((newDataMap === this.bZ)) {
      return this;
    } else {
      var newSize = $m_jl_Integer$().cI(newDataMap);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var newMaximumIndex = ((32 - Math.clz32(newDataMap)) | 0);
      var i$6 = newDataMap;
      var j = ((32 - Math.clz32(((~i$6) & ((i$6 - 1) | 0)))) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().cS(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().qI(this.bZ, bitpos$2);
          newContent.a[(newDataIndex << 1)] = this.e6.a[(oldIndex << 1)];
          newContent.a[((1 + (newDataIndex << 1)) | 0)] = this.e6.a[((1 + (oldIndex << 1)) | 0)];
          newOriginalHashCodes.a[newDataIndex] = this.hv.a[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.bZ | this.cU);
    var minimumIndex$2 = ((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().cS(i$2$1);
      if (((bitpos$3 & this.bZ) !== 0)) {
        var payload$2 = this.zI(dataIndex$2);
        if (((!(!pred.p(payload$2))) !== flipped)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().bV(this.d1(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.cU) !== 0)) {
        var oldSubNode = this.io(nodeIndex);
        var newSubNode = oldSubNode.ah0(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.aH()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.dR()) | 0);
        if ((newSubNode.aH() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = new $c_scm_Queue(16);
            }
            newNodes.DM(newSubNode);
          }
        } else if ((newSubNode.aH() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), []);
            nodesToMigrateToData = new $c_scm_Queue(16).I9(elems);
          }
          nodesToMigrateToData.DM(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    if ((newSize$2 === 0)) {
      return $m_sci_MapNode$().CY;
    } else if ((newSize$2 === this.e7)) {
      return this;
    } else {
      var newDataSize = $m_jl_Integer$().cI(newDataMap$2);
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().cI(newNodeMap)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().cS(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          newContent$2.a[(newDataIndex$2 << 1)] = this.jr(oldDataIndex);
          newContent$2.a[((1 + (newDataIndex$2 << 1)) | 0)] = this.ip(oldDataIndex);
          newOriginalHashes.a[newDataIndex$2] = this.d1(oldDataIndex);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          newContent$2.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = this.io(oldNodeIndex);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var x$proxy4 = nodesToMigrateToData;
          if ((x$proxy4 === null)) {
            $m_sr_Scala3RunTime$().bW();
          }
          var node = x$proxy4.Nk(false);
          newContent$2.a[(newDataIndex$2 << 1)] = node.jr(0);
          newContent$2.a[((1 + (newDataIndex$2 << 1)) | 0)] = node.ip(0);
          newOriginalHashes.a[newDataIndex$2] = node.d1(0);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $x_1 = newNodeIndex;
          var x$proxy5 = newNodes;
          if ((x$proxy5 === null)) {
            $m_sr_Scala3RunTime$().bW();
          }
          newContent$2.a[((((newContentSize - $x_1) | 0) - 1) | 0)] = x$proxy5.Nk(false);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & this.bZ) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & this.cU) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        }
        i$3$1 = ((1 + i$3$1) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2);
    }
  }
});
$p.IH = (function(index) {
  return this.io(index);
});
$p.akn = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.VO(key, value, originalHash, hash, shift, replaceValue);
});
$p.agj = (function() {
  return this.agh();
});
$p.ah0 = (function(pred, isFlipped) {
  return this.agX(pred, isFlipped);
});
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hk)));
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().i($c_sci_BitmapIndexedMapNode, "scala.collection.immutable.BitmapIndexedMapNode", ({
  hk: 1,
  hw: 1,
  bv: 1
}));
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    return $m_sci_SetNode$().D1;
  } else if ((newSize === $thiz.df)) {
    return $thiz;
  } else {
    var newDataSize = $m_jl_Integer$().cI(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().cI(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().cS(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        newContent.a[newDataIndex] = $thiz.dJ(oldDataIndex);
        newOriginalHashes.a[newDataIndex] = $thiz.d1(oldDataIndex);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        newContent.a[((((newContentSize - newNodeIndex) | 0) - 1) | 0)] = $thiz.fl(oldNodeIndex);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        if ((nodesToMigrateToData === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        var node = nodesToMigrateToData.Nk(false);
        newContent.a[newDataIndex] = node.dJ(0);
        newOriginalHashes.a[newDataIndex] = node.d1(0);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        var $x_1 = newNodeIndex;
        if ((newNodes === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        newContent.a[((((newContentSize - $x_1) | 0) - 1) | 0)] = newNodes.Nk(false);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & $thiz.bm) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & $thiz.c1) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      }
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode);
  }
}
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.bm = 0;
  this.c1 = 0;
  this.e8 = null;
  this.fz = null;
  this.df = 0;
  this.fZ = 0;
  this.bm = dataMap;
  this.c1 = nodeMap;
  this.e8 = content;
  this.fz = originalHashes;
  this.df = size;
  this.fZ = cachedJavaKeySetHashCode;
}
$p = $c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$p.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
}
$h_sci_BitmapIndexedSetNode.prototype = $p;
$p.aH = (function() {
  return this.df;
});
$p.dR = (function() {
  return this.fZ;
});
$p.dJ = (function(index) {
  return this.e8.a[index];
});
$p.d1 = (function(index) {
  return this.fz.a[index];
});
$p.fl = (function(index) {
  return this.e8.a[((((this.e8.a.length - 1) | 0) - index) | 0)];
});
$p.Iu = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().fp(elementHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bm & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bm, mask, bitpos);
    return ((this.fz.a[index] === originalHash) && $m_sr_BoxesRunTime$().B(element, this.dJ(index)));
  }
  if (((this.c1 & bitpos) !== 0)) {
    return this.fl($m_sci_Node$().fn(this.c1, mask, bitpos)).Iu(element, originalHash, elementHash, ((5 + shift) | 0));
  }
  return false;
});
$p.EH = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().fp(elementHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bm & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bm, mask, bitpos);
    var element0 = this.dJ(index);
    if (Object.is(element0, element)) {
      return this;
    } else {
      var element0UnimprovedHash = this.d1(index);
      var element0Hash = $m_sc_Hashing$().bV(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().B(element0, element))) {
        return this;
      } else {
        return this.asS(bitpos, element0Hash, this.IX(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0)));
      }
    }
  }
  if (((this.c1 & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().fn(this.c1, mask, bitpos);
    var subNode = this.fl(index$2);
    var subNodeNew$2 = subNode.Jg(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this;
    } else {
      return this.asU(bitpos, subNode, subNodeNew$2);
    }
  }
  return this.asQ(bitpos, element, originalHash, elementHash);
});
$p.NE = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().fp(elementHash, shift);
  var bitpos = $m_sci_Node$().cS(mask);
  if (((this.bm & bitpos) !== 0)) {
    var index = $m_sci_Node$().fn(this.bm, mask, bitpos);
    var element0 = this.dJ(index);
    var element0UnimprovedHash = this.d1(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().B(element0, element))) {
      return shallowlyMutableNodeMap;
    } else {
      var element0Hash = $m_sc_Hashing$().bV(element0UnimprovedHash);
      this.aiR(bitpos, element0Hash, this.IX(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0)));
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.c1 & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().fn(this.c1, mask, bitpos);
    var subNode = this.fl(index$2);
    var subNodeSize = subNode.aH();
    var subNodeCachedJavaKeySetHashCode = subNode.dR();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchResult8: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          subNode.NE(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = subNode;
          break matchResult8;
        }
      }
      var subNodeNew$2 = subNode.Jg(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos);
      }
      var subNodeNew$3 = subNodeNew$2;
    }
    this.e8.a[((((this.e8.a.length - 1) | 0) - this.uz(bitpos)) | 0)] = subNodeNew$3;
    this.df = ((((this.df - subNodeSize) | 0) + subNodeNew$3.aH()) | 0);
    this.fZ = ((((this.fZ - subNodeCachedJavaKeySetHashCode) | 0) + subNodeNew$3.dR()) | 0);
    return returnNodeMap;
  } else {
    var dataIx = this.kI(bitpos);
    var src = this.e8;
    var dst = new $ac_O(((1 + src.a.length) | 0));
    src.av(0, dst, 0, dataIx);
    dst.a[dataIx] = element;
    var destPos = ((1 + dataIx) | 0);
    var length = ((src.a.length - dataIx) | 0);
    src.av(dataIx, dst, destPos, length);
    var dstHashes = this.UJ(this.fz, dataIx, originalHash);
    this.bm = (this.bm | bitpos);
    this.e8 = dst;
    this.fz = dstHashes;
    this.df = ((1 + this.df) | 0);
    this.fZ = ((this.fZ + elementHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$p.IX = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, $m_sci_Vector$().E5($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key0, key1])));
  } else {
    var mask0 = $m_sci_Node$().fp(keyHash0, shift);
    var mask1 = $m_sci_Node$().fp(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().cS(mask0) | $m_sci_Node$().cS(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      if ((mask0 < mask1)) {
        var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key0, key1]);
        var array$2 = new $ac_O(xs.F());
        var iterator = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs));
        var i = 0;
        while ((iterator.eY > 0)) {
          array$2.a[i] = iterator.e();
          i = ((1 + i) | 0);
        }
        return new $c_sci_BitmapIndexedSetNode(dataMap, 0, array$2, new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode);
      } else {
        var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [key1, key0]);
        var array$4 = new $ac_O(xs$1.F());
        var iterator$1 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs$1));
        var i$1 = 0;
        while ((iterator$1.eY > 0)) {
          array$4.a[i$1] = iterator$1.e();
          i$1 = ((1 + i$1) | 0);
        }
        return new $c_sci_BitmapIndexedSetNode(dataMap, 0, array$4, new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode);
      }
    } else {
      var nodeMap = $m_sci_Node$().cS(mask0);
      var node = this.IX(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      var xs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [node]);
      var array$6 = new $ac_O(xs$2.F());
      var iterator$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs$2));
      var i$2 = 0;
      while ((iterator$2.eY > 0)) {
        array$6.a[i$2] = iterator$2.e();
        i$2 = ((1 + i$2) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, array$6, $m_s_Array$EmptyArrays$().Gz, node.aH(), node.dR());
    }
  }
});
$p.Ea = (function() {
  return (this.bm !== 0);
});
$p.J4 = (function() {
  return $m_jl_Integer$().cI(this.bm);
});
$p.IK = (function() {
  return (this.c1 !== 0);
});
$p.IY = (function() {
  return $m_jl_Integer$().cI(this.c1);
});
$p.kI = (function(bitpos) {
  return $m_jl_Integer$().cI((this.bm & ((bitpos - 1) | 0)));
});
$p.uz = (function(bitpos) {
  return $m_jl_Integer$().cI((this.c1 & ((bitpos - 1) | 0)));
});
$p.asU = (function(bitpos, oldNode, newNode) {
  var idx = ((((this.e8.a.length - 1) | 0) - this.uz(bitpos)) | 0);
  var src = this.e8;
  var dst = new $ac_O(src.a.length);
  var length = src.a.length;
  src.av(0, dst, 0, length);
  dst.a[idx] = newNode;
  return new $c_sci_BitmapIndexedSetNode(this.bm, this.c1, dst, this.fz, ((((this.df - oldNode.aH()) | 0) + newNode.aH()) | 0), ((((this.fZ - oldNode.dR()) | 0) + newNode.dR()) | 0));
});
$p.asQ = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.kI(bitpos);
  var src = this.e8;
  var dst = new $ac_O(((1 + src.a.length) | 0));
  src.av(0, dst, 0, dataIx);
  dst.a[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.a.length - dataIx) | 0);
  src.av(dataIx, dst, destPos, length);
  var dstHashes = this.UJ(this.fz, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.bm | bitpos), this.c1, dst, dstHashes, ((1 + this.df) | 0), ((this.fZ + elementHash) | 0));
});
$p.asS = (function(bitpos, elementHash, node) {
  var dataIx = this.kI(bitpos);
  var idxNew = ((((this.e8.a.length - 1) | 0) - this.uz(bitpos)) | 0);
  var src = this.e8;
  var dst = new $ac_O(src.a.length);
  src.av(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  src.av(srcPos, dst, dataIx, length);
  dst.a[idxNew] = node;
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = ((((src.a.length - idxNew) | 0) - 1) | 0);
  src.av(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.Nj(this.fz, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.bm ^ bitpos), (this.c1 | bitpos), dst, dstHashes, ((((this.df - 1) | 0) + node.aH()) | 0), ((((this.fZ - elementHash) | 0) + node.dR()) | 0));
});
$p.aiR = (function(bitpos, keyHash, node) {
  var dataIx = this.kI(bitpos);
  var idxNew = ((((this.e8.a.length - 1) | 0) - this.uz(bitpos)) | 0);
  var src = this.e8;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.e8;
  var length = ((idxNew - dataIx) | 0);
  src.av(srcPos, dest, dataIx, length);
  this.e8.a[idxNew] = node;
  this.bm = (this.bm ^ bitpos);
  this.c1 = (this.c1 | bitpos);
  this.fz = this.Nj(this.fz, dataIx);
  this.df = ((((this.df - 1) | 0) + node.aH()) | 0);
  this.fZ = ((((this.fZ - keyHash) | 0) + node.dR()) | 0);
  return this;
});
$p.al = (function(f) {
  var thisPayloadArity = $m_jl_Integer$().cI(this.bm);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.p(this.dJ(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var thisNodeArity = $m_jl_Integer$().cI(this.c1);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.fl(j).al(f);
    j = ((1 + j) | 0);
  }
});
$p.VC = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else {
    if ((that instanceof $c_sci_HashCollisionSetNode)) {
      return false;
    }
    if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
      var thisBitmap = (this.bm | this.c1);
      var nodeBitmap = (that.bm | that.c1);
      if (((thisBitmap | nodeBitmap) !== nodeBitmap)) {
        return false;
      }
      var bitmap = (thisBitmap & nodeBitmap);
      var i = bitmap;
      var bitsToSkip = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
      var isValidSubset = true;
      while ((isValidSubset && (bitsToSkip < 32))) {
        var bitpos = $m_sci_Node$().cS(bitsToSkip);
        if (((this.bm & bitpos) !== 0)) {
          if (((that.bm & bitpos) !== 0)) {
            isValidSubset = $m_sr_BoxesRunTime$().B(this.dJ($m_sci_Node$().qI(this.bm, bitpos)), that.dJ($m_sci_Node$().qI(that.bm, bitpos)));
          } else {
            var thisDataIndex = $m_sci_Node$().qI(this.bm, bitpos);
            var payload = this.dJ(thisDataIndex);
            var subNode = that.fl($m_sci_Node$().qI(that.c1, bitpos));
            var elementUnimprovedHash = this.d1(thisDataIndex);
            var elementHash = $m_sc_Hashing$().bV(elementUnimprovedHash);
            isValidSubset = subNode.Iu(payload, elementUnimprovedHash, elementHash, ((5 + shift) | 0));
          }
        } else if (((that.bm & bitpos) === 0)) {
          var subNode0 = this.fl($m_sci_Node$().qI(this.c1, bitpos));
          var subNode1 = that.fl($m_sci_Node$().qI(that.c1, bitpos));
          isValidSubset = subNode0.VC(subNode1, ((5 + shift) | 0));
        } else {
          isValidSubset = false;
        }
        var newBitmap = (bitmap ^ bitpos);
        bitmap = newBitmap;
        bitsToSkip = ((32 - Math.clz32(((~newBitmap) & ((newBitmap - 1) | 0)))) | 0);
      }
      return isValidSubset;
    }
    throw new $c_s_MatchError(that);
  }
});
$p.agY = (function(pred, flipped) {
  if ((this.df === 0)) {
    return this;
  } else if ((this.df === 1)) {
    return (((!(!pred.p(this.dJ(0)))) !== flipped) ? this : $m_sci_SetNode$().D1);
  } else if ((this.c1 === 0)) {
    var i = this.bm;
    var minimumIndex = ((32 - Math.clz32(((~i) & ((i - 1) | 0)))) | 0);
    var maximumIndex = ((32 - Math.clz32(this.bm)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().cS(i$3);
      if (((bitpos & this.bm) !== 0)) {
        var payload = this.dJ(dataIndex);
        if (((!(!pred.p(payload))) !== flipped)) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bV(this.d1(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      return $m_sci_SetNode$().D1;
    } else if ((newDataMap === this.bm)) {
      return this;
    } else {
      var newSize = $m_jl_Integer$().cI(newDataMap);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var newMaximumIndex = ((32 - Math.clz32(newDataMap)) | 0);
      var i$6 = newDataMap;
      var j = ((32 - Math.clz32(((~i$6) & ((i$6 - 1) | 0)))) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().cS(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().qI(this.bm, bitpos$2);
          newContent.a[newDataIndex] = this.e8.a[oldIndex];
          newOriginalHashCodes.a[newDataIndex] = this.fz.a[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.bm | this.c1);
    var minimumIndex$2 = ((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().cS(i$2$1);
      if (((bitpos$3 & this.bm) !== 0)) {
        var payload$2 = this.dJ(dataIndex$2);
        if (((!(!pred.p(payload$2))) !== flipped)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().bV(this.d1(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.c1) !== 0)) {
        var oldSubNode = this.fl(nodeIndex);
        var newSubNode = oldSubNode.ah1(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.aH()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.dR()) | 0);
        if ((newSubNode.aH() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = new $c_scm_Queue(16);
            }
            newNodes.DM(newSubNode);
          }
        } else if ((newSubNode.aH() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = new $c_scm_Queue(16);
          }
          nodesToMigrateToData.DM(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2);
  }
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this === that)) {
      return true;
    } else if ((((((this.fZ === that.fZ) && (this.c1 === that.c1)) && (this.bm === that.bm)) && (this.df === that.df)) && $m_ju_Arrays$().Mz(this.fz, that.fz))) {
      var a1 = this.e8;
      var a2 = that.e8;
      var length = this.e8.a.length;
      if ((a1 === a2)) {
        return true;
      } else {
        var isEqual = true;
        var i = 0;
        while ((isEqual && (i < length))) {
          isEqual = $m_sr_BoxesRunTime$().B(a1.a[i], a2.a[i]);
          i = ((1 + i) | 0);
        }
        return isEqual;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.g = (function() {
  return $m_sc_StringOps$().Ul("BitmapIndexedSetNode(size=%s, dataMap=%x, nodeMap=%x)", $m_sr_ScalaRunTime$().IE(new $ac_O([this.df, this.bm, this.c1])));
});
$p.agi = (function() {
  var this$1 = this.e8;
  var contentClone = this$1.ar();
  var contentLength = contentClone.a.length;
  var i$1 = $m_jl_Integer$().cI(this.bm);
  while ((i$1 < contentLength)) {
    contentClone.a[i$1] = contentClone.a[i$1].agk();
    i$1 = ((1 + i$1) | 0);
  }
  return new $c_sci_BitmapIndexedSetNode(this.bm, this.c1, contentClone, this.fz.ar(), this.df, this.fZ);
});
$p.agc = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this.df === 0)) {
      return that;
    } else if (((that.df === 0) || (that === this))) {
      return this;
    } else if ((that.df === 1)) {
      var originalHash = that.d1(0);
      return this.EH(that.dJ(0), originalHash, $m_sc_Hashing$().bV(originalHash), shift);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.bm | that.bm) | this.c1) | that.c1);
    var minimumBitPos = $m_sci_Node$().cS(((32 - Math.clz32(((~allMap) & ((allMap - 1) | 0)))) | 0));
    var maximumBitPos = $m_sci_Node$().cS(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.bm) !== 0)) {
        if (((bitpos & that.bm) !== 0)) {
          if (((this.d1(leftIdx) === that.d1(rightIdx)) && $m_sr_BoxesRunTime$().B(this.dJ(leftIdx), that.dJ(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().cS($m_sci_Node$().fp($m_sc_Hashing$().bV(this.d1(leftIdx)), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.c1) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.c1) !== 0)) {
        if (((bitpos & that.bm) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.c1) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & that.bm) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & that.c1) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this;
    }
    var newDataSize = $m_jl_Integer$().cI(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().cI(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.fl(leftNodeIdx);
        var newNode = leftNode.agd(that.fl(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.dR()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = that.fl(rightNodeIdx);
        var leftPayload = this.dJ(leftDataIdx);
        var leftOriginalHash = this.d1(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().bV(leftOriginalHash);
        var newNode$2 = n.Jg(leftPayload, leftOriginalHash, leftImproved, nextShift);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$2;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + newNode$2.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$2.dR()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = that.d1(rightDataIdx);
        var leftNode$2 = this.fl(leftNodeIdx);
        var updated = leftNode$2.Jg(that.dJ(rightDataIdx), that.d1(rightDataIdx), $m_sc_Hashing$().bV(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true;
        }
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = updated;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + updated.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.dR()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = this.fz.a[leftDataIdx];
        newContent.a[compressedDataIdx] = this.dJ(leftDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$2;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bV(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = that.fz.a[rightDataIdx];
        newContent.a[compressedDataIdx] = that.dJ(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$3;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bV(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.fl(leftNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$4;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.dR()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = that.fl(rightNodeIdx);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$5;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.dR()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.d1(leftDataIdx);
        var rightOriginalHash$2 = that.d1(rightDataIdx);
        var newNode$6 = that.IX(this.dJ(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().bV(leftOriginalHash$2), that.dJ(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().bV(rightOriginalHash$2), nextShift);
        newContent.a[((((newContentSize - compressedNodeIdx) | 0) - 1) | 0)] = newNode$6;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.aH()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.dR()) | 0);
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = that.fz.a[rightDataIdx];
        newContent.a[compressedDataIdx] = that.dJ(rightDataIdx);
        newOriginalHashes.a[compressedDataIdx] = originalHash$4;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().bV(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this);
  }
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
});
$p.Uj = (function(f) {
  var iN = $m_jl_Integer$().cI(this.bm);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.cm(this.dJ(i$1), this.d1(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var jN = $m_jl_Integer$().cI(this.c1);
  var j = 0;
  while ((j < jN)) {
    this.fl(j).Uj(f);
    j = ((1 + j) | 0);
  }
});
$p.IH = (function(index) {
  return this.fl(index);
});
$p.Jg = (function(element, originalHash, hash, shift) {
  return this.EH(element, originalHash, hash, shift);
});
$p.ah1 = (function(pred, flipped) {
  return this.agY(pred, flipped);
});
$p.agk = (function() {
  return this.agi();
});
$p.agd = (function(that, shift) {
  return this.agc(that, shift);
});
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hl)));
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().i($c_sci_BitmapIndexedSetNode, "scala.collection.immutable.BitmapIndexedSetNode", ({
  hl: 1,
  hB: 1,
  bv: 1
}));
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.CS = 0;
  this.mj = 0;
  this.dy = null;
  this.CS = originalHash;
  this.mj = hash;
  this.dy = content;
  $m_s_Predef$().Nl((this.dy.F() >= 2));
}
$p = $c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$p.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
}
$h_sci_HashCollisionMapNode.prototype = $p;
$p.Ee = (function(key) {
  var iter = this.dy.l();
  var i = 0;
  while (iter.f()) {
    if ($m_sr_BoxesRunTime$().B(iter.e().P(), key)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$p.aH = (function() {
  return this.dy.F();
});
$p.TF = (function(key, originalHash, hash, shift) {
  var this$1 = this.MI(key, originalHash, hash, shift);
  return (this$1.c() ? $m_sc_Iterator$().aZ.e() : this$1.h());
});
$p.MI = (function(key, originalHash, hash, shift) {
  if ((this.mj === hash)) {
    var index = this.Ee(key);
    return ((index >= 0) ? new $c_s_Some(this.dy.at(index).V()) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
});
$p.Ut = (function(key, originalHash, hash, shift, f) {
  if ((this.mj === hash)) {
    var x36 = this.Ee(key);
    if ((x36 === (-1))) {
      return f.aA();
    }
    return this.dy.at(x36).V();
  } else {
    return f.aA();
  }
});
$p.U1 = (function(key, originalHash, hash, shift) {
  return ((this.mj === hash) && (this.Ee(key) >= 0));
});
$p.akn = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.Ee(key);
  return ((index >= 0) ? (replaceValue ? (Object.is(this.dy.at(index).V(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.dy.qQ(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.dy.fH(new $c_T2(key, value))));
});
$p.IK = (function() {
  return false;
});
$p.IY = (function() {
  return 0;
});
$p.io = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$p.Ea = (function() {
  return true;
});
$p.J4 = (function() {
  return this.dy.F();
});
$p.jr = (function(index) {
  return this.dy.at(index).P();
});
$p.ip = (function(index) {
  return this.dy.at(index).V();
});
$p.zI = (function(index) {
  return this.dy.at(index);
});
$p.d1 = (function(index) {
  return this.CS;
});
$p.al = (function(f) {
  this.dy.al(f);
});
$p.jo = (function(f) {
  this.dy.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var k = x$1$2.P();
    var v = x$1$2.V();
    return f.cm(k, v);
  })));
});
$p.Uk = (function(f) {
  var iter = this.dy.l();
  while (iter.f()) {
    var next = iter.e();
    f.afJ(next.P(), next.V(), this.CS);
  }
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    if ((this === that)) {
      return true;
    } else if (((this.mj === that.mj) && (this.dy.F() === that.dy.F()))) {
      var iter = this.dy.l();
      while (iter.f()) {
        var x47 = iter.e();
        x47.P();
        x47.V();
        var \u03b412$ = x47;
        var key$2 = \u03b412$.P();
        var value$2 = \u03b412$.V();
        var index = that.Ee(key$2);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().B(value$2, that.dy.at(index).V())))) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.ah0 = (function(pred, flipped) {
  var newContent = this.dy.MC(pred, flipped);
  var newContentLength = newContent.F();
  if ((newContentLength === 0)) {
    return $m_sci_MapNode$().CY;
  } else if ((newContentLength === 1)) {
    var x61 = newContent.W();
    x61.P();
    x61.V();
    var \u03b416$ = x61;
    var k$2 = \u03b416$.P();
    var v$2 = \u03b416$.V();
    var $x_1 = $m_sci_Node$().cS($m_sci_Node$().fp(this.mj, 0));
    var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [k$2, v$2]);
    var array$1 = new $ac_O(xs.F());
    var iterator = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs));
    var i = 0;
    while ((iterator.eY > 0)) {
      array$1.a[i] = iterator.e();
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedMapNode($x_1, 0, array$1, new $ac_I(new Int32Array([this.CS])), 1, this.mj);
  } else {
    return ((newContentLength === this.dy.F()) ? this : new $c_sci_HashCollisionMapNode(this.CS, this.mj, newContent));
  }
});
$p.r = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.g = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$p.dR = (function() {
  return Math.imul(this.dy.F(), this.mj);
});
$p.IH = (function(index) {
  return this.io(index);
});
$p.agj = (function() {
  return new $c_sci_HashCollisionMapNode(this.CS, this.mj, this.dy);
});
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hm)));
}
var $d_sci_HashCollisionMapNode = new $TypeData().i($c_sci_HashCollisionMapNode, "scala.collection.immutable.HashCollisionMapNode", ({
  hm: 1,
  hw: 1,
  bv: 1
}));
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.yr = 0;
  this.o6 = 0;
  this.dl = null;
  this.yr = originalHash;
  this.o6 = hash;
  this.dl = content;
  $m_s_Predef$().Nl((this.dl.F() >= 2));
}
$p = $c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$p.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
}
$h_sci_HashCollisionSetNode.prototype = $p;
$p.Iu = (function(element, originalHash, hash, shift) {
  return ((this.o6 === hash) && $f_sc_SeqOps__contains__O__Z(this.dl, element));
});
$p.Jg = (function(element, originalHash, hash, shift) {
  return (this.Iu(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.dl.fH(element)));
});
$p.IK = (function() {
  return false;
});
$p.IY = (function() {
  return 0;
});
$p.fl = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$p.Ea = (function() {
  return true;
});
$p.J4 = (function() {
  return this.dl.F();
});
$p.dJ = (function(index) {
  return this.dl.at(index);
});
$p.d1 = (function(index) {
  return this.yr;
});
$p.aH = (function() {
  return this.dl.F();
});
$p.al = (function(f) {
  var iter = this.dl.l();
  while (iter.f()) {
    f.p(iter.e());
  }
});
$p.dR = (function() {
  return Math.imul(this.dl.F(), this.o6);
});
$p.VC = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this.dl.F() <= that.dl.F())) {
      var this$1 = this.dl;
      var \u03b41$ = that.dl;
      var res = true;
      var it = this$1.l();
      while ((res && it.f())) {
        res = $f_sc_SeqOps__contains__O__Z(\u03b41$, it.e());
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.ah1 = (function(pred, flipped) {
  var newContent = this.dl.MC(pred, flipped);
  var newContentLength = newContent.F();
  if ((newContentLength === 0)) {
    return $m_sci_SetNode$().D1;
  } else if ((newContentLength === 1)) {
    var $x_1 = $m_sci_Node$().cS($m_sci_Node$().fp(this.o6, 0));
    var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [newContent.W()]);
    var array$1 = new $ac_O(xs.F());
    var iterator = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(xs));
    var i = 0;
    while ((iterator.eY > 0)) {
      array$1.a[i] = iterator.e();
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode($x_1, 0, array$1, new $ac_I(new Int32Array([this.yr])), 1, this.o6);
  } else {
    return ((newContent.F() === this.dl.F()) ? this : new $c_sci_HashCollisionSetNode(this.yr, this.o6, newContent));
  }
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this === that)) {
      return true;
    } else if (((this.o6 === that.o6) && (this.dl.F() === that.dl.F()))) {
      var this$3 = this.dl;
      var \u03b42$ = that.dl;
      var res = true;
      var it = this$3.l();
      while ((res && it.f())) {
        res = $f_sc_SeqOps__contains__O__Z(\u03b42$, it.e());
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$p.agd = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((that === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = that.dl.l();
      while (iter.f()) {
        var nextPayload = iter.e();
        if ((!$f_sc_SeqOps__contains__O__Z(this.dl, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.ul(this.dl);
          }
          newContent.DL(nextPayload);
        }
      }
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.yr, this.o6, newContent.ix()));
    }
  }
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  }
  throw new $c_s_MatchError(that);
});
$p.Uj = (function(f) {
  var iter = this.dl.l();
  while (iter.f()) {
    var next = iter.e();
    f.cm(next, this.yr);
  }
});
$p.IH = (function(index) {
  return this.fl(index);
});
$p.agk = (function() {
  return new $c_sci_HashCollisionSetNode(this.yr, this.o6, this.dl);
});
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hn)));
}
var $d_sci_HashCollisionSetNode = new $TypeData().i($c_sci_HashCollisionSetNode, "scala.collection.immutable.HashCollisionSetNode", ({
  hn: 1,
  hB: 1,
  bv: 1
}));
/** @constructor */
function $c_sci_HashMap$() {
  this.kr = null;
  $n_sci_HashMap$ = this;
  this.kr = new $c_sci_HashMap($m_sci_MapNode$().CY);
}
$p = $c_sci_HashMap$.prototype = new $h_O();
$p.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
}
$h_sci_HashMap$.prototype = $p;
$p.e4 = (function(elems) {
  return this.ahb(elems);
});
$p.ahb = (function(source) {
  return ((source instanceof $c_sci_HashMap) ? source : new $c_sci_HashMapBuilder().Tw(source).Vg());
});
$p.ce = (function() {
  return this.kr;
});
$p.bp = (function(it) {
  return this.ahb(it);
});
$p.aP = (function() {
  return new $c_sci_HashMapBuilder();
});
var $d_sci_HashMap$ = new $TypeData().i($c_sci_HashMap$, "scala.collection.immutable.HashMap$", ({
  xx: 1,
  a: 1,
  bp: 1
}));
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$();
  }
  return $n_sci_HashMap$;
}
/** @constructor */
function $c_sci_HashSet$() {
  this.CV = null;
  $n_sci_HashSet$ = this;
  this.CV = new $c_sci_HashSet($m_sci_SetNode$().D1);
}
$p = $c_sci_HashSet$.prototype = new $h_O();
$p.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
}
$h_sci_HashSet$.prototype = $p;
$p.au8 = (function(source) {
  return ((source instanceof $c_sci_HashSet) ? source : ((source.G() === 0) ? this.CV : new $c_sci_HashSetBuilder().Tx(source).Vh()));
});
$p.ce = (function() {
  return this.CV;
});
$p.bp = (function(source) {
  return this.au8(source);
});
$p.aP = (function() {
  return new $c_sci_HashSetBuilder();
});
var $d_sci_HashSet$ = new $TypeData().i($c_sci_HashSet$, "scala.collection.immutable.HashSet$", ({
  xA: 1,
  a: 1,
  U: 1
}));
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$();
  }
  return $n_sci_HashSet$;
}
/** @constructor */
function $c_sci_LazyList$WithFilter(lazyList, p) {
  this.aaZ = null;
  this.aaZ = lazyList.agW(p);
}
$p = $c_sci_LazyList$WithFilter.prototype = new $h_sc_WithFilter();
$p.constructor = $c_sci_LazyList$WithFilter;
/** @constructor */
function $h_sci_LazyList$WithFilter() {
}
$h_sci_LazyList$WithFilter.prototype = $p;
$p.El = (function(f) {
  return this.aaZ.El(f);
});
$p.X = (function(f) {
  return this.El(f);
});
var $d_sci_LazyList$WithFilter = new $TypeData().i($c_sci_LazyList$WithFilter, "scala.collection.immutable.LazyList$WithFilter", ({
  xO: 1,
  c1: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$() {
}
$p = $c_sci_Map$.prototype = new $h_O();
$p.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
}
$h_sci_Map$.prototype = $p;
$p.e4 = (function(elems) {
  return this.dH(elems);
});
$p.dH = (function(it) {
  if ($is_sci_Iterable(it)) {
    if (it.c()) {
      return $m_sci_Map$EmptyMap$();
    }
  }
  if ((it instanceof $c_sci_HashMap)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map1)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map2)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map3)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map4)) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  return new $c_sci_MapBuilderImpl().afq(it).Vi();
});
$p.aP = (function() {
  return new $c_sci_MapBuilderImpl();
});
$p.ce = (function() {
  return $m_sci_Map$EmptyMap$();
});
$p.bp = (function(it) {
  return this.dH(it);
});
var $d_sci_Map$ = new $TypeData().i($c_sci_Map$, "scala.collection.immutable.Map$", ({
  xT: 1,
  a: 1,
  bp: 1
}));
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$();
  }
  return $n_sci_Map$;
}
/** @constructor */
function $c_sci_Set$() {
}
$p = $c_sci_Set$.prototype = new $h_O();
$p.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
}
$h_sci_Set$.prototype = $p;
$p.jp = (function(it) {
  return ((it.G() === 0) ? $m_sci_Set$EmptySet$() : ((it instanceof $c_sci_HashSet) ? it : (false ? it : ((it instanceof $c_sci_Set$Set1) ? it : ((it instanceof $c_sci_Set$Set2) ? it : ((it instanceof $c_sci_Set$Set3) ? it : ((it instanceof $c_sci_Set$Set4) ? it : ((it instanceof $c_sci_HashMap$HashKeySet) ? it : ((it instanceof $c_sci_MapOps$LazyImmutableKeySet) ? it : new $c_sci_SetBuilderImpl().afr(it).ajq())))))))));
});
$p.aP = (function() {
  return new $c_sci_SetBuilderImpl();
});
$p.ce = (function() {
  return $m_sci_Set$EmptySet$();
});
$p.bp = (function(source) {
  return this.jp(source);
});
var $d_sci_Set$ = new $TypeData().i($c_sci_Set$, "scala.collection.immutable.Set$", ({
  yo: 1,
  a: 1,
  U: 1
}));
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$();
  }
  return $n_sci_Set$;
}
/** @constructor */
function $c_sci_WrappedString$() {
}
$p = $c_sci_WrappedString$.prototype = new $h_O();
$p.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
}
$h_sci_WrappedString$.prototype = $p;
$p.ahj = (function(it) {
  var b = this.aP();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, it, 0);
  b.cz(it);
  return b.aR();
});
$p.aP = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => new $c_sci_WrappedString(x$2))), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
var $d_sci_WrappedString$ = new $TypeData().i($c_sci_WrappedString$, "scala.collection.immutable.WrappedString$", ({
  yG: 1,
  bf: 1,
  cF: 1
}));
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$();
  }
  return $n_sci_WrappedString$;
}
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var x1 = coll.G();
  if ((x1 === (-1))) {
    return (void 0);
  }
  var that = ((x1 + delta) | 0);
  $thiz.dk(((that < 0) ? 0 : that));
}
/** @constructor */
function $c_scm_HashMap$() {
}
$p = $c_scm_HashMap$.prototype = new $h_O();
$p.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
}
$h_scm_HashMap$.prototype = $p;
$p.e4 = (function(elems) {
  return this.ahd(elems);
});
$p.ahd = (function(it) {
  var k = it.G();
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16), 0.75).aft(it);
});
$p.aP = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75);
});
$p.ce = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap());
});
$p.bp = (function(it) {
  return this.ahd(it);
});
var $d_scm_HashMap$ = new $TypeData().i($c_scm_HashMap$, "scala.collection.mutable.HashMap$", ({
  z1: 1,
  a: 1,
  bp: 1
}));
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$();
  }
  return $n_scm_HashMap$;
}
/** @constructor */
function $c_scm_HashSet$() {
}
$p = $c_scm_HashSet$.prototype = new $h_O();
$p.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
}
$h_scm_HashSet$.prototype = $p;
$p.aua = (function(it) {
  var k = it.G();
  return $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16), 0.75).afu(it);
});
$p.aP = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75);
});
$p.bp = (function(source) {
  return this.aua(source);
});
$p.ce = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet());
});
var $d_scm_HashSet$ = new $TypeData().i($c_scm_HashSet$, "scala.collection.mutable.HashSet$", ({
  z9: 1,
  a: 1,
  U: 1
}));
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$();
  }
  return $n_scm_HashSet$;
}
/** @constructor */
function $c_scm_LinkedHashSet$() {
}
$p = $c_scm_LinkedHashSet$.prototype = new $h_O();
$p.constructor = $c_scm_LinkedHashSet$;
/** @constructor */
function $h_scm_LinkedHashSet$() {
}
$h_scm_LinkedHashSet$.prototype = $p;
$p.aub = (function(it) {
  var newlhs = new $c_scm_LinkedHashSet();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(newlhs, it, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(newlhs, it);
  return newlhs;
});
$p.ce = (function() {
  return new $c_scm_LinkedHashSet();
});
$p.bp = (function(source) {
  return this.aub(source);
});
$p.aP = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_LinkedHashSet());
});
var $d_scm_LinkedHashSet$ = new $TypeData().i($c_scm_LinkedHashSet$, "scala.collection.mutable.LinkedHashSet$", ({
  zj: 1,
  a: 1,
  U: 1
}));
var $n_scm_LinkedHashSet$;
function $m_scm_LinkedHashSet$() {
  if ((!$n_scm_LinkedHashSet$)) {
    $n_scm_LinkedHashSet$ = new $c_scm_LinkedHashSet$();
  }
  return $n_scm_LinkedHashSet$;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.He = null;
  this.Hf = null;
  this.tH = 0;
  this.alh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.alh = outer;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__jl_Runnable__Ajl_Runnable__I__(this, runnable, $m_s_concurrent_BatchingExecutorStatics$().abk, 1);
}
$p = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$p.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $p;
$p.zV = (function() {
  while (true) {
    try {
      this.axx(1024);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if (false) {
        $m_s_concurrent_ExecutionContext$().D6.p(e$2);
      } else {
        matchResult2: {
          if ($m_s_util_control_NonFatal$().DO(e$2)) {
            $m_s_concurrent_ExecutionContext$().D6.p(e$2);
            break matchResult2;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
        }
      }
    }
    if ((this.tH > 0)) {
    } else {
      return (void 0);
    }
  }
});
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i2)));
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().i($c_s_concurrent_BatchingExecutor$SyncBatch, "scala.concurrent.BatchingExecutor$SyncBatch", ({
  i2: 1,
  zy: 1,
  co: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ci = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to);
}
$p = $c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$p.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
}
$h_s_concurrent_impl_Promise$Link.prototype = $p;
$p.Ev = (function(owner) {
  var c = this.ci;
  var target$tailLocal1 = c;
  var current$tailLocal1 = c;
  while (true) {
    var value = target$tailLocal1.ci;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.Ir(current$tailLocal1, target$tailLocal1)) {
        return target$tailLocal1;
      } else {
        current$tailLocal1 = this.ci;
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target$tailLocal1 = value.ci;
    } else {
      owner.ayO(value);
      return owner;
    }
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i6)));
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().i($c_s_concurrent_impl_Promise$Link, "scala.concurrent.impl.Promise$Link", ({
  i6: 1,
  bT: 1,
  a: 1
}));
/** @constructor */
function $c_s_math_ScalaNumber() {
}
$p = $c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$p.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
}
$h_s_math_ScalaNumber.prototype = $p;
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d2)));
}
/** @constructor */
function $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(f) {
  this.abB = null;
  this.abB = f;
}
$p = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = new $h_sr_AbstractFunction0();
$p.constructor = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c;
/** @constructor */
function $h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c() {
}
$h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = $p;
$p.aA = (function() {
  return (0, this.abB)();
});
var $d_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c = new $TypeData().i($c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c, "scala.runtime.AbstractFunction0.$$Lambda$07eded5776954a9c145e92c329afd52873ad179c", ({
  AP: 1,
  AO: 1,
  vR: 1
}));
/** @constructor */
function $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(f) {
  this.abC = null;
  this.abC = f;
}
$p = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919;
/** @constructor */
function $h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919() {
}
$h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = $p;
$p.p = (function(x0) {
  return (0, this.abC)(x0);
});
var $d_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919 = new $TypeData().i($c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919, "scala.runtime.AbstractFunction1.$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919", ({
  AQ: 1,
  bD: 1,
  p: 1
}));
/** @constructor */
function $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(f) {
  this.abD = null;
  this.abD = f;
}
$p = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = new $h_sr_AbstractFunction2();
$p.constructor = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8;
/** @constructor */
function $h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8() {
}
$h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = $p;
$p.cm = (function(x0, x1) {
  return (0, this.abD)(x0, x1);
});
var $d_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8 = new $TypeData().i($c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8, "scala.runtime.AbstractFunction2.$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8", ({
  AR: 1,
  ii: 1,
  cu: 1
}));
/** @constructor */
function $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(f) {
  this.abE = null;
  this.abE = f;
}
$p = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = new $h_sr_AbstractFunction3();
$p.constructor = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825;
/** @constructor */
function $h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825() {
}
$h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = $p;
$p.afJ = (function(x0, x1, x2) {
  return (0, this.abE)(x0, x1, x2);
});
var $d_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825 = new $TypeData().i($c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825, "scala.runtime.AbstractFunction3.$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825", ({
  AT: 1,
  AS: 1,
  vS: 1
}));
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
$p = $c_sr_AbstractPartialFunction.prototype = new $h_O();
$p.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
$h_sr_AbstractPartialFunction.prototype = $p;
$p.g = (function() {
  return "<function1>";
});
$p.p = (function(x) {
  return this.aJ(x, $m_s_PartialFunction$().fX);
});
$p.hK = (function(x) {
  this.aJ(x, $m_s_PartialFunction$().fX);
});
var $d_sr_Nothing$ = new $TypeData().i(0, "scala.runtime.Nothing$", ({
  B4: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_sr_TupleXXL(es) {
  this.ms = null;
  this.ms = es;
  if ((es.a.length <= 22)) {
    $m_sr_Scala3RunTime$().afO();
  }
}
$p = $c_sr_TupleXXL.prototype = new $h_O();
$p.constructor = $c_sr_TupleXXL;
/** @constructor */
function $h_sr_TupleXXL() {
}
$h_sr_TupleXXL.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.z = (function(n) {
  return this.ms.a[n];
});
$p.w = (function() {
  return this.ms.a.length;
});
$p.A = (function() {
  return "Tuple";
});
$p.g = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($m_s_Predef$().Jl(this.ms), "(", ",", ")");
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(that) {
  if ((that instanceof $c_sr_TupleXXL)) {
    if ((this.ms === that.ms)) {
      return true;
    } else {
      if ((this.ms.a.length !== that.ms.a.length)) {
        return false;
      }
      var i = 0;
      while ((i < this.ms.a.length)) {
        var $x_2 = $m_sr_BoxesRunTime$();
        var arr$3 = this.ms;
        var n = i;
        var $x_1 = arr$3.a[n];
        var arr$4 = that.ms;
        var n$1 = i;
        if ((!$x_2.B($x_1, arr$4.a[n$1]))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    }
  } else {
    return false;
  }
});
function $isArrayOf_sr_TupleXXL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ik)));
}
var $d_sr_TupleXXL = new $TypeData().i($c_sr_TupleXXL, "scala.runtime.TupleXXL", ({
  ik: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_sjs_js_Any$() {
}
$p = $c_sjs_js_Any$.prototype = new $h_O();
$p.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
$h_sjs_js_Any$.prototype = $p;
$p.gI = (function(f) {
  return (() => f.aA());
});
$p.b3 = (function(f) {
  return ((arg1$2) => f.p(arg1$2));
});
var $d_sjs_js_Any$ = new $TypeData().i($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  Bo: 1,
  Br: 1,
  Bs: 1
}));
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
/** @constructor */
function $c_sjsr_AnonFunction1() {
}
$p = $c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
$h_sjsr_AnonFunction1.prototype = $p;
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.BI)));
}
function $f_Lscalatags_JsDom$Aggregate__$init$__V($thiz) {
  $thiz.alC = $m_Lscalatags_JsDom$RawFrag$();
}
/** @constructor */
function $c_Lscalatags_JsDom$Cap$SeqFrag(outer, xs, ev) {
  this.Sw = null;
  this.Sv = null;
  this.Sw = xs;
  this.Sv = ev;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lscalatags_JsDom$Cap$SeqFrag.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$Cap$SeqFrag;
/** @constructor */
function $h_Lscalatags_JsDom$Cap$SeqFrag() {
}
$h_Lscalatags_JsDom$Cap$SeqFrag.prototype = $p;
$p.TH = (function(t) {
  this.Sw.al(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((elem) => {
    this.Sv.p(elem).oD(t);
  })));
});
$p.uB = (function() {
  var frag = document.createDocumentFragment();
  this.Sw.X(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((elem) => this.Sv.p(elem).J6()))).al(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((newChild) => frag.appendChild(newChild))));
  return frag;
});
$p.oD = (function(t) {
  this.TH(t);
});
$p.J6 = (function() {
  return this.uB();
});
var $d_Lscalatags_JsDom$Cap$SeqFrag = new $TypeData().i($c_Lscalatags_JsDom$Cap$SeqFrag, "scalatags.JsDom$Cap$SeqFrag", ({
  BS: 1,
  aZ: 1,
  bF: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$RawFrag$() {
}
$p = $c_Lscalatags_JsDom$RawFrag$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$RawFrag$;
/** @constructor */
function $h_Lscalatags_JsDom$RawFrag$() {
}
$h_Lscalatags_JsDom$RawFrag$.prototype = $p;
$p.g = (function() {
  return "RawFrag";
});
var $d_Lscalatags_JsDom$RawFrag$ = new $TypeData().i($c_Lscalatags_JsDom$RawFrag$, "scalatags.JsDom$RawFrag$", ({
  BV: 1,
  v: 1,
  w: 1
}));
var $n_Lscalatags_JsDom$RawFrag$;
function $m_Lscalatags_JsDom$RawFrag$() {
  if ((!$n_Lscalatags_JsDom$RawFrag$)) {
    $n_Lscalatags_JsDom$RawFrag$ = new $c_Lscalatags_JsDom$RawFrag$();
  }
  return $n_Lscalatags_JsDom$RawFrag$;
}
/** @constructor */
function $c_Lscalatags_LowPriorityImplicits$bindNode(outer, e) {
  this.ky = null;
  this.ky = e;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lscalatags_LowPriorityImplicits$bindNode.prototype = new $h_O();
$p.constructor = $c_Lscalatags_LowPriorityImplicits$bindNode;
/** @constructor */
function $h_Lscalatags_LowPriorityImplicits$bindNode() {
}
$h_Lscalatags_LowPriorityImplicits$bindNode.prototype = $p;
$p.TH = (function(t) {
  t.appendChild(this.ky);
});
$p.oD = (function(t) {
  this.TH(t);
});
$p.J6 = (function() {
  return this.ky;
});
var $d_Lscalatags_LowPriorityImplicits$bindNode = new $TypeData().i($c_Lscalatags_LowPriorityImplicits$bindNode, "scalatags.LowPriorityImplicits$bindNode", ({
  C1: 1,
  aZ: 1,
  bF: 1
}));
function $f_Lscalatags_generic_FormEventAttrs__selected__Lscalatags_generic_AttrPair($thiz) {
  var this$1 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "selected", null, false);
  var ev = new $c_Lscalatags_JsDom$GenericAttr();
  return this$1.n(this$1.jf, ev);
}
function $f_Lscalatags_generic_GlobalAttrs__data__T__Lscalatags_generic_Attr($thiz, suffix) {
  return new $c_Lscalatags_generic_Attr(("data-" + suffix), $m_s_None$(), false);
}
function $f_Lscalatags_generic_MouseEventAttrs__$init$__V($thiz) {
  $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "ondrag", null, false);
}
function $f_Lscalatags_generic_TypedTag__build__O__V($thiz, b) {
  var current = $thiz.tK;
  var arr = $m_jl_reflect_Array$().awq($d_sci_Seq.l(), new $ac_I(new Int32Array([$thiz.tK.F()])));
  var i = 0;
  while (true) {
    var x = current;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.b(x$2)))) {
      arr.a[i] = current.W();
      current = current.ak();
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var j = arr.a.length;
  while ((j > 0)) {
    j = ((j - 1) | 0);
    var frag = arr.a[j];
    var i$2 = 0;
    while ((i$2 < frag.F())) {
      frag.at(i$2).oD(b);
      i$2 = ((1 + i$2) | 0);
    }
  }
}
function $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V($thiz, b) {
  b.appendChild($thiz.uB());
}
function $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag($thiz, s, void$1, ns) {
  if ((!$m_Lscalatags_Escaping$().az5(s))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Illegal tag name: " + s) + " is not a valid XML tag name"));
  }
  return new $c_Lscalatags_JsDom$TypedTag(s, $m_sci_Nil$(), void$1, ns);
}
function $ct_Lujson_BaseCharRenderer__Ljava_io_Writer__I__Z__($thiz, out, indent, escapeUnicode) {
  $thiz.hD = out;
  $thiz.Hx = indent;
  $thiz.Sz = escapeUnicode;
  $thiz.c0 = new $c_Lupickle_core_CharBuilder(32);
  $thiz.SA = new $c_Lupickle_core_CharBuilder(32);
  $thiz.kz = 0;
  $thiz.Hz = false;
  $thiz.ok = false;
  $thiz.kA = false;
  $thiz.Hy = false;
  return $thiz;
}
/** @constructor */
function $c_Lujson_BaseCharRenderer() {
  this.hD = null;
  this.Hx = 0;
  this.Sz = false;
  this.c0 = null;
  this.SA = null;
  this.kz = 0;
  this.Hz = false;
  this.ok = false;
  this.kA = false;
  this.Hy = false;
}
$p = $c_Lujson_BaseCharRenderer.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer;
/** @constructor */
function $h_Lujson_BaseCharRenderer() {
}
$h_Lujson_BaseCharRenderer.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.cL = (function(s, index) {
  return $f_Lujson_JsVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lujson_JsVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cB = (function(s, index) {
  return this.VU(("" + $cToS(s)), index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lujson_JsVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.mE = (function() {
  this.c0.aC4(this.hD, ((this.kz === 0) ? 0 : 1000));
});
$p.kK = (function() {
  if (this.ok) {
    this.ok = false;
    this.c0.eP(44);
  }
  if (this.kA) {
    this.kA = false;
    this.Vd();
  }
  if (this.Hy) {
    this.Hy = false;
    this.c0.eP(34);
  }
});
$p.bt = (function(length, index) {
  return new $c_Lujson_BaseCharRenderer$$anon$1(this);
});
$p.akw = (function(index) {
  this.kK();
  $m_Lujson_BaseCharRenderer$().ayJ(this.c0);
  this.mE();
  return this.hD;
});
$p.aze = (function(index) {
  this.kK();
  $m_Lujson_BaseCharRenderer$().ayH(this.c0);
  this.mE();
  return this.hD;
});
$p.azt = (function(index) {
  this.kK();
  $m_Lujson_BaseCharRenderer$().ayK(this.c0);
  this.mE();
  return this.hD;
});
$p.akv = (function(s, decIndex, expIndex, index) {
  this.kK();
  $m_Lujson_BaseCharRenderer$().VJ(this.c0, s);
  this.mE();
  return this.hD;
});
$p.azf = (function(d, index) {
  if ((Infinity === d)) {
    this.Ac("Infinity", (-1));
  } else if (((-Infinity) === d)) {
    this.Ac("-Infinity", (-1));
  } else if ((d !== d)) {
    this.Ac("NaN", (-1));
  } else {
    var i = $doubleToInt(d);
    if ((d === Math.fround(i))) {
      this.Jk(i, index);
    } else {
      var $x_1 = $m_RTLong$().jq(d);
      var i$2_$_lo = $x_1.l;
      var i$2_$_hi = $x_1.h;
      this.kK();
      var compressedLo = (((((-2097152) & (i$2_$_hi ^ (i$2_$_hi >> 10))) === 0) || ((65535 & i$2_$_lo) === 0)) ? i$2_$_lo : (32768 | ((-32768) & i$2_$_lo)));
      if ((Math.fround(((4.294967296E9 * i$2_$_hi) + (compressedLo >>> 0.0))) === d)) {
        $m_Lujson_BaseCharRenderer$().VJ(this.c0, ("" + d));
      } else {
        this.c0.im(15);
        this.c0.be = ((this.c0.be + $m_Lujson_MathUtilsChar$().akd(this.c0.dr, this.c0.be, ("" + d))) | 0);
      }
      this.mE();
    }
  }
  return this.hD;
});
$p.VT = (function(d, index) {
  if ((Infinity === d)) {
    this.Ac("Infinity", (-1));
  } else if (((-Infinity) === d)) {
    this.Ac("-Infinity", (-1));
  } else if ((d !== d)) {
    this.Ac("NaN", (-1));
  } else {
    var i = $doubleToInt(d);
    if ((d === i)) {
      this.Jk(i, index);
    } else {
      var $x_1 = $m_RTLong$().jq(d);
      var i$2_$_lo = $x_1.l;
      var i$2_$_hi = $x_1.h;
      this.kK();
      if ((((4.294967296E9 * i$2_$_hi) + (i$2_$_lo >>> 0.0)) === d)) {
        $m_Lujson_BaseCharRenderer$().VJ(this.c0, $m_RTLong$().gc(i$2_$_lo, i$2_$_hi));
      } else {
        this.c0.im(24);
        this.c0.be = ((this.c0.be + $m_Lujson_MathUtilsChar$().akd(this.c0.dr, this.c0.be, ("" + d))) | 0);
      }
      this.mE();
    }
  }
  return this.hD;
});
$p.Jk = (function(i, index) {
  this.kK();
  $m_Lujson_BaseCharRenderer$().ayI(this.c0, i);
  this.mE();
  return this.hD;
});
$p.azr = (function(i_$_lo, i_$_hi, index) {
  this.kK();
  var sign = (i_$_hi >> 31);
  var xlo = (i_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((i_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  if ((((rhi === 2097152) ? (rlo !== 0) : (rhi > 2097152)) || ((i_$_lo | ((-2147483648) ^ i_$_hi)) === 0))) {
    this.c0.eP(34);
    $m_Lujson_BaseCharRenderer$().aki(this.c0, i_$_lo, i_$_hi);
    this.c0.eP(34);
  } else {
    $m_Lujson_BaseCharRenderer$().aki(this.c0, i_$_lo, i_$_hi);
  }
  this.mE();
  return this.hD;
});
$p.azu = (function(i_$_lo, i_$_hi, index) {
  if ((((i_$_lo ^ i_$_lo) | ((i_$_lo >> 31) ^ i_$_hi)) === 0)) {
    this.Jk(i_$_lo, index);
  } else {
    $f_Lujson_JsVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
  }
  return this.hD;
});
$p.VU = (function(s, index) {
  return ((s === null) ? this.akw(index) : this.Ac(s, index));
});
$p.Ac = (function(s, index) {
  this.kK();
  $m_Lupickle_core_RenderUtils$().agS(this.SA, this.c0, s, this.Sz, (!this.Hz));
  this.mE();
  return this.hD;
});
$p.Vd = (function() {
  if ((this.Hx !== (-1))) {
    var i = Math.imul(this.Hx, this.kz);
    this.c0.im(((1 + i) | 0));
    $m_Lujson_BaseCharRenderer$().ayL(this.c0.dr, this.c0.be, i);
    this.c0.be = ((this.c0.be + ((1 + i) | 0)) | 0);
  }
});
$p.M = (function(index) {
  return this.akw(index);
});
$p.cg = (function(index) {
  return this.aze(index);
});
$p.ch = (function(index) {
  return this.azt(index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.akv(s, decIndex, expIndex, index);
});
$p.cs = (function(d, index) {
  return this.azf(d, index);
});
$p.ct = (function(d, index) {
  return this.VT(d, index);
});
$p.c9 = (function(i, index) {
  return this.Jk(i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return this.azr(i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return this.azu(i_$_lo, i_$_hi, index);
});
$p.bx = (function(s, index) {
  return this.VU(s, index);
});
/** @constructor */
function $c_Lujson_BaseCharRenderer$$anon$1(outer) {
  this.h7 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.h7 = outer;
  outer.kK();
  outer.c0.eP(91);
  outer.kz = ((1 + outer.kz) | 0);
  outer.kA = true;
}
$p = $c_Lujson_BaseCharRenderer$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$$anon$1;
/** @constructor */
function $h_Lujson_BaseCharRenderer$$anon$1() {
}
$h_Lujson_BaseCharRenderer$$anon$1.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bw = (function() {
  return this.h7;
});
$p.EJ = (function(v, index) {
  this.h7.kK();
  this.h7.ok = true;
  this.h7.kA = true;
});
$p.Jj = (function(index) {
  this.h7.kz = ((this.h7.kz - 1) | 0);
  if ((this.h7.kA && this.h7.ok)) {
    this.h7.Vd();
  }
  this.h7.ok = false;
  this.h7.kA = false;
  this.h7.c0.eP(93);
  this.h7.mE();
  return this.h7.hD;
});
$p.bu = (function(v, index) {
  this.EJ(v, index);
});
$p.L = (function(index) {
  return this.Jj(index);
});
var $d_Lujson_BaseCharRenderer$$anon$1 = new $TypeData().i($c_Lujson_BaseCharRenderer$$anon$1, "ujson.BaseCharRenderer$$anon$1", ({
  Cv: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lujson_BaseCharRenderer$$anon$2(outer) {
  this.eN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.eN = outer;
  outer.kK();
  outer.c0.eP(123);
  outer.kz = ((1 + outer.kz) | 0);
  outer.kA = true;
}
$p = $c_Lujson_BaseCharRenderer$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lujson_BaseCharRenderer$$anon$2;
/** @constructor */
function $h_Lujson_BaseCharRenderer$$anon$2() {
}
$h_Lujson_BaseCharRenderer$$anon$2.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return this.eN;
});
$p.eT = (function(index) {
  this.eN.Hy = true;
  this.eN.Hz = true;
  return this.eN;
});
$p.eU = (function(s) {
  this.eN.c0.eP(34);
  this.eN.Hz = false;
  this.eN.c0.eP(58);
  if ((this.eN.Hx !== (-1))) {
    this.eN.c0.eP(32);
  }
});
$p.EJ = (function(v, index) {
  this.eN.ok = true;
  this.eN.kA = true;
});
$p.Jj = (function(index) {
  this.eN.kz = ((this.eN.kz - 1) | 0);
  if ((this.eN.kA && this.eN.ok)) {
    this.eN.Vd();
  }
  this.eN.ok = false;
  this.eN.kA = false;
  this.eN.c0.eP(125);
  this.eN.mE();
  return this.eN.hD;
});
$p.bu = (function(v, index) {
  this.EJ(v, index);
});
$p.L = (function(index) {
  return this.Jj(index);
});
$p.du = (function() {
  return this;
});
var $d_Lujson_BaseCharRenderer$$anon$2 = new $TypeData().i($c_Lujson_BaseCharRenderer$$anon$2, "ujson.BaseCharRenderer$$anon$2", ({
  Cw: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lujson_JsVisitor$$anon$1(length$1, index$1, outer) {
  this.LN = null;
  this.SC = 0;
  this.HB = null;
  this.SB = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SB = outer;
  this.LN = new $c_Lujson_BaseCharRenderer$$anon$1(outer);
  this.SC = (-1);
  this.HB = null;
}
$p = $c_Lujson_JsVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lujson_JsVisitor$$anon$1;
/** @constructor */
function $h_Lujson_JsVisitor$$anon$1() {
}
$h_Lujson_JsVisitor$$anon$1.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return this.SB;
});
$p.eT = (function(index) {
  this.HB = this.LN.bw().bt(2, index);
  this.SC = index;
  return this.SB;
});
$p.eU = (function(s) {
  this.HB.bu(s, this.SC);
});
$p.bu = (function(v, index) {
  this.HB.bu(v, index);
  this.LN.bu(this.HB.L(index), index);
});
$p.L = (function(index) {
  return this.LN.L(index);
});
$p.du = (function() {
  return this;
});
var $d_Lujson_JsVisitor$$anon$1 = new $TypeData().i($c_Lujson_JsVisitor$$anon$1, "ujson.JsVisitor$$anon$1", ({
  CA: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lujson_StringParser(s) {
  this.tM = null;
  this.I4 = 0;
  this.I5 = 0;
  this.ol = 0;
  this.kB = 0;
  this.HA = 0;
  this.om = 0;
  this.tL = null;
  this.gB = null;
  this.adk = null;
  this.SD = 0;
  this.adk = s;
  $ct_Lujson_CharParser__(this);
  this.SD = s.length;
}
$p = $c_Lujson_StringParser.prototype = new $h_Lujson_CharParser();
$p.constructor = $c_Lujson_StringParser;
/** @constructor */
function $h_Lujson_StringParser() {
}
$h_Lujson_StringParser.prototype = $p;
$p.ax2 = (function(buffer, bufferOffset) {
  return ((buffer === null) ? new $c_T3($f_T__toCharArray__AC(this.adk), (this.SD === 0), this.SD) : new $c_T3(buffer, true, (-1)));
});
var $d_Lujson_StringParser = new $TypeData().i($c_Lujson_StringParser, "ujson.StringParser", ({
  CD: 1,
  Cx: 1,
  D8: 1
}));
/** @constructor */
function $c_Lujson_StringParser$() {
}
$p = $c_Lujson_StringParser$.prototype = new $h_O();
$p.constructor = $c_Lujson_StringParser$;
/** @constructor */
function $h_Lujson_StringParser$() {
}
$h_Lujson_StringParser$.prototype = $p;
$p.ayG = (function(j, f) {
  return new $c_Lujson_StringParser(j).awI(f);
});
$p.O = (function(j, f) {
  return this.ayG(j, f);
});
var $d_Lujson_StringParser$ = new $TypeData().i($c_Lujson_StringParser$, "ujson.StringParser$", ({
  CE: 1,
  j: 1,
  CF: 1
}));
var $n_Lujson_StringParser$;
function $m_Lujson_StringParser$() {
  if ((!$n_Lujson_StringParser$)) {
    $n_Lujson_StringParser$ = new $c_Lujson_StringParser$();
  }
  return $n_Lujson_StringParser$;
}
var $d_Lupack_Msg = new $TypeData().i(1, "upack.Msg", ({
  as: 1,
  at: 1,
  ao: 1
}));
/** @constructor */
function $c_Lupack_Msg$$anon$1() {
  this.SE = null;
  this.SE = $m_scm_ArrayBuffer$().Up($m_sr_ScalaRunTime$().azB(new ($d_Lupack_Msg.r().C)([])));
}
$p = $c_Lupack_Msg$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$$anon$1;
/** @constructor */
function $h_Lupack_Msg$$anon$1() {
}
$h_Lupack_Msg$$anon$1.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bw = (function() {
  return $m_Lupack_Msg$();
});
$p.bu = (function(v, index) {
  this.SE.Ia(v);
});
$p.L = (function(index) {
  return new $c_Lupack_Arr(this.SE);
});
var $d_Lupack_Msg$$anon$1 = new $TypeData().i($c_Lupack_Msg$$anon$1, "upack.Msg$$anon$1", ({
  CI: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupack_Msg$$anon$2() {
  this.SG = null;
  this.SF = null;
  this.SG = new $c_Lupickle_core_LinkedHashMap($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap()));
  this.SF = null;
}
$p = $c_Lupack_Msg$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$$anon$2;
/** @constructor */
function $h_Lupack_Msg$$anon$2() {
}
$h_Lupack_Msg$$anon$2.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return $m_Lupack_Msg$();
});
$p.eT = (function(index) {
  return $m_Lupack_Msg$();
});
$p.eU = (function(s) {
  this.SF = s;
});
$p.bu = (function(v, index) {
  $f_scm_MapOps__update__O__O__V(this.SG, this.SF, v);
});
$p.L = (function(index) {
  return new $c_Lupack_Obj(this.SG);
});
$p.du = (function() {
  return this;
});
var $d_Lupack_Msg$$anon$2 = new $TypeData().i($c_Lupack_Msg$$anon$2, "upack.Msg$$anon$2", ({
  CJ: 1,
  Y: 1,
  aw: 1
}));
function $p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T($thiz) {
  return (("Missing key \"" + $thiz.yE.A0()) + "\" for tagged dictionary");
}
/** @constructor */
function $c_Lupickle_AttributeTagged$$anon$6(taggedReader$4, index$2, outer) {
  this.yE = null;
  this.SI = 0;
  this.SH = false;
  this.ii = null;
  this.LO = null;
  this.yE = taggedReader$4;
  this.SI = index$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.LO = outer;
  this.SH = false;
  this.ii = null;
}
$p = $c_Lupickle_AttributeTagged$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_AttributeTagged$$anon$6;
/** @constructor */
function $h_Lupickle_AttributeTagged$$anon$6() {
}
$h_Lupickle_AttributeTagged$$anon$6.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return ((this.ii === null) ? $m_Lupickle_core_StringVisitor$() : this.ii.bw());
});
$p.eT = (function(index) {
  return ((this.ii !== null) ? this.ii.eT(index) : $m_Lupickle_core_StringVisitor$());
});
$p.eU = (function(s) {
  if ((this.ii !== null)) {
    this.ii.eU(s);
  } else if ((!$f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.LO, this.yE.A0(), s))) {
    var this$3 = new $c_Lupickle_core_BufferedValue$Builder$$anon$10(true, this.SI);
    var xxx = new $c_Lupickle_core_BufferedValue$Str($dp_toString__T(s), this.SI);
    this$3.SJ = xxx;
    this.ii = this$3;
  }
});
$p.bu = (function(v, index) {
  if ((this.ii !== null)) {
    this.ii.bu(v, index);
  } else {
    var s = $dp_toString__T(v);
    var facade0 = this.yE.f5(s);
    if ((facade0 === null)) {
      throw new $c_Lupickle_core_Abort(("invalid tag for tagged object: " + s));
    }
    var fastCtx = facade0.K((-1), true, index);
    this.ii = fastCtx;
    this.SH = true;
  }
});
$p.L = (function(index) {
  if ((this.ii === null)) {
    throw new $c_Lupickle_core_Abort($p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T(this));
  } else if (this.SH) {
    return this.ii.L(index);
  } else {
    var x = this.ii.L(index);
    var this$1 = x.on;
    _return: {
      var it = this$1.mS().l();
      while (it.f()) {
        var a = it.e();
        if ($f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.LO, this.yE.A0(), a.P())) {
          var this$4 = new $c_s_Some(a);
          break _return;
        }
      }
      var this$4 = $m_s_None$();
    }
    if (this$4.c()) {
      throw new $c_Lupickle_core_Abort($p_Lupickle_AttributeTagged$$anon$6__missingKeyMsg$1__T(this));
    }
    var keyAttr = this$4.h().V();
    var key = $dp_toString__T(keyAttr.qr);
    var delegate = this.yE.f5(key);
    if ((delegate === null)) {
      throw new $c_Lupickle_core_AbortException(("invalid tag for tagged object: " + key), keyAttr.f7(), (-1), (-1), null);
    }
    var ctx2 = delegate.K((-1), true, (-1));
    var this$5 = x.on;
    var it$1 = this$5.mS().l();
    while (it$1.f()) {
      var x0 = it$1.e();
      matchResult17: {
        var \u03b41$___1;
        var \u03b41$___2;
        if ((x0 !== null)) {
          var \u03b41$___1 = x0.P();
          var \u03b41$___2 = x0.V();
          break matchResult17;
        }
        throw new $c_s_MatchError(x0);
      }
      var k0$2 = \u03b41$___1;
      var v$2 = \u03b41$___2;
      if ((!$f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z(this.LO, this.yE.A0(), k0$2))) {
        var keyVisitor = ctx2.eT((-1));
        ctx2.eU($m_Lupickle_core_BufferedValue$().uG(k0$2, keyVisitor));
        ctx2.bu($m_Lupickle_core_BufferedValue$().uG(v$2, ctx2.bw()), (-1));
      }
    }
    return ctx2.L(index);
  }
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_AttributeTagged$$anon$6 = new $TypeData().i($c_Lupickle_AttributeTagged$$anon$6, "upickle.AttributeTagged$$anon$6", ({
  CP: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_MsgReadWriters$$anon$1(outer) {
  this.adl = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adl = outer;
}
$p = $c_Lupickle_MsgReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_MsgReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_MsgReadWriters$$anon$1() {
}
$h_Lupickle_MsgReadWriters$$anon$1.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.adl;
});
$p.U = (function(out, v) {
  return $m_Lupack_Msg$().ND(v, out);
});
var $d_Lupickle_MsgReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_MsgReadWriters$$anon$1, "upickle.MsgReadWriters$$anon$1", ({
  CT: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$$anon$10(jsonableKeys$2, i$6) {
  this.adn = false;
  this.adm = 0;
  this.SK = null;
  this.SJ = null;
  this.adn = jsonableKeys$2;
  this.adm = i$6;
  this.SK = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
}
$p = $c_Lupickle_core_BufferedValue$Builder$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$$anon$10;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$$anon$10() {
}
$h_Lupickle_core_BufferedValue$Builder$$anon$10.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.eT = (function(index) {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.eU = (function(s) {
  this.SJ = s;
});
$p.azv = (function(v, index) {
  this.SK.Ia(new $c_T2(this.SJ, v));
});
$p.azc = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Obj(this.SK, this.adn, this.adm);
});
$p.bu = (function(v, index) {
  this.azv(v, index);
});
$p.L = (function(index) {
  return this.azc(index);
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_core_BufferedValue$Builder$$anon$10 = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$$anon$10, "upickle.core.BufferedValue$Builder$$anon$10", ({
  D6: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Builder$$anon$9(i$5) {
  this.ado = 0;
  this.SL = null;
  this.ado = i$5;
  this.SL = ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()));
}
$p = $c_Lupickle_core_BufferedValue$Builder$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Builder$$anon$9;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Builder$$anon$9() {
}
$h_Lupickle_core_BufferedValue$Builder$$anon$9.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bw = (function() {
  return $m_Lupickle_core_BufferedValue$Builder$();
});
$p.azb = (function(index) {
  return new $c_Lupickle_core_BufferedValue$Arr(this.SL, this.ado);
});
$p.bu = (function(v, index) {
  this.SL.Ia(v);
});
$p.L = (function(index) {
  return this.azb(index);
});
var $d_Lupickle_core_BufferedValue$Builder$$anon$9 = new $TypeData().i($c_Lupickle_core_BufferedValue$Builder$$anon$9, "upickle.core.BufferedValue$Builder$$anon$9", ({
  D7: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$$anon$1() {
}
$p = $c_Lupickle_core_NoOpVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$$anon$1;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$$anon$1() {
}
$h_Lupickle_core_NoOpVisitor$$anon$1.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bw = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.bu = (function(v, index) {
});
$p.L = (function(index) {
  return (void 0);
});
var $d_Lupickle_core_NoOpVisitor$$anon$1 = new $TypeData().i($c_Lupickle_core_NoOpVisitor$$anon$1, "upickle.core.NoOpVisitor$$anon$1", ({
  Dh: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_core_NoOpVisitor$$anon$2() {
}
$p = $c_Lupickle_core_NoOpVisitor$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_NoOpVisitor$$anon$2;
/** @constructor */
function $h_Lupickle_core_NoOpVisitor$$anon$2() {
}
$h_Lupickle_core_NoOpVisitor$$anon$2.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.eT = (function(index) {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.eU = (function(s) {
});
$p.bu = (function(v, index) {
});
$p.L = (function(index) {
  return (void 0);
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_core_NoOpVisitor$$anon$2 = new $TypeData().i($c_Lupickle_core_NoOpVisitor$$anon$2, "upickle.core.NoOpVisitor$$anon$2", ({
  Di: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_core_StringVisitor$() {
}
$p = $c_Lupickle_core_StringVisitor$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_StringVisitor$;
/** @constructor */
function $h_Lupickle_core_StringVisitor$() {
}
$h_Lupickle_core_StringVisitor$.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.M = (function(index) {
  return null;
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return $dp_toString__T(s);
});
$p.c9 = (function(d, index) {
  return ("" + d);
});
$p.cv = (function(d_$_lo, d_$_hi, index) {
  return $m_RTLong$().gc(d_$_lo, d_$_hi);
});
$p.cD = (function(d_$_lo, d_$_hi, index) {
  return $m_RTLong$().gc(d_$_lo, d_$_hi);
});
$p.cs = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === Math.fround(i)) ? ("" + i) : ("" + d));
});
$p.ct = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === i) ? ("" + i) : ("" + d));
});
$p.ch = (function(index) {
  return "true";
});
$p.cg = (function(index) {
  return "false";
});
$p.cB = (function(s, index) {
  return ("" + $cToS(s));
});
var $d_Lupickle_core_StringVisitor$ = new $TypeData().i($c_Lupickle_core_StringVisitor$, "upickle.core.StringVisitor$", ({
  Dm: 1,
  d: 1,
  f: 1
}));
var $n_Lupickle_core_StringVisitor$;
function $m_Lupickle_core_StringVisitor$() {
  if ((!$n_Lupickle_core_StringVisitor$)) {
    $n_Lupickle_core_StringVisitor$ = new $c_Lupickle_core_StringVisitor$();
  }
  return $n_Lupickle_core_StringVisitor$;
}
function $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__($thiz, delegate, parentPath, wrapper) {
  $thiz.SM = delegate;
  $thiz.z3 = parentPath;
  $thiz.tT = wrapper;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegate);
  wrapper.Dt = parentPath;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_TraceVisitor() {
  this.eO = null;
  this.SM = null;
  this.z3 = null;
  this.tT = null;
}
$p = $c_Lupickle_core_TraceVisitor.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_TraceVisitor;
/** @constructor */
function $h_Lupickle_core_TraceVisitor() {
}
$h_Lupickle_core_TraceVisitor.prototype = $p;
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$1($c_Lupickle_core_Visitor$Delegate.prototype.K.call(this, length, jsonableKeys, index), this);
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$3($c_Lupickle_core_Visitor$Delegate.prototype.bt.call(this, length, index), this);
});
$p.g = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this.z3);
});
var $d_Lupickle_core_TraceVisitor = new $TypeData().i($c_Lupickle_core_TraceVisitor, "upickle.core.TraceVisitor", ({
  jb: 1,
  bI: 1,
  d: 1
}));
function $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O($thiz, out, v) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var x7 = $thiz.IB(v);
    if ((x7 !== null)) {
      var \u03b41$___1 = x7.gZ;
      var \u03b41$___2 = x7.fY;
      var \u03b41$___3 = x7.gr;
      break matchResult3;
    }
    throw new $c_s_MatchError(x7);
  }
  var tagKey$2 = \u03b41$___1;
  var tagValue$2 = \u03b41$___2;
  var w$2 = \u03b41$___3;
  return $f_Lupickle_AttributeTagged__taggedWrite__Lupickle_core_Types$ObjectWriter__T__T__Lupickle_core_Visitor__O__O($thiz.NF(), w$2, tagKey$2, tagValue$2, out, v);
}
function $is_Lupickle_core_Types$TaggedWriter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bH)));
}
function $isArrayOf_Lupickle_core_Types$TaggedWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bH)));
}
/** @constructor */
function $c_Lupickle_core_Types$Writer$MapWriter(outer, src, f) {
  this.adE = null;
  this.adD = null;
  this.adC = null;
  this.adE = src;
  this.adD = f;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.adC = outer;
}
$p = $c_Lupickle_core_Types$Writer$MapWriter.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$Writer$MapWriter;
/** @constructor */
function $h_Lupickle_core_Types$Writer$MapWriter() {
}
$h_Lupickle_core_Types$Writer$MapWriter.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.adE, out, this.adD.p(v));
});
$p.qR = (function() {
  return this.adC.T0;
});
$p.T = (function() {
  return this.qR();
});
var $d_Lupickle_core_Types$Writer$MapWriter = new $TypeData().i($c_Lupickle_core_Types$Writer$MapWriter, "upickle.core.Types$Writer$MapWriter", ({
  DI: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_core_Visitor$MapArrContext(src, f) {
  this.LS = null;
  this.adF = null;
  this.LS = src;
  this.adF = f;
}
$p = $c_Lupickle_core_Visitor$MapArrContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapArrContext;
/** @constructor */
function $h_Lupickle_core_Visitor$MapArrContext() {
}
$h_Lupickle_core_Visitor$MapArrContext.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bw = (function() {
  return this.LS.bw();
});
$p.bu = (function(v, index) {
  this.LS.bu(v, index);
});
$p.L = (function(index) {
  return this.adF.p(this.LS.L(index));
});
var $d_Lupickle_core_Visitor$MapArrContext = new $TypeData().i($c_Lupickle_core_Visitor$MapArrContext, "upickle.core.Visitor$MapArrContext", ({
  DJ: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_core_Visitor$MapObjContext(src, f) {
  this.Dv = null;
  this.adG = null;
  this.Dv = src;
  this.adG = f;
}
$p = $c_Lupickle_core_Visitor$MapObjContext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Visitor$MapObjContext;
/** @constructor */
function $h_Lupickle_core_Visitor$MapObjContext() {
}
$h_Lupickle_core_Visitor$MapObjContext.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return this.Dv.bw();
});
$p.eT = (function(index) {
  return this.Dv.eT(index);
});
$p.eU = (function(s) {
  this.Dv.eU(s);
});
$p.bu = (function(v, index) {
  this.Dv.bu(v, index);
});
$p.L = (function(index) {
  return this.adG.p(this.Dv.L(index));
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_core_Visitor$MapObjContext = new $TypeData().i($c_Lupickle_core_Visitor$MapObjContext, "upickle.core.Visitor$MapObjContext", ({
  DK: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_implicits_CaseClassReadWriters$$anon$1(outer) {
  this.ae0 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae0 = outer;
}
$p = $c_Lupickle_implicits_CaseClassReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseClassReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_CaseClassReadWriters$$anon$1() {
}
$h_Lupickle_implicits_CaseClassReadWriters$$anon$1.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.eT = (function(index) {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.eU = (function(s) {
});
$p.bu = (function(v, index) {
});
$p.L = (function(index) {
  return this.ae0.T5;
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_implicits_CaseClassReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_implicits_CaseClassReadWriters$$anon$1, "upickle.implicits.CaseClassReadWriters$$anon$1", ({
  DQ: 1,
  Y: 1,
  aw: 1
}));
function $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($thiz, evidence$1, evidence$2) {
  return new $c_Lupickle_implicits_TupleReadWriters$TupleNWriter($thiz, new ($d_Lupickle_core_Types$Writer.r().C)([evidence$1, evidence$2]), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => {
    if ((x === null)) {
      return null;
    } else {
      var xs = $m_sr_ScalaRunTime$().IE(new $ac_O([x.P(), x.V()]));
      var array = new $ac_O(xs.F());
      var iterator = xs.l();
      var i = 0;
      while (iterator.f()) {
        array.a[i] = iterator.e();
        i = ((1 + i) | 0);
      }
      return array;
    }
  })));
}
function $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, evidence$1, evidence$2) {
  return new $c_Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, new ($d_Lupickle_core_Types$Reader.r().C)([evidence$1, evidence$2]), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => new $c_T2(x.a[0], x.a[1]))));
}
function $f_Lupickle_implicits_Generated__Tuple3Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($thiz, evidence$1, evidence$2, evidence$3) {
  return new $c_Lupickle_implicits_TupleReadWriters$TupleNWriter($thiz, new ($d_Lupickle_core_Types$Writer.r().C)([evidence$1, evidence$2, evidence$3]), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => {
    if ((x === null)) {
      return null;
    } else {
      var xs = $m_sr_ScalaRunTime$().IE(new $ac_O([x.gZ, x.fY, x.gr]));
      var array = new $ac_O(xs.F());
      var iterator = xs.l();
      var i = 0;
      while (iterator.f()) {
        array.a[i] = iterator.e();
        i = ((1 + i) | 0);
      }
      return array;
    }
  })));
}
function $f_Lupickle_implicits_Generated__Tuple3Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, evidence$1, evidence$2, evidence$3) {
  return new $c_Lupickle_implicits_TupleReadWriters$TupleNReader($thiz, new ($d_Lupickle_core_Types$Reader.r().C)([evidence$1, evidence$2, evidence$3]), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => new $c_T3(x.a[0], x.a[1], x.a[2]))));
}
/** @constructor */
function $c_Lupickle_implicits_LowPriWriters$$anon$22(r$4, outer) {
  this.ae3 = null;
  this.ae2 = null;
  this.ae3 = r$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae2 = outer;
}
$p = $c_Lupickle_implicits_LowPriWriters$$anon$22.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_LowPriWriters$$anon$22;
/** @constructor */
function $h_Lupickle_implicits_LowPriWriters$$anon$22() {
}
$h_Lupickle_implicits_LowPriWriters$$anon$22.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aC2 = (function(out, v) {
  var ctx = out.bt(v.aH(), (-1));
  var x = v.l();
  while (x.f()) {
    var next = x.e();
    ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.ae3, ctx.bw(), next), (-1));
  }
  return ctx.L((-1));
});
$p.T = (function() {
  return this.ae2;
});
$p.U = (function(out, v) {
  return this.aC2(out, v);
});
var $d_Lupickle_implicits_LowPriWriters$$anon$22 = new $TypeData().i($c_Lupickle_implicits_LowPriWriters$$anon$22, "upickle.implicits.LowPriWriters$$anon$22", ({
  DY: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$17$$anon$18(outer) {
  this.T9 = null;
  this.Ta = null;
  this.LW = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.LW = outer;
  this.T9 = $m_scm_Buffer$().dj();
  this.Ta = $m_scm_Buffer$().dj();
}
$p = $c_Lupickle_implicits_Readers$$anon$17$$anon$18.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$17$$anon$18;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$17$$anon$18() {
}
$h_Lupickle_implicits_Readers$$anon$17$$anon$18.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return this.LW.T8;
});
$p.eT = (function(index) {
  return this.LW.T6;
});
$p.eU = (function(s) {
  this.T9.aD(s);
});
$p.bu = (function(v, index) {
  this.Ta.aD(v);
});
$p.aza = (function(index) {
  return this.LW.T7.p(this.T9.bY(this.Ta));
});
$p.L = (function(index) {
  return this.aza(index);
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_implicits_Readers$$anon$17$$anon$18 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$17$$anon$18, "upickle.implicits.Readers$$anon$17$$anon$18", ({
  Ec: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$19$$anon$20(outer) {
  this.Tb = null;
  this.aee = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aee = outer;
  this.Tb = $m_s_None$();
}
$p = $c_Lupickle_implicits_Readers$$anon$19$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$19$$anon$20;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$19$$anon$20() {
}
$h_Lupickle_implicits_Readers$$anon$19$$anon$20.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bu = (function(v, index) {
  this.Tb = new $c_s_Some(v);
});
$p.bw = (function() {
  return this.aee.aed;
});
$p.L = (function(index) {
  return this.Tb;
});
var $d_Lupickle_implicits_Readers$$anon$19$$anon$20 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$19$$anon$20, "upickle.implicits.Readers$$anon$19$$anon$20", ({
  Ee: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$2() {
}
$p = $c_Lupickle_implicits_Readers$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$2() {
}
$h_Lupickle_implicits_Readers$$anon$2.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.bw = (function() {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.bu = (function(v, index) {
});
$p.eT = (function(index) {
  return $m_Lupickle_core_NoOpVisitor$();
});
$p.eU = (function(v) {
});
$p.L = (function(index) {
  return (void 0);
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_implicits_Readers$$anon$2 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$2, "upickle.implicits.Readers$$anon$2", ({
  Ef: 1,
  Y: 1,
  aw: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$22$$anon$23(evidence$2$5, outer) {
  this.Tc = null;
  this.aei = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aei = outer;
  this.Tc = new $c_scm_ArrayBuilder$generic(evidence$2$5.dK());
}
$p = $c_Lupickle_implicits_Readers$$anon$22$$anon$23.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$22$$anon$23;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$22$$anon$23() {
}
$h_Lupickle_implicits_Readers$$anon$22$$anon$23.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bu = (function(v, index) {
  this.Tc.aD(v);
});
$p.L = (function(index) {
  return this.Tc.aR();
});
$p.bw = (function() {
  return this.aei.aeh;
});
var $d_Lupickle_implicits_Readers$$anon$22$$anon$23 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$22$$anon$23, "upickle.implicits.Readers$$anon$22$$anon$23", ({
  Ei: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$24$$anon$25(evidence$2$7, outer) {
  this.Td = null;
  this.aem = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aem = outer;
  this.Td = new $c_scm_ArrayBuilder$generic(evidence$2$7.dK());
}
$p = $c_Lupickle_implicits_Readers$$anon$24$$anon$25.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$24$$anon$25;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$24$$anon$25() {
}
$h_Lupickle_implicits_Readers$$anon$24$$anon$25.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bu = (function(v, index) {
  this.Td.aD(v);
});
$p.L = (function(index) {
  return this.Td.aR();
});
$p.bw = (function() {
  return this.aem.ael;
});
var $d_Lupickle_implicits_Readers$$anon$24$$anon$25 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$24$$anon$25, "upickle.implicits.Readers$$anon$24$$anon$25", ({
  Ek: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$26(outer) {
  this.Te = null;
  this.aen = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aen = outer;
  this.Te = outer.aey.aP();
}
$p = $c_Lupickle_implicits_Readers$$anon$26.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$26;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$26() {
}
$h_Lupickle_implicits_Readers$$anon$26.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bu = (function(v, index) {
  this.Te.aD(v);
});
$p.L = (function(index) {
  return this.Te.aR();
});
$p.bw = (function() {
  return this.aen.aez;
});
var $d_Lupickle_implicits_Readers$$anon$26 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$26, "upickle.implicits.Readers$$anon$26", ({
  El: 1,
  Y: 1,
  aF: 1
}));
function $is_Lupickle_implicits_Readers$OptionReader(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cb)));
}
function $isArrayOf_Lupickle_implicits_Readers$OptionReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cb)));
}
/** @constructor */
function $c_Lupickle_implicits_TupleReadWriters$$anon$1(outer) {
  this.Ti = null;
  this.tU = 0;
  this.Tj = 0;
  this.z4 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.z4 = outer;
  this.Ti = new $ac_O(outer.z5.a.length);
  this.tU = 0;
  this.Tj = this.tU;
}
$p = $c_Lupickle_implicits_TupleReadWriters$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_TupleReadWriters$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_TupleReadWriters$$anon$1() {
}
$h_Lupickle_implicits_TupleReadWriters$$anon$1.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.bu = (function(v, index) {
  this.Ti.a[((this.tU % $checkIntDivisor(this.z4.z5.a.length)) | 0)] = v;
  this.tU = ((1 + this.tU) | 0);
});
$p.L = (function(index) {
  var lengthSoFar = ((this.tU - this.Tj) | 0);
  if ((lengthSoFar !== this.z4.z5.a.length)) {
    throw new $c_Lupickle_core_Abort(((("expected " + this.z4.z5.a.length) + " items in sequence, found ") + lengthSoFar));
  }
  this.Tj = this.tU;
  return this.z4.aeJ.p(this.Ti);
});
$p.bw = (function() {
  return this.z4.z5.a[((this.tU % $checkIntDivisor(this.z4.z5.a.length)) | 0)];
});
var $d_Lupickle_implicits_TupleReadWriters$$anon$1 = new $TypeData().i($c_Lupickle_implicits_TupleReadWriters$$anon$1, "upickle.implicits.TupleReadWriters$$anon$1", ({
  Ez: 1,
  Y: 1,
  aF: 1
}));
/** @constructor */
function $c_Lupickle_implicits_TupleReadWriters$TupleNWriter(outer, writers, f) {
  this.LX = null;
  this.aeL = null;
  this.aeK = null;
  this.LX = writers;
  this.aeL = f;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeK = outer;
}
$p = $c_Lupickle_implicits_TupleReadWriters$TupleNWriter.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_TupleReadWriters$TupleNWriter;
/** @constructor */
function $h_Lupickle_implicits_TupleReadWriters$TupleNWriter() {
}
$h_Lupickle_implicits_TupleReadWriters$TupleNWriter.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.bt(this.LX.a.length, (-1));
    var vs = this.aeL.p(v);
    var i = 0;
    while ((i < this.LX.a.length)) {
      ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.LX.a[i], ctx.bw(), vs.a[i]), (-1));
      i = ((1 + i) | 0);
    }
    return ctx.L((-1));
  }
});
$p.T = (function() {
  return this.aeK;
});
var $d_Lupickle_implicits_TupleReadWriters$TupleNWriter = new $TypeData().i($c_Lupickle_implicits_TupleReadWriters$TupleNWriter, "upickle.implicits.TupleReadWriters$TupleNWriter", ({
  EB: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$11(outer) {
  this.aeO = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeO = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$11.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$11;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$11() {
}
$h_Lupickle_implicits_Writers$$anon$11.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.aeO;
});
$p.U = (function(out, v) {
  var $x_1 = $uJ(v);
  var v$1_$_lo = $x_1.l;
  var v$1_$_hi = $x_1.h;
  return out.cv(v$1_$_lo, v$1_$_hi, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$11 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$11, "upickle.implicits.Writers$$anon$11", ({
  EF: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$18(outer) {
  this.aeX = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeX = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$18.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$18;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$18() {
}
$h_Lupickle_implicits_Writers$$anon$18.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  return out.cr(v, 0, $m_jl_reflect_Array$().b1(v), (-1));
});
$p.T = (function() {
  return this.aeX;
});
var $d_Lupickle_implicits_Writers$$anon$18 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$18, "upickle.implicits.Writers$$anon$18", ({
  EM: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$19(r$3, outer) {
  this.aeZ = null;
  this.aeY = null;
  this.aeZ = r$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeY = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$19.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$19;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$19() {
}
$h_Lupickle_implicits_Writers$$anon$19.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  var ctx = out.bt($m_jl_reflect_Array$().b1(v), (-1));
  var i = 0;
  while ((i < $m_jl_reflect_Array$().b1(v))) {
    ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aeZ, ctx.bw(), $m_sr_ScalaRunTime$().cZ(v, i)), (-1));
    i = ((1 + i) | 0);
  }
  return ctx.L((-1));
});
$p.T = (function() {
  return this.aeY;
});
var $d_Lupickle_implicits_Writers$$anon$19 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$19, "upickle.implicits.Writers$$anon$19", ({
  EN: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$2(outer) {
  this.af0 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af0 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$2() {
}
$h_Lupickle_implicits_Writers$$anon$2.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.af0;
});
$p.U = (function(out, v) {
  return out.M((-1));
});
var $d_Lupickle_implicits_Writers$$anon$2 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$2, "upickle.implicits.Writers$$anon$2", ({
  EO: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$20(kw$2, vw$2, outer) {
  this.Tk = null;
  this.af2 = null;
  this.af1 = null;
  this.Tk = kw$2;
  this.af2 = vw$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af1 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$20;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$20() {
}
$h_Lupickle_implicits_Writers$$anon$20.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aC3 = (function(out, v) {
  var ctx = out.K(v.aH(), this.Tk.Q(), (-1));
  v.al(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((pair) => {
    matchResult4: {
      var \u03b41$___1;
      var \u03b41$___2;
      if ((pair !== null)) {
        var \u03b41$___1 = pair.P();
        var \u03b41$___2 = pair.V();
        break matchResult4;
      }
      throw new $c_s_MatchError(pair);
    }
    var k1$2 = \u03b41$___1;
    var v1$2 = \u03b41$___2;
    var keyVisitor = ctx.eT((-1));
    ctx.eU($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.Tk, keyVisitor, k1$2));
    ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.af2, ctx.bw(), v1$2), (-1));
  })));
  return ctx.L((-1));
});
$p.T = (function() {
  return this.af1;
});
$p.U = (function(out, v) {
  return this.aC3(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$20 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$20, "upickle.implicits.Writers$$anon$20", ({
  EP: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$3(outer) {
  this.af3 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af3 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$3;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$3() {
}
$h_Lupickle_implicits_Writers$$anon$3.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.af3;
});
$p.U = (function(out, v) {
  var v$1 = (+v);
  return out.ct(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$3 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$3, "upickle.implicits.Writers$$anon$3", ({
  EQ: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$4(outer) {
  this.af4 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af4 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$4;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$4() {
}
$h_Lupickle_implicits_Writers$$anon$4.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.af4;
});
$p.U = (function(out, v) {
  var v$1 = (v | 0);
  return out.c9(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$4 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$4, "upickle.implicits.Writers$$anon$4", ({
  ER: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$5(outer) {
  this.af5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af5 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$5;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$5() {
}
$h_Lupickle_implicits_Writers$$anon$5.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.af5;
});
$p.U = (function(out, v) {
  var v$1 = Math.fround(v);
  return out.cs(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$5 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$5, "upickle.implicits.Writers$$anon$5", ({
  ES: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$6(outer) {
  this.af6 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af6 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$6;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$6() {
}
$h_Lupickle_implicits_Writers$$anon$6.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.azE = (function(out, v) {
  return out.c9(v, (-1));
});
$p.T = (function() {
  return this.af6;
});
$p.U = (function(out, v) {
  return this.azE(out, (v | 0));
});
var $d_Lupickle_implicits_Writers$$anon$6 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$6, "upickle.implicits.Writers$$anon$6", ({
  ET: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$7(outer) {
  this.af7 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af7 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$7;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$7() {
}
$h_Lupickle_implicits_Writers$$anon$7.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.azD = (function(out, v) {
  return out.c9(v, (-1));
});
$p.T = (function() {
  return this.af7;
});
$p.U = (function(out, v) {
  return this.azD(out, (v | 0));
});
var $d_Lupickle_implicits_Writers$$anon$7 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$7, "upickle.implicits.Writers$$anon$7", ({
  EU: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$8(outer) {
  this.af8 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af8 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$8;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$8() {
}
$h_Lupickle_implicits_Writers$$anon$8.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.azF = (function(out, v) {
  return (v ? out.ch((-1)) : out.cg((-1)));
});
$p.T = (function() {
  return this.af8;
});
$p.U = (function(out, v) {
  return this.azF(out, (!(!v)));
});
var $d_Lupickle_implicits_Writers$$anon$8 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$8, "upickle.implicits.Writers$$anon$8", ({
  EV: 1,
  j: 1,
  k: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$9(outer) {
  this.af9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.af9 = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$9;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$9() {
}
$h_Lupickle_implicits_Writers$$anon$9.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.T = (function() {
  return this.af9;
});
$p.U = (function(out, v) {
  var v$1 = $uC(v);
  return out.cB(v$1, (-1));
});
var $d_Lupickle_implicits_Writers$$anon$9 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$9, "upickle.implicits.Writers$$anon$9", ({
  EW: 1,
  j: 1,
  k: 1
}));
function $is_Lupickle_implicits_Writers$OptionWriter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cc)));
}
function $isArrayOf_Lupickle_implicits_Writers$OptionWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cc)));
}
function $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O($thiz, out, v) {
  return out.bx($thiz.EL(v), (-1));
}
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData(boards, listUpdateFun, dropdownData) {
  this.hl = null;
  this.uL = null;
  this.qS = null;
  this.hl = boards;
  this.uL = listUpdateFun;
  this.qS = dropdownData;
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardListSetupData() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardListSetupData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 994358390, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData)) {
    var x = this.hl;
    var x$2 = x$0.hl;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.uL;
      var x$4 = x$0.uL;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.qS;
      var x$6 = x$0.qS;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "AgileBoardListSetupData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.hl;
      break;
    }
    case 1: {
      return this.uL;
      break;
    }
    case 2: {
      return this.qS;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_agileboard_AgileBoardListSetupData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.db)));
}
var $d_Lcom_papasofokli_agileboard_AgileBoardListSetupData = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardListSetupData, "com.papasofokli.agileboard.AgileBoardListSetupData", ({
  db: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardData(id_$_lo, id_$_hi, description, elements, enabled, boardCss, isTaskManager, countPerColumn) {
  this.gC = 0;
  this.gD = 0;
  this.qT = null;
  this.kY = null;
  this.gg = false;
  this.kX = null;
  this.iz = false;
  this.jE = null;
  this.gC = id_$_lo;
  this.gD = id_$_hi;
  this.qT = description;
  this.kY = elements;
  this.gg = enabled;
  this.kX = boardCss;
  this.iz = isTaskManager;
  this.jE = countPerColumn;
}
$p = $c_Lcom_papasofokli_agileboard_BoardData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardData;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardData() {
}
$h_Lcom_papasofokli_agileboard_BoardData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 397250448);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.gC, this.gD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.kY));
  acc = $m_sr_Statics$().d(acc, (this.gg ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.kX));
  acc = $m_sr_Statics$().d(acc, (this.iz ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jE));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_BoardData)) {
    var x_$_lo = this.gC;
    var x_$_hi = this.gD;
    var $x_3 = x$0;
    var x$1_$_lo = $x_3.gC;
    var x$1_$_hi = $x_3.gD;
    if (((((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.gg === x$0.gg)) && (this.iz === x$0.iz)) && (this.qT === x$0.qT))) {
      var x$2 = this.kY;
      var x$2$1 = x$0.kY;
      var $x_2 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.kX;
      var x$4 = x$0.kX;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.jE;
      var x$6 = x$0.jE;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "BoardData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.gC, this.gD);
      break;
    }
    case 1: {
      return this.qT;
      break;
    }
    case 2: {
      return this.kY;
      break;
    }
    case 3: {
      return this.gg;
      break;
    }
    case 4: {
      return this.kX;
      break;
    }
    case 5: {
      return this.iz;
      break;
    }
    case 6: {
      return this.jE;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_agileboard_BoardData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dc)));
}
var $d_Lcom_papasofokli_agileboard_BoardData = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardData, "com.papasofokli.agileboard.BoardData", ({
  dc: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardElement(recordId_$_lo, recordId_$_hi, description, style, dateTime, infoBoardIcon, info, sort, isBlocked, additionalBtn, additionalDataRows, assignee, statusAndStyle, instructionsO, descriptionStyle, taskTypeAndCancelComment, createdBy) {
  this.hE = 0;
  this.hF = 0;
  this.mT = null;
  this.p2 = null;
  this.jH = null;
  this.iA = null;
  this.l1 = null;
  this.qU = null;
  this.hR = false;
  this.jF = null;
  this.eJ = null;
  this.jG = null;
  this.gh = null;
  this.jI = null;
  this.l0 = null;
  this.hS = null;
  this.kZ = null;
  this.hE = recordId_$_lo;
  this.hF = recordId_$_hi;
  this.mT = description;
  this.p2 = style;
  this.jH = dateTime;
  this.iA = infoBoardIcon;
  this.l1 = info;
  this.qU = sort;
  this.hR = isBlocked;
  this.jF = additionalBtn;
  this.eJ = additionalDataRows;
  this.jG = assignee;
  this.gh = statusAndStyle;
  this.jI = instructionsO;
  this.l0 = descriptionStyle;
  this.hS = taskTypeAndCancelComment;
  this.kZ = createdBy;
}
$p = $c_Lcom_papasofokli_agileboard_BoardElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardElement;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardElement() {
}
$h_Lcom_papasofokli_agileboard_BoardElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1252741802));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.hE, this.hF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.mT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.p2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iA));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.l1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qU));
  acc = $m_sr_Statics$().d(acc, (this.hR ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.eJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jG));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gh));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.l0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.kZ));
  return $m_sr_Statics$().an(acc, 16);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_BoardElement)) {
    var x_$_lo = this.hE;
    var x_$_hi = this.hF;
    var $x_10 = x$0;
    var x$1_$_lo = $x_10.hE;
    var x$1_$_hi = $x_10.hF;
    if ((((((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.hR === x$0.hR)) && (this.mT === x$0.mT)) && (this.p2 === x$0.p2)) && (this.jH === x$0.jH))) {
      var x$2 = this.iA;
      var x$2$1 = x$0.iA;
      var $x_9 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_9 = false;
    }
    if (($x_9 && (this.l1 === x$0.l1))) {
      var x$3 = this.qU;
      var x$4 = x$0.qU;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.jF;
      var x$6 = x$0.jF;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.eJ;
      var x$8 = x$0.eJ;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.jG;
      var x$10 = x$0.jG;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.gh;
      var x$12 = x$0.gh;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.jI;
      var x$14 = x$0.jI;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.l0;
      var x$16 = x$0.l0;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.hS;
      var x$18 = x$0.hS;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.kZ;
      var x$20 = x$0.kZ;
      return ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 16;
});
$p.A = (function() {
  return "BoardElement";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.hE, this.hF);
      break;
    }
    case 1: {
      return this.mT;
      break;
    }
    case 2: {
      return this.p2;
      break;
    }
    case 3: {
      return this.jH;
      break;
    }
    case 4: {
      return this.iA;
      break;
    }
    case 5: {
      return this.l1;
      break;
    }
    case 6: {
      return this.qU;
      break;
    }
    case 7: {
      return this.hR;
      break;
    }
    case 8: {
      return this.jF;
      break;
    }
    case 9: {
      return this.eJ;
      break;
    }
    case 10: {
      return this.jG;
      break;
    }
    case 11: {
      return this.gh;
      break;
    }
    case 12: {
      return this.jI;
      break;
    }
    case 13: {
      return this.l0;
      break;
    }
    case 14: {
      return this.hS;
      break;
    }
    case 15: {
      return this.kZ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_agileboard_BoardElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dd)));
}
var $d_Lcom_papasofokli_agileboard_BoardElement = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardElement, "com.papasofokli.agileboard.BoardElement", ({
  dd: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_DropdownData(name, clickType) {
  this.uN = null;
  this.uM = null;
  this.uN = name;
  this.uM = clickType;
}
$p = $c_Lcom_papasofokli_agileboard_DropdownData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_DropdownData;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_DropdownData() {
}
$h_Lcom_papasofokli_agileboard_DropdownData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1805654779), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_DropdownData)) {
    if ((this.uN === x$0.uN)) {
      var x = this.uM;
      var x$2 = x$0.uM;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "DropdownData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.uN;
  }
  if ((n === 1)) {
    return this.uM;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_agileboard_DropdownData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.de)));
}
var $d_Lcom_papasofokli_agileboard_DropdownData = new $TypeData().i($c_Lcom_papasofokli_agileboard_DropdownData, "com.papasofokli.agileboard.DropdownData", ({
  de: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_ItemClickRequest(id_$_lo, id_$_hi, clickType) {
  this.z6 = 0;
  this.z7 = 0;
  this.uO = null;
  this.z6 = id_$_lo;
  this.z7 = id_$_hi;
  this.uO = clickType;
}
$p = $c_Lcom_papasofokli_agileboard_ItemClickRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_ItemClickRequest;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_ItemClickRequest() {
}
$h_Lcom_papasofokli_agileboard_ItemClickRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 545524410);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.z6, this.z7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uO));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_ItemClickRequest)) {
    var x_$_lo = this.z6;
    var x_$_hi = this.z7;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.z6;
    var x$1_$_hi = $x_1.z7;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      return (this.uO === x$0.uO);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ItemClickRequest";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.z6, this.z7);
  }
  if ((n === 1)) {
    return this.uO;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_agileboard_ItemClickRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.df)));
}
var $d_Lcom_papasofokli_agileboard_ItemClickRequest = new $TypeData().i($c_Lcom_papasofokli_agileboard_ItemClickRequest, "com.papasofokli.agileboard.ItemClickRequest", ({
  df: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_RequestBoardData(boardId_$_lo, boardId_$_hi, items) {
  this.z8 = 0;
  this.z9 = 0;
  this.uP = null;
  this.z8 = boardId_$_lo;
  this.z9 = boardId_$_hi;
  this.uP = items;
}
$p = $c_Lcom_papasofokli_agileboard_RequestBoardData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_RequestBoardData;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_RequestBoardData() {
}
$h_Lcom_papasofokli_agileboard_RequestBoardData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 500781569);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.z8, this.z9));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uP));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_RequestBoardData)) {
    var x_$_lo = this.z8;
    var x_$_hi = this.z9;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.z8;
    var x$1_$_hi = $x_1.z9;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.uP;
      var x$2$1 = x$0.uP;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "RequestBoardData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.z8, this.z9);
  }
  if ((n === 1)) {
    return this.uP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_agileboard_RequestBoardData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dg)));
}
var $d_Lcom_papasofokli_agileboard_RequestBoardData = new $TypeData().i($c_Lcom_papasofokli_agileboard_RequestBoardData, "com.papasofokli.agileboard.RequestBoardData", ({
  dg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_SelectedIdsRequest(previousId, selectedId) {
  this.Ad = null;
  this.Ae = null;
  this.Ad = previousId;
  this.Ae = selectedId;
}
$p = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_SelectedIdsRequest() {
}
$h_Lcom_papasofokli_agileboard_SelectedIdsRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1881398460, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_agileboard_SelectedIdsRequest)) {
    var x = this.Ad;
    var x$2 = x$0.Ad;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.Ae;
      var x$4 = x$0.Ae;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "SelectedIdsRequest";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Ad;
  }
  if ((n === 1)) {
    return this.Ae;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_agileboard_SelectedIdsRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dh)));
}
var $d_Lcom_papasofokli_agileboard_SelectedIdsRequest = new $TypeData().i($c_Lcom_papasofokli_agileboard_SelectedIdsRequest, "com.papasofokli.agileboard.SelectedIdsRequest", ({
  dh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes(zip, doc, xls) {
  this.Ah = false;
  this.Af = false;
  this.Ag = false;
  this.Ah = zip;
  this.Af = doc;
  this.Ag = xls;
}
$p = $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes;
/** @constructor */
function $h_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes() {
}
$h_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-327754762));
  acc = $m_sr_Statics$().d(acc, (this.Ah ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.Af ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.Ag ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes) && (((this.Ah === x$0.Ah) && (this.Af === x$0.Af)) && (this.Ag === x$0.Ag))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "AdditionalSupportedFileTypes";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Ah;
      break;
    }
    case 1: {
      return this.Af;
      break;
    }
    case 2: {
      return this.Ag;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.auq = (function() {
  return $m_s_Option$().hi((this.Ah ? new $c_s_Some("21530e57-cbd4-4dc9-a7e4-4ea3ef60f2be") : $m_s_None$())).cf().cH((this.Af ? new $c_s_Some("1ece4c34-fa6e-4606-9dfe-c9193f2554c4") : $m_s_None$())).dt((this.Ag ? new $c_s_Some("2b80f4f5-115e-46cf-9baf-13bff19e790b") : $m_s_None$()));
});
function $isArrayOf_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.di)));
}
var $d_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes = new $TypeData().i($c_Lcom_papasofokli_attachments_AdditionalSupportedFileTypes, "com.papasofokli.attachments.AdditionalSupportedFileTypes", ({
  di: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_box_BoxData(title, contents, icon, hasRow, hasButtons, headerContextualBackground, contextualBackground, chevronUp, chevronDown, contentFunctionId, cssStyle, expanded) {
  this.r1 = null;
  this.mV = null;
  this.r0 = null;
  this.l4 = false;
  this.l3 = false;
  this.qZ = null;
  this.qX = null;
  this.qV = null;
  this.mU = null;
  this.qW = null;
  this.qY = null;
  this.l2 = false;
  this.r1 = title;
  this.mV = contents;
  this.r0 = icon;
  this.l4 = hasRow;
  this.l3 = hasButtons;
  this.qZ = headerContextualBackground;
  this.qX = contextualBackground;
  this.qV = chevronUp;
  this.mU = chevronDown;
  this.qW = contentFunctionId;
  this.qY = cssStyle;
  this.l2 = expanded;
}
$p = $c_Lcom_papasofokli_box_BoxData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_box_BoxData;
/** @constructor */
function $h_Lcom_papasofokli_box_BoxData() {
}
$h_Lcom_papasofokli_box_BoxData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1736481781);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.r1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.mV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.r0));
  acc = $m_sr_Statics$().d(acc, (this.l4 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.l3 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qZ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qX));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.mU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qY));
  acc = $m_sr_Statics$().d(acc, (this.l2 ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 12);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_box_BoxData)) {
    if ((((((this.l4 === x$0.l4) && (this.l3 === x$0.l3)) && (this.l2 === x$0.l2)) && (this.r1 === x$0.r1)) && (this.mV === x$0.mV))) {
      var x = this.r0;
      var x$2 = x$0.r0;
      var $x_4 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_4 = false;
    }
    if ((($x_4 && (this.qZ === x$0.qZ)) && (this.qX === x$0.qX))) {
      var x$3 = this.qV;
      var x$4 = x$0.qV;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.mU;
      var x$6 = x$0.mU;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.qW;
      var x$8 = x$0.qW;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.qY === x$0.qY);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 12;
});
$p.A = (function() {
  return "BoxData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.r1;
      break;
    }
    case 1: {
      return this.mV;
      break;
    }
    case 2: {
      return this.r0;
      break;
    }
    case 3: {
      return this.l4;
      break;
    }
    case 4: {
      return this.l3;
      break;
    }
    case 5: {
      return this.qZ;
      break;
    }
    case 6: {
      return this.qX;
      break;
    }
    case 7: {
      return this.qV;
      break;
    }
    case 8: {
      return this.mU;
      break;
    }
    case 9: {
      return this.qW;
      break;
    }
    case 10: {
      return this.qY;
      break;
    }
    case 11: {
      return this.l2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_box_BoxData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dj)));
}
var $d_Lcom_papasofokli_box_BoxData = new $TypeData().i($c_Lcom_papasofokli_box_BoxData, "com.papasofokli.box.BoxData", ({
  dj: 1,
  b: 1,
  c: 1,
  a: 1
}));
var $b_Lcom_papasofokli_chartjs_BarChartOptions;
function $a_Lcom_papasofokli_chartjs_BarChartOptions() {
  if ((!$b_Lcom_papasofokli_chartjs_BarChartOptions)) {
    $b_Lcom_papasofokli_chartjs_BarChartOptions = class $b_Lcom_papasofokli_chartjs_BarChartOptions extends $a_Lcom_papasofokli_chartjs_ChartOptions() {
      constructor(arg, ...rest) {
        var plugins = null;
        var scales = null;
        var animation = null;
        var canvasId = null;
        var indexAxis = null;
        var width = null;
        plugins = arg;
        scales = ((rest[0] === (void 0)) ? (void 0) : rest[0]);
        animation = ((rest[1] === (void 0)) ? $m_Lcom_papasofokli_chartjs_BarChartOptions$().I7() : rest[1]);
        canvasId = rest[2];
        indexAxis = rest[3];
        width = ((rest[4] === (void 0)) ? $m_s_None$() : rest[4]);
        super(plugins, animation, false, indexAxis, width, (void 0), canvasId);
        Object.defineProperty(this, "scales", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.scales = scales;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_BarChartOptions;
}
function $ps_Lcom_papasofokli_chartjs_ChartJSZoom__ctx$accessor__Lcom_papasofokli_chartjs_ChartJSZoom__Lorg_scalajs_dom_CanvasRenderingContext2D(this$1) {
  return $superGet($i_chart$002ejs$002fauto.Chart, this$1, "ctx");
}
function $ps_Lcom_papasofokli_chartjs_ChartJSZoom__redefineEvent__Lcom_papasofokli_chartjs_ChartJSZoom__Lcom_papasofokli_chartjs_EventData__Lcom_papasofokli_chartjs_MouseEventData(this$1, evt) {
  var e = evt.originalEvent;
  var bounding = $ps_Lcom_papasofokli_chartjs_ChartJSZoom__ctx$accessor__Lcom_papasofokli_chartjs_ChartJSZoom__Lorg_scalajs_dom_CanvasRenderingContext2D(this$1).canvas.getBoundingClientRect();
  return $m_Lcom_papasofokli_chartjs_MouseEventData$().amy($doubleToInt(((e.clientX | 0) - (+bounding.left))), $doubleToInt(((e.clientY | 0) - (+bounding.top))), $m_Lcom_papasofokli_chartjs_EventDataXY$().amz($doubleToInt((e.x | 0)), $doubleToInt((e.y | 0))));
}
function $s_Lcom_papasofokli_chartjs_ChartJSZoom__getElementsAtEventForMode2__Lcom_papasofokli_chartjs_ChartJSZoom__Lcom_papasofokli_chartjs_EventData__T__sjs_js_Object__Z__sjs_js_Array(this$1, evt, mode, options, useFinalPosition) {
  var event = $ps_Lcom_papasofokli_chartjs_ChartJSZoom__redefineEvent__Lcom_papasofokli_chartjs_ChartJSZoom__Lcom_papasofokli_chartjs_EventData__Lcom_papasofokli_chartjs_MouseEventData(this$1, evt);
  return $i_chart$002ejs$002fauto.Chart.prototype.getElementsAtEventForMode.call(this$1, event, mode, options, useFinalPosition);
}
var $b_Lcom_papasofokli_chartjs_ChartJSZoom;
function $a_Lcom_papasofokli_chartjs_ChartJSZoom() {
  if ((!$b_Lcom_papasofokli_chartjs_ChartJSZoom)) {
    $b_Lcom_papasofokli_chartjs_ChartJSZoom = class $b_Lcom_papasofokli_chartjs_ChartJSZoom extends $i_chart$002ejs$002fauto.Chart {
      constructor(arg, arg$2) {
        var ctx = null;
        var data = null;
        ctx = arg;
        data = arg$2;
        super(ctx, data);
      }
      "getElementsAtEventForMode2"(arg, arg$2, arg$3, arg$4) {
        return $s_Lcom_papasofokli_chartjs_ChartJSZoom__getElementsAtEventForMode2__Lcom_papasofokli_chartjs_ChartJSZoom__Lcom_papasofokli_chartjs_EventData__T__sjs_js_Object__Z__sjs_js_Array(this, arg, arg$2, arg$3, (!(!arg$4)));
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ChartJSZoom;
}
var $b_Lcom_papasofokli_chartjs_PieChartOption;
function $a_Lcom_papasofokli_chartjs_PieChartOption() {
  if ((!$b_Lcom_papasofokli_chartjs_PieChartOption)) {
    $b_Lcom_papasofokli_chartjs_PieChartOption = class $b_Lcom_papasofokli_chartjs_PieChartOption extends $a_Lcom_papasofokli_chartjs_ChartOptions() {
      constructor(arg, ...rest) {
        var plugins = null;
        var animation = null;
        var canvasId = null;
        plugins = arg;
        animation = ((rest[0] === (void 0)) ? $m_Lcom_papasofokli_chartjs_PieChartOption$().Ts() : rest[0]);
        canvasId = rest[1];
        super(plugins, animation, (void 0), (void 0), (void 0), (void 0), canvasId);
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_PieChartOption;
}
var $b_Lcom_papasofokli_chartjs_RadarChartOptions;
function $a_Lcom_papasofokli_chartjs_RadarChartOptions() {
  if ((!$b_Lcom_papasofokli_chartjs_RadarChartOptions)) {
    $b_Lcom_papasofokli_chartjs_RadarChartOptions = class $b_Lcom_papasofokli_chartjs_RadarChartOptions extends $a_Lcom_papasofokli_chartjs_ChartOptions() {
      constructor(arg, ...rest) {
        var plugins = null;
        var scale = null;
        var animation = null;
        var canvasId = null;
        plugins = arg;
        scale = ((rest[0] === (void 0)) ? (void 0) : rest[0]);
        animation = ((rest[1] === (void 0)) ? $m_Lcom_papasofokli_chartjs_RadarChartOptions$().I7() : rest[1]);
        canvasId = rest[2];
        super(plugins, animation, (void 0), (void 0), (void 0), (void 0), canvasId);
        Object.defineProperty(this, "scale", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.scale = scale;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_RadarChartOptions;
}
var $b_Lcom_papasofokli_chartjs_ScatterChartOption;
function $a_Lcom_papasofokli_chartjs_ScatterChartOption() {
  if ((!$b_Lcom_papasofokli_chartjs_ScatterChartOption)) {
    $b_Lcom_papasofokli_chartjs_ScatterChartOption = class $b_Lcom_papasofokli_chartjs_ScatterChartOption extends $a_Lcom_papasofokli_chartjs_ChartOptions() {
      constructor(arg, ...rest) {
        var plugins = null;
        var scales = null;
        var animation = null;
        var canvasId = null;
        plugins = arg;
        scales = ((rest[0] === (void 0)) ? (void 0) : rest[0]);
        animation = ((rest[1] === (void 0)) ? $m_Lcom_papasofokli_chartjs_ScatterChartOption$().I7() : rest[1]);
        canvasId = rest[2];
        super(plugins, animation, true, (void 0), (void 0), (void 0), canvasId);
        Object.defineProperty(this, "scales", ({
          "configurable": true,
          "enumerable": true,
          "writable": true,
          "value": null
        }));
        this.scales = scales;
      }
    };
  }
  return $b_Lcom_papasofokli_chartjs_ScatterChartOption;
}
/** @constructor */
function $c_Lcom_papasofokli_communication_OutlookData(id_$_lo, id_$_hi, title, summary, dateText, severityName, severityStyle, isViewed, pinOnTop) {
  this.mw = 0;
  this.mx = 0;
  this.r3 = null;
  this.mZ = null;
  this.r2 = null;
  this.jO = null;
  this.ld = null;
  this.lb = false;
  this.lc = false;
  this.mw = id_$_lo;
  this.mx = id_$_hi;
  this.r3 = title;
  this.mZ = summary;
  this.r2 = dateText;
  this.jO = severityName;
  this.ld = severityStyle;
  this.lb = isViewed;
  this.lc = pinOnTop;
}
$p = $c_Lcom_papasofokli_communication_OutlookData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_communication_OutlookData;
/** @constructor */
function $h_Lcom_papasofokli_communication_OutlookData() {
}
$h_Lcom_papasofokli_communication_OutlookData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1298590743);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.mw, this.mx));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.r3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.mZ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.r2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ld));
  acc = $m_sr_Statics$().d(acc, (this.lb ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.lc ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 8);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_communication_OutlookData)) {
    var x_$_lo = this.mw;
    var x_$_hi = this.mx;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.mw;
    var x$1_$_hi = $x_2.mx;
    if (((((((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.lb === x$0.lb)) && (this.lc === x$0.lc)) && (this.r3 === x$0.r3)) && (this.mZ === x$0.mZ)) && (this.r2 === x$0.r2))) {
      var x$2 = this.jO;
      var x$2$1 = x$0.jO;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.ld;
      var x$4 = x$0.ld;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 8;
});
$p.A = (function() {
  return "OutlookData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.mw, this.mx);
      break;
    }
    case 1: {
      return this.r3;
      break;
    }
    case 2: {
      return this.mZ;
      break;
    }
    case 3: {
      return this.r2;
      break;
    }
    case 4: {
      return this.jO;
      break;
    }
    case 5: {
      return this.ld;
      break;
    }
    case 6: {
      return this.lb;
      break;
    }
    case 7: {
      return this.lc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aus = (function() {
  return (this.lb ? "fw-normal" : "fw-bold");
});
function $isArrayOf_Lcom_papasofokli_communication_OutlookData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dq)));
}
var $d_Lcom_papasofokli_communication_OutlookData = new $TypeData().i($c_Lcom_papasofokli_communication_OutlookData, "com.papasofokli.communication.OutlookData", ({
  dq: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_components_ScrollableNumberInputState(element, display, currentValue, adjacentLeft, adjacentRight, value, min, max, verticalIncrement, horizontalIncrement, verticalSpeed, horizontalSpeed, hiddenInput, onChangeIdO, updateOnlyOnDragEnd, isDragging, startX, startY, lastX, lastY, dragMode, dragThreshold) {
  this.Aj = null;
  this.uS = null;
  this.uR = null;
  this.le = null;
  this.lf = null;
  this.jP = 0;
  this.uW = 0;
  this.uV = 0;
  this.Al = 0;
  this.uU = 0;
  this.Am = 0.0;
  this.Ak = 0.0;
  this.uT = null;
  this.uX = null;
  this.v0 = false;
  this.r4 = false;
  this.uY = 0.0;
  this.uZ = 0.0;
  this.p3 = 0.0;
  this.p4 = 0.0;
  this.n0 = null;
  this.Ai = 0;
  this.Aj = element;
  this.uS = display;
  this.uR = currentValue;
  this.le = adjacentLeft;
  this.lf = adjacentRight;
  this.jP = value;
  this.uW = min;
  this.uV = max;
  this.Al = verticalIncrement;
  this.uU = horizontalIncrement;
  this.Am = verticalSpeed;
  this.Ak = horizontalSpeed;
  this.uT = hiddenInput;
  this.uX = onChangeIdO;
  this.v0 = updateOnlyOnDragEnd;
  this.r4 = isDragging;
  this.uY = startX;
  this.uZ = startY;
  this.p3 = lastX;
  this.p4 = lastY;
  this.n0 = dragMode;
  this.Ai = dragThreshold;
}
$p = $c_Lcom_papasofokli_components_ScrollableNumberInputState.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_components_ScrollableNumberInputState;
/** @constructor */
function $h_Lcom_papasofokli_components_ScrollableNumberInputState() {
}
$h_Lcom_papasofokli_components_ScrollableNumberInputState.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-764232969));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Aj));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.le));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lf));
  acc = $m_sr_Statics$().d(acc, this.jP);
  acc = $m_sr_Statics$().d(acc, this.uW);
  acc = $m_sr_Statics$().d(acc, this.uV);
  acc = $m_sr_Statics$().d(acc, this.Al);
  acc = $m_sr_Statics$().d(acc, this.uU);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Am));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Ak));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.uX));
  acc = $m_sr_Statics$().d(acc, (this.v0 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.r4 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.uY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.uZ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.p3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.p4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n0));
  acc = $m_sr_Statics$().d(acc, this.Ai);
  return $m_sr_Statics$().an(acc, 22);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_components_ScrollableNumberInputState)) {
    if (((((((((((((((((((((this.jP === x$0.jP) && (this.uW === x$0.uW)) && (this.uV === x$0.uV)) && (this.Al === x$0.Al)) && (this.uU === x$0.uU)) && (this.Am === x$0.Am)) && (this.Ak === x$0.Ak)) && (this.v0 === x$0.v0)) && (this.r4 === x$0.r4)) && (this.uY === x$0.uY)) && (this.uZ === x$0.uZ)) && (this.p3 === x$0.p3)) && (this.p4 === x$0.p4)) && (this.Ai === x$0.Ai)) && $m_sr_BoxesRunTime$().B(this.Aj, x$0.Aj)) && $m_sr_BoxesRunTime$().B(this.uS, x$0.uS)) && $m_sr_BoxesRunTime$().B(this.uR, x$0.uR)) && $m_sr_BoxesRunTime$().B(this.le, x$0.le)) && $m_sr_BoxesRunTime$().B(this.lf, x$0.lf)) && $m_sr_BoxesRunTime$().B(this.uT, x$0.uT))) {
      var x$6 = this.uX;
      var x$2$1 = x$0.uX;
      var $x_1 = ((x$6 === null) ? (x$2$1 === null) : x$6.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3$1 = this.n0;
      var x$4$1 = x$0.n0;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 22;
});
$p.A = (function() {
  return "ScrollableNumberInputState";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Aj;
      break;
    }
    case 1: {
      return this.uS;
      break;
    }
    case 2: {
      return this.uR;
      break;
    }
    case 3: {
      return this.le;
      break;
    }
    case 4: {
      return this.lf;
      break;
    }
    case 5: {
      return this.jP;
      break;
    }
    case 6: {
      return this.uW;
      break;
    }
    case 7: {
      return this.uV;
      break;
    }
    case 8: {
      return this.Al;
      break;
    }
    case 9: {
      return this.uU;
      break;
    }
    case 10: {
      return this.Am;
      break;
    }
    case 11: {
      return this.Ak;
      break;
    }
    case 12: {
      return this.uT;
      break;
    }
    case 13: {
      return this.uX;
      break;
    }
    case 14: {
      return this.v0;
      break;
    }
    case 15: {
      return this.r4;
      break;
    }
    case 16: {
      return this.uY;
      break;
    }
    case 17: {
      return this.uZ;
      break;
    }
    case 18: {
      return this.p3;
      break;
    }
    case 19: {
      return this.p4;
      break;
    }
    case 20: {
      return this.n0;
      break;
    }
    case 21: {
      return this.Ai;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_components_ScrollableNumberInputState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dr)));
}
var $d_Lcom_papasofokli_components_ScrollableNumberInputState = new $TypeData().i($c_Lcom_papasofokli_components_ScrollableNumberInputState, "com.papasofokli.components.ScrollableNumberInputState", ({
  dr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroup(columnDisplayName, numericValueO, groupOption, columnType) {
  this.p5 = null;
  this.n3 = null;
  this.n2 = null;
  this.n1 = null;
  this.p5 = columnDisplayName;
  this.n3 = numericValueO;
  this.n2 = groupOption;
  this.n1 = columnType;
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroup.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroup;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroup() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroup.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1972696541), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_ColumnGroup)) {
    var x = this.p5;
    var x$2 = x$0.p5;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.n3;
      var x$4 = x$0.n3;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.n2;
      var x$6 = x$0.n2;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.n1;
      var x$8 = x$0.n1;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "ColumnGroup";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.p5;
      break;
    }
    case 1: {
      return this.n3;
      break;
    }
    case 2: {
      return this.n2;
      break;
    }
    case 3: {
      return this.n1;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_ColumnGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ds)));
}
var $d_Lcom_papasofokli_dataTables_ColumnGroup = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroup, "com.papasofokli.dataTables.ColumnGroup", ({
  ds: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroupOption(index, groupByOption) {
  this.p6 = 0;
  this.iF = 0;
  this.p6 = index;
  this.iF = groupByOption;
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroupOption.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroupOption;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroupOption() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroupOption.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1935807102);
  acc = $m_sr_Statics$().d(acc, this.p6);
  acc = $m_sr_Statics$().d(acc, this.iF);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_dataTables_ColumnGroupOption) && ((this.p6 === x$0.p6) && (this.iF === x$0.iF))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ColumnGroupOption";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.p6;
  }
  if ((n === 1)) {
    return this.iF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_dataTables_ColumnGroupOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dt)));
}
var $d_Lcom_papasofokli_dataTables_ColumnGroupOption = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroupOption, "com.papasofokli.dataTables.ColumnGroupOption", ({
  dt: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_CsvPasteHeader(headerName, pastValues) {
  this.An = null;
  this.Ao = null;
  this.An = headerName;
  this.Ao = pastValues;
}
$p = $c_Lcom_papasofokli_dataTables_CsvPasteHeader.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_CsvPasteHeader;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_CsvPasteHeader() {
}
$h_Lcom_papasofokli_dataTables_CsvPasteHeader.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1863817248, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_CsvPasteHeader)) {
    if ((this.An === x$0.An)) {
      var x = this.Ao;
      var x$2 = x$0.Ao;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "CsvPasteHeader";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.An;
  }
  if ((n === 1)) {
    return this.Ao;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_dataTables_CsvPasteHeader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.du)));
}
var $d_Lcom_papasofokli_dataTables_CsvPasteHeader = new $TypeData().i($c_Lcom_papasofokli_dataTables_CsvPasteHeader, "com.papasofokli.dataTables.CsvPasteHeader", ({
  du: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GetRowsResult(draw, recordsTotal, recordsFiltered, data, groupedData, chartData, groupLevel, error, partialLoad, headersWidth, groupCalculationType) {
  this.p7 = 0;
  this.hq = 0;
  this.jS = 0;
  this.n4 = null;
  this.n6 = null;
  this.v1 = null;
  this.n5 = null;
  this.v2 = null;
  this.jR = false;
  this.n7 = null;
  this.jQ = null;
  this.p7 = draw;
  this.hq = recordsTotal;
  this.jS = recordsFiltered;
  this.n4 = data;
  this.n6 = groupedData;
  this.v1 = chartData;
  this.n5 = groupLevel;
  this.v2 = error;
  this.jR = partialLoad;
  this.n7 = headersWidth;
  this.jQ = groupCalculationType;
}
$p = $c_Lcom_papasofokli_dataTables_GetRowsResult.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GetRowsResult;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GetRowsResult() {
}
$h_Lcom_papasofokli_dataTables_GetRowsResult.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-821323988));
  acc = $m_sr_Statics$().d(acc, this.p7);
  acc = $m_sr_Statics$().d(acc, this.hq);
  acc = $m_sr_Statics$().d(acc, this.jS);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.v1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n5));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.v2));
  acc = $m_sr_Statics$().d(acc, (this.jR ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jQ));
  return $m_sr_Statics$().an(acc, 11);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_GetRowsResult)) {
    if (((((this.p7 === x$0.p7) && (this.hq === x$0.hq)) && (this.jS === x$0.jS)) && (this.jR === x$0.jR))) {
      var x = this.n4;
      var x$2 = x$0.n4;
      var $x_6 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.n6;
      var x$4 = x$0.n6;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.v1;
      var x$6 = x$0.v1;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.n5;
      var x$8 = x$0.n5;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.v2;
      var x$10 = x$0.v2;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.n7;
      var x$12 = x$0.n7;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.jQ;
      var x$14 = x$0.jQ;
      return ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 11;
});
$p.A = (function() {
  return "GetRowsResult";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.p7;
      break;
    }
    case 1: {
      return this.hq;
      break;
    }
    case 2: {
      return this.jS;
      break;
    }
    case 3: {
      return this.n4;
      break;
    }
    case 4: {
      return this.n6;
      break;
    }
    case 5: {
      return this.v1;
      break;
    }
    case 6: {
      return this.n5;
      break;
    }
    case 7: {
      return this.v2;
      break;
    }
    case 8: {
      return this.jR;
      break;
    }
    case 9: {
      return this.n7;
      break;
    }
    case 10: {
      return this.jQ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_GetRowsResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dw)));
}
var $d_Lcom_papasofokli_dataTables_GetRowsResult = new $TypeData().i($c_Lcom_papasofokli_dataTables_GetRowsResult, "com.papasofokli.dataTables.GetRowsResult", ({
  dw: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowChartData(name, counter, values) {
  this.v4 = null;
  this.v3 = 0;
  this.v5 = null;
  this.v4 = name;
  this.v3 = counter;
  this.v5 = values;
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowChartData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowChartData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowChartData() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowChartData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1508485556));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.v4));
  acc = $m_sr_Statics$().d(acc, this.v3);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.v5));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_GroupedRowChartData)) {
    if ((this.v3 === x$0.v3)) {
      var x = this.v4;
      var x$2 = x$0.v4;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.v5;
      var x$4 = x$0.v5;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "GroupedRowChartData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.v4;
      break;
    }
    case 1: {
      return this.v3;
      break;
    }
    case 2: {
      return this.v5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_GroupedRowChartData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dx)));
}
var $d_Lcom_papasofokli_dataTables_GroupedRowChartData = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowChartData, "com.papasofokli.dataTables.GroupedRowChartData", ({
  dx: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData(name, columnGroup, values) {
  this.r5 = null;
  this.v6 = null;
  this.r6 = null;
  this.r5 = name;
  this.v6 = columnGroup;
  this.r6 = values;
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowSummaryData() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowSummaryData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-727815193), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData)) {
    var x = this.r5;
    var x$2 = x$0.r5;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.v6;
      var x$4 = x$0.v6;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.r6;
      var x$6 = x$0.r6;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "GroupedRowSummaryData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.r5;
      break;
    }
    case 1: {
      return this.v6;
      break;
    }
    case 2: {
      return this.r6;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_GroupedRowSummaryData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dy)));
}
var $d_Lcom_papasofokli_dataTables_GroupedRowSummaryData = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowSummaryData, "com.papasofokli.dataTables.GroupedRowSummaryData", ({
  dy: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableColumnProperties(name, index, isHidden, isAdditional, sortIndex, columnType, hideAggregation) {
  this.jT = null;
  this.eV = 0;
  this.gk = false;
  this.lk = false;
  this.rd = 0.0;
  this.lj = null;
  this.pc = false;
  this.jT = name;
  this.eV = index;
  this.gk = isHidden;
  this.lk = isAdditional;
  this.rd = sortIndex;
  this.lj = columnType;
  this.pc = hideAggregation;
}
$p = $c_Lcom_papasofokli_dataTables_TableColumnProperties.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableColumnProperties;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableColumnProperties() {
}
$h_Lcom_papasofokli_dataTables_TableColumnProperties.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 764869879);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jT));
  acc = $m_sr_Statics$().d(acc, this.eV);
  acc = $m_sr_Statics$().d(acc, (this.gk ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.lk ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.rd));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lj));
  acc = $m_sr_Statics$().d(acc, (this.pc ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableColumnProperties)) {
    if (((((((this.eV === x$0.eV) && (this.gk === x$0.gk)) && (this.lk === x$0.lk)) && (this.rd === x$0.rd)) && (this.pc === x$0.pc)) && (this.jT === x$0.jT))) {
      var x = this.lj;
      var x$2 = x$0.lj;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "TableColumnProperties";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.jT;
      break;
    }
    case 1: {
      return this.eV;
      break;
    }
    case 2: {
      return this.gk;
      break;
    }
    case 3: {
      return this.lk;
      break;
    }
    case 4: {
      return this.rd;
      break;
    }
    case 5: {
      return this.lj;
      break;
    }
    case 6: {
      return this.pc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableColumnProperties(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dG)));
}
var $d_Lcom_papasofokli_dataTables_TableColumnProperties = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableColumnProperties, "com.papasofokli.dataTables.TableColumnProperties", ({
  dG: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupRequest(keyValues, groupLevel, columnGroupBy, headersWidth, maxClientWidth, groupCalculationType, dateColumnGroupType, columnOrder, directionOrder, columnsSearch, blockAggregationIndexes, innerTablePageNo) {
  this.vi = null;
  this.vg = 0;
  this.vc = null;
  this.vh = null;
  this.nc = null;
  this.jU = null;
  this.na = null;
  this.vd = null;
  this.vf = null;
  this.ve = null;
  this.n9 = null;
  this.nb = null;
  this.vi = keyValues;
  this.vg = groupLevel;
  this.vc = columnGroupBy;
  this.vh = headersWidth;
  this.nc = maxClientWidth;
  this.jU = groupCalculationType;
  this.na = dateColumnGroupType;
  this.vd = columnOrder;
  this.vf = directionOrder;
  this.ve = columnsSearch;
  this.n9 = blockAggregationIndexes;
  this.nb = innerTablePageNo;
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupRequest;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupRequest() {
}
$h_Lcom_papasofokli_dataTables_TableGroupRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-276192802));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vi));
  acc = $m_sr_Statics$().d(acc, this.vg);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vc));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vh));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nc));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.na));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vd));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vf));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ve));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.n9));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nb));
  return $m_sr_Statics$().an(acc, 12);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableGroupRequest)) {
    if ((this.vg === x$0.vg)) {
      var x = this.vi;
      var x$2 = x$0.vi;
      var $x_9 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$3 = this.vc;
      var x$4 = x$0.vc;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.vh;
      var x$6 = x$0.vh;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.nc;
      var x$8 = x$0.nc;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.jU;
      var x$10 = x$0.jU;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.na;
      var x$12 = x$0.na;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.vd;
      var x$14 = x$0.vd;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.vf === x$0.vf))) {
      var x$15 = this.ve;
      var x$16 = x$0.ve;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.n9;
      var x$18 = x$0.n9;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.nb;
      var x$20 = x$0.nb;
      return ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 12;
});
$p.A = (function() {
  return "TableGroupRequest";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.vi;
      break;
    }
    case 1: {
      return this.vg;
      break;
    }
    case 2: {
      return this.vc;
      break;
    }
    case 3: {
      return this.vh;
      break;
    }
    case 4: {
      return this.nc;
      break;
    }
    case 5: {
      return this.jU;
      break;
    }
    case 6: {
      return this.na;
      break;
    }
    case 7: {
      return this.vd;
      break;
    }
    case 8: {
      return this.vf;
      break;
    }
    case 9: {
      return this.ve;
      break;
    }
    case 10: {
      return this.n9;
      break;
    }
    case 11: {
      return this.nb;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableGroupRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dH)));
}
var $d_Lcom_papasofokli_dataTables_TableGroupRequest = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupRequest, "com.papasofokli.dataTables.TableGroupRequest", ({
  dH: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupedResult(tableHtml, data, tableSetupData, groupedData, totalRecords) {
  this.lm = null;
  this.iG = null;
  this.iH = null;
  this.ll = null;
  this.ln = 0;
  this.lm = tableHtml;
  this.iG = data;
  this.iH = tableSetupData;
  this.ll = groupedData;
  this.ln = totalRecords;
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupedResult.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupedResult;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupedResult() {
}
$h_Lcom_papasofokli_dataTables_TableGroupedResult.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1287218189);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lm));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iG));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ll));
  acc = $m_sr_Statics$().d(acc, this.ln);
  return $m_sr_Statics$().an(acc, 5);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableGroupedResult)) {
    if ((this.ln === x$0.ln)) {
      var x = this.lm;
      var x$2 = x$0.lm;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.iG;
      var x$4 = x$0.iG;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.iH;
      var x$6 = x$0.iH;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.ll;
      var x$8 = x$0.ll;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "TableGroupedResult";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.lm;
      break;
    }
    case 1: {
      return this.iG;
      break;
    }
    case 2: {
      return this.iH;
      break;
    }
    case 3: {
      return this.ll;
      break;
    }
    case 4: {
      return this.ln;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableGroupedResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dI)));
}
var $d_Lcom_papasofokli_dataTables_TableGroupedResult = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupedResult, "com.papasofokli.dataTables.TableGroupedResult", ({
  dI: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableParameters(draw, start, length, search, columnOrder, directionOrder, columnsSearch, lazyLoad, columnGroupBy, blockAggregationIndexes, groupLevel, headersWidth, maxClientWidth, groupCalculationType, dateColumnGroupType, chartData, exportDetailsIndicator) {
  this.vm = 0;
  this.vq = 0;
  this.vo = 0;
  this.vp = null;
  this.vj = null;
  this.vl = null;
  this.vk = null;
  this.vn = false;
  this.nf = null;
  this.nd = null;
  this.nj = null;
  this.nk = null;
  this.nl = null;
  this.ni = null;
  this.ng = null;
  this.ne = false;
  this.nh = null;
  this.vm = draw;
  this.vq = start;
  this.vo = length;
  this.vp = search;
  this.vj = columnOrder;
  this.vl = directionOrder;
  this.vk = columnsSearch;
  this.vn = lazyLoad;
  this.nf = columnGroupBy;
  this.nd = blockAggregationIndexes;
  this.nj = groupLevel;
  this.nk = headersWidth;
  this.nl = maxClientWidth;
  this.ni = groupCalculationType;
  this.ng = dateColumnGroupType;
  this.ne = chartData;
  this.nh = exportDetailsIndicator;
}
$p = $c_Lcom_papasofokli_dataTables_TableParameters.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableParameters;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableParameters() {
}
$h_Lcom_papasofokli_dataTables_TableParameters.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-293165000));
  acc = $m_sr_Statics$().d(acc, this.vm);
  acc = $m_sr_Statics$().d(acc, this.vq);
  acc = $m_sr_Statics$().d(acc, this.vo);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vp));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vj));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vl));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.vk));
  acc = $m_sr_Statics$().d(acc, (this.vn ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nf));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nd));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nj));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nk));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nl));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ni));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ng));
  acc = $m_sr_Statics$().d(acc, (this.ne ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nh));
  return $m_sr_Statics$().an(acc, 17);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableParameters)) {
    if (((((((this.vm === x$0.vm) && (this.vq === x$0.vq)) && (this.vo === x$0.vo)) && (this.vn === x$0.vn)) && (this.ne === x$0.ne)) && (this.vp === x$0.vp))) {
      var x = this.vj;
      var x$2 = x$0.vj;
      var $x_9 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_9 = false;
    }
    if (($x_9 && (this.vl === x$0.vl))) {
      var x$3 = this.vk;
      var x$4 = x$0.vk;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.nf;
      var x$6 = x$0.nf;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.nd;
      var x$8 = x$0.nd;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.nj;
      var x$10 = x$0.nj;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.nk;
      var x$12 = x$0.nk;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.nl;
      var x$14 = x$0.nl;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.ni;
      var x$16 = x$0.ni;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.ng;
      var x$18 = x$0.ng;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.nh;
      var x$20 = x$0.nh;
      return ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 17;
});
$p.A = (function() {
  return "TableParameters";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.vm;
      break;
    }
    case 1: {
      return this.vq;
      break;
    }
    case 2: {
      return this.vo;
      break;
    }
    case 3: {
      return this.vp;
      break;
    }
    case 4: {
      return this.vj;
      break;
    }
    case 5: {
      return this.vl;
      break;
    }
    case 6: {
      return this.vk;
      break;
    }
    case 7: {
      return this.vn;
      break;
    }
    case 8: {
      return this.nf;
      break;
    }
    case 9: {
      return this.nd;
      break;
    }
    case 10: {
      return this.nj;
      break;
    }
    case 11: {
      return this.nk;
      break;
    }
    case 12: {
      return this.nl;
      break;
    }
    case 13: {
      return this.ni;
      break;
    }
    case 14: {
      return this.ng;
      break;
    }
    case 15: {
      return this.ne;
      break;
    }
    case 16: {
      return this.nh;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableParameters(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dJ)));
}
var $d_Lcom_papasofokli_dataTables_TableParameters = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableParameters, "com.papasofokli.dataTables.TableParameters", ({
  dJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableSetupData(columns, headersWidth, maxClientWidth, defaultRowsPerPage, additionalButtons, addNewButton) {
  this.hZ = null;
  this.re = null;
  this.lq = null;
  this.lp = 0;
  this.lo = null;
  this.jV = null;
  this.hZ = columns;
  this.re = headersWidth;
  this.lq = maxClientWidth;
  this.lp = defaultRowsPerPage;
  this.lo = additionalButtons;
  this.jV = addNewButton;
}
$p = $c_Lcom_papasofokli_dataTables_TableSetupData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableSetupData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableSetupData() {
}
$h_Lcom_papasofokli_dataTables_TableSetupData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1949118393);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hZ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.re));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lq));
  acc = $m_sr_Statics$().d(acc, this.lp);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lo));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jV));
  return $m_sr_Statics$().an(acc, 6);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableSetupData)) {
    if ((this.lp === x$0.lp)) {
      var x = this.hZ;
      var x$2 = x$0.hZ;
      var $x_4 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.re;
      var x$4 = x$0.re;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.lq;
      var x$6 = x$0.lq;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.lo;
      var x$8 = x$0.lo;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.jV;
      var x$10 = x$0.jV;
      return ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "TableSetupData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.hZ;
      break;
    }
    case 1: {
      return this.re;
      break;
    }
    case 2: {
      return this.lq;
      break;
    }
    case 3: {
      return this.lp;
      break;
    }
    case 4: {
      return this.lo;
      break;
    }
    case 5: {
      return this.jV;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableSetupData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dK)));
}
var $d_Lcom_papasofokli_dataTables_TableSetupData = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableSetupData, "com.papasofokli.dataTables.TableSetupData", ({
  dK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ModalRatio(left, right) {
  this.jW = 0;
  this.jX = 0;
  this.jW = left;
  this.jX = right;
}
$p = $c_Lcom_papasofokli_execution_ModalRatio.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ModalRatio;
/** @constructor */
function $h_Lcom_papasofokli_execution_ModalRatio() {
}
$h_Lcom_papasofokli_execution_ModalRatio.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 535946622);
  acc = $m_sr_Statics$().d(acc, this.jW);
  acc = $m_sr_Statics$().d(acc, this.jX);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ModalRatio) && ((this.jW === x$0.jW) && (this.jX === x$0.jX))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ModalRatio";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.jW;
  }
  if ((n === 1)) {
    return this.jX;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ModalRatio(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eb)));
}
var $d_Lcom_papasofokli_execution_ModalRatio = new $TypeData().i($c_Lcom_papasofokli_execution_ModalRatio, "com.papasofokli.execution.ModalRatio", ({
  eb: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange(subjectIdSeq, fromTime_$_lo, fromTime_$_hi, toTime_$_lo, toTime_$_hi) {
  this.rI = null;
  this.u1 = 0;
  this.u2 = 0;
  this.u3 = 0;
  this.u4 = 0;
  this.rI = subjectIdSeq;
  this.u1 = fromTime_$_lo;
  this.u2 = fromTime_$_hi;
  this.u3 = toTime_$_lo;
  this.u4 = toTime_$_hi;
}
$p = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange;
/** @constructor */
function $h_Lcom_papasofokli_execution_PlanningGenerationEffectRange() {
}
$h_Lcom_papasofokli_execution_PlanningGenerationEffectRange.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 988628599);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.u1, this.u2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.u3, this.u4));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange)) {
    var x_$_lo = this.u1;
    var x_$_hi = this.u2;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.u1;
    var x$1_$_hi = $x_2.u2;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.u3;
      var x$2_$_hi = this.u4;
      var $x_3 = x$0;
      var x$3_$_lo = $x_3.u3;
      var x$3_$_hi = $x_3.u4;
      var $x_1 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$4 = this.rI;
      var x$2$1 = x$0.rI;
      return ((x$4 === null) ? (x$2$1 === null) : x$4.b(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "PlanningGenerationEffectRange";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rI;
      break;
    }
    case 1: {
      return $bL(this.u1, this.u2);
      break;
    }
    case 2: {
      return $bL(this.u3, this.u4);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_PlanningGenerationEffectRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ej)));
}
var $d_Lcom_papasofokli_execution_PlanningGenerationEffectRange = new $TypeData().i($c_Lcom_papasofokli_execution_PlanningGenerationEffectRange, "com.papasofokli.execution.PlanningGenerationEffectRange", ({
  ej: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_ContextMenuRequest(node) {
  this.AC = null;
  this.AC = node;
}
$p = $c_Lcom_papasofokli_jstree_ContextMenuRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_ContextMenuRequest;
/** @constructor */
function $h_Lcom_papasofokli_jstree_ContextMenuRequest() {
}
$h_Lcom_papasofokli_jstree_ContextMenuRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1782927652), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_ContextMenuRequest)) {
    var x = this.AC;
    var x$2 = x$0.AC;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ContextMenuRequest";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.AC;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_jstree_ContextMenuRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eW)));
}
var $d_Lcom_papasofokli_jstree_ContextMenuRequest = new $TypeData().i($c_Lcom_papasofokli_jstree_ContextMenuRequest, "com.papasofokli.jstree.ContextMenuRequest", ({
  eW: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_InfoItem(text, icons, iconCss, style, clickEventId) {
  this.lw = null;
  this.lu = null;
  this.lt = null;
  this.lv = null;
  this.pd = null;
  this.lw = text;
  this.lu = icons;
  this.lt = iconCss;
  this.lv = style;
  this.pd = clickEventId;
}
$p = $c_Lcom_papasofokli_jstree_InfoItem.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_InfoItem;
/** @constructor */
function $h_Lcom_papasofokli_jstree_InfoItem() {
}
$h_Lcom_papasofokli_jstree_InfoItem.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1346820909, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_InfoItem)) {
    var x = this.lw;
    var x$2 = x$0.lw;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.lu;
      var x$4 = x$0.lu;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.lt;
      var x$6 = x$0.lt;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.lv;
      var x$8 = x$0.lv;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.pd;
      var x$10 = x$0.pd;
      return ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "InfoItem";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.lw;
      break;
    }
    case 1: {
      return this.lu;
      break;
    }
    case 2: {
      return this.lt;
      break;
    }
    case 3: {
      return this.lv;
      break;
    }
    case 4: {
      return this.pd;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_jstree_InfoItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eX)));
}
var $d_Lcom_papasofokli_jstree_InfoItem = new $TypeData().i($c_Lcom_papasofokli_jstree_InfoItem, "com.papasofokli.jstree.InfoItem", ({
  eX: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_LeafClickRequest(node, clickType) {
  this.AE = null;
  this.AD = null;
  this.AE = node;
  this.AD = clickType;
}
$p = $c_Lcom_papasofokli_jstree_LeafClickRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_LeafClickRequest;
/** @constructor */
function $h_Lcom_papasofokli_jstree_LeafClickRequest() {
}
$h_Lcom_papasofokli_jstree_LeafClickRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1710475516, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_LeafClickRequest)) {
    var x = this.AE;
    var x$2 = x$0.AE;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.AD === x$0.AD);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "LeafClickRequest";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.AE;
  }
  if ((n === 1)) {
    return this.AD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_jstree_LeafClickRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eY)));
}
var $d_Lcom_papasofokli_jstree_LeafClickRequest = new $TypeData().i($c_Lcom_papasofokli_jstree_LeafClickRequest, "com.papasofokli.jstree.LeafClickRequest", ({
  eY: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_NodeClickRequest(node, clickType) {
  this.AG = null;
  this.AF = null;
  this.AG = node;
  this.AF = clickType;
}
$p = $c_Lcom_papasofokli_jstree_NodeClickRequest.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_NodeClickRequest;
/** @constructor */
function $h_Lcom_papasofokli_jstree_NodeClickRequest() {
}
$h_Lcom_papasofokli_jstree_NodeClickRequest.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1127905621), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_NodeClickRequest)) {
    var x = this.AG;
    var x$2 = x$0.AG;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.AF === x$0.AF);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "NodeClickRequest";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.AG;
  }
  if ((n === 1)) {
    return this.AF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_jstree_NodeClickRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eZ)));
}
var $d_Lcom_papasofokli_jstree_NodeClickRequest = new $TypeData().i($c_Lcom_papasofokli_jstree_NodeClickRequest, "com.papasofokli.jstree.NodeClickRequest", ({
  eZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeNodeListSetupData(nodes, leaves, expandOnDoubleClick) {
  this.pg = null;
  this.pf = null;
  this.si = false;
  this.pg = nodes;
  this.pf = leaves;
  this.si = expandOnDoubleClick;
}
$p = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeNodeListSetupData() {
}
$h_Lcom_papasofokli_jstree_TreeNodeListSetupData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-246335031));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pg));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pf));
  acc = $m_sr_Statics$().d(acc, (this.si ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_TreeNodeListSetupData)) {
    if ((this.si === x$0.si)) {
      var x = this.pg;
      var x$2 = x$0.pg;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.pf;
      var x$4 = x$0.pf;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TreeNodeListSetupData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pg;
      break;
    }
    case 1: {
      return this.pf;
      break;
    }
    case 2: {
      return this.si;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_jstree_TreeNodeListSetupData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f2)));
}
var $d_Lcom_papasofokli_jstree_TreeNodeListSetupData = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeNodeListSetupData, "com.papasofokli.jstree.TreeNodeListSetupData", ({
  f2: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_AppliedToC(name) {
  this.AH = null;
  this.AH = name;
}
$p = $c_Lcom_papasofokli_planning_AppliedToC.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_AppliedToC;
/** @constructor */
function $h_Lcom_papasofokli_planning_AppliedToC() {
}
$h_Lcom_papasofokli_planning_AppliedToC.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-742887223), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_planning_AppliedToC) && (this.AH === x$0.AH)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "AppliedToC";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.AH;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_AppliedToC(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f3)));
}
var $d_Lcom_papasofokli_planning_AppliedToC = new $TypeData().i($c_Lcom_papasofokli_planning_AppliedToC, "com.papasofokli.planning.AppliedToC", ({
  f3: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DetailedPlanningRow(periodDetails, hideIfEmpty) {
  this.k3 = null;
  this.k2 = false;
  this.k3 = periodDetails;
  this.k2 = hideIfEmpty;
}
$p = $c_Lcom_papasofokli_planning_DetailedPlanningRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DetailedPlanningRow;
/** @constructor */
function $h_Lcom_papasofokli_planning_DetailedPlanningRow() {
}
$h_Lcom_papasofokli_planning_DetailedPlanningRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1328483917);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k3));
  acc = $m_sr_Statics$().d(acc, (this.k2 ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_DetailedPlanningRow)) {
    if ((this.k2 === x$0.k2)) {
      var x = this.k3;
      var x$2 = x$0.k3;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "DetailedPlanningRow";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.k3;
  }
  if ((n === 1)) {
    return this.k2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_DetailedPlanningRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f4)));
}
var $d_Lcom_papasofokli_planning_DetailedPlanningRow = new $TypeData().i($c_Lcom_papasofokli_planning_DetailedPlanningRow, "com.papasofokli.planning.DetailedPlanningRow", ({
  f4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_IndicationsDictionary(icon, text, appliedTo) {
  this.nr = null;
  this.wF = null;
  this.lE = null;
  this.nr = icon;
  this.wF = text;
  this.lE = appliedTo;
}
$p = $c_Lcom_papasofokli_planning_IndicationsDictionary.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_IndicationsDictionary;
/** @constructor */
function $h_Lcom_papasofokli_planning_IndicationsDictionary() {
}
$h_Lcom_papasofokli_planning_IndicationsDictionary.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-301177988), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_IndicationsDictionary)) {
    var x = this.nr;
    var x$2 = x$0.nr;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.wF === x$0.wF))) {
      var x$3 = this.lE;
      var x$4 = x$0.lE;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "IndicationsDictionary";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nr;
      break;
    }
    case 1: {
      return this.wF;
      break;
    }
    case 2: {
      return this.lE;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_IndicationsDictionary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f5)));
}
var $d_Lcom_papasofokli_planning_IndicationsDictionary = new $TypeData().i($c_Lcom_papasofokli_planning_IndicationsDictionary, "com.papasofokli.planning.IndicationsDictionary", ({
  f5: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodJS(periodId, fromDate_$_lo, fromDate_$_hi, toDate_$_lo, toDate_$_hi, totalHours, taskName, periodType, vesselId, tooltipInformation, startDateConfirmed, endDateConfirmed, periodStyle, toAppearInRow, leftIndications, text, textLine2, rightIndications, centerIndications, rowInformation, uniqueUUID, color, stroke, customIndicationsDictionary, changeDatesFunctionUUID, changeRightDateFunctionUUID, changeLeftDateFunctionUUID, animationTime, showDatesOnTooltip) {
  this.fU = null;
  this.qw = 0;
  this.qx = 0;
  this.ot = 0;
  this.ou = 0;
  this.iQ = null;
  this.k6 = null;
  this.nu = null;
  this.k7 = null;
  this.nv = null;
  this.lH = false;
  this.lG = false;
  this.k4 = null;
  this.hr = 0;
  this.gV = null;
  this.iP = null;
  this.i4 = null;
  this.gW = null;
  this.gU = null;
  this.k5 = null;
  this.fw = null;
  this.iM = null;
  this.iO = null;
  this.i3 = null;
  this.iJ = null;
  this.iL = null;
  this.iK = null;
  this.fv = null;
  this.iN = false;
  this.fU = periodId;
  this.qw = fromDate_$_lo;
  this.qx = fromDate_$_hi;
  this.ot = toDate_$_lo;
  this.ou = toDate_$_hi;
  this.iQ = totalHours;
  this.k6 = taskName;
  this.nu = periodType;
  this.k7 = vesselId;
  this.nv = tooltipInformation;
  this.lH = startDateConfirmed;
  this.lG = endDateConfirmed;
  this.k4 = periodStyle;
  this.hr = toAppearInRow;
  this.gV = leftIndications;
  this.iP = text;
  this.i4 = textLine2;
  this.gW = rightIndications;
  this.gU = centerIndications;
  this.k5 = rowInformation;
  this.fw = uniqueUUID;
  this.iM = color;
  this.iO = stroke;
  this.i3 = customIndicationsDictionary;
  this.iJ = changeDatesFunctionUUID;
  this.iL = changeRightDateFunctionUUID;
  this.iK = changeLeftDateFunctionUUID;
  this.fv = animationTime;
  this.iN = showDatesOnTooltip;
}
$p = $c_Lcom_papasofokli_planning_PeriodJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodJS() {
}
$h_Lcom_papasofokli_planning_PeriodJS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 498562794);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.fU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.qw, this.qx));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ot, this.ou));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nu));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nv));
  acc = $m_sr_Statics$().d(acc, (this.lH ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.lG ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k4));
  acc = $m_sr_Statics$().d(acc, this.hr);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iP));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.i4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k5));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.fw));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.i3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.fv));
  acc = $m_sr_Statics$().d(acc, (this.iN ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 27);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_PeriodJS)) {
    var x_$_lo = this.qw;
    var x_$_hi = this.qx;
    var $x_20 = x$0;
    var x$1_$_lo = $x_20.qw;
    var x$1_$_hi = $x_20.qx;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.ot;
      var x$2_$_hi = this.ou;
      var $x_21 = x$0;
      var x$3_$_lo = $x_21.ot;
      var x$3_$_hi = $x_21.ou;
      var $x_19 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_19 = false;
    }
    if ((((($x_19 && (this.lH === x$0.lH)) && (this.lG === x$0.lG)) && (this.hr === x$0.hr)) && (this.iN === x$0.iN))) {
      var x$4 = this.fU;
      var x$2$1 = x$0.fU;
      var $x_18 = ((x$4 === null) ? (x$2$1 === null) : x$4.b(x$2$1));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$3$1 = this.iQ;
      var x$4$1 = x$0.iQ;
      var $x_17 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      var $x_17 = false;
    }
    if ((($x_17 && (this.k6 === x$0.k6)) && (this.nu === x$0.nu))) {
      var x$5 = this.k7;
      var x$6 = x$0.k7;
      var $x_16 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$7 = this.nv;
      var x$8 = x$0.nv;
      var $x_15 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$9 = this.k4;
      var x$10 = x$0.k4;
      var $x_14 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$11 = this.gV;
      var x$12 = x$0.gV;
      var $x_13 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$13 = this.iP;
      var x$14 = x$0.iP;
      var $x_12 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$15 = this.i4;
      var x$16 = x$0.i4;
      var $x_11 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$17 = this.gW;
      var x$18 = x$0.gW;
      var $x_10 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$19 = this.gU;
      var x$20 = x$0.gU;
      var $x_9 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$21 = this.k5;
      var x$22 = x$0.k5;
      var $x_8 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$23 = this.fw;
      var x$24 = x$0.fw;
      var $x_7 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$25 = this.iM;
      var x$26 = x$0.iM;
      var $x_6 = ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$27 = this.iO;
      var x$28 = x$0.iO;
      var $x_5 = ((x$27 === null) ? (x$28 === null) : x$27.b(x$28));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$29 = this.i3;
      var x$30 = x$0.i3;
      var $x_4 = ((x$29 === null) ? (x$30 === null) : x$29.b(x$30));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$31 = this.iJ;
      var x$32 = x$0.iJ;
      var $x_3 = ((x$31 === null) ? (x$32 === null) : x$31.b(x$32));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$33 = this.iL;
      var x$34 = x$0.iL;
      var $x_2 = ((x$33 === null) ? (x$34 === null) : x$33.b(x$34));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$35 = this.iK;
      var x$36 = x$0.iK;
      var $x_1 = ((x$35 === null) ? (x$36 === null) : x$35.b(x$36));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$37 = this.fv;
      var x$38 = x$0.fv;
      return ((x$37 === null) ? (x$38 === null) : x$37.b(x$38));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 27;
});
$p.A = (function() {
  return "PeriodJS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.fU;
      break;
    }
    case 1: {
      return $bL(this.qw, this.qx);
      break;
    }
    case 2: {
      return $bL(this.ot, this.ou);
      break;
    }
    case 3: {
      return this.iQ;
      break;
    }
    case 4: {
      return this.k6;
      break;
    }
    case 5: {
      return this.nu;
      break;
    }
    case 6: {
      return this.k7;
      break;
    }
    case 7: {
      return this.nv;
      break;
    }
    case 8: {
      return this.lH;
      break;
    }
    case 9: {
      return this.lG;
      break;
    }
    case 10: {
      return this.k4;
      break;
    }
    case 11: {
      return this.hr;
      break;
    }
    case 12: {
      return this.gV;
      break;
    }
    case 13: {
      return this.iP;
      break;
    }
    case 14: {
      return this.i4;
      break;
    }
    case 15: {
      return this.gW;
      break;
    }
    case 16: {
      return this.gU;
      break;
    }
    case 17: {
      return this.k5;
      break;
    }
    case 18: {
      return this.fw;
      break;
    }
    case 19: {
      return this.iM;
      break;
    }
    case 20: {
      return this.iO;
      break;
    }
    case 21: {
      return this.i3;
      break;
    }
    case 22: {
      return this.iJ;
      break;
    }
    case 23: {
      return this.iL;
      break;
    }
    case 24: {
      return this.iK;
      break;
    }
    case 25: {
      return this.fv;
      break;
    }
    case 26: {
      return this.iN;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_PeriodJS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fa)));
}
var $d_Lcom_papasofokli_planning_PeriodJS = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodJS, "com.papasofokli.planning.PeriodJS", ({
  fa: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodStyle(name) {
  this.sk = null;
  this.sk = name;
}
$p = $c_Lcom_papasofokli_planning_PeriodStyle.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodStyle;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodStyle() {
}
$h_Lcom_papasofokli_planning_PeriodStyle.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1124981192, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_planning_PeriodStyle) && (this.sk === x$0.sk)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "PeriodStyle";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.sk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_PeriodStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fb)));
}
var $d_Lcom_papasofokli_planning_PeriodStyle = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodStyle, "com.papasofokli.planning.PeriodStyle", ({
  fb: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodTransformation(oldPeriod, newPeriod) {
  this.wK = null;
  this.wJ = null;
  this.wK = oldPeriod;
  this.wJ = newPeriod;
}
$p = $c_Lcom_papasofokli_planning_PeriodTransformation.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodTransformation;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodTransformation() {
}
$h_Lcom_papasofokli_planning_PeriodTransformation.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 934856506, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_PeriodTransformation)) {
    var x = this.wK;
    var x$2 = x$0.wK;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.wJ;
      var x$4 = x$0.wJ;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "PeriodTransformation";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wK;
  }
  if ((n === 1)) {
    return this.wJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_PeriodTransformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fc)));
}
var $d_Lcom_papasofokli_planning_PeriodTransformation = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodTransformation, "com.papasofokli.planning.PeriodTransformation", ({
  fc: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlannerPeriodsData(rowUUID, periodWithRowSeq, subjectRowId) {
  this.AJ = null;
  this.AI = null;
  this.AK = null;
  this.AJ = rowUUID;
  this.AI = periodWithRowSeq;
  this.AK = subjectRowId;
}
$p = $c_Lcom_papasofokli_planning_PlannerPeriodsData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlannerPeriodsData;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlannerPeriodsData() {
}
$h_Lcom_papasofokli_planning_PlannerPeriodsData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1299130317, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_PlannerPeriodsData)) {
    var x = this.AJ;
    var x$2 = x$0.AJ;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.AI;
      var x$4 = x$0.AI;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.AK;
      var x$6 = x$0.AK;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "PlannerPeriodsData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.AJ;
      break;
    }
    case 1: {
      return this.AI;
      break;
    }
    case 2: {
      return this.AK;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_PlannerPeriodsData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fd)));
}
var $d_Lcom_papasofokli_planning_PlannerPeriodsData = new $TypeData().i($c_Lcom_papasofokli_planning_PlannerPeriodsData, "com.papasofokli.planning.PlannerPeriodsData", ({
  fd: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningData(subjectData, fromDate_$_lo, fromDate_$_hi, toDate, zoomLevel, scrollOnTime, showButtons, contextMenuFunctionUUID, clickFunctionUUID, clickSubjectButtonParams, departmentClickFunctionUUID, verticalDateLines, leafDivisionSize, subjectNameDivisionSize, indicationsDictionary, showSubjectId, periodHide, wideTimeline, divisionRowsToShow, vesselSchedules, showVesselScheduleComponents, voyageClickFunctionUUID) {
  this.lR = null;
  this.kC = 0;
  this.kD = 0;
  this.nx = null;
  this.ny = null;
  this.nw = null;
  this.k8 = false;
  this.lK = null;
  this.lI = null;
  this.lJ = null;
  this.lL = null;
  this.lS = null;
  this.iR = 0.0;
  this.iS = 0.0;
  this.lN = null;
  this.lP = false;
  this.lO = null;
  this.lU = false;
  this.lM = null;
  this.lT = null;
  this.lQ = false;
  this.k9 = null;
  this.a1r = false;
  this.a1s = false;
  this.lR = subjectData;
  this.kC = fromDate_$_lo;
  this.kD = fromDate_$_hi;
  this.nx = toDate;
  this.ny = zoomLevel;
  this.nw = scrollOnTime;
  this.k8 = showButtons;
  this.lK = contextMenuFunctionUUID;
  this.lI = clickFunctionUUID;
  this.lJ = clickSubjectButtonParams;
  this.lL = departmentClickFunctionUUID;
  this.lS = verticalDateLines;
  this.iR = leafDivisionSize;
  this.iS = subjectNameDivisionSize;
  this.lN = indicationsDictionary;
  this.lP = showSubjectId;
  this.lO = periodHide;
  this.lU = wideTimeline;
  this.lM = divisionRowsToShow;
  this.lT = vesselSchedules;
  this.lQ = showVesselScheduleComponents;
  this.k9 = voyageClickFunctionUUID;
}
$p = $c_Lcom_papasofokli_planning_PlanningData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningData;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningData() {
}
$h_Lcom_papasofokli_planning_PlanningData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1813305145));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.kC, this.kD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nx));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ny));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nw));
  acc = $m_sr_Statics$().d(acc, (this.k8 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.iR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.iS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lN));
  acc = $m_sr_Statics$().d(acc, (this.lP ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lO));
  acc = $m_sr_Statics$().d(acc, (this.lU ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lT));
  acc = $m_sr_Statics$().d(acc, (this.lQ ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k9));
  return $m_sr_Statics$().an(acc, 21);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_PlanningData)) {
    var x_$_lo = this.kC;
    var x_$_hi = this.kD;
    var $x_14 = x$0;
    var x$1_$_lo = $x_14.kC;
    var x$1_$_hi = $x_14.kD;
    if ((((((((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.k8 === x$0.k8)) && (this.iR === x$0.iR)) && (this.iS === x$0.iS)) && (this.lP === x$0.lP)) && (this.lU === x$0.lU)) && (this.lQ === x$0.lQ))) {
      var x$2 = this.lR;
      var x$2$1 = x$0.lR;
      var $x_13 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$3 = this.nx;
      var x$4 = x$0.nx;
      var $x_12 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$5 = this.ny;
      var x$6 = x$0.ny;
      var $x_11 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$7 = this.nw;
      var x$8 = x$0.nw;
      var $x_10 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$9 = this.lK;
      var x$10 = x$0.lK;
      var $x_9 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$11 = this.lI;
      var x$12 = x$0.lI;
      var $x_8 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$13 = this.lJ;
      var x$14 = x$0.lJ;
      var $x_7 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$15 = this.lL;
      var x$16 = x$0.lL;
      var $x_6 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$17 = this.lS;
      var x$18 = x$0.lS;
      var $x_5 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$19 = this.lN;
      var x$20 = x$0.lN;
      var $x_4 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$21 = this.lO;
      var x$22 = x$0.lO;
      var $x_3 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$23 = this.lM;
      var x$24 = x$0.lM;
      var $x_2 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$25 = this.lT;
      var x$26 = x$0.lT;
      var $x_1 = ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$27 = this.k9;
      var x$28 = x$0.k9;
      return ((x$27 === null) ? (x$28 === null) : x$27.b(x$28));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 21;
});
$p.A = (function() {
  return "PlanningData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.lR;
      break;
    }
    case 1: {
      return $bL(this.kC, this.kD);
      break;
    }
    case 2: {
      return this.nx;
      break;
    }
    case 3: {
      return this.ny;
      break;
    }
    case 4: {
      return this.nw;
      break;
    }
    case 5: {
      return this.k8;
      break;
    }
    case 6: {
      return this.lK;
      break;
    }
    case 7: {
      return this.lI;
      break;
    }
    case 8: {
      return this.lJ;
      break;
    }
    case 9: {
      return this.lL;
      break;
    }
    case 10: {
      return this.lS;
      break;
    }
    case 11: {
      return this.iR;
      break;
    }
    case 12: {
      return this.iS;
      break;
    }
    case 13: {
      return this.lN;
      break;
    }
    case 14: {
      return this.lP;
      break;
    }
    case 15: {
      return this.lO;
      break;
    }
    case 16: {
      return this.lU;
      break;
    }
    case 17: {
      return this.lM;
      break;
    }
    case 18: {
      return this.lT;
      break;
    }
    case 19: {
      return this.lQ;
      break;
    }
    case 20: {
      return this.k9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ay0 = (function() {
  if ((!this.a1s)) {
    var this$1 = this.ny;
    if ((!this$1.c())) {
      var x0 = this$1.h();
      var $x_2 = $uJ(x0);
      var p$2_$_lo = $x_2.l;
      var p$2_$_hi = $x_2.h;
      var $x_1 = (((((4 ^ p$2_$_lo) | p$2_$_hi) === 0) || (((5 ^ p$2_$_lo) | p$2_$_hi) === 0)) || (((7 ^ p$2_$_lo) | p$2_$_hi) === 0));
    } else {
      var $x_1 = false;
    }
    this.a1r = $x_1;
    this.a1s = true;
  }
  return this.a1r;
});
function $isArrayOf_Lcom_papasofokli_planning_PlanningData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fe)));
}
var $d_Lcom_papasofokli_planning_PlanningData = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningData, "com.papasofokli.planning.PlanningData", ({
  fe: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningPeriodChange(periodId_$_lo, periodId_$_hi, vesselPositionId_$_lo, vesselPositionId_$_hi, fromDate_$_lo, fromDate_$_hi, toDate_$_lo, toDate_$_hi, explanation, removed) {
  this.ov = 0;
  this.ow = 0;
  this.qy = 0;
  this.qz = 0;
  this.u9 = 0;
  this.ua = 0;
  this.ub = 0;
  this.uc = 0;
  this.sl = null;
  this.sm = false;
  this.ov = periodId_$_lo;
  this.ow = periodId_$_hi;
  this.qy = vesselPositionId_$_lo;
  this.qz = vesselPositionId_$_hi;
  this.u9 = fromDate_$_lo;
  this.ua = fromDate_$_hi;
  this.ub = toDate_$_lo;
  this.uc = toDate_$_hi;
  this.sl = explanation;
  this.sm = removed;
}
$p = $c_Lcom_papasofokli_planning_PlanningPeriodChange.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningPeriodChange;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningPeriodChange() {
}
$h_Lcom_papasofokli_planning_PlanningPeriodChange.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 28978414);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ov, this.ow));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.qy, this.qz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.u9, this.ua));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ub, this.uc));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sl));
  acc = $m_sr_Statics$().d(acc, (this.sm ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 6);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_PlanningPeriodChange)) {
    var x_$_lo = this.ov;
    var x_$_hi = this.ow;
    var $x_4 = x$0;
    var x$1_$_lo = $x_4.ov;
    var x$1_$_hi = $x_4.ow;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.qy;
      var x$2_$_hi = this.qz;
      var $x_5 = x$0;
      var x$3_$_lo = $x_5.qy;
      var x$3_$_hi = $x_5.qz;
      var $x_3 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$4_$_lo = this.u9;
      var x$4_$_hi = this.ua;
      var $x_6 = x$0;
      var x$5_$_lo = $x_6.u9;
      var x$5_$_hi = $x_6.ua;
      var $x_2 = (((x$4_$_lo ^ x$5_$_lo) | (x$4_$_hi ^ x$5_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$6_$_lo = this.ub;
      var x$6_$_hi = this.uc;
      var $x_7 = x$0;
      var x$7_$_lo = $x_7.ub;
      var x$7_$_hi = $x_7.uc;
      var $x_1 = (((x$6_$_lo ^ x$7_$_lo) | (x$6_$_hi ^ x$7_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.sm === x$0.sm))) {
      return (this.sl === x$0.sl);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "PlanningPeriodChange";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.ov, this.ow);
      break;
    }
    case 1: {
      return $bL(this.qy, this.qz);
      break;
    }
    case 2: {
      return $bL(this.u9, this.ua);
      break;
    }
    case 3: {
      return $bL(this.ub, this.uc);
      break;
    }
    case 4: {
      return this.sl;
      break;
    }
    case 5: {
      return this.sm;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_PlanningPeriodChange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ff)));
}
var $d_Lcom_papasofokli_planning_PlanningPeriodChange = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningPeriodChange, "com.papasofokli.planning.PlanningPeriodChange", ({
  ff: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowClickData(rowUUID, rowDataSeq) {
  this.AM = null;
  this.AL = null;
  this.AM = rowUUID;
  this.AL = rowDataSeq;
}
$p = $c_Lcom_papasofokli_planning_RowClickData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowClickData;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowClickData() {
}
$h_Lcom_papasofokli_planning_RowClickData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1693070263, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_RowClickData)) {
    var x = this.AM;
    var x$2 = x$0.AM;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.AL;
      var x$4 = x$0.AL;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "RowClickData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.AM;
  }
  if ((n === 1)) {
    return this.AL;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_RowClickData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fg)));
}
var $d_Lcom_papasofokli_planning_RowClickData = new $TypeData().i($c_Lcom_papasofokli_planning_RowClickData, "com.papasofokli.planning.RowClickData", ({
  fg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowData(rowId, subjectId_$_lo, subjectId_$_hi, leafData) {
  this.sn = null;
  this.zc = 0;
  this.zd = 0;
  this.wL = null;
  this.sn = rowId;
  this.zc = subjectId_$_lo;
  this.zd = subjectId_$_hi;
  this.wL = leafData;
}
$p = $c_Lcom_papasofokli_planning_RowData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowData;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowData() {
}
$h_Lcom_papasofokli_planning_RowData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1244252028));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sn));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.zc, this.zd));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wL));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_RowData)) {
    var x_$_lo = this.zc;
    var x_$_hi = this.zd;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.zc;
    var x$1_$_hi = $x_2.zd;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.sn;
      var x$2$1 = x$0.sn;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.wL;
      var x$4 = x$0.wL;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "RowData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sn;
      break;
    }
    case 1: {
      return $bL(this.zc, this.zd);
      break;
    }
    case 2: {
      return this.wL;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_RowData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fh)));
}
var $d_Lcom_papasofokli_planning_RowData = new $TypeData().i($c_Lcom_papasofokli_planning_RowData, "com.papasofokli.planning.RowData", ({
  fh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowPeriodKey(rowId, periods) {
  this.EZ = null;
  this.EY = null;
  this.EZ = rowId;
  this.EY = periods;
}
$p = $c_Lcom_papasofokli_planning_RowPeriodKey.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowPeriodKey;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowPeriodKey() {
}
$h_Lcom_papasofokli_planning_RowPeriodKey.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-874657028), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_RowPeriodKey)) {
    var x = this.EZ;
    var x$2 = x$0.EZ;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.EY;
      var x$4 = x$0.EY;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "RowPeriodKey";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.EZ;
  }
  if ((n === 1)) {
    return this.EY;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_RowPeriodKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fi)));
}
var $d_Lcom_papasofokli_planning_RowPeriodKey = new $TypeData().i($c_Lcom_papasofokli_planning_RowPeriodKey, "com.papasofokli.planning.RowPeriodKey", ({
  fi: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectButtonParameters(funUUId, icon, tooltipText) {
  this.wM = null;
  this.wN = null;
  this.so = null;
  this.wM = funUUId;
  this.wN = icon;
  this.so = tooltipText;
}
$p = $c_Lcom_papasofokli_planning_SubjectButtonParameters.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectButtonParameters;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectButtonParameters() {
}
$h_Lcom_papasofokli_planning_SubjectButtonParameters.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1493772030), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_SubjectButtonParameters)) {
    var x = this.wM;
    var x$2 = x$0.wM;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.wN;
      var x$4 = x$0.wN;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.so;
      var x$6 = x$0.so;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "SubjectButtonParameters";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.wM;
      break;
    }
    case 1: {
      return this.wN;
      break;
    }
    case 2: {
      return this.so;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_SubjectButtonParameters(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fj)));
}
var $d_Lcom_papasofokli_planning_SubjectButtonParameters = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectButtonParameters, "com.papasofokli.planning.SubjectButtonParameters", ({
  fj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectJS(subjectId, shortName, fullName, extraInfoText, icon, href, showButtonInd) {
  this.nA = null;
  this.sp = null;
  this.nz = null;
  this.lV = null;
  this.i5 = null;
  this.ka = null;
  this.lW = false;
  this.nA = subjectId;
  this.sp = shortName;
  this.nz = fullName;
  this.lV = extraInfoText;
  this.i5 = icon;
  this.ka = href;
  this.lW = showButtonInd;
}
$p = $c_Lcom_papasofokli_planning_SubjectJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectJS() {
}
$h_Lcom_papasofokli_planning_SubjectJS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-2032409771));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nA));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sp));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.i5));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ka));
  acc = $m_sr_Statics$().d(acc, (this.lW ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_SubjectJS)) {
    if ((this.lW === x$0.lW)) {
      var x = this.nA;
      var x$2 = x$0.nA;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ((($x_3 && (this.sp === x$0.sp)) && (this.nz === x$0.nz))) {
      var x$3 = this.lV;
      var x$4 = x$0.lV;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.i5;
      var x$6 = x$0.i5;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.ka;
      var x$8 = x$0.ka;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "SubjectJS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nA;
      break;
    }
    case 1: {
      return this.sp;
      break;
    }
    case 2: {
      return this.nz;
      break;
    }
    case 3: {
      return this.lV;
      break;
    }
    case 4: {
      return this.i5;
      break;
    }
    case 5: {
      return this.ka;
      break;
    }
    case 6: {
      return this.lW;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_SubjectJS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fk)));
}
var $d_Lcom_papasofokli_planning_SubjectJS = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectJS, "com.papasofokli.planning.SubjectJS", ({
  fk: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectPlanningData(subject, periodsJS, detailedPlanningRows, isExpandable, initialClassStyle) {
  this.pm = null;
  this.pl = null;
  this.kb = null;
  this.nB = false;
  this.lX = null;
  this.pm = subject;
  this.pl = periodsJS;
  this.kb = detailedPlanningRows;
  this.nB = isExpandable;
  this.lX = initialClassStyle;
}
$p = $c_Lcom_papasofokli_planning_SubjectPlanningData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectPlanningData;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectPlanningData() {
}
$h_Lcom_papasofokli_planning_SubjectPlanningData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1073144787);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pm));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pl));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.kb));
  acc = $m_sr_Statics$().d(acc, (this.nB ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lX));
  return $m_sr_Statics$().an(acc, 5);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_SubjectPlanningData)) {
    if ((this.nB === x$0.nB)) {
      var x = this.pm;
      var x$2 = x$0.pm;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.pl;
      var x$4 = x$0.pl;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.kb;
      var x$6 = x$0.kb;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.lX === x$0.lX);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "SubjectPlanningData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pm;
      break;
    }
    case 1: {
      return this.pl;
      break;
    }
    case 2: {
      return this.kb;
      break;
    }
    case 3: {
      return this.nB;
      break;
    }
    case 4: {
      return this.lX;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_SubjectPlanningData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fl)));
}
var $d_Lcom_papasofokli_planning_SubjectPlanningData = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectPlanningData, "com.papasofokli.planning.SubjectPlanningData", ({
  fl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SvgColor(red, green, blue, opacity) {
  this.nE = 0;
  this.nD = 0;
  this.nC = 0;
  this.pn = 0.0;
  this.nE = red;
  this.nD = green;
  this.nC = blue;
  this.pn = opacity;
}
$p = $c_Lcom_papasofokli_planning_SvgColor.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SvgColor;
/** @constructor */
function $h_Lcom_papasofokli_planning_SvgColor() {
}
$h_Lcom_papasofokli_planning_SvgColor.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1010285697));
  acc = $m_sr_Statics$().d(acc, this.nE);
  acc = $m_sr_Statics$().d(acc, this.nD);
  acc = $m_sr_Statics$().d(acc, this.nC);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pn));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_planning_SvgColor) && ((((this.nE === x$0.nE) && (this.nD === x$0.nD)) && (this.nC === x$0.nC)) && (this.pn === x$0.pn))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "SvgColor";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nE;
      break;
    }
    case 1: {
      return this.nD;
      break;
    }
    case 2: {
      return this.nC;
      break;
    }
    case 3: {
      return this.pn;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_SvgColor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fm)));
}
var $d_Lcom_papasofokli_planning_SvgColor = new $TypeData().i($c_Lcom_papasofokli_planning_SvgColor, "com.papasofokli.planning.SvgColor", ({
  fm: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_UUIDRowWithPeriod(rowUUID, period) {
  this.po = null;
  this.dX = null;
  this.po = rowUUID;
  this.dX = period;
}
$p = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod;
/** @constructor */
function $h_Lcom_papasofokli_planning_UUIDRowWithPeriod() {
}
$h_Lcom_papasofokli_planning_UUIDRowWithPeriod.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1785579919), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_UUIDRowWithPeriod)) {
    var x = this.po;
    var x$2 = x$0.po;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.dX;
      var x$4 = x$0.dX;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "UUIDRowWithPeriod";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.po;
  }
  if ((n === 1)) {
    return this.dX;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_UUIDRowWithPeriod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fn)));
}
var $d_Lcom_papasofokli_planning_UUIDRowWithPeriod = new $TypeData().i($c_Lcom_papasofokli_planning_UUIDRowWithPeriod, "com.papasofokli.planning.UUIDRowWithPeriod", ({
  fn: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VerticalDateLine(date_$_lo, date_$_hi, text, cssClass, id) {
  this.ud = 0;
  this.ue = 0;
  this.sr = null;
  this.sq = null;
  this.lY = null;
  this.ud = date_$_lo;
  this.ue = date_$_hi;
  this.sr = text;
  this.sq = cssClass;
  this.lY = id;
}
$p = $c_Lcom_papasofokli_planning_VerticalDateLine.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VerticalDateLine;
/** @constructor */
function $h_Lcom_papasofokli_planning_VerticalDateLine() {
}
$h_Lcom_papasofokli_planning_VerticalDateLine.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 711378552);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ud, this.ue));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sr));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sq));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lY));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_VerticalDateLine)) {
    var x_$_lo = this.ud;
    var x_$_hi = this.ue;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.ud;
    var x$1_$_hi = $x_1.ue;
    if ((((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.sr === x$0.sr)) && (this.sq === x$0.sq))) {
      var x$2 = this.lY;
      var x$2$1 = x$0.lY;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "VerticalDateLine";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.ud, this.ue);
      break;
    }
    case 1: {
      return this.sr;
      break;
    }
    case 2: {
      return this.sq;
      break;
    }
    case 3: {
      return this.lY;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_VerticalDateLine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fo)));
}
var $d_Lcom_papasofokli_planning_VerticalDateLine = new $TypeData().i($c_Lcom_papasofokli_planning_VerticalDateLine, "com.papasofokli.planning.VerticalDateLine", ({
  fo: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VesselScheduleJS(id_$_lo, id_$_hi, voyageId_$_lo, voyageId_$_hi, vesselId_$_lo, vesselId_$_hi, vesselName, sailingType, portName, voyageNumber, from_$_lo, from_$_hi, to_$_lo, to_$_hi, remarks, customCss) {
  this.ze = 0;
  this.zf = 0;
  this.zi = 0;
  this.zj = 0;
  this.zg = 0;
  this.zh = 0;
  this.pq = null;
  this.st = null;
  this.pp = null;
  this.su = null;
  this.kE = 0;
  this.kF = 0;
  this.ox = 0;
  this.oy = 0;
  this.wO = null;
  this.ss = null;
  this.ze = id_$_lo;
  this.zf = id_$_hi;
  this.zi = voyageId_$_lo;
  this.zj = voyageId_$_hi;
  this.zg = vesselId_$_lo;
  this.zh = vesselId_$_hi;
  this.pq = vesselName;
  this.st = sailingType;
  this.pp = portName;
  this.su = voyageNumber;
  this.kE = from_$_lo;
  this.kF = from_$_hi;
  this.ox = to_$_lo;
  this.oy = to_$_hi;
  this.wO = remarks;
  this.ss = customCss;
}
$p = $c_Lcom_papasofokli_planning_VesselScheduleJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VesselScheduleJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_VesselScheduleJS() {
}
$h_Lcom_papasofokli_planning_VesselScheduleJS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-42022634));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ze, this.zf));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.zi, this.zj));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.zg, this.zh));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pq));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.st));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pp));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.su));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.kE, this.kF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.ox, this.oy));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ss));
  return $m_sr_Statics$().an(acc, 11);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_VesselScheduleJS)) {
    var x_$_lo = this.ze;
    var x_$_hi = this.zf;
    var $x_6 = x$0;
    var x$1_$_lo = $x_6.ze;
    var x$1_$_hi = $x_6.zf;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.zi;
      var x$2_$_hi = this.zj;
      var $x_7 = x$0;
      var x$3_$_lo = $x_7.zi;
      var x$3_$_hi = $x_7.zj;
      var $x_5 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$4_$_lo = this.zg;
      var x$4_$_hi = this.zh;
      var $x_8 = x$0;
      var x$5_$_lo = $x_8.zg;
      var x$5_$_hi = $x_8.zh;
      var $x_4 = (((x$4_$_lo ^ x$5_$_lo) | (x$4_$_hi ^ x$5_$_hi)) === 0);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$6_$_lo = this.kE;
      var x$6_$_hi = this.kF;
      var $x_9 = x$0;
      var x$7_$_lo = $x_9.kE;
      var x$7_$_hi = $x_9.kF;
      var $x_3 = (((x$6_$_lo ^ x$7_$_lo) | (x$6_$_hi ^ x$7_$_hi)) === 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$8_$_lo = this.ox;
      var x$8_$_hi = this.oy;
      var $x_10 = x$0;
      var x$9_$_lo = $x_10.ox;
      var x$9_$_hi = $x_10.oy;
      var $x_2 = (((x$8_$_lo ^ x$9_$_lo) | (x$8_$_hi ^ x$9_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ((((($x_2 && (this.pq === x$0.pq)) && (this.st === x$0.st)) && (this.pp === x$0.pp)) && (this.su === x$0.su))) {
      var x$10 = this.wO;
      var x$2$1 = x$0.wO;
      var $x_1 = ((x$10 === null) ? (x$2$1 === null) : x$10.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3$1 = this.ss;
      var x$4$1 = x$0.ss;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 11;
});
$p.A = (function() {
  return "VesselScheduleJS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.ze, this.zf);
      break;
    }
    case 1: {
      return $bL(this.zi, this.zj);
      break;
    }
    case 2: {
      return $bL(this.zg, this.zh);
      break;
    }
    case 3: {
      return this.pq;
      break;
    }
    case 4: {
      return this.st;
      break;
    }
    case 5: {
      return this.pp;
      break;
    }
    case 6: {
      return this.su;
      break;
    }
    case 7: {
      return $bL(this.kE, this.kF);
      break;
    }
    case 8: {
      return $bL(this.ox, this.oy);
      break;
    }
    case 9: {
      return this.wO;
      break;
    }
    case 10: {
      return this.ss;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_VesselScheduleJS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fp)));
}
var $d_Lcom_papasofokli_planning_VesselScheduleJS = new $TypeData().i($c_Lcom_papasofokli_planning_VesselScheduleJS, "com.papasofokli.planning.VesselScheduleJS", ({
  fp: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData(leafDivisionSize, subjectNameDivisionSize, periodsHeight, departmentWidth, totalDepartmentWidth, timeLine, periodSvgIndicationsSetup, clickSubjectButtonParams, getAllRelevantPeriods, clickDepartmentFunction, fixSvgHeight, addPeriodsToRow, cleanRow, getRowSeamanPeriods, hoverRectAppear, hoverRectHide, getRowsForSubjectId, showSubjectId, getSubjectIdByPosition, divisionRowsToShow, voyageClickFunctionUUID, windowStartMs_$_lo, windowStartMs_$_hi, windowEndMs_$_lo, windowEndMs_$_hi) {
  this.sw = 0.0;
  this.sy = 0.0;
  this.eW = 0.0;
  this.kc = 0.0;
  this.pr = 0.0;
  this.nG = null;
  this.sx = null;
  this.AT = null;
  this.AU = null;
  this.AS = null;
  this.wQ = null;
  this.AQ = null;
  this.AR = null;
  this.sv = null;
  this.wR = null;
  this.nF = null;
  this.AV = null;
  this.AX = false;
  this.AW = null;
  this.wP = null;
  this.AY = null;
  this.Dz = 0;
  this.DA = 0;
  this.Dx = 0;
  this.Dy = 0;
  this.OY = 0.0;
  this.sw = leafDivisionSize;
  this.sy = subjectNameDivisionSize;
  this.eW = periodsHeight;
  this.kc = departmentWidth;
  this.pr = totalDepartmentWidth;
  this.nG = timeLine;
  this.sx = periodSvgIndicationsSetup;
  this.AT = clickSubjectButtonParams;
  this.AU = getAllRelevantPeriods;
  this.AS = clickDepartmentFunction;
  this.wQ = fixSvgHeight;
  this.AQ = addPeriodsToRow;
  this.AR = cleanRow;
  this.sv = getRowSeamanPeriods;
  this.wR = hoverRectAppear;
  this.nF = hoverRectHide;
  this.AV = getRowsForSubjectId;
  this.AX = showSubjectId;
  this.AW = getSubjectIdByPosition;
  this.wP = divisionRowsToShow;
  this.AY = voyageClickFunctionUUID;
  this.Dz = windowStartMs_$_lo;
  this.DA = windowStartMs_$_hi;
  this.Dx = windowEndMs_$_lo;
  this.Dy = windowEndMs_$_hi;
  this.OY = Math.fround((Math.fround((leafDivisionSize + subjectNameDivisionSize)) + totalDepartmentWidth));
}
$p = $c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData() {
}
$h_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1749336580);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.sw));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.sy));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.eW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.kc));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pr));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nG));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sx));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sv));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AV));
  acc = $m_sr_Statics$().d(acc, (this.AX ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wP));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.Dz, this.DA));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.Dx, this.Dy));
  return $m_sr_Statics$().an(acc, 23);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData)) {
    if (((((((this.sw === x$0.sw) && (this.sy === x$0.sy)) && (this.eW === x$0.eW)) && (this.kc === x$0.kc)) && (this.pr === x$0.pr)) && (this.AX === x$0.AX))) {
      var x_$_lo = this.Dz;
      var x_$_hi = this.DA;
      var $x_17 = x$0;
      var x$1_$_lo = $x_17.Dz;
      var x$1_$_hi = $x_17.DA;
      var $x_16 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$2_$_lo = this.Dx;
      var x$2_$_hi = this.Dy;
      var $x_18 = x$0;
      var x$3_$_lo = $x_18.Dx;
      var x$3_$_hi = $x_18.Dy;
      var $x_15 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$4 = this.nG;
      var x$2$1 = x$0.nG;
      var $x_14 = ((x$4 === null) ? (x$2$1 === null) : x$4.b(x$2$1));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$3$1 = this.sx;
      var x$4$1 = x$0.sx;
      var $x_13 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$5 = this.AT;
      var x$6 = x$0.AT;
      var $x_12 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$7 = this.AU;
      var x$8 = x$0.AU;
      var $x_11 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$9 = this.AS;
      var x$10 = x$0.AS;
      var $x_10 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$11 = this.wQ;
      var x$12 = x$0.wQ;
      var $x_9 = ((x$11 === null) ? (x$12 === null) : (x$11 === x$12));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$13 = this.AQ;
      var x$14 = x$0.AQ;
      var $x_8 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$15 = this.AR;
      var x$16 = x$0.AR;
      var $x_7 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$17 = this.sv;
      var x$18 = x$0.sv;
      var $x_6 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$19 = this.wR;
      var x$20 = x$0.wR;
      var $x_5 = ((x$19 === null) ? (x$20 === null) : (x$19 === x$20));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$21 = this.nF;
      var x$22 = x$0.nF;
      var $x_4 = ((x$21 === null) ? (x$22 === null) : (x$21 === x$22));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$23 = this.AV;
      var x$24 = x$0.AV;
      var $x_3 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$25 = this.AW;
      var x$26 = x$0.AW;
      var $x_2 = ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$27 = this.wP;
      var x$28 = x$0.wP;
      var $x_1 = ((x$27 === null) ? (x$28 === null) : x$27.b(x$28));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$29 = this.AY;
      var x$30 = x$0.AY;
      return ((x$29 === null) ? (x$30 === null) : x$29.b(x$30));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 23;
});
$p.A = (function() {
  return "DepartmentCreatorFixedData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sw;
      break;
    }
    case 1: {
      return this.sy;
      break;
    }
    case 2: {
      return this.eW;
      break;
    }
    case 3: {
      return this.kc;
      break;
    }
    case 4: {
      return this.pr;
      break;
    }
    case 5: {
      return this.nG;
      break;
    }
    case 6: {
      return this.sx;
      break;
    }
    case 7: {
      return this.AT;
      break;
    }
    case 8: {
      return this.AU;
      break;
    }
    case 9: {
      return this.AS;
      break;
    }
    case 10: {
      return this.wQ;
      break;
    }
    case 11: {
      return this.AQ;
      break;
    }
    case 12: {
      return this.AR;
      break;
    }
    case 13: {
      return this.sv;
      break;
    }
    case 14: {
      return this.wR;
      break;
    }
    case 15: {
      return this.nF;
      break;
    }
    case 16: {
      return this.AV;
      break;
    }
    case 17: {
      return this.AX;
      break;
    }
    case 18: {
      return this.AW;
      break;
    }
    case 19: {
      return this.wP;
      break;
    }
    case 20: {
      return this.AY;
      break;
    }
    case 21: {
      return $bL(this.Dz, this.DA);
      break;
    }
    case 22: {
      return $bL(this.Dx, this.Dy);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fr)));
}
var $d_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData = new $TypeData().i($c_Lcom_papasofokli_planning_api_DepartmentCreatorFixedData, "com.papasofokli.planning.api.DepartmentCreatorFixedData", ({
  fr: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_MergedPortBlock(startMs_$_lo, startMs_$_hi, endMs_$_lo, endMs_$_hi, ports, customCss) {
  this.zk = 0;
  this.zl = 0;
  this.DB = 0;
  this.DC = 0;
  this.ps = null;
  this.B2 = null;
  this.zk = startMs_$_lo;
  this.zl = startMs_$_hi;
  this.DB = endMs_$_lo;
  this.DC = endMs_$_hi;
  this.ps = ports;
  this.B2 = customCss;
}
$p = $c_Lcom_papasofokli_planning_api_MergedPortBlock.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_MergedPortBlock;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_MergedPortBlock() {
}
$h_Lcom_papasofokli_planning_api_MergedPortBlock.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1435445920);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.zk, this.zl));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.DB, this.DC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ps));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.B2));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_MergedPortBlock)) {
    var x_$_lo = this.zk;
    var x_$_hi = this.zl;
    var $x_3 = x$0;
    var x$1_$_lo = $x_3.zk;
    var x$1_$_hi = $x_3.zl;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.DB;
      var x$2_$_hi = this.DC;
      var $x_4 = x$0;
      var x$3_$_lo = $x_4.DB;
      var x$3_$_hi = $x_4.DC;
      var $x_2 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$4 = this.ps;
      var x$2$1 = x$0.ps;
      var $x_1 = ((x$4 === null) ? (x$2$1 === null) : x$4.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3$1 = this.B2;
      var x$4$1 = x$0.B2;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "MergedPortBlock";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.zk, this.zl);
      break;
    }
    case 1: {
      return $bL(this.DB, this.DC);
      break;
    }
    case 2: {
      return this.ps;
      break;
    }
    case 3: {
      return this.B2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_MergedPortBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fu)));
}
var $d_Lcom_papasofokli_planning_api_MergedPortBlock = new $TypeData().i($c_Lcom_papasofokli_planning_api_MergedPortBlock, "com.papasofokli.planning.api.MergedPortBlock", ({
  fu: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_planning_api_PeriodSvgSetup__makeElement__Lcom_papasofokli_planning_IndicationsDictionary__sci_Seq($thiz, ind) {
  return new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row planner-tooltip", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n((ind.nr.g() + " col-sm-1 i-extra-padding"), $m_Lscalatags_JsDom$all$().s)])), $m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-10", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(ind.wF))]))])), $m_sci_Nil$());
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PeriodSvgSetup(indicationsDictionary, contextMenuFunctionUUID, clickFunctionUUID, showHoursMinutes) {
  this.B7 = null;
  this.x3 = null;
  this.x2 = null;
  this.x4 = false;
  this.Pr = null;
  this.Ps = null;
  this.Pq = null;
  this.B7 = indicationsDictionary;
  this.x3 = contextMenuFunctionUUID;
  this.x2 = clickFunctionUUID;
  this.x4 = showHoursMinutes;
  this.Pr = indicationsDictionary.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2) => {
    var x = ind$2.lE;
    var x$2 = $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$().a18;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return true;
    } else {
      var x$3 = ind$2.lE;
      var x$4 = $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$().OU;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    }
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2$1) => {
    var htmlText = $p_Lcom_papasofokli_planning_api_PeriodSvgSetup__makeElement__Lcom_papasofokli_planning_IndicationsDictionary__sci_Seq(this, ind$2$1);
    return new $c_T2(ind$2$1.nr, htmlText);
  }))).fd($m_s_$less$colon$less$().b0);
  this.Ps = indicationsDictionary.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2$2) => {
    var x$1 = ind$2$2.lE;
    var x$2$1 = $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$().a19;
    if (((x$1 === null) ? (x$2$1 === null) : x$1.b(x$2$1))) {
      return true;
    } else {
      var x$3$1 = ind$2$2.lE;
      var x$4$1 = $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$().OU;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    }
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2$3) => {
    var htmlText$1 = $p_Lcom_papasofokli_planning_api_PeriodSvgSetup__makeElement__Lcom_papasofokli_planning_IndicationsDictionary__sci_Seq(this, ind$2$3);
    return new $c_T2(ind$2$3.nr, htmlText$1);
  }))).fd($m_s_$less$colon$less$().b0);
  this.Pq = indicationsDictionary.fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2$4) => {
    var x$5 = ind$2$4.lE;
    var x$2$2 = $m_Lcom_papasofokli_planning_IndicationsDictionaryAppliedTo$().a17;
    return ((x$5 === null) ? (x$2$2 === null) : x$5.b(x$2$2));
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((ind$2$5) => {
    var htmlText$2 = $p_Lcom_papasofokli_planning_api_PeriodSvgSetup__makeElement__Lcom_papasofokli_planning_IndicationsDictionary__sci_Seq(this, ind$2$5);
    return new $c_T2(ind$2$5.nr, htmlText$2);
  }))).fd($m_s_$less$colon$less$().b0);
}
$p = $c_Lcom_papasofokli_planning_api_PeriodSvgSetup.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_PeriodSvgSetup;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PeriodSvgSetup() {
}
$h_Lcom_papasofokli_planning_api_PeriodSvgSetup.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-920502406));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.B7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.x3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.x2));
  acc = $m_sr_Statics$().d(acc, (this.x4 ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_PeriodSvgSetup)) {
    if ((this.x4 === x$0.x4)) {
      var x = this.B7;
      var x$2 = x$0.B7;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.x3;
      var x$4 = x$0.x3;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.x2;
      var x$6 = x$0.x2;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "PeriodSvgSetup";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.B7;
      break;
    }
    case 1: {
      return this.x3;
      break;
    }
    case 2: {
      return this.x2;
      break;
    }
    case 3: {
      return this.x4;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_PeriodSvgSetup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fx)));
}
var $d_Lcom_papasofokli_planning_api_PeriodSvgSetup = new $TypeData().i($c_Lcom_papasofokli_planning_api_PeriodSvgSetup, "com.papasofokli.planning.api.PeriodSvgSetup", ({
  fx: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VesselInfoPair(vesselName, voyageBlocks, portBlocks) {
  this.Be = null;
  this.Bf = null;
  this.Bd = null;
  this.Be = vesselName;
  this.Bf = voyageBlocks;
  this.Bd = portBlocks;
}
$p = $c_Lcom_papasofokli_planning_api_VesselInfoPair.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VesselInfoPair;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VesselInfoPair() {
}
$h_Lcom_papasofokli_planning_api_VesselInfoPair.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-66294726), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_VesselInfoPair)) {
    if ((this.Be === x$0.Be)) {
      var x = this.Bf;
      var x$2 = x$0.Bf;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Bd;
      var x$4 = x$0.Bd;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "VesselInfoPair";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Be;
      break;
    }
    case 1: {
      return this.Bf;
      break;
    }
    case 2: {
      return this.Bd;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_VesselInfoPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fz)));
}
var $d_Lcom_papasofokli_planning_api_VesselInfoPair = new $TypeData().i($c_Lcom_papasofokli_planning_api_VesselInfoPair, "com.papasofokli.planning.api.VesselInfoPair", ({
  fz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig(rowHeight, vesselGroupSpacing, leftTextXOffset, rectTopMargin, minCellWidth, minWidthForText, estimatedCharWidth, textVerticalOffset, textHorizontalPadding, maxPortNameLength, rowsPerSchedule) {
  this.i7 = 0.0;
  this.xe = 0.0;
  this.xa = 0.0;
  this.xb = 0.0;
  this.Bi = 0.0;
  this.Bj = 0.0;
  this.pw = 0.0;
  this.px = 0.0;
  this.xd = 0.0;
  this.Bh = 0;
  this.xc = 0;
  this.i7 = rowHeight;
  this.xe = vesselGroupSpacing;
  this.xa = leftTextXOffset;
  this.xb = rectTopMargin;
  this.Bi = minCellWidth;
  this.Bj = minWidthForText;
  this.pw = estimatedCharWidth;
  this.px = textVerticalOffset;
  this.xd = textHorizontalPadding;
  this.Bh = maxPortNameLength;
  this.xc = rowsPerSchedule;
}
$p = $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig() {
}
$h_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 368345263);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.i7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xe));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xa));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xb));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Bi));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Bj));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pw));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.px));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xd));
  acc = $m_sr_Statics$().d(acc, this.Bh);
  acc = $m_sr_Statics$().d(acc, this.xc);
  return $m_sr_Statics$().an(acc, 11);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig) && (((((((((((this.i7 === x$0.i7) && (this.xe === x$0.xe)) && (this.xa === x$0.xa)) && (this.xb === x$0.xb)) && (this.Bi === x$0.Bi)) && (this.Bj === x$0.Bj)) && (this.pw === x$0.pw)) && (this.px === x$0.px)) && (this.xd === x$0.xd)) && (this.Bh === x$0.Bh)) && (this.xc === x$0.xc))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 11;
});
$p.A = (function() {
  return "VesselScheduleConfig";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.i7;
      break;
    }
    case 1: {
      return this.xe;
      break;
    }
    case 2: {
      return this.xa;
      break;
    }
    case 3: {
      return this.xb;
      break;
    }
    case 4: {
      return this.Bi;
      break;
    }
    case 5: {
      return this.Bj;
      break;
    }
    case 6: {
      return this.pw;
      break;
    }
    case 7: {
      return this.px;
      break;
    }
    case 8: {
      return this.xd;
      break;
    }
    case 9: {
      return this.Bh;
      break;
    }
    case 10: {
      return this.xc;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fA)));
}
var $d_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig = new $TypeData().i($c_Lcom_papasofokli_planning_api_VesselScheduleHelpers$VesselScheduleConfig, "com.papasofokli.planning.api.VesselScheduleHelpers$VesselScheduleConfig", ({
  fA: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_VoyageBlock(voyageNumber, vesselName, sailingType, startMs_$_lo, startMs_$_hi, endMs_$_lo, endMs_$_hi) {
  this.nL = null;
  this.Bl = null;
  this.Bk = null;
  this.uf = 0;
  this.ug = 0;
  this.zm = 0;
  this.zn = 0;
  this.nL = voyageNumber;
  this.Bl = vesselName;
  this.Bk = sailingType;
  this.uf = startMs_$_lo;
  this.ug = startMs_$_hi;
  this.zm = endMs_$_lo;
  this.zn = endMs_$_hi;
}
$p = $c_Lcom_papasofokli_planning_api_VoyageBlock.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_VoyageBlock;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_VoyageBlock() {
}
$h_Lcom_papasofokli_planning_api_VoyageBlock.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1512485774);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bl));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bk));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.uf, this.ug));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.zm, this.zn));
  return $m_sr_Statics$().an(acc, 5);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_VoyageBlock)) {
    var x_$_lo = this.uf;
    var x_$_hi = this.ug;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.uf;
    var x$1_$_hi = $x_2.ug;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.zm;
      var x$2_$_hi = this.zn;
      var $x_3 = x$0;
      var x$3_$_lo = $x_3.zm;
      var x$3_$_hi = $x_3.zn;
      var $x_1 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.nL === x$0.nL)) && (this.Bl === x$0.Bl))) {
      return (this.Bk === x$0.Bk);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "VoyageBlock";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nL;
      break;
    }
    case 1: {
      return this.Bl;
      break;
    }
    case 2: {
      return this.Bk;
      break;
    }
    case 3: {
      return $bL(this.uf, this.ug);
      break;
    }
    case 4: {
      return $bL(this.zm, this.zn);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_planning_api_VoyageBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fC)));
}
var $d_Lcom_papasofokli_planning_api_VoyageBlock = new $TypeData().i($c_Lcom_papasofokli_planning_api_VoyageBlock, "com.papasofokli.planning.api.VoyageBlock", ({
  fC: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_popover_PopoverSetupData(title, content, html, sanitize, customClass, placement, dismissible, tabIndex) {
  this.sO = null;
  this.sN = null;
  this.m2 = false;
  this.m4 = false;
  this.m1 = null;
  this.m3 = null;
  this.xf = false;
  this.xg = 0;
  this.sO = title;
  this.sN = content;
  this.m2 = html;
  this.m4 = sanitize;
  this.m1 = customClass;
  this.m3 = placement;
  this.xf = dismissible;
  this.xg = tabIndex;
}
$p = $c_Lcom_papasofokli_popover_PopoverSetupData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_popover_PopoverSetupData;
/** @constructor */
function $h_Lcom_papasofokli_popover_PopoverSetupData() {
}
$h_Lcom_papasofokli_popover_PopoverSetupData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1767061822));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sN));
  acc = $m_sr_Statics$().d(acc, (this.m2 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.m4 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.m1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.m3));
  acc = $m_sr_Statics$().d(acc, (this.xf ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, this.xg);
  return $m_sr_Statics$().an(acc, 8);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_popover_PopoverSetupData) && ((((((((this.m2 === x$0.m2) && (this.m4 === x$0.m4)) && (this.xf === x$0.xf)) && (this.xg === x$0.xg)) && (this.sO === x$0.sO)) && (this.sN === x$0.sN)) && (this.m1 === x$0.m1)) && (this.m3 === x$0.m3))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 8;
});
$p.A = (function() {
  return "PopoverSetupData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sO;
      break;
    }
    case 1: {
      return this.sN;
      break;
    }
    case 2: {
      return this.m2;
      break;
    }
    case 3: {
      return this.m4;
      break;
    }
    case 4: {
      return this.m1;
      break;
    }
    case 5: {
      return this.m3;
      break;
    }
    case 6: {
      return this.xf;
      break;
    }
    case 7: {
      return this.xg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_popover_PopoverSetupData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fD)));
}
var $d_Lcom_papasofokli_popover_PopoverSetupData = new $TypeData().i($c_Lcom_papasofokli_popover_PopoverSetupData, "com.papasofokli.popover.PopoverSetupData", ({
  fD: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingInitialData(initialValue, selections, disabled, icon) {
  this.nN = null;
  this.pA = null;
  this.kd = false;
  this.sQ = null;
  this.nN = initialValue;
  this.pA = selections;
  this.kd = disabled;
  this.sQ = icon;
}
$p = $c_Lcom_papasofokli_rating_RatingInitialData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingInitialData;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingInitialData() {
}
$h_Lcom_papasofokli_rating_RatingInitialData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-339838191));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pA));
  acc = $m_sr_Statics$().d(acc, (this.kd ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sQ));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_rating_RatingInitialData)) {
    if ((this.kd === x$0.kd)) {
      var x = this.nN;
      var x$2 = x$0.nN;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.pA;
      var x$4 = x$0.pA;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.sQ;
      var x$6 = x$0.sQ;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "RatingInitialData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nN;
      break;
    }
    case 1: {
      return this.pA;
      break;
    }
    case 2: {
      return this.kd;
      break;
    }
    case 3: {
      return this.sQ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_rating_RatingInitialData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fG)));
}
var $d_Lcom_papasofokli_rating_RatingInitialData = new $TypeData().i($c_Lcom_papasofokli_rating_RatingInitialData, "com.papasofokli.rating.RatingInitialData", ({
  fG: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableConnectedListsData(leftSide, rightSide) {
  this.Fk = null;
  this.Fl = null;
  this.Fk = leftSide;
  this.Fl = rightSide;
}
$p = $c_Lcom_papasofokli_sortable_SortableConnectedListsData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableConnectedListsData;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableConnectedListsData() {
}
$h_Lcom_papasofokli_sortable_SortableConnectedListsData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1149259330), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_sortable_SortableConnectedListsData)) {
    var x = this.Fk;
    var x$2 = x$0.Fk;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.Fl;
      var x$4 = x$0.Fl;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "SortableConnectedListsData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Fk;
  }
  if ((n === 1)) {
    return this.Fl;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_sortable_SortableConnectedListsData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fH)));
}
var $d_Lcom_papasofokli_sortable_SortableConnectedListsData = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableConnectedListsData, "com.papasofokli.sortable.SortableConnectedListsData", ({
  fH: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData(leftTitle, rightTitle, leftListItems, rightListItems, leftListUpdateFun, rightListUpdateFun, contextMenuFun, blockedItemsIds, blockedItemsMessage) {
  this.xl = null;
  this.xn = null;
  this.sS = null;
  this.sT = null;
  this.xk = null;
  this.xm = null;
  this.ke = null;
  this.xj = null;
  this.nO = null;
  this.xl = leftTitle;
  this.xn = rightTitle;
  this.sS = leftListItems;
  this.sT = rightListItems;
  this.xk = leftListUpdateFun;
  this.xm = rightListUpdateFun;
  this.ke = contextMenuFun;
  this.xj = blockedItemsIds;
  this.nO = blockedItemsMessage;
}
$p = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData() {
}
$h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1943228285), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData)) {
    if (((this.xl === x$0.xl) && (this.xn === x$0.xn))) {
      var x = this.sS;
      var x$2 = x$0.sS;
      var $x_6 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.sT;
      var x$4 = x$0.sT;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.xk;
      var x$6 = x$0.xk;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.xm;
      var x$8 = x$0.xm;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.ke;
      var x$10 = x$0.ke;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.xj;
      var x$12 = x$0.xj;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.nO;
      var x$14 = x$0.nO;
      return ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 9;
});
$p.A = (function() {
  return "SortableConnectedListsSetupData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.xl;
      break;
    }
    case 1: {
      return this.xn;
      break;
    }
    case 2: {
      return this.sS;
      break;
    }
    case 3: {
      return this.sT;
      break;
    }
    case 4: {
      return this.xk;
      break;
    }
    case 5: {
      return this.xm;
      break;
    }
    case 6: {
      return this.ke;
      break;
    }
    case 7: {
      return this.xj;
      break;
    }
    case 8: {
      return this.nO;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_sortable_SortableConnectedListsSetupData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fI)));
}
var $d_Lcom_papasofokli_sortable_SortableConnectedListsSetupData = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData, "com.papasofokli.sortable.SortableConnectedListsSetupData", ({
  fI: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableElement(recordId_$_lo, recordId_$_hi, name, description) {
  this.h9 = 0;
  this.ha = 0;
  this.iV = null;
  this.m5 = null;
  this.h9 = recordId_$_lo;
  this.ha = recordId_$_hi;
  this.iV = name;
  this.m5 = description;
}
$p = $c_Lcom_papasofokli_sortable_SortableElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableElement;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableElement() {
}
$h_Lcom_papasofokli_sortable_SortableElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1002175428);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.h9, this.ha));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.m5));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_sortable_SortableElement)) {
    var x_$_lo = this.h9;
    var x_$_hi = this.ha;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.h9;
    var x$1_$_hi = $x_1.ha;
    if (((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.iV === x$0.iV))) {
      var x$2 = this.m5;
      var x$2$1 = x$0.m5;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "SortableElement";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.h9, this.ha);
      break;
    }
    case 1: {
      return this.iV;
      break;
    }
    case 2: {
      return this.m5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_sortable_SortableElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fJ)));
}
var $d_Lcom_papasofokli_sortable_SortableElement = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableElement, "com.papasofokli.sortable.SortableElement", ({
  fJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_util_IconWithStyle__stylesString__T($thiz) {
  if ((!$thiz.a8S)) {
    $thiz.a8R = (((((($thiz.Gj.g() + " ") + $thiz.Gi.g()) + " ") + $thiz.Gh.g()) + " ") + $thiz.Gf);
    $thiz.a8S = true;
  }
  return $thiz.a8R;
}
/** @constructor */
function $c_Lcom_papasofokli_util_IconWithStyle(icon, size, iconType, iconRotation, extraCss) {
  this.Gg = null;
  this.Gj = null;
  this.Gi = null;
  this.Gh = null;
  this.Gf = null;
  this.a8R = null;
  this.a8S = false;
  this.Gg = icon;
  this.Gj = size;
  this.Gi = iconType;
  this.Gh = iconRotation;
  this.Gf = extraCss;
}
$p = $c_Lcom_papasofokli_util_IconWithStyle.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_IconWithStyle;
/** @constructor */
function $h_Lcom_papasofokli_util_IconWithStyle() {
}
$h_Lcom_papasofokli_util_IconWithStyle.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1134991124, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_util_IconWithStyle)) {
    var x = this.Gg;
    var x$2 = x$0.Gg;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.Gj;
      var x$4 = x$0.Gj;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Gi;
      var x$6 = x$0.Gi;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Gh;
      var x$8 = x$0.Gh;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Gf === x$0.Gf);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "IconWithStyle";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Gg;
      break;
    }
    case 1: {
      return this.Gj;
      break;
    }
    case 2: {
      return this.Gi;
      break;
    }
    case 3: {
      return this.Gh;
      break;
    }
    case 4: {
      return this.Gf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.g = (function() {
  return ((this.Gg.by + " ") + $p_Lcom_papasofokli_util_IconWithStyle__stylesString__T(this));
});
function $isArrayOf_Lcom_papasofokli_util_IconWithStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g8)));
}
var $d_Lcom_papasofokli_util_IconWithStyle = new $TypeData().i($c_Lcom_papasofokli_util_IconWithStyle, "com.papasofokli.util.IconWithStyle", ({
  g8: 1,
  b: 1,
  c: 1,
  a: 1
}));
class $c_Ljava_io_IOException extends $c_jl_Exception {
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cn)));
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
$p = $c_Ljava_io_OutputStream.prototype = new $h_O();
$p.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
$h_Ljava_io_OutputStream.prototype = $p;
function $ct_jl_AssertionError__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_AssertionError__O__($thiz, detailMessage) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, ("" + detailMessage), ((detailMessage instanceof $c_jl_Throwable) ? detailMessage : null), true, true);
  return $thiz;
}
class $c_jl_AssertionError extends $c_jl_Error {
}
var $d_jl_AssertionError = new $TypeData().i($c_jl_AssertionError, "java.lang.AssertionError", ({
  tv: 1,
  bQ: 1,
  F: 1,
  a: 1
}));
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237);
}
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : ($thiz ? 1 : (-1)));
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gg)));
}
var $d_jl_Boolean = new $TypeData().i(0, "java.lang.Boolean", ({
  gg: 1,
  a: 1,
  N: 1,
  aJ: 1
}), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  return ((that instanceof $Char) && ($thiz === that.c));
}
function $f_jl_Character__toString__T($thiz) {
  return ("" + $cToS($thiz));
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  return (($thiz - o.c) | 0);
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gi)));
}
var $d_jl_Character = new $TypeData().i(0, "java.lang.Character", ({
  gi: 1,
  a: 1,
  N: 1,
  aJ: 1
}), ((x) => (x instanceof $Char)));
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.tD)));
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.tH)));
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
var $d_jl_RuntimeException = new $TypeData().i($c_jl_RuntimeException, "java.lang.RuntimeException", ({
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.xW = builder;
  return $thiz;
}
function $ct_jl_StringBuffer__($thiz) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuffer() {
  this.xW = null;
}
$p = $c_jl_StringBuffer.prototype = new $h_O();
$p.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
}
$h_jl_StringBuffer.prototype = $p;
$p.F = (function() {
  return this.xW.F();
});
$p.qD = (function(index) {
  return this.xW.qD(index);
});
$p.afE = (function(s) {
  var this$1 = this.xW;
  this$1.aC = (("" + this$1.aC) + s);
  return this;
});
$p.aml = (function(str, offset, len) {
  this.xW.amm(str, offset, len);
  return this;
});
$p.EC = (function(start, end) {
  return this.xW.VD(start, end);
});
$p.g = (function() {
  return this.xW.aC;
});
$p.Id = (function(csq) {
  return this.afE(csq);
});
var $d_jl_StringBuffer = new $TypeData().i($c_jl_StringBuffer, "java.lang.StringBuffer", ({
  tS: 1,
  aO: 1,
  bb: 1,
  a: 1
}));
function $ct_jl_StringBuilder__($thiz) {
  $thiz.aC = "";
  return $thiz;
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  $thiz.aC = str;
  return $thiz;
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.aC = null;
}
$p = $c_jl_StringBuilder.prototype = new $h_O();
$p.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
}
$h_jl_StringBuilder.prototype = $p;
$p.afF = (function(str) {
  var str$1 = $m_jl_String$().hg(str, 0, str.a.length);
  this.aC = (("" + this.aC) + str$1);
  return this;
});
$p.amm = (function(str, offset, len) {
  var length = str.a.length;
  var endOffset = ((offset + len) | 0);
  if (((((offset | len) | endOffset) | ((length - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(offset, len, length);
  }
  var str$1 = $m_jl_String$().hg(str, offset, len);
  this.aC = (("" + this.aC) + str$1);
  return this;
});
$p.g = (function() {
  return this.aC;
});
$p.F = (function() {
  return this.aC.length;
});
$p.qD = (function(index) {
  return this.aC.charCodeAt(index);
});
$p.ahp = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V(this.aC, srcBegin, srcEnd, dst, dstBegin);
});
$p.axP = (function(index, ch) {
  var oldContent = this.aC;
  var $x_1 = oldContent.substring(0, index);
  var beginIndex = ((1 + index) | 0);
  this.aC = (($x_1 + $cToS(ch)) + oldContent.substring(beginIndex));
});
$p.EC = (function(start, end) {
  return this.VD(start, end);
});
$p.VD = (function(start, end) {
  var this$1 = this.aC;
  return this$1.substring(start, end);
});
$p.Id = (function(csq) {
  this.aC = (("" + this.aC) + csq);
  return this;
});
var $d_jl_StringBuilder = new $TypeData().i($c_jl_StringBuilder, "java.lang.StringBuilder", ({
  tT: 1,
  aO: 1,
  bb: 1,
  a: 1
}));
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.tW)));
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gu)));
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value_$_lo, value_$_hi) {
  if (((value_$_lo | ((-2147483648) ^ value_$_hi)) === 0)) {
    return 19;
  } else {
    var $x_2 = $m_ju_Arrays$();
    var $x_1 = $m_Ljava_math_BigDecimal$().Gq;
    var sign = (value_$_hi >> 31);
    var xlo = (value_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((value_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var index = $x_2.amY($x_1, rlo, rhi);
    return ((index < 0) ? (~index) : ((1 + index) | 0));
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.q0;
  var discardedPrecision = (($thiz.Es() - mcPrecision) | 0);
  if ((!((($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0)) || (discardedPrecision <= 0)))) {
    if (($thiz.fg < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision);
    } else {
      var $x_1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $x_1.uA(discardedPrecision, hi);
      var integerAndFraction = $thiz.fP().agF(sizeOfFraction);
      var value = $thiz.bd;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
      if ((integerAndFraction.a[1].aX !== 0)) {
        var absBi = integerAndFraction.a[1].afp();
        var compRem = absBi.axX().ur(sizeOfFraction);
        var parityBit = (integerAndFraction.a[0].Nz(0) | 0);
        var frac = Math.imul(integerAndFraction.a[1].aX, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().ahY(parityBit, frac, mc.y0);
        if ((carry !== 0)) {
          var $x_2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $x_2.iy(carry, hi$4);
          integerAndFraction.a[0] = $m_Ljava_math_Elementary$().I8(integerAndFraction.a[0], bi);
        }
        if (($ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.a[0]).Es() > mcPrecision)) {
          integerAndFraction.a[0] = integerAndFraction.a[0].U5($m_Ljava_math_BigInteger$().pY);
          var lo$1 = ((lo - 1) | 0);
          var hi$5 = ((((hi$3 - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
          var newScale_$_lo = lo$1;
          var newScale_$_hi = hi$5;
        } else {
          var newScale_$_lo = lo;
          var newScale_$_hi = hi$3;
        }
      } else {
        var newScale_$_lo = lo;
        var newScale_$_hi = hi$3;
      }
      $thiz.bd = $m_Ljava_math_BigDecimal$().IS(newScale_$_lo, newScale_$_hi);
      $thiz.t9 = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.a[0]);
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.fg === 0)) {
    var x_$_lo = $thiz.eu;
    var x_$_hi = $thiz.ev;
    return (((~x_$_lo) | (~x_$_hi)) !== 0);
  } else {
    return false;
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var $x_1 = $m_Ljava_math_BigDecimal$().Gq.a;
  var $x_2 = (discardedPrecision << 1);
  var sizeOfFraction_$_lo = $x_1[$x_2];
  var sizeOfFraction_$_hi = $x_1[(($x_2 + 1) | 0)];
  var value = $thiz.bd;
  var hi = (value >> 31);
  var hi$1 = (discardedPrecision >> 31);
  var lo = ((value - discardedPrecision) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
  var unscaledVal_$_lo = $thiz.eu;
  var unscaledVal_$_hi = $thiz.ev;
  var $x_3 = $m_RTLong$().agD(unscaledVal_$_lo, unscaledVal_$_hi, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
  var intPart0_$_lo = $x_3.l;
  var intPart0_$_hi = $x_3.h;
  var a0 = (65535 & sizeOfFraction_$_lo);
  var a1 = ((sizeOfFraction_$_lo >>> 16) | 0);
  var b0 = (65535 & intPart0_$_lo);
  var b1 = ((intPart0_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(sizeOfFraction_$_lo, intPart0_$_hi) + Math.imul(sizeOfFraction_$_hi, intPart0_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((unscaledVal_$_lo - lo$1) | 0);
  var hi$4 = ((((unscaledVal_$_hi - hi$3) | 0) - (((lo$2 >>> 0) > (unscaledVal_$_lo >>> 0)) | 0)) | 0);
  if (((lo$2 | hi$4) !== 0)) {
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var sign = (hi$4 >> 31);
    var xlo = (lo$2 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$4 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var lo$3 = (rlo << 1);
    var hi$5 = (((rlo >>> 31) | 0) | (rhi << 1));
    var compRem = $x_4.avG(lo$3, hi$5, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
    var frac = Math.imul(((hi$4 >> 31) | ((((((-hi$4) | 0) - ((((-lo$2) | 0) !== 0) | 0)) | 0) >>> 31) | 0)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().ahY((1 & intPart0_$_lo), frac, mc.y0);
    var hi$8 = (value$1 >> 31);
    var lo$8 = ((intPart0_$_lo + value$1) | 0);
    var hi$9 = ((((intPart0_$_hi + hi$8) | 0) + (((lo$8 >>> 0) < (intPart0_$_lo >>> 0)) | 0)) | 0);
    var sign$1 = (hi$9 >> 31);
    var xlo$1 = (lo$8 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$9 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var a = ((4.294967296E9 * rhi$1) + (rlo$1 >>> 0.0));
    if (((+Math.log10(a)) >= mc.q0)) {
      var lo$9 = ((lo - 1) | 0);
      var hi$10 = ((((hi$2 - 1) | 0) + ((lo$9 !== (-1)) | 0)) | 0);
      var sign$2 = (hi$9 >> 31);
      var xlo$2 = (lo$8 ^ sign$2);
      var rlo$2 = ((xlo$2 - sign$2) | 0);
      var rhi$2 = (((hi$9 ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
      var quotHi = (((rhi$2 >>> 0) / 10) | 0);
      var k = ((rhi$2 - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo$2 >>> 0.0))) | 0.0);
      if ((hi$9 < 0)) {
        var lo$10 = ((-quotLo) | 0);
        var hi$11 = ((((-quotHi) | 0) - ((lo$10 !== 0) | 0)) | 0);
        var _2_$_lo = lo$10;
        var _2_$_hi = hi$11;
      } else {
        var _2_$_lo = quotLo;
        var _2_$_hi = quotHi;
      }
      var x1___1 = $bL(lo$9, hi$10);
      var x1___2 = $bL(_2_$_lo, _2_$_hi);
    } else {
      var x1___1 = $bL(lo, hi$2);
      var x1___2 = $bL(lo$8, hi$9);
    }
  } else {
    var x1___1 = $bL(lo, hi$2);
    var x1___2 = $bL(intPart0_$_lo, intPart0_$_hi);
  }
  var $x_5 = $uJ(x1___1);
  var newScale_$_lo = $x_5.l;
  var newScale_$_hi = $x_5.h;
  var $x_6 = $uJ(x1___2);
  var intPart_$_lo = $x_6.l;
  var intPart_$_hi = $x_6.h;
  $thiz.bd = $m_Ljava_math_BigDecimal$().IS(newScale_$_lo, newScale_$_hi);
  $thiz.t9 = mc.q0;
  $thiz.eu = intPart_$_lo;
  $thiz.ev = intPart_$_hi;
  $thiz.fg = $m_Ljava_math_BigDecimal$().Ip(intPart_$_lo, intPart_$_hi);
  $thiz.t8 = null;
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.bd;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  if (((hi$3 === 0) ? ((lo$1 >>> 0) > 19) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.aka();
  if (($m_Ljava_math_BitLevel$().DQ(bigInteger) < bitLengthOfType)) {
    return bigInteger.jw();
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.t9 > 0) ? $thiz.t9 : ((1 + $doubleToInt((0.3010299956639812 * (($thiz.fg - 1) | 0)))) | 0));
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.t8 = unscaledVal;
  $thiz.fg = $m_Ljava_math_BitLevel$().DQ(unscaledVal);
  if (($thiz.fg < 64)) {
    var $x_1 = unscaledVal.jw();
    $thiz.eu = $x_1.l;
    $thiz.ev = $x_1.h;
  }
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.xZ = null;
  $thiz.ma = 0;
  $thiz.fg = 0;
  $thiz.eu = 0;
  $thiz.ev = 0;
  $thiz.bd = 0;
  $thiz.t9 = 0;
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue_$_lo, smallValue_$_hi, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.eu = smallValue_$_lo;
  $thiz.ev = smallValue_$_hi;
  $thiz.bd = scale;
  $thiz.fg = $m_Ljava_math_BigDecimal$().Ip(smallValue_$_lo, smallValue_$_hi);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.eu = smallValue;
  $thiz.ev = hi;
  $thiz.bd = scale;
  $thiz.fg = $m_Ljava_math_BigDecimal$().avF(smallValue);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var endOffset = ((offset + len) | 0);
  var last = ((endOffset - 1) | 0);
  if (((((offset | len) | endOffset) | ((in$1.a.length - endOffset) | 0)) < 0)) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.a.length));
  }
  var index = offset;
  if (((offset <= last) && (in$1.a[offset] === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().N2(in$1.a[index], new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.g()));
    }
  } else {
    var isMinus = ((index <= last) && (in$1.a[index] === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().N2(in$1.a[((1 + index) | 0)], new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.g()));
    }
  }
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().ahX(in$1.a[index], new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if ((in$1.a[index] === 48)) {
        counter = ((1 + counter) | 0);
      } else {
        wasNonZero = true;
      }
    }
    index = ((1 + index) | 0);
  }
  var u = $m_jl_String$().hg(in$1, begin, ((index - begin) | 0));
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.a[index] === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().ahX(in$1.a[index], new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if ((in$1.a[index] === 48)) {
          counter = ((1 + counter) | 0);
        } else {
          wasNonZero = true;
        }
      }
      index = ((1 + index) | 0);
    }
    $thiz.bd = ((index - begin$2) | 0);
    var x1___1 = (("" + u) + $m_jl_String$().hg(in$1, begin$2, $thiz.bd));
    var x1___2 = ((b + $thiz.bd) | 0);
  } else {
    $thiz.bd = 0;
    var x1___1 = u;
    var x1___2 = b;
  }
  var unscaled = x1___1;
  var bufLength = (x1___2 | 0);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().N2(in$1.a[index], new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.a[index] === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.a[((1 + index) | 0)] !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var scaleString = $m_jl_String$().hg(in$1, begin$3, ((((1 + last) | 0) - begin$3) | 0));
    var value = $thiz.bd;
    var hi = (value >> 31);
    var value$1 = $m_jl_Integer$().c7(scaleString, 10, 214748364);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
    $thiz.bd = lo;
    var value$2 = $thiz.bd;
    if ((((lo ^ value$2) | (hi$2 ^ (value$2 >> 31))) !== 0)) {
      throw new $c_jl_NumberFormatException("Scale out of range");
    }
  }
  if ((bufLength < 19)) {
    var $x_1 = $m_jl_Long$().V5(unscaled, 10);
    $thiz.eu = $x_1.l;
    $thiz.ev = $x_1.h;
    $thiz.fg = $m_Ljava_math_BigDecimal$().Ip($thiz.eu, $thiz.ev);
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled));
  }
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.bd = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.xZ = null;
  this.ma = 0;
  this.t8 = null;
  this.fg = 0;
  this.eu = 0;
  this.ev = 0;
  this.bd = 0;
  this.t9 = 0;
}
$p = $c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$p.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
$h_Ljava_math_BigDecimal.prototype = $p;
$p.ajM = (function() {
  if ((this.fg < 64)) {
    var x_$_lo = this.eu;
    var x_$_hi = this.ev;
    if ((x_$_hi < 0)) {
      return (-1);
    } else {
      var x$1_$_lo = this.eu;
      var x$1_$_hi = this.ev;
      return (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0)) | 0);
    }
  } else {
    return this.fP().aX;
  }
});
$p.Es = (function() {
  if ((this.t9 === 0)) {
    if ((this.fg === 0)) {
      var $x_1 = 1;
    } else if ((this.fg < 64)) {
      var $x_1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.eu, this.ev);
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * ((this.fg - 1) | 0)))) | 0);
      var $x_3 = this.fP();
      var $x_2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      if (($x_3.U5($x_2.uA(decimalDigits, hi)).aX !== 0)) {
        var $x_1 = ((1 + decimalDigits) | 0);
      } else {
        var $x_1 = decimalDigits;
      }
    }
    this.t9 = $x_1;
  }
  return this.t9;
});
$p.axI = (function(n) {
  var value = this.bd;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
  if ((this.fg < 64)) {
    var x_$_lo = this.eu;
    var x_$_hi = this.ev;
    if (((x_$_lo | x_$_hi) === 0)) {
      return $m_Ljava_math_BigDecimal$().avH(lo, hi$2);
    } else {
      return $m_Ljava_math_BigDecimal$().aku(this.eu, this.ev, $m_Ljava_math_BigDecimal$().IS(lo, hi$2));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.fP(), $m_Ljava_math_BigDecimal$().IS(lo, hi$2));
  }
});
$p.ak2 = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return $m_Ljava_math_BigDecimal$().a9h;
  } else {
    var lastPow = (($m_Ljava_math_Multiplication$().tc.a.length - 1) | 0);
    var i = 1;
    var strippedBI = this.fP();
    var value = this.bd;
    var hi = (value >> 31);
    var scale_$_lo = value;
    var scale_$_hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.Nz(0))) {
        var qr = strippedBI.agG($m_Ljava_math_Multiplication$().tc.a[i]);
        if ((qr.QU.aX === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.QT;
          var x_$_lo = scale_$_lo;
          var x_$_hi = scale_$_hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var lo = ((x_$_lo - value$1) | 0);
          var hi$2 = ((((x_$_hi - hi$1) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
          i = temp$i;
          strippedBI = temp$strippedBI;
          scale_$_lo = lo;
          scale_$_hi = hi$2;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var x1___1 = strippedBI;
        var x1___2 = $bL(scale_$_lo, scale_$_hi);
        break;
      } else {
        var x1___1 = strippedBI;
        var x1___2 = $bL(scale_$_lo, scale_$_hi);
        break;
      }
    }
    var strippedBI$1 = x1___1;
    var $x_1 = $uJ(x1___2);
    var newScale_$_lo = $x_1.l;
    var newScale_$_hi = $x_1.h;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().IS(newScale_$_lo, newScale_$_hi));
  }
});
$p.It = (function(bi) {
  var thisSign = this.ajM();
  var valueSign = bi.ajM();
  if ((thisSign === valueSign)) {
    if ((((this.bd === bi.bd) && (this.fg < 64)) && (bi.fg < 64))) {
      var x_$_lo = this.eu;
      var x_$_hi = this.ev;
      var x$1_$_lo = bi.eu;
      var x$1_$_hi = bi.ev;
      if (((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi))) {
        return (-1);
      } else {
        var x$2_$_lo = this.eu;
        var x$2_$_hi = this.ev;
        var x$3_$_lo = bi.eu;
        var x$3_$_hi = bi.ev;
        return (((x$2_$_hi === x$3_$_hi) ? ((x$2_$_lo >>> 0) > (x$3_$_lo >>> 0)) : (x$2_$_hi > x$3_$_hi)) | 0);
      }
    } else {
      var value = this.bd;
      var hi = (value >> 31);
      var value$1 = bi.bd;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) - (((lo >>> 0) > (value >>> 0)) | 0)) | 0);
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((hi$2 + ((lo$1 === 0) | 0)) | 0);
      if (((hi$3 === hi$4) ? ((diffPrecision >>> 0) > (lo$1 >>> 0)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = ((lo - 1) | 0);
        var hi$6 = ((((hi$2 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
        if (((hi$5 === hi$6) ? ((diffPrecision >>> 0) < (lo$2 >>> 0)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.fP();
          var v = bi.fP();
          if ((hi$2 < 0)) {
            var $x_1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((((-hi$2) | 0) - ((lo$3 !== 0) | 0)) | 0);
            var x1___1 = t.hf($x_1.uA(lo$3, hi$7));
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var x1___1 = t;
            var x1___2 = v.hf($m_Ljava_math_Multiplication$().uA(lo, hi$2));
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = x1___1;
          var valUnscaled = x1___2;
          return thisUnscaled.ur(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$p.b = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    if ((x.bd === this.bd)) {
      if ((this.fg < 64)) {
        var $x_1 = x;
        var x$1_$_lo = $x_1.eu;
        var x$1_$_hi = $x_1.ev;
        var x$2_$_lo = this.eu;
        var x$2_$_hi = this.ev;
        return (((x$1_$_lo ^ x$2_$_lo) | (x$1_$_hi ^ x$2_$_hi)) === 0);
      } else {
        return this.t8.b(x.t8);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  if ((this.ma !== 0)) {
    return this.ma;
  } else if ((this.fg < 64)) {
    this.ma = $s_RTLong__toInt__I__I__I(this.eu, this.ev);
    var $x_1 = this.ma;
    var x$1_$_lo = this.eu;
    var x$1_$_hi = this.ev;
    this.ma = ((Math.imul(33, $x_1) + x$1_$_hi) | 0);
    this.ma = ((Math.imul(17, this.ma) + this.bd) | 0);
    return this.ma;
  } else {
    this.ma = ((Math.imul(17, this.t8.r()) + this.bd) | 0);
    return this.ma;
  }
});
$p.g = (function() {
  if ((this.xZ !== null)) {
    return this.xZ;
  } else if ((this.fg < 32)) {
    this.xZ = $m_Ljava_math_Conversion$().ayE(this.eu, this.ev, this.bd);
    return this.xZ;
  } else {
    var intString = $m_Ljava_math_Conversion$().qP(this.fP());
    if ((this.bd === 0)) {
      return intString;
    } else {
      var begin = ((this.fP().aX < 0) ? 2 : 1);
      var end = intString.length;
      var value = this.bd;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((hi$3 - hi$4) | 0) - (((lo$2 >>> 0) > (lo$1 >>> 0)) | 0)) | 0);
      if (((this.bd > 0) && ((hi$5 === (-1)) ? ((lo$2 >>> 0) >= 4294967290) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.bd) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = ((intString.substring(0, pos) + ".") + intString.substring(pos));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = ((begin - 1) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = ((intString.substring(0, pos$1) + "0.") + intString.substring(pos$1));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().a9i;
          var s2Len = (~lo$2);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = s2.substring(0, s2Len);
          var result = ((("" + s.substring(0, pos$2)) + s2$1) + s.substring(pos$2));
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), ((intString.substring(0, begin) + ".") + intString.substring(begin))) : intString);
        var r1 = (r0 + "E");
        var result = ((((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1) + $m_RTLong$().gc(lo$2, hi$5));
      }
      this.xZ = result;
      return this.xZ;
    }
  }
});
$p.NA = (function() {
  if (((this.bd === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.fP();
  } else if ((this.bd < 0)) {
    var $x_2 = this.fP();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.bd;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.hf($x_1.uA(lo, hi$1));
  } else {
    var $x_4 = this.fP();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.bd;
    var hi$2 = (value$1 >> 31);
    return $x_4.U5($x_3.uA(value$1, hi$2));
  }
});
$p.aka = (function() {
  if (((this.bd === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.fP();
  } else if ((this.bd < 0)) {
    var $x_2 = this.fP();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.bd;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) - ((lo !== 0) | 0)) | 0);
    return $x_2.hf($x_1.uA(lo, hi$1));
  } else {
    if (((this.bd > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.bd > this.fP().aht()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = this.fP();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.bd;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $x_4.agF($x_3.uA(value$1, hi$2));
    if ((integerAndFraction.a[1].aX !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    return integerAndFraction.a[0];
  }
});
$p.jw = (function() {
  if (((this.bd <= (-64)) || (this.bd > $p_Ljava_math_BigDecimal__approxPrecision__I(this)))) {
    return $bL(0, 0);
  } else {
    return this.NA().jw();
  }
});
$p.js = (function() {
  return (((this.bd <= (-32)) || (this.bd > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.NA().js());
});
$p.UK = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.axY = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.an3 = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.E3 = (function() {
  return $m_jl_Float$().gL(((this.fP() + "e") + ((-this.bd) | 0)));
});
$p.qG = (function() {
  return $m_jl_Double$().fS(((this.fP() + "e") + ((-this.bd) | 0)));
});
$p.fP = (function() {
  if ((this.t8 === null)) {
    this.t8 = $m_Ljava_math_BigInteger$().iy(this.eu, this.ev);
  }
  return this.t8;
});
$p.jl = (function(o) {
  return this.It(o);
});
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gw)));
}
var $d_Ljava_math_BigDecimal = new $TypeData().i($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  gw: 1,
  aA: 1,
  a: 1,
  N: 1
}));
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  var stringLength0 = s.length;
  if ((s.charCodeAt(0) === 45)) {
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else if ((s.charCodeAt(0) === 43)) {
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0;
  }
  var _sign = (x1___1 | 0);
  var startChar = (x1___2 | 0);
  var stringLength = (x1___3 | 0);
  var i = startChar;
  while ((i < stringLength0)) {
    var value = i;
    var c = s.charCodeAt(value);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $m_Ljava_math_Conversion$().QW.a[radix];
  var bigRadixDigitsLength = ((stringLength / $checkIntDivisor(charsPerInt)) | 0);
  var topChars = ((stringLength % $checkIntDivisor(charsPerInt)) | 0);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().QV.a[((radix - 2) | 0)];
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var this$4 = $m_jl_Integer$();
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = s.substring(beginIndex, endIndex);
    if (((((radix - 2) | 0) >>> 0) > 34)) {
      this$4.iu(s$1);
    }
    var bigRadixDigit = this$4.c7(s$1, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($m_Ljava_math_Multiplication$(), _digits, _digits, digitIndex, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().avc(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.a[digitIndex] = newDigit;
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.aX = _sign;
  $thiz.bb = digitIndex;
  $thiz.aN = _digits;
  $thiz.jm();
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.KG = (-2);
  $thiz.ta = 0;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (((((radix - 2) | 0) >>> 0) > 34)) {
    throw new $c_jl_NumberFormatException("Radix out of range");
  }
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.aX = sign;
  $thiz.bb = 1;
  $thiz.aN = new $ac_I(new Int32Array([value]));
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.a.length === 0)) {
    $thiz.aX = 0;
    $thiz.bb = 1;
    $thiz.aN = new $ac_I(new Int32Array([0]));
  } else {
    $thiz.aX = signum;
    $thiz.bb = digits.a.length;
    $thiz.aN = digits;
    $thiz.jm();
  }
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.aX = sign;
  $thiz.bb = numberLength;
  $thiz.aN = digits;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal_$_lo, lVal_$_hi) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.aX = sign;
  if ((lVal_$_hi === 0)) {
    $thiz.bb = 1;
    $thiz.aN = new $ac_I(new Int32Array([lVal_$_lo]));
  } else {
    $thiz.bb = 2;
    $thiz.aN = new $ac_I(new Int32Array([lVal_$_lo, lVal_$_hi]));
  }
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.aN = null;
  this.bb = 0;
  this.aX = 0;
  this.KG = 0;
  this.ta = 0;
}
$p = $c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$p.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
$h_Ljava_math_BigInteger.prototype = $p;
$p.afp = (function() {
  return ((this.aX < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.bb, this.aN) : this);
});
$p.ur = (function(bi) {
  return ((this.aX > bi.aX) ? 1 : ((this.aX < bi.aX) ? (-1) : ((this.bb > bi.bb) ? this.aX : ((this.bb < bi.bb) ? ((-bi.aX) | 0) : Math.imul(this.aX, $m_Ljava_math_Elementary$().Is(this.aN, bi.aN, this.bb))))));
});
$p.U5 = (function(divisor) {
  if ((divisor.aX === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = divisor.aX;
  if (divisor.avs()) {
    return ((divisor.aX > 0) ? this : this.aiX());
  } else {
    var thisSign = this.aX;
    var thisLen = this.bb;
    var divisorLen = divisor.bb;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var dividend = this.aN.a[0];
      var divisor$1 = divisor.aN.a[0];
      var x = (((dividend >>> 0) / ($checkIntDivisor(divisor$1) >>> 0)) | 0);
      if ((thisSign !== divisorSign)) {
        var lo = ((-x) | 0);
        var hi = ((-((lo !== 0) | 0)) | 0);
        var bi_$_lo = lo;
        var bi_$_hi = hi;
      } else {
        var bi_$_lo = x;
        var bi_$_hi = 0;
      }
      return $m_Ljava_math_BigInteger$().iy(bi_$_lo, bi_$_hi);
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Is(this.aN, divisor.aN, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Cs : $m_Ljava_math_BigInteger$().KH);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().pZ;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().U6(resDigits, this.aN, thisLen, divisor.aN.a[0]);
        } else {
          $m_Ljava_math_Division$().agE(resDigits, resLength, this.aN, thisLen, divisor.aN, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.jm();
        return result;
      }
    }
  }
});
$p.agF = (function(divisor) {
  return this.agG(divisor).ayA();
});
$p.agG = (function(divisor) {
  var divisorSign = divisor.aX;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = divisor.bb;
  var divisorDigits = divisor.aN;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().ath(this, divisorDigits.a[0], divisorSign);
  } else {
    var thisDigits = this.aN;
    var thisLen = this.bb;
    if ((((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().Is(thisDigits, divisorDigits, thisLen)) < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().pZ, this);
    } else {
      var thisSign = this.aX;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().agE(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.jm();
      result1.jm();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$p.b = (function(x) {
  return ((x instanceof $c_Ljava_math_BigInteger) && (((this.aX === x.aX) && (this.bb === x.bb)) && this.aty(x.aN)));
});
$p.aht = (function() {
  if ((this.aX === 0)) {
    return (-1);
  } else {
    var i = this.MM();
    var i$1 = this.aN.a[i];
    return (((i << 5) + ((32 - Math.clz32(((~i$1) & ((i$1 - 1) | 0)))) | 0)) | 0);
  }
});
$p.r = (function() {
  if ((this.ta !== 0)) {
    return this.ta;
  } else {
    var end = this.bb;
    var i = 0;
    while ((i < end)) {
      var value = i;
      this.ta = ((Math.imul(33, this.ta) + this.aN.a[value]) | 0);
      i = ((1 + i) | 0);
    }
    this.ta = Math.imul(this.ta, this.aX);
    return this.ta;
  }
});
$p.js = (function() {
  return Math.imul(this.aX, this.aN.a[0]);
});
$p.jw = (function() {
  if ((this.bb > 1)) {
    var value = this.aN.a[1];
    var value$1 = this.aN.a[0];
    var value$3_$_lo = value$1;
    var value$3_$_hi = value;
  } else {
    var value$2 = this.aN.a[0];
    var value$3_$_lo = value$2;
    var value$3_$_hi = 0;
  }
  var value$4 = this.aX;
  var hi$3 = (value$4 >> 31);
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & value$3_$_lo);
  var b1 = ((value$3_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3_$_hi) + Math.imul(hi$3, value$3_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi$4);
});
$p.hf = (function(bi) {
  return (((bi.aX === 0) || (this.aX === 0)) ? $m_Ljava_math_BigInteger$().pZ : $m_Ljava_math_Multiplication$().N5(this, bi));
});
$p.aiX = (function() {
  return ((this.aX === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.aX) | 0), this.bb, this.aN));
});
$p.qL = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Cs;
  } else if ((((exp === 1) || this.b($m_Ljava_math_BigInteger$().Cs)) || this.b($m_Ljava_math_BigInteger$().pZ))) {
    return this;
  } else if ((!this.Nz(0))) {
    var x = 1;
    while ((!this.Nz(x))) {
      x = ((1 + x) | 0);
    }
    return $m_Ljava_math_BigInteger$().aun(Math.imul(x, exp)).hf(this.Nr(x).qL(exp));
  } else {
    return $m_Ljava_math_Multiplication$().awV(this, exp);
  }
});
$p.kT = (function(n) {
  return (((n === 0) || (this.aX === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().ajH(this, n) : $m_Ljava_math_BitLevel$().ajJ(this, ((-n) | 0))));
});
$p.Nr = (function(n) {
  return (((n === 0) || (this.aX === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().ajJ(this, n) : $m_Ljava_math_BitLevel$().ajH(this, ((-n) | 0))));
});
$p.Nz = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.aN.a[0]) !== 0);
  } else {
    if ((n < 0)) {
      throw new $c_jl_ArithmeticException("Negative bit address");
    }
    if ((intCount >= this.bb)) {
      return (this.aX < 0);
    } else if ((!((this.aX < 0) && (intCount < this.MM())))) {
      var digit = this.aN.a[intCount];
      if ((this.aX < 0)) {
        digit = ((this.MM() === intCount) ? ((-digit) | 0) : (~digit));
      }
      return ((digit & (1 << n)) !== 0);
    } else {
      return false;
    }
  }
});
$p.g = (function() {
  return $m_Ljava_math_Conversion$().qP(this);
});
$p.jm = (function() {
  while (true) {
    if ((this.bb > 0)) {
      this.bb = ((this.bb - 1) | 0);
      if ((this.aN.a[this.bb] === 0)) {
        continue;
      }
    }
    break;
  }
  if ((this.aN.a[this.bb] === 0)) {
    this.aX = 0;
  }
  this.bb = ((1 + this.bb) | 0);
});
$p.aty = (function(b) {
  var i = 0;
  while ((i !== this.bb)) {
    if ((this.aN.a[i] !== b.a[i])) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.MM = (function() {
  if ((this.KG === (-2))) {
    if ((this.aX === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while ((this.aN.a[i] === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.KG = $x_1;
  }
  return this.KG;
});
$p.avs = (function() {
  return ((this.bb === 1) && (this.aN.a[0] === 1));
});
$p.axX = (function() {
  return ((this.aX === 0) ? this : $m_Ljava_math_BitLevel$().axW(this));
});
$p.jl = (function(o) {
  return this.ur(o);
});
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gx)));
}
var $d_Ljava_math_BigInteger = new $TypeData().i($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  gx: 1,
  aA: 1,
  a: 1,
  N: 1
}));
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal);
}
$p = $c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$p.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
$h_Ljava_math_RoundingMode.prototype = $p;
var $d_Ljava_math_RoundingMode = new $TypeData().i($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  ua: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly, _isDirect) {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
  this.td = null;
  this.y1 = 0;
  this.KI = false;
  this.KI = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.eA.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.UW.call(this, _initialLimit);
}
$p = $c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$p.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
}
$h_Ljava_nio_HeapByteBuffer.prototype = $p;
$p.MJ = (function() {
  var p = this.b5;
  if ((p === this.bF)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b5 = ((1 + p) | 0);
  var a = this.td;
  var i = ((this.y1 + p) | 0);
  return a.a[i];
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().i($c_Ljava_nio_HeapByteBuffer, "java.nio.HeapByteBuffer", ({
  ud: 1,
  gB: 1,
  cp: 1,
  N: 1
}));
class $c_Ljava_nio_charset_CoderMalfunctionError extends $c_jl_Error {
  constructor(cause) {
    super();
    $ct_jl_Error__jl_Throwable__(this, cause);
  }
}
var $d_Ljava_nio_charset_CoderMalfunctionError = new $TypeData().i($c_Ljava_nio_charset_CoderMalfunctionError, "java.nio.charset.CoderMalfunctionError", ({
  uk: 1,
  bQ: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_Ljava_security_SecureRandom() {
  this.a9w = null;
  $ct_ju_Random__J__(this, 0, 0);
  this.a9w = $m_Ljava_security_SecureRandom$().avL();
}
$p = $c_Ljava_security_SecureRandom.prototype = new $h_ju_Random();
$p.constructor = $c_Ljava_security_SecureRandom;
/** @constructor */
function $h_Ljava_security_SecureRandom() {
}
$h_Ljava_security_SecureRandom.prototype = $p;
$p.awt = (function(bytes) {
  var len = bytes.a.length;
  var buffer = new Int8Array(len);
  (0, this.a9w)(buffer);
  var i = 0;
  while ((i !== len)) {
    bytes.a[i] = (buffer[i] | 0);
    i = ((1 + i) | 0);
  }
});
var $d_Ljava_security_SecureRandom = new $TypeData().i($c_Ljava_security_SecureRandom, "java.security.SecureRandom", ({
  ut: 1,
  uZ: 1,
  vk: 1,
  a: 1
}));
function $ct_ju_Date__J__($thiz, millis_$_lo, millis_$_hi) {
  $thiz.hG = millis_$_lo;
  $thiz.hH = millis_$_hi;
  return $thiz;
}
function $ct_ju_Date__($thiz) {
  var $x_1 = $m_RTLong$().jq((+Date.now()));
  $ct_ju_Date__J__($thiz, $x_1.l, $x_1.h);
  return $thiz;
}
/** @constructor */
function $c_ju_Date() {
  this.hG = 0;
  this.hH = 0;
}
$p = $c_ju_Date.prototype = new $h_O();
$p.constructor = $c_ju_Date;
/** @constructor */
function $h_ju_Date() {
}
$h_ju_Date.prototype = $p;
$p.b = (function(obj) {
  if ((obj instanceof $c_ju_Date)) {
    var $x_1 = obj;
    var x_$_lo = $x_1.hG;
    var x_$_hi = $x_1.hH;
    var x$1_$_lo = this.hG;
    var x$1_$_hi = this.hH;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.r = (function() {
  var this$1_$_lo = this.hG;
  var this$1_$_hi = this.hH;
  return (this$1_$_lo ^ this$1_$_hi);
});
$p.avM = (function() {
  var x_$_lo = this.hG;
  var x_$_hi = this.hH;
  if (((x_$_hi === (-2011657)) ? ((x_$_lo >>> 0) >= 1025769472) : (x_$_hi > (-2011657)))) {
    var x$1_$_lo = this.hG;
    var x$1_$_hi = this.hH;
    var $x_1 = ((x$1_$_hi === 2011656) ? ((x$1_$_lo >>> 0) <= 3269197824) : (x$1_$_hi < 2011656));
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("cannot convert this java.util.Date (" + $s_RTLong__toString__I__I__T(this.hG, this.hH)) + " millis) to a js.Date"));
  }
  var $x_2 = Date;
  var x$2_$_lo = this.hG;
  var x$2_$_hi = this.hH;
  return new $x_2(((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0)));
});
$p.g = (function() {
  var x_$_lo = this.hG;
  var x_$_hi = this.hH;
  if (((x_$_hi === (-2011657)) ? ((x_$_lo >>> 0) >= 1025769472) : (x_$_hi > (-2011657)))) {
    var x$1_$_lo = this.hG;
    var x$1_$_hi = this.hH;
    var $x_1 = ((x$1_$_hi === 2011656) ? ((x$1_$_lo >>> 0) <= 3269197824) : (x$1_$_hi < 2011656));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var date = this.avM();
    var offset = ((-$doubleToInt((+date.getTimezoneOffset()))) | 0);
    var $x_2 = $m_ju_Date$();
    var sign$1 = (offset >> 31);
    $x_2.Ei((((((offset ^ sign$1) - sign$1) | 0) / 60) | 0));
    var $x_3 = $m_ju_Date$();
    var sign$2 = (offset >> 31);
    $x_3.Ei((((((offset ^ sign$2) - sign$2) | 0) % 60) | 0));
    return (((((((((((($m_ju_Date$().a9x.a[$doubleToInt((+date.getDay()))] + " ") + $m_ju_Date$().a9y.a[$doubleToInt((+date.getMonth()))]) + " ") + $m_ju_Date$().Ei($doubleToInt((+date.getDate())))) + " ") + $m_ju_Date$().Ei($doubleToInt((+date.getHours())))) + ":") + $m_ju_Date$().Ei($doubleToInt((+date.getMinutes())))) + ":") + $m_ju_Date$().Ei($doubleToInt((+date.getSeconds())))) + " GMT ") + $doubleToInt((+date.getFullYear())));
  } else {
    return (("java.util.Date(" + $s_RTLong__toString__I__I__T(this.hG, this.hH)) + ")");
  }
});
$p.jl = (function(o) {
  var x_$_lo = this.hG;
  var x_$_hi = this.hH;
  var $x_1 = o;
  var x$1_$_lo = $x_1.hG;
  var x$1_$_hi = $x_1.hH;
  return ((x_$_hi === x$1_$_hi) ? ((x_$_lo === x$1_$_lo) ? 0 : (((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < x$1_$_hi) ? (-1) : 1));
});
function $isArrayOf_ju_Date(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gE)));
}
var $d_ju_Date = new $TypeData().i($c_ju_Date, "java.util.Date", ({
  gE: 1,
  a: 1,
  P: 1,
  N: 1
}));
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.y2 === null)) {
    $thiz.th = (("" + $thiz.th) + s);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.y2 === null)) {
    $thiz.th = ((("" + $thiz.th) + s1) + s2);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.y2 === null)) {
    $thiz.th = (($thiz.th + (("" + s1) + s2)) + s3);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3]);
  }
}
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = (ss.length | 0);
    var i = 0;
    while ((i !== len)) {
      var t = ss[i];
      $thiz.y2.Id(t);
      i = ((1 + i) | 0);
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_io_IOException))) {
      throw e;
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.R3) {
    throw new $c_ju_FormatterClosedException();
  }
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var fmtLength = format.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var fromIndex = fmtIndex;
    var nextPercentIndex = (format.indexOf("%", fromIndex) | 0);
    if ((nextPercentIndex < 0)) {
      var beginIndex = fmtIndex;
      $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex));
      return $thiz;
    }
    var beginIndex$1 = fmtIndex;
    $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex$1, nextPercentIndex));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().a9E;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ((execResult.index | 0) !== formatSpecifierIndex))) {
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, ((formatSpecifierIndex === fmtLength) ? 37 : format.charCodeAt(formatSpecifierIndex)));
    }
    fmtIndex = (re.lastIndex | 0);
    var index = ((fmtIndex - 1) | 0);
    var conversion$2 = format.charCodeAt(index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, execResult[2], conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648));
    }
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648));
    }
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width);
      }
      if ((flags !== 0)) {
        $thiz.UR(flags);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n");
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.UR(flags);
      }
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((-2) & flags) !== 0)) {
        $thiz.N3(37, flags, (-2));
      }
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%");
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $m_ju_Formatter$().a9D.a[((conversionLower - 97) | 0)];
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2);
      }
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.UR(flags);
      }
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if (((flags & illegalFlags) !== 0)) {
        $thiz.N3(conversionLower, flags, illegalFlags);
      }
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex;
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex;
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i);
          }
          var argIndex = i;
        }
      }
      if (((argIndex <= 0) || (argIndex > args.a.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      lastArgIndex = argIndex;
      var arg = args.a[((argIndex - 1) | 0)];
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null");
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision);
      }
    }
  }
  return $thiz;
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((((conversion - 65) | 0) >>> 0) <= 25) ? 256 : 0);
  var len = flags.length;
  var i = 0;
  while ((i !== len)) {
    var index = i;
    var f = flags.charCodeAt(index);
    switch (f) {
      case 45: {
        var bit = 1;
        break;
      }
      case 35: {
        var bit = 2;
        break;
      }
      case 43: {
        var bit = 4;
        break;
      }
      case 32: {
        var bit = 8;
        break;
      }
      case 48: {
        var bit = 16;
        break;
      }
      case 44: {
        var bit = 32;
        break;
      }
      case 40: {
        var bit = 64;
        break;
      }
      case 60: {
        var bit = 128;
        break;
      }
      default: {
        var bit;
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(f));
      }
    }
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f);
    }
    bits = (bits | bit);
    i = ((1 + i) | 0);
  }
  return bits;
}
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var x = (+parseInt(capture, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2));
  } else {
    return (-1);
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, (((arg === false) || (arg === null)) ? "false" : "true"));
      break;
    }
    case 104: {
      var $x_1 = $m_ju_Formatter$RootLocaleInfo$();
      var i = $dp_hashCode__I(arg);
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $x_1, flags, width, precision, (i >>> 0.0).toString(16));
      break;
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var formattableFlags = (((((1 & flags) !== 0) | 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        arg.aEy($thiz, formattableFlags, width, precision);
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.N3(conversionLower, flags, 2);
        }
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, ("" + arg));
      }
      break;
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var $x_2 = ("" + $cToS($uC(arg)));
      } else {
        if ((!$isInt(arg))) {
          $thiz.IT(conversionLower, arg);
        }
        var x3 = (arg | 0);
        if (((x3 >>> 0) > 1114111)) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3);
        }
        var $x_2 = $m_jl_Character$().EF(x3);
      }
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), $x_2);
      break;
    }
    case 100: {
      if ($isInt(arg)) {
        var $x_3 = ("" + (arg | 0));
      } else if ((arg instanceof $Long)) {
        var $x_4 = $uJ(arg);
        var x3$2_$_lo = $x_4.l;
        var x3$2_$_hi = $x_4.h;
        var $x_3 = $m_RTLong$().gc(x3$2_$_lo, x3$2_$_hi);
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.IT(conversionLower, arg);
        }
        var $x_3 = $m_Ljava_math_Conversion$().qP(arg);
      }
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, $x_3, "");
      break;
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, $m_Ljava_math_Conversion$().amX(arg, (isOctal ? 8 : 16)), prefix);
      } else {
        if ($isInt(arg)) {
          var x2$5 = (arg | 0);
          var str$6 = (isOctal ? (x2$5 >>> 0.0).toString(8) : (x2$5 >>> 0.0).toString(16));
        } else {
          if ((!(arg instanceof $Long))) {
            $thiz.IT(conversionLower, arg);
          }
          var $x_5 = $uJ(arg);
          var x3$3_$_lo = $x_5.l;
          var x3$3_$_hi = $x_5.h;
          var str$6 = (isOctal ? $m_jl_Long$().avB(x3$3_$_lo, x3$3_$_hi) : $m_jl_Long$().ahW(x3$3_$_lo, x3$3_$_hi));
        }
        if (((76 & flags) !== 0)) {
          $thiz.N3(conversionLower, flags, 76);
        }
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6));
      }
      break;
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = (+arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6);
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().avO(x2$6), flags, precision, conversionLower, localeInfo, width);
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().avN(arg), flags, precision, conversionLower, localeInfo, width);
      } else {
        $thiz.IT(conversionLower, arg);
      }
      break;
    }
    case 97: {
      if (((typeof arg) === "number")) {
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, (+arg));
      } else {
        $thiz.IT(conversionLower, arg);
      }
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("Unknown conversion '" + $cToS(conversionLower)) + "' was not rejected earlier"));
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""));
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = x.ajt(((1 + digitsAfterDot) | 0));
  var signStr = (rounded.q1 ? "-" : "");
  var intStr = rounded.q2;
  var fractionalDigitCount = ((intStr.length - 1) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var integerPart = intStr.substring(0, 1);
  var fractionalPart = (("" + intStr.substring(1)) + $m_ju_Formatter$().UQ(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - rounded.nW) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var sign = (exponent >> 31);
  var this$5 = (((exponent ^ sign) - sign) | 0);
  var exponentAbsStr0 = ("" + this$5);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr);
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = x.axR(scale);
  var signStr = (rounded.q1 ? "-" : "");
  var intStr = rounded.q2;
  var intStrLen = intStr.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().UQ(((minDigits - intStrLen) | 0))) + intStr));
  var dotPos = ((expandedIntStr.length - scale) | 0);
  var integerPart = (signStr + expandedIntStr.substring(0, dotPos));
  return (((scale === 0) && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + expandedIntStr.substring(dotPos)));
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = x.ajt(p);
  var orderOfMagnitude = ((((rounded.q2.length - 1) | 0) - rounded.nW) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = ((((p - orderOfMagnitude) | 0) - 1) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep);
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((p - 1) | 0), forceDecimalSep);
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg);
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, arg, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var biasedExponent = (2047 & ((hi >>> 20) | 0));
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo | hi$1) === 0)) {
        var x1___1 = "0";
        var x1___2 = $bL(0, 0);
        var x1___3 = 0;
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = $bL(lo, hi$1);
        var x1___3 = (-1022);
      } else {
        var leadingZeros = ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo)) | 0));
        var shift = ((leadingZeros - 11) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> (~shift)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = $bL(lo$2, hi$3);
        var x1___3 = normalizedExponent;
      }
    } else {
      var _3 = ((biasedExponent - 1023) | 0);
      var x1___1 = "1";
      var x1___2 = $bL(lo, hi$1);
      var x1___3 = _3;
    }
    var implicitBitStr = x1___1;
    var $x_1 = $uJ(x1___2);
    var mantissa_$_lo = $x_1.l;
    var mantissa_$_hi = $x_1.h;
    var exponent = (x1___3 | 0);
    if ((actualPrecision === (-1))) {
      var roundedMantissa_$_lo = mantissa_$_lo;
      var roundedMantissa_$_hi = mantissa_$_hi;
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$3 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$4 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$4 = ((lo$3 - 1) | 0);
      var hi$5 = ((((hi$4 - 1) | 0) + ((lo$4 !== (-1)) | 0)) | 0);
      var lo$5 = (((lo$3 >>> 1) | 0) | (hi$4 << 31));
      var hi$6 = (hi$4 >> 1);
      var lo$6 = (~lo$4);
      var hi$7 = (~hi$5);
      var lo$7 = (mantissa_$_lo & lo$6);
      var hi$8 = (mantissa_$_hi & hi$7);
      var lo$8 = (mantissa_$_lo & lo$4);
      var hi$9 = (mantissa_$_hi & hi$5);
      if (((hi$9 === hi$6) ? ((lo$8 >>> 0) < (lo$5 >>> 0)) : (hi$9 < hi$6))) {
        var roundedMantissa_$_lo = lo$7;
        var roundedMantissa_$_hi = hi$8;
      } else if (((hi$9 === hi$6) ? ((lo$8 >>> 0) > (lo$5 >>> 0)) : (hi$9 > hi$6))) {
        var lo$9 = ((lo$7 + lo$3) | 0);
        var hi$10 = ((((hi$8 + hi$4) | 0) + (((lo$9 >>> 0) < (lo$7 >>> 0)) | 0)) | 0);
        var roundedMantissa_$_lo = lo$9;
        var roundedMantissa_$_hi = hi$10;
      } else if ((((lo$7 & lo$3) | (hi$8 & hi$4)) === 0)) {
        var roundedMantissa_$_lo = lo$7;
        var roundedMantissa_$_hi = hi$8;
      } else {
        var lo$11 = ((lo$7 + lo$3) | 0);
        var hi$12 = ((((hi$8 + hi$4) | 0) + (((lo$11 >>> 0) < (lo$7 >>> 0)) | 0)) | 0);
        var roundedMantissa_$_lo = lo$11;
        var roundedMantissa_$_hi = hi$12;
      }
    }
    var baseStr = $m_jl_Long$().ahW(roundedMantissa_$_lo, roundedMantissa_$_hi);
    var beginIndex = baseStr.length;
    var padded = (("" + "0000000000000".substring(beginIndex)) + baseStr);
    $m_ju_Formatter$();
    if ((!(padded.length === 13))) {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "padded mantissa does not have the right number of bits");
    }
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (((len > minLength) && (padded.charCodeAt(((len - 1) | 0)) === 48))) {
      len = ((len - 1) | 0);
    }
    var endIndex = len;
    var mantissaStr = padded.substring(0, endIndex);
    var exponentStr = ("" + exponent);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, (signStr + (((256 & flags) !== 0) ? "0X" : "0x")), $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr)));
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, (((precision >>> 0) >= (str.length >>> 0)) ? str : str.substring(0, precision))));
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")))));
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  if (((str.length >= width) && ((110 & flags) === 0))) {
    $p_ju_Formatter__sendToDest__T__V($thiz, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else {
    if ((str.charCodeAt(0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str;
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str;
      } else {
        var x1___1 = "";
        var x1___2 = str;
      }
    } else if (((64 & flags) !== 0)) {
      var x1___1 = "(";
      var x1___2 = (str.substring(1) + ")");
    } else {
      var x1___1 = "-";
      var x1___2 = str.substring(1);
    }
    var numberPrefix = x1___1;
    var rest0 = x1___2;
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, (("" + numberPrefix) + basePrefix), $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0)));
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  var len = s.length;
  var index = 0;
  while (((index !== len) && ((((s.charCodeAt(index) - 48) | 0) >>> 0) <= 9))) {
    index = ((1 + index) | 0);
  }
  index = ((index - 3) | 0);
  if ((index <= 0)) {
    return s;
  } else {
    var beginIndex = index;
    var result = s.substring(beginIndex);
    while ((index > 3)) {
      var next = ((index - 3) | 0);
      var endIndex = index;
      result = ((s.substring(next, endIndex) + ",") + result);
      index = next;
    }
    var endIndex$1 = index;
    return ((s.substring(0, endIndex$1) + ",") + result);
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var len = str.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str);
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var len = ((prefix.length + str.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str);
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, "0", ((width - len) | 0)), str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str);
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException(("" + $cToS(flag)));
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException(("" + $cToS(conversion)));
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision);
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width);
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  throw new $c_ju_IllegalFormatArgumentIndexException(((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)"));
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg);
}
function $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult$1) {
  return ("%" + execResult$1[0]);
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var $x_1 = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    case 102: {
      var $x_1 = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    default: {
      var $x_1 = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
    }
  }
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, $x_1, "");
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.y2 = dest;
  $thiz.a9C = formatterLocaleInfo;
  $thiz.th = "";
  $thiz.R3 = false;
  return $thiz;
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz;
}
/** @constructor */
function $c_ju_Formatter() {
  this.y2 = null;
  this.a9C = null;
  this.th = null;
  this.R3 = false;
}
$p = $c_ju_Formatter.prototype = new $h_O();
$p.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
}
$h_ju_Formatter.prototype = $p;
$p.au6 = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.a9C, format, args);
});
$p.g = (function() {
  if (this.R3) {
    throw new $c_ju_FormatterClosedException();
  }
  return ((this.y2 === null) ? this.th : this.y2.g());
});
$p.UR = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags));
});
$p.N3 = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower);
});
$p.IT = (function(conversionLower, arg) {
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(arg));
});
var $d_ju_Formatter = new $TypeData().i($c_ju_Formatter, "java.util.Formatter", ({
  uE: 1,
  bN: 1,
  bP: 1,
  bO: 1
}));
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_ju_concurrent_ExecutionException = new $TypeData().i($c_ju_concurrent_ExecutionException, "java.util.concurrent.ExecutionException", ({
  v4: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.m9 = null;
  this.iW = 0;
}
$p = $c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$p.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
}
$h_ju_concurrent_TimeUnit.prototype = $p;
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $p;
$p.bM = (function(o1, o2) {
  return (((o1 | 0) - (o2 | 0)) | 0);
});
$p.mK = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.hd = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ByteArrayOps$, "java.util.internal.GenericArrayOps$ByteArrayOps$", ({
  vd: 1,
  bc: 1,
  bl: 1,
  W: 1
}));
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $p;
$p.bM = (function(o1, o2) {
  return (($uC(o1) - $uC(o2)) | 0);
});
$p.mK = (function(a, i, v) {
  var v$1 = $uC(v);
  a.a[i] = v$1;
});
$p.hd = (function(a, i) {
  return $bC(a.a[i]);
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$CharArrayOps$, "java.util.internal.GenericArrayOps$CharArrayOps$", ({
  ve: 1,
  bc: 1,
  bl: 1,
  W: 1
}));
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$CharArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $p;
$p.bM = (function(o1, o2) {
  var x = (o1 | 0);
  var y = (o2 | 0);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$p.mK = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.hd = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$IntArrayOps$, "java.util.internal.GenericArrayOps$IntArrayOps$", ({
  vf: 1,
  bc: 1,
  bl: 1,
  W: 1
}));
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$IntArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $p;
$p.bM = (function(o1, o2) {
  var $x_1 = $uJ(o1);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $uJ(o2);
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$p.mK = (function(a, i, v) {
  var $x_1 = $uJ(v);
  var v$1_$_lo = $x_1.l;
  var v$1_$_hi = $x_1.h;
  var $x_2 = a.a;
  var $x_3 = (i << 1);
  $x_2[$x_3] = v$1_$_lo;
  $x_2[(($x_3 + 1) | 0)] = v$1_$_hi;
});
$p.hd = (function(a, i) {
  var $x_1 = a.a;
  var $x_2 = (i << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$LongArrayOps$, "java.util.internal.GenericArrayOps$LongArrayOps$", ({
  vg: 1,
  bc: 1,
  bl: 1,
  W: 1
}));
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$LongArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$p = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$p.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $p;
$p.bM = (function(o1, o2) {
  return (((o1 | 0) - (o2 | 0)) | 0);
});
$p.mK = (function(a, i, v) {
  var v$1 = (v | 0);
  a.a[i] = v$1;
});
$p.hd = (function(a, i) {
  return a.a[i];
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().i($c_ju_internal_GenericArrayOps$ShortArrayOps$, "java.util.internal.GenericArrayOps$ShortArrayOps$", ({
  vi: 1,
  bc: 1,
  bl: 1,
  W: 1
}));
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$;
}
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListIterator(domList) {
  this.Rk = null;
  this.Gx = 0;
  this.Rk = domList;
  this.Gx = 0;
}
$p = $c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListIterator;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListIterator() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.l = (function() {
  return this;
});
$p.c = (function() {
  return (!this.f());
});
$p.kH = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.EE = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.ex = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.EA = (function(from, until) {
  return $f_sc_Iterator__slice__I__I__sc_Iterator(this, from, until);
});
$p.mL = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.g = (function() {
  return "<iterator>";
});
$p.f = (function() {
  return (this.Gx < (this.Rk.length | 0));
});
$p.e = (function() {
  var res = this.Rk[this.Gx];
  this.Gx = ((1 + this.Gx) | 0);
  return res;
});
var $d_Lorg_scalajs_dom_DOMList$DOMListIterator = new $TypeData().i($c_Lorg_scalajs_dom_DOMList$DOMListIterator, "org.scalajs.dom.DOMList$DOMListIterator", ({
  vu: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(outer) {
  this.Gy = 0;
  this.Rl = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Rl = outer;
  this.Gy = 0;
}
$p = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.l = (function() {
  return this;
});
$p.c = (function() {
  return (!this.f());
});
$p.kH = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.EE = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.ex = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.EA = (function(from, until) {
  return $f_sc_Iterator__slice__I__I__sc_Iterator(this, from, until);
});
$p.mL = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.g = (function() {
  return "<iterator>";
});
$p.kS = (function() {
  var n = this.Rl.Cy.item(this.Gy);
  this.Gy = ((1 + this.Gy) | 0);
  return new $c_T2(n.name, n);
});
$p.f = (function() {
  return (this.Gy < (this.Rl.Cy.length | 0));
});
$p.e = (function() {
  return this.kS();
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1 = new $TypeData().i($c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1, "org.scalajs.dom.NamedNodeMapMap$$anon$1", ({
  vz: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_s_$eq$colon$eq() {
}
$p = $c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$p.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
$h_s_$eq$colon$eq.prototype = $p;
function $ct_s_Enumeration$Value__s_Enumeration__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.KZ = outer;
  return $thiz;
}
/** @constructor */
function $c_s_Enumeration$Value() {
  this.KZ = null;
}
$p = $c_s_Enumeration$Value.prototype = new $h_O();
$p.constructor = $c_s_Enumeration$Value;
/** @constructor */
function $h_s_Enumeration$Value() {
}
$h_s_Enumeration$Value.prototype = $p;
$p.jl = (function(that) {
  return this.TZ(that);
});
$p.TZ = (function(that) {
  return ((this.i9 < that.i9) ? (-1) : ((this.i9 !== that.i9) | 0));
});
$p.b = (function(other) {
  return ((other instanceof $c_s_Enumeration$Value) && ((this.KZ === other.KZ) && (this.i9 === other.i9)));
});
$p.r = (function() {
  return $m_sr_Statics$().k(this.i9);
});
$p.oH = (function(that) {
  return this.TZ(that);
});
function $isArrayOf_s_Enumeration$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gI)));
}
/** @constructor */
function $c_s_Enumeration$ValueSet$$anon$1(outer) {
  this.Rq = null;
  this.Rp = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Rp = outer;
  this.Rq = $ct_scm_BitSet__(new $c_scm_BitSet());
}
$p = $c_s_Enumeration$ValueSet$$anon$1.prototype = new $h_O();
$p.constructor = $c_s_Enumeration$ValueSet$$anon$1;
/** @constructor */
function $h_s_Enumeration$ValueSet$$anon$1() {
}
$h_s_Enumeration$ValueSet$$anon$1.prototype = $p;
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.dk = (function(size) {
});
$p.am7 = (function(x) {
  this.Rq.TB(((x.i9 - this.Rp.Ro.j1) | 0));
  return this;
});
$p.axq = (function() {
  return new $c_s_Enumeration$ValueSet(this.Rp.Ro, $m_sci_BitSet$().auc(this.Rq.fj));
});
$p.aD = (function(elem) {
  return this.am7(elem);
});
$p.aR = (function() {
  return this.axq();
});
var $d_s_Enumeration$ValueSet$$anon$1 = new $TypeData().i($c_s_Enumeration$ValueSet$$anon$1, "scala.Enumeration$ValueSet$$anon$1", ({
  vQ: 1,
  S: 1,
  T: 1,
  X: 1
}));
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.alc = null;
  this.alc = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => $m_s_None$()));
}
$p = $c_s_PartialFunction$$anon$1.prototype = new $h_O();
$p.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
$h_s_PartialFunction$$anon$1.prototype = $p;
$p.g = (function() {
  return "<function1>";
});
$p.hK = (function(x$0) {
  this.Mg(x$0);
});
$p.aJ = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.aU = (function(x) {
  return false;
});
$p.Mg = (function(x) {
  throw new $c_s_MatchError(x);
});
$p.p = (function(v1) {
  this.Mg(v1);
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().i($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  w0: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.aad = null;
  this.aad = pf;
}
$p = $c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$p.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
$h_s_PartialFunction$Lifted.prototype = $p;
$p.Z = (function(x) {
  var z = this.aad.aJ(x, $m_s_PartialFunction$().L1);
  return ((!$m_s_PartialFunction$().axy(z)) ? new $c_s_Some(z) : $m_s_None$());
});
$p.p = (function(v1) {
  return this.Z(v1);
});
var $d_s_PartialFunction$Lifted = new $TypeData().i($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  w1: 1,
  bD: 1,
  p: 1,
  a: 1
}));
/** @constructor */
function $c_sc_AbstractIterator() {
}
$p = $c_sc_AbstractIterator.prototype = new $h_O();
$p.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
}
$h_sc_AbstractIterator.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$1) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$1);
});
$p.l = (function() {
  return this;
});
$p.c = (function() {
  return (!this.f());
});
$p.kH = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.EE = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.ex = (function(n) {
  return this.mL(n, (-1));
});
$p.EA = (function(from, until) {
  return $f_sc_Iterator__slice__I__I__sc_Iterator(this, from, until);
});
$p.mL = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.g = (function() {
  return "<iterator>";
});
/** @constructor */
function $c_sc_Iterable$() {
  this.q7 = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$());
}
$p = $c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
$h_sc_Iterable$.prototype = $p;
var $d_sc_Iterable$ = new $TypeData().i($c_sc_Iterable$, "scala.collection.Iterable$", ({
  wt: 1,
  bn: 1,
  a: 1,
  U: 1
}));
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
/** @constructor */
function $c_sc_Map$() {
  this.ye = null;
  this.aaw = null;
  this.aax = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.aaw = $ct_O__(new $c_O());
  this.aax = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.aaw));
}
$p = $c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$p.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
}
$h_sc_Map$.prototype = $p;
var $d_sc_Map$ = new $TypeData().i($c_sc_Map$, "scala.collection.Map$", ({
  wP: 1,
  h0: 1,
  a: 1,
  bp: 1
}));
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$();
  }
  return $n_sc_Map$;
}
/** @constructor */
function $c_sc_MapOps$WithFilter(self, p) {
  this.GF = null;
  this.L8 = null;
  $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(this, self, p);
}
$p = $c_sc_MapOps$WithFilter.prototype = new $h_sc_IterableOps$WithFilter();
$p.constructor = $c_sc_MapOps$WithFilter;
/** @constructor */
function $h_sc_MapOps$WithFilter() {
}
$h_sc_MapOps$WithFilter.prototype = $p;
var $d_sc_MapOps$WithFilter = new $TypeData().i($c_sc_MapOps$WithFilter, "scala.collection.MapOps$WithFilter", ({
  wV: 1,
  cw: 1,
  c1: 1,
  a: 1
}));
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.o1 = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.o1 = null;
}
$p = $c_sc_SeqFactory$Delegate.prototype = new $h_O();
$p.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
}
$h_sc_SeqFactory$Delegate.prototype = $p;
$p.Mj = (function(elems) {
  return this.o1.e4(elems);
});
$p.dj = (function() {
  return this.o1.ce();
});
$p.zH = (function(it) {
  return this.o1.bp(it);
});
$p.aP = (function() {
  return this.o1.aP();
});
$p.e4 = (function(elems) {
  return this.Mj(elems);
});
$p.ce = (function() {
  return this.dj();
});
$p.bp = (function(source) {
  return this.zH(source);
});
function $f_sc_SeqOps__prepended__O__O($thiz, elem) {
  return $thiz.b4().bp($ct_sc_View$Prepended__O__sc_IterableOps__(new $c_sc_View$Prepended(), elem, $thiz));
}
function $f_sc_SeqOps__appended__O__O($thiz, elem) {
  return $thiz.b4().bp($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, elem));
}
function $f_sc_SeqOps__prependedAll__sc_IterableOnce__O($thiz, prefix) {
  return $thiz.b4().bp(($is_sc_Iterable(prefix) ? new $c_sc_View$Concat(prefix, $thiz) : prefix.l().kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $thiz.l())))));
}
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.eQ(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => x$2)));
}
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.de(new $c_sc_View$DistinctBy($thiz, f));
}
function $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z($thiz, that, offset) {
  var i = $thiz.l().ex(offset);
  var j = that.l();
  while ((j.f() && i.f())) {
    if ((!$m_sr_BoxesRunTime$().B(i.e(), j.e()))) {
      return false;
    }
  }
  return (!j.f());
}
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.cp(idx) > 0));
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.iq(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => $m_sr_BoxesRunTime$().B(elem, _$2$2))), from);
}
function $f_sc_SeqOps__lastIndexOf__O__I__I($thiz, elem, end) {
  return $thiz.is(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => $m_sr_BoxesRunTime$().B(elem, _$3$2))), end);
}
function $f_sc_SeqOps__lastIndexWhere__F1__I__I($thiz, p, end) {
  var i = (($thiz.F() - 1) | 0);
  var it = $thiz.bX();
  while (true) {
    if (it.f()) {
      var elem = it.e();
      var $x_1 = ((i > end) || (!(!(!p.p(elem)))));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((i - 1) | 0);
    } else {
      break;
    }
  }
  return i;
}
function $f_sc_SeqOps__indexOfSlice__sc_Seq__I__I($thiz, that, from) {
  if ((that.c() && (from === 0))) {
    return 0;
  } else {
    var l = $thiz.G();
    var tl = that.G();
    if (((l >= 0) && (tl >= 0))) {
      var clippedFrom = ((from < 0) ? 0 : from);
      return ((from > l) ? (-1) : ((tl < 1) ? clippedFrom : ((l < tl) ? (-1) : $m_sc_SeqOps$().axz(($is_sc_Seq($thiz) ? $thiz : $thiz.cf()), clippedFrom, l, that, 0, tl, true))));
    } else {
      var i = from;
      var s = ($is_sc_Seq($thiz) ? $thiz : $thiz.cf()).bo(i);
      while ((!s.c())) {
        var \u03b41$ = s;
        if (\u03b41$.Nu(that, \u03b41$.Nv())) {
          return i;
        }
        i = ((1 + i) | 0);
        s = s.ak();
      }
      return (-1);
    }
  }
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => $m_sr_BoxesRunTime$().B(_$4$2, elem))));
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.F();
  var b = $thiz.dw();
  if ((len === 1)) {
    b.aD($thiz.W());
  } else if ((len > 1)) {
    b.dk(len);
    var arr = new $ac_O(len);
    $thiz.d0(arr, 0, 2147483647);
    $m_ju_Arrays$().zY(arr, ord);
    var i = 0;
    while ((i < len)) {
      b.aD(arr.a[i]);
      i = ((1 + i) | 0);
    }
  }
  return b.aR();
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  return $thiz.eC(new $c_s_math_Ordering$$anon$1(f, ord));
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.cp(0) === 0);
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.G();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.G();
    if ((thatKnownSize !== (-1))) {
      if ((thisKnownSize !== thatKnownSize)) {
        return false;
      }
      if ((thisKnownSize === 0)) {
        return true;
      }
    }
  }
  return $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz.l(), that);
}
/** @constructor */
function $c_sc_Set$() {
  this.q7 = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$());
}
$p = $c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
}
$h_sc_Set$.prototype = $p;
var $d_sc_Set$ = new $TypeData().i($c_sc_Set$, "scala.collection.Set$", ({
  x7: 1,
  bn: 1,
  a: 1,
  U: 1
}));
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$();
  }
  return $n_sc_Set$;
}
/** @constructor */
function $c_sc_SortedSetOps$WithFilter(self, p) {
  this.GF = null;
  this.L8 = null;
  $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(this, self, p);
}
$p = $c_sc_SortedSetOps$WithFilter.prototype = new $h_sc_IterableOps$WithFilter();
$p.constructor = $c_sc_SortedSetOps$WithFilter;
/** @constructor */
function $h_sc_SortedSetOps$WithFilter() {
}
$h_sc_SortedSetOps$WithFilter.prototype = $p;
var $d_sc_SortedSetOps$WithFilter = new $TypeData().i($c_sc_SortedSetOps$WithFilter, "scala.collection.SortedSetOps$WithFilter", ({
  x8: 1,
  cw: 1,
  c1: 1,
  a: 1
}));
function $f_sc_StrictOptimizedIterableOps__unzip__F1__T2($thiz, asPair) {
  var first = $thiz.b4().aP();
  var second = $thiz.b4().aP();
  $thiz.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((a$2) => {
    var pair = asPair.p(a$2);
    first.aD(pair.P());
    return second.aD(pair.V());
  })));
  return new $c_T2(first.aR(), second.aR());
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.b4().aP();
  var it = $thiz.l();
  while (it.f()) {
    b.aD(f.p(it.e()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.b4().aP();
  var it = $thiz.l();
  while (it.f()) {
    b.cz(f.p(it.e()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $thiz.b4().aP();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.l();
  while (it.f()) {
    var elem = it.e();
    var v = pf.aJ(elem, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      b.aD(v);
    }
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $thiz.b4().aP();
  var it = $thiz.l();
  while (it.f()) {
    b.cz(toIterableOnce.p(it.e()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var b = $thiz.b4().aP();
  var it1 = $thiz.l();
  var it2 = that.l();
  while ((it1.f() && it2.f())) {
    b.aD(new $c_T2(it1.e(), it2.e()));
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $thiz.b4().aP();
  var i = 0;
  var it = $thiz.l();
  while (it.f()) {
    b.aD(new $c_T2(it.e(), i));
    i = ((1 + i) | 0);
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O($thiz, z, op) {
  var b = $thiz.b4().aP();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 0);
  var acc = z;
  b.aD(acc);
  var it = $thiz.l();
  while (it.f()) {
    acc = op.cm(acc, it.e());
    b.aD(acc);
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.dw();
  var it = $thiz.l();
  while (it.f()) {
    var elem = it.e();
    if (((!(!pred.p(elem))) !== isFlipped)) {
      b.aD(elem);
    }
  }
  return b.aR();
}
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.dw();
  if ((n >= 0)) {
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, ((-n) | 0));
  }
  var lead = $thiz.l().ex(n);
  var it = $thiz.l();
  while (lead.f()) {
    b.aD(it.e());
    lead.e();
  }
  return b.aR();
}
/** @constructor */
function $c_sci_Iterable$() {
  this.q7 = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$());
}
$p = $c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
}
$h_sci_Iterable$.prototype = $p;
$p.au9 = (function(it) {
  return ($is_sci_Iterable(it) ? it : $c_sc_IterableFactory$Delegate.prototype.bp.call(this, it));
});
$p.bp = (function(it) {
  return this.au9(it);
});
var $d_sci_Iterable$ = new $TypeData().i($c_sci_Iterable$, "scala.collection.immutable.Iterable$", ({
  xF: 1,
  bn: 1,
  a: 1,
  U: 1
}));
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$();
  }
  return $n_sci_Iterable$;
}
/** @constructor */
function $c_sci_LazyList$() {
  this.aM = null;
  this.RP = null;
  $n_sci_LazyList$ = this;
  this.aM = $ct_sci_LazyList__O__(new $c_sci_LazyList(), $m_sci_LazyList$EmptyMarker$());
  this.RP = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$9$2) => $m_sr_Statics$PFMarker$()));
}
$p = $c_sci_LazyList$.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
}
$h_sci_LazyList$.prototype = $p;
$p.e4 = (function(elems) {
  return this.E4(elems);
});
$p.Vm = (function(ll, p, isFlipped) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var elem = null;
    var found = false;
    var rest = restRef.bL;
    while (((!found) && (!($p_sci_LazyList__evaluated__sci_LazyList(rest) === $m_sci_LazyList$().aM)))) {
      elem = rest.W();
      found = ((!(!p.p(elem))) !== isFlipped);
      rest = rest.cq();
      restRef.bL = rest;
    }
    return (found ? $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, this.Vm(rest, p, isFlipped)) : this.aM);
  }))(new $c_sr_ObjectRef(ll))));
});
$p.ajy = (function(ll, pf) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var marker = $m_sr_Statics$PFMarker$();
    var toMarker = this.RP;
    var res = marker;
    var rest = restRef.bL;
    while (((res === marker) && (!($p_sci_LazyList__evaluated__sci_LazyList(rest) === $m_sci_LazyList$().aM)))) {
      res = pf.aJ(rest.W(), toMarker);
      rest = rest.cq();
      restRef.bL = rest;
    }
    return ((res === marker) ? this.aM : $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), res, this.ajy(rest, pf)));
  }))(new $c_sr_ObjectRef(ll))));
});
$p.ajz = (function(ll, f) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef) => (() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var rest = new $c_sr_ObjectRef(restRef.bL);
    while (((!itHasNext) && (!($p_sci_LazyList__evaluated__sci_LazyList(rest.bL) === $m_sci_LazyList$().aM)))) {
      it.bL = f.p(rest.bL.W()).l();
      itHasNext = it.bL.f();
      if ((!itHasNext)) {
        rest.bL = rest.bL.cq();
        restRef.bL = rest.bL;
      }
    }
    if (itHasNext) {
      var x$proxy2 = it.bL;
      if ((x$proxy2 === null)) {
        $m_sr_Scala3RunTime$().bW();
      }
      var head = x$proxy2.e();
      rest.bL = rest.bL.cq();
      restRef.bL = rest.bL;
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), head, $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        var x$proxy3 = it.bL;
        if ((x$proxy3 === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        return this.No(x$proxy3, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.ajz(rest.bL, f))));
      }))));
    } else {
      return this.aM;
    }
  }))(new $c_sr_ObjectRef(ll))));
});
$p.axC = (function(ll, n) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((restRef, iRef) => (() => {
    var rest = restRef.bL;
    var i = iRef.f4;
    while (((i > 0) && (!($p_sci_LazyList__evaluated__sci_LazyList(rest) === $m_sci_LazyList$().aM)))) {
      rest = rest.cq();
      restRef.bL = rest;
      i = ((i - 1) | 0);
      iRef.f4 = i;
    }
    return rest;
  }))(new $c_sr_ObjectRef(ll), new $c_sr_IntRef(n))));
});
$p.E4 = (function(coll) {
  return ((coll instanceof $c_sci_LazyList) ? coll : ((coll.G() === 0) ? this.aM : $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Vl(coll.l()))))));
});
$p.No = (function(it, suffix) {
  return (it.f() ? $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), it.e(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.No(it, suffix))))) : suffix.aA());
});
$p.Vl = (function(it) {
  return (it.f() ? $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), it.e(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Vl(it))))) : this.aM);
});
$p.ah9 = (function(start, step) {
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), start, this.ah9(((start + step) | 0), step)))));
});
$p.aP = (function() {
  return new $c_sci_LazyList$LazyBuilder();
});
$p.bp = (function(source) {
  return this.E4(source);
});
$p.ce = (function() {
  return this.aM;
});
var $d_sci_LazyList$ = new $TypeData().i($c_sci_LazyList$, "scala.collection.immutable.LazyList$", ({
  xG: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$();
  }
  return $n_sci_LazyList$;
}
/** @constructor */
function $c_scm_Builder$$anon$1(f$2, outer) {
  this.abb = null;
  this.H9 = null;
  this.abb = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.H9 = outer;
}
$p = $c_scm_Builder$$anon$1.prototype = new $h_O();
$p.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
}
$h_scm_Builder$$anon$1.prototype = $p;
$p.am5 = (function(x) {
  this.H9.aD(x);
  return this;
});
$p.alU = (function(xs) {
  this.H9.cz(xs);
  return this;
});
$p.dk = (function(size) {
  this.H9.dk(size);
});
$p.aR = (function() {
  return this.abb.p(this.H9.aR());
});
$p.aD = (function(elem) {
  return this.am5(elem);
});
$p.cz = (function(elems) {
  return this.alU(elems);
});
var $d_scm_Builder$$anon$1 = new $TypeData().i($c_scm_Builder$$anon$1, "scala.collection.mutable.Builder$$anon$1", ({
  yT: 1,
  S: 1,
  T: 1,
  X: 1
}));
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.h5 = elems;
  return $thiz;
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.h5 = null;
}
$p = $c_scm_GrowableBuilder.prototype = new $h_O();
$p.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
}
$h_scm_GrowableBuilder.prototype = $p;
$p.dk = (function(size) {
});
$p.Ib = (function(elem) {
  this.h5.aD(elem);
  return this;
});
$p.Tz = (function(xs) {
  this.h5.cz(xs);
  return this;
});
$p.aR = (function() {
  return this.h5;
});
$p.aD = (function(elem) {
  return this.Ib(elem);
});
$p.cz = (function(elems) {
  return this.Tz(elems);
});
var $d_scm_GrowableBuilder = new $TypeData().i($c_scm_GrowableBuilder, "scala.collection.mutable.GrowableBuilder", ({
  bz: 1,
  S: 1,
  T: 1,
  X: 1
}));
/** @constructor */
function $c_scm_Iterable$() {
  this.q7 = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$());
}
$p = $c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
}
$h_scm_Iterable$.prototype = $p;
var $d_scm_Iterable$ = new $TypeData().i($c_scm_Iterable$, "scala.collection.mutable.Iterable$", ({
  zh: 1,
  bn: 1,
  a: 1,
  U: 1
}));
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$();
  }
  return $n_scm_Iterable$;
}
/** @constructor */
function $c_scm_Map$() {
  this.ye = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$());
}
$p = $c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$p.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
$h_scm_Map$.prototype = $p;
var $d_scm_Map$ = new $TypeData().i($c_scm_Map$, "scala.collection.mutable.Map$", ({
  zp: 1,
  h0: 1,
  a: 1,
  bp: 1
}));
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
/** @constructor */
function $c_scm_Set$() {
  this.q7 = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$());
}
$p = $c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$p.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
}
$h_scm_Set$.prototype = $p;
var $d_scm_Set$ = new $TypeData().i($c_scm_Set$, "scala.collection.mutable.Set$", ({
  zu: 1,
  bn: 1,
  a: 1,
  U: 1
}));
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$();
  }
  return $n_scm_Set$;
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  zF() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().i($c_s_concurrent_Future$$anon$4, "scala.concurrent.Future$$anon$4", ({
  zG: 1,
  F: 1,
  a: 1,
  bE: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration() {
}
$p = $c_s_concurrent_duration_Duration.prototype = new $h_O();
$p.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
}
$h_s_concurrent_duration_Duration.prototype = $p;
$p.jl = (function(that) {
  return this.qF(that);
});
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.B3)));
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  this.abH = null;
  this.abH = Promise.resolve((void 0));
}
$p = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
}
$h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = $p;
$p.Uc = (function(runnable) {
  this.abH.then(((arg1$2) => {
    try {
      runnable.zV();
    } catch (e) {
      ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)).Eu($m_jl_System$Streams$().xX);
    }
  }));
});
$p.Ve = (function(t) {
  t.Eu($m_jl_System$Streams$().xX);
});
var $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$PromisesExecutionContext", ({
  Bl: 1,
  cY: 1,
  cX: 1,
  ct: 1
}));
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
$p = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = new $h_O();
$p.constructor = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
}
$h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = $p;
$p.Uc = (function(runnable) {
  setTimeout($m_sjs_js_Any$().gI(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    try {
      runnable.zV();
    } catch (e) {
      ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)).Eu($m_jl_System$Streams$().xX);
    }
  }))), 0);
});
$p.Ve = (function(t) {
  t.Eu($m_jl_System$Streams$().xX);
});
var $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext = new $TypeData().i($c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext, "scala.scalajs.concurrent.QueueExecutionContext$TimeoutsExecutionContext", ({
  Bm: 1,
  cY: 1,
  cX: 1,
  ct: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(f) {
  this.abJ = null;
  this.abJ = f;
}
$p = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = new $h_sjsr_AnonFunction1();
$p.constructor = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1;
/** @constructor */
function $h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1() {
}
$h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = $p;
$p.p = (function(x0) {
  return (0, this.abJ)(x0);
});
var $d_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1 = new $TypeData().i($c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1, "scala.scalajs.runtime.AnonFunction1.$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1", ({
  BC: 1,
  BB: 1,
  bD: 1,
  p: 1
}));
/** @constructor */
function $c_s_util_Try() {
}
$p = $c_s_util_Try.prototype = new $h_O();
$p.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
$h_s_util_Try.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d4)));
}
/** @constructor */
function $c_Lscalatags_generic_Attr(name, namespace, raw) {
  this.jf = null;
  this.Dc = null;
  this.Dd = false;
  this.jf = name;
  this.Dc = namespace;
  this.Dd = raw;
  if (((!raw) && (!$m_Lscalatags_Escaping$().az4(name)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Illegal attribute name: " + name) + " is not a valid XML attribute name"));
  }
}
$p = $c_Lscalatags_generic_Attr.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Attr;
/** @constructor */
function $h_Lscalatags_generic_Attr() {
}
$h_Lscalatags_generic_Attr.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, $f_T__hashCode__I("Attr"));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jf));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Dc));
  acc = $m_sr_Statics$().d(acc, (this.Dd ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscalatags_generic_Attr)) {
    if (((this.Dd === x$0.Dd) && (this.jf === x$0.jf))) {
      var x = this.Dc;
      var x$2 = x$0.Dc;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "Attr";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.jf;
      break;
    }
    case 1: {
      return this.Dc;
      break;
    }
    case 2: {
      return this.Dd;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.n = (function(v, ev) {
  return new $c_Lscalatags_generic_AttrPair(this, v, ev);
});
function $isArrayOf_Lscalatags_generic_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.it)));
}
var $d_Lscalatags_generic_Attr = new $TypeData().i($c_Lscalatags_generic_Attr, "scalatags.generic.Attr", ({
  it: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $f_Lscalatags_generic_InputAttrs__checked__Lscalatags_generic_AttrPair($thiz) {
  var this$1 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "checked", null, false);
  var ev = new $c_Lscalatags_JsDom$GenericAttr();
  return this$1.n(this$1.jf, ev);
}
function $f_Lscalatags_generic_InputAttrs__multiple__Lscalatags_generic_AttrPair($thiz) {
  var this$1 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "multiple", null, false);
  var ev = new $c_Lscalatags_JsDom$GenericAttr();
  return this$1.n(this$1.jf, ev);
}
function $ct_Lscalatags_generic_Style__T__T__($thiz, jsName, cssName) {
  $thiz.Ht = jsName;
  $thiz.Df = cssName;
  return $thiz;
}
/** @constructor */
function $c_Lscalatags_generic_Style() {
  this.Ht = null;
  this.Df = null;
}
$p = $c_Lscalatags_generic_Style.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_Style;
/** @constructor */
function $h_Lscalatags_generic_Style() {
}
$h_Lscalatags_generic_Style.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lscalatags_generic_Style) && ((this.Ht === x$0.Ht) && (this.Df === x$0.Df))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Style";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Ht;
  }
  if ((n === 1)) {
    return this.Df;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.alI = (function(v, ev) {
  return new $c_Lscalatags_generic_StylePair(this, v, ev);
});
function $isArrayOf_Lscalatags_generic_Style(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iw)));
}
/** @constructor */
function $c_Lupack_Bool() {
}
$p = $c_Lupack_Bool.prototype = new $h_O();
$p.constructor = $c_Lupack_Bool;
/** @constructor */
function $h_Lupack_Bool() {
}
$h_Lupack_Bool.prototype = $p;
function $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, x) {
  if ((x instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    var x183 = x.tN;
    $m_scm_ArrayBuffer$();
    var b = new $c_scm_ArrayBuffer$$anon$1();
    var it = x183.mS().l();
    while (it.f()) {
      b.Ib(($p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, it.e()), (void 0)));
    }
  } else if ((x instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    var x178 = x.on;
    matchResult19: {
      $m_scm_ArrayBuffer$();
      var builder = new $c_scm_ArrayBuffer$$anon$1();
      var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
      var it$1 = x178.mS().l();
      while (it$1.f()) {
        var next = it$1.e();
        if (seen.qA($objectGetClass(next.P()))) {
          builder.Ib(next);
        }
      }
      var x136 = builder.h5;
      if ((x136 !== null)) {
        $m_sc_Seq$();
        if ((x136.cp(1) === 0)) {
          var x168 = x136.at(0);
          if ((x168 !== null)) {
            var x169 = x168.P();
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Num)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$1(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Float32)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$2(), $m_s_math_Ordering$DeprecatedFloatOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$3(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Int32)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$4(), $m_s_math_Ordering$Int$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$5(), $m_s_math_Ordering$Long$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$6(), $m_s_math_Ordering$DeprecatedDoubleOrdering$());
              break matchResult19;
            }
            if ((x169 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
              $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$7(), $m_s_math_Ordering$Long$());
              break matchResult19;
            }
          }
        }
      }
      $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps(x178, new $c_Lupickle_core_BufferedValue$$anon$8(), $m_s_math_Ordering$String$());
    }
    var it$2 = x178.mS().l();
    while (it$2.f()) {
      var x0$1 = it$2.e();
      matchResult20: {
        if ((x0$1 !== null)) {
          var c = x0$1.P();
          $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V($thiz, x0$1.V());
          break matchResult20;
        }
        throw new $c_s_MatchError(x0$1);
      }
    }
  }
}
/** @constructor */
function $c_Lupickle_core_BufferedValue$() {
}
$p = $c_Lupickle_core_BufferedValue$.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$;
/** @constructor */
function $h_Lupickle_core_BufferedValue$() {
}
$h_Lupickle_core_BufferedValue$.prototype = $p;
$p.Ji = (function(b) {
  if ((b instanceof $c_Lupickle_core_BufferedValue$Null)) {
    return "null";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$True)) {
    return "true";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$False)) {
    return "false";
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Str)) {
    return $dp_toString__T(b.qr);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Num)) {
    return $dp_toString__T(b.tR);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Char)) {
    return ("" + $cToS(b.yL));
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Binary)) {
    return $m_jl_String$().aiY(b.yG, b.yJ, b.yI, $m_Ljava_nio_charset_UTF\uff3f8$());
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Ext)) {
    return (("" + b.yQ) + $m_jl_String$().aiY(b.yM, b.yP, b.yO, $m_Ljava_nio_charset_UTF\uff3f8$()));
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Float32)) {
    return ("" + b.tO);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
    return b.tP;
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Int32)) {
    return ("" + b.tQ);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Int64)) {
    var $x_1 = b;
    var x24_$_lo = $x_1.uh;
    var x24_$_hi = $x_1.ui;
    return $m_RTLong$().gc(x24_$_lo, x24_$_hi);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
    return ("" + b.tS);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
    var $x_2 = b;
    var x16_$_lo = $x_2.uj;
    var x16_$_hi = $x_2.uk;
    return $m_RTLong$().gc(x16_$_lo, x16_$_hi);
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    var x12 = b.tN;
    $m_scm_ArrayBuffer$();
    var b$1 = new $c_scm_ArrayBuffer$$anon$1();
    var it = x12.mS().l();
    while (it.f()) {
      b$1.Ib($m_Lupickle_core_BufferedValue$().Ji(it.e()));
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(b$1.h5, "", "", "");
  }
  if ((b instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    var x7 = b.on;
    $m_scm_ArrayBuffer$();
    var b$2 = new $c_scm_ArrayBuffer$$anon$1();
    var it$1 = x7.mS().l();
    while (it$1.f()) {
      var x0$1 = it$1.e();
      matchResult1: {
        var $x_3;
        if ((x0$1 !== null)) {
          var k = x0$1.P();
          var v = x0$1.V();
          var $x_3 = (("" + $m_Lupickle_core_BufferedValue$().Ji(k)) + $m_Lupickle_core_BufferedValue$().Ji(v));
          break matchResult1;
        }
        throw new $c_s_MatchError(x0$1);
      }
      b$2.Ib($x_3);
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(b$2.h5, "", "", "");
  }
  throw new $c_s_MatchError(b);
});
$p.awf = (function(tr, t, sortKeys, f) {
  if (sortKeys) {
    var buffered = tr.O(t, $m_Lupickle_core_BufferedValue$Builder$());
    $p_Lupickle_core_BufferedValue$__rec$1__Lupickle_core_BufferedValue__V(this, buffered);
    return $m_Lupickle_core_BufferedValue$().uG(buffered, f);
  } else {
    return tr.O(t, f);
  }
});
$p.uG = (function(j, f) {
  try {
    if ((j instanceof $c_Lupickle_core_BufferedValue$Null)) {
      var x324 = j.yW;
      return f.M(x324);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$True)) {
      var x321 = j.z1;
      return f.ch(x321);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$False)) {
      var x318 = j.yR;
      return f.cg(x318);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Str)) {
      var x314 = j.qr;
      var x315 = j.z0;
      return f.bx(x314, x315);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Num)) {
      var x308 = j.tR;
      var x309 = j.Dm;
      var x310 = j.Dn;
      var x311 = j.yX;
      return f.cu(x308, x309, x310, x311);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      var x304 = j.tS;
      var x305 = j.yY;
      return f.ct(x304, x305);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Arr)) {
      var x300 = j.tN;
      var x301 = j.yF;
      var ctx = f.bt(x300.dh, x301);
      var it = x300.mS().l();
      while (it.f()) {
        var x0 = it.e();
        try {
          ctx.bu($m_Lupickle_core_BufferedValue$().uG(x0, ctx.bw()), x0.f7());
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          $m_Lupickle_core_ParseUtils$();
          var \u03b42$ = new $c_Lupickle_core_ParseUtils$$anon$1(x0.f7());
          if (\u03b42$.bq(e$2)) {
            \u03b42$.bn(e$2, $m_s_PartialFunction$().fX);
          } else {
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
          }
        }
      }
      return ctx.L(x301);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Obj)) {
      var x295 = j.on;
      var x296 = j.Do;
      var x297 = j.yZ;
      var ctx$3 = f.K(x295.dh, x296, x297);
      var this$12 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), x295, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => ((x$1 !== null) && (x$1.P(), x$1.V(), true)))));
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
        matchResult71: {
          if ((x$1$2 !== null)) {
            var k$1 = x$1$2.P();
            var item$1 = x$1$2.V();
            var $x_2 = $m_Lupickle_core_BufferedValue$();
            try {
              var $x_1 = ctx$3.eT(x297);
            } catch (e$1) {
              var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
              $m_Lupickle_core_ParseUtils$();
              var \u03b43$ = new $c_Lupickle_core_ParseUtils$$anon$1(x297);
              if (\u03b43$.bq(e$2$1)) {
                var $x_1 = \u03b43$.bn(e$2$1, $m_s_PartialFunction$().fX);
              } else {
                var $x_1;
                throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
              }
            }
            ctx$3.eU($x_2.uG(k$1, $x_1));
            try {
              ctx$3.bu($m_Lupickle_core_BufferedValue$().uG(item$1, ctx$3.bw()), item$1.f7());
              break matchResult71;
            } catch (e$3) {
              var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
              $m_Lupickle_core_ParseUtils$();
              var \u03b44$ = new $c_Lupickle_core_ParseUtils$$anon$1(item$1.f7());
              if (\u03b44$.bq(e$4)) {
                \u03b44$.bn(e$4, $m_s_PartialFunction$().fX);
                break matchResult71;
              } else {
                throw ((e$4 instanceof $c_sjs_js_JavaScriptException) ? e$4.b6 : e$4);
              }
            }
          }
          throw new $c_s_MatchError(x$1$2);
        }
      }));
      this$12.ah3().al(f$1);
      return ctx$3.L(x297);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Binary)) {
      var x289 = j.yG;
      var x290 = j.yJ;
      var x291 = j.yI;
      var x292 = j.yH;
      return f.cr(x289, x290, x291, x292);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Char)) {
      var x285 = j.yL;
      var x286 = j.yK;
      return f.cB(x285, x286);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Ext)) {
      var x278 = j.yQ;
      var x279 = j.yM;
      var x280 = j.yP;
      var x281 = j.yO;
      var x282 = j.yN;
      return f.cC(x278, x279, x280, x281, x282);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      var x274 = j.tO;
      var x275 = j.yS;
      return f.cs(x274, x275);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      var x270 = j.tP;
      var x271 = j.yT;
      return f.cL(x270, x271);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      var x266 = j.tQ;
      var x267 = j.yU;
      return f.c9(x266, x267);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      var $x_3 = j;
      var x262_$_lo = $x_3.uh;
      var x262_$_hi = $x_3.ui;
      var x263 = j.yV;
      return f.cv(x262_$_lo, x262_$_hi, x263);
    }
    if ((j instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      var $x_4 = j;
      var x258_$_lo = $x_4.uj;
      var x258_$_hi = $x_4.uk;
      var x259 = j.z2;
      return f.cD(x258_$_lo, x258_$_hi, x259);
    }
    throw new $c_s_MatchError(j);
  } catch (e$2$2) {
    var e$3$1 = ((e$2$2 instanceof $c_jl_Throwable) ? e$2$2 : new $c_sjs_js_JavaScriptException(e$2$2));
    $m_Lupickle_core_ParseUtils$();
    var \u03b41$ = new $c_Lupickle_core_ParseUtils$$anon$1(j.f7());
    if (\u03b41$.bq(e$3$1)) {
      return \u03b41$.bn(e$3$1, $m_s_PartialFunction$().fX);
    } else {
      throw ((e$3$1 instanceof $c_sjs_js_JavaScriptException) ? e$3$1.b6 : e$3$1);
    }
  }
});
$p.O = (function(j, f) {
  return this.uG(j, f);
});
var $d_Lupickle_core_BufferedValue$ = new $TypeData().i($c_Lupickle_core_BufferedValue$, "upickle.core.BufferedValue$", ({
  CW: 1,
  j: 1,
  v: 1,
  an: 1
}));
var $n_Lupickle_core_BufferedValue$;
function $m_Lupickle_core_BufferedValue$() {
  if ((!$n_Lupickle_core_BufferedValue$)) {
    $n_Lupickle_core_BufferedValue$ = new $c_Lupickle_core_BufferedValue$();
  }
  return $n_Lupickle_core_BufferedValue$;
}
/** @constructor */
function $c_Lupickle_core_LinkedHashMap$$anon$1(outer) {
  this.HT = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.HT = new $c_ju_HashMap$EntrySet(outer.Dp).zN();
}
$p = $c_Lupickle_core_LinkedHashMap$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_LinkedHashMap$$anon$1;
/** @constructor */
function $h_Lupickle_core_LinkedHashMap$$anon$1() {
}
$h_Lupickle_core_LinkedHashMap$$anon$1.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.l = (function() {
  return this;
});
$p.c = (function() {
  return (!this.HT.f());
});
$p.kH = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$p.EE = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$p.ex = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$p.EA = (function(from, until) {
  return $f_sc_Iterator__slice__I__I__sc_Iterator(this, from, until);
});
$p.mL = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$p.g = (function() {
  return "<iterator>";
});
$p.f = (function() {
  return this.HT.f();
});
$p.kS = (function() {
  var entry = this.HT.e();
  return new $c_T2(entry.me, entry.ht);
});
$p.e = (function() {
  return this.kS();
});
var $d_Lupickle_core_LinkedHashMap$$anon$1 = new $TypeData().i($c_Lupickle_core_LinkedHashMap$$anon$1, "upickle.core.LinkedHashMap$$anon$1", ({
  Df: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$1(objVisitor$3, outer) {
  this.Dr = null;
  this.Ds = null;
  this.Dq = null;
  this.Dr = objVisitor$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Dq = outer;
}
$p = $c_Lupickle_core_TraceVisitor$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$1;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$1() {
}
$h_Lupickle_core_TraceVisitor$$anon$1.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.g = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.eT = (function(index) {
  return new $c_Lupickle_core_TraceVisitor$$anon$2(this.Dr, index, this);
});
$p.eU = (function(v) {
  if ((this.Ds === null)) {
    this.Ds = "?";
  }
  this.Dr.eU(v);
});
$p.bw = (function() {
  return $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), this.Dr.bw(), this, this.Dq.tT);
});
$p.bu = (function(v, index) {
  this.Ds = null;
  this.Dr.bu(v, index);
});
$p.L = (function(index) {
  this.Dq.tT.Dt = this.Dq.z3;
  return this.Dr.L(index);
});
$p.V7 = (function() {
  var this$1 = $m_s_Option$().Z(this.Ds);
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some((("'" + x0.split("'").join("\\'")) + "'"));
  }
});
$p.Nf = (function() {
  return new $c_s_Some(this.Dq.z3);
});
$p.du = (function() {
  return this;
});
var $d_Lupickle_core_TraceVisitor$$anon$1 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$1, "upickle.core.TraceVisitor$$anon$1", ({
  Dn: 1,
  Y: 1,
  aw: 1,
  da: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$2(objVisitor$2, index$1, outer) {
  this.eO = null;
  this.SM = null;
  this.z3 = null;
  this.tT = null;
  this.SN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SN = outer;
  $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(this, objVisitor$2.eT(index$1), outer, outer.Dq.tT);
}
$p = $c_Lupickle_core_TraceVisitor$$anon$2.prototype = new $h_Lupickle_core_TraceVisitor();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$2;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$2() {
}
$h_Lupickle_core_TraceVisitor$$anon$2.prototype = $p;
$p.bx = (function(s, index) {
  this.SN.Ds = $dp_toString__T(s);
  return this.SM.bx(this.SN.Ds, index);
});
var $d_Lupickle_core_TraceVisitor$$anon$2 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$2, "upickle.core.TraceVisitor$$anon$2", ({
  Do: 1,
  jb: 1,
  bI: 1,
  d: 1
}));
/** @constructor */
function $c_Lupickle_core_TraceVisitor$$anon$3(arrVisitor$2, outer) {
  this.LP = null;
  this.LQ = 0;
  this.HU = null;
  this.LP = arrVisitor$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.HU = outer;
  this.LQ = 0;
  outer.tT.Dt = this;
}
$p = $c_Lupickle_core_TraceVisitor$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_TraceVisitor$$anon$3;
/** @constructor */
function $h_Lupickle_core_TraceVisitor$$anon$3() {
}
$h_Lupickle_core_TraceVisitor$$anon$3.prototype = $p;
$p.ey = (function() {
  return false;
});
$p.du = (function() {
  return this;
});
$p.g = (function() {
  return $f_Lupickle_core_TraceVisitor$HasPath__path__T(this);
});
$p.bw = (function() {
  return $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), this.LP.bw(), this, this.HU.tT);
});
$p.bu = (function(v, index) {
  this.LP.bu(v, index);
  this.LQ = ((1 + this.LQ) | 0);
});
$p.L = (function(index) {
  this.HU.tT.Dt = this.HU.z3;
  return this.LP.L(index);
});
$p.V7 = (function() {
  return new $c_s_Some(("" + this.LQ));
});
$p.Nf = (function() {
  return new $c_s_Some(this.HU.z3);
});
var $d_Lupickle_core_TraceVisitor$$anon$3 = new $TypeData().i($c_Lupickle_core_TraceVisitor$$anon$3, "upickle.core.TraceVisitor$$anon$3", ({
  Dp: 1,
  Y: 1,
  aF: 1,
  da: 1
}));
function $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__($thiz, outer, delegatedReader) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.SR = outer;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__($thiz, delegatedReader);
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Types$Reader$Delegate() {
  this.eO = null;
  this.SR = null;
}
$p = $c_Lupickle_core_Types$Reader$Delegate.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_Types$Reader$Delegate;
/** @constructor */
function $h_Lupickle_core_Types$Reader$Delegate() {
}
$h_Lupickle_core_Types$Reader$Delegate.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.K = (function(length, jsonableKeys, index) {
  return $c_Lupickle_core_Visitor$Delegate.prototype.K.call(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $c_Lupickle_core_Visitor$Delegate.prototype.bt.call(this, length, index);
});
$p.mO = (function() {
  return this.SR.LR;
});
$p.dL = (function() {
  return this.mO();
});
var $d_Lupickle_core_Types$Reader$Delegate = new $TypeData().i($c_Lupickle_core_Types$Reader$Delegate, "upickle.core.Types$Reader$Delegate", ({
  jd: 1,
  bI: 1,
  d: 1,
  e: 1
}));
function $ct_Lupickle_core_Types$Reader$MapReader__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__($thiz, outer, delegatedReader) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.SS = outer;
  $ct_Lupickle_core_Visitor$MapReader__Lupickle_core_Visitor__($thiz, delegatedReader);
  return $thiz;
}
/** @constructor */
function $c_Lupickle_core_Types$Reader$MapReader() {
  this.fG = null;
  this.SS = null;
}
$p = $c_Lupickle_core_Types$Reader$MapReader.prototype = new $h_Lupickle_core_Visitor$MapReader();
$p.constructor = $c_Lupickle_core_Types$Reader$MapReader;
/** @constructor */
function $h_Lupickle_core_Types$Reader$MapReader() {
}
$h_Lupickle_core_Types$Reader$MapReader.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.K = (function(length, jsonableKeys, index) {
  return $c_Lupickle_core_Visitor$MapReader.prototype.K.call(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $c_Lupickle_core_Visitor$MapReader.prototype.bt.call(this, length, index);
});
$p.mO = (function() {
  return this.SS.LR;
});
$p.dL = (function() {
  return this.mO();
});
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$Leaf(outer, checker, tagKey, tagValue, r) {
  this.adA = null;
  this.SX = null;
  this.SY = null;
  this.SW = null;
  this.SV = null;
  this.adA = checker;
  this.SX = tagKey;
  this.SY = tagValue;
  this.SW = r;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SV = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$Leaf.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$Leaf;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$Leaf() {
}
$h_Lupickle_core_Types$TaggedWriter$Leaf.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.IB = (function(v) {
  var x11 = this.adA;
  if ((x11 instanceof $c_Lupickle_core_Annotator$Checker$Cls)) {
    if (x11.HR.ax.I(v)) {
      return new $c_T3(this.SX, this.SY, this.SW);
    }
  }
  if ((x11 instanceof $c_Lupickle_core_Annotator$Checker$Val)) {
    if ($m_sr_BoxesRunTime$().B(x11.HS, v)) {
      return new $c_T3(this.SX, this.SY, this.SW);
    }
  }
  return null;
});
$p.qR = (function() {
  return this.SV.HW;
});
$p.Jh = (function() {
  return this.SV.HW;
});
$p.T = (function() {
  return this.qR();
});
$p.NF = (function() {
  return this.Jh();
});
var $d_Lupickle_core_Types$TaggedWriter$Leaf = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$Leaf, "upickle.core.Types$TaggedWriter$Leaf", ({
  DF: 1,
  j: 1,
  k: 1,
  bH: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedWriter$Node(outer, rs) {
  this.adB = null;
  this.SZ = null;
  this.adB = rs;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SZ = outer;
}
$p = $c_Lupickle_core_Types$TaggedWriter$Node.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedWriter$Node;
/** @constructor */
function $h_Lupickle_core_Types$TaggedWriter$Node() {
}
$h_Lupickle_core_Types$TaggedWriter$Node.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.IB = (function(v) {
  var xs = this.adB;
  var x = null;
  var i = xs.l();
  while (((x === null) && i.f())) {
    var t = i.e().IB(v);
    if ((t !== null)) {
      x = t;
    }
  }
  return x;
});
$p.qR = (function() {
  return this.SZ.HW;
});
$p.Jh = (function() {
  return this.SZ.HW;
});
$p.T = (function() {
  return this.qR();
});
$p.NF = (function() {
  return this.Jh();
});
var $d_Lupickle_core_Types$TaggedWriter$Node = new $TypeData().i($c_Lupickle_core_Types$TaggedWriter$Node, "upickle.core.Types$TaggedWriter$Node", ({
  DG: 1,
  j: 1,
  k: 1,
  bH: 1
}));
function $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__write0__Lupickle_core_Visitor__O__O($thiz, out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K($thiz.ah(v), true, (-1));
    $thiz.ai(ctx, v);
    return ctx.L((-1));
  }
}
function $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V($thiz, ctx, mappedArgsI, w, value) {
  var keyVisitor = ctx.eT((-1));
  ctx.eU(keyVisitor.bx(mappedArgsI, (-1)));
  ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(w, ctx.bw(), value), (-1));
}
/** @constructor */
function $c_Lupickle_implicits_CaseObjectContext0() {
}
$p = $c_Lupickle_implicits_CaseObjectContext0.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseObjectContext0;
/** @constructor */
function $h_Lupickle_implicits_CaseObjectContext0() {
}
$h_Lupickle_implicits_CaseObjectContext0.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.ag = (function(i, v) {
  var $x_1 = this;
  var x_$_lo = $x_1.oz;
  var x_$_hi = $x_1.oA;
  var lo = (((32 & i) === 0) ? (1 << i) : 0);
  var hi = (((32 & i) === 0) ? 0 : (1 << i));
  if ((((x_$_lo & lo) | (x_$_hi & hi)) === 0)) {
    var $x_2 = this;
    var x$1_$_lo = $x_2.oz;
    var x$1_$_hi = $x_2.oA;
    var lo$2 = (((32 & i) === 0) ? (1 << i) : 0);
    var hi$2 = (((32 & i) === 0) ? 0 : (1 << i));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    var $x_3 = this;
    $x_3.oz = lo$3;
    $x_3.oA = hi$3;
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, i, v);
  }
});
$p.agR = (function(rawArgsLength, mappedArgs) {
  throw new $c_Lupickle_core_Abort(("missing keys in dictionary: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, rawArgsLength, 1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
    var i$1 = (i | 0);
    var $x_1 = this;
    var x_$_lo = $x_1.oz;
    var x_$_hi = $x_1.oA;
    var lo = (((32 & i$1) === 0) ? (1 << i$1) : 0);
    var hi = (((32 & i$1) === 0) ? 0 : (1 << i$1));
    return (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  }))).X(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i$2) => {
    var i$3 = (i$2 | 0);
    return mappedArgs.a[i$3];
  }))), "", ", ", "")));
});
$p.afQ = (function(rawArgsBitset_$_lo, rawArgsBitset_$_hi) {
  var $x_1 = this;
  var x_$_lo = $x_1.oz;
  var x_$_hi = $x_1.oA;
  return (((x_$_lo ^ rawArgsBitset_$_lo) | (x_$_hi ^ rawArgsBitset_$_hi)) !== 0);
});
$p.du = (function() {
  return this;
});
/** @constructor */
function $c_Lupickle_implicits_HugeCaseObjectContext0() {
}
$p = $c_Lupickle_implicits_HugeCaseObjectContext0.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_HugeCaseObjectContext0;
/** @constructor */
function $h_Lupickle_implicits_HugeCaseObjectContext0() {
}
$h_Lupickle_implicits_HugeCaseObjectContext0.prototype = $p;
$p.ey = (function() {
  return true;
});
$p.ag = (function(i, v) {
  var $x_1 = this.qt.a;
  var $x_2 = ((((i + (((i >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
  var x_$_lo = $x_1[$x_2];
  var x_$_hi = $x_1[(($x_2 + 1) | 0)];
  var lo = (((32 & i) === 0) ? (1 << i) : 0);
  var hi = (((32 & i) === 0) ? 0 : (1 << i));
  if ((((x_$_lo & lo) | (x_$_hi & hi)) === 0)) {
    var \u03b42$ = this.qt;
    var i$2 = (((i + (((i >> 5) >>> 26) | 0)) | 0) >> 6);
    var $x_3 = \u03b42$.a;
    var $x_4 = (i$2 << 1);
    var x$1_$_lo = $x_3[$x_4];
    var x$1_$_hi = $x_3[(($x_4 + 1) | 0)];
    var lo$2 = (((32 & i) === 0) ? (1 << i) : 0);
    var hi$2 = (((32 & i) === 0) ? 0 : (1 << i));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    var $x_5 = \u03b42$.a;
    var $x_6 = (i$2 << 1);
    $x_5[$x_6] = lo$3;
    $x_5[(($x_6 + 1) | 0)] = hi$3;
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, i, v);
  }
});
$p.agR = (function(rawArgsLength, mappedArgs) {
  throw new $c_Lupickle_core_Abort(("missing keys in dictionary: " + $f_sc_IterableOnceOps__mkString__T__T__T__T($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), new $c_sci_Range$Exclusive(0, rawArgsLength, 1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
    var i$1 = (i | 0);
    var $x_1 = this.qt.a;
    var $x_2 = ((((i$1 + (((i$1 >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var lo = (((32 & i$1) === 0) ? (1 << i$1) : 0);
    var hi = (((32 & i$1) === 0) ? 0 : (1 << i$1));
    return (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  }))).X(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i$2) => {
    var i$3 = (i$2 | 0);
    return mappedArgs.a[i$3];
  }))), "", ", ", "")));
});
$p.afQ = (function(rawArgsLength_$_lo, rawArgsLength_$_hi) {
  var bits = new $c_sr_IntRef(0);
  var xs = this.qt;
  var f = ((v1) => {
    var $x_1 = $uJ(v1);
    var v_$_lo = $x_1.l;
    var v_$_hi = $x_1.h;
    bits.f4 = ((bits.f4 + (($m_jl_Integer$().cI(v_$_lo) + $m_jl_Integer$().cI(v_$_hi)) | 0)) | 0);
  });
  var len = ((xs.a.length >>> 1) | 0);
  var i = 0;
  if ((xs instanceof $ac_O)) {
    while ((i < len)) {
      var x0 = xs.a[i];
      f(x0);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_I)) {
    while ((i < len)) {
      var x0$1 = xs.a[i];
      f(x0$1);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_D)) {
    while ((i < len)) {
      var x0$2 = xs.a[i];
      f(x0$2);
      i = ((1 + i) | 0);
    }
  } else if ((xs !== null)) {
    while ((i < len)) {
      var $x_2 = xs.a;
      var $x_3 = (i << 1);
      var x0$3_$_lo = $x_2[$x_3];
      var x0$3_$_hi = $x_2[(($x_3 + 1) | 0)];
      f($bL(x0$3_$_lo, x0$3_$_hi));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_F)) {
    while ((i < len)) {
      var x0$4 = xs.a[i];
      f(x0$4);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_C)) {
    while ((i < len)) {
      var x0$5 = xs.a[i];
      f($bC(x0$5));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_B)) {
    while ((i < len)) {
      var x0$6 = xs.a[i];
      f(x0$6);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_S)) {
    while ((i < len)) {
      var x0$7 = xs.a[i];
      f(x0$7);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_Z)) {
    while ((i < len)) {
      var x0$8 = xs.a[i];
      f(x0$8);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(xs);
  }
  var value = bits.f4;
  return (((value ^ rawArgsLength_$_lo) | ((value >> 31) ^ rawArgsLength_$_hi)) !== 0);
});
$p.du = (function() {
  return this;
});
/** @constructor */
function $c_Lupickle_implicits_Readers$JavaReader(outer, evidence$1) {
  this.aev = null;
  this.Tf = null;
  this.aev = evidence$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Tf = outer;
}
$p = $c_Lupickle_implicits_Readers$JavaReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$JavaReader;
/** @constructor */
function $h_Lupickle_implicits_Readers$JavaReader() {
}
$h_Lupickle_implicits_Readers$JavaReader.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 1239034277;
});
$p.b = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lupickle_implicits_Readers$JavaReader) && (x$0.Tf === this.Tf)) || false));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "JavaReader";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ut = (function() {
  return this.aev;
});
function $isArrayOf_Lupickle_implicits_Readers$JavaReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jh)));
}
var $d_Lupickle_implicits_Readers$JavaReader = new $TypeData().i($c_Lupickle_implicits_Readers$JavaReader, "upickle.implicits.Readers$JavaReader", ({
  jh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$1(outer) {
  this.aeM = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeM = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$1() {
}
$h_Lupickle_implicits_Writers$$anon$1.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.aeM;
});
$p.EL = (function(v) {
  return v;
});
var $d_Lupickle_implicits_Writers$$anon$1 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$1, "upickle.implicits.Writers$$anon$1", ({
  ED: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$10(outer) {
  this.aeN = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeN = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$10;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$10() {
}
$h_Lupickle_implicits_Writers$$anon$10.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.aeN;
});
$p.EL = (function(v) {
  return v.g();
});
var $d_Lupickle_implicits_Writers$$anon$10 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$10, "upickle.implicits.Writers$$anon$10", ({
  EE: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$12(outer) {
  this.aeP = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeP = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$12;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$12() {
}
$h_Lupickle_implicits_Writers$$anon$12.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.aeP;
});
$p.EL = (function(v) {
  return v.g();
});
var $d_Lupickle_implicits_Writers$$anon$12 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$12, "upickle.implicits.Writers$$anon$12", ({
  EG: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$13(outer) {
  this.aeQ = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeQ = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$13;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$13() {
}
$h_Lupickle_implicits_Writers$$anon$13.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.aeQ;
});
$p.EL = (function(v) {
  return v.c4.g();
});
var $d_Lupickle_implicits_Writers$$anon$13 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$13, "upickle.implicits.Writers$$anon$13", ({
  EH: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$14(outer) {
  this.aeR = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeR = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$14;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$14() {
}
$h_Lupickle_implicits_Writers$$anon$14.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.T = (function() {
  return this.aeR;
});
$p.EL = (function(v) {
  return v.L2;
});
var $d_Lupickle_implicits_Writers$$anon$14 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$14, "upickle.implicits.Writers$$anon$14", ({
  EI: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$15(outer) {
  this.aeS = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeS = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$15.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$15;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$15() {
}
$h_Lupickle_implicits_Writers$$anon$15.prototype = $p;
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.Q = (function() {
  return true;
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_Writers$SimpleMapKeyWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aC5 = (function(v) {
  var x = $m_s_concurrent_duration_Duration$().Sd;
  if (((x === null) ? (v === null) : x.b(v))) {
    return "inf";
  } else {
    var x$3 = $m_s_concurrent_duration_Duration$().Se;
    if (((x$3 === null) ? (v === null) : x$3.b(v))) {
      return "-inf";
    } else if ((v === $m_s_concurrent_duration_Duration$().LB)) {
      return "undef";
    } else {
      var $x_1 = v.akc();
      var this$1_$_lo = $x_1.l;
      var this$1_$_hi = $x_1.h;
      return $m_RTLong$().gc(this$1_$_lo, this$1_$_hi);
    }
  }
});
$p.T = (function() {
  return this.aeS;
});
$p.EL = (function(v) {
  return this.aC5(v);
});
var $d_Lupickle_implicits_Writers$$anon$15 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$15, "upickle.implicits.Writers$$anon$15", ({
  EJ: 1,
  j: 1,
  k: 1,
  bg: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$16(inner$3, outer) {
  this.aeU = null;
  this.aeT = null;
  this.aeU = inner$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeT = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$16;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$16() {
}
$h_Lupickle_implicits_Writers$$anon$16.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.VW = (function(out, v) {
  var ctx = out.bt($m_s_Option$().hi(v).aH(), (-1));
  matchResult1: {
    if (($m_s_None$() === v)) {
      break matchResult1;
    }
    if ((v instanceof $c_s_Some)) {
      var next = v.bg;
      ctx.bu($f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aeU, ctx.bw(), next), (-1));
      break matchResult1;
    }
    throw new $c_s_MatchError(v);
  }
  return ctx.L((-1));
});
$p.T = (function() {
  return this.aeT;
});
$p.U = (function(out, v) {
  return this.VW(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$16 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$16, "upickle.implicits.Writers$$anon$16", ({
  EK: 1,
  j: 1,
  k: 1,
  cc: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$$anon$17(inner$4, outer) {
  this.aeW = null;
  this.aeV = null;
  this.aeW = inner$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeV = outer;
}
$p = $c_Lupickle_implicits_Writers$$anon$17.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$$anon$17;
/** @constructor */
function $h_Lupickle_implicits_Writers$$anon$17() {
}
$h_Lupickle_implicits_Writers$$anon$17.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.VW = (function(out, v) {
  if (($m_s_None$() === v)) {
    return out.M((-1));
  }
  if ((v instanceof $c_s_Some)) {
    var next = v.bg;
    return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.aeW, out, next);
  }
  throw new $c_s_MatchError(v);
});
$p.T = (function() {
  return this.aeV;
});
$p.U = (function(out, v) {
  return this.VW(out, v);
});
var $d_Lupickle_implicits_Writers$$anon$17 = new $TypeData().i($c_Lupickle_implicits_Writers$$anon$17, "upickle.implicits.Writers$$anon$17", ({
  EL: 1,
  j: 1,
  k: 1,
  cc: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Writers$JavaWriter(outer, evidence$1) {
  this.afa = null;
  this.Tl = null;
  this.afa = evidence$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Tl = outer;
}
$p = $c_Lupickle_implicits_Writers$JavaWriter.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Writers$JavaWriter;
/** @constructor */
function $h_Lupickle_implicits_Writers$JavaWriter() {
}
$h_Lupickle_implicits_Writers$JavaWriter.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 1394439509;
});
$p.b = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lupickle_implicits_Writers$JavaWriter) && (x$0.Tl === this.Tl)) || false));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "JavaWriter";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.uu = (function() {
  return this.afa;
});
function $isArrayOf_Lupickle_implicits_Writers$JavaWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jj)));
}
var $d_Lupickle_implicits_Writers$JavaWriter = new $TypeData().i($c_Lupickle_implicits_Writers$JavaWriter, "upickle.implicits.Writers$JavaWriter", ({
  jj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_InitializeScalaJS$$anon$1(freezePage$3) {
  this.VY = null;
  this.VY = freezePage$3;
}
$p = $c_Lcom_papasofokli_InitializeScalaJS$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_InitializeScalaJS$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_InitializeScalaJS$$anon$1() {
}
$h_Lcom_papasofokli_InitializeScalaJS$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.VY.ep();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_InitializeScalaJS$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_InitializeScalaJS$$anon$1, "com.papasofokli.InitializeScalaJS$$anon$1", ({
  jm: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_InitializeScalaJS$$anon$2() {
}
$p = $c_Lcom_papasofokli_InitializeScalaJS$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_InitializeScalaJS$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_InitializeScalaJS$$anon$2() {
}
$h_Lcom_papasofokli_InitializeScalaJS$$anon$2.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_InitializeScalaJS$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_InitializeScalaJS$$anon$2, "com.papasofokli.InitializeScalaJS$$anon$2", ({
  jn: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1(freezePage$11) {
  this.VZ = null;
  this.VZ = freezePage$11;
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  return this.VZ.ep();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$1, "com.papasofokli.agileboard.AgileBoardJs$$anon$1", ({
  jr: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2(freezePage$12) {
  this.W0 = null;
  this.W0 = freezePage$12;
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  this.W0.ep();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$2, "com.papasofokli.agileboard.AgileBoardJs$$anon$2", ({
  js: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3(freezePage$13, jq$5) {
  this.W1 = null;
  this.W2 = null;
  this.W1 = freezePage$13;
  this.W2 = jq$5;
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.W1.ep();
  this.W2.attr("disabled", false);
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardJs$$anon$3, "com.papasofokli.agileboard.AgileBoardJs$$anon$3", ({
  jt: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2(WritersVersionSpecific_this$15, outer) {
  this.W5 = null;
  this.W5 = WritersVersionSpecific_this$15;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azG = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boards", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_BoardData$().q(), this$2), v.hl);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "listUpdateFun", $m_Lupickle_default$().a1, v.uL);
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dropdownData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_DropdownData$().q(), this$5), v.qS);
    return ctx.L((-1));
  }
});
$p.aC6 = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boards", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_BoardData$().q(), this$2), v.hl);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "listUpdateFun", $m_Lupickle_default$().a1, v.uL);
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dropdownData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_DropdownData$().q(), this$5), v.qS);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.azG(out, v);
});
$p.ai = (function(ctx, v) {
  this.aC6(ctx, v);
});
$p.T = (function() {
  return this.W5;
});
var $d_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$2, "com.papasofokli.agileboard.AgileBoardListSetupData$$anon$2", ({
  jw: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardData$$anon$10(WritersVersionSpecific_this$19, outer) {
  this.W8 = null;
  this.W8 = WritersVersionSpecific_this$19;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_BoardData$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardData$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardData$$anon$10() {
}
$h_Lcom_papasofokli_agileboard_BoardData$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai3 = (function(v) {
  var x = v.kX;
  var x$2 = $m_s_None$();
  var $x_2 = ((x !== null) && x.b(x$2));
  var $x_1 = $m_sr_BoxesRunTime$().B(v.iz, false);
  var x$3 = v.jE;
  var x$4 = $m_s_None$();
  return ((3 + ((((1 + ((!$x_2) | 0)) | 0) + ((((!$x_1) | 0) + ((!((x$3 !== null) && x$3.b(x$4))) | 0)) | 0)) | 0)) | 0);
});
$p.azH = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai3(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.gC, v.gD));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $m_Lupickle_default$().m, v.qT);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elements", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_BoardElement$().q(), this$4), v.kY);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "enabled", $m_Lupickle_default$().aw, v.gg);
    var x = v.kX;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boardCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.kX);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.iz, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isTaskManager", $m_Lupickle_default$().aw, v.iz);
    }
    var x$3 = v.jE;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "countPerColumn", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jE);
    }
    return ctx.L((-1));
  }
});
$p.aC7 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.gC, v.gD));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $m_Lupickle_default$().m, v.qT);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elements", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_agileboard_BoardElement$().q(), this$4), v.kY);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "enabled", $m_Lupickle_default$().aw, v.gg);
  var x = v.kX;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boardCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.kX);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.iz, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isTaskManager", $m_Lupickle_default$().aw, v.iz);
  }
  var x$3 = v.jE;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "countPerColumn", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jE);
  }
});
$p.ah = (function(v) {
  return this.ai3(v);
});
$p.U = (function(out, v) {
  return this.azH(out, v);
});
$p.ai = (function(ctx, v) {
  this.aC7(ctx, v);
});
$p.T = (function() {
  return this.W8;
});
var $d_Lcom_papasofokli_agileboard_BoardData$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardData$$anon$10, "com.papasofokli.agileboard.BoardData$$anon$10", ({
  jz: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardElement$$anon$12(WritersVersionSpecific_this$20, outer) {
  this.Wb = null;
  this.Wb = WritersVersionSpecific_this$20;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_BoardElement$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardElement$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardElement$$anon$12() {
}
$h_Lcom_papasofokli_agileboard_BoardElement$$anon$12.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai4 = (function(v) {
  var x = v.iA;
  var x$2 = $m_sci_Nil$();
  var $x_8 = ((x !== null) && x.b(x$2));
  var x$3 = v.jF;
  var x$4 = $m_s_None$();
  var $x_7 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.eJ;
  var x$6 = $m_sci_Nil$();
  var $x_6 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.jG;
  var x$8 = $m_s_None$();
  var $x_5 = ((x$7 !== null) && x$7.b(x$8));
  var x$9 = v.gh;
  var x$10 = $m_s_None$();
  var $x_4 = ((x$9 !== null) && x$9.b(x$10));
  var x$11 = v.jI;
  var x$12 = $m_s_None$();
  var $x_3 = ((x$11 !== null) && x$11.b(x$12));
  var x$13 = v.l0;
  var x$14 = $m_s_None$();
  var $x_2 = ((x$13 !== null) && x$13.b(x$14));
  var x$15 = v.hS;
  var x$16 = $m_s_None$();
  var $x_1 = ((x$15 !== null) && x$15.b(x$16));
  var x$17 = v.kZ;
  var x$18 = $m_s_None$();
  return ((((7 + ((!$x_8) | 0)) | 0) + ((((((((!$x_7) | 0) + ((!$x_6) | 0)) | 0) + ((((!$x_5) | 0) + ((!$x_4) | 0)) | 0)) | 0) + ((((((!$x_3) | 0) + ((!$x_2) | 0)) | 0) + ((((!$x_1) | 0) + ((!((x$17 !== null) && x$17.b(x$18))) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.azI = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai4(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.hE, v.hF));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $m_Lupickle_default$().m, v.mT);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $m_Lupickle_default$().m, v.p2);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateTime", $m_Lupickle_default$().m, v.jH);
    var x = v.iA;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.b(x$2)))) {
      var this$8 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoBoardIcon", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), v.iA);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "info", $m_Lupickle_default$().m, v.l1);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sort", $m_Lupickle_default$().mu, v.qU);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isBlocked", $m_Lupickle_default$().aw, v.hR);
    var x$3 = v.jF;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalBtn", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jF);
    }
    var x$5 = v.eJ;
    var x$6 = $m_sci_Nil$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      var this$20 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalDataRows", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m), this$20), v.eJ);
    }
    var x$7 = v.jG;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.b(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "assignee", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jG);
    }
    var x$9 = v.gh;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "statusAndStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m)), v.gh);
    }
    var x$11 = v.jI;
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.b(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "instructionsO", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jI);
    }
    var x$13 = v.l0;
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.b(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "descriptionStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.l0);
    }
    var x$15 = v.hS;
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.b(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "taskTypeAndCancelComment", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple3Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m, $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m))), v.hS);
    }
    var x$17 = v.kZ;
    var x$18 = $m_s_None$();
    if ((!((x$17 !== null) && x$17.b(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdBy", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.kZ);
    }
    return ctx.L((-1));
  }
});
$p.aC8 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.hE, v.hF));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $m_Lupickle_default$().m, v.mT);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $m_Lupickle_default$().m, v.p2);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateTime", $m_Lupickle_default$().m, v.jH);
  var x = v.iA;
  var x$2 = $m_sci_Nil$();
  if ((!((x !== null) && x.b(x$2)))) {
    var this$8 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoBoardIcon", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), v.iA);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "info", $m_Lupickle_default$().m, v.l1);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sort", $m_Lupickle_default$().mu, v.qU);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isBlocked", $m_Lupickle_default$().aw, v.hR);
  var x$3 = v.jF;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalBtn", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jF);
  }
  var x$5 = v.eJ;
  var x$6 = $m_sci_Nil$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    var this$20 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalDataRows", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m), this$20), v.eJ);
  }
  var x$7 = v.jG;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.b(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "assignee", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jG);
  }
  var x$9 = v.gh;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "statusAndStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m)), v.gh);
  }
  var x$11 = v.jI;
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.b(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "instructionsO", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jI);
  }
  var x$13 = v.l0;
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.b(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "descriptionStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.l0);
  }
  var x$15 = v.hS;
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.b(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "taskTypeAndCancelComment", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple3Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().m, $m_Lupickle_default$().m, $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m))), v.hS);
  }
  var x$17 = v.kZ;
  var x$18 = $m_s_None$();
  if ((!((x$17 !== null) && x$17.b(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "createdBy", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.kZ);
  }
});
$p.ah = (function(v) {
  return this.ai4(v);
});
$p.U = (function(out, v) {
  return this.azI(out, v);
});
$p.ai = (function(ctx, v) {
  this.aC8(ctx, v);
});
$p.T = (function() {
  return this.Wb;
});
var $d_Lcom_papasofokli_agileboard_BoardElement$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardElement$$anon$12, "com.papasofokli.agileboard.BoardElement$$anon$12", ({
  jD: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_DropdownData$$anon$14(WritersVersionSpecific_this$21, outer) {
  this.We = null;
  this.We = WritersVersionSpecific_this$21;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_DropdownData$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_DropdownData$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_DropdownData$$anon$14() {
}
$h_Lcom_papasofokli_agileboard_DropdownData$$anon$14.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azJ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.uN);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().a1, v.uM);
    return ctx.L((-1));
  }
});
$p.aC9 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.uN);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().a1, v.uM);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azJ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aC9(ctx, v);
});
$p.T = (function() {
  return this.We;
});
var $d_Lcom_papasofokli_agileboard_DropdownData$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_agileboard_DropdownData$$anon$14, "com.papasofokli.agileboard.DropdownData$$anon$14", ({
  jG: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6(WritersVersionSpecific_this$17, outer) {
  this.Wh = null;
  this.Wh = WritersVersionSpecific_this$17;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6() {
}
$h_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azK = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.z6, v.z7));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.uO);
    return ctx.L((-1));
  }
});
$p.aCa = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.z6, v.z7));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.uO);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azK(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCa(ctx, v);
});
$p.T = (function() {
  return this.Wh;
});
var $d_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$6, "com.papasofokli.agileboard.ItemClickRequest$$anon$6", ({
  jJ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4(WritersVersionSpecific_this$16, outer) {
  this.Wk = null;
  this.Wk = WritersVersionSpecific_this$16;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4() {
}
$h_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azL = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boardId", $m_Lupickle_default$().ay, $bL(v.z8, v.z9));
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "items", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$3), v.uP);
    return ctx.L((-1));
  }
});
$p.aCb = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "boardId", $m_Lupickle_default$().ay, $bL(v.z8, v.z9));
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "items", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$3), v.uP);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azL(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCb(ctx, v);
});
$p.T = (function() {
  return this.Wk;
});
var $d_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$4, "com.papasofokli.agileboard.RequestBoardData$$anon$4", ({
  jM: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8(WritersVersionSpecific_this$18, outer) {
  this.Wn = null;
  this.Wn = WritersVersionSpecific_this$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8() {
}
$h_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azM = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "previousId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.Ad);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selectedId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.Ae);
    return ctx.L((-1));
  }
});
$p.aCc = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "previousId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.Ad);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selectedId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.Ae);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azM(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCc(ctx, v);
});
$p.T = (function() {
  return this.Wn;
});
var $d_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$8, "com.papasofokli.agileboard.SelectedIdsRequest$$anon$8", ({
  jP: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_box_BoxData$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.Wq = null;
  this.Wq = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_box_BoxData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_box_BoxData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_box_BoxData$$anon$2() {
}
$h_Lcom_papasofokli_box_BoxData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai5 = (function(v) {
  return ((((((2 + ((v.mV !== "") | 0)) | 0) + ((((!$m_sr_BoxesRunTime$().B(v.l4, true)) | 0) + ((1 + ((!$m_sr_BoxesRunTime$().B(v.l3, true)) | 0)) | 0)) | 0)) | 0) + ((5 + ((!$m_sr_BoxesRunTime$().B(v.l2, false)) | 0)) | 0)) | 0);
});
$p.azN = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai5(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.r1);
    if ((v.mV !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contents", $m_Lupickle_default$().m, v.mV);
    }
    var $x_1 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2)))), v.r0);
    if ((!$m_sr_BoxesRunTime$().B(v.l4, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hasRow", $m_Lupickle_default$().aw, v.l4);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.l3, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hasButtons", $m_Lupickle_default$().aw, v.l3);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headerContextualBackground", $m_Lupickle_default$().m, v.qZ);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextualBackground", $m_Lupickle_default$().m, v.qX);
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chevronUp", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$1) => _$1$2$1))), v.qV);
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chevronDown", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$2) => _$1$2$2))), v.mU);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentFunctionId", $m_Lupickle_default$().a1, v.qW);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssStyle", $m_Lupickle_default$().m, v.qY);
    if ((!$m_sr_BoxesRunTime$().B(v.l2, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expanded", $m_Lupickle_default$().aw, v.l2);
    }
    return ctx.L((-1));
  }
});
$p.aCd = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.r1);
  if ((v.mV !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contents", $m_Lupickle_default$().m, v.mV);
  }
  var $x_1 = $m_Lupickle_default$();
  $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2)))), v.r0);
  if ((!$m_sr_BoxesRunTime$().B(v.l4, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hasRow", $m_Lupickle_default$().aw, v.l4);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.l3, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hasButtons", $m_Lupickle_default$().aw, v.l3);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headerContextualBackground", $m_Lupickle_default$().m, v.qZ);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextualBackground", $m_Lupickle_default$().m, v.qX);
  $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chevronUp", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$1) => _$1$2$1))), v.qV);
  $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chevronDown", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$2) => _$1$2$2))), v.mU);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentFunctionId", $m_Lupickle_default$().a1, v.qW);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssStyle", $m_Lupickle_default$().m, v.qY);
  if ((!$m_sr_BoxesRunTime$().B(v.l2, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expanded", $m_Lupickle_default$().aw, v.l2);
  }
});
$p.ah = (function(v) {
  return this.ai5(v);
});
$p.U = (function(out, v) {
  return this.azN(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCd(ctx, v);
});
$p.T = (function() {
  return this.Wq;
});
var $d_Lcom_papasofokli_box_BoxData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_box_BoxData$$anon$2, "com.papasofokli.box.BoxData$$anon$2", ({
  jZ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1(freezePage$7, element$11, inner$5) {
  this.Wr = null;
  this.NO = null;
  this.Ws = null;
  this.Wr = freezePage$7;
  this.NO = element$11;
  this.Ws = inner$5;
}
$p = $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1() {
}
$h_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.Wr.ep();
  $m_sjs_js_timers_package$().gb(3000.0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    this.NO.innerHTML = this.Ws;
    this.NO.disabled = false;
  })));
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$1, "com.papasofokli.buttons.ButtonsInitializer$$anon$1", ({
  k1: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2(freezePage$9) {
  this.Wt = null;
  this.Wt = freezePage$9;
}
$p = $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2() {
}
$h_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.Wt.ep();
  return false;
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_buttons_ButtonsInitializer$$anon$2, "com.papasofokli.buttons.ButtonsInitializer$$anon$2", ({
  k2: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1(freezePage$5, jq$5) {
  this.Wu = null;
  this.Wv = null;
  this.Wu = freezePage$5;
  this.Wv = jq$5;
}
$p = $c_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1() {
}
$h_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.Wu.ep();
  this.Wv.attr("disabled", false);
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_buttons_DropdownButtonJs$$anon$1, "com.papasofokli.buttons.DropdownButtonJs$$anon$1", ({
  k5: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS(chartType, onClickResponse, pointAndLegendResponse, chartTimePeriod, maxHeight, data, shortLabel, stacked, horizontal, customWidth) {
  this.gi = null;
  this.hn = false;
  this.gR = false;
  this.gP = null;
  this.gQ = 0;
  this.hm = null;
  this.gS = false;
  this.gT = false;
  this.gj = false;
  this.fT = null;
  this.gi = chartType;
  this.hn = onClickResponse;
  this.gR = pointAndLegendResponse;
  this.gP = chartTimePeriod;
  this.gQ = maxHeight;
  this.hm = data;
  this.gS = shortLabel;
  this.gT = stacked;
  this.gj = horizontal;
  this.fT = customWidth;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 555448699);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gi));
  acc = $m_sr_Statics$().d(acc, (this.hn ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.gR ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gP));
  acc = $m_sr_Statics$().d(acc, this.gQ);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hm));
  acc = $m_sr_Statics$().d(acc, (this.gS ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.gT ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.gj ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.fT));
  return $m_sr_Statics$().an(acc, 10);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS)) {
    if (((((((((this.hn === x$0.hn) && (this.gR === x$0.gR)) && (this.gQ === x$0.gQ)) && (this.gS === x$0.gS)) && (this.gT === x$0.gT)) && (this.gj === x$0.gj)) && (this.gi === x$0.gi)) && (this.gP === x$0.gP))) {
      var x = this.hm;
      var x$2 = x$0.hm;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.fT;
      var x$4 = x$0.fT;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 10;
});
$p.A = (function() {
  return "ChartConfigurationS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.gi;
      break;
    }
    case 1: {
      return this.hn;
      break;
    }
    case 2: {
      return this.gR;
      break;
    }
    case 3: {
      return this.gP;
      break;
    }
    case 4: {
      return this.gQ;
      break;
    }
    case 5: {
      return this.hm;
      break;
    }
    case 6: {
      return this.gS;
      break;
    }
    case 7: {
      return this.gT;
      break;
    }
    case 8: {
      return this.gj;
      break;
    }
    case 9: {
      return this.fT;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
Object.defineProperty($p, "chartType", ({
  "get": (function() {
    return this.gi;
  }),
  "set": (function(arg) {
    this.gi = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "pointAndLegendResponse", ({
  "get": (function() {
    return this.gR;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.gR = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "data", ({
  "get": (function() {
    return this.hm;
  }),
  "set": (function(arg) {
    this.hm = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "maxHeight", ({
  "get": (function() {
    return this.gQ;
  }),
  "set": (function(arg) {
    var prep0 = (arg | 0);
    this.gQ = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "chartTimePeriod", ({
  "get": (function() {
    return this.gP;
  }),
  "set": (function(arg) {
    this.gP = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "stacked", ({
  "get": (function() {
    return this.gT;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.gT = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "customWidth", ({
  "get": (function() {
    return this.fT;
  }),
  "set": (function(arg) {
    this.fT = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "horizontal", ({
  "get": (function() {
    return this.gj;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.gj = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "onClickResponse", ({
  "get": (function() {
    return this.hn;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.hn = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "shortLabel", ({
  "get": (function() {
    return this.gS;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.gS = prep0;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_chartJSv2x_ChartConfigurationS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dk)));
}
var $d_Lcom_papasofokli_chartJSv2x_ChartConfigurationS = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS, "com.papasofokli.chartJSv2x.ChartConfigurationS", ({
  dk: 1,
  bh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4(WritersVersionSpecific_this$12, outer) {
  this.Wy = null;
  this.Wy = WritersVersionSpecific_this$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai6 = (function(v) {
  var $x_7 = $m_sr_BoxesRunTime$().B(v.hn, true);
  var $x_6 = $m_sr_BoxesRunTime$().B(v.gR, false);
  var $x_5 = v.gP;
  var $x_4 = $m_sr_BoxesRunTime$().dG(v.gQ, 300);
  var $x_3 = $m_sr_BoxesRunTime$().B(v.gS, true);
  var $x_2 = $m_sr_BoxesRunTime$().B(v.gT, false);
  var $x_1 = $m_sr_BoxesRunTime$().B(v.gj, false);
  var x$5 = v.fT;
  var x$2$1 = $m_s_None$();
  return ((((((1 + ((!$x_7) | 0)) | 0) + ((((!$x_6) | 0) + (((($x_5 !== "") | 0) + ((!$x_4) | 0)) | 0)) | 0)) | 0) + ((((1 + ((!$x_3) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$5 !== null) && x$5.b(x$2$1))) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.azO = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai6(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartType", $m_Lupickle_default$().m, v.gi);
    if ((!$m_sr_BoxesRunTime$().B(v.hn, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "onClickResponse", $m_Lupickle_default$().aw, v.hn);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.gR, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pointAndLegendResponse", $m_Lupickle_default$().aw, v.gR);
    }
    if ((v.gP !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartTimePeriod", $m_Lupickle_default$().m, v.gP);
    }
    if ((!$m_sr_BoxesRunTime$().dG(v.gQ, 300))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxHeight", $m_Lupickle_default$().ao, v.gQ);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lcom_papasofokli_chartJSv2x_ChartDataS$().UA(), v.hm);
    if ((!$m_sr_BoxesRunTime$().B(v.gS, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().aw, v.gS);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.gT, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "stacked", $m_Lupickle_default$().aw, v.gT);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.gj, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "horizontal", $m_Lupickle_default$().aw, v.gj);
    }
    var x$5 = v.fT;
    var x$2$1 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$2$1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.fT);
    }
    return ctx.L((-1));
  }
});
$p.aCe = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartType", $m_Lupickle_default$().m, v.gi);
  if ((!$m_sr_BoxesRunTime$().B(v.hn, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "onClickResponse", $m_Lupickle_default$().aw, v.hn);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.gR, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pointAndLegendResponse", $m_Lupickle_default$().aw, v.gR);
  }
  if ((v.gP !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartTimePeriod", $m_Lupickle_default$().m, v.gP);
  }
  if ((!$m_sr_BoxesRunTime$().dG(v.gQ, 300))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxHeight", $m_Lupickle_default$().ao, v.gQ);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lcom_papasofokli_chartJSv2x_ChartDataS$().UA(), v.hm);
  if ((!$m_sr_BoxesRunTime$().B(v.gS, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().aw, v.gS);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.gT, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "stacked", $m_Lupickle_default$().aw, v.gT);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.gj, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "horizontal", $m_Lupickle_default$().aw, v.gj);
  }
  var x$5 = v.fT;
  var x$2$1 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$2$1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.fT);
  }
});
$p.ah = (function(v) {
  return this.ai6(v);
});
$p.U = (function(out, v) {
  return this.azO(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCe(ctx, v);
});
$p.T = (function() {
  return this.Wy;
});
var $d_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$4, "com.papasofokli.chartJSv2x.ChartConfigurationS$$anon$4", ({
  k9: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDataS(labels, datasets, notes, legends) {
  this.l5 = null;
  this.ho = null;
  this.hp = null;
  this.jJ = null;
  this.l5 = labels;
  this.ho = datasets;
  this.hp = notes;
  this.jJ = legends;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDataS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDataS;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDataS() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDataS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1389879853, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDataS) && ((($m_sr_BoxesRunTime$().B(this.l5, x$0.l5) && $m_sr_BoxesRunTime$().B(this.ho, x$0.ho)) && $m_sr_BoxesRunTime$().B(this.hp, x$0.hp)) && $m_sr_BoxesRunTime$().B(this.jJ, x$0.jJ))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "ChartDataS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.l5;
      break;
    }
    case 1: {
      return this.ho;
      break;
    }
    case 2: {
      return this.hp;
      break;
    }
    case 3: {
      return this.jJ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
Object.defineProperty($p, "labels", ({
  "get": (function() {
    return this.l5;
  }),
  "set": (function(arg) {
    this.l5 = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "notes", ({
  "get": (function() {
    return this.hp;
  }),
  "set": (function(arg) {
    this.hp = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "datasets", ({
  "get": (function() {
    return this.ho;
  }),
  "set": (function(arg) {
    this.ho = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "legends", ({
  "get": (function() {
    return this.jJ;
  }),
  "set": (function(arg) {
    this.jJ = arg;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_chartJSv2x_ChartDataS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dl)));
}
var $d_Lcom_papasofokli_chartJSv2x_ChartDataS = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDataS, "com.papasofokli.chartJSv2x.ChartDataS", ({
  dl: 1,
  bh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6(WritersVersionSpecific_this$13, outer) {
  this.WB = null;
  this.WB = WritersVersionSpecific_this$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai7 = (function(v) {
  return ((2 + ((((!$m_sr_BoxesRunTime$().B(v.hp, $m_sci_Seq$().dj())) | 0) + ((!$m_sr_BoxesRunTime$().B(v.jJ, $m_sci_Seq$().dj())) | 0)) | 0)) | 0);
});
$p.azP = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai7(v), true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labels", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$2), v.l5);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "datasets", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_chartJSv2x_ChartDatasetS$().UB(), this$4), v.ho);
    if ((!$m_sr_BoxesRunTime$().B(v.hp, $m_sci_Seq$().dj()))) {
      var this$8 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), v.hp);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.jJ, $m_sci_Seq$().dj()))) {
      var this$12 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "legends", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$12), v.jJ);
    }
    return ctx.L((-1));
  }
});
$p.aCf = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "labels", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$2), v.l5);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "datasets", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_chartJSv2x_ChartDatasetS$().UB(), this$4), v.ho);
  if ((!$m_sr_BoxesRunTime$().B(v.hp, $m_sci_Seq$().dj()))) {
    var this$8 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "notes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), v.hp);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.jJ, $m_sci_Seq$().dj()))) {
    var this$12 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "legends", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$12), v.jJ);
  }
});
$p.ah = (function(v) {
  return this.ai7(v);
});
$p.U = (function(out, v) {
  return this.azP(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCf(ctx, v);
});
$p.T = (function() {
  return this.WB;
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$6, "com.papasofokli.chartJSv2x.ChartDataS$$anon$6", ({
  kc: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8(WritersVersionSpecific_this$14, outer) {
  this.WE = null;
  this.WE = WritersVersionSpecific_this$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai8 = (function(v) {
  return ((((3 + ((v.jM !== "") | 0)) | 0) + ((((1 + ((v.iC !== "") | 0)) | 0) + ((((!$m_sr_BoxesRunTime$().B(v.iB, $m_sci_Seq$().dj())) | 0) + ((!$m_sr_BoxesRunTime$().B(v.jK, $m_sci_Seq$().dj())) | 0)) | 0)) | 0)) | 0);
});
$p.azQ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai8(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().m, v.l6);
    if ((v.jM !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().m, v.jM);
    }
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "backgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), v.mW);
    var this$7 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hoverBackgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7), v.mX);
    var this$9 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().h8, this$9), v.jL);
    if ((v.iC !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "type", $m_Lupickle_default$().m, v.iC);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.iB, $m_sci_Seq$().dj()))) {
      var this$15 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compactData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$15), v.iB);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.jK, $m_sci_Seq$().dj()))) {
      var this$19 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "borderColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$19), v.jK);
    }
    return ctx.L((-1));
  }
});
$p.aCg = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().m, v.l6);
  if ((v.jM !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().m, v.jM);
  }
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "backgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), v.mW);
  var this$7 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hoverBackgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7), v.mX);
  var this$9 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().h8, this$9), v.jL);
  if ((v.iC !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "type", $m_Lupickle_default$().m, v.iC);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.iB, $m_sci_Seq$().dj()))) {
    var this$15 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compactData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$15), v.iB);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.jK, $m_sci_Seq$().dj()))) {
    var this$19 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "borderColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$19), v.jK);
  }
});
$p.ah = (function(v) {
  return this.ai8(v);
});
$p.U = (function(out, v) {
  return this.azQ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCg(ctx, v);
});
$p.T = (function() {
  return this.WE;
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$8, "com.papasofokli.chartJSv2x.ChartDatasetDoubleS$$anon$8", ({
  kf: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10(WritersVersionSpecific_this$15, outer) {
  this.WJ = null;
  this.WJ = WritersVersionSpecific_this$15;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ai9 = (function(v) {
  return ((((((1 + ((v.iE !== "") | 0)) | 0) + ((2 + ((v.hX !== "") | 0)) | 0)) | 0) + ((((((!$m_sr_BoxesRunTime$().B(v.hW, true)) | 0) + ((1 + ((!$m_sr_BoxesRunTime$().B(v.hU, false)) | 0)) | 0)) | 0) + ((((!$m_sr_BoxesRunTime$().dG(v.hV, 1)) | 0) + ((1 + ((!$m_sr_BoxesRunTime$().B(v.hT, $m_sci_Seq$().dj())) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.azR = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ai9(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().m, v.jN);
    if ((v.iE !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().m, v.iE);
    }
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "backgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), v.l7);
    var this$7 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hoverBackgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7), v.l9);
    if ((v.hX !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "type", $m_Lupickle_default$().m, v.hX);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.hW, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showLine", $m_Lupickle_default$().aw, v.hW);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.hU, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fill", $m_Lupickle_default$().aw, v.hU);
    }
    var this$15 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "borderColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$15), v.l8);
    if ((!$m_sr_BoxesRunTime$().dG(v.hV, 1))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pointRadius", $m_Lupickle_default$().ao, v.hV);
    }
    var this$19 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_chartJSv2x_XY$().q(), this$19), v.iD);
    if ((!$m_sr_BoxesRunTime$().B(v.hT, $m_sci_Seq$().dj()))) {
      var this$23 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compactData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$23), v.hT);
    }
    return ctx.L((-1));
  }
});
$p.aCh = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "label", $m_Lupickle_default$().m, v.jN);
  if ((v.iE !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortLabel", $m_Lupickle_default$().m, v.iE);
  }
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "backgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), v.l7);
  var this$7 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hoverBackgroundColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$7), v.l9);
  if ((v.hX !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "type", $m_Lupickle_default$().m, v.hX);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.hW, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showLine", $m_Lupickle_default$().aw, v.hW);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.hU, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fill", $m_Lupickle_default$().aw, v.hU);
  }
  var this$15 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "borderColor", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$15), v.l8);
  if ((!$m_sr_BoxesRunTime$().dG(v.hV, 1))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pointRadius", $m_Lupickle_default$().ao, v.hV);
  }
  var this$19 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_chartJSv2x_XY$().q(), this$19), v.iD);
  if ((!$m_sr_BoxesRunTime$().B(v.hT, $m_sci_Seq$().dj()))) {
    var this$23 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compactData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$23), v.hT);
  }
});
$p.ah = (function(v) {
  return this.ai9(v);
});
$p.U = (function(out, v) {
  return this.azR(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCh(ctx, v);
});
$p.T = (function() {
  return this.WJ;
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$10, "com.papasofokli.chartJSv2x.ChartDatasetXYS$$anon$10", ({
  ki: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_XY(x, y) {
  this.mY = 0.0;
  this.la = 0.0;
  this.mY = x;
  this.la = y;
}
$p = $c_Lcom_papasofokli_chartJSv2x_XY.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_XY;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_XY() {
}
$h_Lcom_papasofokli_chartJSv2x_XY.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 2817);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.mY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.la));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_chartJSv2x_XY) && ((this.mY === x$0.mY) && (this.la === x$0.la))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "XY";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.mY;
  }
  if ((n === 1)) {
    return this.la;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
Object.defineProperty($p, "x", ({
  "get": (function() {
    return this.mY;
  }),
  "set": (function(arg) {
    var prep0 = (+arg);
    this.mY = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "y", ({
  "get": (function() {
    return this.la;
  }),
  "set": (function(arg) {
    var prep0 = (+arg);
    this.la = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "t", ({
  "get": (function() {
    return (void 0);
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_chartJSv2x_XY(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dp)));
}
var $d_Lcom_papasofokli_chartJSv2x_XY = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_XY, "com.papasofokli.chartJSv2x.XY", ({
  dp: 1,
  bh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_XY$$anon$2(WritersVersionSpecific_this$11, outer) {
  this.WM = null;
  this.WM = WritersVersionSpecific_this$11;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_chartJSv2x_XY$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_XY$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_XY$$anon$2() {
}
$h_Lcom_papasofokli_chartJSv2x_XY$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azS = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "x", $m_Lupickle_default$().h8, v.mY);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "y", $m_Lupickle_default$().h8, v.la);
    return ctx.L((-1));
  }
});
$p.aCi = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "x", $m_Lupickle_default$().h8, v.mY);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "y", $m_Lupickle_default$().h8, v.la);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azS(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCi(ctx, v);
});
$p.T = (function() {
  return this.WM;
});
var $d_Lcom_papasofokli_chartJSv2x_XY$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_XY$$anon$2, "com.papasofokli.chartJSv2x.XY$$anon$2", ({
  km: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_communication_OutlookData$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.WS = null;
  this.WS = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_communication_OutlookData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_communication_OutlookData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_communication_OutlookData$$anon$2() {
}
$h_Lcom_papasofokli_communication_OutlookData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aia = (function(v) {
  var $x_2 = v.mZ;
  var x = v.jO;
  var x$2 = $m_s_None$();
  var $x_1 = ((x !== null) && x.b(x$2));
  var x$3 = v.ld;
  var x$4 = $m_s_None$();
  return ((((3 + (($x_2 !== "") | 0)) | 0) + ((((((!$x_1) | 0) + ((!((x$3 !== null) && x$3.b(x$4))) | 0)) | 0) + ((((!$m_sr_BoxesRunTime$().B(v.lb, true)) | 0) + ((!$m_sr_BoxesRunTime$().B(v.lc, false)) | 0)) | 0)) | 0)) | 0);
});
$p.azT = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aia(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.mw, v.mx));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.r3);
    if ((v.mZ !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "summary", $m_Lupickle_default$().m, v.mZ);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateText", $m_Lupickle_default$().m, v.r2);
    var x = v.jO;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "severityName", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jO);
    }
    var x$3 = v.ld;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "severityStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ld);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lb, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isViewed", $m_Lupickle_default$().aw, v.lb);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lc, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pinOnTop", $m_Lupickle_default$().aw, v.lc);
    }
    return ctx.L((-1));
  }
});
$p.aCj = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.mw, v.mx));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.r3);
  if ((v.mZ !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "summary", $m_Lupickle_default$().m, v.mZ);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateText", $m_Lupickle_default$().m, v.r2);
  var x = v.jO;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "severityName", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jO);
  }
  var x$3 = v.ld;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "severityStyle", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ld);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lb, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isViewed", $m_Lupickle_default$().aw, v.lb);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lc, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pinOnTop", $m_Lupickle_default$().aw, v.lc);
  }
});
$p.ah = (function(v) {
  return this.aia(v);
});
$p.U = (function(out, v) {
  return this.azT(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCj(ctx, v);
});
$p.T = (function() {
  return this.WS;
});
var $d_Lcom_papasofokli_communication_OutlookData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_communication_OutlookData$$anon$2, "com.papasofokli.communication.OutlookData$$anon$2", ({
  kU: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20(WritersVersionSpecific_this$30, outer) {
  this.X6 = null;
  this.X6 = WritersVersionSpecific_this$30;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aib = (function(v) {
  var x = v.n3;
  var x$2 = $m_s_None$();
  var $x_2 = ((x !== null) && x.b(x$2));
  var x$3 = v.n2;
  var x$4 = $m_s_None$();
  var $x_1 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.n1;
  var x$6 = $m_s_None$();
  return ((((1 + ((!$x_2) | 0)) | 0) + ((((!$x_1) | 0) + ((!((x$5 !== null) && x$5.b(x$6))) | 0)) | 0)) | 0);
});
$p.azU = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aib(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnDisplayName", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.p5);
    var x = v.n3;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "numericValueO", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.n3);
    }
    var x$3 = v.n2;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupOption", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n2);
    }
    var x$5 = v.n1;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n1);
    }
    return ctx.L((-1));
  }
});
$p.aCk = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnDisplayName", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.p5);
  var x = v.n3;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "numericValueO", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.n3);
  }
  var x$3 = v.n2;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupOption", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n2);
  }
  var x$5 = v.n1;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n1);
  }
});
$p.ah = (function(v) {
  return this.aib(v);
});
$p.U = (function(out, v) {
  return this.azU(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCk(ctx, v);
});
$p.T = (function() {
  return this.X6;
});
var $d_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$20, "com.papasofokli.dataTables.ColumnGroup$$anon$20", ({
  le: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18(WritersVersionSpecific_this$29, outer) {
  this.X9 = null;
  this.X9 = WritersVersionSpecific_this$29;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aic = (function(v) {
  return ((1 + ((!$m_sr_BoxesRunTime$().dG(v.iF, 0)) | 0)) | 0);
});
$p.azV = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aic(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.p6);
    if ((!$m_sr_BoxesRunTime$().dG(v.iF, 0))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupByOption", $m_Lupickle_default$().ao, v.iF);
    }
    return ctx.L((-1));
  }
});
$p.aCl = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.p6);
  if ((!$m_sr_BoxesRunTime$().dG(v.iF, 0))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupByOption", $m_Lupickle_default$().ao, v.iF);
  }
});
$p.ah = (function(v) {
  return this.aic(v);
});
$p.U = (function(out, v) {
  return this.azV(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCl(ctx, v);
});
$p.T = (function() {
  return this.X9;
});
var $d_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$18, "com.papasofokli.dataTables.ColumnGroupOption$$anon$18", ({
  lh: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.Xc = null;
  this.Xc = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2() {
}
$h_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azW = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headerName", $m_Lupickle_default$().m, v.An);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pastValues", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$3), v.Ao);
    return ctx.L((-1));
  }
});
$p.aCm = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headerName", $m_Lupickle_default$().m, v.An);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pastValues", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$3), v.Ao);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.azW(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCm(ctx, v);
});
$p.T = (function() {
  return this.Xc;
});
var $d_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$2, "com.papasofokli.dataTables.CsvPasteHeader$$anon$2", ({
  lk: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2(WritersVersionSpecific_this$21, outer) {
  this.Xf = null;
  this.Xf = WritersVersionSpecific_this$21;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2() {
}
$h_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aid = (function(v) {
  var x = v.n5;
  var x$2 = $m_s_None$();
  var $x_3 = ((x !== null) && x.b(x$2));
  var $x_2 = $m_sr_BoxesRunTime$().B(v.jR, false);
  var x$3 = v.n7;
  var x$4 = $m_Lcom_papasofokli_dataTables_GetRowsResult$().oB();
  var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
  var x$5 = v.jQ;
  var x$6 = $m_s_Option$().Z("average");
  return ((5 + ((((2 + ((!$x_3) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$5 === null) ? (x$6 === null) : x$5.b(x$6))) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.azX = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aid(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "draw", $m_Lupickle_default$().ao, v.p7);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordsTotal", $m_Lupickle_default$().ao, v.hq);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordsFiltered", $m_Lupickle_default$().ao, v.jS);
    var this$6 = $m_Lupickle_default$();
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22(new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), this$6), v.n4);
    var this$8 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupedData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$().q(), this$8), v.n6);
    var this$10 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_GroupedRowChartData$().q(), this$10), v.v1);
    var x = v.n5;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n5);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "error", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.v2);
    if ((!$m_sr_BoxesRunTime$().B(v.jR, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "partialLoad", $m_Lupickle_default$().aw, v.jR);
    }
    var x$3 = v.n7;
    var x$4 = $m_Lcom_papasofokli_dataTables_GetRowsResult$().oB();
    if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
      var this$22 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$22), v.n7);
    }
    var x$5 = v.jQ;
    var x$6 = $m_s_Option$().Z("average");
    if ((!((x$5 === null) ? (x$6 === null) : x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jQ);
    }
    return ctx.L((-1));
  }
});
$p.aCn = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "draw", $m_Lupickle_default$().ao, v.p7);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordsTotal", $m_Lupickle_default$().ao, v.hq);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordsFiltered", $m_Lupickle_default$().ao, v.jS);
  var this$6 = $m_Lupickle_default$();
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22(new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$5), this$6), v.n4);
  var this$8 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupedData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$().q(), this$8), v.n6);
  var this$10 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_GroupedRowChartData$().q(), this$10), v.v1);
  var x = v.n5;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.n5);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "error", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.v2);
  if ((!$m_sr_BoxesRunTime$().B(v.jR, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "partialLoad", $m_Lupickle_default$().aw, v.jR);
  }
  var x$3 = v.n7;
  var x$4 = $m_Lcom_papasofokli_dataTables_GetRowsResult$().oB();
  if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
    var this$22 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$22), v.n7);
  }
  var x$5 = v.jQ;
  var x$6 = $m_s_Option$().Z("average");
  if ((!((x$5 === null) ? (x$6 === null) : x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jQ);
  }
});
$p.ah = (function(v) {
  return this.aid(v);
});
$p.U = (function(out, v) {
  return this.azX(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCn(ctx, v);
});
$p.T = (function() {
  return this.Xf;
});
var $d_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$2, "com.papasofokli.dataTables.GetRowsResult$$anon$2", ({
  ln: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16(WritersVersionSpecific_this$28, outer) {
  this.Xi = null;
  this.Xi = WritersVersionSpecific_this$28;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azY = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.v4);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "counter", $m_Lupickle_default$().ao, v.v3);
    var this$7 = $m_Lupickle_default$();
    var $x_2 = $m_Lupickle_default$();
    var $x_1 = $m_Lupickle_default$().ao;
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "values", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($x_2, $x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().h8, this$5)), this$7), v.v5);
    return ctx.L((-1));
  }
});
$p.aCo = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.v4);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "counter", $m_Lupickle_default$().ao, v.v3);
  var this$7 = $m_Lupickle_default$();
  var $x_2 = $m_Lupickle_default$();
  var $x_1 = $m_Lupickle_default$().ao;
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "values", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($x_2, $x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().h8, this$5)), this$7), v.v5);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.azY(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCo(ctx, v);
});
$p.T = (function() {
  return this.Xi;
});
var $d_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$16, "com.papasofokli.dataTables.GroupedRowChartData$$anon$16", ({
  lq: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14(WritersVersionSpecific_this$27, outer) {
  this.Xl = null;
  this.Xl = WritersVersionSpecific_this$27;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.azZ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.r5);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroup", $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), v.v6);
    var this$6 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "values", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().m), this$6), v.r6);
    return ctx.L((-1));
  }
});
$p.aCp = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.r5);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroup", $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), v.v6);
  var this$6 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "values", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().m), this$6), v.r6);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.azZ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCp(ctx, v);
});
$p.T = (function() {
  return this.Xl;
});
var $d_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$14, "com.papasofokli.dataTables.GroupedRowSummaryData$$anon$14", ({
  lt: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1.prototype = $p;
$p.jt = (function(x) {
  return ((!$f_sc_MapOps__contains__O__Z(new $c_Lorg_scalajs_dom_NamedNodeMapMap(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x.children).l().e().attributes), "colspan")) || false);
});
$p.jk = (function(x, default$1) {
  return ((!$f_sc_MapOps__contains__O__Z(new $c_Lorg_scalajs_dom_NamedNodeMapMap(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x.children).l().e().attributes), "colspan")) ? x.firstChild.innerText : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$1, "com.papasofokli.dataTables.ScalaJsTable$$anon$1", ({
  lv: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10.prototype = $p;
$p.IP = (function(x) {
  var this$1 = x.jT;
  if (($f_T__trim__T(this$1.toLowerCase()) === "id")) {
    return true;
  } else {
    return false;
  }
});
$p.Io = (function(x, default$1) {
  var this$1 = x.jT;
  if (($f_T__trim__T(this$1.toLowerCase()) === "id")) {
    return ((1 + x.eV) | 0);
  } else {
    return default$1.p(x);
  }
});
$p.aU = (function(x) {
  return this.IP(x);
});
$p.aJ = (function(x, default$1) {
  return this.Io(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$10, "com.papasofokli.dataTables.ScalaJsTable$$anon$10", ({
  lw: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11(hiddenIndex$3, showIdInd$16, idColumnIndex$3, columnNames$3, cells$2, singleClickFunIdO$7, doubleClickFunIdO$7, contextClickFunIdO$15, stickyColNo$21, colNumO$3, ec$59, columns$17) {
  this.Oj = null;
  this.Ol = false;
  this.Ok = null;
  this.Of = null;
  this.Od = null;
  this.Om = null;
  this.Oh = null;
  this.Og = null;
  this.On = null;
  this.Oe = null;
  this.Oi = null;
  this.XJ = null;
  this.Oj = hiddenIndex$3;
  this.Ol = showIdInd$16;
  this.Ok = idColumnIndex$3;
  this.Of = columnNames$3;
  this.Od = cells$2;
  this.Om = singleClickFunIdO$7;
  this.Oh = doubleClickFunIdO$7;
  this.Og = contextClickFunIdO$15;
  this.On = stickyColNo$21;
  this.Oe = colNumO$3;
  this.Oi = ec$59;
  this.XJ = columns$17;
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11.prototype = $p;
$p.avq = (function(x) {
  if ((x !== null)) {
    var x57 = x.gZ;
    var x58 = (x.fY | 0);
    if ((((x58 === 0) || this.Oj.az(x58)) || ((!this.Ol) && this.Ok.az(x58)))) {
      return true;
    }
    $m_sc_StringOps$();
    $m_sc_StringParsers$();
    _return: {
      var len = x57.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(x57, i);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
            var $x_2 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var $x_1 = new $c_s_Some(true);
    } else {
      _return$1: {
        var len$1 = x57.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(x57, i$1);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_3 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ($x_3) {
        var $x_1 = new $c_s_Some(false);
      } else {
        var $x_1 = $m_s_None$();
      }
    }
    if ((!$x_1.c())) {
      return true;
    }
    return true;
  }
  return false;
});
$p.amS = (function(x, default$1) {
  if ((x !== null)) {
    var x67 = x.gZ;
    var x68 = (x.fY | 0);
    if ((((x68 === 0) || this.Oj.az(x68)) || ((!this.Ol) && this.Ok.az(x68)))) {
      return $m_Lscalatags_JsDom$all$().mM().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("table_column_hidden", $m_Lscalatags_JsDom$all$().s), ($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(x67))]));
    }
    $m_sc_StringOps$();
    $m_sc_StringParsers$();
    _return: {
      var len = x67.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(x67, i);
          if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("true", i))))) {
            var $x_2 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_2 = true;
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var $x_1 = new $c_s_Some(true);
    } else {
      _return$1: {
        var len$1 = x67.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(x67, i$1);
            if (($m_jl_Character$().br($m_jl_Character$().bs(thisCP$1)) !== $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I("false", i$1))))) {
              var $x_3 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ($x_3) {
        var $x_1 = new $c_s_Some(false);
      } else {
        var $x_1 = $m_s_None$();
      }
    }
    if ((!$x_1.c())) {
      var $x_10 = $m_Lcom_papasofokli_dataTables_ScalaJsTable$();
      var $x_9 = this.Of;
      var $x_8 = this.Od.W();
      var $x_7 = this.Om;
      var $x_6 = this.Oh;
      var $x_5 = this.Og;
      if ((!this.On.c())) {
        var this$15 = this.Oe;
        var $x_4 = ((!this$15.c()) && ((this$15.h() | 0) >= x68));
      } else {
        var $x_4 = false;
      }
      return $x_10.afY(x67, ((x68 - 1) | 0), $x_9, $x_8, $x_7, $x_6, $x_5, true, $x_4, ($m_Lcom_papasofokli_dataTables_ScalaJsTable$(), false), this.Oi);
    }
    var this$17 = this.XJ.MD(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$30$2) => (_$30$2.eV === ((x68 - 1) | 0)))));
    var this$18 = (this$17.c() ? $m_s_None$() : this$17.h().lj);
    if ((!this$18.c())) {
      var x0$3 = this$18.h();
      var id$2 = (x0$3 | 0);
      var isNumeric = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().Xs.az(id$2);
    } else {
      var isNumeric = false;
    }
    var index$1 = ((x68 - 1) | 0);
    var rowId$1 = this.Od.W();
    if ((!this.On.c())) {
      var this$20 = this.Oe;
      var isSticky$1 = ((!this$20.c()) && ((this$20.h() | 0) >= x68));
    } else {
      var isSticky$1 = false;
    }
    $m_Lcom_papasofokli_dataTables_ScalaJsTable$();
    var isBoolean$1 = false;
    return $m_Lcom_papasofokli_dataTables_ScalaJsTable$().afY(x67, index$1, this.Of, rowId$1, this.Om, this.Oh, this.Og, isBoolean$1, isSticky$1, isNumeric, this.Oi);
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.avq(x);
});
$p.aJ = (function(x, default$1) {
  return this.amS(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$11, "com.papasofokli.dataTables.ScalaJsTable$$anon$11", ({
  lx: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12(columnTypeMap$4) {
  this.Oo = null;
  this.Oo = columnTypeMap$4;
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12.prototype = $p;
$p.zM = (function(x) {
  return (this.Oo.az(x) || true);
});
$p.TG = (function(x, default$1) {
  return (this.Oo.az(x) ? new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, $m_Lcom_papasofokli_dataTables_ScalaJsTable$().O5), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, $m_Lcom_papasofokli_dataTables_ScalaJsTable$().O4), $m_sci_Nil$())) : new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, 0), $m_sci_Nil$()));
});
$p.aU = (function(x) {
  return this.zM((x | 0));
});
$p.aJ = (function(x, default$1) {
  return this.TG((x | 0), default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$12, "com.papasofokli.dataTables.ScalaJsTable$$anon$12", ({
  ly: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    var x137 = x.P();
    if ((x137 instanceof $c_s_Some)) {
      (x.V() | 0);
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x142 = x.P();
    if ((x142 instanceof $c_s_Some)) {
      return new $c_T2((x142.bg | 0), (x.V() | 0));
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$13, "com.papasofokli.dataTables.ScalaJsTable$$anon$13", ({
  lz: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14.prototype = $p;
$p.jt = (function(x) {
  return ((!(!x.hasAttribute($m_Lcom_papasofokli_dataTables_ScalaJsTable$().r8))) || false);
});
$p.jk = (function(x, default$1) {
  return ((!(!x.hasAttribute($m_Lcom_papasofokli_dataTables_ScalaJsTable$().r8))) ? ($m_sc_StringOps$(), $m_jl_Integer$().c7(x.getAttribute($m_Lcom_papasofokli_dataTables_ScalaJsTable$().r8), 10, 214748364)) : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$14, "com.papasofokli.dataTables.ScalaJsTable$$anon$14", ({
  lA: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2(columns$16, tableElement$8) {
  this.Op = null;
  this.XK = null;
  this.Op = columns$16;
  this.XK = tableElement$8;
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2.prototype = $p;
$p.avj = (function(x) {
  return (this.Op.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => ((!f$2.gk) && (f$2.eV === x.li))))) || false);
});
$p.amL = (function(x, default$1) {
  if (this.Op.fK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((f$2) => ((!f$2.gk) && (f$2.eV === x.li)))))) {
    var cellClasses = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ao1(x.hY);
    var contentClasses = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ao2(x.hY);
    var additionalContents = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().ao0(x.hY);
    var rowElements = this.XK.querySelectorAll("tbody tr");
    var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(rowElements);
    _return: {
      var it = this$3.l();
      while (it.f()) {
        var a = it.e();
        if ((a.firstChild.textContent === x.pa.g())) {
          var rowElement = new $c_s_Some(a);
          break _return;
        }
      }
      var rowElement = $m_s_None$();
    }
    var this$5 = x.li;
    var colIndex = ("" + this$5);
    if ((!cellClasses.c())) {
      if (rowElement.c()) {
        var tdElement = $m_s_None$();
      } else {
        var x0 = rowElement.h();
        var this$8 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(x0.querySelectorAll("td"));
        _return$1: {
          var it$1 = this$8.l();
          while (it$1.f()) {
            var a$1 = it$1.e();
            var this$10 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(a$1.children);
            var res = false;
            var it$2 = this$10.l();
            while (((!res) && it$2.f())) {
              var x0$1 = it$2.e();
              res = (x0$1.getAttribute($m_Lcom_papasofokli_dataTables_ScalaJsTable$().Jw) === colIndex);
            }
            if (res) {
              var tdElement = new $c_s_Some(a$1);
              break _return$1;
            }
          }
          var tdElement = $m_s_None$();
        }
      }
      var xs = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().afZ(cellClasses.h());
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var i = 0;
      while ((i < xs.a.length)) {
        var x1 = i;
        var x0$2 = xs.a[x1];
        if (tdElement.c()) {
          var elems = $m_s_None$();
        } else {
          var x0$3 = tdElement.h();
          x0$3.classList.add(x0$2);
          var elems = new $c_s_Some((void 0));
        }
        var it$3 = elems.l();
        while (it$3.f()) {
          var elem = it$3.e();
          var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_V.l()) : elem);
          jsElems.push(unboxedElem);
        }
        i = ((1 + i) | 0);
      }
      $m_scm_ArrayBuilder$().v($d_jl_Void.l(), jsElems);
    }
    if ((!contentClasses.c())) {
      if (rowElement.c()) {
        var cellContentElement = $m_s_None$();
      } else {
        var x0$4 = rowElement.h();
        var cellContentElement = new $c_s_Some(x0$4.querySelector((((("[" + $m_Lcom_papasofokli_dataTables_ScalaJsTable$().Jw) + "='") + colIndex) + "']")));
      }
      var xs$1 = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().afZ(contentClasses.h());
      var capacity$1 = 0;
      var size$1 = 0;
      var jsElems$1 = null;
      capacity$1 = 0;
      size$1 = 0;
      jsElems$1 = [];
      var i$1 = 0;
      while ((i$1 < xs$1.a.length)) {
        var x1$1 = i$1;
        var x0$5 = xs$1.a[x1$1];
        if ((!cellContentElement.c())) {
          var x0$6 = cellContentElement.h();
          x0$6.classList.remove($m_Lcom_papasofokli_dataTables_ScalaJsTable$().Oa);
        }
        if (cellContentElement.c()) {
          var elems$1 = $m_s_None$();
        } else {
          var x0$7 = cellContentElement.h();
          x0$7.classList.add(x0$5);
          var elems$1 = new $c_s_Some((void 0));
        }
        var it$4 = elems$1.l();
        while (it$4.f()) {
          var elem$1 = it$4.e();
          var unboxedElem$1 = ((elem$1 === null) ? $m_scm_ArrayBuilder$().u($d_V.l()) : elem$1);
          jsElems$1.push(unboxedElem$1);
        }
        i$1 = ((1 + i$1) | 0);
      }
      $m_scm_ArrayBuilder$().v($d_jl_Void.l(), jsElems$1);
    }
    if ((!additionalContents.c())) {
      var divClass = (cellClasses.az("col-extra-small") ? "table-cell-center" : "");
      if (rowElement.c()) {
        var cellContentElement$2 = $m_s_None$();
      } else {
        var x0$8 = rowElement.h();
        var cellContentElement$2 = new $c_s_Some(x0$8.querySelector((((("[" + $m_Lcom_papasofokli_dataTables_ScalaJsTable$().Jw) + "='") + colIndex) + "']")));
      }
      var innerDiv = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(divClass, $m_Lscalatags_JsDom$all$().s)])).aB();
      innerDiv.innerHTML = (additionalContents.c() ? "" : additionalContents.h());
      if ((!cellContentElement$2.c())) {
        var x0$10 = cellContentElement$2.h();
        x0$10.replaceChildren(new $c_Lscalatags_LowPriorityImplicits$bindNode($m_Lscalatags_JsDom$all$(), innerDiv).ky);
      }
      if ((!cellContentElement$2.c())) {
        var x0$11 = cellContentElement$2.h();
        x0$11.classList.remove($m_Lcom_papasofokli_dataTables_ScalaJsTable$().Oa);
      }
      if ((!cellContentElement$2.c())) {
        var x0$12 = cellContentElement$2.h();
        x0$12.classList.add($m_Lcom_papasofokli_dataTables_ScalaJsTable$().Xo);
      }
      return (void 0);
    } else {
      return (void 0);
    }
  } else {
    return default$1.p(x);
  }
});
$p.aU = (function(x) {
  return this.avj(x);
});
$p.aJ = (function(x, default$1) {
  return this.amL(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$2, "com.papasofokli.dataTables.ScalaJsTable$$anon$2", ({
  lB: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3.prototype = $p;
$p.IO = (function(x) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellHighlightData) || false);
});
$p.In = (function(x, default$1) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellHighlightData) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.IO(x);
});
$p.aJ = (function(x, default$1) {
  return this.In(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$3, "com.papasofokli.dataTables.ScalaJsTable$$anon$3", ({
  lC: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4.prototype = $p;
$p.IO = (function(x) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellContentCssData) || ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellStatusData) || false));
});
$p.In = (function(x, default$1) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellContentCssData) ? x : ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellStatusData) ? x : default$1.p(x)));
});
$p.aU = (function(x) {
  return this.IO(x);
});
$p.aJ = (function(x, default$1) {
  return this.In(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$4, "com.papasofokli.dataTables.ScalaJsTable$$anon$4", ({
  lD: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5.prototype = $p;
$p.IO = (function(x) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellContentData) || false);
});
$p.In = (function(x, default$1) {
  return ((x instanceof $c_Lcom_papasofokli_dataTables_TableCellContentData) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.IO(x);
});
$p.aJ = (function(x, default$1) {
  return this.In(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$5, "com.papasofokli.dataTables.ScalaJsTable$$anon$5", ({
  lE: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6(columnTypeMap$3) {
  this.Oq = null;
  this.Oq = columnTypeMap$3;
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6.prototype = $p;
$p.zM = (function(x) {
  return (this.Oq.az(x) || true);
});
$p.TG = (function(x, default$1) {
  return (this.Oq.az(x) ? new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, $m_Lcom_papasofokli_dataTables_ScalaJsTable$().O5), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, $m_Lcom_papasofokli_dataTables_ScalaJsTable$().O4), $m_sci_Nil$())) : new $c_sci_$colon$colon(new $c_Lcom_papasofokli_dataTables_ColumnGroupOption(x, 0), $m_sci_Nil$()));
});
$p.aU = (function(x) {
  return this.zM((x | 0));
});
$p.aJ = (function(x, default$1) {
  return this.TG((x | 0), default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$6, "com.papasofokli.dataTables.ScalaJsTable$$anon$6", ({
  lF: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  var x$1 = x.dI();
  $m_s_Console$().J1().zO((x$1 + "\n"));
  return $m_s_None$();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$7, "com.papasofokli.dataTables.ScalaJsTable$$anon$7", ({
  lG: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8.prototype = $p;
$p.IP = (function(x) {
  var this$1 = x.lj;
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var elem$2 = (x0 | 0);
    var $x_1 = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().NV.az(elem$2);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return true;
  } else {
    return false;
  }
});
$p.Io = (function(x, default$1) {
  var this$1 = x.lj;
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var elem$2 = (x0 | 0);
    var $x_1 = $m_Lcom_papasofokli_dataTables_ScalaJsTable$().NV.az(elem$2);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return new $c_T2(x.eV, x.lj.h());
  } else {
    return default$1.p(x);
  }
});
$p.aU = (function(x) {
  return this.IP(x);
});
$p.aJ = (function(x, default$1) {
  return this.Io(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$8, "com.papasofokli.dataTables.ScalaJsTable$$anon$8", ({
  lH: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9() {
}
$p = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9() {
}
$h_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9.prototype = $p;
$p.IP = (function(x) {
  return (x.gk || false);
});
$p.Io = (function(x, default$1) {
  return (x.gk ? ((1 + x.eV) | 0) : default$1.p(x));
});
$p.aU = (function(x) {
  return this.IP(x);
});
$p.aJ = (function(x, default$1) {
  return this.Io(x, default$1);
});
var $d_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ScalaJsTable$$anon$9, "com.papasofokli.dataTables.ScalaJsTable$$anon$9", ({
  lI: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData(uiComponentId, cellContent) {
  this.ra = null;
  this.n8 = null;
  this.XM = null;
  this.XL = null;
  this.ra = uiComponentId;
  this.n8 = cellContent;
  this.XM = uiComponentId;
  this.XL = $m_s_None$();
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 301241756, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData)) {
    var x = this.ra;
    var x$2 = x$0.ra;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.n8;
      var x$4 = x$0.n8;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "SimpleTableCellContentCssData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.ra;
  }
  if ((n === 1)) {
    return this.n8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.IG = (function() {
  return this.XL;
});
function $isArrayOf_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dz)));
}
var $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData, "com.papasofokli.dataTables.SimpleTableCellContentCssData", ({
  dz: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24(WritersVersionSpecific_this$48, outer) {
  this.XP = null;
  this.XP = WritersVersionSpecific_this$48;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.VV = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uiComponentId", $m_Lupickle_default$().a1, v.ra);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContent", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.n8);
    return ctx.L((-1));
  }
});
$p.VX = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uiComponentId", $m_Lupickle_default$().a1, v.ra);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContent", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.n8);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.VV(out, v);
});
$p.ai = (function(ctx, v) {
  this.VX(ctx, v);
});
$p.T = (function() {
  return this.XP;
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24 = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$24, "com.papasofokli.dataTables.SimpleTableCellContentCssData$$anon$24", ({
  lM: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellS(rowUUID, column, tableCellData) {
  this.rc = null;
  this.rb = 0;
  this.lg = null;
  this.rc = rowUUID;
  this.rb = column;
  this.lg = tableCellData;
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellS;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellS() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1697905803));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rc));
  acc = $m_sr_Statics$().d(acc, this.rb);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lg));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_SimpleTableCellS)) {
    if ((this.rb === x$0.rb)) {
      var x = this.rc;
      var x$2 = x$0.rc;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.lg;
      var x$4 = x$0.lg;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "SimpleTableCellS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rc;
      break;
    }
    case 1: {
      return this.rb;
      break;
    }
    case 2: {
      return this.lg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
Object.defineProperty($p, "rowUUID", ({
  "get": (function() {
    return this.rc;
  }),
  "configurable": true
}));
Object.defineProperty($p, "tableCellData", ({
  "get": (function() {
    return this.lg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "column", ({
  "get": (function() {
    return this.rb;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_dataTables_SimpleTableCellS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dA)));
}
var $d_Lcom_papasofokli_dataTables_SimpleTableCellS = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellS, "com.papasofokli.dataTables.SimpleTableCellS", ({
  dA: 1,
  dv: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4(WritersVersionSpecific_this$38, outer) {
  this.XS = null;
  this.XS = WritersVersionSpecific_this$38;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aie = (function(v) {
  var x = v.lg;
  var x$2 = $m_s_None$();
  return ((2 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aA0 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aie(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.rc);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.rb);
    var x = v.lg;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableCellData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), v.lg);
    }
    return ctx.L((-1));
  }
});
$p.aCq = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.rc);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.rb);
  var x = v.lg;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableCellData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), v.lg);
  }
});
$p.ah = (function(v) {
  return this.aie(v);
});
$p.U = (function(out, v) {
  return this.aA0(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCq(ctx, v);
});
$p.T = (function() {
  return this.XS;
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$4, "com.papasofokli.dataTables.SimpleTableCellS$$anon$4", ({
  lP: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellContentCssData(rowUUID, columnName, contentCssClass) {
  this.Au = null;
  this.At = null;
  this.va = null;
  this.Au = rowUUID;
  this.At = columnName;
  this.va = contentCssClass;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellContentCssData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellContentCssData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellContentCssData() {
}
$h_Lcom_papasofokli_dataTables_TableCellContentCssData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-339740826), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableCellContentCssData)) {
    var x = this.Au;
    var x$2 = x$0.Au;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.At === x$0.At))) {
      var x$3 = this.va;
      var x$4 = x$0.va;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TableCellContentCssData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Au;
      break;
    }
    case 1: {
      return this.At;
      break;
    }
    case 2: {
      return this.va;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.IG = (function() {
  return this.va;
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableCellContentCssData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dB)));
}
var $d_Lcom_papasofokli_dataTables_TableCellContentCssData = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellContentCssData, "com.papasofokli.dataTables.TableCellContentCssData", ({
  dB: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellContentData(rowUUID, columnName, cellContentHtml, cellCssClass) {
  this.Ax = null;
  this.Aw = null;
  this.Av = null;
  this.p9 = null;
  this.Or = null;
  this.Ax = rowUUID;
  this.Aw = columnName;
  this.Av = cellContentHtml;
  this.p9 = cellCssClass;
  this.Or = $m_s_Option$().Z(cellContentHtml);
}
$p = $c_Lcom_papasofokli_dataTables_TableCellContentData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellContentData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellContentData() {
}
$h_Lcom_papasofokli_dataTables_TableCellContentData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 657789537, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableCellContentData)) {
    var x = this.Ax;
    var x$2 = x$0.Ax;
    if (((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.Aw === x$0.Aw)) && (this.Av === x$0.Av))) {
      var x$3 = this.p9;
      var x$4 = x$0.p9;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "TableCellContentData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Ax;
      break;
    }
    case 1: {
      return this.Aw;
      break;
    }
    case 2: {
      return this.Av;
      break;
    }
    case 3: {
      return this.p9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.IG = (function() {
  return this.Or;
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableCellContentData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dC)));
}
var $d_Lcom_papasofokli_dataTables_TableCellContentData = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellContentData, "com.papasofokli.dataTables.TableCellContentData", ({
  dC: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$10(WritersVersionSpecific_this$39, outer) {
  this.XV = null;
  this.XV = WritersVersionSpecific_this$39;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$10() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.VV = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uiComponentId", $m_Lupickle_default$().a1, v.ra);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContent", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.n8);
    return ctx.L((-1));
  }
});
$p.VX = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uiComponentId", $m_Lupickle_default$().a1, v.ra);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContent", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.n8);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.VV(out, v);
});
$p.ai = (function(ctx, v) {
  this.VX(ctx, v);
});
$p.T = (function() {
  return this.XV;
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$10, "com.papasofokli.dataTables.TableCellData$$anon$10", ({
  lR: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$11(WritersVersionSpecific_this$40, outer) {
  this.XW = null;
  this.XW = WritersVersionSpecific_this$40;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$11.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$11() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$11.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aA1 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Au);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.At);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.va);
    return ctx.L((-1));
  }
});
$p.aCr = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Au);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.At);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.va);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aA1(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCr(ctx, v);
});
$p.T = (function() {
  return this.XW;
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$11, "com.papasofokli.dataTables.TableCellData$$anon$11", ({
  lS: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$12(WritersVersionSpecific_this$41, outer) {
  this.XX = null;
  this.XX = WritersVersionSpecific_this$41;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$12() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$12.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aii = (function(v) {
  return ((2 + ((v.pb !== "Status") | 0)) | 0);
});
$p.aA5 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aii(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AA);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.vb);
    if ((v.pb !== "Status")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.pb);
    }
    return ctx.L((-1));
  }
});
$p.aCv = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AA);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.vb);
  if ((v.pb !== "Status")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.pb);
  }
});
$p.ah = (function(v) {
  return this.aii(v);
});
$p.U = (function(out, v) {
  return this.aA5(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCv(ctx, v);
});
$p.T = (function() {
  return this.XX;
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$12, "com.papasofokli.dataTables.TableCellData$$anon$12", ({
  lT: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$13(WritersVersionSpecific_this$42, outer) {
  this.XY = null;
  this.XY = WritersVersionSpecific_this$42;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$13() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$13.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aif = (function(v) {
  var x = v.p9;
  var x$2 = $m_s_None$();
  return ((3 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aA2 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aif(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Ax);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.Aw);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContentHtml", $m_Lupickle_default$().m, v.Av);
    var x = v.p9;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.p9);
    }
    return ctx.L((-1));
  }
});
$p.aCs = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Ax);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.Aw);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellContentHtml", $m_Lupickle_default$().m, v.Av);
  var x = v.p9;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.p9);
  }
});
$p.ah = (function(v) {
  return this.aif(v);
});
$p.U = (function(out, v) {
  return this.aA2(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCs(ctx, v);
});
$p.T = (function() {
  return this.XY;
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$13, "com.papasofokli.dataTables.TableCellData$$anon$13", ({
  lU: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$14(WritersVersionSpecific_this$43, outer) {
  this.XZ = null;
  this.XZ = WritersVersionSpecific_this$43;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$14() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$14.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aig = (function(v) {
  var x = v.lh;
  var x$2 = $m_s_None$();
  return ((2 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aA3 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aig(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Az);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.Ay);
    var x = v.lh;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lh);
    }
    return ctx.L((-1));
  }
});
$p.aCt = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.Az);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnName", $m_Lupickle_default$().m, v.Ay);
  var x = v.lh;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cellCssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lh);
  }
});
$p.ah = (function(v) {
  return this.aig(v);
});
$p.U = (function(out, v) {
  return this.aA3(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCt(ctx, v);
});
$p.T = (function() {
  return this.XZ;
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$14, "com.papasofokli.dataTables.TableCellData$$anon$14", ({
  lV: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellHighlightData(rowUUID, columnName, cellCssClass) {
  this.Az = null;
  this.Ay = null;
  this.lh = null;
  this.Az = rowUUID;
  this.Ay = columnName;
  this.lh = cellCssClass;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellHighlightData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellHighlightData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellHighlightData() {
}
$h_Lcom_papasofokli_dataTables_TableCellHighlightData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2082289930, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableCellHighlightData)) {
    var x = this.Az;
    var x$2 = x$0.Az;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.Ay === x$0.Ay))) {
      var x$3 = this.lh;
      var x$4 = x$0.lh;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TableCellHighlightData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Az;
      break;
    }
    case 1: {
      return this.Ay;
      break;
    }
    case 2: {
      return this.lh;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.IG = (function() {
  return this.lh;
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableCellHighlightData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dD)));
}
var $d_Lcom_papasofokli_dataTables_TableCellHighlightData = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellHighlightData, "com.papasofokli.dataTables.TableCellHighlightData", ({
  dD: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellS(rowUUID, column, tableCellData) {
  this.pa = null;
  this.li = 0;
  this.hY = null;
  this.pa = rowUUID;
  this.li = column;
  this.hY = tableCellData;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellS;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellS() {
}
$h_Lcom_papasofokli_dataTables_TableCellS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 462717987);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pa));
  acc = $m_sr_Statics$().d(acc, this.li);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hY));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableCellS)) {
    if ((this.li === x$0.li)) {
      var x = this.pa;
      var x$2 = x$0.pa;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.hY;
      var x$4 = x$0.hY;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TableCellS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pa;
      break;
    }
    case 1: {
      return this.li;
      break;
    }
    case 2: {
      return this.hY;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
Object.defineProperty($p, "rowUUID", ({
  "get": (function() {
    return this.pa;
  }),
  "configurable": true
}));
Object.defineProperty($p, "tableCellData", ({
  "get": (function() {
    return this.hY;
  }),
  "configurable": true
}));
Object.defineProperty($p, "column", ({
  "get": (function() {
    return this.li;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_dataTables_TableCellS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dE)));
}
var $d_Lcom_papasofokli_dataTables_TableCellS = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellS, "com.papasofokli.dataTables.TableCellS", ({
  dE: 1,
  dv: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellS$$anon$2(WritersVersionSpecific_this$37, outer) {
  this.Y2 = null;
  this.Y2 = WritersVersionSpecific_this$37;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableCellS$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellS$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellS$$anon$2() {
}
$h_Lcom_papasofokli_dataTables_TableCellS$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aih = (function(v) {
  var x = v.hY;
  var x$2 = $m_s_None$();
  return ((2 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aA4 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aih(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.pa);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.li);
    var x = v.hY;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableCellData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), v.hY);
    }
    return ctx.L((-1));
  }
});
$p.aCu = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.pa);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.li);
  var x = v.hY;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableCellData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), v.hY);
  }
});
$p.ah = (function(v) {
  return this.aih(v);
});
$p.U = (function(out, v) {
  return this.aA4(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCu(ctx, v);
});
$p.T = (function() {
  return this.Y2;
});
var $d_Lcom_papasofokli_dataTables_TableCellS$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellS$$anon$2, "com.papasofokli.dataTables.TableCellS$$anon$2", ({
  m3: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellStatusData(rowUUID, contentCssClass, columnName) {
  this.AA = null;
  this.vb = null;
  this.pb = null;
  this.AA = rowUUID;
  this.vb = contentCssClass;
  this.pb = columnName;
}
$p = $c_Lcom_papasofokli_dataTables_TableCellStatusData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellStatusData;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellStatusData() {
}
$h_Lcom_papasofokli_dataTables_TableCellStatusData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1183543938, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_dataTables_TableCellStatusData)) {
    var x = this.AA;
    var x$2 = x$0.AA;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.vb;
      var x$4 = x$0.vb;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.pb === x$0.pb);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TableCellStatusData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.AA;
      break;
    }
    case 1: {
      return this.vb;
      break;
    }
    case 2: {
      return this.pb;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.IG = (function() {
  var this$1 = this.vb;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(("cell-label " + this$1.h())));
});
function $isArrayOf_Lcom_papasofokli_dataTables_TableCellStatusData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dF)));
}
var $d_Lcom_papasofokli_dataTables_TableCellStatusData = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellStatusData, "com.papasofokli.dataTables.TableCellStatusData", ({
  dF: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6(WritersVersionSpecific_this$23, outer) {
  this.Y5 = null;
  this.Y5 = WritersVersionSpecific_this$23;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6() {
}
$h_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aij = (function(v) {
  return ((6 + ((!$m_sr_BoxesRunTime$().B(v.lk, false)) | 0)) | 0);
});
$p.aA6 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aij(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.jT);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.eV);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isHidden", $m_Lupickle_default$().aw, v.gk);
    if ((!$m_sr_BoxesRunTime$().B(v.lk, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isAdditional", $m_Lupickle_default$().aw, v.lk);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortIndex", $m_Lupickle_default$().h8, v.rd);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.lj);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hideAggregation", $m_Lupickle_default$().aw, v.pc);
    return ctx.L((-1));
  }
});
$p.aCw = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.jT);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.eV);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isHidden", $m_Lupickle_default$().aw, v.gk);
  if ((!$m_sr_BoxesRunTime$().B(v.lk, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isAdditional", $m_Lupickle_default$().aw, v.lk);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortIndex", $m_Lupickle_default$().h8, v.rd);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.lj);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hideAggregation", $m_Lupickle_default$().aw, v.pc);
});
$p.ah = (function(v) {
  return this.aij(v);
});
$p.U = (function(out, v) {
  return this.aA6(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCw(ctx, v);
});
$p.T = (function() {
  return this.Y5;
});
var $d_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$6, "com.papasofokli.dataTables.TableColumnProperties$$anon$6", ({
  m6: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12(WritersVersionSpecific_this$26, outer) {
  this.Y8 = null;
  this.Y8 = WritersVersionSpecific_this$26;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12() {
}
$h_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aik = (function(v) {
  var x = v.nc;
  var x$2 = $m_s_None$();
  var $x_4 = ((x !== null) && x.b(x$2));
  var x$3 = v.jU;
  var x$4 = $m_s_None$();
  var $x_3 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.na;
  var x$6 = $m_s_None$();
  var $x_2 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.n9;
  var x$8 = $m_Lcom_papasofokli_dataTables_TableGroupRequest$().I6();
  var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
  var x$9 = v.nb;
  var x$10 = $m_s_None$();
  return ((((4 + ((((!$x_4) | 0) + ((!$x_3) | 0)) | 0)) | 0) + ((((2 + ((!$x_2) | 0)) | 0) + ((1 + ((((!$x_1) | 0) + ((!((x$9 !== null) && x$9.b(x$10))) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aA7 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aik(v), true, (-1));
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "keyValues", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple3Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), $m_Lupickle_default$().ao), this$3), v.vi);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $m_Lupickle_default$().ao, v.vg);
    var this$6 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroupBy", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), this$6), v.vc);
    var this$9 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$9), v.vh);
    var x = v.nc;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nc);
    }
    var x$3 = v.jU;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jU);
    }
    var x$5 = v.na;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateColumnGroupType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.na);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.vd);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directionOrder", $m_Lupickle_default$().m, v.vf);
    var this$27 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnsSearch", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), this$27), v.ve);
    var x$7 = v.n9;
    var x$8 = $m_Lcom_papasofokli_dataTables_TableGroupRequest$().I6();
    if ((!((x$7 === null) ? (x$8 === null) : x$7.b(x$8)))) {
      var this$30 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockAggregationIndexes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$30), v.n9);
    }
    var x$9 = v.nb;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "innerTablePageNo", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nb);
    }
    return ctx.L((-1));
  }
});
$p.aCx = (function(ctx, v) {
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "keyValues", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple3Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), $m_Lupickle_default$().ao), this$3), v.vi);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $m_Lupickle_default$().ao, v.vg);
  var this$6 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroupBy", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), this$6), v.vc);
  var this$9 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$9), v.vh);
  var x = v.nc;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nc);
  }
  var x$3 = v.jU;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jU);
  }
  var x$5 = v.na;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateColumnGroupType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.na);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.vd);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directionOrder", $m_Lupickle_default$().m, v.vf);
  var this$27 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnsSearch", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), this$27), v.ve);
  var x$7 = v.n9;
  var x$8 = $m_Lcom_papasofokli_dataTables_TableGroupRequest$().I6();
  if ((!((x$7 === null) ? (x$8 === null) : x$7.b(x$8)))) {
    var this$30 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockAggregationIndexes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$30), v.n9);
  }
  var x$9 = v.nb;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "innerTablePageNo", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nb);
  }
});
$p.ah = (function(v) {
  return this.aik(v);
});
$p.U = (function(out, v) {
  return this.aA7(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCx(ctx, v);
});
$p.T = (function() {
  return this.Y8;
});
var $d_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$12, "com.papasofokli.dataTables.TableGroupRequest$$anon$12", ({
  ma: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10(WritersVersionSpecific_this$25, outer) {
  this.Yb = null;
  this.Yb = WritersVersionSpecific_this$25;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10() {
}
$h_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ail = (function(v) {
  var x = v.lm;
  var x$2 = $m_s_None$();
  var $x_3 = ((x !== null) && x.b(x$2));
  var x$3 = v.iG;
  var x$4 = $m_sci_Nil$();
  var $x_2 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.iH;
  var x$6 = $m_s_None$();
  var $x_1 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.ll;
  var x$8 = $m_s_None$();
  return ((((((!$x_3) | 0) + ((!$x_2) | 0)) | 0) + ((((!$x_1) | 0) + ((((!((x$7 !== null) && x$7.b(x$8))) | 0) + ((!$m_sr_BoxesRunTime$().dG(v.ln, 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aA8 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ail(v), true, (-1));
    var x = v.lm;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableHtml", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lm);
    }
    var x$3 = v.iG;
    var x$4 = $m_sci_Nil$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      var this$9 = $m_Lupickle_default$();
      var this$8 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22(new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), this$9), v.iG);
    }
    var x$5 = v.iH;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableSetupData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableSetupData$().q()), v.iH);
    }
    var x$7 = v.ll;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.b(x$8)))) {
      var $x_3 = $m_Lupickle_default$();
      var this$20 = $m_Lupickle_default$();
      var $x_2 = $m_Lupickle_default$();
      var $x_1 = $m_Lcom_papasofokli_dataTables_ColumnGroup$().q();
      var this$18 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupedData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_3, new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($x_2, $x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().m), this$18)), this$20)), v.ll);
    }
    if ((!$m_sr_BoxesRunTime$().dG(v.ln, 0))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "totalRecords", $m_Lupickle_default$().ao, v.ln);
    }
    return ctx.L((-1));
  }
});
$p.aCy = (function(ctx, v) {
  var x = v.lm;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableHtml", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lm);
  }
  var x$3 = v.iG;
  var x$4 = $m_sci_Nil$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    var this$9 = $m_Lupickle_default$();
    var this$8 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", new $c_Lupickle_implicits_LowPriWriters$$anon$22(new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$8), this$9), v.iG);
  }
  var x$5 = v.iH;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableSetupData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableSetupData$().q()), v.iH);
  }
  var x$7 = v.ll;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.b(x$8)))) {
    var $x_3 = $m_Lupickle_default$();
    var this$20 = $m_Lupickle_default$();
    var $x_2 = $m_Lupickle_default$();
    var $x_1 = $m_Lcom_papasofokli_dataTables_ColumnGroup$().q();
    var this$18 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupedData", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_3, new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($x_2, $x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().m), this$18)), this$20)), v.ll);
  }
  if ((!$m_sr_BoxesRunTime$().dG(v.ln, 0))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "totalRecords", $m_Lupickle_default$().ao, v.ln);
  }
});
$p.ah = (function(v) {
  return this.ail(v);
});
$p.U = (function(out, v) {
  return this.aA8(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCy(ctx, v);
});
$p.T = (function() {
  return this.Yb;
});
var $d_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$10, "com.papasofokli.dataTables.TableGroupedResult$$anon$10", ({
  mc: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableParameters$$anon$8(WritersVersionSpecific_this$24, outer) {
  this.Ye = null;
  this.Ye = WritersVersionSpecific_this$24;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableParameters$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableParameters$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableParameters$$anon$8() {
}
$h_Lcom_papasofokli_dataTables_TableParameters$$anon$8.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aim = (function(v) {
  var x = v.nf;
  var x$2 = $m_sci_Nil$();
  var $x_8 = ((x !== null) && x.b(x$2));
  var x$3 = v.nd;
  var x$4 = $m_Lcom_papasofokli_dataTables_TableParameters$().oB();
  var $x_7 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
  var x$5 = v.nj;
  var x$6 = $m_s_None$();
  var $x_6 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.nk;
  var x$8 = $m_Lcom_papasofokli_dataTables_TableParameters$().DJ();
  var $x_5 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
  var x$9 = v.nl;
  var x$10 = $m_s_None$();
  var $x_4 = ((x$9 !== null) && x$9.b(x$10));
  var x$11 = v.ni;
  var x$12 = $m_s_None$();
  var $x_3 = ((x$11 !== null) && x$11.b(x$12));
  var x$13 = v.ng;
  var x$14 = $m_s_None$();
  var $x_2 = ((x$13 !== null) && x$13.b(x$14));
  var $x_1 = $m_sr_BoxesRunTime$().B(v.ne, false);
  var x$15 = v.nh;
  var x$16 = $m_s_None$();
  return ((8 + ((((((((!$x_8) | 0) + ((!$x_7) | 0)) | 0) + ((((!$x_6) | 0) + ((!$x_5) | 0)) | 0)) | 0) + ((((((!$x_4) | 0) + ((!$x_3) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$15 !== null) && x$15.b(x$16))) | 0)) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aA9 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aim(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "draw", $m_Lupickle_default$().ao, v.vm);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $m_Lupickle_default$().ao, v.vq);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "length", $m_Lupickle_default$().ao, v.vo);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "search", $m_Lupickle_default$().m, v.vp);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.vj);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directionOrder", $m_Lupickle_default$().m, v.vl);
    var this$10 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnsSearch", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), this$10), v.vk);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lazyLoad", $m_Lupickle_default$().aw, v.vn);
    var x = v.nf;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.b(x$2)))) {
      var this$15 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroupBy", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), this$15), v.nf);
    }
    var x$3 = v.nd;
    var x$4 = $m_Lcom_papasofokli_dataTables_TableParameters$().oB();
    if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
      var this$18 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockAggregationIndexes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$18), v.nd);
    }
    var x$5 = v.nj;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nj);
    }
    var x$7 = v.nk;
    var x$8 = $m_Lcom_papasofokli_dataTables_TableParameters$().DJ();
    if ((!((x$7 === null) ? (x$8 === null) : x$7.b(x$8)))) {
      var this$26 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$26), v.nk);
    }
    var x$9 = v.nl;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nl);
    }
    var x$11 = v.ni;
    var x$12 = $m_s_None$();
    if ((!((x$11 !== null) && x$11.b(x$12)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ni);
    }
    var x$13 = v.ng;
    var x$14 = $m_s_None$();
    if ((!((x$13 !== null) && x$13.b(x$14)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateColumnGroupType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ng);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.ne, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartData", $m_Lupickle_default$().aw, v.ne);
    }
    var x$15 = v.nh;
    var x$16 = $m_s_None$();
    if ((!((x$15 !== null) && x$15.b(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "exportDetailsIndicator", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().aw), v.nh);
    }
    return ctx.L((-1));
  }
});
$p.aCz = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "draw", $m_Lupickle_default$().ao, v.vm);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "start", $m_Lupickle_default$().ao, v.vq);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "length", $m_Lupickle_default$().ao, v.vo);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "search", $m_Lupickle_default$().m, v.vp);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.vj);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "directionOrder", $m_Lupickle_default$().m, v.vl);
  var this$10 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnsSearch", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), this$10), v.vk);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "lazyLoad", $m_Lupickle_default$().aw, v.vn);
  var x = v.nf;
  var x$2 = $m_sci_Nil$();
  if ((!((x !== null) && x.b(x$2)))) {
    var this$15 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnGroupBy", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), this$15), v.nf);
  }
  var x$3 = v.nd;
  var x$4 = $m_Lcom_papasofokli_dataTables_TableParameters$().oB();
  if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
    var this$18 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockAggregationIndexes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$18), v.nd);
  }
  var x$5 = v.nj;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nj);
  }
  var x$7 = v.nk;
  var x$8 = $m_Lcom_papasofokli_dataTables_TableParameters$().DJ();
  if ((!((x$7 === null) ? (x$8 === null) : x$7.b(x$8)))) {
    var this$26 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$26), v.nk);
  }
  var x$9 = v.nl;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.nl);
  }
  var x$11 = v.ni;
  var x$12 = $m_s_None$();
  if ((!((x$11 !== null) && x$11.b(x$12)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "groupCalculationType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ni);
  }
  var x$13 = v.ng;
  var x$14 = $m_s_None$();
  if ((!((x$13 !== null) && x$13.b(x$14)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dateColumnGroupType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ng);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.ne, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "chartData", $m_Lupickle_default$().aw, v.ne);
  }
  var x$15 = v.nh;
  var x$16 = $m_s_None$();
  if ((!((x$15 !== null) && x$15.b(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "exportDetailsIndicator", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().aw), v.nh);
  }
});
$p.ah = (function(v) {
  return this.aim(v);
});
$p.U = (function(out, v) {
  return this.aA9(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCz(ctx, v);
});
$p.T = (function() {
  return this.Ye;
});
var $d_Lcom_papasofokli_dataTables_TableParameters$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableParameters$$anon$8, "com.papasofokli.dataTables.TableParameters$$anon$8", ({
  mh: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$4(WritersVersionSpecific_this$22, outer) {
  this.Yh = null;
  this.Yh = WritersVersionSpecific_this$22;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableSetupData$$anon$4() {
}
$h_Lcom_papasofokli_dataTables_TableSetupData$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ain = (function(v) {
  var x = v.lq;
  var x$2 = $m_s_None$();
  var $x_2 = ((x !== null) && x.b(x$2));
  var x$3 = v.lo;
  var x$4 = $m_s_None$();
  var $x_1 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.jV;
  var x$6 = $m_s_None$();
  return ((((2 + ((!$x_2) | 0)) | 0) + ((1 + ((((!$x_1) | 0) + ((!((x$5 !== null) && x$5.b(x$6))) | 0)) | 0)) | 0)) | 0);
});
$p.aAa = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ain(v), true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columns", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_TableColumnProperties$().q(), this$2), v.hZ);
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$5), v.re);
    var x = v.lq;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.lq);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultRowsPerPage", $m_Lupickle_default$().ao, v.lp);
    var x$3 = v.lo;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalButtons", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lo);
    }
    var x$5 = v.jV;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "addNewButton", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jV);
    }
    return ctx.L((-1));
  }
});
$p.aCA = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columns", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_dataTables_TableColumnProperties$().q(), this$2), v.hZ);
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "headersWidth", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ao, $m_Lupickle_default$().ao), this$5), v.re);
  var x = v.lq;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "maxClientWidth", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ao), v.lq);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "defaultRowsPerPage", $m_Lupickle_default$().ao, v.lp);
  var x$3 = v.lo;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalButtons", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lo);
  }
  var x$5 = v.jV;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "addNewButton", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.jV);
  }
});
$p.ah = (function(v) {
  return this.ain(v);
});
$p.U = (function(out, v) {
  return this.aAa(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCA(ctx, v);
});
$p.T = (function() {
  return this.Yh;
});
var $d_Lcom_papasofokli_dataTables_TableSetupData$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableSetupData$$anon$4, "com.papasofokli.dataTables.TableSetupData$$anon$4", ({
  mk: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddAttributeToElement(id, attributeName, attributeValue, idSuffix) {
  this.vt = null;
  this.vr = null;
  this.vs = null;
  this.nm = null;
  this.vt = id;
  this.vr = attributeName;
  this.vs = attributeValue;
  this.nm = idSuffix;
}
$p = $c_Lcom_papasofokli_execution_AddAttributeToElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddAttributeToElement;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddAttributeToElement() {
}
$h_Lcom_papasofokli_execution_AddAttributeToElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 576135300, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AddAttributeToElement)) {
    var x = this.vt;
    var x$2 = x$0.vt;
    if (((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.vr === x$0.vr)) && (this.vs === x$0.vs))) {
      return (this.nm === x$0.nm);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "AddAttributeToElement";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.vt;
      break;
    }
    case 1: {
      return this.vr;
      break;
    }
    case 2: {
      return this.vs;
      break;
    }
    case 3: {
      return this.nm;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AddAttributeToElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dL)));
}
var $d_Lcom_papasofokli_execution_AddAttributeToElement = new $TypeData().i($c_Lcom_papasofokli_execution_AddAttributeToElement, "com.papasofokli.execution.AddAttributeToElement", ({
  dL: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddClassToElement(elementId, className) {
  this.vv = null;
  this.vu = null;
  this.vv = elementId;
  this.vu = className;
}
$p = $c_Lcom_papasofokli_execution_AddClassToElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddClassToElement;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddClassToElement() {
}
$h_Lcom_papasofokli_execution_AddClassToElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 410797155, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AddClassToElement)) {
    var x = this.vv;
    var x$2 = x$0.vv;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.vu === x$0.vu);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "AddClassToElement";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vv;
  }
  if ((n === 1)) {
    return this.vu;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_AddClassToElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dM)));
}
var $d_Lcom_papasofokli_execution_AddClassToElement = new $TypeData().i($c_Lcom_papasofokli_execution_AddClassToElement, "com.papasofokli.execution.AddClassToElement", ({
  dM: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow(plannerId, rowId, index, periods) {
  this.rh = null;
  this.ri = null;
  this.rf = 0;
  this.rg = null;
  this.rh = plannerId;
  this.ri = rowId;
  this.rf = index;
  this.rg = periods;
}
$p = $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow() {
}
$h_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1339935261));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rh));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ri));
  acc = $m_sr_Statics$().d(acc, this.rf);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rg));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow)) {
    if ((this.rf === x$0.rf)) {
      var x = this.rh;
      var x$2 = x$0.rh;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.ri;
      var x$4 = x$0.ri;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.rg;
      var x$6 = x$0.rg;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "AddDetailPeriodsToPlannerRow";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rh;
      break;
    }
    case 1: {
      return this.ri;
      break;
    }
    case 2: {
      return this.rf;
      break;
    }
    case 3: {
      return this.rg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dN)));
}
var $d_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow = new $TypeData().i($c_Lcom_papasofokli_execution_AddDetailPeriodsToPlannerRow, "com.papasofokli.execution.AddDetailPeriodsToPlannerRow", ({
  dN: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow(plannerId, rowId, periods) {
  this.vx = null;
  this.vy = null;
  this.vw = null;
  this.vx = plannerId;
  this.vy = rowId;
  this.vw = periods;
}
$p = $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddPeriodsToPlannerRow() {
}
$h_Lcom_papasofokli_execution_AddPeriodsToPlannerRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 436125239, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow)) {
    var x = this.vx;
    var x$2 = x$0.vx;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.vy;
      var x$4 = x$0.vy;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.vw;
      var x$6 = x$0.vw;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "AddPeriodsToPlannerRow";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.vx;
      break;
    }
    case 1: {
      return this.vy;
      break;
    }
    case 2: {
      return this.vw;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AddPeriodsToPlannerRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dO)));
}
var $d_Lcom_papasofokli_execution_AddPeriodsToPlannerRow = new $TypeData().i($c_Lcom_papasofokli_execution_AddPeriodsToPlannerRow, "com.papasofokli.execution.AddPeriodsToPlannerRow", ({
  dO: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddPeriodsToSubject(plannerId, subjectId_$_lo, subjectId_$_hi, periodSeq) {
  this.rk = null;
  this.tV = 0;
  this.tW = 0;
  this.rj = null;
  this.rk = plannerId;
  this.tV = subjectId_$_lo;
  this.tW = subjectId_$_hi;
  this.rj = periodSeq;
}
$p = $c_Lcom_papasofokli_execution_AddPeriodsToSubject.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddPeriodsToSubject;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddPeriodsToSubject() {
}
$h_Lcom_papasofokli_execution_AddPeriodsToSubject.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1097483744));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rk));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.tV, this.tW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rj));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AddPeriodsToSubject)) {
    var x_$_lo = this.tV;
    var x_$_hi = this.tW;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.tV;
    var x$1_$_hi = $x_2.tW;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.rk;
      var x$2$1 = x$0.rk;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.rj;
      var x$4 = x$0.rj;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "AddPeriodsToSubject";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rk;
      break;
    }
    case 1: {
      return $bL(this.tV, this.tW);
      break;
    }
    case 2: {
      return this.rj;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AddPeriodsToSubject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dP)));
}
var $d_Lcom_papasofokli_execution_AddPeriodsToSubject = new $TypeData().i($c_Lcom_papasofokli_execution_AddPeriodsToSubject, "com.papasofokli.execution.AddPeriodsToSubject", ({
  dP: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AddTableRow(tableId, position, noOfColumns, rowContent, collapseExpandedRows) {
  this.ro = null;
  this.rm = 0;
  this.rl = 0;
  this.rn = null;
  this.lr = false;
  this.ro = tableId;
  this.rm = position;
  this.rl = noOfColumns;
  this.rn = rowContent;
  this.lr = collapseExpandedRows;
}
$p = $c_Lcom_papasofokli_execution_AddTableRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AddTableRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_AddTableRow() {
}
$h_Lcom_papasofokli_execution_AddTableRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-201842995));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.ro));
  acc = $m_sr_Statics$().d(acc, this.rm);
  acc = $m_sr_Statics$().d(acc, this.rl);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rn));
  acc = $m_sr_Statics$().d(acc, (this.lr ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 5);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_AddTableRow) && (((((this.rm === x$0.rm) && (this.rl === x$0.rl)) && (this.lr === x$0.lr)) && (this.ro === x$0.ro)) && (this.rn === x$0.rn))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "AddTableRow";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.ro;
      break;
    }
    case 1: {
      return this.rm;
      break;
    }
    case 2: {
      return this.rl;
      break;
    }
    case 3: {
      return this.rn;
      break;
    }
    case 4: {
      return this.lr;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AddTableRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dQ)));
}
var $d_Lcom_papasofokli_execution_AddTableRow = new $TypeData().i($c_Lcom_papasofokli_execution_AddTableRow, "com.papasofokli.execution.AddTableRow", ({
  dQ: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight(id, compact) {
  this.rq = null;
  this.rp = false;
  this.rq = id;
  this.rp = compact;
}
$p = $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight;
/** @constructor */
function $h_Lcom_papasofokli_execution_AdjustPlannerComponentHeight() {
}
$h_Lcom_papasofokli_execution_AdjustPlannerComponentHeight.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1157575393);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rq));
  acc = $m_sr_Statics$().d(acc, (this.rp ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight)) {
    if ((this.rp === x$0.rp)) {
      var x = this.rq;
      var x$2 = x$0.rq;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "AdjustPlannerComponentHeight";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.rq;
  }
  if ((n === 1)) {
    return this.rp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_AdjustPlannerComponentHeight(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dR)));
}
var $d_Lcom_papasofokli_execution_AdjustPlannerComponentHeight = new $TypeData().i($c_Lcom_papasofokli_execution_AdjustPlannerComponentHeight, "com.papasofokli.execution.AdjustPlannerComponentHeight", ({
  dR: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AppendChildrenToParentTree(node, withRefresh, clickFunctionId, leafClickFunctionId, contextMenuFunctionId, expandOnDoubleClick, cssClass) {
  this.rw = null;
  this.rx = false;
  this.rr = null;
  this.rv = null;
  this.rs = null;
  this.ru = false;
  this.rt = null;
  this.rw = node;
  this.rx = withRefresh;
  this.rr = clickFunctionId;
  this.rv = leafClickFunctionId;
  this.rs = contextMenuFunctionId;
  this.ru = expandOnDoubleClick;
  this.rt = cssClass;
}
$p = $c_Lcom_papasofokli_execution_AppendChildrenToParentTree.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AppendChildrenToParentTree;
/** @constructor */
function $h_Lcom_papasofokli_execution_AppendChildrenToParentTree() {
}
$h_Lcom_papasofokli_execution_AppendChildrenToParentTree.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1744465348));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rw));
  acc = $m_sr_Statics$().d(acc, (this.rx ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rr));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rv));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rs));
  acc = $m_sr_Statics$().d(acc, (this.ru ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rt));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AppendChildrenToParentTree)) {
    if (((this.rx === x$0.rx) && (this.ru === x$0.ru))) {
      var x = this.rw;
      var x$2 = x$0.rw;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if (((($x_1 && (this.rr === x$0.rr)) && (this.rv === x$0.rv)) && (this.rs === x$0.rs))) {
      var x$3 = this.rt;
      var x$4 = x$0.rt;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "AppendChildrenToParentTree";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rw;
      break;
    }
    case 1: {
      return this.rx;
      break;
    }
    case 2: {
      return this.rr;
      break;
    }
    case 3: {
      return this.rv;
      break;
    }
    case 4: {
      return this.rs;
      break;
    }
    case 5: {
      return this.ru;
      break;
    }
    case 6: {
      return this.rt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_AppendChildrenToParentTree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dS)));
}
var $d_Lcom_papasofokli_execution_AppendChildrenToParentTree = new $TypeData().i($c_Lcom_papasofokli_execution_AppendChildrenToParentTree, "com.papasofokli.execution.AppendChildrenToParentTree", ({
  dS: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_AppendElementWithId(id, html) {
  this.vA = null;
  this.vz = null;
  this.vA = id;
  this.vz = html;
}
$p = $c_Lcom_papasofokli_execution_AppendElementWithId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_AppendElementWithId;
/** @constructor */
function $h_Lcom_papasofokli_execution_AppendElementWithId() {
}
$h_Lcom_papasofokli_execution_AppendElementWithId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-533014779), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_AppendElementWithId)) {
    var x = this.vA;
    var x$2 = x$0.vA;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.vz === x$0.vz);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "AppendElementWithId";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vA;
  }
  if ((n === 1)) {
    return this.vz;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_AppendElementWithId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dT)));
}
var $d_Lcom_papasofokli_execution_AppendElementWithId = new $TypeData().i($c_Lcom_papasofokli_execution_AppendElementWithId, "com.papasofokli.execution.AppendElementWithId", ({
  dT: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_CalculateDropdownPosition(ulId) {
  this.vB = null;
  this.vB = ulId;
}
$p = $c_Lcom_papasofokli_execution_CalculateDropdownPosition.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_CalculateDropdownPosition;
/** @constructor */
function $h_Lcom_papasofokli_execution_CalculateDropdownPosition() {
}
$h_Lcom_papasofokli_execution_CalculateDropdownPosition.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1965647359), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_CalculateDropdownPosition) && (this.vB === x$0.vB)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "CalculateDropdownPosition";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vB;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_CalculateDropdownPosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dU)));
}
var $d_Lcom_papasofokli_execution_CalculateDropdownPosition = new $TypeData().i($c_Lcom_papasofokli_execution_CalculateDropdownPosition, "com.papasofokli.execution.CalculateDropdownPosition", ({
  dU: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ChangeTitleTo(title) {
  this.vC = null;
  this.vC = title;
}
$p = $c_Lcom_papasofokli_execution_ChangeTitleTo.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ChangeTitleTo;
/** @constructor */
function $h_Lcom_papasofokli_execution_ChangeTitleTo() {
}
$h_Lcom_papasofokli_execution_ChangeTitleTo.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1646567952, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ChangeTitleTo) && (this.vC === x$0.vC)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ChangeTitleTo";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vC;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ChangeTitleTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dV)));
}
var $d_Lcom_papasofokli_execution_ChangeTitleTo = new $TypeData().i($c_Lcom_papasofokli_execution_ChangeTitleTo, "com.papasofokli.execution.ChangeTitleTo", ({
  dV: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ChangeUrlTo(url) {
  this.vD = null;
  this.vD = url;
}
$p = $c_Lcom_papasofokli_execution_ChangeUrlTo.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ChangeUrlTo;
/** @constructor */
function $h_Lcom_papasofokli_execution_ChangeUrlTo() {
}
$h_Lcom_papasofokli_execution_ChangeUrlTo.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 578247720, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ChangeUrlTo) && (this.vD === x$0.vD)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ChangeUrlTo";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vD;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ChangeUrlTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dW)));
}
var $d_Lcom_papasofokli_execution_ChangeUrlTo = new $TypeData().i($c_Lcom_papasofokli_execution_ChangeUrlTo, "com.papasofokli.execution.ChangeUrlTo", ({
  dW: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_CleanDetailPlannerRow(plannerId, rowId, index) {
  this.rz = null;
  this.rA = null;
  this.ry = 0;
  this.rz = plannerId;
  this.rA = rowId;
  this.ry = index;
}
$p = $c_Lcom_papasofokli_execution_CleanDetailPlannerRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_CleanDetailPlannerRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_CleanDetailPlannerRow() {
}
$h_Lcom_papasofokli_execution_CleanDetailPlannerRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 404967970);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rA));
  acc = $m_sr_Statics$().d(acc, this.ry);
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_CleanDetailPlannerRow)) {
    if ((this.ry === x$0.ry)) {
      var x = this.rz;
      var x$2 = x$0.rz;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.rA;
      var x$4 = x$0.rA;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "CleanDetailPlannerRow";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rz;
      break;
    }
    case 1: {
      return this.rA;
      break;
    }
    case 2: {
      return this.ry;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_CleanDetailPlannerRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dX)));
}
var $d_Lcom_papasofokli_execution_CleanDetailPlannerRow = new $TypeData().i($c_Lcom_papasofokli_execution_CleanDetailPlannerRow, "com.papasofokli.execution.CleanDetailPlannerRow", ({
  dX: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_CleanPlannerRow(plannerId, rowId) {
  this.vE = null;
  this.vF = null;
  this.vE = plannerId;
  this.vF = rowId;
}
$p = $c_Lcom_papasofokli_execution_CleanPlannerRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_CleanPlannerRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_CleanPlannerRow() {
}
$h_Lcom_papasofokli_execution_CleanPlannerRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1199404972), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_CleanPlannerRow)) {
    var x = this.vE;
    var x$2 = x$0.vE;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.vF;
      var x$4 = x$0.vF;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "CleanPlannerRow";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vE;
  }
  if ((n === 1)) {
    return this.vF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_CleanPlannerRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dY)));
}
var $d_Lcom_papasofokli_execution_CleanPlannerRow = new $TypeData().i($c_Lcom_papasofokli_execution_CleanPlannerRow, "com.papasofokli.execution.CleanPlannerRow", ({
  dY: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ClickOnId(id) {
  this.vG = null;
  this.vG = id;
}
$p = $c_Lcom_papasofokli_execution_ClickOnId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ClickOnId;
/** @constructor */
function $h_Lcom_papasofokli_execution_ClickOnId() {
}
$h_Lcom_papasofokli_execution_ClickOnId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-450880148), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ClickOnId)) {
    var x = this.vG;
    var x$2 = x$0.vG;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ClickOnId";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ClickOnId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dZ)));
}
var $d_Lcom_papasofokli_execution_ClickOnId = new $TypeData().i($c_Lcom_papasofokli_execution_ClickOnId, "com.papasofokli.execution.ClickOnId", ({
  dZ: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_CollapseTableRow(tableId, cssClass) {
  this.vI = null;
  this.vH = null;
  this.vI = tableId;
  this.vH = cssClass;
}
$p = $c_Lcom_papasofokli_execution_CollapseTableRow.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_CollapseTableRow;
/** @constructor */
function $h_Lcom_papasofokli_execution_CollapseTableRow() {
}
$h_Lcom_papasofokli_execution_CollapseTableRow.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1753093737), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_CollapseTableRow) && ((this.vI === x$0.vI) && (this.vH === x$0.vH))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "CollapseTableRow";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vI;
  }
  if ((n === 1)) {
    return this.vH;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_CollapseTableRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e0)));
}
var $d_Lcom_papasofokli_execution_CollapseTableRow = new $TypeData().i($c_Lcom_papasofokli_execution_CollapseTableRow, "com.papasofokli.execution.CollapseTableRow", ({
  e0: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_CopyTextToClipboard(text) {
  this.vJ = null;
  this.vJ = text;
}
$p = $c_Lcom_papasofokli_execution_CopyTextToClipboard.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_CopyTextToClipboard;
/** @constructor */
function $h_Lcom_papasofokli_execution_CopyTextToClipboard() {
}
$h_Lcom_papasofokli_execution_CopyTextToClipboard.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 740640471, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_CopyTextToClipboard) && (this.vJ === x$0.vJ)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "CopyTextToClipboard";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_CopyTextToClipboard(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e1)));
}
var $d_Lcom_papasofokli_execution_CopyTextToClipboard = new $TypeData().i($c_Lcom_papasofokli_execution_CopyTextToClipboard, "com.papasofokli.execution.CopyTextToClipboard", ({
  e1: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_DownloadFile(url) {
  this.vK = null;
  this.vK = url;
}
$p = $c_Lcom_papasofokli_execution_DownloadFile.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_DownloadFile;
/** @constructor */
function $h_Lcom_papasofokli_execution_DownloadFile() {
}
$h_Lcom_papasofokli_execution_DownloadFile.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1394810324), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_DownloadFile) && (this.vK === x$0.vK)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "DownloadFile";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vK;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_DownloadFile(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e2)));
}
var $d_Lcom_papasofokli_execution_DownloadFile = new $TypeData().i($c_Lcom_papasofokli_execution_DownloadFile, "com.papasofokli.execution.DownloadFile", ({
  e2: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ExpandModal(side1Id, side2Id, percentage, ratio) {
  this.rD = null;
  this.rE = null;
  this.rB = 0.0;
  this.rC = null;
  this.rD = side1Id;
  this.rE = side2Id;
  this.rB = percentage;
  this.rC = ratio;
}
$p = $c_Lcom_papasofokli_execution_ExpandModal.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ExpandModal;
/** @constructor */
function $h_Lcom_papasofokli_execution_ExpandModal() {
}
$h_Lcom_papasofokli_execution_ExpandModal.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1213654035);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rE));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.rB));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rC));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ExpandModal)) {
    if ((this.rB === x$0.rB)) {
      var x = this.rD;
      var x$2 = x$0.rD;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.rE;
      var x$4 = x$0.rE;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.rC;
      var x$6 = x$0.rC;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "ExpandModal";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rD;
      break;
    }
    case 1: {
      return this.rE;
      break;
    }
    case 2: {
      return this.rB;
      break;
    }
    case 3: {
      return this.rC;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_ExpandModal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e3)));
}
var $d_Lcom_papasofokli_execution_ExpandModal = new $TypeData().i($c_Lcom_papasofokli_execution_ExpandModal, "com.papasofokli.execution.ExpandModal", ({
  e3: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_FocusInput(id) {
  this.vL = null;
  this.vL = id;
}
$p = $c_Lcom_papasofokli_execution_FocusInput.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_FocusInput;
/** @constructor */
function $h_Lcom_papasofokli_execution_FocusInput() {
}
$h_Lcom_papasofokli_execution_FocusInput.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-322033590), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_FocusInput)) {
    var x = this.vL;
    var x$2 = x$0.vL;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "FocusInput";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vL;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_FocusInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e4)));
}
var $d_Lcom_papasofokli_execution_FocusInput = new $TypeData().i($c_Lcom_papasofokli_execution_FocusInput, "com.papasofokli.execution.FocusInput", ({
  e4: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_FocusPlanningPeriods(plannerId, rangeSeq) {
  this.vM = null;
  this.vN = null;
  this.vM = plannerId;
  this.vN = rangeSeq;
}
$p = $c_Lcom_papasofokli_execution_FocusPlanningPeriods.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_FocusPlanningPeriods;
/** @constructor */
function $h_Lcom_papasofokli_execution_FocusPlanningPeriods() {
}
$h_Lcom_papasofokli_execution_FocusPlanningPeriods.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-900546704), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_FocusPlanningPeriods)) {
    var x = this.vM;
    var x$2 = x$0.vM;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.vN;
      var x$4 = x$0.vN;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "FocusPlanningPeriods";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vM;
  }
  if ((n === 1)) {
    return this.vN;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_FocusPlanningPeriods(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e5)));
}
var $d_Lcom_papasofokli_execution_FocusPlanningPeriods = new $TypeData().i($c_Lcom_papasofokli_execution_FocusPlanningPeriods, "com.papasofokli.execution.FocusPlanningPeriods", ({
  e5: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect(plannerId) {
  this.vO = null;
  this.vO = plannerId;
}
$p = $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect;
/** @constructor */
function $h_Lcom_papasofokli_execution_HidePlanningGenerationEffect() {
}
$h_Lcom_papasofokli_execution_HidePlanningGenerationEffect.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 261821293, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_HidePlanningGenerationEffect)) {
    var x = this.vO;
    var x$2 = x$0.vO;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "HidePlanningGenerationEffect";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vO;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_HidePlanningGenerationEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e6)));
}
var $d_Lcom_papasofokli_execution_HidePlanningGenerationEffect = new $TypeData().i($c_Lcom_papasofokli_execution_HidePlanningGenerationEffect, "com.papasofokli.execution.HidePlanningGenerationEffect", ({
  e6: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges(plannerId) {
  this.vP = null;
  this.vP = plannerId;
}
$p = $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges;
/** @constructor */
function $h_Lcom_papasofokli_execution_HidePlanningPeriodChanges() {
}
$h_Lcom_papasofokli_execution_HidePlanningPeriodChanges.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-999906999), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_HidePlanningPeriodChanges)) {
    var x = this.vP;
    var x$2 = x$0.vP;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "HidePlanningPeriodChanges";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_HidePlanningPeriodChanges(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e7)));
}
var $d_Lcom_papasofokli_execution_HidePlanningPeriodChanges = new $TypeData().i($c_Lcom_papasofokli_execution_HidePlanningPeriodChanges, "com.papasofokli.execution.HidePlanningPeriodChanges", ({
  e7: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_HighlightTimePeriod(plannerId, fromTime_$_lo, fromTime_$_hi, toTime_$_lo, toTime_$_hi) {
  this.rF = null;
  this.tX = 0;
  this.tY = 0;
  this.tZ = 0;
  this.u0 = 0;
  this.rF = plannerId;
  this.tX = fromTime_$_lo;
  this.tY = fromTime_$_hi;
  this.tZ = toTime_$_lo;
  this.u0 = toTime_$_hi;
}
$p = $c_Lcom_papasofokli_execution_HighlightTimePeriod.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_HighlightTimePeriod;
/** @constructor */
function $h_Lcom_papasofokli_execution_HighlightTimePeriod() {
}
$h_Lcom_papasofokli_execution_HighlightTimePeriod.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1250985634);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.tX, this.tY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.tZ, this.u0));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_HighlightTimePeriod)) {
    var x_$_lo = this.tX;
    var x_$_hi = this.tY;
    var $x_2 = x$0;
    var x$1_$_lo = $x_2.tX;
    var x$1_$_hi = $x_2.tY;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.tZ;
      var x$2_$_hi = this.u0;
      var $x_3 = x$0;
      var x$3_$_lo = $x_3.tZ;
      var x$3_$_hi = $x_3.u0;
      var $x_1 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.rF === x$0.rF);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "HighlightTimePeriod";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rF;
      break;
    }
    case 1: {
      return $bL(this.tX, this.tY);
      break;
    }
    case 2: {
      return $bL(this.tZ, this.u0);
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_HighlightTimePeriod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e8)));
}
var $d_Lcom_papasofokli_execution_HighlightTimePeriod = new $TypeData().i($c_Lcom_papasofokli_execution_HighlightTimePeriod, "com.papasofokli.execution.HighlightTimePeriod", ({
  e8: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_HttpRedirect(url) {
  this.vQ = null;
  this.vQ = url;
}
$p = $c_Lcom_papasofokli_execution_HttpRedirect.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_HttpRedirect;
/** @constructor */
function $h_Lcom_papasofokli_execution_HttpRedirect() {
}
$h_Lcom_papasofokli_execution_HttpRedirect.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-409132720), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_HttpRedirect) && (this.vQ === x$0.vQ)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "HttpRedirect";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vQ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_HttpRedirect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e9)));
}
var $d_Lcom_papasofokli_execution_HttpRedirect = new $TypeData().i($c_Lcom_papasofokli_execution_HttpRedirect, "com.papasofokli.execution.HttpRedirect", ({
  e9: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_InitializeTab(id) {
  this.vR = null;
  this.vR = id;
}
$p = $c_Lcom_papasofokli_execution_InitializeTab.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_InitializeTab;
/** @constructor */
function $h_Lcom_papasofokli_execution_InitializeTab() {
}
$h_Lcom_papasofokli_execution_InitializeTab.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 602610250, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_InitializeTab)) {
    var x = this.vR;
    var x$2 = x$0.vR;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "InitializeTab";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_InitializeTab(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ea)));
}
var $d_Lcom_papasofokli_execution_InitializeTab = new $TypeData().i($c_Lcom_papasofokli_execution_InitializeTab, "com.papasofokli.execution.InitializeTab", ({
  ea: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$100(WritersVersionSpecific_this$326, outer) {
  this.Yt = null;
  this.Yt = WritersVersionSpecific_this$326;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$100.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$100;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$100() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$100.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAw = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vO);
    return ctx.L((-1));
  }
});
$p.aCW = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vO);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAw(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCW(ctx, v);
});
$p.T = (function() {
  return this.Yt;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$100 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$100, "com.papasofokli.execution.JsStatement$$anon$100", ({
  mv: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$101(WritersVersionSpecific_this$327, outer) {
  this.Yu = null;
  this.Yu = WritersVersionSpecific_this$327;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$101.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$101;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$101() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$101.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB8 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.wo);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rangeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), this$3), v.wp);
    return ctx.L((-1));
  }
});
$p.aDy = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.wo);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rangeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), this$3), v.wp);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aB8(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDy(ctx, v);
});
$p.T = (function() {
  return this.Yu;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$101 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$101, "com.papasofokli.execution.JsStatement$$anon$101", ({
  mw: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$102(WritersVersionSpecific_this$328, outer) {
  this.Yv = null;
  this.Yv = WritersVersionSpecific_this$328;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$102.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$102;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$102() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$102.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAv = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vM);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rangeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), this$3), v.vN);
    return ctx.L((-1));
  }
});
$p.aCV = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vM);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rangeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), this$3), v.vN);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAv(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCV(ctx, v);
});
$p.T = (function() {
  return this.Yv;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$102 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$102, "com.papasofokli.execution.JsStatement$$anon$102", ({
  mx: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$103(WritersVersionSpecific_this$329, outer) {
  this.Yw = null;
  this.Yw = WritersVersionSpecific_this$329;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$103.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$103;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$103() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$103.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBi = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().m, v.wy);
    return ctx.L((-1));
  }
});
$p.aDI = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().m, v.wy);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBi(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDI(ctx, v);
});
$p.T = (function() {
  return this.Yw;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$103 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$103, "com.papasofokli.execution.JsStatement$$anon$103", ({
  my: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$104(WritersVersionSpecific_this$330, outer) {
  this.Yx = null;
  this.Yx = WritersVersionSpecific_this$330;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$104.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$104;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$104() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$104.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAy = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().m, v.rF);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromTime", $m_Lupickle_default$().ay, $bL(v.tX, v.tY));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toTime", $m_Lupickle_default$().ay, $bL(v.tZ, v.u0));
    return ctx.L((-1));
  }
});
$p.aCY = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().m, v.rF);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromTime", $m_Lupickle_default$().ay, $bL(v.tX, v.tY));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toTime", $m_Lupickle_default$().ay, $bL(v.tZ, v.u0));
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAy(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCY(ctx, v);
});
$p.T = (function() {
  return this.Yx;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$104 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$104, "com.papasofokli.execution.JsStatement$$anon$104", ({
  mz: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$105(WritersVersionSpecific_this$331, outer) {
  this.Yy = null;
  this.Yy = WritersVersionSpecific_this$331;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$105.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$105;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$105() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$105.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAf = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rk);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $m_Lupickle_default$().ay, $bL(v.tV, v.tW));
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$4), v.rj);
    return ctx.L((-1));
  }
});
$p.aCF = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rk);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $m_Lupickle_default$().ay, $bL(v.tV, v.tW));
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$4), v.rj);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAf(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCF(ctx, v);
});
$p.T = (function() {
  return this.Yy;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$105 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$105, "com.papasofokli.execution.JsStatement$$anon$105", ({
  mA: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$106(WritersVersionSpecific_this$332, outer) {
  this.Yz = null;
  this.Yz = WritersVersionSpecific_this$332;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$106.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$106;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$106() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$106.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAe = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vx);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.vy);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periods", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$4), v.vw);
    return ctx.L((-1));
  }
});
$p.aCE = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vx);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.vy);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periods", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$4), v.vw);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAe(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCE(ctx, v);
});
$p.T = (function() {
  return this.Yz;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$106 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$106, "com.papasofokli.execution.JsStatement$$anon$106", ({
  mB: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$107(WritersVersionSpecific_this$333, outer) {
  this.YA = null;
  this.YA = WritersVersionSpecific_this$333;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$107.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$107;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$107() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$107.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAn = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rz);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.rA);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.ry);
    return ctx.L((-1));
  }
});
$p.aCN = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rz);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.rA);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.ry);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAn(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCN(ctx, v);
});
$p.T = (function() {
  return this.YA;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$107 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$107, "com.papasofokli.execution.JsStatement$$anon$107", ({
  mC: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$108(WritersVersionSpecific_this$334, outer) {
  this.YB = null;
  this.YB = WritersVersionSpecific_this$334;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$108.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$108;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$108() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$108.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAo = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vE);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.vF);
    return ctx.L((-1));
  }
});
$p.aCO = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vE);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.vF);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAo(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCO(ctx, v);
});
$p.T = (function() {
  return this.YB;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$108 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$108, "com.papasofokli.execution.JsStatement$$anon$108", ({
  mD: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$109(WritersVersionSpecific_this$335, outer) {
  this.YC = null;
  this.YC = WritersVersionSpecific_this$335;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$109.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$109;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$109() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$109.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB1 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rS);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sidebarSize", $m_Lupickle_default$().ao, v.rT);
    return ctx.L((-1));
  }
});
$p.aDr = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rS);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sidebarSize", $m_Lupickle_default$().ao, v.rT);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aB1(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDr(ctx, v);
});
$p.T = (function() {
  return this.YC;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$109 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$109, "com.papasofokli.execution.JsStatement$$anon$109", ({
  mE: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$110(WritersVersionSpecific_this$336, outer) {
  this.YD = null;
  this.YD = WritersVersionSpecific_this$336;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$110.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$110;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$110() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$110.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBa = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.ws);
    return ctx.L((-1));
  }
});
$p.aDA = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.ws);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBa(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDA(ctx, v);
});
$p.T = (function() {
  return this.YD;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$110 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$110, "com.papasofokli.execution.JsStatement$$anon$110", ({
  mG: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$111(WritersVersionSpecific_this$337, outer) {
  this.YE = null;
  this.YE = WritersVersionSpecific_this$337;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$111.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$111;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$111() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$111.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAp = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vG);
    return ctx.L((-1));
  }
});
$p.aCP = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vG);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAp(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCP(ctx, v);
});
$p.T = (function() {
  return this.YE;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$111 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$111, "com.papasofokli.execution.JsStatement$$anon$111", ({
  mH: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$112(WritersVersionSpecific_this$338, outer) {
  this.YF = null;
  this.YF = WritersVersionSpecific_this$338;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$112.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$112;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$112() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$112.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBb = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side1Id", $m_Lupickle_default$().a1, v.s6);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side2Id", $m_Lupickle_default$().a1, v.s7);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "percentage", $m_Lupickle_default$().g5, v.s4);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $m_Lcom_papasofokli_execution_ModalRatio$().q(), v.s5);
    return ctx.L((-1));
  }
});
$p.aDB = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side1Id", $m_Lupickle_default$().a1, v.s6);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side2Id", $m_Lupickle_default$().a1, v.s7);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "percentage", $m_Lupickle_default$().g5, v.s4);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $m_Lcom_papasofokli_execution_ModalRatio$().q(), v.s5);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aBb(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDB(ctx, v);
});
$p.T = (function() {
  return this.YF;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$112 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$112, "com.papasofokli.execution.JsStatement$$anon$112", ({
  mI: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$113(WritersVersionSpecific_this$339, outer) {
  this.YG = null;
  this.YG = WritersVersionSpecific_this$339;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$113.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$113;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$113() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$113.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAt = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side1Id", $m_Lupickle_default$().a1, v.rD);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side2Id", $m_Lupickle_default$().a1, v.rE);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "percentage", $m_Lupickle_default$().g5, v.rB);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $m_Lcom_papasofokli_execution_ModalRatio$().q(), v.rC);
    return ctx.L((-1));
  }
});
$p.aCT = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side1Id", $m_Lupickle_default$().a1, v.rD);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "side2Id", $m_Lupickle_default$().a1, v.rE);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "percentage", $m_Lupickle_default$().g5, v.rB);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ratio", $m_Lcom_papasofokli_execution_ModalRatio$().q(), v.rC);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aAt(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCT(ctx, v);
});
$p.T = (function() {
  return this.YG;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$113 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$113, "com.papasofokli.execution.JsStatement$$anon$113", ({
  mJ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$114(WritersVersionSpecific_this$340, outer) {
  this.YH = null;
  this.YH = WritersVersionSpecific_this$340;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$114.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$114;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$114() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$114.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAF = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vW);
    return ctx.L((-1));
  }
});
$p.aD5 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vW);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAF(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD5(ctx, v);
});
$p.T = (function() {
  return this.YH;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$114 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$114, "com.papasofokli.execution.JsStatement$$anon$114", ({
  mK: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$115(WritersVersionSpecific_this$341, outer) {
  this.YI = null;
  this.YI = WritersVersionSpecific_this$341;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$115.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$115;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$115() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$115.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAE = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vV);
    return ctx.L((-1));
  }
});
$p.aD4 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vV);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAE(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD4(ctx, v);
});
$p.T = (function() {
  return this.YI;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$115 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$115, "com.papasofokli.execution.JsStatement$$anon$115", ({
  mL: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$116(WritersVersionSpecific_this$342, outer) {
  this.YJ = null;
  this.YJ = WritersVersionSpecific_this$342;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$116.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$116;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$116() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$116.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAY = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rQ);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.rP);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "smooth", $m_Lupickle_default$().aw, v.rR);
    return ctx.L((-1));
  }
});
$p.aDo = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rQ);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.rP);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "smooth", $m_Lupickle_default$().aw, v.rR);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAY(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDo(ctx, v);
});
$p.T = (function() {
  return this.YJ;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$116 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$116, "com.papasofokli.execution.JsStatement$$anon$116", ({
  mM: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$117(WritersVersionSpecific_this$343, outer) {
  this.YK = null;
  this.YK = WritersVersionSpecific_this$343;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$117.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$117;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$117() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$117.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAj = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vA);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.vz);
    return ctx.L((-1));
  }
});
$p.aCJ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vA);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.vz);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAj(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCJ(ctx, v);
});
$p.T = (function() {
  return this.YK;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$117 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$117, "com.papasofokli.execution.JsStatement$$anon$117", ({
  mN: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$118(WritersVersionSpecific_this$344, outer) {
  this.YL = null;
  this.YL = WritersVersionSpecific_this$344;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$118.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$118;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$118() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$118.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAL = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w1);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.w0);
    return ctx.L((-1));
  }
});
$p.aDb = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w1);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.w0);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAL(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDb(ctx, v);
});
$p.T = (function() {
  return this.YL;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$118 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$118, "com.papasofokli.execution.JsStatement$$anon$118", ({
  mO: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$119(WritersVersionSpecific_this$345, outer) {
  this.YM = null;
  this.YM = WritersVersionSpecific_this$345;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$119.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$119;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$119() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$119.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAX = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rN);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.rM);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "smooth", $m_Lupickle_default$().aw, v.rO);
    return ctx.L((-1));
  }
});
$p.aDn = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rN);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.rM);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "smooth", $m_Lupickle_default$().aw, v.rO);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAX(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDn(ctx, v);
});
$p.T = (function() {
  return this.YM;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$119 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$119, "com.papasofokli.execution.JsStatement$$anon$119", ({
  mP: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$120(WritersVersionSpecific_this$346, outer) {
  this.YN = null;
  this.YN = WritersVersionSpecific_this$346;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$120.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$120;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$120() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$120.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAh = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rq);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compact", $m_Lupickle_default$().aw, v.rp);
    return ctx.L((-1));
  }
});
$p.aCH = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.rq);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "compact", $m_Lupickle_default$().aw, v.rp);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAh(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCH(ctx, v);
});
$p.T = (function() {
  return this.YN;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$120 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$120, "com.papasofokli.execution.JsStatement$$anon$120", ({
  mR: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$121(WritersVersionSpecific_this$347, outer) {
  this.YO = null;
  this.YO = WritersVersionSpecific_this$347;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$121.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$121;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$121() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$121.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAP = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w7);
    return ctx.L((-1));
  }
});
$p.aDf = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w7);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAP(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDf(ctx, v);
});
$p.T = (function() {
  return this.YO;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$121 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$121, "com.papasofokli.execution.JsStatement$$anon$121", ({
  mS: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$122(WritersVersionSpecific_this$348, outer) {
  this.YP = null;
  this.YP = WritersVersionSpecific_this$348;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$122.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$122;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$122() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$122.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAN = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $m_Lupickle_default$().m, v.w5);
    return ctx.L((-1));
  }
});
$p.aDd = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $m_Lupickle_default$().m, v.w5);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAN(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDd(ctx, v);
});
$p.T = (function() {
  return this.YP;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$122 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$122, "com.papasofokli.execution.JsStatement$$anon$122", ({
  mT: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$123(WritersVersionSpecific_this$349, outer) {
  this.YQ = null;
  this.YQ = WritersVersionSpecific_this$349;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$123.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$123;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$123() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$123.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAG = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "printerName", $m_Lupickle_default$().m, v.vX);
    return ctx.L((-1));
  }
});
$p.aD6 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "printerName", $m_Lupickle_default$().m, v.vX);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAG(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD6(ctx, v);
});
$p.T = (function() {
  return this.YQ;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$123 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$123, "com.papasofokli.execution.JsStatement$$anon$123", ({
  mU: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$124(WritersVersionSpecific_this$350, outer) {
  this.YR = null;
  this.YR = WritersVersionSpecific_this$350;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$124.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$124;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$124() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$124.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAM = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(6, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pdfBytes", $f_Lupickle_implicits_Writers__ArrayWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().HX), v.rK);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentHeight", $m_Lupickle_default$().g5, v.w2);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "documentWidth", $m_Lupickle_default$().g5, v.w3);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "printerName", $m_Lupickle_default$().m, v.rL);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "jobName", $m_Lupickle_default$().m, v.rJ);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "openCashbox", $m_Lupickle_default$().aw, v.w4);
    return ctx.L((-1));
  }
});
$p.aDc = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "pdfBytes", $f_Lupickle_implicits_Writers__ArrayWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().HX), v.rK);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contentHeight", $m_Lupickle_default$().g5, v.w2);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "documentWidth", $m_Lupickle_default$().g5, v.w3);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "printerName", $m_Lupickle_default$().m, v.rL);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "jobName", $m_Lupickle_default$().m, v.rJ);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "openCashbox", $m_Lupickle_default$().aw, v.w4);
});
$p.ah = (function(v) {
  return 6;
});
$p.U = (function(out, v) {
  return this.aAM(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDc(ctx, v);
});
$p.T = (function() {
  return this.YR;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$124 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$124, "com.papasofokli.execution.JsStatement$$anon$124", ({
  mV: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$125(WritersVersionSpecific_this$351, outer) {
  this.YS = null;
  this.YS = WritersVersionSpecific_this$351;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$125.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$125;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$125() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$125.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAs = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vK);
    return ctx.L((-1));
  }
});
$p.aCS = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vK);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAs(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCS(ctx, v);
});
$p.T = (function() {
  return this.YS;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$125 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$125, "com.papasofokli.execution.JsStatement$$anon$125", ({
  mW: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$126(WritersVersionSpecific_this$352, outer) {
  this.YT = null;
  this.YT = WritersVersionSpecific_this$352;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$126.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$126;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$126() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$126.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBh = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wx);
    return ctx.L((-1));
  }
});
$p.aDH = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wx);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBh(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDH(ctx, v);
});
$p.T = (function() {
  return this.YT;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$126 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$126, "com.papasofokli.execution.JsStatement$$anon$126", ({
  mX: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$127(WritersVersionSpecific_this$353, outer) {
  this.YU = null;
  this.YU = WritersVersionSpecific_this$353;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$127.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$127;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$127() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$127.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBk = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "number", $m_Lupickle_default$().ao, v.sh);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.sg);
    return ctx.L((-1));
  }
});
$p.aDK = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "number", $m_Lupickle_default$().ao, v.sh);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.sg);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBk(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDK(ctx, v);
});
$p.T = (function() {
  return this.YU;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$127 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$127, "com.papasofokli.execution.JsStatement$$anon$127", ({
  mY: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$128(WritersVersionSpecific_this$354, outer) {
  this.YV = null;
  this.YV = WritersVersionSpecific_this$354;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$128.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$128;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$128() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$128.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB7 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "alwaysHidden", $m_Lupickle_default$().aw, v.s3);
    return ctx.L((-1));
  }
});
$p.aDx = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "alwaysHidden", $m_Lupickle_default$().aw, v.s3);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aB7(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDx(ctx, v);
});
$p.T = (function() {
  return this.YV;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$128 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$128, "com.papasofokli.execution.JsStatement$$anon$128", ({
  mZ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$129(WritersVersionSpecific_this$355, outer) {
  this.YW = null;
  this.YW = WritersVersionSpecific_this$355;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$129.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$129;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$129() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$129.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAz = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vQ);
    return ctx.L((-1));
  }
});
$p.aCZ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vQ);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAz(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCZ(ctx, v);
});
$p.T = (function() {
  return this.YW;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$129 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$129, "com.papasofokli.execution.JsStatement$$anon$129", ({
  n0: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$130(WritersVersionSpecific_this$356, outer) {
  this.YX = null;
  this.YX = WritersVersionSpecific_this$356;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$130.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$130;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$130() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$130.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAD = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vU);
    return ctx.L((-1));
  }
});
$p.aD3 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vU);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAD(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD3(ctx, v);
});
$p.T = (function() {
  return this.YX;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$130 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$130, "com.papasofokli.execution.JsStatement$$anon$130", ({
  n2: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$131(WritersVersionSpecific_this$357, outer) {
  this.YY = null;
  this.YY = WritersVersionSpecific_this$357;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$131.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$131;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$131() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$131.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAl = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.vC);
    return ctx.L((-1));
  }
});
$p.aCL = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.vC);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAl(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCL(ctx, v);
});
$p.T = (function() {
  return this.YY;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$131 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$131, "com.papasofokli.execution.JsStatement$$anon$131", ({
  n3: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$132(WritersVersionSpecific_this$358, outer) {
  this.YZ = null;
  this.YZ = WritersVersionSpecific_this$358;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$132.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$132;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$132() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$132.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAm = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vD);
    return ctx.L((-1));
  }
});
$p.aCM = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.vD);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAm(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCM(ctx, v);
});
$p.T = (function() {
  return this.YZ;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$132 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$132, "com.papasofokli.execution.JsStatement$$anon$132", ({
  n4: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$133(WritersVersionSpecific_this$359, outer) {
  this.Z0 = null;
  this.Z0 = WritersVersionSpecific_this$359;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$133.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$133;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$133() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$133.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.air = (function(v) {
  return ((2 + ((!$m_sr_BoxesRunTime$().B(v.ls, false)) | 0)) | 0);
});
$p.aAH = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.air(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.rH);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $m_Lupickle_default$().m, v.rG);
    if ((!$m_sr_BoxesRunTime$().B(v.ls, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "warnIfIsBlocked", $m_Lupickle_default$().aw, v.ls);
    }
    return ctx.L((-1));
  }
});
$p.aD7 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "url", $m_Lupickle_default$().m, v.rH);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "target", $m_Lupickle_default$().m, v.rG);
  if ((!$m_sr_BoxesRunTime$().B(v.ls, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "warnIfIsBlocked", $m_Lupickle_default$().aw, v.ls);
  }
});
$p.ah = (function(v) {
  return this.air(v);
});
$p.U = (function(out, v) {
  return this.aAH(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD7(ctx, v);
});
$p.T = (function() {
  return this.Z0;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$133 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$133, "com.papasofokli.execution.JsStatement$$anon$133", ({
  n5: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$134(WritersVersionSpecific_this$360, outer) {
  this.Z1 = null;
  this.Z1 = WritersVersionSpecific_this$360;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$134.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$134;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$134() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$134.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAW = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.wi);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wj);
    return ctx.L((-1));
  }
});
$p.aDm = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.wi);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wj);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAW(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDm(ctx, v);
});
$p.T = (function() {
  return this.Z1;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$134 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$134, "com.papasofokli.execution.JsStatement$$anon$134", ({
  n6: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$135(WritersVersionSpecific_this$361, outer) {
  this.Z2 = null;
  this.Z2 = WritersVersionSpecific_this$361;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$135.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$135;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$135() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$135.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAU = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().m, v.we);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wf);
    return ctx.L((-1));
  }
});
$p.aDk = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().m, v.we);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wf);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAU(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDk(ctx, v);
});
$p.T = (function() {
  return this.Z2;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$135 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$135, "com.papasofokli.execution.JsStatement$$anon$135", ({
  n7: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$136(WritersVersionSpecific_this$362, outer) {
  this.Z3 = null;
  this.Z3 = WritersVersionSpecific_this$362;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$136.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$136;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$136() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$136.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAV = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().m, v.wg);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wh);
    return ctx.L((-1));
  }
});
$p.aDl = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().m, v.wg);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().m, v.wh);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAV(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDl(ctx, v);
});
$p.T = (function() {
  return this.Z3;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$136 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$136, "com.papasofokli.execution.JsStatement$$anon$136", ({
  n8: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$137(WritersVersionSpecific_this$363, outer) {
  this.Z4 = null;
  this.Z4 = WritersVersionSpecific_this$363;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$137.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$137;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$137() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$137.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAQ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uuid", $m_Lupickle_default$().a1, v.w8);
    return ctx.L((-1));
  }
});
$p.aDg = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uuid", $m_Lupickle_default$().a1, v.w8);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAQ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDg(ctx, v);
});
$p.T = (function() {
  return this.Z4;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$137 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$137, "com.papasofokli.execution.JsStatement$$anon$137", ({
  n9: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$138(WritersVersionSpecific_this$364, outer) {
  this.Z5 = null;
  this.Z5 = WritersVersionSpecific_this$364;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$138.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$138;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$138() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$138.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBl = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "formGroupId", $m_Lupickle_default$().a1, v.wz);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "helpId", $m_Lupickle_default$().a1, v.wA);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "status", $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().q(), v.wC);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "helpText", $m_Lupickle_default$().m, v.wB);
    return ctx.L((-1));
  }
});
$p.aDL = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "formGroupId", $m_Lupickle_default$().a1, v.wz);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "helpId", $m_Lupickle_default$().a1, v.wA);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "status", $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().q(), v.wC);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "helpText", $m_Lupickle_default$().m, v.wB);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aBl(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDL(ctx, v);
});
$p.T = (function() {
  return this.Z5;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$138 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$138, "com.papasofokli.execution.JsStatement$$anon$138", ({
  na: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$139(WritersVersionSpecific_this$365, outer) {
  this.Z6 = null;
  this.Z6 = WritersVersionSpecific_this$365;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$139.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$139;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$139() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$139.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAZ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lupickle_default$().m, v.wk);
    return ctx.L((-1));
  }
});
$p.aDp = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lupickle_default$().m, v.wk);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAZ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDp(ctx, v);
});
$p.T = (function() {
  return this.Z6;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$139 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$139, "com.papasofokli.execution.JsStatement$$anon$139", ({
  nb: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$140(WritersVersionSpecific_this$366, outer) {
  this.Z7 = null;
  this.Z7 = WritersVersionSpecific_this$366;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$140.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$140;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$140() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$140.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAI = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lupickle_default$().m, v.vY);
    return ctx.L((-1));
  }
});
$p.aD8 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "data", $m_Lupickle_default$().m, v.vY);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAI(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD8(ctx, v);
});
$p.T = (function() {
  return this.Z7;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$140 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$140, "com.papasofokli.execution.JsStatement$$anon$140", ({
  nd: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$141(WritersVersionSpecific_this$367, outer) {
  this.Z8 = null;
  this.Z8 = WritersVersionSpecific_this$367;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$141.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$141;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$141() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$141.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAx = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vP);
    return ctx.L((-1));
  }
});
$p.aCX = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.vP);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAx(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCX(ctx, v);
});
$p.T = (function() {
  return this.Z8;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$141 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$141, "com.papasofokli.execution.JsStatement$$anon$141", ({
  ne: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$142(WritersVersionSpecific_this$368, outer) {
  this.Z9 = null;
  this.Z9 = WritersVersionSpecific_this$368;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$142.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$142;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$142() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$142.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB9 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.wr);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PlanningPeriodChange$().q(), this$3), v.wq);
    return ctx.L((-1));
  }
});
$p.aDz = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.wr);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PlanningPeriodChange$().q(), this$3), v.wq);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aB9(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDz(ctx, v);
});
$p.T = (function() {
  return this.Z9;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$142 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$142, "com.papasofokli.execution.JsStatement$$anon$142", ({
  nf: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$143(WritersVersionSpecific_this$369, outer) {
  this.Za = null;
  this.Za = WritersVersionSpecific_this$369;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$143.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$143;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$143() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$143.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAC = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uuid", $m_Lupickle_default$().a1, v.vT);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodChanges", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodTransformation$().q(), this$3), v.vS);
    return ctx.L((-1));
  }
});
$p.aD2 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uuid", $m_Lupickle_default$().a1, v.vT);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodChanges", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodTransformation$().q(), this$3), v.vS);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAC(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD2(ctx, v);
});
$p.T = (function() {
  return this.Za;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$143 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$143, "com.papasofokli.execution.JsStatement$$anon$143", ({
  ng: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$144(WritersVersionSpecific_this$370, outer) {
  this.Zb = null;
  this.Zb = WritersVersionSpecific_this$370;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$144.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$144;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$144() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$144.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB6 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightId", $m_Lupickle_default$().a1, v.s1);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftId", $m_Lupickle_default$().a1, v.rZ);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightSize", $m_Lupickle_default$().ao, v.s2);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightCss", $m_Lupickle_default$().m, v.s0);
    return ctx.L((-1));
  }
});
$p.aDw = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightId", $m_Lupickle_default$().a1, v.s1);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftId", $m_Lupickle_default$().a1, v.rZ);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightSize", $m_Lupickle_default$().ao, v.s2);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightCss", $m_Lupickle_default$().m, v.s0);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aB6(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDw(ctx, v);
});
$p.T = (function() {
  return this.Zb;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$144 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$144, "com.papasofokli.execution.JsStatement$$anon$144", ({
  nh: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$145(WritersVersionSpecific_this$371, outer) {
  this.Zc = null;
  this.Zc = WritersVersionSpecific_this$371;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$145.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$145;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$145() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$145.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBg = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.ww);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.wv);
    return ctx.L((-1));
  }
});
$p.aDG = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.ww);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.wv);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBg(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDG(ctx, v);
});
$p.T = (function() {
  return this.Zc;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$145 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$145, "com.papasofokli.execution.JsStatement$$anon$145", ({
  ni: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$146(WritersVersionSpecific_this$372, outer) {
  this.Zd = null;
  this.Zd = WritersVersionSpecific_this$372;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$146.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$146;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$146() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$146.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAS = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.wc);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.wb);
    return ctx.L((-1));
  }
});
$p.aDi = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.wc);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.wb);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAS(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDi(ctx, v);
});
$p.T = (function() {
  return this.Zd;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$146 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$146, "com.papasofokli.execution.JsStatement$$anon$146", ({
  nj: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$147(WritersVersionSpecific_this$373, outer) {
  this.Ze = null;
  this.Ze = WritersVersionSpecific_this$373;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$147.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$147;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$147() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$147.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAc = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.vv);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.vu);
    return ctx.L((-1));
  }
});
$p.aCC = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "elementId", $m_Lupickle_default$().a1, v.vv);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "className", $m_Lupickle_default$().m, v.vu);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAc(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCC(ctx, v);
});
$p.T = (function() {
  return this.Ze;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$147 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$147, "com.papasofokli.execution.JsStatement$$anon$147", ({
  nk: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$148(WritersVersionSpecific_this$374, outer) {
  this.Zf = null;
  this.Zf = WritersVersionSpecific_this$374;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$148.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$148;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$148() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$148.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAA = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vR);
    return ctx.L((-1));
  }
});
$p.aD0 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vR);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAA(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD0(ctx, v);
});
$p.T = (function() {
  return this.Zf;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$148 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$148, "com.papasofokli.execution.JsStatement$$anon$148", ({
  nl: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$75(WritersVersionSpecific_this$301, outer) {
  this.Zg = null;
  this.Zg = WritersVersionSpecific_this$301;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$75.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$75;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$75() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$75.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBf = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.sc);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.sa);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortDirection", $m_Lupickle_default$().m, v.sb);
    return ctx.L((-1));
  }
});
$p.aDF = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.sc);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.sa);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortDirection", $m_Lupickle_default$().m, v.sb);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBf(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDF(ctx, v);
});
$p.T = (function() {
  return this.Zg;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$75 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$75, "com.papasofokli.execution.JsStatement$$anon$75", ({
  oq: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$76(WritersVersionSpecific_this$302, outer) {
  this.Zh = null;
  this.Zh = WritersVersionSpecific_this$302;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$76.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$76;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$76() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$76.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBe = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.s9);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.s8);
    return ctx.L((-1));
  }
});
$p.aDE = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.s9);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.s8);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBe(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDE(ctx, v);
});
$p.T = (function() {
  return this.Zh;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$76 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$76, "com.papasofokli.execution.JsStatement$$anon$76", ({
  or: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$77(WritersVersionSpecific_this$303, outer) {
  this.Zi = null;
  this.Zi = WritersVersionSpecific_this$303;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$77.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$77;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$77() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$77.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB0 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "videoId", $m_Lupickle_default$().m, v.wl);
    return ctx.L((-1));
  }
});
$p.aDq = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "videoId", $m_Lupickle_default$().m, v.wl);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aB0(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDq(ctx, v);
});
$p.T = (function() {
  return this.Zi;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$77 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$77, "com.papasofokli.execution.JsStatement$$anon$77", ({
  os: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$78(WritersVersionSpecific_this$304, outer) {
  this.Zj = null;
  this.Zj = WritersVersionSpecific_this$304;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$78.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$78;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$78() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$78.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBj = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "agileBoard2Id", $m_Lupickle_default$().m, v.sd);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.se);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnContent", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$4), v.sf);
    return ctx.L((-1));
  }
});
$p.aDJ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "agileBoard2Id", $m_Lupickle_default$().m, v.sd);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "column", $m_Lupickle_default$().ao, v.se);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "columnContent", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$4), v.sf);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBj(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDJ(ctx, v);
});
$p.T = (function() {
  return this.Zj;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$78 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$78, "com.papasofokli.execution.JsStatement$$anon$78", ({
  ot: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$80(WritersVersionSpecific_this$306, outer) {
  this.Zk = null;
  this.Zk = WritersVersionSpecific_this$306;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$80.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$80;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$80() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$80.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAq = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.vI);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.vH);
    return ctx.L((-1));
  }
});
$p.aCQ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.vI);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.vH);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aAq(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCQ(ctx, v);
});
$p.T = (function() {
  return this.Zk;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$80 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$80, "com.papasofokli.execution.JsStatement$$anon$80", ({
  ov: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$81(WritersVersionSpecific_this$307, outer) {
  this.Zl = null;
  this.Zl = WritersVersionSpecific_this$307;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$81.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$81;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$81() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$81.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aip = (function(v) {
  return ((4 + ((!$m_sr_BoxesRunTime$().B(v.lr, false)) | 0)) | 0);
});
$p.aAg = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aip(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.ro);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "position", $m_Lupickle_default$().ao, v.rm);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "noOfColumns", $m_Lupickle_default$().ao, v.rl);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowContent", $m_Lupickle_default$().m, v.rn);
    if ((!$m_sr_BoxesRunTime$().B(v.lr, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapseExpandedRows", $m_Lupickle_default$().aw, v.lr);
    }
    return ctx.L((-1));
  }
});
$p.aCG = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tableId", $m_Lupickle_default$().m, v.ro);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "position", $m_Lupickle_default$().ao, v.rm);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "noOfColumns", $m_Lupickle_default$().ao, v.rl);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowContent", $m_Lupickle_default$().m, v.rn);
  if ((!$m_sr_BoxesRunTime$().B(v.lr, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "collapseExpandedRows", $m_Lupickle_default$().aw, v.lr);
  }
});
$p.ah = (function(v) {
  return this.aip(v);
});
$p.U = (function(out, v) {
  return this.aAg(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCG(ctx, v);
});
$p.T = (function() {
  return this.Zl;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$81 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$81, "com.papasofokli.execution.JsStatement$$anon$81", ({
  ow: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$82(WritersVersionSpecific_this$308, outer) {
  this.Zm = null;
  this.Zm = WritersVersionSpecific_this$308;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$82.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$82;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$82() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$82.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAr = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.vJ);
    return ctx.L((-1));
  }
});
$p.aCR = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.vJ);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAr(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCR(ctx, v);
});
$p.T = (function() {
  return this.Zm;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$82 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$82, "com.papasofokli.execution.JsStatement$$anon$82", ({
  ox: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$83(WritersVersionSpecific_this$309, outer) {
  this.Zn = null;
  this.Zn = WritersVersionSpecific_this$309;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$83.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$83;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$83() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$83.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBc = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wt);
    return ctx.L((-1));
  }
});
$p.aDC = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wt);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBc(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDC(ctx, v);
});
$p.T = (function() {
  return this.Zn;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$83 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$83, "com.papasofokli.execution.JsStatement$$anon$83", ({
  oy: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$84(WritersVersionSpecific_this$310, outer) {
  this.Zo = null;
  this.Zo = WritersVersionSpecific_this$310;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$84.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$84;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$84() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$84.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBd = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wu);
    return ctx.L((-1));
  }
});
$p.aDD = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wu);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBd(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDD(ctx, v);
});
$p.T = (function() {
  return this.Zo;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$84 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$84, "com.papasofokli.execution.JsStatement$$anon$84", ({
  oz: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$85(WritersVersionSpecific_this$311, outer) {
  this.Zp = null;
  this.Zp = WritersVersionSpecific_this$311;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$85.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$85;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$85() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$85.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAu = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vL);
    return ctx.L((-1));
  }
});
$p.aCU = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vL);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAu(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCU(ctx, v);
});
$p.T = (function() {
  return this.Zp;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$85 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$85, "com.papasofokli.execution.JsStatement$$anon$85", ({
  oA: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$86(WritersVersionSpecific_this$312, outer) {
  this.Zq = null;
  this.Zq = WritersVersionSpecific_this$312;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$86.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$86;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$86() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$86.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB3 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wm);
    return ctx.L((-1));
  }
});
$p.aDt = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wm);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aB3(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDt(ctx, v);
});
$p.T = (function() {
  return this.Zq;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$86 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$86, "com.papasofokli.execution.JsStatement$$anon$86", ({
  oB: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$87(WritersVersionSpecific_this$313, outer) {
  this.Zr = null;
  this.Zr = WritersVersionSpecific_this$313;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$87.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$87;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$87() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$87.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB4 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wn);
    return ctx.L((-1));
  }
});
$p.aDu = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wn);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aB4(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDu(ctx, v);
});
$p.T = (function() {
  return this.Zr;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$87 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$87, "com.papasofokli.execution.JsStatement$$anon$87", ({
  oC: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$88(WritersVersionSpecific_this$314, outer) {
  this.Zs = null;
  this.Zs = WritersVersionSpecific_this$314;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$88.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$88;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$88() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$88.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAT = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wd);
    return ctx.L((-1));
  }
});
$p.aDj = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wd);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAT(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDj(ctx, v);
});
$p.T = (function() {
  return this.Zs;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$88 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$88, "com.papasofokli.execution.JsStatement$$anon$88", ({
  oD: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$89(WritersVersionSpecific_this$315, outer) {
  this.Zt = null;
  this.Zt = WritersVersionSpecific_this$315;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$89.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$89;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$89() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$89.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ais = (function(v) {
  return ((2 + ((v.nn !== "") | 0)) | 0);
});
$p.aAR = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ais(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wa);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeName", $m_Lupickle_default$().m, v.w9);
    if ((v.nn !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "idSuffix", $m_Lupickle_default$().m, v.nn);
    }
    return ctx.L((-1));
  }
});
$p.aDh = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.wa);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeName", $m_Lupickle_default$().m, v.w9);
  if ((v.nn !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "idSuffix", $m_Lupickle_default$().m, v.nn);
  }
});
$p.ah = (function(v) {
  return this.ais(v);
});
$p.U = (function(out, v) {
  return this.aAR(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDh(ctx, v);
});
$p.T = (function() {
  return this.Zt;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$89 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$89, "com.papasofokli.execution.JsStatement$$anon$89", ({
  oE: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$90(WritersVersionSpecific_this$316, outer) {
  this.Zu = null;
  this.Zu = WritersVersionSpecific_this$316;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$90.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$90;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$90() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$90.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aio = (function(v) {
  return ((3 + ((v.nm !== "") | 0)) | 0);
});
$p.aAb = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aio(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vt);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeName", $m_Lupickle_default$().m, v.vr);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeValue", $m_Lupickle_default$().m, v.vs);
    if ((v.nm !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "idSuffix", $m_Lupickle_default$().m, v.nm);
    }
    return ctx.L((-1));
  }
});
$p.aCB = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vt);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeName", $m_Lupickle_default$().m, v.vr);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "attributeValue", $m_Lupickle_default$().m, v.vs);
  if ((v.nm !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "idSuffix", $m_Lupickle_default$().m, v.nm);
  }
});
$p.ah = (function(v) {
  return this.aio(v);
});
$p.U = (function(out, v) {
  return this.aAb(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCB(ctx, v);
});
$p.T = (function() {
  return this.Zu;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$90 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$90, "com.papasofokli.execution.JsStatement$$anon$90", ({
  oG: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$91(WritersVersionSpecific_this$317, outer) {
  this.Zv = null;
  this.Zv = WritersVersionSpecific_this$317;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$91.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$91;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$91() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$91.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAK = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vZ);
    return ctx.L((-1));
  }
});
$p.aDa = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.vZ);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAK(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDa(ctx, v);
});
$p.T = (function() {
  return this.Zv;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$91 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$91, "com.papasofokli.execution.JsStatement$$anon$91", ({
  oH: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$92(WritersVersionSpecific_this$318, outer) {
  this.Zw = null;
  this.Zw = WritersVersionSpecific_this$318;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$92.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$92;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$92() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$92.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB2 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().m, v.rU);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isModal", $m_Lupickle_default$().aw, v.rV);
    return ctx.L((-1));
  }
});
$p.aDs = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().m, v.rU);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isModal", $m_Lupickle_default$().aw, v.rV);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aB2(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDs(ctx, v);
});
$p.T = (function() {
  return this.Zw;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$92 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$92, "com.papasofokli.execution.JsStatement$$anon$92", ({
  oI: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$93(WritersVersionSpecific_this$319, outer) {
  this.Zx = null;
  this.Zx = WritersVersionSpecific_this$319;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$93.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$93;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$93() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$93.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAO = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w6);
    return ctx.L((-1));
  }
});
$p.aDe = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.w6);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAO(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDe(ctx, v);
});
$p.T = (function() {
  return this.Zx;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$93 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$93, "com.papasofokli.execution.JsStatement$$anon$93", ({
  oJ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$94(WritersVersionSpecific_this$320, outer) {
  this.Zy = null;
  this.Zy = WritersVersionSpecific_this$320;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$94.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$94;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$94() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$94.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAi = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(7, true, (-1));
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.rw);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "withRefresh", $m_Lupickle_default$().aw, v.rx);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickFunctionId", $m_Lupickle_default$().m, v.rr);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafClickFunctionId", $m_Lupickle_default$().m, v.rv);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFunctionId", $m_Lupickle_default$().m, v.rs);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expandOnDoubleClick", $m_Lupickle_default$().aw, v.ru);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.rt);
    return ctx.L((-1));
  }
});
$p.aCI = (function(ctx, v) {
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.rw);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "withRefresh", $m_Lupickle_default$().aw, v.rx);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickFunctionId", $m_Lupickle_default$().m, v.rr);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafClickFunctionId", $m_Lupickle_default$().m, v.rv);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFunctionId", $m_Lupickle_default$().m, v.rs);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expandOnDoubleClick", $m_Lupickle_default$().aw, v.ru);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.rt);
});
$p.ah = (function(v) {
  return 7;
});
$p.U = (function(out, v) {
  return this.aAi(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCI(ctx, v);
});
$p.T = (function() {
  return this.Zy;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$94 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$94, "com.papasofokli.execution.JsStatement$$anon$94", ({
  oK: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$95(WritersVersionSpecific_this$321, outer) {
  this.Zz = null;
  this.Zz = WritersVersionSpecific_this$321;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$95.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$95;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$95() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$95.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAk = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ulId", $m_Lupickle_default$().m, v.vB);
    return ctx.L((-1));
  }
});
$p.aCK = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "ulId", $m_Lupickle_default$().m, v.vB);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aAk(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCK(ctx, v);
});
$p.T = (function() {
  return this.Zz;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$95 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$95, "com.papasofokli.execution.JsStatement$$anon$95", ({
  oL: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$98(WritersVersionSpecific_this$324, outer) {
  this.ZA = null;
  this.ZA = WritersVersionSpecific_this$324;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$98.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$98;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$98() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$98.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aB5 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "progressBarId", $m_Lupickle_default$().a1, v.rW);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().h8, v.rY);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_util_ProgressBarStyle$().q()), v.rX);
    return ctx.L((-1));
  }
});
$p.aDv = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "progressBarId", $m_Lupickle_default$().a1, v.rW);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $m_Lupickle_default$().h8, v.rY);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_util_ProgressBarStyle$().q()), v.rX);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aB5(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDv(ctx, v);
});
$p.T = (function() {
  return this.ZA;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$98 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$98, "com.papasofokli.execution.JsStatement$$anon$98", ({
  oM: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$99(WritersVersionSpecific_this$325, outer) {
  this.ZB = null;
  this.ZB = WritersVersionSpecific_this$325;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$99.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$99;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$99() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$99.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAd = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rh);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.ri);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.rf);
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periods", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$5), v.rg);
    return ctx.L((-1));
  }
});
$p.aCD = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "plannerId", $m_Lupickle_default$().a1, v.rh);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.ri);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "index", $m_Lupickle_default$().ao, v.rf);
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periods", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$5), v.rg);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aAd(out, v);
});
$p.ai = (function(ctx, v) {
  this.aCD(ctx, v);
});
$p.T = (function() {
  return this.ZB;
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$99 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$99, "com.papasofokli.execution.JsStatement$$anon$99", ({
  oN: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ModalRatio$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.ZE = null;
  this.ZE = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_ModalRatio$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ModalRatio$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_execution_ModalRatio$$anon$2() {
}
$h_Lcom_papasofokli_execution_ModalRatio$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiq = (function(v) {
  return ((((!$m_sr_BoxesRunTime$().dG(v.jW, 6)) | 0) + ((!$m_sr_BoxesRunTime$().dG(v.jX, 6)) | 0)) | 0);
});
$p.aAB = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiq(v), true, (-1));
    if ((!$m_sr_BoxesRunTime$().dG(v.jW, 6))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "left", $m_Lupickle_default$().ao, v.jW);
    }
    if ((!$m_sr_BoxesRunTime$().dG(v.jX, 6))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "right", $m_Lupickle_default$().ao, v.jX);
    }
    return ctx.L((-1));
  }
});
$p.aD1 = (function(ctx, v) {
  if ((!$m_sr_BoxesRunTime$().dG(v.jW, 6))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "left", $m_Lupickle_default$().ao, v.jW);
  }
  if ((!$m_sr_BoxesRunTime$().dG(v.jX, 6))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "right", $m_Lupickle_default$().ao, v.jX);
  }
});
$p.ah = (function(v) {
  return this.aiq(v);
});
$p.U = (function(out, v) {
  return this.aAB(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD1(ctx, v);
});
$p.T = (function() {
  return this.ZE;
});
var $d_Lcom_papasofokli_execution_ModalRatio$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_execution_ModalRatio$$anon$2, "com.papasofokli.execution.ModalRatio$$anon$2", ({
  oQ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ModifyPeriods(uuid, periodChanges) {
  this.vT = null;
  this.vS = null;
  this.vT = uuid;
  this.vS = periodChanges;
}
$p = $c_Lcom_papasofokli_execution_ModifyPeriods.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ModifyPeriods;
/** @constructor */
function $h_Lcom_papasofokli_execution_ModifyPeriods() {
}
$h_Lcom_papasofokli_execution_ModifyPeriods.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1983866967), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ModifyPeriods)) {
    var x = this.vT;
    var x$2 = x$0.vT;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.vS;
      var x$4 = x$0.vS;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ModifyPeriods";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vT;
  }
  if ((n === 1)) {
    return this.vS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ModifyPeriods(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ec)));
}
var $d_Lcom_papasofokli_execution_ModifyPeriods = new $TypeData().i($c_Lcom_papasofokli_execution_ModifyPeriods, "com.papasofokli.execution.ModifyPeriods", ({
  ec: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_NavigateTo(url) {
  this.vU = null;
  this.vU = url;
}
$p = $c_Lcom_papasofokli_execution_NavigateTo.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_NavigateTo;
/** @constructor */
function $h_Lcom_papasofokli_execution_NavigateTo() {
}
$h_Lcom_papasofokli_execution_NavigateTo.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-661381009), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_NavigateTo) && (this.vU === x$0.vU)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "NavigateTo";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_NavigateTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ed)));
}
var $d_Lcom_papasofokli_execution_NavigateTo = new $TypeData().i($c_Lcom_papasofokli_execution_NavigateTo, "com.papasofokli.execution.NavigateTo", ({
  ed: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_OnCloseModal(id) {
  this.vV = null;
  this.vV = id;
}
$p = $c_Lcom_papasofokli_execution_OnCloseModal.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_OnCloseModal;
/** @constructor */
function $h_Lcom_papasofokli_execution_OnCloseModal() {
}
$h_Lcom_papasofokli_execution_OnCloseModal.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 91502904, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_OnCloseModal)) {
    var x = this.vV;
    var x$2 = x$0.vV;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "OnCloseModal";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vV;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_OnCloseModal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ee)));
}
var $d_Lcom_papasofokli_execution_OnCloseModal = new $TypeData().i($c_Lcom_papasofokli_execution_OnCloseModal, "com.papasofokli.execution.OnCloseModal", ({
  ee: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_OnShownModal(id) {
  this.vW = null;
  this.vW = id;
}
$p = $c_Lcom_papasofokli_execution_OnShownModal.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_OnShownModal;
/** @constructor */
function $h_Lcom_papasofokli_execution_OnShownModal() {
}
$h_Lcom_papasofokli_execution_OnShownModal.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1025451248, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_OnShownModal)) {
    var x = this.vW;
    var x$2 = x$0.vW;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "OnShownModal";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vW;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_OnShownModal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ef)));
}
var $d_Lcom_papasofokli_execution_OnShownModal = new $TypeData().i($c_Lcom_papasofokli_execution_OnShownModal, "com.papasofokli.execution.OnShownModal", ({
  ef: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_OpenPrinterCashbox(printerName) {
  this.vX = null;
  this.vX = printerName;
}
$p = $c_Lcom_papasofokli_execution_OpenPrinterCashbox.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_OpenPrinterCashbox;
/** @constructor */
function $h_Lcom_papasofokli_execution_OpenPrinterCashbox() {
}
$h_Lcom_papasofokli_execution_OpenPrinterCashbox.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1733762425, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_OpenPrinterCashbox) && (this.vX === x$0.vX)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "OpenPrinterCashbox";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vX;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_OpenPrinterCashbox(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eg)));
}
var $d_Lcom_papasofokli_execution_OpenPrinterCashbox = new $TypeData().i($c_Lcom_papasofokli_execution_OpenPrinterCashbox, "com.papasofokli.execution.OpenPrinterCashbox", ({
  eg: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_OpenUrl(url, target, warnIfIsBlocked) {
  this.rH = null;
  this.rG = null;
  this.ls = false;
  this.rH = url;
  this.rG = target;
  this.ls = warnIfIsBlocked;
}
$p = $c_Lcom_papasofokli_execution_OpenUrl.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_OpenUrl;
/** @constructor */
function $h_Lcom_papasofokli_execution_OpenUrl() {
}
$h_Lcom_papasofokli_execution_OpenUrl.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 401449637);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rG));
  acc = $m_sr_Statics$().d(acc, (this.ls ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_OpenUrl) && (((this.ls === x$0.ls) && (this.rH === x$0.rH)) && (this.rG === x$0.rG))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "OpenUrl";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rH;
      break;
    }
    case 1: {
      return this.rG;
      break;
    }
    case 2: {
      return this.ls;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_OpenUrl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eh)));
}
var $d_Lcom_papasofokli_execution_OpenUrl = new $TypeData().i($c_Lcom_papasofokli_execution_OpenUrl, "com.papasofokli.execution.OpenUrl", ({
  eh: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PayrollTreeLoadData(data) {
  this.vY = null;
  this.vY = data;
}
$p = $c_Lcom_papasofokli_execution_PayrollTreeLoadData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PayrollTreeLoadData;
/** @constructor */
function $h_Lcom_papasofokli_execution_PayrollTreeLoadData() {
}
$h_Lcom_papasofokli_execution_PayrollTreeLoadData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 385779261, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_PayrollTreeLoadData) && (this.vY === x$0.vY)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "PayrollTreeLoadData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vY;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_PayrollTreeLoadData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ei)));
}
var $d_Lcom_papasofokli_execution_PayrollTreeLoadData = new $TypeData().i($c_Lcom_papasofokli_execution_PayrollTreeLoadData, "com.papasofokli.execution.PayrollTreeLoadData", ({
  ei: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150(WritersVersionSpecific_this$375, outer) {
  this.ZH = null;
  this.ZH = WritersVersionSpecific_this$375;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150;
/** @constructor */
function $h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150() {
}
$h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aAJ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectIdSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$2), v.rI);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromTime", $m_Lupickle_default$().ay, $bL(v.u1, v.u2));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toTime", $m_Lupickle_default$().ay, $bL(v.u3, v.u4));
    return ctx.L((-1));
  }
});
$p.aD9 = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectIdSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$2), v.rI);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromTime", $m_Lupickle_default$().ay, $bL(v.u1, v.u2));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toTime", $m_Lupickle_default$().ay, $bL(v.u3, v.u4));
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aAJ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aD9(ctx, v);
});
$p.T = (function() {
  return this.ZH;
});
var $d_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150 = new $TypeData().i($c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$150, "com.papasofokli.execution.PlanningGenerationEffectRange$$anon$150", ({
  oT: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PopoverHide(id) {
  this.vZ = null;
  this.vZ = id;
}
$p = $c_Lcom_papasofokli_execution_PopoverHide.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PopoverHide;
/** @constructor */
function $h_Lcom_papasofokli_execution_PopoverHide() {
}
$h_Lcom_papasofokli_execution_PopoverHide.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1459095119), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_PopoverHide)) {
    var x = this.vZ;
    var x$2 = x$0.vZ;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "PopoverHide";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.vZ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_PopoverHide(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ek)));
}
var $d_Lcom_papasofokli_execution_PopoverHide = new $TypeData().i($c_Lcom_papasofokli_execution_PopoverHide, "com.papasofokli.execution.PopoverHide", ({
  ek: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PrependElementWithId(id, html) {
  this.w1 = null;
  this.w0 = null;
  this.w1 = id;
  this.w0 = html;
}
$p = $c_Lcom_papasofokli_execution_PrependElementWithId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PrependElementWithId;
/** @constructor */
function $h_Lcom_papasofokli_execution_PrependElementWithId() {
}
$h_Lcom_papasofokli_execution_PrependElementWithId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 457634793, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_PrependElementWithId)) {
    var x = this.w1;
    var x$2 = x$0.w1;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.w0 === x$0.w0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "PrependElementWithId";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.w1;
  }
  if ((n === 1)) {
    return this.w0;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_PrependElementWithId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.el)));
}
var $d_Lcom_papasofokli_execution_PrependElementWithId = new $TypeData().i($c_Lcom_papasofokli_execution_PrependElementWithId, "com.papasofokli.execution.PrependElementWithId", ({
  el: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PrintReceiptBytes(pdfBytes, contentHeight, documentWidth, printerName, jobName, openCashbox) {
  this.rK = null;
  this.w2 = 0.0;
  this.w3 = 0.0;
  this.rL = null;
  this.rJ = null;
  this.w4 = false;
  this.rK = pdfBytes;
  this.w2 = contentHeight;
  this.w3 = documentWidth;
  this.rL = printerName;
  this.rJ = jobName;
  this.w4 = openCashbox;
}
$p = $c_Lcom_papasofokli_execution_PrintReceiptBytes.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_PrintReceiptBytes;
/** @constructor */
function $h_Lcom_papasofokli_execution_PrintReceiptBytes() {
}
$h_Lcom_papasofokli_execution_PrintReceiptBytes.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1511959616);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.w2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.w3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rJ));
  acc = $m_sr_Statics$().d(acc, (this.w4 ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 6);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_PrintReceiptBytes)) {
    if ((((this.w2 === x$0.w2) && (this.w3 === x$0.w3)) && (this.w4 === x$0.w4))) {
      var x = this.rK;
      var x$2 = x$0.rK;
      var $x_1 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.rL === x$0.rL))) {
      return (this.rJ === x$0.rJ);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "PrintReceiptBytes";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rK;
      break;
    }
    case 1: {
      return this.w2;
      break;
    }
    case 2: {
      return this.w3;
      break;
    }
    case 3: {
      return this.rL;
      break;
    }
    case 4: {
      return this.rJ;
      break;
    }
    case 5: {
      return this.w4;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_PrintReceiptBytes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.em)));
}
var $d_Lcom_papasofokli_execution_PrintReceiptBytes = new $TypeData().i($c_Lcom_papasofokli_execution_PrintReceiptBytes, "com.papasofokli.execution.PrintReceiptBytes", ({
  em: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_RedirectPageToHref(href) {
  this.w5 = null;
  this.w5 = href;
}
$p = $c_Lcom_papasofokli_execution_RedirectPageToHref.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_RedirectPageToHref;
/** @constructor */
function $h_Lcom_papasofokli_execution_RedirectPageToHref() {
}
$h_Lcom_papasofokli_execution_RedirectPageToHref.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1729723400, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_RedirectPageToHref) && (this.w5 === x$0.w5)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "RedirectPageToHref";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.w5;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_RedirectPageToHref(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.en)));
}
var $d_Lcom_papasofokli_execution_RedirectPageToHref = new $TypeData().i($c_Lcom_papasofokli_execution_RedirectPageToHref, "com.papasofokli.execution.RedirectPageToHref", ({
  en: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv(id) {
  this.w6 = null;
  this.w6 = id;
}
$p = $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReloadAgileBoardInDiv() {
}
$h_Lcom_papasofokli_execution_ReloadAgileBoardInDiv.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 765118577, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv)) {
    var x = this.w6;
    var x$2 = x$0.w6;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ReloadAgileBoardInDiv";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.w6;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReloadAgileBoardInDiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eo)));
}
var $d_Lcom_papasofokli_execution_ReloadAgileBoardInDiv = new $TypeData().i($c_Lcom_papasofokli_execution_ReloadAgileBoardInDiv, "com.papasofokli.execution.ReloadAgileBoardInDiv", ({
  eo: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv(id) {
  this.w7 = null;
  this.w7 = id;
}
$p = $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv() {
}
$h_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1517553883, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv)) {
    var x = this.w7;
    var x$2 = x$0.w7;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ReloadPlannerComponentInDiv";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.w7;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ep)));
}
var $d_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv = new $TypeData().i($c_Lcom_papasofokli_execution_ReloadPlannerComponentInDiv, "com.papasofokli.execution.ReloadPlannerComponentInDiv", ({
  ep: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReloadTable(uuid) {
  this.w8 = null;
  this.w8 = uuid;
}
$p = $c_Lcom_papasofokli_execution_ReloadTable.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReloadTable;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReloadTable() {
}
$h_Lcom_papasofokli_execution_ReloadTable.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 735979941, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ReloadTable)) {
    var x = this.w8;
    var x$2 = x$0.w8;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ReloadTable";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.w8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReloadTable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eq)));
}
var $d_Lcom_papasofokli_execution_ReloadTable = new $TypeData().i($c_Lcom_papasofokli_execution_ReloadTable, "com.papasofokli.execution.ReloadTable", ({
  eq: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_RemoveAttributeFromElement(id, attributeName, idSuffix) {
  this.wa = null;
  this.w9 = null;
  this.nn = null;
  this.wa = id;
  this.w9 = attributeName;
  this.nn = idSuffix;
}
$p = $c_Lcom_papasofokli_execution_RemoveAttributeFromElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_RemoveAttributeFromElement;
/** @constructor */
function $h_Lcom_papasofokli_execution_RemoveAttributeFromElement() {
}
$h_Lcom_papasofokli_execution_RemoveAttributeFromElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-644018484), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_RemoveAttributeFromElement)) {
    var x = this.wa;
    var x$2 = x$0.wa;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && (this.w9 === x$0.w9))) {
      return (this.nn === x$0.nn);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "RemoveAttributeFromElement";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.wa;
      break;
    }
    case 1: {
      return this.w9;
      break;
    }
    case 2: {
      return this.nn;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_RemoveAttributeFromElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.er)));
}
var $d_Lcom_papasofokli_execution_RemoveAttributeFromElement = new $TypeData().i($c_Lcom_papasofokli_execution_RemoveAttributeFromElement, "com.papasofokli.execution.RemoveAttributeFromElement", ({
  er: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_RemoveClassFromElement(elementId, className) {
  this.wc = null;
  this.wb = null;
  this.wc = elementId;
  this.wb = className;
}
$p = $c_Lcom_papasofokli_execution_RemoveClassFromElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_RemoveClassFromElement;
/** @constructor */
function $h_Lcom_papasofokli_execution_RemoveClassFromElement() {
}
$h_Lcom_papasofokli_execution_RemoveClassFromElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-862315657), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_RemoveClassFromElement)) {
    var x = this.wc;
    var x$2 = x$0.wc;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.wb === x$0.wb);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "RemoveClassFromElement";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wc;
  }
  if ((n === 1)) {
    return this.wb;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_RemoveClassFromElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.es)));
}
var $d_Lcom_papasofokli_execution_RemoveClassFromElement = new $TypeData().i($c_Lcom_papasofokli_execution_RemoveClassFromElement, "com.papasofokli.execution.RemoveClassFromElement", ({
  es: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_RemoveElementChildren(id) {
  this.wd = null;
  this.wd = id;
}
$p = $c_Lcom_papasofokli_execution_RemoveElementChildren.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_RemoveElementChildren;
/** @constructor */
function $h_Lcom_papasofokli_execution_RemoveElementChildren() {
}
$h_Lcom_papasofokli_execution_RemoveElementChildren.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-885960904), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_RemoveElementChildren)) {
    var x = this.wd;
    var x$2 = x$0.wd;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "RemoveElementChildren";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wd;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_RemoveElementChildren(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.et)));
}
var $d_Lcom_papasofokli_execution_RemoveElementChildren = new $TypeData().i($c_Lcom_papasofokli_execution_RemoveElementChildren, "com.papasofokli.execution.RemoveElementChildren", ({
  et: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReplaceAnchorContents(elementId, html) {
  this.we = null;
  this.wf = null;
  this.we = elementId;
  this.wf = html;
}
$p = $c_Lcom_papasofokli_execution_ReplaceAnchorContents.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReplaceAnchorContents;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReplaceAnchorContents() {
}
$h_Lcom_papasofokli_execution_ReplaceAnchorContents.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2066639534, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ReplaceAnchorContents) && ((this.we === x$0.we) && (this.wf === x$0.wf))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ReplaceAnchorContents";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.we;
  }
  if ((n === 1)) {
    return this.wf;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReplaceAnchorContents(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eu)));
}
var $d_Lcom_papasofokli_execution_ReplaceAnchorContents = new $TypeData().i($c_Lcom_papasofokli_execution_ReplaceAnchorContents, "com.papasofokli.execution.ReplaceAnchorContents", ({
  eu: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReplaceAnchorWithId(elementId, html) {
  this.wg = null;
  this.wh = null;
  this.wg = elementId;
  this.wh = html;
}
$p = $c_Lcom_papasofokli_execution_ReplaceAnchorWithId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReplaceAnchorWithId;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReplaceAnchorWithId() {
}
$h_Lcom_papasofokli_execution_ReplaceAnchorWithId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1616517031, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ReplaceAnchorWithId) && ((this.wg === x$0.wg) && (this.wh === x$0.wh))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ReplaceAnchorWithId";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wg;
  }
  if ((n === 1)) {
    return this.wh;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReplaceAnchorWithId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ev)));
}
var $d_Lcom_papasofokli_execution_ReplaceAnchorWithId = new $TypeData().i($c_Lcom_papasofokli_execution_ReplaceAnchorWithId, "com.papasofokli.execution.ReplaceAnchorWithId", ({
  ev: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith(cssClass, html) {
  this.wi = null;
  this.wj = null;
  this.wi = cssClass;
  this.wj = html;
}
$p = $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReplaceContentsByClassWith() {
}
$h_Lcom_papasofokli_execution_ReplaceContentsByClassWith.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 973562414, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ReplaceContentsByClassWith) && ((this.wi === x$0.wi) && (this.wj === x$0.wj))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ReplaceContentsByClassWith";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wi;
  }
  if ((n === 1)) {
    return this.wj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ReplaceContentsByClassWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ew)));
}
var $d_Lcom_papasofokli_execution_ReplaceContentsByClassWith = new $TypeData().i($c_Lcom_papasofokli_execution_ReplaceContentsByClassWith, "com.papasofokli.execution.ReplaceContentsByClassWith", ({
  ew: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReplaceElementContents(id, html, smooth) {
  this.rN = null;
  this.rM = null;
  this.rO = false;
  this.rN = id;
  this.rM = html;
  this.rO = smooth;
}
$p = $c_Lcom_papasofokli_execution_ReplaceElementContents.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReplaceElementContents;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReplaceElementContents() {
}
$h_Lcom_papasofokli_execution_ReplaceElementContents.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 2118161666);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rM));
  acc = $m_sr_Statics$().d(acc, (this.rO ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ReplaceElementContents)) {
    if ((this.rO === x$0.rO)) {
      var x = this.rN;
      var x$2 = x$0.rN;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.rM === x$0.rM);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "ReplaceElementContents";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rN;
      break;
    }
    case 1: {
      return this.rM;
      break;
    }
    case 2: {
      return this.rO;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_ReplaceElementContents(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ex)));
}
var $d_Lcom_papasofokli_execution_ReplaceElementContents = new $TypeData().i($c_Lcom_papasofokli_execution_ReplaceElementContents, "com.papasofokli.execution.ReplaceElementContents", ({
  ex: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ReplaceElementWithId(id, html, smooth) {
  this.rQ = null;
  this.rP = null;
  this.rR = false;
  this.rQ = id;
  this.rP = html;
  this.rR = smooth;
}
$p = $c_Lcom_papasofokli_execution_ReplaceElementWithId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ReplaceElementWithId;
/** @constructor */
function $h_Lcom_papasofokli_execution_ReplaceElementWithId() {
}
$h_Lcom_papasofokli_execution_ReplaceElementWithId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1334496151));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rP));
  acc = $m_sr_Statics$().d(acc, (this.rR ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ReplaceElementWithId)) {
    if ((this.rR === x$0.rR)) {
      var x = this.rQ;
      var x$2 = x$0.rQ;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.rP === x$0.rP);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "ReplaceElementWithId";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rQ;
      break;
    }
    case 1: {
      return this.rP;
      break;
    }
    case 2: {
      return this.rR;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_ReplaceElementWithId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ey)));
}
var $d_Lcom_papasofokli_execution_ReplaceElementWithId = new $TypeData().i($c_Lcom_papasofokli_execution_ReplaceElementWithId, "com.papasofokli.execution.ReplaceElementWithId", ({
  ey: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ResetPayrollTree(data) {
  this.wk = null;
  this.wk = data;
}
$p = $c_Lcom_papasofokli_execution_ResetPayrollTree.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ResetPayrollTree;
/** @constructor */
function $h_Lcom_papasofokli_execution_ResetPayrollTree() {
}
$h_Lcom_papasofokli_execution_ResetPayrollTree.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-448234885), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ResetPayrollTree) && (this.wk === x$0.wk)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ResetPayrollTree";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ResetPayrollTree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ez)));
}
var $d_Lcom_papasofokli_execution_ResetPayrollTree = new $TypeData().i($c_Lcom_papasofokli_execution_ResetPayrollTree, "com.papasofokli.execution.ResetPayrollTree", ({
  ez: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ResetScanner(videoId) {
  this.wl = null;
  this.wl = videoId;
}
$p = $c_Lcom_papasofokli_execution_ResetScanner.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ResetScanner;
/** @constructor */
function $h_Lcom_papasofokli_execution_ResetScanner() {
}
$h_Lcom_papasofokli_execution_ResetScanner.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1131451606, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ResetScanner) && (this.wl === x$0.wl)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ResetScanner";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wl;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ResetScanner(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eA)));
}
var $d_Lcom_papasofokli_execution_ResetScanner = new $TypeData().i($c_Lcom_papasofokli_execution_ResetScanner, "com.papasofokli.execution.ResetScanner", ({
  eA: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner(plannerId, sidebarSize) {
  this.rS = null;
  this.rT = 0;
  this.rS = plannerId;
  this.rT = sidebarSize;
}
$p = $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner;
/** @constructor */
function $h_Lcom_papasofokli_execution_ResizeSidebarForPlanner() {
}
$h_Lcom_papasofokli_execution_ResizeSidebarForPlanner.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 398067409);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rS));
  acc = $m_sr_Statics$().d(acc, this.rT);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ResizeSidebarForPlanner)) {
    if ((this.rT === x$0.rT)) {
      var x = this.rS;
      var x$2 = x$0.rS;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ResizeSidebarForPlanner";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.rS;
  }
  if ((n === 1)) {
    return this.rT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ResizeSidebarForPlanner(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eB)));
}
var $d_Lcom_papasofokli_execution_ResizeSidebarForPlanner = new $TypeData().i($c_Lcom_papasofokli_execution_ResizeSidebarForPlanner, "com.papasofokli.execution.ResizeSidebarForPlanner", ({
  eB: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ScrollToAnchorId(id, isModal) {
  this.rU = null;
  this.rV = false;
  this.rU = id;
  this.rV = isModal;
}
$p = $c_Lcom_papasofokli_execution_ScrollToAnchorId.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ScrollToAnchorId;
/** @constructor */
function $h_Lcom_papasofokli_execution_ScrollToAnchorId() {
}
$h_Lcom_papasofokli_execution_ScrollToAnchorId.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 753034520);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rU));
  acc = $m_sr_Statics$().d(acc, (this.rV ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ScrollToAnchorId) && ((this.rV === x$0.rV) && (this.rU === x$0.rU))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ScrollToAnchorId";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.rU;
  }
  if ((n === 1)) {
    return this.rV;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ScrollToAnchorId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eC)));
}
var $d_Lcom_papasofokli_execution_ScrollToAnchorId = new $TypeData().i($c_Lcom_papasofokli_execution_ScrollToAnchorId, "com.papasofokli.execution.ScrollToAnchorId", ({
  eC: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SelectInputDisable(id) {
  this.wm = null;
  this.wm = id;
}
$p = $c_Lcom_papasofokli_execution_SelectInputDisable.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SelectInputDisable;
/** @constructor */
function $h_Lcom_papasofokli_execution_SelectInputDisable() {
}
$h_Lcom_papasofokli_execution_SelectInputDisable.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2132227605, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SelectInputDisable)) {
    var x = this.wm;
    var x$2 = x$0.wm;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "SelectInputDisable";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wm;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_SelectInputDisable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eD)));
}
var $d_Lcom_papasofokli_execution_SelectInputDisable = new $TypeData().i($c_Lcom_papasofokli_execution_SelectInputDisable, "com.papasofokli.execution.SelectInputDisable", ({
  eD: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SelectInputEnable(id) {
  this.wn = null;
  this.wn = id;
}
$p = $c_Lcom_papasofokli_execution_SelectInputEnable.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SelectInputEnable;
/** @constructor */
function $h_Lcom_papasofokli_execution_SelectInputEnable() {
}
$h_Lcom_papasofokli_execution_SelectInputEnable.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 708681271, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SelectInputEnable)) {
    var x = this.wn;
    var x$2 = x$0.wn;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "SelectInputEnable";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wn;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_SelectInputEnable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eE)));
}
var $d_Lcom_papasofokli_execution_SelectInputEnable = new $TypeData().i($c_Lcom_papasofokli_execution_SelectInputEnable, "com.papasofokli.execution.SelectInputEnable", ({
  eE: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SetProgress(progressBarId, value, style) {
  this.rW = null;
  this.rY = 0.0;
  this.rX = null;
  this.rW = progressBarId;
  this.rY = value;
  this.rX = style;
}
$p = $c_Lcom_papasofokli_execution_SetProgress.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SetProgress;
/** @constructor */
function $h_Lcom_papasofokli_execution_SetProgress() {
}
$h_Lcom_papasofokli_execution_SetProgress.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1638856561));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.rY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rX));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SetProgress)) {
    if ((this.rY === x$0.rY)) {
      var x = this.rW;
      var x$2 = x$0.rW;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.rX;
      var x$4 = x$0.rX;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "SetProgress";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.rW;
      break;
    }
    case 1: {
      return this.rY;
      break;
    }
    case 2: {
      return this.rX;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_SetProgress(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eF)));
}
var $d_Lcom_papasofokli_execution_SetProgress = new $TypeData().i($c_Lcom_papasofokli_execution_SetProgress, "com.papasofokli.execution.SetProgress", ({
  eF: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SetRightDivSize(rightId, leftId, rightSize, rightCss) {
  this.s1 = null;
  this.rZ = null;
  this.s2 = 0;
  this.s0 = null;
  this.s1 = rightId;
  this.rZ = leftId;
  this.s2 = rightSize;
  this.s0 = rightCss;
}
$p = $c_Lcom_papasofokli_execution_SetRightDivSize.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SetRightDivSize;
/** @constructor */
function $h_Lcom_papasofokli_execution_SetRightDivSize() {
}
$h_Lcom_papasofokli_execution_SetRightDivSize.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 957606872);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.rZ));
  acc = $m_sr_Statics$().d(acc, this.s2);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s0));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SetRightDivSize)) {
    if ((this.s2 === x$0.s2)) {
      var x = this.s1;
      var x$2 = x$0.s1;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.rZ;
      var x$4 = x$0.rZ;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.s0 === x$0.s0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "SetRightDivSize";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.s1;
      break;
    }
    case 1: {
      return this.rZ;
      break;
    }
    case 2: {
      return this.s2;
      break;
    }
    case 3: {
      return this.s0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_SetRightDivSize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eG)));
}
var $d_Lcom_papasofokli_execution_SetRightDivSize = new $TypeData().i($c_Lcom_papasofokli_execution_SetRightDivSize, "com.papasofokli.execution.SetRightDivSize", ({
  eG: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ShowHideNavSidebar(alwaysHidden) {
  this.s3 = false;
  this.s3 = alwaysHidden;
}
$p = $c_Lcom_papasofokli_execution_ShowHideNavSidebar.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShowHideNavSidebar;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShowHideNavSidebar() {
}
$h_Lcom_papasofokli_execution_ShowHideNavSidebar.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1964675048));
  acc = $m_sr_Statics$().d(acc, (this.s3 ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_ShowHideNavSidebar) && (this.s3 === x$0.s3)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ShowHideNavSidebar";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.s3;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ShowHideNavSidebar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eH)));
}
var $d_Lcom_papasofokli_execution_ShowHideNavSidebar = new $TypeData().i($c_Lcom_papasofokli_execution_ShowHideNavSidebar, "com.papasofokli.execution.ShowHideNavSidebar", ({
  eH: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects(plannerId, rangeSeq) {
  this.wo = null;
  this.wp = null;
  this.wo = plannerId;
  this.wp = rangeSeq;
}
$p = $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShowPlanningGenerationEffects() {
}
$h_Lcom_papasofokli_execution_ShowPlanningGenerationEffects.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 245362926, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects)) {
    var x = this.wo;
    var x$2 = x$0.wo;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.wp;
      var x$4 = x$0.wp;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ShowPlanningGenerationEffects";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wo;
  }
  if ((n === 1)) {
    return this.wp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ShowPlanningGenerationEffects(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eI)));
}
var $d_Lcom_papasofokli_execution_ShowPlanningGenerationEffects = new $TypeData().i($c_Lcom_papasofokli_execution_ShowPlanningGenerationEffects, "com.papasofokli.execution.ShowPlanningGenerationEffects", ({
  eI: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges(plannerId, changeSeq) {
  this.wr = null;
  this.wq = null;
  this.wr = plannerId;
  this.wq = changeSeq;
}
$p = $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShowPlanningPeriodChanges() {
}
$h_Lcom_papasofokli_execution_ShowPlanningPeriodChanges.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2012644308, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges)) {
    var x = this.wr;
    var x$2 = x$0.wr;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.wq;
      var x$4 = x$0.wq;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ShowPlanningPeriodChanges";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wr;
  }
  if ((n === 1)) {
    return this.wq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ShowPlanningPeriodChanges(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eJ)));
}
var $d_Lcom_papasofokli_execution_ShowPlanningPeriodChanges = new $TypeData().i($c_Lcom_papasofokli_execution_ShowPlanningPeriodChanges, "com.papasofokli.execution.ShowPlanningPeriodChanges", ({
  eJ: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ShowSidebarForPlanner(plannerId) {
  this.ws = null;
  this.ws = plannerId;
}
$p = $c_Lcom_papasofokli_execution_ShowSidebarForPlanner.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShowSidebarForPlanner;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShowSidebarForPlanner() {
}
$h_Lcom_papasofokli_execution_ShowSidebarForPlanner.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 822417441, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ShowSidebarForPlanner)) {
    var x = this.ws;
    var x$2 = x$0.ws;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ShowSidebarForPlanner";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.ws;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ShowSidebarForPlanner(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eK)));
}
var $d_Lcom_papasofokli_execution_ShowSidebarForPlanner = new $TypeData().i($c_Lcom_papasofokli_execution_ShowSidebarForPlanner, "com.papasofokli.execution.ShowSidebarForPlanner", ({
  eK: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ShrinkModal(side1Id, side2Id, percentage, ratio) {
  this.s6 = null;
  this.s7 = null;
  this.s4 = 0.0;
  this.s5 = null;
  this.s6 = side1Id;
  this.s7 = side2Id;
  this.s4 = percentage;
  this.s5 = ratio;
}
$p = $c_Lcom_papasofokli_execution_ShrinkModal.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShrinkModal;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShrinkModal() {
}
$h_Lcom_papasofokli_execution_ShrinkModal.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1681536508));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.s4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s5));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ShrinkModal)) {
    if ((this.s4 === x$0.s4)) {
      var x = this.s6;
      var x$2 = x$0.s6;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.s7;
      var x$4 = x$0.s7;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.s5;
      var x$6 = x$0.s5;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "ShrinkModal";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.s6;
      break;
    }
    case 1: {
      return this.s7;
      break;
    }
    case 2: {
      return this.s4;
      break;
    }
    case 3: {
      return this.s5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_ShrinkModal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eL)));
}
var $d_Lcom_papasofokli_execution_ShrinkModal = new $TypeData().i($c_Lcom_papasofokli_execution_ShrinkModal, "com.papasofokli.execution.ShrinkModal", ({
  eL: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SignaturePadClear(id) {
  this.wt = null;
  this.wt = id;
}
$p = $c_Lcom_papasofokli_execution_SignaturePadClear.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SignaturePadClear;
/** @constructor */
function $h_Lcom_papasofokli_execution_SignaturePadClear() {
}
$h_Lcom_papasofokli_execution_SignaturePadClear.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 516755399, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SignaturePadClear)) {
    var x = this.wt;
    var x$2 = x$0.wt;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "SignaturePadClear";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wt;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_SignaturePadClear(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eM)));
}
var $d_Lcom_papasofokli_execution_SignaturePadClear = new $TypeData().i($c_Lcom_papasofokli_execution_SignaturePadClear, "com.papasofokli.execution.SignaturePadClear", ({
  eM: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_SignaturePadToDataURL(id) {
  this.wu = null;
  this.wu = id;
}
$p = $c_Lcom_papasofokli_execution_SignaturePadToDataURL.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_SignaturePadToDataURL;
/** @constructor */
function $h_Lcom_papasofokli_execution_SignaturePadToDataURL() {
}
$h_Lcom_papasofokli_execution_SignaturePadToDataURL.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 752131544, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_SignaturePadToDataURL)) {
    var x = this.wu;
    var x$2 = x$0.wu;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "SignaturePadToDataURL";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wu;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_SignaturePadToDataURL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eN)));
}
var $d_Lcom_papasofokli_execution_SignaturePadToDataURL = new $TypeData().i($c_Lcom_papasofokli_execution_SignaturePadToDataURL, "com.papasofokli.execution.SignaturePadToDataURL", ({
  eN: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_TableGroupColumn(tableId, index) {
  this.s9 = null;
  this.s8 = 0;
  this.s9 = tableId;
  this.s8 = index;
}
$p = $c_Lcom_papasofokli_execution_TableGroupColumn.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_TableGroupColumn;
/** @constructor */
function $h_Lcom_papasofokli_execution_TableGroupColumn() {
}
$h_Lcom_papasofokli_execution_TableGroupColumn.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1537638873));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.s9));
  acc = $m_sr_Statics$().d(acc, this.s8);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_TableGroupColumn) && ((this.s8 === x$0.s8) && (this.s9 === x$0.s9))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "TableGroupColumn";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.s9;
  }
  if ((n === 1)) {
    return this.s8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_TableGroupColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eO)));
}
var $d_Lcom_papasofokli_execution_TableGroupColumn = new $TypeData().i($c_Lcom_papasofokli_execution_TableGroupColumn, "com.papasofokli.execution.TableGroupColumn", ({
  eO: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_TableSortColumn(tableId, index, sortDirection) {
  this.sc = null;
  this.sa = 0;
  this.sb = null;
  this.sc = tableId;
  this.sa = index;
  this.sb = sortDirection;
}
$p = $c_Lcom_papasofokli_execution_TableSortColumn.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_TableSortColumn;
/** @constructor */
function $h_Lcom_papasofokli_execution_TableSortColumn() {
}
$h_Lcom_papasofokli_execution_TableSortColumn.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1927975710));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sc));
  acc = $m_sr_Statics$().d(acc, this.sa);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sb));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_TableSortColumn) && (((this.sa === x$0.sa) && (this.sc === x$0.sc)) && (this.sb === x$0.sb))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "TableSortColumn";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sc;
      break;
    }
    case 1: {
      return this.sa;
      break;
    }
    case 2: {
      return this.sb;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_TableSortColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eP)));
}
var $d_Lcom_papasofokli_execution_TableSortColumn = new $TypeData().i($c_Lcom_papasofokli_execution_TableSortColumn, "com.papasofokli.execution.TableSortColumn", ({
  eP: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ToggleClassFromElement(elementId, className) {
  this.ww = null;
  this.wv = null;
  this.ww = elementId;
  this.wv = className;
}
$p = $c_Lcom_papasofokli_execution_ToggleClassFromElement.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ToggleClassFromElement;
/** @constructor */
function $h_Lcom_papasofokli_execution_ToggleClassFromElement() {
}
$h_Lcom_papasofokli_execution_ToggleClassFromElement.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1415711274, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ToggleClassFromElement)) {
    var x = this.ww;
    var x$2 = x$0.ww;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      return (this.wv === x$0.wv);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ToggleClassFromElement";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.ww;
  }
  if ((n === 1)) {
    return this.wv;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ToggleClassFromElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eQ)));
}
var $d_Lcom_papasofokli_execution_ToggleClassFromElement = new $TypeData().i($c_Lcom_papasofokli_execution_ToggleClassFromElement, "com.papasofokli.execution.ToggleClassFromElement", ({
  eQ: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ToggleNotificationDropdown(id) {
  this.wx = null;
  this.wx = id;
}
$p = $c_Lcom_papasofokli_execution_ToggleNotificationDropdown.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ToggleNotificationDropdown;
/** @constructor */
function $h_Lcom_papasofokli_execution_ToggleNotificationDropdown() {
}
$h_Lcom_papasofokli_execution_ToggleNotificationDropdown.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1298742006), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_ToggleNotificationDropdown)) {
    var x = this.wx;
    var x$2 = x$0.wx;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ToggleNotificationDropdown";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wx;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_ToggleNotificationDropdown(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eR)));
}
var $d_Lcom_papasofokli_execution_ToggleNotificationDropdown = new $TypeData().i($c_Lcom_papasofokli_execution_ToggleNotificationDropdown, "com.papasofokli.execution.ToggleNotificationDropdown", ({
  eR: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod(plannerId) {
  this.wy = null;
  this.wy = plannerId;
}
$p = $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod;
/** @constructor */
function $h_Lcom_papasofokli_execution_UndoHighlightTimePeriod() {
}
$h_Lcom_papasofokli_execution_UndoHighlightTimePeriod.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1484819382), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_execution_UndoHighlightTimePeriod) && (this.wy === x$0.wy)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "UndoHighlightTimePeriod";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.wy;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_UndoHighlightTimePeriod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eS)));
}
var $d_Lcom_papasofokli_execution_UndoHighlightTimePeriod = new $TypeData().i($c_Lcom_papasofokli_execution_UndoHighlightTimePeriod, "com.papasofokli.execution.UndoHighlightTimePeriod", ({
  eS: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column(agileBoard2Id, column, columnContent) {
  this.sd = null;
  this.se = 0;
  this.sf = null;
  this.sd = agileBoard2Id;
  this.se = column;
  this.sf = columnContent;
}
$p = $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column;
/** @constructor */
function $h_Lcom_papasofokli_execution_UpdateAgileBoard2Column() {
}
$h_Lcom_papasofokli_execution_UpdateAgileBoard2Column.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-373994891));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sd));
  acc = $m_sr_Statics$().d(acc, this.se);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sf));
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_UpdateAgileBoard2Column)) {
    if (((this.se === x$0.se) && (this.sd === x$0.sd))) {
      var x = this.sf;
      var x$2 = x$0.sf;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "UpdateAgileBoard2Column";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sd;
      break;
    }
    case 1: {
      return this.se;
      break;
    }
    case 2: {
      return this.sf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_UpdateAgileBoard2Column(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eT)));
}
var $d_Lcom_papasofokli_execution_UpdateAgileBoard2Column = new $TypeData().i($c_Lcom_papasofokli_execution_UpdateAgileBoard2Column, "com.papasofokli.execution.UpdateAgileBoard2Column", ({
  eT: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_UpdateIconNotification(number, id) {
  this.sh = 0;
  this.sg = null;
  this.sh = number;
  this.sg = id;
}
$p = $c_Lcom_papasofokli_execution_UpdateIconNotification.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_UpdateIconNotification;
/** @constructor */
function $h_Lcom_papasofokli_execution_UpdateIconNotification() {
}
$h_Lcom_papasofokli_execution_UpdateIconNotification.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 644326157);
  acc = $m_sr_Statics$().d(acc, this.sh);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sg));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_UpdateIconNotification)) {
    if ((this.sh === x$0.sh)) {
      var x = this.sg;
      var x$2 = x$0.sg;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "UpdateIconNotification";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.sh;
  }
  if ((n === 1)) {
    return this.sg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_execution_UpdateIconNotification(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eU)));
}
var $d_Lcom_papasofokli_execution_UpdateIconNotification = new $TypeData().i($c_Lcom_papasofokli_execution_UpdateIconNotification, "com.papasofokli.execution.UpdateIconNotification", ({
  eU: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_UpdateValidation(formGroupId, helpId, status, helpText) {
  this.wz = null;
  this.wA = null;
  this.wC = null;
  this.wB = null;
  this.wz = formGroupId;
  this.wA = helpId;
  this.wC = status;
  this.wB = helpText;
}
$p = $c_Lcom_papasofokli_execution_UpdateValidation.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_UpdateValidation;
/** @constructor */
function $h_Lcom_papasofokli_execution_UpdateValidation() {
}
$h_Lcom_papasofokli_execution_UpdateValidation.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2113318291, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_execution_UpdateValidation)) {
    var x = this.wz;
    var x$2 = x$0.wz;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.wA;
      var x$4 = x$0.wA;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wC;
      var x$6 = x$0.wC;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.wB === x$0.wB);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "UpdateValidation";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.wz;
      break;
    }
    case 1: {
      return this.wA;
      break;
    }
    case 2: {
      return this.wC;
      break;
    }
    case 3: {
      return this.wB;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_execution_UpdateValidation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eV)));
}
var $d_Lcom_papasofokli_execution_UpdateValidation = new $TypeData().i($c_Lcom_papasofokli_execution_UpdateValidation, "com.papasofokli.execution.UpdateValidation", ({
  eV: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8(WritersVersionSpecific_this$26, outer) {
  this.a0g = null;
  this.a0g = WritersVersionSpecific_this$26;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8() {
}
$h_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBm = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $m_Lcom_papasofokli_jstree_TreeItemData$().q(), v.AC);
    return ctx.L((-1));
  }
});
$p.aDM = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $m_Lcom_papasofokli_jstree_TreeItemData$().q(), v.AC);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBm(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDM(ctx, v);
});
$p.T = (function() {
  return this.a0g;
});
var $d_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$8, "com.papasofokli.jstree.ContextMenuRequest$$anon$8", ({
  pf: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_InfoItem$$anon$10(WritersVersionSpecific_this$27, outer) {
  this.a0j = null;
  this.a0j = WritersVersionSpecific_this$27;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_InfoItem$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_InfoItem$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_jstree_InfoItem$$anon$10() {
}
$h_Lcom_papasofokli_jstree_InfoItem$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ait = (function(v) {
  var x = v.lw;
  var x$2 = $m_s_None$();
  var $x_4 = ((x !== null) && x.b(x$2));
  var x$3 = v.lu;
  var x$4 = $m_sci_Nil$();
  var $x_3 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.lt;
  var x$6 = $m_s_Option$().Z("scala-tree-icon");
  var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
  var x$7 = v.lv;
  var x$8 = $m_s_None$();
  var $x_1 = ((x$7 !== null) && x$7.b(x$8));
  var x$9 = v.pd;
  var x$10 = $m_s_None$();
  return ((((((!$x_4) | 0) + ((!$x_3) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$9 !== null) && x$9.b(x$10))) | 0)) | 0)) | 0)) | 0);
});
$p.aBn = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.ait(v), true, (-1));
    var x = v.lw;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lw);
    }
    var x$3 = v.lu;
    var x$4 = $m_sci_Nil$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      var this$11 = $m_Lupickle_default$();
      $m_Lupickle_default$();
      $m_Lcom_papasofokli_util_IconUI$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icons", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), this$11), v.lu);
    }
    var x$5 = v.lt;
    var x$6 = $m_s_Option$().Z("scala-tree-icon");
    if ((!((x$5 === null) ? (x$6 === null) : x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "iconCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lt);
    }
    var x$7 = v.lv;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.b(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lv);
    }
    var x$9 = v.pd;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickEventId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.pd);
    }
    return ctx.L((-1));
  }
});
$p.aDN = (function(ctx, v) {
  var x = v.lw;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lw);
  }
  var x$3 = v.lu;
  var x$4 = $m_sci_Nil$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    var this$11 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icons", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), this$11), v.lu);
  }
  var x$5 = v.lt;
  var x$6 = $m_s_Option$().Z("scala-tree-icon");
  if ((!((x$5 === null) ? (x$6 === null) : x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "iconCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lt);
  }
  var x$7 = v.lv;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.b(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lv);
  }
  var x$9 = v.pd;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickEventId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.pd);
  }
});
$p.ah = (function(v) {
  return this.ait(v);
});
$p.U = (function(out, v) {
  return this.aBn(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDN(ctx, v);
});
$p.T = (function() {
  return this.a0j;
});
var $d_Lcom_papasofokli_jstree_InfoItem$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_jstree_InfoItem$$anon$10, "com.papasofokli.jstree.InfoItem$$anon$10", ({
  ph: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6(WritersVersionSpecific_this$25, outer) {
  this.a0m = null;
  this.a0m = WritersVersionSpecific_this$25;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6() {
}
$h_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBo = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.AE);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.AD);
    return ctx.L((-1));
  }
});
$p.aDO = (function(ctx, v) {
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.AE);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.AD);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBo(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDO(ctx, v);
});
$p.T = (function() {
  return this.a0m;
});
var $d_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$6, "com.papasofokli.jstree.LeafClickRequest$$anon$6", ({
  pl: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4(WritersVersionSpecific_this$24, outer) {
  this.a0p = null;
  this.a0p = WritersVersionSpecific_this$24;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4() {
}
$h_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBp = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.AG);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.AF);
    return ctx.L((-1));
  }
});
$p.aDP = (function(ctx, v) {
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "node", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.AG);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickType", $m_Lupickle_default$().m, v.AF);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBp(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDP(ctx, v);
});
$p.T = (function() {
  return this.a0p;
});
var $d_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$4, "com.papasofokli.jstree.NodeClickRequest$$anon$4", ({
  po: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeItemData$$anon$13(WritersVersionSpecific_this$28, outer) {
  this.a0t = null;
  this.a0t = WritersVersionSpecific_this$28;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeItemData$$anon$13() {
}
$h_Lcom_papasofokli_jstree_TreeItemData$$anon$13.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiu = (function(v) {
  var $x_2 = $m_sr_BoxesRunTime$().B(v.jZ, false);
  var x$1 = v.jY;
  var x$2 = $m_s_None$();
  var $x_1 = ((x$1 !== null) && x$1.b(x$2));
  var x$3 = v.i2;
  var x$4 = $m_ju_UUID$().aW();
  return ((((2 + ((!$x_2) | 0)) | 0) + ((2 + ((((!$x_1) | 0) + ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4))) | 0)) | 0)) | 0)) | 0);
});
$p.aBq = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiu(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "parentNodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.pe);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.or, v.os));
    if ((!$m_sr_BoxesRunTime$().B(v.jZ, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selected", $m_Lupickle_default$().aw, v.jZ);
    }
    var this$7 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_InfoItem$().q(), this$7), v.no);
    var this$9 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "widthPercentages", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$9), v.np);
    var x$1 = v.jY;
    var x$2 = $m_s_None$();
    if ((!((x$1 !== null) && x$1.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalNodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.jY);
    }
    var x$3 = v.i2;
    var x$4 = $m_ju_UUID$().aW();
    if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.i2);
    }
    return ctx.L((-1));
  }
});
$p.aDQ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "parentNodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.pe);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.or, v.os));
  if ((!$m_sr_BoxesRunTime$().B(v.jZ, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selected", $m_Lupickle_default$().aw, v.jZ);
  }
  var this$7 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_InfoItem$().q(), this$7), v.no);
  var this$9 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "widthPercentages", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$9), v.np);
  var x$1 = v.jY;
  var x$2 = $m_s_None$();
  if ((!((x$1 !== null) && x$1.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "additionalNodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.jY);
  }
  var x$3 = v.i2;
  var x$4 = $m_ju_UUID$().aW();
  if ((!((x$3 === null) ? (x$4 === null) : x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.i2);
  }
});
$p.ah = (function(v) {
  return this.aiu(v);
});
$p.U = (function(out, v) {
  return this.aBq(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDQ(ctx, v);
});
$p.T = (function() {
  return this.a0t;
});
var $d_Lcom_papasofokli_jstree_TreeItemData$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeItemData$$anon$13, "com.papasofokli.jstree.TreeItemData$$anon$13", ({
  ps: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeItemData$$anon$14(WritersVersionSpecific_this$29, x0$lzy2$7, x1$lzy2$9, WritersVersionSpecific_this$30, outer) {
  this.a0u = null;
  this.OG = null;
  this.EV = null;
  this.EU = null;
  this.a0u = WritersVersionSpecific_this$29;
  this.OG = x0$lzy2$7;
  this.EV = x1$lzy2$9;
  this.EU = WritersVersionSpecific_this$30;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeItemData$$anon$14() {
}
$h_Lcom_papasofokli_jstree_TreeItemData$$anon$14.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiv = (function(v) {
  var $x_4 = $m_sr_BoxesRunTime$().B(v.ly, false);
  var $x_3 = $m_sr_BoxesRunTime$().B(v.k1, false);
  var x$2 = v.lB;
  var x$2$1 = $m_s_None$();
  var $x_2 = ((x$2 !== null) && x$2.b(x$2$1));
  var x$3 = v.lz;
  var x$4 = $m_s_None$();
  var $x_1 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.lA;
  var x$6 = $m_s_None$();
  return ((((4 + ((!$x_4) | 0)) | 0) + ((((2 + ((!$x_3) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$5 !== null) && x$5.b(x$6))) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aBr = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiv(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.u5, v.u6));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.gE, v.gF));
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "childNodeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_TreeItemData$().TO(this.OG, this.EU, this.EV), this$4), v.k0);
    var this$6 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "childLeafSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_TreeItemData$().TP(this.EV, this.EU), this$6), v.lx);
    if ((!$m_sr_BoxesRunTime$().B(v.ly, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expanded", $m_Lupickle_default$().aw, v.ly);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.k1, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selected", $m_Lupickle_default$().aw, v.k1);
    }
    var this$12 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_InfoItem$().q(), this$12), v.nq);
    var this$14 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "widthPercentages", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$14), v.lC);
    var x$2 = v.lB;
    var x$2$1 = $m_s_None$();
    if ((!((x$2 !== null) && x$2.b(x$2$1)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "treeNodeType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lB);
    }
    var x$3 = v.lz;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "parentRecordId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.lz);
    }
    var x$5 = v.lA;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.lA);
    }
    return ctx.L((-1));
  }
});
$p.aDR = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.u5, v.u6));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.gE, v.gF));
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "childNodeSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_TreeItemData$().TO(this.OG, this.EU, this.EV), this$4), v.k0);
  var this$6 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "childLeafSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_TreeItemData$().TP(this.EV, this.EU), this$6), v.lx);
  if ((!$m_sr_BoxesRunTime$().B(v.ly, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expanded", $m_Lupickle_default$().aw, v.ly);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.k1, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selected", $m_Lupickle_default$().aw, v.k1);
  }
  var this$12 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "infoItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_jstree_InfoItem$().q(), this$12), v.nq);
  var this$14 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "widthPercentages", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$14), v.lC);
  var x$2 = v.lB;
  var x$2$1 = $m_s_None$();
  if ((!((x$2 !== null) && x$2.b(x$2$1)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "treeNodeType", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lB);
  }
  var x$3 = v.lz;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "parentRecordId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.lz);
  }
  var x$5 = v.lA;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sortOrder", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.lA);
  }
});
$p.ah = (function(v) {
  return this.aiv(v);
});
$p.U = (function(out, v) {
  return this.aBr(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDR(ctx, v);
});
$p.T = (function() {
  return this.a0u;
});
var $d_Lcom_papasofokli_jstree_TreeItemData$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeItemData$$anon$14, "com.papasofokli.jstree.TreeItemData$$anon$14", ({
  pt: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeLeafData(parentNodeId, recordId_$_lo, recordId_$_hi, selected, infoItems, widthPercentages, additionalNodeId, id) {
  this.pe = null;
  this.or = 0;
  this.os = 0;
  this.jZ = false;
  this.no = null;
  this.np = null;
  this.jY = null;
  this.i2 = null;
  this.pe = parentNodeId;
  this.or = recordId_$_lo;
  this.os = recordId_$_hi;
  this.jZ = selected;
  this.no = infoItems;
  this.np = widthPercentages;
  this.jY = additionalNodeId;
  this.i2 = id;
}
$p = $c_Lcom_papasofokli_jstree_TreeLeafData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeLeafData;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeLeafData() {
}
$h_Lcom_papasofokli_jstree_TreeLeafData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 353227270);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pe));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.or, this.os));
  acc = $m_sr_Statics$().d(acc, (this.jZ ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.no));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.np));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.i2));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_TreeLeafData)) {
    var x_$_lo = this.or;
    var x_$_hi = this.os;
    var $x_5 = x$0;
    var x$1_$_lo = $x_5.or;
    var x$1_$_hi = $x_5.os;
    if (((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.jZ === x$0.jZ))) {
      var x$2 = this.pe;
      var x$2$1 = x$0.pe;
      var $x_4 = ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.no;
      var x$4 = x$0.no;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.np;
      var x$6 = x$0.np;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.jY;
      var x$8 = x$0.jY;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.i2;
      var x$10 = x$0.i2;
      return ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "TreeLeafData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pe;
      break;
    }
    case 1: {
      return $bL(this.or, this.os);
      break;
    }
    case 2: {
      return this.jZ;
      break;
    }
    case 3: {
      return this.no;
      break;
    }
    case 4: {
      return this.np;
      break;
    }
    case 5: {
      return this.jY;
      break;
    }
    case 6: {
      return this.i2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_jstree_TreeLeafData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f0)));
}
var $d_Lcom_papasofokli_jstree_TreeLeafData = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeLeafData, "com.papasofokli.jstree.TreeLeafData", ({
  f0: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeNodeData(id_$_lo, id_$_hi, recordId_$_lo, recordId_$_hi, childNodeSeq, childLeafSeq, expanded, selected, infoItems, widthPercentages, treeNodeType, parentRecordId, sortOrder) {
  this.u5 = 0;
  this.u6 = 0;
  this.gE = 0;
  this.gF = 0;
  this.k0 = null;
  this.lx = null;
  this.ly = false;
  this.k1 = false;
  this.nq = null;
  this.lC = null;
  this.lB = null;
  this.lz = null;
  this.lA = null;
  this.u5 = id_$_lo;
  this.u6 = id_$_hi;
  this.gE = recordId_$_lo;
  this.gF = recordId_$_hi;
  this.k0 = childNodeSeq;
  this.lx = childLeafSeq;
  this.ly = expanded;
  this.k1 = selected;
  this.nq = infoItems;
  this.lC = widthPercentages;
  this.lB = treeNodeType;
  this.lz = parentRecordId;
  this.lA = sortOrder;
}
$p = $c_Lcom_papasofokli_jstree_TreeNodeData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeNodeData;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeNodeData() {
}
$h_Lcom_papasofokli_jstree_TreeNodeData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-86053206));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.u5, this.u6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.gE, this.gF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.k0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lx));
  acc = $m_sr_Statics$().d(acc, (this.ly ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.k1 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nq));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lB));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lA));
  return $m_sr_Statics$().an(acc, 11);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_jstree_TreeNodeData)) {
    var x_$_lo = this.u5;
    var x_$_hi = this.u6;
    var $x_8 = x$0;
    var x$1_$_lo = $x_8.u5;
    var x$1_$_hi = $x_8.u6;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.gE;
      var x$2_$_hi = this.gF;
      var $x_9 = x$0;
      var x$3_$_lo = $x_9.gE;
      var x$3_$_hi = $x_9.gF;
      var $x_7 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_7 = false;
    }
    if ((($x_7 && (this.ly === x$0.ly)) && (this.k1 === x$0.k1))) {
      var x$4 = this.k0;
      var x$2$1 = x$0.k0;
      var $x_6 = ((x$4 === null) ? (x$2$1 === null) : x$4.b(x$2$1));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3$1 = this.lx;
      var x$4$1 = x$0.lx;
      var $x_5 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.b(x$4$1));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.nq;
      var x$6 = x$0.nq;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.lC;
      var x$8 = x$0.lC;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.lB;
      var x$10 = x$0.lB;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.lz;
      var x$12 = x$0.lz;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.lA;
      var x$14 = x$0.lA;
      return ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 11;
});
$p.A = (function() {
  return "TreeNodeData";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return $bL(this.u5, this.u6);
      break;
    }
    case 1: {
      return $bL(this.gE, this.gF);
      break;
    }
    case 2: {
      return this.k0;
      break;
    }
    case 3: {
      return this.lx;
      break;
    }
    case 4: {
      return this.ly;
      break;
    }
    case 5: {
      return this.k1;
      break;
    }
    case 6: {
      return this.nq;
      break;
    }
    case 7: {
      return this.lC;
      break;
    }
    case 8: {
      return this.lB;
      break;
    }
    case 9: {
      return this.lz;
      break;
    }
    case 10: {
      return this.lA;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lcom_papasofokli_jstree_TreeNodeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f1)));
}
var $d_Lcom_papasofokli_jstree_TreeNodeData = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeNodeData, "com.papasofokli.jstree.TreeNodeData", ({
  f1: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2(WritersVersionSpecific_this$23, outer) {
  this.a0x = null;
  this.a0x = WritersVersionSpecific_this$23;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2() {
}
$h_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBs = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    var this$5 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), this$5), v.pg);
    var this$10 = $m_Lupickle_default$();
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leaves", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$1) => _$1$2$1))), this$10), v.pf);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expandOnDoubleClick", $m_Lupickle_default$().aw, v.si);
    return ctx.L((-1));
  }
});
$p.aDS = (function(ctx, v) {
  var this$5 = $m_Lupickle_default$();
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodes", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), this$5), v.pg);
  var this$10 = $m_Lupickle_default$();
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leaves", new $c_Lupickle_implicits_LowPriWriters$$anon$22($f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_jstree_TreeItemData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2$1) => _$1$2$1))), this$10), v.pf);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "expandOnDoubleClick", $m_Lupickle_default$().aw, v.si);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBs(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDS(ctx, v);
});
$p.T = (function() {
  return this.a0x;
});
var $d_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$2, "com.papasofokli.jstree.TreeNodeListSetupData$$anon$2", ({
  pw: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_pagination_PaginationJs$$anon$1(element$4, freezePage$4) {
  this.a0I = null;
  this.a0J = null;
  this.a0I = element$4;
  this.a0J = freezePage$4;
}
$p = $c_Lcom_papasofokli_pagination_PaginationJs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_pagination_PaginationJs$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_pagination_PaginationJs$$anon$1() {
}
$h_Lcom_papasofokli_pagination_PaginationJs$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
  this.a0I.classList.remove($m_Lcom_papasofokli_pagination_PaginationHelper$().wE);
  this.a0J.ep();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_pagination_PaginationJs$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_pagination_PaginationJs$$anon$1, "com.papasofokli.pagination.PaginationJs$$anon$1", ({
  pB: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_AppliedToC$$anon$42(WritersVersionSpecific_this$80, outer) {
  this.a0M = null;
  this.a0M = WritersVersionSpecific_this$80;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_AppliedToC$$anon$42.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_AppliedToC$$anon$42;
/** @constructor */
function $h_Lcom_papasofokli_planning_AppliedToC$$anon$42() {
}
$h_Lcom_papasofokli_planning_AppliedToC$$anon$42.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBt = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.AH);
    return ctx.L((-1));
  }
});
$p.aDT = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.AH);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBt(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDT(ctx, v);
});
$p.T = (function() {
  return this.a0M;
});
var $d_Lcom_papasofokli_planning_AppliedToC$$anon$42 = new $TypeData().i($c_Lcom_papasofokli_planning_AppliedToC$$anon$42, "com.papasofokli.planning.AppliedToC$$anon$42", ({
  pE: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14(WritersVersionSpecific_this$66, outer) {
  this.a0P = null;
  this.a0P = WritersVersionSpecific_this$66;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14() {
}
$h_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiw = (function(v) {
  return ((1 + ((!$m_sr_BoxesRunTime$().B(v.k2, true)) | 0)) | 0);
});
$p.aBu = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiw(v), true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodDetails", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$2), v.k3);
    if ((!$m_sr_BoxesRunTime$().B(v.k2, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hideIfEmpty", $m_Lupickle_default$().aw, v.k2);
    }
    return ctx.L((-1));
  }
});
$p.aDU = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodDetails", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$2), v.k3);
  if ((!$m_sr_BoxesRunTime$().B(v.k2, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "hideIfEmpty", $m_Lupickle_default$().aw, v.k2);
  }
});
$p.ah = (function(v) {
  return this.aiw(v);
});
$p.U = (function(out, v) {
  return this.aBu(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDU(ctx, v);
});
$p.T = (function() {
  return this.a0P;
});
var $d_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$14, "com.papasofokli.planning.DetailedPlanningRow$$anon$14", ({
  pH: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionData$$anon$27(WritersVersionSpecific_this$72, outer) {
  this.a0S = null;
  this.a0S = WritersVersionSpecific_this$72;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_DivisionData$$anon$27.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionData$$anon$27;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionData$$anon$27() {
}
$h_Lcom_papasofokli_planning_DivisionData$$anon$27.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBw = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.za, v.zb));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeId", $m_Lupickle_default$().ay, $bL(v.u7, v.u8));
    return ctx.L((-1));
  }
});
$p.aDW = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.za, v.zb));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeId", $m_Lupickle_default$().ay, $bL(v.u7, v.u8));
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBw(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDW(ctx, v);
});
$p.T = (function() {
  return this.a0S;
});
var $d_Lcom_papasofokli_planning_DivisionData$$anon$27 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionData$$anon$27, "com.papasofokli.planning.DivisionData$$anon$27", ({
  pL: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionData$$anon$28(WritersVersionSpecific_this$73, outer) {
  this.a0T = null;
  this.a0T = WritersVersionSpecific_this$73;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_DivisionData$$anon$28.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionData$$anon$28;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionData$$anon$28() {
}
$h_Lcom_papasofokli_planning_DivisionData$$anon$28.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBy = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.qu, v.qv));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.pk);
    return ctx.L((-1));
  }
});
$p.aDY = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.qu, v.qv));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.pk);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBy(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDY(ctx, v);
});
$p.T = (function() {
  return this.a0T;
});
var $d_Lcom_papasofokli_planning_DivisionData$$anon$28 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionData$$anon$28, "com.papasofokli.planning.DivisionData$$anon$28", ({
  pM: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10(WritersVersionSpecific_this$63, x2$lzy2$7, WritersVersionSpecific_this$64, x0$lzy2$7, x1$lzy2$9, outer) {
  this.a0Y = null;
  this.OT = null;
  this.OQ = null;
  this.OR = null;
  this.OS = null;
  this.a0Y = WritersVersionSpecific_this$63;
  this.OT = x2$lzy2$7;
  this.OQ = WritersVersionSpecific_this$64;
  this.OR = x0$lzy2$7;
  this.OS = x1$lzy2$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10() {
}
$h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiy = (function(v) {
  var x = v.iI;
  var x$2 = $m_sci_Nil$();
  return ((3 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aBz = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiy(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionName", $m_Lupickle_default$().m, v.nt);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "departmentDataJS", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DivisionsDataJSI$().TQ(this.OT, this.OQ, this.OR, this.OS), this$3), v.wH);
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wI);
    var x = v.iI;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.b(x$2)))) {
      var this$11 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselSchedules", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), this$11), v.iI);
    }
    return ctx.L((-1));
  }
});
$p.aDZ = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionName", $m_Lupickle_default$().m, v.nt);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "departmentDataJS", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DivisionsDataJSI$().TQ(this.OT, this.OQ, this.OR, this.OS), this$3), v.wH);
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "nodeData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wI);
  var x = v.iI;
  var x$2 = $m_sci_Nil$();
  if ((!((x !== null) && x.b(x$2)))) {
    var this$11 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselSchedules", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), this$11), v.iI);
  }
});
$p.ah = (function(v) {
  return this.aiy(v);
});
$p.U = (function(out, v) {
  return this.aBz(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDZ(ctx, v);
});
$p.T = (function() {
  return this.a0Y;
});
var $d_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$10, "com.papasofokli.planning.DivisionsDataJSI$$anon$10", ({
  pP: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9(WritersVersionSpecific_this$62, outer) {
  this.a13 = null;
  this.a13 = WritersVersionSpecific_this$62;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9() {
}
$h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aix = (function(v) {
  var $x_2 = v.lF;
  var x = v.pj;
  var x$2 = $m_Lcom_papasofokli_planning_PeriodStyleE$().EX;
  var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
  var x$3 = v.ns;
  var x$4 = $m_s_None$();
  return ((((2 + (($x_2 !== "") | 0)) | 0) + ((1 + ((((!$x_1) | 0) + ((!((x$3 !== null) && x$3.b(x$4))) | 0)) | 0)) | 0)) | 0);
});
$p.aBx = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aix(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionName", $m_Lupickle_default$().m, v.ph);
    if ((v.lF !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipText", $m_Lupickle_default$().m, v.lF);
    }
    var this$5 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "seq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_SubjectPlanningData$().q(), this$5), v.pi);
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wG);
    var x = v.pj;
    var x$2 = $m_Lcom_papasofokli_planning_PeriodStyleE$().EX;
    if ((!((x === null) ? (x$2 === null) : x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $m_Lcom_papasofokli_planning_PeriodStyle$().q(), v.pj);
    }
    var x$3 = v.ns;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q()), v.ns);
    }
    return ctx.L((-1));
  }
});
$p.aDX = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionName", $m_Lupickle_default$().m, v.ph);
  if ((v.lF !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipText", $m_Lupickle_default$().m, v.lF);
  }
  var this$5 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "seq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_SubjectPlanningData$().q(), this$5), v.pi);
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wG);
  var x = v.pj;
  var x$2 = $m_Lcom_papasofokli_planning_PeriodStyleE$().EX;
  if ((!((x === null) ? (x$2 === null) : x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "style", $m_Lcom_papasofokli_planning_PeriodStyle$().q(), v.pj);
  }
  var x$3 = v.ns;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q()), v.ns);
  }
});
$p.ah = (function(v) {
  return this.aix(v);
});
$p.U = (function(out, v) {
  return this.aBx(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDX(ctx, v);
});
$p.T = (function() {
  return this.a13;
});
var $d_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$9, "com.papasofokli.planning.DivisionsDataJSI$$anon$9", ({
  pS: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44(WritersVersionSpecific_this$81, outer) {
  this.a16 = null;
  this.a16 = WritersVersionSpecific_this$81;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44;
/** @constructor */
function $h_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44() {
}
$h_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBv = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $m_Lcom_papasofokli_util_GeneralText$().q(), v.nr);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.wF);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "appliedTo", $m_Lcom_papasofokli_planning_AppliedToC$().q(), v.lE);
    return ctx.L((-1));
  }
});
$p.aDV = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $m_Lcom_papasofokli_util_GeneralText$().q(), v.nr);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.wF);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "appliedTo", $m_Lcom_papasofokli_planning_AppliedToC$().q(), v.lE);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBv(out, v);
});
$p.ai = (function(ctx, v) {
  this.aDV(ctx, v);
});
$p.T = (function() {
  return this.a16;
});
var $d_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44 = new $TypeData().i($c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$44, "com.papasofokli.planning.IndicationsDictionary$$anon$44", ({
  pV: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_LeafData(vesselId_$_lo, vesselId_$_hi, nodeId_$_lo, nodeId_$_hi) {
  this.za = 0;
  this.zb = 0;
  this.u7 = 0;
  this.u8 = 0;
  this.za = vesselId_$_lo;
  this.zb = vesselId_$_hi;
  this.u7 = nodeId_$_lo;
  this.u8 = nodeId_$_hi;
}
$p = $c_Lcom_papasofokli_planning_LeafData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_LeafData;
/** @constructor */
function $h_Lcom_papasofokli_planning_LeafData() {
}
$h_Lcom_papasofokli_planning_LeafData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1626507336);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.za, this.zb));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.u7, this.u8));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_LeafData)) {
    var x_$_lo = this.za;
    var x_$_hi = this.zb;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.za;
    var x$1_$_hi = $x_1.zb;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.u7;
      var x$2_$_hi = this.u8;
      var $x_2 = x$0;
      var x$3_$_lo = $x_2.u7;
      var x$3_$_hi = $x_2.u8;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "LeafData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.za, this.zb);
  }
  if ((n === 1)) {
    return $bL(this.u7, this.u8);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_LeafData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f6)));
}
var $d_Lcom_papasofokli_planning_LeafData = new $TypeData().i($c_Lcom_papasofokli_planning_LeafData, "com.papasofokli.planning.LeafData", ({
  f6: 1,
  cf: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_LeafDivisionJS(divisionName, tooltipText, seq, leafData, style, icon) {
  this.ph = null;
  this.lF = null;
  this.pi = null;
  this.wG = null;
  this.pj = null;
  this.ns = null;
  this.a1b = null;
  this.a1a = null;
  this.ph = divisionName;
  this.lF = tooltipText;
  this.pi = seq;
  this.wG = leafData;
  this.pj = style;
  this.ns = icon;
  $m_sci_Nil$();
  this.a1b = seq.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => _$4$2.pl)));
  this.a1a = $m_s_Option$().Z(0);
}
$p = $c_Lcom_papasofokli_planning_LeafDivisionJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_LeafDivisionJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_LeafDivisionJS() {
}
$h_Lcom_papasofokli_planning_LeafDivisionJS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1930927041), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_LeafDivisionJS)) {
    if (((this.ph === x$0.ph) && (this.lF === x$0.lF))) {
      var x = this.pi;
      var x$2 = x$0.pi;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.wG;
      var x$4 = x$0.wG;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.pj;
      var x$6 = x$0.pj;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.ns;
      var x$8 = x$0.ns;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "LeafDivisionJS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.ph;
      break;
    }
    case 1: {
      return this.lF;
      break;
    }
    case 2: {
      return this.pi;
      break;
    }
    case 3: {
      return this.wG;
      break;
    }
    case 4: {
      return this.pj;
      break;
    }
    case 5: {
      return this.ns;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.V8 = (function() {
  return this.a1b;
});
$p.N9 = (function() {
  return this.a1a;
});
function $isArrayOf_Lcom_papasofokli_planning_LeafDivisionJS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f7)));
}
var $d_Lcom_papasofokli_planning_LeafDivisionJS = new $TypeData().i($c_Lcom_papasofokli_planning_LeafDivisionJS, "com.papasofokli.planning.LeafDivisionJS", ({
  f7: 1,
  cg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_NodeData(vesselId_$_lo, vesselId_$_hi, nodeId) {
  this.qu = 0;
  this.qv = 0;
  this.pk = null;
  this.qu = vesselId_$_lo;
  this.qv = vesselId_$_hi;
  this.pk = nodeId;
}
$p = $c_Lcom_papasofokli_planning_NodeData.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_NodeData;
/** @constructor */
function $h_Lcom_papasofokli_planning_NodeData() {
}
$h_Lcom_papasofokli_planning_NodeData.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1187226860);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.qu, this.qv));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pk));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_NodeData)) {
    var x_$_lo = this.qu;
    var x_$_hi = this.qv;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.qu;
    var x$1_$_hi = $x_1.qv;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.pk;
      var x$2$1 = x$0.pk;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.b(x$2$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "NodeData";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.qu, this.qv);
  }
  if ((n === 1)) {
    return this.pk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_planning_NodeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f8)));
}
var $d_Lcom_papasofokli_planning_NodeData = new $TypeData().i($c_Lcom_papasofokli_planning_NodeData, "com.papasofokli.planning.NodeData", ({
  f8: 1,
  cf: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_NodeDivisionJS(divisionName, departmentDataJS, nodeData, vesselSchedules) {
  this.nt = null;
  this.wH = null;
  this.wI = null;
  this.iI = null;
  this.a1d = null;
  this.a1c = null;
  this.nt = divisionName;
  this.wH = departmentDataJS;
  this.wI = nodeData;
  this.iI = vesselSchedules;
  this.a1d = departmentDataJS.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2.V8())));
  try {
    var $x_1 = new $c_s_util_Success(((1 + (departmentDataJS.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.N9()))).fq($m_s_math_Ordering$Int$()) | 0)) | 0));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  this.a1c = $x_1.mN();
}
$p = $c_Lcom_papasofokli_planning_NodeDivisionJS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_NodeDivisionJS;
/** @constructor */
function $h_Lcom_papasofokli_planning_NodeDivisionJS() {
}
$h_Lcom_papasofokli_planning_NodeDivisionJS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1193945885), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_NodeDivisionJS)) {
    if ((this.nt === x$0.nt)) {
      var x = this.wH;
      var x$2 = x$0.wH;
      var $x_2 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.wI;
      var x$4 = x$0.wI;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.iI;
      var x$6 = x$0.iI;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "NodeDivisionJS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.nt;
      break;
    }
    case 1: {
      return this.wH;
      break;
    }
    case 2: {
      return this.wI;
      break;
    }
    case 3: {
      return this.iI;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.V8 = (function() {
  return this.a1d;
});
$p.N9 = (function() {
  return this.a1c;
});
function $isArrayOf_Lcom_papasofokli_planning_NodeDivisionJS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.f9)));
}
var $d_Lcom_papasofokli_planning_NodeDivisionJS = new $TypeData().i($c_Lcom_papasofokli_planning_NodeDivisionJS, "com.papasofokli.planning.NodeDivisionJS", ({
  f9: 1,
  cg: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodJS$$anon$18(WritersVersionSpecific_this$68, outer) {
  this.a1g = null;
  this.a1g = WritersVersionSpecific_this$68;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PeriodJS$$anon$18.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodJS$$anon$18;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodJS$$anon$18() {
}
$h_Lcom_papasofokli_planning_PeriodJS$$anon$18.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiz = (function(v) {
  var x = v.iQ;
  var x$2 = $m_s_None$();
  var $x_17 = ((x !== null) && x.b(x$2));
  var $x_16 = v.k6;
  var x$3 = v.k7;
  var x$4 = $m_s_None$();
  var $x_15 = ((x$3 !== null) && x$3.b(x$4));
  var $x_14 = $m_sr_BoxesRunTime$().dG(v.hr, 0);
  var x$5 = v.gV;
  var x$6 = $m_sci_Nil$();
  var $x_13 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.iP;
  var x$8 = $m_s_None$();
  var $x_12 = ((x$7 !== null) && x$7.b(x$8));
  var x$9 = v.i4;
  var x$10 = $m_s_None$();
  var $x_11 = ((x$9 !== null) && x$9.b(x$10));
  var x$11 = v.gW;
  var x$12 = $m_sci_Nil$();
  var $x_10 = ((x$11 !== null) && x$11.b(x$12));
  var x$13 = v.gU;
  var x$14 = $m_sci_Nil$();
  var $x_9 = ((x$13 !== null) && x$13.b(x$14));
  var x$15 = v.k5;
  var x$16 = $m_sci_Nil$();
  var $x_8 = ((x$15 !== null) && x$15.b(x$16));
  var x$17 = v.fw;
  var x$18 = $m_ju_UUID$().aW();
  var $x_7 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
  var x$19 = v.iM;
  var x$20 = $m_s_None$();
  var $x_6 = ((x$19 !== null) && x$19.b(x$20));
  var x$21 = v.iO;
  var x$22 = $m_s_None$();
  var $x_5 = ((x$21 !== null) && x$21.b(x$22));
  var x$23 = v.i3;
  var x$24 = $m_s_None$();
  var $x_4 = ((x$23 !== null) && x$23.b(x$24));
  var x$25 = v.iJ;
  var x$26 = $m_s_None$();
  var $x_3 = ((x$25 !== null) && x$25.b(x$26));
  var x$27 = v.iL;
  var x$28 = $m_s_None$();
  var $x_2 = ((x$27 !== null) && x$27.b(x$28));
  var x$29 = v.iK;
  var x$30 = $m_s_None$();
  var $x_1 = ((x$29 !== null) && x$29.b(x$30));
  var x$31 = v.fv;
  var x$32 = new $c_s_Some(0.5);
  return ((((((3 + ((((!$x_17) | 0) + ((1 + (($x_16 !== "") | 0)) | 0)) | 0)) | 0) + ((((2 + ((!$x_15) | 0)) | 0) + ((2 + ((((!$x_14) | 0) + ((!$x_13) | 0)) | 0)) | 0)) | 0)) | 0) + ((((((((!$x_12) | 0) + ((((!$x_11) | 0) + ((!$x_10) | 0)) | 0)) | 0) + ((((((!$x_9) | 0) + ((!$x_8) | 0)) | 0) + ((((!$x_7) | 0) + ((!$x_6) | 0)) | 0)) | 0)) | 0) + ((((((!$x_5) | 0) + ((((!$x_4) | 0) + ((!$x_3) | 0)) | 0)) | 0) + ((((((!$x_2) | 0) + ((!$x_1) | 0)) | 0) + ((((!((x$31 !== null) && x$31.b(x$32))) | 0) + ((!$m_sr_BoxesRunTime$().B(v.iN, true)) | 0)) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aBA = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiz(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.fU);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.qw, v.qx));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $m_Lupickle_default$().ay, $bL(v.ot, v.ou));
    var x = v.iQ;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "totalHours", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.iQ);
    }
    if ((v.k6 !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "taskName", $m_Lupickle_default$().m, v.k6);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodType", $m_Lupickle_default$().m, v.nu);
    var x$3 = v.k7;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.k7);
    }
    var this$17 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipInformation", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$17), v.nv);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "startDateConfirmed", $m_Lupickle_default$().aw, v.lH);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "endDateConfirmed", $m_Lupickle_default$().aw, v.lG);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodStyle", $m_Lcom_papasofokli_planning_PeriodStyle$().q(), v.k4);
    if ((!$m_sr_BoxesRunTime$().dG(v.hr, 0))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toAppearInRow", $m_Lupickle_default$().ao, v.hr);
    }
    var x$5 = v.gV;
    var x$6 = $m_sci_Nil$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      var this$26 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$26), v.gV);
    }
    var x$7 = v.iP;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.b(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.iP);
    }
    var x$9 = v.i4;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "textLine2", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.i4);
    }
    var x$11 = v.gW;
    var x$12 = $m_sci_Nil$();
    if ((!((x$11 !== null) && x$11.b(x$12)))) {
      var this$38 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$38), v.gW);
    }
    var x$13 = v.gU;
    var x$14 = $m_sci_Nil$();
    if ((!((x$13 !== null) && x$13.b(x$14)))) {
      var this$42 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "centerIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$42), v.gU);
    }
    var x$15 = v.k5;
    var x$16 = $m_sci_Nil$();
    if ((!((x$15 !== null) && x$15.b(x$16)))) {
      var this$46 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowInformation", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$46), v.k5);
    }
    var x$17 = v.fw;
    var x$18 = $m_ju_UUID$().aW();
    if ((!((x$17 === null) ? (x$18 === null) : x$17.b(x$18)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uniqueUUID", $m_Lupickle_default$().a1, v.fw);
    }
    var x$19 = v.iM;
    var x$20 = $m_s_None$();
    if ((!((x$19 !== null) && x$19.b(x$20)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.iM);
    }
    var x$21 = v.iO;
    var x$22 = $m_s_None$();
    if ((!((x$21 !== null) && x$21.b(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "stroke", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.iO);
    }
    var x$23 = v.i3;
    var x$24 = $m_s_None$();
    if ((!((x$23 !== null) && x$23.b(x$24)))) {
      var $x_1 = $m_Lupickle_default$();
      var this$61 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customIndicationsDictionary", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), this$61)), v.i3);
    }
    var x$25 = v.iJ;
    var x$26 = $m_s_None$();
    if ((!((x$25 !== null) && x$25.b(x$26)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeDatesFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iJ);
    }
    var x$27 = v.iL;
    var x$28 = $m_s_None$();
    if ((!((x$27 !== null) && x$27.b(x$28)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeRightDateFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iL);
    }
    var x$29 = v.iK;
    var x$30 = $m_s_None$();
    if ((!((x$29 !== null) && x$29.b(x$30)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeLeftDateFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iK);
    }
    var x$31 = v.fv;
    var x$32 = new $c_s_Some(0.5);
    if ((!((x$31 !== null) && x$31.b(x$32)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "animationTime", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().g5), v.fv);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.iN, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showDatesOnTooltip", $m_Lupickle_default$().aw, v.iN);
    }
    return ctx.L((-1));
  }
});
$p.aE0 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.fU);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.qw, v.qx));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $m_Lupickle_default$().ay, $bL(v.ot, v.ou));
  var x = v.iQ;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "totalHours", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.iQ);
  }
  if ((v.k6 !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "taskName", $m_Lupickle_default$().m, v.k6);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodType", $m_Lupickle_default$().m, v.nu);
  var x$3 = v.k7;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.k7);
  }
  var this$17 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipInformation", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().m, this$17), v.nv);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "startDateConfirmed", $m_Lupickle_default$().aw, v.lH);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "endDateConfirmed", $m_Lupickle_default$().aw, v.lG);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodStyle", $m_Lcom_papasofokli_planning_PeriodStyle$().q(), v.k4);
  if ((!$m_sr_BoxesRunTime$().dG(v.hr, 0))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toAppearInRow", $m_Lupickle_default$().ao, v.hr);
  }
  var x$5 = v.gV;
  var x$6 = $m_sci_Nil$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    var this$26 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$26), v.gV);
  }
  var x$7 = v.iP;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.b(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.iP);
  }
  var x$9 = v.i4;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "textLine2", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.i4);
  }
  var x$11 = v.gW;
  var x$12 = $m_sci_Nil$();
  if ((!((x$11 !== null) && x$11.b(x$12)))) {
    var this$38 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$38), v.gW);
  }
  var x$13 = v.gU;
  var x$14 = $m_sci_Nil$();
  if ((!((x$13 !== null) && x$13.b(x$14)))) {
    var this$42 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "centerIndications", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$42), v.gU);
  }
  var x$15 = v.k5;
  var x$16 = $m_sci_Nil$();
  if ((!((x$15 !== null) && x$15.b(x$16)))) {
    var this$46 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowInformation", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$46), v.k5);
  }
  var x$17 = v.fw;
  var x$18 = $m_ju_UUID$().aW();
  if ((!((x$17 === null) ? (x$18 === null) : x$17.b(x$18)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "uniqueUUID", $m_Lupickle_default$().a1, v.fw);
  }
  var x$19 = v.iM;
  var x$20 = $m_s_None$();
  if ((!((x$19 !== null) && x$19.b(x$20)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.iM);
  }
  var x$21 = v.iO;
  var x$22 = $m_s_None$();
  if ((!((x$21 !== null) && x$21.b(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "stroke", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.iO);
  }
  var x$23 = v.i3;
  var x$24 = $m_s_None$();
  if ((!((x$23 !== null) && x$23.b(x$24)))) {
    var $x_1 = $m_Lupickle_default$();
    var this$61 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customIndicationsDictionary", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($x_1, new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), this$61)), v.i3);
  }
  var x$25 = v.iJ;
  var x$26 = $m_s_None$();
  if ((!((x$25 !== null) && x$25.b(x$26)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeDatesFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iJ);
  }
  var x$27 = v.iL;
  var x$28 = $m_s_None$();
  if ((!((x$27 !== null) && x$27.b(x$28)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeRightDateFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iL);
  }
  var x$29 = v.iK;
  var x$30 = $m_s_None$();
  if ((!((x$29 !== null) && x$29.b(x$30)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "changeLeftDateFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.iK);
  }
  var x$31 = v.fv;
  var x$32 = new $c_s_Some(0.5);
  if ((!((x$31 !== null) && x$31.b(x$32)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "animationTime", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().g5), v.fv);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.iN, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showDatesOnTooltip", $m_Lupickle_default$().aw, v.iN);
  }
});
$p.ah = (function(v) {
  return this.aiz(v);
});
$p.U = (function(out, v) {
  return this.aBA(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE0(ctx, v);
});
$p.T = (function() {
  return this.a1g;
});
var $d_Lcom_papasofokli_planning_PeriodJS$$anon$18 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodJS$$anon$18, "com.papasofokli.planning.PeriodJS$$anon$18", ({
  pZ: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodStyle$$anon$40(WritersVersionSpecific_this$79, outer) {
  this.a1j = null;
  this.a1j = WritersVersionSpecific_this$79;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PeriodStyle$$anon$40.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodStyle$$anon$40;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodStyle$$anon$40() {
}
$h_Lcom_papasofokli_planning_PeriodStyle$$anon$40.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBB = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.sk);
    return ctx.L((-1));
  }
});
$p.aE1 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.sk);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBB(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE1(ctx, v);
});
$p.T = (function() {
  return this.a1j;
});
var $d_Lcom_papasofokli_planning_PeriodStyle$$anon$40 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodStyle$$anon$40, "com.papasofokli.planning.PeriodStyle$$anon$40", ({
  q2: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$34(WritersVersionSpecific_this$76, outer) {
  this.a1n = null;
  this.a1n = WritersVersionSpecific_this$76;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$34.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$34;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodTransformation$$anon$34() {
}
$h_Lcom_papasofokli_planning_PeriodTransformation$$anon$34.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBC = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "oldPeriod", $m_Lcom_papasofokli_planning_PeriodJS$().q(), v.wK);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "newPeriod", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q()), v.wJ);
    return ctx.L((-1));
  }
});
$p.aE2 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "oldPeriod", $m_Lcom_papasofokli_planning_PeriodJS$().q(), v.wK);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "newPeriod", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q()), v.wJ);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBC(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE2(ctx, v);
});
$p.T = (function() {
  return this.a1n;
});
var $d_Lcom_papasofokli_planning_PeriodTransformation$$anon$34 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodTransformation$$anon$34, "com.papasofokli.planning.PeriodTransformation$$anon$34", ({
  q6: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22(WritersVersionSpecific_this$70, outer) {
  this.a1q = null;
  this.a1q = WritersVersionSpecific_this$70;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22() {
}
$h_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBD = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AJ);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodWithRowSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_UUIDRowWithPeriod$().q(), this$3), v.AI);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectRowId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ay, $m_Lupickle_default$().a1)), v.AK);
    return ctx.L((-1));
  }
});
$p.aE3 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AJ);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodWithRowSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_UUIDRowWithPeriod$().q(), this$3), v.AI);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectRowId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Writer__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer__Lupickle_implicits_TupleReadWriters$TupleNWriter($m_Lupickle_default$(), $m_Lupickle_default$().ay, $m_Lupickle_default$().a1)), v.AK);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBD(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE3(ctx, v);
});
$p.T = (function() {
  return this.a1q;
});
var $d_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22 = new $TypeData().i($c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$22, "com.papasofokli.planning.PlannerPeriodsData$$anon$22", ({
  q9: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningData$$anon$2(WritersVersionSpecific_this$59, outer) {
  this.a1v = null;
  this.a1v = WritersVersionSpecific_this$59;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PlanningData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningData$$anon$2() {
}
$h_Lcom_papasofokli_planning_PlanningData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiA = (function(v) {
  var x = v.nw;
  var x$2 = $m_s_None$();
  var $x_16 = ((x !== null) && x.b(x$2));
  var $x_15 = $m_sr_BoxesRunTime$().B(v.k8, true);
  var x$3 = v.lK;
  var x$4 = $m_s_None$();
  var $x_14 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.lI;
  var x$6 = $m_s_None$();
  var $x_13 = ((x$5 !== null) && x$5.b(x$6));
  var x$7 = v.lJ;
  var x$8 = $m_s_None$();
  var $x_12 = ((x$7 !== null) && x$7.b(x$8));
  var x$9 = v.lL;
  var x$10 = $m_s_None$();
  var $x_11 = ((x$9 !== null) && x$9.b(x$10));
  var x$11 = v.lS;
  var x$12 = $m_sci_Nil$();
  var $x_10 = ((x$11 !== null) && x$11.b(x$12));
  var $x_9 = $m_sr_BoxesRunTime$().dG(v.iR, 150.0);
  var $x_8 = $m_sr_BoxesRunTime$().dG(v.iS, 150.0);
  var x$13 = v.lN;
  var x$14 = $m_sci_Set$EmptySet$();
  var $x_7 = ((x$13 !== null) && x$13.b(x$14));
  var $x_6 = $m_sr_BoxesRunTime$().B(v.lP, false);
  var x$15$1 = v.lO;
  var x$16 = $m_s_None$();
  var $x_5 = ((x$15$1 !== null) && x$15$1.b(x$16));
  var $x_4 = $m_sr_BoxesRunTime$().B(v.lU, false);
  var x$17$1 = v.lM;
  var x$18 = $m_Lcom_papasofokli_planning_PlanningData$().M4();
  var $x_3 = ((x$17$1 === null) ? (x$18 === null) : x$17$1.b(x$18));
  var x$19 = v.lT;
  var x$20 = $m_sci_Nil$();
  var $x_2 = ((x$19 !== null) && x$19.b(x$20));
  var $x_1 = $m_sr_BoxesRunTime$().B(v.lQ, false);
  var x$21$1 = v.k9;
  var x$22 = $m_s_None$();
  return ((((((4 + ((!$x_16) | 0)) | 0) + ((((((!$x_15) | 0) + ((!$x_14) | 0)) | 0) + ((((!$x_13) | 0) + ((((!$x_12) | 0) + ((!$x_11) | 0)) | 0)) | 0)) | 0)) | 0) + ((((((((!$x_10) | 0) + ((!$x_9) | 0)) | 0) + ((((!$x_8) | 0) + ((((!$x_7) | 0) + ((!$x_6) | 0)) | 0)) | 0)) | 0) + ((((((!$x_5) | 0) + ((((!$x_4) | 0) + ((!$x_3) | 0)) | 0)) | 0) + ((((!$x_2) | 0) + ((((!$x_1) | 0) + ((!((x$21$1 !== null) && x$21$1.b(x$22))) | 0)) | 0)) | 0)) | 0)) | 0)) | 0);
});
$p.aBE = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiA(v), true, (-1));
    var this$2 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DivisionsDataJSI$().q(), this$2), v.lR);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.kC, v.kD));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nx);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "zoomLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.ny);
    var x = v.nw;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "scrollOnTime", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nw);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.k8, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showButtons", $m_Lupickle_default$().aw, v.k8);
    }
    var x$3 = v.lK;
    var x$4 = $m_s_None$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lK);
    }
    var x$5 = v.lI;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lI);
    }
    var x$7 = v.lJ;
    var x$8 = $m_s_None$();
    if ((!((x$7 !== null) && x$7.b(x$8)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickSubjectButtonParams", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SubjectButtonParameters$().q()), v.lJ);
    }
    var x$9 = v.lL;
    var x$10 = $m_s_None$();
    if ((!((x$9 !== null) && x$9.b(x$10)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "departmentClickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lL);
    }
    var x$11 = v.lS;
    var x$12 = $m_sci_Nil$();
    if ((!((x$11 !== null) && x$11.b(x$12)))) {
      var this$33 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "verticalDateLines", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VerticalDateLine$().q(), this$33), v.lS);
    }
    if ((!$m_sr_BoxesRunTime$().dG(v.iR, 150.0))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafDivisionSize", $m_Lupickle_default$().g5, v.iR);
    }
    if ((!$m_sr_BoxesRunTime$().dG(v.iS, 150.0))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectNameDivisionSize", $m_Lupickle_default$().g5, v.iS);
    }
    var x$13 = v.lN;
    var x$14 = $m_sci_Set$EmptySet$();
    if ((!((x$13 !== null) && x$13.b(x$14)))) {
      var this$42 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "indicationsDictionary", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), this$42), v.lN);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lP, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showSubjectId", $m_Lupickle_default$().aw, v.lP);
    }
    var x$15$1 = v.lO;
    var x$16 = $m_s_None$();
    if ((!((x$15$1 !== null) && x$15$1.b(x$16)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodHide", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().g5), v.lO);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lU, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "wideTimeline", $m_Lupickle_default$().aw, v.lU);
    }
    var x$17$1 = v.lM;
    var x$18 = $m_Lcom_papasofokli_planning_PlanningData$().M4();
    if ((!((x$17$1 === null) ? (x$18 === null) : x$17$1.b(x$18)))) {
      var this$53 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionRowsToShow", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$53), v.lM);
    }
    var x$19 = v.lT;
    var x$20 = $m_sci_Nil$();
    if ((!((x$19 !== null) && x$19.b(x$20)))) {
      var this$57 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselSchedules", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), this$57), v.lT);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lQ, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showVesselScheduleComponents", $m_Lupickle_default$().aw, v.lQ);
    }
    var x$21$1 = v.k9;
    var x$22 = $m_s_None$();
    if ((!((x$21$1 !== null) && x$21$1.b(x$22)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageClickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.k9);
    }
    return ctx.L((-1));
  }
});
$p.aE4 = (function(ctx, v) {
  var this$2 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectData", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DivisionsDataJSI$().q(), this$2), v.lR);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.kC, v.kD));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nx);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "zoomLevel", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.ny);
  var x = v.nw;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "scrollOnTime", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nw);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.k8, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showButtons", $m_Lupickle_default$().aw, v.k8);
  }
  var x$3 = v.lK;
  var x$4 = $m_s_None$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lK);
  }
  var x$5 = v.lI;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lI);
  }
  var x$7 = v.lJ;
  var x$8 = $m_s_None$();
  if ((!((x$7 !== null) && x$7.b(x$8)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "clickSubjectButtonParams", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SubjectButtonParameters$().q()), v.lJ);
  }
  var x$9 = v.lL;
  var x$10 = $m_s_None$();
  if ((!((x$9 !== null) && x$9.b(x$10)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "departmentClickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.lL);
  }
  var x$11 = v.lS;
  var x$12 = $m_sci_Nil$();
  if ((!((x$11 !== null) && x$11.b(x$12)))) {
    var this$33 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "verticalDateLines", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VerticalDateLine$().q(), this$33), v.lS);
  }
  if ((!$m_sr_BoxesRunTime$().dG(v.iR, 150.0))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafDivisionSize", $m_Lupickle_default$().g5, v.iR);
  }
  if ((!$m_sr_BoxesRunTime$().dG(v.iS, 150.0))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectNameDivisionSize", $m_Lupickle_default$().g5, v.iS);
  }
  var x$13 = v.lN;
  var x$14 = $m_sci_Set$EmptySet$();
  if ((!((x$13 !== null) && x$13.b(x$14)))) {
    var this$42 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "indicationsDictionary", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), this$42), v.lN);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lP, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showSubjectId", $m_Lupickle_default$().aw, v.lP);
  }
  var x$15$1 = v.lO;
  var x$16 = $m_s_None$();
  if ((!((x$15$1 !== null) && x$15$1.b(x$16)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodHide", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().g5), v.lO);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lU, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "wideTimeline", $m_Lupickle_default$().aw, v.lU);
  }
  var x$17$1 = v.lM;
  var x$18 = $m_Lcom_papasofokli_planning_PlanningData$().M4();
  if ((!((x$17$1 === null) ? (x$18 === null) : x$17$1.b(x$18)))) {
    var this$53 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "divisionRowsToShow", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ao, this$53), v.lM);
  }
  var x$19 = v.lT;
  var x$20 = $m_sci_Nil$();
  if ((!((x$19 !== null) && x$19.b(x$20)))) {
    var this$57 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselSchedules", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), this$57), v.lT);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lQ, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showVesselScheduleComponents", $m_Lupickle_default$().aw, v.lQ);
  }
  var x$21$1 = v.k9;
  var x$22 = $m_s_None$();
  if ((!((x$21$1 !== null) && x$21$1.b(x$22)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageClickFunctionUUID", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().a1), v.k9);
  }
});
$p.ah = (function(v) {
  return this.aiA(v);
});
$p.U = (function(out, v) {
  return this.aBE(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE4(ctx, v);
});
$p.T = (function() {
  return this.a1v;
});
var $d_Lcom_papasofokli_planning_PlanningData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningData$$anon$2, "com.papasofokli.planning.PlanningData$$anon$2", ({
  qc: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36(WritersVersionSpecific_this$77, outer) {
  this.a1y = null;
  this.a1y = WritersVersionSpecific_this$77;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36() {
}
$h_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBF = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(6, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodId", $m_Lupickle_default$().ay, $bL(v.ov, v.ow));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselPositionId", $m_Lupickle_default$().ay, $bL(v.qy, v.qz));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.u9, v.ua));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $m_Lupickle_default$().ay, $bL(v.ub, v.uc));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "explanation", $m_Lupickle_default$().m, v.sl);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "removed", $m_Lupickle_default$().aw, v.sm);
    return ctx.L((-1));
  }
});
$p.aE5 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodId", $m_Lupickle_default$().ay, $bL(v.ov, v.ow));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselPositionId", $m_Lupickle_default$().ay, $bL(v.qy, v.qz));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fromDate", $m_Lupickle_default$().ay, $bL(v.u9, v.ua));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "toDate", $m_Lupickle_default$().ay, $bL(v.ub, v.uc));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "explanation", $m_Lupickle_default$().m, v.sl);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "removed", $m_Lupickle_default$().aw, v.sm);
});
$p.ah = (function(v) {
  return 6;
});
$p.U = (function(out, v) {
  return this.aBF(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE5(ctx, v);
});
$p.T = (function() {
  return this.a1y;
});
var $d_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36 = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$36, "com.papasofokli.planning.PlanningPeriodChange$$anon$36", ({
  qf: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowClickData$$anon$32(WritersVersionSpecific_this$75, outer) {
  this.a1B = null;
  this.a1B = WritersVersionSpecific_this$75;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_RowClickData$$anon$32.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowClickData$$anon$32;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowClickData$$anon$32() {
}
$h_Lcom_papasofokli_planning_RowClickData$$anon$32.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBG = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AM);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowDataSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_RowData$().q(), this$3), v.AL);
    return ctx.L((-1));
  }
});
$p.aE6 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.AM);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowDataSeq", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_RowData$().q(), this$3), v.AL);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBG(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE6(ctx, v);
});
$p.T = (function() {
  return this.a1B;
});
var $d_Lcom_papasofokli_planning_RowClickData$$anon$32 = new $TypeData().i($c_Lcom_papasofokli_planning_RowClickData$$anon$32, "com.papasofokli.planning.RowClickData$$anon$32", ({
  qi: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowData$$anon$30(WritersVersionSpecific_this$74, outer) {
  this.a1E = null;
  this.a1E = WritersVersionSpecific_this$74;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_RowData$$anon$30.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_RowData$$anon$30;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowData$$anon$30() {
}
$h_Lcom_papasofokli_planning_RowData$$anon$30.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBH = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.sn);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $m_Lupickle_default$().ay, $bL(v.zc, v.zd));
    $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wL);
    return ctx.L((-1));
  }
});
$p.aE7 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowId", $m_Lupickle_default$().a1, v.sn);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $m_Lupickle_default$().ay, $bL(v.zc, v.zd));
  $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leafData", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_planning_DivisionData$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wL);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBH(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE7(ctx, v);
});
$p.T = (function() {
  return this.a1E;
});
var $d_Lcom_papasofokli_planning_RowData$$anon$30 = new $TypeData().i($c_Lcom_papasofokli_planning_RowData$$anon$30, "com.papasofokli.planning.RowData$$anon$30", ({
  ql: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4(WritersVersionSpecific_this$60, outer) {
  this.a1H = null;
  this.a1H = WritersVersionSpecific_this$60;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4() {
}
$h_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBI = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(3, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "funUUId", $m_Lupickle_default$().a1, v.wM);
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wN);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipText", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.so);
    return ctx.L((-1));
  }
});
$p.aE8 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "funUUId", $m_Lupickle_default$().a1, v.wM);
  $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.wN);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltipText", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.so);
});
$p.ah = (function(v) {
  return 3;
});
$p.U = (function(out, v) {
  return this.aBI(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE8(ctx, v);
});
$p.T = (function() {
  return this.a1H;
});
var $d_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$4, "com.papasofokli.planning.SubjectButtonParameters$$anon$4", ({
  qo: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectJS$$anon$16(WritersVersionSpecific_this$67, outer) {
  this.a1K = null;
  this.a1K = WritersVersionSpecific_this$67;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_SubjectJS$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectJS$$anon$16;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectJS$$anon$16() {
}
$h_Lcom_papasofokli_planning_SubjectJS$$anon$16.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiB = (function(v) {
  var x = v.lV;
  var x$2 = $m_s_None$();
  var $x_2 = ((x !== null) && x.b(x$2));
  var x$3 = v.i5;
  var x$4 = $m_sci_Nil$();
  var $x_1 = ((x$3 !== null) && x$3.b(x$4));
  var x$5 = v.ka;
  var x$6 = $m_s_None$();
  return ((3 + ((((((!$x_2) | 0) + ((!$x_1) | 0)) | 0) + ((((!((x$5 !== null) && x$5.b(x$6))) | 0) + ((!$m_sr_BoxesRunTime$().B(v.lW, true)) | 0)) | 0)) | 0)) | 0);
});
$p.aBJ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiB(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nA);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortName", $m_Lupickle_default$().m, v.sp);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fullName", $m_Lupickle_default$().m, v.nz);
    var x = v.lV;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraInfoText", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lV);
    }
    var x$3 = v.i5;
    var x$4 = $m_sci_Nil$();
    if ((!((x$3 !== null) && x$3.b(x$4)))) {
      var this$12 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$12), v.i5);
    }
    var x$5 = v.ka;
    var x$6 = $m_s_None$();
    if ((!((x$5 !== null) && x$5.b(x$6)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ka);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.lW, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showButtonInd", $m_Lupickle_default$().aw, v.lW);
    }
    return ctx.L((-1));
  }
});
$p.aE9 = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subjectId", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().ay), v.nA);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "shortName", $m_Lupickle_default$().m, v.sp);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "fullName", $m_Lupickle_default$().m, v.nz);
  var x = v.lV;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraInfoText", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.lV);
  }
  var x$3 = v.i5;
  var x$4 = $m_sci_Nil$();
  if ((!((x$3 !== null) && x$3.b(x$4)))) {
    var this$12 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_util_GeneralText$().q(), this$12), v.i5);
  }
  var x$5 = v.ka;
  var x$6 = $m_s_None$();
  if ((!((x$5 !== null) && x$5.b(x$6)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ka);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.lW, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "showButtonInd", $m_Lupickle_default$().aw, v.lW);
  }
});
$p.ah = (function(v) {
  return this.aiB(v);
});
$p.U = (function(out, v) {
  return this.aBJ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aE9(ctx, v);
});
$p.T = (function() {
  return this.a1K;
});
var $d_Lcom_papasofokli_planning_SubjectJS$$anon$16 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectJS$$anon$16, "com.papasofokli.planning.SubjectJS$$anon$16", ({
  qr: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12(WritersVersionSpecific_this$65, outer) {
  this.a1N = null;
  this.a1N = WritersVersionSpecific_this$65;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12() {
}
$h_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiC = (function(v) {
  var x = v.kb;
  var x$2 = $m_sci_Nil$();
  return ((2 + ((((!((x !== null) && x.b(x$2))) | 0) + ((((!$m_sr_BoxesRunTime$().B(v.nB, false)) | 0) + ((v.lX !== "topBackground") | 0)) | 0)) | 0)) | 0);
});
$p.aBK = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiC(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subject", $m_Lcom_papasofokli_planning_SubjectJS$().q(), v.pm);
    var this$3 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodsJS", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$3), v.pl);
    var x = v.kb;
    var x$2 = $m_sci_Nil$();
    if ((!((x !== null) && x.b(x$2)))) {
      var this$7 = $m_Lupickle_default$();
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "detailedPlanningRows", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DetailedPlanningRow$().q(), this$7), v.kb);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.nB, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isExpandable", $m_Lupickle_default$().aw, v.nB);
    }
    if ((v.lX !== "topBackground")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "initialClassStyle", $m_Lupickle_default$().m, v.lX);
    }
    return ctx.L((-1));
  }
});
$p.aEa = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "subject", $m_Lcom_papasofokli_planning_SubjectJS$().q(), v.pm);
  var this$3 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "periodsJS", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_PeriodJS$().q(), this$3), v.pl);
  var x = v.kb;
  var x$2 = $m_sci_Nil$();
  if ((!((x !== null) && x.b(x$2)))) {
    var this$7 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "detailedPlanningRows", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_planning_DetailedPlanningRow$().q(), this$7), v.kb);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.nB, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "isExpandable", $m_Lupickle_default$().aw, v.nB);
  }
  if ((v.lX !== "topBackground")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "initialClassStyle", $m_Lupickle_default$().m, v.lX);
  }
});
$p.ah = (function(v) {
  return this.aiC(v);
});
$p.U = (function(out, v) {
  return this.aBK(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEa(ctx, v);
});
$p.T = (function() {
  return this.a1N;
});
var $d_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$12, "com.papasofokli.planning.SubjectPlanningData$$anon$12", ({
  qu: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SvgColor$$anon$24(WritersVersionSpecific_this$71, outer) {
  this.a1Q = null;
  this.a1Q = WritersVersionSpecific_this$71;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_SvgColor$$anon$24.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_SvgColor$$anon$24;
/** @constructor */
function $h_Lcom_papasofokli_planning_SvgColor$$anon$24() {
}
$h_Lcom_papasofokli_planning_SvgColor$$anon$24.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBL = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(4, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "red", $m_Lupickle_default$().ao, v.nE);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "green", $m_Lupickle_default$().ao, v.nD);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blue", $m_Lupickle_default$().ao, v.nC);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "opacity", $m_Lupickle_default$().h8, v.pn);
    return ctx.L((-1));
  }
});
$p.aEb = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "red", $m_Lupickle_default$().ao, v.nE);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "green", $m_Lupickle_default$().ao, v.nD);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blue", $m_Lupickle_default$().ao, v.nC);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "opacity", $m_Lupickle_default$().h8, v.pn);
});
$p.ah = (function(v) {
  return 4;
});
$p.U = (function(out, v) {
  return this.aBL(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEb(ctx, v);
});
$p.T = (function() {
  return this.a1Q;
});
var $d_Lcom_papasofokli_planning_SvgColor$$anon$24 = new $TypeData().i($c_Lcom_papasofokli_planning_SvgColor$$anon$24, "com.papasofokli.planning.SvgColor$$anon$24", ({
  qx: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20(WritersVersionSpecific_this$69, outer) {
  this.a1T = null;
  this.a1T = WritersVersionSpecific_this$69;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20;
/** @constructor */
function $h_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20() {
}
$h_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBM = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.po);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "period", $m_Lcom_papasofokli_planning_PeriodJS$().q(), v.dX);
    return ctx.L((-1));
  }
});
$p.aEc = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rowUUID", $m_Lupickle_default$().a1, v.po);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "period", $m_Lcom_papasofokli_planning_PeriodJS$().q(), v.dX);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aBM(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEc(ctx, v);
});
$p.T = (function() {
  return this.a1T;
});
var $d_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20 = new $TypeData().i($c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$20, "com.papasofokli.planning.UUIDRowWithPeriod$$anon$20", ({
  qA: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$6(WritersVersionSpecific_this$61, outer) {
  this.a1W = null;
  this.a1W = WritersVersionSpecific_this$61;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_planning_VerticalDateLine$$anon$6() {
}
$h_Lcom_papasofokli_planning_VerticalDateLine$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiD = (function(v) {
  var x = v.lY;
  var x$2 = $m_ju_UUID$().aW();
  return ((3 + ((!((x === null) ? (x$2 === null) : x.b(x$2))) | 0)) | 0);
});
$p.aBN = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiD(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "date", $m_Lupickle_default$().ay, $bL(v.ud, v.ue));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.sr);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.sq);
    var x = v.lY;
    var x$2 = $m_ju_UUID$().aW();
    if ((!((x === null) ? (x$2 === null) : x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.lY);
    }
    return ctx.L((-1));
  }
});
$p.aEd = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "date", $m_Lupickle_default$().ay, $bL(v.ud, v.ue));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.sr);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "cssClass", $m_Lupickle_default$().m, v.sq);
  var x = v.lY;
  var x$2 = $m_ju_UUID$().aW();
  if ((!((x === null) ? (x$2 === null) : x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().a1, v.lY);
  }
});
$p.ah = (function(v) {
  return this.aiD(v);
});
$p.U = (function(out, v) {
  return this.aBN(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEd(ctx, v);
});
$p.T = (function() {
  return this.a1W;
});
var $d_Lcom_papasofokli_planning_VerticalDateLine$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_planning_VerticalDateLine$$anon$6, "com.papasofokli.planning.VerticalDateLine$$anon$6", ({
  qD: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38(WritersVersionSpecific_this$78, outer) {
  this.a1Z = null;
  this.a1Z = WritersVersionSpecific_this$78;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38;
/** @constructor */
function $h_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38() {
}
$h_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBO = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(11, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.ze, v.zf));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageId", $m_Lupickle_default$().ay, $bL(v.zi, v.zj));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.zg, v.zh));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselName", $m_Lupickle_default$().m, v.pq);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sailingType", $m_Lupickle_default$().m, v.st);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "portName", $m_Lupickle_default$().m, v.pp);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageNumber", $m_Lupickle_default$().m, v.su);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "from", $m_Lupickle_default$().ay, $bL(v.kE, v.kF));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "to", $m_Lupickle_default$().ay, $bL(v.ox, v.oy));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "remarks", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.wO);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ss);
    return ctx.L((-1));
  }
});
$p.aEe = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "id", $m_Lupickle_default$().ay, $bL(v.ze, v.zf));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageId", $m_Lupickle_default$().ay, $bL(v.zi, v.zj));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselId", $m_Lupickle_default$().ay, $bL(v.zg, v.zh));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "vesselName", $m_Lupickle_default$().m, v.pq);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sailingType", $m_Lupickle_default$().m, v.st);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "portName", $m_Lupickle_default$().m, v.pp);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "voyageNumber", $m_Lupickle_default$().m, v.su);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "from", $m_Lupickle_default$().ay, $bL(v.kE, v.kF));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "to", $m_Lupickle_default$().ay, $bL(v.ox, v.oy));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "remarks", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.wO);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customCss", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.ss);
});
$p.ah = (function(v) {
  return 11;
});
$p.U = (function(out, v) {
  return this.aBO(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEe(ctx, v);
});
$p.T = (function() {
  return this.a1Z;
});
var $d_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38 = new $TypeData().i($c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$38, "com.papasofokli.planning.VesselScheduleJS$$anon$38", ({
  qG: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
function $p_Lcom_papasofokli_planning_api_ClickSubjectRowButton__clickFunction__V($thiz) {
  var allRowsData = $thiz.AO.aA();
  var this$6 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var id = $thiz.AN.wM;
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), new $c_Lcom_papasofokli_planning_RowClickData($thiz.AP, allRowsData), ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_planning_RowClickData$().q());
  var executionContext = $thiz.a20;
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$6, id.g(), data, executionContext);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_ClickSubjectRowButton(initialX, initialY, extraCssClass, clickSubjectParams, getSubjectRowsData, divisionData, rowUUID, executionContext) {
  this.F2 = 0.0;
  this.F3 = 0.0;
  this.F1 = null;
  this.AN = null;
  this.AO = null;
  this.F0 = null;
  this.AP = null;
  this.a20 = null;
  this.OX = null;
  this.F2 = initialX;
  this.F3 = initialY;
  this.F1 = extraCssClass;
  this.AN = clickSubjectParams;
  this.AO = getSubjectRowsData;
  this.F0 = divisionData;
  this.AP = rowUUID;
  this.a20 = executionContext;
  var faIcon$2 = new $c_sci_$colon$colon(clickSubjectParams.wN, $m_sci_Nil$());
  var clickFunction$5 = new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$3) => {
    $p_Lcom_papasofokli_planning_api_ClickSubjectRowButton__clickFunction__V(this);
  })));
  var this$3 = clickSubjectParams.so;
  if (this$3.c()) {
    var onHover$5 = $m_s_None$();
  } else {
    var x0 = this$3.h();
    var onHover$5 = new $c_s_Some($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(x0, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), $m_s_None$())));
  }
  var this$6 = clickSubjectParams.so;
  var onMouseOut$5 = (this$6.c() ? $m_s_None$() : new $c_s_Some((this$6.h(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  })))));
  this.OX = new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon$2, initialX, initialY, extraCssClass, $m_Lcom_papasofokli_svg_components_IconTextComponent$().afn(), $m_s_None$(), clickFunction$5, $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb(), onHover$5, onMouseOut$5, true, $m_s_None$(), new $c_s_Some(0.5), $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor());
}
$p = $c_Lcom_papasofokli_planning_api_ClickSubjectRowButton.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_ClickSubjectRowButton;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_ClickSubjectRowButton() {
}
$h_Lcom_papasofokli_planning_api_ClickSubjectRowButton.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1828628328);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.F2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.F3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.F1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.F0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.AP));
  return $m_sr_Statics$().an(acc, 7);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_ClickSubjectRowButton)) {
    if (((this.F2 === x$0.F2) && (this.F3 === x$0.F3))) {
      var x = this.F1;
      var x$2 = x$0.F1;
      var $x_4 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.AN;
      var x$4 = x$0.AN;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.AO;
      var x$6 = x$0.AO;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.F0;
      var x$8 = x$0.F0;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.AP;
      var x$10 = x$0.AP;
      return ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 7;
});
$p.A = (function() {
  return "ClickSubjectRowButton";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.F2;
      break;
    }
    case 1: {
      return this.F3;
      break;
    }
    case 2: {
      return this.F1;
      break;
    }
    case 3: {
      return this.AN;
      break;
    }
    case 4: {
      return this.AO;
      break;
    }
    case 5: {
      return this.F0;
      break;
    }
    case 6: {
      return this.AP;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cT = (function(newX, newY) {
  this.OX.cT(newX, newY);
});
$p.di = (function() {
  return this.OX.di();
});
function $isArrayOf_Lcom_papasofokli_planning_api_ClickSubjectRowButton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fq)));
}
var $d_Lcom_papasofokli_planning_api_ClickSubjectRowButton = new $TypeData().i($c_Lcom_papasofokli_planning_api_ClickSubjectRowButton, "com.papasofokli.planning.api.ClickSubjectRowButton", ({
  fq: 1,
  aj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1.prototype = $p;
$p.avk = (function(x) {
  return (((!x.k3.c()) || (x.k3.c() && (!x.k2))) || false);
});
$p.amM = (function(x, default$1) {
  return (((!x.k3.c()) || (x.k3.c() && (!x.k2))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.avk(x);
});
$p.aJ = (function(x, default$1) {
  return this.amM(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1, "com.papasofokli.planning.api.LeafDivisionSVG$$anon$1", ({
  qJ: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1.prototype = $p;
$p.avo = (function(x) {
  return ((x instanceof $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG) || false);
});
$p.amQ = (function(x, default$1) {
  return ((x instanceof $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG) ? x.ajs() : default$1.p(x));
});
$p.aU = (function(x) {
  return this.avo(x);
});
$p.aJ = (function(x, default$1) {
  return this.amQ(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1, "com.papasofokli.planning.api.NodeDivisionSVG$$anon$1", ({
  qL: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1.prototype = $p;
$p.qJ = (function(x) {
  return ((!(!(x instanceof Element))) || false);
});
$p.qB = (function(x, default$1) {
  return ((!(!(x instanceof Element))) ? x.id : default$1.p(x));
});
$p.aU = (function(x) {
  return this.qJ(x);
});
$p.aJ = (function(x, default$1) {
  return this.qB(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$1, "com.papasofokli.planning.api.PositionPlanningSVG$$anon$1", ({
  qP: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2() {
}
$p = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2() {
}
$h_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2.prototype = $p;
$p.jt = (function(x) {
  return ((!(!(x instanceof HTMLDivElement))) || false);
});
$p.jk = (function(x, default$1) {
  return ((!(!(x instanceof HTMLDivElement))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_api_PositionPlanningSVG$$anon$2, "com.papasofokli.planning.api.PositionPlanningSVG$$anon$2", ({
  qQ: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1.prototype = $p;
$p.avl = (function(x) {
  return ((x instanceof $c_Lcom_papasofokli_planning_api_NodeDivisionSVG) || false);
});
$p.amN = (function(x, default$1) {
  return ((x instanceof $c_Lcom_papasofokli_planning_api_NodeDivisionSVG) ? x.auy() : default$1.p(x));
});
$p.aU = (function(x) {
  return this.avl(x);
});
$p.aJ = (function(x, default$1) {
  return this.amN(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$1, "com.papasofokli.planning.api.SubjectNameLeafPlanningSVG$$anon$1", ({
  qT: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2() {
}
$p = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2() {
}
$h_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2.prototype = $p;
$p.qJ = (function(x) {
  return ((!(!(x instanceof Element))) || false);
});
$p.qB = (function(x, default$1) {
  return ((!(!(x instanceof Element))) ? x.id : default$1.p(x));
});
$p.aU = (function(x) {
  return this.qJ(x);
});
$p.aJ = (function(x, default$1) {
  return this.qB(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_api_SubjectNameLeafPlanningSVG$$anon$2, "com.papasofokli.planning.api.SubjectNameLeafPlanningSVG$$anon$2", ({
  qU: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(subjectId, divisionData, subjectPeriods, detailedRows, timeLine, initialY, periodHeight, periodSvgIndicationsSetup, getAllRelevantPeriods, isDivisionSummary, getRowSeamanPeriods, getSubjectIdByPosition, executionContext) {
  this.sK = null;
  this.Ba = null;
  this.Fa = null;
  this.F8 = null;
  this.Fb = null;
  this.nJ = 0.0;
  this.x8 = 0.0;
  this.x9 = null;
  this.x6 = null;
  this.x7 = false;
  this.Bb = null;
  this.F9 = null;
  this.PA = 0;
  this.K1 = 0.0;
  this.m0 = null;
  this.Bc = null;
  this.Py = null;
  this.Pz = null;
  this.sK = subjectId;
  this.Ba = divisionData;
  this.Fa = subjectPeriods;
  this.F8 = detailedRows;
  this.Fb = timeLine;
  this.nJ = initialY;
  this.x8 = periodHeight;
  this.x9 = periodSvgIndicationsSetup;
  this.x6 = getAllRelevantPeriods;
  this.x7 = isDivisionSummary;
  this.Bb = getRowSeamanPeriods;
  this.F9 = getSubjectIdByPosition;
  this.PA = ((1 + detailedRows.F()) | 0);
  this.K1 = Math.fround((Math.fround((periodHeight * Math.fround(this.PA))) - 2.0));
  this.m0 = $m_ju_UUID$().aW();
  var initialYHorizontalLine = Math.fround((initialY + this.K1));
  var initialX2$1 = Math.fround(timeLine.m7.aA());
  this.Bc = new $c_Lcom_papasofokli_svg_components_LineComponent(((!isDivisionSummary) ? new $c_s_Some("horizontalLines") : $m_s_None$()), 0.0, initialYHorizontalLine, initialX2$1, initialYHorizontalLine, $m_s_None$(), $m_s_None$(), $m_Lcom_papasofokli_svg_components_LineComponent$().DK(), true, $m_s_None$(), $m_s_None$(), $m_s_Option$().Z(0.5), $m_s_None$(), $m_ju_UUID$().aW());
  this.Py = detailedRows.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var periodS = x$1$2.P();
      var index = (x$1$2.V() | 0);
      var initialYRow = Math.fround((initialY + Math.fround((Math.fround(((1 + index) | 0)) * periodHeight))));
      return periodS.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((period$2) => new $c_T2(period$2, new $c_Lcom_papasofokli_planning_api_PeriodSvg(period$2, initialYRow, periodHeight, timeLine, this.m0, new $c_s_Some(index), getAllRelevantPeriods, periodSvgIndicationsSetup, getSubjectIdByPosition, executionContext))))).fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
        if ((x$1$2$1 !== null)) {
          if ((x$1$2$1.P() !== null)) {
            return x$1$2$1.V().N0();
          }
        }
        throw new $c_s_MatchError(x$1$2$1);
      }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
        if ((x$1$2$2 !== null)) {
          if ((x$1$2$2.P() !== null)) {
            return x$1$2$2.V();
          }
        }
        throw new $c_s_MatchError(x$1$2$2);
      })));
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  this.Pz = subjectPeriods.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((period$2$1) => new $c_T2(period$2$1, new $c_Lcom_papasofokli_planning_api_PeriodSvg(period$2$1, initialY, periodHeight, timeLine, this.m0, $m_s_None$(), getAllRelevantPeriods, periodSvgIndicationsSetup, getSubjectIdByPosition, executionContext))))).fu(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$3) => {
    if ((x$1$2$3 !== null)) {
      if ((x$1$2$3.P() !== null)) {
        return x$1$2$3.V().N0();
      }
    }
    throw new $c_s_MatchError(x$1$2$3);
  }))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$4) => {
    if ((x$1$2$4 !== null)) {
      if ((x$1$2$4.P() !== null)) {
        return x$1$2$4.V();
      }
    }
    throw new $c_s_MatchError(x$1$2$4);
  })));
}
$p = $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG() {
}
$h_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 913805331);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Ba));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Fa));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.F8));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Fb));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.nJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.x8));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.x9));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.x6));
  acc = $m_sr_Statics$().d(acc, (this.x7 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bb));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.F9));
  return $m_sr_Statics$().an(acc, 12);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG)) {
    if ((((this.nJ === x$0.nJ) && (this.x8 === x$0.x8)) && (this.x7 === x$0.x7))) {
      var x = this.sK;
      var x$2 = x$0.sK;
      var $x_8 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$3 = this.Ba;
      var x$4 = x$0.Ba;
      var $x_7 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$5 = this.Fa;
      var x$6 = x$0.Fa;
      var $x_6 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$7 = this.F8;
      var x$8 = x$0.F8;
      var $x_5 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$9 = this.Fb;
      var x$10 = x$0.Fb;
      var $x_4 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$11 = this.x9;
      var x$12 = x$0.x9;
      var $x_3 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$13 = this.x6;
      var x$14 = x$0.x6;
      var $x_2 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$15 = this.Bb;
      var x$16 = x$0.Bb;
      var $x_1 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$17 = this.F9;
      var x$18 = x$0.F9;
      return ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 12;
});
$p.A = (function() {
  return "SubjectPlanningRowSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sK;
      break;
    }
    case 1: {
      return this.Ba;
      break;
    }
    case 2: {
      return this.Fa;
      break;
    }
    case 3: {
      return this.F8;
      break;
    }
    case 4: {
      return this.Fb;
      break;
    }
    case 5: {
      return this.nJ;
      break;
    }
    case 6: {
      return this.x8;
      break;
    }
    case 7: {
      return this.x9;
      break;
    }
    case 8: {
      return this.x6;
      break;
    }
    case 9: {
      return this.x7;
      break;
    }
    case 10: {
      return this.Bb;
      break;
    }
    case 11: {
      return this.F9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E6 = (function() {
  return Math.fround((this.x8 * Math.fround(this.PA)));
});
$p.zJ = (function() {
  var this$1 = this.Bc.ahy();
  var this$3 = (this$1.c() ? $m_s_None$() : new $c_s_Some(Math.fround((Math.fround(this$1.h()) - this.K1))));
  return Math.fround((this$3.c() ? this.nJ : this$3.h()));
});
$p.di = (function() {
  var cond = this.x7;
  var this$3 = (cond ? new $c_s_Some(new $c_Lcom_papasofokli_svg_components_FlattenSVG(new $c_sci_$colon$colon(this.Bc, $m_sci_Nil$())).xJ) : $m_s_None$());
  return (this$3.c() ? new $c_Lcom_papasofokli_svg_components_FlattenSVG(this.Pz.cH(this.Py).aV(this.Bc)).xJ : this$3.h());
});
$p.gd = (function(nextY) {
  this.Bb.p(this.m0).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    _$2$3.gd(nextY);
  })));
  var newYHorizontalLine = Math.fround((nextY + this.K1));
  $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this.Bc, $m_Lcom_papasofokli_planning_package$().nM);
  var newY1$1 = $m_s_Option$().Z(newYHorizontalLine);
  var newY2$1 = new $c_s_Some(newYHorizontalLine);
  var newX1$1 = $m_s_None$();
  var newX2$1 = $m_s_None$();
  this.Bc.aiU(newX1$1, newY1$1, newX2$1, newY2$1);
});
function $isArrayOf_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fy)));
}
var $d_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG, "com.papasofokli.planning.api.SubjectPlanningRowSVG", ({
  fy: 1,
  aj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1.prototype = $p;
$p.jt = (function(x) {
  return ((x !== null) || false);
});
$p.jk = (function(x, default$1) {
  return ((x !== null) ? x.id : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$1, "com.papasofokli.planning.api.TimeLineButtons$$anon$1", ({
  qW: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2() {
}
$p = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2() {
}
$h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2.prototype = $p;
$p.jt = (function(x) {
  return ((!(!(x instanceof HTMLElement))) || false);
});
$p.jk = (function(x, default$1) {
  return ((!(!(x instanceof HTMLElement))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$2, "com.papasofokli.planning.api.TimeLineButtons$$anon$2", ({
  qX: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3() {
}
$p = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3() {
}
$h_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3.prototype = $p;
$p.avp = (function(x) {
  return ((!(!(x instanceof HTMLDivElement))) || false);
});
$p.amR = (function(x, default$1) {
  return ((!(!(x instanceof HTMLDivElement))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.avp(x);
});
$p.aJ = (function(x, default$1) {
  return this.amR(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLineButtons$$anon$3, "com.papasofokli.planning.api.TimeLineButtons$$anon$3", ({
  qY: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1.prototype = $p;
$p.qJ = (function(x) {
  return ((!(!(x instanceof Element))) || false);
});
$p.qB = (function(x, default$1) {
  return ((!(!(x instanceof Element))) ? x.id : default$1.p(x));
});
$p.aU = (function(x) {
  return this.qJ(x);
});
$p.aJ = (function(x, default$1) {
  return this.qB(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$1, "com.papasofokli.planning.api.TimeLinePlanningSVG$$anon$1", ({
  r0: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2() {
}
$p = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2() {
}
$h_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2.prototype = $p;
$p.qJ = (function(x) {
  return ((!(!(x instanceof Element))) || false);
});
$p.qB = (function(x, default$1) {
  return ((!(!(x instanceof Element))) ? x.id : default$1.p(x));
});
$p.aU = (function(x) {
  return this.qJ(x);
});
$p.aJ = (function(x, default$1) {
  return this.qB(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_api_TimeLinePlanningSVG$$anon$2, "com.papasofokli.planning.api.TimeLinePlanningSVG$$anon$2", ({
  r1: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1() {
}
$p = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1() {
}
$h_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    var x2 = x.P();
    if ((x2 instanceof $c_s_Some)) {
      $uJ(x2.bg);
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x7 = x.P();
    if ((x7 instanceof $c_s_Some)) {
      var $x_1 = $uJ(x7.bg);
      var subjectId_$_lo = $x_1.l;
      var subjectId_$_hi = $x_1.h;
      return new $c_T2($bL(subjectId_$_lo, subjectId_$_hi), x.V().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((row$2) => new $c_Lcom_papasofokli_planning_RowData(row$2.m0, subjectId_$_lo, subjectId_$_hi, row$2.Ba)))));
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$1, "com.papasofokli.planning.api.mutations.ModificationsManager$$anon$1", ({
  r5: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2(rowUUID$7, index$3) {
  this.PS = null;
  this.PR = 0;
  this.PS = rowUUID$7;
  this.PR = index$3;
}
$p = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2() {
}
$h_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2.prototype = $p;
$p.avm = (function(x) {
  var x$3 = x.eK;
  var x$4 = this.PS;
  if ((((x$3 === null) ? (x$4 === null) : x$3.b(x$4)) && x.sC.az(this.PR))) {
    return true;
  } else {
    return false;
  }
});
$p.amO = (function(x, default$1) {
  var x$3 = x.eK;
  var x$4 = this.PS;
  if ((((x$3 === null) ? (x$4 === null) : x$3.b(x$4)) && x.sC.az(this.PR))) {
    return x;
  } else {
    return default$1.p(x);
  }
});
$p.aU = (function(x) {
  return this.avm(x);
});
$p.aJ = (function(x, default$1) {
  return this.amO(x, default$1);
});
var $d_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_planning_api_mutations_ModificationsManager$$anon$2, "com.papasofokli.planning.api.mutations.ModificationsManager$$anon$2", ({
  r6: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$2(WritersVersionSpecific_this$3, outer) {
  this.a51 = null;
  this.a51 = WritersVersionSpecific_this$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_popover_PopoverSetupData$$anon$2() {
}
$h_Lcom_papasofokli_popover_PopoverSetupData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiE = (function(v) {
  return ((((2 + ((((!$m_sr_BoxesRunTime$().B(v.m2, false)) | 0) + ((!$m_sr_BoxesRunTime$().B(v.m4, true)) | 0)) | 0)) | 0) + ((2 + ((((v.m1 !== "") | 0) + ((v.m3 !== "auto") | 0)) | 0)) | 0)) | 0);
});
$p.aBP = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiE(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.sO);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "content", $m_Lupickle_default$().m, v.sN);
    if ((!$m_sr_BoxesRunTime$().B(v.m2, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().aw, v.m2);
    }
    if ((!$m_sr_BoxesRunTime$().B(v.m4, true))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sanitize", $m_Lupickle_default$().aw, v.m4);
    }
    if ((v.m1 !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customClass", $m_Lupickle_default$().m, v.m1);
    }
    if ((v.m3 !== "auto")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "placement", $m_Lupickle_default$().m, v.m3);
    }
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dismissible", $m_Lupickle_default$().aw, v.xf);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tabIndex", $m_Lupickle_default$().ao, v.xg);
    return ctx.L((-1));
  }
});
$p.aEf = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "title", $m_Lupickle_default$().m, v.sO);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "content", $m_Lupickle_default$().m, v.sN);
  if ((!$m_sr_BoxesRunTime$().B(v.m2, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "html", $m_Lupickle_default$().aw, v.m2);
  }
  if ((!$m_sr_BoxesRunTime$().B(v.m4, true))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "sanitize", $m_Lupickle_default$().aw, v.m4);
  }
  if ((v.m1 !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "customClass", $m_Lupickle_default$().m, v.m1);
  }
  if ((v.m3 !== "auto")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "placement", $m_Lupickle_default$().m, v.m3);
  }
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "dismissible", $m_Lupickle_default$().aw, v.xf);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tabIndex", $m_Lupickle_default$().ao, v.xg);
});
$p.ah = (function(v) {
  return this.aiE(v);
});
$p.U = (function(out, v) {
  return this.aBP(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEf(ctx, v);
});
$p.T = (function() {
  return this.a51;
});
var $d_Lcom_papasofokli_popover_PopoverSetupData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_popover_PopoverSetupData$$anon$2, "com.papasofokli.popover.PopoverSetupData$$anon$2", ({
  rc: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_InitializeRating() {
}
$p = $c_Lcom_papasofokli_rating_InitializeRating.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_InitializeRating;
/** @constructor */
function $h_Lcom_papasofokli_rating_InitializeRating() {
}
$h_Lcom_papasofokli_rating_InitializeRating.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 157794669;
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_rating_InitializeRating) || false));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "InitializeRating";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_rating_InitializeRating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fE)));
}
var $d_Lcom_papasofokli_rating_InitializeRating = new $TypeData().i($c_Lcom_papasofokli_rating_InitializeRating, "com.papasofokli.rating.InitializeRating", ({
  fE: 1,
  ch: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_OptionChangedRating(value) {
  this.Bp = null;
  this.Bp = value;
}
$p = $c_Lcom_papasofokli_rating_OptionChangedRating.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_OptionChangedRating;
/** @constructor */
function $h_Lcom_papasofokli_rating_OptionChangedRating() {
}
$h_Lcom_papasofokli_rating_OptionChangedRating.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 2086525153, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_rating_OptionChangedRating)) {
    var x = this.Bp;
    var x$2 = x$0.Bp;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "OptionChangedRating";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Bp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_rating_OptionChangedRating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fF)));
}
var $d_Lcom_papasofokli_rating_OptionChangedRating = new $TypeData().i($c_Lcom_papasofokli_rating_OptionChangedRating, "com.papasofokli.rating.OptionChangedRating", ({
  fF: 1,
  ch: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$5(WritersVersionSpecific_this$14, outer) {
  this.a5d = null;
  this.a5d = WritersVersionSpecific_this$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingClientMessages$$anon$5() {
}
$h_Lcom_papasofokli_rating_RatingClientMessages$$anon$5.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBR = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.Bp);
    return ctx.L((-1));
  }
});
$p.aEg = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "value", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.Bp);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBR(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEg(ctx, v);
});
$p.T = (function() {
  return this.a5d;
});
var $d_Lcom_papasofokli_rating_RatingClientMessages$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingClientMessages$$anon$5, "com.papasofokli.rating.RatingClientMessages$$anon$5", ({
  rq: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$6(WritersVersionSpecific_this$15, outer) {
  this.a5e = null;
  this.a5e = WritersVersionSpecific_this$15;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingClientMessages$$anon$6() {
}
$h_Lcom_papasofokli_rating_RatingClientMessages$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBQ = (function(out, v) {
  return ((v === null) ? out.M((-1)) : out.K(0, true, (-1)).L((-1)));
});
$p.ah = (function(v) {
  return 0;
});
$p.U = (function(out, v) {
  return this.aBQ(out, v);
});
$p.ai = (function(ctx, v) {
});
$p.T = (function() {
  return this.a5e;
});
var $d_Lcom_papasofokli_rating_RatingClientMessages$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingClientMessages$$anon$6, "com.papasofokli.rating.RatingClientMessages$$anon$6", ({
  rr: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingInitialData$$anon$2(WritersVersionSpecific_this$13, outer) {
  this.a5h = null;
  this.a5h = WritersVersionSpecific_this$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_rating_RatingInitialData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_rating_RatingInitialData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingInitialData$$anon$2() {
}
$h_Lcom_papasofokli_rating_RatingInitialData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiF = (function(v) {
  return ((3 + ((!$m_sr_BoxesRunTime$().B(v.kd, false)) | 0)) | 0);
});
$p.aBS = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiF(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "initialValue", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.nN);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selections", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().mu, $m_Lupickle_default$().m, this$4), v.pA);
    if ((!$m_sr_BoxesRunTime$().B(v.kd, false))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "disabled", $m_Lupickle_default$().aw, v.kd);
    }
    $m_Lupickle_default$();
    $m_Lcom_papasofokli_util_IconUI$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.sQ);
    return ctx.L((-1));
  }
});
$p.aEh = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "initialValue", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().mu), v.nN);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "selections", new $c_Lupickle_implicits_Writers$$anon$20($m_Lupickle_default$().mu, $m_Lupickle_default$().m, this$4), v.pA);
  if ((!$m_sr_BoxesRunTime$().B(v.kd, false))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "disabled", $m_Lupickle_default$().aw, v.kd);
  }
  $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "icon", $f_Lupickle_core_Types$Writer__comap__F1__Lupickle_core_Types$Writer$MapWriter($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => _$1$2))), v.sQ);
});
$p.ah = (function(v) {
  return this.aiF(v);
});
$p.U = (function(out, v) {
  return this.aBS(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEh(ctx, v);
});
$p.T = (function() {
  return this.a5h;
});
var $d_Lcom_papasofokli_rating_RatingInitialData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingInitialData$$anon$2, "com.papasofokli.rating.RatingInitialData$$anon$2", ({
  ru: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2(WritersVersionSpecific_this$7, outer) {
  this.a5p = null;
  this.a5p = WritersVersionSpecific_this$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2() {
}
$h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiG = (function(v) {
  var x = v.nO;
  var x$2 = $m_s_None$();
  return ((8 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aBT = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiG(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftTitle", $m_Lupickle_default$().m, v.xl);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightTitle", $m_Lupickle_default$().m, v.xn);
    var this$4 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftListItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_sortable_SortableElement$().q(), this$4), v.sS);
    var this$6 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightListItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_sortable_SortableElement$().q(), this$6), v.sT);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftListUpdateFun", $m_Lupickle_default$().a1, v.xk);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightListUpdateFun", $m_Lupickle_default$().a1, v.xm);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFun", $m_Lupickle_default$().a1, v.ke);
    var this$11 = $m_Lupickle_default$();
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockedItemsIds", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$11), v.xj);
    var x = v.nO;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockedItemsMessage", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.nO);
    }
    return ctx.L((-1));
  }
});
$p.aEi = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftTitle", $m_Lupickle_default$().m, v.xl);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightTitle", $m_Lupickle_default$().m, v.xn);
  var this$4 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftListItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_sortable_SortableElement$().q(), this$4), v.sS);
  var this$6 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightListItems", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lcom_papasofokli_sortable_SortableElement$().q(), this$6), v.sT);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "leftListUpdateFun", $m_Lupickle_default$().a1, v.xk);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "rightListUpdateFun", $m_Lupickle_default$().a1, v.xm);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "contextMenuFun", $m_Lupickle_default$().a1, v.ke);
  var this$11 = $m_Lupickle_default$();
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockedItemsIds", new $c_Lupickle_implicits_LowPriWriters$$anon$22($m_Lupickle_default$().ay, this$11), v.xj);
  var x = v.nO;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "blockedItemsMessage", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.nO);
  }
});
$p.ah = (function(v) {
  return this.aiG(v);
});
$p.U = (function(out, v) {
  return this.aBT(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEi(ctx, v);
});
$p.T = (function() {
  return this.a5p;
});
var $d_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$2, "com.papasofokli.sortable.SortableConnectedListsSetupData$$anon$2", ({
  rC: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableElement$$anon$6(WritersVersionSpecific_this$9, outer) {
  this.a5s = null;
  this.a5s = WritersVersionSpecific_this$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_sortable_SortableElement$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableElement$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableElement$$anon$6() {
}
$h_Lcom_papasofokli_sortable_SortableElement$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiH = (function(v) {
  var x = v.m5;
  var x$2 = $m_s_None$();
  return ((2 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aBU = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiH(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.h9, v.ha));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.iV);
    var x = v.m5;
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.m5);
    }
    return ctx.L((-1));
  }
});
$p.aEj = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "recordId", $m_Lupickle_default$().ay, $bL(v.h9, v.ha));
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.iV);
  var x = v.m5;
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "description", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.m5);
  }
});
$p.ah = (function(v) {
  return this.aiH(v);
});
$p.U = (function(out, v) {
  return this.aBU(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEj(ctx, v);
});
$p.T = (function() {
  return this.a5s;
});
var $d_Lcom_papasofokli_sortable_SortableElement$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableElement$$anon$6, "com.papasofokli.sortable.SortableElement$$anon$6", ({
  rG: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1() {
}
$p = $c_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1() {
}
$h_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1.prototype = $p;
$p.qJ = (function(x) {
  return ((!(!(x instanceof Element))) || false);
});
$p.qB = (function(x, default$1) {
  return ((!(!(x instanceof Element))) ? (+(0, $m_Lcom_papasofokli_jquery_package$().I)(x).height()) : default$1.p(x));
});
$p.aU = (function(x) {
  return this.qJ(x);
});
$p.aJ = (function(x, default$1) {
  return this.qB(x, default$1);
});
var $d_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1, "com.papasofokli.svg.api.ForeignObjectContainer$$anon$1", ({
  rJ: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_HorizontalAnchor() {
}
$p = $c_Lcom_papasofokli_svg_components_HorizontalAnchor.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_HorizontalAnchor;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_HorizontalAnchor() {
}
$h_Lcom_papasofokli_svg_components_HorizontalAnchor.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $p_Lcom_papasofokli_svg_components_IconTextComponent__clickIcon__s_Option($thiz) {
  var this$1 = $thiz.pE;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$3) => (() => {
    $thiz.Cc.al(fun$3);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_IconTextComponent__dragRectangle__s_Option($thiz) {
  var this$1 = $thiz.pF;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$4) => (() => {
    fun$4.p($thiz.FD);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_IconTextComponent__composeMouseOutActions__s_Option__s_Option__s_Option($thiz, textMouseOutAction, mouseOut) {
  if (mouseOut.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = mouseOut.h();
    var this$2 = (textMouseOutAction.c() ? $m_s_None$() : new $c_s_Some($m_Lcom_papasofokli_svg_components_package$().asI(x0, textMouseOutAction.h())));
  }
  var this$3 = (this$2.c() ? mouseOut : this$2);
  return (this$3.c() ? textMouseOutAction : this$3);
}
function $p_Lcom_papasofokli_svg_components_IconTextComponent__composeHoverActions__s_Option__s_Option__s_Option($thiz, textOnHoverAction, hover) {
  if (hover.c()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = hover.h();
    var this$2 = (textOnHoverAction.c() ? $m_s_None$() : new $c_s_Some($m_Lcom_papasofokli_svg_components_package$().asH(x0, textOnHoverAction.h())));
  }
  var this$3 = (this$2.c() ? hover : this$2);
  return (this$3.c() ? textOnHoverAction : this$3);
}
function $p_Lcom_papasofokli_svg_components_IconTextComponent__totalWidth__F($thiz) {
  if ((!$thiz.a7f)) {
    $thiz.a7e = $m_Lcom_papasofokli_svg_api_TextSizeMeasure$().ahr($p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer($thiz));
    $thiz.a7f = true;
  }
  return $thiz.a7e;
}
function $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer($thiz) {
  if ((!$thiz.a7d)) {
    var dragStopFun$1 = $p_Lcom_papasofokli_svg_components_IconTextComponent__dragRectangle__s_Option($thiz);
    var dragStartFun$1 = $m_s_None$();
    var clickFun$2 = $m_s_None$();
    var onHover$1 = $m_s_None$();
    var onMouseOut$1 = $m_s_None$();
    var contextMenuFunction$1 = $m_s_None$();
    $thiz.a7c = new $c_Lcom_papasofokli_svg_api_ForeignObjectContainer($thiz.pI, $thiz.pJ, $thiz.Qc, $m_s_None$(), $m_s_None$(), $m_s_None$(), $thiz.pD, dragStartFun$1, dragStopFun$1, $thiz.pG, clickFun$2, $thiz.pH, onHover$1, onMouseOut$1, contextMenuFunction$1, $thiz.pK);
    $thiz.a7d = true;
    $thiz.Qc = null;
  }
  return $thiz.a7c;
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon, initialX, initialY, extraCssClass, generalTextHoverHtmlMap, dragFunction, clickFunction, draggingFunction, contextMenuFunction, getGroupedDraggedShapes, onHover, onMouseOut, isMovableOnDrag, href, appendWithAnimationTime, horizontalAnchor) {
  this.FC = null;
  this.pI = 0.0;
  this.pJ = 0.0;
  this.sW = null;
  this.sX = null;
  this.pF = null;
  this.pE = null;
  this.pG = null;
  this.sV = null;
  this.pH = null;
  this.xK = null;
  this.xL = null;
  this.pK = false;
  this.sZ = null;
  this.pD = null;
  this.sY = null;
  this.Cc = null;
  this.Qc = null;
  this.a7e = 0.0;
  this.a7f = false;
  this.Qb = 0.0;
  this.FD = null;
  this.a7c = null;
  this.a7d = false;
  this.FC = faIcon;
  this.pI = initialX;
  this.pJ = initialY;
  this.sW = extraCssClass;
  this.sX = generalTextHoverHtmlMap;
  this.pF = dragFunction;
  this.pE = clickFunction;
  this.pG = draggingFunction;
  this.sV = contextMenuFunction;
  this.pH = getGroupedDraggedShapes;
  this.xK = onHover;
  this.xL = onMouseOut;
  this.pK = isMovableOnDrag;
  this.sZ = href;
  this.pD = appendWithAnimationTime;
  this.sY = horizontalAnchor;
  this.Cc = faIcon.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2) => {
    var onHoverText = generalTextHoverHtmlMap.b9(t$2);
    if (onHoverText.c()) {
      var textOnHoverAction = $m_s_None$();
    } else {
      var x0 = onHoverText.h();
      var textOnHoverAction = new $c_s_Some($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), x0, $m_s_$less$colon$less$().b0)])).aB().outerHTML, true, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), $m_s_None$())));
    }
    var textMouseOutAction = (onHoverText.c() ? $m_s_None$() : new $c_s_Some((onHoverText.h(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
    })))));
    var onHoverAction = $p_Lcom_papasofokli_svg_components_IconTextComponent__composeHoverActions__s_Option__s_Option__s_Option(this, textOnHoverAction, onHover);
    var onMouseOutFunction = $p_Lcom_papasofokli_svg_components_IconTextComponent__composeMouseOutActions__s_Option__s_Option__s_Option(this, textMouseOutAction, onMouseOut);
    return new $c_Lcom_papasofokli_svg_api_ForeignSpan(t$2, (extraCssClass.c() ? $m_s_None$() : new $c_s_Some($f_T__trim__T(extraCssClass.h()))), new $c_s_Some("extra-padding-3"), contextMenuFunction, $p_Lcom_papasofokli_svg_components_IconTextComponent__clickIcon__s_Option(this), onHoverAction, onMouseOutFunction, ((t$2 instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon) ? t$2.t4 : $m_s_None$()));
  })));
  this.Qc = this.Cc.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$1) => {
    var this$20 = (href.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_svg_api_ForeignHyperLink(href.h(), new $c_sci_$colon$colon(t$2$1, $m_sci_Nil$()))));
    return (this$20.c() ? t$2$1 : this$20.h());
  })));
  matchResult5: {
    var $x_1;
    var x = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
    if (((x === null) ? (horizontalAnchor === null) : (x === horizontalAnchor))) {
      var $x_1 = 0.0;
      break matchResult5;
    }
    var x$3 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
    if (((x$3 === null) ? (horizontalAnchor === null) : (x$3 === horizontalAnchor))) {
      var $x_1 = Math.fround((0.5 * Math.fround((-$p_Lcom_papasofokli_svg_components_IconTextComponent__totalWidth__F(this)))));
      break matchResult5;
    }
    var x$5 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
    if (((x$5 === null) ? (horizontalAnchor === null) : (x$5 === horizontalAnchor))) {
      var $x_1 = Math.fround((-$p_Lcom_papasofokli_svg_components_IconTextComponent__totalWidth__F(this)));
      break matchResult5;
    }
    throw new $c_s_MatchError(horizontalAnchor);
  }
  this.Qb = $x_1;
  this.FD = ($p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this), new $c_Lcom_papasofokli_svg_api_ForeignObjectContainer(Math.fround((initialX + this.Qb)), $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xw, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).nP, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).sU, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xA, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xv, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xo, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xr, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xs, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xt, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xp, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xu, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xy, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xz, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xq, $p_Lcom_papasofokli_svg_components_IconTextComponent__foreignObjectContainer__Lcom_papasofokli_svg_api_ForeignObjectContainer(this).xx));
}
$p = $c_Lcom_papasofokli_svg_components_IconTextComponent.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_IconTextComponent;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_IconTextComponent() {
}
$h_Lcom_papasofokli_svg_components_IconTextComponent.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 735672887);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sX));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pE));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pG));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xL));
  acc = $m_sr_Statics$().d(acc, (this.pK ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sZ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sY));
  return $m_sr_Statics$().an(acc, 16);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_IconTextComponent)) {
    if ((((this.pI === x$0.pI) && (this.pJ === x$0.pJ)) && (this.pK === x$0.pK))) {
      var x = this.FC;
      var x$2 = x$0.FC;
      var $x_12 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$3 = this.sW;
      var x$4 = x$0.sW;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.sX;
      var x$6 = x$0.sX;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.pF;
      var x$8 = x$0.pF;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.pE;
      var x$10 = x$0.pE;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.pG;
      var x$12 = x$0.pG;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.sV;
      var x$14 = x$0.sV;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.pH;
      var x$16 = x$0.pH;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : (x$15 === x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.xK;
      var x$18 = x$0.xK;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.xL;
      var x$20 = x$0.xL;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.sZ;
      var x$22 = x$0.sZ;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.pD;
      var x$24 = x$0.pD;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$25 = this.sY;
      var x$26 = x$0.sY;
      return ((x$25 === null) ? (x$26 === null) : (x$25 === x$26));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 16;
});
$p.A = (function() {
  return "IconTextComponent";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.FC;
      break;
    }
    case 1: {
      return this.pI;
      break;
    }
    case 2: {
      return this.pJ;
      break;
    }
    case 3: {
      return this.sW;
      break;
    }
    case 4: {
      return this.sX;
      break;
    }
    case 5: {
      return this.pF;
      break;
    }
    case 6: {
      return this.pE;
      break;
    }
    case 7: {
      return this.pG;
      break;
    }
    case 8: {
      return this.sV;
      break;
    }
    case 9: {
      return this.pH;
      break;
    }
    case 10: {
      return this.xK;
      break;
    }
    case 11: {
      return this.xL;
      break;
    }
    case 12: {
      return this.pK;
      break;
    }
    case 13: {
      return this.sZ;
      break;
    }
    case 14: {
      return this.pD;
      break;
    }
    case 15: {
      return this.sY;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.afv = (function(cl) {
  this.Cc.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__addClass__T__V(_$1$3, cl);
  })));
});
$p.ajl = (function(cl) {
  this.Cc.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
    $f_Lcom_papasofokli_svg_api_GeneralShape__removeClass__T__V(_$2$3, cl);
  })));
});
$p.VA = (function() {
  this.Cc.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
    _$3$3.VA();
  })));
});
$p.cT = (function(newX, newY) {
  this.FD.cT(Math.fround((newX + this.Qb)), newY);
});
$p.uv = (function() {
  return $m_Lcom_papasofokli_svg_api_TextSizeMeasure$().ahr(this.FD);
});
$p.A7 = (function(maxWidth) {
  return ((maxWidth >= this.uv()) ? new $c_s_Some(this) : $m_s_None$());
});
$p.di = (function() {
  return new $c_sci_$colon$colon(this.FD, $m_sci_Nil$());
});
function $isArrayOf_Lcom_papasofokli_svg_components_IconTextComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fU)));
}
var $d_Lcom_papasofokli_svg_components_IconTextComponent = new $TypeData().i($c_Lcom_papasofokli_svg_components_IconTextComponent, "com.papasofokli.svg.components.IconTextComponent", ({
  fU: 1,
  aj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_LeftBound(rectangleSVG, dragEndFunction, onHoverFunction) {
  this.a7g = null;
  this.a7h = false;
  this.a7i = null;
  this.a7j = false;
  this.fW = null;
  this.FE = null;
  this.FF = null;
  this.fW = rectangleSVG;
  this.FE = dragEndFunction;
  this.FF = onHoverFunction;
}
$p = $c_Lcom_papasofokli_svg_components_LeftBound.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_LeftBound;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_LeftBound() {
}
$h_Lcom_papasofokli_svg_components_LeftBound.prototype = $p;
$p.Mo = (function() {
  if ((!this.a7h)) {
    this.a7g = $f_Lcom_papasofokli_svg_components_RectangleBounds__com$papasofokli$svg$components$RectangleBounds$$dragStartFunction__s_Option(this);
    this.a7h = true;
  }
  return this.a7g;
});
$p.zR = (function() {
  if ((!this.a7j)) {
    this.a7i = $f_Lcom_papasofokli_svg_components_RectangleBounds__lineSVG__Lcom_papasofokli_svg_api_LineSVG(this);
    this.a7j = true;
  }
  return this.a7i;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1950203515), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_LeftBound)) {
    var x = this.fW;
    var x$2 = x$0.fW;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.FE;
      var x$4 = x$0.FE;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.FF;
      var x$6 = x$0.FF;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "LeftBound";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.fW;
      break;
    }
    case 1: {
      return this.FE;
      break;
    }
    case 2: {
      return this.FF;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ew = (function() {
  return this.fW;
});
$p.Mw = (function() {
  return this.FE;
});
$p.Nc = (function() {
  return this.FF;
});
$p.Na = (function(dx, \u03b4times) {
  this.fW.axl(dx);
});
$p.gH = (function() {
  return "resizeLine ew";
});
$p.MW = (function() {
  return this.fW.go;
});
$p.Ef = (function() {
  return this.fW.fV;
});
$p.zL = (function() {
  return this.fW.go;
});
$p.MX = (function() {
  return Math.fround((this.fW.fV + this.fW.pB));
});
$p.E7 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.fW, "x");
  return Math.fround((this$2.c() ? this.fW.go : this$2.h()));
});
$p.E8 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.fW, "y");
  return Math.fround((this$2.c() ? this.fW.fV : this$2.h()));
});
$p.MN = (function() {
  return this.E7();
});
$p.MO = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.fW, "y");
  if (this$2.c()) {
    var newY1 = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var y$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.fW, "height");
    var newY1 = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((y$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newY1.c() ? this.fW.fV : newY1.h()));
});
function $isArrayOf_Lcom_papasofokli_svg_components_LeftBound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fV)));
}
var $d_Lcom_papasofokli_svg_components_LeftBound = new $TypeData().i($c_Lcom_papasofokli_svg_components_LeftBound, "com.papasofokli.svg.components.LeftBound", ({
  fV: 1,
  bK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_LowerBound(rectangleSVG, dragEndFunction, onHoverFunction) {
  this.a7q = null;
  this.a7r = false;
  this.a7s = null;
  this.a7t = false;
  this.gp = null;
  this.FG = null;
  this.FH = null;
  this.gp = rectangleSVG;
  this.FG = dragEndFunction;
  this.FH = onHoverFunction;
}
$p = $c_Lcom_papasofokli_svg_components_LowerBound.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_LowerBound;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_LowerBound() {
}
$h_Lcom_papasofokli_svg_components_LowerBound.prototype = $p;
$p.Mo = (function() {
  if ((!this.a7r)) {
    this.a7q = $f_Lcom_papasofokli_svg_components_RectangleBounds__com$papasofokli$svg$components$RectangleBounds$$dragStartFunction__s_Option(this);
    this.a7r = true;
  }
  return this.a7q;
});
$p.zR = (function() {
  if ((!this.a7t)) {
    this.a7s = $f_Lcom_papasofokli_svg_components_RectangleBounds__lineSVG__Lcom_papasofokli_svg_api_LineSVG(this);
    this.a7t = true;
  }
  return this.a7s;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1203570063, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_LowerBound)) {
    var x = this.gp;
    var x$2 = x$0.gp;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.FG;
      var x$4 = x$0.FG;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.FH;
      var x$6 = x$0.FH;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "LowerBound";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.gp;
      break;
    }
    case 1: {
      return this.FG;
      break;
    }
    case 2: {
      return this.FH;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ew = (function() {
  return this.gp;
});
$p.Mw = (function() {
  return this.FG;
});
$p.Nc = (function() {
  return this.FH;
});
$p.Na = (function(dx, dy) {
  this.gp.axj(dx, dy);
});
$p.gH = (function() {
  return "resizeLine ns";
});
$p.MW = (function() {
  return this.gp.go;
});
$p.Ef = (function() {
  return Math.fround((this.gp.fV + this.gp.pB));
});
$p.zL = (function() {
  return Math.fround((this.gp.go + this.gp.nQ));
});
$p.MX = (function() {
  return this.Ef();
});
$p.E7 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gp, "x");
  return Math.fround((this$2.c() ? this.gp.go : this$2.h()));
});
$p.E8 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gp, "y");
  if (this$2.c()) {
    var newY1 = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var y$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gp, "height");
    var newY1 = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((y$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newY1.c() ? this.Ef() : newY1.h()));
});
$p.MN = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gp, "x");
  if (this$2.c()) {
    var newX2O = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var x$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gp, "width");
    var newX2O = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((x$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newX2O.c() ? this.zL() : newX2O.h()));
});
$p.MO = (function() {
  return this.E8();
});
function $isArrayOf_Lcom_papasofokli_svg_components_LowerBound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fW)));
}
var $d_Lcom_papasofokli_svg_components_LowerBound = new $TypeData().i($c_Lcom_papasofokli_svg_components_LowerBound, "com.papasofokli.svg.components.LowerBound", ({
  fW: 1,
  bK: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_components_RectComponent__dragRectangle__s_Option($thiz) {
  var this$1 = $thiz.Ce;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$3) => (() => {
    $p_Lcom_papasofokli_svg_components_RectComponent__dragRectAction__F1__V($thiz, fun$3);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_RectComponent__dragRectAction__F1__V($thiz, fun) {
  fun.p($thiz.gY);
  $p_Lcom_papasofokli_svg_components_RectComponent__resetBounds__V($thiz);
}
function $p_Lcom_papasofokli_svg_components_RectComponent__resetBoundsAndExecute__F1__F1($thiz, function$1) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((rectangleSVG$3) => {
    $p_Lcom_papasofokli_svg_components_RectComponent__resetBounds__V($thiz);
    function$1.p(rectangleSVG$3);
  }));
}
function $p_Lcom_papasofokli_svg_components_RectComponent__clickRectangle__s_Option($thiz) {
  var this$1 = $thiz.Cd;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$4) => (() => {
    fun$4.p($thiz.gY);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_RectComponent__resetBounds__V($thiz) {
  $thiz.Qd.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => {
    $f_Lcom_papasofokli_svg_components_RectangleBounds__refreshBound__V(_$1$3);
  })));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName, initialHeight, initialWidth, initialX, initialY, resizeUpFunction, resizeDownFunction, resizeLeftFunction, resizeRightFunction, dragFunction, clickFunction, contextMenuFunction, getGroupedDraggedShapes, onHover, onMouseOut, isMovableOnDrag, href, appendWithAnimationTime, color, stroke, onBoundHover) {
  this.FN = null;
  this.FO = 0.0;
  this.FP = 0.0;
  this.Cf = 0.0;
  this.Cg = 0.0;
  this.FX = null;
  this.FU = null;
  this.FV = null;
  this.FW = null;
  this.Ce = null;
  this.Cd = null;
  this.FK = null;
  this.FL = null;
  this.FS = null;
  this.FT = null;
  this.FQ = false;
  this.FM = null;
  this.FI = null;
  this.FJ = null;
  this.FY = null;
  this.FR = null;
  this.gY = null;
  this.Qd = null;
  this.a7u = null;
  this.FN = initialClassName;
  this.FO = initialHeight;
  this.FP = initialWidth;
  this.Cf = initialX;
  this.Cg = initialY;
  this.FX = resizeUpFunction;
  this.FU = resizeDownFunction;
  this.FV = resizeLeftFunction;
  this.FW = resizeRightFunction;
  this.Ce = dragFunction;
  this.Cd = clickFunction;
  this.FK = contextMenuFunction;
  this.FL = getGroupedDraggedShapes;
  this.FS = onHover;
  this.FT = onMouseOut;
  this.FQ = isMovableOnDrag;
  this.FM = href;
  this.FI = appendWithAnimationTime;
  this.FJ = color;
  this.FY = stroke;
  this.FR = onBoundHover;
  this.gY = new $c_Lcom_papasofokli_svg_api_RectangleSVG(initialClassName, initialHeight, initialWidth, initialX, initialY, appendWithAnimationTime, $m_s_None$(), $p_Lcom_papasofokli_svg_components_RectComponent__dragRectangle__s_Option(this), $m_s_None$(), $p_Lcom_papasofokli_svg_components_RectComponent__clickRectangle__s_Option(this), getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag, color, stroke);
  if (resizeUpFunction.c()) {
    var upperBound = $m_s_None$();
  } else {
    var x0 = resizeUpFunction.h();
    var upperBound = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_UpperBound(this.gY, $p_Lcom_papasofokli_svg_components_RectComponent__resetBoundsAndExecute__F1__F1(this, x0), onBoundHover));
  }
  if (resizeDownFunction.c()) {
    var lowerBound = $m_s_None$();
  } else {
    var x0$1 = resizeDownFunction.h();
    var lowerBound = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_LowerBound(this.gY, $p_Lcom_papasofokli_svg_components_RectComponent__resetBoundsAndExecute__F1__F1(this, x0$1), onBoundHover));
  }
  if (resizeLeftFunction.c()) {
    var leftBound = $m_s_None$();
  } else {
    var x0$2 = resizeLeftFunction.h();
    var leftBound = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_LeftBound(this.gY, $p_Lcom_papasofokli_svg_components_RectComponent__resetBoundsAndExecute__F1__F1(this, x0$2), onBoundHover));
  }
  if (resizeRightFunction.c()) {
    var rightBound = $m_s_None$();
  } else {
    var x0$3 = resizeRightFunction.h();
    var rightBound = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_RightBound(this.gY, $p_Lcom_papasofokli_svg_components_RectComponent__resetBoundsAndExecute__F1__F1(this, x0$3), onBoundHover));
  }
  this.Qd = $m_s_Option$().hi(upperBound).cf().cH(lowerBound).dt(leftBound).dt(rightBound);
  var this$17 = (href.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_svg_api_SvgHyperLink(href.h(), new $c_sci_$colon$colon(this.gY, $m_sci_Nil$()))));
  this.a7u = (this$17.c() ? this.gY : this$17.h());
}
$p = $c_Lcom_papasofokli_svg_components_RectComponent.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_RectComponent;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_RectComponent() {
}
$h_Lcom_papasofokli_svg_components_RectComponent.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-657984679));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.FO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.FP));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Cf));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Cg));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FX));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Ce));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Cd));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FT));
  acc = $m_sr_Statics$().d(acc, (this.FQ ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.FR));
  return $m_sr_Statics$().an(acc, 21);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_RectComponent)) {
    if ((((((this.FO === x$0.FO) && (this.FP === x$0.FP)) && (this.Cf === x$0.Cf)) && (this.Cg === x$0.Cg)) && (this.FQ === x$0.FQ))) {
      var x = this.FN;
      var x$2 = x$0.FN;
      var $x_15 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$3 = this.FX;
      var x$4 = x$0.FX;
      var $x_14 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$5 = this.FU;
      var x$6 = x$0.FU;
      var $x_13 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$7 = this.FV;
      var x$8 = x$0.FV;
      var $x_12 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$9 = this.FW;
      var x$10 = x$0.FW;
      var $x_11 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$11 = this.Ce;
      var x$12 = x$0.Ce;
      var $x_10 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$13 = this.Cd;
      var x$14 = x$0.Cd;
      var $x_9 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$15 = this.FK;
      var x$16 = x$0.FK;
      var $x_8 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$17 = this.FL;
      var x$18 = x$0.FL;
      var $x_7 = ((x$17 === null) ? (x$18 === null) : (x$17 === x$18));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$19 = this.FS;
      var x$20 = x$0.FS;
      var $x_6 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$21 = this.FT;
      var x$22 = x$0.FT;
      var $x_5 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$23 = this.FM;
      var x$24 = x$0.FM;
      var $x_4 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$25 = this.FI;
      var x$26 = x$0.FI;
      var $x_3 = ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$27 = this.FJ;
      var x$28 = x$0.FJ;
      var $x_2 = ((x$27 === null) ? (x$28 === null) : x$27.b(x$28));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$29 = this.FY;
      var x$30 = x$0.FY;
      var $x_1 = ((x$29 === null) ? (x$30 === null) : x$29.b(x$30));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$31 = this.FR;
      var x$32 = x$0.FR;
      return ((x$31 === null) ? (x$32 === null) : x$31.b(x$32));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 21;
});
$p.A = (function() {
  return "RectComponent";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.FN;
      break;
    }
    case 1: {
      return this.FO;
      break;
    }
    case 2: {
      return this.FP;
      break;
    }
    case 3: {
      return this.Cf;
      break;
    }
    case 4: {
      return this.Cg;
      break;
    }
    case 5: {
      return this.FX;
      break;
    }
    case 6: {
      return this.FU;
      break;
    }
    case 7: {
      return this.FV;
      break;
    }
    case 8: {
      return this.FW;
      break;
    }
    case 9: {
      return this.Ce;
      break;
    }
    case 10: {
      return this.Cd;
      break;
    }
    case 11: {
      return this.FK;
      break;
    }
    case 12: {
      return this.FL;
      break;
    }
    case 13: {
      return this.FS;
      break;
    }
    case 14: {
      return this.FT;
      break;
    }
    case 15: {
      return this.FQ;
      break;
    }
    case 16: {
      return this.FM;
      break;
    }
    case 17: {
      return this.FI;
      break;
    }
    case 18: {
      return this.FJ;
      break;
    }
    case 19: {
      return this.FY;
      break;
    }
    case 20: {
      return this.FR;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ahx = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gY, "y");
});
$p.Ez = (function(w) {
  this.gY.Ez(w);
});
$p.gN = (function(h) {
  this.gY.gN(h);
});
$p.ahs = (function() {
  return $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gY, "height");
});
$p.cT = (function(newX, newY) {
  this.gY.cT(newX, newY);
});
$p.zS = (function(newX, newY) {
  this.gY.zS(newX, newY);
});
$p.Em = (function() {
  $f_Lcom_papasofokli_svg_api_GeneralShape__appendOnTop__V(this.gY);
  $p_Lcom_papasofokli_svg_components_RectComponent__resetBounds__V(this);
});
$p.di = (function() {
  return new $c_sci_$colon$colon(this.a7u, $m_sci_Nil$()).cY(this.Qd.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => _$2$2.zR()))));
});
function $isArrayOf_Lcom_papasofokli_svg_components_RectComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fX)));
}
var $d_Lcom_papasofokli_svg_components_RectComponent = new $TypeData().i($c_Lcom_papasofokli_svg_components_RectComponent, "com.papasofokli.svg.components.RectComponent", ({
  fX: 1,
  aj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_RightBound(rectangleSVG, dragEndFunction, onHoverFunction) {
  this.a7v = null;
  this.a7w = false;
  this.a7x = null;
  this.a7y = false;
  this.ff = null;
  this.FZ = null;
  this.G0 = null;
  this.ff = rectangleSVG;
  this.FZ = dragEndFunction;
  this.G0 = onHoverFunction;
}
$p = $c_Lcom_papasofokli_svg_components_RightBound.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_RightBound;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_RightBound() {
}
$h_Lcom_papasofokli_svg_components_RightBound.prototype = $p;
$p.Mo = (function() {
  if ((!this.a7w)) {
    this.a7v = $f_Lcom_papasofokli_svg_components_RectangleBounds__com$papasofokli$svg$components$RectangleBounds$$dragStartFunction__s_Option(this);
    this.a7w = true;
  }
  return this.a7v;
});
$p.zR = (function() {
  if ((!this.a7y)) {
    this.a7x = $f_Lcom_papasofokli_svg_components_RectangleBounds__lineSVG__Lcom_papasofokli_svg_api_LineSVG(this);
    this.a7y = true;
  }
  return this.a7x;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-627731110), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_RightBound)) {
    var x = this.ff;
    var x$2 = x$0.ff;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.FZ;
      var x$4 = x$0.FZ;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.G0;
      var x$6 = x$0.G0;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "RightBound";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.ff;
      break;
    }
    case 1: {
      return this.FZ;
      break;
    }
    case 2: {
      return this.G0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ew = (function() {
  return this.ff;
});
$p.Mw = (function() {
  return this.FZ;
});
$p.Nc = (function() {
  return this.G0;
});
$p.Na = (function(dx, dy) {
  this.ff.axm(dx, dy);
});
$p.gH = (function() {
  return "resizeLine ew";
});
$p.MW = (function() {
  return Math.fround((this.ff.go + this.ff.nQ));
});
$p.Ef = (function() {
  return this.ff.fV;
});
$p.zL = (function() {
  return Math.fround((this.ff.go + this.ff.nQ));
});
$p.MX = (function() {
  return Math.fround((this.ff.fV + this.ff.pB));
});
$p.E7 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.ff, "x");
  if (this$2.c()) {
    var newX2O = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var x$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.ff, "width");
    var newX2O = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((x$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newX2O.c() ? this.zL() : newX2O.h()));
});
$p.E8 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.ff, "y");
  return Math.fround((this$2.c() ? this.ff.fV : this$2.h()));
});
$p.MN = (function() {
  return this.E7();
});
$p.MO = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.ff, "y");
  if (this$2.c()) {
    var newY1 = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var y$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.ff, "height");
    var newY1 = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((y$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newY1.c() ? this.ff.fV : newY1.h()));
});
function $isArrayOf_Lcom_papasofokli_svg_components_RightBound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fY)));
}
var $d_Lcom_papasofokli_svg_components_RightBound = new $TypeData().i($c_Lcom_papasofokli_svg_components_RightBound, "com.papasofokli.svg.components.RightBound", ({
  fY: 1,
  bK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1() {
}
$p = $c_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1() {
}
$h_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1.prototype = $p;
$p.avn = (function(x) {
  return ($is_Lcom_papasofokli_svg_actions_ActionsShape(x) || false);
});
$p.amP = (function(x, default$1) {
  return ($is_Lcom_papasofokli_svg_actions_ActionsShape(x) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.avn(x);
});
$p.aJ = (function(x, default$1) {
  return this.amP(x, default$1);
});
var $d_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_svg_components_SvgDragGrouping$$anon$1, "com.papasofokli.svg.components.SvgDragGrouping$$anon$1", ({
  rX: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_components_TextComponent__dragText__s_Option($thiz) {
  var this$1 = $thiz.nS;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$3) => (() => {
    fun$3.p($thiz.xN);
  }))(this$1.h()))));
}
function $p_Lcom_papasofokli_svg_components_TextComponent__clickText__s_Option($thiz) {
  var this$1 = $thiz.nR;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((fun$4) => (() => {
    fun$4.p($thiz.xN);
  }))(this$1.h()))));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName, text, initialX, initialY, textLength, lengthAdjust, dragFunction, clickFunction, appendWithAnimationTime, getGroupedDraggedShapes, isMovableOnDrag, onHover, onMouseOut, contextMenuFunction, href, color, stroke) {
  this.xM = null;
  this.t0 = null;
  this.m6 = 0.0;
  this.nT = 0.0;
  this.pW = null;
  this.pS = null;
  this.nS = null;
  this.nR = null;
  this.pM = null;
  this.pP = null;
  this.pR = false;
  this.pT = null;
  this.pU = null;
  this.pO = null;
  this.pQ = null;
  this.pN = null;
  this.pV = null;
  this.xN = null;
  this.a7z = null;
  this.xM = initialClassName;
  this.t0 = text;
  this.m6 = initialX;
  this.nT = initialY;
  this.pW = textLength;
  this.pS = lengthAdjust;
  this.nS = dragFunction;
  this.nR = clickFunction;
  this.pM = appendWithAnimationTime;
  this.pP = getGroupedDraggedShapes;
  this.pR = isMovableOnDrag;
  this.pT = onHover;
  this.pU = onMouseOut;
  this.pO = contextMenuFunction;
  this.pQ = href;
  this.pN = color;
  this.pV = stroke;
  this.xN = new $c_Lcom_papasofokli_svg_api_TextSVG(initialClassName, text, initialX, initialY, textLength, lengthAdjust, appendWithAnimationTime, $m_s_None$(), $p_Lcom_papasofokli_svg_components_TextComponent__dragText__s_Option(this), $m_s_None$(), $p_Lcom_papasofokli_svg_components_TextComponent__clickText__s_Option(this), getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag, color, stroke);
  var this$6 = (href.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_svg_api_SvgHyperLink(href.h(), new $c_sci_$colon$colon(this.xN, $m_sci_Nil$()))));
  this.a7z = (this$6.c() ? this.xN : this$6.h());
}
$p = $c_Lcom_papasofokli_svg_components_TextComponent.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_TextComponent;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_TextComponent() {
}
$h_Lcom_papasofokli_svg_components_TextComponent.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-326063568));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.t0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.m6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.nT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pP));
  acc = $m_sr_Statics$().d(acc, (this.pR ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pO));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pV));
  return $m_sr_Statics$().an(acc, 17);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_TextComponent)) {
    if ((((this.m6 === x$0.m6) && (this.nT === x$0.nT)) && (this.pR === x$0.pR))) {
      var x = this.xM;
      var x$2 = x$0.xM;
      var $x_12 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_12 = false;
    }
    if (($x_12 && (this.t0 === x$0.t0))) {
      var x$3 = this.pW;
      var x$4 = x$0.pW;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.pS;
      var x$6 = x$0.pS;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.nS;
      var x$8 = x$0.nS;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.nR;
      var x$10 = x$0.nR;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.pM;
      var x$12 = x$0.pM;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.pP;
      var x$14 = x$0.pP;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : (x$13 === x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.pT;
      var x$16 = x$0.pT;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.pU;
      var x$18 = x$0.pU;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.pO;
      var x$20 = x$0.pO;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.pQ;
      var x$22 = x$0.pQ;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.pN;
      var x$24 = x$0.pN;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$25 = this.pV;
      var x$26 = x$0.pV;
      return ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 17;
});
$p.A = (function() {
  return "TextComponent";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.xM;
      break;
    }
    case 1: {
      return this.t0;
      break;
    }
    case 2: {
      return this.m6;
      break;
    }
    case 3: {
      return this.nT;
      break;
    }
    case 4: {
      return this.pW;
      break;
    }
    case 5: {
      return this.pS;
      break;
    }
    case 6: {
      return this.nS;
      break;
    }
    case 7: {
      return this.nR;
      break;
    }
    case 8: {
      return this.pM;
      break;
    }
    case 9: {
      return this.pP;
      break;
    }
    case 10: {
      return this.pR;
      break;
    }
    case 11: {
      return this.pT;
      break;
    }
    case 12: {
      return this.pU;
      break;
    }
    case 13: {
      return this.pO;
      break;
    }
    case 14: {
      return this.pQ;
      break;
    }
    case 15: {
      return this.pN;
      break;
    }
    case 16: {
      return this.pV;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cT = (function(newX, newY) {
  this.xN.cT(newX, newY);
});
$p.Uy = (function() {
  var this$1 = this.xN;
  return $m_Lcom_papasofokli_svg_api_TextSizeMeasure$().aur(this$1);
});
$p.A7 = (function(width) {
  return (this.ahN(width) ? $m_s_Option$().Z(this) : $m_s_None$());
});
$p.ahN = (function(width) {
  return (Math.fround((width - this.Uy())) > 10.0);
});
$p.di = (function() {
  return new $c_sci_$colon$colon(this.a7z, $m_sci_Nil$());
});
function $isArrayOf_Lcom_papasofokli_svg_components_TextComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fZ)));
}
var $d_Lcom_papasofokli_svg_components_TextComponent = new $TypeData().i($c_Lcom_papasofokli_svg_components_TextComponent, "com.papasofokli.svg.components.TextComponent", ({
  fZ: 1,
  aj: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_components_UpperBound(rectangleSVG, dragEndFunction, onHoverFunction) {
  this.a7A = null;
  this.a7B = false;
  this.a7C = null;
  this.a7D = false;
  this.gq = null;
  this.G1 = null;
  this.G2 = null;
  this.gq = rectangleSVG;
  this.G1 = dragEndFunction;
  this.G2 = onHoverFunction;
}
$p = $c_Lcom_papasofokli_svg_components_UpperBound.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_components_UpperBound;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_UpperBound() {
}
$h_Lcom_papasofokli_svg_components_UpperBound.prototype = $p;
$p.Mo = (function() {
  if ((!this.a7B)) {
    this.a7A = $f_Lcom_papasofokli_svg_components_RectangleBounds__com$papasofokli$svg$components$RectangleBounds$$dragStartFunction__s_Option(this);
    this.a7B = true;
  }
  return this.a7A;
});
$p.zR = (function() {
  if ((!this.a7D)) {
    this.a7C = $f_Lcom_papasofokli_svg_components_RectangleBounds__lineSVG__Lcom_papasofokli_svg_api_LineSVG(this);
    this.a7D = true;
  }
  return this.a7C;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-2112672067), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_components_UpperBound)) {
    var x = this.gq;
    var x$2 = x$0.gq;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.G1;
      var x$4 = x$0.G1;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.G2;
      var x$6 = x$0.G2;
      return ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "UpperBound";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.gq;
      break;
    }
    case 1: {
      return this.G1;
      break;
    }
    case 2: {
      return this.G2;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ew = (function() {
  return this.gq;
});
$p.Mw = (function() {
  return this.G1;
});
$p.Nc = (function() {
  return this.G2;
});
$p.Na = (function(dx, dy) {
  this.gq.axo(dx, dy);
});
$p.gH = (function() {
  return "resizeLine ns";
});
$p.MW = (function() {
  return this.gq.go;
});
$p.Ef = (function() {
  return this.gq.fV;
});
$p.zL = (function() {
  return Math.fround((this.gq.go + this.gq.nQ));
});
$p.MX = (function() {
  return this.gq.fV;
});
$p.E7 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gq, "x");
  return Math.fround((this$2.c() ? this.gq.go : this$2.h()));
});
$p.E8 = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gq, "y");
  return Math.fround((this$2.c() ? this.gq.fV : this$2.h()));
});
$p.MN = (function() {
  var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gq, "x");
  if (this$2.c()) {
    var newX2O = $m_s_None$();
  } else {
    var x0 = this$2.h();
    var x$2 = Math.fround(x0);
    var this$4 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this.gq, "width");
    var newX2O = (this$4.c() ? $m_s_None$() : new $c_s_Some(Math.fround((x$2 + Math.fround(this$4.h())))));
  }
  return Math.fround((newX2O.c() ? this.zL() : newX2O.h()));
});
$p.MO = (function() {
  return this.E8();
});
function $isArrayOf_Lcom_papasofokli_svg_components_UpperBound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g0)));
}
var $d_Lcom_papasofokli_svg_components_UpperBound = new $TypeData().i($c_Lcom_papasofokli_svg_components_UpperBound, "com.papasofokli.svg.components.UpperBound", ({
  g0: 1,
  bK: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval(minutesSeparation) {
  this.t1 = 0;
  this.t1 = minutesSeparation;
}
$p = $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_MinutesTickInterval() {
}
$h_Lcom_papasofokli_svg_timeline_MinutesTickInterval.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1685622753);
  acc = $m_sr_Statics$().d(acc, this.t1);
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval) && (this.t1 === x$0.t1)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "MinutesTickInterval";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.t1;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.kJ = (function(date) {
  return ("" + ((+date.getUTCMinutes()) + this.t1));
});
$p.mB = (function() {
  return $m_s_Option$().Z("svg-timelinetext-small");
});
$p.oO = (function(date) {
  return false;
});
$p.oW = (function(date) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().afw(date, this.t1);
});
$p.oL = (function(startDate) {
  return $m_Lcom_papasofokli_util_DateUtilsJS$().auh(startDate, this.t1);
});
function $isArrayOf_Lcom_papasofokli_svg_timeline_MinutesTickInterval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g1)));
}
var $d_Lcom_papasofokli_svg_timeline_MinutesTickInterval = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_MinutesTickInterval, "com.papasofokli.svg.timeline.MinutesTickInterval", ({
  g1: 1,
  aI: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2() {
}
$p = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2() {
}
$h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  x.Eu($m_jl_System$Streams$().xX);
  $m_Lcom_papasofokli_components_ToastJS$().IZ("Connection with server failed. Refresh the page and try again.", $m_s_Option$().Z($bL(3000, 0)));
  var $x_1 = x;
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$2, "com.papasofokli.util.AjaxCallFunctions$$anon$2", ({
  si: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4(data$8) {
  this.a8e = null;
  this.a8e = data$8;
}
$p = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4() {
}
$h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  var xs = x.II();
  var f = ((s$3) => {
    $m_s_Console$().J1().zO((s$3 + "\n"));
  });
  var len = xs.a.length;
  var i = 0;
  if ((xs !== null)) {
    while ((i < len)) {
      var x0 = xs.a[i];
      f(x0);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_I)) {
    while ((i < len)) {
      var x0$1 = xs.a[i];
      f(x0$1);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_D)) {
    while ((i < len)) {
      var x0$2 = xs.a[i];
      f(x0$2);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_J)) {
    while ((i < len)) {
      var $x_1 = xs.a;
      var $x_2 = (i << 1);
      var x0$3_$_lo = $x_1[$x_2];
      var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
      f($bL(x0$3_$_lo, x0$3_$_hi));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_F)) {
    while ((i < len)) {
      var x0$4 = xs.a[i];
      f(x0$4);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_C)) {
    while ((i < len)) {
      var x0$5 = xs.a[i];
      f($bC(x0$5));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_B)) {
    while ((i < len)) {
      var x0$6 = xs.a[i];
      f(x0$6);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_S)) {
    while ((i < len)) {
      var x0$7 = xs.a[i];
      f(x0$7);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_Z)) {
    while ((i < len)) {
      var x0$8 = xs.a[i];
      f(x0$8);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(xs);
  }
  return new $c_T2(false, (this.a8e.name + " cannot be uploaded."));
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$4, "com.papasofokli.util.AjaxCallFunctions$$anon$4", ({
  sj: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6() {
}
$p = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6() {
}
$h_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  var xs = x.II();
  var f = ((s$3) => {
    $m_s_Console$().J1().zO((s$3 + "\n"));
  });
  var len = xs.a.length;
  var i = 0;
  if ((xs !== null)) {
    while ((i < len)) {
      var x0 = xs.a[i];
      f(x0);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_I)) {
    while ((i < len)) {
      var x0$1 = xs.a[i];
      f(x0$1);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_D)) {
    while ((i < len)) {
      var x0$2 = xs.a[i];
      f(x0$2);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_J)) {
    while ((i < len)) {
      var $x_1 = xs.a;
      var $x_2 = (i << 1);
      var x0$3_$_lo = $x_1[$x_2];
      var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
      f($bL(x0$3_$_lo, x0$3_$_hi));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_F)) {
    while ((i < len)) {
      var x0$4 = xs.a[i];
      f(x0$4);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_C)) {
    while ((i < len)) {
      var x0$5 = xs.a[i];
      f($bC(x0$5));
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_B)) {
    while ((i < len)) {
      var x0$6 = xs.a[i];
      f(x0$6);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_S)) {
    while ((i < len)) {
      var x0$7 = xs.a[i];
      f(x0$7);
      i = ((1 + i) | 0);
    }
  } else if ((xs instanceof $ac_Z)) {
    while ((i < len)) {
      var x0$8 = xs.a[i];
      f(x0$8);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(xs);
  }
  return Response.error();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_util_AjaxCallFunctions$$anon$6, "com.papasofokli.util.AjaxCallFunctions$$anon$6", ({
  sk: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AttachmentBoxIcon(name) {
  this.xP = null;
  this.xP = name;
}
$p = $c_Lcom_papasofokli_util_AttachmentBoxIcon.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_AttachmentBoxIcon;
/** @constructor */
function $h_Lcom_papasofokli_util_AttachmentBoxIcon() {
}
$h_Lcom_papasofokli_util_AttachmentBoxIcon.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 429970319, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_AttachmentBoxIcon) && (this.xP === x$0.xP)));
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "AttachmentBoxIcon";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.xP;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return this.xP;
});
function $isArrayOf_Lcom_papasofokli_util_AttachmentBoxIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g3)));
}
var $d_Lcom_papasofokli_util_AttachmentBoxIcon = new $TypeData().i($c_Lcom_papasofokli_util_AttachmentBoxIcon, "com.papasofokli.util.AttachmentBoxIcon", ({
  g3: 1,
  ba: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_AttributeValue(attribute, value) {
  this.Gc = null;
  this.Gd = null;
  this.Gc = attribute;
  this.Gd = value;
}
$p = $c_Lcom_papasofokli_util_AttributeValue.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_AttributeValue;
/** @constructor */
function $h_Lcom_papasofokli_util_AttributeValue() {
}
$h_Lcom_papasofokli_util_AttributeValue.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 192897051, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_AttributeValue) && ((this.Gc === x$0.Gc) && $m_sr_BoxesRunTime$().B(this.Gd, x$0.Gd))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "AttributeValue";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Gc;
  }
  if ((n === 1)) {
    return this.Gd;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ds = (function(element) {
  element.setAttribute(this.Gc, $dp_toString__T(this.Gd));
});
function $isArrayOf_Lcom_papasofokli_util_AttributeValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g4)));
}
var $d_Lcom_papasofokli_util_AttributeValue = new $TypeData().i($c_Lcom_papasofokli_util_AttributeValue, "com.papasofokli.util.AttributeValue", ({
  g4: 1,
  cl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_CountryFlagIcon(countryCode, extraClass) {
  this.xQ = null;
  this.nU = null;
  this.xQ = countryCode;
  this.nU = extraClass;
}
$p = $c_Lcom_papasofokli_util_CountryFlagIcon.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_CountryFlagIcon;
/** @constructor */
function $h_Lcom_papasofokli_util_CountryFlagIcon() {
}
$h_Lcom_papasofokli_util_CountryFlagIcon.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 512741187, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_CountryFlagIcon) && ((this.xQ === x$0.xQ) && (this.nU === x$0.nU))));
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "CountryFlagIcon";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.xQ;
  }
  if ((n === 1)) {
    return this.nU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return ((("flag-icon-rf flag-icon-background flag-icon-" + this.xQ) + " ") + this.nU);
});
function $isArrayOf_Lcom_papasofokli_util_CountryFlagIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g5)));
}
var $d_Lcom_papasofokli_util_CountryFlagIcon = new $TypeData().i($c_Lcom_papasofokli_util_CountryFlagIcon, "com.papasofokli.util.CountryFlagIcon", ({
  g5: 1,
  ba: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_FreezePage$$anon$1() {
}
$p = $c_Lcom_papasofokli_util_FreezePage$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_FreezePage$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_util_FreezePage$$anon$1() {
}
$h_Lcom_papasofokli_util_FreezePage$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  return $m_s_None$();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_util_FreezePage$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_util_FreezePage$$anon$1, "com.papasofokli.util.FreezePage$$anon$1", ({
  sr: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GenderSymbolIcon(iconCode, color, extraClass) {
  this.t5 = null;
  this.t4 = null;
  this.nV = null;
  this.t5 = iconCode;
  this.t4 = color;
  this.nV = extraClass;
}
$p = $c_Lcom_papasofokli_util_GenderSymbolIcon.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GenderSymbolIcon;
/** @constructor */
function $h_Lcom_papasofokli_util_GenderSymbolIcon() {
}
$h_Lcom_papasofokli_util_GenderSymbolIcon.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-405471153), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon)) {
    if ((this.t5 === x$0.t5)) {
      var x = this.t4;
      var x$2 = x$0.t4;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.nV === x$0.nV);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "GenderSymbolIcon";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.t5;
      break;
    }
    case 1: {
      return this.t4;
      break;
    }
    case 2: {
      return this.nV;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.g = (function() {
  return ((this.t5 + " flag-icon-background ") + this.nV);
});
function $isArrayOf_Lcom_papasofokli_util_GenderSymbolIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g6)));
}
var $d_Lcom_papasofokli_util_GenderSymbolIcon = new $TypeData().i($c_Lcom_papasofokli_util_GenderSymbolIcon, "com.papasofokli.util.GenderSymbolIcon", ({
  g6: 1,
  ba: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$10(WritersVersionSpecific_this$27, outer) {
  this.a8k = null;
  this.a8k = WritersVersionSpecific_this$27;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$10() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$10.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiK = (function(v) {
  var x = v.m8;
  $m_Lcom_papasofokli_util_IconUI$();
  var x$2 = $m_s_None$();
  return ((1 + ((!((x !== null) && x.b(x$2))) | 0)) | 0);
});
$p.aBY = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiK(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.by);
    var x = v.m8;
    $m_Lcom_papasofokli_util_IconUI$();
    var x$2 = $m_s_None$();
    if ((!((x !== null) && x.b(x$2)))) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.m8);
    }
    return ctx.L((-1));
  }
});
$p.aEn = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.by);
  var x = v.m8;
  $m_Lcom_papasofokli_util_IconUI$();
  var x$2 = $m_s_None$();
  if ((!((x !== null) && x.b(x$2)))) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "tooltip", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lupickle_default$().m), v.m8);
  }
});
$p.ah = (function(v) {
  return this.aiK(v);
});
$p.U = (function(out, v) {
  return this.aBY(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEn(ctx, v);
});
$p.T = (function() {
  return this.a8k;
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$10, "com.papasofokli.util.GeneralText$$anon$10", ({
  su: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$6(WritersVersionSpecific_this$23, outer) {
  this.a8l = null;
  this.a8l = WritersVersionSpecific_this$23;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$6() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$6.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBZ = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.xT);
    return ctx.L((-1));
  }
});
$p.aEo = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "text", $m_Lupickle_default$().m, v.xT);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBZ(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEo(ctx, v);
});
$p.T = (function() {
  return this.a8l;
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$6, "com.papasofokli.util.GeneralText$$anon$6", ({
  sz: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$7(WritersVersionSpecific_this$24, outer) {
  this.a8m = null;
  this.a8m = WritersVersionSpecific_this$24;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$7() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$7.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiJ = (function(v) {
  return ((2 + ((v.nV !== "") | 0)) | 0);
});
$p.aBX = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiJ(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "iconCode", $m_Lupickle_default$().m, v.t5);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.t4);
    if ((v.nV !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraClass", $m_Lupickle_default$().m, v.nV);
    }
    return ctx.L((-1));
  }
});
$p.aEm = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "iconCode", $m_Lupickle_default$().m, v.t5);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "color", $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), v.t4);
  if ((v.nV !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraClass", $m_Lupickle_default$().m, v.nV);
  }
});
$p.ah = (function(v) {
  return this.aiJ(v);
});
$p.U = (function(out, v) {
  return this.aBX(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEm(ctx, v);
});
$p.T = (function() {
  return this.a8m;
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$7, "com.papasofokli.util.GeneralText$$anon$7", ({
  sA: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$8(WritersVersionSpecific_this$25, outer) {
  this.a8n = null;
  this.a8n = WritersVersionSpecific_this$25;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$8() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$8.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aiI = (function(v) {
  return ((1 + ((v.nU !== "") | 0)) | 0);
});
$p.aBW = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(this.aiI(v), true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "countryCode", $m_Lupickle_default$().m, v.xQ);
    if ((v.nU !== "")) {
      $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraClass", $m_Lupickle_default$().m, v.nU);
    }
    return ctx.L((-1));
  }
});
$p.aEl = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "countryCode", $m_Lupickle_default$().m, v.xQ);
  if ((v.nU !== "")) {
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "extraClass", $m_Lupickle_default$().m, v.nU);
  }
});
$p.ah = (function(v) {
  return this.aiI(v);
});
$p.U = (function(out, v) {
  return this.aBW(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEl(ctx, v);
});
$p.T = (function() {
  return this.a8n;
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$8, "com.papasofokli.util.GeneralText$$anon$8", ({
  sB: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$9(WritersVersionSpecific_this$26, outer) {
  this.a8o = null;
  this.a8o = WritersVersionSpecific_this$26;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$9() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$9.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aBV = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.xP);
    return ctx.L((-1));
  }
});
$p.aEk = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "name", $m_Lupickle_default$().m, v.xP);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aBV(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEk(ctx, v);
});
$p.T = (function() {
  return this.a8o;
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$9, "com.papasofokli.util.GeneralText$$anon$9", ({
  sC: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_IconUI(name, tooltip) {
  this.by = null;
  this.m8 = null;
  this.by = name;
  this.m8 = tooltip;
}
$p = $c_Lcom_papasofokli_util_IconUI.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_IconUI;
/** @constructor */
function $h_Lcom_papasofokli_util_IconUI() {
}
$h_Lcom_papasofokli_util_IconUI.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1744189245), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_util_IconUI)) {
    if ((this.by === x$0.by)) {
      var x = this.m8;
      var x$2 = x$0.m8;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "IconUI";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.by;
  }
  if ((n === 1)) {
    return this.m8;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return this.by;
});
$p.TA = (function(cssClassName, tooltipO) {
  $m_Lcom_papasofokli_util_IconUI$();
  return new $c_Lcom_papasofokli_util_IconUI($f_T__trim__T(((this.by + " ") + cssClassName)), tooltipO);
});
function $isArrayOf_Lcom_papasofokli_util_IconUI(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g7)));
}
var $d_Lcom_papasofokli_util_IconUI = new $TypeData().i($c_Lcom_papasofokli_util_IconUI, "com.papasofokli.util.IconUI", ({
  g7: 1,
  ba: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_SpanTextContainer(text) {
  this.xT = null;
  this.xT = text;
}
$p = $c_Lcom_papasofokli_util_SpanTextContainer.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_SpanTextContainer;
/** @constructor */
function $h_Lcom_papasofokli_util_SpanTextContainer() {
}
$h_Lcom_papasofokli_util_SpanTextContainer.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1332702934, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_SpanTextContainer) && (this.xT === x$0.xT)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "SpanTextContainer";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.xT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_util_SpanTextContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g9)));
}
var $d_Lcom_papasofokli_util_SpanTextContainer = new $TypeData().i($c_Lcom_papasofokli_util_SpanTextContainer, "com.papasofokli.util.SpanTextContainer", ({
  g9: 1,
  ba: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_StyleValue(property, value) {
  this.Gl = null;
  this.Gm = null;
  this.Gl = property;
  this.Gm = value;
}
$p = $c_Lcom_papasofokli_util_StyleValue.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_StyleValue;
/** @constructor */
function $h_Lcom_papasofokli_util_StyleValue() {
}
$h_Lcom_papasofokli_util_StyleValue.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-74134836), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_StyleValue) && ((this.Gl === x$0.Gl) && $m_sr_BoxesRunTime$().B(this.Gm, x$0.Gm))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "StyleValue";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Gl;
  }
  if ((n === 1)) {
    return this.Gm;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ds = (function(element) {
  (0, $m_Lcom_papasofokli_jquery_package$().I)(element).css(this.Gl, $dp_toString__T(this.Gm));
});
function $isArrayOf_Lcom_papasofokli_util_StyleValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ga)));
}
var $d_Lcom_papasofokli_util_StyleValue = new $TypeData().i($c_Lcom_papasofokli_util_StyleValue, "com.papasofokli.util.StyleValue", ({
  ga: 1,
  cl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_TextContent(text) {
  this.Gn = null;
  this.Gn = text;
}
$p = $c_Lcom_papasofokli_util_TextContent.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_TextContent;
/** @constructor */
function $h_Lcom_papasofokli_util_TextContent() {
}
$h_Lcom_papasofokli_util_TextContent.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1008407317, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_util_TextContent) && (this.Gn === x$0.Gn)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "TextContent";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Gn;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ds = (function(element) {
  element.textContent = this.Gn;
});
function $isArrayOf_Lcom_papasofokli_util_TextContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gb)));
}
var $d_Lcom_papasofokli_util_TextContent = new $TypeData().i($c_Lcom_papasofokli_util_TextContent, "com.papasofokli.util.TextContent", ({
  gb: 1,
  cl: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1() {
}
$p = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1() {
}
$h_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1.prototype = $p;
$p.jt = (function(x) {
  return ((!(!(x instanceof HTMLElement))) || false);
});
$p.jk = (function(x, default$1) {
  return ((!(!(x instanceof HTMLElement))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$1, "com.papasofokli.util.TopBottomScrollDivJs$$anon$1", ({
  sS: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2() {
}
$p = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2() {
}
$h_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2.prototype = $p;
$p.jt = (function(x) {
  return ((!(!(x instanceof HTMLElement))) || false);
});
$p.jk = (function(x, default$1) {
  return ((!(!(x instanceof HTMLElement))) ? x : default$1.p(x));
});
$p.aU = (function(x) {
  return this.jt(x);
});
$p.aJ = (function(x, default$1) {
  return this.jk(x, default$1);
});
var $d_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_util_TopBottomScrollDivJs$$anon$2, "com.papasofokli.util.TopBottomScrollDivJs$$anon$2", ({
  sT: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$$anon$4(WritersVersionSpecific_this$29, outer) {
  this.a92 = null;
  this.a92 = WritersVersionSpecific_this$29;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$$anon$4() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$$anon$4.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aC0 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(1, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "logout", $m_Lupickle_default$().aw, v.xU);
    return ctx.L((-1));
  }
});
$p.aEp = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "logout", $m_Lupickle_default$().aw, v.xU);
});
$p.ah = (function(v) {
  return 1;
});
$p.U = (function(out, v) {
  return this.aC0(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEp(ctx, v);
});
$p.T = (function() {
  return this.a92;
});
var $d_Lcom_papasofokli_websocket_ClientMessages$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$$anon$4, "com.papasofokli.websocket.ClientMessages$$anon$4", ({
  tc: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$$anon$5(WritersVersionSpecific_this$30, outer) {
  this.a93 = null;
  this.a93 = WritersVersionSpecific_this$30;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$$anon$5() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$$anon$5.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.aC1 = (function(out, v) {
  if ((v === null)) {
    return out.M((-1));
  } else {
    var ctx = out.K(2, true, (-1));
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $m_Lupickle_default$().m, v.Cl);
    $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "visibilityInfo", $m_Lcom_papasofokli_websocket_VisibilityInfo$().q(), v.Cm);
    return ctx.L((-1));
  }
});
$p.aEq = (function(ctx, v) {
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "href", $m_Lupickle_default$().m, v.Cl);
  $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__writeSnippetMappedName__Lupickle_core_ObjVisitor__jl_CharSequence__O__O__V(this, ctx, "visibilityInfo", $m_Lcom_papasofokli_websocket_VisibilityInfo$().q(), v.Cm);
});
$p.ah = (function(v) {
  return 2;
});
$p.U = (function(out, v) {
  return this.aC1(out, v);
});
$p.ai = (function(ctx, v) {
  this.aEq(ctx, v);
});
$p.T = (function() {
  return this.a93;
});
var $d_Lcom_papasofokli_websocket_ClientMessages$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$$anon$5, "com.papasofokli.websocket.ClientMessages$$anon$5", ({
  td: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClosePageMessage(logout) {
  this.xU = false;
  this.xU = logout;
}
$p = $c_Lcom_papasofokli_websocket_ClosePageMessage.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_ClosePageMessage;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClosePageMessage() {
}
$h_Lcom_papasofokli_websocket_ClosePageMessage.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1705585024);
  acc = $m_sr_Statics$().d(acc, (this.xU ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_websocket_ClosePageMessage) && (this.xU === x$0.xU)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "ClosePageMessage";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.xU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_websocket_ClosePageMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gc)));
}
var $d_Lcom_papasofokli_websocket_ClosePageMessage = new $TypeData().i($c_Lcom_papasofokli_websocket_ClosePageMessage, "com.papasofokli.websocket.ClosePageMessage", ({
  gc: 1,
  b1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_WebPageStatus(href, visibilityInfo) {
  this.Cl = null;
  this.Cm = null;
  this.Cl = href;
  this.Cm = visibilityInfo;
}
$p = $c_Lcom_papasofokli_websocket_WebPageStatus.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_WebPageStatus;
/** @constructor */
function $h_Lcom_papasofokli_websocket_WebPageStatus() {
}
$h_Lcom_papasofokli_websocket_WebPageStatus.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 36369930, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_websocket_WebPageStatus)) {
    if ((this.Cl === x$0.Cl)) {
      var x = this.Cm;
      var x$2 = x$0.Cm;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "WebPageStatus";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Cl;
  }
  if ((n === 1)) {
    return this.Cm;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcom_papasofokli_websocket_WebPageStatus(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gd)));
}
var $d_Lcom_papasofokli_websocket_WebPageStatus = new $TypeData().i($c_Lcom_papasofokli_websocket_WebPageStatus, "com.papasofokli.websocket.WebPageStatus", ({
  gd: 1,
  b1: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1() {
}
$p = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1() {
}
$h_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  console.error(x.dI());
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$1, "com.papasofokli.zxing.InitializeVideoScanner$$anon$1", ({
  tn: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2() {
}
$p = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2() {
}
$h_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2.prototype = $p;
$p.bq = (function(x) {
  return true;
});
$p.bn = (function(x, default$1) {
  window.location.reload();
  console.error(x.dI());
  return Response.error();
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_zxing_InitializeVideoScanner$$anon$2, "com.papasofokli.zxing.InitializeVideoScanner$$anon$2", ({
  to: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
}
$p = $c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$p.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
$h_Ljava_io_FilterOutputStream.prototype = $p;
function $ct_Ljava_io_Writer__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_Writer() {
}
$p = $c_Ljava_io_Writer.prototype = new $h_O();
$p.constructor = $c_Ljava_io_Writer;
/** @constructor */
function $h_Ljava_io_Writer() {
}
$h_Ljava_io_Writer.prototype = $p;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gf)));
}
var $d_jl_ArithmeticException = new $TypeData().i($c_jl_ArithmeticException, "java.lang.ArithmeticException", ({
  gf: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gh)));
}
var $d_jl_Byte = new $TypeData().i(0, "java.lang.Byte", ({
  gh: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1
}), ((x) => $isByte(x)));
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.tz)));
}
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalArgumentException = new $TypeData().i($c_jl_IllegalArgumentException, "java.lang.IllegalArgumentException", ({
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().i($c_jl_IllegalStateException, "java.lang.IllegalStateException", ({
  gl: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().i($c_jl_IndexOutOfBoundsException, "java.lang.IndexOutOfBoundsException", ({
  gm: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$p = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $p;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().i($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  tG: 1,
  ge: 1,
  bN: 1,
  bP: 1,
  bO: 1
}));
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().i($c_jl_NullPointerException, "java.lang.NullPointerException", ({
  tL: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.tM)));
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gr)));
}
var $d_jl_Short = new $TypeData().i(0, "java.lang.Short", ({
  gr: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1
}), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_StackOverflowError = new $TypeData().i($c_jl_StackOverflowError, "java.lang.StackOverflowError", ({
  tN: 1,
  gu: 1,
  bQ: 1,
  F: 1,
  a: 1
}));
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().i($c_jl_UnsupportedOperationException, "java.lang.UnsupportedOperationException", ({
  gt: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_Ljava_nio_BufferOverflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gz)));
}
var $d_Ljava_nio_BufferOverflowException = new $TypeData().i($c_Ljava_nio_BufferOverflowException, "java.nio.BufferOverflowException", ({
  gz: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_Ljava_nio_BufferUnderflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gA)));
}
var $d_Ljava_nio_BufferUnderflowException = new $TypeData().i($c_Ljava_nio_BufferUnderflowException, "java.nio.BufferUnderflowException", ({
  gA: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_Ljava_nio_charset_CharacterCodingException extends $c_Ljava_io_IOException {
}
/** @constructor */
function $c_ju_AbstractSet() {
}
$p = $c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$p.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
$h_ju_AbstractSet.prototype = $p;
$p.b = (function(that) {
  return ((that === this) || ($is_ju_Collection(that) && ((that.aH() === this.aH()) && this.asL(that))));
});
$p.r = (function() {
  var _\uff3fself = this.zN();
  var result = 0;
  while (_\uff3fself.f()) {
    var t = result;
    var u = _\uff3fself.e();
    var t$1 = (t | 0);
    result = (($dp_hashCode__I(u) + t$1) | 0);
  }
  return (result | 0);
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_ju_ConcurrentModificationException = new $TypeData().i($c_ju_ConcurrentModificationException, "java.util.ConcurrentModificationException", ({
  uA: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.US(key, hash, (hash & (($thiz.i8.a.length - 1) | 0)));
  return ((node === null) ? defaultValue : ($thiz.aj2(node), node.ht));
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.i8;
  var oldlen = oldTable.a.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.r().C)(newlen);
  $thiz.i8 = newTable;
  $thiz.KS = $doubleToInt((newlen * $thiz.KR));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.a[i];
    while ((node !== null)) {
      if (((node.ti & oldlen) === 0)) {
        node.y3 = lastLow;
        if ((lastLow === null)) {
          newTable.a[i] = node;
        } else {
          lastLow.kh = node;
        }
        lastLow = node;
      } else {
        node.y3 = lastHigh;
        if ((lastHigh === null)) {
          newTable.a[((oldlen + i) | 0)] = node;
        } else {
          lastHigh.kh = node;
        }
        lastHigh = node;
      }
      node = node.kh;
    }
    if ((lastLow !== null)) {
      lastLow.kh = null;
    }
    if ((lastHigh !== null)) {
      lastHigh.kh = null;
    }
    i = ((1 + i) | 0);
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.KR = loadFactor;
  if ((initialCapacity < 0)) {
    $m_jl_BoundsChecks$().ahU(initialCapacity);
  }
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = ((initialCapacity - 1) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.i8 = new ($d_ju_HashMap$Node.r().C)(((a$1 < 1073741824) ? a$1 : 1073741824));
  $thiz.KS = $doubleToInt(($thiz.i8.a.length * $thiz.KR));
  $thiz.nX = 0;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap() {
  this.KR = 0.0;
  this.i8 = null;
  this.KS = 0;
  this.nX = 0;
}
$p = $c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$p.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
$h_ju_HashMap.prototype = $p;
$p.ax7 = (function(key) {
  var node = this.avQ(key);
  return ((node === null) ? null : node.ht);
});
$p.US = (function(key, hash, idx) {
  var node = this.i8.a[idx];
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === node.ti)) {
        var b = node.me;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < node.ti)) {
        return null;
      } else {
        node = node.kh;
      }
    }
  }
});
$p.avP = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.nX) | 0);
  if ((newContentSize >= this.KS)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & ((this.i8.a.length - 1) | 0));
  var x1 = this.i8.a[idx];
  if ((x1 === null)) {
    var newNode = new $c_ju_LinkedHashMap$Node(key, hash, value, null, null, null, null);
    this.i8.a[idx] = newNode;
    var newNode$3 = newNode;
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.ti <= hash))) {
      if ((n.ti === hash)) {
        var b = n.me;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this.aj2(n);
        var old = n.ht;
        if (((!ifAbsent) || (old === null))) {
          n.ht = value;
        }
        return old;
      }
      prev = n;
      n = n.kh;
    }
    var newNode$2 = new $c_ju_LinkedHashMap$Node(key, hash, value, prev, n, null, null);
    if ((prev === null)) {
      this.i8.a[idx] = newNode$2;
    } else {
      prev.kh = newNode$2;
    }
    if ((n !== null)) {
      n.y3 = newNode$2;
    }
    var newNode$3 = newNode$2;
  }
  this.nX = newContentSize;
  this.awx(newNode$3);
  return null;
});
$p.avQ = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & ((this.i8.a.length - 1) | 0));
  var node = this.US(key, hash, idx);
  if ((node !== null)) {
    this.avR(node, idx);
  }
  return node;
});
$p.avR = (function(node, idx) {
  var previous = node.y3;
  var next = node.kh;
  if ((previous === null)) {
    this.i8.a[idx] = next;
  } else {
    previous.kh = next;
  }
  if ((next !== null)) {
    next.y3 = previous;
  }
  this.nX = ((this.nX - 1) | 0);
  this.awy(node);
});
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().i($c_ju_NoSuchElementException, "java.util.NoSuchElementException", ({
  bS: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0);
}
$p = $c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.jA(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000016E-6 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000017E-9 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.6666666666666693E-11 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(22528, b0);
  var a1b0 = Math.imul(63559, b0);
  var a0b1 = Math.imul(22528, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul((-129542144), hi) + Math.imul(13, lo)) | 0) + Math.imul(63559, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-13 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, lo)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074086E-14 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a1b0 = Math.imul(37199, b0);
  var lo$1 = (a1b0 << 16);
  var hi$1 = ((((((Math.imul((-1857093632), hi) + Math.imul(20116, lo)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$1, "java.util.concurrent.TimeUnit$$anon$1", ({
  v6: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1);
}
$p = $c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A4(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000016E-6 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.6666666666666693E-8 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(60000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-10 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(41984, b0);
  var a1b0 = Math.imul(54931, b0);
  var a0b1 = Math.imul(41984, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul((-694967296), hi) + Math.imul(54931, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074087E-11 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(24576, b0);
  var a1b0 = Math.imul(7639, b0);
  var a0b1 = Math.imul(24576, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(500654080, hi) + Math.imul(20, lo)) | 0) + Math.imul(7639, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    return $bL(lo$4, hi$4);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$2, "java.util.concurrent.TimeUnit$$anon$2", ({
  v7: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2);
}
$p = $c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A5(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60000) | 0);
  var k = ((rhi - Math.imul(60000, quotHi)) | 0);
  var quotLo = ((1.6666666666666674E-5 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-7 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(3600000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074087E-8 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(86400000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((a_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    return $bL(lo$2, hi$2);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$3, "java.util.concurrent.TimeUnit$$anon$3", ({
  v8: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3);
}
$p = $c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A8(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000000000, 0, 633437444, 2);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60) | 0);
  var k = ((rhi - Math.imul(60, quotHi)) | 0);
  var quotLo = ((0.016666666666666673 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 3600) | 0);
  var k = ((rhi - Math.imul(3600, quotHi)) | 0);
  var quotLo = ((2.777777777777779E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 86400) | 0);
  var k = ((rhi - Math.imul(86400, quotHi)) | 0);
  var quotLo = ((1.1574074074074079E-5 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$4, "java.util.concurrent.TimeUnit$$anon$4", ({
  v9: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4);
}
$p = $c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A6(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, (-129542144), 13, 153722867, 0);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 60000000, 0, (-895955376), 35);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 60000, 0, 1692789776, 35791);
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 60) | 0);
  var k = ((rhi - Math.imul(60, quotHi)) | 0);
  var quotLo = ((0.016666666666666673 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1440) | 0);
  var k = ((rhi - Math.imul(1440, quotHi)) | 0);
  var quotLo = ((6.944444444444448E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$5, "java.util.concurrent.TimeUnit$$anon$5", ({
  va: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5);
}
$p = $c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A3(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 817405952, 838, 2562047, 0);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, (-694967296), 0, (-1732919508), 0);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 3600000, 0, (-2047687697), 596);
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 3600, 0, 1011703407, 596523);
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  var sign = (a_$_hi >> 31);
  var xlo = (a_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 24) | 0);
  var k = ((rhi - Math.imul(24, quotHi)) | 0);
  var quotLo = ((0.041666666666666685 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((a_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    return $bL(lo, hi);
  } else {
    return $bL(quotLo, quotHi);
  }
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$6, "java.util.concurrent.TimeUnit$$anon$6", ({
  vb: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.m9 = null;
  this.iW = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6);
}
$p = $c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$p.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $p;
$p.zz = (function(a_$_lo, a_$_hi, u) {
  return u.A2(a_$_lo, a_$_hi);
});
$p.jA = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, (-1857093632), 20116, 106751, 0);
});
$p.A4 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 500654080, 20, 106751991, 0);
});
$p.A5 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 86400000, 0, (-622191233), 24);
});
$p.A8 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 86400, 0, 579025220, 24855);
});
$p.A6 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 1440, 0, 381774870, 1491308);
});
$p.A3 = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().fa(a_$_lo, a_$_hi, 24, 0, 1431655765, 89478485);
});
$p.A2 = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().i($c_ju_concurrent_TimeUnit$$anon$7, "java.util.concurrent.TimeUnit$$anon$7", ({
  vc: 1,
  b2: 1,
  aU: 1,
  N: 1,
  a: 1
}));
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
$p = $c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$p.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
$h_s_$less$colon$less$$anon$1.prototype = $p;
$p.p = (function(x) {
  return x;
});
$p.g = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().i($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  vI: 1,
  vF: 1,
  vG: 1,
  p: 1,
  a: 1
}));
/** @constructor */
function $c_s_Enumeration$Val(outer, i, name) {
  this.KZ = null;
  this.i9 = 0;
  this.Rn = null;
  this.i9 = i;
  this.Rn = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_s_Enumeration$Value__s_Enumeration__(this, outer);
  if (outer.mf.az(i)) {
    $m_sr_Scala3RunTime$().Mk(("Duplicate id: " + i));
  }
  outer.mf.Jf(i, this);
  outer.nZ = false;
  outer.bI = ((1 + i) | 0);
  if ((outer.bI > outer.q3)) {
    outer.q3 = outer.bI;
  }
  if ((i < outer.j1)) {
    outer.j1 = i;
  }
}
$p = $c_s_Enumeration$Val.prototype = new $h_s_Enumeration$Value();
$p.constructor = $c_s_Enumeration$Val;
/** @constructor */
function $h_s_Enumeration$Val() {
}
$h_s_Enumeration$Val.prototype = $p;
$p.g = (function() {
  return ((this.Rn !== null) ? this.Rn : (((("<Unknown name for enum field #" + this.i9) + " of class ") + $objectGetClass(this)) + ">"));
});
var $d_s_Enumeration$Val = new $TypeData().i($c_s_Enumeration$Val, "scala.Enumeration$Val", ({
  vM: 1,
  gI: 1,
  N: 1,
  aY: 1,
  a: 1
}));
function $p_s_MatchError__objString__T($thiz) {
  if ((!$thiz.aac)) {
    if (($thiz.L0 === null)) {
      var $x_1 = "null";
    } else {
      var this$1 = $thiz.L0;
      var cls = $objectGetClass(this$1);
      var ofClass = ((cls === null) ? "of a JS class" : ("of class " + cls.ax.N));
      try {
        var $x_1 = ((($thiz.L0 + " (") + ofClass) + ")");
      } catch (e) {
        var $x_1 = ("an instance " + ofClass);
      }
    }
    $thiz.aab = $x_1;
    $thiz.aac = true;
  }
  return $thiz.aab;
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.L0 = null;
    this.aab = null;
    this.aac = false;
    this.L0 = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return $p_s_MatchError__objString__T(this);
  }
}
var $d_s_MatchError = new $TypeData().i($c_s_MatchError, "scala.MatchError", ({
  vV: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_s_Option() {
}
$p = $c_s_Option.prototype = new $h_O();
$p.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
}
$h_s_Option.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.c = (function() {
  return (this === $m_s_None$());
});
$p.G = (function() {
  return ((!this.c()) | 0);
});
$p.ah5 = (function(ev) {
  return (this.c() ? $m_s_None$() : this.h());
});
$p.az = (function(elem) {
  return ((!this.c()) && $m_sr_BoxesRunTime$().B(this.h(), elem));
});
$p.l = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sc_Iterator$$anon$20(this.h()));
});
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.GA = 0;
  this.aaf = 0;
  this.aae = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aae = outer;
  this.GA = 0;
  this.aaf = outer.w();
}
$p = $c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
}
$h_s_Product$$anon$1.prototype = $p;
$p.f = (function() {
  return (this.GA < this.aaf);
});
$p.e = (function() {
  var result = this.aae.z(this.GA);
  this.GA = ((1 + this.GA) | 0);
  return result;
});
var $d_s_Product$$anon$1 = new $TypeData().i($c_s_Product$$anon$1, "scala.Product$$anon$1", ({
  w3: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_T2(_1, _2) {
  this.L3 = null;
  this.L4 = null;
  this.L3 = _1;
  this.L4 = _2;
}
$p = $c_T2.prototype = new $h_O();
$p.constructor = $c_T2;
/** @constructor */
function $h_T2() {
}
$h_T2.prototype = $p;
$p.w = (function() {
  return 2;
});
$p.z = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n);
});
$p.P = (function() {
  return this.L3;
});
$p.V = (function() {
  return this.L4;
});
$p.g = (function() {
  return (((("(" + this.P()) + ",") + this.V()) + ")");
});
$p.A = (function() {
  return "Tuple2";
});
$p.C = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-116390334), true);
});
$p.b = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T2) && ($m_sr_BoxesRunTime$().B(this.P(), x$1.P()) && $m_sr_BoxesRunTime$().B(this.V(), x$1.V()))));
});
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gL)));
}
var $d_T2 = new $TypeData().i($c_T2, "scala.Tuple2", ({
  gL: 1,
  w4: 1,
  c: 1,
  b: 1,
  a: 1
}));
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.gZ = null;
  this.fY = null;
  this.gr = null;
  this.gZ = _1;
  this.fY = _2;
  this.gr = _3;
}
$p = $c_T3.prototype = new $h_O();
$p.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
$h_T3.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.w = (function() {
  return 3;
});
$p.z = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-192629203), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T3) && (($m_sr_BoxesRunTime$().B(this.gZ, x$0.gZ) && $m_sr_BoxesRunTime$().B(this.fY, x$0.fY)) && $m_sr_BoxesRunTime$().B(this.gr, x$0.gr))));
});
$p.A = (function() {
  return "Tuple3";
});
$p.g = (function() {
  return (((((("(" + this.gZ) + ",") + this.fY) + ",") + this.gr) + ")");
});
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gM)));
}
var $d_T3 = new $TypeData().i($c_T3, "scala.Tuple3", ({
  gM: 1,
  b: 1,
  c: 1,
  w5: 1,
  a: 1
}));
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.y8 = null;
  this.y9 = null;
  this.ya = null;
  this.tp = null;
  this.y8 = _1;
  this.y9 = _2;
  this.ya = _3;
  this.tp = _4;
}
$p = $c_T4.prototype = new $h_O();
$p.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
$h_T4.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.w = (function() {
  return 4;
});
$p.z = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1542739752), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T4) && ((($m_sr_BoxesRunTime$().B(this.y8, x$0.y8) && $m_sr_BoxesRunTime$().B(this.y9, x$0.y9)) && $m_sr_BoxesRunTime$().B(this.ya, x$0.ya)) && $m_sr_BoxesRunTime$().B(this.tp, x$0.tp))));
});
$p.A = (function() {
  return "Tuple4";
});
$p.g = (function() {
  return (((((((("(" + this.y8) + ",") + this.y9) + ",") + this.ya) + ",") + this.tp) + ")");
});
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gN)));
}
var $d_T4 = new $TypeData().i($c_T4, "scala.Tuple4", ({
  gN: 1,
  b: 1,
  c: 1,
  w6: 1,
  a: 1
}));
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.CA = null;
  this.CB = null;
  this.CC = null;
  this.CD = null;
  this.CE = null;
  this.CA = _1;
  this.CB = _2;
  this.CC = _3;
  this.CD = _4;
  this.CE = _5;
}
$p = $c_T5.prototype = new $h_O();
$p.constructor = $c_T5;
/** @constructor */
function $h_T5() {
}
$h_T5.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.w = (function() {
  return 5;
});
$p.z = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 417360321, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T5) && (((($m_sr_BoxesRunTime$().B(this.CA, x$0.CA) && $m_sr_BoxesRunTime$().B(this.CB, x$0.CB)) && $m_sr_BoxesRunTime$().B(this.CC, x$0.CC)) && $m_sr_BoxesRunTime$().B(this.CD, x$0.CD)) && $m_sr_BoxesRunTime$().B(this.CE, x$0.CE))));
});
$p.A = (function() {
  return "Tuple5";
});
$p.g = (function() {
  return (((((((((("(" + this.CA) + ",") + this.CB) + ",") + this.CC) + ",") + this.CD) + ",") + this.CE) + ")");
});
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gO)));
}
var $d_T5 = new $TypeData().i($c_T5, "scala.Tuple5", ({
  gO: 1,
  b: 1,
  c: 1,
  w7: 1,
  a: 1
}));
/** @constructor */
function $c_sc_BitSetOps$$anon$1(start$1, outer) {
  this.yb = 0;
  this.zs = 0;
  this.zt = 0;
  this.Rs = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Rs = outer;
  this.yb = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var $x_2 = outer.dW(this.yb);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> (~n)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (x_$_lo & lo);
    var hi$1 = (x_$_hi & hi);
    var $x_1_$_lo = lo$1;
    var $x_1_$_hi = hi$1;
  } else {
    var $x_3 = outer.dW(0);
    var $x_1_$_lo = $x_3.l;
    var $x_1_$_hi = $x_3.h;
  }
  this.zs = $x_1_$_lo;
  this.zt = $x_1_$_hi;
}
$p = $c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
}
$h_sc_BitSetOps$$anon$1.prototype = $p;
$p.f = (function() {
  while (true) {
    var x_$_lo = this.zs;
    var x_$_hi = this.zt;
    if (((x_$_lo | x_$_hi) === 0)) {
      if ((((1 + this.yb) | 0) >= this.Rs.hh())) {
        return false;
      }
      this.yb = ((1 + this.yb) | 0);
      var $x_1 = this.Rs.dW(this.yb);
      this.zs = $x_1.l;
      this.zt = $x_1.h;
    } else {
      break;
    }
  }
  return true;
});
$p.jx = (function() {
  if (this.f()) {
    var l_$_lo = this.zs;
    var l_$_hi = this.zt;
    var bitPos = ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0));
    var x$1_$_lo = this.zs;
    var x$1_$_hi = this.zt;
    var x_$_lo = this.zs;
    var x_$_hi = this.zt;
    var lo = ((x_$_lo - 1) | 0);
    var hi = ((((x_$_hi - 1) | 0) + ((lo !== (-1)) | 0)) | 0);
    var lo$1 = (x$1_$_lo & lo);
    var hi$1 = (x$1_$_hi & hi);
    this.zs = lo$1;
    this.zt = hi$1;
    return (((this.yb << 6) + bitPos) | 0);
  } else {
    return ($m_sc_Iterator$().aZ.e() | 0);
  }
});
$p.e = (function() {
  return this.jx();
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().i($c_sc_BitSetOps$$anon$1, "scala.collection.BitSetOps$$anon$1", ({
  wg: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.CF = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate);
}
$p = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$p.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $p;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().i($c_sc_ClassTagSeqFactory$AnySeqDelegate, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", ({
  wn: 1,
  wm: 1,
  a: 1,
  U: 1,
  ak: 1
}));
function $f_sc_IndexedSeqOps__prepended__O__O($thiz, elem) {
  return $thiz.b4().bp($ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, $thiz));
}
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.de(new $c_sc_IndexedSeqView$Take($thiz, n));
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.de($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n));
}
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.de($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n));
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.b4().bp($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f));
}
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.de(new $c_sc_IndexedSeqView$Reverse($thiz));
}
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.c())) {
    return $thiz.at(0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.eH() : $thiz.g())));
  }
}
function $f_sc_IndexedSeqOps__headOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.W()));
}
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.c())) {
    return $thiz.at((($thiz.F() - 1) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.eH() : $thiz.g())));
  }
}
function $f_sc_Iterable__toString__T($thiz) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, ($thiz.eH() + "("), ", ", ")");
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.q)));
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.q)));
}
/** @constructor */
function $c_sc_Iterator$$anon$10(f$10, outer) {
  this.aak = null;
  this.CG = null;
  this.yd = 0;
  this.Rx = null;
  this.aak = f$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Rx = outer;
  this.CG = $m_sc_Iterator$().aZ;
  this.yd = (-1);
}
$p = $c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
}
$h_sc_Iterator$$anon$10.prototype = $p;
$p.awu = (function() {
  this.CG = $m_sc_Iterator$().aZ;
  this.CG = this.aak.p(this.Rx.e()).l();
  this.yd = (-1);
});
$p.f = (function() {
  if ((this.yd === (-1))) {
    while ((!this.CG.f())) {
      if ((!this.Rx.f())) {
        this.yd = 0;
        this.CG = $m_sc_Iterator$().aZ;
        return false;
      }
      this.awu();
    }
    this.yd = 1;
    return true;
  } else {
    return (this.yd === 1);
  }
});
$p.e = (function() {
  if (this.f()) {
    this.yd = (-1);
  }
  return this.CG.e();
});
var $d_sc_Iterator$$anon$10 = new $TypeData().i($c_sc_Iterator$$anon$10, "scala.collection.Iterator$$anon$10", ({
  wA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$14(that$1, outer) {
  this.La = null;
  this.L9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.L9 = outer;
  this.La = that$1.l();
}
$p = $c_sc_Iterator$$anon$14.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$14;
/** @constructor */
function $h_sc_Iterator$$anon$14() {
}
$h_sc_Iterator$$anon$14.prototype = $p;
$p.G = (function() {
  var x = this.L9.G();
  var that = this.La.G();
  return ((x < that) ? x : that);
});
$p.f = (function() {
  return (this.L9.f() && this.La.f());
});
$p.kS = (function() {
  return new $c_T2(this.L9.e(), this.La.e());
});
$p.e = (function() {
  return this.kS();
});
var $d_sc_Iterator$$anon$14 = new $TypeData().i($c_sc_Iterator$$anon$14, "scala.collection.Iterator$$anon$14", ({
  wB: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.Lc = 0;
  this.Lb = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lb = outer;
  this.Lc = 0;
}
$p = $c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
}
$h_sc_Iterator$$anon$16.prototype = $p;
$p.G = (function() {
  return this.Lb.G();
});
$p.f = (function() {
  return this.Lb.f();
});
$p.kS = (function() {
  var ret = new $c_T2(this.Lb.e(), this.Lc);
  this.Lc = ((1 + this.Lc) | 0);
  return ret;
});
$p.e = (function() {
  return this.kS();
});
var $d_sc_Iterator$$anon$16 = new $TypeData().i($c_sc_Iterator$$anon$16, "scala.collection.Iterator$$anon$16", ({
  wC: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$19() {
}
$p = $c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
}
$h_sc_Iterator$$anon$19.prototype = $p;
$p.f = (function() {
  return false;
});
$p.awr = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
});
$p.G = (function() {
  return 0;
});
$p.e = (function() {
  this.awr();
});
$p.mL = (function(from, until) {
  return this;
});
var $d_sc_Iterator$$anon$19 = new $TypeData().i($c_sc_Iterator$$anon$19, "scala.collection.Iterator$$anon$19", ({
  wD: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$20(a$2) {
  this.aal = null;
  this.GG = false;
  this.aal = a$2;
  this.GG = false;
}
$p = $c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
}
$h_sc_Iterator$$anon$20.prototype = $p;
$p.f = (function() {
  return (!this.GG);
});
$p.e = (function() {
  if (this.GG) {
    return $m_sc_Iterator$().aZ.e();
  } else {
    this.GG = true;
    return this.aal;
  }
});
$p.mL = (function(from, until) {
  return (((this.GG || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().aZ : this);
});
var $d_sc_Iterator$$anon$20 = new $TypeData().i($c_sc_Iterator$$anon$20, "scala.collection.Iterator$$anon$20", ({
  wE: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3(z$1, op$1, outer) {
  this.GI = null;
  this.GH = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.GH = outer;
  this.GI = new $c_sc_Iterator$$anon$3$$anon$4(z$1, op$1, this);
}
$p = $c_sc_Iterator$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3;
/** @constructor */
function $h_sc_Iterator$$anon$3() {
}
$h_sc_Iterator$$anon$3.prototype = $p;
$p.G = (function() {
  return this.GI.G();
});
$p.e = (function() {
  return this.GI.e();
});
$p.f = (function() {
  return this.GI.f();
});
var $d_sc_Iterator$$anon$3 = new $TypeData().i($c_sc_Iterator$$anon$3, "scala.collection.Iterator$$anon$3", ({
  wG: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4(z$4, op$3, outer) {
  this.Ry = null;
  this.aam = null;
  this.CH = null;
  this.Ry = z$4;
  this.aam = op$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.CH = outer;
}
$p = $c_sc_Iterator$$anon$3$$anon$4.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3$$anon$4;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4() {
}
$h_sc_Iterator$$anon$3$$anon$4.prototype = $p;
$p.G = (function() {
  var thisSize = this.CH.GH.G();
  return ((thisSize < 0) ? (-1) : ((1 + thisSize) | 0));
});
$p.f = (function() {
  return true;
});
$p.e = (function() {
  this.CH.GI = new $c_sc_Iterator$$anon$3$$anon$4$$anon$5(this.Ry, this);
  return this.Ry;
});
var $d_sc_Iterator$$anon$3$$anon$4 = new $TypeData().i($c_sc_Iterator$$anon$3$$anon$4, "scala.collection.Iterator$$anon$3$$anon$4", ({
  wH: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4$$anon$5(z$3, outer) {
  this.Ld = null;
  this.GJ = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.GJ = outer;
  this.Ld = z$3;
}
$p = $c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$3$$anon$4$$anon$5;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4$$anon$5() {
}
$h_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = $p;
$p.e = (function() {
  this.Ld = this.GJ.aam.cm(this.Ld, this.GJ.CH.GH.e());
  return this.Ld;
});
$p.f = (function() {
  return this.GJ.CH.GH.f();
});
$p.G = (function() {
  return this.GJ.CH.GH.G();
});
var $d_sc_Iterator$$anon$3$$anon$4$$anon$5 = new $TypeData().i($c_sc_Iterator$$anon$3$$anon$4$$anon$5, "scala.collection.Iterator$$anon$3$$anon$4$$anon$5", ({
  wI: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$6(p$5, isFlipped$2, outer) {
  this.aao = null;
  this.aan = false;
  this.Le = null;
  this.Lf = false;
  this.GK = null;
  this.aao = p$5;
  this.aan = isFlipped$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.GK = outer;
  this.Lf = false;
}
$p = $c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
}
$h_sc_Iterator$$anon$6.prototype = $p;
$p.f = (function() {
  if (this.Lf) {
    return true;
  } else {
    if ((!this.GK.f())) {
      return false;
    }
    this.Le = this.GK.e();
    while (((!(!this.aao.p(this.Le))) === this.aan)) {
      if ((!this.GK.f())) {
        return false;
      }
      this.Le = this.GK.e();
    }
    this.Lf = true;
    return true;
  }
});
$p.e = (function() {
  if (this.f()) {
    this.Lf = false;
    return this.Le;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().i($c_sc_Iterator$$anon$6, "scala.collection.Iterator$$anon$6", ({
  wJ: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$8(f$8, outer) {
  this.aar = null;
  this.aat = null;
  this.Lg = false;
  this.aas = null;
  this.RA = null;
  this.aar = f$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.RA = outer;
  this.aat = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.Lg = false;
}
$p = $c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
}
$h_sc_Iterator$$anon$8.prototype = $p;
$p.f = (function() {
  while (true) {
    if (this.Lg) {
      return true;
    } else if (this.RA.f()) {
      var a = this.RA.e();
      if ((!this.aat.qA(this.aar.p(a)))) {
        continue;
      }
      this.aas = a;
      this.Lg = true;
      return true;
    } else {
      return false;
    }
  }
});
$p.e = (function() {
  if (this.f()) {
    this.Lg = false;
    return this.aas;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().i($c_sc_Iterator$$anon$8, "scala.collection.Iterator$$anon$8", ({
  wL: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$9(f$9, outer) {
  this.aau = null;
  this.Lh = null;
  this.aau = f$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lh = outer;
}
$p = $c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
}
$h_sc_Iterator$$anon$9.prototype = $p;
$p.G = (function() {
  return this.Lh.G();
});
$p.f = (function() {
  return this.Lh.f();
});
$p.e = (function() {
  return this.aau.p(this.Lh.e());
});
var $d_sc_Iterator$$anon$9 = new $TypeData().i($c_sc_Iterator$$anon$9, "scala.collection.Iterator$$anon$9", ({
  wM: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (true) {
    if (($thiz.ia instanceof $c_sc_Iterator$ConcatIterator)) {
      var c = $thiz.ia;
      $thiz.ia = c.ia;
      $thiz.tq = c.tq;
      if ((c.kk !== null)) {
        if (($thiz.kj === null)) {
          $thiz.kj = c.kj;
        }
        var x$proxy10 = c.kj;
        if ((x$proxy10 === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        x$proxy10.GL = $thiz.kk;
        $thiz.kk = c.kk;
      }
    } else {
      return (void 0);
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.kk === null)) {
      $thiz.ia = null;
      $thiz.kj = null;
      return false;
    } else {
      $thiz.ia = $thiz.kk.auH();
      if (($thiz.kj === $thiz.kk)) {
        var x$proxy12 = $thiz.kj;
        if ((x$proxy12 === null)) {
          $m_sr_Scala3RunTime$().bW();
        }
        $thiz.kj = x$proxy12.GL;
      }
      $thiz.kk = $thiz.kk.GL;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.tq) {
        return true;
      } else {
        if ((!(($thiz.ia !== null) && $thiz.ia.f()))) {
          continue;
        }
        $thiz.tq = true;
        return true;
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(from) {
  this.ia = null;
  this.kk = null;
  this.kj = null;
  this.tq = false;
  this.ia = from;
  this.kk = null;
  this.kj = null;
  this.tq = false;
}
$p = $c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
}
$h_sc_Iterator$ConcatIterator.prototype = $p;
$p.f = (function() {
  if (this.tq) {
    return true;
  } else if ((this.ia !== null)) {
    if (this.ia.f()) {
      this.tq = true;
      return true;
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this);
    }
  } else {
    return false;
  }
});
$p.e = (function() {
  if (this.f()) {
    this.tq = false;
    var x$proxy13 = this.ia;
    if ((x$proxy13 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return x$proxy13.e();
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
$p.kH = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.kk === null)) {
    this.kk = c;
    this.kj = c;
  } else {
    var x$proxy14 = this.kj;
    if ((x$proxy14 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    x$proxy14.GL = c;
    this.kj = c;
  }
  if ((this.ia === null)) {
    this.ia = $m_sc_Iterator$().aZ;
  }
  return this;
});
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gZ)));
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().i($c_sc_Iterator$ConcatIterator, "scala.collection.Iterator$ConcatIterator", ({
  gZ: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.q8 > 0)) {
    if ($thiz.tr.f()) {
      $thiz.tr.e();
      $thiz.q8 = (($thiz.q8 - 1) | 0);
    } else {
      $thiz.q8 = 0;
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.j2 < 0)) {
    return (-1);
  } else {
    var that = (($thiz.j2 - lo$1) | 0);
    return ((that < 0) ? 0 : that);
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.tr = null;
  this.j2 = 0;
  this.q8 = 0;
  this.tr = underlying;
  this.j2 = limit;
  this.q8 = start;
}
$p = $c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
}
$h_sc_Iterator$SliceIterator.prototype = $p;
$p.G = (function() {
  var size = this.tr.G();
  if ((size < 0)) {
    return (-1);
  } else {
    var that = ((size - this.q8) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.j2 < 0)) {
      return dropSize;
    } else {
      var x = this.j2;
      return ((x < dropSize) ? x : dropSize);
    }
  }
});
$p.f = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.j2 !== 0) && this.tr.f());
});
$p.e = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.j2 > 0)) {
    this.j2 = ((this.j2 - 1) | 0);
    return this.tr.e();
  } else {
    return ((this.j2 < 0) ? this.tr.e() : $m_sc_Iterator$().aZ.e());
  }
});
$p.mL = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
  } else if ((until <= lo)) {
    var rest = 0;
  } else if ((this.j2 < 0)) {
    var rest = ((until - lo) | 0);
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that);
  }
  var sum = ((this.q8 + lo) | 0);
  if ((rest === 0)) {
    return $m_sc_Iterator$().aZ;
  } else if ((sum < 0)) {
    this.q8 = 2147483647;
    this.j2 = 0;
    return $f_sc_Iterator__concat__F0__sc_Iterator(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$SliceIterator(this.tr, ((sum - 2147483647) | 0), rest))));
  } else {
    this.q8 = sum;
    this.j2 = rest;
    return this;
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().i($c_sc_Iterator$SliceIterator, "scala.collection.Iterator$SliceIterator", ({
  wO: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $f_sc_LinearSeqOps__headOption__s_Option($thiz) {
  return ($thiz.c() ? $m_s_None$() : new $c_s_Some($thiz.W()));
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $thiz;
  var len = 0;
  while ((!these.c())) {
    len = ((1 + len) | 0);
    these = these.ak();
  }
  return len;
}
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last");
  } else {
    var these = $thiz;
    var scout = $thiz.VE();
    while ((!scout.c())) {
      these = scout;
      scout = scout.ak();
    }
    return these.W();
  }
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__I__sc_LinearSeq__I($thiz, len, 0, $thiz));
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.cp(x) > 0));
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  var skipped = $thiz.bo(n);
  if (skipped.c()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return skipped.W();
}
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.c())) {
    if ((!(!(!p.p(these.W()))))) {
      return false;
    }
    these = these.ak();
  }
  return true;
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.c())) {
    if ((!(!p.p(these.W())))) {
      return true;
    }
    these = these.ak();
  }
  return false;
}
function $f_sc_LinearSeqOps__contains__O__Z($thiz, elem) {
  var these = $thiz;
  while ((!these.c())) {
    if ($m_sr_BoxesRunTime$().B(these.W(), elem)) {
      return true;
    }
    these = these.ak();
  }
  return false;
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $thiz;
  while ((!these.c())) {
    acc = op.cm(acc, these.W());
    these = these.ak();
  }
  return acc;
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  return ($is_sc_LinearSeq(that) ? $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $thiz, that) : $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that));
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $thiz.bo(from);
  while ((!these.c())) {
    if ((!(!p.p(these.W())))) {
      return i;
    }
    i = ((1 + i) | 0);
    these = these.ak();
  }
  return (-1);
}
function $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I($thiz, p, end) {
  var i = 0;
  var these = $thiz;
  var last = (-1);
  while (((!these.c()) && (i <= end))) {
    if ((!(!p.p(these.W())))) {
      last = i;
    }
    these = these.ak();
    i = ((1 + i) | 0);
  }
  return last;
}
function $p_sc_LinearSeqOps__loop$1__I__I__sc_LinearSeq__I($thiz, len$1, i, xs) {
  var xs$tailLocal1 = xs;
  var i$tailLocal1 = i;
  while (true) {
    if ((i$tailLocal1 === len$1)) {
      return ((!xs$tailLocal1.c()) | 0);
    } else {
      if ((!xs$tailLocal1.c())) {
        var i$tailLocal1$tmp1 = ((1 + i$tailLocal1) | 0);
        var xs$tailLocal1$tmp1 = xs$tailLocal1.ak();
        i$tailLocal1 = i$tailLocal1$tmp1;
        xs$tailLocal1 = xs$tailLocal1$tmp1;
        continue;
      }
      return (-1);
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  var b$tailLocal1 = b;
  var a$tailLocal1 = a;
  while (true) {
    if ((a$tailLocal1 === b$tailLocal1)) {
      return true;
    } else {
      if ((((!a$tailLocal1.c()) && (!b$tailLocal1.c())) && $m_sr_BoxesRunTime$().B(a$tailLocal1.W(), b$tailLocal1.W()))) {
        var a$tailLocal1$tmp1 = a$tailLocal1.ak();
        var b$tailLocal1$tmp1 = b$tailLocal1.ak();
        a$tailLocal1 = a$tailLocal1$tmp1;
        b$tailLocal1 = b$tailLocal1$tmp1;
        continue;
      }
      return (a$tailLocal1.c() && b$tailLocal1.c());
    }
  }
}
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.RD = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.RD = outer.l();
}
$p = $c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
}
$h_sc_MapOps$$anon$2.prototype = $p;
$p.f = (function() {
  return this.RD.f();
});
$p.e = (function() {
  return this.RD.e().P();
});
var $d_sc_MapOps$$anon$2 = new $TypeData().i($c_sc_MapOps$$anon$2, "scala.collection.MapOps$$anon$2", ({
  wS: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.RE = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.RE = outer.l();
}
$p = $c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
}
$h_sc_MapOps$$anon$3.prototype = $p;
$p.f = (function() {
  return this.RE.f();
});
$p.e = (function() {
  return this.RE.e().V();
});
var $d_sc_MapOps$$anon$3 = new $TypeData().i($c_sc_MapOps$$anon$3, "scala.collection.MapOps$$anon$3", ({
  wT: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_Seq$() {
  this.o1 = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$());
}
$p = $c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
}
$h_sc_Seq$.prototype = $p;
var $d_sc_Seq$ = new $TypeData().i($c_sc_Seq$, "scala.collection.Seq$", ({
  wZ: 1,
  bq: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$();
  }
  return $n_sc_Seq$;
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  matchAlts1: {
    matchAlts2: {
      if (($thiz instanceof $c_sci_Set$Set1)) {
        break matchAlts2;
      }
      if (($thiz instanceof $c_sci_Set$Set2)) {
        break matchAlts2;
      }
      if (($thiz instanceof $c_sci_Set$Set3)) {
        break matchAlts2;
      }
      if (($thiz instanceof $c_sci_Set$Set4)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    var result = $thiz;
    var it = that.l();
    while (it.f()) {
      result = result.kL(it.e());
    }
    return result;
  }
  return $thiz.de(($is_sc_Iterable(that) ? new $c_sc_View$Concat($thiz, that) : $thiz.l().kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => that.l())))));
}
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.GT = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.GT = outer;
}
$p = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $p;
$p.f = (function() {
  return (!this.GT.c());
});
$p.e = (function() {
  var r = this.GT.W();
  this.GT = this.GT.ak();
  return r;
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().i($c_sc_StrictOptimizedLinearSeqOps$$anon$1, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", ({
  x9: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.fy;
  while (true) {
    if (($thiz.fy < $thiz.yi)) {
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var this$ = $thiz.GU;
      var i = $thiz.fy;
      var c = this$.charCodeAt(i);
      var $x_1 = (!((c === 10) || (c === 13)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.fy = ((1 + $thiz.fy) | 0);
    } else {
      break;
    }
  }
  var end = $thiz.fy;
  if (($thiz.fy < $thiz.yi)) {
    $m_sc_StringOps$();
    var this$$2 = $thiz.GU;
    var i$1 = $thiz.fy;
    var c$1 = this$$2.charCodeAt(i$1);
    $thiz.fy = ((1 + $thiz.fy) | 0);
    if ((($thiz.fy < $thiz.yi) && ($m_sc_StringOps$(), $m_sc_StringOps$(), (((13 ^ c$1) | (10 ^ $thiz.GU.charCodeAt($thiz.fy))) === 0)))) {
      $thiz.fy = ((1 + $thiz.fy) | 0);
    }
    if ((!$thiz.aaK)) {
      end = $thiz.fy;
    }
  }
  var this$6 = $thiz.GU;
  var endIndex = end;
  return this$6.substring(start, endIndex);
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.GU = null;
  this.aaK = false;
  this.yi = 0;
  this.fy = 0;
  this.GU = \u03b4this$2;
  this.aaK = stripped$1;
  this.yi = \u03b4this$2.length;
  this.fy = 0;
}
$p = $c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
}
$h_sc_StringOps$$anon$1.prototype = $p;
$p.f = (function() {
  return (this.fy < this.yi);
});
$p.aj0 = (function() {
  return ((this.fy >= this.yi) ? $m_sc_Iterator$().aZ.e() : $p_sc_StringOps$$anon$1__advance__T(this));
});
$p.e = (function() {
  return this.aj0();
});
var $d_sc_StringOps$$anon$1 = new $TypeData().i($c_sc_StringOps$$anon$1, "scala.collection.StringOps$$anon$1", ({
  xb: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.CQ = null;
  this.Lr = 0;
  this.tt = 0;
  this.mi = 0;
  this.GZ = null;
  this.CQ = underlying;
  this.Lr = maxlen;
  this.tt = (-1);
  this.mi = 0;
}
$p = $c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
}
$h_sc_View$DropRightIterator.prototype = $p;
$p.auT = (function() {
  if ((this.GZ === null)) {
    var x = this.Lr;
    this.GZ = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.mi < this.Lr) && this.CQ.f())) {
      this.GZ.Ia(this.CQ.e());
      this.mi = ((1 + this.mi) | 0);
    }
    if ((!this.CQ.f())) {
      this.tt = 0;
    }
    this.mi = 0;
  }
});
$p.G = (function() {
  return this.tt;
});
$p.f = (function() {
  this.auT();
  return (this.tt !== 0);
});
$p.e = (function() {
  if ((!this.f())) {
    return $m_sc_Iterator$().aZ.e();
  } else {
    var x$proxy4 = this.GZ;
    if ((x$proxy4 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var x = x$proxy4.at(this.mi);
    if ((this.tt === (-1))) {
      var x$proxy5 = this.GZ;
      if ((x$proxy5 === null)) {
        $m_sr_Scala3RunTime$().bW();
      }
      x$proxy5.hQ(this.mi, this.CQ.e());
      if ((!this.CQ.f())) {
        this.tt = 0;
      }
    } else {
      this.tt = ((this.tt - 1) | 0);
    }
    this.mi = ((1 + this.mi) | 0);
    if ((this.mi === this.Lr)) {
      this.mi = 0;
    }
    return x;
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().i($c_sc_View$DropRightIterator, "scala.collection.View$DropRightIterator", ({
  xi: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.cE = 0;
  $thiz.o4 = 0;
  $thiz.fA = (-1);
  return $thiz;
}
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.ib === null)) {
    $thiz.ib = new $ac_I(($m_sci_Node$().H6 << 1));
    $thiz.o5 = new ($d_sci_Node.r().C)($m_sci_Node$().H6);
  }
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.IK()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode);
  }
  if (rootNode.Ea()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode);
  }
  return $thiz;
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.g0 = node;
  $thiz.cE = 0;
  $thiz.o4 = node.J4();
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.fA = ((1 + $thiz.fA) | 0);
  var cursorIndex = ($thiz.fA << 1);
  var lengthIndex = ((1 + ($thiz.fA << 1)) | 0);
  $thiz.o5.a[$thiz.fA] = node;
  $thiz.ib.a[cursorIndex] = 0;
  $thiz.ib.a[lengthIndex] = node.IY();
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.fA = (($thiz.fA - 1) | 0);
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.fA >= 0)) {
    var cursorIndex = ($thiz.fA << 1);
    var lengthIndex = ((1 + ($thiz.fA << 1)) | 0);
    var nodeCursor = $thiz.ib.a[cursorIndex];
    if ((nodeCursor < $thiz.ib.a[lengthIndex])) {
      var \u03b41$ = $thiz.ib;
      \u03b41$.a[cursorIndex] = ((1 + \u03b41$.a[cursorIndex]) | 0);
      var nextNode = $thiz.o5.a[$thiz.fA].IH(nodeCursor);
      if (nextNode.IK()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode);
      }
      if (nextNode.Ea()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true;
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz);
    }
  }
  return false;
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
}
$p = $c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
}
$h_sci_ChampBaseIterator.prototype = $p;
$p.f = (function() {
  return ((this.cE < this.o4) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this));
});
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.h0 = (-1);
  $thiz.hw = (-1);
  $thiz.yp = new $ac_I(((1 + $m_sci_Node$().H6) | 0));
  $thiz.yq = new ($d_sci_Node.r().C)(((1 + $m_sci_Node$().H6) | 0));
  return $thiz;
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz;
}
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.tu = node;
  $thiz.h0 = ((node.J4() - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.hw = ((1 + $thiz.hw) | 0);
  $thiz.yq.a[$thiz.hw] = node;
  $thiz.yp.a[$thiz.hw] = ((node.IY() - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.hw = (($thiz.hw - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.hw >= 0)) {
    var nodeCursor = $thiz.yp.a[$thiz.hw];
    $thiz.yp.a[$thiz.hw] = ((nodeCursor - 1) | 0);
    if ((nodeCursor >= 0)) {
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, $thiz.yq.a[$thiz.hw].IH(nodeCursor));
    } else {
      var currNode = $thiz.yq.a[$thiz.hw];
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.Ea()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true;
      }
    }
  }
  return false;
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.h0 = 0;
  this.tu = null;
  this.hw = 0;
  this.yp = null;
  this.yq = null;
}
$p = $c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
}
$h_sci_ChampBaseReverseIterator.prototype = $p;
$p.f = (function() {
  return ((this.h0 >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this));
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.CU !== null);
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.a.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.kI(bitpos);
  var idx = (dataIx << 1);
  var src = bm.e6;
  var dst = new $ac_O(((2 + src.a.length) | 0));
  src.av(0, dst, 0, idx);
  dst.a[idx] = key;
  dst.a[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.a.length - idx) | 0);
  src.av(idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.hv, dataIx, originalHash);
  bm.bZ = (bm.bZ | bitpos);
  bm.e6 = dst;
  bm.hv = dstHashes;
  bm.e7 = ((1 + bm.e7) | 0);
  bm.hu = ((bm.hu + keyHash) | 0);
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz);
  }
  $thiz.CU = null;
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.o7 = $thiz.o7.agh();
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.CU = null;
  this.o7 = null;
  this.o7 = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().Rm, $m_s_Array$EmptyArrays$().Gz, 0, 0);
}
$p = $c_sci_HashMapBuilder.prototype = new $h_O();
$p.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
}
$h_sci_HashMapBuilder.prototype = $p;
$p.dk = (function(size) {
});
$p.EG = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var mask = $m_sci_Node$().fp(keyHash, shift);
    var bitpos = $m_sci_Node$().cS(mask);
    if (((mapNode.bZ & bitpos) !== 0)) {
      var index = $m_sci_Node$().fn(mapNode.bZ, mask, bitpos);
      var key0 = mapNode.jr(index);
      var key0UnimprovedHash = mapNode.d1(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().B(key0, key))) {
        mapNode.e6.a[((1 + (index << 1)) | 0)] = value;
        return (void 0);
      } else {
        var value0 = mapNode.ip(index);
        var key0Hash = $m_sc_Hashing$().bV(key0UnimprovedHash);
        var subNodeNew = mapNode.V2(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        mapNode.awg(bitpos, key0Hash, subNodeNew);
        return (void 0);
      }
    } else if (((mapNode.cU & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().fn(mapNode.cU, mask, bitpos);
      var subNode = mapNode.io(index$2);
      var beforeSize = subNode.aH();
      var beforeHash = subNode.dR();
      this.EG(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      mapNode.e7 = ((mapNode.e7 + ((subNode.aH() - beforeSize) | 0)) | 0);
      mapNode.hu = ((mapNode.hu + ((subNode.dR() - beforeHash) | 0)) | 0);
      return (void 0);
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, mapNode, bitpos, key, originalHash, keyHash, value);
      return (void 0);
    }
  }
  if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var index$3 = mapNode.Ee(key);
    if ((index$3 < 0)) {
      mapNode.dy = mapNode.dy.fH(new $c_T2(key, value));
      return (void 0);
    } else {
      mapNode.dy = mapNode.dy.qQ(index$3, new $c_T2(key, value));
      return (void 0);
    }
  }
  throw new $c_s_MatchError(mapNode);
});
$p.Vg = (function() {
  if ((this.o7.e7 === 0)) {
    return $m_sci_HashMap$().kr;
  } else if ((this.CU !== null)) {
    return this.CU;
  } else {
    this.CU = new $c_sci_HashMap(this.o7);
    return this.CU;
  }
});
$p.afz = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().k(elem.P());
  var im = $m_sc_Hashing$().bV(h);
  this.EG(this.o7, elem.P(), elem.V(), h, im, 0);
  return this;
});
$p.zu = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().k(key);
  this.EG(this.o7, key, value, originalHash, $m_sc_Hashing$().bV(originalHash), 0);
  return this;
});
$p.Tw = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    new $c_sci_HashMapBuilder$$anon$1(xs, this);
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.aj1();
    while (iter.f()) {
      var next = iter.e();
      var improvedHash = next.jb;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().bV(originalHash);
      this.EG(this.o7, next.ku, next.h6, originalHash, hash, 0);
    }
  } else if (false) {
    var iter$2 = xs.atw();
    while (iter$2.f()) {
      var next$2 = iter$2.e();
      var originalHash$2 = xs.aEJ(next$2.auE());
      var hash$2 = $m_sc_Hashing$().bV(originalHash$2);
      this.EG(this.o7, next$2.avU(), next$2.akt(), originalHash$2, hash$2, 0);
    }
  } else if ($is_sci_Map(xs)) {
    xs.jo(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2, value$2) => this.zu(key$2, value$2))));
  } else {
    var it = xs.l();
    while (it.f()) {
      this.afz(it.e());
    }
  }
  return this;
});
$p.aR = (function() {
  return this.Vg();
});
$p.aD = (function(elem) {
  return this.afz(elem);
});
$p.cz = (function(elems) {
  return this.Tw(elems);
});
var $d_sci_HashMapBuilder = new $TypeData().i($c_sci_HashMapBuilder, "scala.collection.immutable.HashMapBuilder", ({
  xy: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.ys !== null);
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.a.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.a.length) | 0));
  as.av(0, result, 0, ix);
  result.a[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.a.length - ix) | 0);
  as.av(ix, result, destPos, length);
  return result;
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.kI(bitpos);
  var src = bm.e8;
  var dst = new $ac_O(((1 + src.a.length) | 0));
  src.av(0, dst, 0, dataIx);
  dst.a[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.a.length - dataIx) | 0);
  src.av(dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.fz, dataIx, originalHash);
  bm.bm = (bm.bm | bitpos);
  bm.e8 = dst;
  bm.fz = dstHashes;
  bm.df = ((1 + bm.df) | 0);
  bm.fZ = ((bm.fZ + keyHash) | 0);
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.kI(bitpos);
  bm.e8.a[dataIx] = elem;
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz);
  }
  $thiz.ys = null;
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.yt = $thiz.yt.agi();
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.ys = null;
  this.yt = null;
  this.ys = null;
  this.yt = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().Rm, $m_s_Array$EmptyArrays$().Gz, 0, 0);
}
$p = $c_sci_HashSetBuilder.prototype = new $h_O();
$p.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
}
$h_sci_HashSetBuilder.prototype = $p;
$p.dk = (function(size) {
});
$p.VK = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var mask = $m_sci_Node$().fp(elementHash, shift);
    var bitpos = $m_sci_Node$().cS(mask);
    if (((setNode.bm & bitpos) !== 0)) {
      var index = $m_sci_Node$().fn(setNode.bm, mask, bitpos);
      var element0 = setNode.dJ(index);
      var element0UnimprovedHash = setNode.d1(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().B(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, setNode, bitpos, element0);
        return (void 0);
      } else {
        var element0Hash = $m_sc_Hashing$().bV(element0UnimprovedHash);
        var subNodeNew = setNode.IX(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        setNode.aiR(bitpos, element0Hash, subNodeNew);
        return (void 0);
      }
    } else if (((setNode.c1 & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().fn(setNode.c1, mask, bitpos);
      var subNode = setNode.fl(index$2);
      var beforeSize = subNode.aH();
      var beforeHashCode = subNode.dR();
      this.VK(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      setNode.df = ((setNode.df + ((subNode.aH() - beforeSize) | 0)) | 0);
      setNode.fZ = ((setNode.fZ + ((subNode.dR() - beforeHashCode) | 0)) | 0);
      return (void 0);
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, setNode, bitpos, element, originalHash, elementHash);
      return (void 0);
    }
  }
  if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(setNode.dl, element, 0);
    if ((index$3 < 0)) {
      setNode.dl = setNode.dl.fH(element);
      return (void 0);
    } else {
      setNode.dl = setNode.dl.qQ(index$3, element);
      return (void 0);
    }
  }
  throw new $c_s_MatchError(setNode);
});
$p.Vh = (function() {
  if ((this.yt.df === 0)) {
    return $m_sci_HashSet$().CV;
  } else if ((this.ys !== null)) {
    return this.ys;
  } else {
    this.ys = new $c_sci_HashSet(this.yt);
    return this.ys;
  }
});
$p.M9 = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().k(elem);
  var im = $m_sc_Hashing$().bV(h);
  this.VK(this.yt, elem, h, im, 0);
  return this;
});
$p.Tx = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    new $c_sci_HashSetBuilder$$anon$1(xs, this);
  } else {
    var it = xs.l();
    while (it.f()) {
      this.M9(it.e());
    }
  }
  return this;
});
$p.aR = (function() {
  return this.Vh();
});
$p.aD = (function(elem) {
  return this.M9(elem);
});
$p.cz = (function(elems) {
  return this.Tx(elems);
});
var $d_sci_HashSetBuilder = new $TypeData().i($c_sci_HashSetBuilder, "scala.collection.immutable.HashSetBuilder", ({
  xB: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.o1 = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$());
}
$p = $c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
$h_sci_IndexedSeq$.prototype = $p;
$p.oK = (function(it) {
  return ($is_sci_IndexedSeq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.zH.call(this, it));
});
$p.zH = (function(it) {
  return this.oK(it);
});
$p.bp = (function(source) {
  return this.oK(source);
});
var $d_sci_IndexedSeq$ = new $TypeData().i($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  xD: 1,
  bq: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.CW = null;
  this.aaY = null;
  this.Iq();
}
$p = $c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$p.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
}
$h_sci_LazyList$LazyBuilder.prototype = $p;
$p.dk = (function(size) {
});
$p.Iq = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.aaY = ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.Ub()))));
  this.CW = deferred;
});
$p.axr = (function() {
  this.CW.UH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().aM)));
  return this.aaY;
});
$p.am3 = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.CW.UH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.Ub())))));
  })));
  this.CW = deferred;
  return this;
});
$p.alS = (function(xs) {
  if ((xs.G() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.CW.UH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().No(xs.l(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.Ub()))))));
    this.CW = deferred;
  }
  return this;
});
$p.aR = (function() {
  return this.axr();
});
$p.aD = (function(elem) {
  return this.am3(elem);
});
$p.cz = (function(elems) {
  return this.alS(elems);
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().i($c_sci_LazyList$LazyBuilder, "scala.collection.immutable.LazyList$LazyBuilder", ({
  xJ: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.CX = null;
  this.CX = lazyList;
}
$p = $c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
}
$h_sci_LazyList$LazyIterator.prototype = $p;
$p.f = (function() {
  return (!($p_sci_LazyList__evaluated__sci_LazyList(this.CX) === $m_sci_LazyList$().aM));
});
$p.e = (function() {
  if (($p_sci_LazyList__evaluated__sci_LazyList(this.CX) === $m_sci_LazyList$().aM)) {
    return $m_sc_Iterator$().aZ.e();
  } else {
    var res = this.CX.W();
    this.CX = this.CX.cq();
    return res;
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().i($c_sci_LazyList$LazyIterator, "scala.collection.immutable.LazyList$LazyIterator", ({
  xL: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_List$() {
  this.H2 = null;
  $n_sci_List$ = this;
  var _1 = $m_sci_Nil$();
  $m_sci_Nil$();
  this.H2 = new $c_sci_List$$anon$1();
}
$p = $c_sci_List$.prototype = new $h_O();
$p.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
}
$h_sci_List$.prototype = $p;
$p.e4 = (function(elems) {
  return $m_sci_Nil$().aY(elems);
});
$p.aP = (function() {
  return new $c_scm_ListBuffer();
});
$p.bp = (function(source) {
  return $m_sci_Nil$().aY(source);
});
$p.ce = (function() {
  return $m_sci_Nil$();
});
var $d_sci_List$ = new $TypeData().i($c_sci_List$, "scala.collection.immutable.List$", ({
  xP: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$();
  }
  return $n_sci_List$;
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.tv = outer;
  $thiz.o9 = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.o9 = 0;
  this.tv = null;
}
$p = $c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
}
$h_sci_Map$Map2$Map2Iterator.prototype = $p;
$p.f = (function() {
  return (this.o9 < 2);
});
$p.e = (function() {
  matchResult5: {
    var result;
    var x23 = this.o9;
    if ((x23 === 0)) {
      var result = this.gK(this.tv.h1, this.tv.j4);
      break matchResult5;
    }
    if ((x23 === 1)) {
      var result = this.gK(this.tv.h2, this.tv.j5);
      break matchResult5;
    }
    var result = $m_sc_Iterator$().aZ.e();
  }
  this.o9 = ((1 + this.o9) | 0);
  return result;
});
$p.ex = (function(n) {
  this.o9 = ((this.o9 + n) | 0);
  return this;
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.oa = outer;
  $thiz.ob = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.ob = 0;
  this.oa = null;
}
$p = $c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
}
$h_sci_Map$Map3$Map3Iterator.prototype = $p;
$p.f = (function() {
  return (this.ob < 3);
});
$p.e = (function() {
  var result;
  switch (this.ob) {
    case 0: {
      var result = this.gK(this.oa.gs, this.oa.ic);
      break;
    }
    case 1: {
      var result = this.gK(this.oa.g1, this.oa.hy);
      break;
    }
    case 2: {
      var result = this.gK(this.oa.g2, this.oa.hz);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().aZ.e();
    }
  }
  this.ob = ((1 + this.ob) | 0);
  return result;
});
$p.ex = (function(n) {
  this.ob = ((this.ob + n) | 0);
  return this;
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.kt = outer;
  $thiz.oc = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.oc = 0;
  this.kt = null;
}
$p = $c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
}
$h_sci_Map$Map4$Map4Iterator.prototype = $p;
$p.f = (function() {
  return (this.oc < 4);
});
$p.e = (function() {
  var result;
  switch (this.oc) {
    case 0: {
      var result = this.gK(this.kt.fB, this.kt.h3);
      break;
    }
    case 1: {
      var result = this.gK(this.kt.fh, this.kt.gt);
      break;
    }
    case 2: {
      var result = this.gK(this.kt.eZ, this.kt.g3);
      break;
    }
    case 3: {
      var result = this.gK(this.kt.f0, this.kt.g4);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().aZ.e();
    }
  }
  this.oc = ((1 + this.oc) | 0);
  return result;
});
$p.ex = (function(n) {
  this.oc = ((this.oc + n) | 0);
  return this;
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.qa = null;
  this.H4 = false;
  this.yu = null;
  this.qa = $m_sci_Map$EmptyMap$();
  this.H4 = false;
}
$p = $c_sci_MapBuilderImpl.prototype = new $h_O();
$p.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
}
$h_sci_MapBuilderImpl.prototype = $p;
$p.dk = (function(size) {
});
$p.Vi = (function() {
  return (this.H4 ? this.yu.Vg() : this.qa);
});
$p.afx = (function(key, value) {
  if (this.H4) {
    this.yu.zu(key, value);
  } else if ((this.qa.aH() < 4)) {
    this.qa = this.qa.hk(key, value);
  } else if (this.qa.az(key)) {
    this.qa = this.qa.hk(key, value);
  } else {
    this.H4 = true;
    if ((this.yu === null)) {
      this.yu = new $c_sci_HashMapBuilder();
    }
    this.qa.amZ(this.yu);
    this.yu.zu(key, value);
  }
  return this;
});
$p.afq = (function(xs) {
  return (this.H4 ? (this.yu.Tw(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.aR = (function() {
  return this.Vi();
});
$p.aD = (function(elem) {
  return this.afx(elem.P(), elem.V());
});
$p.cz = (function(elems) {
  return this.afq(elems);
});
var $d_sci_MapBuilderImpl = new $TypeData().i($c_sci_MapBuilderImpl, "scala.collection.immutable.MapBuilderImpl", ({
  y5: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_sci_Seq$() {
  this.o1 = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$());
}
$p = $c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
}
$h_sci_Seq$.prototype = $p;
$p.fM = (function(it) {
  return ($is_sci_Seq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.zH.call(this, it));
});
$p.zH = (function(it) {
  return this.fM(it);
});
$p.bp = (function(source) {
  return this.fM(source);
});
var $d_sci_Seq$ = new $TypeData().i($c_sci_Seq$, "scala.collection.immutable.Seq$", ({
  yj: 1,
  bq: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$();
  }
  return $n_sci_Seq$;
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.yy = null;
  this.H7 = false;
  this.yz = null;
  this.yy = $m_sci_Set$EmptySet$();
  this.H7 = false;
}
$p = $c_sci_SetBuilderImpl.prototype = new $h_O();
$p.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
}
$h_sci_SetBuilderImpl.prototype = $p;
$p.dk = (function(size) {
});
$p.ajq = (function() {
  return (this.H7 ? this.yz.Vh() : this.yy);
});
$p.am4 = (function(elem) {
  if (this.H7) {
    this.yz.M9(elem);
  } else if ((this.yy.aH() < 4)) {
    this.yy = this.yy.kL(elem);
  } else if ((!this.yy.az(elem))) {
    this.H7 = true;
    if ((this.yz === null)) {
      this.yz = new $c_sci_HashSetBuilder();
    }
    this.yy.an0(this.yz);
    this.yz.M9(elem);
  }
  return this;
});
$p.afr = (function(xs) {
  return (this.H7 ? (this.yz.Tx(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.aR = (function() {
  return this.ajq();
});
$p.aD = (function(elem) {
  return this.am4(elem);
});
$p.cz = (function(elems) {
  return this.afr(elems);
});
var $d_sci_SetBuilderImpl = new $TypeData().i($c_sci_SetBuilderImpl, "scala.collection.immutable.SetBuilderImpl", ({
  yt: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_sci_Vector$() {
  this.ab6 = 0;
  this.ab7 = null;
  $n_sci_Vector$ = this;
  try {
    $m_sc_StringOps$();
    var $x_1 = $m_jl_Integer$().c7($m_jl_System$SystemProperties$().Uv("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250"), 10, 214748364);
  } catch (e) {
    if (false) {
      var $x_1 = 250;
    } else {
      var $x_1;
      throw e;
    }
  }
  this.ab6 = $x_1;
  this.ab7 = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0);
}
$p = $c_sci_Vector$.prototype = new $h_O();
$p.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
}
$h_sci_Vector$.prototype = $p;
$p.e4 = (function(elems) {
  return this.E5(elems);
});
$p.E5 = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    return it;
  } else {
    var knownSize = it.G();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$();
    } else if (((((knownSize - 1) | 0) >>> 0) <= 31)) {
      matchResult3: {
        var $x_1;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x = it.e5().dK();
          if (((x !== null) && (x === $d_O.l()))) {
            var $x_1 = it.kp;
            break matchResult3;
          }
        }
        if ($is_sci_Iterable(it)) {
          var a1 = new $ac_O(knownSize);
          it.d0(a1, 0, 2147483647);
          var $x_1 = a1;
          break matchResult3;
        }
        var a1$2 = new $ac_O(knownSize);
        it.l().d0(a1$2, 0, 2147483647);
        var $x_1 = a1$2;
      }
      return new $c_sci_Vector1($x_1);
    } else {
      return new $c_sci_VectorBuilder().ul(it).ix();
    }
  }
});
$p.ce = (function() {
  return $m_sci_Vector0$();
});
$p.bp = (function(source) {
  return this.E5(source);
});
$p.aP = (function() {
  return new $c_sci_VectorBuilder();
});
var $d_sci_Vector$ = new $TypeData().i($c_sci_Vector$, "scala.collection.immutable.Vector$", ({
  yA: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$();
  }
  return $n_sci_Vector$;
}
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.cl >= 6)) {
    a = $thiz.f1;
    var i = (($thiz.bT >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      src.av(i, dest, 0, length);
    }
    var num = $thiz.bT;
    var t = (((num >> 24) >>> 7) | 0);
    var newOffset = (((33554431 & ((num + t) | 0)) - t) | 0);
    $thiz.bh = (($thiz.bh - (($thiz.bT - newOffset) | 0)) | 0);
    $thiz.bT = newOffset;
    if (((($thiz.bh >>> 25) | 0) === 0)) {
      $thiz.cl = 5;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.cl >= 5)) {
    if ((a === null)) {
      a = $thiz.dC;
    }
    var i$2 = (31 & (($thiz.bT >>> 20) | 0));
    if (($thiz.cl === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        src$1.av(i$2, dest$1, 0, length$1);
      }
      $thiz.dC = a;
      var num$1 = $thiz.bT;
      var t$1 = (((num$1 >> 19) >>> 12) | 0);
      var newOffset$1 = (((1048575 & ((num$1 + t$1) | 0)) - t$1) | 0);
      $thiz.bh = (($thiz.bh - (($thiz.bT - newOffset$1) | 0)) | 0);
      $thiz.bT = newOffset$1;
      if (((($thiz.bh >>> 20) | 0) === 0)) {
        $thiz.cl = 4;
      }
    } else {
      if ((i$2 > 0)) {
        a = $m_ju_Arrays$().bO(a, i$2, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.cl >= 4)) {
    if ((a === null)) {
      a = $thiz.cX;
    }
    var i$3 = (31 & (($thiz.bT >>> 15) | 0));
    if (($thiz.cl === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        src$2.av(i$3, dest$2, 0, length$2);
      }
      $thiz.cX = a;
      var num$2 = $thiz.bT;
      var t$2 = (((num$2 >> 14) >>> 17) | 0);
      var newOffset$2 = (((32767 & ((num$2 + t$2) | 0)) - t$2) | 0);
      $thiz.bh = (($thiz.bh - (($thiz.bT - newOffset$2) | 0)) | 0);
      $thiz.bT = newOffset$2;
      if (((($thiz.bh >>> 15) | 0) === 0)) {
        $thiz.cl = 3;
      }
    } else {
      if ((i$3 > 0)) {
        a = $m_ju_Arrays$().bO(a, i$3, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.cl >= 3)) {
    if ((a === null)) {
      a = $thiz.ck;
    }
    var i$4 = (31 & (($thiz.bT >>> 10) | 0));
    if (($thiz.cl === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        src$3.av(i$4, dest$3, 0, length$3);
      }
      $thiz.ck = a;
      var num$3 = $thiz.bT;
      var t$3 = (((num$3 >> 9) >>> 22) | 0);
      var newOffset$3 = (((1023 & ((num$3 + t$3) | 0)) - t$3) | 0);
      $thiz.bh = (($thiz.bh - (($thiz.bT - newOffset$3) | 0)) | 0);
      $thiz.bT = newOffset$3;
      if (((($thiz.bh >>> 10) | 0) === 0)) {
        $thiz.cl = 2;
      }
    } else {
      if ((i$4 > 0)) {
        a = $m_ju_Arrays$().bO(a, i$4, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.cl >= 2)) {
    if ((a === null)) {
      a = $thiz.bS;
    }
    var i$5 = (31 & (($thiz.bT >>> 5) | 0));
    if (($thiz.cl === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        src$4.av(i$5, dest$4, 0, length$4);
      }
      $thiz.bS = a;
      var num$4 = $thiz.bT;
      var t$4 = (((num$4 >> 4) >>> 27) | 0);
      var newOffset$4 = (((31 & ((num$4 + t$4) | 0)) - t$4) | 0);
      $thiz.bh = (($thiz.bh - (($thiz.bT - newOffset$4) | 0)) | 0);
      $thiz.bT = newOffset$4;
      if (((($thiz.bh >>> 5) | 0) === 0)) {
        $thiz.cl = 1;
      }
    } else {
      if ((i$5 > 0)) {
        a = $m_ju_Arrays$().bO(a, i$5, 32);
      }
      aParent.a[0] = a;
    }
    aParent = a;
    a = a.a[0];
  }
  if (($thiz.cl >= 1)) {
    if ((a === null)) {
      a = $thiz.dc;
    }
    var i$6 = (31 & $thiz.bT);
    if (($thiz.cl === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        src$5.av(i$6, dest$5, 0, length$5);
      }
      $thiz.dc = a;
      $thiz.bJ = (($thiz.bJ - $thiz.bT) | 0);
      $thiz.bT = 0;
    } else {
      if ((i$6 > 0)) {
        a = $m_ju_Arrays$().bO(a, i$6, 32);
      }
      aParent.a[0] = a;
    }
  }
  $thiz.H8 = false;
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.a.length;
  if ((dl > 0)) {
    if (($thiz.bJ === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz);
    }
    var a = ((32 - $thiz.bJ) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.dc;
    var destPos = $thiz.bJ;
    data.av(0, dest, destPos, copy1);
    $thiz.bJ = (($thiz.bJ + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.dc;
      data.av(copy1, dest$1, 0, copy2);
      $thiz.bJ = (($thiz.bJ + copy2) | 0);
    }
  }
}
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if ((slice.a.length === 0)) {
    return (void 0);
  }
  if (($thiz.bJ === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz);
  }
  var sl = slice.a.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.bh) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.bh >>> 5) | 0));
      var dest = $thiz.bS;
      slice.av(0, dest, destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.bS;
        slice.av(copy1, dest$1, 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5));
      }
      break;
    }
    case 3: {
      var num = $thiz.bh;
      var t = (((num >> 9) >>> 22) | 0);
      if (((((1023 & ((num + t) | 0)) - t) | 0) !== 0)) {
        var f = ((e$3) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$3, 2);
        });
        var len = slice.a.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var x0 = slice.a[i];
            f(x0);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i < len)) {
            var x0$1 = slice.a[i];
            f(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i < len)) {
            var x0$2 = slice.a[i];
            f(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i < len)) {
            var $x_1 = slice.a;
            var $x_2 = (i << 1);
            var x0$3_$_lo = $x_1[$x_2];
            var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
            f($bL(x0$3_$_lo, x0$3_$_hi));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i < len)) {
            var x0$4 = slice.a[i];
            f(x0$4);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i < len)) {
            var x0$5 = slice.a[i];
            f($bC(x0$5));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i < len)) {
            var x0$6 = slice.a[i];
            f(x0$6);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i < len)) {
            var x0$7 = slice.a[i];
            f(x0$7);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i < len)) {
            var x0$8 = slice.a[i];
            f(x0$8);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$1 = (31 & ((((32768 - $thiz.bh) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.bh >>> 10) | 0));
      var dest$2 = $thiz.ck;
      slice.av(0, dest$2, destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.ck;
        slice.av(copy1$2, dest$3, 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10));
      }
      break;
    }
    case 4: {
      var num$1 = $thiz.bh;
      var t$1 = (((num$1 >> 14) >>> 17) | 0);
      if (((((32767 & ((num$1 + t$1) | 0)) - t$1) | 0) !== 0)) {
        var f$1 = ((e$3$1) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$3$1, 3);
        });
        var len$1 = slice.a.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var x0$9 = slice.a[i$1];
            f$1(x0$9);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$1 < len$1)) {
            var x0$10 = slice.a[i$1];
            f$1(x0$10);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$1 < len$1)) {
            var x0$11 = slice.a[i$1];
            f$1(x0$11);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$1 < len$1)) {
            var $x_3 = slice.a;
            var $x_4 = (i$1 << 1);
            var x0$12_$_lo = $x_3[$x_4];
            var x0$12_$_hi = $x_3[(($x_4 + 1) | 0)];
            f$1($bL(x0$12_$_lo, x0$12_$_hi));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$1 < len$1)) {
            var x0$13 = slice.a[i$1];
            f$1(x0$13);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$1 < len$1)) {
            var x0$14 = slice.a[i$1];
            f$1($bC(x0$14));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$1 < len$1)) {
            var x0$15 = slice.a[i$1];
            f$1(x0$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$1 < len$1)) {
            var x0$16 = slice.a[i$1];
            f$1(x0$16);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$1 < len$1)) {
            var x0$17 = slice.a[i$1];
            f$1(x0$17);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$2 = (31 & ((((1048576 - $thiz.bh) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.bh >>> 15) | 0));
      var dest$4 = $thiz.cX;
      slice.av(0, dest$4, destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.cX;
        slice.av(copy1$3, dest$5, 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15));
      }
      break;
    }
    case 5: {
      var num$2 = $thiz.bh;
      var t$2 = (((num$2 >> 19) >>> 12) | 0);
      if (((((1048575 & ((num$2 + t$2) | 0)) - t$2) | 0) !== 0)) {
        var f$2 = ((e$3$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$3$2, 4);
        });
        var len$2 = slice.a.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var x0$18 = slice.a[i$2];
            f$2(x0$18);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$2 < len$2)) {
            var x0$19 = slice.a[i$2];
            f$2(x0$19);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$2 < len$2)) {
            var x0$20 = slice.a[i$2];
            f$2(x0$20);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$2 < len$2)) {
            var $x_5 = slice.a;
            var $x_6 = (i$2 << 1);
            var x0$21_$_lo = $x_5[$x_6];
            var x0$21_$_hi = $x_5[(($x_6 + 1) | 0)];
            f$2($bL(x0$21_$_lo, x0$21_$_hi));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$2 < len$2)) {
            var x0$22 = slice.a[i$2];
            f$2(x0$22);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$2 < len$2)) {
            var x0$23 = slice.a[i$2];
            f$2($bC(x0$23));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$2 < len$2)) {
            var x0$24 = slice.a[i$2];
            f$2(x0$24);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$2 < len$2)) {
            var x0$25 = slice.a[i$2];
            f$2(x0$25);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$2 < len$2)) {
            var x0$26 = slice.a[i$2];
            f$2(x0$26);
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$3 = (31 & ((((33554432 - $thiz.bh) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.bh >>> 20) | 0));
      var dest$6 = $thiz.dC;
      slice.av(0, dest$6, destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.dC;
        slice.av(copy1$4, dest$7, 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20));
      }
      break;
    }
    case 6: {
      var num$3 = $thiz.bh;
      var t$3 = (((num$3 >> 24) >>> 7) | 0);
      if (((((33554431 & ((num$3 + t$3) | 0)) - t$3) | 0) !== 0)) {
        var f$3 = ((e$3$3) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$3$3, 5);
        });
        var len$3 = slice.a.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var x0$27 = slice.a[i$3];
            f$3(x0$27);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$3 < len$3)) {
            var x0$28 = slice.a[i$3];
            f$3(x0$28);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$3 < len$3)) {
            var x0$29 = slice.a[i$3];
            f$3(x0$29);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$3 < len$3)) {
            var $x_7 = slice.a;
            var $x_8 = (i$3 << 1);
            var x0$30_$_lo = $x_7[$x_8];
            var x0$30_$_hi = $x_7[(($x_8 + 1) | 0)];
            f$3($bL(x0$30_$_lo, x0$30_$_hi));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$3 < len$3)) {
            var x0$31 = slice.a[i$3];
            f$3(x0$31);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$3 < len$3)) {
            var x0$32 = slice.a[i$3];
            f$3($bC(x0$32));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$3 < len$3)) {
            var x0$33 = slice.a[i$3];
            f$3(x0$33);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$3 < len$3)) {
            var x0$34 = slice.a[i$3];
            f$3(x0$34);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$3 < len$3)) {
            var x0$35 = slice.a[i$3];
            f$3(x0$35);
            i$3 = ((1 + i$3) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var destPos$5 = (($thiz.bh >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements");
      }
      var dest$8 = $thiz.f1;
      slice.av(0, dest$8, destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break;
    }
    default: {
      throw new $c_s_MatchError(dim);
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.jD();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.mQ(sliceIdx);
    matchResult26: {
      var idx = sliceIdx;
      var c = (((sliceCount + ((sliceCount >>> 31) | 0)) | 0) >> 1);
      var a = ((idx - c) | 0);
      var sign = (a >> 31);
      var x37 = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
      if ((x37 === 1)) {
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice);
        break matchResult26;
      }
      if ((($thiz.bJ === 32) || ($thiz.bJ === 0))) {
        $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x37);
        break matchResult26;
      }
      $m_sci_VectorStatics$().ME(((x37 - 2) | 0), slice, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((data$3) => {
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data$3);
      })));
    }
    sliceIdx = ((1 + sliceIdx) | 0);
  }
  return $thiz;
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.bh) | 0);
  var xor = (idx ^ $thiz.bh);
  $thiz.bh = idx;
  $thiz.bJ = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
}
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.bh + n) | 0);
    var xor = (idx ^ $thiz.bh);
    $thiz.bh = idx;
    $thiz.bJ = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
  }
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.dc) + ", a2=") + $thiz.bS) + ", a3=") + $thiz.ck) + ", a4=") + $thiz.cX) + ", a5=") + $thiz.dC) + ", a6=") + $thiz.f1) + ", depth=") + $thiz.cl));
  } else if ((xor < 1024)) {
    if (($thiz.cl <= 1)) {
      $thiz.bS = new ($d_O.r().r().C)(32);
      $thiz.bS.a[0] = $thiz.dc;
      $thiz.cl = 2;
    }
    $thiz.dc = new $ac_O(32);
    $thiz.bS.a[(31 & ((idx >>> 5) | 0))] = $thiz.dc;
  } else if ((xor < 32768)) {
    if (($thiz.cl <= 2)) {
      $thiz.ck = new ($d_O.r().r().r().C)(32);
      $thiz.ck.a[0] = $thiz.bS;
      $thiz.cl = 3;
    }
    $thiz.dc = new $ac_O(32);
    $thiz.bS = new ($d_O.r().r().C)(32);
    $thiz.bS.a[(31 & ((idx >>> 5) | 0))] = $thiz.dc;
    $thiz.ck.a[(31 & ((idx >>> 10) | 0))] = $thiz.bS;
  } else if ((xor < 1048576)) {
    if (($thiz.cl <= 3)) {
      $thiz.cX = new ($d_O.r().r().r().r().C)(32);
      $thiz.cX.a[0] = $thiz.ck;
      $thiz.cl = 4;
    }
    $thiz.dc = new $ac_O(32);
    $thiz.bS = new ($d_O.r().r().C)(32);
    $thiz.ck = new ($d_O.r().r().r().C)(32);
    $thiz.bS.a[(31 & ((idx >>> 5) | 0))] = $thiz.dc;
    $thiz.ck.a[(31 & ((idx >>> 10) | 0))] = $thiz.bS;
    $thiz.cX.a[(31 & ((idx >>> 15) | 0))] = $thiz.ck;
  } else if ((xor < 33554432)) {
    if (($thiz.cl <= 4)) {
      $thiz.dC = new ($d_O.r().r().r().r().r().C)(32);
      $thiz.dC.a[0] = $thiz.cX;
      $thiz.cl = 5;
    }
    $thiz.dc = new $ac_O(32);
    $thiz.bS = new ($d_O.r().r().C)(32);
    $thiz.ck = new ($d_O.r().r().r().C)(32);
    $thiz.cX = new ($d_O.r().r().r().r().C)(32);
    $thiz.bS.a[(31 & ((idx >>> 5) | 0))] = $thiz.dc;
    $thiz.ck.a[(31 & ((idx >>> 10) | 0))] = $thiz.bS;
    $thiz.cX.a[(31 & ((idx >>> 15) | 0))] = $thiz.ck;
    $thiz.dC.a[(31 & ((idx >>> 20) | 0))] = $thiz.cX;
  } else {
    if (($thiz.cl <= 5)) {
      $thiz.f1 = new ($d_O.r().r().r().r().r().r().C)(64);
      $thiz.f1.a[0] = $thiz.dC;
      $thiz.cl = 6;
    }
    $thiz.dc = new $ac_O(32);
    $thiz.bS = new ($d_O.r().r().C)(32);
    $thiz.ck = new ($d_O.r().r().r().C)(32);
    $thiz.cX = new ($d_O.r().r().r().r().C)(32);
    $thiz.dC = new ($d_O.r().r().r().r().r().C)(32);
    $thiz.bS.a[(31 & ((idx >>> 5) | 0))] = $thiz.dc;
    $thiz.ck.a[(31 & ((idx >>> 10) | 0))] = $thiz.bS;
    $thiz.cX.a[(31 & ((idx >>> 15) | 0))] = $thiz.ck;
    $thiz.dC.a[(31 & ((idx >>> 20) | 0))] = $thiz.cX;
    $thiz.f1.a[((idx >>> 25) | 0)] = $thiz.dC;
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.f1 = null;
  this.dC = null;
  this.cX = null;
  this.ck = null;
  this.bS = null;
  this.dc = null;
  this.bJ = 0;
  this.bh = 0;
  this.bT = 0;
  this.H8 = false;
  this.cl = 0;
  this.dc = new $ac_O(32);
  this.bJ = 0;
  this.bh = 0;
  this.bT = 0;
  this.H8 = false;
  this.cl = 1;
}
$p = $c_sci_VectorBuilder.prototype = new $h_O();
$p.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
}
$h_sci_VectorBuilder.prototype = $p;
$p.dk = (function(size) {
});
$p.auU = (function(prefix1) {
  this.cl = 1;
  var i = prefix1.a.length;
  this.bJ = (31 & i);
  this.bh = ((i - this.bJ) | 0);
  this.dc = ((prefix1.a.length === 32) ? prefix1 : $m_ju_Arrays$().bO(prefix1, 0, 32));
  if (((this.bJ === 0) && (this.bh > 0))) {
    this.bJ = 32;
    this.bh = ((this.bh - 32) | 0);
  }
});
$p.ahJ = (function(v) {
  var x28 = v.jD();
  switch (x28) {
    case 0: {
      break;
    }
    case 1: {
      this.cl = 1;
      var i = v.R.a.length;
      this.bJ = (31 & i);
      this.bh = ((i - this.bJ) | 0);
      var a = v.R;
      this.dc = ((a.a.length === 32) ? a : $m_ju_Arrays$().bO(a, 0, 32));
      break;
    }
    case 3: {
      var d2 = v.es;
      var a$1 = v.aj;
      this.dc = ((a$1.a.length === 32) ? a$1 : $m_ju_Arrays$().bO(a$1, 0, 32));
      this.cl = 2;
      this.bT = ((32 - v.eM) | 0);
      var i$1 = ((v.am + this.bT) | 0);
      this.bJ = (31 & i$1);
      this.bh = ((i$1 - this.bJ) | 0);
      this.bS = new ($d_O.r().r().C)(32);
      this.bS.a[0] = v.R;
      var dest = this.bS;
      var length = d2.a.length;
      d2.av(0, dest, 1, length);
      this.bS.a[((1 + d2.a.length) | 0)] = this.dc;
      break;
    }
    case 5: {
      var d3 = v.dB;
      var s2 = v.dO;
      var a$2 = v.aj;
      this.dc = ((a$2.a.length === 32) ? a$2 : $m_ju_Arrays$().bO(a$2, 0, 32));
      this.cl = 3;
      this.bT = ((1024 - v.e9) | 0);
      var i$2 = ((v.am + this.bT) | 0);
      this.bJ = (31 & i$2);
      this.bh = ((i$2 - this.bJ) | 0);
      this.ck = new ($d_O.r().r().r().C)(32);
      this.ck.a[0] = $m_sci_VectorStatics$().bi(v.R, v.eE);
      var dest$1 = this.ck;
      var length$1 = d3.a.length;
      d3.av(0, dest$1, 1, length$1);
      this.bS = $m_ju_Arrays$().cn(s2, 32);
      this.ck.a[((1 + d3.a.length) | 0)] = this.bS;
      this.bS.a[s2.a.length] = this.dc;
      break;
    }
    case 7: {
      var d4 = v.cV;
      var s3 = v.d6;
      var s2$2 = v.d5;
      var a$3 = v.aj;
      this.dc = ((a$3.a.length === 32) ? a$3 : $m_ju_Arrays$().bO(a$3, 0, 32));
      this.cl = 4;
      this.bT = ((32768 - v.dm) | 0);
      var i$3 = ((v.am + this.bT) | 0);
      this.bJ = (31 & i$3);
      this.bh = ((i$3 - this.bJ) | 0);
      this.cX = new ($d_O.r().r().r().r().C)(32);
      this.cX.a[0] = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(v.R, v.dP), v.dQ);
      var dest$2 = this.cX;
      var length$2 = d4.a.length;
      d4.av(0, dest$2, 1, length$2);
      this.ck = $m_ju_Arrays$().cn(s3, 32);
      this.bS = $m_ju_Arrays$().cn(s2$2, 32);
      this.cX.a[((1 + d4.a.length) | 0)] = this.ck;
      this.ck.a[s3.a.length] = this.bS;
      this.bS.a[s2$2.a.length] = this.dc;
      break;
    }
    case 9: {
      var d5 = v.cj;
      var s4 = v.cy;
      var s3$2 = v.cx;
      var s2$3 = v.cw;
      var a$4 = v.aj;
      this.dc = ((a$4.a.length === 32) ? a$4 : $m_ju_Arrays$().bO(a$4, 0, 32));
      this.cl = 5;
      this.bT = ((1048576 - v.cM) | 0);
      var i$4 = ((v.am + this.bT) | 0);
      this.bJ = (31 & i$4);
      this.bh = ((i$4 - this.bJ) | 0);
      this.dC = new ($d_O.r().r().r().r().r().C)(32);
      this.dC.a[0] = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(v.R, v.d7), v.d8), v.d9);
      var dest$3 = this.dC;
      var length$3 = d5.a.length;
      d5.av(0, dest$3, 1, length$3);
      this.cX = $m_ju_Arrays$().cn(s4, 32);
      this.ck = $m_ju_Arrays$().cn(s3$2, 32);
      this.bS = $m_ju_Arrays$().cn(s2$3, 32);
      this.dC.a[((1 + d5.a.length) | 0)] = this.cX;
      this.cX.a[s4.a.length] = this.ck;
      this.ck.a[s3$2.a.length] = this.bS;
      this.bS.a[s2$3.a.length] = this.dc;
      break;
    }
    case 11: {
      var d6 = v.c2;
      var s5 = v.cd;
      var s4$2 = v.cc;
      var s3$3 = v.cb;
      var s2$4 = v.ca;
      var a$5 = v.aj;
      this.dc = ((a$5.a.length === 32) ? a$5 : $m_ju_Arrays$().bO(a$5, 0, 32));
      this.cl = 6;
      this.bT = ((33554432 - v.cG) | 0);
      var i$5 = ((v.am + this.bT) | 0);
      this.bJ = (31 & i$5);
      this.bh = ((i$5 - this.bJ) | 0);
      this.f1 = new ($d_O.r().r().r().r().r().r().C)(64);
      this.f1.a[0] = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(v.R, v.cO), v.cP), v.cQ), v.cR);
      var dest$4 = this.f1;
      var length$4 = d6.a.length;
      d6.av(0, dest$4, 1, length$4);
      this.dC = $m_ju_Arrays$().cn(s5, 32);
      this.cX = $m_ju_Arrays$().cn(s4$2, 32);
      this.ck = $m_ju_Arrays$().cn(s3$3, 32);
      this.bS = $m_ju_Arrays$().cn(s2$4, 32);
      this.f1.a[((1 + d6.a.length) | 0)] = this.dC;
      this.dC.a[s5.a.length] = this.cX;
      this.cX.a[s4$2.a.length] = this.ck;
      this.ck.a[s3$3.a.length] = this.bS;
      this.bS.a[s2$4.a.length] = this.dc;
      break;
    }
    default: {
      throw new $c_s_MatchError(x28);
    }
  }
  if (((this.bJ === 0) && (this.bh > 0))) {
    this.bJ = 32;
    this.bh = ((this.bh - 32) | 0);
  }
  return this;
});
$p.afC = (function(before, bigVector) {
  if (((this.bJ !== 0) || (this.bh !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.");
  }
  matchResult24: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ($m_sci_Vector0$().b(bigVector)) {
      var \u03b41$___1 = 0;
      var \u03b41$___2 = 1;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector1)) {
      var \u03b41$___1 = 0;
      var \u03b41$___2 = 1;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector2)) {
      var \u03b41$___1 = bigVector.eM;
      var \u03b41$___2 = 32;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector3)) {
      var \u03b41$___1 = bigVector.e9;
      var \u03b41$___2 = 1024;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector4)) {
      var \u03b41$___1 = bigVector.dm;
      var \u03b41$___2 = 32768;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector5)) {
      var \u03b41$___1 = bigVector.cM;
      var \u03b41$___2 = 1048576;
      break matchResult24;
    }
    if ((bigVector instanceof $c_sci_Vector6)) {
      var \u03b41$___1 = bigVector.cG;
      var \u03b41$___2 = 33554432;
      break matchResult24;
    }
    throw new $c_s_MatchError(bigVector);
  }
  var prefixLength = (\u03b41$___1 | 0);
  var maxPrefixLength = (\u03b41$___2 | 0);
  if ((maxPrefixLength === 1)) {
    return this;
  }
  var overallPrefixLength = ((((before + prefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  this.bT = ((((maxPrefixLength - overallPrefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.bT));
  this.bJ = (31 & this.bT);
  this.H8 = true;
  return this;
});
$p.DL = (function(elem) {
  if ((this.bJ === 32)) {
    $p_sci_VectorBuilder__advance__V(this);
  }
  this.dc.a[this.bJ] = elem;
  this.bJ = ((1 + this.bJ) | 0);
  return this;
});
$p.ul = (function(xs) {
  return ((xs instanceof $c_sci_Vector) ? ((((this.bJ === 0) && (this.bh === 0)) && (!this.H8)) ? this.ahJ(xs) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, xs)) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$p.ix = (function() {
  if (this.H8) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this);
  }
  var len = ((this.bJ + this.bh) | 0);
  var realLen = ((len - this.bT) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len));
  } else if ((len <= 32)) {
    var a = this.dc;
    return new $c_sci_Vector1(((a.a.length === realLen) ? a : $m_ju_Arrays$().cn(a, realLen)));
  } else if ((len <= 1024)) {
    var i1 = (31 & ((len - 1) | 0));
    var i2 = ((((len - 1) | 0) >>> 5) | 0);
    var data = $m_ju_Arrays$().bO(this.bS, 1, i2);
    var prefix1 = this.bS.a[0];
    var a$1 = this.bS.a[i2];
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a$1.a.length === len$1) ? a$1 : $m_ju_Arrays$().cn(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.bT) | 0), data, suffix1, realLen);
  } else if ((len <= 32768)) {
    var i1$2 = (31 & ((len - 1) | 0));
    var i2$2 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3 = ((((len - 1) | 0) >>> 10) | 0);
    var data$2 = $m_ju_Arrays$().bO(this.ck, 1, i3);
    var a$2 = this.ck.a[0];
    var prefix2 = $m_ju_Arrays$().bO(a$2, 1, a$2.a.length);
    var prefix1$2 = this.ck.a[0].a[0];
    var suffix2 = $m_ju_Arrays$().cn(this.ck.a[i3], i2$2);
    var a$3 = this.ck.a[i3].a[i2$2];
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$3.a.length === len$2) ? a$3 : $m_ju_Arrays$().cn(a$3, len$2));
    var len1 = prefix1$2.a.length;
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, ((len1 + (prefix2.a.length << 5)) | 0), data$2, suffix2, suffix1$2, realLen);
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & ((len - 1) | 0));
    var i2$3 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$2 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4 = ((((len - 1) | 0) >>> 15) | 0);
    var data$3 = $m_ju_Arrays$().bO(this.cX, 1, i4);
    var a$4 = this.cX.a[0];
    var prefix3 = $m_ju_Arrays$().bO(a$4, 1, a$4.a.length);
    var a$5 = this.cX.a[0].a[0];
    var prefix2$2 = $m_ju_Arrays$().bO(a$5, 1, a$5.a.length);
    var prefix1$3 = this.cX.a[0].a[0].a[0];
    var suffix3 = $m_ju_Arrays$().cn(this.cX.a[i4], i3$2);
    var suffix2$2 = $m_ju_Arrays$().cn(this.cX.a[i4].a[i3$2], i2$3);
    var a$6 = this.cX.a[i4].a[i3$2].a[i2$3];
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$6.a.length === len$3) ? a$6 : $m_ju_Arrays$().cn(a$6, len$3));
    var len1$2 = prefix1$3.a.length;
    var len12$2 = ((len1$2 + (prefix2$2.a.length << 5)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, ((len12$2 + (prefix3.a.length << 10)) | 0), data$3, suffix3, suffix2$2, suffix1$3, realLen);
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & ((len - 1) | 0));
    var i2$4 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$3 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$2 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5 = ((((len - 1) | 0) >>> 20) | 0);
    var data$4 = $m_ju_Arrays$().bO(this.dC, 1, i5);
    var a$7 = this.dC.a[0];
    var prefix4 = $m_ju_Arrays$().bO(a$7, 1, a$7.a.length);
    var a$8 = this.dC.a[0].a[0];
    var prefix3$2 = $m_ju_Arrays$().bO(a$8, 1, a$8.a.length);
    var a$9 = this.dC.a[0].a[0].a[0];
    var prefix2$3 = $m_ju_Arrays$().bO(a$9, 1, a$9.a.length);
    var prefix1$4 = this.dC.a[0].a[0].a[0].a[0];
    var suffix4 = $m_ju_Arrays$().cn(this.dC.a[i5], i4$2);
    var suffix3$2 = $m_ju_Arrays$().cn(this.dC.a[i5].a[i4$2], i3$3);
    var suffix2$3 = $m_ju_Arrays$().cn(this.dC.a[i5].a[i4$2].a[i3$3], i2$4);
    var a$10 = this.dC.a[i5].a[i4$2].a[i3$3].a[i2$4];
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$10.a.length === len$4) ? a$10 : $m_ju_Arrays$().cn(a$10, len$4));
    var len1$3 = prefix1$4.a.length;
    var len12$3 = ((len1$3 + (prefix2$3.a.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.a.length << 10)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, ((len123$2 + (prefix4.a.length << 15)) | 0), data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen);
  } else {
    var i1$5 = (31 & ((len - 1) | 0));
    var i2$5 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$4 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$3 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5$2 = (31 & ((((len - 1) | 0) >>> 20) | 0));
    var i6 = ((((len - 1) | 0) >>> 25) | 0);
    var data$5 = $m_ju_Arrays$().bO(this.f1, 1, i6);
    var a$11 = this.f1.a[0];
    var prefix5 = $m_ju_Arrays$().bO(a$11, 1, a$11.a.length);
    var a$12 = this.f1.a[0].a[0];
    var prefix4$2 = $m_ju_Arrays$().bO(a$12, 1, a$12.a.length);
    var a$13 = this.f1.a[0].a[0].a[0];
    var prefix3$3 = $m_ju_Arrays$().bO(a$13, 1, a$13.a.length);
    var a$14 = this.f1.a[0].a[0].a[0].a[0];
    var prefix2$4 = $m_ju_Arrays$().bO(a$14, 1, a$14.a.length);
    var prefix1$5 = this.f1.a[0].a[0].a[0].a[0].a[0];
    var suffix5 = $m_ju_Arrays$().cn(this.f1.a[i6], i5$2);
    var suffix4$2 = $m_ju_Arrays$().cn(this.f1.a[i6].a[i5$2], i4$3);
    var suffix3$3 = $m_ju_Arrays$().cn(this.f1.a[i6].a[i5$2].a[i4$3], i3$4);
    var suffix2$4 = $m_ju_Arrays$().cn(this.f1.a[i6].a[i5$2].a[i4$3].a[i3$4], i2$5);
    var a$15 = this.f1.a[i6].a[i5$2].a[i4$3].a[i3$4].a[i2$5];
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$15.a.length === len$5) ? a$15 : $m_ju_Arrays$().cn(a$15, len$5));
    var len1$4 = prefix1$5.a.length;
    var len12$4 = ((len1$4 + (prefix2$4.a.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.a.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.a.length << 15)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, ((len1234$2 + (prefix5.a.length << 20)) | 0), data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen);
  }
});
$p.g = (function() {
  return (((((((("VectorBuilder(len1=" + this.bJ) + ", lenRest=") + this.bh) + ", offset=") + this.bT) + ", depth=") + this.cl) + ")");
});
$p.aD = (function(elem) {
  return this.DL(elem);
});
$p.cz = (function(elems) {
  return this.ul(elems);
});
$p.aR = (function() {
  return this.ix();
});
var $d_sci_VectorBuilder = new $TypeData().i($c_sci_VectorBuilder, "scala.collection.immutable.VectorBuilder", ({
  yC: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.ab8 = null;
  $n_scm_ArrayBuffer$ = this;
  this.ab8 = new $ac_O(0);
}
$p = $c_scm_ArrayBuffer$.prototype = new $h_O();
$p.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
}
$h_scm_ArrayBuffer$.prototype = $p;
$p.e4 = (function(elems) {
  return this.Up(elems);
});
$p.Up = (function(coll) {
  var k = coll.G();
  if ((k >= 0)) {
    var array = this.ajC(this.ab8, 0, k);
    var actual = ($is_sc_Iterable(coll) ? coll.d0(array, 0, 2147483647) : coll.l().d0(array, 0, 2147483647));
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k));
    }
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k);
  } else {
    return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()).afs(coll);
  }
});
$p.aP = (function() {
  return new $c_scm_ArrayBuffer$$anon$1();
});
$p.axp = (function(arrayLen, targetLen) {
  if ((targetLen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((((("Overflow while resizing array of array-backed collection. Requested length: " + targetLen) + "; current length: ") + arrayLen) + "; increase: ") + ((targetLen - arrayLen) | 0)));
  } else if ((targetLen <= arrayLen)) {
    return (-1);
  } else {
    if ((targetLen > 2147483639)) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((("Array of array-backed collection exceeds VM length limit of 2147483639. Requested length: " + targetLen) + "; current length: ") + arrayLen));
    }
    if ((arrayLen > 1073741819)) {
      return 2147483639;
    } else {
      var x = (arrayLen << 1);
      var y = ((x > 16) ? x : 16);
      return ((targetLen > y) ? targetLen : y);
    }
  }
});
$p.ajC = (function(array, curSize, targetSize) {
  var newLen = this.axp(array.a.length, targetSize);
  if ((newLen < 0)) {
    return array;
  } else {
    var res = new $ac_O(newLen);
    array.av(0, res, 0, curSize);
    return res;
  }
});
$p.bp = (function(source) {
  return this.Up(source);
});
$p.ce = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
});
var $d_scm_ArrayBuffer$ = new $TypeData().i($c_scm_ArrayBuffer$, "scala.collection.mutable.ArrayBuffer$", ({
  yI: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$();
  }
  return $n_scm_ArrayBuffer$;
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.h5 = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())));
}
$p = $c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
}
$h_scm_ArrayBuffer$$anon$1.prototype = $p;
$p.dk = (function(size) {
  this.h5.dk(size);
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().i($c_scm_ArrayBuffer$$anon$1, "scala.collection.mutable.ArrayBuffer$$anon$1", ({
  yJ: 1,
  bz: 1,
  S: 1,
  T: 1,
  X: 1
}));
/** @constructor */
function $c_scm_ArrayDeque$() {
}
$p = $c_scm_ArrayDeque$.prototype = new $h_O();
$p.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
}
$h_scm_ArrayDeque$.prototype = $p;
$p.e4 = (function(elems) {
  return this.ahc(elems);
});
$p.ahc = (function(coll) {
  var s = coll.G();
  if ((s >= 0)) {
    var array = this.Md(s);
    var actual = ($is_sc_Iterable(coll) ? coll.d0(array, 0, 2147483647) : coll.l().d0(array, 0, 2147483647));
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s));
    }
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s);
  } else {
    return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16).I9(coll);
  }
});
$p.aP = (function() {
  return new $c_scm_ArrayDeque$$anon$1();
});
$p.Md = (function(len) {
  if ((!(len >= 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required");
  }
  var size = ((((-2147483648) >>> Math.clz32(len)) | 0) << 1);
  if ((!(size >= 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len));
  }
  return new $ac_O(((size > 16) ? size : 16));
});
$p.bp = (function(source) {
  return this.ahc(source);
});
$p.ce = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
});
var $d_scm_ArrayDeque$ = new $TypeData().i($c_scm_ArrayDeque$, "scala.collection.mutable.ArrayDeque$", ({
  yO: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$();
  }
  return $n_scm_ArrayDeque$;
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.h5 = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16));
}
$p = $c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
}
$h_scm_ArrayDeque$$anon$1.prototype = $p;
$p.dk = (function(size) {
  var this$1 = this.h5;
  var idx = this$1.dq;
  if (((size > (((this$1.dD - idx) | 0) & ((this$1.bK.a.length - 1) | 0))) && (size >= this$1.bK.a.length))) {
    $p_scm_ArrayDeque__resize__I__V(this$1, size);
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().i($c_scm_ArrayDeque$$anon$1, "scala.collection.mutable.ArrayDeque$$anon$1", ({
  yP: 1,
  bz: 1,
  S: 1,
  T: 1,
  X: 1
}));
/** @constructor */
function $c_scm_Buffer$() {
  this.o1 = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$());
}
$p = $c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
}
$h_scm_Buffer$.prototype = $p;
var $d_scm_Buffer$ = new $TypeData().i($c_scm_Buffer$, "scala.collection.mutable.Buffer$", ({
  yS: 1,
  bq: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$();
  }
  return $n_scm_Buffer$;
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.h5 = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1));
}
$p = $c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
}
$h_scm_HashMap$$anon$6.prototype = $p;
$p.dk = (function(size) {
  this.h5.dk(size);
});
var $d_scm_HashMap$$anon$6 = new $TypeData().i($c_scm_HashMap$$anon$6, "scala.collection.mutable.HashMap$$anon$6", ({
  z7: 1,
  bz: 1,
  S: 1,
  T: 1,
  X: 1
}));
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.yA = outer;
  $thiz.oi = 0;
  $thiz.mp = null;
  $thiz.yB = outer.bP.a.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
}
$p = $c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
}
$h_scm_HashMap$HashMapIterator.prototype = $p;
$p.f = (function() {
  if ((this.mp !== null)) {
    return true;
  } else {
    while ((this.oi < this.yB)) {
      var n = this.yA.bP.a[this.oi];
      this.oi = ((1 + this.oi) | 0);
      if ((n !== null)) {
        this.mp = n;
        return true;
      }
    }
    return false;
  }
});
$p.e = (function() {
  if ((!this.f())) {
    return $m_sc_Iterator$().aZ.e();
  } else {
    var x$proxy14 = this.mp;
    if ((x$proxy14 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var r = this.Iz(x$proxy14);
    var x$proxy15 = this.mp;
    if ((x$proxy15 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    this.mp = x$proxy15.dE;
    return r;
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.h5 = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1));
}
$p = $c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$p.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
}
$h_scm_HashSet$$anon$4.prototype = $p;
$p.dk = (function(size) {
  this.h5.dk(size);
});
var $d_scm_HashSet$$anon$4 = new $TypeData().i($c_scm_HashSet$$anon$4, "scala.collection.mutable.HashSet$$anon$4", ({
  zd: 1,
  bz: 1,
  S: 1,
  T: 1,
  X: 1
}));
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.Hb = outer;
  $thiz.tF = 0;
  $thiz.qm = null;
  $thiz.Hc = outer.f2.a.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.tF = 0;
  this.qm = null;
  this.Hc = 0;
  this.Hb = null;
}
$p = $c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
}
$h_scm_HashSet$HashSetIterator.prototype = $p;
$p.f = (function() {
  if ((this.qm !== null)) {
    return true;
  } else {
    while ((this.tF < this.Hc)) {
      var n = this.Hb.f2.a[this.tF];
      this.tF = ((1 + this.tF) | 0);
      if ((n !== null)) {
        this.qm = n;
        return true;
      }
    }
    return false;
  }
});
$p.e = (function() {
  if ((!this.f())) {
    return $m_sc_Iterator$().aZ.e();
  } else {
    var x$proxy10 = this.qm;
    if ((x$proxy10 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var r = this.Uf(x$proxy10);
    var x$proxy11 = this.qm;
    if ((x$proxy11 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    this.qm = x$proxy11.f3;
    return r;
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.Hd = empty;
  return $thiz;
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.Hd = null;
}
$p = $c_scm_ImmutableBuilder.prototype = new $h_O();
$p.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
}
$h_scm_ImmutableBuilder.prototype = $p;
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.dk = (function(size) {
});
$p.aR = (function() {
  return this.Hd;
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.o1 = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$());
}
$p = $c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$p.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
}
$h_scm_IndexedSeq$.prototype = $p;
var $d_scm_IndexedSeq$ = new $TypeData().i($c_scm_IndexedSeq$, "scala.collection.mutable.IndexedSeq$", ({
  zg: 1,
  bq: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$();
  }
  return $n_scm_IndexedSeq$;
}
function $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.tG = outer.D4;
  return $thiz;
}
/** @constructor */
function $c_scm_LinkedHashSet$LinkedHashSetIterator() {
  this.tG = null;
}
$p = $c_scm_LinkedHashSet$LinkedHashSetIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_LinkedHashSet$LinkedHashSetIterator;
/** @constructor */
function $h_scm_LinkedHashSet$LinkedHashSetIterator() {
}
$h_scm_LinkedHashSet$LinkedHashSetIterator.prototype = $p;
$p.f = (function() {
  return (this.tG !== null);
});
$p.e = (function() {
  if (this.f()) {
    var x$proxy9 = this.tG;
    if ((x$proxy9 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    var r = this.Ug(x$proxy9);
    var x$proxy10 = this.tG;
    if ((x$proxy10 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    this.tG = x$proxy10.Ly;
    return r;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
/** @constructor */
function $c_scm_ListBuffer$() {
}
$p = $c_scm_ListBuffer$.prototype = new $h_O();
$p.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
}
$h_scm_ListBuffer$.prototype = $p;
$p.e4 = (function(elems) {
  return new $c_scm_ListBuffer().Np(elems);
});
$p.aP = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
});
$p.bp = (function(source) {
  return new $c_scm_ListBuffer().Np(source);
});
$p.ce = (function() {
  return new $c_scm_ListBuffer();
});
var $d_scm_ListBuffer$ = new $TypeData().i($c_scm_ListBuffer$, "scala.collection.mutable.ListBuffer$", ({
  zo: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$();
  }
  return $n_scm_ListBuffer$;
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.Sb = null;
  this.abj = null;
  this.abi = 0;
  this.Sb = underlying;
  this.abj = mutationCount;
  this.abi = (mutationCount.aA() | 0);
}
$p = $c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
}
$h_scm_MutationTracker$CheckedIterator.prototype = $p;
$p.f = (function() {
  $m_scm_MutationTracker$().TK(this.abi, (this.abj.aA() | 0), "mutation occurred during iteration");
  return this.Sb.f();
});
$p.e = (function() {
  return this.Sb.e();
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().i($c_scm_MutationTracker$CheckedIterator, "scala.collection.mutable.MutationTracker$CheckedIterator", ({
  zr: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_Queue$() {
}
$p = $c_scm_Queue$.prototype = new $h_O();
$p.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
}
$h_scm_Queue$.prototype = $p;
$p.e4 = (function(elems) {
  return new $c_scm_Queue(16).I9(elems);
});
$p.aP = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_Queue(16));
});
$p.bp = (function(source) {
  return new $c_scm_Queue(16).I9(source);
});
$p.ce = (function() {
  return new $c_scm_Queue(16);
});
var $d_scm_Queue$ = new $TypeData().i($c_scm_Queue$, "scala.collection.mutable.Queue$", ({
  zt: 1,
  a: 1,
  U: 1,
  ak: 1,
  aW: 1
}));
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$();
  }
  return $n_scm_Queue$;
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.abn = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.abn = new $c_jl_ThreadLocal();
}
$p = $c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$p.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $p;
$p.Uc = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable);
});
$p.Ve = (function(t) {
  $m_s_concurrent_ExecutionContext$().D6.p(t);
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().i($c_s_concurrent_ExecutionContext$parasitic$, "scala.concurrent.ExecutionContext$parasitic$", ({
  zB: 1,
  cX: 1,
  ct: 1,
  cY: 1,
  cW: 1
}));
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$();
  }
  return $n_s_concurrent_ExecutionContext$parasitic$;
}
function $p_s_concurrent_duration_Duration$Infinite__fail__T__E($thiz, what) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (what + " not allowed on infinite Durations"));
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
}
$p = $c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$p.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $p;
$p.akc = (function() {
  $p_s_concurrent_duration_Duration$Infinite__fail__T__E(this, "toNanos");
});
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max_$_lo, max_$_hi) {
  var lo = ((-max_$_lo) | 0);
  var hi = ((((-max_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
  var x_$_lo = $thiz.my;
  var x_$_hi = $thiz.mz;
  if (((hi === x_$_hi) ? ((lo >>> 0) <= (x_$_lo >>> 0)) : (hi < x_$_hi))) {
    var x$1_$_lo = $thiz.my;
    var x$1_$_hi = $thiz.mz;
    return ((x$1_$_hi === max_$_hi) ? ((x$1_$_lo >>> 0) <= (max_$_lo >>> 0)) : (x$1_$_hi < max_$_hi));
  } else {
    return false;
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $x_1 = $m_s_concurrent_duration_Duration$().abu.p($thiz.tI);
  var x_$_lo = $thiz.my;
  var x_$_hi = $thiz.mz;
  return ($x_1 + ((((1 ^ x_$_lo) | x_$_hi) === 0) ? "" : "s"));
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length_$_lo, length_$_hi, unit) {
  this.my = 0;
  this.mz = 0;
  this.tI = null;
  this.my = length_$_lo;
  this.mz = length_$_hi;
  this.tI = unit;
  var x = $m_s_concurrent_duration_package$().Sj;
  if (((x === null) ? (unit === null) : (x === unit))) {
    var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1), 2147483647);
  } else {
    var x$3 = $m_s_concurrent_duration_package$().Sg;
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1511828489), 2147483);
    } else {
      var x$5 = $m_s_concurrent_duration_package$().Sh;
      if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
        var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2077252342, 2147);
      } else {
        var x$7 = $m_s_concurrent_duration_package$().Sk;
        if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
          var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 633437444, 2);
        } else {
          var x$9 = $m_s_concurrent_duration_package$().Si;
          if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
            var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 153722867, 0);
          } else {
            var x$11 = $m_s_concurrent_duration_package$().Sf;
            if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
              var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2562047, 0);
            } else {
              var x$13 = $m_s_concurrent_duration_package$().Hg;
              if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
                var $x_1 = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 106751, 0);
              } else {
                var $x_2 = $m_s_concurrent_duration_package$().Hg.zz(length_$_lo, length_$_hi, unit);
                var v_$_lo = $x_2.l;
                var v_$_hi = $x_2.h;
                var $x_1 = (((v_$_hi === (-1)) ? ((v_$_lo >>> 0) >= 4294860545) : (v_$_hi > (-1))) && ((v_$_hi === 0) ? ((v_$_lo >>> 0) <= 106751) : (v_$_hi < 0)));
              }
            }
          }
        }
      }
    }
  }
  if ((!$x_1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)");
  }
}
$p = $c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$p.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
}
$h_s_concurrent_duration_FiniteDuration.prototype = $p;
$p.akc = (function() {
  return this.tI.jA(this.my, this.mz);
});
$p.g = (function() {
  return (($s_RTLong__toString__I__I__T(this.my, this.mz) + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this));
});
$p.qF = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var $x_1 = this.tI.jA(this.my, this.mz);
    var this$2 = new $c_sr_RichLong($x_1.l, $x_1.h);
    var $x_4 = other.tI;
    var $x_3 = other;
    var $x_2 = $x_4.jA($x_3.my, $x_3.mz);
    var y_$_lo = $x_2.l;
    var y_$_hi = $x_2.h;
    var x$1_$_lo = this$2.g6;
    var x$1_$_hi = this$2.g7;
    return ((x$1_$_hi === y_$_hi) ? ((x$1_$_lo === y_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y_$_hi) ? (-1) : 1));
  } else {
    return ((-other.qF(this)) | 0);
  }
});
$p.b = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var $x_1 = this.tI.jA(this.my, this.mz);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var $x_4 = other.tI;
    var $x_3 = other;
    var $x_2 = $x_4.jA($x_3.my, $x_3.mz);
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return (this === other);
  }
});
$p.r = (function() {
  var $x_1 = this.tI.jA(this.my, this.mz);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.oH = (function(that) {
  return this.qF(that);
});
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i5)));
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().i($c_s_concurrent_duration_FiniteDuration, "scala.concurrent.duration.FiniteDuration", ({
  i5: 1,
  c7: 1,
  a: 1,
  N: 1,
  aY: 1
}));
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.bM(x, y) <= 0);
}
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.bM(x, y) >= 0);
}
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.bM(x, y) < 0);
}
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.bM(x, y) > 0);
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.bM(x, y) === 0);
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.fN(x, y) ? x : y);
}
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.fR(x, y) ? x : y);
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x = other.ih;
    return ((x !== null) && x.b($thiz));
  } else {
    return false;
  }
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.dK();
    var x$3 = x.dK();
    return ((x$2 === null) ? (x$3 === null) : (x$2 === x$3));
  } else {
    return false;
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return (clazz.ax.Z ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz.ax.Q())) + "]") : clazz.ax.N);
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ah)));
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ah)));
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$1) {
  this.abG = null;
  this.Hn = 0;
  this.abF = 0;
  this.abG = x$1;
  this.Hn = 0;
  this.abF = x$1.w();
}
$p = $c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
}
$h_sr_ScalaRunTime$$anon$1.prototype = $p;
$p.f = (function() {
  return (this.Hn < this.abF);
});
$p.e = (function() {
  var result = this.abG.z(this.Hn);
  this.Hn = ((1 + this.Hn) | 0);
  return result;
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().i($c_sr_ScalaRunTime$$anon$1, "scala.runtime.ScalaRunTime$$anon$1", ({
  Bd: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sjs_js_WrappedArray$() {
}
$p = $c_sjs_js_WrappedArray$.prototype = new $h_O();
$p.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
}
$h_sjs_js_WrappedArray$.prototype = $p;
$p.e4 = (function(elems) {
  return this.ahe(elems);
});
$p.aP = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
$p.ahe = (function(source) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray()), source).aR();
});
$p.bp = (function(source) {
  return this.ahe(source);
});
$p.ce = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
var $d_sjs_js_WrappedArray$ = new $TypeData().i($c_sjs_js_WrappedArray$, "scala.scalajs.js.WrappedArray$", ({
  Bx: 1,
  aW: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$();
  }
  return $n_sjs_js_WrappedArray$;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
}
$p = $c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$p.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
}
$h_sjsr_WrappedVarArgs$.prototype = $p;
$p.e4 = (function(elems) {
  return this.Uq(elems);
});
$p.Uq = (function(source) {
  return this.aP().cz(source).aR();
});
$p.aP = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1$2$2.mt))), $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), []));
});
$p.bp = (function(source) {
  return this.Uq(source);
});
$p.ce = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs());
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().i($c_sjsr_WrappedVarArgs$, "scala.scalajs.runtime.WrappedVarArgs$", ({
  BE: 1,
  aW: 1,
  a: 1,
  U: 1,
  ak: 1
}));
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$();
  }
  return $n_sjsr_WrappedVarArgs$;
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.tJ = null;
  this.tJ = exception;
}
$p = $c_s_util_Failure.prototype = new $h_s_util_Try();
$p.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
$h_s_util_Failure.prototype = $p;
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1408943127), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_s_util_Failure)) {
    var x = this.tJ;
    var x$2 = x$0.tJ;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Failure";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ahO = (function() {
  return true;
});
$p.h = (function() {
  var $x_1 = this.tJ;
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
});
$p.Uu = (function(default$1) {
  return default$1.aA();
});
$p.al = (function(f) {
});
$p.kN = (function(f) {
  return this;
});
$p.ajj = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.aJ(this.tJ, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : this);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x18 = $m_s_util_control_NonFatal$().dV(e$2);
    if ((!x18.c())) {
      return new $c_s_util_Failure(x18.h());
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
  }
});
$p.mN = (function() {
  return $m_s_None$();
});
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.io)));
}
var $d_s_util_Failure = new $TypeData().i($c_s_util_Failure, "scala.util.Failure", ({
  io: 1,
  d4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_s_util_Success(value) {
  this.hC = null;
  this.hC = value;
}
$p = $c_s_util_Success.prototype = new $h_s_util_Try();
$p.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
$h_s_util_Success.prototype = $p;
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1750213842), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_s_util_Success) && $m_sr_BoxesRunTime$().B(this.hC, x$0.hC)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Success";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.hC;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ahO = (function() {
  return false;
});
$p.h = (function() {
  return this.hC;
});
$p.Uu = (function(default$1) {
  return this.hC;
});
$p.al = (function(f) {
  f.p(this.hC);
});
$p.kN = (function(f) {
  try {
    return new $c_s_util_Success(f.p(this.hC));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x2 = $m_s_util_control_NonFatal$().dV(e$2);
    if ((!x2.c())) {
      return new $c_s_util_Failure(x2.h());
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
  }
});
$p.ajj = (function(pf) {
  return this;
});
$p.mN = (function() {
  return new $c_s_Some(this.hC);
});
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ip)));
}
var $d_s_util_Success = new $TypeData().i($c_s_util_Success, "scala.util.Success", ({
  ip: 1,
  d4: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lscalatags_generic_AttrPair(a, v, ev) {
  this.De = null;
  this.Hs = null;
  this.Hr = null;
  this.De = a;
  this.Hs = v;
  this.Hr = ev;
}
$p = $c_Lscalatags_generic_AttrPair.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_AttrPair;
/** @constructor */
function $h_Lscalatags_generic_AttrPair() {
}
$h_Lscalatags_generic_AttrPair.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscalatags_generic_AttrPair)) {
    var x = this.De;
    var x$2 = x$0.De;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && $m_sr_BoxesRunTime$().B(this.Hs, x$0.Hs))) {
      var x$3 = this.Hr;
      var x$4 = x$0.Hr;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "AttrPair";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.De;
      break;
    }
    case 1: {
      return this.Hs;
      break;
    }
    case 2: {
      return this.Hr;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oD = (function(t) {
  this.Hr.afK(t, this.De, this.Hs);
});
$p.n = (function(v, ev) {
  return new $c_Lscalatags_generic_AttrPair(this.De, v, ev);
});
function $isArrayOf_Lscalatags_generic_AttrPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iu)));
}
var $d_Lscalatags_generic_AttrPair = new $TypeData().i($c_Lscalatags_generic_AttrPair, "scalatags.generic.AttrPair", ({
  iu: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lscalatags_generic_StylePair(s, v, ev) {
  this.Hv = null;
  this.Hw = null;
  this.Hu = null;
  this.Hv = s;
  this.Hw = v;
  this.Hu = ev;
}
$p = $c_Lscalatags_generic_StylePair.prototype = new $h_O();
$p.constructor = $c_Lscalatags_generic_StylePair;
/** @constructor */
function $h_Lscalatags_generic_StylePair() {
}
$h_Lscalatags_generic_StylePair.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscalatags_generic_StylePair)) {
    var x = this.Hv;
    var x$2 = x$0.Hv;
    if ((((x === null) ? (x$2 === null) : x.b(x$2)) && $m_sr_BoxesRunTime$().B(this.Hw, x$0.Hw))) {
      var x$3 = this.Hu;
      var x$4 = x$0.Hu;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "StylePair";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Hv;
      break;
    }
    case 1: {
      return this.Hw;
      break;
    }
    case 2: {
      return this.Hu;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oD = (function(t) {
  this.Hu.amG(t, this.Hv, this.Hw);
});
function $isArrayOf_Lscalatags_generic_StylePair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ix)));
}
var $d_Lscalatags_generic_StylePair = new $TypeData().i($c_Lscalatags_generic_StylePair, "scalatags.generic.StylePair", ({
  ix: 1,
  aZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_CharParser$$anon$1(j$2) {
  this.adj = 0;
  this.adj = j$2;
}
$p = $c_Lujson_CharParser$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lujson_CharParser$$anon$1;
/** @constructor */
function $h_Lujson_CharParser$$anon$1() {
}
$h_Lujson_CharParser$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return ((x instanceof $c_Lupickle_core_Abort) || false);
});
$p.bn = (function(x, default$1) {
  if ((x instanceof $c_Lupickle_core_Abort)) {
    throw new $c_Lupickle_core_AbortException(x.Dl, this.adj, (-1), (-1), x);
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lujson_CharParser$$anon$1 = new $TypeData().i($c_Lujson_CharParser$$anon$1, "ujson.CharParser$$anon$1", ({
  Cy: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lujson_Readable$fromTransformer(t, w) {
  this.HE = null;
  this.HF = null;
  this.HE = t;
  this.HF = w;
}
$p = $c_Lujson_Readable$fromTransformer.prototype = new $h_O();
$p.constructor = $c_Lujson_Readable$fromTransformer;
/** @constructor */
function $h_Lujson_Readable$fromTransformer() {
}
$h_Lujson_Readable$fromTransformer.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-883911318), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lujson_Readable$fromTransformer)) {
    if ($m_sr_BoxesRunTime$().B(this.HE, x$0.HE)) {
      var x$1 = this.HF;
      var x$2 = x$0.HF;
      return ((x$1 === null) ? (x$2 === null) : (x$1 === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "fromTransformer";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HE;
  }
  if ((n === 1)) {
    return this.HF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_Readable$fromTransformer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iD)));
}
var $d_Lujson_Readable$fromTransformer = new $TypeData().i($c_Lujson_Readable$fromTransformer, "ujson.Readable$fromTransformer", ({
  iD: 1,
  CC: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lupack_Msg$__visitObjContents__Lupickle_core_Visitor__Lupickle_core_LinkedHashMap__O($thiz, f, items) {
  var obj = f.K(items.aH(), true, (-1));
  var kvs = new $c_Lupickle_core_LinkedHashMap$$anon$1(items);
  while (kvs.HT.f()) {
    var kv = kvs.kS();
    var k = kv.P();
    var v = kv.V();
    var keyVisitor = obj.eT((-1));
    obj.eU($m_Lupack_Msg$().ND(k, keyVisitor));
    obj.bu($thiz.ND(v, obj.bw()), (-1));
  }
  return obj.L((-1));
}
function $p_Lupack_Msg$__visitArrContents__Lupickle_core_Visitor__scm_ArrayBuffer__O($thiz, f, items) {
  var arr = f.bt(items.dh, (-1));
  var i = 0;
  var itemsLength = items.dh;
  while ((i < itemsLength)) {
    arr.bu($thiz.ND(items.at(i), arr.bw()), (-1));
    i = ((1 + i) | 0);
  }
  return arr.L((-1));
}
/** @constructor */
function $c_Lupack_Msg$() {
}
$p = $c_Lupack_Msg$.prototype = new $h_O();
$p.constructor = $c_Lupack_Msg$;
/** @constructor */
function $h_Lupack_Msg$() {
}
$h_Lupack_Msg$.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.cL = (function(s, index) {
  return $f_Lupack_MsgVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupack_MsgVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.ND = (function(j, f) {
  if (($m_Lupack_Null$() === j)) {
    return f.M((-1));
  }
  if (($m_Lupack_True$() === j)) {
    return f.ch((-1));
  }
  if (($m_Lupack_False$() === j)) {
    return f.cg((-1));
  }
  if ((j instanceof $c_Lupack_Int32)) {
    var x141 = j.Dk;
    return f.c9(x141, (-1));
  }
  if ((j instanceof $c_Lupack_Int64)) {
    var $x_1 = j;
    var x138_$_lo = $x_1.DF;
    var x138_$_hi = $x_1.DG;
    return f.cv(x138_$_lo, x138_$_hi, (-1));
  }
  if ((j instanceof $c_Lupack_UInt64)) {
    var $x_2 = j;
    var x135_$_lo = $x_2.DH;
    var x135_$_hi = $x_2.DI;
    return f.cD(x135_$_lo, x135_$_hi, (-1));
  }
  if ((j instanceof $c_Lupack_Float32)) {
    var x132 = j.Di;
    return f.cs(x132, (-1));
  }
  if ((j instanceof $c_Lupack_Float64)) {
    var x129 = j.Dj;
    return f.ct(x129, (-1));
  }
  if ((j instanceof $c_Lupack_Str)) {
    var x126 = j.HL;
    return f.bx(x126, (-1));
  }
  if ((j instanceof $c_Lupack_Binary)) {
    var x123 = j.HJ;
    return f.cr(x123, 0, x123.a.length, (-1));
  }
  if ((j instanceof $c_Lupack_Arr)) {
    return $p_Lupack_Msg$__visitArrContents__Lupickle_core_Visitor__scm_ArrayBuffer__O(this, f, j.HI);
  }
  if ((j instanceof $c_Lupack_Obj)) {
    return $p_Lupack_Msg$__visitObjContents__Lupickle_core_Visitor__Lupickle_core_LinkedHashMap__O(this, f, j.HK);
  }
  if ((j instanceof $c_Lupack_Ext)) {
    var x113 = j.Dh;
    var x114 = j.Dg;
    return f.cC(x113, x114, 0, x114.a.length, (-1));
  }
  throw new $c_s_MatchError(j);
});
$p.bt = (function(length, index) {
  return new $c_Lupack_Msg$$anon$1();
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupack_Msg$$anon$2();
});
$p.az8 = (function(bytes, offset, len, index) {
  return new $c_Lupack_Binary($m_sc_ArrayOps$().uD(bytes, offset, ((offset + len) | 0)));
});
$p.azd = (function(tag, bytes, offset, len, index) {
  return new $c_Lupack_Ext(tag, $m_sc_ArrayOps$().uD(bytes, offset, ((offset + len) | 0)));
});
$p.az9 = (function(s, index) {
  return new $c_Lupack_Int32(s);
});
$p.M = (function(index) {
  return $m_Lupack_Null$();
});
$p.cg = (function(index) {
  return $m_Lupack_False$();
});
$p.ch = (function(index) {
  return $m_Lupack_True$();
});
$p.ct = (function(d, index) {
  return new $c_Lupack_Float64(d);
});
$p.cs = (function(d, index) {
  return new $c_Lupack_Float32(d);
});
$p.c9 = (function(i, index) {
  return new $c_Lupack_Int32(i);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupack_Int64(i_$_lo, i_$_hi);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return new $c_Lupack_UInt64(i_$_lo, i_$_hi);
});
$p.bx = (function(s, index) {
  return new $c_Lupack_Str($dp_toString__T(s));
});
$p.cr = (function(bytes, offset, len, index) {
  return this.az8(bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return this.azd(tag, bytes, offset, len, index);
});
$p.cB = (function(s, index) {
  return this.az9(s, index);
});
var $d_Lupack_Msg$ = new $TypeData().i($c_Lupack_Msg$, "upack.Msg$", ({
  CH: 1,
  d: 1,
  CK: 1,
  v: 1,
  an: 1
}));
var $n_Lupack_Msg$;
function $m_Lupack_Msg$() {
  if ((!$n_Lupack_Msg$)) {
    $n_Lupack_Msg$ = new $c_Lupack_Msg$();
  }
  return $n_Lupack_Msg$;
}
/** @constructor */
function $c_Lupickle_core_Annotator$Checker$Cls(c) {
  this.HR = null;
  this.HR = c;
}
$p = $c_Lupickle_core_Annotator$Checker$Cls.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Annotator$Checker$Cls;
/** @constructor */
function $h_Lupickle_core_Annotator$Checker$Cls() {
}
$h_Lupickle_core_Annotator$Checker$Cls.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 49928814, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_Annotator$Checker$Cls)) {
    var x = this.HR;
    var x$2 = x$0.HR;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Cls";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupickle_core_Annotator$Checker$Cls(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iT)));
}
var $d_Lupickle_core_Annotator$Checker$Cls = new $TypeData().i($c_Lupickle_core_Annotator$Checker$Cls, "upickle.core.Annotator$Checker$Cls", ({
  iT: 1,
  iS: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_Annotator$Checker$Val(v) {
  this.HS = null;
  this.HS = v;
}
$p = $c_Lupickle_core_Annotator$Checker$Val.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Annotator$Checker$Val;
/** @constructor */
function $h_Lupickle_core_Annotator$Checker$Val() {
}
$h_Lupickle_core_Annotator$Checker$Val.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 490693973, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_Annotator$Checker$Val) && $m_sr_BoxesRunTime$().B(this.HS, x$0.HS)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Val";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupickle_core_Annotator$Checker$Val(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iU)));
}
var $d_Lupickle_core_Annotator$Checker$Val = new $TypeData().i($c_Lupickle_core_Annotator$Checker$Val, "upickle.core.Annotator$Checker$Val", ({
  iU: 1,
  iS: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$1() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$1;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$1() {
}
$h_Lupickle_core_BufferedValue$$anon$1.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$Num)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x79 = x.P();
    if ((x79 instanceof $c_Lupickle_core_BufferedValue$Num)) {
      x.V();
      $m_sc_StringOps$();
      return $m_jl_Double$().fS($dp_toString__T(x79.tR));
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$1 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$1, "upickle.core.BufferedValue$$anon$1", ({
  CX: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$2() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$2;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$2() {
}
$h_Lupickle_core_BufferedValue$$anon$2.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x87 = x.P();
    if ((x87 instanceof $c_Lupickle_core_BufferedValue$Float32)) {
      x.V();
      return x87.tO;
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$2 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$2, "upickle.core.BufferedValue$$anon$2", ({
  CY: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$3() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$3;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$3() {
}
$h_Lupickle_core_BufferedValue$$anon$3.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x95 = x.P();
    if ((x95 instanceof $c_Lupickle_core_BufferedValue$Float64String)) {
      x.V();
      $m_sc_StringOps$();
      return $m_jl_Double$().fS(x95.tP);
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$3 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$3, "upickle.core.BufferedValue$$anon$3", ({
  CZ: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$4() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$4;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$4() {
}
$h_Lupickle_core_BufferedValue$$anon$4.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x103 = x.P();
    if ((x103 instanceof $c_Lupickle_core_BufferedValue$Int32)) {
      x.V();
      return x103.tQ;
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$4 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$4, "upickle.core.BufferedValue$$anon$4", ({
  D0: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$5() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$5;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$5() {
}
$h_Lupickle_core_BufferedValue$$anon$5.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x111 = x.P();
    if ((x111 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
      x.V();
      var $x_1 = x111;
      return $bL($x_1.uh, $x_1.ui);
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$5 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$5, "upickle.core.BufferedValue$$anon$5", ({
  D1: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$6() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$6;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$6() {
}
$h_Lupickle_core_BufferedValue$$anon$6.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x119 = x.P();
    if ((x119 instanceof $c_Lupickle_core_BufferedValue$NumRaw)) {
      x.V();
      return x119.tS;
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$6 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$6, "upickle.core.BufferedValue$$anon$6", ({
  D2: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$7() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$7;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$7() {
}
$h_Lupickle_core_BufferedValue$$anon$7.prototype = $p;
$p.fO = (function(x) {
  if ((x !== null)) {
    if ((x.P() instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      x.V();
      return true;
    }
  }
  return false;
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var x127 = x.P();
    if ((x127 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
      x.V();
      var $x_1 = x127;
      return $bL($x_1.uj, $x_1.uk);
    }
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$7 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$7, "upickle.core.BufferedValue$$anon$7", ({
  D3: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$$anon$8() {
}
$p = $c_Lupickle_core_BufferedValue$$anon$8.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_BufferedValue$$anon$8;
/** @constructor */
function $h_Lupickle_core_BufferedValue$$anon$8() {
}
$h_Lupickle_core_BufferedValue$$anon$8.prototype = $p;
$p.fO = (function(x) {
  return ((x !== null) && (x.P(), x.V(), true));
});
$p.fI = (function(x, default$1) {
  if ((x !== null)) {
    var k = x.P();
    x.V();
    return $m_Lupickle_core_BufferedValue$().Ji(k);
  } else {
    return default$1.p(x);
  }
});
$p.aU = (function(x) {
  return this.fO(x);
});
$p.aJ = (function(x, default$1) {
  return this.fI(x, default$1);
});
var $d_Lupickle_core_BufferedValue$$anon$8 = new $TypeData().i($c_Lupickle_core_BufferedValue$$anon$8, "upickle.core.BufferedValue$$anon$8", ({
  D4: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Arr(value, index) {
  this.tN = null;
  this.yF = 0;
  this.tN = value;
  this.yF = index;
}
$p = $c_Lupickle_core_BufferedValue$Arr.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Arr;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Arr() {
}
$h_Lupickle_core_BufferedValue$Arr.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 66113);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.tN));
  acc = $m_sr_Statics$().d(acc, this.yF);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Arr)) {
    if ((this.yF === x$0.yF)) {
      var x = this.tN;
      var x$2 = x$0.tN;
      return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Arr";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tN;
  }
  if ((n === 1)) {
    return this.yF;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yF;
});
function $isArrayOf_Lupickle_core_BufferedValue$Arr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iV)));
}
var $d_Lupickle_core_BufferedValue$Arr = new $TypeData().i($c_Lupickle_core_BufferedValue$Arr, "upickle.core.BufferedValue$Arr", ({
  iV: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Binary(bytes, offset, len, index) {
  this.yG = null;
  this.yJ = 0;
  this.yI = 0;
  this.yH = 0;
  this.yG = bytes;
  this.yJ = offset;
  this.yI = len;
  this.yH = index;
}
$p = $c_Lupickle_core_BufferedValue$Binary.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Binary;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Binary() {
}
$h_Lupickle_core_BufferedValue$Binary.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1989867553);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.yG));
  acc = $m_sr_Statics$().d(acc, this.yJ);
  acc = $m_sr_Statics$().d(acc, this.yI);
  acc = $m_sr_Statics$().d(acc, this.yH);
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Binary)) {
    if ((((this.yJ === x$0.yJ) && (this.yI === x$0.yI)) && (this.yH === x$0.yH))) {
      var x = this.yG;
      var x$2 = x$0.yG;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "Binary";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.yG;
      break;
    }
    case 1: {
      return this.yJ;
      break;
    }
    case 2: {
      return this.yI;
      break;
    }
    case 3: {
      return this.yH;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.f7 = (function() {
  return this.yH;
});
function $isArrayOf_Lupickle_core_BufferedValue$Binary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iW)));
}
var $d_Lupickle_core_BufferedValue$Binary = new $TypeData().i($c_Lupickle_core_BufferedValue$Binary, "upickle.core.BufferedValue$Binary", ({
  iW: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Char(s, index) {
  this.yL = 0;
  this.yK = 0;
  this.yL = s;
  this.yK = index;
}
$p = $c_Lupickle_core_BufferedValue$Char.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Char;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Char() {
}
$h_Lupickle_core_BufferedValue$Char.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 2099062);
  acc = $m_sr_Statics$().d(acc, this.yL);
  acc = $m_sr_Statics$().d(acc, this.yK);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Char) && ((this.yL === x$0.yL) && (this.yK === x$0.yK))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Char";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bC(this.yL);
  }
  if ((n === 1)) {
    return this.yK;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yK;
});
function $isArrayOf_Lupickle_core_BufferedValue$Char(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iX)));
}
var $d_Lupickle_core_BufferedValue$Char = new $TypeData().i($c_Lupickle_core_BufferedValue$Char, "upickle.core.BufferedValue$Char", ({
  iX: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Ext(tag, bytes, offset, len, index) {
  this.yQ = 0;
  this.yM = null;
  this.yP = 0;
  this.yO = 0;
  this.yN = 0;
  this.yQ = tag;
  this.yM = bytes;
  this.yP = offset;
  this.yO = len;
  this.yN = index;
}
$p = $c_Lupickle_core_BufferedValue$Ext.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Ext;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Ext() {
}
$h_Lupickle_core_BufferedValue$Ext.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70145);
  acc = $m_sr_Statics$().d(acc, this.yQ);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.yM));
  acc = $m_sr_Statics$().d(acc, this.yP);
  acc = $m_sr_Statics$().d(acc, this.yO);
  acc = $m_sr_Statics$().d(acc, this.yN);
  return $m_sr_Statics$().an(acc, 5);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Ext)) {
    if (((((this.yQ === x$0.yQ) && (this.yP === x$0.yP)) && (this.yO === x$0.yO)) && (this.yN === x$0.yN))) {
      var x = this.yM;
      var x$2 = x$0.yM;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 5;
});
$p.A = (function() {
  return "Ext";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.yQ;
      break;
    }
    case 1: {
      return this.yM;
      break;
    }
    case 2: {
      return this.yP;
      break;
    }
    case 3: {
      return this.yO;
      break;
    }
    case 4: {
      return this.yN;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.f7 = (function() {
  return this.yN;
});
function $isArrayOf_Lupickle_core_BufferedValue$Ext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iY)));
}
var $d_Lupickle_core_BufferedValue$Ext = new $TypeData().i($c_Lupickle_core_BufferedValue$Ext, "upickle.core.BufferedValue$Ext", ({
  iY: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$False(index) {
  this.yR = 0;
  this.yR = index;
}
$p = $c_Lupickle_core_BufferedValue$False.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$False;
/** @constructor */
function $h_Lupickle_core_BufferedValue$False() {
}
$h_Lupickle_core_BufferedValue$False.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 67643651);
  acc = $m_sr_Statics$().d(acc, this.yR);
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$False) && (this.yR === x$0.yR)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "False";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.yR;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yR;
});
function $isArrayOf_Lupickle_core_BufferedValue$False(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iZ)));
}
var $d_Lupickle_core_BufferedValue$False = new $TypeData().i($c_Lupickle_core_BufferedValue$False, "upickle.core.BufferedValue$False", ({
  iZ: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Float32(d, index) {
  this.tO = 0.0;
  this.yS = 0;
  this.tO = d;
  this.yS = index;
}
$p = $c_Lupickle_core_BufferedValue$Float32.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Float32;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Float32() {
}
$h_Lupickle_core_BufferedValue$Float32.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 898210203);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.tO));
  acc = $m_sr_Statics$().d(acc, this.yS);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Float32) && ((this.tO === x$0.tO) && (this.yS === x$0.yS))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Float32";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tO;
  }
  if ((n === 1)) {
    return this.yS;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yS;
});
function $isArrayOf_Lupickle_core_BufferedValue$Float32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j0)));
}
var $d_Lupickle_core_BufferedValue$Float32 = new $TypeData().i($c_Lupickle_core_BufferedValue$Float32, "upickle.core.BufferedValue$Float32", ({
  j0: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Float64String(s, index) {
  this.tP = null;
  this.yT = 0;
  this.tP = s;
  this.yT = index;
}
$p = $c_Lupickle_core_BufferedValue$Float64String.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Float64String;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Float64String() {
}
$h_Lupickle_core_BufferedValue$Float64String.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 21168811);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.tP));
  acc = $m_sr_Statics$().d(acc, this.yT);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Float64String) && ((this.yT === x$0.yT) && (this.tP === x$0.tP))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Float64String";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tP;
  }
  if ((n === 1)) {
    return this.yT;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yT;
});
function $isArrayOf_Lupickle_core_BufferedValue$Float64String(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j1)));
}
var $d_Lupickle_core_BufferedValue$Float64String = new $TypeData().i($c_Lupickle_core_BufferedValue$Float64String, "upickle.core.BufferedValue$Float64String", ({
  j1: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Int32(i, index) {
  this.tQ = 0;
  this.yU = 0;
  this.tQ = i;
  this.yU = index;
}
$p = $c_Lupickle_core_BufferedValue$Int32.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Int32;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Int32() {
}
$h_Lupickle_core_BufferedValue$Int32.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70807150);
  acc = $m_sr_Statics$().d(acc, this.tQ);
  acc = $m_sr_Statics$().d(acc, this.yU);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Int32) && ((this.tQ === x$0.tQ) && (this.yU === x$0.yU))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Int32";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tQ;
  }
  if ((n === 1)) {
    return this.yU;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yU;
});
function $isArrayOf_Lupickle_core_BufferedValue$Int32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j2)));
}
var $d_Lupickle_core_BufferedValue$Int32 = new $TypeData().i($c_Lupickle_core_BufferedValue$Int32, "upickle.core.BufferedValue$Int32", ({
  j2: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Int64(i_$_lo, i_$_hi, index) {
  this.uh = 0;
  this.ui = 0;
  this.yV = 0;
  this.uh = i_$_lo;
  this.ui = i_$_hi;
  this.yV = index;
}
$p = $c_Lupickle_core_BufferedValue$Int64.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Int64;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Int64() {
}
$h_Lupickle_core_BufferedValue$Int64.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70807245);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.uh, this.ui));
  acc = $m_sr_Statics$().d(acc, this.yV);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Int64)) {
    var x_$_lo = this.uh;
    var x_$_hi = this.ui;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.uh;
    var x$1_$_hi = $x_1.ui;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      return (this.yV === x$0.yV);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Int64";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.uh, this.ui);
  }
  if ((n === 1)) {
    return this.yV;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yV;
});
function $isArrayOf_Lupickle_core_BufferedValue$Int64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j3)));
}
var $d_Lupickle_core_BufferedValue$Int64 = new $TypeData().i($c_Lupickle_core_BufferedValue$Int64, "upickle.core.BufferedValue$Int64", ({
  j3: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Null(index) {
  this.yW = 0;
  this.yW = index;
}
$p = $c_Lupickle_core_BufferedValue$Null.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Null;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Null() {
}
$h_Lupickle_core_BufferedValue$Null.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 2439591);
  acc = $m_sr_Statics$().d(acc, this.yW);
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$Null) && (this.yW === x$0.yW)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Null";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.yW;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yW;
});
function $isArrayOf_Lupickle_core_BufferedValue$Null(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j4)));
}
var $d_Lupickle_core_BufferedValue$Null = new $TypeData().i($c_Lupickle_core_BufferedValue$Null, "upickle.core.BufferedValue$Null", ({
  j4: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Num(s, decIndex, expIndex, index) {
  this.tR = null;
  this.Dm = 0;
  this.Dn = 0;
  this.yX = 0;
  this.tR = s;
  this.Dm = decIndex;
  this.Dn = expIndex;
  this.yX = index;
}
$p = $c_Lupickle_core_BufferedValue$Num.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Num;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Num() {
}
$h_Lupickle_core_BufferedValue$Num.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 78694);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.tR));
  acc = $m_sr_Statics$().d(acc, this.Dm);
  acc = $m_sr_Statics$().d(acc, this.Dn);
  acc = $m_sr_Statics$().d(acc, this.yX);
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Num)) {
    if ((((this.Dm === x$0.Dm) && (this.Dn === x$0.Dn)) && (this.yX === x$0.yX))) {
      var x = this.tR;
      var x$2 = x$0.tR;
      return ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "Num";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.tR;
      break;
    }
    case 1: {
      return this.Dm;
      break;
    }
    case 2: {
      return this.Dn;
      break;
    }
    case 3: {
      return this.yX;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.f7 = (function() {
  return this.yX;
});
function $isArrayOf_Lupickle_core_BufferedValue$Num(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j5)));
}
var $d_Lupickle_core_BufferedValue$Num = new $TypeData().i($c_Lupickle_core_BufferedValue$Num, "upickle.core.BufferedValue$Num", ({
  j5: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$NumRaw(d, index) {
  this.tS = 0.0;
  this.yY = 0;
  this.tS = d;
  this.yY = index;
}
$p = $c_Lupickle_core_BufferedValue$NumRaw.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$NumRaw;
/** @constructor */
function $h_Lupickle_core_BufferedValue$NumRaw() {
}
$h_Lupickle_core_BufferedValue$NumRaw.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1950512414));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.tS));
  acc = $m_sr_Statics$().d(acc, this.yY);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$NumRaw) && ((this.tS === x$0.tS) && (this.yY === x$0.yY))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "NumRaw";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.tS;
  }
  if ((n === 1)) {
    return this.yY;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.yY;
});
function $isArrayOf_Lupickle_core_BufferedValue$NumRaw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j6)));
}
var $d_Lupickle_core_BufferedValue$NumRaw = new $TypeData().i($c_Lupickle_core_BufferedValue$NumRaw, "upickle.core.BufferedValue$NumRaw", ({
  j6: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Obj(value0, jsonableKeys, index) {
  this.on = null;
  this.Do = false;
  this.yZ = 0;
  this.on = value0;
  this.Do = jsonableKeys;
  this.yZ = index;
}
$p = $c_Lupickle_core_BufferedValue$Obj.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Obj;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Obj() {
}
$h_Lupickle_core_BufferedValue$Obj.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 79063);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.on));
  acc = $m_sr_Statics$().d(acc, (this.Do ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, this.yZ);
  return $m_sr_Statics$().an(acc, 3);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Obj)) {
    if (((this.Do === x$0.Do) && (this.yZ === x$0.yZ))) {
      var x = this.on;
      var x$2 = x$0.on;
      return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 3;
});
$p.A = (function() {
  return "Obj";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.on;
      break;
    }
    case 1: {
      return this.Do;
      break;
    }
    case 2: {
      return this.yZ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.f7 = (function() {
  return this.yZ;
});
function $isArrayOf_Lupickle_core_BufferedValue$Obj(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j7)));
}
var $d_Lupickle_core_BufferedValue$Obj = new $TypeData().i($c_Lupickle_core_BufferedValue$Obj, "upickle.core.BufferedValue$Obj", ({
  j7: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$Str(value0, index) {
  this.qr = null;
  this.z0 = 0;
  this.qr = value0;
  this.z0 = index;
}
$p = $c_Lupickle_core_BufferedValue$Str.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$Str;
/** @constructor */
function $h_Lupickle_core_BufferedValue$Str() {
}
$h_Lupickle_core_BufferedValue$Str.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 83473);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.qr));
  acc = $m_sr_Statics$().d(acc, this.z0);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$Str)) {
    if ((this.z0 === x$0.z0)) {
      var x = this.qr;
      var x$2 = x$0.qr;
      return ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Str";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.qr;
  }
  if ((n === 1)) {
    return this.z0;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.z0;
});
function $isArrayOf_Lupickle_core_BufferedValue$Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j8)));
}
var $d_Lupickle_core_BufferedValue$Str = new $TypeData().i($c_Lupickle_core_BufferedValue$Str, "upickle.core.BufferedValue$Str", ({
  j8: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$True(index) {
  this.z1 = 0;
  this.z1 = index;
}
$p = $c_Lupickle_core_BufferedValue$True.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$True;
/** @constructor */
function $h_Lupickle_core_BufferedValue$True() {
}
$h_Lupickle_core_BufferedValue$True.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 2615726);
  acc = $m_sr_Statics$().d(acc, this.z1);
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_BufferedValue$True) && (this.z1 === x$0.z1)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "True";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.z1;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.z1;
});
function $isArrayOf_Lupickle_core_BufferedValue$True(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j9)));
}
var $d_Lupickle_core_BufferedValue$True = new $TypeData().i($c_Lupickle_core_BufferedValue$True, "upickle.core.BufferedValue$True", ({
  j9: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_BufferedValue$UInt64(i_$_lo, i_$_hi, index) {
  this.uj = 0;
  this.uk = 0;
  this.z2 = 0;
  this.uj = i_$_lo;
  this.uk = i_$_hi;
  this.z2 = index;
}
$p = $c_Lupickle_core_BufferedValue$UInt64.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_BufferedValue$UInt64;
/** @constructor */
function $h_Lupickle_core_BufferedValue$UInt64() {
}
$h_Lupickle_core_BufferedValue$UInt64.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1790682216));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.uj, this.uk));
  acc = $m_sr_Statics$().d(acc, this.z2);
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupickle_core_BufferedValue$UInt64)) {
    var x_$_lo = this.uj;
    var x_$_hi = this.uk;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.uj;
    var x$1_$_hi = $x_1.uk;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      return (this.z2 === x$0.z2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "UInt64";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.uj, this.uk);
  }
  if ((n === 1)) {
    return this.z2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.f7 = (function() {
  return this.z2;
});
function $isArrayOf_Lupickle_core_BufferedValue$UInt64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ja)));
}
var $d_Lupickle_core_BufferedValue$UInt64 = new $TypeData().i($c_Lupickle_core_BufferedValue$UInt64, "upickle.core.BufferedValue$UInt64", ({
  ja: 1,
  ai: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_ParseUtils$$anon$1(j$2) {
  this.adp = 0;
  this.adp = j$2;
}
$p = $c_Lupickle_core_ParseUtils$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$p.constructor = $c_Lupickle_core_ParseUtils$$anon$1;
/** @constructor */
function $h_Lupickle_core_ParseUtils$$anon$1() {
}
$h_Lupickle_core_ParseUtils$$anon$1.prototype = $p;
$p.bq = (function(x) {
  return ((x instanceof $c_Lupickle_core_Abort) || false);
});
$p.bn = (function(x, default$1) {
  if ((x instanceof $c_Lupickle_core_Abort)) {
    throw new $c_Lupickle_core_AbortException(x.Dl, this.adp, (-1), (-1), x);
  }
  return default$1.p(x);
});
$p.aU = (function(x) {
  return this.bq(x);
});
$p.aJ = (function(x, default$1) {
  return this.bn(x, default$1);
});
var $d_Lupickle_core_ParseUtils$$anon$1 = new $TypeData().i($c_Lupickle_core_ParseUtils$$anon$1, "upickle.core.ParseUtils$$anon$1", ({
  Dk: 1,
  B: 1,
  p: 1,
  t: 1,
  a: 1
}));
class $c_Lupickle_core_TraceVisitor$TraceException extends $c_jl_Exception {
  constructor(jsonPath, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, jsonPath, cause, true, true);
  }
  zF() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_Lupickle_core_TraceVisitor$TraceException = new $TypeData().i($c_Lupickle_core_TraceVisitor$TraceException, "upickle.core.TraceVisitor$TraceException", ({
  Dr: 1,
  J: 1,
  F: 1,
  a: 1,
  bE: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$$anon$4(f$5, outer) {
  this.fG = null;
  this.SS = null;
  this.adt = null;
  this.adt = f$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_core_Types$Reader$MapReader__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(this, outer.dL().hJ(), outer);
}
$p = $c_Lupickle_core_Types$$anon$4.prototype = new $h_Lupickle_core_Types$Reader$MapReader();
$p.constructor = $c_Lupickle_core_Types$$anon$4;
/** @constructor */
function $h_Lupickle_core_Types$$anon$4() {
}
$h_Lupickle_core_Types$$anon$4.prototype = $p;
$p.V0 = (function(v) {
  return this.adt.p(v);
});
var $d_Lupickle_core_Types$$anon$4 = new $TypeData().i($c_Lupickle_core_Types$$anon$4, "upickle.core.Types$$anon$4", ({
  Dw: 1,
  Dz: 1,
  DL: 1,
  d: 1,
  e: 1
}));
function $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O($thiz, s, index) {
  var x6 = $thiz.f5($dp_toString__T(s));
  if ((x6 === null)) {
    throw new $c_Lupickle_core_AbortException(("invalid tag for tagged object: " + s), index, (-1), (-1), null);
  }
  return x6.bx(s, index);
}
function $is_Lupickle_core_Types$TaggedReader(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bG)));
}
function $isArrayOf_Lupickle_core_Types$TaggedReader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bG)));
}
function $ct_Lupickle_implicits_CaseClassReadWriters$CaseClassReader__Lupickle_implicits_CaseClassReadWriters__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.a0 = outer;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader() {
  this.a0 = null;
}
$p = $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseClassReadWriters$CaseClassReader;
/** @constructor */
function $h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader() {
}
$h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected dictionary";
});
$p.dL = (function() {
  return this.a0;
});
/** @constructor */
function $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(outer, f) {
  this.ae1 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae1 = outer;
}
$p = $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter;
/** @constructor */
function $h_Lupickle_implicits_CaseClassReadWriters$SingletonWriter() {
}
$h_Lupickle_implicits_CaseClassReadWriters$SingletonWriter.prototype = $p;
$p.Q = (function() {
  return false;
});
$p.S = (function() {
  return this;
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.U = (function(out, v) {
  return $f_Lupickle_implicits_CaseClassReadWriters$CaseClassWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.ah = (function(v) {
  return 0;
});
$p.ai = (function(ctx, v) {
});
$p.T = (function() {
  return this.ae1;
});
function $isArrayOf_Lupickle_implicits_CaseClassReadWriters$SingletonWriter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jg)));
}
var $d_Lupickle_implicits_CaseClassReadWriters$SingletonWriter = new $TypeData().i($c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter, "upickle.implicits.CaseClassReadWriters$SingletonWriter", ({
  jg: 1,
  j: 1,
  k: 1,
  n: 1,
  o: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$1(outer) {
  this.ae4 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae4 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$1.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$1() {
}
$h_Lupickle_implicits_Readers$$anon$1.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected unit";
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_implicits_Readers$$anon$2();
});
$p.dL = (function() {
  return this.ae4;
});
$p.M = (function(index) {
  return (void 0);
});
var $d_Lupickle_implicits_Readers$$anon$1 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$1, "upickle.implicits.Readers$$anon$1", ({
  E3: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$17(v$2, k$2, make$2, outer) {
  this.T8 = null;
  this.T6 = null;
  this.T7 = null;
  this.LV = null;
  this.T8 = v$2;
  this.T6 = k$2;
  this.T7 = make$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.LV = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$17.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$17;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$17() {
}
$h_Lupickle_implicits_Readers$$anon$17.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_implicits_Readers$$anon$17$$anon$18(this);
});
$p.bt = (function(length, index) {
  var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => this.T7.p($m_s_Predef$().Jl(x))));
  var $x_3 = this.LV;
  var $x_2 = $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader(this.LV, this.T6, this.T8);
  var $x_1;
  var $x_1 = new $c_s_reflect_ClassTag$GenericClassTag($d_T2.l());
  return $c_Lupickle_core_Visitor$MapReader.prototype.bt.call(new $c_Lupickle_core_Types$$anon$4($x_4, new $c_Lupickle_implicits_Readers$SeqLikeReader($x_3, $x_2, new $c_sc_Factory$ArrayFactory($x_1))), length, index);
});
$p.bR = (function() {
  return "expected map or sequence";
});
$p.dL = (function() {
  return this.LV;
});
var $d_Lupickle_implicits_Readers$$anon$17 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$17, "upickle.implicits.Readers$$anon$17", ({
  Eb: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$22(evidence$2$9, evidence$1$6, outer) {
  this.aeg = null;
  this.aeh = null;
  this.aef = null;
  this.aeg = evidence$2$9;
  this.aeh = evidence$1$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aef = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$22.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$22;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$22() {
}
$h_Lupickle_implicits_Readers$$anon$22.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected sequence";
});
$p.cr = (function(bytes, offset, len, index) {
  return $m_sc_ArrayOps$().uD(bytes, offset, ((offset + len) | 0));
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$22$$anon$23(this.aeg, this);
});
$p.dL = (function() {
  return this.aef;
});
var $d_Lupickle_implicits_Readers$$anon$22 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$22, "upickle.implicits.Readers$$anon$22", ({
  Eh: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$24(evidence$2$10, evidence$1$7, outer) {
  this.aek = null;
  this.ael = null;
  this.aej = null;
  this.aek = evidence$2$10;
  this.ael = evidence$1$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aej = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$24.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$24;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$24() {
}
$h_Lupickle_implicits_Readers$$anon$24.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected sequence";
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$24$$anon$25(this.aek, this);
});
$p.dL = (function() {
  return this.aej;
});
var $d_Lupickle_implicits_Readers$$anon$24 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$24, "upickle.implicits.Readers$$anon$24", ({
  Ej: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$3(outer) {
  this.aeo = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeo = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$3.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$3;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$3() {
}
$h_Lupickle_implicits_Readers$$anon$3.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected boolean";
});
$p.azs = (function(s, index) {
  var this$2 = $m_sc_StringOps$();
  var x = $dp_toString__T(s);
  return this$2.zW(x, x);
});
$p.dL = (function() {
  return this.aeo;
});
$p.ch = (function(index) {
  return true;
});
$p.cg = (function(index) {
  return false;
});
$p.bx = (function(s, index) {
  return this.azs(s, index);
});
var $d_Lupickle_implicits_Readers$$anon$3 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$3, "upickle.implicits.Readers$$anon$3", ({
  Em: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$9(outer) {
  this.aeu = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeu = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$9.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$9;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$9() {
}
$h_Lupickle_implicits_Readers$$anon$9.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.azg = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === Math.fround(i)) ? ("" + i) : ("" + d));
});
$p.azh = (function(d, index) {
  var i = $doubleToInt(d);
  return ((d === i) ? ("" + i) : ("" + d));
});
$p.dL = (function() {
  return this.aeu;
});
$p.bx = (function(s, index) {
  return $dp_toString__T(s);
});
$p.c9 = (function(i, index) {
  return ("" + i);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $m_RTLong$().gc(i_$_lo, i_$_hi);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $m_RTLong$().gc(i_$_lo, i_$_hi);
});
$p.cs = (function(d, index) {
  return this.azg(d, index);
});
$p.ct = (function(d, index) {
  return this.azh(d, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $dp_toString__T(s);
});
$p.ch = (function(index) {
  return "true";
});
$p.cg = (function(index) {
  return "false";
});
$p.cB = (function(s, index) {
  return ("" + $cToS(s));
});
var $d_Lupickle_implicits_Readers$$anon$9 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$9, "upickle.implicits.Readers$$anon$9", ({
  Es: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
function $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O($thiz, s, index) {
  var $x_2 = $f_T__indexOf__I__I(s, 46);
  matchResult1: {
    var $x_1;
    var x1 = $f_T__indexOf__I__I(s, 69);
    if ((x1 === (-1))) {
      var $x_1 = $f_T__indexOf__I__I(s, 101);
      break matchResult1;
    }
    var $x_1 = x1;
  }
  return $thiz.cu(s, $x_2, $x_1, (-1));
}
/** @constructor */
function $c_Lupickle_implicits_Readers$SeqLikeReader(outer, r, factory) {
  this.aez = null;
  this.aey = null;
  this.aex = null;
  this.aez = r;
  this.aey = factory;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aex = outer;
}
$p = $c_Lupickle_implicits_Readers$SeqLikeReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$SeqLikeReader;
/** @constructor */
function $h_Lupickle_implicits_Readers$SeqLikeReader() {
}
$h_Lupickle_implicits_Readers$SeqLikeReader.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected sequence";
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$26(this);
});
$p.dL = (function() {
  return this.aex;
});
var $d_Lupickle_implicits_Readers$SeqLikeReader = new $TypeData().i($c_Lupickle_implicits_Readers$SeqLikeReader, "upickle.implicits.Readers$SeqLikeReader", ({
  Eu: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__$init$__V($thiz) {
  $thiz.akr(new $ac_O($thiz.gf().Y));
  $thiz.akq(new $c_scm_ListBuffer());
  $thiz.VR(null);
  $thiz.Nw(false);
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKey__I__Lupickle_core_Visitor($thiz, index) {
  return ($thiz.gf().MR() ? $m_Lupickle_core_BufferedValue$Builder$() : $m_Lupickle_core_StringVisitor$());
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V($thiz, currentIndex, v) {
  if ((currentIndex === (-1))) {
    if ($thiz.ak0()) {
      $thiz.VQ().TC(new $c_T2($thiz.akp(), v));
    }
  } else {
    $thiz.VS().a[currentIndex] = v;
  }
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__subVisitor__Lupickle_core_Visitor($thiz) {
  return (($thiz.Ms() === (-1)) ? ($thiz.gf().MR() ? $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__$1$__T3($thiz.gf()).fY : $m_Lupickle_core_NoOpVisitor$()) : $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__$1$__T3($thiz.gf()).gr.a[$thiz.Ms()]);
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKeyValue__O__V($thiz, v) {
  $thiz.Nw(false);
  var currentKeyString = ($thiz.gf().MR() ? ($thiz.gf(), $m_Lupickle_core_BufferedValue$().Ji(v)) : ($thiz.gf(), $dp_toString__T(v)));
  $thiz.agy($thiz.gf().ad(currentKeyString));
  if (($thiz.Ms() === (-1))) {
    if ($thiz.gf().MR()) {
      $thiz.VR($m_Lupickle_core_BufferedValue$().uG(v, $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__$1$__T3($thiz.gf()).gZ));
      $thiz.Nw(true);
    } else if ((!$thiz.gf().a6)) {
      throw new $c_Lupickle_core_Abort(("Unknown Key: " + currentKeyString));
    }
  }
}
function $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitEnd__I__O($thiz, index) {
  $thiz.gf().ae($thiz);
  var $x_1 = $thiz.gf();
  if ($thiz.afQ($x_1.a8, $x_1.a9)) {
    $thiz.agR($thiz.gf().Y, $thiz.gf().ac());
  }
  return $thiz.gf().a7.cm($thiz.VS(), $thiz.VQ());
}
/** @constructor */
function $c_Lupickle_implicits_TupleReadWriters$TupleNReader(outer, readers, f) {
  this.z5 = null;
  this.aeJ = null;
  this.aeI = null;
  this.z5 = readers;
  this.aeJ = f;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeI = outer;
}
$p = $c_Lupickle_implicits_TupleReadWriters$TupleNReader.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_TupleReadWriters$TupleNReader;
/** @constructor */
function $h_Lupickle_implicits_TupleReadWriters$TupleNReader() {
}
$h_Lupickle_implicits_TupleReadWriters$TupleNReader.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected sequence";
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_implicits_TupleReadWriters$$anon$1(this);
});
$p.dL = (function() {
  return this.aeI;
});
var $d_Lupickle_implicits_TupleReadWriters$TupleNReader = new $TypeData().i($c_Lupickle_implicits_TupleReadWriters$TupleNReader, "upickle.implicits.TupleReadWriters$TupleNReader", ({
  EA: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS(label, shortLabel, backgroundColor, hoverBackgroundColor, data, type, compactData, borderColor) {
  this.l6 = null;
  this.jM = null;
  this.mW = null;
  this.mX = null;
  this.jL = null;
  this.iC = null;
  this.iB = null;
  this.jK = null;
  this.l6 = label;
  this.jM = shortLabel;
  this.mW = backgroundColor;
  this.mX = hoverBackgroundColor;
  this.jL = data;
  this.iC = type;
  this.iB = compactData;
  this.jK = borderColor;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-705169294), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS) && ((((((((this.l6 === x$0.l6) && (this.jM === x$0.jM)) && $m_sr_BoxesRunTime$().B(this.mW, x$0.mW)) && $m_sr_BoxesRunTime$().B(this.mX, x$0.mX)) && $m_sr_BoxesRunTime$().B(this.jL, x$0.jL)) && (this.iC === x$0.iC)) && $m_sr_BoxesRunTime$().B(this.iB, x$0.iB)) && $m_sr_BoxesRunTime$().B(this.jK, x$0.jK))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 8;
});
$p.A = (function() {
  return "ChartDatasetDoubleS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.l6;
      break;
    }
    case 1: {
      return this.jM;
      break;
    }
    case 2: {
      return this.mW;
      break;
    }
    case 3: {
      return this.mX;
      break;
    }
    case 4: {
      return this.jL;
      break;
    }
    case 5: {
      return this.iC;
      break;
    }
    case 6: {
      return this.iB;
      break;
    }
    case 7: {
      return this.jK;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ek = (function() {
  return this.l6;
});
$p.Ml = (function() {
  return this.mW;
});
$p.UE = (function() {
  return this.mX;
});
$p.TY = (function() {
  return this.iB;
});
Object.defineProperty($p, "data", ({
  "get": (function() {
    return this.jL;
  }),
  "set": (function(arg) {
    this.jL = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "hoverBackgroundColor", ({
  "get": (function() {
    return this.mX;
  }),
  "set": (function(arg) {
    this.mX = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "label", ({
  "get": (function() {
    return this.l6;
  }),
  "set": (function(arg) {
    this.l6 = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "compactData", ({
  "get": (function() {
    return this.iB;
  }),
  "set": (function(arg) {
    this.iB = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "borderColor", ({
  "get": (function() {
    return this.jK;
  }),
  "set": (function(arg) {
    this.jK = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "type", ({
  "get": (function() {
    return this.iC;
  }),
  "set": (function(arg) {
    this.iC = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "backgroundColor", ({
  "get": (function() {
    return this.mW;
  }),
  "set": (function(arg) {
    this.mW = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "shortLabel", ({
  "get": (function() {
    return this.jM;
  }),
  "set": (function(arg) {
    this.jM = arg;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dm)));
}
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS, "com.papasofokli.chartJSv2x.ChartDatasetDoubleS", ({
  dm: 1,
  cd: 1,
  bh: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS(label, shortLabel, backgroundColor, hoverBackgroundColor, type, showLine, fill, borderColor, pointRadius, data, compactData) {
  this.jN = null;
  this.iE = null;
  this.l7 = null;
  this.l9 = null;
  this.hX = null;
  this.hW = false;
  this.hU = false;
  this.l8 = null;
  this.hV = 0;
  this.iD = null;
  this.hT = null;
  this.jN = label;
  this.iE = shortLabel;
  this.l7 = backgroundColor;
  this.l9 = hoverBackgroundColor;
  this.hX = type;
  this.hW = showLine;
  this.hU = fill;
  this.l8 = borderColor;
  this.hV = pointRadius;
  this.iD = data;
  this.hT = compactData;
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-2086642600));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.jN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iE));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.l7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.l9));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hX));
  acc = $m_sr_Statics$().d(acc, (this.hW ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, (this.hU ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.l8));
  acc = $m_sr_Statics$().d(acc, this.hV);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.iD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.hT));
  return $m_sr_Statics$().an(acc, 11);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS) && (((((((((((this.hW === x$0.hW) && (this.hU === x$0.hU)) && (this.hV === x$0.hV)) && (this.jN === x$0.jN)) && (this.iE === x$0.iE)) && $m_sr_BoxesRunTime$().B(this.l7, x$0.l7)) && $m_sr_BoxesRunTime$().B(this.l9, x$0.l9)) && (this.hX === x$0.hX)) && $m_sr_BoxesRunTime$().B(this.l8, x$0.l8)) && $m_sr_BoxesRunTime$().B(this.iD, x$0.iD)) && $m_sr_BoxesRunTime$().B(this.hT, x$0.hT))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 11;
});
$p.A = (function() {
  return "ChartDatasetXYS";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.jN;
      break;
    }
    case 1: {
      return this.iE;
      break;
    }
    case 2: {
      return this.l7;
      break;
    }
    case 3: {
      return this.l9;
      break;
    }
    case 4: {
      return this.hX;
      break;
    }
    case 5: {
      return this.hW;
      break;
    }
    case 6: {
      return this.hU;
      break;
    }
    case 7: {
      return this.l8;
      break;
    }
    case 8: {
      return this.hV;
      break;
    }
    case 9: {
      return this.iD;
      break;
    }
    case 10: {
      return this.hT;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Ek = (function() {
  return this.jN;
});
$p.Ml = (function() {
  return this.l7;
});
$p.UE = (function() {
  return this.l9;
});
$p.TY = (function() {
  return this.hT;
});
Object.defineProperty($p, "showLine", ({
  "get": (function() {
    return this.hW;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.hW = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "fill", ({
  "get": (function() {
    return this.hU;
  }),
  "set": (function(arg) {
    var prep0 = (!(!arg));
    this.hU = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "data", ({
  "get": (function() {
    return this.iD;
  }),
  "set": (function(arg) {
    this.iD = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "pointRadius", ({
  "get": (function() {
    return this.hV;
  }),
  "set": (function(arg) {
    var prep0 = (arg | 0);
    this.hV = prep0;
  }),
  "configurable": true
}));
Object.defineProperty($p, "hoverBackgroundColor", ({
  "get": (function() {
    return this.l9;
  }),
  "set": (function(arg) {
    this.l9 = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "label", ({
  "get": (function() {
    return this.jN;
  }),
  "set": (function(arg) {
    this.jN = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "compactData", ({
  "get": (function() {
    return this.hT;
  }),
  "set": (function(arg) {
    this.hT = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "borderColor", ({
  "get": (function() {
    return this.l8;
  }),
  "set": (function(arg) {
    this.l8 = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "type", ({
  "get": (function() {
    return this.hX;
  }),
  "set": (function(arg) {
    this.hX = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "backgroundColor", ({
  "get": (function() {
    return this.l7;
  }),
  "set": (function(arg) {
    this.l7 = arg;
  }),
  "configurable": true
}));
Object.defineProperty($p, "shortLabel", ({
  "get": (function() {
    return this.iE;
  }),
  "set": (function(arg) {
    this.iE = arg;
  }),
  "configurable": true
}));
function $isArrayOf_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dn)));
}
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS, "com.papasofokli.chartJSv2x.ChartDatasetXYS", ({
  dn: 1,
  cd: 1,
  bh: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__toolTipText__s_Option($thiz) {
  var this$1 = $thiz.P3;
  if (this$1.c()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.h();
    return new $c_s_Some($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(x0, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V($thiz);
    })))));
  }
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__getNamePlanningRowTuple__sci_Seq__F__sci_Seq__sci_Seq($thiz, data, startYForThisRow, acc) {
  var acc$tailLocal1 = acc;
  var startYForThisRow$tailLocal1 = startYForThisRow;
  var data$tailLocal1 = data;
  while (true) {
    if (data$tailLocal1.c()) {
      return acc$tailLocal1;
    } else {
      var seamanPlanningData = data$tailLocal1.W();
      var nonEmptyAdditionalRows = seamanPlanningData.kb.bD(new $c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1());
      var noOfPeriodRows = ((1 + nonEmptyAdditionalRows.F()) | 0);
      var detailedRows$1 = nonEmptyAdditionalRows.X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$7$2) => _$7$2.k3)));
      var planningRowSVG = new $c_Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(seamanPlanningData.pm.nA, $thiz.JL, seamanPlanningData.pl, detailedRows$1, $thiz.eq.nG, startYForThisRow$tailLocal1, $thiz.eq.eW, $thiz.eq.sx, $thiz.eq.AU, false, $thiz.eq.sv, $thiz.eq.AW, $thiz.JM);
      var nameSVGHeight = Math.fround((Math.fround(noOfPeriodRows) * $thiz.eq.eW));
      var s = new $c_Lcom_papasofokli_planning_api_NameSVG(seamanPlanningData.pm, $thiz.eq.sy, $thiz.P0, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((startYForThisRow$tailLocal1$1) => (() => startYForThisRow$tailLocal1$1))(startYForThisRow$tailLocal1)), nameSVGHeight, $thiz.eq.wR, $thiz.eq.nF, $thiz.eq.AT, $thiz.eq.AV, $thiz.JL, planningRowSVG.m0, $thiz.eq.AX, seamanPlanningData.lX, $thiz.JM);
      var data$tailLocal1$tmp1 = data$tailLocal1.ak();
      var startYForThisRow$tailLocal1$tmp1 = Math.fround((nameSVGHeight + startYForThisRow$tailLocal1));
      var acc$tailLocal1$tmp1 = acc$tailLocal1.aV(new $c_T2(s, planningRowSVG));
      data$tailLocal1 = data$tailLocal1$tmp1;
      startYForThisRow$tailLocal1 = startYForThisRow$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__namePlanningRowTuple__sci_Seq($thiz) {
  if ((!$thiz.a2B)) {
    $thiz.a2A = $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__getNamePlanningRowTuple__sci_Seq__F__sci_Seq__sci_Seq($thiz, $thiz.sA.pi, $thiz.qN(), $m_sci_Nil$());
    $thiz.a2B = true;
  }
  return $thiz.a2A;
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__$2$__T2($thiz) {
  if ((!$thiz.a25)) {
    matchResult6: {
      var $x_1;
      var x7 = $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__namePlanningRowTuple__sci_Seq($thiz).uI($m_s_$less$colon$less$().b0);
      if ((x7 !== null)) {
        x7.P();
        x7.V();
        var $x_1 = x7;
        break matchResult6;
      }
      throw new $c_s_MatchError(x7);
    }
    $thiz.a24 = $x_1;
    $thiz.a25 = true;
  }
  return $thiz.a24;
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__translateToYSeamenName__F__V($thiz, nextY) {
  $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__namePlanningRowTuple__sci_Seq($thiz).bc().al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    matchResult7: {
      if ((x$1$3 !== null)) {
        var x11 = x$1$3.P();
        if ((x11 !== null)) {
          var seamanNameSVG = x11.P();
          var seamanRow = x11.V();
          var index = (x$1$3.V() | 0);
          var extraHeight = Math.fround((Math.fround(index) * $thiz.eq.eW));
          seamanNameSVG.gd(Math.fround((nextY + extraHeight)));
          seamanRow.gd(Math.fround((nextY + extraHeight)));
          break matchResult7;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__makeTooltipElement__T__sci_Seq($thiz, tooltipText) {
  return new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("row planner-tooltip", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-10", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(tooltipText))]))])), $m_sci_Nil$());
}
function $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__allGroupedComponents__sci_Seq($thiz) {
  return new $c_sci_$colon$colon($thiz.wS, new $c_sci_$colon$colon($thiz.P2, $m_sci_Nil$())).cY($thiz.E1()).cY($p_Lcom_papasofokli_planning_api_LeafDivisionSVG__$2$__T2($thiz).P()).cY($thiz.OZ);
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_LeafDivisionSVG(rankData, layer, initialY, parentDepartment, getBelowDepartment, departmentCreatorFixedData, executionContext) {
  this.afc = 0;
  this.afd = 0;
  this.a2q = false;
  this.a2o = null;
  this.a2p = false;
  this.a2m = false;
  this.a2n = false;
  this.a2k = false;
  this.a2l = false;
  this.a2e = null;
  this.a2h = false;
  this.a2a = null;
  this.a2d = false;
  this.a2f = null;
  this.a2g = false;
  this.a2b = null;
  this.a2c = false;
  this.a2w = null;
  this.a2x = false;
  this.a2i = null;
  this.a2j = false;
  this.a28 = null;
  this.a29 = false;
  this.a2u = null;
  this.a2v = false;
  this.a26 = null;
  this.a27 = false;
  this.sA = null;
  this.F4 = 0;
  this.sz = 0.0;
  this.B0 = null;
  this.wT = null;
  this.eq = null;
  this.JM = null;
  this.JL = null;
  this.B1 = 0.0;
  this.a2t = null;
  this.wU = 0.0;
  this.JN = 0.0;
  this.wV = 0.0;
  this.P0 = 0.0;
  this.P3 = null;
  this.wS = null;
  this.a2A = null;
  this.a2B = false;
  this.a24 = null;
  this.a25 = false;
  this.P4 = 0.0;
  this.P1 = 0.0;
  this.JO = 0.0;
  this.a2C = null;
  this.OZ = null;
  this.P2 = null;
  this.a2y = null;
  this.a2z = false;
  this.a2r = null;
  this.a2s = false;
  this.sA = rankData;
  this.F4 = layer;
  this.sz = initialY;
  this.B0 = parentDepartment;
  this.wT = getBelowDepartment;
  this.eq = departmentCreatorFixedData;
  this.JM = executionContext;
  this.JL = rankData.wG;
  this.B1 = 2.0;
  this.a2t = $m_sci_Nil$();
  this.wU = Math.fround((Math.fround((departmentCreatorFixedData.eW * Math.fround(rankData.pi.F()))) + Math.fround((departmentCreatorFixedData.eW * Math.fround(rankData.pi.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => _$3$2.kb))).bD(new $c_Lcom_papasofokli_planning_api_LeafDivisionSVG$$anon$1()).F())))));
  this.JN = Math.fround((departmentCreatorFixedData.pr - Math.fround((Math.fround(layer) * departmentCreatorFixedData.kc))));
  this.wV = Math.fround((departmentCreatorFixedData.pr - this.JN));
  this.P0 = Math.fround((departmentCreatorFixedData.pr + departmentCreatorFixedData.sw));
  var totalWidth = Math.fround((this.P0 - this.wV));
  var mouseOverFun = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
    $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V(this);
  }));
  this.P3 = (($m_sc_StringOps$(), (rankData.lF !== "")) ? $m_s_Option$().Z($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().DR(), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(rankData.lF))]))]))])).aB().outerHTML) : $m_s_None$());
  var initialClassName$1 = $m_s_Option$().Z($m_Lcom_papasofokli_planning_package$().Bn);
  var initialHeight$1 = Math.fround((this.wU - this.B1));
  var clickFunction$1 = this.qE();
  var onMouseOut$1 = $m_s_Option$().Z(departmentCreatorFixedData.nF);
  var onHover$1 = $m_s_Option$().Z(mouseOverFun);
  var resizeUpFunction$1 = $m_s_None$();
  var resizeDownFunction$1 = $m_s_None$();
  var resizeLeftFunction$1 = $m_s_None$();
  var resizeRightFunction$1 = $m_s_None$();
  var dragFunction$1 = $m_s_None$();
  var contextMenuFunction$1 = $m_s_None$();
  var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var href$1 = $m_s_None$();
  var appendWithAnimationTime$1 = new $c_s_Some(0.5);
  var color$1 = $m_s_None$();
  var stroke$1 = $m_s_None$();
  var onBoundHover$1 = $m_s_None$();
  this.wS = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$1, initialHeight$1, totalWidth, this.wV, initialY, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$1, clickFunction$1, contextMenuFunction$1, getGroupedDraggedShapes$1, onHover$1, onMouseOut$1, true, href$1, appendWithAnimationTime$1, color$1, stroke$1, onBoundHover$1);
  this.P4 = Math.fround((Math.fround((0.5 * this.wU)) + 5.0));
  this.P1 = Math.fround((initialY + this.P4));
  this.JO = Math.fround((departmentCreatorFixedData.pr + 10.0));
  var this$31 = this.P3;
  if (this$31.c()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0$4 = this$31.h();
    var $x_1 = new $c_s_Some($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(x0$4, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V(this);
    })))));
  }
  this.a2C = $x_1;
  var this$35 = rankData.ns;
  if (this$35.c()) {
    var $x_2 = $m_s_None$();
  } else {
    var x0$5 = this$35.h();
    matchResult8: {
      var generalTextHoverHtmlMap;
      if ((x0$5 instanceof $c_Lcom_papasofokli_util_IconUI)) {
        $m_Lcom_papasofokli_util_IconUI$();
        var x19 = x0$5.m8;
        if ((x19 instanceof $c_s_Some)) {
          var generalTextHoverHtmlMap = $m_sci_Map$().dH($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_T2(x0$5, $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__makeTooltipElement__T__sci_Seq(this, x19.bg))]));
          break matchResult8;
        }
      }
      var generalTextHoverHtmlMap = $m_sci_Map$EmptyMap$();
    }
    var faIcon$1 = new $c_sci_$colon$colon(x0$5, $m_sci_Nil$());
    var initialY$1 = Math.fround((this.P1 - 15.0));
    var extraCssClass$1 = new $c_s_Some("activeText not-selectable");
    var onMouseOut$2 = $m_s_Option$().Z(departmentCreatorFixedData.nF);
    var dragFunction$2 = $m_s_None$();
    var clickFunction$2 = $m_s_None$();
    var draggingFunction$1 = $m_s_None$();
    var contextMenuFunction$2 = $m_s_None$();
    var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_IconTextComponent$().hb();
    var appendWithAnimationTime$2 = new $c_s_Some(0.5);
    var horizontalAnchor$1 = $s_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor__Lcom_papasofokli_svg_components_HorizontalAnchor();
    var $x_2 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_IconTextComponent(faIcon$1, this.wV, initialY$1, extraCssClass$1, generalTextHoverHtmlMap, dragFunction$2, clickFunction$2, draggingFunction$1, contextMenuFunction$2, getGroupedDraggedShapes$2, this.a2C, onMouseOut$2, true, $m_s_None$(), appendWithAnimationTime$2, horizontalAnchor$1));
  }
  this.OZ = $x_2;
  var initialClassName$2 = $m_s_Option$().Z("planning-left-side-text-small not-selectable");
  var this$63 = this.OZ;
  var this$65 = (this$63.c() ? $m_s_None$() : (this$63.h(), new $c_s_Some(Math.fround((this.JO + 10.0)))));
  var initialX$1$1 = Math.fround((this$65.c() ? this.JO : this$65.h()));
  var clickFunction$3 = this.qE();
  var onMouseOut$3 = $m_s_Option$().Z(departmentCreatorFixedData.nF);
  var onHover$2 = $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__toolTipText__s_Option(this);
  var textLength$1 = $m_s_None$();
  var lengthAdjust$1 = $m_s_None$();
  var dragFunction$3 = $m_s_None$();
  var appendWithAnimationTime$3 = new $c_s_Some(0.5);
  var getGroupedDraggedShapes$3 = $m_Lcom_papasofokli_svg_components_TextComponent$().hb();
  var contextMenuFunction$3 = $m_s_None$();
  var href$2 = $m_s_None$();
  var color$2 = $m_s_None$();
  var stroke$2 = $m_s_None$();
  this.P2 = new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$2, rankData.ph, initialX$1$1, this.P1, textLength$1, lengthAdjust$1, dragFunction$3, clickFunction$3, appendWithAnimationTime$3, getGroupedDraggedShapes$3, true, onHover$2, onMouseOut$3, contextMenuFunction$3, href$2, color$2, stroke$2);
}
$p = $c_Lcom_papasofokli_planning_api_LeafDivisionSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_LeafDivisionSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_LeafDivisionSVG() {
}
$h_Lcom_papasofokli_planning_api_LeafDivisionSVG.prototype = $p;
$p.TU = (function() {
  if ((!this.a2q)) {
    var $x_1 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summarySubjectId__J(this);
    this.afc = $x_1.l;
    this.afd = $x_1.h;
    this.a2q = true;
  }
  return $bL(this.afc, this.afd);
});
$p.TT = (function() {
  if ((!this.a2p)) {
    this.a2o = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summaryLeafData__Lcom_papasofokli_planning_LeafData(this);
    this.a2p = true;
  }
  return this.a2o;
});
$p.TS = (function() {
  if ((!this.a2n)) {
    this.a2m = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionManning__Z(this);
    this.a2n = true;
  }
  return this.a2m;
});
$p.TR = (function() {
  if ((!this.a2l)) {
    this.a2k = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionDaysOff__Z(this);
    this.a2l = true;
  }
  return this.a2k;
});
$p.ag6 = (function() {
  if ((!this.a2h)) {
    this.a2e = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(this);
    this.a2h = true;
  }
  return this.a2e;
});
$p.ag4 = (function() {
  if ((!this.a2d)) {
    this.a2a = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(this);
    this.a2d = true;
  }
  return this.a2a;
});
$p.ag7 = (function() {
  if ((!this.a2g)) {
    this.a2f = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRowO__s_Option(this);
    this.a2g = true;
  }
  return this.a2f;
});
$p.ag5 = (function() {
  if ((!this.a2c)) {
    this.a2b = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRowO__s_Option(this);
    this.a2c = true;
  }
  return this.a2b;
});
$p.qH = (function() {
  if ((!this.a2x)) {
    this.a2w = $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraRowSeq__sci_Seq(this);
    this.a2x = true;
  }
  return this.a2w;
});
$p.ag8 = (function() {
  if ((!this.a2j)) {
    this.a2i = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$manningLabelO__s_Option(this);
    this.a2j = true;
  }
  return this.a2i;
});
$p.ag3 = (function() {
  if ((!this.a29)) {
    this.a28 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$daysOffLabelO__s_Option(this);
    this.a29 = true;
  }
  return this.a28;
});
$p.E1 = (function() {
  if ((!this.a2v)) {
    this.a2u = $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraLabelSeq__sci_Seq(this);
    this.a2v = true;
  }
  return this.a2u;
});
$p.qE = (function() {
  if ((!this.a27)) {
    this.a26 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__clickOnDivisionO__s_Option(this);
    this.a27 = true;
  }
  return this.a26;
});
$p.N7 = (function() {
  return this.eI();
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1757401113);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sA));
  acc = $m_sr_Statics$().d(acc, this.F4);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.sz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.B0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.eq));
  return $m_sr_Statics$().an(acc, 6);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_LeafDivisionSVG)) {
    if (((this.F4 === x$0.F4) && (this.sz === x$0.sz))) {
      var x = this.sA;
      var x$2 = x$0.sA;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.B0;
      var x$4 = x$0.B0;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wT;
      var x$6 = x$0.wT;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.eq;
      var x$8 = x$0.eq;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "LeafDivisionSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.sA;
      break;
    }
    case 1: {
      return this.F4;
      break;
    }
    case 2: {
      return this.sz;
      break;
    }
    case 3: {
      return this.B0;
      break;
    }
    case 4: {
      return this.wT;
      break;
    }
    case 5: {
      return this.eq;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ew = (function() {
  return this.eq;
});
$p.hL = (function() {
  return this.JM;
});
$p.Mt = (function() {
  return this.a2t;
});
$p.eI = (function() {
  var this$1 = $m_s_Option$().Z(this.wS);
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.h().ahs());
  var this$4 = (this$2.c() ? $m_s_None$() : new $c_s_Some(Math.fround((Math.fround(this$2.h()) + this.B1))));
  return Math.fround((this$4.c() ? this.wU : this$4.h()));
});
$p.qN = (function() {
  var this$1 = $m_s_Option$().Z(this.wS);
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.h().ahx());
  return Math.fround((this$2.c() ? this.sz : this$2.h()));
});
$p.Uw = (function() {
  return $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__$2$__T2(this).V().cH(this.qH());
});
$p.aiO = (function() {
  if ((!this.a2z)) {
    this.a2y = new $c_Lcom_papasofokli_planning_api_DivisionLabel((this.sA.ph + " - Manning comparison:"), $m_Lcom_papasofokli_planning_package$().Bn, this.sz, this.B1, Math.fround((this.eq.sy + this.eq.sw)), this.wV, this.JN, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.wU)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.eI())), this.qE());
    this.a2z = true;
  }
  return this.a2y;
});
$p.agA = (function() {
  if ((!this.a2s)) {
    this.a2r = new $c_Lcom_papasofokli_planning_api_DivisionLabel((this.sA.ph + " - Days off:"), $m_Lcom_papasofokli_planning_package$().Bn, this.sz, this.B1, Math.fround((this.eq.sy + this.eq.sw)), this.wV, this.JN, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.wU)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.eI())), this.qE());
    this.a2s = true;
  }
  return this.a2r;
});
$p.di = (function() {
  return new $c_Lcom_papasofokli_svg_components_FlattenSVG($p_Lcom_papasofokli_planning_api_LeafDivisionSVG__allGroupedComponents__sci_Seq(this)).xJ;
});
$p.MZ = (function() {
  return (this.eI() !== this.wU);
});
$p.J8 = (function(resizeLength) {
  var newHeight = Math.fround((this.eI() + resizeLength));
  this.wS.gN(Math.fround((newHeight - this.B1)));
  $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionResize__F__V(this, newHeight);
  var this$1 = this.wT.aA();
  if ((!this$1.c())) {
    this$1.h().gd(Math.fround((this.qN() + newHeight)));
  }
  var this$2 = this.B0;
  if ((!this$2.c())) {
    this$2.h().J8(resizeLength);
  }
});
$p.gd = (function(nextY) {
  var bottomBoundaries = Math.fround((nextY + this.eI()));
  $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this.wS, $m_Lcom_papasofokli_planning_package$().nM);
  this.wS.cT(this.wV, nextY);
  this.P2.cT(this.JO, Math.fround((nextY + this.P4)));
  $p_Lcom_papasofokli_planning_api_LeafDivisionSVG__translateToYSeamenName__F__V(this, nextY);
  var this$2 = this.wT.aA();
  if ((!this$2.c())) {
    this$2.h().gd(bottomBoundaries);
  }
  $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionTranslate__F__F__V(this, bottomBoundaries, nextY);
});
$p.Mv = (function() {
  return this.JL;
});
function $isArrayOf_Lcom_papasofokli_planning_api_LeafDivisionSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ft)));
}
var $d_Lcom_papasofokli_planning_api_LeafDivisionSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_LeafDivisionSVG, "com.papasofokli.planning.api.LeafDivisionSVG", ({
  ft: 1,
  aj: 1,
  fs: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__extendedContentHeight__F($thiz) {
  return Math.fround(($thiz.eI() - $thiz.Eo()));
}
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleComponents__sci_Seq($thiz) {
  if ((!$thiz.a3g)) {
    if ((($thiz.wY === 0) && (!$thiz.lZ.iI.c()))) {
      var totalWidth$1 = Math.fround($thiz.gm.nG.m7.aA());
      var $x_11 = $thiz.lZ.iI;
      var $x_10 = $thiz.pt;
      var $x_9 = $thiz.gm.OY;
      var $x_8 = $thiz.gm.nG;
      var $x_7 = $thiz.gm.eW;
      var $x_6 = $thiz.gm.AY;
      var $x_5 = $m_s_None$();
      var $x_4 = $thiz.gm;
      var $x_3_$_lo = $x_4.Dz;
      var $x_3_$_hi = $x_4.DA;
      var $x_2 = $thiz.gm;
      var $x_1 = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG($x_11, $x_10, $x_9, $x_8, $x_7, totalWidth$1, $x_6, $x_5, $x_3_$_lo, $x_3_$_hi, $x_2.Dx, $x_2.Dy, $thiz.Pg), $m_sci_Nil$());
    } else {
      var $x_1 = $m_sci_Seq$().dj();
    }
    $thiz.a3f = $x_1;
    $thiz.a3g = true;
  }
  return $thiz.a3f;
}
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F($thiz) {
  if ((!$thiz.a3i)) {
    if ((($thiz.wY === 0) && (!$thiz.lZ.iI.c()))) {
      var this$2 = $thiz.lZ.iI;
      var m = $m_scm_Map$().ce();
      var it = this$2.l();
      while (it.f()) {
        var elem = it.e();
        var key = elem.pq;
        m.oM(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$2) => (() => this$2.dw()))(this$2))).aD(elem);
      }
      var result = $m_sci_HashMap$().kr;
      var mapIt = m.l();
      while (mapIt.f()) {
        var x1 = mapIt.e();
        x1.P();
        x1.V();
        var \u03b42$ = x1;
        var k$2 = \u03b42$.P();
        var v$2 = \u03b42$.V();
        result = result.jC(k$2, v$2.aR());
      }
      var vesselCount = result.dM.e7;
      var $x_1 = Math.fround((Math.fround((Math.fround((vesselCount << 1)) * $thiz.gm.eW)) + Math.fround((5.0 * Math.fround(vesselCount)))));
    } else {
      var $x_1 = 0.0;
    }
    $thiz.a3h = $x_1;
    $thiz.a3i = true;
  }
  return $thiz.a3h;
}
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__toolTipText__s_Option($thiz) {
  return $m_s_Option$().Z($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU($thiz.a3e, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $f_Lcom_papasofokli_planning_api_DivisionsSVG__appearHighlight__V($thiz);
  })))));
}
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__rectangleHeight__F($thiz) {
  return Math.fround(($thiz.Eo() - $thiz.B3));
}
function $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__mouseOutFun__V($thiz) {
  $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
  $thiz.gm.nF.aA();
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_NodeDivisionSVG(data, layer, initialStartY, parentDepartment, getBelowDepartment, departmentCreatorFixedData, executionContext) {
  this.afe = 0;
  this.aff = 0;
  this.a34 = false;
  this.a32 = null;
  this.a33 = false;
  this.a30 = false;
  this.a31 = false;
  this.a2Y = false;
  this.a2Z = false;
  this.a2S = null;
  this.a2V = false;
  this.a2O = null;
  this.a2R = false;
  this.a2T = null;
  this.a2U = false;
  this.a2P = null;
  this.a2Q = false;
  this.a3a = null;
  this.a3b = false;
  this.a2W = null;
  this.a2X = false;
  this.a2M = null;
  this.a2N = false;
  this.a38 = null;
  this.a39 = false;
  this.a2K = null;
  this.a2L = false;
  this.lZ = null;
  this.wY = 0;
  this.pt = 0.0;
  this.B6 = null;
  this.wX = null;
  this.gm = null;
  this.Pg = null;
  this.a37 = null;
  this.B3 = 0.0;
  this.B4 = null;
  this.B5 = 0.0;
  this.JU = null;
  this.a3f = null;
  this.a3g = false;
  this.a3h = 0.0;
  this.a3i = false;
  this.a3e = null;
  this.wW = null;
  this.Pf = 0.0;
  this.Ph = 0;
  this.Pe = null;
  this.Pi = 0.0;
  this.a3c = null;
  this.a3d = false;
  this.a35 = null;
  this.a36 = false;
  this.a2J = null;
  this.lZ = data;
  this.wY = layer;
  this.pt = initialStartY;
  this.B6 = parentDepartment;
  this.wX = getBelowDepartment;
  this.gm = departmentCreatorFixedData;
  this.Pg = executionContext;
  this.a37 = data.wI;
  this.B3 = 4.0;
  this.B4 = $m_Lcom_papasofokli_planning_api_DepartmentCreator$().UY(data.wH.uF(), ((1 + layer) | 0), Math.fround((initialStartY + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))), $m_s_Option$().Z(this), departmentCreatorFixedData, executionContext);
  this.B5 = Math.fround((Math.fround(layer) * departmentCreatorFixedData.kc));
  this.JU = ((layer === 0) ? "bar warning" : ((layer === 1) ? "bar success" : "bar"));
  this.a3e = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().DR(), $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n("col-sm-12", $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().ez().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(data.nt))]))]))])).aB().outerHTML;
  var initialClassName$1 = $m_s_Option$().Z(this.JU);
  var initialHeight$1 = $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__rectangleHeight__F(this);
  var initialWidth$1 = Math.fround((departmentCreatorFixedData.kc - 4.0));
  var onHover$1 = $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__toolTipText__s_Option(this);
  var onMouseOut$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__mouseOutFun__V(this);
  })));
  var initialY$1 = Math.fround((initialStartY + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this)));
  var clickFunction$1 = this.qE();
  var resizeUpFunction$1 = $m_s_None$();
  var resizeDownFunction$1 = $m_s_None$();
  var resizeLeftFunction$1 = $m_s_None$();
  var resizeRightFunction$1 = $m_s_None$();
  var dragFunction$1 = $m_s_None$();
  var contextMenuFunction$1 = $m_s_None$();
  var getGroupedDraggedShapes$1 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
  var href$1 = $m_s_None$();
  var appendWithAnimationTime$1 = new $c_s_Some(0.5);
  var color$1 = $m_s_None$();
  var stroke$1 = $m_s_None$();
  var onBoundHover$1 = $m_s_None$();
  this.wW = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$1, initialHeight$1, initialWidth$1, this.B5, initialY$1, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$1, clickFunction$1, contextMenuFunction$1, getGroupedDraggedShapes$1, onHover$1, onMouseOut$1, true, href$1, appendWithAnimationTime$1, color$1, stroke$1, onBoundHover$1);
  this.Pf = Math.fround((Math.fround((0.5 * Math.fround((Math.fround(((1 + (layer << 1)) | 0)) * departmentCreatorFixedData.kc)))) - 2.0));
  this.Ph = 10;
  var initialClassName$2 = $m_s_Option$().Z("planning-left-side-text-small vertical-text not-selectable");
  var initialY$2 = Math.fround((Math.fround((initialStartY + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))) + Math.fround(this.Ph)));
  var onHover$2 = $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__toolTipText__s_Option(this);
  var onMouseOut$2 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__mouseOutFun__V(this);
  })));
  var clickFunction$2 = this.qE();
  var textLength$1 = $m_s_None$();
  var lengthAdjust$1 = $m_s_None$();
  var dragFunction$2 = $m_s_None$();
  var appendWithAnimationTime$2 = new $c_s_Some(0.5);
  var getGroupedDraggedShapes$2 = $m_Lcom_papasofokli_svg_components_TextComponent$().hb();
  var contextMenuFunction$2 = $m_s_None$();
  var href$2 = $m_s_None$();
  var color$2 = $m_s_None$();
  var stroke$2 = $m_s_None$();
  this.Pe = new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$2, data.nt, this.Pf, initialY$2, textLength$1, lengthAdjust$1, dragFunction$2, clickFunction$2, appendWithAnimationTime$2, getGroupedDraggedShapes$2, true, onHover$2, onMouseOut$2, contextMenuFunction$2, href$2, color$2, stroke$2);
  this.Pi = Math.fround((Math.fround((departmentCreatorFixedData.OY - this.B5)) - departmentCreatorFixedData.kc));
  var allGroupedComponents = new $c_sci_$colon$colon(this.wW, new $c_sci_$colon$colon(this.Pe, $m_sci_Nil$())).cY(this.B4).cY(this.E1());
  this.a2J = new $c_Lcom_papasofokli_svg_components_FlattenSVG(allGroupedComponents).xJ.cH($p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleComponents__sci_Seq(this).aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => ((x$1$2 instanceof $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG) ? x$1$2.ai2().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$6$2) => _$6$2.di()))) : x$1$2.di())))));
}
$p = $c_Lcom_papasofokli_planning_api_NodeDivisionSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_NodeDivisionSVG;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_NodeDivisionSVG() {
}
$h_Lcom_papasofokli_planning_api_NodeDivisionSVG.prototype = $p;
$p.TU = (function() {
  if ((!this.a34)) {
    var $x_1 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summarySubjectId__J(this);
    this.afe = $x_1.l;
    this.aff = $x_1.h;
    this.a34 = true;
  }
  return $bL(this.afe, this.aff);
});
$p.TT = (function() {
  if ((!this.a33)) {
    this.a32 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$summaryLeafData__Lcom_papasofokli_planning_LeafData(this);
    this.a33 = true;
  }
  return this.a32;
});
$p.TS = (function() {
  if ((!this.a31)) {
    this.a30 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionManning__Z(this);
    this.a31 = true;
  }
  return this.a30;
});
$p.TR = (function() {
  if ((!this.a2Z)) {
    this.a2Y = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$showDivisionDaysOff__Z(this);
    this.a2Z = true;
  }
  return this.a2Y;
});
$p.ag6 = (function() {
  if ((!this.a2V)) {
    this.a2S = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(this);
    this.a2V = true;
  }
  return this.a2S;
});
$p.ag4 = (function() {
  if ((!this.a2R)) {
    this.a2O = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRow__Lcom_papasofokli_planning_api_SubjectPlanningRowSVG(this);
    this.a2R = true;
  }
  return this.a2O;
});
$p.ag7 = (function() {
  if ((!this.a2U)) {
    this.a2T = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionManningRowO__s_Option(this);
    this.a2U = true;
  }
  return this.a2T;
});
$p.ag5 = (function() {
  if ((!this.a2Q)) {
    this.a2P = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$divisionDaysOffRowO__s_Option(this);
    this.a2Q = true;
  }
  return this.a2P;
});
$p.qH = (function() {
  if ((!this.a3b)) {
    this.a3a = $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraRowSeq__sci_Seq(this);
    this.a3b = true;
  }
  return this.a3a;
});
$p.ag8 = (function() {
  if ((!this.a2X)) {
    this.a2W = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$manningLabelO__s_Option(this);
    this.a2X = true;
  }
  return this.a2W;
});
$p.ag3 = (function() {
  if ((!this.a2N)) {
    this.a2M = $f_Lcom_papasofokli_planning_api_DivisionsSVG__com$papasofokli$planning$api$DivisionsSVG$$daysOffLabelO__s_Option(this);
    this.a2N = true;
  }
  return this.a2M;
});
$p.E1 = (function() {
  if ((!this.a39)) {
    this.a38 = $f_Lcom_papasofokli_planning_api_DivisionsSVG__extraLabelSeq__sci_Seq(this);
    this.a39 = true;
  }
  return this.a38;
});
$p.qE = (function() {
  if ((!this.a2L)) {
    this.a2K = $f_Lcom_papasofokli_planning_api_DivisionsSVG__clickOnDivisionO__s_Option(this);
    this.a2L = true;
  }
  return this.a2K;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1292373259));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.lZ));
  acc = $m_sr_Statics$().d(acc, this.wY);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pt));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.B6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.wX));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.gm));
  return $m_sr_Statics$().an(acc, 6);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_NodeDivisionSVG)) {
    if (((this.wY === x$0.wY) && (this.pt === x$0.pt))) {
      var x = this.lZ;
      var x$2 = x$0.lZ;
      var $x_3 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.B6;
      var x$4 = x$0.B6;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wX;
      var x$6 = x$0.wX;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.gm;
      var x$8 = x$0.gm;
      return ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "NodeDivisionSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.lZ;
      break;
    }
    case 1: {
      return this.wY;
      break;
    }
    case 2: {
      return this.pt;
      break;
    }
    case 3: {
      return this.B6;
      break;
    }
    case 4: {
      return this.wX;
      break;
    }
    case 5: {
      return this.gm;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.ew = (function() {
  return this.gm;
});
$p.hL = (function() {
  return this.Pg;
});
$p.qN = (function() {
  var this$1 = this.wW.ahx();
  return Math.fround((this$1.c() ? Math.fround((this.pt + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))) : this$1.h()));
});
$p.Mt = (function() {
  return this.B4;
});
$p.N7 = (function() {
  return Math.fround((this.eI() + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this)));
});
$p.eI = (function() {
  var this$1 = $m_s_Option$().Z(this.wW);
  var this$2 = (this$1.c() ? $m_s_None$() : this$1.h().ahs());
  var this$4 = (this$2.c() ? $m_s_None$() : new $c_s_Some(Math.fround((Math.fround(this$2.h()) + this.B3))));
  return Math.fround((this$4.c() ? this.Eo() : this$4.h()));
});
$p.Eo = (function() {
  var this$2 = this.B4;
  var f = ((_$3$2) => _$3$2.eI());
  if ((this$2 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$2.W();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$2.ak();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.W();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.bz = nx;
      t = nx;
      rest = rest.ak();
    }
    var $x_1 = h;
  }
  return Math.fround($f_sc_IterableOnceOps__sum__s_math_Numeric__O($x_1, $m_s_math_Numeric$FloatIsFractional$()));
});
$p.Uw = (function() {
  var this$1 = this.B4;
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = rest.W().Uw().l();
    while (it.f()) {
      var nx = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.bz = nx;
      }
      t = nx;
    }
    rest = rest.ak();
  }
  return ((h === null) ? $m_sci_Nil$() : h).cY(this.qH());
});
$p.aiO = (function() {
  if ((!this.a3d)) {
    this.a3c = new $c_Lcom_papasofokli_planning_api_DivisionLabel((this.lZ.nt + " - Manning comparison:"), this.JU, Math.fround((this.pt + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))), this.B3, this.Pi, this.B5, this.gm.kc, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Eo())), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__extendedContentHeight__F(this))), this.qE());
    this.a3d = true;
  }
  return this.a3c;
});
$p.agA = (function() {
  if ((!this.a36)) {
    this.a35 = new $c_Lcom_papasofokli_planning_api_DivisionLabel((this.lZ.nt + " - Days off:"), this.JU, Math.fround((this.pt + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))), this.B3, this.Pi, this.B5, this.gm.kc, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Eo())), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.eI())), this.qE());
    this.a36 = true;
  }
  return this.a35;
});
$p.di = (function() {
  return this.a2J;
});
$p.auy = (function() {
  return $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleComponents__sci_Seq(this).bD(new $c_Lcom_papasofokli_planning_api_NodeDivisionSVG$$anon$1()).bU($m_s_$less$colon$less$().b0);
});
$p.gd = (function(newStartY) {
  var bottomBoundaries = Math.fround((newStartY + this.N7()));
  $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this.wW, $m_Lcom_papasofokli_planning_package$().nM);
  this.wW.cT(this.B5, newStartY);
  this.Pe.cT(this.Pf, Math.fround((newStartY + Math.fround(this.Ph))));
  var this$2 = this.B4.bj();
  if ((!this$2.c())) {
    this$2.h().gd(Math.fround((newStartY + $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleHeight__F(this))));
  }
  if ((!$p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleComponents__sci_Seq(this).c())) {
    $p_Lcom_papasofokli_planning_api_NodeDivisionSVG__vesselScheduleComponents__sci_Seq(this).al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      if ((x$1$3 instanceof $c_Lcom_papasofokli_planning_api_VesselScheduleInlineSVG)) {
        x$1$3.gd(newStartY);
      }
    })));
  }
  $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionTranslate__F__F__V(this, bottomBoundaries, newStartY);
  var this$5 = this.wX.aA();
  if ((!this$5.c())) {
    this$5.h().gd(bottomBoundaries);
  }
});
$p.MZ = (function() {
  return (this.eI() !== this.Eo());
});
$p.J8 = (function(resizeLength) {
  var newHeight = Math.fround((this.eI() + resizeLength));
  this.wW.gN($m_Lcom_papasofokli_util_misc_package$().V3(Math.fround((newHeight - this.B3))));
  $f_Lcom_papasofokli_planning_api_DivisionsSVG__divisionResize__F__V(this, newHeight);
  var bottomY = Math.fround((this.qN() + newHeight));
  var this$1 = this.wX.aA();
  if ((!this$1.c())) {
    this$1.h().gd(bottomY);
  }
  var this$2 = this.B6;
  if ((!this$2.c())) {
    this$2.h().J8(resizeLength);
  }
});
$p.Mv = (function() {
  return this.a37;
});
function $isArrayOf_Lcom_papasofokli_planning_api_NodeDivisionSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fv)));
}
var $d_Lcom_papasofokli_planning_api_NodeDivisionSVG = new $TypeData().i($c_Lcom_papasofokli_planning_api_NodeDivisionSVG, "com.papasofokli.planning.api.NodeDivisionSVG", ({
  fv: 1,
  aj: 1,
  fs: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_planning_api_PeriodSvg__getUTCDateString__sjs_js_Date__T($thiz, date) {
  var sp = $f_T__split__T__I__AT(date.toUTCString(), " ", 0);
  return (((((($m_sc_StringOps$().VF(sp.a[0], 3) + " ") + sp.a[2]) + " ") + sp.a[1]) + " ") + sp.a[3]);
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__longDate2String__J__T($thiz, d_$_lo, d_$_hi) {
  var date = new Date(((4.294967296E9 * d_$_hi) + (d_$_lo >>> 0.0)));
  return ($thiz.nH.x4 ? $m_Lcom_papasofokli_util_DateUtilsJS$().auw(date) : $p_Lcom_papasofokli_planning_api_PeriodSvg__getUTCDateString__sjs_js_Date__T($thiz, date));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__contextMenuFunction__s_Option($thiz) {
  if ((!$thiz.a3L)) {
    var this$1 = $thiz.nH.x3;
    $thiz.a3K = (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((id$3) => (() => {
      $p_Lcom_papasofokli_planning_api_PeriodSvg__actionsFunctionFun__ju_UUID__V($thiz, id$3);
    }))(this$1.h()))));
    $thiz.a3L = true;
  }
  return $thiz.a3K;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__clickFunction__s_Option($thiz) {
  if ((!$thiz.a3J)) {
    var this$1 = $thiz.nH.x2;
    $thiz.a3I = (this$1.c() ? $m_s_None$() : new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$4) => ((_$1$3) => {
      $p_Lcom_papasofokli_planning_api_PeriodSvg__actionsFunctionFun__ju_UUID__V($thiz, id$4);
    }))(this$1.h()))));
    $thiz.a3J = true;
  }
  return $thiz.a3I;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__changeDatesFunction__s_Option($thiz) {
  if ((!$thiz.a3D)) {
    $thiz.a3C = ((!$thiz.aI.iJ.c()) ? new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => {
      $p_Lcom_papasofokli_planning_api_PeriodSvg__dragFun__s_Option__Lcom_papasofokli_svg_api_RectangleSVG__V($thiz, $thiz.aI.iJ, _$2$3);
    }))) : $m_s_None$());
    $thiz.a3D = true;
  }
  return $thiz.a3C;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__changeRightDateFunction__s_Option($thiz) {
  if ((!$thiz.a3H)) {
    $thiz.a3G = ((!$thiz.aI.iL.c()) ? new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => {
      $p_Lcom_papasofokli_planning_api_PeriodSvg__dragFun__s_Option__Lcom_papasofokli_svg_api_RectangleSVG__V($thiz, $thiz.aI.iL, _$3$3);
    }))) : $m_s_None$());
    $thiz.a3H = true;
  }
  return $thiz.a3G;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__changeLeftDateFunction__s_Option($thiz) {
  if ((!$thiz.a3F)) {
    $thiz.a3E = ((!$thiz.aI.iK.c()) ? new $c_s_Some(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => {
      $p_Lcom_papasofokli_planning_api_PeriodSvg__dragFun__s_Option__Lcom_papasofokli_svg_api_RectangleSVG__V($thiz, $thiz.aI.iK, _$4$3);
    }))) : $m_s_None$());
    $thiz.a3F = true;
  }
  return $thiz.a3E;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__initialTextX__F($thiz) {
  if ((!$thiz.a3R)) {
    $thiz.a3Q = Math.fround(($thiz.sE + Math.fround((0.5 * $thiz.sB))));
    $thiz.a3R = true;
  }
  return $thiz.a3Q;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__initialYWithLevel__F($thiz) {
  if ((!$thiz.a3T)) {
    $thiz.a3S = Math.fround(($thiz.x1 + Math.fround(($thiz.iT * Math.fround($thiz.aI.hr)))));
    $thiz.a3T = true;
  }
  return $thiz.a3S;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__periodIndications__Lcom_papasofokli_planning_api_PeriodIndications($thiz) {
  if ((!$thiz.a3V)) {
    $thiz.a3U = new $c_Lcom_papasofokli_planning_api_PeriodIndications($thiz.aI, $thiz.sE, $thiz.Pp, $p_Lcom_papasofokli_planning_api_PeriodSvg__initialYWithLevel__F($thiz), $thiz.iT, $p_Lcom_papasofokli_planning_api_PeriodSvg__clickFunction__s_Option($thiz), $p_Lcom_papasofokli_planning_api_PeriodSvg__contextMenuFunction__s_Option($thiz), $thiz.nH);
    $thiz.a3V = true;
  }
  return $thiz.a3U;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipHtmlText__Lscalatags_JsDom$TypedTag($thiz) {
  if ((!$thiz.a43)) {
    if ($thiz.aI.iN) {
      var $x_8 = $m_Lscalatags_JsDom$all$().as();
      var $x_7 = $m_Lscalatags_JsDom$all$().bk();
      $m_Lscalatags_JsDom$all$();
      var $x_6 = $thiz.aI;
      var $x_5 = $x_8.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_7.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$StringFrag((("from " + $p_Lcom_papasofokli_planning_api_PeriodSvg__longDate2String__J__T($thiz, $x_6.qw, $x_6.qx)) + " "))])), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_planning_api_PeriodSvg__confirmedStr__Z__s_Option($thiz, $thiz.aI.lH), $m_s_$less$colon$less$().b0)]));
      var $x_4 = $m_Lscalatags_JsDom$all$().as();
      var $x_3 = $m_Lscalatags_JsDom$all$().bk();
      $m_Lscalatags_JsDom$all$();
      var $x_1 = $thiz.aI;
      var x_$_lo = $x_1.ot;
      var x_$_hi = $x_1.ou;
      var $x_2 = $m_Lcom_papasofokli_planning_package$();
      var x$1_$_lo = $x_2.DD;
      var x$1_$_hi = $x_2.DE;
      var lo = ((x_$_lo - x$1_$_lo) | 0);
      var hi = ((((x_$_hi - x$1_$_hi) | 0) - (((lo >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
      var this$29 = new $c_sci_$colon$colon($x_5, new $c_sci_$colon$colon($x_4.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_3.o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$StringFrag((("to " + $p_Lcom_papasofokli_planning_api_PeriodSvg__longDate2String__J__T($thiz, lo, hi)) + " "))])), $f_Lscalatags_generic_Util__OptionNode__s_Option__F1__Lscalatags_generic_Util$SeqNode($m_Lscalatags_JsDom$all$(), $p_Lcom_papasofokli_planning_api_PeriodSvg__confirmedStr__Z__s_Option($thiz, $thiz.aI.lG), $m_s_$less$colon$less$().b0)])), $m_sci_Nil$()));
      var this$20 = $thiz.aI.iQ;
      if (this$20.c()) {
        var $x_9 = $m_s_None$();
      } else {
        var x0$4 = this$20.h();
        var $x_9 = new $c_s_Some($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(("Total hours: " + x0$4)))]))])));
      }
      var datesInfo = this$29.cY($x_9);
    } else {
      var datesInfo = $m_sci_Nil$();
    }
    var basicInfo = new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag($thiz.aI.k6))])), new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag($thiz.aI.nu))]))])), $m_sci_Nil$())).cY(datesInfo);
    var extraInfo = $thiz.aI.nv.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((str$2) => new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().DR(), new $c_sci_$colon$colon($m_Lscalatags_JsDom$all$().bk().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [($m_Lscalatags_JsDom$all$(), new $c_Lscalatags_JsDom$StringFrag(str$2))])), $m_sci_Nil$())))));
    var tooltipElementSeq = basicInfo.cY(extraInfo);
    var hasSpecialStyle = new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodStyleE$().OW, new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodStyleE$().a1k, new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodStyleE$().OV, $m_sci_Nil$()))).az($thiz.aI.k4);
    var cssClass = (hasSpecialStyle ? "expanded-period-tooltip" : "");
    $thiz.a42 = $m_Lscalatags_JsDom$all$().as().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n(cssClass, $m_Lscalatags_JsDom$all$().s)])).o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lscalatags_JsDom$Cap$SeqFrag($m_Lscalatags_JsDom$all$(), tooltipElementSeq, $m_s_$less$colon$less$().b0)]));
    $thiz.a43 = true;
  }
  return $thiz.a42;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__textRelevantY__F($thiz) {
  if ((!$thiz.a41)) {
    $thiz.a40 = ($thiz.aI.i4.c() ? Math.fround((Math.fround((0.5 * $thiz.iT)) + 3.0)) : Math.fround((Math.fround(($thiz.iT / 3.0)) + 5.0)));
    $thiz.a41 = true;
  }
  return $thiz.a40;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__getTextPeriodY__F($thiz) {
  if ((!$thiz.a3N)) {
    $thiz.a3M = Math.fround(($p_Lcom_papasofokli_planning_api_PeriodSvg__initialYWithLevel__F($thiz) + $p_Lcom_papasofokli_planning_api_PeriodSvg__textRelevantY__F($thiz)));
    $thiz.a3N = true;
  }
  return $thiz.a3M;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__textPeriod__s_Option($thiz) {
  if ((!$thiz.a3Z)) {
    var this$1 = $thiz.aI.iP;
    if (this$1.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$1.h();
      var initialClassName$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__getTextClass__T__s_Option($thiz, "barText-big");
      var initialY$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__getTextPeriodY__F($thiz);
      var initialX$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__initialTextX__F($thiz);
      var onHover$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipText__s_Option($thiz);
      var onMouseOut$1 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
      })));
      var contextMenuFunction$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__contextMenuFunction__s_Option($thiz);
      var clickFunction$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__clickFunction__s_Option($thiz);
      var getGroupedDraggedShapes$1 = $thiz.Ic();
      var textLength$1 = $m_s_None$();
      var lengthAdjust$1 = $m_s_None$();
      var dragFunction$1 = $m_s_None$();
      var href$1 = $m_s_None$();
      var color$1 = $m_s_None$();
      var stroke$1 = $m_s_None$();
      var $x_1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__adjustTextSize__Lcom_papasofokli_svg_components_TextComponent__s_Option($thiz, new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$1, x0, initialX$1, initialY$1, textLength$1, lengthAdjust$1, dragFunction$1, clickFunction$1, $thiz.aI.fv, getGroupedDraggedShapes$1, true, onHover$1, onMouseOut$1, contextMenuFunction$1, href$1, color$1, stroke$1));
    }
    $thiz.a3Y = $x_1;
    $thiz.a3Z = true;
  }
  return $thiz.a3Y;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__additionalTextPeriod__s_Option($thiz) {
  if ((!$thiz.a3v)) {
    var this$1 = $thiz.aI.i4;
    if (this$1.c()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$1.h();
      var initialClassName$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__getTextClass__T__s_Option($thiz, "barText-small");
      var initialY$2 = Math.fround(($p_Lcom_papasofokli_planning_api_PeriodSvg__getTextPeriodY__F($thiz) + 15.0));
      var initialX$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__initialTextX__F($thiz);
      var onHover$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipText__s_Option($thiz);
      var onMouseOut$2 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
        $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
      })));
      var contextMenuFunction$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__contextMenuFunction__s_Option($thiz);
      var clickFunction$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__clickFunction__s_Option($thiz);
      var getGroupedDraggedShapes$2 = $thiz.Ic();
      var textLength$2 = $m_s_None$();
      var lengthAdjust$2 = $m_s_None$();
      var dragFunction$2 = $m_s_None$();
      var href$2 = $m_s_None$();
      var color$2 = $m_s_None$();
      var stroke$2 = $m_s_None$();
      var $x_1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__adjustTextSize__Lcom_papasofokli_svg_components_TextComponent__s_Option($thiz, new $c_Lcom_papasofokli_svg_components_TextComponent(initialClassName$2, x0, initialX$2, initialY$2, textLength$2, lengthAdjust$2, dragFunction$2, clickFunction$2, $thiz.aI.fv, getGroupedDraggedShapes$2, true, onHover$2, onMouseOut$2, contextMenuFunction$2, href$2, color$2, stroke$2));
    }
    $thiz.a3u = $x_1;
    $thiz.a3v = true;
  }
  return $thiz.a3u;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__adjustTextSize__Lcom_papasofokli_svg_components_TextComponent__s_Option($thiz, default$1) {
  var alternative$lzy1 = new $c_sr_LazyRef();
  var small$lzy1 = new $c_sr_LazyRef();
  var this$1 = default$1.A7($thiz.sB);
  var alternative$lzy1$3 = alternative$lzy1;
  var this$2 = (this$1.c() ? $p_Lcom_papasofokli_planning_api_PeriodSvg__alternative$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, alternative$lzy1$3, default$1).A7($thiz.sB) : this$1);
  var small$lzy1$3 = small$lzy1;
  return (this$2.c() ? $p_Lcom_papasofokli_planning_api_PeriodSvg__small$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, small$lzy1$3, default$1).A7($thiz.sB) : this$2);
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__getTextClass__T__s_Option($thiz, className) {
  return $m_s_Option$().Z((($thiz.aI.k4.sk + " ") + className));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__confirmedStr__Z__s_Option($thiz, isConfirmed) {
  return (isConfirmed ? $m_s_Option$().Z($m_Lscalatags_JsDom$all$().c6().o($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lscalatags_JsDom$all$().D().n($m_Lcom_papasofokli_util_IconUI$().a8C.by, $m_Lscalatags_JsDom$all$().s)]))) : $m_s_None$());
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipText__s_Option($thiz) {
  var $x_1 = $m_s_Option$();
  var textHtmlInToolTip = $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipHtmlText__Lscalatags_JsDom$TypedTag($thiz).aB().outerHTML;
  return $x_1.Z($m_Lcom_papasofokli_planning_tooltip_Tooltip$().oU(textHtmlInToolTip, ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), false), ($m_Lcom_papasofokli_planning_tooltip_Tooltip$(), $m_s_None$())));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__actionsFunctionFun__ju_UUID__V($thiz, functionUUID) {
  var this$1 = $thiz.aI.fU;
  var f = $thiz.sD;
  var this$3 = (this$1.c() ? $m_s_None$() : new $c_s_Some(f.p(this$1.h())));
  var relevantPeriodSeq = (this$3.c() ? new $c_sci_$colon$colon(new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod($thiz.eK, $thiz.aI), $m_sci_Nil$()) : this$3.h());
  var plannerPeriodsData = new $c_Lcom_papasofokli_planning_PlannerPeriodsData($thiz.eK, relevantPeriodSeq, $m_s_None$());
  var this$10 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
  var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), plannerPeriodsData, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_planning_PlannerPeriodsData$().q());
  var executionContext = $thiz.Po;
  $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$10, functionUUID.g(), data, executionContext);
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__dragFun__s_Option__Lcom_papasofokli_svg_api_RectangleSVG__V($thiz, functionUUID, r) {
  if ((functionUUID instanceof $c_s_Some)) {
    var x13 = functionUUID.bg;
    if ((x13 !== null)) {
      var nextx = Math.fround($f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(r, "x").h());
      var nextendx = Math.fround((Math.fround($f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(r, "x").h()) + Math.fround($f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(r, "width").h())));
      var startDate = $thiz.sF.ahq(nextx);
      var endDate = $thiz.sF.ahq(nextendx);
      var subjectRowIdO = $thiz.x0.p($f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(r, "y").h());
      var $x_1 = $m_RTLong$().jq((+startDate.getTime()));
      var fromDate$1_$_lo = $x_1.l;
      var fromDate$1_$_hi = $x_1.h;
      var $x_2 = $m_RTLong$().jq((+endDate.getTime()));
      var toDate$1_$_lo = $x_2.l;
      var toDate$1_$_hi = $x_2.h;
      var changedPeriod = new $c_Lcom_papasofokli_planning_PeriodJS($thiz.aI.fU, fromDate$1_$_lo, fromDate$1_$_hi, toDate$1_$_lo, toDate$1_$_hi, $thiz.aI.iQ, $thiz.aI.k6, $thiz.aI.nu, $thiz.aI.k7, $thiz.aI.nv, $thiz.aI.lH, $thiz.aI.lG, $thiz.aI.k4, $thiz.aI.hr, $thiz.aI.gV, $thiz.aI.iP, $thiz.aI.i4, $thiz.aI.gW, $thiz.aI.gU, $thiz.aI.k5, $thiz.aI.fw, $thiz.aI.iM, $thiz.aI.iO, $thiz.aI.i3, $thiz.aI.iJ, $thiz.aI.iL, $thiz.aI.iK, $thiz.aI.fv, $thiz.aI.iN);
      var periodJsSeq = new $c_Lcom_papasofokli_planning_PlannerPeriodsData($thiz.eK, $thiz.sD.p($thiz.aI.fU.h()).ba(new $c_Lcom_papasofokli_planning_UUIDRowWithPeriod($thiz.eK, changedPeriod)), subjectRowIdO);
      var this$34 = $m_Lcom_papasofokli_util_AjaxCallFunctions$();
      var data = $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($m_Lupickle_default$(), periodJsSeq, ($m_Lupickle_default$(), (-1)), ($m_Lupickle_default$(), false), ($m_Lupickle_default$(), false), $m_Lcom_papasofokli_planning_PlannerPeriodsData$().q());
      var executionContext = $thiz.Po;
      $p_Lcom_papasofokli_util_AjaxCallFunctions$__ajaxFunctionCallAndEvalF__O__O__s_concurrent_ExecutionContext__s_concurrent_Future(this$34, x13.g(), data, executionContext);
      return (void 0);
    }
  }
  if (($m_s_None$() === functionUUID)) {
    return (void 0);
  }
  throw new $c_s_MatchError(functionUUID);
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__rectComponent__Lcom_papasofokli_svg_components_RectComponent($thiz) {
  if ((!$thiz.a3X)) {
    var initialClassName$3 = $m_s_Option$().Z($thiz.aI.k4.sk);
    var initialHeight$1 = Math.fround(($thiz.iT - 6.0));
    var initialY$3 = Math.fround(($p_Lcom_papasofokli_planning_api_PeriodSvg__initialYWithLevel__F($thiz) + 1.0));
    var resizeLeftFunction$1 = ((!$thiz.aI.lH) ? $p_Lcom_papasofokli_planning_api_PeriodSvg__changeLeftDateFunction__s_Option($thiz) : $m_s_None$());
    var resizeRightFunction$1 = ((!$thiz.aI.lG) ? $p_Lcom_papasofokli_planning_api_PeriodSvg__changeRightDateFunction__s_Option($thiz) : $m_s_None$());
    var dragFunction$3 = (((!$thiz.aI.lH) && (!$thiz.aI.lG)) ? $p_Lcom_papasofokli_planning_api_PeriodSvg__changeDatesFunction__s_Option($thiz) : $m_s_None$());
    var clickFunction$3 = $p_Lcom_papasofokli_planning_api_PeriodSvg__clickFunction__s_Option($thiz);
    var contextMenuFunction$3 = $p_Lcom_papasofokli_planning_api_PeriodSvg__contextMenuFunction__s_Option($thiz);
    var getGroupedDraggedShapes$3 = $thiz.Ic();
    var onHover$3 = $p_Lcom_papasofokli_planning_api_PeriodSvg__toolTipText__s_Option($thiz);
    var onMouseOut$3 = $m_s_Option$().Z(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $m_Lcom_papasofokli_planning_tooltip_Tooltip$().hO();
    })));
    var resizeUpFunction$1 = $m_s_None$();
    var resizeDownFunction$1 = $m_s_None$();
    var href$3 = $m_s_None$();
    var onBoundHover$1 = $m_s_None$();
    $thiz.a3W = new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$3, initialHeight$1, $thiz.sB, $thiz.sE, initialY$3, resizeUpFunction$1, resizeDownFunction$1, resizeLeftFunction$1, resizeRightFunction$1, dragFunction$3, clickFunction$3, contextMenuFunction$3, getGroupedDraggedShapes$3, onHover$3, onMouseOut$3, true, href$3, $thiz.aI.fv, $thiz.aI.iM, $thiz.aI.iO, onBoundHover$1);
    $thiz.a3X = true;
  }
  return $thiz.a3W;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__ghostPeriodGlowO__s_Option($thiz) {
  if ((!$thiz.a3P)) {
    var x = $thiz.aI.k4;
    var x$2 = $m_Lcom_papasofokli_planning_PeriodStyleE$().OW;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var initialClassName$4 = new $c_s_Some("ghost-period-glow");
      var initialHeight$2 = Math.fround(($thiz.iT - 6.0));
      var initialY$4 = Math.fround(($p_Lcom_papasofokli_planning_api_PeriodSvg__initialYWithLevel__F($thiz) + 1.0));
      var resizeUpFunction$2 = $m_s_None$();
      var resizeDownFunction$2 = $m_s_None$();
      var resizeLeftFunction$2 = $m_s_None$();
      var resizeRightFunction$2 = $m_s_None$();
      var dragFunction$4 = $m_s_None$();
      var clickFunction$4 = $m_s_None$();
      var contextMenuFunction$4 = $m_s_None$();
      var getGroupedDraggedShapes$4 = $m_Lcom_papasofokli_svg_components_RectComponent$().hI();
      var onHover$4 = $m_s_None$();
      var onMouseOut$4 = $m_s_None$();
      var href$4 = $m_s_None$();
      var color$4 = $m_s_None$();
      var stroke$4 = $m_s_None$();
      var onBoundHover$2 = $m_s_None$();
      var $x_1 = new $c_s_Some(new $c_Lcom_papasofokli_svg_components_RectComponent(initialClassName$4, initialHeight$2, $thiz.sB, $thiz.sE, initialY$4, resizeUpFunction$2, resizeDownFunction$2, resizeLeftFunction$2, resizeRightFunction$2, dragFunction$4, clickFunction$4, contextMenuFunction$4, getGroupedDraggedShapes$4, onHover$4, onMouseOut$4, false, href$4, $thiz.aI.fv, color$4, stroke$4, onBoundHover$2));
    } else {
      var $x_1 = $m_s_None$();
    }
    $thiz.a3O = $x_1;
    $thiz.a3P = true;
  }
  return $thiz.a3O;
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__alternative$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, alternative$lzy1$1, default$1) {
  return (alternative$lzy1$1.i ? alternative$lzy1$1.j : alternative$lzy1$1.E(new $c_Lcom_papasofokli_svg_components_TextComponent($p_Lcom_papasofokli_planning_api_PeriodSvg__getTextClass__T__s_Option($thiz, "barText-small"), default$1.t0, default$1.m6, default$1.nT, default$1.pW, default$1.pS, default$1.nS, default$1.nR, default$1.pM, default$1.pP, default$1.pR, default$1.pT, default$1.pU, default$1.pO, default$1.pQ, default$1.pN, default$1.pV)));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__alternative$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, alternative$lzy1$2, default$2) {
  return (alternative$lzy1$2.i ? alternative$lzy1$2.j : $p_Lcom_papasofokli_planning_api_PeriodSvg__alternative$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, alternative$lzy1$2, default$2));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__small$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, small$lzy1$1, default$3) {
  return (small$lzy1$1.i ? small$lzy1$1.j : small$lzy1$1.E(new $c_Lcom_papasofokli_svg_components_TextComponent($p_Lcom_papasofokli_planning_api_PeriodSvg__getTextClass__T__s_Option($thiz, "barText-xs"), default$3.t0, default$3.m6, default$3.nT, default$3.pW, default$3.pS, default$3.nS, default$3.nR, default$3.pM, default$3.pP, default$3.pR, default$3.pT, default$3.pU, default$3.pO, default$3.pQ, default$3.pN, default$3.pV)));
}
function $p_Lcom_papasofokli_planning_api_PeriodSvg__small$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, small$lzy1$2, default$4) {
  return (small$lzy1$2.i ? small$lzy1$2.j : $p_Lcom_papasofokli_planning_api_PeriodSvg__small$lzyINIT1$1__sr_LazyRef__Lcom_papasofokli_svg_components_TextComponent__Lcom_papasofokli_svg_components_TextComponent($thiz, small$lzy1$2, default$4));
}
/** @constructor */
function $c_Lcom_papasofokli_planning_api_PeriodSvg(period, initialY, periodHeight, timeLine, rowUUID, detailRowIndexO, getAllRelevantPeriods, periodSvgIndicationsSetup, getSubjectIdByPosition, executionContext) {
  this.a3A = null;
  this.a3B = false;
  this.a3w = null;
  this.a3x = false;
  this.aI = null;
  this.x1 = 0.0;
  this.iT = 0.0;
  this.sF = null;
  this.eK = null;
  this.sC = null;
  this.sD = null;
  this.nH = null;
  this.x0 = null;
  this.Po = null;
  this.sE = 0.0;
  this.Pp = 0.0;
  this.sB = 0.0;
  this.a3K = null;
  this.a3L = false;
  this.a3I = null;
  this.a3J = false;
  this.a3C = null;
  this.a3D = false;
  this.a3G = null;
  this.a3H = false;
  this.a3E = null;
  this.a3F = false;
  this.a3Q = 0.0;
  this.a3R = false;
  this.a3S = 0.0;
  this.a3T = false;
  this.a3U = null;
  this.a3V = false;
  this.a42 = null;
  this.a43 = false;
  this.a40 = 0.0;
  this.a41 = false;
  this.a3M = 0.0;
  this.a3N = false;
  this.a3Y = null;
  this.a3Z = false;
  this.a3u = null;
  this.a3v = false;
  this.a3W = null;
  this.a3X = false;
  this.a3O = null;
  this.a3P = false;
  this.a3y = null;
  this.a3z = false;
  this.aI = period;
  this.x1 = initialY;
  this.iT = periodHeight;
  this.sF = timeLine;
  this.eK = rowUUID;
  this.sC = detailRowIndexO;
  this.sD = getAllRelevantPeriods;
  this.nH = periodSvgIndicationsSetup;
  this.x0 = getSubjectIdByPosition;
  this.Po = executionContext;
  matchResult4: {
    var \u03b42$;
    var x5 = $m_Lcom_papasofokli_planning_api_PeriodSvg$().Ux(period, timeLine);
    if ((x5 !== null)) {
      Math.fround(x5.P());
      Math.fround(x5.V());
      var \u03b42$ = x5;
      break matchResult4;
    }
    throw new $c_s_MatchError(x5);
  }
  this.sE = Math.fround(\u03b42$.P());
  this.Pp = Math.fround(\u03b42$.V());
  this.sB = Math.fround($f_sc_IterableOnceOps__max__s_math_Ordering__O(new $c_sci_$colon$colon(Math.fround((this.Pp - this.sE)), new $c_sci_$colon$colon(0.0, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
}
$p = $c_Lcom_papasofokli_planning_api_PeriodSvg.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_planning_api_PeriodSvg;
/** @constructor */
function $h_Lcom_papasofokli_planning_api_PeriodSvg() {
}
$h_Lcom_papasofokli_planning_api_PeriodSvg.prototype = $p;
$p.di = (function() {
  if ((!this.a3B)) {
    this.a3A = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allShapes__sci_Seq(this);
    this.a3B = true;
  }
  return this.a3A;
});
$p.Ic = (function() {
  if ((!this.a3x)) {
    this.a3w = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allActionShapes__F0(this);
    this.a3x = true;
  }
  return this.a3w;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1724412733));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.aI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.x1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.iT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.eK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.x0));
  return $m_sr_Statics$().an(acc, 9);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_planning_api_PeriodSvg)) {
    if (((this.x1 === x$0.x1) && (this.iT === x$0.iT))) {
      var x = this.aI;
      var x$2 = x$0.aI;
      var $x_6 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.sF;
      var x$4 = x$0.sF;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.eK;
      var x$6 = x$0.eK;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.sC;
      var x$8 = x$0.sC;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.sD;
      var x$10 = x$0.sD;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.nH;
      var x$12 = x$0.nH;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.x0;
      var x$14 = x$0.x0;
      return ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 9;
});
$p.A = (function() {
  return "PeriodSvg";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.aI;
      break;
    }
    case 1: {
      return this.x1;
      break;
    }
    case 2: {
      return this.iT;
      break;
    }
    case 3: {
      return this.sF;
      break;
    }
    case 4: {
      return this.eK;
      break;
    }
    case 5: {
      return this.sC;
      break;
    }
    case 6: {
      return this.sD;
      break;
    }
    case 7: {
      return this.nH;
      break;
    }
    case 8: {
      return this.x0;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.N0 = (function() {
  return (this.sB > 0.0);
});
$p.Mc = (function() {
  if ((!this.a3z)) {
    this.a3y = $m_s_Option$().hi($p_Lcom_papasofokli_planning_api_PeriodSvg__ghostPeriodGlowO__s_Option(this)).cf().cH(new $c_sci_$colon$colon($p_Lcom_papasofokli_planning_api_PeriodSvg__rectComponent__Lcom_papasofokli_svg_components_RectComponent(this), $m_sci_Nil$())).dt($p_Lcom_papasofokli_planning_api_PeriodSvg__periodIndications__Lcom_papasofokli_planning_api_PeriodIndications(this).a3j).dt($p_Lcom_papasofokli_planning_api_PeriodSvg__textPeriod__s_Option(this)).dt($p_Lcom_papasofokli_planning_api_PeriodSvg__additionalTextPeriod__s_Option(this));
    this.a3z = true;
  }
  return this.a3y;
});
$p.gd = (function(nextY) {
  $f_Lcom_papasofokli_svg_components_SvgComponent__addClass__T__V(this, $m_Lcom_papasofokli_planning_package$().nM);
  var newYWithLevel = Math.fround((nextY + Math.fround((this.iT * Math.fround(this.aI.hr)))));
  var this$1 = $p_Lcom_papasofokli_planning_api_PeriodSvg__ghostPeriodGlowO__s_Option(this);
  if ((!this$1.c())) {
    this$1.h().cT(this.sE, Math.fround((newYWithLevel + 1.0)));
  }
  $p_Lcom_papasofokli_planning_api_PeriodSvg__rectComponent__Lcom_papasofokli_svg_components_RectComponent(this).cT(this.sE, Math.fround((newYWithLevel + 1.0)));
  var this$2 = $p_Lcom_papasofokli_planning_api_PeriodSvg__textPeriod__s_Option(this);
  if ((!this$2.c())) {
    this$2.h().cT($p_Lcom_papasofokli_planning_api_PeriodSvg__initialTextX__F(this), Math.fround((newYWithLevel + $p_Lcom_papasofokli_planning_api_PeriodSvg__textRelevantY__F(this))));
  }
  var this$3 = $p_Lcom_papasofokli_planning_api_PeriodSvg__additionalTextPeriod__s_Option(this);
  if ((!this$3.c())) {
    this$3.h().cT($p_Lcom_papasofokli_planning_api_PeriodSvg__initialTextX__F(this), Math.fround((newYWithLevel + $p_Lcom_papasofokli_planning_api_PeriodSvg__textRelevantY__F(this))));
  }
  $p_Lcom_papasofokli_planning_api_PeriodSvg__periodIndications__Lcom_papasofokli_planning_api_PeriodIndications(this).gd(nextY);
});
function $isArrayOf_Lcom_papasofokli_planning_api_PeriodSvg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fw)));
}
var $d_Lcom_papasofokli_planning_api_PeriodSvg = new $TypeData().i($c_Lcom_papasofokli_planning_api_PeriodSvg, "com.papasofokli.planning.api.PeriodSvg", ({
  fw: 1,
  aj: 1,
  bL: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_api_Svg__parentDiv__Lorg_scalajs_dom_HTMLDivElement($thiz) {
  var this$1 = $m_s_Option$().Z(document.getElementById($thiz.pC));
  var element = (this$1.c() ? (console.error(("problem, not found " + $thiz.pC), $thiz.pC), document.getElementById($thiz.pC)) : this$1.h());
  if ((!(!(element instanceof HTMLDivElement)))) {
    return element;
  }
  throw new $c_s_MatchError("Element not a div as expected");
}
function $p_Lcom_papasofokli_svg_api_Svg__width__F($thiz) {
  var this$1 = $thiz.BZ;
  return Math.fround((this$1.c() ? Math.fround((+$p_Lcom_papasofokli_svg_api_Svg__parentDiv__Lorg_scalajs_dom_HTMLDivElement($thiz).getBoundingClientRect().width)) : this$1.h()));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_Svg(divId, interiorElements, height, widthO) {
  this.a6D = null;
  this.a6E = false;
  this.a6B = null;
  this.a6C = false;
  this.a6G = null;
  this.pC = null;
  this.BY = null;
  this.xB = 0.0;
  this.BZ = null;
  this.a6I = null;
  this.a6A = null;
  this.a6F = null;
  this.a6H = null;
  this.pC = divId;
  this.BY = interiorElements;
  this.xB = height;
  this.BZ = widthO;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a6I = $m_s_None$();
  this.a6A = $m_s_None$();
  this.a6F = new $c_s_Some("planner");
  this.a6H = "svg";
}
$p = $c_Lcom_papasofokli_svg_api_Svg.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_Svg;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_Svg() {
}
$h_Lcom_papasofokli_svg_api_Svg.prototype = $p;
$p.g9 = (function() {
  if ((!this.a6E)) {
    this.a6D = $m_ju_UUID$().aW();
    this.a6E = true;
  }
  return this.a6D;
});
$p.oG = (function() {
  if ((!this.a6C)) {
    this.a6B = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a6C = true;
  }
  return this.a6B;
});
$p.oT = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a6G;
});
$p.zx = (function(x$0) {
  this.a6G = x$0;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 83524);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BY));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xB));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BZ));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_Svg)) {
    if (((this.xB === x$0.xB) && (this.pC === x$0.pC))) {
      var x = this.BY;
      var x$2 = x$0.BY;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.BZ;
      var x$4 = x$0.BZ;
      return ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "Svg";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pC;
      break;
    }
    case 1: {
      return this.BY;
      break;
    }
    case 2: {
      return this.xB;
      break;
    }
    case 3: {
      return this.BZ;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oQ = (function() {
  return this.BY;
});
$p.E6 = (function() {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option(this, "height");
  return Math.fround((this$1.c() ? this.xB : this$1.h()));
});
$p.p1 = (function() {
  return this.a6I;
});
$p.oC = (function() {
  return this.a6A;
});
$p.oP = (function() {
  return this.a6F;
});
$p.oZ = (function() {
  return this.a6H;
});
$p.oE = (function() {
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("width", ("" + $p_Lcom_papasofokli_svg_api_Svg__width__F(this))), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("height", ("" + this.xB)), $m_sci_Nil$()));
});
$p.gN = (function(h) {
  var this$3 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  var \u03b41$ = new $c_Lcom_papasofokli_util_AttributeValue("height", ("" + h));
  if ((!this$3.c())) {
    \u03b41$.ds(this$3.h());
  }
});
$p.aw2 = (function() {
  $p_Lcom_papasofokli_svg_api_Svg__parentDiv__Lorg_scalajs_dom_HTMLDivElement(this).innerHTML = "";
  var timeLoading = (+new Date().getTime());
  $f_Lcom_papasofokli_svg_api_GeneralShape__appendTo__s_Option__F0__Lorg_scalajs_dom_Element(this, new $c_s_Some($p_Lcom_papasofokli_svg_api_Svg__parentDiv__Lorg_scalajs_dom_HTMLDivElement(this)), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => 0.0)));
  return timeLoading;
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.p0 = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lcom_papasofokli_svg_api_Svg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fR)));
}
var $d_Lcom_papasofokli_svg_api_Svg = new $TypeData().i($c_Lcom_papasofokli_svg_api_Svg, "com.papasofokli.svg.api.Svg", ({
  fR: 1,
  aH: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__dayWeekTickInterval__s_Option($thiz) {
  if ((!$thiz.a7S)) {
    var this$1 = new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_DayLongWeekTickInterval$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_DayShortWeekTickInterval$(), $m_sci_Nil$()));
    _return: {
      var these = this$1;
      while ((!these.c())) {
        if ($f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z(these.W(), $thiz.t3, $thiz.t2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz, date$2))))) {
          var $x_1 = new $c_s_Some(these.W());
          break _return;
        }
        these = these.ak();
      }
      var $x_1 = $m_s_None$();
    }
    $thiz.a7R = $x_1;
    $thiz.a7S = true;
  }
  return $thiz.a7R;
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__commonTickIntervals__sci_Seq($thiz) {
  if ((!$thiz.a7Q)) {
    $thiz.a7P = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__applicableTickIntervals__sci_List__sci_List($thiz, new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_DayMonthTickInterval$(), $m_sci_Nil$())));
    $thiz.a7Q = true;
  }
  return $thiz.a7P;
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__detailedMinutesTickIntervals__s_Option($thiz) {
  if ((!$thiz.a7U)) {
    var this$3 = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval(15), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_svg_timeline_MinutesTickInterval(30), $m_sci_Nil$()));
    _return: {
      var these = this$3;
      while ((!these.c())) {
        if ($f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z(these.W(), $thiz.t3, $thiz.t2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz, date$2))))) {
          var $x_1 = new $c_s_Some(these.W());
          break _return;
        }
        these = these.ak();
      }
      var $x_1 = $m_s_None$();
    }
    $thiz.a7T = $x_1;
    $thiz.a7U = true;
  }
  return $thiz.a7T;
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__detailedTickIntervals__sci_List($thiz) {
  if ((!$thiz.a7W)) {
    var seq = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__applicableTickIntervals__sci_List__sci_List($thiz, new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_DayFullTickInterval$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_HourTickInterval$(), $m_sci_Nil$())));
    $thiz.a7V = ((seq.F() === 2) ? seq.cY($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__detailedMinutesTickIntervals__s_Option($thiz)) : seq);
    $thiz.a7W = true;
  }
  return $thiz.a7V;
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__applicableTickIntervals__sci_List__sci_List($thiz, sortedTickIntervals) {
  if ((sortedTickIntervals instanceof $c_sci_$colon$colon)) {
    var x8 = sortedTickIntervals.bz;
    var x = sortedTickIntervals.q9;
    if ($f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z(x, $thiz.t3, $thiz.t2, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz, date$2))))) {
      return new $c_sci_$colon$colon(x, $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__applicableTickIntervals__sci_List__sci_List($thiz, x8));
    }
  }
  return $m_sci_Nil$();
}
function $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F($thiz, date) {
  return Math.fround(((((+date.getTime()) - $thiz.Ku) * $thiz.Qf) + Math.fround($thiz.pX.aA())));
}
/** @constructor */
function $c_Lcom_papasofokli_svg_timeline_TimeLineSVG(getStartPoint, getEndPoint, startDate, endDate, rowThickness, onHover, mouseOut, appendWithAnimationTime) {
  this.a7N = null;
  this.a7O = false;
  this.a7L = null;
  this.a7M = false;
  this.pX = null;
  this.m7 = null;
  this.t3 = null;
  this.t2 = null;
  this.G6 = 0.0;
  this.G5 = null;
  this.G4 = null;
  this.G3 = null;
  this.Ku = 0.0;
  this.Qf = 0.0;
  this.a7R = null;
  this.a7S = false;
  this.a7P = null;
  this.a7Q = false;
  this.a7T = null;
  this.a7U = false;
  this.a7V = null;
  this.a7W = false;
  this.a7X = null;
  this.a7Y = null;
  this.Qg = 0.0;
  this.pX = getStartPoint;
  this.m7 = getEndPoint;
  this.t3 = startDate;
  this.t2 = endDate;
  this.G6 = rowThickness;
  this.G5 = onHover;
  this.G4 = mouseOut;
  this.G3 = appendWithAnimationTime;
  this.Ku = (+startDate.getTime());
  var endMills = (+endDate.getTime());
  this.Qf = (this.uv() / (endMills - this.Ku));
  if (($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__detailedTickIntervals__sci_List(this).F() > 1)) {
    var applicableTickIntervals = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__detailedTickIntervals__sci_List(this);
  } else if ((($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__commonTickIntervals__sci_Seq(this).F() > 1) || (!$p_Lcom_papasofokli_svg_timeline_TimeLineSVG__dayWeekTickInterval__s_Option(this).c()))) {
    var applicableTickIntervals = $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__commonTickIntervals__sci_Seq(this).cH($p_Lcom_papasofokli_svg_timeline_TimeLineSVG__dayWeekTickInterval__s_Option(this));
  } else {
    var this$3 = new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_MonthLongTickInterval$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_MonthShortTickInterval$(), new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_MonthShorterTickInterval$(), $m_sci_Nil$())));
    _return: {
      var these = this$3;
      while ((!these.c())) {
        if ($f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z(these.W(), startDate, endDate, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(this, date$2))))) {
          var monthTickInterval = new $c_s_Some(these.W());
          break _return;
        }
        these = these.ak();
      }
      var monthTickInterval = $m_s_None$();
    }
    var this$7 = new $c_sci_$colon$colon($m_Lcom_papasofokli_svg_timeline_YearTickInterval$(), $m_sci_Nil$());
    var f = ((_$4$2) => $f_Lcom_papasofokli_svg_timeline_TickInterval__textCanFit__sjs_js_Date__sjs_js_Date__F1__Z(_$4$2, startDate, endDate, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2$1) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(this, date$2$1)))));
    _return$1: {
      var $x_1;
      var l$tailLocal1 = this$7;
      while (true) {
        if (l$tailLocal1.c()) {
          var $x_1 = $m_sci_Nil$();
          break;
        } else {
          var h = l$tailLocal1.W();
          var t = l$tailLocal1.ak();
          if ((!(!(!f(h))))) {
            l$tailLocal1 = t;
            continue;
          }
          var start = l$tailLocal1;
          var remaining$tailLocal1 = t;
          while (true) {
            if (remaining$tailLocal1.c()) {
              var $x_1 = start;
              break _return$1;
            } else {
              var x = remaining$tailLocal1.W();
              if ((!(!f(x)))) {
                remaining$tailLocal1 = remaining$tailLocal1.ak();
                continue;
              }
              var firstMiss = remaining$tailLocal1;
              var newHead = new $c_sci_$colon$colon(start.W(), $m_sci_Nil$());
              var toProcess = start.ak();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
                currentLast.bz = newElem;
                currentLast = newElem;
                toProcess = toProcess.ak();
              }
              var next = firstMiss.ak();
              var nextToCopy = next;
              while ((!next.c())) {
                var head = next.W();
                if ((!(!f(head)))) {
                  next = next.ak();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
                    currentLast.bz = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.ak();
                  }
                  nextToCopy = next.ak();
                  next = next.ak();
                }
              }
              if ((!nextToCopy.c())) {
                currentLast.bz = nextToCopy;
              }
              var $x_1 = newHead;
              break _return$1;
            }
          }
        }
      }
    }
    var applicableTickIntervals = $x_1.cY(monthTickInterval);
  }
  this.a7X = applicableTickIntervals.bc().X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var index = (x$1$2.V() | 0);
      var yComp = Math.fround((Math.fround(((1 + index) | 0)) * rowThickness));
      return new $c_Lcom_papasofokli_svg_components_LineComponent($m_s_Option$().Z("axisline"), Math.fround(getStartPoint.aA()), yComp, Math.fround(getEndPoint.aA()), yComp, $m_s_None$(), $m_s_None$(), this.Ic(), false, $m_s_None$(), $m_s_None$(), appendWithAnimationTime, $m_s_None$(), $m_ju_UUID$().aW());
    }
    throw new $c_s_MatchError(x$1$2);
  })));
  this.a7Y = applicableTickIntervals.bc().aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
    if ((x$1$2$1 !== null)) {
      var x18 = x$1$2$1.P();
      if ((x18 !== null)) {
        var index$1 = (x$1$2$1.V() | 0);
        var yComp$1 = Math.fround((Math.fround(index$1) * rowThickness));
        return $m_Lcom_papasofokli_svg_timeline_TimeLineSVGHelper$().aj3($f_Lcom_papasofokli_svg_timeline_TickInterval__apply__sjs_js_Date__sjs_js_Date__sci_Seq(x18, startDate, endDate)).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
          if ((x$1$2$2 !== null)) {
            var x13 = x$1$2$2.P();
            var x14 = x$1$2$2.V();
            if ((x13 !== null)) {
              if ((x14 !== null)) {
                return new $c_Lcom_papasofokli_svg_timeline_TimeLineCell(Math.fround(getStartPoint.aA()), Math.fround(getEndPoint.aA()), x13, x14, x18, yComp$1, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((date$2$2) => $p_Lcom_papasofokli_svg_timeline_TimeLineSVG__getPosition__sjs_js_Date__F(this, date$2$2))), rowThickness, onHover, mouseOut, appendWithAnimationTime);
              }
            }
          }
          throw new $c_s_MatchError(x$1$2$2);
        })));
      }
    }
    throw new $c_s_MatchError(x$1$2$1);
  })));
  var numberOfRows = applicableTickIntervals.F();
  this.Qg = Math.fround((rowThickness * Math.fround(numberOfRows)));
}
$p = $c_Lcom_papasofokli_svg_timeline_TimeLineSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_timeline_TimeLineSVG;
/** @constructor */
function $h_Lcom_papasofokli_svg_timeline_TimeLineSVG() {
}
$h_Lcom_papasofokli_svg_timeline_TimeLineSVG.prototype = $p;
$p.di = (function() {
  if ((!this.a7O)) {
    this.a7N = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allShapes__sci_Seq(this);
    this.a7O = true;
  }
  return this.a7N;
});
$p.Ic = (function() {
  if ((!this.a7M)) {
    this.a7L = $f_Lcom_papasofokli_svg_components_SvgDragGrouping__allActionShapes__F0(this);
    this.a7M = true;
  }
  return this.a7L;
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1746421213));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.pX));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.m7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.t3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.t2));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.G6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.G5));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.G4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.G3));
  return $m_sr_Statics$().an(acc, 8);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_timeline_TimeLineSVG)) {
    if ((this.G6 === x$0.G6)) {
      var x = this.pX;
      var x$2 = x$0.pX;
      var $x_4 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.m7;
      var x$4 = x$0.m7;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_3 = false;
    }
    if ((($x_3 && $m_sr_BoxesRunTime$().B(this.t3, x$0.t3)) && $m_sr_BoxesRunTime$().B(this.t2, x$0.t2))) {
      var x$5$1 = this.G5;
      var x$6 = x$0.G5;
      var $x_2 = ((x$5$1 === null) ? (x$6 === null) : x$5$1.b(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.G4;
      var x$8 = x$0.G4;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.G3;
      var x$10 = x$0.G3;
      return ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 8;
});
$p.A = (function() {
  return "TimeLineSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.pX;
      break;
    }
    case 1: {
      return this.m7;
      break;
    }
    case 2: {
      return this.t3;
      break;
    }
    case 3: {
      return this.t2;
      break;
    }
    case 4: {
      return this.G6;
      break;
    }
    case 5: {
      return this.G5;
      break;
    }
    case 6: {
      return this.G4;
      break;
    }
    case 7: {
      return this.G3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.uv = (function() {
  return Math.fround((Math.fround(this.m7.aA()) - Math.fround(this.pX.aA())));
});
$p.ahq = (function(comp) {
  var timeMills = ((Math.fround((comp - Math.fround(this.pX.aA()))) / this.Qf) + this.Ku);
  return new Date(timeMills);
});
$p.Mc = (function() {
  return this.a7Y.cH(this.a7X);
});
function $isArrayOf_Lcom_papasofokli_svg_timeline_TimeLineSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g2)));
}
var $d_Lcom_papasofokli_svg_timeline_TimeLineSVG = new $TypeData().i($c_Lcom_papasofokli_svg_timeline_TimeLineSVG, "com.papasofokli.svg.timeline.TimeLineSVG", ({
  g2: 1,
  aj: 1,
  bL: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Ljava_io_StringWriter() {
  this.KC = null;
  $ct_Ljava_io_Writer__(this);
  this.KC = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
}
$p = $c_Ljava_io_StringWriter.prototype = new $h_Ljava_io_Writer();
$p.constructor = $c_Ljava_io_StringWriter;
/** @constructor */
function $h_Ljava_io_StringWriter() {
}
$h_Ljava_io_StringWriter.prototype = $p;
$p.azC = (function(cbuf, off, len) {
  this.KC.aml(cbuf, off, len);
});
$p.amk = (function(csq) {
  this.KC.afE(csq);
  return this;
});
$p.g = (function() {
  return this.KC.g();
});
$p.Id = (function(csq) {
  return this.amk(csq);
});
var $d_Ljava_io_StringWriter = new $TypeData().i($c_Ljava_io_StringWriter, "java.io.StringWriter", ({
  ts: 1,
  tt: 1,
  bb: 1,
  bN: 1,
  bP: 1,
  bO: 1
}));
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().i($c_jl_ArrayIndexOutOfBoundsException, "java.lang.ArrayIndexOutOfBoundsException", ({
  tu: 1,
  gm: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Double__hashCode__I($thiz) {
  var valueInt = ($thiz | 0);
  if (((valueInt === $thiz) && ((1.0 / $thiz) !== (-Infinity)))) {
    return valueInt;
  } else if (($thiz !== $thiz)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, $thiz, true);
    return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
  }
}
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().zy($thiz, o);
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gj)));
}
var $d_jl_Double = new $TypeData().i(0, "java.lang.Double", ({
  gj: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1,
  bk: 1
}), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $thiz;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    return ((fpBitsDataView.getInt32(0, true) | 0) ^ (fpBitsDataView.getInt32(4, true) | 0));
  }
}
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().zy($thiz, o);
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gk)));
}
var $d_jl_Float = new $TypeData().i(0, "java.lang.Float", ({
  gk: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1,
  bk: 1
}), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : (($thiz < o) ? (-1) : 1));
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gn)));
}
var $d_jl_Integer = new $TypeData().i(0, "java.lang.Integer", ({
  gn: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1,
  bk: 1
}), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, $thizhi, that) {
  if ((that instanceof $Long)) {
    var $x_1 = that;
    var this$1_$_lo = $x_1.l;
    var this$1_$_hi = $x_1.h;
    return ((($thiz ^ this$1_$_lo) | ($thizhi ^ this$1_$_hi)) === 0);
  } else {
    return false;
  }
}
function $f_jl_Long__hashCode__I($thiz, $thizhi) {
  return ($thiz ^ $thizhi);
}
function $f_jl_Long__toString__T($thiz, $thizhi) {
  return $m_RTLong$().gc($thiz, $thizhi);
}
function $f_jl_Long__compareTo__O__I($thiz, $thizhi, o) {
  var $x_1 = o;
  var this$1_$_lo = $x_1.l;
  var this$1_$_hi = $x_1.h;
  return (($thizhi === this$1_$_hi) ? (($thiz === this$1_$_lo) ? 0 : ((($thiz >>> 0) < (this$1_$_lo >>> 0)) ? (-1) : 1)) : (($thizhi < this$1_$_hi) ? (-1) : 1));
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.go)));
}
var $d_jl_Long = new $TypeData().i(0, "java.lang.Long", ({
  go: 1,
  aA: 1,
  a: 1,
  N: 1,
  aJ: 1,
  bk: 1
}), ((x) => (x instanceof $Long)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gp)));
}
var $d_jl_NumberFormatException = new $TypeData().i($c_jl_NumberFormatException, "java.lang.NumberFormatException", ({
  gp: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $f_T__length__I($thiz) {
  return $thiz.length;
}
function $f_T__charAt__I__C($thiz, index) {
  return $thiz.charCodeAt(index);
}
function $f_T__codePointAt__I__I($thiz, index) {
  return ($thiz.codePointAt(index) | 0);
}
function $f_T__hashCode__I($thiz) {
  var n = $thiz.length;
  var h = 0;
  var i = 0;
  while ((i !== n)) {
    h = (((((h << 5) - h) | 0) + $thiz.charCodeAt(i)) | 0);
    i = ((1 + i) | 0);
  }
  return h;
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var strLength = anotherString.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var cmp = (($thiz.charCodeAt(i) - anotherString.charCodeAt(i)) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__compareToIgnoreCase__T__I($thiz, str) {
  var thisLength = $thiz.length;
  var strLength = str.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var thisCP = $f_T__codePointAt__I__I($thiz, i);
    var cmp = (($m_jl_Character$().br($m_jl_Character$().bs(thisCP)) - $m_jl_Character$().br($m_jl_Character$().bs($f_T__codePointAt__I__I(str, i)))) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    dst.a[((i + offset) | 0)] = $thiz.charCodeAt(i);
    i = ((1 + i) | 0);
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().EF(ch);
  return ($thiz.indexOf(str) | 0);
}
function $f_T__indexOf__I__I__I($thiz, ch, fromIndex) {
  var str = $m_jl_Character$().EF(ch);
  return ($thiz.indexOf(str, fromIndex) | 0);
}
function $f_T__lastIndexOf__I__I__I($thiz, ch, fromIndex) {
  if ((fromIndex < 0)) {
    return (-1);
  } else {
    var str = $m_jl_Character$().EF(ch);
    return ((fromIndex < 0) ? (-1) : ($thiz.lastIndexOf(str, fromIndex) | 0));
  }
}
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  } else {
    return $thiz.repeat(count);
  }
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  return new $c_ju_regex_Matcher($m_ju_regex_PatternCompiler$().Mp(regex, 0), $thiz).ajn(replacement);
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  return $m_ju_regex_PatternCompiler$().Mp(regex, 0).avT($thiz, limit);
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  return $thiz.substring(beginIndex, endIndex);
}
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    result.a[i] = $thiz.charCodeAt(i);
    i = ((1 + i) | 0);
  }
  return result;
}
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (((start !== len) && ($thiz.charCodeAt(start) <= 32))) {
    start = ((1 + start) | 0);
  }
  if ((start === len)) {
    return "";
  } else {
    var end = len;
    while (($thiz.charCodeAt(((end - 1) | 0)) <= 32)) {
      end = ((end - 1) | 0);
    }
    if (((start | (end ^ len)) === 0)) {
      return $thiz;
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $thiz.substring(beginIndex, endIndex);
    }
  }
}
function $f_T__strip__T($thiz) {
  var len = $thiz.length;
  var leading = 0;
  while (((leading < len) && $m_jl_UnicodeData$().UO($thiz.charCodeAt(leading)))) {
    leading = ((1 + leading) | 0);
  }
  if ((leading === len)) {
    return "";
  } else {
    var trailing = len;
    while ($m_jl_UnicodeData$().UO($thiz.charCodeAt(((trailing - 1) | 0)))) {
      trailing = ((trailing - 1) | 0);
    }
    if (((leading | (trailing ^ len)) === 0)) {
      return $thiz;
    } else {
      var beginIndex = leading;
      var endIndex = trailing;
      return $thiz.substring(beginIndex, endIndex);
    }
  }
}
function $f_T__isBlank__Z($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (((start !== len) && $m_jl_UnicodeData$().UO($thiz.charCodeAt(start)))) {
    start = ((1 + start) | 0);
  }
  return (start === len);
}
function $f_T__toString__T($thiz) {
  return $thiz;
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, o);
}
var $d_T = new $TypeData().i(0, "java.lang.String", ({
  tQ: 1,
  a: 1,
  N: 1,
  aO: 1,
  aJ: 1,
  bk: 1
}), ((x) => ((typeof x) === "string")));
function $ct_Ljava_nio_CharBuffer__I__AC__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.hs = _array;
  $thiz.iY = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_CharBuffer() {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
  this.hs = null;
  this.iY = 0;
}
$p = $c_Ljava_nio_CharBuffer.prototype = new $h_Ljava_nio_Buffer();
$p.constructor = $c_Ljava_nio_CharBuffer;
/** @constructor */
function $h_Ljava_nio_CharBuffer() {
}
$h_Ljava_nio_CharBuffer.prototype = $p;
$p.ajh = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.IQ()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var srcLimit = src.bF;
  var srcPos = src.b5;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.b5;
  var newPos = ((p + length) | 0);
  if ((newPos > this.bF)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b5 = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.eA.call(src, srcLimit);
  var srcArray = src.hs;
  if ((srcArray !== null)) {
    this.ajZ(selfPos, srcArray, ((src.iY + srcPos) | 0), length);
  } else {
    while ((srcPos !== srcLimit)) {
      this.ajY(selfPos, src.IW(srcPos));
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$p.ajg = (function(src, start, end) {
  return this.ajh($m_Ljava_nio_CharBuffer$().azz(src, start, end));
});
$p.r = (function() {
  var start = this.b5;
  var end = this.bF;
  var h = (-182887236);
  var i = start;
  while ((i !== end)) {
    h = $m_ju_internal_MurmurHash3$().d(h, this.IW(i));
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().an(h, ((end - start) | 0));
});
$p.b = (function(that) {
  return ((that instanceof $c_Ljava_nio_CharBuffer) && (this.agb(that) === 0));
});
$p.agb = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.b5;
    var thisRemaining = ((this.bF - thisStart) | 0);
    var thatStart = that.b5;
    var thatRemaining = ((that.bF - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var t = this.IW(((thisStart + i) | 0));
      var u = that.IW(((thatStart + i) | 0));
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$p.g = (function() {
  if ((this.hs !== null)) {
    return $m_jl_String$().hg(this.hs, ((this.b5 + this.iY) | 0), ((this.bF - this.b5) | 0));
  } else {
    var chars = new $ac_C(((this.bF - this.b5) | 0));
    var savedPos = this.b5;
    this.ahn(chars, 0, chars.a.length);
    $c_Ljava_nio_Buffer.prototype.eA.call(this, savedPos);
    return $m_jl_String$().hg(chars, 0, chars.a.length);
  }
});
$p.F = (function() {
  return ((this.bF - this.b5) | 0);
});
$p.qD = (function(index) {
  return this.ahm(((this.b5 + index) | 0));
});
$p.Id = (function(csq) {
  var src = $dp_toString__T(csq);
  return this.ajg(src, 0, src.length);
});
$p.jl = (function(o) {
  return this.agb(o);
});
function $isArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cq)));
}
class $c_Ljava_nio_ReadOnlyBufferException extends $c_jl_UnsupportedOperationException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().i($c_Ljava_nio_ReadOnlyBufferException, "java.nio.ReadOnlyBufferException", ({
  ug: 1,
  gt: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_Ljava_nio_charset_MalformedInputException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.a9u = 0;
    this.a9u = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ("Input length = " + this.a9u);
  }
}
var $d_Ljava_nio_charset_MalformedInputException = new $TypeData().i($c_Ljava_nio_charset_MalformedInputException, "java.nio.charset.MalformedInputException", ({
  up: 1,
  gC: 1,
  cn: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_Ljava_nio_charset_UnmappableCharacterException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.a9v = 0;
    this.a9v = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ("Input length = " + this.a9v);
  }
}
var $d_Ljava_nio_charset_UnmappableCharacterException = new $TypeData().i($c_Ljava_nio_charset_UnmappableCharacterException, "java.nio.charset.UnmappableCharacterException", ({
  us: 1,
  gC: 1,
  cn: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_ju_FormatterClosedException = new $TypeData().i($c_ju_FormatterClosedException, "java.util.FormatterClosedException", ({
  uJ: 1,
  gl: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.KT = null;
  this.KT = outer;
}
$p = $c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$p.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
$h_ju_HashMap$EntrySet.prototype = $p;
$p.zN = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this.KT);
});
$p.aH = (function() {
  return this.KT.nX;
});
$p.az = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var this$1 = this.KT;
    var key = o.me;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$1.US(key, hash, (hash & ((this$1.i8.a.length - 1) | 0)));
    if ((node !== null)) {
      var a = node.ht;
      var b = o.ht;
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().i($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  uL: 1,
  ux: 1,
  uv: 1,
  cr: 1,
  tE: 1,
  v1: 1
}));
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.aa7 = null;
    this.aa9 = null;
    this.aa8 = 0;
    this.aa7 = desc;
    this.aa9 = regex;
    this.aa8 = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    var idx = this.aa8;
    var re = this.aa9;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.aa7 + indexHint) + "\n") + re);
    return ((((idx >= 0) && (re !== null)) && (idx < re.length)) ? (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^") : base);
  }
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().i($c_ju_regex_PatternSyntaxException, "java.util.regex.PatternSyntaxException", ({
  vt: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_s_Enumeration$ValueOrdering$() {
}
$p = $c_s_Enumeration$ValueOrdering$.prototype = new $h_O();
$p.constructor = $c_s_Enumeration$ValueOrdering$;
/** @constructor */
function $h_s_Enumeration$ValueOrdering$() {
}
$h_s_Enumeration$ValueOrdering$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return x.TZ(y);
});
var $d_s_Enumeration$ValueOrdering$ = new $TypeData().i($c_s_Enumeration$ValueOrdering$, "scala.Enumeration$ValueOrdering$", ({
  vN: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1
}));
/** @constructor */
function $c_s_None$() {
}
$p = $c_s_None$.prototype = new $h_s_Option();
$p.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
}
$h_s_None$.prototype = $p;
$p.r = (function() {
  return 2433880;
});
$p.g = (function() {
  return "None";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "None";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.aa = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get");
});
$p.h = (function() {
  this.aa();
});
var $d_s_None$ = new $TypeData().i($c_s_None$, "scala.None$", ({
  vW: 1,
  gJ: 1,
  h: 1,
  b: 1,
  c: 1,
  a: 1
}));
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$();
  }
  return $n_s_None$;
}
/** @constructor */
function $c_s_Some(value) {
  this.bg = null;
  this.bg = value;
}
$p = $c_s_Some.prototype = new $h_s_Option();
$p.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
}
$h_s_Some.prototype = $p;
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1323286827, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_s_Some) && $m_sr_BoxesRunTime$().B(this.bg, x$0.bg)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Some";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.bg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.h = (function() {
  return this.bg;
});
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.gK)));
}
var $d_s_Some = new $TypeData().i($c_s_Some, "scala.Some", ({
  gK: 1,
  gJ: 1,
  h: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_sc_AbstractIterable() {
}
$p = $c_sc_AbstractIterable.prototype = new $h_O();
$p.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
}
$h_sc_AbstractIterable.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.g8 = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.fK = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.MD = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.aH = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.d0 = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.TM = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.uF = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().aY(this);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$1) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$1);
});
$p.eB = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$p.W = (function() {
  return this.l().e();
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.Ns = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.fu = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.ak = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_IterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.X = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return this.aL(asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.uI = (function(asPair) {
  return $f_sc_IterableOps__unzip__F1__T2(this, asPair);
});
$p.mF = (function(coll) {
  return this.b4().bp(coll);
});
$p.dw = (function() {
  return this.b4().aP();
});
$p.b4 = (function() {
  return $m_sc_Iterable$();
});
$p.eH = (function() {
  return this.c8();
});
$p.c8 = (function() {
  return "Iterable";
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.de = (function(coll) {
  return this.mF(coll);
});
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator(xs) {
  this.L5 = null;
  this.q5 = 0;
  this.GB = 0;
  this.L5 = xs;
  this.q5 = 0;
  this.GB = $m_jl_reflect_Array$().b1(this.L5);
}
$p = $c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
}
$h_sc_ArrayOps$ArrayIterator.prototype = $p;
$p.G = (function() {
  return ((this.GB - this.q5) | 0);
});
$p.f = (function() {
  return (this.q5 < this.GB);
});
$p.e = (function() {
  if ((this.q5 >= $m_jl_reflect_Array$().b1(this.L5))) {
    $m_sc_Iterator$().aZ.e();
  }
  var r = $m_sr_ScalaRunTime$().cZ(this.L5, this.q5);
  this.q5 = ((1 + this.q5) | 0);
  return r;
});
$p.ex = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.q5 + n) | 0);
    if ((newPos < 0)) {
      var $x_1 = this.GB;
    } else {
      var a = this.GB;
      var $x_1 = ((a < newPos) ? a : newPos);
    }
    this.q5 = $x_1;
  }
  return this;
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().i($c_sc_ArrayOps$ArrayIterator, "scala.collection.ArrayOps$ArrayIterator", ({
  we: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.Rt = self;
  $thiz.q6 = 0;
  $thiz.eY = self.F();
  return $thiz;
}
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.eY) ? $thiz.eY : value));
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.Rt = null;
  this.q6 = 0;
  this.eY = 0;
}
$p = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $p;
$p.G = (function() {
  return this.eY;
});
$p.f = (function() {
  return (this.eY > 0);
});
$p.e = (function() {
  if ((this.eY > 0)) {
    var r = this.Rt.at(this.q6);
    this.q6 = ((1 + this.q6) | 0);
    this.eY = ((this.eY - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
$p.ex = (function(n) {
  if ((n > 0)) {
    this.q6 = ((this.q6 + n) | 0);
    var b = ((this.eY - n) | 0);
    this.eY = ((b < 0) ? 0 : b);
  }
  return this;
});
$p.mL = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.eY = ((b < 0) ? 0 : b);
  this.q6 = ((this.q6 + formatFrom) | 0);
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().i($c_sc_IndexedSeqView$IndexedSeqViewIterator, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", ({
  gV: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.Ru = self;
  $thiz.fx = self.F();
  $thiz.yc = (($thiz.fx - 1) | 0);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.Ru = null;
  this.fx = 0;
  this.yc = 0;
}
$p = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $p;
$p.f = (function() {
  return (this.fx > 0);
});
$p.e = (function() {
  if ((this.fx > 0)) {
    var r = this.Ru.at(this.yc);
    this.yc = ((this.yc - 1) | 0);
    this.fx = ((this.fx - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
$p.mL = (function(from, until) {
  if ((this.fx > 0)) {
    if ((this.fx <= from)) {
      this.fx = 0;
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.fx))) {
        this.fx = until;
      }
    } else {
      this.yc = ((this.yc - from) | 0);
      if (((until >= 0) && (until < this.fx))) {
        if ((until <= from)) {
          this.fx = 0;
        } else {
          this.fx = ((until - from) | 0);
        }
      } else {
        this.fx = ((this.fx - from) | 0);
      }
    }
  }
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().i($c_sc_IndexedSeqView$IndexedSeqViewReverseIterator, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", ({
  gW: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.Hd = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().aZ);
}
$p = $c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$p.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
}
$h_sc_Iterator$$anon$21.prototype = $p;
$p.am2 = (function(elem) {
  this.Hd = this.Hd.kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$$anon$20(elem))));
  return this;
});
$p.aD = (function(elem) {
  return this.am2(elem);
});
var $d_sc_Iterator$$anon$21 = new $TypeData().i($c_sc_Iterator$$anon$21, "scala.collection.Iterator$$anon$21", ({
  wF: 1,
  zf: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$7(pf$2, outer) {
  this.aaq = null;
  this.aap = null;
  this.CI = 0;
  this.Rz = null;
  this.aaq = pf$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Rz = outer;
  this.CI = 0;
}
$p = $c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
}
$h_sc_Iterator$$anon$7.prototype = $p;
$p.g = (function() {
  return "<function1>";
});
$p.hK = (function(x$0) {
});
$p.p = (function(value) {
  return $m_sr_Statics$PFMarker$();
});
$p.f = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.CI === 0)) {
    if (this.Rz.f()) {
      var x = this.Rz.e();
      var v = this.aaq.aJ(x, this);
      if ((marker !== v)) {
        this.aap = v;
        this.CI = 1;
      }
    } else {
      this.CI = (-1);
    }
  }
  return (this.CI === 1);
});
$p.e = (function() {
  if (this.f()) {
    this.CI = 0;
    return this.aap;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().i($c_sc_Iterator$$anon$7, "scala.collection.Iterator$$anon$7", ({
  wK: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  p: 1
}));
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x5 = $thiz.b9(key);
  if ((x5 instanceof $c_s_Some)) {
    return x5.bg;
  }
  if (($m_s_None$() === x5)) {
    return default$1.aA();
  }
  throw new $c_s_MatchError(x5);
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x8 = $thiz.b9(key);
  if (($m_s_None$() === x8)) {
    return $thiz.Ix(key);
  }
  if ((x8 instanceof $c_s_Some)) {
    return x8.bg;
  }
  throw new $c_s_MatchError(x8);
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.f6(x, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => default$1.p(x))));
}
function $f_sc_MapOps__keySet__sc_Set($thiz) {
  return ($is_sc_SeqMap($thiz) ? $ct_sc_MapOps$LazyKeySet__sc_MapOps__(new $c_sc_MapOps$LazyKeySet(), $thiz) : ($is_sc_SortedMap($thiz) ? $ct_sc_MapOps$LazyKeySet__sc_MapOps__(new $c_sc_MapOps$LazyKeySet(), $thiz) : ($is_sci_MapOps($thiz) ? $ct_sc_MapOps$LazyKeySet__sc_MapOps__(new $c_sc_MapOps$LazyKeySet(), $thiz) : ($is_scm_MapOps($thiz) ? $ct_sc_MapOps$LazyKeySet__sc_MapOps__(new $c_sc_MapOps$LazyKeySet(), $thiz) : new $c_sc_MapOps$StrictKeySet($thiz)))));
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.l();
  while (it.f()) {
    var next = it.e();
    f.cm(next.P(), next.V());
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  return (!$thiz.b9(key).c());
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(new $c_sc_Iterator$$anon$9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var k = x$1$2.P();
    var v = x$1$2.V();
    return ((k + " -> ") + v);
  })), $thiz.l()), sb, start, sep, end);
}
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.dw();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.l();
  while (it.f()) {
    var next = it.e();
    if (seen.qA(f.p(next))) {
      builder.aD(next);
    }
  }
  return builder.aR();
}
function $f_sc_StrictOptimizedSeqOps__prepended__O__O($thiz, elem) {
  var b = $thiz.hM().aP();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.aD(elem);
  b.cz($thiz);
  return b.aR();
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $thiz.hM().aP();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.cz($thiz);
  b.aD(elem);
  return b.aR();
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.hM().aP();
  b.cz($thiz);
  b.cz(suffix);
  return b.aR();
}
function $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O($thiz, prefix) {
  var b = $thiz.hM().aP();
  b.cz(prefix);
  b.cz($thiz);
  return b.aR();
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.aaW)) {
    $thiz.aaV = new $c_sci_ArraySeq$ofRef(new ($d_sr_Nothing$.r().C)(0));
    $thiz.aaW = true;
  }
  return $thiz.aaV;
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.Lw = null;
  this.aaV = null;
  this.aaW = false;
  $n_sci_ArraySeq$ = this;
  this.Lw = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
}
$p = $c_sci_ArraySeq$.prototype = new $h_O();
$p.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
}
$h_sci_ArraySeq$.prototype = $p;
$p.Uo = (function(it, tag) {
  return ((it instanceof $c_sci_ArraySeq) ? it : this.ge($m_s_Array$().aha(it, tag)));
});
$p.Nb = (function(evidence$1) {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2) => this.ge($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(b$2, evidence$1)))), ($m_scm_ArrayBuffer$(), new $c_scm_ArrayBuffer$$anon$1()));
});
$p.ge = (function(x) {
  if ((x === null)) {
    return null;
  }
  if ((x instanceof $ac_O)) {
    return new $c_sci_ArraySeq$ofRef(x);
  }
  if ((x instanceof $ac_I)) {
    return new $c_sci_ArraySeq$ofInt(x);
  }
  if ((x instanceof $ac_D)) {
    return new $c_sci_ArraySeq$ofDouble(x);
  }
  if ((x instanceof $ac_J)) {
    return new $c_sci_ArraySeq$ofLong(x);
  }
  if ((x instanceof $ac_F)) {
    return new $c_sci_ArraySeq$ofFloat(x);
  }
  if ((x instanceof $ac_C)) {
    return new $c_sci_ArraySeq$ofChar(x);
  }
  if ((x instanceof $ac_B)) {
    return new $c_sci_ArraySeq$ofByte(x);
  }
  if ((x instanceof $ac_S)) {
    return new $c_sci_ArraySeq$ofShort(x);
  }
  if ((x instanceof $ac_Z)) {
    return new $c_sci_ArraySeq$ofBoolean(x);
  }
  if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_sci_ArraySeq$ofUnit(x);
  }
  throw new $c_s_MatchError(x);
});
$p.agJ = (function(evidence$1) {
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this);
});
$p.Un = (function(it, evidence$1) {
  return this.Uo(it, evidence$1);
});
var $d_sci_ArraySeq$ = new $TypeData().i($c_sci_ArraySeq$, "scala.collection.immutable.ArraySeq$", ({
  xs: 1,
  a: 1,
  gR: 1,
  gP: 1,
  gQ: 1,
  h5: 1
}));
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$();
  }
  return $n_sci_ArraySeq$;
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(hm$1, outer) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_ChampBaseIterator__sci_Node__(this, hm$1.dM);
  while (this.f()) {
    var originalHash = this.g0.d1(this.cE);
    outer.EG(outer.o7, this.g0.jr(this.cE), this.g0.ip(this.cE), originalHash, $m_sc_Hashing$().bV(originalHash), 0);
    this.cE = ((1 + this.cE) | 0);
  }
}
$p = $c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
}
$h_sci_HashMapBuilder$$anon$1.prototype = $p;
$p.e = (function() {
  return $m_sc_Iterator$().aZ.e();
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().i($c_sci_HashMapBuilder$$anon$1, "scala.collection.immutable.HashMapBuilder$$anon$1", ({
  xz: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(hm$1, outer) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_ChampBaseIterator__sci_Node__(this, hm$1.dz);
  while (this.f()) {
    var originalHash = this.g0.d1(this.cE);
    outer.VK(outer.yt, this.g0.dJ(this.cE), originalHash, $m_sc_Hashing$().bV(originalHash), 0);
    this.cE = ((1 + this.cE) | 0);
  }
}
$p = $c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
}
$h_sci_HashSetBuilder$$anon$1.prototype = $p;
$p.e = (function() {
  return $m_sc_Iterator$().aZ.e();
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().i($c_sci_HashSetBuilder$$anon$1, "scala.collection.immutable.HashSetBuilder$$anon$1", ({
  xC: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.G)));
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.G)));
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.o9 = 0;
  this.tv = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
}
$h_sci_Map$Map2$$anon$1.prototype = $p;
$p.gK = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().i($c_sci_Map$Map2$$anon$1, "scala.collection.immutable.Map$Map2$$anon$1", ({
  xV: 1,
  cK: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.o9 = 0;
  this.tv = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
}
$h_sci_Map$Map2$$anon$2.prototype = $p;
$p.gK = (function(k, v) {
  return k;
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().i($c_sci_Map$Map2$$anon$2, "scala.collection.immutable.Map$Map2$$anon$2", ({
  xW: 1,
  cK: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.o9 = 0;
  this.tv = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$p = $c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$p.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
}
$h_sci_Map$Map2$$anon$3.prototype = $p;
$p.gK = (function(k, v) {
  return v;
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().i($c_sci_Map$Map2$$anon$3, "scala.collection.immutable.Map$Map2$$anon$3", ({
  xX: 1,
  cK: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.ob = 0;
  this.oa = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
}
$h_sci_Map$Map3$$anon$4.prototype = $p;
$p.gK = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().i($c_sci_Map$Map3$$anon$4, "scala.collection.immutable.Map$Map3$$anon$4", ({
  xY: 1,
  cL: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.ob = 0;
  this.oa = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
}
$h_sci_Map$Map3$$anon$5.prototype = $p;
$p.gK = (function(k, v) {
  return k;
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().i($c_sci_Map$Map3$$anon$5, "scala.collection.immutable.Map$Map3$$anon$5", ({
  xZ: 1,
  cL: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.ob = 0;
  this.oa = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$p = $c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$p.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
}
$h_sci_Map$Map3$$anon$6.prototype = $p;
$p.gK = (function(k, v) {
  return v;
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().i($c_sci_Map$Map3$$anon$6, "scala.collection.immutable.Map$Map3$$anon$6", ({
  y0: 1,
  cL: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.oc = 0;
  this.kt = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
}
$h_sci_Map$Map4$$anon$7.prototype = $p;
$p.gK = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().i($c_sci_Map$Map4$$anon$7, "scala.collection.immutable.Map$Map4$$anon$7", ({
  y1: 1,
  cM: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.oc = 0;
  this.kt = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
}
$h_sci_Map$Map4$$anon$8.prototype = $p;
$p.gK = (function(k, v) {
  return k;
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().i($c_sci_Map$Map4$$anon$8, "scala.collection.immutable.Map$Map4$$anon$8", ({
  y2: 1,
  cM: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.oc = 0;
  this.kt = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$p = $c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$p.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
}
$h_sci_Map$Map4$$anon$9.prototype = $p;
$p.gK = (function(k, v) {
  return v;
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().i($c_sci_Map$Map4$$anon$9, "scala.collection.immutable.Map$Map4$$anon$9", ({
  y3: 1,
  cM: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
}
$h_sci_MapKeyIterator.prototype = $p;
$p.e = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var key = this.g0.jr(this.cE);
  this.cE = ((1 + this.cE) | 0);
  return key;
});
var $d_sci_MapKeyIterator = new $TypeData().i($c_sci_MapKeyIterator, "scala.collection.immutable.MapKeyIterator", ({
  y6: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.h0 = 0;
  this.tu = null;
  this.hw = 0;
  this.yp = null;
  this.yq = null;
  this.RR = 0;
  this.ab0 = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.RR = 0;
}
$p = $c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $p;
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().akh(this.RR, $m_sr_Statics$().k(this.ab0), (-889275714));
});
$p.aws = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  this.RR = this.tu.d1(this.h0);
  this.ab0 = this.tu.ip(this.h0);
  this.h0 = ((this.h0 - 1) | 0);
  return this;
});
$p.e = (function() {
  return this.aws();
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().i($c_sci_MapKeyValueTupleHashIterator, "scala.collection.immutable.MapKeyValueTupleHashIterator", ({
  y7: 1,
  cG: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
}
$h_sci_MapKeyValueTupleIterator.prototype = $p;
$p.kS = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var payload = this.g0.zI(this.cE);
  this.cE = ((1 + this.cE) | 0);
  return payload;
});
$p.e = (function() {
  return this.kS();
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().i($c_sci_MapKeyValueTupleIterator, "scala.collection.immutable.MapKeyValueTupleIterator", ({
  y8: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleReverseIterator(rootNode) {
  this.h0 = 0;
  this.tu = null;
  this.hw = 0;
  this.yp = null;
  this.yq = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapKeyValueTupleReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_MapKeyValueTupleReverseIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleReverseIterator() {
}
$h_sci_MapKeyValueTupleReverseIterator.prototype = $p;
$p.kS = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var payload = this.tu.zI(this.h0);
  this.h0 = ((this.h0 - 1) | 0);
  return payload;
});
$p.e = (function() {
  return this.kS();
});
var $d_sci_MapKeyValueTupleReverseIterator = new $TypeData().i($c_sci_MapKeyValueTupleReverseIterator, "scala.collection.immutable.MapKeyValueTupleReverseIterator", ({
  y9: 1,
  cG: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
}
$h_sci_MapValueIterator.prototype = $p;
$p.e = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var value = this.g0.ip(this.cE);
  this.cE = ((1 + this.cE) | 0);
  return value;
});
var $d_sci_MapValueIterator = new $TypeData().i($c_sci_MapValueIterator, "scala.collection.immutable.MapValueIterator", ({
  yb: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.fi <= $thiz.er)) {
    $m_sc_Iterator$().aZ.e();
  }
  $thiz.ty = ((1 + $thiz.ty) | 0);
  var slice = $thiz.RU.mQ($thiz.ty);
  while ((slice.a.length === 0)) {
    $thiz.ty = ((1 + $thiz.ty) | 0);
    slice = $thiz.RU.mQ($thiz.ty);
  }
  $thiz.H5 = $thiz.qb;
  var count = $thiz.ab1;
  var idx = $thiz.ty;
  var c = (((count + ((count >>> 31) | 0)) | 0) >> 1);
  var a = ((idx - c) | 0);
  var sign = (a >> 31);
  $thiz.tx = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
  var x46 = $thiz.tx;
  switch (x46) {
    case 1: {
      $thiz.fC = slice;
      break;
    }
    case 2: {
      $thiz.fD = slice;
      break;
    }
    case 3: {
      $thiz.hA = slice;
      break;
    }
    case 4: {
      $thiz.ml = slice;
      break;
    }
    case 5: {
      $thiz.yv = slice;
      break;
    }
    case 6: {
      $thiz.RT = slice;
      break;
    }
    default: {
      throw new $c_s_MatchError(x46);
    }
  }
  $thiz.qb = (($thiz.H5 + Math.imul(slice.a.length, (1 << Math.imul(5, (($thiz.tx - 1) | 0))))) | 0);
  if (($thiz.qb > $thiz.j6)) {
    $thiz.qb = $thiz.j6;
  }
  if (($thiz.tx > 1)) {
    $thiz.CZ = (((1 << Math.imul(5, $thiz.tx)) - 1) | 0);
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.er - $thiz.fi) | 0) + $thiz.j6) | 0);
  if ((pos === $thiz.qb)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz);
  }
  if (($thiz.tx > 1)) {
    var io = ((pos - $thiz.H5) | 0);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, ($thiz.CZ ^ io));
    $thiz.CZ = io;
  }
  $thiz.fi = (($thiz.fi - $thiz.er) | 0);
  var a = $thiz.fC.a.length;
  var b = $thiz.fi;
  $thiz.mk = ((a < b) ? a : b);
  $thiz.er = 0;
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.fD = $thiz.hA.a[(31 & ((io >>> 10) | 0))];
    $thiz.fC = $thiz.fD.a[0];
  } else if ((xor < 1048576)) {
    $thiz.hA = $thiz.ml.a[(31 & ((io >>> 15) | 0))];
    $thiz.fD = $thiz.hA.a[0];
    $thiz.fC = $thiz.fD.a[0];
  } else if ((xor < 33554432)) {
    $thiz.ml = $thiz.yv.a[(31 & ((io >>> 20) | 0))];
    $thiz.hA = $thiz.ml.a[0];
    $thiz.fD = $thiz.hA.a[0];
    $thiz.fC = $thiz.fD.a[0];
  } else {
    $thiz.yv = $thiz.RT.a[((io >>> 25) | 0)];
    $thiz.ml = $thiz.yv.a[0];
    $thiz.hA = $thiz.ml.a[0];
    $thiz.fD = $thiz.hA.a[0];
    $thiz.fC = $thiz.fD.a[0];
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.fD = $thiz.hA.a[(31 & ((io >>> 10) | 0))];
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 1048576)) {
    $thiz.hA = $thiz.ml.a[(31 & ((io >>> 15) | 0))];
    $thiz.fD = $thiz.hA.a[(31 & ((io >>> 10) | 0))];
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 33554432)) {
    $thiz.ml = $thiz.yv.a[(31 & ((io >>> 20) | 0))];
    $thiz.hA = $thiz.ml.a[(31 & ((io >>> 15) | 0))];
    $thiz.fD = $thiz.hA.a[(31 & ((io >>> 10) | 0))];
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  } else {
    $thiz.yv = $thiz.RT.a[((io >>> 25) | 0)];
    $thiz.ml = $thiz.yv.a[(31 & ((io >>> 20) | 0))];
    $thiz.hA = $thiz.ml.a[(31 & ((io >>> 15) | 0))];
    $thiz.fD = $thiz.hA.a[(31 & ((io >>> 10) | 0))];
    $thiz.fC = $thiz.fD.a[(31 & ((io >>> 5) | 0))];
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.RU = null;
  this.j6 = 0;
  this.ab1 = 0;
  this.fC = null;
  this.fD = null;
  this.hA = null;
  this.ml = null;
  this.yv = null;
  this.RT = null;
  this.mk = 0;
  this.er = 0;
  this.CZ = 0;
  this.fi = 0;
  this.ty = 0;
  this.tx = 0;
  this.H5 = 0;
  this.qb = 0;
  this.RU = v;
  this.j6 = totalLength;
  this.ab1 = sliceCount;
  this.fC = v.R;
  this.mk = this.fC.a.length;
  this.er = 0;
  this.CZ = 0;
  this.fi = this.j6;
  this.ty = 0;
  this.tx = 1;
  this.H5 = 0;
  this.qb = this.mk;
}
$p = $c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
}
$h_sci_NewVectorIterator.prototype = $p;
$p.G = (function() {
  return ((this.fi - this.er) | 0);
});
$p.f = (function() {
  return (this.fi > this.er);
});
$p.e = (function() {
  if ((this.er === this.mk)) {
    $p_sci_NewVectorIterator__advance__V(this);
  }
  var r = this.fC.a[this.er];
  this.er = ((1 + this.er) | 0);
  return r;
});
$p.ex = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.er - this.fi) | 0) + this.j6) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.j6;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.j6)) {
      this.er = 0;
      this.fi = 0;
      this.mk = 0;
    } else {
      while ((newpos >= this.qb)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this);
      }
      var io = ((newpos - this.H5) | 0);
      if ((this.tx > 1)) {
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, (this.CZ ^ io));
        this.CZ = io;
      }
      this.mk = this.fC.a.length;
      this.er = (31 & io);
      this.fi = ((this.er + ((this.j6 - newpos) | 0)) | 0);
      if ((this.mk > this.fi)) {
        this.mk = this.fi;
      }
    }
  }
  return this;
});
$p.EE = (function(n) {
  if ((n < ((this.fi - this.er) | 0))) {
    var trunc = ((((this.fi - this.er) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.j6 = ((this.j6 - trunc) | 0);
    this.fi = ((this.fi - trunc) | 0);
    if ((this.fi < this.mk)) {
      this.mk = this.fi;
    }
    if ((this.j6 < this.qb)) {
      this.qb = this.j6;
    }
  }
  return this;
});
$p.EA = (function(from, until) {
  var _until = ((until > 0) ? until : 0);
  return this.EE(((from > 0) ? (this.ex(from), ((_until - from) | 0)) : _until));
});
$p.d0 = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().b1(xs);
  var srcLen = ((this.fi - this.er) | 0);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? xsLen : ((xsLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var total$1 = ((total < 0) ? 0 : total);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total$1)) {
    if ((this.er === this.mk)) {
      $p_sci_NewVectorIterator__advance__V(this);
    }
    var a = ((total$1 - copied) | 0);
    var b = ((this.fC.a.length - this.er) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.fC;
      var srcPos = this.er;
      var destPos = ((start + copied) | 0);
      src.av(srcPos, xs, destPos, count);
    } else {
      $m_s_Array$().dd(this.fC, this.er, xs, ((start + copied) | 0), count);
    }
    this.er = ((this.er + count) | 0);
    copied = ((copied + count) | 0);
  }
  return total$1;
});
var $d_sci_NewVectorIterator = new $TypeData().i($c_sci_NewVectorIterator, "scala.collection.immutable.NewVectorIterator", ({
  yc: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  P: 1
}));
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.D0 = 0;
  this.yx = 0;
  this.gu = false;
  this.yw = 0;
  this.D0 = step;
  this.yx = lastElement;
  this.gu = (!initiallyEmpty);
  this.yw = start;
}
$p = $c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
}
$h_sci_RangeIterator.prototype = $p;
$p.G = (function() {
  return (this.gu ? ((1 + ((((this.yx - this.yw) | 0) / $checkIntDivisor(this.D0)) | 0)) | 0) : 0);
});
$p.f = (function() {
  return this.gu;
});
$p.jx = (function() {
  if ((!this.gu)) {
    $m_sc_Iterator$().aZ.e();
  }
  var value = this.yw;
  this.gu = (value !== this.yx);
  this.yw = ((value + this.D0) | 0);
  return value;
});
$p.ex = (function(n) {
  if ((n > 0)) {
    var value = this.yw;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.D0, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((hi + hi$1) | 0) + (((lo >>> 0) < (value >>> 0)) | 0)) | 0);
    if ((this.D0 > 0)) {
      var x = this.yx;
      var hi$3 = (x >> 31);
      if (((hi$3 === hi$2) ? ((x >>> 0) < (lo >>> 0)) : (hi$3 < hi$2))) {
        var $x_1_$_lo = x;
        var $x_1_$_hi = hi$3;
      } else {
        var $x_1_$_lo = lo;
        var $x_1_$_hi = hi$2;
      }
      this.yw = $x_1_$_lo;
      var value$2 = this.yx;
      var hi$4 = (value$2 >> 31);
      this.gu = ((hi$2 === hi$4) ? ((lo >>> 0) <= (value$2 >>> 0)) : (hi$2 < hi$4));
    } else if ((this.D0 < 0)) {
      var x$2 = this.yx;
      var hi$5 = (x$2 >> 31);
      if (((hi$5 === hi$2) ? ((x$2 >>> 0) > (lo >>> 0)) : (hi$5 > hi$2))) {
        var $x_2_$_lo = x$2;
        var $x_2_$_hi = hi$5;
      } else {
        var $x_2_$_lo = lo;
        var $x_2_$_hi = hi$2;
      }
      this.yw = $x_2_$_lo;
      var value$3 = this.yx;
      var hi$6 = (value$3 >> 31);
      this.gu = ((hi$2 === hi$6) ? ((lo >>> 0) >= (value$3 >>> 0)) : (hi$2 > hi$6));
    }
  }
  return this;
});
$p.e = (function() {
  return this.jx();
});
var $d_sci_RangeIterator = new $TypeData().i($c_sci_RangeIterator, "scala.collection.immutable.RangeIterator", ({
  yi: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.qg = 0;
  $thiz.of = n;
  return $thiz;
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.qg = 0;
  this.of = 0;
}
$p = $c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$p.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
}
$h_sci_Set$SetNIterator.prototype = $p;
$p.G = (function() {
  return this.of;
});
$p.f = (function() {
  return (this.of > 0);
});
$p.e = (function() {
  if (this.f()) {
    var r = this.at(this.qg);
    this.qg = ((1 + this.qg) | 0);
    this.of = ((this.of - 1) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().aZ.e();
  }
});
$p.ex = (function(n) {
  if ((n > 0)) {
    this.qg = ((this.qg + n) | 0);
    var b = ((this.of - n) | 0);
    this.of = ((b < 0) ? 0 : b);
  }
  return this;
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  this.RV = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.RV = 0;
}
$p = $c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
}
$h_sci_SetHashIterator.prototype = $p;
$p.r = (function() {
  return this.RV;
});
$p.e = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  this.RV = this.g0.d1(this.cE);
  this.cE = ((1 + this.cE) | 0);
  return this;
});
var $d_sci_SetHashIterator = new $TypeData().i($c_sci_SetHashIterator, "scala.collection.immutable.SetHashIterator", ({
  yu: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.cE = 0;
  this.o4 = 0;
  this.g0 = null;
  this.fA = 0;
  this.ib = null;
  this.o5 = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$p.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
}
$h_sci_SetIterator.prototype = $p;
$p.e = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var payload = this.g0.dJ(this.cE);
  this.cE = ((1 + this.cE) | 0);
  return payload;
});
var $d_sci_SetIterator = new $TypeData().i($c_sci_SetIterator, "scala.collection.immutable.SetIterator", ({
  yv: 1,
  b6: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_sci_SetReverseIterator(rootNode) {
  this.h0 = 0;
  this.tu = null;
  this.hw = 0;
  this.yp = null;
  this.yq = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$p = $c_sci_SetReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$p.constructor = $c_sci_SetReverseIterator;
/** @constructor */
function $h_sci_SetReverseIterator() {
}
$h_sci_SetReverseIterator.prototype = $p;
$p.e = (function() {
  if ((!this.f())) {
    $m_sc_Iterator$().aZ.e();
  }
  var payload = this.tu.dJ(this.h0);
  this.h0 = ((this.h0 - 1) | 0);
  return payload;
});
var $d_sci_SetReverseIterator = new $TypeData().i($c_sci_SetReverseIterator, "scala.collection.immutable.SetReverseIterator", ({
  yx: 1,
  cG: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.S0 = 0;
  $thiz.ab9 = 0;
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.S0 = 0;
  this.ab9 = 0;
}
$p = $c_scm_ArrayBuilder.prototype = new $h_O();
$p.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
}
$h_scm_ArrayBuilder.prototype = $p;
$p.dk = (function(size) {
  if ((this.S0 < size)) {
    this.axi(size);
  }
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.S3 = null;
  this.S2 = null;
  $n_scm_ArraySeq$ = this;
  this.S3 = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.S2 = new $c_scm_ArraySeq$ofRef(new $ac_O(0));
}
$p = $c_scm_ArraySeq$.prototype = new $h_O();
$p.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
}
$h_scm_ArraySeq$.prototype = $p;
$p.au7 = (function(it, evidence$1) {
  return this.N8($m_s_Array$().aha(it, evidence$1));
});
$p.Nb = (function(evidence$1) {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2) => this.N8(x$2))), new $c_scm_ArrayBuilder$generic(evidence$1.dK()));
});
$p.N8 = (function(x) {
  if ((x === null)) {
    return null;
  }
  if ((x instanceof $ac_O)) {
    return new $c_scm_ArraySeq$ofRef(x);
  }
  if ((x instanceof $ac_I)) {
    return new $c_scm_ArraySeq$ofInt(x);
  }
  if ((x instanceof $ac_D)) {
    return new $c_scm_ArraySeq$ofDouble(x);
  }
  if ((x instanceof $ac_J)) {
    return new $c_scm_ArraySeq$ofLong(x);
  }
  if ((x instanceof $ac_F)) {
    return new $c_scm_ArraySeq$ofFloat(x);
  }
  if ((x instanceof $ac_C)) {
    return new $c_scm_ArraySeq$ofChar(x);
  }
  if ((x instanceof $ac_B)) {
    return new $c_scm_ArraySeq$ofByte(x);
  }
  if ((x instanceof $ac_S)) {
    return new $c_scm_ArraySeq$ofShort(x);
  }
  if ((x instanceof $ac_Z)) {
    return new $c_scm_ArraySeq$ofBoolean(x);
  }
  if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_scm_ArraySeq$ofUnit(x);
  }
  throw new $c_s_MatchError(x);
});
$p.agJ = (function(evidence$1) {
  return this.S2;
});
$p.Un = (function(it, evidence$1) {
  return this.au7(it, evidence$1);
});
var $d_scm_ArraySeq$ = new $TypeData().i($c_scm_ArraySeq$, "scala.collection.mutable.ArraySeq$", ({
  yQ: 1,
  a: 1,
  gR: 1,
  gP: 1,
  gQ: 1,
  h5: 1
}));
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$();
  }
  return $n_scm_ArraySeq$;
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
}
$h_scm_HashMap$$anon$1.prototype = $p;
$p.Iz = (function(nd) {
  return new $c_T2(nd.ku, nd.h6);
});
var $d_scm_HashMap$$anon$1 = new $TypeData().i($c_scm_HashMap$$anon$1, "scala.collection.mutable.HashMap$$anon$1", ({
  z2: 1,
  bA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
}
$h_scm_HashMap$$anon$2.prototype = $p;
$p.Iz = (function(nd) {
  return nd.ku;
});
var $d_scm_HashMap$$anon$2 = new $TypeData().i($c_scm_HashMap$$anon$2, "scala.collection.mutable.HashMap$$anon$2", ({
  z3: 1,
  bA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
}
$h_scm_HashMap$$anon$3.prototype = $p;
$p.Iz = (function(nd) {
  return nd.h6;
});
var $d_scm_HashMap$$anon$3 = new $TypeData().i($c_scm_HashMap$$anon$3, "scala.collection.mutable.HashMap$$anon$3", ({
  z4: 1,
  bA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$p = $c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
}
$h_scm_HashMap$$anon$4.prototype = $p;
$p.Iz = (function(nd) {
  return nd;
});
var $d_scm_HashMap$$anon$4 = new $TypeData().i($c_scm_HashMap$$anon$4, "scala.collection.mutable.HashMap$$anon$4", ({
  z5: 1,
  bA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.oi = 0;
  this.mp = null;
  this.yB = 0;
  this.yA = null;
  this.S5 = 0;
  this.alf = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.alf = outer;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.S5 = 0;
}
$p = $c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$p.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
}
$h_scm_HashMap$$anon$5.prototype = $p;
$p.r = (function() {
  return this.S5;
});
$p.Iz = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.jb;
  this.S5 = $x_1.kV((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().k(nd.h6));
  return this;
});
var $d_scm_HashMap$$anon$5 = new $TypeData().i($c_scm_HashMap$$anon$5, "scala.collection.mutable.HashMap$$anon$5", ({
  z6: 1,
  bA: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.tF = 0;
  this.qm = null;
  this.Hc = 0;
  this.Hb = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$p = $c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
}
$h_scm_HashSet$$anon$1.prototype = $p;
$p.Uf = (function(nd) {
  return nd.qn;
});
var $d_scm_HashSet$$anon$1 = new $TypeData().i($c_scm_HashSet$$anon$1, "scala.collection.mutable.HashSet$$anon$1", ({
  za: 1,
  cS: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.tF = 0;
  this.qm = null;
  this.Hc = 0;
  this.Hb = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$p = $c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
}
$h_scm_HashSet$$anon$2.prototype = $p;
$p.Uf = (function(nd) {
  return nd;
});
var $d_scm_HashSet$$anon$2 = new $TypeData().i($c_scm_HashSet$$anon$2, "scala.collection.mutable.HashSet$$anon$2", ({
  zb: 1,
  cS: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.tF = 0;
  this.qm = null;
  this.Hc = 0;
  this.Hb = null;
  this.S8 = 0;
  this.abg = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.abg = outer;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.S8 = 0;
}
$p = $c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$p.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
}
$h_scm_HashSet$$anon$3.prototype = $p;
$p.r = (function() {
  return this.S8;
});
$p.Uf = (function(nd) {
  this.S8 = $p_scm_HashSet__improveHash__I__I(this.abg, nd.mq);
  return this;
});
var $d_scm_HashSet$$anon$3 = new $TypeData().i($c_scm_HashSet$$anon$3, "scala.collection.mutable.HashSet$$anon$3", ({
  zc: 1,
  cS: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$1(outer) {
  this.tG = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
$p = $c_scm_LinkedHashSet$$anon$1.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$1;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$1() {
}
$h_scm_LinkedHashSet$$anon$1.prototype = $p;
$p.Ug = (function(nd) {
  return nd.mr;
});
var $d_scm_LinkedHashSet$$anon$1 = new $TypeData().i($c_scm_LinkedHashSet$$anon$1, "scala.collection.mutable.LinkedHashSet$$anon$1", ({
  zk: 1,
  cT: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$2(outer) {
  this.tG = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
$p = $c_scm_LinkedHashSet$$anon$2.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$2;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$2() {
}
$h_scm_LinkedHashSet$$anon$2.prototype = $p;
$p.Ug = (function(nd) {
  return nd;
});
var $d_scm_LinkedHashSet$$anon$2 = new $TypeData().i($c_scm_LinkedHashSet$$anon$2, "scala.collection.mutable.LinkedHashSet$$anon$2", ({
  zl: 1,
  cT: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_scm_LinkedHashSet$$anon$3(outer) {
  this.tG = null;
  this.Sa = 0;
  this.alg = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.alg = outer;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
  this.Sa = 0;
}
$p = $c_scm_LinkedHashSet$$anon$3.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$p.constructor = $c_scm_LinkedHashSet$$anon$3;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$3() {
}
$h_scm_LinkedHashSet$$anon$3.prototype = $p;
$p.r = (function() {
  return this.Sa;
});
$p.Ug = (function(nd) {
  var improvedHash = nd.oj;
  this.Sa = (improvedHash ^ ((improvedHash >>> 16) | 0));
  return this;
});
var $d_scm_LinkedHashSet$$anon$3 = new $TypeData().i($c_scm_LinkedHashSet$$anon$3, "scala.collection.mutable.LinkedHashSet$$anon$3", ({
  zm: 1,
  cT: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
}
$p = $c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $p;
$p.g = (function() {
  return "Duration.Undefined";
});
$p.b = (function(other) {
  return false;
});
$p.qF = (function(other) {
  return ((other !== this) | 0);
});
$p.oH = (function(that) {
  return this.qF(that);
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$1, "scala.concurrent.duration.Duration$$anon$1", ({
  zJ: 1,
  cZ: 1,
  c7: 1,
  a: 1,
  N: 1,
  aY: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
}
$p = $c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $p;
$p.g = (function() {
  return "Duration.Inf";
});
$p.qF = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().LB) ? (-1) : ((other === this) ? 0 : 1));
});
$p.oH = (function(that) {
  return this.qF(that);
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$2, "scala.concurrent.duration.Duration$$anon$2", ({
  zK: 1,
  cZ: 1,
  c7: 1,
  a: 1,
  N: 1,
  aY: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
}
$p = $c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$p.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $p;
$p.g = (function() {
  return "Duration.MinusInf";
});
$p.qF = (function(other) {
  return ((other === this) ? 0 : (-1));
});
$p.oH = (function(that) {
  return this.qF(that);
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().i($c_s_concurrent_duration_Duration$$anon$3, "scala.concurrent.duration.Duration$$anon$3", ({
  zL: 1,
  cZ: 1,
  c7: 1,
  a: 1,
  N: 1,
  aY: 1
}));
/** @constructor */
function $c_s_math_Ordering$$anon$1(f$4, outer) {
  this.Sq = null;
  this.abw = null;
  this.Sq = f$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.abw = outer;
}
$p = $c_s_math_Ordering$$anon$1.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
}
$h_s_math_Ordering$$anon$1.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return this.abw.bM(this.Sq.p(x), this.Sq.p(y));
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().i($c_s_math_Ordering$$anon$1, "scala.math.Ordering$$anon$1", ({
  A1: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1
}));
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.Sr);
}
function $f_s_math_Ordering$Float$IeeeOrdering__lteq__F__F__Z($thiz, x, y) {
  return (x <= y);
}
function $f_s_math_Ordering$Float$IeeeOrdering__gteq__F__F__Z($thiz, x, y) {
  return (x >= y);
}
function $f_s_math_Ordering$Float$IeeeOrdering__lt__F__F__Z($thiz, x, y) {
  return (x < y);
}
function $f_s_math_Ordering$Float$IeeeOrdering__gt__F__F__Z($thiz, x, y) {
  return (x > y);
}
function $f_s_math_Ordering$Float$IeeeOrdering__equiv__F__F__Z($thiz, x, y) {
  return (x === y);
}
function $f_s_math_Ordering$OptionOrdering__compare__s_Option__s_Option__I($thiz, x, y) {
  var x9 = new $c_T2(x, y);
  var x20 = x9.L3;
  var x21 = x9.L4;
  if (($m_s_None$() === x20)) {
    if (($m_s_None$() === x21)) {
      return 0;
    }
    return (-1);
  }
  if (($m_s_None$() === x21)) {
    return 1;
  }
  if ((x20 instanceof $c_s_Some)) {
    var x$8 = x20.bg;
    if ((x21 instanceof $c_s_Some)) {
      var y$2 = x21.bg;
      return $thiz.Hl.bM(x$8, y$2);
    }
  }
  throw new $c_s_MatchError(x9);
}
function $f_s_math_Ordering$OptionOrdering__equals__O__Z($thiz, obj) {
  if ((obj !== null)) {
    if (($thiz === obj)) {
      return true;
    }
  }
  if ($is_s_math_Ordering$OptionOrdering(obj)) {
    var x = $thiz.Hl;
    var x$2 = obj.Hl;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  }
  return false;
}
function $f_s_math_Ordering$OptionOrdering__hashCode__I($thiz) {
  return Math.imul(43, $thiz.Hl.r());
}
function $is_s_math_Ordering$OptionOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.d1)));
}
function $isArrayOf_s_math_Ordering$OptionOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d1)));
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.ih = null;
  this.ih = outer;
}
$p = $c_s_math_Ordering$Reverse.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
}
$h_s_math_Ordering$Reverse.prototype = $p;
$p.f9 = (function(other) {
  var x$2 = this.ih;
  return ((other === null) ? (x$2 === null) : other.b(x$2));
});
$p.bM = (function(x, y) {
  return this.ih.bM(y, x);
});
$p.fR = (function(x, y) {
  return this.ih.fR(y, x);
});
$p.fN = (function(x, y) {
  return this.ih.fN(y, x);
});
$p.fQ = (function(x, y) {
  return this.ih.fQ(y, x);
});
$p.fm = (function(x, y) {
  return this.ih.fm(y, x);
});
$p.fJ = (function(x, y) {
  return this.ih.fJ(y, x);
});
$p.eR = (function(x, y) {
  return this.ih.fr(x, y);
});
$p.fr = (function(x, y) {
  return this.ih.eR(x, y);
});
$p.b = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x = this.ih;
    var x$2 = obj.ih;
    return ((x === null) ? (x$2 === null) : x.b(x$2));
  }
  return false;
});
$p.r = (function() {
  return Math.imul(41, this.ih.r());
});
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ig)));
}
var $d_s_math_Ordering$Reverse = new $TypeData().i($c_s_math_Ordering$Reverse, "scala.math.Ordering$Reverse", ({
  ig: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1
}));
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.Hm = null;
  this.Hm = runtimeClass;
}
$p = $c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$p.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $p;
$p.b = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x);
});
$p.r = (function() {
  return $m_sr_Statics$().k(this.Hm);
});
$p.g = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.Hm);
});
$p.dK = (function() {
  return this.Hm;
});
$p.fb = (function(len) {
  return this.Hm.ax.U(len);
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().i($c_s_reflect_ClassTag$GenericClassTag, "scala.reflect.ClassTag$GenericClassTag", ({
  Aq: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1
}));
/** @constructor */
function $c_Lscalatags_generic_Styles$$anon$5(outer) {
  this.Ht = null;
  this.Df = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lscalatags_generic_Style__T__T__(this, "textAlign", "text-align");
}
$p = $c_Lscalatags_generic_Styles$$anon$5.prototype = new $h_Lscalatags_generic_Style();
$p.constructor = $c_Lscalatags_generic_Styles$$anon$5;
/** @constructor */
function $h_Lscalatags_generic_Styles$$anon$5() {
}
$h_Lscalatags_generic_Styles$$anon$5.prototype = $p;
var $d_Lscalatags_generic_Styles$$anon$5 = new $TypeData().i($c_Lscalatags_generic_Styles$$anon$5, "scalatags.generic.Styles$$anon$5", ({
  Cm: 1,
  iw: 1,
  b: 1,
  c: 1,
  a: 1,
  Cn: 1
}));
class $c_Lupickle_core_Abort extends $c_jl_Exception {
  constructor(msg) {
    super();
    this.Dl = null;
    this.Dl = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true);
  }
  C() {
    return new $c_s_Product$$anon$1(this);
  }
  r() {
    return $m_s_util_hashing_MurmurHash3$().au(this, (-1684712866), true);
  }
  b(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lupickle_core_Abort) && (this.Dl === x$0.Dl)));
  }
  w() {
    return 1;
  }
  A() {
    return "Abort";
  }
  z(n) {
    if ((n === 0)) {
      return this.Dl;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lupickle_core_Abort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iQ)));
}
var $d_Lupickle_core_Abort = new $TypeData().i($c_Lupickle_core_Abort, "upickle.core.Abort", ({
  iQ: 1,
  J: 1,
  F: 1,
  a: 1,
  b: 1,
  c: 1
}));
class $c_Lupickle_core_AbortException extends $c_jl_Exception {
  constructor(clue, index, line, col, cause) {
    super();
    this.HN = null;
    this.HP = 0;
    this.HQ = 0;
    this.HO = 0;
    this.HM = null;
    this.HN = clue;
    this.HP = index;
    this.HQ = line;
    this.HO = col;
    this.HM = cause;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((clue + " at index ") + index), cause, true, true);
  }
  C() {
    return new $c_s_Product$$anon$1(this);
  }
  r() {
    var acc = (-889275714);
    acc = $m_sr_Statics$().d(acc, (-866111713));
    acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.HN));
    acc = $m_sr_Statics$().d(acc, this.HP);
    acc = $m_sr_Statics$().d(acc, this.HQ);
    acc = $m_sr_Statics$().d(acc, this.HO);
    acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.HM));
    return $m_sr_Statics$().an(acc, 5);
  }
  b(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lupickle_core_AbortException)) {
      if (((((this.HP === x$0.HP) && (this.HQ === x$0.HQ)) && (this.HO === x$0.HO)) && (this.HN === x$0.HN))) {
        var x = this.HM;
        var x$2 = x$0.HM;
        return ((x === null) ? (x$2 === null) : x.b(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  w() {
    return 5;
  }
  A() {
    return "AbortException";
  }
  z(n) {
    switch (n) {
      case 0: {
        return this.HN;
        break;
      }
      case 1: {
        return this.HP;
        break;
      }
      case 2: {
        return this.HQ;
        break;
      }
      case 3: {
        return this.HO;
        break;
      }
      case 4: {
        return this.HM;
        break;
      }
      default: {
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
}
function $isArrayOf_Lupickle_core_AbortException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iR)));
}
var $d_Lupickle_core_AbortException = new $TypeData().i($c_Lupickle_core_AbortException, "upickle.core.AbortException", ({
  iR: 1,
  J: 1,
  F: 1,
  a: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$Leaf(outer, tagKey, tagValue, tagShortValue, r) {
  this.adv = null;
  this.adx = null;
  this.adw = null;
  this.adu = null;
  this.ST = null;
  this.adv = tagKey;
  this.adx = tagValue;
  this.adw = tagShortValue;
  this.adu = r;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ST = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$Leaf.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$Leaf;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$Leaf() {
}
$h_Lupickle_core_Types$TaggedReader$Leaf.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  this.kW();
  return "expected dictionary";
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.kW(), this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.kW());
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.A0 = (function() {
  return this.adv;
});
$p.f5 = (function(s) {
  return (((s === this.adx) || (s === this.adw)) ? this.adu : null);
});
$p.mO = (function() {
  return this.ST.HV;
});
$p.kW = (function() {
  return this.ST.HV;
});
$p.dL = (function() {
  return this.mO();
});
$p.VP = (function() {
  return this.kW();
});
var $d_Lupickle_core_Types$TaggedReader$Leaf = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$Leaf, "upickle.core.Types$TaggedReader$Leaf", ({
  DC: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bG: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$TaggedReader$Node(outer, tagKey, rs) {
  this.adz = null;
  this.ady = null;
  this.SU = null;
  this.adz = tagKey;
  this.ady = rs;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SU = outer;
}
$p = $c_Lupickle_core_Types$TaggedReader$Node.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$TaggedReader$Node;
/** @constructor */
function $h_Lupickle_core_Types$TaggedReader$Node() {
}
$h_Lupickle_core_Types$TaggedReader$Node.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  this.kW();
  return "expected dictionary";
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.kW(), this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.kW());
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.A0 = (function() {
  return this.adz;
});
$p.f5 = (function(s) {
  var xs = this.ady;
  var x = null;
  var i = xs.l();
  while (((x === null) && i.f())) {
    var t = i.e().f5(s);
    if ((t !== null)) {
      x = t;
    }
  }
  return x;
});
$p.mO = (function() {
  return this.SU.HV;
});
$p.kW = (function() {
  return this.SU.HV;
});
$p.dL = (function() {
  return this.mO();
});
$p.VP = (function() {
  return this.kW();
});
var $d_Lupickle_core_Types$TaggedReader$Node = new $TypeData().i($c_Lupickle_core_Types$TaggedReader$Node, "upickle.core.Types$TaggedReader$Node", ({
  DD: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bG: 1
}));
/** @constructor */
function $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader(outer, t) {
  this.a0 = null;
  this.T5 = null;
  this.T5 = t;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_implicits_CaseClassReadWriters$CaseClassReader__Lupickle_implicits_CaseClassReadWriters__(this, outer);
}
$p = $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader.prototype = new $h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader();
$p.constructor = $c_Lupickle_implicits_CaseClassReadWriters$SingletonReader;
/** @constructor */
function $h_Lupickle_implicits_CaseClassReadWriters$SingletonReader() {
}
$h_Lupickle_implicits_CaseClassReadWriters$SingletonReader.prototype = $p;
$p.bR = (function() {
  return "expected string or dictionary";
});
$p.bx = (function(s, index) {
  return this.T5;
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_implicits_CaseClassReadWriters$$anon$1(this);
});
var $d_Lupickle_implicits_CaseClassReadWriters$SingletonReader = new $TypeData().i($c_Lupickle_implicits_CaseClassReadWriters$SingletonReader, "upickle.implicits.CaseClassReadWriters$SingletonReader", ({
  DR: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
function $ct_Lupickle_implicits_CaseObjectContext2__I__($thiz, fieldCount) {
  $thiz.qs = (-1);
  $thiz.oz = 0;
  $thiz.oA = 0;
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_CaseObjectContext2() {
  this.qs = 0;
  this.oz = 0;
  this.oA = 0;
}
$p = $c_Lupickle_implicits_CaseObjectContext2.prototype = new $h_Lupickle_implicits_CaseObjectContext0();
$p.constructor = $c_Lupickle_implicits_CaseObjectContext2;
/** @constructor */
function $h_Lupickle_implicits_CaseObjectContext2() {
}
$h_Lupickle_implicits_CaseObjectContext2.prototype = $p;
$p.Ms = (function() {
  return this.qs;
});
$p.agy = (function(x$1) {
  this.qs = x$1;
});
function $ct_Lupickle_implicits_HugeCaseObjectContext2__I__($thiz, fieldCount) {
  $thiz.mv = (-1);
  $thiz.qt = new $ac_J(((1 + (((fieldCount + (((fieldCount >> 5) >>> 26) | 0)) | 0) >> 6)) | 0));
  return $thiz;
}
/** @constructor */
function $c_Lupickle_implicits_HugeCaseObjectContext2() {
  this.mv = 0;
  this.qt = null;
}
$p = $c_Lupickle_implicits_HugeCaseObjectContext2.prototype = new $h_Lupickle_implicits_HugeCaseObjectContext0();
$p.constructor = $c_Lupickle_implicits_HugeCaseObjectContext2;
/** @constructor */
function $h_Lupickle_implicits_HugeCaseObjectContext2() {
}
$h_Lupickle_implicits_HugeCaseObjectContext2.prototype = $p;
$p.Ms = (function() {
  return this.mv;
});
$p.agy = (function(x$1) {
  this.mv = x$1;
});
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$10(outer) {
  this.ae5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae5 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$10.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$10;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$10() {
}
$h_Lupickle_implicits_Readers$$anon$10.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected char";
});
$p.azm = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().J2(s, decIndex, expIndex, index);
  return (65535 & $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h));
});
$p.dL = (function() {
  return this.ae5;
});
$p.bx = (function(s, index) {
  return $bC($dp_toString__T(s).charCodeAt(0));
});
$p.cB = (function(s, index) {
  return $bC(s);
});
$p.c9 = (function(i, index) {
  return $bC((65535 & i));
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $bC((65535 & i_$_lo));
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $bC((65535 & i_$_lo));
});
$p.cs = (function(d, index) {
  return $bC((65535 & $doubleToInt(d)));
});
$p.ct = (function(d, index) {
  return $bC((65535 & $doubleToInt(d)));
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $bC(this.azm(s, decIndex, expIndex, index));
});
var $d_Lupickle_implicits_Readers$$anon$10 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$10, "upickle.implicits.Readers$$anon$10", ({
  E4: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$11(outer) {
  this.ae6 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae6 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$11.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$11;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$11() {
}
$h_Lupickle_implicits_Readers$$anon$11.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return $m_ju_UUID$().aO($dp_toString__T(s));
});
$p.dL = (function() {
  return this.ae6;
});
var $d_Lupickle_implicits_Readers$$anon$11 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$11, "upickle.implicits.Readers$$anon$11", ({
  E5: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bJ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$12(outer) {
  this.ae7 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae7 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$12.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$12;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$12() {
}
$h_Lupickle_implicits_Readers$$anon$12.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.dL = (function() {
  return this.ae7;
});
$p.bx = (function(s, index) {
  return $uJ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.c9 = (function(i, index) {
  var hi = (i >> 31);
  return $bL(i, hi);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $bL(i_$_lo, i_$_hi);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $bL(i_$_lo, i_$_hi);
});
$p.cs = (function(d, index) {
  return $m_RTLong$().jq(d);
});
$p.ct = (function(d, index) {
  return $m_RTLong$().jq(d);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $m_Lupickle_core_ParseUtils$().J2(s, decIndex, expIndex, index);
});
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $m_Lupickle_core_CharUtils$().J3(s, arrOffset, arrLength, decIndex, expIndex);
});
var $d_Lupickle_implicits_Readers$$anon$12 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$12, "upickle.implicits.Readers$$anon$12", ({
  E6: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$13(outer) {
  this.ae8 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae8 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$13.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$13;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$13() {
}
$h_Lupickle_implicits_Readers$$anon$13.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return $m_s_package$().alP().amD($dp_toString__T(s));
});
$p.dL = (function() {
  return this.ae8;
});
var $d_Lupickle_implicits_Readers$$anon$13 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$13, "upickle.implicits.Readers$$anon$13", ({
  E7: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bJ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$14(outer) {
  this.ae9 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ae9 = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$14.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$14;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$14() {
}
$h_Lupickle_implicits_Readers$$anon$14.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return $m_s_package$().alO().atB($dp_toString__T(s));
});
$p.dL = (function() {
  return this.ae9;
});
var $d_Lupickle_implicits_Readers$$anon$14 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$14, "upickle.implicits.Readers$$anon$14", ({
  E8: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bJ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$15(outer) {
  this.aea = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aea = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$15.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$15;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$15() {
}
$h_Lupickle_implicits_Readers$$anon$15.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return $c_s_UniquenessCache.prototype.amC.call($m_s_Symbol$(), $dp_toString__T(s));
});
$p.dL = (function() {
  return this.aea;
});
var $d_Lupickle_implicits_Readers$$anon$15 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$15, "upickle.implicits.Readers$$anon$15", ({
  E9: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bJ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$16(outer) {
  this.aeb = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeb = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$16.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$16;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$16() {
}
$h_Lupickle_implicits_Readers$$anon$16.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected string";
});
$p.bx = (function(s, index) {
  return this.ax3(s);
});
$p.ax3 = (function(s) {
  if ((((($dp_charAt__I__C(s, 0) === 105) && ($dp_charAt__I__C(s, 1) === 110)) && ($dp_charAt__I__C(s, 2) === 102)) && ($dp_length__I(s) === 3))) {
    return $m_s_concurrent_duration_Duration$().Sd;
  } else if (((((($dp_charAt__I__C(s, 0) === 45) && ($dp_charAt__I__C(s, 1) === 105)) && ($dp_charAt__I__C(s, 2) === 110)) && ($dp_charAt__I__C(s, 3) === 102)) && ($dp_length__I(s) === 4))) {
    return $m_s_concurrent_duration_Duration$().Se;
  } else if ((((((($dp_charAt__I__C(s, 0) === 117) && ($dp_charAt__I__C(s, 1) === 110)) && ($dp_charAt__I__C(s, 2) === 100)) && ($dp_charAt__I__C(s, 3) === 101)) && ($dp_charAt__I__C(s, 4) === 102)) && ($dp_length__I(s) === 5))) {
    return $m_s_concurrent_duration_Duration$().LB;
  } else {
    $m_s_concurrent_duration_Duration$();
    var $x_1 = $m_Lupickle_core_ParseUtils$().awJ(s, 0, $dp_length__I(s));
    return new $c_s_concurrent_duration_FiniteDuration($x_1.l, $x_1.h, $m_ju_concurrent_TimeUnit$().R8);
  }
});
$p.dL = (function() {
  return this.aeb;
});
var $d_Lupickle_implicits_Readers$$anon$16 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$16, "upickle.implicits.Readers$$anon$16", ({
  Ea: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  bJ: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$19(inner$2, outer) {
  this.aed = null;
  this.aec = null;
  this.aed = inner$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aec = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$19.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$19;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$19() {
}
$h_Lupickle_implicits_Readers$$anon$19.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  return "expected sequence";
});
$p.bt = (function(length, index) {
  return new $c_Lupickle_implicits_Readers$$anon$19$$anon$20(this);
});
$p.dL = (function() {
  return this.aec;
});
var $d_Lupickle_implicits_Readers$$anon$19 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$19, "upickle.implicits.Readers$$anon$19", ({
  Ed: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  cb: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$21(evidence$1$5, outer) {
  this.eO = null;
  this.SR = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(this, outer.hJ(), $s_Lupickle_implicits_Readers__upickle$implicits$Readers$$_$$anon$superArg$1$1__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader(evidence$1$5));
}
$p = $c_Lupickle_implicits_Readers$$anon$21.prototype = new $h_Lupickle_core_Types$Reader$Delegate();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$21;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$21() {
}
$h_Lupickle_implicits_Readers$$anon$21.prototype = $p;
$p.M = (function(index) {
  return $m_s_None$();
});
var $d_Lupickle_implicits_Readers$$anon$21 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$21, "upickle.implicits.Readers$$anon$21", ({
  Eg: 1,
  jd: 1,
  bI: 1,
  d: 1,
  e: 1,
  cb: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$4(outer) {
  this.aep = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aep = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$4.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$4;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$4() {
}
$h_Lupickle_implicits_Readers$$anon$4.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.azn = (function(s, decIndex, expIndex, index) {
  $m_sc_StringOps$();
  return $m_jl_Double$().fS($dp_toString__T(s));
});
$p.dL = (function() {
  return this.aep;
});
$p.bx = (function(s, index) {
  return (+$f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.c9 = (function(i, index) {
  return i;
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0));
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return ((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0));
});
$p.cs = (function(d, index) {
  return d;
});
$p.ct = (function(d, index) {
  return d;
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.azn(s, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$4 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$4, "upickle.implicits.Readers$$anon$4", ({
  En: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$5(outer) {
  this.aeq = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeq = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$5.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$5;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$5() {
}
$h_Lupickle_implicits_Readers$$anon$5.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.azp = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().J2(s, decIndex, expIndex, index);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.azj = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().J3(s, arrOffset, arrLength, decIndex, expIndex);
  return $s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
});
$p.dL = (function() {
  return this.aeq;
});
$p.bx = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.c9 = (function(i, index) {
  return i;
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return i_$_lo;
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return i_$_lo;
});
$p.cs = (function(d, index) {
  return $doubleToInt(d);
});
$p.ct = (function(d, index) {
  return $doubleToInt(d);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.azp(s, decIndex, expIndex, index);
});
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.azj(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$5 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$5, "upickle.implicits.Readers$$anon$5", ({
  Eo: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$6(outer) {
  this.aer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aer = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$6.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$6;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$6() {
}
$h_Lupickle_implicits_Readers$$anon$6.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.azo = (function(s, decIndex, expIndex, index) {
  $m_sc_StringOps$();
  return $m_jl_Float$().gL($dp_toString__T(s));
});
$p.dL = (function() {
  return this.aer;
});
$p.bx = (function(s, index) {
  return Math.fround($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index));
});
$p.c9 = (function(i, index) {
  return Math.fround(i);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  var compressedLo = (((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0) || ((65535 & i_$_lo) === 0)) ? i_$_lo : (32768 | ((-32768) & i_$_lo)));
  return Math.fround(((4.294967296E9 * i_$_hi) + (compressedLo >>> 0.0)));
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  var compressedLo = (((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0) || ((65535 & i_$_lo) === 0)) ? i_$_lo : (32768 | ((-32768) & i_$_lo)));
  return Math.fround(((4.294967296E9 * i_$_hi) + (compressedLo >>> 0.0)));
});
$p.cs = (function(d, index) {
  return d;
});
$p.ct = (function(d, index) {
  return Math.fround(d);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.azo(s, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$6 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$6, "upickle.implicits.Readers$$anon$6", ({
  Ep: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$7(outer) {
  this.aes = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aes = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$7.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$7;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$7() {
}
$h_Lupickle_implicits_Readers$$anon$7.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.azq = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().J2(s, decIndex, expIndex, index);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.azk = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().J3(s, arrOffset, arrLength, decIndex, expIndex);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 16) >> 16);
});
$p.dL = (function() {
  return this.aes;
});
$p.bx = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.c9 = (function(i, index) {
  return ((i << 16) >> 16);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 16) >> 16);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 16) >> 16);
});
$p.cs = (function(d, index) {
  return (($doubleToInt(d) << 16) >> 16);
});
$p.ct = (function(d, index) {
  return (($doubleToInt(d) << 16) >> 16);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.azq(s, decIndex, expIndex, index);
});
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.azk(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$7 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$7, "upickle.implicits.Readers$$anon$7", ({
  Eq: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
/** @constructor */
function $c_Lupickle_implicits_Readers$$anon$8(outer) {
  this.aet = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aet = outer;
}
$p = $c_Lupickle_implicits_Readers$$anon$8.prototype = new $h_O();
$p.constructor = $c_Lupickle_implicits_Readers$$anon$8;
/** @constructor */
function $h_Lupickle_implicits_Readers$$anon$8() {
}
$h_Lupickle_implicits_Readers$$anon$8.prototype = $p;
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return $f_Lupickle_core_SimpleVisitor__visitObject__I__Z__I__Lupickle_core_ObjVisitor(this, length, jsonableKeys, index);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_SimpleVisitor__visitArray__I__I__Lupickle_core_ArrVisitor(this, length, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, s, index);
});
$p.bR = (function() {
  return "expected number";
});
$p.azl = (function(s, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_ParseUtils$().J2(s, decIndex, expIndex, index);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.azi = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  var $x_1 = $m_Lupickle_core_CharUtils$().J3(s, arrOffset, arrLength, decIndex, expIndex);
  return (($s_RTLong__toInt__I__I__I($x_1.l, $x_1.h) << 24) >> 24);
});
$p.dL = (function() {
  return this.aet;
});
$p.bx = (function(s, index) {
  return ($f_Lupickle_implicits_Readers$NumericReader__visitFloat64String__T__I__O(this, $dp_toString__T(s), index) | 0);
});
$p.c9 = (function(i, index) {
  return ((i << 24) >> 24);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 24) >> 24);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return ((i_$_lo << 24) >> 24);
});
$p.cs = (function(d, index) {
  return (($doubleToInt(d) << 24) >> 24);
});
$p.ct = (function(d, index) {
  return (($doubleToInt(d) << 24) >> 24);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return this.azl(s, decIndex, expIndex, index);
});
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return this.azi(s, arrOffset, arrLength, decIndex, expIndex, index);
});
var $d_Lupickle_implicits_Readers$$anon$8 = new $TypeData().i($c_Lupickle_implicits_Readers$$anon$8, "upickle.implicits.Readers$$anon$8", ({
  Er: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1,
  b8: 1
}));
function $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__($thiz, outer, paramCount, missingKeyCount_$_lo, missingKeyCount_$_hi, allowUnknownKeys, construct) {
  $thiz.Y = paramCount;
  $thiz.a8 = missingKeyCount_$_lo;
  $thiz.a9 = missingKeyCount_$_hi;
  $thiz.a6 = allowUnknownKeys;
  $thiz.a7 = construct;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.ab = outer;
  $ct_Lupickle_implicits_CaseClassReadWriters$CaseClassReader__Lupickle_implicits_CaseClassReadWriters__($thiz, outer);
  return $thiz;
}
function $p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__$1$__T3($thiz) {
  if ((!$thiz.a3)) {
    matchResult1$1: {
      var $x_1;
      var x1 = $thiz.af();
      if ((x1 !== null)) {
        var x2 = x1.P();
        if ((x2 !== null)) {
          var $x_1 = new $c_T3(x2.P(), x2.V(), x1.V());
          break matchResult1$1;
        }
      }
      throw new $c_s_MatchError(x1);
    }
    $thiz.a2 = $x_1;
    $thiz.a3 = true;
  }
  return $thiz.a2;
}
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3() {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3.prototype = new $h_Lupickle_implicits_CaseClassReadWriters$CaseClassReader();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3.prototype = $p;
$p.MR = (function() {
  if ((!this.a5)) {
    this.a4 = ($p_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__$1$__T3(this).fY !== null);
    this.a5 = true;
  }
  return this.a4;
});
$p.K = (function(length, jsonableKeys, index) {
  return ((this.Y <= 64) ? new $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1(this) : new $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2(this));
});
/** @constructor */
function $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_AgileBoardListSetupData$().anj(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_agileboard_AgileBoardListSetupData$().ank());
}
$p = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1() {
}
$h_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$9 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_agileboard_BoardData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_agileboard_DropdownData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$9);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "boards": {
      return 0;
      break;
    }
    case "listUpdateFun": {
      return 1;
      break;
    }
    case "dropdownData": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("boards", new $c_sci_$colon$colon("listUpdateFun", new $c_sci_$colon$colon("dropdownData", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_agileboard_AgileBoardListSetupData$$anon$1, "com.papasofokli.agileboard.AgileBoardListSetupData$$anon$1", ({
  jv: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardData$$anon$9(ReadersVersionSpecific_this$13, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_BoardData$().anm(ReadersVersionSpecific_this$13), $m_Lcom_papasofokli_agileboard_BoardData$().anl());
}
$p = $c_Lcom_papasofokli_agileboard_BoardData$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardData$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardData$$anon$9() {
}
$h_Lcom_papasofokli_agileboard_BoardData$$anon$9.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$8 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_agileboard_BoardElement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$8);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "description": {
      return 1;
      break;
    }
    case "elements": {
      return 2;
      break;
    }
    case "enabled": {
      return 3;
      break;
    }
    case "boardCss": {
      return 4;
      break;
    }
    case "isTaskManager": {
      return 5;
      break;
    }
    case "countPerColumn": {
      return 6;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("description", new $c_sci_$colon$colon("elements", new $c_sci_$colon$colon("enabled", new $c_sci_$colon$colon("boardCss", new $c_sci_$colon$colon("isTaskManager", new $c_sci_$colon$colon("countPerColumn", $m_sci_Nil$())))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(4, $m_s_None$());
  x.ag(5, false);
  x.ag(6, $m_s_None$());
});
var $d_Lcom_papasofokli_agileboard_BoardData$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardData$$anon$9, "com.papasofokli.agileboard.BoardData$$anon$9", ({
  jA: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_BoardElement$$anon$11(ReadersVersionSpecific_this$16, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$16, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_BoardElement$().ann(ReadersVersionSpecific_this$16), $m_Lcom_papasofokli_agileboard_BoardElement$().ano());
}
$p = $c_Lcom_papasofokli_agileboard_BoardElement$$anon$11.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_BoardElement$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_BoardElement$$anon$11() {
}
$h_Lcom_papasofokli_agileboard_BoardElement$$anon$11.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().bl, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().J, $m_Lupickle_default$().Dw, $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().J, $m_Lupickle_default$().J), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().J, $m_Lupickle_default$().J)), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple3Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().J, $m_Lupickle_default$().J, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J)]);
  var this$24 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$24.G() >= 0)) {
    var destination = new $ac_O(this$24.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$24, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$24.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "recordId": {
      return 0;
      break;
    }
    case "description": {
      return 1;
      break;
    }
    case "style": {
      return 2;
      break;
    }
    case "dateTime": {
      return 3;
      break;
    }
    case "infoBoardIcon": {
      return 4;
      break;
    }
    case "info": {
      return 5;
      break;
    }
    case "sort": {
      return 6;
      break;
    }
    case "isBlocked": {
      return 7;
      break;
    }
    case "additionalBtn": {
      return 8;
      break;
    }
    case "additionalDataRows": {
      return 9;
      break;
    }
    case "assignee": {
      return 10;
      break;
    }
    case "statusAndStyle": {
      return 11;
      break;
    }
    case "instructionsO": {
      return 12;
      break;
    }
    case "descriptionStyle": {
      return 13;
      break;
    }
    case "taskTypeAndCancelComment": {
      return 14;
      break;
    }
    case "createdBy": {
      return 15;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["recordId", "description", "style", "dateTime", "infoBoardIcon", "info", "sort", "isBlocked", "additionalBtn", "additionalDataRows", "assignee", "statusAndStyle", "instructionsO", "descriptionStyle", "taskTypeAndCancelComment", "createdBy"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(4, $m_sci_Nil$());
  x.ag(8, $m_s_None$());
  x.ag(9, $m_sci_Nil$());
  x.ag(10, $m_s_None$());
  x.ag(11, $m_s_None$());
  x.ag(12, $m_s_None$());
  x.ag(13, $m_s_None$());
  x.ag(14, $m_s_None$());
  x.ag(15, $m_s_None$());
});
var $d_Lcom_papasofokli_agileboard_BoardElement$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_agileboard_BoardElement$$anon$11, "com.papasofokli.agileboard.BoardElement$$anon$11", ({
  jC: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_DropdownData$$anon$13(ReadersVersionSpecific_this$19, paramCount$7, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_DropdownData$().anp(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_agileboard_DropdownData$().anq());
}
$p = $c_Lcom_papasofokli_agileboard_DropdownData$$anon$13.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_DropdownData$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_DropdownData$$anon$13() {
}
$h_Lcom_papasofokli_agileboard_DropdownData$$anon$13.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "name") ? 0 : ((x === "clickType") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("clickType", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_agileboard_DropdownData$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_agileboard_DropdownData$$anon$13, "com.papasofokli.agileboard.DropdownData$$anon$13", ({
  jF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_ItemClickRequest$().anr(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_agileboard_ItemClickRequest$().ans());
}
$p = $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5() {
}
$h_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : ((x === "clickType") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("clickType", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_agileboard_ItemClickRequest$$anon$5, "com.papasofokli.agileboard.ItemClickRequest$$anon$5", ({
  jI: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_RequestBoardData$().ant(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_agileboard_RequestBoardData$().anu());
}
$p = $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3() {
}
$h_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().bl, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "boardId") ? 0 : ((x === "items") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("boardId", new $c_sci_$colon$colon("items", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_agileboard_RequestBoardData$$anon$3, "com.papasofokli.agileboard.RequestBoardData$$anon$3", ({
  jL: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_agileboard_SelectedIdsRequest$().anv(ReadersVersionSpecific_this$10), $m_Lcom_papasofokli_agileboard_SelectedIdsRequest$().anw());
}
$p = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7() {
}
$h_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$5 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "previousId") ? 0 : ((x === "selectedId") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("previousId", new $c_sci_$colon$colon("selectedId", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_agileboard_SelectedIdsRequest$$anon$7, "com.papasofokli.agileboard.SelectedIdsRequest$$anon$7", ({
  jO: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_box_BoxData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_box_BoxData$().anx(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_box_BoxData$().any());
}
$p = $c_Lcom_papasofokli_box_BoxData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_box_BoxData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_box_BoxData$$anon$1() {
}
$h_Lcom_papasofokli_box_BoxData$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var $x_9 = $m_Lupickle_default$().J;
  var $x_8 = $m_Lupickle_default$().J;
  var $x_7 = $m_Lupickle_default$();
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e = $m_Lcom_papasofokli_util_GeneralText$().q();
  var $x_6 = $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($x_7, new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e.f5("com.papasofokli.util.IconUI")));
  var $x_5 = $m_Lupickle_default$().bf;
  var $x_4 = $m_Lupickle_default$().bf;
  var $x_3 = $m_Lupickle_default$().J;
  var $x_2 = $m_Lupickle_default$().J;
  var ReadersVersionSpecific_this$2 = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e$1 = $m_Lcom_papasofokli_util_GeneralText$().q();
  var $x_1 = new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$2.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e$1.f5("com.papasofokli.util.IconUI"));
  var ReadersVersionSpecific_this$3 = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e$2 = $m_Lcom_papasofokli_util_GeneralText$().q();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$x_9, $x_8, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$3.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e$2.f5("com.papasofokli.util.IconUI")), $m_Lupickle_default$().aG, $m_Lupickle_default$().J, $m_Lupickle_default$().bf]);
  var this$14 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$14.G() >= 0)) {
    var destination = new $ac_O(this$14.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$14, destination, 0, 2147483647);
    var $x_10 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$14.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_10 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_10);
});
$p.ad = (function(x) {
  switch (x) {
    case "title": {
      return 0;
      break;
    }
    case "contents": {
      return 1;
      break;
    }
    case "icon": {
      return 2;
      break;
    }
    case "hasRow": {
      return 3;
      break;
    }
    case "hasButtons": {
      return 4;
      break;
    }
    case "headerContextualBackground": {
      return 5;
      break;
    }
    case "contextualBackground": {
      return 6;
      break;
    }
    case "chevronUp": {
      return 7;
      break;
    }
    case "chevronDown": {
      return 8;
      break;
    }
    case "contentFunctionId": {
      return 9;
      break;
    }
    case "cssStyle": {
      return 10;
      break;
    }
    case "expanded": {
      return 11;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["title", "contents", "icon", "hasRow", "hasButtons", "headerContextualBackground", "contextualBackground", "chevronUp", "chevronDown", "contentFunctionId", "cssStyle", "expanded"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(1, "");
  x.ag(3, true);
  x.ag(4, true);
  x.ag(11, false);
});
var $d_Lcom_papasofokli_box_BoxData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_box_BoxData$$anon$1, "com.papasofokli.box.BoxData$$anon$1", ({
  jY: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$().anz(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$().anA());
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().J, $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, $m_Lupickle_default$().J, $m_Lupickle_default$().aT, $m_Lcom_papasofokli_chartJSv2x_ChartDataS$().UA(), $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT)]);
  var this$8 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$8.G() >= 0)) {
    var destination = new $ac_O(this$8.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$8, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$8.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "chartType": {
      return 0;
      break;
    }
    case "onClickResponse": {
      return 1;
      break;
    }
    case "pointAndLegendResponse": {
      return 2;
      break;
    }
    case "chartTimePeriod": {
      return 3;
      break;
    }
    case "maxHeight": {
      return 4;
      break;
    }
    case "data": {
      return 5;
      break;
    }
    case "shortLabel": {
      return 6;
      break;
    }
    case "stacked": {
      return 7;
      break;
    }
    case "horizontal": {
      return 8;
      break;
    }
    case "customWidth": {
      return 9;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["chartType", "onClickResponse", "pointAndLegendResponse", "chartTimePeriod", "maxHeight", "data", "shortLabel", "stacked", "horizontal", "customWidth"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(1, true);
  x.ag(2, false);
  x.ag(3, "");
  x.ag(4, 300);
  x.ag(6, true);
  x.ag(7, false);
  x.ag(8, false);
  x.ag(9, $m_s_None$());
});
var $d_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartConfigurationS$$anon$3, "com.papasofokli.chartJSv2x.ChartConfigurationS$$anon$3", ({
  k8: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_chartJSv2x_ChartDataS$().anB(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_chartJSv2x_ChartDataS$().anC());
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$15 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_chartJSv2x_ChartDatasetS$().UB(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$15);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "labels": {
      return 0;
      break;
    }
    case "datasets": {
      return 1;
      break;
    }
    case "notes": {
      return 2;
      break;
    }
    case "legends": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("labels", new $c_sci_$colon$colon("datasets", new $c_sci_$colon$colon("notes", new $c_sci_$colon$colon("legends", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_sci_Seq$().dj());
  x.ag(3, $m_sci_Seq$().dj());
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDataS$$anon$5, "com.papasofokli.chartJSv2x.ChartDataS$$anon$5", ({
  kb: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$().anD(ReadersVersionSpecific_this$10), $m_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$().anE());
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().J, $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().op, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))]);
  var this$22 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$22.G() >= 0)) {
    var destination = new $ac_O(this$22.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$22, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$22.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "label": {
      return 0;
      break;
    }
    case "shortLabel": {
      return 1;
      break;
    }
    case "backgroundColor": {
      return 2;
      break;
    }
    case "hoverBackgroundColor": {
      return 3;
      break;
    }
    case "data": {
      return 4;
      break;
    }
    case "type": {
      return 5;
      break;
    }
    case "compactData": {
      return 6;
      break;
    }
    case "borderColor": {
      return 7;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["label", "shortLabel", "backgroundColor", "hoverBackgroundColor", "data", "type", "compactData", "borderColor"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(1, "");
  x.ag(5, "");
  x.ag(6, $m_sci_Seq$().dj());
  x.ag(7, $m_sci_Seq$().dj());
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetDoubleS$$anon$7, "com.papasofokli.chartJSv2x.ChartDatasetDoubleS$$anon$7", ({
  ke: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9(ReadersVersionSpecific_this$13, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$().anG(ReadersVersionSpecific_this$13), $m_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$().anF());
}
$p = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9() {
}
$h_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().J, $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().J, $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().aT, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_chartJSv2x_XY$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))]);
  var this$22 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$22.G() >= 0)) {
    var destination = new $ac_O(this$22.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$22, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$22.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "label": {
      return 0;
      break;
    }
    case "shortLabel": {
      return 1;
      break;
    }
    case "backgroundColor": {
      return 2;
      break;
    }
    case "hoverBackgroundColor": {
      return 3;
      break;
    }
    case "type": {
      return 4;
      break;
    }
    case "showLine": {
      return 5;
      break;
    }
    case "fill": {
      return 6;
      break;
    }
    case "borderColor": {
      return 7;
      break;
    }
    case "pointRadius": {
      return 8;
      break;
    }
    case "data": {
      return 9;
      break;
    }
    case "compactData": {
      return 10;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["label", "shortLabel", "backgroundColor", "hoverBackgroundColor", "type", "showLine", "fill", "borderColor", "pointRadius", "data", "compactData"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(1, "");
  x.ag(4, "");
  x.ag(5, true);
  x.ag(6, false);
  x.ag(8, 1);
  x.ag(10, $m_sci_Seq$().dj());
});
var $d_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_ChartDatasetXYS$$anon$9, "com.papasofokli.chartJSv2x.ChartDatasetXYS$$anon$9", ({
  kj: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_chartJSv2x_XY$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_chartJSv2x_XY$().anH(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_chartJSv2x_XY$().anI());
}
$p = $c_Lcom_papasofokli_chartJSv2x_XY$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_chartJSv2x_XY$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_chartJSv2x_XY$$anon$1() {
}
$h_Lcom_papasofokli_chartJSv2x_XY$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().op, new $c_sci_$colon$colon($m_Lupickle_default$().op, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "x") ? 0 : ((x === "y") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("x", new $c_sci_$colon$colon("y", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_chartJSv2x_XY$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_chartJSv2x_XY$$anon$1, "com.papasofokli.chartJSv2x.XY$$anon$1", ({
  kl: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_communication_OutlookData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_communication_OutlookData$().anJ(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_communication_OutlookData$().anK());
}
$p = $c_Lcom_papasofokli_communication_OutlookData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_communication_OutlookData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_communication_OutlookData$$anon$1() {
}
$h_Lcom_papasofokli_communication_OutlookData$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().bl, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_Lupickle_default$().bf, $m_Lupickle_default$().bf]);
  var this$9 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$9.G() >= 0)) {
    var destination = new $ac_O(this$9.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$9, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$9.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "title": {
      return 1;
      break;
    }
    case "summary": {
      return 2;
      break;
    }
    case "dateText": {
      return 3;
      break;
    }
    case "severityName": {
      return 4;
      break;
    }
    case "severityStyle": {
      return 5;
      break;
    }
    case "isViewed": {
      return 6;
      break;
    }
    case "pinOnTop": {
      return 7;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["id", "title", "summary", "dateText", "severityName", "severityStyle", "isViewed", "pinOnTop"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(2, "");
  x.ag(4, $m_s_None$());
  x.ag(5, $m_s_None$());
  x.ag(6, true);
  x.ag(7, false);
});
var $d_Lcom_papasofokli_communication_OutlookData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_communication_OutlookData$$anon$1, "com.papasofokli.communication.OutlookData$$anon$1", ({
  kT: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19(ReadersVersionSpecific_this$28, paramCount$10, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$10 <= 64)) {
    if ((paramCount$10 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$10) === 0) ? (1 << paramCount$10) : 0);
      var hi = (((32 & paramCount$10) === 0) ? 0 : (1 << paramCount$10));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$10 >> 31);
    var $x_1_$_lo = paramCount$10;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$28, paramCount$10, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_ColumnGroup$().anO(ReadersVersionSpecific_this$28), $m_Lcom_papasofokli_dataTables_ColumnGroup$().anP());
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$7 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$7);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "columnDisplayName": {
      return 0;
      break;
    }
    case "numericValueO": {
      return 1;
      break;
    }
    case "groupOption": {
      return 2;
      break;
    }
    case "columnType": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("columnDisplayName", new $c_sci_$colon$colon("numericValueO", new $c_sci_$colon$colon("groupOption", new $c_sci_$colon$colon("columnType", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, $m_s_None$());
  x.ag(2, $m_s_None$());
  x.ag(3, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroup$$anon$19, "com.papasofokli.dataTables.ColumnGroup$$anon$19", ({
  ld: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17(ReadersVersionSpecific_this$25, paramCount$9, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$9 <= 64)) {
    if ((paramCount$9 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$9) === 0) ? (1 << paramCount$9) : 0);
      var hi = (((32 & paramCount$9) === 0) ? 0 : (1 << paramCount$9));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$9 >> 31);
    var $x_1_$_lo = paramCount$9;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$25, paramCount$9, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_ColumnGroupOption$().anQ(ReadersVersionSpecific_this$25), $m_Lcom_papasofokli_dataTables_ColumnGroupOption$().anR());
}
$p = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17() {
}
$h_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "index") ? 0 : ((x === "groupByOption") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("index", new $c_sci_$colon$colon("groupByOption", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, 0);
});
var $d_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17 = new $TypeData().i($c_Lcom_papasofokli_dataTables_ColumnGroupOption$$anon$17, "com.papasofokli.dataTables.ColumnGroupOption$$anon$17", ({
  lg: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_CsvPasteHeader$().anS(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_dataTables_CsvPasteHeader$().anT());
}
$p = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1() {
}
$h_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "headerName") ? 0 : ((x === "pastValues") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("headerName", new $c_sci_$colon$colon("pastValues", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_dataTables_CsvPasteHeader$$anon$1, "com.papasofokli.dataTables.CsvPasteHeader$$anon$1", ({
  lj: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_GetRowsResult$().anU(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_dataTables_GetRowsResult$().anV());
}
$p = $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1() {
}
$h_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().aT, $m_Lupickle_default$().aT, $m_Lupickle_default$().aT, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_GroupedRowChartData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_Lupickle_default$().bf, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().aT), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J)]);
  var this$26 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$26.G() >= 0)) {
    var destination = new $ac_O(this$26.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$26, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$26.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "draw": {
      return 0;
      break;
    }
    case "recordsTotal": {
      return 1;
      break;
    }
    case "recordsFiltered": {
      return 2;
      break;
    }
    case "data": {
      return 3;
      break;
    }
    case "groupedData": {
      return 4;
      break;
    }
    case "chartData": {
      return 5;
      break;
    }
    case "groupLevel": {
      return 6;
      break;
    }
    case "error": {
      return 7;
      break;
    }
    case "partialLoad": {
      return 8;
      break;
    }
    case "headersWidth": {
      return 9;
      break;
    }
    case "groupCalculationType": {
      return 10;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["draw", "recordsTotal", "recordsFiltered", "data", "groupedData", "chartData", "groupLevel", "error", "partialLoad", "headersWidth", "groupCalculationType"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(6, $m_s_None$());
  x.ag(8, false);
  x.ag(9, $m_Lcom_papasofokli_dataTables_GetRowsResult$().oB());
  x.ag(10, $m_s_Option$().Z("average"));
});
var $d_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GetRowsResult$$anon$1, "com.papasofokli.dataTables.GetRowsResult$$anon$1", ({
  lm: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15(ReadersVersionSpecific_this$22, paramCount$8, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$8 <= 64)) {
    if ((paramCount$8 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$8) === 0) ? (1 << paramCount$8) : 0);
      var hi = (((32 & paramCount$8) === 0) ? 0 : (1 << paramCount$8));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$8 >> 31);
    var $x_1_$_lo = paramCount$8;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$22, paramCount$8, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_GroupedRowChartData$().anW(ReadersVersionSpecific_this$22), $m_Lcom_papasofokli_dataTables_GroupedRowChartData$().anX());
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$11 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().op, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$11);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "name": {
      return 0;
      break;
    }
    case "counter": {
      return 1;
      break;
    }
    case "values": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("counter", new $c_sci_$colon$colon("values", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowChartData$$anon$15, "com.papasofokli.dataTables.GroupedRowChartData$$anon$15", ({
  lp: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13(ReadersVersionSpecific_this$19, paramCount$7, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$().anY(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_dataTables_GroupedRowSummaryData$().anZ());
}
$p = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13() {
}
$h_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$8 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().J), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$8);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "name": {
      return 0;
      break;
    }
    case "columnGroup": {
      return 1;
      break;
    }
    case "values": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("columnGroup", new $c_sci_$colon$colon("values", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_dataTables_GroupedRowSummaryData$$anon$13, "com.papasofokli.dataTables.GroupedRowSummaryData$$anon$13", ({
  ls: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23(ReadersVersionSpecific_this$46, paramCount$12, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$12 <= 64)) {
    if ((paramCount$12 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$12) === 0) ? (1 << paramCount$12) : 0);
      var hi = (((32 & paramCount$12) === 0) ? 0 : (1 << paramCount$12));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$12 >> 31);
    var $x_1_$_lo = paramCount$12;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$46, paramCount$12, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$().ao3(ReadersVersionSpecific_this$46), $m_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$().ao4());
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "uiComponentId") ? 0 : ((x === "cellContent") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("uiComponentId", new $c_sci_$colon$colon("cellContent", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23 = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellContentCssData$$anon$23, "com.papasofokli.dataTables.SimpleTableCellContentCssData$$anon$23", ({
  lL: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_SimpleTableCellS$().ao5(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_dataTables_SimpleTableCellS$().ao6());
}
$p = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3() {
}
$h_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "column": {
      return 1;
      break;
    }
    case "tableCellData": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("column", new $c_sci_$colon$colon("tableCellData", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_dataTables_SimpleTableCellS$$anon$3, "com.papasofokli.dataTables.SimpleTableCellS$$anon$3", ({
  lO: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$5(ReadersVersionSpecific_this$10, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellData$().aoc(ReadersVersionSpecific_this$10), $m_Lcom_papasofokli_dataTables_TableCellData$().aod());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$5() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "uiComponentId") ? 0 : ((x === "cellContent") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("uiComponentId", new $c_sci_$colon$colon("cellContent", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$5, "com.papasofokli.dataTables.TableCellData$$anon$5", ({
  lW: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$6(ReadersVersionSpecific_this$15, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$15, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellData$().aoe(ReadersVersionSpecific_this$15), $m_Lcom_papasofokli_dataTables_TableCellData$().aof());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$6.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$6() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$6.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "columnName": {
      return 1;
      break;
    }
    case "contentCssClass": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("columnName", new $c_sci_$colon$colon("contentCssClass", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$6, "com.papasofokli.dataTables.TableCellData$$anon$6", ({
  lX: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$7(ReadersVersionSpecific_this$20, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$20, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellData$().aog(ReadersVersionSpecific_this$20), $m_Lcom_papasofokli_dataTables_TableCellData$().ao7());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$7() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$7.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "contentCssClass": {
      return 1;
      break;
    }
    case "columnName": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("contentCssClass", new $c_sci_$colon$colon("columnName", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, "Status");
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$7, "com.papasofokli.dataTables.TableCellData$$anon$7", ({
  lY: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$8(ReadersVersionSpecific_this$25, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$25, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellData$().ao8(ReadersVersionSpecific_this$25), $m_Lcom_papasofokli_dataTables_TableCellData$().ao9());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$8.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$8() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$8.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "columnName": {
      return 1;
      break;
    }
    case "cellContentHtml": {
      return 2;
      break;
    }
    case "cellCssClass": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("columnName", new $c_sci_$colon$colon("cellContentHtml", new $c_sci_$colon$colon("cellCssClass", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$8, "com.papasofokli.dataTables.TableCellData$$anon$8", ({
  lZ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellData$$anon$9(ReadersVersionSpecific_this$30, paramCount$7, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$30, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellData$().aoa(ReadersVersionSpecific_this$30), $m_Lcom_papasofokli_dataTables_TableCellData$().aob());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellData$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellData$$anon$9() {
}
$h_Lcom_papasofokli_dataTables_TableCellData$$anon$9.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "columnName": {
      return 1;
      break;
    }
    case "cellCssClass": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("columnName", new $c_sci_$colon$colon("cellCssClass", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableCellData$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellData$$anon$9, "com.papasofokli.dataTables.TableCellData$$anon$9", ({
  m0: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableCellS$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableCellS$().aoh(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_dataTables_TableCellS$().aoi());
}
$p = $c_Lcom_papasofokli_dataTables_TableCellS$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableCellS$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableCellS$$anon$1() {
}
$h_Lcom_papasofokli_dataTables_TableCellS$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableCellData$().q()), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "column": {
      return 1;
      break;
    }
    case "tableCellData": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("column", new $c_sci_$colon$colon("tableCellData", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableCellS$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableCellS$$anon$1, "com.papasofokli.dataTables.TableCellS$$anon$1", ({
  m2: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableColumnProperties$().aoj(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_dataTables_TableColumnProperties$().aok());
}
$p = $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5() {
}
$h_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($m_Lupickle_default$().op, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "name": {
      return 0;
      break;
    }
    case "index": {
      return 1;
      break;
    }
    case "isHidden": {
      return 2;
      break;
    }
    case "isAdditional": {
      return 3;
      break;
    }
    case "sortIndex": {
      return 4;
      break;
    }
    case "columnType": {
      return 5;
      break;
    }
    case "hideAggregation": {
      return 6;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("index", new $c_sci_$colon$colon("isHidden", new $c_sci_$colon$colon("isAdditional", new $c_sci_$colon$colon("sortIndex", new $c_sci_$colon$colon("columnType", new $c_sci_$colon$colon("hideAggregation", $m_sci_Nil$())))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, false);
});
var $d_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableColumnProperties$$anon$5, "com.papasofokli.dataTables.TableColumnProperties$$anon$5", ({
  m5: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11(ReadersVersionSpecific_this$16, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$16, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableGroupRequest$().aol(ReadersVersionSpecific_this$16), $m_Lcom_papasofokli_dataTables_TableGroupRequest$().aom());
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11() {
}
$h_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple3Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), $m_Lupickle_default$().aT), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().aT, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().aT), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT)]);
  var this$30 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$30.G() >= 0)) {
    var destination = new $ac_O(this$30.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$30, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$30.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "keyValues": {
      return 0;
      break;
    }
    case "groupLevel": {
      return 1;
      break;
    }
    case "columnGroupBy": {
      return 2;
      break;
    }
    case "headersWidth": {
      return 3;
      break;
    }
    case "maxClientWidth": {
      return 4;
      break;
    }
    case "groupCalculationType": {
      return 5;
      break;
    }
    case "dateColumnGroupType": {
      return 6;
      break;
    }
    case "columnOrder": {
      return 7;
      break;
    }
    case "directionOrder": {
      return 8;
      break;
    }
    case "columnsSearch": {
      return 9;
      break;
    }
    case "blockAggregationIndexes": {
      return 10;
      break;
    }
    case "innerTablePageNo": {
      return 11;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["keyValues", "groupLevel", "columnGroupBy", "headersWidth", "maxClientWidth", "groupCalculationType", "dateColumnGroupType", "columnOrder", "directionOrder", "columnsSearch", "blockAggregationIndexes", "innerTablePageNo"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(4, $m_s_None$());
  x.ag(5, $m_s_None$());
  x.ag(6, $m_s_None$());
  x.ag(10, $m_Lcom_papasofokli_dataTables_TableGroupRequest$().I6());
  x.ag(11, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupRequest$$anon$11, "com.papasofokli.dataTables.TableGroupRequest$$anon$11", ({
  m9: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9(ReadersVersionSpecific_this$13, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableGroupedResult$().aoo(ReadersVersionSpecific_this$13), $m_Lcom_papasofokli_dataTables_TableGroupedResult$().aon());
}
$p = $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9() {
}
$h_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$20 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableSetupData$().q()), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_ColumnGroup$().q(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().J), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()))), new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$())))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$20);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "tableHtml": {
      return 0;
      break;
    }
    case "data": {
      return 1;
      break;
    }
    case "tableSetupData": {
      return 2;
      break;
    }
    case "groupedData": {
      return 3;
      break;
    }
    case "totalRecords": {
      return 4;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("tableHtml", new $c_sci_$colon$colon("data", new $c_sci_$colon$colon("tableSetupData", new $c_sci_$colon$colon("groupedData", new $c_sci_$colon$colon("totalRecords", $m_sci_Nil$())))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(0, $m_s_None$());
  x.ag(1, $m_sci_Nil$());
  x.ag(2, $m_s_None$());
  x.ag(3, $m_s_None$());
  x.ag(4, 0);
});
var $d_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableGroupedResult$$anon$9, "com.papasofokli.dataTables.TableGroupedResult$$anon$9", ({
  md: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableParameters$$anon$7(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableParameters$().aop(ReadersVersionSpecific_this$10), $m_Lcom_papasofokli_dataTables_TableParameters$().aoq());
}
$p = $c_Lcom_papasofokli_dataTables_TableParameters$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableParameters$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableParameters$$anon$7() {
}
$h_Lcom_papasofokli_dataTables_TableParameters$$anon$7.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().aT, $m_Lupickle_default$().aT, $m_Lupickle_default$().aT, $m_Lupickle_default$().J, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().bf, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_ColumnGroupOption$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().aT), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bf)]);
  var this$27 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$27.G() >= 0)) {
    var destination = new $ac_O(this$27.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$27, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$27.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "draw": {
      return 0;
      break;
    }
    case "start": {
      return 1;
      break;
    }
    case "length": {
      return 2;
      break;
    }
    case "search": {
      return 3;
      break;
    }
    case "columnOrder": {
      return 4;
      break;
    }
    case "directionOrder": {
      return 5;
      break;
    }
    case "columnsSearch": {
      return 6;
      break;
    }
    case "lazyLoad": {
      return 7;
      break;
    }
    case "columnGroupBy": {
      return 8;
      break;
    }
    case "blockAggregationIndexes": {
      return 9;
      break;
    }
    case "groupLevel": {
      return 10;
      break;
    }
    case "headersWidth": {
      return 11;
      break;
    }
    case "maxClientWidth": {
      return 12;
      break;
    }
    case "groupCalculationType": {
      return 13;
      break;
    }
    case "dateColumnGroupType": {
      return 14;
      break;
    }
    case "chartData": {
      return 15;
      break;
    }
    case "exportDetailsIndicator": {
      return 16;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["draw", "start", "length", "search", "columnOrder", "directionOrder", "columnsSearch", "lazyLoad", "columnGroupBy", "blockAggregationIndexes", "groupLevel", "headersWidth", "maxClientWidth", "groupCalculationType", "dateColumnGroupType", "chartData", "exportDetailsIndicator"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(8, $m_sci_Nil$());
  x.ag(9, $m_Lcom_papasofokli_dataTables_TableParameters$().oB());
  x.ag(10, $m_s_None$());
  x.ag(11, $m_Lcom_papasofokli_dataTables_TableParameters$().DJ());
  x.ag(12, $m_s_None$());
  x.ag(13, $m_s_None$());
  x.ag(14, $m_s_None$());
  x.ag(15, false);
  x.ag(16, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableParameters$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableParameters$$anon$7, "com.papasofokli.dataTables.TableParameters$$anon$7", ({
  mg: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_dataTables_TableSetupData$().aor(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_dataTables_TableSetupData$().aos());
}
$p = $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_dataTables_TableSetupData$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_dataTables_TableSetupData$$anon$3() {
}
$h_Lcom_papasofokli_dataTables_TableSetupData$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$13 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_dataTables_TableColumnProperties$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, $m_Lupickle_default$().aT), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aT), new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$()))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$13);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "columns": {
      return 0;
      break;
    }
    case "headersWidth": {
      return 1;
      break;
    }
    case "maxClientWidth": {
      return 2;
      break;
    }
    case "defaultRowsPerPage": {
      return 3;
      break;
    }
    case "additionalButtons": {
      return 4;
      break;
    }
    case "addNewButton": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("columns", new $c_sci_$colon$colon("headersWidth", new $c_sci_$colon$colon("maxClientWidth", new $c_sci_$colon$colon("defaultRowsPerPage", new $c_sci_$colon$colon("additionalButtons", new $c_sci_$colon$colon("addNewButton", $m_sci_Nil$()))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_s_None$());
  x.ag(4, $m_s_None$());
  x.ag(5, $m_s_None$());
});
var $d_Lcom_papasofokli_dataTables_TableSetupData$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_dataTables_TableSetupData$$anon$3, "com.papasofokli.dataTables.TableSetupData$$anon$3", ({
  mj: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aot(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_execution_JsStatement$().apr());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$1() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "tableId": {
      return 0;
      break;
    }
    case "index": {
      return 1;
      break;
    }
    case "sortDirection": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("tableId", new $c_sci_$colon$colon("index", new $c_sci_$colon$colon("sortDirection", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$1, "com.papasofokli.execution.JsStatement$$anon$1", ({
  mt: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$10(ReadersVersionSpecific_this$49, paramCount$10, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$10 <= 64)) {
    if ((paramCount$10 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$10) === 0) ? (1 << paramCount$10) : 0);
      var hi = (((32 & paramCount$10) === 0) ? 0 : (1 << paramCount$10));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$10 >> 31);
    var $x_1_$_lo = paramCount$10;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$49, paramCount$10, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apq(ReadersVersionSpecific_this$49), $m_Lcom_papasofokli_execution_JsStatement$().aps());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$10.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$10;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$10() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$10.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$10 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$10, "com.papasofokli.execution.JsStatement$$anon$10", ({
  mu: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$11(ReadersVersionSpecific_this$54, paramCount$11, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$11 <= 64)) {
    if ((paramCount$11 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$11) === 0) ? (1 << paramCount$11) : 0);
      var hi = (((32 & paramCount$11) === 0) ? 0 : (1 << paramCount$11));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$11 >> 31);
    var $x_1_$_lo = paramCount$11;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$54, paramCount$11, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apt(ReadersVersionSpecific_this$54), $m_Lcom_papasofokli_execution_JsStatement$().apu());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$11.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$11() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$11.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$11, "com.papasofokli.execution.JsStatement$$anon$11", ({
  mF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$12(ReadersVersionSpecific_this$59, paramCount$12, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$12 <= 64)) {
    if ((paramCount$12 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$12) === 0) ? (1 << paramCount$12) : 0);
      var hi = (((32 & paramCount$12) === 0) ? 0 : (1 << paramCount$12));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$12 >> 31);
    var $x_1_$_lo = paramCount$12;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$59, paramCount$12, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apv(ReadersVersionSpecific_this$59), $m_Lcom_papasofokli_execution_JsStatement$().apw());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$12.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$12() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$12.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$12, "com.papasofokli.execution.JsStatement$$anon$12", ({
  mQ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$13(ReadersVersionSpecific_this$64, paramCount$13, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$13 <= 64)) {
    if ((paramCount$13 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$13) === 0) ? (1 << paramCount$13) : 0);
      var hi = (((32 & paramCount$13) === 0) ? 0 : (1 << paramCount$13));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$13 >> 31);
    var $x_1_$_lo = paramCount$13;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$64, paramCount$13, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apx(ReadersVersionSpecific_this$64), $m_Lcom_papasofokli_execution_JsStatement$().apy());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$13.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$13() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$13.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$13, "com.papasofokli.execution.JsStatement$$anon$13", ({
  n1: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$14(ReadersVersionSpecific_this$69, paramCount$14, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$14 <= 64)) {
    if ((paramCount$14 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$14) === 0) ? (1 << paramCount$14) : 0);
      var hi = (((32 & paramCount$14) === 0) ? 0 : (1 << paramCount$14));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$14 >> 31);
    var $x_1_$_lo = paramCount$14;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$69, paramCount$14, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apz(ReadersVersionSpecific_this$69), $m_Lcom_papasofokli_execution_JsStatement$().apA());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$14.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$14;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$14() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$14.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$14 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$14, "com.papasofokli.execution.JsStatement$$anon$14", ({
  nc: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$15(ReadersVersionSpecific_this$74, paramCount$15, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$15 <= 64)) {
    if ((paramCount$15 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$15) === 0) ? (1 << paramCount$15) : 0);
      var hi = (((32 & paramCount$15) === 0) ? 0 : (1 << paramCount$15));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$15 >> 31);
    var $x_1_$_lo = paramCount$15;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$74, paramCount$15, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apB(ReadersVersionSpecific_this$74), $m_Lcom_papasofokli_execution_JsStatement$().apD());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$15.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$15;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$15() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$15.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "attributeName": {
      return 1;
      break;
    }
    case "idSuffix": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("attributeName", new $c_sci_$colon$colon("idSuffix", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, "");
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$15 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$15, "com.papasofokli.execution.JsStatement$$anon$15", ({
  nm: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$16(ReadersVersionSpecific_this$79, paramCount$16, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$16 <= 64)) {
    if ((paramCount$16 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$16) === 0) ? (1 << paramCount$16) : 0);
      var hi = (((32 & paramCount$16) === 0) ? 0 : (1 << paramCount$16));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$16 >> 31);
    var $x_1_$_lo = paramCount$16;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$79, paramCount$16, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apE(ReadersVersionSpecific_this$79), $m_Lcom_papasofokli_execution_JsStatement$().apF());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$16.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$16;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$16() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$16.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "attributeName": {
      return 1;
      break;
    }
    case "attributeValue": {
      return 2;
      break;
    }
    case "idSuffix": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("attributeName", new $c_sci_$colon$colon("attributeValue", new $c_sci_$colon$colon("idSuffix", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, "");
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$16 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$16, "com.papasofokli.execution.JsStatement$$anon$16", ({
  nn: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$17(ReadersVersionSpecific_this$84, paramCount$17, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$17 <= 64)) {
    if ((paramCount$17 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$17) === 0) ? (1 << paramCount$17) : 0);
      var hi = (((32 & paramCount$17) === 0) ? 0 : (1 << paramCount$17));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$17 >> 31);
    var $x_1_$_lo = paramCount$17;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$84, paramCount$17, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apG(ReadersVersionSpecific_this$84), $m_Lcom_papasofokli_execution_JsStatement$().apH());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$17.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$17;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$17() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$17.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$17 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$17, "com.papasofokli.execution.JsStatement$$anon$17", ({
  no: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$18(ReadersVersionSpecific_this$89, paramCount$18, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$18 <= 64)) {
    if ((paramCount$18 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$18) === 0) ? (1 << paramCount$18) : 0);
      var hi = (((32 & paramCount$18) === 0) ? 0 : (1 << paramCount$18));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$18 >> 31);
    var $x_1_$_lo = paramCount$18;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$89, paramCount$18, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apI(ReadersVersionSpecific_this$89), $m_Lcom_papasofokli_execution_JsStatement$().apJ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$18.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$18;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$18() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$18.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : ((x === "isModal") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("isModal", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$18 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$18, "com.papasofokli.execution.JsStatement$$anon$18", ({
  np: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$19(ReadersVersionSpecific_this$94, paramCount$19, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$19 <= 64)) {
    if ((paramCount$19 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$19) === 0) ? (1 << paramCount$19) : 0);
      var hi = (((32 & paramCount$19) === 0) ? 0 : (1 << paramCount$19));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$19 >> 31);
    var $x_1_$_lo = paramCount$19;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$94, paramCount$19, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apK(ReadersVersionSpecific_this$94), $m_Lcom_papasofokli_execution_JsStatement$().apL());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$19.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$19;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$19() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$19.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$19 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$19, "com.papasofokli.execution.JsStatement$$anon$19", ({
  nq: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$2(ReadersVersionSpecific_this$9, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$9, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apC(ReadersVersionSpecific_this$9), $m_Lcom_papasofokli_execution_JsStatement$().apN());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$2() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$2.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "tableId") ? 0 : ((x === "index") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("tableId", new $c_sci_$colon$colon("index", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$2, "com.papasofokli.execution.JsStatement$$anon$2", ({
  nr: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$20(ReadersVersionSpecific_this$99, paramCount$20, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$20 <= 64)) {
    if ((paramCount$20 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$20) === 0) ? (1 << paramCount$20) : 0);
      var hi = (((32 & paramCount$20) === 0) ? 0 : (1 << paramCount$20));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$20 >> 31);
    var $x_1_$_lo = paramCount$20;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$99, paramCount$20, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apM(ReadersVersionSpecific_this$99), $m_Lcom_papasofokli_execution_JsStatement$().apO());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$20.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$20;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$20() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$20.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_jstree_TreeItemData$().q();
  var this$6 = new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.jstree.TreeNodeData", "TreeNodeData", e.f5("com.papasofokli.jstree.TreeNodeData")), new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "node": {
      return 0;
      break;
    }
    case "withRefresh": {
      return 1;
      break;
    }
    case "clickFunctionId": {
      return 2;
      break;
    }
    case "leafClickFunctionId": {
      return 3;
      break;
    }
    case "contextMenuFunctionId": {
      return 4;
      break;
    }
    case "expandOnDoubleClick": {
      return 5;
      break;
    }
    case "cssClass": {
      return 6;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("node", new $c_sci_$colon$colon("withRefresh", new $c_sci_$colon$colon("clickFunctionId", new $c_sci_$colon$colon("leafClickFunctionId", new $c_sci_$colon$colon("contextMenuFunctionId", new $c_sci_$colon$colon("expandOnDoubleClick", new $c_sci_$colon$colon("cssClass", $m_sci_Nil$())))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$20 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$20, "com.papasofokli.execution.JsStatement$$anon$20", ({
  ns: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$21(ReadersVersionSpecific_this$104, paramCount$21, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$21 <= 64)) {
    if ((paramCount$21 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$21) === 0) ? (1 << paramCount$21) : 0);
      var hi = (((32 & paramCount$21) === 0) ? 0 : (1 << paramCount$21));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$21 >> 31);
    var $x_1_$_lo = paramCount$21;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$104, paramCount$21, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apP(ReadersVersionSpecific_this$104), $m_Lcom_papasofokli_execution_JsStatement$().apQ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$21.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$21;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$21() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$21.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "ulId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("ulId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$21 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$21, "com.papasofokli.execution.JsStatement$$anon$21", ({
  nt: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$22(ReadersVersionSpecific_this$109, paramCount$22, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$22 <= 64)) {
    if ((paramCount$22 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$22) === 0) ? (1 << paramCount$22) : 0);
      var hi = (((32 & paramCount$22) === 0) ? 0 : (1 << paramCount$22));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$22 >> 31);
    var $x_1_$_lo = paramCount$22;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$109, paramCount$22, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apR(ReadersVersionSpecific_this$109), $m_Lcom_papasofokli_execution_JsStatement$().apS());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$22.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$22;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$22() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$22.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$22 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$22, "com.papasofokli.execution.JsStatement$$anon$22", ({
  nu: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$23(ReadersVersionSpecific_this$114, paramCount$23, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$23 <= 64)) {
    if ((paramCount$23 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$23) === 0) ? (1 << paramCount$23) : 0);
      var hi = (((32 & paramCount$23) === 0) ? 0 : (1 << paramCount$23));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$23 >> 31);
    var $x_1_$_lo = paramCount$23;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$114, paramCount$23, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apT(ReadersVersionSpecific_this$114), $m_Lcom_papasofokli_execution_JsStatement$().apU());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$23.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$23;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$23() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$23.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$23 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$23, "com.papasofokli.execution.JsStatement$$anon$23", ({
  nv: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$24(ReadersVersionSpecific_this$119, paramCount$24, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$24 <= 64)) {
    if ((paramCount$24 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$24) === 0) ? (1 << paramCount$24) : 0);
      var hi = (((32 & paramCount$24) === 0) ? 0 : (1 << paramCount$24));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$24 >> 31);
    var $x_1_$_lo = paramCount$24;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$119, paramCount$24, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apV(ReadersVersionSpecific_this$119), $m_Lcom_papasofokli_execution_JsStatement$().apW());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$24.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$24;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$24() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$24.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().op, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_ProgressBarStyle$().q()), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "progressBarId": {
      return 0;
      break;
    }
    case "value": {
      return 1;
      break;
    }
    case "style": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("progressBarId", new $c_sci_$colon$colon("value", new $c_sci_$colon$colon("style", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$24 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$24, "com.papasofokli.execution.JsStatement$$anon$24", ({
  nw: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$25(ReadersVersionSpecific_this$124, paramCount$25, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$25 <= 64)) {
    if ((paramCount$25 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$25) === 0) ? (1 << paramCount$25) : 0);
      var hi = (((32 & paramCount$25) === 0) ? 0 : (1 << paramCount$25));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$25 >> 31);
    var $x_1_$_lo = paramCount$25;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$124, paramCount$25, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apX(ReadersVersionSpecific_this$124), $m_Lcom_papasofokli_execution_JsStatement$().apZ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$25.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$25;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$25() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$25.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "plannerId": {
      return 0;
      break;
    }
    case "rowId": {
      return 1;
      break;
    }
    case "index": {
      return 2;
      break;
    }
    case "periods": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rowId", new $c_sci_$colon$colon("index", new $c_sci_$colon$colon("periods", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$25 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$25, "com.papasofokli.execution.JsStatement$$anon$25", ({
  nx: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$26(ReadersVersionSpecific_this$129, paramCount$26, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$26 <= 64)) {
    if ((paramCount$26 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$26) === 0) ? (1 << paramCount$26) : 0);
      var hi = (((32 & paramCount$26) === 0) ? 0 : (1 << paramCount$26));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$26 >> 31);
    var $x_1_$_lo = paramCount$26;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$129, paramCount$26, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aq0(ReadersVersionSpecific_this$129), $m_Lcom_papasofokli_execution_JsStatement$().aq1());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$26.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$26;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$26() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$26.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$26 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$26, "com.papasofokli.execution.JsStatement$$anon$26", ({
  ny: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$27(ReadersVersionSpecific_this$134, paramCount$27, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$27 <= 64)) {
    if ((paramCount$27 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$27) === 0) ? (1 << paramCount$27) : 0);
      var hi = (((32 & paramCount$27) === 0) ? 0 : (1 << paramCount$27));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$27 >> 31);
    var $x_1_$_lo = paramCount$27;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$134, paramCount$27, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aq2(ReadersVersionSpecific_this$134), $m_Lcom_papasofokli_execution_JsStatement$().aq3());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$27.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$27;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$27() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$27.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : ((x === "rangeSeq") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rangeSeq", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$27 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$27, "com.papasofokli.execution.JsStatement$$anon$27", ({
  nz: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$28(ReadersVersionSpecific_this$139, paramCount$28, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$28 <= 64)) {
    if ((paramCount$28 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$28) === 0) ? (1 << paramCount$28) : 0);
      var hi = (((32 & paramCount$28) === 0) ? 0 : (1 << paramCount$28));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$28 >> 31);
    var $x_1_$_lo = paramCount$28;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$139, paramCount$28, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aq4(ReadersVersionSpecific_this$139), $m_Lcom_papasofokli_execution_JsStatement$().aq5());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$28.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$28;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$28() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$28.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : ((x === "rangeSeq") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rangeSeq", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$28 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$28, "com.papasofokli.execution.JsStatement$$anon$28", ({
  nA: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$29(ReadersVersionSpecific_this$144, paramCount$29, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$29 <= 64)) {
    if ((paramCount$29 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$29) === 0) ? (1 << paramCount$29) : 0);
      var hi = (((32 & paramCount$29) === 0) ? 0 : (1 << paramCount$29));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$29 >> 31);
    var $x_1_$_lo = paramCount$29;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$144, paramCount$29, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aq6(ReadersVersionSpecific_this$144), $m_Lcom_papasofokli_execution_JsStatement$().aq7());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$29.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$29;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$29() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$29.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$29 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$29, "com.papasofokli.execution.JsStatement$$anon$29", ({
  nB: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$3(ReadersVersionSpecific_this$14, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$14, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apY(ReadersVersionSpecific_this$14), $m_Lcom_papasofokli_execution_JsStatement$().aq9());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$3() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "videoId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("videoId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$3, "com.papasofokli.execution.JsStatement$$anon$3", ({
  nC: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$30(ReadersVersionSpecific_this$149, paramCount$30, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$30 <= 64)) {
    if ((paramCount$30 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$30) === 0) ? (1 << paramCount$30) : 0);
      var hi = (((32 & paramCount$30) === 0) ? 0 : (1 << paramCount$30));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$30 >> 31);
    var $x_1_$_lo = paramCount$30;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$149, paramCount$30, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aq8(ReadersVersionSpecific_this$149), $m_Lcom_papasofokli_execution_JsStatement$().aqa());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$30.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$30;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$30() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$30.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "plannerId": {
      return 0;
      break;
    }
    case "fromTime": {
      return 1;
      break;
    }
    case "toTime": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("fromTime", new $c_sci_$colon$colon("toTime", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$30 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$30, "com.papasofokli.execution.JsStatement$$anon$30", ({
  nD: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$31(ReadersVersionSpecific_this$154, paramCount$31, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$31 <= 64)) {
    if ((paramCount$31 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$31) === 0) ? (1 << paramCount$31) : 0);
      var hi = (((32 & paramCount$31) === 0) ? 0 : (1 << paramCount$31));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$31 >> 31);
    var $x_1_$_lo = paramCount$31;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$154, paramCount$31, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqb(ReadersVersionSpecific_this$154), $m_Lcom_papasofokli_execution_JsStatement$().aqc());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$31.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$31;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$31() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$31.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "plannerId": {
      return 0;
      break;
    }
    case "subjectId": {
      return 1;
      break;
    }
    case "periodSeq": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("subjectId", new $c_sci_$colon$colon("periodSeq", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$31 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$31, "com.papasofokli.execution.JsStatement$$anon$31", ({
  nE: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$32(ReadersVersionSpecific_this$159, paramCount$32, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$32 <= 64)) {
    if ((paramCount$32 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$32) === 0) ? (1 << paramCount$32) : 0);
      var hi = (((32 & paramCount$32) === 0) ? 0 : (1 << paramCount$32));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$32 >> 31);
    var $x_1_$_lo = paramCount$32;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$159, paramCount$32, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqd(ReadersVersionSpecific_this$159), $m_Lcom_papasofokli_execution_JsStatement$().aqe());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$32.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$32;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$32() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$32.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "plannerId": {
      return 0;
      break;
    }
    case "rowId": {
      return 1;
      break;
    }
    case "periods": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rowId", new $c_sci_$colon$colon("periods", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$32 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$32, "com.papasofokli.execution.JsStatement$$anon$32", ({
  nF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$33(ReadersVersionSpecific_this$164, paramCount$33, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$33 <= 64)) {
    if ((paramCount$33 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$33) === 0) ? (1 << paramCount$33) : 0);
      var hi = (((32 & paramCount$33) === 0) ? 0 : (1 << paramCount$33));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$33 >> 31);
    var $x_1_$_lo = paramCount$33;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$164, paramCount$33, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqf(ReadersVersionSpecific_this$164), $m_Lcom_papasofokli_execution_JsStatement$().aqg());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$33.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$33;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$33() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$33.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "plannerId": {
      return 0;
      break;
    }
    case "rowId": {
      return 1;
      break;
    }
    case "index": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rowId", new $c_sci_$colon$colon("index", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$33 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$33, "com.papasofokli.execution.JsStatement$$anon$33", ({
  nG: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$34(ReadersVersionSpecific_this$169, paramCount$34, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$34 <= 64)) {
    if ((paramCount$34 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$34) === 0) ? (1 << paramCount$34) : 0);
      var hi = (((32 & paramCount$34) === 0) ? 0 : (1 << paramCount$34));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$34 >> 31);
    var $x_1_$_lo = paramCount$34;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$169, paramCount$34, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqh(ReadersVersionSpecific_this$169), $m_Lcom_papasofokli_execution_JsStatement$().aqi());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$34.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$34;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$34() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$34.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : ((x === "rowId") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("rowId", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$34 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$34, "com.papasofokli.execution.JsStatement$$anon$34", ({
  nH: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$35(ReadersVersionSpecific_this$174, paramCount$35, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$35 <= 64)) {
    if ((paramCount$35 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$35) === 0) ? (1 << paramCount$35) : 0);
      var hi = (((32 & paramCount$35) === 0) ? 0 : (1 << paramCount$35));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$35 >> 31);
    var $x_1_$_lo = paramCount$35;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$174, paramCount$35, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqj(ReadersVersionSpecific_this$174), $m_Lcom_papasofokli_execution_JsStatement$().aql());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$35.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$35;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$35() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$35.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : ((x === "sidebarSize") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("sidebarSize", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$35 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$35, "com.papasofokli.execution.JsStatement$$anon$35", ({
  nI: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$36(ReadersVersionSpecific_this$179, paramCount$36, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$36 <= 64)) {
    if ((paramCount$36 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$36) === 0) ? (1 << paramCount$36) : 0);
      var hi = (((32 & paramCount$36) === 0) ? 0 : (1 << paramCount$36));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$36 >> 31);
    var $x_1_$_lo = paramCount$36;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$179, paramCount$36, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqm(ReadersVersionSpecific_this$179), $m_Lcom_papasofokli_execution_JsStatement$().aqn());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$36.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$36;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$36() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$36.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$36 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$36, "com.papasofokli.execution.JsStatement$$anon$36", ({
  nJ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$37(ReadersVersionSpecific_this$184, paramCount$37, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$37 <= 64)) {
    if ((paramCount$37 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$37) === 0) ? (1 << paramCount$37) : 0);
      var hi = (((32 & paramCount$37) === 0) ? 0 : (1 << paramCount$37));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$37 >> 31);
    var $x_1_$_lo = paramCount$37;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$184, paramCount$37, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqo(ReadersVersionSpecific_this$184), $m_Lcom_papasofokli_execution_JsStatement$().aqp());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$37.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$37;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$37() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$37.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$37 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$37, "com.papasofokli.execution.JsStatement$$anon$37", ({
  nK: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$38(ReadersVersionSpecific_this$189, paramCount$38, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$38 <= 64)) {
    if ((paramCount$38 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$38) === 0) ? (1 << paramCount$38) : 0);
      var hi = (((32 & paramCount$38) === 0) ? 0 : (1 << paramCount$38));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$38 >> 31);
    var $x_1_$_lo = paramCount$38;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$189, paramCount$38, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqq(ReadersVersionSpecific_this$189), $m_Lcom_papasofokli_execution_JsStatement$().aqr());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$38.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$38;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$38() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$38.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().oq, new $c_sci_$colon$colon($m_Lcom_papasofokli_execution_ModalRatio$().q(), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "side1Id": {
      return 0;
      break;
    }
    case "side2Id": {
      return 1;
      break;
    }
    case "percentage": {
      return 2;
      break;
    }
    case "ratio": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("side1Id", new $c_sci_$colon$colon("side2Id", new $c_sci_$colon$colon("percentage", new $c_sci_$colon$colon("ratio", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$38 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$38, "com.papasofokli.execution.JsStatement$$anon$38", ({
  nL: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$39(ReadersVersionSpecific_this$194, paramCount$39, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$39 <= 64)) {
    if ((paramCount$39 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$39) === 0) ? (1 << paramCount$39) : 0);
      var hi = (((32 & paramCount$39) === 0) ? 0 : (1 << paramCount$39));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$39 >> 31);
    var $x_1_$_lo = paramCount$39;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$194, paramCount$39, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqs(ReadersVersionSpecific_this$194), $m_Lcom_papasofokli_execution_JsStatement$().aqt());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$39.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$39;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$39() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$39.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().oq, new $c_sci_$colon$colon($m_Lcom_papasofokli_execution_ModalRatio$().q(), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "side1Id": {
      return 0;
      break;
    }
    case "side2Id": {
      return 1;
      break;
    }
    case "percentage": {
      return 2;
      break;
    }
    case "ratio": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("side1Id", new $c_sci_$colon$colon("side2Id", new $c_sci_$colon$colon("percentage", new $c_sci_$colon$colon("ratio", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$39 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$39, "com.papasofokli.execution.JsStatement$$anon$39", ({
  nM: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$4(ReadersVersionSpecific_this$19, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqk(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_execution_JsStatement$().aqv());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$4() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$4.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "agileBoard2Id": {
      return 0;
      break;
    }
    case "column": {
      return 1;
      break;
    }
    case "columnContent": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("agileBoard2Id", new $c_sci_$colon$colon("column", new $c_sci_$colon$colon("columnContent", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$4, "com.papasofokli.execution.JsStatement$$anon$4", ({
  nN: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$40(ReadersVersionSpecific_this$199, paramCount$40, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$40 <= 64)) {
    if ((paramCount$40 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$40) === 0) ? (1 << paramCount$40) : 0);
      var hi = (((32 & paramCount$40) === 0) ? 0 : (1 << paramCount$40));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$40 >> 31);
    var $x_1_$_lo = paramCount$40;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$199, paramCount$40, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqu(ReadersVersionSpecific_this$199), $m_Lcom_papasofokli_execution_JsStatement$().aqw());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$40.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$40;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$40() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$40.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$40 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$40, "com.papasofokli.execution.JsStatement$$anon$40", ({
  nO: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$41(ReadersVersionSpecific_this$204, paramCount$41, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$41 <= 64)) {
    if ((paramCount$41 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$41) === 0) ? (1 << paramCount$41) : 0);
      var hi = (((32 & paramCount$41) === 0) ? 0 : (1 << paramCount$41));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$41 >> 31);
    var $x_1_$_lo = paramCount$41;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$204, paramCount$41, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqx(ReadersVersionSpecific_this$204), $m_Lcom_papasofokli_execution_JsStatement$().aqy());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$41.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$41;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$41() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$41.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$41 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$41, "com.papasofokli.execution.JsStatement$$anon$41", ({
  nP: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$42(ReadersVersionSpecific_this$209, paramCount$42, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$42 <= 64)) {
    if ((paramCount$42 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$42) === 0) ? (1 << paramCount$42) : 0);
      var hi = (((32 & paramCount$42) === 0) ? 0 : (1 << paramCount$42));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$42 >> 31);
    var $x_1_$_lo = paramCount$42;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$209, paramCount$42, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqz(ReadersVersionSpecific_this$209), $m_Lcom_papasofokli_execution_JsStatement$().aqA());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$42.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$42;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$42() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$42.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "html": {
      return 1;
      break;
    }
    case "smooth": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("html", new $c_sci_$colon$colon("smooth", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$42 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$42, "com.papasofokli.execution.JsStatement$$anon$42", ({
  nQ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$43(ReadersVersionSpecific_this$214, paramCount$43, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$43 <= 64)) {
    if ((paramCount$43 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$43) === 0) ? (1 << paramCount$43) : 0);
      var hi = (((32 & paramCount$43) === 0) ? 0 : (1 << paramCount$43));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$43 >> 31);
    var $x_1_$_lo = paramCount$43;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$214, paramCount$43, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqB(ReadersVersionSpecific_this$214), $m_Lcom_papasofokli_execution_JsStatement$().aqC());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$43.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$43;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$43() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$43.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$43 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$43, "com.papasofokli.execution.JsStatement$$anon$43", ({
  nR: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$44(ReadersVersionSpecific_this$219, paramCount$44, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$44 <= 64)) {
    if ((paramCount$44 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$44) === 0) ? (1 << paramCount$44) : 0);
      var hi = (((32 & paramCount$44) === 0) ? 0 : (1 << paramCount$44));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$44 >> 31);
    var $x_1_$_lo = paramCount$44;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$219, paramCount$44, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqD(ReadersVersionSpecific_this$219), $m_Lcom_papasofokli_execution_JsStatement$().aqE());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$44.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$44;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$44() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$44.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$44 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$44, "com.papasofokli.execution.JsStatement$$anon$44", ({
  nS: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$45(ReadersVersionSpecific_this$224, paramCount$45, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$45 <= 64)) {
    if ((paramCount$45 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$45) === 0) ? (1 << paramCount$45) : 0);
      var hi = (((32 & paramCount$45) === 0) ? 0 : (1 << paramCount$45));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$45 >> 31);
    var $x_1_$_lo = paramCount$45;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$224, paramCount$45, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqF(ReadersVersionSpecific_this$224), $m_Lcom_papasofokli_execution_JsStatement$().aqH());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$45.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$45;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$45() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$45.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "html": {
      return 1;
      break;
    }
    case "smooth": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("html", new $c_sci_$colon$colon("smooth", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$45 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$45, "com.papasofokli.execution.JsStatement$$anon$45", ({
  nT: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$46(ReadersVersionSpecific_this$229, paramCount$46, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$46 <= 64)) {
    if ((paramCount$46 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$46) === 0) ? (1 << paramCount$46) : 0);
      var hi = (((32 & paramCount$46) === 0) ? 0 : (1 << paramCount$46));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$46 >> 31);
    var $x_1_$_lo = paramCount$46;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$229, paramCount$46, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqI(ReadersVersionSpecific_this$229), $m_Lcom_papasofokli_execution_JsStatement$().aqJ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$46.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$46;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$46() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$46.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : ((x === "compact") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", new $c_sci_$colon$colon("compact", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$46 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$46, "com.papasofokli.execution.JsStatement$$anon$46", ({
  nU: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$47(ReadersVersionSpecific_this$234, paramCount$47, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$47 <= 64)) {
    if ((paramCount$47 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$47) === 0) ? (1 << paramCount$47) : 0);
      var hi = (((32 & paramCount$47) === 0) ? 0 : (1 << paramCount$47));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$47 >> 31);
    var $x_1_$_lo = paramCount$47;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$234, paramCount$47, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqK(ReadersVersionSpecific_this$234), $m_Lcom_papasofokli_execution_JsStatement$().aqL());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$47.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$47;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$47() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$47.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$47 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$47, "com.papasofokli.execution.JsStatement$$anon$47", ({
  nV: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$48(ReadersVersionSpecific_this$239, paramCount$48, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$48 <= 64)) {
    if ((paramCount$48 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$48) === 0) ? (1 << paramCount$48) : 0);
      var hi = (((32 & paramCount$48) === 0) ? 0 : (1 << paramCount$48));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$48 >> 31);
    var $x_1_$_lo = paramCount$48;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$239, paramCount$48, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqM(ReadersVersionSpecific_this$239), $m_Lcom_papasofokli_execution_JsStatement$().aqN());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$48.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$48;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$48() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$48.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "href") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("href", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$48 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$48, "com.papasofokli.execution.JsStatement$$anon$48", ({
  nW: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$49(ReadersVersionSpecific_this$244, paramCount$49, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$49 <= 64)) {
    if ((paramCount$49 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$49) === 0) ? (1 << paramCount$49) : 0);
      var hi = (((32 & paramCount$49) === 0) ? 0 : (1 << paramCount$49));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$49 >> 31);
    var $x_1_$_lo = paramCount$49;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$244, paramCount$49, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqO(ReadersVersionSpecific_this$244), $m_Lcom_papasofokli_execution_JsStatement$().aqP());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$49.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$49;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$49() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$49.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "printerName") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("printerName", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$49 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$49, "com.papasofokli.execution.JsStatement$$anon$49", ({
  nX: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$5(ReadersVersionSpecific_this$24, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$24, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqG(ReadersVersionSpecific_this$24), $m_Lcom_papasofokli_execution_JsStatement$().aou());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$5() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$5.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$5, "com.papasofokli.execution.JsStatement$$anon$5", ({
  nY: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$50(ReadersVersionSpecific_this$249, paramCount$50, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$50 <= 64)) {
    if ((paramCount$50 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$50) === 0) ? (1 << paramCount$50) : 0);
      var hi = (((32 & paramCount$50) === 0) ? 0 : (1 << paramCount$50));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$50 >> 31);
    var $x_1_$_lo = paramCount$50;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$249, paramCount$50, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aqQ(ReadersVersionSpecific_this$249), $m_Lcom_papasofokli_execution_JsStatement$().aov());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$50.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$50;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$50() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$50.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = $m_Lupickle_default$();
  var evidence$1 = $m_Lupickle_default$().LU;
  var evidence$2;
  var evidence$2 = $m_s_reflect_ManifestFactory$ByteManifest$();
  var x$2 = this$3.LU;
  var this$6 = new $c_sci_$colon$colon((((evidence$1 === null) ? (x$2 === null) : (evidence$1 === x$2)) ? new $c_Lupickle_implicits_Readers$$anon$22(evidence$2, evidence$1, this$3) : new $c_Lupickle_implicits_Readers$$anon$24(evidence$2, evidence$1, this$3)), new $c_sci_$colon$colon($m_Lupickle_default$().oq, new $c_sci_$colon$colon($m_Lupickle_default$().oq, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$()))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "pdfBytes": {
      return 0;
      break;
    }
    case "contentHeight": {
      return 1;
      break;
    }
    case "documentWidth": {
      return 2;
      break;
    }
    case "printerName": {
      return 3;
      break;
    }
    case "jobName": {
      return 4;
      break;
    }
    case "openCashbox": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("pdfBytes", new $c_sci_$colon$colon("contentHeight", new $c_sci_$colon$colon("documentWidth", new $c_sci_$colon$colon("printerName", new $c_sci_$colon$colon("jobName", new $c_sci_$colon$colon("openCashbox", $m_sci_Nil$()))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$50 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$50, "com.papasofokli.execution.JsStatement$$anon$50", ({
  nZ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$51(ReadersVersionSpecific_this$254, paramCount$51, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$51 <= 64)) {
    if ((paramCount$51 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$51) === 0) ? (1 << paramCount$51) : 0);
      var hi = (((32 & paramCount$51) === 0) ? 0 : (1 << paramCount$51));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$51 >> 31);
    var $x_1_$_lo = paramCount$51;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$254, paramCount$51, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aow(ReadersVersionSpecific_this$254), $m_Lcom_papasofokli_execution_JsStatement$().aox());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$51.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$51;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$51() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$51.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "url") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("url", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$51 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$51, "com.papasofokli.execution.JsStatement$$anon$51", ({
  o0: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$52(ReadersVersionSpecific_this$259, paramCount$52, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$52 <= 64)) {
    if ((paramCount$52 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$52) === 0) ? (1 << paramCount$52) : 0);
      var hi = (((32 & paramCount$52) === 0) ? 0 : (1 << paramCount$52));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$52 >> 31);
    var $x_1_$_lo = paramCount$52;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$259, paramCount$52, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoy(ReadersVersionSpecific_this$259), $m_Lcom_papasofokli_execution_JsStatement$().aoz());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$52.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$52;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$52() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$52.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$52 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$52, "com.papasofokli.execution.JsStatement$$anon$52", ({
  o1: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$53(ReadersVersionSpecific_this$264, paramCount$53, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$53 <= 64)) {
    if ((paramCount$53 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$53) === 0) ? (1 << paramCount$53) : 0);
      var hi = (((32 & paramCount$53) === 0) ? 0 : (1 << paramCount$53));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$53 >> 31);
    var $x_1_$_lo = paramCount$53;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$264, paramCount$53, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoA(ReadersVersionSpecific_this$264), $m_Lcom_papasofokli_execution_JsStatement$().aoB());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$53.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$53;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$53() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$53.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "number") ? 0 : ((x === "id") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("number", new $c_sci_$colon$colon("id", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$53 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$53, "com.papasofokli.execution.JsStatement$$anon$53", ({
  o2: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$54(ReadersVersionSpecific_this$269, paramCount$54, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$54 <= 64)) {
    if ((paramCount$54 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$54) === 0) ? (1 << paramCount$54) : 0);
      var hi = (((32 & paramCount$54) === 0) ? 0 : (1 << paramCount$54));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$54 >> 31);
    var $x_1_$_lo = paramCount$54;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$269, paramCount$54, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoC(ReadersVersionSpecific_this$269), $m_Lcom_papasofokli_execution_JsStatement$().aoD());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$54.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$54;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$54() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$54.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "alwaysHidden") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("alwaysHidden", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$54 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$54, "com.papasofokli.execution.JsStatement$$anon$54", ({
  o3: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$55(ReadersVersionSpecific_this$274, paramCount$55, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$55 <= 64)) {
    if ((paramCount$55 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$55) === 0) ? (1 << paramCount$55) : 0);
      var hi = (((32 & paramCount$55) === 0) ? 0 : (1 << paramCount$55));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$55 >> 31);
    var $x_1_$_lo = paramCount$55;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$274, paramCount$55, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoE(ReadersVersionSpecific_this$274), $m_Lcom_papasofokli_execution_JsStatement$().aoG());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$55.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$55;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$55() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$55.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "url") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("url", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$55 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$55, "com.papasofokli.execution.JsStatement$$anon$55", ({
  o4: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$56(ReadersVersionSpecific_this$279, paramCount$56, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$56 <= 64)) {
    if ((paramCount$56 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$56) === 0) ? (1 << paramCount$56) : 0);
      var hi = (((32 & paramCount$56) === 0) ? 0 : (1 << paramCount$56));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$56 >> 31);
    var $x_1_$_lo = paramCount$56;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$279, paramCount$56, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoH(ReadersVersionSpecific_this$279), $m_Lcom_papasofokli_execution_JsStatement$().aoI());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$56.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$56;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$56() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$56.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "url") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("url", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$56 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$56, "com.papasofokli.execution.JsStatement$$anon$56", ({
  o5: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$57(ReadersVersionSpecific_this$284, paramCount$57, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$57 <= 64)) {
    if ((paramCount$57 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$57) === 0) ? (1 << paramCount$57) : 0);
      var hi = (((32 & paramCount$57) === 0) ? 0 : (1 << paramCount$57));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$57 >> 31);
    var $x_1_$_lo = paramCount$57;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$284, paramCount$57, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoJ(ReadersVersionSpecific_this$284), $m_Lcom_papasofokli_execution_JsStatement$().aoK());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$57.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$57;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$57() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$57.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "title") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("title", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$57 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$57, "com.papasofokli.execution.JsStatement$$anon$57", ({
  o6: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$58(ReadersVersionSpecific_this$289, paramCount$58, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$58 <= 64)) {
    if ((paramCount$58 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$58) === 0) ? (1 << paramCount$58) : 0);
      var hi = (((32 & paramCount$58) === 0) ? 0 : (1 << paramCount$58));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$58 >> 31);
    var $x_1_$_lo = paramCount$58;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$289, paramCount$58, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoL(ReadersVersionSpecific_this$289), $m_Lcom_papasofokli_execution_JsStatement$().aoM());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$58.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$58;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$58() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$58.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "url") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("url", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$58 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$58, "com.papasofokli.execution.JsStatement$$anon$58", ({
  o7: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$59(ReadersVersionSpecific_this$294, paramCount$59, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$59 <= 64)) {
    if ((paramCount$59 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$59) === 0) ? (1 << paramCount$59) : 0);
      var hi = (((32 & paramCount$59) === 0) ? 0 : (1 << paramCount$59));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$59 >> 31);
    var $x_1_$_lo = paramCount$59;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$294, paramCount$59, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoN(ReadersVersionSpecific_this$294), $m_Lcom_papasofokli_execution_JsStatement$().aoO());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$59.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$59;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$59() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$59.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "url": {
      return 0;
      break;
    }
    case "target": {
      return 1;
      break;
    }
    case "warnIfIsBlocked": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("url", new $c_sci_$colon$colon("target", new $c_sci_$colon$colon("warnIfIsBlocked", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, false);
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$59 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$59, "com.papasofokli.execution.JsStatement$$anon$59", ({
  o8: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$6(ReadersVersionSpecific_this$29, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$29, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoF(ReadersVersionSpecific_this$29), $m_Lcom_papasofokli_execution_JsStatement$().aoQ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$6.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$6;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$6() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$6.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "tableId") ? 0 : ((x === "cssClass") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("tableId", new $c_sci_$colon$colon("cssClass", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$6 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$6, "com.papasofokli.execution.JsStatement$$anon$6", ({
  o9: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$60(ReadersVersionSpecific_this$299, paramCount$60, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$60 <= 64)) {
    if ((paramCount$60 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$60) === 0) ? (1 << paramCount$60) : 0);
      var hi = (((32 & paramCount$60) === 0) ? 0 : (1 << paramCount$60));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$60 >> 31);
    var $x_1_$_lo = paramCount$60;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$299, paramCount$60, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoP(ReadersVersionSpecific_this$299), $m_Lcom_papasofokli_execution_JsStatement$().aoR());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$60.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$60;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$60() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$60.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "cssClass") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("cssClass", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$60 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$60, "com.papasofokli.execution.JsStatement$$anon$60", ({
  oa: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$61(ReadersVersionSpecific_this$304, paramCount$61, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$61 <= 64)) {
    if ((paramCount$61 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$61) === 0) ? (1 << paramCount$61) : 0);
      var hi = (((32 & paramCount$61) === 0) ? 0 : (1 << paramCount$61));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$61 >> 31);
    var $x_1_$_lo = paramCount$61;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$304, paramCount$61, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoS(ReadersVersionSpecific_this$304), $m_Lcom_papasofokli_execution_JsStatement$().aoT());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$61.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$61;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$61() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$61.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "elementId") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("elementId", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$61 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$61, "com.papasofokli.execution.JsStatement$$anon$61", ({
  ob: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$62(ReadersVersionSpecific_this$309, paramCount$62, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$62 <= 64)) {
    if ((paramCount$62 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$62) === 0) ? (1 << paramCount$62) : 0);
      var hi = (((32 & paramCount$62) === 0) ? 0 : (1 << paramCount$62));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$62 >> 31);
    var $x_1_$_lo = paramCount$62;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$309, paramCount$62, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoU(ReadersVersionSpecific_this$309), $m_Lcom_papasofokli_execution_JsStatement$().aoV());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$62.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$62;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$62() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$62.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "elementId") ? 0 : ((x === "html") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("elementId", new $c_sci_$colon$colon("html", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$62 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$62, "com.papasofokli.execution.JsStatement$$anon$62", ({
  oc: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$63(ReadersVersionSpecific_this$314, paramCount$63, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$63 <= 64)) {
    if ((paramCount$63 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$63) === 0) ? (1 << paramCount$63) : 0);
      var hi = (((32 & paramCount$63) === 0) ? 0 : (1 << paramCount$63));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$63 >> 31);
    var $x_1_$_lo = paramCount$63;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$314, paramCount$63, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoW(ReadersVersionSpecific_this$314), $m_Lcom_papasofokli_execution_JsStatement$().aoX());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$63.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$63;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$63() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$63.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "uuid") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("uuid", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$63 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$63, "com.papasofokli.execution.JsStatement$$anon$63", ({
  od: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$64(ReadersVersionSpecific_this$319, paramCount$64, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$64 <= 64)) {
    if ((paramCount$64 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$64) === 0) ? (1 << paramCount$64) : 0);
      var hi = (((32 & paramCount$64) === 0) ? 0 : (1 << paramCount$64));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$64 >> 31);
    var $x_1_$_lo = paramCount$64;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$319, paramCount$64, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().aoY(ReadersVersionSpecific_this$319), $m_Lcom_papasofokli_execution_JsStatement$().aoZ());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$64.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$64;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$64() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$64.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().q(), new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "formGroupId": {
      return 0;
      break;
    }
    case "helpId": {
      return 1;
      break;
    }
    case "status": {
      return 2;
      break;
    }
    case "helpText": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("formGroupId", new $c_sci_$colon$colon("helpId", new $c_sci_$colon$colon("status", new $c_sci_$colon$colon("helpText", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$64 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$64, "com.papasofokli.execution.JsStatement$$anon$64", ({
  oe: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$65(ReadersVersionSpecific_this$324, paramCount$65, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$65 <= 64)) {
    if ((paramCount$65 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$65) === 0) ? (1 << paramCount$65) : 0);
      var hi = (((32 & paramCount$65) === 0) ? 0 : (1 << paramCount$65));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$65 >> 31);
    var $x_1_$_lo = paramCount$65;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$324, paramCount$65, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap0(ReadersVersionSpecific_this$324), $m_Lcom_papasofokli_execution_JsStatement$().ap2());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$65.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$65;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$65() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$65.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "data") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("data", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$65 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$65, "com.papasofokli.execution.JsStatement$$anon$65", ({
  of: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$66(ReadersVersionSpecific_this$329, paramCount$66, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$66 <= 64)) {
    if ((paramCount$66 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$66) === 0) ? (1 << paramCount$66) : 0);
      var hi = (((32 & paramCount$66) === 0) ? 0 : (1 << paramCount$66));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$66 >> 31);
    var $x_1_$_lo = paramCount$66;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$329, paramCount$66, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap3(ReadersVersionSpecific_this$329), $m_Lcom_papasofokli_execution_JsStatement$().ap4());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$66.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$66;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$66() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$66.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "data") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("data", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$66 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$66, "com.papasofokli.execution.JsStatement$$anon$66", ({
  og: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$67(ReadersVersionSpecific_this$334, paramCount$67, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$67 <= 64)) {
    if ((paramCount$67 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$67) === 0) ? (1 << paramCount$67) : 0);
      var hi = (((32 & paramCount$67) === 0) ? 0 : (1 << paramCount$67));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$67 >> 31);
    var $x_1_$_lo = paramCount$67;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$334, paramCount$67, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap5(ReadersVersionSpecific_this$334), $m_Lcom_papasofokli_execution_JsStatement$().ap6());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$67.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$67;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$67() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$67.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$67 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$67, "com.papasofokli.execution.JsStatement$$anon$67", ({
  oh: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$68(ReadersVersionSpecific_this$339, paramCount$68, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$68 <= 64)) {
    if ((paramCount$68 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$68) === 0) ? (1 << paramCount$68) : 0);
      var hi = (((32 & paramCount$68) === 0) ? 0 : (1 << paramCount$68));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$68 >> 31);
    var $x_1_$_lo = paramCount$68;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$339, paramCount$68, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap7(ReadersVersionSpecific_this$339), $m_Lcom_papasofokli_execution_JsStatement$().ap8());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$68.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$68;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$68() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$68.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PlanningPeriodChange$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "plannerId") ? 0 : ((x === "changeSeq") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("plannerId", new $c_sci_$colon$colon("changeSeq", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$68 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$68, "com.papasofokli.execution.JsStatement$$anon$68", ({
  oi: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$69(ReadersVersionSpecific_this$344, paramCount$69, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$69 <= 64)) {
    if ((paramCount$69 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$69) === 0) ? (1 << paramCount$69) : 0);
      var hi = (((32 & paramCount$69) === 0) ? 0 : (1 << paramCount$69));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$69 >> 31);
    var $x_1_$_lo = paramCount$69;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$344, paramCount$69, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap9(ReadersVersionSpecific_this$344), $m_Lcom_papasofokli_execution_JsStatement$().apa());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$69.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$69;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$69() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$69.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodTransformation$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "uuid") ? 0 : ((x === "periodChanges") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("uuid", new $c_sci_$colon$colon("periodChanges", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$69 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$69, "com.papasofokli.execution.JsStatement$$anon$69", ({
  oj: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$7(ReadersVersionSpecific_this$34, paramCount$7, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$34, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ap1(ReadersVersionSpecific_this$34), $m_Lcom_papasofokli_execution_JsStatement$().apc());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$7() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$7.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "tableId": {
      return 0;
      break;
    }
    case "position": {
      return 1;
      break;
    }
    case "noOfColumns": {
      return 2;
      break;
    }
    case "rowContent": {
      return 3;
      break;
    }
    case "collapseExpandedRows": {
      return 4;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("tableId", new $c_sci_$colon$colon("position", new $c_sci_$colon$colon("noOfColumns", new $c_sci_$colon$colon("rowContent", new $c_sci_$colon$colon("collapseExpandedRows", $m_sci_Nil$())))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(4, false);
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$7, "com.papasofokli.execution.JsStatement$$anon$7", ({
  ok: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$70(ReadersVersionSpecific_this$349, paramCount$70, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$70 <= 64)) {
    if ((paramCount$70 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$70) === 0) ? (1 << paramCount$70) : 0);
      var hi = (((32 & paramCount$70) === 0) ? 0 : (1 << paramCount$70));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$70 >> 31);
    var $x_1_$_lo = paramCount$70;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$349, paramCount$70, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apb(ReadersVersionSpecific_this$349), $m_Lcom_papasofokli_execution_JsStatement$().apd());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$70.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$70;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$70() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$70.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rightId": {
      return 0;
      break;
    }
    case "leftId": {
      return 1;
      break;
    }
    case "rightSize": {
      return 2;
      break;
    }
    case "rightCss": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rightId", new $c_sci_$colon$colon("leftId", new $c_sci_$colon$colon("rightSize", new $c_sci_$colon$colon("rightCss", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$70 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$70, "com.papasofokli.execution.JsStatement$$anon$70", ({
  ol: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$71(ReadersVersionSpecific_this$354, paramCount$71, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$71 <= 64)) {
    if ((paramCount$71 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$71) === 0) ? (1 << paramCount$71) : 0);
      var hi = (((32 & paramCount$71) === 0) ? 0 : (1 << paramCount$71));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$71 >> 31);
    var $x_1_$_lo = paramCount$71;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$354, paramCount$71, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().ape(ReadersVersionSpecific_this$354), $m_Lcom_papasofokli_execution_JsStatement$().apf());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$71.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$71;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$71() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$71.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "elementId") ? 0 : ((x === "className") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("elementId", new $c_sci_$colon$colon("className", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$71 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$71, "com.papasofokli.execution.JsStatement$$anon$71", ({
  om: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$72(ReadersVersionSpecific_this$359, paramCount$72, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$72 <= 64)) {
    if ((paramCount$72 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$72) === 0) ? (1 << paramCount$72) : 0);
      var hi = (((32 & paramCount$72) === 0) ? 0 : (1 << paramCount$72));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$72 >> 31);
    var $x_1_$_lo = paramCount$72;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$359, paramCount$72, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apg(ReadersVersionSpecific_this$359), $m_Lcom_papasofokli_execution_JsStatement$().aph());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$72.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$72;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$72() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$72.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "elementId") ? 0 : ((x === "className") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("elementId", new $c_sci_$colon$colon("className", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$72 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$72, "com.papasofokli.execution.JsStatement$$anon$72", ({
  on: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$73(ReadersVersionSpecific_this$364, paramCount$73, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$73 <= 64)) {
    if ((paramCount$73 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$73) === 0) ? (1 << paramCount$73) : 0);
      var hi = (((32 & paramCount$73) === 0) ? 0 : (1 << paramCount$73));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$73 >> 31);
    var $x_1_$_lo = paramCount$73;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$364, paramCount$73, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().api(ReadersVersionSpecific_this$364), $m_Lcom_papasofokli_execution_JsStatement$().apj());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$73.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$73;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$73() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$73.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "elementId") ? 0 : ((x === "className") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("elementId", new $c_sci_$colon$colon("className", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$73 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$73, "com.papasofokli.execution.JsStatement$$anon$73", ({
  oo: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$74(ReadersVersionSpecific_this$369, paramCount$74, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$74 <= 64)) {
    if ((paramCount$74 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$74) === 0) ? (1 << paramCount$74) : 0);
      var hi = (((32 & paramCount$74) === 0) ? 0 : (1 << paramCount$74));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$74 >> 31);
    var $x_1_$_lo = paramCount$74;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$369, paramCount$74, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apk(ReadersVersionSpecific_this$369), $m_Lcom_papasofokli_execution_JsStatement$().apl());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$74.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$74;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$74() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$74.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$74 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$74, "com.papasofokli.execution.JsStatement$$anon$74", ({
  op: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$8(ReadersVersionSpecific_this$39, paramCount$8, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$8 <= 64)) {
    if ((paramCount$8 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$8) === 0) ? (1 << paramCount$8) : 0);
      var hi = (((32 & paramCount$8) === 0) ? 0 : (1 << paramCount$8));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$8 >> 31);
    var $x_1_$_lo = paramCount$8;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$39, paramCount$8, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apm(ReadersVersionSpecific_this$39), $m_Lcom_papasofokli_execution_JsStatement$().apn());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$8.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$8() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$8.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "text") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("text", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$8, "com.papasofokli.execution.JsStatement$$anon$8", ({
  ou: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_JsStatement$$anon$9(ReadersVersionSpecific_this$44, paramCount$9, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$9 <= 64)) {
    if ((paramCount$9 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$9) === 0) ? (1 << paramCount$9) : 0);
      var hi = (((32 & paramCount$9) === 0) ? 0 : (1 << paramCount$9));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$9 >> 31);
    var $x_1_$_lo = paramCount$9;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$44, paramCount$9, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_JsStatement$().apo(ReadersVersionSpecific_this$44), $m_Lcom_papasofokli_execution_JsStatement$().app());
}
$p = $c_Lcom_papasofokli_execution_JsStatement$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_JsStatement$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_execution_JsStatement$$anon$9() {
}
$h_Lcom_papasofokli_execution_JsStatement$$anon$9.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "id") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("id", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_JsStatement$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_execution_JsStatement$$anon$9, "com.papasofokli.execution.JsStatement$$anon$9", ({
  oF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_ModalRatio$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_ModalRatio$().aqR(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_execution_ModalRatio$().aqS());
}
$p = $c_Lcom_papasofokli_execution_ModalRatio$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_ModalRatio$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_execution_ModalRatio$$anon$1() {
}
$h_Lcom_papasofokli_execution_ModalRatio$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aT, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "left") ? 0 : ((x === "right") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("left", new $c_sci_$colon$colon("right", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(0, 6);
  x.ag(1, 6);
});
var $d_Lcom_papasofokli_execution_ModalRatio$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_execution_ModalRatio$$anon$1, "com.papasofokli.execution.ModalRatio$$anon$1", ({
  oP: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149(ReadersVersionSpecific_this$373, paramCount$75, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$75 <= 64)) {
    if ((paramCount$75 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$75) === 0) ? (1 << paramCount$75) : 0);
      var hi = (((32 & paramCount$75) === 0) ? 0 : (1 << paramCount$75));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$75 >> 31);
    var $x_1_$_lo = paramCount$75;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$373, paramCount$75, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().aqT(ReadersVersionSpecific_this$373), $m_Lcom_papasofokli_execution_PlanningGenerationEffectRange$().aqU());
}
$p = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149;
/** @constructor */
function $h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149() {
}
$h_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().bl, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "subjectIdSeq": {
      return 0;
      break;
    }
    case "fromTime": {
      return 1;
      break;
    }
    case "toTime": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("subjectIdSeq", new $c_sci_$colon$colon("fromTime", new $c_sci_$colon$colon("toTime", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149 = new $TypeData().i($c_Lcom_papasofokli_execution_PlanningGenerationEffectRange$$anon$149, "com.papasofokli.execution.PlanningGenerationEffectRange$$anon$149", ({
  oS: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7(ReadersVersionSpecific_this$10, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$10, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_ContextMenuRequest$().aqV(ReadersVersionSpecific_this$10), $m_Lcom_papasofokli_jstree_ContextMenuRequest$().aqW());
}
$p = $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7() {
}
$h_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lcom_papasofokli_jstree_TreeItemData$().q(), $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "node") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("node", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_jstree_ContextMenuRequest$$anon$7, "com.papasofokli.jstree.ContextMenuRequest$$anon$7", ({
  pe: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_InfoItem$$anon$9(ReadersVersionSpecific_this$13, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_InfoItem$().aqY(ReadersVersionSpecific_this$13), $m_Lcom_papasofokli_jstree_InfoItem$().aqX());
}
$p = $c_Lcom_papasofokli_jstree_InfoItem$$anon$9.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_InfoItem$$anon$9;
/** @constructor */
function $h_Lcom_papasofokli_jstree_InfoItem$$anon$9() {
}
$h_Lcom_papasofokli_jstree_InfoItem$$anon$9.prototype = $p;
$p.af = (function() {
  var $x_3 = new $c_T2(null, null);
  var $x_2 = $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J);
  var $x_1 = $m_Lupickle_default$();
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e = $m_Lcom_papasofokli_util_GeneralText$().q();
  var this$12 = new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($x_1, new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e.f5("com.papasofokli.util.IconUI")), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$12);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_3, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "text": {
      return 0;
      break;
    }
    case "icons": {
      return 1;
      break;
    }
    case "iconCss": {
      return 2;
      break;
    }
    case "style": {
      return 3;
      break;
    }
    case "clickEventId": {
      return 4;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("text", new $c_sci_$colon$colon("icons", new $c_sci_$colon$colon("iconCss", new $c_sci_$colon$colon("style", new $c_sci_$colon$colon("clickEventId", $m_sci_Nil$())))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(0, $m_s_None$());
  x.ag(1, $m_sci_Nil$());
  x.ag(2, $m_s_Option$().Z("scala-tree-icon"));
  x.ag(3, $m_s_None$());
  x.ag(4, $m_s_None$());
});
var $d_Lcom_papasofokli_jstree_InfoItem$$anon$9 = new $TypeData().i($c_Lcom_papasofokli_jstree_InfoItem$$anon$9, "com.papasofokli.jstree.InfoItem$$anon$9", ({
  pi: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_LeafClickRequest$().aqZ(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_jstree_LeafClickRequest$().ar0());
}
$p = $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5() {
}
$h_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_jstree_TreeItemData$().q();
  var this$5 = new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.jstree.TreeLeafData", "TreeLeafData", e.f5("com.papasofokli.jstree.TreeLeafData")), new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "node") ? 0 : ((x === "clickType") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("node", new $c_sci_$colon$colon("clickType", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_jstree_LeafClickRequest$$anon$5, "com.papasofokli.jstree.LeafClickRequest$$anon$5", ({
  pk: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_NodeClickRequest$().ar1(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_jstree_NodeClickRequest$().ar2());
}
$p = $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3() {
}
$h_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_jstree_TreeItemData$().q();
  var this$5 = new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.jstree.TreeNodeData", "TreeNodeData", e.f5("com.papasofokli.jstree.TreeNodeData")), new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "node") ? 0 : ((x === "clickType") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("node", new $c_sci_$colon$colon("clickType", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_jstree_NodeClickRequest$$anon$3, "com.papasofokli.jstree.NodeClickRequest$$anon$3", ({
  pn: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeItemData$$anon$11(ReadersVersionSpecific_this$19, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_TreeItemData$().ar3(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_jstree_TreeItemData$().ar4());
}
$p = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$11.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeItemData$$anon$11() {
}
$h_Lcom_papasofokli_jstree_TreeItemData$$anon$11.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$11 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_jstree_InfoItem$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$())))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$11);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "parentNodeId": {
      return 0;
      break;
    }
    case "recordId": {
      return 1;
      break;
    }
    case "selected": {
      return 2;
      break;
    }
    case "infoItems": {
      return 3;
      break;
    }
    case "widthPercentages": {
      return 4;
      break;
    }
    case "additionalNodeId": {
      return 5;
      break;
    }
    case "id": {
      return 6;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("parentNodeId", new $c_sci_$colon$colon("recordId", new $c_sci_$colon$colon("selected", new $c_sci_$colon$colon("infoItems", new $c_sci_$colon$colon("widthPercentages", new $c_sci_$colon$colon("additionalNodeId", new $c_sci_$colon$colon("id", $m_sci_Nil$())))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, false);
  x.ag(5, $m_s_None$());
  x.ag(6, $m_ju_UUID$().aW());
});
var $d_Lcom_papasofokli_jstree_TreeItemData$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeItemData$$anon$11, "com.papasofokli.jstree.TreeItemData$$anon$11", ({
  pq: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeItemData$$anon$12(ReadersVersionSpecific_this$24, paramCount$7, x0$lzy1$4, x1$lzy1$6, ReadersVersionSpecific_this$25, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  this.a0s = null;
  this.OF = null;
  this.OE = null;
  this.a0s = x0$lzy1$4;
  this.OF = x1$lzy1$6;
  this.OE = ReadersVersionSpecific_this$25;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$24, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_TreeItemData$().ar5(ReadersVersionSpecific_this$24), $m_Lcom_papasofokli_jstree_TreeItemData$().ar6());
}
$p = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$12.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeItemData$$anon$12;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeItemData$$anon$12() {
}
$h_Lcom_papasofokli_jstree_TreeItemData$$anon$12.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().bl, $m_Lupickle_default$().bl, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_jstree_TreeItemData$().ag0(this.a0s, this.OE, this.OF), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_jstree_TreeItemData$().ag1(this.OF, this.OE), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_jstree_InfoItem$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().Dw)]);
  var this$22 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$22.G() >= 0)) {
    var destination = new $ac_O(this$22.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$22, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$22.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "recordId": {
      return 1;
      break;
    }
    case "childNodeSeq": {
      return 2;
      break;
    }
    case "childLeafSeq": {
      return 3;
      break;
    }
    case "expanded": {
      return 4;
      break;
    }
    case "selected": {
      return 5;
      break;
    }
    case "infoItems": {
      return 6;
      break;
    }
    case "widthPercentages": {
      return 7;
      break;
    }
    case "treeNodeType": {
      return 8;
      break;
    }
    case "parentRecordId": {
      return 9;
      break;
    }
    case "sortOrder": {
      return 10;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["id", "recordId", "childNodeSeq", "childLeafSeq", "expanded", "selected", "infoItems", "widthPercentages", "treeNodeType", "parentRecordId", "sortOrder"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(4, false);
  x.ag(5, false);
  x.ag(8, $m_s_None$());
  x.ag(9, $m_s_None$());
  x.ag(10, $m_s_None$());
});
var $d_Lcom_papasofokli_jstree_TreeItemData$$anon$12 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeItemData$$anon$12, "com.papasofokli.jstree.TreeItemData$$anon$12", ({
  pr: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_jstree_TreeNodeListSetupData$().ar7(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_jstree_TreeNodeListSetupData$().ar8());
}
$p = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1() {
}
$h_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_4 = new $c_T2(null, null);
  var $x_3 = $m_Lupickle_default$();
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_jstree_TreeItemData$().q();
  var $x_2 = new $c_Lupickle_implicits_Readers$SeqLikeReader($x_3, new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.jstree.TreeNodeData", "TreeNodeData", e.f5("com.papasofokli.jstree.TreeNodeData")), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()));
  var $x_1 = $m_Lupickle_default$();
  var ReadersVersionSpecific_this$2 = $m_Lupickle_default$();
  var e$1 = $m_Lcom_papasofokli_jstree_TreeItemData$().q();
  var this$13 = new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($x_1, new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this$2.aq(), "$type", "com.papasofokli.jstree.TreeLeafData", "TreeLeafData", e$1.f5("com.papasofokli.jstree.TreeLeafData")), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$13);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_4, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "nodes": {
      return 0;
      break;
    }
    case "leaves": {
      return 1;
      break;
    }
    case "expandOnDoubleClick": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("nodes", new $c_sci_$colon$colon("leaves", new $c_sci_$colon$colon("expandOnDoubleClick", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_jstree_TreeNodeListSetupData$$anon$1, "com.papasofokli.jstree.TreeNodeListSetupData$$anon$1", ({
  pv: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_AppliedToC$$anon$41(ReadersVersionSpecific_this$74, paramCount$21, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$21 <= 64)) {
    if ((paramCount$21 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$21) === 0) ? (1 << paramCount$21) : 0);
      var hi = (((32 & paramCount$21) === 0) ? 0 : (1 << paramCount$21));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$21 >> 31);
    var $x_1_$_lo = paramCount$21;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$74, paramCount$21, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_AppliedToC$().ar9(ReadersVersionSpecific_this$74), $m_Lcom_papasofokli_planning_AppliedToC$().ara());
}
$p = $c_Lcom_papasofokli_planning_AppliedToC$$anon$41.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_AppliedToC$$anon$41;
/** @constructor */
function $h_Lcom_papasofokli_planning_AppliedToC$$anon$41() {
}
$h_Lcom_papasofokli_planning_AppliedToC$$anon$41.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "name") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_AppliedToC$$anon$41 = new $TypeData().i($c_Lcom_papasofokli_planning_AppliedToC$$anon$41, "com.papasofokli.planning.AppliedToC$$anon$41", ({
  pD: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13(ReadersVersionSpecific_this$26, paramCount$7, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$7 <= 64)) {
    if ((paramCount$7 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$7) === 0) ? (1 << paramCount$7) : 0);
      var hi = (((32 & paramCount$7) === 0) ? 0 : (1 << paramCount$7));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$7 >> 31);
    var $x_1_$_lo = paramCount$7;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$26, paramCount$7, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_DetailedPlanningRow$().arb(ReadersVersionSpecific_this$26), $m_Lcom_papasofokli_planning_DetailedPlanningRow$().arc());
}
$p = $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13;
/** @constructor */
function $h_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13() {
}
$h_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "periodDetails") ? 0 : ((x === "hideIfEmpty") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("periodDetails", new $c_sci_$colon$colon("hideIfEmpty", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, true);
});
var $d_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13 = new $TypeData().i($c_Lcom_papasofokli_planning_DetailedPlanningRow$$anon$13, "com.papasofokli.planning.DetailedPlanningRow$$anon$13", ({
  pG: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionData$$anon$25(ReadersVersionSpecific_this$47, paramCount$13, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$13 <= 64)) {
    if ((paramCount$13 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$13) === 0) ? (1 << paramCount$13) : 0);
      var hi = (((32 & paramCount$13) === 0) ? 0 : (1 << paramCount$13));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$13 >> 31);
    var $x_1_$_lo = paramCount$13;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$47, paramCount$13, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_DivisionData$().ard(ReadersVersionSpecific_this$47), $m_Lcom_papasofokli_planning_DivisionData$().are());
}
$p = $c_Lcom_papasofokli_planning_DivisionData$$anon$25.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionData$$anon$25;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionData$$anon$25() {
}
$h_Lcom_papasofokli_planning_DivisionData$$anon$25.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "vesselId") ? 0 : ((x === "nodeId") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("vesselId", new $c_sci_$colon$colon("nodeId", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_DivisionData$$anon$25 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionData$$anon$25, "com.papasofokli.planning.DivisionData$$anon$25", ({
  pJ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionData$$anon$26(ReadersVersionSpecific_this$52, paramCount$14, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$14 <= 64)) {
    if ((paramCount$14 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$14) === 0) ? (1 << paramCount$14) : 0);
      var hi = (((32 & paramCount$14) === 0) ? 0 : (1 << paramCount$14));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$14 >> 31);
    var $x_1_$_lo = paramCount$14;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$52, paramCount$14, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_DivisionData$().arf(ReadersVersionSpecific_this$52), $m_Lcom_papasofokli_planning_DivisionData$().arg());
}
$p = $c_Lcom_papasofokli_planning_DivisionData$$anon$26.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionData$$anon$26;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionData$$anon$26() {
}
$h_Lcom_papasofokli_planning_DivisionData$$anon$26.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "vesselId") ? 0 : ((x === "nodeId") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("vesselId", new $c_sci_$colon$colon("nodeId", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_DivisionData$$anon$26 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionData$$anon$26, "com.papasofokli.planning.DivisionData$$anon$26", ({
  pK: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7(ReadersVersionSpecific_this$13, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$13, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_DivisionsDataJSI$().ari(ReadersVersionSpecific_this$13), $m_Lcom_papasofokli_planning_DivisionsDataJSI$().arj());
}
$p = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7() {
}
$h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7.prototype = $p;
$p.af = (function() {
  var $x_4 = new $c_T2(null, null);
  var $x_3 = $m_Lupickle_default$().J;
  var $x_2 = $m_Lupickle_default$().J;
  var $x_1 = new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SubjectPlanningData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()));
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_planning_DivisionData$().q();
  var this$9 = new $c_sci_$colon$colon($x_3, new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.planning.LeafData", "LeafData", e.f5("com.papasofokli.planning.LeafData")), new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodStyle$().q(), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q()), $m_sci_Nil$()))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$9);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_4, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "divisionName": {
      return 0;
      break;
    }
    case "tooltipText": {
      return 1;
      break;
    }
    case "seq": {
      return 2;
      break;
    }
    case "leafData": {
      return 3;
      break;
    }
    case "style": {
      return 4;
      break;
    }
    case "icon": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("divisionName", new $c_sci_$colon$colon("tooltipText", new $c_sci_$colon$colon("seq", new $c_sci_$colon$colon("leafData", new $c_sci_$colon$colon("style", new $c_sci_$colon$colon("icon", $m_sci_Nil$()))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, "");
  x.ag(4, $m_Lcom_papasofokli_planning_PeriodStyleE$().EX);
  x.ag(5, $m_s_None$());
});
var $d_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$7, "com.papasofokli.planning.DivisionsDataJSI$$anon$7", ({
  pQ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8(ReadersVersionSpecific_this$18, paramCount$5, x2$lzy1$4, ReadersVersionSpecific_this$19, x0$lzy1$4, x1$lzy1$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  this.a12 = null;
  this.a0Z = null;
  this.a10 = null;
  this.a11 = null;
  this.a12 = x2$lzy1$4;
  this.a0Z = ReadersVersionSpecific_this$19;
  this.a10 = x0$lzy1$4;
  this.a11 = x1$lzy1$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$18, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_DivisionsDataJSI$().ark(ReadersVersionSpecific_this$18), $m_Lcom_papasofokli_planning_DivisionsDataJSI$().arh());
}
$p = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8() {
}
$h_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8.prototype = $p;
$p.af = (function() {
  var $x_3 = new $c_T2(null, null);
  var $x_2 = $m_Lupickle_default$().J;
  var $x_1 = new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_DivisionsDataJSI$().ag2(this.a12, this.a0Z, this.a10, this.a11), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$()));
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_planning_DivisionData$().q();
  var this$11 = new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.planning.NodeData", "NodeData", e.f5("com.papasofokli.planning.NodeData")), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$11);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_3, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "divisionName": {
      return 0;
      break;
    }
    case "departmentDataJS": {
      return 1;
      break;
    }
    case "nodeData": {
      return 2;
      break;
    }
    case "vesselSchedules": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("divisionName", new $c_sci_$colon$colon("departmentDataJS", new $c_sci_$colon$colon("nodeData", new $c_sci_$colon$colon("vesselSchedules", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, $m_sci_Nil$());
});
var $d_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_planning_DivisionsDataJSI$$anon$8, "com.papasofokli.planning.DivisionsDataJSI$$anon$8", ({
  pR: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43(ReadersVersionSpecific_this$77, paramCount$22, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$22 <= 64)) {
    if ((paramCount$22 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$22) === 0) ? (1 << paramCount$22) : 0);
      var hi = (((32 & paramCount$22) === 0) ? 0 : (1 << paramCount$22));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$22 >> 31);
    var $x_1_$_lo = paramCount$22;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$77, paramCount$22, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_IndicationsDictionary$().arl(ReadersVersionSpecific_this$77), $m_Lcom_papasofokli_planning_IndicationsDictionary$().arm());
}
$p = $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43;
/** @constructor */
function $h_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43() {
}
$h_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_AppliedToC$().q(), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "icon": {
      return 0;
      break;
    }
    case "text": {
      return 1;
      break;
    }
    case "appliedTo": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("icon", new $c_sci_$colon$colon("text", new $c_sci_$colon$colon("appliedTo", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43 = new $TypeData().i($c_Lcom_papasofokli_planning_IndicationsDictionary$$anon$43, "com.papasofokli.planning.IndicationsDictionary$$anon$43", ({
  pU: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodJS$$anon$17(ReadersVersionSpecific_this$32, paramCount$9, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$9 <= 64)) {
    if ((paramCount$9 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$9) === 0) ? (1 << paramCount$9) : 0);
      var hi = (((32 & paramCount$9) === 0) ? 0 : (1 << paramCount$9));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$9 >> 31);
    var $x_1_$_lo = paramCount$9;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$32, paramCount$9, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PeriodJS$().arn(ReadersVersionSpecific_this$32), $m_Lcom_papasofokli_planning_PeriodJS$().aro());
}
$p = $c_Lcom_papasofokli_planning_PeriodJS$$anon$17.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodJS$$anon$17;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodJS$$anon$17() {
}
$h_Lcom_papasofokli_planning_PeriodJS$$anon$17.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $m_Lupickle_default$().bl, $m_Lupickle_default$().bl, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_Lupickle_default$().J, $m_Lupickle_default$().J, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().J, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, $m_Lcom_papasofokli_planning_PeriodStyle$().q(), $m_Lupickle_default$().aT, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().bl, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().aG, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Set$()))), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().oq), $m_Lupickle_default$().bf]);
  var this$37 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$37.G() >= 0)) {
    var destination = new $ac_O(this$37.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$37, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$37.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "periodId": {
      return 0;
      break;
    }
    case "fromDate": {
      return 1;
      break;
    }
    case "toDate": {
      return 2;
      break;
    }
    case "totalHours": {
      return 3;
      break;
    }
    case "taskName": {
      return 4;
      break;
    }
    case "periodType": {
      return 5;
      break;
    }
    case "vesselId": {
      return 6;
      break;
    }
    case "tooltipInformation": {
      return 7;
      break;
    }
    case "startDateConfirmed": {
      return 8;
      break;
    }
    case "endDateConfirmed": {
      return 9;
      break;
    }
    case "periodStyle": {
      return 10;
      break;
    }
    case "toAppearInRow": {
      return 11;
      break;
    }
    case "leftIndications": {
      return 12;
      break;
    }
    case "text": {
      return 13;
      break;
    }
    case "textLine2": {
      return 14;
      break;
    }
    case "rightIndications": {
      return 15;
      break;
    }
    case "centerIndications": {
      return 16;
      break;
    }
    case "rowInformation": {
      return 17;
      break;
    }
    case "uniqueUUID": {
      return 18;
      break;
    }
    case "color": {
      return 19;
      break;
    }
    case "stroke": {
      return 20;
      break;
    }
    case "customIndicationsDictionary": {
      return 21;
      break;
    }
    case "changeDatesFunctionUUID": {
      return 22;
      break;
    }
    case "changeRightDateFunctionUUID": {
      return 23;
      break;
    }
    case "changeLeftDateFunctionUUID": {
      return 24;
      break;
    }
    case "animationTime": {
      return 25;
      break;
    }
    case "showDatesOnTooltip": {
      return 26;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["periodId", "fromDate", "toDate", "totalHours", "taskName", "periodType", "vesselId", "tooltipInformation", "startDateConfirmed", "endDateConfirmed", "periodStyle", "toAppearInRow", "leftIndications", "text", "textLine2", "rightIndications", "centerIndications", "rowInformation", "uniqueUUID", "color", "stroke", "customIndicationsDictionary", "changeDatesFunctionUUID", "changeRightDateFunctionUUID", "changeLeftDateFunctionUUID", "animationTime", "showDatesOnTooltip"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(3, $m_s_None$());
  x.ag(4, "");
  x.ag(6, $m_s_None$());
  x.ag(11, 0);
  x.ag(12, $m_sci_Nil$());
  x.ag(13, $m_s_None$());
  x.ag(14, $m_s_None$());
  x.ag(15, $m_sci_Nil$());
  x.ag(16, $m_sci_Nil$());
  x.ag(17, $m_sci_Nil$());
  x.ag(18, $m_ju_UUID$().aW());
  x.ag(19, $m_s_None$());
  x.ag(20, $m_s_None$());
  x.ag(21, $m_s_None$());
  x.ag(22, $m_s_None$());
  x.ag(23, $m_s_None$());
  x.ag(24, $m_s_None$());
  x.ag(25, new $c_s_Some(0.5));
  x.ag(26, true);
});
var $d_Lcom_papasofokli_planning_PeriodJS$$anon$17 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodJS$$anon$17, "com.papasofokli.planning.PeriodJS$$anon$17", ({
  pY: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodStyle$$anon$39(ReadersVersionSpecific_this$71, paramCount$20, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$20 <= 64)) {
    if ((paramCount$20 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$20) === 0) ? (1 << paramCount$20) : 0);
      var hi = (((32 & paramCount$20) === 0) ? 0 : (1 << paramCount$20));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$20 >> 31);
    var $x_1_$_lo = paramCount$20;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$71, paramCount$20, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PeriodStyle$().arp(ReadersVersionSpecific_this$71), $m_Lcom_papasofokli_planning_PeriodStyle$().arq());
}
$p = $c_Lcom_papasofokli_planning_PeriodStyle$$anon$39.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodStyle$$anon$39;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodStyle$$anon$39() {
}
$h_Lcom_papasofokli_planning_PeriodStyle$$anon$39.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "name") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_PeriodStyle$$anon$39 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodStyle$$anon$39, "com.papasofokli.planning.PeriodStyle$$anon$39", ({
  q1: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$33(ReadersVersionSpecific_this$62, paramCount$17, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$17 <= 64)) {
    if ((paramCount$17 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$17) === 0) ? (1 << paramCount$17) : 0);
      var hi = (((32 & paramCount$17) === 0) ? 0 : (1 << paramCount$17));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$17 >> 31);
    var $x_1_$_lo = paramCount$17;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$62, paramCount$17, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PeriodTransformation$().arr(ReadersVersionSpecific_this$62), $m_Lcom_papasofokli_planning_PeriodTransformation$().ars());
}
$p = $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$33.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PeriodTransformation$$anon$33;
/** @constructor */
function $h_Lcom_papasofokli_planning_PeriodTransformation$$anon$33() {
}
$h_Lcom_papasofokli_planning_PeriodTransformation$$anon$33.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q()), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "oldPeriod") ? 0 : ((x === "newPeriod") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("oldPeriod", new $c_sci_$colon$colon("newPeriod", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_PeriodTransformation$$anon$33 = new $TypeData().i($c_Lcom_papasofokli_planning_PeriodTransformation$$anon$33, "com.papasofokli.planning.PeriodTransformation$$anon$33", ({
  q5: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21(ReadersVersionSpecific_this$38, paramCount$11, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$11 <= 64)) {
    if ((paramCount$11 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$11) === 0) ? (1 << paramCount$11) : 0);
      var hi = (((32 & paramCount$11) === 0) ? 0 : (1 << paramCount$11));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$11 >> 31);
    var $x_1_$_lo = paramCount$11;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$38, paramCount$11, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PlannerPeriodsData$().art(ReadersVersionSpecific_this$38), $m_Lcom_papasofokli_planning_PlannerPeriodsData$().aru());
}
$p = $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21() {
}
$h_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$8 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_UUIDRowWithPeriod$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $f_Lupickle_implicits_Generated__Tuple2Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_implicits_TupleReadWriters$TupleNReader($m_Lupickle_default$(), $m_Lupickle_default$().bl, $m_Lupickle_default$().aG)), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$8);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowUUID": {
      return 0;
      break;
    }
    case "periodWithRowSeq": {
      return 1;
      break;
    }
    case "subjectRowId": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("periodWithRowSeq", new $c_sci_$colon$colon("subjectRowId", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21 = new $TypeData().i($c_Lcom_papasofokli_planning_PlannerPeriodsData$$anon$21, "com.papasofokli.planning.PlannerPeriodsData$$anon$21", ({
  q8: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PlanningData$().arv(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_planning_PlanningData$().arw());
}
$p = $c_Lcom_papasofokli_planning_PlanningData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningData$$anon$1() {
}
$h_Lcom_papasofokli_planning_PlanningData$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_DivisionsDataJSI$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().bl, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SubjectButtonParameters$().q()), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_VerticalDateLine$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().oq, $m_Lupickle_default$().oq, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_IndicationsDictionary$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().oq), $m_Lupickle_default$().bf, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().aT, new $c_sc_IterableFactory$ToFactory($m_sci_Set$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_VesselScheduleJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().bf, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().aG)]);
  var this$31 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$31.G() >= 0)) {
    var destination = new $ac_O(this$31.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$31, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$31.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "subjectData": {
      return 0;
      break;
    }
    case "fromDate": {
      return 1;
      break;
    }
    case "toDate": {
      return 2;
      break;
    }
    case "zoomLevel": {
      return 3;
      break;
    }
    case "scrollOnTime": {
      return 4;
      break;
    }
    case "showButtons": {
      return 5;
      break;
    }
    case "contextMenuFunctionUUID": {
      return 6;
      break;
    }
    case "clickFunctionUUID": {
      return 7;
      break;
    }
    case "clickSubjectButtonParams": {
      return 8;
      break;
    }
    case "departmentClickFunctionUUID": {
      return 9;
      break;
    }
    case "verticalDateLines": {
      return 10;
      break;
    }
    case "leafDivisionSize": {
      return 11;
      break;
    }
    case "subjectNameDivisionSize": {
      return 12;
      break;
    }
    case "indicationsDictionary": {
      return 13;
      break;
    }
    case "showSubjectId": {
      return 14;
      break;
    }
    case "periodHide": {
      return 15;
      break;
    }
    case "wideTimeline": {
      return 16;
      break;
    }
    case "divisionRowsToShow": {
      return 17;
      break;
    }
    case "vesselSchedules": {
      return 18;
      break;
    }
    case "showVesselScheduleComponents": {
      return 19;
      break;
    }
    case "voyageClickFunctionUUID": {
      return 20;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["subjectData", "fromDate", "toDate", "zoomLevel", "scrollOnTime", "showButtons", "contextMenuFunctionUUID", "clickFunctionUUID", "clickSubjectButtonParams", "departmentClickFunctionUUID", "verticalDateLines", "leafDivisionSize", "subjectNameDivisionSize", "indicationsDictionary", "showSubjectId", "periodHide", "wideTimeline", "divisionRowsToShow", "vesselSchedules", "showVesselScheduleComponents", "voyageClickFunctionUUID"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(4, $m_s_None$());
  x.ag(5, true);
  x.ag(6, $m_s_None$());
  x.ag(7, $m_s_None$());
  x.ag(8, $m_s_None$());
  x.ag(9, $m_s_None$());
  x.ag(10, $m_sci_Nil$());
  x.ag(11, 150.0);
  x.ag(12, 150.0);
  x.ag(13, $m_sci_Set$EmptySet$());
  x.ag(14, false);
  x.ag(15, $m_s_None$());
  x.ag(16, false);
  x.ag(17, $m_Lcom_papasofokli_planning_PlanningData$().M4());
  x.ag(18, $m_sci_Nil$());
  x.ag(19, false);
  x.ag(20, $m_s_None$());
});
var $d_Lcom_papasofokli_planning_PlanningData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningData$$anon$1, "com.papasofokli.planning.PlanningData$$anon$1", ({
  qb: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35(ReadersVersionSpecific_this$65, paramCount$18, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$18 <= 64)) {
    if ((paramCount$18 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$18) === 0) ? (1 << paramCount$18) : 0);
      var hi = (((32 & paramCount$18) === 0) ? 0 : (1 << paramCount$18));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$18 >> 31);
    var $x_1_$_lo = paramCount$18;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$65, paramCount$18, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_PlanningPeriodChange$().arx(ReadersVersionSpecific_this$65), $m_Lcom_papasofokli_planning_PlanningPeriodChange$().ary());
}
$p = $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35;
/** @constructor */
function $h_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35() {
}
$h_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$()))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "periodId": {
      return 0;
      break;
    }
    case "vesselPositionId": {
      return 1;
      break;
    }
    case "fromDate": {
      return 2;
      break;
    }
    case "toDate": {
      return 3;
      break;
    }
    case "explanation": {
      return 4;
      break;
    }
    case "removed": {
      return 5;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("periodId", new $c_sci_$colon$colon("vesselPositionId", new $c_sci_$colon$colon("fromDate", new $c_sci_$colon$colon("toDate", new $c_sci_$colon$colon("explanation", new $c_sci_$colon$colon("removed", $m_sci_Nil$()))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35 = new $TypeData().i($c_Lcom_papasofokli_planning_PlanningPeriodChange$$anon$35, "com.papasofokli.planning.PlanningPeriodChange$$anon$35", ({
  qe: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowClickData$$anon$31(ReadersVersionSpecific_this$59, paramCount$16, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$16 <= 64)) {
    if ((paramCount$16 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$16) === 0) ? (1 << paramCount$16) : 0);
      var hi = (((32 & paramCount$16) === 0) ? 0 : (1 << paramCount$16));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$16 >> 31);
    var $x_1_$_lo = paramCount$16;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$59, paramCount$16, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_RowClickData$().arz(ReadersVersionSpecific_this$59), $m_Lcom_papasofokli_planning_RowClickData$().arA());
}
$p = $c_Lcom_papasofokli_planning_RowClickData$$anon$31.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_RowClickData$$anon$31;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowClickData$$anon$31() {
}
$h_Lcom_papasofokli_planning_RowClickData$$anon$31.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$6 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_RowData$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "rowUUID") ? 0 : ((x === "rowDataSeq") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("rowDataSeq", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_RowClickData$$anon$31 = new $TypeData().i($c_Lcom_papasofokli_planning_RowClickData$$anon$31, "com.papasofokli.planning.RowClickData$$anon$31", ({
  qh: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_RowData$$anon$29(ReadersVersionSpecific_this$56, paramCount$15, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$15 <= 64)) {
    if ((paramCount$15 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$15) === 0) ? (1 << paramCount$15) : 0);
      var hi = (((32 & paramCount$15) === 0) ? 0 : (1 << paramCount$15));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$15 >> 31);
    var $x_1_$_lo = paramCount$15;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$56, paramCount$15, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_RowData$().arB(ReadersVersionSpecific_this$56), $m_Lcom_papasofokli_planning_RowData$().arC());
}
$p = $c_Lcom_papasofokli_planning_RowData$$anon$29.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_RowData$$anon$29;
/** @constructor */
function $h_Lcom_papasofokli_planning_RowData$$anon$29() {
}
$h_Lcom_papasofokli_planning_RowData$$anon$29.prototype = $p;
$p.af = (function() {
  var $x_3 = new $c_T2(null, null);
  var $x_2 = $m_Lupickle_default$().aG;
  var $x_1 = $m_Lupickle_default$().bl;
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  var e = $m_Lcom_papasofokli_planning_DivisionData$().q();
  var this$5 = new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.planning.LeafData", "LeafData", e.f5("com.papasofokli.planning.LeafData")), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_3, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "rowId": {
      return 0;
      break;
    }
    case "subjectId": {
      return 1;
      break;
    }
    case "leafData": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowId", new $c_sci_$colon$colon("subjectId", new $c_sci_$colon$colon("leafData", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_RowData$$anon$29 = new $TypeData().i($c_Lcom_papasofokli_planning_RowData$$anon$29, "com.papasofokli.planning.RowData$$anon$29", ({
  qk: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3(ReadersVersionSpecific_this$4, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_SubjectButtonParameters$().arD(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_planning_SubjectButtonParameters$().arE());
}
$p = $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3() {
}
$h_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_2 = new $c_T2(null, null);
  var $x_1 = $m_Lupickle_default$().aG;
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e = $m_Lcom_papasofokli_util_GeneralText$().q();
  var this$6 = new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e.f5("com.papasofokli.util.IconUI")), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_2, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "funUUId": {
      return 0;
      break;
    }
    case "icon": {
      return 1;
      break;
    }
    case "tooltipText": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("funUUId", new $c_sci_$colon$colon("icon", new $c_sci_$colon$colon("tooltipText", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectButtonParameters$$anon$3, "com.papasofokli.planning.SubjectButtonParameters$$anon$3", ({
  qn: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectJS$$anon$15(ReadersVersionSpecific_this$29, paramCount$8, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$8 <= 64)) {
    if ((paramCount$8 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$8) === 0) ? (1 << paramCount$8) : 0);
      var hi = (((32 & paramCount$8) === 0) ? 0 : (1 << paramCount$8));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$8 >> 31);
    var $x_1_$_lo = paramCount$8;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$29, paramCount$8, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_SubjectJS$().arF(ReadersVersionSpecific_this$29), $m_Lcom_papasofokli_planning_SubjectJS$().arG());
}
$p = $c_Lcom_papasofokli_planning_SubjectJS$$anon$15.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectJS$$anon$15;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectJS$$anon$15() {
}
$h_Lcom_papasofokli_planning_SubjectJS$$anon$15.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$9 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().bl), new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_util_GeneralText$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$())))))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$9);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "subjectId": {
      return 0;
      break;
    }
    case "shortName": {
      return 1;
      break;
    }
    case "fullName": {
      return 2;
      break;
    }
    case "extraInfoText": {
      return 3;
      break;
    }
    case "icon": {
      return 4;
      break;
    }
    case "href": {
      return 5;
      break;
    }
    case "showButtonInd": {
      return 6;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("subjectId", new $c_sci_$colon$colon("shortName", new $c_sci_$colon$colon("fullName", new $c_sci_$colon$colon("extraInfoText", new $c_sci_$colon$colon("icon", new $c_sci_$colon$colon("href", new $c_sci_$colon$colon("showButtonInd", $m_sci_Nil$())))))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, $m_s_None$());
  x.ag(4, $m_sci_Nil$());
  x.ag(5, $m_s_None$());
  x.ag(6, true);
});
var $d_Lcom_papasofokli_planning_SubjectJS$$anon$15 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectJS$$anon$15, "com.papasofokli.planning.SubjectJS$$anon$15", ({
  qq: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11(ReadersVersionSpecific_this$23, paramCount$6, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$6 <= 64)) {
    if ((paramCount$6 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$6) === 0) ? (1 << paramCount$6) : 0);
      var hi = (((32 & paramCount$6) === 0) ? 0 : (1 << paramCount$6));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$6 >> 31);
    var $x_1_$_lo = paramCount$6;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$23, paramCount$6, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_SubjectPlanningData$().arH(ReadersVersionSpecific_this$23), $m_Lcom_papasofokli_planning_SubjectPlanningData$().arI());
}
$p = $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11;
/** @constructor */
function $h_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11() {
}
$h_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$9 = new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_SubjectJS$().q(), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_PeriodJS$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon(new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_DetailedPlanningRow$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_sci_$colon$colon($m_Lupickle_default$().bf, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$())))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$9);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "subject": {
      return 0;
      break;
    }
    case "periodsJS": {
      return 1;
      break;
    }
    case "detailedPlanningRows": {
      return 2;
      break;
    }
    case "isExpandable": {
      return 3;
      break;
    }
    case "initialClassStyle": {
      return 4;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("subject", new $c_sci_$colon$colon("periodsJS", new $c_sci_$colon$colon("detailedPlanningRows", new $c_sci_$colon$colon("isExpandable", new $c_sci_$colon$colon("initialClassStyle", $m_sci_Nil$())))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_sci_Nil$());
  x.ag(3, false);
  x.ag(4, "topBackground");
});
var $d_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11 = new $TypeData().i($c_Lcom_papasofokli_planning_SubjectPlanningData$$anon$11, "com.papasofokli.planning.SubjectPlanningData$$anon$11", ({
  qt: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_SvgColor$$anon$23(ReadersVersionSpecific_this$41, paramCount$12, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$12 <= 64)) {
    if ((paramCount$12 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$12) === 0) ? (1 << paramCount$12) : 0);
      var hi = (((32 & paramCount$12) === 0) ? 0 : (1 << paramCount$12));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$12 >> 31);
    var $x_1_$_lo = paramCount$12;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$41, paramCount$12, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_SvgColor$().arJ(ReadersVersionSpecific_this$41), $m_Lcom_papasofokli_planning_SvgColor$().arK());
}
$p = $c_Lcom_papasofokli_planning_SvgColor$$anon$23.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_SvgColor$$anon$23;
/** @constructor */
function $h_Lcom_papasofokli_planning_SvgColor$$anon$23() {
}
$h_Lcom_papasofokli_planning_SvgColor$$anon$23.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().aT, new $c_sci_$colon$colon($m_Lupickle_default$().op, $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "red": {
      return 0;
      break;
    }
    case "green": {
      return 1;
      break;
    }
    case "blue": {
      return 2;
      break;
    }
    case "opacity": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("red", new $c_sci_$colon$colon("green", new $c_sci_$colon$colon("blue", new $c_sci_$colon$colon("opacity", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_SvgColor$$anon$23 = new $TypeData().i($c_Lcom_papasofokli_planning_SvgColor$$anon$23, "com.papasofokli.planning.SvgColor$$anon$23", ({
  qw: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19(ReadersVersionSpecific_this$35, paramCount$10, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$10 <= 64)) {
    if ((paramCount$10 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$10) === 0) ? (1 << paramCount$10) : 0);
      var hi = (((32 & paramCount$10) === 0) ? 0 : (1 << paramCount$10));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$10 >> 31);
    var $x_1_$_lo = paramCount$10;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$35, paramCount$10, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_UUIDRowWithPeriod$().arL(ReadersVersionSpecific_this$35), $m_Lcom_papasofokli_planning_UUIDRowWithPeriod$().arM());
}
$p = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19;
/** @constructor */
function $h_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19() {
}
$h_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().aG, new $c_sci_$colon$colon($m_Lcom_papasofokli_planning_PeriodJS$().q(), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "rowUUID") ? 0 : ((x === "period") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("rowUUID", new $c_sci_$colon$colon("period", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19 = new $TypeData().i($c_Lcom_papasofokli_planning_UUIDRowWithPeriod$$anon$19, "com.papasofokli.planning.UUIDRowWithPeriod$$anon$19", ({
  qz: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_VerticalDateLine$().arN(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_planning_VerticalDateLine$().arO());
}
$p = $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_VerticalDateLine$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_planning_VerticalDateLine$$anon$5() {
}
$h_Lcom_papasofokli_planning_VerticalDateLine$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().aG, $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "date": {
      return 0;
      break;
    }
    case "text": {
      return 1;
      break;
    }
    case "cssClass": {
      return 2;
      break;
    }
    case "id": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("date", new $c_sci_$colon$colon("text", new $c_sci_$colon$colon("cssClass", new $c_sci_$colon$colon("id", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(3, $m_ju_UUID$().aW());
});
var $d_Lcom_papasofokli_planning_VerticalDateLine$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_planning_VerticalDateLine$$anon$5, "com.papasofokli.planning.VerticalDateLine$$anon$5", ({
  qC: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37(ReadersVersionSpecific_this$68, paramCount$19, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$19 <= 64)) {
    if ((paramCount$19 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$19) === 0) ? (1 << paramCount$19) : 0);
      var hi = (((32 & paramCount$19) === 0) ? 0 : (1 << paramCount$19));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$19 >> 31);
    var $x_1_$_lo = paramCount$19;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$68, paramCount$19, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_planning_VesselScheduleJS$().arP(ReadersVersionSpecific_this$68), $m_Lcom_papasofokli_planning_VesselScheduleJS$().arQ());
}
$p = $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37;
/** @constructor */
function $h_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37() {
}
$h_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().bl, $m_Lupickle_default$().bl, $m_Lupickle_default$().bl, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().bl, $m_Lupickle_default$().bl, $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J)]);
  var this$9 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$9.G() >= 0)) {
    var destination = new $ac_O(this$9.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$9, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$9.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "id": {
      return 0;
      break;
    }
    case "voyageId": {
      return 1;
      break;
    }
    case "vesselId": {
      return 2;
      break;
    }
    case "vesselName": {
      return 3;
      break;
    }
    case "sailingType": {
      return 4;
      break;
    }
    case "portName": {
      return 5;
      break;
    }
    case "voyageNumber": {
      return 6;
      break;
    }
    case "from": {
      return 7;
      break;
    }
    case "to": {
      return 8;
      break;
    }
    case "remarks": {
      return 9;
      break;
    }
    case "customCss": {
      return 10;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["id", "voyageId", "vesselId", "vesselName", "sailingType", "portName", "voyageNumber", "from", "to", "remarks", "customCss"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37 = new $TypeData().i($c_Lcom_papasofokli_planning_VesselScheduleJS$$anon$37, "com.papasofokli.planning.VesselScheduleJS$$anon$37", ({
  qF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_popover_PopoverSetupData$().arR(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_popover_PopoverSetupData$().arS());
}
$p = $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_popover_PopoverSetupData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_popover_PopoverSetupData$$anon$1() {
}
$h_Lcom_papasofokli_popover_PopoverSetupData$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().bf, $m_Lupickle_default$().bf, $m_Lupickle_default$().J, $m_Lupickle_default$().J, $m_Lupickle_default$().bf, $m_Lupickle_default$().aT]);
  var this$7 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$7.G() >= 0)) {
    var destination = new $ac_O(this$7.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$7, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$7.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "title": {
      return 0;
      break;
    }
    case "content": {
      return 1;
      break;
    }
    case "html": {
      return 2;
      break;
    }
    case "sanitize": {
      return 3;
      break;
    }
    case "customClass": {
      return 4;
      break;
    }
    case "placement": {
      return 5;
      break;
    }
    case "dismissible": {
      return 6;
      break;
    }
    case "tabIndex": {
      return 7;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["title", "content", "html", "sanitize", "customClass", "placement", "dismissible", "tabIndex"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(2, false);
  x.ag(3, true);
  x.ag(4, "");
  x.ag(5, "auto");
});
var $d_Lcom_papasofokli_popover_PopoverSetupData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_popover_PopoverSetupData$$anon$1, "com.papasofokli.popover.PopoverSetupData$$anon$1", ({
  rb: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$3(ReadersVersionSpecific_this$7, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_rating_RatingClientMessages$().arT(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_rating_RatingClientMessages$().arU());
}
$p = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingClientMessages$$anon$3() {
}
$h_Lcom_papasofokli_rating_RatingClientMessages$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().Dw), $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "value") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("value", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_rating_RatingClientMessages$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingClientMessages$$anon$3, "com.papasofokli.rating.RatingClientMessages$$anon$3", ({
  ro: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$4(ReadersVersionSpecific_this$12, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$12, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_rating_RatingClientMessages$().arV(ReadersVersionSpecific_this$12), $m_Lcom_papasofokli_rating_RatingClientMessages$().arW());
}
$p = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_rating_RatingClientMessages$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingClientMessages$$anon$4() {
}
$h_Lcom_papasofokli_rating_RatingClientMessages$$anon$4.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_rating_RatingClientMessages$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingClientMessages$$anon$4, "com.papasofokli.rating.RatingClientMessages$$anon$4", ({
  rp: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_rating_RatingInitialData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_rating_RatingInitialData$().arX(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_rating_RatingInitialData$().arY());
}
$p = $c_Lcom_papasofokli_rating_RatingInitialData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_rating_RatingInitialData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_rating_RatingInitialData$$anon$1() {
}
$h_Lcom_papasofokli_rating_RatingInitialData$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_4 = new $c_T2(null, null);
  var $x_3 = $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().Dw);
  var $x_2 = $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().Dw, $m_Lupickle_default$().J);
  var $x_1 = $m_Lupickle_default$().bf;
  var ReadersVersionSpecific_this = $m_Lupickle_default$();
  $m_Lcom_papasofokli_util_IconUI$();
  var e = $m_Lcom_papasofokli_util_GeneralText$().q();
  var this$7 = new $c_sci_$colon$colon($x_3, new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lupickle_core_Types$TaggedReader$Leaf(ReadersVersionSpecific_this.aq(), "$type", "com.papasofokli.util.IconUI", "IconUI", e.f5("com.papasofokli.util.IconUI")), $m_sci_Nil$()))));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$7);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_4, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "initialValue": {
      return 0;
      break;
    }
    case "selections": {
      return 1;
      break;
    }
    case "disabled": {
      return 2;
      break;
    }
    case "icon": {
      return 3;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("initialValue", new $c_sci_$colon$colon("selections", new $c_sci_$colon$colon("disabled", new $c_sci_$colon$colon("icon", $m_sci_Nil$()))));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, false);
});
var $d_Lcom_papasofokli_rating_RatingInitialData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_rating_RatingInitialData$$anon$1, "com.papasofokli.rating.RatingInitialData$$anon$1", ({
  rt: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1(ReadersVersionSpecific_this$1, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$1, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$().as0(ReadersVersionSpecific_this$1), $m_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$().as1());
}
$p = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1() {
}
$h_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [$m_Lupickle_default$().J, $m_Lupickle_default$().J, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_sortable_SortableElement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lcom_papasofokli_sortable_SortableElement$().q(), new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $m_Lupickle_default$().aG, $m_Lupickle_default$().aG, $m_Lupickle_default$().aG, new $c_Lupickle_implicits_Readers$SeqLikeReader($m_Lupickle_default$(), $m_Lupickle_default$().bl, new $c_sc_IterableFactory$ToFactory($m_sci_Seq$())), $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J)]);
  var this$17 = $m_sci_Nil$().aY(elems);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  if ((this$17.G() >= 0)) {
    var destination = new $ac_O(this$17.G());
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$17, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = this$17.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v($d_O.l(), jsElems);
  }
  return new $c_T2(_1, $x_1);
});
$p.ad = (function(x) {
  switch (x) {
    case "leftTitle": {
      return 0;
      break;
    }
    case "rightTitle": {
      return 1;
      break;
    }
    case "leftListItems": {
      return 2;
      break;
    }
    case "rightListItems": {
      return 3;
      break;
    }
    case "leftListUpdateFun": {
      return 4;
      break;
    }
    case "rightListUpdateFun": {
      return 5;
      break;
    }
    case "contextMenuFun": {
      return 6;
      break;
    }
    case "blockedItemsIds": {
      return 7;
      break;
    }
    case "blockedItemsMessage": {
      return 8;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  $m_sci_List$();
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), ["leftTitle", "rightTitle", "leftListItems", "rightListItems", "leftListUpdateFun", "rightListUpdateFun", "contextMenuFun", "blockedItemsIds", "blockedItemsMessage"]);
  var this$6 = $m_sci_Nil$().aY(elems);
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  if ((this$6.G() >= 0)) {
    var length = this$6.G();
    var componentType = evidence$1__runtimeClass;
    var destination = componentType.ax.U(length);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$6, destination, 0, 2147483647);
    var $x_1 = destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1__runtimeClass;
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.l());
    jsElems = [];
    var it = this$6.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
      jsElems.push(unboxedElem);
    }
    var $x_1 = $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
  }
  return $x_1;
});
$p.ae = (function(x) {
  x.ag(8, $m_s_None$());
});
var $d_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableConnectedListsSetupData$$anon$1, "com.papasofokli.sortable.SortableConnectedListsSetupData$$anon$1", ({
  rB: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_sortable_SortableElement$$anon$5(ReadersVersionSpecific_this$7, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$7, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_sortable_SortableElement$().as2(ReadersVersionSpecific_this$7), $m_Lcom_papasofokli_sortable_SortableElement$().as3());
}
$p = $c_Lcom_papasofokli_sortable_SortableElement$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_sortable_SortableElement$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_sortable_SortableElement$$anon$5() {
}
$h_Lcom_papasofokli_sortable_SortableElement$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().bl, new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "recordId": {
      return 0;
      break;
    }
    case "name": {
      return 1;
      break;
    }
    case "description": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("recordId", new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("description", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, $m_s_None$());
});
var $d_Lcom_papasofokli_sortable_SortableElement$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_sortable_SortableElement$$anon$5, "com.papasofokli.sortable.SortableElement$$anon$5", ({
  rF: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_api_ForeignHyperLink(href, interiorElements) {
  this.a5z = null;
  this.a5A = false;
  this.a5x = null;
  this.a5y = false;
  this.a5D = null;
  this.a5B = null;
  this.a5w = null;
  this.a5C = null;
  this.Bq = null;
  this.Br = null;
  this.Bq = href;
  this.Br = interiorElements;
  $f_Lcom_papasofokli_svg_api_ForeignShape__$init$__V(this);
  this.a5C = "a";
}
$p = $c_Lcom_papasofokli_svg_api_ForeignHyperLink.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_ForeignHyperLink;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_ForeignHyperLink() {
}
$h_Lcom_papasofokli_svg_api_ForeignHyperLink.prototype = $p;
$p.g9 = (function() {
  if ((!this.a5A)) {
    this.a5z = $m_ju_UUID$().aW();
    this.a5A = true;
  }
  return this.a5z;
});
$p.oG = (function() {
  if ((!this.a5y)) {
    this.a5x = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a5y = true;
  }
  return this.a5x;
});
$p.oT = (function() {
  return $m_s_None$();
});
$p.p1 = (function() {
  return this.a5D;
});
$p.oV = (function() {
  return this.a5B;
});
$p.TX = (function(x$0) {
  this.a5D = x$0;
});
$p.TW = (function(x$0) {
  this.a5B = x$0;
});
$p.TV = (function(x$0) {
  this.a5w = x$0;
});
$p.p0 = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return new $c_sci_$colon$colon(this.a5w, $m_sci_Nil$());
});
$p.oC = (function() {
  return $m_s_None$();
});
$p.oZ = (function() {
  return this.a5C;
});
$p.oE = (function() {
  return $f_Lcom_papasofokli_svg_api_HyperLink__attributeValues__sci_Seq(this);
});
$p.oP = (function() {
  return $m_s_None$();
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1828323766), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_ForeignHyperLink)) {
    if ((this.Bq === x$0.Bq)) {
      var x = this.Br;
      var x$2 = x$0.Br;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "ForeignHyperLink";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Bq;
  }
  if ((n === 1)) {
    return this.Br;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ahH = (function() {
  return this.Bq;
});
$p.oQ = (function() {
  return this.Br;
});
function $isArrayOf_Lcom_papasofokli_svg_api_ForeignHyperLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fK)));
}
var $d_Lcom_papasofokli_svg_api_ForeignHyperLink = new $TypeData().i($c_Lcom_papasofokli_svg_api_ForeignHyperLink, "com.papasofokli.svg.api.ForeignHyperLink", ({
  fK: 1,
  aH: 1,
  ci: 1,
  fO: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_api_ForeignIcon(extraClass, contextMenuFunction, clickFun, onHover, onMouseOut, color) {
  this.a5K = null;
  this.a5L = false;
  this.a5I = null;
  this.a5J = false;
  this.a5Q = null;
  this.a5O = null;
  this.a5H = null;
  this.a5F = null;
  this.a5G = false;
  this.Ks = null;
  this.Fp = null;
  this.Fn = null;
  this.Fq = null;
  this.Fr = null;
  this.Fo = null;
  this.a5N = null;
  this.a5M = null;
  this.a5E = null;
  this.a5P = null;
  this.Ks = extraClass;
  this.Fp = contextMenuFunction;
  this.Fn = clickFun;
  this.Fq = onHover;
  this.Fr = onMouseOut;
  this.Fo = color;
  $f_Lcom_papasofokli_svg_api_ForeignShape__$init$__V(this);
  this.a5N = $m_sci_Nil$();
  this.a5M = extraClass;
  this.a5E = $m_sci_Nil$();
  this.a5P = "i";
}
$p = $c_Lcom_papasofokli_svg_api_ForeignIcon.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_ForeignIcon;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_ForeignIcon() {
}
$h_Lcom_papasofokli_svg_api_ForeignIcon.prototype = $p;
$p.g9 = (function() {
  if ((!this.a5L)) {
    this.a5K = $m_ju_UUID$().aW();
    this.a5L = true;
  }
  return this.a5K;
});
$p.oG = (function() {
  if ((!this.a5J)) {
    this.a5I = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a5J = true;
  }
  return this.a5I;
});
$p.p1 = (function() {
  return this.a5Q;
});
$p.oV = (function() {
  return this.a5O;
});
$p.TX = (function(x$0) {
  this.a5Q = x$0;
});
$p.TW = (function(x$0) {
  this.a5O = x$0;
});
$p.TV = (function(x$0) {
  this.a5H = x$0;
});
$p.p0 = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return new $c_sci_$colon$colon(this.a5H, $m_sci_Nil$());
});
$p.oC = (function() {
  return $m_s_None$();
});
$p.E0 = (function(element, dx, dy) {
});
$p.zB = (function() {
  return $m_s_None$();
});
$p.zC = (function() {
  return $m_s_None$();
});
$p.zD = (function() {
  return $m_s_None$();
});
$p.Eh = (function() {
  return false;
});
$p.oN = (function() {
  return $m_sci_Nil$();
});
$p.DV = (function() {
  if ((!this.a5G)) {
    this.a5F = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a5G = true;
  }
  return this.a5F;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1957063574), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_ForeignIcon)) {
    var x = this.Ks;
    var x$2 = x$0.Ks;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.Fp;
      var x$4 = x$0.Fp;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Fn;
      var x$6 = x$0.Fn;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Fq;
      var x$8 = x$0.Fq;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Fr;
      var x$10 = x$0.Fr;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Fo;
      var x$12 = x$0.Fo;
      return ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 6;
});
$p.A = (function() {
  return "ForeignIcon";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Ks;
      break;
    }
    case 1: {
      return this.Fp;
      break;
    }
    case 2: {
      return this.Fn;
      break;
    }
    case 3: {
      return this.Fq;
      break;
    }
    case 4: {
      return this.Fr;
      break;
    }
    case 5: {
      return this.Fo;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.DW = (function() {
  return this.Fp;
});
$p.DU = (function() {
  return this.Fn;
});
$p.Ep = (function() {
  return this.Fq;
});
$p.Eq = (function() {
  return this.Fr;
});
$p.oF = (function() {
  return this.Fo;
});
$p.oQ = (function() {
  return this.a5N;
});
$p.oP = (function() {
  return this.a5M;
});
$p.oE = (function() {
  return this.a5E;
});
$p.oZ = (function() {
  return this.a5P;
});
$p.zU = (function() {
});
function $isArrayOf_Lcom_papasofokli_svg_api_ForeignIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fL)));
}
var $d_Lcom_papasofokli_svg_api_ForeignIcon = new $TypeData().i($c_Lcom_papasofokli_svg_api_ForeignIcon, "com.papasofokli.svg.api.ForeignIcon", ({
  fL: 1,
  aH: 1,
  ci: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__totalHeight__s_Option($thiz) {
  try {
    var $x_1 = new $c_s_util_Success(Math.fround((Math.fround((+$thiz.nP.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(_$2$2)))).aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__getInnerElementsHeight__Lorg_scalajs_dom_Element__sci_Seq($thiz, e$2).aV((+(0, $m_Lcom_papasofokli_jquery_package$().I)(e$2).height()))))).fq($m_s_math_Ordering$Double$TotalOrdering$()))) + 5.0)));
  } catch (e) {
    var e$2$1 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2$1);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
    }
  }
  return $x_1.mN();
}
function $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__getInnerElementsHeight__Lorg_scalajs_dom_Element__sci_Seq($thiz, e) {
  var array$1 = $m_sjs_js_ArrayOps$().ani((0, $m_Lcom_papasofokli_jquery_package$().I)(e).children().toArray(), new $c_Lcom_papasofokli_svg_api_ForeignObjectContainer$$anon$1());
  return $m_sci_IndexedSeq$().oK($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$1));
}
function $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__moveTo__Lorg_scalajs_dom_Element__F__F__V($thiz, element, newX1, newY1) {
  new $c_Lcom_papasofokli_util_AttributeValue("x", newX1).ds(element);
  new $c_Lcom_papasofokli_util_AttributeValue("y", newY1).ds(element);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_ForeignObjectContainer(initialX, initialY, interiorElements, initialClassName, width, height, appendWithAnimationTime, dragStartFun, dragStopFun, draggingFun, clickFun, getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag) {
  this.a5X = null;
  this.a5Y = false;
  this.a5T = null;
  this.a5U = false;
  this.a5Z = null;
  this.a5R = null;
  this.a5S = false;
  this.Bs = 0.0;
  this.xw = 0.0;
  this.nP = null;
  this.sU = null;
  this.xA = null;
  this.xv = null;
  this.xo = null;
  this.xr = null;
  this.xs = null;
  this.xt = null;
  this.xp = null;
  this.xu = null;
  this.xy = null;
  this.xz = null;
  this.xq = null;
  this.xx = false;
  this.a5V = null;
  this.a5W = false;
  this.a61 = null;
  this.a60 = null;
  this.Bs = initialX;
  this.xw = initialY;
  this.nP = interiorElements;
  this.sU = initialClassName;
  this.xA = width;
  this.xv = height;
  this.xo = appendWithAnimationTime;
  this.xr = dragStartFun;
  this.xs = dragStopFun;
  this.xt = draggingFun;
  this.xp = clickFun;
  this.xu = getGroupedDraggedShapes;
  this.xy = onHover;
  this.xz = onMouseOut;
  this.xq = contextMenuFunction;
  this.xx = isMovableOnDrag;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a61 = new $c_s_Some(initialX);
  this.a60 = "foreignObject";
}
$p = $c_Lcom_papasofokli_svg_api_ForeignObjectContainer.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_ForeignObjectContainer;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_ForeignObjectContainer() {
}
$h_Lcom_papasofokli_svg_api_ForeignObjectContainer.prototype = $p;
$p.g9 = (function() {
  if ((!this.a5Y)) {
    this.a5X = $m_ju_UUID$().aW();
    this.a5Y = true;
  }
  return this.a5X;
});
$p.oG = (function() {
  if ((!this.a5U)) {
    this.a5T = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a5U = true;
  }
  return this.a5T;
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a5Z;
});
$p.zx = (function(x$0) {
  this.a5Z = x$0;
});
$p.DV = (function() {
  if ((!this.a5S)) {
    this.a5R = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a5S = true;
  }
  return this.a5R;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.zU = (function() {
  $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 732471470);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Bs));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.xw));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.nP));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.sU));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xA));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xv));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xo));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xr));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xs));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xt));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xp));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xu));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xy));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xq));
  acc = $m_sr_Statics$().d(acc, (this.xx ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 16);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_ForeignObjectContainer)) {
    if ((((this.Bs === x$0.Bs) && (this.xw === x$0.xw)) && (this.xx === x$0.xx))) {
      var x = this.nP;
      var x$2 = x$0.nP;
      var $x_12 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$3 = this.sU;
      var x$4 = x$0.sU;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.xA;
      var x$6 = x$0.xA;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.xv;
      var x$8 = x$0.xv;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.xo;
      var x$10 = x$0.xo;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.xr;
      var x$12 = x$0.xr;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.xs;
      var x$14 = x$0.xs;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.xt;
      var x$16 = x$0.xt;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.xp;
      var x$18 = x$0.xp;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.xu;
      var x$20 = x$0.xu;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : (x$19 === x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.xy;
      var x$22 = x$0.xy;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.xz;
      var x$24 = x$0.xz;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$25 = this.xq;
      var x$26 = x$0.xq;
      return ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 16;
});
$p.A = (function() {
  return "ForeignObjectContainer";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Bs;
      break;
    }
    case 1: {
      return this.xw;
      break;
    }
    case 2: {
      return this.nP;
      break;
    }
    case 3: {
      return this.sU;
      break;
    }
    case 4: {
      return this.xA;
      break;
    }
    case 5: {
      return this.xv;
      break;
    }
    case 6: {
      return this.xo;
      break;
    }
    case 7: {
      return this.xr;
      break;
    }
    case 8: {
      return this.xs;
      break;
    }
    case 9: {
      return this.xt;
      break;
    }
    case 10: {
      return this.xp;
      break;
    }
    case 11: {
      return this.xu;
      break;
    }
    case 12: {
      return this.xy;
      break;
    }
    case 13: {
      return this.xz;
      break;
    }
    case 14: {
      return this.xq;
      break;
    }
    case 15: {
      return this.xx;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oQ = (function() {
  return this.nP;
});
$p.oP = (function() {
  return this.sU;
});
$p.oC = (function() {
  return this.xo;
});
$p.zB = (function() {
  return this.xr;
});
$p.zC = (function() {
  return this.xs;
});
$p.zD = (function() {
  return this.xt;
});
$p.DU = (function() {
  return this.xp;
});
$p.Ep = (function() {
  return this.xy;
});
$p.Eq = (function() {
  return this.xz;
});
$p.DW = (function() {
  return this.xq;
});
$p.Eh = (function() {
  return this.xx;
});
$p.oN = (function() {
  if ((!this.a5W)) {
    this.a5V = this.xu.aA();
    this.a5W = true;
  }
  return this.a5V;
});
$p.p1 = (function() {
  return this.a61;
});
$p.ake = (function() {
  return Math.fround((Math.fround(this.nP.aL(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(_$1$2)))).X(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((e$2) => Math.fround((Math.fround((+(0, $m_Lcom_papasofokli_jquery_package$().I)(e$2).width())) + 6.0))))).gO($m_s_math_Numeric$FloatIsFractional$())) + 1.0));
});
$p.oE = (function() {
  var this$1 = this.xA;
  var widthAttr = new $c_Lcom_papasofokli_util_AttributeValue("width", (this$1.c() ? this.ake() : this$1.h()));
  var this$3 = this.xv;
  var this$4 = (this$3.c() ? $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__totalHeight__s_Option(this) : this$3);
  var heightAttr = (this$4.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_AttributeValue("height", Math.fround(this$4.h()))));
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("x", this.Bs), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("y", this.xw), new $c_sci_$colon$colon(widthAttr, $m_sci_Nil$()))).cY(heightAttr);
});
$p.cT = (function(newX, newY) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$1.c())) {
    $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__moveTo__Lorg_scalajs_dom_Element__F__F__V(this, this$1.h(), newX, newY);
  }
});
$p.oZ = (function() {
  return this.a60;
});
$p.E0 = (function(element, dx, dy) {
  try {
    var $x_1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("x"))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  var newX1U = $x_1.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => Math.fround((Math.fround(_$3$3) + dx)))));
  try {
    var $x_2 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("y"))));
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchResult1$1: {
      var $x_2;
      var x2$1 = $m_s_util_control_NonFatal$().dV(e$2$1);
      if ((!x2$1.c())) {
        var $x_2 = new $c_s_util_Failure(x2$1.h());
        break matchResult1$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
    }
  }
  var newY1U = $x_2.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => Math.fround((Math.fround(_$4$3) + dy)))));
  newX1U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var newX1 = Math.fround(v1$2);
    newY1U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2$1) => {
      $p_Lcom_papasofokli_svg_api_ForeignObjectContainer__moveTo__Lorg_scalajs_dom_Element__F__F__V(this, element, newX1, Math.fround(v1$2$1));
    })));
  })));
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.p0 = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lcom_papasofokli_svg_api_ForeignObjectContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fM)));
}
var $d_Lcom_papasofokli_svg_api_ForeignObjectContainer = new $TypeData().i($c_Lcom_papasofokli_svg_api_ForeignObjectContainer, "com.papasofokli.svg.api.ForeignObjectContainer", ({
  fM: 1,
  aH: 1,
  b0: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_api_ForeignSpan(generalText, extraClass, extraIconClass, contextMenuFunction, clickFun, onHover, onMouseOut, color) {
  this.a68 = null;
  this.a69 = false;
  this.a66 = null;
  this.a67 = false;
  this.a6d = null;
  this.a6b = null;
  this.a65 = null;
  this.a63 = null;
  this.a64 = false;
  this.Fw = null;
  this.Fu = null;
  this.Fv = null;
  this.Ft = null;
  this.Fs = null;
  this.Fx = null;
  this.Fy = null;
  this.Bt = null;
  this.Q8 = null;
  this.a6a = null;
  this.Q9 = null;
  this.a62 = null;
  this.a6c = null;
  this.Fw = generalText;
  this.Fu = extraClass;
  this.Fv = extraIconClass;
  this.Ft = contextMenuFunction;
  this.Fs = clickFun;
  this.Fx = onHover;
  this.Fy = onMouseOut;
  this.Bt = color;
  $f_Lcom_papasofokli_svg_api_ForeignShape__$init$__V(this);
  this.Q8 = ((generalText instanceof $c_Lcom_papasofokli_util_IconUI) ? ($m_Lcom_papasofokli_util_IconUI$(), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_svg_api_ForeignIcon(new $c_s_Some(((generalText.by + " ") + (extraIconClass.c() ? "" : extraIconClass.h()))), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), $m_sci_Nil$())) : ((generalText instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon) ? new $c_sci_$colon$colon(new $c_Lcom_papasofokli_svg_api_ForeignIcon(new $c_s_Some(((generalText.t5 + " ") + (extraIconClass.c() ? "" : extraIconClass.h()))), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()), $m_sci_Nil$()) : $m_sci_Nil$()));
  if ((generalText instanceof $c_Lcom_papasofokli_util_CountryFlagIcon)) {
    var $x_2 = $m_s_Option$();
    var this$18 = (extraClass.c() ? $m_s_None$() : new $c_s_Some(((extraClass.h() + " ") + generalText.g())));
    var $x_1 = $x_2.Z((this$18.c() ? generalText.g() : this$18.h()));
  } else if ((generalText instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon)) {
    var $x_3 = $m_s_Option$();
    var this$21 = (extraClass.c() ? $m_s_None$() : new $c_s_Some((extraClass.h() + " flag-icon-background")));
    var $x_1 = $x_3.Z((this$21.c() ? "flag-icon-background" : this$21.h()));
  } else {
    var $x_1 = extraClass;
  }
  this.a6a = $x_1;
  this.Q9 = "fa-spin";
  var baseAttributes = ((generalText instanceof $c_Lcom_papasofokli_util_SpanTextContainer) ? new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_TextContent(generalText.xT), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_StyleValue("white-space", "pre"), $m_sci_Nil$())) : $m_sci_Nil$());
  if ((generalText instanceof $c_Lcom_papasofokli_util_GenderSymbolIcon)) {
    var this$25 = generalText.t4;
    var effectiveColor = (this$25.c() ? color : this$25);
  } else {
    var effectiveColor = color;
  }
  var $x_5 = $m_s_Option$();
  if (effectiveColor.c()) {
    var $x_4 = $m_s_None$();
  } else {
    var x0$2 = effectiveColor.h();
    var $x_4 = new $c_s_Some(new $c_Lcom_papasofokli_util_StyleValue("color", (((((("rgb(" + x0$2.nE) + ",") + x0$2.nD) + ",") + x0$2.nC) + ")")));
  }
  this.a62 = baseAttributes.cH($x_5.hi($x_4).cf());
  this.a6c = "span";
}
$p = $c_Lcom_papasofokli_svg_api_ForeignSpan.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_ForeignSpan;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_ForeignSpan() {
}
$h_Lcom_papasofokli_svg_api_ForeignSpan.prototype = $p;
$p.g9 = (function() {
  if ((!this.a69)) {
    this.a68 = $m_ju_UUID$().aW();
    this.a69 = true;
  }
  return this.a68;
});
$p.oG = (function() {
  if ((!this.a67)) {
    this.a66 = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a67 = true;
  }
  return this.a66;
});
$p.p1 = (function() {
  return this.a6d;
});
$p.oV = (function() {
  return this.a6b;
});
$p.TX = (function(x$0) {
  this.a6d = x$0;
});
$p.TW = (function(x$0) {
  this.a6b = x$0;
});
$p.TV = (function(x$0) {
  this.a65 = x$0;
});
$p.p0 = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return new $c_sci_$colon$colon(this.a65, $m_sci_Nil$());
});
$p.oC = (function() {
  return $m_s_None$();
});
$p.E0 = (function(element, dx, dy) {
});
$p.zB = (function() {
  return $m_s_None$();
});
$p.zC = (function() {
  return $m_s_None$();
});
$p.zD = (function() {
  return $m_s_None$();
});
$p.Eh = (function() {
  return false;
});
$p.oN = (function() {
  return $m_sci_Nil$();
});
$p.DV = (function() {
  if ((!this.a64)) {
    this.a63 = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a64 = true;
  }
  return this.a63;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.zU = (function() {
  $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1994854236, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_ForeignSpan)) {
    var x = this.Fw;
    var x$2 = x$0.Fw;
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      var x$3 = this.Fu;
      var x$4 = x$0.Fu;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.Fv;
      var x$6 = x$0.Fv;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.Ft;
      var x$8 = x$0.Ft;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.Fs;
      var x$10 = x$0.Fs;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.Fx;
      var x$12 = x$0.Fx;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Fy;
      var x$14 = x$0.Fy;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.Bt;
      var x$16 = x$0.Bt;
      return ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 8;
});
$p.A = (function() {
  return "ForeignSpan";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.Fw;
      break;
    }
    case 1: {
      return this.Fu;
      break;
    }
    case 2: {
      return this.Fv;
      break;
    }
    case 3: {
      return this.Ft;
      break;
    }
    case 4: {
      return this.Fs;
      break;
    }
    case 5: {
      return this.Fx;
      break;
    }
    case 6: {
      return this.Fy;
      break;
    }
    case 7: {
      return this.Bt;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.DW = (function() {
  return this.Ft;
});
$p.DU = (function() {
  return this.Fs;
});
$p.Ep = (function() {
  return this.Fx;
});
$p.Eq = (function() {
  return this.Fy;
});
$p.oF = (function() {
  return this.Bt;
});
$p.oQ = (function() {
  return this.Q8;
});
$p.oP = (function() {
  return this.a6a;
});
$p.VA = (function() {
  var x18 = this.Q8.bj();
  if ((x18 instanceof $c_s_Some)) {
    $f_Lcom_papasofokli_svg_api_GeneralShape__addClass__T__V(x18.bg, this.Q9);
    return (void 0);
  }
  if (($m_s_None$() === x18)) {
    $f_Lcom_papasofokli_svg_api_GeneralShape__addClass__T__V(this, this.Q9);
    return (void 0);
  }
  throw new $c_s_MatchError(x18);
});
$p.oE = (function() {
  return this.a62;
});
$p.oZ = (function() {
  return this.a6c;
});
function $isArrayOf_Lcom_papasofokli_svg_api_ForeignSpan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fN)));
}
var $d_Lcom_papasofokli_svg_api_ForeignSpan = new $TypeData().i($c_Lcom_papasofokli_svg_api_ForeignSpan, "com.papasofokli.svg.api.ForeignSpan", ({
  fN: 1,
  aH: 1,
  ci: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_svg_api_SvgHyperLink(href, interiorElements) {
  this.a6L = null;
  this.a6M = false;
  this.a6J = null;
  this.a6K = false;
  this.a6N = null;
  this.a6O = null;
  this.Fz = null;
  this.FA = null;
  this.a6P = null;
  this.Fz = href;
  this.FA = interiorElements;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a6O = "a";
  this.a6P = $m_s_None$();
}
$p = $c_Lcom_papasofokli_svg_api_SvgHyperLink.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_SvgHyperLink;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_SvgHyperLink() {
}
$h_Lcom_papasofokli_svg_api_SvgHyperLink.prototype = $p;
$p.g9 = (function() {
  if ((!this.a6M)) {
    this.a6L = $m_ju_UUID$().aW();
    this.a6M = true;
  }
  return this.a6L;
});
$p.oG = (function() {
  if ((!this.a6K)) {
    this.a6J = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a6K = true;
  }
  return this.a6J;
});
$p.oT = (function() {
  return $m_s_None$();
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a6N;
});
$p.zx = (function(x$0) {
  this.a6N = x$0;
});
$p.oZ = (function() {
  return this.a6O;
});
$p.oE = (function() {
  return $f_Lcom_papasofokli_svg_api_HyperLink__attributeValues__sci_Seq(this);
});
$p.oP = (function() {
  return $m_s_None$();
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 1442299823, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_SvgHyperLink)) {
    if ((this.Fz === x$0.Fz)) {
      var x = this.FA;
      var x$2 = x$0.FA;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "SvgHyperLink";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Fz;
  }
  if ((n === 1)) {
    return this.FA;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ahH = (function() {
  return this.Fz;
});
$p.oQ = (function() {
  return this.FA;
});
$p.oC = (function() {
  return $m_s_None$();
});
$p.p1 = (function() {
  return this.a6P;
});
$p.p0 = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lcom_papasofokli_svg_api_SvgHyperLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fS)));
}
var $d_Lcom_papasofokli_svg_api_SvgHyperLink = new $TypeData().i($c_Lcom_papasofokli_svg_api_SvgHyperLink, "com.papasofokli.svg.api.SvgHyperLink", ({
  fS: 1,
  aH: 1,
  b0: 1,
  fO: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_GeneralText$().as4(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_util_GeneralText$().as6());
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$1() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "text") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("text", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$1, "com.papasofokli.util.GeneralText$$anon$1", ({
  st: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$2(ReadersVersionSpecific_this$9, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$9, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_GeneralText$().as7(ReadersVersionSpecific_this$9), $m_Lcom_papasofokli_util_GeneralText$().as8());
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$2() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$2.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lcom_papasofokli_planning_SvgColor$().q()), new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$())));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  switch (x) {
    case "iconCode": {
      return 0;
      break;
    }
    case "color": {
      return 1;
      break;
    }
    case "extraClass": {
      return 2;
      break;
    }
    default: {
      return (-1);
    }
  }
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("iconCode", new $c_sci_$colon$colon("color", new $c_sci_$colon$colon("extraClass", $m_sci_Nil$())));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(2, "");
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$2, "com.papasofokli.util.GeneralText$$anon$2", ({
  sv: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$3(ReadersVersionSpecific_this$14, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$14, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_GeneralText$().as9(ReadersVersionSpecific_this$14), $m_Lcom_papasofokli_util_GeneralText$().asa());
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$3() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$3.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "countryCode") ? 0 : ((x === "extraClass") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("countryCode", new $c_sci_$colon$colon("extraClass", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, "");
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$3, "com.papasofokli.util.GeneralText$$anon$3", ({
  sw: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$4(ReadersVersionSpecific_this$19, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_GeneralText$().asb(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_util_GeneralText$().asc());
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$4() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$4.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "name") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$4, "com.papasofokli.util.GeneralText$$anon$4", ({
  sx: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_GeneralText$$anon$5(ReadersVersionSpecific_this$24, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$24, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_GeneralText$().asd(ReadersVersionSpecific_this$24), $m_Lcom_papasofokli_util_GeneralText$().as5());
}
$p = $c_Lcom_papasofokli_util_GeneralText$$anon$5.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_GeneralText$$anon$5;
/** @constructor */
function $h_Lcom_papasofokli_util_GeneralText$$anon$5() {
}
$h_Lcom_papasofokli_util_GeneralText$$anon$5.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$4 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($m_Lupickle_default$(), $m_Lupickle_default$().J), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "name") ? 0 : ((x === "tooltip") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("name", new $c_sci_$colon$colon("tooltip", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
  x.ag(1, ($m_Lcom_papasofokli_util_IconUI$(), $m_s_None$()));
});
var $d_Lcom_papasofokli_util_GeneralText$$anon$5 = new $TypeData().i($c_Lcom_papasofokli_util_GeneralText$$anon$5, "com.papasofokli.util.GeneralText$$anon$5", ({
  sy: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_ProgressBarStyle$().ase(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_util_ProgressBarStyle$().asf());
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle$$anon$1() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_ProgressBarStyle$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_util_ProgressBarStyle$$anon$1, "com.papasofokli.util.ProgressBarStyle$$anon$1", ({
  sL: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$2(ReadersVersionSpecific_this$9, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$9, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_ProgressBarStyle$().asg(ReadersVersionSpecific_this$9), $m_Lcom_papasofokli_util_ProgressBarStyle$().ash());
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle$$anon$2() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle$$anon$2.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_ProgressBarStyle$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_util_ProgressBarStyle$$anon$2, "com.papasofokli.util.ProgressBarStyle$$anon$2", ({
  sM: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$3(ReadersVersionSpecific_this$14, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$14, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_ProgressBarStyle$().asi(ReadersVersionSpecific_this$14), $m_Lcom_papasofokli_util_ProgressBarStyle$().asj());
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle$$anon$3() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle$$anon$3.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_ProgressBarStyle$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_util_ProgressBarStyle$$anon$3, "com.papasofokli.util.ProgressBarStyle$$anon$3", ({
  sN: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$4(ReadersVersionSpecific_this$19, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_ProgressBarStyle$().ask(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_util_ProgressBarStyle$().asl());
}
$p = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_ProgressBarStyle$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_util_ProgressBarStyle$$anon$4() {
}
$h_Lcom_papasofokli_util_ProgressBarStyle$$anon$4.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_ProgressBarStyle$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_util_ProgressBarStyle$$anon$4, "com.papasofokli.util.ProgressBarStyle$$anon$4", ({
  sO: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().asm(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().asn());
}
$p = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1() {
}
$h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$1, "com.papasofokli.util.formgroup.FormGroupValidationStatus$$anon$1", ({
  sZ: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2(ReadersVersionSpecific_this$9, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$9, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().aso(ReadersVersionSpecific_this$9), $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().asp());
}
$p = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2() {
}
$h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$2, "com.papasofokli.util.formgroup.FormGroupValidationStatus$$anon$2", ({
  t0: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3(ReadersVersionSpecific_this$14, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$14, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().asq(ReadersVersionSpecific_this$14), $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().asr());
}
$p = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3() {
}
$h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$3, "com.papasofokli.util.formgroup.FormGroupValidationStatus$$anon$3", ({
  t1: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4(ReadersVersionSpecific_this$19, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$19, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().ass(ReadersVersionSpecific_this$19), $m_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$().ast());
}
$p = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4() {
}
$h_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4 = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_FormGroupValidationStatus$$anon$4, "com.papasofokli.util.formgroup.FormGroupValidationStatus$$anon$4", ({
  t2: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$$anon$1(ReadersVersionSpecific_this$4, paramCount$1, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$1 <= 64)) {
    if ((paramCount$1 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$1) === 0) ? (1 << paramCount$1) : 0);
      var hi = (((32 & paramCount$1) === 0) ? 0 : (1 << paramCount$1));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$1 >> 31);
    var $x_1_$_lo = paramCount$1;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$4, paramCount$1, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_websocket_ClientMessages$().asu(ReadersVersionSpecific_this$4), $m_Lcom_papasofokli_websocket_ClientMessages$().asv());
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$1.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$$anon$1() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$$anon$1.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().bf, $m_sci_Nil$());
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "logout") ? 0 : (-1));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("logout", $m_sci_Nil$());
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_websocket_ClientMessages$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$$anon$1, "com.papasofokli.websocket.ClientMessages$$anon$1", ({
  t9: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$$anon$2(ReadersVersionSpecific_this$9, paramCount$2, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$2 <= 64)) {
    if ((paramCount$2 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$2) === 0) ? (1 << paramCount$2) : 0);
      var hi = (((32 & paramCount$2) === 0) ? 0 : (1 << paramCount$2));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$2 >> 31);
    var $x_1_$_lo = paramCount$2;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$9, paramCount$2, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_websocket_ClientMessages$().asw(ReadersVersionSpecific_this$9), $m_Lcom_papasofokli_websocket_ClientMessages$().asx());
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$2.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$2;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$$anon$2() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$$anon$2.prototype = $p;
$p.af = (function() {
  var $x_1 = new $c_T2(null, null);
  var this$3 = new $c_sci_$colon$colon($m_Lupickle_default$().J, new $c_sci_$colon$colon($m_Lcom_papasofokli_websocket_VisibilityInfo$().q(), $m_sci_Nil$()));
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
    jsElems.push(unboxedElem);
  }
  return new $c_T2($x_1, $m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
});
$p.ad = (function(x) {
  return ((x === "href") ? 0 : ((x === "visibilityInfo") ? 1 : (-1)));
});
$p.ac = (function() {
  var this$2 = new $c_sci_$colon$colon("href", new $c_sci_$colon$colon("visibilityInfo", $m_sci_Nil$()));
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1__runtimeClass;
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems);
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_websocket_ClientMessages$$anon$2 = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$$anon$2, "com.papasofokli.websocket.ClientMessages$$anon$2", ({
  ta: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_ClientMessages$$anon$3(ReadersVersionSpecific_this$14, paramCount$3, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$3 <= 64)) {
    if ((paramCount$3 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$3) === 0) ? (1 << paramCount$3) : 0);
      var hi = (((32 & paramCount$3) === 0) ? 0 : (1 << paramCount$3));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$3 >> 31);
    var $x_1_$_lo = paramCount$3;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$14, paramCount$3, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_websocket_ClientMessages$().asy(ReadersVersionSpecific_this$14), $m_Lcom_papasofokli_websocket_ClientMessages$().asz());
}
$p = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$3.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_websocket_ClientMessages$$anon$3;
/** @constructor */
function $h_Lcom_papasofokli_websocket_ClientMessages$$anon$3() {
}
$h_Lcom_papasofokli_websocket_ClientMessages$$anon$3.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_websocket_ClientMessages$$anon$3 = new $TypeData().i($c_Lcom_papasofokli_websocket_ClientMessages$$anon$3, "com.papasofokli.websocket.ClientMessages$$anon$3", ({
  tb: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7(ReadersVersionSpecific_this$21, paramCount$4, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$4 <= 64)) {
    if ((paramCount$4 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$4) === 0) ? (1 << paramCount$4) : 0);
      var hi = (((32 & paramCount$4) === 0) ? 0 : (1 << paramCount$4));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$4 >> 31);
    var $x_1_$_lo = paramCount$4;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$21, paramCount$4, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_websocket_VisibilityInfo$().asB(ReadersVersionSpecific_this$21), $m_Lcom_papasofokli_websocket_VisibilityInfo$().asC());
}
$p = $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7;
/** @constructor */
function $h_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7() {
}
$h_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7 = new $TypeData().i($c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$7, "com.papasofokli.websocket.VisibilityInfo$$anon$7", ({
  ti: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8(ReadersVersionSpecific_this$26, paramCount$5, outer) {
  this.a0 = null;
  this.Y = 0;
  this.a8 = 0;
  this.a9 = 0;
  this.a6 = false;
  this.a7 = null;
  this.a2 = null;
  this.a3 = false;
  this.a4 = false;
  this.a5 = false;
  this.ab = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((paramCount$5 <= 64)) {
    if ((paramCount$5 === 64)) {
      var $x_1_$_lo = (-1);
      var $x_1_$_hi = (-1);
    } else {
      var lo = (((32 & paramCount$5) === 0) ? (1 << paramCount$5) : 0);
      var hi = (((32 & paramCount$5) === 0) ? 0 : (1 << paramCount$5));
      var lo$1 = ((lo - 1) | 0);
      var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$1;
    }
  } else {
    var hi$2 = (paramCount$5 >> 31);
    var $x_1_$_lo = paramCount$5;
    var $x_1_$_hi = hi$2;
  }
  $ct_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3__Lupickle_implicits_ReadersVersionSpecific__I__J__Z__F2__(this, ReadersVersionSpecific_this$26, paramCount$5, $x_1_$_lo, $x_1_$_hi, $m_Lcom_papasofokli_websocket_VisibilityInfo$().asD(ReadersVersionSpecific_this$26), $m_Lcom_papasofokli_websocket_VisibilityInfo$().asA());
}
$p = $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8.prototype = new $h_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3();
$p.constructor = $c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8;
/** @constructor */
function $h_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8() {
}
$h_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8.prototype = $p;
$p.af = (function() {
  var _1 = new $c_T2(null, null);
  var this$3 = $m_sci_Nil$();
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var destination = new $ac_O(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$3, destination, 0, 2147483647);
  return new $c_T2(_1, destination);
});
$p.ad = (function(x) {
  return (-1);
});
$p.ac = (function() {
  var this$2 = $m_sci_Nil$();
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $d_T.l();
  var componentType = evidence$1__runtimeClass;
  var destination = componentType.ax.U(0);
  $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
  return destination;
});
$p.ae = (function(x) {
});
var $d_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8 = new $TypeData().i($c_Lcom_papasofokli_websocket_VisibilityInfo$$anon$8, "com.papasofokli.websocket.VisibilityInfo$$anon$8", ({
  tj: 1,
  m: 1,
  l: 1,
  d: 1,
  e: 1,
  f: 1,
  g: 1
}));
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
}
$p = $c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$p.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
$h_Ljava_io_PrintStream.prototype = $p;
$p.zT = (function(s) {
  this.ajd(s);
  this.zO("\n");
});
$p.amj = (function(csq) {
  this.ajd(((csq === null) ? "null" : $dp_toString__T(csq)));
  return this;
});
$p.Id = (function(csq) {
  return this.amj(csq);
});
/** @constructor */
function $c_Ljava_nio_HeapCharBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
  this.hs = null;
  this.iY = 0;
  this.KJ = false;
  this.KJ = _readOnly;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.eA.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.UW.call(this, _initialLimit);
}
$p = $c_Ljava_nio_HeapCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$p.constructor = $c_Ljava_nio_HeapCharBuffer;
/** @constructor */
function $h_Ljava_nio_HeapCharBuffer() {
}
$h_Ljava_nio_HeapCharBuffer.prototype = $p;
$p.IQ = (function() {
  return this.KJ;
});
$p.VB = (function(start, end) {
  var length = ((this.bF - this.b5) | 0);
  if (((((start | ((end - start) | 0)) | end) | ((length - end) | 0)) < 0)) {
    $m_jl_BoundsChecks$().ahV(start, end, length);
  }
  return new $c_Ljava_nio_HeapCharBuffer(this.iX, this.hs, this.iY, ((this.b5 + start) | 0), ((this.b5 + end) | 0), this.KJ);
});
$p.J5 = (function(c) {
  if (this.KJ) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.b5;
  if ((p === this.bF)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.b5 = ((1 + p) | 0);
  var a = this.hs;
  var i = ((this.iY + p) | 0);
  a.a[i] = c;
  return this;
});
$p.ahm = (function(index) {
  var length = this.bF;
  if (((index >>> 0) >= (length >>> 0))) {
    $m_jl_BoundsChecks$().ahT(index, length);
  }
  var a = this.hs;
  var i = ((this.iY + index) | 0);
  return a.a[i];
});
$p.ahn = (function(dst, offset, length) {
  var length$1 = dst.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(offset, length, length$1);
  }
  var p = this.b5;
  var newPos = ((p + length) | 0);
  if ((newPos > this.bF)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b5 = newPos;
  var x0 = this.hs;
  var x1 = ((this.iY + p) | 0);
  x0.av(x1, dst, offset, length);
  return this;
});
$p.IW = (function(index) {
  var a = this.hs;
  var i = ((this.iY + index) | 0);
  return a.a[i];
});
$p.ajY = (function(index, elem) {
  var a = this.hs;
  var i = ((this.iY + index) | 0);
  a.a[i] = elem;
});
$p.ajZ = (function(startIndex, src, offset, length) {
  var x2 = this.hs;
  var x3 = ((this.iY + startIndex) | 0);
  src.av(offset, x2, x3, length);
});
$p.EC = (function(start, end) {
  return this.VB(start, end);
});
var $d_Ljava_nio_HeapCharBuffer = new $TypeData().i($c_Ljava_nio_HeapCharBuffer, "java.nio.HeapCharBuffer", ({
  uf: 1,
  cq: 1,
  cp: 1,
  N: 1,
  aO: 1,
  bb: 1,
  gq: 1
}));
/** @constructor */
function $c_Ljava_nio_StringCharBuffer(_capacity, _csq, _csqOffset, _initialPosition, _initialLimit) {
  this.iX = 0;
  this.bF = 0;
  this.b5 = 0;
  this.mb = 0;
  this.hs = null;
  this.iY = 0;
  this.Cu = null;
  this.Cv = 0;
  this.Cu = _csq;
  this.Cv = _csqOffset;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, null, (-1));
  $c_Ljava_nio_Buffer.prototype.eA.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.UW.call(this, _initialLimit);
}
$p = $c_Ljava_nio_StringCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$p.constructor = $c_Ljava_nio_StringCharBuffer;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer() {
}
$h_Ljava_nio_StringCharBuffer.prototype = $p;
$p.IQ = (function() {
  return true;
});
$p.VB = (function(start, end) {
  var length = ((this.bF - this.b5) | 0);
  if (((((start | ((end - start) | 0)) | end) | ((length - end) | 0)) < 0)) {
    $m_jl_BoundsChecks$().ahV(start, end, length);
  }
  return new $c_Ljava_nio_StringCharBuffer(this.iX, this.Cu, this.Cv, ((this.b5 + start) | 0), ((this.b5 + end) | 0));
});
$p.J5 = (function(c) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.ahm = (function(index) {
  var length = this.bF;
  if (((index >>> 0) >= (length >>> 0))) {
    $m_jl_BoundsChecks$().ahT(index, length);
  }
  return $dp_charAt__I__C(this.Cu, ((this.Cv + index) | 0));
});
$p.ahn = (function(dst, offset, length) {
  var length$1 = dst.a.length;
  var endOffset = ((offset + length) | 0);
  if (((((offset | length) | endOffset) | ((length$1 - endOffset) | 0)) < 0)) {
    $m_jl_BoundsChecks$().mH(offset, length, length$1);
  }
  var p = this.b5;
  var newPos = ((p + length) | 0);
  if ((newPos > this.bF)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.b5 = newPos;
  var selfPos = p;
  var endPos = ((selfPos + length) | 0);
  var arrayIndex = offset;
  while ((selfPos !== endPos)) {
    var i = arrayIndex;
    var index = selfPos;
    var v = $dp_charAt__I__C(this.Cu, ((this.Cv + index) | 0));
    dst.a[i] = v;
    selfPos = ((1 + selfPos) | 0);
    arrayIndex = ((1 + arrayIndex) | 0);
  }
  return this;
});
$p.g = (function() {
  var offset = this.Cv;
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.Cu, ((this.b5 + offset) | 0), ((this.bF + offset) | 0)));
});
$p.IW = (function(index) {
  return $dp_charAt__I__C(this.Cu, ((this.Cv + index) | 0));
});
$p.ajY = (function(index, elem) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.ajZ = (function(startIndex, src, offset, length) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$p.EC = (function(start, end) {
  return this.VB(start, end);
});
var $d_Ljava_nio_StringCharBuffer = new $TypeData().i($c_Ljava_nio_StringCharBuffer, "java.nio.StringCharBuffer", ({
  uh: 1,
  cq: 1,
  cp: 1,
  N: 1,
  aO: 1,
  bb: 1,
  gq: 1
}));
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.a9z = null;
    this.a9z = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return (("Flags = '" + this.a9z) + "'");
  }
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().i($c_ju_DuplicateFormatFlagsException, "java.util.DuplicateFormatFlagsException", ({
  uC: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.a9B = null;
    this.a9A = 0;
    this.a9B = f;
    this.a9A = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ((("Conversion = " + $cToS(this.a9A)) + ", Flags = ") + this.a9B);
  }
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().i($c_ju_FormatFlagsConversionMismatchException, "java.util.FormatFlagsConversionMismatchException", ({
  uD: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.a9F = null;
    this.a9F = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return this.a9F;
  }
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().i($c_ju_IllegalFormatArgumentIndexException, "java.util.IllegalFormatArgumentIndexException", ({
  uM: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.a9G = 0;
    this.a9G = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    var i = this.a9G;
    return ("Code point = 0x" + (i >>> 0.0).toString(16));
  }
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().i($c_ju_IllegalFormatCodePointException, "java.util.IllegalFormatCodePointException", ({
  uN: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.a9I = 0;
    this.a9H = null;
    this.a9I = c;
    this.a9H = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ((("" + $cToS(this.a9I)) + " != ") + this.a9H.ax.N);
  }
}
var $d_ju_IllegalFormatConversionException = new $TypeData().i($c_ju_IllegalFormatConversionException, "java.util.IllegalFormatConversionException", ({
  uO: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.a9J = null;
    this.a9J = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return (("Flags = '" + this.a9J) + "'");
  }
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().i($c_ju_IllegalFormatFlagsException, "java.util.IllegalFormatFlagsException", ({
  uP: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.a9K = 0;
    this.a9K = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ("" + this.a9K);
  }
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().i($c_ju_IllegalFormatPrecisionException, "java.util.IllegalFormatPrecisionException", ({
  uQ: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.a9L = 0;
    this.a9L = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return ("" + this.a9L);
  }
}
var $d_ju_IllegalFormatWidthException = new $TypeData().i($c_ju_IllegalFormatWidthException, "java.util.IllegalFormatWidthException", ({
  uR: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.R5;
  if ((older !== null)) {
    older.y4 = node;
  } else {
    $thiz.R4 = node;
  }
  node.KU = older;
  node.y4 = null;
  $thiz.R5 = node;
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = node.KU;
  var younger = node.y4;
  if ((older === null)) {
    $thiz.R4 = younger;
  } else {
    older.y4 = younger;
  }
  if ((younger === null)) {
    $thiz.R5 = older;
  } else {
    younger.KU = older;
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.a9M = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz;
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.KR = 0.0;
  this.i8 = null;
  this.KS = 0;
  this.nX = 0;
  this.a9M = false;
  this.R4 = null;
  this.R5 = null;
}
$p = $c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$p.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
}
$h_ju_LinkedHashMap.prototype = $p;
$p.aj2 = (function(node) {
  if (this.a9M) {
    if ((node.y4 !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
    }
  }
});
$p.awx = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
$p.awy = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
var $d_ju_LinkedHashMap = new $TypeData().i($c_ju_LinkedHashMap, "java.util.LinkedHashMap", ({
  uT: 1,
  uK: 1,
  uw: 1,
  cs: 1,
  a: 1,
  P: 1,
  v0: 1
}));
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.a9N = null;
    this.a9N = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return (("Format specifier '" + this.a9N) + "'");
  }
}
var $d_ju_MissingFormatArgumentException = new $TypeData().i($c_ju_MissingFormatArgumentException, "java.util.MissingFormatArgumentException", ({
  uX: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.a9O = null;
    this.a9O = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return this.a9O;
  }
}
var $d_ju_MissingFormatWidthException = new $TypeData().i($c_ju_MissingFormatWidthException, "java.util.MissingFormatWidthException", ({
  uY: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.a9P = null;
    this.a9P = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return (("Conversion = '" + this.a9P) + "'");
  }
}
var $d_ju_UnknownFormatConversionException = new $TypeData().i($c_ju_UnknownFormatConversionException, "java.util.UnknownFormatConversionException", ({
  v3: 1,
  aB: 1,
  ap: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1
}));
/** @constructor */
function $c_sc_Iterable$$anon$1(a$2) {
  this.GC = null;
  this.GC = a$2;
}
$p = $c_sc_Iterable$$anon$1.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_Iterable$$anon$1;
/** @constructor */
function $h_sc_Iterable$$anon$1() {
}
$h_sc_Iterable$$anon$1.prototype = $p;
$p.l = (function() {
  return new $c_sc_Iterator$$anon$20(this.GC);
});
$p.G = (function() {
  return 1;
});
$p.auI = (function() {
  return new $c_s_Some(this.GC);
});
$p.cJ = (function() {
  return this.GC;
});
$p.avX = (function() {
  return new $c_s_Some(this.GC);
});
$p.atj = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().ce() : this);
});
$p.atp = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().ce() : this);
});
$p.bj = (function() {
  return this.auI();
});
$p.oS = (function() {
  return this.avX();
});
$p.bo = (function(n) {
  return this.atj(n);
});
$p.b8 = (function(n) {
  return this.atp(n);
});
var $d_sc_Iterable$$anon$1 = new $TypeData().i($c_sc_Iterable$$anon$1, "scala.collection.Iterable$$anon$1", ({
  wu: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1
}));
function $f_sc_SortedSetOps__min__s_math_Ordering__O($thiz, ord) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
  } else {
    var x$2 = $thiz.oX();
    if (((ord === null) ? (x$2 === null) : ord.b(x$2))) {
      return $thiz.l().e();
    } else {
      return (ord.f9($thiz.oX()) ? $f_sc_IterableOps__last__O($thiz) : $thiz.Vk(ord));
    }
  }
}
function $f_sc_SortedSetOps__max__s_math_Ordering__O($thiz, ord) {
  if ($thiz.c()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
  } else {
    var x$2 = $thiz.oX();
    if (((ord === null) ? (x$2 === null) : ord.b(x$2))) {
      return $f_sc_IterableOps__last__O($thiz);
    } else {
      return (ord.f9($thiz.oX()) ? $thiz.l().e() : $thiz.Vj(ord));
    }
  }
}
function $f_sc_View__toString__T($thiz) {
  return ($thiz.eH() + "(<not computed>)");
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.E)));
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.E)));
}
function $is_sci_MapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aR)));
}
function $isArrayOf_sci_MapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aR)));
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.qg = 0;
  this.of = 0;
  this.ab3 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab3 = outer;
  $ct_sci_Set$SetNIterator__I__(this, 2);
}
$p = $c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
}
$h_sci_Set$Set2$$anon$1.prototype = $p;
$p.at = (function(i) {
  return this.ab3.axD(i);
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().i($c_sci_Set$Set2$$anon$1, "scala.collection.immutable.Set$Set2$$anon$1", ({
  yq: 1,
  cP: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.qg = 0;
  this.of = 0;
  this.ab4 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab4 = outer;
  $ct_sci_Set$SetNIterator__I__(this, 3);
}
$p = $c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
}
$h_sci_Set$Set3$$anon$2.prototype = $p;
$p.at = (function(i) {
  return this.ab4.axE(i);
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().i($c_sci_Set$Set3$$anon$2, "scala.collection.immutable.Set$Set3$$anon$2", ({
  yr: 1,
  cP: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.qg = 0;
  this.of = 0;
  this.ab5 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.ab5 = outer;
  $ct_sci_Set$SetNIterator__I__(this, 4);
}
$p = $c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$p.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
}
$h_sci_Set$Set4$$anon$3.prototype = $p;
$p.at = (function(i) {
  return this.ab5.axF(i);
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().i($c_sci_Set$Set4$$anon$3, "scala.collection.immutable.Set$Set4$$anon$3", ({
  ys: 1,
  cP: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.S0 = 0;
  this.ab9 = 0;
  this.D3 = null;
  this.aba = false;
  this.S1 = null;
  this.D3 = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.aba = (elementClass === $d_C.l());
  this.S1 = [];
}
$p = $c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$p.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
}
$h_scm_ArrayBuilder$generic.prototype = $p;
$p.afy = (function(elem) {
  var unboxedElem = (this.aba ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(this.D3) : elem));
  this.S1.push(unboxedElem);
  return this;
});
$p.alT = (function(xs) {
  var it = xs.l();
  while (it.f()) {
    this.afy(it.e());
  }
  return this;
});
$p.axi = (function(size) {
});
$p.aR = (function() {
  return $m_scm_ArrayBuilder$().v(((this.D3 === $d_V.l()) ? $d_jl_Void.l() : (((this.D3 === $d_sr_Null$.l()) || (this.D3 === $d_sr_Nothing$.l())) ? $d_O.l() : this.D3)), this.S1);
});
$p.g = (function() {
  return "ArrayBuilder.generic";
});
$p.aD = (function(elem) {
  return this.afy(elem);
});
$p.cz = (function(elems) {
  return this.alT(elems);
});
var $d_scm_ArrayBuilder$generic = new $TypeData().i($c_scm_ArrayBuilder$generic, "scala.collection.mutable.ArrayBuilder$generic", ({
  yN: 1,
  yL: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1,
  a: 1
}));
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().b1(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $m_scg_CommonErrors$().kM(destStart, ((until - 1) | 0));
  }
  var idx = $thiz.dq;
  var a = ((((($thiz.dD - idx) | 0) & (($thiz.bK.a.length - 1) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().b1(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.dq;
    var until$1 = ((($thiz.dD - idx$1) | 0) & (($thiz.bK.a.length - 1) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $m_scg_CommonErrors$().kM(srcStart, ((until$1 - 1) | 0));
    }
    var startIdx = ((($thiz.dq + srcStart) | 0) & (($thiz.bK.a.length - 1) | 0));
    var b$2 = (($thiz.bK.a.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().dd($thiz.bK, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().dd($thiz.bK, 0, dest, ((destStart + block1) | 0), block2);
    }
  }
  return dest;
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.Rt = null;
  this.q6 = 0;
  this.eY = 0;
  this.abd = null;
  this.abc = 0;
  this.abd = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  this.abc = (mutationCount.aA() | 0);
}
$p = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$p.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $p;
$p.f = (function() {
  $m_scm_MutationTracker$().TK(this.abc, (this.abd.aA() | 0), "mutation occurred during iteration");
  return (this.eY > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().i($c_scm_CheckedIndexedSeqView$CheckedIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", ({
  yV: 1,
  gV: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.Ru = null;
  this.fx = 0;
  this.yc = 0;
  this.abf = null;
  this.abe = 0;
  this.abf = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  this.abe = (mutationCount.aA() | 0);
}
$p = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$p.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $p;
$p.f = (function() {
  $m_scm_MutationTracker$().TK(this.abe, (this.abf.aA() | 0), "mutation occurred during iteration");
  return (this.fx > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().i($c_scm_CheckedIndexedSeqView$CheckedReverseIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", ({
  yW: 1,
  gW: 1,
  A: 1,
  h: 1,
  i: 1,
  z: 1,
  a: 1
}));
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ("Future.collect partial function is not defined at: " + t$2), null, true, true);
  }
  zF() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().i($c_s_concurrent_Future$$anon$1, "scala.concurrent.Future$$anon$1", ({
  zD: 1,
  bS: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1,
  bE: 1
}));
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true);
  }
  zF() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().i($c_s_concurrent_Future$$anon$2, "scala.concurrent.Future$$anon$2", ({
  zE: 1,
  bS: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1,
  bE: 1
}));
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true);
  }
  zF() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().i($c_s_concurrent_Future$$anon$3, "scala.concurrent.Future$$anon$3", ({
  zF: 1,
  bS: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1,
  bE: 1
}));
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().J9(result));
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().Hh);
  return $thiz;
}
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var \u03b4this$tailLocal2 = $thiz;
  while (true) {
    var state = \u03b4this$tailLocal2.ci;
    if ((state instanceof $c_s_util_Try)) {
      return state;
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      \u03b4this$tailLocal2 = state.Ev(\u03b4this$tailLocal2);
    } else {
      return null;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var \u03b4this$tailLocal4 = $thiz;
  var state$tailLocal2 = state;
  while (true) {
    if ((state$tailLocal2 instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(\u03b4this$tailLocal4, callbacks, state$tailLocal2);
      return callbacks;
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state$tailLocal2)) {
      if (\u03b4this$tailLocal4.Ir(state$tailLocal2, ((state$tailLocal2 !== $m_s_concurrent_impl_Promise$().Hh) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(\u03b4this$tailLocal4, callbacks, state$tailLocal2) : callbacks))) {
        return callbacks;
      } else {
        state$tailLocal2 = \u03b4this$tailLocal4.ci;
      }
    } else {
      var p = state$tailLocal2.Ev(\u03b4this$tailLocal4);
      var state$tailLocal2$tmp1 = p.ci;
      \u03b4this$tailLocal4 = p;
      state$tailLocal2 = state$tailLocal2$tmp1;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  var right$tailLocal1 = right;
  var left$tailLocal1 = left;
  while (true) {
    if ((left$tailLocal1 instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks(left$tailLocal1, right$tailLocal1);
    } else {
      var m = left$tailLocal1;
      var left$tailLocal1$tmp1 = m.Sm;
      var right$tailLocal1$tmp1 = new $c_s_concurrent_impl_Promise$ManyCallbacks(m.Sl, right$tailLocal1);
      left$tailLocal1 = left$tailLocal1$tmp1;
      right$tailLocal1 = right$tailLocal1$tmp1;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  var callbacks$tailLocal1 = callbacks;
  while (true) {
    if ((callbacks$tailLocal1 instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
      var m = callbacks$tailLocal1;
      m.Sl.ak4(resolved);
      callbacks$tailLocal1 = m.Sm;
    } else {
      callbacks$tailLocal1.ak4(resolved);
      return (void 0);
    }
  }
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ci = null;
}
$p = $c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$p.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $p;
$p.hK = (function(x$0) {
});
$p.aEs = (function(that, f, executor) {
  var state = this.ci;
  if ((state instanceof $c_s_util_Try)) {
    if (state.ahO()) {
      return this;
    } else {
      var l = state.hC;
      return that.aK(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((r$2) => f.cm(l, r$2))), executor);
    }
  } else {
    var buffer = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    var zipped = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var thisF = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
      if ((x$1$3 instanceof $c_s_util_Success)) {
        var right = buffer.aho(x$1$3);
        if ((right !== null)) {
          try {
            var $x_1 = new $c_s_util_Success(f.cm(x$1$3.hC, right.hC));
          } catch (e) {
            var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
            matchResult1: {
              var $x_1;
              if ($m_s_util_control_NonFatal$().DO(e$2)) {
                var $x_1 = new $c_s_util_Failure(e$2);
                break matchResult1;
              }
              throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
            }
          }
          zipped.Je($x_1);
        }
      } else {
        zipped.Je(x$1$3);
      }
    }));
    var thatF = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3$1) => {
      if ((x$1$3$1 instanceof $c_s_util_Success)) {
        var left = buffer.aho(x$1$3$1);
        if ((left !== null)) {
          try {
            var $x_2 = new $c_s_util_Success(f.cm(left.hC, x$1$3$1.hC));
          } catch (e$1) {
            var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
            matchResult3: {
              var $x_2;
              if ($m_s_util_control_NonFatal$().DO(e$2$1)) {
                var $x_2 = new $c_s_util_Failure(e$2$1);
                break matchResult3;
              }
              throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
            }
          }
          zipped.Je($x_2);
        }
      } else {
        zipped.Je(x$1$3$1);
      }
    }));
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, thisF, executor));
    that.aj4(thatF, executor);
    return zipped;
  }
});
$p.zG = (function(f, executor) {
  var state = this.ci;
  if ((!(state instanceof $c_s_util_Failure))) {
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 5, f, executor));
  }
});
$p.aF = (function(f, executor) {
  var state = this.ci;
  return ((!(state instanceof $c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 2, f, executor)) : this);
});
$p.aK = (function(f, executor) {
  var state = this.ci;
  return ((!(state instanceof $c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 1, f, executor)) : this);
});
$p.agV = (function(p, executor) {
  var state = this.ci;
  return ((!(state instanceof $c_s_util_Failure)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 9, p, executor)) : this);
});
$p.hj = (function(pf, executor) {
  var state = this.ci;
  return ((!(state instanceof $c_s_util_Success)) ? $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 7, pf, executor)) : this);
});
$p.aj4 = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ci, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor));
});
$p.g = (function() {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    var state = \u03b4this$tailLocal1.ci;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")");
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      \u03b4this$tailLocal1 = state.Ev(\u03b4this$tailLocal1);
    } else {
      return "Future(<not completed>)";
    }
  }
});
$p.Je = (function(value) {
  var state = this.ci;
  return ((!(state instanceof $c_s_util_Try)) && this.A9(state, $m_s_concurrent_impl_Promise$().J9(value)));
});
$p.A9 = (function(state, resolved) {
  var \u03b4this$tailLocal3 = this;
  var state$tailLocal1 = state;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state$tailLocal1)) {
      if ((!\u03b4this$tailLocal3.Ir(state$tailLocal1, resolved))) {
        state$tailLocal1 = \u03b4this$tailLocal3.ci;
        continue;
      }
      if ((state$tailLocal1 !== $m_s_concurrent_impl_Promise$().Hh)) {
        $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(\u03b4this$tailLocal3, state$tailLocal1, resolved);
      }
      return true;
    } else if ((state$tailLocal1 instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = state$tailLocal1.Ev(\u03b4this$tailLocal3);
      if ((p !== \u03b4this$tailLocal3)) {
        var state$tailLocal1$tmp1 = p.ci;
        \u03b4this$tailLocal3 = p;
        state$tailLocal1 = state$tailLocal1$tmp1;
        continue;
      }
      return false;
    } else {
      return false;
    }
  }
});
$p.U0 = (function(other) {
  if ((other !== this)) {
    var state = this.ci;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other);
      } else {
        var this$1 = $m_s_Option$().Z($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other));
        var resolved = (this$1.c() ? null : this$1.h());
      }
      if ((resolved !== null)) {
        this.A9(state, resolved);
      } else {
        other.aj4(this, $m_s_concurrent_ExecutionContext$parasitic$());
      }
    }
  }
  return this;
});
$p.UX = (function(target, link) {
  var \u03b4this$tailLocal5 = this;
  var link$tailLocal1 = link;
  var target$tailLocal2 = target;
  while (true) {
    if ((\u03b4this$tailLocal5 !== target$tailLocal2)) {
      var state = \u03b4this$tailLocal5.ci;
      if ((state instanceof $c_s_util_Try)) {
        if ((!target$tailLocal2.A9(target$tailLocal2.ci, state))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together");
        } else {
          return (void 0);
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link$tailLocal1 !== null) ? link$tailLocal1 : new $c_s_concurrent_impl_Promise$Link(target$tailLocal2));
        var p = l.Ev(\u03b4this$tailLocal5);
        if (((\u03b4this$tailLocal5 !== p) && \u03b4this$tailLocal5.Ir(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().Hh)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(p, p.ci, state);
            return (void 0);
          } else {
            return (void 0);
          }
        } else {
          target$tailLocal2 = p;
          link$tailLocal1 = l;
        }
      } else {
        \u03b4this$tailLocal5 = state.Ev(\u03b4this$tailLocal5);
      }
    } else {
      return (void 0);
    }
  }
});
$p.ayO = (function(resolved) {
  var \u03b4this$tailLocal6 = this;
  while (true) {
    var state = \u03b4this$tailLocal6.ci;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = (\u03b4this$tailLocal6.Ir(state, resolved) ? state.ci : \u03b4this$tailLocal6);
      \u03b4this$tailLocal6 = next;
    } else {
      \u03b4this$tailLocal6.A9(state, resolved);
      return (void 0);
    }
  }
});
$p.p = (function(v1) {
  this.A9(this.ci, v1);
});
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d0)));
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().i($c_s_concurrent_impl_Promise$DefaultPromise, "scala.concurrent.impl.Promise$DefaultPromise", ({
  d0: 1,
  bT: 1,
  a: 1,
  i4: 1,
  i1: 1,
  i3: 1,
  p: 1
}));
/** @constructor */
function $c_s_math_Ordering$BigDecimal$() {
}
$p = $c_s_math_Ordering$BigDecimal$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$BigDecimal$;
/** @constructor */
function $h_s_math_Ordering$BigDecimal$() {
}
$h_s_math_Ordering$BigDecimal$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return x.c4.It(y.c4);
});
var $d_s_math_Ordering$BigDecimal$ = new $TypeData().i($c_s_math_Ordering$BigDecimal$, "scala.math.Ordering$BigDecimal$", ({
  A2: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  A3: 1
}));
var $n_s_math_Ordering$BigDecimal$;
function $m_s_math_Ordering$BigDecimal$() {
  if ((!$n_s_math_Ordering$BigDecimal$)) {
    $n_s_math_Ordering$BigDecimal$ = new $c_s_math_Ordering$BigDecimal$();
  }
  return $n_s_math_Ordering$BigDecimal$;
}
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
}
$p = $c_s_math_Ordering$Boolean$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
}
$h_s_math_Ordering$Boolean$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  var x$1 = (!(!x));
  return ((x$1 === (!(!y))) ? 0 : (x$1 ? 1 : (-1)));
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().i($c_s_math_Ordering$Boolean$, "scala.math.Ordering$Boolean$", ({
  A4: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  A5: 1
}));
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$();
  }
  return $n_s_math_Ordering$Boolean$;
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
}
$p = $c_s_math_Ordering$Byte$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
}
$h_s_math_Ordering$Byte$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return (((x | 0) - (y | 0)) | 0);
});
var $d_s_math_Ordering$Byte$ = new $TypeData().i($c_s_math_Ordering$Byte$, "scala.math.Ordering$Byte$", ({
  A6: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  A7: 1
}));
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$();
  }
  return $n_s_math_Ordering$Byte$;
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
}
$p = $c_s_math_Ordering$Char$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
}
$h_s_math_Ordering$Char$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return (($uC(x) - $uC(y)) | 0);
});
var $d_s_math_Ordering$Char$ = new $TypeData().i($c_s_math_Ordering$Char$, "scala.math.Ordering$Char$", ({
  A9: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  Aa: 1
}));
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$();
  }
  return $n_s_math_Ordering$Char$;
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedDoubleOrdering$() {
}
$p = $c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$DeprecatedDoubleOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedDoubleOrdering$() {
}
$h_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $m_jl_Double$().zy((+x), (+y));
});
var $d_s_math_Ordering$DeprecatedDoubleOrdering$ = new $TypeData().i($c_s_math_Ordering$DeprecatedDoubleOrdering$, "scala.math.Ordering$DeprecatedDoubleOrdering$", ({
  Ab: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  ic: 1
}));
var $n_s_math_Ordering$DeprecatedDoubleOrdering$;
function $m_s_math_Ordering$DeprecatedDoubleOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedDoubleOrdering$)) {
    $n_s_math_Ordering$DeprecatedDoubleOrdering$ = new $c_s_math_Ordering$DeprecatedDoubleOrdering$();
  }
  return $n_s_math_Ordering$DeprecatedDoubleOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedFloatOrdering$() {
}
$p = $c_s_math_Ordering$DeprecatedFloatOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$DeprecatedFloatOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedFloatOrdering$() {
}
$h_s_math_Ordering$DeprecatedFloatOrdering$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $m_jl_Double$().zy(Math.fround(x), Math.fround(y));
});
var $d_s_math_Ordering$DeprecatedFloatOrdering$ = new $TypeData().i($c_s_math_Ordering$DeprecatedFloatOrdering$, "scala.math.Ordering$DeprecatedFloatOrdering$", ({
  Ac: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  id: 1
}));
var $n_s_math_Ordering$DeprecatedFloatOrdering$;
function $m_s_math_Ordering$DeprecatedFloatOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedFloatOrdering$)) {
    $n_s_math_Ordering$DeprecatedFloatOrdering$ = new $c_s_math_Ordering$DeprecatedFloatOrdering$();
  }
  return $n_s_math_Ordering$DeprecatedFloatOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$Double$TotalOrdering$() {
}
$p = $c_s_math_Ordering$Double$TotalOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Double$TotalOrdering$;
/** @constructor */
function $h_s_math_Ordering$Double$TotalOrdering$() {
}
$h_s_math_Ordering$Double$TotalOrdering$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $m_jl_Double$().zy((+x), (+y));
});
var $d_s_math_Ordering$Double$TotalOrdering$ = new $TypeData().i($c_s_math_Ordering$Double$TotalOrdering$, "scala.math.Ordering$Double$TotalOrdering$", ({
  Ad: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  ic: 1
}));
var $n_s_math_Ordering$Double$TotalOrdering$;
function $m_s_math_Ordering$Double$TotalOrdering$() {
  if ((!$n_s_math_Ordering$Double$TotalOrdering$)) {
    $n_s_math_Ordering$Double$TotalOrdering$ = new $c_s_math_Ordering$Double$TotalOrdering$();
  }
  return $n_s_math_Ordering$Double$TotalOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$Float$TotalOrdering$() {
}
$p = $c_s_math_Ordering$Float$TotalOrdering$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Float$TotalOrdering$;
/** @constructor */
function $h_s_math_Ordering$Float$TotalOrdering$() {
}
$h_s_math_Ordering$Float$TotalOrdering$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $m_jl_Double$().zy(Math.fround(x), Math.fround(y));
});
var $d_s_math_Ordering$Float$TotalOrdering$ = new $TypeData().i($c_s_math_Ordering$Float$TotalOrdering$, "scala.math.Ordering$Float$TotalOrdering$", ({
  Af: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  id: 1
}));
var $n_s_math_Ordering$Float$TotalOrdering$;
function $m_s_math_Ordering$Float$TotalOrdering$() {
  if ((!$n_s_math_Ordering$Float$TotalOrdering$)) {
    $n_s_math_Ordering$Float$TotalOrdering$ = new $c_s_math_Ordering$Float$TotalOrdering$();
  }
  return $n_s_math_Ordering$Float$TotalOrdering$;
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
}
$p = $c_s_math_Ordering$Long$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
}
$h_s_math_Ordering$Long$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return ((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo === y$1_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y$1_$_hi) ? (-1) : 1));
});
var $d_s_math_Ordering$Long$ = new $TypeData().i($c_s_math_Ordering$Long$, "scala.math.Ordering$Long$", ({
  Ah: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  Ai: 1
}));
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$();
  }
  return $n_s_math_Ordering$Long$;
}
/** @constructor */
function $c_s_math_Ordering$O$1(ord$3) {
  this.Hl = null;
  this.Hl = ord$3;
}
$p = $c_s_math_Ordering$O$1.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$O$1;
/** @constructor */
function $h_s_math_Ordering$O$1() {
}
$h_s_math_Ordering$O$1.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b = (function(obj) {
  return $f_s_math_Ordering$OptionOrdering__equals__O__Z(this, obj);
});
$p.r = (function() {
  return $f_s_math_Ordering$OptionOrdering__hashCode__I(this);
});
$p.bM = (function(x, y) {
  return $f_s_math_Ordering$OptionOrdering__compare__s_Option__s_Option__I(this, x, y);
});
var $d_s_math_Ordering$O$1 = new $TypeData().i($c_s_math_Ordering$O$1, "scala.math.Ordering$O$1", ({
  Aj: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  d1: 1
}));
/** @constructor */
function $c_s_math_Ordering$Short$() {
}
$p = $c_s_math_Ordering$Short$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
}
$h_s_math_Ordering$Short$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return (((x | 0) - (y | 0)) | 0);
});
var $d_s_math_Ordering$Short$ = new $TypeData().i($c_s_math_Ordering$Short$, "scala.math.Ordering$Short$", ({
  Ak: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  Al: 1
}));
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$();
  }
  return $n_s_math_Ordering$Short$;
}
/** @constructor */
function $c_s_math_Ordering$String$() {
}
$p = $c_s_math_Ordering$String$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
$h_s_math_Ordering$String$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $f_T__compareTo__T__I(x, y);
});
var $d_s_math_Ordering$String$ = new $TypeData().i($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  Am: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  An: 1
}));
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.dF = null;
}
$p = $c_s_reflect_AnyValManifest.prototype = new $h_O();
$p.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
}
$h_s_reflect_AnyValManifest.prototype = $p;
$p.g = (function() {
  return this.dF;
});
$p.b = (function(that) {
  return (this === that);
});
$p.r = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$p = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$p.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $p;
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.b6 = null;
    this.b6 = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  dI() {
    return $dp_toString__T(this.b6);
  }
  A() {
    return "JavaScriptException";
  }
  w() {
    return 1;
  }
  z(x$1) {
    return ((x$1 === 0) ? this.b6 : $m_sr_Statics$().avg(x$1));
  }
  C() {
    return new $c_sr_ScalaRunTime$$anon$1(this);
  }
  r() {
    return $m_s_util_hashing_MurmurHash3$().au(this, 1744042595, true);
  }
  b(x$1) {
    return ((this === x$1) || ((x$1 instanceof $c_sjs_js_JavaScriptException) && $m_sr_BoxesRunTime$().B(this.b6, x$1.b6)));
  }
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.il)));
}
var $d_sjs_js_JavaScriptException = new $TypeData().i($c_sjs_js_JavaScriptException, "scala.scalajs.js.JavaScriptException", ({
  il: 1,
  O: 1,
  J: 1,
  F: 1,
  a: 1,
  c: 1,
  b: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$RawFrag(v) {
  this.Hp = null;
  this.Hp = v;
}
$p = $c_Lscalatags_JsDom$RawFrag.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$RawFrag;
/** @constructor */
function $h_Lscalatags_JsDom$RawFrag() {
}
$h_Lscalatags_JsDom$RawFrag.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lscalatags_JsDom$RawFrag) && (this.Hp === x$0.Hp)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "RawFrag";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Hp;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.uB = (function() {
  return document.createRange().createContextualFragment(this.Hp);
});
$p.J6 = (function() {
  return this.uB();
});
$p.oD = (function(t) {
  $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V(this, t);
});
function $isArrayOf_Lscalatags_JsDom$RawFrag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iq)));
}
var $d_Lscalatags_JsDom$RawFrag = new $TypeData().i($c_Lscalatags_JsDom$RawFrag, "scalatags.JsDom$RawFrag", ({
  iq: 1,
  aZ: 1,
  bF: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$StringFrag(v) {
  this.Hq = null;
  this.Hq = v;
}
$p = $c_Lscalatags_JsDom$StringFrag.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$StringFrag;
/** @constructor */
function $h_Lscalatags_JsDom$StringFrag() {
}
$h_Lscalatags_JsDom$StringFrag.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().DS(this, (-889275714), null);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lscalatags_JsDom$StringFrag) && (this.Hq === x$0.Hq)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "StringFrag";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Hq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.ajm = (function() {
  return document.createTextNode(this.Hq);
});
$p.uB = (function() {
  return this.ajm();
});
$p.J6 = (function() {
  return this.ajm();
});
$p.oD = (function(t) {
  $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V(this, t);
});
function $isArrayOf_Lscalatags_JsDom$StringFrag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ir)));
}
var $d_Lscalatags_JsDom$StringFrag = new $TypeData().i($c_Lscalatags_JsDom$StringFrag, "scalatags.JsDom$StringFrag", ({
  ir: 1,
  aZ: 1,
  bF: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lscalatags_JsDom$tags$() {
  this.ad7 = null;
  this.ad8 = false;
}
$p = $c_Lscalatags_JsDom$tags$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$tags$;
/** @constructor */
function $h_Lscalatags_JsDom$tags$() {
}
$h_Lscalatags_JsDom$tags$.prototype = $p;
$p.he = (function() {
  if ((!this.ad8)) {
    this.ad7 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "li", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ad8 = true;
  }
  return this.ad7;
});
var $d_Lscalatags_JsDom$tags$ = new $TypeData().i($c_Lscalatags_JsDom$tags$, "scalatags.JsDom$tags$", ({
  BX: 1,
  d6: 1,
  d7: 1,
  d9: 1,
  d5: 1,
  iy: 1,
  iz: 1
}));
var $n_Lscalatags_JsDom$tags$;
function $m_Lscalatags_JsDom$tags$() {
  if ((!$n_Lscalatags_JsDom$tags$)) {
    $n_Lscalatags_JsDom$tags$ = new $c_Lscalatags_JsDom$tags$();
  }
  return $n_Lscalatags_JsDom$tags$;
}
/** @constructor */
function $c_Lscalatags_JsDom$tags2$() {
  this.adb = null;
  this.adc = false;
  this.ad9 = null;
  this.ada = false;
}
$p = $c_Lscalatags_JsDom$tags2$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$tags2$;
/** @constructor */
function $h_Lscalatags_JsDom$tags2$() {
}
$h_Lscalatags_JsDom$tags2$.prototype = $p;
$p.aiW = (function() {
  if ((!this.adc)) {
    this.adb = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "nav", false, $m_Lscalatags_generic_Namespace$().eG);
    this.adc = true;
  }
  return this.adb;
});
$p.awc = (function() {
  if ((!this.ada)) {
    this.ad9 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "mark", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ada = true;
  }
  return this.ad9;
});
var $d_Lscalatags_JsDom$tags2$ = new $TypeData().i($c_Lscalatags_JsDom$tags2$, "scalatags.JsDom$tags2$", ({
  BY: 1,
  d6: 1,
  d7: 1,
  d9: 1,
  d5: 1,
  Co: 1,
  Cs: 1
}));
var $n_Lscalatags_JsDom$tags2$;
function $m_Lscalatags_JsDom$tags2$() {
  if ((!$n_Lscalatags_JsDom$tags2$)) {
    $n_Lscalatags_JsDom$tags2$ = new $c_Lscalatags_JsDom$tags2$();
  }
  return $n_Lscalatags_JsDom$tags2$;
}
class $c_Lujson_IncompleteParseException extends $c_jl_Exception {
  constructor(msg) {
    super();
    this.LM = null;
    this.LM = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true);
  }
  C() {
    return new $c_s_Product$$anon$1(this);
  }
  r() {
    return $m_s_util_hashing_MurmurHash3$().au(this, (-973463950), true);
  }
  b(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lujson_IncompleteParseException) && (this.LM === x$0.LM)));
  }
  w() {
    return 1;
  }
  A() {
    return "IncompleteParseException";
  }
  z(n) {
    if ((n === 0)) {
      return this.LM;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lujson_IncompleteParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iA)));
}
var $d_Lujson_IncompleteParseException = new $TypeData().i($c_Lujson_IncompleteParseException, "ujson.IncompleteParseException", ({
  iA: 1,
  J: 1,
  F: 1,
  a: 1,
  iC: 1,
  b: 1,
  c: 1
}));
class $c_Lujson_ParseException extends $c_jl_Exception {
  constructor(clue, index) {
    super();
    this.HC = null;
    this.HD = 0;
    this.HC = clue;
    this.HD = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, ((clue + " at index ") + index), null, true, true);
  }
  C() {
    return new $c_s_Product$$anon$1(this);
  }
  r() {
    var acc = (-889275714);
    acc = $m_sr_Statics$().d(acc, 1971845884);
    acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.HC));
    acc = $m_sr_Statics$().d(acc, this.HD);
    return $m_sr_Statics$().an(acc, 2);
  }
  b(x$0) {
    return ((this === x$0) || ((x$0 instanceof $c_Lujson_ParseException) && ((this.HD === x$0.HD) && (this.HC === x$0.HC))));
  }
  w() {
    return 2;
  }
  A() {
    return "ParseException";
  }
  z(n) {
    if ((n === 0)) {
      return this.HC;
    }
    if ((n === 1)) {
      return this.HD;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $isArrayOf_Lujson_ParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iB)));
}
var $d_Lujson_ParseException = new $TypeData().i($c_Lujson_ParseException, "ujson.ParseException", ({
  iB: 1,
  J: 1,
  F: 1,
  a: 1,
  iC: 1,
  b: 1,
  c: 1
}));
/** @constructor */
function $c_Lujson_StringRenderer(indent, escapeUnicode) {
  this.hD = null;
  this.Hx = 0;
  this.Sz = false;
  this.c0 = null;
  this.SA = null;
  this.kz = 0;
  this.Hz = false;
  this.ok = false;
  this.kA = false;
  this.Hy = false;
  this.HH = 0;
  this.HG = false;
  this.HH = indent;
  this.HG = escapeUnicode;
  $ct_Lujson_BaseCharRenderer__Ljava_io_Writer__I__Z__(this, new $c_Ljava_io_StringWriter(), indent, escapeUnicode);
}
$p = $c_Lujson_StringRenderer.prototype = new $h_Lujson_BaseCharRenderer();
$p.constructor = $c_Lujson_StringRenderer;
/** @constructor */
function $h_Lujson_StringRenderer() {
}
$h_Lujson_StringRenderer.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1386426388);
  acc = $m_sr_Statics$().d(acc, this.HH);
  acc = $m_sr_Statics$().d(acc, (this.HG ? 1231 : 1237));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lujson_StringRenderer) && ((this.HH === x$0.HH) && (this.HG === x$0.HG))));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "StringRenderer";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HH;
  }
  if ((n === 1)) {
    return this.HG;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lujson_StringRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iE)));
}
var $d_Lujson_StringRenderer = new $TypeData().i($c_Lujson_StringRenderer, "ujson.StringRenderer", ({
  iE: 1,
  Ct: 1,
  d: 1,
  Cz: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Arr(value) {
  this.HI = null;
  this.HI = value;
}
$p = $c_Lupack_Arr.prototype = new $h_O();
$p.constructor = $c_Lupack_Arr;
/** @constructor */
function $h_Lupack_Arr() {
}
$h_Lupack_Arr.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-572458024), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Arr)) {
    var x = this.HI;
    var x$2 = x$0.HI;
    return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Arr";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HI;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Arr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iF)));
}
var $d_Lupack_Arr = new $TypeData().i($c_Lupack_Arr, "upack.Arr", ({
  iF: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Binary(value) {
  this.HJ = null;
  this.HJ = value;
}
$p = $c_Lupack_Binary.prototype = new $h_O();
$p.constructor = $c_Lupack_Binary;
/** @constructor */
function $h_Lupack_Binary() {
}
$h_Lupack_Binary.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 358877642, true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Binary)) {
    var x = this.HJ;
    var x$2 = x$0.HJ;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Binary";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HJ;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Binary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iG)));
}
var $d_Lupack_Binary = new $TypeData().i($c_Lupack_Binary, "upack.Binary", ({
  iG: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Ext(tag, data) {
  this.Dh = 0;
  this.Dg = null;
  this.Dh = tag;
  this.Dg = data;
}
$p = $c_Lupack_Ext.prototype = new $h_O();
$p.constructor = $c_Lupack_Ext;
/** @constructor */
function $h_Lupack_Ext() {
}
$h_Lupack_Ext.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70145);
  acc = $m_sr_Statics$().d(acc, this.Dh);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Dg));
  return $m_sr_Statics$().an(acc, 2);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Ext)) {
    if ((this.Dh === x$0.Dh)) {
      var x = this.Dg;
      var x$2 = x$0.Dg;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "Ext";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Dh;
  }
  if ((n === 1)) {
    return this.Dg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Ext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iI)));
}
var $d_Lupack_Ext = new $TypeData().i($c_Lupack_Ext, "upack.Ext", ({
  iI: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Float32(value) {
  this.Di = 0.0;
  this.Di = value;
}
$p = $c_Lupack_Float32.prototype = new $h_O();
$p.constructor = $c_Lupack_Float32;
/** @constructor */
function $h_Lupack_Float32() {
}
$h_Lupack_Float32.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 898210203);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Di));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Float32) && (this.Di === x$0.Di)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Float32";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Di;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Float32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iJ)));
}
var $d_Lupack_Float32 = new $TypeData().i($c_Lupack_Float32, "upack.Float32", ({
  iJ: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Float64(value) {
  this.Dj = 0.0;
  this.Dj = value;
}
$p = $c_Lupack_Float64.prototype = new $h_O();
$p.constructor = $c_Lupack_Float64;
/** @constructor */
function $h_Lupack_Float64() {
}
$h_Lupack_Float64.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 898210298);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.Dj));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Float64) && (this.Dj === x$0.Dj)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Float64";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Dj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Float64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iK)));
}
var $d_Lupack_Float64 = new $TypeData().i($c_Lupack_Float64, "upack.Float64", ({
  iK: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Int32(value) {
  this.Dk = 0;
  this.Dk = value;
}
$p = $c_Lupack_Int32.prototype = new $h_O();
$p.constructor = $c_Lupack_Int32;
/** @constructor */
function $h_Lupack_Int32() {
}
$h_Lupack_Int32.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70807150);
  acc = $m_sr_Statics$().d(acc, this.Dk);
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Int32) && (this.Dk === x$0.Dk)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Int32";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.Dk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Int32(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iL)));
}
var $d_Lupack_Int32 = new $TypeData().i($c_Lupack_Int32, "upack.Int32", ({
  iL: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Int64(value_$_lo, value_$_hi) {
  this.DF = 0;
  this.DG = 0;
  this.DF = value_$_lo;
  this.DG = value_$_hi;
}
$p = $c_Lupack_Int64.prototype = new $h_O();
$p.constructor = $c_Lupack_Int64;
/** @constructor */
function $h_Lupack_Int64() {
}
$h_Lupack_Int64.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 70807245);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.DF, this.DG));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Int64)) {
    var x_$_lo = this.DF;
    var x_$_hi = this.DG;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.DF;
    var x$1_$_hi = $x_1.DG;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Int64";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.DF, this.DG);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Int64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iM)));
}
var $d_Lupack_Int64 = new $TypeData().i($c_Lupack_Int64, "upack.Int64", ({
  iM: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Obj(value) {
  this.HK = null;
  this.HK = value;
}
$p = $c_Lupack_Obj.prototype = new $h_O();
$p.constructor = $c_Lupack_Obj;
/** @constructor */
function $h_Lupack_Obj() {
}
$h_Lupack_Obj.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-1484184333), true);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_Obj)) {
    var x = this.HK;
    var x$2 = x$0.HK;
    return ((x === null) ? (x$2 === null) : $f_sc_Map__equals__O__Z(x, x$2));
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Obj";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HK;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Obj(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iN)));
}
var $d_Lupack_Obj = new $TypeData().i($c_Lupack_Obj, "upack.Obj", ({
  iN: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_Str(value) {
  this.HL = null;
  this.HL = value;
}
$p = $c_Lupack_Str.prototype = new $h_O();
$p.constructor = $c_Lupack_Str;
/** @constructor */
function $h_Lupack_Str() {
}
$h_Lupack_Str.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, 540823359, true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lupack_Str) && (this.HL === x$0.HL)));
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "Str";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.HL;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_Str(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iO)));
}
var $d_Lupack_Str = new $TypeData().i($c_Lupack_Str, "upack.Str", ({
  iO: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupack_UInt64(value_$_lo, value_$_hi) {
  this.DH = 0;
  this.DI = 0;
  this.DH = value_$_lo;
  this.DI = value_$_hi;
}
$p = $c_Lupack_UInt64.prototype = new $h_O();
$p.constructor = $c_Lupack_UInt64;
/** @constructor */
function $h_Lupack_UInt64() {
}
$h_Lupack_UInt64.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1790682216));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().bG(this.DH, this.DI));
  return $m_sr_Statics$().an(acc, 1);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lupack_UInt64)) {
    var x_$_lo = this.DH;
    var x_$_hi = this.DI;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.DH;
    var x$1_$_hi = $x_1.DI;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "UInt64";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return $bL(this.DH, this.DI);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lupack_UInt64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iP)));
}
var $d_Lupack_UInt64 = new $TypeData().i($c_Lupack_UInt64, "upack.UInt64", ({
  iP: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_Types$$anon$3(r0$1, w0$2, outer) {
  this.eO = null;
  this.SQ = null;
  this.SP = null;
  this.SQ = w0$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.SP = outer;
  $ct_Lupickle_core_Visitor$Delegate__Lupickle_core_Visitor__(this, r0$1);
}
$p = $c_Lupickle_core_Types$$anon$3.prototype = new $h_Lupickle_core_Visitor$Delegate();
$p.constructor = $c_Lupickle_core_Types$$anon$3;
/** @constructor */
function $h_Lupickle_core_Types$$anon$3() {
}
$h_Lupickle_core_Types$$anon$3.prototype = $p;
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.dv = (function() {
  return this;
});
$p.Q = (function() {
  return this.SQ.Q();
});
$p.U = (function(out, v) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this.SQ, out, v);
});
$p.mO = (function() {
  return this.SP.oo;
});
$p.qR = (function() {
  return this.SP.oo;
});
$p.dL = (function() {
  return this.mO();
});
$p.T = (function() {
  return this.qR();
});
$p.S = (function() {
  return this;
});
var $d_Lupickle_core_Types$$anon$3 = new $TypeData().i($c_Lupickle_core_Types$$anon$3, "upickle.core.Types$$anon$3", ({
  Dv: 1,
  bI: 1,
  d: 1,
  e: 1,
  j: 1,
  k: 1,
  jc: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_execution_HideModal$() {
}
$p = $c_Lcom_papasofokli_execution_HideModal$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_HideModal$;
/** @constructor */
function $h_Lcom_papasofokli_execution_HideModal$() {
}
$h_Lcom_papasofokli_execution_HideModal$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-1454094741);
});
$p.g = (function() {
  return "HideModal";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "HideModal";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_execution_HideModal$ = new $TypeData().i($c_Lcom_papasofokli_execution_HideModal$, "com.papasofokli.execution.HideModal$", ({
  mq: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_execution_HideModal$;
function $m_Lcom_papasofokli_execution_HideModal$() {
  if ((!$n_Lcom_papasofokli_execution_HideModal$)) {
    $n_Lcom_papasofokli_execution_HideModal$ = new $c_Lcom_papasofokli_execution_HideModal$();
  }
  return $n_Lcom_papasofokli_execution_HideModal$;
}
/** @constructor */
function $c_Lcom_papasofokli_execution_InvalidPrintServerUUID$() {
}
$p = $c_Lcom_papasofokli_execution_InvalidPrintServerUUID$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_InvalidPrintServerUUID$;
/** @constructor */
function $h_Lcom_papasofokli_execution_InvalidPrintServerUUID$() {
}
$h_Lcom_papasofokli_execution_InvalidPrintServerUUID$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-449117900);
});
$p.g = (function() {
  return "InvalidPrintServerUUID";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "InvalidPrintServerUUID";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_execution_InvalidPrintServerUUID$ = new $TypeData().i($c_Lcom_papasofokli_execution_InvalidPrintServerUUID$, "com.papasofokli.execution.InvalidPrintServerUUID$", ({
  mr: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_execution_InvalidPrintServerUUID$;
function $m_Lcom_papasofokli_execution_InvalidPrintServerUUID$() {
  if ((!$n_Lcom_papasofokli_execution_InvalidPrintServerUUID$)) {
    $n_Lcom_papasofokli_execution_InvalidPrintServerUUID$ = new $c_Lcom_papasofokli_execution_InvalidPrintServerUUID$();
  }
  return $n_Lcom_papasofokli_execution_InvalidPrintServerUUID$;
}
/** @constructor */
function $c_Lcom_papasofokli_execution_ShowModal$() {
}
$p = $c_Lcom_papasofokli_execution_ShowModal$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_execution_ShowModal$;
/** @constructor */
function $h_Lcom_papasofokli_execution_ShowModal$() {
}
$h_Lcom_papasofokli_execution_ShowModal$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 83862928;
});
$p.g = (function() {
  return "ShowModal";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "ShowModal";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_execution_ShowModal$ = new $TypeData().i($c_Lcom_papasofokli_execution_ShowModal$, "com.papasofokli.execution.ShowModal$", ({
  oU: 1,
  x: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_execution_ShowModal$;
function $m_Lcom_papasofokli_execution_ShowModal$() {
  if ((!$n_Lcom_papasofokli_execution_ShowModal$)) {
    $n_Lcom_papasofokli_execution_ShowModal$ = new $c_Lcom_papasofokli_execution_ShowModal$();
  }
  return $n_Lcom_papasofokli_execution_ShowModal$;
}
function $p_Lcom_papasofokli_svg_api_LineSVG__moveTo__Lorg_scalajs_dom_Element__F__F__F__F__V($thiz, element, newX1, newY1, newX2, newY2) {
  new $c_Lcom_papasofokli_util_AttributeValue("x1", ("" + newX1)).ds(element);
  new $c_Lcom_papasofokli_util_AttributeValue("y1", ("" + newY1)).ds(element);
  new $c_Lcom_papasofokli_util_AttributeValue("x2", ("" + newX2)).ds(element);
  new $c_Lcom_papasofokli_util_AttributeValue("y2", ("" + newY2)).ds(element);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_LineSVG(initialX1, initialY1, initialX2, initialY2, initialClassName, appendWithAnimationTime, dragStartFun, dragStopFun, draggingFun, clickFun, getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag, stroke, lineId) {
  this.a6g = null;
  this.a6h = false;
  this.a6m = null;
  this.a6e = null;
  this.a6f = false;
  this.BC = 0.0;
  this.BE = 0.0;
  this.BD = 0.0;
  this.BF = 0.0;
  this.BB = null;
  this.Bu = null;
  this.Bx = null;
  this.By = null;
  this.Bz = null;
  this.Bv = null;
  this.BA = null;
  this.BI = null;
  this.BJ = null;
  this.Bw = null;
  this.BG = false;
  this.BK = null;
  this.BH = null;
  this.a6k = null;
  this.a6l = false;
  this.a6o = null;
  this.a6i = null;
  this.a6j = false;
  this.a6n = null;
  this.BC = initialX1;
  this.BE = initialY1;
  this.BD = initialX2;
  this.BF = initialY2;
  this.BB = initialClassName;
  this.Bu = appendWithAnimationTime;
  this.Bx = dragStartFun;
  this.By = dragStopFun;
  this.Bz = draggingFun;
  this.Bv = clickFun;
  this.BA = getGroupedDraggedShapes;
  this.BI = onHover;
  this.BJ = onMouseOut;
  this.Bw = contextMenuFunction;
  this.BG = isMovableOnDrag;
  this.BK = stroke;
  this.BH = lineId;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a6o = $m_s_Option$().Z($f_sc_IterableOnceOps__min__s_math_Ordering__O(new $c_sci_$colon$colon(initialX1, new $c_sci_$colon$colon(initialX2, $m_sci_Nil$())), $m_s_math_Ordering$Float$TotalOrdering$()));
  this.a6n = "line";
}
$p = $c_Lcom_papasofokli_svg_api_LineSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_LineSVG;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_LineSVG() {
}
$h_Lcom_papasofokli_svg_api_LineSVG.prototype = $p;
$p.oG = (function() {
  if ((!this.a6h)) {
    this.a6g = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a6h = true;
  }
  return this.a6g;
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a6m;
});
$p.zx = (function(x$0) {
  this.a6m = x$0;
});
$p.DV = (function() {
  if ((!this.a6f)) {
    this.a6e = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a6f = true;
  }
  return this.a6e;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.zU = (function() {
  $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 1841542576);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.BC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.BE));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.BD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.BF));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BB));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bu));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bx));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.By));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bz));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bv));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BA));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BI));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BJ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Bw));
  acc = $m_sr_Statics$().d(acc, (this.BG ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BK));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BH));
  return $m_sr_Statics$().an(acc, 17);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_LineSVG)) {
    if ((((((this.BC === x$0.BC) && (this.BE === x$0.BE)) && (this.BD === x$0.BD)) && (this.BF === x$0.BF)) && (this.BG === x$0.BG))) {
      var x = this.BB;
      var x$2 = x$0.BB;
      var $x_11 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$3 = this.Bu;
      var x$4 = x$0.Bu;
      var $x_10 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$5 = this.Bx;
      var x$6 = x$0.Bx;
      var $x_9 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$7 = this.By;
      var x$8 = x$0.By;
      var $x_8 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$9 = this.Bz;
      var x$10 = x$0.Bz;
      var $x_7 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$11 = this.Bv;
      var x$12 = x$0.Bv;
      var $x_6 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$13 = this.BA;
      var x$14 = x$0.BA;
      var $x_5 = ((x$13 === null) ? (x$14 === null) : (x$13 === x$14));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$15 = this.BI;
      var x$16 = x$0.BI;
      var $x_4 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$17 = this.BJ;
      var x$18 = x$0.BJ;
      var $x_3 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$19 = this.Bw;
      var x$20 = x$0.Bw;
      var $x_2 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$21 = this.BK;
      var x$22 = x$0.BK;
      var $x_1 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$23 = this.BH;
      var x$24 = x$0.BH;
      return ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 17;
});
$p.A = (function() {
  return "LineSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.BC;
      break;
    }
    case 1: {
      return this.BE;
      break;
    }
    case 2: {
      return this.BD;
      break;
    }
    case 3: {
      return this.BF;
      break;
    }
    case 4: {
      return this.BB;
      break;
    }
    case 5: {
      return this.Bu;
      break;
    }
    case 6: {
      return this.Bx;
      break;
    }
    case 7: {
      return this.By;
      break;
    }
    case 8: {
      return this.Bz;
      break;
    }
    case 9: {
      return this.Bv;
      break;
    }
    case 10: {
      return this.BA;
      break;
    }
    case 11: {
      return this.BI;
      break;
    }
    case 12: {
      return this.BJ;
      break;
    }
    case 13: {
      return this.Bw;
      break;
    }
    case 14: {
      return this.BG;
      break;
    }
    case 15: {
      return this.BK;
      break;
    }
    case 16: {
      return this.BH;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oP = (function() {
  return this.BB;
});
$p.oC = (function() {
  return this.Bu;
});
$p.zB = (function() {
  return this.Bx;
});
$p.zC = (function() {
  return this.By;
});
$p.zD = (function() {
  return this.Bz;
});
$p.DU = (function() {
  return this.Bv;
});
$p.Ep = (function() {
  return this.BI;
});
$p.Eq = (function() {
  return this.BJ;
});
$p.DW = (function() {
  return this.Bw;
});
$p.Eh = (function() {
  return this.BG;
});
$p.p0 = (function() {
  return this.BK;
});
$p.g9 = (function() {
  if ((!this.a6l)) {
    this.a6k = this.BH;
    this.a6l = true;
  }
  return this.a6k;
});
$p.p1 = (function() {
  return this.a6o;
});
$p.oN = (function() {
  if ((!this.a6j)) {
    this.a6i = this.BA.aA();
    this.a6j = true;
  }
  return this.a6i;
});
$p.oQ = (function() {
  return $m_sci_Nil$();
});
$p.oF = (function() {
  return $m_s_None$();
});
$p.oE = (function() {
  return new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("x1", ("" + this.BC)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("y1", ("" + this.BE)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("x2", ("" + this.BD)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("y2", ("" + this.BF)), $m_sci_Nil$()))));
});
$p.oZ = (function() {
  return this.a6n;
});
$p.aiT = (function(newX1, newY1, newX2, newY2) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$1.c())) {
    $p_Lcom_papasofokli_svg_api_LineSVG__moveTo__Lorg_scalajs_dom_Element__F__F__F__F__V(this, this$1.h(), newX1, newY1, newX2, newY2);
  }
});
$p.E0 = (function(element, dx, dy) {
  try {
    var $x_1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("x1"))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  var newX1U = $x_1.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$3) => Math.fround((Math.fround(_$2$3) + dx)))));
  try {
    var $x_2 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("y1"))));
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchResult1$1: {
      var $x_2;
      var x2$1 = $m_s_util_control_NonFatal$().dV(e$2$1);
      if ((!x2$1.c())) {
        var $x_2 = new $c_s_util_Failure(x2$1.h());
        break matchResult1$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
    }
  }
  var newY1U = $x_2.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => Math.fround((Math.fround(_$3$3) + dy)))));
  try {
    var $x_3 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("x2"))));
  } catch (e$3) {
    var e$2$2 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
    matchResult1$2: {
      var $x_3;
      var x2$2 = $m_s_util_control_NonFatal$().dV(e$2$2);
      if ((!x2$2.c())) {
        var $x_3 = new $c_s_util_Failure(x2$2.h());
        break matchResult1$2;
      }
      throw ((e$2$2 instanceof $c_sjs_js_JavaScriptException) ? e$2$2.b6 : e$2$2);
    }
  }
  var newX2U = $x_3.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => Math.fround((Math.fround(_$4$3) + dx)))));
  try {
    var $x_4 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("y2"))));
  } catch (e$4) {
    var e$2$3 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
    matchResult1$3: {
      var $x_4;
      var x2$3 = $m_s_util_control_NonFatal$().dV(e$2$3);
      if ((!x2$3.c())) {
        var $x_4 = new $c_s_util_Failure(x2$3.h());
        break matchResult1$3;
      }
      throw ((e$2$3 instanceof $c_sjs_js_JavaScriptException) ? e$2$3.b6 : e$2$3);
    }
  }
  var newY2U = $x_4.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => Math.fround((Math.fround(_$5$3) + dy)))));
  newX1U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var newX1 = Math.fround(v1$2);
    newY1U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2$1) => {
      var newY1 = Math.fround(v1$2$1);
      newX2U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2$2) => {
        var newX2 = Math.fround(v1$2$2);
        newY2U.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2$3) => {
          $p_Lcom_papasofokli_svg_api_LineSVG__moveTo__Lorg_scalajs_dom_Element__F__F__F__F__V(this, element, newX1, newY1, newX2, Math.fround(v1$2$3));
        })));
      })));
    })));
  })));
});
function $isArrayOf_Lcom_papasofokli_svg_api_LineSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fP)));
}
var $d_Lcom_papasofokli_svg_api_LineSVG = new $TypeData().i($c_Lcom_papasofokli_svg_api_LineSVG, "com.papasofokli.svg.api.LineSVG", ({
  fP: 1,
  aH: 1,
  b0: 1,
  cj: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_api_RectangleSVG__moveTo__s_Option__s_Option__Lorg_scalajs_dom_Element__V($thiz, newX, newY, element) {
  if ((!newX.c())) {
    new $c_Lcom_papasofokli_util_AttributeValue("x", Math.fround(newX.h())).ds(element);
  }
  if ((!newY.c())) {
    new $c_Lcom_papasofokli_util_AttributeValue("y", Math.fround(newY.h())).ds(element);
  }
}
function $p_Lcom_papasofokli_svg_api_RectangleSVG__translate__F__F__V($thiz, dx, dy) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option($thiz, "x");
  if ((!this$1.c())) {
    var x0 = this$1.h();
    var lastX = Math.fround(x0);
    var this$2 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option($thiz, "y");
    if ((!this$2.c())) {
      $thiz.cT(Math.fround((lastX + dx)), Math.fround((Math.fround(this$2.h()) + dy)));
    }
  }
}
function $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeWidth__F__V($thiz, dw) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option($thiz, "width");
  if ((!this$1.c())) {
    $thiz.Ez(Math.fround((Math.fround(this$1.h()) + dw)));
  }
}
function $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeHeight__F__V($thiz, dh) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getNumeric__T__s_Option($thiz, "height");
  if ((!this$1.c())) {
    $thiz.gN(Math.fround((Math.fround(this$1.h()) + dh)));
  }
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_RectangleSVG(initialClassName, initialHeight, initialWidth, initialX, initialY, appendWithAnimationTime, dragStartFun, dragStopFun, draggingFun, clickFun, getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag, color, stroke) {
  this.a6v = null;
  this.a6w = false;
  this.a6r = null;
  this.a6s = false;
  this.a6x = null;
  this.a6p = null;
  this.a6q = false;
  this.BT = null;
  this.pB = 0.0;
  this.nQ = 0.0;
  this.go = 0.0;
  this.fV = 0.0;
  this.BL = null;
  this.BP = null;
  this.BQ = null;
  this.BR = null;
  this.BM = null;
  this.BS = null;
  this.BV = null;
  this.BW = null;
  this.BO = null;
  this.BU = false;
  this.BN = null;
  this.BX = null;
  this.a6t = null;
  this.a6u = false;
  this.a6z = null;
  this.a6y = null;
  this.BT = initialClassName;
  this.pB = initialHeight;
  this.nQ = initialWidth;
  this.go = initialX;
  this.fV = initialY;
  this.BL = appendWithAnimationTime;
  this.BP = dragStartFun;
  this.BQ = dragStopFun;
  this.BR = draggingFun;
  this.BM = clickFun;
  this.BS = getGroupedDraggedShapes;
  this.BV = onHover;
  this.BW = onMouseOut;
  this.BO = contextMenuFunction;
  this.BU = isMovableOnDrag;
  this.BN = color;
  this.BX = stroke;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a6z = new $c_s_Some(initialX);
  this.a6y = "rect";
}
$p = $c_Lcom_papasofokli_svg_api_RectangleSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_RectangleSVG;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_RectangleSVG() {
}
$h_Lcom_papasofokli_svg_api_RectangleSVG.prototype = $p;
$p.g9 = (function() {
  if ((!this.a6w)) {
    this.a6v = $m_ju_UUID$().aW();
    this.a6w = true;
  }
  return this.a6v;
});
$p.oG = (function() {
  if ((!this.a6s)) {
    this.a6r = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a6s = true;
  }
  return this.a6r;
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a6x;
});
$p.zx = (function(x$0) {
  this.a6x = x$0;
});
$p.DV = (function() {
  if ((!this.a6q)) {
    this.a6p = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a6q = true;
  }
  return this.a6p;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.zU = (function() {
  $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, (-1448198507));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BT));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.pB));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.nQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.go));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.fV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BL));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BP));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BQ));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BR));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BM));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BS));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BV));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BW));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BO));
  acc = $m_sr_Statics$().d(acc, (this.BU ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BN));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.BX));
  return $m_sr_Statics$().an(acc, 17);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_RectangleSVG)) {
    if ((((((this.pB === x$0.pB) && (this.nQ === x$0.nQ)) && (this.go === x$0.go)) && (this.fV === x$0.fV)) && (this.BU === x$0.BU))) {
      var x = this.BT;
      var x$2 = x$0.BT;
      var $x_11 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$3 = this.BL;
      var x$4 = x$0.BL;
      var $x_10 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$5 = this.BP;
      var x$6 = x$0.BP;
      var $x_9 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$7 = this.BQ;
      var x$8 = x$0.BQ;
      var $x_8 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$9 = this.BR;
      var x$10 = x$0.BR;
      var $x_7 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$11 = this.BM;
      var x$12 = x$0.BM;
      var $x_6 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$13 = this.BS;
      var x$14 = x$0.BS;
      var $x_5 = ((x$13 === null) ? (x$14 === null) : (x$13 === x$14));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$15 = this.BV;
      var x$16 = x$0.BV;
      var $x_4 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$17 = this.BW;
      var x$18 = x$0.BW;
      var $x_3 = ((x$17 === null) ? (x$18 === null) : x$17.b(x$18));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$19 = this.BO;
      var x$20 = x$0.BO;
      var $x_2 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$21 = this.BN;
      var x$22 = x$0.BN;
      var $x_1 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$23 = this.BX;
      var x$24 = x$0.BX;
      return ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 17;
});
$p.A = (function() {
  return "RectangleSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.BT;
      break;
    }
    case 1: {
      return this.pB;
      break;
    }
    case 2: {
      return this.nQ;
      break;
    }
    case 3: {
      return this.go;
      break;
    }
    case 4: {
      return this.fV;
      break;
    }
    case 5: {
      return this.BL;
      break;
    }
    case 6: {
      return this.BP;
      break;
    }
    case 7: {
      return this.BQ;
      break;
    }
    case 8: {
      return this.BR;
      break;
    }
    case 9: {
      return this.BM;
      break;
    }
    case 10: {
      return this.BS;
      break;
    }
    case 11: {
      return this.BV;
      break;
    }
    case 12: {
      return this.BW;
      break;
    }
    case 13: {
      return this.BO;
      break;
    }
    case 14: {
      return this.BU;
      break;
    }
    case 15: {
      return this.BN;
      break;
    }
    case 16: {
      return this.BX;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oP = (function() {
  return this.BT;
});
$p.oC = (function() {
  return this.BL;
});
$p.zB = (function() {
  return this.BP;
});
$p.zC = (function() {
  return this.BQ;
});
$p.zD = (function() {
  return this.BR;
});
$p.DU = (function() {
  return this.BM;
});
$p.Ep = (function() {
  return this.BV;
});
$p.Eq = (function() {
  return this.BW;
});
$p.DW = (function() {
  return this.BO;
});
$p.Eh = (function() {
  return this.BU;
});
$p.oF = (function() {
  return this.BN;
});
$p.p0 = (function() {
  return this.BX;
});
$p.oN = (function() {
  if ((!this.a6u)) {
    this.a6t = this.BS.aA();
    this.a6u = true;
  }
  return this.a6t;
});
$p.p1 = (function() {
  return this.a6z;
});
$p.oZ = (function() {
  return this.a6y;
});
$p.oE = (function() {
  var x = this.pB;
  var $x_1 = new $c_Lcom_papasofokli_util_AttributeValue("height", ("" + Math.fround((+Math.max(x, 0.0)))));
  var x$1 = this.nQ;
  return new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("width", ("" + Math.fround((+Math.max(x$1, 0.0))))), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("x", ("" + this.go)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("y", ("" + this.fV)), $m_sci_Nil$()))));
});
$p.Ez = (function(w) {
  var width = Math.fround((+Math.max(w, 0.0)));
  var this$3 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$3.c())) {
    var x0 = this$3.h();
    new $c_Lcom_papasofokli_util_AttributeValue("width", ("" + width)).ds(x0);
  }
});
$p.gN = (function(h) {
  var height = Math.fround((+Math.max(h, 0.0)));
  var this$3 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$3.c())) {
    var x0 = this$3.h();
    new $c_Lcom_papasofokli_util_AttributeValue("height", ("" + height)).ds(x0);
  }
});
$p.axl = (function(dx) {
  $p_Lcom_papasofokli_svg_api_RectangleSVG__translate__F__F__V(this, dx, 0.0);
  $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeWidth__F__V(this, Math.fround((-dx)));
});
$p.axm = (function(dx, dy) {
  $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeWidth__F__V(this, dx);
});
$p.axo = (function(dx, dy) {
  $p_Lcom_papasofokli_svg_api_RectangleSVG__translate__F__F__V(this, 0.0, dy);
  $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeHeight__F__V(this, Math.fround((-dy)));
});
$p.axj = (function(dx, dy) {
  $p_Lcom_papasofokli_svg_api_RectangleSVG__resizeHeight__F__V(this, dy);
});
$p.cT = (function(newX, newY) {
  this.zS(new $c_s_Some(newX), new $c_s_Some(newY));
});
$p.zS = (function(newX, newY) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$1.c())) {
    $p_Lcom_papasofokli_svg_api_RectangleSVG__moveTo__s_Option__s_Option__Lorg_scalajs_dom_Element__V(this, newX, newY, this$1.h());
  }
});
$p.oQ = (function() {
  return $m_sci_Nil$();
});
$p.E0 = (function(element, dx, dy) {
  try {
    var $x_3 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("x"))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_3;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_3 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  var $x_2 = $x_3.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => Math.fround((Math.fround(_$4$3) + dx))))).mN();
  try {
    var $x_1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("y"))));
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchResult1$1: {
      var $x_1;
      var x2$1 = $m_s_util_control_NonFatal$().dV(e$2$1);
      if ((!x2$1.c())) {
        var $x_1 = new $c_s_util_Failure(x2$1.h());
        break matchResult1$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
    }
  }
  $p_Lcom_papasofokli_svg_api_RectangleSVG__moveTo__s_Option__s_Option__Lorg_scalajs_dom_Element__V(this, $x_2, $x_1.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$3) => Math.fround((Math.fround(_$5$3) + dy))))).mN(), element);
});
function $isArrayOf_Lcom_papasofokli_svg_api_RectangleSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fQ)));
}
var $d_Lcom_papasofokli_svg_api_RectangleSVG = new $TypeData().i($c_Lcom_papasofokli_svg_api_RectangleSVG, "com.papasofokli.svg.api.RectangleSVG", ({
  fQ: 1,
  aH: 1,
  b0: 1,
  cj: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
function $p_Lcom_papasofokli_svg_api_TextSVG__moveTo__Lorg_scalajs_dom_Element__F__F__V($thiz, element, newX, newY) {
  new $c_Lcom_papasofokli_util_AttributeValue("x", ("" + newX)).ds(element);
  new $c_Lcom_papasofokli_util_AttributeValue("y", ("" + newY)).ds(element);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_api_TextSVG(initialClassName, text, initialX, initialY, textLength, lengthAdjust, appendWithAnimationTime, dragStartFun, dragStopFun, draggingFun, clickFun, getGroupedDraggedShapes, onHover, onMouseOut, contextMenuFunction, isMovableOnDrag, color, stroke) {
  this.a6V = null;
  this.a6W = false;
  this.a6T = null;
  this.a6U = false;
  this.a6X = null;
  this.a6R = null;
  this.a6S = false;
  this.xD = null;
  this.xG = null;
  this.C7 = 0.0;
  this.C8 = 0.0;
  this.xH = null;
  this.xE = null;
  this.C0 = null;
  this.C3 = null;
  this.C4 = null;
  this.C5 = null;
  this.C1 = null;
  this.C6 = null;
  this.Ca = null;
  this.Cb = null;
  this.C2 = null;
  this.C9 = false;
  this.xC = null;
  this.xF = null;
  this.a6Z = null;
  this.a6Y = null;
  this.xD = initialClassName;
  this.xG = text;
  this.C7 = initialX;
  this.C8 = initialY;
  this.xH = textLength;
  this.xE = lengthAdjust;
  this.C0 = appendWithAnimationTime;
  this.C3 = dragStartFun;
  this.C4 = dragStopFun;
  this.C5 = draggingFun;
  this.C1 = clickFun;
  this.C6 = getGroupedDraggedShapes;
  this.Ca = onHover;
  this.Cb = onMouseOut;
  this.C2 = contextMenuFunction;
  this.C9 = isMovableOnDrag;
  this.xC = color;
  this.xF = stroke;
  $f_Lcom_papasofokli_svg_api_SvgShape__$init$__V(this);
  this.a6Z = new $c_s_Some(initialX);
  this.a6Y = "text";
}
$p = $c_Lcom_papasofokli_svg_api_TextSVG.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_svg_api_TextSVG;
/** @constructor */
function $h_Lcom_papasofokli_svg_api_TextSVG() {
}
$h_Lcom_papasofokli_svg_api_TextSVG.prototype = $p;
$p.g9 = (function() {
  if ((!this.a6W)) {
    this.a6V = $m_ju_UUID$().aW();
    this.a6W = true;
  }
  return this.a6V;
});
$p.oG = (function() {
  if ((!this.a6U)) {
    this.a6T = $f_Lcom_papasofokli_svg_api_GeneralShape__com$papasofokli$svg$api$GeneralShape$$attributeValueClass__s_Option(this);
    this.a6U = true;
  }
  return this.a6T;
});
$p.oJ = (function() {
  return $m_sci_Nil$();
});
$p.oV = (function() {
  return this.a6X;
});
$p.zx = (function(x$0) {
  this.a6X = x$0;
});
$p.DV = (function() {
  if ((!this.a6S)) {
    this.a6R = $f_Lcom_papasofokli_svg_actions_ActionsShape__com$papasofokli$svg$actions$ActionsShape$$element__Lorg_scalajs_dom_Element(this);
    this.a6S = true;
  }
  return this.a6R;
});
$p.oT = (function() {
  return $f_Lcom_papasofokli_svg_actions_ActionsShape__makeLocalFunctionsO__s_Option(this);
});
$p.zU = (function() {
  $f_Lcom_papasofokli_svg_actions_ActionsShape__removeInitialAnimation__V(this);
});
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, 246802903);
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xG));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.C7));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().aS(this.C8));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xH));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xE));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C0));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C3));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C4));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C5));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C1));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C6));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Ca));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.Cb));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.C2));
  acc = $m_sr_Statics$().d(acc, (this.C9 ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xC));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.xF));
  return $m_sr_Statics$().an(acc, 18);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcom_papasofokli_svg_api_TextSVG)) {
    if ((((this.C7 === x$0.C7) && (this.C8 === x$0.C8)) && (this.C9 === x$0.C9))) {
      var x = this.xD;
      var x$2 = x$0.xD;
      var $x_13 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_13 = false;
    }
    if (($x_13 && (this.xG === x$0.xG))) {
      var x$3 = this.xH;
      var x$4 = x$0.xH;
      var $x_12 = ((x$3 === null) ? (x$4 === null) : x$3.b(x$4));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$5 = this.xE;
      var x$6 = x$0.xE;
      var $x_11 = ((x$5 === null) ? (x$6 === null) : x$5.b(x$6));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$7 = this.C0;
      var x$8 = x$0.C0;
      var $x_10 = ((x$7 === null) ? (x$8 === null) : x$7.b(x$8));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$9 = this.C3;
      var x$10 = x$0.C3;
      var $x_9 = ((x$9 === null) ? (x$10 === null) : x$9.b(x$10));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$11 = this.C4;
      var x$12 = x$0.C4;
      var $x_8 = ((x$11 === null) ? (x$12 === null) : x$11.b(x$12));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$13 = this.C5;
      var x$14 = x$0.C5;
      var $x_7 = ((x$13 === null) ? (x$14 === null) : x$13.b(x$14));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$15 = this.C1;
      var x$16 = x$0.C1;
      var $x_6 = ((x$15 === null) ? (x$16 === null) : x$15.b(x$16));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$17 = this.C6;
      var x$18 = x$0.C6;
      var $x_5 = ((x$17 === null) ? (x$18 === null) : (x$17 === x$18));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$19 = this.Ca;
      var x$20 = x$0.Ca;
      var $x_4 = ((x$19 === null) ? (x$20 === null) : x$19.b(x$20));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$21 = this.Cb;
      var x$22 = x$0.Cb;
      var $x_3 = ((x$21 === null) ? (x$22 === null) : x$21.b(x$22));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$23 = this.C2;
      var x$24 = x$0.C2;
      var $x_2 = ((x$23 === null) ? (x$24 === null) : x$23.b(x$24));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$25 = this.xC;
      var x$26 = x$0.xC;
      var $x_1 = ((x$25 === null) ? (x$26 === null) : x$25.b(x$26));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$27 = this.xF;
      var x$28 = x$0.xF;
      return ((x$27 === null) ? (x$28 === null) : x$27.b(x$28));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.g = (function() {
  return $m_sr_ScalaRunTime$().H(this);
});
$p.w = (function() {
  return 18;
});
$p.A = (function() {
  return "TextSVG";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.xD;
      break;
    }
    case 1: {
      return this.xG;
      break;
    }
    case 2: {
      return this.C7;
      break;
    }
    case 3: {
      return this.C8;
      break;
    }
    case 4: {
      return this.xH;
      break;
    }
    case 5: {
      return this.xE;
      break;
    }
    case 6: {
      return this.C0;
      break;
    }
    case 7: {
      return this.C3;
      break;
    }
    case 8: {
      return this.C4;
      break;
    }
    case 9: {
      return this.C5;
      break;
    }
    case 10: {
      return this.C1;
      break;
    }
    case 11: {
      return this.C6;
      break;
    }
    case 12: {
      return this.Ca;
      break;
    }
    case 13: {
      return this.Cb;
      break;
    }
    case 14: {
      return this.C2;
      break;
    }
    case 15: {
      return this.C9;
      break;
    }
    case 16: {
      return this.xC;
      break;
    }
    case 17: {
      return this.xF;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.oP = (function() {
  return this.xD;
});
$p.oC = (function() {
  return this.C0;
});
$p.zB = (function() {
  return this.C3;
});
$p.zC = (function() {
  return this.C4;
});
$p.zD = (function() {
  return this.C5;
});
$p.DU = (function() {
  return this.C1;
});
$p.Ep = (function() {
  return this.Ca;
});
$p.Eq = (function() {
  return this.Cb;
});
$p.DW = (function() {
  return this.C2;
});
$p.Eh = (function() {
  return this.C9;
});
$p.oF = (function() {
  return this.xC;
});
$p.p0 = (function() {
  return this.xF;
});
$p.oN = (function() {
  return this.C6.aA();
});
$p.p1 = (function() {
  return this.a6Z;
});
$p.oE = (function() {
  var seq = new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("font-family", "FontAwesome"), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("x", ("" + this.C7)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_AttributeValue("y", ("" + this.C8)), new $c_sci_$colon$colon(new $c_Lcom_papasofokli_util_TextContent(this.xG), $m_sci_Nil$()))));
  var this$9 = this.xH;
  var lengthAttr = (this$9.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_AttributeValue("textLength", ("" + Math.fround(this$9.h())))));
  var this$13 = this.xE;
  var lengthAdjustAttr = (this$13.c() ? $m_s_None$() : new $c_s_Some(new $c_Lcom_papasofokli_util_AttributeValue("lengthAdjust", this$13.h().g())));
  return seq.cY(lengthAttr).cY(lengthAdjustAttr);
});
$p.oZ = (function() {
  return this.a6Y;
});
$p.cT = (function(newX, newY) {
  var this$1 = $f_Lcom_papasofokli_svg_api_GeneralShape__getElement__s_Option(this);
  if ((!this$1.c())) {
    $p_Lcom_papasofokli_svg_api_TextSVG__moveTo__Lorg_scalajs_dom_Element__F__F__V(this, this$1.h(), newX, newY);
  }
});
$p.oQ = (function() {
  return $m_sci_Nil$();
});
$p.E0 = (function(element, dx, dy) {
  try {
    var $x_1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("x"))));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var $x_1 = new $c_s_util_Failure(x2.h());
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
  var newXU = $x_1.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$3) => Math.fround((Math.fround(_$3$3) + dx)))));
  try {
    var $x_2 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Float$().gL(element.getAttribute("y"))));
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchResult1$1: {
      var $x_2;
      var x2$1 = $m_s_util_control_NonFatal$().dV(e$2$1);
      if ((!x2$1.c())) {
        var $x_2 = new $c_s_util_Failure(x2$1.h());
        break matchResult1$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.b6 : e$2$1);
    }
  }
  var newYU = $x_2.kN(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$3) => Math.fround((Math.fround(_$4$3) + dy)))));
  newXU.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var newX = Math.fround(v1$2);
    newYU.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2$1) => {
      $p_Lcom_papasofokli_svg_api_TextSVG__moveTo__Lorg_scalajs_dom_Element__F__F__V(this, element, newX, Math.fround(v1$2$1));
    })));
  })));
});
function $isArrayOf_Lcom_papasofokli_svg_api_TextSVG(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fT)));
}
var $d_Lcom_papasofokli_svg_api_TextSVG = new $TypeData().i($c_Lcom_papasofokli_svg_api_TextSVG, "com.papasofokli.svg.api.TextSVG", ({
  fT: 1,
  aH: 1,
  b0: 1,
  cj: 1,
  aT: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_util_DangerProgressBar$() {
  this.xS = null;
  $ct_Lcom_papasofokli_util_ProgressBarStyle__T__(this, "progress-bar-danger");
}
$p = $c_Lcom_papasofokli_util_DangerProgressBar$.prototype = new $h_Lcom_papasofokli_util_ProgressBarStyle();
$p.constructor = $c_Lcom_papasofokli_util_DangerProgressBar$;
/** @constructor */
function $h_Lcom_papasofokli_util_DangerProgressBar$() {
}
$h_Lcom_papasofokli_util_DangerProgressBar$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-1886378909);
});
$p.g = (function() {
  return "DangerProgressBar";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "DangerProgressBar";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_util_DangerProgressBar$ = new $TypeData().i($c_Lcom_papasofokli_util_DangerProgressBar$, "com.papasofokli.util.DangerProgressBar$", ({
  sn: 1,
  bi: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_DangerProgressBar$;
function $m_Lcom_papasofokli_util_DangerProgressBar$() {
  if ((!$n_Lcom_papasofokli_util_DangerProgressBar$)) {
    $n_Lcom_papasofokli_util_DangerProgressBar$ = new $c_Lcom_papasofokli_util_DangerProgressBar$();
  }
  return $n_Lcom_papasofokli_util_DangerProgressBar$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_PrimaryProgressBar$() {
  this.xS = null;
  $ct_Lcom_papasofokli_util_ProgressBarStyle__T__(this, "progress-bar-primary");
}
$p = $c_Lcom_papasofokli_util_PrimaryProgressBar$.prototype = new $h_Lcom_papasofokli_util_ProgressBarStyle();
$p.constructor = $c_Lcom_papasofokli_util_PrimaryProgressBar$;
/** @constructor */
function $h_Lcom_papasofokli_util_PrimaryProgressBar$() {
}
$h_Lcom_papasofokli_util_PrimaryProgressBar$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 900749156;
});
$p.g = (function() {
  return "PrimaryProgressBar";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "PrimaryProgressBar";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_util_PrimaryProgressBar$ = new $TypeData().i($c_Lcom_papasofokli_util_PrimaryProgressBar$, "com.papasofokli.util.PrimaryProgressBar$", ({
  sJ: 1,
  bi: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_PrimaryProgressBar$;
function $m_Lcom_papasofokli_util_PrimaryProgressBar$() {
  if ((!$n_Lcom_papasofokli_util_PrimaryProgressBar$)) {
    $n_Lcom_papasofokli_util_PrimaryProgressBar$ = new $c_Lcom_papasofokli_util_PrimaryProgressBar$();
  }
  return $n_Lcom_papasofokli_util_PrimaryProgressBar$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_SuccessProgressBar$() {
  this.xS = null;
  $ct_Lcom_papasofokli_util_ProgressBarStyle__T__(this, "progress-bar-success");
}
$p = $c_Lcom_papasofokli_util_SuccessProgressBar$.prototype = new $h_Lcom_papasofokli_util_ProgressBarStyle();
$p.constructor = $c_Lcom_papasofokli_util_SuccessProgressBar$;
/** @constructor */
function $h_Lcom_papasofokli_util_SuccessProgressBar$() {
}
$h_Lcom_papasofokli_util_SuccessProgressBar$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-248083773);
});
$p.g = (function() {
  return "SuccessProgressBar";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "SuccessProgressBar";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_util_SuccessProgressBar$ = new $TypeData().i($c_Lcom_papasofokli_util_SuccessProgressBar$, "com.papasofokli.util.SuccessProgressBar$", ({
  sP: 1,
  bi: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_SuccessProgressBar$;
function $m_Lcom_papasofokli_util_SuccessProgressBar$() {
  if ((!$n_Lcom_papasofokli_util_SuccessProgressBar$)) {
    $n_Lcom_papasofokli_util_SuccessProgressBar$ = new $c_Lcom_papasofokli_util_SuccessProgressBar$();
  }
  return $n_Lcom_papasofokli_util_SuccessProgressBar$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_WarningProgressBar$() {
  this.xS = null;
  $ct_Lcom_papasofokli_util_ProgressBarStyle__T__(this, "progress-bar-warning");
}
$p = $c_Lcom_papasofokli_util_WarningProgressBar$.prototype = new $h_Lcom_papasofokli_util_ProgressBarStyle();
$p.constructor = $c_Lcom_papasofokli_util_WarningProgressBar$;
/** @constructor */
function $h_Lcom_papasofokli_util_WarningProgressBar$() {
}
$h_Lcom_papasofokli_util_WarningProgressBar$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 1288081802;
});
$p.g = (function() {
  return "WarningProgressBar";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "WarningProgressBar";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_util_WarningProgressBar$ = new $TypeData().i($c_Lcom_papasofokli_util_WarningProgressBar$, "com.papasofokli.util.WarningProgressBar$", ({
  sV: 1,
  bi: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_WarningProgressBar$;
function $m_Lcom_papasofokli_util_WarningProgressBar$() {
  if ((!$n_Lcom_papasofokli_util_WarningProgressBar$)) {
    $n_Lcom_papasofokli_util_WarningProgressBar$ = new $c_Lcom_papasofokli_util_WarningProgressBar$();
  }
  return $n_Lcom_papasofokli_util_WarningProgressBar$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_Default$() {
}
$p = $c_Lcom_papasofokli_util_formgroup_Default$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_Default$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_Default$() {
}
$h_Lcom_papasofokli_util_formgroup_Default$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-1085510111);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Default";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return "";
});
var $d_Lcom_papasofokli_util_formgroup_Default$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_Default$, "com.papasofokli.util.formgroup.Default$", ({
  sW: 1,
  bj: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_formgroup_Default$;
function $m_Lcom_papasofokli_util_formgroup_Default$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_Default$)) {
    $n_Lcom_papasofokli_util_formgroup_Default$ = new $c_Lcom_papasofokli_util_formgroup_Default$();
  }
  return $n_Lcom_papasofokli_util_formgroup_Default$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_Error$() {
}
$p = $c_Lcom_papasofokli_util_formgroup_Error$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_Error$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_Error$() {
}
$h_Lcom_papasofokli_util_formgroup_Error$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 67232232;
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Error";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return "has-error";
});
var $d_Lcom_papasofokli_util_formgroup_Error$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_Error$, "com.papasofokli.util.formgroup.Error$", ({
  sX: 1,
  bj: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_formgroup_Error$;
function $m_Lcom_papasofokli_util_formgroup_Error$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_Error$)) {
    $n_Lcom_papasofokli_util_formgroup_Error$ = new $c_Lcom_papasofokli_util_formgroup_Error$();
  }
  return $n_Lcom_papasofokli_util_formgroup_Error$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_Success$() {
}
$p = $c_Lcom_papasofokli_util_formgroup_Success$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_Success$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_Success$() {
}
$h_Lcom_papasofokli_util_formgroup_Success$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-202516509);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Success";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return "has-success";
});
var $d_Lcom_papasofokli_util_formgroup_Success$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_Success$, "com.papasofokli.util.formgroup.Success$", ({
  t4: 1,
  bj: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_formgroup_Success$;
function $m_Lcom_papasofokli_util_formgroup_Success$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_Success$)) {
    $n_Lcom_papasofokli_util_formgroup_Success$ = new $c_Lcom_papasofokli_util_formgroup_Success$();
  }
  return $n_Lcom_papasofokli_util_formgroup_Success$;
}
/** @constructor */
function $c_Lcom_papasofokli_util_formgroup_Warning$() {
}
$p = $c_Lcom_papasofokli_util_formgroup_Warning$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_util_formgroup_Warning$;
/** @constructor */
function $h_Lcom_papasofokli_util_formgroup_Warning$() {
}
$h_Lcom_papasofokli_util_formgroup_Warning$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-1505867908);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Warning";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.g = (function() {
  return "has-warning";
});
var $d_Lcom_papasofokli_util_formgroup_Warning$ = new $TypeData().i($c_Lcom_papasofokli_util_formgroup_Warning$, "com.papasofokli.util.formgroup.Warning$", ({
  t5: 1,
  bj: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_util_formgroup_Warning$;
function $m_Lcom_papasofokli_util_formgroup_Warning$() {
  if ((!$n_Lcom_papasofokli_util_formgroup_Warning$)) {
    $n_Lcom_papasofokli_util_formgroup_Warning$ = new $c_Lcom_papasofokli_util_formgroup_Warning$();
  }
  return $n_Lcom_papasofokli_util_formgroup_Warning$;
}
/** @constructor */
function $c_Lcom_papasofokli_websocket_GreetingMessage$() {
}
$p = $c_Lcom_papasofokli_websocket_GreetingMessage$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_GreetingMessage$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_GreetingMessage$() {
}
$h_Lcom_papasofokli_websocket_GreetingMessage$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 1783287150;
});
$p.g = (function() {
  return "GreetingMessage";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "GreetingMessage";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_websocket_GreetingMessage$ = new $TypeData().i($c_Lcom_papasofokli_websocket_GreetingMessage$, "com.papasofokli.websocket.GreetingMessage$", ({
  te: 1,
  b1: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_websocket_GreetingMessage$;
function $m_Lcom_papasofokli_websocket_GreetingMessage$() {
  if ((!$n_Lcom_papasofokli_websocket_GreetingMessage$)) {
    $n_Lcom_papasofokli_websocket_GreetingMessage$ = new $c_Lcom_papasofokli_websocket_GreetingMessage$();
  }
  return $n_Lcom_papasofokli_websocket_GreetingMessage$;
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (((typeof console) !== "undefined")) {
    if (($thiz.a96 && (!(!(!(!console.error)))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.a96 = false;
  this.Go = null;
  this.a96 = isErr;
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream(), false, null);
  this.Go = "";
}
$p = $c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
$h_jl_JSConsoleBasedPrintStream.prototype = $p;
$p.ajd = (function(s) {
  this.zO(((s === null) ? "null" : s));
});
$p.zO = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = (this$1.indexOf("\n") | 0);
    if ((nlPos < 0)) {
      this.Go = (("" + this.Go) + rest);
      rest = "";
    } else {
      var $x_1 = this.Go;
      var this$2 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + this$2.substring(0, nlPos)));
      this.Go = "";
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = this$4.substring(beginIndex);
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().i($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  tF: 1,
  tr: 1,
  tq: 1,
  ge: 1,
  bN: 1,
  bP: 1,
  bO: 1,
  bb: 1
}));
var $d_Lorg_scalajs_dom_Element = new $TypeData().i(2, "org.scalajs.dom.Element", ({
  vw: 1,
  vA: 1,
  vx: 1,
  Bt: 1,
  Bn: 1,
  vB: 1,
  vD: 1,
  vC: 1
}), ((x) => (x instanceof Element)));
function $f_sc_BitSetOps__ordering__s_math_Ordering($thiz) {
  $m_s_math_Ordering$();
  return $m_s_math_Ordering$Int$();
}
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var $x_1 = $thiz.dW((elem >> 6));
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    return (((x_$_lo & lo) | (x_$_hi & hi)) !== 0);
  } else {
    return false;
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.hh();
  while ((i > 0)) {
    i = ((i - 1) | 0);
    var $x_2 = s;
    var $x_1 = $thiz.dW(i);
    var i$1_$_lo = $x_1.l;
    var i$1_$_hi = $x_1.h;
    s = (($x_2 + (($m_jl_Integer$().cI(i$1_$_lo) + $m_jl_Integer$().cI(i$1_$_hi)) | 0)) | 0);
  }
  return s;
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.hh();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.gu)) {
    var x0 = it.jx();
    var $x_1 = $thiz.dW(x0);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    res = ((x_$_lo | x_$_hi) === 0);
  }
  return res;
}
function $f_sc_BitSetOps__max__s_math_Ordering__I($thiz, ord) {
  if (($m_s_math_Ordering$(), ($m_s_math_Ordering$Int$() === ord))) {
    var i = (($thiz.hh() - 1) | 0);
    while ((i >= 0)) {
      var $x_1 = $thiz.dW(i);
      var currentWord_$_lo = $x_1.l;
      var currentWord_$_hi = $x_1.h;
      if (((currentWord_$_lo | currentWord_$_hi) !== 0)) {
        return (((((((1 + i) | 0) << 6) - ((currentWord_$_hi !== 0) ? Math.clz32(currentWord_$_hi) : ((32 + Math.clz32(currentWord_$_lo)) | 0))) | 0) - 1) | 0);
      }
      i = ((i - 1) | 0);
    }
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.largestInt");
  } else if (($m_s_math_Ordering$(), $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord))) {
    var thisnwords = $thiz.hh();
    var i$1 = 0;
    while ((i$1 < thisnwords)) {
      var $x_2 = $thiz.dW(i$1);
      var currentWord$1_$_lo = $x_2.l;
      var currentWord$1_$_hi = $x_2.h;
      if (((currentWord$1_$_lo | currentWord$1_$_hi) !== 0)) {
        return ((((currentWord$1_$_lo !== 0) ? ((32 - Math.clz32(((~currentWord$1_$_lo) & ((currentWord$1_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~currentWord$1_$_hi) & ((currentWord$1_$_hi - 1) | 0)))) | 0)) + (i$1 << 6)) | 0);
      }
      i$1 = ((1 + i$1) | 0);
    }
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.smallestInt");
  } else {
    return $thiz.ajv(ord);
  }
}
function $f_sc_BitSetOps__min__s_math_Ordering__I($thiz, ord) {
  if (($m_s_math_Ordering$(), ($m_s_math_Ordering$Int$() === ord))) {
    var thisnwords = $thiz.hh();
    var i = 0;
    while ((i < thisnwords)) {
      var $x_1 = $thiz.dW(i);
      var currentWord_$_lo = $x_1.l;
      var currentWord_$_hi = $x_1.h;
      if (((currentWord_$_lo | currentWord_$_hi) !== 0)) {
        return ((((currentWord_$_lo !== 0) ? ((32 - Math.clz32(((~currentWord_$_lo) & ((currentWord_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~currentWord_$_hi) & ((currentWord_$_hi - 1) | 0)))) | 0)) + (i << 6)) | 0);
      }
      i = ((1 + i) | 0);
    }
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.smallestInt");
  } else if (($m_s_math_Ordering$(), $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord))) {
    var i$3 = (($thiz.hh() - 1) | 0);
    while ((i$3 >= 0)) {
      var $x_2 = $thiz.dW(i$3);
      var currentWord$1_$_lo = $x_2.l;
      var currentWord$1_$_hi = $x_2.h;
      if (((currentWord$1_$_lo | currentWord$1_$_hi) !== 0)) {
        return (((((((1 + i$3) | 0) << 6) - ((currentWord$1_$_hi !== 0) ? Math.clz32(currentWord$1_$_hi) : ((32 + Math.clz32(currentWord$1_$_lo)) | 0))) | 0) - 1) | 0);
      }
      i$3 = ((i$3 - 1) | 0);
    }
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.largestInt");
  } else {
    return $thiz.ajw(ord);
  }
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.hh())) {
    var $x_1 = $thiz.dW(i);
    var w_$_lo = $x_1.l;
    var w_$_hi = $x_1.h;
    var j = (i << 6);
    while (true) {
      var x_$_lo = w_$_lo;
      var x_$_hi = w_$_hi;
      if (((x_$_lo | x_$_hi) !== 0)) {
        if (((1 & w_$_lo) === 1)) {
          f.p(j);
        }
        var x$2_$_lo = w_$_lo;
        var x$2_$_hi = w_$_hi;
        var lo$1 = (((x$2_$_lo >>> 1) | 0) | (x$2_$_hi << 31));
        var hi = ((x$2_$_hi >>> 1) | 0);
        w_$_lo = lo$1;
        w_$_hi = hi;
        j = ((1 + j) | 0);
      } else {
        break;
      }
    }
    i = ((1 + i) | 0);
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x = $thiz.hh();
    var that = other.hh();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = ((len - 1) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var x0 = i;
        var $x_1 = $thiz.dW(x0);
        var x$1_$_lo = $x_1.l;
        var x$1_$_hi = $x_1.h;
        var $x_2 = other.dW(x0);
        var x$2_$_lo = $x_2.l;
        var x$2_$_hi = $x_2.h;
        var lo = (x$1_$_lo | x$2_$_lo);
        var hi = (x$1_$_hi | x$2_$_hi);
        var $x_3 = words.a;
        var $x_4 = (x0 << 1);
        $x_3[$x_4] = lo;
        $x_3[(($x_4 + 1) | 0)] = hi;
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    return $thiz.ahf(words);
  } else {
    return $thiz.aju(other);
  }
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  var s$tailLocal1 = s;
  var n$tailLocal1 = n;
  while (true) {
    if (((n$tailLocal1 <= 0) || s$tailLocal1.c())) {
      return s$tailLocal1;
    } else {
      var n$tailLocal1$tmp1 = ((n$tailLocal1 - 1) | 0);
      var s$tailLocal1$tmp1 = s$tailLocal1.ak();
      n$tailLocal1 = n$tailLocal1$tmp1;
      s$tailLocal1 = s$tailLocal1$tmp1;
    }
  }
}
function $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  var b = $thiz.uy().aP();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.l();
  while (it.f()) {
    var elem = it.e();
    var v = pf.aJ(elem, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      b.aD(v);
    }
  }
  return b.aR();
}
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.cp(1) <= 0)) {
    return $thiz;
  } else {
    var builder = $thiz.dw();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.l();
    var different = false;
    while (it.f()) {
      var next = it.e();
      if (seen.qA(f.p(next))) {
        builder.aD(next);
      } else {
        different = true;
      }
    }
    return (different ? builder.aR() : $thiz);
  }
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if (($thiz.ahR() && ((($thiz.c4.Es() - $thiz.c4.bd) | 0) < 4934))) {
    var $x_1 = $thiz.ayB().r();
  } else if ($thiz.avi()) {
    var $x_1 = $m_sr_Statics$().aS($thiz.c4.qG());
  } else {
    var temp = $thiz.c4.ak2();
    var $x_1 = $m_s_util_hashing_MurmurHash3$().kR(temp.axI(temp.bd).NA().r(), temp.bd);
  }
  $thiz.LD = $x_1;
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.c4 = null;
  this.LD = 0;
  this.c4 = bigDecimal;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal");
  }
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal");
  }
  this.LD = 1565550863;
}
$p = $c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$p.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
}
$h_s_math_BigDecimal.prototype = $p;
$p.jl = (function(that) {
  return this.c4.It(that.c4);
});
$p.r = (function() {
  if ((this.LD === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this);
  }
  return this.LD;
});
$p.b = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    return this.My(that);
  } else if ((that instanceof $c_s_math_BigInt)) {
    if ((that.TI() > (3.3219280948873626 * ((((this.c4.Es() - this.c4.bd) | 0) - 2) | 0)))) {
      var this$2 = this.ayC();
      if ((!this$2.c())) {
        var x0 = this$2.h();
        return that.agK(x0);
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (((typeof that) === "number")) {
    var that$4 = (+that);
    if ((!((that$4 === Infinity) || (that$4 === (-Infinity))))) {
      var d = this.c4.qG();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === that$4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.My(this$9.U4(d, this$9.D7));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if ($isFloat(that)) {
    var that$5 = Math.fround(that);
    if ((!((that$5 === Infinity) || (that$5 === (-Infinity))))) {
      var f = this.c4.E3();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === that$5))) {
        var this$16 = $m_s_math_BigDecimal$();
        return this.My(this$16.U4(f, this$16.D7));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return (this.IR() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$p.UL = (function() {
  try {
    this.c4.an3();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.UN = (function() {
  try {
    this.c4.axY();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.UM = (function() {
  return ((this.N1() && (this.c4.UK() >= 0)) && (this.c4.UK() <= 65535));
});
$p.N1 = (function() {
  try {
    this.c4.UK();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.IR = (function() {
  try {
    $p_Ljava_math_BigDecimal__valueExact__I__J(this.c4, 64);
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.avi = (function() {
  var d = this.c4.qG();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.My(this$4.U4(d, this$4.D7));
  } else {
    return false;
  }
});
$p.ahR = (function() {
  return ((this.c4.bd <= 0) || (this.c4.ak2().bd <= 0));
});
$p.My = (function(that) {
  return (this.c4.It(that.c4) === 0);
});
$p.TJ = (function() {
  return ((this.c4.js() << 24) >> 24);
});
$p.Vs = (function() {
  return ((this.c4.js() << 16) >> 16);
});
$p.js = (function() {
  return this.c4.js();
});
$p.jw = (function() {
  return this.c4.jw();
});
$p.E3 = (function() {
  return this.c4.E3();
});
$p.qG = (function() {
  return this.c4.qG();
});
$p.ayB = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.c4.NA());
});
$p.ayC = (function() {
  if (this.ahR()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.c4.aka()));
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$();
      } else {
        throw e;
      }
    }
  } else {
    return $m_s_None$();
  }
});
$p.g = (function() {
  return this.c4.g();
});
$p.akj = (function() {
  return this.c4;
});
$p.oH = (function(that) {
  return this.c4.It(that.c4);
});
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i9)));
}
var $d_s_math_BigDecimal = new $TypeData().i($c_s_math_BigDecimal, "scala.math.BigDecimal", ({
  i9: 1,
  d2: 1,
  aA: 1,
  a: 1,
  d3: 1,
  ih: 1,
  N: 1,
  aY: 1
}));
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long_$_lo, _long_$_hi) {
  $thiz.je = _bigInteger;
  $thiz.e2 = _long_$_lo;
  $thiz.e3 = _long_$_hi;
  return $thiz;
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  if (($m_Ljava_math_BitLevel$().DQ(bigInteger) <= 63)) {
    var $x_2 = bigInteger.jw();
    var $x_1_$_lo = $x_2.l;
    var $x_1_$_hi = $x_2.h;
  } else {
    var $x_1_$_lo = 0;
    var $x_1_$_hi = (-2147483648);
  }
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, $x_1_$_lo, $x_1_$_hi);
  return $thiz;
}
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var x_$_lo = $thiz.e2;
  var x_$_hi = $thiz.e3;
  return ((x_$_lo | ((-2147483648) ^ x_$_hi)) !== 0);
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.uq().Nr(2147483647);
  return ((shifted.aX !== 0) && (!shifted.b($m_s_math_BigInt$().abv)));
}
/** @constructor */
function $c_s_math_BigInt() {
  this.je = null;
  this.e2 = 0;
  this.e3 = 0;
}
$p = $c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$p.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
$h_s_math_BigInt.prototype = $p;
$p.jl = (function(that) {
  return this.ag9(that);
});
$p.uq = (function() {
  var read = this.je;
  if ((read !== null)) {
    return read;
  } else {
    var lVal_$_lo = this.e2;
    var lVal_$_hi = this.e3;
    var write = $m_Ljava_math_BigInteger$().iy(lVal_$_lo, lVal_$_hi);
    this.je = write;
    return write;
  }
});
$p.r = (function() {
  return (this.IR() ? $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this) : $m_sr_Statics$().k(this.uq()));
});
$p.b = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    return this.agK(that);
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    return that.b(this);
  } else if (((typeof that) === "number")) {
    var that$4 = (+that);
    return (this.avv() && (this.qG() === that$4));
  } else if ($isFloat(that)) {
    var that$5 = Math.fround(that);
    return (this.avw() && ($m_jl_Float$().gL($m_Ljava_math_Conversion$().qP(this.uq())) === that$5));
  } else {
    return (this.IR() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$p.UL = (function() {
  var x_$_lo = this.e2;
  var x_$_hi = this.e3;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294967168) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.e2;
    var x$1_$_hi = this.e3;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 127) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.UN = (function() {
  var x_$_lo = this.e2;
  var x_$_hi = this.e3;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294934528) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.e2;
    var x$1_$_hi = this.e3;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 32767) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.UM = (function() {
  var x_$_lo = this.e2;
  var x_$_hi = this.e3;
  if ((x_$_hi >= 0)) {
    var x$1_$_lo = this.e2;
    var x$1_$_hi = this.e3;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 65535) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.N1 = (function() {
  var x_$_lo = this.e2;
  var x_$_hi = this.e3;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.e2;
    var x$1_$_hi = this.e3;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.IR = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().Ua(this.je, $m_s_math_BigInt$().Sp));
});
$p.avw = (function() {
  var bitLen = this.TI();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.aiN();
    var $x_1 = (((bitLen <= 128) && (lowest >= ((bitLen - 24) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.avv = (function() {
  var bitLen = this.TI();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.aiN();
    var $x_1 = (((bitLen <= 1024) && (lowest >= ((bitLen - 53) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$p.agK = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.e2;
      var x_$_hi = this.e3;
      var x$1_$_lo = that.e2;
      var x$1_$_hi = that.e3;
      return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $m_sr_BoxesRunTime$().Ua(this.je, that.je));
  }
});
$p.ag9 = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var x_$_lo = this.e2;
      var x_$_hi = this.e3;
      var y_$_lo = that.e2;
      var y_$_hi = that.e3;
      return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
    } else {
      var x$proxy2 = that.je;
      if ((x$proxy2 === null)) {
        $m_sr_Scala3RunTime$().bW();
      }
      return ((-x$proxy2.aX) | 0);
    }
  } else if ($p_s_math_BigInt__longEncoding__Z(that)) {
    var x$proxy3 = this.je;
    if ((x$proxy3 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return x$proxy3.aX;
  } else {
    var x$proxy4 = this.je;
    if ((x$proxy4 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return x$proxy4.ur(that.je);
  }
});
$p.aiN = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.e2;
    var x_$_hi = this.e3;
    if (((x_$_lo | x_$_hi) === 0)) {
      return (-1);
    } else {
      var l_$_lo = this.e2;
      var l_$_hi = this.e3;
      return ((l_$_lo !== 0) ? ((32 - Math.clz32(((~l_$_lo) & ((l_$_lo - 1) | 0)))) | 0) : ((64 - Math.clz32(((~l_$_hi) & ((l_$_hi - 1) | 0)))) | 0));
    }
  } else {
    return this.uq().aht();
  }
});
$p.TI = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.e2;
    var x_$_hi = this.e3;
    if ((x_$_hi < 0)) {
      var x$1_$_lo = this.e2;
      var x$1_$_hi = this.e3;
      var lo = ((1 + x$1_$_lo) | 0);
      var hi = ((x$1_$_hi + ((lo === 0) | 0)) | 0);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((((-hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
    } else {
      var l_$_lo = this.e2;
      var l_$_hi = this.e3;
      return ((64 - ((l_$_hi !== 0) ? Math.clz32(l_$_hi) : ((32 + Math.clz32(l_$_lo)) | 0))) | 0);
    }
  } else {
    var x$proxy7 = this.je;
    if ((x$proxy7 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return $m_Ljava_math_BitLevel$().DQ(x$proxy7);
  }
});
$p.TJ = (function() {
  return ((this.js() << 24) >> 24);
});
$p.Vs = (function() {
  return ((this.js() << 16) >> 16);
});
$p.js = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? $s_RTLong__toInt__I__I__I(this.e2, this.e3) : this.uq().js());
});
$p.jw = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    return $bL(this.e2, this.e3);
  } else {
    var x$proxy8 = this.je;
    if ((x$proxy8 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return x$proxy8.jw();
  }
});
$p.E3 = (function() {
  return $m_jl_Float$().gL($m_Ljava_math_Conversion$().qP(this.uq()));
});
$p.qG = (function() {
  if (this.IR()) {
    var x_$_lo = this.e2;
    var x_$_hi = this.e3;
    if ((x_$_hi >= (-2097152))) {
      var x$1_$_lo = this.e2;
      var x$1_$_hi = this.e3;
      var $x_1 = ((x$1_$_hi === 2097152) ? (x$1_$_lo === 0) : (x$1_$_hi < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var x$2_$_lo = this.e2;
    var x$2_$_hi = this.e3;
    return ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
  } else {
    return $m_jl_Double$().fS($m_Ljava_math_Conversion$().qP(this.uq()));
  }
});
$p.g = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1_$_lo = this.e2;
    var this$1_$_hi = this.e3;
    return $m_RTLong$().gc(this$1_$_lo, this$1_$_hi);
  } else {
    return $m_Ljava_math_Conversion$().qP(this.je);
  }
});
$p.akj = (function() {
  return this.uq();
});
$p.oH = (function(that) {
  return this.ag9(that);
});
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ia)));
}
var $d_s_math_BigInt = new $TypeData().i($c_s_math_BigInt, "scala.math.BigInt", ({
  ia: 1,
  d2: 1,
  aA: 1,
  a: 1,
  d3: 1,
  ih: 1,
  N: 1,
  aY: 1
}));
function $f_s_math_Numeric$FloatIsFractional__plus__F__F__F($thiz, x, y) {
  return Math.fround((x + y));
}
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0);
}
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.Sr = null;
  $n_s_math_Ordering$Int$ = this;
  this.Sr = new $c_s_math_Ordering$Reverse(this);
}
$p = $c_s_math_Ordering$Int$.prototype = new $h_O();
$p.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
}
$h_s_math_Ordering$Int$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Ordering$Int$ = new $TypeData().i($c_s_math_Ordering$Int$, "scala.math.Ordering$Int$", ({
  Ag: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  ie: 1,
  A8: 1
}));
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$();
  }
  return $n_s_math_Ordering$Int$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $p;
$p.dK = (function() {
  return $d_Z.l();
});
$p.fb = (function(len) {
  return new $ac_Z(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $p;
$p.dK = (function() {
  return $d_B.l();
});
$p.fb = (function(len) {
  return new $ac_B(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $p;
$p.dK = (function() {
  return $d_C.l();
});
$p.fb = (function(len) {
  return new $ac_C(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $p;
$p.dK = (function() {
  return $d_D.l();
});
$p.fb = (function(len) {
  return new $ac_D(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $p;
$p.dK = (function() {
  return $d_F.l();
});
$p.fb = (function(len) {
  return new $ac_F(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $p;
$p.dK = (function() {
  return $d_I.l();
});
$p.fb = (function(len) {
  return new $ac_I(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $p;
$p.dK = (function() {
  return $d_J.l();
});
$p.fb = (function(len) {
  return new $ac_J(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.qo = null;
}
$p = $c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$p.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $p;
$p.g = (function() {
  return this.qo;
});
$p.b = (function(that) {
  return (this === that);
});
$p.r = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $p;
$p.dK = (function() {
  return $d_S.l();
});
$p.fb = (function(len) {
  return new $ac_S(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.dF = null;
}
$p = $c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$p.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $p;
$p.dK = (function() {
  return $d_V.l();
});
$p.fb = (function(len) {
  return new ($d_jl_Void.r().C)(len);
});
/** @constructor */
function $c_Lscalatags_JsDom$TypedTag(tag, modifiers, void$1, namespace) {
  this.yD = null;
  this.tK = null;
  this.Db = false;
  this.yC = null;
  this.yD = tag;
  this.tK = modifiers;
  this.Db = void$1;
  this.yC = namespace;
}
$p = $c_Lscalatags_JsDom$TypedTag.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$TypedTag;
/** @constructor */
function $h_Lscalatags_JsDom$TypedTag() {
}
$h_Lscalatags_JsDom$TypedTag.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  var acc = (-889275714);
  acc = $m_sr_Statics$().d(acc, $f_T__hashCode__I("TypedTag"));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.yD));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.tK));
  acc = $m_sr_Statics$().d(acc, (this.Db ? 1231 : 1237));
  acc = $m_sr_Statics$().d(acc, $m_sr_Statics$().k(this.yC));
  return $m_sr_Statics$().an(acc, 4);
});
$p.b = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscalatags_JsDom$TypedTag)) {
    if (((this.Db === x$0.Db) && (this.yD === x$0.yD))) {
      var x = this.tK;
      var x$2 = x$0.tK;
      var $x_1 = ((x === null) ? (x$2 === null) : x.b(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.yC;
      var x$4 = x$0.yC;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.w = (function() {
  return 4;
});
$p.A = (function() {
  return "TypedTag";
});
$p.z = (function(n) {
  switch (n) {
    case 0: {
      return this.yD;
      break;
    }
    case 1: {
      return this.tK;
      break;
    }
    case 2: {
      return this.Db;
      break;
    }
    case 3: {
      return this.yC;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aB = (function() {
  var elem = document.createElementNS(this.yC.aks(), this.yD);
  $f_Lscalatags_generic_TypedTag__build__O__V(this, elem);
  return elem;
});
$p.o = (function(xs) {
  var modifiers$1 = new $c_sci_$colon$colon(xs, this.tK);
  var namespace$1 = this.yC;
  return new $c_Lscalatags_JsDom$TypedTag(this.yD, modifiers$1, this.Db, namespace$1);
});
$p.g = (function() {
  return this.aB().outerHTML;
});
$p.uB = (function() {
  return this.aB();
});
$p.J6 = (function() {
  return this.aB();
});
$p.oD = (function(t) {
  $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V(this, t);
});
function $isArrayOf_Lscalatags_JsDom$TypedTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.is)));
}
var $d_Lscalatags_JsDom$TypedTag = new $TypeData().i($c_Lscalatags_JsDom$TypedTag, "scalatags.JsDom$TypedTag", ({
  is: 1,
  aZ: 1,
  bF: 1,
  Cp: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1(outer) {
  this.qs = 0;
  this.oz = 0;
  this.oA = 0;
  this.aeD = null;
  this.aeB = null;
  this.aeC = null;
  this.Tg = false;
  this.aeA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeA = outer;
  $ct_Lupickle_implicits_CaseObjectContext2__I__(this, outer.Y);
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__$init$__V(this);
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1.prototype = new $h_Lupickle_implicits_CaseObjectContext2();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$1;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$$anon$1() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$$anon$1.prototype = $p;
$p.VS = (function() {
  return this.aeD;
});
$p.VQ = (function() {
  return this.aeB;
});
$p.akp = (function() {
  return this.aeC;
});
$p.ak0 = (function() {
  return this.Tg;
});
$p.VR = (function(x$1) {
  this.aeC = x$1;
});
$p.Nw = (function(x$1) {
  this.Tg = x$1;
});
$p.akr = (function(x$0) {
  this.aeD = x$0;
});
$p.akq = (function(x$0) {
  this.aeB = x$0;
});
$p.eT = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKey__I__Lupickle_core_Visitor(this, index);
});
$p.bw = (function() {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__subVisitor__Lupickle_core_Visitor(this);
});
$p.eU = (function(v) {
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKeyValue__O__V(this, v);
});
$p.L = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitEnd__I__O(this, index);
});
$p.bu = (function(v, index) {
  if ((this.qs !== (-1))) {
    var x_$_lo = this.oz;
    var x_$_hi = this.oA;
    var n = this.qs;
    var lo = (((32 & n) === 0) ? (1 << n) : 0);
    var hi = (((32 & n) === 0) ? 0 : (1 << n));
    var $x_1 = (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, this.qs, v);
    var x$1_$_lo = this.oz;
    var x$1_$_hi = this.oA;
    var n$1 = this.qs;
    var lo$2 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$2 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    this.oz = lo$3;
    this.oA = hi$3;
  } else if (this.Tg) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, this.qs, v);
  }
});
$p.gf = (function() {
  return this.aeA;
});
var $d_Lupickle_implicits_ReadersVersionSpecific$$anon$1 = new $TypeData().i($c_Lupickle_implicits_ReadersVersionSpecific$$anon$1, "upickle.implicits.ReadersVersionSpecific$$anon$1", ({
  Ew: 1,
  DT: 1,
  DS: 1,
  Y: 1,
  aw: 1,
  je: 1,
  jf: 1,
  ji: 1
}));
/** @constructor */
function $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2(outer) {
  this.mv = 0;
  this.qt = null;
  this.aeH = null;
  this.aeF = null;
  this.aeG = null;
  this.Th = false;
  this.aeE = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.aeE = outer;
  $ct_Lupickle_implicits_HugeCaseObjectContext2__I__(this, outer.Y);
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__$init$__V(this);
}
$p = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2.prototype = new $h_Lupickle_implicits_HugeCaseObjectContext2();
$p.constructor = $c_Lupickle_implicits_ReadersVersionSpecific$$anon$2;
/** @constructor */
function $h_Lupickle_implicits_ReadersVersionSpecific$$anon$2() {
}
$h_Lupickle_implicits_ReadersVersionSpecific$$anon$2.prototype = $p;
$p.VS = (function() {
  return this.aeH;
});
$p.VQ = (function() {
  return this.aeF;
});
$p.akp = (function() {
  return this.aeG;
});
$p.ak0 = (function() {
  return this.Th;
});
$p.VR = (function(x$1) {
  this.aeG = x$1;
});
$p.Nw = (function(x$1) {
  this.Th = x$1;
});
$p.akr = (function(x$0) {
  this.aeH = x$0;
});
$p.akq = (function(x$0) {
  this.aeF = x$0;
});
$p.eT = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKey__I__Lupickle_core_Visitor(this, index);
});
$p.bw = (function() {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__subVisitor__Lupickle_core_Visitor(this);
});
$p.eU = (function(v) {
  $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitKeyValue__O__V(this, v);
});
$p.L = (function(index) {
  return $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__visitEnd__I__O(this, index);
});
$p.bu = (function(v, index) {
  if ((this.mv !== (-1))) {
    var $x_2 = this.qt;
    var num = this.mv;
    var $x_3 = $x_2.a;
    var $x_4 = ((((num + (((num >> 5) >>> 26) | 0)) | 0) >> 6) << 1);
    var x_$_lo = $x_3[$x_4];
    var x_$_hi = $x_3[(($x_4 + 1) | 0)];
    var n = this.mv;
    var lo = (((32 & n) === 0) ? (1 << n) : 0);
    var hi = (((32 & n) === 0) ? 0 : (1 << n));
    var $x_1 = (((x_$_lo & lo) | (x_$_hi & hi)) === 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, this.mv, v);
    var num$1 = this.mv;
    var i$1 = (((num$1 + (((num$1 >> 5) >>> 26) | 0)) | 0) >> 6);
    var $x_7 = this.qt;
    var $x_5 = this.qt.a;
    var $x_6 = (i$1 << 1);
    var x$1_$_lo = $x_5[$x_6];
    var x$1_$_hi = $x_5[(($x_6 + 1) | 0)];
    var n$1 = this.mv;
    var lo$2 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$2 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var lo$3 = (x$1_$_lo | lo$2);
    var hi$3 = (x$1_$_hi | hi$2);
    var $x_8 = $x_7.a;
    var $x_9 = (i$1 << 1);
    $x_8[$x_9] = lo$3;
    $x_8[(($x_9 + 1) | 0)] = hi$3;
  } else if (this.Th) {
    $f_Lupickle_implicits_ReadersVersionSpecific$CaseClassReader3V3$ObjectContext__storeAggregatedValue__I__O__V(this, this.mv, v);
  }
});
$p.gf = (function() {
  return this.aeE;
});
var $d_Lupickle_implicits_ReadersVersionSpecific$$anon$2 = new $TypeData().i($c_Lupickle_implicits_ReadersVersionSpecific$$anon$2, "upickle.implicits.ReadersVersionSpecific$$anon$2", ({
  Ex: 1,
  DW: 1,
  DV: 1,
  Y: 1,
  aw: 1,
  je: 1,
  jf: 1,
  ji: 1
}));
/** @constructor */
function $c_Lcom_papasofokli_websocket_IsNotVisibleMessage$() {
}
$p = $c_Lcom_papasofokli_websocket_IsNotVisibleMessage$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_IsNotVisibleMessage$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_IsNotVisibleMessage$() {
}
$h_Lcom_papasofokli_websocket_IsNotVisibleMessage$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-262414146);
});
$p.g = (function() {
  return "IsNotVisibleMessage";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "IsNotVisibleMessage";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_websocket_IsNotVisibleMessage$ = new $TypeData().i($c_Lcom_papasofokli_websocket_IsNotVisibleMessage$, "com.papasofokli.websocket.IsNotVisibleMessage$", ({
  tf: 1,
  b1: 1,
  cm: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_websocket_IsNotVisibleMessage$;
function $m_Lcom_papasofokli_websocket_IsNotVisibleMessage$() {
  if ((!$n_Lcom_papasofokli_websocket_IsNotVisibleMessage$)) {
    $n_Lcom_papasofokli_websocket_IsNotVisibleMessage$ = new $c_Lcom_papasofokli_websocket_IsNotVisibleMessage$();
  }
  return $n_Lcom_papasofokli_websocket_IsNotVisibleMessage$;
}
/** @constructor */
function $c_Lcom_papasofokli_websocket_IsVisibleMessage$() {
}
$p = $c_Lcom_papasofokli_websocket_IsVisibleMessage$.prototype = new $h_O();
$p.constructor = $c_Lcom_papasofokli_websocket_IsVisibleMessage$;
/** @constructor */
function $h_Lcom_papasofokli_websocket_IsVisibleMessage$() {
}
$h_Lcom_papasofokli_websocket_IsVisibleMessage$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return (-1812369633);
});
$p.g = (function() {
  return "IsVisibleMessage";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "IsVisibleMessage";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcom_papasofokli_websocket_IsVisibleMessage$ = new $TypeData().i($c_Lcom_papasofokli_websocket_IsVisibleMessage$, "com.papasofokli.websocket.IsVisibleMessage$", ({
  tg: 1,
  b1: 1,
  cm: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lcom_papasofokli_websocket_IsVisibleMessage$;
function $m_Lcom_papasofokli_websocket_IsVisibleMessage$() {
  if ((!$n_Lcom_papasofokli_websocket_IsVisibleMessage$)) {
    $n_Lcom_papasofokli_websocket_IsVisibleMessage$ = new $c_Lcom_papasofokli_websocket_IsVisibleMessage$();
  }
  return $n_Lcom_papasofokli_websocket_IsVisibleMessage$;
}
/** @constructor */
function $c_sc_AbstractView() {
}
$p = $c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
}
$h_sc_AbstractView.prototype = $p;
$p.b4 = (function() {
  return $m_sc_View$();
});
$p.g = (function() {
  return $f_sc_View__toString__T(this);
});
$p.c8 = (function() {
  return "View";
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.RC = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.RC = outer;
}
$p = $c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
}
$h_sc_MapOps$$anon$1.prototype = $p;
$p.G = (function() {
  return this.RC.G();
});
$p.l = (function() {
  return this.RC.mP();
});
var $d_sc_MapOps$$anon$1 = new $TypeData().i($c_sc_MapOps$$anon$1, "scala.collection.MapOps$$anon$1", ({
  wR: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  a4: 1
}));
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  } else if ($is_sc_Set(that)) {
    if (($thiz.aH() === that.aH())) {
      try {
        return $thiz.Nx(that);
      } catch (e) {
        if (false) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.a6)));
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.a6)));
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $thiz;
  var it = that.l();
  while (it.f()) {
    result = result.kL(it.e());
  }
  return result;
}
function $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps($thiz, ord) {
  var len = $thiz.F();
  if ((len > 1)) {
    var arr = new $ac_O(len);
    var elem = 0;
    elem = 0;
    var it = $thiz.l();
    while (it.f()) {
      var x0 = it.e();
      arr.a[elem] = x0;
      elem = ((1 + elem) | 0);
    }
    $m_ju_Arrays$().zY(arr, ord);
    elem = 0;
    while ((elem < arr.a.length)) {
      $thiz.hQ(elem, arr.a[elem]);
      elem = ((1 + elem) | 0);
    }
  }
  return $thiz;
}
function $f_scm_IndexedSeqOps__sortInPlaceBy__F1__s_math_Ordering__scm_IndexedSeqOps($thiz, f, ord) {
  return $thiz.Jc(new $c_s_math_Ordering$$anon$1(f, ord));
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.qo = null;
  this.qo = "Any";
  $m_sci_Nil$();
}
$p = $c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $p;
$p.dK = (function() {
  return $d_O.l();
});
$p.fb = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$AnyManifest$, "scala.reflect.ManifestFactory$AnyManifest$", ({
  As: 1,
  ca: 1,
  c9: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$();
  }
  return $n_s_reflect_ManifestFactory$AnyManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.dF = null;
  this.dF = "Boolean";
}
$p = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$p.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$BooleanManifest$, "scala.reflect.ManifestFactory$BooleanManifest$", ({
  Au: 1,
  At: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$();
  }
  return $n_s_reflect_ManifestFactory$BooleanManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.dF = null;
  this.dF = "Byte";
}
$p = $c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ByteManifest$, "scala.reflect.ManifestFactory$ByteManifest$", ({
  Aw: 1,
  Av: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$();
  }
  return $n_s_reflect_ManifestFactory$ByteManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.dF = null;
  this.dF = "Char";
}
$p = $c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$p.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$CharManifest$, "scala.reflect.ManifestFactory$CharManifest$", ({
  Ay: 1,
  Ax: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$();
  }
  return $n_s_reflect_ManifestFactory$CharManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.dF = null;
  this.dF = "Double";
}
$p = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$p.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$DoubleManifest$, "scala.reflect.ManifestFactory$DoubleManifest$", ({
  AA: 1,
  Az: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$();
  }
  return $n_s_reflect_ManifestFactory$DoubleManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.dF = null;
  this.dF = "Float";
}
$p = $c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$p.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$FloatManifest$, "scala.reflect.ManifestFactory$FloatManifest$", ({
  AC: 1,
  AB: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$();
  }
  return $n_s_reflect_ManifestFactory$FloatManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.dF = null;
  this.dF = "Int";
}
$p = $c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$p.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$IntManifest$, "scala.reflect.ManifestFactory$IntManifest$", ({
  AE: 1,
  AD: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$();
  }
  return $n_s_reflect_ManifestFactory$IntManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.dF = null;
  this.dF = "Long";
}
$p = $c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$p.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$LongManifest$, "scala.reflect.ManifestFactory$LongManifest$", ({
  AG: 1,
  AF: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$();
  }
  return $n_s_reflect_ManifestFactory$LongManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.qo = null;
  this.qo = "Nothing";
  $m_sci_Nil$();
}
$p = $c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $p;
$p.dK = (function() {
  return $d_sr_Nothing$.l();
});
$p.fb = (function(len) {
  return new ($d_sr_Nothing$.r().C)(len);
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$NothingManifest$, "scala.reflect.ManifestFactory$NothingManifest$", ({
  AH: 1,
  ca: 1,
  c9: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$();
  }
  return $n_s_reflect_ManifestFactory$NothingManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.qo = null;
  this.qo = "Null";
  $m_sci_Nil$();
}
$p = $c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $p;
$p.dK = (function() {
  return $d_sr_Null$.l();
});
$p.fb = (function(len) {
  return new ($d_sr_Null$.r().C)(len);
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$NullManifest$, "scala.reflect.ManifestFactory$NullManifest$", ({
  AI: 1,
  ca: 1,
  c9: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$();
  }
  return $n_s_reflect_ManifestFactory$NullManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.qo = null;
  this.qo = "Object";
  $m_sci_Nil$();
}
$p = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $p;
$p.dK = (function() {
  return $d_O.l();
});
$p.fb = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ObjectManifest$, "scala.reflect.ManifestFactory$ObjectManifest$", ({
  AJ: 1,
  ca: 1,
  c9: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$();
  }
  return $n_s_reflect_ManifestFactory$ObjectManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.dF = null;
  this.dF = "Short";
}
$p = $c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$p.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$ShortManifest$, "scala.reflect.ManifestFactory$ShortManifest$", ({
  AL: 1,
  AK: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$();
  }
  return $n_s_reflect_ManifestFactory$ShortManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.dF = null;
  this.dF = "Unit";
}
$p = $c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$p.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $p;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().i($c_s_reflect_ManifestFactory$UnitManifest$, "scala.reflect.ManifestFactory$UnitManifest$", ({
  AN: 1,
  AM: 1,
  aS: 1,
  a: 1,
  ar: 1,
  aq: 1,
  b: 1,
  ah: 1,
  av: 1
}));
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$();
  }
  return $n_s_reflect_ManifestFactory$UnitManifest$;
}
function $f_Lupickle_implicits_Readers__$init$__V($thiz) {
  new $c_Lupickle_implicits_Readers$$anon$1($thiz);
  $thiz.bf = new $c_Lupickle_implicits_Readers$$anon$3($thiz);
  $thiz.op = new $c_Lupickle_implicits_Readers$$anon$4($thiz);
  $thiz.aT = new $c_Lupickle_implicits_Readers$$anon$5($thiz);
  $thiz.oq = new $c_Lupickle_implicits_Readers$$anon$6($thiz);
  $thiz.adO = new $c_Lupickle_implicits_Readers$$anon$7($thiz);
  $thiz.LU = new $c_Lupickle_implicits_Readers$$anon$8($thiz);
  $thiz.J = new $c_Lupickle_implicits_Readers$$anon$9($thiz);
  $thiz.adI = new $c_Lupickle_implicits_Readers$$anon$10($thiz);
  $thiz.aG = new $c_Lupickle_implicits_Readers$$anon$11($thiz);
  $thiz.bl = new $c_Lupickle_implicits_Readers$$anon$12($thiz);
  new $c_Lupickle_implicits_Readers$$anon$13($thiz);
  $thiz.Dw = new $c_Lupickle_implicits_Readers$$anon$14($thiz);
  new $c_Lupickle_implicits_Readers$$anon$15($thiz);
  $thiz.T3 = new $c_Lupickle_implicits_Readers$$anon$16($thiz);
  $thiz.T3.dv();
  $thiz.T3.dv();
  $thiz.uJ().uo($thiz.bf).ut();
  $thiz.uJ().uo($thiz.LU).ut();
  $thiz.uJ().uo($thiz.adI).ut();
  $thiz.uJ().uo($thiz.adO).ut();
  $thiz.uJ().uo($thiz.aT).ut();
  $thiz.uJ().uo($thiz.bl).ut();
  $thiz.uJ().uo($thiz.oq).ut();
  $thiz.uJ().uo($thiz.op).ut();
}
function $f_Lupickle_implicits_Readers__MapReader2__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($thiz, evidence$1, evidence$2) {
  return new $c_Lupickle_implicits_Readers$$anon$17(evidence$2, evidence$1, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((seq) => {
    var b = new $c_sci_MapBuilderImpl();
    seq.al(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => b.afx(_$2.P(), _$2.V()))));
    return b.Vi();
  })), $thiz);
}
function $f_Lupickle_implicits_Readers__OptionReader__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader($thiz, evidence$1) {
  return ($is_Lupickle_implicits_Readers$OptionReader(evidence$1) ? new $c_Lupickle_implicits_Readers$$anon$19(evidence$1, $thiz) : new $c_Lupickle_implicits_Readers$$anon$21(evidence$1, $thiz));
}
function $s_Lupickle_implicits_Readers__upickle$implicits$Readers$$_$$anon$superArg$1$1__Lupickle_core_Types$Reader__Lupickle_core_Types$Reader(evidence$1$1) {
  return new $c_Lupickle_core_Types$$anon$4(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => new $c_s_Some(_$8))), evidence$1$1);
}
/** @constructor */
function $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Kt = null;
  this.Kt = \u03b4name$2;
}
$p = $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1.prototype = new $h_Lcom_papasofokli_svg_components_HorizontalAnchor();
$p.constructor = $c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1;
/** @constructor */
function $h_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1() {
}
$h_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1.prototype = $p;
$p.w = (function() {
  return 0;
});
$p.z = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$p.A = (function() {
  return this.Kt;
});
$p.g = (function() {
  return this.Kt;
});
$p.r = (function() {
  return $f_T__hashCode__I(this.Kt);
});
var $d_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1 = new $TypeData().i($c_Lcom_papasofokli_svg_components_HorizontalAnchor$$anon$1, "com.papasofokli.svg.components.HorizontalAnchor$$anon$1", ({
  rS: 1,
  rQ: 1,
  b: 1,
  c: 1,
  a: 1,
  Ar: 1,
  AY: 1,
  v: 1,
  w: 1,
  a8: 1
}));
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Seq(o)) {
      if (o.zv($thiz)) {
        return $thiz.qM(o);
      }
    }
    return false;
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.I)));
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.I)));
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying_, len, ord) {
  $thiz.mg = len;
  $thiz.CM = ord;
  $thiz.GR = underlying_;
  $thiz.RK = false;
  return $thiz;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, underlying.F(), ord);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.mg = 0;
  this.CM = null;
  this.GR = null;
  this.RK = false;
  this.aaF = null;
  this.aaG = false;
}
$p = $c_sc_SeqView$Sorted.prototype = new $h_O();
$p.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
}
$h_sc_SeqView$Sorted.prototype = $p;
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fK = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$1) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$1);
});
$p.W = (function() {
  return this.l().e();
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.fu = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.mg;
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.dw = (function() {
  return $m_sc_View$().aP();
});
$p.eH = (function() {
  return "SeqView";
});
$p.b4 = (function() {
  return $m_sc_View$();
});
$p.g = (function() {
  return $f_sc_View__toString__T(this);
});
$p.Nm = (function() {
  if ((!this.aaG)) {
    var len = this.mg;
    if ((len === 0)) {
      var res = $m_sci_Nil$();
    } else if ((len === 1)) {
      $m_sci_List$();
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), [this.GR.W()]);
      var res = $m_sci_Nil$().aY(elems);
    } else {
      var arr = new $ac_O(len);
      this.GR.d0(arr, 0, 2147483647);
      $m_ju_Arrays$().zY(arr, this.CM);
      var res = $m_sci_ArraySeq$().ge(arr);
    }
    this.RK = true;
    this.GR = null;
    this.aaF = res;
    this.aaG = true;
  }
  return this.aaF;
});
$p.ajx = (function() {
  return (this.RK ? this.Nm() : this.GR);
});
$p.at = (function(i) {
  return this.Nm().at(i);
});
$p.F = (function() {
  return this.mg;
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ.kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Nm().l())));
});
$p.G = (function() {
  return this.mg;
});
$p.c = (function() {
  return (this.mg === 0);
});
$p.Vy = (function(ord1) {
  var x$2 = this.CM;
  if (((ord1 === null) ? (x$2 === null) : ord1.b(x$2))) {
    return this;
  } else {
    return (ord1.f9(this.CM) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.ajx(), this.mg, ord1));
  }
});
$p.eC = (function(ord) {
  return this.Vy(ord);
});
$p.X = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.aV = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.ba = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.bo = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.b8 = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.de = (function(coll) {
  return $m_sc_View$().MG(coll);
});
var $d_sc_SeqView$Sorted = new $TypeData().i($c_sc_SeqView$Sorted, "scala.collection.SeqView$Sorted", ({
  x4: 1,
  h: 1,
  i: 1,
  s: 1,
  y: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  Q: 1
}));
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.aaI)) {
    $thiz.aaH = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $thiz.mh.Nm());
    $thiz.aaI = true;
  }
  return $thiz.aaH;
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.aaH = null;
  this.aaI = false;
  this.mh = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.mh = outer;
}
$p = $c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$p.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $p;
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fK = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$1) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$1);
});
$p.W = (function() {
  return this.l().e();
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.fu = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.mh.l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.dw = (function() {
  return $m_sc_View$().aP();
});
$p.eH = (function() {
  return "SeqView";
});
$p.b4 = (function() {
  return $m_sc_View$();
});
$p.g = (function() {
  return $f_sc_View__toString__T(this);
});
$p.at = (function(i) {
  return $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).at(i);
});
$p.F = (function() {
  return this.mh.mg;
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ.kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).l())));
});
$p.G = (function() {
  return this.mh.mg;
});
$p.c = (function() {
  return (this.mh.mg === 0);
});
$p.Vy = (function(ord1) {
  var x$2 = this.mh.CM;
  if (((ord1 === null) ? (x$2 === null) : ord1.b(x$2))) {
    return this.mh;
  } else {
    return (ord1.f9(this.mh.CM) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.mh.ajx(), this.mh.mg, ord1));
  }
});
$p.eC = (function(ord) {
  return this.Vy(ord);
});
$p.X = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.aV = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.ba = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.bo = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.b8 = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.de = (function(coll) {
  return $m_sc_View$().MG(coll);
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().i($c_sc_SeqView$Sorted$ReverseSorted, "scala.collection.SeqView$Sorted$ReverseSorted", ({
  x5: 1,
  h: 1,
  i: 1,
  s: 1,
  y: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  Q: 1
}));
/** @constructor */
function $c_sc_View$$anon$1(it$3) {
  this.aaL = null;
  this.aaL = it$3;
}
$p = $c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
}
$h_sc_View$$anon$1.prototype = $p;
$p.l = (function() {
  return this.aaL.aA();
});
var $d_sc_View$$anon$1 = new $TypeData().i($c_sc_View$$anon$1, "scala.collection.View$$anon$1", ({
  xe: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem) {
  $thiz.CN = underlying;
  $thiz.GV = elem;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Appended() {
  this.CN = null;
  this.GV = null;
}
$p = $c_sc_View$Appended.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Appended;
/** @constructor */
function $h_sc_View$Appended() {
}
$h_sc_View$Appended.prototype = $p;
$p.l = (function() {
  return new $c_sc_View$Concat(this.CN, new $c_sc_View$Single(this.GV)).l();
});
$p.G = (function() {
  var size = this.CN.G();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$p.c = (function() {
  return false;
});
var $d_sc_View$Appended = new $TypeData().i($c_sc_View$Appended, "scala.collection.View$Appended", ({
  bW: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.aaN = null;
  this.aaM = null;
  this.aaN = underlying;
  this.aaM = pf;
}
$p = $c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
}
$h_sc_View$Collect.prototype = $p;
$p.l = (function() {
  var this$1 = this.aaN.l();
  return new $c_sc_Iterator$$anon$7(this.aaM, this$1);
});
var $d_sc_View$Collect = new $TypeData().i($c_sc_View$Collect, "scala.collection.View$Collect", ({
  xf: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.Lo = null;
  this.Lp = null;
  this.Lo = prefix;
  this.Lp = suffix;
}
$p = $c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
}
$h_sc_View$Concat.prototype = $p;
$p.l = (function() {
  return this.Lo.l().kH(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.Lp.l())));
});
$p.G = (function() {
  var prefixSize = this.Lo.G();
  if ((prefixSize >= 0)) {
    var suffixSize = this.Lp.G();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1));
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return (this.Lo.c() && this.Lp.c());
});
var $d_sc_View$Concat = new $TypeData().i($c_sc_View$Concat, "scala.collection.View$Concat", ({
  xg: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.Lq = null;
  this.aaO = null;
  this.Lq = underlying;
  this.aaO = f;
}
$p = $c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
}
$h_sc_View$DistinctBy.prototype = $p;
$p.l = (function() {
  var this$1 = this.Lq.l();
  return new $c_sc_Iterator$$anon$8(this.aaO, this$1);
});
$p.G = (function() {
  return ((this.Lq.G() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return this.Lq.c();
});
var $d_sc_View$DistinctBy = new $TypeData().i($c_sc_View$DistinctBy, "scala.collection.View$DistinctBy", ({
  xh: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.CO = underlying;
  $thiz.GW = n;
  $thiz.yk = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Drop() {
  this.CO = null;
  this.GW = 0;
  this.yk = 0;
}
$p = $c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
}
$h_sc_View$Drop.prototype = $p;
$p.l = (function() {
  return this.CO.l().ex(this.GW);
});
$p.G = (function() {
  var size = this.CO.G();
  if ((size >= 0)) {
    var x = ((size - this.yk) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return (!this.l().f());
});
var $d_sc_View$Drop = new $TypeData().i($c_sc_View$Drop, "scala.collection.View$Drop", ({
  bX: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.CP = underlying;
  $thiz.GX = n;
  $thiz.GY = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$DropRight() {
  this.CP = null;
  this.GX = 0;
  this.GY = 0;
}
$p = $c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
}
$h_sc_View$DropRight.prototype = $p;
$p.l = (function() {
  return $m_sc_View$().atu(this.CP.l(), this.GX);
});
$p.G = (function() {
  var size = this.CP.G();
  if ((size >= 0)) {
    var x = ((size - this.GY) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$p.c = (function() {
  return ((this.G() >= 0) ? (this.G() === 0) : (!this.l().f()));
});
var $d_sc_View$DropRight = new $TypeData().i($c_sc_View$DropRight, "scala.collection.View$DropRight", ({
  bY: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.RM = null;
  this.aaQ = null;
  this.aaP = false;
  this.RM = underlying;
  this.aaQ = p;
  this.aaP = isFlipped;
}
$p = $c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
}
$h_sc_View$Filter.prototype = $p;
$p.l = (function() {
  var this$1 = this.RM.l();
  return new $c_sc_Iterator$$anon$6(this.aaQ, this.aaP, this$1);
});
$p.G = (function() {
  return ((this.RM.G() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.l().f());
});
var $d_sc_View$Filter = new $TypeData().i($c_sc_View$Filter, "scala.collection.View$Filter", ({
  xk: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.RN = null;
  this.aaR = null;
  this.RN = underlying;
  this.aaR = f;
}
$p = $c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
}
$h_sc_View$FlatMap.prototype = $p;
$p.l = (function() {
  var this$1 = this.RN.l();
  return new $c_sc_Iterator$$anon$10(this.aaR, this$1);
});
$p.G = (function() {
  return ((this.RN.G() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.l().f());
});
var $d_sc_View$FlatMap = new $TypeData().i($c_sc_View$FlatMap, "scala.collection.View$FlatMap", ({
  xl: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.yl = underlying;
  $thiz.H0 = f;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Map() {
  this.yl = null;
  this.H0 = null;
}
$p = $c_sc_View$Map.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
}
$h_sc_View$Map.prototype = $p;
$p.l = (function() {
  var this$1 = this.yl.l();
  return new $c_sc_Iterator$$anon$9(this.H0, this$1);
});
$p.G = (function() {
  return this.yl.G();
});
$p.c = (function() {
  return this.yl.c();
});
var $d_sc_View$Map = new $TypeData().i($c_sc_View$Map, "scala.collection.View$Map", ({
  bZ: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying) {
  $thiz.H1 = elem;
  $thiz.CR = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Prepended() {
  this.H1 = null;
  this.CR = null;
}
$p = $c_sc_View$Prepended.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Prepended;
/** @constructor */
function $h_sc_View$Prepended() {
}
$h_sc_View$Prepended.prototype = $p;
$p.l = (function() {
  return new $c_sc_View$Concat(new $c_sc_View$Single(this.H1), this.CR).l();
});
$p.G = (function() {
  var size = this.CR.G();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$p.c = (function() {
  return false;
});
var $d_sc_View$Prepended = new $TypeData().i($c_sc_View$Prepended, "scala.collection.View$Prepended", ({
  c0: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$ScanLeft(underlying, z, op) {
  this.RO = null;
  this.aaT = null;
  this.aaS = null;
  this.RO = underlying;
  this.aaT = z;
  this.aaS = op;
}
$p = $c_sc_View$ScanLeft.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$ScanLeft;
/** @constructor */
function $h_sc_View$ScanLeft() {
}
$h_sc_View$ScanLeft.prototype = $p;
$p.l = (function() {
  var this$1 = this.RO.l();
  return new $c_sc_Iterator$$anon$3(this.aaT, this.aaS, this$1);
});
$p.G = (function() {
  var size = this.RO.G();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$p.c = (function() {
  return (!this.l().f());
});
var $d_sc_View$ScanLeft = new $TypeData().i($c_sc_View$ScanLeft, "scala.collection.View$ScanLeft", ({
  xm: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$Single(a) {
  this.aaU = null;
  this.aaU = a;
}
$p = $c_sc_View$Single.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Single;
/** @constructor */
function $h_sc_View$Single() {
}
$h_sc_View$Single.prototype = $p;
$p.l = (function() {
  return new $c_sc_Iterator$$anon$20(this.aaU);
});
$p.G = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
var $d_sc_View$Single = new $TypeData().i($c_sc_View$Single, "scala.collection.View$Single", ({
  xn: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.Ls = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Take() {
  this.Ls = 0;
}
$p = $c_sc_View$Take.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
}
$h_sc_View$Take.prototype = $p;
/** @constructor */
function $c_sc_View$Zip(underlying, other) {
  this.Lu = null;
  this.Lt = null;
  this.Lu = underlying;
  this.Lt = other;
}
$p = $c_sc_View$Zip.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Zip;
/** @constructor */
function $h_sc_View$Zip() {
}
$h_sc_View$Zip.prototype = $p;
$p.l = (function() {
  var this$1 = this.Lu.l();
  return new $c_sc_Iterator$$anon$14(this.Lt, this$1);
});
$p.G = (function() {
  var s1 = this.Lu.G();
  if ((s1 === 0)) {
    return 0;
  } else {
    var s2 = this.Lt.G();
    return ((s2 === 0) ? 0 : ((s1 < s2) ? s1 : s2));
  }
});
$p.c = (function() {
  return (this.Lu.c() || this.Lt.c());
});
var $d_sc_View$Zip = new $TypeData().i($c_sc_View$Zip, "scala.collection.View$Zip", ({
  xp: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.Lv = null;
  this.Lv = underlying;
}
$p = $c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
}
$h_sc_View$ZipWithIndex.prototype = $p;
$p.l = (function() {
  return new $c_sc_Iterator$$anon$16(this.Lv.l());
});
$p.G = (function() {
  return this.Lv.G();
});
$p.c = (function() {
  return this.Lv.c();
});
var $d_sc_View$ZipWithIndex = new $TypeData().i($c_sc_View$ZipWithIndex, "scala.collection.View$ZipWithIndex", ({
  xq: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1
}));
/** @constructor */
function $c_s_math_Numeric$FloatIsFractional$() {
}
$p = $c_s_math_Numeric$FloatIsFractional$.prototype = new $h_O();
$p.constructor = $c_s_math_Numeric$FloatIsFractional$;
/** @constructor */
function $h_s_math_Numeric$FloatIsFractional$() {
}
$h_s_math_Numeric$FloatIsFractional$.prototype = $p;
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  return $m_jl_Double$().zy(Math.fround(x), Math.fround(y));
});
$p.fR = (function(x, y) {
  return $f_s_math_Ordering$Float$IeeeOrdering__lteq__F__F__Z(this, Math.fround(x), Math.fround(y));
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering$Float$IeeeOrdering__gteq__F__F__Z(this, Math.fround(x), Math.fround(y));
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering$Float$IeeeOrdering__lt__F__F__Z(this, Math.fround(x), Math.fround(y));
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering$Float$IeeeOrdering__gt__F__F__Z(this, Math.fround(x), Math.fround(y));
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering$Float$IeeeOrdering__equiv__F__F__Z(this, Math.fround(x), Math.fround(y));
});
$p.eR = (function(x, y) {
  var x$1 = Math.fround(x);
  var y$1 = Math.fround(y);
  return Math.fround((+Math.max(x$1, y$1)));
});
$p.fr = (function(x, y) {
  var x$1 = Math.fround(x);
  var y$1 = Math.fround(y);
  return Math.fround((+Math.min(x$1, y$1)));
});
$p.Ni = (function(x, y) {
  return $f_s_math_Numeric$FloatIsFractional__plus__F__F__F(this, Math.fround(x), Math.fround(y));
});
$p.ID = (function(x) {
  return Math.fround(x);
});
$p.VG = (function(x) {
  return $doubleToInt(Math.fround(x));
});
var $d_s_math_Numeric$FloatIsFractional$ = new $TypeData().i($c_s_math_Numeric$FloatIsFractional$, "scala.math.Numeric$FloatIsFractional$", ({
  zX: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  ib: 1,
  zS: 1,
  zW: 1,
  Ae: 1
}));
var $n_s_math_Numeric$FloatIsFractional$;
function $m_s_math_Numeric$FloatIsFractional$() {
  if ((!$n_s_math_Numeric$FloatIsFractional$)) {
    $n_s_math_Numeric$FloatIsFractional$ = new $c_s_math_Numeric$FloatIsFractional$();
  }
  return $n_s_math_Numeric$FloatIsFractional$;
}
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
}
$p = $c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$p.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
}
$h_s_math_Numeric$IntIsIntegral$.prototype = $p;
$p.fR = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.fN = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.fQ = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.fm = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$p.fJ = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$p.eR = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.fr = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.f9 = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bM = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
$p.Ni = (function(x, y) {
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, (x | 0), (y | 0));
});
$p.ID = (function(x) {
  return x;
});
$p.VG = (function(x) {
  return (x | 0);
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().i($c_s_math_Numeric$IntIsIntegral$, "scala.math.Numeric$IntIsIntegral$", ({
  zZ: 1,
  W: 1,
  a: 1,
  a9: 1,
  ab: 1,
  aa: 1,
  ib: 1,
  zT: 1,
  zY: 1,
  ie: 1
}));
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$();
  }
  return $n_s_math_Numeric$IntIsIntegral$;
}
/** @constructor */
function $c_Lupack_Null$() {
}
$p = $c_Lupack_Null$.prototype = new $h_O();
$p.constructor = $c_Lupack_Null$;
/** @constructor */
function $h_Lupack_Null$() {
}
$h_Lupack_Null$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 2439591;
});
$p.g = (function() {
  return "Null";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Null";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_Null$ = new $TypeData().i($c_Lupack_Null$, "upack.Null$", ({
  CL: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lupack_Null$;
function $m_Lupack_Null$() {
  if ((!$n_Lupack_Null$)) {
    $n_Lupack_Null$ = new $c_Lupack_Null$();
  }
  return $n_Lupack_Null$;
}
function $f_Lupickle_implicits_Writers__$init$__V($thiz) {
  $thiz.m = new $c_Lupickle_implicits_Writers$$anon$1($thiz);
  new $c_Lupickle_implicits_Writers$$anon$2($thiz);
  $thiz.h8 = new $c_Lupickle_implicits_Writers$$anon$3($thiz);
  $thiz.ao = new $c_Lupickle_implicits_Writers$$anon$4($thiz);
  $thiz.g5 = new $c_Lupickle_implicits_Writers$$anon$5($thiz);
  $thiz.adP = new $c_Lupickle_implicits_Writers$$anon$6($thiz);
  $thiz.HX = new $c_Lupickle_implicits_Writers$$anon$7($thiz);
  $thiz.aw = new $c_Lupickle_implicits_Writers$$anon$8($thiz);
  $thiz.adJ = new $c_Lupickle_implicits_Writers$$anon$9($thiz);
  $thiz.a1 = new $c_Lupickle_implicits_Writers$$anon$10($thiz);
  $thiz.ay = new $c_Lupickle_implicits_Writers$$anon$11($thiz);
  new $c_Lupickle_implicits_Writers$$anon$12($thiz);
  $thiz.mu = new $c_Lupickle_implicits_Writers$$anon$13($thiz);
  new $c_Lupickle_implicits_Writers$$anon$14($thiz);
  $thiz.T4 = new $c_Lupickle_implicits_Writers$$anon$15($thiz);
  $thiz.T4.S();
  $thiz.T4.S();
  $thiz.uK().up($thiz.aw).uu();
  $thiz.uK().up($thiz.HX).uu();
  $thiz.uK().up($thiz.adJ).uu();
  $thiz.uK().up($thiz.adP).uu();
  $thiz.uK().up($thiz.ao).uu();
  $thiz.uK().up($thiz.ay).uu();
  $thiz.uK().up($thiz.g5).uu();
  $thiz.uK().up($thiz.h8).uu();
}
function $f_Lupickle_implicits_Writers__OptionWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($thiz, evidence$1) {
  return ($is_Lupickle_implicits_Writers$OptionWriter(evidence$1) ? new $c_Lupickle_implicits_Writers$$anon$16(evidence$1, $thiz) : new $c_Lupickle_implicits_Writers$$anon$17(evidence$1, $thiz));
}
function $f_Lupickle_implicits_Writers__ArrayWriter__Lupickle_core_Types$Writer__Lupickle_core_Types$Writer($thiz, r) {
  var x$2 = $thiz.HX;
  if (((r === null) ? (x$2 === null) : (r === x$2))) {
    return new $c_Lupickle_implicits_Writers$$anon$18($thiz);
  } else {
    return new $c_Lupickle_implicits_Writers$$anon$19(r, $thiz);
  }
}
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList) {
  this.KY = null;
  this.KY = domList;
}
$p = $c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListSeq;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListSeq() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = $p;
$p.G = (function() {
  return (-1);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.fK = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.W = (function() {
  return this.l().e();
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.fu = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.ak = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$p.X = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.dw = (function() {
  return $m_sc_Seq$().aP();
});
$p.eH = (function() {
  return "Seq";
});
$p.aJ = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.ba = (function(elem) {
  return $f_sc_SeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.cH = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this).l();
});
$p.Nu = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$p.Nv = (function() {
  return 0;
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.Ed = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.IV = (function(elem, end) {
  return $f_sc_SeqOps__lastIndexOf__O__I__I(this, elem, end);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.eC = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.qM = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.zv = (function(that) {
  return true;
});
$p.b = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().Nq(this);
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.F = (function() {
  return (this.KY.length | 0);
});
$p.at = (function(x) {
  return this.KY[x];
});
$p.l = (function() {
  return new $c_Lorg_scalajs_dom_DOMList$DOMListIterator(this.KY);
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
$p.b4 = (function() {
  return $m_sc_Seq$();
});
$p.aU = (function(x) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.de = (function(coll) {
  return $m_sc_Seq$().zH(coll);
});
$p.hK = (function(v1) {
  this.at(v1);
});
var $d_Lorg_scalajs_dom_DOMList$DOMListSeq = new $TypeData().i($c_Lorg_scalajs_dom_DOMList$DOMListSeq, "org.scalajs.dom.DOMList$DOMListSeq", ({
  vv: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1
}));
/** @constructor */
function $c_sc_AbstractSet() {
}
$p = $c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
}
$h_sc_AbstractSet.prototype = $p;
$p.hK = (function(x$0) {
  this.az(x$0);
});
$p.Nx = (function(that) {
  return this.g8(that);
});
$p.Mq = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that);
});
$p.b = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that);
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.Aa(this, this$1.Ho);
});
$p.b4 = (function() {
  return $m_sc_Set$();
});
$p.c8 = (function() {
  return "Set";
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.p = (function(v1) {
  return this.az(v1);
});
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else if ($is_sc_Map(o)) {
    if (($thiz.aH() === o.aH())) {
      try {
        return $thiz.g8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((map$1) => ((kv$2) => $m_sr_BoxesRunTime$().B(map$1.f6(kv$2.P(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sc_Map$().aax.aA()))), kv$2.V())))(o)));
      } catch (e) {
        if (false) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ax)));
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ax)));
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.LC = _fun;
  $thiz.Hj = _ec;
  $thiz.Hi = _arg;
  $thiz.Hk = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, ec, null, xform);
  return $thiz;
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  if ((false || $m_s_util_control_NonFatal$().DO(t))) {
    var completed = $thiz.A9($thiz.ci, $m_s_concurrent_impl_Promise$().J9(new $c_s_util_Failure(t)));
    if (((($thiz.Hk === 5) || ($thiz.Hk === 6)) || (!completed))) {
      e.Ve(t);
    }
  } else {
    var $x_1 = t;
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
  }
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ci = null;
  this.LC = null;
  this.Hj = null;
  this.Hi = null;
  this.Hk = 0;
}
$p = $c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$p.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $p;
$p.ak4 = (function(resolved) {
  this.Hi = resolved;
  var e = this.Hj;
  try {
    if ((e === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    e.Uc(this);
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
    this.LC = null;
    this.Hi = null;
    this.Hj = null;
    if ((e === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e);
  }
  return this;
});
$p.zV = (function() {
  var x$proxy4 = this.Hi;
  if ((x$proxy4 === null)) {
    $m_sr_Scala3RunTime$().bW();
  }
  var x$proxy5 = this.LC;
  if ((x$proxy5 === null)) {
    $m_sr_Scala3RunTime$().bW();
  }
  var x$proxy6 = this.Hj;
  if ((x$proxy6 === null)) {
    $m_sr_Scala3RunTime$().bW();
  }
  this.LC = null;
  this.Hi = null;
  this.Hj = null;
  try {
    var resolvedResult;
    switch (this.Hk) {
      case 0: {
        var resolvedResult = null;
        break;
      }
      case 1: {
        var resolvedResult = ((x$proxy4 instanceof $c_s_util_Success) ? new $c_s_util_Success(x$proxy5.p(x$proxy4.h())) : x$proxy4);
        break;
      }
      case 2: {
        if ((x$proxy4 instanceof $c_s_util_Success)) {
          var f = x$proxy5.p(x$proxy4.h());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            f.UX(this, null);
          } else {
            this.U0(f);
          }
          var resolvedResult = null;
        } else {
          var resolvedResult = x$proxy4;
        }
        break;
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().J9(x$proxy5.p(x$proxy4));
        break;
      }
      case 4: {
        var f$2 = x$proxy5.p(x$proxy4);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          f$2.UX(this, null);
        } else {
          this.U0(f$2);
        }
        var resolvedResult = null;
        break;
      }
      case 5: {
        x$proxy4.al(x$proxy5);
        var resolvedResult = null;
        break;
      }
      case 6: {
        x$proxy5.p(x$proxy4);
        var resolvedResult = null;
        break;
      }
      case 7: {
        var resolvedResult = ((x$proxy4 instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().J9(x$proxy4.ajj(x$proxy5)) : x$proxy4);
        break;
      }
      case 8: {
        if ((x$proxy4 instanceof $c_s_util_Failure)) {
          var f$3 = x$proxy5.aJ(x$proxy4.tJ, $m_s_concurrent_Future$().abs);
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().Sc) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? f$3.UX(this, null) : this.U0(f$3)), null) : x$proxy4);
        } else {
          var resolvedResult = x$proxy4;
        }
        break;
      }
      case 9: {
        var resolvedResult = (((x$proxy4 instanceof $c_s_util_Failure) || (!(!x$proxy5.p(x$proxy4.h())))) ? x$proxy4 : $m_s_concurrent_Future$().abr);
        break;
      }
      case 10: {
        var resolvedResult = ((x$proxy4 instanceof $c_s_util_Success) ? new $c_s_util_Success(x$proxy5.aJ(x$proxy4.h(), $m_s_concurrent_Future$().abp)) : x$proxy4);
        break;
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.Hk)));
      }
    }
    if ((resolvedResult !== null)) {
      this.A9(this.ci, resolvedResult);
    }
  } catch (e) {
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e)), x$proxy6);
  }
});
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i8)));
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().i($c_s_concurrent_impl_Promise$Transformation, "scala.concurrent.impl.Promise$Transformation", ({
  i8: 1,
  d0: 1,
  bT: 1,
  a: 1,
  i4: 1,
  i1: 1,
  i3: 1,
  p: 1,
  c8: 1,
  co: 1,
  zx: 1
}));
/** @constructor */
function $c_sr_RichLong(self_$_lo, self_$_hi) {
  this.g6 = 0;
  this.g7 = 0;
  this.g6 = self_$_lo;
  this.g7 = self_$_hi;
}
$p = $c_sr_RichLong.prototype = new $h_O();
$p.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
}
$h_sr_RichLong.prototype = $p;
$p.g = (function() {
  return $f_s_Proxy__toString__T(this);
});
$p.jl = (function(that) {
  var x_$_lo = this.g6;
  var x_$_hi = this.g7;
  var $x_1 = $uJ(that);
  var y_$_lo = $x_1.l;
  var y_$_hi = $x_1.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$p.oH = (function(y) {
  var x_$_lo = this.g6;
  var x_$_hi = this.g7;
  var $x_1 = $uJ(y);
  var y$1_$_lo = $x_1.l;
  var y$1_$_hi = $x_1.h;
  return ((x_$_hi === y$1_$_hi) ? ((x_$_lo === y$1_$_lo) ? 0 : (((x_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y$1_$_hi) ? (-1) : 1));
});
$p.r = (function() {
  var this$_$_lo = this.g6;
  var this$_$_hi = this.g7;
  return (this$_$_lo ^ this$_$_hi);
});
$p.b = (function(x$0) {
  return $m_sr_RichLong$().atx(this.g6, this.g7, x$0);
});
$p.qG = (function() {
  var this$_$_lo = this.g6;
  var this$_$_hi = this.g7;
  return ((4.294967296E9 * this$_$_hi) + (this$_$_lo >>> 0.0));
});
$p.E3 = (function() {
  var this$_$_lo = this.g6;
  var this$_$_hi = this.g7;
  var compressedLo = (((((-2097152) & (this$_$_hi ^ (this$_$_hi >> 10))) === 0) || ((65535 & this$_$_lo) === 0)) ? this$_$_lo : (32768 | ((-32768) & this$_$_lo)));
  return Math.fround(((4.294967296E9 * this$_$_hi) + (compressedLo >>> 0.0)));
});
$p.jw = (function() {
  return $bL(this.g6, this.g7);
});
$p.js = (function() {
  return $s_RTLong__toInt__I__I__I(this.g6, this.g7);
});
$p.TJ = (function() {
  return (($s_RTLong__toInt__I__I__I(this.g6, this.g7) << 24) >> 24);
});
$p.Vs = (function() {
  return (($s_RTLong__toInt__I__I__I(this.g6, this.g7) << 16) >> 16);
});
$p.UL = (function() {
  return $m_sr_RichLong$().avt(this.g6, this.g7);
});
$p.UN = (function() {
  return $m_sr_RichLong$().avy(this.g6, this.g7);
});
$p.UM = (function() {
  return $m_sr_RichLong$().avu(this.g6, this.g7);
});
$p.N1 = (function() {
  return $m_sr_RichLong$().avx(this.g6, this.g7);
});
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ij)));
}
var $d_sr_RichLong = new $TypeData().i($c_sr_RichLong, "scala.runtime.RichLong", ({
  ij: 1,
  d3: 1,
  w8: 1,
  w9: 1,
  N: 1,
  aY: 1,
  B7: 1,
  Bb: 1,
  Be: 1,
  B8: 1,
  B0: 1
}));
/** @constructor */
function $c_Lupack_False$() {
}
$p = $c_Lupack_False$.prototype = new $h_Lupack_Bool();
$p.constructor = $c_Lupack_False$;
/** @constructor */
function $h_Lupack_False$() {
}
$h_Lupack_False$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 67643651;
});
$p.g = (function() {
  return "False";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "False";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_False$ = new $TypeData().i($c_Lupack_False$, "upack.False$", ({
  CG: 1,
  iH: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lupack_False$;
function $m_Lupack_False$() {
  if ((!$n_Lupack_False$)) {
    $n_Lupack_False$ = new $c_Lupack_False$();
  }
  return $n_Lupack_False$;
}
/** @constructor */
function $c_Lupack_True$() {
}
$p = $c_Lupack_True$.prototype = new $h_Lupack_Bool();
$p.constructor = $c_Lupack_True$;
/** @constructor */
function $h_Lupack_True$() {
}
$h_Lupack_True$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 2615726;
});
$p.g = (function() {
  return "True";
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "True";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lupack_True$ = new $TypeData().i($c_Lupack_True$, "upack.True$", ({
  CM: 1,
  iH: 1,
  at: 1,
  ao: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1,
  v: 1,
  w: 1,
  a8: 1
}));
var $n_Lupack_True$;
function $m_Lupack_True$() {
  if ((!$n_Lupack_True$)) {
    $n_Lupack_True$ = new $c_Lupack_True$();
  }
  return $n_Lupack_True$;
}
/** @constructor */
function $c_Lupickle_core_Types$$anon$2(r1$2, w0$4, w1$2, outer) {
  this.SO = null;
  this.adr = null;
  this.ads = null;
  this.Du = null;
  this.SO = r1$2;
  this.adr = w0$4;
  this.ads = w1$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Du = outer;
}
$p = $c_Lupickle_core_Types$$anon$2.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_Types$$anon$2;
/** @constructor */
function $h_Lupickle_core_Types$$anon$2() {
}
$h_Lupickle_core_Types$$anon$2.prototype = $p;
$p.d3 = (function(s, arrOffset, arrLength, decIndex, expIndex, index) {
  return $f_Lupickle_core_Visitor__visitFloat64CharParts__AC__I__I__I__I__I__O(this, s, arrOffset, arrLength, decIndex, expIndex, index);
});
$p.O = (function(v, out) {
  return $f_Lupickle_core_Types$Writer__write__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.dv = (function() {
  return this;
});
$p.M = (function(index) {
  return null;
});
$p.ch = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitTrue__I__O(this, index);
});
$p.cg = (function(index) {
  return $f_Lupickle_core_SimpleVisitor__visitFalse__I__O(this, index);
});
$p.cu = (function(s, decIndex, expIndex, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64StringParts__jl_CharSequence__I__I__I__O(this, s, decIndex, expIndex, index);
});
$p.ct = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64__D__I__O(this, d, index);
});
$p.cs = (function(d, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat32__F__I__O(this, d, index);
});
$p.c9 = (function(i, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt32__I__I__O(this, i, index);
});
$p.cv = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cD = (function(i_$_lo, i_$_hi, index) {
  return $f_Lupickle_core_SimpleVisitor__visitUInt64__J__I__O(this, i_$_lo, i_$_hi, index);
});
$p.cL = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitFloat64String__T__I__O(this, s, index);
});
$p.cB = (function(s, index) {
  return $f_Lupickle_core_SimpleVisitor__visitChar__C__I__O(this, s, index);
});
$p.cr = (function(bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitBinary__AB__I__I__I__O(this, bytes, offset, len, index);
});
$p.cC = (function(tag, bytes, offset, len, index) {
  return $f_Lupickle_core_SimpleVisitor__visitExt__B__AB__I__I__I__O(this, tag, bytes, offset, len, index);
});
$p.bR = (function() {
  this.kW();
  return "expected dictionary";
});
$p.bx = (function(s, index) {
  return $f_Lupickle_core_Types$TaggedReader__visitString__jl_CharSequence__I__O(this, s, index);
});
$p.U = (function(out, v) {
  return $f_Lupickle_core_Types$TaggedWriter__write0__Lupickle_core_Visitor__O__O(this, out, v);
});
$p.bt = (function(length, index) {
  return $f_Lupickle_core_Types__taggedArrayContext__Lupickle_core_Types$TaggedReader__I__Lupickle_core_ArrVisitor(this.ako(), this, index);
});
$p.K = (function(length, jsonableKeys, index) {
  return new $c_Lupickle_AttributeTagged$$anon$6(this, index, this.ako());
});
$p.A0 = (function() {
  return this.SO.A0();
});
$p.Q = (function() {
  return this.adr.Q();
});
$p.f5 = (function(s) {
  return this.SO.f5(s);
});
$p.IB = (function(v) {
  return this.ads.IB(v);
});
$p.mO = (function() {
  return this.Du.oo;
});
$p.qR = (function() {
  return this.Du.oo;
});
$p.kW = (function() {
  return this.Du.oo;
});
$p.Jh = (function() {
  return this.Du.oo;
});
$p.ako = (function() {
  return this.Du.oo;
});
$p.dL = (function() {
  return this.mO();
});
$p.T = (function() {
  return this.qR();
});
$p.VP = (function() {
  return this.kW();
});
$p.NF = (function() {
  return this.Jh();
});
$p.S = (function() {
  return this;
});
var $d_Lupickle_core_Types$$anon$2 = new $TypeData().i($c_Lupickle_core_Types$$anon$2, "upickle.core.Types$$anon$2", ({
  Du: 1,
  d: 1,
  e: 1,
  j: 1,
  k: 1,
  jc: 1,
  f: 1,
  g: 1,
  bG: 1,
  bH: 1,
  DA: 1
}));
/** @constructor */
function $c_sc_AbstractSeq() {
}
$p = $c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
}
$h_sc_AbstractSeq.prototype = $p;
$p.hK = (function(x$0) {
  this.p(x$0);
});
$p.aJ = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.aV = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.cH = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.dt = (function(suffix) {
  return this.cH(suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.Nu = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$p.Nv = (function() {
  return 0;
});
$p.zM = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.Ed = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.IV = (function(elem, end) {
  return $f_sc_SeqOps__lastIndexOf__O__I__I(this, elem, end);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.eC = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.Ns = (function(otherSize) {
  return this.cp(otherSize);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.qM = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.zv = (function(that) {
  return true;
});
$p.b = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().Nq(this);
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.aU = (function(x) {
  return this.zM((x | 0));
});
/** @constructor */
function $c_sc_AbstractSeqView() {
}
$p = $c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
}
$h_sc_AbstractSeqView.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.L)));
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.L)));
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bo)));
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bo)));
}
function $is_sc_SeqMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.h1)));
}
function $isArrayOf_sc_SeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h1)));
}
/** @constructor */
function $c_sc_View$Empty$() {
}
$p = $c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
}
$h_sc_View$Empty$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return 67081517;
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Empty";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.G = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
var $d_sc_View$Empty$ = new $TypeData().i($c_sc_View$Empty$, "scala.collection.View$Empty$", ({
  xj: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  b: 1,
  c: 1
}));
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$();
  }
  return $n_sc_View$Empty$;
}
function $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator($thiz) {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator($thiz, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($thiz.En().aA() | 0))));
}
function $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator($thiz) {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator($thiz, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => ($thiz.En().aA() | 0))));
}
function $f_scm_SetOps__add__O__Z($thiz, elem) {
  return ((!$thiz.az(elem)) && ($thiz.aD(elem), true));
}
/** @constructor */
function $c_sc_AbstractMap() {
}
$p = $c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$p.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
}
$h_sc_AbstractMap.prototype = $p;
$p.hK = (function(x$0) {
  this.p(x$0);
});
$p.f6 = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.p = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aJ = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.N6 = (function() {
  return $f_sc_MapOps__keySet__sc_Set(this);
});
$p.jv = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.mP = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.jo = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$p.Ix = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.az = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aU = (function(key) {
  return this.az(key);
});
$p.gG = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.mF = (function(coll) {
  return this.uy().bp(coll);
});
$p.dw = (function() {
  return this.uy().aP();
});
$p.b = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().UZ(this);
});
$p.c8 = (function() {
  return "Map";
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.de = (function(coll) {
  return this.mF(coll);
});
$p.fu = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
function $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem) {
  $thiz.CK = underlying;
  $thiz.Lj = elem;
  $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Appended() {
  this.CN = null;
  this.GV = null;
  this.CK = null;
  this.Lj = null;
}
$p = $c_sc_SeqView$Appended.prototype = new $h_sc_View$Appended();
$p.constructor = $c_sc_SeqView$Appended;
/** @constructor */
function $h_sc_SeqView$Appended() {
}
$h_sc_SeqView$Appended.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.at = (function(idx) {
  return ((idx === this.CK.F()) ? this.Lj : this.CK.at(idx));
});
$p.F = (function() {
  return ((1 + this.CK.F()) | 0);
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
var $d_sc_SeqView$Appended = new $TypeData().i($c_sc_SeqView$Appended, "scala.collection.SeqView$Appended", ({
  cA: 1,
  bW: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.CL = underlying;
  $thiz.Lk = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.CO = null;
  this.GW = 0;
  this.yk = 0;
  this.CL = null;
  this.Lk = 0;
}
$p = $c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$p.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
}
$h_sc_SeqView$Drop.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.F = (function() {
  var x = ((this.CL.F() - this.yk) | 0);
  return ((x > 0) ? x : 0);
});
$p.at = (function(i) {
  return this.CL.at(((i + this.yk) | 0));
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.CL, ((this.Lk + n) | 0));
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
var $d_sc_SeqView$Drop = new $TypeData().i($c_sc_SeqView$Drop, "scala.collection.SeqView$Drop", ({
  cB: 1,
  bX: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.Ll = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var x = ((underlying.F() - ((n > 0) ? n : 0)) | 0);
  $thiz.yf = ((x > 0) ? x : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.CP = null;
  this.GX = 0;
  this.GY = 0;
  this.Ll = null;
  this.yf = 0;
}
$p = $c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$p.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
}
$h_sc_SeqView$DropRight.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.yf;
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.F = (function() {
  return this.yf;
});
$p.at = (function(i) {
  return this.Ll.at(i);
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
var $d_sc_SeqView$DropRight = new $TypeData().i($c_sc_SeqView$DropRight, "scala.collection.SeqView$DropRight", ({
  cC: 1,
  bY: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.yg = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.yg = null;
}
$p = $c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
}
$h_sc_SeqView$Id.prototype = $p;
$p.at = (function(idx) {
  return this.yg.at(idx);
});
$p.F = (function() {
  return this.yg.F();
});
$p.l = (function() {
  return this.yg.l();
});
$p.G = (function() {
  return this.yg.G();
});
$p.c = (function() {
  return this.yg.c();
});
var $d_sc_SeqView$Id = new $TypeData().i($c_sc_SeqView$Id, "scala.collection.SeqView$Id", ({
  h2: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.GP = underlying;
  $thiz.Lm = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.yl = null;
  this.H0 = null;
  this.GP = null;
  this.Lm = null;
}
$p = $c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$p.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
}
$h_sc_SeqView$Map.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.at = (function(idx) {
  return this.Lm.p(this.GP.at(idx));
});
$p.F = (function() {
  return this.GP.F();
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
var $d_sc_SeqView$Map = new $TypeData().i($c_sc_SeqView$Map, "scala.collection.SeqView$Map", ({
  cD: 1,
  bZ: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying) {
  $thiz.Ln = elem;
  $thiz.GQ = underlying;
  $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Prepended() {
  this.H1 = null;
  this.CR = null;
  this.Ln = null;
  this.GQ = null;
}
$p = $c_sc_SeqView$Prepended.prototype = new $h_sc_View$Prepended();
$p.constructor = $c_sc_SeqView$Prepended;
/** @constructor */
function $h_sc_SeqView$Prepended() {
}
$h_sc_SeqView$Prepended.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.bX = (function() {
  return this.eB().l();
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.l(), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.cp = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.ej = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$p.ec = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$p.el = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$p.ef = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$p.c8 = (function() {
  return "SeqView";
});
$p.at = (function(idx) {
  return ((idx === 0) ? this.Ln : this.GQ.at(((idx - 1) | 0)));
});
$p.F = (function() {
  return ((1 + this.GQ.F()) | 0);
});
$p.X = (function(f) {
  return this.ej(f);
});
$p.aV = (function(elem) {
  return this.ec(elem);
});
$p.ba = (function(elem) {
  return this.el(elem);
});
$p.bo = (function(n) {
  return this.ef(n);
});
$p.b8 = (function(n) {
  return this.eh(n);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
var $d_sc_SeqView$Prepended = new $TypeData().i($c_sc_SeqView$Prepended, "scala.collection.SeqView$Prepended", ({
  cE: 1,
  c0: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.yh = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.yh = null;
}
$p = $c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
}
$h_sc_SeqView$Reverse.prototype = $p;
$p.at = (function(i) {
  return this.yh.at(((((this.F() - 1) | 0) - i) | 0));
});
$p.F = (function() {
  return this.yh.F();
});
$p.l = (function() {
  return this.yh.bX();
});
$p.G = (function() {
  return this.yh.G();
});
$p.c = (function() {
  return this.yh.c();
});
var $d_sc_SeqView$Reverse = new $TypeData().i($c_sc_SeqView$Reverse, "scala.collection.SeqView$Reverse", ({
  h3: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1
}));
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.GS = underlying;
  $thiz.RL = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.Ls = 0;
  this.GS = null;
  this.RL = 0;
}
$p = $c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$p.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
}
$h_sc_SeqView$Take.prototype = $p;
$p.eS = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.eQ = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this), p, from);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.at = (function(idx) {
  if ((idx < this.RL)) {
    return this.GS.at(idx);
  } else {
    throw ((this.GS.G() >= 0) ? $m_scg_CommonErrors$().kM(idx, ((this.G() - 1) | 0)) : $m_scg_CommonErrors$().auQ(idx));
  }
});
$p.F = (function() {
  var x = this.GS.F();
  var that = this.Ls;
  return ((x < that) ? x : that);
});
$p.eC = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  }
  if ($is_sc_SortedSet(that)) {
    var x = that.oX();
    var x$2 = $thiz.oX();
    if (((x === null) ? (x$2 === null) : x.b(x$2))) {
      if (($thiz.aH() === that.aH())) {
        var i1 = $thiz.l();
        var i2 = that.l();
        var allEqual = true;
        while ((allEqual && i1.f())) {
          allEqual = $thiz.oX().fJ(i1.e(), i2.e());
        }
        return allEqual;
      } else {
        return false;
      }
    }
  }
  return $f_sc_Set__equals__O__Z($thiz, that);
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.b3)));
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.b3)));
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.R)));
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.R)));
}
var $d_sci_Seq = new $TypeData().i(1, "scala.collection.immutable.Seq", ({
  R: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  G: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  V: 1
}));
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  $thiz.aD(new $c_T2(key, value));
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, defaultValue) {
  var x12 = $thiz.b9(key);
  if ((x12 instanceof $c_s_Some)) {
    return x12.bg;
  }
  if (($m_s_None$() === x12)) {
    var d = defaultValue.aA();
    $thiz.Jf(key, d);
    return d;
  }
  throw new $c_s_MatchError(x12);
}
function $f_scm_MapOps__remove__O__s_Option($thiz, key) {
  var r = $thiz.b9(key);
  if ((!r.c())) {
    $thiz.ED(key);
  }
  return r;
}
function $f_scm_MapOps__clear__V($thiz) {
  var this$1 = $thiz.jv();
  while (this$1.f()) {
    $thiz.ED(this$1.e());
  }
}
function $is_scm_MapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bC)));
}
function $isArrayOf_scm_MapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bC)));
}
/** @constructor */
function $c_sc_AbstractMapView() {
}
$p = $c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$p.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
}
$h_sc_AbstractMapView.prototype = $p;
$p.hK = (function(x$0) {
  $f_sc_MapOps__apply__O__O(this, x$0);
});
$p.f6 = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.p = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aJ = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.jv = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.mP = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.Ix = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.az = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aU = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.gG = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.atP = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred);
});
$p.atR = (function(pred) {
  return new $c_sc_MapView$Filter(this, true, pred);
});
$p.g = (function() {
  return $f_sc_View__toString__T(this);
});
$p.c8 = (function() {
  return "MapView";
});
$p.bB = (function(pred) {
  return this.atP(pred);
});
$p.bC = (function(pred) {
  return this.atR(pred);
});
$p.fu = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
function $ct_sc_MapOps$LazyKeySet__sc_MapOps__($thiz, mp) {
  $thiz.ts = mp;
  return $thiz;
}
/** @constructor */
function $c_sc_MapOps$LazyKeySet() {
  this.ts = null;
}
$p = $c_sc_MapOps$LazyKeySet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_sc_MapOps$LazyKeySet;
/** @constructor */
function $h_sc_MapOps$LazyKeySet() {
}
$h_sc_MapOps$LazyKeySet.prototype = $p;
$p.l = (function() {
  return this.ts.jv();
});
$p.az = (function(key) {
  return this.ts.az(key);
});
$p.aH = (function() {
  return this.ts.aH();
});
$p.G = (function() {
  return this.ts.G();
});
$p.c = (function() {
  return this.ts.c();
});
var $d_sc_MapOps$LazyKeySet = new $TypeData().i($c_sc_MapOps$LazyKeySet, "scala.collection.MapOps$LazyKeySet", ({
  cy: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sc_MapOps$StrictKeySet(mp) {
  this.CJ = null;
  this.CJ = new $c_sc_IterableFactory$ToFactory($m_scm_LinkedHashSet$()).de(mp.jv());
}
$p = $c_sc_MapOps$StrictKeySet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_sc_MapOps$StrictKeySet;
/** @constructor */
function $h_sc_MapOps$StrictKeySet() {
}
$h_sc_MapOps$StrictKeySet.prototype = $p;
$p.l = (function() {
  return new $c_scm_LinkedHashSet$$anon$1(this.CJ);
});
$p.az = (function(key) {
  return this.CJ.az(key);
});
$p.aH = (function() {
  return this.CJ.jc;
});
$p.G = (function() {
  return this.CJ.jc;
});
$p.c = (function() {
  return this.CJ.c();
});
var $d_sc_MapOps$StrictKeySet = new $TypeData().i($c_sc_MapOps$StrictKeySet, "scala.collection.MapOps$StrictKeySet", ({
  wU: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a: 1,
  a4: 1
}));
function $f_sci_Map__withDefaultValue__O__sci_Map($thiz, d) {
  return new $c_sci_Map$WithDefault($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => d)));
}
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.aQ)));
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aQ)));
}
function $f_Lupickle_MsgReadWriters__$init$__V($thiz) {
  $ct_Lupickle_core_Types$Reader$Delegate__Lupickle_core_Types$Reader$__Lupickle_core_Visitor__(new $c_Lupickle_core_Types$Reader$Delegate(), $thiz.hJ(), $m_Lupack_Msg$());
  new $c_Lupickle_MsgReadWriters$$anon$1($thiz);
}
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
}
$p = $c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$p.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
}
$h_sc_AbstractIndexedSeqView.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.be)));
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.be)));
}
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.Li = null;
  this.RF = false;
  this.RG = null;
  this.Li = underlying;
  this.RF = isFlipped;
  this.RG = p;
}
$p = $c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
}
$h_sc_MapView$Filter.prototype = $p;
$p.l = (function() {
  var this$1 = this.Li.l();
  return new $c_sc_Iterator$$anon$6(this.RG, this.RF, this$1);
});
$p.b9 = (function(key) {
  var x4 = this.Li.b9(key);
  if ((x4 instanceof $c_s_Some)) {
    var v = x4.bg;
    if (((!(!this.RG.p(new $c_T2(key, v)))) !== this.RF)) {
      return x4;
    }
  }
  return $m_s_None$();
});
$p.G = (function() {
  return ((this.Li.G() === 0) ? 0 : (-1));
});
$p.c = (function() {
  return (!this.l().f());
});
var $d_sc_MapView$Filter = new $TypeData().i($c_sc_MapView$Filter, "scala.collection.MapView$Filter", ({
  wW: 1,
  cv: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  p: 1,
  t: 1,
  au: 1,
  cz: 1
}));
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.GM = null;
  this.GM = underlying;
}
$p = $c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
}
$h_sc_MapView$Id.prototype = $p;
$p.b9 = (function(key) {
  return this.GM.b9(key);
});
$p.l = (function() {
  return this.GM.l();
});
$p.G = (function() {
  return this.GM.G();
});
$p.c = (function() {
  return this.GM.c();
});
var $d_sc_MapView$Id = new $TypeData().i($c_sc_MapView$Id, "scala.collection.MapView$Id", ({
  wX: 1,
  cv: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  p: 1,
  t: 1,
  au: 1,
  cz: 1
}));
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.GN = null;
  this.RH = null;
  this.GN = underlying;
  this.RH = f;
}
$p = $c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$p.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
}
$h_sc_MapView$MapValues.prototype = $p;
$p.l = (function() {
  return new $c_sc_Iterator$$anon$9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2) => new $c_T2(kv$2.P(), this.RH.p(kv$2.V())))), this.GN.l());
});
$p.b9 = (function(key) {
  var this$1 = this.GN.b9(key);
  var f = this.RH;
  return (this$1.c() ? $m_s_None$() : new $c_s_Some(f.p(this$1.h())));
});
$p.G = (function() {
  return this.GN.G();
});
$p.c = (function() {
  return this.GN.c();
});
var $d_sc_MapView$MapValues = new $TypeData().i($c_sc_MapView$MapValues, "scala.collection.MapView$MapValues", ({
  wY: 1,
  cv: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  p: 1,
  t: 1,
  au: 1,
  cz: 1
}));
function $is_sc_SortedMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.h4)));
}
function $isArrayOf_sc_SortedMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h4)));
}
/** @constructor */
function $c_sci_AbstractSet() {
}
$p = $c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
}
$h_sci_AbstractSet.prototype = $p;
$p.b4 = (function() {
  return $m_sci_Set$();
});
function $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__($thiz, underlying, elem) {
  $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Appended() {
  this.CN = null;
  this.GV = null;
  this.CK = null;
  this.Lj = null;
}
$p = $c_sc_IndexedSeqView$Appended.prototype = new $h_sc_SeqView$Appended();
$p.constructor = $c_sc_IndexedSeqView$Appended;
/** @constructor */
function $h_sc_IndexedSeqView$Appended() {
}
$h_sc_IndexedSeqView$Appended.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_sc_IndexedSeqView$Appended = new $TypeData().i($c_sc_IndexedSeqView$Appended, "scala.collection.IndexedSeqView$Appended", ({
  gS: 1,
  cA: 1,
  bW: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.CO = null;
  this.GW = 0;
  this.yk = 0;
  this.CL = null;
  this.Lk = 0;
}
$p = $c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$p.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
}
$h_sc_IndexedSeqView$Drop.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().i($c_sc_IndexedSeqView$Drop, "scala.collection.IndexedSeqView$Drop", ({
  gT: 1,
  cB: 1,
  bX: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.CP = null;
  this.GX = 0;
  this.GY = 0;
  this.Ll = null;
  this.yf = 0;
}
$p = $c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$p.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
}
$h_sc_IndexedSeqView$DropRight.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.yf;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.yf;
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().i($c_sc_IndexedSeqView$DropRight, "scala.collection.IndexedSeqView$DropRight", ({
  gU: 1,
  cC: 1,
  bY: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.yg = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying);
}
$p = $c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$p.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
}
$h_sc_IndexedSeqView$Id.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.aV = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ba = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.el = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.bo = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.ef = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.b8 = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.X = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.ej = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
var $d_sc_IndexedSeqView$Id = new $TypeData().i($c_sc_IndexedSeqView$Id, "scala.collection.IndexedSeqView$Id", ({
  wq: 1,
  h2: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.yl = null;
  this.H0 = null;
  this.GP = null;
  this.Lm = null;
}
$p = $c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$p.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
}
$h_sc_IndexedSeqView$Map.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_sc_IndexedSeqView$Map = new $TypeData().i($c_sc_IndexedSeqView$Map, "scala.collection.IndexedSeqView$Map", ({
  gX: 1,
  cD: 1,
  bZ: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
function $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__($thiz, elem, underlying) {
  $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Prepended() {
  this.H1 = null;
  this.CR = null;
  this.Ln = null;
  this.GQ = null;
}
$p = $c_sc_IndexedSeqView$Prepended.prototype = new $h_sc_SeqView$Prepended();
$p.constructor = $c_sc_IndexedSeqView$Prepended;
/** @constructor */
function $h_sc_IndexedSeqView$Prepended() {
}
$h_sc_IndexedSeqView$Prepended.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.eb = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ek = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.ee = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.eg = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.ei = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_sc_IndexedSeqView$Prepended = new $TypeData().i($c_sc_IndexedSeqView$Prepended, "scala.collection.IndexedSeqView$Prepended", ({
  gY: 1,
  cE: 1,
  c0: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Reverse(underlying) {
  this.yh = null;
  $ct_sc_SeqView$Reverse__sc_SeqOps__(this, underlying);
}
$p = $c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$p.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
}
$h_sc_IndexedSeqView$Reverse.prototype = $p;
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.ec = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.aV = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ba = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.el = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.bo = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.ef = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.b8 = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.eh = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.X = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$p.ej = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().i($c_sc_IndexedSeqView$Reverse, "scala.collection.IndexedSeqView$Reverse", ({
  wr: 1,
  h3: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Take(underlying, n) {
  this.Ls = 0;
  this.GS = null;
  this.RL = 0;
  $ct_sc_SeqView$Take__sc_SeqOps__I__(this, underlying, n);
}
$p = $c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$p.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
}
$h_sc_IndexedSeqView$Take.prototype = $p;
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$p.c8 = (function() {
  return "IndexedSeqView";
});
$p.aV = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$p.ba = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$p.bo = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$p.b8 = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$p.X = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
var $d_sc_IndexedSeqView$Take = new $TypeData().i($c_sc_IndexedSeqView$Take, "scala.collection.IndexedSeqView$Take", ({
  ws: 1,
  x6: 1,
  xo: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_SeqOps$$anon$1(n1$1, n0$1, iso$1) {
  this.aay = null;
  this.aaA = 0;
  this.aaz = 0;
  this.aay = iso$1;
  this.aaA = n0$1;
  this.aaz = ((n1$1 - n0$1) | 0);
}
$p = $c_sc_SeqOps$$anon$1.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_SeqOps$$anon$1;
/** @constructor */
function $h_sc_SeqOps$$anon$1() {
}
$h_sc_SeqOps$$anon$1.prototype = $p;
$p.F = (function() {
  return this.aaz;
});
$p.at = (function(x) {
  return this.aay.at(((this.aaA + x) | 0));
});
var $d_sc_SeqOps$$anon$1 = new $TypeData().i($c_sc_SeqOps$$anon$1, "scala.collection.SeqOps$$anon$1", ({
  x1: 1,
  bm: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_SeqOps$$anon$2(n1$4, n0$5, iso$4) {
  this.RI = 0;
  this.aaC = 0;
  this.aaB = null;
  this.RI = n1$4;
  this.aaC = n0$5;
  this.aaB = iso$4;
}
$p = $c_sc_SeqOps$$anon$2.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_SeqOps$$anon$2;
/** @constructor */
function $h_sc_SeqOps$$anon$2() {
}
$h_sc_SeqOps$$anon$2.prototype = $p;
$p.F = (function() {
  return ((this.RI - this.aaC) | 0);
});
$p.at = (function(x) {
  return this.aaB.at(((((this.RI - 1) | 0) - x) | 0));
});
var $d_sc_SeqOps$$anon$2 = new $TypeData().i($c_sc_SeqOps$$anon$2, "scala.collection.SeqOps$$anon$2", ({
  x2: 1,
  bm: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sc_SeqOps$$anon$3(n1$3, n0$4, forward$1, W$1) {
  this.RJ = null;
  this.aaE = null;
  this.GO = 0;
  this.aaD = 0;
  this.RJ = new $ac_O(((n1$3 - n0$4) | 0));
  var delta = (forward$1 ? 1 : (-1));
  var done = (forward$1 ? ((n1$3 - n0$4) | 0) : (-1));
  this.aaE = W$1.l().ex(n0$4);
  this.GO = (forward$1 ? 0 : ((((n1$3 - n0$4) | 0) - 1) | 0));
  while ((this.GO !== done)) {
    this.RJ.a[this.GO] = this.aaE.e();
    this.GO = ((this.GO + delta) | 0);
  }
  this.aaD = ((n1$3 - n0$4) | 0);
}
$p = $c_sc_SeqOps$$anon$3.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_SeqOps$$anon$3;
/** @constructor */
function $h_sc_SeqOps$$anon$3() {
}
$h_sc_SeqOps$$anon$3.prototype = $p;
$p.F = (function() {
  return this.aaD;
});
$p.at = (function(x) {
  return this.RJ.a[x];
});
var $d_sc_SeqOps$$anon$3 = new $TypeData().i($c_sc_SeqOps$$anon$3, "scala.collection.SeqOps$$anon$3", ({
  x3: 1,
  bm: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sci_AbstractSeq() {
}
$p = $c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$p.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
}
$h_sci_AbstractSeq.prototype = $p;
$p.cf = (function() {
  return this;
});
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.RZ = null;
  this.tC = null;
  this.RZ = underlying;
  this.tC = mutationCount;
}
$p = $c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
}
$h_scm_ArrayBufferView.prototype = $p;
$p.at = (function(n) {
  return this.RZ.at(n);
});
$p.F = (function() {
  return this.RZ.dh;
});
$p.eH = (function() {
  return "ArrayBufferView";
});
$p.l = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.tC);
});
$p.bX = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.tC);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.tC);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.tC);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.tC);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.tC);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.tC);
});
$p.ec = (function(elem) {
  return this.eb(elem);
});
$p.aV = (function(elem) {
  return this.eb(elem);
});
$p.ba = (function(elem) {
  return this.ek(elem);
});
$p.el = (function(elem) {
  return this.ek(elem);
});
$p.bo = (function(n) {
  return this.ee(n);
});
$p.ef = (function(n) {
  return this.ee(n);
});
$p.b8 = (function(n) {
  return this.eg(n);
});
$p.eh = (function(n) {
  return this.eg(n);
});
$p.X = (function(f) {
  return this.ei(f);
});
$p.ej = (function(f) {
  return this.ei(f);
});
var $d_scm_ArrayBufferView = new $TypeData().i($c_scm_ArrayBufferView, "scala.collection.mutable.ArrayBufferView", ({
  yK: 1,
  bm: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1
}));
/** @constructor */
function $c_sci_AbstractMap() {
}
$p = $c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$p.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
}
$h_sci_AbstractMap.prototype = $p;
$p.b4 = (function() {
  return $m_sci_Iterable$();
});
$p.zQ = (function() {
  return $ct_sci_MapOps$LazyImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$LazyImmutableKeySet(), this);
});
$p.uy = (function() {
  return $m_sci_Map$();
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.N6 = (function() {
  return this.zQ();
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  return ($is_sci_IndexedSeq(that) ? ($thiz.F() === that.F()) : true);
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    if (($thiz === o)) {
      return true;
    } else {
      var length = $thiz.F();
      var equal = (length === o.F());
      if (equal) {
        var index = 0;
        var a = $thiz.DP();
        var b = o.DP();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? ((length >>> 0) > (lo >>> 0)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength;
        } else {
          var maxApplyCompare = length;
        }
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().B($thiz.at(index), o.at(index));
          index = ((1 + index) | 0);
        }
        if (((index < length) && equal)) {
          var thisIt = $thiz.l().ex(index);
          var thatIt = o.l().ex(index);
          while ((equal && thisIt.f())) {
            equal = $m_sr_BoxesRunTime$().B(thisIt.e(), thatIt.e());
          }
        }
      }
      return equal;
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o);
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.a0)));
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.a0)));
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
}
$p = $c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
}
$h_sci_Set$EmptySet$.prototype = $p;
$p.aH = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.G = (function() {
  return 0;
});
$p.Nx = (function(that) {
  return true;
});
$p.az = (function(elem) {
  return false;
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.al = (function(f) {
});
$p.bB = (function(pred) {
  return this;
});
$p.bC = (function(pred) {
  return this;
});
$p.kL = (function(elem) {
  return new $c_sci_Set$Set1(elem);
});
var $d_sci_Set$EmptySet$ = new $TypeData().i($c_sci_Set$EmptySet$, "scala.collection.immutable.Set$EmptySet$", ({
  yp: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  a: 1
}));
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$();
  }
  return $n_sci_Set$EmptySet$;
}
/** @constructor */
function $c_sc_StringView(s) {
  this.yj = null;
  this.yj = s;
}
$p = $c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$p.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
}
$h_sc_StringView.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().au(this, (-351294208), true);
});
$p.b = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_sc_StringView) && (this.yj === x$0.yj)));
});
$p.w = (function() {
  return 1;
});
$p.A = (function() {
  return "StringView";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.yj;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.F = (function() {
  return this.yj.length;
});
$p.g = (function() {
  return (("StringView(" + this.yj) + ")");
});
$p.at = (function(i) {
  return $bC(this.yj.charCodeAt(i));
});
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h8)));
}
var $d_sc_StringView = new $TypeData().i($c_sc_StringView, "scala.collection.StringView", ({
  h8: 1,
  bm: 1,
  aP: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  b: 1,
  c: 1
}));
function $ct_sci_MapOps$LazyImmutableKeySet__sci_MapOps__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.RS = outer;
  $ct_sc_MapOps$LazyKeySet__sc_MapOps__($thiz, outer);
  return $thiz;
}
/** @constructor */
function $c_sci_MapOps$LazyImmutableKeySet() {
  this.ts = null;
  this.RS = null;
}
$p = $c_sci_MapOps$LazyImmutableKeySet.prototype = new $h_sc_MapOps$LazyKeySet();
$p.constructor = $c_sci_MapOps$LazyImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$LazyImmutableKeySet() {
}
$h_sci_MapOps$LazyImmutableKeySet.prototype = $p;
$p.b4 = (function() {
  return $m_sci_Set$();
});
$p.mG = (function(elem) {
  return (this.az(elem) ? this : this.RS.hk(elem, (void 0)).zQ());
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
function $isArrayOf_sci_MapOps$LazyImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cN)));
}
var $d_sci_MapOps$LazyImmutableKeySet = new $TypeData().i($c_sci_MapOps$LazyImmutableKeySet, "scala.collection.immutable.MapOps$LazyImmutableKeySet", ({
  cN: 1,
  cy: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a: 1,
  a4: 1,
  G: 1,
  az: 1,
  ay: 1
}));
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.yk)));
}
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.yl)));
}
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ym)));
}
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.yn)));
}
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.tz = null;
  this.tz = elem1;
}
$p = $c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
}
$h_sci_Set$Set1.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mD(pred, false);
});
$p.bC = (function(pred) {
  return this.mD(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
$p.G = (function() {
  return 1;
});
$p.az = (function(elem) {
  return $m_sr_BoxesRunTime$().B(elem, this.tz);
});
$p.mG = (function(elem) {
  return (this.az(elem) ? this : new $c_sci_Set$Set2(this.tz, elem));
});
$p.l = (function() {
  return new $c_sc_Iterator$$anon$20(this.tz);
});
$p.al = (function(f) {
  f.p(this.tz);
});
$p.g8 = (function(p) {
  return (!(!p.p(this.tz)));
});
$p.mD = (function(pred, isFlipped) {
  return (((!(!pred.p(this.tz))) !== isFlipped) ? this : $m_sci_Set$EmptySet$());
});
$p.W = (function() {
  return this.tz;
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hx)));
}
var $d_sci_Set$Set1 = new $TypeData().i($c_sci_Set$Set1, "scala.collection.immutable.Set$Set1", ({
  hx: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.qc = null;
  this.tA = null;
  this.qc = elem1;
  this.tA = elem2;
}
$p = $c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
}
$h_sci_Set$Set2.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mD(pred, false);
});
$p.bC = (function(pred) {
  return this.mD(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 2;
});
$p.c = (function() {
  return false;
});
$p.G = (function() {
  return 2;
});
$p.az = (function(elem) {
  return ($m_sr_BoxesRunTime$().B(elem, this.qc) || $m_sr_BoxesRunTime$().B(elem, this.tA));
});
$p.mG = (function(elem) {
  return (this.az(elem) ? this : new $c_sci_Set$Set3(this.qc, this.tA, elem));
});
$p.l = (function() {
  return new $c_sci_Set$Set2$$anon$1(this);
});
$p.axD = (function(i) {
  if ((i === 0)) {
    return this.qc;
  }
  if ((i === 1)) {
    return this.tA;
  }
  throw new $c_s_MatchError(i);
});
$p.al = (function(f) {
  f.p(this.qc);
  f.p(this.tA);
});
$p.g8 = (function(p) {
  return ((!(!p.p(this.qc))) && (!(!p.p(this.tA))));
});
$p.mD = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (((!(!pred.p(this.qc))) !== isFlipped)) {
    r1 = this.qc;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.tA))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.tA;
    }
    n = ((1 + n) | 0);
  }
  var x11 = n;
  switch (x11) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x11);
    }
  }
});
$p.W = (function() {
  return this.qc;
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hy)));
}
var $d_sci_Set$Set2 = new $TypeData().i($c_sci_Set$Set2, "scala.collection.immutable.Set$Set2", ({
  hy: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.qd = null;
  this.qe = null;
  this.qf = null;
  this.qd = elem1;
  this.qe = elem2;
  this.qf = elem3;
}
$p = $c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
}
$h_sci_Set$Set3.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mD(pred, false);
});
$p.bC = (function(pred) {
  return this.mD(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 3;
});
$p.c = (function() {
  return false;
});
$p.G = (function() {
  return 3;
});
$p.az = (function(elem) {
  return (($m_sr_BoxesRunTime$().B(elem, this.qd) || $m_sr_BoxesRunTime$().B(elem, this.qe)) || $m_sr_BoxesRunTime$().B(elem, this.qf));
});
$p.mG = (function(elem) {
  return (this.az(elem) ? this : new $c_sci_Set$Set4(this.qd, this.qe, this.qf, elem));
});
$p.l = (function() {
  return new $c_sci_Set$Set3$$anon$2(this);
});
$p.axE = (function(i) {
  switch (i) {
    case 0: {
      return this.qd;
      break;
    }
    case 1: {
      return this.qe;
      break;
    }
    case 2: {
      return this.qf;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$p.al = (function(f) {
  f.p(this.qd);
  f.p(this.qe);
  f.p(this.qf);
});
$p.g8 = (function(p) {
  return (((!(!p.p(this.qd))) && (!(!p.p(this.qe)))) && (!(!p.p(this.qf))));
});
$p.mD = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (((!(!pred.p(this.qd))) !== isFlipped)) {
    r1 = this.qd;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.qe))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.qe;
    } else {
      r2 = this.qe;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.qf))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.qf;
    } else if ((n === 1)) {
      r2 = this.qf;
    }
    n = ((1 + n) | 0);
  }
  var x13 = n;
  switch (x13) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x13);
    }
  }
});
$p.W = (function() {
  return this.qd;
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hz)));
}
var $d_sci_Set$Set3 = new $TypeData().i($c_sci_Set$Set3, "scala.collection.immutable.Set$Set3", ({
  hz: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.od = null;
  this.oe = null;
  this.mm = null;
  this.mn = null;
  this.od = elem1;
  this.oe = elem2;
  this.mm = elem3;
  this.mn = elem4;
}
$p = $c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
}
$h_sci_Set$Set4.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mD(pred, false);
});
$p.bC = (function(pred) {
  return this.mD(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 4;
});
$p.c = (function() {
  return false;
});
$p.G = (function() {
  return 4;
});
$p.az = (function(elem) {
  return ((($m_sr_BoxesRunTime$().B(elem, this.od) || $m_sr_BoxesRunTime$().B(elem, this.oe)) || $m_sr_BoxesRunTime$().B(elem, this.mm)) || $m_sr_BoxesRunTime$().B(elem, this.mn));
});
$p.mG = (function(elem) {
  return (this.az(elem) ? this : $m_sci_HashSet$().CV.Ec(this.od).Ec(this.oe).Ec(this.mm).Ec(this.mn).Ec(elem));
});
$p.l = (function() {
  return new $c_sci_Set$Set4$$anon$3(this);
});
$p.axF = (function(i) {
  switch (i) {
    case 0: {
      return this.od;
      break;
    }
    case 1: {
      return this.oe;
      break;
    }
    case 2: {
      return this.mm;
      break;
    }
    case 3: {
      return this.mn;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$p.al = (function(f) {
  f.p(this.od);
  f.p(this.oe);
  f.p(this.mm);
  f.p(this.mn);
});
$p.g8 = (function(p) {
  return ((((!(!p.p(this.od))) && (!(!p.p(this.oe)))) && (!(!p.p(this.mm)))) && (!(!p.p(this.mn))));
});
$p.mD = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (((!(!pred.p(this.od))) !== isFlipped)) {
    r1 = this.od;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.oe))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.oe;
    } else {
      r2 = this.oe;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.mm))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.mm;
    } else if ((n === 1)) {
      r2 = this.mm;
    } else {
      r3 = this.mm;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(this.mn))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.mn;
    } else if ((n === 1)) {
      r2 = this.mn;
    } else if ((n === 2)) {
      r3 = this.mn;
    }
    n = ((1 + n) | 0);
  }
  var x15 = n;
  switch (x15) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x15);
    }
  }
});
$p.W = (function() {
  return this.od;
});
$p.an0 = (function(builder) {
  return builder.aD(this.od).aD(this.oe).aD(this.mm).aD(this.mn);
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hA)));
}
var $d_sci_Set$Set4 = new $TypeData().i($c_sci_Set$Set4, "scala.collection.immutable.Set$Set4", ({
  hA: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_scm_AbstractSeq() {
}
$p = $c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$p.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
}
$h_scm_AbstractSeq.prototype = $p;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Appended(underlying, elem, mutationCount) {
  this.CN = null;
  this.GV = null;
  this.CK = null;
  this.Lj = null;
  this.gv = null;
  this.gv = mutationCount;
  $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(this, underlying, elem);
}
$p = $c_scm_CheckedIndexedSeqView$Appended.prototype = new $h_sc_IndexedSeqView$Appended();
$p.constructor = $c_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Appended() {
}
$h_scm_CheckedIndexedSeqView$Appended.prototype = $p;
$p.l = (function() {
  return $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator(this);
});
$p.bX = (function() {
  return $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator(this);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gv);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gv);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gv);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gv);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gv);
});
$p.En = (function() {
  return this.gv;
});
$p.ec = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gv);
});
$p.aV = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gv);
});
$p.ba = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gv);
});
$p.el = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gv);
});
$p.bo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gv);
});
$p.ef = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gv);
});
$p.b8 = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gv);
});
$p.eh = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gv);
});
$p.X = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gv);
});
$p.ej = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gv);
});
var $d_scm_CheckedIndexedSeqView$Appended = new $TypeData().i($c_scm_CheckedIndexedSeqView$Appended, "scala.collection.mutable.CheckedIndexedSeqView$Appended", ({
  yU: 1,
  gS: 1,
  cA: 1,
  bW: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  by: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.CO = null;
  this.GW = 0;
  this.yk = 0;
  this.CL = null;
  this.Lk = 0;
  this.gw = null;
  this.gw = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n);
}
$p = $c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$p.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $p;
$p.l = (function() {
  return $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator(this);
});
$p.bX = (function() {
  return $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator(this);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gw);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gw);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gw);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gw);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gw);
});
$p.En = (function() {
  return this.gw;
});
$p.ec = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gw);
});
$p.aV = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gw);
});
$p.ba = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gw);
});
$p.el = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gw);
});
$p.bo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gw);
});
$p.ef = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gw);
});
$p.b8 = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gw);
});
$p.eh = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gw);
});
$p.X = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gw);
});
$p.ej = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gw);
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().i($c_scm_CheckedIndexedSeqView$Drop, "scala.collection.mutable.CheckedIndexedSeqView$Drop", ({
  yX: 1,
  gT: 1,
  cB: 1,
  bX: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  by: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.CP = null;
  this.GX = 0;
  this.GY = 0;
  this.Ll = null;
  this.yf = 0;
  this.gx = null;
  this.gx = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n);
}
$p = $c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$p.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
}
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $p;
$p.l = (function() {
  return $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator(this);
});
$p.bX = (function() {
  return $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator(this);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gx);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gx);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gx);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gx);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gx);
});
$p.En = (function() {
  return this.gx;
});
$p.ec = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gx);
});
$p.aV = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gx);
});
$p.ba = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gx);
});
$p.el = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gx);
});
$p.bo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gx);
});
$p.ef = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gx);
});
$p.b8 = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gx);
});
$p.eh = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gx);
});
$p.X = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gx);
});
$p.ej = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gx);
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().i($c_scm_CheckedIndexedSeqView$DropRight, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", ({
  yY: 1,
  gU: 1,
  cC: 1,
  bY: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  by: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.yl = null;
  this.H0 = null;
  this.GP = null;
  this.Lm = null;
  this.gy = null;
  this.gy = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f);
}
$p = $c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$p.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $p;
$p.l = (function() {
  return $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator(this);
});
$p.bX = (function() {
  return $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator(this);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gy);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gy);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gy);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gy);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gy);
});
$p.En = (function() {
  return this.gy;
});
$p.ec = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gy);
});
$p.aV = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gy);
});
$p.ba = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gy);
});
$p.el = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gy);
});
$p.bo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gy);
});
$p.ef = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gy);
});
$p.b8 = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gy);
});
$p.eh = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gy);
});
$p.X = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gy);
});
$p.ej = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gy);
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().i($c_scm_CheckedIndexedSeqView$Map, "scala.collection.mutable.CheckedIndexedSeqView$Map", ({
  yZ: 1,
  gX: 1,
  cD: 1,
  bZ: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  by: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Prepended(elem, underlying, mutationCount) {
  this.H1 = null;
  this.CR = null;
  this.Ln = null;
  this.GQ = null;
  this.gz = null;
  this.gz = mutationCount;
  $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(this, elem, underlying);
}
$p = $c_scm_CheckedIndexedSeqView$Prepended.prototype = new $h_sc_IndexedSeqView$Prepended();
$p.constructor = $c_scm_CheckedIndexedSeqView$Prepended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Prepended() {
}
$h_scm_CheckedIndexedSeqView$Prepended.prototype = $p;
$p.l = (function() {
  return $f_scm_CheckedIndexedSeqView__iterator__sc_Iterator(this);
});
$p.bX = (function() {
  return $f_scm_CheckedIndexedSeqView__reverseIterator__sc_Iterator(this);
});
$p.eb = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gz);
});
$p.ek = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gz);
});
$p.ee = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gz);
});
$p.eg = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gz);
});
$p.ei = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gz);
});
$p.En = (function() {
  return this.gz;
});
$p.ec = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gz);
});
$p.aV = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.gz);
});
$p.ba = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gz);
});
$p.el = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.gz);
});
$p.bo = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gz);
});
$p.ef = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.gz);
});
$p.b8 = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gz);
});
$p.eh = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.gz);
});
$p.X = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gz);
});
$p.ej = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.gz);
});
var $d_scm_CheckedIndexedSeqView$Prepended = new $TypeData().i($c_scm_CheckedIndexedSeqView$Prepended, "scala.collection.mutable.CheckedIndexedSeqView$Prepended", ({
  z0: 1,
  gY: 1,
  cE: 1,
  c0: 1,
  H: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a: 1,
  E: 1,
  y: 1,
  Q: 1,
  D: 1,
  a7: 1,
  by: 1
}));
function $f_Lupickle_Api__upickle$Api$$maybeSortKeysTransform__O__Z__Lupickle_core_Visitor__Lupickle_core_Types$Writer__O($thiz, t, sortKeys, f, evidence$1) {
  return $m_Lupickle_core_BufferedValue$().awf(evidence$1, t, sortKeys, f);
}
function $f_Lupickle_Api__read__Lujson_Readable__Z__Lupickle_core_Types$Reader__O($thiz, s, trace, evidence$1) {
  var f = ((_$2) => s.HF.O(s.HE, _$2));
  if ((!trace)) {
    return f(evidence$1);
  } else {
    var wrapper = new $c_Lupickle_core_TraceVisitor$Wrapper();
    try {
      var x0 = $ct_Lupickle_core_TraceVisitor__Lupickle_core_Visitor__Lupickle_core_TraceVisitor$HasPath__Lupickle_core_TraceVisitor$Wrapper__(new $c_Lupickle_core_TraceVisitor(), evidence$1, $m_Lupickle_core_TraceVisitor$RootHasPath$(), wrapper);
      return f(x0);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x2 = $m_s_util_control_NonFatal$().dV(e$2);
      if ((!x2.c())) {
        var x3 = x2.h();
        throw new $c_Lupickle_core_TraceVisitor$TraceException($f_Lupickle_core_TraceVisitor$HasPath__path__T(wrapper.Dt), x3);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.b6 : e$2);
    }
  }
}
function $f_Lupickle_Api__write__O__I__Z__Z__Lupickle_core_Types$Writer__T($thiz, t, indent, escapeUnicode, sortKeys, evidence$1) {
  return $f_Lupickle_Api__upickle$Api$$maybeSortKeysTransform__O__Z__Lupickle_core_Visitor__Lupickle_core_Types$Writer__O($thiz, t, sortKeys, new $c_Lujson_StringRenderer(indent, escapeUnicode), evidence$1).g();
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $thiz.CT) ? $thiz : newHashMap.zQ());
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $thiz.CT.dM) ? $thiz : new $c_sci_HashMap(newRootNode).zQ());
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.ts = null;
  this.RS = null;
  this.CT = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.CT = outer;
  $ct_sci_MapOps$LazyImmutableKeySet__sci_MapOps__(this, outer);
}
$p = $c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$LazyImmutableKeySet();
$p.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
}
$h_sci_HashMap$HashKeySet.prototype = $p;
$p.mG = (function(elem) {
  var originalHash = $m_sr_Statics$().k(elem);
  var improvedHash = $m_sc_Hashing$().bV(originalHash);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, this.CT.dM.VO(elem, null, originalHash, improvedHash, 0, false));
});
$p.atQ = (function(pred) {
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this.CT.MB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2) => (!(!pred.p(kv$2.P()))))), false));
});
$p.atT = (function(pred) {
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this.CT.MB(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2) => (!(!pred.p(kv$2.P()))))), true));
});
$p.kL = (function(elem) {
  return this.mG(elem);
});
$p.bB = (function(pred) {
  return this.atQ(pred);
});
$p.bC = (function(pred) {
  return this.atT(pred);
});
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hp)));
}
var $d_sci_HashMap$HashKeySet = new $TypeData().i($c_sci_HashMap$HashKeySet, "scala.collection.immutable.HashMap$HashKeySet", ({
  hp: 1,
  cN: 1,
  cy: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a: 1,
  a4: 1,
  G: 1,
  az: 1,
  ay: 1
}));
/** @constructor */
function $c_sci_Map$EmptyMap$() {
}
$p = $c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
}
$h_sci_Map$EmptyMap$.prototype = $p;
$p.aH = (function() {
  return 0;
});
$p.G = (function() {
  return 0;
});
$p.c = (function() {
  return true;
});
$p.Mg = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
});
$p.az = (function(key) {
  return false;
});
$p.b9 = (function(key) {
  return $m_s_None$();
});
$p.f6 = (function(key, default$1) {
  return default$1.aA();
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.jv = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.mP = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.p = (function(key) {
  this.Mg(key);
});
$p.hk = (function(key, value) {
  return new $c_sci_Map$Map1(key, value);
});
var $d_sci_Map$EmptyMap$ = new $TypeData().i($c_sci_Map$EmptyMap$, "scala.collection.immutable.Map$EmptyMap$", ({
  xU: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  a: 1
}));
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$();
  }
  return $n_sci_Map$EmptyMap$;
}
/** @constructor */
function $c_sci_Map$WithDefault(underlying, defaultValue) {
  this.tw = null;
  this.H3 = null;
  this.tw = underlying;
  this.H3 = defaultValue;
}
$p = $c_sci_Map$WithDefault.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$WithDefault;
/** @constructor */
function $h_sci_Map$WithDefault() {
}
$h_sci_Map$WithDefault.prototype = $p;
$p.b9 = (function(key) {
  return this.tw.b9(key);
});
$p.Ix = (function(key) {
  return this.H3.p(key);
});
$p.b4 = (function() {
  return this.tw.b4();
});
$p.l = (function() {
  return this.tw.l();
});
$p.c = (function() {
  return this.tw.c();
});
$p.uy = (function() {
  return this.tw.uy();
});
$p.az2 = (function(key, value) {
  return new $c_sci_Map$WithDefault(this.tw.hk(key, value), this.H3);
});
$p.ahi = (function(coll) {
  return new $c_sci_Map$WithDefault(this.tw.uy().bp(coll), this.H3);
});
$p.dw = (function() {
  return new $c_scm_Builder$$anon$1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2) => new $c_sci_Map$WithDefault(p$2, this.H3))), new $c_sci_MapBuilderImpl());
});
$p.hk = (function(key, value) {
  return this.az2(key, value);
});
$p.mF = (function(coll) {
  return this.ahi(coll);
});
$p.de = (function(coll) {
  return this.ahi(coll);
});
var $d_sci_Map$WithDefault = new $TypeData().i($c_sci_Map$WithDefault, "scala.collection.immutable.Map$WithDefault", ({
  y4: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  a: 1
}));
function $f_Lupickle_AttributeTagged__annotate__Lupickle_core_Types$ObjectWriter__T__T__T__Lupickle_core_Annotator$Checker__Lupickle_core_Types$TaggedWriter($thiz, rw, key, value, shortValue, checker) {
  return new $c_Lupickle_core_Types$TaggedWriter$Leaf($thiz.afo(), checker, key, shortValue, rw);
}
function $f_Lupickle_AttributeTagged__upickle$AttributeTagged$$isTagName__T__O__Z($thiz, tagKey, i) {
  return ((i instanceof $c_Lupickle_core_BufferedValue$Str) ? ($dp_toString__T(i.qr) === tagKey) : ($is_jl_CharSequence(i) && ($dp_toString__T(i) === tagKey)));
}
function $f_Lupickle_AttributeTagged__taggedWrite__Lupickle_core_Types$ObjectWriter__T__T__Lupickle_core_Visitor__O__O($thiz, w, tagKey, tagValue, out, v) {
  if ((w instanceof $c_Lupickle_implicits_CaseClassReadWriters$SingletonWriter)) {
    return out.bx(tagValue, (-1));
  } else {
    var ctx = out.K(((1 + w.ah(v)) | 0), true, (-1));
    var keyVisitor = ctx.eT((-1));
    ctx.eU(keyVisitor.bx(tagKey, (-1)));
    ctx.bu(ctx.bw().bx(tagValue, (-1)), (-1));
    w.ai(ctx, v);
    return ctx.L((-1));
  }
}
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.hx = null;
  this.ks = null;
  this.hx = key1;
  this.ks = value1;
}
$p = $c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
}
$h_sci_Map$Map1.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mC(pred, false);
});
$p.bC = (function(pred) {
  return this.mC(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 1;
});
$p.G = (function() {
  return 1;
});
$p.c = (function() {
  return false;
});
$p.p = (function(key) {
  if ($m_sr_BoxesRunTime$().B(key, this.hx)) {
    return this.ks;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.az = (function(key) {
  return $m_sr_BoxesRunTime$().B(key, this.hx);
});
$p.b9 = (function(key) {
  return ($m_sr_BoxesRunTime$().B(key, this.hx) ? new $c_s_Some(this.ks) : $m_s_None$());
});
$p.f6 = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().B(key, this.hx) ? this.ks : default$1.aA());
});
$p.l = (function() {
  return new $c_sc_Iterator$$anon$20(new $c_T2(this.hx, this.ks));
});
$p.jv = (function() {
  return new $c_sc_Iterator$$anon$20(this.hx);
});
$p.mP = (function() {
  return new $c_sc_Iterator$$anon$20(this.ks);
});
$p.Ab = (function(key, value) {
  return ($m_sr_BoxesRunTime$().B(key, this.hx) ? new $c_sci_Map$Map1(this.hx, value) : new $c_sci_Map$Map2(this.hx, this.ks, key, value));
});
$p.al = (function(f) {
  f.p(new $c_T2(this.hx, this.ks));
});
$p.fK = (function(p) {
  return (!(!p.p(new $c_T2(this.hx, this.ks))));
});
$p.g8 = (function(p) {
  return (!(!p.p(new $c_T2(this.hx, this.ks))));
});
$p.mC = (function(pred, isFlipped) {
  return (((!(!pred.p(new $c_T2(this.hx, this.ks)))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$());
});
$p.r = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().kV(this.hx, this.ks);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().qp;
  h = $m_s_util_hashing_MurmurHash3$().d(h, a);
  h = $m_s_util_hashing_MurmurHash3$().d(h, b);
  h = $m_s_util_hashing_MurmurHash3$().kR(h, c);
  return $m_s_util_hashing_MurmurHash3$().an(h, 1);
});
$p.hk = (function(key, value) {
  return this.Ab(key, value);
});
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hs)));
}
var $d_sci_Map$Map1 = new $TypeData().i($c_sci_Map$Map1, "scala.collection.immutable.Map$Map1", ({
  hs: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.h1 = null;
  this.j4 = null;
  this.h2 = null;
  this.j5 = null;
  this.h1 = key1;
  this.j4 = value1;
  this.h2 = key2;
  this.j5 = value2;
}
$p = $c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
}
$h_sci_Map$Map2.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mC(pred, false);
});
$p.bC = (function(pred) {
  return this.mC(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 2;
});
$p.G = (function() {
  return 2;
});
$p.c = (function() {
  return false;
});
$p.p = (function(key) {
  if ($m_sr_BoxesRunTime$().B(key, this.h1)) {
    return this.j4;
  } else if ($m_sr_BoxesRunTime$().B(key, this.h2)) {
    return this.j5;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.az = (function(key) {
  return ($m_sr_BoxesRunTime$().B(key, this.h1) || $m_sr_BoxesRunTime$().B(key, this.h2));
});
$p.b9 = (function(key) {
  return ($m_sr_BoxesRunTime$().B(key, this.h1) ? new $c_s_Some(this.j4) : ($m_sr_BoxesRunTime$().B(key, this.h2) ? new $c_s_Some(this.j5) : $m_s_None$()));
});
$p.f6 = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().B(key, this.h1) ? this.j4 : ($m_sr_BoxesRunTime$().B(key, this.h2) ? this.j5 : default$1.aA()));
});
$p.l = (function() {
  return new $c_sci_Map$Map2$$anon$1(this);
});
$p.jv = (function() {
  return new $c_sci_Map$Map2$$anon$2(this);
});
$p.mP = (function() {
  return new $c_sci_Map$Map2$$anon$3(this);
});
$p.Ab = (function(key, value) {
  return ($m_sr_BoxesRunTime$().B(key, this.h1) ? new $c_sci_Map$Map2(this.h1, value, this.h2, this.j5) : ($m_sr_BoxesRunTime$().B(key, this.h2) ? new $c_sci_Map$Map2(this.h1, this.j4, this.h2, value) : new $c_sci_Map$Map3(this.h1, this.j4, this.h2, this.j5, key, value)));
});
$p.al = (function(f) {
  f.p(new $c_T2(this.h1, this.j4));
  f.p(new $c_T2(this.h2, this.j5));
});
$p.fK = (function(p) {
  return ((!(!p.p(new $c_T2(this.h1, this.j4)))) || (!(!p.p(new $c_T2(this.h2, this.j5)))));
});
$p.g8 = (function(p) {
  return ((!(!p.p(new $c_T2(this.h1, this.j4)))) && (!(!p.p(new $c_T2(this.h2, this.j5)))));
});
$p.mC = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (((!(!pred.p(new $c_T2(this.h1, this.j4)))) !== isFlipped)) {
    k1 = this.h1;
    v1 = this.j4;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.h2, this.j5)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.h2;
      v1 = this.j5;
    }
    n = ((1 + n) | 0);
  }
  var x24 = n;
  switch (x24) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x24);
    }
  }
});
$p.r = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().kV(this.h1, this.j4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.h2, this.j5);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().qp;
  h = $m_s_util_hashing_MurmurHash3$().d(h, a);
  h = $m_s_util_hashing_MurmurHash3$().d(h, b);
  h = $m_s_util_hashing_MurmurHash3$().kR(h, c);
  return $m_s_util_hashing_MurmurHash3$().an(h, 2);
});
$p.hk = (function(key, value) {
  return this.Ab(key, value);
});
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ht)));
}
var $d_sci_Map$Map2 = new $TypeData().i($c_sci_Map$Map2, "scala.collection.immutable.Map$Map2", ({
  ht: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.gs = null;
  this.ic = null;
  this.g1 = null;
  this.hy = null;
  this.g2 = null;
  this.hz = null;
  this.gs = key1;
  this.ic = value1;
  this.g1 = key2;
  this.hy = value2;
  this.g2 = key3;
  this.hz = value3;
}
$p = $c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
}
$h_sci_Map$Map3.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mC(pred, false);
});
$p.bC = (function(pred) {
  return this.mC(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 3;
});
$p.G = (function() {
  return 3;
});
$p.c = (function() {
  return false;
});
$p.p = (function(key) {
  if ($m_sr_BoxesRunTime$().B(key, this.gs)) {
    return this.ic;
  } else if ($m_sr_BoxesRunTime$().B(key, this.g1)) {
    return this.hy;
  } else if ($m_sr_BoxesRunTime$().B(key, this.g2)) {
    return this.hz;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.az = (function(key) {
  return (($m_sr_BoxesRunTime$().B(key, this.gs) || $m_sr_BoxesRunTime$().B(key, this.g1)) || $m_sr_BoxesRunTime$().B(key, this.g2));
});
$p.b9 = (function(key) {
  return ($m_sr_BoxesRunTime$().B(key, this.gs) ? new $c_s_Some(this.ic) : ($m_sr_BoxesRunTime$().B(key, this.g1) ? new $c_s_Some(this.hy) : ($m_sr_BoxesRunTime$().B(key, this.g2) ? new $c_s_Some(this.hz) : $m_s_None$())));
});
$p.f6 = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().B(key, this.gs) ? this.ic : ($m_sr_BoxesRunTime$().B(key, this.g1) ? this.hy : ($m_sr_BoxesRunTime$().B(key, this.g2) ? this.hz : default$1.aA())));
});
$p.l = (function() {
  return new $c_sci_Map$Map3$$anon$4(this);
});
$p.jv = (function() {
  return new $c_sci_Map$Map3$$anon$5(this);
});
$p.mP = (function() {
  return new $c_sci_Map$Map3$$anon$6(this);
});
$p.Ab = (function(key, value) {
  return ($m_sr_BoxesRunTime$().B(key, this.gs) ? new $c_sci_Map$Map3(this.gs, value, this.g1, this.hy, this.g2, this.hz) : ($m_sr_BoxesRunTime$().B(key, this.g1) ? new $c_sci_Map$Map3(this.gs, this.ic, this.g1, value, this.g2, this.hz) : ($m_sr_BoxesRunTime$().B(key, this.g2) ? new $c_sci_Map$Map3(this.gs, this.ic, this.g1, this.hy, this.g2, value) : new $c_sci_Map$Map4(this.gs, this.ic, this.g1, this.hy, this.g2, this.hz, key, value))));
});
$p.al = (function(f) {
  f.p(new $c_T2(this.gs, this.ic));
  f.p(new $c_T2(this.g1, this.hy));
  f.p(new $c_T2(this.g2, this.hz));
});
$p.fK = (function(p) {
  return (((!(!p.p(new $c_T2(this.gs, this.ic)))) || (!(!p.p(new $c_T2(this.g1, this.hy))))) || (!(!p.p(new $c_T2(this.g2, this.hz)))));
});
$p.g8 = (function(p) {
  return (((!(!p.p(new $c_T2(this.gs, this.ic)))) && (!(!p.p(new $c_T2(this.g1, this.hy))))) && (!(!p.p(new $c_T2(this.g2, this.hz)))));
});
$p.mC = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (((!(!pred.p(new $c_T2(this.gs, this.ic)))) !== isFlipped)) {
    k1 = this.gs;
    v1 = this.ic;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.g1, this.hy)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.g1;
      v1 = this.hy;
    } else {
      k2 = this.g1;
      v2 = this.hy;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.g2, this.hz)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.g2;
      v1 = this.hz;
    } else if ((n === 1)) {
      k2 = this.g2;
      v2 = this.hz;
    }
    n = ((1 + n) | 0);
  }
  var $x_1;
  var x26 = n;
  switch (x26) {
    case 0: {
      var $x_1 = $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      var $x_1 = new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      var $x_1 = new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      var $x_1 = this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x26);
    }
  }
  return $x_1;
});
$p.r = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().kV(this.gs, this.ic);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.g1, this.hy);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.g2, this.hz);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().qp;
  h = $m_s_util_hashing_MurmurHash3$().d(h, a);
  h = $m_s_util_hashing_MurmurHash3$().d(h, b);
  h = $m_s_util_hashing_MurmurHash3$().kR(h, c);
  return $m_s_util_hashing_MurmurHash3$().an(h, 3);
});
$p.hk = (function(key, value) {
  return this.Ab(key, value);
});
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hu)));
}
var $d_sci_Map$Map3 = new $TypeData().i($c_sci_Map$Map3, "scala.collection.immutable.Map$Map3", ({
  hu: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  C: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.fB = null;
  this.h3 = null;
  this.fh = null;
  this.gt = null;
  this.eZ = null;
  this.g3 = null;
  this.f0 = null;
  this.g4 = null;
  this.fB = key1;
  this.h3 = value1;
  this.fh = key2;
  this.gt = value2;
  this.eZ = key3;
  this.g3 = value3;
  this.f0 = key4;
  this.g4 = value4;
}
$p = $c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
}
$h_sci_Map$Map4.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.mC(pred, false);
});
$p.bC = (function(pred) {
  return this.mC(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return 4;
});
$p.G = (function() {
  return 4;
});
$p.c = (function() {
  return false;
});
$p.p = (function(key) {
  if ($m_sr_BoxesRunTime$().B(key, this.fB)) {
    return this.h3;
  } else if ($m_sr_BoxesRunTime$().B(key, this.fh)) {
    return this.gt;
  } else if ($m_sr_BoxesRunTime$().B(key, this.eZ)) {
    return this.g3;
  } else if ($m_sr_BoxesRunTime$().B(key, this.f0)) {
    return this.g4;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$p.az = (function(key) {
  return ((($m_sr_BoxesRunTime$().B(key, this.fB) || $m_sr_BoxesRunTime$().B(key, this.fh)) || $m_sr_BoxesRunTime$().B(key, this.eZ)) || $m_sr_BoxesRunTime$().B(key, this.f0));
});
$p.b9 = (function(key) {
  return ($m_sr_BoxesRunTime$().B(key, this.fB) ? new $c_s_Some(this.h3) : ($m_sr_BoxesRunTime$().B(key, this.fh) ? new $c_s_Some(this.gt) : ($m_sr_BoxesRunTime$().B(key, this.eZ) ? new $c_s_Some(this.g3) : ($m_sr_BoxesRunTime$().B(key, this.f0) ? new $c_s_Some(this.g4) : $m_s_None$()))));
});
$p.f6 = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().B(key, this.fB) ? this.h3 : ($m_sr_BoxesRunTime$().B(key, this.fh) ? this.gt : ($m_sr_BoxesRunTime$().B(key, this.eZ) ? this.g3 : ($m_sr_BoxesRunTime$().B(key, this.f0) ? this.g4 : default$1.aA()))));
});
$p.l = (function() {
  return new $c_sci_Map$Map4$$anon$7(this);
});
$p.jv = (function() {
  return new $c_sci_Map$Map4$$anon$8(this);
});
$p.mP = (function() {
  return new $c_sci_Map$Map4$$anon$9(this);
});
$p.Ab = (function(key, value) {
  return ($m_sr_BoxesRunTime$().B(key, this.fB) ? new $c_sci_Map$Map4(this.fB, value, this.fh, this.gt, this.eZ, this.g3, this.f0, this.g4) : ($m_sr_BoxesRunTime$().B(key, this.fh) ? new $c_sci_Map$Map4(this.fB, this.h3, this.fh, value, this.eZ, this.g3, this.f0, this.g4) : ($m_sr_BoxesRunTime$().B(key, this.eZ) ? new $c_sci_Map$Map4(this.fB, this.h3, this.fh, this.gt, this.eZ, value, this.f0, this.g4) : ($m_sr_BoxesRunTime$().B(key, this.f0) ? new $c_sci_Map$Map4(this.fB, this.h3, this.fh, this.gt, this.eZ, this.g3, this.f0, value) : $m_sci_HashMap$().kr.jC(this.fB, this.h3).jC(this.fh, this.gt).jC(this.eZ, this.g3).jC(this.f0, this.g4).jC(key, value)))));
});
$p.al = (function(f) {
  f.p(new $c_T2(this.fB, this.h3));
  f.p(new $c_T2(this.fh, this.gt));
  f.p(new $c_T2(this.eZ, this.g3));
  f.p(new $c_T2(this.f0, this.g4));
});
$p.fK = (function(p) {
  return ((((!(!p.p(new $c_T2(this.fB, this.h3)))) || (!(!p.p(new $c_T2(this.fh, this.gt))))) || (!(!p.p(new $c_T2(this.eZ, this.g3))))) || (!(!p.p(new $c_T2(this.f0, this.g4)))));
});
$p.g8 = (function(p) {
  return ((((!(!p.p(new $c_T2(this.fB, this.h3)))) && (!(!p.p(new $c_T2(this.fh, this.gt))))) && (!(!p.p(new $c_T2(this.eZ, this.g3))))) && (!(!p.p(new $c_T2(this.f0, this.g4)))));
});
$p.mC = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (((!(!pred.p(new $c_T2(this.fB, this.h3)))) !== isFlipped)) {
    k1 = this.fB;
    v1 = this.h3;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.fh, this.gt)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.fh;
      v1 = this.gt;
    } else {
      k2 = this.fh;
      v2 = this.gt;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.eZ, this.g3)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.eZ;
      v1 = this.g3;
    } else if ((n === 1)) {
      k2 = this.eZ;
      v2 = this.g3;
    } else {
      k3 = this.eZ;
      v3 = this.g3;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.p(new $c_T2(this.f0, this.g4)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.f0;
      v1 = this.g4;
    } else if ((n === 1)) {
      k2 = this.f0;
      v2 = this.g4;
    } else if ((n === 2)) {
      k3 = this.f0;
      v3 = this.g4;
    }
    n = ((1 + n) | 0);
  }
  var $x_1;
  var x28 = n;
  switch (x28) {
    case 0: {
      var $x_1 = $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      var $x_1 = new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      var $x_1 = new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      var $x_1 = new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break;
    }
    case 4: {
      var $x_1 = this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x28);
    }
  }
  return $x_1;
});
$p.amZ = (function(builder) {
  return builder.zu(this.fB, this.h3).zu(this.fh, this.gt).zu(this.eZ, this.g3).zu(this.f0, this.g4);
});
$p.r = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().kV(this.fB, this.h3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.fh, this.gt);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.eZ, this.g3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().kV(this.f0, this.g4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().qp;
  h = $m_s_util_hashing_MurmurHash3$().d(h, a);
  h = $m_s_util_hashing_MurmurHash3$().d(h, b);
  h = $m_s_util_hashing_MurmurHash3$().kR(h, c);
  return $m_s_util_hashing_MurmurHash3$().an(h, 4);
});
$p.hk = (function(key, value) {
  return this.Ab(key, value);
});
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hv)));
}
var $d_sci_Map$Map4 = new $TypeData().i($c_sci_Map$Map4, "scala.collection.immutable.Map$Map4", ({
  hv: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  C: 1,
  a: 1
}));
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bB)));
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bB)));
}
/** @constructor */
function $c_Lupickle_default$() {
  this.adK = null;
  this.adL = false;
  this.adM = null;
  this.adN = false;
  this.adU = null;
  this.adV = false;
  this.adQ = null;
  this.adR = false;
  this.adS = null;
  this.adT = false;
  this.alE = null;
  this.bf = null;
  this.op = null;
  this.aT = null;
  this.oq = null;
  this.adO = null;
  this.LU = null;
  this.J = null;
  this.adI = null;
  this.aG = null;
  this.bl = null;
  this.Dw = null;
  this.T3 = null;
  this.adW = null;
  this.adX = false;
  this.m = null;
  this.h8 = null;
  this.ao = null;
  this.g5 = null;
  this.adP = null;
  this.HX = null;
  this.aw = null;
  this.adJ = null;
  this.a1 = null;
  this.ay = null;
  this.mu = null;
  this.T4 = null;
  this.adY = null;
  this.adZ = false;
  $n_Lupickle_default$ = this;
  this.alE = this;
  $f_Lupickle_implicits_Readers__$init$__V(this);
  $f_Lupickle_implicits_Writers__$init$__V(this);
  $f_Lupickle_MsgReadWriters__$init$__V(this);
}
$p = $c_Lupickle_default$.prototype = new $h_O();
$p.constructor = $c_Lupickle_default$;
/** @constructor */
function $h_Lupickle_default$() {
}
$h_Lupickle_default$.prototype = $p;
$p.ap = (function() {
  if ((!this.adL)) {
    this.adK = new $c_Lupickle_core_Types$ReadWriter$(this);
    this.adL = true;
  }
  return this.adK;
});
$p.hJ = (function() {
  if ((!this.adN)) {
    this.adM = new $c_Lupickle_core_Types$Reader$(this);
    this.adN = true;
  }
  return this.adM;
});
$p.ji = (function() {
  if ((!this.adV)) {
    this.adU = new $c_Lupickle_core_Types$Writer$(this);
    this.adV = true;
  }
  return this.adU;
});
$p.aq = (function() {
  if ((!this.adR)) {
    this.adQ = new $c_Lupickle_core_Types$TaggedReader$(this);
    this.adR = true;
  }
  return this.adQ;
});
$p.afo = (function() {
  if ((!this.adT)) {
    this.adS = new $c_Lupickle_core_Types$TaggedWriter$(this);
    this.adT = true;
  }
  return this.adS;
});
$p.uJ = (function() {
  if ((!this.adX)) {
    this.adW = new $c_Lupickle_implicits_Readers$JavaReader$(this);
    this.adX = true;
  }
  return this.adW;
});
$p.uK = (function() {
  if ((!this.adZ)) {
    this.adY = new $c_Lupickle_implicits_Writers$JavaWriter$(this);
    this.adZ = true;
  }
  return this.adY;
});
var $d_Lupickle_default$ = new $TypeData().i($c_Lupickle_default$, "upickle.default$", ({
  DO: 1,
  Dt: 1,
  Ey: 1,
  DU: 1,
  Dd: 1,
  E1: 1,
  CV: 1,
  DP: 1,
  Ev: 1,
  E2: 1,
  EY: 1,
  DX: 1,
  EC: 1,
  CU: 1,
  DZ: 1,
  CR: 1,
  CQ: 1,
  CS: 1,
  CN: 1,
  CO: 1
}));
var $n_Lupickle_default$;
function $m_Lupickle_default$() {
  if ((!$n_Lupickle_default$)) {
    $n_Lupickle_default$ = new $c_Lupickle_default$();
  }
  return $n_Lupickle_default$;
}
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap(namedNodeMap) {
  this.Cy = null;
  this.Cy = namedNodeMap;
}
$p = $c_Lorg_scalajs_dom_NamedNodeMapMap.prototype = new $h_O();
$p.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap.prototype = $p;
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.g8 = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.aH = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.X = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.eH = (function() {
  return "Map";
});
$p.b4 = (function() {
  return $m_scm_Iterable$();
});
$p.f6 = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.p = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aJ = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.jv = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.mP = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.jo = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$p.Ix = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.az = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aU = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.gG = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.dw = (function() {
  return $m_scm_Map$().aP();
});
$p.b = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().UZ(this);
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.cz = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
});
$p.dk = (function(size) {
});
$p.Jf = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$p.oM = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op);
});
$p.Vc = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key);
});
$p.G = (function() {
  return (-1);
});
$p.l = (function() {
  return new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this);
});
$p.Us = (function(key) {
  var x1 = this.Cy.getNamedItem(key);
  if ((x1 === null)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x1);
});
$p.Iq = (function() {
  var this$1 = new $c_sc_MapOps$$anon$2(this);
  $m_sci_List$();
  var this$3 = $m_sci_Nil$().aY(this$1);
  var these = this$3;
  while ((!these.c())) {
    this.ak5(these.W());
    these = these.ak();
  }
});
$p.am8 = (function(kv) {
  this.Cy.setNamedItem(kv.V());
  return this;
});
$p.ak5 = (function(key) {
  this.Cy.removeNamedItem(key);
  return this;
});
$p.b9 = (function(key) {
  return this.Us(key);
});
$p.aD = (function(elem) {
  return this.am8(elem);
});
$p.ED = (function(elem) {
  return this.ak5(elem);
});
$p.aR = (function() {
  return this;
});
$p.de = (function(coll) {
  return $m_scm_Map$().bp(coll);
});
$p.fu = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
$p.hK = (function(v1) {
  $f_sc_MapOps__apply__O__O(this, v1);
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap = new $TypeData().i($c_Lorg_scalajs_dom_NamedNodeMapMap, "org.scalajs.dom.NamedNodeMapMap", ({
  vy: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a3: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  bC: 1,
  bB: 1
}));
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.dz === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode));
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.dz = null;
  this.dz = rootNode;
}
$p = $c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
}
$h_sci_HashSet.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.agZ(pred, false);
});
$p.bC = (function(pred) {
  return this.agZ(pred, true);
});
$p.b4 = (function() {
  return $m_sci_HashSet$();
});
$p.G = (function() {
  return this.dz.df;
});
$p.aH = (function() {
  return this.dz.df;
});
$p.c = (function() {
  return (this.dz.df === 0);
});
$p.l = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sci_SetIterator(this.dz));
});
$p.az = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().k(element);
  var elementHash = $m_sc_Hashing$().bV(elementUnimprovedHash);
  return this.dz.Iu(element, elementUnimprovedHash, elementHash, 0);
});
$p.Ec = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().k(element);
  var elementHash = $m_sc_Hashing$().bV(elementUnimprovedHash);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, this.dz.EH(element, elementUnimprovedHash, elementHash, 0));
});
$p.asJ = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if (this.c()) {
      return that;
    } else {
      var newNode = this.dz.agc(that.dz, 0);
      return ((newNode === that.dz) ? that : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode));
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(that);
    var current = this.dz;
    while (iter.f()) {
      var next = iter.e();
      var originalHash = $p_scm_HashSet__improveHash__I__I(that, next.mq);
      var improved = $m_sc_Hashing$().bV(originalHash);
      current = current.EH(next.qn, originalHash, improved, 0);
      if ((current !== this.dz)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().cS($m_sci_Node$().fp(improved, 0));
        while (iter.f()) {
          var next$2 = iter.e();
          var originalHash$2 = $p_scm_HashSet__improveHash__I__I(that, next$2.mq);
          var improved$2 = $m_sc_Hashing$().bV(originalHash$2);
          shallowlyMutableNodeMap = current.NE(next$2.qn, originalHash$2, improved$2, 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashSet(current);
      }
    }
    return this;
  } else if ((that instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(that);
    var current$2 = this.dz;
    while (iter$2.f()) {
      var next$3 = iter$2.e();
      var improvedHash$2 = next$3.oj;
      var originalHash$3 = (improvedHash$2 ^ ((improvedHash$2 >>> 16) | 0));
      var improved$3 = $m_sc_Hashing$().bV(originalHash$3);
      current$2 = current$2.EH(next$3.mr, originalHash$3, improved$3, 0);
      if ((current$2 !== this.dz)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().cS($m_sci_Node$().fp(improved$3, 0));
        while (iter$2.f()) {
          var next$4 = iter$2.e();
          var improvedHash$3 = next$4.oj;
          var originalHash$4 = (improvedHash$3 ^ ((improvedHash$3 >>> 16) | 0));
          var improved$4 = $m_sc_Hashing$().bV(originalHash$4);
          shallowlyMutableNodeMap$2 = current$2.NE(next$4.mr, originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashSet(current$2);
      }
    }
    return this;
  } else {
    var iter$3 = that.l();
    var current$3 = this.dz;
    while (iter$3.f()) {
      var element = iter$3.e();
      var originalHash$5 = $m_sr_Statics$().k(element);
      var improved$5 = $m_sc_Hashing$().bV(originalHash$5);
      current$3 = current$3.EH(element, originalHash$5, improved$5, 0);
      if ((current$3 !== this.dz)) {
        var shallowlyMutableNodeMap$3 = $m_sci_Node$().cS($m_sci_Node$().fp(improved$5, 0));
        while (iter$3.f()) {
          var element$2 = iter$3.e();
          var originalHash$6 = $m_sr_Statics$().k(element$2);
          var improved$6 = $m_sc_Hashing$().bV(originalHash$6);
          shallowlyMutableNodeMap$3 = current$3.NE(element$2, originalHash$6, improved$6, 0, shallowlyMutableNodeMap$3);
        }
        return new $c_sci_HashSet(current$3);
      }
    }
    return this;
  }
});
$p.W = (function() {
  return this.l().e();
});
$p.cJ = (function() {
  return new $c_sci_SetReverseIterator(this.dz).e();
});
$p.al = (function(f) {
  this.dz.al(f);
});
$p.Nx = (function(that) {
  return (this.c() || ((!that.c()) && ((that instanceof $c_sci_HashSet) ? this.dz.VC(that.dz, 0) : $f_sc_IterableOnceOps__forall__F1__Z(this, that))));
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.dz;
      var x$2 = that.dz;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that);
  }
});
$p.eH = (function() {
  return "HashSet";
});
$p.r = (function() {
  var it = new $c_sci_SetHashIterator(this.dz);
  return $m_s_util_hashing_MurmurHash3$().Aa(it, $m_s_util_hashing_MurmurHash3$().Ho);
});
$p.agZ = (function(pred, isFlipped) {
  var newRootNode = this.dz.agY(pred, isFlipped);
  return ((newRootNode === this.dz) ? this : ((newRootNode.df === 0) ? $m_sci_HashSet$().CV : new $c_sci_HashSet(newRootNode)));
});
$p.kL = (function(elem) {
  return this.Ec(elem);
});
$p.Mq = (function(that) {
  return this.asJ(that);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hq)));
}
var $d_sci_HashSet = new $TypeData().i($c_sci_HashSet, "scala.collection.immutable.HashSet", ({
  hq: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  C: 1,
  bu: 1,
  c5: 1,
  a: 1,
  a4: 1
}));
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.xS)));
}
/** @constructor */
function $c_scm_AbstractSet() {
}
$p = $c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$p.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
}
$h_scm_AbstractSet.prototype = $p;
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.dk = (function(size) {
});
$p.qA = (function(elem) {
  return $f_scm_SetOps__add__O__Z(this, elem);
});
$p.G = (function() {
  return (-1);
});
$p.b4 = (function() {
  return $m_scm_Set$();
});
$p.aR = (function() {
  return this;
});
function $ct_sci_LazyList__O__($thiz, lazyState) {
  $thiz.dA = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : $m_sci_LazyList$Uninitialized$());
  $thiz.o8 = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : lazyState);
  return $thiz;
}
function $ct_sci_LazyList__O__sci_LazyList__($thiz, head, tail) {
  $ct_sci_LazyList__O__($thiz, $m_sci_LazyList$EmptyMarker$());
  $thiz.dA = head;
  $thiz.o8 = tail;
  return $thiz;
}
function $p_sci_LazyList__initState__V($thiz) {
  if (($thiz.dA === $m_sci_LazyList$Uninitialized$())) {
    if (($thiz.o8 === $m_sci_LazyList$MidEvaluation$())) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "LazyList evaluation depends on its own result (self-reference); see docs for more info");
    }
    var fun = $thiz.o8;
    $thiz.o8 = $m_sci_LazyList$MidEvaluation$();
    try {
      var l = $p_sci_LazyList__evaluated__sci_LazyList(fun.aA());
    } finally {
      $thiz.o8 = fun;
    }
    $thiz.o8 = l.o8;
    $thiz.dA = l.dA;
  }
}
function $p_sci_LazyList__evaluated__sci_LazyList($thiz) {
  while (true) {
    if (($thiz.dA !== $m_sci_LazyList$Uninitialized$())) {
      return (($thiz.o8 === null) ? $m_sci_LazyList$().aM : $thiz);
    } else {
      $p_sci_LazyList__initState__V($thiz);
    }
  }
}
function $p_sci_LazyList__scanLeftImpl__O__F2__sci_LazyList($thiz, z, op) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), z, ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (($p_sci_LazyList__evaluated__sci_LazyList($thiz) === $m_sci_LazyList$().aM) ? $m_sci_LazyList$().aM : $p_sci_LazyList__scanLeftImpl__O__F2__sci_LazyList($thiz.cq(), op.cm(z, $thiz.W()), op)))))));
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (($p_sci_LazyList__evaluated__sci_LazyList($thiz) === $m_sci_LazyList$().aM) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), f.p($thiz.W()), $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz.cq(), f)))))));
}
function $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList($thiz, it) {
  return ((($p_sci_LazyList__evaluated__sci_LazyList($thiz) === $m_sci_LazyList$().aM) || (!it.f())) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), new $c_T2($thiz.W(), it.e()), ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList($thiz.cq(), it))))))));
}
function $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz, scout) {
  return (($p_sci_LazyList__evaluated__sci_LazyList(scout) === $m_sci_LazyList$().aM) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), $thiz.W(), ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz.cq(), scout.cq()))))))));
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  return ((n <= 0) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => (($p_sci_LazyList__evaluated__sci_LazyList($thiz) === $m_sci_LazyList$().aM) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), $thiz.W(), $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz.cq(), ((n - 1) | 0))))))))));
}
function $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList($thiz, tl) {
  var \u03b4this$tailLocal5 = $thiz;
  var tl$tailLocal1 = tl;
  while (true) {
    if (($p_sci_LazyList__evaluated__sci_LazyList(\u03b4this$tailLocal5) === $m_sci_LazyList$().aM)) {
      return tl$tailLocal1;
    } else {
      var \u03b4this$tailLocal5$tmp1 = \u03b4this$tailLocal5.cq();
      $m_sci_LazyList$();
      var tl$tailLocal1$tmp1 = $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((\u03b4this$tailLocal5$1, tl$tailLocal1$1) => (() => {
        $m_sci_LazyList$();
        return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), \u03b4this$tailLocal5$1.W(), tl$tailLocal1$1);
      }))(\u03b4this$tailLocal5, tl$tailLocal1)));
      \u03b4this$tailLocal5 = \u03b4this$tailLocal5$tmp1;
      tl$tailLocal1 = tl$tailLocal1$tmp1;
    }
  }
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.aC = (("" + b.aC) + start);
  if (($thiz.dA === $m_sci_LazyList$Uninitialized$())) {
    b.aC = (b.aC + "<not computed>");
  } else if (($p_sci_LazyList__evaluated__sci_LazyList($thiz) !== $m_sci_LazyList$().aM)) {
    var obj = $thiz.W();
    b.aC = (("" + b.aC) + obj);
    var cursor = $thiz;
    var scout = $thiz.cq();
    if ((cursor !== scout)) {
      cursor = scout;
      var this$1 = scout;
      if (((this$1.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this$1) !== $m_sci_LazyList$().aM))) {
        scout = scout.cq();
        while (true) {
          if ((cursor !== scout)) {
            var this$2 = scout;
            var $x_1 = ((this$2.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this$2) !== $m_sci_LazyList$().aM));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var c = cursor;
            b.aC = (("" + b.aC) + sep);
            var obj$1 = c.W();
            b.aC = (("" + b.aC) + obj$1);
            cursor = cursor.cq();
            scout = scout.cq();
            var this$3 = scout;
            if (((this$3.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this$3) !== $m_sci_LazyList$().aM))) {
              scout = scout.cq();
            }
          } else {
            break;
          }
        }
      }
    }
    var this$4 = scout;
    if ((!((this$4.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this$4) !== $m_sci_LazyList$().aM)))) {
      while ((cursor !== scout)) {
        var c$1 = cursor;
        b.aC = (("" + b.aC) + sep);
        var obj$2 = c$1.W();
        b.aC = (("" + b.aC) + obj$2);
        cursor = cursor.cq();
      }
      if ((!(cursor.dA !== $m_sci_LazyList$Uninitialized$()))) {
        b.aC = (("" + b.aC) + sep);
        b.aC = (b.aC + "<not computed>");
      }
    } else {
      if ((cursor !== $thiz)) {
        var runner = $thiz;
        while ((runner !== scout)) {
          runner = runner.cq();
          scout = scout.cq();
        }
        while (true) {
          var ct = cursor.cq();
          if ((ct !== scout)) {
            var c$2 = cursor;
            b.aC = (("" + b.aC) + sep);
            var obj$3 = c$2.W();
            b.aC = (("" + b.aC) + obj$3);
          }
          cursor = ct;
          if ((cursor !== scout)) {
          } else {
            break;
          }
        }
      }
      b.aC = (("" + b.aC) + sep);
      b.aC = (b.aC + "<cycle>");
    }
  }
  b.aC = (("" + b.aC) + end);
  return b;
}
/** @constructor */
function $c_sci_LazyList() {
  this.dA = null;
  this.o8 = null;
}
$p = $c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
}
$h_sci_LazyList.prototype = $p;
$p.bj = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$p.F = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$p.cJ = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$p.cp = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$p.zM = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$p.at = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$p.g8 = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$p.fK = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$p.az = (function(elem) {
  return $f_sc_LinearSeqOps__contains__O__Z(this, elem);
});
$p.qM = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.iq = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$p.is = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.c8 = (function() {
  return "LinearSeq";
});
$p.c = (function() {
  return ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM);
});
$p.G = (function() {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? 0 : (-1));
});
$p.W = (function() {
  if (($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list");
  } else {
    return this.dA;
  }
});
$p.cq = (function() {
  if (($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list");
  } else {
    return this.o8;
  }
});
$p.au4 = (function() {
  var these = this;
  var those = this;
  if ((!($p_sci_LazyList__evaluated__sci_LazyList(these) === $m_sci_LazyList$().aM))) {
    these = these.cq();
  }
  while ((those !== these)) {
    if (($p_sci_LazyList__evaluated__sci_LazyList(these) === $m_sci_LazyList$().aM)) {
      return this;
    }
    these = these.cq();
    if (($p_sci_LazyList__evaluated__sci_LazyList(these) === $m_sci_LazyList$().aM)) {
      return this;
    }
    these = these.cq();
    if ((these === those)) {
      return this;
    }
    those = those.cq();
  }
  return this;
});
$p.l = (function() {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sc_Iterator$().aZ : new $c_sci_LazyList$LazyIterator(this));
});
$p.al = (function(f) {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    if ((!($p_sci_LazyList__evaluated__sci_LazyList(\u03b4this$tailLocal1) === $m_sci_LazyList$().aM))) {
      f.p(\u03b4this$tailLocal1.W());
      \u03b4this$tailLocal1 = \u03b4this$tailLocal1.cq();
    } else {
      return (void 0);
    }
  }
});
$p.fL = (function(z, op) {
  var \u03b4this$tailLocal2 = this;
  var z$tailLocal1 = z;
  while (true) {
    if (($p_sci_LazyList__evaluated__sci_LazyList(\u03b4this$tailLocal2) === $m_sci_LazyList$().aM)) {
      return z$tailLocal1;
    } else {
      var \u03b4this$tailLocal2$tmp1 = \u03b4this$tailLocal2.cq();
      var z$tailLocal1$tmp1 = op.cm(z$tailLocal1, \u03b4this$tailLocal2.W());
      \u03b4this$tailLocal2 = \u03b4this$tailLocal2$tmp1;
      z$tailLocal1 = z$tailLocal1$tmp1;
    }
  }
});
$p.eH = (function() {
  return "LazyList";
});
$p.UV = (function(suffix) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if (($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) {
      var x1 = suffix.aA();
      if ((x1 instanceof $c_sci_LazyList)) {
        return x1;
      }
      if ((x1.G() === 0)) {
        return $m_sci_LazyList$().aM;
      }
      return $m_sci_LazyList$().Vl(x1.l());
    } else {
      $m_sci_LazyList$();
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), this.W(), this.cq().UV(suffix));
    }
  })));
});
$p.amw = (function(suffix) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().E4(suffix) : this.UV(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix))));
});
$p.amt = (function(elem) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, $m_sci_LazyList$().aM)) : this.UV(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$$anon$20(elem)))));
});
$p.axJ = (function(z, op) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? ($m_sci_LazyList$(), $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), z, $m_sci_LazyList$().aM)) : $p_sci_LazyList__scanLeftImpl__O__F2__sci_LazyList(this, z, op));
});
$p.gM = (function(f) {
  if (($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = this.W();
    var left = this.cq();
    while ((!($p_sci_LazyList__evaluated__sci_LazyList(left) === $m_sci_LazyList$().aM))) {
      reducedRes = f.cm(reducedRes, left.W());
      left = left.cq();
    }
    return reducedRes;
  }
});
$p.agW = (function(pred) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $m_sci_LazyList$().Vm(this, pred, false));
});
$p.atS = (function(pred) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $m_sci_LazyList$().Vm(this, pred, true));
});
$p.fu = (function(p) {
  return new $c_sci_LazyList$WithFilter(this, p);
});
$p.awX = (function(prefix) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().E4(prefix) : ((prefix.G() === 0) ? this : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().No(prefix.l(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this)))))))));
});
$p.El = (function(f) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f));
});
$p.ang = (function(pf) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $m_sci_LazyList$().ajy(this, pf));
});
$p.TM = (function(pf) {
  var \u03b4this$tailLocal3 = this;
  while (true) {
    if (($p_sci_LazyList__evaluated__sci_LazyList(\u03b4this$tailLocal3) === $m_sci_LazyList$().aM)) {
      return $m_s_None$();
    } else {
      var res = pf.aJ(\u03b4this$tailLocal3.W(), $m_sci_LazyList$().RP);
      if ((res === $m_sr_Statics$PFMarker$())) {
        \u03b4this$tailLocal3 = \u03b4this$tailLocal3.cq();
      } else {
        return new $c_s_Some(res);
      }
    }
  }
});
$p.MD = (function(p) {
  var \u03b4this$tailLocal4 = this;
  while (true) {
    if (($p_sci_LazyList__evaluated__sci_LazyList(\u03b4this$tailLocal4) === $m_sci_LazyList$().aM)) {
      return $m_s_None$();
    } else {
      var elem = \u03b4this$tailLocal4.W();
      if ((!(!p.p(elem)))) {
        return new $c_s_Some(elem);
      } else {
        \u03b4this$tailLocal4 = \u03b4this$tailLocal4.cq();
      }
    }
  }
});
$p.ah4 = (function(f) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $m_sci_LazyList$().ajz(this, f));
});
$p.akA = (function(that) {
  return ((((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) || (that.G() === 0)) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadZipImpl__sc_Iterator__sci_LazyList(this, that.l()))))));
});
$p.aEt = (function() {
  return this.akA($m_sci_LazyList$().ah9(0, 1));
});
$p.uI = (function(asPair) {
  return new $c_T2(this.El(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => asPair.p(_$4$2).P()))), this.El(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$5$2) => asPair.p(_$5$2).V()))));
});
$p.atl = (function(n) {
  return ((n <= 0) ? this : (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $m_sci_LazyList$().axC(this, n)));
});
$p.atr = (function(n) {
  return ((n <= 0) ? this : (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : ($m_sci_LazyList$(), $ct_sci_LazyList__O__(new $c_sci_LazyList(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var scout = this;
    var remaining = n;
    while (((remaining > 0) && (!($p_sci_LazyList__evaluated__sci_LazyList(scout) === $m_sci_LazyList$().aM)))) {
      remaining = ((remaining - 1) | 0);
      scout = scout.cq();
    }
    return $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList(this, scout);
  }))))));
});
$p.ayv = (function(n) {
  return (((this.dA !== $m_sci_LazyList$Uninitialized$()) && ($p_sci_LazyList__evaluated__sci_LazyList(this) === $m_sci_LazyList$().aM)) ? $m_sci_LazyList$().aM : $p_sci_LazyList__takeImpl__I__sci_LazyList(this, n));
});
$p.axt = (function() {
  return $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList(this, $m_sci_LazyList$().aM);
});
$p.gG = (function(sb, start, sep, end) {
  this.au4();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.et, start, sep, end);
  return sb;
});
$p.g = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").aC;
});
$p.b4 = (function() {
  return $m_sci_LazyList$();
});
$p.ak = (function() {
  return this.cq();
});
$p.VE = (function() {
  return this.cq();
});
$p.cH = (function(suffix) {
  return this.amw(suffix);
});
$p.aV = (function(elem) {
  return this.amt(elem);
});
$p.zX = (function(z, op) {
  return this.axJ(z, op);
});
$p.bB = (function(pred) {
  return this.agW(pred);
});
$p.bC = (function(pred) {
  return this.atS(pred);
});
$p.ba = (function(elem) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, this);
});
$p.eS = (function(prefix) {
  return this.awX(prefix);
});
$p.X = (function(f) {
  return this.El(f);
});
$p.bD = (function(pf) {
  return this.ang(pf);
});
$p.aL = (function(f) {
  return this.ah4(f);
});
$p.bU = (function(asIterable) {
  return this.ah4(asIterable);
});
$p.bY = (function(that) {
  return this.akA(that);
});
$p.bc = (function() {
  return this.aEt();
});
$p.bo = (function(n) {
  return this.atl(n);
});
$p.b8 = (function(n) {
  return this.atr(n);
});
$p.qO = (function(n) {
  return this.ayv(n);
});
$p.uC = (function() {
  return this.axt();
});
$p.aU = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.p = (function(v1) {
  return $f_sc_LinearSeqOps__apply__I__O(this, (v1 | 0));
});
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hr)));
}
var $d_sci_LazyList = new $TypeData().i($c_sci_LazyList, "scala.collection.immutable.LazyList", ({
  hr: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  cx: 1,
  bo: 1,
  cI: 1,
  cH: 1,
  a: 1
}));
/** @constructor */
function $c_sci_WrappedString(self) {
  this.eF = null;
  this.eF = self;
}
$p = $c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
}
$h_sci_WrappedString.prototype = $p;
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_StringView(this.eF));
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_StringView(this.eF));
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.ba = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$p.qO = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.X = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.uC = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var this$1 = this.eF;
  var x = this$1.length;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.eF.length;
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.zv = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.dw = (function() {
  return $m_sci_WrappedString$().aP();
});
$p.F = (function() {
  return this.eF.length;
});
$p.g = (function() {
  return this.eF;
});
$p.Nu = (function(that, offset) {
  if ((that instanceof $c_sci_WrappedString)) {
    var this$1 = this.eF;
    var prefix = that.eF;
    return ((!((offset >>> 0) > (this$1.length >>> 0))) && (!(!this$1.startsWith(prefix, offset))));
  } else {
    return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
  }
});
$p.Nv = (function() {
  return 0;
});
$p.Ed = (function(elem, from) {
  if ((elem instanceof $Char)) {
    var c = $uC(elem);
    return $f_T__indexOf__I__I__I(this.eF, c, from);
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$p.IV = (function(elem, end) {
  if ((elem instanceof $Char)) {
    var c = $uC(elem);
    return $f_T__lastIndexOf__I__I__I(this.eF, c, end);
  } else {
    return $f_sc_SeqOps__lastIndexOf__O__I__I(this, elem, end);
  }
});
$p.d0 = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var this$1 = this.eF;
    var srcLen = this$1.length;
    var destLen = xs.a.length;
    var limit = ((len < srcLen) ? len : srcLen);
    var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
    var total = ((capacity < limit) ? capacity : limit);
    var copied = ((total < 0) ? 0 : total);
    $f_T__getChars__I__I__AC__I__V(this.eF, 0, copied, xs, start);
    return copied;
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
  }
});
$p.amv = (function(suffix) {
  return ((suffix instanceof $c_sci_WrappedString) ? new $c_sci_WrappedString((this.eF + suffix.eF)) : $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$p.qM = (function(o) {
  return ((o instanceof $c_sci_WrappedString) ? (this.eF === o.eF) : $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o));
});
$p.eH = (function() {
  return "WrappedString";
});
$p.DP = (function() {
  return 2147483647;
});
$p.b = (function(other) {
  return ((other instanceof $c_sci_WrappedString) ? (this.eF === other.eF) : $f_sc_Seq__equals__O__Z(this, other));
});
$p.at = (function(i) {
  return $bC(this.eF.charCodeAt(i));
});
$p.p = (function(v1) {
  var i = (v1 | 0);
  return $bC(this.eF.charCodeAt(i));
});
$p.mF = (function(coll) {
  return $m_sci_WrappedString$().ahj(coll);
});
$p.de = (function(coll) {
  return $m_sci_WrappedString$().ahj(coll);
});
$p.mR = (function() {
  return new $c_sc_StringView(this.eF);
});
$p.cH = (function(suffix) {
  return this.amv(suffix);
});
$p.b4 = (function() {
  return $m_sci_IndexedSeq$();
});
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hI)));
}
var $d_sci_WrappedString = new $TypeData().i($c_sci_WrappedString, "scala.collection.immutable.WrappedString", ({
  hI: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  a: 1
}));
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.St = array;
  return $thiz;
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.St = null;
}
$p = $c_sjsr_WrappedVarArgs.prototype = new $h_O();
$p.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
}
$h_sjsr_WrappedVarArgs.prototype = $p;
$p.eQ = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.eC = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.uI = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.zv = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.qM = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.DP = (function() {
  return $m_sci_IndexedSeqDefaults$().aaX;
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.qO = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.uC = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.cf = (function() {
  return this;
});
$p.b = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().Nq(this);
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.dt = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.aH = (function() {
  return this.F();
});
$p.jn = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$p.Nu = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$p.Nv = (function() {
  return 0;
});
$p.iq = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this)), p, from);
});
$p.Ed = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$p.IV = (function(elem, end) {
  return $f_sc_SeqOps__lastIndexOf__O__I__I(this, elem, end);
});
$p.is = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.az = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem);
});
$p.Ns = (function(otherSize) {
  var x = this.F();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$p.c = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$p.aJ = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.hK = (function(v1) {
  this.at(v1);
});
$p.dw = (function() {
  return $m_sjsr_WrappedVarArgs$().aP();
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.fu = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$p.ak = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.g8 = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.fK = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$p.MD = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.d0 = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.TM = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$p.gG = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$p.uF = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().aY(this);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.hM = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
$p.F = (function() {
  return (this.St.length | 0);
});
$p.at = (function(idx) {
  return this.St[idx];
});
$p.eH = (function() {
  return "WrappedVarArgs";
});
$p.de = (function(coll) {
  return $m_sjsr_WrappedVarArgs$().Uq(coll);
});
$p.aU = (function(x) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
$p.b4 = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
var $d_sjsr_WrappedVarArgs = new $TypeData().i($c_sjsr_WrappedVarArgs, "scala.scalajs.runtime.WrappedVarArgs", ({
  BD: 1,
  a0: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  G: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a1: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_Lupickle_core_LinkedHashMap(underlying) {
  this.Dp = null;
  this.Dp = underlying;
}
$p = $c_Lupickle_core_LinkedHashMap.prototype = new $h_O();
$p.constructor = $c_Lupickle_core_LinkedHashMap;
/** @constructor */
function $h_Lupickle_core_LinkedHashMap() {
}
$h_Lupickle_core_LinkedHashMap.prototype = $p;
$p.al = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$p.g8 = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$p.fL = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$p.gM = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$p.c = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$p.d0 = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$p.gO = (function(num) {
  return $f_sc_IterableOnceOps__sum__s_math_Numeric__O(this, num);
});
$p.gJ = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.fd = (function(ev) {
  return $m_sci_Map$().dH(this);
});
$p.cf = (function() {
  return $m_sci_Seq$().fM(this);
});
$p.jz = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$p.bj = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$p.oS = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$p.bB = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$p.bC = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$p.X = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$p.bU = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$p.bD = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.dt = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$p.bY = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$p.eH = (function() {
  return "Map";
});
$p.b4 = (function() {
  return $m_scm_Iterable$();
});
$p.f6 = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$p.p = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$p.aJ = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$p.jv = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$p.mP = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$p.jo = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$p.Ix = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$p.az = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.aU = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$p.gG = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$p.dw = (function() {
  return $m_scm_Map$().aP();
});
$p.b = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$p.r = (function() {
  return $m_s_util_hashing_MurmurHash3$().UZ(this);
});
$p.g = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.dk = (function(size) {
});
$p.Jf = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$p.oM = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$p.Vc = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key);
});
$p.Iq = (function() {
  $f_scm_MapOps__clear__V(this);
});
$p.G = (function() {
  return (-1);
});
$p.az3 = (function(key, value) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null keys are not allowed");
  }
  var $x_2 = this.Dp;
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return $x_2.avP(key, value, $x_1, false);
});
$p.ama = (function(elem) {
  this.az3(elem.P(), elem.V());
  return this;
});
$p.aH = (function() {
  return this.Dp.nX;
});
$p.l = (function() {
  return new $c_Lupickle_core_LinkedHashMap$$anon$1(this);
});
$p.b9 = (function(key) {
  return $m_s_Option$().Z($p_ju_HashMap__getOrDefaultImpl__O__O__O(this.Dp, key, null));
});
$p.ayo = (function(elem) {
  this.Dp.ax7(elem);
  return this;
});
$p.aD = (function(elem) {
  return this.ama(elem);
});
$p.ED = (function(elem) {
  return this.ayo(elem);
});
$p.aR = (function() {
  return this;
});
$p.de = (function(coll) {
  return $m_scm_Map$().bp(coll);
});
$p.fu = (function(p) {
  return new $c_sc_MapOps$WithFilter(this, p);
});
$p.hK = (function(v1) {
  $f_sc_MapOps__apply__O__O(this, v1);
});
var $d_Lupickle_core_LinkedHashMap = new $TypeData().i($c_Lupickle_core_LinkedHashMap, "upickle.core.LinkedHashMap", ({
  De: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  a3: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  bC: 1,
  bB: 1,
  DN: 1
}));
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.dM = null;
  this.dM = rootNode;
}
$p = $c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$p.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
}
$h_sci_HashMap.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.MB(pred, false);
});
$p.bC = (function(pred) {
  return this.MB(pred, true);
});
$p.uy = (function() {
  return $m_sci_HashMap$();
});
$p.G = (function() {
  return this.dM.e7;
});
$p.aH = (function() {
  return this.dM.e7;
});
$p.c = (function() {
  return (this.dM.e7 === 0);
});
$p.zQ = (function() {
  return ((this.dM.e7 === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this));
});
$p.l = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sci_MapKeyValueTupleIterator(this.dM));
});
$p.jv = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sci_MapKeyIterator(this.dM));
});
$p.mP = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sci_MapValueIterator(this.dM));
});
$p.bX = (function() {
  return (this.c() ? $m_sc_Iterator$().aZ : new $c_sci_MapKeyValueTupleReverseIterator(this.dM));
});
$p.az = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().k(key);
  var keyHash = $m_sc_Hashing$().bV(keyUnimprovedHash);
  return this.dM.U1(key, keyUnimprovedHash, keyHash, 0);
});
$p.p = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().k(key);
  var keyHash = $m_sc_Hashing$().bV(keyUnimprovedHash);
  return this.dM.TF(key, keyUnimprovedHash, keyHash, 0);
});
$p.b9 = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().k(key);
  var keyHash = $m_sc_Hashing$().bV(keyUnimprovedHash);
  return this.dM.MI(key, keyUnimprovedHash, keyHash, 0);
});
$p.f6 = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().k(key);
  var keyHash = $m_sc_Hashing$().bV(keyUnimprovedHash);
  return this.dM.Ut(key, keyUnimprovedHash, keyHash, 0, default$1);
});
$p.jC = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().k(key);
  var newRootNode = this.dM.VO(key, value, keyUnimprovedHash, $m_sc_Hashing$().bV(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.dM) ? this : new $c_sci_HashMap(newRootNode));
});
$p.al = (function(f) {
  this.dM.al(f);
});
$p.jo = (function(f) {
  this.dM.jo(f);
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.dM;
      var x$2 = that.dM;
      return ((x === null) ? (x$2 === null) : x.b(x$2));
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that);
  }
});
$p.r = (function() {
  if (this.c()) {
    return $m_s_util_hashing_MurmurHash3$().LF;
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.dM);
    return $m_s_util_hashing_MurmurHash3$().Aa(hashIterator, $m_s_util_hashing_MurmurHash3$().qp);
  }
});
$p.eH = (function() {
  return "HashMap";
});
$p.MB = (function(pred, isFlipped) {
  var newRootNode = this.dM.agX(pred, isFlipped);
  return ((newRootNode === this.dM) ? this : ((newRootNode.e7 === 0) ? $m_sci_HashMap$().kr : new $c_sci_HashMap(newRootNode)));
});
$p.N6 = (function() {
  return this.zQ();
});
$p.hk = (function(key, value) {
  return this.jC(key, value);
});
$p.W = (function() {
  return this.l().e();
});
$p.cJ = (function() {
  return this.bX().e();
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.bo = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ho)));
}
var $d_sci_HashMap = new $TypeData().i($c_sci_HashMap, "scala.collection.immutable.HashMap", ({
  ho: 1,
  b4: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  G: 1,
  aR: 1,
  aQ: 1,
  C: 1,
  h7: 1,
  yy: 1,
  a: 1,
  a4: 1
}));
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.yz)));
}
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.yD)));
}
/** @constructor */
function $c_scm_AbstractBuffer() {
}
$p = $c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
}
$h_scm_AbstractBuffer.prototype = $p;
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
/** @constructor */
function $c_scm_AbstractMap() {
}
$p = $c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$p.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
}
$h_scm_AbstractMap.prototype = $p;
$p.b4 = (function() {
  return $m_scm_Iterable$();
});
$p.aR = (function() {
  return this;
});
/** @constructor */
function $c_s_Enumeration$ValueSet(outer, nnIds) {
  this.Cz = null;
  this.o0 = null;
  this.Cz = nnIds;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.o0 = outer;
}
$p = $c_s_Enumeration$ValueSet.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_s_Enumeration$ValueSet;
/** @constructor */
function $h_s_Enumeration$ValueSet() {
}
$h_s_Enumeration$ValueSet.prototype = $p;
$p.gJ = (function(ord) {
  return $f_sc_SortedSetOps__min__s_math_Ordering__O(this, ord);
});
$p.fq = (function(ord) {
  return $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord);
});
$p.c8 = (function() {
  return "SortedSet";
});
$p.b = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.oX = (function() {
  return this.o0.alQ();
});
$p.G = (function() {
  return $f_sc_BitSetOps__size__I(this.Cz);
});
$p.c = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this.Cz);
});
$p.asK = (function(v) {
  return $f_sc_BitSetOps__contains__I__Z(this.Cz, ((v.i9 - this.o0.j1) | 0));
});
$p.auP = (function(value) {
  return new $c_s_Enumeration$ValueSet(this.o0, this.Cz.ahI(((value.i9 - this.o0.j1) | 0)));
});
$p.l = (function() {
  return new $c_sc_Iterator$$anon$9(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((id$3) => {
    var id$2 = (id$3 | 0);
    var this$3 = this.o0;
    var x = ((this.o0.j1 + id$2) | 0);
    return this$3.mf.p(x);
  })), new $c_sc_BitSetOps$$anon$1(0, this.Cz));
});
$p.eH = (function() {
  return (this.o0 + ".ValueSet");
});
$p.MH = (function(coll) {
  return this.o0.Tv().MH(coll);
});
$p.dw = (function() {
  return new $c_s_Enumeration$ValueSet$$anon$1(this.o0.Tv());
});
$p.az = (function(elem) {
  return this.asK(elem);
});
$p.kL = (function(elem) {
  return this.auP(elem);
});
$p.mF = (function(coll) {
  return this.MH(coll);
});
$p.de = (function(coll) {
  return this.MH(coll);
});
$p.Vk = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$p.Vj = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$p.fu = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p);
});
var $d_s_Enumeration$ValueSet = new $TypeData().i($c_s_Enumeration$ValueSet, "scala.Enumeration$ValueSet", ({
  vO: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  br: 1,
  bt: 1,
  bs: 1,
  b3: 1,
  c4: 1,
  c3: 1,
  C: 1,
  a: 1
}));
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.S6 = loadFactor;
  $thiz.f2 = new ($d_scm_HashSet$Node.r().C)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.S7 = $p_scm_HashSet__newThreshold__I__I($thiz, $thiz.f2.a.length);
  $thiz.tE = 0;
  return $thiz;
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz;
}
function $p_scm_HashSet__improveHash__I__I($thiz, originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0));
}
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($thiz.f2.a.length - 1) | 0));
  matchResult4: {
    var x10 = $thiz.f2.a[idx];
    if ((x10 === null)) {
      $thiz.f2.a[idx] = new $c_scm_HashSet$Node(elem, hash, null);
      break matchResult4;
    }
    var prev = null;
    var n = x10;
    while (((n !== null) && (n.mq <= hash))) {
      if (((n.mq === hash) && $m_sr_BoxesRunTime$().B(elem, n.qn))) {
        return false;
      }
      prev = n;
      n = n.f3;
    }
    if ((prev === null)) {
      $thiz.f2.a[idx] = new $c_scm_HashSet$Node(elem, hash, x10);
    } else {
      var this$3 = prev;
      var n$1 = new $c_scm_HashSet$Node(elem, hash, prev.f3);
      this$3.f3 = n$1;
    }
  }
  $thiz.tE = ((1 + $thiz.tE) | 0);
  return true;
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $thiz.f2.a.length;
  $thiz.S7 = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.tE === 0)) {
    $thiz.f2 = new ($d_scm_HashSet$Node.r().C)(newlen);
  } else {
    $thiz.f2 = $m_ju_Arrays$().cn($thiz.f2, newlen);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.f2.a[i];
        if ((old !== null)) {
          preLow.f3 = null;
          preHigh.f3 = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.f3;
            if (((n.mq & oldlen) === 0)) {
              var this$2 = lastLow;
              var n$1 = n;
              this$2.f3 = n$1;
              lastLow = n;
            } else {
              var this$3 = lastHigh;
              var n$2 = n;
              this$3.f3 = n$2;
              lastHigh = n;
            }
            n = next;
          }
          var this$4 = lastLow;
          this$4.f3 = null;
          if ((old !== preLow.f3)) {
            $thiz.f2.a[i] = preLow.f3;
          }
          if ((preHigh.f3 !== null)) {
            $thiz.f2.a[((i + oldlen) | 0)] = preHigh.f3;
            var this$5 = lastHigh;
            this$5.f3 = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.S6));
}
/** @constructor */
function $c_scm_HashSet() {
  this.S6 = 0.0;
  this.f2 = null;
  this.S7 = 0;
  this.tE = 0;
}
$p = $c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$p.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
}
$h_scm_HashSet.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return this.tE;
});
$p.az = (function(elem) {
  var hash = $p_scm_HashSet__improveHash__I__I(this, $m_sr_Statics$().k(elem));
  matchResult1: {
    var $x_1;
    var x1 = this.f2.a[(hash & ((this.f2.a.length - 1) | 0))];
    if ((x1 === null)) {
      var $x_1 = null;
      break matchResult1;
    }
    var $x_1 = x1.atX(elem, hash);
  }
  return ($x_1 !== null);
});
$p.dk = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.S6)));
  if ((target > this.f2.a.length)) {
    $p_scm_HashSet__growTable__I__V(this, target);
  }
});
$p.qA = (function(elem) {
  if ((((1 + this.tE) | 0) >= this.S7)) {
    $p_scm_HashSet__growTable__I__V(this, (this.f2.a.length << 1));
  }
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, $p_scm_HashSet__improveHash__I__I(this, $m_sr_Statics$().k(elem)));
});
$p.afu = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashSet)) {
    var f = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((v1$2, v2$2) => {
      $p_scm_HashSet__addElem__O__I__Z(this, v1$2, $p_scm_HashSet__improveHash__I__I(this, (v2$2 | 0)));
    }));
    xs.dz.Uj(f);
    return this;
  } else if ((xs instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(xs);
    while (iter.f()) {
      var next = iter.e();
      $p_scm_HashSet__addElem__O__I__Z(this, next.qn, next.mq);
    }
    return this;
  } else if ((xs instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(xs);
    while (iter$2.f()) {
      var next$2 = iter$2.e();
      $p_scm_HashSet__addElem__O__I__Z(this, next$2.mr, next$2.oj);
    }
    return this;
  } else {
    return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
});
$p.l = (function() {
  return new $c_scm_HashSet$$anon$1(this);
});
$p.b4 = (function() {
  return $m_scm_HashSet$();
});
$p.G = (function() {
  return this.tE;
});
$p.c = (function() {
  return (this.tE === 0);
});
$p.al = (function(f) {
  var len = this.f2.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.f2.a[i];
    if ((n !== null)) {
      n.al(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.eH = (function() {
  return "HashSet";
});
$p.r = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.f()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().Aa(hashIterator, $m_s_util_hashing_MurmurHash3$().Ho);
});
$p.cz = (function(elems) {
  return this.afu(elems);
});
$p.aD = (function(elem) {
  this.qA(elem);
  return this;
});
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hX)));
}
var $d_scm_HashSet = new $TypeData().i($c_scm_HashSet, "scala.collection.mutable.HashSet", ({
  hX: 1,
  cR: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a3: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  cV: 1,
  cU: 1,
  C: 1,
  a: 1
}));
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.xR)));
}
function $p_sci_Range__isInexact$1__Z($thiz) {
  return ($thiz.oR() ? ($thiz.j7 !== $thiz.id) : ((($thiz.j7 + $thiz.bA) | 0) !== $thiz.id));
}
function $ct_sci_Range__I__I__I__($thiz, start, end, step) {
  $thiz.cF = start;
  $thiz.id = end;
  $thiz.bA = step;
  $thiz.dN = ($thiz.oR() ? ((step >= 0) ? (start > end) : (start < end)) : ((step >= 0) ? (start >= end) : (start <= end)));
  if ((step === 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  }
  var stepSign = (step >> 31);
  var gap = (((((end - start) | 0) ^ stepSign) - stepSign) | 0);
  var absStep = (((step ^ stepSign) - stepSign) | 0);
  var div = (((gap >>> 0) / ($checkIntDivisor(absStep) >>> 0)) | 0);
  $thiz.ie = (($thiz.oR() || (Math.imul(absStep, div) !== gap)) ? ((1 + div) | 0) : div);
  if ((((-3) & ((1 + step) | 0)) === 0)) {
    var $x_1 = ($thiz.oR() ? end : ((end - step) | 0));
  } else {
    var n = (($thiz.ie - 1) | 0);
    var $x_1 = (($thiz.cF + Math.imul($thiz.bA, n)) | 0);
  }
  $thiz.j7 = $x_1;
  return $thiz;
}
/** @constructor */
function $c_sci_Range() {
  this.cF = 0;
  this.id = 0;
  this.bA = 0;
  this.dN = false;
  this.ie = 0;
  this.j7 = 0;
}
$p = $c_sci_Range.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_Range;
/** @constructor */
function $h_sci_Range() {
}
$h_sci_Range.prototype = $p;
$p.eQ = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.uI = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.zv = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.hM = (function() {
  return $m_sci_IndexedSeq$();
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.l = (function() {
  return new $c_sci_RangeIterator(this.cF, this.bA, this.j7, this.dN);
});
$p.c = (function() {
  return this.dN;
});
$p.F = (function() {
  if (this.dN) {
    return 0;
  } else {
    if ((this.ie <= 0)) {
      $m_sci_Range$().oY(this.cF, this.id, this.bA, this.oR());
    }
    return this.ie;
  }
});
$p.qK = (function() {
  if (this.dN) {
    var $x_1 = $m_sci_Range$().Vn("last");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
  } else {
    return this.j7;
  }
});
$p.uw = (function() {
  if (this.dN) {
    var $x_1 = $m_sci_Range$().Vn("head");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
  } else {
    return this.cF;
  }
});
$p.ays = (function() {
  if (this.dN) {
    var $x_1 = $m_sci_Range$().Vn("tail");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.b6 : $x_1);
  }
  if ((this.ie === 1)) {
    var value = this.id;
    return new $c_sci_Range$Exclusive(value, value, this.bA);
  } else {
    return (this.oR() ? new $c_sci_Range$Inclusive(((this.cF + this.bA) | 0), this.id, this.bA) : new $c_sci_Range$Exclusive(((this.cF + this.bA) | 0), this.id, this.bA));
  }
});
$p.aw8 = (function(f) {
  this.ajB();
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.asO = (function(start, end, step, isInclusive) {
  return (isInclusive ? new $c_sci_Range$Inclusive(start, end, step) : new $c_sci_Range$Exclusive(start, end, step));
});
$p.ajB = (function() {
  if (((this.ie <= 0) && (!this.dN))) {
    $m_sci_Range$().oY(this.cF, this.id, this.bA, this.oR());
  }
});
$p.al = (function(f) {
  if ((!this.dN)) {
    var i = this.cF;
    while (true) {
      f.p(i);
      if ((i === this.j7)) {
        return (void 0);
      }
      i = ((i + this.bA) | 0);
    }
  }
});
$p.Ed = (function(elem, from) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var pos = this.ajA(x2);
    return ((pos >= from) ? pos : (-1));
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$p.IV = (function(elem, end) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var pos = this.ajA(x2);
    return ((pos <= end) ? pos : (-1));
  } else {
    return $f_sc_SeqOps__lastIndexOf__O__I__I(this, elem, end);
  }
});
$p.ajA = (function(i) {
  return (this.age(i) ? ((((i - this.cF) | 0) / $checkIntDivisor(this.bA)) | 0) : (-1));
});
$p.qM = (function(that) {
  if ((that instanceof $c_sci_Range)) {
    var x1$2 = this.F();
    switch (x1$2) {
      case 0: {
        return that.dN;
        break;
      }
      case 1: {
        return ((that.F() === 1) && (this.cF === that.cF));
        break;
      }
      default: {
        return ((that.F() === x1$2) && ((this.cF === that.cF) && (this.bA === that.bA)));
      }
    }
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, that);
  }
});
$p.ayx = (function(n) {
  if (((n <= 0) || this.dN)) {
    var value = this.cF;
    return new $c_sci_Range$Exclusive(value, value, this.bA);
  } else if (((n >>> 0) > (((this.ie - 1) | 0) >>> 0))) {
    return this;
  } else {
    var $x_1 = this.cF;
    var n$1 = ((n - 1) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.cF + Math.imul(this.bA, n$1)) | 0), this.bA);
  }
});
$p.atm = (function(n) {
  if (((n <= 0) || this.dN)) {
    return this;
  } else if (((n >>> 0) > (((this.ie - 1) | 0) >>> 0))) {
    var value = this.id;
    return new $c_sci_Range$Exclusive(value, value, this.bA);
  } else {
    return this.asO(((this.cF + Math.imul(this.bA, n)) | 0), this.id, this.bA, this.oR());
  }
});
$p.ats = (function(n) {
  if (((n <= 0) || this.dN)) {
    return this;
  } else if (((n >>> 0) > (((this.ie - 1) | 0) >>> 0))) {
    var value = this.id;
    return new $c_sci_Range$Exclusive(value, value, this.bA);
  } else {
    var $x_1 = this.cF;
    var n$1 = ((((this.ie - 1) | 0) - n) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.cF + Math.imul(this.bA, n$1)) | 0), this.bA);
  }
});
$p.ajr = (function() {
  return (this.dN ? this : new $c_sci_Range$Inclusive(this.qK(), this.cF, ((-this.bA) | 0)));
});
$p.age = (function(x) {
  return ((!this.dN) && ((this.bA > 0) ? ((!((x < this.cF) || (x > this.j7))) && ((this.bA === 1) || ((((((x - this.cF) | 0) >>> 0) % ($checkIntDivisor(this.bA) >>> 0)) | 0) === 0))) : ((!((x > this.cF) || (x < this.j7))) && ((this.bA === (-1)) || ((((((this.cF - x) | 0) >>> 0) % ($checkIntDivisor(((-this.bA) | 0)) >>> 0)) | 0) === 0)))));
});
$p.az = (function(elem) {
  return ($isInt(elem) ? this.age((elem | 0)) : $f_sc_SeqOps__contains__O__Z(this, elem));
});
$p.ayq = (function(num) {
  if ((num === $m_s_math_Numeric$IntIsIntegral$())) {
    if (this.dN) {
      return 0;
    } else if ((this.F() === 1)) {
      return this.uw();
    } else {
      var value = this.F();
      var hi = (value >> 31);
      var value$1 = this.uw();
      var hi$1 = (value$1 >> 31);
      var value$2 = this.qK();
      var hi$2 = (value$2 >> 31);
      var lo = ((value$1 + value$2) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo >>> 0) < (value$1 >>> 0)) | 0)) | 0);
      var a0 = (65535 & value);
      var a1 = ((value >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(value, hi$3) + Math.imul(hi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((hi$4 >>> 31) | 0);
      var lo$3 = ((lo$1 + lo$2) | 0);
      return (((lo$3 >>> 1) | 0) | (((hi$4 + (((lo$3 >>> 0) < (lo$1 >>> 0)) | 0)) | 0) << 31));
    }
  } else {
    if ((!this.dN)) {
      var acc = num.ID(0);
      var i = this.uw();
      while (true) {
        acc = num.Ni(acc, i);
        if ((i === this.j7)) {
          return num.VG(acc);
        }
        i = ((i + this.bA) | 0);
      }
    }
    return num.VG(num.ID(0));
  }
});
$p.aiS = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.bA > 0) ? this.uw() : this.qK()) : ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord) ? ((this.bA > 0) ? this.qK() : this.uw()) : ($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord) | 0)));
});
$p.aiQ = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.bA > 0) ? this.qK() : this.uw()) : ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($m_s_math_Ordering$Int$(), ord) ? ((this.bA > 0) ? this.uw() : this.qK()) : ($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord) | 0)));
});
$p.DP = (function() {
  return 2147483647;
});
$p.b = (function(other) {
  if ((other instanceof $c_sci_Range)) {
    if (this.dN) {
      return other.dN;
    } else if (((!other.dN) && (this.cF === other.cF))) {
      var l0 = this.qK();
      return ((l0 === other.qK()) && ((this.cF === l0) || (this.bA === other.bA)));
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$p.r = (function() {
  if ((this.F() >= 2)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    return this$1.aji(this.cF, this.bA, this.j7, this$1.ea);
  } else {
    return $m_s_util_hashing_MurmurHash3$().Nq(this);
  }
});
$p.g = (function() {
  var preposition = (this.oR() ? "to" : "until");
  var stepped = ((this.bA === 1) ? "" : (" by " + this.bA));
  return ((((((((this.dN ? "empty " : ($p_sci_Range__isInexact$1__Z(this) ? "inexact " : "")) + "Range ") + this.cF) + " ") + preposition) + " ") + this.id) + stepped);
});
$p.eH = (function() {
  return "Range";
});
$p.aye = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.bA > 0) ? this : this.ajr()) : $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord));
});
$p.afM = (function(idx) {
  if ((((idx < 0) || (idx >= this.ie)) || this.dN)) {
    this.ajB();
    var max = (this.dN ? (-1) : ((this.ie - 1) | 0));
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + max) + ")"));
  } else {
    return ((this.cF + Math.imul(this.bA, idx)) | 0);
  }
});
$p.b4 = (function() {
  return $m_sci_IndexedSeq$();
});
$p.eC = (function(ord) {
  return this.aye(ord);
});
$p.jn = (function() {
  return this;
});
$p.fq = (function(ord) {
  return this.aiQ(ord);
});
$p.gJ = (function(ord) {
  return this.aiS(ord);
});
$p.gO = (function(num) {
  return this.ayq(num);
});
$p.uC = (function() {
  return this.ajr();
});
$p.b8 = (function(n) {
  return this.ats(n);
});
$p.bo = (function(n) {
  return this.atm(n);
});
$p.qO = (function(n) {
  return this.ayx(n);
});
$p.p = (function(v1) {
  return this.afM((v1 | 0));
});
$p.at = (function(i) {
  return this.afM(i);
});
$p.X = (function(f) {
  return this.aw8(f);
});
$p.ak = (function() {
  return this.ays();
});
$p.W = (function() {
  return this.uw();
});
$p.cJ = (function() {
  return this.qK();
});
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cO)));
}
function $p_scm_LinkedHashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_LinkedHashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((0.75 * size));
}
function $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, key, hash) {
  var e = new $c_scm_LinkedHashSet$Entry(key, hash);
  if (($thiz.D4 === null)) {
    $thiz.D4 = e;
  } else {
    var x$proxy14 = $thiz.D5;
    if ((x$proxy14 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    x$proxy14.Ly = e;
    e.abh = $thiz.D5;
  }
  $thiz.D5 = e;
  return e;
}
function $p_scm_LinkedHashSet__put0__O__I__I__Z($thiz, elem, hash, idx) {
  matchResult2: {
    var x2 = $thiz.gA.a[idx];
    if ((x2 === null)) {
      $thiz.gA.a[idx] = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
      break matchResult2;
    }
    var prev = null;
    var n = x2;
    while (((n !== null) && (n.oj <= hash))) {
      if (((n.oj === hash) && $m_sr_BoxesRunTime$().B(elem, n.mr))) {
        return false;
      }
      prev = n;
      n = n.fF;
    }
    var nnode = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
    if ((prev === null)) {
      nnode.fF = x2;
      $thiz.gA.a[idx] = nnode;
    } else {
      nnode.fF = prev.fF;
      prev.fF = nnode;
    }
  }
  $thiz.jc = ((1 + $thiz.jc) | 0);
  return true;
}
function $p_scm_LinkedHashSet__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new hash table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.gA.a.length;
  $thiz.S9 = $p_scm_LinkedHashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.jc === 0)) {
    $thiz.gA = new ($d_scm_LinkedHashSet$Entry.r().C)(newlen);
  } else {
    $thiz.gA = $m_ju_Arrays$().cn($thiz.gA, newlen);
    var preLow = new $c_scm_LinkedHashSet$Entry(null, 0);
    var preHigh = new $c_scm_LinkedHashSet$Entry(null, 0);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.gA.a[i];
        if ((old !== null)) {
          preLow.fF = null;
          preHigh.fF = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.fF;
            if (((n.oj & oldlen) === 0)) {
              lastLow.fF = n;
              lastLow = n;
            } else {
              lastHigh.fF = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.fF = null;
          if ((old !== preLow.fF)) {
            $thiz.gA.a[i] = preLow.fF;
          }
          if ((preHigh.fF !== null)) {
            $thiz.gA.a[((i + oldlen) | 0)] = preHigh.fF;
            lastHigh.fF = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
/** @constructor */
function $c_scm_LinkedHashSet() {
  this.D4 = null;
  this.D5 = null;
  this.gA = null;
  this.S9 = 0;
  this.jc = 0;
  this.D4 = null;
  this.D5 = null;
  this.gA = new ($d_scm_LinkedHashSet$Entry.r().C)($p_scm_LinkedHashSet__tableSizeFor__I__I(this, 16));
  this.S9 = $p_scm_LinkedHashSet__newThreshold__I__I(this, this.gA.a.length);
  this.jc = 0;
}
$p = $c_scm_LinkedHashSet.prototype = new $h_scm_AbstractSet();
$p.constructor = $c_scm_LinkedHashSet;
/** @constructor */
function $h_scm_LinkedHashSet() {
}
$h_scm_LinkedHashSet.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.b4 = (function() {
  return $m_scm_LinkedHashSet$();
});
$p.cJ = (function() {
  if ((this.jc > 0)) {
    var x$proxy1 = this.D5;
    if ((x$proxy1 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return x$proxy1.mr;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .last on empty LinkedHashSet");
  }
});
$p.oS = (function() {
  if ((this.jc > 0)) {
    var x$proxy2 = this.D5;
    if ((x$proxy2 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return new $c_s_Some(x$proxy2.mr);
  } else {
    return $m_s_None$();
  }
});
$p.bj = (function() {
  if ((this.jc > 0)) {
    var x$proxy4 = this.D4;
    if ((x$proxy4 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    return new $c_s_Some(x$proxy4.mr);
  } else {
    return $m_s_None$();
  }
});
$p.aH = (function() {
  return this.jc;
});
$p.G = (function() {
  return this.jc;
});
$p.c = (function() {
  return (this.jc === 0);
});
$p.az = (function(elem) {
  var originalHash = $m_sr_Statics$().k(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  matchResult1: {
    var $x_1;
    var x1 = this.gA.a[(hash & ((this.gA.a.length - 1) | 0))];
    if ((x1 === null)) {
      var $x_1 = null;
      break matchResult1;
    }
    var $x_1 = x1.atU(elem, hash);
  }
  return ($x_1 !== null);
});
$p.dk = (function(size) {
  var target = $p_scm_LinkedHashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / 0.75)));
  if ((target > this.gA.a.length)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, target);
  }
});
$p.qA = (function(elem) {
  if ((((1 + this.jc) | 0) >= this.S9)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, (this.gA.a.length << 1));
  }
  var originalHash = $m_sr_Statics$().k(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_LinkedHashSet__put0__O__I__I__Z(this, elem, hash, (hash & ((this.gA.a.length - 1) | 0)));
});
$p.am6 = (function(elem) {
  this.qA(elem);
  return this;
});
$p.l = (function() {
  return new $c_scm_LinkedHashSet$$anon$1(this);
});
$p.al = (function(f) {
  var cur = this.D4;
  while ((cur !== null)) {
    f.p(cur.mr);
    cur = cur.Ly;
  }
});
$p.r = (function() {
  var setHashIterator = (this.c() ? new $c_scm_LinkedHashSet$$anon$1(this) : new $c_scm_LinkedHashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().Aa(setHashIterator, $m_s_util_hashing_MurmurHash3$().Ho);
});
$p.c8 = (function() {
  return "LinkedHashSet";
});
$p.aD = (function(elem) {
  return this.am6(elem);
});
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hY)));
}
var $d_scm_LinkedHashSet = new $TypeData().i($c_scm_LinkedHashSet, "scala.collection.mutable.LinkedHashSet", ({
  hY: 1,
  cR: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a3: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  cV: 1,
  cU: 1,
  C: 1,
  a: 1,
  a4: 1
}));
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that;
  } else if ($f_sc_SeqOps__isEmpty__Z(that)) {
    return $thiz;
  } else {
    var thisIsObj = ($thiz.d2() instanceof $ac_O);
    if ((thisIsObj !== (that.d2() instanceof $ac_O))) {
      return null;
    } else if (thisIsObj) {
      var ax = $thiz.d2();
      var ay = that.d2();
      var len = (($m_jl_reflect_Array$().b1(ax) + $m_jl_reflect_Array$().b1(ay)) | 0);
      var a = new $ac_O(len);
      var length = $m_jl_reflect_Array$().b1(ax);
      ax.av(0, a, 0, length);
      var destPos = $m_jl_reflect_Array$().b1(ax);
      var length$1 = $m_jl_reflect_Array$().b1(ay);
      ay.av(0, a, destPos, length$1);
      return $m_sci_ArraySeq$().ge(a);
    } else {
      var ax$2 = $thiz.d2();
      var ay$2 = that.d2();
      var len$2 = (($m_jl_reflect_Array$().b1(ax$2) + $m_jl_reflect_Array$().b1(ay$2)) | 0);
      var a$2 = $thiz.e5().fb(len$2);
      var length$2 = $m_jl_reflect_Array$().b1(ax$2);
      ax$2.av(0, a$2, 0, length$2);
      var destPos$1 = $m_jl_reflect_Array$().b1(ax$2);
      var length$3 = $m_jl_reflect_Array$().b1(ay$2);
      ay$2.av(0, a$2, destPos$1, length$3);
      return $m_sci_ArraySeq$().ge(a$2);
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = suffix$1.G();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      $m_jl_reflect_Array$().b1($thiz.d2());
    }
    var xs$1 = $thiz.d2();
    var length = $m_jl_reflect_Array$().b1(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().cZ(xs$1, i);
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0);
    }
    var it = suffix$1.l();
    while (it.f()) {
      var elem$1 = it.e();
      var unboxedElem$1 = ((elem$1 === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem$1);
      jsElems.push(unboxedElem$1);
    }
    return $m_sci_ArraySeq$().ge($m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
  }
}
function $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq($thiz, prefix$1) {
  var k = prefix$1.G();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      $m_jl_reflect_Array$().b1($thiz.d2());
    }
    var it = prefix$1.l();
    while (it.f()) {
      var elem = it.e();
      var unboxedElem = ((elem === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem);
      jsElems.push(unboxedElem);
    }
    if ((k < 0)) {
      (jsElems.length | 0);
      $m_jl_reflect_Array$().b1($thiz.d2());
    }
    var xs$2 = $thiz.d2();
    var length = $m_jl_reflect_Array$().b1(xs$2);
    var i = 0;
    while ((i < length)) {
      var elem$1 = $m_sr_ScalaRunTime$().cZ(xs$2, i);
      var unboxedElem$1 = ((elem$1 === null) ? $m_scm_ArrayBuilder$().u($d_O.l()) : elem$1);
      jsElems.push(unboxedElem$1);
      i = ((1 + i) | 0);
    }
    return $m_sci_ArraySeq$().ge($m_scm_ArrayBuilder$().v($d_O.l(), jsElems));
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
}
$p = $c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
}
$h_sci_ArraySeq.prototype = $p;
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.zv = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.qM = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.uI = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.eQ = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.mF = (function(coll) {
  return $m_sci_ArraySeq$().Uo(coll, this.e5());
});
$p.dw = (function() {
  return $m_sci_ArraySeq$().Nb(this.e5());
});
$p.hM = (function() {
  return $m_sci_ArraySeq$().Lw;
});
$p.aw7 = (function(f) {
  var a = new $ac_O(this.F());
  var i = 0;
  while ((i < a.a.length)) {
    a.a[i] = f.p(this.at(i));
    i = ((1 + i) | 0);
  }
  return $m_sci_ArraySeq$().ge(a);
});
$p.em = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.d2();
  var dest = new $ac_O(((1 + $m_jl_reflect_Array$().b1(xs)) | 0));
  dest.a[0] = elem;
  $m_s_Array$().dd(xs, 0, dest, 1, $m_jl_reflect_Array$().b1(xs));
  return $x_1.ge(dest);
});
$p.ed = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.d2();
  var newLength = ((1 + $m_jl_reflect_Array$().b1(xs)) | 0);
  if ($d_O.R($objectGetClass(xs).ax.Q().ax)) {
    var dest$1 = $m_ju_Arrays$().Iv(xs, newLength, $d_O.r().l());
  } else {
    var dest = new $ac_O(newLength);
    $m_s_Array$().dd(xs, 0, dest, 0, $m_jl_reflect_Array$().b1(xs));
    var dest$1 = dest;
  }
  var x1 = $m_jl_reflect_Array$().b1(xs);
  dest$1.a[x1] = elem;
  return $x_1.ge(dest$1);
});
$p.amu = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, suffix);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix);
  }
});
$p.awW = (function(prefix) {
  if ((prefix instanceof $c_sci_ArraySeq)) {
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(prefix, this);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq(this, prefix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq(this, prefix);
  }
});
$p.aEr = (function(that) {
  if ((that instanceof $c_sci_ArraySeq)) {
    var x = this.F();
    var that$1 = that.F();
    var n = ((x < that$1) ? x : that$1);
    var evidence$1__runtimeClass;
    var evidence$1__runtimeClass = $d_T2.l();
    var n1 = ((n > 0) ? n : 0);
    var componentType = evidence$1__runtimeClass;
    var elements = componentType.ax.U(n1);
    var i = 0;
    while ((i < n)) {
      var $x_2 = $m_sr_ScalaRunTime$();
      var $x_1 = i;
      var x0 = i;
      $x_2.bQ(elements, $x_1, new $c_T2(this.at(x0), that.at(x0)));
      i = ((1 + i) | 0);
    }
    return $m_sci_ArraySeq$().ge(elements);
  } else {
    var b = $m_sci_ArraySeq$().Lw.aP();
    var it1 = this.l();
    var it2 = that.l();
    while ((it1.f() && it2.f())) {
      b.aD(new $c_T2(it1.e(), it2.e()));
    }
    return b.aR();
  }
});
$p.ayu = (function(n) {
  return (($m_jl_reflect_Array$().b1(this.d2()) <= n) ? this : $m_sci_ArraySeq$().ge($m_sc_ArrayOps$().uD(this.d2(), 0, n)));
});
$p.atk = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().ge($m_sc_ArrayOps$().atn(this.d2(), n)));
});
$p.atq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().ge($m_sc_ArrayOps$().att(this.d2(), n)));
});
$p.fL = (function(z, f) {
  var array = this.d2();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().b1(array))) {
    var a = $m_sr_ScalaRunTime$().cZ(array, i);
    b = f.cm(b, a);
    i = ((1 + i) | 0);
  }
  return b;
});
$p.ayr = (function() {
  return $m_sci_ArraySeq$().ge($m_sc_ArrayOps$().ayt(this.d2()));
});
$p.axs = (function() {
  var $x_1 = $m_sci_ArraySeq$();
  var ev$9 = this.d2();
  var len = $m_jl_reflect_Array$().b1(ev$9);
  var res = $m_s_reflect_ClassTag$().um($objectGetClass(ev$9).ax.Q()).fb(len);
  var i = 0;
  while ((i < len)) {
    $m_sr_ScalaRunTime$().bQ(res, ((((len - i) | 0) - 1) | 0), $m_sr_ScalaRunTime$().cZ(ev$9, i));
    i = ((1 + i) | 0);
  }
  return $x_1.ge(res);
});
$p.eH = (function() {
  return "ArraySeq";
});
$p.d0 = (function(xs, start, len) {
  var srcLen = this.F();
  var destLen = $m_jl_reflect_Array$().b1(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().dd(this.d2(), 0, xs, start, copied);
  }
  return copied;
});
$p.DP = (function() {
  return 2147483647;
});
$p.ft = (function(ord) {
  if (($m_jl_reflect_Array$().b1(this.d2()) <= 1)) {
    return this;
  } else {
    var original = this.d2();
    var newLength = this.F();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    if ($d_O.R($objectGetClass(original).ax.Q().ax)) {
      var a = $m_ju_Arrays$().Iv(original, newLength, $d_O.r().l());
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().dd(original, 0, dest, 0, $m_jl_reflect_Array$().b1(original));
      var a = dest;
    }
    $m_ju_Arrays$().zY(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$p.b4 = (function() {
  return $m_sci_ArraySeq$().Lw;
});
$p.X = (function(f) {
  return this.aw7(f);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.cH = (function(suffix) {
  return this.amu(suffix);
});
$p.eS = (function(prefix) {
  return this.awW(prefix);
});
$p.bY = (function(that) {
  return this.aEr(that);
});
$p.qO = (function(n) {
  return this.ayu(n);
});
$p.bo = (function(n) {
  return this.atk(n);
});
$p.b8 = (function(n) {
  return this.atq(n);
});
$p.ak = (function() {
  return this.ayr();
});
$p.uC = (function() {
  return this.axs();
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.de = (function(coll) {
  return $m_sci_ArraySeq$().Uo(coll, this.e5());
});
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aC)));
}
/** @constructor */
function $c_sci_Range$Exclusive(start, end, step) {
  this.cF = 0;
  this.id = 0;
  this.bA = 0;
  this.dN = false;
  this.ie = 0;
  this.j7 = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
$p = $c_sci_Range$Exclusive.prototype = new $h_sci_Range();
$p.constructor = $c_sci_Range$Exclusive;
/** @constructor */
function $h_sci_Range$Exclusive() {
}
$h_sci_Range$Exclusive.prototype = $p;
$p.oR = (function() {
  return false;
});
var $d_sci_Range$Exclusive = new $TypeData().i($c_sci_Range$Exclusive, "scala.collection.immutable.Range$Exclusive", ({
  yg: 1,
  cO: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  a0: 1,
  D: 1,
  L: 1,
  a5: 1,
  a1: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_sci_Range$Inclusive(start, end, step) {
  this.cF = 0;
  this.id = 0;
  this.bA = 0;
  this.dN = false;
  this.ie = 0;
  this.j7 = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
$p = $c_sci_Range$Inclusive.prototype = new $h_sci_Range();
$p.constructor = $c_sci_Range$Inclusive;
/** @constructor */
function $h_sci_Range$Inclusive() {
}
$h_sci_Range$Inclusive.prototype = $p;
$p.oR = (function() {
  return true;
});
var $d_sci_Range$Inclusive = new $TypeData().i($c_sci_Range$Inclusive, "scala.collection.immutable.Range$Inclusive", ({
  yh: 1,
  cO: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  a0: 1,
  D: 1,
  L: 1,
  a5: 1,
  a1: 1,
  C: 1,
  M: 1,
  a: 1
}));
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.R = prefix1;
  return $thiz;
}
/** @constructor */
function $c_sci_Vector() {
  this.R = null;
}
$p = $c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
}
$h_sci_Vector.prototype = $p;
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.uC = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.zv = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$p.qM = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$p.uI = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.bB = (function(pred) {
  return this.MC(pred, false);
});
$p.bC = (function(pred) {
  return this.MC(pred, true);
});
$p.eQ = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.eC = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.hM = (function() {
  return $m_sci_Vector$();
});
$p.F = (function() {
  return ((this instanceof $c_sci_BigVector) ? this.am : this.R.a.length);
});
$p.l = (function() {
  return ((this === $m_sci_Vector0$()) ? $m_sci_Vector$().ab7 : new $c_sci_NewVectorIterator(this, this.F(), this.jD()));
});
$p.MC = (function(pred, isFlipped) {
  var i = 0;
  var len = this.R.a.length;
  while ((i !== len)) {
    if (((!(!pred.p(this.R.a[i]))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (((!(!pred.p(this.R.a[j]))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j));
        }
        j = ((1 + j) | 0);
      }
      var newLen = ((i + $m_jl_Integer$().cI(bitmap)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.DL(this.R.a[k]);
          k = ((1 + k) | 0);
        }
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.DL(this.R.a[k]);
            i = ((1 + i) | 0);
          }
          k = ((1 + k) | 0);
        }
        this.ah8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pred, isFlipped, b) => ((v$3) => {
          if (((!(!pred.p(v$3))) !== isFlipped)) {
            b.DL(v$3);
          }
        }))(pred, isFlipped, b)));
        return b.ix();
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$();
        }
        var newData = new $ac_O(newLen);
        var src = this.R;
        var length = i;
        src.av(0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.a[i] = this.R.a[k$2];
            i = ((1 + i) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
        return new $c_sci_Vector1(newData);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.auU(this.R);
    this.ah8(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$3$1) => {
      if (((!(!pred.p(v$3$1))) !== isFlipped)) {
        b$2.DL(v$3$1);
      }
    })));
    return b$2.ix();
  } else {
    return this;
  }
});
$p.awY = (function(prefix) {
  var k = prefix.G();
  return ((k === 0) ? this : ((k < 0) ? $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix) : this.iv(prefix, k)));
});
$p.amx = (function(suffix) {
  var k = suffix.G();
  return ((k === 0) ? this : ((k < 0) ? $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix) : this.ik(suffix, k)));
});
$p.iv = (function(prefix, k) {
  if ((k < ((4 + this.jD()) | 0))) {
    var v = this;
    var it = $m_sci_IndexedSeq$().oK(prefix).mR().bX();
    while (it.f()) {
      v = v.hN(it.e());
    }
    return v;
  } else if (((this.F() < ((k >>> 5) | 0)) && (prefix instanceof $c_sci_Vector))) {
    var v$2 = prefix;
    var it$2 = this.l();
    while (it$2.f()) {
      v$2 = v$2.aV(it$2.e());
    }
    return v$2;
  } else {
    return ((k < ((this.F() - 64) | 0)) ? new $c_sci_VectorBuilder().afC(k, this).ul(prefix).ul(this).ix() : $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix));
  }
});
$p.ik = (function(suffix, k) {
  if ((k < ((4 + this.jD()) | 0))) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      suffix.al(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3) => {
        v.bL = v.bL.fH(x$3);
      })));
    } else {
      var this$3 = suffix.l();
      while (this$3.f()) {
        var x0 = this$3.e();
        v.bL = v.bL.fH(x0);
      }
    }
    return v.bL;
  } else if (((this.F() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = suffix;
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
    while ((ri.fx > 0)) {
      v$2 = v$2.hN(ri.e());
    }
    return v$2;
  } else {
    return (((this.F() < ((k - 64) | 0)) && (suffix instanceof $c_sci_Vector)) ? new $c_sci_VectorBuilder().afC(this.F(), suffix).ul(this).ul(suffix).ix() : new $c_sci_VectorBuilder().ahJ(this).ul(suffix).ix());
  }
});
$p.eH = (function() {
  return "Vector";
});
$p.d0 = (function(xs, start, len) {
  return this.l().d0(xs, start, len);
});
$p.DP = (function() {
  return $m_sci_Vector$().ab6;
});
$p.f8 = (function(index) {
  return $m_scg_CommonErrors$().kM(index, ((this.F() - 1) | 0));
});
$p.W = (function() {
  if ((this.R.a.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head");
  } else {
    return this.R.a[0];
  }
});
$p.cJ = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = this.aj;
    if ((suffix.a.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail");
    } else {
      return suffix.a[((suffix.a.length - 1) | 0)];
    }
  } else {
    return this.R.a[((this.R.a.length - 1) | 0)];
  }
});
$p.al = (function(f) {
  var c = this.jD();
  var i = 0;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.ME(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.mQ(i), f);
    i = ((1 + i) | 0);
  }
});
$p.b4 = (function() {
  return $m_sci_Vector$();
});
$p.eS = (function(prefix) {
  return this.awY(prefix);
});
$p.cH = (function(suffix) {
  return this.amx(suffix);
});
$p.qO = (function(n) {
  return this.Vx(0, n);
});
$p.bo = (function(n) {
  return this.Vx(n, this.F());
});
$p.b8 = (function(n) {
  return this.Vx(0, ((this.F() - ((n > 0) ? n : 0)) | 0));
});
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aX)));
}
/** @constructor */
function $c_scm_ArraySeq() {
}
$p = $c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
}
$h_scm_ArraySeq.prototype = $p;
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.G = (function() {
  return this.F();
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.eQ = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.hM = (function() {
  return $m_scm_ArraySeq$().S3;
});
$p.ahk = (function(coll) {
  var evidence$1 = this.e5();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.dK();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.l());
  jsElems = [];
  coll.G();
  var it = coll.l();
  while (it.f()) {
    var elem = it.e();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $m_scm_ArrayBuilder$().u(elementClass) : elem));
    jsElems.push(unboxedElem);
  }
  return $m_scm_ArraySeq$().N8($m_scm_ArrayBuilder$().v(((elementClass === $d_V.l()) ? $d_jl_Void.l() : (((elementClass === $d_sr_Null$.l()) || (elementClass === $d_sr_Nothing$.l())) ? $d_O.l() : elementClass)), jsElems));
});
$p.dw = (function() {
  return $m_scm_ArraySeq$().Nb(this.e5());
});
$p.eH = (function() {
  return "ArraySeq";
});
$p.d0 = (function(xs, start, len) {
  var srcLen = this.F();
  var destLen = $m_jl_reflect_Array$().b1(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().dd(this.il(), 0, xs, start, copied);
  }
  return copied;
});
$p.b = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    if (($m_jl_reflect_Array$().b1(this.il()) !== $m_jl_reflect_Array$().b1(other.il()))) {
      return false;
    }
  }
  return $f_sc_Seq__equals__O__Z(this, other);
});
$p.ayf = (function(ord) {
  return $m_scm_ArraySeq$().N8($m_sc_ArrayOps$().ayg(this.il(), ord));
});
$p.ayd = (function(ord) {
  if ((this.F() > 1)) {
    var this$1 = $m_s_util_Sorting$();
    var a = this.il();
    this$1.Jd(a, 0, $m_jl_reflect_Array$().b1(a), ord);
  }
  return this;
});
$p.b4 = (function() {
  return $m_scm_ArraySeq$().S3;
});
$p.mF = (function(coll) {
  return this.ahk(coll);
});
$p.de = (function(coll) {
  return this.ahk(coll);
});
$p.eC = (function(ord) {
  return this.ayf(ord);
});
$p.Jc = (function(ord) {
  return this.ayd(ord);
});
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.aD)));
}
/** @constructor */
function $c_Lscalatags_JsDom$all$() {
  this.abW = null;
  this.abX = false;
  this.aca = null;
  this.acb = false;
  this.acP = null;
  this.acQ = false;
  this.acR = null;
  this.acS = false;
  this.acX = null;
  this.acY = false;
  this.abU = null;
  this.abV = false;
  this.aci = null;
  this.acj = false;
  this.acA = null;
  this.acB = false;
  this.ad1 = null;
  this.ad2 = false;
  this.ad5 = null;
  this.ad6 = false;
  this.ack = null;
  this.acl = false;
  this.aco = null;
  this.acp = false;
  this.acs = null;
  this.act = false;
  this.acu = null;
  this.acv = false;
  this.acm = null;
  this.acn = false;
  this.acq = null;
  this.acr = false;
  this.acG = null;
  this.acH = false;
  this.ac6 = null;
  this.ac7 = false;
  this.acC = null;
  this.acD = false;
  this.abY = null;
  this.abZ = false;
  this.abO = null;
  this.abP = false;
  this.acV = null;
  this.acW = false;
  this.ac2 = null;
  this.ac3 = false;
  this.ac4 = null;
  this.ac5 = false;
  this.acy = null;
  this.acz = false;
  this.ad3 = null;
  this.ad4 = false;
  this.acg = null;
  this.ach = false;
  this.ac0 = null;
  this.ac1 = false;
  this.abM = null;
  this.abN = false;
  this.acN = null;
  this.acO = false;
  this.acI = null;
  this.acJ = false;
  this.ac8 = null;
  this.ac9 = false;
  this.acK = null;
  this.acL = false;
  this.abQ = null;
  this.abR = false;
  this.acZ = null;
  this.ad0 = false;
  this.acT = null;
  this.acU = false;
  this.ace = null;
  this.acf = false;
  this.acc = null;
  this.acd = false;
  this.abS = null;
  this.abT = false;
  this.acE = null;
  this.acF = false;
  this.acw = null;
  this.acx = false;
  this.s = null;
  this.Sx = null;
  this.qq = null;
  this.Sy = null;
  this.acM = null;
  this.alD = null;
  this.alC = null;
  $n_Lscalatags_JsDom$all$ = this;
  $f_Lscalatags_generic_MouseEventAttrs__$init$__V(this);
  $f_Lscalatags_generic_Aggregate__$init$__V(this);
  $f_Lscalatags_JsDom$Aggregate__$init$__V(this);
}
$p = $c_Lscalatags_JsDom$all$.prototype = new $h_O();
$p.constructor = $c_Lscalatags_JsDom$all$;
/** @constructor */
function $h_Lscalatags_JsDom$all$() {
}
$h_Lscalatags_JsDom$all$.prototype = $p;
$p.D = (function() {
  if ((!this.abX)) {
    this.abW = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "class", null, false);
    this.abX = true;
  }
  return this.abW;
});
$p.bE = (function() {
  if ((!this.acb)) {
    this.aca = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "id", null, false);
    this.acb = true;
  }
  return this.aca;
});
$p.ak3 = (function() {
  if ((!this.acQ)) {
    this.acP = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "style", null, false);
    this.acQ = true;
  }
  return this.acP;
});
$p.ak6 = (function() {
  if ((!this.acS)) {
    this.acR = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "tabindex", null, false);
    this.acS = true;
  }
  return this.acR;
});
$p.A1 = (function() {
  if ((!this.acY)) {
    this.acX = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "title", null, false);
    this.acY = true;
  }
  return this.acX;
});
$p.an9 = (function() {
  if ((!this.abV)) {
    this.abU = $f_Lscalatags_generic_InputAttrs__checked__Lscalatags_generic_AttrPair(this);
    this.abV = true;
  }
  return this.abU;
});
$p.awl = (function() {
  if ((!this.acj)) {
    this.aci = $f_Lscalatags_generic_InputAttrs__multiple__Lscalatags_generic_AttrPair(this);
    this.acj = true;
  }
  return this.aci;
});
$p.V9 = (function() {
  if ((!this.acB)) {
    this.acA = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "placeholder", null, false);
    this.acB = true;
  }
  return this.acA;
});
$p.uH = (function() {
  if ((!this.ad2)) {
    this.ad1 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "type", null, false);
    this.ad2 = true;
  }
  return this.ad1;
});
$p.NG = (function() {
  if ((!this.ad6)) {
    this.ad5 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "value", null, false);
    this.ad6 = true;
  }
  return this.ad5;
});
$p.fc = (function() {
  if ((!this.acl)) {
    this.ack = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "onclick", null, false);
    this.acl = true;
  }
  return this.ack;
});
$p.J0 = (function() {
  if ((!this.acp)) {
    this.aco = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "ondblclick", null, false);
    this.acp = true;
  }
  return this.aco;
});
$p.aj6 = (function() {
  if ((!this.act)) {
    this.acs = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "onmouseout", null, false);
    this.act = true;
  }
  return this.acs;
});
$p.aj7 = (function() {
  if ((!this.acv)) {
    this.acu = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "onmouseover", null, false);
    this.acv = true;
  }
  return this.acu;
});
$p.Nd = (function() {
  if ((!this.acn)) {
    this.acm = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "oncontextmenu", null, false);
    this.acn = true;
  }
  return this.acm;
});
$p.aj5 = (function() {
  if ((!this.acr)) {
    this.acq = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "oninput", null, false);
    this.acr = true;
  }
  return this.acq;
});
$p.ajF = (function() {
  if ((!this.acH)) {
    this.acG = $f_Lscalatags_generic_FormEventAttrs__selected__Lscalatags_generic_AttrPair(this);
    this.acH = true;
  }
  return this.acG;
});
$p.IL = (function() {
  if ((!this.ac7)) {
    this.ac6 = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "href", null, false);
    this.ac7 = true;
  }
  return this.ac6;
});
$p.axw = (function() {
  if ((!this.acD)) {
    this.acC = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "role", null, false);
    this.acD = true;
  }
  return this.acC;
});
$p.TN = (function() {
  if ((!this.abZ)) {
    this.abY = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr(this, "colspan", null, false);
    this.abZ = true;
  }
  return this.abY;
});
$p.amT = (function() {
  if ((!this.abP)) {
    this.abO = new $c_Lscalatags_generic_Attrs$aria$(this);
    this.abP = true;
  }
  return this.abO;
});
$p.ayy = (function() {
  if ((!this.acW)) {
    this.acV = new $c_Lscalatags_generic_Styles$$anon$5(this);
    this.acW = true;
  }
  return this.acV;
});
$p.ahE = (function() {
  if ((!this.ac3)) {
    this.ac2 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "h3", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ac3 = true;
  }
  return this.ac2;
});
$p.auC = (function() {
  if ((!this.ac5)) {
    this.ac4 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "h4", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ac5 = true;
  }
  return this.ac4;
});
$p.ez = (function() {
  if ((!this.acz)) {
    this.acy = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "p", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acz = true;
  }
  return this.acy;
});
$p.jB = (function() {
  if ((!this.ad4)) {
    this.ad3 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "ul", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ad4 = true;
  }
  return this.ad3;
});
$p.he = (function() {
  if ((!this.ach)) {
    this.acg = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "li", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ach = true;
  }
  return this.acg;
});
$p.as = (function() {
  if ((!this.ac1)) {
    this.ac0 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "div", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ac1 = true;
  }
  return this.ac0;
});
$p.ij = (function() {
  if ((!this.abN)) {
    this.abM = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "a", false, $m_Lscalatags_generic_Namespace$().eG);
    this.abN = true;
  }
  return this.abM;
});
$p.zZ = (function() {
  if ((!this.acO)) {
    this.acN = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "strong", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acO = true;
  }
  return this.acN;
});
$p.ajN = (function() {
  if ((!this.acJ)) {
    this.acI = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "small", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acJ = true;
  }
  return this.acI;
});
$p.c6 = (function() {
  if ((!this.ac9)) {
    this.ac8 = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "i", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ac9 = true;
  }
  return this.ac8;
});
$p.bk = (function() {
  if ((!this.acL)) {
    this.acK = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "span", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acL = true;
  }
  return this.acK;
});
$p.DR = (function() {
  if ((!this.abR)) {
    this.abQ = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "br", true, $m_Lscalatags_generic_Namespace$().eG);
    this.abR = true;
  }
  return this.abQ;
});
$p.VI = (function() {
  if ((!this.ad0)) {
    this.acZ = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "tr", false, $m_Lscalatags_generic_Namespace$().eG);
    this.ad0 = true;
  }
  return this.acZ;
});
$p.mM = (function() {
  if ((!this.acU)) {
    this.acT = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "td", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acU = true;
  }
  return this.acT;
});
$p.avV = (function() {
  if ((!this.acf)) {
    this.ace = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "label", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acf = true;
  }
  return this.ace;
});
$p.IN = (function() {
  if ((!this.acd)) {
    this.acc = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "input", true, $m_Lscalatags_generic_Namespace$().eG);
    this.acd = true;
  }
  return this.acc;
});
$p.qC = (function() {
  if ((!this.abT)) {
    this.abS = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "button", false, $m_Lscalatags_generic_Namespace$().eG);
    this.abT = true;
  }
  return this.abS;
});
$p.ajE = (function() {
  if ((!this.acF)) {
    this.acE = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "select", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acF = true;
  }
  return this.acE;
});
$p.Ne = (function() {
  if ((!this.acx)) {
    this.acw = $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag(this, "option", false, $m_Lscalatags_generic_Namespace$().eG);
    this.acx = true;
  }
  return this.acw;
});
var $d_Lscalatags_JsDom$all$ = new $TypeData().i($c_Lscalatags_JsDom$all$, "scalatags.JsDom$all$", ({
  BW: 1,
  d6: 1,
  d7: 1,
  d9: 1,
  d5: 1,
  C9: 1,
  Ca: 1,
  C7: 1,
  Ci: 1,
  Cc: 1,
  Cd: 1,
  Cb: 1,
  Ce: 1,
  Cr: 1,
  C8: 1,
  C4: 1,
  C5: 1,
  Cj: 1,
  Cl: 1,
  iy: 1,
  iz: 1,
  BP: 1,
  C3: 1,
  C2: 1,
  BR: 1,
  BZ: 1
}));
var $n_Lscalatags_JsDom$all$;
function $m_Lscalatags_JsDom$all$() {
  if ((!$n_Lscalatags_JsDom$all$)) {
    $n_Lscalatags_JsDom$all$ = new $c_Lscalatags_JsDom$all$();
  }
  return $n_Lscalatags_JsDom$all$;
}
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.kl = null;
  this.kl = unsafeArray;
}
$p = $c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
}
$h_sci_ArraySeq$ofBoolean.prototype = $p;
$p.F = (function() {
  return this.kl.a.length;
});
$p.Im = (function(i) {
  return this.kl.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.kl, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofBoolean) ? $m_ju_Arrays$().agP(this.kl, that.kl) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((this.kl.a.length <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Boolean$()))) {
    var this$1 = this.kl;
    var a = this$1.ar();
    $m_s_util_Sorting$().Jd(a, 0, a.a.length, $m_s_math_Ordering$Boolean$());
    return new $c_sci_ArraySeq$ofBoolean(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.kl);
});
$p.ed = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var b = (!(!elem));
    var xs = this.kl;
    $m_s_reflect_ManifestFactory$BooleanManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_Z.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_Z(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofBoolean(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var b = (!(!elem));
    var xs = this.kl;
    $m_s_reflect_ManifestFactory$BooleanManifest$();
    var dest = new $ac_Z(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofBoolean(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.kl;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$p.at = (function(i) {
  return this.Im(i);
});
$p.p = (function(v1) {
  return this.Im((v1 | 0));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ha)));
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().i($c_sci_ArraySeq$ofBoolean, "scala.collection.immutable.ArraySeq$ofBoolean", ({
  ha: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.km = null;
  this.km = unsafeArray;
}
$p = $c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
}
$h_sci_ArraySeq$ofByte.prototype = $p;
$p.F = (function() {
  return this.km.a.length;
});
$p.Ie = (function(i) {
  return this.km.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.km, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofByte) ? $m_ju_Arrays$().agL(this.km, that.km) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((this.km.a.length <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Byte$()))) {
    var this$1 = this.km;
    var a = this$1.ar();
    $m_ju_Arrays$().ajO(a);
    return new $c_sci_ArraySeq$ofByte(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.km);
});
$p.ed = (function(elem) {
  if ($isByte(elem)) {
    var b = (elem | 0);
    var xs = this.km;
    $m_s_reflect_ManifestFactory$ByteManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_B.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_B(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofByte(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ($isByte(elem)) {
    var b = (elem | 0);
    var xs = this.km;
    $m_s_reflect_ManifestFactory$ByteManifest$();
    var dest = new $ac_B(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofByte(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.km;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$p.at = (function(i) {
  return this.Ie(i);
});
$p.p = (function(v1) {
  return this.Ie((v1 | 0));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hb)));
}
var $d_sci_ArraySeq$ofByte = new $TypeData().i($c_sci_ArraySeq$ofByte, "scala.collection.immutable.ArraySeq$ofByte", ({
  hb: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.j3 = null;
  this.j3 = unsafeArray;
}
$p = $c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
}
$h_sci_ArraySeq$ofChar.prototype = $p;
$p.F = (function() {
  return this.j3.a.length;
});
$p.If = (function(i) {
  return this.j3.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.j3, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofChar) ? $m_ju_Arrays$().agM(this.j3, that.j3) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((this.j3.a.length <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Char$()))) {
    var this$1 = this.j3;
    var a = this$1.ar();
    $m_ju_Arrays$().ajP(a);
    return new $c_sci_ArraySeq$ofChar(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.j3);
});
$p.ed = (function(elem) {
  if ((elem instanceof $Char)) {
    var b = $uC(elem);
    var xs = this.j3;
    $m_s_reflect_ManifestFactory$CharManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_C.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_C(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, $bC(b));
    return new $c_sci_ArraySeq$ofChar(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ((elem instanceof $Char)) {
    var b = $uC(elem);
    var xs = this.j3;
    $m_s_reflect_ManifestFactory$CharManifest$();
    var dest = new $ac_C(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofChar(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.gG = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.j3).gG(sb, start, sep, end);
});
$p.d2 = (function() {
  return this.j3;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$p.at = (function(i) {
  return $bC(this.If(i));
});
$p.p = (function(v1) {
  return $bC(this.If((v1 | 0)));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hc)));
}
var $d_sci_ArraySeq$ofChar = new $TypeData().i($c_sci_ArraySeq$ofChar, "scala.collection.immutable.ArraySeq$ofChar", ({
  hc: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.o2 = null;
  this.o2 = unsafeArray;
}
$p = $c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
}
$h_sci_ArraySeq$ofDouble.prototype = $p;
$p.F = (function() {
  return this.o2.a.length;
});
$p.Ig = (function(i) {
  return this.o2.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.o2, this$1.ea);
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var array = this.o2;
    var thatArray = that.o2;
    if ((array === thatArray)) {
      return true;
    } else if ((array.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < array.a.length) && (array.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.a.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.o2);
});
$p.ed = (function(elem) {
  if (((typeof elem) === "number")) {
    var b = (+elem);
    var xs = this.o2;
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_D.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_D(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofDouble(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if (((typeof elem) === "number")) {
    var b = (+elem);
    var xs = this.o2;
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    var dest = new $ac_D(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofDouble(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.o2;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$p.at = (function(i) {
  return this.Ig(i);
});
$p.p = (function(v1) {
  return this.Ig((v1 | 0));
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hd)));
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().i($c_sci_ArraySeq$ofDouble, "scala.collection.immutable.ArraySeq$ofDouble", ({
  hd: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.o3 = null;
  this.o3 = unsafeArray;
}
$p = $c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
}
$h_sci_ArraySeq$ofFloat.prototype = $p;
$p.F = (function() {
  return this.o3.a.length;
});
$p.Ih = (function(i) {
  return this.o3.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.o3, this$1.ea);
});
$p.b = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var array = this.o3;
    var thatArray = that.o3;
    if ((array === thatArray)) {
      return true;
    } else if ((array.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < array.a.length) && (array.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.a.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.o3);
});
$p.ed = (function(elem) {
  if ($isFloat(elem)) {
    var b = Math.fround(elem);
    var xs = this.o3;
    $m_s_reflect_ManifestFactory$FloatManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_F.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_F(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofFloat(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ($isFloat(elem)) {
    var b = Math.fround(elem);
    var xs = this.o3;
    $m_s_reflect_ManifestFactory$FloatManifest$();
    var dest = new $ac_F(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofFloat(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.o3;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$p.at = (function(i) {
  return this.Ih(i);
});
$p.p = (function(v1) {
  return this.Ih((v1 | 0));
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.he)));
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().i($c_sci_ArraySeq$ofFloat, "scala.collection.immutable.ArraySeq$ofFloat", ({
  he: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.kn = null;
  this.kn = unsafeArray;
}
$p = $c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
}
$h_sci_ArraySeq$ofInt.prototype = $p;
$p.F = (function() {
  return this.kn.a.length;
});
$p.Ii = (function(i) {
  return this.kn.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.kn, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofInt) ? $m_ju_Arrays$().Mz(this.kn, that.kn) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((this.kn.a.length <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Int$()))) {
    var this$1 = this.kn;
    var a = this$1.ar();
    $m_ju_Arrays$().ajQ(a);
    return new $c_sci_ArraySeq$ofInt(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.kn);
});
$p.ed = (function(elem) {
  if ($isInt(elem)) {
    var b = (elem | 0);
    var xs = this.kn;
    $m_s_reflect_ManifestFactory$IntManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_I.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_I(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofInt(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ($isInt(elem)) {
    var b = (elem | 0);
    var xs = this.kn;
    $m_s_reflect_ManifestFactory$IntManifest$();
    var dest = new $ac_I(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofInt(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.kn;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$p.at = (function(i) {
  return this.Ii(i);
});
$p.p = (function(v1) {
  return this.Ii((v1 | 0));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hf)));
}
var $d_sci_ArraySeq$ofInt = new $TypeData().i($c_sci_ArraySeq$ofInt, "scala.collection.immutable.ArraySeq$ofInt", ({
  hf: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.ko = null;
  this.ko = unsafeArray;
}
$p = $c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
}
$h_sci_ArraySeq$ofLong.prototype = $p;
$p.F = (function() {
  return ((this.ko.a.length >>> 1) | 0);
});
$p.Ij = (function(i) {
  var $x_1 = this.ko.a;
  var $x_2 = (i << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.ko, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofLong) ? $m_ju_Arrays$().agN(this.ko, that.ko) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((((this.ko.a.length >>> 1) | 0) <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Long$()))) {
    var this$1 = this.ko;
    var a = this$1.ar();
    $m_ju_Arrays$().ajR(a);
    return new $c_sci_ArraySeq$ofLong(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.ko);
});
$p.ed = (function(elem) {
  if ((elem instanceof $Long)) {
    var $x_1 = $uJ(elem);
    var b_$_lo = $x_1.l;
    var b_$_hi = $x_1.h;
    var xs = this.ko;
    $m_s_reflect_ManifestFactory$LongManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + ((xs.a.length >>> 1) | 0)) | 0);
    if ($d_J.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_J(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, ((xs.a.length >>> 1) | 0));
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, ((xs.a.length >>> 1) | 0), $bL(b_$_lo, b_$_hi));
    return new $c_sci_ArraySeq$ofLong(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ((elem instanceof $Long)) {
    var $x_1 = $uJ(elem);
    var b_$_lo = $x_1.l;
    var b_$_hi = $x_1.h;
    var xs = this.ko;
    $m_s_reflect_ManifestFactory$LongManifest$();
    var dest = new $ac_J(((1 + ((xs.a.length >>> 1) | 0)) | 0));
    var $x_2 = dest.a;
    $x_2[0] = b_$_lo;
    $x_2[1] = b_$_hi;
    $m_s_Array$().dd(xs, 0, dest, 1, ((xs.a.length >>> 1) | 0));
    return new $c_sci_ArraySeq$ofLong(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.ko;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$p.at = (function(i) {
  return this.Ij(i);
});
$p.p = (function(v1) {
  return this.Ij((v1 | 0));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hg)));
}
var $d_sci_ArraySeq$ofLong = new $TypeData().i($c_sci_ArraySeq$ofLong, "scala.collection.immutable.ArraySeq$ofLong", ({
  hg: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.kp = null;
  this.kp = unsafeArray;
}
$p = $c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
}
$h_sci_ArraySeq$ofRef.prototype = $p;
$p.e5 = (function() {
  return $m_s_reflect_ClassTag$().um($objectGetClass(this.kp).ax.Q());
});
$p.F = (function() {
  return this.kp.a.length;
});
$p.at = (function(i) {
  return this.kp.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.kp, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofRef) ? $m_s_Array$().agQ(this.kp, that.kp) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ajV = (function(ord) {
  if ((this.kp.a.length <= 1)) {
    return this;
  } else {
    var this$1 = this.kp;
    var a = this$1.ar();
    $m_ju_Arrays$().zY(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.kp);
});
$p.d2 = (function() {
  return this.kp;
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
$p.ft = (function(ord) {
  return this.ajV(ord);
});
$p.eC = (function(ord) {
  return this.ajV(ord);
});
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hh)));
}
var $d_sci_ArraySeq$ofRef = new $TypeData().i($c_sci_ArraySeq$ofRef, "scala.collection.immutable.ArraySeq$ofRef", ({
  hh: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.kq = null;
  this.kq = unsafeArray;
}
$p = $c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
}
$h_sci_ArraySeq$ofShort.prototype = $p;
$p.F = (function() {
  return this.kq.a.length;
});
$p.Ik = (function(i) {
  return this.kq.a[i];
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.kq, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofShort) ? $m_ju_Arrays$().agO(this.kq, that.kq) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.ft = (function(ord) {
  if ((this.kq.a.length <= 1)) {
    return this;
  } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Short$()))) {
    var this$1 = this.kq;
    var a = this$1.ar();
    $m_ju_Arrays$().ajS(a);
    return new $c_sci_ArraySeq$ofShort(a);
  } else {
    return $c_sci_ArraySeq.prototype.ft.call(this, ord);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.kq);
});
$p.ed = (function(elem) {
  if ($isShort(elem)) {
    var b = (elem | 0);
    var xs = this.kq;
    $m_s_reflect_ManifestFactory$ShortManifest$();
    var this$4 = $m_s_Array$();
    var newLength = ((1 + xs.a.length) | 0);
    if ($d_S.R($objectGetClass(xs).ax.Q().ax)) {
      var dest$1 = this$4.mA(xs, newLength);
    } else {
      var dest = new $ac_S(newLength);
      $m_s_Array$().dd(xs, 0, dest, 0, xs.a.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().bQ(dest$1, xs.a.length, b);
    return new $c_sci_ArraySeq$ofShort(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.ed.call(this, elem);
  }
});
$p.em = (function(elem) {
  if ($isShort(elem)) {
    var b = (elem | 0);
    var xs = this.kq;
    $m_s_reflect_ManifestFactory$ShortManifest$();
    var dest = new $ac_S(((1 + xs.a.length) | 0));
    dest.a[0] = b;
    $m_s_Array$().dd(xs, 0, dest, 1, xs.a.length);
    return new $c_sci_ArraySeq$ofShort(dest);
  } else {
    return $c_sci_ArraySeq.prototype.em.call(this, elem);
  }
});
$p.d2 = (function() {
  return this.kq;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$p.at = (function(i) {
  return this.Ik(i);
});
$p.p = (function(v1) {
  return this.Ik((v1 | 0));
});
$p.eC = (function(ord) {
  return this.ft(ord);
});
$p.aV = (function(elem) {
  return this.ed(elem);
});
$p.ba = (function(elem) {
  return this.em(elem);
});
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hi)));
}
var $d_sci_ArraySeq$ofShort = new $TypeData().i($c_sci_ArraySeq$ofShort, "scala.collection.immutable.ArraySeq$ofShort", ({
  hi: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.ym = null;
  this.ym = unsafeArray;
}
$p = $c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$p.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
}
$h_sci_ArraySeq$ofUnit.prototype = $p;
$p.F = (function() {
  return this.ym.a.length;
});
$p.Il = (function(i) {
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.ym, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofUnit) ? (this.ym.a.length === that.ym.a.length) : $f_sc_Seq__equals__O__Z(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.ym);
});
$p.d2 = (function() {
  return this.ym;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$p.at = (function(i) {
  this.Il(i);
});
$p.p = (function(v1) {
  this.Il((v1 | 0));
});
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hj)));
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().i($c_sci_ArraySeq$ofUnit, "scala.collection.immutable.ArraySeq$ofUnit", ({
  hj: 1,
  aC: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  aK: 1,
  a: 1
}));
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  return $p_sci_List__noneIn$1__F1__Z__sci_List__sci_List($thiz, p, isFlipped, $thiz);
}
function $p_sci_List__loop$2__I__I__sci_List__I($thiz, len$1, i, xs) {
  var xs$tailLocal1 = xs;
  var i$tailLocal1 = i;
  while (true) {
    if ((i$tailLocal1 === len$1)) {
      return ((!xs$tailLocal1.c()) | 0);
    } else {
      if ((!xs$tailLocal1.c())) {
        var i$tailLocal1$tmp1 = ((1 + i$tailLocal1) | 0);
        var xs$tailLocal1$tmp1 = xs$tailLocal1.ak();
        i$tailLocal1 = i$tailLocal1$tmp1;
        xs$tailLocal1 = xs$tailLocal1$tmp1;
        continue;
      }
      return (-1);
    }
  }
}
function $p_sci_List__noneIn$1__F1__Z__sci_List__sci_List($thiz, p$1, isFlipped$1, l) {
  var l$tailLocal1 = l;
  while (true) {
    if (l$tailLocal1.c()) {
      return $m_sci_Nil$();
    } else {
      var h = l$tailLocal1.W();
      var t = l$tailLocal1.ak();
      if (((!(!p$1.p(h))) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__F1__Z__sci_List__sci_List__sci_List($thiz, p$1, isFlipped$1, l$tailLocal1, t);
      } else {
        l$tailLocal1 = t;
      }
    }
  }
}
function $p_sci_List__allIn$1__F1__Z__sci_List__sci_List__sci_List($thiz, p$2, isFlipped$2, start, remaining) {
  var remaining$tailLocal1 = remaining;
  while (true) {
    if (remaining$tailLocal1.c()) {
      return start;
    } else {
      var x = remaining$tailLocal1.W();
      if (((!(!p$2.p(x))) !== isFlipped$2)) {
        remaining$tailLocal1 = remaining$tailLocal1.ak();
      } else {
        return $p_sci_List__partialFill$1__F1__Z__sci_List__sci_List__sci_List($thiz, p$2, isFlipped$2, start, remaining$tailLocal1);
      }
    }
  }
}
function $p_sci_List__partialFill$1__F1__Z__sci_List__sci_List__sci_List($thiz, p$3, isFlipped$3, origStart, firstMiss) {
  var newHead = new $c_sci_$colon$colon(origStart.W(), $m_sci_Nil$());
  var toProcess = origStart.ak();
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon(toProcess.W(), $m_sci_Nil$());
    currentLast.bz = newElem;
    currentLast = newElem;
    toProcess = toProcess.ak();
  }
  var next = firstMiss.ak();
  var nextToCopy = next;
  while ((!next.c())) {
    var head = next.W();
    if (((!(!p$3.p(head))) !== isFlipped$3)) {
      next = next.ak();
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon(nextToCopy.W(), $m_sci_Nil$());
        currentLast.bz = newElem$2;
        currentLast = newElem$2;
        nextToCopy = nextToCopy.ak();
      }
      nextToCopy = next.ak();
      next = next.ak();
    }
  }
  if ((!nextToCopy.c())) {
    currentLast.bz = nextToCopy;
  }
  return newHead;
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  var b$tailLocal1 = b;
  var a$tailLocal1 = a;
  while (true) {
    if ((a$tailLocal1 === b$tailLocal1)) {
      return true;
    } else {
      var aEmpty = a$tailLocal1.c();
      var bEmpty = b$tailLocal1.c();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().B(a$tailLocal1.W(), b$tailLocal1.W()))) {
        var a$tailLocal1$tmp1 = a$tailLocal1.ak();
        var b$tailLocal1$tmp1 = b$tailLocal1.ak();
        a$tailLocal1 = a$tailLocal1$tmp1;
        b$tailLocal1 = b$tailLocal1$tmp1;
        continue;
      }
      return (aEmpty && bEmpty);
    }
  }
}
/** @constructor */
function $c_sci_List() {
}
$p = $c_sci_List.prototype = new $h_sci_AbstractSeq();
$p.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
}
$h_sci_List.prototype = $p;
$p.zM = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$p.at = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$p.fL = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$p.qM = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$p.iq = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$p.is = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end);
});
$p.c8 = (function() {
  return "LinearSeq";
});
$p.uI = (function(asPair) {
  return $f_sc_StrictOptimizedIterableOps__unzip__F1__T2(this, asPair);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.zX = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.l = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this);
});
$p.eQ = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.eC = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$p.hM = (function() {
  return $m_sci_List$();
});
$p.afm = (function(prefix) {
  if (this.c()) {
    return prefix;
  } else if (prefix.c()) {
    return this;
  } else {
    var result = new $c_sci_$colon$colon(prefix.W(), this);
    var curr = result;
    var that = prefix.ak();
    while ((!that.c())) {
      var temp = new $c_sci_$colon$colon(that.W(), this);
      curr.bz = temp;
      curr = temp;
      that = that.ak();
    }
    return result;
  }
});
$p.c = (function() {
  return (this === $m_sci_Nil$());
});
$p.aY = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    return this.afm(prefix);
  }
  if ((prefix.G() === 0)) {
    return this;
  }
  if ((prefix instanceof $c_scm_ListBuffer)) {
    if (this.c()) {
      return prefix.uF();
    }
  }
  var iter = prefix.l();
  if (iter.f()) {
    var result = new $c_sci_$colon$colon(iter.e(), this);
    var curr = result;
    while (iter.f()) {
      var temp = new $c_sci_$colon$colon(iter.e(), this);
      curr.bz = temp;
      curr = temp;
    }
    return result;
  } else {
    return this;
  }
});
$p.cY = (function(suffix) {
  return ((suffix instanceof $c_sci_List) ? suffix.afm(this) : $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix));
});
$p.ayw = (function(n) {
  if ((this.c() || (n <= 0))) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(this.W(), $m_sci_Nil$());
    var t = h;
    var rest = this.ak();
    var i = 1;
    while (true) {
      if (rest.c()) {
        return this;
      }
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon(rest.W(), $m_sci_Nil$());
        t.bz = nx;
        t = nx;
        rest = rest.ak();
      } else {
        break;
      }
    }
    var $x_1 = h;
  }
  return $x_1;
});
$p.aw9 = (function(f) {
  if ((this === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(f.p(this.W()), $m_sci_Nil$());
    var t = h;
    var rest = this.ak();
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.p(rest.W()), $m_sci_Nil$());
      t.bz = nx;
      t = nx;
      rest = rest.ak();
    }
    var $x_1 = h;
  }
  return $x_1;
});
$p.anh = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = pf.aJ(rest.W(), $m_sci_List$().H2);
      if ((x !== $m_sci_List$().H2)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$());
      }
      rest = rest.ak();
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h);
      }
    }
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = pf.aJ(rest.W(), $m_sci_List$().H2);
      if ((x !== $m_sci_List$().H2)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        t.bz = nx;
        t = nx;
      }
      rest = rest.ak();
    }
    var $x_1 = h;
  }
  return $x_1;
});
$p.atZ = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = f.p(rest.W()).l();
    while (it.f()) {
      var nx = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.bz = nx;
      }
      t = nx;
    }
    rest = rest.ak();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$p.al = (function(f) {
  var these = this;
  while ((!these.c())) {
    f.p(these.W());
    these = these.ak();
  }
});
$p.axu = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!these.c())) {
    result = new $c_sci_$colon$colon(these.W(), result);
    these = these.ak();
  }
  return result;
});
$p.F = (function() {
  var these = this;
  var len = 0;
  while ((!these.c())) {
    len = ((1 + len) | 0);
    these = these.ak();
  }
  return len;
});
$p.cp = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__I__sci_List__I(this, len, 0, this));
});
$p.g8 = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!(!p.p(these.W()))))) {
      return false;
    }
    these = these.ak();
  }
  return true;
});
$p.fK = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!p.p(these.W())))) {
      return true;
    }
    these = these.ak();
  }
  return false;
});
$p.az = (function(elem) {
  var these = this;
  while ((!these.c())) {
    if ($m_sr_BoxesRunTime$().B(these.W(), elem)) {
      return true;
    }
    these = these.ak();
  }
  return false;
});
$p.MD = (function(p) {
  var these = this;
  while ((!these.c())) {
    if ((!(!p.p(these.W())))) {
      return new $c_s_Some(these.W());
    }
    these = these.ak();
  }
  return $m_s_None$();
});
$p.cJ = (function() {
  if (this.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last");
  } else {
    var these = this;
    var scout = this.ak();
    while ((!scout.c())) {
      these = scout;
      scout = scout.ak();
    }
    return these.W();
  }
});
$p.eH = (function() {
  return "List";
});
$p.uF = (function() {
  return this;
});
$p.b = (function(o) {
  return ((o instanceof $c_sci_List) ? $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, o) : $f_sc_Seq__equals__O__Z(this, o));
});
$p.b4 = (function() {
  return $m_sci_List$();
});
$p.ba = (function(elem) {
  return new $c_sci_$colon$colon(elem, this);
});
$p.eS = (function(prefix) {
  return this.aY(prefix);
});
$p.cH = (function(suffix) {
  return this.cY(suffix);
});
$p.qO = (function(n) {
  return this.ayw(n);
});
$p.X = (function(f) {
  return this.aw9(f);
});
$p.bD = (function(pf) {
  return this.anh(pf);
});
$p.aL = (function(f) {
  return this.atZ(f);
});
$p.uC = (function() {
  return this.axu();
});
$p.bB = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false);
});
$p.bC = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, true);
});
$p.bo = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$p.aU = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, (x | 0));
});
$p.p = (function(v1) {
  return $f_sc_LinearSeqOps__apply__I__O(this, (v1 | 0));
});
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cJ)));
}
/** @constructor */
function $c_sci_VectorImpl() {
  this.R = null;
}
$p = $c_sci_VectorImpl.prototype = new $h_sci_Vector();
$p.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
}
$h_sci_VectorImpl.prototype = $p;
$p.Vx = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.F();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.F()) ? this : this.kU(lo, hi)));
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.qh = null;
  this.qh = array;
}
$p = $c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
}
$h_scm_ArraySeq$ofBoolean.prototype = $p;
$p.F = (function() {
  return this.qh.a.length;
});
$p.Im = (function(index) {
  return this.qh.a[index];
});
$p.ayW = (function(index, elem) {
  this.qh.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.qh, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofBoolean) ? $m_ju_Arrays$().agP(this.qh, that.qh) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.qh);
});
$p.il = (function() {
  return this.qh;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$p.at = (function(i) {
  return this.Im(i);
});
$p.p = (function(v1) {
  return this.Im((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayW(index, (!(!elem)));
});
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hM)));
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().i($c_scm_ArraySeq$ofBoolean, "scala.collection.mutable.ArraySeq$ofBoolean", ({
  hM: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.qi = null;
  this.qi = array;
}
$p = $c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
}
$h_scm_ArraySeq$ofByte.prototype = $p;
$p.F = (function() {
  return this.qi.a.length;
});
$p.Ie = (function(index) {
  return this.qi.a[index];
});
$p.ayP = (function(index, elem) {
  this.qi.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.qi, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofByte) ? $m_ju_Arrays$().agL(this.qi, that.qi) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.qi);
});
$p.il = (function() {
  return this.qi;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$p.at = (function(i) {
  return this.Ie(i);
});
$p.p = (function(v1) {
  return this.Ie((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayP(index, (elem | 0));
});
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hN)));
}
var $d_scm_ArraySeq$ofByte = new $TypeData().i($c_scm_ArraySeq$ofByte, "scala.collection.mutable.ArraySeq$ofByte", ({
  hN: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.ig = null;
  this.ig = array;
}
$p = $c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
}
$h_scm_ArraySeq$ofChar.prototype = $p;
$p.F = (function() {
  return this.ig.a.length;
});
$p.If = (function(index) {
  return this.ig.a[index];
});
$p.ayQ = (function(index, elem) {
  this.ig.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.ig, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofChar) ? $m_ju_Arrays$().agM(this.ig, that.ig) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.ig);
});
$p.gG = (function(sb, start, sep, end) {
  var jsb = sb.et;
  if ((start.length !== 0)) {
    jsb.aC = (("" + jsb.aC) + start);
  }
  var len = this.ig.a.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.afF(this.ig);
    } else {
      jsb.F();
      var c = this.ig.a[0];
      var str = ("" + $cToS(c));
      jsb.aC = (jsb.aC + str);
      var i = 1;
      while ((i < len)) {
        jsb.aC = (("" + jsb.aC) + sep);
        var c$1 = this.ig.a[i];
        var str$1 = ("" + $cToS(c$1));
        jsb.aC = (jsb.aC + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  if ((end.length !== 0)) {
    jsb.aC = (("" + jsb.aC) + end);
  }
  return sb;
});
$p.il = (function() {
  return this.ig;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$p.at = (function(i) {
  return $bC(this.If(i));
});
$p.p = (function(v1) {
  return $bC(this.If((v1 | 0)));
});
$p.hQ = (function(index, elem) {
  this.ayQ(index, $uC(elem));
});
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hO)));
}
var $d_scm_ArraySeq$ofChar = new $TypeData().i($c_scm_ArraySeq$ofChar, "scala.collection.mutable.ArraySeq$ofChar", ({
  hO: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.j9 = null;
  this.j9 = array;
}
$p = $c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
}
$h_scm_ArraySeq$ofDouble.prototype = $p;
$p.F = (function() {
  return this.j9.a.length;
});
$p.Ig = (function(index) {
  return this.j9.a[index];
});
$p.ayR = (function(index, elem) {
  this.j9.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.j9, this$1.ea);
});
$p.b = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var thatArray = that.j9;
    if ((this.j9 === thatArray)) {
      return true;
    } else if ((this.j9.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < this.j9.a.length) && (this.j9.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.j9.a.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.b.call(this, that);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.j9);
});
$p.il = (function() {
  return this.j9;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$p.at = (function(i) {
  return this.Ig(i);
});
$p.p = (function(v1) {
  return this.Ig((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayR(index, (+elem));
});
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hP)));
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().i($c_scm_ArraySeq$ofDouble, "scala.collection.mutable.ArraySeq$ofDouble", ({
  hP: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.ja = null;
  this.ja = array;
}
$p = $c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
}
$h_scm_ArraySeq$ofFloat.prototype = $p;
$p.F = (function() {
  return this.ja.a.length;
});
$p.Ih = (function(index) {
  return this.ja.a[index];
});
$p.ayS = (function(index, elem) {
  this.ja.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.ja, this$1.ea);
});
$p.b = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var thatArray = that.ja;
    if ((this.ja === thatArray)) {
      return true;
    } else if ((this.ja.a.length === thatArray.a.length)) {
      var i = 0;
      while (((i < this.ja.a.length) && (this.ja.a[i] === thatArray.a[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.ja.a.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.b.call(this, that);
  }
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.ja);
});
$p.il = (function() {
  return this.ja;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$p.at = (function(i) {
  return this.Ih(i);
});
$p.p = (function(v1) {
  return this.Ih((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayS(index, Math.fround(elem));
});
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hQ)));
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().i($c_scm_ArraySeq$ofFloat, "scala.collection.mutable.ArraySeq$ofFloat", ({
  hQ: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.qj = null;
  this.qj = array;
}
$p = $c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
}
$h_scm_ArraySeq$ofInt.prototype = $p;
$p.F = (function() {
  return this.qj.a.length;
});
$p.Ii = (function(index) {
  return this.qj.a[index];
});
$p.ayT = (function(index, elem) {
  this.qj.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.qj, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofInt) ? $m_ju_Arrays$().Mz(this.qj, that.qj) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.qj);
});
$p.il = (function() {
  return this.qj;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$p.at = (function(i) {
  return this.Ii(i);
});
$p.p = (function(v1) {
  return this.Ii((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayT(index, (elem | 0));
});
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hR)));
}
var $d_scm_ArraySeq$ofInt = new $TypeData().i($c_scm_ArraySeq$ofInt, "scala.collection.mutable.ArraySeq$ofInt", ({
  hR: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.qk = null;
  this.qk = array;
}
$p = $c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
}
$h_scm_ArraySeq$ofLong.prototype = $p;
$p.F = (function() {
  return ((this.qk.a.length >>> 1) | 0);
});
$p.Ij = (function(index) {
  var $x_1 = this.qk.a;
  var $x_2 = (index << 1);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$p.ayU = (function(index, elem_$_lo, elem_$_hi) {
  var $x_1 = this.qk.a;
  var $x_2 = (index << 1);
  $x_1[$x_2] = elem_$_lo;
  $x_1[(($x_2 + 1) | 0)] = elem_$_hi;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.qk, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofLong) ? $m_ju_Arrays$().agN(this.qk, that.qk) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.qk);
});
$p.il = (function() {
  return this.qk;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$p.at = (function(i) {
  return this.Ij(i);
});
$p.p = (function(v1) {
  return this.Ij((v1 | 0));
});
$p.hQ = (function(index, elem) {
  var $x_1 = $uJ(elem);
  this.ayU(index, $x_1.l, $x_1.h);
});
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hS)));
}
var $d_scm_ArraySeq$ofLong = new $TypeData().i($c_scm_ArraySeq$ofLong, "scala.collection.mutable.ArraySeq$ofLong", ({
  hS: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.oh = null;
  this.oh = array;
}
$p = $c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
}
$h_scm_ArraySeq$ofRef.prototype = $p;
$p.e5 = (function() {
  return $m_s_reflect_ClassTag$().um($objectGetClass(this.oh).ax.Q());
});
$p.F = (function() {
  return this.oh.a.length;
});
$p.at = (function(index) {
  return this.oh.a[index];
});
$p.hQ = (function(index, elem) {
  this.oh.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.oh, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofRef) ? $m_s_Array$().agQ(this.oh, that.oh) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.oh);
});
$p.il = (function() {
  return this.oh;
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hT)));
}
var $d_scm_ArraySeq$ofRef = new $TypeData().i($c_scm_ArraySeq$ofRef, "scala.collection.mutable.ArraySeq$ofRef", ({
  hT: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.ql = null;
  this.ql = array;
}
$p = $c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
}
$h_scm_ArraySeq$ofShort.prototype = $p;
$p.F = (function() {
  return this.ql.a.length;
});
$p.Ik = (function(index) {
  return this.ql.a[index];
});
$p.ayV = (function(index, elem) {
  this.ql.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.ql, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofShort) ? $m_ju_Arrays$().agO(this.ql, that.ql) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.ql);
});
$p.il = (function() {
  return this.ql;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$p.at = (function(i) {
  return this.Ik(i);
});
$p.p = (function(v1) {
  return this.Ik((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayV(index, (elem | 0));
});
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hU)));
}
var $d_scm_ArraySeq$ofShort = new $TypeData().i($c_scm_ArraySeq$ofShort, "scala.collection.mutable.ArraySeq$ofShort", ({
  hU: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.tD = null;
  this.tD = array;
}
$p = $c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$p.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
}
$h_scm_ArraySeq$ofUnit.prototype = $p;
$p.F = (function() {
  return this.tD.a.length;
});
$p.Il = (function(index) {
});
$p.ayX = (function(index, elem) {
  this.tD.a[index] = elem;
});
$p.r = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.fk(this.tD, this$1.ea);
});
$p.b = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofUnit) ? (this.tD.a.length === that.tD.a.length) : $c_scm_ArraySeq.prototype.b.call(this, that));
});
$p.l = (function() {
  return new $c_sc_ArrayOps$ArrayIterator(this.tD);
});
$p.il = (function() {
  return this.tD;
});
$p.e5 = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$p.at = (function(i) {
  this.Il(i);
});
$p.p = (function(v1) {
  this.Il((v1 | 0));
});
$p.hQ = (function(index, elem) {
  this.ayX(index, elem);
});
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hV)));
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().i($c_scm_ArraySeq$ofUnit, "scala.collection.mutable.ArraySeq$ofUnit", ({
  hV: 1,
  aD: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  C: 1,
  M: 1,
  a: 1
}));
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.S4 = loadFactor;
  $thiz.bP = new ($d_scm_HashMap$Node.r().C)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.Ha = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.bP.a.length);
  $thiz.fE = 0;
  return $thiz;
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz;
}
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.fE) | 0) >= $thiz.Ha)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.bP.a.length << 1));
  }
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, (hash & (($thiz.bP.a.length - 1) | 0)));
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.fE) | 0) >= $thiz.Ha)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.bP.a.length << 1));
  }
  var originalHash = $m_sr_Statics$().k(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, (hash & (($thiz.bP.a.length - 1) | 0)));
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  matchResult7: {
    var x30 = $thiz.bP.a[idx];
    if ((x30 === null)) {
      $thiz.bP.a[idx] = new $c_scm_HashMap$Node(key, hash, value, null);
      break matchResult7;
    }
    var prev = null;
    var n = x30;
    while (((n !== null) && (n.jb <= hash))) {
      if (((n.jb === hash) && $m_sr_BoxesRunTime$().B(key, n.ku))) {
        var old$2 = n.h6;
        var this$2 = n;
        this$2.h6 = value;
        return (getOld ? new $c_s_Some(old$2) : null);
      }
      prev = n;
      n = n.dE;
    }
    if ((prev === null)) {
      $thiz.bP.a[idx] = new $c_scm_HashMap$Node(key, hash, value, x30);
    } else {
      var this$6 = prev;
      var n$1 = new $c_scm_HashMap$Node(key, hash, value, prev.dE);
      this$6.dE = n$1;
    }
  }
  $thiz.fE = ((1 + $thiz.fE) | 0);
  return null;
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().k(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (($thiz.bP.a.length - 1) | 0));
  var x31 = $thiz.bP.a[idx];
  if ((x31 === null)) {
    return null;
  }
  if (((x31.jb === hash) && $m_sr_BoxesRunTime$().B(x31.ku, elem))) {
    $thiz.bP.a[idx] = x31.dE;
    $thiz.fE = (($thiz.fE - 1) | 0);
    return x31;
  }
  var prev = x31;
  var next = x31.dE;
  while (((next !== null) && (next.jb <= hash))) {
    if (((next.jb === hash) && $m_sr_BoxesRunTime$().B(next.ku, elem))) {
      var this$2 = prev;
      var n = next.dE;
      this$2.dE = n;
      $thiz.fE = (($thiz.fE - 1) | 0);
      return next;
    }
    prev = next;
    next = next.dE;
  }
  return null;
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.bP.a.length;
  $thiz.Ha = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.fE === 0)) {
    $thiz.bP = new ($d_scm_HashMap$Node.r().C)(newlen);
  } else {
    $thiz.bP = $m_ju_Arrays$().cn($thiz.bP, newlen);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.bP.a[i];
        if ((old !== null)) {
          preLow.dE = null;
          preHigh.dE = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.dE;
            if (((n.jb & oldlen) === 0)) {
              var this$2 = lastLow;
              var n$1 = n;
              this$2.dE = n$1;
              lastLow = n;
            } else {
              var this$3 = lastHigh;
              var n$2 = n;
              this$3.dE = n$2;
              lastHigh = n;
            }
            n = next;
          }
          var this$4 = lastLow;
          this$4.dE = null;
          if ((old !== preLow.dE)) {
            $thiz.bP.a[i] = preLow.dE;
          }
          if ((preHigh.dE !== null)) {
            $thiz.bP.a[((i + oldlen) | 0)] = preHigh.dE;
            var this$5 = lastHigh;
            this$5.dE = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.S4));
}
/** @constructor */
function $c_scm_HashMap() {
  this.S4 = 0.0;
  this.bP = null;
  this.Ha = 0;
  this.fE = 0;
}
$p = $c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$p.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
}
$h_scm_HashMap.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.aH = (function() {
  return this.fE;
});
$p.az = (function(key) {
  var originalHash = $m_sr_Statics$().k(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  matchResult1: {
    var $x_1;
    var x1 = this.bP.a[(hash & ((this.bP.a.length - 1) | 0))];
    if ((x1 === null)) {
      var $x_1 = null;
      break matchResult1;
    }
    var $x_1 = x1.IA(key, hash);
  }
  return ($x_1 !== null);
});
$p.dk = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.S4)));
  if ((target > this.bP.a.length)) {
    $p_scm_HashMap__growTable__I__V(this, target);
  }
});
$p.aft = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashMap)) {
    var f = new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((v1$2, v2$2, v3$2) => {
      var h = (v3$2 | 0);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, v1$2, v2$2, (h ^ ((h >>> 16) | 0)), false);
    }));
    xs.dM.Uk(f);
    return this;
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.aj1();
    while (iter.f()) {
      var next = iter.e();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.ku, next.h6, next.jb, false);
    }
    return this;
  } else if (false) {
    var iter$2 = xs.atw();
    while (iter$2.f()) {
      var entry = iter$2.e();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, entry.avU(), entry.akt(), entry.auE(), false);
    }
    return this;
  } else {
    return ($is_scm_Map(xs) ? (xs.jo(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2, value$2) => {
      var originalHash = $m_sr_Statics$().k(key$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false);
    }))), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$p.l = (function() {
  return ((this.fE === 0) ? $m_sc_Iterator$().aZ : new $c_scm_HashMap$$anon$1(this));
});
$p.jv = (function() {
  return ((this.fE === 0) ? $m_sc_Iterator$().aZ : new $c_scm_HashMap$$anon$2(this));
});
$p.mP = (function() {
  return ((this.fE === 0) ? $m_sc_Iterator$().aZ : new $c_scm_HashMap$$anon$3(this));
});
$p.aj1 = (function() {
  return ((this.fE === 0) ? $m_sc_Iterator$().aZ : new $c_scm_HashMap$$anon$4(this));
});
$p.Iq = (function() {
  $m_ju_Arrays$().agU(this.bP, null);
  this.fE = 0;
});
$p.b9 = (function(key) {
  var originalHash = $m_sr_Statics$().k(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  matchResult1: {
    var x34;
    var x1 = this.bP.a[(hash & ((this.bP.a.length - 1) | 0))];
    if ((x1 === null)) {
      var x34 = null;
      break matchResult1;
    }
    var x34 = x1.IA(key, hash);
  }
  if ((x34 === null)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x34.h6);
});
$p.p = (function(key) {
  var originalHash = $m_sr_Statics$().k(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  matchResult1: {
    var x35;
    var x1 = this.bP.a[(hash & ((this.bP.a.length - 1) | 0))];
    if ((x1 === null)) {
      var x35 = null;
      break matchResult1;
    }
    var x35 = x1.IA(key, hash);
  }
  if ((x35 === null)) {
    return $f_sc_MapOps__default__O__O(this, key);
  }
  return x35.h6;
});
$p.f6 = (function(key, default$1) {
  if ((!($objectGetClass(this) === $d_scm_HashMap.l()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().k(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    matchResult1: {
      var nd;
      var x1 = this.bP.a[(hash & ((this.bP.a.length - 1) | 0))];
      if ((x1 === null)) {
        var nd = null;
        break matchResult1;
      }
      var nd = x1.IA(key, hash);
    }
    return ((nd === null) ? default$1.aA() : nd.h6);
  }
});
$p.oM = (function(key, defaultValue) {
  if ((!($objectGetClass(this) === $d_scm_HashMap.l()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().k(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & ((this.bP.a.length - 1) | 0));
    matchResult13: {
      var nd$2;
      var x36 = this.bP.a[idx];
      if ((x36 === null)) {
        var nd$2 = null;
        break matchResult13;
      }
      var nd$2 = x36.IA(key, hash);
    }
    if ((nd$2 !== null)) {
      return nd$2.h6;
    } else {
      var table0 = this.bP;
      var default$1 = defaultValue.aA();
      if ((((1 + this.fE) | 0) >= this.Ha)) {
        $p_scm_HashMap__growTable__I__V(this, (this.bP.a.length << 1));
      }
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, ((table0 === this.bP) ? idx : (hash & ((this.bP.a.length - 1) | 0))));
      return default$1;
    }
  }
});
$p.Vc = (function(key) {
  var x38 = $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, key);
  if ((x38 === null)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x38.h6);
});
$p.Jf = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$p.am9 = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem.P(), elem.V(), false);
  return this;
});
$p.ayn = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this;
});
$p.G = (function() {
  return this.fE;
});
$p.c = (function() {
  return (this.fE === 0);
});
$p.al = (function(f) {
  var len = this.bP.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.bP.a[i];
    if ((n !== null)) {
      n.al(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.jo = (function(f) {
  var len = this.bP.a.length;
  var i = 0;
  while ((i < len)) {
    var n = this.bP.a[i];
    if ((n !== null)) {
      n.jo(f);
    }
    i = ((1 + i) | 0);
  }
});
$p.uy = (function() {
  return $m_scm_HashMap$();
});
$p.c8 = (function() {
  return "HashMap";
});
$p.r = (function() {
  if (this.c()) {
    return $m_s_util_hashing_MurmurHash3$().LF;
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().Aa(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().qp);
  }
});
$p.cz = (function(elems) {
  return this.aft(elems);
});
$p.aD = (function(elem) {
  return this.am9(elem);
});
$p.ED = (function(elem) {
  return this.ayn(elem);
});
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hW)));
}
var $d_scm_HashMap = new $TypeData().i($c_scm_HashMap, "scala.collection.mutable.HashMap", ({
  hW: 1,
  yH: 1,
  aV: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  au: 1,
  aL: 1,
  b: 1,
  ax: 1,
  a3: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  bC: 1,
  bB: 1,
  C: 1,
  h7: 1,
  a: 1
}));
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.aj = suffix1;
  $thiz.am = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz;
}
/** @constructor */
function $c_sci_BigVector() {
  this.R = null;
  this.aj = null;
  this.am = 0;
}
$p = $c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$p.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
}
$h_sci_BigVector.prototype = $p;
$p.ah8 = (function(f) {
  var c = this.jD();
  var i = 1;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.ME(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.mQ(i), f);
    i = ((1 + i) | 0);
  }
});
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.b5)));
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.R = null;
  $ct_sci_Vector__AO__(this, _data1);
}
$p = $c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$p.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
}
$h_sci_Vector1.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.R.a.length))) {
    return this.R.a[index];
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.R.a.length))) {
    var a1 = this.R;
    var a1c = a1.ar();
    a1c.a[index] = elem;
    return new $c_sci_Vector1(a1c);
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.R.a.length < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().DX(this.R, elem));
  } else {
    var $x_2 = this.R;
    var $x_1 = $m_sci_VectorStatics$().c3;
    var a = new $ac_O(1);
    a.a[0] = elem;
    return new $c_sci_Vector2($x_2, 32, $x_1, a, 33);
  }
});
$p.hN = (function(elem) {
  var len1 = this.R.a.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().DY(elem, this.R));
  } else {
    var a = new $ac_O(1);
    a.a[0] = elem;
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().c3, this.R, ((1 + len1) | 0));
  }
});
$p.mI = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().kO(this.R, f));
});
$p.kU = (function(lo, hi) {
  return new $c_sci_Vector1($m_ju_Arrays$().bO(this.R, lo, hi));
});
$p.jy = (function() {
  if ((this.R.a.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.R;
    return new $c_sci_Vector1($m_ju_Arrays$().bO(a, 1, a.a.length));
  }
});
$p.jD = (function() {
  return 1;
});
$p.mQ = (function(idx) {
  return this.R;
});
$p.iv = (function(prefix, k) {
  var x11 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x11 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  return new $c_sci_Vector1(x11);
});
$p.ik = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().DN(this.R, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.ik.call(this, suffix, k));
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.R.a.length))) {
    return this.R.a[index];
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hC)));
}
var $d_sci_Vector1 = new $TypeData().i($c_sci_Vector1, "scala.collection.immutable.Vector1", ({
  hC: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.q9 = null;
  this.bz = null;
  this.q9 = head;
  this.bz = next;
}
$p = $c_sci_$colon$colon.prototype = new $h_sci_List();
$p.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
}
$h_sci_$colon$colon.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.w = (function() {
  return 2;
});
$p.A = (function() {
  return "::";
});
$p.z = (function(n) {
  if ((n === 0)) {
    return this.q9;
  }
  if ((n === 1)) {
    return this.bz;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.W = (function() {
  return this.q9;
});
$p.bj = (function() {
  return new $c_s_Some(this.q9);
});
$p.ak = (function() {
  return this.bz;
});
$p.VE = (function() {
  return this.bz;
});
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.h9)));
}
var $d_sci_$colon$colon = new $TypeData().i($c_sci_$colon$colon, "scala.collection.immutable.$colon$colon", ({
  h9: 1,
  cJ: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  cx: 1,
  bo: 1,
  cI: 1,
  cH: 1,
  C: 1,
  M: 1,
  h6: 1,
  a1: 1,
  a: 1,
  a4: 1,
  c: 1
}));
/** @constructor */
function $c_sci_Nil$() {
  this.ab2 = null;
  $n_sci_Nil$ = this;
  this.ab2 = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
}
$p = $c_sci_Nil$.prototype = new $h_sci_List();
$p.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
}
$h_sci_Nil$.prototype = $p;
$p.C = (function() {
  return new $c_s_Product$$anon$1(this);
});
$p.w = (function() {
  return 0;
});
$p.A = (function() {
  return "Nil";
});
$p.z = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.auF = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list");
});
$p.ak7 = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list");
});
$p.avW = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list");
});
$p.G = (function() {
  return 0;
});
$p.l = (function() {
  return $m_sc_Iterator$().aZ;
});
$p.uI = (function(asPair) {
  return this.ab2;
});
$p.W = (function() {
  this.auF();
});
$p.bj = (function() {
  return $m_s_None$();
});
$p.ak = (function() {
  this.ak7();
});
$p.VE = (function() {
  this.ak7();
});
$p.cJ = (function() {
  this.avW();
});
var $d_sci_Nil$ = new $TypeData().i($c_sci_Nil$, "scala.collection.immutable.Nil$", ({
  yd: 1,
  cJ: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  cx: 1,
  bo: 1,
  cI: 1,
  cH: 1,
  C: 1,
  M: 1,
  h6: 1,
  a1: 1,
  a: 1,
  a4: 1,
  c: 1
}));
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$();
  }
  return $n_sci_Nil$;
}
/** @constructor */
function $c_sci_Vector0$() {
  this.R = null;
  this.aj = null;
  this.am = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().RY, $m_sci_VectorStatics$().RY, 0);
}
$p = $c_sci_Vector0$.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
}
$h_sci_Vector0$.prototype = $p;
$p.afI = (function(index) {
  throw this.f8(index);
});
$p.qQ = (function(index, elem) {
  throw this.f8(index);
});
$p.fH = (function(elem) {
  var a = new $ac_O(1);
  a.a[0] = elem;
  return new $c_sci_Vector1(a);
});
$p.hN = (function(elem) {
  var a = new $ac_O(1);
  a.a[0] = elem;
  return new $c_sci_Vector1(a);
});
$p.jy = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail");
});
$p.kU = (function(lo, hi) {
  return this;
});
$p.jD = (function() {
  return 0;
});
$p.mQ = (function(idx) {
  return null;
});
$p.b = (function(o) {
  return ((this === o) || ((o instanceof $c_sci_Vector) ? false : $f_sc_Seq__equals__O__Z(this, o)));
});
$p.iv = (function(prefix, k) {
  return $m_sci_Vector$().E5(prefix);
});
$p.ik = (function(suffix, k) {
  return $m_sci_Vector$().E5(suffix);
});
$p.f8 = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"));
});
$p.at = (function(i) {
  this.afI(i);
});
$p.p = (function(v1) {
  this.afI((v1 | 0));
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this;
});
$p.ak = (function() {
  return this.jy();
});
var $d_sci_Vector0$ = new $TypeData().i($c_sci_Vector0$, "scala.collection.immutable.Vector0$", ({
  yB: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$();
  }
  return $n_sci_Vector0$;
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.R = null;
  this.aj = null;
  this.am = 0;
  this.eM = 0;
  this.es = null;
  this.eM = len1;
  this.es = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector2.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
}
$h_sci_Vector2.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.eM) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.es.a.length) ? this.es.a[i2].a[i1] : this.aj.a[(31 & io)]);
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.am))) {
    if ((index >= this.eM)) {
      var io = ((index - this.eM) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.es.a.length)) {
        var a2 = this.es;
        var a2c = a2.ar();
        var a1 = a2c.a[i2];
        var a1c = a1.ar();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        return new $c_sci_Vector2(this.R, this.eM, a2c, this.aj, this.am);
      } else {
        var a1$1 = this.aj;
        var a1c$1 = a1$1.ar();
        a1c$1.a[i1] = elem;
        return new $c_sci_Vector2(this.R, this.eM, this.es, a1c$1, this.am);
      }
    } else {
      var a1$2 = this.R;
      var a1c$2 = a1$2.ar();
      a1c$2.a[index] = elem;
      return new $c_sci_Vector2(a1c$2, this.eM, this.es, this.aj, this.am);
    }
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.aj.a.length < 32)) {
    var suffix1$3 = $m_sci_VectorStatics$().DX(this.aj, elem);
    var length0$3 = ((1 + this.am) | 0);
    return new $c_sci_Vector2(this.R, this.eM, this.es, suffix1$3, length0$3);
  } else if ((this.es.a.length < 30)) {
    var data2$4 = $m_sci_VectorStatics$().bN(this.es, this.aj);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var length0$4 = ((1 + this.am) | 0);
    return new $c_sci_Vector2(this.R, this.eM, data2$4, a, length0$4);
  } else {
    var $x_5 = this.R;
    var $x_4 = this.eM;
    var $x_3 = this.es;
    var $x_2 = this.eM;
    var $x_1 = $m_sci_VectorStatics$().e0;
    var x = this.aj;
    var a$1 = new ($d_O.r().r().C)(1);
    a$1.a[0] = x;
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    return new $c_sci_Vector3($x_5, $x_4, $x_3, ((960 + $x_2) | 0), $x_1, a$1, a$2, ((1 + this.am) | 0));
  }
});
$p.hN = (function(elem) {
  if ((this.eM < 32)) {
    var prefix1$5 = $m_sci_VectorStatics$().DY(elem, this.R);
    var len1$5 = ((1 + this.eM) | 0);
    var length0$5 = ((1 + this.am) | 0);
    return new $c_sci_Vector2(prefix1$5, len1$5, this.es, this.aj, length0$5);
  } else if ((this.es.a.length < 30)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var data2$6 = $m_sci_VectorStatics$().bi(this.R, this.es);
    var length0$6 = ((1 + this.am) | 0);
    return new $c_sci_Vector2(a, 1, data2$6, this.aj, length0$6);
  } else {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var x = this.R;
    var a$2 = new ($d_O.r().r().C)(1);
    a$2.a[0] = x;
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.eM) | 0), $m_sci_VectorStatics$().e0, this.es, this.aj, ((1 + this.am) | 0));
  }
});
$p.mI = (function(f) {
  var prefix1$7 = $m_sci_VectorStatics$().kO(this.R, f);
  var data2$7 = $m_sci_VectorStatics$().dU(2, this.es, f);
  var suffix1$7 = $m_sci_VectorStatics$().kO(this.aj, f);
  return new $c_sci_Vector2(prefix1$7, this.eM, data2$7, suffix1$7, this.am);
});
$p.kU = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.cA(1, this.R);
  b.cA(2, this.es);
  b.cA(1, this.aj);
  return b.ix();
});
$p.jy = (function() {
  if ((this.eM > 1)) {
    var a = this.R;
    var prefix1$8 = $m_ju_Arrays$().bO(a, 1, a.a.length);
    var len1$7 = ((this.eM - 1) | 0);
    var length0$8 = ((this.am - 1) | 0);
    return new $c_sci_Vector2(prefix1$8, len1$7, this.es, this.aj, length0$8);
  } else {
    return this.kU(1, this.am);
  }
});
$p.jD = (function() {
  return 3;
});
$p.mQ = (function(idx) {
  switch (idx) {
    case 0: {
      return this.R;
      break;
    }
    case 1: {
      return this.es;
      break;
    }
    case 2: {
      return this.aj;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.iv = (function(prefix, k) {
  var x14 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x14 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  var diff = ((x14.a.length - this.R.a.length) | 0);
  var len1$9 = ((this.eM + diff) | 0);
  var length0$10 = ((this.am + diff) | 0);
  return new $c_sci_Vector2(x14, len1$9, this.es, this.aj, length0$10);
});
$p.ik = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().DN(this.aj, suffix);
  if ((suffix1b !== null)) {
    var length0$11 = ((((this.am - this.aj.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector2(this.R, this.eM, this.es, suffix1b, length0$11);
  } else {
    return $c_sci_Vector.prototype.ik.call(this, suffix, k);
  }
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.eM) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.es.a.length) ? this.es.a[i2].a[i1] : this.aj.a[(31 & io)]);
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hD)));
}
var $d_sci_Vector2 = new $TypeData().i($c_sci_Vector2, "scala.collection.immutable.Vector2", ({
  hD: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.R = null;
  this.aj = null;
  this.am = 0;
  this.eD = 0;
  this.eE = null;
  this.e9 = 0;
  this.dB = null;
  this.dO = null;
  this.eD = len1;
  this.eE = prefix2;
  this.e9 = len12;
  this.dB = data3;
  this.dO = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector3.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
}
$h_sci_Vector3.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.e9) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.dB.a.length) ? this.dB.a[i3].a[i2].a[i1] : ((i2 < this.dO.a.length) ? this.dO.a[i2].a[i1] : this.aj.a[i1]));
    } else if ((index >= this.eD)) {
      var io$2 = ((index - this.eD) | 0);
      return this.eE.a[((io$2 >>> 5) | 0)].a[(31 & io$2)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.am))) {
    if ((index >= this.e9)) {
      var io = ((index - this.e9) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.dB.a.length)) {
        var a3 = this.dB;
        var a3c = a3.ar();
        var a2 = a3c.a[i3];
        var a2c = a2.ar();
        var a1 = a2c.a[i2];
        var a1c = a1.ar();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, a3c, this.dO, this.aj, this.am);
      } else if ((i2 < this.dO.a.length)) {
        var a2$1 = this.dO;
        var a2c$1 = a2$1.ar();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ar();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, this.dB, a2c$1, this.aj, this.am);
      } else {
        var a1$2 = this.aj;
        var a1c$2 = a1$2.ar();
        a1c$2.a[i1] = elem;
        return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, this.dB, this.dO, a1c$2, this.am);
      }
    } else if ((index >= this.eD)) {
      var io$2 = ((index - this.eD) | 0);
      var a2$2 = this.eE;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.ar();
      var a1$3 = a2c$2.a[idx2];
      var a1c$3 = a1$3.ar();
      a1c$3.a[idx1] = elem;
      a2c$2.a[idx2] = a1c$3;
      return new $c_sci_Vector3(this.R, this.eD, a2c$2, this.e9, this.dB, this.dO, this.aj, this.am);
    } else {
      var a1$4 = this.R;
      var a1c$4 = a1$4.ar();
      a1c$4.a[index] = elem;
      return new $c_sci_Vector3(a1c$4, this.eD, this.eE, this.e9, this.dB, this.dO, this.aj, this.am);
    }
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.aj.a.length < 32)) {
    var suffix1$16 = $m_sci_VectorStatics$().DX(this.aj, elem);
    var length0$16 = ((1 + this.am) | 0);
    return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, this.dB, this.dO, suffix1$16, length0$16);
  } else if ((this.dO.a.length < 31)) {
    var suffix2$6 = $m_sci_VectorStatics$().bN(this.dO, this.aj);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var length0$17 = ((1 + this.am) | 0);
    return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, this.dB, suffix2$6, a, length0$17);
  } else if ((this.dB.a.length < 30)) {
    var data3$7 = $m_sci_VectorStatics$().bN(this.dB, $m_sci_VectorStatics$().bN(this.dO, this.aj));
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var length0$18 = ((1 + this.am) | 0);
    return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, data3$7, $m_sci_VectorStatics$().c3, a$1, length0$18);
  } else {
    var $x_8 = this.R;
    var $x_7 = this.eD;
    var $x_6 = this.eE;
    var $x_5 = this.e9;
    var $x_4 = this.dB;
    var $x_3 = this.e9;
    var $x_2 = $m_sci_VectorStatics$().h4;
    var x = $m_sci_VectorStatics$().bN(this.dO, this.aj);
    var a$2 = new ($d_O.r().r().r().C)(1);
    a$2.a[0] = x;
    var $x_1 = $m_sci_VectorStatics$().c3;
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    return new $c_sci_Vector4($x_8, $x_7, $x_6, $x_5, $x_4, ((30720 + $x_3) | 0), $x_2, a$2, $x_1, a$3, ((1 + this.am) | 0));
  }
});
$p.hN = (function(elem) {
  if ((this.eD < 32)) {
    var prefix1$18 = $m_sci_VectorStatics$().DY(elem, this.R);
    var len1$18 = ((1 + this.eD) | 0);
    var len12$8 = ((1 + this.e9) | 0);
    var length0$19 = ((1 + this.am) | 0);
    return new $c_sci_Vector3(prefix1$18, len1$18, this.eE, len12$8, this.dB, this.dO, this.aj, length0$19);
  } else if ((this.e9 < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var prefix2$9 = $m_sci_VectorStatics$().bi(this.R, this.eE);
    var len12$9 = ((1 + this.e9) | 0);
    var length0$20 = ((1 + this.am) | 0);
    return new $c_sci_Vector3(a, 1, prefix2$9, len12$9, this.dB, this.dO, this.aj, length0$20);
  } else if ((this.dB.a.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var data3$10 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.eE), this.dB);
    var length0$21 = ((1 + this.am) | 0);
    var suffix2$9 = this.dO;
    var suffix1$21 = this.aj;
    return new $c_sci_Vector3(a$1, 1, $m_sci_VectorStatics$().c3, 1, data3$10, suffix2$9, suffix1$21, length0$21);
  } else {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var $x_1 = $m_sci_VectorStatics$().c3;
    var x = $m_sci_VectorStatics$().bi(this.R, this.eE);
    var a$3 = new ($d_O.r().r().r().C)(1);
    a$3.a[0] = x;
    return new $c_sci_Vector4(a$2, 1, $x_1, 1, a$3, ((1 + this.e9) | 0), $m_sci_VectorStatics$().h4, this.dB, this.dO, this.aj, ((1 + this.am) | 0));
  }
});
$p.mI = (function(f) {
  var prefix1$21 = $m_sci_VectorStatics$().kO(this.R, f);
  var prefix2$10 = $m_sci_VectorStatics$().dU(2, this.eE, f);
  var data3$11 = $m_sci_VectorStatics$().dU(3, this.dB, f);
  var suffix2$10 = $m_sci_VectorStatics$().dU(2, this.dO, f);
  var suffix1$22 = $m_sci_VectorStatics$().kO(this.aj, f);
  return new $c_sci_Vector3(prefix1$21, this.eD, prefix2$10, this.e9, data3$11, suffix2$10, suffix1$22, this.am);
});
$p.kU = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.cA(1, this.R);
  b.cA(2, this.eE);
  b.cA(3, this.dB);
  b.cA(2, this.dO);
  b.cA(1, this.aj);
  return b.ix();
});
$p.jy = (function() {
  if ((this.eD > 1)) {
    var a = this.R;
    var prefix1$22 = $m_ju_Arrays$().bO(a, 1, a.a.length);
    var len1$20 = ((this.eD - 1) | 0);
    var len12$11 = ((this.e9 - 1) | 0);
    var length0$23 = ((this.am - 1) | 0);
    return new $c_sci_Vector3(prefix1$22, len1$20, this.eE, len12$11, this.dB, this.dO, this.aj, length0$23);
  } else {
    return this.kU(1, this.am);
  }
});
$p.jD = (function() {
  return 5;
});
$p.mQ = (function(idx) {
  switch (idx) {
    case 0: {
      return this.R;
      break;
    }
    case 1: {
      return this.eE;
      break;
    }
    case 2: {
      return this.dB;
      break;
    }
    case 3: {
      return this.dO;
      break;
    }
    case 4: {
      return this.aj;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.iv = (function(prefix, k) {
  var x17 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x17 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  var diff = ((x17.a.length - this.R.a.length) | 0);
  var len1$22 = ((this.eD + diff) | 0);
  var len12$13 = ((this.e9 + diff) | 0);
  var length0$25 = ((this.am + diff) | 0);
  return new $c_sci_Vector3(x17, len1$22, this.eE, len12$13, this.dB, this.dO, this.aj, length0$25);
});
$p.ik = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().DN(this.aj, suffix);
  if ((suffix1b !== null)) {
    var length0$26 = ((((this.am - this.aj.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector3(this.R, this.eD, this.eE, this.e9, this.dB, this.dO, suffix1b, length0$26);
  } else {
    return $c_sci_Vector.prototype.ik.call(this, suffix, k);
  }
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.e9) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.dB.a.length) ? this.dB.a[i3].a[i2].a[i1] : ((i2 < this.dO.a.length) ? this.dO.a[i2].a[i1] : this.aj.a[i1]));
    } else if ((index >= this.eD)) {
      var io$2 = ((index - this.eD) | 0);
      return this.eE.a[((io$2 >>> 5) | 0)].a[(31 & io$2)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hE)));
}
var $d_sci_Vector3 = new $TypeData().i($c_sci_Vector3, "scala.collection.immutable.Vector3", ({
  hE: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.R = null;
  this.aj = null;
  this.am = 0;
  this.dY = 0;
  this.dP = null;
  this.dZ = 0;
  this.dQ = null;
  this.dm = 0;
  this.cV = null;
  this.d6 = null;
  this.d5 = null;
  this.dY = len1;
  this.dP = prefix2;
  this.dZ = len12;
  this.dQ = prefix3;
  this.dm = len123;
  this.cV = data4;
  this.d6 = suffix3;
  this.d5 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector4.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
}
$h_sci_Vector4.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.dm) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.cV.a.length) ? this.cV.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.d6.a.length) ? this.d6.a[i3].a[i2].a[i1] : ((i2 < this.d5.a.length) ? this.d5.a[i2].a[i1] : this.aj.a[i1])));
    } else if ((index >= this.dZ)) {
      var io$2 = ((index - this.dZ) | 0);
      return this.dQ.a[((io$2 >>> 10) | 0)].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.dY)) {
      var io$3 = ((index - this.dY) | 0);
      return this.dP.a[((io$3 >>> 5) | 0)].a[(31 & io$3)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.am))) {
    if ((index >= this.dm)) {
      var io = ((index - this.dm) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.cV.a.length)) {
        var a4 = this.cV;
        var a4c = a4.ar();
        var a3 = a4c.a[i4];
        var a3c = a3.ar();
        var a2 = a3c.a[i3];
        var a2c = a2.ar();
        var a1 = a2c.a[i2];
        var a1c = a1.ar();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, a4c, this.d6, this.d5, this.aj, this.am);
      } else if ((i3 < this.d6.a.length)) {
        var a3$1 = this.d6;
        var a3c$1 = a3$1.ar();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ar();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ar();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, a3c$1, this.d5, this.aj, this.am);
      } else if ((i2 < this.d5.a.length)) {
        var a2$2 = this.d5;
        var a2c$2 = a2$2.ar();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ar();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, a2c$2, this.aj, this.am);
      } else {
        var a1$3 = this.aj;
        var a1c$3 = a1$3.ar();
        a1c$3.a[i1] = elem;
        return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, this.d5, a1c$3, this.am);
      }
    } else if ((index >= this.dZ)) {
      var io$2 = ((index - this.dZ) | 0);
      var a3$2 = this.dQ;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.ar();
      var a2$3 = a3c$2.a[idx3];
      var a2c$3 = a2$3.ar();
      var a1$4 = a2c$3.a[idx2];
      var a1c$4 = a1$4.ar();
      a1c$4.a[idx1] = elem;
      a2c$3.a[idx2] = a1c$4;
      a3c$2.a[idx3] = a2c$3;
      return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, a3c$2, this.dm, this.cV, this.d6, this.d5, this.aj, this.am);
    } else if ((index >= this.dY)) {
      var io$3 = ((index - this.dY) | 0);
      var a2$4 = this.dP;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.ar();
      var a1$5 = a2c$4.a[idx2$1];
      var a1c$5 = a1$5.ar();
      a1c$5.a[idx1$1] = elem;
      a2c$4.a[idx2$1] = a1c$5;
      return new $c_sci_Vector4(this.R, this.dY, a2c$4, this.dZ, this.dQ, this.dm, this.cV, this.d6, this.d5, this.aj, this.am);
    } else {
      var a1$6 = this.R;
      var a1c$6 = a1$6.ar();
      a1c$6.a[index] = elem;
      return new $c_sci_Vector4(a1c$6, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, this.d5, this.aj, this.am);
    }
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.aj.a.length < 32)) {
    var suffix1$33 = $m_sci_VectorStatics$().DX(this.aj, elem);
    var length0$33 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, this.d5, suffix1$33, length0$33);
  } else if ((this.d5.a.length < 31)) {
    var suffix2$22 = $m_sci_VectorStatics$().bN(this.d5, this.aj);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var length0$34 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, suffix2$22, a, length0$34);
  } else if ((this.d6.a.length < 31)) {
    var suffix3$9 = $m_sci_VectorStatics$().bN(this.d6, $m_sci_VectorStatics$().bN(this.d5, this.aj));
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var length0$35 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, suffix3$9, $m_sci_VectorStatics$().c3, a$1, length0$35);
  } else if ((this.cV.a.length < 30)) {
    var data4$10 = $m_sci_VectorStatics$().bN(this.cV, $m_sci_VectorStatics$().bN(this.d6, $m_sci_VectorStatics$().bN(this.d5, this.aj)));
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var length0$36 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, data4$10, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$2, length0$36);
  } else {
    var $x_11 = this.R;
    var $x_10 = this.dY;
    var $x_9 = this.dP;
    var $x_8 = this.dZ;
    var $x_7 = this.dQ;
    var $x_6 = this.dm;
    var $x_5 = this.cV;
    var $x_4 = this.dm;
    var $x_3 = $m_sci_VectorStatics$().tB;
    var x = $m_sci_VectorStatics$().bN(this.d6, $m_sci_VectorStatics$().bN(this.d5, this.aj));
    var a$3 = new ($d_O.r().r().r().r().C)(1);
    a$3.a[0] = x;
    var $x_2 = $m_sci_VectorStatics$().e0;
    var $x_1 = $m_sci_VectorStatics$().c3;
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    return new $c_sci_Vector5($x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, ((983040 + $x_4) | 0), $x_3, a$3, $x_2, $x_1, a$4, ((1 + this.am) | 0));
  }
});
$p.hN = (function(elem) {
  if ((this.dY < 32)) {
    var prefix1$35 = $m_sci_VectorStatics$().DY(elem, this.R);
    var len1$34 = ((1 + this.dY) | 0);
    var len12$25 = ((1 + this.dZ) | 0);
    var len123$11 = ((1 + this.dm) | 0);
    var length0$37 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(prefix1$35, len1$34, this.dP, len12$25, this.dQ, len123$11, this.cV, this.d6, this.d5, this.aj, length0$37);
  } else if ((this.dZ < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var prefix2$26 = $m_sci_VectorStatics$().bi(this.R, this.dP);
    var len12$26 = ((1 + this.dZ) | 0);
    var len123$12 = ((1 + this.dm) | 0);
    var length0$38 = ((1 + this.am) | 0);
    return new $c_sci_Vector4(a, 1, prefix2$26, len12$26, this.dQ, len123$12, this.cV, this.d6, this.d5, this.aj, length0$38);
  } else if ((this.dm < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var prefix3$13 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.dP), this.dQ);
    var len123$13 = ((1 + this.dm) | 0);
    var length0$39 = ((1 + this.am) | 0);
    var data4$13 = this.cV;
    var suffix3$12 = this.d6;
    var suffix2$25 = this.d5;
    var suffix1$39 = this.aj;
    return new $c_sci_Vector4(a$1, 1, $m_sci_VectorStatics$().c3, 1, prefix3$13, len123$13, data4$13, suffix3$12, suffix2$25, suffix1$39, length0$39);
  } else if ((this.cV.a.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var data4$14 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.dP), this.dQ), this.cV);
    var length0$40 = ((1 + this.am) | 0);
    var suffix3$13 = this.d6;
    var suffix2$26 = this.d5;
    var suffix1$40 = this.aj;
    return new $c_sci_Vector4(a$2, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, data4$14, suffix3$13, suffix2$26, suffix1$40, length0$40);
  } else {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var $x_2 = $m_sci_VectorStatics$().c3;
    var $x_1 = $m_sci_VectorStatics$().e0;
    var x = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.dP), this.dQ);
    var a$4 = new ($d_O.r().r().r().r().C)(1);
    a$4.a[0] = x;
    return new $c_sci_Vector5(a$3, 1, $x_2, 1, $x_1, 1, a$4, ((1 + this.dm) | 0), $m_sci_VectorStatics$().tB, this.cV, this.d6, this.d5, this.aj, ((1 + this.am) | 0));
  }
});
$p.mI = (function(f) {
  var prefix1$39 = $m_sci_VectorStatics$().kO(this.R, f);
  var prefix2$27 = $m_sci_VectorStatics$().dU(2, this.dP, f);
  var prefix3$14 = $m_sci_VectorStatics$().dU(3, this.dQ, f);
  var data4$15 = $m_sci_VectorStatics$().dU(4, this.cV, f);
  var suffix3$14 = $m_sci_VectorStatics$().dU(3, this.d6, f);
  var suffix2$27 = $m_sci_VectorStatics$().dU(2, this.d5, f);
  var suffix1$41 = $m_sci_VectorStatics$().kO(this.aj, f);
  return new $c_sci_Vector4(prefix1$39, this.dY, prefix2$27, this.dZ, prefix3$14, this.dm, data4$15, suffix3$14, suffix2$27, suffix1$41, this.am);
});
$p.kU = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.cA(1, this.R);
  b.cA(2, this.dP);
  b.cA(3, this.dQ);
  b.cA(4, this.cV);
  b.cA(3, this.d6);
  b.cA(2, this.d5);
  b.cA(1, this.aj);
  return b.ix();
});
$p.jy = (function() {
  if ((this.dY > 1)) {
    var a = this.R;
    var prefix1$40 = $m_ju_Arrays$().bO(a, 1, a.a.length);
    var len1$36 = ((this.dY - 1) | 0);
    var len12$28 = ((this.dZ - 1) | 0);
    var len123$15 = ((this.dm - 1) | 0);
    var length0$42 = ((this.am - 1) | 0);
    return new $c_sci_Vector4(prefix1$40, len1$36, this.dP, len12$28, this.dQ, len123$15, this.cV, this.d6, this.d5, this.aj, length0$42);
  } else {
    return this.kU(1, this.am);
  }
});
$p.jD = (function() {
  return 7;
});
$p.mQ = (function(idx) {
  switch (idx) {
    case 0: {
      return this.R;
      break;
    }
    case 1: {
      return this.dP;
      break;
    }
    case 2: {
      return this.dQ;
      break;
    }
    case 3: {
      return this.cV;
      break;
    }
    case 4: {
      return this.d6;
      break;
    }
    case 5: {
      return this.d5;
      break;
    }
    case 6: {
      return this.aj;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.iv = (function(prefix, k) {
  var x20 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x20 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  var diff = ((x20.a.length - this.R.a.length) | 0);
  var len1$38 = ((this.dY + diff) | 0);
  var len12$30 = ((this.dZ + diff) | 0);
  var len123$17 = ((this.dm + diff) | 0);
  var length0$44 = ((this.am + diff) | 0);
  return new $c_sci_Vector4(x20, len1$38, this.dP, len12$30, this.dQ, len123$17, this.cV, this.d6, this.d5, this.aj, length0$44);
});
$p.ik = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().DN(this.aj, suffix);
  if ((suffix1b !== null)) {
    var length0$45 = ((((this.am - this.aj.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector4(this.R, this.dY, this.dP, this.dZ, this.dQ, this.dm, this.cV, this.d6, this.d5, suffix1b, length0$45);
  } else {
    return $c_sci_Vector.prototype.ik.call(this, suffix, k);
  }
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.dm) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.cV.a.length) ? this.cV.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.d6.a.length) ? this.d6.a[i3].a[i2].a[i1] : ((i2 < this.d5.a.length) ? this.d5.a[i2].a[i1] : this.aj.a[i1])));
    } else if ((index >= this.dZ)) {
      var io$2 = ((index - this.dZ) | 0);
      return this.dQ.a[((io$2 >>> 10) | 0)].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.dY)) {
      var io$3 = ((index - this.dY) | 0);
      return this.dP.a[((io$3 >>> 5) | 0)].a[(31 & io$3)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hF)));
}
var $d_sci_Vector4 = new $TypeData().i($c_sci_Vector4, "scala.collection.immutable.Vector4", ({
  hF: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.R = null;
  this.aj = null;
  this.am = 0;
  this.dn = 0;
  this.d7 = null;
  this.dp = 0;
  this.d8 = null;
  this.dg = 0;
  this.d9 = null;
  this.cM = 0;
  this.cj = null;
  this.cy = null;
  this.cx = null;
  this.cw = null;
  this.dn = len1;
  this.d7 = prefix2;
  this.dp = len12;
  this.d8 = prefix3;
  this.dg = len123;
  this.d9 = prefix4;
  this.cM = len1234;
  this.cj = data5;
  this.cy = suffix4;
  this.cx = suffix3;
  this.cw = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector5.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
}
$h_sci_Vector5.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.cM) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.cj.a.length) ? this.cj.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.cy.a.length) ? this.cy.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.cx.a.length) ? this.cx.a[i3].a[i2].a[i1] : ((i2 < this.cw.a.length) ? this.cw.a[i2].a[i1] : this.aj.a[i1]))));
    } else if ((index >= this.dg)) {
      var io$2 = ((index - this.dg) | 0);
      return this.d9.a[((io$2 >>> 15) | 0)].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.dp)) {
      var io$3 = ((index - this.dp) | 0);
      return this.d8.a[((io$3 >>> 10) | 0)].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.dn)) {
      var io$4 = ((index - this.dn) | 0);
      return this.d7.a[((io$4 >>> 5) | 0)].a[(31 & io$4)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.am))) {
    if ((index >= this.cM)) {
      var io = ((index - this.cM) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.cj.a.length)) {
        var a5 = this.cj;
        var a5c = a5.ar();
        var a4 = a5c.a[i5];
        var a4c = a4.ar();
        var a3 = a4c.a[i4];
        var a3c = a3.ar();
        var a2 = a3c.a[i3];
        var a2c = a2.ar();
        var a1 = a2c.a[i2];
        var a1c = a1.ar();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        a5c.a[i5] = a4c;
        return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, a5c, this.cy, this.cx, this.cw, this.aj, this.am);
      } else if ((i4 < this.cy.a.length)) {
        var a4$1 = this.cy;
        var a4c$1 = a4$1.ar();
        var a3$1 = a4c$1.a[i4];
        var a3c$1 = a3$1.ar();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ar();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ar();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        a4c$1.a[i4] = a3c$1;
        return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, a4c$1, this.cx, this.cw, this.aj, this.am);
      } else if ((i3 < this.cx.a.length)) {
        var a3$2 = this.cx;
        var a3c$2 = a3$2.ar();
        var a2$2 = a3c$2.a[i3];
        var a2c$2 = a2$2.ar();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ar();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        a3c$2.a[i3] = a2c$2;
        return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, a3c$2, this.cw, this.aj, this.am);
      } else if ((i2 < this.cw.a.length)) {
        var a2$3 = this.cw;
        var a2c$3 = a2$3.ar();
        var a1$3 = a2c$3.a[i2];
        var a1c$3 = a1$3.ar();
        a1c$3.a[i1] = elem;
        a2c$3.a[i2] = a1c$3;
        return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, a2c$3, this.aj, this.am);
      } else {
        var a1$4 = this.aj;
        var a1c$4 = a1$4.ar();
        a1c$4.a[i1] = elem;
        return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, a1c$4, this.am);
      }
    } else if ((index >= this.dg)) {
      var io$2 = ((index - this.dg) | 0);
      var a4$2 = this.d9;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.ar();
      var a3$3 = a4c$2.a[idx4];
      var a3c$3 = a3$3.ar();
      var a2$4 = a3c$3.a[idx3];
      var a2c$4 = a2$4.ar();
      var a1$5 = a2c$4.a[idx2];
      var a1c$5 = a1$5.ar();
      a1c$5.a[idx1] = elem;
      a2c$4.a[idx2] = a1c$5;
      a3c$3.a[idx3] = a2c$4;
      a4c$2.a[idx4] = a3c$3;
      return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, a4c$2, this.cM, this.cj, this.cy, this.cx, this.cw, this.aj, this.am);
    } else if ((index >= this.dp)) {
      var io$3 = ((index - this.dp) | 0);
      var a3$4 = this.d8;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.ar();
      var a2$5 = a3c$4.a[idx3$1];
      var a2c$5 = a2$5.ar();
      var a1$6 = a2c$5.a[idx2$1];
      var a1c$6 = a1$6.ar();
      a1c$6.a[idx1$1] = elem;
      a2c$5.a[idx2$1] = a1c$6;
      a3c$4.a[idx3$1] = a2c$5;
      return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, a3c$4, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, this.aj, this.am);
    } else if ((index >= this.dn)) {
      var io$4 = ((index - this.dn) | 0);
      var a2$6 = this.d7;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.ar();
      var a1$7 = a2c$6.a[idx2$2];
      var a1c$7 = a1$7.ar();
      a1c$7.a[idx1$2] = elem;
      a2c$6.a[idx2$2] = a1c$7;
      return new $c_sci_Vector5(this.R, this.dn, a2c$6, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, this.aj, this.am);
    } else {
      var a1$8 = this.R;
      var a1c$8 = a1$8.ar();
      a1c$8.a[index] = elem;
      return new $c_sci_Vector5(a1c$8, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, this.aj, this.am);
    }
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.aj.a.length < 32)) {
    var suffix1$54 = $m_sci_VectorStatics$().DX(this.aj, elem);
    var length0$54 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, suffix1$54, length0$54);
  } else if ((this.cw.a.length < 31)) {
    var suffix2$41 = $m_sci_VectorStatics$().bN(this.cw, this.aj);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var length0$55 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, suffix2$41, a, length0$55);
  } else if ((this.cx.a.length < 31)) {
    var suffix3$29 = $m_sci_VectorStatics$().bN(this.cx, $m_sci_VectorStatics$().bN(this.cw, this.aj));
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var length0$56 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, suffix3$29, $m_sci_VectorStatics$().c3, a$1, length0$56);
  } else if ((this.cy.a.length < 31)) {
    var suffix4$12 = $m_sci_VectorStatics$().bN(this.cy, $m_sci_VectorStatics$().bN(this.cx, $m_sci_VectorStatics$().bN(this.cw, this.aj)));
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var length0$57 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, suffix4$12, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$2, length0$57);
  } else if ((this.cj.a.length < 30)) {
    var data5$13 = $m_sci_VectorStatics$().bN(this.cj, $m_sci_VectorStatics$().bN(this.cy, $m_sci_VectorStatics$().bN(this.cx, $m_sci_VectorStatics$().bN(this.cw, this.aj))));
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var length0$58 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, data5$13, $m_sci_VectorStatics$().h4, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$3, length0$58);
  } else {
    var $x_14 = this.R;
    var $x_13 = this.dn;
    var $x_12 = this.d7;
    var $x_11 = this.dp;
    var $x_10 = this.d8;
    var $x_9 = this.dg;
    var $x_8 = this.d9;
    var $x_7 = this.cM;
    var $x_6 = this.cj;
    var $x_5 = this.cM;
    var $x_4 = $m_sci_VectorStatics$().Lx;
    var x = $m_sci_VectorStatics$().bN(this.cy, $m_sci_VectorStatics$().bN(this.cx, $m_sci_VectorStatics$().bN(this.cw, this.aj)));
    var a$4 = new ($d_O.r().r().r().r().r().C)(1);
    a$4.a[0] = x;
    var $x_3 = $m_sci_VectorStatics$().h4;
    var $x_2 = $m_sci_VectorStatics$().e0;
    var $x_1 = $m_sci_VectorStatics$().c3;
    var a$5 = new $ac_O(1);
    a$5.a[0] = elem;
    return new $c_sci_Vector6($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, ((31457280 + $x_5) | 0), $x_4, a$4, $x_3, $x_2, $x_1, a$5, ((1 + this.am) | 0));
  }
});
$p.hN = (function(elem) {
  if ((this.dn < 32)) {
    var prefix1$56 = $m_sci_VectorStatics$().DY(elem, this.R);
    var len1$53 = ((1 + this.dn) | 0);
    var len12$45 = ((1 + this.dp) | 0);
    var len123$32 = ((1 + this.dg) | 0);
    var len1234$14 = ((1 + this.cM) | 0);
    var length0$59 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(prefix1$56, len1$53, this.d7, len12$45, this.d8, len123$32, this.d9, len1234$14, this.cj, this.cy, this.cx, this.cw, this.aj, length0$59);
  } else if ((this.dp < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var prefix2$46 = $m_sci_VectorStatics$().bi(this.R, this.d7);
    var len12$46 = ((1 + this.dp) | 0);
    var len123$33 = ((1 + this.dg) | 0);
    var len1234$15 = ((1 + this.cM) | 0);
    var length0$60 = ((1 + this.am) | 0);
    return new $c_sci_Vector5(a, 1, prefix2$46, len12$46, this.d8, len123$33, this.d9, len1234$15, this.cj, this.cy, this.cx, this.cw, this.aj, length0$60);
  } else if ((this.dg < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var prefix3$34 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.d7), this.d8);
    var len123$34 = ((1 + this.dg) | 0);
    var len1234$16 = ((1 + this.cM) | 0);
    var length0$61 = ((1 + this.am) | 0);
    var prefix4$16 = this.d9;
    var data5$16 = this.cj;
    var suffix4$15 = this.cy;
    var suffix3$32 = this.cx;
    var suffix2$44 = this.cw;
    var suffix1$61 = this.aj;
    return new $c_sci_Vector5(a$1, 1, $m_sci_VectorStatics$().c3, 1, prefix3$34, len123$34, prefix4$16, len1234$16, data5$16, suffix4$15, suffix3$32, suffix2$44, suffix1$61, length0$61);
  } else if ((this.cM < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var prefix4$17 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.d7), this.d8), this.d9);
    var len1234$17 = ((1 + this.cM) | 0);
    var length0$62 = ((1 + this.am) | 0);
    var data5$17 = this.cj;
    var suffix4$16 = this.cy;
    var suffix3$33 = this.cx;
    var suffix2$45 = this.cw;
    var suffix1$62 = this.aj;
    return new $c_sci_Vector5(a$2, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, prefix4$17, len1234$17, data5$17, suffix4$16, suffix3$33, suffix2$45, suffix1$62, length0$62);
  } else if ((this.cj.a.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var data5$18 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.d7), this.d8), this.d9), this.cj);
    var length0$63 = ((1 + this.am) | 0);
    var suffix4$17 = this.cy;
    var suffix3$34 = this.cx;
    var suffix2$46 = this.cw;
    var suffix1$63 = this.aj;
    return new $c_sci_Vector5(a$3, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, $m_sci_VectorStatics$().h4, 1, data5$18, suffix4$17, suffix3$34, suffix2$46, suffix1$63, length0$63);
  } else {
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var $x_3 = $m_sci_VectorStatics$().c3;
    var $x_2 = $m_sci_VectorStatics$().e0;
    var $x_1 = $m_sci_VectorStatics$().h4;
    var x = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.d7), this.d8), this.d9);
    var a$5 = new ($d_O.r().r().r().r().r().C)(1);
    a$5.a[0] = x;
    return new $c_sci_Vector6(a$4, 1, $x_3, 1, $x_2, 1, $x_1, 1, a$5, ((1 + this.cM) | 0), $m_sci_VectorStatics$().Lx, this.cj, this.cy, this.cx, this.cw, this.aj, ((1 + this.am) | 0));
  }
});
$p.mI = (function(f) {
  var prefix1$61 = $m_sci_VectorStatics$().kO(this.R, f);
  var prefix2$47 = $m_sci_VectorStatics$().dU(2, this.d7, f);
  var prefix3$35 = $m_sci_VectorStatics$().dU(3, this.d8, f);
  var prefix4$18 = $m_sci_VectorStatics$().dU(4, this.d9, f);
  var data5$19 = $m_sci_VectorStatics$().dU(5, this.cj, f);
  var suffix4$18 = $m_sci_VectorStatics$().dU(4, this.cy, f);
  var suffix3$35 = $m_sci_VectorStatics$().dU(3, this.cx, f);
  var suffix2$47 = $m_sci_VectorStatics$().dU(2, this.cw, f);
  var suffix1$64 = $m_sci_VectorStatics$().kO(this.aj, f);
  return new $c_sci_Vector5(prefix1$61, this.dn, prefix2$47, this.dp, prefix3$35, this.dg, prefix4$18, this.cM, data5$19, suffix4$18, suffix3$35, suffix2$47, suffix1$64, this.am);
});
$p.kU = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.cA(1, this.R);
  b.cA(2, this.d7);
  b.cA(3, this.d8);
  b.cA(4, this.d9);
  b.cA(5, this.cj);
  b.cA(4, this.cy);
  b.cA(3, this.cx);
  b.cA(2, this.cw);
  b.cA(1, this.aj);
  return b.ix();
});
$p.jy = (function() {
  if ((this.dn > 1)) {
    var a = this.R;
    var prefix1$62 = $m_ju_Arrays$().bO(a, 1, a.a.length);
    var len1$55 = ((this.dn - 1) | 0);
    var len12$48 = ((this.dp - 1) | 0);
    var len123$36 = ((this.dg - 1) | 0);
    var len1234$19 = ((this.cM - 1) | 0);
    var length0$65 = ((this.am - 1) | 0);
    return new $c_sci_Vector5(prefix1$62, len1$55, this.d7, len12$48, this.d8, len123$36, this.d9, len1234$19, this.cj, this.cy, this.cx, this.cw, this.aj, length0$65);
  } else {
    return this.kU(1, this.am);
  }
});
$p.jD = (function() {
  return 9;
});
$p.mQ = (function(idx) {
  switch (idx) {
    case 0: {
      return this.R;
      break;
    }
    case 1: {
      return this.d7;
      break;
    }
    case 2: {
      return this.d8;
      break;
    }
    case 3: {
      return this.d9;
      break;
    }
    case 4: {
      return this.cj;
      break;
    }
    case 5: {
      return this.cy;
      break;
    }
    case 6: {
      return this.cx;
      break;
    }
    case 7: {
      return this.cw;
      break;
    }
    case 8: {
      return this.aj;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.iv = (function(prefix, k) {
  var x23 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x23 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  var diff = ((x23.a.length - this.R.a.length) | 0);
  var len1$57 = ((this.dn + diff) | 0);
  var len12$50 = ((this.dp + diff) | 0);
  var len123$38 = ((this.dg + diff) | 0);
  var len1234$21 = ((this.cM + diff) | 0);
  var length0$67 = ((this.am + diff) | 0);
  return new $c_sci_Vector5(x23, len1$57, this.d7, len12$50, this.d8, len123$38, this.d9, len1234$21, this.cj, this.cy, this.cx, this.cw, this.aj, length0$67);
});
$p.ik = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().DN(this.aj, suffix);
  if ((suffix1b !== null)) {
    var length0$68 = ((((this.am - this.aj.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector5(this.R, this.dn, this.d7, this.dp, this.d8, this.dg, this.d9, this.cM, this.cj, this.cy, this.cx, this.cw, suffix1b, length0$68);
  } else {
    return $c_sci_Vector.prototype.ik.call(this, suffix, k);
  }
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.cM) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.cj.a.length) ? this.cj.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.cy.a.length) ? this.cy.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.cx.a.length) ? this.cx.a[i3].a[i2].a[i1] : ((i2 < this.cw.a.length) ? this.cw.a[i2].a[i1] : this.aj.a[i1]))));
    } else if ((index >= this.dg)) {
      var io$2 = ((index - this.dg) | 0);
      return this.d9.a[((io$2 >>> 15) | 0)].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.dp)) {
      var io$3 = ((index - this.dp) | 0);
      return this.d8.a[((io$3 >>> 10) | 0)].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.dn)) {
      var io$4 = ((index - this.dn) | 0);
      return this.d7.a[((io$4 >>> 5) | 0)].a[(31 & io$4)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hG)));
}
var $d_sci_Vector5 = new $TypeData().i($c_sci_Vector5, "scala.collection.immutable.Vector5", ({
  hG: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.R = null;
  this.aj = null;
  this.am = 0;
  this.da = 0;
  this.cO = null;
  this.db = 0;
  this.cP = null;
  this.cW = 0;
  this.cQ = null;
  this.cN = 0;
  this.cR = null;
  this.cG = 0;
  this.c2 = null;
  this.cd = null;
  this.cc = null;
  this.cb = null;
  this.ca = null;
  this.da = len1;
  this.cO = prefix2;
  this.db = len12;
  this.cP = prefix3;
  this.cW = len123;
  this.cQ = prefix4;
  this.cN = len1234;
  this.cR = prefix5;
  this.cG = len12345;
  this.c2 = data6;
  this.cd = suffix5;
  this.cc = suffix4;
  this.cb = suffix3;
  this.ca = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$p = $c_sci_Vector6.prototype = new $h_sci_BigVector();
$p.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
}
$h_sci_Vector6.prototype = $p;
$p.at = (function(index) {
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.cG) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.c2.a.length) ? this.c2.a[i6].a[i5].a[i4].a[i3].a[i2].a[i1] : ((i5 < this.cd.a.length) ? this.cd.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.cc.a.length) ? this.cc.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.cb.a.length) ? this.cb.a[i3].a[i2].a[i1] : ((i2 < this.ca.a.length) ? this.ca.a[i2].a[i1] : this.aj.a[i1])))));
    } else if ((index >= this.cN)) {
      var io$2 = ((index - this.cN) | 0);
      return this.cR.a[((io$2 >>> 20) | 0)].a[(31 & ((io$2 >>> 15) | 0))].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.cW)) {
      var io$3 = ((index - this.cW) | 0);
      return this.cQ.a[((io$3 >>> 15) | 0)].a[(31 & ((io$3 >>> 10) | 0))].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.db)) {
      var io$4 = ((index - this.db) | 0);
      return this.cP.a[((io$4 >>> 10) | 0)].a[(31 & ((io$4 >>> 5) | 0))].a[(31 & io$4)];
    } else if ((index >= this.da)) {
      var io$5 = ((index - this.da) | 0);
      return this.cO.a[((io$5 >>> 5) | 0)].a[(31 & io$5)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.qQ = (function(index, elem) {
  if (((index >= 0) && (index < this.am))) {
    if ((index >= this.cG)) {
      var io = ((index - this.cG) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.c2.a.length)) {
        var a6 = this.c2;
        var a6c = a6.ar();
        var a5 = a6c.a[i6];
        var a5c = a5.ar();
        var a4 = a5c.a[i5];
        var a4c = a4.ar();
        var a3 = a4c.a[i4];
        var a3c = a3.ar();
        var a2 = a3c.a[i3];
        var a2c = a2.ar();
        var a1 = a2c.a[i2];
        var a1c = a1.ar();
        a1c.a[i1] = elem;
        a2c.a[i2] = a1c;
        a3c.a[i3] = a2c;
        a4c.a[i4] = a3c;
        a5c.a[i5] = a4c;
        a6c.a[i6] = a5c;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, a6c, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
      } else if ((i5 < this.cd.a.length)) {
        var a5$1 = this.cd;
        var a5c$1 = a5$1.ar();
        var a4$1 = a5c$1.a[i5];
        var a4c$1 = a4$1.ar();
        var a3$1 = a4c$1.a[i4];
        var a3c$1 = a3$1.ar();
        var a2$1 = a3c$1.a[i3];
        var a2c$1 = a2$1.ar();
        var a1$1 = a2c$1.a[i2];
        var a1c$1 = a1$1.ar();
        a1c$1.a[i1] = elem;
        a2c$1.a[i2] = a1c$1;
        a3c$1.a[i3] = a2c$1;
        a4c$1.a[i4] = a3c$1;
        a5c$1.a[i5] = a4c$1;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, a5c$1, this.cc, this.cb, this.ca, this.aj, this.am);
      } else if ((i4 < this.cc.a.length)) {
        var a4$2 = this.cc;
        var a4c$2 = a4$2.ar();
        var a3$2 = a4c$2.a[i4];
        var a3c$2 = a3$2.ar();
        var a2$2 = a3c$2.a[i3];
        var a2c$2 = a2$2.ar();
        var a1$2 = a2c$2.a[i2];
        var a1c$2 = a1$2.ar();
        a1c$2.a[i1] = elem;
        a2c$2.a[i2] = a1c$2;
        a3c$2.a[i3] = a2c$2;
        a4c$2.a[i4] = a3c$2;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, a4c$2, this.cb, this.ca, this.aj, this.am);
      } else if ((i3 < this.cb.a.length)) {
        var a3$3 = this.cb;
        var a3c$3 = a3$3.ar();
        var a2$3 = a3c$3.a[i3];
        var a2c$3 = a2$3.ar();
        var a1$3 = a2c$3.a[i2];
        var a1c$3 = a1$3.ar();
        a1c$3.a[i1] = elem;
        a2c$3.a[i2] = a1c$3;
        a3c$3.a[i3] = a2c$3;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, a3c$3, this.ca, this.aj, this.am);
      } else if ((i2 < this.ca.a.length)) {
        var a2$4 = this.ca;
        var a2c$4 = a2$4.ar();
        var a1$4 = a2c$4.a[i2];
        var a1c$4 = a1$4.ar();
        a1c$4.a[i1] = elem;
        a2c$4.a[i2] = a1c$4;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, a2c$4, this.aj, this.am);
      } else {
        var a1$5 = this.aj;
        var a1c$5 = a1$5.ar();
        a1c$5.a[i1] = elem;
        return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, a1c$5, this.am);
      }
    } else if ((index >= this.cN)) {
      var io$2 = ((index - this.cN) | 0);
      var a5$2 = this.cR;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.ar();
      var a4$3 = a5c$2.a[idx5];
      var a4c$3 = a4$3.ar();
      var a3$4 = a4c$3.a[idx4];
      var a3c$4 = a3$4.ar();
      var a2$5 = a3c$4.a[idx3];
      var a2c$5 = a2$5.ar();
      var a1$6 = a2c$5.a[idx2];
      var a1c$6 = a1$6.ar();
      a1c$6.a[idx1] = elem;
      a2c$5.a[idx2] = a1c$6;
      a3c$4.a[idx3] = a2c$5;
      a4c$3.a[idx4] = a3c$4;
      a5c$2.a[idx5] = a4c$3;
      return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, a5c$2, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
    } else if ((index >= this.cW)) {
      var io$3 = ((index - this.cW) | 0);
      var a4$4 = this.cQ;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.ar();
      var a3$5 = a4c$4.a[idx4$1];
      var a3c$5 = a3$5.ar();
      var a2$6 = a3c$5.a[idx3$1];
      var a2c$6 = a2$6.ar();
      var a1$7 = a2c$6.a[idx2$1];
      var a1c$7 = a1$7.ar();
      a1c$7.a[idx1$1] = elem;
      a2c$6.a[idx2$1] = a1c$7;
      a3c$5.a[idx3$1] = a2c$6;
      a4c$4.a[idx4$1] = a3c$5;
      return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, a4c$4, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
    } else if ((index >= this.db)) {
      var io$4 = ((index - this.db) | 0);
      var a3$6 = this.cP;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.ar();
      var a2$7 = a3c$6.a[idx3$2];
      var a2c$7 = a2$7.ar();
      var a1$8 = a2c$7.a[idx2$2];
      var a1c$8 = a1$8.ar();
      a1c$8.a[idx1$2] = elem;
      a2c$7.a[idx2$2] = a1c$8;
      a3c$6.a[idx3$2] = a2c$7;
      return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, a3c$6, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
    } else if ((index >= this.da)) {
      var io$5 = ((index - this.da) | 0);
      var a2$8 = this.cO;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.ar();
      var a1$9 = a2c$8.a[idx2$3];
      var a1c$9 = a1$9.ar();
      a1c$9.a[idx1$3] = elem;
      a2c$8.a[idx2$3] = a1c$9;
      return new $c_sci_Vector6(this.R, this.da, a2c$8, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
    } else {
      var a1$10 = this.R;
      var a1c$10 = a1$10.ar();
      a1c$10.a[index] = elem;
      return new $c_sci_Vector6(a1c$10, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, this.am);
    }
  } else {
    throw this.f8(index);
  }
});
$p.fH = (function(elem) {
  if ((this.aj.a.length < 32)) {
    var suffix1$79 = $m_sci_VectorStatics$().DX(this.aj, elem);
    var length0$79 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, suffix1$79, length0$79);
  } else if ((this.ca.a.length < 31)) {
    var suffix2$63 = $m_sci_VectorStatics$().bN(this.ca, this.aj);
    var a = new $ac_O(1);
    a.a[0] = elem;
    var length0$80 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, suffix2$63, a, length0$80);
  } else if ((this.cb.a.length < 31)) {
    var suffix3$52 = $m_sci_VectorStatics$().bN(this.cb, $m_sci_VectorStatics$().bN(this.ca, this.aj));
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var length0$81 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, suffix3$52, $m_sci_VectorStatics$().c3, a$1, length0$81);
  } else if ((this.cc.a.length < 31)) {
    var suffix4$36 = $m_sci_VectorStatics$().bN(this.cc, $m_sci_VectorStatics$().bN(this.cb, $m_sci_VectorStatics$().bN(this.ca, this.aj)));
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var length0$82 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, suffix4$36, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$2, length0$82);
  } else if ((this.cd.a.length < 31)) {
    var suffix5$15 = $m_sci_VectorStatics$().bN(this.cd, $m_sci_VectorStatics$().bN(this.cc, $m_sci_VectorStatics$().bN(this.cb, $m_sci_VectorStatics$().bN(this.ca, this.aj))));
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var length0$83 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, suffix5$15, $m_sci_VectorStatics$().h4, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$3, length0$83);
  } else if ((this.c2.a.length < 62)) {
    var data6$16 = $m_sci_VectorStatics$().bN(this.c2, $m_sci_VectorStatics$().bN(this.cd, $m_sci_VectorStatics$().bN(this.cc, $m_sci_VectorStatics$().bN(this.cb, $m_sci_VectorStatics$().bN(this.ca, this.aj)))));
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var length0$84 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, data6$16, $m_sci_VectorStatics$().tB, $m_sci_VectorStatics$().h4, $m_sci_VectorStatics$().e0, $m_sci_VectorStatics$().c3, a$4, length0$84);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$p.hN = (function(elem) {
  if ((this.da < 32)) {
    var prefix1$81 = $m_sci_VectorStatics$().DY(elem, this.R);
    var len1$75 = ((1 + this.da) | 0);
    var len12$68 = ((1 + this.db) | 0);
    var len123$56 = ((1 + this.cW) | 0);
    var len1234$39 = ((1 + this.cN) | 0);
    var len12345$17 = ((1 + this.cG) | 0);
    var length0$85 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(prefix1$81, len1$75, this.cO, len12$68, this.cP, len123$56, this.cQ, len1234$39, this.cR, len12345$17, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, length0$85);
  } else if ((this.db < 1024)) {
    var a = new $ac_O(1);
    a.a[0] = elem;
    var prefix2$69 = $m_sci_VectorStatics$().bi(this.R, this.cO);
    var len12$69 = ((1 + this.db) | 0);
    var len123$57 = ((1 + this.cW) | 0);
    var len1234$40 = ((1 + this.cN) | 0);
    var len12345$18 = ((1 + this.cG) | 0);
    var length0$86 = ((1 + this.am) | 0);
    return new $c_sci_Vector6(a, 1, prefix2$69, len12$69, this.cP, len123$57, this.cQ, len1234$40, this.cR, len12345$18, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, length0$86);
  } else if ((this.cW < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.a[0] = elem;
    var prefix3$58 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.cO), this.cP);
    var len123$58 = ((1 + this.cW) | 0);
    var len1234$41 = ((1 + this.cN) | 0);
    var len12345$19 = ((1 + this.cG) | 0);
    var length0$87 = ((1 + this.am) | 0);
    var prefix4$41 = this.cQ;
    var prefix5$19 = this.cR;
    var data6$19 = this.c2;
    var suffix5$18 = this.cd;
    var suffix4$39 = this.cc;
    var suffix3$55 = this.cb;
    var suffix2$66 = this.ca;
    var suffix1$87 = this.aj;
    return new $c_sci_Vector6(a$1, 1, $m_sci_VectorStatics$().c3, 1, prefix3$58, len123$58, prefix4$41, len1234$41, prefix5$19, len12345$19, data6$19, suffix5$18, suffix4$39, suffix3$55, suffix2$66, suffix1$87, length0$87);
  } else if ((this.cN < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.a[0] = elem;
    var prefix4$42 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.cO), this.cP), this.cQ);
    var len1234$42 = ((1 + this.cN) | 0);
    var len12345$20 = ((1 + this.cG) | 0);
    var length0$88 = ((1 + this.am) | 0);
    var prefix5$20 = this.cR;
    var data6$20 = this.c2;
    var suffix5$19 = this.cd;
    var suffix4$40 = this.cc;
    var suffix3$56 = this.cb;
    var suffix2$67 = this.ca;
    var suffix1$88 = this.aj;
    return new $c_sci_Vector6(a$2, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, prefix4$42, len1234$42, prefix5$20, len12345$20, data6$20, suffix5$19, suffix4$40, suffix3$56, suffix2$67, suffix1$88, length0$88);
  } else if ((this.cG < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.a[0] = elem;
    var prefix5$21 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.cO), this.cP), this.cQ), this.cR);
    var len12345$21 = ((1 + this.cG) | 0);
    var length0$89 = ((1 + this.am) | 0);
    var data6$21 = this.c2;
    var suffix5$20 = this.cd;
    var suffix4$41 = this.cc;
    var suffix3$57 = this.cb;
    var suffix2$68 = this.ca;
    var suffix1$89 = this.aj;
    return new $c_sci_Vector6(a$3, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, $m_sci_VectorStatics$().h4, 1, prefix5$21, len12345$21, data6$21, suffix5$20, suffix4$41, suffix3$57, suffix2$68, suffix1$89, length0$89);
  } else if ((this.c2.a.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.a[0] = elem;
    var data6$22 = $m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi($m_sci_VectorStatics$().bi(this.R, this.cO), this.cP), this.cQ), this.cR), this.c2);
    var length0$90 = ((1 + this.am) | 0);
    var suffix5$21 = this.cd;
    var suffix4$42 = this.cc;
    var suffix3$58 = this.cb;
    var suffix2$69 = this.ca;
    var suffix1$90 = this.aj;
    return new $c_sci_Vector6(a$4, 1, $m_sci_VectorStatics$().c3, 1, $m_sci_VectorStatics$().e0, 1, $m_sci_VectorStatics$().h4, 1, $m_sci_VectorStatics$().tB, 1, data6$22, suffix5$21, suffix4$42, suffix3$58, suffix2$69, suffix1$90, length0$90);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$p.mI = (function(f) {
  var prefix1$87 = $m_sci_VectorStatics$().kO(this.R, f);
  var prefix2$70 = $m_sci_VectorStatics$().dU(2, this.cO, f);
  var prefix3$59 = $m_sci_VectorStatics$().dU(3, this.cP, f);
  var prefix4$43 = $m_sci_VectorStatics$().dU(4, this.cQ, f);
  var prefix5$22 = $m_sci_VectorStatics$().dU(5, this.cR, f);
  var data6$23 = $m_sci_VectorStatics$().dU(6, this.c2, f);
  var suffix5$22 = $m_sci_VectorStatics$().dU(5, this.cd, f);
  var suffix4$43 = $m_sci_VectorStatics$().dU(4, this.cc, f);
  var suffix3$59 = $m_sci_VectorStatics$().dU(3, this.cb, f);
  var suffix2$70 = $m_sci_VectorStatics$().dU(2, this.ca, f);
  var suffix1$91 = $m_sci_VectorStatics$().kO(this.aj, f);
  return new $c_sci_Vector6(prefix1$87, this.da, prefix2$70, this.db, prefix3$59, this.cW, prefix4$43, this.cN, prefix5$22, this.cG, data6$23, suffix5$22, suffix4$43, suffix3$59, suffix2$70, suffix1$91, this.am);
});
$p.kU = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.cA(1, this.R);
  b.cA(2, this.cO);
  b.cA(3, this.cP);
  b.cA(4, this.cQ);
  b.cA(5, this.cR);
  b.cA(6, this.c2);
  b.cA(5, this.cd);
  b.cA(4, this.cc);
  b.cA(3, this.cb);
  b.cA(2, this.ca);
  b.cA(1, this.aj);
  return b.ix();
});
$p.jy = (function() {
  if ((this.da > 1)) {
    var a = this.R;
    var prefix1$88 = $m_ju_Arrays$().bO(a, 1, a.a.length);
    var len1$77 = ((this.da - 1) | 0);
    var len12$71 = ((this.db - 1) | 0);
    var len123$60 = ((this.cW - 1) | 0);
    var len1234$44 = ((this.cN - 1) | 0);
    var len12345$23 = ((this.cG - 1) | 0);
    var length0$92 = ((this.am - 1) | 0);
    return new $c_sci_Vector6(prefix1$88, len1$77, this.cO, len12$71, this.cP, len123$60, this.cQ, len1234$44, this.cR, len12345$23, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, length0$92);
  } else {
    return this.kU(1, this.am);
  }
});
$p.jD = (function() {
  return 11;
});
$p.mQ = (function(idx) {
  switch (idx) {
    case 0: {
      return this.R;
      break;
    }
    case 1: {
      return this.cO;
      break;
    }
    case 2: {
      return this.cP;
      break;
    }
    case 3: {
      return this.cQ;
      break;
    }
    case 4: {
      return this.cR;
      break;
    }
    case 5: {
      return this.c2;
      break;
    }
    case 6: {
      return this.cd;
      break;
    }
    case 7: {
      return this.cc;
      break;
    }
    case 8: {
      return this.cb;
      break;
    }
    case 9: {
      return this.ca;
      break;
    }
    case 10: {
      return this.aj;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$p.iv = (function(prefix, k) {
  var x26 = $m_sci_VectorStatics$().Et(this.R, prefix);
  if ((x26 === null)) {
    return $c_sci_Vector.prototype.iv.call(this, prefix, k);
  }
  var diff = ((x26.a.length - this.R.a.length) | 0);
  var len1$79 = ((this.da + diff) | 0);
  var len12$73 = ((this.db + diff) | 0);
  var len123$62 = ((this.cW + diff) | 0);
  var len1234$46 = ((this.cN + diff) | 0);
  var len12345$25 = ((this.cG + diff) | 0);
  var length0$94 = ((this.am + diff) | 0);
  return new $c_sci_Vector6(x26, len1$79, this.cO, len12$73, this.cP, len123$62, this.cQ, len1234$46, this.cR, len12345$25, this.c2, this.cd, this.cc, this.cb, this.ca, this.aj, length0$94);
});
$p.ik = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().DN(this.aj, suffix);
  if ((suffix1b !== null)) {
    var length0$95 = ((((this.am - this.aj.a.length) | 0) + suffix1b.a.length) | 0);
    return new $c_sci_Vector6(this.R, this.da, this.cO, this.db, this.cP, this.cW, this.cQ, this.cN, this.cR, this.cG, this.c2, this.cd, this.cc, this.cb, this.ca, suffix1b, length0$95);
  } else {
    return $c_sci_Vector.prototype.ik.call(this, suffix, k);
  }
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.am))) {
    var io = ((index - this.cG) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.c2.a.length) ? this.c2.a[i6].a[i5].a[i4].a[i3].a[i2].a[i1] : ((i5 < this.cd.a.length) ? this.cd.a[i5].a[i4].a[i3].a[i2].a[i1] : ((i4 < this.cc.a.length) ? this.cc.a[i4].a[i3].a[i2].a[i1] : ((i3 < this.cb.a.length) ? this.cb.a[i3].a[i2].a[i1] : ((i2 < this.ca.a.length) ? this.ca.a[i2].a[i1] : this.aj.a[i1])))));
    } else if ((index >= this.cN)) {
      var io$2 = ((index - this.cN) | 0);
      return this.cR.a[((io$2 >>> 20) | 0)].a[(31 & ((io$2 >>> 15) | 0))].a[(31 & ((io$2 >>> 10) | 0))].a[(31 & ((io$2 >>> 5) | 0))].a[(31 & io$2)];
    } else if ((index >= this.cW)) {
      var io$3 = ((index - this.cW) | 0);
      return this.cQ.a[((io$3 >>> 15) | 0)].a[(31 & ((io$3 >>> 10) | 0))].a[(31 & ((io$3 >>> 5) | 0))].a[(31 & io$3)];
    } else if ((index >= this.db)) {
      var io$4 = ((index - this.db) | 0);
      return this.cP.a[((io$4 >>> 10) | 0)].a[(31 & ((io$4 >>> 5) | 0))].a[(31 & io$4)];
    } else if ((index >= this.da)) {
      var io$5 = ((index - this.da) | 0);
      return this.cO.a[((io$5 >>> 5) | 0)].a[(31 & io$5)];
    } else {
      return this.R.a[index];
    }
  } else {
    throw this.f8(index);
  }
});
$p.aV = (function(elem) {
  return this.fH(elem);
});
$p.ba = (function(elem) {
  return this.hN(elem);
});
$p.X = (function(f) {
  return this.mI(f);
});
$p.ak = (function() {
  return this.jy();
});
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hH)));
}
var $d_sci_Vector6 = new $TypeData().i($c_sci_Vector6, "scala.collection.immutable.Vector6", ({
  hH: 1,
  b5: 1,
  b7: 1,
  aX: 1,
  Z: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  G: 1,
  V: 1,
  R: 1,
  D: 1,
  L: 1,
  a5: 1,
  a0: 1,
  C: 1,
  M: 1,
  a1: 1,
  a: 1,
  a4: 1
}));
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.et = underlying;
  return $thiz;
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.et = null;
}
$p = $c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$p.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
}
$h_scm_StringBuilder.prototype = $p;
$p.cz = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$p.dk = (function(size) {
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.ba = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.X = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.et.F();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.Jc = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.dw = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
$p.F = (function() {
  return this.et.F();
});
$p.G = (function() {
  return this.et.F();
});
$p.am1 = (function(x) {
  var this$1 = this.et;
  var str = ("" + $cToS(x));
  this$1.aC = (this$1.aC + str);
  return this;
});
$p.g = (function() {
  return this.et.aC;
});
$p.jz = (function(ct) {
  return ((ct.dK() === $d_C.l()) ? this.akb() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct));
});
$p.akb = (function() {
  var len = this.et.F();
  var arr = new $ac_C(len);
  this.et.ahp(0, len, arr, 0);
  return arr;
});
$p.afG = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var this$3 = this.et;
    var str = xs.eF;
    this$3.aC = (("" + this$3.aC) + str);
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    this.et.afF(xs.ig);
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var this$4 = this.et;
    var s = xs.et;
    this$4.aC = (("" + this$4.aC) + s);
  } else {
    var ks = xs.G();
    if ((ks !== 0)) {
      var b = this.et;
      if ((ks > 0)) {
        b.F();
      }
      var it = xs.l();
      while (it.f()) {
        var c = $uC(it.e());
        var str$1 = ("" + $cToS(c));
        b.aC = (b.aC + str$1);
      }
    }
  }
  return this;
});
$p.qD = (function(index) {
  return this.et.qD(index);
});
$p.EC = (function(start, end) {
  return this.et.VD(start, end);
});
$p.c = (function() {
  return (this.et.F() === 0);
});
$p.at = (function(i) {
  return $bC(this.et.qD(i));
});
$p.p = (function(v1) {
  var i = (v1 | 0);
  return $bC(this.et.qD(i));
});
$p.mF = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).afG(coll);
});
$p.de = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).afG(coll);
});
$p.aD = (function(elem) {
  return this.am1($uC(elem));
});
$p.aR = (function() {
  return this.et.aC;
});
$p.hQ = (function(idx, elem) {
  var elem$1 = $uC(elem);
  this.et.axP(idx, elem$1);
});
$p.b4 = (function() {
  return $m_scm_IndexedSeq$();
});
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i0)));
}
var $d_scm_StringBuilder = new $TypeData().i($c_scm_StringBuilder, "scala.collection.mutable.StringBuilder", ({
  i0: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  X: 1,
  aN: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  aO: 1,
  a: 1
}));
/** @constructor */
function $c_sci_BitSet() {
}
$p = $c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$p.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
}
$h_sci_BitSet.prototype = $p;
$p.b = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.MA(pred, false);
});
$p.bC = (function(pred) {
  return this.MA(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.oX = (function() {
  return $f_sc_BitSetOps__ordering__s_math_Ordering(this);
});
$p.l = (function() {
  return new $c_sc_BitSetOps$$anon$1(0, this);
});
$p.aH = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$p.c = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$p.al = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$p.c8 = (function() {
  return "BitSet";
});
$p.ajv = (function(ord) {
  return ($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord) | 0);
});
$p.ajw = (function(ord) {
  return ($f_sc_SortedSetOps__min__s_math_Ordering__O(this, ord) | 0);
});
$p.dw = (function() {
  return $m_sci_BitSet$().aP();
});
$p.ahI = (function(elem) {
  if ((!(elem >= 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this;
  } else {
    var idx = (elem >> 6);
    var $x_1 = this.dW(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (x_$_lo | lo);
    var hi$1 = (x_$_hi | hi);
    return this.VN(idx, lo$1, hi$1);
  }
});
$p.mF = (function(coll) {
  return $m_sci_BitSet$().ahh(coll);
});
$p.de = (function(coll) {
  return $m_sci_BitSet$().ahh(coll);
});
$p.ahf = (function(elems) {
  return $m_sci_BitSet$().IC(elems);
});
$p.kL = (function(elem) {
  return this.ahI((elem | 0));
});
$p.Vk = (function(ord) {
  return ($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord) | 0);
});
$p.Vj = (function(ord) {
  return ($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord) | 0);
});
$p.aju = (function(that) {
  return $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that);
});
$p.az = (function(elem) {
  return $f_sc_BitSetOps__contains__I__Z(this, (elem | 0));
});
$p.fq = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord);
});
$p.gJ = (function(ord) {
  return $f_sc_BitSetOps__min__s_math_Ordering__I(this, ord);
});
$p.Mq = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$p.fu = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p);
});
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.c2)));
}
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.zi)));
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().Np($thiz);
  $thiz.kv = buf.kv;
  $thiz.jd = buf.jd;
  $thiz.Lz = false;
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.LA = ((1 + $thiz.LA) | 0);
  if ($thiz.Lz) {
    $p_scm_ListBuffer__copyElems__V($thiz);
  }
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.LA = 0;
  this.kv = null;
  this.jd = null;
  this.Lz = false;
  this.kw = 0;
  this.LA = 0;
  this.kv = $m_sci_Nil$();
  this.jd = null;
  this.Lz = false;
  this.kw = 0;
}
$p = $c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
}
$h_scm_ListBuffer.prototype = $p;
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.eQ = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.dk = (function(size) {
});
$p.l = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.kv.l(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.LA)));
});
$p.hM = (function() {
  return $m_scm_ListBuffer$();
});
$p.at = (function(i) {
  return $f_sc_LinearSeqOps__apply__I__O(this.kv, i);
});
$p.F = (function() {
  return this.kw;
});
$p.G = (function() {
  return this.kw;
});
$p.c = (function() {
  return (this.kw === 0);
});
$p.uF = (function() {
  this.Lz = (!this.c());
  return this.kv;
});
$p.TC = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.kw === 0)) {
    this.kv = last1;
  } else {
    var x$proxy2 = this.jd;
    if ((x$proxy2 === null)) {
      $m_sr_Scala3RunTime$().bW();
    }
    x$proxy2.bz = last1;
  }
  this.jd = last1;
  this.kw = ((1 + this.kw) | 0);
  return this;
});
$p.Np = (function(xs) {
  var it = xs.l();
  if (it.f()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
    this.kv = last0;
    while (it.f()) {
      var last1 = new $c_sci_$colon$colon(it.e(), $m_sci_Nil$());
      last0.bz = last1;
      last0 = last1;
      len = ((1 + len) | 0);
    }
    this.kw = len;
    this.jd = last0;
  }
  return this;
});
$p.alV = (function(xs) {
  var it = xs.l();
  if (it.f()) {
    var fresh = new $c_scm_ListBuffer().Np(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.kw === 0)) {
      this.kv = fresh.kv;
    } else {
      var x$proxy3 = this.jd;
      if ((x$proxy3 === null)) {
        $m_sr_Scala3RunTime$().bW();
      }
      x$proxy3.bz = fresh.kv;
    }
    this.jd = fresh.jd;
    this.kw = ((this.kw + fresh.kw) | 0);
  }
  return this;
});
$p.cJ = (function() {
  if ((this.jd === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer");
  } else {
    return this.jd.q9;
  }
});
$p.oS = (function() {
  return ((this.jd === null) ? $m_s_None$() : new $c_s_Some(this.jd.q9));
});
$p.c8 = (function() {
  return "ListBuffer";
});
$p.b4 = (function() {
  return $m_scm_ListBuffer$();
});
$p.p = (function(v1) {
  var i = (v1 | 0);
  return $f_sc_LinearSeqOps__apply__I__O(this.kv, i);
});
$p.aR = (function() {
  return this.uF();
});
$p.aD = (function(elem) {
  return this.TC(elem);
});
$p.cz = (function(elems) {
  return this.alV(elems);
});
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hZ)));
}
var $d_scm_ListBuffer = new $TypeData().i($c_scm_ListBuffer, "scala.collection.mutable.ListBuffer", ({
  hZ: 1,
  bw: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  aE: 1,
  bx: 1,
  C: 1,
  M: 1,
  X: 1,
  aN: 1,
  a: 1,
  a4: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet1(elems_$_lo, elems_$_hi) {
  this.HY = 0;
  this.HZ = 0;
  this.HY = elems_$_lo;
  this.HZ = elems_$_hi;
}
$p = $c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$p.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
}
$h_sci_BitSet$BitSet1.prototype = $p;
$p.hh = (function() {
  return 1;
});
$p.dW = (function(idx) {
  if ((idx === 0)) {
    return $bL(this.HY, this.HZ);
  } else {
    return $bL(0, 0);
  }
});
$p.VN = (function(idx, w_$_lo, w_$_hi) {
  return ((idx === 0) ? new $c_sci_BitSet$BitSet1(w_$_lo, w_$_hi) : ((idx === 1) ? $m_sci_BitSet$().Nn(this.HY, this.HZ, w_$_lo, w_$_hi) : $m_sci_BitSet$().IC($m_sc_BitSetOps$().VL(new $ac_J(new Int32Array([this.HY, this.HZ])), idx, w_$_lo, w_$_hi))));
});
$p.MA = (function(pred, isFlipped) {
  var $x_1 = $m_sc_BitSetOps$().us(pred, isFlipped, this.HY, this.HZ, 0);
  var _elems_$_lo = $x_1.l;
  var _elems_$_hi = $x_1.h;
  return (((_elems_$_lo | _elems_$_hi) === 0) ? $m_sci_BitSet$().yn : new $c_sci_BitSet$BitSet1(_elems_$_lo, _elems_$_hi));
});
var $d_sci_BitSet$BitSet1 = new $TypeData().i($c_sci_BitSet$BitSet1, "scala.collection.immutable.BitSet$BitSet1", ({
  xu: 1,
  c2: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  br: 1,
  bt: 1,
  bs: 1,
  b3: 1,
  c4: 1,
  c3: 1,
  C: 1,
  bu: 1,
  bV: 1,
  c5: 1,
  cQ: 1,
  bU: 1,
  be: 1,
  a: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0_$_lo, elems0_$_hi, elems1_$_lo, elems1_$_hi) {
  this.I0 = 0;
  this.I1 = 0;
  this.I2 = 0;
  this.I3 = 0;
  this.I0 = elems0_$_lo;
  this.I1 = elems0_$_hi;
  this.I2 = elems1_$_lo;
  this.I3 = elems1_$_hi;
}
$p = $c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$p.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
}
$h_sci_BitSet$BitSet2.prototype = $p;
$p.hh = (function() {
  return 2;
});
$p.dW = (function(idx) {
  if ((idx === 0)) {
    return $bL(this.I0, this.I1);
  } else if ((idx === 1)) {
    return $bL(this.I2, this.I3);
  } else {
    return $bL(0, 0);
  }
});
$p.VN = (function(idx, w_$_lo, w_$_hi) {
  return ((idx === 0) ? new $c_sci_BitSet$BitSet2(w_$_lo, w_$_hi, this.I2, this.I3) : ((idx === 1) ? $m_sci_BitSet$().Nn(this.I0, this.I1, w_$_lo, w_$_hi) : $m_sci_BitSet$().IC($m_sc_BitSetOps$().VL(new $ac_J(new Int32Array([this.I0, this.I1, this.I2, this.I3])), idx, w_$_lo, w_$_hi))));
});
$p.MA = (function(pred, isFlipped) {
  var $x_1 = $m_sc_BitSetOps$().us(pred, isFlipped, this.I0, this.I1, 0);
  var _elems0_$_lo = $x_1.l;
  var _elems0_$_hi = $x_1.h;
  var $x_2 = $m_sc_BitSetOps$().us(pred, isFlipped, this.I2, this.I3, 1);
  var _elems1_$_lo = $x_2.l;
  var _elems1_$_hi = $x_2.h;
  return (((_elems1_$_lo | _elems1_$_hi) === 0) ? (((_elems0_$_lo | _elems0_$_hi) === 0) ? $m_sci_BitSet$().yn : new $c_sci_BitSet$BitSet1(_elems0_$_lo, _elems0_$_hi)) : new $c_sci_BitSet$BitSet2(_elems0_$_lo, _elems0_$_hi, _elems1_$_lo, _elems1_$_hi));
});
var $d_sci_BitSet$BitSet2 = new $TypeData().i($c_sci_BitSet$BitSet2, "scala.collection.immutable.BitSet$BitSet2", ({
  xv: 1,
  c2: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  br: 1,
  bt: 1,
  bs: 1,
  b3: 1,
  c4: 1,
  c3: 1,
  C: 1,
  bu: 1,
  bV: 1,
  c5: 1,
  cQ: 1,
  bU: 1,
  be: 1,
  a: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.yo = null;
  this.yo = elems;
}
$p = $c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$p.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
}
$h_sci_BitSet$BitSetN.prototype = $p;
$p.hh = (function() {
  return ((this.yo.a.length >>> 1) | 0);
});
$p.dW = (function(idx) {
  if ((idx < ((this.yo.a.length >>> 1) | 0))) {
    var $x_1 = this.yo.a;
    var $x_2 = (idx << 1);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else {
    return $bL(0, 0);
  }
});
$p.VN = (function(idx, w_$_lo, w_$_hi) {
  return $m_sci_BitSet$().IC($m_sc_BitSetOps$().VL(this.yo, idx, w_$_lo, w_$_hi));
});
$p.MA = (function(pred, isFlipped) {
  var i = ((((this.yo.a.length >>> 1) | 0) - 1) | 0);
  var currentWord_$_lo = 0;
  var currentWord_$_hi = 0;
  var anyChanges = false;
  while (true) {
    if ((i >= 0)) {
      var x_$_lo = currentWord_$_lo;
      var x_$_hi = currentWord_$_hi;
      var $x_3 = ((x_$_lo | x_$_hi) === 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_1 = this.dW(i);
      var oldWord_$_lo = $x_1.l;
      var oldWord_$_hi = $x_1.h;
      var $x_2 = $m_sc_BitSetOps$().us(pred, isFlipped, oldWord_$_lo, oldWord_$_hi, i);
      currentWord_$_lo = $x_2.l;
      currentWord_$_hi = $x_2.h;
      if (anyChanges) {
        anyChanges = true;
      } else {
        var x$1_$_lo = currentWord_$_lo;
        var x$1_$_hi = currentWord_$_hi;
        anyChanges = (((x$1_$_lo ^ oldWord_$_lo) | (x$1_$_hi ^ oldWord_$_hi)) !== 0);
      }
      i = ((i - 1) | 0);
    } else {
      break;
    }
  }
  var x12 = i;
  if ((x12 === (-1))) {
    if (anyChanges) {
      var x$2_$_lo = currentWord_$_lo;
      var x$2_$_hi = currentWord_$_hi;
      if (((x$2_$_lo | x$2_$_hi) === 0)) {
        return $m_sci_BitSet$().yn;
      } else {
        return new $c_sci_BitSet$BitSet1(currentWord_$_lo, currentWord_$_hi);
      }
    } else {
      return this;
    }
  }
  if ((x12 === 0)) {
    var $x_4 = this.dW(0);
    var oldFirstWord_$_lo = $x_4.l;
    var oldFirstWord_$_hi = $x_4.h;
    var $x_5 = $m_sc_BitSetOps$().us(pred, isFlipped, oldFirstWord_$_lo, oldFirstWord_$_hi, 0);
    var firstWord_$_lo = $x_5.l;
    var firstWord_$_hi = $x_5.h;
    anyChanges = (anyChanges || (((firstWord_$_lo ^ oldFirstWord_$_lo) | (firstWord_$_hi ^ oldFirstWord_$_hi)) !== 0));
    return (anyChanges ? new $c_sci_BitSet$BitSet2(firstWord_$_lo, firstWord_$_hi, currentWord_$_lo, currentWord_$_hi) : this);
  }
  var minimumNonZeroIndex = ((1 + i) | 0);
  while (((!anyChanges) && (i >= 0))) {
    var $x_6 = this.dW(i);
    var oldWord$2_$_lo = $x_6.l;
    var oldWord$2_$_hi = $x_6.h;
    var $x_7 = $m_sc_BitSetOps$().us(pred, isFlipped, oldWord$2_$_lo, oldWord$2_$_hi, i);
    currentWord_$_lo = $x_7.l;
    currentWord_$_hi = $x_7.h;
    if (anyChanges) {
      anyChanges = true;
    } else {
      var x$3_$_lo = currentWord_$_lo;
      var x$3_$_hi = currentWord_$_hi;
      anyChanges = (((x$3_$_lo ^ oldWord$2_$_lo) | (x$3_$_hi ^ oldWord$2_$_hi)) !== 0);
    }
    i = ((i - 1) | 0);
  }
  if (anyChanges) {
    var newArray = $m_sc_ArrayOps$().uD(this.yo, 0, ((1 + minimumNonZeroIndex) | 0));
    var $x_8 = newArray.a;
    var $x_9 = (((1 + i) | 0) << 1);
    $x_8[$x_9] = currentWord_$_lo;
    $x_8[(($x_9 + 1) | 0)] = currentWord_$_hi;
    while ((i >= 0)) {
      var $x_13 = i;
      var $x_12 = $m_sc_BitSetOps$();
      var $x_11 = this.dW(i);
      var $x_10 = $x_12.us(pred, isFlipped, $x_11.l, $x_11.h, i);
      var $x_14 = newArray.a;
      var $x_15 = ($x_13 << 1);
      $x_14[$x_15] = $x_10.l;
      $x_14[(($x_15 + 1) | 0)] = $x_10.h;
      i = ((i - 1) | 0);
    }
    return new $c_sci_BitSet$BitSetN(newArray);
  } else {
    return this;
  }
});
var $d_sci_BitSet$BitSetN = new $TypeData().i($c_sci_BitSet$BitSetN, "scala.collection.immutable.BitSet$BitSetN", ({
  xw: 1,
  c2: 1,
  aM: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  G: 1,
  az: 1,
  ay: 1,
  br: 1,
  bt: 1,
  bs: 1,
  b3: 1,
  c4: 1,
  c3: 1,
  C: 1,
  bu: 1,
  bV: 1,
  c5: 1,
  cQ: 1,
  bU: 1,
  be: 1,
  a: 1
}));
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.og = 0;
  $thiz.j8 = initialElements;
  $thiz.dh = initialSize;
  return $thiz;
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz;
}
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz;
}
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  var z$tailLocal1 = z;
  var start$tailLocal1 = start;
  while (true) {
    if ((start$tailLocal1 === end)) {
      return z$tailLocal1;
    } else {
      var start$tailLocal1$tmp1 = ((1 + start$tailLocal1) | 0);
      var z$tailLocal1$tmp1 = op.cm(z$tailLocal1, $thiz.j8.a[start$tailLocal1]);
      start$tailLocal1 = start$tailLocal1$tmp1;
      z$tailLocal1 = z$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.og = 0;
  this.j8 = null;
  this.dh = 0;
}
$p = $c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
}
$h_scm_ArrayBuffer.prototype = $p;
$p.l = (function() {
  return this.mS().l();
});
$p.bX = (function() {
  return this.mS().bX();
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = this.dh;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.eQ = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.G = (function() {
  return this.dh;
});
$p.U9 = (function(n) {
  this.j8 = $m_scm_ArrayBuffer$().ajC(this.j8, this.dh, n);
});
$p.dk = (function(size) {
  if (((size > this.dh) && (size >= 1))) {
    this.U9(size);
  }
});
$p.at = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $m_scg_CommonErrors$().kM(n, ((this.dh - 1) | 0));
  }
  if ((hi > this.dh)) {
    throw $m_scg_CommonErrors$().kM(((hi - 1) | 0), ((this.dh - 1) | 0));
  }
  return this.j8.a[n];
});
$p.hQ = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().kM(index, ((this.dh - 1) | 0));
  }
  if ((hi > this.dh)) {
    throw $m_scg_CommonErrors$().kM(((hi - 1) | 0), ((this.dh - 1) | 0));
  }
  this.og = ((1 + this.og) | 0);
  this.j8.a[index] = elem;
});
$p.F = (function() {
  return this.dh;
});
$p.mS = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.og)));
});
$p.hM = (function() {
  return $m_scm_ArrayBuffer$();
});
$p.Ia = (function(elem) {
  this.og = ((1 + this.og) | 0);
  var newSize = ((1 + this.dh) | 0);
  if ((this.j8.a.length <= ((newSize - 1) | 0))) {
    this.U9(newSize);
  }
  this.dh = newSize;
  this.j8.a[((newSize - 1) | 0)] = elem;
  return this;
});
$p.afs = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var elemsLength = elems.dh;
    if ((elemsLength > 0)) {
      this.og = ((1 + this.og) | 0);
      this.U9(((this.dh + elemsLength) | 0));
      $m_s_Array$().dd(elems.j8, 0, this.j8, this.dh, elemsLength);
      this.dh = ((this.dh + elemsLength) | 0);
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
  }
  return this;
});
$p.c8 = (function() {
  return "ArrayBuffer";
});
$p.d0 = (function(xs, start, len) {
  var srcLen = this.dh;
  var destLen = $m_jl_reflect_Array$().b1(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().dd(this.j8, 0, xs, start, copied);
  }
  return copied;
});
$p.ayc = (function(ord) {
  if ((this.dh > 1)) {
    this.og = ((1 + this.og) | 0);
    $m_s_util_Sorting$().Jd(this.j8, 0, this.dh, ord);
  }
  return this;
});
$p.fL = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.dh, z, op);
});
$p.gM = (function(op) {
  return ((this.dh > 0) ? $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 1, this.dh, this.j8.a[0], op) : $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op));
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
$p.mR = (function() {
  return this.mS();
});
$p.b4 = (function() {
  return $m_scm_ArrayBuffer$();
});
$p.aD = (function(elem) {
  return this.Ia(elem);
});
$p.cz = (function(elems) {
  return this.afs(elems);
});
$p.Jc = (function(ord) {
  return this.ayc(ord);
});
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hJ)));
}
var $d_scm_ArrayBuffer = new $TypeData().i($c_scm_ArrayBuffer, "scala.collection.mutable.ArrayBuffer", ({
  hJ: 1,
  bw: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  aE: 1,
  bx: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  c6: 1,
  C: 1,
  M: 1,
  a: 1,
  a4: 1
}));
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.mt = array;
  return $thiz;
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.mt = null;
}
$p = $c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
}
$h_sjs_js_WrappedArray.prototype = $p;
$p.dk = (function(size) {
});
$p.Jc = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.c8 = (function() {
  return "IndexedSeq";
});
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.ba = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.b8 = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$p.X = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var x = (this.mt.length | 0);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.eQ = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.hM = (function() {
  return $m_sjs_js_WrappedArray$();
});
$p.hQ = (function(index, elem) {
  this.mt[index] = elem;
});
$p.at = (function(index) {
  return this.mt[index];
});
$p.F = (function() {
  return (this.mt.length | 0);
});
$p.G = (function() {
  return (this.mt.length | 0);
});
$p.eH = (function() {
  return "WrappedArray";
});
$p.aR = (function() {
  return this;
});
$p.aD = (function(elem) {
  this.mt.push(elem);
  return this;
});
$p.p = (function(v1) {
  var index = (v1 | 0);
  return this.mt[index];
});
$p.b4 = (function() {
  return $m_sjs_js_WrappedArray$();
});
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.im)));
}
var $d_sjs_js_WrappedArray = new $TypeData().i($c_sjs_js_WrappedArray, "scala.scalajs.js.WrappedArray", ({
  im: 1,
  bw: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  aE: 1,
  bx: 1,
  M: 1,
  C: 1,
  al: 1,
  D: 1,
  L: 1,
  am: 1,
  c6: 1,
  X: 1,
  a: 1
}));
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.bK = array;
  $thiz.dq = start;
  $thiz.dD = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.bK, $thiz.dq, $thiz.dD);
  return $thiz;
}
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  if (((array.a.length & ((array.a.length - 1) | 0)) !== 0)) {
    $m_sr_Scala3RunTime$().Mk("Array.length must be power of 2");
  }
  var until = array.a.length;
  if (((start < 0) || (start >= until))) {
    throw $m_scg_CommonErrors$().kM(start, ((until - 1) | 0));
  }
  var until$1 = array.a.length;
  if (((end < 0) || (end >= until$1))) {
    throw $m_scg_CommonErrors$().kM(end, ((until$1 - 1) | 0));
  }
  $thiz.bK = array;
  $thiz.dq = start;
  $thiz.dD = end;
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().Md(initialSize), 0, 0);
  return $thiz;
}
function $p_scm_ArrayDeque__resize__I__V($thiz, len) {
  if (((len >= $thiz.bK.a.length) || (($thiz.bK.a.length > 16) && ((($thiz.bK.a.length - len) | 0) > len)))) {
    var idx = $thiz.dq;
    var n = ((($thiz.dD - idx) | 0) & (($thiz.bK.a.length - 1) | 0));
    $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, 0, $m_scm_ArrayDeque$().Md(len), 0, n), 0, n);
  }
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.bK = null;
  this.dq = 0;
  this.dD = 0;
}
$p = $c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$p.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
}
$h_scm_ArrayDeque.prototype = $p;
$p.l = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.bX = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), new $c_sc_IndexedSeqView$Id(this));
});
$p.mR = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$p.eB = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$p.bo = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$p.W = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$p.bj = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$p.cJ = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$p.cp = (function(len) {
  var idx = this.dq;
  var x = (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$p.Jc = (function(ord) {
  return $f_scm_IndexedSeqOps__sortInPlace__s_math_Ordering__scm_IndexedSeqOps(this, ord);
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$p.bC = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.eQ = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$p.ba = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$p.aV = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$p.cH = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$p.eS = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$p.G = (function() {
  var idx = this.dq;
  return (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0));
});
$p.at = (function(idx) {
  var idx$1 = this.dq;
  var until = (((this.dD - idx$1) | 0) & ((this.bK.a.length - 1) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().kM(idx, ((until - 1) | 0));
  }
  return this.bK.a[(((this.dq + idx) | 0) & ((this.bK.a.length - 1) | 0))];
});
$p.hQ = (function(idx, elem) {
  var idx$1 = this.dq;
  var until = (((this.dD - idx$1) | 0) & ((this.bK.a.length - 1) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().kM(idx, ((until - 1) | 0));
  }
  this.bK.a[(((this.dq + idx) | 0) & ((this.bK.a.length - 1) | 0))] = elem;
});
$p.DM = (function(elem) {
  var idx = this.dq;
  var hint = ((1 + (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0))) | 0);
  var idx$1 = this.dq;
  if (((hint > (((this.dD - idx$1) | 0) & ((this.bK.a.length - 1) | 0))) && (hint >= this.bK.a.length))) {
    $p_scm_ArrayDeque__resize__I__V(this, hint);
  }
  this.bK.a[this.dD] = elem;
  this.dD = (((1 + this.dD) | 0) & ((this.bK.a.length - 1) | 0));
  return this;
});
$p.I9 = (function(elems) {
  matchResult2: {
    var x2 = elems.G();
    if ((x2 > 0)) {
      var idx = this.dq;
      var hint = ((x2 + (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0))) | 0);
      var idx$1 = this.dq;
      if (((hint > (((this.dD - idx$1) | 0) & ((this.bK.a.length - 1) | 0))) && (hint >= this.bK.a.length))) {
        $p_scm_ArrayDeque__resize__I__V(this, hint);
      }
      var this$1 = elems.l();
      while (this$1.f()) {
        var x0 = this$1.e();
        this.bK.a[this.dD] = x0;
        this.dD = (((1 + this.dD) | 0) & ((this.bK.a.length - 1) | 0));
      }
      break matchResult2;
    }
    var this$2 = elems.l();
    while (this$2.f()) {
      this.DM(this$2.e());
    }
  }
  return this;
});
$p.Nk = (function(resizeInternalRepr) {
  if (this.c()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection");
  } else {
    var elem = this.bK.a[this.dq];
    this.bK.a[this.dq] = null;
    this.dq = (((1 + this.dq) | 0) & ((this.bK.a.length - 1) | 0));
    if (resizeInternalRepr) {
      var idx = this.dq;
      $p_scm_ArrayDeque__resize__I__V(this, (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0)));
    }
    return elem;
  }
});
$p.F = (function() {
  var idx = this.dq;
  return (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0));
});
$p.c = (function() {
  return (this.dq === this.dD);
});
$p.hM = (function() {
  return $m_scm_ArrayDeque$();
});
$p.d0 = (function(dest, destStart, len) {
  var idx = this.dq;
  var srcLen = (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0));
  var destLen = $m_jl_reflect_Array$().b1(dest);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((destStart < 0) ? destLen : ((destLen - destStart) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len);
  }
  return copied;
});
$p.jz = (function(evidence$1) {
  var idx = this.dq;
  var length = (((this.dD - idx) | 0) & ((this.bK.a.length - 1) | 0));
  var dest = evidence$1.fb(length);
  var idx$1 = this.dq;
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, (((this.dD - idx$1) | 0) & ((this.bK.a.length - 1) | 0)));
});
$p.c8 = (function() {
  return "ArrayDeque";
});
$p.p = (function(v1) {
  return this.at((v1 | 0));
});
$p.aD = (function(elem) {
  return this.DM(elem);
});
$p.cz = (function(elems) {
  return this.I9(elems);
});
$p.b4 = (function() {
  return this.hM();
});
var $d_scm_ArrayDeque = new $TypeData().i($c_scm_ArrayDeque, "scala.collection.mutable.ArrayDeque", ({
  hK: 1,
  bw: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  aE: 1,
  bx: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  c6: 1,
  C: 1,
  M: 1,
  hL: 1,
  a: 1,
  a4: 1
}));
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.fj = elems;
  return $thiz;
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz;
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_BitSet() {
  this.fj = null;
}
$p = $c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$p.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
}
$h_scm_BitSet.prototype = $p;
$p.b = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$p.X = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.aL = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$p.bD = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$p.bU = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$p.bY = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.bc = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$p.bB = (function(pred) {
  return this.ah2(pred, false);
});
$p.bC = (function(pred) {
  return this.ah2(pred, true);
});
$p.b8 = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$p.oX = (function() {
  return $f_sc_BitSetOps__ordering__s_math_Ordering(this);
});
$p.l = (function() {
  return new $c_sc_BitSetOps$$anon$1(0, this);
});
$p.aH = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$p.c = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$p.al = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$p.c8 = (function() {
  return "BitSet";
});
$p.ajv = (function(ord) {
  return ($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord) | 0);
});
$p.ajw = (function(ord) {
  return ($f_sc_SortedSetOps__min__s_math_Ordering__O(this, ord) | 0);
});
$p.dw = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
});
$p.hh = (function() {
  return ((this.fj.a.length >>> 1) | 0);
});
$p.dW = (function(idx) {
  if ((idx < ((this.fj.a.length >>> 1) | 0))) {
    var $x_1 = this.fj.a;
    var $x_2 = (idx << 1);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else {
    return $bL(0, 0);
  }
});
$p.ahg = (function(elems) {
  return ((((elems.a.length >>> 1) | 0) === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems));
});
$p.TB = (function(elem) {
  $m_s_Predef$().Nl((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var $x_1 = this.dW(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (x_$_lo | lo);
    var hi$1 = (x_$_hi | hi);
    this.az1(idx, lo$1, hi$1);
  }
  return this;
});
$p.az1 = (function(idx, w_$_lo, w_$_hi) {
  this.Iy(idx);
  var $x_1 = this.fj.a;
  var $x_2 = (idx << 1);
  $x_1[$x_2] = w_$_lo;
  $x_1[(($x_2 + 1) | 0)] = w_$_hi;
});
$p.Iy = (function(idx) {
  $m_s_Predef$().Nl((idx < 33554432));
  if ((idx >= ((this.fj.a.length >>> 1) | 0))) {
    var newlen = ((this.fj.a.length >>> 1) | 0);
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432);
    }
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().dd(this.fj, 0, elems1, 0, ((this.fj.a.length >>> 1) | 0));
    this.fj = elems1;
  }
});
$p.alH = (function(other) {
  this.Iy(((other.hh() - 1) | 0));
  var i = 0;
  var othernwords = other.hh();
  while ((i < othernwords)) {
    var $x_5 = this.fj;
    var $x_4 = i;
    var $x_1 = this.fj.a;
    var $x_2 = (i << 1);
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var $x_3 = other.dW(i);
    var x$1_$_lo = $x_3.l;
    var x$1_$_hi = $x_3.h;
    var lo = (x_$_lo | x$1_$_lo);
    var hi = (x_$_hi | x$1_$_hi);
    var $x_6 = $x_5.a;
    var $x_7 = ($x_4 << 1);
    $x_6[$x_7] = lo;
    $x_6[(($x_7 + 1) | 0)] = hi;
    i = ((1 + i) | 0);
  }
  return this;
});
$p.Ty = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    return this.alH(xs);
  } else if ((xs instanceof $c_sci_Range)) {
    if ((!xs.dN)) {
      var start = xs.aiS($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = xs.aiQ($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.Iy(endIdx);
        if (((xs.bA === 1) || (xs.bA === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> (~n)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var \u03b41$ = this.fj;
            var $x_1 = \u03b41$.a;
            var $x_2 = (startIdx << 1);
            var x_$_lo = $x_1[$x_2];
            var x_$_hi = $x_1[(($x_2 + 1) | 0)];
            var lo$1 = (x_$_lo | lo);
            var hi$1 = (x_$_hi | hi);
            var $x_3 = \u03b41$.a;
            var $x_4 = (startIdx << 1);
            $x_3[$x_4] = lo$1;
            $x_3[(($x_4 + 1) | 0)] = hi$1;
            $m_ju_Arrays$().atO(this.fj, ((1 + startIdx) | 0), endIdx, (-1), (-1));
            var \u03b42$ = this.fj;
            var $x_5 = \u03b42$.a;
            var $x_6 = (endIdx << 1);
            var x$1_$_lo = $x_5[$x_6];
            var x$1_$_hi = $x_5[(($x_6 + 1) | 0)];
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << (~n$1))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (x$1_$_lo | lo$2);
            var hi$3 = (x$1_$_hi | hi$2);
            var $x_7 = \u03b42$.a;
            var $x_8 = (endIdx << 1);
            $x_7[$x_8] = lo$3;
            $x_7[(($x_8 + 1) | 0)] = hi$3;
          } else {
            var \u03b43$ = this.fj;
            var $x_9 = \u03b43$.a;
            var $x_10 = (endIdx << 1);
            var x$2_$_lo = $x_9[$x_10];
            var x$2_$_hi = $x_9[(($x_10 + 1) | 0)];
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << (~n$2))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (x$2_$_lo | lo$5);
            var hi$6 = (x$2_$_hi | hi$5);
            var $x_11 = \u03b43$.a;
            var $x_12 = (endIdx << 1);
            $x_11[$x_12] = lo$6;
            $x_11[(($x_12 + 1) | 0)] = hi$6;
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
      }
    }
    return this;
  } else if ($is_sc_SortedSet(xs)) {
    if ((!xs.c())) {
      var ord = xs.oX();
      if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Int$()))) {
        this.Iy((($f_sc_IterableOps__last__O(xs) | 0) >> 6));
      } else if ((ord === ($m_s_math_Ordering$(), $m_s_math_Ordering$Int$().Sr))) {
        this.Iy(((xs.l().e() | 0) >> 6));
      }
      var iter = xs.l();
      while (iter.f()) {
        this.TB((iter.e() | 0));
      }
    }
    return this;
  } else {
    return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
});
$p.Nx = (function(that) {
  if ($is_sc_BitSet(that)) {
    var thisnwords = ((this.fj.a.length >>> 1) | 0);
    var bsnwords = that.hh();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var $x_1 = this.dW(i);
      var x_$_lo = $x_1.l;
      var x_$_hi = $x_1.h;
      if (((x_$_lo | x_$_hi) !== 0)) {
        return false;
      }
      i = ((1 + i) | 0);
    }
    var j = 0;
    while ((j < minWords)) {
      var $x_2 = this.dW(j);
      var x$2_$_lo = $x_2.l;
      var x$2_$_hi = $x_2.h;
      var $x_3 = that.dW(j);
      var x$1_$_lo = $x_3.l;
      var x$1_$_hi = $x_3.h;
      var lo = (~x$1_$_lo);
      var hi = (~x$1_$_hi);
      if ((((x$2_$_lo & lo) | (x$2_$_hi & hi)) !== 0)) {
        return false;
      }
      j = ((1 + j) | 0);
    }
    return true;
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that);
  }
});
$p.ah2 = (function(pred, isFlipped) {
  var i = ((((this.fj.a.length >>> 1) | 0) - 1) | 0);
  var newArray = null;
  while ((i >= 0)) {
    var $x_3 = $m_sc_BitSetOps$();
    var $x_2 = this.dW(i);
    var $x_1 = $x_3.us(pred, isFlipped, $x_2.l, $x_2.h, i);
    var w_$_lo = $x_1.l;
    var w_$_hi = $x_1.h;
    if (((w_$_lo | w_$_hi) !== 0)) {
      if ((newArray === null)) {
        newArray = new $ac_J(((1 + i) | 0));
      }
      var $x_4 = newArray.a;
      var $x_5 = (i << 1);
      $x_4[$x_5] = w_$_lo;
      $x_4[(($x_5 + 1) | 0)] = w_$_hi;
    }
    i = ((i - 1) | 0);
  }
  return ((newArray === null) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : this.ahg(newArray));
});
$p.mF = (function(coll) {
  return $ct_scm_BitSet__(new $c_scm_BitSet()).Ty(coll);
});
$p.de = (function(coll) {
  return $ct_scm_BitSet__(new $c_scm_BitSet()).Ty(coll);
});
$p.ahf = (function(elems) {
  return this.ahg(elems);
});
$p.aD = (function(elem) {
  return this.TB((elem | 0));
});
$p.cz = (function(elems) {
  return this.Ty(elems);
});
$p.Vk = (function(ord) {
  return ($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord) | 0);
});
$p.Vj = (function(ord) {
  return ($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord) | 0);
});
$p.aju = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.Tz(this);
  b.Tz(that);
  return b.h5;
});
$p.az = (function(elem) {
  return $f_sc_BitSetOps__contains__I__Z(this, (elem | 0));
});
$p.fq = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord);
});
$p.gJ = (function(ord) {
  return $f_sc_BitSetOps__min__s_math_Ordering__I(this, ord);
});
$p.Mq = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$p.fu = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p);
});
var $d_scm_BitSet = new $TypeData().i($c_scm_BitSet, "scala.collection.mutable.BitSet", ({
  yR: 1,
  cR: 1,
  ac: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  ad: 1,
  b: 1,
  a6: 1,
  a3: 1,
  P: 1,
  a2: 1,
  S: 1,
  T: 1,
  X: 1,
  aE: 1,
  cV: 1,
  cU: 1,
  br: 1,
  bt: 1,
  bs: 1,
  b3: 1,
  zw: 1,
  zv: 1,
  C: 1,
  bu: 1,
  bV: 1,
  bU: 1,
  be: 1,
  a: 1
}));
/** @constructor */
function $c_scm_Queue(initialSize) {
  this.bK = null;
  this.dq = 0;
  this.dD = 0;
  $ct_scm_ArrayDeque__AO__I__I__(this, $m_scm_ArrayDeque$().Md(initialSize), 0, 0);
}
$p = $c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$p.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
}
$h_scm_Queue.prototype = $p;
$p.hM = (function() {
  return $m_scm_Queue$();
});
$p.c8 = (function() {
  return "Queue";
});
$p.b4 = (function() {
  return $m_scm_Queue$();
});
var $d_scm_Queue = new $TypeData().i($c_scm_Queue, "scala.collection.mutable.Queue", ({
  zs: 1,
  hK: 1,
  bw: 1,
  ae: 1,
  K: 1,
  u: 1,
  h: 1,
  i: 1,
  s: 1,
  r: 1,
  q: 1,
  p: 1,
  t: 1,
  y: 1,
  b: 1,
  I: 1,
  a3: 1,
  P: 1,
  a2: 1,
  ag: 1,
  af: 1,
  S: 1,
  T: 1,
  aE: 1,
  bx: 1,
  D: 1,
  L: 1,
  am: 1,
  al: 1,
  c6: 1,
  C: 1,
  M: 1,
  hL: 1,
  a: 1,
  a4: 1
}));
var $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__LeftAnchor = null;
var $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__CenterAnchor = null;
var $t_Lcom_papasofokli_svg_components_HorizontalAnchor$__RightAnchor = null;
let $e_ajaxCallFreezePageScalaJs = (function(arg, arg$2) {
  $m_Lcom_papasofokli_TopLevelMethods$().amg(arg, arg$2);
});
export { $e_ajaxCallFreezePageScalaJs as ajaxCallFreezePageScalaJs };
let $e_documentLoaded = (function() {
  $m_Lcom_papasofokli_TopLevelMethods$().agH();
});
export { $e_documentLoaded as documentLoaded };
let $e_executeJsStatements = (function(arg) {
  $m_Lcom_papasofokli_util_package$().atH(arg, $m_sjs_concurrent_JSExecutionContext$Implicits$().kx);
});
export { $e_executeJsStatements as executeJsStatements };
$s_Lcom_papasofokli_TopLevelMethods__main__AT__V(new ($d_T.r().C)([]));
//# sourceMappingURL=main.js.map
